
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2be5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2be5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1apN2", function(module, exports) {
$parcel$export(module.exports, "AtlassianRelayEnvironmentProvider", () => $c0c6d5656e8c1ee4$export$6c22afad970ad5ac);
$parcel$export(module.exports, "RelayEnvironmentProvider", () => $c0c6d5656e8c1ee4$export$43b1f3e917d65526);
$parcel$export(module.exports, "ConditionalRelayEnvironmentProvider", () => $c0c6d5656e8c1ee4$export$2f6292af3d34630d);
$parcel$export(module.exports, "useRelayEnvironmentProvider", () => $c0c6d5656e8c1ee4$export$e237a628f59c9f4e);

var $1v5pe = parcelRequire("1v5pe");

var $jEbac = parcelRequire("jEbac");

var $2aEiL = parcelRequire("2aEiL");

var $6Fero = parcelRequire("6Fero");

var $lTVJL = parcelRequire("lTVJL");

var $kIqwl = parcelRequire("kIqwl");
function $c0c6d5656e8c1ee4$export$6c22afad970ad5ac({ children: children }) {
    const existingRelayContext = (0, $1v5pe.useContext)((0, $jEbac.ReactRelayContext));
    // If a compatible relay environment (one created via `createRelayEnvironment`) is already present
    // in the tree, reuse it instead of shadowing it with our own internal environment.
    if (existingRelayContext != null && (0, $6Fero.isAtlassianRelayEnvironment)(existingRelayContext.environment) && (0, $2aEiL.fg)('relay_environment_-_reuse_product_env_when_exist')) return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kIqwl.Fragment), {
        children: children
    });
    // Otherwise, fall back to providing the default internal relay environment.
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jEbac.RelayEnvironmentProvider), {
        environment: (0, $lTVJL.__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__),
        children: children
    });
}
const $c0c6d5656e8c1ee4$export$43b1f3e917d65526 = $c0c6d5656e8c1ee4$export$6c22afad970ad5ac;
const $c0c6d5656e8c1ee4$export$2f6292af3d34630d = ({ children: children })=>{
    const isRelayPresent = (0, $1v5pe.useContext)((0, $jEbac.ReactRelayContext));
    if (isRelayPresent) return children;
    return /*#__PURE__*/ (0, $kIqwl.jsx)($c0c6d5656e8c1ee4$export$6c22afad970ad5ac, {
        children: children
    });
};
function $c0c6d5656e8c1ee4$export$e237a628f59c9f4e() {
    const environment = (0, $jEbac.useRelayEnvironment)();
    return (0, $1v5pe.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});
parcelRegister("1v5pe", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3AJ0s"));

});
parcelRegister("3AJ0s", function(module, exports) {
$parcel$export(module.exports, "Children", () => $29d7a53af20a6ce2$export$dca3b0875bd9a954, (v) => $29d7a53af20a6ce2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $29d7a53af20a6ce2$export$16fa2f45be04daa8, (v) => $29d7a53af20a6ce2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $29d7a53af20a6ce2$export$ffb0004e005737fa, (v) => $29d7a53af20a6ce2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $29d7a53af20a6ce2$export$e2c29f18771995cb, (v) => $29d7a53af20a6ce2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $29d7a53af20a6ce2$export$221d75b3f55bb0bd, (v) => $29d7a53af20a6ce2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $29d7a53af20a6ce2$export$5f8d39834fd61797, (v) => $29d7a53af20a6ce2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $29d7a53af20a6ce2$export$74bf444e3cd11ea5, (v) => $29d7a53af20a6ce2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $29d7a53af20a6ce2$export$ae55be85d98224ed, (v) => $29d7a53af20a6ce2$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $29d7a53af20a6ce2$export$3ba232387fd5d6dd, (v) => $29d7a53af20a6ce2$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $29d7a53af20a6ce2$export$e530037191fcd5d7, (v) => $29d7a53af20a6ce2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $29d7a53af20a6ce2$export$fd42f52fd3ae1109, (v) => $29d7a53af20a6ce2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $29d7a53af20a6ce2$export$c8a8987d4410bf2d, (v) => $29d7a53af20a6ce2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $29d7a53af20a6ce2$export$d38cd72104c1f0e9, (v) => $29d7a53af20a6ce2$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $29d7a53af20a6ce2$export$7d1e3a5e95ceca43, (v) => $29d7a53af20a6ce2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $29d7a53af20a6ce2$export$257a8862b851cb5b, (v) => $29d7a53af20a6ce2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $29d7a53af20a6ce2$export$a8257692ac88316c, (v) => $29d7a53af20a6ce2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $29d7a53af20a6ce2$export$488013bae63b21da, (v) => $29d7a53af20a6ce2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $29d7a53af20a6ce2$export$7c73462e0d25e514, (v) => $29d7a53af20a6ce2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $29d7a53af20a6ce2$export$7568632d0d33d16d, (v) => $29d7a53af20a6ce2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $29d7a53af20a6ce2$export$88948ce120ea2619, (v) => $29d7a53af20a6ce2$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $29d7a53af20a6ce2$export$35808ee640e87ca7, (v) => $29d7a53af20a6ce2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $29d7a53af20a6ce2$export$fae74005e78b1a27, (v) => $29d7a53af20a6ce2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $29d7a53af20a6ce2$export$dc8fbce3eb94dc1e, (v) => $29d7a53af20a6ce2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $29d7a53af20a6ce2$export$6a7bc4e911dc01cf, (v) => $29d7a53af20a6ce2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $29d7a53af20a6ce2$export$6d9c69b0de29b591, (v) => $29d7a53af20a6ce2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $29d7a53af20a6ce2$export$f680877a34711e37, (v) => $29d7a53af20a6ce2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $29d7a53af20a6ce2$export$d5a552a76deda3c2, (v) => $29d7a53af20a6ce2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $29d7a53af20a6ce2$export$aaabe4eda9ed9969, (v) => $29d7a53af20a6ce2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $29d7a53af20a6ce2$export$e5c5a5f917a5871c, (v) => $29d7a53af20a6ce2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $29d7a53af20a6ce2$export$1538c33de8887b59, (v) => $29d7a53af20a6ce2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $29d7a53af20a6ce2$export$13e3392192263954, (v) => $29d7a53af20a6ce2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $29d7a53af20a6ce2$export$b8f5890fc79d6aca, (v) => $29d7a53af20a6ce2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $29d7a53af20a6ce2$export$60241385465d0a34, (v) => $29d7a53af20a6ce2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $29d7a53af20a6ce2$export$306c0aa65ff9ec16, (v) => $29d7a53af20a6ce2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $29d7a53af20a6ce2$export$7b286972b8d8ccbf, (v) => $29d7a53af20a6ce2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $29d7a53af20a6ce2$export$83d89fbfd8236492, (v) => $29d7a53af20a6ce2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $29d7a53af20a6ce2$export$dca3b0875bd9a954;
var $29d7a53af20a6ce2$export$16fa2f45be04daa8;
var $29d7a53af20a6ce2$export$ffb0004e005737fa;
var $29d7a53af20a6ce2$export$e2c29f18771995cb;
var $29d7a53af20a6ce2$export$221d75b3f55bb0bd;
var $29d7a53af20a6ce2$export$5f8d39834fd61797;
var $29d7a53af20a6ce2$export$74bf444e3cd11ea5;
var $29d7a53af20a6ce2$export$ae55be85d98224ed;
var $29d7a53af20a6ce2$export$3ba232387fd5d6dd;
var $29d7a53af20a6ce2$export$e530037191fcd5d7;
var $29d7a53af20a6ce2$export$fd42f52fd3ae1109;
var $29d7a53af20a6ce2$export$c8a8987d4410bf2d;
var $29d7a53af20a6ce2$export$d38cd72104c1f0e9;
var $29d7a53af20a6ce2$export$7d1e3a5e95ceca43;
var $29d7a53af20a6ce2$export$257a8862b851cb5b;
var $29d7a53af20a6ce2$export$a8257692ac88316c;
var $29d7a53af20a6ce2$export$488013bae63b21da;
var $29d7a53af20a6ce2$export$7c73462e0d25e514;
var $29d7a53af20a6ce2$export$7568632d0d33d16d;
var $29d7a53af20a6ce2$export$88948ce120ea2619;
var $29d7a53af20a6ce2$export$35808ee640e87ca7;
var $29d7a53af20a6ce2$export$fae74005e78b1a27;
var $29d7a53af20a6ce2$export$dc8fbce3eb94dc1e;
var $29d7a53af20a6ce2$export$6a7bc4e911dc01cf;
var $29d7a53af20a6ce2$export$6d9c69b0de29b591;
var $29d7a53af20a6ce2$export$f680877a34711e37;
var $29d7a53af20a6ce2$export$d5a552a76deda3c2;
var $29d7a53af20a6ce2$export$aaabe4eda9ed9969;
var $29d7a53af20a6ce2$export$e5c5a5f917a5871c;
var $29d7a53af20a6ce2$export$1538c33de8887b59;
var $29d7a53af20a6ce2$export$13e3392192263954;
var $29d7a53af20a6ce2$export$b8f5890fc79d6aca;
var $29d7a53af20a6ce2$export$60241385465d0a34;
var $29d7a53af20a6ce2$export$306c0aa65ff9ec16;
var $29d7a53af20a6ce2$export$7b286972b8d8ccbf;
var $29d7a53af20a6ce2$export$83d89fbfd8236492;
'use strict';
var $29d7a53af20a6ce2$var$l = Symbol.for("react.element"), $29d7a53af20a6ce2$var$n = Symbol.for("react.portal"), $29d7a53af20a6ce2$var$p = Symbol.for("react.fragment"), $29d7a53af20a6ce2$var$q = Symbol.for("react.strict_mode"), $29d7a53af20a6ce2$var$r = Symbol.for("react.profiler"), $29d7a53af20a6ce2$var$t = Symbol.for("react.provider"), $29d7a53af20a6ce2$var$u = Symbol.for("react.context"), $29d7a53af20a6ce2$var$v = Symbol.for("react.forward_ref"), $29d7a53af20a6ce2$var$w = Symbol.for("react.suspense"), $29d7a53af20a6ce2$var$x = Symbol.for("react.memo"), $29d7a53af20a6ce2$var$y = Symbol.for("react.lazy"), $29d7a53af20a6ce2$var$z = Symbol.iterator;
function $29d7a53af20a6ce2$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $29d7a53af20a6ce2$var$z && a[$29d7a53af20a6ce2$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $29d7a53af20a6ce2$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $29d7a53af20a6ce2$var$C = Object.assign, $29d7a53af20a6ce2$var$D = {};
function $29d7a53af20a6ce2$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $29d7a53af20a6ce2$var$D;
    this.updater = e || $29d7a53af20a6ce2$var$B;
}
$29d7a53af20a6ce2$var$E.prototype.isReactComponent = {};
$29d7a53af20a6ce2$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$29d7a53af20a6ce2$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $29d7a53af20a6ce2$var$F() {}
$29d7a53af20a6ce2$var$F.prototype = $29d7a53af20a6ce2$var$E.prototype;
function $29d7a53af20a6ce2$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $29d7a53af20a6ce2$var$D;
    this.updater = e || $29d7a53af20a6ce2$var$B;
}
var $29d7a53af20a6ce2$var$H = $29d7a53af20a6ce2$var$G.prototype = new $29d7a53af20a6ce2$var$F;
$29d7a53af20a6ce2$var$H.constructor = $29d7a53af20a6ce2$var$G;
$29d7a53af20a6ce2$var$C($29d7a53af20a6ce2$var$H, $29d7a53af20a6ce2$var$E.prototype);
$29d7a53af20a6ce2$var$H.isPureReactComponent = !0;
var $29d7a53af20a6ce2$var$I = Array.isArray, $29d7a53af20a6ce2$var$J = Object.prototype.hasOwnProperty, $29d7a53af20a6ce2$var$K = {
    current: null
}, $29d7a53af20a6ce2$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $29d7a53af20a6ce2$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$29d7a53af20a6ce2$var$J.call(b, d) && !$29d7a53af20a6ce2$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $29d7a53af20a6ce2$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $29d7a53af20a6ce2$var$K.current
    };
}
function $29d7a53af20a6ce2$var$N(a, b) {
    return {
        $$typeof: $29d7a53af20a6ce2$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $29d7a53af20a6ce2$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $29d7a53af20a6ce2$var$l;
}
function $29d7a53af20a6ce2$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $29d7a53af20a6ce2$var$P = /\/+/g;
function $29d7a53af20a6ce2$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $29d7a53af20a6ce2$var$escape("" + a.key) : b.toString(36);
}
function $29d7a53af20a6ce2$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $29d7a53af20a6ce2$var$l:
                case $29d7a53af20a6ce2$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $29d7a53af20a6ce2$var$Q(h, 0) : d, $29d7a53af20a6ce2$var$I(c) ? (e = "", null != a && (e = a.replace($29d7a53af20a6ce2$var$P, "$&/") + "/"), $29d7a53af20a6ce2$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($29d7a53af20a6ce2$var$O(c) && (c = $29d7a53af20a6ce2$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($29d7a53af20a6ce2$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($29d7a53af20a6ce2$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $29d7a53af20a6ce2$var$Q(k, g);
        h += $29d7a53af20a6ce2$var$R(k, b, e, f, c);
    }
    else if (f = $29d7a53af20a6ce2$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $29d7a53af20a6ce2$var$Q(k, g++), h += $29d7a53af20a6ce2$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $29d7a53af20a6ce2$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $29d7a53af20a6ce2$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $29d7a53af20a6ce2$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $29d7a53af20a6ce2$var$U = {
    current: null
}, $29d7a53af20a6ce2$var$V = {
    transition: null
}, $29d7a53af20a6ce2$var$W = {
    ReactCurrentDispatcher: $29d7a53af20a6ce2$var$U,
    ReactCurrentBatchConfig: $29d7a53af20a6ce2$var$V,
    ReactCurrentOwner: $29d7a53af20a6ce2$var$K
};
function $29d7a53af20a6ce2$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$29d7a53af20a6ce2$export$dca3b0875bd9a954 = {
    map: $29d7a53af20a6ce2$var$S,
    forEach: function(a, b, e) {
        $29d7a53af20a6ce2$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $29d7a53af20a6ce2$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $29d7a53af20a6ce2$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$29d7a53af20a6ce2$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$29d7a53af20a6ce2$export$16fa2f45be04daa8 = $29d7a53af20a6ce2$var$E;
$29d7a53af20a6ce2$export$ffb0004e005737fa = $29d7a53af20a6ce2$var$p;
$29d7a53af20a6ce2$export$e2c29f18771995cb = $29d7a53af20a6ce2$var$r;
$29d7a53af20a6ce2$export$221d75b3f55bb0bd = $29d7a53af20a6ce2$var$G;
$29d7a53af20a6ce2$export$5f8d39834fd61797 = $29d7a53af20a6ce2$var$q;
$29d7a53af20a6ce2$export$74bf444e3cd11ea5 = $29d7a53af20a6ce2$var$w;
$29d7a53af20a6ce2$export$ae55be85d98224ed = $29d7a53af20a6ce2$var$W;
$29d7a53af20a6ce2$export$3ba232387fd5d6dd = $29d7a53af20a6ce2$var$X;
$29d7a53af20a6ce2$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $29d7a53af20a6ce2$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $29d7a53af20a6ce2$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$29d7a53af20a6ce2$var$J.call(b, f) && !$29d7a53af20a6ce2$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $29d7a53af20a6ce2$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$29d7a53af20a6ce2$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $29d7a53af20a6ce2$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $29d7a53af20a6ce2$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$29d7a53af20a6ce2$export$c8a8987d4410bf2d = $29d7a53af20a6ce2$var$M;
$29d7a53af20a6ce2$export$d38cd72104c1f0e9 = function(a) {
    var b = $29d7a53af20a6ce2$var$M.bind(null, a);
    b.type = a;
    return b;
};
$29d7a53af20a6ce2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$29d7a53af20a6ce2$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $29d7a53af20a6ce2$var$v,
        render: a
    };
};
$29d7a53af20a6ce2$export$a8257692ac88316c = $29d7a53af20a6ce2$var$O;
$29d7a53af20a6ce2$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $29d7a53af20a6ce2$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $29d7a53af20a6ce2$var$T
    };
};
$29d7a53af20a6ce2$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $29d7a53af20a6ce2$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$29d7a53af20a6ce2$export$7568632d0d33d16d = function(a) {
    var b = $29d7a53af20a6ce2$var$V.transition;
    $29d7a53af20a6ce2$var$V.transition = {};
    try {
        a();
    } finally{
        $29d7a53af20a6ce2$var$V.transition = b;
    }
};
$29d7a53af20a6ce2$export$88948ce120ea2619 = $29d7a53af20a6ce2$var$X;
$29d7a53af20a6ce2$export$35808ee640e87ca7 = function(a, b) {
    return $29d7a53af20a6ce2$var$U.current.useCallback(a, b);
};
$29d7a53af20a6ce2$export$fae74005e78b1a27 = function(a) {
    return $29d7a53af20a6ce2$var$U.current.useContext(a);
};
$29d7a53af20a6ce2$export$dc8fbce3eb94dc1e = function() {};
$29d7a53af20a6ce2$export$6a7bc4e911dc01cf = function(a) {
    return $29d7a53af20a6ce2$var$U.current.useDeferredValue(a);
};
$29d7a53af20a6ce2$export$6d9c69b0de29b591 = function(a, b) {
    return $29d7a53af20a6ce2$var$U.current.useEffect(a, b);
};
$29d7a53af20a6ce2$export$f680877a34711e37 = function() {
    return $29d7a53af20a6ce2$var$U.current.useId();
};
$29d7a53af20a6ce2$export$d5a552a76deda3c2 = function(a, b, e) {
    return $29d7a53af20a6ce2$var$U.current.useImperativeHandle(a, b, e);
};
$29d7a53af20a6ce2$export$aaabe4eda9ed9969 = function(a, b) {
    return $29d7a53af20a6ce2$var$U.current.useInsertionEffect(a, b);
};
$29d7a53af20a6ce2$export$e5c5a5f917a5871c = function(a, b) {
    return $29d7a53af20a6ce2$var$U.current.useLayoutEffect(a, b);
};
$29d7a53af20a6ce2$export$1538c33de8887b59 = function(a, b) {
    return $29d7a53af20a6ce2$var$U.current.useMemo(a, b);
};
$29d7a53af20a6ce2$export$13e3392192263954 = function(a, b, e) {
    return $29d7a53af20a6ce2$var$U.current.useReducer(a, b, e);
};
$29d7a53af20a6ce2$export$b8f5890fc79d6aca = function(a) {
    return $29d7a53af20a6ce2$var$U.current.useRef(a);
};
$29d7a53af20a6ce2$export$60241385465d0a34 = function(a) {
    return $29d7a53af20a6ce2$var$U.current.useState(a);
};
$29d7a53af20a6ce2$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $29d7a53af20a6ce2$var$U.current.useSyncExternalStore(a, b, e);
};
$29d7a53af20a6ce2$export$7b286972b8d8ccbf = function() {
    return $29d7a53af20a6ce2$var$U.current.useTransition();
};
$29d7a53af20a6ce2$export$83d89fbfd8236492 = "18.3.1";

});


parcelRegister("jEbac", function(module, exports) {
/**
 * Relay v20.1.1
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("dW8JE"));

});
parcelRegister("dW8JE", function(module, exports) {
'use strict';

var $1hStr = parcelRequire("1hStr");

var $hcInD = parcelRequire("hcInD");

var $q5gmz = parcelRequire("q5gmz");

var $le2gd = parcelRequire("le2gd");

var $2A0bC = parcelRequire("2A0bC");

var $7qVOt = parcelRequire("7qVOt");

var $7PnDX = parcelRequire("7PnDX");

var $8T3sM = parcelRequire("8T3sM");

var $gucdA = parcelRequire("gucdA");
var $a25777c4fa408cbc$var$loadQuery = $gucdA.loadQuery;

var $bB7hb = parcelRequire("bB7hb");

var $i9N25 = parcelRequire("i9N25");

var $h6pym = parcelRequire("h6pym");

var $dwWEa = parcelRequire("dwWEa");

var $cjsY7 = parcelRequire("cjsY7");

var $bGlmd = parcelRequire("bGlmd");

var $9ZZQS = parcelRequire("9ZZQS");

var $3gP7m = parcelRequire("3gP7m");

var $747sM = parcelRequire("747sM");

var $fMcxN = parcelRequire("fMcxN");

var $8QBSZ = parcelRequire("8QBSZ");

var $gELjH = parcelRequire("gELjH");

var $aLV9i = parcelRequire("aLV9i");

var $h3obL = parcelRequire("h3obL");

var $k4u74 = parcelRequire("k4u74");

var $ArurZ = parcelRequire("ArurZ");
module.exports = {
    ConnectionHandler: $ArurZ.ConnectionHandler,
    QueryRenderer: $2A0bC,
    LocalQueryRenderer: $q5gmz,
    MutationTypes: $ArurZ.MutationTypes,
    RangeOperations: $ArurZ.RangeOperations,
    ReactRelayContext: $1hStr,
    applyOptimisticMutation: $ArurZ.applyOptimisticMutation,
    commitLocalUpdate: $ArurZ.commitLocalUpdate,
    commitMutation: $ArurZ.commitMutation,
    createFragmentContainer: $hcInD.createContainer,
    createPaginationContainer: $le2gd.createContainer,
    createRefetchContainer: $7qVOt.createContainer,
    fetchQuery_DEPRECATED: $ArurZ.fetchQuery_DEPRECATED,
    graphql: $ArurZ.graphql,
    readInlineData: $ArurZ.readInlineData,
    requestSubscription: $ArurZ.requestSubscription,
    EntryPointContainer: $7PnDX,
    RelayEnvironmentProvider: $i9N25,
    ProfilerContext: $bB7hb,
    fetchQuery: $ArurZ.fetchQuery,
    loadQuery: $a25777c4fa408cbc$var$loadQuery,
    loadEntryPoint: $8T3sM,
    useClientQuery: $h6pym,
    useFragment: $cjsY7,
    useLazyLoadQuery: $bGlmd,
    useEntryPointLoader: $dwWEa,
    useQueryLoader: $8QBSZ,
    useMutation: $9ZZQS,
    usePaginationFragment: $3gP7m,
    usePreloadedQuery: $fMcxN,
    useRefetchableFragment: $gELjH,
    usePrefetchableForwardPaginationFragment: $747sM,
    useRelayEnvironment: $aLV9i,
    useSubscribeToInvalidationState: $h3obL,
    useSubscription: $k4u74
};

});
parcelRegister("1hStr", function(module, exports) {
'use strict';

var $1v5pe = parcelRequire("1v5pe");

var $ArurZ = parcelRequire("ArurZ");
var $0f01a255e7e0144f$var$createRelayContext = $ArurZ.__internal.createRelayContext;
module.exports = $0f01a255e7e0144f$var$createRelayContext($1v5pe);

});
parcelRegister("ArurZ", function(module, exports) {
/**
 * Relay v20.1.1
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("kxmr2"));

});
parcelRegister("kxmr2", function(module, exports) {
'use strict';

var $3KwdJ = parcelRequire("3KwdJ");
var $ef384adf0d78967a$var$isErrorResult = $3KwdJ.isErrorResult, $ef384adf0d78967a$var$isValueResult = $3KwdJ.isValueResult;

var $aZiI7 = parcelRequire("aZiI7");

var $ckpmP = parcelRequire("ckpmP");

var $krLBg = parcelRequire("krLBg");

var $cCKkj = parcelRequire("cCKkj");

var $51mRT = parcelRequire("51mRT");

var $cr3Pd = parcelRequire("cr3Pd");

var $lmRbm = parcelRequire("lmRbm");

var $IbWT2 = parcelRequire("IbWT2");

var $42Dtw = parcelRequire("42Dtw");

var $u7PH0 = parcelRequire("u7PH0");

var $26M0b = parcelRequire("26M0b");

var $02zve = parcelRequire("02zve");

var $70PVw = parcelRequire("70PVw");

var $aDkGX = parcelRequire("aDkGX");

var $5AvhW = parcelRequire("5AvhW");

var $jy2DY = parcelRequire("jy2DY");

var $fJ2hT = parcelRequire("fJ2hT");
var $ef384adf0d78967a$var$generateClientID = $fJ2hT.generateClientID, $ef384adf0d78967a$var$generateUniqueClientID = $fJ2hT.generateUniqueClientID, $ef384adf0d78967a$var$isClientID = $fJ2hT.isClientID;

var $dr26Y = parcelRequire("dr26Y");

var $83vbi = parcelRequire("83vbi");

var $9thWZ = parcelRequire("9thWZ");

var $Gchpg = parcelRequire("Gchpg");

var $gvcbH = parcelRequire("gvcbH");
var $ef384adf0d78967a$var$isSuspenseSentinel = $gvcbH.isSuspenseSentinel, $ef384adf0d78967a$var$suspenseSentinel = $gvcbH.suspenseSentinel;

var $8zzta = parcelRequire("8zzta");

var $cx0Ds = parcelRequire("cx0Ds");

var $gQ9aH = parcelRequire("gQ9aH");

var $anr3q = parcelRequire("anr3q");

var $f2NQb = parcelRequire("f2NQb");

var $cdcDZ = parcelRequire("cdcDZ");

var $dTSGA = parcelRequire("dTSGA");

var $gL89e = parcelRequire("gL89e");

var $59AhP = parcelRequire("59AhP");

var $qckAk = parcelRequire("qckAk");

var $5vBPt = parcelRequire("5vBPt");

var $8E0e2 = parcelRequire("8E0e2");

var $cBCPf = parcelRequire("cBCPf");

var $aOgBE = parcelRequire("aOgBE");

var $8yYFn = parcelRequire("8yYFn");

var $a9DXr = parcelRequire("a9DXr");

var $lzxG1 = parcelRequire("lzxG1");

var $3xHhH = parcelRequire("3xHhH");

var $hnYfT = parcelRequire("hnYfT");

var $gyLIM = parcelRequire("gyLIM");

var $4HhBF = parcelRequire("4HhBF");

var $1W7vD = parcelRequire("1W7vD");

var $4fgpQ = parcelRequire("4fgpQ");

var $jmyS6 = parcelRequire("jmyS6");

var $lLciG = parcelRequire("lLciG");
var $ef384adf0d78967a$var$handlePotentialSnapshotErrors = $lLciG.handlePotentialSnapshotErrors;

var $b3WHn = parcelRequire("b3WHn");

var $dEqQj = parcelRequire("dEqQj");

var $7hYYU = parcelRequire("7hYYU");

var $eqz8c = parcelRequire("eqz8c");

var $haR4J = parcelRequire("haR4J");

var $7vCKo = parcelRequire("7vCKo");

var $3hqjB = parcelRequire("3hqjB");

var $gmVBN = parcelRequire("gmVBN");

var $902AI = parcelRequire("902AI");

var $aFY6e = parcelRequire("aFY6e");
var $ef384adf0d78967a$var$hasCycle = $aFY6e.hasCycle, $ef384adf0d78967a$var$stableCopy = $aFY6e.stableCopy;

var $lOhgn = parcelRequire("lOhgn");
var $ef384adf0d78967a$var$mapStr, $ef384adf0d78967a$var$setStr, $ef384adf0d78967a$var$promiseStr, $ef384adf0d78967a$var$objStr;
module.exports = {
    Environment: $anr3q,
    Network: $42Dtw,
    Observable: $u7PH0,
    QueryResponseCache: $26M0b,
    RecordSource: $qckAk,
    Record: $cdcDZ,
    ReplaySubject: $902AI,
    Store: $gL89e,
    areEqualSelectors: $dTSGA.areEqualSelectors,
    createFragmentSpecResolver: $dr26Y,
    createNormalizationSelector: $dTSGA.createNormalizationSelector,
    createOperationDescriptor: $f2NQb.createOperationDescriptor,
    createReaderSelector: $dTSGA.createReaderSelector,
    createRequestDescriptor: $f2NQb.createRequestDescriptor,
    getArgumentValues: $5vBPt.getArgumentValues,
    getDataIDsFromFragment: $dTSGA.getDataIDsFromFragment,
    getDataIDsFromObject: $dTSGA.getDataIDsFromObject,
    getNode: $5AvhW.getNode,
    getFragment: $5AvhW.getFragment,
    getInlineDataFragment: $5AvhW.getInlineDataFragment,
    getModuleComponentKey: $5vBPt.getModuleComponentKey,
    getModuleOperationKey: $5vBPt.getModuleOperationKey,
    getPaginationFragment: $5AvhW.getPaginationFragment,
    getPluralSelector: $dTSGA.getPluralSelector,
    getRefetchableFragment: $5AvhW.getRefetchableFragment,
    getRequest: $5AvhW.getRequest,
    getRequestIdentifier: $4fgpQ,
    getSelector: $dTSGA.getSelector,
    getSelectorsFromObject: $dTSGA.getSelectorsFromObject,
    getSingularSelector: $dTSGA.getSingularSelector,
    getStorageKey: $5vBPt.getStorageKey,
    getVariablesFromFragment: $dTSGA.getVariablesFromFragment,
    getVariablesFromObject: $dTSGA.getVariablesFromObject,
    getVariablesFromPluralFragment: $dTSGA.getVariablesFromPluralFragment,
    getVariablesFromSingularFragment: $dTSGA.getVariablesFromSingularFragment,
    handlePotentialSnapshotErrors: $ef384adf0d78967a$var$handlePotentialSnapshotErrors,
    graphql: $5AvhW.graphql,
    isErrorResult: $ef384adf0d78967a$var$isErrorResult,
    isValueResult: $ef384adf0d78967a$var$isValueResult,
    isFragment: $5AvhW.isFragment,
    isInlineDataFragment: $5AvhW.isInlineDataFragment,
    isSuspenseSentinel: $ef384adf0d78967a$var$isSuspenseSentinel,
    suspenseSentinel: $ef384adf0d78967a$var$suspenseSentinel,
    isRequest: $5AvhW.isRequest,
    readInlineData: $cx0Ds,
    readFragment: $8E0e2.readFragment,
    MutationTypes: $IbWT2.MutationTypes,
    RangeOperations: $IbWT2.RangeOperations,
    DefaultHandlerProvider: $cCKkj,
    ConnectionHandler: $aZiI7,
    MutationHandlers: $krLBg,
    VIEWER_ID: $cBCPf.VIEWER_ID,
    VIEWER_TYPE: $cBCPf.VIEWER_TYPE,
    applyOptimisticMutation: $51mRT,
    commitLocalUpdate: $cr3Pd,
    commitMutation: $lmRbm,
    fetchQuery: $02zve,
    fetchQuery_DEPRECATED: $70PVw,
    isRelayModernEnvironment: $Gchpg,
    requestSubscription: $aOgBE,
    ConnectionInterface: $ckpmP,
    PreloadableQueryRegistry: $jy2DY,
    RelayProfiler: $gmVBN,
    createPayloadFor3DField: $8yYFn,
    RelayConcreteNode: $eqz8c,
    RelayError: $7vCKo,
    RelayFeatureFlags: $3hqjB,
    DEFAULT_HANDLE_KEY: $haR4J.DEFAULT_HANDLE_KEY,
    FRAGMENTS_KEY: $5vBPt.FRAGMENTS_KEY,
    FRAGMENT_OWNER_KEY: $5vBPt.FRAGMENT_OWNER_KEY,
    ID_KEY: $5vBPt.ID_KEY,
    REF_KEY: $5vBPt.REF_KEY,
    REFS_KEY: $5vBPt.REFS_KEY,
    ROOT_ID: $5vBPt.ROOT_ID,
    ROOT_TYPE: $5vBPt.ROOT_TYPE,
    TYPENAME_KEY: $5vBPt.TYPENAME_KEY,
    deepFreeze: $a9DXr,
    generateClientID: $ef384adf0d78967a$var$generateClientID,
    generateUniqueClientID: $ef384adf0d78967a$var$generateUniqueClientID,
    getRelayHandleKey: $1W7vD,
    isClientID: $ef384adf0d78967a$var$isClientID,
    isPromise: $b3WHn,
    isScalarAndEqual: $dEqQj,
    recycleNodesInto: $7hYYU,
    stableCopy: $ef384adf0d78967a$var$stableCopy,
    hasCycle: $ef384adf0d78967a$var$hasCycle,
    getFragmentIdentifier: $lzxG1,
    getRefetchMetadata: $4HhBF,
    getPaginationMetadata: $3xHhH,
    getPaginationVariables: $hnYfT,
    getPendingOperationsForFragment: $gyLIM,
    getValueAtPath: $jmyS6,
    __internal: {
        ResolverFragments: $8E0e2,
        OperationTracker: $59AhP,
        createRelayContext: $83vbi,
        createRelayLoggingContext: $9thWZ,
        getOperationVariables: $gQ9aH.getOperationVariables,
        getLocalVariables: $gQ9aH.getLocalVariables,
        fetchQuery: $aDkGX.fetchQuery,
        fetchQueryDeduped: $aDkGX.fetchQueryDeduped,
        getPromiseForActiveRequest: $aDkGX.getPromiseForActiveRequest,
        getObservableForActiveRequest: $aDkGX.getObservableForActiveRequest,
        normalizeResponse: $8zzta,
        withProvidedVariables: $lOhgn
    }
};

});
parcelRegister("3KwdJ", function(module, exports) {
'use strict';

var $6WRxp = parcelRequire("6WRxp");

var $7J5du = parcelRequire("7J5du");
var $2baea94d2237a691$var$observeFragment = $7J5du.observeFragment;

var $9hEmW = parcelRequire("9hEmW");
var $2baea94d2237a691$var$observeQuery = $9hEmW.observeQuery;

var $5D68Q = parcelRequire("5D68Q");
var $2baea94d2237a691$var$waitForFragmentData = $5D68Q.waitForFragmentData;
function $2baea94d2237a691$var$isValueResult(input) {
    return input.ok === true;
}
function $2baea94d2237a691$var$isErrorResult(input) {
    return input.ok === false;
}
module.exports = {
    resolverDataInjector: $6WRxp,
    isValueResult: $2baea94d2237a691$var$isValueResult,
    isErrorResult: $2baea94d2237a691$var$isErrorResult,
    observeQuery: $2baea94d2237a691$var$observeQuery,
    observeFragment: $2baea94d2237a691$var$observeFragment,
    waitForFragmentData: $2baea94d2237a691$var$waitForFragmentData
};

});
parcelRegister("6WRxp", function(module, exports) {
'use strict';

var $8E0e2 = parcelRequire("8E0e2");
var $50f1b05dc0829aba$var$readFragment = $8E0e2.readFragment;

var $5Wk1R = parcelRequire("5Wk1R");
function $50f1b05dc0829aba$var$resolverDataInjector(fragment, _resolverFn, fieldName, isRequiredField) {
    var resolverFn = _resolverFn;
    return function(fragmentKey, args, resolverContext) {
        var data = $50f1b05dc0829aba$var$readFragment(fragment, fragmentKey);
        if (fieldName != null) {
            if (data == null) {
                if (isRequiredField === true) $5Wk1R(false);
                else return resolverFn(null, args, resolverContext);
            }
            if (fieldName in data) {
                if (isRequiredField === true) !(data[fieldName] != null) && $5Wk1R(false);
                return resolverFn(data[fieldName], args, resolverContext);
            } else $5Wk1R(false);
        } else return resolverFn(null, args, resolverContext);
    };
}
module.exports = $50f1b05dc0829aba$var$resolverDataInjector;

});
parcelRegister("8E0e2", function(module, exports) {
'use strict';

var $5AvhW = parcelRequire("5AvhW");
var $64b23bebe1fd7169$var$getFragment = $5AvhW.getFragment;

var $lLciG = parcelRequire("lLciG");
var $64b23bebe1fd7169$var$eventShouldThrow = $lLciG.eventShouldThrow;

var $dTSGA = parcelRequire("dTSGA");
var $64b23bebe1fd7169$var$getSelector = $dTSGA.getSelector;

var $5Wk1R = parcelRequire("5Wk1R");
var $64b23bebe1fd7169$var$contextStack = [];
function $64b23bebe1fd7169$var$withResolverContext(context, cb) {
    $64b23bebe1fd7169$var$contextStack.push(context);
    try {
        return cb();
    } finally{
        $64b23bebe1fd7169$var$contextStack.pop();
    }
}
function $64b23bebe1fd7169$var$readFragment(fragmentInput, fragmentKey) {
    if (!$64b23bebe1fd7169$var$contextStack.length) throw new Error('readFragment should be called only from within a Relay Resolver function.');
    var context = $64b23bebe1fd7169$var$contextStack[$64b23bebe1fd7169$var$contextStack.length - 1];
    var fragmentNode = $64b23bebe1fd7169$var$getFragment(fragmentInput);
    var fragmentSelector = $64b23bebe1fd7169$var$getSelector(fragmentNode, fragmentKey);
    !(fragmentSelector != null) && $5Wk1R(false);
    !(fragmentSelector.kind === 'SingularReaderSelector') && $5Wk1R(false);
    var _context$getDataForRe = context.getDataForResolverFragment(fragmentSelector, fragmentKey), data = _context$getDataForRe.data, isMissingData = _context$getDataForRe.isMissingData, fieldErrors = _context$getDataForRe.fieldErrors;
    if (isMissingData || fieldErrors != null && fieldErrors.some($64b23bebe1fd7169$var$eventShouldThrow)) throw $64b23bebe1fd7169$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL;
    return data;
}
var $64b23bebe1fd7169$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL = {};
module.exports = {
    readFragment: $64b23bebe1fd7169$var$readFragment,
    withResolverContext: $64b23bebe1fd7169$var$withResolverContext,
    RESOLVER_FRAGMENT_ERRORED_SENTINEL: $64b23bebe1fd7169$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL
};

});
parcelRegister("5AvhW", function(module, exports) {
'use strict';

var $eqz8c = parcelRequire("eqz8c");

var $5Wk1R = parcelRequire("5Wk1R");
parcelRequire("91yGl");
function $411895c2bd747f34$var$graphql(strings) {
    $5Wk1R(false);
}
function $411895c2bd747f34$var$getNode(taggedNode) {
    var node = taggedNode;
    if (typeof node === 'function') node = node();
    else if (node["default"]) node = node["default"];
    return node;
}
function $411895c2bd747f34$var$isFragment(node) {
    var fragment = $411895c2bd747f34$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $eqz8c.FRAGMENT;
}
function $411895c2bd747f34$var$isRequest(node) {
    var request = $411895c2bd747f34$var$getNode(node);
    return typeof request === 'object' && request !== null && request.kind === $eqz8c.REQUEST;
}
function $411895c2bd747f34$var$isUpdatableQuery(node) {
    var updatableQuery = $411895c2bd747f34$var$getNode(node);
    return typeof updatableQuery === 'object' && updatableQuery !== null && updatableQuery.kind === $eqz8c.UPDATABLE_QUERY;
}
function $411895c2bd747f34$var$isInlineDataFragment(node) {
    var fragment = $411895c2bd747f34$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $eqz8c.INLINE_DATA_FRAGMENT;
}
function $411895c2bd747f34$var$getFragment(taggedNode) {
    var fragment = $411895c2bd747f34$var$getNode(taggedNode);
    !$411895c2bd747f34$var$isFragment(fragment) && $5Wk1R(false);
    return fragment;
}
function $411895c2bd747f34$var$getPaginationFragment(taggedNode) {
    var _fragment$metadata;
    var fragment = $411895c2bd747f34$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.refetch;
    var connection = refetch === null || refetch === void 0 ? void 0 : refetch.connection;
    if (refetch === null || typeof refetch !== 'object' || connection === null || typeof connection !== 'object') return null;
    return fragment;
}
function $411895c2bd747f34$var$getRefetchableFragment(taggedNode) {
    var _fragment$metadata2;
    var fragment = $411895c2bd747f34$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata2 = fragment.metadata) === null || _fragment$metadata2 === void 0 ? void 0 : _fragment$metadata2.refetch;
    if (refetch === null || typeof refetch !== 'object') return null;
    return fragment;
}
function $411895c2bd747f34$var$getRequest(taggedNode) {
    var request = $411895c2bd747f34$var$getNode(taggedNode);
    !$411895c2bd747f34$var$isRequest(request) && $5Wk1R(false);
    return request;
}
function $411895c2bd747f34$var$getUpdatableQuery(taggedNode) {
    var updatableQuery = $411895c2bd747f34$var$getNode(taggedNode);
    !$411895c2bd747f34$var$isUpdatableQuery(updatableQuery) && $5Wk1R(false);
    return updatableQuery;
}
function $411895c2bd747f34$var$getInlineDataFragment(taggedNode) {
    var fragment = $411895c2bd747f34$var$getNode(taggedNode);
    !$411895c2bd747f34$var$isInlineDataFragment(fragment) && $5Wk1R(false);
    return fragment;
}
module.exports = {
    getFragment: $411895c2bd747f34$var$getFragment,
    getNode: $411895c2bd747f34$var$getNode,
    getPaginationFragment: $411895c2bd747f34$var$getPaginationFragment,
    getRefetchableFragment: $411895c2bd747f34$var$getRefetchableFragment,
    getRequest: $411895c2bd747f34$var$getRequest,
    getUpdatableQuery: $411895c2bd747f34$var$getUpdatableQuery,
    getInlineDataFragment: $411895c2bd747f34$var$getInlineDataFragment,
    graphql: $411895c2bd747f34$var$graphql,
    isFragment: $411895c2bd747f34$var$isFragment,
    isRequest: $411895c2bd747f34$var$isRequest,
    isUpdatableQuery: $411895c2bd747f34$var$isUpdatableQuery,
    isInlineDataFragment: $411895c2bd747f34$var$isInlineDataFragment
};

});
parcelRegister("eqz8c", function(module, exports) {
'use strict';
var $a80ebebcbb234b2f$var$RelayConcreteNode = {
    ACTOR_CHANGE: 'ActorChange',
    CATCH_FIELD: 'CatchField',
    CONDITION: 'Condition',
    CLIENT_COMPONENT: 'ClientComponent',
    CLIENT_EDGE_TO_SERVER_OBJECT: 'ClientEdgeToServerObject',
    CLIENT_EDGE_TO_CLIENT_OBJECT: 'ClientEdgeToClientObject',
    CLIENT_EXTENSION: 'ClientExtension',
    DEFER: 'Defer',
    CONNECTION: 'Connection',
    FRAGMENT: 'Fragment',
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_DATA_FRAGMENT_SPREAD: 'InlineDataFragmentSpread',
    INLINE_DATA_FRAGMENT: 'InlineDataFragment',
    INLINE_FRAGMENT: 'InlineFragment',
    LINKED_FIELD: 'LinkedField',
    LINKED_HANDLE: 'LinkedHandle',
    LITERAL: 'Literal',
    LIST_VALUE: 'ListValue',
    LOCAL_ARGUMENT: 'LocalArgument',
    MODULE_IMPORT: 'ModuleImport',
    ALIASED_FRAGMENT_SPREAD: 'AliasedFragmentSpread',
    ALIASED_INLINE_FRAGMENT_SPREAD: 'AliasedInlineFragmentSpread',
    RELAY_RESOLVER: 'RelayResolver',
    RELAY_LIVE_RESOLVER: 'RelayLiveResolver',
    REQUIRED_FIELD: 'RequiredField',
    OBJECT_VALUE: 'ObjectValue',
    OPERATION: 'Operation',
    REQUEST: 'Request',
    ROOT_ARGUMENT: 'RootArgument',
    SCALAR_FIELD: 'ScalarField',
    SCALAR_HANDLE: 'ScalarHandle',
    SPLIT_OPERATION: 'SplitOperation',
    STREAM: 'Stream',
    TYPE_DISCRIMINATOR: 'TypeDiscriminator',
    UPDATABLE_QUERY: 'UpdatableQuery',
    VARIABLE: 'Variable'
};
module.exports = $a80ebebcbb234b2f$var$RelayConcreteNode;

});

parcelRegister("5Wk1R", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $4531e7dae4644d11$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $4531e7dae4644d11$var$invariant;

});

parcelRegister("91yGl", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';

var $5pRgy = parcelRequire("5pRgy");
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ function $691f1c32095d0b1c$var$printWarning(format) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function() {
        return args[argIndex++];
    });
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
}
var $691f1c32095d0b1c$var$warning = $5pRgy;
module.exports = $691f1c32095d0b1c$var$warning;

});
parcelRegister("5pRgy", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function $3f189b184013f32d$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var $3f189b184013f32d$var$emptyFunction = function emptyFunction() {};
$3f189b184013f32d$var$emptyFunction.thatReturns = $3f189b184013f32d$var$makeEmptyFunction;
$3f189b184013f32d$var$emptyFunction.thatReturnsFalse = $3f189b184013f32d$var$makeEmptyFunction(false);
$3f189b184013f32d$var$emptyFunction.thatReturnsTrue = $3f189b184013f32d$var$makeEmptyFunction(true);
$3f189b184013f32d$var$emptyFunction.thatReturnsNull = $3f189b184013f32d$var$makeEmptyFunction(null);
$3f189b184013f32d$var$emptyFunction.thatReturnsThis = function() {
    return this;
};
$3f189b184013f32d$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
module.exports = $3f189b184013f32d$var$emptyFunction;

});



parcelRegister("lLciG", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $fd778754903b97fa$var$_interopRequireDefault = $bGHxy.default;

var $fd778754903b97fa$var$_objectSpread2 = $fd778754903b97fa$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $fd778754903b97fa$var$_createForOfIteratorHelper2 = $fd778754903b97fa$var$_interopRequireDefault((parcelRequire("cXbK5")));

var $5Wk1R = parcelRequire("5Wk1R");
function $fd778754903b97fa$var$handleFieldErrors(environment, fieldErrors, loggingContext) {
    var _iterator = (0, $fd778754903b97fa$var$_createForOfIteratorHelper2["default"])(fieldErrors), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var fieldError = _step.value;
            environment.relayFieldLogger((0, $fd778754903b97fa$var$_objectSpread2["default"])((0, $fd778754903b97fa$var$_objectSpread2["default"])({}, fieldError), {}, {
                uiContext: loggingContext
            }));
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var _iterator2 = (0, $fd778754903b97fa$var$_createForOfIteratorHelper2["default"])(fieldErrors), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _fieldError = _step2.value;
            if ($fd778754903b97fa$var$eventShouldThrow(_fieldError)) switch(_fieldError.kind){
                case 'relay_resolver.error':
                    throw new Error("Relay: Resolver error at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'. Message: ").concat(_fieldError.error.message));
                case 'relay_field_payload.error':
                    throw new Error("Relay: Unexpected response payload - check server logs for details.");
                case 'missing_expected_data.throw':
                    throw new Error("Relay: Missing expected data at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'."));
                case 'missing_required_field.throw':
                    throw new Error("Relay: Missing @required value at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'."));
                case 'missing_required_field.log':
                case 'missing_expected_data.log':
                    break;
                default:
                    _fieldError.kind;
                    $5Wk1R(false);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $fd778754903b97fa$var$eventShouldThrow(event) {
    switch(event.kind){
        case 'relay_resolver.error':
        case 'relay_field_payload.error':
            return event.shouldThrow && !event.handled;
        case 'missing_expected_data.throw':
        case 'missing_required_field.throw':
            return !event.handled;
        case 'missing_required_field.log':
        case 'missing_expected_data.log':
            return false;
        default:
            event.kind;
            throw new Error('Relay: Unexpected event kind');
    }
}
function $fd778754903b97fa$var$handlePotentialSnapshotErrors(environment, fieldErrors, loggingContext) {
    if (fieldErrors != null) $fd778754903b97fa$var$handleFieldErrors(environment, fieldErrors, loggingContext);
}
module.exports = {
    handlePotentialSnapshotErrors: $fd778754903b97fa$var$handlePotentialSnapshotErrors,
    eventShouldThrow: $fd778754903b97fa$var$eventShouldThrow
};

});
parcelRegister("bGHxy", function(module, exports) {
function $8825641de9a7f6ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $8825641de9a7f6ae$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eQAdv", function(module, exports) {

var $aUl3j = parcelRequire("aUl3j");
function $acf203e8e7ef22ed$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $acf203e8e7ef22ed$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $acf203e8e7ef22ed$var$ownKeys(Object(t), !0).forEach(function(r) {
            $aUl3j(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $acf203e8e7ef22ed$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $acf203e8e7ef22ed$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aUl3j", function(module, exports) {

var $fIrVD = parcelRequire("fIrVD");
function $7f0f76e94aeeca26$var$_defineProperty(e, r, t) {
    return (r = $fIrVD(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $7f0f76e94aeeca26$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fIrVD", function(module, exports) {

var $ergie = parcelRequire("ergie");
var $b710a116c23a6cbf$var$_typeof = $ergie.default;

var $gUZ5f = parcelRequire("gUZ5f");
function $b710a116c23a6cbf$var$toPropertyKey(t) {
    var i = $gUZ5f(t, "string");
    return "symbol" == $b710a116c23a6cbf$var$_typeof(i) ? i : i + "";
}
module.exports = $b710a116c23a6cbf$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ergie", function(module, exports) {
function $a83039c7841866c8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $a83039c7841866c8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a83039c7841866c8$var$_typeof(o);
}
module.exports = $a83039c7841866c8$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gUZ5f", function(module, exports) {

var $ergie = parcelRequire("ergie");
var $c511423d531e0ac5$var$_typeof = $ergie.default;
function $c511423d531e0ac5$var$toPrimitive(t, r) {
    if ("object" != $c511423d531e0ac5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c511423d531e0ac5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $c511423d531e0ac5$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("cXbK5", function(module, exports) {

var $2DKWi = parcelRequire("2DKWi");
function $96e41a7c8465efa9$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $2DKWi(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
module.exports = $96e41a7c8465efa9$var$_createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2DKWi", function(module, exports) {

var $9nben = parcelRequire("9nben");
function $1ec3a26f94d3de10$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9nben(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9nben(r, a) : void 0;
    }
}
module.exports = $1ec3a26f94d3de10$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9nben", function(module, exports) {
function $6d2ef944fbdccd0b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $6d2ef944fbdccd0b$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("dTSGA", function(module, exports) {
'use strict';

var $gQ9aH = parcelRequire("gQ9aH");
var $a1ead4e3cf16d497$var$getFragmentVariables = $gQ9aH.getFragmentVariables;

var $5vBPt = parcelRequire("5vBPt");
var $a1ead4e3cf16d497$var$CLIENT_EDGE_TRAVERSAL_PATH = $5vBPt.CLIENT_EDGE_TRAVERSAL_PATH, $a1ead4e3cf16d497$var$FRAGMENT_OWNER_KEY = $5vBPt.FRAGMENT_OWNER_KEY, $a1ead4e3cf16d497$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT = $5vBPt.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT, $a1ead4e3cf16d497$var$FRAGMENTS_KEY = $5vBPt.FRAGMENTS_KEY, $a1ead4e3cf16d497$var$ID_KEY = $5vBPt.ID_KEY;

var $cGxFv = parcelRequire("cGxFv");

var $5Wk1R = parcelRequire("5Wk1R");
parcelRequire("91yGl");
function $a1ead4e3cf16d497$var$getSingularSelector(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $5Wk1R(false);
    var dataID = item[$a1ead4e3cf16d497$var$ID_KEY];
    var fragments = item[$a1ead4e3cf16d497$var$FRAGMENTS_KEY];
    var mixedOwner = item[$a1ead4e3cf16d497$var$FRAGMENT_OWNER_KEY];
    var mixedClientEdgeTraversalPath = item[$a1ead4e3cf16d497$var$CLIENT_EDGE_TRAVERSAL_PATH];
    if (typeof dataID === 'string' && typeof fragments === 'object' && fragments !== null && typeof fragments[fragment.name] === 'object' && fragments[fragment.name] !== null && typeof mixedOwner === 'object' && mixedOwner !== null && (mixedClientEdgeTraversalPath == null || Array.isArray(mixedClientEdgeTraversalPath))) {
        var owner = mixedOwner;
        var clientEdgeTraversalPath = mixedClientEdgeTraversalPath;
        var argumentVariables = fragments[fragment.name];
        var fragmentVariables = $a1ead4e3cf16d497$var$getFragmentVariables(fragment, owner.variables, argumentVariables);
        var isWithinUnmatchedTypeRefinement = argumentVariables[$a1ead4e3cf16d497$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] === true;
        return $a1ead4e3cf16d497$var$createReaderSelector(fragment, dataID, fragmentVariables, owner, isWithinUnmatchedTypeRefinement, clientEdgeTraversalPath);
    }
    var stringifiedItem;
    return null;
}
function $a1ead4e3cf16d497$var$getPluralSelector(fragment, items) {
    var selectors = null;
    items.forEach(function(item, ii) {
        var selector = item != null ? $a1ead4e3cf16d497$var$getSingularSelector(fragment, item) : null;
        if (selector != null) {
            selectors = selectors || [];
            selectors.push(selector);
        }
    });
    if (selectors == null) return null;
    else return {
        kind: 'PluralReaderSelector',
        selectors: selectors
    };
}
function $a1ead4e3cf16d497$var$getSelector(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $5Wk1R(false);
        return $a1ead4e3cf16d497$var$getPluralSelector(fragment, item);
    } else {
        !!Array.isArray(item) && $5Wk1R(false);
        return $a1ead4e3cf16d497$var$getSingularSelector(fragment, item);
    }
}
function $a1ead4e3cf16d497$var$getSelectorsFromObject(fragments, object) {
    var selectors = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        selectors[key] = $a1ead4e3cf16d497$var$getSelector(fragment, item);
    }
    return selectors;
}
function $a1ead4e3cf16d497$var$getDataIDsFromObject(fragments, object) {
    var ids = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        ids[key] = $a1ead4e3cf16d497$var$getDataIDsFromFragment(fragment, item);
    }
    return ids;
}
function $a1ead4e3cf16d497$var$getDataIDsFromFragment(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $5Wk1R(false);
        return $a1ead4e3cf16d497$var$getDataIDs(fragment, item);
    } else {
        !!Array.isArray(item) && $5Wk1R(false);
        return $a1ead4e3cf16d497$var$getDataID(fragment, item);
    }
}
function $a1ead4e3cf16d497$var$getDataIDs(fragment, items) {
    var ids = null;
    items.forEach(function(item) {
        var id = item != null ? $a1ead4e3cf16d497$var$getDataID(fragment, item) : null;
        if (id != null) {
            ids = ids || [];
            ids.push(id);
        }
    });
    return ids;
}
function $a1ead4e3cf16d497$var$getDataID(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $5Wk1R(false);
    var dataID = item[$a1ead4e3cf16d497$var$ID_KEY];
    if (typeof dataID === 'string') return dataID;
    return null;
}
function $a1ead4e3cf16d497$var$getVariablesFromObject(fragments, object) {
    var variables = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        var itemVariables = $a1ead4e3cf16d497$var$getVariablesFromFragment(fragment, item);
        Object.assign(variables, itemVariables);
    }
    return variables;
}
function $a1ead4e3cf16d497$var$getVariablesFromFragment(fragment, item) {
    var _fragment$metadata;
    if (item == null) return {};
    else if (((_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.plural) === true) {
        !Array.isArray(item) && $5Wk1R(false);
        return $a1ead4e3cf16d497$var$getVariablesFromPluralFragment(fragment, item);
    } else {
        !!Array.isArray(item) && $5Wk1R(false);
        return $a1ead4e3cf16d497$var$getVariablesFromSingularFragment(fragment, item) || {};
    }
}
function $a1ead4e3cf16d497$var$getVariablesFromSingularFragment(fragment, item) {
    var selector = $a1ead4e3cf16d497$var$getSingularSelector(fragment, item);
    if (!selector) return null;
    return selector.variables;
}
function $a1ead4e3cf16d497$var$getVariablesFromPluralFragment(fragment, items) {
    var variables = {};
    items.forEach(function(value, ii) {
        if (value != null) {
            var itemVariables = $a1ead4e3cf16d497$var$getVariablesFromSingularFragment(fragment, value);
            if (itemVariables != null) Object.assign(variables, itemVariables);
        }
    });
    return variables;
}
function $a1ead4e3cf16d497$var$areEqualSingularSelectors(thisSelector, thatSelector) {
    return thisSelector.dataID === thatSelector.dataID && thisSelector.node === thatSelector.node && $cGxFv(thisSelector.variables, thatSelector.variables) && $a1ead4e3cf16d497$var$areEqualOwners(thisSelector.owner, thatSelector.owner) && thisSelector.isWithinUnmatchedTypeRefinement === thatSelector.isWithinUnmatchedTypeRefinement && $a1ead4e3cf16d497$var$areEqualClientEdgeTraversalPaths(thisSelector.clientEdgeTraversalPath, thatSelector.clientEdgeTraversalPath);
}
function $a1ead4e3cf16d497$var$areEqualOwners(thisOwner, thatOwner) {
    if (thisOwner === thatOwner) return true;
    else return thisOwner.identifier === thatOwner.identifier && $cGxFv(thisOwner.cacheConfig, thatOwner.cacheConfig);
}
function $a1ead4e3cf16d497$var$areEqualClientEdgeTraversalPaths(thisPath, thatPath) {
    if (thisPath === thatPath) return true;
    if (thisPath == null || thatPath == null || thisPath.length !== thatPath.length) return false;
    var idx = thisPath.length;
    while(idx--){
        var a = thisPath[idx];
        var b = thatPath[idx];
        if (a === b) continue;
        if (a == null || b == null || a.clientEdgeDestinationID !== b.clientEdgeDestinationID || a.readerClientEdge !== b.readerClientEdge) return false;
    }
    return true;
}
function $a1ead4e3cf16d497$var$areEqualSelectors(a, b) {
    if (a === b) return true;
    else if (a == null) return b == null;
    else if (b == null) return a == null;
    else if (a.kind === 'SingularReaderSelector' && b.kind === 'SingularReaderSelector') return $a1ead4e3cf16d497$var$areEqualSingularSelectors(a, b);
    else if (a.kind === 'PluralReaderSelector' && b.kind === 'PluralReaderSelector') return a.selectors.length === b.selectors.length && a.selectors.every(function(s, i) {
        return $a1ead4e3cf16d497$var$areEqualSingularSelectors(s, b.selectors[i]);
    });
    else return false;
}
function $a1ead4e3cf16d497$var$createReaderSelector(fragment, dataID, variables, request) {
    var isWithinUnmatchedTypeRefinement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var clientEdgeTraversalPath = arguments.length > 5 ? arguments[5] : undefined;
    return {
        kind: 'SingularReaderSelector',
        dataID: dataID,
        isWithinUnmatchedTypeRefinement: isWithinUnmatchedTypeRefinement,
        clientEdgeTraversalPath: clientEdgeTraversalPath !== null && clientEdgeTraversalPath !== void 0 ? clientEdgeTraversalPath : null,
        node: fragment,
        variables: variables,
        owner: request
    };
}
function $a1ead4e3cf16d497$var$createNormalizationSelector(node, dataID, variables) {
    return {
        dataID: dataID,
        node: node,
        variables: variables
    };
}
module.exports = {
    areEqualSelectors: $a1ead4e3cf16d497$var$areEqualSelectors,
    createReaderSelector: $a1ead4e3cf16d497$var$createReaderSelector,
    createNormalizationSelector: $a1ead4e3cf16d497$var$createNormalizationSelector,
    getDataIDsFromFragment: $a1ead4e3cf16d497$var$getDataIDsFromFragment,
    getDataIDsFromObject: $a1ead4e3cf16d497$var$getDataIDsFromObject,
    getSingularSelector: $a1ead4e3cf16d497$var$getSingularSelector,
    getPluralSelector: $a1ead4e3cf16d497$var$getPluralSelector,
    getSelector: $a1ead4e3cf16d497$var$getSelector,
    getSelectorsFromObject: $a1ead4e3cf16d497$var$getSelectorsFromObject,
    getVariablesFromSingularFragment: $a1ead4e3cf16d497$var$getVariablesFromSingularFragment,
    getVariablesFromPluralFragment: $a1ead4e3cf16d497$var$getVariablesFromPluralFragment,
    getVariablesFromFragment: $a1ead4e3cf16d497$var$getVariablesFromFragment,
    getVariablesFromObject: $a1ead4e3cf16d497$var$getVariablesFromObject
};

});
parcelRegister("gQ9aH", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $c4289df35f173541$var$_interopRequireDefault = $bGHxy.default;

var $c4289df35f173541$var$_objectSpread2 = $c4289df35f173541$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $5vBPt = parcelRequire("5vBPt");
var $c4289df35f173541$var$getArgumentValues = $5vBPt.getArgumentValues;

var $5Wk1R = parcelRequire("5Wk1R");
function $c4289df35f173541$var$getFragmentVariables(fragment, rootVariables, argumentVariables) {
    if (fragment.argumentDefinitions == null) return argumentVariables;
    var variables;
    fragment.argumentDefinitions.forEach(function(definition) {
        if (argumentVariables.hasOwnProperty(definition.name)) return;
        variables = variables || (0, $c4289df35f173541$var$_objectSpread2["default"])({}, argumentVariables);
        switch(definition.kind){
            case 'LocalArgument':
                variables[definition.name] = definition.defaultValue;
                break;
            case 'RootArgument':
                if (!rootVariables.hasOwnProperty(definition.name)) {
                    variables[definition.name] = undefined;
                    break;
                }
                variables[definition.name] = rootVariables[definition.name];
                break;
            default:
                definition;
                $5Wk1R(false);
        }
    });
    return variables || argumentVariables;
}
function $c4289df35f173541$var$getOperationVariables(operation, providedVariables, variables) {
    var operationVariables = {};
    operation.argumentDefinitions.forEach(function(def) {
        var value = def.defaultValue;
        if (variables[def.name] != null) value = variables[def.name];
        operationVariables[def.name] = value;
    });
    if (providedVariables != null) Object.keys(providedVariables).forEach(function(varName) {
        operationVariables[varName] = providedVariables[varName].get();
    });
    return operationVariables;
}
function $c4289df35f173541$var$getLocalVariables(currentVariables, argumentDefinitions, args) {
    if (argumentDefinitions == null) return currentVariables;
    var nextVariables = (0, $c4289df35f173541$var$_objectSpread2["default"])({}, currentVariables);
    var nextArgs = args ? $c4289df35f173541$var$getArgumentValues(args, currentVariables) : {};
    argumentDefinitions.forEach(function(def) {
        var _nextArgs$def$name;
        var value = (_nextArgs$def$name = nextArgs[def.name]) !== null && _nextArgs$def$name !== void 0 ? _nextArgs$def$name : def.defaultValue;
        nextVariables[def.name] = value;
    });
    return nextVariables;
}
module.exports = {
    getLocalVariables: $c4289df35f173541$var$getLocalVariables,
    getFragmentVariables: $c4289df35f173541$var$getFragmentVariables,
    getOperationVariables: $c4289df35f173541$var$getOperationVariables
};

});
parcelRegister("5vBPt", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $402d311d6f799697$var$_interopRequireDefault = $bGHxy.default;

var $402d311d6f799697$var$_toConsumableArray2 = $402d311d6f799697$var$_interopRequireDefault((parcelRequire("kTVTn")));

var $1W7vD = parcelRequire("1W7vD");

var $eqz8c = parcelRequire("eqz8c");

var $3hqjB = parcelRequire("3hqjB");

var $aFY6e = parcelRequire("aFY6e");
var $402d311d6f799697$var$stableCopy = $aFY6e.stableCopy;

var $5Wk1R = parcelRequire("5Wk1R");
var $402d311d6f799697$var$VARIABLE = $eqz8c.VARIABLE, $402d311d6f799697$var$LITERAL = $eqz8c.LITERAL, $402d311d6f799697$var$OBJECT_VALUE = $eqz8c.OBJECT_VALUE, $402d311d6f799697$var$LIST_VALUE = $eqz8c.LIST_VALUE;
var $402d311d6f799697$var$ERRORS_KEY = '__errors';
var $402d311d6f799697$var$MODULE_COMPONENT_KEY_PREFIX = '__module_component_';
var $402d311d6f799697$var$MODULE_OPERATION_KEY_PREFIX = '__module_operation_';
var $402d311d6f799697$var$RELAY_READ_TIME_RESOLVER_KEY_PREFIX = '$r:';
function $402d311d6f799697$var$getArgumentValue(arg, variables) {
    if (arg.kind === $402d311d6f799697$var$VARIABLE) return $402d311d6f799697$var$getStableVariableValue(arg.variableName, variables);
    else if (arg.kind === $402d311d6f799697$var$LITERAL) return arg.value;
    else if (arg.kind === $402d311d6f799697$var$OBJECT_VALUE) {
        var value = {};
        arg.fields.forEach(function(field) {
            value[field.name] = $402d311d6f799697$var$getArgumentValue(field, variables);
        });
        return value;
    } else if (arg.kind === $402d311d6f799697$var$LIST_VALUE) {
        var _value = [];
        arg.items.forEach(function(item) {
            item != null && _value.push($402d311d6f799697$var$getArgumentValue(item, variables));
        });
        return _value;
    }
}
function $402d311d6f799697$var$getArgumentValues(args, variables, isWithinUnmatchedTypeRefinement) {
    var values = {};
    if (isWithinUnmatchedTypeRefinement) values[$402d311d6f799697$var$RelayStoreUtils.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] = true;
    if (args) args.forEach(function(arg) {
        values[arg.name] = $402d311d6f799697$var$getArgumentValue(arg, variables);
    });
    return values;
}
function $402d311d6f799697$var$getHandleStorageKey(handleField, variables) {
    var dynamicKey = handleField.dynamicKey, handle = handleField.handle, key = handleField.key, name = handleField.name, args = handleField.args, filters = handleField.filters;
    var handleName = $1W7vD(handle, key, name);
    var filterArgs = null;
    if (args && filters && args.length !== 0 && filters.length !== 0) filterArgs = args.filter(function(arg) {
        return filters.indexOf(arg.name) > -1;
    });
    if (dynamicKey) filterArgs = filterArgs != null ? [
        dynamicKey
    ].concat((0, $402d311d6f799697$var$_toConsumableArray2["default"])(filterArgs)) : [
        dynamicKey
    ];
    if (filterArgs === null) return handleName;
    else return $402d311d6f799697$var$formatStorageKey(handleName, $402d311d6f799697$var$getArgumentValues(filterArgs, variables));
}
function $402d311d6f799697$var$getStorageKey(field, variables) {
    if (field.storageKey) return field.storageKey;
    var args = $402d311d6f799697$var$getArguments(field);
    var name = field.name;
    return args && args.length !== 0 ? $402d311d6f799697$var$formatStorageKey(name, $402d311d6f799697$var$getArgumentValues(args, variables)) : name;
}
function $402d311d6f799697$var$getReadTimeResolverStorageKey(field, variables) {
    var storageKey = $402d311d6f799697$var$getStorageKey(field, variables);
    return $3hqjB.ENABLE_READ_TIME_RESOLVER_STORAGE_KEY_PREFIX ? '$r:' + storageKey : storageKey;
}
function $402d311d6f799697$var$getArguments(field) {
    if (field.kind === 'RelayResolver' || field.kind === 'RelayLiveResolver') {
        var _field$fragment2;
        if (field.args == null) {
            var _field$fragment;
            return (_field$fragment = field.fragment) === null || _field$fragment === void 0 ? void 0 : _field$fragment.args;
        }
        if (((_field$fragment2 = field.fragment) === null || _field$fragment2 === void 0 ? void 0 : _field$fragment2.args) == null) return field.args;
        return field.args.concat(field.fragment.args);
    }
    var args = typeof field.args === 'undefined' ? undefined : field.args;
    return args;
}
function $402d311d6f799697$var$getStableStorageKey(name, args) {
    return $402d311d6f799697$var$formatStorageKey(name, $402d311d6f799697$var$stableCopy(args));
}
function $402d311d6f799697$var$formatStorageKey(name, argValues) {
    if (!argValues) return name;
    var values = [];
    for(var argName in argValues)if (argValues.hasOwnProperty(argName)) {
        var value = argValues[argName];
        if (value != null) {
            var _JSON$stringify;
            values.push(argName + ':' + ((_JSON$stringify = JSON.stringify(value)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'undefined'));
        }
    }
    return values.length === 0 ? name : name + "(".concat(values.join(','), ")");
}
function $402d311d6f799697$var$getStableVariableValue(name, variables) {
    !variables.hasOwnProperty(name) && $5Wk1R(false);
    return $402d311d6f799697$var$stableCopy(variables[name]);
}
function $402d311d6f799697$var$getModuleComponentKey(documentName) {
    return "".concat($402d311d6f799697$var$MODULE_COMPONENT_KEY_PREFIX).concat(documentName);
}
function $402d311d6f799697$var$getModuleOperationKey(documentName) {
    return "".concat($402d311d6f799697$var$MODULE_OPERATION_KEY_PREFIX).concat(documentName);
}
var $402d311d6f799697$var$RelayStoreUtils = {
    ACTOR_IDENTIFIER_KEY: '__actorIdentifier',
    CLIENT_EDGE_TRAVERSAL_PATH: '__clientEdgeTraversalPath',
    FRAGMENTS_KEY: '__fragments',
    FRAGMENT_OWNER_KEY: '__fragmentOwner',
    FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT: '$isWithinUnmatchedTypeRefinement',
    FRAGMENT_PROP_NAME_KEY: '__fragmentPropName',
    MODULE_COMPONENT_KEY: '__module_component',
    ERRORS_KEY: $402d311d6f799697$var$ERRORS_KEY,
    ID_KEY: '__id',
    REF_KEY: '__ref',
    REFS_KEY: '__refs',
    ROOT_ID: 'client:root',
    ROOT_TYPE: '__Root',
    TYPENAME_KEY: '__typename',
    INVALIDATED_AT_KEY: '__invalidated_at',
    RELAY_RESOLVER_VALUE_KEY: '__resolverValue',
    RELAY_RESOLVER_INVALIDATION_KEY: '__resolverValueMayBeInvalid',
    RELAY_RESOLVER_SNAPSHOT_KEY: '__resolverSnapshot',
    RELAY_RESOLVER_ERROR_KEY: '__resolverError',
    RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS: '__resolverOutputTypeRecordIDs',
    RELAY_READ_TIME_RESOLVER_KEY_PREFIX: $402d311d6f799697$var$RELAY_READ_TIME_RESOLVER_KEY_PREFIX,
    formatStorageKey: $402d311d6f799697$var$formatStorageKey,
    getArgumentValue: $402d311d6f799697$var$getArgumentValue,
    getArgumentValues: $402d311d6f799697$var$getArgumentValues,
    getHandleStorageKey: $402d311d6f799697$var$getHandleStorageKey,
    getStorageKey: $402d311d6f799697$var$getStorageKey,
    getReadTimeResolverStorageKey: $402d311d6f799697$var$getReadTimeResolverStorageKey,
    getStableStorageKey: $402d311d6f799697$var$getStableStorageKey,
    getModuleComponentKey: $402d311d6f799697$var$getModuleComponentKey,
    getModuleOperationKey: $402d311d6f799697$var$getModuleOperationKey
};
module.exports = $402d311d6f799697$var$RelayStoreUtils;

});
parcelRegister("kTVTn", function(module, exports) {

var $kCUwc = parcelRequire("kCUwc");

var $g75yA = parcelRequire("g75yA");

var $2DKWi = parcelRequire("2DKWi");

var $3M4GG = parcelRequire("3M4GG");
function $f375d9dfd825a8d5$var$_toConsumableArray(r) {
    return $kCUwc(r) || $g75yA(r) || $2DKWi(r) || $3M4GG();
}
module.exports = $f375d9dfd825a8d5$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kCUwc", function(module, exports) {

var $9nben = parcelRequire("9nben");
function $f043329ee30b3ffb$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $9nben(r);
}
module.exports = $f043329ee30b3ffb$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("g75yA", function(module, exports) {
function $bbb19c474e3678b2$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $bbb19c474e3678b2$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3M4GG", function(module, exports) {
function $2bf97da302627e79$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $2bf97da302627e79$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("1W7vD", function(module, exports) {
'use strict';

var $haR4J = parcelRequire("haR4J");
var $1691086b6ef56e4d$var$DEFAULT_HANDLE_KEY = $haR4J.DEFAULT_HANDLE_KEY;

var $5Wk1R = parcelRequire("5Wk1R");
function $1691086b6ef56e4d$var$getRelayHandleKey(handleName, key, fieldName) {
    if (key && key !== $1691086b6ef56e4d$var$DEFAULT_HANDLE_KEY) return "__".concat(key, "_").concat(handleName);
    !(fieldName != null) && $5Wk1R(false);
    return "__".concat(fieldName, "_").concat(handleName);
}
module.exports = $1691086b6ef56e4d$var$getRelayHandleKey;

});
parcelRegister("haR4J", function(module, exports) {
'use strict';
module.exports = {
    DEFAULT_HANDLE_KEY: ''
};

});


parcelRegister("3hqjB", function(module, exports) {
'use strict';
var $26375f448fdbbe38$var$RelayFeatureFlags = {
    ENABLE_VARIABLE_CONNECTION_KEY: false,
    ENABLE_RELAY_RESOLVERS: false,
    ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION: false,
    ENABLE_FRIENDLY_QUERY_NAME_GQL_URL: false,
    ENABLE_DO_NOT_WRAP_LIVE_QUERY: false,
    ENABLE_NOTIFY_SUBSCRIPTION: false,
    BATCH_ASYNC_MODULE_UPDATES_FN: null,
    ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT: false,
    MAX_DATA_ID_LENGTH: null,
    STRING_INTERN_LEVEL: 0,
    LOG_MISSING_RECORDS_IN_PROD: false,
    ENABLE_STORE_ID_COLLISION_LOGGING: false,
    ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS: false,
    ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION: false,
    ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES: false,
    ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE: false,
    PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION: false,
    MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD: false,
    ENABLE_CYLE_DETECTION_IN_VARIABLES: false,
    ENABLE_ACTIVITY_COMPATIBILITY: false,
    ENABLE_READ_TIME_RESOLVER_STORAGE_KEY_PREFIX: true,
    ENABLE_USE_PAGINATION_IS_LOADING_FIX: false,
    DISALLOW_NESTED_UPDATES: false,
    ENABLE_TYPENAME_PREFIXED_DATA_ID: false,
    ENABLE_UI_CONTEXT_ON_RELAY_LOGGER: false,
    CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES: false
};
module.exports = $26375f448fdbbe38$var$RelayFeatureFlags;

});

parcelRegister("aFY6e", function(module, exports) {
'use strict';
function $7c5c5a3e77b0f265$var$stableCopy(value) {
    if (!value || typeof value !== 'object') return value;
    if (Array.isArray(value)) return value.map($7c5c5a3e77b0f265$var$stableCopy);
    var keys = Object.keys(value).sort();
    var stable = {};
    for(var i = 0; i < keys.length; i++)stable[keys[i]] = $7c5c5a3e77b0f265$var$stableCopy(value[keys[i]]);
    return stable;
}
function $7c5c5a3e77b0f265$var$hasCycle(value) {
    var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
    if (!value || typeof value !== 'object') return false;
    if (parents.has(value)) return true;
    var newParents = new Set(parents);
    newParents.add(value);
    var children = Array.isArray(value) ? value : Object.values(value);
    return children.some(function(v) {
        return $7c5c5a3e77b0f265$var$hasCycle(v, newParents);
    });
}
module.exports = {
    stableCopy: $7c5c5a3e77b0f265$var$stableCopy,
    hasCycle: $7c5c5a3e77b0f265$var$hasCycle
};

});



parcelRegister("cGxFv", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ var $93c3861eb84c9651$var$aStackPool = [];
var $93c3861eb84c9651$var$bStackPool = [];
/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */ function $93c3861eb84c9651$var$areEqual(a, b) {
    var aStack = $93c3861eb84c9651$var$aStackPool.length ? $93c3861eb84c9651$var$aStackPool.pop() : [];
    var bStack = $93c3861eb84c9651$var$bStackPool.length ? $93c3861eb84c9651$var$bStackPool.pop() : [];
    var result = $93c3861eb84c9651$var$eq(a, b, aStack, bStack);
    aStack.length = 0;
    bStack.length = 0;
    $93c3861eb84c9651$var$aStackPool.push(aStack);
    $93c3861eb84c9651$var$bStackPool.push(bStack);
    return result;
}
function $93c3861eb84c9651$var$eq(a, b, aStack, bStack) {
    if (a === b) // Identical objects are equal. `0 === -0`, but they aren't identical.
    return a !== 0 || 1 / a == 1 / b;
    if (a == null || b == null) // a or b can be `null` or `undefined`
    return false;
    if (typeof a != 'object' || typeof b != 'object') return false;
    var objToStr = Object.prototype.toString;
    var className = objToStr.call(a);
    if (className != objToStr.call(b)) return false;
    switch(className){
        case '[object String]':
            return a == String(b);
        case '[object Number]':
            return isNaN(a) || isNaN(b) ? false : a == Number(b);
        case '[object Date]':
        case '[object Boolean]':
            return +a == +b;
        case '[object RegExp]':
            return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
    } // Assume equality for cyclic structures.
    var length = aStack.length;
    while(length--){
        if (aStack[length] == a) return bStack[length] == b;
    }
    aStack.push(a);
    bStack.push(b);
    var size = 0; // Recursively compare objects and arrays.
    if (className === '[object Array]') {
        size = a.length;
        if (size !== b.length) return false;
         // Deep compare the contents, ignoring non-numeric properties.
        while(size--){
            if (!$93c3861eb84c9651$var$eq(a[size], b[size], aStack, bStack)) return false;
        }
    } else {
        if (a.constructor !== b.constructor) return false;
        if (a.hasOwnProperty('valueOf') && b.hasOwnProperty('valueOf')) return a.valueOf() == b.valueOf();
        var keys = Object.keys(a);
        if (keys.length != Object.keys(b).length) return false;
        for(var i = 0; i < keys.length; i++){
            if (!$93c3861eb84c9651$var$eq(a[keys[i]], b[keys[i]], aStack, bStack)) return false;
        }
    }
    aStack.pop();
    bStack.pop();
    return true;
}
module.exports = $93c3861eb84c9651$var$areEqual;

});




parcelRegister("7J5du", function(module, exports) {
"use strict";

var $bGHxy = parcelRequire("bGHxy");
var $5a00c847bed7d270$var$_interopRequireDefault = $bGHxy.default;

var $g7083 = parcelRequire("g7083");
var $5a00c847bed7d270$require$_asyncToGenerator = $g7083.default;

var $5a00c847bed7d270$var$_createForOfIteratorHelper2 = $5a00c847bed7d270$var$_interopRequireDefault((parcelRequire("cXbK5")));

var $u7PH0 = parcelRequire("u7PH0");

var $aDkGX = parcelRequire("aDkGX");
var $5a00c847bed7d270$var$getObservableForActiveRequest = $aDkGX.getObservableForActiveRequest;

var $5AvhW = parcelRequire("5AvhW");
var $5a00c847bed7d270$var$getFragment = $5AvhW.getFragment;

var $lLciG = parcelRequire("lLciG");
var $5a00c847bed7d270$var$handlePotentialSnapshotErrors = $lLciG.handlePotentialSnapshotErrors;

var $dTSGA = parcelRequire("dTSGA");
var $5a00c847bed7d270$var$getSelector = $dTSGA.getSelector;

var $5Wk1R = parcelRequire("5Wk1R");
function $5a00c847bed7d270$var$waitForFragmentData(_x, _x2, _x3) {
    return $5a00c847bed7d270$var$_waitForFragmentData.apply(this, arguments);
}
function $5a00c847bed7d270$var$_waitForFragmentData() {
    $5a00c847bed7d270$var$_waitForFragmentData = $5a00c847bed7d270$require$_asyncToGenerator(function*(environment, fragment, fragmentRef) {
        var subscription;
        try {
            var _subscription;
            var data = yield new Promise(function(resolve, reject) {
                subscription = $5a00c847bed7d270$var$observeFragment(environment, fragment, fragmentRef).subscribe({
                    next: function next(val) {
                        if (val.state === 'ok') resolve(val.value);
                        else if (val.state === 'error') reject(val.error);
                    }
                });
            });
            (_subscription = subscription) === null || _subscription === void 0 || _subscription.unsubscribe();
            return data;
        } catch (e) {
            var _subscription2;
            (_subscription2 = subscription) === null || _subscription2 === void 0 || _subscription2.unsubscribe();
            throw e;
        }
    });
    return $5a00c847bed7d270$var$_waitForFragmentData.apply(this, arguments);
}
function $5a00c847bed7d270$var$observeFragment(environment, fragment, fragmentRef) {
    var _fragmentNode$metadat;
    var fragmentNode = $5a00c847bed7d270$var$getFragment(fragment);
    var fragmentSelector = $5a00c847bed7d270$var$getSelector(fragmentNode, fragmentRef);
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.hasClientEdges) == null) && $5Wk1R(false);
    !(fragmentSelector != null) && $5Wk1R(false);
    switch(fragmentSelector.kind){
        case 'SingularReaderSelector':
            return $5a00c847bed7d270$var$observeSingularSelector(environment, fragment, fragmentSelector);
        case 'PluralReaderSelector':
            return $5a00c847bed7d270$var$observePluralSelector(environment, fragment, fragmentSelector);
    }
    $5Wk1R(false);
}
function $5a00c847bed7d270$var$observeSingularSelector(environment, fragmentNode, fragmentSelector) {
    var snapshot = environment.lookup(fragmentSelector);
    return $u7PH0.create(function(sink) {
        sink.next($5a00c847bed7d270$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.owner, snapshot));
        var subscription = environment.subscribe(snapshot, function(nextSnapshot) {
            sink.next($5a00c847bed7d270$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.owner, nextSnapshot));
        });
        return function() {
            return subscription.dispose();
        };
    });
}
function $5a00c847bed7d270$var$observePluralSelector(environment, fragmentNode, fragmentSelector) {
    var snapshots = fragmentSelector.selectors.map(function(selector) {
        return environment.lookup(selector);
    });
    return $u7PH0.create(function(sink) {
        var states = snapshots.map(function(snapshot, index) {
            return $5a00c847bed7d270$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.selectors[index].owner, snapshot);
        });
        sink.next($5a00c847bed7d270$var$mergeFragmentStates(states));
        var subscriptions = snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                states[index] = $5a00c847bed7d270$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.selectors[index].owner, latestSnapshot);
                sink.next($5a00c847bed7d270$var$mergeFragmentStates(states));
            });
        });
        return function() {
            return subscriptions.forEach(function(subscription) {
                return subscription.dispose();
            });
        };
    });
}
function $5a00c847bed7d270$var$snapshotToFragmentState(environment, fragmentNode, owner, snapshot) {
    var missingLiveResolverFields = snapshot.missingLiveResolverFields != null && snapshot.missingLiveResolverFields.length > 0;
    var missingClientEdges = snapshot.missingClientEdges != null && snapshot.missingClientEdges.length > 0;
    if (missingLiveResolverFields || missingClientEdges) return {
        state: 'loading'
    };
    if (snapshot.isMissingData) {
        if ($5a00c847bed7d270$var$getObservableForActiveRequest(environment, owner) != null || environment.getOperationTracker().getPendingOperationsAffectingOwner(owner) != null) return {
            state: 'loading'
        };
    }
    try {
        $5a00c847bed7d270$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
    } catch (error) {
        return {
            error: error,
            state: 'error'
        };
    }
    !(snapshot.data != null) && $5Wk1R(false);
    return {
        state: 'ok',
        value: snapshot.data
    };
}
function $5a00c847bed7d270$var$mergeFragmentStates(states) {
    var value = [];
    var _iterator = (0, $5a00c847bed7d270$var$_createForOfIteratorHelper2["default"])(states), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var state = _step.value;
            if (state.state === 'ok') value.push(state.value);
            else return state;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return {
        state: 'ok',
        value: value
    };
}
module.exports = {
    observeFragment: $5a00c847bed7d270$var$observeFragment,
    waitForFragmentData: $5a00c847bed7d270$var$waitForFragmentData
};

});
parcelRegister("g7083", function(module, exports) {
function $bbad6661ede9049a$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $bbad6661ede9049a$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $bbad6661ede9049a$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $bbad6661ede9049a$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $bbad6661ede9049a$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("u7PH0", function(module, exports) {
'use strict';

var $b3WHn = parcelRequire("b3WHn");
var $05a8e0e0c2025088$var$hostReportError = $05a8e0e0c2025088$var$swallowError;
var $05a8e0e0c2025088$var$RelayObservable = /*#__PURE__*/ function() {
    RelayObservable.create = function create(source) {
        return new RelayObservable(source);
    };
    function RelayObservable(source) {
        this._source = source;
    }
    RelayObservable.onUnhandledError = function onUnhandledError(callback) {
        $05a8e0e0c2025088$var$hostReportError = callback;
    };
    RelayObservable.from = function from(obj) {
        return $05a8e0e0c2025088$var$isObservable(obj) ? $05a8e0e0c2025088$var$fromObservable(obj) : $b3WHn(obj) ? $05a8e0e0c2025088$var$fromPromise(obj) : $05a8e0e0c2025088$var$fromValue(obj);
    };
    var _proto = RelayObservable.prototype;
    _proto["catch"] = function _catch(fn) {
        var _this = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            _this.subscribe({
                start: function start(sub) {
                    subscription = sub;
                },
                next: sink.next,
                complete: sink.complete,
                error: function error(_error2) {
                    try {
                        fn(_error2).subscribe({
                            start: function start(sub) {
                                subscription = sub;
                            },
                            next: sink.next,
                            complete: sink.complete,
                            error: sink.error
                        });
                    } catch (error2) {
                        sink.error(error2, true);
                    }
                }
            });
            return function() {
                return subscription.unsubscribe();
            };
        });
    };
    _proto.concat = function concat(next) {
        var _this2 = this;
        return RelayObservable.create(function(sink) {
            var current;
            _this2.subscribe({
                start: function start(subscription) {
                    current = subscription;
                },
                next: sink.next,
                error: sink.error,
                complete: function complete() {
                    current = next.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto["do"] = function _do(observer) {
        var _this3 = this;
        return RelayObservable.create(function(sink) {
            var both = function both(action) {
                return function() {
                    try {
                        observer[action] && observer[action].apply(observer, arguments);
                    } catch (error) {
                        $05a8e0e0c2025088$var$hostReportError(error, true);
                    }
                    sink[action] && sink[action].apply(sink, arguments);
                };
            };
            return _this3.subscribe({
                start: both('start'),
                next: both('next'),
                error: both('error'),
                complete: both('complete'),
                unsubscribe: both('unsubscribe')
            });
        });
    };
    _proto["finally"] = function _finally(fn) {
        var _this4 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this4.subscribe(sink);
            return function() {
                subscription.unsubscribe();
                fn();
            };
        });
    };
    _proto.ifEmpty = function ifEmpty(alternate) {
        var _this5 = this;
        return RelayObservable.create(function(sink) {
            var hasValue = false;
            var current;
            current = _this5.subscribe({
                next: function next(value) {
                    hasValue = true;
                    sink.next(value);
                },
                error: sink.error,
                complete: function complete() {
                    if (hasValue) sink.complete();
                    else current = alternate.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto.subscribe = function subscribe(observer) {
        return $05a8e0e0c2025088$var$_subscribe(this._source, observer);
    };
    _proto.map = function map(fn) {
        var _this6 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this6.subscribe({
                complete: sink.complete,
                error: sink.error,
                next: function next(value) {
                    try {
                        var mapValue = fn(value);
                        sink.next(mapValue);
                    } catch (error) {
                        sink.error(error, true);
                    }
                }
            });
            return function() {
                subscription.unsubscribe();
            };
        });
    };
    _proto.mergeMap = function mergeMap(fn) {
        var _this7 = this;
        return RelayObservable.create(function(sink) {
            var subscriptions = [];
            function start(subscription) {
                this._sub = subscription;
                subscriptions.push(subscription);
            }
            function complete() {
                subscriptions.splice(subscriptions.indexOf(this._sub), 1);
                if (subscriptions.length === 0) sink.complete();
            }
            _this7.subscribe({
                start: start,
                next: function next(value) {
                    try {
                        if (!sink.closed) RelayObservable.from(fn(value)).subscribe({
                            start: start,
                            next: sink.next,
                            error: sink.error,
                            complete: complete
                        });
                    } catch (error) {
                        sink.error(error, true);
                    }
                },
                error: sink.error,
                complete: complete
            });
            return function() {
                subscriptions.forEach(function(sub) {
                    return sub.unsubscribe();
                });
                subscriptions.length = 0;
            };
        });
    };
    _proto.poll = function poll(pollInterval) {
        var _this8 = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            var timeout;
            var poll = function poll() {
                subscription = _this8.subscribe({
                    next: sink.next,
                    error: sink.error,
                    complete: function complete() {
                        timeout = setTimeout(poll, pollInterval);
                    }
                });
            };
            poll();
            return function() {
                clearTimeout(timeout);
                subscription.unsubscribe();
            };
        });
    };
    _proto.toPromise = function toPromise() {
        var _this9 = this;
        return new Promise(function(resolve, reject) {
            var resolved = false;
            _this9.subscribe({
                next: function next(val) {
                    if (!resolved) {
                        resolved = true;
                        resolve(val);
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    return RelayObservable;
}();
function $05a8e0e0c2025088$var$isObservable(obj) {
    return typeof obj === 'object' && obj !== null && typeof obj.subscribe === 'function';
}
function $05a8e0e0c2025088$var$fromObservable(obj) {
    return obj instanceof $05a8e0e0c2025088$var$RelayObservable ? obj : $05a8e0e0c2025088$var$RelayObservable.create(function(sink) {
        return obj.subscribe(sink);
    });
}
function $05a8e0e0c2025088$var$fromPromise(promise) {
    return $05a8e0e0c2025088$var$RelayObservable.create(function(sink) {
        promise.then(function(value) {
            sink.next(value);
            sink.complete();
        }, sink.error);
    });
}
function $05a8e0e0c2025088$var$fromValue(value) {
    return $05a8e0e0c2025088$var$RelayObservable.create(function(sink) {
        sink.next(value);
        sink.complete();
    });
}
function $05a8e0e0c2025088$var$_subscribe(source, observer) {
    var closed = false;
    var cleanup;
    var withClosed = function withClosed(obj) {
        return Object.defineProperty(obj, 'closed', {
            get: function get() {
                return closed;
            }
        });
    };
    function doCleanup() {
        if (cleanup) {
            if (cleanup.unsubscribe) cleanup.unsubscribe();
            else try {
                cleanup();
            } catch (error) {
                $05a8e0e0c2025088$var$hostReportError(error, true);
            }
            cleanup = undefined;
        }
    }
    var subscription = withClosed({
        unsubscribe: function unsubscribe() {
            if (!closed) {
                closed = true;
                try {
                    observer.unsubscribe && observer.unsubscribe(subscription);
                } catch (error) {
                    $05a8e0e0c2025088$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        observer.start && observer.start(subscription);
    } catch (error) {
        $05a8e0e0c2025088$var$hostReportError(error, true);
    }
    if (closed) return subscription;
    var sink = withClosed({
        next: function next(value) {
            if (!closed && observer.next) try {
                observer.next(value);
            } catch (error) {
                $05a8e0e0c2025088$var$hostReportError(error, true);
            }
        },
        error: function error(_error3, isUncaughtThrownError) {
            if (closed || !observer.error) {
                closed = true;
                $05a8e0e0c2025088$var$hostReportError(_error3, isUncaughtThrownError || false);
                doCleanup();
            } else {
                closed = true;
                try {
                    observer.error(_error3);
                } catch (error2) {
                    $05a8e0e0c2025088$var$hostReportError(error2, true);
                } finally{
                    doCleanup();
                }
            }
        },
        complete: function complete() {
            if (!closed) {
                closed = true;
                try {
                    observer.complete && observer.complete();
                } catch (error) {
                    $05a8e0e0c2025088$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        cleanup = source(sink);
    } catch (error) {
        sink.error(error, true);
    }
    if (closed) doCleanup();
    return subscription;
}
function $05a8e0e0c2025088$var$swallowError(_error, _isUncaughtThrownError) {}
module.exports = $05a8e0e0c2025088$var$RelayObservable;

});
parcelRegister("b3WHn", function(module, exports) {
'use strict';
function $80dd81d7b9f2b9da$var$isPromise(p) {
    return p != null && typeof p === 'object' && typeof p.then === 'function';
}
module.exports = $80dd81d7b9f2b9da$var$isPromise;

});


parcelRegister("aDkGX", function(module, exports) {
'use strict';

var $u7PH0 = parcelRequire("u7PH0");

var $902AI = parcelRequire("902AI");

var $5Wk1R = parcelRequire("5Wk1R");
var $7bdd98e55d9f95b1$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $7bdd98e55d9f95b1$var$requestCachesByEnvironment = $7bdd98e55d9f95b1$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $7bdd98e55d9f95b1$var$fetchQuery(environment, operation) {
    return $7bdd98e55d9f95b1$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
        return environment.execute({
            operation: operation
        });
    });
}
function $7bdd98e55d9f95b1$var$fetchQueryDeduped(environment, identifier, fetchFn) {
    return $u7PH0.create(function(sink) {
        var requestCache = $7bdd98e55d9f95b1$var$getRequestCache(environment);
        var cachedRequest = requestCache.get(identifier);
        if (!cachedRequest) fetchFn()["finally"](function() {
            return requestCache["delete"](identifier);
        }).subscribe({
            start: function start(subscription) {
                cachedRequest = {
                    identifier: identifier,
                    subject: new $902AI(),
                    subjectForInFlightStatus: new $902AI(),
                    subscription: subscription,
                    promise: null
                };
                requestCache.set(identifier, cachedRequest);
            },
            next: function next(response) {
                var cachedReq = $7bdd98e55d9f95b1$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.next(response);
                cachedReq.subjectForInFlightStatus.next(response);
            },
            error: function error(_error) {
                var cachedReq = $7bdd98e55d9f95b1$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.error(_error);
                cachedReq.subjectForInFlightStatus.error(_error);
            },
            complete: function complete() {
                var cachedReq = $7bdd98e55d9f95b1$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.complete();
                cachedReq.subjectForInFlightStatus.complete();
            },
            unsubscribe: function unsubscribe(subscription) {
                var cachedReq = $7bdd98e55d9f95b1$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.unsubscribe();
                cachedReq.subjectForInFlightStatus.unsubscribe();
            }
        });
        !(cachedRequest != null) && $5Wk1R(false);
        return $7bdd98e55d9f95b1$var$getObservableForCachedRequest(requestCache, cachedRequest).subscribe(sink);
    });
}
function $7bdd98e55d9f95b1$var$getObservableForCachedRequest(requestCache, cachedRequest) {
    return $u7PH0.create(function(sink) {
        var subscription = cachedRequest.subject.subscribe(sink);
        return function() {
            subscription.unsubscribe();
            var cachedRequestInstance = requestCache.get(cachedRequest.identifier);
            if (cachedRequestInstance) {
                var requestSubscription = cachedRequestInstance.subscription;
                if (requestSubscription != null && cachedRequestInstance.subject.getObserverCount() === 0) {
                    requestSubscription.unsubscribe();
                    requestCache["delete"](cachedRequest.identifier);
                }
            }
        };
    });
}
function $7bdd98e55d9f95b1$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest) {
    return $u7PH0.create(function(sink) {
        var subscription = cachedRequest.subjectForInFlightStatus.subscribe({
            error: sink.error,
            next: function next(response) {
                if (!environment.isRequestActive(cachedRequest.identifier)) {
                    sink.complete();
                    return;
                }
                sink.next();
            },
            complete: sink.complete,
            unsubscribe: sink.complete
        });
        return function() {
            subscription.unsubscribe();
        };
    });
}
function $7bdd98e55d9f95b1$var$getPromiseForActiveRequest(environment, request) {
    var requestCache = $7bdd98e55d9f95b1$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    var promise = new Promise(function(resolve, reject) {
        var resolveOnNext = false;
        $7bdd98e55d9f95b1$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest).subscribe({
            complete: resolve,
            error: reject,
            next: function next(response) {
                if (resolveOnNext) resolve(response);
            }
        });
        resolveOnNext = true;
    });
    return promise;
}
function $7bdd98e55d9f95b1$var$getObservableForActiveRequest(environment, request) {
    var requestCache = $7bdd98e55d9f95b1$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    return $7bdd98e55d9f95b1$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest);
}
function $7bdd98e55d9f95b1$var$getRequestCache(environment) {
    var cached = $7bdd98e55d9f95b1$var$requestCachesByEnvironment.get(environment);
    if (cached != null) return cached;
    var requestCache = new Map();
    $7bdd98e55d9f95b1$var$requestCachesByEnvironment.set(environment, requestCache);
    return requestCache;
}
function $7bdd98e55d9f95b1$var$getCachedRequest(requestCache, identifier) {
    var cached = requestCache.get(identifier);
    !(cached != null) && $5Wk1R(false);
    return cached;
}
module.exports = {
    fetchQuery: $7bdd98e55d9f95b1$var$fetchQuery,
    fetchQueryDeduped: $7bdd98e55d9f95b1$var$fetchQueryDeduped,
    getPromiseForActiveRequest: $7bdd98e55d9f95b1$var$getPromiseForActiveRequest,
    getObservableForActiveRequest: $7bdd98e55d9f95b1$var$getObservableForActiveRequest
};

});
parcelRegister("902AI", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $68d61fb2e9ddec47$var$_interopRequireDefault = $bGHxy.default;

var $68d61fb2e9ddec47$var$_createForOfIteratorHelper2 = $68d61fb2e9ddec47$var$_interopRequireDefault((parcelRequire("cXbK5")));

var $68d61fb2e9ddec47$var$_defineProperty2 = $68d61fb2e9ddec47$var$_interopRequireDefault((parcelRequire("aUl3j")));

var $u7PH0 = parcelRequire("u7PH0");

var $5Wk1R = parcelRequire("5Wk1R");
var $68d61fb2e9ddec47$var$RelayReplaySubject = /*#__PURE__*/ function() {
    function RelayReplaySubject() {
        var _this = this;
        (0, $68d61fb2e9ddec47$var$_defineProperty2["default"])(this, "_complete", false);
        (0, $68d61fb2e9ddec47$var$_defineProperty2["default"])(this, "_events", []);
        (0, $68d61fb2e9ddec47$var$_defineProperty2["default"])(this, "_sinks", new Set());
        (0, $68d61fb2e9ddec47$var$_defineProperty2["default"])(this, "_subscription", []);
        this._observable = $u7PH0.create(function(sink) {
            _this._sinks.add(sink);
            var events = _this._events;
            for(var i = 0; i < events.length; i++){
                if (sink.closed) break;
                var event = events[i];
                switch(event.kind){
                    case 'complete':
                        sink.complete();
                        break;
                    case 'error':
                        sink.error(event.error);
                        break;
                    case 'next':
                        sink.next(event.data);
                        break;
                    default:
                        event.kind;
                        $5Wk1R(false);
                }
            }
            return function() {
                _this._sinks["delete"](sink);
            };
        });
    }
    var _proto = RelayReplaySubject.prototype;
    _proto.complete = function complete() {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'complete'
        });
        this._sinks.forEach(function(sink) {
            return sink.complete();
        });
    };
    _proto.error = function error(_error) {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'error',
            error: _error
        });
        this._sinks.forEach(function(sink) {
            return sink.error(_error);
        });
    };
    _proto.next = function next(data) {
        if (this._complete === true) return;
        this._events.push({
            kind: 'next',
            data: data
        });
        this._sinks.forEach(function(sink) {
            return sink.next(data);
        });
    };
    _proto.subscribe = function subscribe(observer) {
        var subscription = this._observable.subscribe(observer);
        this._subscription.push(subscription);
        return subscription;
    };
    _proto.unsubscribe = function unsubscribe() {
        var _iterator = (0, $68d61fb2e9ddec47$var$_createForOfIteratorHelper2["default"])(this._subscription), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var subscription = _step.value;
                subscription.unsubscribe();
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._subscription = [];
    };
    _proto.getObserverCount = function getObserverCount() {
        return this._sinks.size;
    };
    return RelayReplaySubject;
}();
module.exports = $68d61fb2e9ddec47$var$RelayReplaySubject;

});



parcelRegister("9hEmW", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $6c2504046185f1dc$var$_interopRequireDefault = $bGHxy.default;

var $6c2504046185f1dc$var$_defineProperty2 = $6c2504046185f1dc$var$_interopRequireDefault((parcelRequire("aUl3j")));

var $7J5du = parcelRequire("7J5du");
var $6c2504046185f1dc$var$observeFragment = $7J5du.observeFragment;

var $f2NQb = parcelRequire("f2NQb");
var $6c2504046185f1dc$var$createOperationDescriptor = $f2NQb.createOperationDescriptor;
function $6c2504046185f1dc$var$observeQuery(environment, gqlQuery, variables) {
    var operation = $6c2504046185f1dc$var$createOperationDescriptor(gqlQuery, variables);
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, $6c2504046185f1dc$var$_defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    var fragmentNode = operation.request.node.fragment;
    return $6c2504046185f1dc$var$observeFragment(environment, fragmentNode, rootFragmentRef);
}
module.exports = {
    observeQuery: $6c2504046185f1dc$var$observeQuery
};

});
parcelRegister("f2NQb", function(module, exports) {
'use strict';
parcelRequire("a9DXr");

var $4fgpQ = parcelRequire("4fgpQ");

var $3hqjB = parcelRequire("3hqjB");

var $aFY6e = parcelRequire("aFY6e");
var $af3db43d83ef9f71$var$hasCycle = $aFY6e.hasCycle;

var $gQ9aH = parcelRequire("gQ9aH");
var $af3db43d83ef9f71$var$getOperationVariables = $gQ9aH.getOperationVariables;

var $dTSGA = parcelRequire("dTSGA");
var $af3db43d83ef9f71$var$createNormalizationSelector = $dTSGA.createNormalizationSelector, $af3db43d83ef9f71$var$createReaderSelector = $dTSGA.createReaderSelector;

var $5vBPt = parcelRequire("5vBPt");
var $af3db43d83ef9f71$var$ROOT_ID = $5vBPt.ROOT_ID;

var $5Wk1R = parcelRequire("5Wk1R");
function $af3db43d83ef9f71$var$createOperationDescriptor(request, variables, cacheConfig) {
    var dataID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $af3db43d83ef9f71$var$ROOT_ID;
    var operation = request.operation;
    var operationVariables = $af3db43d83ef9f71$var$getOperationVariables(operation, request.params.providedVariables, variables);
    if ($3hqjB.ENABLE_CYLE_DETECTION_IN_VARIABLES) !!$af3db43d83ef9f71$var$hasCycle(operationVariables) && $5Wk1R(false);
    var requestDescriptor = $af3db43d83ef9f71$var$createRequestDescriptor(request, operationVariables, cacheConfig);
    var operationDescriptor = {
        fragment: $af3db43d83ef9f71$var$createReaderSelector(request.fragment, dataID, operationVariables, requestDescriptor),
        request: requestDescriptor,
        root: $af3db43d83ef9f71$var$createNormalizationSelector(operation, dataID, operationVariables)
    };
    return operationDescriptor;
}
function $af3db43d83ef9f71$var$createRequestDescriptor(request, variables, cacheConfig) {
    var requestDescriptor = {
        identifier: $4fgpQ(request.params, variables),
        node: request,
        variables: variables,
        cacheConfig: cacheConfig
    };
    return requestDescriptor;
}
module.exports = {
    createOperationDescriptor: $af3db43d83ef9f71$var$createOperationDescriptor,
    createRequestDescriptor: $af3db43d83ef9f71$var$createRequestDescriptor
};

});
parcelRegister("a9DXr", function(module, exports) {
'use strict';
function $7649bd6f211016e3$var$deepFreeze(object) {
    if (!$7649bd6f211016e3$var$shouldBeFrozen(object)) return object;
    Object.freeze(object);
    Object.getOwnPropertyNames(object).forEach(function(name) {
        var property = object[name];
        if (property && typeof property === 'object' && !Object.isFrozen(property)) $7649bd6f211016e3$var$deepFreeze(property);
    });
    return object;
}
function $7649bd6f211016e3$var$shouldBeFrozen(value) {
    return value != null && (Array.isArray(value) || typeof value === 'object' && value.constructor === Object);
}
module.exports = $7649bd6f211016e3$var$deepFreeze;

});

parcelRegister("4fgpQ", function(module, exports) {
'use strict';

var $aFY6e = parcelRequire("aFY6e");
var $31754bffe6022202$var$stableCopy = $aFY6e.stableCopy;

var $5Wk1R = parcelRequire("5Wk1R");
function $31754bffe6022202$var$getRequestIdentifier(parameters, variables) {
    var requestID = parameters.cacheID != null ? parameters.cacheID : parameters.id;
    !(requestID != null) && $5Wk1R(false);
    return requestID + JSON.stringify($31754bffe6022202$var$stableCopy(variables));
}
module.exports = $31754bffe6022202$var$getRequestIdentifier;

});



parcelRegister("5D68Q", function(module, exports) {
"use strict";

var $g7083 = parcelRequire("g7083");
var $41955be126438d8f$require$_asyncToGenerator = $g7083.default;

var $7J5du = parcelRequire("7J5du");
var $41955be126438d8f$var$observeFragment = $7J5du.observeFragment;
function $41955be126438d8f$var$waitForFragmentData(_x, _x2, _x3) {
    return $41955be126438d8f$var$_waitForFragmentData.apply(this, arguments);
}
function $41955be126438d8f$var$_waitForFragmentData() {
    $41955be126438d8f$var$_waitForFragmentData = $41955be126438d8f$require$_asyncToGenerator(function*(environment, fragment, fragmentRef) {
        var subscription;
        try {
            var _subscription;
            var data = yield new Promise(function(resolve, reject) {
                subscription = $41955be126438d8f$var$observeFragment(environment, fragment, fragmentRef).subscribe({
                    next: function next(val) {
                        if (val.state === 'ok') resolve(val.value);
                        else if (val.state === 'error') reject(val.error);
                    }
                });
            });
            (_subscription = subscription) === null || _subscription === void 0 || _subscription.unsubscribe();
            return data;
        } catch (e) {
            var _subscription2;
            (_subscription2 = subscription) === null || _subscription2 === void 0 || _subscription2.unsubscribe();
            throw e;
        }
    });
    return $41955be126438d8f$var$_waitForFragmentData.apply(this, arguments);
}
module.exports = {
    waitForFragmentData: $41955be126438d8f$var$waitForFragmentData
};

});


parcelRegister("aZiI7", function(module, exports) {
'use strict';

var $fJ2hT = parcelRequire("fJ2hT");
var $7ffe1d66dd09b62f$var$generateClientID = $fJ2hT.generateClientID;

var $5vBPt = parcelRequire("5vBPt");
var $7ffe1d66dd09b62f$var$getStableStorageKey = $5vBPt.getStableStorageKey;

var $1W7vD = parcelRequire("1W7vD");

var $ckpmP = parcelRequire("ckpmP");

var $5Wk1R = parcelRequire("5Wk1R");
parcelRequire("91yGl");
var $7ffe1d66dd09b62f$var$CONNECTION = 'connection';
var $7ffe1d66dd09b62f$var$NEXT_EDGE_INDEX = '__connection_next_edge_index';
function $7ffe1d66dd09b62f$var$update(store, payload) {
    var record = store.get(payload.dataID);
    if (!record) return;
    var _ConnectionInterface$ = $ckpmP.get(), EDGES = _ConnectionInterface$.EDGES, END_CURSOR = _ConnectionInterface$.END_CURSOR, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, PAGE_INFO_TYPE = _ConnectionInterface$.PAGE_INFO_TYPE, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var serverConnection = record.getLinkedRecord(payload.fieldKey);
    var serverPageInfo = serverConnection && serverConnection.getLinkedRecord(PAGE_INFO);
    if (!serverConnection) {
        record.setValue(null, payload.handleKey, undefined, record.getErrors(payload.fieldKey));
        return;
    }
    var clientConnectionID = $7ffe1d66dd09b62f$var$generateClientID(record.getDataID(), payload.handleKey);
    var clientConnectionField = record.getLinkedRecord(payload.handleKey);
    var clientConnection = clientConnectionField !== null && clientConnectionField !== void 0 ? clientConnectionField : store.get(clientConnectionID);
    var clientPageInfo = clientConnection && clientConnection.getLinkedRecord(PAGE_INFO);
    if (!clientConnection) {
        var connection = store.create(clientConnectionID, serverConnection.getType());
        connection.setValue(0, $7ffe1d66dd09b62f$var$NEXT_EDGE_INDEX);
        connection.copyFieldsFrom(serverConnection);
        var serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (serverEdges) {
            serverEdges = serverEdges.map(function(edge) {
                return $7ffe1d66dd09b62f$var$buildConnectionEdge(store, connection, edge);
            });
            connection.setLinkedRecords(serverEdges, EDGES);
        }
        record.setLinkedRecord(connection, payload.handleKey);
        clientPageInfo = store.create($7ffe1d66dd09b62f$var$generateClientID(connection.getDataID(), PAGE_INFO), PAGE_INFO_TYPE);
        clientPageInfo.setValue(false, HAS_NEXT_PAGE);
        clientPageInfo.setValue(false, HAS_PREV_PAGE);
        clientPageInfo.setValue(null, END_CURSOR);
        clientPageInfo.setValue(null, START_CURSOR);
        if (serverPageInfo) clientPageInfo.copyFieldsFrom(serverPageInfo);
        connection.setLinkedRecord(clientPageInfo, PAGE_INFO);
    } else {
        if (clientConnectionField == null) record.setLinkedRecord(clientConnection, payload.handleKey);
        var _connection = clientConnection;
        var _serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (_serverEdges) _serverEdges = _serverEdges.map(function(edge) {
            return $7ffe1d66dd09b62f$var$buildConnectionEdge(store, _connection, edge);
        });
        var prevEdges = _connection.getLinkedRecords(EDGES);
        var prevPageInfo = _connection.getLinkedRecord(PAGE_INFO);
        _connection.copyFieldsFrom(serverConnection);
        if (prevEdges) _connection.setLinkedRecords(prevEdges, EDGES);
        if (prevPageInfo) _connection.setLinkedRecord(prevPageInfo, PAGE_INFO);
        var nextEdges = [];
        var args = payload.args;
        if (prevEdges && _serverEdges) {
            if (args.after != null) {
                var _clientPageInfo;
                var clientEndCursor = (_clientPageInfo = clientPageInfo) === null || _clientPageInfo === void 0 ? void 0 : _clientPageInfo.getValue(END_CURSOR);
                var serverEndCursor = serverPageInfo === null || serverPageInfo === void 0 ? void 0 : serverPageInfo.getValue(END_CURSOR);
                var isAddingEdgesAfterCurrentPage = clientPageInfo && args.after === clientEndCursor;
                var isFillingOutCurrentPage = clientPageInfo && clientEndCursor === serverEndCursor;
                if (isAddingEdgesAfterCurrentPage || isFillingOutCurrentPage) {
                    var nodeIDs = new Set();
                    $7ffe1d66dd09b62f$var$mergeEdges(prevEdges, nextEdges, nodeIDs);
                    $7ffe1d66dd09b62f$var$mergeEdges(_serverEdges, nextEdges, nodeIDs);
                } else return;
            } else if (args.before != null) {
                if (clientPageInfo && args.before === clientPageInfo.getValue(START_CURSOR)) {
                    var _nodeIDs = new Set();
                    $7ffe1d66dd09b62f$var$mergeEdges(_serverEdges, nextEdges, _nodeIDs);
                    $7ffe1d66dd09b62f$var$mergeEdges(prevEdges, nextEdges, _nodeIDs);
                } else return;
            } else nextEdges = _serverEdges;
        } else if (_serverEdges) nextEdges = _serverEdges;
        else nextEdges = prevEdges;
        if (nextEdges != null && nextEdges !== prevEdges) _connection.setLinkedRecords(nextEdges, EDGES);
        if (clientPageInfo && serverPageInfo) {
            if (args.after == null && args.before == null) clientPageInfo.copyFieldsFrom(serverPageInfo);
            else if (args.before != null || args.after == null && args.last) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_PREV_PAGE), HAS_PREV_PAGE);
                var startCursor = serverPageInfo.getValue(START_CURSOR);
                if (typeof startCursor === 'string') clientPageInfo.setValue(startCursor, START_CURSOR);
            } else if (args.after != null || args.before == null && args.first) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_NEXT_PAGE), HAS_NEXT_PAGE);
                var endCursor = serverPageInfo.getValue(END_CURSOR);
                if (typeof endCursor === 'string') clientPageInfo.setValue(endCursor, END_CURSOR);
            }
        }
    }
}
function $7ffe1d66dd09b62f$var$getConnection(record, key, filters) {
    var handleKey = $1W7vD($7ffe1d66dd09b62f$var$CONNECTION, key, null);
    return record.getLinkedRecord(handleKey, filters);
}
function $7ffe1d66dd09b62f$var$getConnectionID(recordID, key, filters) {
    var handleKey = $1W7vD($7ffe1d66dd09b62f$var$CONNECTION, key, null);
    var storageKey = $7ffe1d66dd09b62f$var$getStableStorageKey(handleKey, filters);
    return $7ffe1d66dd09b62f$var$generateClientID(recordID, storageKey);
}
function $7ffe1d66dd09b62f$var$insertEdgeAfter(record, newEdge, cursor) {
    var _ConnectionInterface$2 = $ckpmP.get(), CURSOR = _ConnectionInterface$2.CURSOR, EDGES = _ConnectionInterface$2.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = edges.concat(newEdge);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            nextEdges.push(edge);
            if (edge == null) continue;
            var edgeCursor = edge.getValue(CURSOR);
            if (cursor === edgeCursor) {
                nextEdges.push(newEdge);
                foundCursor = true;
            }
        }
        if (!foundCursor) nextEdges.push(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $7ffe1d66dd09b62f$var$createEdge(store, record, node, edgeType) {
    var _ConnectionInterface$3 = $ckpmP.get(), NODE = _ConnectionInterface$3.NODE;
    var edgeID = $7ffe1d66dd09b62f$var$generateClientID(record.getDataID(), node.getDataID());
    var edge = store.get(edgeID);
    if (!edge) edge = store.create(edgeID, edgeType);
    edge.setLinkedRecord(node, NODE);
    if (edge.getValue('cursor') == null) edge.setValue(null, 'cursor');
    return edge;
}
function $7ffe1d66dd09b62f$var$insertEdgeBefore(record, newEdge, cursor) {
    var _ConnectionInterface$4 = $ckpmP.get(), CURSOR = _ConnectionInterface$4.CURSOR, EDGES = _ConnectionInterface$4.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = [
        newEdge
    ].concat(edges);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            if (edge != null) {
                var edgeCursor = edge.getValue(CURSOR);
                if (cursor === edgeCursor) {
                    nextEdges.push(newEdge);
                    foundCursor = true;
                }
            }
            nextEdges.push(edge);
        }
        if (!foundCursor) nextEdges.unshift(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $7ffe1d66dd09b62f$var$deleteNode(record, nodeID) {
    var _ConnectionInterface$5 = $ckpmP.get(), EDGES = _ConnectionInterface$5.EDGES, NODE = _ConnectionInterface$5.NODE;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    var nextEdges;
    for(var ii = 0; ii < edges.length; ii++){
        var edge = edges[ii];
        var node = edge && edge.getLinkedRecord(NODE);
        if (node != null && node.getDataID() === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
function $7ffe1d66dd09b62f$var$buildConnectionEdge(store, connection, edge) {
    if (edge == null) return edge;
    var _ConnectionInterface$6 = $ckpmP.get(), EDGES = _ConnectionInterface$6.EDGES;
    var edgeIndex = connection.getValue($7ffe1d66dd09b62f$var$NEXT_EDGE_INDEX);
    !(typeof edgeIndex === 'number') && $5Wk1R(false);
    var edgeID = $7ffe1d66dd09b62f$var$generateClientID(connection.getDataID(), EDGES, edgeIndex);
    var connectionEdge = store.create(edgeID, edge.getType());
    connectionEdge.copyFieldsFrom(edge);
    if (connectionEdge.getValue('cursor') == null) connectionEdge.setValue(null, 'cursor');
    connection.setValue(edgeIndex + 1, $7ffe1d66dd09b62f$var$NEXT_EDGE_INDEX);
    return connectionEdge;
}
function $7ffe1d66dd09b62f$var$mergeEdges(sourceEdges, targetEdges, nodeIDs) {
    var _ConnectionInterface$7 = $ckpmP.get(), NODE = _ConnectionInterface$7.NODE;
    for(var ii = 0; ii < sourceEdges.length; ii++){
        var edge = sourceEdges[ii];
        if (!edge) continue;
        var node = edge.getLinkedRecord(NODE);
        var nodeID = node && node.getDataID();
        if (nodeID) {
            if (nodeIDs.has(nodeID)) continue;
            nodeIDs.add(nodeID);
        }
        targetEdges.push(edge);
    }
}
module.exports = {
    buildConnectionEdge: $7ffe1d66dd09b62f$var$buildConnectionEdge,
    createEdge: $7ffe1d66dd09b62f$var$createEdge,
    deleteNode: $7ffe1d66dd09b62f$var$deleteNode,
    getConnection: $7ffe1d66dd09b62f$var$getConnection,
    getConnectionID: $7ffe1d66dd09b62f$var$getConnectionID,
    insertEdgeAfter: $7ffe1d66dd09b62f$var$insertEdgeAfter,
    insertEdgeBefore: $7ffe1d66dd09b62f$var$insertEdgeBefore,
    update: $7ffe1d66dd09b62f$var$update
};

});
parcelRegister("fJ2hT", function(module, exports) {
'use strict';

var $3hqjB = parcelRequire("3hqjB");

var $bhpNX = parcelRequire("bhpNX");
var $b72cd5474681b0b1$var$intern = $bhpNX.intern;
var $b72cd5474681b0b1$var$PREFIX = 'client:';
function $b72cd5474681b0b1$var$generateClientID(id, storageKey, index) {
    var internedId = $3hqjB.STRING_INTERN_LEVEL <= 0 ? id : $b72cd5474681b0b1$var$intern(id, $3hqjB.MAX_DATA_ID_LENGTH);
    var key = internedId + ':' + storageKey;
    if (index != null) key += ':' + index;
    if (key.indexOf($b72cd5474681b0b1$var$PREFIX) !== 0) key = $b72cd5474681b0b1$var$PREFIX + key;
    return key;
}
function $b72cd5474681b0b1$var$isClientID(id) {
    return id.indexOf($b72cd5474681b0b1$var$PREFIX) === 0;
}
var $b72cd5474681b0b1$var$localID = 0;
function $b72cd5474681b0b1$var$generateUniqueClientID() {
    return "".concat($b72cd5474681b0b1$var$PREFIX, "local:").concat($b72cd5474681b0b1$var$localID++);
}
function $b72cd5474681b0b1$var$generateClientObjectClientID(typename, localId, index) {
    var key = "".concat($b72cd5474681b0b1$var$PREFIX).concat(typename, ":").concat(localId);
    if (index != null) key += ':' + index;
    return key;
}
module.exports = {
    generateClientID: $b72cd5474681b0b1$var$generateClientID,
    generateClientObjectClientID: $b72cd5474681b0b1$var$generateClientObjectClientID,
    generateUniqueClientID: $b72cd5474681b0b1$var$generateUniqueClientID,
    isClientID: $b72cd5474681b0b1$var$isClientID
};

});
parcelRegister("bhpNX", function(module, exports) {
'use strict';
var $83654c8a9aeb92d9$var$internTable = new Map();
var $83654c8a9aeb92d9$var$nextIndex = 1;
var $83654c8a9aeb92d9$var$digits = $83654c8a9aeb92d9$var$initDigitTable();
var $83654c8a9aeb92d9$var$INTERN_PREFIX = '\t';
var $83654c8a9aeb92d9$var$ESCAPE_PREFIX = '\v';
function $83654c8a9aeb92d9$var$initDigitTable() {
    var digits = new Set();
    for(var i = 0; i < 10; ++i)digits.add(i.toString());
    return digits;
}
function $83654c8a9aeb92d9$var$escape(str) {
    if (str[0] === $83654c8a9aeb92d9$var$INTERN_PREFIX && $83654c8a9aeb92d9$var$digits.has(str[1]) || str[0] === $83654c8a9aeb92d9$var$ESCAPE_PREFIX) return $83654c8a9aeb92d9$var$ESCAPE_PREFIX + str;
    return str;
}
function $83654c8a9aeb92d9$var$intern(str, limit) {
    if (limit == null || str.length < limit) return $83654c8a9aeb92d9$var$escape(str);
    var internedString = $83654c8a9aeb92d9$var$internTable.get(str);
    if (internedString != null) return internedString;
    internedString = $83654c8a9aeb92d9$var$INTERN_PREFIX + $83654c8a9aeb92d9$var$nextIndex++;
    $83654c8a9aeb92d9$var$internTable.set(str, internedString);
    return internedString;
}
module.exports = {
    intern: $83654c8a9aeb92d9$var$intern
};

});


parcelRegister("ckpmP", function(module, exports) {
'use strict';
var $8f9b07b0d7ac4c3f$var$CONNECTION_CALLS = {
    after: true,
    before: true,
    find: true,
    first: true,
    last: true,
    surrounds: true
};
var $8f9b07b0d7ac4c3f$var$config = {
    CURSOR: 'cursor',
    EDGES: 'edges',
    END_CURSOR: 'endCursor',
    HAS_NEXT_PAGE: 'hasNextPage',
    HAS_PREV_PAGE: 'hasPreviousPage',
    NODE: 'node',
    PAGE_INFO_TYPE: 'PageInfo',
    PAGE_INFO: 'pageInfo',
    START_CURSOR: 'startCursor'
};
var $8f9b07b0d7ac4c3f$var$ConnectionInterface = {
    inject: function inject(newConfig) {
        $8f9b07b0d7ac4c3f$var$config = newConfig;
    },
    get: function get() {
        return $8f9b07b0d7ac4c3f$var$config;
    },
    isConnectionCall: function isConnectionCall(call) {
        return $8f9b07b0d7ac4c3f$var$CONNECTION_CALLS.hasOwnProperty(call.name);
    }
};
module.exports = $8f9b07b0d7ac4c3f$var$ConnectionInterface;

});


parcelRegister("krLBg", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $ee2b40a4fbf966f9$var$_interopRequireDefault = $bGHxy.default;

var $ee2b40a4fbf966f9$var$_createForOfIteratorHelper2 = $ee2b40a4fbf966f9$var$_interopRequireDefault((parcelRequire("cXbK5")));

var $aZiI7 = parcelRequire("aZiI7");

var $ckpmP = parcelRequire("ckpmP");

var $5Wk1R = parcelRequire("5Wk1R");
parcelRequire("91yGl");
var $ee2b40a4fbf966f9$var$DeleteRecordHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record != null) {
            var idOrIds = record.getValue(payload.fieldKey);
            if (typeof idOrIds === 'string') store["delete"](idOrIds);
            else if (Array.isArray(idOrIds)) idOrIds.forEach(function(id) {
                if (typeof id === 'string') store["delete"](id);
            });
        }
    }
};
var $ee2b40a4fbf966f9$var$DeleteEdgeHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $5Wk1R(false);
        var idOrIds = record.getValue(payload.fieldKey);
        var idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach(function(id) {
            if (typeof id === 'string') {
                var _iterator = (0, $ee2b40a4fbf966f9$var$_createForOfIteratorHelper2["default"])(connections), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var connectionID = _step.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        $aZiI7.deleteNode(connection, id);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        });
    }
};
var $ee2b40a4fbf966f9$var$AppendEdgeHandler = {
    update: $ee2b40a4fbf966f9$var$edgeUpdater($aZiI7.insertEdgeAfter)
};
var $ee2b40a4fbf966f9$var$PrependEdgeHandler = {
    update: $ee2b40a4fbf966f9$var$edgeUpdater($aZiI7.insertEdgeBefore)
};
var $ee2b40a4fbf966f9$var$AppendNodeHandler = {
    update: $ee2b40a4fbf966f9$var$nodeUpdater($aZiI7.insertEdgeAfter)
};
var $ee2b40a4fbf966f9$var$PrependNodeHandler = {
    update: $ee2b40a4fbf966f9$var$nodeUpdater($aZiI7.insertEdgeBefore)
};
function $ee2b40a4fbf966f9$var$edgeUpdater(insertFn) {
    return function(store, payload) {
        var _serverEdges;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $5Wk1R(false);
        var singleServerEdge, serverEdges;
        try {
            singleServerEdge = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused) {}
        if (!singleServerEdge) try {
            serverEdges = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused2) {}
        if (singleServerEdge == null && serverEdges == null) return;
        var _ConnectionInterface$ = $ckpmP.get(), NODE = _ConnectionInterface$.NODE, EDGES = _ConnectionInterface$.EDGES;
        var serverEdgeList = (_serverEdges = serverEdges) !== null && _serverEdges !== void 0 ? _serverEdges : [
            singleServerEdge
        ];
        var _iterator2 = (0, $ee2b40a4fbf966f9$var$_createForOfIteratorHelper2["default"])(serverEdgeList), _step2;
        try {
            var _loop = function _loop() {
                var serverEdge = _step2.value;
                if (serverEdge == null) return "continue";
                var serverNode = serverEdge.getLinkedRecord('node');
                if (!serverNode) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator3 = (0, $ee2b40a4fbf966f9$var$_createForOfIteratorHelper2["default"])(connections), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var connectionID = _step3.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked === void 0 ? void 0 : _connection$getLinked.some(function(edge) {
                            var _edge$getLinkedRecord;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord === void 0 ? void 0 : _edge$getLinkedRecord.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $aZiI7.buildConnectionEdge(store, connection, serverEdge);
                        !(clientEdge != null) && $5Wk1R(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            };
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _connection$getLinked;
                var _ret = _loop();
                if (_ret === "continue") continue;
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
    };
}
function $ee2b40a4fbf966f9$var$nodeUpdater(insertFn) {
    return function(store, payload) {
        var _serverNodes;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var _payload$handleArgs = payload.handleArgs, connections = _payload$handleArgs.connections, edgeTypeName = _payload$handleArgs.edgeTypeName;
        !(connections != null) && $5Wk1R(false);
        !(edgeTypeName != null) && $5Wk1R(false);
        var singleServerNode;
        var serverNodes;
        try {
            singleServerNode = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused3) {}
        if (!singleServerNode) try {
            serverNodes = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused4) {}
        if (singleServerNode == null && serverNodes == null) return;
        var _ConnectionInterface$2 = $ckpmP.get(), NODE = _ConnectionInterface$2.NODE, EDGES = _ConnectionInterface$2.EDGES;
        var serverNodeList = (_serverNodes = serverNodes) !== null && _serverNodes !== void 0 ? _serverNodes : [
            singleServerNode
        ];
        var _iterator4 = (0, $ee2b40a4fbf966f9$var$_createForOfIteratorHelper2["default"])(serverNodeList), _step4;
        try {
            var _loop2 = function _loop2() {
                var serverNode = _step4.value;
                if (serverNode == null) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator5 = (0, $ee2b40a4fbf966f9$var$_createForOfIteratorHelper2["default"])(connections), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var connectionID = _step5.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked2 = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked2 === void 0 ? void 0 : _connection$getLinked2.some(function(edge) {
                            var _edge$getLinkedRecord2;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord2 = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord2 === void 0 ? void 0 : _edge$getLinkedRecord2.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $aZiI7.createEdge(store, connection, serverNode, edgeTypeName);
                        !(clientEdge != null) && $5Wk1R(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
            };
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _connection$getLinked2;
                var _ret2 = _loop2();
                if (_ret2 === "continue") continue;
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
}
module.exports = {
    AppendEdgeHandler: $ee2b40a4fbf966f9$var$AppendEdgeHandler,
    DeleteRecordHandler: $ee2b40a4fbf966f9$var$DeleteRecordHandler,
    PrependEdgeHandler: $ee2b40a4fbf966f9$var$PrependEdgeHandler,
    AppendNodeHandler: $ee2b40a4fbf966f9$var$AppendNodeHandler,
    PrependNodeHandler: $ee2b40a4fbf966f9$var$PrependNodeHandler,
    DeleteEdgeHandler: $ee2b40a4fbf966f9$var$DeleteEdgeHandler
};

});

parcelRegister("cCKkj", function(module, exports) {
'use strict';

var $aZiI7 = parcelRequire("aZiI7");

var $krLBg = parcelRequire("krLBg");

var $5Wk1R = parcelRequire("5Wk1R");
function $930cf8231aaf25d7$var$RelayDefaultHandlerProvider(handle) {
    switch(handle){
        case 'connection':
            return $aZiI7;
        case 'deleteRecord':
            return $krLBg.DeleteRecordHandler;
        case 'deleteEdge':
            return $krLBg.DeleteEdgeHandler;
        case 'appendEdge':
            return $krLBg.AppendEdgeHandler;
        case 'prependEdge':
            return $krLBg.PrependEdgeHandler;
        case 'appendNode':
            return $krLBg.AppendNodeHandler;
        case 'prependNode':
            return $krLBg.PrependNodeHandler;
    }
    $5Wk1R(false);
}
module.exports = $930cf8231aaf25d7$var$RelayDefaultHandlerProvider;

});

parcelRegister("51mRT", function(module, exports) {
'use strict';

var $5AvhW = parcelRequire("5AvhW");
var $3a7ec8e1e61fa9c3$var$getRequest = $5AvhW.getRequest;

var $Gchpg = parcelRequire("Gchpg");

var $f2NQb = parcelRequire("f2NQb");
var $3a7ec8e1e61fa9c3$var$createOperationDescriptor = $f2NQb.createOperationDescriptor;

var $IbWT2 = parcelRequire("IbWT2");

var $5Wk1R = parcelRequire("5Wk1R");
function $3a7ec8e1e61fa9c3$var$applyOptimisticMutation(environment, config) {
    !$Gchpg(environment) && $5Wk1R(false);
    var mutation = $3a7ec8e1e61fa9c3$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    var optimisticUpdater = config.optimisticUpdater;
    var configs = config.configs, optimisticResponse = config.optimisticResponse, variables = config.variables;
    var operation = $3a7ec8e1e61fa9c3$var$createOperationDescriptor(mutation, variables);
    if (configs) {
        var _RelayDeclarativeMuta = $IbWT2.convert(configs, mutation, optimisticUpdater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
    }
    return environment.applyMutation({
        operation: operation,
        response: optimisticResponse,
        updater: optimisticUpdater
    });
}
module.exports = $3a7ec8e1e61fa9c3$var$applyOptimisticMutation;

});
parcelRegister("Gchpg", function(module, exports) {
'use strict';
function $07ed72dc68ccee6c$var$isRelayModernEnvironment(environment) {
    return Boolean(environment && environment['@@RelayModernEnvironment']);
}
module.exports = $07ed72dc68ccee6c$var$isRelayModernEnvironment;

});

parcelRegister("IbWT2", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $084d60f482d292d7$var$_interopRequireDefault = $bGHxy.default;

var $084d60f482d292d7$var$_createForOfIteratorHelper2 = $084d60f482d292d7$var$_interopRequireDefault((parcelRequire("cXbK5")));

var $aZiI7 = parcelRequire("aZiI7");
parcelRequire("91yGl");
var $084d60f482d292d7$var$MutationTypes = Object.freeze({
    RANGE_ADD: 'RANGE_ADD',
    RANGE_DELETE: 'RANGE_DELETE',
    NODE_DELETE: 'NODE_DELETE'
});
var $084d60f482d292d7$var$RangeOperations = Object.freeze({
    APPEND: 'append',
    PREPEND: 'prepend'
});
function $084d60f482d292d7$var$convert(configs, request, optimisticUpdater, updater) {
    var configOptimisticUpdates = optimisticUpdater ? [
        optimisticUpdater
    ] : [];
    var configUpdates = updater ? [
        updater
    ] : [];
    configs.forEach(function(config) {
        switch(config.type){
            case 'NODE_DELETE':
                var nodeDeleteResult = $084d60f482d292d7$var$nodeDelete(config, request);
                if (nodeDeleteResult) {
                    configOptimisticUpdates.push(nodeDeleteResult);
                    configUpdates.push(nodeDeleteResult);
                }
                break;
            case 'RANGE_ADD':
                var rangeAddResult = $084d60f482d292d7$var$rangeAdd(config, request);
                if (rangeAddResult) {
                    configOptimisticUpdates.push(rangeAddResult);
                    configUpdates.push(rangeAddResult);
                }
                break;
            case 'RANGE_DELETE':
                var rangeDeleteResult = $084d60f482d292d7$var$rangeDelete(config, request);
                if (rangeDeleteResult) {
                    configOptimisticUpdates.push(rangeDeleteResult);
                    configUpdates.push(rangeDeleteResult);
                }
                break;
        }
    });
    return {
        optimisticUpdater: function optimisticUpdater(store, data) {
            configOptimisticUpdates.forEach(function(eachOptimisticUpdater) {
                eachOptimisticUpdater(store, data);
            });
        },
        updater: function updater(store, data) {
            configUpdates.forEach(function(eachUpdater) {
                eachUpdater(store, data);
            });
        }
    };
}
function $084d60f482d292d7$var$nodeDelete(config, request) {
    var deletedIDFieldName = config.deletedIDFieldName;
    var rootField = $084d60f482d292d7$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var deleteID = payload.getValue(deletedIDFieldName);
        var deleteIDs = Array.isArray(deleteID) ? deleteID : [
            deleteID
        ];
        deleteIDs.forEach(function(id) {
            if (id && typeof id === 'string') store["delete"](id);
        });
    };
}
function $084d60f482d292d7$var$rangeAdd(config, request) {
    var parentID = config.parentID, connectionInfo = config.connectionInfo, edgeName = config.edgeName;
    if (!parentID) return null;
    var rootField = $084d60f482d292d7$var$getRootField(request);
    if (!connectionInfo || !rootField) return null;
    return function(store, data) {
        var parent = store.get(parentID);
        if (!parent) return;
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var serverEdge = payload.getLinkedRecord(edgeName);
        var _iterator = (0, $084d60f482d292d7$var$_createForOfIteratorHelper2["default"])(connectionInfo), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var info = _step.value;
                if (!serverEdge) continue;
                var connection = $aZiI7.getConnection(parent, info.key, info.filters);
                if (!connection) continue;
                var clientEdge = $aZiI7.buildConnectionEdge(store, connection, serverEdge);
                if (!clientEdge) continue;
                switch(info.rangeBehavior){
                    case 'append':
                        $aZiI7.insertEdgeAfter(connection, clientEdge);
                        break;
                    case 'prepend':
                        $aZiI7.insertEdgeBefore(connection, clientEdge);
                        break;
                    default:
                        break;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
}
function $084d60f482d292d7$var$rangeDelete(config, request) {
    var parentID = config.parentID, connectionKeys = config.connectionKeys, pathToConnection = config.pathToConnection, deletedIDFieldName = config.deletedIDFieldName;
    if (!parentID) return null;
    var rootField = $084d60f482d292d7$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        if (!data) return;
        var deleteIDs = [];
        var deletedIDField = data[rootField];
        if (deletedIDField && Array.isArray(deletedIDFieldName)) {
            var _iterator2 = (0, $084d60f482d292d7$var$_createForOfIteratorHelper2["default"])(deletedIDFieldName), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var eachField = _step2.value;
                    if (deletedIDField && typeof deletedIDField === 'object') deletedIDField = deletedIDField[eachField];
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(idObject) {
                if (idObject && idObject.id && typeof idObject === 'object' && typeof idObject.id === 'string') deleteIDs.push(idObject.id);
            });
            else if (deletedIDField && deletedIDField.id && typeof deletedIDField.id === 'string') deleteIDs.push(deletedIDField.id);
        } else if (deletedIDField && typeof deletedIDFieldName === 'string' && typeof deletedIDField === 'object') {
            deletedIDField = deletedIDField[deletedIDFieldName];
            if (typeof deletedIDField === 'string') deleteIDs.push(deletedIDField);
            else if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(id) {
                if (typeof id === 'string') deleteIDs.push(id);
            });
        }
        $084d60f482d292d7$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs);
    };
}
function $084d60f482d292d7$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs) {
    var parent = store.get(parentID);
    if (!parent) return;
    if (pathToConnection.length < 2) return;
    var recordProxy = parent;
    for(var i = 1; i < pathToConnection.length - 1; i++)if (recordProxy) recordProxy = recordProxy.getLinkedRecord(pathToConnection[i]);
    if (!connectionKeys || !recordProxy) return;
    var _iterator3 = (0, $084d60f482d292d7$var$_createForOfIteratorHelper2["default"])(connectionKeys), _step3;
    try {
        var _loop = function _loop() {
            var key = _step3.value;
            var connection = $aZiI7.getConnection(recordProxy, key.key, key.filters);
            if (connection) deleteIDs.forEach(function(deleteID) {
                $aZiI7.deleteNode(connection, deleteID);
            });
        };
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;)_loop();
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $084d60f482d292d7$var$getRootField(request) {
    if (request.fragment.selections && request.fragment.selections.length > 0 && request.fragment.selections[0].kind === 'LinkedField') return request.fragment.selections[0].name;
    return null;
}
module.exports = {
    MutationTypes: $084d60f482d292d7$var$MutationTypes,
    RangeOperations: $084d60f482d292d7$var$RangeOperations,
    convert: $084d60f482d292d7$var$convert
};

});


parcelRegister("cr3Pd", function(module, exports) {
'use strict';
function $90daf93e611e35a5$var$commitLocalUpdate(environment, updater) {
    environment.commitUpdate(updater);
}
module.exports = $90daf93e611e35a5$var$commitLocalUpdate;

});

parcelRegister("lmRbm", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $f8e4e7f24761c861$var$_interopRequireDefault = $bGHxy.default;

var $f8e4e7f24761c861$var$_toConsumableArray2 = $f8e4e7f24761c861$var$_interopRequireDefault((parcelRequire("kTVTn")));

var $5AvhW = parcelRequire("5AvhW");
var $f8e4e7f24761c861$var$getRequest = $5AvhW.getRequest;

var $fJ2hT = parcelRequire("fJ2hT");
var $f8e4e7f24761c861$var$generateUniqueClientID = $fJ2hT.generateUniqueClientID;

var $Gchpg = parcelRequire("Gchpg");

var $f2NQb = parcelRequire("f2NQb");
var $f8e4e7f24761c861$var$createOperationDescriptor = $f2NQb.createOperationDescriptor;

var $IbWT2 = parcelRequire("IbWT2");
parcelRequire("3COHU");

var $5Wk1R = parcelRequire("5Wk1R");
parcelRequire("91yGl");
function $f8e4e7f24761c861$var$commitMutation(environment, config) {
    !$Gchpg(environment) && $5Wk1R(false);
    var mutation = $f8e4e7f24761c861$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    if (mutation.kind !== 'Request') throw new Error('commitMutation: Expected mutation to be of type request');
    var optimisticResponse = config.optimisticResponse, optimisticUpdater = config.optimisticUpdater, updater = config.updater;
    var configs = config.configs, cacheConfig = config.cacheConfig, onError = config.onError, onUnsubscribe = config.onUnsubscribe, variables = config.variables, uploadables = config.uploadables;
    var operation = $f8e4e7f24761c861$var$createOperationDescriptor(mutation, variables, cacheConfig, $f8e4e7f24761c861$var$generateUniqueClientID());
    if (typeof optimisticResponse === 'function') optimisticResponse = optimisticResponse();
    if (configs) {
        var _RelayDeclarativeMuta = $IbWT2.convert(configs, mutation, optimisticUpdater, updater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
        updater = _RelayDeclarativeMuta.updater;
    }
    var errors = [];
    var subscription = environment.executeMutation({
        operation: operation,
        optimisticResponse: optimisticResponse,
        optimisticUpdater: optimisticUpdater,
        updater: updater,
        uploadables: uploadables
    }).subscribe({
        next: function next(payload) {
            var _config$onNext;
            if (Array.isArray(payload)) payload.forEach(function(item) {
                if (item.errors) errors.push.apply(errors, (0, $f8e4e7f24761c861$var$_toConsumableArray2["default"])(item.errors));
            });
            else if (payload.errors) errors.push.apply(errors, (0, $f8e4e7f24761c861$var$_toConsumableArray2["default"])(payload.errors));
            (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
        },
        complete: function complete() {
            var onCompleted = config.onCompleted;
            if (onCompleted) {
                var snapshot = environment.lookup(operation.fragment);
                onCompleted(snapshot.data, errors.length !== 0 ? errors : null);
            }
        },
        error: onError,
        unsubscribe: onUnsubscribe
    });
    return {
        dispose: subscription.unsubscribe
    };
}
module.exports = $f8e4e7f24761c861$var$commitMutation;

});
parcelRegister("3COHU", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $2a3c41154bc12cbb$var$_interopRequireDefault = $bGHxy.default;

var $2a3c41154bc12cbb$var$_objectSpread2 = $2a3c41154bc12cbb$var$_interopRequireDefault((parcelRequire("eQAdv")));
parcelRequire("91yGl");
var $2a3c41154bc12cbb$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $2a3c41154bc12cbb$var$validateMutation = function validateMutation() {};
var $2a3c41154bc12cbb$var$addFieldToDiff, $2a3c41154bc12cbb$var$validateSelections, $2a3c41154bc12cbb$var$validateSelection, $2a3c41154bc12cbb$var$validateModuleImport, $2a3c41154bc12cbb$var$validateAbstractKey, $2a3c41154bc12cbb$var$validateField, $2a3c41154bc12cbb$var$validateOptimisticResponse;
module.exports = $2a3c41154bc12cbb$var$validateMutation;

});


parcelRegister("42Dtw", function(module, exports) {
'use strict';

var $lOhgn = parcelRequire("lOhgn");

var $hlKwp = parcelRequire("hlKwp");
var $2f15f84163761852$var$convertFetch = $hlKwp.convertFetch;

var $5Wk1R = parcelRequire("5Wk1R");
function $2f15f84163761852$var$create(fetchFn, subscribe) {
    var observeFetch = $2f15f84163761852$var$convertFetch(fetchFn);
    function execute(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var operationVariables = $lOhgn(variables, request.providedVariables);
        if (request.operationKind === 'subscription') {
            !subscribe && $5Wk1R(false);
            !!uploadables && $5Wk1R(false);
            return subscribe(request, operationVariables, cacheConfig);
        }
        var pollInterval = cacheConfig.poll;
        if (pollInterval != null) {
            !!uploadables && $5Wk1R(false);
            return observeFetch(request, operationVariables, {
                force: true
            }).poll(pollInterval);
        }
        return observeFetch(request, operationVariables, cacheConfig, uploadables, logRequestInfo);
    }
    return {
        execute: execute
    };
}
module.exports = {
    create: $2f15f84163761852$var$create
};

});
parcelRegister("lOhgn", function(module, exports) {
'use strict';
parcelRequire("cGxFv");
parcelRequire("91yGl");
var $fe0ba89956234d4c$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $fe0ba89956234d4c$var$debugCache = $fe0ba89956234d4c$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $fe0ba89956234d4c$var$withProvidedVariables(userSuppliedVariables, providedVariables) {
    if (providedVariables != null) {
        var operationVariables = {};
        Object.assign(operationVariables, userSuppliedVariables);
        Object.keys(providedVariables).forEach(function(varName) {
            var providerFunction = providedVariables[varName].get;
            var providerResult = providerFunction();
            if (!$fe0ba89956234d4c$var$debugCache.has(providerFunction)) {
                $fe0ba89956234d4c$var$debugCache.set(providerFunction, providerResult);
                operationVariables[varName] = providerResult;
            } else {
                var cachedResult = $fe0ba89956234d4c$var$debugCache.get(providerFunction);
                operationVariables[varName] = cachedResult;
            }
        });
        return operationVariables;
    } else return userSuppliedVariables;
}
$fe0ba89956234d4c$var$withProvidedVariables.tests_only_resetDebugCache = undefined;
module.exports = $fe0ba89956234d4c$var$withProvidedVariables;

});

parcelRegister("hlKwp", function(module, exports) {
'use strict';

var $u7PH0 = parcelRequire("u7PH0");
function $ca187c0de60523f2$var$convertFetch(fn) {
    return function fetch(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var result = fn(request, variables, cacheConfig, uploadables, logRequestInfo);
        if (result instanceof Error) return $u7PH0.create(function(sink) {
            return sink.error(result);
        });
        return $u7PH0.from(result);
    };
}
module.exports = {
    convertFetch: $ca187c0de60523f2$var$convertFetch
};

});


parcelRegister("26M0b", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $1891607dcc737c60$var$_interopRequireDefault = $bGHxy.default;

var $1891607dcc737c60$var$_objectSpread2 = $1891607dcc737c60$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $aFY6e = parcelRequire("aFY6e");
var $1891607dcc737c60$var$stableCopy = $aFY6e.stableCopy;

var $5Wk1R = parcelRequire("5Wk1R");
var $1891607dcc737c60$var$RelayQueryResponseCache = /*#__PURE__*/ function() {
    function RelayQueryResponseCache(_ref) {
        var size = _ref.size, ttl = _ref.ttl;
        !(size > 0) && $5Wk1R(false);
        !(ttl > 0) && $5Wk1R(false);
        this._responses = new Map();
        this._size = size;
        this._ttl = ttl;
    }
    var _proto = RelayQueryResponseCache.prototype;
    _proto.clear = function clear() {
        this._responses.clear();
    };
    _proto.get = function get(queryID, variables) {
        var _this = this;
        var cacheKey = $1891607dcc737c60$var$getCacheKey(queryID, variables);
        this._responses.forEach(function(response, key) {
            if (!$1891607dcc737c60$var$isCurrent(response.fetchTime, _this._ttl)) _this._responses["delete"](key);
        });
        var response = this._responses.get(cacheKey);
        if (response == null) return null;
        if (Array.isArray(response.payload)) return response.payload.map(function(payload) {
            return (0, $1891607dcc737c60$var$_objectSpread2["default"])((0, $1891607dcc737c60$var$_objectSpread2["default"])({}, payload), {}, {
                extensions: (0, $1891607dcc737c60$var$_objectSpread2["default"])((0, $1891607dcc737c60$var$_objectSpread2["default"])({}, payload.extensions), {}, {
                    cacheTimestamp: response.fetchTime
                })
            });
        });
        return (0, $1891607dcc737c60$var$_objectSpread2["default"])((0, $1891607dcc737c60$var$_objectSpread2["default"])({}, response.payload), {}, {
            extensions: (0, $1891607dcc737c60$var$_objectSpread2["default"])((0, $1891607dcc737c60$var$_objectSpread2["default"])({}, response.payload.extensions), {}, {
                cacheTimestamp: response.fetchTime
            })
        });
    };
    _proto.set = function set(queryID, variables, payload) {
        var fetchTime = Date.now();
        var cacheKey = $1891607dcc737c60$var$getCacheKey(queryID, variables);
        this._responses["delete"](cacheKey);
        this._responses.set(cacheKey, {
            fetchTime: fetchTime,
            payload: payload
        });
        if (this._responses.size > this._size) {
            var firstKey = this._responses.keys().next();
            if (!firstKey.done) this._responses["delete"](firstKey.value);
        }
    };
    return RelayQueryResponseCache;
}();
function $1891607dcc737c60$var$getCacheKey(queryID, variables) {
    return JSON.stringify($1891607dcc737c60$var$stableCopy({
        queryID: queryID,
        variables: variables
    }));
}
function $1891607dcc737c60$var$isCurrent(fetchTime, ttl) {
    return fetchTime + ttl >= Date.now();
}
module.exports = $1891607dcc737c60$var$RelayQueryResponseCache;

});

parcelRegister("02zve", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $007bba21334da144$var$_interopRequireDefault = $bGHxy.default;

var $007bba21334da144$var$_objectSpread2 = $007bba21334da144$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $u7PH0 = parcelRequire("u7PH0");

var $f2NQb = parcelRequire("f2NQb");
var $007bba21334da144$var$createOperationDescriptor = $f2NQb.createOperationDescriptor;

var $lLciG = parcelRequire("lLciG");
var $007bba21334da144$var$handlePotentialSnapshotErrors = $lLciG.handlePotentialSnapshotErrors;

var $aDkGX = parcelRequire("aDkGX");

var $5AvhW = parcelRequire("5AvhW");
var $007bba21334da144$var$getRequest = $5AvhW.getRequest;

var $5Wk1R = parcelRequire("5Wk1R");
function $007bba21334da144$var$fetchQuery(environment, query, variables, options) {
    var _options$fetchPolicy;
    var queryNode = $007bba21334da144$var$getRequest(query);
    !(queryNode.params.operationKind === 'query') && $5Wk1R(false);
    var networkCacheConfig = (0, $007bba21334da144$var$_objectSpread2["default"])({
        force: true
    }, options === null || options === void 0 ? void 0 : options.networkCacheConfig);
    var operation = $007bba21334da144$var$createOperationDescriptor(queryNode, variables, networkCacheConfig);
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'network-only';
    function readData(snapshot) {
        $007bba21334da144$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
        return snapshot.data;
    }
    switch(fetchPolicy){
        case 'network-only':
            return $007bba21334da144$var$getNetworkObservable(environment, operation).map(readData);
        case 'store-or-network':
            if (environment.check(operation).status === 'available') return $u7PH0.from(environment.lookup(operation.fragment)).map(readData);
            return $007bba21334da144$var$getNetworkObservable(environment, operation).map(readData);
        default:
            fetchPolicy;
            throw new Error('fetchQuery: Invalid fetchPolicy ' + fetchPolicy);
    }
}
function $007bba21334da144$var$getNetworkObservable(environment, operation) {
    return $aDkGX.fetchQuery(environment, operation).map(function() {
        return environment.lookup(operation.fragment);
    });
}
module.exports = $007bba21334da144$var$fetchQuery;

});

parcelRegister("70PVw", function(module, exports) {
'use strict';

var $f2NQb = parcelRequire("f2NQb");
var $51b0d00ab70f2d57$var$createOperationDescriptor = $f2NQb.createOperationDescriptor;

var $5AvhW = parcelRequire("5AvhW");
var $51b0d00ab70f2d57$var$getRequest = $5AvhW.getRequest;
function $51b0d00ab70f2d57$var$fetchQuery_DEPRECATED(environment, taggedNode, variables, cacheConfig) {
    var query = $51b0d00ab70f2d57$var$getRequest(taggedNode);
    if (query.params.operationKind !== 'query') throw new Error('fetchQuery: Expected query operation');
    var operation = $51b0d00ab70f2d57$var$createOperationDescriptor(query, variables, cacheConfig);
    return environment.execute({
        operation: operation
    }).map(function() {
        return environment.lookup(operation.fragment).data;
    }).toPromise();
}
module.exports = $51b0d00ab70f2d57$var$fetchQuery_DEPRECATED;

});

parcelRegister("jy2DY", function(module, exports) {
'use strict';
var $e3b33e45e5219795$var$PreloadableQueryRegistry = /*#__PURE__*/ function() {
    function PreloadableQueryRegistry() {
        this._preloadableQueries = new Map();
        this._callbacks = new Map();
    }
    var _proto = PreloadableQueryRegistry.prototype;
    _proto.set = function set(key, value) {
        this._preloadableQueries.set(key, value);
        var callbacks = this._callbacks.get(key);
        if (callbacks != null) callbacks.forEach(function(cb) {
            try {
                cb(value);
            } catch (e) {
                setTimeout(function() {
                    throw e;
                }, 0);
            }
        });
    };
    _proto.get = function get(key) {
        return this._preloadableQueries.get(key);
    };
    _proto.onLoad = function onLoad(key, callback) {
        var _this$_callbacks$get;
        var callbacks = (_this$_callbacks$get = this._callbacks.get(key)) !== null && _this$_callbacks$get !== void 0 ? _this$_callbacks$get : new Set();
        callbacks.add(callback);
        var dispose = function dispose() {
            callbacks["delete"](callback);
        };
        this._callbacks.set(key, callbacks);
        return {
            dispose: dispose
        };
    };
    _proto.clear = function clear() {
        this._preloadableQueries.clear();
    };
    return PreloadableQueryRegistry;
}();
var $e3b33e45e5219795$var$preloadableQueryRegistry = new $e3b33e45e5219795$var$PreloadableQueryRegistry();
module.exports = $e3b33e45e5219795$var$preloadableQueryRegistry;

});

parcelRegister("dr26Y", function(module, exports) {
'use strict';

var $lLgmK = parcelRequire("lLgmK");
parcelRequire("91yGl");
function $9c7f6f424e8b6c93$var$createFragmentSpecResolver(context, containerName, fragments, props, rootIsQueryRenderer, callback) {
    var fragmentNames;
    return new $lLgmK(context, fragments, props, callback, rootIsQueryRenderer);
}
module.exports = $9c7f6f424e8b6c93$var$createFragmentSpecResolver;

});
parcelRegister("lLgmK", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $fd7aaeb51f9d13ac$var$_interopRequireDefault = $bGHxy.default;

var $fd7aaeb51f9d13ac$var$_objectSpread2 = $fd7aaeb51f9d13ac$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $fd7aaeb51f9d13ac$var$_defineProperty2 = $fd7aaeb51f9d13ac$var$_interopRequireDefault((parcelRequire("aUl3j")));

var $gyLIM = parcelRequire("gyLIM");

var $lLciG = parcelRequire("lLciG");
var $fd7aaeb51f9d13ac$var$handlePotentialSnapshotErrors = $lLciG.handlePotentialSnapshotErrors;

var $dEqQj = parcelRequire("dEqQj");

var $7hYYU = parcelRequire("7hYYU");

var $3hqjB = parcelRequire("3hqjB");

var $f2NQb = parcelRequire("f2NQb");
var $fd7aaeb51f9d13ac$var$createRequestDescriptor = $f2NQb.createRequestDescriptor;

var $dTSGA = parcelRequire("dTSGA");
var $fd7aaeb51f9d13ac$var$areEqualSelectors = $dTSGA.areEqualSelectors, $fd7aaeb51f9d13ac$var$createReaderSelector = $dTSGA.createReaderSelector, $fd7aaeb51f9d13ac$var$getSelectorsFromObject = $dTSGA.getSelectorsFromObject;

var $cGxFv = parcelRequire("cGxFv");

var $5Wk1R = parcelRequire("5Wk1R");
parcelRequire("91yGl");
var $fd7aaeb51f9d13ac$var$RelayModernFragmentSpecResolver = /*#__PURE__*/ function() {
    function RelayModernFragmentSpecResolver(context, fragments, props, callback, rootIsQueryRenderer) {
        var _this = this;
        (0, $fd7aaeb51f9d13ac$var$_defineProperty2["default"])(this, "_onChange", function() {
            _this._stale = true;
            if (typeof _this._callback === 'function') _this._callback();
        });
        this._callback = callback;
        this._context = context;
        this._data = {};
        this._fragments = fragments;
        this._props = {};
        this._resolvers = {};
        this._stale = false;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this.setProps(props);
    }
    var _proto = RelayModernFragmentSpecResolver.prototype;
    _proto.dispose = function dispose() {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) $fd7aaeb51f9d13ac$var$disposeCallback(this._resolvers[key]);
    };
    _proto.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
                var resolver = this._resolvers[key];
                var prevItem = prevData[key];
                if (resolver) {
                    var nextItem = resolver.resolve();
                    if (nextData || nextItem !== prevItem) {
                        nextData = nextData || (0, $fd7aaeb51f9d13ac$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = nextItem;
                    }
                } else {
                    var prop = this._props[key];
                    var _nextItem = prop !== undefined ? prop : null;
                    if (nextData || !$dEqQj(_nextItem, prevItem)) {
                        nextData = nextData || (0, $fd7aaeb51f9d13ac$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = _nextItem;
                    }
                }
            }
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto.setCallback = function setCallback(props, callback) {
        this._callback = callback;
        if ($3hqjB.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this.setProps(props);
    };
    _proto.setProps = function setProps(props) {
        this._props = {};
        var ownedSelectors = $fd7aaeb51f9d13ac$var$getSelectorsFromObject(this._fragments, props);
        for(var key in ownedSelectors)if (ownedSelectors.hasOwnProperty(key)) {
            var ownedSelector = ownedSelectors[key];
            var resolver = this._resolvers[key];
            if (ownedSelector == null) {
                if (resolver != null) resolver.dispose();
                resolver = null;
            } else if (ownedSelector.kind === 'PluralReaderSelector') {
                if (resolver == null) resolver = new $fd7aaeb51f9d13ac$var$SelectorListResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
                else {
                    !(resolver instanceof $fd7aaeb51f9d13ac$var$SelectorListResolver) && $5Wk1R(false);
                    resolver.setSelector(ownedSelector);
                }
            } else if (resolver == null) resolver = new $fd7aaeb51f9d13ac$var$SelectorResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
            else {
                !(resolver instanceof $fd7aaeb51f9d13ac$var$SelectorResolver) && $5Wk1R(false);
                resolver.setSelector(ownedSelector);
            }
            this._props[key] = props[key];
            this._resolvers[key] = resolver;
        }
        this._stale = true;
    };
    _proto.setVariables = function setVariables(variables, request) {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
            var resolver = this._resolvers[key];
            if (resolver) resolver.setVariables(variables, request);
        }
        this._stale = true;
    };
    return RelayModernFragmentSpecResolver;
}();
var $fd7aaeb51f9d13ac$var$SelectorResolver = /*#__PURE__*/ function() {
    function SelectorResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this2 = this;
        (0, $fd7aaeb51f9d13ac$var$_defineProperty2["default"])(this, "_onChange", function(snapshot) {
            _this2._data = snapshot.data;
            _this2._isMissingData = snapshot.isMissingData;
            _this2._fieldErrors = snapshot.fieldErrors;
            _this2._callback();
        });
        var _snapshot = environment.lookup(selector);
        this._callback = callback;
        this._data = _snapshot.data;
        this._isMissingData = _snapshot.isMissingData;
        this._fieldErrors = _snapshot.fieldErrors;
        this._environment = environment;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._selector = selector;
        if ($3hqjB.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
            if (subscribeOnConstruction) this._subscription = environment.subscribe(_snapshot, this._onChange);
        } else this._subscription = environment.subscribe(_snapshot, this._onChange);
    }
    var _proto2 = SelectorResolver.prototype;
    _proto2.dispose = function dispose() {
        if (this._subscription) {
            this._subscription.dispose();
            this._subscription = null;
        }
    };
    _proto2.resolve = function resolve() {
        if (this._isMissingData === true) {
            var pendingOperationsResult = $gyLIM(this._environment, this._selector.node, this._selector.owner);
            var promise = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.promise;
            if (promise != null) {
                if (this._rootIsQueryRenderer) ;
                else {
                    var _pendingOperationsRes;
                    var pendingOperations = (_pendingOperationsRes = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.pendingOperations) !== null && _pendingOperationsRes !== void 0 ? _pendingOperationsRes : [];
                    this._environment.__log({
                        name: 'suspense.fragment',
                        data: this._data,
                        fragment: this._selector.node,
                        isRelayHooks: false,
                        isMissingData: this._isMissingData,
                        isPromiseCached: false,
                        pendingOperations: pendingOperations
                    });
                    throw promise;
                }
            }
        }
        $fd7aaeb51f9d13ac$var$handlePotentialSnapshotErrors(this._environment, this._fieldErrors);
        return this._data;
    };
    _proto2.setSelector = function setSelector(selector) {
        if (this._subscription != null && $fd7aaeb51f9d13ac$var$areEqualSelectors(selector, this._selector)) return;
        this.dispose();
        var snapshot = this._environment.lookup(selector);
        this._data = $7hYYU(this._data, snapshot.data);
        this._isMissingData = snapshot.isMissingData;
        this._fieldErrors = snapshot.fieldErrors;
        this._selector = selector;
        this._subscription = this._environment.subscribe(snapshot, this._onChange);
    };
    _proto2.setVariables = function setVariables(variables, request) {
        if ($cGxFv(variables, this._selector.variables)) return;
        var requestDescriptor = $fd7aaeb51f9d13ac$var$createRequestDescriptor(request, variables);
        var selector = $fd7aaeb51f9d13ac$var$createReaderSelector(this._selector.node, this._selector.dataID, variables, requestDescriptor);
        this.setSelector(selector);
    };
    return SelectorResolver;
}();
var $fd7aaeb51f9d13ac$var$SelectorListResolver = /*#__PURE__*/ function() {
    function SelectorListResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this3 = this;
        (0, $fd7aaeb51f9d13ac$var$_defineProperty2["default"])(this, "_onChange", function(data) {
            _this3._stale = true;
            _this3._callback();
        });
        this._callback = callback;
        this._data = [];
        this._environment = environment;
        this._resolvers = [];
        this._stale = true;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._subscribeOnConstruction = subscribeOnConstruction;
        this.setSelector(selector);
    }
    var _proto3 = SelectorListResolver.prototype;
    _proto3.dispose = function dispose() {
        this._resolvers.forEach($fd7aaeb51f9d13ac$var$disposeCallback);
    };
    _proto3.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var ii = 0; ii < this._resolvers.length; ii++){
                var prevItem = prevData[ii];
                var nextItem = this._resolvers[ii].resolve();
                if (nextData || nextItem !== prevItem) {
                    nextData = nextData || prevData.slice(0, ii);
                    nextData.push(nextItem);
                }
            }
            if (!nextData && this._resolvers.length !== prevData.length) nextData = prevData.slice(0, this._resolvers.length);
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto3.setSelector = function setSelector(selector) {
        var selectors = selector.selectors;
        while(this._resolvers.length > selectors.length){
            var resolver = this._resolvers.pop();
            resolver.dispose();
        }
        for(var ii = 0; ii < selectors.length; ii++)if (ii < this._resolvers.length) this._resolvers[ii].setSelector(selectors[ii]);
        else this._resolvers[ii] = new $fd7aaeb51f9d13ac$var$SelectorResolver(this._environment, this._rootIsQueryRenderer, selectors[ii], this._subscribeOnConstruction, this._onChange);
        this._stale = true;
    };
    _proto3.setVariables = function setVariables(variables, request) {
        this._resolvers.forEach(function(resolver) {
            return resolver.setVariables(variables, request);
        });
        this._stale = true;
    };
    return SelectorListResolver;
}();
function $fd7aaeb51f9d13ac$var$disposeCallback(disposable) {
    disposable && disposable.dispose();
}
module.exports = $fd7aaeb51f9d13ac$var$RelayModernFragmentSpecResolver;

});
parcelRegister("gyLIM", function(module, exports) {
'use strict';

var $aDkGX = parcelRequire("aDkGX");
var $c0e4d6c0040af955$var$getPromiseForActiveRequest = $aDkGX.getPromiseForActiveRequest;
function $c0e4d6c0040af955$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner) {
    var _pendingOperations$ma, _pendingOperations;
    var pendingOperations = [];
    var promise = $c0e4d6c0040af955$var$getPromiseForActiveRequest(environment, fragmentOwner);
    if (promise != null) pendingOperations = [
        fragmentOwner
    ];
    else {
        var _result$pendingOperat, _result$promise;
        var operationTracker = environment.getOperationTracker();
        var result = operationTracker.getPendingOperationsAffectingOwner(fragmentOwner);
        pendingOperations = (_result$pendingOperat = result === null || result === void 0 ? void 0 : result.pendingOperations) !== null && _result$pendingOperat !== void 0 ? _result$pendingOperat : [];
        promise = (_result$promise = result === null || result === void 0 ? void 0 : result.promise) !== null && _result$promise !== void 0 ? _result$promise : null;
    }
    if (!promise) return null;
    var pendingOperationName = (_pendingOperations$ma = (_pendingOperations = pendingOperations) === null || _pendingOperations === void 0 ? void 0 : _pendingOperations.map(function(op) {
        return op.node.params.name;
    }).join(',')) !== null && _pendingOperations$ma !== void 0 ? _pendingOperations$ma : null;
    if (pendingOperationName == null || pendingOperationName.length === 0) pendingOperationName = 'Unknown pending operation';
    var fragmentName = fragmentNode.name;
    var promiseDisplayName = pendingOperationName === fragmentName ? "Relay(".concat(pendingOperationName, ")") : "Relay(".concat(pendingOperationName, ":").concat(fragmentName, ")");
    promise.displayName = promiseDisplayName;
    environment.__log({
        name: 'pendingoperation.found',
        fragment: fragmentNode,
        fragmentOwner: fragmentOwner,
        pendingOperations: pendingOperations
    });
    return {
        promise: promise,
        pendingOperations: pendingOperations
    };
}
module.exports = $c0e4d6c0040af955$var$getPendingOperationsForFragment;

});

parcelRegister("dEqQj", function(module, exports) {
'use strict';
function $9f03d53838e52291$var$isScalarAndEqual(valueA, valueB) {
    return valueA === valueB && (valueA === null || typeof valueA !== 'object');
}
module.exports = $9f03d53838e52291$var$isScalarAndEqual;

});

parcelRegister("7hYYU", function(module, exports) {
'use strict';
function $54e96c975c640e14$var$recycleNodesInto(prevData, nextData) {
    return $54e96c975c640e14$var$recycleNodesIntoImpl(prevData, nextData, true);
}
function $54e96c975c640e14$var$recycleNodesIntoImpl(prevData, nextData, canMutate) {
    if (prevData === nextData || typeof prevData !== 'object' || !prevData || prevData.constructor !== Object && !Array.isArray(prevData) || typeof nextData !== 'object' || !nextData || nextData.constructor !== Object && !Array.isArray(nextData)) return nextData;
    var canRecycle = false;
    var prevArray = Array.isArray(prevData) ? prevData : null;
    var nextArray = Array.isArray(nextData) ? nextData : null;
    if (prevArray && nextArray) {
        var canMutateNext = canMutate && !Object.isFrozen(nextArray);
        canRecycle = nextArray.reduce(function(wasEqual, nextItem, ii) {
            var prevValue = prevArray[ii];
            var nextValue = $54e96c975c640e14$var$recycleNodesIntoImpl(prevValue, nextItem, canMutateNext);
            if (nextValue !== nextArray[ii] && canMutateNext) nextArray[ii] = nextValue;
            return wasEqual && nextValue === prevArray[ii];
        }, true) && prevArray.length === nextArray.length;
    } else if (!prevArray && !nextArray) {
        var prevObject = prevData;
        var nextObject = nextData;
        var prevKeys = Object.keys(prevObject);
        var nextKeys = Object.keys(nextObject);
        var _canMutateNext = canMutate && !Object.isFrozen(nextObject);
        canRecycle = nextKeys.reduce(function(wasEqual, key) {
            var prevValue = prevObject[key];
            var nextValue = $54e96c975c640e14$var$recycleNodesIntoImpl(prevValue, nextObject[key], _canMutateNext);
            if (nextValue !== nextObject[key] && _canMutateNext) nextObject[key] = nextValue;
            return wasEqual && nextValue === prevObject[key];
        }, true) && prevKeys.length === nextKeys.length;
    }
    return canRecycle ? prevData : nextData;
}
module.exports = $54e96c975c640e14$var$recycleNodesInto;

});



parcelRegister("83vbi", function(module, exports) {
'use strict';

var $5Wk1R = parcelRequire("5Wk1R");
var $5dd6ca74571daeb2$var$relayContext;
var $5dd6ca74571daeb2$var$firstReact;
function $5dd6ca74571daeb2$var$createRelayContext(react) {
    if (!$5dd6ca74571daeb2$var$relayContext) {
        $5dd6ca74571daeb2$var$relayContext = react.createContext(null);
        $5dd6ca74571daeb2$var$firstReact = react;
    }
    !(react === $5dd6ca74571daeb2$var$firstReact) && $5Wk1R(false);
    return $5dd6ca74571daeb2$var$relayContext;
}
module.exports = $5dd6ca74571daeb2$var$createRelayContext;

});

parcelRegister("9thWZ", function(module, exports) {
'use strict';

var $5Wk1R = parcelRequire("5Wk1R");
var $6e54bf0f6d230675$var$relayLoggingContext;
var $6e54bf0f6d230675$var$firstReact;
function $6e54bf0f6d230675$var$createRelayLoggingContext(react) {
    if (!$6e54bf0f6d230675$var$relayLoggingContext) {
        $6e54bf0f6d230675$var$relayLoggingContext = react.createContext(null);
        $6e54bf0f6d230675$var$firstReact = react;
    }
    !(react === $6e54bf0f6d230675$var$firstReact) && $5Wk1R(false);
    return $6e54bf0f6d230675$var$relayLoggingContext;
}
module.exports = $6e54bf0f6d230675$var$createRelayLoggingContext;

});

parcelRegister("gvcbH", function(module, exports) {
'use strict';
var $c038fecbf1a38c5d$var$LIVE_RESOLVER_SUSPENSE_SENTINEL = Object.freeze({
    __LIVE_RESOLVER_SUSPENSE_SENTINEL: true
});
function $c038fecbf1a38c5d$var$suspenseSentinel() {
    return $c038fecbf1a38c5d$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
function $c038fecbf1a38c5d$var$isSuspenseSentinel(value) {
    return value === $c038fecbf1a38c5d$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
module.exports = {
    isSuspenseSentinel: $c038fecbf1a38c5d$var$isSuspenseSentinel,
    suspenseSentinel: $c038fecbf1a38c5d$var$suspenseSentinel
};

});

parcelRegister("8zzta", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $63dd1b1c9b97095c$var$_interopRequireDefault = $bGHxy.default;

var $63dd1b1c9b97095c$var$_objectSpread2 = $63dd1b1c9b97095c$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $63dd1b1c9b97095c$var$_RelayModernRecord = $63dd1b1c9b97095c$var$_interopRequireDefault((parcelRequire("cdcDZ")));

var $63dd1b1c9b97095c$var$_RelayRecordSource = $63dd1b1c9b97095c$var$_interopRequireDefault((parcelRequire("qckAk")));

var $63dd1b1c9b97095c$var$_RelayResponseNormalizer = $63dd1b1c9b97095c$var$_interopRequireDefault((parcelRequire("3U9zg")));
function $63dd1b1c9b97095c$var$normalizeResponse(response, selector, typeName, options, useExecTimeResolvers) {
    var _response$extensions;
    var data = response.data, errors = response.errors;
    var source = $63dd1b1c9b97095c$var$_RelayRecordSource["default"].create();
    var record = $63dd1b1c9b97095c$var$_RelayModernRecord["default"].create(selector.dataID, typeName);
    source.set(selector.dataID, record);
    var relayPayload = $63dd1b1c9b97095c$var$_RelayResponseNormalizer["default"].normalize(source, selector, data, options, errors, useExecTimeResolvers);
    return (0, $63dd1b1c9b97095c$var$_objectSpread2["default"])((0, $63dd1b1c9b97095c$var$_objectSpread2["default"])({}, relayPayload), {}, {
        isFinal: ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.is_final) === true
    });
}
module.exports = $63dd1b1c9b97095c$var$normalizeResponse;

});
parcelRegister("cdcDZ", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $8e4081be7f185b7f$var$_interopRequireDefault = $bGHxy.default;

var $8e4081be7f185b7f$var$_defineProperty2 = $8e4081be7f185b7f$var$_interopRequireDefault((parcelRequire("aUl3j")));

var $8e4081be7f185b7f$var$_objectWithoutPropertiesLoose2 = $8e4081be7f185b7f$var$_interopRequireDefault((parcelRequire("4erYc")));

var $8e4081be7f185b7f$var$_toPropertyKey2 = $8e4081be7f185b7f$var$_interopRequireDefault((parcelRequire("fIrVD")));

var $8e4081be7f185b7f$var$_objectSpread2 = $8e4081be7f185b7f$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $a9DXr = parcelRequire("a9DXr");

var $fJ2hT = parcelRequire("fJ2hT");
var $8e4081be7f185b7f$var$generateClientObjectClientID = $fJ2hT.generateClientObjectClientID, $8e4081be7f185b7f$var$isClientID = $fJ2hT.isClientID;

var $gvcbH = parcelRequire("gvcbH");
var $8e4081be7f185b7f$var$isSuspenseSentinel = $gvcbH.isSuspenseSentinel;

var $5vBPt = parcelRequire("5vBPt");
var $8e4081be7f185b7f$var$ACTOR_IDENTIFIER_KEY = $5vBPt.ACTOR_IDENTIFIER_KEY, $8e4081be7f185b7f$var$ERRORS_KEY = $5vBPt.ERRORS_KEY, $8e4081be7f185b7f$var$ID_KEY = $5vBPt.ID_KEY, $8e4081be7f185b7f$var$INVALIDATED_AT_KEY = $5vBPt.INVALIDATED_AT_KEY, $8e4081be7f185b7f$var$REF_KEY = $5vBPt.REF_KEY, $8e4081be7f185b7f$var$REFS_KEY = $5vBPt.REFS_KEY, $8e4081be7f185b7f$var$RELAY_RESOLVER_VALUE_KEY = $5vBPt.RELAY_RESOLVER_VALUE_KEY, $8e4081be7f185b7f$var$ROOT_ID = $5vBPt.ROOT_ID, $8e4081be7f185b7f$var$TYPENAME_KEY = $5vBPt.TYPENAME_KEY;

var $cGxFv = parcelRequire("cGxFv");

var $5Wk1R = parcelRequire("5Wk1R");
parcelRequire("91yGl");
function $8e4081be7f185b7f$var$clone(record) {
    return (0, $8e4081be7f185b7f$var$_objectSpread2["default"])({}, record);
}
function $8e4081be7f185b7f$var$copyFields(source, sink) {
    for(var key in source){
        if (source.hasOwnProperty(key)) {
            if (key !== $8e4081be7f185b7f$var$ID_KEY && key !== $8e4081be7f185b7f$var$TYPENAME_KEY) sink[key] = source[key];
        }
    }
}
function $8e4081be7f185b7f$var$create(dataID, typeName) {
    var record = {};
    record[$8e4081be7f185b7f$var$ID_KEY] = dataID;
    record[$8e4081be7f185b7f$var$TYPENAME_KEY] = typeName;
    return record;
}
function $8e4081be7f185b7f$var$fromObject(json) {
    return json;
}
function $8e4081be7f185b7f$var$getDataID(record) {
    return record[$8e4081be7f185b7f$var$ID_KEY];
}
function $8e4081be7f185b7f$var$getFields(record) {
    if ($8e4081be7f185b7f$var$ERRORS_KEY in record) return Object.keys(record).filter(function(field) {
        return field !== $8e4081be7f185b7f$var$ERRORS_KEY;
    });
    return Object.keys(record);
}
function $8e4081be7f185b7f$var$getType(record) {
    return record[$8e4081be7f185b7f$var$TYPENAME_KEY];
}
function $8e4081be7f185b7f$var$getErrors(record, storageKey) {
    var _record$ERRORS_KEY;
    return (_record$ERRORS_KEY = record[$8e4081be7f185b7f$var$ERRORS_KEY]) === null || _record$ERRORS_KEY === void 0 ? void 0 : _record$ERRORS_KEY[storageKey];
}
function $8e4081be7f185b7f$var$getValue(record, storageKey) {
    var value = record[storageKey];
    if (value && typeof value === 'object') !(!value.hasOwnProperty($8e4081be7f185b7f$var$REF_KEY) && !value.hasOwnProperty($8e4081be7f185b7f$var$REFS_KEY)) && $5Wk1R(false);
    return value;
}
function $8e4081be7f185b7f$var$hasValue(record, storageKey) {
    return storageKey in record;
}
function $8e4081be7f185b7f$var$getLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return maybeLink;
    var link = maybeLink;
    !(typeof link === 'object' && link && typeof link[$8e4081be7f185b7f$var$REF_KEY] === 'string') && $5Wk1R(false);
    return link[$8e4081be7f185b7f$var$REF_KEY];
}
function $8e4081be7f185b7f$var$hasLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return false;
    var link = maybeLink;
    return typeof link === 'object' && link && typeof link[$8e4081be7f185b7f$var$REF_KEY] === 'string';
}
function $8e4081be7f185b7f$var$getLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return links;
    !(typeof links === 'object' && Array.isArray(links[$8e4081be7f185b7f$var$REFS_KEY])) && $5Wk1R(false);
    return links[$8e4081be7f185b7f$var$REFS_KEY];
}
function $8e4081be7f185b7f$var$hasLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return false;
    return typeof links === 'object' && Array.isArray(links[$8e4081be7f185b7f$var$REFS_KEY]) && links[$8e4081be7f185b7f$var$REFS_KEY].every(function(link) {
        return typeof link === 'string';
    });
}
function $8e4081be7f185b7f$var$getInvalidationEpoch(record) {
    if (record == null) return null;
    var invalidatedAt = record[$8e4081be7f185b7f$var$INVALIDATED_AT_KEY];
    if (typeof invalidatedAt !== 'number') return null;
    return invalidatedAt;
}
function $8e4081be7f185b7f$var$update(prevRecord, nextRecord) {
    var _updated2;
    var _getType, _getType2, prevID, nextID, prevType, nextType;
    var prevErrorsByKey = prevRecord[$8e4081be7f185b7f$var$ERRORS_KEY];
    var nextErrorsByKey = nextRecord[$8e4081be7f185b7f$var$ERRORS_KEY];
    var updated = null;
    if (prevErrorsByKey == null && nextErrorsByKey == null) {
        var _updated;
        for(var storageKey in nextRecord)if (updated || !$cGxFv(prevRecord[storageKey], nextRecord[storageKey])) {
            updated = updated !== null ? updated : (0, $8e4081be7f185b7f$var$_objectSpread2["default"])({}, prevRecord);
            updated[storageKey] = nextRecord[storageKey];
        }
        return (_updated = updated) !== null && _updated !== void 0 ? _updated : prevRecord;
    }
    for(var _storageKey2 in nextRecord){
        if (_storageKey2 === $8e4081be7f185b7f$var$ERRORS_KEY) continue;
        var nextValue = nextRecord[_storageKey2];
        var nextErrors = nextErrorsByKey === null || nextErrorsByKey === void 0 ? void 0 : nextErrorsByKey[_storageKey2];
        if (updated == null) {
            var prevValue = prevRecord[_storageKey2];
            var prevErrors = prevErrorsByKey === null || prevErrorsByKey === void 0 ? void 0 : prevErrorsByKey[_storageKey2];
            if ($cGxFv(prevValue, nextValue) && $cGxFv(prevErrors, nextErrors)) continue;
            updated = (0, $8e4081be7f185b7f$var$_objectSpread2["default"])({}, prevRecord);
            if (prevErrorsByKey != null) updated[$8e4081be7f185b7f$var$ERRORS_KEY] = (0, $8e4081be7f185b7f$var$_objectSpread2["default"])({}, prevErrorsByKey);
        }
        $8e4081be7f185b7f$var$setValue(updated, _storageKey2, nextValue);
        $8e4081be7f185b7f$var$setErrors(updated, _storageKey2, nextErrors);
    }
    return (_updated2 = updated) !== null && _updated2 !== void 0 ? _updated2 : prevRecord;
}
function $8e4081be7f185b7f$var$merge(record1, record2) {
    var _getType3, _getType4, prevID, nextID, prevType, nextType;
    if ($8e4081be7f185b7f$var$ERRORS_KEY in record1 || $8e4081be7f185b7f$var$ERRORS_KEY in record2) {
        var errors1 = record1[$8e4081be7f185b7f$var$ERRORS_KEY], fields1 = (0, $8e4081be7f185b7f$var$_objectWithoutPropertiesLoose2["default"])(record1, [
            $8e4081be7f185b7f$var$ERRORS_KEY
        ].map($8e4081be7f185b7f$var$_toPropertyKey2["default"]));
        var errors2 = record2[$8e4081be7f185b7f$var$ERRORS_KEY], fields2 = (0, $8e4081be7f185b7f$var$_objectWithoutPropertiesLoose2["default"])(record2, [
            $8e4081be7f185b7f$var$ERRORS_KEY
        ].map($8e4081be7f185b7f$var$_toPropertyKey2["default"]));
        var updated = (0, $8e4081be7f185b7f$var$_objectSpread2["default"])((0, $8e4081be7f185b7f$var$_objectSpread2["default"])({}, fields1), fields2);
        if (errors1 == null && errors2 == null) return updated;
        var updatedErrors = {};
        for(var storageKey in errors1){
            if (fields2.hasOwnProperty(storageKey)) continue;
            updatedErrors[storageKey] = errors1[storageKey];
        }
        for(var _storageKey3 in errors2)updatedErrors[_storageKey3] = errors2[_storageKey3];
        for(var _storageKey in updatedErrors){
            updated[$8e4081be7f185b7f$var$ERRORS_KEY] = updatedErrors;
            break;
        }
        return updated;
    } else return (0, $8e4081be7f185b7f$var$_objectSpread2["default"])((0, $8e4081be7f185b7f$var$_objectSpread2["default"])({}, record1), record2);
}
function $8e4081be7f185b7f$var$freeze(record) {
    $a9DXr(record);
}
function $8e4081be7f185b7f$var$setErrors(record, storageKey, errors) {
    var errorsByStorageKey = record[$8e4081be7f185b7f$var$ERRORS_KEY];
    if (errors != null && errors.length > 0) {
        if (errorsByStorageKey == null) record[$8e4081be7f185b7f$var$ERRORS_KEY] = (0, $8e4081be7f185b7f$var$_defineProperty2["default"])({}, storageKey, errors);
        else errorsByStorageKey[storageKey] = errors;
    } else if (errorsByStorageKey != null) {
        if (delete errorsByStorageKey[storageKey]) {
            for(var otherStorageKey in errorsByStorageKey){
                if (errorsByStorageKey.hasOwnProperty(otherStorageKey)) return;
            }
            delete record[$8e4081be7f185b7f$var$ERRORS_KEY];
        }
    }
}
function $8e4081be7f185b7f$var$setValue(record, storageKey, value) {
    var prevID, _getType5, prevType, nextType;
    record[storageKey] = value;
}
function $8e4081be7f185b7f$var$setLinkedRecordID(record, storageKey, linkedID) {
    var link = {};
    link[$8e4081be7f185b7f$var$REF_KEY] = linkedID;
    record[storageKey] = link;
}
function $8e4081be7f185b7f$var$setLinkedRecordIDs(record, storageKey, linkedIDs) {
    var links = {};
    links[$8e4081be7f185b7f$var$REFS_KEY] = linkedIDs;
    record[storageKey] = links;
}
function $8e4081be7f185b7f$var$setActorLinkedRecordID(record, storageKey, actorIdentifier, linkedID) {
    var link = {};
    link[$8e4081be7f185b7f$var$REF_KEY] = linkedID;
    link[$8e4081be7f185b7f$var$ACTOR_IDENTIFIER_KEY] = actorIdentifier;
    record[storageKey] = link;
}
function $8e4081be7f185b7f$var$getActorLinkedRecordID(record, storageKey) {
    var link = record[storageKey];
    if (link == null) return link;
    !(typeof link === 'object' && typeof link[$8e4081be7f185b7f$var$REF_KEY] === 'string' && link[$8e4081be7f185b7f$var$ACTOR_IDENTIFIER_KEY] != null) && $5Wk1R(false);
    return [
        link[$8e4081be7f185b7f$var$ACTOR_IDENTIFIER_KEY],
        link[$8e4081be7f185b7f$var$REF_KEY]
    ];
}
function $8e4081be7f185b7f$var$getResolverLinkedRecordID(record, typeName) {
    var id = $8e4081be7f185b7f$var$getValue(record, $8e4081be7f185b7f$var$RELAY_RESOLVER_VALUE_KEY);
    if (id == null || $8e4081be7f185b7f$var$isSuspenseSentinel(id)) return null;
    if (typeof id === 'object') id = id.id;
    !(typeof id === 'string') && $5Wk1R(false);
    return $8e4081be7f185b7f$var$generateClientObjectClientID(typeName, id);
}
function $8e4081be7f185b7f$var$getResolverLinkedRecordIDs(record, typeName) {
    var resolverValue = $8e4081be7f185b7f$var$getValue(record, $8e4081be7f185b7f$var$RELAY_RESOLVER_VALUE_KEY);
    if (resolverValue == null || $8e4081be7f185b7f$var$isSuspenseSentinel(resolverValue)) return null;
    !Array.isArray(resolverValue) && $5Wk1R(false);
    return resolverValue.map(function(id) {
        if (id == null) return null;
        if (typeof id === 'object') id = id.id;
        !(typeof id === 'string') && $5Wk1R(false);
        return $8e4081be7f185b7f$var$generateClientObjectClientID(typeName, id);
    });
}
function $8e4081be7f185b7f$var$toJSON(record) {
    return record;
}
module.exports = {
    clone: $8e4081be7f185b7f$var$clone,
    copyFields: $8e4081be7f185b7f$var$copyFields,
    create: $8e4081be7f185b7f$var$create,
    freeze: $8e4081be7f185b7f$var$freeze,
    fromObject: $8e4081be7f185b7f$var$fromObject,
    getDataID: $8e4081be7f185b7f$var$getDataID,
    getErrors: $8e4081be7f185b7f$var$getErrors,
    getFields: $8e4081be7f185b7f$var$getFields,
    getInvalidationEpoch: $8e4081be7f185b7f$var$getInvalidationEpoch,
    getLinkedRecordID: $8e4081be7f185b7f$var$getLinkedRecordID,
    getLinkedRecordIDs: $8e4081be7f185b7f$var$getLinkedRecordIDs,
    getType: $8e4081be7f185b7f$var$getType,
    getValue: $8e4081be7f185b7f$var$getValue,
    hasValue: $8e4081be7f185b7f$var$hasValue,
    hasLinkedRecordID: $8e4081be7f185b7f$var$hasLinkedRecordID,
    hasLinkedRecordIDs: $8e4081be7f185b7f$var$hasLinkedRecordIDs,
    merge: $8e4081be7f185b7f$var$merge,
    setErrors: $8e4081be7f185b7f$var$setErrors,
    setValue: $8e4081be7f185b7f$var$setValue,
    setLinkedRecordID: $8e4081be7f185b7f$var$setLinkedRecordID,
    setLinkedRecordIDs: $8e4081be7f185b7f$var$setLinkedRecordIDs,
    update: $8e4081be7f185b7f$var$update,
    getActorLinkedRecordID: $8e4081be7f185b7f$var$getActorLinkedRecordID,
    setActorLinkedRecordID: $8e4081be7f185b7f$var$setActorLinkedRecordID,
    getResolverLinkedRecordID: $8e4081be7f185b7f$var$getResolverLinkedRecordID,
    getResolverLinkedRecordIDs: $8e4081be7f185b7f$var$getResolverLinkedRecordIDs,
    toJSON: $8e4081be7f185b7f$var$toJSON
};

});
parcelRegister("4erYc", function(module, exports) {
function $314e2a7f95a66439$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $314e2a7f95a66439$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("qckAk", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $04ebfe8161b7c75d$var$_interopRequireDefault = $bGHxy.default;

var $04ebfe8161b7c75d$var$_createForOfIteratorHelper2 = $04ebfe8161b7c75d$var$_interopRequireDefault((parcelRequire("cXbK5")));

var $cdcDZ = parcelRequire("cdcDZ");

var $1KM42 = parcelRequire("1KM42");
var $04ebfe8161b7c75d$var$EXISTENT = $1KM42.EXISTENT, $04ebfe8161b7c75d$var$NONEXISTENT = $1KM42.NONEXISTENT, $04ebfe8161b7c75d$var$UNKNOWN = $1KM42.UNKNOWN;
var $04ebfe8161b7c75d$var$RelayRecordSource = /*#__PURE__*/ function() {
    function RelayRecordSource(records) {
        var _this = this;
        this._records = new Map();
        if (records != null) Object.keys(records).forEach(function(key) {
            var object = records[key];
            var record = $cdcDZ.fromObject(object);
            _this._records.set(key, record);
        });
    }
    RelayRecordSource.create = function create(records) {
        return new RelayRecordSource(records);
    };
    var _proto = RelayRecordSource.prototype;
    _proto.clear = function clear() {
        this._records = new Map();
    };
    _proto["delete"] = function _delete(dataID) {
        this._records.set(dataID, null);
    };
    _proto.get = function get(dataID) {
        return this._records.get(dataID);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Array.from(this._records.keys());
    };
    _proto.getStatus = function getStatus(dataID) {
        if (!this._records.has(dataID)) return $04ebfe8161b7c75d$var$UNKNOWN;
        return this._records.get(dataID) == null ? $04ebfe8161b7c75d$var$NONEXISTENT : $04ebfe8161b7c75d$var$EXISTENT;
    };
    _proto.has = function has(dataID) {
        return this._records.has(dataID);
    };
    _proto.remove = function remove(dataID) {
        this._records["delete"](dataID);
    };
    _proto.set = function set(dataID, record) {
        this._records.set(dataID, record);
    };
    _proto.size = function size() {
        return this._records.size;
    };
    _proto.toJSON = function toJSON() {
        var obj = {};
        var _iterator = (0, $04ebfe8161b7c75d$var$_createForOfIteratorHelper2["default"])(this._records), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = _step.value, key = _step$value[0], record = _step$value[1];
                obj[key] = $cdcDZ.toJSON(record);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return obj;
    };
    return RelayRecordSource;
}();
module.exports = $04ebfe8161b7c75d$var$RelayRecordSource;

});
parcelRegister("1KM42", function(module, exports) {
'use strict';
var $146f5eddb81c940d$var$RelayRecordState = {
    EXISTENT: 'EXISTENT',
    NONEXISTENT: 'NONEXISTENT',
    UNKNOWN: 'UNKNOWN'
};
module.exports = $146f5eddb81c940d$var$RelayRecordState;

});


parcelRegister("3U9zg", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $2d7e060192bb1b97$var$_interopRequireDefault = $bGHxy.default;

var $2d7e060192bb1b97$var$_createForOfIteratorHelper2 = $2d7e060192bb1b97$var$_interopRequireDefault((parcelRequire("cXbK5")));

var $2d7e060192bb1b97$var$_toConsumableArray2 = $2d7e060192bb1b97$var$_interopRequireDefault((parcelRequire("kTVTn")));

var $fc0ND = parcelRequire("fc0ND");
var $2d7e060192bb1b97$var$ACTOR_IDENTIFIER_FIELD_NAME = $fc0ND.ACTOR_IDENTIFIER_FIELD_NAME, $2d7e060192bb1b97$var$getActorIdentifierFromPayload = $fc0ND.getActorIdentifierFromPayload;

var $3hqjB = parcelRequire("3hqjB");

var $fJ2hT = parcelRequire("fJ2hT");
var $2d7e060192bb1b97$var$generateClientID = $fJ2hT.generateClientID, $2d7e060192bb1b97$var$isClientID = $fJ2hT.isClientID;

var $gQ9aH = parcelRequire("gQ9aH");
var $2d7e060192bb1b97$var$getLocalVariables = $gQ9aH.getLocalVariables;

var $2uF1G = parcelRequire("2uF1G");
var $2d7e060192bb1b97$var$buildErrorTrie = $2uF1G.buildErrorTrie, $2d7e060192bb1b97$var$getErrorsByKey = $2uF1G.getErrorsByKey, $2d7e060192bb1b97$var$getNestedErrorTrieByKey = $2uF1G.getNestedErrorTrieByKey;

var $cdcDZ = parcelRequire("cdcDZ");

var $dTSGA = parcelRequire("dTSGA");
var $2d7e060192bb1b97$var$createNormalizationSelector = $dTSGA.createNormalizationSelector;

var $5vBPt = parcelRequire("5vBPt");
var $2d7e060192bb1b97$var$ROOT_ID = $5vBPt.ROOT_ID, $2d7e060192bb1b97$var$TYPENAME_KEY = $5vBPt.TYPENAME_KEY, $2d7e060192bb1b97$var$getArgumentValues = $5vBPt.getArgumentValues, $2d7e060192bb1b97$var$getHandleStorageKey = $5vBPt.getHandleStorageKey, $2d7e060192bb1b97$var$getModuleComponentKey = $5vBPt.getModuleComponentKey, $2d7e060192bb1b97$var$getModuleOperationKey = $5vBPt.getModuleOperationKey, $2d7e060192bb1b97$var$getStorageKey = $5vBPt.getStorageKey;

var $h3ajd = parcelRequire("h3ajd");
var $2d7e060192bb1b97$var$TYPE_SCHEMA_TYPE = $h3ajd.TYPE_SCHEMA_TYPE, $2d7e060192bb1b97$var$generateTypeID = $h3ajd.generateTypeID;
parcelRequire("cGxFv");

var $5Wk1R = parcelRequire("5Wk1R");
parcelRequire("91yGl");
function $2d7e060192bb1b97$var$normalize(recordSource, selector, response, options, errors, useExecTimeResolvers) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var normalizer = new $2d7e060192bb1b97$var$RelayResponseNormalizer(recordSource, variables, options, useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false);
    return normalizer.normalizeResponse(node, dataID, response, errors);
}
var $2d7e060192bb1b97$var$RelayResponseNormalizer = /*#__PURE__*/ function() {
    function RelayResponseNormalizer(recordSource, variables, options, useExecTimeResolvers) {
        this._actorIdentifier = options.actorIdentifier;
        this._getDataId = options.getDataID;
        this._handleFieldPayloads = [];
        this._treatMissingFieldsAsNull = options.treatMissingFieldsAsNull;
        this._incrementalPlaceholders = [];
        this._isClientExtension = false;
        this._isUnmatchedAbstractType = false;
        this._useExecTimeResolvers = useExecTimeResolvers;
        this._followupPayloads = [];
        this._path = options.path ? (0, $2d7e060192bb1b97$var$_toConsumableArray2["default"])(options.path) : [];
        this._recordSource = recordSource;
        this._variables = variables;
        this._shouldProcessClientComponents = options.shouldProcessClientComponents;
        this._log = options.log;
    }
    var _proto = RelayResponseNormalizer.prototype;
    _proto.normalizeResponse = function normalizeResponse(node, dataID, data, errors) {
        var record = this._recordSource.get(dataID);
        !record && $5Wk1R(false);
        this._assignClientAbstractTypes(node);
        this._errorTrie = $2d7e060192bb1b97$var$buildErrorTrie(errors);
        this._traverseSelections(node, record, data);
        return {
            errors: errors,
            fieldPayloads: this._handleFieldPayloads,
            incrementalPlaceholders: this._incrementalPlaceholders,
            followupPayloads: this._followupPayloads,
            source: this._recordSource,
            isFinal: false
        };
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator = (0, $2d7e060192bb1b97$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var concreteType = _step.value;
                    var typeID = $2d7e060192bb1b97$var$generateTypeID(concreteType);
                    var typeRecord = this._recordSource.get(typeID);
                    if (typeRecord == null) {
                        typeRecord = $cdcDZ.create(typeID, $2d7e060192bb1b97$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(typeID, typeRecord);
                    }
                    $cdcDZ.setValue(typeRecord, abstractType, true);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $5Wk1R(false);
        return this._variables[name];
    };
    _proto._getRecordType = function _getRecordType(data) {
        var typeName = data[$2d7e060192bb1b97$var$TYPENAME_KEY];
        !(typeName != null) && $5Wk1R(false);
        return typeName;
    };
    _proto._traverseSelections = function _traverseSelections(node, record, data) {
        for(var i = 0; i < node.selections.length; i++){
            var selection = node.selections[i];
            switch(selection.kind){
                case 'ScalarField':
                case 'LinkedField':
                    this._normalizeField(selection, record, data);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) this._traverseSelections(selection, record, data);
                    break;
                case 'FragmentSpread':
                    var prevVariables = this._variables;
                    this._variables = $2d7e060192bb1b97$var$getLocalVariables(this._variables, selection.fragment.argumentDefinitions, selection.args);
                    this._traverseSelections(selection.fragment, record, data);
                    this._variables = prevVariables;
                    break;
                case 'InlineFragment':
                    var abstractKey = selection.abstractKey;
                    if (abstractKey == null) {
                        var typeName = $cdcDZ.getType(record);
                        if (typeName === selection.type) this._traverseSelections(selection, record, data);
                    } else {
                        var implementsInterface = Object.prototype.hasOwnProperty.call(data, abstractKey);
                        var _typeName = $cdcDZ.getType(record);
                        var typeID = $2d7e060192bb1b97$var$generateTypeID(_typeName);
                        var typeRecord = this._recordSource.get(typeID);
                        if (typeRecord == null) {
                            typeRecord = $cdcDZ.create(typeID, $2d7e060192bb1b97$var$TYPE_SCHEMA_TYPE);
                            this._recordSource.set(typeID, typeRecord);
                        }
                        $cdcDZ.setValue(typeRecord, abstractKey, implementsInterface);
                        if (implementsInterface) this._traverseSelections(selection, record, data);
                    }
                    break;
                case 'TypeDiscriminator':
                    var _abstractKey = selection.abstractKey;
                    var _implementsInterface = Object.prototype.hasOwnProperty.call(data, _abstractKey);
                    var _typeName2 = $cdcDZ.getType(record);
                    var _typeID = $2d7e060192bb1b97$var$generateTypeID(_typeName2);
                    var _typeRecord = this._recordSource.get(_typeID);
                    if (_typeRecord == null) {
                        _typeRecord = $cdcDZ.create(_typeID, $2d7e060192bb1b97$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(_typeID, _typeRecord);
                    }
                    $cdcDZ.setValue(_typeRecord, _abstractKey, _implementsInterface);
                    break;
                case 'LinkedHandle':
                case 'ScalarHandle':
                    var args = selection.args ? $2d7e060192bb1b97$var$getArgumentValues(selection.args, this._variables) : {};
                    var fieldKey = $2d7e060192bb1b97$var$getStorageKey(selection, this._variables);
                    var handleKey = $2d7e060192bb1b97$var$getHandleStorageKey(selection, this._variables);
                    this._handleFieldPayloads.push({
                        args: args,
                        dataID: $cdcDZ.getDataID(record),
                        fieldKey: fieldKey,
                        handle: selection.handle,
                        handleKey: handleKey,
                        handleArgs: selection.handleArgs ? $2d7e060192bb1b97$var$getArgumentValues(selection.handleArgs, this._variables) : {}
                    });
                    break;
                case 'ModuleImport':
                    this._normalizeModuleImport(selection, record, data);
                    break;
                case 'Defer':
                    this._normalizeDefer(selection, record, data);
                    break;
                case 'Stream':
                    this._normalizeStream(selection, record, data);
                    break;
                case 'ClientExtension':
                    var isClientExtension = this._isClientExtension;
                    this._isClientExtension = true;
                    this._traverseSelections(selection, record, data);
                    this._isClientExtension = isClientExtension;
                    break;
                case 'ClientComponent':
                    if (this._shouldProcessClientComponents === false) break;
                    this._traverseSelections(selection.fragment, record, data);
                    break;
                case 'ActorChange':
                    this._normalizeActorChange(selection, record, data);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    if (!this._useExecTimeResolvers) this._normalizeResolver(selection, record, data);
                    break;
                case 'ClientEdgeToClientObject':
                    if (!this._useExecTimeResolvers) this._normalizeResolver(selection.backingField, record, data);
                    break;
                default:
                    selection;
                    $5Wk1R(false);
            }
        }
    };
    _proto._normalizeResolver = function _normalizeResolver(resolver, record, data) {
        if (resolver.fragment != null) this._traverseSelections(resolver.fragment, record, data);
    };
    _proto._normalizeDefer = function _normalizeDefer(defer, record, data) {
        var isDeferred = defer["if"] === null || this._getVariableValue(defer["if"]);
        if (isDeferred === false) this._traverseSelections(defer, record, data);
        else this._incrementalPlaceholders.push({
            kind: 'defer',
            data: data,
            label: defer.label,
            path: (0, $2d7e060192bb1b97$var$_toConsumableArray2["default"])(this._path),
            selector: $2d7e060192bb1b97$var$createNormalizationSelector(defer, $cdcDZ.getDataID(record), this._variables),
            typeName: $cdcDZ.getType(record),
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeStream = function _normalizeStream(stream, record, data) {
        this._traverseSelections(stream, record, data);
        var isStreamed = stream["if"] === null || this._getVariableValue(stream["if"]);
        if (isStreamed === true) this._incrementalPlaceholders.push({
            kind: 'stream',
            label: stream.label,
            path: (0, $2d7e060192bb1b97$var$_toConsumableArray2["default"])(this._path),
            parentID: $cdcDZ.getDataID(record),
            node: stream,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeModuleImport = function _normalizeModuleImport(moduleImport, record, data) {
        !(typeof data === 'object' && data) && $5Wk1R(false);
        var typeName = $cdcDZ.getType(record);
        var componentKey = $2d7e060192bb1b97$var$getModuleComponentKey(moduleImport.documentName);
        var componentReference = moduleImport.componentModuleProvider || data[componentKey];
        $cdcDZ.setValue(record, componentKey, componentReference !== null && componentReference !== void 0 ? componentReference : null);
        var operationKey = $2d7e060192bb1b97$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = moduleImport.operationModuleProvider || data[operationKey];
        $cdcDZ.setValue(record, operationKey, operationReference !== null && operationReference !== void 0 ? operationReference : null);
        if (operationReference != null) this._followupPayloads.push({
            kind: 'ModuleImportPayload',
            args: moduleImport.args,
            data: data,
            dataID: $cdcDZ.getDataID(record),
            operationReference: operationReference,
            path: (0, $2d7e060192bb1b97$var$_toConsumableArray2["default"])(this._path),
            typeName: typeName,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeField = function _normalizeField(selection, record, data) {
        !(typeof data === 'object' && data) && $5Wk1R(false);
        var responseKey = selection.alias || selection.name;
        var storageKey = $2d7e060192bb1b97$var$getStorageKey(selection, this._variables);
        var fieldValue = data[responseKey];
        var isNoncompliantlyNullish = $3hqjB.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(fieldValue) && fieldValue.length === 0;
        if (fieldValue == null || isNoncompliantlyNullish) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            if (selection.kind === 'ScalarField') this._validateConflictingFieldsWithIdenticalId(record, storageKey, null);
            if (isNoncompliantlyNullish) {
                if (selection.kind === 'LinkedField') $cdcDZ.setLinkedRecordIDs(record, storageKey, []);
                else $cdcDZ.setValue(record, storageKey, []);
            } else $cdcDZ.setValue(record, storageKey, null);
            var errorTrie = this._errorTrie;
            if (errorTrie != null) {
                var errors = $2d7e060192bb1b97$var$getErrorsByKey(errorTrie, responseKey);
                if (errors != null) $cdcDZ.setErrors(record, storageKey, errors);
            }
            return;
        }
        if (selection.kind === 'ScalarField') {
            this._validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue);
            $cdcDZ.setValue(record, storageKey, fieldValue);
        } else if (selection.kind === 'LinkedField') {
            this._path.push(responseKey);
            var oldErrorTrie = this._errorTrie;
            this._errorTrie = oldErrorTrie == null ? null : $2d7e060192bb1b97$var$getNestedErrorTrieByKey(oldErrorTrie, responseKey);
            if (selection.plural) this._normalizePluralLink(selection, record, storageKey, fieldValue);
            else this._normalizeLink(selection, record, storageKey, fieldValue);
            this._errorTrie = oldErrorTrie;
            this._path.pop();
        } else {
            selection;
            $5Wk1R(false);
        }
    };
    _proto._normalizeActorChange = function _normalizeActorChange(selection, record, data) {
        var _field$concreteType;
        var field = selection.linkedField;
        !(typeof data === 'object' && data) && $5Wk1R(false);
        var responseKey = field.alias || field.name;
        var storageKey = $2d7e060192bb1b97$var$getStorageKey(field, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $cdcDZ.setValue(record, storageKey, null);
            return;
        }
        var actorIdentifier = $2d7e060192bb1b97$var$getActorIdentifierFromPayload(fieldValue);
        if (actorIdentifier == null) {
            $cdcDZ.setValue(record, storageKey, null);
            return;
        }
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : this._getRecordType(fieldValue);
        var nextID = this._getDataId(fieldValue, typeName) || $cdcDZ.getLinkedRecordID(record, storageKey) || $2d7e060192bb1b97$var$generateClientID($cdcDZ.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $5Wk1R(false);
        $cdcDZ.setActorLinkedRecordID(record, storageKey, actorIdentifier, nextID);
        this._followupPayloads.push({
            kind: 'ActorPayload',
            data: fieldValue,
            dataID: nextID,
            path: [].concat((0, $2d7e060192bb1b97$var$_toConsumableArray2["default"])(this._path), [
                responseKey
            ]),
            typeName: typeName,
            variables: this._variables,
            node: field,
            actorIdentifier: actorIdentifier
        });
    };
    _proto._normalizeLink = function _normalizeLink(field, record, storageKey, fieldValue) {
        var _field$concreteType2;
        !(typeof fieldValue === 'object' && fieldValue) && $5Wk1R(false);
        var nextID = this._getDataId(fieldValue, (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : this._getRecordType(fieldValue)) || $cdcDZ.getLinkedRecordID(record, storageKey) || $2d7e060192bb1b97$var$generateClientID($cdcDZ.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $5Wk1R(false);
        this._validateConflictingLinkedFieldsWithIdenticalId($cdcDZ.getLinkedRecordID(record, storageKey), nextID, storageKey);
        $cdcDZ.setLinkedRecordID(record, storageKey, nextID);
        var nextRecord = this._recordSource.get(nextID);
        if (!nextRecord) {
            var typeName = field.concreteType || this._getRecordType(fieldValue);
            nextRecord = $cdcDZ.create(nextID, typeName);
            this._recordSource.set(nextID, nextRecord);
        } else this._validateRecordType(nextRecord, field, fieldValue);
        this._traverseSelections(field, nextRecord, fieldValue);
    };
    _proto._normalizePluralLink = function _normalizePluralLink(field, record, storageKey, fieldValue) {
        var _this = this;
        !Array.isArray(fieldValue) && $5Wk1R(false);
        var prevIDs = $cdcDZ.getLinkedRecordIDs(record, storageKey);
        var nextIDs = [];
        fieldValue.forEach(function(item, nextIndex) {
            var _field$concreteType3;
            if (item == null) {
                nextIDs.push(item);
                return;
            }
            _this._path.push(String(nextIndex));
            var oldErrorTrie = _this._errorTrie;
            _this._errorTrie = oldErrorTrie == null ? null : $2d7e060192bb1b97$var$getNestedErrorTrieByKey(oldErrorTrie, nextIndex);
            !(typeof item === 'object') && $5Wk1R(false);
            var nextID = _this._getDataId(item, (_field$concreteType3 = field.concreteType) !== null && _field$concreteType3 !== void 0 ? _field$concreteType3 : _this._getRecordType(item)) || prevIDs && prevIDs[nextIndex] || $2d7e060192bb1b97$var$generateClientID($cdcDZ.getDataID(record), storageKey, nextIndex);
            !(typeof nextID === 'string') && $5Wk1R(false);
            nextIDs.push(nextID);
            var nextRecord = _this._recordSource.get(nextID);
            if (!nextRecord) {
                var typeName = field.concreteType || _this._getRecordType(item);
                nextRecord = $cdcDZ.create(nextID, typeName);
                _this._recordSource.set(nextID, nextRecord);
            } else _this._validateRecordType(nextRecord, field, item);
            if (prevIDs) _this._validateConflictingLinkedFieldsWithIdenticalId(prevIDs[nextIndex], nextID, storageKey);
            _this._traverseSelections(field, nextRecord, item);
            _this._errorTrie = oldErrorTrie;
            _this._path.pop();
        });
        $cdcDZ.setLinkedRecordIDs(record, storageKey, nextIDs);
    };
    _proto._validateRecordType = function _validateRecordType(record, field, payload) {
        if ($3hqjB.ENABLE_STORE_ID_COLLISION_LOGGING) {
            var _field$concreteType4;
            var typeName = (_field$concreteType4 = field.concreteType) !== null && _field$concreteType4 !== void 0 ? _field$concreteType4 : this._getRecordType(payload);
            var dataID = $cdcDZ.getDataID(record);
            var expected = $2d7e060192bb1b97$var$isClientID(dataID) && dataID !== $2d7e060192bb1b97$var$ROOT_ID || $cdcDZ.getType(record) === typeName;
            if (!expected) {
                var logEvent = {
                    name: 'idCollision.typename',
                    previous_typename: $cdcDZ.getType(record),
                    new_typename: typeName
                };
                if (this._log != null) this._log(logEvent);
            }
        }
        var _field$concreteType5, _typeName3, _dataID, _expected;
    };
    _proto._validateConflictingFieldsWithIdenticalId = function _validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue) {
        var previousValue, dataID, expected;
    };
    _proto._validateConflictingLinkedFieldsWithIdenticalId = function _validateConflictingLinkedFieldsWithIdenticalId(prevID, nextID, storageKey) {
        var expected;
    };
    return RelayResponseNormalizer;
}();
module.exports = {
    normalize: $2d7e060192bb1b97$var$normalize
};

});
parcelRegister("fc0ND", function(module, exports) {
'use strict';
var $b0f898c1e544dfa8$var$ACTOR_IDENTIFIER_FIELD_NAME = 'actor_key';

var $1umzp = parcelRequire("1umzp");
var $b0f898c1e544dfa8$var$getActorIdentifier = $1umzp.getActorIdentifier;
function $b0f898c1e544dfa8$var$getActorIdentifierFromPayload(payload) {
    if (payload != null && typeof payload === 'object' && typeof payload[$b0f898c1e544dfa8$var$ACTOR_IDENTIFIER_FIELD_NAME] === 'string') return $b0f898c1e544dfa8$var$getActorIdentifier(payload[$b0f898c1e544dfa8$var$ACTOR_IDENTIFIER_FIELD_NAME]);
}
module.exports = {
    ACTOR_IDENTIFIER_FIELD_NAME: $b0f898c1e544dfa8$var$ACTOR_IDENTIFIER_FIELD_NAME,
    getActorIdentifierFromPayload: $b0f898c1e544dfa8$var$getActorIdentifierFromPayload
};

});
parcelRegister("1umzp", function(module, exports) {
'use strict';

var $5Wk1R = parcelRequire("5Wk1R");
var $115a19b761402861$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = 'INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE';
function $115a19b761402861$var$assertInternalActorIdentifier(actorIdentifier) {
    !(actorIdentifier === $115a19b761402861$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE) && $5Wk1R(false);
}
module.exports = {
    assertInternalActorIdentifier: $115a19b761402861$var$assertInternalActorIdentifier,
    getActorIdentifier: function getActorIdentifier(actorID) {
        return actorID;
    },
    getDefaultActorIdentifier: function getDefaultActorIdentifier() {
        throw new Error('Not Implemented');
    },
    INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE: $115a19b761402861$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE
};

});


parcelRegister("2uF1G", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $1d0e350b61b3792e$var$_interopRequireDefault = $bGHxy.default;

var $1d0e350b61b3792e$var$_objectSpread2 = $1d0e350b61b3792e$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $1d0e350b61b3792e$var$_objectWithoutPropertiesLoose2 = $1d0e350b61b3792e$var$_interopRequireDefault((parcelRequire("4erYc")));

var $1d0e350b61b3792e$var$_createForOfIteratorHelper2 = $1d0e350b61b3792e$var$_interopRequireDefault((parcelRequire("cXbK5")));

var $1d0e350b61b3792e$var$_toConsumableArray2 = $1d0e350b61b3792e$var$_interopRequireDefault((parcelRequire("kTVTn")));
var $1d0e350b61b3792e$var$_excluded = [
    "path",
    "locations"
];
var $1d0e350b61b3792e$var$SELF = Symbol('$SELF');
function $1d0e350b61b3792e$var$buildErrorTrie(errors) {
    if (errors == null) return null;
    var trie = new Map();
    var _iterator = (0, $1d0e350b61b3792e$var$_createForOfIteratorHelper2["default"])(errors), _step;
    try {
        ERRORS: for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, path = _step$value.path, _ = _step$value.locations, error = (0, $1d0e350b61b3792e$var$_objectWithoutPropertiesLoose2["default"])(_step$value, $1d0e350b61b3792e$var$_excluded);
            if (path == null) continue;
            var length = path.length;
            if (length === 0) continue;
            var lastIndex = length - 1;
            var currentTrie = trie;
            for(var index = 0; index < lastIndex; index++){
                var key = path[index];
                var existingValue = currentTrie.get(key);
                if (existingValue instanceof Map) {
                    currentTrie = existingValue;
                    continue;
                }
                var newValue = new Map();
                if (Array.isArray(existingValue)) newValue.set($1d0e350b61b3792e$var$SELF, existingValue);
                currentTrie.set(key, newValue);
                currentTrie = newValue;
            }
            var lastKey = path[lastIndex];
            var container = currentTrie.get(lastKey);
            if (container instanceof Map) {
                currentTrie = container;
                container = currentTrie.get(lastKey);
                lastKey = $1d0e350b61b3792e$var$SELF;
            }
            if (Array.isArray(container)) container.push(error);
            else currentTrie.set(lastKey, [
                error
            ]);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return trie;
}
function $1d0e350b61b3792e$var$getErrorsByKey(trie, key) {
    var value = trie.get(key);
    if (value == null) return null;
    if (Array.isArray(value)) return value;
    var errors = [];
    $1d0e350b61b3792e$var$recursivelyCopyErrorsIntoArray(value, errors);
    return errors;
}
function $1d0e350b61b3792e$var$recursivelyCopyErrorsIntoArray(trieOrSet, errors) {
    var _iterator2 = (0, $1d0e350b61b3792e$var$_createForOfIteratorHelper2["default"])(trieOrSet), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _step2$value = _step2.value, childKey = _step2$value[0], value = _step2$value[1];
            var oldLength = errors.length;
            if (Array.isArray(value)) errors.push.apply(errors, (0, $1d0e350b61b3792e$var$_toConsumableArray2["default"])(value));
            else $1d0e350b61b3792e$var$recursivelyCopyErrorsIntoArray(value, errors);
            if (childKey === $1d0e350b61b3792e$var$SELF) continue;
            var newLength = errors.length;
            for(var index = oldLength; index < newLength; index++){
                var error = errors[index];
                if (error.path == null) errors[index] = (0, $1d0e350b61b3792e$var$_objectSpread2["default"])((0, $1d0e350b61b3792e$var$_objectSpread2["default"])({}, error), {}, {
                    path: [
                        childKey
                    ]
                });
                else error.path.unshift(childKey);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $1d0e350b61b3792e$var$getNestedErrorTrieByKey(trie, key) {
    var value = trie.get(key);
    if (value instanceof Map) return value;
    return null;
}
module.exports = {
    SELF: $1d0e350b61b3792e$var$SELF,
    buildErrorTrie: $1d0e350b61b3792e$var$buildErrorTrie,
    getNestedErrorTrieByKey: $1d0e350b61b3792e$var$getNestedErrorTrieByKey,
    getErrorsByKey: $1d0e350b61b3792e$var$getErrorsByKey
};

});

parcelRegister("h3ajd", function(module, exports) {
'use strict';
var $c69ab69bb5cb428c$var$PREFIX = 'client:__type:';
var $c69ab69bb5cb428c$var$TYPE_SCHEMA_TYPE = '__TypeSchema';
function $c69ab69bb5cb428c$var$generateTypeID(typeName) {
    return $c69ab69bb5cb428c$var$PREFIX + typeName;
}
function $c69ab69bb5cb428c$var$isTypeID(id) {
    return id.indexOf($c69ab69bb5cb428c$var$PREFIX) === 0;
}
module.exports = {
    generateTypeID: $c69ab69bb5cb428c$var$generateTypeID,
    isTypeID: $c69ab69bb5cb428c$var$isTypeID,
    TYPE_SCHEMA_TYPE: $c69ab69bb5cb428c$var$TYPE_SCHEMA_TYPE
};

});



parcelRegister("cx0Ds", function(module, exports) {
'use strict';

var $5AvhW = parcelRequire("5AvhW");
var $91f90f49206f0786$var$getInlineDataFragment = $5AvhW.getInlineDataFragment;

var $5vBPt = parcelRequire("5vBPt");
var $91f90f49206f0786$var$FRAGMENTS_KEY = $5vBPt.FRAGMENTS_KEY;

var $5Wk1R = parcelRequire("5Wk1R");
function $91f90f49206f0786$var$readInlineData(fragment, fragmentRef) {
    var _fragmentRef$FRAGMENT;
    var inlineDataFragment = $91f90f49206f0786$var$getInlineDataFragment(fragment);
    if (fragmentRef == null) return fragmentRef;
    !(typeof fragmentRef === 'object') && $5Wk1R(false);
    var inlineData = (_fragmentRef$FRAGMENT = fragmentRef[$91f90f49206f0786$var$FRAGMENTS_KEY]) === null || _fragmentRef$FRAGMENT === void 0 ? void 0 : _fragmentRef$FRAGMENT[inlineDataFragment.name];
    !(inlineData != null) && $5Wk1R(false);
    return inlineData;
}
module.exports = $91f90f49206f0786$var$readInlineData;

});

parcelRegister("anr3q", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $78e109c1f8f736d0$var$_interopRequireDefault = $bGHxy.default;

var $78e109c1f8f736d0$var$_objectSpread2 = $78e109c1f8f736d0$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $cCKkj = parcelRequire("cCKkj");

var $1umzp = parcelRequire("1umzp");
var $78e109c1f8f736d0$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $1umzp.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $78e109c1f8f736d0$var$assertInternalActorIdentifier = $1umzp.assertInternalActorIdentifier;

var $u7PH0 = parcelRequire("u7PH0");

var $lPY0g = parcelRequire("lPY0g");

var $59AhP = parcelRequire("59AhP");

var $hB8AO = parcelRequire("hB8AO");

var $5kOf7 = parcelRequire("5kOf7");

var $dncWC = parcelRequire("dncWC");

var $8zzta = parcelRequire("8zzta");

var $f3EXN = parcelRequire("f3EXN");

var $gL89e = parcelRequire("gL89e");

var $d2OIe = parcelRequire("d2OIe");

var $qckAk = parcelRequire("qckAk");
parcelRequire("5Wk1R");
var $78e109c1f8f736d0$var$RelayModernEnvironment = /*#__PURE__*/ function() {
    function RelayModernEnvironment(config) {
        var _this = this;
        var _config$store, _config$log, _config$relayFieldLog, _config$UNSTABLE_defa, _config$getDataID, _config$missingFieldH, _config$handlerProvid, _config$scheduler, _config$isServer, _config$normalizeResp, _config$operationTrac;
        this.configName = config.configName;
        this._treatMissingFieldsAsNull = config.treatMissingFieldsAsNull === true;
        var operationLoader = config.operationLoader;
        var store = (_config$store = config.store) !== null && _config$store !== void 0 ? _config$store : new $gL89e(new $qckAk(), {
            log: config.log,
            operationLoader: config.operationLoader,
            getDataID: config.getDataID,
            shouldProcessClientComponents: config.shouldProcessClientComponents
        });
        this.__log = (_config$log = config.log) !== null && _config$log !== void 0 ? _config$log : $78e109c1f8f736d0$var$emptyFunction;
        this.relayFieldLogger = (_config$relayFieldLog = config.relayFieldLogger) !== null && _config$relayFieldLog !== void 0 ? _config$relayFieldLog : $dncWC;
        this._defaultRenderPolicy = (_config$UNSTABLE_defa = config.UNSTABLE_defaultRenderPolicy) !== null && _config$UNSTABLE_defa !== void 0 ? _config$UNSTABLE_defa : 'partial';
        this._operationLoader = operationLoader;
        this._operationExecutions = new Map();
        this._network = $lPY0g(this, config.network);
        this._getDataID = (_config$getDataID = config.getDataID) !== null && _config$getDataID !== void 0 ? _config$getDataID : $5kOf7;
        this._missingFieldHandlers = (_config$missingFieldH = config.missingFieldHandlers) !== null && _config$missingFieldH !== void 0 ? _config$missingFieldH : [];
        this._publishQueue = new $d2OIe(store, (_config$handlerProvid = config.handlerProvider) !== null && _config$handlerProvid !== void 0 ? _config$handlerProvid : $cCKkj, this._getDataID, this._missingFieldHandlers, this.__log);
        this._scheduler = (_config$scheduler = config.scheduler) !== null && _config$scheduler !== void 0 ? _config$scheduler : null;
        this._store = store;
        this.options = config.options;
        this._isServer = (_config$isServer = config.isServer) !== null && _config$isServer !== void 0 ? _config$isServer : false;
        this._normalizeResponse = (_config$normalizeResp = config.normalizeResponse) !== null && _config$normalizeResp !== void 0 ? _config$normalizeResp : $8zzta;
        this.__setNet = function(newNet) {
            return _this._network = $lPY0g(_this, newNet);
        };
        var _require2, inspect;
        this._operationTracker = (_config$operationTrac = config.operationTracker) !== null && _config$operationTrac !== void 0 ? _config$operationTrac : new $59AhP();
        this._shouldProcessClientComponents = config.shouldProcessClientComponents;
        $hB8AO(this);
    }
    var _proto = RelayModernEnvironment.prototype;
    _proto.getStore = function getStore() {
        return this._store;
    };
    _proto.getNetwork = function getNetwork() {
        return this._network;
    };
    _proto.getOperationTracker = function getOperationTracker() {
        return this._operationTracker;
    };
    _proto.getScheduler = function getScheduler() {
        return this._scheduler;
    };
    _proto.isRequestActive = function isRequestActive(requestIdentifier) {
        var activeState = this._operationExecutions.get(requestIdentifier);
        return activeState === 'active';
    };
    _proto.UNSTABLE_getDefaultRenderPolicy = function UNSTABLE_getDefaultRenderPolicy() {
        return this._defaultRenderPolicy;
    };
    _proto.applyUpdate = function applyUpdate(optimisticUpdate) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2._scheduleUpdates(function() {
                _this2._publishQueue.revertUpdate(optimisticUpdate);
                _this2._publishQueue.run();
            });
        };
        this._scheduleUpdates(function() {
            _this2._publishQueue.applyUpdate(optimisticUpdate);
            _this2._publishQueue.run();
        });
        return {
            dispose: dispose
        };
    };
    _proto.revertUpdate = function revertUpdate(update) {
        var _this3 = this;
        this._scheduleUpdates(function() {
            _this3._publishQueue.revertUpdate(update);
            _this3._publishQueue.run();
        });
    };
    _proto.replaceUpdate = function replaceUpdate(update, newUpdate) {
        var _this4 = this;
        this._scheduleUpdates(function() {
            _this4._publishQueue.revertUpdate(update);
            _this4._publishQueue.applyUpdate(newUpdate);
            _this4._publishQueue.run();
        });
    };
    _proto.applyMutation = function applyMutation(optimisticConfig) {
        var subscription = this._execute({
            createSource: function createSource() {
                return $u7PH0.create(function(_sink) {});
            },
            isClientPayload: false,
            operation: optimisticConfig.operation,
            optimisticConfig: optimisticConfig,
            updater: null
        }).subscribe({});
        return {
            dispose: function dispose() {
                return subscription.unsubscribe();
            }
        };
    };
    _proto.check = function check(operation) {
        if (this._missingFieldHandlers.length === 0 && !$78e109c1f8f736d0$var$operationHasClientAbstractTypes(operation)) return this._store.check(operation);
        return this._checkSelectorAndHandleMissingFields(operation, this._missingFieldHandlers);
    };
    _proto.commitPayload = function commitPayload(operation, payload) {
        this._execute({
            createSource: function createSource() {
                return $u7PH0.from({
                    data: payload
                });
            },
            isClientPayload: true,
            operation: operation,
            optimisticConfig: null,
            updater: null
        }).subscribe({});
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        var _this5 = this;
        this._scheduleUpdates(function() {
            _this5._publishQueue.commitUpdate(updater);
            _this5._publishQueue.run();
        });
    };
    _proto.lookup = function lookup(readSelector) {
        return this._store.lookup(readSelector);
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._store.subscribe(snapshot, callback);
    };
    _proto.retain = function retain(operation) {
        return this._store.retain(operation);
    };
    _proto.isServer = function isServer() {
        return this._isServer;
    };
    _proto._checkSelectorAndHandleMissingFields = function _checkSelectorAndHandleMissingFields(operation, handlers) {
        var _this6 = this;
        var target = $qckAk.create();
        var source = this._store.getSource();
        var result = this._store.check(operation, {
            handlers: handlers,
            defaultActorIdentifier: $78e109c1f8f736d0$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
            getSourceForActor: function getSourceForActor(actorIdentifier) {
                $78e109c1f8f736d0$var$assertInternalActorIdentifier(actorIdentifier);
                return source;
            },
            getTargetForActor: function getTargetForActor(actorIdentifier) {
                $78e109c1f8f736d0$var$assertInternalActorIdentifier(actorIdentifier);
                return target;
            }
        });
        if (target.size() > 0) this._scheduleUpdates(function() {
            _this6._publishQueue.commitSource(target);
            _this6._publishQueue.run();
        });
        return result;
    };
    _proto._scheduleUpdates = function _scheduleUpdates(task) {
        var scheduler = this._scheduler;
        if (scheduler != null) scheduler.schedule(task);
        else task();
    };
    _proto.execute = function execute(_ref) {
        var _this7 = this;
        var operation = _ref.operation;
        return this._execute({
            createSource: function createSource() {
                return _this7.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null, undefined, undefined, undefined, function() {
                    return _this7.check(operation);
                });
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.executeSubscription = function executeSubscription(_ref2) {
        var _this8 = this;
        var operation = _ref2.operation, updater = _ref2.updater;
        return this._execute({
            createSource: function createSource() {
                return _this8.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: updater
        });
    };
    _proto.executeMutation = function executeMutation(_ref3) {
        var _this9 = this;
        var operation = _ref3.operation, optimisticResponse = _ref3.optimisticResponse, optimisticUpdater = _ref3.optimisticUpdater, updater = _ref3.updater, uploadables = _ref3.uploadables;
        var optimisticConfig;
        if (optimisticResponse || optimisticUpdater) optimisticConfig = {
            operation: operation,
            response: optimisticResponse,
            updater: optimisticUpdater
        };
        return this._execute({
            createSource: function createSource() {
                return _this9.getNetwork().execute(operation.request.node.params, operation.request.variables, (0, $78e109c1f8f736d0$var$_objectSpread2["default"])((0, $78e109c1f8f736d0$var$_objectSpread2["default"])({}, operation.request.cacheConfig), {}, {
                    force: true
                }), uploadables);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: optimisticConfig,
            updater: updater
        });
    };
    _proto.executeWithSource = function executeWithSource(_ref4) {
        var operation = _ref4.operation, source = _ref4.source;
        return this._execute({
            createSource: function createSource() {
                return source;
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.toJSON = function toJSON() {
        var _this$configName;
        return "RelayModernEnvironment(".concat((_this$configName = this.configName) !== null && _this$configName !== void 0 ? _this$configName : '', ")");
    };
    _proto._execute = function _execute(_ref5) {
        var _this10 = this;
        var createSource = _ref5.createSource, isClientPayload = _ref5.isClientPayload, operation = _ref5.operation, optimisticConfig = _ref5.optimisticConfig, updater = _ref5.updater;
        var publishQueue = this._publishQueue;
        var store = this._store;
        return $u7PH0.create(function(sink) {
            var executor = $f3EXN.execute({
                actorIdentifier: $78e109c1f8f736d0$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
                getDataID: _this10._getDataID,
                isClientPayload: isClientPayload,
                log: _this10.__log,
                operation: operation,
                operationExecutions: _this10._operationExecutions,
                operationLoader: _this10._operationLoader,
                operationTracker: _this10._operationTracker,
                optimisticConfig: optimisticConfig,
                getPublishQueue: function getPublishQueue(actorIdentifier) {
                    $78e109c1f8f736d0$var$assertInternalActorIdentifier(actorIdentifier);
                    return publishQueue;
                },
                scheduler: _this10._scheduler,
                shouldProcessClientComponents: _this10._shouldProcessClientComponents,
                sink: sink,
                source: createSource(),
                getStore: function getStore(actorIdentifier) {
                    $78e109c1f8f736d0$var$assertInternalActorIdentifier(actorIdentifier);
                    return store;
                },
                treatMissingFieldsAsNull: _this10._treatMissingFieldsAsNull,
                updater: updater,
                normalizeResponse: _this10._normalizeResponse
            });
            return function() {
                return executor.cancel();
            };
        });
    };
    return RelayModernEnvironment;
}();
function $78e109c1f8f736d0$var$operationHasClientAbstractTypes(operation) {
    return operation.root.node.kind === 'Operation' && operation.root.node.clientAbstractTypes != null;
}
$78e109c1f8f736d0$var$RelayModernEnvironment.prototype['@@RelayModernEnvironment'] = true;
function $78e109c1f8f736d0$var$emptyFunction() {}
module.exports = $78e109c1f8f736d0$var$RelayModernEnvironment;

});
parcelRegister("lPY0g", function(module, exports) {
'use strict';

var $hCAmP = parcelRequire("hCAmP");
function $fe5ce7cb2209523f$var$wrapNetworkWithLogObserver(env, network) {
    return {
        execute: function execute(params, variables, cacheConfig, uploadables, _, encryptedVariables, preprocessResponse, checkOperation) {
            var networkRequestId = $hCAmP();
            var logObserver = {
                start: function start(subscription) {
                    env.__log({
                        name: 'network.start',
                        networkRequestId: networkRequestId,
                        params: params,
                        variables: variables,
                        cacheConfig: cacheConfig
                    });
                },
                next: function next(response) {
                    env.__log({
                        name: 'network.next',
                        networkRequestId: networkRequestId,
                        response: response
                    });
                },
                error: function error(_error) {
                    env.__log({
                        name: 'network.error',
                        networkRequestId: networkRequestId,
                        error: _error
                    });
                },
                complete: function complete() {
                    env.__log({
                        name: 'network.complete',
                        networkRequestId: networkRequestId
                    });
                },
                unsubscribe: function unsubscribe() {
                    env.__log({
                        name: 'network.unsubscribe',
                        networkRequestId: networkRequestId
                    });
                }
            };
            var logRequestInfo = function logRequestInfo(info) {
                env.__log({
                    name: 'network.info',
                    networkRequestId: networkRequestId,
                    info: info
                });
            };
            return network.execute(params, variables, cacheConfig, uploadables, logRequestInfo, encryptedVariables, preprocessResponse, checkOperation)["do"](logObserver);
        }
    };
}
module.exports = $fe5ce7cb2209523f$var$wrapNetworkWithLogObserver;

});
parcelRegister("hCAmP", function(module, exports) {
'use strict';
var $cd42320fa2d34a3d$var$id = 100000;
function $cd42320fa2d34a3d$var$generateID() {
    return $cd42320fa2d34a3d$var$id++;
}
module.exports = $cd42320fa2d34a3d$var$generateID;

});


parcelRegister("59AhP", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $3c09f0c81e312013$var$_interopRequireDefault = $bGHxy.default;

var $3c09f0c81e312013$var$_createForOfIteratorHelper2 = $3c09f0c81e312013$var$_interopRequireDefault((parcelRequire("cXbK5")));

var $5Wk1R = parcelRequire("5Wk1R");
var $3c09f0c81e312013$var$RelayOperationTracker = /*#__PURE__*/ function() {
    function RelayOperationTracker() {
        this._ownersToPendingOperations = new Map();
        this._pendingOperationsToOwners = new Map();
        this._ownersToPendingPromise = new Map();
    }
    var _proto = RelayOperationTracker.prototype;
    _proto.update = function update(pendingOperation, affectedOwners) {
        if (affectedOwners.size === 0) return;
        var pendingOperationIdentifier = pendingOperation.identifier;
        var newlyAffectedOwnersIdentifier = new Set();
        var _iterator = (0, $3c09f0c81e312013$var$_createForOfIteratorHelper2["default"])(affectedOwners), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var owner = _step.value;
                var ownerIdentifier = owner.identifier;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (pendingOperationsAffectingOwner != null) {
                    if (!pendingOperationsAffectingOwner.has(pendingOperationIdentifier)) {
                        pendingOperationsAffectingOwner.set(pendingOperationIdentifier, pendingOperation);
                        newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                    }
                } else {
                    this._ownersToPendingOperations.set(ownerIdentifier, new Map([
                        [
                            pendingOperationIdentifier,
                            pendingOperation
                        ]
                    ]));
                    newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (newlyAffectedOwnersIdentifier.size === 0) return;
        var ownersAffectedByPendingOperation = this._pendingOperationsToOwners.get(pendingOperationIdentifier) || new Set();
        var _iterator2 = (0, $3c09f0c81e312013$var$_createForOfIteratorHelper2["default"])(newlyAffectedOwnersIdentifier), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _ownerIdentifier = _step2.value;
                this._resolveOwnerResolvers(_ownerIdentifier);
                ownersAffectedByPendingOperation.add(_ownerIdentifier);
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._pendingOperationsToOwners.set(pendingOperationIdentifier, ownersAffectedByPendingOperation);
    };
    _proto.complete = function complete(pendingOperation) {
        var pendingOperationIdentifier = pendingOperation.identifier;
        var affectedOwnersIdentifier = this._pendingOperationsToOwners.get(pendingOperationIdentifier);
        if (affectedOwnersIdentifier == null) return;
        var completedOwnersIdentifier = new Set();
        var updatedOwnersIdentifier = new Set();
        var _iterator3 = (0, $3c09f0c81e312013$var$_createForOfIteratorHelper2["default"])(affectedOwnersIdentifier), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var ownerIdentifier = _step3.value;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (!pendingOperationsAffectingOwner) continue;
                pendingOperationsAffectingOwner["delete"](pendingOperationIdentifier);
                if (pendingOperationsAffectingOwner.size > 0) updatedOwnersIdentifier.add(ownerIdentifier);
                else completedOwnersIdentifier.add(ownerIdentifier);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        var _iterator4 = (0, $3c09f0c81e312013$var$_createForOfIteratorHelper2["default"])(completedOwnersIdentifier), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _ownerIdentifier2 = _step4.value;
                this._resolveOwnerResolvers(_ownerIdentifier2);
                this._ownersToPendingOperations["delete"](_ownerIdentifier2);
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        var _iterator5 = (0, $3c09f0c81e312013$var$_createForOfIteratorHelper2["default"])(updatedOwnersIdentifier), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _ownerIdentifier3 = _step5.value;
                this._resolveOwnerResolvers(_ownerIdentifier3);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._pendingOperationsToOwners["delete"](pendingOperationIdentifier);
    };
    _proto._resolveOwnerResolvers = function _resolveOwnerResolvers(ownerIdentifier) {
        var promiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (promiseEntry != null) promiseEntry.resolve();
        this._ownersToPendingPromise["delete"](ownerIdentifier);
    };
    _proto.getPendingOperationsAffectingOwner = function getPendingOperationsAffectingOwner(owner) {
        var ownerIdentifier = owner.identifier;
        var pendingOperationsForOwner = this._ownersToPendingOperations.get(ownerIdentifier);
        if (pendingOperationsForOwner == null || pendingOperationsForOwner.size === 0) return null;
        var cachedPromiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (cachedPromiseEntry != null) return {
            promise: cachedPromiseEntry.promise,
            pendingOperations: cachedPromiseEntry.pendingOperations
        };
        var resolve;
        var promise = new Promise(function(r) {
            resolve = r;
        });
        !(resolve != null) && $5Wk1R(false);
        var pendingOperations = Array.from(pendingOperationsForOwner.values());
        this._ownersToPendingPromise.set(ownerIdentifier, {
            promise: promise,
            resolve: resolve,
            pendingOperations: pendingOperations
        });
        return {
            promise: promise,
            pendingOperations: pendingOperations
        };
    };
    return RelayOperationTracker;
}();
module.exports = $3c09f0c81e312013$var$RelayOperationTracker;

});

parcelRegister("hB8AO", function(module, exports) {
'use strict';
function $ccfc8eaf82bc5067$var$registerEnvironmentWithDevTools(environment) {
    var _global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
    var devToolsHook = _global && _global.__RELAY_DEVTOOLS_HOOK__;
    if (devToolsHook) devToolsHook.registerEnvironment(environment);
}
module.exports = $ccfc8eaf82bc5067$var$registerEnvironmentWithDevTools;

});

parcelRegister("5kOf7", function(module, exports) {
'use strict';

var $cBCPf = parcelRequire("cBCPf");
var $3e25cb3192b22af0$var$VIEWER_ID = $cBCPf.VIEWER_ID, $3e25cb3192b22af0$var$VIEWER_TYPE = $cBCPf.VIEWER_TYPE;
function $3e25cb3192b22af0$var$defaultGetDataID(fieldValue, typeName) {
    if (typeName === $3e25cb3192b22af0$var$VIEWER_TYPE) return fieldValue.id == null ? $3e25cb3192b22af0$var$VIEWER_ID : fieldValue.id;
    return fieldValue.id;
}
module.exports = $3e25cb3192b22af0$var$defaultGetDataID;

});
parcelRegister("cBCPf", function(module, exports) {
'use strict';

var $fJ2hT = parcelRequire("fJ2hT");
var $92d70eb3ccd2a3a0$var$generateClientID = $fJ2hT.generateClientID;

var $5vBPt = parcelRequire("5vBPt");
var $92d70eb3ccd2a3a0$var$ROOT_ID = $5vBPt.ROOT_ID;
var $92d70eb3ccd2a3a0$var$VIEWER_ID = $92d70eb3ccd2a3a0$var$generateClientID($92d70eb3ccd2a3a0$var$ROOT_ID, 'viewer');
var $92d70eb3ccd2a3a0$var$VIEWER_TYPE = 'Viewer';
module.exports = {
    VIEWER_ID: $92d70eb3ccd2a3a0$var$VIEWER_ID,
    VIEWER_TYPE: $92d70eb3ccd2a3a0$var$VIEWER_TYPE
};

});


parcelRegister("dncWC", function(module, exports) {
'use strict';
var $9bc776d836d790ec$var$defaultRelayFieldLogger = function defaultRelayFieldLogger(event) {};
module.exports = $9bc776d836d790ec$var$defaultRelayFieldLogger;

});

parcelRegister("f3EXN", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $af66e9524dce7e31$var$_interopRequireDefault = $bGHxy.default;

var $af66e9524dce7e31$var$_createForOfIteratorHelper2 = $af66e9524dce7e31$var$_interopRequireDefault((parcelRequire("cXbK5")));

var $af66e9524dce7e31$var$_toConsumableArray2 = $af66e9524dce7e31$var$_interopRequireDefault((parcelRequire("kTVTn")));

var $u7PH0 = parcelRequire("u7PH0");

var $hCAmP = parcelRequire("hCAmP");

var $8FBJK = parcelRequire("8FBJK");

var $7vCKo = parcelRequire("7vCKo");

var $3hqjB = parcelRequire("3hqjB");

var $aFY6e = parcelRequire("aFY6e");
var $af66e9524dce7e31$var$stableCopy = $aFY6e.stableCopy;

var $bLjbe = parcelRequire("bLjbe");

var $fJ2hT = parcelRequire("fJ2hT");
var $af66e9524dce7e31$var$generateClientID = $fJ2hT.generateClientID, $af66e9524dce7e31$var$generateUniqueClientID = $fJ2hT.generateUniqueClientID;

var $gQ9aH = parcelRequire("gQ9aH");
var $af66e9524dce7e31$var$getLocalVariables = $gQ9aH.getLocalVariables;

var $cdcDZ = parcelRequire("cdcDZ");

var $dTSGA = parcelRequire("dTSGA");
var $af66e9524dce7e31$var$createNormalizationSelector = $dTSGA.createNormalizationSelector, $af66e9524dce7e31$var$createReaderSelector = $dTSGA.createReaderSelector;

var $qckAk = parcelRequire("qckAk");

var $5vBPt = parcelRequire("5vBPt");
var $af66e9524dce7e31$var$ROOT_TYPE = $5vBPt.ROOT_TYPE, $af66e9524dce7e31$var$TYPENAME_KEY = $5vBPt.TYPENAME_KEY, $af66e9524dce7e31$var$getStorageKey = $5vBPt.getStorageKey;

var $5Wk1R = parcelRequire("5Wk1R");
parcelRequire("91yGl");
function $af66e9524dce7e31$var$execute(config) {
    return new $af66e9524dce7e31$var$Executor(config);
}
var $af66e9524dce7e31$var$Executor = /*#__PURE__*/ function() {
    function Executor(_ref3) {
        var _this = this;
        var _ref, _this$_operation$requ, _this$_operation$requ2;
        var actorIdentifier = _ref3.actorIdentifier, getDataID = _ref3.getDataID, getPublishQueue = _ref3.getPublishQueue, getStore = _ref3.getStore, isClientPayload = _ref3.isClientPayload, operation = _ref3.operation, operationExecutions = _ref3.operationExecutions, operationLoader = _ref3.operationLoader, operationTracker = _ref3.operationTracker, optimisticConfig = _ref3.optimisticConfig, scheduler = _ref3.scheduler, shouldProcessClientComponents = _ref3.shouldProcessClientComponents, sink = _ref3.sink, source = _ref3.source, treatMissingFieldsAsNull = _ref3.treatMissingFieldsAsNull, updater = _ref3.updater, log = _ref3.log, normalizeResponse = _ref3.normalizeResponse;
        this._actorIdentifier = actorIdentifier;
        this._getDataID = getDataID;
        this._treatMissingFieldsAsNull = treatMissingFieldsAsNull;
        this._incrementalPayloadsPending = false;
        this._incrementalResults = new Map();
        this._log = log;
        this._executeId = $hCAmP();
        this._nextSubscriptionId = 0;
        this._operation = operation;
        this._operationExecutions = operationExecutions;
        this._operationLoader = operationLoader;
        this._operationTracker = operationTracker;
        this._operationUpdateEpochs = new Map();
        this._optimisticUpdates = null;
        this._useExecTimeResolvers = (_ref = (_this$_operation$requ = this._operation.request.node.operation.use_exec_time_resolvers) !== null && _this$_operation$requ !== void 0 ? _this$_operation$requ : ((_this$_operation$requ2 = this._operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _this$_operation$requ2 === void 0 ? void 0 : _this$_operation$requ2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        this._execTimeResolverResponseComplete = false;
        this._pendingModulePayloadsCount = 0;
        this._getPublishQueue = getPublishQueue;
        this._scheduler = scheduler;
        this._sink = sink;
        this._source = new Map();
        this._state = 'started';
        this._getStore = getStore;
        this._subscriptions = new Map();
        this._updater = updater;
        this._isClientPayload = isClientPayload === true;
        this._isSubscriptionOperation = this._operation.request.node.params.operationKind === 'subscription';
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._retainDisposables = new Map();
        this._seenActors = new Set();
        this._completeFns = [];
        this._normalizeResponse = normalizeResponse;
        var id = this._nextSubscriptionId++;
        if ($3hqjB.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
        source.subscribe({
            complete: function complete() {
                return _this._complete(id);
            },
            error: function error(_error2) {
                return _this._error(_error2);
            },
            next: function next(response) {
                try {
                    _this._next(id, response);
                } catch (error) {
                    sink.error(error);
                }
            },
            start: function start(subscription) {
                var _this$_operation$requ3;
                _this._start(id, subscription);
                _this._log({
                    name: 'execute.start',
                    executeId: _this._executeId,
                    params: _this._operation.request.node.params,
                    variables: _this._operation.request.variables,
                    cacheConfig: (_this$_operation$requ3 = _this._operation.request.cacheConfig) !== null && _this$_operation$requ3 !== void 0 ? _this$_operation$requ3 : {}
                });
            },
            unsubscribe: function unsubscribe() {
                _this._log({
                    name: 'execute.unsubscribe',
                    executeId: _this._executeId
                });
            }
        });
        if (!$3hqjB.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
    }
    var _proto = Executor.prototype;
    _proto.cancel = function cancel() {
        var _this2 = this;
        if (this._state === 'completed') return;
        this._state = 'completed';
        this._operationExecutions["delete"](this._operation.request.identifier);
        if (this._subscriptions.size !== 0) {
            this._subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            this._subscriptions.clear();
        }
        var optimisticUpdates = this._optimisticUpdates;
        if (optimisticUpdates !== null) {
            this._optimisticUpdates = null;
            optimisticUpdates.forEach(function(update) {
                return _this2._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._runPublishQueue();
        }
        this._incrementalResults.clear();
        if (this._asyncStoreUpdateDisposable != null) {
            this._asyncStoreUpdateDisposable.dispose();
            this._asyncStoreUpdateDisposable = null;
        }
        this._completeFns = [];
        this._completeOperationTracker();
        this._disposeRetainedData();
    };
    _proto._updateActiveState = function _updateActiveState() {
        var activeState;
        switch(this._state){
            case 'started':
                activeState = 'active';
                break;
            case 'loading_incremental':
                activeState = 'active';
                break;
            case 'completed':
                activeState = 'inactive';
                break;
            case 'loading_final':
                activeState = this._pendingModulePayloadsCount > 0 || this._useExecTimeResolvers && !this._execTimeResolverResponseComplete ? 'active' : 'inactive';
                break;
            default:
                this._state;
                $5Wk1R(false);
        }
        this._operationExecutions.set(this._operation.request.identifier, activeState);
    };
    _proto._schedule = function _schedule(task, priority) {
        var _this3 = this;
        var scheduler = this._scheduler;
        if (scheduler != null) {
            var id = this._nextSubscriptionId++;
            $u7PH0.create(function(sink) {
                var cancellationToken = scheduler.schedule(function() {
                    try {
                        task();
                        sink.complete();
                    } catch (error) {
                        sink.error(error);
                    }
                }, priority);
                return function() {
                    return scheduler.cancel(cancellationToken);
                };
            }).subscribe({
                complete: function complete() {
                    return _this3._complete(id);
                },
                error: function error(_error3) {
                    return _this3._error(_error3);
                },
                start: function start(subscription) {
                    return _this3._start(id, subscription);
                }
            });
        } else task();
    };
    _proto._complete = function _complete(id) {
        this._subscriptions["delete"](id);
        if (this._subscriptions.size === 0) {
            this.cancel();
            this._sink.complete();
            this._log({
                name: 'execute.complete',
                executeId: this._executeId
            });
        }
    };
    _proto._error = function _error(error) {
        this.cancel();
        this._sink.error(error);
        this._log({
            name: 'execute.error',
            executeId: this._executeId,
            error: error
        });
    };
    _proto._start = function _start(id, subscription) {
        this._subscriptions.set(id, subscription);
        this._updateActiveState();
    };
    _proto._next = function _next(_id, response) {
        var _this4 = this;
        var priority = this._state === 'loading_incremental' ? 'low' : 'default';
        this._schedule(function() {
            _this4._log({
                name: 'execute.next.start',
                executeId: _this4._executeId,
                response: response,
                operation: _this4._operation
            });
            _this4._handleNext(response);
            _this4._maybeCompleteSubscriptionOperationTracking();
            _this4._log({
                name: 'execute.next.end',
                executeId: _this4._executeId,
                response: response,
                operation: _this4._operation
            });
        }, priority);
    };
    _proto._handleErrorResponse = function _handleErrorResponse(responses) {
        var _this5 = this;
        var results = [];
        responses.forEach(function(response) {
            if (response.data === null && response.extensions != null && !response.hasOwnProperty('errors')) return;
            else if (response.data == null) {
                var errors = response.hasOwnProperty('errors') && response.errors != null ? response.errors : null;
                var messages = errors ? errors.map(function(_ref4) {
                    var message = _ref4.message;
                    return message;
                }).join('\n') : '(No errors)';
                var error = $7vCKo.create('RelayNetwork', 'No data returned for operation `' + _this5._operation.request.node.params.name + '`, got error(s):\n' + messages + '\n\nSee the error `source` property for more information.');
                error.source = {
                    errors: errors,
                    operation: _this5._operation.request.node,
                    variables: _this5._operation.request.variables
                };
                error.stack;
                throw error;
            } else {
                var responseWithData = response;
                results.push(responseWithData);
            }
        });
        return results;
    };
    _proto._handleOptimisticResponses = function _handleOptimisticResponses(responses) {
        var _response$extensions;
        if (responses.length > 1) {
            if (responses.some(function(responsePart) {
                var _responsePart$extensi;
                return ((_responsePart$extensi = responsePart.extensions) === null || _responsePart$extensi === void 0 ? void 0 : _responsePart$extensi.isOptimistic) === true;
            })) $5Wk1R(false);
            return false;
        }
        var response = responses[0];
        var isOptimistic = ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.isOptimistic) === true;
        if (isOptimistic && this._state !== 'started') $5Wk1R(false);
        if (isOptimistic) {
            this._processOptimisticResponse(response, null, this._treatMissingFieldsAsNull);
            this._sink.next(response);
            return true;
        }
        return false;
    };
    _proto._handleNext = function _handleNext(response) {
        if (this._state === 'completed') return;
        this._seenActors.clear();
        var responses = Array.isArray(response) ? response : [
            response
        ];
        var responsesWithData = this._handleErrorResponse(responses);
        if (responsesWithData.length === 0) {
            var isFinal = responses.some(function(x) {
                var _x$extensions;
                return ((_x$extensions = x.extensions) === null || _x$extensions === void 0 ? void 0 : _x$extensions.is_final) === true;
            });
            if (isFinal) {
                this._state = 'loading_final';
                this._updateActiveState();
                this._incrementalPayloadsPending = false;
            }
            this._sink.next(response);
            return;
        }
        var isOptimistic = this._handleOptimisticResponses(responsesWithData);
        if (isOptimistic) return;
        var _partitionGraphQLResp = $af66e9524dce7e31$var$partitionGraphQLResponses(responsesWithData), nonIncrementalResponses = _partitionGraphQLResp[0], incrementalResponses = _partitionGraphQLResp[1], normalizedResponses = _partitionGraphQLResp[2];
        var hasNonIncrementalResponses = nonIncrementalResponses.length > 0;
        var hasNormalizedResponses = normalizedResponses.length > 0;
        if (hasNonIncrementalResponses) {
            if (this._isSubscriptionOperation) {
                var nextID = $af66e9524dce7e31$var$generateUniqueClientID();
                this._operation = {
                    request: this._operation.request,
                    fragment: $af66e9524dce7e31$var$createReaderSelector(this._operation.fragment.node, nextID, this._operation.fragment.variables, this._operation.fragment.owner),
                    root: $af66e9524dce7e31$var$createNormalizationSelector(this._operation.root.node, nextID, this._operation.root.variables)
                };
            }
            var payloadFollowups = this._processResponses(nonIncrementalResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
        if (hasNormalizedResponses) {
            var _payloadFollowups = [];
            for(var i = 0; i < normalizedResponses.length; i++){
                var _response$extensions2;
                var _response = normalizedResponses[i];
                var source = new $qckAk(_response.data);
                var isFinal = ((_response$extensions2 = _response.extensions) === null || _response$extensions2 === void 0 ? void 0 : _response$extensions2.is_final) === true;
                var payload = {
                    errors: [],
                    fieldPayloads: [],
                    followupPayloads: [],
                    incrementalPlaceholders: [],
                    isFinal: isFinal,
                    source: source
                };
                this._getPublishQueueAndSaveActor().commitPayload(this._operation, payload, this._updater);
                _payloadFollowups.push(payload);
                this._execTimeResolverResponseComplete = isFinal;
                if (isFinal) this._updateActiveState();
            }
        }
        if (incrementalResponses.length > 0) {
            var _payloadFollowups2 = this._processIncrementalResponses(incrementalResponses);
            this._processPayloadFollowups(_payloadFollowups2);
        }
        if (this._isSubscriptionOperation) {
            if (responsesWithData[0].extensions == null) responsesWithData[0].extensions = {
                __relay_subscription_root_id: this._operation.fragment.dataID
            };
            else responsesWithData[0].extensions.__relay_subscription_root_id = this._operation.fragment.dataID;
        }
        var updatedOwners = this._runPublishQueue(hasNonIncrementalResponses || hasNormalizedResponses ? this._operation : undefined);
        if (hasNonIncrementalResponses) {
            if (this._incrementalPayloadsPending) this._retainData();
        }
        this._updateOperationTracker(updatedOwners);
        this._sink.next(response);
    };
    _proto._processOptimisticResponse = function _processOptimisticResponse(response, updater, treatMissingFieldsAsNull) {
        var _this6 = this;
        !(this._optimisticUpdates === null) && $5Wk1R(false);
        if (response == null && updater == null) return;
        var optimisticUpdates = [];
        if (response) {
            var payload = this._normalizeResponse(response, this._operation.root, $af66e9524dce7e31$var$ROOT_TYPE, {
                actorIdentifier: this._actorIdentifier,
                getDataID: this._getDataID,
                log: this._log,
                path: [],
                shouldProcessClientComponents: this._shouldProcessClientComponents,
                treatMissingFieldsAsNull: treatMissingFieldsAsNull
            }, this._useExecTimeResolvers);
            $af66e9524dce7e31$var$validateOptimisticResponsePayload(payload);
            optimisticUpdates.push({
                operation: this._operation,
                payload: payload,
                updater: updater
            });
            this._processOptimisticFollowups(payload, optimisticUpdates);
        } else if (updater) optimisticUpdates.push({
            operation: this._operation,
            payload: {
                errors: null,
                fieldPayloads: null,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $qckAk.create(),
                isFinal: false
            },
            updater: updater
        });
        this._optimisticUpdates = optimisticUpdates;
        optimisticUpdates.forEach(function(update) {
            return _this6._getPublishQueueAndSaveActor().applyUpdate(update);
        });
        var updatedOwners = this._runPublishQueue();
        if ($3hqjB.ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES) this._updateOperationTracker(updatedOwners);
    };
    _proto._processOptimisticFollowups = function _processOptimisticFollowups(payload, optimisticUpdates) {
        if (payload.followupPayloads && payload.followupPayloads.length) {
            var followupPayloads = payload.followupPayloads;
            var _iterator = (0, $af66e9524dce7e31$var$_createForOfIteratorHelper2["default"])(followupPayloads), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var followupPayload = _step.value;
                    switch(followupPayload.kind){
                        case 'ModuleImportPayload':
                            var operationLoader = this._expectOperationLoader();
                            var operation = operationLoader.get(followupPayload.operationReference);
                            if (operation == null) this._processAsyncOptimisticModuleImport(followupPayload);
                            else {
                                var moduleImportOptimisticUpdates = this._processOptimisticModuleImport(operation, followupPayload);
                                optimisticUpdates.push.apply(optimisticUpdates, (0, $af66e9524dce7e31$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                            }
                            break;
                        case 'ActorPayload':
                            break;
                        default:
                            followupPayload;
                            $5Wk1R(false);
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._normalizeFollowupPayload = function _normalizeFollowupPayload(followupPayload, normalizationNode) {
        var variables;
        if (normalizationNode.kind === 'SplitOperation' && followupPayload.kind === 'ModuleImportPayload') variables = $af66e9524dce7e31$var$getLocalVariables(followupPayload.variables, normalizationNode.argumentDefinitions, followupPayload.args);
        else variables = followupPayload.variables;
        var selector = $af66e9524dce7e31$var$createNormalizationSelector(normalizationNode, followupPayload.dataID, variables);
        var nextResponse = {
            data: followupPayload.data,
            extensions: this._state === 'loading_final' ? {
                is_final: true
            } : undefined
        };
        return this._normalizeResponse(nextResponse, selector, followupPayload.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            log: this._log,
            path: followupPayload.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        }, this._useExecTimeResolvers);
    };
    _proto._processOptimisticModuleImport = function _processOptimisticModuleImport(normalizationRootNode, moduleImportPayload) {
        var operation = $8FBJK(normalizationRootNode);
        var optimisticUpdates = [];
        var modulePayload = this._normalizeFollowupPayload(moduleImportPayload, operation);
        $af66e9524dce7e31$var$validateOptimisticResponsePayload(modulePayload);
        optimisticUpdates.push({
            operation: this._operation,
            payload: modulePayload,
            updater: null
        });
        this._processOptimisticFollowups(modulePayload, optimisticUpdates);
        return optimisticUpdates;
    };
    _proto._processAsyncOptimisticModuleImport = function _processAsyncOptimisticModuleImport(moduleImportPayload) {
        var _this7 = this;
        this._expectOperationLoader().load(moduleImportPayload.operationReference).then(function(operation) {
            if (operation == null || _this7._state !== 'started') return;
            var moduleImportOptimisticUpdates = _this7._processOptimisticModuleImport(operation, moduleImportPayload);
            moduleImportOptimisticUpdates.forEach(function(update) {
                return _this7._getPublishQueueAndSaveActor().applyUpdate(update);
            });
            if (_this7._optimisticUpdates == null) ;
            else {
                var _this$_optimisticUpda;
                (_this$_optimisticUpda = _this7._optimisticUpdates).push.apply(_this$_optimisticUpda, (0, $af66e9524dce7e31$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                _this7._runPublishQueue();
            }
        });
    };
    _proto._processResponses = function _processResponses(responses) {
        var _this8 = this;
        this._log({
            name: 'execute.normalize.start',
            operation: this._operation
        });
        if (this._optimisticUpdates !== null) {
            this._optimisticUpdates.forEach(function(update) {
                _this8._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._optimisticUpdates = null;
        }
        this._incrementalPayloadsPending = false;
        this._incrementalResults.clear();
        this._source.clear();
        return responses.map(function(payloadPart) {
            var relayPayload = _this8._normalizeResponse(payloadPart, _this8._operation.root, $af66e9524dce7e31$var$ROOT_TYPE, {
                actorIdentifier: _this8._actorIdentifier,
                getDataID: _this8._getDataID,
                log: _this8._log,
                path: [],
                treatMissingFieldsAsNull: _this8._treatMissingFieldsAsNull,
                shouldProcessClientComponents: _this8._shouldProcessClientComponents
            }, _this8._useExecTimeResolvers);
            _this8._getPublishQueueAndSaveActor().commitPayload(_this8._operation, relayPayload, _this8._updater);
            _this8._log({
                name: 'execute.normalize.end',
                operation: _this8._operation
            });
            return relayPayload;
        });
    };
    _proto._processPayloadFollowups = function _processPayloadFollowups(payloads) {
        var _this9 = this;
        if (this._state === 'completed') return;
        payloads.forEach(function(payload) {
            var incrementalPlaceholders = payload.incrementalPlaceholders, followupPayloads = payload.followupPayloads, isFinal = payload.isFinal;
            _this9._state = isFinal ? 'loading_final' : 'loading_incremental';
            _this9._updateActiveState();
            if (isFinal) _this9._incrementalPayloadsPending = false;
            if (followupPayloads && followupPayloads.length !== 0) followupPayloads.forEach(function(followupPayload) {
                var _followupPayload$acto;
                var prevActorIdentifier = _this9._actorIdentifier;
                _this9._actorIdentifier = (_followupPayload$acto = followupPayload.actorIdentifier) !== null && _followupPayload$acto !== void 0 ? _followupPayload$acto : _this9._actorIdentifier;
                _this9._processFollowupPayload(followupPayload);
                _this9._actorIdentifier = prevActorIdentifier;
            });
            if (incrementalPlaceholders && incrementalPlaceholders.length !== 0) {
                _this9._incrementalPayloadsPending = _this9._state !== 'loading_final';
                incrementalPlaceholders.forEach(function(incrementalPlaceholder) {
                    var _incrementalPlacehold;
                    var prevActorIdentifier = _this9._actorIdentifier;
                    _this9._actorIdentifier = (_incrementalPlacehold = incrementalPlaceholder.actorIdentifier) !== null && _incrementalPlacehold !== void 0 ? _incrementalPlacehold : _this9._actorIdentifier;
                    _this9._processIncrementalPlaceholder(payload, incrementalPlaceholder);
                    _this9._actorIdentifier = prevActorIdentifier;
                });
                if (_this9._isClientPayload || _this9._state === 'loading_final') {
                    var relayPayloads = [];
                    incrementalPlaceholders.forEach(function(placeholder) {
                        if (placeholder.kind === 'defer') relayPayloads.push(_this9._processDeferResponse(placeholder.label, placeholder.path, placeholder, {
                            data: placeholder.data,
                            extensions: {
                                is_final: true
                            }
                        }));
                    });
                    if (relayPayloads.length > 0) _this9._processPayloadFollowups(relayPayloads);
                }
            }
        });
    };
    _proto._maybeCompleteSubscriptionOperationTracking = function _maybeCompleteSubscriptionOperationTracking() {
        if (!this._isSubscriptionOperation && !(this._useExecTimeResolvers && this._execTimeResolverResponseComplete && this._state === 'loading_final')) return;
        if (this._pendingModulePayloadsCount === 0 && this._incrementalPayloadsPending === false) this._completeOperationTracker();
    };
    _proto._processFollowupPayload = function _processFollowupPayload(followupPayload) {
        var _this10 = this;
        switch(followupPayload.kind){
            case 'ModuleImportPayload':
                var operationLoader = this._expectOperationLoader();
                var node = operationLoader.get(followupPayload.operationReference);
                if (node != null) this._processFollowupPayloadWithNormalizationNode(followupPayload, $8FBJK(node));
                else {
                    var id = this._nextSubscriptionId++;
                    this._pendingModulePayloadsCount++;
                    var decrementPendingCount = function decrementPendingCount() {
                        _this10._pendingModulePayloadsCount--;
                        _this10._maybeCompleteSubscriptionOperationTracking();
                    };
                    var networkObservable = $u7PH0.from(new Promise(function(resolve, reject) {
                        operationLoader.load(followupPayload.operationReference).then(resolve, reject);
                    }));
                    $u7PH0.create(function(sink) {
                        var cancellationToken;
                        var subscription = networkObservable.subscribe({
                            next: function next(loadedNode) {
                                if (loadedNode != null) {
                                    var publishModuleImportPayload = function publishModuleImportPayload() {
                                        try {
                                            var operation = $8FBJK(loadedNode);
                                            var batchAsyncModuleUpdatesFN = $3hqjB.BATCH_ASYNC_MODULE_UPDATES_FN;
                                            var shouldScheduleAsyncStoreUpdate = batchAsyncModuleUpdatesFN != null && _this10._pendingModulePayloadsCount > 1;
                                            var _withStartAndDuration = $bLjbe(function() {
                                                _this10._handleFollowupPayload(followupPayload, operation);
                                                if (shouldScheduleAsyncStoreUpdate) _this10._scheduleAsyncStoreUpdate(batchAsyncModuleUpdatesFN, sink.complete);
                                                else {
                                                    var updatedOwners = _this10._runPublishQueue();
                                                    _this10._updateOperationTracker(updatedOwners);
                                                }
                                            }), _ = _withStartAndDuration[0], duration = _withStartAndDuration[1];
                                            _this10._log({
                                                name: 'execute.async.module',
                                                executeId: _this10._executeId,
                                                operationName: operation.name,
                                                duration: duration
                                            });
                                            if (!shouldScheduleAsyncStoreUpdate) sink.complete();
                                        } catch (error) {
                                            sink.error(error);
                                        }
                                    };
                                    var scheduler = _this10._scheduler;
                                    if (scheduler == null) publishModuleImportPayload();
                                    else cancellationToken = scheduler.schedule(publishModuleImportPayload);
                                } else sink.complete();
                            },
                            error: sink.error
                        });
                        return function() {
                            subscription.unsubscribe();
                            if (_this10._scheduler != null && cancellationToken != null) _this10._scheduler.cancel(cancellationToken);
                        };
                    }).subscribe({
                        complete: function complete() {
                            _this10._complete(id);
                            decrementPendingCount();
                        },
                        error: function error(_error4) {
                            _this10._error(_error4);
                            decrementPendingCount();
                        },
                        start: function start(subscription) {
                            return _this10._start(id, subscription);
                        }
                    });
                }
                break;
            case 'ActorPayload':
                this._processFollowupPayloadWithNormalizationNode(followupPayload, followupPayload.node);
                break;
            default:
                followupPayload;
                $5Wk1R(false);
        }
    };
    _proto._processFollowupPayloadWithNormalizationNode = function _processFollowupPayloadWithNormalizationNode(followupPayload, normalizationNode) {
        this._handleFollowupPayload(followupPayload, normalizationNode);
        this._maybeCompleteSubscriptionOperationTracking();
    };
    _proto._handleFollowupPayload = function _handleFollowupPayload(followupPayload, normalizationNode) {
        var relayPayload = this._normalizeFollowupPayload(followupPayload, normalizationNode);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        this._processPayloadFollowups([
            relayPayload
        ]);
    };
    _proto._processIncrementalPlaceholder = function _processIncrementalPlaceholder(relayPayload, placeholder) {
        var _relayPayload$fieldPa;
        var label = placeholder.label, path = placeholder.path;
        var pathKey = path.map(String).join('.');
        var resultForLabel = this._incrementalResults.get(label);
        if (resultForLabel == null) {
            resultForLabel = new Map();
            this._incrementalResults.set(label, resultForLabel);
        }
        var resultForPath = resultForLabel.get(pathKey);
        var pendingResponses = resultForPath != null && resultForPath.kind === 'response' ? resultForPath.responses : null;
        resultForLabel.set(pathKey, {
            kind: 'placeholder',
            placeholder: placeholder
        });
        var parentID;
        if (placeholder.kind === 'stream') parentID = placeholder.parentID;
        else if (placeholder.kind === 'defer') parentID = placeholder.selector.dataID;
        else {
            placeholder;
            $5Wk1R(false);
        }
        var parentRecord = relayPayload.source.get(parentID);
        var parentPayloads = ((_relayPayload$fieldPa = relayPayload.fieldPayloads) !== null && _relayPayload$fieldPa !== void 0 ? _relayPayload$fieldPa : []).filter(function(fieldPayload) {
            var fieldID = $af66e9524dce7e31$var$generateClientID(fieldPayload.dataID, fieldPayload.fieldKey);
            return fieldPayload.dataID === parentID || fieldID === parentID;
        });
        !(parentRecord != null) && $5Wk1R(false);
        var nextParentRecord;
        var nextParentPayloads;
        var previousParentEntry = this._source.get(parentID);
        if (previousParentEntry != null) {
            nextParentRecord = $cdcDZ.update(previousParentEntry.record, parentRecord);
            var handlePayloads = new Map();
            var dedupePayload = function dedupePayload(payload) {
                var key = $af66e9524dce7e31$var$stableStringify(payload);
                handlePayloads.set(key, payload);
            };
            previousParentEntry.fieldPayloads.forEach(dedupePayload);
            parentPayloads.forEach(dedupePayload);
            nextParentPayloads = Array.from(handlePayloads.values());
        } else {
            nextParentRecord = parentRecord;
            nextParentPayloads = parentPayloads;
        }
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: nextParentPayloads
        });
        if (pendingResponses != null) {
            var payloadFollowups = this._processIncrementalResponses(pendingResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
    };
    _proto._processIncrementalResponses = function _processIncrementalResponses(incrementalResponses) {
        var _this11 = this;
        var relayPayloads = [];
        incrementalResponses.forEach(function(incrementalResponse) {
            var label = incrementalResponse.label, path = incrementalResponse.path, response = incrementalResponse.response;
            var resultForLabel = _this11._incrementalResults.get(label);
            if (resultForLabel == null) {
                resultForLabel = new Map();
                _this11._incrementalResults.set(label, resultForLabel);
            }
            if (label.indexOf('$defer$') !== -1) {
                var pathKey = path.map(String).join('.');
                var resultForPath = resultForLabel.get(pathKey);
                if (resultForPath == null) {
                    resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(pathKey, resultForPath);
                    return;
                } else if (resultForPath.kind === 'response') {
                    resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var placeholder = resultForPath.placeholder;
                !(placeholder.kind === 'defer') && $5Wk1R(false);
                relayPayloads.push(_this11._processDeferResponse(label, path, placeholder, response));
            } else {
                var _pathKey = path.slice(0, -2).map(String).join('.');
                var _resultForPath = resultForLabel.get(_pathKey);
                if (_resultForPath == null) {
                    _resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(_pathKey, _resultForPath);
                    return;
                } else if (_resultForPath.kind === 'response') {
                    _resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var _placeholder = _resultForPath.placeholder;
                !(_placeholder.kind === 'stream') && $5Wk1R(false);
                relayPayloads.push(_this11._processStreamResponse(label, path, _placeholder, response));
            }
        });
        return relayPayloads;
    };
    _proto._processDeferResponse = function _processDeferResponse(label, path, placeholder, response) {
        var _placeholder$actorIde;
        var parentID = placeholder.selector.dataID;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = (_placeholder$actorIde = placeholder.actorIdentifier) !== null && _placeholder$actorIde !== void 0 ? _placeholder$actorIde : this._actorIdentifier;
        var relayPayload = this._normalizeResponse(response, placeholder.selector, placeholder.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            log: this._log,
            path: placeholder.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        }, this._useExecTimeResolvers);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $5Wk1R(false);
        var fieldPayloads = parentEntry.fieldPayloads;
        if (fieldPayloads.length !== 0) {
            var _response$extensions3;
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $qckAk.create(),
                isFinal: ((_response$extensions3 = response.extensions) === null || _response$extensions3 === void 0 ? void 0 : _response$extensions3.is_final) === true
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._processStreamResponse = function _processStreamResponse(label, path, placeholder, response) {
        var parentID = placeholder.parentID, node = placeholder.node, variables = placeholder.variables, actorIdentifier = placeholder.actorIdentifier;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = actorIdentifier !== null && actorIdentifier !== void 0 ? actorIdentifier : this._actorIdentifier;
        var field = node.selections[0];
        !(field != null && field.kind === 'LinkedField' && field.plural === true) && $5Wk1R(false);
        var _this$_normalizeStrea = this._normalizeStreamItem(response, parentID, field, variables, path, placeholder.path), fieldPayloads = _this$_normalizeStrea.fieldPayloads, itemID = _this$_normalizeStrea.itemID, itemIndex = _this$_normalizeStrea.itemIndex, prevIDs = _this$_normalizeStrea.prevIDs, relayPayload = _this$_normalizeStrea.relayPayload, storageKey = _this$_normalizeStrea.storageKey;
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload, function(store) {
            var currentParentRecord = store.get(parentID);
            if (currentParentRecord == null) return;
            var currentItems = currentParentRecord.getLinkedRecords(storageKey);
            if (currentItems == null) return;
            if (currentItems.length !== prevIDs.length || currentItems.some(function(currentItem, index) {
                return prevIDs[index] !== (currentItem && currentItem.getDataID());
            })) return;
            var nextItems = (0, $af66e9524dce7e31$var$_toConsumableArray2["default"])(currentItems);
            nextItems[itemIndex] = store.get(itemID);
            currentParentRecord.setLinkedRecords(nextItems, storageKey);
        });
        if (fieldPayloads.length !== 0) {
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $qckAk.create(),
                isFinal: false
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._normalizeStreamItem = function _normalizeStreamItem(response, parentID, field, variables, path, normalizationPath) {
        var _field$alias, _field$concreteType, _ref2, _this$_getDataID;
        var data = response.data;
        !(typeof data === 'object') && $5Wk1R(false);
        var responseKey = (_field$alias = field.alias) !== null && _field$alias !== void 0 ? _field$alias : field.name;
        var storageKey = $af66e9524dce7e31$var$getStorageKey(field, variables);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $5Wk1R(false);
        var parentRecord = parentEntry.record, fieldPayloads = parentEntry.fieldPayloads;
        var prevIDs = $cdcDZ.getLinkedRecordIDs(parentRecord, storageKey);
        !(prevIDs != null) && $5Wk1R(false);
        var finalPathEntry = path[path.length - 1];
        var itemIndex = parseInt(finalPathEntry, 10);
        !(itemIndex === finalPathEntry && itemIndex >= 0) && $5Wk1R(false);
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : data[$af66e9524dce7e31$var$TYPENAME_KEY];
        !(typeof typeName === 'string') && $5Wk1R(false);
        var itemID = (_ref2 = (_this$_getDataID = this._getDataID(data, typeName)) !== null && _this$_getDataID !== void 0 ? _this$_getDataID : prevIDs === null || prevIDs === void 0 ? void 0 : prevIDs[itemIndex]) !== null && _ref2 !== void 0 ? _ref2 : $af66e9524dce7e31$var$generateClientID(parentID, storageKey, itemIndex);
        !(typeof itemID === 'string') && $5Wk1R(false);
        var selector = $af66e9524dce7e31$var$createNormalizationSelector(field, itemID, variables);
        var nextParentRecord = $cdcDZ.clone(parentRecord);
        var nextIDs = (0, $af66e9524dce7e31$var$_toConsumableArray2["default"])(prevIDs);
        nextIDs[itemIndex] = itemID;
        $cdcDZ.setLinkedRecordIDs(nextParentRecord, storageKey, nextIDs);
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: fieldPayloads
        });
        var relayPayload = this._normalizeResponse(response, selector, typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            log: this._log,
            path: [].concat((0, $af66e9524dce7e31$var$_toConsumableArray2["default"])(normalizationPath), [
                responseKey,
                String(itemIndex)
            ]),
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        }, this._useExecTimeResolvers);
        return {
            fieldPayloads: fieldPayloads,
            itemID: itemID,
            itemIndex: itemIndex,
            prevIDs: prevIDs,
            relayPayload: relayPayload,
            storageKey: storageKey
        };
    };
    _proto._scheduleAsyncStoreUpdate = function _scheduleAsyncStoreUpdate(scheduleFn, completeFn) {
        var _this12 = this;
        this._completeFns.push(completeFn);
        if (this._asyncStoreUpdateDisposable != null) return;
        this._asyncStoreUpdateDisposable = scheduleFn(function() {
            _this12._asyncStoreUpdateDisposable = null;
            var updatedOwners = _this12._runPublishQueue();
            _this12._updateOperationTracker(updatedOwners);
            var _iterator2 = (0, $af66e9524dce7e31$var$_createForOfIteratorHelper2["default"])(_this12._completeFns), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var complete = _step2.value;
                    complete();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            _this12._completeFns = [];
        });
    };
    _proto._updateOperationTracker = function _updateOperationTracker(updatedOwners) {
        if (updatedOwners != null && updatedOwners.length > 0) this._operationTracker.update(this._operation.request, new Set(updatedOwners));
    };
    _proto._completeOperationTracker = function _completeOperationTracker() {
        this._operationTracker.complete(this._operation.request);
    };
    _proto._getPublishQueueAndSaveActor = function _getPublishQueueAndSaveActor() {
        this._seenActors.add(this._actorIdentifier);
        return this._getPublishQueue(this._actorIdentifier);
    };
    _proto._getActorsToVisit = function _getActorsToVisit() {
        if (this._seenActors.size === 0) return new Set([
            this._actorIdentifier
        ]);
        else return this._seenActors;
    };
    _proto._runPublishQueue = function _runPublishQueue(operation) {
        var updatedOwners = new Set();
        var _iterator3 = (0, $af66e9524dce7e31$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var actorIdentifier = _step3.value;
                var owners = this._getPublishQueue(actorIdentifier).run(operation);
                owners.forEach(function(owner) {
                    return updatedOwners.add(owner);
                });
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return Array.from(updatedOwners);
    };
    _proto._retainData = function _retainData() {
        var _iterator4 = (0, $af66e9524dce7e31$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var actorIdentifier = _step4.value;
                if (!this._retainDisposables.has(actorIdentifier)) this._retainDisposables.set(actorIdentifier, this._getStore(actorIdentifier).retain(this._operation));
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
    _proto._disposeRetainedData = function _disposeRetainedData() {
        var _iterator5 = (0, $af66e9524dce7e31$var$_createForOfIteratorHelper2["default"])(this._retainDisposables.values()), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var disposable = _step5.value;
                disposable.dispose();
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._retainDisposables.clear();
    };
    _proto._expectOperationLoader = function _expectOperationLoader() {
        var operationLoader = this._operationLoader;
        !operationLoader && $5Wk1R(false);
        return operationLoader;
    };
    return Executor;
}();
function $af66e9524dce7e31$var$partitionGraphQLResponses(responses) {
    var nonIncrementalResponses = [];
    var incrementalResponses = [];
    var normalizedResponses = [];
    responses.forEach(function(response) {
        var _response$extensions4;
        if (response.path != null || response.label != null) {
            var label = response.label, path = response.path;
            if (label == null || path == null) $5Wk1R(false);
            incrementalResponses.push({
                label: label,
                path: path,
                response: response
            });
        } else if (((_response$extensions4 = response.extensions) === null || _response$extensions4 === void 0 ? void 0 : _response$extensions4.is_normalized) === true) normalizedResponses.push(response);
        else nonIncrementalResponses.push(response);
    });
    return [
        nonIncrementalResponses,
        incrementalResponses,
        normalizedResponses
    ];
}
function $af66e9524dce7e31$var$stableStringify(value) {
    var _JSON$stringify;
    return (_JSON$stringify = JSON.stringify($af66e9524dce7e31$var$stableCopy(value))) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
}
function $af66e9524dce7e31$var$validateOptimisticResponsePayload(payload) {
    var incrementalPlaceholders = payload.incrementalPlaceholders;
    if (incrementalPlaceholders != null && incrementalPlaceholders.length !== 0) $5Wk1R(false);
}
module.exports = {
    execute: $af66e9524dce7e31$var$execute
};

});
parcelRegister("8FBJK", function(module, exports) {
'use strict';

var $eqz8c = parcelRequire("eqz8c");
var $64ff6ccf95a35ec2$var$REQUEST = $eqz8c.REQUEST, $64ff6ccf95a35ec2$var$SPLIT_OPERATION = $eqz8c.SPLIT_OPERATION;
function $64ff6ccf95a35ec2$var$getOperation(node) {
    switch(node.kind){
        case $64ff6ccf95a35ec2$var$REQUEST:
            return node.operation;
        case $64ff6ccf95a35ec2$var$SPLIT_OPERATION:
        default:
            return node;
    }
}
module.exports = $64ff6ccf95a35ec2$var$getOperation;

});

parcelRegister("7vCKo", function(module, exports) {
'use strict';
function $57797c09a22d9955$var$createError(type, name, messageFormat) {
    for(var _len = arguments.length, messageParams = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)messageParams[_key - 3] = arguments[_key];
    var index = 0;
    var message = messageFormat.replace(/%s/g, function() {
        return String(messageParams[index++]);
    });
    var err = new Error(message);
    var error = Object.assign(err, {
        name: name,
        messageFormat: messageFormat,
        messageParams: messageParams,
        type: type,
        taalOpcodes: [
            2,
            2
        ]
    });
    if (error.stack === undefined) try {
        throw error;
    } catch (_unused) {}
    return error;
}
module.exports = {
    create: function create(name, messageFormat) {
        for(var _len2 = arguments.length, messageParams = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)messageParams[_key2 - 2] = arguments[_key2];
        return $57797c09a22d9955$var$createError.apply(void 0, [
            'error',
            name,
            messageFormat
        ].concat(messageParams));
    },
    createWarning: function createWarning(name, messageFormat) {
        for(var _len3 = arguments.length, messageParams = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)messageParams[_key3 - 2] = arguments[_key3];
        return $57797c09a22d9955$var$createError.apply(void 0, [
            'warn',
            name,
            messageFormat
        ].concat(messageParams));
    }
};

});

parcelRegister("bLjbe", function(module, exports) {
'use strict';
var $8902f648b9fedfd1$var$_window, $8902f648b9fedfd1$var$_window$performance;
var $8902f648b9fedfd1$var$isPerformanceNowAvailable = typeof window !== 'undefined' && typeof (($8902f648b9fedfd1$var$_window = window) === null || $8902f648b9fedfd1$var$_window === void 0 ? void 0 : ($8902f648b9fedfd1$var$_window$performance = $8902f648b9fedfd1$var$_window.performance) === null || $8902f648b9fedfd1$var$_window$performance === void 0 ? void 0 : $8902f648b9fedfd1$var$_window$performance.now) === 'function';
function $8902f648b9fedfd1$var$currentTimestamp() {
    if ($8902f648b9fedfd1$var$isPerformanceNowAvailable) return window.performance.now();
    return Date.now();
}
function $8902f648b9fedfd1$var$withStartAndDuration(cb) {
    var startTime = $8902f648b9fedfd1$var$currentTimestamp();
    var result = cb();
    return [
        startTime,
        $8902f648b9fedfd1$var$currentTimestamp() - startTime,
        result
    ];
}
module.exports = $8902f648b9fedfd1$var$withStartAndDuration;

});


parcelRegister("gL89e", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $c3375b1f06227c28$var$_interopRequireDefault = $bGHxy.default;

var $c3375b1f06227c28$var$_createForOfIteratorHelper2 = $c3375b1f06227c28$var$_interopRequireDefault((parcelRequire("cXbK5")));

var $c3375b1f06227c28$var$_defineProperty2 = $c3375b1f06227c28$var$_interopRequireDefault((parcelRequire("aUl3j")));

var $1umzp = parcelRequire("1umzp");
var $c3375b1f06227c28$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $1umzp.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $c3375b1f06227c28$var$assertInternalActorIdentifier = $1umzp.assertInternalActorIdentifier;
parcelRequire("a9DXr");

var $cmKb4 = parcelRequire("cmKb4");

var $fukCx = parcelRequire("fukCx");

var $5kOf7 = parcelRequire("5kOf7");

var $8fKbZ = parcelRequire("8fKbZ");
var $c3375b1f06227c28$var$LiveResolverCache = $8fKbZ.LiveResolverCache, $c3375b1f06227c28$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = $8fKbZ.RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, $c3375b1f06227c28$var$getUpdatedDataIDs = $8fKbZ.getUpdatedDataIDs;

var $cdcDZ = parcelRequire("cdcDZ");

var $1fSDY = parcelRequire("1fSDY");

var $hKPnN = parcelRequire("hKPnN");

var $jMnLs = parcelRequire("jMnLs");

var $fPYIp = parcelRequire("fPYIp");

var $5vBPt = parcelRequire("5vBPt");

var $5vBPt = parcelRequire("5vBPt");
var $c3375b1f06227c28$var$ROOT_ID = $5vBPt.ROOT_ID, $c3375b1f06227c28$var$ROOT_TYPE = $5vBPt.ROOT_TYPE;

var $5Wk1R = parcelRequire("5Wk1R");
var $c3375b1f06227c28$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
var $c3375b1f06227c28$var$RelayModernStore = /*#__PURE__*/ function() {
    function RelayModernStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$shouldRetain, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa, _options$shouldProces, _options$treatMissing;
        (0, $c3375b1f06227c28$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $c3375b1f06227c28$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._shouldRetainWithinTTL_EXPERIMENTAL = (_options$shouldRetain = options === null || options === void 0 ? void 0 : options.shouldRetainWithinTTL_EXPERIMENTAL) !== null && _options$shouldRetain !== void 0 ? _options$shouldRetain : false;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $cmKb4;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $5kOf7;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $c3375b1f06227c28$var$LiveResolverCache(function() {
            return _this._getMutableRecordSource();
        }, this);
        this._resolverContext = options === null || options === void 0 ? void 0 : options.resolverContext;
        this._storeSubscriptions = new $fPYIp(options === null || options === void 0 ? void 0 : options.log, this._resolverCache, this._resolverContext);
        this._updatedRecordIDs = new Set();
        this._shouldProcessClientComponents = (_options$shouldProces = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents) !== null && _options$shouldProces !== void 0 ? _options$shouldProces : false;
        this._treatMissingFieldsAsNull = (_options$treatMissing = options === null || options === void 0 ? void 0 : options.treatMissingFieldsAsNull) !== null && _options$treatMissing !== void 0 ? _options$treatMissing : false;
        this._actorIdentifier = options === null || options === void 0 ? void 0 : options.actorIdentifier;
        $c3375b1f06227c28$var$initializeRecordSource(this._recordSource);
    }
    var _proto = RelayModernStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto.getOperationLoader = function getOperationLoader() {
        return this._operationLoader;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(recordID) {
        return this._resolverCache.getLiveResolverPromise(recordID);
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        if (this.__log != null) this.__log({
            name: 'liveresolver.batch.start'
        });
        try {
            this._resolverCache.batchLiveStateUpdates(callback);
        } finally{
            if (this.__log != null) this.__log({
                name: 'liveresolver.batch.end'
            });
        }
    };
    _proto.check = function check(operation, options) {
        var _ref, _operation$request$no, _operation$request$no2, _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var useExecTimeResolvers = (_ref = (_operation$request$no = operation.request.node.operation.use_exec_time_resolvers) !== null && _operation$request$no !== void 0 ? _operation$request$no : ((_operation$request$no2 = operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _operation$request$no2 === void 0 ? void 0 : _operation$request$no2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $c3375b1f06227c28$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $c3375b1f06227c28$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $fukCx.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $c3375b1f06227c28$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents, this.__log, useExecTimeResolvers);
        return $c3375b1f06227c28$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    if (!_this2._shouldRetainWithinTTL_EXPERIMENTAL) _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        if (!_this2._shouldRetainWithinTTL_EXPERIMENTAL) _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var log = this.__log;
        if (log != null) log({
            name: 'store.lookup.start',
            selector: selector
        });
        var source = this.getSource();
        var snapshot = $hKPnN.read(source, selector, this._resolverCache, this._resolverContext);
        if (log != null) log({
            name: 'store.lookup.end',
            selector: selector
        });
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs,
            subscriptionsSize: this._storeSubscriptions.size(),
            updatedOwners: updatedOwners
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $c3375b1f06227c28$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'RelayModernStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $cdcDZ.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        return {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, $c3375b1f06227c28$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $5Wk1R(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $1fSDY.create(this.getSource());
    };
    _proto.restore = function restore() {
        var optimisticSource = this._optimisticSource;
        !optimisticSource && $5Wk1R(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        var optimisticIDs = $1fSDY.getOptimisticRecordIDs(optimisticSource);
        this._resolverCache.unsubscribeFromLiveResolverRecords(optimisticIDs);
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
        this._resolverCache.invalidateResolverRecords(optimisticIDs);
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        if (this._shouldRetainWithinTTL_EXPERIMENTAL && this._queryCacheExpirationTime == null) return;
        var log = this.__log;
        top: while(true){
            if (log != null) log({
                name: 'store.gc.start'
            });
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator2 = (0, $c3375b1f06227c28$var$_createForOfIteratorHelper2["default"])(this._roots.entries()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _ref2, _operation$request$no3, _operation$request$no4;
                    var _step2$value = _step2.value, _dataID = _step2$value[0], _step2$value$ = _step2$value[1], operation = _step2$value$.operation, refCount = _step2$value$.refCount, fetchTime = _step2$value$.fetchTime;
                    if (this._shouldRetainWithinTTL_EXPERIMENTAL) {
                        var _queryCacheExpirationTime = this._queryCacheExpirationTime;
                        !(_queryCacheExpirationTime != null) && $5Wk1R(false);
                        var recordHasExpired = fetchTime == null || fetchTime <= Date.now() - _queryCacheExpirationTime;
                        var recordShouldBeCollected = recordHasExpired && refCount === 0 && !this._releaseBuffer.includes(_dataID);
                        if (recordShouldBeCollected) continue;
                    }
                    var selector = operation.root;
                    var useExecTimeResolvers = (_ref2 = (_operation$request$no3 = operation.request.node.operation.use_exec_time_resolvers) !== null && _operation$request$no3 !== void 0 ? _operation$request$no3 : ((_operation$request$no4 = operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _operation$request$no4 === void 0 ? void 0 : _operation$request$no4.get()) === true) !== null && _ref2 !== void 0 ? _ref2 : false;
                    $jMnLs.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents, useExecTimeResolvers);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) {
                        if (log != null) log({
                            name: 'store.gc.interrupted'
                        });
                        continue top;
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var storeIDs = this._recordSource.getRecordIDs();
            for(var ii = 0; ii < storeIDs.length; ii++){
                var dataID = storeIDs[ii];
                if (!references.has(dataID)) {
                    var record = this._recordSource.get(dataID);
                    if (record != null) {
                        var maybeResolverSubscription = $cdcDZ.getValue(record, $c3375b1f06227c28$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
                        if (maybeResolverSubscription != null) maybeResolverSubscription();
                    }
                    this._recordSource.remove(dataID);
                    if (this._shouldRetainWithinTTL_EXPERIMENTAL) this._roots["delete"](dataID);
                }
            }
            if (log != null) log({
                name: 'store.gc.end',
                references: references
            });
            return;
        }
    };
    _proto.__getNormalizationOptions = function __getNormalizationOptions(path) {
        return {
            path: path,
            getDataID: this._getDataID,
            log: this.__log,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents,
            actorIdentifier: this._actorIdentifier
        };
    };
    _proto.__notifyUpdatedSubscribers = function __notifyUpdatedSubscribers(updatedRecords) {
        var nextUpdatedRecordIDs = $c3375b1f06227c28$var$getUpdatedDataIDs(updatedRecords);
        var prevUpdatedRecordIDs = this._updatedRecordIDs;
        this._updatedRecordIDs = nextUpdatedRecordIDs;
        this.notify();
        this._updatedRecordIDs = prevUpdatedRecordIDs;
    };
    return RelayModernStore;
}();
function $c3375b1f06227c28$var$initializeRecordSource(target) {
    if (!target.has($c3375b1f06227c28$var$ROOT_ID)) {
        var rootRecord = $cdcDZ.create($c3375b1f06227c28$var$ROOT_ID, $c3375b1f06227c28$var$ROOT_TYPE);
        target.set($c3375b1f06227c28$var$ROOT_ID, rootRecord);
    }
}
function $c3375b1f06227c28$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = $cdcDZ.clone(targetRecord);
        else nextRecord = sourceRecord != null ? $cdcDZ.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $cdcDZ.setValue(nextRecord, $5vBPt.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = $cdcDZ.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function $c3375b1f06227c28$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = $c3375b1f06227c28$var$RelayModernStore;

});
parcelRegister("cmKb4", function(module, exports) {
'use strict';
var $900b5bfdecf4fea4$var$resolvedPromise = Promise.resolve();
function $900b5bfdecf4fea4$var$resolveImmediate(callback) {
    $900b5bfdecf4fea4$var$resolvedPromise.then(callback)["catch"]($900b5bfdecf4fea4$var$throwNext);
}
function $900b5bfdecf4fea4$var$throwNext(error) {
    setTimeout(function() {
        throw error;
    }, 0);
}
module.exports = $900b5bfdecf4fea4$var$resolveImmediate;

});

parcelRegister("fukCx", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $b469a72c5626fe52$var$_interopRequireDefault = $bGHxy.default;

var $b469a72c5626fe52$var$_createForOfIteratorHelper2 = $b469a72c5626fe52$var$_interopRequireDefault((parcelRequire("cXbK5")));

var $lNhcP = parcelRequire("lNhcP");

var $8OQuk = parcelRequire("8OQuk");

var $8FBJK = parcelRequire("8FBJK");

var $fJ2hT = parcelRequire("fJ2hT");
var $b469a72c5626fe52$var$isClientID = $fJ2hT.isClientID;

var $6m3Ro = parcelRequire("6m3Ro");

var $31xiY = parcelRequire("31xiY");

var $gQ9aH = parcelRequire("gQ9aH");
var $b469a72c5626fe52$var$getLocalVariables = $gQ9aH.getLocalVariables;

var $cdcDZ = parcelRequire("cdcDZ");

var $1KM42 = parcelRequire("1KM42");
var $b469a72c5626fe52$var$EXISTENT = $1KM42.EXISTENT, $b469a72c5626fe52$var$UNKNOWN = $1KM42.UNKNOWN;

var $5vBPt = parcelRequire("5vBPt");

var $h3ajd = parcelRequire("h3ajd");
var $b469a72c5626fe52$var$TYPE_SCHEMA_TYPE = $h3ajd.TYPE_SCHEMA_TYPE, $b469a72c5626fe52$var$generateTypeID = $h3ajd.generateTypeID;

var $5Wk1R = parcelRequire("5Wk1R");
var $b469a72c5626fe52$var$getModuleOperationKey = $5vBPt.getModuleOperationKey, $b469a72c5626fe52$var$getStorageKey = $5vBPt.getStorageKey, $b469a72c5626fe52$var$getArgumentValues = $5vBPt.getArgumentValues;
function $b469a72c5626fe52$var$check(getSourceForActor, getTargetForActor, defaultActorIdentifier, selector, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers) {
    if (log != null) log({
        name: 'store.datachecker.start',
        selector: selector
    });
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var checker = new $b469a72c5626fe52$var$DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers);
    var result = checker.check(node, dataID);
    if (log != null) log({
        name: 'store.datachecker.end',
        selector: selector
    });
    return result;
}
var $b469a72c5626fe52$var$DataChecker = /*#__PURE__*/ function() {
    function DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers) {
        this._getSourceForActor = getSourceForActor;
        this._getTargetForActor = getTargetForActor;
        this._getDataID = getDataID;
        this._source = getSourceForActor(defaultActorIdentifier);
        this._mutatorRecordSourceProxyCache = new Map();
        var _this$_getMutatorAndR = this._getMutatorAndRecordProxyForActor(defaultActorIdentifier), mutator = _this$_getMutatorAndR[0], recordSourceProxy = _this$_getMutatorAndR[1];
        this._useExecTimeResolvers = useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false;
        this._mostRecentlyInvalidatedAt = null;
        this._handlers = handlers;
        this._mutator = mutator;
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._recordSourceProxy = recordSourceProxy;
        this._recordWasMissing = false;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._log = log;
    }
    var _proto = DataChecker.prototype;
    _proto._getMutatorAndRecordProxyForActor = function _getMutatorAndRecordProxyForActor(actorIdentifier) {
        var tuple = this._mutatorRecordSourceProxyCache.get(actorIdentifier);
        if (tuple == null) {
            var target = this._getTargetForActor(actorIdentifier);
            var mutator = new $lNhcP(this._getSourceForActor(actorIdentifier), target);
            var recordSourceProxy = new $8OQuk(mutator, this._getDataID, undefined, this._handlers, this._log);
            tuple = [
                mutator,
                recordSourceProxy
            ];
            this._mutatorRecordSourceProxyCache.set(actorIdentifier, tuple);
        }
        return tuple;
    };
    _proto.check = function check(node, dataID) {
        this._assignClientAbstractTypes(node);
        this._traverse(node, dataID);
        return this._recordWasMissing === true ? {
            status: 'missing',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        } : {
            status: 'available',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        };
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $5Wk1R(false);
        return this._variables[name];
    };
    _proto._handleMissing = function _handleMissing() {
        this._recordWasMissing = true;
    };
    _proto._handleMissingScalarField = function _handleMissingScalarField(field, dataID) {
        if (field.name === 'id' && field.alias == null && $b469a72c5626fe52$var$isClientID(dataID)) return undefined;
        var args = field.args != undefined ? $b469a72c5626fe52$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator = (0, $b469a72c5626fe52$var$_createForOfIteratorHelper2["default"])(this._handlers), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var handler = _step.value;
                if (handler.kind === 'scalar') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined) return newValue;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingLinkField = function _handleMissingLinkField(field, dataID) {
        var args = field.args != undefined ? $b469a72c5626fe52$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator2 = (0, $b469a72c5626fe52$var$_createForOfIteratorHelper2["default"])(this._handlers), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var handler = _step2.value;
                if (handler.kind === 'linked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined && (newValue === null || this._mutator.getStatus(newValue) === $b469a72c5626fe52$var$EXISTENT)) return newValue;
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingPluralLinkField = function _handleMissingPluralLinkField(field, dataID) {
        var _this = this;
        var args = field.args != undefined ? $b469a72c5626fe52$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator3 = (0, $b469a72c5626fe52$var$_createForOfIteratorHelper2["default"])(this._handlers), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var handler = _step3.value;
                if (handler.kind === 'pluralLinked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue != null) {
                        var allItemsKnown = newValue.every(function(linkedID) {
                            return linkedID != null && _this._mutator.getStatus(linkedID) === $b469a72c5626fe52$var$EXISTENT;
                        });
                        if (allItemsKnown) return newValue;
                    } else if (newValue === null) return null;
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        this._handleMissing();
    };
    _proto._traverse = function _traverse(node, dataID) {
        var status = this._mutator.getStatus(dataID);
        if (status === $b469a72c5626fe52$var$UNKNOWN) this._handleMissing();
        if (status === $b469a72c5626fe52$var$EXISTENT) {
            var record = this._source.get(dataID);
            var invalidatedAt = $cdcDZ.getInvalidationEpoch(record);
            if (invalidatedAt != null) this._mostRecentlyInvalidatedAt = this._mostRecentlyInvalidatedAt != null ? Math.max(this._mostRecentlyInvalidatedAt, invalidatedAt) : invalidatedAt;
            this._traverseSelections(node.selections, dataID);
        }
    };
    _proto._traverseSelections = function _traverseSelections(selections, dataID) {
        var _this2 = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case 'ScalarField':
                    _this2._checkScalar(selection, dataID);
                    break;
                case 'LinkedField':
                    if (selection.plural) _this2._checkPluralLink(selection, dataID);
                    else _this2._checkLink(selection, dataID);
                    break;
                case 'ActorChange':
                    _this2._checkActorChange(selection.linkedField, dataID);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(_this2._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this2._traverseSelections(selection.selections, dataID);
                    break;
                case 'InlineFragment':
                    var _abstractKey = selection.abstractKey;
                    if (_abstractKey == null) {
                        var typeName = _this2._mutator.getType(dataID);
                        if (typeName === selection.type) _this2._traverseSelections(selection.selections, dataID);
                    } else {
                        var _recordType = _this2._mutator.getType(dataID);
                        !(_recordType != null) && $5Wk1R(false);
                        var _typeID = $b469a72c5626fe52$var$generateTypeID(_recordType);
                        var _implementsInterface = _this2._mutator.getValue(_typeID, _abstractKey);
                        if (_implementsInterface === true) _this2._traverseSelections(selection.selections, dataID);
                        else if (_implementsInterface == null) _this2._handleMissing();
                    }
                    break;
                case 'LinkedHandle':
                    var handleField = $6m3Ro(selection, selections, _this2._variables);
                    if (handleField.plural) _this2._checkPluralLink(handleField, dataID);
                    else _this2._checkLink(handleField, dataID);
                    break;
                case 'ScalarHandle':
                    var _handleField = $31xiY(selection, selections, _this2._variables);
                    _this2._checkScalar(_handleField, dataID);
                    break;
                case 'ModuleImport':
                    _this2._checkModuleImport(selection, dataID);
                    break;
                case 'Defer':
                case 'Stream':
                    _this2._traverseSelections(selection.selections, dataID);
                    break;
                case 'FragmentSpread':
                    var prevVariables = _this2._variables;
                    _this2._variables = $b469a72c5626fe52$var$getLocalVariables(_this2._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    _this2._variables = prevVariables;
                    break;
                case 'ClientExtension':
                    var recordWasMissing = _this2._recordWasMissing;
                    _this2._traverseSelections(selection.selections, dataID);
                    _this2._recordWasMissing = recordWasMissing;
                    break;
                case 'TypeDiscriminator':
                    var abstractKey = selection.abstractKey;
                    var recordType = _this2._mutator.getType(dataID);
                    !(recordType != null) && $5Wk1R(false);
                    var typeID = $b469a72c5626fe52$var$generateTypeID(recordType);
                    var implementsInterface = _this2._mutator.getValue(typeID, abstractKey);
                    if (implementsInterface == null) _this2._handleMissing();
                    break;
                case 'ClientComponent':
                    if (_this2._shouldProcessClientComponents === false) break;
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    if (!_this2._useExecTimeResolvers) _this2._checkResolver(selection, dataID);
                    break;
                case 'ClientEdgeToClientObject':
                    if (!_this2._useExecTimeResolvers) _this2._checkResolver(selection.backingField, dataID);
                    break;
                default:
                    selection;
                    $5Wk1R(false);
            }
        });
    };
    _proto._checkResolver = function _checkResolver(resolver, dataID) {
        if (resolver.fragment) this._traverseSelections([
            resolver.fragment
        ], dataID);
    };
    _proto._checkModuleImport = function _checkModuleImport(moduleImport, dataID) {
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $5Wk1R(false);
        var operationKey = $b469a72c5626fe52$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = this._mutator.getValue(dataID, operationKey);
        if (operationReference == null) {
            if (operationReference === undefined) this._handleMissing();
            return;
        }
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $8FBJK(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $b469a72c5626fe52$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverse(operation, dataID);
            this._variables = prevVariables;
        } else this._handleMissing();
    };
    _proto._checkScalar = function _checkScalar(field, dataID) {
        var storageKey = $b469a72c5626fe52$var$getStorageKey(field, this._variables);
        var fieldValue = this._mutator.getValue(dataID, storageKey);
        if (fieldValue === undefined) {
            fieldValue = this._handleMissingScalarField(field, dataID);
            if (fieldValue !== undefined) this._mutator.setValue(dataID, storageKey, fieldValue);
        }
    };
    _proto._checkLink = function _checkLink(field, dataID) {
        var storageKey = $b469a72c5626fe52$var$getStorageKey(field, this._variables);
        var linkedID = this._mutator.getLinkedRecordID(dataID, storageKey);
        if (linkedID === undefined) {
            linkedID = this._handleMissingLinkField(field, dataID);
            if (linkedID != null) this._mutator.setLinkedRecordID(dataID, storageKey, linkedID);
            else if (linkedID === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedID != null) this._traverse(field, linkedID);
    };
    _proto._checkPluralLink = function _checkPluralLink(field, dataID) {
        var _this3 = this;
        var storageKey = $b469a72c5626fe52$var$getStorageKey(field, this._variables);
        var linkedIDs = this._mutator.getLinkedRecordIDs(dataID, storageKey);
        if (linkedIDs === undefined) {
            linkedIDs = this._handleMissingPluralLinkField(field, dataID);
            if (linkedIDs != null) this._mutator.setLinkedRecordIDs(dataID, storageKey, linkedIDs);
            else if (linkedIDs === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedIDs) linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this3._traverse(field, linkedID);
        });
    };
    _proto._checkActorChange = function _checkActorChange(field, dataID) {
        var storageKey = $b469a72c5626fe52$var$getStorageKey(field, this._variables);
        var record = this._source.get(dataID);
        var tuple = record != null ? $cdcDZ.getActorLinkedRecordID(record, storageKey) : record;
        if (tuple == null) {
            if (tuple === undefined) this._handleMissing();
        } else {
            var actorIdentifier = tuple[0], linkedID = tuple[1];
            var prevSource = this._source;
            var prevMutator = this._mutator;
            var prevRecordSourceProxy = this._recordSourceProxy;
            var _this$_getMutatorAndR2 = this._getMutatorAndRecordProxyForActor(actorIdentifier), mutator = _this$_getMutatorAndR2[0], recordSourceProxy = _this$_getMutatorAndR2[1];
            this._source = this._getSourceForActor(actorIdentifier);
            this._mutator = mutator;
            this._recordSourceProxy = recordSourceProxy;
            this._assignClientAbstractTypes(field);
            this._traverse(field, linkedID);
            this._source = prevSource;
            this._mutator = prevMutator;
            this._recordSourceProxy = prevRecordSourceProxy;
        }
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator4 = (0, $b469a72c5626fe52$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var concreteType = _step4.value;
                    var typeID = $b469a72c5626fe52$var$generateTypeID(concreteType);
                    if (this._source.get(typeID) == null) this._mutator.create(typeID, $b469a72c5626fe52$var$TYPE_SCHEMA_TYPE);
                    if (this._mutator.getValue(typeID, abstractType) == null) this._mutator.setValue(typeID, abstractType, true);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    return DataChecker;
}();
module.exports = {
    check: $b469a72c5626fe52$var$check
};

});
parcelRegister("lNhcP", function(module, exports) {
'use strict';

var $cdcDZ = parcelRequire("cdcDZ");

var $1KM42 = parcelRequire("1KM42");
var $fddb854d47dc2640$var$EXISTENT = $1KM42.EXISTENT;

var $5Wk1R = parcelRequire("5Wk1R");
var $fddb854d47dc2640$var$RelayRecordSourceMutator = /*#__PURE__*/ function() {
    function RelayRecordSourceMutator(base, sink) {
        this.__sources = [
            sink,
            base
        ];
        this._base = base;
        this._sink = sink;
    }
    var _proto = RelayRecordSourceMutator.prototype;
    _proto.unstable_getRawRecordWithChanges = function unstable_getRawRecordWithChanges(dataID) {
        var baseRecord = this._base.get(dataID);
        var sinkRecord = this._sink.get(dataID);
        if (sinkRecord === undefined) {
            if (baseRecord == null) return baseRecord;
            var nextRecord = $cdcDZ.clone(baseRecord);
            return nextRecord;
        } else if (sinkRecord === null) return null;
        else if (baseRecord != null) {
            var _nextRecord = $cdcDZ.update(baseRecord, sinkRecord);
            return _nextRecord;
        } else {
            var _nextRecord2 = $cdcDZ.clone(sinkRecord);
            return _nextRecord2;
        }
    };
    _proto._getSinkRecord = function _getSinkRecord(dataID) {
        var sinkRecord = this._sink.get(dataID);
        if (!sinkRecord) {
            var baseRecord = this._base.get(dataID);
            !baseRecord && $5Wk1R(false);
            sinkRecord = $cdcDZ.create(dataID, $cdcDZ.getType(baseRecord));
            this._sink.set(dataID, sinkRecord);
        }
        return sinkRecord;
    };
    _proto.copyFields = function copyFields(sourceID, sinkID) {
        var sinkSource = this._sink.get(sourceID);
        var baseSource = this._base.get(sourceID);
        !(sinkSource || baseSource) && $5Wk1R(false);
        var sink = this._getSinkRecord(sinkID);
        if (baseSource) $cdcDZ.copyFields(baseSource, sink);
        if (sinkSource) $cdcDZ.copyFields(sinkSource, sink);
    };
    _proto.copyFieldsFromRecord = function copyFieldsFromRecord(record, sinkID) {
        var sink = this._getSinkRecord(sinkID);
        $cdcDZ.copyFields(record, sink);
    };
    _proto.create = function create(dataID, typeName) {
        !(this._base.getStatus(dataID) !== $fddb854d47dc2640$var$EXISTENT && this._sink.getStatus(dataID) !== $fddb854d47dc2640$var$EXISTENT) && $5Wk1R(false);
        var record = $cdcDZ.create(dataID, typeName);
        this._sink.set(dataID, record);
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        return this._sink.has(dataID) ? this._sink.getStatus(dataID) : this._base.getStatus(dataID);
    };
    _proto.getType = function getType(dataID) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) return $cdcDZ.getType(record);
            else if (record === null) return null;
        }
    };
    _proto.getValue = function getValue(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $cdcDZ.getValue(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setValue = function setValue(dataID, storageKey, value) {
        var sinkRecord = this._getSinkRecord(dataID);
        $cdcDZ.setValue(sinkRecord, storageKey, value);
    };
    _proto.getErrors = function getErrors(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $cdcDZ.getErrors(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setErrors = function setErrors(dataID, storageKey, errors) {
        var sinkRecord = this._getSinkRecord(dataID);
        $cdcDZ.setErrors(sinkRecord, storageKey, errors);
    };
    _proto.getLinkedRecordID = function getLinkedRecordID(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedID = $cdcDZ.getLinkedRecordID(record, storageKey);
                if (linkedID !== undefined) return linkedID;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordID = function setLinkedRecordID(dataID, storageKey, linkedID) {
        var sinkRecord = this._getSinkRecord(dataID);
        $cdcDZ.setLinkedRecordID(sinkRecord, storageKey, linkedID);
    };
    _proto.getLinkedRecordIDs = function getLinkedRecordIDs(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedIDs = $cdcDZ.getLinkedRecordIDs(record, storageKey);
                if (linkedIDs !== undefined) return linkedIDs;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordIDs = function setLinkedRecordIDs(dataID, storageKey, linkedIDs) {
        var sinkRecord = this._getSinkRecord(dataID);
        $cdcDZ.setLinkedRecordIDs(sinkRecord, storageKey, linkedIDs);
    };
    return RelayRecordSourceMutator;
}();
module.exports = $fddb854d47dc2640$var$RelayRecordSourceMutator;

});

parcelRegister("8OQuk", function(module, exports) {
'use strict';

var $cdcDZ = parcelRequire("cdcDZ");

var $1KM42 = parcelRequire("1KM42");
var $66bbb551739051d0$var$EXISTENT = $1KM42.EXISTENT, $66bbb551739051d0$var$NONEXISTENT = $1KM42.NONEXISTENT;

var $5vBPt = parcelRequire("5vBPt");
var $66bbb551739051d0$var$ROOT_ID = $5vBPt.ROOT_ID, $66bbb551739051d0$var$ROOT_TYPE = $5vBPt.ROOT_TYPE;

var $e8KXb = parcelRequire("e8KXb");
var $66bbb551739051d0$var$_readUpdatableFragment = $e8KXb.readUpdatableFragment;

var $jQ76a = parcelRequire("jQ76a");
var $66bbb551739051d0$var$_readUpdatableQuery = $jQ76a.readUpdatableQuery;

var $kXtfT = parcelRequire("kXtfT");

var $5Wk1R = parcelRequire("5Wk1R");
var $66bbb551739051d0$var$RelayRecordSourceProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceProxy(mutator, getDataID, handlerProvider, missingFieldHandlers, log) {
        this.__mutator = mutator;
        this._handlerProvider = handlerProvider || null;
        this._proxies = {};
        this._getDataID = getDataID;
        this._invalidatedStore = false;
        this._idsMarkedForInvalidation = new Set();
        this._missingFieldHandlers = missingFieldHandlers;
        this._log = log !== null && log !== void 0 ? log : function(LogEvent) {};
    }
    var _proto = RelayRecordSourceProxy.prototype;
    _proto.publishSource = function publishSource(source, fieldPayloads) {
        var _this = this;
        var dataIDs = source.getRecordIDs();
        dataIDs.forEach(function(dataID) {
            var status = source.getStatus(dataID);
            if (status === $66bbb551739051d0$var$EXISTENT) {
                var sourceRecord = source.get(dataID);
                if (sourceRecord) {
                    if (_this.__mutator.getStatus(dataID) !== $66bbb551739051d0$var$EXISTENT) _this.create(dataID, $cdcDZ.getType(sourceRecord));
                    _this.__mutator.copyFieldsFromRecord(sourceRecord, dataID);
                }
            } else if (status === $66bbb551739051d0$var$NONEXISTENT) _this["delete"](dataID);
        });
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $5Wk1R(false);
            handler.update(_this, fieldPayload);
        });
    };
    _proto.create = function create(dataID, typeName) {
        this.__mutator.create(dataID, typeName);
        delete this._proxies[dataID];
        var record = this.get(dataID);
        !record && $5Wk1R(false);
        return record;
    };
    _proto["delete"] = function _delete(dataID) {
        !(dataID !== $66bbb551739051d0$var$ROOT_ID) && $5Wk1R(false);
        delete this._proxies[dataID];
        this.__mutator["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        if (!this._proxies.hasOwnProperty(dataID)) {
            var status = this.__mutator.getStatus(dataID);
            if (status === $66bbb551739051d0$var$EXISTENT) this._proxies[dataID] = new $kXtfT(this, this.__mutator, dataID);
            else this._proxies[dataID] = status === $66bbb551739051d0$var$NONEXISTENT ? null : undefined;
        }
        return this._proxies[dataID];
    };
    _proto.getRoot = function getRoot() {
        var root = this.get($66bbb551739051d0$var$ROOT_ID);
        if (!root) root = this.create($66bbb551739051d0$var$ROOT_ID, $66bbb551739051d0$var$ROOT_TYPE);
        !(root && root.getType() === $66bbb551739051d0$var$ROOT_TYPE) && $5Wk1R(false);
        return root;
    };
    _proto.invalidateStore = function invalidateStore() {
        this._invalidatedStore = true;
    };
    _proto.isStoreMarkedForInvalidation = function isStoreMarkedForInvalidation() {
        return this._invalidatedStore;
    };
    _proto.markIDForInvalidation = function markIDForInvalidation(dataID) {
        this._idsMarkedForInvalidation.add(dataID);
    };
    _proto.getIDsMarkedForInvalidation = function getIDsMarkedForInvalidation() {
        return this._idsMarkedForInvalidation;
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $66bbb551739051d0$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $66bbb551739051d0$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceProxy;
}();
module.exports = $66bbb551739051d0$var$RelayRecordSourceProxy;

});
parcelRegister("e8KXb", function(module, exports) {
'use strict';

var $5AvhW = parcelRequire("5AvhW");
var $a4b63c0679f848fc$var$getFragment = $5AvhW.getFragment;

var $dTSGA = parcelRequire("dTSGA");
var $a4b63c0679f848fc$var$getVariablesFromFragment = $dTSGA.getVariablesFromFragment;

var $5vBPt = parcelRequire("5vBPt");
var $a4b63c0679f848fc$var$ID_KEY = $5vBPt.ID_KEY;

var $dPYI7 = parcelRequire("dPYI7");
var $a4b63c0679f848fc$var$createUpdatableProxy = $dPYI7.createUpdatableProxy;

var $5Wk1R = parcelRequire("5Wk1R");
function $a4b63c0679f848fc$var$readUpdatableFragment(fragment, fragmentReference, proxy, missingFieldHandlers) {
    var updatableFragment = $a4b63c0679f848fc$var$getFragment(fragment);
    var fragmentVariables = $a4b63c0679f848fc$var$getVariablesFromFragment(updatableFragment, fragmentReference);
    var id = fragmentReference[$a4b63c0679f848fc$var$ID_KEY];
    var fragmentRoot = proxy.get(id);
    !(fragmentRoot != null) && $5Wk1R(false);
    return {
        updatableData: $a4b63c0679f848fc$var$createUpdatableProxy(fragmentRoot, fragmentVariables, updatableFragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableFragment: $a4b63c0679f848fc$var$readUpdatableFragment
};

});
parcelRegister("dPYI7", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $a12f21a973eae242$var$_interopRequireDefault = $bGHxy.default;

var $a12f21a973eae242$var$_createForOfIteratorHelper2 = $a12f21a973eae242$var$_interopRequireDefault((parcelRequire("cXbK5")));

var $5vBPt = parcelRequire("5vBPt");
var $a12f21a973eae242$var$getArgumentValues = $5vBPt.getArgumentValues;
var $a12f21a973eae242$var$nonUpdatableKeys = [
    'id',
    '__id',
    '__typename',
    'js'
];
function $a12f21a973eae242$var$createUpdatableProxy(updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var mutableUpdatableProxy = {};
    $a12f21a973eae242$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers);
    return mutableUpdatableProxy;
}
function $a12f21a973eae242$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var _selection$alias3;
    var _iterator = (0, $a12f21a973eae242$var$_createForOfIteratorHelper2["default"])(selections), _step;
    try {
        var _loop = function _loop() {
            var selection = _step.value;
            switch(selection.kind){
                case 'LinkedField':
                    if (selection.plural) Object.defineProperty(mutableUpdatableProxy, (_selection$alias = selection.alias) !== null && _selection$alias !== void 0 ? _selection$alias : selection.name, {
                        get: $a12f21a973eae242$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $a12f21a973eae242$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    else Object.defineProperty(mutableUpdatableProxy, (_selection$alias2 = selection.alias) !== null && _selection$alias2 !== void 0 ? _selection$alias2 : selection.name, {
                        get: $a12f21a973eae242$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $a12f21a973eae242$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    break;
                case 'ScalarField':
                    var scalarFieldName = (_selection$alias3 = selection.alias) !== null && _selection$alias3 !== void 0 ? _selection$alias3 : selection.name;
                    Object.defineProperty(mutableUpdatableProxy, scalarFieldName, {
                        get: function get() {
                            var _selection$args;
                            var newVariables = $a12f21a973eae242$var$getArgumentValues((_selection$args = selection.args) !== null && _selection$args !== void 0 ? _selection$args : [], variables);
                            var value = updatableProxyRootRecord.getValue(selection.name, newVariables);
                            if (value == null) value = $a12f21a973eae242$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
                            return value;
                        },
                        set: $a12f21a973eae242$var$nonUpdatableKeys.includes(selection.name) ? undefined : function(newValue) {
                            var _selection$args2;
                            var newVariables = $a12f21a973eae242$var$getArgumentValues((_selection$args2 = selection.args) !== null && _selection$args2 !== void 0 ? _selection$args2 : [], variables);
                            updatableProxyRootRecord.setValue__UNSAFE(newValue, selection.name, newVariables);
                        }
                    });
                    break;
                case 'InlineFragment':
                    if (updatableProxyRootRecord.getType() === selection.type) $a12f21a973eae242$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case 'ClientExtension':
                    $a12f21a973eae242$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case 'FragmentSpread':
                    break;
                case 'Condition':
                case 'ActorChange':
                case 'InlineDataFragmentSpread':
                case 'AliasedInlineFragmentSpread':
                case 'ClientEdgeToClientObject':
                case 'ClientEdgeToServerObject':
                case 'Defer':
                case 'ModuleImport':
                case 'RequiredField':
                case 'CatchField':
                case 'Stream':
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
                default:
                    selection.kind;
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _selection$alias;
            var _selection$alias2;
            _loop();
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $a12f21a973eae242$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args3;
        var newVariables = $a12f21a973eae242$var$getArgumentValues((_selection$args3 = selection.args) !== null && _selection$args3 !== void 0 ? _selection$args3 : [], variables);
        if (newValue == null) throw new Error('Do not assign null to plural linked fields; assign an empty array instead.');
        else {
            var recordProxies = newValue.map(function(item) {
                if (item == null) throw new Error('When assigning an array of items, none of the items should be null or undefined.');
                var __id = item.__id;
                if (__id == null) throw new Error('The __id field must be present on each item passed to the setter. This indicates a bug in Relay.');
                var newValueRecord = recordSourceProxy.get(__id);
                if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
                return newValueRecord;
            });
            updatableProxyRootRecord.setLinkedRecords(recordProxies, selection.name, newVariables);
        }
    };
}
function $a12f21a973eae242$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args4;
        var newVariables = $a12f21a973eae242$var$getArgumentValues((_selection$args4 = selection.args) !== null && _selection$args4 !== void 0 ? _selection$args4 : [], variables);
        if (newValue == null) updatableProxyRootRecord.setValue(newValue, selection.name, newVariables);
        else {
            var __id = newValue.__id;
            if (__id == null) throw new Error('The __id field must be present on the argument. This indicates a bug in Relay.');
            var newValueRecord = recordSourceProxy.get(__id);
            if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
            updatableProxyRootRecord.setLinkedRecord(newValueRecord, selection.name, newVariables);
        }
    };
}
function $a12f21a973eae242$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args5;
        var newVariables = $a12f21a973eae242$var$getArgumentValues((_selection$args5 = selection.args) !== null && _selection$args5 !== void 0 ? _selection$args5 : [], variables);
        var linkedRecords = updatableProxyRootRecord.getLinkedRecords(selection.name, newVariables);
        if (linkedRecords === undefined) linkedRecords = $a12f21a973eae242$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecords != null) return linkedRecords.map(function(linkedRecord) {
            if (linkedRecord != null) {
                var updatableProxy = {};
                $a12f21a973eae242$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                return updatableProxy;
            } else return linkedRecord;
        });
        else return linkedRecords;
    };
}
function $a12f21a973eae242$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args6;
        var newVariables = $a12f21a973eae242$var$getArgumentValues((_selection$args6 = selection.args) !== null && _selection$args6 !== void 0 ? _selection$args6 : [], variables);
        var linkedRecord = updatableProxyRootRecord.getLinkedRecord(selection.name, newVariables);
        if (linkedRecord === undefined) linkedRecord = $a12f21a973eae242$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecord != null) {
            var updatableProxy = {};
            $a12f21a973eae242$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
            return updatableProxy;
        } else return linkedRecord;
    };
}
function $a12f21a973eae242$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator2 = (0, $a12f21a973eae242$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var handler = _step2.value;
            if (handler.kind === 'linked') {
                var newId = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newId != null) return recordSourceProxy.get(newId);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $a12f21a973eae242$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator3 = (0, $a12f21a973eae242$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var handler = _step3.value;
            if (handler.kind === 'pluralLinked') {
                var newIds = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newIds != null) return newIds.map(function(newId) {
                    if (newId != null) return recordSourceProxy.get(newId);
                });
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $a12f21a973eae242$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator4 = (0, $a12f21a973eae242$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step4;
    try {
        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
            var handler = _step4.value;
            if (handler.kind === 'scalar') {
                var value = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (value !== undefined) return value;
            }
        }
    } catch (err) {
        _iterator4.e(err);
    } finally{
        _iterator4.f();
    }
}
module.exports = {
    createUpdatableProxy: $a12f21a973eae242$var$createUpdatableProxy
};

});


parcelRegister("jQ76a", function(module, exports) {
'use strict';

var $5AvhW = parcelRequire("5AvhW");
var $e7186141aa67b7f2$var$getUpdatableQuery = $5AvhW.getUpdatableQuery;

var $dPYI7 = parcelRequire("dPYI7");
var $e7186141aa67b7f2$var$createUpdatableProxy = $dPYI7.createUpdatableProxy;
function $e7186141aa67b7f2$var$readUpdatableQuery(query, variables, proxy, missingFieldHandlers) {
    var updatableQuery = $e7186141aa67b7f2$var$getUpdatableQuery(query);
    return {
        updatableData: $e7186141aa67b7f2$var$createUpdatableProxy(proxy.getRoot(), variables, updatableQuery.fragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableQuery: $e7186141aa67b7f2$var$readUpdatableQuery
};

});

parcelRegister("kXtfT", function(module, exports) {
'use strict';

var $fJ2hT = parcelRequire("fJ2hT");
var $f42002d5abd9be74$var$generateClientID = $fJ2hT.generateClientID;

var $5vBPt = parcelRequire("5vBPt");
var $f42002d5abd9be74$var$getStableStorageKey = $5vBPt.getStableStorageKey;

var $5Wk1R = parcelRequire("5Wk1R");
var $f42002d5abd9be74$var$RelayRecordProxy = /*#__PURE__*/ function() {
    function RelayRecordProxy(source, mutator, dataID) {
        this._dataID = dataID;
        this._mutator = mutator;
        this._source = source;
    }
    var _proto = RelayRecordProxy.prototype;
    _proto.copyFieldsFrom = function copyFieldsFrom(source) {
        this._mutator.copyFields(source.getDataID(), this._dataID);
    };
    _proto.getDataID = function getDataID() {
        return this._dataID;
    };
    _proto.getType = function getType() {
        var type = this._mutator.getType(this._dataID);
        !(type != null) && $5Wk1R(false);
        return type;
    };
    _proto.getValue = function getValue(name, args) {
        var storageKey = $f42002d5abd9be74$var$getStableStorageKey(name, args);
        return this._mutator.getValue(this._dataID, storageKey);
    };
    _proto.setValue = function setValue(value, name, args, errors) {
        !$f42002d5abd9be74$var$isValidLeafValue(value) && $5Wk1R(false);
        return this.setValue__UNSAFE(value, name, args, errors);
    };
    _proto.getErrors = function getErrors(name, args) {
        var storageKey = $f42002d5abd9be74$var$getStableStorageKey(name, args);
        return this._mutator.getErrors(this._dataID, storageKey);
    };
    _proto.setValue__UNSAFE = function setValue__UNSAFE(value, name, args, errors) {
        var storageKey = $f42002d5abd9be74$var$getStableStorageKey(name, args);
        this._mutator.setValue(this._dataID, storageKey, value);
        if (errors != null) {
            if (errors.length === 0) this._mutator.setErrors(this._dataID, storageKey);
            else this._mutator.setErrors(this._dataID, storageKey, errors);
        }
        return this;
    };
    _proto.getLinkedRecord = function getLinkedRecord(name, args) {
        var storageKey = $f42002d5abd9be74$var$getStableStorageKey(name, args);
        var linkedID = this._mutator.getLinkedRecordID(this._dataID, storageKey);
        return linkedID != null ? this._source.get(linkedID) : linkedID;
    };
    _proto.setLinkedRecord = function setLinkedRecord(record, name, args) {
        !(record instanceof RelayRecordProxy) && $5Wk1R(false);
        var storageKey = $f42002d5abd9be74$var$getStableStorageKey(name, args);
        var linkedID = record.getDataID();
        this._mutator.setLinkedRecordID(this._dataID, storageKey, linkedID);
        return this;
    };
    _proto.getOrCreateLinkedRecord = function getOrCreateLinkedRecord(name, typeName, args) {
        var linkedRecord = this.getLinkedRecord(name, args);
        if (!linkedRecord) {
            var _this$_source$get;
            var storageKey = $f42002d5abd9be74$var$getStableStorageKey(name, args);
            var clientID = $f42002d5abd9be74$var$generateClientID(this.getDataID(), storageKey);
            linkedRecord = (_this$_source$get = this._source.get(clientID)) !== null && _this$_source$get !== void 0 ? _this$_source$get : this._source.create(clientID, typeName);
            this.setLinkedRecord(linkedRecord, name, args);
        }
        return linkedRecord;
    };
    _proto.getLinkedRecords = function getLinkedRecords(name, args) {
        var _this = this;
        var storageKey = $f42002d5abd9be74$var$getStableStorageKey(name, args);
        var linkedIDs = this._mutator.getLinkedRecordIDs(this._dataID, storageKey);
        if (linkedIDs == null) return linkedIDs;
        return linkedIDs.map(function(linkedID) {
            return linkedID != null ? _this._source.get(linkedID) : linkedID;
        });
    };
    _proto.setLinkedRecords = function setLinkedRecords(records, name, args) {
        !Array.isArray(records) && $5Wk1R(false);
        var storageKey = $f42002d5abd9be74$var$getStableStorageKey(name, args);
        var linkedIDs = records.map(function(record) {
            return record && record.getDataID();
        });
        this._mutator.setLinkedRecordIDs(this._dataID, storageKey, linkedIDs);
        return this;
    };
    _proto.invalidateRecord = function invalidateRecord() {
        this._source.markIDForInvalidation(this._dataID);
    };
    return RelayRecordProxy;
}();
function $f42002d5abd9be74$var$isValidLeafValue(value) {
    return value == null || typeof value !== 'object' || Array.isArray(value) && value.every($f42002d5abd9be74$var$isValidLeafValue);
}
module.exports = $f42002d5abd9be74$var$RelayRecordProxy;

});


parcelRegister("6m3Ro", function(module, exports) {
'use strict';

var $eqz8c = parcelRequire("eqz8c");
var $4a07caaf4bd29761$var$LINKED_FIELD = $eqz8c.LINKED_FIELD;

var $5vBPt = parcelRequire("5vBPt");
var $4a07caaf4bd29761$var$getHandleStorageKey = $5vBPt.getHandleStorageKey;

var $cGxFv = parcelRequire("cGxFv");

var $5Wk1R = parcelRequire("5Wk1R");
function $4a07caaf4bd29761$var$cloneRelayHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $4a07caaf4bd29761$var$LINKED_FIELD && source.name === handleField.name && source.alias === handleField.alias && $cGxFv(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $4a07caaf4bd29761$var$LINKED_FIELD) && $5Wk1R(false);
    var handleKey = $4a07caaf4bd29761$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'LinkedField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null,
        concreteType: sourceField.concreteType,
        plural: sourceField.plural,
        selections: sourceField.selections
    };
}
module.exports = $4a07caaf4bd29761$var$cloneRelayHandleSourceField;

});

parcelRegister("31xiY", function(module, exports) {
'use strict';

var $eqz8c = parcelRequire("eqz8c");
var $233b4ccbdac75f64$var$SCALAR_FIELD = $eqz8c.SCALAR_FIELD;

var $5vBPt = parcelRequire("5vBPt");
var $233b4ccbdac75f64$var$getHandleStorageKey = $5vBPt.getHandleStorageKey;

var $cGxFv = parcelRequire("cGxFv");

var $5Wk1R = parcelRequire("5Wk1R");
function $233b4ccbdac75f64$var$cloneRelayScalarHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $233b4ccbdac75f64$var$SCALAR_FIELD && source.name === handleField.name && source.alias === handleField.alias && $cGxFv(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $233b4ccbdac75f64$var$SCALAR_FIELD) && $5Wk1R(false);
    var handleKey = $233b4ccbdac75f64$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'ScalarField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null
    };
}
module.exports = $233b4ccbdac75f64$var$cloneRelayScalarHandleSourceField;

});


parcelRegister("8fKbZ", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $60238e44593d5e27$var$_interopRequireDefault = $bGHxy.default;

var $60238e44593d5e27$var$_createForOfIteratorHelper2 = $60238e44593d5e27$var$_interopRequireDefault((parcelRequire("cXbK5")));

var $7hYYU = parcelRequire("7hYYU");

var $eqz8c = parcelRequire("eqz8c");
var $60238e44593d5e27$var$RELAY_LIVE_RESOLVER = $eqz8c.RELAY_LIVE_RESOLVER;

var $3hqjB = parcelRequire("3hqjB");

var $i3Slg = parcelRequire("i3Slg");

var $fJ2hT = parcelRequire("fJ2hT");
var $60238e44593d5e27$var$generateClientID = $fJ2hT.generateClientID, $60238e44593d5e27$var$generateClientObjectClientID = $fJ2hT.generateClientObjectClientID;

var $cdcDZ = parcelRequire("cdcDZ");

var $dTSGA = parcelRequire("dTSGA");
var $60238e44593d5e27$var$createNormalizationSelector = $dTSGA.createNormalizationSelector;

var $qckAk = parcelRequire("qckAk");

var $3U9zg = parcelRequire("3U9zg");
var $60238e44593d5e27$var$normalize = $3U9zg.normalize;

var $5vBPt = parcelRequire("5vBPt");
var $60238e44593d5e27$var$RELAY_RESOLVER_ERROR_KEY = $5vBPt.RELAY_RESOLVER_ERROR_KEY, $60238e44593d5e27$var$RELAY_RESOLVER_INVALIDATION_KEY = $5vBPt.RELAY_RESOLVER_INVALIDATION_KEY, $60238e44593d5e27$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $5vBPt.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, $60238e44593d5e27$var$RELAY_RESOLVER_SNAPSHOT_KEY = $5vBPt.RELAY_RESOLVER_SNAPSHOT_KEY, $60238e44593d5e27$var$RELAY_RESOLVER_VALUE_KEY = $5vBPt.RELAY_RESOLVER_VALUE_KEY, $60238e44593d5e27$var$getReadTimeResolverStorageKey = $5vBPt.getReadTimeResolverStorageKey, $60238e44593d5e27$var$getStorageKey = $5vBPt.getStorageKey;

var $evc83 = parcelRequire("evc83");

var $2W0we = parcelRequire("2W0we");

var $gvcbH = parcelRequire("gvcbH");
var $60238e44593d5e27$var$isSuspenseSentinel = $gvcbH.isSuspenseSentinel;

var $5Wk1R = parcelRequire("5Wk1R");
parcelRequire("91yGl");
var $60238e44593d5e27$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = '__resolverLiveStateSubscription';
var $60238e44593d5e27$var$RELAY_RESOLVER_LIVE_STATE_VALUE = '__resolverLiveStateValue';
var $60238e44593d5e27$var$RELAY_RESOLVER_LIVE_STATE_DIRTY = '__resolverLiveStateDirty';
var $60238e44593d5e27$var$RELAY_RESOLVER_RECORD_TYPENAME = '__RELAY_RESOLVER__';
var $60238e44593d5e27$var$MODEL_PROPERTY_NAME = '__relay_model_instance';
function $60238e44593d5e27$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $60238e44593d5e27$var$LiveResolverCache = /*#__PURE__*/ function() {
    function LiveResolverCache(getRecordSource, store) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
        this._store = store;
        this._handlingBatch = false;
        this._liveResolverBatchRecordSource = null;
    }
    var _proto = LiveResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = $60238e44593d5e27$var$expectRecord(recordSource, recordID);
        var storageKey = $60238e44593d5e27$var$getReadTimeResolverStorageKey(field, variables);
        var linkedID = $cdcDZ.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        var updatedDataIDs;
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            if (linkedRecord != null) $60238e44593d5e27$var$maybeUnsubscribeFromLiveState(linkedRecord);
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $60238e44593d5e27$var$generateClientID(recordID, storageKey);
            linkedRecord = $cdcDZ.create(linkedID, $60238e44593d5e27$var$RELAY_RESOLVER_RECORD_TYPENAME);
            var evaluationResult = evaluate();
            $cdcDZ.setValue(linkedRecord, $60238e44593d5e27$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $cdcDZ.setValue(linkedRecord, $60238e44593d5e27$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            if (field.kind === $60238e44593d5e27$var$RELAY_LIVE_RESOLVER) {
                if (evaluationResult.resolverResult != null) {
                    !(evaluationResult.error == null) && $5Wk1R(false);
                    var liveState = evaluationResult.resolverResult;
                    updatedDataIDs = this._setLiveStateValue(linkedRecord, linkedID, liveState, field, variables);
                } else var _evaluationResult$sna;
            } else updatedDataIDs = this._setResolverValue(linkedRecord, evaluationResult.resolverResult, field, variables);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = $60238e44593d5e27$var$expectRecord(recordSource, recordID);
            var nextRecord = $cdcDZ.clone(currentRecord);
            $cdcDZ.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna2;
                var fragmentStorageKey = $60238e44593d5e27$var$getStorageKey(field.fragment, variables);
                var resolverID = $60238e44593d5e27$var$generateClientID(recordID, fragmentStorageKey);
                $60238e44593d5e27$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $60238e44593d5e27$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna2 = evaluationResult.snapshot) === null || _evaluationResult$sna2 === void 0 ? void 0 : _evaluationResult$sna2.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $60238e44593d5e27$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $60238e44593d5e27$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        } else if (field.kind === $60238e44593d5e27$var$RELAY_LIVE_RESOLVER && $cdcDZ.getValue(linkedRecord, $60238e44593d5e27$var$RELAY_RESOLVER_LIVE_STATE_DIRTY)) {
            var _linkedID2;
            linkedID = (_linkedID2 = linkedID) !== null && _linkedID2 !== void 0 ? _linkedID2 : $60238e44593d5e27$var$generateClientID(recordID, storageKey);
            linkedRecord = $cdcDZ.clone(linkedRecord);
            var _liveState = $cdcDZ.getValue(linkedRecord, $60238e44593d5e27$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
            if (!$2W0we(_liveState)) $5Wk1R(false);
            updatedDataIDs = this._setLiveResolverValue(linkedRecord, _liveState, field, variables);
            $cdcDZ.setValue(linkedRecord, $60238e44593d5e27$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
            recordSource.set(linkedID, linkedRecord);
        }
        var answer = this._getResolverValue(linkedRecord);
        var snapshot = $cdcDZ.getValue(linkedRecord, $60238e44593d5e27$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = $cdcDZ.getValue(linkedRecord, $60238e44593d5e27$var$RELAY_RESOLVER_ERROR_KEY);
        var suspenseID = null;
        if ($60238e44593d5e27$var$isSuspenseSentinel(answer)) {
            var _linkedID3;
            suspenseID = (_linkedID3 = linkedID) !== null && _linkedID3 !== void 0 ? _linkedID3 : $60238e44593d5e27$var$generateClientID(recordID, storageKey);
        }
        return [
            answer,
            linkedID,
            error,
            snapshot,
            suspenseID,
            updatedDataIDs
        ];
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(liveStateID) {
        var recordSource = this._getRecordSource();
        var liveStateRecord = recordSource.get(liveStateID);
        !(liveStateRecord != null) && $5Wk1R(false);
        var liveState = $cdcDZ.getValue(liveStateRecord, $60238e44593d5e27$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
        return new Promise(function(resolve) {
            var unsubscribe = liveState.subscribe(function() {
                unsubscribe();
                resolve();
            });
        });
    };
    _proto._setLiveStateValue = function _setLiveStateValue(linkedRecord, linkedID, liveState, field, variables) {
        var handler = this._makeLiveStateHandler(linkedID);
        var unsubscribe = liveState.subscribe(handler);
        $cdcDZ.setValue(linkedRecord, $60238e44593d5e27$var$RELAY_RESOLVER_LIVE_STATE_VALUE, liveState);
        var updatedDataIDs = this._setLiveResolverValue(linkedRecord, liveState, field, variables);
        $cdcDZ.setValue(linkedRecord, $60238e44593d5e27$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
        $cdcDZ.setValue(linkedRecord, $60238e44593d5e27$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, unsubscribe);
        return updatedDataIDs;
    };
    _proto._makeLiveStateHandler = function _makeLiveStateHandler(linkedID) {
        var _this = this;
        return function() {
            var currentSource = _this._getRecordSource();
            var currentRecord = currentSource.get(linkedID);
            if (!currentRecord) return;
            if (!$cdcDZ.hasValue(currentRecord, $60238e44593d5e27$var$RELAY_RESOLVER_LIVE_STATE_VALUE)) return;
            var nextRecord = $cdcDZ.clone(currentRecord);
            $cdcDZ.setValue(nextRecord, $60238e44593d5e27$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, true);
            _this._setLiveResolverUpdate(linkedID, nextRecord);
        };
    };
    _proto._setLiveResolverUpdate = function _setLiveResolverUpdate(linkedId, record) {
        if (this._handlingBatch) {
            if (this._liveResolverBatchRecordSource == null) this._liveResolverBatchRecordSource = $qckAk.create();
            this._liveResolverBatchRecordSource.set(linkedId, record);
        } else {
            var nextSource = $qckAk.create();
            nextSource.set(linkedId, record);
            this._store.publish(nextSource);
            this._store.notify();
        }
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        !!this._handlingBatch && $5Wk1R(false);
        this._handlingBatch = true;
        try {
            callback();
        } finally{
            if (this._liveResolverBatchRecordSource != null) {
                this._store.publish(this._liveResolverBatchRecordSource);
                this._store.notify();
            }
            this._liveResolverBatchRecordSource = null;
            this._handlingBatch = false;
        }
    };
    _proto._setLiveResolverValue = function _setLiveResolverValue(resolverRecord, liveValue, field, variables) {
        var value = null;
        var resolverError = null;
        try {
            value = liveValue.read();
        } catch (e) {
            resolverError = e;
        }
        $cdcDZ.setValue(resolverRecord, $60238e44593d5e27$var$RELAY_RESOLVER_ERROR_KEY, resolverError);
        return this._setResolverValue(resolverRecord, value, field, variables);
    };
    _proto._setResolverValue = function _setResolverValue(resolverRecord, value, field, variables) {
        var normalizationInfo = field.normalizationInfo;
        var updatedDataIDs = null;
        if (value != null && normalizationInfo != null && !$60238e44593d5e27$var$isSuspenseSentinel(value)) {
            var resolverValue;
            var prevOutputTypeRecordIDs = $evc83(resolverRecord);
            var nextOutputTypeRecordIDs = new Set();
            var currentSource = this._getRecordSource();
            if (normalizationInfo.plural) {
                !Array.isArray(value) && $5Wk1R(false);
                resolverValue = [];
                var nextSource = $qckAk.create();
                for(var ii = 0; ii < value.length; ii++){
                    var currentValue = value[ii];
                    if (currentValue == null) continue;
                    !(typeof currentValue === 'object') && $5Wk1R(false);
                    var typename = $60238e44593d5e27$var$getConcreteTypename(normalizationInfo, currentValue);
                    var outputTypeDataID = $60238e44593d5e27$var$generateClientObjectClientID(typename, $cdcDZ.getDataID(resolverRecord), ii);
                    var source = this._normalizeOutputTypeValue(outputTypeDataID, currentValue, variables, normalizationInfo, [
                        field.path,
                        String(ii)
                    ], typename);
                    var _iterator2 = (0, $60238e44593d5e27$var$_createForOfIteratorHelper2["default"])(source.getRecordIDs()), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var recordID = _step2.value;
                            nextSource.set(recordID, $60238e44593d5e27$var$expectRecord(source, recordID));
                            nextOutputTypeRecordIDs.add(recordID);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    resolverValue.push(outputTypeDataID);
                }
                updatedDataIDs = $60238e44593d5e27$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs);
            } else {
                !(typeof value === 'object') && $5Wk1R(false);
                var _typename = $60238e44593d5e27$var$getConcreteTypename(normalizationInfo, value);
                var _outputTypeDataID = $60238e44593d5e27$var$generateClientObjectClientID(_typename, $cdcDZ.getDataID(resolverRecord));
                var _nextSource = this._normalizeOutputTypeValue(_outputTypeDataID, value, variables, normalizationInfo, [
                    field.path
                ], _typename);
                var _iterator3 = (0, $60238e44593d5e27$var$_createForOfIteratorHelper2["default"])(_nextSource.getRecordIDs()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _recordID = _step3.value;
                        nextOutputTypeRecordIDs.add(_recordID);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                resolverValue = _outputTypeDataID;
                updatedDataIDs = $60238e44593d5e27$var$updateCurrentSource(currentSource, _nextSource, prevOutputTypeRecordIDs);
            }
            $cdcDZ.setValue(resolverRecord, $60238e44593d5e27$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, nextOutputTypeRecordIDs);
            $i3Slg(resolverValue);
            $cdcDZ.setValue(resolverRecord, $60238e44593d5e27$var$RELAY_RESOLVER_VALUE_KEY, resolverValue);
        } else {
            $i3Slg(value);
            $cdcDZ.setValue(resolverRecord, $60238e44593d5e27$var$RELAY_RESOLVER_VALUE_KEY, value);
        }
        return updatedDataIDs;
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        this._store.__notifyUpdatedSubscribers(updatedDataIDs);
    };
    _proto._getResolverValue = function _getResolverValue(resolverRecord) {
        return $cdcDZ.getValue(resolverRecord, $60238e44593d5e27$var$RELAY_RESOLVER_VALUE_KEY);
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            visited.add(recordID);
            updatedDataIDs.add(recordID);
            var fragmentSet = this._recordIDToResolverIDs.get(recordID);
            if (fragmentSet == null) continue;
            var _iterator4 = (0, $60238e44593d5e27$var$_createForOfIteratorHelper2["default"])(fragmentSet), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var fragment = _step4.value;
                    if (!visited.has(fragment)) {
                        visited.add(fragment);
                        var recordSet = this._resolverIDToRecordIDs.get(fragment);
                        if (recordSet == null) continue;
                        var _iterator5 = (0, $60238e44593d5e27$var$_createForOfIteratorHelper2["default"])(recordSet), _step5;
                        try {
                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                var anotherRecordID = _step5.value;
                                $60238e44593d5e27$var$markInvalidatedResolverRecord(anotherRecordID, recordSource);
                                if (!visited.has(anotherRecordID)) {
                                    visited.add(anotherRecordID);
                                    recordsToVisit.push(anotherRecordID);
                                }
                            }
                        } catch (err) {
                            _iterator5.e(err);
                        } finally{
                            _iterator5.f();
                        }
                    }
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    _proto._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$cdcDZ.getValue(record, $60238e44593d5e27$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = $cdcDZ.getValue(record, $60238e44593d5e27$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $7hYYU(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if ($3hqjB.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = $cdcDZ.clone(record);
            $cdcDZ.setValue(nextRecord, $60238e44593d5e27$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set($cdcDZ.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto._normalizeOutputTypeValue = function _normalizeOutputTypeValue(outputTypeDataID, value, variables, normalizationInfo, fieldPath, typename) {
        var source = $qckAk.create();
        switch(normalizationInfo.kind){
            case 'OutputType':
                var record = $cdcDZ.create(outputTypeDataID, typename);
                source.set(outputTypeDataID, record);
                var selector = $60238e44593d5e27$var$createNormalizationSelector(normalizationInfo.normalizationNode, outputTypeDataID, variables);
                var useExecTimeResolvers = false;
                var normalizationOptions = this._store.__getNormalizationOptions(fieldPath);
                return $60238e44593d5e27$var$normalize(source, selector, value, normalizationOptions, undefined, useExecTimeResolvers).source;
            case 'WeakModel':
                var _record = $cdcDZ.create(outputTypeDataID, typename);
                $cdcDZ.setValue(_record, $60238e44593d5e27$var$MODEL_PROPERTY_NAME, value);
                source.set(outputTypeDataID, _record);
                return source;
            default:
                normalizationInfo.kind;
                $5Wk1R(false);
        }
    };
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        var key = $60238e44593d5e27$var$generateClientObjectClientID(typeName, id);
        var recordSource = this._getRecordSource();
        if (!recordSource.has(key)) {
            var newRecord = $cdcDZ.create(key, typeName);
            $cdcDZ.setValue(newRecord, 'id', id);
            recordSource.set(key, newRecord);
        }
        return key;
    };
    _proto.unsubscribeFromLiveResolverRecords = function unsubscribeFromLiveResolverRecords(invalidatedDataIDs) {
        return $60238e44593d5e27$var$unsubscribeFromLiveResolverRecordsImpl(this._getRecordSource(), invalidatedDataIDs);
    };
    _proto.invalidateResolverRecords = function invalidateResolverRecords(invalidatedDataIDs) {
        if (invalidatedDataIDs.size === 0) return;
        var _iterator6 = (0, $60238e44593d5e27$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step6;
        try {
            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                var dataID = _step6.value;
                var record = this._getRecordSource().get(dataID);
                if (record != null && $60238e44593d5e27$var$isResolverRecord(record)) this._getRecordSource()["delete"](dataID);
            }
        } catch (err) {
            _iterator6.e(err);
        } finally{
            _iterator6.f();
        }
    };
    return LiveResolverCache;
}();
function $60238e44593d5e27$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs) {
    var updatedDataIDs = new Set();
    if (prevOutputTypeRecordIDs != null) {
        var _iterator7 = (0, $60238e44593d5e27$var$_createForOfIteratorHelper2["default"])(prevOutputTypeRecordIDs), _step7;
        try {
            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                var recordID = _step7.value;
                if (!nextSource.has(recordID)) {
                    updatedDataIDs.add(recordID);
                    currentSource.remove(recordID);
                }
            }
        } catch (err) {
            _iterator7.e(err);
        } finally{
            _iterator7.f();
        }
    }
    var _iterator8 = (0, $60238e44593d5e27$var$_createForOfIteratorHelper2["default"])(nextSource.getRecordIDs()), _step8;
    try {
        for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
            var _recordID2 = _step8.value;
            var nextRecord = $60238e44593d5e27$var$expectRecord(nextSource, _recordID2);
            if (currentSource.has(_recordID2)) {
                var currentRecord = $60238e44593d5e27$var$expectRecord(currentSource, _recordID2);
                var updatedRecord = $cdcDZ.update(currentRecord, nextRecord);
                if (updatedRecord !== currentRecord) {
                    updatedDataIDs.add(_recordID2);
                    currentSource.set(_recordID2, updatedRecord);
                    $60238e44593d5e27$var$markInvalidatedLinkedResolverRecords(currentRecord, currentSource);
                }
            } else currentSource.set(_recordID2, nextRecord);
        }
    } catch (err) {
        _iterator8.e(err);
    } finally{
        _iterator8.f();
    }
    return updatedDataIDs;
}
function $60238e44593d5e27$var$getAllLinkedRecordIds(record) {
    var linkedRecordIDs = new Set();
    $cdcDZ.getFields(record).forEach(function(field) {
        if ($cdcDZ.hasLinkedRecordID(record, field)) {
            var linkedRecordID = $cdcDZ.getLinkedRecordID(record, field);
            if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
        } else if ($cdcDZ.hasLinkedRecordIDs(record, field)) {
            var _RelayModernRecord$ge;
            (_RelayModernRecord$ge = $cdcDZ.getLinkedRecordIDs(record, field)) === null || _RelayModernRecord$ge === void 0 || _RelayModernRecord$ge.forEach(function(linkedRecordID) {
                if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
            });
        }
    });
    return linkedRecordIDs;
}
function $60238e44593d5e27$var$markInvalidatedResolverRecord(dataID, recordSource) {
    var record = recordSource.get(dataID);
    if (!record) return;
    var nextRecord = $cdcDZ.clone(record);
    $cdcDZ.setValue(nextRecord, $60238e44593d5e27$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
    recordSource.set(dataID, nextRecord);
}
function $60238e44593d5e27$var$markInvalidatedLinkedResolverRecords(record, recordSource) {
    var currentLinkedDataIDs = $60238e44593d5e27$var$getAllLinkedRecordIds(record);
    var _iterator9 = (0, $60238e44593d5e27$var$_createForOfIteratorHelper2["default"])(currentLinkedDataIDs), _step9;
    try {
        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
            var recordID = _step9.value;
            var _record2 = recordSource.get(recordID);
            if (_record2 != null && $60238e44593d5e27$var$isResolverRecord(_record2)) $60238e44593d5e27$var$markInvalidatedResolverRecord(recordID, recordSource);
        }
    } catch (err) {
        _iterator9.e(err);
    } finally{
        _iterator9.f();
    }
}
function $60238e44593d5e27$var$unsubscribeFromLiveResolverRecordsImpl(recordSource, invalidatedDataIDs) {
    if (invalidatedDataIDs.size === 0) return;
    var _iterator10 = (0, $60238e44593d5e27$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step10;
    try {
        for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
            var dataID = _step10.value;
            var record = recordSource.get(dataID);
            if (record != null && $60238e44593d5e27$var$isResolverRecord(record)) $60238e44593d5e27$var$maybeUnsubscribeFromLiveState(record);
        }
    } catch (err) {
        _iterator10.e(err);
    } finally{
        _iterator10.f();
    }
}
function $60238e44593d5e27$var$isResolverRecord(record) {
    return $cdcDZ.getType(record) === $60238e44593d5e27$var$RELAY_RESOLVER_RECORD_TYPENAME;
}
function $60238e44593d5e27$var$maybeUnsubscribeFromLiveState(linkedRecord) {
    var previousUnsubscribe = $cdcDZ.getValue(linkedRecord, $60238e44593d5e27$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
    if (previousUnsubscribe != null) previousUnsubscribe();
}
function $60238e44593d5e27$var$expectRecord(source, recordID) {
    var record = source.get(recordID);
    !(record != null) && $5Wk1R(false);
    return record;
}
function $60238e44593d5e27$var$getUpdatedDataIDs(updatedRecords) {
    return updatedRecords;
}
function $60238e44593d5e27$var$getConcreteTypename(normalizationInfo, currentValue) {
    var _normalizationInfo$co;
    var typename = (_normalizationInfo$co = normalizationInfo.concreteType) !== null && _normalizationInfo$co !== void 0 ? _normalizationInfo$co : currentValue.__typename;
    !(typename != null) && $5Wk1R(false);
    return typename;
}
module.exports = {
    LiveResolverCache: $60238e44593d5e27$var$LiveResolverCache,
    getUpdatedDataIDs: $60238e44593d5e27$var$getUpdatedDataIDs,
    RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY: $60238e44593d5e27$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY
};

});
parcelRegister("i3Slg", function(module, exports) {
'use strict';
module.exports = function shallowFreeze(value) {
    if (typeof value === 'object' && value != null && (Array.isArray(value) || value.constructor === Object)) Object.freeze(value);
};

});

parcelRegister("evc83", function(module, exports) {
'use strict';

var $cdcDZ = parcelRequire("cdcDZ");

var $5vBPt = parcelRequire("5vBPt");
var $a8ed5e79c8e20be8$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $5vBPt.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS;

var $5Wk1R = parcelRequire("5Wk1R");
function $a8ed5e79c8e20be8$var$getOutputTypeRecordIDs(record) {
    var maybeOutputTypeRecordIDs = $cdcDZ.getValue(record, $a8ed5e79c8e20be8$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS);
    if (maybeOutputTypeRecordIDs == null) return null;
    !(maybeOutputTypeRecordIDs instanceof Set) && $5Wk1R(false);
    return maybeOutputTypeRecordIDs;
}
module.exports = $a8ed5e79c8e20be8$var$getOutputTypeRecordIDs;

});

parcelRegister("2W0we", function(module, exports) {
'use strict';
function $22316690b3f6ef09$var$isLiveStateValue(v) {
    return v != null && typeof v === 'object' && typeof v.read === 'function' && typeof v.subscribe === 'function';
}
module.exports = $22316690b3f6ef09$var$isLiveStateValue;

});


parcelRegister("1fSDY", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $0ea19444532582b3$var$_interopRequireDefault = $bGHxy.default;

var $0ea19444532582b3$var$_objectSpread2 = $0ea19444532582b3$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $cdcDZ = parcelRequire("cdcDZ");

var $qckAk = parcelRequire("qckAk");

var $5Wk1R = parcelRequire("5Wk1R");
var $0ea19444532582b3$var$UNPUBLISH_RECORD_SENTINEL = $cdcDZ.fromObject(Object.freeze({
    __UNPUBLISH_RECORD_SENTINEL: true
}));
var $0ea19444532582b3$var$RelayOptimisticRecordSource = /*#__PURE__*/ function() {
    function RelayOptimisticRecordSource(base) {
        this._base = base;
        this._sink = $qckAk.create();
    }
    var _proto = RelayOptimisticRecordSource.prototype;
    _proto.has = function has(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            return sinkRecord !== $0ea19444532582b3$var$UNPUBLISH_RECORD_SENTINEL;
        } else return this._base.has(dataID);
    };
    _proto.get = function get(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            if (sinkRecord === $0ea19444532582b3$var$UNPUBLISH_RECORD_SENTINEL) return undefined;
            else return sinkRecord;
        } else return this._base.get(dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        var record = this.get(dataID);
        if (record === undefined) return 'UNKNOWN';
        else if (record === null) return 'NONEXISTENT';
        else return 'EXISTENT';
    };
    _proto.clear = function clear() {
        this._base = $qckAk.create();
        this._sink.clear();
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.remove = function remove(dataID) {
        this._sink.set(dataID, $0ea19444532582b3$var$UNPUBLISH_RECORD_SENTINEL);
    };
    _proto.set = function set(dataID, record) {
        this._sink.set(dataID, record);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Object.keys(this.toJSON());
    };
    _proto.size = function size() {
        return Object.keys(this.toJSON()).length;
    };
    _proto.toJSON = function toJSON() {
        var _this = this;
        var merged = (0, $0ea19444532582b3$var$_objectSpread2["default"])({}, this._base.toJSON());
        this._sink.getRecordIDs().forEach(function(dataID) {
            var record = _this.get(dataID);
            if (record === undefined) delete merged[dataID];
            else merged[dataID] = $cdcDZ.toJSON(record);
        });
        return merged;
    };
    _proto.getOptimisticRecordIDs = function getOptimisticRecordIDs() {
        return new Set(this._sink.getRecordIDs());
    };
    return RelayOptimisticRecordSource;
}();
function $0ea19444532582b3$var$create(base) {
    return new $0ea19444532582b3$var$RelayOptimisticRecordSource(base);
}
function $0ea19444532582b3$var$getOptimisticRecordIDs(source) {
    !(source instanceof $0ea19444532582b3$var$RelayOptimisticRecordSource) && $5Wk1R(false);
    return source.getOptimisticRecordIDs();
}
module.exports = {
    create: $0ea19444532582b3$var$create,
    getOptimisticRecordIDs: $0ea19444532582b3$var$getOptimisticRecordIDs
};

});

parcelRegister("hKPnN", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $cece971fa429cdb2$var$_interopRequireDefault = $bGHxy.default;

var $cece971fa429cdb2$var$_objectSpread2 = $cece971fa429cdb2$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $cece971fa429cdb2$var$_defineProperty2 = $cece971fa429cdb2$var$_interopRequireDefault((parcelRequire("aUl3j")));

var $cece971fa429cdb2$var$_objectWithoutPropertiesLoose2 = $cece971fa429cdb2$var$_interopRequireDefault((parcelRequire("4erYc")));

var $cece971fa429cdb2$var$_toConsumableArray2 = $cece971fa429cdb2$var$_interopRequireDefault((parcelRequire("kTVTn")));
var $cece971fa429cdb2$var$_excluded = [
    "message"
];

var $3hqjB = parcelRequire("3hqjB");

var $gvcbH = parcelRequire("gvcbH");
var $cece971fa429cdb2$var$isSuspenseSentinel = $gvcbH.isSuspenseSentinel;

var $gQ9aH = parcelRequire("gQ9aH");

var $cdcDZ = parcelRequire("cdcDZ");

var $5vBPt = parcelRequire("5vBPt");
var $cece971fa429cdb2$var$CLIENT_EDGE_TRAVERSAL_PATH = $5vBPt.CLIENT_EDGE_TRAVERSAL_PATH, $cece971fa429cdb2$var$FRAGMENT_OWNER_KEY = $5vBPt.FRAGMENT_OWNER_KEY, $cece971fa429cdb2$var$FRAGMENT_PROP_NAME_KEY = $5vBPt.FRAGMENT_PROP_NAME_KEY, $cece971fa429cdb2$var$FRAGMENTS_KEY = $5vBPt.FRAGMENTS_KEY, $cece971fa429cdb2$var$ID_KEY = $5vBPt.ID_KEY, $cece971fa429cdb2$var$MODULE_COMPONENT_KEY = $5vBPt.MODULE_COMPONENT_KEY, $cece971fa429cdb2$var$ROOT_ID = $5vBPt.ROOT_ID, $cece971fa429cdb2$var$getArgumentValues = $5vBPt.getArgumentValues, $cece971fa429cdb2$var$getModuleComponentKey = $5vBPt.getModuleComponentKey, $cece971fa429cdb2$var$getStorageKey = $5vBPt.getStorageKey;

var $kj38x = parcelRequire("kj38x");
var $cece971fa429cdb2$var$NoopResolverCache = $kj38x.NoopResolverCache;

var $8E0e2 = parcelRequire("8E0e2");
var $cece971fa429cdb2$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL = $8E0e2.RESOLVER_FRAGMENT_ERRORED_SENTINEL, $cece971fa429cdb2$var$withResolverContext = $8E0e2.withResolverContext;

var $h3ajd = parcelRequire("h3ajd");
var $cece971fa429cdb2$var$generateTypeID = $h3ajd.generateTypeID;

var $5Wk1R = parcelRequire("5Wk1R");
function $cece971fa429cdb2$var$read(recordSource, selector, resolverCache, resolverContext) {
    var reader = new $cece971fa429cdb2$var$RelayReader(recordSource, selector, resolverCache !== null && resolverCache !== void 0 ? resolverCache : new $cece971fa429cdb2$var$NoopResolverCache(), resolverContext);
    return reader.read();
}
var $cece971fa429cdb2$var$RelayReader = /*#__PURE__*/ function() {
    function RelayReader(recordSource, selector, resolverCache, resolverContext) {
        var _selector$clientEdgeT, _ref, _this$_owner$node$ope, _this$_owner$node$ope2;
        this._clientEdgeTraversalPath = (_selector$clientEdgeT = selector.clientEdgeTraversalPath) !== null && _selector$clientEdgeT !== void 0 && _selector$clientEdgeT.length ? (0, $cece971fa429cdb2$var$_toConsumableArray2["default"])(selector.clientEdgeTraversalPath) : [];
        this._missingClientEdges = [];
        this._missingLiveResolverFields = [];
        this._isMissingData = false;
        this._isWithinUnmatchedTypeRefinement = false;
        this._fieldErrors = null;
        this._owner = selector.owner;
        this._useExecTimeResolvers = (_ref = (_this$_owner$node$ope = this._owner.node.operation.use_exec_time_resolvers) !== null && _this$_owner$node$ope !== void 0 ? _this$_owner$node$ope : ((_this$_owner$node$ope2 = this._owner.node.operation.exec_time_resolvers_enabled_provider) === null || _this$_owner$node$ope2 === void 0 ? void 0 : _this$_owner$node$ope2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        this._recordSource = recordSource;
        this._seenRecords = new Set();
        this._selector = selector;
        this._variables = selector.variables;
        this._resolverCache = resolverCache;
        this._fragmentName = selector.node.name;
        this._updatedDataIDs = new Set();
        this._resolverContext = resolverContext;
    }
    var _proto = RelayReader.prototype;
    _proto.read = function read() {
        var _this$_selector$node$;
        var _this$_selector = this._selector, node = _this$_selector.node, dataID = _this$_selector.dataID, isWithinUnmatchedTypeRefinement = _this$_selector.isWithinUnmatchedTypeRefinement;
        var abstractKey = node.abstractKey;
        var record = this._recordSource.get(dataID);
        var isDataExpectedToBePresent = !isWithinUnmatchedTypeRefinement;
        if (isDataExpectedToBePresent && abstractKey == null && record != null) {
            if (!this._recordMatchesTypeCondition(record, node.type)) isDataExpectedToBePresent = false;
        }
        if (isDataExpectedToBePresent && abstractKey != null && record != null) {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) isDataExpectedToBePresent = false;
        }
        this._isWithinUnmatchedTypeRefinement = !isDataExpectedToBePresent;
        var data = this._traverse(node, dataID, null);
        var catchTo = (_this$_selector$node$ = this._selector.node.metadata) === null || _this$_selector$node$ === void 0 ? void 0 : _this$_selector$node$.catchTo;
        if (catchTo != null) data = this._catchErrors(data, catchTo, null);
        if (this._updatedDataIDs.size > 0) {
            this._resolverCache.notifyUpdatedSubscribers(this._updatedDataIDs);
            this._updatedDataIDs.clear();
        }
        return {
            data: data,
            isMissingData: this._isMissingData && isDataExpectedToBePresent,
            missingClientEdges: this._missingClientEdges.length ? this._missingClientEdges : null,
            missingLiveResolverFields: this._missingLiveResolverFields,
            seenRecords: this._seenRecords,
            selector: this._selector,
            fieldErrors: this._fieldErrors
        };
    };
    _proto._maybeAddFieldErrors = function _maybeAddFieldErrors(record, storageKey) {
        var errors = $cdcDZ.getErrors(record, storageKey);
        if (errors == null) return;
        var owner = this._fragmentName;
        if (this._fieldErrors == null) this._fieldErrors = [];
        for(var i = 0; i < errors.length; i++){
            var _error$path, _this$_selector$node$2, _this$_selector$node$3;
            var error = errors[i];
            this._fieldErrors.push({
                kind: 'relay_field_payload.error',
                owner: owner,
                fieldPath: ((_error$path = error.path) !== null && _error$path !== void 0 ? _error$path : []).join('.'),
                error: error,
                shouldThrow: (_this$_selector$node$2 = (_this$_selector$node$3 = this._selector.node.metadata) === null || _this$_selector$node$3 === void 0 ? void 0 : _this$_selector$node$3.throwOnFieldError) !== null && _this$_selector$node$2 !== void 0 ? _this$_selector$node$2 : false,
                handled: false,
                uiContext: undefined
            });
        }
    };
    _proto._markDataAsMissing = function _markDataAsMissing(fieldName) {
        var _this$_selector$node$4, _this$_selector$node$5;
        if (this._isWithinUnmatchedTypeRefinement) return;
        if (this._fieldErrors == null) this._fieldErrors = [];
        var owner = this._fragmentName;
        this._fieldErrors.push(((_this$_selector$node$4 = (_this$_selector$node$5 = this._selector.node.metadata) === null || _this$_selector$node$5 === void 0 ? void 0 : _this$_selector$node$5.throwOnFieldError) !== null && _this$_selector$node$4 !== void 0 ? _this$_selector$node$4 : false) ? {
            kind: 'missing_expected_data.throw',
            owner: owner,
            fieldPath: fieldName,
            handled: false,
            uiContext: undefined
        } : {
            kind: 'missing_expected_data.log',
            owner: owner,
            fieldPath: fieldName,
            uiContext: undefined
        });
        this._isMissingData = true;
        if (this._clientEdgeTraversalPath.length) {
            var top = this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1];
            if (top !== null) this._missingClientEdges.push({
                request: top.readerClientEdge.operation,
                clientEdgeDestinationID: top.clientEdgeDestinationID
            });
        }
    };
    _proto._traverse = function _traverse(node, dataID, prevData) {
        var record = this._recordSource.get(dataID);
        this._seenRecords.add(dataID);
        if (record == null) {
            if (record === undefined) this._markDataAsMissing('<record>');
            return record;
        }
        var data = prevData || {};
        var hadRequiredData = this._traverseSelections(node.selections, record, data);
        return hadRequiredData ? data : null;
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $5Wk1R(false);
        return this._variables[name];
    };
    _proto._maybeReportUnexpectedNull = function _maybeReportUnexpectedNull(selection) {
        if (selection.action === 'NONE') return;
        var owner = this._fragmentName;
        if (this._fieldErrors == null) this._fieldErrors = [];
        var fieldName;
        if (selection.field.linkedField != null) {
            var _selection$field$link;
            fieldName = (_selection$field$link = selection.field.linkedField.alias) !== null && _selection$field$link !== void 0 ? _selection$field$link : selection.field.linkedField.name;
        } else {
            var _selection$field$alia;
            fieldName = (_selection$field$alia = selection.field.alias) !== null && _selection$field$alia !== void 0 ? _selection$field$alia : selection.field.name;
        }
        switch(selection.action){
            case 'THROW':
                this._fieldErrors.push({
                    kind: 'missing_required_field.throw',
                    fieldPath: fieldName,
                    owner: owner,
                    handled: false,
                    uiContext: undefined
                });
                return;
            case 'LOG':
                this._fieldErrors.push({
                    kind: 'missing_required_field.log',
                    fieldPath: fieldName,
                    owner: owner,
                    uiContext: undefined
                });
                return;
            default:
                selection.action;
        }
    };
    _proto._handleRequiredFieldValue = function _handleRequiredFieldValue(selection, value) {
        if (value == null) {
            this._maybeReportUnexpectedNull(selection);
            return false;
        }
        return true;
    };
    _proto._catchErrors = function _catchErrors(_value, to, previousResponseFields) {
        var value = _value;
        switch(to){
            case 'RESULT':
                value = this._asResult(_value);
                break;
            case 'NULL':
                if (this._fieldErrors != null && this._fieldErrors.length > 0) value = null;
                break;
            default:
                to;
        }
        var childrenFieldErrors = this._fieldErrors;
        this._fieldErrors = previousResponseFields;
        if (childrenFieldErrors != null) {
            if (this._fieldErrors == null) this._fieldErrors = [];
            for(var i = 0; i < childrenFieldErrors.length; i++)this._fieldErrors.push($cece971fa429cdb2$var$markFieldErrorHasHandled(childrenFieldErrors[i]));
        }
        return value;
    };
    _proto._asResult = function _asResult(value) {
        if (this._fieldErrors == null || this._fieldErrors.length === 0) return {
            ok: true,
            value: value
        };
        var errors = this._fieldErrors.map(function(error) {
            switch(error.kind){
                case 'relay_field_payload.error':
                    var _error$error = error.error, message = _error$error.message, displayError = (0, $cece971fa429cdb2$var$_objectWithoutPropertiesLoose2["default"])(_error$error, $cece971fa429cdb2$var$_excluded);
                    return displayError;
                case 'missing_expected_data.throw':
                case 'missing_expected_data.log':
                    return {
                        path: error.fieldPath.split('.')
                    };
                case 'relay_resolver.error':
                    return {
                        message: "Relay: Error in resolver for field at ".concat(error.fieldPath, " in ").concat(error.owner)
                    };
                case 'missing_required_field.throw':
                    return {
                        message: "Relay: Missing @required value at path '".concat(error.fieldPath, "' in '").concat(error.owner, "'.")
                    };
                case 'missing_required_field.log':
                    return null;
                default:
                    error.kind;
                    $5Wk1R(false);
            }
        }).filter(Boolean);
        return {
            ok: false,
            errors: errors
        };
    };
    _proto._traverseSelections = function _traverseSelections(selections, record, data) {
        for(var i = 0; i < selections.length; i++){
            var selection = selections[i];
            switch(selection.kind){
                case 'RequiredField':
                    var requiredFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    if (!this._handleRequiredFieldValue(selection, requiredFieldValue)) return false;
                    break;
                case 'CatchField':
                    var _selection$field$back, _selection$field, _field$alias;
                    var previousResponseFields = this._fieldErrors;
                    this._fieldErrors = null;
                    var catchFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    var field = (_selection$field$back = (_selection$field = selection.field) === null || _selection$field === void 0 ? void 0 : _selection$field.backingField) !== null && _selection$field$back !== void 0 ? _selection$field$back : selection.field;
                    var fieldName = (_field$alias = field === null || field === void 0 ? void 0 : field.alias) !== null && _field$alias !== void 0 ? _field$alias : field === null || field === void 0 ? void 0 : field.name;
                    !(fieldName != null) && $5Wk1R(false);
                    data[fieldName] = this._catchErrors(catchFieldValue, selection.to, previousResponseFields);
                    break;
                case 'ScalarField':
                    this._readScalar(selection, record, data);
                    break;
                case 'LinkedField':
                    if (selection.plural) this._readPluralLink(selection, record, data);
                    else this._readLink(selection, record, data);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) {
                        var hasExpectedData = this._traverseSelections(selection.selections, record, data);
                        if (!hasExpectedData) return false;
                    }
                    break;
                case 'InlineFragment':
                    var _hasExpectedData = this._readInlineFragment(selection, record, data, false);
                    if (_hasExpectedData === false) return false;
                    break;
                case 'RelayLiveResolver':
                case 'RelayResolver':
                    if (this._useExecTimeResolvers) this._readScalar(selection, record, data);
                    else this._readResolverField(selection, record, data);
                    break;
                case 'FragmentSpread':
                    this._createFragmentPointer(selection, record, data);
                    break;
                case 'AliasedInlineFragmentSpread':
                    this._readAliasedInlineFragment(selection, record, data);
                    break;
                case 'ModuleImport':
                    this._readModuleImport(selection, record, data);
                    break;
                case 'InlineDataFragmentSpread':
                    this._createInlineDataOrResolverFragmentPointer(selection, record, data);
                    break;
                case 'Defer':
                case 'ClientExtension':
                    var isMissingData = this._isMissingData;
                    var alreadyMissingClientEdges = this._missingClientEdges.length;
                    this._clientEdgeTraversalPath.push(null);
                    var _hasExpectedData2 = this._traverseSelections(selection.selections, record, data);
                    this._isMissingData = isMissingData || this._missingClientEdges.length > alreadyMissingClientEdges || this._missingLiveResolverFields.length > 0;
                    this._clientEdgeTraversalPath.pop();
                    if (!_hasExpectedData2) return false;
                    break;
                case 'Stream':
                    var _hasExpectedData3 = this._traverseSelections(selection.selections, record, data);
                    if (!_hasExpectedData3) return false;
                    break;
                case 'ActorChange':
                    this._readActorChange(selection, record, data);
                    break;
                case 'ClientEdgeToClientObject':
                case 'ClientEdgeToServerObject':
                    if (this._useExecTimeResolvers && (selection.backingField.kind === 'RelayResolver' || selection.backingField.kind === 'RelayLiveResolver')) {
                        var linkedField = selection.linkedField;
                        if (linkedField.plural) this._readPluralLink(linkedField, record, data);
                        else this._readLink(linkedField, record, data);
                    } else this._readClientEdge(selection, record, data);
                    break;
                default:
                    selection;
                    $5Wk1R(false);
            }
        }
        return true;
    };
    _proto._readClientSideDirectiveField = function _readClientSideDirectiveField(selection, record, data) {
        switch(selection.field.kind){
            case 'ScalarField':
                return this._readScalar(selection.field, record, data);
            case 'LinkedField':
                if (selection.field.plural) return this._readPluralLink(selection.field, record, data);
                else return this._readLink(selection.field, record, data);
            case 'RelayResolver':
            case 'RelayLiveResolver':
                if (this._useExecTimeResolvers) return this._readScalar(selection.field, record, data);
                else return this._readResolverField(selection.field, record, data);
            case 'ClientEdgeToClientObject':
            case 'ClientEdgeToServerObject':
                if (this._useExecTimeResolvers && (selection.field.backingField.kind === 'RelayResolver' || selection.field.backingField.kind === 'RelayLiveResolver')) {
                    var field = selection.field;
                    if (field.linkedField.plural) return this._readPluralLink(field.linkedField, record, data);
                    else return this._readLink(field.linkedField, record, data);
                } else return this._readClientEdge(selection.field, record, data);
            case 'AliasedInlineFragmentSpread':
                return this._readAliasedInlineFragment(selection.field, record, data);
            default:
                selection.field.kind;
                $5Wk1R(false);
        }
    };
    _proto._readResolverField = function _readResolverField(field, record, data) {
        var _field$alias2;
        var parentRecordID = $cdcDZ.getDataID(record);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var result = this._readResolverFieldImpl(field, parentRecordID);
        var fieldName = (_field$alias2 = field.alias) !== null && _field$alias2 !== void 0 ? _field$alias2 : field.name;
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = result;
        return result;
    };
    _proto._readResolverFieldImpl = function _readResolverFieldImpl(field, parentRecordID) {
        var _this = this;
        var fragment = field.fragment;
        var snapshot;
        var getDataForResolverFragment = function getDataForResolverFragment(singularReaderSelector) {
            if (snapshot != null) return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData,
                fieldErrors: snapshot.fieldErrors
            };
            snapshot = $cece971fa429cdb2$var$read(_this._recordSource, singularReaderSelector, _this._resolverCache);
            return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData,
                fieldErrors: snapshot.fieldErrors
            };
        };
        var evaluate = function evaluate() {
            if (fragment != null) {
                var key = {
                    __id: parentRecordID,
                    __fragmentOwner: _this._owner,
                    __fragments: (0, $cece971fa429cdb2$var$_defineProperty2["default"])({}, fragment.name, fragment.args ? $cece971fa429cdb2$var$getArgumentValues(fragment.args, _this._variables) : {})
                };
                if (_this._clientEdgeTraversalPath.length > 0 && _this._clientEdgeTraversalPath[_this._clientEdgeTraversalPath.length - 1] !== null) key[$cece971fa429cdb2$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $cece971fa429cdb2$var$_toConsumableArray2["default"])(_this._clientEdgeTraversalPath);
                var resolverContext = {
                    getDataForResolverFragment: getDataForResolverFragment
                };
                return $cece971fa429cdb2$var$withResolverContext(resolverContext, function() {
                    var _getResolverValue = $cece971fa429cdb2$var$getResolverValue(field, _this._variables, key, _this._resolverContext), resolverResult = _getResolverValue[0], resolverError = _getResolverValue[1];
                    return {
                        resolverResult: resolverResult,
                        snapshot: snapshot,
                        error: resolverError
                    };
                });
            } else {
                var _getResolverValue2 = $cece971fa429cdb2$var$getResolverValue(field, _this._variables, null, _this._resolverContext), resolverResult = _getResolverValue2[0], _resolverError = _getResolverValue2[1];
                return {
                    resolverResult: resolverResult,
                    snapshot: undefined,
                    error: _resolverError
                };
            }
        };
        var _this$_resolverCache$ = this._resolverCache.readFromCacheOrEvaluate(parentRecordID, field, this._variables, evaluate, getDataForResolverFragment), result = _this$_resolverCache$[0], seenRecord = _this$_resolverCache$[1], resolverError = _this$_resolverCache$[2], cachedSnapshot = _this$_resolverCache$[3], suspenseID = _this$_resolverCache$[4], updatedDataIDs = _this$_resolverCache$[5];
        this._propagateResolverMetadata(field.path, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs);
        return result;
    };
    _proto._propagateResolverMetadata = function _propagateResolverMetadata(fieldPath, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs) {
        var _this2 = this;
        if (cachedSnapshot != null) {
            if (cachedSnapshot.missingClientEdges != null) for(var i = 0; i < cachedSnapshot.missingClientEdges.length; i++){
                var missing = cachedSnapshot.missingClientEdges[i];
                this._missingClientEdges.push(missing);
            }
            if (cachedSnapshot.missingLiveResolverFields != null) {
                this._isMissingData = this._isMissingData || cachedSnapshot.missingLiveResolverFields.length > 0;
                for(var _i = 0; _i < cachedSnapshot.missingLiveResolverFields.length; _i++){
                    var missingResolverField = cachedSnapshot.missingLiveResolverFields[_i];
                    this._missingLiveResolverFields.push(missingResolverField);
                }
            }
            if (cachedSnapshot.fieldErrors != null) {
                if (this._fieldErrors == null) this._fieldErrors = [];
                for(var _i2 = 0; _i2 < cachedSnapshot.fieldErrors.length; _i2++){
                    var _this$_selector$node$6;
                    var error = cachedSnapshot.fieldErrors[_i2];
                    if (((_this$_selector$node$6 = this._selector.node.metadata) === null || _this$_selector$node$6 === void 0 ? void 0 : _this$_selector$node$6.throwOnFieldError) === true) this._fieldErrors.push(error);
                    else this._fieldErrors.push($cece971fa429cdb2$var$markFieldErrorHasHandled(error));
                }
            }
            this._isMissingData = this._isMissingData || cachedSnapshot.isMissingData;
        }
        if (resolverError) {
            var _this$_selector$node$7, _this$_selector$node$8;
            var errorEvent = {
                kind: 'relay_resolver.error',
                fieldPath: fieldPath,
                owner: this._fragmentName,
                error: resolverError,
                shouldThrow: (_this$_selector$node$7 = (_this$_selector$node$8 = this._selector.node.metadata) === null || _this$_selector$node$8 === void 0 ? void 0 : _this$_selector$node$8.throwOnFieldError) !== null && _this$_selector$node$7 !== void 0 ? _this$_selector$node$7 : false,
                handled: false,
                uiContext: undefined
            };
            if (this._fieldErrors == null) this._fieldErrors = [
                errorEvent
            ];
            else this._fieldErrors.push(errorEvent);
        }
        if (seenRecord != null) this._seenRecords.add(seenRecord);
        if (suspenseID != null) {
            this._isMissingData = true;
            this._missingLiveResolverFields.push(suspenseID);
        }
        if (updatedDataIDs != null) updatedDataIDs.forEach(function(recordID) {
            _this2._updatedDataIDs.add(recordID);
        });
    };
    _proto._readClientEdge = function _readClientEdge(field, record, data) {
        var _this3 = this;
        var _backingField$alias;
        var backingField = field.backingField;
        !(backingField.kind !== 'ClientExtension') && $5Wk1R(false);
        var fieldName = (_backingField$alias = backingField.alias) !== null && _backingField$alias !== void 0 ? _backingField$alias : backingField.name;
        var backingFieldData = {};
        this._traverseSelections([
            backingField
        ], record, backingFieldData);
        var clientEdgeResolverResponse = backingFieldData[fieldName];
        if (clientEdgeResolverResponse == null || $cece971fa429cdb2$var$isSuspenseSentinel(clientEdgeResolverResponse)) {
            data[fieldName] = clientEdgeResolverResponse;
            return clientEdgeResolverResponse;
        }
        if (field.linkedField.plural) {
            !Array.isArray(clientEdgeResolverResponse) && $5Wk1R(false);
            var storeIDs;
            !(field.kind === 'ClientEdgeToClientObject') && $5Wk1R(false);
            if (field.backingField.normalizationInfo == null) storeIDs = clientEdgeResolverResponse.map(function(itemResponse) {
                var _field$concreteType;
                var concreteType = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : itemResponse.__typename;
                !(typeof concreteType === 'string') && $5Wk1R(false);
                var localId = $cece971fa429cdb2$var$extractIdFromResponse(itemResponse, backingField.path, _this3._owner.identifier);
                var id = _this3._resolverCache.ensureClientRecord(localId, concreteType);
                var modelResolvers = field.modelResolvers;
                if (modelResolvers != null) {
                    var modelResolver = modelResolvers[concreteType];
                    !(modelResolver !== undefined) && $5Wk1R(false);
                    var model = _this3._readResolverFieldImpl(modelResolver, id);
                    return model != null ? id : null;
                }
                return id;
            });
            else storeIDs = clientEdgeResolverResponse.map(function(obj) {
                return $cece971fa429cdb2$var$extractIdFromResponse(obj, backingField.path, _this3._owner.identifier);
            });
            this._clientEdgeTraversalPath.push(null);
            var edgeValues = this._readLinkedIds(field.linkedField, storeIDs, record, data);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValues;
            return edgeValues;
        } else {
            var _field$concreteType2;
            var id = $cece971fa429cdb2$var$extractIdFromResponse(clientEdgeResolverResponse, backingField.path, this._owner.identifier);
            var storeID;
            var concreteType = (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : clientEdgeResolverResponse.__typename;
            var traversalPathSegment;
            if (field.kind === 'ClientEdgeToClientObject') {
                if (field.backingField.normalizationInfo == null) {
                    !(typeof concreteType === 'string') && $5Wk1R(false);
                    storeID = this._resolverCache.ensureClientRecord(id, concreteType);
                    traversalPathSegment = null;
                } else {
                    storeID = id;
                    traversalPathSegment = null;
                }
            } else {
                storeID = id;
                traversalPathSegment = {
                    readerClientEdge: field,
                    clientEdgeDestinationID: id
                };
            }
            var modelResolvers = field.modelResolvers;
            if (modelResolvers != null) {
                !(typeof concreteType === 'string') && $5Wk1R(false);
                var modelResolver = modelResolvers[concreteType];
                !(modelResolver !== undefined) && $5Wk1R(false);
                var model = this._readResolverFieldImpl(modelResolver, storeID);
                if (model == null) {
                    data[fieldName] = null;
                    return null;
                }
            }
            this._clientEdgeTraversalPath.push(traversalPathSegment);
            var prevData = data[fieldName];
            !(prevData == null || typeof prevData === 'object') && $5Wk1R(false);
            var prevErrors = this._fieldErrors;
            this._fieldErrors = null;
            var edgeValue = this._traverse(field.linkedField, storeID, prevData);
            this._prependPreviousErrors(prevErrors, fieldName);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValue;
            return edgeValue;
        }
    };
    _proto._readScalar = function _readScalar(field, record, data) {
        var _field$alias3;
        var fieldName = (_field$alias3 = field.alias) !== null && _field$alias3 !== void 0 ? _field$alias3 : field.name;
        var storageKey = $cece971fa429cdb2$var$getStorageKey(field, this._variables);
        var value = $cdcDZ.getValue(record, storageKey);
        if (value === null || $3hqjB.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(value) && value.length === 0) this._maybeAddFieldErrors(record, storageKey);
        else if (value === undefined) this._markDataAsMissing(fieldName);
        data[fieldName] = value;
        return value;
    };
    _proto._readLink = function _readLink(field, record, data) {
        var _field$alias4;
        var fieldName = (_field$alias4 = field.alias) !== null && _field$alias4 !== void 0 ? _field$alias4 : field.name;
        var storageKey = $cece971fa429cdb2$var$getStorageKey(field, this._variables);
        var linkedID = $cdcDZ.getLinkedRecordID(record, storageKey);
        if (linkedID == null) {
            data[fieldName] = linkedID;
            if (linkedID === null) this._maybeAddFieldErrors(record, storageKey);
            else if (linkedID === undefined) this._markDataAsMissing(fieldName);
            return linkedID;
        }
        var prevData = data[fieldName];
        !(prevData == null || typeof prevData === 'object') && $5Wk1R(false);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var value = this._traverse(field, linkedID, prevData);
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = value;
        return value;
    };
    _proto._prependPreviousErrors = function _prependPreviousErrors(prevErrors, fieldNameOrIndex) {
        if (this._fieldErrors != null) {
            for(var i = 0; i < this._fieldErrors.length; i++){
                var event = this._fieldErrors[i];
                if (event.owner === this._fragmentName && (event.kind === 'missing_expected_data.throw' || event.kind === 'missing_expected_data.log' || event.kind === 'missing_required_field.throw' || event.kind === 'missing_required_field.log')) event.fieldPath = "".concat(fieldNameOrIndex, ".").concat(event.fieldPath);
            }
            if (prevErrors != null) {
                for(var _i3 = this._fieldErrors.length - 1; _i3 >= 0; _i3--)prevErrors.push(this._fieldErrors[_i3]);
                this._fieldErrors = prevErrors;
            }
        } else this._fieldErrors = prevErrors;
    };
    _proto._readActorChange = function _readActorChange(field, record, data) {
        var _field$alias5;
        var fieldName = (_field$alias5 = field.alias) !== null && _field$alias5 !== void 0 ? _field$alias5 : field.name;
        var storageKey = $cece971fa429cdb2$var$getStorageKey(field, this._variables);
        var externalRef = $cdcDZ.getActorLinkedRecordID(record, storageKey);
        if (externalRef == null) {
            data[fieldName] = externalRef;
            if (externalRef === undefined) this._markDataAsMissing(fieldName);
            else if (externalRef === null) this._maybeAddFieldErrors(record, storageKey);
            return data[fieldName];
        }
        var actorIdentifier = externalRef[0], dataID = externalRef[1];
        var fragmentRef = {};
        this._createFragmentPointer(field.fragmentSpread, $cdcDZ.fromObject({
            __id: dataID
        }), fragmentRef);
        data[fieldName] = {
            __fragmentRef: fragmentRef,
            __viewer: actorIdentifier
        };
        return data[fieldName];
    };
    _proto._readPluralLink = function _readPluralLink(field, record, data) {
        var storageKey = $cece971fa429cdb2$var$getStorageKey(field, this._variables);
        var linkedIDs = $cdcDZ.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs === null || $3hqjB.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(linkedIDs) && linkedIDs.length === 0) this._maybeAddFieldErrors(record, storageKey);
        return this._readLinkedIds(field, linkedIDs, record, data);
    };
    _proto._readLinkedIds = function _readLinkedIds(field, linkedIDs, record, data) {
        var _this4 = this;
        var _field$alias6;
        var fieldName = (_field$alias6 = field.alias) !== null && _field$alias6 !== void 0 ? _field$alias6 : field.name;
        if (linkedIDs == null) {
            data[fieldName] = linkedIDs;
            if (linkedIDs === undefined) this._markDataAsMissing(fieldName);
            return linkedIDs;
        }
        var prevData = data[fieldName];
        !(prevData == null || Array.isArray(prevData)) && $5Wk1R(false);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var linkedArray = prevData || [];
        linkedIDs.forEach(function(linkedID, nextIndex) {
            if (linkedID == null) {
                if (linkedID === undefined) _this4._markDataAsMissing(String(nextIndex));
                linkedArray[nextIndex] = linkedID;
                return;
            }
            var prevItem = linkedArray[nextIndex];
            !(prevItem == null || typeof prevItem === 'object') && $5Wk1R(false);
            var prevErrors = _this4._fieldErrors;
            _this4._fieldErrors = null;
            linkedArray[nextIndex] = _this4._traverse(field, linkedID, prevItem);
            _this4._prependPreviousErrors(prevErrors, nextIndex);
        });
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = linkedArray;
        return linkedArray;
    };
    _proto._readModuleImport = function _readModuleImport(moduleImport, record, data) {
        var componentKey = $cece971fa429cdb2$var$getModuleComponentKey(moduleImport.documentName);
        var relayStoreComponent = $cdcDZ.getValue(record, componentKey);
        var component = relayStoreComponent !== undefined ? relayStoreComponent : moduleImport.componentModuleProvider;
        if (component == null) {
            if (component === undefined) this._markDataAsMissing('<module-import>');
            return;
        }
        this._createFragmentPointer({
            kind: 'FragmentSpread',
            name: moduleImport.fragmentName,
            args: moduleImport.args
        }, record, data);
        data[$cece971fa429cdb2$var$FRAGMENT_PROP_NAME_KEY] = moduleImport.fragmentPropName;
        data[$cece971fa429cdb2$var$MODULE_COMPONENT_KEY] = component;
    };
    _proto._readAliasedInlineFragment = function _readAliasedInlineFragment(aliasedInlineFragment, record, data) {
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var fieldValue = this._readInlineFragment(aliasedInlineFragment.fragment, record, {}, true);
        this._prependPreviousErrors(prevErrors, aliasedInlineFragment.name);
        if (fieldValue === false) fieldValue = null;
        data[aliasedInlineFragment.name] = fieldValue;
    };
    _proto._readInlineFragment = function _readInlineFragment(inlineFragment, record, data, skipUnmatchedAbstractTypes) {
        if (inlineFragment.type == null) {
            var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
            if (hasExpectedData === false) return false;
            return data;
        }
        var abstractKey = inlineFragment.abstractKey;
        if (abstractKey == null) {
            if (!this._recordMatchesTypeCondition(record, inlineFragment.type)) return null;
            else {
                var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
                if (!hasExpectedData) return false;
            }
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false && skipUnmatchedAbstractTypes) return null;
            var parentIsMissingData = this._isMissingData;
            var parentIsWithinUnmatchedTypeRefinement = this._isWithinUnmatchedTypeRefinement;
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement || implementsInterface === false;
            var hasMissingData = this._traverseSelections(inlineFragment.selections, record, data);
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement;
            if (implementsInterface === false) {
                this._isMissingData = parentIsMissingData;
                return null;
            } else if (implementsInterface == null) return undefined;
            else if (hasMissingData === false) return false;
        }
        return data;
    };
    _proto._recordMatchesTypeCondition = function _recordMatchesTypeCondition(record, type) {
        var typeName = $cdcDZ.getType(record);
        return typeName != null && typeName === type || $cdcDZ.getDataID(record) === $cece971fa429cdb2$var$ROOT_ID;
    };
    _proto._createFragmentPointer = function _createFragmentPointer(fragmentSpread, record, data) {
        var fragmentPointers = data[$cece971fa429cdb2$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$cece971fa429cdb2$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $5Wk1R(false);
        if (data[$cece971fa429cdb2$var$ID_KEY] == null) data[$cece971fa429cdb2$var$ID_KEY] = $cdcDZ.getDataID(record);
        fragmentPointers[fragmentSpread.name] = $cece971fa429cdb2$var$getArgumentValues(fragmentSpread.args, this._variables, this._isWithinUnmatchedTypeRefinement);
        data[$cece971fa429cdb2$var$FRAGMENT_OWNER_KEY] = this._owner;
        if (this._clientEdgeTraversalPath.length > 0 && this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1] !== null) data[$cece971fa429cdb2$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $cece971fa429cdb2$var$_toConsumableArray2["default"])(this._clientEdgeTraversalPath);
    };
    _proto._createInlineDataOrResolverFragmentPointer = function _createInlineDataOrResolverFragmentPointer(fragmentSpreadOrFragment, record, data) {
        var fragmentPointers = data[$cece971fa429cdb2$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$cece971fa429cdb2$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $5Wk1R(false);
        if (data[$cece971fa429cdb2$var$ID_KEY] == null) data[$cece971fa429cdb2$var$ID_KEY] = $cdcDZ.getDataID(record);
        var inlineData = {};
        var parentFragmentName = this._fragmentName;
        this._fragmentName = fragmentSpreadOrFragment.name;
        var parentVariables = this._variables;
        var argumentVariables = fragmentSpreadOrFragment.args ? $cece971fa429cdb2$var$getArgumentValues(fragmentSpreadOrFragment.args, this._variables) : {};
        this._variables = $gQ9aH.getFragmentVariables(fragmentSpreadOrFragment, this._owner.variables, argumentVariables);
        this._traverseSelections(fragmentSpreadOrFragment.selections, record, inlineData);
        this._variables = parentVariables;
        this._fragmentName = parentFragmentName;
        fragmentPointers[fragmentSpreadOrFragment.name] = inlineData;
    };
    _proto._implementsInterface = function _implementsInterface(record, abstractKey) {
        var typeName = $cdcDZ.getType(record);
        var typeRecord = this._recordSource.get($cece971fa429cdb2$var$generateTypeID(typeName));
        var implementsInterface = typeRecord != null ? $cdcDZ.getValue(typeRecord, abstractKey) : null;
        if (implementsInterface == null) this._markDataAsMissing('<abstract-type-hint>');
        return implementsInterface;
    };
    return RelayReader;
}();
function $cece971fa429cdb2$var$markFieldErrorHasHandled(event) {
    switch(event.kind){
        case 'missing_expected_data.throw':
        case 'missing_required_field.throw':
        case 'relay_field_payload.error':
        case 'relay_resolver.error':
            return (0, $cece971fa429cdb2$var$_objectSpread2["default"])((0, $cece971fa429cdb2$var$_objectSpread2["default"])({}, event), {}, {
                handled: true
            });
        case 'missing_expected_data.log':
        case 'missing_required_field.log':
            return event;
        default:
            event.kind;
            $5Wk1R(false);
    }
}
function $cece971fa429cdb2$var$getResolverValue(field, variables, fragmentKey, resolverContext) {
    var resolverFunction = typeof field.resolverModule === 'function' ? field.resolverModule : field.resolverModule["default"];
    var resolverResult = null;
    var resolverError = null;
    try {
        var resolverFunctionArgs = [];
        if (field.fragment != null) resolverFunctionArgs.push(fragmentKey);
        var args = field.args ? $cece971fa429cdb2$var$getArgumentValues(field.args, variables) : undefined;
        resolverFunctionArgs.push(args);
        resolverFunctionArgs.push(resolverContext);
        resolverResult = resolverFunction.apply(null, resolverFunctionArgs);
    } catch (e) {
        resolverResult = null;
        if (e !== $cece971fa429cdb2$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL) resolverError = e;
    }
    return [
        resolverResult,
        resolverError
    ];
}
function $cece971fa429cdb2$var$extractIdFromResponse(individualResponse, path, owner) {
    if (typeof individualResponse === 'string') return individualResponse;
    else if (typeof individualResponse === 'object' && individualResponse != null && typeof individualResponse.id === 'string') return individualResponse.id;
    $5Wk1R(false);
}
module.exports = {
    read: $cece971fa429cdb2$var$read
};

});
parcelRegister("kj38x", function(module, exports) {
'use strict';

var $eqz8c = parcelRequire("eqz8c");
var $ec8803df44e57eaa$var$RELAY_LIVE_RESOLVER = $eqz8c.RELAY_LIVE_RESOLVER;

var $5Wk1R = parcelRequire("5Wk1R");
var $ec8803df44e57eaa$var$NoopResolverCache = /*#__PURE__*/ function() {
    function NoopResolverCache() {}
    var _proto = NoopResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        !(field.kind !== $ec8803df44e57eaa$var$RELAY_LIVE_RESOLVER) && $5Wk1R(false);
        var _evaluate = evaluate(), resolverResult = _evaluate.resolverResult, snapshot = _evaluate.snapshot, error = _evaluate.error;
        return [
            resolverResult,
            undefined,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {};
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        $5Wk1R(false);
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {};
    return NoopResolverCache;
}();
module.exports = {
    NoopResolverCache: $ec8803df44e57eaa$var$NoopResolverCache
};

});


parcelRegister("jMnLs", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $e664ef280345bb61$var$_interopRequireDefault = $bGHxy.default;

var $e664ef280345bb61$var$_createForOfIteratorHelper2 = $e664ef280345bb61$var$_interopRequireDefault((parcelRequire("cXbK5")));

var $8FBJK = parcelRequire("8FBJK");

var $6m3Ro = parcelRequire("6m3Ro");

var $evc83 = parcelRequire("evc83");

var $gQ9aH = parcelRequire("gQ9aH");
var $e664ef280345bb61$var$getLocalVariables = $gQ9aH.getLocalVariables;

var $cdcDZ = parcelRequire("cdcDZ");

var $5vBPt = parcelRequire("5vBPt");

var $h3ajd = parcelRequire("h3ajd");
var $e664ef280345bb61$var$generateTypeID = $h3ajd.generateTypeID;

var $5Wk1R = parcelRequire("5Wk1R");
var $e664ef280345bb61$var$getReadTimeResolverStorageKey = $5vBPt.getReadTimeResolverStorageKey, $e664ef280345bb61$var$getStorageKey = $5vBPt.getStorageKey, $e664ef280345bb61$var$getModuleOperationKey = $5vBPt.getModuleOperationKey;
function $e664ef280345bb61$var$mark(recordSource, selector, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var marker = new $e664ef280345bb61$var$RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers);
    marker.mark(node, dataID);
}
var $e664ef280345bb61$var$RelayReferenceMarker = /*#__PURE__*/ function() {
    function RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers) {
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._operationName = null;
        this._useExecTimeResolvers = useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false;
        this._recordSource = recordSource;
        this._references = references;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = RelayReferenceMarker.prototype;
    _proto.mark = function mark(node, dataID) {
        if (node.kind === 'Operation' || node.kind === 'SplitOperation') this._operationName = node.name;
        this._traverse(node, dataID);
    };
    _proto._traverse = function _traverse(node, dataID) {
        this._references.add(dataID);
        var record = this._recordSource.get(dataID);
        if (record == null) return;
        this._traverseSelections(node.selections, record);
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $5Wk1R(false);
        return this._variables[name];
    };
    _proto._traverseSelections = function _traverseSelections(selections, record) {
        var _this = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case 'ActorChange':
                    _this._traverseLink(selection.linkedField, record);
                    break;
                case 'LinkedField':
                    if (selection.plural) _this._traversePluralLink(selection, record);
                    else _this._traverseLink(selection, record);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(_this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this._traverseSelections(selection.selections, record);
                    break;
                case 'InlineFragment':
                    if (selection.abstractKey == null) {
                        var typeName = $cdcDZ.getType(record);
                        if (typeName != null && typeName === selection.type || typeName === $5vBPt.ROOT_TYPE) _this._traverseSelections(selection.selections, record);
                    } else {
                        var _typeName = $cdcDZ.getType(record);
                        var typeID = $e664ef280345bb61$var$generateTypeID(_typeName);
                        _this._references.add(typeID);
                        _this._traverseSelections(selection.selections, record);
                    }
                    break;
                case 'FragmentSpread':
                    var prevVariables = _this._variables;
                    _this._variables = $e664ef280345bb61$var$getLocalVariables(_this._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this._traverseSelections(selection.fragment.selections, record);
                    _this._variables = prevVariables;
                    break;
                case 'LinkedHandle':
                    var handleField = $6m3Ro(selection, selections, _this._variables);
                    if (handleField.plural) _this._traversePluralLink(handleField, record);
                    else _this._traverseLink(handleField, record);
                    break;
                case 'Defer':
                case 'Stream':
                    _this._traverseSelections(selection.selections, record);
                    break;
                case 'ScalarField':
                case 'ScalarHandle':
                    break;
                case 'TypeDiscriminator':
                    var _typeName2 = $cdcDZ.getType(record);
                    var _typeID = $e664ef280345bb61$var$generateTypeID(_typeName2);
                    _this._references.add(_typeID);
                    break;
                case 'ModuleImport':
                    _this._traverseModuleImport(selection, record);
                    break;
                case 'ClientExtension':
                    _this._traverseSelections(selection.selections, record);
                    break;
                case 'ClientComponent':
                    if (_this._shouldProcessClientComponents === false) break;
                    _this._traverseSelections(selection.fragment.selections, record);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    _this._traverseResolverField(selection, record);
                    break;
                case 'ClientEdgeToClientObject':
                    _this._traverseClientEdgeToClientObject(selection, record);
                    break;
                default:
                    selection;
                    $5Wk1R(false);
            }
        });
    };
    _proto._traverseClientEdgeToClientObject = function _traverseClientEdgeToClientObject(field, record) {
        if (this._useExecTimeResolvers) {
            this._traverseLink(field.linkedField, record);
            return;
        }
        var dataID = this._traverseResolverField(field.backingField, record);
        if (dataID == null) return;
        var resolverRecord = this._recordSource.get(dataID);
        if (resolverRecord == null) return;
        if (field.backingField.isOutputType) {
            var outputTypeRecordIDs = $evc83(resolverRecord);
            if (outputTypeRecordIDs != null) {
                var _iterator = (0, $e664ef280345bb61$var$_createForOfIteratorHelper2["default"])(outputTypeRecordIDs), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _dataID = _step.value;
                        this._references.add(_dataID);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        } else {
            var linkedField = field.linkedField;
            var concreteType = linkedField.concreteType;
            if (concreteType == null) return;
            if (linkedField.plural) {
                var dataIDs = $cdcDZ.getResolverLinkedRecordIDs(resolverRecord, concreteType);
                if (dataIDs != null) {
                    var _iterator2 = (0, $e664ef280345bb61$var$_createForOfIteratorHelper2["default"])(dataIDs), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _dataID2 = _step2.value;
                            if (_dataID2 != null) this._traverse(linkedField, _dataID2);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            } else {
                var _dataID3 = $cdcDZ.getResolverLinkedRecordID(resolverRecord, concreteType);
                if (_dataID3 != null) this._traverse(linkedField, _dataID3);
            }
        }
    };
    _proto._traverseResolverField = function _traverseResolverField(field, record) {
        if (this._useExecTimeResolvers) return;
        var storageKey = $e664ef280345bb61$var$getReadTimeResolverStorageKey(field, this._variables);
        var dataID = $cdcDZ.getLinkedRecordID(record, storageKey);
        if (dataID != null) this._references.add(dataID);
        var fragment = field.fragment;
        if (fragment != null) this._traverseSelections([
            fragment
        ], record);
        return dataID;
    };
    _proto._traverseModuleImport = function _traverseModuleImport(moduleImport, record) {
        var _this$_operationName;
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $5Wk1R(false);
        var operationKey = $e664ef280345bb61$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = $cdcDZ.getValue(record, operationKey);
        if (operationReference == null) return;
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $8FBJK(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $e664ef280345bb61$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverseSelections(operation.selections, record);
            this._variables = prevVariables;
        }
    };
    _proto._traverseLink = function _traverseLink(field, record) {
        var storageKey = $e664ef280345bb61$var$getStorageKey(field, this._variables);
        var linkedID = $cdcDZ.getLinkedRecordID(record, storageKey);
        if (linkedID == null) return;
        this._traverse(field, linkedID);
    };
    _proto._traversePluralLink = function _traversePluralLink(field, record) {
        var _this2 = this;
        var storageKey = $e664ef280345bb61$var$getStorageKey(field, this._variables);
        var linkedIDs = $cdcDZ.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs == null) return;
        linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this2._traverse(field, linkedID);
        });
    };
    return RelayReferenceMarker;
}();
module.exports = {
    mark: $e664ef280345bb61$var$mark
};

});

parcelRegister("fPYIp", function(module, exports) {
'use strict';
parcelRequire("a9DXr");

var $7hYYU = parcelRequire("7hYYU");

var $3hqjB = parcelRequire("3hqjB");

var $4oeNy = parcelRequire("4oeNy");

var $7vYAC = parcelRequire("7vYAC");

var $hKPnN = parcelRequire("hKPnN");
var $b87ab73ea0d79d57$var$RelayStoreSubscriptions = /*#__PURE__*/ function() {
    function RelayStoreSubscriptions(log, resolverCache, resolverContext) {
        this._subscriptions = new Set();
        this.__log = log;
        this._resolverCache = resolverCache;
        this._resolverContext = resolverContext;
    }
    var _proto = RelayStoreSubscriptions.prototype;
    _proto.subscribe = function subscribe(snapshot, callback) {
        var _this = this;
        var subscription = {
            backup: null,
            callback: callback,
            snapshot: snapshot,
            stale: false
        };
        var dispose = function dispose() {
            _this._subscriptions["delete"](subscription);
        };
        this._subscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto.snapshotSubscriptions = function snapshotSubscriptions(source) {
        var _this2 = this;
        this._subscriptions.forEach(function(subscription) {
            if (!subscription.stale) {
                subscription.backup = subscription.snapshot;
                return;
            }
            var snapshot = subscription.snapshot;
            var backup = $hKPnN.read(source, snapshot.selector, _this2._resolverCache, _this2._resolverContext);
            var nextData = $7hYYU(snapshot.data, backup.data);
            backup.data = nextData;
            subscription.backup = backup;
        });
    };
    _proto.restoreSubscriptions = function restoreSubscriptions() {
        this._subscriptions.forEach(function(subscription) {
            var backup = subscription.backup;
            subscription.backup = null;
            if (backup) {
                if (backup.data !== subscription.snapshot.data) subscription.stale = true;
                subscription.snapshot = {
                    data: subscription.snapshot.data,
                    isMissingData: backup.isMissingData,
                    missingClientEdges: backup.missingClientEdges,
                    missingLiveResolverFields: backup.missingLiveResolverFields,
                    seenRecords: backup.seenRecords,
                    selector: backup.selector,
                    fieldErrors: backup.fieldErrors
                };
            } else subscription.stale = true;
        });
    };
    _proto.updateSubscriptions = function updateSubscriptions(source, updatedRecordIDs, updatedOwners, sourceOperation) {
        var _this3 = this;
        var hasUpdatedRecords = updatedRecordIDs.size !== 0;
        this._subscriptions.forEach(function(subscription) {
            var owner = _this3._updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation);
            if (owner != null) updatedOwners.push(owner);
        });
    };
    _proto._updateSubscription = function _updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation) {
        var backup = subscription.backup, callback = subscription.callback, snapshot = subscription.snapshot, stale = subscription.stale;
        var hasOverlappingUpdates = hasUpdatedRecords && $4oeNy(snapshot.seenRecords, updatedRecordIDs);
        if (!stale && !hasOverlappingUpdates) return;
        var nextSnapshot = hasOverlappingUpdates || !backup ? $hKPnN.read(source, snapshot.selector, this._resolverCache, this._resolverContext) : backup;
        var nextData = $7hYYU(snapshot.data, nextSnapshot.data);
        nextSnapshot = {
            data: nextData,
            isMissingData: nextSnapshot.isMissingData,
            missingClientEdges: nextSnapshot.missingClientEdges,
            missingLiveResolverFields: nextSnapshot.missingLiveResolverFields,
            seenRecords: nextSnapshot.seenRecords,
            selector: nextSnapshot.selector,
            fieldErrors: nextSnapshot.fieldErrors
        };
        subscription.snapshot = nextSnapshot;
        subscription.stale = false;
        if (nextSnapshot.data !== snapshot.data) {
            if (this.__log && $3hqjB.ENABLE_NOTIFY_SUBSCRIPTION) this.__log({
                name: 'store.notify.subscription',
                sourceOperation: sourceOperation,
                snapshot: snapshot,
                nextSnapshot: nextSnapshot
            });
            callback(nextSnapshot);
            return snapshot.selector.owner;
        }
        if ($3hqjB.ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION && (stale || $7vYAC(snapshot.seenRecords, updatedRecordIDs))) return snapshot.selector.owner;
    };
    _proto.size = function size() {
        return this._subscriptions.size;
    };
    return RelayStoreSubscriptions;
}();
module.exports = $b87ab73ea0d79d57$var$RelayStoreSubscriptions;

});
parcelRegister("4oeNy", function(module, exports) {
'use strict';
var $3324e1f75e764c27$var$ITERATOR_KEY = Symbol.iterator;
function $3324e1f75e764c27$var$hasOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$3324e1f75e764c27$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key)) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $3324e1f75e764c27$var$hasOverlappingIDs;

});

parcelRegister("7vYAC", function(module, exports) {
'use strict';

var $5vBPt = parcelRequire("5vBPt");
var $578a6d82067fbe2c$var$ROOT_ID = $5vBPt.ROOT_ID;

var $cBCPf = parcelRequire("cBCPf");
var $578a6d82067fbe2c$var$VIEWER_ID = $cBCPf.VIEWER_ID;
var $578a6d82067fbe2c$var$ITERATOR_KEY = Symbol.iterator;
function $578a6d82067fbe2c$var$hasSignificantOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$578a6d82067fbe2c$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key) && key !== $578a6d82067fbe2c$var$ROOT_ID && key !== $578a6d82067fbe2c$var$VIEWER_ID) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $578a6d82067fbe2c$var$hasSignificantOverlappingIDs;

});



parcelRegister("d2OIe", function(module, exports) {
'use strict';
var $97f2ccb34f94d652$var$_global$ErrorUtils$ap, $97f2ccb34f94d652$var$_global$ErrorUtils;

var $lNhcP = parcelRequire("lNhcP");

var $8OQuk = parcelRequire("8OQuk");

var $YpwTr = parcelRequire("YpwTr");

var $3hqjB = parcelRequire("3hqjB");

var $hKPnN = parcelRequire("hKPnN");

var $qckAk = parcelRequire("qckAk");

var $5Wk1R = parcelRequire("5Wk1R");
parcelRequire("91yGl");
var $97f2ccb34f94d652$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
var $97f2ccb34f94d652$var$applyWithGuard = ($97f2ccb34f94d652$var$_global$ErrorUtils$ap = $97f2ccb34f94d652$var$_global === null || $97f2ccb34f94d652$var$_global === void 0 ? void 0 : ($97f2ccb34f94d652$var$_global$ErrorUtils = $97f2ccb34f94d652$var$_global.ErrorUtils) === null || $97f2ccb34f94d652$var$_global$ErrorUtils === void 0 ? void 0 : $97f2ccb34f94d652$var$_global$ErrorUtils.applyWithGuard) !== null && $97f2ccb34f94d652$var$_global$ErrorUtils$ap !== void 0 ? $97f2ccb34f94d652$var$_global$ErrorUtils$ap : function(callback, context, args, onError, name) {
    return callback.apply(context, args);
};
var $97f2ccb34f94d652$var$RelayPublishQueue = /*#__PURE__*/ function() {
    function RelayPublishQueue(store, handlerProvider, getDataID, missingFieldHandlers, log) {
        this._hasStoreSnapshot = false;
        this._handlerProvider = handlerProvider || null;
        this._pendingBackupRebase = false;
        this._pendingData = new Set();
        this._pendingOptimisticUpdates = new Set();
        this._store = store;
        this._appliedOptimisticUpdates = new Set();
        this._gcHold = null;
        this._getDataID = getDataID;
        this._missingFieldHandlers = missingFieldHandlers;
        this._log = log;
    }
    var _proto = RelayPublishQueue.prototype;
    _proto.applyUpdate = function applyUpdate(updater) {
        !(!this._appliedOptimisticUpdates.has(updater) && !this._pendingOptimisticUpdates.has(updater)) && $5Wk1R(false);
        this._pendingOptimisticUpdates.add(updater);
    };
    _proto.revertUpdate = function revertUpdate(updater) {
        if (this._pendingOptimisticUpdates.has(updater)) this._pendingOptimisticUpdates["delete"](updater);
        else if (this._appliedOptimisticUpdates.has(updater)) {
            this._pendingBackupRebase = true;
            this._appliedOptimisticUpdates["delete"](updater);
        }
    };
    _proto.revertAll = function revertAll() {
        this._pendingBackupRebase = true;
        this._pendingOptimisticUpdates.clear();
        this._appliedOptimisticUpdates.clear();
    };
    _proto.commitPayload = function commitPayload(operation, payload, updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'payload',
            operation: operation,
            payload: payload,
            updater: updater
        });
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'updater',
            updater: updater
        });
    };
    _proto.commitSource = function commitSource(source) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'source',
            source: source
        });
    };
    _proto.run = function run(sourceOperation) {
        var runWillClearGcHold = this._appliedOptimisticUpdates === 0 && !!this._gcHold;
        var runIsANoop = !this._pendingBackupRebase && this._pendingOptimisticUpdates.size === 0 && !runWillClearGcHold;
        $3hqjB.DISALLOW_NESTED_UPDATES && !(this._isRunning !== true) && $5Wk1R(false);
        this._isRunning = true;
        if (runIsANoop) {
            this._isRunning = false;
            return [];
        }
        if (this._pendingBackupRebase) {
            if (this._hasStoreSnapshot) {
                this._store.restore();
                this._hasStoreSnapshot = false;
            }
        }
        var invalidatedStore = this._commitData();
        if (this._pendingOptimisticUpdates.size || this._pendingBackupRebase && this._appliedOptimisticUpdates.size) {
            if (!this._hasStoreSnapshot) {
                this._store.snapshot();
                this._hasStoreSnapshot = true;
            }
            this._applyUpdates();
        }
        this._pendingBackupRebase = false;
        if (this._appliedOptimisticUpdates.size > 0) {
            if (!this._gcHold) this._gcHold = this._store.holdGC();
        } else if (this._gcHold) {
            this._gcHold.dispose();
            this._gcHold = null;
        }
        this._isRunning = false;
        return this._store.notify(sourceOperation, invalidatedStore);
    };
    _proto._publishSourceFromPayload = function _publishSourceFromPayload(pendingPayload) {
        var _this = this;
        var payload = pendingPayload.payload, operation = pendingPayload.operation, updater = pendingPayload.updater;
        var source = payload.source, fieldPayloads = payload.fieldPayloads;
        var mutator = new $lNhcP(this._store.getSource(), source);
        var recordSourceProxy = new $8OQuk(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers, this._log);
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $5Wk1R(false);
            handler.update(recordSourceProxy, fieldPayload);
        });
        if (updater) {
            var selector = operation.fragment;
            !(selector != null) && $5Wk1R(false);
            var recordSourceSelectorProxy = new $YpwTr(mutator, recordSourceProxy, selector, this._missingFieldHandlers);
            var selectorData = $97f2ccb34f94d652$var$lookupSelector(source, selector);
            updater(recordSourceSelectorProxy, selectorData);
        }
        var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
        this._store.publish(source, idsMarkedForInvalidation);
        return recordSourceProxy.isStoreMarkedForInvalidation();
    };
    _proto._commitData = function _commitData() {
        var _this2 = this;
        if (!this._pendingData.size) return false;
        var invalidatedStore = false;
        this._pendingData.forEach(function(data) {
            if (data.kind === 'payload') {
                var payloadInvalidatedStore = _this2._publishSourceFromPayload(data);
                invalidatedStore = invalidatedStore || payloadInvalidatedStore;
            } else if (data.kind === 'source') {
                var source = data.source;
                _this2._store.publish(source);
            } else {
                var updater = data.updater;
                var sink = $qckAk.create();
                var mutator = new $lNhcP(_this2._store.getSource(), sink);
                var recordSourceProxy = new $8OQuk(mutator, _this2._getDataID, _this2._handlerProvider, _this2._missingFieldHandlers, _this2._log);
                $97f2ccb34f94d652$var$applyWithGuard(updater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:commitData');
                invalidatedStore = invalidatedStore || recordSourceProxy.isStoreMarkedForInvalidation();
                var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
                _this2._store.publish(sink, idsMarkedForInvalidation);
            }
        });
        this._pendingData.clear();
        return invalidatedStore;
    };
    _proto._applyUpdates = function _applyUpdates() {
        var _this3 = this;
        var sink = $qckAk.create();
        var mutator = new $lNhcP(this._store.getSource(), sink);
        var recordSourceProxy = new $8OQuk(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers, this._log);
        var processUpdate = function processUpdate(optimisticUpdate) {
            if (optimisticUpdate.storeUpdater) {
                var storeUpdater = optimisticUpdate.storeUpdater;
                $97f2ccb34f94d652$var$applyWithGuard(storeUpdater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:applyUpdates');
            } else {
                var operation = optimisticUpdate.operation, payload = optimisticUpdate.payload, updater = optimisticUpdate.updater;
                var source = payload.source, fieldPayloads = payload.fieldPayloads;
                if (source) recordSourceProxy.publishSource(source, fieldPayloads);
                if (updater) {
                    var selectorData;
                    if (source) selectorData = $97f2ccb34f94d652$var$lookupSelector(source, operation.fragment);
                    var recordSourceSelectorProxy = new $YpwTr(mutator, recordSourceProxy, operation.fragment, _this3._missingFieldHandlers);
                    $97f2ccb34f94d652$var$applyWithGuard(updater, null, [
                        recordSourceSelectorProxy,
                        selectorData
                    ], null, 'RelayPublishQueue:applyUpdates');
                }
            }
        };
        if (this._pendingBackupRebase && this._appliedOptimisticUpdates.size) this._appliedOptimisticUpdates.forEach(processUpdate);
        if (this._pendingOptimisticUpdates.size) {
            this._pendingOptimisticUpdates.forEach(function(optimisticUpdate) {
                processUpdate(optimisticUpdate);
                _this3._appliedOptimisticUpdates.add(optimisticUpdate);
            });
            this._pendingOptimisticUpdates.clear();
        }
        this._store.publish(sink);
    };
    return RelayPublishQueue;
}();
function $97f2ccb34f94d652$var$lookupSelector(source, selector) {
    var selectorData = $hKPnN.read(source, selector).data;
    var deepFreeze;
    return selectorData;
}
module.exports = $97f2ccb34f94d652$var$RelayPublishQueue;

});
parcelRegister("YpwTr", function(module, exports) {
'use strict';

var $5vBPt = parcelRequire("5vBPt");
var $0b59685869cee3fa$var$ROOT_TYPE = $5vBPt.ROOT_TYPE, $0b59685869cee3fa$var$getStorageKey = $5vBPt.getStorageKey;

var $e8KXb = parcelRequire("e8KXb");
var $0b59685869cee3fa$var$_readUpdatableFragment = $e8KXb.readUpdatableFragment;

var $jQ76a = parcelRequire("jQ76a");
var $0b59685869cee3fa$var$_readUpdatableQuery = $jQ76a.readUpdatableQuery;

var $5Wk1R = parcelRequire("5Wk1R");
var $0b59685869cee3fa$var$RelayRecordSourceSelectorProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceSelectorProxy(mutator, recordSource, readSelector, missingFieldHandlers) {
        this.__mutator = mutator;
        this.__recordSource = recordSource;
        this._readSelector = readSelector;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceSelectorProxy.prototype;
    _proto.create = function create(dataID, typeName) {
        return this.__recordSource.create(dataID, typeName);
    };
    _proto["delete"] = function _delete(dataID) {
        this.__recordSource["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        return this.__recordSource.get(dataID);
    };
    _proto.getRoot = function getRoot() {
        return this.__recordSource.getRoot();
    };
    _proto.getOperationRoot = function getOperationRoot() {
        var root = this.__recordSource.get(this._readSelector.dataID);
        if (!root) root = this.__recordSource.create(this._readSelector.dataID, $0b59685869cee3fa$var$ROOT_TYPE);
        return root;
    };
    _proto._getRootField = function _getRootField(selector, fieldName, plural) {
        var field = selector.node.selections.find(function(selection) {
            return selection.kind === 'LinkedField' && selection.name === fieldName || selection.kind === 'RequiredField' && selection.field.name === fieldName;
        });
        if (field && field.kind === 'RequiredField') field = field.field;
        !(field && field.kind === 'LinkedField') && $5Wk1R(false);
        !(field.plural === plural) && $5Wk1R(false);
        return field;
    };
    _proto.getRootField = function getRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, false);
        var storageKey = $0b59685869cee3fa$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecord(storageKey);
    };
    _proto.getPluralRootField = function getPluralRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, true);
        var storageKey = $0b59685869cee3fa$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecords(storageKey);
    };
    _proto.invalidateStore = function invalidateStore() {
        this.__recordSource.invalidateStore();
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $0b59685869cee3fa$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $0b59685869cee3fa$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceSelectorProxy;
}();
module.exports = $0b59685869cee3fa$var$RelayRecordSourceSelectorProxy;

});



parcelRegister("aOgBE", function(module, exports) {
'use strict';

var $IbWT2 = parcelRequire("IbWT2");

var $5AvhW = parcelRequire("5AvhW");
var $7deb749254dbd766$var$getRequest = $5AvhW.getRequest;

var $f2NQb = parcelRequire("f2NQb");
var $7deb749254dbd766$var$createOperationDescriptor = $f2NQb.createOperationDescriptor;

var $dTSGA = parcelRequire("dTSGA");
var $7deb749254dbd766$var$createReaderSelector = $dTSGA.createReaderSelector;
parcelRequire("91yGl");
function $7deb749254dbd766$var$requestSubscription(environment, config) {
    var subscription = $7deb749254dbd766$var$getRequest(config.subscription);
    if (subscription.params.operationKind !== 'subscription') throw new Error('requestSubscription: Must use Subscription operation');
    var configs = config.configs, onCompleted = config.onCompleted, onError = config.onError, onNext = config.onNext, variables = config.variables, cacheConfig = config.cacheConfig;
    var operation = $7deb749254dbd766$var$createOperationDescriptor(subscription, variables, cacheConfig);
    var _ref = configs ? $IbWT2.convert(configs, subscription, null, config.updater) : config, updater = _ref.updater;
    var sub = environment.executeSubscription({
        operation: operation,
        updater: updater
    }).subscribe({
        next: function next(responses) {
            if (onNext != null) {
                var selector = operation.fragment;
                var nextID;
                if (Array.isArray(responses)) {
                    var _responses$, _responses$$extension;
                    nextID = (_responses$ = responses[0]) === null || _responses$ === void 0 ? void 0 : (_responses$$extension = _responses$.extensions) === null || _responses$$extension === void 0 ? void 0 : _responses$$extension.__relay_subscription_root_id;
                } else {
                    var _responses$extensions;
                    nextID = (_responses$extensions = responses.extensions) === null || _responses$extensions === void 0 ? void 0 : _responses$extensions.__relay_subscription_root_id;
                }
                if (typeof nextID === 'string') selector = $7deb749254dbd766$var$createReaderSelector(selector.node, nextID, selector.variables, selector.owner);
                var data = environment.lookup(selector).data;
                onNext(data);
            }
        },
        error: onError,
        complete: onCompleted
    });
    return {
        dispose: sub.unsubscribe
    };
}
module.exports = $7deb749254dbd766$var$requestSubscription;

});

parcelRegister("8yYFn", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $63c08ecea930d71b$var$_interopRequireDefault = $bGHxy.default;

var $63c08ecea930d71b$var$_objectSpread2 = $63c08ecea930d71b$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $5vBPt = parcelRequire("5vBPt");
var $63c08ecea930d71b$var$getModuleComponentKey = $5vBPt.getModuleComponentKey, $63c08ecea930d71b$var$getModuleOperationKey = $5vBPt.getModuleOperationKey;
function $63c08ecea930d71b$var$createPayloadFor3DField(name, operation, component, response) {
    var data = (0, $63c08ecea930d71b$var$_objectSpread2["default"])({}, response);
    data[$63c08ecea930d71b$var$getModuleComponentKey(name)] = component;
    data[$63c08ecea930d71b$var$getModuleOperationKey(name)] = operation;
    return data;
}
module.exports = $63c08ecea930d71b$var$createPayloadFor3DField;

});

parcelRegister("lzxG1", function(module, exports) {
'use strict';

var $dTSGA = parcelRequire("dTSGA");
var $fb46fd5ddb05ab12$var$getDataIDsFromFragment = $dTSGA.getDataIDsFromFragment, $fb46fd5ddb05ab12$var$getSelector = $dTSGA.getSelector, $fb46fd5ddb05ab12$var$getVariablesFromFragment = $dTSGA.getVariablesFromFragment;

var $kZ5Zl = parcelRequire("kZ5Zl");

var $3hqjB = parcelRequire("3hqjB");

var $aFY6e = parcelRequire("aFY6e");
var $fb46fd5ddb05ab12$var$stableCopy = $aFY6e.stableCopy;

var $bhpNX = parcelRequire("bhpNX");
var $fb46fd5ddb05ab12$var$intern = $bhpNX.intern;
function $fb46fd5ddb05ab12$var$getFragmentIdentifier(fragmentNode, fragmentRef) {
    var selector = $fb46fd5ddb05ab12$var$getSelector(fragmentNode, fragmentRef);
    var fragmentOwnerIdentifier = selector == null ? 'null' : selector.kind === 'SingularReaderSelector' ? selector.owner.identifier : '[' + selector.selectors.map(function(sel) {
        return sel.owner.identifier;
    }).join(',') + ']';
    var fragmentVariables = $fb46fd5ddb05ab12$var$getVariablesFromFragment(fragmentNode, fragmentRef);
    var dataIDs = $fb46fd5ddb05ab12$var$getDataIDsFromFragment(fragmentNode, fragmentRef);
    if ($3hqjB.ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION) {
        var ids = typeof dataIDs === 'undefined' ? 'missing' : dataIDs == null ? 'null' : Array.isArray(dataIDs) ? '[' + dataIDs.join(',') + ']' : dataIDs;
        ids = $3hqjB.STRING_INTERN_LEVEL <= 1 ? ids : $fb46fd5ddb05ab12$var$intern(ids, $3hqjB.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + (fragmentVariables == null || $kZ5Zl(fragmentVariables) ? '{}' : JSON.stringify($fb46fd5ddb05ab12$var$stableCopy(fragmentVariables))) + '/' + ids;
    } else {
        var _JSON$stringify;
        var _ids = (_JSON$stringify = JSON.stringify(dataIDs)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'missing';
        _ids = $3hqjB.STRING_INTERN_LEVEL <= 1 ? _ids : $fb46fd5ddb05ab12$var$intern(_ids, $3hqjB.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + JSON.stringify($fb46fd5ddb05ab12$var$stableCopy(fragmentVariables)) + '/' + _ids;
    }
}
module.exports = $fb46fd5ddb05ab12$var$getFragmentIdentifier;

});
parcelRegister("kZ5Zl", function(module, exports) {
'use strict';
var $f46e26513c168718$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $f46e26513c168718$var$isEmptyObject(obj) {
    for(var _key in obj){
        if ($f46e26513c168718$var$hasOwnProperty.call(obj, _key)) return false;
    }
    return true;
}
module.exports = $f46e26513c168718$var$isEmptyObject;

});


parcelRegister("3xHhH", function(module, exports) {
'use strict';

var $4HhBF = parcelRequire("4HhBF");

var $5Wk1R = parcelRequire("5Wk1R");
function $29460794c5f4eef0$var$getPaginationMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var _getRefetchMetadata = $4HhBF(fragmentNode, componentDisplayName), paginationRequest = _getRefetchMetadata.refetchableRequest, refetchMetadata = _getRefetchMetadata.refetchMetadata;
    var paginationMetadata = refetchMetadata.connection;
    !(paginationMetadata != null) && $5Wk1R(false);
    var connectionPathInFragmentData = paginationMetadata.path;
    var connectionMetadata = ((_fragmentNode$metadat = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.connection) !== null && _fragmentNode$metadat !== void 0 ? _fragmentNode$metadat : [])[0];
    !(connectionMetadata != null) && $5Wk1R(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    !((identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) == null || typeof identifierInfo.identifierField === 'string') && $5Wk1R(false);
    return {
        connectionPathInFragmentData: connectionPathInFragmentData,
        identifierField: identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField,
        paginationRequest: paginationRequest,
        paginationMetadata: paginationMetadata,
        stream: connectionMetadata.stream === true
    };
}
module.exports = $29460794c5f4eef0$var$getPaginationMetadata;

});
parcelRegister("4HhBF", function(module, exports) {
'use strict';

var $5Wk1R = parcelRequire("5Wk1R");
function $36b8d5d962812798$var$getRefetchMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) !== true) && $5Wk1R(false);
    var refetchMetadata = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.refetch;
    !(refetchMetadata != null) && $5Wk1R(false);
    var refetchableRequest = refetchMetadata.operation["default"] ? refetchMetadata.operation["default"] : refetchMetadata.operation;
    var fragmentRefPathInResponse = refetchMetadata.fragmentPathInResult;
    !(typeof refetchableRequest !== 'string') && $5Wk1R(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    if (identifierInfo != null) {
        !(identifierInfo.identifierField == null || typeof identifierInfo.identifierField === 'string') && $5Wk1R(false);
        !(identifierInfo.identifierQueryVariableName == null || typeof identifierInfo.identifierQueryVariableName === 'string') && $5Wk1R(false);
    }
    return {
        fragmentRefPathInResponse: fragmentRefPathInResponse,
        identifierInfo: identifierInfo,
        refetchableRequest: refetchableRequest,
        refetchMetadata: refetchMetadata
    };
}
module.exports = $36b8d5d962812798$var$getRefetchMetadata;

});


parcelRegister("hnYfT", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $ca835317461e1724$var$_interopRequireDefault = $bGHxy.default;

var $ca835317461e1724$var$_defineProperty2 = $ca835317461e1724$var$_interopRequireDefault((parcelRequire("aUl3j")));

var $ca835317461e1724$var$_objectSpread4 = $ca835317461e1724$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $5Wk1R = parcelRequire("5Wk1R");
parcelRequire("91yGl");
function $ca835317461e1724$var$getPaginationVariables(direction, count, cursor, baseVariables, extraVariables, paginationMetadata) {
    var _objectSpread3;
    var backwardMetadata = paginationMetadata.backward, forwardMetadata = paginationMetadata.forward;
    if (direction === 'backward') {
        var _objectSpread2;
        !(backwardMetadata != null && backwardMetadata.count != null && backwardMetadata.cursor != null) && $5Wk1R(false);
        var _paginationVariables = (0, $ca835317461e1724$var$_objectSpread4["default"])((0, $ca835317461e1724$var$_objectSpread4["default"])((0, $ca835317461e1724$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread2 = {}, (0, $ca835317461e1724$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.cursor, cursor), (0, $ca835317461e1724$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.count, count), _objectSpread2));
        if (forwardMetadata && forwardMetadata.cursor) _paginationVariables[forwardMetadata.cursor] = null;
        if (forwardMetadata && forwardMetadata.count) _paginationVariables[forwardMetadata.count] = null;
        return _paginationVariables;
    }
    !(forwardMetadata != null && forwardMetadata.count != null && forwardMetadata.cursor != null) && $5Wk1R(false);
    var paginationVariables = (0, $ca835317461e1724$var$_objectSpread4["default"])((0, $ca835317461e1724$var$_objectSpread4["default"])((0, $ca835317461e1724$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread3 = {}, (0, $ca835317461e1724$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.cursor, cursor), (0, $ca835317461e1724$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.count, count), _objectSpread3));
    if (backwardMetadata && backwardMetadata.cursor) paginationVariables[backwardMetadata.cursor] = null;
    if (backwardMetadata && backwardMetadata.count) paginationVariables[backwardMetadata.count] = null;
    return paginationVariables;
}
module.exports = $ca835317461e1724$var$getPaginationVariables;

});

parcelRegister("jmyS6", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $e18b1f26faf01ddd$var$_interopRequireDefault = $bGHxy.default;

var $e18b1f26faf01ddd$var$_createForOfIteratorHelper2 = $e18b1f26faf01ddd$var$_interopRequireDefault((parcelRequire("cXbK5")));

var $5Wk1R = parcelRequire("5Wk1R");
function $e18b1f26faf01ddd$var$getValueAtPath(data, path) {
    var result = data;
    var _iterator = (0, $e18b1f26faf01ddd$var$_createForOfIteratorHelper2["default"])(path), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            if (result == null) return null;
            if (typeof key === 'number') {
                !Array.isArray(result) && $5Wk1R(false);
                result = result[key];
            } else {
                !(typeof result === 'object' && !Array.isArray(result)) && $5Wk1R(false);
                result = result[key];
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return result;
}
module.exports = $e18b1f26faf01ddd$var$getValueAtPath;

});

parcelRegister("gmVBN", function(module, exports) {
'use strict';
var $beab634dd5345651$var$profileHandlersByName = {};
var $beab634dd5345651$var$defaultProfiler = {
    stop: function stop() {}
};
var $beab634dd5345651$var$RelayProfiler = {
    profile: function profile(name, state) {
        var handlers = $beab634dd5345651$var$profileHandlersByName[name];
        if (handlers && handlers.length > 0) {
            var stopHandlers = [];
            for(var ii = handlers.length - 1; ii >= 0; ii--){
                var stopHandler = handlers[ii](name, state);
                stopHandlers.unshift(stopHandler);
            }
            return {
                stop: function stop(error) {
                    stopHandlers.forEach(function(stopHandler) {
                        return stopHandler(error);
                    });
                }
            };
        }
        return $beab634dd5345651$var$defaultProfiler;
    },
    attachProfileHandler: function attachProfileHandler(name, handler) {
        if (!$beab634dd5345651$var$profileHandlersByName.hasOwnProperty(name)) $beab634dd5345651$var$profileHandlersByName[name] = [];
        $beab634dd5345651$var$profileHandlersByName[name].push(handler);
    },
    detachProfileHandler: function detachProfileHandler(name, handler) {
        if ($beab634dd5345651$var$profileHandlersByName.hasOwnProperty(name)) $beab634dd5345651$var$removeFromArray($beab634dd5345651$var$profileHandlersByName[name], handler);
    }
};
function $beab634dd5345651$var$removeFromArray(array, element) {
    var index = array.indexOf(element);
    if (index !== -1) array.splice(index, 1);
}
module.exports = $beab634dd5345651$var$RelayProfiler;

});




parcelRegister("hcInD", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $c865fba221ad8579$var$_interopRequireDefault = $bGHxy.default;

var $c865fba221ad8579$var$_extends2 = $c865fba221ad8579$var$_interopRequireDefault((parcelRequire("hxgLY")));

var $c865fba221ad8579$var$_objectWithoutPropertiesLoose2 = $c865fba221ad8579$var$_interopRequireDefault((parcelRequire("4erYc")));

var $c865fba221ad8579$var$_assertThisInitialized2 = $c865fba221ad8579$var$_interopRequireDefault((parcelRequire("lBoGG")));

var $c865fba221ad8579$var$_inheritsLoose2 = $c865fba221ad8579$var$_interopRequireDefault((parcelRequire("2TP0G")));

var $c865fba221ad8579$var$_defineProperty2 = $c865fba221ad8579$var$_interopRequireDefault((parcelRequire("aUl3j")));
var $c865fba221ad8579$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $4DPVL = parcelRequire("4DPVL");

var $eqZQk = parcelRequire("eqZQk");
var $c865fba221ad8579$var$getContainerName = $eqZQk.getContainerName;

var $ceCVW = parcelRequire("ceCVW");
var $c865fba221ad8579$var$assertRelayContext = $ceCVW.assertRelayContext;

var $cGxFv = parcelRequire("cGxFv");

var $1v5pe = parcelRequire("1v5pe");

var $ArurZ = parcelRequire("ArurZ");
var $c865fba221ad8579$var$createFragmentSpecResolver = $ArurZ.createFragmentSpecResolver, $c865fba221ad8579$var$getDataIDsFromObject = $ArurZ.getDataIDsFromObject, $c865fba221ad8579$var$isScalarAndEqual = $ArurZ.isScalarAndEqual;
function $c865fba221ad8579$var$createContainerWithFragments(Component, fragments) {
    var _class;
    var containerName = $c865fba221ad8579$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $c865fba221ad8579$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $c865fba221ad8579$var$_defineProperty2["default"])((0, $c865fba221ad8579$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve(),
                        relayProp: $c865fba221ad8579$var$getRelayProp(updatedState.relayProp.environment)
                    } : null;
                });
            });
            var relayContext = $c865fba221ad8579$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            var resolver = $c865fba221ad8579$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                prevProps: props,
                prevPropsContext: relayContext,
                relayProp: $c865fba221ad8579$var$getRelayProp(relayContext.environment),
                resolver: resolver
            };
            return _this;
        }
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $c865fba221ad8579$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $c865fba221ad8579$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $c865fba221ad8579$var$getDataIDsFromObject(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$cGxFv(prevIDs, nextIDs)) {
                resolver = $c865fba221ad8579$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    prevPropsContext: relayContext,
                    prevProps: nextProps,
                    relayProp: $c865fba221ad8579$var$getRelayProp(relayContext.environment),
                    resolver: resolver
                };
            } else {
                resolver.setProps(nextProps);
                var data = resolver.resolve();
                if (data !== prevState.data) return {
                    data: data,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    relayProp: $c865fba221ad8579$var$getRelayProp(relayContext.environment)
                };
            }
            return null;
        };
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.state.resolver.dispose();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevPropsContext.environment !== this.state.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$c865fba221ad8579$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $c865fba221ad8579$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $c865fba221ad8579$var$_excluded);
            return /*#__PURE__*/ $1v5pe.createElement(Component, (0, $c865fba221ad8579$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            }));
        };
        return _class;
    }($1v5pe.Component), (0, $c865fba221ad8579$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $c865fba221ad8579$var$getRelayProp(environment) {
    return {
        environment: environment
    };
}
function $c865fba221ad8579$var$createContainer(Component, fragmentSpec) {
    return $4DPVL(Component, fragmentSpec, $c865fba221ad8579$var$createContainerWithFragments);
}
module.exports = {
    createContainer: $c865fba221ad8579$var$createContainer
};

});
parcelRegister("hxgLY", function(module, exports) {
function $cc4287740a77ec32$var$_extends() {
    return module.exports = $cc4287740a77ec32$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $cc4287740a77ec32$var$_extends.apply(null, arguments);
}
module.exports = $cc4287740a77ec32$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lBoGG", function(module, exports) {
function $fba03412fd1cc782$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $fba03412fd1cc782$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2TP0G", function(module, exports) {

var $ay7Hx = parcelRequire("ay7Hx");
function $21c8495cf11418c4$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $ay7Hx(t, o);
}
module.exports = $21c8495cf11418c4$var$_inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ay7Hx", function(module, exports) {
function $7ae30daef50d2906$var$_setPrototypeOf(t, e) {
    return module.exports = $7ae30daef50d2906$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $7ae30daef50d2906$var$_setPrototypeOf(t, e);
}
module.exports = $7ae30daef50d2906$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("4DPVL", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $361316517405fddf$var$_interopRequireDefault = $bGHxy.default;

var $361316517405fddf$var$_extends2 = $361316517405fddf$var$_interopRequireDefault((parcelRequire("hxgLY")));

var $fHNgJ = parcelRequire("fHNgJ");

var $eqZQk = parcelRequire("eqZQk");
var $361316517405fddf$var$getComponentName = $eqZQk.getComponentName, $361316517405fddf$var$getContainerName = $eqZQk.getContainerName;

var $1hStr = parcelRequire("1hStr");

var $b7Mjb = parcelRequire("b7Mjb");

var $5Wk1R = parcelRequire("5Wk1R");

var $1v5pe = parcelRequire("1v5pe");

var $ArurZ = parcelRequire("ArurZ");
var $361316517405fddf$var$getFragment = $ArurZ.getFragment;
var $361316517405fddf$var$useContext = $1v5pe.useContext;
function $361316517405fddf$var$buildReactRelayContainer(ComponentClass, fragmentSpec, createContainerWithFragments) {
    var containerName = $361316517405fddf$var$getContainerName(ComponentClass);
    $fHNgJ($361316517405fddf$var$getComponentName(ComponentClass), fragmentSpec);
    var fragments = {};
    for(var key in fragmentSpec)fragments[key] = $361316517405fddf$var$getFragment(fragmentSpec[key]);
    var Container = createContainerWithFragments(ComponentClass, fragments);
    Container.displayName = containerName;
    function ForwardRef(props, ref) {
        var _queryRendererContext;
        var context = $361316517405fddf$var$useContext($1hStr);
        !(context != null) && $5Wk1R(false);
        var queryRendererContext = $361316517405fddf$var$useContext($b7Mjb);
        return /*#__PURE__*/ $1v5pe.createElement(Container, (0, $361316517405fddf$var$_extends2["default"])({}, props, {
            __relayContext: context,
            __rootIsQueryRenderer: (_queryRendererContext = queryRendererContext === null || queryRendererContext === void 0 ? void 0 : queryRendererContext.rootIsQueryRenderer) !== null && _queryRendererContext !== void 0 ? _queryRendererContext : false,
            componentRef: props.componentRef || ref
        }));
    }
    ForwardRef.displayName = containerName;
    var ForwardContainer = $1v5pe.forwardRef(ForwardRef);
    return ForwardContainer;
}
module.exports = $361316517405fddf$var$buildReactRelayContainer;

});
parcelRegister("fHNgJ", function(module, exports) {
'use strict';

var $5Wk1R = parcelRequire("5Wk1R");
function $b6f116edb94887e0$var$assertFragmentMap(componentName, fragmentSpec) {
    !(fragmentSpec && typeof fragmentSpec === 'object') && $5Wk1R(false);
    for(var key in fragmentSpec)if (fragmentSpec.hasOwnProperty(key)) {
        var fragment = fragmentSpec[key];
        !(fragment && (typeof fragment === 'object' || typeof fragment === 'function')) && $5Wk1R(false);
    }
}
module.exports = $b6f116edb94887e0$var$assertFragmentMap;

});

parcelRegister("eqZQk", function(module, exports) {
'use strict';
function $a823771c062f0eb8$var$getComponentName(component) {
    return component.displayName || component.name || 'Component';
}
function $a823771c062f0eb8$var$getContainerName(Component) {
    return 'Relay(' + $a823771c062f0eb8$var$getComponentName(Component) + ')';
}
module.exports = {
    getComponentName: $a823771c062f0eb8$var$getComponentName,
    getContainerName: $a823771c062f0eb8$var$getContainerName
};

});

parcelRegister("b7Mjb", function(module, exports) {
'use strict';

var $1v5pe = parcelRequire("1v5pe");
module.exports = $1v5pe.createContext({
    rootIsQueryRenderer: false
});

});


parcelRegister("ceCVW", function(module, exports) {
'use strict';

var $6bUp8 = parcelRequire("6bUp8");

var $5Wk1R = parcelRequire("5Wk1R");
function $024c77b69e61033c$var$assertRelayContext(relay) {
    !$024c77b69e61033c$var$isRelayContext(relay) && $5Wk1R(false);
    return relay;
}
function $024c77b69e61033c$var$isRelayContext(context) {
    return typeof context === 'object' && context !== null && !Array.isArray(context) && $6bUp8(context.environment);
}
module.exports = {
    assertRelayContext: $024c77b69e61033c$var$assertRelayContext,
    isRelayContext: $024c77b69e61033c$var$isRelayContext
};

});
parcelRegister("6bUp8", function(module, exports) {
'use strict';
function $481f85e91d7c8754$var$isRelayEnvironment(environment) {
    return typeof environment === 'object' && environment !== null && typeof environment.check === 'function' && typeof environment.lookup === 'function' && typeof environment.retain === 'function' && typeof environment.execute === 'function' && typeof environment.subscribe === 'function';
}
module.exports = $481f85e91d7c8754$var$isRelayEnvironment;

});



parcelRegister("q5gmz", function(module, exports) {
'use strict';

var $1hStr = parcelRequire("1hStr");

var $b7Mjb = parcelRequire("b7Mjb");

var $cGxFv = parcelRequire("cGxFv");

var $1v5pe = parcelRequire("1v5pe");

var $ArurZ = parcelRequire("ArurZ");
var $04e682edc495fe48$var$createOperationDescriptor = $ArurZ.createOperationDescriptor, $04e682edc495fe48$var$deepFreeze = $ArurZ.deepFreeze, $04e682edc495fe48$var$getRequest = $ArurZ.getRequest;
var $04e682edc495fe48$var$useLayoutEffect = $1v5pe.useLayoutEffect, $04e682edc495fe48$var$useState = $1v5pe.useState, $04e682edc495fe48$var$useRef = $1v5pe.useRef, $04e682edc495fe48$var$useMemo = $1v5pe.useMemo;
var $04e682edc495fe48$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
function $04e682edc495fe48$var$useDeepCompare(value) {
    var latestValue = $1v5pe.useRef(value);
    if (!$cGxFv(latestValue.current, value)) latestValue.current = value;
    return latestValue.current;
}
function $04e682edc495fe48$var$ReactRelayLocalQueryRenderer(props) {
    var environment = props.environment, query = props.query, variables = props.variables, render = props.render;
    var latestVariables = $04e682edc495fe48$var$useDeepCompare(variables);
    var operation = $04e682edc495fe48$var$useMemo(function() {
        var request = $04e682edc495fe48$var$getRequest(query);
        return $04e682edc495fe48$var$createOperationDescriptor(request, latestVariables);
    }, [
        query,
        latestVariables
    ]);
    var relayContext = $04e682edc495fe48$var$useMemo(function() {
        return {
            environment: environment
        };
    }, [
        environment
    ]);
    var dataRef = $04e682edc495fe48$var$useRef(null);
    var _useState = $04e682edc495fe48$var$useState(null), forceUpdate = _useState[1];
    var cleanupFnRef = $04e682edc495fe48$var$useRef(null);
    var snapshot = $04e682edc495fe48$var$useMemo(function() {
        environment.check(operation);
        var res = environment.lookup(operation.fragment);
        dataRef.current = res.data;
        var retainDisposable = environment.retain(operation);
        var subscribeDisposable = environment.subscribe(res, function(newSnapshot) {
            dataRef.current = newSnapshot.data;
            forceUpdate(dataRef.current);
        });
        var disposed = false;
        function nextCleanupFn() {
            if (!disposed) {
                disposed = true;
                cleanupFnRef.current = null;
                retainDisposable.dispose();
                subscribeDisposable.dispose();
            }
        }
        if (cleanupFnRef.current) cleanupFnRef.current();
        cleanupFnRef.current = nextCleanupFn;
        return res;
    }, [
        environment,
        operation
    ]);
    $04e682edc495fe48$var$useLayoutEffect(function() {
        var cleanupFn = cleanupFnRef.current;
        return function() {
            cleanupFn && cleanupFn();
        };
    }, [
        snapshot
    ]);
    return /*#__PURE__*/ $1v5pe.createElement($1hStr.Provider, {
        value: relayContext
    }, /*#__PURE__*/ $1v5pe.createElement($b7Mjb.Provider, {
        value: $04e682edc495fe48$var$queryRendererContext
    }, render({
        props: dataRef.current
    })));
}
module.exports = $04e682edc495fe48$var$ReactRelayLocalQueryRenderer;

});

parcelRegister("le2gd", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $f73ca8ae812e35d9$var$_interopRequireDefault = $bGHxy.default;

var $f73ca8ae812e35d9$var$_extends2 = $f73ca8ae812e35d9$var$_interopRequireDefault((parcelRequire("hxgLY")));

var $f73ca8ae812e35d9$var$_objectWithoutPropertiesLoose2 = $f73ca8ae812e35d9$var$_interopRequireDefault((parcelRequire("4erYc")));

var $f73ca8ae812e35d9$var$_assertThisInitialized2 = $f73ca8ae812e35d9$var$_interopRequireDefault((parcelRequire("lBoGG")));

var $f73ca8ae812e35d9$var$_inheritsLoose2 = $f73ca8ae812e35d9$var$_interopRequireDefault((parcelRequire("2TP0G")));

var $f73ca8ae812e35d9$var$_defineProperty2 = $f73ca8ae812e35d9$var$_interopRequireDefault((parcelRequire("aUl3j")));

var $f73ca8ae812e35d9$var$_objectSpread3 = $f73ca8ae812e35d9$var$_interopRequireDefault((parcelRequire("eQAdv")));
var $f73ca8ae812e35d9$var$_excluded = [
    "componentRef"
], $f73ca8ae812e35d9$var$_excluded2 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
], $f73ca8ae812e35d9$var$_excluded3 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $4DPVL = parcelRequire("4DPVL");

var $fVkkU = parcelRequire("fVkkU");

var $eqZQk = parcelRequire("eqZQk");
var $f73ca8ae812e35d9$var$getComponentName = $eqZQk.getComponentName, $f73ca8ae812e35d9$var$getContainerName = $eqZQk.getContainerName;

var $1hStr = parcelRequire("1hStr");

var $lR5xR = parcelRequire("lR5xR");

var $ceCVW = parcelRequire("ceCVW");
var $f73ca8ae812e35d9$var$assertRelayContext = $ceCVW.assertRelayContext;

var $cGxFv = parcelRequire("cGxFv");

var $5Wk1R = parcelRequire("5Wk1R");

var $1v5pe = parcelRequire("1v5pe");

var $ArurZ = parcelRequire("ArurZ");
var $f73ca8ae812e35d9$var$ConnectionInterface = $ArurZ.ConnectionInterface, $f73ca8ae812e35d9$var$Observable = $ArurZ.Observable, $f73ca8ae812e35d9$var$RelayFeatureFlags = $ArurZ.RelayFeatureFlags, $f73ca8ae812e35d9$var$createFragmentSpecResolver = $ArurZ.createFragmentSpecResolver, $f73ca8ae812e35d9$var$createOperationDescriptor = $ArurZ.createOperationDescriptor, $f73ca8ae812e35d9$var$getDataIDsFromObject = $ArurZ.getDataIDsFromObject, $f73ca8ae812e35d9$var$getRequest = $ArurZ.getRequest, $f73ca8ae812e35d9$var$getVariablesFromObject = $ArurZ.getVariablesFromObject, $f73ca8ae812e35d9$var$isScalarAndEqual = $ArurZ.isScalarAndEqual;
parcelRequire("91yGl");
var $f73ca8ae812e35d9$var$FORWARD = 'forward';
function $f73ca8ae812e35d9$var$createGetConnectionFromProps(metadata) {
    var path = metadata.path;
    !path && $5Wk1R(false);
    return function(props) {
        var data = props[metadata.fragmentName];
        for(var i = 0; i < path.length; i++){
            if (!data || typeof data !== 'object') return null;
            data = data[path[i]];
        }
        return data;
    };
}
function $f73ca8ae812e35d9$var$createGetFragmentVariables(metadata) {
    var countVariable = metadata.count;
    !countVariable && $5Wk1R(false);
    return function(prevVars, totalCount) {
        return (0, $f73ca8ae812e35d9$var$_objectSpread3["default"])((0, $f73ca8ae812e35d9$var$_objectSpread3["default"])({}, prevVars), {}, (0, $f73ca8ae812e35d9$var$_defineProperty2["default"])({}, countVariable, totalCount));
    };
}
function $f73ca8ae812e35d9$var$findConnectionMetadata(fragments) {
    var foundConnectionMetadata = null;
    var isRelayModern = false;
    for(var fragmentName in fragments){
        var fragment = fragments[fragmentName];
        var connectionMetadata = fragment.metadata && fragment.metadata.connection;
        if (fragment.metadata !== undefined) isRelayModern = true;
        if (connectionMetadata) {
            !(connectionMetadata.length === 1) && $5Wk1R(false);
            !!foundConnectionMetadata && $5Wk1R(false);
            foundConnectionMetadata = (0, $f73ca8ae812e35d9$var$_objectSpread3["default"])((0, $f73ca8ae812e35d9$var$_objectSpread3["default"])({}, connectionMetadata[0]), {}, {
                fragmentName: fragmentName
            });
        }
    }
    !(!isRelayModern || foundConnectionMetadata !== null) && $5Wk1R(false);
    return foundConnectionMetadata || {};
}
function $f73ca8ae812e35d9$var$toObserver(observerOrCallback) {
    return typeof observerOrCallback === 'function' ? {
        error: observerOrCallback,
        complete: observerOrCallback,
        unsubscribe: function unsubscribe(subscription) {
            typeof observerOrCallback === 'function' && observerOrCallback();
        }
    } : observerOrCallback || {};
}
function $f73ca8ae812e35d9$var$createContainerWithFragments(Component, fragments, connectionConfig) {
    var _class;
    var componentName = $f73ca8ae812e35d9$var$getComponentName(Component);
    var containerName = $f73ca8ae812e35d9$var$getContainerName(Component);
    var metadata = $f73ca8ae812e35d9$var$findConnectionMetadata(fragments);
    var getConnectionFromProps = connectionConfig.getConnectionFromProps || $f73ca8ae812e35d9$var$createGetConnectionFromProps(metadata);
    var direction = connectionConfig.direction || metadata.direction;
    !direction && $5Wk1R(false);
    var getFragmentVariables = connectionConfig.getFragmentVariables || $f73ca8ae812e35d9$var$createGetFragmentVariables(metadata);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $f73ca8ae812e35d9$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $f73ca8ae812e35d9$var$_defineProperty2["default"])((0, $f73ca8ae812e35d9$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                _this.setState({
                    data: _this._resolver.resolve()
                });
            });
            (0, $f73ca8ae812e35d9$var$_defineProperty2["default"])((0, $f73ca8ae812e35d9$var$_assertThisInitialized2["default"])(_this), "_hasMore", function() {
                var connectionData = _this._getConnectionData();
                return !!(connectionData && connectionData.hasMore && connectionData.cursor);
            });
            (0, $f73ca8ae812e35d9$var$_defineProperty2["default"])((0, $f73ca8ae812e35d9$var$_assertThisInitialized2["default"])(_this), "_isLoading", function() {
                return !!_this._refetchSubscription;
            });
            (0, $f73ca8ae812e35d9$var$_defineProperty2["default"])((0, $f73ca8ae812e35d9$var$_assertThisInitialized2["default"])(_this), "_refetchConnection", function(totalCount, observerOrCallback, refetchVariables) {
                if (!_this._canFetchPage('refetchConnection')) return {
                    dispose: function dispose() {}
                };
                _this._refetchVariables = refetchVariables;
                var paginatingVariables = {
                    count: totalCount,
                    cursor: null,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, $f73ca8ae812e35d9$var$toObserver(observerOrCallback), {
                    force: true
                });
                return {
                    dispose: fetch.unsubscribe
                };
            });
            (0, $f73ca8ae812e35d9$var$_defineProperty2["default"])((0, $f73ca8ae812e35d9$var$_assertThisInitialized2["default"])(_this), "_loadMore", function(pageSize, observerOrCallback, options) {
                if (!_this._canFetchPage('loadMore')) return {
                    dispose: function dispose() {}
                };
                var observer = $f73ca8ae812e35d9$var$toObserver(observerOrCallback);
                var connectionData = _this._getConnectionData();
                if (!connectionData) {
                    $f73ca8ae812e35d9$var$Observable.create(function(sink) {
                        return sink.complete();
                    }).subscribe(observer);
                    return null;
                }
                var totalCount = connectionData.edgeCount + pageSize;
                if (options && options.force) return _this._refetchConnection(totalCount, observerOrCallback);
                var _ConnectionInterface$ = $f73ca8ae812e35d9$var$ConnectionInterface.get(), END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
                var cursor = connectionData.cursor;
                var paginatingVariables = {
                    count: pageSize,
                    cursor: cursor,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, observer, options);
                return {
                    dispose: fetch.unsubscribe
                };
            });
            var relayContext = $f73ca8ae812e35d9$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._isARequestInFlight = false;
            _this._refetchSubscription = null;
            _this._refetchVariables = null;
            if ($f73ca8ae812e35d9$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) _this._resolver = $f73ca8ae812e35d9$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            else _this._resolver = $f73ca8ae812e35d9$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer, _this._handleFragmentDataUpdate);
            _this.state = {
                data: _this._resolver.resolve(),
                prevContext: relayContext,
                contextForChildren: relayContext,
                relayProp: _this._buildRelayProp(relayContext),
                resolverGeneration: 0
            };
            _this._isUnmounted = false;
            _this._hasFetched = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            if ($f73ca8ae812e35d9$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if ($f73ca8ae812e35d9$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
                if (prevState.resolverGeneration !== this.state.resolverGeneration) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
                else this._rerenderIfStoreHasChanged();
            }
        };
        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;
            var _nextProps$__rootIsQu;
            var relayContext = $f73ca8ae812e35d9$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $f73ca8ae812e35d9$var$getDataIDsFromObject(fragments, this.props);
            var nextIDs = $f73ca8ae812e35d9$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $fVkkU(fragments, this.props);
            var nextRootVariables = $fVkkU(fragments, nextProps);
            if (relayContext.environment !== this.state.prevContext.environment || !$cGxFv(prevRootVariables, nextRootVariables) || !$cGxFv(prevIDs, nextIDs)) {
                this._cleanup();
                if ($f73ca8ae812e35d9$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._resolver = $f73ca8ae812e35d9$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                else this._resolver = $f73ca8ae812e35d9$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer, this._handleFragmentDataUpdate);
                this.setState(function(prevState) {
                    return {
                        prevContext: relayContext,
                        contextForChildren: relayContext,
                        relayProp: _this2._buildRelayProp(relayContext),
                        resolverGeneration: prevState.resolverGeneration + 1
                    };
                });
            } else if (!this._hasFetched) this._resolver.setProps(nextProps);
            var data = this._resolver.resolve();
            if (data !== this.state.data) this.setState({
                data: data
            });
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this._cleanup();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp || nextState.resolverGeneration !== this.state.resolverGeneration) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevContext.environment !== this.state.prevContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$f73ca8ae812e35d9$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._buildRelayProp = function _buildRelayProp(relayContext) {
            return {
                hasMore: this._hasMore,
                isLoading: this._isLoading,
                loadMore: this._loadMore,
                refetchConnection: this._refetchConnection,
                environment: relayContext.environment
            };
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            this._resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getConnectionData = function _getConnectionData() {
            var _this$props = this.props, _ = _this$props.componentRef, restProps = (0, $f73ca8ae812e35d9$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $f73ca8ae812e35d9$var$_excluded);
            var props = (0, $f73ca8ae812e35d9$var$_objectSpread3["default"])((0, $f73ca8ae812e35d9$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var connectionData = getConnectionFromProps(props);
            if (connectionData == null) return null;
            var _ConnectionInterface$2 = $f73ca8ae812e35d9$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$2.EDGES, PAGE_INFO = _ConnectionInterface$2.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$2.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$2.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$2.END_CURSOR, START_CURSOR = _ConnectionInterface$2.START_CURSOR;
            !(typeof connectionData === 'object') && $5Wk1R(false);
            var edges = connectionData[EDGES];
            var pageInfo = connectionData[PAGE_INFO];
            if (edges == null || pageInfo == null) return null;
            !Array.isArray(edges) && $5Wk1R(false);
            !(typeof pageInfo === 'object') && $5Wk1R(false);
            var hasMore = direction === $f73ca8ae812e35d9$var$FORWARD ? pageInfo[HAS_NEXT_PAGE] : pageInfo[HAS_PREV_PAGE];
            var cursor = direction === $f73ca8ae812e35d9$var$FORWARD ? pageInfo[END_CURSOR] : pageInfo[START_CURSOR];
            if (typeof hasMore !== 'boolean' || edges.length !== 0 && typeof cursor === 'undefined') return null;
            return {
                cursor: cursor,
                edgeCount: edges.length,
                hasMore: hasMore
            };
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $lR5xR();
            return this._queryFetcher;
        };
        _proto._canFetchPage = function _canFetchPage(method) {
            if (this._isUnmounted) return false;
            return true;
        };
        _proto._fetchPage = function _fetchPage(paginatingVariables, observer, options) {
            var _this3 = this;
            var _assertRelayContext = $f73ca8ae812e35d9$var$assertRelayContext(this.props.__relayContext), environment = _assertRelayContext.environment;
            var _this$props2 = this.props, _ = _this$props2.componentRef, __relayContext = _this$props2.__relayContext, __rootIsQueryRenderer = _this$props2.__rootIsQueryRenderer, restProps = (0, $f73ca8ae812e35d9$var$_objectWithoutPropertiesLoose2["default"])(_this$props2, $f73ca8ae812e35d9$var$_excluded2);
            var props = (0, $f73ca8ae812e35d9$var$_objectSpread3["default"])((0, $f73ca8ae812e35d9$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var fragmentVariables;
            var rootVariables = $fVkkU(fragments, restProps);
            fragmentVariables = $f73ca8ae812e35d9$var$getVariablesFromObject(fragments, restProps);
            fragmentVariables = (0, $f73ca8ae812e35d9$var$_objectSpread3["default"])((0, $f73ca8ae812e35d9$var$_objectSpread3["default"])((0, $f73ca8ae812e35d9$var$_objectSpread3["default"])({}, rootVariables), fragmentVariables), this._refetchVariables);
            var fetchVariables = connectionConfig.getVariables(props, {
                count: paginatingVariables.count,
                cursor: paginatingVariables.cursor
            }, fragmentVariables);
            !(typeof fetchVariables === 'object' && fetchVariables !== null) && $5Wk1R(false);
            fetchVariables = (0, $f73ca8ae812e35d9$var$_objectSpread3["default"])((0, $f73ca8ae812e35d9$var$_objectSpread3["default"])({}, fetchVariables), this._refetchVariables);
            fragmentVariables = (0, $f73ca8ae812e35d9$var$_objectSpread3["default"])((0, $f73ca8ae812e35d9$var$_objectSpread3["default"])({}, fetchVariables), fragmentVariables);
            var cacheConfig = options ? {
                force: !!options.force
            } : undefined;
            if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
            var request = $f73ca8ae812e35d9$var$getRequest(connectionConfig.query);
            var operation = $f73ca8ae812e35d9$var$createOperationDescriptor(request, fetchVariables, cacheConfig);
            var refetchSubscription = null;
            if (this._refetchSubscription) this._refetchSubscription.unsubscribe();
            this._hasFetched = true;
            var onNext = function onNext(payload, complete) {
                var prevData = _this3._resolver.resolve();
                _this3._resolver.setVariables(getFragmentVariables(fragmentVariables, paginatingVariables.totalCount), operation.request.node);
                var nextData = _this3._resolver.resolve();
                if (!$cGxFv(prevData, nextData)) _this3.setState({
                    data: nextData,
                    contextForChildren: {
                        environment: _this3.props.__relayContext.environment
                    }
                }, complete);
                else complete();
            };
            var cleanup = function cleanup() {
                if (_this3._refetchSubscription === refetchSubscription) {
                    _this3._refetchSubscription = null;
                    _this3._isARequestInFlight = false;
                }
            };
            this._isARequestInFlight = true;
            refetchSubscription = this._getQueryFetcher().execute({
                environment: environment,
                operation: operation,
                preservePreviousReferences: true
            }).mergeMap(function(payload) {
                return $f73ca8ae812e35d9$var$Observable.create(function(sink) {
                    onNext(payload, function() {
                        sink.next();
                        sink.complete();
                    });
                });
            })["do"]({
                error: cleanup,
                complete: cleanup,
                unsubscribe: cleanup
            }).subscribe(observer || {});
            this._refetchSubscription = this._isARequestInFlight ? refetchSubscription : null;
            return refetchSubscription;
        };
        _proto._cleanup = function _cleanup() {
            this._resolver.dispose();
            this._refetchVariables = null;
            this._hasFetched = false;
            if (this._refetchSubscription) {
                this._refetchSubscription.unsubscribe();
                this._refetchSubscription = null;
                this._isARequestInFlight = false;
            }
            if (this._queryFetcher) this._queryFetcher.dispose();
        };
        _proto.render = function render() {
            var _this$props3 = this.props, componentRef = _this$props3.componentRef, __relayContext = _this$props3.__relayContext, __rootIsQueryRenderer = _this$props3.__rootIsQueryRenderer, props = (0, $f73ca8ae812e35d9$var$_objectWithoutPropertiesLoose2["default"])(_this$props3, $f73ca8ae812e35d9$var$_excluded3);
            return /*#__PURE__*/ $1v5pe.createElement($1hStr.Provider, {
                value: this.state.contextForChildren
            }, /*#__PURE__*/ $1v5pe.createElement(Component, (0, $f73ca8ae812e35d9$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            })));
        };
        return _class;
    }($1v5pe.Component), (0, $f73ca8ae812e35d9$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $f73ca8ae812e35d9$var$createContainer(Component, fragmentSpec, connectionConfig) {
    return $4DPVL(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $f73ca8ae812e35d9$var$createContainerWithFragments(ComponentClass, fragments, connectionConfig);
    });
}
module.exports = {
    createContainer: $f73ca8ae812e35d9$var$createContainer
};

});
parcelRegister("fVkkU", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $b97bf4373e0444bc$var$_interopRequireDefault = $bGHxy.default;

var $b97bf4373e0444bc$var$_objectSpread2 = $b97bf4373e0444bc$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $ArurZ = parcelRequire("ArurZ");
var $b97bf4373e0444bc$var$getSelector = $ArurZ.getSelector;
function $b97bf4373e0444bc$var$getRootVariablesForFragments(fragments, props) {
    var rootVariables = {};
    Object.keys(fragments).forEach(function(key) {
        var _selector$selectors$, _selector$selectors$2, _selector$owner$varia;
        var fragmentNode = fragments[key];
        var fragmentRef = props[key];
        var selector = $b97bf4373e0444bc$var$getSelector(fragmentNode, fragmentRef);
        var fragmentOwnerVariables = selector != null && selector.kind === 'PluralReaderSelector' ? (_selector$selectors$ = (_selector$selectors$2 = selector.selectors[0]) === null || _selector$selectors$2 === void 0 ? void 0 : _selector$selectors$2.owner.variables) !== null && _selector$selectors$ !== void 0 ? _selector$selectors$ : {} : (_selector$owner$varia = selector === null || selector === void 0 ? void 0 : selector.owner.variables) !== null && _selector$owner$varia !== void 0 ? _selector$owner$varia : {};
        rootVariables = (0, $b97bf4373e0444bc$var$_objectSpread2["default"])((0, $b97bf4373e0444bc$var$_objectSpread2["default"])({}, rootVariables), fragmentOwnerVariables);
    });
    return rootVariables;
}
module.exports = $b97bf4373e0444bc$var$getRootVariablesForFragments;

});

parcelRegister("lR5xR", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $fe92d9568ac9cd41$var$_interopRequireDefault = $bGHxy.default;

var $fe92d9568ac9cd41$var$_defineProperty2 = $fe92d9568ac9cd41$var$_interopRequireDefault((parcelRequire("aUl3j")));

var $5Wk1R = parcelRequire("5Wk1R");

var $ArurZ = parcelRequire("ArurZ");
var $fe92d9568ac9cd41$var$fetchQuery = $ArurZ.__internal.fetchQuery, $fe92d9568ac9cd41$var$createOperationDescriptor = $ArurZ.createOperationDescriptor, $fe92d9568ac9cd41$var$isRelayModernEnvironment = $ArurZ.isRelayModernEnvironment;
var $fe92d9568ac9cd41$var$ReactRelayQueryFetcher = /*#__PURE__*/ function() {
    function ReactRelayQueryFetcher(args) {
        (0, $fe92d9568ac9cd41$var$_defineProperty2["default"])(this, "_selectionReferences", []);
        (0, $fe92d9568ac9cd41$var$_defineProperty2["default"])(this, "_didFetchFinish", false);
        if (args != null) {
            this._cacheSelectionReference = args.cacheSelectionReference;
            this._selectionReferences = args.selectionReferences;
        }
    }
    var _proto = ReactRelayQueryFetcher.prototype;
    _proto.getSelectionReferences = function getSelectionReferences() {
        return {
            cacheSelectionReference: this._cacheSelectionReference,
            selectionReferences: this._selectionReferences
        };
    };
    _proto.lookupInStore = function lookupInStore(environment, operation, fetchPolicy) {
        if (fetchPolicy === 'store-and-network' || fetchPolicy === 'store-or-network') {
            if (environment.check(operation).status === 'available') {
                this._retainCachedOperation(environment, operation);
                return environment.lookup(operation.fragment);
            }
        }
        return null;
    };
    _proto.getFetchResult = function getFetchResult() {
        if (this._didFetchFinish) {
            if (this._error != null) return {
                error: this._error
            };
            else if (this._snapshot != null) return {
                snapshot: this._snapshot
            };
        } else return null;
    };
    _proto.execute = function execute(_ref) {
        var _this = this;
        var environment = _ref.environment, operation = _ref.operation, _ref$preservePrevious = _ref.preservePreviousReferences, preservePreviousReferences = _ref$preservePrevious === void 0 ? false : _ref$preservePrevious;
        var reference = environment.retain(operation);
        var error = function error() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var complete = function complete() {
            if (!preservePreviousReferences) _this.disposeSelectionReferences();
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var unsubscribe = function unsubscribe() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        if (!$fe92d9568ac9cd41$var$isRelayModernEnvironment(environment)) return environment.execute({
            operation: operation
        })["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
        return $fe92d9568ac9cd41$var$fetchQuery(environment, operation)["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
    };
    _proto.setOnDataChange = function setOnDataChange(onDataChange) {
        !this._fetchOptions && $5Wk1R(false);
        if (typeof onDataChange === 'function') {
            this._fetchOptions.onDataChangeCallbacks = this._fetchOptions.onDataChangeCallbacks || [];
            this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
            if (this._didFetchFinish) {
                if (this._error != null) onDataChange({
                    error: this._error
                });
                else if (this._snapshot != null) onDataChange({
                    snapshot: this._snapshot
                });
            }
        }
    };
    _proto.fetch = function fetch(fetchOptions, cacheConfigOverride) {
        var _this2 = this;
        var environment = fetchOptions.environment, operation = fetchOptions.operation, onDataChange = fetchOptions.onDataChange;
        var fetchHasReturned = false;
        var _error;
        this.disposeRequest();
        var oldOnDataChangeCallbacks = this._fetchOptions && this._fetchOptions.onDataChangeCallbacks;
        this._fetchOptions = {
            environment: environment,
            onDataChangeCallbacks: oldOnDataChangeCallbacks || [],
            operation: operation
        };
        if (onDataChange && this._fetchOptions.onDataChangeCallbacks.indexOf(onDataChange) === -1) this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
        var operationOverride = cacheConfigOverride ? $fe92d9568ac9cd41$var$createOperationDescriptor(operation.request.node, operation.request.variables, cacheConfigOverride) : operation;
        var request = this.execute({
            environment: environment,
            operation: operationOverride
        })["finally"](function() {
            _this2._pendingRequest = null;
        }).subscribe({
            next: function next() {
                _this2._didFetchFinish = true;
                _this2._error = null;
                _this2._onQueryDataAvailable({
                    notifyFirstResult: fetchHasReturned
                });
            },
            error: function error(err) {
                _this2._didFetchFinish = true;
                _this2._error = err;
                _this2._snapshot = null;
                var onDataChangeCallbacks = _this2._fetchOptions && _this2._fetchOptions.onDataChangeCallbacks;
                if (fetchHasReturned) {
                    if (onDataChangeCallbacks) onDataChangeCallbacks.forEach(function(onDataChange) {
                        onDataChange({
                            error: err
                        });
                    });
                } else _error = err;
            }
        });
        this._pendingRequest = {
            dispose: function dispose() {
                request.unsubscribe();
            }
        };
        fetchHasReturned = true;
        if (_error) throw _error;
        return this._snapshot;
    };
    _proto.retry = function retry(cacheConfigOverride) {
        !this._fetchOptions && $5Wk1R(false);
        return this.fetch({
            environment: this._fetchOptions.environment,
            operation: this._fetchOptions.operation,
            onDataChange: null
        }, cacheConfigOverride);
    };
    _proto.dispose = function dispose() {
        this.disposeRequest();
        this.disposeSelectionReferences();
    };
    _proto.disposeRequest = function disposeRequest() {
        this._error = null;
        this._snapshot = null;
        if (this._pendingRequest) this._pendingRequest.dispose();
        if (this._rootSubscription) {
            this._rootSubscription.dispose();
            this._rootSubscription = null;
        }
    };
    _proto._retainCachedOperation = function _retainCachedOperation(environment, operation) {
        this._disposeCacheSelectionReference();
        this._cacheSelectionReference = environment.retain(operation);
    };
    _proto._disposeCacheSelectionReference = function _disposeCacheSelectionReference() {
        this._cacheSelectionReference && this._cacheSelectionReference.dispose();
        this._cacheSelectionReference = null;
    };
    _proto.disposeSelectionReferences = function disposeSelectionReferences() {
        this._disposeCacheSelectionReference();
        this._selectionReferences.forEach(function(r) {
            return r.dispose();
        });
        this._selectionReferences = [];
    };
    _proto._onQueryDataAvailable = function _onQueryDataAvailable(_ref2) {
        var _this3 = this;
        var notifyFirstResult = _ref2.notifyFirstResult;
        !this._fetchOptions && $5Wk1R(false);
        var _this$_fetchOptions = this._fetchOptions, environment = _this$_fetchOptions.environment, onDataChangeCallbacks = _this$_fetchOptions.onDataChangeCallbacks, operation = _this$_fetchOptions.operation;
        if (this._snapshot) return;
        this._snapshot = environment.lookup(operation.fragment);
        this._rootSubscription = environment.subscribe(this._snapshot, function(snapshot) {
            if (_this3._fetchOptions != null) {
                var maybeNewOnDataChangeCallbacks = _this3._fetchOptions.onDataChangeCallbacks;
                if (Array.isArray(maybeNewOnDataChangeCallbacks)) maybeNewOnDataChangeCallbacks.forEach(function(onDataChange) {
                    return onDataChange({
                        snapshot: snapshot
                    });
                });
            }
        });
        if (this._snapshot && notifyFirstResult && Array.isArray(onDataChangeCallbacks)) {
            var snapshot = this._snapshot;
            onDataChangeCallbacks.forEach(function(onDataChange) {
                return onDataChange({
                    snapshot: snapshot
                });
            });
        }
    };
    return ReactRelayQueryFetcher;
}();
module.exports = $fe92d9568ac9cd41$var$ReactRelayQueryFetcher;

});


parcelRegister("2A0bC", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $1e0f168e0182b99b$var$_interopRequireDefault = $bGHxy.default;

var $1e0f168e0182b99b$var$_objectSpread2 = $1e0f168e0182b99b$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $1e0f168e0182b99b$var$_assertThisInitialized2 = $1e0f168e0182b99b$var$_interopRequireDefault((parcelRequire("lBoGG")));

var $1e0f168e0182b99b$var$_inheritsLoose2 = $1e0f168e0182b99b$var$_interopRequireDefault((parcelRequire("2TP0G")));

var $1e0f168e0182b99b$var$_defineProperty2 = $1e0f168e0182b99b$var$_interopRequireDefault((parcelRequire("aUl3j")));

var $1hStr = parcelRequire("1hStr");

var $lR5xR = parcelRequire("lR5xR");

var $b7Mjb = parcelRequire("b7Mjb");

var $cGxFv = parcelRequire("cGxFv");

var $1v5pe = parcelRequire("1v5pe");

var $ArurZ = parcelRequire("ArurZ");
var $1e0f168e0182b99b$var$createOperationDescriptor = $ArurZ.createOperationDescriptor, $1e0f168e0182b99b$var$deepFreeze = $ArurZ.deepFreeze, $1e0f168e0182b99b$var$getRequest = $ArurZ.getRequest;
var $1e0f168e0182b99b$var$requestCache = {};
var $1e0f168e0182b99b$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
var $1e0f168e0182b99b$var$ReactRelayQueryRenderer = /*#__PURE__*/ function(_React$Component) {
    (0, $1e0f168e0182b99b$var$_inheritsLoose2["default"])(ReactRelayQueryRenderer, _React$Component);
    function ReactRelayQueryRenderer(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        (0, $1e0f168e0182b99b$var$_defineProperty2["default"])((0, $1e0f168e0182b99b$var$_assertThisInitialized2["default"])(_this), "_handleDataChange", function(params) {
            var error = params.error == null ? null : params.error;
            var snapshot = params.snapshot == null ? null : params.snapshot;
            _this.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $1e0f168e0182b99b$var$requestCache[prevRequestCacheKey];
                if (snapshot === prevState.snapshot && error === prevState.error) return null;
                return {
                    renderProps: $1e0f168e0182b99b$var$getRenderProps(error, snapshot, prevState.queryFetcher, prevState.retryCallbacks),
                    snapshot: snapshot,
                    requestCacheKey: null
                };
            });
        });
        var retryCallbacks = {
            handleDataChange: null,
            handleRetryAfterError: null
        };
        var queryFetcher;
        var requestCacheKey;
        if (props.query) {
            var query = props.query;
            var request = $1e0f168e0182b99b$var$getRequest(query);
            requestCacheKey = $1e0f168e0182b99b$var$getRequestCacheKey(request.params, props.variables);
            queryFetcher = $1e0f168e0182b99b$var$requestCache[requestCacheKey] ? $1e0f168e0182b99b$var$requestCache[requestCacheKey].queryFetcher : new $lR5xR();
        } else queryFetcher = new $lR5xR();
        _this._maybeHiddenOrFastRefresh = false;
        _this.state = (0, $1e0f168e0182b99b$var$_objectSpread2["default"])({
            prevPropsEnvironment: props.environment,
            prevPropsVariables: props.variables,
            prevQuery: props.query,
            queryFetcher: queryFetcher,
            retryCallbacks: retryCallbacks
        }, $1e0f168e0182b99b$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey));
        return _this;
    }
    ReactRelayQueryRenderer.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.prevQuery !== nextProps.query || prevState.prevPropsEnvironment !== nextProps.environment || !$cGxFv(prevState.prevPropsVariables, nextProps.variables)) return $1e0f168e0182b99b$var$resetQueryStateForUpdate(nextProps, prevState);
        return null;
    };
    var _proto = ReactRelayQueryRenderer.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        if (this._maybeHiddenOrFastRefresh === true) {
            this._maybeHiddenOrFastRefresh = false;
            this.setState(function(prevState) {
                var newState = $1e0f168e0182b99b$var$resetQueryStateForUpdate(_this2.props, prevState);
                var requestCacheKey = newState.requestCacheKey, queryFetcher = newState.queryFetcher;
                if (requestCacheKey != null && $1e0f168e0182b99b$var$requestCache[requestCacheKey] != null) queryFetcher.setOnDataChange(_this2._handleDataChange);
                return newState;
            });
            return;
        }
        var _this$state = this.state, retryCallbacks = _this$state.retryCallbacks, queryFetcher = _this$state.queryFetcher, requestCacheKey = _this$state.requestCacheKey;
        if (requestCacheKey) delete $1e0f168e0182b99b$var$requestCache[requestCacheKey];
        retryCallbacks.handleDataChange = this._handleDataChange;
        retryCallbacks.handleRetryAfterError = function(error) {
            return _this2.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $1e0f168e0182b99b$var$requestCache[prevRequestCacheKey];
                return {
                    renderProps: $1e0f168e0182b99b$var$getLoadingRenderProps(),
                    requestCacheKey: null
                };
            });
        };
        if (this.props.query) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentDidUpdate = function componentDidUpdate(_prevProps, prevState) {
        var _this$state2 = this.state, queryFetcher = _this$state2.queryFetcher, requestCacheKey = _this$state2.requestCacheKey;
        if (requestCacheKey) {
            delete $1e0f168e0182b99b$var$requestCache[requestCacheKey];
            delete this.state.requestCacheKey;
        }
        if (this.props.query && queryFetcher !== prevState.queryFetcher) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.state.queryFetcher.dispose();
        this._maybeHiddenOrFastRefresh = true;
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextProps.render !== this.props.render || nextState.renderProps !== this.state.renderProps;
    };
    _proto.render = function render() {
        var _this$state3 = this.state, renderProps = _this$state3.renderProps, relayContext = _this$state3.relayContext;
        return /*#__PURE__*/ $1v5pe.createElement($1hStr.Provider, {
            value: relayContext
        }, /*#__PURE__*/ $1v5pe.createElement($b7Mjb.Provider, {
            value: $1e0f168e0182b99b$var$queryRendererContext
        }, this.props.render(renderProps)));
    };
    return ReactRelayQueryRenderer;
}($1v5pe.Component);
function $1e0f168e0182b99b$var$getLoadingRenderProps() {
    return {
        error: null,
        props: null,
        retry: null
    };
}
function $1e0f168e0182b99b$var$getEmptyRenderProps() {
    return {
        error: null,
        props: {},
        retry: null
    };
}
function $1e0f168e0182b99b$var$getRenderProps(error, snapshot, queryFetcher, retryCallbacks) {
    return {
        error: error ? error : null,
        props: snapshot ? snapshot.data : null,
        retry: function retry(cacheConfigOverride) {
            var syncSnapshot = queryFetcher.retry(cacheConfigOverride);
            if (syncSnapshot && typeof retryCallbacks.handleDataChange === 'function') retryCallbacks.handleDataChange({
                snapshot: syncSnapshot
            });
            else if (error && typeof retryCallbacks.handleRetryAfterError === 'function') retryCallbacks.handleRetryAfterError(error);
        }
    };
}
function $1e0f168e0182b99b$var$getRequestCacheKey(request, variables) {
    return JSON.stringify({
        id: request.cacheID ? request.cacheID : request.id,
        variables: variables
    });
}
function $1e0f168e0182b99b$var$resetQueryStateForUpdate(props, prevState) {
    var query = props.query;
    var prevSelectionReferences = prevState.queryFetcher.getSelectionReferences();
    prevState.queryFetcher.disposeRequest();
    var queryFetcher;
    if (query) {
        var request = $1e0f168e0182b99b$var$getRequest(query);
        var requestCacheKey = $1e0f168e0182b99b$var$getRequestCacheKey(request.params, props.variables);
        queryFetcher = $1e0f168e0182b99b$var$requestCache[requestCacheKey] ? $1e0f168e0182b99b$var$requestCache[requestCacheKey].queryFetcher : new $lR5xR(prevSelectionReferences);
    } else queryFetcher = new $lR5xR(prevSelectionReferences);
    return (0, $1e0f168e0182b99b$var$_objectSpread2["default"])({
        prevQuery: props.query,
        prevPropsEnvironment: props.environment,
        prevPropsVariables: props.variables,
        queryFetcher: queryFetcher
    }, $1e0f168e0182b99b$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, prevState.retryCallbacks));
}
function $1e0f168e0182b99b$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey) {
    var environment = props.environment, query = props.query, variables = props.variables, cacheConfig = props.cacheConfig;
    var genericEnvironment = environment;
    if (query) {
        var request = $1e0f168e0182b99b$var$getRequest(query);
        var operation = $1e0f168e0182b99b$var$createOperationDescriptor(request, variables, cacheConfig);
        var relayContext = {
            environment: genericEnvironment
        };
        if (typeof requestCacheKey === 'string' && $1e0f168e0182b99b$var$requestCache[requestCacheKey]) {
            var snapshot = $1e0f168e0182b99b$var$requestCache[requestCacheKey].snapshot;
            if (snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $1e0f168e0182b99b$var$getRenderProps(null, snapshot, queryFetcher, retryCallbacks),
                snapshot: snapshot,
                requestCacheKey: requestCacheKey
            };
            else return {
                error: null,
                relayContext: relayContext,
                renderProps: $1e0f168e0182b99b$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
        try {
            var storeSnapshot = queryFetcher.lookupInStore(genericEnvironment, operation, props.fetchPolicy);
            var querySnapshot = queryFetcher.fetch({
                environment: genericEnvironment,
                onDataChange: null,
                operation: operation
            });
            var _snapshot = querySnapshot || storeSnapshot;
            requestCacheKey = requestCacheKey || $1e0f168e0182b99b$var$getRequestCacheKey(request.params, props.variables);
            $1e0f168e0182b99b$var$requestCache[requestCacheKey] = {
                queryFetcher: queryFetcher,
                snapshot: _snapshot
            };
            if (!_snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $1e0f168e0182b99b$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
            return {
                error: null,
                relayContext: relayContext,
                renderProps: $1e0f168e0182b99b$var$getRenderProps(null, _snapshot, queryFetcher, retryCallbacks),
                snapshot: _snapshot,
                requestCacheKey: requestCacheKey
            };
        } catch (error) {
            return {
                error: error,
                relayContext: relayContext,
                renderProps: $1e0f168e0182b99b$var$getRenderProps(error, null, queryFetcher, retryCallbacks),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
    } else {
        queryFetcher.dispose();
        var _relayContext = {
            environment: genericEnvironment
        };
        return {
            error: null,
            relayContext: _relayContext,
            renderProps: $1e0f168e0182b99b$var$getEmptyRenderProps(),
            requestCacheKey: null
        };
    }
}
module.exports = $1e0f168e0182b99b$var$ReactRelayQueryRenderer;

});

parcelRegister("7qVOt", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $5697ce91df2b1f32$var$_interopRequireDefault = $bGHxy.default;

var $5697ce91df2b1f32$var$_extends2 = $5697ce91df2b1f32$var$_interopRequireDefault((parcelRequire("hxgLY")));

var $5697ce91df2b1f32$var$_objectWithoutPropertiesLoose2 = $5697ce91df2b1f32$var$_interopRequireDefault((parcelRequire("4erYc")));

var $5697ce91df2b1f32$var$_objectSpread2 = $5697ce91df2b1f32$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $5697ce91df2b1f32$var$_assertThisInitialized2 = $5697ce91df2b1f32$var$_interopRequireDefault((parcelRequire("lBoGG")));

var $5697ce91df2b1f32$var$_inheritsLoose2 = $5697ce91df2b1f32$var$_interopRequireDefault((parcelRequire("2TP0G")));

var $5697ce91df2b1f32$var$_defineProperty2 = $5697ce91df2b1f32$var$_interopRequireDefault((parcelRequire("aUl3j")));
var $5697ce91df2b1f32$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $4DPVL = parcelRequire("4DPVL");

var $fVkkU = parcelRequire("fVkkU");

var $eqZQk = parcelRequire("eqZQk");
var $5697ce91df2b1f32$var$getContainerName = $eqZQk.getContainerName;

var $1hStr = parcelRequire("1hStr");

var $lR5xR = parcelRequire("lR5xR");

var $ceCVW = parcelRequire("ceCVW");
var $5697ce91df2b1f32$var$assertRelayContext = $ceCVW.assertRelayContext;

var $cGxFv = parcelRequire("cGxFv");

var $1v5pe = parcelRequire("1v5pe");

var $ArurZ = parcelRequire("ArurZ");
var $5697ce91df2b1f32$var$Observable = $ArurZ.Observable, $5697ce91df2b1f32$var$createFragmentSpecResolver = $ArurZ.createFragmentSpecResolver, $5697ce91df2b1f32$var$createOperationDescriptor = $ArurZ.createOperationDescriptor, $5697ce91df2b1f32$var$getDataIDsFromObject = $ArurZ.getDataIDsFromObject, $5697ce91df2b1f32$var$getRequest = $ArurZ.getRequest, $5697ce91df2b1f32$var$getVariablesFromObject = $ArurZ.getVariablesFromObject, $5697ce91df2b1f32$var$isScalarAndEqual = $ArurZ.isScalarAndEqual;
parcelRequire("91yGl");
function $5697ce91df2b1f32$var$createContainerWithFragments(Component, fragments, taggedNode) {
    var _class;
    var containerName = $5697ce91df2b1f32$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $5697ce91df2b1f32$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $5697ce91df2b1f32$var$_defineProperty2["default"])((0, $5697ce91df2b1f32$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve()
                    } : null;
                });
            });
            (0, $5697ce91df2b1f32$var$_defineProperty2["default"])((0, $5697ce91df2b1f32$var$_assertThisInitialized2["default"])(_this), "_refetch", function(refetchVariables, renderVariables, observerOrCallback, options) {
                if (_this._isUnmounted) return {
                    dispose: function dispose() {}
                };
                var _assertRelayContext = $5697ce91df2b1f32$var$assertRelayContext(_this.props.__relayContext), environment = _assertRelayContext.environment;
                var rootVariables = $fVkkU(fragments, _this.props);
                var fetchVariables = typeof refetchVariables === 'function' ? refetchVariables(_this._getFragmentVariables()) : refetchVariables;
                fetchVariables = (0, $5697ce91df2b1f32$var$_objectSpread2["default"])((0, $5697ce91df2b1f32$var$_objectSpread2["default"])({}, rootVariables), fetchVariables);
                var fragmentVariables = renderVariables ? (0, $5697ce91df2b1f32$var$_objectSpread2["default"])((0, $5697ce91df2b1f32$var$_objectSpread2["default"])({}, fetchVariables), renderVariables) : fetchVariables;
                var cacheConfig = options ? {
                    force: !!options.force
                } : undefined;
                if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
                var observer = typeof observerOrCallback === 'function' ? {
                    next: observerOrCallback,
                    error: observerOrCallback
                } : observerOrCallback || {};
                var query = $5697ce91df2b1f32$var$getRequest(taggedNode);
                var operation = $5697ce91df2b1f32$var$createOperationDescriptor(query, fetchVariables, cacheConfig);
                _this.state.localVariables = fetchVariables;
                _this._refetchSubscription && _this._refetchSubscription.unsubscribe();
                var refetchSubscription;
                var storeSnapshot = _this._getQueryFetcher().lookupInStore(environment, operation, options === null || options === void 0 ? void 0 : options.fetchPolicy);
                if (storeSnapshot != null) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    _this.setState(function(latestState) {
                        return {
                            data: latestState.resolver.resolve(),
                            contextForChildren: {
                                environment: _this.props.__relayContext.environment
                            }
                        };
                    }, function() {
                        observer.next && observer.next();
                        observer.complete && observer.complete();
                    });
                    return {
                        dispose: function dispose() {}
                    };
                }
                _this._getQueryFetcher().execute({
                    environment: environment,
                    operation: operation,
                    preservePreviousReferences: true
                }).mergeMap(function(response) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    return $5697ce91df2b1f32$var$Observable.create(function(sink) {
                        return _this.setState(function(latestState) {
                            return {
                                data: latestState.resolver.resolve(),
                                contextForChildren: {
                                    environment: _this.props.__relayContext.environment
                                }
                            };
                        }, function() {
                            sink.next();
                            sink.complete();
                        });
                    });
                })["finally"](function() {
                    if (_this._refetchSubscription === refetchSubscription) _this._refetchSubscription = null;
                }).subscribe((0, $5697ce91df2b1f32$var$_objectSpread2["default"])((0, $5697ce91df2b1f32$var$_objectSpread2["default"])({}, observer), {}, {
                    start: function start(subscription) {
                        _this._refetchSubscription = refetchSubscription = subscription;
                        observer.start && observer.start(subscription);
                    }
                }));
                return {
                    dispose: function dispose() {
                        refetchSubscription && refetchSubscription.unsubscribe();
                    }
                };
            });
            var relayContext = $5697ce91df2b1f32$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._refetchSubscription = null;
            var resolver = $5697ce91df2b1f32$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                localVariables: null,
                prevProps: props,
                prevPropsContext: relayContext,
                contextForChildren: relayContext,
                relayProp: $5697ce91df2b1f32$var$getRelayProp(relayContext.environment, _this._refetch),
                resolver: resolver
            };
            _this._isUnmounted = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._queryFetcher && this._queryFetcher.dispose();
                this._refetchSubscription && this._refetchSubscription.unsubscribe();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $5697ce91df2b1f32$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $5697ce91df2b1f32$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $5697ce91df2b1f32$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $fVkkU(fragments, prevProps);
            var nextRootVariables = $fVkkU(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$cGxFv(prevRootVariables, nextRootVariables) || !$cGxFv(prevIDs, nextIDs)) {
                resolver = $5697ce91df2b1f32$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    localVariables: null,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    contextForChildren: relayContext,
                    relayProp: $5697ce91df2b1f32$var$getRelayProp(relayContext.environment, prevState.relayProp.refetch),
                    resolver: resolver
                };
            } else if (!prevState.localVariables) resolver.setProps(nextProps);
            var data = resolver.resolve();
            if (data !== prevState.data) return {
                data: data,
                prevProps: nextProps
            };
            return null;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this.state.resolver.dispose();
            this._queryFetcher && this._queryFetcher.dispose();
            this._refetchSubscription && this._refetchSubscription.unsubscribe();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (this.state.prevPropsContext.environment !== nextState.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$5697ce91df2b1f32$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getFragmentVariables = function _getFragmentVariables() {
            return $5697ce91df2b1f32$var$getVariablesFromObject(fragments, this.props);
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $lR5xR();
            return this._queryFetcher;
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $5697ce91df2b1f32$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $5697ce91df2b1f32$var$_excluded);
            var _this$state3 = this.state, relayProp = _this$state3.relayProp, contextForChildren = _this$state3.contextForChildren;
            return /*#__PURE__*/ $1v5pe.createElement($1hStr.Provider, {
                value: contextForChildren
            }, /*#__PURE__*/ $1v5pe.createElement(Component, (0, $5697ce91df2b1f32$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: relayProp
            })));
        };
        return _class;
    }($1v5pe.Component), (0, $5697ce91df2b1f32$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $5697ce91df2b1f32$var$getRelayProp(environment, refetch) {
    return {
        environment: environment,
        refetch: refetch
    };
}
function $5697ce91df2b1f32$var$createContainer(Component, fragmentSpec, taggedNode) {
    return $4DPVL(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $5697ce91df2b1f32$var$createContainerWithFragments(ComponentClass, fragments, taggedNode);
    });
}
module.exports = {
    createContainer: $5697ce91df2b1f32$var$createContainer
};

});

parcelRegister("7PnDX", function(module, exports) {
'use strict';

var $bB7hb = parcelRequire("bB7hb");

var $aLV9i = parcelRequire("aLV9i");

var $1v5pe = parcelRequire("1v5pe");

var $1v5pe = parcelRequire("1v5pe");
var $5b2fa2e8a6e1a7f9$var$useContext = $1v5pe.useContext, $5b2fa2e8a6e1a7f9$var$useEffect = $1v5pe.useEffect;
parcelRequire("91yGl");
function $5b2fa2e8a6e1a7f9$var$EntryPointContainer(_ref) {
    var entryPointReference = _ref.entryPointReference, props = _ref.props;
    var getComponent = entryPointReference.getComponent, queries = entryPointReference.queries, entryPoints = entryPointReference.entryPoints, extraProps = entryPointReference.extraProps, rootModuleID = entryPointReference.rootModuleID;
    var Component = getComponent();
    var profilerContext = $5b2fa2e8a6e1a7f9$var$useContext($bB7hb);
    var environment = $aLV9i();
    $5b2fa2e8a6e1a7f9$var$useEffect(function() {
        environment.__log({
            name: 'entrypoint.root.consume',
            profilerContext: profilerContext,
            rootModuleID: rootModuleID
        });
    }, [
        environment,
        profilerContext,
        rootModuleID
    ]);
    return /*#__PURE__*/ $1v5pe.createElement(Component, {
        entryPoints: entryPoints,
        extraProps: extraProps,
        props: props,
        queries: queries
    });
}
module.exports = $5b2fa2e8a6e1a7f9$var$EntryPointContainer;

});
parcelRegister("bB7hb", function(module, exports) {
'use strict';

var $1v5pe = parcelRequire("1v5pe");
var $8718cb4ae8a01356$var$ProfilerContext = $1v5pe.createContext({
    wrapPrepareQueryResource: function wrapPrepareQueryResource(cb) {
        return cb();
    }
});
module.exports = $8718cb4ae8a01356$var$ProfilerContext;

});

parcelRegister("aLV9i", function(module, exports) {
'use strict';

var $1hStr = parcelRequire("1hStr");

var $5Wk1R = parcelRequire("5Wk1R");

var $1v5pe = parcelRequire("1v5pe");
var $7d7a9fc8280bebed$var$useContext = $1v5pe.useContext;
function $7d7a9fc8280bebed$var$useRelayEnvironment() {
    var context = $7d7a9fc8280bebed$var$useContext($1hStr);
    !(context != null) && $5Wk1R(false);
    return context.environment;
}
module.exports = $7d7a9fc8280bebed$var$useRelayEnvironment;

});


parcelRegister("8T3sM", function(module, exports) {
'use strict';

var $gucdA = parcelRequire("gucdA");
var $6786257a25ac49f5$var$loadQuery = $gucdA.loadQuery;
function $6786257a25ac49f5$var$loadEntryPoint(environmentProvider, entryPoint, entryPointParams) {
    var loadingPromise = null;
    if (entryPoint.root.getModuleIfRequired() == null) loadingPromise = entryPoint.root.load();
    var preloadProps = entryPoint.getPreloadProps(entryPointParams);
    var queries = preloadProps.queries, entryPoints = preloadProps.entryPoints, extraProps = preloadProps.extraProps;
    var preloadedQueries = {};
    var preloadedEntryPoints = {};
    if (queries != null) {
        var queriesPropNames = Object.keys(queries);
        queriesPropNames.forEach(function(queryPropName) {
            var query = queries[queryPropName];
            if (query == null) return;
            var environmentProviderOptions = query.environmentProviderOptions, options = query.options, parameters = query.parameters, variables = query.variables;
            if ((options === null || options === void 0 ? void 0 : options.includeIf) === false) return;
            var environment = environmentProvider.getEnvironment(environmentProviderOptions);
            preloadedQueries[queryPropName] = $6786257a25ac49f5$var$loadQuery(environment, parameters, variables, {
                fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
                networkCacheConfig: options === null || options === void 0 ? void 0 : options.networkCacheConfig,
                __nameForWarning: 'loadEntryPoint'
            }, environmentProviderOptions);
        });
    }
    if (entryPoints != null) {
        var entryPointPropNames = Object.keys(entryPoints);
        entryPointPropNames.forEach(function(entryPointPropName) {
            var entryPointDescription = entryPoints[entryPointPropName];
            if (entryPointDescription == null) return;
            var nestedEntryPoint = entryPointDescription.entryPoint, nestedParams = entryPointDescription.entryPointParams;
            preloadedEntryPoints[entryPointPropName] = $6786257a25ac49f5$var$loadEntryPoint(environmentProvider, nestedEntryPoint, nestedParams);
        });
    }
    var isDisposed = false;
    return {
        dispose: function dispose() {
            if (isDisposed) return;
            if (preloadedQueries != null) Object.values(preloadedQueries).forEach(function(_ref) {
                var innerDispose = _ref.dispose;
                innerDispose();
            });
            if (preloadedEntryPoints != null) Object.values(preloadedEntryPoints).forEach(function(_ref2) {
                var innerDispose = _ref2.dispose;
                innerDispose();
            });
            isDisposed = true;
        },
        entryPoints: preloadedEntryPoints,
        extraProps: extraProps !== null && extraProps !== void 0 ? extraProps : null,
        getComponent: function getComponent() {
            var componentModule = entryPoint.root.getModuleIfRequired();
            if (componentModule == null) {
                var _loadingPromise;
                loadingPromise = (_loadingPromise = loadingPromise) !== null && _loadingPromise !== void 0 ? _loadingPromise : entryPoint.root.load();
                throw loadingPromise;
            }
            var component = componentModule["default"] != null ? componentModule["default"] : componentModule;
            return component;
        },
        get isDisposed () {
            return isDisposed;
        },
        queries: preloadedQueries,
        rootModuleID: entryPoint.root.getModuleId()
    };
}
module.exports = $6786257a25ac49f5$var$loadEntryPoint;

});
parcelRegister("gucdA", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $c008ecf44510e06e$var$_interopRequireDefault = $bGHxy.default;

var $c008ecf44510e06e$var$_objectSpread2 = $c008ecf44510e06e$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $5Wk1R = parcelRequire("5Wk1R");

var $ArurZ = parcelRequire("ArurZ");
var $c008ecf44510e06e$var$fetchQueryDeduped = $ArurZ.__internal.fetchQueryDeduped, $c008ecf44510e06e$var$Observable = $ArurZ.Observable, $c008ecf44510e06e$var$PreloadableQueryRegistry = $ArurZ.PreloadableQueryRegistry, $c008ecf44510e06e$var$ReplaySubject = $ArurZ.ReplaySubject, $c008ecf44510e06e$var$createOperationDescriptor = $ArurZ.createOperationDescriptor, $c008ecf44510e06e$var$getRequest = $ArurZ.getRequest, $c008ecf44510e06e$var$getRequestIdentifier = $ArurZ.getRequestIdentifier;
var $c008ecf44510e06e$var$fetchKey = 100001;
function $c008ecf44510e06e$var$loadQuery(environment, preloadableRequest, variables, options, environmentProviderOptions) {
    var _options$fetchPolicy;
    $c008ecf44510e06e$var$fetchKey++;
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'store-or-network';
    var networkCacheConfig = (0, $c008ecf44510e06e$var$_objectSpread2["default"])((0, $c008ecf44510e06e$var$_objectSpread2["default"])({}, options === null || options === void 0 ? void 0 : options.networkCacheConfig), {}, {
        force: true
    });
    var retainReference;
    var didExecuteNetworkSource = false;
    var executeWithNetworkSource = function executeWithNetworkSource(operation, networkObservable) {
        didExecuteNetworkSource = true;
        return environment.executeWithSource({
            operation: operation,
            source: networkObservable
        });
    };
    var executionSubject = new $c008ecf44510e06e$var$ReplaySubject();
    var returnedObservable = $c008ecf44510e06e$var$Observable.create(function(sink) {
        return executionSubject.subscribe(sink);
    });
    var unsubscribeFromNetworkRequest;
    var networkError = null;
    var didMakeNetworkRequest = false;
    var makeNetworkRequest = function makeNetworkRequest(params, checkOperation) {
        didMakeNetworkRequest = true;
        var subject = new $c008ecf44510e06e$var$ReplaySubject();
        var identifier = 'raw-network-request-' + $c008ecf44510e06e$var$getRequestIdentifier(params, variables);
        var observable = $c008ecf44510e06e$var$fetchQueryDeduped(environment, identifier, function() {
            var network = environment.getNetwork();
            return network.execute(params, variables, networkCacheConfig, undefined, undefined, undefined, undefined, checkOperation);
        });
        var _observable$subscribe = observable.subscribe({
            error: function error(err) {
                networkError = err;
                subject.error(err);
            },
            next: function next(data) {
                subject.next(data);
            },
            complete: function complete() {
                subject.complete();
            }
        }), unsubscribe = _observable$subscribe.unsubscribe;
        unsubscribeFromNetworkRequest = unsubscribe;
        return $c008ecf44510e06e$var$Observable.create(function(sink) {
            var subjectSubscription = subject.subscribe(sink);
            return function() {
                subjectSubscription.unsubscribe();
                unsubscribeFromNetworkRequest();
            };
        });
    };
    var unsubscribeFromExecution;
    var executeDeduped = function executeDeduped(operation, fetchFn) {
        didMakeNetworkRequest = true;
        var _fetchQueryDeduped$su = $c008ecf44510e06e$var$fetchQueryDeduped(environment, operation.request.identifier, fetchFn).subscribe({
            error: function error(err) {
                executionSubject.error(err);
            },
            next: function next(data) {
                executionSubject.next(data);
            },
            complete: function complete() {
                executionSubject.complete();
            }
        });
        unsubscribeFromExecution = _fetchQueryDeduped$su.unsubscribe;
    };
    var checkAvailabilityAndExecute = function checkAvailabilityAndExecute(concreteRequest) {
        var operation = $c008ecf44510e06e$var$createOperationDescriptor(concreteRequest, variables, networkCacheConfig);
        retainReference = environment.retain(operation);
        if (fetchPolicy === 'store-only') return;
        var shouldFetch = fetchPolicy !== 'store-or-network' || environment.check(operation).status !== 'available';
        if (shouldFetch) executeDeduped(operation, function() {
            var networkObservable = makeNetworkRequest(concreteRequest.params, function() {
                return environment.check(operation);
            });
            var executeObservable = executeWithNetworkSource(operation, networkObservable);
            return executeObservable;
        });
    };
    var params;
    var cancelOnLoadCallback;
    var queryId;
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
        var preloadableConcreteRequest = preloadableRequest;
        params = preloadableConcreteRequest.params;
        var _params = params;
        queryId = _params.id;
        !(queryId !== null) && $5Wk1R(false);
        var _module = $c008ecf44510e06e$var$PreloadableQueryRegistry.get(queryId);
        if (_module != null) checkAvailabilityAndExecute(_module);
        else {
            var networkObservable = fetchPolicy === 'store-only' ? null : makeNetworkRequest(params);
            var _PreloadableQueryRegi = $c008ecf44510e06e$var$PreloadableQueryRegistry.onLoad(queryId, function(preloadedModule) {
                cancelOnLoadCallback();
                var operation = $c008ecf44510e06e$var$createOperationDescriptor(preloadedModule, variables, networkCacheConfig);
                retainReference = environment.retain(operation);
                if (networkObservable != null) executeDeduped(operation, function() {
                    return executeWithNetworkSource(operation, networkObservable);
                });
            });
            cancelOnLoadCallback = _PreloadableQueryRegi.dispose;
        }
    } else {
        var graphQlTaggedNode = preloadableRequest;
        var request = $c008ecf44510e06e$var$getRequest(graphQlTaggedNode);
        params = request.params;
        queryId = params.cacheID != null ? params.cacheID : params.id;
        checkAvailabilityAndExecute(request);
    }
    var isDisposed = false;
    var isReleased = false;
    var isNetworkRequestCancelled = false;
    var releaseQuery = function releaseQuery() {
        if (isReleased) return;
        retainReference && retainReference.dispose();
        isReleased = true;
    };
    var cancelNetworkRequest = function cancelNetworkRequest() {
        if (isNetworkRequestCancelled) return;
        if (didExecuteNetworkSource) unsubscribeFromExecution && unsubscribeFromExecution();
        else unsubscribeFromNetworkRequest && unsubscribeFromNetworkRequest();
        cancelOnLoadCallback && cancelOnLoadCallback();
        isNetworkRequestCancelled = true;
    };
    return {
        kind: 'PreloadedQuery',
        environment: environment,
        environmentProviderOptions: environmentProviderOptions,
        dispose: function dispose() {
            if (isDisposed) return;
            releaseQuery();
            cancelNetworkRequest();
            isDisposed = true;
        },
        releaseQuery: releaseQuery,
        cancelNetworkRequest: cancelNetworkRequest,
        fetchKey: $c008ecf44510e06e$var$fetchKey,
        id: queryId,
        get isDisposed () {
            return isDisposed || isReleased;
        },
        get networkError () {
            return networkError;
        },
        name: params.name,
        networkCacheConfig: networkCacheConfig,
        fetchPolicy: fetchPolicy,
        source: didMakeNetworkRequest ? returnedObservable : undefined,
        variables: variables
    };
}
module.exports = {
    loadQuery: $c008ecf44510e06e$var$loadQuery
};

});


parcelRegister("i9N25", function(module, exports) {
'use strict';

var $1hStr = parcelRequire("1hStr");

var $1v5pe = parcelRequire("1v5pe");
var $d37f1a19aefbff72$var$useMemo = $1v5pe.useMemo;
function $d37f1a19aefbff72$var$RelayEnvironmentProvider(props) {
    var children = props.children, environment = props.environment, getEnvironmentForActor = props.getEnvironmentForActor;
    var context = $d37f1a19aefbff72$var$useMemo(function() {
        return {
            environment: environment,
            getEnvironmentForActor: getEnvironmentForActor
        };
    }, [
        environment,
        getEnvironmentForActor
    ]);
    return /*#__PURE__*/ $1v5pe.createElement($1hStr.Provider, {
        value: context
    }, children);
}
module.exports = $d37f1a19aefbff72$var$RelayEnvironmentProvider;

});

parcelRegister("h6pym", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $c736d185605b8cf8$var$_interopRequireDefault = $bGHxy.default;

var $c736d185605b8cf8$var$_objectSpread2 = $c736d185605b8cf8$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $bGlmd = parcelRequire("bGlmd");
function $c736d185605b8cf8$var$useClientQuery(gqlQuery, variables, options) {
    var query = gqlQuery;
    return $bGlmd(query, variables, (0, $c736d185605b8cf8$var$_objectSpread2["default"])((0, $c736d185605b8cf8$var$_objectSpread2["default"])({}, options), {}, {
        fetchPolicy: 'store-only'
    }));
}
module.exports = $c736d185605b8cf8$var$useClientQuery;

});
parcelRegister("bGlmd", function(module, exports) {
'use strict';

var $hpgYJ = parcelRequire("hpgYJ");

var $9cvfB = parcelRequire("9cvfB");

var $aLV9i = parcelRequire("aLV9i");

var $ArurZ = parcelRequire("ArurZ");
var $88142f17f7f54a95$var$fetchQuery = $ArurZ.__internal.fetchQuery;
function $88142f17f7f54a95$var$useLazyLoadQuery(gqlQuery, variables, options) {
    var environment = $aLV9i();
    var query = $9cvfB(gqlQuery, variables, options && options.networkCacheConfig ? options.networkCacheConfig : {
        force: true
    });
    var data = $hpgYJ({
        componentDisplayName: 'useLazyLoadQuery()',
        fetchKey: options === null || options === void 0 ? void 0 : options.fetchKey,
        fetchObservable: $88142f17f7f54a95$var$fetchQuery(environment, query),
        fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
        query: query,
        renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
    });
    return data;
}
module.exports = $88142f17f7f54a95$var$useLazyLoadQuery;

});
parcelRegister("hpgYJ", function(module, exports) {
'use strict';

var $bB7hb = parcelRequire("bB7hb");

var $lFOtW = parcelRequire("lFOtW");
var $cac1f10f59af4adc$var$getQueryCacheIdentifier = $lFOtW.getQueryCacheIdentifier, $cac1f10f59af4adc$var$getQueryResourceForEnvironment = $lFOtW.getQueryResourceForEnvironment;

var $1DgzH = parcelRequire("1DgzH");

var $ayoXm = parcelRequire("ayoXm");

var $aLV9i = parcelRequire("aLV9i");

var $1v5pe = parcelRequire("1v5pe");
var $cac1f10f59af4adc$var$useContext = $1v5pe.useContext, $cac1f10f59af4adc$var$useEffect = $1v5pe.useEffect, $cac1f10f59af4adc$var$useState = $1v5pe.useState, $cac1f10f59af4adc$var$useRef = $1v5pe.useRef;
function $cac1f10f59af4adc$var$useLazyLoadQueryNode(_ref) {
    var query = _ref.query, componentDisplayName = _ref.componentDisplayName, fetchObservable = _ref.fetchObservable, fetchPolicy = _ref.fetchPolicy, fetchKey = _ref.fetchKey, renderPolicy = _ref.renderPolicy;
    var environment = $aLV9i();
    var profilerContext = $cac1f10f59af4adc$var$useContext($bB7hb);
    var QueryResource = $cac1f10f59af4adc$var$getQueryResourceForEnvironment(environment);
    var _useState = $cac1f10f59af4adc$var$useState(0), forceUpdateKey = _useState[0], forceUpdate = _useState[1];
    var _useFetchTrackingRef = $1DgzH(), startFetch = _useFetchTrackingRef.startFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var cacheBreaker = "".concat(forceUpdateKey, "-").concat(fetchKey !== null && fetchKey !== void 0 ? fetchKey : '');
    var cacheIdentifier = $cac1f10f59af4adc$var$getQueryCacheIdentifier(environment, query, fetchPolicy, renderPolicy, cacheBreaker);
    var preparedQueryResult = profilerContext.wrapPrepareQueryResource(function() {
        return QueryResource.prepareWithIdentifier(cacheIdentifier, query, fetchObservable, fetchPolicy, renderPolicy, {
            start: startFetch,
            complete: completeFetch,
            error: completeFetch
        }, profilerContext);
    });
    var maybeHiddenOrFastRefresh = $cac1f10f59af4adc$var$useRef(false);
    $cac1f10f59af4adc$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $cac1f10f59af4adc$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            forceUpdate(function(n) {
                return n + 1;
            });
            return;
        }
        var disposable = QueryResource.retain(preparedQueryResult, profilerContext);
        return function() {
            disposable.dispose();
        };
    }, [
        environment,
        cacheIdentifier
    ]);
    $cac1f10f59af4adc$var$useEffect(function() {
        QueryResource.releaseTemporaryRetain(preparedQueryResult);
    });
    var fragmentNode = preparedQueryResult.fragmentNode, fragmentRef = preparedQueryResult.fragmentRef;
    var data = $ayoXm(fragmentNode, fragmentRef, componentDisplayName);
    return data;
}
module.exports = $cac1f10f59af4adc$var$useLazyLoadQueryNode;

});
parcelRegister("lFOtW", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $fc7495f4b5f485f8$var$_interopRequireDefault = $bGHxy.default;

var $fc7495f4b5f485f8$var$_objectSpread2 = $fc7495f4b5f485f8$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $fc7495f4b5f485f8$var$_defineProperty2 = $fc7495f4b5f485f8$var$_interopRequireDefault((parcelRequire("aUl3j")));

var $dkrR7 = parcelRequire("dkrR7");

var $8iCIV = parcelRequire("8iCIV");

var $5Wk1R = parcelRequire("5Wk1R");

var $ArurZ = parcelRequire("ArurZ");
var $fc7495f4b5f485f8$var$isPromise = $ArurZ.isPromise;
parcelRequire("91yGl");
var $fc7495f4b5f485f8$var$CACHE_CAPACITY = 1000;
var $fc7495f4b5f485f8$var$DEFAULT_FETCH_POLICY = 'store-or-network';
var $fc7495f4b5f485f8$var$DEFAULT_LIVE_FETCH_POLICY = 'store-and-network';
var $fc7495f4b5f485f8$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
function $fc7495f4b5f485f8$var$operationIsLiveQuery(operation) {
    return operation.request.node.params.metadata.live !== undefined;
}
function $fc7495f4b5f485f8$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
    var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $fc7495f4b5f485f8$var$operationIsLiveQuery(operation) ? $fc7495f4b5f485f8$var$DEFAULT_LIVE_FETCH_POLICY : $fc7495f4b5f485f8$var$DEFAULT_FETCH_POLICY;
    var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
    var cacheIdentifier = "".concat(fetchPolicy, "-").concat(renderPolicy, "-").concat(operation.request.identifier);
    if (cacheBreaker != null) return "".concat(cacheIdentifier, "-").concat(cacheBreaker);
    return cacheIdentifier;
}
function $fc7495f4b5f485f8$var$getQueryResult(operation, cacheIdentifier) {
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, $fc7495f4b5f485f8$var$_defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    return {
        cacheIdentifier: cacheIdentifier,
        fragmentNode: operation.request.node.fragment,
        fragmentRef: rootFragmentRef,
        operation: operation
    };
}
var $fc7495f4b5f485f8$var$nextID = 200000;
function $fc7495f4b5f485f8$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, onDispose) {
    var isLiveQuery = $fc7495f4b5f485f8$var$operationIsLiveQuery(operation);
    var currentValue = value;
    var currentNetworkSubscription = networkSubscription;
    var suspenseResource = new $8iCIV(function(environment) {
        var retention = environment.retain(operation);
        return {
            dispose: function dispose() {
                if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
                retention.dispose();
                onDispose(cacheEntry);
            }
        };
    });
    var cacheEntry = {
        cacheIdentifier: cacheIdentifier,
        id: $fc7495f4b5f485f8$var$nextID++,
        processedPayloadsCount: 0,
        operationAvailability: operationAvailability,
        getValue: function getValue() {
            return currentValue;
        },
        setValue: function setValue(val) {
            currentValue = val;
        },
        setNetworkSubscription: function setNetworkSubscription(subscription) {
            if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
            currentNetworkSubscription = subscription;
        },
        temporaryRetain: function temporaryRetain(environment) {
            return suspenseResource.temporaryRetain(environment);
        },
        permanentRetain: function permanentRetain(environment) {
            return suspenseResource.permanentRetain(environment);
        },
        releaseTemporaryRetain: function releaseTemporaryRetain() {
            suspenseResource.releaseTemporaryRetain();
        }
    };
    return cacheEntry;
}
var $fc7495f4b5f485f8$var$QueryResourceImpl = /*#__PURE__*/ function() {
    function QueryResourceImpl(environment) {
        var _this = this;
        (0, $fc7495f4b5f485f8$var$_defineProperty2["default"])(this, "_clearCacheEntry", function(cacheEntry) {
            _this._cache["delete"](cacheEntry.cacheIdentifier);
        });
        this._environment = environment;
        this._cache = $dkrR7.create($fc7495f4b5f485f8$var$CACHE_CAPACITY);
    }
    var _proto = QueryResourceImpl.prototype;
    _proto.prepare = function prepare(operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, cacheBreaker, profilerContext) {
        var cacheIdentifier = $fc7495f4b5f485f8$var$getQueryCacheIdentifier(this._environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this.prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext);
    };
    _proto.prepareWithIdentifier = function prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext) {
        var environment = this._environment;
        var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $fc7495f4b5f485f8$var$operationIsLiveQuery(operation) ? $fc7495f4b5f485f8$var$DEFAULT_LIVE_FETCH_POLICY : $fc7495f4b5f485f8$var$DEFAULT_FETCH_POLICY;
        var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
        var cacheEntry = this._cache.get(cacheIdentifier);
        var temporaryRetainDisposable = null;
        var entryWasCached = cacheEntry != null;
        if (cacheEntry == null) cacheEntry = this._fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, (0, $fc7495f4b5f485f8$var$_objectSpread2["default"])((0, $fc7495f4b5f485f8$var$_objectSpread2["default"])({}, observer), {}, {
            unsubscribe: function unsubscribe(subscription) {
                if (temporaryRetainDisposable != null) temporaryRetainDisposable.dispose();
                var observerUnsubscribe = observer === null || observer === void 0 ? void 0 : observer.unsubscribe;
                observerUnsubscribe && observerUnsubscribe(subscription);
            }
        }));
        temporaryRetainDisposable = cacheEntry.temporaryRetain(environment);
        var cachedValue = cacheEntry.getValue();
        if ($fc7495f4b5f485f8$var$isPromise(cachedValue)) {
            environment.__log({
                name: 'suspense.query',
                fetchPolicy: fetchPolicy,
                isPromiseCached: entryWasCached,
                operation: operation,
                queryAvailability: cacheEntry.operationAvailability,
                renderPolicy: renderPolicy
            });
            throw cachedValue;
        }
        if (cachedValue instanceof Error) throw cachedValue;
        return cachedValue;
    };
    _proto.retain = function retain(queryResult, profilerContext) {
        var environment = this._environment;
        var cacheIdentifier = queryResult.cacheIdentifier, operation = queryResult.operation;
        var cacheEntry = this._getOrCreateCacheEntry(cacheIdentifier, operation, null, queryResult, null);
        var disposable = cacheEntry.permanentRetain(environment);
        environment.__log({
            name: 'queryresource.retain',
            profilerContext: profilerContext,
            resourceID: cacheEntry.id
        });
        return {
            dispose: function dispose() {
                disposable.dispose();
            }
        };
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain(queryResult) {
        var cacheEntry = this._cache.get(queryResult.cacheIdentifier);
        if (cacheEntry != null) cacheEntry.releaseTemporaryRetain();
    };
    _proto.TESTS_ONLY__getCacheEntry = function TESTS_ONLY__getCacheEntry(operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
        var environment = this._environment;
        var cacheIdentifier = $fc7495f4b5f485f8$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this._cache.get(cacheIdentifier);
    };
    _proto._getOrCreateCacheEntry = function _getOrCreateCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription) {
        var cacheEntry = this._cache.get(cacheIdentifier);
        if (cacheEntry == null) {
            cacheEntry = $fc7495f4b5f485f8$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, cacheEntry);
        }
        return cacheEntry;
    };
    _proto._fetchAndSaveQuery = function _fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, observer) {
        var _this2 = this;
        var environment = this._environment;
        var queryAvailability = environment.check(operation);
        var queryStatus = queryAvailability.status;
        var hasFullQuery = queryStatus === 'available';
        var canPartialRender = hasFullQuery || renderPolicy === 'partial' && queryStatus !== 'stale';
        var shouldFetch;
        var shouldAllowRender;
        var resolveNetworkPromise = function resolveNetworkPromise() {};
        switch(fetchPolicy){
            case 'store-only':
                shouldFetch = false;
                shouldAllowRender = true;
                break;
            case 'store-or-network':
                shouldFetch = !hasFullQuery;
                shouldAllowRender = canPartialRender;
                break;
            case 'store-and-network':
                shouldFetch = true;
                shouldAllowRender = canPartialRender;
                break;
            case 'network-only':
            default:
                shouldFetch = true;
                shouldAllowRender = false;
                break;
        }
        if (shouldAllowRender) {
            var queryResult = $fc7495f4b5f485f8$var$getQueryResult(operation, cacheIdentifier);
            var _cacheEntry = $fc7495f4b5f485f8$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, queryResult, null, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, _cacheEntry);
        }
        if (shouldFetch) {
            var _queryResult = $fc7495f4b5f485f8$var$getQueryResult(operation, cacheIdentifier);
            var networkSubscription;
            fetchObservable.subscribe({
                start: function start(subscription) {
                    networkSubscription = subscription;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(networkSubscription);
                    var observerStart = observer === null || observer === void 0 ? void 0 : observer.start;
                    if (observerStart) {
                        var subscriptionWithConditionalCancelation = (0, $fc7495f4b5f485f8$var$_objectSpread2["default"])((0, $fc7495f4b5f485f8$var$_objectSpread2["default"])({}, subscription), {}, {
                            unsubscribe: function unsubscribe() {
                                if ($fc7495f4b5f485f8$var$operationIsLiveQuery(operation)) subscription.unsubscribe();
                            }
                        });
                        observerStart(subscriptionWithConditionalCancelation);
                    }
                },
                next: function next() {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _queryResult, networkSubscription);
                    cacheEntry.processedPayloadsCount += 1;
                    cacheEntry.setValue(_queryResult);
                    resolveNetworkPromise();
                    var observerNext = observer === null || observer === void 0 ? void 0 : observer.next;
                    if (observerNext != null) {
                        var snapshot = environment.lookup(operation.fragment);
                        observerNext(snapshot);
                    }
                },
                error: function error(_error) {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _error, networkSubscription);
                    if (cacheEntry.processedPayloadsCount === 0) cacheEntry.setValue(_error);
                    resolveNetworkPromise();
                    networkSubscription = null;
                    cacheEntry.setNetworkSubscription(null);
                    var observerError = observer === null || observer === void 0 ? void 0 : observer.error;
                    observerError && observerError(_error);
                },
                complete: function complete() {
                    resolveNetworkPromise();
                    networkSubscription = null;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(null);
                    var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
                    observerComplete && observerComplete();
                },
                unsubscribe: observer === null || observer === void 0 ? void 0 : observer.unsubscribe
            });
            var _cacheEntry2 = this._cache.get(cacheIdentifier);
            if (!_cacheEntry2) {
                var networkPromise = new Promise(function(resolve) {
                    resolveNetworkPromise = resolve;
                });
                networkPromise.displayName = 'Relay(' + operation.fragment.node.name + ')';
                _cacheEntry2 = $fc7495f4b5f485f8$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, networkPromise, networkSubscription, this._clearCacheEntry);
                this._cache.set(cacheIdentifier, _cacheEntry2);
            }
        } else {
            var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
            observerComplete && observerComplete();
        }
        var cacheEntry = this._cache.get(cacheIdentifier);
        !(cacheEntry != null) && $5Wk1R(false);
        environment.__log({
            name: 'queryresource.fetch',
            resourceID: cacheEntry.id,
            operation: operation,
            profilerContext: profilerContext,
            fetchPolicy: fetchPolicy,
            renderPolicy: renderPolicy,
            queryAvailability: queryAvailability,
            shouldFetch: shouldFetch
        });
        return cacheEntry;
    };
    return QueryResourceImpl;
}();
function $fc7495f4b5f485f8$var$createQueryResource(environment) {
    return new $fc7495f4b5f485f8$var$QueryResourceImpl(environment);
}
var $fc7495f4b5f485f8$var$dataResources = $fc7495f4b5f485f8$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $fc7495f4b5f485f8$var$getQueryResourceForEnvironment(environment) {
    var cached = $fc7495f4b5f485f8$var$dataResources.get(environment);
    if (cached) return cached;
    var newDataResource = $fc7495f4b5f485f8$var$createQueryResource(environment);
    $fc7495f4b5f485f8$var$dataResources.set(environment, newDataResource);
    return newDataResource;
}
module.exports = {
    createQueryResource: $fc7495f4b5f485f8$var$createQueryResource,
    getQueryResourceForEnvironment: $fc7495f4b5f485f8$var$getQueryResourceForEnvironment,
    getQueryCacheIdentifier: $fc7495f4b5f485f8$var$getQueryCacheIdentifier
};

});
parcelRegister("dkrR7", function(module, exports) {
'use strict';

var $5Wk1R = parcelRequire("5Wk1R");
var $9b42c036c6355396$var$LRUCache = /*#__PURE__*/ function() {
    function LRUCache(capacity) {
        this._capacity = capacity;
        !(this._capacity > 0) && $5Wk1R(false);
        this._map = new Map();
    }
    var _proto = LRUCache.prototype;
    _proto.set = function set(key, value) {
        this._map["delete"](key);
        this._map.set(key, value);
        if (this._map.size > this._capacity) {
            var firstKey = this._map.keys().next();
            if (!firstKey.done) this._map["delete"](firstKey.value);
        }
    };
    _proto.get = function get(key) {
        var value = this._map.get(key);
        if (value != null) {
            this._map["delete"](key);
            this._map.set(key, value);
        }
        return value;
    };
    _proto.has = function has(key) {
        return this._map.has(key);
    };
    _proto["delete"] = function _delete(key) {
        this._map["delete"](key);
    };
    _proto.size = function size() {
        return this._map.size;
    };
    _proto.capacity = function capacity() {
        return this._capacity - this._map.size;
    };
    _proto.clear = function clear() {
        this._map.clear();
    };
    return LRUCache;
}();
function $9b42c036c6355396$var$create(capacity) {
    return new $9b42c036c6355396$var$LRUCache(capacity);
}
module.exports = {
    create: $9b42c036c6355396$var$create
};

});

parcelRegister("8iCIV", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $60ae0adf3fbfd92d$var$_interopRequireDefault = $bGHxy.default;

var $60ae0adf3fbfd92d$var$_defineProperty2 = $60ae0adf3fbfd92d$var$_interopRequireDefault((parcelRequire("aUl3j")));
parcelRequire("91yGl");
var $60ae0adf3fbfd92d$var$TEMPORARY_RETAIN_DURATION_MS = 300000;
var $60ae0adf3fbfd92d$var$SuspenseResource = /*#__PURE__*/ function() {
    function SuspenseResource(retain) {
        var _this = this;
        (0, $60ae0adf3fbfd92d$var$_defineProperty2["default"])(this, "_retainCount", 0);
        (0, $60ae0adf3fbfd92d$var$_defineProperty2["default"])(this, "_retainDisposable", null);
        (0, $60ae0adf3fbfd92d$var$_defineProperty2["default"])(this, "_releaseTemporaryRetain", null);
        this._retain = function(environment) {
            _this._retainCount++;
            if (_this._retainCount === 1) _this._retainDisposable = retain(environment);
            return {
                dispose: function dispose() {
                    _this._retainCount = Math.max(0, _this._retainCount - 1);
                    if (_this._retainCount === 0) {
                        if (_this._retainDisposable != null) {
                            _this._retainDisposable.dispose();
                            _this._retainDisposable = null;
                        }
                    }
                }
            };
        };
    }
    var _proto = SuspenseResource.prototype;
    _proto.temporaryRetain = function temporaryRetain(environment) {
        var _this2 = this;
        var _this$_releaseTempora;
        if (environment.isServer()) return {
            dispose: function dispose() {}
        };
        var retention = this._retain(environment);
        var releaseQueryTimeout = null;
        var releaseTemporaryRetain = function releaseTemporaryRetain() {
            clearTimeout(releaseQueryTimeout);
            releaseQueryTimeout = null;
            _this2._releaseTemporaryRetain = null;
            retention.dispose();
        };
        releaseQueryTimeout = setTimeout(releaseTemporaryRetain, $60ae0adf3fbfd92d$var$TEMPORARY_RETAIN_DURATION_MS);
        (_this$_releaseTempora = this._releaseTemporaryRetain) === null || _this$_releaseTempora === void 0 || _this$_releaseTempora.call(this);
        this._releaseTemporaryRetain = releaseTemporaryRetain;
        return {
            dispose: function dispose() {
                var _this$_releaseTempora2;
                (_this$_releaseTempora2 = _this2._releaseTemporaryRetain) === null || _this$_releaseTempora2 === void 0 || _this$_releaseTempora2.call(_this2);
            }
        };
    };
    _proto.permanentRetain = function permanentRetain(environment) {
        var disposable = this._retain(environment);
        this.releaseTemporaryRetain();
        return disposable;
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain() {
        var _this$_releaseTempora3;
        (_this$_releaseTempora3 = this._releaseTemporaryRetain) === null || _this$_releaseTempora3 === void 0 || _this$_releaseTempora3.call(this);
        this._releaseTemporaryRetain = null;
    };
    _proto.getRetainCount = function getRetainCount() {
        return this._retainCount;
    };
    return SuspenseResource;
}();
module.exports = $60ae0adf3fbfd92d$var$SuspenseResource;

});


parcelRegister("1DgzH", function(module, exports) {
'use strict';

var $YZJru = parcelRequire("YZJru");

var $1v5pe = parcelRequire("1v5pe");
var $13064a627f9c95c3$var$useCallback = $1v5pe.useCallback, $13064a627f9c95c3$var$useEffect = $1v5pe.useEffect;
function $13064a627f9c95c3$var$useFetchTrackingRef() {
    var subscriptionRef = $YZJru(null);
    var isFetchingRef = $YZJru(false);
    var disposeFetch = $13064a627f9c95c3$var$useCallback(function() {
        if (subscriptionRef.current != null) {
            subscriptionRef.current.unsubscribe();
            subscriptionRef.current = null;
        }
        isFetchingRef.current = false;
    }, []);
    var startFetch = $13064a627f9c95c3$var$useCallback(function(subscription) {
        subscriptionRef.current = subscription;
        isFetchingRef.current = true;
    }, []);
    var completeFetch = $13064a627f9c95c3$var$useCallback(function() {
        subscriptionRef.current = null;
        isFetchingRef.current = false;
    }, []);
    $13064a627f9c95c3$var$useEffect(function() {
        return disposeFetch;
    }, [
        disposeFetch
    ]);
    return {
        isFetchingRef: isFetchingRef,
        startFetch: startFetch,
        disposeFetch: disposeFetch,
        completeFetch: completeFetch
    };
}
module.exports = $13064a627f9c95c3$var$useFetchTrackingRef;

});
parcelRegister("YZJru", function(module, exports) {
'use strict';

var $1v5pe = parcelRequire("1v5pe");
var $0b757d6384a6007e$var$useMemo = $1v5pe.useMemo;
function $0b757d6384a6007e$var$useUnsafeRef_DEPRECATED(init) {
    return $0b757d6384a6007e$var$useMemo(function() {
        return {
            current: init
        };
    }, []);
}
module.exports = $0b757d6384a6007e$var$useUnsafeRef_DEPRECATED;

});


parcelRegister("ayoXm", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $7af0702ac8ba7125$var$_interopRequireDefault = $bGHxy.default;

var $7af0702ac8ba7125$var$_useFragmentInternal_CURRENT = $7af0702ac8ba7125$var$_interopRequireDefault((parcelRequire("k2gXa")));

var $7af0702ac8ba7125$var$_useFragmentInternal_EXPERIMENTAL = $7af0702ac8ba7125$var$_interopRequireDefault((parcelRequire("61OJG")));

var $ArurZ = parcelRequire("ArurZ");
function $7af0702ac8ba7125$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    if ($ArurZ.RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return (0, $7af0702ac8ba7125$var$_useFragmentInternal_EXPERIMENTAL["default"])(fragmentNode, fragmentRef, hookDisplayName, queryOptions);
    return (0, $7af0702ac8ba7125$var$_useFragmentInternal_CURRENT["default"])(fragmentNode, fragmentRef, hookDisplayName, queryOptions);
}
module.exports = $7af0702ac8ba7125$var$useFragmentInternal;

});
parcelRegister("k2gXa", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $e9612524ef6c2fa4$var$_interopRequireDefault = $bGHxy.default;

var $e9612524ef6c2fa4$var$_objectSpread2 = $e9612524ef6c2fa4$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $e9612524ef6c2fa4$var$_createForOfIteratorHelper2 = $e9612524ef6c2fa4$var$_interopRequireDefault((parcelRequire("cXbK5")));

var $e9612524ef6c2fa4$var$_toConsumableArray2 = $e9612524ef6c2fa4$var$_interopRequireDefault((parcelRequire("kTVTn")));

var $lFOtW = parcelRequire("lFOtW");
var $e9612524ef6c2fa4$var$getQueryResourceForEnvironment = $lFOtW.getQueryResourceForEnvironment;

var $aLV9i = parcelRequire("aLV9i");

var $fNYxL = parcelRequire("fNYxL");

var $5Wk1R = parcelRequire("5Wk1R");

var $1v5pe = parcelRequire("1v5pe");
var $e9612524ef6c2fa4$var$useDebugValue = $1v5pe.useDebugValue, $e9612524ef6c2fa4$var$useEffect = $1v5pe.useEffect, $e9612524ef6c2fa4$var$useMemo = $1v5pe.useMemo, $e9612524ef6c2fa4$var$useRef = $1v5pe.useRef, $e9612524ef6c2fa4$var$useState = $1v5pe.useState;

var $ArurZ = parcelRequire("ArurZ");
var $e9612524ef6c2fa4$var$_require3$__internal = $ArurZ.__internal, $e9612524ef6c2fa4$var$fetchQueryInternal = $e9612524ef6c2fa4$var$_require3$__internal.fetchQuery, $e9612524ef6c2fa4$var$getPromiseForActiveRequest = $e9612524ef6c2fa4$var$_require3$__internal.getPromiseForActiveRequest, $e9612524ef6c2fa4$var$RelayFeatureFlags = $ArurZ.RelayFeatureFlags, $e9612524ef6c2fa4$var$areEqualSelectors = $ArurZ.areEqualSelectors, $e9612524ef6c2fa4$var$createOperationDescriptor = $ArurZ.createOperationDescriptor, $e9612524ef6c2fa4$var$getPendingOperationsForFragment = $ArurZ.getPendingOperationsForFragment, $e9612524ef6c2fa4$var$getSelector = $ArurZ.getSelector, $e9612524ef6c2fa4$var$getVariablesFromFragment = $ArurZ.getVariablesFromFragment, $e9612524ef6c2fa4$var$handlePotentialSnapshotErrors = $ArurZ.handlePotentialSnapshotErrors, $e9612524ef6c2fa4$var$recycleNodesInto = $ArurZ.recycleNodesInto;
parcelRequire("91yGl");
function $e9612524ef6c2fa4$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $e9612524ef6c2fa4$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $e9612524ef6c2fa4$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $e9612524ef6c2fa4$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $e9612524ef6c2fa4$var$getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $e9612524ef6c2fa4$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $e9612524ef6c2fa4$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $e9612524ef6c2fa4$var$handlePotentialSnapshotErrorsForState(environment, state, loggingContext) {
    if (state.kind === 'singular') $e9612524ef6c2fa4$var$handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors, loggingContext);
    else if (state.kind === 'plural') {
        var _iterator5 = (0, $e9612524ef6c2fa4$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var snapshot = _step5.value;
                $e9612524ef6c2fa4$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors, loggingContext);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $e9612524ef6c2fa4$var$handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $e9612524ef6c2fa4$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            fieldErrors: currentSnapshot.fieldErrors
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: 'singular',
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $e9612524ef6c2fa4$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                fieldErrors: _currentSnapshot.fieldErrors
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $5Wk1R(false);
        return [
            didMissUpdates,
            {
                kind: 'plural',
                snapshots: currentSnapshots,
                epoch: currentEpoch
            }
        ];
    }
}
function $e9612524ef6c2fa4$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $e9612524ef6c2fa4$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $e9612524ef6c2fa4$var$_objectSpread2["default"])((0, $e9612524ef6c2fa4$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $e9612524ef6c2fa4$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $e9612524ef6c2fa4$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $e9612524ef6c2fa4$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    return [
        queryResult,
        $e9612524ef6c2fa4$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request)
    ];
}
function $e9612524ef6c2fa4$var$subscribeToSnapshot(environment, state, setState, hasPendingStateChanges) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector) {
                    var updates = $e9612524ef6c2fa4$var$handleMissedUpdates(environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], nextState = updates[1];
                        environment.__log({
                            name: 'useFragment.subscription.missedUpdates',
                            hasDataChanges: dataChanged
                        });
                        hasPendingStateChanges.current = dataChanged;
                        return dataChanged ? nextState : prevState;
                    } else return prevState;
                }
                hasPendingStateChanges.current = true;
                return {
                    kind: 'singular',
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch()
                };
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector) {
                        var updates = $e9612524ef6c2fa4$var$handleMissedUpdates(environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], nextState = updates[1];
                            environment.__log({
                                name: 'useFragment.subscription.missedUpdates',
                                hasDataChanges: dataChanged
                            });
                            hasPendingStateChanges.current = hasPendingStateChanges.current || dataChanged;
                            return dataChanged ? nextState : prevState;
                        } else return prevState;
                    }
                    var updated = (0, $e9612524ef6c2fa4$var$_toConsumableArray2["default"])(prevState.snapshots);
                    updated[index] = latestSnapshot;
                    hasPendingStateChanges.current = true;
                    return {
                        kind: 'plural',
                        snapshots: updated,
                        epoch: environment.getStore().getEpoch()
                    };
                });
            });
        });
        return function() {
            var _iterator6 = (0, $e9612524ef6c2fa4$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $e9612524ef6c2fa4$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch()
    };
    else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $e9612524ef6c2fa4$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $e9612524ef6c2fa4$var$useMemo(function() {
        return $e9612524ef6c2fa4$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $5Wk1R(false);
    else !!Array.isArray(fragmentRef) && $5Wk1R(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $5Wk1R(false);
    var environment = $aLV9i();
    var loggerContext;
    if ($e9612524ef6c2fa4$var$RelayFeatureFlags.ENABLE_UI_CONTEXT_ON_RELAY_LOGGER) loggerContext = $fNYxL();
    var _useState = $e9612524ef6c2fa4$var$useState(function() {
        return $e9612524ef6c2fa4$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var _useState2 = $e9612524ef6c2fa4$var$useState(state), _subscribedState = _useState2[0], setSubscribedState = _useState2[1];
    var subscribedState = _subscribedState;
    var _useState3 = $e9612524ef6c2fa4$var$useState(fragmentSelector), previousFragmentSelector = _useState3[0], setPreviousFragmentSelector = _useState3[1];
    var _useState4 = $e9612524ef6c2fa4$var$useState(environment), previousEnvironment = _useState4[0], setPreviousEnvironment = _useState4[1];
    if (!$e9612524ef6c2fa4$var$areEqualSelectors(fragmentSelector, previousFragmentSelector) || environment !== previousEnvironment) {
        setPreviousFragmentSelector(fragmentSelector);
        setPreviousEnvironment(environment);
        var newState = $e9612524ef6c2fa4$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        setSubscribedState(newState);
        state = newState;
        subscribedState = newState;
    }
    var committedFragmentSelectorRef = $e9612524ef6c2fa4$var$useRef(false);
    $e9612524ef6c2fa4$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || $e9612524ef6c2fa4$var$RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var _useMemo = $e9612524ef6c2fa4$var$useMemo(function() {
            var missingClientEdges = $e9612524ef6c2fa4$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $e9612524ef6c2fa4$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $e9612524ef6c2fa4$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) throw Promise.all(activeRequestPromises);
        $e9612524ef6c2fa4$var$useEffect(function() {
            var QueryResource = $e9612524ef6c2fa4$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $e9612524ef6c2fa4$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    for(var _i = 0, _disposables = disposables; _i < _disposables.length; _i++){
                        var disposable = _disposables[_i];
                        disposable.dispose();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($e9612524ef6c2fa4$var$isMissingData(state)) {
        var suspendingLiveResolvers = $e9612524ef6c2fa4$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) throw Promise.all(suspendingLiveResolvers.map(function(liveStateID) {
            return environment.getStore().getLiveResolverPromise(liveStateID);
        }));
        if ($e9612524ef6c2fa4$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !$e9612524ef6c2fa4$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $5Wk1R(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $e9612524ef6c2fa4$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    $e9612524ef6c2fa4$var$handlePotentialSnapshotErrorsForState(environment, state, loggerContext);
    var hasPendingStateChanges = $e9612524ef6c2fa4$var$useRef(false);
    $e9612524ef6c2fa4$var$useEffect(function() {
        var currentState = subscribedState;
        var updates = $e9612524ef6c2fa4$var$handleMissedUpdates(environment, subscribedState);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) setState(updatedState);
            currentState = updatedState;
        }
        return $e9612524ef6c2fa4$var$subscribeToSnapshot(environment, currentState, setState, hasPendingStateChanges);
    }, [
        environment,
        subscribedState
    ]);
    if (hasPendingStateChanges.current) {
        var updates = $e9612524ef6c2fa4$var$handleMissedUpdates(environment, state);
        if (updates != null) {
            var hasStateUpdates = updates[0], updatedState = updates[1];
            if (hasStateUpdates) {
                setState(updatedState);
                state = updatedState;
            }
        }
        hasPendingStateChanges.current = false;
    }
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $e9612524ef6c2fa4$var$useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && $5Wk1R(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && $5Wk1R(false);
        data = state.snapshot.data;
    }
    if ($e9612524ef6c2fa4$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $e9612524ef6c2fa4$var$useFragmentInternal;

});
parcelRegister("fNYxL", function(module, exports) {
'use strict';

var $1x15T = parcelRequire("1x15T");

var $1v5pe = parcelRequire("1v5pe");
var $b81a6550a61312d1$var$useContext = $1v5pe.useContext;
function $b81a6550a61312d1$var$useRelayLoggingContext() {
    return $b81a6550a61312d1$var$useContext($1x15T);
}
module.exports = $b81a6550a61312d1$var$useRelayLoggingContext;

});
parcelRegister("1x15T", function(module, exports) {
'use strict';

var $1v5pe = parcelRequire("1v5pe");

var $ArurZ = parcelRequire("ArurZ");
var $11d9b8c1ccf7a0b1$var$createRelayLoggingContext = $ArurZ.__internal.createRelayLoggingContext;
module.exports = $11d9b8c1ccf7a0b1$var$createRelayLoggingContext($1v5pe);

});



parcelRegister("61OJG", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $463a31295f8063ce$var$_interopRequireDefault = $bGHxy.default;

var $463a31295f8063ce$var$_objectSpread2 = $463a31295f8063ce$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $463a31295f8063ce$var$_createForOfIteratorHelper2 = $463a31295f8063ce$var$_interopRequireDefault((parcelRequire("cXbK5")));

var $463a31295f8063ce$var$_toConsumableArray2 = $463a31295f8063ce$var$_interopRequireDefault((parcelRequire("kTVTn")));

var $lFOtW = parcelRequire("lFOtW");
var $463a31295f8063ce$var$getQueryResourceForEnvironment = $lFOtW.getQueryResourceForEnvironment;

var $aLV9i = parcelRequire("aLV9i");

var $fNYxL = parcelRequire("fNYxL");

var $5Wk1R = parcelRequire("5Wk1R");

var $1v5pe = parcelRequire("1v5pe");
var $463a31295f8063ce$var$useDebugValue = $1v5pe.useDebugValue, $463a31295f8063ce$var$useEffect = $1v5pe.useEffect, $463a31295f8063ce$var$useMemo = $1v5pe.useMemo, $463a31295f8063ce$var$useRef = $1v5pe.useRef, $463a31295f8063ce$var$useState = $1v5pe.useState;

var $ArurZ = parcelRequire("ArurZ");
var $463a31295f8063ce$var$_require3$__internal = $ArurZ.__internal, $463a31295f8063ce$var$fetchQueryInternal = $463a31295f8063ce$var$_require3$__internal.fetchQuery, $463a31295f8063ce$var$getPromiseForActiveRequest = $463a31295f8063ce$var$_require3$__internal.getPromiseForActiveRequest, $463a31295f8063ce$var$RelayFeatureFlags = $ArurZ.RelayFeatureFlags, $463a31295f8063ce$var$areEqualSelectors = $ArurZ.areEqualSelectors, $463a31295f8063ce$var$createOperationDescriptor = $ArurZ.createOperationDescriptor, $463a31295f8063ce$var$getPendingOperationsForFragment = $ArurZ.getPendingOperationsForFragment, $463a31295f8063ce$var$getSelector = $ArurZ.getSelector, $463a31295f8063ce$var$getVariablesFromFragment = $ArurZ.getVariablesFromFragment, $463a31295f8063ce$var$handlePotentialSnapshotErrors = $ArurZ.handlePotentialSnapshotErrors, $463a31295f8063ce$var$recycleNodesInto = $ArurZ.recycleNodesInto;
parcelRequire("91yGl");
function $463a31295f8063ce$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $463a31295f8063ce$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $463a31295f8063ce$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $463a31295f8063ce$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $463a31295f8063ce$var$getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $463a31295f8063ce$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $463a31295f8063ce$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $463a31295f8063ce$var$handlePotentialSnapshotErrorsForState(environment, state, loggingContext) {
    if (state.kind === 'singular') $463a31295f8063ce$var$handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors, loggingContext);
    else if (state.kind === 'plural') {
        var _iterator5 = (0, $463a31295f8063ce$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var snapshot = _step5.value;
                $463a31295f8063ce$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors, loggingContext);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $463a31295f8063ce$var$handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $463a31295f8063ce$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            fieldErrors: currentSnapshot.fieldErrors
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: 'singular',
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch,
                selector: state.selector,
                environment: state.environment
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $463a31295f8063ce$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                fieldErrors: _currentSnapshot.fieldErrors
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $5Wk1R(false);
        return [
            didMissUpdates,
            {
                kind: 'plural',
                snapshots: currentSnapshots,
                epoch: currentEpoch,
                selector: state.selector,
                environment: state.environment
            }
        ];
    }
}
function $463a31295f8063ce$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $463a31295f8063ce$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $463a31295f8063ce$var$_objectSpread2["default"])((0, $463a31295f8063ce$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $463a31295f8063ce$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $463a31295f8063ce$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $463a31295f8063ce$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    var promise = $463a31295f8063ce$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request);
    if (promise != null && promise.displayName == null) promise.displayName = missingClientEdgeRequestInfo.request.params.name;
    return [
        queryResult,
        promise
    ];
}
function $463a31295f8063ce$var$subscribeToSnapshot(environment, state, setState) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                var nextState = null;
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector || prevState.environment !== environment) {
                    var updates = $463a31295f8063ce$var$handleMissedUpdates(prevState.environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], updatedState = updates[1];
                        environment.__log({
                            name: 'useFragment.subscription.missedUpdates',
                            hasDataChanges: dataChanged
                        });
                        nextState = dataChanged ? updatedState : prevState;
                    } else nextState = prevState;
                } else nextState = {
                    kind: 'singular',
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch(),
                    selector: state.selector,
                    environment: state.environment
                };
                return nextState;
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    var nextState = null;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector || prevState.environment !== environment) {
                        var updates = $463a31295f8063ce$var$handleMissedUpdates(prevState.environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], updatedState = updates[1];
                            environment.__log({
                                name: 'useFragment.subscription.missedUpdates',
                                hasDataChanges: dataChanged
                            });
                            nextState = dataChanged ? updatedState : prevState;
                        } else nextState = prevState;
                    } else {
                        var updated = (0, $463a31295f8063ce$var$_toConsumableArray2["default"])(prevState.snapshots);
                        updated[index] = latestSnapshot;
                        nextState = {
                            kind: 'plural',
                            snapshots: updated,
                            epoch: environment.getStore().getEpoch(),
                            selector: state.selector,
                            environment: state.environment
                        };
                    }
                    return nextState;
                });
            });
        });
        return function() {
            var _iterator6 = (0, $463a31295f8063ce$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $463a31295f8063ce$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout',
        environment: environment
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch(),
        selector: fragmentSelector,
        environment: environment
    };
    else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch(),
        selector: fragmentSelector,
        environment: environment
    };
}
function $463a31295f8063ce$var$useFragmentInternal_EXPERIMENTAL(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $463a31295f8063ce$var$useMemo(function() {
        return $463a31295f8063ce$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $5Wk1R(false);
    else !!Array.isArray(fragmentRef) && $5Wk1R(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $5Wk1R(false);
    var environment = $aLV9i();
    var loggerContext;
    if ($463a31295f8063ce$var$RelayFeatureFlags.ENABLE_UI_CONTEXT_ON_RELAY_LOGGER) loggerContext = $fNYxL();
    var _useState = $463a31295f8063ce$var$useState(function() {
        return $463a31295f8063ce$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var previousEnvironment = state.environment;
    if (!$463a31295f8063ce$var$areEqualSelectors(fragmentSelector, state.selector) || environment !== state.environment) {
        var newState = $463a31295f8063ce$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        state = newState;
    }
    var committedFragmentSelectorRef = $463a31295f8063ce$var$useRef(false);
    $463a31295f8063ce$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || $463a31295f8063ce$var$RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var _useMemo = $463a31295f8063ce$var$useMemo(function() {
            var missingClientEdges = $463a31295f8063ce$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $463a31295f8063ce$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $463a31295f8063ce$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) {
            var allPromises = Promise.all(activeRequestPromises);
            allPromises.displayName = "RelayClientEdge(".concat(activeRequestPromises.map(function(promise) {
                return promise.displayName;
            }).join(','), ")");
            throw allPromises;
        }
        $463a31295f8063ce$var$useEffect(function() {
            var QueryResource = $463a31295f8063ce$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $463a31295f8063ce$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    for(var _i = 0, _disposables = disposables; _i < _disposables.length; _i++){
                        var disposable = _disposables[_i];
                        disposable.dispose();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($463a31295f8063ce$var$isMissingData(state)) {
        var suspendingLiveResolvers = $463a31295f8063ce$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) {
            var promise = Promise.all(suspendingLiveResolvers.map(function(liveStateID) {
                return environment.getStore().getLiveResolverPromise(liveStateID);
            }));
            promise.displayName = 'RelayLiveResolver(' + fragmentNode.name + ')';
            throw promise;
        }
        if ($463a31295f8063ce$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !$463a31295f8063ce$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $5Wk1R(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $463a31295f8063ce$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    $463a31295f8063ce$var$handlePotentialSnapshotErrorsForState(environment, state, loggerContext);
    var storeSubscriptionRef = $463a31295f8063ce$var$useRef(null);
    $463a31295f8063ce$var$useEffect(function() {
        var storeSubscription = storeSubscriptionRef.current;
        if (storeSubscription != null) {
            if (state.environment === storeSubscription.environment && state.selector === storeSubscription.selector) return;
            else storeSubscription.dispose();
        }
        if (state.kind === 'bailout') return;
        var stateForSubscription = state;
        var updates = $463a31295f8063ce$var$handleMissedUpdates(state.environment, state);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) {
                setState(updatedState);
                return;
            }
            stateForSubscription = updatedState;
        }
        var dispose = $463a31295f8063ce$var$subscribeToSnapshot(state.environment, stateForSubscription, setState);
        storeSubscriptionRef.current = {
            dispose: dispose,
            selector: state.selector,
            environment: state.environment
        };
    }, [
        state
    ]);
    $463a31295f8063ce$var$useEffect(function() {
        if (storeSubscriptionRef.current == null && state.kind !== 'bailout') {
            var dispose = $463a31295f8063ce$var$subscribeToSnapshot(state.environment, state, setState);
            storeSubscriptionRef.current = {
                dispose: dispose,
                selector: state.selector,
                environment: state.environment
            };
        }
        return function() {
            var _storeSubscriptionRef;
            (_storeSubscriptionRef = storeSubscriptionRef.current) === null || _storeSubscriptionRef === void 0 || _storeSubscriptionRef.dispose();
            storeSubscriptionRef.current = null;
        };
    }, []);
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $463a31295f8063ce$var$useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && $5Wk1R(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && $5Wk1R(false);
        data = state.snapshot.data;
    }
    if ($463a31295f8063ce$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $463a31295f8063ce$var$useFragmentInternal_EXPERIMENTAL;

});



parcelRegister("9cvfB", function(module, exports) {
'use strict';

var $kW5RB = parcelRequire("kW5RB");

var $1v5pe = parcelRequire("1v5pe");

var $ArurZ = parcelRequire("ArurZ");
var $6b2d79c17a1b3337$var$createOperationDescriptor = $ArurZ.createOperationDescriptor, $6b2d79c17a1b3337$var$getRequest = $ArurZ.getRequest;
var $6b2d79c17a1b3337$var$useMemo = $1v5pe.useMemo;
function $6b2d79c17a1b3337$var$useMemoOperationDescriptor(gqlQuery, variables, cacheConfig) {
    var memoVariables = $kW5RB(variables);
    var memoCacheConfig = $kW5RB(cacheConfig || {});
    return $6b2d79c17a1b3337$var$useMemo(function() {
        return $6b2d79c17a1b3337$var$createOperationDescriptor($6b2d79c17a1b3337$var$getRequest(gqlQuery), memoVariables, memoCacheConfig);
    }, [
        gqlQuery,
        memoVariables,
        memoCacheConfig
    ]);
}
module.exports = $6b2d79c17a1b3337$var$useMemoOperationDescriptor;

});
parcelRegister("kW5RB", function(module, exports) {
'use strict';

var $cGxFv = parcelRequire("cGxFv");

var $1v5pe = parcelRequire("1v5pe");
var $f3ddc5d05e5300f2$var$useState = $1v5pe.useState;
function $f3ddc5d05e5300f2$var$useMemoVariables(variables) {
    var _useState = $f3ddc5d05e5300f2$var$useState(variables), mirroredVariables = _useState[0], setMirroredVariables = _useState[1];
    if ($cGxFv(variables, mirroredVariables)) return mirroredVariables;
    else {
        setMirroredVariables(variables);
        return variables;
    }
}
module.exports = $f3ddc5d05e5300f2$var$useMemoVariables;

});




parcelRegister("dwWEa", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $9d9bc1957759a93d$var$_interopRequireDefault = $bGHxy.default;

var $9d9bc1957759a93d$var$_createForOfIteratorHelper2 = $9d9bc1957759a93d$var$_interopRequireDefault((parcelRequire("cXbK5")));

var $8T3sM = parcelRequire("8T3sM");

var $5chmM = parcelRequire("5chmM");

var $1v5pe = parcelRequire("1v5pe");
var $9d9bc1957759a93d$var$useCallback = $1v5pe.useCallback, $9d9bc1957759a93d$var$useEffect = $1v5pe.useEffect, $9d9bc1957759a93d$var$useRef = $1v5pe.useRef, $9d9bc1957759a93d$var$useState = $1v5pe.useState;
var $9d9bc1957759a93d$var$initialNullEntryPointReferenceState = {
    kind: 'NullEntryPointReference'
};
function $9d9bc1957759a93d$var$useLoadEntryPoint(environmentProvider, entryPoint, options) {
    var _options$TEST_ONLY__i, _options$TEST_ONLY__i2, _options$TEST_ONLY__i3, _options$TEST_ONLY__i4;
    var initialEntryPointReferenceInternal = (_options$TEST_ONLY__i = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i2 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i2 === void 0 ? void 0 : _options$TEST_ONLY__i2.entryPointReference) !== null && _options$TEST_ONLY__i !== void 0 ? _options$TEST_ONLY__i : $9d9bc1957759a93d$var$initialNullEntryPointReferenceState;
    var initialEntryPointParamsInternal = (_options$TEST_ONLY__i3 = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i4 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i4 === void 0 ? void 0 : _options$TEST_ONLY__i4.entryPointParams) !== null && _options$TEST_ONLY__i3 !== void 0 ? _options$TEST_ONLY__i3 : null;
    var isMountedRef = $5chmM();
    var undisposedEntryPointReferencesRef = $9d9bc1957759a93d$var$useRef(new Set([
        initialEntryPointReferenceInternal
    ]));
    var _useState = $9d9bc1957759a93d$var$useState(initialEntryPointReferenceInternal), entryPointReference = _useState[0], setEntryPointReference = _useState[1];
    var _useState2 = $9d9bc1957759a93d$var$useState(initialEntryPointParamsInternal), entryPointParams = _useState2[0], setEntryPointParams = _useState2[1];
    var disposeEntryPoint = $9d9bc1957759a93d$var$useCallback(function() {
        if (isMountedRef.current) {
            var nullEntryPointReference = {
                kind: 'NullEntryPointReference'
            };
            undisposedEntryPointReferencesRef.current.add(nullEntryPointReference);
            setEntryPointReference(nullEntryPointReference);
        }
    }, [
        setEntryPointReference,
        isMountedRef
    ]);
    var entryPointLoaderCallback = $9d9bc1957759a93d$var$useCallback(function(params) {
        if (isMountedRef.current) {
            var updatedEntryPointReference = $8T3sM(environmentProvider, entryPoint, params);
            undisposedEntryPointReferencesRef.current.add(updatedEntryPointReference);
            setEntryPointReference(updatedEntryPointReference);
            setEntryPointParams(params);
        }
    }, [
        environmentProvider,
        entryPoint,
        setEntryPointReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $9d9bc1957759a93d$var$useRef(false);
    $9d9bc1957759a93d$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $9d9bc1957759a93d$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (entryPointReference.kind !== 'NullEntryPointReference' && entryPointParams != null) entryPointLoaderCallback(entryPointParams);
            return;
        }
        var undisposedEntryPointReferences = undisposedEntryPointReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $9d9bc1957759a93d$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedEntryPointReference = _step.value;
                    if (undisposedEntryPointReference === entryPointReference) break;
                    undisposedEntryPointReferences["delete"](undisposedEntryPointReference);
                    if (undisposedEntryPointReference.kind !== 'NullEntryPointReference') undisposedEntryPointReference.dispose();
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        entryPointReference,
        entryPointParams,
        entryPointLoaderCallback,
        isMountedRef
    ]);
    $9d9bc1957759a93d$var$useEffect(function() {
        return function disposeAllRemainingEntryPointReferences() {
            var _iterator2 = (0, $9d9bc1957759a93d$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var unhandledStateChange = _step2.value;
                    if (unhandledStateChange.kind !== 'NullEntryPointReference') unhandledStateChange.dispose();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, []);
    return [
        entryPointReference.kind === 'NullEntryPointReference' ? null : entryPointReference,
        entryPointLoaderCallback,
        disposeEntryPoint
    ];
}
module.exports = $9d9bc1957759a93d$var$useLoadEntryPoint;

});
parcelRegister("5chmM", function(module, exports) {
'use strict';

var $1v5pe = parcelRequire("1v5pe");
var $3c8b8b5f25369482$var$useEffect = $1v5pe.useEffect, $3c8b8b5f25369482$var$useRef = $1v5pe.useRef;
function $3c8b8b5f25369482$var$useIsMountedRef() {
    var isMountedRef = $3c8b8b5f25369482$var$useRef(true);
    $3c8b8b5f25369482$var$useEffect(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return isMountedRef;
}
module.exports = $3c8b8b5f25369482$var$useIsMountedRef;

});


parcelRegister("cjsY7", function(module, exports) {
'use strict';

var $ayoXm = parcelRequire("ayoXm");

var $GQ49S = parcelRequire("GQ49S");

var $1v5pe = parcelRequire("1v5pe");
var $8f6dbaf68b29a5f2$var$useDebugValue = $1v5pe.useDebugValue;

var $ArurZ = parcelRequire("ArurZ");
var $8f6dbaf68b29a5f2$var$getFragment = $ArurZ.getFragment;
function $8f6dbaf68b29a5f2$var$useFragment(fragment, key) {
    var fragmentNode = $8f6dbaf68b29a5f2$var$getFragment(fragment);
    $GQ49S(fragmentNode, 'first argument of useFragment()');
    var data = $ayoXm(fragmentNode, key, 'useFragment()');
    return data;
}
module.exports = $8f6dbaf68b29a5f2$var$useFragment;

});
parcelRegister("GQ49S", function(module, exports) {
'use strict';
parcelRequire("YZJru");
parcelRequire("91yGl");
function $080c4f98796b9e51$var$useStaticFragmentNodeWarning(fragmentNode, warningContext) {
    var initialPropRef;
}
module.exports = $080c4f98796b9e51$var$useStaticFragmentNodeWarning;

});


parcelRegister("9ZZQS", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $7479ca0afc6b616b$var$_interopRequireDefault = $bGHxy.default;

var $7479ca0afc6b616b$var$_objectSpread2 = $7479ca0afc6b616b$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $5chmM = parcelRequire("5chmM");

var $aLV9i = parcelRequire("aLV9i");

var $1v5pe = parcelRequire("1v5pe");

var $ArurZ = parcelRequire("ArurZ");
var $7479ca0afc6b616b$var$defaultCommitMutation = $ArurZ.commitMutation;
var $7479ca0afc6b616b$var$useState = $1v5pe.useState, $7479ca0afc6b616b$var$useEffect = $1v5pe.useEffect, $7479ca0afc6b616b$var$useRef = $1v5pe.useRef, $7479ca0afc6b616b$var$useCallback = $1v5pe.useCallback;
function $7479ca0afc6b616b$var$useMutation(mutation) {
    var commitMutationFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7479ca0afc6b616b$var$defaultCommitMutation;
    var environment = $aLV9i();
    var isMountedRef = $5chmM();
    var environmentRef = $7479ca0afc6b616b$var$useRef(environment);
    var mutationRef = $7479ca0afc6b616b$var$useRef(mutation);
    var inFlightMutationsRef = $7479ca0afc6b616b$var$useRef(new Set());
    var _useState = $7479ca0afc6b616b$var$useState(false), isMutationInFlight = _useState[0], setMutationInFlight = _useState[1];
    var cleanup = $7479ca0afc6b616b$var$useCallback(function(disposable) {
        if (environmentRef.current === environment && mutationRef.current === mutation) {
            inFlightMutationsRef.current["delete"](disposable);
            if (isMountedRef.current) setMutationInFlight(inFlightMutationsRef.current.size > 0);
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    $7479ca0afc6b616b$var$useEffect(function() {
        if (environmentRef.current !== environment || mutationRef.current !== mutation) {
            inFlightMutationsRef.current = new Set();
            if (isMountedRef.current) setMutationInFlight(false);
            environmentRef.current = environment;
            mutationRef.current = mutation;
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    var commit = $7479ca0afc6b616b$var$useCallback(function(config) {
        if (isMountedRef.current) setMutationInFlight(true);
        var disposable = commitMutationFn(environment, (0, $7479ca0afc6b616b$var$_objectSpread2["default"])((0, $7479ca0afc6b616b$var$_objectSpread2["default"])({}, config), {}, {
            mutation: mutation,
            onCompleted: function onCompleted(response, errors) {
                var _config$onCompleted;
                cleanup(disposable);
                (_config$onCompleted = config.onCompleted) === null || _config$onCompleted === void 0 || _config$onCompleted.call(config, response, errors);
            },
            onError: function onError(error) {
                var _config$onError;
                cleanup(disposable);
                (_config$onError = config.onError) === null || _config$onError === void 0 || _config$onError.call(config, error);
            },
            onUnsubscribe: function onUnsubscribe() {
                var _config$onUnsubscribe;
                cleanup(disposable);
                (_config$onUnsubscribe = config.onUnsubscribe) === null || _config$onUnsubscribe === void 0 || _config$onUnsubscribe.call(config);
            },
            onNext: function onNext() {
                var _config$onNext;
                (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
            }
        }));
        inFlightMutationsRef.current.add(disposable);
        return disposable;
    }, [
        cleanup,
        commitMutationFn,
        environment,
        isMountedRef,
        mutation
    ]);
    return [
        commit,
        isMutationInFlight
    ];
}
module.exports = $7479ca0afc6b616b$var$useMutation;

});

parcelRegister("3gP7m", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $261a84a644065bc5$var$_interopRequireDefault = $bGHxy.default;

var $261a84a644065bc5$var$_objectSpread2 = $261a84a644065bc5$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $ft6Ql = parcelRequire("ft6Ql");

var $71dX5 = parcelRequire("71dX5");

var $aLV9i = parcelRequire("aLV9i");

var $GQ49S = parcelRequire("GQ49S");

var $1v5pe = parcelRequire("1v5pe");
var $261a84a644065bc5$var$useCallback = $1v5pe.useCallback, $261a84a644065bc5$var$useDebugValue = $1v5pe.useDebugValue, $261a84a644065bc5$var$useState = $1v5pe.useState;

var $ArurZ = parcelRequire("ArurZ");
var $261a84a644065bc5$var$RelayFeatureFlags = $ArurZ.RelayFeatureFlags, $261a84a644065bc5$var$getFragment = $ArurZ.getFragment, $261a84a644065bc5$var$getFragmentIdentifier = $ArurZ.getFragmentIdentifier, $261a84a644065bc5$var$getPaginationMetadata = $ArurZ.getPaginationMetadata;
function $261a84a644065bc5$var$usePaginationFragment(fragmentInput, parentFragmentRef) {
    var fragmentNode = $261a84a644065bc5$var$getFragment(fragmentInput);
    $GQ49S(fragmentNode, 'first argument of usePaginationFragment()');
    var componentDisplayName = 'usePaginationFragment()';
    var _getPaginationMetadat = $261a84a644065bc5$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = $71dX5(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $261a84a644065bc5$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    var _useLoadMore = $261a84a644065bc5$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'backward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadPrevious = _useLoadMore[0], hasPrevious = _useLoadMore[1], isLoadingPrevious = _useLoadMore[2], disposeFetchPrevious = _useLoadMore[3];
    var _useLoadMore2 = $261a84a644065bc5$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadNext = _useLoadMore2[0], hasNext = _useLoadMore2[1], isLoadingNext = _useLoadMore2[2], disposeFetchNext = _useLoadMore2[3];
    var refetchPagination = $261a84a644065bc5$var$useCallback(function(variables, options) {
        disposeFetchNext();
        disposeFetchPrevious();
        return refetch(variables, (0, $261a84a644065bc5$var$_objectSpread2["default"])((0, $261a84a644065bc5$var$_objectSpread2["default"])({}, options), {}, {
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        disposeFetchPrevious,
        refetch
    ]);
    return {
        data: fragmentData,
        loadNext: loadNext,
        loadPrevious: loadPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        refetch: refetchPagination
    };
}
function $261a84a644065bc5$var$useLoadMore(args) {
    var environment = $aLV9i();
    var _useState = $261a84a644065bc5$var$useState(false), isLoadingMore = _useState[0], reallySetIsLoadingMore = _useState[1];
    var setIsLoadingMore = function setIsLoadingMore(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    };
    var observer = {
        start: function start() {
            return setIsLoadingMore(true);
        },
        complete: function complete() {
            return setIsLoadingMore(false);
        },
        error: function error() {
            return setIsLoadingMore(false);
        },
        unsubscribe: $261a84a644065bc5$var$RelayFeatureFlags.ENABLE_USE_PAGINATION_IS_LOADING_FIX ? function() {
            return setIsLoadingMore(false);
        } : undefined
    };
    var handleReset = function handleReset() {
        return setIsLoadingMore(false);
    };
    var _useLoadMoreFunction = $ft6Ql((0, $261a84a644065bc5$var$_objectSpread2["default"])((0, $261a84a644065bc5$var$_objectSpread2["default"])({}, args), {}, {
        observer: observer,
        onReset: handleReset
    })), loadMore = _useLoadMoreFunction[0], hasMore = _useLoadMoreFunction[1], disposeFetch = _useLoadMoreFunction[2];
    return [
        loadMore,
        hasMore,
        isLoadingMore,
        disposeFetch
    ];
}
module.exports = $261a84a644065bc5$var$usePaginationFragment;

});
parcelRegister("ft6Ql", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $b42edf642c502a27$var$_interopRequireDefault = $bGHxy.default;

var $b42edf642c502a27$var$_objectSpread2 = $b42edf642c502a27$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $eVoLY = parcelRequire("eVoLY");

var $1DgzH = parcelRequire("1DgzH");

var $5chmM = parcelRequire("5chmM");

var $ihBap = parcelRequire("ihBap");

var $h8gM8 = parcelRequire("h8gM8");

var $aLV9i = parcelRequire("aLV9i");

var $5Wk1R = parcelRequire("5Wk1R");

var $1v5pe = parcelRequire("1v5pe");
var $b42edf642c502a27$var$useCallback = $1v5pe.useCallback, $b42edf642c502a27$var$useEffect = $1v5pe.useEffect, $b42edf642c502a27$var$useState = $1v5pe.useState;

var $ArurZ = parcelRequire("ArurZ");
var $b42edf642c502a27$var$fetchQuery = $ArurZ.__internal.fetchQuery, $b42edf642c502a27$var$RelayFeatureFlags = $ArurZ.RelayFeatureFlags, $b42edf642c502a27$var$createOperationDescriptor = $ArurZ.createOperationDescriptor, $b42edf642c502a27$var$getPaginationVariables = $ArurZ.getPaginationVariables, $b42edf642c502a27$var$getRefetchMetadata = $ArurZ.getRefetchMetadata, $b42edf642c502a27$var$getSelector = $ArurZ.getSelector;
parcelRequire("91yGl");
function $b42edf642c502a27$var$useLoadMoreFunction(args) {
    if ($b42edf642c502a27$var$RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return $h8gM8(args);
    return $b42edf642c502a27$var$useLoadMoreFunction_CURRENT(args);
}
function $b42edf642c502a27$var$useLoadMoreFunction_CURRENT(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $aLV9i();
    var _useFetchTrackingRef = $1DgzH(), isFetchingRef = _useFetchTrackingRef.isFetchingRef, startFetch = _useFetchTrackingRef.startFetch, disposeFetch = _useFetchTrackingRef.disposeFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var _getRefetchMetadata = $b42edf642c502a27$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var isMountedRef = $5chmM();
    var _useState = $b42edf642c502a27$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $b42edf642c502a27$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $ihBap(fragmentNode, fragmentRef);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        disposeFetch();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $eVoLY(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    $b42edf642c502a27$var$useEffect(function() {
        return function() {
            disposeFetch();
        };
    }, [
        disposeFetch
    ]);
    var isRequestInvalid = fragmentData == null || isParentQueryActive;
    var loadMore = $b42edf642c502a27$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $b42edf642c502a27$var$getSelector(fragmentNode, fragmentRef);
        if (isFetchingRef.current === true || isRequestInvalid) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && $5Wk1R(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $b42edf642c502a27$var$_objectSpread2["default"])((0, $b42edf642c502a27$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $b42edf642c502a27$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $b42edf642c502a27$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $b42edf642c502a27$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $b42edf642c502a27$var$fetchQuery(environment, paginationQuery).subscribe((0, $b42edf642c502a27$var$_objectSpread2["default"])((0, $b42edf642c502a27$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                startFetch(subscription);
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                completeFetch();
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                completeFetch();
                observer.error && observer.error(_error);
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: disposeFetch
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        startFetch,
        disposeFetch,
        completeFetch,
        isFetchingRef,
        isRequestInvalid,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        disposeFetch
    ];
}
module.exports = $b42edf642c502a27$var$useLoadMoreFunction;

});
parcelRegister("eVoLY", function(module, exports) {
'use strict';

var $5Wk1R = parcelRequire("5Wk1R");

var $ArurZ = parcelRequire("ArurZ");
var $add99aefb8cb9e8e$var$ConnectionInterface = $ArurZ.ConnectionInterface, $add99aefb8cb9e8e$var$getValueAtPath = $ArurZ.getValueAtPath;
function $add99aefb8cb9e8e$var$getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData) {
    var _pageInfo$END_CURSOR, _pageInfo$START_CURSO;
    var _ConnectionInterface$ = $add99aefb8cb9e8e$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var connection = $add99aefb8cb9e8e$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
    if (connection == null) return {
        cursor: null,
        hasMore: false
    };
    !(typeof connection === 'object') && $5Wk1R(false);
    var edges = connection[EDGES];
    var pageInfo = connection[PAGE_INFO];
    if (edges == null || pageInfo == null) return {
        cursor: null,
        hasMore: false
    };
    !Array.isArray(edges) && $5Wk1R(false);
    !(typeof pageInfo === 'object') && $5Wk1R(false);
    var cursor = direction === 'forward' ? (_pageInfo$END_CURSOR = pageInfo[END_CURSOR]) !== null && _pageInfo$END_CURSOR !== void 0 ? _pageInfo$END_CURSOR : null : (_pageInfo$START_CURSO = pageInfo[START_CURSOR]) !== null && _pageInfo$START_CURSO !== void 0 ? _pageInfo$START_CURSO : null;
    !(cursor === null || typeof cursor === 'string') && $5Wk1R(false);
    var hasMore;
    if (direction === 'forward') hasMore = cursor != null && pageInfo[HAS_NEXT_PAGE] === true;
    else hasMore = cursor != null && pageInfo[HAS_PREV_PAGE] === true;
    return {
        cursor: cursor,
        hasMore: hasMore
    };
}
module.exports = $add99aefb8cb9e8e$var$getConnectionState;

});

parcelRegister("ihBap", function(module, exports) {
'use strict';

var $aLV9i = parcelRequire("aLV9i");

var $5Wk1R = parcelRequire("5Wk1R");

var $1v5pe = parcelRequire("1v5pe");

var $ArurZ = parcelRequire("ArurZ");
var $d4f6a51dc0e1938a$var$getObservableForActiveRequest = $ArurZ.__internal.getObservableForActiveRequest, $d4f6a51dc0e1938a$var$getSelector = $ArurZ.getSelector;
var $d4f6a51dc0e1938a$var$useEffect = $1v5pe.useEffect, $d4f6a51dc0e1938a$var$useState = $1v5pe.useState, $d4f6a51dc0e1938a$var$useMemo = $1v5pe.useMemo;
function $d4f6a51dc0e1938a$var$useIsOperationNodeActive(fragmentNode, fragmentRef) {
    var environment = $aLV9i();
    var observable = $d4f6a51dc0e1938a$var$useMemo(function() {
        var selector = $d4f6a51dc0e1938a$var$getSelector(fragmentNode, fragmentRef);
        if (selector == null) return null;
        !(selector.kind === 'SingularReaderSelector') && $5Wk1R(false);
        return $d4f6a51dc0e1938a$var$getObservableForActiveRequest(environment, selector.owner);
    }, [
        environment,
        fragmentNode,
        fragmentRef
    ]);
    var _useState = $d4f6a51dc0e1938a$var$useState(observable != null), isActive = _useState[0], setIsActive = _useState[1];
    $d4f6a51dc0e1938a$var$useEffect(function() {
        var subscription;
        setIsActive(observable != null);
        if (observable != null) {
            var onCompleteOrError = function onCompleteOrError() {
                setIsActive(false);
            };
            subscription = observable.subscribe({
                complete: onCompleteOrError,
                error: onCompleteOrError
            });
        }
        return function() {
            if (subscription) subscription.unsubscribe();
        };
    }, [
        observable
    ]);
    return isActive;
}
module.exports = $d4f6a51dc0e1938a$var$useIsOperationNodeActive;

});

parcelRegister("h8gM8", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $c790324875b1640c$var$_interopRequireDefault = $bGHxy.default;

var $c790324875b1640c$var$_objectSpread2 = $c790324875b1640c$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $eVoLY = parcelRequire("eVoLY");

var $5chmM = parcelRequire("5chmM");

var $ihBap = parcelRequire("ihBap");

var $aLV9i = parcelRequire("aLV9i");

var $5Wk1R = parcelRequire("5Wk1R");

var $1v5pe = parcelRequire("1v5pe");
var $c790324875b1640c$var$useCallback = $1v5pe.useCallback, $c790324875b1640c$var$useRef = $1v5pe.useRef, $c790324875b1640c$var$useState = $1v5pe.useState;

var $ArurZ = parcelRequire("ArurZ");
var $c790324875b1640c$var$fetchQuery = $ArurZ.__internal.fetchQuery, $c790324875b1640c$var$createOperationDescriptor = $ArurZ.createOperationDescriptor, $c790324875b1640c$var$getPaginationVariables = $ArurZ.getPaginationVariables, $c790324875b1640c$var$getRefetchMetadata = $ArurZ.getRefetchMetadata, $c790324875b1640c$var$getSelector = $ArurZ.getSelector;
parcelRequire("91yGl");
function $c790324875b1640c$var$useLoadMoreFunction_EXPERIMENTAL(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $aLV9i();
    var _getRefetchMetadata = $c790324875b1640c$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var fetchStatusRef = $c790324875b1640c$var$useRef({
        kind: 'none'
    });
    var _useState = $c790324875b1640c$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $c790324875b1640c$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $ihBap(fragmentNode, fragmentRef);
    var forceDisposeFn = $c790324875b1640c$var$useCallback(function() {
        if (fetchStatusRef.current.kind === 'fetching') fetchStatusRef.current.subscription.unsubscribe();
        fetchStatusRef.current = {
            kind: 'none'
        };
    }, []);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        forceDisposeFn();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $eVoLY(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    var isRequestInvalid = fragmentData == null || isParentQueryActive;
    var isMountedRef = $5chmM();
    var loadMore = $c790324875b1640c$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $c790324875b1640c$var$getSelector(fragmentNode, fragmentRef);
        if (fetchStatusRef.current.kind === 'fetching' || isRequestInvalid) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && $5Wk1R(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $c790324875b1640c$var$_objectSpread2["default"])((0, $c790324875b1640c$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $c790324875b1640c$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $c790324875b1640c$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $c790324875b1640c$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $c790324875b1640c$var$fetchQuery(environment, paginationQuery).subscribe((0, $c790324875b1640c$var$_objectSpread2["default"])((0, $c790324875b1640c$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                fetchStatusRef.current = {
                    kind: 'fetching',
                    subscription: subscription
                };
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                fetchStatusRef.current = {
                    kind: 'none'
                };
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                fetchStatusRef.current = {
                    kind: 'none'
                };
                observer.complete && observer.complete();
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: function dispose() {}
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        isRequestInvalid,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        forceDisposeFn
    ];
}
module.exports = $c790324875b1640c$var$useLoadMoreFunction_EXPERIMENTAL;

});


parcelRegister("71dX5", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $51c372fd1b84f703$var$_interopRequireDefault = $bGHxy.default;

var $51c372fd1b84f703$var$_objectSpread2 = $51c372fd1b84f703$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $bB7hb = parcelRequire("bB7hb");

var $lFOtW = parcelRequire("lFOtW");
var $51c372fd1b84f703$var$getQueryResourceForEnvironment = $lFOtW.getQueryResourceForEnvironment;

var $i5YYJ = parcelRequire("i5YYJ");

var $ayoXm = parcelRequire("ayoXm");

var $5chmM = parcelRequire("5chmM");

var $8QBSZ = parcelRequire("8QBSZ");

var $aLV9i = parcelRequire("aLV9i");

var $5Wk1R = parcelRequire("5Wk1R");

var $1v5pe = parcelRequire("1v5pe");
var $51c372fd1b84f703$var$useCallback = $1v5pe.useCallback, $51c372fd1b84f703$var$useContext = $1v5pe.useContext, $51c372fd1b84f703$var$useReducer = $1v5pe.useReducer;

var $ArurZ = parcelRequire("ArurZ");
var $51c372fd1b84f703$var$fetchQuery = $ArurZ.__internal.fetchQuery, $51c372fd1b84f703$var$createOperationDescriptor = $ArurZ.createOperationDescriptor, $51c372fd1b84f703$var$getFragmentIdentifier = $ArurZ.getFragmentIdentifier, $51c372fd1b84f703$var$getRefetchMetadata = $ArurZ.getRefetchMetadata, $51c372fd1b84f703$var$getSelector = $ArurZ.getSelector, $51c372fd1b84f703$var$getValueAtPath = $ArurZ.getValueAtPath;
parcelRequire("91yGl");
function $51c372fd1b84f703$var$reducer(state, action) {
    switch(action.type){
        case 'refetch':
            var _action$refetchEnviro;
            return (0, $51c372fd1b84f703$var$_objectSpread2["default"])((0, $51c372fd1b84f703$var$_objectSpread2["default"])({}, state), {}, {
                fetchPolicy: action.fetchPolicy,
                mirroredEnvironment: (_action$refetchEnviro = action.refetchEnvironment) !== null && _action$refetchEnviro !== void 0 ? _action$refetchEnviro : state.mirroredEnvironment,
                onComplete: action.onComplete,
                refetchEnvironment: action.refetchEnvironment,
                refetchQuery: action.refetchQuery,
                renderPolicy: action.renderPolicy
            });
        case 'reset':
            return {
                fetchPolicy: undefined,
                mirroredEnvironment: action.environment,
                mirroredFragmentIdentifier: action.fragmentIdentifier,
                onComplete: undefined,
                refetchQuery: null,
                renderPolicy: undefined
            };
        default:
            action.type;
            throw new Error('useRefetchableFragmentNode: Unexpected action type');
    }
}
function $51c372fd1b84f703$var$useRefetchableFragmentInternal(fragmentNode, parentFragmentRef, componentDisplayName) {
    var parentEnvironment = $aLV9i();
    var _getRefetchMetadata = $51c372fd1b84f703$var$getRefetchMetadata(fragmentNode, componentDisplayName), refetchableRequest = _getRefetchMetadata.refetchableRequest, fragmentRefPathInResponse = _getRefetchMetadata.fragmentRefPathInResponse, identifierInfo = _getRefetchMetadata.identifierInfo;
    var fragmentIdentifier = $51c372fd1b84f703$var$getFragmentIdentifier(fragmentNode, parentFragmentRef);
    var _useReducer = $51c372fd1b84f703$var$useReducer($51c372fd1b84f703$var$reducer, {
        fetchPolicy: undefined,
        mirroredEnvironment: parentEnvironment,
        mirroredFragmentIdentifier: fragmentIdentifier,
        onComplete: undefined,
        refetchEnvironment: null,
        refetchQuery: null,
        renderPolicy: undefined
    }), refetchState = _useReducer[0], dispatch = _useReducer[1];
    var fetchPolicy = refetchState.fetchPolicy, mirroredEnvironment = refetchState.mirroredEnvironment, mirroredFragmentIdentifier = refetchState.mirroredFragmentIdentifier, onComplete = refetchState.onComplete, refetchEnvironment = refetchState.refetchEnvironment, refetchQuery = refetchState.refetchQuery, renderPolicy = refetchState.renderPolicy;
    var environment = refetchEnvironment !== null && refetchEnvironment !== void 0 ? refetchEnvironment : parentEnvironment;
    var QueryResource = $51c372fd1b84f703$var$getQueryResourceForEnvironment(environment);
    var profilerContext = $51c372fd1b84f703$var$useContext($bB7hb);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    var _useQueryLoader = $8QBSZ(refetchableRequest), queryRef = _useQueryLoader[0], loadQuery = _useQueryLoader[1], disposeQuery = _useQueryLoader[2];
    var fragmentRef = parentFragmentRef;
    if (shouldReset) {
        dispatch({
            type: 'reset',
            environment: environment,
            fragmentIdentifier: fragmentIdentifier
        });
        disposeQuery();
    } else if (refetchQuery != null && queryRef != null) {
        var debugPreviousIDAndTypename;
        var handleQueryCompleted = function handleQueryCompleted(maybeError) {
            onComplete && onComplete(maybeError !== null && maybeError !== void 0 ? maybeError : null);
        };
        var fetchObservable = queryRef.source != null ? queryRef.source : $51c372fd1b84f703$var$fetchQuery(environment, refetchQuery);
        var queryResult = profilerContext.wrapPrepareQueryResource(function() {
            return QueryResource.prepare(refetchQuery, fetchObservable, fetchPolicy, renderPolicy, {
                error: handleQueryCompleted,
                complete: function complete() {
                    handleQueryCompleted();
                }
            }, queryRef.fetchKey, profilerContext);
        });
        var queryData = $i5YYJ(environment, queryResult.fragmentNode, queryResult.fragmentRef, componentDisplayName).data;
        !(queryData != null) && $5Wk1R(false);
        var refetchedFragmentRef = $51c372fd1b84f703$var$getValueAtPath(queryData, fragmentRefPathInResponse);
        fragmentRef = refetchedFragmentRef;
    }
    var fragmentData = $ayoXm(fragmentNode, fragmentRef, componentDisplayName);
    var refetch = $51c372fd1b84f703$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest);
    return {
        fragmentData: fragmentData,
        fragmentRef: fragmentRef,
        refetch: refetch
    };
}
function $51c372fd1b84f703$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest) {
    var isMountedRef = $5chmM();
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    return $51c372fd1b84f703$var$useCallback(function(providedRefetchVariables, options) {
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        parentFragmentRef;
        var refetchEnvironment = options === null || options === void 0 ? void 0 : options.__environment;
        var fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy;
        var renderPolicy = options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy;
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        var fragmentSelector = $51c372fd1b84f703$var$getSelector(fragmentNode, parentFragmentRef);
        var parentVariables;
        var fragmentVariables;
        if (fragmentSelector == null) {
            parentVariables = {};
            fragmentVariables = {};
        } else if (fragmentSelector.kind === 'PluralReaderSelector') {
            var _fragmentSelector$sel, _fragmentSelector$sel2, _fragmentSelector$sel3, _fragmentSelector$sel4;
            parentVariables = (_fragmentSelector$sel = (_fragmentSelector$sel2 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel2 === void 0 ? void 0 : _fragmentSelector$sel2.owner.variables) !== null && _fragmentSelector$sel !== void 0 ? _fragmentSelector$sel : {};
            fragmentVariables = (_fragmentSelector$sel3 = (_fragmentSelector$sel4 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel4 === void 0 ? void 0 : _fragmentSelector$sel4.variables) !== null && _fragmentSelector$sel3 !== void 0 ? _fragmentSelector$sel3 : {};
        } else {
            parentVariables = fragmentSelector.owner.variables;
            fragmentVariables = fragmentSelector.variables;
        }
        var refetchVariables = (0, $51c372fd1b84f703$var$_objectSpread2["default"])((0, $51c372fd1b84f703$var$_objectSpread2["default"])((0, $51c372fd1b84f703$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables), providedRefetchVariables);
        if (identifierInfo != null && !providedRefetchVariables.hasOwnProperty(identifierInfo.identifierQueryVariableName)) {
            typeof identifierValue;
            refetchVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var refetchQuery = $51c372fd1b84f703$var$createOperationDescriptor(refetchableRequest, refetchVariables, {
            force: true
        });
        loadQuery(refetchQuery.request.variables, {
            fetchPolicy: fetchPolicy,
            __environment: refetchEnvironment,
            __nameForWarning: 'refetch'
        });
        dispatch({
            type: 'refetch',
            fetchPolicy: fetchPolicy,
            onComplete: onComplete,
            refetchEnvironment: refetchEnvironment,
            refetchQuery: refetchQuery,
            renderPolicy: renderPolicy
        });
        return {
            dispose: disposeQuery
        };
    }, [
        fragmentIdentifier,
        dispatch,
        disposeQuery,
        identifierValue,
        loadQuery
    ]);
}
var $51c372fd1b84f703$var$debugFunctions;
module.exports = $51c372fd1b84f703$var$useRefetchableFragmentInternal;

});
parcelRegister("i5YYJ", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $d2c7feb28dcade4e$var$_interopRequireDefault = $bGHxy.default;

var $d2c7feb28dcade4e$var$_objectSpread2 = $d2c7feb28dcade4e$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $d2c7feb28dcade4e$var$_createForOfIteratorHelper2 = $d2c7feb28dcade4e$var$_interopRequireDefault((parcelRequire("cXbK5")));

var $lFOtW = parcelRequire("lFOtW");
var $d2c7feb28dcade4e$var$getQueryResourceForEnvironment = $lFOtW.getQueryResourceForEnvironment;

var $5Wk1R = parcelRequire("5Wk1R");

var $ArurZ = parcelRequire("ArurZ");
var $d2c7feb28dcade4e$var$fetchQueryInternal = $ArurZ.__internal.fetchQuery, $d2c7feb28dcade4e$var$RelayFeatureFlags = $ArurZ.RelayFeatureFlags, $d2c7feb28dcade4e$var$createOperationDescriptor = $ArurZ.createOperationDescriptor, $d2c7feb28dcade4e$var$getPendingOperationsForFragment = $ArurZ.getPendingOperationsForFragment, $d2c7feb28dcade4e$var$getSelector = $ArurZ.getSelector, $d2c7feb28dcade4e$var$getVariablesFromFragment = $ArurZ.getVariablesFromFragment, $d2c7feb28dcade4e$var$handlePotentialSnapshotErrors = $ArurZ.handlePotentialSnapshotErrors;
parcelRequire("91yGl");
function $d2c7feb28dcade4e$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $d2c7feb28dcade4e$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $d2c7feb28dcade4e$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $d2c7feb28dcade4e$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $d2c7feb28dcade4e$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') $d2c7feb28dcade4e$var$handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors);
    else if (state.kind === 'plural') {
        var _iterator3 = (0, $d2c7feb28dcade4e$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                $d2c7feb28dcade4e$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
    }
}
function $d2c7feb28dcade4e$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $d2c7feb28dcade4e$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $d2c7feb28dcade4e$var$_objectSpread2["default"])((0, $d2c7feb28dcade4e$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $d2c7feb28dcade4e$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $d2c7feb28dcade4e$var$getQueryResourceForEnvironment(environment);
    return QueryResource.prepare(queryOperationDescriptor, $d2c7feb28dcade4e$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
}
function $d2c7feb28dcade4e$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') {
        if (fragmentSelector.selectors.length === 0) return {
            kind: 'bailout'
        };
        else return {
            kind: 'plural',
            snapshots: fragmentSelector.selectors.map(function(s) {
                return environment.lookup(s);
            }),
            epoch: environment.getStore().getEpoch()
        };
    } else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $d2c7feb28dcade4e$var$readFragmentInternal(environment, fragmentNode, fragmentRef, hookDisplayName, queryOptions, fragmentKey) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $d2c7feb28dcade4e$var$getSelector(fragmentNode, fragmentRef);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $5Wk1R(false);
    else !!Array.isArray(fragmentRef) && $5Wk1R(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $5Wk1R(false);
    var state = $d2c7feb28dcade4e$var$getFragmentState(environment, fragmentSelector);
    var clientEdgeQueries = null;
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || $d2c7feb28dcade4e$var$RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var missingClientEdges = $d2c7feb28dcade4e$var$getMissingClientEdges(state);
        if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
            clientEdgeQueries = [];
            var _iterator4 = (0, $d2c7feb28dcade4e$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var edge = _step4.value;
                    clientEdgeQueries.push($d2c7feb28dcade4e$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions));
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    }
    if ($d2c7feb28dcade4e$var$isMissingData(state)) {
        !(fragmentSelector != null) && $5Wk1R(false);
        var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
        var pendingOperationsResult = $d2c7feb28dcade4e$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
        if (pendingOperationsResult) throw pendingOperationsResult.promise;
        $d2c7feb28dcade4e$var$handlePotentialSnapshotErrorsForState(environment, state);
    }
    var data;
    if (state.kind === 'bailout') data = isPlural ? [] : null;
    else if (state.kind === 'singular') data = state.snapshot.data;
    else data = state.snapshots.map(function(s) {
        return s.data;
    });
    if ($d2c7feb28dcade4e$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return {
        data: data,
        clientEdgeQueries: clientEdgeQueries
    };
}
module.exports = $d2c7feb28dcade4e$var$readFragmentInternal;

});

parcelRegister("8QBSZ", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $67109167942d8522$var$_interopRequireDefault = $bGHxy.default;

var $67109167942d8522$var$_createForOfIteratorHelper2 = $67109167942d8522$var$_interopRequireDefault((parcelRequire("cXbK5")));

var $gucdA = parcelRequire("gucdA");
var $67109167942d8522$var$loadQuery = $gucdA.loadQuery;

var $5chmM = parcelRequire("5chmM");

var $6tVmg = parcelRequire("6tVmg");

var $aLV9i = parcelRequire("aLV9i");

var $1v5pe = parcelRequire("1v5pe");
var $67109167942d8522$var$useCallback = $1v5pe.useCallback, $67109167942d8522$var$useEffect = $1v5pe.useEffect, $67109167942d8522$var$useRef = $1v5pe.useRef, $67109167942d8522$var$useState = $1v5pe.useState;

var $ArurZ = parcelRequire("ArurZ");
var $67109167942d8522$var$RelayFeatureFlags = $ArurZ.RelayFeatureFlags, $67109167942d8522$var$getRequest = $ArurZ.getRequest;
var $67109167942d8522$var$initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function $67109167942d8522$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = $67109167942d8522$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
function $67109167942d8522$var$useQueryLoader(preloadableRequest, initialQueryReference) {
    if ($67109167942d8522$var$RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return $6tVmg(preloadableRequest, initialQueryReference);
    return $67109167942d8522$var$useQueryLoader_CURRENT(preloadableRequest, initialQueryReference);
}
function $67109167942d8522$var$useQueryLoader_CURRENT(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $67109167942d8522$var$initialNullQueryReferenceState;
    var environment = $aLV9i();
    var isMountedRef = $5chmM();
    var undisposedQueryReferencesRef = $67109167942d8522$var$useRef(new Set([
        initialQueryReferenceInternal
    ]));
    var _useState = $67109167942d8522$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $67109167942d8522$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        undisposedQueryReferencesRef.current.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $67109167942d8522$var$useCallback(function() {
        if (isMountedRef.current) {
            undisposedQueryReferencesRef.current.add($67109167942d8522$var$initialNullQueryReferenceState);
            setQueryReference($67109167942d8522$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $67109167942d8522$var$useCallback(function(variables, options) {
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        if (isMountedRef.current) {
            var _options$__environmen;
            var updatedQueryReference = $67109167942d8522$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
            undisposedQueryReferencesRef.current.add(updatedQueryReference);
            setQueryReference(updatedQueryReference);
        }
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $67109167942d8522$var$useRef(false);
    $67109167942d8522$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $67109167942d8522$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (queryReference.kind !== 'NullQueryReference') queryLoaderCallback(queryReference.variables, {
                fetchPolicy: queryReference.fetchPolicy,
                networkCacheConfig: queryReference.networkCacheConfig
            });
            return;
        }
        var undisposedQueryReferences = undisposedQueryReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $67109167942d8522$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedQueryReference = _step.value;
                    if (undisposedQueryReference === queryReference) break;
                    undisposedQueryReferences["delete"](undisposedQueryReference);
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($67109167942d8522$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        queryReference,
        isMountedRef,
        queryLoaderCallback,
        preloadableRequest
    ]);
    $67109167942d8522$var$useEffect(function() {
        return function disposeAllRemainingQueryReferences() {
            var _iterator2 = (0, $67109167942d8522$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var undisposedQueryReference = _step2.value;
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($67109167942d8522$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $67109167942d8522$var$useQueryLoader;

});
parcelRegister("6tVmg", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $4b81f19c4a3a3fb6$var$_interopRequireDefault = $bGHxy.default;

var $4b81f19c4a3a3fb6$var$_createForOfIteratorHelper2 = $4b81f19c4a3a3fb6$var$_interopRequireDefault((parcelRequire("cXbK5")));

var $gucdA = parcelRequire("gucdA");
var $4b81f19c4a3a3fb6$var$loadQuery = $gucdA.loadQuery;

var $5chmM = parcelRequire("5chmM");

var $aLV9i = parcelRequire("aLV9i");

var $1v5pe = parcelRequire("1v5pe");
var $4b81f19c4a3a3fb6$var$useCallback = $1v5pe.useCallback, $4b81f19c4a3a3fb6$var$useEffect = $1v5pe.useEffect, $4b81f19c4a3a3fb6$var$useInsertionEffect = $1v5pe.useInsertionEffect, $4b81f19c4a3a3fb6$var$useRef = $1v5pe.useRef, $4b81f19c4a3a3fb6$var$useState = $1v5pe.useState;

var $ArurZ = parcelRequire("ArurZ");
var $4b81f19c4a3a3fb6$var$getRequest = $ArurZ.getRequest;
var $4b81f19c4a3a3fb6$var$initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function $4b81f19c4a3a3fb6$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = $4b81f19c4a3a3fb6$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
var $4b81f19c4a3a3fb6$var$CLEANUP_TIMEOUT = 300000;
function $4b81f19c4a3a3fb6$var$useQueryLoader_EXPERIMENTAL(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $4b81f19c4a3a3fb6$var$initialNullQueryReferenceState;
    var environment = $aLV9i();
    var isMountedRef = $5chmM();
    var undisposedQueryReferencesRef = $4b81f19c4a3a3fb6$var$useRef(null);
    if (undisposedQueryReferencesRef.current == null) undisposedQueryReferencesRef.current = new Set([
        initialQueryReferenceInternal
    ]);
    var _useState = $4b81f19c4a3a3fb6$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $4b81f19c4a3a3fb6$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        var _undisposedQueryRefer;
        (_undisposedQueryRefer = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer === void 0 || _undisposedQueryRefer.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $4b81f19c4a3a3fb6$var$useCallback(function() {
        if (isMountedRef.current) {
            var _undisposedQueryRefer2;
            (_undisposedQueryRefer2 = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer2 === void 0 || _undisposedQueryRefer2.add($4b81f19c4a3a3fb6$var$initialNullQueryReferenceState);
            setQueryReference($4b81f19c4a3a3fb6$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $4b81f19c4a3a3fb6$var$useCallback(function(variables, options) {
        var _options$__environmen, _undisposedQueryRefer3;
        if (!isMountedRef.current) return;
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        var updatedQueryReference = $4b81f19c4a3a3fb6$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
        (_undisposedQueryRefer3 = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer3 === void 0 || _undisposedQueryRefer3.add(updatedQueryReference);
        setQueryReference(updatedQueryReference);
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var disposeAllRemainingQueryReferences = $4b81f19c4a3a3fb6$var$useCallback(function disposeAllRemainingQueryReferences(preloadableRequest, currentQueryReference) {
        var _undisposedQueryRefer4;
        var undisposedQueryReferences = (_undisposedQueryRefer4 = undisposedQueryReferencesRef.current) !== null && _undisposedQueryRefer4 !== void 0 ? _undisposedQueryRefer4 : new Set();
        var _iterator = (0, $4b81f19c4a3a3fb6$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var undisposedQueryReference = _step.value;
                if (undisposedQueryReference === currentQueryReference) continue;
                if (undisposedQueryReference.kind !== 'NullQueryReference') {
                    if ($4b81f19c4a3a3fb6$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                    else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }, []);
    var cleanupTimerRef = $4b81f19c4a3a3fb6$var$useRef(null);
    $4b81f19c4a3a3fb6$var$useEffect(function() {
        disposeAllRemainingQueryReferences(preloadableRequest, queryReference);
        if (cleanupTimerRef.current != null) {
            clearTimeout(cleanupTimerRef.current);
            cleanupTimerRef.current = null;
        }
        return function() {
            cleanupTimerRef.current = setTimeout(function() {
                disposeAllRemainingQueryReferences(preloadableRequest, null);
            }, $4b81f19c4a3a3fb6$var$CLEANUP_TIMEOUT);
        };
    }, [
        preloadableRequest,
        queryReference
    ]);
    $4b81f19c4a3a3fb6$var$useInsertionEffect(function() {
        return function() {
            cleanupTimerRef.current && clearTimeout(cleanupTimerRef.current);
            cleanupTimerRef.current = null;
            disposeAllRemainingQueryReferences(preloadableRequest, null);
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $4b81f19c4a3a3fb6$var$useQueryLoader_EXPERIMENTAL;

});




parcelRegister("747sM", function(module, exports) {
'use strict';

var $bGHxy = parcelRequire("bGHxy");
var $524eb228c484a790$var$_interopRequireDefault = $bGHxy.default;

var $524eb228c484a790$var$_objectSpread2 = $524eb228c484a790$var$_interopRequireDefault((parcelRequire("eQAdv")));

var $cjsY7 = parcelRequire("cjsY7");

var $ft6Ql = parcelRequire("ft6Ql");

var $71dX5 = parcelRequire("71dX5");

var $aLV9i = parcelRequire("aLV9i");

var $GQ49S = parcelRequire("GQ49S");

var $5Wk1R = parcelRequire("5Wk1R");

var $1v5pe = parcelRequire("1v5pe");
var $524eb228c484a790$var$useCallback = $1v5pe.useCallback, $524eb228c484a790$var$useDebugValue = $1v5pe.useDebugValue, $524eb228c484a790$var$useEffect = $1v5pe.useEffect, $524eb228c484a790$var$useLayoutEffect = $1v5pe.useLayoutEffect, $524eb228c484a790$var$useMemo = $1v5pe.useMemo, $524eb228c484a790$var$useRef = $1v5pe.useRef, $524eb228c484a790$var$useState = $1v5pe.useState;

var $ArurZ = parcelRequire("ArurZ");
var $524eb228c484a790$var$getFragment = $ArurZ.getFragment, $524eb228c484a790$var$getFragmentIdentifier = $ArurZ.getFragmentIdentifier, $524eb228c484a790$var$getPaginationMetadata = $ArurZ.getPaginationMetadata;

var $ArurZ = parcelRequire("ArurZ");
var $524eb228c484a790$var$ConnectionInterface = $ArurZ.ConnectionInterface, $524eb228c484a790$var$RelayFeatureFlags = $ArurZ.RelayFeatureFlags, $524eb228c484a790$var$getSelector = $ArurZ.getSelector, $524eb228c484a790$var$getValueAtPath = $ArurZ.getValueAtPath;
function $524eb228c484a790$var$usePrefetchableForwardPaginationFragment(fragmentInput, parentFragmentRef, bufferSize, initialSize, prefetchingLoadMoreOptions) {
    var _fragmentInput$metada, _fragmentInput$metada2;
    var minimalFetchSize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
    var disablePrefetching = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var fragmentNode = $524eb228c484a790$var$getFragment(fragmentInput);
    $GQ49S(fragmentNode, 'first argument of usePrefetchableForwardPaginationFragment()');
    var componentDisplayName = 'usePrefetchableForwardPaginationFragment()';
    var _getPaginationMetadat = $524eb228c484a790$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = $71dX5(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $524eb228c484a790$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    var edgeKeys = $524eb228c484a790$var$useMemo(function() {
        var connection = $524eb228c484a790$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
        if (connection == null) return null;
        var _ConnectionInterface$ = $524eb228c484a790$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES;
        return connection[EDGES];
    }, [
        connectionPathInFragmentData,
        fragmentData
    ]);
    var sourceSize = edgeKeys == null ? -1 : edgeKeys.length;
    var _useState = $524eb228c484a790$var$useState(initialSize != null ? initialSize : sourceSize), _numInUse = _useState[0], setNumInUse = _useState[1];
    var numInUse = _numInUse;
    if (_numInUse === -1 && sourceSize !== -1) {
        numInUse = initialSize != null ? initialSize : sourceSize;
        setNumInUse(numInUse);
    }
    var environment = $aLV9i();
    var _useState2 = $524eb228c484a790$var$useState(false), isLoadingMore = _useState2[0], reallySetIsLoadingMore = _useState2[1];
    var _useState3 = $524eb228c484a790$var$useState(false), isRefetching = _useState3[0], setIsRefetching = _useState3[1];
    var availableSizeRef = $524eb228c484a790$var$useRef(0);
    var setIsLoadingMore = $524eb228c484a790$var$useCallback(function(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    }, [
        environment
    ]);
    var isLoadingMoreRef = $524eb228c484a790$var$useRef(false);
    var observer = $524eb228c484a790$var$useMemo(function() {
        function setIsLoadingFalse() {
            isLoadingMoreRef.current = false;
            setIsLoadingMore(false);
        }
        return {
            start: function start() {
                isLoadingMoreRef.current = true;
                reallySetIsLoadingMore(true);
            },
            complete: setIsLoadingFalse,
            error: setIsLoadingFalse,
            unsubscribe: $524eb228c484a790$var$RelayFeatureFlags.ENABLE_USE_PAGINATION_IS_LOADING_FIX ? setIsLoadingFalse : undefined
        };
    }, [
        setIsLoadingMore
    ]);
    var handleReset = $524eb228c484a790$var$useCallback(function() {
        if (!isRefetching) {
            var _environment$getSched2;
            var schedule = (_environment$getSched2 = environment.getScheduler()) === null || _environment$getSched2 === void 0 ? void 0 : _environment$getSched2.schedule;
            if (schedule) schedule(function() {
                setNumInUse(-1);
            });
            else setNumInUse(-1);
        }
        isLoadingMoreRef.current = false;
        setIsLoadingMore(false);
    }, [
        environment,
        isRefetching,
        setIsLoadingMore
    ]);
    var _useLoadMoreFunction = $ft6Ql({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest,
        observer: observer,
        onReset: handleReset
    }), loadMore = _useLoadMoreFunction[0], hasNext = _useLoadMoreFunction[1], disposeFetchNext = _useLoadMoreFunction[2];
    $524eb228c484a790$var$useLayoutEffect(function() {
        availableSizeRef.current = sourceSize - numInUse;
    }, [
        numInUse,
        sourceSize
    ]);
    var prefetchingUNSTABLE_extraVariables = prefetchingLoadMoreOptions === null || prefetchingLoadMoreOptions === void 0 ? void 0 : prefetchingLoadMoreOptions.UNSTABLE_extraVariables;
    var prefetchingOnComplete = prefetchingLoadMoreOptions === null || prefetchingLoadMoreOptions === void 0 ? void 0 : prefetchingLoadMoreOptions.onComplete;
    var showMore = $524eb228c484a790$var$useCallback(function(numToAdd, options) {
        if (!isLoadingMoreRef.current || availableSizeRef.current >= 0) {
            availableSizeRef.current -= numToAdd;
            setNumInUse(function(lastNumInUse) {
                return lastNumInUse + numToAdd;
            });
            if (!isLoadingMoreRef.current && availableSizeRef.current < 0) loadMore(Math.max(minimalFetchSize, Math.min(numToAdd, bufferSize - availableSizeRef.current)), options !== null && options !== void 0 ? options : {
                onComplete: prefetchingOnComplete,
                UNSTABLE_extraVariables: typeof prefetchingUNSTABLE_extraVariables === 'function' ? prefetchingUNSTABLE_extraVariables({
                    hasNext: hasNext,
                    data: fragmentData,
                    getServerEdges: function getServerEdges() {
                        var selector = $524eb228c484a790$var$getSelector(edgesFragment, edgeKeys);
                        if (selector == null) return [];
                        !(selector.kind === 'PluralReaderSelector') && $5Wk1R(false);
                        return selector.selectors.map(function(sel) {
                            return environment.lookup(sel).data;
                        });
                    }
                }) : prefetchingUNSTABLE_extraVariables
            });
        }
    }, [
        bufferSize,
        loadMore,
        minimalFetchSize,
        edgeKeys,
        fragmentData,
        prefetchingUNSTABLE_extraVariables,
        prefetchingOnComplete
    ]);
    var edgesFragment = (_fragmentInput$metada = fragmentInput.metadata) === null || _fragmentInput$metada === void 0 ? void 0 : (_fragmentInput$metada2 = _fragmentInput$metada.refetch) === null || _fragmentInput$metada2 === void 0 ? void 0 : _fragmentInput$metada2.edgesFragment;
    !(edgesFragment != null) && $5Wk1R(false);
    $524eb228c484a790$var$useEffect(function() {
        if (!isLoadingMoreRef.current && !isLoadingMore && !isRefetching && !disablePrefetching && hasNext && (sourceSize - numInUse < bufferSize || numInUse > sourceSize)) {
            var onComplete = prefetchingOnComplete;
            loadMore(Math.max(bufferSize - Math.max(sourceSize - numInUse, 0), numInUse - sourceSize, minimalFetchSize), {
                onComplete: onComplete,
                UNSTABLE_extraVariables: typeof prefetchingUNSTABLE_extraVariables === 'function' ? prefetchingUNSTABLE_extraVariables({
                    hasNext: hasNext,
                    data: fragmentData,
                    getServerEdges: function getServerEdges() {
                        var selector = $524eb228c484a790$var$getSelector(edgesFragment, edgeKeys);
                        if (selector == null) return [];
                        !(selector.kind === 'PluralReaderSelector') && $5Wk1R(false);
                        return selector.selectors.map(function(sel) {
                            return environment.lookup(sel).data;
                        });
                    }
                }) : prefetchingUNSTABLE_extraVariables
            });
        }
    }, [
        hasNext,
        bufferSize,
        isRefetching,
        loadMore,
        numInUse,
        prefetchingUNSTABLE_extraVariables,
        prefetchingOnComplete,
        sourceSize,
        edgeKeys,
        isLoadingMore,
        minimalFetchSize,
        environment,
        edgesFragment
    ]);
    var realNumInUse = Math.min(numInUse, sourceSize);
    var derivedEdgeKeys = $524eb228c484a790$var$useMemo(function() {
        var _edgeKeys$slice;
        return (_edgeKeys$slice = edgeKeys === null || edgeKeys === void 0 ? void 0 : edgeKeys.slice(0, realNumInUse)) !== null && _edgeKeys$slice !== void 0 ? _edgeKeys$slice : [];
    }, [
        edgeKeys,
        realNumInUse
    ]);
    var edges = $cjsY7(edgesFragment, derivedEdgeKeys);
    var refetchPagination = $524eb228c484a790$var$useCallback(function(variables, options) {
        disposeFetchNext();
        setIsRefetching(true);
        return refetch(variables, (0, $524eb228c484a790$var$_objectSpread2["default"])((0, $524eb228c484a790$var$_objectSpread2["default"])({}, options), {}, {
            onComplete: function onComplete(maybeError) {
                var _environment$getSched3, _options$onComplete;
                var schedule = (_environment$getSched3 = environment.getScheduler()) === null || _environment$getSched3 === void 0 ? void 0 : _environment$getSched3.schedule;
                if (schedule) schedule(function() {
                    setIsRefetching(false);
                    setNumInUse(-1);
                });
                else {
                    setIsRefetching(false);
                    setNumInUse(-1);
                }
                options === null || options === void 0 || (_options$onComplete = options.onComplete) === null || _options$onComplete === void 0 || _options$onComplete.call(options, maybeError);
            },
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        environment,
        refetch
    ]);
    return {
        edges: edges,
        data: fragmentData,
        loadNext: showMore,
        hasNext: hasNext || sourceSize > numInUse,
        isLoadingNext: isLoadingMore && numInUse > sourceSize,
        refetch: refetchPagination
    };
}
module.exports = $524eb228c484a790$var$usePrefetchableForwardPaginationFragment;

});

parcelRegister("fMcxN", function(module, exports) {
'use strict';

var $hpgYJ = parcelRequire("hpgYJ");

var $9cvfB = parcelRequire("9cvfB");

var $aLV9i = parcelRequire("aLV9i");

var $5Wk1R = parcelRequire("5Wk1R");

var $1v5pe = parcelRequire("1v5pe");
var $b7c511bb93a348ab$var$useDebugValue = $1v5pe.useDebugValue;

var $ArurZ = parcelRequire("ArurZ");
var $b7c511bb93a348ab$var$_require2$__internal = $ArurZ.__internal, $b7c511bb93a348ab$var$fetchQueryDeduped = $b7c511bb93a348ab$var$_require2$__internal.fetchQueryDeduped, $b7c511bb93a348ab$var$fetchQuery = $b7c511bb93a348ab$var$_require2$__internal.fetchQuery;
parcelRequire("91yGl");
function $b7c511bb93a348ab$var$usePreloadedQuery(gqlQuery, preloadedQuery, options) {
    var environment = $aLV9i();
    var fetchKey = preloadedQuery.fetchKey, fetchPolicy = preloadedQuery.fetchPolicy, source = preloadedQuery.source, variables = preloadedQuery.variables, networkCacheConfig = preloadedQuery.networkCacheConfig;
    var operation = $9cvfB(gqlQuery, variables, networkCacheConfig);
    var useLazyLoadQueryNodeParams;
    if (preloadedQuery.kind === 'PreloadedQuery_DEPRECATED') {
        !(operation.request.node.params.name === preloadedQuery.name) && $5Wk1R(false);
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchKey: fetchKey,
            fetchObservable: $b7c511bb93a348ab$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
                if (environment === preloadedQuery.environment && source != null) return environment.executeWithSource({
                    operation: operation,
                    source: source
                });
                else return environment.execute({
                    operation: operation
                });
            }),
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    } else {
        var fallbackFetchObservable = $b7c511bb93a348ab$var$fetchQuery(environment, operation);
        var fetchObservable;
        if (source != null && environment === preloadedQuery.environment) fetchObservable = source.ifEmpty(fallbackFetchObservable);
        else if (environment !== preloadedQuery.environment) fetchObservable = fallbackFetchObservable;
        else fetchObservable = fallbackFetchObservable;
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchObservable: fetchObservable,
            fetchKey: fetchKey,
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    }
    var data = $hpgYJ(useLazyLoadQueryNodeParams);
    return data;
}
module.exports = $b7c511bb93a348ab$var$usePreloadedQuery;

});

parcelRegister("gELjH", function(module, exports) {
'use strict';

var $71dX5 = parcelRequire("71dX5");

var $GQ49S = parcelRequire("GQ49S");

var $1v5pe = parcelRequire("1v5pe");
var $c20515e78bd332a9$var$useDebugValue = $1v5pe.useDebugValue;

var $ArurZ = parcelRequire("ArurZ");
var $c20515e78bd332a9$var$getFragment = $ArurZ.getFragment;
function $c20515e78bd332a9$var$useRefetchableFragment(fragmentInput, fragmentRef) {
    var fragmentNode = $c20515e78bd332a9$var$getFragment(fragmentInput);
    $GQ49S(fragmentNode, 'first argument of useRefetchableFragment()');
    var _useRefetchableFragme = $71dX5(fragmentNode, fragmentRef, 'useRefetchableFragment()'), fragmentData = _useRefetchableFragme.fragmentData, refetch = _useRefetchableFragme.refetch;
    return [
        fragmentData,
        refetch
    ];
}
module.exports = $c20515e78bd332a9$var$useRefetchableFragment;

});

parcelRegister("h3obL", function(module, exports) {
'use strict';

var $aLV9i = parcelRequire("aLV9i");

var $1v5pe = parcelRequire("1v5pe");
var $c6a57adc514ec185$var$useEffect = $1v5pe.useEffect, $c6a57adc514ec185$var$useRef = $1v5pe.useRef;
function $c6a57adc514ec185$var$useSubscribeToInvalidationState(dataIDs, callback) {
    var environment = $aLV9i();
    var disposableRef = $c6a57adc514ec185$var$useRef(null);
    var stableDataIDs = Array.from(dataIDs).sort().join('');
    $c6a57adc514ec185$var$useEffect(function() {
        var store = environment.getStore();
        var invalidationState = store.lookupInvalidationState(dataIDs);
        var disposable = store.subscribeToInvalidationState(invalidationState, callback);
        disposableRef.current = disposable;
        return function() {
            return disposable.dispose();
        };
    }, [
        stableDataIDs,
        callback,
        environment
    ]);
    return {
        dispose: function dispose() {
            if (disposableRef.current != null) disposableRef.current.dispose();
        }
    };
}
module.exports = $c6a57adc514ec185$var$useSubscribeToInvalidationState;

});

parcelRegister("k4u74", function(module, exports) {
'use strict';

var $aLV9i = parcelRequire("aLV9i");

var $1v5pe = parcelRequire("1v5pe");
var $e9cb8a35e779a37b$var$useEffect = $1v5pe.useEffect;

var $ArurZ = parcelRequire("ArurZ");
var $e9cb8a35e779a37b$var$requestSubscription = $ArurZ.requestSubscription;
function $e9cb8a35e779a37b$var$useSubscription(config, requestSubscriptionFn) {
    var actualRequestSubscription = requestSubscriptionFn !== null && requestSubscriptionFn !== void 0 ? requestSubscriptionFn : $e9cb8a35e779a37b$var$requestSubscription;
    var environment = $aLV9i();
    $e9cb8a35e779a37b$var$useEffect(function() {
        var _actualRequestSubscri = actualRequestSubscription(environment, config), dispose = _actualRequestSubscri.dispose;
        return dispose;
    }, [
        environment,
        config,
        actualRequestSubscription
    ]);
}
module.exports = $e9cb8a35e779a37b$var$useSubscription;

});



parcelRegister("2aEiL", function(module, exports) {
$parcel$export(module.exports, "fg", () => $66aab3be55683b8e$export$b40ec24ac8275656);

var $5ErpT = parcelRequire("5ErpT");
function $66aab3be55683b8e$export$b40ec24ac8275656(name) {
    return (0, $5ErpT.resolveBooleanFlag)(name);
}

});
parcelRegister("5ErpT", function(module, exports) {
$parcel$export(module.exports, "resolveBooleanFlag", () => $b5053bcaf5f170df$export$6333b6aff9fc6275);

var $4d1Vr = parcelRequire("4d1Vr");

var $7u1vJ = parcelRequire("7u1vJ");

var $380IJ = parcelRequire("380IJ");

var $k2MNL = parcelRequire("k2MNL");

var $8puww = parcelRequire("8puww");

var $4cILa = parcelRequire("4cILa");
const $b5053bcaf5f170df$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $380IJ.ENV_ENABLE_PLATFORM_FF) || (0, $k2MNL.ENV_STORYBOOK_ENABLE_PLATFORM_FF);
function $b5053bcaf5f170df$export$6333b6aff9fc6275(flagKey) {
    if ($b5053bcaf5f170df$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $7u1vJ.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $4cILa.pkgName), flagKey);
        return true;
    }
    try {
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if ((0, $8puww.globalVar)[0, $4cILa.PFF_GLOBAL_KEY]?.booleanResolver === undefined || (0, $8puww.globalVar)[0, $4cILa.PFF_GLOBAL_KEY]?.booleanResolver === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $4d1Vr.default).checkGate(flagKey);
        const result = (0, $8puww.globalVar)[0, $4cILa.PFF_GLOBAL_KEY]?.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn(`${flagKey} resolved to a non-boolean value, returning false for safety`);
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("4d1Vr", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e09d4787d3ead01$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $b5pyb = parcelRequire("b5pyb");

var $4d6dI = parcelRequire("4d6dI");



/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ class $9e09d4787d3ead01$var$FeatureGates {
    static client = new (0, $b5pyb.Client)();
    static hasCheckGateErrorOccurred = false;
    static hasGetExperimentValueErrorOccurred = false;
    static checkGate = (gateName, options)=>{
        try {
            // Check if the CRITERION override mechanism is available
            if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
                // Attempt to retrieve an override value for the feature gate
                const overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
                // If an override value is found, return it immediately
                if (overrideValue !== undefined) return overrideValue;
            }
        } catch (error) {
            // Log the first occurrence of the error
            if (!$9e09d4787d3ead01$var$FeatureGates.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                $9e09d4787d3ead01$var$FeatureGates.hasCheckGateErrorOccurred = true;
            }
        }
        // Proceed with the main logic if no override is found
        return this.client.checkGate(gateName, options);
    };
    /**
   * Returns whether the given feature gate exists for the current user.
   *
   * Not for flags that only exist in the Feature Flag Platform (FFP): use
   * {@link FeatureGates.ffpClient} for those. Use this method for Statsig flags, including flags
   * being migrated from Statsig to FFP.
   */ static isGateExists(gateName) {
        return this.client.isGateExist(gateName);
    }
    /**
   * Returns whether the given experiment exists for the current user.
   *
   * Not for flags that only exist in the Feature Flag Platform (FFP): use
   * {@link FeatureGates.ffpClient} for those. Use this method for Statsig flags, including flags
   * being migrated from Statsig to FFP.
   */ static isExperimentExists(experimentName) {
        return this.client.isExperimentExist(experimentName);
    }
    static getExperimentValue = (experimentName, parameterName, defaultValue, options)=>{
        try {
            // Check if the CRITERION override mechanism is available
            if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
                const overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
                if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
            }
        } catch (error) {
            // Log the first occurrence of the error
            if (!$9e09d4787d3ead01$var$FeatureGates.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
        // Proceed with the main logic if no override is found
        return this.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
    };
    static initializeCalled = this.client.initializeCalled.bind(this.client);
    static initializeCompleted = this.client.initializeCompleted.bind(this.client);
    static waitUntilInitializeCompleted = this.client.waitUntilInitializeCompleted.bind(this.client);
    static initialize = this.client.initialize.bind(this.client);
    static initializeWithProvider = this.client.initializeWithProvider.bind(this.client);
    static initializeFromValues = this.client.initializeFromValues.bind(this.client);
    static manuallyLogGateExposure = this.client.manuallyLogGateExposure.bind(this.client);
    static getExperiment = this.client.getExperiment.bind(this.client);
    static manuallyLogExperimentExposure = this.client.manuallyLogExperimentExposure.bind(this.client);
    static manuallyLogLayerExposure = this.client.manuallyLogLayerExposure.bind(this.client);
    static shutdownStatsig = this.client.shutdownStatsig.bind(this.client);
    static overrideGate = this.client.overrideGate.bind(this.client);
    static clearGateOverride = this.client.clearGateOverride.bind(this.client);
    static overrideConfig = this.client.overrideConfig.bind(this.client);
    static clearConfigOverride = this.client.clearConfigOverride.bind(this.client);
    static setOverrides = this.client.setOverrides.bind(this.client);
    static getOverrides = this.client.getOverrides.bind(this.client);
    static clearAllOverrides = this.client.clearAllOverrides.bind(this.client);
    static isCurrentUser = this.client.isCurrentUser.bind(this.client);
    static onGateUpdated = this.client.onGateUpdated.bind(this.client);
    static onExperimentValueUpdated = this.client.onExperimentValueUpdated.bind(this.client);
    static onAnyUpdated = this.client.onAnyUpdated.bind(this.client);
    static updateUser = this.client.updateUser.bind(this.client);
    static updateUserWithProvider = this.client.updateUserWithProvider.bind(this.client);
    static updateUserWithValues = this.client.updateUserWithValues.bind(this.client);
    /**
   * The Feature Flag Platform (FFP) client, for reading flags that only exist in FFP. See
   * {@link Client.ffpClient}.
   *
   * It is `undefined` until an initialize method is called, and also when an older version of this
   * package that predates it is the one bound to the page.
   *
   * @example
   * ```ts
   * const enabled = FeatureGates.ffpClient?.getBooleanValue('my-new-flag', false) ?? false;
   * ```
   */ static get ffpClient() {
        return this.client.ffpClient;
    }
    static getPackageVersion = this.client.getPackageVersion.bind(this.client);
    static getTargetApp = this.client.getTargetApp.bind(this.client);
    static getLayer = this.client.getLayer.bind(this.client);
    static getLayerValue = this.client.getLayerValue.bind(this.client);
}
let $9e09d4787d3ead01$var$boundFGJS = $9e09d4787d3ead01$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $9e09d4787d3ead01$var$FeatureGates;
    else {
        $9e09d4787d3ead01$var$boundFGJS = window.__FEATUREGATES_JS__;
        const boundVersion = $9e09d4787d3ead01$var$boundFGJS?.getPackageVersion?.() || '4.10.0 or earlier';
        if (boundVersion !== (0, $4d6dI.CLIENT_VERSION)) {
            const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, $4d6dI.CLIENT_VERSION)} was loading.`;
            // eslint-disable-next-line no-console
            console.warn(message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $9e09d4787d3ead01$export$2e2bcd8739ae039 = $9e09d4787d3ead01$var$boundFGJS;

});
parcelRegister("b5pyb", function(module, exports) {
$parcel$export(module.exports, "Client", () => $c464ed79c9f7a942$export$1f2bb630327ac4b6);

var $1T45w = parcelRequire("1T45w");

var $iaAZy = parcelRequire("iaAZy");

var $4p9Sd = parcelRequire("4p9Sd");

var $kIeaF = parcelRequire("kIeaF");

var $lOIRH = parcelRequire("lOIRH");

var $jQSGj = parcelRequire("jQSGj");

var $khTgG = parcelRequire("khTgG");

var $7eV3p = parcelRequire("7eV3p");

var $5Oj64 = parcelRequire("5Oj64");

var $1aoIg = parcelRequire("1aoIg");

var $jOwMd = parcelRequire("jOwMd");

var $2YPaE = parcelRequire("2YPaE");

var $iTSgg = parcelRequire("iTSgg");

var $1xPXE = parcelRequire("1xPXE");

var $deCXZ = parcelRequire("deCXZ");

var $hHsjm = parcelRequire("hHsjm");

var $joS99 = parcelRequire("joS99");

var $4d6dI = parcelRequire("4d6dI");
const $c464ed79c9f7a942$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
const $c464ed79c9f7a942$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
function $c464ed79c9f7a942$var$logFetchError(error) {
    if (error instanceof Error) // eslint-disable-next-line no-console
    console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error.message}`);
    // eslint-disable-next-line no-console
    console.warn(`Initialising Statsig client without values`);
}
class $c464ed79c9f7a942$export$1f2bb630327ac4b6 {
    statsigClient;
    user;
    initOptions;
    initPromise = null;
    /** True if an initialize method was called and completed successfully. */ initCompleted = false;
    /**
   * True if an initialize method was called and completed, meaning the client is now usable.
   * However if there was an error during initialization it may have initialized with default
   * values. Use {@link initCompleted} to check for this.
   */ initWithDefaults = false;
    currentIdentifiers;
    currentAttributes;
    hasCheckGateErrorOccurred = false;
    hasGetExperimentErrorOccurred = false;
    hasGetExperimentValueErrorOccurred = false;
    hasGetLayerErrorOccurred = false;
    hasGetLayerValueErrorOccurred = false;
    provider;
    subscriptions = new (0, $iaAZy.default)();
    dataAdapter = new (0, $iTSgg.NoFetchDataAdapter)();
    /** Serves the flags the Feature Flag Service assigns to FFP; all other keys use Statsig. */ ffp = new (0, $1aoIg.FfpClientAdapter)();
    overrideAdapter;
    /** True once an initialize method has applied values, even if Statsig is not running. */ valuesApplied = false;
    /** The options Statsig was (or will be) started with, kept to start it again when re-enabled. */ statsigInitOptions;
    /** A start of Statsig after initialization that is still in progress. */ statsigStart;
    /** Incremented when Statsig stops, so a start that it overtook does nothing. */ statsigGeneration = 0;
    constructor({ localStorageKey: localStorageKey = (0, $1xPXE.LOCAL_STORAGE_KEY), overrideAdapter: overrideAdapter } = {}){
        this.overrideAdapter = overrideAdapter || new (0, $1xPXE.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initialize(clientOptions, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $jOwMd.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $deCXZ.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initialize', this.initCompleted, clientOptionsWithDefaults.apiKey);
        });
        return this.initPromise;
    }
    /**
   * @description
   * This method initializes the client using the provider given to call to fetch the bootstrap values.
   * If the client is initialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param provider {Provider}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initializeWithProvider(clientOptions, provider, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $jOwMd.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $deCXZ.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.provider = provider;
        this.provider.setClientVersion((0, $4d6dI.CLIENT_VERSION));
        if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
        this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeWithProvider', this.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
        });
        return this.initPromise;
    }
    applyUpdateCallback(experimentsResult) {
        try {
            if ((this.initCompleted || this.initWithDefaults) && this.currentIdentifiers) {
                this.assertReady();
                const identifiers = this.currentIdentifiers;
                const customAttributes = experimentsResult.customAttributesFromFetch ?? this.currentAttributes;
                const disabled = experimentsResult.disabledProviders ?? [];
                this.ffp.apply(this.initOptions, disabled.includes('ffp') ? undefined : experimentsResult.ffp, identifiers, customAttributes);
                if (disabled.includes('statsig')) this.stopStatsig();
                else if (this.statsigClient) {
                    this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                    this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                } else if (!this.statsigStart) // Statsig is enabled again after being disabled. A start already in progress is left to
                // finish; the next update brings it up to date.
                this.restartStatsig(experimentsResult, identifiers, customAttributes).then(()=>this.subscriptions.anyUpdated()).catch((error)=>{
                    // eslint-disable-next-line no-console
                    console.warn('Failed to start the Statsig client', error);
                });
                this.statsigValuesUpdated();
                this.reportEvalFlagsStatus('providerUpdate', experimentsResult.status);
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Error when attempting to apply update', error);
        }
    }
    fireClientEvent(startTime, totalTime, action, success, apiKey) {
        this.sendOperationalEvent(action, 'featureGatesClient', {
            success: success,
            startTime: startTime,
            totalTime: totalTime,
            ...apiKey && {
                apiKey: apiKey
            }
        })?.catch((err)=>{
            if (this.initOptions.environment !== (0, $joS99.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
            console.error('Analytics web client promise did not resolve', err);
        });
    }
    /** Sends an operational event about this client, once the analytics client is available. */ sendOperationalEvent(action, actionSubject, attributes) {
        const initOptions = this.initOptions;
        return initOptions.analyticsWebClient?.then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                action: action,
                actionSubject: actionSubject,
                attributes: {
                    targetApp: initOptions.targetApp,
                    clientVersion: (0, $4d6dI.CLIENT_VERSION),
                    ...attributes
                },
                tags: [
                    'measurement'
                ],
                source: '@atlaskit/feature-gate-js-client'
            });
        });
    }
    /**
   * Reports values that are worse than the Feature Flag Service intends because a provider is
   * unavailable. The client still resolves with what it received; affected flags return the
   * code default (or, with the polling provider, the last values the provider served).
   */ reportEvalFlagsStatus(trigger, status) {
        if (!status || !(0, $khTgG.isEvalFlagsDegraded)(status) || !this.initOptions) return;
        const initOptions = this.initOptions;
        if (initOptions.environment !== (0, $joS99.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
        console.warn(`Feature flag values are degraded (Statsig: ${status.statsig}, FFP: ${status.ffp}). Affected flags will return their default values.`);
        this.sendOperationalEvent('degraded', 'featureGatesClientValues', {
            trigger: trigger,
            statsigStatus: status.statsig,
            ffpStatus: status.ffp
        })?.catch(()=>{
        // The initialization event already reports a missing analytics client.
        });
    }
    async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}, ffpValues) {
        const clientOptionsWithDefaults = (0, $jOwMd.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $deCXZ.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        // This makes sure the new Statsig client behaves like the old when bootstrap data is
        // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
        if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues, ffpValues).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeFromValues', this.initCompleted);
        });
        return this.initPromise;
    }
    /**
   * Throws if the Statsig client does not exist. The client's own methods use
   * {@link assertReady} instead, because Statsig is absent while the Feature Flag Service
   * disables it.
   */ assertInitialized(statsigClient) {
        if (!statsigClient) throw new Error('Client must be initialized before using this method');
    }
    /**
   * This method updates the user using a network call to fetch the new set of values.
   * @param fetchOptions {FetcherOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUser(fetchOptions, identifiers, customAttributes) {
        this.assertReady();
        const fetchOptionsWithDefaults = (0, $jOwMd.getOptionsWithDefaults)(fetchOptions);
        const initializeValuesProducer = ()=>(0, $5Oj64.default).fetchFlagValues(fetchOptionsWithDefaults, identifiers, customAttributes).then((response)=>(0, $7eV3p.toInitializeValues)(response, customAttributes));
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
   * This method updates the user using the provider given on initialisation to get the new set of
   * values.
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUserWithProvider(identifiers, customAttributes) {
        this.assertReady();
        if (!this.provider) throw new Error('Cannot update user using provider as the client was not initialised with a provider');
        await this.provider.setProfile(this.initOptions, identifiers, customAttributes);
        await this.updateUserUsingInitializeValuesProducer(()=>this.provider.getExperimentValues(), identifiers, customAttributes);
    }
    /**
   * This method updates the user given a new set of bootstrap values obtained from one of the
   * server-side SDKs.
   *
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @param initializeValues {Record<string,unknown>}
   */ async updateUserWithValues(identifiers, customAttributes, initializeValues = {}, ffpValues) {
        this.assertReady();
        const initializeValuesProducer = ()=>Promise.resolve({
                experimentValues: initializeValues,
                customAttributesFromFetch: customAttributes,
                ffp: ffpValues
            });
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    initializeCalled() {
        return this.initPromise != null;
    }
    initializeCompleted() {
        return this.initCompleted;
    }
    async waitUntilInitializeCompleted() {
        if (!this.initPromise) throw new Error('The client must be initialized before you can wait until initialized.');
        if (this.initCompleted) return;
        await this.initPromise;
    }
    /**
   * The Feature Flag Platform (FFP) client, for reading flags that only exist in FFP. New flags are
   * created only in FFP, so read them here.
   *
   * @example
   * ```ts
   * const enabled = client.ffpClient?.getBooleanValue('my-new-flag', false) ?? false;
   * ```
   *
   * - It is `undefined` until an initialize method is called, then it is the same instance for the
   *   lifetime of this client, including across user updates.
   * - Until FFP values arrive, and when the Feature Flag Service does not use FFP for the user, its
   *   reads return the default they are given.
   * - Local overrides (see {@link Client.overrideGate}) do not apply to it.
   * - It serves only FFP values, so a flag being migrated from Statsig to FFP gets the default
   *   whenever Statsig serves it. Read migrating flags with {@link Client.checkGate},
   *   {@link Client.getExperimentValue} and the other methods of this client, which serve each flag
   *   from whichever of FFP or Statsig the service assigns it to.
   *
   * Its methods match those of `FlagClient` from `@atlaskit/flag-client`, so code that reads it
   * keeps working once it uses a `FlagClient` directly.
   */ get ffpClient() {
        return this.initOptions ? this.ffp.getClient(this.initOptions) : undefined;
    }
    /**
   * Returns the value for a feature gate. Returns false if there are errors.
   *
   * Not for flags that only exist in the Feature Flag Platform (FFP): use {@link Client.ffpClient}
   * for those. Use this method for Statsig flags, including flags being migrated from Statsig to FFP.
   *
   * @param {string} gateName - The name of the feature gate.
   * @param {Object} options
   * @param {boolean} options.fireGateExposure
   *        Whether or not to fire the exposure event for the gate. Defaults to true.
   *        To log an exposure event manually at a later time, use {@link Client.manuallyLogGateExposure}
   *        (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   */ checkGate(gateName, options = {}) {
        try {
            this.assertReady();
            const { fireGateExposure: fireGateExposure = true } = options;
            const route = this.route(gateName, 'gates');
            switch(route.source){
                case 'statsig':
                    return route.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                case 'ffp':
                    return this.ffp.checkGate(gateName, fireGateExposure);
                case 'override':
                    return route.value;
                default:
                    return false;
            }
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                this.hasCheckGateErrorOccurred = true;
            }
            return false;
        }
    }
    /**
   * Returns whether the given feature gate exists for the current user.
   *
   * Not for flags that only exist in the Feature Flag Platform (FFP): use {@link Client.ffpClient}
   * for those. Use this method for Statsig flags, including flags being migrated from Statsig to FFP.
   */ isGateExist(gateName) {
        try {
            this.assertReady();
            const route = this.route(gateName, 'gates');
            if (route.source !== 'statsig') return route.source !== 'default';
            const gate = route.statsigClient.getFeatureGate(gateName, {
                disableExposureLog: true
            });
            return !gate.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check FeatureGate: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    /**
   * Returns whether the given experiment exists for the current user.
   *
   * Not for flags that only exist in the Feature Flag Platform (FFP): use {@link Client.ffpClient}
   * for those. Use this method for Statsig flags, including flags being migrated from Statsig to FFP.
   */ isExperimentExist(experimentName) {
        try {
            this.assertReady();
            const route = this.route(experimentName, 'configs');
            if (route.source !== 'statsig') return route.source !== 'default';
            const config = route.statsigClient.getExperiment(experimentName, {
                disableExposureLog: true
            });
            return !config.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check Experiment: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    /**
   * Manually log a gate exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a gate earlier via {@link Client.checkGate} where
   * <code>options.fireGateExposure</code> is false.
   *
   * Not for flags that only exist in the Feature Flag Platform (FFP): use {@link Client.ffpClient}
   * for those. Use this method for Statsig flags, including flags being migrated from Statsig to FFP.
   *
   * @param gateName
   */ manuallyLogGateExposure(gateName) {
        this.assertReady();
        const route = this.route(gateName, 'gates');
        if (route.source === 'ffp') this.ffp.logGateExposure(gateName);
        else if (route.source === 'statsig') // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        route.statsigClient.checkGate(gateName);
    // An overridden or default value has no exposure.
    }
    /**
   * Returns the entire config for a given experiment.
   *
   * Not for flags that only exist in the Feature Flag Platform (FFP): use {@link Client.ffpClient}
   * for those. Use this method for Statsig flags, including flags being migrated from Statsig to FFP.
   *
   * @param {string} experimentName - The name of the experiment
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns The config for an experiment
   * @example
   * ```ts
   * const experimentConfig = client.getExperiment('example-experiment-name');
   * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
   * ```
   */ getExperiment(experimentName, options = {}) {
        try {
            this.assertReady();
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            const route = this.route(experimentName, 'configs');
            switch(route.source){
                case 'statsig':
                    return (0, $4p9Sd.DynamicConfig).fromExperiment(route.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                case 'ffp':
                    {
                        const ffpConfig = this.ffp.getConfig(experimentName, fireExperimentExposure);
                        return new (0, $4p9Sd.DynamicConfig)(experimentName, ffpConfig.value, ffpConfig.ruleId, {
                            time: Date.now(),
                            reason: (0, $lOIRH.EvaluationReason).Bootstrap
                        });
                    }
                case 'override':
                    return new (0, $4p9Sd.DynamicConfig)(experimentName, route.value, '', {
                        time: Date.now(),
                        reason: (0, $lOIRH.EvaluationReason).LocalOverride
                    });
                default:
                    return new (0, $4p9Sd.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $lOIRH.EvaluationReason).Unrecognized
                    });
            }
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    error: error
                });
                this.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new (0, $4p9Sd.DynamicConfig)(experimentName, {}, '', {
                time: Date.now(),
                reason: (0, $lOIRH.EvaluationReason).Error
            });
        }
    }
    /**
   * Returns the value of a given parameter in an experiment config.
   *
   * Not for flags that only exist in the Feature Flag Platform (FFP): use {@link Client.ffpClient}
   * for those. Use this method for Statsig flags, including flags being migrated from Statsig to FFP.
   *
   * @template T
   * @param {string} experimentName - The name of the experiment
   * @param {string} parameterName - The name of the parameter to fetch from the experiment config
   * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or
   * if the returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the
   * expected type. If this function returns false, then the default value will be returned
   * instead. This can be set to protect your code from unexpected values being set remotely. By
   * default, this will be done by asserting that the default value and value are the same primitive
   * type.
   * @returns The value of the parameter if the experiment and parameter both exist, otherwise the
   * default value.
   * @example
   ``` ts
   type ValidColor = 'blue' | 'red' | 'yellow';
   type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
  	 const isValidColor: ValidColorTypeCheck =
  		(value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
  	 const buttonColor: ValidColor = client.getExperimentValue(
  		'example-experiment-name',
  		'backgroundColor',
  		'yellow',
  		{
  				typeGuard: isValidColor
  		}
   );
   ```
  */ getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
        const experiment = this.getExperiment(experimentName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return experiment.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    /**
   * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated an experiment earlier via {@link Client.getExperimentValue} or
   * {@link Client.getExperiment} where <code>options.fireExperimentExposure</code> is false.
   *
   * Not for flags that only exist in the Feature Flag Platform (FFP): use {@link Client.ffpClient}
   * for those. Use this method for Statsig flags, including flags being migrated from Statsig to FFP.
   *
   * @param experimentName
   */ manuallyLogExperimentExposure(experimentName) {
        this.assertReady();
        const route = this.route(experimentName, 'configs');
        if (route.source === 'ffp') this.ffp.logConfigExposure(experimentName);
        else if (route.source === 'statsig') // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        route.statsigClient.getExperiment(experimentName);
    // An overridden or default value has no exposure.
    }
    /**
   * Manually log a layer exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a layer earlier via {@link Client.getLayerValue} where <code>options.fireExperimentExposure</code> is false.
   *
   * Layers exist only in Statsig. Flags that only exist in the Feature Flag Platform (FFP) are read
   * with {@link Client.ffpClient}.
   *
   * @param layerName
   * @param parameterName
   */ manuallyLogLayerExposure(layerName, parameterName) {
        this.assertReady();
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient?.getLayer(layerName)?.get(parameterName);
    }
    shutdownStatsig() {
        this.assertReady();
        this.statsigClient?.shutdown();
    }
    /**
   * Adds a new override for the given gate.
   *
   * This method is additive, meaning you can call it multiple times with different gate names to
   * build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearGateOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} gateName
   * @param {boolean} value
   */ overrideGate(gateName, value) {
        this.overrideAdapter.overrideGate(gateName, value);
        // Trigger a reset of the memoized gate value
        if (this.user) this.statsigClient?.updateUserSync(this.user, {
            disableBackgroundCacheRefresh: true
        });
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given gate.
   */ clearGateOverride(gateName) {
        this.overrideAdapter.removeGateOverride(gateName);
        this.statsigValuesUpdated();
    }
    /**
   * Adds a new override for the given config (or experiment).
   *
   * This method is additive, meaning you can call it multiple times with different experiment
   * names to build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearConfigOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} experimentName
   * @param {object} values
   */ overrideConfig(experimentName, values) {
        this.overrideAdapter.overrideDynamicConfig(experimentName, values);
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given experiment.
   * @param {string} experimentName
   */ clearConfigOverride(experimentName) {
        this.overrideAdapter.removeDynamicConfigOverride(experimentName);
        this.statsigValuesUpdated();
    }
    /**
   * Set overrides for gates, experiments and layers in batch.
   *
   * Note that these overrides are **not** additive and will completely replace any that have been
   * added via prior calls to {@link Client.overrideConfig} or
   * {@link Client.overrideGate}.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearAllOverrides} after your tests are completed to remove this
   * localStorage entry.
   */ setOverrides(overrides) {
        this.overrideAdapter.setOverrides(overrides);
        this.statsigValuesUpdated();
    }
    /**
   * @returns The current overrides for gates, configs (including experiments) and layers.
   */ getOverrides() {
        return this.overrideAdapter.getOverrides();
    }
    /**
   * Clears overrides for all gates, configs (including experiments) and layers.
   */ clearAllOverrides() {
        this.overrideAdapter.removeAllOverrides();
        this.statsigValuesUpdated();
    }
    /**
   * Returns whether the given identifiers and customAttributes align with the current
   * set that is being used by the client.
   *
   * If this method returns false, then the {@link Client.updateUser},
   * {@link Client.updateUserWithValues} or {@link Client.updateUserWithProvider}
   * methods can be used to re-align these values.
   *
   * @param identifiers
   * @param customAttributes
   * @returns a flag indicating whether the clients current configuration aligns with the given values
   */ isCurrentUser(identifiers, customAttributes) {
        return (0, $deCXZ.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $deCXZ.shallowEquals)(this.currentAttributes, customAttributes);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current checkGate value
   *
   * Not for flags that only exist in the Feature Flag Platform (FFP): use {@link Client.ffpClient}
   * for those. Use this method for Statsig flags, including flags being migrated from Statsig to FFP.
   *
   * @param gateName
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onGateUpdated(gateName, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireGateExposure: fireGateExposure = true } = options;
            if (fireGateExposure) this.manuallyLogGateExposure(gateName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for gate ${gateName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current experiment value
   *
   * Not for flags that only exist in the Feature Flag Platform (FFP): use {@link Client.ffpClient}
   * for those. Use this method for Statsig flags, including flags being migrated from Statsig to FFP.
   *
   * @param experimentName
   * @param parameterName
   * @param defaultValue
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            if (fireExperimentExposure) this.manuallyLogExperimentExposure(experimentName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for experiment ${experimentName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
    }
    /**
   * Subscribe so on any update the callback will be called.
   * NOTE: The callback will be called whenever the values are updated even if the values have not
   * changed.
   * @param callback
   * @returns off function to unsubscribe from updates
   */ onAnyUpdated(callback) {
        return this.subscriptions.onAnyUpdated(callback);
    }
    /**
   * This method initializes the client using a network call to fetch the bootstrap values for the
   * given user.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @private
   */ async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...clientOptions
        };
        if (clientOptions.localMode) {
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            return;
        }
        await this.initFromFetchedValues(fromValuesClientOptions, identifiers, customAttributes, (0, $5Oj64.default).fetchClientSdk(clientOptions).then((value)=>value.clientSdkKey), (0, $5Oj64.default).fetchFlagValues(clientOptions, identifiers, customAttributes).then((response)=>(0, $7eV3p.toInitializeValues)(response, customAttributes)), 'initialize');
    }
    async initWithProvider(baseClientOptions, provider, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...baseClientOptions,
            disableCurrentPageLogging: true
        };
        // A failure to set the profile, even a synchronous one, fails both fetches.
        const profilePromise = Promise.resolve().then(()=>provider.setProfile(baseClientOptions, identifiers, customAttributes));
        await this.initFromFetchedValues(fromValuesClientOptions, identifiers, customAttributes, profilePromise.then(()=>provider.getClientSdkKey()), profilePromise.then(()=>provider.getExperimentValues()), 'initializeWithProvider');
    }
    /**
   * Initializes from values that are still being fetched, alongside Statsig's SDK key.
   *
   * Only Statsig needs the key, so a failed key fetch leaves FFP initialized with its values and
   * Statsig without values, and the key is not waited for at all when the Feature Flag Service
   * disables Statsig. A failed values fetch initializes Statsig without values (but with the key,
   * if it arrives) and FFP not at all. Either failure rejects after initializing.
   */ async initFromFetchedValues(fromValuesClientOptions, identifiers, customAttributes, clientSdkKeyPromise, valuesPromise, trigger) {
        // Record the key on the options whenever it arrives, so Statsig can still use it if it is
        // enabled after being disabled. Never leave a failure unhandled, as it may never be awaited.
        const clientSdkKeyResult = clientSdkKeyPromise.then((sdkKey)=>{
            fromValuesClientOptions.sdkKey = sdkKey;
            return {};
        }, (error)=>({
                error: error
            }));
        let values;
        try {
            values = await valuesPromise;
        } catch (error) {
            $c464ed79c9f7a942$var$logFetchError(error);
            // Statsig starts without values, but still with its SDK key if that arrives.
            await clientSdkKeyResult;
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        const disabledProviders = values.disabledProviders ?? [];
        const keyFailure = disabledProviders.includes('statsig') ? {} : await clientSdkKeyResult;
        if ('error' in keyFailure) {
            $c464ed79c9f7a942$var$logFetchError(keyFailure.error);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes, undefined, values.ffp, disabledProviders);
            throw keyFailure.error;
        }
        await this.initFromValues(fromValuesClientOptions, identifiers, values.customAttributesFromFetch, values.experimentValues, values.ffp, disabledProviders);
        this.reportEvalFlagsStatus(trigger, values.status);
    }
    /**
   * This method initializes the client using a set of boostrap values obtained from one of the
   * server-side SDKs.
   *
   * Each provider is initialized independently, and a provider in `disabledProviders` is not
   * initialized at all.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @param initializeValues
   * @private
   */ async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}, ffpValues, disabledProviders = []) {
        this.overrideAdapter.initFromStoredOverrides();
        this.currentIdentifiers = identifiers;
        this.currentAttributes = customAttributes;
        this.statsigInitOptions = clientOptions;
        // FFP is independent of Statsig, so apply it before the Statsig client can fail.
        this.ffp.apply(clientOptions, disabledProviders.includes('ffp') ? undefined : ffpValues, identifiers, customAttributes);
        this.valuesApplied = true;
        if (!disabledProviders.includes('statsig')) await this.startStatsig(clientOptions, identifiers, customAttributes, initializeValues);
    }
    /**
   * Creates and initializes the Statsig client. If that fails, Statsig is initialized with the
   * default SDK key and without values, and the error is rethrown.
   */ async startStatsig(clientOptions, identifiers, customAttributes, initializeValues) {
        const newClientOptions = (0, $2YPaE.migrateInitializationOptions)(clientOptions);
        if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $c464ed79c9f7a942$var$DEFAULT_CLIENT_KEY;
        if (!newClientOptions.networkConfig?.logEventUrl) newClientOptions.networkConfig = {
            ...newClientOptions.networkConfig,
            logEventUrl: $c464ed79c9f7a942$var$DEFAULT_EVENT_LOGGING_API
        };
        if (newClientOptions.perimeter === (0, $joS99.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
        newClientOptions.disableLogging = true;
        const { sdkKey: sdkKey, environment: environment, updateUserCompletionCallback: _updateUserCompletionCallback, perimeter: _perimeter, ...restClientOptions } = newClientOptions;
        const frontendUser = (0, $hHsjm.toStatsigUser)(identifiers, customAttributes);
        this.user = (0, $jQSGj.deepAssign)({}, initializeValues.user, frontendUser);
        const statsigOptions = {
            ...restClientOptions,
            environment: {
                tier: environment
            },
            includeCurrentPageUrlWithEvents: false,
            dataAdapter: this.dataAdapter,
            overrideAdapter: this.overrideAdapter,
            logEventCompressionMode: (0, $1T45w.LogEventCompressionMode).Forced
        };
        // Statsig validates the provided stableId against their own cookie, so we either need
        // to update the cookie to match, or disable the validation completely.
        if (identifiers.stableId) (0, $1T45w.StableID).setOverride(identifiers.stableId, sdkKey);
        else statsigOptions.disableStableID = true;
        const generation = this.statsigGeneration;
        try {
            this.statsigClient = new (0, $1T45w.StatsigClient)(sdkKey, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData(initializeValues);
            await this.statsigClient.initializeAsync();
        } catch (error) {
            if (generation !== this.statsigGeneration) // Statsig was stopped while starting, so it must not be started again with defaults.
            throw error;
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to initialise the Statsig client, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            this.statsigClient = new (0, $1T45w.StatsigClient)($c464ed79c9f7a942$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData();
            await this.statsigClient.initializeAsync();
            this.initWithDefaults = true;
            throw error;
        }
    }
    /**
   * Starts Statsig after initialization, when the Feature Flag Service enables it again after
   * disabling it. Concurrent calls share one start, and a start overtaken by {@link stopStatsig}
   * does nothing.
   */ restartStatsig(values, identifiers, customAttributes) {
        if (!this.statsigStart) {
            const generation = this.statsigGeneration;
            this.statsigStart = this.getStatsigRestartOptions(values).then((options)=>{
                if (generation !== this.statsigGeneration) return;
                this.statsigInitOptions = options;
                return this.startStatsig(options, identifiers, customAttributes, values.experimentValues);
            }).finally(()=>{
                this.statsigStart = undefined;
            });
        }
        return this.statsigStart;
    }
    /**
   * The options to start Statsig with after initialization. Statsig's SDK key is normally already
   * known from initialization; otherwise it comes from the values or is fetched again.
   */ async getStatsigRestartOptions(values) {
        const options = {
            ...this.statsigInitOptions ?? this.initOptions
        };
        if (!options.sdkKey) options.sdkKey = values.clientSdkKey ?? await this.fetchStatsigSdkKey();
        return options;
    }
    async fetchStatsigSdkKey() {
        if (this.provider) return this.provider.getClientSdkKey();
        const initOptions = this.initOptions;
        if (initOptions && 'apiKey' in initOptions) return (await (0, $5Oj64.default).fetchClientSdk(initOptions)).clientSdkKey;
        // Initialized from values: the caller supplied the key, if any.
        return undefined;
    }
    /**
   * Stops Statsig while the Feature Flag Service disables it: the client is shut down and no longer
   * called, so its keys get the wrapper's defaults. It is started again when re-enabled.
   */ stopStatsig() {
        this.statsigGeneration += 1;
        const statsigClient = this.statsigClient;
        this.statsigClient = undefined;
        this.user = undefined;
        if (statsigClient) Promise.resolve(statsigClient.shutdown()).catch((error)=>{
            // eslint-disable-next-line no-console
            console.warn('Failed to shut down the Statsig client', error);
        });
    }
    /**
   * This method updates the user for this client with the bootstrap values returned from a given
   * Promise.
   * It uses the customAttributes from fetching experiment values to update the Statsig user but
   * uses the customAttributes from given input to check if the user has changed.
   *
   * @param {Identifiers} identifiers
   * @param {CustomAttributes} customAttributes
   * @param {Promise<InitializeValues>} getInitializeValues
   * @private
   */ async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        this.assertReady();
        if (!this.initPromise) throw new Error('The client must be initialized before you can update the user.');
        // If the user isn't changing at all, then exit immediately
        if (this.isCurrentUser(identifiers, customAttributes)) return this.initPromise;
        // Wait for the current initialize/update to finish
        const originalInitPromise = this.initPromise;
        try {
            await this.initPromise;
        } catch (err) {
        // Proceed with the user update even if the init failed, since this update
        // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = this.updateClientsUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this
        // point. Any subsequent calls to await client.initialize() or client.updateUser()
        // will now also await this user update.
        this.initPromise = updateUserPromise.catch(async ()=>{
            // A failed update leaves the initialization result as it was.
            this.initPromise = originalInitPromise;
            // Once the values arrive the client switches to the new user, even if Statsig then fails to
            // update, so the provider keeps the new profile. Only a failed fetch reverts it.
            if (this.isCurrentUser(identifiers, customAttributes)) return;
            // Set the user profile again to revert back to the current user
            if (this.provider) await this.provider.setProfile(this.initOptions, this.currentIdentifiers, this.currentAttributes);
        });
        return updateUserPromise;
    }
    /**
   * This method updates the user on each provider's client, independently: FFP serves the new
   * user's values even if Statsig fails to update, and a provider disabled by the Feature Flag
   * Service is stopped (or, if it is enabled again, started).
   *
   * @param identifiers
   * @param customAttributes
   * @param initializeValuesPromise
   * @private
   */ async updateClientsUser(initializeValuesPromise, identifiers, customAttributes) {
        let initializeValues;
        try {
            initializeValues = await initializeValuesPromise;
        } catch (err) {
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will
            // already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            this.initOptions.updateUserCompletionCallback?.(false, errMsg);
            throw err;
        }
        const disabledProviders = initializeValues.disabledProviders ?? [];
        this.currentIdentifiers = identifiers;
        this.currentAttributes = customAttributes;
        this.ffp.apply(this.initOptions, disabledProviders.includes('ffp') ? undefined : initializeValues.ffp, identifiers, initializeValues.customAttributesFromFetch);
        let success = true;
        let errorMessage = null;
        try {
            await this.updateStatsigUser(initializeValues, identifiers, disabledProviders.includes('statsig'));
        } catch (err) {
            success = false;
            errorMessage = String(err);
        }
        this.initOptions?.updateUserCompletionCallback?.(success, errorMessage);
        this.subscriptions.anyUpdated();
        this.reportEvalFlagsStatus('updateUser', initializeValues.status);
        if (!success) throw new Error('Failed to update user. An unexpected error occured.');
    }
    /** Updates, starts or stops Statsig for a new user, as the Feature Flag Service directs. */ async updateStatsigUser(initializeValues, identifiers, disabled) {
        if (disabled) {
            this.stopStatsig();
            return;
        }
        // Let a start that is already in progress finish, then update the client it created.
        await this.statsigStart?.catch(()=>undefined);
        if (!this.statsigClient) {
            await this.restartStatsig(initializeValues, identifiers, initializeValues.customAttributesFromFetch);
            return;
        }
        const frontendUser = (0, $hHsjm.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
        this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
        this.user = (0, $jQSGj.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
        await this.statsigClient.updateUserAsync(this.user);
    }
    /**
   * Picks the one source that answers for a gate or config, so a key never reaches a client that
   * does not own it:
   * - FFP, for a key in its latest payload. A local override for such a key is applied here
   *   instead, because Statsig must not be called for it.
   * - Statsig, for every other key while it is enabled. It applies local overrides itself.
   * - Otherwise a local override, or the wrapper's default.
   */ route(name, kind) {
        const servedByFfp = this.ffp.has(name);
        if (!servedByFfp && this.statsigClient) return {
            source: 'statsig',
            statsigClient: this.statsigClient
        };
        const override = this.overrideAdapter.getOverride(kind, name);
        if (override !== undefined) return {
            source: 'override',
            value: override
        };
        return {
            source: servedByFfp ? 'ffp' : 'default'
        };
    }
    /**
   * Throws until values have been applied by an initialize method. Statsig may legitimately be
   * absent afterwards, when the Feature Flag Service disables it.
   */ assertReady() {
        if (!this.valuesApplied) throw new Error('Client must be initialized before using this method');
    }
    /**
   * Call this if modifying the values being served by the Statsig library since it has its own
   * memoization cache which will not be updated if the values are changed outside of the library.
   */ statsigValuesUpdated = ()=>{
        if (this.user) // Trigger a reset of the memoize cache
        this.statsigClient?.updateUserSync(this.user, {
            disableBackgroundCacheRefresh: true
        });
        this.subscriptions.anyUpdated();
    };
    /**
   * @returns string version of the current package in semver style.
   */ getPackageVersion() {
        return 0, $4d6dI.CLIENT_VERSION;
    }
    /**
   * Returns the `targetApp` value that was provided during client initialization.
   * This identifies the product/app context (e.g., `'confluence_web'`, `'jira_web'`).
   *
   * Returns `undefined` if `initialize` has never been called.
   *
   * @returns The targetApp string, or undefined if initialize has never been called.
   */ getTargetApp() {
        return this.initOptions?.targetApp;
    }
    /**
   * Returns a specified layer otherwise returns an empty layer as a default value if the layer doesn't exist.
   *
   * Layers exist only in Statsig. Flags that only exist in the Feature Flag Platform (FFP) are read
   * with {@link Client.ffpClient}.
   *
   * @param {string} layerName - The name of the layer
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns A layer
   * @example
   * ```ts
   * const layer = client.getLayer('example-layer-name');
   * const exampletitle: string = layer.get("title", "Welcome to Statsig!");
   * ```
   */ getLayer(/** The name of the layer */ layerName, options = {}) {
        try {
            this.assertReady();
            const { fireLayerExposure: fireLayerExposure = true } = options;
            if (!this.statsigClient) {
                // Layers are Statsig-only, so without Statsig only an override can serve one.
                const layer = (0, $1T45w._makeLayer)(layerName, {
                    reason: 'Unrecognized'
                }, null);
                return (0, $kIeaF.Layer).fromLayer(this.overrideAdapter.getLayerOverride(layer, {}) ?? layer);
            }
            return (0, $kIeaF.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                disableExposureLog: !fireLayerExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    error: error
                });
                this.hasGetLayerErrorOccurred = true;
            }
            // Return a default value
            return (0, $kIeaF.Layer).fromLayer((0, $1T45w._makeLayer)(layerName, {
                reason: 'Error'
            }, null));
        }
    }
    /**
   * Returns the value of a given parameter in a layer config.
   *
   * Layers exist only in Statsig. Flags that only exist in the Feature Flag Platform (FFP) are read
   * with {@link Client.ffpClient}.
   *
   * @template T
   * @param {string} layerName - The name of the layer
   * @param {string} parameterName - The name of the parameter to fetch from the layer config
   * @param {T} defaultValue - The value to serve if the layer or parameter do not exist, or if the
   * returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
   * @returns The value of the parameter if the layer and parameter both exist, otherwise the default value.
   * @example
   * ``` ts
   * type ValidColor = 'blue' | 'red' | 'yellow';
   * type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
   *
   * const isValidColor: ValidColorTypeCheck =
   *    (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
   *
   * const buttonColor: ValidColor = client.getLayerValue(
   *    'example-layer-name',
   *    'backgroundColor',
   *    'yellow',
   *    {
   *        typeGuard: isValidColor
   *    }
   * );
   * ```
   */ getLayerValue(layerName, parameterName, defaultValue, options = {}) {
        const layer = this.getLayer(layerName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return layer.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetLayerValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
}

});
parcelRegister("1T45w", function(module, exports) {
"use strict";
var $15fe194a98569649$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $15fe194a98569649$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $15fe194a98569649$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $jCry9 = parcelRequire("jCry9");
module.exports.StatsigClient = $jCry9.default;

$15fe194a98569649$var$__exportStar((parcelRequire("49Dnu")), module.exports);
const $15fe194a98569649$var$__STATSIG__ = Object.assign((0, (parcelRequire("49Dnu"))._getStatsigGlobal)(), {
    StatsigClient: $jCry9.default
});
module.exports.default = $15fe194a98569649$var$__STATSIG__;

});
parcelRegister("49Dnu", function(module, exports) {
"use strict";
var $30668c514f90d554$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $30668c514f90d554$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $30668c514f90d554$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("dlLC5")).Diagnostics;
    }
});

var $4CA2n = parcelRequire("4CA2n");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $4CA2n.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("eIUhW")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("kf7uu")).Storage;
    }
});

$30668c514f90d554$var$__exportStar((parcelRequire("ge5Q0")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("gQAqt")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("gMEdt")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("6yXjF")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("dlLC5")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("eY3Ok")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("8AmNf")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("jIYlr")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("1zMX2")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("gJOcU")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("84MPJ")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("eIUhW")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("l2wIj")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("4NRde")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("dskBU")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("7Q0Y4")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("39Oab")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("3NmQX")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("fdSDn")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("cZ6kH")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("9LSa2")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("4TgO5")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("7jKOl")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("46jth")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("46Eic")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("bhhEl")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("1JtKM")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("5D3EU")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("ipkFC")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("jE84N")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("anXRC")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("4qBGS")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("kf7uu")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("RzrOC")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("h0RPa")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("jglHZ")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("6ULMU")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("21ucb")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("7N1Ma")), module.exports);

$30668c514f90d554$var$__exportStar((parcelRequire("b3IPY")), module.exports);
Object.assign((0, (parcelRequire("ge5Q0"))._getStatsigGlobal)(), {
    Log: (parcelRequire("eIUhW")).Log,
    SDK_VERSION: (parcelRequire("1JtKM")).SDK_VERSION
});

});
parcelRegister("ge5Q0", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $bd027b6447a8f66d$var$_a, $bd027b6447a8f66d$var$_b, $bd027b6447a8f66d$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $eIUhW = parcelRequire("eIUhW");
const $bd027b6447a8f66d$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $bd027b6447a8f66d$var$statsigGlobal;
    } catch (e) {
        return $bd027b6447a8f66d$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $bd027b6447a8f66d$var$_getStatsigGlobal;
const $bd027b6447a8f66d$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $bd027b6447a8f66d$var$_getStatsigGlobalFlag;
const $bd027b6447a8f66d$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $eIUhW.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $bd027b6447a8f66d$var$_getInstance;
const $bd027b6447a8f66d$var$GLOBAL_KEY = '__STATSIG__';
const $bd027b6447a8f66d$var$_window = typeof window !== 'undefined' ? window : {};
const $bd027b6447a8f66d$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $bd027b6447a8f66d$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $bd027b6447a8f66d$var$statsigGlobal = ($bd027b6447a8f66d$var$_c = ($bd027b6447a8f66d$var$_b = ($bd027b6447a8f66d$var$_a = $bd027b6447a8f66d$var$_window[$bd027b6447a8f66d$var$GLOBAL_KEY]) !== null && $bd027b6447a8f66d$var$_a !== void 0 ? $bd027b6447a8f66d$var$_a : $bd027b6447a8f66d$var$_global[$bd027b6447a8f66d$var$GLOBAL_KEY]) !== null && $bd027b6447a8f66d$var$_b !== void 0 ? $bd027b6447a8f66d$var$_b : $bd027b6447a8f66d$var$_globalThis[$bd027b6447a8f66d$var$GLOBAL_KEY]) !== null && $bd027b6447a8f66d$var$_c !== void 0 ? $bd027b6447a8f66d$var$_c : {
    instance: module.exports._getInstance
};
$bd027b6447a8f66d$var$_window[$bd027b6447a8f66d$var$GLOBAL_KEY] = $bd027b6447a8f66d$var$statsigGlobal;
$bd027b6447a8f66d$var$_global[$bd027b6447a8f66d$var$GLOBAL_KEY] = $bd027b6447a8f66d$var$statsigGlobal;
$bd027b6447a8f66d$var$_globalThis[$bd027b6447a8f66d$var$GLOBAL_KEY] = $bd027b6447a8f66d$var$statsigGlobal;

});
parcelRegister("eIUhW", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $ab80d676264066c9$var$DEBUG = ' DEBUG ';
const $ab80d676264066c9$var$_INFO = '  INFO ';
const $ab80d676264066c9$var$_WARN = '  WARN ';
const $ab80d676264066c9$var$ERROR = ' ERROR ';
function $ab80d676264066c9$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $ab80d676264066c9$var$Log {
    static info(...args) {
        if ($ab80d676264066c9$var$Log.level >= module.exports.LogLevel.Info) console.info($ab80d676264066c9$var$_INFO, ...$ab80d676264066c9$var$addTag(args));
    }
    static debug(...args) {
        if ($ab80d676264066c9$var$Log.level >= module.exports.LogLevel.Debug) console.debug($ab80d676264066c9$var$DEBUG, ...$ab80d676264066c9$var$addTag(args));
    }
    static warn(...args) {
        if ($ab80d676264066c9$var$Log.level >= module.exports.LogLevel.Warn) console.warn($ab80d676264066c9$var$_WARN, ...$ab80d676264066c9$var$addTag(args));
    }
    static error(...args) {
        if ($ab80d676264066c9$var$Log.level >= module.exports.LogLevel.Error) console.error($ab80d676264066c9$var$ERROR, ...$ab80d676264066c9$var$addTag(args));
    }
}
module.exports.Log = $ab80d676264066c9$var$Log;
$ab80d676264066c9$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("dlLC5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $9b822b8692b18229$var$MARKER_MAP = new Map();
const $9b822b8692b18229$var$ACT_START = 'start';
const $9b822b8692b18229$var$ACT_END = 'end';
const $9b822b8692b18229$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $9b822b8692b18229$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $9b822b8692b18229$var$_addMarker(sdkKey, $9b822b8692b18229$var$_createMarker({}, $9b822b8692b18229$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $9b822b8692b18229$var$_addMarker(sdkKey, $9b822b8692b18229$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $9b822b8692b18229$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $9b822b8692b18229$var$_addMarker(sdkKey, $9b822b8692b18229$var$_createMarker(data, $9b822b8692b18229$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $9b822b8692b18229$var$_addMarker(sdkKey, $9b822b8692b18229$var$_createMarker(data, $9b822b8692b18229$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $9b822b8692b18229$var$_addMarker(sdkKey, $9b822b8692b18229$var$_createMarker({}, $9b822b8692b18229$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $9b822b8692b18229$var$_addMarker(sdkKey, $9b822b8692b18229$var$_createMarker(data, $9b822b8692b18229$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $9b822b8692b18229$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $9b822b8692b18229$var$_safeGetField(e, 'code'),
            name: $9b822b8692b18229$var$_safeGetField(e, 'name'),
            message: $9b822b8692b18229$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $9b822b8692b18229$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $9b822b8692b18229$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $9b822b8692b18229$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $9b822b8692b18229$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $9b822b8692b18229$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $9b822b8692b18229$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $9b822b8692b18229$var$MARKER_MAP.set(sdkKey, markers);
}
function $9b822b8692b18229$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("4CA2n", function(module, exports) {
"use strict";
var $35d6aa4b60253a18$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $gQAqt = parcelRequire("gQAqt");

var $gJOcU = parcelRequire("gJOcU");

var $eIUhW = parcelRequire("eIUhW");

var $4NRde = parcelRequire("4NRde");

var $3NmQX = parcelRequire("3NmQX");

var $bhhEl = parcelRequire("bhhEl");

var $5D3EU = parcelRequire("5D3EU");

var $kf7uu = parcelRequire("kf7uu");

var $jglHZ = parcelRequire("jglHZ");

var $21ucb = parcelRequire("21ucb");
const $35d6aa4b60253a18$var$DEFAULT_QUEUE_SIZE = 100;
const $35d6aa4b60253a18$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $35d6aa4b60253a18$var$MAX_DEDUPER_KEYS = 1000;
const $35d6aa4b60253a18$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $35d6aa4b60253a18$var$MAX_FAILED_LOGS = 500;
const $35d6aa4b60253a18$var$QUICK_FLUSH_WINDOW_MS = 200;
const $35d6aa4b60253a18$var$EVENT_LOGGER_MAP = {};
class $35d6aa4b60253a18$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $35d6aa4b60253a18$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $35d6aa4b60253a18$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs();
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $5D3EU.LoggingEnabledOption.disabled : $5D3EU.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $eIUhW.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $35d6aa4b60253a18$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $jglHZ.UrlConfiguration($4NRde.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        if (this._loggingEnabled === 'disabled' && loggingEnabled !== 'disabled') {
            // load any pre consented events into memory
            const storageKey = this._getStorageKey();
            const events = (0, $kf7uu._getObjectFromStorage)(storageKey);
            if (events) this._queue.push(...events);
            $kf7uu.Storage.removeItem(storageKey);
        }
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $35d6aa4b60253a18$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $3NmQX._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $35d6aa4b60253a18$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $21ucb._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $35d6aa4b60253a18$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $35d6aa4b60253a18$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs();
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $35d6aa4b60253a18$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $35d6aa4b60253a18$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $35d6aa4b60253a18$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $35d6aa4b60253a18$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$35d6aa4b60253a18$var$EventLogger._safeFlushAndForget(this._sdkKey), $35d6aa4b60253a18$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $3NmQX._isServerEnv)()) return false;
        if (!(0, $bhhEl._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $gQAqt._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $35d6aa4b60253a18$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $35d6aa4b60253a18$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $35d6aa4b60253a18$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $21ucb._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $eIUhW.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $eIUhW.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $35d6aa4b60253a18$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$4NRde.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        // Products opt into this patch through their own rollout controls.
        const boundFailedLogs = typeof window !== 'undefined' && window.__USE_STATSIG_PATCH__ === true;
        if (!boundFailedLogs) while(events.length > $35d6aa4b60253a18$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            const savedEvents = this._getFailedLogsFromStorage(storageKey);
            // Bound the total retry queue only when the product opts in.
            // https://github.com/statsig-io/js-client-monorepo/issues/39
            const combined = [
                ...savedEvents,
                ...events
            ];
            if (boundFailedLogs && combined.length > 100) combined.splice(0, combined.length - 100);
            (0, $kf7uu._setObjectInStorage)(storageKey, combined);
        } catch (_a) {
            $eIUhW.Log.warn('Unable to save failed logs to storage');
        }
    }
    _getFailedLogsFromStorage(storageKey) {
        let savedEvents = [];
        try {
            const retrieved = (0, $kf7uu._getObjectFromStorage)(storageKey);
            if (Array.isArray(retrieved)) savedEvents = retrieved;
            return savedEvents;
        } catch (_a) {
            return [];
        }
    }
    _retryFailedLogs() {
        const storageKey = this._getStorageKey();
        (()=>$35d6aa4b60253a18$var$__awaiter(this, void 0, void 0, function*() {
                if (!$kf7uu.Storage.isReady()) yield $kf7uu.Storage.isReadyResolver();
                const events = (0, $kf7uu._getObjectFromStorage)(storageKey);
                if (!events) return;
                $kf7uu.Storage.removeItem(storageKey);
                yield this._sendEvents(events);
            }))().catch(()=>{
            $eIUhW.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $gJOcU._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $eIUhW.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $3NmQX._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $35d6aa4b60253a18$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $35d6aa4b60253a18$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $35d6aa4b60253a18$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $35d6aa4b60253a18$var$EventLogger;

});
parcelRegister("gQAqt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $gJOcU = parcelRequire("gJOcU");
function $c43dc21f20ea933f$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $gJOcU._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $c43dc21f20ea933f$var$_getUserStorageKey;
function $c43dc21f20ea933f$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $c43dc21f20ea933f$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $gJOcU._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $c43dc21f20ea933f$var$_getStorageKey;

});
parcelRegister("gJOcU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $h0RPa = parcelRequire("h0RPa");
const $c2f7cb67581a275d$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $c2f7cb67581a275d$var$_DJB2;
const $c2f7cb67581a275d$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $c2f7cb67581a275d$var$_DJB2Object;
const $c2f7cb67581a275d$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $h0RPa._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $c2f7cb67581a275d$var$_getSortedObject;

});
parcelRegister("h0RPa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $c62c301f927e3283$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $c62c301f927e3283$var$_typeOf;
function $c62c301f927e3283$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $c62c301f927e3283$var$_isTypeMatch;

});



parcelRegister("4NRde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("3NmQX", function(module, exports) {

var $k1Wvt = parcelRequire("k1Wvt");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $2c37acdc22b09f9b$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $2c37acdc22b09f9b$var$_getWindowSafe;
const $2c37acdc22b09f9b$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $2c37acdc22b09f9b$var$_getDocumentSafe;
const $2c37acdc22b09f9b$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $k1Wvt !== 'undefined' && $k1Wvt.versions != null && $k1Wvt.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $2c37acdc22b09f9b$var$_isServerEnv;
const $2c37acdc22b09f9b$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $2c37acdc22b09f9b$var$_addWindowEventListenerSafe;
const $2c37acdc22b09f9b$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $2c37acdc22b09f9b$var$_addDocumentEventListenerSafe;
const $2c37acdc22b09f9b$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $2c37acdc22b09f9b$var$_getCurrentPageUrlSafe;
const $2c37acdc22b09f9b$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $2c37acdc22b09f9b$var$_getUnloadEvent;

});
parcelRegister("k1Wvt", function(module, exports) {
// shim for using process in browser
var $e95148d6a2d48abe$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $e95148d6a2d48abe$var$cachedSetTimeout;
var $e95148d6a2d48abe$var$cachedClearTimeout;
function $e95148d6a2d48abe$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $e95148d6a2d48abe$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $e95148d6a2d48abe$var$cachedSetTimeout = setTimeout;
        else $e95148d6a2d48abe$var$cachedSetTimeout = $e95148d6a2d48abe$var$defaultSetTimout;
    } catch (e) {
        $e95148d6a2d48abe$var$cachedSetTimeout = $e95148d6a2d48abe$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $e95148d6a2d48abe$var$cachedClearTimeout = clearTimeout;
        else $e95148d6a2d48abe$var$cachedClearTimeout = $e95148d6a2d48abe$var$defaultClearTimeout;
    } catch (e) {
        $e95148d6a2d48abe$var$cachedClearTimeout = $e95148d6a2d48abe$var$defaultClearTimeout;
    }
})();
function $e95148d6a2d48abe$var$runTimeout(fun) {
    if ($e95148d6a2d48abe$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($e95148d6a2d48abe$var$cachedSetTimeout === $e95148d6a2d48abe$var$defaultSetTimout || !$e95148d6a2d48abe$var$cachedSetTimeout) && setTimeout) {
        $e95148d6a2d48abe$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e95148d6a2d48abe$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $e95148d6a2d48abe$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $e95148d6a2d48abe$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $e95148d6a2d48abe$var$runClearTimeout(marker) {
    if ($e95148d6a2d48abe$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($e95148d6a2d48abe$var$cachedClearTimeout === $e95148d6a2d48abe$var$defaultClearTimeout || !$e95148d6a2d48abe$var$cachedClearTimeout) && clearTimeout) {
        $e95148d6a2d48abe$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e95148d6a2d48abe$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $e95148d6a2d48abe$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $e95148d6a2d48abe$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $e95148d6a2d48abe$var$queue = [];
var $e95148d6a2d48abe$var$draining = false;
var $e95148d6a2d48abe$var$currentQueue;
var $e95148d6a2d48abe$var$queueIndex = -1;
function $e95148d6a2d48abe$var$cleanUpNextTick() {
    if (!$e95148d6a2d48abe$var$draining || !$e95148d6a2d48abe$var$currentQueue) return;
    $e95148d6a2d48abe$var$draining = false;
    if ($e95148d6a2d48abe$var$currentQueue.length) $e95148d6a2d48abe$var$queue = $e95148d6a2d48abe$var$currentQueue.concat($e95148d6a2d48abe$var$queue);
    else $e95148d6a2d48abe$var$queueIndex = -1;
    if ($e95148d6a2d48abe$var$queue.length) $e95148d6a2d48abe$var$drainQueue();
}
function $e95148d6a2d48abe$var$drainQueue() {
    if ($e95148d6a2d48abe$var$draining) return;
    var timeout = $e95148d6a2d48abe$var$runTimeout($e95148d6a2d48abe$var$cleanUpNextTick);
    $e95148d6a2d48abe$var$draining = true;
    var len = $e95148d6a2d48abe$var$queue.length;
    while(len){
        $e95148d6a2d48abe$var$currentQueue = $e95148d6a2d48abe$var$queue;
        $e95148d6a2d48abe$var$queue = [];
        while(++$e95148d6a2d48abe$var$queueIndex < len)if ($e95148d6a2d48abe$var$currentQueue) $e95148d6a2d48abe$var$currentQueue[$e95148d6a2d48abe$var$queueIndex].run();
        $e95148d6a2d48abe$var$queueIndex = -1;
        len = $e95148d6a2d48abe$var$queue.length;
    }
    $e95148d6a2d48abe$var$currentQueue = null;
    $e95148d6a2d48abe$var$draining = false;
    $e95148d6a2d48abe$var$runClearTimeout(timeout);
}
$e95148d6a2d48abe$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $e95148d6a2d48abe$var$queue.push(new $e95148d6a2d48abe$var$Item(fun, args));
    if ($e95148d6a2d48abe$var$queue.length === 1 && !$e95148d6a2d48abe$var$draining) $e95148d6a2d48abe$var$runTimeout($e95148d6a2d48abe$var$drainQueue);
};
// v8 likes predictible objects
function $e95148d6a2d48abe$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$e95148d6a2d48abe$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$e95148d6a2d48abe$var$process.title = 'browser';
$e95148d6a2d48abe$var$process.browser = true;
$e95148d6a2d48abe$var$process.env = {};
$e95148d6a2d48abe$var$process.argv = [];
$e95148d6a2d48abe$var$process.version = ''; // empty string to avoid regexp issues
$e95148d6a2d48abe$var$process.versions = {};
function $e95148d6a2d48abe$var$noop() {}
$e95148d6a2d48abe$var$process.on = $e95148d6a2d48abe$var$noop;
$e95148d6a2d48abe$var$process.addListener = $e95148d6a2d48abe$var$noop;
$e95148d6a2d48abe$var$process.once = $e95148d6a2d48abe$var$noop;
$e95148d6a2d48abe$var$process.off = $e95148d6a2d48abe$var$noop;
$e95148d6a2d48abe$var$process.removeListener = $e95148d6a2d48abe$var$noop;
$e95148d6a2d48abe$var$process.removeAllListeners = $e95148d6a2d48abe$var$noop;
$e95148d6a2d48abe$var$process.emit = $e95148d6a2d48abe$var$noop;
$e95148d6a2d48abe$var$process.prependListener = $e95148d6a2d48abe$var$noop;
$e95148d6a2d48abe$var$process.prependOnceListener = $e95148d6a2d48abe$var$noop;
$e95148d6a2d48abe$var$process.listeners = function(name) {
    return [];
};
$e95148d6a2d48abe$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$e95148d6a2d48abe$var$process.cwd = function() {
    return '/';
};
$e95148d6a2d48abe$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$e95148d6a2d48abe$var$process.umask = function() {
    return 0;
};

});


parcelRegister("bhhEl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $835ef9220bfb399c$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $835ef9220bfb399c$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $835ef9220bfb399c$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $835ef9220bfb399c$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $835ef9220bfb399c$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $835ef9220bfb399c$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $835ef9220bfb399c$var$GATE_EXPOSURE_NAME || eventName === $835ef9220bfb399c$var$CONFIG_EXPOSURE_NAME || eventName === $835ef9220bfb399c$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $835ef9220bfb399c$var$_isExposureEvent;
const $835ef9220bfb399c$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $835ef9220bfb399c$var$_createExposure($835ef9220bfb399c$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $835ef9220bfb399c$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $835ef9220bfb399c$var$_createGateExposure;
function $835ef9220bfb399c$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $835ef9220bfb399c$var$_mapExposures;
const $835ef9220bfb399c$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $835ef9220bfb399c$var$_createExposure($835ef9220bfb399c$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $835ef9220bfb399c$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $835ef9220bfb399c$var$_createConfigExposure;
const $835ef9220bfb399c$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $835ef9220bfb399c$var$_createExposure($835ef9220bfb399c$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $835ef9220bfb399c$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $835ef9220bfb399c$var$_createLayerParameterExposure;
const $835ef9220bfb399c$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("5D3EU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("kf7uu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $eIUhW = parcelRequire("eIUhW");

var $3NmQX = parcelRequire("3NmQX");
const $ebcb04e5ffd9f73c$var$inMemoryStore = {};
const $ebcb04e5ffd9f73c$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$ebcb04e5ffd9f73c$var$inMemoryStore[key] ? $ebcb04e5ffd9f73c$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $ebcb04e5ffd9f73c$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $ebcb04e5ffd9f73c$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($ebcb04e5ffd9f73c$var$inMemoryStore)
};
let $ebcb04e5ffd9f73c$var$_localStorageProvider = null;
try {
    const win = (0, $3NmQX._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $ebcb04e5ffd9f73c$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $eIUhW.Log.warn('Failed to setup localStorageProvider.');
}
let $ebcb04e5ffd9f73c$var$_main = $ebcb04e5ffd9f73c$var$_localStorageProvider !== null && $ebcb04e5ffd9f73c$var$_localStorageProvider !== void 0 ? $ebcb04e5ffd9f73c$var$_localStorageProvider : $ebcb04e5ffd9f73c$var$_inMemoryProvider;
let $ebcb04e5ffd9f73c$var$_current = $ebcb04e5ffd9f73c$var$_main;
function $ebcb04e5ffd9f73c$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($ebcb04e5ffd9f73c$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$ebcb04e5ffd9f73c$var$_current.isReady(),
    isReadyResolver: ()=>$ebcb04e5ffd9f73c$var$_current.isReadyResolver(),
    getProviderName: ()=>$ebcb04e5ffd9f73c$var$_current.getProviderName(),
    getItem: (key)=>$ebcb04e5ffd9f73c$var$_inMemoryBreaker(()=>$ebcb04e5ffd9f73c$var$_current.getItem(key)),
    setItem: (key, value)=>$ebcb04e5ffd9f73c$var$_inMemoryBreaker(()=>$ebcb04e5ffd9f73c$var$_current.setItem(key, value)),
    removeItem: (key)=>$ebcb04e5ffd9f73c$var$_current.removeItem(key),
    getAllKeys: ()=>$ebcb04e5ffd9f73c$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $ebcb04e5ffd9f73c$var$_main = newProvider;
        $ebcb04e5ffd9f73c$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $ebcb04e5ffd9f73c$var$_current = $ebcb04e5ffd9f73c$var$_inMemoryProvider;
        else $ebcb04e5ffd9f73c$var$_current = $ebcb04e5ffd9f73c$var$_main;
    }
};
function $ebcb04e5ffd9f73c$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : 'null');
    } catch (e) {
        $eIUhW.Log.error(`Failed to parse value for key "${key}"`);
        return null;
    }
}
module.exports._getObjectFromStorage = $ebcb04e5ffd9f73c$var$_getObjectFromStorage;
function $ebcb04e5ffd9f73c$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $ebcb04e5ffd9f73c$var$_setObjectInStorage;

});

parcelRegister("jglHZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $gJOcU = parcelRequire("gJOcU");

var $4NRde = parcelRequire("4NRde");
const $e06059cb188639a0$var$ENDPOINT_DNS_KEY_MAP = {
    [$4NRde.Endpoint._initialize]: 'i',
    [$4NRde.Endpoint._rgstr]: 'e',
    [$4NRde.Endpoint._download_config_specs]: 'd'
};
class $e06059cb188639a0$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $e06059cb188639a0$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $4NRde.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $gJOcU._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $e06059cb188639a0$var$UrlConfiguration;

});

parcelRegister("21ucb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $3NmQX = parcelRequire("3NmQX");
const $179318fcf1eb5c3d$var$FOREGROUND = 'foreground';
const $179318fcf1eb5c3d$var$BACKGROUND = 'background';
const $179318fcf1eb5c3d$var$LISTENERS = [];
let $179318fcf1eb5c3d$var$current = $179318fcf1eb5c3d$var$FOREGROUND;
let $179318fcf1eb5c3d$var$isUnloading = false;
const $179318fcf1eb5c3d$var$_isCurrentlyVisible = ()=>{
    return $179318fcf1eb5c3d$var$current === $179318fcf1eb5c3d$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $179318fcf1eb5c3d$var$_isCurrentlyVisible;
const $179318fcf1eb5c3d$var$_isUnloading = ()=>$179318fcf1eb5c3d$var$isUnloading;
module.exports._isUnloading = $179318fcf1eb5c3d$var$_isUnloading;
const $179318fcf1eb5c3d$var$_subscribeToVisiblityChanged = (listener)=>{
    $179318fcf1eb5c3d$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $179318fcf1eb5c3d$var$_subscribeToVisiblityChanged;
const $179318fcf1eb5c3d$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $179318fcf1eb5c3d$var$current) return;
    $179318fcf1eb5c3d$var$current = visibility;
    $179318fcf1eb5c3d$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $179318fcf1eb5c3d$var$_notifyVisibilityChanged;
(0, $3NmQX._addWindowEventListenerSafe)('focus', ()=>{
    $179318fcf1eb5c3d$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($179318fcf1eb5c3d$var$FOREGROUND);
});
(0, $3NmQX._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($179318fcf1eb5c3d$var$BACKGROUND));
(0, $3NmQX._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $179318fcf1eb5c3d$var$FOREGROUND : $179318fcf1eb5c3d$var$BACKGROUND);
});
(0, $3NmQX._addWindowEventListenerSafe)((0, $3NmQX._getUnloadEvent)(), ()=>{
    $179318fcf1eb5c3d$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($179318fcf1eb5c3d$var$BACKGROUND);
});

});


parcelRegister("1JtKM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.30.2';
let $143112de3ba9f699$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$143112de3ba9f699$var$metadata,
    add: (additions)=>{
        $143112de3ba9f699$var$metadata = Object.assign(Object.assign({}, $143112de3ba9f699$var$metadata), additions);
    }
};

});

parcelRegister("gMEdt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6yXjF", function(module, exports) {
"use strict";
var $4c73ee05cee48c47$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $eIUhW = parcelRequire("eIUhW");

var $4TgO5 = parcelRequire("4TgO5");

var $4qBGS = parcelRequire("4qBGS");

var $kf7uu = parcelRequire("kf7uu");

var $RzrOC = parcelRequire("RzrOC");
const $4c73ee05cee48c47$var$CACHE_LIMIT = 10;
const $4c73ee05cee48c47$var$MAX_CACHE_WRITE_ATTEMPTS = 8;
class $4c73ee05cee48c47$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = $4c73ee05cee48c47$var$CACHE_LIMIT;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $4c73ee05cee48c47$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $4qBGS._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $4qBGS._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $4c73ee05cee48c47$var$_makeDataAdapterResult('Bootstrap', data, null, normalized), this._cacheLimit);
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $4TgO5.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $4c73ee05cee48c47$var$__awaiter(this, void 0, void 0, function*() {
            if (!$kf7uu.Storage.isReady()) yield $kf7uu.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $eIUhW.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $4c73ee05cee48c47$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $4qBGS._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }), this._cacheLimit);
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $4c73ee05cee48c47$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $eIUhW.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $RzrOC._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $4TgO5.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $4c73ee05cee48c47$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $4c73ee05cee48c47$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $eIUhW.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $kf7uu.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($kf7uu.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $RzrOC._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        const resultString = JSON.stringify(result);
        for(let i = 0; i < $4c73ee05cee48c47$var$MAX_CACHE_WRITE_ATTEMPTS; i++)try {
            $kf7uu.Storage.setItem(cacheKey, resultString);
            break;
        } catch (error) {
            if (!(error instanceof Error) || !(error.toString().includes('QuotaExceededError') || error.toString().includes('QUOTA_EXCEEDED_ERR')) || this._cacheLimit <= 1) throw error;
            this._cacheLimit = Math.ceil(this._cacheLimit / 2);
            this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
        }
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey, cacheLimit = this._cacheLimit) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $kf7uu._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictableKeys = $4c73ee05cee48c47$var$_getEvictableKeys(lastModifiedTimeMap, cacheLimit);
        for (const evictable of evictableKeys){
            delete lastModifiedTimeMap[evictable];
            $kf7uu.Storage.removeItem(evictable);
        }
        (0, $kf7uu._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $4c73ee05cee48c47$var$DataAdapterCore;
function $4c73ee05cee48c47$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $4qBGS._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $4c73ee05cee48c47$var$_makeDataAdapterResult;
class $4c73ee05cee48c47$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $eIUhW.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value, cacheLimit) {
        const evictableKeys = $4c73ee05cee48c47$var$_getEvictableKeys(this._data, cacheLimit - 1);
        for (const evictable of evictableKeys)delete this._data[evictable];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $4c73ee05cee48c47$var$_getEvictableKeys(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort((keyA, keyB)=>{
        const valueA = data[keyA];
        const valueB = data[keyB];
        if (typeof valueA === 'object' && typeof valueB === 'object') return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

});
parcelRegister("4TgO5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCookieName = module.exports.StableID = void 0;

var $gQAqt = parcelRequire("gQAqt");

var $eIUhW = parcelRequire("eIUhW");

var $3NmQX = parcelRequire("3NmQX");

var $kf7uu = parcelRequire("kf7uu");

var $6ULMU = parcelRequire("6ULMU");
const $38f955f33f5880aa$var$PROMISE_MAP = {};
const $38f955f33f5880aa$var$COOKIE_ENABLED_MAP = {};
const $38f955f33f5880aa$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($38f955f33f5880aa$var$DISABLED_MAP[sdkKey]) return null;
        if ($38f955f33f5880aa$var$PROMISE_MAP[sdkKey] != null) return $38f955f33f5880aa$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $38f955f33f5880aa$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $38f955f33f5880aa$var$PROMISE_MAP[sdkKey] = stableID;
            $38f955f33f5880aa$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $38f955f33f5880aa$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $6ULMU.getUUID)();
        $38f955f33f5880aa$var$_persistToStorage(stableID, sdkKey);
        $38f955f33f5880aa$var$_persistToCookie(stableID, sdkKey);
        $38f955f33f5880aa$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $38f955f33f5880aa$var$PROMISE_MAP[sdkKey] = override;
        $38f955f33f5880aa$var$_persistToStorage(override, sdkKey);
        $38f955f33f5880aa$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $38f955f33f5880aa$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $38f955f33f5880aa$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $38f955f33f5880aa$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $gQAqt._getStorageKey)(sdkKey)}`;
}
function $38f955f33f5880aa$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $38f955f33f5880aa$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $kf7uu._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $eIUhW.Log.warn('Failed to save StableID to storage');
    }
}
function $38f955f33f5880aa$var$_loadFromStorage(sdkKey) {
    const storageKey = $38f955f33f5880aa$var$_getStableIDStorageKey(sdkKey);
    return (0, $kf7uu._getObjectFromStorage)(storageKey);
}
function $38f955f33f5880aa$var$_loadFromCookie(sdkKey) {
    if (!$38f955f33f5880aa$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $3NmQX._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $38f955f33f5880aa$var$getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $38f955f33f5880aa$var$_persistToCookie(stableID, sdkKey) {
    if (!$38f955f33f5880aa$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $3NmQX._getDocumentSafe)() == null) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$38f955f33f5880aa$var$getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $38f955f33f5880aa$var$getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $gQAqt._getStorageKey)(sdkKey)}`;
}
module.exports.getCookieName = $38f955f33f5880aa$var$getCookieName;

});
parcelRegister("6ULMU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $508d0abbed982e19$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $508d0abbed982e19$var$getUUID;

});


parcelRegister("4qBGS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $gJOcU = parcelRequire("gJOcU");

var $eIUhW = parcelRequire("eIUhW");
function $3396d3ab5fe99a49$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $eIUhW.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $3396d3ab5fe99a49$var$_normalizeUser;
function $3396d3ab5fe99a49$var$_getFullUserHash(user) {
    return user ? (0, $gJOcU._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $3396d3ab5fe99a49$var$_getFullUserHash;

});

parcelRegister("RzrOC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $eIUhW = parcelRequire("eIUhW");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $0a1072837f60f5e9$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $eIUhW.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $0a1072837f60f5e9$var$_typedJsonParse;

});


parcelRegister("eY3Ok", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8AmNf", function(module, exports) {
"use strict";
var $64035dcb506143c7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $eIUhW = parcelRequire("eIUhW");

var $fdSDn = parcelRequire("fdSDn");

var $1JtKM = parcelRequire("1JtKM");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $64035dcb506143c7$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $64035dcb506143c7$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $64035dcb506143c7$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $64035dcb506143c7$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $eIUhW.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$64035dcb506143c7$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($64035dcb506143c7$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $64035dcb506143c7$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $fdSDn.SDKType._get(this._sdkKey);
                    const statsigMetadata = $1JtKM.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $64035dcb506143c7$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $64035dcb506143c7$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $64035dcb506143c7$var$ErrorBoundary;
function $64035dcb506143c7$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $64035dcb506143c7$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $64035dcb506143c7$var$UNKNOWN_ERROR;
    }
}
function $64035dcb506143c7$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $64035dcb506143c7$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.keys(options).forEach((key)=>{
        const option = key;
        const value = options[option];
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("fdSDn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $b152731e92464821$var$SDK_CLIENT = {};
let $b152731e92464821$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $b152731e92464821$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($b152731e92464821$var$suffix !== null && $b152731e92464821$var$suffix !== void 0 ? $b152731e92464821$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $b152731e92464821$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$b152731e92464821$var$suffix || $b152731e92464821$var$suffix === '-react') $b152731e92464821$var$suffix = '-' + binding;
    }
};

});


parcelRegister("jIYlr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1zMX2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("84MPJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("l2wIj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $f5132924e603febc$var$EXIST_KEYS = new Set([]);
const $f5132924e603febc$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $f5132924e603febc$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($f5132924e603febc$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($f5132924e603febc$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $f5132924e603febc$var$createMemoKey;

});

parcelRegister("dskBU", function(module, exports) {
"use strict";
var $9cbde0aae193ec4d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $ge5Q0 = parcelRequire("ge5Q0");

var $ge5Q0 = parcelRequire("ge5Q0");

var $dlLC5 = parcelRequire("dlLC5");

var $eIUhW = parcelRequire("eIUhW");

var $4NRde = parcelRequire("4NRde");

var $hf2Ts = parcelRequire("hf2Ts");

var $b3IPY = parcelRequire("b3IPY");

var $fdSDn = parcelRequire("fdSDn");

var $3NmQX = parcelRequire("3NmQX");

var $cZ6kH = parcelRequire("cZ6kH");

var $4TgO5 = parcelRequire("4TgO5");

var $46jth = parcelRequire("46jth");

var $1JtKM = parcelRequire("1JtKM");

var $5D3EU = parcelRequire("5D3EU");

var $21ucb = parcelRequire("21ucb");
const $9cbde0aae193ec4d$var$DEFAULT_TIMEOUT_MS = 10000;
const $9cbde0aae193ec4d$var$BACKOFF_BASE_MS = 500;
const $9cbde0aae193ec4d$var$BACKOFF_MAX_MS = 30000;
const $9cbde0aae193ec4d$var$RATE_LIMIT_WINDOW_MS = 1000;
const $9cbde0aae193ec4d$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $9cbde0aae193ec4d$var$LEAK_RATE = $9cbde0aae193ec4d$var$RATE_LIMIT_MAX_REQ_COUNT / $9cbde0aae193ec4d$var$RATE_LIMIT_WINDOW_MS;
const $9cbde0aae193ec4d$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $9cbde0aae193ec4d$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $9cbde0aae193ec4d$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $hf2Ts.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$9cbde0aae193ec4d$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $9cbde0aae193ec4d$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $9cbde0aae193ec4d$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$9cbde0aae193ec4d$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $eIUhW.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            let reqTimedOut = false;
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $21ucb._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    priority: args.priority,
                    keepalive: keepalive
                };
                $9cbde0aae193ec4d$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                let timeoutId;
                response = yield Promise.race([
                    func(populatedUrl, config).finally(()=>clearTimeout(timeoutId)),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>{
                            reqTimedOut = true;
                            reject(new Error(`Timeout of ${this._timeout}ms expired.`));
                        }, this._timeout);
                    })
                ]);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $9cbde0aae193ec4d$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $9cbde0aae193ec4d$var$_getErrorMessage(error);
                const timedOut = $9cbde0aae193ec4d$var$_didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : '', reqTimedOut);
                $9cbde0aae193ec4d$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$9cbde0aae193ec4d$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $46jth.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $eIUhW.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $9cbde0aae193ec4d$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $5D3EU.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $5D3EU.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $9cbde0aae193ec4d$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $9cbde0aae193ec4d$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $4NRde.Endpoint._initialize || args.urlConfig.endpoint === $4NRde.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$4NRde.NetworkParam.SdkKey]: args.sdkKey,
            [$4NRde.NetworkParam.SdkType]: $fdSDn.SDKType._get(args.sdkKey),
            [$4NRde.NetworkParam.SdkVersion]: $1JtKM.SDK_VERSION,
            [$4NRde.NetworkParam.Time]: String(Date.now()),
            [$4NRde.NetworkParam.SessionID]: $cZ6kH.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $3NmQX._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $ge5Q0._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$4NRde.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $eIUhW.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $9cbde0aae193ec4d$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$9cbde0aae193ec4d$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($eIUhW.Log.error);
                writer.close().catch($eIUhW.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$4NRde.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $eIUhW.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $9cbde0aae193ec4d$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $9cbde0aae193ec4d$var$NetworkCore;
const $9cbde0aae193ec4d$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $eIUhW.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $9cbde0aae193ec4d$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $4TgO5.StableID.get(sdkKey);
    const sessionID = $cZ6kH.SessionID.get(sdkKey);
    const sdkType = $fdSDn.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $1JtKM.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $9cbde0aae193ec4d$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $ge5Q0._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $b3IPY.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $5D3EU.LogEventCompressionMode.Disabled:
            return false;
        case $5D3EU.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $5D3EU.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $9cbde0aae193ec4d$var$_getErrorMessage(error) {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $9cbde0aae193ec4d$var$_didTimeout(errorMsg, abortedByTimeout) {
    const timeout = errorMsg.includes('Timeout'); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function $9cbde0aae193ec4d$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $4NRde.Endpoint._initialize) return;
    $dlLC5.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $9cbde0aae193ec4d$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $4NRde.Endpoint._initialize) return;
    $dlLC5.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $dlLC5.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $9cbde0aae193ec4d$var$_exponentialBackoff(attempt) {
    return $9cbde0aae193ec4d$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($9cbde0aae193ec4d$var$BACKOFF_BASE_MS * (attempt * attempt), $9cbde0aae193ec4d$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("hf2Ts", function(module, exports) {
"use strict";
var $c8d614f560972e95$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $4J75K = parcelRequire("4J75K");

var $gJOcU = parcelRequire("gJOcU");

var $eIUhW = parcelRequire("eIUhW");

var $kf7uu = parcelRequire("kf7uu");
const $c8d614f560972e95$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $c8d614f560972e95$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $c8d614f560972e95$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $c8d614f560972e95$var$DEFAULT_TTL_MS;
        $c8d614f560972e95$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $c8d614f560972e95$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $c8d614f560972e95$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $c8d614f560972e95$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$c8d614f560972e95$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $c8d614f560972e95$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $c8d614f560972e95$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $c8d614f560972e95$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $c8d614f560972e95$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $4J75K._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $c8d614f560972e95$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $c8d614f560972e95$var$NetworkFallbackResolver;
function $c8d614f560972e95$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $c8d614f560972e95$var$_isDomainFailure;
function $c8d614f560972e95$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $gJOcU._DJB2)(sdkKey)}`;
}
function $c8d614f560972e95$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $c8d614f560972e95$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $kf7uu.Storage.removeItem(hashKey);
        return;
    }
    $kf7uu.Storage.setItem(hashKey, JSON.stringify(info));
}
function $c8d614f560972e95$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $c8d614f560972e95$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $kf7uu.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $eIUhW.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $c8d614f560972e95$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("4J75K", function(module, exports) {
"use strict";
var $3710dda6ba9e9270$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $3710dda6ba9e9270$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $3710dda6ba9e9270$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $3710dda6ba9e9270$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $3710dda6ba9e9270$var$MAX_START_LOOKUP = 200;
function $3710dda6ba9e9270$var$_fetchTxtRecords(networkFunc) {
    return $3710dda6ba9e9270$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($3710dda6ba9e9270$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $3710dda6ba9e9270$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $3710dda6ba9e9270$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $3710dda6ba9e9270$var$_fetchTxtRecords;
function $3710dda6ba9e9270$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $3710dda6ba9e9270$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $3710dda6ba9e9270$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("b3IPY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $80d2c148579ecbac$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $80d2c148579ecbac$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $80d2c148579ecbac$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("cZ6kH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $ge5Q0 = parcelRequire("ge5Q0");

var $gQAqt = parcelRequire("gQAqt");

var $eIUhW = parcelRequire("eIUhW");

var $kf7uu = parcelRequire("kf7uu");

var $6ULMU = parcelRequire("6ULMU");
const $9740181bf2016a22$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $9740181bf2016a22$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $9740181bf2016a22$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($9740181bf2016a22$var$PROMISE_MAP[sdkKey] == null) $9740181bf2016a22$var$PROMISE_MAP[sdkKey] = $9740181bf2016a22$var$_loadSession(sdkKey);
        const session = $9740181bf2016a22$var$PROMISE_MAP[sdkKey];
        return $9740181bf2016a22$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $9740181bf2016a22$var$PROMISE_MAP[sdkKey] = $9740181bf2016a22$var$_overrideSessionId(override, sdkKey);
    }
};
function $9740181bf2016a22$var$_loadSession(sdkKey) {
    let data = $9740181bf2016a22$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $6ULMU.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $9740181bf2016a22$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $9740181bf2016a22$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($9740181bf2016a22$var$_isIdle(data) || $9740181bf2016a22$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $6ULMU.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $9740181bf2016a22$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $9740181bf2016a22$var$_createSessionTimeout(sdkKey, $9740181bf2016a22$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $9740181bf2016a22$var$_createSessionTimeout(sdkKey, $9740181bf2016a22$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $9740181bf2016a22$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $ge5Q0._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $9740181bf2016a22$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $9740181bf2016a22$var$MAX_SESSION_IDLE_TIME;
}
function $9740181bf2016a22$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $9740181bf2016a22$var$MAX_SESSION_AGE;
}
function $9740181bf2016a22$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $gQAqt._getStorageKey)(sdkKey)}`;
}
function $9740181bf2016a22$var$_persistToStorage(session, sdkKey) {
    const storageKey = $9740181bf2016a22$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $kf7uu._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $eIUhW.Log.warn('Failed to save SessionID');
    }
}
function $9740181bf2016a22$var$_loadFromStorage(sdkKey) {
    const storageKey = $9740181bf2016a22$var$_getSessionIDStorageKey(sdkKey);
    return (0, $kf7uu._getObjectFromStorage)(storageKey);
}

});

parcelRegister("46jth", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("7Q0Y4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("39Oab", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9LSa2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $71d2840c914b9cdf$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $71d2840c914b9cdf$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $71d2840c914b9cdf$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $71d2840c914b9cdf$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $71d2840c914b9cdf$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $71d2840c914b9cdf$var$_fastApproxSizeOf;

});

parcelRegister("7jKOl", function(module, exports) {
"use strict";
var $553e9e732ea8cd3f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $ge5Q0 = parcelRequire("ge5Q0");

var $ge5Q0 = parcelRequire("ge5Q0");

var $8AmNf = parcelRequire("8AmNf");

var $4CA2n = parcelRequire("4CA2n");

var $eIUhW = parcelRequire("eIUhW");

var $l2wIj = parcelRequire("l2wIj");

var $3NmQX = parcelRequire("3NmQX");

var $cZ6kH = parcelRequire("cZ6kH");

var $4TgO5 = parcelRequire("4TgO5");

var $5D3EU = parcelRequire("5D3EU");

var $kf7uu = parcelRequire("kf7uu");
const $553e9e732ea8cd3f$var$MAX_MEMO_CACHE_SIZE = 3000;
class $553e9e732ea8cd3f$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($eIUhW.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $kf7uu.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $cZ6kH.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $kf7uu.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $4TgO5.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $4TgO5.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $4CA2n.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $8AmNf.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $kf7uu.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $553e9e732ea8cd3f$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $kf7uu.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $4TgO5.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($5D3EU.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $553e9e732ea8cd3f$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $eIUhW.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $l2wIj.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $553e9e732ea8cd3f$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $553e9e732ea8cd3f$var$StatsigClientBase;
function $553e9e732ea8cd3f$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $3NmQX._isServerEnv)()) return;
    const statsigGlobal = (0, $ge5Q0._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $eIUhW.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("46Eic", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("ipkFC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jE84N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $eIUhW = parcelRequire("eIUhW");

var $h0RPa = parcelRequire("h0RPa");
function $e4d8048876970bcc$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $e4d8048876970bcc$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $e4d8048876970bcc$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $e4d8048876970bcc$var$_makeFeatureGate;
function $e4d8048876970bcc$var$_makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $e4d8048876970bcc$var$_makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: $e4d8048876970bcc$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $e4d8048876970bcc$var$_makeDynamicConfig;
function $e4d8048876970bcc$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $e4d8048876970bcc$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $e4d8048876970bcc$var$_makeExperiment;
function $e4d8048876970bcc$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $e4d8048876970bcc$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $e4d8048876970bcc$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $e4d8048876970bcc$var$_makeLayer;
function $e4d8048876970bcc$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $e4d8048876970bcc$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $e4d8048876970bcc$var$_mergeOverride;
function $e4d8048876970bcc$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $h0RPa._isTypeMatch)(found, fallback)) {
            $eIUhW.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $e4d8048876970bcc$var$_makeTypedGet;

});

parcelRegister("anXRC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7N1Ma", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $5abe7cac4a102f53$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $5abe7cac4a102f53$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("jCry9", function(module, exports) {
"use strict";
var $03af98832d29291f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $49Dnu = parcelRequire("49Dnu");

var $91Bz6 = parcelRequire("91Bz6");

var $5qJeH = parcelRequire("5qJeH");

var $19OtR = parcelRequire("19OtR");

var $6cXIa = parcelRequire("6cXIa");
class $03af98832d29291f$var$StatsigClient extends $49Dnu.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $49Dnu._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $03af98832d29291f$var$StatsigClient) return instance;
        $49Dnu.Log.warn((0, $49Dnu._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $03af98832d29291f$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $49Dnu.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $5qJeH.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $6cXIa.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($49Dnu.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($49Dnu.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($49Dnu.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($49Dnu.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($49Dnu.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($49Dnu.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $91Bz6.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $49Dnu.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $49Dnu.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $03af98832d29291f$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $49Dnu.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $49Dnu.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $03af98832d29291f$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $03af98832d29291f$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $49Dnu.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $49Dnu.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $49Dnu.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $49Dnu.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($49Dnu.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $49Dnu.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $49Dnu.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $49Dnu.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        let user = {};
        try {
            user = JSON.parse(JSON.stringify(this._user));
        } catch (_a) {
            $49Dnu.Log.error('Failed to parse user');
        }
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: user,
            errorBoundary: this._errorBoundary,
            session: $49Dnu.StatsigSession.get(this._sdkKey),
            stableID: $49Dnu.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $03af98832d29291f$var$__awaiter(this, void 0, void 0, function*() {
            if (!$49Dnu.Storage.isReady()) yield $49Dnu.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $49Dnu.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $49Dnu.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a, _b, _c;
        const user = (0, $49Dnu._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) {
            const readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (readyPromise) readyPromise.then(()=>$49Dnu.StableID.setOverride(stableIdOverride, this._sdkKey), ()=>$49Dnu.StableID.setOverride(stableIdOverride, this._sdkKey));
            else $49Dnu.StableID.setOverride(stableIdOverride, this._sdkKey);
        }
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $49Dnu._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $49Dnu._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $49Dnu._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $49Dnu._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $49Dnu._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $49Dnu._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $49Dnu._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $49Dnu._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $49Dnu._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $49Dnu._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $19OtR._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $19OtR._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
}
module.exports.default = $03af98832d29291f$var$StatsigClient;

});
parcelRegister("91Bz6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $49Dnu = parcelRequire("49Dnu");

var $8PO8Y = parcelRequire("8PO8Y");

var $aD2oW = parcelRequire("aD2oW");
class $692158b116e95668$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $49Dnu._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a, _b;
        if (!result) return false;
        const values = (0, $49Dnu._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        const updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        if (updatedLcut < this._lcut) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        if (values.response_format === 'init-v2') this._values = new $aD2oW.V2InitializeContainer(values);
        else this._values = new $8PO8Y.V1InitializeContainer(values);
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $49Dnu.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        const res = this._values ? this._values.getGate(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfig(name) {
        const res = this._values ? this._values.getConfig(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfigList() {
        if (!this._values) return [];
        return this._values.getConfigList();
    }
    getLayer(name) {
        const res = this._values ? this._values.getLayer(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getParamStore(name) {
        const res = this._values ? this._values.getParamStore(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(result) {
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $49Dnu.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $49Dnu._getFullUserHash)(userForComparison) !== (0, $49Dnu._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $692158b116e95668$var$EvaluationStore;

});
parcelRegister("8PO8Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1InitializeContainer = void 0;

var $49Dnu = parcelRequire("49Dnu");
class $66e9fbacb8c716bd$var$V1InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        return this._getResultFromLookup(this._values.feature_gates, name);
    }
    getConfig(name) {
        return this._getResultFromLookup(this._values.dynamic_configs, name);
    }
    getLayer(name) {
        return this._getResultFromLookup(this._values.layer_configs, name);
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $49Dnu._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V1InitializeContainer = $66e9fbacb8c716bd$var$V1InitializeContainer;

});

parcelRegister("aD2oW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V2InitializeContainer = void 0;

var $49Dnu = parcelRequire("49Dnu");
class $7bcf68ba3431efb7$var$V2InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        var _a, _b, _c;
        const evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: evalV2.v === true,
            rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : 'default',
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ''
        };
    }
    getConfig(name) {
        var _a, _b, _c, _d;
        const evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : '',
            is_user_in_experiment: evalV2.ue === true ? true : false,
            passed: evalV2.p === true,
            group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID'
        };
    }
    getLayer(name) {
        var _a, _b, _c, _d, _e, _f;
        const evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            is_user_in_experiment: evalV2.ue === true ? true : false,
            group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID',
            allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : '',
            explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
            undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
            parameter_rule_ids: evalV2.pr
        };
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $49Dnu._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V2InitializeContainer = $7bcf68ba3431efb7$var$V2InitializeContainer;

});


parcelRegister("5qJeH", function(module, exports) {
"use strict";
var $3f4278646d739f63$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $49Dnu = parcelRequire("49Dnu");

var $gd5Yu = parcelRequire("gd5Yu");
class $3f4278646d739f63$var$StatsigNetwork extends $49Dnu.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $49Dnu.UrlConfiguration($49Dnu.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $3f4278646d739f63$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $49Dnu._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $3f4278646d739f63$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $gd5Yu._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $3f4278646d739f63$var$StatsigNetwork;

});
parcelRegister("gd5Yu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $49Dnu = parcelRequire("49Dnu");
const $bcd27ea837ac45e4$var$MAX_DELTAS_SORT_DEPTH = 2;
function $bcd27ea837ac45e4$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $49Dnu._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $bcd27ea837ac45e4$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $bcd27ea837ac45e4$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $49Dnu._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $bcd27ea837ac45e4$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $bcd27ea837ac45e4$var$_resolveDeltasResponse;
function $bcd27ea837ac45e4$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $bcd27ea837ac45e4$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $bcd27ea837ac45e4$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $bcd27ea837ac45e4$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $bcd27ea837ac45e4$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $bcd27ea837ac45e4$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("19OtR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $49Dnu = parcelRequire("49Dnu");
const $0d7dca1fe2ab336f$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $0d7dca1fe2ab336f$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $0d7dca1fe2ab336f$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $49Dnu._isTypeMatch)(value, fallback);
}
function $0d7dca1fe2ab336f$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $0d7dca1fe2ab336f$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $0d7dca1fe2ab336f$var$_shouldLogExposure(options) ? undefined : $0d7dca1fe2ab336f$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $0d7dca1fe2ab336f$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $0d7dca1fe2ab336f$var$_shouldLogExposure(options) ? undefined : $0d7dca1fe2ab336f$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($0d7dca1fe2ab336f$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $0d7dca1fe2ab336f$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $0d7dca1fe2ab336f$var$_shouldLogExposure(options) ? undefined : $0d7dca1fe2ab336f$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($0d7dca1fe2ab336f$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $0d7dca1fe2ab336f$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $0d7dca1fe2ab336f$var$_shouldLogExposure(options) ? undefined : $0d7dca1fe2ab336f$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($0d7dca1fe2ab336f$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $0d7dca1fe2ab336f$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $49Dnu._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $0d7dca1fe2ab336f$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $0d7dca1fe2ab336f$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $0d7dca1fe2ab336f$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $0d7dca1fe2ab336f$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $0d7dca1fe2ab336f$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $0d7dca1fe2ab336f$var$_makeParamStoreGetter;

});

parcelRegister("6cXIa", function(module, exports) {
"use strict";
var $48522e816d83b334$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $49Dnu = parcelRequire("49Dnu");

var $5qJeH = parcelRequire("5qJeH");
class $48522e816d83b334$var$StatsigEvaluationsDataAdapter extends $49Dnu.DataAdapterCore {
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $5qJeH.default) this._network = network;
        else this._network = new $5qJeH.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $49Dnu._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $49Dnu._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $49Dnu.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $48522e816d83b334$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $49Dnu._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$49Dnu.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $49Dnu._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $48522e816d83b334$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("iaAZy", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6823a650e7a352e$export$2e2bcd8739ae039);

var $hacB2 = parcelRequire("hacB2");
const $d6823a650e7a352e$export$a66cbd9b2289cd78 = '@all-features';
class $d6823a650e7a352e$export$2e2bcd8739ae039 {
    emitter;
    eventToValue = new Map();
    constructor(){
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hacB2)))();
    }
    onGateUpdated(gateName, callback, checkGate, options) {
        const value = checkGate(gateName, {
            ...options,
            fireGateExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = checkGate(gateName, {
                ...options,
                fireGateExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(gateName, wrapCallback);
        return ()=>{
            this.emitter.off(gateName, wrapCallback);
        };
    }
    onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
        const experimentEventName = `${experimentName}.${parameterName}`;
        const value = getExperimentValue(experimentName, parameterName, defaultValue, {
            ...options,
            fireExperimentExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = getExperimentValue(experimentName, parameterName, defaultValue, {
                ...options,
                fireExperimentExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(experimentEventName, wrapCallback);
        return ()=>{
            this.emitter.off(experimentEventName, wrapCallback);
        };
    }
    onAnyUpdated(callback) {
        this.emitter.on($d6823a650e7a352e$export$a66cbd9b2289cd78, callback);
        return ()=>{
            this.emitter.off($d6823a650e7a352e$export$a66cbd9b2289cd78, callback);
        };
    }
    anyUpdated() {
        this.emitter.emit($d6823a650e7a352e$export$a66cbd9b2289cd78);
        this.emitter.eventNames().filter((name)=>name !== $d6823a650e7a352e$export$a66cbd9b2289cd78).forEach((event)=>{
            this.emitter.emit(event);
        });
    }
}

});
parcelRegister("hacB2", function(module, exports) {
'use strict';
var $c7ed243b039b52b5$var$has = Object.prototype.hasOwnProperty, $c7ed243b039b52b5$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $c7ed243b039b52b5$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $c7ed243b039b52b5$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $c7ed243b039b52b5$var$Events().__proto__) $c7ed243b039b52b5$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $c7ed243b039b52b5$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $c7ed243b039b52b5$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $c7ed243b039b52b5$var$EE(fn, context || emitter, once), evt = $c7ed243b039b52b5$var$prefix ? $c7ed243b039b52b5$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $c7ed243b039b52b5$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $c7ed243b039b52b5$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $c7ed243b039b52b5$var$EventEmitter() {
    this._events = new $c7ed243b039b52b5$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $c7ed243b039b52b5$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($c7ed243b039b52b5$var$has.call(events, name)) names.push($c7ed243b039b52b5$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $c7ed243b039b52b5$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $c7ed243b039b52b5$var$prefix ? $c7ed243b039b52b5$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $c7ed243b039b52b5$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $c7ed243b039b52b5$var$prefix ? $c7ed243b039b52b5$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $c7ed243b039b52b5$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $c7ed243b039b52b5$var$prefix ? $c7ed243b039b52b5$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c7ed243b039b52b5$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $c7ed243b039b52b5$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c7ed243b039b52b5$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $c7ed243b039b52b5$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c7ed243b039b52b5$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $c7ed243b039b52b5$var$prefix ? $c7ed243b039b52b5$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $c7ed243b039b52b5$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $c7ed243b039b52b5$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $c7ed243b039b52b5$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c7ed243b039b52b5$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $c7ed243b039b52b5$var$prefix ? $c7ed243b039b52b5$var$prefix + event : event;
        if (this._events[evt]) $c7ed243b039b52b5$var$clearEvent(this, evt);
    } else {
        this._events = new $c7ed243b039b52b5$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$c7ed243b039b52b5$var$EventEmitter.prototype.off = $c7ed243b039b52b5$var$EventEmitter.prototype.removeListener;
$c7ed243b039b52b5$var$EventEmitter.prototype.addListener = $c7ed243b039b52b5$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$c7ed243b039b52b5$var$EventEmitter.prefixed = $c7ed243b039b52b5$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$c7ed243b039b52b5$var$EventEmitter.EventEmitter = $c7ed243b039b52b5$var$EventEmitter;
module.exports = $c7ed243b039b52b5$var$EventEmitter;

});


parcelRegister("4p9Sd", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $654031b0bde63c04$export$6dc24881a3d96325);

var $dBdHW = parcelRequire("dBdHW");

var $23J4N = parcelRequire("23J4N");
class $654031b0bde63c04$export$6dc24881a3d96325 {
    static fromExperiment(experiment) {
        const config = new $654031b0bde63c04$export$6dc24881a3d96325(experiment.name, experiment.value, experiment.ruleID, (0, $dBdHW.migrateEvaluationDetails)(experiment.details), (0, $23J4N.migrateSecondaryExposures)(experiment.__evaluation?.secondary_exposures ?? []), experiment.groupName ?? undefined);
        config.experiment = experiment;
        return config;
    }
    value;
    _name;
    _ruleID;
    /** @deprecated - do not use, this is still exported for backwards compatibility but will be removed in the next major version  */ _secondaryExposures;
    _allocatedExperimentName;
    _evaluationDetails;
    _onDefaultValueFallback;
    experiment;
    constructor(configName, configValue, ruleID, evaluationDetails, secondaryExposures = [], allocatedExperimentName = '', onDefaultValueFallback = null){
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    get(key, defaultValue, typeGuard) {
        const val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        const expectedType = Array.isArray(defaultValue) ? 'array' : typeof defaultValue;
        const actualType = Array.isArray(val) ? 'array' : typeof val;
        if (typeGuard) {
            if (typeGuard(val)) {
                this.fireExposure(key);
                return val;
            }
            this._onDefaultValueFallback?.(this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) {
            this.fireExposure(key);
            return val;
        }
        this._onDefaultValueFallback?.(this, key, expectedType, actualType);
        return defaultValue;
    }
    getValue(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        this.fireExposure(key);
        return this.value[key];
    }
    fireExposure(key) {
        // Call the wrapped experiment's get method to fire exposure
        if (this.experiment) this.experiment.get(key);
    }
}

});
parcelRegister("dBdHW", function(module, exports) {
$parcel$export(module.exports, "migrateEvaluationDetails", () => $c84ffd3ef08963ee$export$18ad168d3dbac899);

var $lOIRH = parcelRequire("lOIRH");
const $c84ffd3ef08963ee$var$evaluationReasonMappings = Object.entries((0, $lOIRH.EvaluationReason)).map(([key, value])=>[
        key.toLowerCase(),
        value
    ]);
const $c84ffd3ef08963ee$export$18ad168d3dbac899 = (details)=>{
    const reasonLower = details.reason.toLowerCase();
    return {
        reason: $c84ffd3ef08963ee$var$evaluationReasonMappings.find(([key])=>reasonLower.includes(key))?.[1] ?? (0, $lOIRH.EvaluationReason).Unknown,
        time: details.receivedAt ?? Date.now()
    };
};

});
parcelRegister("lOIRH", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $d66c4f9a9e8cecbd$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
const $d66c4f9a9e8cecbd$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
};

});


parcelRegister("23J4N", function(module, exports) {
$parcel$export(module.exports, "migrateSecondaryExposures", () => $44e2b104b9319839$export$55fd683752d01e67);
const $44e2b104b9319839$export$55fd683752d01e67 = (secondaryExposures)=>{
    return secondaryExposures.map((exposure)=>{
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});


parcelRegister("kIeaF", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $83e053890fdc7361$export$936d0764594b6eb3);

var $dBdHW = parcelRequire("dBdHW");

var $23J4N = parcelRequire("23J4N");
class $83e053890fdc7361$export$936d0764594b6eb3 {
    static fromLayer(layer) {
        const value = new $83e053890fdc7361$export$936d0764594b6eb3(layer.name, layer.__value, layer.ruleID, (0, $dBdHW.migrateEvaluationDetails)(layer.details), (_layer, parameterName)=>layer.get(parameterName), (0, $23J4N.migrateSecondaryExposures)(layer.__evaluation?.secondary_exposures ?? []), (0, $23J4N.migrateSecondaryExposures)(layer.__evaluation?.undelegated_secondary_exposures ?? []), layer.__evaluation?.allocated_experiment_name, layer.__evaluation?.explicit_parameters);
        return value;
    }
    _name;
    _value;
    _ruleID;
    /** @deprecated - do not use, this is still exported for backwards compatibility but will be removed in the next major version  */ _secondaryExposures;
    /** @deprecated - do not use, this is still exported for backwards compatibility but will be removed in the next major version  */ _undelegatedSecondaryExposures;
    _allocatedExperimentName;
    _explicitParameters;
    _evaluationDetails;
    _logParameterFunction;
    constructor(name, layerValue, ruleID, evaluationDetails, logParameterFunction = null, secondaryExposures = [], undelegatedSecondaryExposures = [], allocatedExperimentName = '', explicitParameters = []){
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue ?? {}));
        this._ruleID = ruleID ?? '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    get(key, defaultValue, typeGuard) {
        const val = this._value[key];
        if (val == null) return defaultValue;
        const logAndReturn = ()=>{
            this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    }
    getValue(key, defaultValue) {
        // eslint-disable-next-line eqeqeq
        if (defaultValue == undefined) defaultValue = null;
        const val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val ?? defaultValue;
    }
    _logLayerParameterExposure(parameterName) {
        this._logParameterFunction?.(this, parameterName);
    }
}

});

parcelRegister("jQSGj", function(module, exports) {
$parcel$export(module.exports, "deepAssign", () => $eb3a7f8a80185386$export$1148cb79ceecd5fa);
/**
 * Deeply merges source objects into the target object.
 * Handles nested objects, but arrays are not handled (replaced).
 */ function $eb3a7f8a80185386$export$1148cb79ceecd5fa(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
    if (source === undefined || source === null) return $eb3a7f8a80185386$export$1148cb79ceecd5fa(target, ...sources);
    for (const [key, src] of Object.entries(source)){
        const dst = target[key];
        const srcIsObj = src && typeof src === 'object' && !Array.isArray(src);
        const dstIsObj = dst && typeof dst === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $eb3a7f8a80185386$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $eb3a7f8a80185386$export$1148cb79ceecd5fa(target, ...sources);
}

});

parcelRegister("khTgG", function(module, exports) {
$parcel$export(module.exports, "isEvalFlagsDegraded", () => $f3d89bf6821f89a6$export$426949866882809c);
const $f3d89bf6821f89a6$export$426949866882809c = (status)=>status.statsig === 'UNAVAILABLE' || status.ffp === 'UNAVAILABLE' || status.statsig === 'DISABLED' && status.ffp === 'DISABLED';

});

parcelRegister("7eV3p", function(module, exports) {
$parcel$export(module.exports, "toInitializeValues", () => $da3f81ad18a559d8$export$8a9596f588a26431);

var $brrBD = parcelRequire("brrBD");
const $da3f81ad18a559d8$export$8a9596f588a26431 = (response, requestCustomAttributes)=>{
    const { status: status, statsig: statsig, ffp: ffp } = (0, $brrBD.decodeEvalFlagsResponse)(response);
    const disabledProviders = [
        'statsig',
        'ffp'
    ].filter((provider)=>status[provider] === 'DISABLED');
    return {
        clientSdkKey: statsig?.clientSdkKey,
        experimentValues: statsig?.experimentValues ?? {},
        customAttributesFromFetch: statsig?.customAttributes ?? requestCustomAttributes,
        ffp: ffp,
        status: status,
        ...disabledProviders.length > 0 && {
            disabledProviders: disabledProviders
        }
    };
};

});
parcelRegister("brrBD", function(module, exports) {
$parcel$export(module.exports, "decodeEvalFlagsResponse", () => $cbf6524b51745412$export$b697cf918684dbf0);
// @atlaskit/feature-gate-fetcher imports the helpers in this directory through the `./eval-flags/*`
// entry points, so the client and the providers share one implementation.
const $cbf6524b51745412$var$PROVIDER_STATUSES = [
    'OK',
    'DISABLED',
    'UNAVAILABLE'
];
const $cbf6524b51745412$var$isRecord = (value)=>typeof value === 'object' && value !== null;
/** The status the service reported, or `undefined` when it is absent or unknown to this client. */ const $cbf6524b51745412$var$decodeReportedStatus = (reported)=>$cbf6524b51745412$var$PROVIDER_STATUSES.find((status)=>status === reported);
/**
 * A provider's status when the service reported none this client knows. The body is not validated,
 * so this falls back to the sections, which the service omits for a provider it did not use.
 */ const $cbf6524b51745412$var$statusFromSection = (section)=>section === undefined ? 'DISABLED' : 'OK';
/** A section normalised to `undefined` unless it carries values. */ const $cbf6524b51745412$var$sectionWithValues = (section, hasValues)=>hasValues ? section ?? undefined : undefined;
/** The Statsig section when it carries values; `undefined` when omitted, `null` or empty. */ const $cbf6524b51745412$var$decodeStatsigSection = (response)=>$cbf6524b51745412$var$sectionWithValues(response.statsig, $cbf6524b51745412$var$isRecord(response.statsig?.experimentValues));
/** The FFP section when it carries flags; `undefined` when omitted, `null` or empty. */ const $cbf6524b51745412$var$decodeFfpSection = (response)=>$cbf6524b51745412$var$sectionWithValues(response.ffp, $cbf6524b51745412$var$isRecord(response.ffp?.flags));
/** A section a caller may use, which is one whose provider is `OK`. */ const $cbf6524b51745412$var$whenOk = (section, status)=>status === 'OK' ? section : undefined;
const $cbf6524b51745412$export$b697cf918684dbf0 = (response)=>{
    const statsig = $cbf6524b51745412$var$decodeStatsigSection(response);
    const ffp = $cbf6524b51745412$var$decodeFfpSection(response);
    const status = {
        statsig: $cbf6524b51745412$var$decodeReportedStatus(response.status?.statsig) ?? $cbf6524b51745412$var$statusFromSection(statsig),
        ffp: $cbf6524b51745412$var$decodeReportedStatus(response.status?.ffp) ?? $cbf6524b51745412$var$statusFromSection(ffp)
    };
    return {
        status: status,
        statsig: $cbf6524b51745412$var$whenOk(statsig, status.statsig),
        ffp: $cbf6524b51745412$var$whenOk(ffp, status.ffp)
    };
};

});


parcelRegister("5Oj64", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f12bd6461e3c73f$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $joS99 = parcelRequire("joS99");

var $4d6dI = parcelRequire("4d6dI");

var $4VRUo = parcelRequire("4VRUo");

var $jpm8R = parcelRequire("jpm8R");

var $hnwjG = parcelRequire("hnwjG");

var $c6mX7 = parcelRequire("c6mX7");

var $gJH5G = parcelRequire("gJH5G");
const $3f12bd6461e3c73f$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $3f12bd6461e3c73f$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
const $3f12bd6461e3c73f$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
const $3f12bd6461e3c73f$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $3f12bd6461e3c73f$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $3f12bd6461e3c73f$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $3f12bd6461e3c73f$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
const $3f12bd6461e3c73f$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
const $3f12bd6461e3c73f$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
const $3f12bd6461e3c73f$export$450bd8fb2a6d7ace = '/gateway/api/flags';
class $3f12bd6461e3c73f$export$2e2bcd8739ae039 {
    static async fetchClientSdk(fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    /**
   * Fetches the Statsig values for a user from `/api/v2/frontend/experimentValues`. Use
   * {@link Fetcher.fetchFlagValues}, which calls this only without `includeFfpFlags`.
   */ static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    /**
   * Fetches the combined Statsig and Feature Flag Platform bootstrap values for a user.
   *
   * Rejects with {@link EvalFlagsUnavailableError} when no provider is `OK` and one is `UNAVAILABLE`,
   * so that a response with no values fails like any other failed fetch.
   */ static async fetchEvalFlags(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        let response;
        try {
            response = await this.fetchRequest('/api/v1/evalFlags', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve flag values');
        }
        const status = (0, $hnwjG.getEvalFlagsStatus)(response);
        if ((0, $c6mX7.hasNoUsableProvider)(status)) throw new (0, $gJH5G.EvalFlagsUnavailableError)(status);
        return response;
    }
    /**
   * Fetches the bootstrap values for a user. With `includeFfpFlags`, they come from
   * {@link Fetcher.fetchEvalFlags}; otherwise only Statsig values are fetched, with
   * {@link Fetcher.fetchExperimentValues}, and are returned as a response in which FFP is `DISABLED`.
   */ static async fetchFlagValues(fetcherOptions, identifiers, customAttributes) {
        if (fetcherOptions.includeFfpFlags) return this.fetchEvalFlags(fetcherOptions, identifiers, customAttributes);
        return this.fetchExperimentValues(fetcherOptions, identifiers, customAttributes).then((0, $jpm8R.fromExperimentValuesResponse));
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $4VRUo.ResponseError)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
        }
        if (response.status === 204) throw new (0, $4VRUo.ResponseError)('Unexpected 204 response');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter, isolationContextId = null) {
        if (useGatewayUrl) return $3f12bd6461e3c73f$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $joS99.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $joS99.FeatureGateEnvironment).Production:
                return $3f12bd6461e3c73f$export$18c93900db9358a4;
            case (0, $joS99.FeatureGateEnvironment).Staging:
                return $3f12bd6461e3c73f$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $joS99.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, $joS99.FeatureGateEnvironment).Development:
                return $3f12bd6461e3c73f$export$f058dbf75c3bc647;
            case (0, $joS99.FeatureGateEnvironment).Staging:
                const apiUrl = this.getApiUrl(isolationContextId);
                if (apiUrl !== null) return apiUrl;
                return $3f12bd6461e3c73f$export$942ba04389b0d5a2;
            default:
                const prodApiUrl = this.getApiUrl(isolationContextId);
                if (prodApiUrl !== null) return prodApiUrl;
                return $3f12bd6461e3c73f$export$250a58ecde616daa;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(path, method, fetcherOptions, body) {
        const baseUrl = $3f12bd6461e3c73f$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $3f12bd6461e3c73f$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': (0, $4d6dI.CLIENT_VERSION),
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
    static getApiUrl(isolationContextId) {
        const window1 = this.getWindowLocation();
        if (window1 === undefined) {
            //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
            if (!isolationContextId) return null;
            return $3f12bd6461e3c73f$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
        }
        const { protocol: protocol, hostname: hostname } = window1;
        // Match last subdomain fragment before oasis-stg.com
        const oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
        if (oasisMatch) return `${protocol}//api.${oasisMatch[1]}.${$3f12bd6461e3c73f$export$cb3cd156f70d7e94}`;
        // Match last subdomain fragment before atlassian-isolated.net
        const isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
        if (isolatedMatch) return `${protocol}//api.${isolatedMatch[1]}.${$3f12bd6461e3c73f$export$921fbc6cdfd4eee0}`;
        return null;
    }
    static getWindowLocation() {
        if (typeof window !== 'undefined' && window.location) return window.location;
        return undefined;
    }
}

});
parcelRegister("joS99", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $b88290f2101ac95e$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $b88290f2101ac95e$export$c42b7bbc5e7ba555);
const $b88290f2101ac95e$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
const $b88290f2101ac95e$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
const $b88290f2101ac95e$export$42f4885608027d0c = 'non_boolean';

});

parcelRegister("4d6dI", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $c298906a7c96abbb$export$a59f8d67326bd1cb);
/// <reference types="node" />
const $c298906a7c96abbb$export$a59f8d67326bd1cb = undefined;

});

parcelRegister("4VRUo", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $fcd83743f85c978c$export$286baf652d0b1206);
class $fcd83743f85c978c$export$286baf652d0b1206 extends Error {
    constructor(message){
        super(message);
    }
}

});

parcelRegister("jpm8R", function(module, exports) {
$parcel$export(module.exports, "fromExperimentValuesResponse", () => $b42325615197576b$export$69f3c94f0aa979d5);
const $b42325615197576b$export$69f3c94f0aa979d5 = (response)=>({
        statsig: response,
        status: {
            statsig: 'OK',
            ffp: 'DISABLED'
        }
    });

});

parcelRegister("hnwjG", function(module, exports) {
$parcel$export(module.exports, "getEvalFlagsStatus", () => $94b6ab403f38a0d6$export$874ce68018557ae1);

var $brrBD = parcelRequire("brrBD");
const $94b6ab403f38a0d6$export$874ce68018557ae1 = (response)=>(0, $brrBD.decodeEvalFlagsResponse)(response).status;

});

parcelRegister("c6mX7", function(module, exports) {
$parcel$export(module.exports, "hasNoUsableProvider", () => $99f01192e7123ee2$export$1a81cdd8dc55ce47);
const $99f01192e7123ee2$export$1a81cdd8dc55ce47 = (status)=>status.statsig !== 'OK' && status.ffp !== 'OK' && (status.statsig === 'UNAVAILABLE' || status.ffp === 'UNAVAILABLE');

});

parcelRegister("gJH5G", function(module, exports) {
$parcel$export(module.exports, "EvalFlagsUnavailableError", () => $f6e10244ba2ea82b$export$49ae4f7192ab8153);
class $f6e10244ba2ea82b$export$49ae4f7192ab8153 extends Error {
    status;
    constructor(status){
        super(`Feature flag values are unavailable (Statsig: ${status.statsig}, FFP: ${status.ffp})`);
        this.status = status;
    }
}

});


parcelRegister("1aoIg", function(module, exports) {
$parcel$export(module.exports, "FfpClientAdapter", () => $717b16e0f29393a7$export$d0440eddc68143b1);

var $8HOA0 = parcelRequire("8HOA0");

var $fuxTf = parcelRequire("fuxTf");

var $joS99 = parcelRequire("joS99");
/**
 * Returned by a typed read only when the Feature Flag Platform client falls back to the safe
 * default (flag absent, type mismatch, unusable value, or `useCodeDefault`). Identity comparison
 * against it lets the wrapper apply the caller's own default instead.
 */ const $717b16e0f29393a7$var$NOT_SERVED = Symbol('ffp-not-served');
const $717b16e0f29393a7$var$toEnvironmentType = (environment)=>{
    switch(environment){
        case (0, $joS99.FeatureGateEnvironment).Development:
            return 'dev';
        case (0, $joS99.FeatureGateEnvironment).Staging:
            return 'staging';
        default:
            return 'prod';
    }
};
const $717b16e0f29393a7$var$isPlainObject = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value);
/**
 * What the client serves for a user FFP serves nothing to: every read returns its default. The
 * payload's request context is the user, so exposures are attributed to them.
 */ const $717b16e0f29393a7$var$emptyPayload = (user)=>()=>({
            flags: {},
            requestContext: user
        });
/** Only forward the members the FFP client consumes; the service payload carries extra metadata. */ const $717b16e0f29393a7$var$toBulkEvaluationPayload = (values)=>({
        // Forward the schema version so the FFP client rejects a wire format it does not support.
        ...values.vs !== undefined && {
            vs: values.vs
        },
        flags: values.flags,
        requestContext: values.requestContext,
        ...values.clientVersion !== undefined && {
            clientVersion: values.clientVersion
        }
    });
const $717b16e0f29393a7$var$toFlagClientOptions = (options)=>{
    // Match the Statsig client: no telemetry egress in FedRAMP or when logging is disabled.
    const loggingDisabled = options.perimeter === (0, $joS99.PerimeterType).FEDRAMP_MODERATE || options.disableAllLogging === true;
    return {
        targetApp: options.targetApp,
        environmentType: $717b16e0f29393a7$var$toEnvironmentType(options.environment),
        ...loggingDisabled && {
            exposureLogging: {
                enabled: false
            }
        }
    };
};
const $717b16e0f29393a7$var$EMPTY_CONFIG = {
    value: {},
    ruleId: ''
};
class $717b16e0f29393a7$export$d0440eddc68143b1 {
    client;
    initialized = false;
    flags;
    /**
   * Applies the FFP values for a user. Absent values mean FFP serves nothing for this user (for
   * example the provider is disabled or unavailable), so no key is routed here until the next values
   * arrive. The client is not created until the first values arrive.
   */ apply(options, values, identifiers, customAttributes) {
        // Never keep serving the previous user's values, whatever happens below.
        this.flags = undefined;
        const user = (0, $fuxTf.toFlagUser)(identifiers, customAttributes);
        try {
            if (values && this.applyPayload(options, ()=>$717b16e0f29393a7$var$toBulkEvaluationPayload(values), user)) {
                this.flags = values.flags;
                return;
            }
            // Callers may read the client directly (see `getClient`), and a failed or skipped replacement
            // would leave it serving the previous user's payload, so give it an empty one for this user.
            if (this.initialized) this.client?.replace($717b16e0f29393a7$var$emptyPayload(user), user);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Failed to apply Feature Flag Platform values', error);
        }
    }
    /** Gives the client a payload and user, returning whether it accepted them. */ applyPayload(options, provider, user) {
        const client = this.getClient(options);
        // `initialize` can be retried after a failure; once it succeeds, later users use `replace`.
        if (this.initialized) return client.replace(provider, user).replaced;
        this.initialized = client.initialize(provider, user).initialized;
        return this.initialized;
    }
    /**
   * The FFP client, created on first use with the given options and the same instance afterwards.
   * Until values are applied (and while FFP serves nothing for the user), its reads return the safe
   * default they are given.
   */ getClient(options) {
        this.client ??= new (0, $8HOA0.FlagClient)($717b16e0f29393a7$var$toFlagClientOptions(options));
        return this.client;
    }
    /** Whether the latest FFP payload contains the given flag key, so FFP answers for it. */ has(flagKey) {
        return this.getFlag(flagKey) !== undefined;
    }
    /**
   * Gate read. FFP's default is `false`, which covers a key it does not serve and a flag that is not
   * a boolean (FFP falls back to the default for a type mismatch).
   */ checkGate(gateName, fireExposure) {
        if (!this.client || !this.has(gateName)) return false;
        return this.client.getBooleanValue(gateName, false, $717b16e0f29393a7$var$toEvaluationOptions(fireExposure));
    }
    /**
   * Config (experiment or dynamic config) read.
   *
   * JSON object flags are Statsig experiments and are returned as their parameters. Every other
   * value is a flattened Statsig dynamic config, so it is returned as `{ value }`. When FFP does not
   * serve the key or falls back to a code default, the config is empty so the caller's default
   * applies.
   */ getConfig(configName, fireExposure) {
        const flag = this.getFlag(configName);
        if (!this.client || !flag) return $717b16e0f29393a7$var$EMPTY_CONFIG;
        const { value: value, metadata: metadata } = this.readDetails(this.client, configName, flag, $717b16e0f29393a7$var$toEvaluationOptions(fireExposure));
        const ruleId = metadata.ruleId ?? '';
        if (value === $717b16e0f29393a7$var$NOT_SERVED) return {
            value: {},
            ruleId: ruleId
        };
        return {
            value: $717b16e0f29393a7$var$isPlainObject(value) ? value : {
                value: value
            },
            ruleId: ruleId
        };
    }
    /** Logs an exposure for a gate served by FFP. */ logGateExposure(gateName) {
        this.checkGate(gateName, true);
    }
    /** Logs an exposure for a config served by FFP. */ logConfigExposure(configName) {
        this.getConfig(configName, true);
    }
    getFlag(flagKey) {
        if (!this.flags || !Object.prototype.hasOwnProperty.call(this.flags, flagKey)) return undefined;
        return this.flags[flagKey];
    }
    readDetails(client, flagKey, flag, options) {
        // The sentinel is returned by identity on every fallback; the casts only satisfy the typed
        // read signatures.
        switch(flag.returnType){
            case 'BOOLEAN':
                return client.getBooleanDetails(flagKey, $717b16e0f29393a7$var$NOT_SERVED, options);
            case 'STRING':
                return client.getStringDetails(flagKey, $717b16e0f29393a7$var$NOT_SERVED, options);
            case 'NUMBER':
                return client.getNumberDetails(flagKey, $717b16e0f29393a7$var$NOT_SERVED, options);
            default:
                return client.getObjectDetails(flagKey, $717b16e0f29393a7$var$NOT_SERVED, options);
        }
    }
}
const $717b16e0f29393a7$var$toEvaluationOptions = (fireExposure)=>({
        disableExposureLogging: !fireExposure
    });

});
parcelRegister("8HOA0", function(module, exports) {
$parcel$export(module.exports, "FlagClient", () => $7fcfdd69e350d5d0$export$603f1f22d15d0fb5);

var $lxI0W = parcelRequire("lxI0W");

var $kBwwj = parcelRequire("kBwwj");

var $7MYjT = parcelRequire("7MYjT");

var $28Z3d = parcelRequire("28Z3d");

var $k1euP = parcelRequire("k1euP");

var $6PhJH = parcelRequire("6PhJH");

var $3IggU = parcelRequire("3IggU");

var $at1lo = parcelRequire("at1lo");

var $3W0VD = parcelRequire("3W0VD");

var $b8Wx5 = parcelRequire("b8Wx5");

var $dbqWz = parcelRequire("dbqWz");

var $1ENyO = parcelRequire("1ENyO");
const $7fcfdd69e350d5d0$var$ACQUISITION_FAILURE_TIPS = {
    provider_threw: 'Check the payload provider for thrown errors and confirm it synchronously returns a BulkEvaluationPayload.',
    provider_returned_no_payload: 'Confirm the payload provider returns a BulkEvaluationPayload value instead of null or undefined.',
    invalid_schema_version: 'Supply a payload whose vs schema version is "1", or omit vs.',
    invalid_payload_shape: 'Validate the provider result against the BulkEvaluationPayload shape before passing the provider to the client.',
    payload_capture_failed: 'Ensure the payload only contains cloneable data so the SDK can capture an immutable snapshot.'
};
const $7fcfdd69e350d5d0$var$INITIALIZATION_FAILURE_TIPS = {
    ...$7fcfdd69e350d5d0$var$ACQUISITION_FAILURE_TIPS,
    already_initialized: 'Call replace() to serve a different payload or user from an initialized FlagClient.'
};
const $7fcfdd69e350d5d0$var$REPLACEMENT_FAILURE_TIPS = {
    ...$7fcfdd69e350d5d0$var$ACQUISITION_FAILURE_TIPS,
    not_initialized: 'Call initialize() successfully before calling replace().'
};
const $7fcfdd69e350d5d0$var$EXPOSURE_OPTION_TIP = 'See ExposureLoggingOptions: enabled is a boolean, endpoint an absolute HTTP(S) URL, batchSize a positive integer, and flushIntervalMs a positive finite number.';
const $7fcfdd69e350d5d0$var$USER_NORMALIZATION_TIP = 'Pass identifier values as strings and attribute values as strings, booleans, or finite numbers.';
class $7fcfdd69e350d5d0$export$603f1f22d15d0fb5 {
    initialized = null;
    /**
   * The normalized user from the most recent initialization attempt that did not fail with
   * `already_initialized`, or from the most recent successful replacement after it. Set even when
   * that initialization attempt fails, so exposure telemetry can attribute uninitialized reads.
   * `EMPTY_USER` before any such attempt, so reads need only check `initialized`.
   */ currentUser = (0, $1ENyO.EMPTY_USER);
    /**
   * Each details read's exposure inputs, keyed by the returned metadata object, so a manual exposure
   * reproduces its read's attribution. Shallow copies of details share the metadata object.
   */ exposureContexts = new WeakMap();
    /**
   * The identifier part of the last deduplication identity and the request context or user it was
   * built from. Both are replaced, never mutated, on `initialize` and `replace`.
   */ cachedIdentifiersKey = null;
    retained;
    /**
   * Where reads send their exposures: the delivery subsystem once it has loaded, a buffer that
   * replays into it until then, or the no-op sink when exposure logging is disabled.
   */ exposureSink;
    /**
   * The clock an enabled client stamps its exposures with, and the flag that it logs at all; `null`
   * when exposure logging is disabled. The rest of the host environment belongs to the delivery
   * subsystem and is constructed with it.
   */ exposureClock;
    /** Exposure resource identity, resolved once from the construction options. */ exposureIdentity;
    /**
   * Create an uninitialized client for one target app and environment.
   *
   * Copies the option values without validating them and never throws. Unsupported exposure
   * logging options are ignored with one warning each, naming the option but never its value.
   */ constructor(options){
        const captured = $7fcfdd69e350d5d0$var$captureOptions(options);
        this.retained = {
            options: captured,
            lastInitializeFailure: null,
            rejectedSchemaVersion: null
        };
        this.exposureIdentity = (0, $kBwwj.resolveExposureIdentity)(captured);
        const exposureLogging = (0, $3IggU.resolveExposureLogging)(captured.exposureLogging, {
            hasWindow: typeof window !== 'undefined',
            origin: $7fcfdd69e350d5d0$var$windowOrigin()
        });
        for (const option of exposureLogging.unsupported)// eslint-disable-next-line no-console -- diagnostics are part of the client's documented contract
        console.warn('Flag client ignored an unsupported exposure logging option', {
            option: option,
            tip: $7fcfdd69e350d5d0$var$EXPOSURE_OPTION_TIP
        });
        let clock = null;
        let sink = (0, $at1lo.NOOP_EXPOSURE_SINK);
        if (exposureLogging.enabled) try {
            clock = (0, $7MYjT.createExposureClock)();
            sink = this.openSink(exposureLogging.delivery);
        } catch  {
            // Construction never throws, so a host that cannot run exposure delivery logs nothing.
            clock = null;
            sink = (0, $at1lo.NOOP_EXPOSURE_SINK);
        }
        this.exposureClock = clock;
        this.exposureSink = sink;
    }
    /**
   * The sink for an enabled client.
   *
   * The delivery subsystem is loaded on demand, so it is normally still arriving while the first
   * flags are read. Until it arrives those exposures are buffered and then replayed into it, so a
   * read on the critical path logs the same exposure an eagerly loaded subsystem would have logged.
   * A subsystem that fails to load leaves the client logging nothing, as a host that cannot run
   * delivery does.
   */ openSink(options) {
        const delivery = (0, $k1euP.loadExposureDelivery)();
        if (!$7fcfdd69e350d5d0$var$isPending(delivery)) return (0, $at1lo.deliveringSink)(delivery.createExposureLogger(options, delivery.createExposureEnvironment()), delivery);
        const buffer = new (0, $at1lo.BufferingExposureSink)();
        // These callbacks run in a later microtask than the constructor, so the assignment below never
        // races the one the constructor makes from this method's return value.
        delivery.then((loaded)=>{
            let sink;
            try {
                sink = (0, $at1lo.deliveringSink)(loaded.createExposureLogger(options, loaded.createExposureEnvironment()), loaded);
            } catch  {
                this.exposureSink = (0, $at1lo.NOOP_EXPOSURE_SINK);
                return;
            }
            buffer.replayInto(sink);
            this.exposureSink = sink;
        }, ()=>{
            this.exposureSink = (0, $at1lo.NOOP_EXPOSURE_SINK);
        });
        return buffer;
    }
    /**
   * Initialize the client once from a synchronous payload provider.
   *
   * Checks run in order: `already_initialized`, user normalization, then payload acquisition. Never
   * throws.
   */ initialize(provider, user) {
        if (this.initialized !== null) return this.warnInitializationFailure({
            initialized: false,
            reason: 'already_initialized'
        });
        this.currentUser = this.normalizeAndWarn(user, 'initialize');
        const acquisition = $7fcfdd69e350d5d0$var$acquirePayload(provider);
        if (!acquisition.acquired) {
            this.retained.lastInitializeFailure = acquisition.reason;
            this.retained.rejectedSchemaVersion = acquisition.rejectedSchemaVersion ?? null;
            return this.warnInitializationFailure({
                initialized: false,
                reason: acquisition.reason,
                ...acquisition.error !== undefined ? {
                    error: acquisition.error
                } : {}
            });
        }
        this.initialized = {
            payload: acquisition.payload
        };
        this.retained.lastInitializeFailure = null;
        this.retained.rejectedSchemaVersion = null;
        return {
            initialized: true
        };
    }
    /**
   * Replace the payload and user of an initialized client together.
   *
   * Fails with `not_initialized`, without invoking the provider or normalizing the user, before a
   * successful initialization. Any other failure keeps the previous payload and user. Never throws.
   */ replace(provider, user) {
        if (this.initialized === null) return this.warnReplacementFailure({
            replaced: false,
            reason: 'not_initialized'
        });
        const replacementUser = this.normalizeAndWarn(user, 'replace');
        const acquisition = $7fcfdd69e350d5d0$var$acquirePayload(provider);
        if (!acquisition.acquired) return this.warnReplacementFailure({
            replaced: false,
            reason: acquisition.reason,
            ...acquisition.error !== undefined ? {
                error: acquisition.error
            } : {}
        });
        this.initialized = {
            payload: acquisition.payload
        };
        this.currentUser = replacementUser;
        this.exposureSink.endDeduplicationWindows();
        return {
            replaced: true
        };
    }
    getBooleanValue(flagKey, safeDefaultValue, options) {
        return this.read((0, $lxI0W.evaluateBooleanFlag), flagKey, safeDefaultValue, options, false).value;
    }
    getStringValue(flagKey, safeDefaultValue, options) {
        return this.read((0, $lxI0W.evaluateStringFlag), flagKey, safeDefaultValue, options, false).value;
    }
    getNumberValue(flagKey, safeDefaultValue, options) {
        return this.read((0, $lxI0W.evaluateNumberFlag), flagKey, safeDefaultValue, options, false).value;
    }
    getObjectValue(flagKey, safeDefaultValue, options) {
        return this.read((0, $lxI0W.evaluateObjectFlag), flagKey, safeDefaultValue, options, false).value;
    }
    getBooleanDetails(flagKey, safeDefaultValue, options) {
        return this.read((0, $lxI0W.evaluateBooleanFlag), flagKey, safeDefaultValue, options, true);
    }
    getStringDetails(flagKey, safeDefaultValue, options) {
        return this.read((0, $lxI0W.evaluateStringFlag), flagKey, safeDefaultValue, options, true);
    }
    getNumberDetails(flagKey, safeDefaultValue, options) {
        return this.read((0, $lxI0W.evaluateNumberFlag), flagKey, safeDefaultValue, options, true);
    }
    getObjectDetails(flagKey, safeDefaultValue, options) {
        return this.read((0, $lxI0W.evaluateObjectFlag), flagKey, safeDefaultValue, options, true);
    }
    /**
   * Log one manual exposure for details obtained from this client, typically after a read with
   * `disableExposureLogging`. Details this client returned reproduce the exposure their read would
   * have produced; for any other details, attribution comes from the client's current state. Does
   * nothing when exposure logging is disabled and never throws.
   */ logExposure(details) {
        if (this.exposureClock === null) return;
        try {
            const metadata = details?.metadata;
            // Caller-built metadata without these would queue a record with no flag key or reason.
            if (typeof metadata !== 'object' || metadata === null) return;
            const { flagKey: flagKey, matchReason: matchReason } = metadata;
            if (!(0, $dbqWz.isString)(flagKey) || !(0, $dbqWz.isString)(matchReason)) return;
            const context = this.exposureContexts.get(metadata) ?? this.exposureContext(this.initialized === null ? null : (0, $lxI0W.ownFlagResult)(this.initialized.payload.flags, flagKey) ?? null);
            this.recordExposure(details, context, true);
        } catch  {
        // Exposure telemetry must never affect the caller.
        }
    }
    /** The one read path: evaluate, record at most one automatic exposure, return the details. */ read(evaluate, flagKey, safeDefaultValue, options, // Only returned details can reach `logExposure`, so value reads keep no context.
    retainContext) {
        const outcome = evaluate(this.evaluationState(), flagKey, safeDefaultValue);
        if (this.exposureClock !== null) try {
            const record = options?.disableExposureLogging !== true;
            // A suppressed value read neither records nor retains, so it builds no context.
            if (record || retainContext) {
                const context = this.exposureContext(outcome.flagResult);
                if (retainContext) this.exposureContexts.set(outcome.details.metadata, context);
                if (record) this.recordExposure(outcome.details, context, false);
            }
        } catch  {
        // Exposure telemetry must never change or fail a read.
        }
        return outcome.details;
    }
    /** Queue one exposure unless deduplicated. The record is built only when it is queued. */ recordExposure(details, context, manual) {
        const clock = this.exposureClock;
        if (clock === null) return;
        const { flagKey: flagKey, variationId: variationId, ruleId: ruleId, matchReason: matchReason } = details.metadata;
        const identityKey = (0, $28Z3d.exposureIdentityKey)({
            flagKey: flagKey,
            variationId: variationId,
            ruleId: ruleId,
            matchReason: matchReason,
            identifiersKey: this.identifiersKey(context)
        });
        this.exposureSink.log(identityKey, {
            ...context,
            details: details,
            identity: this.exposureIdentity,
            manual: manual,
            epochMillis: clock.now()
        });
    }
    /** The identifier part of the deduplication identity, recomputed only when its source changes. */ identifiersKey(context) {
        const source = context.requestContext ?? context.user;
        let cached = this.cachedIdentifiersKey;
        if (cached?.source !== source) {
            cached = {
                source: source,
                key: (0, $28Z3d.exposureIdentifiersKey)((0, $6PhJH.attributionIdentifiers)(context))
            };
            this.cachedIdentifiersKey = cached;
        }
        return cached.key;
    }
    /** The exposure inputs current state supplies for a read of a flag with this payload result. */ exposureContext(flagResult) {
        const payload = this.initialized?.payload;
        return {
            flagResult: flagResult,
            user: this.currentUser,
            initialization: this.initializationStatus(),
            ...payload !== undefined ? {
                requestContext: payload.requestContext
            } : {},
            ...payload?.clientVersion !== undefined ? {
                clientVersion: payload.clientVersion
            } : {}
        };
    }
    /**
   * Initialization as exposures see it, from FFP-141's retained most recent failure reason and
   * rejected schema version.
   */ initializationStatus() {
        if (this.initialized !== null) return 0, $kBwwj.INITIALIZED;
        const { lastInitializeFailure: lastInitializeFailure, rejectedSchemaVersion: rejectedSchemaVersion } = this.retained;
        return {
            state: 'uninitialized',
            lastFailureReason: lastInitializeFailure,
            ...rejectedSchemaVersion === null ? {} : {
                rejectedSchemaVersion: rejectedSchemaVersion
            }
        };
    }
    /** Read state, or `null` while uninitialized. */ evaluationState() {
        if (this.initialized === null) return null;
        return {
            payload: this.initialized.payload,
            user: this.currentUser
        };
    }
    /** Normalize a user and emit at most one warning naming discarded keys, never values. */ normalizeAndWarn(user, operation) {
        const normalization = (0, $1ENyO.normalizeUser)(user);
        if ((0, $1ENyO.hasNormalizationFindings)(normalization)) // eslint-disable-next-line no-console -- diagnostics are part of the client's documented contract
        console.warn('Flag client user normalization dropped invalid entries', {
            operation: operation,
            droppedEntries: normalization.droppedEntries,
            emptyMembers: normalization.emptyMembers,
            tip: $7fcfdd69e350d5d0$var$USER_NORMALIZATION_TIP
        });
        return normalization.user;
    }
    warnInitializationFailure(result) {
        // eslint-disable-next-line no-console -- diagnostics are part of the client's documented contract
        console.warn('Flag client initialization failed', {
            reason: result.reason,
            tip: $7fcfdd69e350d5d0$var$INITIALIZATION_FAILURE_TIPS[result.reason],
            ...result.error !== undefined ? {
                error: result.error
            } : {}
        });
        return result;
    }
    warnReplacementFailure(result) {
        // eslint-disable-next-line no-console -- diagnostics are part of the client's documented contract
        console.warn('Flag client replacement failed', {
            reason: result.reason,
            tip: $7fcfdd69e350d5d0$var$REPLACEMENT_FAILURE_TIPS[result.reason],
            ...result.error !== undefined ? {
                error: result.error
            } : {}
        });
        return result;
    }
}
/**
 * Invoke, check, validate, and capture a provider payload. Shared by initialize and replace.
 *
 * The schema version is resolved before the rest of the shape, so a payload of another schema
 * version is reported as `invalid_schema_version` rather than `invalid_payload_shape`. Each version
 * is then validated against its own wire format.
 */ function $7fcfdd69e350d5d0$var$acquirePayload(provider) {
    let candidate;
    try {
        candidate = provider();
    } catch (error) {
        return {
            acquired: false,
            reason: 'provider_threw',
            error: error
        };
    }
    if (candidate == null) return {
        acquired: false,
        reason: 'provider_returned_no_payload'
    };
    try {
        return $7fcfdd69e350d5d0$var$inspectPayload(candidate);
    } catch (error) {
        // A payload that throws while it is read, such as a revoked proxy or a throwing getter, cannot
        // be validated; reporting it keeps initialize and replace from throwing.
        return {
            acquired: false,
            reason: 'invalid_payload_shape',
            error: error
        };
    }
}
/** Resolve the schema version, then validate and capture the payload against that version. */ function $7fcfdd69e350d5d0$var$inspectPayload(candidate) {
    if (!(0, $b8Wx5.isRecord)(candidate)) return {
        acquired: false,
        reason: 'invalid_payload_shape'
    };
    const schemaVersion = (0, $b8Wx5.payloadSchemaVersion)(candidate);
    if (schemaVersion === null) return {
        acquired: false,
        reason: 'invalid_schema_version',
        ...(0, $dbqWz.isString)(candidate.vs) ? {
            rejectedSchemaVersion: candidate.vs
        } : {}
    };
    // A later schema version adds a case that validates its wire format and converts it into the
    // internal model that reads and exposure telemetry use; version 1 is currently that model.
    switch(schemaVersion){
        case '1':
            return $7fcfdd69e350d5d0$var$acquireVersion1Payload(candidate);
    }
}
function $7fcfdd69e350d5d0$var$acquireVersion1Payload(candidate) {
    if (!(0, $b8Wx5.isValidBulkEvaluationPayloadV1)(candidate)) return {
        acquired: false,
        reason: 'invalid_payload_shape'
    };
    const payload = (0, $3W0VD.capturePayload)(candidate, $7fcfdd69e350d5d0$var$withRequestContextAttributes);
    if (payload === null) return {
        acquired: false,
        reason: 'payload_capture_failed'
    };
    // Capture reads the provider's object again, so a getter or proxy can yield a different value than
    // the one validated above. Validate the frozen snapshot that reads will use as well. The empty
    // `attributes` is supplied on the private copy before this check, so a valid snapshot always
    // carries both request context maps. The original is still validated first because the JSON
    // capture fallback drops members such as functions, and the failure reasons must reflect what the
    // provider returned.
    if (!(0, $b8Wx5.isValidBulkEvaluationPayloadV1)(payload)) return {
        acquired: false,
        reason: 'invalid_payload_shape'
    };
    return {
        acquired: true,
        payload: payload
    };
}
/**
 * Supply an empty `attributes` to a `requestContext` that omits it, so the captured payload always
 * retains both maps.
 *
 * This runs on the private copy made during capture, which has not been validated yet; a copy that no
 * longer has an object `requestContext` is returned unchanged and fails the snapshot validation.
 */ function $7fcfdd69e350d5d0$var$withRequestContextAttributes(copy) {
    const requestContext = copy.requestContext;
    if (!(0, $b8Wx5.isRecord)(requestContext) || requestContext.attributes !== undefined) // TypeScript does not narrow the nested optional member; the snapshot validation establishes it.
    return copy;
    return {
        ...copy,
        requestContext: {
            ...requestContext,
            attributes: {}
        }
    };
}
/**
 * Copy the construction option values so later mutation of the caller's object has no effect.
 *
 * The values are deliberately not validated at runtime. Reads go through optional chaining, so an
 * untyped caller that omits the options does not throw.
 */ function $7fcfdd69e350d5d0$var$captureOptions(options) {
    const source = options;
    const serviceVersion = source?.serviceVersion;
    const exposureLogging = source?.exposureLogging;
    return Object.freeze({
        targetApp: source?.targetApp,
        environmentType: source?.environmentType,
        ...serviceVersion !== undefined ? {
            serviceVersion: serviceVersion
        } : {},
        ...exposureLogging !== undefined ? {
            exposureLogging: $7fcfdd69e350d5d0$var$copyExposureLogging(exposureLogging)
        } : {}
    });
}
/** Shallow-copy exposure logging options when they are an object; other values are kept for warnings. */ function $7fcfdd69e350d5d0$var$copyExposureLogging(value) {
    try {
        return typeof value === 'object' && value !== null && !Array.isArray(value) ? Object.freeze({
            ...value
        }) : value;
    } catch  {
        // A throwing getter or a revoked proxy is reported as an unsupported `exposureLogging`.
        return null;
    }
}
/** Whether the exposure delivery subsystem is still loading. */ function $7fcfdd69e350d5d0$var$isPending(delivery) {
    return typeof delivery.then === 'function';
}
/** The global `window` location origin, or `null` when it is absent, unreadable, or opaque. */ function $7fcfdd69e350d5d0$var$windowOrigin() {
    if (typeof window === 'undefined') return null;
    try {
        const origin = window.location?.origin;
        return typeof origin === 'string' && origin !== 'null' ? origin : null;
    } catch  {
        return null;
    }
}

});
parcelRegister("lxI0W", function(module, exports) {
$parcel$export(module.exports, "CLIENT_FALLBACK_REASONS", () => $bc2333452a7734a3$export$3fdc239d777dd274);
$parcel$export(module.exports, "evaluateBooleanFlag", () => $bc2333452a7734a3$export$7f8a3203042948c);
$parcel$export(module.exports, "evaluateStringFlag", () => $bc2333452a7734a3$export$9884a797df8b2531);
$parcel$export(module.exports, "evaluateNumberFlag", () => $bc2333452a7734a3$export$c410031c8f6bac62);
$parcel$export(module.exports, "evaluateObjectFlag", () => $bc2333452a7734a3$export$13075d8205b2cfdb);
$parcel$export(module.exports, "ownFlagResult", () => $bc2333452a7734a3$export$5ad4da1a5d98a00d);

var $dbqWz = parcelRequire("dbqWz");
const $bc2333452a7734a3$export$3fdc239d777dd274 = [
    'not_initialized',
    'flag_not_found',
    'type_mismatch'
];
const $bc2333452a7734a3$var$NO_SEGMENTS = Object.freeze([]);
function $bc2333452a7734a3$export$7f8a3203042948c(state, flagKey, safeDefaultValue) {
    return $bc2333452a7734a3$var$evaluateFlag(state, flagKey, 'BOOLEAN', safeDefaultValue, $bc2333452a7734a3$var$isBoolean);
}
function $bc2333452a7734a3$export$9884a797df8b2531(state, flagKey, safeDefaultValue) {
    return $bc2333452a7734a3$var$evaluateFlag(state, flagKey, 'STRING', safeDefaultValue, (0, $dbqWz.isString));
}
function $bc2333452a7734a3$export$c410031c8f6bac62(state, flagKey, safeDefaultValue) {
    return $bc2333452a7734a3$var$evaluateFlag(state, flagKey, 'NUMBER', safeDefaultValue, $bc2333452a7734a3$var$isNumber);
}
function $bc2333452a7734a3$export$13075d8205b2cfdb(state, flagKey, safeDefaultValue) {
    return $bc2333452a7734a3$var$evaluateFlag(state, flagKey, 'JSON', safeDefaultValue, (value)=>$bc2333452a7734a3$var$isJsonContainer(value));
}
function $bc2333452a7734a3$export$5ad4da1a5d98a00d(flags, flagKey) {
    return (0, $dbqWz.hasOwn)(flags, flagKey) ? flags[flagKey] : undefined;
}
function $bc2333452a7734a3$var$evaluateFlag(state, flagKey, expectedReturnType, safeDefaultValue, isExpectedValue) {
    if (state === null) return $bc2333452a7734a3$var$fallbackDetails(flagKey, safeDefaultValue, 'not_initialized');
    const flagResult = $bc2333452a7734a3$export$5ad4da1a5d98a00d(state.payload.flags, flagKey);
    if (flagResult === undefined) return $bc2333452a7734a3$var$fallbackDetails(flagKey, safeDefaultValue, 'flag_not_found');
    if (flagResult.returnType !== expectedReturnType) return $bc2333452a7734a3$var$fallbackDetails(flagKey, safeDefaultValue, 'type_mismatch', flagResult);
    if (flagResult.useCodeDefault) return {
        details: {
            value: safeDefaultValue,
            metadata: $bc2333452a7734a3$var$metadataFromResult(flagKey, state.user, flagResult)
        },
        flagResult: flagResult
    };
    if (!isExpectedValue(flagResult.value)) return $bc2333452a7734a3$var$fallbackDetails(flagKey, safeDefaultValue, 'type_mismatch', flagResult);
    return {
        details: {
            value: flagResult.value,
            metadata: $bc2333452a7734a3$var$metadataFromResult(flagKey, state.user, flagResult)
        },
        flagResult: flagResult
    };
}
function $bc2333452a7734a3$var$fallbackDetails(flagKey, value, matchReason, flagResult = null) {
    const metadata = {
        flagKey: flagKey,
        identifierType: null,
        identifierValue: null,
        matchReason: matchReason,
        variationId: null,
        ruleId: null,
        holdoutAllocation: null,
        segments: $bc2333452a7734a3$var$NO_SEGMENTS
    };
    return {
        details: {
            value: value,
            metadata: metadata
        },
        flagResult: flagResult
    };
}
/**
 * Build details metadata for a payload-backed result.
 *
 * `identifierValue` comes from the current user, never from the payload request context. The holdout
 * allocation and segment list are the captured, already-frozen values, so no per-read copy is
 * needed.
 */ function $bc2333452a7734a3$var$metadataFromResult(flagKey, user, result) {
    const identifierType = result.metadata.identifierType ?? null;
    return {
        flagKey: flagKey,
        identifierType: identifierType,
        identifierValue: identifierType === null ? null : user.identifiers[identifierType] ?? null,
        matchReason: result.metadata.matchReason,
        variationId: result.metadata.variationId ?? null,
        ruleId: result.metadata.ruleId ?? null,
        holdoutAllocation: result.metadata.holdoutAllocation ?? null,
        segments: result.metadata.segments ?? $bc2333452a7734a3$var$NO_SEGMENTS
    };
}
function $bc2333452a7734a3$var$isBoolean(value) {
    return typeof value === 'boolean';
}
function $bc2333452a7734a3$var$isNumber(value) {
    return typeof value === 'number' && Number.isFinite(value);
}
function $bc2333452a7734a3$var$isJsonContainer(value) {
    return typeof value === 'object' && value !== null;
}

});
parcelRegister("dbqWz", function(module, exports) {
$parcel$export(module.exports, "isString", () => $0bc999ec122bbe83$export$844ec244b1367d54);
$parcel$export(module.exports, "hasOwn", () => $0bc999ec122bbe83$export$b5a638e9b3fff9f3);
/** Shared internal type guards. Not part of the public API. */ /** Whether a value is a string primitive. */ function $0bc999ec122bbe83$export$844ec244b1367d54(value) {
    return typeof value === 'string';
}
function $0bc999ec122bbe83$export$b5a638e9b3fff9f3(value, property) {
    return Object.prototype.hasOwnProperty.call(value, property);
}

});


parcelRegister("kBwwj", function(module, exports) {
$parcel$export(module.exports, "resolveExposureIdentity", () => $d6433289263edb9f$export$489c90dada9f64a4);
$parcel$export(module.exports, "isNonBlankString", () => $d6433289263edb9f$export$eba10bf061757d82);
$parcel$export(module.exports, "isEnvironmentType", () => $d6433289263edb9f$export$ba2ce149416198d2);
$parcel$export(module.exports, "INITIALIZED", () => $d6433289263edb9f$export$1ed1792d90fa81b2);
$parcel$export(module.exports, "notInitializedMessage", () => $d6433289263edb9f$export$392eab774f060ef0);
/** Resource identity and not-initialized messages for exposures. Not part of the public API. */ 
var $hzuqC = parcelRequire("hzuqC");
/** The `deployment.environment_type` values exposures may report. */ const $d6433289263edb9f$var$ENVIRONMENT_TYPES = new Set(Object.keys({
    dev: true,
    local: true,
    staging: true,
    prod: true
}));
function $d6433289263edb9f$export$489c90dada9f64a4(options) {
    const targetApp = $d6433289263edb9f$export$eba10bf061757d82(options.targetApp) ? options.targetApp : null;
    const environmentType = $d6433289263edb9f$export$ba2ce149416198d2(options.environmentType) ? options.environmentType : undefined;
    const serviceVersion = $d6433289263edb9f$export$eba10bf061757d82(options.serviceVersion) ? options.serviceVersion : undefined;
    return Object.freeze({
        resource: Object.freeze({
            serviceName: targetApp ?? (0, $hzuqC.PACKAGE_NAME),
            ...environmentType === undefined ? {} : {
                environmentType: environmentType
            },
            ...serviceVersion === undefined ? {} : {
                serviceVersion: serviceVersion
            }
        }),
        flagSetId: targetApp
    });
}
const $d6433289263edb9f$export$1ed1792d90fa81b2 = Object.freeze({
    state: 'initialized'
});
const $d6433289263edb9f$export$5f2944b911ea68d7 = Object.freeze({
    state: 'uninitialized',
    lastFailureReason: null
});
/** Characters of a rejected schema version kept in a message before it is cut short with `...`. */ const $d6433289263edb9f$var$MESSAGE_SCHEMA_VERSION_LENGTH = 16;
function $d6433289263edb9f$export$392eab774f060ef0(status) {
    if (status.state === 'initialized') return undefined;
    const reason = status.lastFailureReason;
    const cause = reason === null ? 'no initialize attempt completed' : reason === 'invalid_schema_version' && status.rejectedSchemaVersion !== undefined ? `${reason} ${$d6433289263edb9f$var$quoteForMessage(status.rejectedSchemaVersion)}` : reason;
    return `FFP evaluation failed: not_initialized (${cause})`;
}
/**
 * The value as a JSON string, cut to the message length on a code point boundary and followed by
 * `...` outside the quotes when cut, so a cut value cannot be mistaken for one ending in `...`.
 */ function $d6433289263edb9f$var$quoteForMessage(value) {
    const codePoints = Array.from(value);
    return codePoints.length <= $d6433289263edb9f$var$MESSAGE_SCHEMA_VERSION_LENGTH ? JSON.stringify(value) : `${JSON.stringify(codePoints.slice(0, $d6433289263edb9f$var$MESSAGE_SCHEMA_VERSION_LENGTH).join(''))}...`;
}
function $d6433289263edb9f$export$eba10bf061757d82(value) {
    return typeof value === 'string' && value.trim() !== '';
}
function $d6433289263edb9f$export$ba2ce149416198d2(value) {
    return typeof value === 'string' && $d6433289263edb9f$var$ENVIRONMENT_TYPES.has(value);
}

});
parcelRegister("hzuqC", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $852c99c9a9115097$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_VERSION", () => $852c99c9a9115097$export$4a03ffab3315ee34);
/** Package identity used for telemetry. Not part of the public API. */ /**
 * The npm package name, injected at build time from `package.json`; also the exposure
 * Instrumentation Scope name.
 */ const $852c99c9a9115097$export$b8b9d90f9e5bd72b = undefined;
const $852c99c9a9115097$export$4a03ffab3315ee34 = undefined;

});


parcelRegister("7MYjT", function(module, exports) {
$parcel$export(module.exports, "createExposureClock", () => $7c1e0002c2beacf6$export$d9328b5eabf56099);
/**
 * The clock a read stamps its exposure with. Not part of the public API.
 *
 * This is the one host capability the client needs before the delivery subsystem has loaded, so it
 * is deliberately separate from {@link ExposureEnvironment}: an exposure buffered on the critical
 * path must carry the time its read observed, while everything else the subsystem touches — storage,
 * `fetch`, timers, page lifecycle — is constructed with the subsystem itself.
 */ function $7c1e0002c2beacf6$export$2e1d42eb26789c5() {
    return {
        now: ()=>Date.now()
    };
}
let $7c1e0002c2beacf6$var$clockFactory = $7c1e0002c2beacf6$export$2e1d42eb26789c5;
function $7c1e0002c2beacf6$export$d9328b5eabf56099() {
    return $7c1e0002c2beacf6$var$clockFactory();
}
function $7c1e0002c2beacf6$export$3d826b815b6de58a(factory) {
    $7c1e0002c2beacf6$var$clockFactory = factory ?? $7c1e0002c2beacf6$export$2e1d42eb26789c5;
}

});

parcelRegister("28Z3d", function(module, exports) {
$parcel$export(module.exports, "exposureIdentifiersKey", () => $4b85bf8f0aa6194d$export$f26b09663eabb5d3);
$parcel$export(module.exports, "exposureIdentityKey", () => $4b85bf8f0aa6194d$export$ca3dbc1b93284651);
$parcel$export(module.exports, "ExposureDeduplicator", () => $4b85bf8f0aa6194d$export$c54265a17eb3acde);
/** Exposure deduplication windows. Not part of the public API. */ /** How long an identity's queued exposure suppresses later ones with the same identity. */ const $4b85bf8f0aa6194d$export$4f403c2a3da953f4 = 600000;
function $4b85bf8f0aa6194d$export$f26b09663eabb5d3(identifiers) {
    return JSON.stringify([
        ...identifiers
    ].sort(([a], [b])=>a < b ? -1 : a > b ? 1 : 0));
}
function $4b85bf8f0aa6194d$export$ca3dbc1b93284651(parts) {
    return JSON.stringify([
        parts.flagKey,
        parts.variationId,
        parts.ruleId,
        parts.matchReason,
        parts.identifiersKey
    ]);
}
class $4b85bf8f0aa6194d$export$c54265a17eb3acde {
    windowStarts = new Map();
    /**
   * Whether an exposure produced at `nowMs` should be queued. Admitting it starts a new window, so
   * later exposures with the same identity are discarded until the window has passed. A clock that
   * moves back before the window's start also ends it, so suppression never outlasts the window.
   */ admit(identityKey, nowMs) {
        const start = this.windowStarts.get(identityKey);
        if (start !== undefined && nowMs >= start && nowMs - start <= $4b85bf8f0aa6194d$export$4f403c2a3da953f4) return false;
        this.windowStarts.set(identityKey, nowMs);
        return true;
    }
    /** End the window `admit` just started, for an exposure that was not queued after all. */ forget(identityKey) {
        this.windowStarts.delete(identityKey);
    }
    /** End every window, as a successful replacement requires. */ clear() {
        this.windowStarts.clear();
    }
}

});

parcelRegister("k1euP", function(module, exports) {
$parcel$export(module.exports, "loadExposureDelivery", () => $f6171e246492ac2f$export$79a84ccee9aa0b0);
/**
 * How the client obtains the exposure delivery subsystem. Not part of the public API.
 *
 * Loading is on demand, so a client that logs nothing never downloads it and a client that does
 * keeps it off the critical path. The result is deliberately a value or a promise: tests, and any
 * host that has already supplied the subsystem, construct their logger synchronously.
 */ let $f6171e246492ac2f$var$supplied;

function $f6171e246492ac2f$export$79a84ccee9aa0b0() {
    // @ts-ignore TS2835: a relative import() must name its file under `nodenext`, which only the prebuilt tools' declaration build uses
    return $f6171e246492ac2f$var$supplied ?? (parcelRequire("2yUOo"));
}
function $f6171e246492ac2f$export$14fb2985a3fdae6f(delivery) {
    $f6171e246492ac2f$var$supplied = delivery;
}

});
parcelRegister("2yUOo", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("bST3O").then(()=>parcelRequire('8Auj8'));

});
parcelRegister("7mhPs", function(module, exports) {
"use strict";

function $55b86af18518ded8$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("7p89F")).resolve(id));
}
module.exports = $55b86af18518ded8$var$load;

});
parcelRegister("7p89F", function(module, exports) {
$parcel$export(module.exports, "register", () => $564131a031794f5a$export$6503ec6e8aabbaf, (v) => $564131a031794f5a$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $564131a031794f5a$export$f7ad0328861e2f03, (v) => $564131a031794f5a$export$f7ad0328861e2f03 = v);
var $564131a031794f5a$export$6503ec6e8aabbaf;
var $564131a031794f5a$export$f7ad0328861e2f03;
"use strict";
var $564131a031794f5a$var$mapping = new Map();
function $564131a031794f5a$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$564131a031794f5a$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $564131a031794f5a$var$resolve(id) {
    var resolved = $564131a031794f5a$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$564131a031794f5a$export$6503ec6e8aabbaf = $564131a031794f5a$var$register;
$564131a031794f5a$export$f7ad0328861e2f03 = $564131a031794f5a$var$resolve;

});




parcelRegister("6PhJH", function(module, exports) {
$parcel$export(module.exports, "attributionIdentifiers", () => $d7001d82b01976f7$export$2e8d7a22d44742f1);
$parcel$export(module.exports, "isNonEmptyString", () => $d7001d82b01976f7$export$e1fe2eb830813601);
/**
 * The attribution identifiers of an exposure, and the string check exposure mapping shares with
 * them. Separate from the mapper so a read can build its deduplication identity without loading the
 * delivery subsystem. Not part of the public API.
 */ function $d7001d82b01976f7$export$2e8d7a22d44742f1(input) {
    return Object.entries((input.requestContext ?? input.user).identifiers).filter((entry)=>entry[0] !== '' && $d7001d82b01976f7$export$e1fe2eb830813601(entry[1]));
}
function $d7001d82b01976f7$export$e1fe2eb830813601(value) {
    return typeof value === 'string' && value !== '';
}

});

parcelRegister("3IggU", function(module, exports) {
$parcel$export(module.exports, "resolveExposureLogging", () => $e50759b0c068c769$export$294a4baefb36c792);
/** Exposure logging option resolution. Not part of the public API. */ const $e50759b0c068c769$export$a658c6a2a046acde = 'https://xp.atlassian.com/ft/v1/logs';
const $e50759b0c068c769$export$45b7810513497e4d = 100;
const $e50759b0c068c769$export$5f8135784e47aa61 = 10000;
function $e50759b0c068c769$export$294a4baefb36c792(raw, host) {
    const unsupported = [];
    let source = {};
    if (raw !== undefined) {
        if (typeof raw === 'object' && raw !== null && !Array.isArray(raw)) source = raw;
        else unsupported.push('exposureLogging');
    }
    const pick = (name, resolve, fallback)=>{
        const value = source[name];
        if (value === undefined) return fallback;
        const resolved = resolve(value);
        if (resolved !== undefined) return resolved;
        unsupported.push(name);
        return fallback;
    };
    const enabled = pick('enabled', $e50759b0c068c769$var$asBoolean, host.hasWindow);
    const delivery = enabled ? {
        endpoint: pick('endpoint', (value)=>$e50759b0c068c769$var$asEndpoint(value, host.origin), $e50759b0c068c769$export$a658c6a2a046acde),
        batchSize: pick('batchSize', $e50759b0c068c769$var$asPositiveInteger, $e50759b0c068c769$export$45b7810513497e4d),
        flushIntervalMs: pick('flushIntervalMs', $e50759b0c068c769$var$asPositiveFiniteNumber, $e50759b0c068c769$export$5f8135784e47aa61)
    } : {
        endpoint: $e50759b0c068c769$export$a658c6a2a046acde,
        batchSize: $e50759b0c068c769$export$45b7810513497e4d,
        flushIntervalMs: $e50759b0c068c769$export$5f8135784e47aa61
    };
    return {
        enabled: enabled,
        delivery: delivery,
        unsupported: unsupported
    };
}
function $e50759b0c068c769$var$asBoolean(value) {
    return typeof value === 'boolean' ? value : undefined;
}
function $e50759b0c068c769$var$asPositiveInteger(value) {
    return Number.isSafeInteger(value) && value > 0 ? value : undefined;
}
function $e50759b0c068c769$var$asPositiveFiniteNumber(value) {
    return typeof value === 'number' && Number.isFinite(value) && value > 0 ? value : undefined;
}
/**
 * An absolute `http:` or `https:` URL, normalized by the URL parser, or a single-slash path resolved
 * against `origin`.
 *
 * Parsing without a base rejects relative references. A second `/` or `\` would make the path
 * protocol-relative and leave the page origin, so such paths are rejected. The parser also drops
 * tab and newline characters, so a path is rejected whenever it resolves to another origin.
 */ function $e50759b0c068c769$var$asEndpoint(value, origin) {
    if (typeof value !== 'string') return undefined;
    if (value.startsWith('/')) {
        if (origin === null || value.startsWith('//') || value.startsWith('/\\')) return undefined;
        const url = $e50759b0c068c769$var$asHttpUrl(value, origin);
        return url !== undefined && new URL(url).origin === origin ? url : undefined;
    }
    return $e50759b0c068c769$var$asHttpUrl(value);
}
function $e50759b0c068c769$var$asHttpUrl(value, base) {
    try {
        const url = base === undefined ? new URL(value) : new URL(value, base);
        // Browsers reject a request to a URL with credentials, so such an endpoint could never deliver.
        const supported = (url.protocol === 'http:' || url.protocol === 'https:') && url.username === '' && url.password === '';
        return supported ? url.href : undefined;
    } catch  {
        return undefined;
    }
}

});

parcelRegister("at1lo", function(module, exports) {
$parcel$export(module.exports, "NOOP_EXPOSURE_SINK", () => $93721374966143a2$export$7f6c0ea3aef07d74);
$parcel$export(module.exports, "deliveringSink", () => $93721374966143a2$export$a72499ffc9e61d61);
$parcel$export(module.exports, "BufferingExposureSink", () => $93721374966143a2$export$bb3771f2a716fdec);
/**
 * Where a read sends its exposure: straight into the delivery subsystem, or into a buffer until that
 * subsystem has loaded. Not part of the public API.
 *
 * A sink takes the mapping input rather than a finished record, because the code that maps a record
 * is part of the subsystem being loaded.
 */ const $93721374966143a2$export$390c0a0afaa9f5ae = 1000;
const $93721374966143a2$export$7f6c0ea3aef07d74 = Object.freeze({
    log: ()=>undefined,
    endDeduplicationWindows: ()=>undefined
});
function $93721374966143a2$export$a72499ffc9e61d61(logger, delivery) {
    return {
        log: (identityKey, input)=>{
            logger.log(identityKey, ()=>delivery.mapExposureRecord(input));
        },
        endDeduplicationWindows: ()=>{
            logger.endDeduplicationWindows();
        }
    };
}
class $93721374966143a2$export$bb3771f2a716fdec {
    operations = [];
    held = 0;
    log(identityKey, input) {
        this.operations.push({
            kind: 'log',
            identityKey: identityKey,
            input: input
        });
        this.held += 1;
        if (this.held > $93721374966143a2$export$390c0a0afaa9f5ae) {
            // The push above guarantees there is one to drop.
            this.operations.splice(this.operations.findIndex((operation)=>operation.kind === 'log'), 1);
            this.held -= 1;
        }
    }
    endDeduplicationWindows() {
        this.operations.push({
            kind: 'endDeduplicationWindows'
        });
    }
    /** Replay every held operation into `sink`, in the order the client performed them. */ replayInto(sink) {
        const operations = this.operations.splice(0, this.operations.length);
        this.held = 0;
        for (const operation of operations)if (operation.kind === 'log') sink.log(operation.identityKey, operation.input);
        else sink.endDeduplicationWindows();
    }
}

});

parcelRegister("3W0VD", function(module, exports) {
$parcel$export(module.exports, "capturePayload", () => $cebcca04cd398c5a$export$37593618646e1eae);
/**
 * Capture a deeply frozen copy of a validated payload, or `null` when it cannot be copied.
 *
 * `prepare` receives the private copy before it is frozen, so derived members are computed from the
 * copy rather than from another read of the caller's object.
 */ function $cebcca04cd398c5a$export$37593618646e1eae(payload, prepare) {
    const clonedPayload = $cebcca04cd398c5a$var$clonePayload(payload);
    if (clonedPayload === null) return null;
    const prepared = prepare === undefined ? clonedPayload : prepare(clonedPayload);
    return $cebcca04cd398c5a$var$deepFreeze(prepared);
}
function $cebcca04cd398c5a$var$clonePayload(payload) {
    try {
        return structuredClone(payload);
    } catch  {
        try {
            return JSON.parse(JSON.stringify(payload));
        } catch  {
            return null;
        }
    }
}
function $cebcca04cd398c5a$var$deepFreeze(value, seen = new WeakSet()) {
    if (!$cebcca04cd398c5a$var$isObjectLike(value) || seen.has(value)) return value;
    seen.add(value);
    for (const propertyValue of Object.values(value))$cebcca04cd398c5a$var$deepFreeze(propertyValue, seen);
    return Object.freeze(value);
}
function $cebcca04cd398c5a$var$isObjectLike(value) {
    return typeof value === 'object' && value !== null;
}

});

parcelRegister("b8Wx5", function(module, exports) {
$parcel$export(module.exports, "payloadSchemaVersion", () => $6fba01fb71317c63$export$240351e8c44bdbd4);
$parcel$export(module.exports, "isValidBulkEvaluationPayloadV1", () => $6fba01fb71317c63$export$4a1f079b0fbec351);
$parcel$export(module.exports, "isRecord", () => $6fba01fb71317c63$export$6ba840931da50680);

var $dbqWz = parcelRequire("dbqWz");
const $6fba01fb71317c63$var$FLAG_RETURN_TYPES = new Set([
    'BOOLEAN',
    'STRING',
    'NUMBER',
    'JSON'
]);
const $6fba01fb71317c63$var$SUPPORTED_SCHEMA_VERSIONS = new Set([
    '1'
]);
function $6fba01fb71317c63$export$240351e8c44bdbd4(payload) {
    if (payload.vs === undefined) return '1';
    return $6fba01fb71317c63$var$SUPPORTED_SCHEMA_VERSIONS.has(payload.vs) ? payload.vs : null;
}
function $6fba01fb71317c63$export$4a1f079b0fbec351(value) {
    if (!$6fba01fb71317c63$export$6ba840931da50680(value) || value.vs !== undefined && value.vs !== '1' || !$6fba01fb71317c63$export$6ba840931da50680(value.flags)) return false;
    if (!$6fba01fb71317c63$var$isValidRequestContext(value.requestContext)) return false;
    if (value.clientVersion !== undefined && !$6fba01fb71317c63$var$isValidClientVersion(value.clientVersion)) return false;
    return Object.values(value.flags).every($6fba01fb71317c63$var$isValidFlagResult);
}
/**
 * Validate a client version: a non-empty string `token` and an optional string `updatedAt`, which is
 * not parsed as a timestamp. Other members are tolerated.
 */ function $6fba01fb71317c63$var$isValidClientVersion(value) {
    return $6fba01fb71317c63$export$6ba840931da50680(value) && typeof value.token === 'string' && value.token.length > 0 && $6fba01fb71317c63$var$isOptionalString(value.updatedAt);
}
/**
 * Validate request-context identifiers and, when present, attributes without enforcing higher-level
 * semantics. An absent `attributes` is valid; an explicit `null` is not.
 */ function $6fba01fb71317c63$var$isValidRequestContext(value) {
    if (!$6fba01fb71317c63$export$6ba840931da50680(value) || !$6fba01fb71317c63$var$isStringRecord(value.identifiers)) return false;
    return value.attributes === undefined || $6fba01fb71317c63$var$isFlagContextValueRecord(value.attributes);
}
/** Validate one per-flag result, including value presence rules for useCodeDefault. */ function $6fba01fb71317c63$var$isValidFlagResult(value) {
    if (!$6fba01fb71317c63$export$6ba840931da50680(value)) return false;
    if (!$6fba01fb71317c63$var$isFlagReturnType(value.returnType)) return false;
    if (typeof value.useCodeDefault !== 'boolean') return false;
    if (!$6fba01fb71317c63$var$isValidBulkEvaluationMetadata(value.metadata)) return false;
    return value.useCodeDefault || (0, $dbqWz.hasOwn)(value, 'value') && $6fba01fb71317c63$var$isTransportFlagValue(value.value);
}
function $6fba01fb71317c63$var$isValidBulkEvaluationMetadata(value) {
    if (!$6fba01fb71317c63$export$6ba840931da50680(value) || typeof value.matchReason !== 'string') return false;
    return $6fba01fb71317c63$var$isOptionalStringOrNull(value.identifierType) && $6fba01fb71317c63$var$isOptionalStringOrNull(value.variationId) && $6fba01fb71317c63$var$isOptionalStringOrNull(value.ruleId) && $6fba01fb71317c63$var$isOptionalRecordOrNull(value.holdoutAllocation) && $6fba01fb71317c63$var$isOptionalArrayOf(value.segments, $6fba01fb71317c63$export$6ba840931da50680) && $6fba01fb71317c63$var$isOptionalArrayOf(value.targetApps, (0, $dbqWz.isString)) && $6fba01fb71317c63$var$isOptionalString(value.flagVersion) && $6fba01fb71317c63$var$isOptionalString(value.errorMessage);
}
/**
 * Accept an omitted, `null`, or object member.
 *
 * A holdout allocation is checked only for being an object; its members pass through.
 */ function $6fba01fb71317c63$var$isOptionalRecordOrNull(value) {
    return value === undefined || value === null || $6fba01fb71317c63$export$6ba840931da50680(value);
}
/**
 * Accept an omitted member or an array whose every entry satisfies `isEntry`.
 *
 * Segment entries are checked only for being objects; their members pass through.
 */ function $6fba01fb71317c63$var$isOptionalArrayOf(value, isEntry) {
    return value === undefined || Array.isArray(value) && value.every(isEntry);
}
function $6fba01fb71317c63$var$isOptionalString(value) {
    return value === undefined || (0, $dbqWz.isString)(value);
}
function $6fba01fb71317c63$var$isFlagReturnType(value) {
    return typeof value === 'string' && $6fba01fb71317c63$var$FLAG_RETURN_TYPES.has(value);
}
function $6fba01fb71317c63$var$isFlagContextValueRecord(value) {
    return $6fba01fb71317c63$export$6ba840931da50680(value) && Object.values(value).every((entry)=>typeof entry === 'string' || typeof entry === 'number' || typeof entry === 'boolean');
}
function $6fba01fb71317c63$var$isStringRecord(value) {
    return $6fba01fb71317c63$export$6ba840931da50680(value) && Object.values(value).every((entry)=>typeof entry === 'string');
}
function $6fba01fb71317c63$var$isOptionalStringOrNull(value) {
    return value === undefined || value === null || typeof value === 'string';
}
/** Accept transport-safe primitive values plus JSON composite values for JSON flags. */ function $6fba01fb71317c63$var$isTransportFlagValue(value) {
    if (typeof value === 'string' || typeof value === 'boolean') return true;
    if (typeof value === 'number') return Number.isFinite(value);
    return $6fba01fb71317c63$var$isJsonContainer(value);
}
/** Accept JSON object or array containers when all nested entries are JSON-compatible. */ function $6fba01fb71317c63$var$isJsonContainer(value) {
    if (!$6fba01fb71317c63$var$isObjectLike(value)) return false;
    return Object.values(value).every($6fba01fb71317c63$var$isJsonCompatibleValue);
}
/** Recursively validate JSON-compatible nested values used inside transport JSON containers. */ function $6fba01fb71317c63$var$isJsonCompatibleValue(value) {
    if (value === null || typeof value === 'string' || typeof value === 'boolean') return true;
    if (typeof value === 'number') return Number.isFinite(value);
    return $6fba01fb71317c63$var$isObjectLike(value) && Object.values(value).every($6fba01fb71317c63$var$isJsonCompatibleValue);
}
function $6fba01fb71317c63$export$6ba840931da50680(value) {
    return $6fba01fb71317c63$var$isObjectLike(value) && !Array.isArray(value);
}
function $6fba01fb71317c63$var$isObjectLike(value) {
    return typeof value === 'object' && value !== null;
}

});

parcelRegister("1ENyO", function(module, exports) {
$parcel$export(module.exports, "normalizeUser", () => $00e5a6d628fba1c1$export$86dc25049b50352f);
$parcel$export(module.exports, "EMPTY_USER", () => $00e5a6d628fba1c1$export$f19e2c3a37ff07b4);
$parcel$export(module.exports, "hasNormalizationFindings", () => $00e5a6d628fba1c1$export$c11d127f76cdede2);

var $dbqWz = parcelRequire("dbqWz");
function $00e5a6d628fba1c1$export$86dc25049b50352f(user) {
    const droppedEntries = [];
    const emptyMembers = [];
    if (!$00e5a6d628fba1c1$var$isRecord(user)) {
        emptyMembers.push('user');
        return {
            user: $00e5a6d628fba1c1$var$freezeUser($00e5a6d628fba1c1$var$createMap(), $00e5a6d628fba1c1$var$createMap()),
            droppedEntries: droppedEntries,
            emptyMembers: emptyMembers
        };
    }
    const identifiers = $00e5a6d628fba1c1$var$copyValidEntries(user, 'identifiers', (0, $dbqWz.isString), droppedEntries, emptyMembers, false);
    const attributes = $00e5a6d628fba1c1$var$copyValidEntries(user, 'attributes', $00e5a6d628fba1c1$var$isFlagContextValue, droppedEntries, emptyMembers, true);
    return {
        user: $00e5a6d628fba1c1$var$freezeUser(identifiers, attributes),
        droppedEntries: droppedEntries,
        emptyMembers: emptyMembers
    };
}
const $00e5a6d628fba1c1$export$f19e2c3a37ff07b4 = $00e5a6d628fba1c1$var$freezeUser($00e5a6d628fba1c1$var$createMap(), $00e5a6d628fba1c1$var$createMap());
function $00e5a6d628fba1c1$export$c11d127f76cdede2(normalization) {
    return normalization.droppedEntries.length > 0 || normalization.emptyMembers.length > 0;
}
function $00e5a6d628fba1c1$var$copyValidEntries(user, member, isValid, droppedEntries, emptyMembers, absentIsEmpty) {
    const copy = $00e5a6d628fba1c1$var$createMap();
    let entries;
    try {
        const value = user[member];
        if (value === undefined && absentIsEmpty) return copy;
        if (!$00e5a6d628fba1c1$var$isRecord(value)) {
            emptyMembers.push(member);
            return copy;
        }
        entries = Object.entries(value);
    } catch  {
        emptyMembers.push(member);
        return copy;
    }
    for (const [key, value] of entries)if (isValid(value)) copy[key] = value;
    else droppedEntries.push(`${member}.${key}`);
    return copy;
}
function $00e5a6d628fba1c1$var$freezeUser(identifiers, attributes) {
    return Object.freeze({
        identifiers: Object.freeze(identifiers),
        attributes: Object.freeze(attributes)
    });
}
/** Null-prototype map, so keys such as `__proto__` are stored as ordinary entries. */ function $00e5a6d628fba1c1$var$createMap() {
    return Object.create(null);
}
function $00e5a6d628fba1c1$var$isFlagContextValue(value) {
    return typeof value === 'string' || typeof value === 'boolean' || typeof value === 'number' && Number.isFinite(value);
}
/** Object check that never throws, including for revoked proxies. */ function $00e5a6d628fba1c1$var$isRecord(value) {
    try {
        return typeof value === 'object' && value !== null && !Array.isArray(value);
    } catch  {
        return false;
    }
}

});


parcelRegister("fuxTf", function(module, exports) {
$parcel$export(module.exports, "toFlagUser", () => $9205e8c4bfbccd7e$export$2e7de09bcd2b7caf);

var $hHsjm = parcelRequire("hHsjm");
const $9205e8c4bfbccd7e$var$isFlagContextValue = (value)=>typeof value === 'string' || typeof value === 'boolean' || typeof value === 'number' && Number.isFinite(value);
const $9205e8c4bfbccd7e$export$2e7de09bcd2b7caf = (identifiers, customAttributes)=>{
    const flagIdentifiers = {};
    Object.entries((0, $hHsjm.toStatsigUser)(identifiers).customIDs ?? {}).forEach(([key, value])=>{
        if (typeof value === 'string') flagIdentifiers[key] = value;
    });
    const attributes = {};
    Object.entries(customAttributes ?? {}).forEach(([key, value])=>{
        if ($9205e8c4bfbccd7e$var$isFlagContextValue(value)) attributes[key] = value;
    });
    return {
        identifiers: flagIdentifiers,
        attributes: attributes
    };
};

});
parcelRegister("hHsjm", function(module, exports) {
$parcel$export(module.exports, "toStatsigUser", () => $67768b8aa87e23ed$export$3dad1db244472f32);
const $67768b8aa87e23ed$export$3dad1db244472f32 = (identifiers, customAttributes)=>{
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    const { stableId: stableId, ...otherIdentifiers } = identifiers;
    const user = {
        customIDs: {
            ...otherIdentifiers,
            ...stableId !== undefined ? {
                stableID: stableId
            } : {}
        },
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};

});



parcelRegister("jOwMd", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $4b80c6b0ddd45a4a$export$d119b37e5f788b43);

var $1KT2J = parcelRequire("1KT2J");

var $joS99 = parcelRequire("joS99");
const $4b80c6b0ddd45a4a$export$d119b37e5f788b43 = (options)=>({
        /**
   * If more federal PerimeterTypes are added in the future, this should be updated so
   * that isFedRamp() === true always returns the strictest perimeter.
   */ perimeter: (0, $1KT2J.isFedRamp)() ? (0, $joS99.PerimeterType).FEDRAMP_MODERATE : (0, $joS99.PerimeterType).COMMERCIAL,
        ...options
    });

});
parcelRegister("1KT2J", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $97c32b7902cf0ed6$export$64d6499adf9b2e51);

var $houtj = parcelRequire("houtj");
function $97c32b7902cf0ed6$export$64d6499adf9b2e51() {
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $houtj.FEDRAMP_MODERATE);
    const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("houtj", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $618b22bc7e7c0afa$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $618b22bc7e7c0afa$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "FEDRAMP_FEDEX", () => $618b22bc7e7c0afa$export$bd6b5a7802d76127);
$parcel$export(module.exports, "STAGING", () => $618b22bc7e7c0afa$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $618b22bc7e7c0afa$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $618b22bc7e7c0afa$export$404582bc18fe4d9e);
const $618b22bc7e7c0afa$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $618b22bc7e7c0afa$export$f005e2e9f707cb5f = 'commercial';
const $618b22bc7e7c0afa$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $618b22bc7e7c0afa$export$a739cd5aac835909 = 'stg';
const $618b22bc7e7c0afa$export$42dd0cdd351a4a9 = 'prod';
const $618b22bc7e7c0afa$export$404582bc18fe4d9e = 'dev';

});



parcelRegister("2YPaE", function(module, exports) {
$parcel$export(module.exports, "migrateInitializationOptions", () => $d4cddd24e8d889db$export$202946b690d26d22);
const $d4cddd24e8d889db$export$202946b690d26d22 = (options)=>{
    const { api: api, disableCurrentPageLogging: disableCurrentPageLogging, loggingIntervalMillis: loggingIntervalMillis, loggingBufferMaxSize: loggingBufferMaxSize, localMode: localMode, eventLoggingApi: eventLoggingApi, eventLoggingApiForRetries: eventLoggingApiForRetries, disableLocalStorage: disableLocalStorage, ignoreWindowUndefined: ignoreWindowUndefined, disableAllLogging: disableAllLogging, // No equivalent but is pointless anyway since our Statsig init is synchronous
    initTimeoutMs: _initTimeoutMs, // No equivalent in new client but probably not important?
    disableNetworkKeepalive: _disableNetworkKeepalive, // Needs to be implemented manually but unused according to zoekt
    overrideStableID: _overrideStableID, // No equivalent for these but can't see them actually used anywhere in old client?
    disableErrorLogging: _disableErrorLogging, disableAutoMetricsLogging: _disableAutoMetricsLogging, ...rest } = options;
    return {
        ...rest,
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    };
};

});

parcelRegister("iTSgg", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $9cfd8eba476dcbec$export$55fffef3474104af);

var $1T45w = parcelRequire("1T45w");
class $9cfd8eba476dcbec$export$55fffef3474104af extends (0, $1T45w.DataAdapterCore) {
    bootstrapResult = null;
    constructor(){
        super('NoFetchDataAdapter', 'nofetch');
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ setBootstrapData(data) {
        this.bootstrapResult = data ? {
            source: 'Bootstrap',
            data: JSON.stringify(data),
            receivedAt: Date.now(),
            stableID: (0, $1T45w.StableID).get(this._getSdkKey()),
            fullUserHash: null
        } : null;
    }
    async prefetchData(_user, _options) {}
    async getDataAsync(_current, user, _options) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $1T45w._getFullUserHash)(user)
        };
    }
    getDataSync(user) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $1T45w._getFullUserHash)(user)
        };
    }
    async _fetchFromNetwork(_current, _user, _options) {
        return null;
    }
    _getCacheKey(user) {
        // Same logic as default data adapter
        // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
        const key = (0, $1T45w._getStorageKey)(this._getSdkKey(), user);
        return `${0, $1T45w.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(_result, _user) {
        return false;
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    // Do not stringify options property since that includes this adapter and will
    // cause a circular reference when Statsig sends diagnostic events and including
    // values is not necessary and makes the result huge
    toJSON() {
        const result = {
            ...this
        };
        delete result._options;
        delete result._inMemoryCache;
        delete result.bootstrapResult;
        return result;
    }
}

});

parcelRegister("1xPXE", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $5df8651d7f89ed9e$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $5df8651d7f89ed9e$export$bcb28fbac1def494);

var $49Dnu = parcelRequire("49Dnu");
const $5df8651d7f89ed9e$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
const $5df8651d7f89ed9e$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
const $5df8651d7f89ed9e$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
const $5df8651d7f89ed9e$var$makeEmptyStore = ()=>({
        gates: {},
        configs: {},
        layers: {}
    });
const $5df8651d7f89ed9e$var$djb2MapKey = (hash, kind)=>kind + ':' + hash;
class $5df8651d7f89ed9e$export$bcb28fbac1def494 {
    _overrides;
    _localStorageKey;
    _djb2Map;
    constructor(localStorageKey){
        this._overrides = $5df8651d7f89ed9e$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    parseStoredOverrides(localStorageKey) {
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const json = window.localStorage.getItem(localStorageKey);
            if (!json) return $5df8651d7f89ed9e$var$makeEmptyStore();
            return JSON.parse(json);
        } catch  {
            return $5df8651d7f89ed9e$var$makeEmptyStore();
        }
    }
    mergeOverrides(...allOverrides) {
        const merged = $5df8651d7f89ed9e$var$makeEmptyStore();
        for (const overrides of allOverrides){
            for (const [name, value] of Object.entries(overrides.gates ?? {}))merged.gates[name] = value;
            for (const [name, value] of Object.entries(overrides.configs ?? {}))merged.configs[name] = value;
            for (const [name, value] of Object.entries(overrides.layers ?? {}))merged.layers[name] = value;
        }
        return merged;
    }
    initFromStoredOverrides() {
        const storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($5df8651d7f89ed9e$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
        // Clear data from legacy local storage key now we've read from it.
        // This prevents things being stuck in there that are always read but never written to.
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.removeItem($5df8651d7f89ed9e$var$LEGACY_LOCAL_STORAGE_KEY);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
        // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
        // multiple hashes to continue being created. This code here removes these hashes since we've moved
        // to using a more reliable and easier to maintain map in `_djb2Map`.
        for (const container of Object.values(storedOverrides)){
            const allKeys = new Set(Object.keys(container));
            for (const name of allKeys){
                const hash = (0, $49Dnu._DJB2)(name);
                if (allKeys.has(hash)) delete container[hash];
            }
        }
        this.applyOverrides(storedOverrides);
    }
    saveOverrides() {
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getOverrides() {
        return this.mergeOverrides(this._overrides);
    }
    applyOverrides(overrides) {
        const newOverrides = {
            ...$5df8651d7f89ed9e$var$makeEmptyStore(),
            ...overrides
        };
        this._djb2Map.clear();
        for (const [containerName, container] of Object.entries(newOverrides))for (const [name, value] of Object.entries(container))this._djb2Map.set($5df8651d7f89ed9e$var$djb2MapKey((0, $49Dnu._DJB2)(name), containerName), value);
        this._overrides = newOverrides;
    }
    setOverrides(overrides) {
        this.applyOverrides(overrides);
        this.saveOverrides();
    }
    overrideGate(name, value) {
        this._overrides.gates[name] = value;
        this._djb2Map.set($5df8651d7f89ed9e$var$djb2MapKey((0, $49Dnu._DJB2)(name), 'gates'), value);
        this.saveOverrides();
    }
    removeGateOverride(name) {
        delete this._overrides.gates[name];
        this._djb2Map.delete($5df8651d7f89ed9e$var$djb2MapKey((0, $49Dnu._DJB2)(name), 'gates'));
        this.saveOverrides();
    }
    getGateOverride(current, _user) {
        const overridden = this._overrides.gates[current.name] ?? this._djb2Map.get($5df8651d7f89ed9e$var$djb2MapKey(current.name, 'gates'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            details: {
                ...current.details,
                reason: $5df8651d7f89ed9e$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    overrideDynamicConfig(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($5df8651d7f89ed9e$var$djb2MapKey((0, $49Dnu._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeDynamicConfigOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($5df8651d7f89ed9e$var$djb2MapKey((0, $49Dnu._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getDynamicConfigOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideExperiment(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($5df8651d7f89ed9e$var$djb2MapKey((0, $49Dnu._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeExperimentOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($5df8651d7f89ed9e$var$djb2MapKey((0, $49Dnu._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getExperimentOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideLayer(name, value) {
        this._overrides.layers[name] = value;
        this._djb2Map.set($5df8651d7f89ed9e$var$djb2MapKey((0, $49Dnu._DJB2)(name), 'layers'), value);
        this.saveOverrides();
    }
    removeLayerOverride(name) {
        delete this._overrides.layers[name];
        this._djb2Map.delete($5df8651d7f89ed9e$var$djb2MapKey((0, $49Dnu._DJB2)(name), 'layers'));
        this.saveOverrides();
    }
    removeAllOverrides() {
        this._overrides = $5df8651d7f89ed9e$var$makeEmptyStore();
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.removeItem(this._localStorageKey);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getLayerOverride(current, _user) {
        const overridden = this._overrides.layers[current.name] ?? this._djb2Map.get($5df8651d7f89ed9e$var$djb2MapKey(current.name, 'layers'));
        if (overridden == null) return null;
        return {
            ...current,
            __value: overridden,
            get: (0, $49Dnu._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $5df8651d7f89ed9e$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    /**
   * The override for a gate, config or layer, looked up the same way as the Statsig override
   * methods above. `undefined` when there is none. Used for keys the wrapper answers without the
   * Statsig client.
   */ getOverride(kind, name) {
        return this._overrides[kind][name] ?? this._djb2Map.get($5df8651d7f89ed9e$var$djb2MapKey(name, kind));
    }
    _getConfigOverride(current, lookup) {
        const overridden = lookup[current.name] ?? this._djb2Map.get($5df8651d7f89ed9e$var$djb2MapKey(current.name, 'configs'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            get: (0, $49Dnu._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $5df8651d7f89ed9e$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
}

});

parcelRegister("deCXZ", function(module, exports) {
$parcel$export(module.exports, "shallowEquals", () => $11e748dcc8cde44b$export$fa1c2bbf4100b8bc);
const $11e748dcc8cde44b$export$fa1c2bbf4100b8bc = (objectA, objectB)=>{
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    const aEntries = Object.entries(objectA);
    const bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(let i = 0; i < aEntries.length; i++){
        const [, aValue] = aEntries[i];
        const [, bValue] = bEntries[i];
        if (aValue !== bValue) return false;
    }
    return true;
};

});



parcelRegister("7u1vJ", function(module, exports) {
$parcel$export(module.exports, "debug", () => $88ed502129b26741$export$1c9f709888824e05);
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
const $88ed502129b26741$var$TESTS_MODE = globalThis?.process?.env?.JEST_WORKER_ID !== undefined;
const $88ed502129b26741$var$DEBUG_MODE = !$88ed502129b26741$var$TESTS_MODE && globalThis?.process?.env?.NODE_ENV !== 'production';
const $88ed502129b26741$export$1c9f709888824e05 = (...args)=>{
    if (!$88ed502129b26741$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    console.debug(...args);
};

});

parcelRegister("380IJ", function(module, exports) {
$parcel$export(module.exports, "ENV_ENABLE_PLATFORM_FF", () => $084bbdaa78d6e70f$export$b574c24e1e6490f5);

var $4cILa = parcelRequire("4cILa");
const $084bbdaa78d6e70f$export$b574c24e1e6490f5 = (0, $4cILa.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});
parcelRegister("4cILa", function(module, exports) {
$parcel$export(module.exports, "PFF_GLOBAL_KEY", () => $2ece8187a9739e33$export$7e41b1b2bdee3f98);
$parcel$export(module.exports, "pkgName", () => $2ece8187a9739e33$export$407f05df8e3ce9f3);
$parcel$export(module.exports, "hasProcessEnv", () => $2ece8187a9739e33$export$75f4a1454eff2805);

var $k1Wvt = parcelRequire("k1Wvt");
const $2ece8187a9739e33$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
const $2ece8187a9739e33$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
const $2ece8187a9739e33$export$75f4a1454eff2805 = typeof $k1Wvt !== 'undefined' && typeof $k1Wvt.env !== 'undefined';

});


parcelRegister("k2MNL", function(module, exports) {
$parcel$export(module.exports, "ENV_STORYBOOK_ENABLE_PLATFORM_FF", () => $873f2a2dfcec513c$export$92f8b531feaeb23d);

var $4cILa = parcelRequire("4cILa");
const $873f2a2dfcec513c$export$92f8b531feaeb23d = (0, $4cILa.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});

parcelRegister("8puww", function(module, exports) {
$parcel$export(module.exports, "globalVar", () => $910a26afc7fab095$export$54ea85357b4e0159);

var $4cILa = parcelRequire("4cILa");
const $910a26afc7fab095$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
const $910a26afc7fab095$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$910a26afc7fab095$export$54ea85357b4e0159[0, $4cILa.PFF_GLOBAL_KEY] = $910a26afc7fab095$export$54ea85357b4e0159[0, $4cILa.PFF_GLOBAL_KEY] || $910a26afc7fab095$var$DEFAULT_PFF_GLOBAL;

});



parcelRegister("6Fero", function(module, exports) {
$parcel$export(module.exports, "isAtlassianRelayEnvironment", () => $d6205930911653be$export$56db1ec1ca8ef90c);
$parcel$export(module.exports, "createRelayEnvironment", () => $d6205930911653be$export$7afaa9c867644497);

var $ArurZ = parcelRequire("ArurZ");

var $jonSk = parcelRequire("jonSk");

var $4gHdz = parcelRequire("4gHdz");

var $hxjq4 = parcelRequire("hxjq4");

var $ku7St = parcelRequire("ku7St");

var $01WOC = parcelRequire("01WOC");

var $dNQOn = parcelRequire("dNQOn");

var $jYxYB = parcelRequire("jYxYB");

var $gP2Fh = parcelRequire("gP2Fh");

var $4Sf93 = parcelRequire("4Sf93");
// Enable Relay Resolvers globally for this module
(0, $ArurZ.RelayFeatureFlags).ENABLE_RELAY_RESOLVERS = true;
function $d6205930911653be$var$createNetwork(networkOptions, getEnableUfoHolds) {
    const fetchOperation = (request, variables, cacheConfig)=>(0, $ku7St.fetch)(request, variables, cacheConfig, networkOptions);
    const fetchOperationWithMiddleware = (0, $4Sf93.ufoDataFetchHoldMiddleware)(fetchOperation, {
        getIsEnabled: getEnableUfoHolds
    });
    return (0, $ArurZ.Network).create(fetchOperationWithMiddleware, networkOptions.isServer === false ? (0, $jYxYB.createSubscribeFn)(networkOptions) : undefined);
}
/**
 * Brand attached to every environment produced by {@link createRelayEnvironment}.
 *
 * We use `Symbol.for` (the global symbol registry) rather than a module-local `Symbol()` so the
 * brand stays stable even if this module ends up duplicated across bundles/realms — the guard in a
 * consumer will still recognise an environment created by another copy of this package.
 */ const $d6205930911653be$var$ATLASSIAN_RELAY_ENVIRONMENT_BRAND = Symbol.for('@atlassian/relay-environment.AtlassianRelayEnvironment');
function $d6205930911653be$var$brandEnvironment(environment) {
    Object.defineProperty(environment, $d6205930911653be$var$ATLASSIAN_RELAY_ENVIRONMENT_BRAND, {
        value: true,
        enumerable: false,
        configurable: false,
        writable: false
    });
    return environment;
}
function $d6205930911653be$export$56db1ec1ca8ef90c(environment) {
    return environment != null && (typeof environment === 'object' || typeof environment === 'function') && environment[$d6205930911653be$var$ATLASSIAN_RELAY_ENVIRONMENT_BRAND] === true;
}
/**
 * Relay calls `environment.UNSTABLE_getDefaultRenderPolicy()` on every `QueryResource.prepare`, so
 * this allows overriding it dynamically (and not during module scope evaluation).
 */ class $d6205930911653be$var$DynamicRenderPolicyEnvironment extends (0, $ArurZ.Environment) {
    getRenderPolicy;
    constructor(config, getRenderPolicy){
        super(config);
        this.getRenderPolicy = getRenderPolicy;
    }
    /**
   * Note: currently missing from @types/relay-runtime (version 20.1.1) but DOES exist at runtime.
   */ UNSTABLE_getDefaultRenderPolicy() {
        return this.getRenderPolicy();
    }
}
const $d6205930911653be$var$createStore = (source, options)=>new (0, (/*@__PURE__*/$parcel$interopDefault($jonSk)))(source, options);
function $d6205930911653be$export$7afaa9c867644497({ log: log, requiredFieldLogger: requiredFieldLogger, networkOptions: networkOptions, getDataID: getDataID, getDefaultRenderPolicy: getDefaultRenderPolicy, getEnableUfoHolds: getEnableUfoHolds, wsClientOptions: wsClientOptions }) {
    if (wsClientOptions) (0, $4gHdz.configureWebSocketClient)(wsClientOptions);
    const source = new (0, $ArurZ.RecordSource)();
    const config = {
        configName: 'Atlassian Shared Graphql Gateway',
        network: $d6205930911653be$var$createNetwork(networkOptions || {
            isServer: false
        }, getEnableUfoHolds),
        store: $d6205930911653be$var$createStore(source, {
            log: log ?? undefined,
            getDataID: 'getDataID' in arguments[0] ? getDataID : (0, $hxjq4.default)
        }),
        log: log,
        relayFieldLogger: requiredFieldLogger,
        getDataID: 'getDataID' in arguments[0] ? getDataID : (0, $hxjq4.default),
        scheduler: (0, $dNQOn.default),
        missingFieldHandlers: (0, $01WOC.default),
        handlerProvider: (0, $gP2Fh.createRelayHandlerProvider)(source)
    };
    const environment = getDefaultRenderPolicy ? new $d6205930911653be$var$DynamicRenderPolicyEnvironment(config, getDefaultRenderPolicy) : new (0, $ArurZ.Environment)(config);
    return $d6205930911653be$var$brandEnvironment(environment);
}

});
parcelRegister("jonSk", function(module, exports) {
'use strict';

var $gL89e = parcelRequire("gL89e");
module.exports = $gL89e;

});

parcelRegister("4gHdz", function(module, exports) {
$parcel$export(module.exports, "configureWebSocketClient", () => $43cf3ba099915377$export$155768b0e0a38663);
$parcel$export(module.exports, "getClient", () => $43cf3ba099915377$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "getSocketConnectionState", () => $43cf3ba099915377$export$83dc7d6f7d0a4fad);
$parcel$export(module.exports, "acquireSubscriptionClient", () => $43cf3ba099915377$export$2f4a9d3832f4a2d9);

var $9Ayth = parcelRequire("9Ayth");

var $2aEiL = parcelRequire("2aEiL");

var $3DhQk = parcelRequire("3DhQk");

var $2Ssux = parcelRequire("2Ssux");

var $5UfqC = parcelRequire("5UfqC");

var $5jDad = parcelRequire("5jDad");

var $AYl3d = parcelRequire("AYl3d");

var $e1eYM = parcelRequire("e1eYM");
const $43cf3ba099915377$var$defaultClientState = (0, $5jDad.createClientState)();
let $43cf3ba099915377$var$configuredOptions;
let $43cf3ba099915377$var$recoveryCount = 0;
let $43cf3ba099915377$var$detachRecovery;
const $43cf3ba099915377$export$155768b0e0a38663 = (options)=>{
    if ($43cf3ba099915377$var$defaultClientState.client) {
        // eslint-disable-next-line no-console
        console.warn('configureWebSocketClient was called after the subscription client was already created, so these options have been ignored. Configure it while creating the relay environment, before any subscription starts.');
        return;
    }
    $43cf3ba099915377$var$configuredOptions = options;
};
const $43cf3ba099915377$var$getClientForState = (state, url)=>{
    if ((0, $5UfqC.isSSR)()) return null;
    if (!state.client) {
        const onConnectionEvent = $43cf3ba099915377$var$configuredOptions?.getConnectionEventReporter?.();
        const terminate = ()=>state.client?.terminate();
        const { listeners: listeners, isConnected: isConnected } = (0, $e1eYM.createSocketListeners)({
            onConnectionEvent: onConnectionEvent,
            pongWaitTimeout: (0, $2aEiL.fg)('platform_relay_subscription_reliability') ? (0, $2Ssux.WS_CLIENT_PONG_WAIT) : 0,
            terminate: terminate
        });
        state.isSocketConnected = isConnected;
        const rateLimitedRetryWait = (0, $2aEiL.fg)('platform_relay_subscription_reliability') && (0, $2aEiL.fg)('platform_relay_subscription_rate_limit_backoff') ? (0, $AYl3d.createRateLimitedRetryWait)((0, $2Ssux.WS_CLIENT_MAX_RETRY_WAIT)) : undefined;
        const retryWait = (0, $2aEiL.fg)('platform_relay_subscription_reliability') ? rateLimitedRetryWait ?? (0, $AYl3d.createRetryWait)((0, $2Ssux.WS_CLIENT_MAX_RETRY_WAIT)) : undefined;
        state.abortPendingRetryWait = retryWait?.abort ?? (()=>false);
        state.observesSocketState = (0, $2aEiL.fg)('platform_relay_subscription_reliability-additional') && Boolean(onConnectionEvent || (0, $2aEiL.fg)('platform_relay_subscription_reliability'));
        const options = {
            url: url ?? (0, $5UfqC.getAggSubscriptionEndpoint)(),
            lazy: true,
            keepAlive: (0, $2aEiL.fg)('platform_relay_subscription_reliability') ? (0, $2Ssux.WS_CLIENT_LIVENESS_KEEP_ALIVE) : (0, $2Ssux.WS_CLIENT_KEEP_ALIVE),
            retryAttempts: (0, $2aEiL.fg)('platform_relay_subscription_reliability') ? (0, $2Ssux.WS_CLIENT_CAPPED_RETRIES) : (0, $2Ssux.WS_CLIENT_RETRIES),
            retryWait: retryWait?.wait,
            shouldRetry: (0, $2aEiL.fg)('platform_relay_subscription_reliability') ? (0, $AYl3d.shouldRetryTransportFailure) : undefined,
            // 0 = wait forever (graphql-ws default).
            connectionAckWaitTimeout: (0, $2aEiL.fg)('platform_relay_subscription_reliability') ? (0, $2Ssux.WS_CLIENT_CONNECTION_ACK_WAIT) : 0,
            lazyCloseTimeout: (0, $2aEiL.fg)('platform_relay_subscription_connection_reuse') ? (0, $2Ssux.WS_CLIENT_LAZY_CLOSE) : 0,
            on: onConnectionEvent || (0, $2aEiL.fg)('platform_relay_subscription_reliability') ? listeners : undefined,
            connectionParams: {
                'atl-client-name': 'jira-frontend',
                'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
                'X-ExperimentalApi': (0, $3DhQk.getRelayExperimentalApis)().join(',')
            }
        };
        state.client = (0, $9Ayth.createClient)(options);
        state.lazyCloseTimeout = options.lazyCloseTimeout;
        if (rateLimitedRetryWait) state.client.on('closed', rateLimitedRetryWait.recordClose);
    }
    return state.client;
};
const $43cf3ba099915377$export$6bb76d6eba7e258c = ()=>$43cf3ba099915377$var$getClientForState($43cf3ba099915377$var$defaultClientState);
const $43cf3ba099915377$export$b4412e664c6cc09b = ()=>{
    if (!(0, $2aEiL.fg)('platform_relay_subscription_reliability')) return ()=>{};
    $43cf3ba099915377$var$recoveryCount += 1;
    if ($43cf3ba099915377$var$recoveryCount === 1) (0, $5jDad.setEndpointRecoveryEnabled)(true);
    $43cf3ba099915377$var$detachRecovery ??= (0, $AYl3d.addRecoveryListeners)({
        terminate: ()=>$43cf3ba099915377$var$defaultClientState.client?.terminate(),
        isConnected: ()=>$43cf3ba099915377$var$defaultClientState.isSocketConnected(),
        abortRetryWait: ()=>$43cf3ba099915377$var$defaultClientState.abortPendingRetryWait()
    });
    let released = false;
    return ()=>{
        if (released) return;
        released = true;
        $43cf3ba099915377$var$recoveryCount -= 1;
        if ($43cf3ba099915377$var$recoveryCount === 0) {
            (0, $5jDad.setEndpointRecoveryEnabled)(false);
            $43cf3ba099915377$var$detachRecovery?.();
            $43cf3ba099915377$var$detachRecovery = undefined;
        }
    };
};
const $43cf3ba099915377$export$2f0afd443356d36f = ()=>{
    $43cf3ba099915377$var$defaultClientState.client = null;
    $43cf3ba099915377$var$configuredOptions = undefined;
    $43cf3ba099915377$var$defaultClientState.isSocketConnected = ()=>false;
    $43cf3ba099915377$var$defaultClientState.abortPendingRetryWait = ()=>false;
    $43cf3ba099915377$var$defaultClientState.observesSocketState = false;
    $43cf3ba099915377$var$defaultClientState.lazyCloseTimeout = 0;
};
/** Unknown when the product has not enabled socket lifecycle reporting or reliability. */ const $43cf3ba099915377$var$getConnectionState = (state)=>(0, $2aEiL.fg)('platform_relay_subscription_reliability-additional') && state.observesSocketState ? state.isSocketConnected() ? 'connected' : 'disconnected' : 'unknown';
const $43cf3ba099915377$export$83dc7d6f7d0a4fad = ()=>$43cf3ba099915377$var$getConnectionState($43cf3ba099915377$var$defaultClientState);
const $43cf3ba099915377$export$2f4a9d3832f4a2d9 = (url)=>(0, $5UfqC.isSSR)() ? null : (0, $5jDad.acquireClient)(typeof url === 'function' ? url() : url, $43cf3ba099915377$var$getClientForState, $43cf3ba099915377$var$getConnectionState);

});
parcelRegister("9Ayth", function(module, exports) {
$parcel$export(module.exports, "createClient", () => $6fb23725afb155ef$export$5d730b7aed1a3eb0);
/**
 *
 * client
 *
 */ 
var $cMrha = parcelRequire("cMrha");

var $dGpBA = parcelRequire("dGpBA");
var $6fb23725afb155ef$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $6fb23725afb155ef$var$__await ? (this.v = v, this) : new $6fb23725afb155ef$var$__await(v);
};
var $6fb23725afb155ef$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $6fb23725afb155ef$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function $6fb23725afb155ef$export$5d730b7aed1a3eb0(options) {
    const { url: url, connectionParams: connectionParams, lazy: lazy = true, onNonLazyError: onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive: keepAlive = 0, disablePong: disablePong, connectionAckWaitTimeout: connectionAckWaitTimeout = 0, retryAttempts: retryAttempts = 5, retryWait: retryWait = async function randomisedExponentialBackoff(retries) {
        let retryDelay = 1000; // start with 1s delay
        for(let i = 0; i < retries; i++)retryDelay *= 2;
        await new Promise((resolve)=>setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
            Math.floor(Math.random() * 2700 + 300)));
    }, shouldRetry: shouldRetry = $6fb23725afb155ef$var$isLikeCloseEvent, isFatalConnectionProblem: isFatalConnectionProblem, on: on, webSocketImpl: webSocketImpl, generateID: /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */ generateID = function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
    let ws;
    if (webSocketImpl) {
        if (!$6fb23725afb155ef$var$isWebSocket(webSocketImpl)) throw new Error('Invalid WebSocket implementation provided');
        ws = webSocketImpl;
    } else if (typeof WebSocket !== 'undefined') ws = WebSocket;
    else if (typeof $parcel$global !== 'undefined') ws = $parcel$global.WebSocket || // @ts-expect-error: Support more browsers
    $parcel$global.MozWebSocket;
    else if (typeof window !== 'undefined') ws = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket;
    if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
    const WebSocketImpl = ws;
    // websocket status emitter, subscriptions are handled differently
    const emitter = (()=>{
        const message = (()=>{
            const listeners = {};
            return {
                on (id, listener) {
                    listeners[id] = listener;
                    return ()=>{
                        delete listeners[id];
                    };
                },
                emit (message) {
                    var _a;
                    if ('id' in message) (_a = listeners[message.id]) === null || _a === void 0 || _a.call(listeners, message);
                }
            };
        })();
        const listeners = {
            connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [
                on.connecting
            ] : [],
            opened: (on === null || on === void 0 ? void 0 : on.opened) ? [
                on.opened
            ] : [],
            connected: (on === null || on === void 0 ? void 0 : on.connected) ? [
                on.connected
            ] : [],
            ping: (on === null || on === void 0 ? void 0 : on.ping) ? [
                on.ping
            ] : [],
            pong: (on === null || on === void 0 ? void 0 : on.pong) ? [
                on.pong
            ] : [],
            message: (on === null || on === void 0 ? void 0 : on.message) ? [
                message.emit,
                on.message
            ] : [
                message.emit
            ],
            closed: (on === null || on === void 0 ? void 0 : on.closed) ? [
                on.closed
            ] : [],
            error: (on === null || on === void 0 ? void 0 : on.error) ? [
                on.error
            ] : []
        };
        return {
            onMessage: message.on,
            on (event, listener) {
                const l = listeners[event];
                l.push(listener);
                return ()=>{
                    l.splice(l.indexOf(listener), 1);
                };
            },
            emit (event, ...args) {
                // we copy the listeners so that unlistens dont "pull the rug under our feet"
                for (const listener of [
                    ...listeners[event]
                ])// @ts-expect-error: The args should fit
                listener(...args);
            }
        };
    })();
    // invokes the callback either when an error or closed event is emitted,
    // first one that gets called prevails, other emissions are ignored
    function errorOrClosed(cb) {
        const listening = [
            // errors are fatal and more critical than close events, throw them first
            emitter.on('error', (err)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(err);
            }),
            // closes can be graceful and not fatal, throw them second (if error didnt throw)
            emitter.on('closed', (event)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(event);
            })
        ];
    }
    let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
    async function connect() {
        // clear the lazy close timeout immediatelly so that close gets debounced
        // see: https://github.com/enisdenjo/graphql-ws/issues/388
        clearTimeout(lazyCloseTimeout);
        const [socket, throwOnClose] = await (connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise((connected, denied)=>(async ()=>{
                if (retrying) {
                    await retryWait(retries);
                    // subscriptions might complete while waiting for retry
                    if (!locks) {
                        connecting = undefined;
                        return denied({
                            code: 1000,
                            reason: 'All Subscriptions Gone'
                        });
                    }
                    retries++;
                }
                emitter.emit('connecting', retrying);
                const socket = new WebSocketImpl(typeof url === 'function' ? await url() : url, (0, $cMrha.GRAPHQL_TRANSPORT_WS_PROTOCOL));
                let connectionAckTimeout, queuedPing;
                function enqueuePing() {
                    if (isFinite(keepAlive) && keepAlive > 0) {
                        clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)
                        queuedPing = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) {
                                socket.send((0, $cMrha.stringifyMessage)({
                                    type: (0, $cMrha.MessageType).Ping
                                }));
                                emitter.emit('ping', false, undefined);
                            }
                        }, keepAlive);
                    }
                }
                errorOrClosed((errOrEvent)=>{
                    connecting = undefined;
                    clearTimeout(connectionAckTimeout);
                    clearTimeout(queuedPing);
                    denied(errOrEvent);
                    if (errOrEvent instanceof $6fb23725afb155ef$export$f5b1bfead8e118a7) {
                        socket.close(4499, 'Terminated'); // close event is artificial and emitted manually, see `Client.terminate()` below
                        socket.onerror = null;
                        socket.onclose = null;
                    }
                });
                socket.onerror = (err)=>emitter.emit('error', err);
                socket.onclose = (event)=>emitter.emit('closed', event);
                socket.onopen = async ()=>{
                    try {
                        emitter.emit('opened', socket);
                        const payload = typeof connectionParams === 'function' ? await connectionParams() : connectionParams;
                        // connectionParams might take too long causing the server to kick off the client
                        // the necessary error/close event is already reported - simply stop execution
                        if (socket.readyState !== WebSocketImpl.OPEN) return;
                        socket.send((0, $cMrha.stringifyMessage)(payload ? {
                            type: (0, $cMrha.MessageType).ConnectionInit,
                            payload: payload
                        } : {
                            type: (0, $cMrha.MessageType).ConnectionInit
                        }, replacer));
                        if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                            socket.close((0, $cMrha.CloseCode).ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                        }, connectionAckWaitTimeout);
                        enqueuePing(); // enqueue ping (noop if disabled)
                    } catch (err) {
                        emitter.emit('error', err);
                        socket.close((0, $cMrha.CloseCode).InternalClientError, (0, $dGpBA.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Internal client error'));
                    }
                };
                let acknowledged = false;
                socket.onmessage = ({ data: data })=>{
                    try {
                        const message = (0, $cMrha.parseMessage)(data, reviver);
                        emitter.emit('message', message);
                        if (message.type === 'ping' || message.type === 'pong') {
                            emitter.emit(message.type, true, message.payload); // received
                            if (message.type === 'pong') enqueuePing(); // enqueue next ping (noop if disabled)
                            else if (!disablePong) {
                                // respond with pong on ping
                                socket.send((0, $cMrha.stringifyMessage)(message.payload ? {
                                    type: (0, $cMrha.MessageType).Pong,
                                    payload: message.payload
                                } : {
                                    type: (0, $cMrha.MessageType).Pong
                                }));
                                emitter.emit('pong', false, message.payload);
                            }
                            return; // ping and pongs can be received whenever
                        }
                        if (acknowledged) return; // already connected and acknowledged
                        if (message.type !== (0, $cMrha.MessageType).ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                        clearTimeout(connectionAckTimeout);
                        acknowledged = true;
                        emitter.emit('connected', socket, message.payload, retrying); // connected = socket opened + acknowledged
                        retrying = false; // future lazy connects are not retries
                        retries = 0; // reset the retries on connect
                        connected([
                            socket,
                            new Promise((_, reject)=>errorOrClosed(reject))
                        ]);
                    } catch (err) {
                        socket.onmessage = null; // stop reading messages as soon as reading breaks once
                        emitter.emit('error', err);
                        socket.close((0, $cMrha.CloseCode).BadResponse, (0, $dGpBA.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Bad response'));
                    }
                };
            })()));
        // if the provided socket is in a closing state, wait for the throw on close
        if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
        let release = ()=>{
        // releases this connection
        };
        const released = new Promise((resolve)=>release = resolve);
        return [
            socket,
            release,
            Promise.race([
                // wait for
                released.then(()=>{
                    if (!locks) {
                        // and if no more locks are present, complete the connection
                        const complete = ()=>socket.close(1000, 'Normal Closure');
                        if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) // if the keepalive is set, allow for the specified calmdown time and
                        // then complete if the socket is still open.
                        lazyCloseTimeout = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) complete();
                        }, lazyCloseTimeoutMs);
                        else // otherwise complete immediately
                        complete();
                    }
                }),
                // or
                throwOnClose
            ])
        ];
    }
    /**
     * Checks the `connect` problem and evaluates if the client should retry.
     */ function shouldRetryConnectOrThrow(errOrCloseEvent) {
        // some close codes are worth reporting immediately
        if ($6fb23725afb155ef$var$isLikeCloseEvent(errOrCloseEvent) && ($6fb23725afb155ef$var$isFatalInternalCloseCode(errOrCloseEvent.code) || [
            (0, $cMrha.CloseCode).InternalServerError,
            (0, $cMrha.CloseCode).InternalClientError,
            (0, $cMrha.CloseCode).BadRequest,
            (0, $cMrha.CloseCode).BadResponse,
            (0, $cMrha.CloseCode).Unauthorized,
            // CloseCode.Forbidden, might grant access out after retry
            (0, $cMrha.CloseCode).SubprotocolNotAcceptable,
            // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
            // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
            (0, $cMrha.CloseCode).SubscriberAlreadyExists,
            (0, $cMrha.CloseCode).TooManyInitialisationRequests
        ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
        // client was disposed, no retries should proceed regardless
        if (disposed) return false;
        // normal closure (possibly all subscriptions have completed)
        // if no locks were acquired in the meantime, shouldnt try again
        if ($6fb23725afb155ef$var$isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0;
        // retries are not allowed or we tried to many times, report error
        if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
        // throw non-retryable connection problems
        if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
        // @deprecated throw fatal connection problems immediately
        if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent;
        // looks good, start retrying
        return retrying = true;
    }
    // in non-lazy (hot?) mode always hold one connection lock to persist the socket
    if (!lazy) (async ()=>{
        locks++;
        for(;;)try {
            const [, , throwOnClose] = await connect();
            await throwOnClose; // will always throw because releaser is not used
        } catch (errOrCloseEvent) {
            try {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            } catch (errOrCloseEvent) {
                // report thrown error, no further retries
                return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent);
            }
        }
    })();
    function subscribe(payload, sink) {
        const id = generateID(payload);
        let done = false, errored = false, releaser = ()=>{
            // for handling completions before connect
            locks--;
            done = true;
        };
        (async ()=>{
            locks++;
            for(;;)try {
                const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                // if done while waiting for connect, release the connection lock right away
                if (done) return release();
                const unlisten = emitter.onMessage(id, (message)=>{
                    switch(message.type){
                        case (0, $cMrha.MessageType).Next:
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                            sink.next(message.payload);
                            return;
                        case (0, $cMrha.MessageType).Error:
                            errored = true, done = true;
                            sink.error(message.payload);
                            releaser();
                            return;
                        case (0, $cMrha.MessageType).Complete:
                            done = true;
                            releaser(); // release completes the sink
                            return;
                    }
                });
                socket.send((0, $cMrha.stringifyMessage)({
                    id: id,
                    type: (0, $cMrha.MessageType).Subscribe,
                    payload: payload
                }, replacer));
                releaser = ()=>{
                    if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                    socket.send((0, $cMrha.stringifyMessage)({
                        id: id,
                        type: (0, $cMrha.MessageType).Complete
                    }, replacer));
                    locks--;
                    done = true;
                    release();
                };
                // either the releaser will be called, connection completed and
                // the promise resolved or the socket closed and the promise rejected.
                // whatever happens though, we want to stop listening for messages
                await waitForReleaseOrThrowOnClose.finally(unlisten);
                return; // completed, shouldnt try again
            } catch (errOrCloseEvent) {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            }
        })().then(()=>{
            // delivering either an error or a complete terminates the sequence
            if (!errored) sink.complete();
        }) // resolves on release or normal closure
        .catch((err)=>{
            sink.error(err);
        }); // rejects on close events and errors
        return ()=>{
            // dispose only of active subscriptions
            if (!done) releaser();
        };
    }
    return {
        on: emitter.on,
        subscribe: subscribe,
        iterate (request) {
            const pending = [];
            const deferred = {
                done: false,
                error: null,
                resolve: ()=>{
                // noop
                }
            };
            const dispose = subscribe(request, {
                next (val) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                    pending.push(val);
                    deferred.resolve();
                },
                error (err) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                },
                complete () {
                    deferred.done = true;
                    deferred.resolve();
                }
            });
            const iterator = function iterator() {
                return $6fb23725afb155ef$var$__asyncGenerator(this, arguments, function* iterator_1() {
                    for(;;){
                        if (!pending.length) // only wait if there are no pending messages available
                        yield $6fb23725afb155ef$var$__await(new Promise((resolve)=>deferred.resolve = resolve));
                        // first flush
                        while(pending.length)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        yield yield $6fb23725afb155ef$var$__await(pending.shift());
                        // then error
                        if (deferred.error) throw deferred.error;
                        // or complete
                        if (deferred.done) return yield $6fb23725afb155ef$var$__await(void 0);
                    }
                });
            }();
            iterator.throw = async (err)=>{
                if (!deferred.done) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                }
                return {
                    done: true,
                    value: undefined
                };
            };
            iterator.return = async ()=>{
                dispose();
                return {
                    done: true,
                    value: undefined
                };
            };
            return iterator;
        },
        async dispose () {
            disposed = true;
            if (connecting) {
                // if there is a connection, close it
                const [socket] = await connecting;
                socket.close(1000, 'Normal Closure');
            }
        },
        terminate () {
            if (connecting) // only if there is a connection
            emitter.emit('closed', new $6fb23725afb155ef$export$f5b1bfead8e118a7());
        }
    };
}
class $6fb23725afb155ef$export$f5b1bfead8e118a7 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'TerminatedCloseEvent';
        this.message = '4499: Terminated';
        this.code = 4499;
        this.reason = 'Terminated';
        this.wasClean = false;
    }
}
function $6fb23725afb155ef$var$isLikeCloseEvent(val) {
    return (0, $dGpBA.isObject)(val) && 'code' in val && 'reason' in val;
}
function $6fb23725afb155ef$var$isFatalInternalCloseCode(code) {
    if ([
        1000,
        1001,
        1006,
        1005,
        1012,
        1013,
        1014
    ].includes(code)) return false;
    // all other internal errors are fatal
    return code >= 1000 && code <= 1999;
}
function $6fb23725afb155ef$var$isWebSocket(val) {
    return typeof val === 'function' && 'constructor' in val && 'CLOSED' in val && 'CLOSING' in val && 'CONNECTING' in val && 'OPEN' in val;
}

});
parcelRegister("cMrha", function(module, exports) {
$parcel$export(module.exports, "GRAPHQL_TRANSPORT_WS_PROTOCOL", () => $94df2027301199e8$export$5c0a4edfedc7c457);
$parcel$export(module.exports, "CloseCode", () => $94df2027301199e8$export$777128f41f6616ec);
$parcel$export(module.exports, "MessageType", () => $94df2027301199e8$export$80edbf15fa61a4db);
$parcel$export(module.exports, "parseMessage", () => $94df2027301199e8$export$f2f615077a189f21);
$parcel$export(module.exports, "stringifyMessage", () => $94df2027301199e8$export$77896e5b47bfd50b);
/**
 *
 * common
 *
 */ 
var $dGpBA = parcelRequire("dGpBA");
const $94df2027301199e8$export$5c0a4edfedc7c457 = 'graphql-transport-ws';
const $94df2027301199e8$export$ec743af8bb66f3be = 'graphql-ws';
var $94df2027301199e8$export$777128f41f6616ec;
(function(CloseCode) {
    CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
    CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
    CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
    /** Tried subscribing before connect ack */ CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
    CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    /** Subscriber distinction is very important */ CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
})($94df2027301199e8$export$777128f41f6616ec || ($94df2027301199e8$export$777128f41f6616ec = {}));
var $94df2027301199e8$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType["ConnectionInit"] = "connection_init";
    MessageType["ConnectionAck"] = "connection_ack";
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
    MessageType["Subscribe"] = "subscribe";
    MessageType["Next"] = "next";
    MessageType["Error"] = "error";
    MessageType["Complete"] = "complete";
})($94df2027301199e8$export$80edbf15fa61a4db || ($94df2027301199e8$export$80edbf15fa61a4db = {}));
function $94df2027301199e8$export$c17861b159b1b673(val) {
    if (!(0, $dGpBA.isObject)(val)) throw new Error(`Message is expected to be an object, but got ${(0, $dGpBA.extendedTypeof)(val)}`);
    if (!val.type) throw new Error(`Message is missing the 'type' property`);
    if (typeof val.type !== 'string') throw new Error(`Message is expects the 'type' property to be a string, but got ${(0, $dGpBA.extendedTypeof)(val.type)}`);
    switch(val.type){
        case $94df2027301199e8$export$80edbf15fa61a4db.ConnectionInit:
        case $94df2027301199e8$export$80edbf15fa61a4db.ConnectionAck:
        case $94df2027301199e8$export$80edbf15fa61a4db.Ping:
        case $94df2027301199e8$export$80edbf15fa61a4db.Pong:
            if (val.payload != null && !(0, $dGpBA.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
            break;
        case $94df2027301199e8$export$80edbf15fa61a4db.Subscribe:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $dGpBA.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $dGpBA.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $dGpBA.extendedTypeof)(val.payload)}`);
            if (typeof val.payload.query !== 'string') throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${(0, $dGpBA.extendedTypeof)(val.payload.query)}`);
            if (val.payload.variables != null && !(0, $dGpBA.isObject)(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${(0, $dGpBA.extendedTypeof)(val.payload.variables)}`);
            if (val.payload.operationName != null && (0, $dGpBA.extendedTypeof)(val.payload.operationName) !== 'string') throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${(0, $dGpBA.extendedTypeof)(val.payload.operationName)}`);
            if (val.payload.extensions != null && !(0, $dGpBA.isObject)(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${(0, $dGpBA.extendedTypeof)(val.payload.extensions)}`);
            break;
        case $94df2027301199e8$export$80edbf15fa61a4db.Next:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $dGpBA.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $dGpBA.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $dGpBA.extendedTypeof)(val.payload)}`);
            break;
        case $94df2027301199e8$export$80edbf15fa61a4db.Error:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $dGpBA.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $dGpBA.areGraphQLErrors)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
            break;
        case $94df2027301199e8$export$80edbf15fa61a4db.Complete:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $dGpBA.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            break;
        default:
            throw new Error(`Invalid message 'type' property "${val.type}"`);
    }
    return val;
}
function $94df2027301199e8$export$9e0e49e75fa7d548(val) {
    try {
        $94df2027301199e8$export$c17861b159b1b673(val);
        return true;
    } catch (_a) {
        return false;
    }
}
function $94df2027301199e8$export$f2f615077a189f21(data, reviver) {
    return $94df2027301199e8$export$c17861b159b1b673(typeof data === 'string' ? JSON.parse(data, reviver) : data);
}
function $94df2027301199e8$export$77896e5b47bfd50b(msg, replacer) {
    $94df2027301199e8$export$c17861b159b1b673(msg);
    return JSON.stringify(msg, replacer);
}

});
parcelRegister("dGpBA", function(module, exports) {
$parcel$export(module.exports, "extendedTypeof", () => $9f630f45399f356f$export$573326049e1b1c6b);
$parcel$export(module.exports, "isObject", () => $9f630f45399f356f$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "areGraphQLErrors", () => $9f630f45399f356f$export$e6262fbc2e92290);
$parcel$export(module.exports, "limitCloseReason", () => $9f630f45399f356f$export$2937fa0c8dddae54);
/** @private */ function $9f630f45399f356f$export$573326049e1b1c6b(val) {
    if (val === null) return 'null';
    if (Array.isArray(val)) return 'array';
    return typeof val;
}
function $9f630f45399f356f$export$a6cdc56e425d0d0a(val) {
    return $9f630f45399f356f$export$573326049e1b1c6b(val) === 'object';
}
function $9f630f45399f356f$export$edb10ab8dd75a915(val) {
    return typeof Object(val)[Symbol.asyncIterator] === 'function';
}
function $9f630f45399f356f$export$92bd080471bc30f1(val) {
    return $9f630f45399f356f$export$a6cdc56e425d0d0a(val) && typeof Object(val)[Symbol.asyncIterator] === 'function' && typeof val.return === 'function';
}
function $9f630f45399f356f$export$e6262fbc2e92290(obj) {
    return Array.isArray(obj) && // must be at least one error
    obj.length > 0 && // error has at least a message
    obj.every((ob)=>'message' in ob);
}
function $9f630f45399f356f$export$2937fa0c8dddae54(reason, whenTooLong) {
    return reason.length < 124 ? reason : whenTooLong;
}

});



parcelRegister("3DhQk", function(module, exports) {
$parcel$export(module.exports, "getRelayExperimentalApis", () => $f487779efdea9d57$export$2cb71284f72ca45b);
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
const $f487779efdea9d57$export$ebe3a775ce3053a5 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs',
    'help-object-store-agg-beta',
    'HelpCenterReorderTopics',
    'polaris-v0'
];
const $f487779efdea9d57$export$2cb71284f72ca45b = ()=>$f487779efdea9d57$export$ebe3a775ce3053a5;

});

parcelRegister("2Ssux", function(module, exports) {
$parcel$export(module.exports, "WS_CLIENT_KEEP_ALIVE", () => $095966b5717ea241$export$8b012b965402e06a);
$parcel$export(module.exports, "WS_CLIENT_LIVENESS_KEEP_ALIVE", () => $095966b5717ea241$export$68a6a6cccbaf5f06);
$parcel$export(module.exports, "WS_CLIENT_PONG_WAIT", () => $095966b5717ea241$export$6fe3216720bb7a79);
$parcel$export(module.exports, "WS_CLIENT_CONNECTION_ACK_WAIT", () => $095966b5717ea241$export$e5f3cb8ab5223cd4);
$parcel$export(module.exports, "WS_CLIENT_RETRIES", () => $095966b5717ea241$export$bf6cd96e19b2987f);
$parcel$export(module.exports, "WS_CLIENT_MAX_RETRY_WAIT", () => $095966b5717ea241$export$bcf3b302e1a0ba63);
$parcel$export(module.exports, "WS_CLOSE_RATE_LIMITED", () => $095966b5717ea241$export$74f911c394187993);
$parcel$export(module.exports, "WS_CLIENT_MAX_RETRY_AFTER", () => $095966b5717ea241$export$5d72de7e544ab20f);
$parcel$export(module.exports, "WS_CLIENT_RATE_LIMIT_SPREAD", () => $095966b5717ea241$export$a5991d6597d2d0f8);
$parcel$export(module.exports, "WS_CLIENT_CAPPED_RETRIES", () => $095966b5717ea241$export$6a0c27ebdbd1f0ed);
$parcel$export(module.exports, "WS_CLIENT_LAZY_CLOSE", () => $095966b5717ea241$export$3f57674185473b5d);
// Gate off keepAlive. UCT refresh window:
// https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $095966b5717ea241$export$8b012b965402e06a = 580000;
const $095966b5717ea241$export$68a6a6cccbaf5f06 = 30000;
const $095966b5717ea241$export$6fe3216720bb7a79 = 15000;
const $095966b5717ea241$export$e5f3cb8ab5223cd4 = 15000;
const $095966b5717ea241$export$bf6cd96e19b2987f = 100;
const $095966b5717ea241$export$bcf3b302e1a0ba63 = 30000;
const $095966b5717ea241$export$74f911c394187993 = 4430;
const $095966b5717ea241$export$5d72de7e544ab20f = 300000;
const $095966b5717ea241$export$a5991d6597d2d0f8 = 15000;
const $095966b5717ea241$export$6a0c27ebdbd1f0ed = 240;
const $095966b5717ea241$export$3f57674185473b5d = 5000;
const $095966b5717ea241$export$1ad8434180c5936c = 300000;

});

parcelRegister("5UfqC", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $ef3b71557a39c8f9$export$48d7c418edadb60c);
$parcel$export(module.exports, "getAggSubscriptionEndpoint", () => $ef3b71557a39c8f9$export$29a72e89601dfc59);
const $ef3b71557a39c8f9$export$48d7c418edadb60c = ()=>globalThis.__SERVER__ ?? false;
const $ef3b71557a39c8f9$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;

});

parcelRegister("5jDad", function(module, exports) {
$parcel$export(module.exports, "createClientState", () => $d99a4093d2db7a5b$export$cc843780465d747);
$parcel$export(module.exports, "setEndpointRecoveryEnabled", () => $d99a4093d2db7a5b$export$9a35d4fa6f37aac7);
$parcel$export(module.exports, "acquireClient", () => $d99a4093d2db7a5b$export$8ecce7f262269062);

var $AYl3d = parcelRequire("AYl3d");
const $d99a4093d2db7a5b$export$cc843780465d747 = ()=>({
        client: null,
        isSocketConnected: ()=>false,
        abortPendingRetryWait: ()=>false,
        observesSocketState: false,
        lazyCloseTimeout: 0
    });
const $d99a4093d2db7a5b$var$clients = new Map();
let $d99a4093d2db7a5b$var$recoveryEnabled = false;
function $d99a4093d2db7a5b$var$attachRecovery(entry) {
    if ($d99a4093d2db7a5b$var$recoveryEnabled && entry.references > 0 && !entry.detachRecovery) entry.detachRecovery = (0, $AYl3d.addRecoveryListeners)({
        terminate: ()=>entry.client.terminate(),
        isConnected: entry.state.isSocketConnected,
        abortRetryWait: entry.state.abortPendingRetryWait
    });
}
function $d99a4093d2db7a5b$export$9a35d4fa6f37aac7(enabled) {
    $d99a4093d2db7a5b$var$recoveryEnabled = enabled;
    for (const entry of $d99a4093d2db7a5b$var$clients.values())if (enabled) $d99a4093d2db7a5b$var$attachRecovery(entry);
    else {
        entry.detachRecovery?.();
        entry.detachRecovery = undefined;
    }
}
function $d99a4093d2db7a5b$export$8ecce7f262269062(url, initialize, getConnectionState) {
    let entry = $d99a4093d2db7a5b$var$clients.get(url);
    if (!entry) {
        const state = $d99a4093d2db7a5b$export$cc843780465d747();
        const client = initialize(state, url);
        if (!client) return null;
        entry = {
            state: state,
            client: client,
            references: 0
        };
        $d99a4093d2db7a5b$var$clients.set(url, entry);
    }
    const acquired = entry;
    clearTimeout(acquired.evictionTimer);
    acquired.evictionTimer = undefined;
    acquired.references += 1;
    $d99a4093d2db7a5b$var$attachRecovery(acquired);
    let released = false;
    return {
        client: acquired.client,
        getSocketConnectionState: ()=>getConnectionState(acquired.state),
        release: ()=>{
            if (released) return;
            released = true;
            if (--acquired.references !== 0) return;
            acquired.detachRecovery?.();
            acquired.detachRecovery = undefined;
            const evict = ()=>{
                // A rapid resubscription can retain the entry during the lazy-close window.
                if (acquired.references !== 0 || $d99a4093d2db7a5b$var$clients.get(url) !== acquired) return;
                $d99a4093d2db7a5b$var$clients.delete(url);
                try {
                    Promise.resolve(acquired.client.dispose()).catch(()=>{
                    /* disposal errors must not break observer teardown */ });
                } catch  {
                /* disposal errors must not break observer teardown */ }
            };
            if (acquired.state.lazyCloseTimeout > 0) acquired.evictionTimer = setTimeout(evict, acquired.state.lazyCloseTimeout);
            else evict();
        }
    };
}

});
parcelRegister("AYl3d", function(module, exports) {
$parcel$export(module.exports, "createRetryWait", () => $df81418a02d6b48c$export$ea2f6b7dff89727b);
$parcel$export(module.exports, "shouldRetryTransportFailure", () => $df81418a02d6b48c$export$f7ed0a50263b7ba7);
$parcel$export(module.exports, "createRateLimitedRetryWait", () => $df81418a02d6b48c$export$7543ed35130ad0de);
$parcel$export(module.exports, "addRecoveryListeners", () => $df81418a02d6b48c$export$693cd641fa681cb1);

var $brxde = parcelRequire("brxde");

var $2Ssux = parcelRequire("2Ssux");
const $df81418a02d6b48c$export$ea2f6b7dff89727b = (maxRetryWait)=>{
    let abortCurrent;
    return {
        abort: ()=>{
            if (!abortCurrent) return false;
            abortCurrent();
            abortCurrent = undefined;
            return true;
        },
        wait: async (retries)=>{
            const jitter = Math.floor(Math.random() * 2700 + 300);
            const delay = Math.min(1000 * 2 ** retries + jitter, maxRetryWait);
            await new Promise((resolve)=>{
                const timer = setTimeout(()=>{
                    abortCurrent = undefined;
                    resolve();
                }, delay);
                abortCurrent = ()=>{
                    clearTimeout(timer);
                    resolve();
                };
            });
        }
    };
};
// The library's own default `shouldRetry`. From 5.16, `Client.terminate()` emits a close-like
// `Error`, so the close shape must be checked before the type.
const $df81418a02d6b48c$var$isLikeCloseEvent = (value)=>typeof value === 'object' && value !== null && 'code' in value && 'reason' in value;
const $df81418a02d6b48c$export$f7ed0a50263b7ba7 = (errOrCloseEvent)=>$df81418a02d6b48c$var$isLikeCloseEvent(errOrCloseEvent) || !(errOrCloseEvent instanceof Error);
/** Retry-after in ms of a rate-limit close, or undefined for any other close. */ const $df81418a02d6b48c$var$getRateLimitRetryAfter = (event)=>{
    if (!$df81418a02d6b48c$var$isLikeCloseEvent(event) || event.code !== (0, $2Ssux.WS_CLOSE_RATE_LIMITED) || typeof event.reason !== 'string' || !/^\d+$/.test(event.reason)) return undefined;
    return Math.min(Math.max(Number(event.reason), 1) * 1000, (0, $2Ssux.WS_CLIENT_MAX_RETRY_AFTER));
};
const $df81418a02d6b48c$export$7543ed35130ad0de = (maxRetryWait)=>{
    let notBefore = 0;
    let abortCurrent;
    return {
        recordClose: (event)=>{
            const retryAfter = $df81418a02d6b48c$var$getRateLimitRetryAfter(event);
            if (retryAfter !== undefined) notBefore = Date.now() + retryAfter + Math.floor(Math.random() * (0, $2Ssux.WS_CLIENT_RATE_LIMIT_SPREAD));
        },
        abort: ()=>{
            if (!abortCurrent) return false;
            abortCurrent();
            return true;
        },
        wait: async (retries)=>{
            const jitter = Math.floor(Math.random() * 2700 + 300);
            // Jitter after the cap, so clients that reached it do not retry in lockstep.
            const backoff = Math.min(1000 * 2 ** retries, maxRetryWait) + jitter;
            await new Promise((resolve)=>{
                let timer;
                const finish = ()=>{
                    clearTimeout(timer);
                    abortCurrent = undefined;
                    resolve();
                };
                const finishAfter = (delay)=>{
                    clearTimeout(timer);
                    timer = setTimeout(finish, delay);
                };
                finishAfter(Math.max(backoff, notBefore - Date.now()));
                abortCurrent = ()=>{
                    const untilDeadline = notBefore - Date.now();
                    if (untilDeadline > 0) finishAfter(untilDeadline);
                    else finish();
                };
            });
        }
    };
};
const $df81418a02d6b48c$export$693cd641fa681cb1 = ({ terminate: terminate, isConnected: isConnected, abortRetryWait: abortRetryWait })=>{
    const doc = (0, $brxde.getDocument)();
    const reconnect = ()=>{
        if (abortRetryWait()) return;
        terminate();
    };
    const wakeIfDisconnected = ()=>{
        if (!isConnected()) reconnect();
    };
    const onVisibilityChange = ()=>{
        if (doc?.visibilityState === 'visible') wakeIfDisconnected();
    };
    const onPageShow = (event)=>{
        // pageshow also fires on ordinary loads; only `persisted` is bfcache.
        if (event.persisted) reconnect();
    };
    const onResume = ()=>{
        reconnect();
    };
    window.addEventListener('online', wakeIfDisconnected);
    window.addEventListener('pageshow', onPageShow);
    doc?.addEventListener('visibilitychange', onVisibilityChange);
    // Chrome tab freeze; no pageshow.
    doc?.addEventListener('resume', onResume);
    return ()=>{
        window.removeEventListener('online', wakeIfDisconnected);
        window.removeEventListener('pageshow', onPageShow);
        doc?.removeEventListener('visibilitychange', onVisibilityChange);
        doc?.removeEventListener('resume', onResume);
    };
};

});
parcelRegister("brxde", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $6cf9a570e39d3c5c$export$f65ca476c09acec0);
const $6cf9a570e39d3c5c$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});



parcelRegister("e1eYM", function(module, exports) {
$parcel$export(module.exports, "createSocketListeners", () => $b2edc57949f0cab0$export$e9b0d6f3238eb01d);

var $7GiIo = parcelRequire("7GiIo");
// Browser close is a CloseEvent; Client.terminate() emits a close-like object, which from
// graphql-ws 5.16 is an Error.
const $b2edc57949f0cab0$var$readCloseInfo = (event)=>{
    if (typeof event !== 'object' || event === null) return {
        closeCode: null,
        reason: null,
        wasClean: null
    };
    const code = 'code' in event ? event.code : undefined;
    const reason = 'reason' in event ? event.reason : undefined;
    const wasClean = 'wasClean' in event ? event.wasClean : undefined;
    return {
        closeCode: typeof code === 'number' ? code : null,
        reason: typeof reason === 'string' ? reason : null,
        wasClean: typeof wasClean === 'boolean' ? wasClean : null
    };
};
const $b2edc57949f0cab0$export$e9b0d6f3238eb01d = ({ onConnectionEvent: onConnectionEvent, pongWaitTimeout: pongWaitTimeout, terminate: terminate })=>{
    let attempt = 0;
    let connectionCount = 0;
    let connectedAt = null;
    let pongDeadline;
    const report = (event)=>{
        if (!onConnectionEvent) return;
        try {
            onConnectionEvent(event);
        } catch  {
        // Avoid breaking the transport if reporting throws.
        }
    };
    const clearPongDeadline = ()=>{
        clearTimeout(pongDeadline);
        pongDeadline = undefined;
    };
    return {
        isConnected: ()=>connectedAt !== null,
        listeners: {
            connecting: ()=>{
                attempt += 1;
                report({
                    type: 'connecting',
                    attempt: attempt
                });
            },
            opened: ()=>{
                report({
                    type: 'opened',
                    attempt: attempt
                });
            },
            connected: ()=>{
                connectionCount += 1;
                connectedAt = Date.now();
                report({
                    type: 'connected',
                    attempt: attempt,
                    connectionCount: connectionCount
                });
                attempt = 0;
            },
            closed: (event)=>{
                // Drop the deadline so it cannot kill a reconnecting socket.
                clearPongDeadline();
                report({
                    type: 'closed',
                    ...$b2edc57949f0cab0$var$readCloseInfo(event),
                    connectedForMs: connectedAt === null ? null : Date.now() - connectedAt
                });
                connectedAt = null;
            },
            // Only our outbound ping arms the deadline; only an inbound pong clears it.
            ping: (received)=>{
                if (received || pongWaitTimeout <= 0) return;
                clearPongDeadline();
                pongDeadline = setTimeout(terminate, pongWaitTimeout);
            },
            pong: (received)=>{
                if (received) clearPongDeadline();
            },
            error: (error)=>{
                report({
                    type: 'error',
                    message: error instanceof Error ? error.message : null,
                    kind: (0, $7GiIo.getSinkError)(error).kind
                });
            }
        }
    };
};

});
parcelRegister("7GiIo", function(module, exports) {
$parcel$export(module.exports, "getSinkError", () => $38c12a0221763a5b$export$ece4736473c28965);

var $2aEiL = parcelRequire("2aEiL");
/** `Array.isArray` alone narrows a `readonly` array to `any[]`, losing the element type. */ const $38c12a0221763a5b$var$isGraphQLErrorArray = (error)=>Array.isArray(error);
/**
 * Events are duck-typed rather than matched with `instanceof`: `Event`, `CloseEvent` and
 * `ErrorEvent` are not globals in every environment the client runs in, and `instanceof`
 * throws outright when its right-hand side is undefined.
 */ const $38c12a0221763a5b$var$isEventLike = (error)=>typeof error === 'object' && error !== null && 'type' in error && typeof error.type === 'string';
const $38c12a0221763a5b$var$isCloseEvent = (error)=>$38c12a0221763a5b$var$isEventLike(error) && error.type === 'close';
const $38c12a0221763a5b$var$isErrorEvent = (error)=>$38c12a0221763a5b$var$isEventLike(error) && error.type === 'error';
// The numeric `code` keeps out Node-style errors, whose `code` is a string such as `ECONNRESET`.
const $38c12a0221763a5b$var$isCloseLike = (error)=>typeof error === 'object' && error !== null && 'code' in error && typeof error.code === 'number' && 'reason' in error && typeof error.reason === 'string';
/** Non-enumerable details on a shared Error instance (same object goes to every sink). */ const $38c12a0221763a5b$var$withDetails = (error, details)=>{
    for (const [key, value] of Object.entries(details))Object.defineProperty(error, key, {
        value: value,
        enumerable: false,
        configurable: true,
        writable: true
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return error;
};
/** Pre-gate sink shaping. */ const $38c12a0221763a5b$var$getLegacySinkError = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const closeEvent = error;
        errorInfo = new Error(`CloseEvent: ${closeEvent.reason}`);
        errorInfo.closeCode = closeEvent.code;
        errorInfo.wasClean = closeEvent.wasClean;
    } else if (typeof error === 'object' && 'type' in error && error.type === 'error') {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const errorEvent = error;
        errorInfo = new Error(`ErrorEvent: "${errorEvent.error}"`);
    } else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    if (error instanceof Error && error.stack) errorInfo.stack = error.stack;
    return errorInfo;
};
const $38c12a0221763a5b$var$getStructuredSinkError = (error)=>{
    if ($38c12a0221763a5b$var$isGraphQLErrorArray(error)) {
        const [firstError] = error;
        // A real Error, not the raw payload element typed as one, so it carries a stack. AGG
        // sends these as JSON, so the element is a plain object however it is typed.
        const errorInfo = Object.assign(new Error(firstError?.message), {
            kind: 'graphql-errors',
            graphQLErrors: error
        });
        if (firstError?.stack) errorInfo.stack = firstError.stack;
        return errorInfo;
    }
    if (error instanceof Error) // Its own `wasClean`, where it has one, is left as it is rather than redefined.
    return $38c12a0221763a5b$var$withDetails(error, $38c12a0221763a5b$var$isCloseLike(error) ? {
        kind: 'close-event',
        closeCode: error.code
    } : {
        kind: 'error'
    });
    if ($38c12a0221763a5b$var$isCloseEvent(error)) return Object.assign(new Error(`CloseEvent: ${error.reason}`), {
        kind: 'close-event',
        closeCode: error.code,
        wasClean: error.wasClean
    });
    if ($38c12a0221763a5b$var$isErrorEvent(error)) return Object.assign(new Error(`ErrorEvent: "${error.error}"`), {
        kind: 'error-event'
    });
    if ($38c12a0221763a5b$var$isEventLike(error)) return Object.assign(new Error(`Event: ${error.type}`), {
        kind: 'event'
    });
    // `String` rather than interpolation, which throws for a symbol.
    const message = `Unknown sink error: ${String(error)}`;
    // A close with no `type`, such as "All Subscriptions Gone". The message stays as it was,
    // because consumers match on it.
    if ($38c12a0221763a5b$var$isCloseLike(error)) return Object.assign(new Error(message), {
        kind: 'close-event',
        closeCode: error.code,
        ...'wasClean' in error && typeof error.wasClean === 'boolean' ? {
            wasClean: error.wasClean
        } : {}
    });
    return Object.assign(new Error(message), {
        kind: 'unknown'
    });
};
const $38c12a0221763a5b$export$ece4736473c28965 = (error)=>{
    if ((0, $2aEiL.fg)('platform_relay_subscription_sink_error')) return $38c12a0221763a5b$var$getStructuredSinkError(error);
    // Gate off: legacy shape (no `kind`).
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return $38c12a0221763a5b$var$getLegacySinkError(error);
};

});



parcelRegister("hxjq4", function(module, exports) {
$parcel$export(module.exports, "default", () => $558df87437bbe877$export$2e2bcd8739ae039);
function $558df87437bbe877$export$2e2bcd8739ae039(fieldValue, typeName) {
    const { id: id } = fieldValue;
    if (id == null) return undefined;
    return `${String(id)}:::::${typeName}`;
}

});

parcelRegister("ku7St", function(module, exports) {
$parcel$export(module.exports, "fetch", () => $542fcce87a5ec32f$export$e7aa7bc5c1b3cfb3);

var $gUInl = parcelRequire("gUInl");

var $ArurZ = parcelRequire("ArurZ");

var $2aEiL = parcelRequire("2aEiL");

var $je4vK = parcelRequire("je4vK");

var $4UId7 = parcelRequire("4UId7");

var $euqj1 = parcelRequire("euqj1");

var $3vLMp = parcelRequire("3vLMp");

var $jAxjT = parcelRequire("jAxjT");

var $41HbU = parcelRequire("41HbU");

var $cWJT3 = parcelRequire("cWJT3");

var $jfiiz = parcelRequire("jfiiz");

var $1then = parcelRequire("1then");

var $ahkVX = parcelRequire("ahkVX");

var $3IJl1 = parcelRequire("3IJl1");

var $kQanL = parcelRequire("kQanL");

var $ekPd4 = parcelRequire("ekPd4");

var $kfWNj = parcelRequire("kfWNj");
const $542fcce87a5ec32f$var$isSsrHandoverIncrementsEnabled = ()=>Boolean(globalThis.__SSR_HANDOVER_INCREMENTS);
const $542fcce87a5ec32f$var$moduleID = 'relay-fetch';
const $542fcce87a5ec32f$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig, dependencies)=>{
    if (dependencies?.didPreflightAuthenticationCheckTriggerRedirect?.(request, variables, cacheConfig) === true) // Jira's preflight check starts login navigation as a side effect. Keep Relay pending
    // while the redirect takes over instead of starting a fetch with a stale auth state.
    return (0, $ArurZ.Observable).from(new Promise(()=>{}));
    const { name: queryName, operationKind: operationKind } = request;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = dependencies?.getLoggingAndMetricsHelper?.(loggingMetadata);
    // Per-query opt-in (cacheConfig.metadata.captureErrors) to forward this operation's response to
    // the product's capture callback, if one is provided. Whether to actually capture (feature gates,
    // etc.) is a product concern owned by the callback itself, not by this platform code.
    const shouldCaptureErrors = cacheConfig?.metadata?.captureErrors === true && !dependencies?.isServer;
    let responseHeaders;
    // A payload already chose this operation's trace id. A later transport error must not append
    // the header id as well.
    let responseTraceIdCaptured = false;
    function responseHeaderTraceId() {
        return responseHeaders?.get('atl-traceid') ?? undefined;
    }
    function augmentResponse(response) {
        const traceIdFromHeader = responseHeaderTraceId();
        (0, $3vLMp.addTraceId)(queryName, (0, $kfWNj.getTraceIdFromExtensions)(response) ?? traceIdFromHeader, variables);
        (0, $je4vK.putExtensions)(queryName, response.extensions);
        responseTraceIdCaptured = true;
    }
    function recordAvailableHeaderTraceId() {
        if (responseTraceIdCaptured) return;
        const traceId = responseHeaderTraceId();
        if (traceId === undefined) return;
        responseTraceIdCaptured = true;
        (0, $3vLMp.addTraceId)(queryName, traceId, variables);
    }
    // TODO: This needs to be changed by removing each Product, and only if all keys are empty final output is null
    function enforceNonNullability(response) {
        if (response.data && // DO NOT ADD TO THIS CONDITION.
        // Doing so can make service timeouts in non-critical dependencies result in a complete breakage of experiences.
        // If requesting a namespaced field, flatten it - e.g. "query { foo { bar {" should become "query { foo_bar {".
        // See https://atlassian.slack.com/archives/C01E2MPPLE4/p1780367270438419.
        (response.data.jira === null || response.data.customerService === null || response.data.graphStore === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    return (0, $ArurZ.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            // Unique identifier for the server-to-client channel.
            const sinkID = `${$542fcce87a5ec32f$var$moduleID}-${requestID}`;
            let resolveCompletedResponse;
            const completedResponse = new Promise((resolve)=>{
                resolveCompletedResponse = resolve;
            });
            const cacheSsrResultOnCompletion = dependencies?.isServer && !$542fcce87a5ec32f$var$isSsrHandoverIncrementsEnabled() && (0, $2aEiL.fg)('platform_relay_ssr_cache_incremental_payloads');
            const ssrPayloads = [];
            let hasPendingPayloads = false;
            const finalise = ()=>{
                if (cacheSsrResultOnCompletion && !hasPendingPayloads && ssrPayloads.length > 0) {
                    if (requestID != null) dependencies?.queryResponseCache?.setWithMetadata(requestID, variables, ssrPayloads.length === 1 ? ssrPayloads[0] : [
                        ...ssrPayloads
                    ], loggingMetadata);
                    ssrPayloads.length = 0;
                }
                resolveCompletedResponse();
                sink.complete();
            };
            const handleResponse = (response)=>{
                if (cacheSsrResultOnCompletion && 'hasNext' in response) hasPendingPayloads = response.hasNext === true;
                let payload = null;
                if ('incremental' in response && response.incremental) {
                    if (response.incremental.length) // Relay is expecting the contents of this array rather than the entire array itself. Also, Relay doesn't really care about tracking
                    // the pending versus completed values, so we can just return the array without the extra account keeping.
                    // @ts-expect-error It's hard to type this correctly because the payload sometimes has errors, sometimes not. Relay accounts for it,
                    // TypeScript can't handle the polymorphism.
                    payload = response.incremental;
                    else if (response.hasNext === false) // It's possible for the server to send back an empty final increment.
                    // Attempt to make Relay happy.
                    payload = {
                        data: null,
                        extensions: {
                            is_final: true
                        }
                    };
                } else // @ts-expect-error Typescript isn't happy that sometimes errors is undefined, but relay will manage just fine.
                payload = response;
                // Notify observers that we have more data!
                if (payload) {
                    if (cacheSsrResultOnCompletion) // Cache Relay's payload shape, not AGG's incremental envelope.
                    // A partial/aborted response must be fetched again during hydration.
                    ssrPayloads.push(...Array.isArray(payload) ? payload : [
                        payload
                    ]);
                    sink.next(payload);
                }
                // Close the stream if there are no more responses.
                if ('hasNext' in response && response.hasNext === false) finalise();
            };
            // handles getting multipart response
            const getData = ()=>{
                const endpoint = (0, $4UId7.getAggEndpoint)(request, cacheConfig);
                const body = (0, $4UId7.getRequestBody)(request, variables);
                let options = {
                    body: body
                };
                if (dependencies?.getHeaders) {
                    const headers = dependencies.getHeaders({
                        endpoint: endpoint,
                        options: options,
                        request: request,
                        variables: variables
                    });
                    options = {
                        ...options,
                        headers: {
                            ...options.headers,
                            ...headers
                        }
                    };
                }
                if (dependencies?.getAbortSignal) options.signal = dependencies?.getAbortSignal();
                const fetchOverNetwork = (0, $1then.buildGraphqlSmartFetch)({
                    url: dependencies?.setEndpoint ? dependencies?.setEndpoint(endpoint) : endpoint,
                    options: options,
                    variables: variables,
                    request: request,
                    isServer: dependencies?.isServer || false,
                    cacheConfig: cacheConfig
                });
                const earlyScriptPromise = dependencies?.earlyScriptPromise?.(request, variables);
                let fetchFn = fetchOverNetwork;
                let initialSource = fetchFn;
                if (dependencies?.withErrorHandling) {
                    const withErrorHandling = dependencies.withErrorHandling;
                    initialSource = ()=>!dependencies?.isServer && earlyScriptPromise ? withErrorHandling(earlyScriptPromise) : withErrorHandling(fetchFn());
                } else if ((0, $2aEiL.fg)('relay_environment_-_add_status-code_to_agg_errors')) {
                    // Preserve existing custom handlers and their retry semantics (e.g. Jira).
                    const checkResponse = (response)=>{
                        const details = (0, $cWJT3.getHttpErrorDetails)(response);
                        if (details) throw new (0, $jfiiz.RelayHttpError)(details);
                        return response;
                    };
                    fetchFn = ()=>fetchOverNetwork().then(checkResponse);
                    initialSource = ()=>!dependencies?.isServer && earlyScriptPromise ? earlyScriptPromise.then(checkResponse) : fetchFn();
                }
                const responses = (0, $ahkVX.processMultipartPromise)(()=>(0, $kQanL.retryOnError)(initialSource, {
                        retryFunc: fetchFn,
                        retryPredicate: (0, $ekPd4.shouldRetry),
                        retryAttempts: (0, $3IJl1.getRetryAttemptsForQuery)(request),
                        onRetry: loggingAndMetrics?.logErrorRetry
                    }), dependencies?.onFetchError, (headers)=>{
                    responseHeaders = headers;
                });
                // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
                // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                let responseShouldHang = false;
                let firstResponseUsed = false;
                let resolveFirstResponse;
                const firstResponse = new Promise((resolve)=>{
                    resolveFirstResponse = resolve;
                });
                responses.subscribe({
                    start: ()=>{
                        if (requestID != null) {
                            if (dependencies?.isServer) {
                                // so that SSR SPA knows it is safe to render
                                const renderAfterThisResponse = $542fcce87a5ec32f$var$isSsrHandoverIncrementsEnabled() ? firstResponse : completedResponse;
                                (0, $euqj1.QueryPromisesMap).set(requestID, renderAfterThisResponse);
                            } else (0, $euqj1.QueryPromisesMap).set(requestID, firstResponse);
                            (0, $euqj1.CompletedQueryPromisesMap).set(requestID, completedResponse);
                        }
                    },
                    next: (r)=>{
                        let payload = r;
                        let response = payload || {};
                        if (dependencies?.isServer && $542fcce87a5ec32f$var$isSsrHandoverIncrementsEnabled() && firstResponseUsed) {
                            // Send the response payload to a side-channel.
                            // TODO MAGMA-3204: improve robustness. Should be sending ID of module to communicate with, sinkID should be an argument.
                            (0, $41HbU.registerEvent)({
                                id: sinkID,
                                name: 'default',
                                args: [
                                    response
                                ]
                            });
                            if ('hasNext' in response && response.hasNext === false) finalise();
                            // Don't send any further responses to the fetch subscriber, since we'll be sending them through a side-channel.
                            return;
                        }
                        if (!firstResponseUsed) {
                            firstResponseUsed = true;
                            // according to spec, we can assume the first response is a GraphQLSingularResponse.
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const singularResponse = response;
                            augmentResponse(singularResponse);
                            if (shouldCaptureErrors && typeof dependencies?.captureResponseErrors === 'function') dependencies.captureResponseErrors(request, singularResponse);
                            if (dependencies?.validateResponse && !dependencies.validateResponse(request, singularResponse)) {
                                dependencies?.onInvalidResponse?.(request, singularResponse);
                                responseShouldHang = true;
                                return;
                            }
                            enforceNonNullability(singularResponse);
                            // write cache query response on SSR
                            // only write cache query response once or else this will break the assumption of graphql response being singular response
                            if (dependencies?.isServer && !cacheSsrResultOnCompletion && requestID != null && typeof dependencies?.queryResponseCache !== 'undefined') {
                                if ('appendWithMetadata' in dependencies.queryResponseCache) dependencies.queryResponseCache.appendWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                                else dependencies.queryResponseCache.setWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                            }
                        }
                        handleResponse(response);
                        // signal that the initial response has been received
                        resolveFirstResponse();
                        // After the initial response, further responses are sent through a side-channel.
                        if (dependencies?.isServer && $542fcce87a5ec32f$var$isSsrHandoverIncrementsEnabled()) sink.complete();
                    },
                    error: (error)=>{
                        if (!firstResponseUsed) firstResponseUsed = true;
                        recordAvailableHeaderTraceId();
                        loggingAndMetrics?.logError(error);
                        sink.error(error);
                    },
                    complete: ()=>{
                        if (responseShouldHang) return;
                        finalise();
                    }
                });
            };
            // On client...
            if (!dependencies?.isServer && requestID != null) {
                // read cache from window.SPA_STATE if available
                const ssrCache = dependencies?.queryResponseCache?.get(requestID, variables);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($gUInl)))(ssrCache)) {
                    // The cached payload is seeded into Relay below without passing through
                    // validateResponse, so capture its errors here instead.
                    if (shouldCaptureErrors && !Array.isArray(ssrCache) && typeof dependencies?.captureResponseErrors === 'function') dependencies.captureResponseErrors(request, ssrCache);
                    dependencies?.queryResponseCache?.delete(requestID, variables);
                    sink.next(ssrCache);
                    if ($542fcce87a5ec32f$var$isSsrHandoverIncrementsEnabled() && 'hasNext' in ssrCache && ssrCache.hasNext) {
                        // TODO MAGMA-3017: what about SSR fallback mode, or scenarios where SSR has partially failed?
                        // TODO MAGMA-3204: improve robustness. Should be using a middle-man module rather than client dispatcher directly.
                        // Receive response events as they are streamed from the server.
                        (0, $jAxjT.getClientDispatcher)().register(sinkID, handleResponse);
                        (0, $jAxjT.getClientDispatcher)().onAbort(sinkID, ({ reason: reason })=>{
                            if (!sink.closed) {
                                dependencies?.handleAbort?.(request, reason);
                                // if server throws an exception (such as SSR hanging up due to deadline exceeded)
                                // refetch multipart data again via network
                                getData();
                            }
                        });
                    } else finalise();
                    return;
                }
            }
            getData();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            recordAvailableHeaderTraceId();
            loggingAndMetrics?.logError(error);
            sink.error(error);
        }
    });
};

});
parcelRegister("gUInl", function(module, exports) {
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $c5044c5a06929c59$var$isNil(value) {
    return value == null;
}
module.exports = $c5044c5a06929c59$var$isNil;

});

parcelRegister("je4vK", function(module, exports) {
$parcel$export(module.exports, "putExtensions", () => $f81660262269a591$export$17dc47fdf278de21);
const $f81660262269a591$var$OperationExtensionsMap = {};
const $f81660262269a591$export$8656ba3981c6f6c1 = (operationName)=>{
    $f81660262269a591$var$OperationExtensionsMap[operationName] = $f81660262269a591$var$OperationExtensionsMap[operationName] || [];
};
const $f81660262269a591$export$f16fa6040161f056 = (operationName)=>{
    $f81660262269a591$var$OperationExtensionsMap[operationName] = undefined;
};
const $f81660262269a591$export$17dc47fdf278de21 = (operationName, extension)=>{
    if (extension !== undefined) {
        const extensionsForOperation = $f81660262269a591$var$OperationExtensionsMap[operationName];
        if (extensionsForOperation !== undefined) extensionsForOperation.push(extension);
    }
};
const $f81660262269a591$export$7c6ea4184129ef74 = (operationName)=>$f81660262269a591$var$OperationExtensionsMap[operationName] || [];

});

parcelRegister("4UId7", function(module, exports) {
$parcel$export(module.exports, "getAggEndpoint", () => $c0640286ff697b2e$export$fd126d8de571b77d);
$parcel$export(module.exports, "getRequestBody", () => $c0640286ff697b2e$export$55bce18df99af758);

var $k1Wvt = parcelRequire("k1Wvt");
const $c0640286ff697b2e$var$branchSlug = typeof $k1Wvt !== 'undefined' && $k1Wvt.env ? undefined : undefined;
// Pre-encoded value passed through verbatim as the `serviceOverride` query param.
const $c0640286ff697b2e$var$serviceOverrides = typeof $k1Wvt !== 'undefined' && $k1Wvt.env ? undefined : undefined;
const $c0640286ff697b2e$export$8f8c52ac77845a86 = `/gateway/api/graphql${$c0640286ff697b2e$var$branchSlug ? `/${$c0640286ff697b2e$var$branchSlug}/graphql` : ''}`;
const $c0640286ff697b2e$export$fd126d8de571b77d = (request, cacheConfig = {})=>{
    let endpoint = $c0640286ff697b2e$export$8f8c52ac77845a86;
    if (cacheConfig.metadata?.META_SLOW_ENDPOINT) endpoint = `${endpoint}/slow`;
    if (request.id != null) endpoint = `${endpoint}/pq/${request.id}`;
    let url = `${endpoint}?operation=${request.name}`;
    if ($c0640286ff697b2e$var$serviceOverrides) url = `${url}&serviceOverride=${$c0640286ff697b2e$var$serviceOverrides}`;
    return url;
};
const $c0640286ff697b2e$export$55bce18df99af758 = (request, variables)=>{
    const requestBody = {
        operationName: request.name,
        variables: variables
    };
    return JSON.stringify(requestBody);
};

});

parcelRegister("euqj1", function(module, exports) {
$parcel$export(module.exports, "QueryPromisesMap", () => $c696723d228b7949$export$607b80f5bc6e396d);
$parcel$export(module.exports, "CompletedQueryPromisesMap", () => $c696723d228b7949$export$cdadce6ed6361a2c);
/**
 * A map of signals that the initial response from the network has been received for a given relay query.
 *
 * This signal is used on the server-side during SSR to prevent React from running a render pass
 * until we can guarantee the data has arrived and is cached in the relay-client.
 *
 * This allows us to make a meaningful an initial render pass, avoiding needless suspense boundaries
 * and avoiding adding noncritical work to the JS call stack.
 */ const $c696723d228b7949$export$607b80f5bc6e396d = new Map();
const $c696723d228b7949$export$cdadce6ed6361a2c = new Map();

});

parcelRegister("3vLMp", function(module, exports) {
$parcel$export(module.exports, "addTraceId", () => $4add53b47334e9cb$export$fcaa732775f12226);

var $lv8tB = parcelRequire("lv8tB");
const $4add53b47334e9cb$export$a2bcb2fac360646c = (operationName)=>{
    (0, $lv8tB.startCapturingTraceIdsForOperation)(operationName);
};
const $4add53b47334e9cb$export$559128bdc4352001 = (operationName)=>{
    (0, $lv8tB.stopCapturingTraceIdsForOperation)(operationName);
};
const $4add53b47334e9cb$export$fcaa732775f12226 = (operationName, traceId, variables)=>{
    (0, $lv8tB.recordTraceId)(operationName, traceId, variables);
};
const $4add53b47334e9cb$export$5113e470f5c95670 = (operationName)=>(0, $lv8tB.getCapturedTraceIds)(operationName);

});
parcelRegister("lv8tB", function(module, exports) {
$parcel$export(module.exports, "startCapturingTraceIdsForOperation", () => $20b7e4d6d26ee52e$export$8b184389fd4ed20b);
$parcel$export(module.exports, "stopCapturingTraceIdsForOperation", () => $20b7e4d6d26ee52e$export$eb9d7fc8b95c0dfe);
$parcel$export(module.exports, "recordTraceId", () => $20b7e4d6d26ee52e$export$87165385048cf7ff);
$parcel$export(module.exports, "getCapturedTraceIds", () => $20b7e4d6d26ee52e$export$af2228e00c126daa);
// Internal trace-id capture state, shared by the public entry points of this package.
//
// This file intentionally is NOT named `index.ts` so that adding new exports here does not
// expand the package's public barrel file (see the "No expanding existing src/index barrel
// files" ratcheting rule). Public surface area is exposed explicitly via subpath exports in
// package.json (`.` and `./start-capturing-trace-ids-by-predicate`).
const $20b7e4d6d26ee52e$var$OperationTraceIdMap = {};
const $20b7e4d6d26ee52e$var$predicateCaptures = new Set();
const $20b7e4d6d26ee52e$export$8b184389fd4ed20b = (operationName)=>{
    $20b7e4d6d26ee52e$var$OperationTraceIdMap[operationName] = $20b7e4d6d26ee52e$var$OperationTraceIdMap[operationName] || [];
};
const $20b7e4d6d26ee52e$export$6ce1cd976801b213 = (predicate)=>{
    const capture = {
        predicate: predicate,
        traces: []
    };
    $20b7e4d6d26ee52e$var$predicateCaptures.add(capture);
    return {
        getTraces: ()=>capture.traces.slice(),
        dispose: ()=>{
            $20b7e4d6d26ee52e$var$predicateCaptures.delete(capture);
        }
    };
};
const $20b7e4d6d26ee52e$export$eb9d7fc8b95c0dfe = (operationName)=>{
    $20b7e4d6d26ee52e$var$OperationTraceIdMap[operationName] = undefined;
};
const $20b7e4d6d26ee52e$export$87165385048cf7ff = (operationName, traceId, variables)=>{
    if (traceId === undefined) return;
    $20b7e4d6d26ee52e$var$OperationTraceIdMap[operationName]?.push(traceId);
    if ($20b7e4d6d26ee52e$var$predicateCaptures.size === 0) return;
    const context = {
        operationName: operationName,
        variables: variables ?? {}
    };
    for (const capture of [
        ...$20b7e4d6d26ee52e$var$predicateCaptures
    ])if (capture.predicate(context)) capture.traces.push(traceId);
};
const $20b7e4d6d26ee52e$export$af2228e00c126daa = (operationName)=>$20b7e4d6d26ee52e$var$OperationTraceIdMap[operationName] || [];

});


parcelRegister("jAxjT", function(module, exports) {
$parcel$export(module.exports, "getClientDispatcher", () => $ff4f8ae356eb9acd$export$5bb012cf9b3a5452);

var $AX5Us = parcelRequire("AX5Us");
const $ff4f8ae356eb9acd$export$eb5d9c90d65c7fea = 'ClientDispatcher';
let $ff4f8ae356eb9acd$var$dispatcher;
const $ff4f8ae356eb9acd$export$5bb012cf9b3a5452 = ()=>{
    if (!$ff4f8ae356eb9acd$var$dispatcher) {
        $ff4f8ae356eb9acd$var$dispatcher = new (0, $AX5Us.ClientDispatcher)();
        // Handle the server hangup scenarios
        $ff4f8ae356eb9acd$var$dispatcher.register($ff4f8ae356eb9acd$export$eb5d9c90d65c7fea, $ff4f8ae356eb9acd$var$dispatcher._abort.bind($ff4f8ae356eb9acd$var$dispatcher));
    }
    return $ff4f8ae356eb9acd$var$dispatcher;
};

});
parcelRegister("AX5Us", function(module, exports) {
$parcel$export(module.exports, "ClientDispatcher", () => $49542e2103814b16$export$3f5ba18eb97af725);
class $49542e2103814b16$export$3f5ba18eb97af725 {
    handlers;
    queuedPayloads;
    abortReason;
    abortHandlers;
    constructor(){
        this.handlers = new Map();
        this.abortHandlers = new Map();
        this.queuedPayloads = new Map();
    }
    /**
   * Ingest a payload from the server.
   * This will trigger a callback to the component that registered for this event, otherwise the payload will be queued to do so later.
   * @param payload - The payload to ingest.
   */ ingest(payload) {
        const handler = this.handlers.get(payload.id);
        if (handler) this.exec(handler, payload);
        else {
            const queue = this.queuedPayloads.get(payload.id) || [];
            queue.push(payload);
            this.queuedPayloads.set(payload.id, queue);
        }
    }
    /**
   * Register a callback for a given event. If any payloads were queued for this event, they will be processed immediately.
   * @param id - The event ID to register for.
   * @param callback - The callback to trigger when the event is ingested.
   */ register(id, callback) {
        this.handlers.set(id, callback);
        // Process any queued payloads for this handler
        const queuedPayloads = this.queuedPayloads.get(id) || [];
        if (queuedPayloads.length > 0) {
            queuedPayloads.forEach((payload)=>this.exec(callback, payload));
            this.queuedPayloads.delete(id);
        }
    }
    /**
   * Unregister a callback for a given event.
   * @param id
   */ unregister(id) {
        this.handlers.delete(id);
        this.queuedPayloads.delete(id);
    }
    /**
   * Register an abort handler that will get called if exceptional circmstances arise (such as SSR hanging up due to deadline exceeded)
   * @param id - The event ID to register for.
   * @param callback - The callback to trigger when abort detected.
   */ onAbort(id, callback) {
        if (this.abortReason) this.exec(callback, {
            args: [
                this.abortReason
            ]
        });
        else this.abortHandlers.set(id, callback);
    }
    /**
   * Notify any registered abort handlers that the server exceeded its deadline before finishing, so we may not have received all events.
   * @private
   * @param props
   */ _abort(props) {
        this.abortReason = props;
        this.abortHandlers.forEach((handler)=>{
            this.exec(handler, {
                args: [
                    props
                ]
            });
        });
        // We can delete these now that we've handled the case and remainder will be dealt with immediately.
        this.abortHandlers = new Map();
    }
    /**
   * Execute a callback with the given payload.
   * @param callback - The callback to execute.
   * @param payload - The payload to execute the callback with.
   */ exec(callback, payload) {
        const { args: args, error: error } = payload;
        try {
            if (error) throw error;
            // @ts-expect-error
            callback(...args);
        } catch (err) {
        // TODO: log error
        // console.error(err);
        }
    }
}

});


parcelRegister("41HbU", function(module, exports) {
$parcel$export(module.exports, "registerEvent", () => $f79f0a3c59f7c19a$export$bd50bc4cd3c601ee);
const $f79f0a3c59f7c19a$var$events = [];
const $f79f0a3c59f7c19a$export$bd50bc4cd3c601ee = (event)=>{
    $f79f0a3c59f7c19a$var$events.push(event);
};
const $f79f0a3c59f7c19a$export$3c7145db84d4587c = ()=>{
    return $f79f0a3c59f7c19a$var$events.splice(0, $f79f0a3c59f7c19a$var$events.length);
};

});

parcelRegister("cWJT3", function(module, exports) {
$parcel$export(module.exports, "getHttpErrorDetails", () => $5f9211c1e11a08d2$export$1862c452948bb411);
function $5f9211c1e11a08d2$export$1862c452948bb411(response) {
    if (response.ok) return undefined;
    // Match Jira's first-present-header precedence, including an empty atl-traceid.
    const header = [
        'atl-traceid',
        'x-trace-id'
    ].find((name)=>response.headers.has(name));
    return {
        statusCode: response.status,
        message: `Error server response: ${response.status}`,
        traceId: header === undefined ? undefined : response.headers.get(header) || undefined,
        originalResponse: response
    };
}

});

parcelRegister("jfiiz", function(module, exports) {
$parcel$export(module.exports, "RelayHttpError", () => $a39951487ca64457$export$8489bdbad141de6d);
class $a39951487ca64457$export$8489bdbad141de6d extends Error {
    statusCode;
    traceId;
    originalResponse;
    constructor({ statusCode: statusCode, message: message, traceId: traceId, originalResponse: originalResponse }){
        super(message);
        this.name = 'RelayHttpError';
        this.statusCode = statusCode;
        this.traceId = traceId;
        this.originalResponse = originalResponse;
    }
}

});

parcelRegister("1then", function(module, exports) {
$parcel$export(module.exports, "buildGraphqlSmartFetch", () => $1d9e1fb8f788d889$export$33c9c992c7855d86);

var $27UgF = parcelRequire("27UgF");

var $3DhQk = parcelRequire("3DhQk");

var $lilfh = parcelRequire("lilfh");

var $cnaFf = parcelRequire("cnaFf");
const $1d9e1fb8f788d889$var$relayDeferAcceptableFormats = [
    'application/graphql-response+json',
    'application/json',
    // there must not be spacing between `multipart/mixed` and `deferSpec=20220824` since the backend assumes no spacing
    'multipart/mixed;deferSpec=20220824'
];
function $1d9e1fb8f788d889$export$33c9c992c7855d86({ url: url, options: options, variables: variables, request: request, isServer: isServer, cacheConfig: cacheConfig }) {
    const headers = {
        'atl-client-name': 'atlassian-frontend-monorepo',
        Accept: $1d9e1fb8f788d889$var$relayDeferAcceptableFormats.join(', '),
        'X-ExperimentalApi': (0, $3DhQk.getRelayExperimentalApis)().join(','),
        ...cacheConfig?.metadata?.headers || {}
    };
    const requestOptions = (0, (/*@__PURE__*/$parcel$interopDefault($27UgF)))(options, {
        credentials: 'same-origin',
        headers: headers
    });
    requestOptions.headers['Content-Type'] = 'application/json';
    // Default `atl-attribution` header value for AGG requests
    // https://hello.atlassian.net/wiki/spaces/AGG/pages/5954141702/Metrics+Attribution+Onboarding+Doc+for+AGG+Clients
    if (!requestOptions.headers['atl-attribution']) requestOptions.headers['atl-attribution'] = JSON.stringify({
        service: 'afm-frontend'
    });
    const { isGetRequest: isGetRequest, reason: reason } = (0, $cnaFf.shouldUseGetMethod)({
        url: url,
        variables: variables,
        request: request,
        headers: requestOptions.headers,
        isServer: isServer
    });
    // Nav4ProjectsContentQuery is forced to go POST route to avoid the stale cache issues when transition between issues in Issue-view
    // that's not a permanent fix, but rather an attampt to unblock the team
    // Context: #jiv-navigation-issue channel
    if (isGetRequest && request.name !== 'Nav4ProjectsContentQuery') {
        requestOptions.method = 'GET';
        url = (0, $lilfh.buildGetUrl)(url, variables);
        delete requestOptions.body; // Not needed for GET
    } else {
        requestOptions.method = 'POST';
        if (reason) requestOptions.headers['X-Request-Fallback-To-Post-Reason'] = reason;
    }
    return ()=>fetch(url, requestOptions);
}

});
parcelRegister("27UgF", function(module, exports) {

var $5Ha4i = parcelRequire("5Ha4i");

var $dFAQ6 = parcelRequire("dFAQ6");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $18c7e1d20355a6d2$var$merge = $dFAQ6(function(object, source, srcIndex) {
    $5Ha4i(object, source, srcIndex);
});
module.exports = $18c7e1d20355a6d2$var$merge;

});
parcelRegister("5Ha4i", function(module, exports) {

var $hwJmJ = parcelRequire("hwJmJ");

var $Yqw9r = parcelRequire("Yqw9r");

var $lzMOl = parcelRequire("lzMOl");

var $iYYx4 = parcelRequire("iYYx4");

var $ghi1o = parcelRequire("ghi1o");

var $ddNxe = parcelRequire("ddNxe");

var $2oVqW = parcelRequire("2oVqW");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $4258c74045a2fcd8$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $lzMOl(source, function(srcValue, key) {
        stack || (stack = new $hwJmJ);
        if ($ghi1o(srcValue)) $iYYx4(object, source, key, srcIndex, $4258c74045a2fcd8$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($2oVqW(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $Yqw9r(object, key, newValue);
        }
    }, $ddNxe);
}
module.exports = $4258c74045a2fcd8$var$baseMerge;

});
parcelRegister("hwJmJ", function(module, exports) {

var $1bAQy = parcelRequire("1bAQy");

var $lkcKz = parcelRequire("lkcKz");

var $fzxNL = parcelRequire("fzxNL");

var $02pdR = parcelRequire("02pdR");

var $dgckY = parcelRequire("dgckY");

var $6zw9b = parcelRequire("6zw9b");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $cc289d839e0505ff$var$Stack(entries) {
    var data = this.__data__ = new $1bAQy(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$cc289d839e0505ff$var$Stack.prototype.clear = $lkcKz;
$cc289d839e0505ff$var$Stack.prototype['delete'] = $fzxNL;
$cc289d839e0505ff$var$Stack.prototype.get = $02pdR;
$cc289d839e0505ff$var$Stack.prototype.has = $dgckY;
$cc289d839e0505ff$var$Stack.prototype.set = $6zw9b;
module.exports = $cc289d839e0505ff$var$Stack;

});
parcelRegister("1bAQy", function(module, exports) {

var $2p8wj = parcelRequire("2p8wj");

var $dq02L = parcelRequire("dq02L");

var $9HiR0 = parcelRequire("9HiR0");

var $kgnUT = parcelRequire("kgnUT");

var $78vJm = parcelRequire("78vJm");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $0dd3668639474479$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$0dd3668639474479$var$ListCache.prototype.clear = $2p8wj;
$0dd3668639474479$var$ListCache.prototype['delete'] = $dq02L;
$0dd3668639474479$var$ListCache.prototype.get = $9HiR0;
$0dd3668639474479$var$ListCache.prototype.has = $kgnUT;
$0dd3668639474479$var$ListCache.prototype.set = $78vJm;
module.exports = $0dd3668639474479$var$ListCache;

});
parcelRegister("2p8wj", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $1c0486841de95923$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $1c0486841de95923$var$listCacheClear;

});

parcelRegister("dq02L", function(module, exports) {

var $gouco = parcelRequire("gouco");
/** Used for built-in method references. */ var $9c4dbcb59f18bdd5$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $9c4dbcb59f18bdd5$var$splice = $9c4dbcb59f18bdd5$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9c4dbcb59f18bdd5$var$listCacheDelete(key) {
    var data = this.__data__, index = $gouco(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $9c4dbcb59f18bdd5$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $9c4dbcb59f18bdd5$var$listCacheDelete;

});
parcelRegister("gouco", function(module, exports) {

var $dIKIh = parcelRequire("dIKIh");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bef65017ff6db777$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($dIKIh(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $bef65017ff6db777$var$assocIndexOf;

});
parcelRegister("dIKIh", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $9fd39eaea35431d7$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $9fd39eaea35431d7$var$eq;

});



parcelRegister("9HiR0", function(module, exports) {

var $gouco = parcelRequire("gouco");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $70f6c138ecccaaf3$var$listCacheGet(key) {
    var data = this.__data__, index = $gouco(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $70f6c138ecccaaf3$var$listCacheGet;

});

parcelRegister("kgnUT", function(module, exports) {

var $gouco = parcelRequire("gouco");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ec07daa171d63c49$var$listCacheHas(key) {
    return $gouco(this.__data__, key) > -1;
}
module.exports = $ec07daa171d63c49$var$listCacheHas;

});

parcelRegister("78vJm", function(module, exports) {

var $gouco = parcelRequire("gouco");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $5321e4cf4863d336$var$listCacheSet(key, value) {
    var data = this.__data__, index = $gouco(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $5321e4cf4863d336$var$listCacheSet;

});


parcelRegister("lkcKz", function(module, exports) {

var $1bAQy = parcelRequire("1bAQy");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $f8655b1f5c03393e$var$stackClear() {
    this.__data__ = new $1bAQy;
    this.size = 0;
}
module.exports = $f8655b1f5c03393e$var$stackClear;

});

parcelRegister("fzxNL", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b5645838ce2a5c1b$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $b5645838ce2a5c1b$var$stackDelete;

});

parcelRegister("02pdR", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0073c0b3f6410ef9$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $0073c0b3f6410ef9$var$stackGet;

});

parcelRegister("dgckY", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9a7656e4af8c02f6$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $9a7656e4af8c02f6$var$stackHas;

});

parcelRegister("6zw9b", function(module, exports) {

var $1bAQy = parcelRequire("1bAQy");

var $dYTal = parcelRequire("dYTal");

var $32K13 = parcelRequire("32K13");
/** Used as the size to enable large array optimizations. */ var $4c8ef2b2e0e17310$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $4c8ef2b2e0e17310$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $1bAQy) {
        var pairs = data.__data__;
        if (!$dYTal || pairs.length < $4c8ef2b2e0e17310$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $32K13(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $4c8ef2b2e0e17310$var$stackSet;

});
parcelRegister("dYTal", function(module, exports) {

var $coVaf = parcelRequire("coVaf");

var $fu3MD = parcelRequire("fu3MD");
/* Built-in method references that are verified to be native. */ var $a2dbabb923309a8e$var$Map = $coVaf($fu3MD, 'Map');
module.exports = $a2dbabb923309a8e$var$Map;

});
parcelRegister("coVaf", function(module, exports) {

var $b17iw = parcelRequire("b17iw");

var $bGZgc = parcelRequire("bGZgc");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $9074118dbd2c7036$var$getNative(object, key) {
    var value = $bGZgc(object, key);
    return $b17iw(value) ? value : undefined;
}
module.exports = $9074118dbd2c7036$var$getNative;

});
parcelRegister("b17iw", function(module, exports) {

var $6pshK = parcelRequire("6pshK");

var $emhAZ = parcelRequire("emhAZ");

var $ghi1o = parcelRequire("ghi1o");

var $jkHbF = parcelRequire("jkHbF");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $805572df233b3952$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $805572df233b3952$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $805572df233b3952$var$funcProto = Function.prototype, $805572df233b3952$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $805572df233b3952$var$funcToString = $805572df233b3952$var$funcProto.toString;
/** Used to check objects for own properties. */ var $805572df233b3952$var$hasOwnProperty = $805572df233b3952$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $805572df233b3952$var$reIsNative = RegExp('^' + $805572df233b3952$var$funcToString.call($805572df233b3952$var$hasOwnProperty).replace($805572df233b3952$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $805572df233b3952$var$baseIsNative(value) {
    if (!$ghi1o(value) || $emhAZ(value)) return false;
    var pattern = $6pshK(value) ? $805572df233b3952$var$reIsNative : $805572df233b3952$var$reIsHostCtor;
    return pattern.test($jkHbF(value));
}
module.exports = $805572df233b3952$var$baseIsNative;

});
parcelRegister("6pshK", function(module, exports) {

var $avvbo = parcelRequire("avvbo");

var $ghi1o = parcelRequire("ghi1o");
/** `Object#toString` result references. */ var $4aab04bb04c3c752$var$asyncTag = '[object AsyncFunction]', $4aab04bb04c3c752$var$funcTag = '[object Function]', $4aab04bb04c3c752$var$genTag = '[object GeneratorFunction]', $4aab04bb04c3c752$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $4aab04bb04c3c752$var$isFunction(value) {
    if (!$ghi1o(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $avvbo(value);
    return tag == $4aab04bb04c3c752$var$funcTag || tag == $4aab04bb04c3c752$var$genTag || tag == $4aab04bb04c3c752$var$asyncTag || tag == $4aab04bb04c3c752$var$proxyTag;
}
module.exports = $4aab04bb04c3c752$var$isFunction;

});
parcelRegister("avvbo", function(module, exports) {

var $ePDSv = parcelRequire("ePDSv");

var $22dFu = parcelRequire("22dFu");

var $awAG2 = parcelRequire("awAG2");
/** `Object#toString` result references. */ var $7a64fce3ad35bec5$var$nullTag = '[object Null]', $7a64fce3ad35bec5$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $7a64fce3ad35bec5$var$symToStringTag = $ePDSv ? $ePDSv.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $7a64fce3ad35bec5$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $7a64fce3ad35bec5$var$undefinedTag : $7a64fce3ad35bec5$var$nullTag;
    return $7a64fce3ad35bec5$var$symToStringTag && $7a64fce3ad35bec5$var$symToStringTag in Object(value) ? $22dFu(value) : $awAG2(value);
}
module.exports = $7a64fce3ad35bec5$var$baseGetTag;

});
parcelRegister("ePDSv", function(module, exports) {

var $fu3MD = parcelRequire("fu3MD");
/** Built-in value references. */ var $acc4c30f6ac65f0b$var$Symbol = $fu3MD.Symbol;
module.exports = $acc4c30f6ac65f0b$var$Symbol;

});
parcelRegister("fu3MD", function(module, exports) {

var $1TD6g = parcelRequire("1TD6g");
/** Detect free variable `self`. */ var $b45c97ab92a0072f$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $b45c97ab92a0072f$var$root = $1TD6g || $b45c97ab92a0072f$var$freeSelf || Function('return this')();
module.exports = $b45c97ab92a0072f$var$root;

});
parcelRegister("1TD6g", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $161941f40ca968ed$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $161941f40ca968ed$var$freeGlobal;

});



parcelRegister("22dFu", function(module, exports) {

var $ePDSv = parcelRequire("ePDSv");
/** Used for built-in method references. */ var $17b65edff2091133$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $17b65edff2091133$var$hasOwnProperty = $17b65edff2091133$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $17b65edff2091133$var$nativeObjectToString = $17b65edff2091133$var$objectProto.toString;
/** Built-in value references. */ var $17b65edff2091133$var$symToStringTag = $ePDSv ? $ePDSv.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $17b65edff2091133$var$getRawTag(value) {
    var isOwn = $17b65edff2091133$var$hasOwnProperty.call(value, $17b65edff2091133$var$symToStringTag), tag = value[$17b65edff2091133$var$symToStringTag];
    try {
        value[$17b65edff2091133$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $17b65edff2091133$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$17b65edff2091133$var$symToStringTag] = tag;
        else delete value[$17b65edff2091133$var$symToStringTag];
    }
    return result;
}
module.exports = $17b65edff2091133$var$getRawTag;

});

parcelRegister("awAG2", function(module, exports) {
/** Used for built-in method references. */ var $7a9957d78791668c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $7a9957d78791668c$var$nativeObjectToString = $7a9957d78791668c$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $7a9957d78791668c$var$objectToString(value) {
    return $7a9957d78791668c$var$nativeObjectToString.call(value);
}
module.exports = $7a9957d78791668c$var$objectToString;

});


parcelRegister("ghi1o", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $bd9c36897f32bc54$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $bd9c36897f32bc54$var$isObject;

});


parcelRegister("emhAZ", function(module, exports) {

var $Y8psS = parcelRequire("Y8psS");
/** Used to detect methods masquerading as native. */ var $a740c4e72789ae48$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($Y8psS && $Y8psS.keys && $Y8psS.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $a740c4e72789ae48$var$isMasked(func) {
    return !!$a740c4e72789ae48$var$maskSrcKey && $a740c4e72789ae48$var$maskSrcKey in func;
}
module.exports = $a740c4e72789ae48$var$isMasked;

});
parcelRegister("Y8psS", function(module, exports) {

var $fu3MD = parcelRequire("fu3MD");
/** Used to detect overreaching core-js shims. */ var $0b4c20b5139a10a8$var$coreJsData = $fu3MD["__core-js_shared__"];
module.exports = $0b4c20b5139a10a8$var$coreJsData;

});


parcelRegister("jkHbF", function(module, exports) {
/** Used for built-in method references. */ var $e13162a47d6fb338$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $e13162a47d6fb338$var$funcToString = $e13162a47d6fb338$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $e13162a47d6fb338$var$toSource(func) {
    if (func != null) {
        try {
            return $e13162a47d6fb338$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $e13162a47d6fb338$var$toSource;

});


parcelRegister("bGZgc", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $883322f59f53af56$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $883322f59f53af56$var$getValue;

});



parcelRegister("32K13", function(module, exports) {

var $aVbEC = parcelRequire("aVbEC");

var $bNRYK = parcelRequire("bNRYK");

var $fIhoV = parcelRequire("fIhoV");

var $i44Yz = parcelRequire("i44Yz");

var $dlpHP = parcelRequire("dlpHP");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $237540cfc67316b2$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$237540cfc67316b2$var$MapCache.prototype.clear = $aVbEC;
$237540cfc67316b2$var$MapCache.prototype['delete'] = $bNRYK;
$237540cfc67316b2$var$MapCache.prototype.get = $fIhoV;
$237540cfc67316b2$var$MapCache.prototype.has = $i44Yz;
$237540cfc67316b2$var$MapCache.prototype.set = $dlpHP;
module.exports = $237540cfc67316b2$var$MapCache;

});
parcelRegister("aVbEC", function(module, exports) {

var $gpYdu = parcelRequire("gpYdu");

var $1bAQy = parcelRequire("1bAQy");

var $dYTal = parcelRequire("dYTal");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $7f38448c07a8a7be$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $gpYdu,
        'map': new ($dYTal || $1bAQy),
        'string': new $gpYdu
    };
}
module.exports = $7f38448c07a8a7be$var$mapCacheClear;

});
parcelRegister("gpYdu", function(module, exports) {

var $b4JwA = parcelRequire("b4JwA");

var $2BXwW = parcelRequire("2BXwW");

var $iVnot = parcelRequire("iVnot");

var $jjfwg = parcelRequire("jjfwg");

var $aDnu6 = parcelRequire("aDnu6");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bf3db0e5391a0b9d$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$bf3db0e5391a0b9d$var$Hash.prototype.clear = $b4JwA;
$bf3db0e5391a0b9d$var$Hash.prototype['delete'] = $2BXwW;
$bf3db0e5391a0b9d$var$Hash.prototype.get = $iVnot;
$bf3db0e5391a0b9d$var$Hash.prototype.has = $jjfwg;
$bf3db0e5391a0b9d$var$Hash.prototype.set = $aDnu6;
module.exports = $bf3db0e5391a0b9d$var$Hash;

});
parcelRegister("b4JwA", function(module, exports) {

var $k1DLg = parcelRequire("k1DLg");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $810361a45cfd08e9$var$hashClear() {
    this.__data__ = $k1DLg ? $k1DLg(null) : {};
    this.size = 0;
}
module.exports = $810361a45cfd08e9$var$hashClear;

});
parcelRegister("k1DLg", function(module, exports) {

var $coVaf = parcelRequire("coVaf");
/* Built-in method references that are verified to be native. */ var $e942be69d5fbf0e2$var$nativeCreate = $coVaf(Object, 'create');
module.exports = $e942be69d5fbf0e2$var$nativeCreate;

});


parcelRegister("2BXwW", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $1e6d36fa5c851050$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $1e6d36fa5c851050$var$hashDelete;

});

parcelRegister("iVnot", function(module, exports) {

var $k1DLg = parcelRequire("k1DLg");
/** Used to stand-in for `undefined` hash values. */ var $dc6fb25f703dc4ae$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $dc6fb25f703dc4ae$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dc6fb25f703dc4ae$var$hasOwnProperty = $dc6fb25f703dc4ae$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $dc6fb25f703dc4ae$var$hashGet(key) {
    var data = this.__data__;
    if ($k1DLg) {
        var result = data[key];
        return result === $dc6fb25f703dc4ae$var$HASH_UNDEFINED ? undefined : result;
    }
    return $dc6fb25f703dc4ae$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $dc6fb25f703dc4ae$var$hashGet;

});

parcelRegister("jjfwg", function(module, exports) {

var $k1DLg = parcelRequire("k1DLg");
/** Used for built-in method references. */ var $e0ebd4835837def6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e0ebd4835837def6$var$hasOwnProperty = $e0ebd4835837def6$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e0ebd4835837def6$var$hashHas(key) {
    var data = this.__data__;
    return $k1DLg ? data[key] !== undefined : $e0ebd4835837def6$var$hasOwnProperty.call(data, key);
}
module.exports = $e0ebd4835837def6$var$hashHas;

});

parcelRegister("aDnu6", function(module, exports) {

var $k1DLg = parcelRequire("k1DLg");
/** Used to stand-in for `undefined` hash values. */ var $7bdfc36eb48f506f$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $7bdfc36eb48f506f$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $k1DLg && value === undefined ? $7bdfc36eb48f506f$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $7bdfc36eb48f506f$var$hashSet;

});



parcelRegister("bNRYK", function(module, exports) {

var $6xSxU = parcelRequire("6xSxU");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $897e245e65a839c9$var$mapCacheDelete(key) {
    var result = $6xSxU(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $897e245e65a839c9$var$mapCacheDelete;

});
parcelRegister("6xSxU", function(module, exports) {

var $1qmou = parcelRequire("1qmou");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $4c4022cedd2a0b42$var$getMapData(map, key) {
    var data = map.__data__;
    return $1qmou(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $4c4022cedd2a0b42$var$getMapData;

});
parcelRegister("1qmou", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $10999726243b507e$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $10999726243b507e$var$isKeyable;

});



parcelRegister("fIhoV", function(module, exports) {

var $6xSxU = parcelRequire("6xSxU");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b7087693d496d27b$var$mapCacheGet(key) {
    return $6xSxU(this, key).get(key);
}
module.exports = $b7087693d496d27b$var$mapCacheGet;

});

parcelRegister("i44Yz", function(module, exports) {

var $6xSxU = parcelRequire("6xSxU");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d26c75d4e211fc20$var$mapCacheHas(key) {
    return $6xSxU(this, key).has(key);
}
module.exports = $d26c75d4e211fc20$var$mapCacheHas;

});

parcelRegister("dlpHP", function(module, exports) {

var $6xSxU = parcelRequire("6xSxU");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $9b712d2b24952120$var$mapCacheSet(key, value) {
    var data = $6xSxU(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $9b712d2b24952120$var$mapCacheSet;

});




parcelRegister("Yqw9r", function(module, exports) {

var $1VaWt = parcelRequire("1VaWt");

var $dIKIh = parcelRequire("dIKIh");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $0b5a2c8c6045652c$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$dIKIh(object[key], value) || value === undefined && !(key in object)) $1VaWt(object, key, value);
}
module.exports = $0b5a2c8c6045652c$var$assignMergeValue;

});
parcelRegister("1VaWt", function(module, exports) {

var $2yWCC = parcelRequire("2yWCC");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $16639a3460adc762$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $2yWCC) $2yWCC(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $16639a3460adc762$var$baseAssignValue;

});
parcelRegister("2yWCC", function(module, exports) {

var $coVaf = parcelRequire("coVaf");
var $1ddc3acff07af414$var$defineProperty = function() {
    try {
        var func = $coVaf(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $1ddc3acff07af414$var$defineProperty;

});



parcelRegister("lzMOl", function(module, exports) {

var $RalW2 = parcelRequire("RalW2");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $fb52baaf1a4144db$var$baseFor = $RalW2();
module.exports = $fb52baaf1a4144db$var$baseFor;

});
parcelRegister("RalW2", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $09fcfb334ddd1658$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $09fcfb334ddd1658$var$createBaseFor;

});


parcelRegister("iYYx4", function(module, exports) {

var $Yqw9r = parcelRequire("Yqw9r");

var $4j97H = parcelRequire("4j97H");

var $cz8eW = parcelRequire("cz8eW");

var $3FhtJ = parcelRequire("3FhtJ");

var $kbyCA = parcelRequire("kbyCA");

var $hAPGU = parcelRequire("hAPGU");

var $ipbSm = parcelRequire("ipbSm");

var $jkRmr = parcelRequire("jkRmr");

var $eaNd3 = parcelRequire("eaNd3");

var $6pshK = parcelRequire("6pshK");

var $ghi1o = parcelRequire("ghi1o");

var $6DL3L = parcelRequire("6DL3L");

var $15mKo = parcelRequire("15mKo");

var $2oVqW = parcelRequire("2oVqW");

var $xWYaa = parcelRequire("xWYaa");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $dd1cc9168d3f0657$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $2oVqW(object, key), srcValue = $2oVqW(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $Yqw9r(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $ipbSm(srcValue), isBuff = !isArr && $eaNd3(srcValue), isTyped = !isArr && !isBuff && $15mKo(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($ipbSm(objValue)) newValue = objValue;
            else if ($jkRmr(objValue)) newValue = $3FhtJ(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $4j97H(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $cz8eW(srcValue, true);
            } else newValue = [];
        } else if ($6DL3L(srcValue) || $hAPGU(srcValue)) {
            newValue = objValue;
            if ($hAPGU(objValue)) newValue = $xWYaa(objValue);
            else if (!$ghi1o(objValue) || $6pshK(objValue)) newValue = $kbyCA(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    $Yqw9r(object, key, newValue);
}
module.exports = $dd1cc9168d3f0657$var$baseMergeDeep;

});
parcelRegister("4j97H", function(module, exports) {

var $fu3MD = parcelRequire("fu3MD");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $fu3MD.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("cz8eW", function(module, exports) {

var $26m0R = parcelRequire("26m0R");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $925f253b3f36cdaa$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $26m0R(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $925f253b3f36cdaa$var$cloneTypedArray;

});
parcelRegister("26m0R", function(module, exports) {

var $gCME2 = parcelRequire("gCME2");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $187d3799a97fbf44$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $gCME2(result).set(new $gCME2(arrayBuffer));
    return result;
}
module.exports = $187d3799a97fbf44$var$cloneArrayBuffer;

});
parcelRegister("gCME2", function(module, exports) {

var $fu3MD = parcelRequire("fu3MD");
/** Built-in value references. */ var $c1a5edcb86f09e60$var$Uint8Array = $fu3MD.Uint8Array;
module.exports = $c1a5edcb86f09e60$var$Uint8Array;

});



parcelRegister("3FhtJ", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $2ab2c24d34410d32$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $2ab2c24d34410d32$var$copyArray;

});

parcelRegister("kbyCA", function(module, exports) {

var $gvwkf = parcelRequire("gvwkf");

var $jLVmc = parcelRequire("jLVmc");

var $5xyJk = parcelRequire("5xyJk");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $eb1fb0d0870f87f4$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$5xyJk(object) ? $gvwkf($jLVmc(object)) : {};
}
module.exports = $eb1fb0d0870f87f4$var$initCloneObject;

});
parcelRegister("gvwkf", function(module, exports) {

var $ghi1o = parcelRequire("ghi1o");
/** Built-in value references. */ var $c0489dc77ad4c6f2$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $c0489dc77ad4c6f2$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$ghi1o(proto)) return {};
        if ($c0489dc77ad4c6f2$var$objectCreate) return $c0489dc77ad4c6f2$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $c0489dc77ad4c6f2$var$baseCreate;

});

parcelRegister("jLVmc", function(module, exports) {

var $jHoTX = parcelRequire("jHoTX");
/** Built-in value references. */ var $e64ee608e84a1c88$var$getPrototype = $jHoTX(Object.getPrototypeOf, Object);
module.exports = $e64ee608e84a1c88$var$getPrototype;

});
parcelRegister("jHoTX", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $e5755961d67b633d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $e5755961d67b633d$var$overArg;

});


parcelRegister("5xyJk", function(module, exports) {
/** Used for built-in method references. */ var $408af98141ddbc4d$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $408af98141ddbc4d$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $408af98141ddbc4d$var$objectProto;
    return value === proto;
}
module.exports = $408af98141ddbc4d$var$isPrototype;

});


parcelRegister("hAPGU", function(module, exports) {

var $4CEKV = parcelRequire("4CEKV");

var $jbhhu = parcelRequire("jbhhu");
/** Used for built-in method references. */ var $ccede53fa8105db8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ccede53fa8105db8$var$hasOwnProperty = $ccede53fa8105db8$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $ccede53fa8105db8$var$propertyIsEnumerable = $ccede53fa8105db8$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $ccede53fa8105db8$var$isArguments = $4CEKV(function() {
    return arguments;
}()) ? $4CEKV : function(value) {
    return $jbhhu(value) && $ccede53fa8105db8$var$hasOwnProperty.call(value, 'callee') && !$ccede53fa8105db8$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $ccede53fa8105db8$var$isArguments;

});
parcelRegister("4CEKV", function(module, exports) {

var $avvbo = parcelRequire("avvbo");

var $jbhhu = parcelRequire("jbhhu");
/** `Object#toString` result references. */ var $35da534759f3554f$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $35da534759f3554f$var$baseIsArguments(value) {
    return $jbhhu(value) && $avvbo(value) == $35da534759f3554f$var$argsTag;
}
module.exports = $35da534759f3554f$var$baseIsArguments;

});
parcelRegister("jbhhu", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $df6c731445d1c69b$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $df6c731445d1c69b$var$isObjectLike;

});



parcelRegister("ipbSm", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $d663c614f5215881$var$isArray = Array.isArray;
module.exports = $d663c614f5215881$var$isArray;

});

parcelRegister("jkRmr", function(module, exports) {

var $aNFH0 = parcelRequire("aNFH0");

var $jbhhu = parcelRequire("jbhhu");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $e13946f2a625118b$var$isArrayLikeObject(value) {
    return $jbhhu(value) && $aNFH0(value);
}
module.exports = $e13946f2a625118b$var$isArrayLikeObject;

});
parcelRegister("aNFH0", function(module, exports) {

var $6pshK = parcelRequire("6pshK");

var $73rbm = parcelRequire("73rbm");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $7dced249d10c6771$var$isArrayLike(value) {
    return value != null && $73rbm(value.length) && !$6pshK(value);
}
module.exports = $7dced249d10c6771$var$isArrayLike;

});
parcelRegister("73rbm", function(module, exports) {
/** Used as references for various `Number` constants. */ var $522de607951bb61b$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $522de607951bb61b$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $522de607951bb61b$var$MAX_SAFE_INTEGER;
}
module.exports = $522de607951bb61b$var$isLength;

});



parcelRegister("eaNd3", function(module, exports) {

var $fu3MD = parcelRequire("fu3MD");

var $3epQf = parcelRequire("3epQf");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $fu3MD.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $3epQf;
module.exports = isBuffer;

});
parcelRegister("3epQf", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $25a6b98c27d7bbc6$var$stubFalse() {
    return false;
}
module.exports = $25a6b98c27d7bbc6$var$stubFalse;

});


parcelRegister("6DL3L", function(module, exports) {

var $avvbo = parcelRequire("avvbo");

var $jLVmc = parcelRequire("jLVmc");

var $jbhhu = parcelRequire("jbhhu");
/** `Object#toString` result references. */ var $4d5ae3a919bc5161$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $4d5ae3a919bc5161$var$funcProto = Function.prototype, $4d5ae3a919bc5161$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $4d5ae3a919bc5161$var$funcToString = $4d5ae3a919bc5161$var$funcProto.toString;
/** Used to check objects for own properties. */ var $4d5ae3a919bc5161$var$hasOwnProperty = $4d5ae3a919bc5161$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $4d5ae3a919bc5161$var$objectCtorString = $4d5ae3a919bc5161$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $4d5ae3a919bc5161$var$isPlainObject(value) {
    if (!$jbhhu(value) || $avvbo(value) != $4d5ae3a919bc5161$var$objectTag) return false;
    var proto = $jLVmc(value);
    if (proto === null) return true;
    var Ctor = $4d5ae3a919bc5161$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $4d5ae3a919bc5161$var$funcToString.call(Ctor) == $4d5ae3a919bc5161$var$objectCtorString;
}
module.exports = $4d5ae3a919bc5161$var$isPlainObject;

});

parcelRegister("15mKo", function(module, exports) {

var $9cdxe = parcelRequire("9cdxe");

var $bQb4E = parcelRequire("bQb4E");

var $lRzrG = parcelRequire("lRzrG");
/* Node.js helper references. */ var $0ca7e73755c3b888$var$nodeIsTypedArray = $lRzrG && $lRzrG.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $0ca7e73755c3b888$var$isTypedArray = $0ca7e73755c3b888$var$nodeIsTypedArray ? $bQb4E($0ca7e73755c3b888$var$nodeIsTypedArray) : $9cdxe;
module.exports = $0ca7e73755c3b888$var$isTypedArray;

});
parcelRegister("9cdxe", function(module, exports) {

var $avvbo = parcelRequire("avvbo");

var $73rbm = parcelRequire("73rbm");

var $jbhhu = parcelRequire("jbhhu");
/** `Object#toString` result references. */ var $6b1fbbcf9f080cff$var$argsTag = '[object Arguments]', $6b1fbbcf9f080cff$var$arrayTag = '[object Array]', $6b1fbbcf9f080cff$var$boolTag = '[object Boolean]', $6b1fbbcf9f080cff$var$dateTag = '[object Date]', $6b1fbbcf9f080cff$var$errorTag = '[object Error]', $6b1fbbcf9f080cff$var$funcTag = '[object Function]', $6b1fbbcf9f080cff$var$mapTag = '[object Map]', $6b1fbbcf9f080cff$var$numberTag = '[object Number]', $6b1fbbcf9f080cff$var$objectTag = '[object Object]', $6b1fbbcf9f080cff$var$regexpTag = '[object RegExp]', $6b1fbbcf9f080cff$var$setTag = '[object Set]', $6b1fbbcf9f080cff$var$stringTag = '[object String]', $6b1fbbcf9f080cff$var$weakMapTag = '[object WeakMap]';
var $6b1fbbcf9f080cff$var$arrayBufferTag = '[object ArrayBuffer]', $6b1fbbcf9f080cff$var$dataViewTag = '[object DataView]', $6b1fbbcf9f080cff$var$float32Tag = '[object Float32Array]', $6b1fbbcf9f080cff$var$float64Tag = '[object Float64Array]', $6b1fbbcf9f080cff$var$int8Tag = '[object Int8Array]', $6b1fbbcf9f080cff$var$int16Tag = '[object Int16Array]', $6b1fbbcf9f080cff$var$int32Tag = '[object Int32Array]', $6b1fbbcf9f080cff$var$uint8Tag = '[object Uint8Array]', $6b1fbbcf9f080cff$var$uint8ClampedTag = '[object Uint8ClampedArray]', $6b1fbbcf9f080cff$var$uint16Tag = '[object Uint16Array]', $6b1fbbcf9f080cff$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $6b1fbbcf9f080cff$var$typedArrayTags = {};
$6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$float32Tag] = $6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$float64Tag] = $6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$int8Tag] = $6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$int16Tag] = $6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$int32Tag] = $6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$uint8Tag] = $6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$uint8ClampedTag] = $6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$uint16Tag] = $6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$uint32Tag] = true;
$6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$argsTag] = $6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$arrayTag] = $6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$arrayBufferTag] = $6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$boolTag] = $6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$dataViewTag] = $6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$dateTag] = $6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$errorTag] = $6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$funcTag] = $6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$mapTag] = $6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$numberTag] = $6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$objectTag] = $6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$regexpTag] = $6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$setTag] = $6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$stringTag] = $6b1fbbcf9f080cff$var$typedArrayTags[$6b1fbbcf9f080cff$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $6b1fbbcf9f080cff$var$baseIsTypedArray(value) {
    return $jbhhu(value) && $73rbm(value.length) && !!$6b1fbbcf9f080cff$var$typedArrayTags[$avvbo(value)];
}
module.exports = $6b1fbbcf9f080cff$var$baseIsTypedArray;

});

parcelRegister("bQb4E", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $89ed24150244178b$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $89ed24150244178b$var$baseUnary;

});

parcelRegister("lRzrG", function(module, exports) {

var $1TD6g = parcelRequire("1TD6g");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $1TD6g.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});


parcelRegister("2oVqW", function(module, exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $1bfa5fc889ef75b6$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
module.exports = $1bfa5fc889ef75b6$var$safeGet;

});

parcelRegister("xWYaa", function(module, exports) {

var $jvBFq = parcelRequire("jvBFq");

var $ddNxe = parcelRequire("ddNxe");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $0660d34548b1a877$var$toPlainObject(value) {
    return $jvBFq(value, $ddNxe(value));
}
module.exports = $0660d34548b1a877$var$toPlainObject;

});
parcelRegister("jvBFq", function(module, exports) {

var $1GvDV = parcelRequire("1GvDV");

var $1VaWt = parcelRequire("1VaWt");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $e33e218218cd159e$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $1VaWt(object, key, newValue);
        else $1GvDV(object, key, newValue);
    }
    return object;
}
module.exports = $e33e218218cd159e$var$copyObject;

});
parcelRegister("1GvDV", function(module, exports) {

var $1VaWt = parcelRequire("1VaWt");

var $dIKIh = parcelRequire("dIKIh");
/** Used for built-in method references. */ var $13a242587f9f07a3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $13a242587f9f07a3$var$hasOwnProperty = $13a242587f9f07a3$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $13a242587f9f07a3$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($13a242587f9f07a3$var$hasOwnProperty.call(object, key) && $dIKIh(objValue, value)) || value === undefined && !(key in object)) $1VaWt(object, key, value);
}
module.exports = $13a242587f9f07a3$var$assignValue;

});


parcelRegister("ddNxe", function(module, exports) {

var $g9sqv = parcelRequire("g9sqv");

var $6PMLs = parcelRequire("6PMLs");

var $aNFH0 = parcelRequire("aNFH0");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $9a02e9e70ea7cc50$var$keysIn(object) {
    return $aNFH0(object) ? $g9sqv(object, true) : $6PMLs(object);
}
module.exports = $9a02e9e70ea7cc50$var$keysIn;

});
parcelRegister("g9sqv", function(module, exports) {

var $1pRT2 = parcelRequire("1pRT2");

var $hAPGU = parcelRequire("hAPGU");

var $ipbSm = parcelRequire("ipbSm");

var $eaNd3 = parcelRequire("eaNd3");

var $gCPVC = parcelRequire("gCPVC");

var $15mKo = parcelRequire("15mKo");
/** Used for built-in method references. */ var $bc238988e6232764$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bc238988e6232764$var$hasOwnProperty = $bc238988e6232764$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $bc238988e6232764$var$arrayLikeKeys(value, inherited) {
    var isArr = $ipbSm(value), isArg = !isArr && $hAPGU(value), isBuff = !isArr && !isArg && $eaNd3(value), isType = !isArr && !isArg && !isBuff && $15mKo(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $1pRT2(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $bc238988e6232764$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $gCPVC(key, length)))) result.push(key);
    return result;
}
module.exports = $bc238988e6232764$var$arrayLikeKeys;

});
parcelRegister("1pRT2", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $1081ed049a4253c2$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $1081ed049a4253c2$var$baseTimes;

});

parcelRegister("gCPVC", function(module, exports) {
/** Used as references for various `Number` constants. */ var $c1a879d795ff798d$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $c1a879d795ff798d$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $c1a879d795ff798d$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $c1a879d795ff798d$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $c1a879d795ff798d$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $c1a879d795ff798d$var$isIndex;

});


parcelRegister("6PMLs", function(module, exports) {

var $ghi1o = parcelRequire("ghi1o");

var $5xyJk = parcelRequire("5xyJk");

var $29god = parcelRequire("29god");
/** Used for built-in method references. */ var $4f9d551337d1dd5d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4f9d551337d1dd5d$var$hasOwnProperty = $4f9d551337d1dd5d$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $4f9d551337d1dd5d$var$baseKeysIn(object) {
    if (!$ghi1o(object)) return $29god(object);
    var isProto = $5xyJk(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$4f9d551337d1dd5d$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $4f9d551337d1dd5d$var$baseKeysIn;

});
parcelRegister("29god", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $190922a7facb6606$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $190922a7facb6606$var$nativeKeysIn;

});






parcelRegister("dFAQ6", function(module, exports) {

var $1atzS = parcelRequire("1atzS");

var $f3ehP = parcelRequire("f3ehP");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $9f3bae38e1954b56$var$createAssigner(assigner) {
    return $1atzS(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && $f3ehP(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $9f3bae38e1954b56$var$createAssigner;

});
parcelRegister("1atzS", function(module, exports) {

var $64Pzr = parcelRequire("64Pzr");

var $j2Pp1 = parcelRequire("j2Pp1");

var $asePb = parcelRequire("asePb");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $0d9dab21d04b9473$var$baseRest(func, start) {
    return $asePb($j2Pp1(func, start, $64Pzr), func + '');
}
module.exports = $0d9dab21d04b9473$var$baseRest;

});
parcelRegister("64Pzr", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $46cb1ea61104a825$var$identity(value) {
    return value;
}
module.exports = $46cb1ea61104a825$var$identity;

});

parcelRegister("j2Pp1", function(module, exports) {

var $4Zlhj = parcelRequire("4Zlhj");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ddd613b1a43a673d$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $ddd613b1a43a673d$var$overRest(func, start, transform) {
    start = $ddd613b1a43a673d$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $ddd613b1a43a673d$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $4Zlhj(func, this, otherArgs);
    };
}
module.exports = $ddd613b1a43a673d$var$overRest;

});
parcelRegister("4Zlhj", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $3a1d5d562b4d429e$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $3a1d5d562b4d429e$var$apply;

});


parcelRegister("asePb", function(module, exports) {

var $9iGC9 = parcelRequire("9iGC9");

var $2G9I5 = parcelRequire("2G9I5");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $79c804ba939a5732$var$setToString = $2G9I5($9iGC9);
module.exports = $79c804ba939a5732$var$setToString;

});
parcelRegister("9iGC9", function(module, exports) {

var $9wmu5 = parcelRequire("9wmu5");

var $2yWCC = parcelRequire("2yWCC");

var $64Pzr = parcelRequire("64Pzr");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $6c56d9d53da9051b$var$baseSetToString = !$2yWCC ? $64Pzr : function(func, string) {
    return $2yWCC(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $9wmu5(string),
        'writable': true
    });
};
module.exports = $6c56d9d53da9051b$var$baseSetToString;

});
parcelRegister("9wmu5", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $6ee88b190425adc1$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $6ee88b190425adc1$var$constant;

});


parcelRegister("2G9I5", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $1f37093713c2cc4f$var$HOT_COUNT = 800, $1f37093713c2cc4f$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1f37093713c2cc4f$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $1f37093713c2cc4f$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $1f37093713c2cc4f$var$nativeNow(), remaining = $1f37093713c2cc4f$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $1f37093713c2cc4f$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $1f37093713c2cc4f$var$shortOut;

});



parcelRegister("f3ehP", function(module, exports) {

var $dIKIh = parcelRequire("dIKIh");

var $aNFH0 = parcelRequire("aNFH0");

var $gCPVC = parcelRequire("gCPVC");

var $ghi1o = parcelRequire("ghi1o");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $af5237d75d10a7db$var$isIterateeCall(value, index, object) {
    if (!$ghi1o(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $aNFH0(object) && $gCPVC(index, object.length) : type == 'string' && index in object) return $dIKIh(object[index], value);
    return false;
}
module.exports = $af5237d75d10a7db$var$isIterateeCall;

});



parcelRegister("lilfh", function(module, exports) {
$parcel$export(module.exports, "buildGetUrl", () => $b4d9033a58ef00ff$export$28ae0033b80c6303);
function $b4d9033a58ef00ff$export$28ae0033b80c6303(baseUrl, variables) {
    const params = new URLSearchParams();
    params.append('variables', JSON.stringify(variables));
    return baseUrl + `${baseUrl.includes('?') ? '&' : '?'}${params.toString()}`;
}

});

parcelRegister("cnaFf", function(module, exports) {
$parcel$export(module.exports, "shouldUseGetMethod", () => $778ed33914e47ef4$export$5ad31d96a9271d42);

var $eEebl = parcelRequire("eEebl");

var $lilfh = parcelRequire("lilfh");

var $i4R6Z = parcelRequire("i4R6Z");
const $778ed33914e47ef4$var$MAX_QUERY_LENGTH = 2000; // Maximum allowed query length
const $778ed33914e47ef4$var$MAX_HEADERS_SIZE = 20480; // Maximum header size in bytes (20 KB)
function $778ed33914e47ef4$export$5ad31d96a9271d42({ url: baseUrl, variables: variables, request: request, headers: headers, isServer: isServer }) {
    if (isServer) return {
        isGetRequest: false,
        reason: 'SSR'
    };
    if ((0, $eEebl.killswitch)('relay-get-queries')) return {
        isGetRequest: false,
        reason: 'Killswitch is on'
    };
    if (request.operationKind !== 'query') return {
        isGetRequest: false,
        reason: request.operationKind
    };
    const queryLength = (0, $lilfh.buildGetUrl)(baseUrl, variables).length;
    const headersSize = (0, $i4R6Z.calculateHeadersSize)(headers || {});
    return queryLength <= $778ed33914e47ef4$var$MAX_QUERY_LENGTH && headersSize <= $778ed33914e47ef4$var$MAX_HEADERS_SIZE ? {
        isGetRequest: true
    } : {
        isGetRequest: false,
        reason: 'URL length or headers size too large'
    };
}

});
parcelRegister("eEebl", function(module, exports) {
$parcel$export(module.exports, "killswitch", () => $26f52dda3236af22$export$fcfcaa5d2f57d3a7);

var $4d1Vr = parcelRequire("4d1Vr");
let $26f52dda3236af22$var$cachedNames;
const $26f52dda3236af22$var$isStringArray = (value)=>Array.isArray(value) && value.every((name)=>typeof name === 'string');
function $26f52dda3236af22$export$fcfcaa5d2f57d3a7(name) {
    if (!$26f52dda3236af22$var$cachedNames) {
        // Do not permanently cache the default before the host initializes the SDK.
        if (!(0, $4d1Vr.default).initializeCompleted()) return false;
        // Killswitches are operational controls and must not fire experiment exposures.
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- shared dynamic config killswitch helper
        const config = (0, $4d1Vr.default).getExperimentValue('killswitch', 'value', [], {
            fireExperimentExposure: false,
            typeGuard: $26f52dda3236af22$var$isStringArray
        });
        // SDK mocks and config overrides can bypass the SDK's type guard.
        $26f52dda3236af22$var$cachedNames = new Set($26f52dda3236af22$var$isStringArray(config) ? config.map((entry)=>entry.toLowerCase()) : []);
    }
    return $26f52dda3236af22$var$cachedNames.has(name.toLowerCase());
}

});

parcelRegister("i4R6Z", function(module, exports) {
$parcel$export(module.exports, "calculateHeadersSize", () => $f486e3e68a07f022$export$dd754c3ef60c6999);
// Calculate the size of the headers
function $f486e3e68a07f022$export$dd754c3ef60c6999(headers) {
    let totalBytes = 0;
    const textEncoder = new TextEncoder();
    // Iterate over each header entry (name and value)
    for (const [name, value] of Object.entries(headers)){
        const headerSize = textEncoder.encode(`${name}: ${value}\r\n`).length; // Include CRLF
        totalBytes += headerSize;
    }
    return totalBytes;
}

});



parcelRegister("ahkVX", function(module, exports) {
$parcel$export(module.exports, "processMultipartPromise", () => $ab138f7c833af908$export$f76505a7f2969e4e);

var $ArurZ = parcelRequire("ArurZ");

var $2aEiL = parcelRequire("2aEiL");

var $7OMPl = parcelRequire("7OMPl");
const $ab138f7c833af908$var$NO_CONTENT = 204;
function $ab138f7c833af908$var$getBoundary(contentType) {
    const parts = contentType.split('boundary=');
    if (parts.length < 2) return null;
    return parts[1].trim();
}
/**
 * Forward `error` to `observer.error`, giving the product-provided
 * `onFetchError` (if any) a chance to transform it first.
 */ function $ab138f7c833af908$var$emitError(observer, error, response, onFetchError) {
    const transformed = onFetchError ? onFetchError(error, response) : error;
    // `Sink.error` accepts `Error` per its type, but in practice relay
    // forwards whatever it receives to consumers. Cast to keep the existing
    // signature while allowing products to return any error-like value.
    observer.error(transformed);
}
function $ab138f7c833af908$var$handleMultipartResponse(response, observer, onFetchError) {
    const contentType = response.headers.get('content-type');
    const boundary = $ab138f7c833af908$var$getBoundary(contentType || '');
    if (!boundary) {
        $ab138f7c833af908$var$emitError(observer, new Error('Invalid multipart boundary'), response, onFetchError);
        return;
    }
    const decoder = new TextDecoder('utf-8');
    async function* streamReader() {
        // @ts-expect-error a Response object in Node is streamable
        for await (const chunk of response.body){
            const newText = decoder.decode(chunk, {
                stream: true
            });
            yield newText;
        }
    }
    try {
        // Depending on the version of Node we're running in, the Response object may not implement ReadableStream.
        // Here, we treat the response as an async iterator, since both node-fetch and browser implement the response body as a stream.
        // We wrap that iteration in an async generator, which lets us
        (0, $7OMPl.processStream)(streamReader(), boundary, observer).catch((error)=>$ab138f7c833af908$var$emitError(observer, error, response, onFetchError));
    } catch (e) {
        const error = new Error('Failed to read from response body');
        // @ts-ignore: cause property may not be available in all environments
        error.cause = e;
        $ab138f7c833af908$var$emitError(observer, error, response, onFetchError);
    }
}
function $ab138f7c833af908$var$handleJsonResponse(response, observer, onFetchError) {
    response.json().then((data)=>{
        return observer.next(data);
    }).catch((error)=>$ab138f7c833af908$var$emitError(observer, error, response, onFetchError)).finally(()=>observer.complete());
}
function $ab138f7c833af908$var$handleTextResponse(response, observer, onFetchError) {
    response.text().then((data)=>{
        const maybeJson = data ? JSON.parse(data) : null;
        observer.next(maybeJson);
        observer.complete();
    }).catch((responseError)=>{
        let traceId = '';
        if ((0, $2aEiL.fg)('platform_relay_use_shared_relay_env_help_center')) traceId = `(trace-id: ${response.headers.get('atl-traceid')}) `;
        const error = new Error(`Error while parsing text response ${traceId}(Content-Type: ${response?.headers?.get('content-type')}): ${responseError instanceof Error ? responseError.message : String(responseError)}`);
        $ab138f7c833af908$var$emitError(observer, error, response, onFetchError);
    });
}
function $ab138f7c833af908$export$f76505a7f2969e4e(source, onFetchError, onResponseHeaders) {
    // Cache the result of the source promise to avoid calling it multiple times.
    const result = source();
    // Wrap an observer around the result to handle the response.
    return (0, $ArurZ.Observable).create((observer)=>{
        result.then((response)=>{
            // Expose the response headers via a side-channel so the consumer can
            // read values such as `atl-traceid` without changing the payload emission shape.
            onResponseHeaders?.(response.headers);
            if (response.status === $ab138f7c833af908$var$NO_CONTENT) {
                observer.complete();
                return;
            }
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json') || contentType.includes('application/graphql-response+json')) $ab138f7c833af908$var$handleJsonResponse(response, observer, onFetchError);
            else if (contentType.includes('text/plain')) $ab138f7c833af908$var$handleTextResponse(response, observer, onFetchError);
            else if (contentType.includes('multipart/mixed')) $ab138f7c833af908$var$handleMultipartResponse(response, observer, onFetchError);
            else $ab138f7c833af908$var$handleTextResponse(response, observer, onFetchError);
        })// Pre-response failure (network error, AbortController, etc.) — no
        // Response object is in scope, so pass `undefined`.
        .catch((error)=>$ab138f7c833af908$var$emitError(observer, error, undefined, onFetchError));
    });
}

});
parcelRegister("7OMPl", function(module, exports) {
$parcel$export(module.exports, "processStream", () => $91cfec68be5fa385$export$efb69f1fe7577739);

var $fCZWA = parcelRequire("fCZWA");
async function $91cfec68be5fa385$export$efb69f1fe7577739(reader, boundary, observer) {
    const boundaryString = `--${boundary}`;
    let incompleteChunk = '';
    // Process chunks until the stream is done
    for await (const newText of reader){
        const combinedChunk = incompleteChunk + newText;
        // Process the combined chunk and get any incomplete part
        incompleteChunk = (0, $fCZWA.processChunk)(combinedChunk, boundaryString, observer);
    }
    // Process any remaining data
    if (incompleteChunk.length > 0) (0, $fCZWA.processChunk)(incompleteChunk, boundaryString, observer);
    observer.complete();
}

});
parcelRegister("fCZWA", function(module, exports) {
$parcel$export(module.exports, "processChunk", () => $e890463b22718cba$export$701544522b0c6c99);

var $2aEiL = parcelRequire("2aEiL");
function $e890463b22718cba$var$escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
// The boundary is fixed for the lifetime of a response while processChunk runs once per network chunk,
// so the compiled delimiter pattern is kept for the last boundary seen instead of rebuilt per chunk.
let $e890463b22718cba$var$cachedDelimiter;
function $e890463b22718cba$var$getDelimiterPattern(boundaryString) {
    if ($e890463b22718cba$var$cachedDelimiter?.boundaryString !== boundaryString) $e890463b22718cba$var$cachedDelimiter = {
        boundaryString: boundaryString,
        pattern: new RegExp(`(?:^|\\r\\n)${$e890463b22718cba$var$escapeRegExp(boundaryString)}`)
    };
    return $e890463b22718cba$var$cachedDelimiter.pattern;
}
function $e890463b22718cba$var$getBody(part) {
    // A part with a header block is "headers\r\n\r\nbody", so the split yields [headers, body] and the
    // payload is part2. A part without a header block yields a single element, part2 is undefined and
    // the whole part (part1) is the payload.
    const [part1, part2] = part.split(/\r?\n\r?\n/);
    return part2 ?? part1;
}
function $e890463b22718cba$var$processChunkCrlfAnchored(chunk, boundaryString, observer) {
    // RFC 2046 5.1.1: a delimiter is CRLF followed by "--" and the boundary (the CRLF is optional only
    // for the first delimiter, at the very start of the body). Matching the bare "--boundary" would
    // also match the same characters inside a JSON payload (e.g. "---" in a document body), which
    // splits and corrupts the payload. JSON strings carry escaped newlines, so a CRLF-anchored
    // delimiter does not occur inside a payload.
    const parts = chunk.split($e890463b22718cba$var$getDelimiterPattern(boundaryString));
    let incompleteChunk = '';
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            const body = $e890463b22718cba$var$getBody(part);
            if (body) try {
                const jsonData = JSON.parse(incompleteChunk + body);
                observer.next(jsonData);
                incompleteChunk = '';
            } catch  {
                // add boundary string back to response for cases when response content has boundary string
                // no error is thrown because next part might be a valid JSON object
                incompleteChunk += body + boundaryString;
            }
        }
    }
    const lastPart = parts[parts.length - 1];
    // The trailing segment is only known to be complete once the next delimiter arrives, but a part
    // whose body already parses as JSON is complete: emit it now instead of holding it back until the
    // next part (or the end of the stream). Keep the trailing CRLF so the delimiter that follows is
    // still recognised.
    const trailingPart = lastPart.trim();
    if (trailingPart && !trailingPart.startsWith('--')) {
        const body = $e890463b22718cba$var$getBody(trailingPart);
        if (body) try {
            observer.next(JSON.parse(incompleteChunk + body));
            return lastPart.match(/\s*$/)?.[0] ?? '';
        } catch  {
        // Body is still incomplete; keep it until more data arrives.
        }
    }
    // Return the last part which might be incomplete
    return incompleteChunk + lastPart;
}
/**
 * The previous implementation, used while `ai_3p_defer_multipart_response_fix` is off.
 *
 * It splits on the bare boundary string, so a payload containing it is cut apart, and a part is only
 * emitted once the next delimiter has arrived.
 */ function $e890463b22718cba$var$processChunkLegacy(chunk, boundaryString, observer) {
    const parts = chunk.split(boundaryString);
    let incompleteChunk = '';
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            // Split content-type header and body
            const [part1, part2] = part.split(/\r?\n\r?\n/);
            // when response content has boundary string, part1 is the actual response
            // when response content does not have boundary string, part2 is the actual response
            const body = part2 ?? part1;
            if (body) try {
                const jsonData = JSON.parse(incompleteChunk + body);
                observer.next(jsonData);
                incompleteChunk = '';
            } catch  {
                // add boundary string back to response for cases when response content has boundary string
                // no error is thrown because next part might be a valid JSON object
                incompleteChunk += body + boundaryString;
            }
        }
    }
    // Return the last part which might be incomplete
    return incompleteChunk + parts[parts.length - 1];
}
function $e890463b22718cba$export$701544522b0c6c99(chunk, boundaryString, observer) {
    if ((0, $2aEiL.fg)('ai_3p_defer_multipart_response_fix')) return $e890463b22718cba$var$processChunkCrlfAnchored(chunk, boundaryString, observer);
    return $e890463b22718cba$var$processChunkLegacy(chunk, boundaryString, observer);
}

});



parcelRegister("3IJl1", function(module, exports) {
$parcel$export(module.exports, "getRetryAttemptsForQuery", () => $01b08518f0fe1a7f$export$9dec0f42cc67f6ab);

var $nZKHZ = parcelRequire("nZKHZ");
const $01b08518f0fe1a7f$export$9dec0f42cc67f6ab = (request)=>{
    if (request.operationKind === 'query') return 0, $nZKHZ.RETRY_ATTEMPTS_LIMIT;
    return 0;
};

});
parcelRegister("nZKHZ", function(module, exports) {
$parcel$export(module.exports, "RETRY_ATTEMPTS_LIMIT", () => $a08267acf44b6d73$export$81189edc9b923717);
const $a08267acf44b6d73$export$81189edc9b923717 = 1;

});


parcelRegister("kQanL", function(module, exports) {
$parcel$export(module.exports, "retryOnError", () => $96bd31ea7e787d37$export$f859c88bfac2cf2c);

var $nZKHZ = parcelRequire("nZKHZ");
const $96bd31ea7e787d37$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = (0, $nZKHZ.RETRY_ATTEMPTS_LIMIT), onRetry: onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > (0, $nZKHZ.RETRY_ATTEMPTS_LIMIT) ? (0, $nZKHZ.RETRY_ATTEMPTS_LIMIT) : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};

});

parcelRegister("ekPd4", function(module, exports) {
$parcel$export(module.exports, "shouldRetry", () => $00b1c34fa56ad135$export$7bfea3c3d460ecd8);

var $2aEiL = parcelRequire("2aEiL");
const $00b1c34fa56ad135$export$7bfea3c3d460ecd8 = (error)=>{
    if ((0, $2aEiL.fg)('platform_relay_fetch_guard_non_object_retry_errors')) {
        if (typeof error !== 'object' || error === null) return false;
    }
    const fetchError = error;
    if ('statusCode' in fetchError && typeof fetchError.statusCode === 'number') return [
        502,
        503,
        504
    ].includes(fetchError.statusCode);
    return false;
};

});

parcelRegister("kfWNj", function(module, exports) {
$parcel$export(module.exports, "getTraceIdFromExtensions", () => $7d62cdff608674a5$export$eefb7f54c3b07211);

var $2aEiL = parcelRequire("2aEiL");
const $7d62cdff608674a5$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    if (extensions == null || extensions.gateway == null) return undefined;
    if ((0, $2aEiL.fg)('platform_relay_fetch_use_tid_property')) {
        if (typeof extensions.gateway.tId === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return extensions.gateway.tId;
    } else {
        if (typeof extensions.gateway.trace_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return extensions.gateway.trace_id;
    }
    return undefined;
};

});


parcelRegister("01WOC", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c5ad47a060aa2b2$export$2e2bcd8739ae039);

var $2aEiL = parcelRequire("2aEiL");

var $6ct60 = parcelRequire("6ct60");

var $39L99 = parcelRequire("39L99");

var $hxjq4 = parcelRequire("hxjq4");
const $7c5ad47a060aa2b2$var$isCustomFilter = (filterId)=>/^\d+$/.test(filterId);
const $7c5ad47a060aa2b2$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $7c5ad47a060aa2b2$export$77232ec02db7a24a = {
    handle: (field, record, argValues)=>{
        // https://relay.dev/docs/guided-tour/reusing-cached-data/filling-in-missing-data/
        // This lets relay know that a query of
        // JiraQuery.filter(id: ID!)
        // can return:
        //   - a JiraCustomFilter object
        //   - a JiraSystemFilter object
        // determined by the type encoded within the id field (which is an ARI type).
        // By providing the id that relay would refer to those objects by, it is able to check it's
        // store to see if they are already fetched, and avoid refetching them if it is unnecessary
        if (record != null && record.getType() === 'JiraQuery' && field.name === 'filter' && argValues.id != null) {
            const { id: id } = argValues;
            const filterId = (0, $6ct60.JiraFilterAri).parse(id).filterId;
            if ($7c5ad47a060aa2b2$var$isCustomFilter(filterId)) return (0, $hxjq4.default)({
                id: id
            }, 'JiraCustomFilter');
            if ($7c5ad47a060aa2b2$var$isSystemFilter(filterId)) return (0, $hxjq4.default)({
                id: id
            }, 'JiraSystemFilter');
            return undefined;
        }
        return undefined;
    },
    kind: 'linked'
};
const $7c5ad47a060aa2b2$var$JiraQueryIssueByIdMissingFieldHandler = {
    handle: (field, record, argValues)=>{
        if ((0, $2aEiL.fg)('platform_relay_issue_by_id_cache')) {
            if (record?.getType() === 'JiraQuery' && field.name === 'issueById' && argValues.id != null) return (0, $hxjq4.default)({
                id: argValues.id
            }, 'JiraIssue');
        }
        return undefined;
    },
    kind: 'linked'
};
const $7c5ad47a060aa2b2$var$JiraIssueNodeMissingFieldHandler = {
    handle: (field, record, argValues, store)=>{
        if ((0, $2aEiL.fg)('platform_relay_issue_by_id_cache')) {
            if (record?.getDataID() !== store.getRoot().getDataID() || field.name !== 'node' || typeof argValues.id !== 'string') return undefined;
            try {
                (0, $39L99.JiraIssueAri).parse(argValues.id);
            } catch  {
                return undefined;
            }
            const dataId = (0, $hxjq4.default)({
                id: argValues.id
            }, 'JiraIssue');
            if (dataId !== undefined && store.get(dataId)?.getType() === 'JiraIssue') return dataId;
        }
        return undefined;
    },
    kind: 'linked'
};
const $7c5ad47a060aa2b2$var$MissingFieldHandlers = [
    $7c5ad47a060aa2b2$export$77232ec02db7a24a,
    $7c5ad47a060aa2b2$var$JiraQueryIssueByIdMissingFieldHandler,
    $7c5ad47a060aa2b2$var$JiraIssueNodeMissingFieldHandler
];
var $7c5ad47a060aa2b2$export$2e2bcd8739ae039 = $7c5ad47a060aa2b2$var$MissingFieldHandlers;

});
parcelRegister("6ct60", function(module, exports) {
$parcel$export(module.exports, "JiraFilterAri", () => $483a6eea7b23ab8a$export$3cfb6cc809e835bd);

var $3QSzX = parcelRequire("3QSzX");

var $7USzn = parcelRequire("7USzn");

var $gjVjm = parcelRequire("gjVjm");
// src/jira/filter/manifest.ts
var $483a6eea7b23ab8a$var$jiraFilterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $3QSzX.JiraFilterAriResourceOwner),
    resourceType: (0, $3QSzX.JiraFilterAriResourceType),
    resourceIdSlug: "activation/{activationId}/{filterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        filterId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/filter/index.ts
var $483a6eea7b23ab8a$export$3cfb6cc809e835bd = class _JiraFilterAri extends (0, $7USzn.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._filterId = opts.resourceIdSegmentValues.filterId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get filterId() {
        return this._filterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $483a6eea7b23ab8a$var$jiraFilterAriStaticOpts.qualifier,
            platformQualifier: $483a6eea7b23ab8a$var$jiraFilterAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $483a6eea7b23ab8a$var$jiraFilterAriStaticOpts.resourceOwner,
            resourceType: $483a6eea7b23ab8a$var$jiraFilterAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.filterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                filterId: opts.filterId
            }
        }, ariOpts = (0, $gjVjm.AriParser).fromOpts(derivedOpts, $483a6eea7b23ab8a$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gjVjm.AriParser).fromString(maybeAri, $483a6eea7b23ab8a$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            filterId: this.filterId
        };
    }
};

});
parcelRegister("3QSzX", function(module, exports) {
$parcel$export(module.exports, "JiraFilterAriResourceOwner", () => $2ce090a5b1b0894d$export$e6199848f52f1119);
$parcel$export(module.exports, "JiraFilterAriResourceType", () => $2ce090a5b1b0894d$export$3c64de4ae038e3ae);
// src/jira/filter/types.ts
var $2ce090a5b1b0894d$export$e6199848f52f1119 = "jira", $2ce090a5b1b0894d$export$3c64de4ae038e3ae = "filter";

});

parcelRegister("7USzn", function(module, exports) {
$parcel$export(module.exports, "RegisteredAri", () => $5c3817bc65d28670$export$579ee78b1dcf0a11);

var $hrJ3Q = parcelRequire("hrJ3Q");
// src/core/registered-ari.ts
var $5c3817bc65d28670$export$579ee78b1dcf0a11 = class extends (0, $hrJ3Q.Ari) {
    static check(maybeAri) {
        try {
            return this.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return (0, $hrJ3Q.AnyAri).parse(this.toString());
    }
};

});
parcelRegister("hrJ3Q", function(module, exports) {
$parcel$export(module.exports, "Ari", () => $cb37e9766e2a48e8$export$3a4885701291260b);
$parcel$export(module.exports, "AnyAri", () => $cb37e9766e2a48e8$export$44a7af7122933d6b);

var $gjVjm = parcelRequire("gjVjm");
// src/core/ari.ts
var $cb37e9766e2a48e8$export$3a4885701291260b = class {
    constructor(opts){
        this._ati = (0, $gjVjm.Ati).create({
            platformQualifier: opts.platformQualifier || "cloud",
            resourceOwner: opts.resourceOwner,
            resourceType: opts.resourceType
        }), this._cloudId = opts.cloudId !== "" ? opts.cloudId : void 0, this._resourceId = opts.resourceId;
    }
    get platformQualifier() {
        return this._ati.platformQualifier;
    }
    get cloudId() {
        return this._cloudId;
    }
    get resourceOwner() {
        return this._ati.resourceOwner;
    }
    get resourceType() {
        return this._ati.resourceType;
    }
    get resourceId() {
        return this._resourceId;
    }
    get ati() {
        return this._ati;
    }
    equals(other) {
        return this.toString() === other.toString();
    }
    toString() {
        return `ari:${this.platformQualifier}:${this.resourceOwner}:${this.cloudId || ""}:${this.resourceType}/${this.resourceId}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this.platformQualifier,
            resourceOwner: this.resourceOwner,
            cloudId: this.cloudId,
            resourceType: this.resourceType,
            resourceId: this.resourceId
        };
    }
};
// src/any-ari.ts
var $cb37e9766e2a48e8$export$44a7af7122933d6b = class _AnyAri extends $cb37e9766e2a48e8$export$3a4885701291260b {
    constructor(opts){
        super(opts);
    }
    static create(ariOpts, ariStaticOpts) {
        let ariOptsWithDefaults = {
            ...ariOpts,
            resourceIdSegmentValues: {}
        }, validatedOpts = (0, $gjVjm.AriParser).fromOpts(ariOptsWithDefaults, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static parse(maybeAri, ariStaticOpts) {
        let validatedOpts = (0, $gjVjm.AriParser).fromString(maybeAri, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static check(maybeAri) {
        try {
            return _AnyAri.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return this;
    }
};

});
parcelRegister("gjVjm", function(module, exports) {
$parcel$export(module.exports, "AriParser", () => $be1ae0883aa48876$export$4c3a8cde7a55740b);
$parcel$export(module.exports, "Ati", () => $be1ae0883aa48876$export$ab4b293d0121b8ee);

var $gsBjl = parcelRequire("gsBjl");

var $laNVt = parcelRequire("laNVt");
// src/core/rules/cloud-id.ts
function $be1ae0883aa48876$var$validateCloudId(cloudId, format = new RegExp("^[a-zA-Z0-9_\\-.]{0,255}$")) {
    if (!cloudId.match(format)) throw new (0, $laNVt.ValidationError)(`Invalid cloud ID, expected ID of format ${format}.`);
}
// src/core/rules/resource-id.ts
function $be1ae0883aa48876$var$validateResourceId(id, format = new RegExp("[!a-zA-Z0-9\\-_.~@:;{}=]+(/[!a-zA-Z0-9\\-_.~@:;{}=]+)*" /* ANY_RESOURCE_ID */ ), key = "resourceId") {
    let formatWithCarets = new RegExp(`^${format.source}$`);
    if (!id.match(formatWithCarets)) throw new (0, $laNVt.ValidationError)(`Invalid ${key} - ${id}, expected ID of format ${formatWithCarets}.`);
}
// src/core/rules/resource-id-segments.ts
function $be1ae0883aa48876$var$validateResourceIdSegments(resourceIdSegmentValues, resourceIdSegmentFormats) {
    Object.entries(resourceIdSegmentValues).forEach(([resourceIdKey, resourceIdValue])=>{
        $be1ae0883aa48876$var$validateResourceId(resourceIdValue, resourceIdSegmentFormats == null ? void 0 : resourceIdSegmentFormats[resourceIdKey], resourceIdKey);
    });
}
// src/core/rules/resource-owner.ts
function $be1ae0883aa48876$var$validateResourceOwner(owner, expectedResourceOwner) {
    if (expectedResourceOwner && owner !== expectedResourceOwner) throw new (0, $laNVt.ValidationError)(`Invalid resource owner - ${owner}, expected ${expectedResourceOwner}.`);
}
// src/core/rules/resource-type.ts
function $be1ae0883aa48876$var$validateResourceType(type, expectedResourceType) {
    if (expectedResourceType && type !== expectedResourceType) throw new (0, $laNVt.ValidationError)(`Invalid resource type - ${type}, expected ${expectedResourceType}.`);
}
// src/core/parser/ari.ts
var $be1ae0883aa48876$var$NUMBER_OF_ARI_SEGMENTS = 5, $be1ae0883aa48876$export$4c3a8cde7a55740b = class extends (0, $gsBjl.BaseParser) {
    static fromString(maybeAri, ariProperties) {
        let segments = this.getIdentifierSegments(maybeAri, $be1ae0883aa48876$var$NUMBER_OF_ARI_SEGMENTS), [qualifier, platformQualifier, resourceOwner, cloudId, resourceTypeAndId] = segments, [resourceType, ...resourceIdSegments] = resourceTypeAndId.split("/"), maybeAriDerivedProperties = {
            qualifier: qualifier,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            resourceId: resourceIdSegments.join("/"),
            resourceIdSegmentValues: ariProperties != null && ariProperties.resourceIdSlug ? this.ariSegmentValuesFromSlug(ariProperties.resourceIdSlug, resourceIdSegments.join("/"), ariProperties.resourceIdSegmentFormats) : {}
        };
        return this.fromOpts(maybeAriDerivedProperties, ariProperties);
    }
    static fromOpts(maybeAriOpts, ariProperties) {
        let { qualifier: qualifier = "ari", platformQualifier: platformQualifier = "cloud", resourceOwner: resourceOwner, cloudId: cloudId, resourceId: resourceId, resourceIdSegmentValues: resourceIdSegmentValues, resourceType: resourceType } = maybeAriOpts;
        return (0, $gsBjl.validateAriQualifier)(qualifier), (0, $gsBjl.validatePlatformQualifier)(platformQualifier), $be1ae0883aa48876$var$validateCloudId(maybeAriOpts.cloudId || "", ariProperties == null ? void 0 : ariProperties.cloudId), $be1ae0883aa48876$var$validateResourceOwner(resourceOwner, ariProperties == null ? void 0 : ariProperties.resourceOwner), $be1ae0883aa48876$var$validateResourceType(resourceType, ariProperties == null ? void 0 : ariProperties.resourceType), $be1ae0883aa48876$var$validateResourceIdSegments(resourceIdSegmentValues, ariProperties == null ? void 0 : ariProperties.resourceIdSegmentFormats), {
            qualifier: qualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceId: resourceId,
            resourceIdSegmentValues: resourceIdSegmentValues
        };
    }
    static ariSegmentValuesFromSlug(slug, incomingSegments, segmentFormats) {
        var _a;
        let expectedKeys = Object.keys(segmentFormats), slugVariables = (_a = slug.match(/\{(.*?)\}/g)) != null ? _a : [], finalVariable = slugVariables[slugVariables.length - 1], finalVariableKey = finalVariable == null ? void 0 : finalVariable.slice(1, -1), slugWithFinalSegmentFormat = slug.replace(/\{(.*?)\}/g, (_placeholder, key)=>{
            var _a2;
            let finalSegmentFormat = key === finalVariableKey ? segmentFormats[key] : void 0;
            return `(?<${key}>${(_a2 = finalSegmentFormat == null ? void 0 : finalSegmentFormat.source) != null ? _a2 : ".*?"})`;
        }), regexpResult = new RegExp(`^${slugWithFinalSegmentFormat}$`).exec(incomingSegments);
        if (!regexpResult) throw new (0, $laNVt.ValidationError)(`Segment '${incomingSegments}' don't match expected slug: ${slug}`);
        return expectedKeys.forEach((expectedKey)=>{
            var _a2;
            if (!((_a2 = regexpResult.groups) != null && _a2[expectedKey])) throw new (0, $laNVt.ValidationError)(`No value supplied for '${expectedKey}' based on slug ${slug}`);
        }), regexpResult.groups || {};
    }
};
// src/core/parser/ati.ts
var $be1ae0883aa48876$var$NUMBER_OF_ATI_SEGMENTS = 4, $be1ae0883aa48876$var$AtiParser = class extends (0, $gsBjl.BaseParser) {
    static fromString(inputStr, atiOpts) {
        let segments = this.getIdentifierSegments(inputStr, $be1ae0883aa48876$var$NUMBER_OF_ATI_SEGMENTS), [qualifier = "ati", platformQualifier = "cloud", resourceOwner, resourceType] = segments;
        return (0, $gsBjl.validateAtiQualifier)(qualifier), (0, $gsBjl.validatePlatformQualifier)(platformQualifier), $be1ae0883aa48876$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $be1ae0883aa48876$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
    static fromOpts(maybeAtiOpts, atiOpts) {
        let { qualifier: qualifier, platformQualifier: platformQualifier, resourceOwner: resourceOwner, resourceType: resourceType } = maybeAtiOpts;
        return (0, $gsBjl.validateAtiQualifier)(qualifier), (0, $gsBjl.validatePlatformQualifier)(platformQualifier), $be1ae0883aa48876$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $be1ae0883aa48876$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
};
// src/ati.ts
var $be1ae0883aa48876$export$ab4b293d0121b8ee = class _Ati {
    constructor(platformQualifier, resourceOwner, resourceType){
        this._platformQualifier = platformQualifier, this._resourceOwner = resourceOwner, this._resourceType = resourceType;
    }
    get platformQualifier() {
        return this._platformQualifier;
    }
    get resourceOwner() {
        return this._resourceOwner;
    }
    get resourceType() {
        return this._resourceType;
    }
    static create(opts) {
        return new _Ati(opts.platformQualifier || "cloud", opts.resourceOwner, opts.resourceType);
    }
    static parse(maybeAti, atiOpts) {
        let opts = $be1ae0883aa48876$var$AtiParser.fromString(maybeAti, atiOpts);
        return new _Ati(opts.platformQualifier, opts.resourceOwner, opts.resourceType);
    }
    toString() {
        return `ati:${this.platformQualifier}:${this.resourceOwner}:${this.resourceType}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this._platformQualifier,
            resourceOwner: this._resourceOwner,
            resourceType: this._resourceType
        };
    }
};

});
parcelRegister("gsBjl", function(module, exports) {
$parcel$export(module.exports, "validatePlatformQualifier", () => $bfbc34146be8bb7a$export$4f6e8fa90a16fdc4);
$parcel$export(module.exports, "validateAtiQualifier", () => $bfbc34146be8bb7a$export$da331df28ad1f3d9);
$parcel$export(module.exports, "validateAriQualifier", () => $bfbc34146be8bb7a$export$822bcd2b6f6774a1);
$parcel$export(module.exports, "BaseParser", () => $bfbc34146be8bb7a$export$3d09a5c28ff3e040);

var $laNVt = parcelRequire("laNVt");
// src/core/rules/platform-qualifier.ts
function $bfbc34146be8bb7a$export$4f6e8fa90a16fdc4(qualifier) {
    if (qualifier !== "cloud" && qualifier !== "third-party") throw new (0, $laNVt.ValidationError)(`Identifier must have a qualifier of 'cloud' or 'third-party'. Received: ${qualifier}`);
}
// src/core/rules/qualifier.ts
function $bfbc34146be8bb7a$export$da331df28ad1f3d9(qualifier) {
    if (qualifier !== "ati") throw new (0, $laNVt.ValidationError)(`ATI must have a qualifier of 'ati'. Received: ${qualifier}`);
}
function $bfbc34146be8bb7a$export$822bcd2b6f6774a1(qualifier) {
    if (qualifier !== "ari") throw new (0, $laNVt.ValidationError)(`ARI must have a qualifier of 'ari'. Received: ${qualifier}`);
}
function $bfbc34146be8bb7a$export$277c2bbc487e609d(qualifier) {
    if (qualifier !== "arm") throw new (0, $laNVt.ValidationError)(`ARM must have a qualifier of 'arm'. Received: ${qualifier}`);
}
// src/core/parser/base.ts
var $bfbc34146be8bb7a$var$NUMBER_OF_BASE_SEGMENTS = 5, $bfbc34146be8bb7a$var$SEGMENT_SEPARATOR = ":", $bfbc34146be8bb7a$export$3d09a5c28ff3e040 = class {
    static getIdentifierSegments(inputStr, numberOfSegmentsRequired) {
        let allSegments = inputStr.split($bfbc34146be8bb7a$var$SEGMENT_SEPARATOR);
        if (allSegments.length < numberOfSegmentsRequired) throw new (0, $laNVt.ValidationError)(`Input string must have ${numberOfSegmentsRequired} segments.`);
        if (allSegments.length > numberOfSegmentsRequired) {
            let segments = allSegments.slice(0, $bfbc34146be8bb7a$var$NUMBER_OF_BASE_SEGMENTS - 1), segmentsForResourceId = allSegments.slice($bfbc34146be8bb7a$var$NUMBER_OF_BASE_SEGMENTS - 1, allSegments.length);
            return [
                ...segments,
                segmentsForResourceId.join($bfbc34146be8bb7a$var$SEGMENT_SEPARATOR)
            ];
        }
        return allSegments;
    }
};

});
parcelRegister("laNVt", function(module, exports) {
$parcel$export(module.exports, "ValidationError", () => $f6a1426a155cb13a$export$2191b9da168c6cf0);
// src/errors.ts
var $f6a1426a155cb13a$export$2191b9da168c6cf0 = class extends Error {
};

});






parcelRegister("39L99", function(module, exports) {
$parcel$export(module.exports, "JiraIssueAri", () => $24c6c8b2a92ef1ad$export$1da6808e89ee03e);

var $l21ja = parcelRequire("l21ja");

var $7USzn = parcelRequire("7USzn");

var $gjVjm = parcelRequire("gjVjm");
// src/jira/issue/manifest.ts
var $24c6c8b2a92ef1ad$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $l21ja.JiraIssueAriResourceOwner),
    resourceType: (0, $l21ja.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $24c6c8b2a92ef1ad$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $7USzn.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $24c6c8b2a92ef1ad$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $24c6c8b2a92ef1ad$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $24c6c8b2a92ef1ad$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $24c6c8b2a92ef1ad$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $gjVjm.AriParser).fromOpts(derivedOpts, $24c6c8b2a92ef1ad$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gjVjm.AriParser).fromString(maybeAri, $24c6c8b2a92ef1ad$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
};

});
parcelRegister("l21ja", function(module, exports) {
$parcel$export(module.exports, "JiraIssueAriResourceOwner", () => $f4faccaa956cbbdc$export$665a39f1b4e29e0a);
$parcel$export(module.exports, "JiraIssueAriResourceType", () => $f4faccaa956cbbdc$export$76beb4d0da177ad4);
// src/jira/issue/types.ts
var $f4faccaa956cbbdc$export$665a39f1b4e29e0a = "jira", $f4faccaa956cbbdc$export$76beb4d0da177ad4 = "issue";

});



parcelRegister("dNQOn", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd32215259498f50$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $fBuCt = parcelRequire("fBuCt");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$fd32215259498f50$export$2e2bcd8739ae039 = {
    cancel: ()=>{},
    schedule: (fn)=>{
        // react 16.x
        if (// `unstable_batchedUpdates` is defined in all currently supported versions
        // but could be removed in the future.
        // This check is defensive and not currently necessary.
        typeof (0, (/*@__PURE__*/$parcel$interopDefault($fBuCt))).unstable_batchedUpdates === 'function' && // The version export was only introduced in `react-dom@16.13.0`
        // but we need to support `react-dom@^16.8.0`
        // so we need to handle when the version is `undefined`
        (typeof (0, $fBuCt.version) === 'undefined' || (0, $fBuCt.version).startsWith('16'))) (0, (/*@__PURE__*/$parcel$interopDefault($fBuCt))).unstable_batchedUpdates(()=>{
            fn();
        });
        else if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).startTransition === 'function') (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).startTransition(()=>{
            fn();
        });
        else fn();
        return '';
    }
};

});
parcelRegister("fBuCt", function(module, exports) {
'use strict';
function $b5c2101f77a75803$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b5c2101f77a75803$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b5c2101f77a75803$var$checkDCE();

module.exports = (parcelRequire("jKYKz"));

});
parcelRegister("jKYKz", function(module, exports) {
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $e6216febf4d6e8a1$export$ae55be85d98224ed, (v) => $e6216febf4d6e8a1$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $e6216febf4d6e8a1$export$d39a5bbd09211389, (v) => $e6216febf4d6e8a1$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $e6216febf4d6e8a1$export$882461b6382ed46c, (v) => $e6216febf4d6e8a1$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $e6216febf4d6e8a1$export$466bfc07425424d5, (v) => $e6216febf4d6e8a1$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $e6216febf4d6e8a1$export$cd75ccfd720a3cd4, (v) => $e6216febf4d6e8a1$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $e6216febf4d6e8a1$export$fa8d919ba61d84db, (v) => $e6216febf4d6e8a1$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $e6216febf4d6e8a1$export$757ceba2d55c277e, (v) => $e6216febf4d6e8a1$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $e6216febf4d6e8a1$export$b3890eb0ae9dca99, (v) => $e6216febf4d6e8a1$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $e6216febf4d6e8a1$export$502457920280e6be, (v) => $e6216febf4d6e8a1$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $e6216febf4d6e8a1$export$c78a37762a8d58e1, (v) => $e6216febf4d6e8a1$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $e6216febf4d6e8a1$export$dc54d992c10e8a18, (v) => $e6216febf4d6e8a1$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $e6216febf4d6e8a1$export$83d89fbfd8236492, (v) => $e6216febf4d6e8a1$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.profiling.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e6216febf4d6e8a1$export$ae55be85d98224ed;
var $e6216febf4d6e8a1$export$d39a5bbd09211389;
var $e6216febf4d6e8a1$export$882461b6382ed46c;
var $e6216febf4d6e8a1$export$466bfc07425424d5;
var $e6216febf4d6e8a1$export$cd75ccfd720a3cd4;
var $e6216febf4d6e8a1$export$fa8d919ba61d84db;
var $e6216febf4d6e8a1$export$757ceba2d55c277e;
var $e6216febf4d6e8a1$export$b3890eb0ae9dca99;
var $e6216febf4d6e8a1$export$502457920280e6be;
var $e6216febf4d6e8a1$export$c78a37762a8d58e1;
var $e6216febf4d6e8a1$export$dc54d992c10e8a18;
var $e6216febf4d6e8a1$export$83d89fbfd8236492;
'use strict';
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $1v5pe = parcelRequire("1v5pe");

var $hziAm = parcelRequire("hziAm");
function $e6216febf4d6e8a1$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $e6216febf4d6e8a1$var$da = new Set, $e6216febf4d6e8a1$var$ea = {};
function $e6216febf4d6e8a1$var$fa(a, b) {
    $e6216febf4d6e8a1$var$ha(a, b);
    $e6216febf4d6e8a1$var$ha(a + "Capture", b);
}
function $e6216febf4d6e8a1$var$ha(a, b) {
    $e6216febf4d6e8a1$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$e6216febf4d6e8a1$var$da.add(b[a]);
}
var $e6216febf4d6e8a1$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e6216febf4d6e8a1$var$ja = Object.prototype.hasOwnProperty, $e6216febf4d6e8a1$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e6216febf4d6e8a1$var$la = {}, $e6216febf4d6e8a1$var$ma = {};
function $e6216febf4d6e8a1$var$na(a) {
    if ($e6216febf4d6e8a1$var$ja.call($e6216febf4d6e8a1$var$ma, a)) return !0;
    if ($e6216febf4d6e8a1$var$ja.call($e6216febf4d6e8a1$var$la, a)) return !1;
    if ($e6216febf4d6e8a1$var$ka.test(a)) return $e6216febf4d6e8a1$var$ma[a] = !0;
    $e6216febf4d6e8a1$var$la[a] = !0;
    return !1;
}
function $e6216febf4d6e8a1$var$oa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $e6216febf4d6e8a1$var$pa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $e6216febf4d6e8a1$var$oa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $e6216febf4d6e8a1$var$qa(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $e6216febf4d6e8a1$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e6216febf4d6e8a1$var$t[a] = new $e6216febf4d6e8a1$var$qa(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e6216febf4d6e8a1$var$t[b] = new $e6216febf4d6e8a1$var$qa(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e6216febf4d6e8a1$var$t[a] = new $e6216febf4d6e8a1$var$qa(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e6216febf4d6e8a1$var$t[a] = new $e6216febf4d6e8a1$var$qa(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e6216febf4d6e8a1$var$t[a] = new $e6216febf4d6e8a1$var$qa(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e6216febf4d6e8a1$var$t[a] = new $e6216febf4d6e8a1$var$qa(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e6216febf4d6e8a1$var$t[a] = new $e6216febf4d6e8a1$var$qa(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e6216febf4d6e8a1$var$t[a] = new $e6216febf4d6e8a1$var$qa(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e6216febf4d6e8a1$var$t[a] = new $e6216febf4d6e8a1$var$qa(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e6216febf4d6e8a1$var$ra = /[\-:]([a-z])/g;
function $e6216febf4d6e8a1$var$ta(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e6216febf4d6e8a1$var$ra, $e6216febf4d6e8a1$var$ta);
    $e6216febf4d6e8a1$var$t[b] = new $e6216febf4d6e8a1$var$qa(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e6216febf4d6e8a1$var$ra, $e6216febf4d6e8a1$var$ta);
    $e6216febf4d6e8a1$var$t[b] = new $e6216febf4d6e8a1$var$qa(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e6216febf4d6e8a1$var$ra, $e6216febf4d6e8a1$var$ta);
    $e6216febf4d6e8a1$var$t[b] = new $e6216febf4d6e8a1$var$qa(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e6216febf4d6e8a1$var$t[a] = new $e6216febf4d6e8a1$var$qa(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e6216febf4d6e8a1$var$t.xlinkHref = new $e6216febf4d6e8a1$var$qa("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e6216febf4d6e8a1$var$t[a] = new $e6216febf4d6e8a1$var$qa(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $e6216febf4d6e8a1$var$ua(a, b, c, d) {
    var e = $e6216febf4d6e8a1$var$t.hasOwnProperty(b) ? $e6216febf4d6e8a1$var$t[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $e6216febf4d6e8a1$var$pa(b, c, e, d) && (c = null), d || null === e ? $e6216febf4d6e8a1$var$na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $e6216febf4d6e8a1$var$va = $1v5pe.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e6216febf4d6e8a1$var$wa = Symbol.for("react.element"), $e6216febf4d6e8a1$var$xa = Symbol.for("react.portal"), $e6216febf4d6e8a1$var$ya = Symbol.for("react.fragment"), $e6216febf4d6e8a1$var$za = Symbol.for("react.strict_mode"), $e6216febf4d6e8a1$var$Aa = Symbol.for("react.profiler"), $e6216febf4d6e8a1$var$Ba = Symbol.for("react.provider"), $e6216febf4d6e8a1$var$Ca = Symbol.for("react.context"), $e6216febf4d6e8a1$var$Da = Symbol.for("react.forward_ref"), $e6216febf4d6e8a1$var$Ea = Symbol.for("react.suspense"), $e6216febf4d6e8a1$var$Fa = Symbol.for("react.suspense_list"), $e6216febf4d6e8a1$var$Ga = Symbol.for("react.memo"), $e6216febf4d6e8a1$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e6216febf4d6e8a1$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $e6216febf4d6e8a1$var$Ja = Symbol.iterator;
function $e6216febf4d6e8a1$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e6216febf4d6e8a1$var$Ja && a[$e6216febf4d6e8a1$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e6216febf4d6e8a1$var$u = Object.assign, $e6216febf4d6e8a1$var$La;
function $e6216febf4d6e8a1$var$Ma(a) {
    if (void 0 === $e6216febf4d6e8a1$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $e6216febf4d6e8a1$var$La = b && b[1] || "";
    }
    return "\n" + $e6216febf4d6e8a1$var$La + a;
}
var $e6216febf4d6e8a1$var$Na = !1;
function $e6216febf4d6e8a1$var$Oa(a, b) {
    if (!a || $e6216febf4d6e8a1$var$Na) return "";
    $e6216febf4d6e8a1$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $e6216febf4d6e8a1$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $e6216febf4d6e8a1$var$Ma(a) : "";
}
function $e6216febf4d6e8a1$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $e6216febf4d6e8a1$var$Ma(a.type);
        case 16:
            return $e6216febf4d6e8a1$var$Ma("Lazy");
        case 13:
            return $e6216febf4d6e8a1$var$Ma("Suspense");
        case 19:
            return $e6216febf4d6e8a1$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $e6216febf4d6e8a1$var$Oa(a.type, !1), a;
        case 11:
            return a = $e6216febf4d6e8a1$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $e6216febf4d6e8a1$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $e6216febf4d6e8a1$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e6216febf4d6e8a1$var$ya:
            return "Fragment";
        case $e6216febf4d6e8a1$var$xa:
            return "Portal";
        case $e6216febf4d6e8a1$var$Aa:
            return "Profiler";
        case $e6216febf4d6e8a1$var$za:
            return "StrictMode";
        case $e6216febf4d6e8a1$var$Ea:
            return "Suspense";
        case $e6216febf4d6e8a1$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e6216febf4d6e8a1$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $e6216febf4d6e8a1$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $e6216febf4d6e8a1$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $e6216febf4d6e8a1$var$Ga:
            return b = a.displayName || null, null !== b ? b : $e6216febf4d6e8a1$var$Qa(a.type) || "Memo";
        case $e6216febf4d6e8a1$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $e6216febf4d6e8a1$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $e6216febf4d6e8a1$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $e6216febf4d6e8a1$var$Qa(b);
        case 8:
            return b === $e6216febf4d6e8a1$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $e6216febf4d6e8a1$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $e6216febf4d6e8a1$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $e6216febf4d6e8a1$var$Ua(a) {
    var b = $e6216febf4d6e8a1$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $e6216febf4d6e8a1$var$Va(a) {
    a._valueTracker || (a._valueTracker = $e6216febf4d6e8a1$var$Ua(a));
}
function $e6216febf4d6e8a1$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $e6216febf4d6e8a1$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $e6216febf4d6e8a1$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $e6216febf4d6e8a1$var$Ya(a, b) {
    var c = b.checked;
    return $e6216febf4d6e8a1$var$u({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $e6216febf4d6e8a1$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $e6216febf4d6e8a1$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $e6216febf4d6e8a1$var$$a(a, b) {
    b = b.checked;
    null != b && $e6216febf4d6e8a1$var$ua(a, "checked", b, !1);
}
function $e6216febf4d6e8a1$var$ab(a, b) {
    $e6216febf4d6e8a1$var$$a(a, b);
    var c = $e6216febf4d6e8a1$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $e6216febf4d6e8a1$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $e6216febf4d6e8a1$var$bb(a, b.type, $e6216febf4d6e8a1$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $e6216febf4d6e8a1$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $e6216febf4d6e8a1$var$bb(a, b, c) {
    if ("number" !== b || $e6216febf4d6e8a1$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $e6216febf4d6e8a1$var$db = Array.isArray;
function $e6216febf4d6e8a1$var$eb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $e6216febf4d6e8a1$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $e6216febf4d6e8a1$var$fb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($e6216febf4d6e8a1$var$p(91));
    return $e6216febf4d6e8a1$var$u({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $e6216febf4d6e8a1$var$gb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($e6216febf4d6e8a1$var$p(92));
            if ($e6216febf4d6e8a1$var$db(c)) {
                if (1 < c.length) throw Error($e6216febf4d6e8a1$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $e6216febf4d6e8a1$var$Sa(c)
    };
}
function $e6216febf4d6e8a1$var$hb(a, b) {
    var c = $e6216febf4d6e8a1$var$Sa(b.value), d = $e6216febf4d6e8a1$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $e6216febf4d6e8a1$var$ib(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $e6216febf4d6e8a1$var$jb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $e6216febf4d6e8a1$var$kb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $e6216febf4d6e8a1$var$jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $e6216febf4d6e8a1$var$mb, $e6216febf4d6e8a1$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $e6216febf4d6e8a1$var$mb = $e6216febf4d6e8a1$var$mb || document.createElement("div");
        $e6216febf4d6e8a1$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $e6216febf4d6e8a1$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $e6216febf4d6e8a1$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $e6216febf4d6e8a1$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e6216febf4d6e8a1$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e6216febf4d6e8a1$var$pb).forEach(function(a) {
    $e6216febf4d6e8a1$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e6216febf4d6e8a1$var$pb[b] = $e6216febf4d6e8a1$var$pb[a];
    });
});
function $e6216febf4d6e8a1$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $e6216febf4d6e8a1$var$pb.hasOwnProperty(a) && $e6216febf4d6e8a1$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $e6216febf4d6e8a1$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $e6216febf4d6e8a1$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $e6216febf4d6e8a1$var$tb = $e6216febf4d6e8a1$var$u({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $e6216febf4d6e8a1$var$ub(a, b) {
    if (b) {
        if ($e6216febf4d6e8a1$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($e6216febf4d6e8a1$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($e6216febf4d6e8a1$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($e6216febf4d6e8a1$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($e6216febf4d6e8a1$var$p(62));
    }
}
function $e6216febf4d6e8a1$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e6216febf4d6e8a1$var$wb = null;
function $e6216febf4d6e8a1$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $e6216febf4d6e8a1$var$yb = null, $e6216febf4d6e8a1$var$zb = null, $e6216febf4d6e8a1$var$Ab = null;
function $e6216febf4d6e8a1$var$Bb(a) {
    if (a = $e6216febf4d6e8a1$var$Cb(a)) {
        if ("function" !== typeof $e6216febf4d6e8a1$var$yb) throw Error($e6216febf4d6e8a1$var$p(280));
        var b = a.stateNode;
        b && (b = $e6216febf4d6e8a1$var$Db(b), $e6216febf4d6e8a1$var$yb(a.stateNode, a.type, b));
    }
}
function $e6216febf4d6e8a1$var$Eb(a) {
    $e6216febf4d6e8a1$var$zb ? $e6216febf4d6e8a1$var$Ab ? $e6216febf4d6e8a1$var$Ab.push(a) : $e6216febf4d6e8a1$var$Ab = [
        a
    ] : $e6216febf4d6e8a1$var$zb = a;
}
function $e6216febf4d6e8a1$var$Fb() {
    if ($e6216febf4d6e8a1$var$zb) {
        var a = $e6216febf4d6e8a1$var$zb, b = $e6216febf4d6e8a1$var$Ab;
        $e6216febf4d6e8a1$var$Ab = $e6216febf4d6e8a1$var$zb = null;
        $e6216febf4d6e8a1$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$e6216febf4d6e8a1$var$Bb(b[a]);
    }
}
function $e6216febf4d6e8a1$var$Gb(a, b) {
    return a(b);
}
function $e6216febf4d6e8a1$var$Hb() {}
var $e6216febf4d6e8a1$var$Ib = !1;
function $e6216febf4d6e8a1$var$Jb(a, b, c) {
    if ($e6216febf4d6e8a1$var$Ib) return a(b, c);
    $e6216febf4d6e8a1$var$Ib = !0;
    try {
        return $e6216febf4d6e8a1$var$Gb(a, b, c);
    } finally{
        if ($e6216febf4d6e8a1$var$Ib = !1, null !== $e6216febf4d6e8a1$var$zb || null !== $e6216febf4d6e8a1$var$Ab) $e6216febf4d6e8a1$var$Hb(), $e6216febf4d6e8a1$var$Fb();
    }
}
function $e6216febf4d6e8a1$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $e6216febf4d6e8a1$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($e6216febf4d6e8a1$var$p(231, b, typeof c));
    return c;
}
var $e6216febf4d6e8a1$var$Lb = !1;
if ($e6216febf4d6e8a1$var$ia) try {
    var $e6216febf4d6e8a1$var$Mb = {};
    Object.defineProperty($e6216febf4d6e8a1$var$Mb, "passive", {
        get: function() {
            $e6216febf4d6e8a1$var$Lb = !0;
        }
    });
    window.addEventListener("test", $e6216febf4d6e8a1$var$Mb, $e6216febf4d6e8a1$var$Mb);
    window.removeEventListener("test", $e6216febf4d6e8a1$var$Mb, $e6216febf4d6e8a1$var$Mb);
} catch (a) {
    $e6216febf4d6e8a1$var$Lb = !1;
}
function $e6216febf4d6e8a1$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $e6216febf4d6e8a1$var$Ob = !1, $e6216febf4d6e8a1$var$Pb = null, $e6216febf4d6e8a1$var$Qb = !1, $e6216febf4d6e8a1$var$Rb = null, $e6216febf4d6e8a1$var$Sb = {
    onError: function(a) {
        $e6216febf4d6e8a1$var$Ob = !0;
        $e6216febf4d6e8a1$var$Pb = a;
    }
};
function $e6216febf4d6e8a1$var$Tb(a, b, c, d, e, f, g, h, k) {
    $e6216febf4d6e8a1$var$Ob = !1;
    $e6216febf4d6e8a1$var$Pb = null;
    $e6216febf4d6e8a1$var$Nb.apply($e6216febf4d6e8a1$var$Sb, arguments);
}
function $e6216febf4d6e8a1$var$Ub(a, b, c, d, e, f, g, h, k) {
    $e6216febf4d6e8a1$var$Tb.apply(this, arguments);
    if ($e6216febf4d6e8a1$var$Ob) {
        if ($e6216febf4d6e8a1$var$Ob) {
            var l = $e6216febf4d6e8a1$var$Pb;
            $e6216febf4d6e8a1$var$Ob = !1;
            $e6216febf4d6e8a1$var$Pb = null;
        } else throw Error($e6216febf4d6e8a1$var$p(198));
        $e6216febf4d6e8a1$var$Qb || ($e6216febf4d6e8a1$var$Qb = !0, $e6216febf4d6e8a1$var$Rb = l);
    }
}
function $e6216febf4d6e8a1$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $e6216febf4d6e8a1$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $e6216febf4d6e8a1$var$Xb(a) {
    if ($e6216febf4d6e8a1$var$Vb(a) !== a) throw Error($e6216febf4d6e8a1$var$p(188));
}
function $e6216febf4d6e8a1$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $e6216febf4d6e8a1$var$Vb(a);
        if (null === b) throw Error($e6216febf4d6e8a1$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $e6216febf4d6e8a1$var$Xb(e), a;
                if (f === d) return $e6216febf4d6e8a1$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($e6216febf4d6e8a1$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($e6216febf4d6e8a1$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($e6216febf4d6e8a1$var$p(190));
    }
    if (3 !== c.tag) throw Error($e6216febf4d6e8a1$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $e6216febf4d6e8a1$var$Zb(a) {
    a = $e6216febf4d6e8a1$var$Yb(a);
    return null !== a ? $e6216febf4d6e8a1$var$$b(a) : null;
}
function $e6216febf4d6e8a1$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $e6216febf4d6e8a1$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $e6216febf4d6e8a1$var$ac = $hziAm.unstable_scheduleCallback, $e6216febf4d6e8a1$var$bc = $hziAm.unstable_cancelCallback, $e6216febf4d6e8a1$var$cc = $hziAm.unstable_shouldYield, $e6216febf4d6e8a1$var$dc = $hziAm.unstable_requestPaint, $e6216febf4d6e8a1$var$A = $hziAm.unstable_now, $e6216febf4d6e8a1$var$ec = $hziAm.unstable_getCurrentPriorityLevel, $e6216febf4d6e8a1$var$fc = $hziAm.unstable_ImmediatePriority, $e6216febf4d6e8a1$var$gc = $hziAm.unstable_UserBlockingPriority, $e6216febf4d6e8a1$var$hc = $hziAm.unstable_NormalPriority, $e6216febf4d6e8a1$var$ic = $hziAm.unstable_LowPriority, $e6216febf4d6e8a1$var$jc = $hziAm.unstable_IdlePriority, $e6216febf4d6e8a1$var$kc = null, $e6216febf4d6e8a1$var$lc = null, $e6216febf4d6e8a1$var$B = null, $e6216febf4d6e8a1$var$mc = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__;
function $e6216febf4d6e8a1$var$nc(a, b) {
    if ($e6216febf4d6e8a1$var$lc && "function" === typeof $e6216febf4d6e8a1$var$lc.onCommitFiberRoot) try {
        var c = 128 === (a.current.flags & 128);
        switch(b){
            case 1:
                var d = $e6216febf4d6e8a1$var$fc;
                break;
            case 4:
                d = $e6216febf4d6e8a1$var$gc;
                break;
            case 16:
                d = $e6216febf4d6e8a1$var$hc;
                break;
            case 536870912:
                d = $e6216febf4d6e8a1$var$jc;
                break;
            default:
                d = $e6216febf4d6e8a1$var$hc;
        }
        $e6216febf4d6e8a1$var$lc.onCommitFiberRoot($e6216febf4d6e8a1$var$kc, a, d, c);
    } catch (e) {}
}
function $e6216febf4d6e8a1$var$oc(a) {
    $e6216febf4d6e8a1$var$B = a;
}
function $e6216febf4d6e8a1$var$pc() {
    for(var a = new Map, b = 1, c = 0; 31 > c; c++){
        var d = $e6216febf4d6e8a1$var$qc(b);
        a.set(b, d);
        b *= 2;
    }
    return a;
}
function $e6216febf4d6e8a1$var$rc() {
    null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markCommitStopped && $e6216febf4d6e8a1$var$B.markCommitStopped();
}
function $e6216febf4d6e8a1$var$sc(a) {
    null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markComponentRenderStarted && $e6216febf4d6e8a1$var$B.markComponentRenderStarted(a);
}
function $e6216febf4d6e8a1$var$tc() {
    null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markComponentRenderStopped && $e6216febf4d6e8a1$var$B.markComponentRenderStopped();
}
function $e6216febf4d6e8a1$var$uc(a) {
    null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markComponentLayoutEffectUnmountStarted && $e6216febf4d6e8a1$var$B.markComponentLayoutEffectUnmountStarted(a);
}
function $e6216febf4d6e8a1$var$vc() {
    null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markComponentLayoutEffectUnmountStopped && $e6216febf4d6e8a1$var$B.markComponentLayoutEffectUnmountStopped();
}
function $e6216febf4d6e8a1$var$wc(a) {
    null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markRenderStarted && $e6216febf4d6e8a1$var$B.markRenderStarted(a);
}
function $e6216febf4d6e8a1$var$xc() {
    null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markRenderStopped && $e6216febf4d6e8a1$var$B.markRenderStopped();
}
function $e6216febf4d6e8a1$var$yc(a, b) {
    null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markStateUpdateScheduled && $e6216febf4d6e8a1$var$B.markStateUpdateScheduled(a, b);
}
var $e6216febf4d6e8a1$var$Ac = Math.clz32 ? Math.clz32 : $e6216febf4d6e8a1$var$zc, $e6216febf4d6e8a1$var$Bc = Math.log, $e6216febf4d6e8a1$var$Cc = Math.LN2;
function $e6216febf4d6e8a1$var$zc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($e6216febf4d6e8a1$var$Bc(a) / $e6216febf4d6e8a1$var$Cc | 0) | 0;
}
function $e6216febf4d6e8a1$var$qc(a) {
    if (a & 1) return "Sync";
    if (a & 2) return "InputContinuousHydration";
    if (a & 4) return "InputContinuous";
    if (a & 8) return "DefaultHydration";
    if (a & 16) return "Default";
    if (a & 32) return "TransitionHydration";
    if (a & 4194240) return "Transition";
    if (a & 130023424) return "Retry";
    if (a & 134217728) return "SelectiveHydration";
    if (a & 268435456) return "IdleHydration";
    if (a & 536870912) return "Idle";
    if (a & 1073741824) return "Offscreen";
}
var $e6216febf4d6e8a1$var$Dc = 64, $e6216febf4d6e8a1$var$Ec = 4194304;
function $e6216febf4d6e8a1$var$Fc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $e6216febf4d6e8a1$var$Gc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $e6216febf4d6e8a1$var$Fc(h) : (f &= g, 0 !== f && (d = $e6216febf4d6e8a1$var$Fc(f)));
    } else g = c & ~e, 0 !== g ? d = $e6216febf4d6e8a1$var$Fc(g) : 0 !== f && (d = $e6216febf4d6e8a1$var$Fc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $e6216febf4d6e8a1$var$Ac(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $e6216febf4d6e8a1$var$Hc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e6216febf4d6e8a1$var$Ic(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $e6216febf4d6e8a1$var$Ac(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $e6216febf4d6e8a1$var$Hc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $e6216febf4d6e8a1$var$Jc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $e6216febf4d6e8a1$var$Kc() {
    var a = $e6216febf4d6e8a1$var$Dc;
    $e6216febf4d6e8a1$var$Dc <<= 1;
    0 === ($e6216febf4d6e8a1$var$Dc & 4194240) && ($e6216febf4d6e8a1$var$Dc = 64);
    return a;
}
function $e6216febf4d6e8a1$var$Lc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $e6216febf4d6e8a1$var$Mc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $e6216febf4d6e8a1$var$Ac(b);
    a[b] = c;
}
function $e6216febf4d6e8a1$var$Nc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $e6216febf4d6e8a1$var$Ac(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $e6216febf4d6e8a1$var$Oc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $e6216febf4d6e8a1$var$Ac(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
function $e6216febf4d6e8a1$var$Pc(a, b, c) {
    if ($e6216febf4d6e8a1$var$mc) for(a = a.pendingUpdatersLaneMap; 0 < c;){
        var d = 31 - $e6216febf4d6e8a1$var$Ac(c), e = 1 << d;
        a[d].add(b);
        c &= ~e;
    }
}
function $e6216febf4d6e8a1$var$Qc(a, b) {
    if ($e6216febf4d6e8a1$var$mc) for(var c = a.pendingUpdatersLaneMap, d = a.memoizedUpdaters; 0 < b;){
        var e = 31 - $e6216febf4d6e8a1$var$Ac(b);
        a = 1 << e;
        e = c[e];
        0 < e.size && (e.forEach(function(a) {
            var b = a.alternate;
            null !== b && d.has(b) || d.add(a);
        }), e.clear());
        b &= ~a;
    }
}
var $e6216febf4d6e8a1$var$E = 0;
function $e6216febf4d6e8a1$var$Rc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $e6216febf4d6e8a1$var$Sc, $e6216febf4d6e8a1$var$Tc, $e6216febf4d6e8a1$var$Uc, $e6216febf4d6e8a1$var$Vc, $e6216febf4d6e8a1$var$Wc, $e6216febf4d6e8a1$var$Xc = !1, $e6216febf4d6e8a1$var$Yc = [], $e6216febf4d6e8a1$var$Zc = null, $e6216febf4d6e8a1$var$$c = null, $e6216febf4d6e8a1$var$ad = null, $e6216febf4d6e8a1$var$bd = new Map, $e6216febf4d6e8a1$var$cd = new Map, $e6216febf4d6e8a1$var$dd = [], $e6216febf4d6e8a1$var$ed = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $e6216febf4d6e8a1$var$fd(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $e6216febf4d6e8a1$var$Zc = null;
            break;
        case "dragenter":
        case "dragleave":
            $e6216febf4d6e8a1$var$$c = null;
            break;
        case "mouseover":
        case "mouseout":
            $e6216febf4d6e8a1$var$ad = null;
            break;
        case "pointerover":
        case "pointerout":
            $e6216febf4d6e8a1$var$bd.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e6216febf4d6e8a1$var$cd.delete(b.pointerId);
    }
}
function $e6216febf4d6e8a1$var$gd(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $e6216febf4d6e8a1$var$Cb(b), null !== b && $e6216febf4d6e8a1$var$Tc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $e6216febf4d6e8a1$var$hd(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $e6216febf4d6e8a1$var$Zc = $e6216febf4d6e8a1$var$gd($e6216febf4d6e8a1$var$Zc, a, b, c, d, e), !0;
        case "dragenter":
            return $e6216febf4d6e8a1$var$$c = $e6216febf4d6e8a1$var$gd($e6216febf4d6e8a1$var$$c, a, b, c, d, e), !0;
        case "mouseover":
            return $e6216febf4d6e8a1$var$ad = $e6216febf4d6e8a1$var$gd($e6216febf4d6e8a1$var$ad, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $e6216febf4d6e8a1$var$bd.set(f, $e6216febf4d6e8a1$var$gd($e6216febf4d6e8a1$var$bd.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $e6216febf4d6e8a1$var$cd.set(f, $e6216febf4d6e8a1$var$gd($e6216febf4d6e8a1$var$cd.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $e6216febf4d6e8a1$var$id(a) {
    var b = $e6216febf4d6e8a1$var$jd(a.target);
    if (null !== b) {
        var c = $e6216febf4d6e8a1$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $e6216febf4d6e8a1$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $e6216febf4d6e8a1$var$Wc(a.priority, function() {
                        $e6216febf4d6e8a1$var$Uc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $e6216febf4d6e8a1$var$kd(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $e6216febf4d6e8a1$var$ld(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $e6216febf4d6e8a1$var$wb = d;
            c.target.dispatchEvent(d);
            $e6216febf4d6e8a1$var$wb = null;
        } else return b = $e6216febf4d6e8a1$var$Cb(c), null !== b && $e6216febf4d6e8a1$var$Tc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $e6216febf4d6e8a1$var$md(a, b, c) {
    $e6216febf4d6e8a1$var$kd(a) && c.delete(b);
}
function $e6216febf4d6e8a1$var$nd() {
    $e6216febf4d6e8a1$var$Xc = !1;
    null !== $e6216febf4d6e8a1$var$Zc && $e6216febf4d6e8a1$var$kd($e6216febf4d6e8a1$var$Zc) && ($e6216febf4d6e8a1$var$Zc = null);
    null !== $e6216febf4d6e8a1$var$$c && $e6216febf4d6e8a1$var$kd($e6216febf4d6e8a1$var$$c) && ($e6216febf4d6e8a1$var$$c = null);
    null !== $e6216febf4d6e8a1$var$ad && $e6216febf4d6e8a1$var$kd($e6216febf4d6e8a1$var$ad) && ($e6216febf4d6e8a1$var$ad = null);
    $e6216febf4d6e8a1$var$bd.forEach($e6216febf4d6e8a1$var$md);
    $e6216febf4d6e8a1$var$cd.forEach($e6216febf4d6e8a1$var$md);
}
function $e6216febf4d6e8a1$var$od(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $e6216febf4d6e8a1$var$Xc || ($e6216febf4d6e8a1$var$Xc = !0, $hziAm.unstable_scheduleCallback($hziAm.unstable_NormalPriority, $e6216febf4d6e8a1$var$nd)));
}
function $e6216febf4d6e8a1$var$pd(a) {
    function b(b) {
        return $e6216febf4d6e8a1$var$od(b, a);
    }
    if (0 < $e6216febf4d6e8a1$var$Yc.length) {
        $e6216febf4d6e8a1$var$od($e6216febf4d6e8a1$var$Yc[0], a);
        for(var c = 1; c < $e6216febf4d6e8a1$var$Yc.length; c++){
            var d = $e6216febf4d6e8a1$var$Yc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $e6216febf4d6e8a1$var$Zc && $e6216febf4d6e8a1$var$od($e6216febf4d6e8a1$var$Zc, a);
    null !== $e6216febf4d6e8a1$var$$c && $e6216febf4d6e8a1$var$od($e6216febf4d6e8a1$var$$c, a);
    null !== $e6216febf4d6e8a1$var$ad && $e6216febf4d6e8a1$var$od($e6216febf4d6e8a1$var$ad, a);
    $e6216febf4d6e8a1$var$bd.forEach(b);
    $e6216febf4d6e8a1$var$cd.forEach(b);
    for(c = 0; c < $e6216febf4d6e8a1$var$dd.length; c++)d = $e6216febf4d6e8a1$var$dd[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $e6216febf4d6e8a1$var$dd.length && (c = $e6216febf4d6e8a1$var$dd[0], null === c.blockedOn);)$e6216febf4d6e8a1$var$id(c), null === c.blockedOn && $e6216febf4d6e8a1$var$dd.shift();
}
var $e6216febf4d6e8a1$var$qd = $e6216febf4d6e8a1$var$va.ReactCurrentBatchConfig, $e6216febf4d6e8a1$var$rd = !0;
function $e6216febf4d6e8a1$var$sd(a, b, c, d) {
    var e = $e6216febf4d6e8a1$var$E, f = $e6216febf4d6e8a1$var$qd.transition;
    $e6216febf4d6e8a1$var$qd.transition = null;
    try {
        $e6216febf4d6e8a1$var$E = 1, $e6216febf4d6e8a1$var$td(a, b, c, d);
    } finally{
        $e6216febf4d6e8a1$var$E = e, $e6216febf4d6e8a1$var$qd.transition = f;
    }
}
function $e6216febf4d6e8a1$var$ud(a, b, c, d) {
    var e = $e6216febf4d6e8a1$var$E, f = $e6216febf4d6e8a1$var$qd.transition;
    $e6216febf4d6e8a1$var$qd.transition = null;
    try {
        $e6216febf4d6e8a1$var$E = 4, $e6216febf4d6e8a1$var$td(a, b, c, d);
    } finally{
        $e6216febf4d6e8a1$var$E = e, $e6216febf4d6e8a1$var$qd.transition = f;
    }
}
function $e6216febf4d6e8a1$var$td(a, b, c, d) {
    if ($e6216febf4d6e8a1$var$rd) {
        var e = $e6216febf4d6e8a1$var$ld(a, b, c, d);
        if (null === e) $e6216febf4d6e8a1$var$vd(a, b, d, $e6216febf4d6e8a1$var$wd, c), $e6216febf4d6e8a1$var$fd(a, d);
        else if ($e6216febf4d6e8a1$var$hd(e, a, b, c, d)) d.stopPropagation();
        else if ($e6216febf4d6e8a1$var$fd(a, d), b & 4 && -1 < $e6216febf4d6e8a1$var$ed.indexOf(a)) {
            for(; null !== e;){
                var f = $e6216febf4d6e8a1$var$Cb(e);
                null !== f && $e6216febf4d6e8a1$var$Sc(f);
                f = $e6216febf4d6e8a1$var$ld(a, b, c, d);
                null === f && $e6216febf4d6e8a1$var$vd(a, b, d, $e6216febf4d6e8a1$var$wd, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $e6216febf4d6e8a1$var$vd(a, b, d, null, c);
    }
}
var $e6216febf4d6e8a1$var$wd = null;
function $e6216febf4d6e8a1$var$ld(a, b, c, d) {
    $e6216febf4d6e8a1$var$wd = null;
    a = $e6216febf4d6e8a1$var$xb(d);
    a = $e6216febf4d6e8a1$var$jd(a);
    if (null !== a) {
        if (b = $e6216febf4d6e8a1$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $e6216febf4d6e8a1$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $e6216febf4d6e8a1$var$wd = a;
    return null;
}
function $e6216febf4d6e8a1$var$xd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($e6216febf4d6e8a1$var$ec()){
                case $e6216febf4d6e8a1$var$fc:
                    return 1;
                case $e6216febf4d6e8a1$var$gc:
                    return 4;
                case $e6216febf4d6e8a1$var$hc:
                case $e6216febf4d6e8a1$var$ic:
                    return 16;
                case $e6216febf4d6e8a1$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $e6216febf4d6e8a1$var$yd = null, $e6216febf4d6e8a1$var$zd = null, $e6216febf4d6e8a1$var$Ad = null;
function $e6216febf4d6e8a1$var$Bd() {
    if ($e6216febf4d6e8a1$var$Ad) return $e6216febf4d6e8a1$var$Ad;
    var a, b = $e6216febf4d6e8a1$var$zd, c = b.length, d, e = "value" in $e6216febf4d6e8a1$var$yd ? $e6216febf4d6e8a1$var$yd.value : $e6216febf4d6e8a1$var$yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $e6216febf4d6e8a1$var$Ad = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $e6216febf4d6e8a1$var$Cd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $e6216febf4d6e8a1$var$Dd() {
    return !0;
}
function $e6216febf4d6e8a1$var$Ed() {
    return !1;
}
function $e6216febf4d6e8a1$var$Fd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $e6216febf4d6e8a1$var$Dd : $e6216febf4d6e8a1$var$Ed;
        this.isPropagationStopped = $e6216febf4d6e8a1$var$Ed;
        return this;
    }
    $e6216febf4d6e8a1$var$u(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $e6216febf4d6e8a1$var$Dd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $e6216febf4d6e8a1$var$Dd);
        },
        persist: function() {},
        isPersistent: $e6216febf4d6e8a1$var$Dd
    });
    return b;
}
var $e6216febf4d6e8a1$var$Gd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e6216febf4d6e8a1$var$Hd = $e6216febf4d6e8a1$var$Fd($e6216febf4d6e8a1$var$Gd), $e6216febf4d6e8a1$var$Id = $e6216febf4d6e8a1$var$u({}, $e6216febf4d6e8a1$var$Gd, {
    view: 0,
    detail: 0
}), $e6216febf4d6e8a1$var$Jd = $e6216febf4d6e8a1$var$Fd($e6216febf4d6e8a1$var$Id), $e6216febf4d6e8a1$var$Kd, $e6216febf4d6e8a1$var$Ld, $e6216febf4d6e8a1$var$Md, $e6216febf4d6e8a1$var$Od = $e6216febf4d6e8a1$var$u({}, $e6216febf4d6e8a1$var$Id, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e6216febf4d6e8a1$var$Nd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $e6216febf4d6e8a1$var$Md && ($e6216febf4d6e8a1$var$Md && "mousemove" === a.type ? ($e6216febf4d6e8a1$var$Kd = a.screenX - $e6216febf4d6e8a1$var$Md.screenX, $e6216febf4d6e8a1$var$Ld = a.screenY - $e6216febf4d6e8a1$var$Md.screenY) : $e6216febf4d6e8a1$var$Ld = $e6216febf4d6e8a1$var$Kd = 0, $e6216febf4d6e8a1$var$Md = a);
        return $e6216febf4d6e8a1$var$Kd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $e6216febf4d6e8a1$var$Ld;
    }
}), $e6216febf4d6e8a1$var$Pd = $e6216febf4d6e8a1$var$Fd($e6216febf4d6e8a1$var$Od), $e6216febf4d6e8a1$var$Qd = $e6216febf4d6e8a1$var$u({}, $e6216febf4d6e8a1$var$Od, {
    dataTransfer: 0
}), $e6216febf4d6e8a1$var$Rd = $e6216febf4d6e8a1$var$Fd($e6216febf4d6e8a1$var$Qd), $e6216febf4d6e8a1$var$Sd = $e6216febf4d6e8a1$var$u({}, $e6216febf4d6e8a1$var$Id, {
    relatedTarget: 0
}), $e6216febf4d6e8a1$var$Td = $e6216febf4d6e8a1$var$Fd($e6216febf4d6e8a1$var$Sd), $e6216febf4d6e8a1$var$Ud = $e6216febf4d6e8a1$var$u({}, $e6216febf4d6e8a1$var$Gd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e6216febf4d6e8a1$var$Vd = $e6216febf4d6e8a1$var$Fd($e6216febf4d6e8a1$var$Ud), $e6216febf4d6e8a1$var$Wd = $e6216febf4d6e8a1$var$u({}, $e6216febf4d6e8a1$var$Gd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $e6216febf4d6e8a1$var$Xd = $e6216febf4d6e8a1$var$Fd($e6216febf4d6e8a1$var$Wd), $e6216febf4d6e8a1$var$Yd = $e6216febf4d6e8a1$var$u({}, $e6216febf4d6e8a1$var$Gd, {
    data: 0
}), $e6216febf4d6e8a1$var$Zd = $e6216febf4d6e8a1$var$Fd($e6216febf4d6e8a1$var$Yd), $e6216febf4d6e8a1$var$$d = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e6216febf4d6e8a1$var$ae = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e6216febf4d6e8a1$var$be = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e6216febf4d6e8a1$var$ce(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $e6216febf4d6e8a1$var$be[a]) ? !!b[a] : !1;
}
function $e6216febf4d6e8a1$var$Nd() {
    return $e6216febf4d6e8a1$var$ce;
}
var $e6216febf4d6e8a1$var$de = $e6216febf4d6e8a1$var$u({}, $e6216febf4d6e8a1$var$Id, {
    key: function(a) {
        if (a.key) {
            var b = $e6216febf4d6e8a1$var$$d[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $e6216febf4d6e8a1$var$Cd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $e6216febf4d6e8a1$var$ae[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e6216febf4d6e8a1$var$Nd,
    charCode: function(a) {
        return "keypress" === a.type ? $e6216febf4d6e8a1$var$Cd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $e6216febf4d6e8a1$var$Cd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $e6216febf4d6e8a1$var$ee = $e6216febf4d6e8a1$var$Fd($e6216febf4d6e8a1$var$de), $e6216febf4d6e8a1$var$fe = $e6216febf4d6e8a1$var$u({}, $e6216febf4d6e8a1$var$Od, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e6216febf4d6e8a1$var$ge = $e6216febf4d6e8a1$var$Fd($e6216febf4d6e8a1$var$fe), $e6216febf4d6e8a1$var$he = $e6216febf4d6e8a1$var$u({}, $e6216febf4d6e8a1$var$Id, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e6216febf4d6e8a1$var$Nd
}), $e6216febf4d6e8a1$var$ie = $e6216febf4d6e8a1$var$Fd($e6216febf4d6e8a1$var$he), $e6216febf4d6e8a1$var$je = $e6216febf4d6e8a1$var$u({}, $e6216febf4d6e8a1$var$Gd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e6216febf4d6e8a1$var$ke = $e6216febf4d6e8a1$var$Fd($e6216febf4d6e8a1$var$je), $e6216febf4d6e8a1$var$le = $e6216febf4d6e8a1$var$u({}, $e6216febf4d6e8a1$var$Od, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e6216febf4d6e8a1$var$me = $e6216febf4d6e8a1$var$Fd($e6216febf4d6e8a1$var$le), $e6216febf4d6e8a1$var$ne = [
    9,
    13,
    27,
    32
], $e6216febf4d6e8a1$var$oe = $e6216febf4d6e8a1$var$ia && "CompositionEvent" in window, $e6216febf4d6e8a1$var$pe = null;
$e6216febf4d6e8a1$var$ia && "documentMode" in document && ($e6216febf4d6e8a1$var$pe = document.documentMode);
var $e6216febf4d6e8a1$var$qe = $e6216febf4d6e8a1$var$ia && "TextEvent" in window && !$e6216febf4d6e8a1$var$pe, $e6216febf4d6e8a1$var$re = $e6216febf4d6e8a1$var$ia && (!$e6216febf4d6e8a1$var$oe || $e6216febf4d6e8a1$var$pe && 8 < $e6216febf4d6e8a1$var$pe && 11 >= $e6216febf4d6e8a1$var$pe), $e6216febf4d6e8a1$var$se = String.fromCharCode(32), $e6216febf4d6e8a1$var$te = !1;
function $e6216febf4d6e8a1$var$ue(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $e6216febf4d6e8a1$var$ne.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e6216febf4d6e8a1$var$ve(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $e6216febf4d6e8a1$var$we = !1;
function $e6216febf4d6e8a1$var$xe(a, b) {
    switch(a){
        case "compositionend":
            return $e6216febf4d6e8a1$var$ve(b);
        case "keypress":
            if (32 !== b.which) return null;
            $e6216febf4d6e8a1$var$te = !0;
            return $e6216febf4d6e8a1$var$se;
        case "textInput":
            return a = b.data, a === $e6216febf4d6e8a1$var$se && $e6216febf4d6e8a1$var$te ? null : a;
        default:
            return null;
    }
}
function $e6216febf4d6e8a1$var$ye(a, b) {
    if ($e6216febf4d6e8a1$var$we) return "compositionend" === a || !$e6216febf4d6e8a1$var$oe && $e6216febf4d6e8a1$var$ue(a, b) ? (a = $e6216febf4d6e8a1$var$Bd(), $e6216febf4d6e8a1$var$Ad = $e6216febf4d6e8a1$var$zd = $e6216febf4d6e8a1$var$yd = null, $e6216febf4d6e8a1$var$we = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $e6216febf4d6e8a1$var$re && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $e6216febf4d6e8a1$var$ze = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e6216febf4d6e8a1$var$Ae(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$e6216febf4d6e8a1$var$ze[a.type] : "textarea" === b ? !0 : !1;
}
function $e6216febf4d6e8a1$var$Be(a, b, c, d) {
    $e6216febf4d6e8a1$var$Eb(d);
    b = $e6216febf4d6e8a1$var$Ce(b, "onChange");
    0 < b.length && (c = new $e6216febf4d6e8a1$var$Hd("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $e6216febf4d6e8a1$var$De = null, $e6216febf4d6e8a1$var$Ee = null;
function $e6216febf4d6e8a1$var$Fe(a) {
    $e6216febf4d6e8a1$var$Ge(a, 0);
}
function $e6216febf4d6e8a1$var$He(a) {
    var b = $e6216febf4d6e8a1$var$Ie(a);
    if ($e6216febf4d6e8a1$var$Wa(b)) return a;
}
function $e6216febf4d6e8a1$var$Je(a, b) {
    if ("change" === a) return b;
}
var $e6216febf4d6e8a1$var$Ke = !1;
if ($e6216febf4d6e8a1$var$ia) {
    var $e6216febf4d6e8a1$var$Le;
    if ($e6216febf4d6e8a1$var$ia) {
        var $e6216febf4d6e8a1$var$Me = "oninput" in document;
        if (!$e6216febf4d6e8a1$var$Me) {
            var $e6216febf4d6e8a1$var$Ne = document.createElement("div");
            $e6216febf4d6e8a1$var$Ne.setAttribute("oninput", "return;");
            $e6216febf4d6e8a1$var$Me = "function" === typeof $e6216febf4d6e8a1$var$Ne.oninput;
        }
        $e6216febf4d6e8a1$var$Le = $e6216febf4d6e8a1$var$Me;
    } else $e6216febf4d6e8a1$var$Le = !1;
    $e6216febf4d6e8a1$var$Ke = $e6216febf4d6e8a1$var$Le && (!document.documentMode || 9 < document.documentMode);
}
function $e6216febf4d6e8a1$var$Oe() {
    $e6216febf4d6e8a1$var$De && ($e6216febf4d6e8a1$var$De.detachEvent("onpropertychange", $e6216febf4d6e8a1$var$Pe), $e6216febf4d6e8a1$var$Ee = $e6216febf4d6e8a1$var$De = null);
}
function $e6216febf4d6e8a1$var$Pe(a) {
    if ("value" === a.propertyName && $e6216febf4d6e8a1$var$He($e6216febf4d6e8a1$var$Ee)) {
        var b = [];
        $e6216febf4d6e8a1$var$Be(b, $e6216febf4d6e8a1$var$Ee, a, $e6216febf4d6e8a1$var$xb(a));
        $e6216febf4d6e8a1$var$Jb($e6216febf4d6e8a1$var$Fe, b);
    }
}
function $e6216febf4d6e8a1$var$Qe(a, b, c) {
    "focusin" === a ? ($e6216febf4d6e8a1$var$Oe(), $e6216febf4d6e8a1$var$De = b, $e6216febf4d6e8a1$var$Ee = c, $e6216febf4d6e8a1$var$De.attachEvent("onpropertychange", $e6216febf4d6e8a1$var$Pe)) : "focusout" === a && $e6216febf4d6e8a1$var$Oe();
}
function $e6216febf4d6e8a1$var$Re(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $e6216febf4d6e8a1$var$He($e6216febf4d6e8a1$var$Ee);
}
function $e6216febf4d6e8a1$var$Se(a, b) {
    if ("click" === a) return $e6216febf4d6e8a1$var$He(b);
}
function $e6216febf4d6e8a1$var$Te(a, b) {
    if ("input" === a || "change" === a) return $e6216febf4d6e8a1$var$He(b);
}
function $e6216febf4d6e8a1$var$Ue(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e6216febf4d6e8a1$var$Ve = "function" === typeof Object.is ? Object.is : $e6216febf4d6e8a1$var$Ue;
function $e6216febf4d6e8a1$var$We(a, b) {
    if ($e6216febf4d6e8a1$var$Ve(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$e6216febf4d6e8a1$var$ja.call(b, e) || !$e6216febf4d6e8a1$var$Ve(a[e], b[e])) return !1;
    }
    return !0;
}
function $e6216febf4d6e8a1$var$Xe(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $e6216febf4d6e8a1$var$Ye(a, b) {
    var c = $e6216febf4d6e8a1$var$Xe(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $e6216febf4d6e8a1$var$Xe(c);
    }
}
function $e6216febf4d6e8a1$var$Ze(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $e6216febf4d6e8a1$var$Ze(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e6216febf4d6e8a1$var$$e() {
    for(var a = window, b = $e6216febf4d6e8a1$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $e6216febf4d6e8a1$var$Xa(a.document);
    }
    return b;
}
function $e6216febf4d6e8a1$var$af(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $e6216febf4d6e8a1$var$bf(a) {
    var b = $e6216febf4d6e8a1$var$$e(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $e6216febf4d6e8a1$var$Ze(c.ownerDocument.documentElement, c)) {
        if (null !== d && $e6216febf4d6e8a1$var$af(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $e6216febf4d6e8a1$var$Ye(c, f);
                var g = $e6216febf4d6e8a1$var$Ye(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $e6216febf4d6e8a1$var$cf = $e6216febf4d6e8a1$var$ia && "documentMode" in document && 11 >= document.documentMode, $e6216febf4d6e8a1$var$df = null, $e6216febf4d6e8a1$var$ef = null, $e6216febf4d6e8a1$var$ff = null, $e6216febf4d6e8a1$var$gf = !1;
function $e6216febf4d6e8a1$var$hf(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $e6216febf4d6e8a1$var$gf || null == $e6216febf4d6e8a1$var$df || $e6216febf4d6e8a1$var$df !== $e6216febf4d6e8a1$var$Xa(d) || (d = $e6216febf4d6e8a1$var$df, "selectionStart" in d && $e6216febf4d6e8a1$var$af(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $e6216febf4d6e8a1$var$ff && $e6216febf4d6e8a1$var$We($e6216febf4d6e8a1$var$ff, d) || ($e6216febf4d6e8a1$var$ff = d, d = $e6216febf4d6e8a1$var$Ce($e6216febf4d6e8a1$var$ef, "onSelect"), 0 < d.length && (b = new $e6216febf4d6e8a1$var$Hd("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $e6216febf4d6e8a1$var$df)));
}
function $e6216febf4d6e8a1$var$jf(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $e6216febf4d6e8a1$var$kf = {
    animationend: $e6216febf4d6e8a1$var$jf("Animation", "AnimationEnd"),
    animationiteration: $e6216febf4d6e8a1$var$jf("Animation", "AnimationIteration"),
    animationstart: $e6216febf4d6e8a1$var$jf("Animation", "AnimationStart"),
    transitionend: $e6216febf4d6e8a1$var$jf("Transition", "TransitionEnd")
}, $e6216febf4d6e8a1$var$lf = {}, $e6216febf4d6e8a1$var$mf = {};
$e6216febf4d6e8a1$var$ia && ($e6216febf4d6e8a1$var$mf = document.createElement("div").style, "AnimationEvent" in window || (delete $e6216febf4d6e8a1$var$kf.animationend.animation, delete $e6216febf4d6e8a1$var$kf.animationiteration.animation, delete $e6216febf4d6e8a1$var$kf.animationstart.animation), "TransitionEvent" in window || delete $e6216febf4d6e8a1$var$kf.transitionend.transition);
function $e6216febf4d6e8a1$var$nf(a) {
    if ($e6216febf4d6e8a1$var$lf[a]) return $e6216febf4d6e8a1$var$lf[a];
    if (!$e6216febf4d6e8a1$var$kf[a]) return a;
    var b = $e6216febf4d6e8a1$var$kf[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $e6216febf4d6e8a1$var$mf) return $e6216febf4d6e8a1$var$lf[a] = b[c];
    return a;
}
var $e6216febf4d6e8a1$var$of = $e6216febf4d6e8a1$var$nf("animationend"), $e6216febf4d6e8a1$var$pf = $e6216febf4d6e8a1$var$nf("animationiteration"), $e6216febf4d6e8a1$var$qf = $e6216febf4d6e8a1$var$nf("animationstart"), $e6216febf4d6e8a1$var$rf = $e6216febf4d6e8a1$var$nf("transitionend"), $e6216febf4d6e8a1$var$sf = new Map, $e6216febf4d6e8a1$var$tf = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $e6216febf4d6e8a1$var$uf(a, b) {
    $e6216febf4d6e8a1$var$sf.set(a, b);
    $e6216febf4d6e8a1$var$fa(b, [
        a
    ]);
}
for(var $e6216febf4d6e8a1$var$vf = 0; $e6216febf4d6e8a1$var$vf < $e6216febf4d6e8a1$var$tf.length; $e6216febf4d6e8a1$var$vf++){
    var $e6216febf4d6e8a1$var$wf = $e6216febf4d6e8a1$var$tf[$e6216febf4d6e8a1$var$vf], $e6216febf4d6e8a1$var$xf = $e6216febf4d6e8a1$var$wf.toLowerCase(), $e6216febf4d6e8a1$var$yf = $e6216febf4d6e8a1$var$wf[0].toUpperCase() + $e6216febf4d6e8a1$var$wf.slice(1);
    $e6216febf4d6e8a1$var$uf($e6216febf4d6e8a1$var$xf, "on" + $e6216febf4d6e8a1$var$yf);
}
$e6216febf4d6e8a1$var$uf($e6216febf4d6e8a1$var$of, "onAnimationEnd");
$e6216febf4d6e8a1$var$uf($e6216febf4d6e8a1$var$pf, "onAnimationIteration");
$e6216febf4d6e8a1$var$uf($e6216febf4d6e8a1$var$qf, "onAnimationStart");
$e6216febf4d6e8a1$var$uf("dblclick", "onDoubleClick");
$e6216febf4d6e8a1$var$uf("focusin", "onFocus");
$e6216febf4d6e8a1$var$uf("focusout", "onBlur");
$e6216febf4d6e8a1$var$uf($e6216febf4d6e8a1$var$rf, "onTransitionEnd");
$e6216febf4d6e8a1$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e6216febf4d6e8a1$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e6216febf4d6e8a1$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e6216febf4d6e8a1$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e6216febf4d6e8a1$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e6216febf4d6e8a1$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e6216febf4d6e8a1$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e6216febf4d6e8a1$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e6216febf4d6e8a1$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e6216febf4d6e8a1$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e6216febf4d6e8a1$var$zf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e6216febf4d6e8a1$var$Af = new Set("cancel close invalid load scroll toggle".split(" ").concat($e6216febf4d6e8a1$var$zf));
function $e6216febf4d6e8a1$var$Bf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $e6216febf4d6e8a1$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $e6216febf4d6e8a1$var$Ge(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e6216febf4d6e8a1$var$Bf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e6216febf4d6e8a1$var$Bf(e, h, l);
                f = k;
            }
        }
    }
    if ($e6216febf4d6e8a1$var$Qb) throw a = $e6216febf4d6e8a1$var$Rb, $e6216febf4d6e8a1$var$Qb = !1, $e6216febf4d6e8a1$var$Rb = null, a;
}
function $e6216febf4d6e8a1$var$F(a, b) {
    var c = b[$e6216febf4d6e8a1$var$Cf];
    void 0 === c && (c = b[$e6216febf4d6e8a1$var$Cf] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($e6216febf4d6e8a1$var$Df(b, a, 2, !1), c.add(d));
}
function $e6216febf4d6e8a1$var$Ef(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $e6216febf4d6e8a1$var$Df(c, a, d, b);
}
var $e6216febf4d6e8a1$var$Ff = "_reactListening" + Math.random().toString(36).slice(2);
function $e6216febf4d6e8a1$var$Gf(a) {
    if (!a[$e6216febf4d6e8a1$var$Ff]) {
        a[$e6216febf4d6e8a1$var$Ff] = !0;
        $e6216febf4d6e8a1$var$da.forEach(function(b) {
            "selectionchange" !== b && ($e6216febf4d6e8a1$var$Af.has(b) || $e6216febf4d6e8a1$var$Ef(b, !1, a), $e6216febf4d6e8a1$var$Ef(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$e6216febf4d6e8a1$var$Ff] || (b[$e6216febf4d6e8a1$var$Ff] = !0, $e6216febf4d6e8a1$var$Ef("selectionchange", !1, b));
    }
}
function $e6216febf4d6e8a1$var$Df(a, b, c, d) {
    switch($e6216febf4d6e8a1$var$xd(b)){
        case 1:
            var e = $e6216febf4d6e8a1$var$sd;
            break;
        case 4:
            e = $e6216febf4d6e8a1$var$ud;
            break;
        default:
            e = $e6216febf4d6e8a1$var$td;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$e6216febf4d6e8a1$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $e6216febf4d6e8a1$var$vd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $e6216febf4d6e8a1$var$jd(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $e6216febf4d6e8a1$var$Jb(function() {
        var d = f, e = $e6216febf4d6e8a1$var$xb(c), g = [];
        a: {
            var h = $e6216febf4d6e8a1$var$sf.get(a);
            if (void 0 !== h) {
                var k = $e6216febf4d6e8a1$var$Hd, m = a;
                switch(a){
                    case "keypress":
                        if (0 === $e6216febf4d6e8a1$var$Cd(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $e6216febf4d6e8a1$var$ee;
                        break;
                    case "focusin":
                        m = "focus";
                        k = $e6216febf4d6e8a1$var$Td;
                        break;
                    case "focusout":
                        m = "blur";
                        k = $e6216febf4d6e8a1$var$Td;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $e6216febf4d6e8a1$var$Td;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $e6216febf4d6e8a1$var$Pd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $e6216febf4d6e8a1$var$Rd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $e6216febf4d6e8a1$var$ie;
                        break;
                    case $e6216febf4d6e8a1$var$of:
                    case $e6216febf4d6e8a1$var$pf:
                    case $e6216febf4d6e8a1$var$qf:
                        k = $e6216febf4d6e8a1$var$Vd;
                        break;
                    case $e6216febf4d6e8a1$var$rf:
                        k = $e6216febf4d6e8a1$var$ke;
                        break;
                    case "scroll":
                        k = $e6216febf4d6e8a1$var$Jd;
                        break;
                    case "wheel":
                        k = $e6216febf4d6e8a1$var$me;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $e6216febf4d6e8a1$var$Xd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $e6216febf4d6e8a1$var$ge;
                }
                var w = 0 !== (b & 4), C = !w && "scroll" === a, x = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var y = d, v; null !== y;){
                    v = y;
                    var D = v.stateNode;
                    5 === v.tag && null !== D && (v = D, null !== x && (D = $e6216febf4d6e8a1$var$Kb(y, x), null != D && w.push($e6216febf4d6e8a1$var$Hf(y, D, v))));
                    if (C) break;
                    y = y.return;
                }
                0 < w.length && (h = new k(h, m, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $e6216febf4d6e8a1$var$wb && (m = c.relatedTarget || c.fromElement) && ($e6216febf4d6e8a1$var$jd(m) || m[$e6216febf4d6e8a1$var$If])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (m = c.relatedTarget || c.toElement, k = d, m = m ? $e6216febf4d6e8a1$var$jd(m) : null, null !== m && (C = $e6216febf4d6e8a1$var$Vb(m), m !== C || 5 !== m.tag && 6 !== m.tag)) m = null;
                    } else k = null, m = d;
                    if (k !== m) {
                        w = $e6216febf4d6e8a1$var$Pd;
                        D = "onMouseLeave";
                        x = "onMouseEnter";
                        y = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $e6216febf4d6e8a1$var$ge, D = "onPointerLeave", x = "onPointerEnter", y = "pointer";
                        C = null == k ? h : $e6216febf4d6e8a1$var$Ie(k);
                        v = null == m ? h : $e6216febf4d6e8a1$var$Ie(m);
                        h = new w(D, y + "leave", k, c, e);
                        h.target = C;
                        h.relatedTarget = v;
                        D = null;
                        $e6216febf4d6e8a1$var$jd(e) === d && (w = new w(x, y + "enter", m, c, e), w.target = v, w.relatedTarget = C, D = w);
                        C = D;
                        if (k && m) b: {
                            w = k;
                            x = m;
                            y = 0;
                            for(v = w; v; v = $e6216febf4d6e8a1$var$Jf(v))y++;
                            v = 0;
                            for(D = x; D; D = $e6216febf4d6e8a1$var$Jf(D))v++;
                            for(; 0 < y - v;)w = $e6216febf4d6e8a1$var$Jf(w), y--;
                            for(; 0 < v - y;)x = $e6216febf4d6e8a1$var$Jf(x), v--;
                            for(; y--;){
                                if (w === x || null !== x && w === x.alternate) break b;
                                w = $e6216febf4d6e8a1$var$Jf(w);
                                x = $e6216febf4d6e8a1$var$Jf(x);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $e6216febf4d6e8a1$var$Kf(g, h, k, w, !1);
                        null !== m && null !== C && $e6216febf4d6e8a1$var$Kf(g, C, m, w, !0);
                    }
                }
            }
            a: {
                h = d ? $e6216febf4d6e8a1$var$Ie(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var ca = $e6216febf4d6e8a1$var$Je;
                else if ($e6216febf4d6e8a1$var$Ae(h)) {
                    if ($e6216febf4d6e8a1$var$Ke) ca = $e6216febf4d6e8a1$var$Te;
                    else {
                        ca = $e6216febf4d6e8a1$var$Re;
                        var R = $e6216febf4d6e8a1$var$Qe;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (ca = $e6216febf4d6e8a1$var$Se);
                if (ca && (ca = ca(a, d))) {
                    $e6216febf4d6e8a1$var$Be(g, ca, c, e);
                    break a;
                }
                R && R(a, h, d);
                "focusout" === a && (R = h._wrapperState) && R.controlled && "number" === h.type && $e6216febf4d6e8a1$var$bb(h, "number", h.value);
            }
            R = d ? $e6216febf4d6e8a1$var$Ie(d) : window;
            switch(a){
                case "focusin":
                    if ($e6216febf4d6e8a1$var$Ae(R) || "true" === R.contentEditable) $e6216febf4d6e8a1$var$df = R, $e6216febf4d6e8a1$var$ef = d, $e6216febf4d6e8a1$var$ff = null;
                    break;
                case "focusout":
                    $e6216febf4d6e8a1$var$ff = $e6216febf4d6e8a1$var$ef = $e6216febf4d6e8a1$var$df = null;
                    break;
                case "mousedown":
                    $e6216febf4d6e8a1$var$gf = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e6216febf4d6e8a1$var$gf = !1;
                    $e6216febf4d6e8a1$var$hf(g, c, e);
                    break;
                case "selectionchange":
                    if ($e6216febf4d6e8a1$var$cf) break;
                case "keydown":
                case "keyup":
                    $e6216febf4d6e8a1$var$hf(g, c, e);
            }
            var sa;
            if ($e6216febf4d6e8a1$var$oe) b: {
                switch(a){
                    case "compositionstart":
                        var V = "onCompositionStart";
                        break b;
                    case "compositionend":
                        V = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        V = "onCompositionUpdate";
                        break b;
                }
                V = void 0;
            }
            else $e6216febf4d6e8a1$var$we ? $e6216febf4d6e8a1$var$ue(a, c) && (V = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (V = "onCompositionStart");
            V && ($e6216febf4d6e8a1$var$re && "ko" !== c.locale && ($e6216febf4d6e8a1$var$we || "onCompositionStart" !== V ? "onCompositionEnd" === V && $e6216febf4d6e8a1$var$we && (sa = $e6216febf4d6e8a1$var$Bd()) : ($e6216febf4d6e8a1$var$yd = e, $e6216febf4d6e8a1$var$zd = "value" in $e6216febf4d6e8a1$var$yd ? $e6216febf4d6e8a1$var$yd.value : $e6216febf4d6e8a1$var$yd.textContent, $e6216febf4d6e8a1$var$we = !0)), R = $e6216febf4d6e8a1$var$Ce(d, V), 0 < R.length && (V = new $e6216febf4d6e8a1$var$Zd(V, a, null, c, e), g.push({
                event: V,
                listeners: R
            }), sa ? V.data = sa : (sa = $e6216febf4d6e8a1$var$ve(c), null !== sa && (V.data = sa))));
            if (sa = $e6216febf4d6e8a1$var$qe ? $e6216febf4d6e8a1$var$xe(a, c) : $e6216febf4d6e8a1$var$ye(a, c)) d = $e6216febf4d6e8a1$var$Ce(d, "onBeforeInput"), 0 < d.length && (e = new $e6216febf4d6e8a1$var$Zd("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = sa);
        }
        $e6216febf4d6e8a1$var$Ge(g, b);
    });
}
function $e6216febf4d6e8a1$var$Hf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $e6216febf4d6e8a1$var$Ce(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $e6216febf4d6e8a1$var$Kb(a, c), null != f && d.unshift($e6216febf4d6e8a1$var$Hf(a, f, e)), f = $e6216febf4d6e8a1$var$Kb(a, b), null != f && d.push($e6216febf4d6e8a1$var$Hf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $e6216febf4d6e8a1$var$Jf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $e6216febf4d6e8a1$var$Kf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $e6216febf4d6e8a1$var$Kb(c, f), null != k && g.unshift($e6216febf4d6e8a1$var$Hf(c, k, h))) : e || (k = $e6216febf4d6e8a1$var$Kb(c, f), null != k && g.push($e6216febf4d6e8a1$var$Hf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $e6216febf4d6e8a1$var$Lf = /\r\n?/g, $e6216febf4d6e8a1$var$Mf = /\u0000|\uFFFD/g;
function $e6216febf4d6e8a1$var$Nf(a) {
    return ("string" === typeof a ? a : "" + a).replace($e6216febf4d6e8a1$var$Lf, "\n").replace($e6216febf4d6e8a1$var$Mf, "");
}
function $e6216febf4d6e8a1$var$Of(a, b, c) {
    b = $e6216febf4d6e8a1$var$Nf(b);
    if ($e6216febf4d6e8a1$var$Nf(a) !== b && c) throw Error($e6216febf4d6e8a1$var$p(425));
}
function $e6216febf4d6e8a1$var$Pf() {}
var $e6216febf4d6e8a1$var$Qf = null, $e6216febf4d6e8a1$var$Rf = null;
function $e6216febf4d6e8a1$var$Sf(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $e6216febf4d6e8a1$var$Tf = "function" === typeof setTimeout ? setTimeout : void 0, $e6216febf4d6e8a1$var$Uf = "function" === typeof clearTimeout ? clearTimeout : void 0, $e6216febf4d6e8a1$var$Vf = "function" === typeof Promise ? Promise : void 0, $e6216febf4d6e8a1$var$Xf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e6216febf4d6e8a1$var$Vf ? function(a) {
    return $e6216febf4d6e8a1$var$Vf.resolve(null).then(a).catch($e6216febf4d6e8a1$var$Wf);
} : $e6216febf4d6e8a1$var$Tf;
function $e6216febf4d6e8a1$var$Wf(a) {
    setTimeout(function() {
        throw a;
    });
}
function $e6216febf4d6e8a1$var$Yf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $e6216febf4d6e8a1$var$pd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $e6216febf4d6e8a1$var$pd(b);
}
function $e6216febf4d6e8a1$var$Zf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $e6216febf4d6e8a1$var$$f(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $e6216febf4d6e8a1$var$ag = Math.random().toString(36).slice(2), $e6216febf4d6e8a1$var$bg = "__reactFiber$" + $e6216febf4d6e8a1$var$ag, $e6216febf4d6e8a1$var$cg = "__reactProps$" + $e6216febf4d6e8a1$var$ag, $e6216febf4d6e8a1$var$If = "__reactContainer$" + $e6216febf4d6e8a1$var$ag, $e6216febf4d6e8a1$var$Cf = "__reactEvents$" + $e6216febf4d6e8a1$var$ag, $e6216febf4d6e8a1$var$dg = "__reactListeners$" + $e6216febf4d6e8a1$var$ag, $e6216febf4d6e8a1$var$eg = "__reactHandles$" + $e6216febf4d6e8a1$var$ag;
function $e6216febf4d6e8a1$var$jd(a) {
    var b = a[$e6216febf4d6e8a1$var$bg];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$e6216febf4d6e8a1$var$If] || c[$e6216febf4d6e8a1$var$bg]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $e6216febf4d6e8a1$var$$f(a); null !== a;){
                if (c = a[$e6216febf4d6e8a1$var$bg]) return c;
                a = $e6216febf4d6e8a1$var$$f(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $e6216febf4d6e8a1$var$Cb(a) {
    a = a[$e6216febf4d6e8a1$var$bg] || a[$e6216febf4d6e8a1$var$If];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $e6216febf4d6e8a1$var$Ie(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($e6216febf4d6e8a1$var$p(33));
}
function $e6216febf4d6e8a1$var$Db(a) {
    return a[$e6216febf4d6e8a1$var$cg] || null;
}
var $e6216febf4d6e8a1$var$fg = [], $e6216febf4d6e8a1$var$gg = -1;
function $e6216febf4d6e8a1$var$hg(a) {
    return {
        current: a
    };
}
function $e6216febf4d6e8a1$var$G(a) {
    0 > $e6216febf4d6e8a1$var$gg || (a.current = $e6216febf4d6e8a1$var$fg[$e6216febf4d6e8a1$var$gg], $e6216febf4d6e8a1$var$fg[$e6216febf4d6e8a1$var$gg] = null, $e6216febf4d6e8a1$var$gg--);
}
function $e6216febf4d6e8a1$var$H(a, b) {
    $e6216febf4d6e8a1$var$gg++;
    $e6216febf4d6e8a1$var$fg[$e6216febf4d6e8a1$var$gg] = a.current;
    a.current = b;
}
var $e6216febf4d6e8a1$var$ig = {}, $e6216febf4d6e8a1$var$I = $e6216febf4d6e8a1$var$hg($e6216febf4d6e8a1$var$ig), $e6216febf4d6e8a1$var$jg = $e6216febf4d6e8a1$var$hg(!1), $e6216febf4d6e8a1$var$kg = $e6216febf4d6e8a1$var$ig;
function $e6216febf4d6e8a1$var$lg(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $e6216febf4d6e8a1$var$ig;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $e6216febf4d6e8a1$var$mg(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $e6216febf4d6e8a1$var$ng() {
    $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$jg);
    $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$I);
}
function $e6216febf4d6e8a1$var$og(a, b, c) {
    if ($e6216febf4d6e8a1$var$I.current !== $e6216febf4d6e8a1$var$ig) throw Error($e6216febf4d6e8a1$var$p(168));
    $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$I, b);
    $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$jg, c);
}
function $e6216febf4d6e8a1$var$pg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($e6216febf4d6e8a1$var$p(108, $e6216febf4d6e8a1$var$Ra(a) || "Unknown", e));
    return $e6216febf4d6e8a1$var$u({}, c, d);
}
function $e6216febf4d6e8a1$var$qg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $e6216febf4d6e8a1$var$ig;
    $e6216febf4d6e8a1$var$kg = $e6216febf4d6e8a1$var$I.current;
    $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$I, a);
    $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$jg, $e6216febf4d6e8a1$var$jg.current);
    return !0;
}
function $e6216febf4d6e8a1$var$rg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($e6216febf4d6e8a1$var$p(169));
    c ? (a = $e6216febf4d6e8a1$var$pg(a, b, $e6216febf4d6e8a1$var$kg), d.__reactInternalMemoizedMergedChildContext = a, $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$jg), $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$I), $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$I, a)) : $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$jg);
    $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$jg, c);
}
var $e6216febf4d6e8a1$var$sg = null, $e6216febf4d6e8a1$var$tg = !1, $e6216febf4d6e8a1$var$ug = !1;
function $e6216febf4d6e8a1$var$vg(a) {
    null === $e6216febf4d6e8a1$var$sg ? $e6216febf4d6e8a1$var$sg = [
        a
    ] : $e6216febf4d6e8a1$var$sg.push(a);
}
function $e6216febf4d6e8a1$var$wg(a) {
    $e6216febf4d6e8a1$var$tg = !0;
    $e6216febf4d6e8a1$var$vg(a);
}
function $e6216febf4d6e8a1$var$xg() {
    if (!$e6216febf4d6e8a1$var$ug && null !== $e6216febf4d6e8a1$var$sg) {
        $e6216febf4d6e8a1$var$ug = !0;
        var a = 0, b = $e6216febf4d6e8a1$var$E;
        try {
            var c = $e6216febf4d6e8a1$var$sg;
            for($e6216febf4d6e8a1$var$E = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $e6216febf4d6e8a1$var$sg = null;
            $e6216febf4d6e8a1$var$tg = !1;
        } catch (e) {
            throw null !== $e6216febf4d6e8a1$var$sg && ($e6216febf4d6e8a1$var$sg = $e6216febf4d6e8a1$var$sg.slice(a + 1)), $e6216febf4d6e8a1$var$ac($e6216febf4d6e8a1$var$fc, $e6216febf4d6e8a1$var$xg), e;
        } finally{
            $e6216febf4d6e8a1$var$E = b, $e6216febf4d6e8a1$var$ug = !1;
        }
    }
    return null;
}
var $e6216febf4d6e8a1$var$yg = [], $e6216febf4d6e8a1$var$zg = 0, $e6216febf4d6e8a1$var$Ag = null, $e6216febf4d6e8a1$var$Bg = 0, $e6216febf4d6e8a1$var$Cg = [], $e6216febf4d6e8a1$var$Dg = 0, $e6216febf4d6e8a1$var$Eg = null, $e6216febf4d6e8a1$var$Fg = 1, $e6216febf4d6e8a1$var$Gg = "";
function $e6216febf4d6e8a1$var$Hg(a, b) {
    $e6216febf4d6e8a1$var$yg[$e6216febf4d6e8a1$var$zg++] = $e6216febf4d6e8a1$var$Bg;
    $e6216febf4d6e8a1$var$yg[$e6216febf4d6e8a1$var$zg++] = $e6216febf4d6e8a1$var$Ag;
    $e6216febf4d6e8a1$var$Ag = a;
    $e6216febf4d6e8a1$var$Bg = b;
}
function $e6216febf4d6e8a1$var$Ig(a, b, c) {
    $e6216febf4d6e8a1$var$Cg[$e6216febf4d6e8a1$var$Dg++] = $e6216febf4d6e8a1$var$Fg;
    $e6216febf4d6e8a1$var$Cg[$e6216febf4d6e8a1$var$Dg++] = $e6216febf4d6e8a1$var$Gg;
    $e6216febf4d6e8a1$var$Cg[$e6216febf4d6e8a1$var$Dg++] = $e6216febf4d6e8a1$var$Eg;
    $e6216febf4d6e8a1$var$Eg = a;
    var d = $e6216febf4d6e8a1$var$Fg;
    a = $e6216febf4d6e8a1$var$Gg;
    var e = 32 - $e6216febf4d6e8a1$var$Ac(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $e6216febf4d6e8a1$var$Ac(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $e6216febf4d6e8a1$var$Fg = 1 << 32 - $e6216febf4d6e8a1$var$Ac(b) + e | c << e | d;
        $e6216febf4d6e8a1$var$Gg = f + a;
    } else $e6216febf4d6e8a1$var$Fg = 1 << f | c << e | d, $e6216febf4d6e8a1$var$Gg = a;
}
function $e6216febf4d6e8a1$var$Jg(a) {
    null !== a.return && ($e6216febf4d6e8a1$var$Hg(a, 1), $e6216febf4d6e8a1$var$Ig(a, 1, 0));
}
function $e6216febf4d6e8a1$var$Kg(a) {
    for(; a === $e6216febf4d6e8a1$var$Ag;)$e6216febf4d6e8a1$var$Ag = $e6216febf4d6e8a1$var$yg[--$e6216febf4d6e8a1$var$zg], $e6216febf4d6e8a1$var$yg[$e6216febf4d6e8a1$var$zg] = null, $e6216febf4d6e8a1$var$Bg = $e6216febf4d6e8a1$var$yg[--$e6216febf4d6e8a1$var$zg], $e6216febf4d6e8a1$var$yg[$e6216febf4d6e8a1$var$zg] = null;
    for(; a === $e6216febf4d6e8a1$var$Eg;)$e6216febf4d6e8a1$var$Eg = $e6216febf4d6e8a1$var$Cg[--$e6216febf4d6e8a1$var$Dg], $e6216febf4d6e8a1$var$Cg[$e6216febf4d6e8a1$var$Dg] = null, $e6216febf4d6e8a1$var$Gg = $e6216febf4d6e8a1$var$Cg[--$e6216febf4d6e8a1$var$Dg], $e6216febf4d6e8a1$var$Cg[$e6216febf4d6e8a1$var$Dg] = null, $e6216febf4d6e8a1$var$Fg = $e6216febf4d6e8a1$var$Cg[--$e6216febf4d6e8a1$var$Dg], $e6216febf4d6e8a1$var$Cg[$e6216febf4d6e8a1$var$Dg] = null;
}
var $e6216febf4d6e8a1$var$Lg = null, $e6216febf4d6e8a1$var$Mg = null, $e6216febf4d6e8a1$var$J = !1, $e6216febf4d6e8a1$var$Ng = null;
function $e6216febf4d6e8a1$var$Og(a, b) {
    var c = $e6216febf4d6e8a1$var$Pg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $e6216febf4d6e8a1$var$Qg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $e6216febf4d6e8a1$var$Lg = a, $e6216febf4d6e8a1$var$Mg = $e6216febf4d6e8a1$var$Zf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $e6216febf4d6e8a1$var$Lg = a, $e6216febf4d6e8a1$var$Mg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $e6216febf4d6e8a1$var$Eg ? {
                id: $e6216febf4d6e8a1$var$Fg,
                overflow: $e6216febf4d6e8a1$var$Gg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $e6216febf4d6e8a1$var$Pg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $e6216febf4d6e8a1$var$Lg = a, $e6216febf4d6e8a1$var$Mg = null, !0) : !1;
        default:
            return !1;
    }
}
function $e6216febf4d6e8a1$var$Rg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $e6216febf4d6e8a1$var$Sg(a) {
    if ($e6216febf4d6e8a1$var$J) {
        var b = $e6216febf4d6e8a1$var$Mg;
        if (b) {
            var c = b;
            if (!$e6216febf4d6e8a1$var$Qg(a, b)) {
                if ($e6216febf4d6e8a1$var$Rg(a)) throw Error($e6216febf4d6e8a1$var$p(418));
                b = $e6216febf4d6e8a1$var$Zf(c.nextSibling);
                var d = $e6216febf4d6e8a1$var$Lg;
                b && $e6216febf4d6e8a1$var$Qg(a, b) ? $e6216febf4d6e8a1$var$Og(d, c) : (a.flags = a.flags & -4097 | 2, $e6216febf4d6e8a1$var$J = !1, $e6216febf4d6e8a1$var$Lg = a);
            }
        } else {
            if ($e6216febf4d6e8a1$var$Rg(a)) throw Error($e6216febf4d6e8a1$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $e6216febf4d6e8a1$var$J = !1;
            $e6216febf4d6e8a1$var$Lg = a;
        }
    }
}
function $e6216febf4d6e8a1$var$Tg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $e6216febf4d6e8a1$var$Lg = a;
}
function $e6216febf4d6e8a1$var$Ug(a) {
    if (a !== $e6216febf4d6e8a1$var$Lg) return !1;
    if (!$e6216febf4d6e8a1$var$J) return $e6216febf4d6e8a1$var$Tg(a), $e6216febf4d6e8a1$var$J = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$e6216febf4d6e8a1$var$Sf(a.type, a.memoizedProps));
    if (b && (b = $e6216febf4d6e8a1$var$Mg)) {
        if ($e6216febf4d6e8a1$var$Rg(a)) throw $e6216febf4d6e8a1$var$Vg(), Error($e6216febf4d6e8a1$var$p(418));
        for(; b;)$e6216febf4d6e8a1$var$Og(a, b), b = $e6216febf4d6e8a1$var$Zf(b.nextSibling);
    }
    $e6216febf4d6e8a1$var$Tg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($e6216febf4d6e8a1$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $e6216febf4d6e8a1$var$Mg = $e6216febf4d6e8a1$var$Zf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $e6216febf4d6e8a1$var$Mg = null;
        }
    } else $e6216febf4d6e8a1$var$Mg = $e6216febf4d6e8a1$var$Lg ? $e6216febf4d6e8a1$var$Zf(a.stateNode.nextSibling) : null;
    return !0;
}
function $e6216febf4d6e8a1$var$Vg() {
    for(var a = $e6216febf4d6e8a1$var$Mg; a;)a = $e6216febf4d6e8a1$var$Zf(a.nextSibling);
}
function $e6216febf4d6e8a1$var$Wg() {
    $e6216febf4d6e8a1$var$Mg = $e6216febf4d6e8a1$var$Lg = null;
    $e6216febf4d6e8a1$var$J = !1;
}
function $e6216febf4d6e8a1$var$Xg(a) {
    null === $e6216febf4d6e8a1$var$Ng ? $e6216febf4d6e8a1$var$Ng = [
        a
    ] : $e6216febf4d6e8a1$var$Ng.push(a);
}
var $e6216febf4d6e8a1$var$Yg = $e6216febf4d6e8a1$var$va.ReactCurrentBatchConfig;
function $e6216febf4d6e8a1$var$Zg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($e6216febf4d6e8a1$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($e6216febf4d6e8a1$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($e6216febf4d6e8a1$var$p(284));
        if (!c._owner) throw Error($e6216febf4d6e8a1$var$p(290, a));
    }
    return a;
}
function $e6216febf4d6e8a1$var$$g(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($e6216febf4d6e8a1$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $e6216febf4d6e8a1$var$ah(a) {
    var b = a._init;
    return b(a._payload);
}
function $e6216febf4d6e8a1$var$bh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $e6216febf4d6e8a1$var$ch(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $e6216febf4d6e8a1$var$dh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $e6216febf4d6e8a1$var$ya) return n(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $e6216febf4d6e8a1$var$Ha && $e6216febf4d6e8a1$var$ah(f) === b.type)) return d = e(b, c.props), d.ref = $e6216febf4d6e8a1$var$Zg(a, b, c), d.return = a, d;
        d = $e6216febf4d6e8a1$var$eh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $e6216febf4d6e8a1$var$Zg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $e6216febf4d6e8a1$var$fh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $e6216febf4d6e8a1$var$gh(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $e6216febf4d6e8a1$var$dh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $e6216febf4d6e8a1$var$wa:
                    return c = $e6216febf4d6e8a1$var$eh(b.type, b.key, b.props, null, a.mode, c), c.ref = $e6216febf4d6e8a1$var$Zg(a, null, b), c.return = a, c;
                case $e6216febf4d6e8a1$var$xa:
                    return b = $e6216febf4d6e8a1$var$fh(b, a.mode, c), b.return = a, b;
                case $e6216febf4d6e8a1$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($e6216febf4d6e8a1$var$db(b) || $e6216febf4d6e8a1$var$Ka(b)) return b = $e6216febf4d6e8a1$var$gh(b, a.mode, c, null), b.return = a, b;
            $e6216febf4d6e8a1$var$$g(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $e6216febf4d6e8a1$var$wa:
                    return c.key === e ? k(a, b, c, d) : null;
                case $e6216febf4d6e8a1$var$xa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $e6216febf4d6e8a1$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($e6216febf4d6e8a1$var$db(c) || $e6216febf4d6e8a1$var$Ka(c)) return null !== e ? null : n(a, b, c, d, null);
            $e6216febf4d6e8a1$var$$g(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $e6216febf4d6e8a1$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $e6216febf4d6e8a1$var$xa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $e6216febf4d6e8a1$var$Ha:
                    var f = d._init;
                    return z(a, b, c, f(d._payload), e);
            }
            if ($e6216febf4d6e8a1$var$db(d) || $e6216febf4d6e8a1$var$Ka(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $e6216febf4d6e8a1$var$$g(b, d);
        }
        return null;
    }
    function m(e, g, h, k) {
        for(var l = null, v = null, n = g, m = g = 0, y = null; null !== n && m < h.length; m++){
            n.index > m ? (y = n, n = null) : y = n.sibling;
            var x = r(e, n, h[m], k);
            if (null === x) {
                null === n && (n = y);
                break;
            }
            a && n && null === x.alternate && b(e, n);
            g = f(x, g, m);
            null === v ? l = x : v.sibling = x;
            v = x;
            n = y;
        }
        if (m === h.length) return c(e, n), $e6216febf4d6e8a1$var$J && $e6216febf4d6e8a1$var$Hg(e, m), l;
        if (null === n) {
            for(; m < h.length; m++)n = q(e, h[m], k), null !== n && (g = f(n, g, m), null === v ? l = n : v.sibling = n, v = n);
            $e6216febf4d6e8a1$var$J && $e6216febf4d6e8a1$var$Hg(e, m);
            return l;
        }
        for(n = d(e, n); m < h.length; m++)y = z(n, e, m, h[m], k), null !== y && (a && null !== y.alternate && n.delete(null === y.key ? m : y.key), g = f(y, g, m), null === v ? l = y : v.sibling = y, v = y);
        a && n.forEach(function(a) {
            return b(e, a);
        });
        $e6216febf4d6e8a1$var$J && $e6216febf4d6e8a1$var$Hg(e, m);
        return l;
    }
    function w(e, g, h, k) {
        var l = $e6216febf4d6e8a1$var$Ka(h);
        if ("function" !== typeof l) throw Error($e6216febf4d6e8a1$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($e6216febf4d6e8a1$var$p(151));
        for(var n = l = null, m = g, v = g = 0, y = null, x = h.next(); null !== m && !x.done; v++, x = h.next()){
            m.index > v ? (y = m, m = null) : y = m.sibling;
            var w = r(e, m, x.value, k);
            if (null === w) {
                null === m && (m = y);
                break;
            }
            a && m && null === w.alternate && b(e, m);
            g = f(w, g, v);
            null === n ? l = w : n.sibling = w;
            n = w;
            m = y;
        }
        if (x.done) return c(e, m), $e6216febf4d6e8a1$var$J && $e6216febf4d6e8a1$var$Hg(e, v), l;
        if (null === m) {
            for(; !x.done; v++, x = h.next())x = q(e, x.value, k), null !== x && (g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
            $e6216febf4d6e8a1$var$J && $e6216febf4d6e8a1$var$Hg(e, v);
            return l;
        }
        for(m = d(e, m); !x.done; v++, x = h.next())x = z(m, e, v, x.value, k), null !== x && (a && null !== x.alternate && m.delete(null === x.key ? v : x.key), g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $e6216febf4d6e8a1$var$J && $e6216febf4d6e8a1$var$Hg(e, v);
        return l;
    }
    function C(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $e6216febf4d6e8a1$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $e6216febf4d6e8a1$var$wa:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $e6216febf4d6e8a1$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $e6216febf4d6e8a1$var$Ha && $e6216febf4d6e8a1$var$ah(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $e6216febf4d6e8a1$var$Zg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $e6216febf4d6e8a1$var$ya ? (d = $e6216febf4d6e8a1$var$gh(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e6216febf4d6e8a1$var$eh(f.type, f.key, f.props, null, a.mode, h), h.ref = $e6216febf4d6e8a1$var$Zg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $e6216febf4d6e8a1$var$xa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $e6216febf4d6e8a1$var$fh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $e6216febf4d6e8a1$var$Ha:
                    return l = f._init, C(a, d, l(f._payload), h);
            }
            if ($e6216febf4d6e8a1$var$db(f)) return m(a, d, f, h);
            if ($e6216febf4d6e8a1$var$Ka(f)) return w(a, d, f, h);
            $e6216febf4d6e8a1$var$$g(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $e6216febf4d6e8a1$var$dh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return C;
}
var $e6216febf4d6e8a1$var$hh = $e6216febf4d6e8a1$var$bh(!0), $e6216febf4d6e8a1$var$ih = $e6216febf4d6e8a1$var$bh(!1), $e6216febf4d6e8a1$var$jh = $e6216febf4d6e8a1$var$hg(null), $e6216febf4d6e8a1$var$kh = null, $e6216febf4d6e8a1$var$lh = null, $e6216febf4d6e8a1$var$mh = null;
function $e6216febf4d6e8a1$var$nh() {
    $e6216febf4d6e8a1$var$mh = $e6216febf4d6e8a1$var$lh = $e6216febf4d6e8a1$var$kh = null;
}
function $e6216febf4d6e8a1$var$oh(a) {
    var b = $e6216febf4d6e8a1$var$jh.current;
    $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$jh);
    a._currentValue = b;
}
function $e6216febf4d6e8a1$var$ph(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $e6216febf4d6e8a1$var$qh(a, b) {
    $e6216febf4d6e8a1$var$kh = a;
    $e6216febf4d6e8a1$var$mh = $e6216febf4d6e8a1$var$lh = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($e6216febf4d6e8a1$var$rh = !0), a.firstContext = null);
}
function $e6216febf4d6e8a1$var$sh(a) {
    var b = a._currentValue;
    if ($e6216febf4d6e8a1$var$mh !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $e6216febf4d6e8a1$var$lh) {
            if (null === $e6216febf4d6e8a1$var$kh) throw Error($e6216febf4d6e8a1$var$p(308));
            $e6216febf4d6e8a1$var$lh = a;
            $e6216febf4d6e8a1$var$kh.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $e6216febf4d6e8a1$var$lh = $e6216febf4d6e8a1$var$lh.next = a;
    }
    return b;
}
var $e6216febf4d6e8a1$var$th = null;
function $e6216febf4d6e8a1$var$uh(a) {
    null === $e6216febf4d6e8a1$var$th ? $e6216febf4d6e8a1$var$th = [
        a
    ] : $e6216febf4d6e8a1$var$th.push(a);
}
function $e6216febf4d6e8a1$var$vh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $e6216febf4d6e8a1$var$uh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $e6216febf4d6e8a1$var$wh(a, d);
}
function $e6216febf4d6e8a1$var$wh(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $e6216febf4d6e8a1$var$xh = !1;
function $e6216febf4d6e8a1$var$yh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $e6216febf4d6e8a1$var$zh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $e6216febf4d6e8a1$var$Ah(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e6216febf4d6e8a1$var$Bh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($e6216febf4d6e8a1$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $e6216febf4d6e8a1$var$wh(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $e6216febf4d6e8a1$var$uh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $e6216febf4d6e8a1$var$wh(a, c);
}
function $e6216febf4d6e8a1$var$Ch(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e6216febf4d6e8a1$var$Oc(a, c);
    }
}
function $e6216febf4d6e8a1$var$Dh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $e6216febf4d6e8a1$var$Eh(a, b, c, d) {
    var e = a.updateQueue;
    $e6216febf4d6e8a1$var$xh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        n = l = k = null;
        h = f;
        do {
            var r = h.lane, z = h.eventTime;
            if ((d & r) === r) {
                null !== n && (n = n.next = {
                    eventTime: z,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var m = a, w = h;
                    r = b;
                    z = c;
                    switch(w.tag){
                        case 1:
                            m = w.payload;
                            if ("function" === typeof m) {
                                q = m.call(z, q, r);
                                break a;
                            }
                            q = m;
                            break a;
                        case 3:
                            m.flags = m.flags & -65537 | 128;
                        case 0:
                            m = w.payload;
                            r = "function" === typeof m ? m.call(z, q, r) : m;
                            if (null === r || void 0 === r) break a;
                            q = $e6216febf4d6e8a1$var$u({}, q, r);
                            break a;
                        case 2:
                            $e6216febf4d6e8a1$var$xh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else z = {
                eventTime: z,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === n ? (l = n = z, k = q) : n = n.next = z, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $e6216febf4d6e8a1$var$Fh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $e6216febf4d6e8a1$var$Gh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($e6216febf4d6e8a1$var$p(191, e));
            e.call(d);
        }
    }
}
var $e6216febf4d6e8a1$var$Hh = {}, $e6216febf4d6e8a1$var$Ih = $e6216febf4d6e8a1$var$hg($e6216febf4d6e8a1$var$Hh), $e6216febf4d6e8a1$var$Jh = $e6216febf4d6e8a1$var$hg($e6216febf4d6e8a1$var$Hh), $e6216febf4d6e8a1$var$Kh = $e6216febf4d6e8a1$var$hg($e6216febf4d6e8a1$var$Hh);
function $e6216febf4d6e8a1$var$Lh(a) {
    if (a === $e6216febf4d6e8a1$var$Hh) throw Error($e6216febf4d6e8a1$var$p(174));
    return a;
}
function $e6216febf4d6e8a1$var$Mh(a, b) {
    $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$Kh, b);
    $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$Jh, a);
    $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$Ih, $e6216febf4d6e8a1$var$Hh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $e6216febf4d6e8a1$var$kb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $e6216febf4d6e8a1$var$kb(b, a);
    }
    $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$Ih);
    $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$Ih, b);
}
function $e6216febf4d6e8a1$var$Nh() {
    $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$Ih);
    $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$Jh);
    $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$Kh);
}
function $e6216febf4d6e8a1$var$Oh(a) {
    $e6216febf4d6e8a1$var$Lh($e6216febf4d6e8a1$var$Kh.current);
    var b = $e6216febf4d6e8a1$var$Lh($e6216febf4d6e8a1$var$Ih.current);
    var c = $e6216febf4d6e8a1$var$kb(b, a.type);
    b !== c && ($e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$Jh, a), $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$Ih, c));
}
function $e6216febf4d6e8a1$var$Ph(a) {
    $e6216febf4d6e8a1$var$Jh.current === a && ($e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$Ih), $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$Jh));
}
var $e6216febf4d6e8a1$var$L = $e6216febf4d6e8a1$var$hg(0);
function $e6216febf4d6e8a1$var$Qh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $e6216febf4d6e8a1$var$Rh = [];
function $e6216febf4d6e8a1$var$Sh() {
    for(var a = 0; a < $e6216febf4d6e8a1$var$Rh.length; a++)$e6216febf4d6e8a1$var$Rh[a]._workInProgressVersionPrimary = null;
    $e6216febf4d6e8a1$var$Rh.length = 0;
}
var $e6216febf4d6e8a1$var$Th = $e6216febf4d6e8a1$var$va.ReactCurrentDispatcher, $e6216febf4d6e8a1$var$Uh = $e6216febf4d6e8a1$var$va.ReactCurrentBatchConfig, $e6216febf4d6e8a1$var$Vh = 0, $e6216febf4d6e8a1$var$M = null, $e6216febf4d6e8a1$var$N = null, $e6216febf4d6e8a1$var$O = null, $e6216febf4d6e8a1$var$Wh = !1, $e6216febf4d6e8a1$var$Xh = !1, $e6216febf4d6e8a1$var$Yh = 0, $e6216febf4d6e8a1$var$Zh = 0;
function $e6216febf4d6e8a1$var$P() {
    throw Error($e6216febf4d6e8a1$var$p(321));
}
function $e6216febf4d6e8a1$var$$h(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e6216febf4d6e8a1$var$Ve(a[c], b[c])) return !1;
    return !0;
}
function $e6216febf4d6e8a1$var$ai(a, b, c, d, e, f) {
    $e6216febf4d6e8a1$var$Vh = f;
    $e6216febf4d6e8a1$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $e6216febf4d6e8a1$var$Th.current = null === a || null === a.memoizedState ? $e6216febf4d6e8a1$var$bi : $e6216febf4d6e8a1$var$ci;
    a = c(d, e);
    if ($e6216febf4d6e8a1$var$Xh) {
        f = 0;
        do {
            $e6216febf4d6e8a1$var$Xh = !1;
            $e6216febf4d6e8a1$var$Yh = 0;
            if (25 <= f) throw Error($e6216febf4d6e8a1$var$p(301));
            f += 1;
            $e6216febf4d6e8a1$var$O = $e6216febf4d6e8a1$var$N = null;
            b.updateQueue = null;
            $e6216febf4d6e8a1$var$Th.current = $e6216febf4d6e8a1$var$di;
            a = c(d, e);
        }while ($e6216febf4d6e8a1$var$Xh);
    }
    $e6216febf4d6e8a1$var$Th.current = $e6216febf4d6e8a1$var$ei;
    b = null !== $e6216febf4d6e8a1$var$N && null !== $e6216febf4d6e8a1$var$N.next;
    $e6216febf4d6e8a1$var$Vh = 0;
    $e6216febf4d6e8a1$var$O = $e6216febf4d6e8a1$var$N = $e6216febf4d6e8a1$var$M = null;
    $e6216febf4d6e8a1$var$Wh = !1;
    if (b) throw Error($e6216febf4d6e8a1$var$p(300));
    return a;
}
function $e6216febf4d6e8a1$var$fi() {
    var a = 0 !== $e6216febf4d6e8a1$var$Yh;
    $e6216febf4d6e8a1$var$Yh = 0;
    return a;
}
function $e6216febf4d6e8a1$var$gi() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e6216febf4d6e8a1$var$O ? $e6216febf4d6e8a1$var$M.memoizedState = $e6216febf4d6e8a1$var$O = a : $e6216febf4d6e8a1$var$O = $e6216febf4d6e8a1$var$O.next = a;
    return $e6216febf4d6e8a1$var$O;
}
function $e6216febf4d6e8a1$var$hi() {
    if (null === $e6216febf4d6e8a1$var$N) {
        var a = $e6216febf4d6e8a1$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $e6216febf4d6e8a1$var$N.next;
    var b = null === $e6216febf4d6e8a1$var$O ? $e6216febf4d6e8a1$var$M.memoizedState : $e6216febf4d6e8a1$var$O.next;
    if (null !== b) $e6216febf4d6e8a1$var$O = b, $e6216febf4d6e8a1$var$N = a;
    else {
        if (null === a) throw Error($e6216febf4d6e8a1$var$p(310));
        $e6216febf4d6e8a1$var$N = a;
        a = {
            memoizedState: $e6216febf4d6e8a1$var$N.memoizedState,
            baseState: $e6216febf4d6e8a1$var$N.baseState,
            baseQueue: $e6216febf4d6e8a1$var$N.baseQueue,
            queue: $e6216febf4d6e8a1$var$N.queue,
            next: null
        };
        null === $e6216febf4d6e8a1$var$O ? $e6216febf4d6e8a1$var$M.memoizedState = $e6216febf4d6e8a1$var$O = a : $e6216febf4d6e8a1$var$O = $e6216febf4d6e8a1$var$O.next = a;
    }
    return $e6216febf4d6e8a1$var$O;
}
function $e6216febf4d6e8a1$var$ii(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e6216febf4d6e8a1$var$ji(a) {
    var b = $e6216febf4d6e8a1$var$hi(), c = b.queue;
    if (null === c) throw Error($e6216febf4d6e8a1$var$p(311));
    c.lastRenderedReducer = a;
    var d = $e6216febf4d6e8a1$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var n = l.lane;
            if (($e6216febf4d6e8a1$var$Vh & n) === n) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: n,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $e6216febf4d6e8a1$var$M.lanes |= n;
                $e6216febf4d6e8a1$var$Fh |= n;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $e6216febf4d6e8a1$var$Ve(d, b.memoizedState) || ($e6216febf4d6e8a1$var$rh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $e6216febf4d6e8a1$var$M.lanes |= f, $e6216febf4d6e8a1$var$Fh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $e6216febf4d6e8a1$var$ki(a) {
    var b = $e6216febf4d6e8a1$var$hi(), c = b.queue;
    if (null === c) throw Error($e6216febf4d6e8a1$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e6216febf4d6e8a1$var$Ve(f, b.memoizedState) || ($e6216febf4d6e8a1$var$rh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $e6216febf4d6e8a1$var$li() {}
function $e6216febf4d6e8a1$var$mi(a, b) {
    var c = $e6216febf4d6e8a1$var$M, d = $e6216febf4d6e8a1$var$hi(), e = b(), f = !$e6216febf4d6e8a1$var$Ve(d.memoizedState, e);
    f && (d.memoizedState = e, $e6216febf4d6e8a1$var$rh = !0);
    d = d.queue;
    $e6216febf4d6e8a1$var$ni($e6216febf4d6e8a1$var$oi.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $e6216febf4d6e8a1$var$O && $e6216febf4d6e8a1$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $e6216febf4d6e8a1$var$pi(9, $e6216febf4d6e8a1$var$qi.bind(null, c, d, e, b), void 0, null);
        if (null === $e6216febf4d6e8a1$var$Q) throw Error($e6216febf4d6e8a1$var$p(349));
        0 !== ($e6216febf4d6e8a1$var$Vh & 30) || $e6216febf4d6e8a1$var$ri(c, b, e);
    }
    return e;
}
function $e6216febf4d6e8a1$var$ri(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $e6216febf4d6e8a1$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e6216febf4d6e8a1$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $e6216febf4d6e8a1$var$qi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $e6216febf4d6e8a1$var$si(b) && $e6216febf4d6e8a1$var$ti(a);
}
function $e6216febf4d6e8a1$var$oi(a, b, c) {
    return c(function() {
        $e6216febf4d6e8a1$var$si(b) && $e6216febf4d6e8a1$var$ti(a);
    });
}
function $e6216febf4d6e8a1$var$si(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$e6216febf4d6e8a1$var$Ve(a, c);
    } catch (d) {
        return !0;
    }
}
function $e6216febf4d6e8a1$var$ti(a) {
    var b = $e6216febf4d6e8a1$var$wh(a, 1);
    null !== b && $e6216febf4d6e8a1$var$ui(b, a, 1, -1);
}
function $e6216febf4d6e8a1$var$vi(a) {
    var b = $e6216febf4d6e8a1$var$gi();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e6216febf4d6e8a1$var$ii,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $e6216febf4d6e8a1$var$wi.bind(null, $e6216febf4d6e8a1$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $e6216febf4d6e8a1$var$pi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $e6216febf4d6e8a1$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e6216febf4d6e8a1$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $e6216febf4d6e8a1$var$xi() {
    return $e6216febf4d6e8a1$var$hi().memoizedState;
}
function $e6216febf4d6e8a1$var$Ai(a, b, c, d) {
    var e = $e6216febf4d6e8a1$var$gi();
    $e6216febf4d6e8a1$var$M.flags |= a;
    e.memoizedState = $e6216febf4d6e8a1$var$pi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $e6216febf4d6e8a1$var$Bi(a, b, c, d) {
    var e = $e6216febf4d6e8a1$var$hi();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $e6216febf4d6e8a1$var$N) {
        var g = $e6216febf4d6e8a1$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $e6216febf4d6e8a1$var$$h(d, g.deps)) {
            e.memoizedState = $e6216febf4d6e8a1$var$pi(b, c, f, d);
            return;
        }
    }
    $e6216febf4d6e8a1$var$M.flags |= a;
    e.memoizedState = $e6216febf4d6e8a1$var$pi(1 | b, c, f, d);
}
function $e6216febf4d6e8a1$var$Ci(a, b) {
    return $e6216febf4d6e8a1$var$Ai(8390656, 8, a, b);
}
function $e6216febf4d6e8a1$var$ni(a, b) {
    return $e6216febf4d6e8a1$var$Bi(2048, 8, a, b);
}
function $e6216febf4d6e8a1$var$Di(a, b) {
    return $e6216febf4d6e8a1$var$Bi(4, 2, a, b);
}
function $e6216febf4d6e8a1$var$Ei(a, b) {
    return $e6216febf4d6e8a1$var$Bi(4, 4, a, b);
}
function $e6216febf4d6e8a1$var$Fi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $e6216febf4d6e8a1$var$Gi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $e6216febf4d6e8a1$var$Bi(4, 4, $e6216febf4d6e8a1$var$Fi.bind(null, b, a), c);
}
function $e6216febf4d6e8a1$var$Hi() {}
function $e6216febf4d6e8a1$var$Ii(a, b) {
    var c = $e6216febf4d6e8a1$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e6216febf4d6e8a1$var$$h(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e6216febf4d6e8a1$var$Ji(a, b) {
    var c = $e6216febf4d6e8a1$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e6216febf4d6e8a1$var$$h(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e6216febf4d6e8a1$var$Ki(a, b, c) {
    if (0 === ($e6216febf4d6e8a1$var$Vh & 21)) return a.baseState && (a.baseState = !1, $e6216febf4d6e8a1$var$rh = !0), a.memoizedState = c;
    $e6216febf4d6e8a1$var$Ve(c, b) || (c = $e6216febf4d6e8a1$var$Kc(), $e6216febf4d6e8a1$var$M.lanes |= c, $e6216febf4d6e8a1$var$Fh |= c, a.baseState = !0);
    return b;
}
function $e6216febf4d6e8a1$var$Li(a, b) {
    var c = $e6216febf4d6e8a1$var$E;
    $e6216febf4d6e8a1$var$E = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $e6216febf4d6e8a1$var$Uh.transition;
    $e6216febf4d6e8a1$var$Uh.transition = {};
    try {
        a(!1), b();
    } finally{
        $e6216febf4d6e8a1$var$E = c, $e6216febf4d6e8a1$var$Uh.transition = d;
    }
}
function $e6216febf4d6e8a1$var$Mi() {
    return $e6216febf4d6e8a1$var$hi().memoizedState;
}
function $e6216febf4d6e8a1$var$Ni(a, b, c) {
    var d = $e6216febf4d6e8a1$var$Oi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e6216febf4d6e8a1$var$Pi(a)) $e6216febf4d6e8a1$var$Qi(b, c);
    else if (c = $e6216febf4d6e8a1$var$vh(a, b, c, d), null !== c) {
        var e = $e6216febf4d6e8a1$var$Ri();
        $e6216febf4d6e8a1$var$ui(c, a, d, e);
        $e6216febf4d6e8a1$var$Si(c, b, d);
    }
    $e6216febf4d6e8a1$var$yc(a, d);
}
function $e6216febf4d6e8a1$var$wi(a, b, c) {
    var d = $e6216febf4d6e8a1$var$Oi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e6216febf4d6e8a1$var$Pi(a)) $e6216febf4d6e8a1$var$Qi(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($e6216febf4d6e8a1$var$Ve(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $e6216febf4d6e8a1$var$uh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $e6216febf4d6e8a1$var$vh(a, b, e, d);
        null !== c && (e = $e6216febf4d6e8a1$var$Ri(), $e6216febf4d6e8a1$var$ui(c, a, d, e), $e6216febf4d6e8a1$var$Si(c, b, d));
    }
    $e6216febf4d6e8a1$var$yc(a, d);
}
function $e6216febf4d6e8a1$var$Pi(a) {
    var b = a.alternate;
    return a === $e6216febf4d6e8a1$var$M || null !== b && b === $e6216febf4d6e8a1$var$M;
}
function $e6216febf4d6e8a1$var$Qi(a, b) {
    $e6216febf4d6e8a1$var$Xh = $e6216febf4d6e8a1$var$Wh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $e6216febf4d6e8a1$var$Si(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e6216febf4d6e8a1$var$Oc(a, c);
    }
}
var $e6216febf4d6e8a1$var$ei = {
    readContext: $e6216febf4d6e8a1$var$sh,
    useCallback: $e6216febf4d6e8a1$var$P,
    useContext: $e6216febf4d6e8a1$var$P,
    useEffect: $e6216febf4d6e8a1$var$P,
    useImperativeHandle: $e6216febf4d6e8a1$var$P,
    useInsertionEffect: $e6216febf4d6e8a1$var$P,
    useLayoutEffect: $e6216febf4d6e8a1$var$P,
    useMemo: $e6216febf4d6e8a1$var$P,
    useReducer: $e6216febf4d6e8a1$var$P,
    useRef: $e6216febf4d6e8a1$var$P,
    useState: $e6216febf4d6e8a1$var$P,
    useDebugValue: $e6216febf4d6e8a1$var$P,
    useDeferredValue: $e6216febf4d6e8a1$var$P,
    useTransition: $e6216febf4d6e8a1$var$P,
    useMutableSource: $e6216febf4d6e8a1$var$P,
    useSyncExternalStore: $e6216febf4d6e8a1$var$P,
    useId: $e6216febf4d6e8a1$var$P,
    unstable_isNewReconciler: !1
}, $e6216febf4d6e8a1$var$bi = {
    readContext: $e6216febf4d6e8a1$var$sh,
    useCallback: function(a, b) {
        $e6216febf4d6e8a1$var$gi().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $e6216febf4d6e8a1$var$sh,
    useEffect: $e6216febf4d6e8a1$var$Ci,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $e6216febf4d6e8a1$var$Ai(4194308, 4, $e6216febf4d6e8a1$var$Fi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $e6216febf4d6e8a1$var$Ai(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $e6216febf4d6e8a1$var$Ai(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $e6216febf4d6e8a1$var$gi();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $e6216febf4d6e8a1$var$gi();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $e6216febf4d6e8a1$var$Ni.bind(null, $e6216febf4d6e8a1$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $e6216febf4d6e8a1$var$gi();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $e6216febf4d6e8a1$var$vi,
    useDebugValue: $e6216febf4d6e8a1$var$Hi,
    useDeferredValue: function(a) {
        return $e6216febf4d6e8a1$var$gi().memoizedState = a;
    },
    useTransition: function() {
        var a = $e6216febf4d6e8a1$var$vi(!1), b = a[0];
        a = $e6216febf4d6e8a1$var$Li.bind(null, a[1]);
        $e6216febf4d6e8a1$var$gi().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $e6216febf4d6e8a1$var$M, e = $e6216febf4d6e8a1$var$gi();
        if ($e6216febf4d6e8a1$var$J) {
            if (void 0 === c) throw Error($e6216febf4d6e8a1$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $e6216febf4d6e8a1$var$Q) throw Error($e6216febf4d6e8a1$var$p(349));
            0 !== ($e6216febf4d6e8a1$var$Vh & 30) || $e6216febf4d6e8a1$var$ri(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $e6216febf4d6e8a1$var$Ci($e6216febf4d6e8a1$var$oi.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $e6216febf4d6e8a1$var$pi(9, $e6216febf4d6e8a1$var$qi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $e6216febf4d6e8a1$var$gi(), b = $e6216febf4d6e8a1$var$Q.identifierPrefix;
        if ($e6216febf4d6e8a1$var$J) {
            var c = $e6216febf4d6e8a1$var$Gg;
            var d = $e6216febf4d6e8a1$var$Fg;
            c = (d & ~(1 << 32 - $e6216febf4d6e8a1$var$Ac(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $e6216febf4d6e8a1$var$Yh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $e6216febf4d6e8a1$var$Zh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $e6216febf4d6e8a1$var$ci = {
    readContext: $e6216febf4d6e8a1$var$sh,
    useCallback: $e6216febf4d6e8a1$var$Ii,
    useContext: $e6216febf4d6e8a1$var$sh,
    useEffect: $e6216febf4d6e8a1$var$ni,
    useImperativeHandle: $e6216febf4d6e8a1$var$Gi,
    useInsertionEffect: $e6216febf4d6e8a1$var$Di,
    useLayoutEffect: $e6216febf4d6e8a1$var$Ei,
    useMemo: $e6216febf4d6e8a1$var$Ji,
    useReducer: $e6216febf4d6e8a1$var$ji,
    useRef: $e6216febf4d6e8a1$var$xi,
    useState: function() {
        return $e6216febf4d6e8a1$var$ji($e6216febf4d6e8a1$var$ii);
    },
    useDebugValue: $e6216febf4d6e8a1$var$Hi,
    useDeferredValue: function(a) {
        var b = $e6216febf4d6e8a1$var$hi();
        return $e6216febf4d6e8a1$var$Ki(b, $e6216febf4d6e8a1$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $e6216febf4d6e8a1$var$ji($e6216febf4d6e8a1$var$ii)[0], b = $e6216febf4d6e8a1$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e6216febf4d6e8a1$var$li,
    useSyncExternalStore: $e6216febf4d6e8a1$var$mi,
    useId: $e6216febf4d6e8a1$var$Mi,
    unstable_isNewReconciler: !1
}, $e6216febf4d6e8a1$var$di = {
    readContext: $e6216febf4d6e8a1$var$sh,
    useCallback: $e6216febf4d6e8a1$var$Ii,
    useContext: $e6216febf4d6e8a1$var$sh,
    useEffect: $e6216febf4d6e8a1$var$ni,
    useImperativeHandle: $e6216febf4d6e8a1$var$Gi,
    useInsertionEffect: $e6216febf4d6e8a1$var$Di,
    useLayoutEffect: $e6216febf4d6e8a1$var$Ei,
    useMemo: $e6216febf4d6e8a1$var$Ji,
    useReducer: $e6216febf4d6e8a1$var$ki,
    useRef: $e6216febf4d6e8a1$var$xi,
    useState: function() {
        return $e6216febf4d6e8a1$var$ki($e6216febf4d6e8a1$var$ii);
    },
    useDebugValue: $e6216febf4d6e8a1$var$Hi,
    useDeferredValue: function(a) {
        var b = $e6216febf4d6e8a1$var$hi();
        return null === $e6216febf4d6e8a1$var$N ? b.memoizedState = a : $e6216febf4d6e8a1$var$Ki(b, $e6216febf4d6e8a1$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $e6216febf4d6e8a1$var$ki($e6216febf4d6e8a1$var$ii)[0], b = $e6216febf4d6e8a1$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e6216febf4d6e8a1$var$li,
    useSyncExternalStore: $e6216febf4d6e8a1$var$mi,
    useId: $e6216febf4d6e8a1$var$Mi,
    unstable_isNewReconciler: !1
}, $e6216febf4d6e8a1$var$Ti = $hziAm.unstable_now, $e6216febf4d6e8a1$var$Ui = 0, $e6216febf4d6e8a1$var$Vi = -1, $e6216febf4d6e8a1$var$Wi = -1, $e6216febf4d6e8a1$var$Xi = -1, $e6216febf4d6e8a1$var$Yi = !1, $e6216febf4d6e8a1$var$Zi = !1;
function $e6216febf4d6e8a1$var$$i(a, b) {
    if (0 <= $e6216febf4d6e8a1$var$Wi) {
        var c = $e6216febf4d6e8a1$var$Ti() - $e6216febf4d6e8a1$var$Wi;
        a.actualDuration += c;
        b && (a.selfBaseDuration = c);
        $e6216febf4d6e8a1$var$Wi = -1;
    }
}
function $e6216febf4d6e8a1$var$aj(a) {
    if (0 <= $e6216febf4d6e8a1$var$Vi) {
        var b = $e6216febf4d6e8a1$var$Ti() - $e6216febf4d6e8a1$var$Vi;
        $e6216febf4d6e8a1$var$Vi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a.stateNode.effectDuration += b;
                    return;
                case 12:
                    a.stateNode.effectDuration += b;
                    return;
            }
            a = a.return;
        }
    }
}
function $e6216febf4d6e8a1$var$bj(a) {
    if (0 <= $e6216febf4d6e8a1$var$Xi) {
        var b = $e6216febf4d6e8a1$var$Ti() - $e6216febf4d6e8a1$var$Xi;
        $e6216febf4d6e8a1$var$Xi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
                case 12:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
            }
            a = a.return;
        }
    }
}
function $e6216febf4d6e8a1$var$cj() {
    $e6216febf4d6e8a1$var$Vi = $e6216febf4d6e8a1$var$Ti();
}
function $e6216febf4d6e8a1$var$dj(a) {
    for(var b = a.child; b;)a.actualDuration += b.actualDuration, b = b.sibling;
}
function $e6216febf4d6e8a1$var$ej(a, b) {
    if (a && a.defaultProps) {
        b = $e6216febf4d6e8a1$var$u({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $e6216febf4d6e8a1$var$fj(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $e6216febf4d6e8a1$var$u({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $e6216febf4d6e8a1$var$gj = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $e6216febf4d6e8a1$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e6216febf4d6e8a1$var$Ri(), e = $e6216febf4d6e8a1$var$Oi(a), f = $e6216febf4d6e8a1$var$Ah(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e6216febf4d6e8a1$var$Bh(a, f, e);
        null !== b && ($e6216febf4d6e8a1$var$ui(b, a, e, d), $e6216febf4d6e8a1$var$Ch(b, a, e));
        $e6216febf4d6e8a1$var$yc(a, e);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e6216febf4d6e8a1$var$Ri(), e = $e6216febf4d6e8a1$var$Oi(a), f = $e6216febf4d6e8a1$var$Ah(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e6216febf4d6e8a1$var$Bh(a, f, e);
        null !== b && ($e6216febf4d6e8a1$var$ui(b, a, e, d), $e6216febf4d6e8a1$var$Ch(b, a, e));
        $e6216febf4d6e8a1$var$yc(a, e);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $e6216febf4d6e8a1$var$Ri(), d = $e6216febf4d6e8a1$var$Oi(a), e = $e6216febf4d6e8a1$var$Ah(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $e6216febf4d6e8a1$var$Bh(a, e, d);
        null !== b && ($e6216febf4d6e8a1$var$ui(b, a, d, c), $e6216febf4d6e8a1$var$Ch(b, a, d));
        null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markForceUpdateScheduled && $e6216febf4d6e8a1$var$B.markForceUpdateScheduled(a, d);
    }
};
function $e6216febf4d6e8a1$var$hj(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e6216febf4d6e8a1$var$We(c, d) || !$e6216febf4d6e8a1$var$We(e, f) : !0;
}
function $e6216febf4d6e8a1$var$ij(a, b, c) {
    var d = !1, e = $e6216febf4d6e8a1$var$ig;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $e6216febf4d6e8a1$var$sh(f) : (e = $e6216febf4d6e8a1$var$mg(b) ? $e6216febf4d6e8a1$var$kg : $e6216febf4d6e8a1$var$I.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $e6216febf4d6e8a1$var$lg(a, e) : $e6216febf4d6e8a1$var$ig);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $e6216febf4d6e8a1$var$gj;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $e6216febf4d6e8a1$var$jj(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $e6216febf4d6e8a1$var$gj.enqueueReplaceState(b, b.state, null);
}
function $e6216febf4d6e8a1$var$kj(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $e6216febf4d6e8a1$var$yh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $e6216febf4d6e8a1$var$sh(f) : (f = $e6216febf4d6e8a1$var$mg(b) ? $e6216febf4d6e8a1$var$kg : $e6216febf4d6e8a1$var$I.current, e.context = $e6216febf4d6e8a1$var$lg(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($e6216febf4d6e8a1$var$fj(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $e6216febf4d6e8a1$var$gj.enqueueReplaceState(e, e.state, null), $e6216febf4d6e8a1$var$Eh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $e6216febf4d6e8a1$var$lj(a, b) {
    try {
        var c = "", d = b;
        do c += $e6216febf4d6e8a1$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $e6216febf4d6e8a1$var$mj(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $e6216febf4d6e8a1$var$nj(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $e6216febf4d6e8a1$var$oj = "function" === typeof WeakMap ? WeakMap : Map;
function $e6216febf4d6e8a1$var$pj(a, b, c) {
    c = $e6216febf4d6e8a1$var$Ah(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $e6216febf4d6e8a1$var$qj || ($e6216febf4d6e8a1$var$qj = !0, $e6216febf4d6e8a1$var$rj = d);
        $e6216febf4d6e8a1$var$nj(a, b);
    };
    return c;
}
function $e6216febf4d6e8a1$var$sj(a, b, c) {
    c = $e6216febf4d6e8a1$var$Ah(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $e6216febf4d6e8a1$var$nj(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $e6216febf4d6e8a1$var$nj(a, b);
        "function" !== typeof d && (null === $e6216febf4d6e8a1$var$tj ? $e6216febf4d6e8a1$var$tj = new Set([
            this
        ]) : $e6216febf4d6e8a1$var$tj.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $e6216febf4d6e8a1$var$uj(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $e6216febf4d6e8a1$var$oj;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), d = $e6216febf4d6e8a1$var$vj.bind(null, a, b, c), $e6216febf4d6e8a1$var$mc && $e6216febf4d6e8a1$var$wj(a, c), b.then(d, d));
}
function $e6216febf4d6e8a1$var$xj(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $e6216febf4d6e8a1$var$yj(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $e6216febf4d6e8a1$var$Ah(-1, 1), b.tag = 2, $e6216febf4d6e8a1$var$Bh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $e6216febf4d6e8a1$var$zj = $e6216febf4d6e8a1$var$va.ReactCurrentOwner, $e6216febf4d6e8a1$var$rh = !1;
function $e6216febf4d6e8a1$var$Aj(a, b, c, d) {
    b.child = null === a ? $e6216febf4d6e8a1$var$ih(b, null, c, d) : $e6216febf4d6e8a1$var$hh(b, a.child, c, d);
}
function $e6216febf4d6e8a1$var$Bj(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $e6216febf4d6e8a1$var$qh(b, e);
    $e6216febf4d6e8a1$var$sc(b);
    d = $e6216febf4d6e8a1$var$ai(a, b, c, d, f, e);
    c = $e6216febf4d6e8a1$var$fi();
    $e6216febf4d6e8a1$var$tc();
    if (null !== a && !$e6216febf4d6e8a1$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e6216febf4d6e8a1$var$Cj(a, b, e);
    $e6216febf4d6e8a1$var$J && c && $e6216febf4d6e8a1$var$Jg(b);
    b.flags |= 1;
    $e6216febf4d6e8a1$var$Aj(a, b, d, e);
    return b.child;
}
function $e6216febf4d6e8a1$var$Dj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$e6216febf4d6e8a1$var$Ej(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $e6216febf4d6e8a1$var$Fj(a, b, f, d, e);
        a = $e6216febf4d6e8a1$var$eh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $e6216febf4d6e8a1$var$We;
        if (c(g, d) && a.ref === b.ref) return $e6216febf4d6e8a1$var$Cj(a, b, e);
    }
    b.flags |= 1;
    a = $e6216febf4d6e8a1$var$ch(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $e6216febf4d6e8a1$var$Fj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($e6216febf4d6e8a1$var$We(f, d) && a.ref === b.ref) {
            if ($e6216febf4d6e8a1$var$rh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($e6216febf4d6e8a1$var$rh = !0);
            else return b.lanes = a.lanes, $e6216febf4d6e8a1$var$Cj(a, b, e);
        }
    }
    return $e6216febf4d6e8a1$var$Gj(a, b, c, d, e);
}
function $e6216febf4d6e8a1$var$Hj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$Ij, $e6216febf4d6e8a1$var$Jj), $e6216febf4d6e8a1$var$Jj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$Ij, $e6216febf4d6e8a1$var$Jj), $e6216febf4d6e8a1$var$Jj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$Ij, $e6216febf4d6e8a1$var$Jj);
            $e6216febf4d6e8a1$var$Jj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$Ij, $e6216febf4d6e8a1$var$Jj), $e6216febf4d6e8a1$var$Jj |= d;
    $e6216febf4d6e8a1$var$Aj(a, b, e, c);
    return b.child;
}
function $e6216febf4d6e8a1$var$Kj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $e6216febf4d6e8a1$var$Gj(a, b, c, d, e) {
    var f = $e6216febf4d6e8a1$var$mg(c) ? $e6216febf4d6e8a1$var$kg : $e6216febf4d6e8a1$var$I.current;
    f = $e6216febf4d6e8a1$var$lg(b, f);
    $e6216febf4d6e8a1$var$qh(b, e);
    $e6216febf4d6e8a1$var$sc(b);
    c = $e6216febf4d6e8a1$var$ai(a, b, c, d, f, e);
    d = $e6216febf4d6e8a1$var$fi();
    $e6216febf4d6e8a1$var$tc();
    if (null !== a && !$e6216febf4d6e8a1$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e6216febf4d6e8a1$var$Cj(a, b, e);
    $e6216febf4d6e8a1$var$J && d && $e6216febf4d6e8a1$var$Jg(b);
    b.flags |= 1;
    $e6216febf4d6e8a1$var$Aj(a, b, c, e);
    return b.child;
}
function $e6216febf4d6e8a1$var$Lj(a, b, c, d, e) {
    if ($e6216febf4d6e8a1$var$mg(c)) {
        var f = !0;
        $e6216febf4d6e8a1$var$qg(b);
    } else f = !1;
    $e6216febf4d6e8a1$var$qh(b, e);
    if (null === b.stateNode) $e6216febf4d6e8a1$var$Mj(a, b), $e6216febf4d6e8a1$var$ij(b, c, d), $e6216febf4d6e8a1$var$kj(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $e6216febf4d6e8a1$var$sh(l) : (l = $e6216febf4d6e8a1$var$mg(c) ? $e6216febf4d6e8a1$var$kg : $e6216febf4d6e8a1$var$I.current, l = $e6216febf4d6e8a1$var$lg(b, l));
        var n = c.getDerivedStateFromProps, q = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $e6216febf4d6e8a1$var$jj(b, g, d, l);
        $e6216febf4d6e8a1$var$xh = !1;
        var r = b.memoizedState;
        g.state = r;
        $e6216febf4d6e8a1$var$Eh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $e6216febf4d6e8a1$var$jg.current || $e6216febf4d6e8a1$var$xh ? ("function" === typeof n && ($e6216febf4d6e8a1$var$fj(b, c, n, d), k = b.memoizedState), (h = $e6216febf4d6e8a1$var$xh || $e6216febf4d6e8a1$var$hj(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $e6216febf4d6e8a1$var$zh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $e6216febf4d6e8a1$var$ej(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $e6216febf4d6e8a1$var$sh(k) : (k = $e6216febf4d6e8a1$var$mg(c) ? $e6216febf4d6e8a1$var$kg : $e6216febf4d6e8a1$var$I.current, k = $e6216febf4d6e8a1$var$lg(b, k));
        var z = c.getDerivedStateFromProps;
        (n = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $e6216febf4d6e8a1$var$jj(b, g, d, k);
        $e6216febf4d6e8a1$var$xh = !1;
        r = b.memoizedState;
        g.state = r;
        $e6216febf4d6e8a1$var$Eh(b, d, g, e);
        var m = b.memoizedState;
        h !== q || r !== m || $e6216febf4d6e8a1$var$jg.current || $e6216febf4d6e8a1$var$xh ? ("function" === typeof z && ($e6216febf4d6e8a1$var$fj(b, c, z, d), m = b.memoizedState), (l = $e6216febf4d6e8a1$var$xh || $e6216febf4d6e8a1$var$hj(b, c, l, d, r, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $e6216febf4d6e8a1$var$Nj(a, b, c, d, f, e);
}
function $e6216febf4d6e8a1$var$Nj(a, b, c, d, e, f) {
    $e6216febf4d6e8a1$var$Kj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $e6216febf4d6e8a1$var$rg(b, c, !1), $e6216febf4d6e8a1$var$Cj(a, b, f);
    d = b.stateNode;
    $e6216febf4d6e8a1$var$zj.current = b;
    if (g && "function" !== typeof c.getDerivedStateFromError) {
        var h = null;
        $e6216febf4d6e8a1$var$Wi = -1;
    } else $e6216febf4d6e8a1$var$sc(b), h = d.render(), $e6216febf4d6e8a1$var$tc();
    b.flags |= 1;
    null !== a && g ? (g = h, b.child = $e6216febf4d6e8a1$var$hh(b, a.child, null, f), b.child = $e6216febf4d6e8a1$var$hh(b, null, g, f)) : $e6216febf4d6e8a1$var$Aj(a, b, h, f);
    b.memoizedState = d.state;
    e && $e6216febf4d6e8a1$var$rg(b, c, !0);
    return b.child;
}
function $e6216febf4d6e8a1$var$Oj(a) {
    var b = a.stateNode;
    b.pendingContext ? $e6216febf4d6e8a1$var$og(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $e6216febf4d6e8a1$var$og(a, b.context, !1);
    $e6216febf4d6e8a1$var$Mh(a, b.containerInfo);
}
function $e6216febf4d6e8a1$var$Rj(a, b, c, d, e) {
    $e6216febf4d6e8a1$var$Wg();
    $e6216febf4d6e8a1$var$Xg(e);
    b.flags |= 256;
    $e6216febf4d6e8a1$var$Aj(a, b, c, d);
    return b.child;
}
var $e6216febf4d6e8a1$var$Sj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e6216febf4d6e8a1$var$Tj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $e6216febf4d6e8a1$var$Uj(a, b, c) {
    var d = b.pendingProps, e = $e6216febf4d6e8a1$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$L, e & 1);
    if (null === a) {
        $e6216febf4d6e8a1$var$Sg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g, b.mode & 2 && (f.actualDuration = 0, f.actualStartTime = -1, f.selfBaseDuration = 0, f.treeBaseDuration = 0)) : f = $e6216febf4d6e8a1$var$Vj(g, d, 0, null), a = $e6216febf4d6e8a1$var$gh(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $e6216febf4d6e8a1$var$Tj(c), b.memoizedState = $e6216febf4d6e8a1$var$Sj, a) : $e6216febf4d6e8a1$var$Wj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $e6216febf4d6e8a1$var$Xj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.mode & 2 && (d.actualDuration = 0, d.actualStartTime = -1, d.selfBaseDuration = e.selfBaseDuration, d.treeBaseDuration = e.treeBaseDuration), b.deletions = null) : (d = $e6216febf4d6e8a1$var$ch(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $e6216febf4d6e8a1$var$ch(h, f) : (f = $e6216febf4d6e8a1$var$gh(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $e6216febf4d6e8a1$var$Tj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $e6216febf4d6e8a1$var$Sj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $e6216febf4d6e8a1$var$ch(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $e6216febf4d6e8a1$var$Wj(a, b) {
    b = $e6216febf4d6e8a1$var$Vj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $e6216febf4d6e8a1$var$Yj(a, b, c, d) {
    null !== d && $e6216febf4d6e8a1$var$Xg(d);
    $e6216febf4d6e8a1$var$hh(b, a.child, null, c);
    a = $e6216febf4d6e8a1$var$Wj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $e6216febf4d6e8a1$var$Xj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $e6216febf4d6e8a1$var$mj(Error($e6216febf4d6e8a1$var$p(422))), $e6216febf4d6e8a1$var$Yj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $e6216febf4d6e8a1$var$Vj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $e6216febf4d6e8a1$var$gh(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $e6216febf4d6e8a1$var$hh(b, a.child, null, g);
        b.child.memoizedState = $e6216febf4d6e8a1$var$Tj(g);
        b.memoizedState = $e6216febf4d6e8a1$var$Sj;
        return f;
    }
    if (0 === (b.mode & 1)) return $e6216febf4d6e8a1$var$Yj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($e6216febf4d6e8a1$var$p(419));
        d = $e6216febf4d6e8a1$var$mj(f, d, void 0);
        return $e6216febf4d6e8a1$var$Yj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($e6216febf4d6e8a1$var$rh || h) {
        d = $e6216febf4d6e8a1$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $e6216febf4d6e8a1$var$wh(a, e), $e6216febf4d6e8a1$var$ui(d, a, e, -1));
        }
        $e6216febf4d6e8a1$var$Zj();
        d = $e6216febf4d6e8a1$var$mj(Error($e6216febf4d6e8a1$var$p(421)));
        return $e6216febf4d6e8a1$var$Yj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $e6216febf4d6e8a1$var$ak.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $e6216febf4d6e8a1$var$Mg = $e6216febf4d6e8a1$var$Zf(e.nextSibling);
    $e6216febf4d6e8a1$var$Lg = b;
    $e6216febf4d6e8a1$var$J = !0;
    $e6216febf4d6e8a1$var$Ng = null;
    null !== a && ($e6216febf4d6e8a1$var$Cg[$e6216febf4d6e8a1$var$Dg++] = $e6216febf4d6e8a1$var$Fg, $e6216febf4d6e8a1$var$Cg[$e6216febf4d6e8a1$var$Dg++] = $e6216febf4d6e8a1$var$Gg, $e6216febf4d6e8a1$var$Cg[$e6216febf4d6e8a1$var$Dg++] = $e6216febf4d6e8a1$var$Eg, $e6216febf4d6e8a1$var$Fg = a.id, $e6216febf4d6e8a1$var$Gg = a.overflow, $e6216febf4d6e8a1$var$Eg = b);
    b = $e6216febf4d6e8a1$var$Wj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $e6216febf4d6e8a1$var$bk(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $e6216febf4d6e8a1$var$ph(a.return, b, c);
}
function $e6216febf4d6e8a1$var$ck(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $e6216febf4d6e8a1$var$dk(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $e6216febf4d6e8a1$var$Aj(a, b, d.children, c);
    d = $e6216febf4d6e8a1$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $e6216febf4d6e8a1$var$bk(a, c, b);
            else if (19 === a.tag) $e6216febf4d6e8a1$var$bk(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $e6216febf4d6e8a1$var$Qh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $e6216febf4d6e8a1$var$ck(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $e6216febf4d6e8a1$var$Qh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $e6216febf4d6e8a1$var$ck(b, !0, c, null, f);
            break;
        case "together":
            $e6216febf4d6e8a1$var$ck(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $e6216febf4d6e8a1$var$Mj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $e6216febf4d6e8a1$var$Cj(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $e6216febf4d6e8a1$var$Wi = -1;
    $e6216febf4d6e8a1$var$Fh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($e6216febf4d6e8a1$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $e6216febf4d6e8a1$var$ch(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $e6216febf4d6e8a1$var$ch(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $e6216febf4d6e8a1$var$ek(a, b, c) {
    switch(b.tag){
        case 3:
            $e6216febf4d6e8a1$var$Oj(b);
            $e6216febf4d6e8a1$var$Wg();
            break;
        case 5:
            $e6216febf4d6e8a1$var$Oh(b);
            break;
        case 1:
            $e6216febf4d6e8a1$var$mg(b.type) && $e6216febf4d6e8a1$var$qg(b);
            break;
        case 4:
            $e6216febf4d6e8a1$var$Mh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$jh, d._currentValue);
            d._currentValue = e;
            break;
        case 12:
            0 !== (c & b.childLanes) && (b.flags |= 4);
            d = b.stateNode;
            d.effectDuration = 0;
            d.passiveEffectDuration = 0;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$L, $e6216febf4d6e8a1$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $e6216febf4d6e8a1$var$Uj(a, b, c);
                $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$L, $e6216febf4d6e8a1$var$L.current & 1);
                a = $e6216febf4d6e8a1$var$Cj(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$L, $e6216febf4d6e8a1$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $e6216febf4d6e8a1$var$dk(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$L, $e6216febf4d6e8a1$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $e6216febf4d6e8a1$var$Hj(a, b, c);
    }
    return $e6216febf4d6e8a1$var$Cj(a, b, c);
}
var $e6216febf4d6e8a1$var$fk, $e6216febf4d6e8a1$var$gk, $e6216febf4d6e8a1$var$hk, $e6216febf4d6e8a1$var$ik;
$e6216febf4d6e8a1$var$fk = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$e6216febf4d6e8a1$var$gk = function() {};
$e6216febf4d6e8a1$var$hk = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $e6216febf4d6e8a1$var$Lh($e6216febf4d6e8a1$var$Ih.current);
        var f = null;
        switch(c){
            case "input":
                e = $e6216febf4d6e8a1$var$Ya(a, e);
                d = $e6216febf4d6e8a1$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $e6216febf4d6e8a1$var$u({}, e, {
                    value: void 0
                });
                d = $e6216febf4d6e8a1$var$u({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $e6216febf4d6e8a1$var$fb(a, e);
                d = $e6216febf4d6e8a1$var$fb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $e6216febf4d6e8a1$var$Pf);
        }
        $e6216febf4d6e8a1$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($e6216febf4d6e8a1$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($e6216febf4d6e8a1$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $e6216febf4d6e8a1$var$F("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$e6216febf4d6e8a1$var$ik = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $e6216febf4d6e8a1$var$jk(a, b) {
    if (!$e6216febf4d6e8a1$var$J) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $e6216febf4d6e8a1$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) {
        if (0 !== (a.mode & 2)) {
            for(var e = a.selfBaseDuration, f = a.child; null !== f;)c |= f.lanes | f.childLanes, d |= f.subtreeFlags & 14680064, d |= f.flags & 14680064, e += f.treeBaseDuration, f = f.sibling;
            a.treeBaseDuration = e;
        } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    } else if (0 !== (a.mode & 2)) {
        e = a.actualDuration;
        f = a.selfBaseDuration;
        for(var g = a.child; null !== g;)c |= g.lanes | g.childLanes, d |= g.subtreeFlags, d |= g.flags, e += g.actualDuration, f += g.treeBaseDuration, g = g.sibling;
        a.actualDuration = e;
        a.treeBaseDuration = f;
    } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $e6216febf4d6e8a1$var$kk(a, b, c) {
    var d = b.pendingProps;
    $e6216febf4d6e8a1$var$Kg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e6216febf4d6e8a1$var$S(b), null;
        case 1:
            return $e6216febf4d6e8a1$var$mg(b.type) && $e6216febf4d6e8a1$var$ng(), $e6216febf4d6e8a1$var$S(b), null;
        case 3:
            d = b.stateNode;
            $e6216febf4d6e8a1$var$Nh();
            $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$jg);
            $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$I);
            $e6216febf4d6e8a1$var$Sh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $e6216febf4d6e8a1$var$Ug(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $e6216febf4d6e8a1$var$Ng && ($e6216febf4d6e8a1$var$lk($e6216febf4d6e8a1$var$Ng), $e6216febf4d6e8a1$var$Ng = null));
            $e6216febf4d6e8a1$var$gk(a, b);
            $e6216febf4d6e8a1$var$S(b);
            return null;
        case 5:
            $e6216febf4d6e8a1$var$Ph(b);
            var e = $e6216febf4d6e8a1$var$Lh($e6216febf4d6e8a1$var$Kh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $e6216febf4d6e8a1$var$hk(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($e6216febf4d6e8a1$var$p(166));
                    $e6216febf4d6e8a1$var$S(b);
                    return null;
                }
                a = $e6216febf4d6e8a1$var$Lh($e6216febf4d6e8a1$var$Ih.current);
                if ($e6216febf4d6e8a1$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.type;
                    c = b.memoizedProps;
                    d[$e6216febf4d6e8a1$var$bg] = b;
                    d[$e6216febf4d6e8a1$var$cg] = c;
                    var f = 0 !== (b.mode & 1);
                    switch(a){
                        case "dialog":
                            $e6216febf4d6e8a1$var$F("cancel", d);
                            $e6216febf4d6e8a1$var$F("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e6216febf4d6e8a1$var$F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $e6216febf4d6e8a1$var$zf.length; e++)$e6216febf4d6e8a1$var$F($e6216febf4d6e8a1$var$zf[e], d);
                            break;
                        case "source":
                            $e6216febf4d6e8a1$var$F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e6216febf4d6e8a1$var$F("error", d);
                            $e6216febf4d6e8a1$var$F("load", d);
                            break;
                        case "details":
                            $e6216febf4d6e8a1$var$F("toggle", d);
                            break;
                        case "input":
                            $e6216febf4d6e8a1$var$Za(d, c);
                            $e6216febf4d6e8a1$var$F("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!c.multiple
                            };
                            $e6216febf4d6e8a1$var$F("invalid", d);
                            break;
                        case "textarea":
                            $e6216febf4d6e8a1$var$gb(d, c), $e6216febf4d6e8a1$var$F("invalid", d);
                    }
                    $e6216febf4d6e8a1$var$ub(a, c);
                    e = null;
                    for(var g in c)if (c.hasOwnProperty(g)) {
                        var h = c[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== c.suppressHydrationWarning && $e6216febf4d6e8a1$var$Of(d.textContent, h, f), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== c.suppressHydrationWarning && $e6216febf4d6e8a1$var$Of(d.textContent, h, f), e = [
                            "children",
                            "" + h
                        ]) : $e6216febf4d6e8a1$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $e6216febf4d6e8a1$var$F("scroll", d);
                    }
                    switch(a){
                        case "input":
                            $e6216febf4d6e8a1$var$Va(d);
                            $e6216febf4d6e8a1$var$cb(d, c, !0);
                            break;
                        case "textarea":
                            $e6216febf4d6e8a1$var$Va(d);
                            $e6216febf4d6e8a1$var$ib(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof c.onClick && (d.onclick = $e6216febf4d6e8a1$var$Pf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $e6216febf4d6e8a1$var$jb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$e6216febf4d6e8a1$var$bg] = b;
                    a[$e6216febf4d6e8a1$var$cg] = d;
                    $e6216febf4d6e8a1$var$fk(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $e6216febf4d6e8a1$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $e6216febf4d6e8a1$var$F("cancel", a);
                                $e6216febf4d6e8a1$var$F("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $e6216febf4d6e8a1$var$F("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $e6216febf4d6e8a1$var$zf.length; e++)$e6216febf4d6e8a1$var$F($e6216febf4d6e8a1$var$zf[e], a);
                                e = d;
                                break;
                            case "source":
                                $e6216febf4d6e8a1$var$F("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $e6216febf4d6e8a1$var$F("error", a);
                                $e6216febf4d6e8a1$var$F("load", a);
                                e = d;
                                break;
                            case "details":
                                $e6216febf4d6e8a1$var$F("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $e6216febf4d6e8a1$var$Za(a, d);
                                e = $e6216febf4d6e8a1$var$Ya(a, d);
                                $e6216febf4d6e8a1$var$F("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $e6216febf4d6e8a1$var$u({}, d, {
                                    value: void 0
                                });
                                $e6216febf4d6e8a1$var$F("invalid", a);
                                break;
                            case "textarea":
                                $e6216febf4d6e8a1$var$gb(a, d);
                                e = $e6216febf4d6e8a1$var$fb(a, d);
                                $e6216febf4d6e8a1$var$F("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $e6216febf4d6e8a1$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $e6216febf4d6e8a1$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $e6216febf4d6e8a1$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $e6216febf4d6e8a1$var$ob(a, k) : "number" === typeof k && $e6216febf4d6e8a1$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($e6216febf4d6e8a1$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $e6216febf4d6e8a1$var$F("scroll", a) : null != k && $e6216febf4d6e8a1$var$ua(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $e6216febf4d6e8a1$var$Va(a);
                                $e6216febf4d6e8a1$var$cb(a, d, !1);
                                break;
                            case "textarea":
                                $e6216febf4d6e8a1$var$Va(a);
                                $e6216febf4d6e8a1$var$ib(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $e6216febf4d6e8a1$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $e6216febf4d6e8a1$var$eb(a, !!d.multiple, f, !1) : null != d.defaultValue && $e6216febf4d6e8a1$var$eb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $e6216febf4d6e8a1$var$Pf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $e6216febf4d6e8a1$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $e6216febf4d6e8a1$var$ik(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($e6216febf4d6e8a1$var$p(166));
                a = $e6216febf4d6e8a1$var$Lh($e6216febf4d6e8a1$var$Kh.current);
                $e6216febf4d6e8a1$var$Lh($e6216febf4d6e8a1$var$Ih.current);
                if ($e6216febf4d6e8a1$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.memoizedProps;
                    d[$e6216febf4d6e8a1$var$bg] = b;
                    if (c = d.nodeValue !== a) {
                        if (f = $e6216febf4d6e8a1$var$Lg, null !== f) switch(f.tag){
                            case 3:
                                $e6216febf4d6e8a1$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                                break;
                            case 5:
                                !0 !== f.memoizedProps.suppressHydrationWarning && $e6216febf4d6e8a1$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                        }
                    }
                    c && (b.flags |= 4);
                } else d = (9 === a.nodeType ? a : a.ownerDocument).createTextNode(d), d[$e6216febf4d6e8a1$var$bg] = b, b.stateNode = d;
            }
            $e6216febf4d6e8a1$var$S(b);
            return null;
        case 13:
            $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($e6216febf4d6e8a1$var$J && null !== $e6216febf4d6e8a1$var$Mg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $e6216febf4d6e8a1$var$Vg(), $e6216febf4d6e8a1$var$Wg(), b.flags |= 98560, f = !1;
                else if (f = $e6216febf4d6e8a1$var$Ug(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($e6216febf4d6e8a1$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($e6216febf4d6e8a1$var$p(317));
                        f[$e6216febf4d6e8a1$var$bg] = b;
                        $e6216febf4d6e8a1$var$S(b);
                        0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    } else $e6216febf4d6e8a1$var$Wg(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4, $e6216febf4d6e8a1$var$S(b), 0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    f = !1;
                } else null !== $e6216febf4d6e8a1$var$Ng && ($e6216febf4d6e8a1$var$lk($e6216febf4d6e8a1$var$Ng), $e6216febf4d6e8a1$var$Ng = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, 0 !== (b.mode & 2) && $e6216febf4d6e8a1$var$dj(b), b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($e6216febf4d6e8a1$var$L.current & 1) ? 0 === $e6216febf4d6e8a1$var$T && ($e6216febf4d6e8a1$var$T = 3) : $e6216febf4d6e8a1$var$Zj()));
            null !== b.updateQueue && (b.flags |= 4);
            $e6216febf4d6e8a1$var$S(b);
            0 !== (b.mode & 2) && d && (d = b.child, null !== d && (b.treeBaseDuration -= d.treeBaseDuration));
            return null;
        case 4:
            return $e6216febf4d6e8a1$var$Nh(), $e6216febf4d6e8a1$var$gk(a, b), null === a && $e6216febf4d6e8a1$var$Gf(b.stateNode.containerInfo), $e6216febf4d6e8a1$var$S(b), null;
        case 10:
            return $e6216febf4d6e8a1$var$oh(b.type._context), $e6216febf4d6e8a1$var$S(b), null;
        case 17:
            return $e6216febf4d6e8a1$var$mg(b.type) && $e6216febf4d6e8a1$var$ng(), $e6216febf4d6e8a1$var$S(b), null;
        case 19:
            $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$L);
            f = b.memoizedState;
            if (null === f) return $e6216febf4d6e8a1$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $e6216febf4d6e8a1$var$jk(f, !1);
                else {
                    if (0 !== $e6216febf4d6e8a1$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $e6216febf4d6e8a1$var$Qh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $e6216febf4d6e8a1$var$jk(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(a = b.child; null !== a;)c = a, g = d, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = g, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null, c.selfBaseDuration = 0, c.treeBaseDuration = 0) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, g = f.dependencies, c.dependencies = null === g ? null : {
                                lanes: g.lanes,
                                firstContext: g.firstContext
                            }, c.selfBaseDuration = f.selfBaseDuration, c.treeBaseDuration = f.treeBaseDuration), a = a.sibling;
                            $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$L, $e6216febf4d6e8a1$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $e6216febf4d6e8a1$var$A() > $e6216febf4d6e8a1$var$mk && (b.flags |= 128, d = !0, $e6216febf4d6e8a1$var$jk(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $e6216febf4d6e8a1$var$Qh(g), null !== a) {
                        if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), $e6216febf4d6e8a1$var$jk(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$e6216febf4d6e8a1$var$J) return $e6216febf4d6e8a1$var$S(b), null;
                    } else 2 * $e6216febf4d6e8a1$var$A() - f.renderingStartTime > $e6216febf4d6e8a1$var$mk && 1073741824 !== c && (b.flags |= 128, d = !0, $e6216febf4d6e8a1$var$jk(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (a = f.last, null !== a ? a.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $e6216febf4d6e8a1$var$A(), b.sibling = null, a = $e6216febf4d6e8a1$var$L.current, $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$L, d ? a & 1 | 2 : a & 1), b;
            $e6216febf4d6e8a1$var$S(b);
            return null;
        case 22:
        case 23:
            return $e6216febf4d6e8a1$var$nk(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($e6216febf4d6e8a1$var$Jj & 1073741824) && ($e6216febf4d6e8a1$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $e6216febf4d6e8a1$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($e6216febf4d6e8a1$var$p(156, b.tag));
}
function $e6216febf4d6e8a1$var$ok(a, b) {
    $e6216febf4d6e8a1$var$Kg(b);
    switch(b.tag){
        case 1:
            return $e6216febf4d6e8a1$var$mg(b.type) && $e6216febf4d6e8a1$var$ng(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $e6216febf4d6e8a1$var$dj(b), b) : null;
        case 3:
            return $e6216febf4d6e8a1$var$Nh(), $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$jg), $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$I), $e6216febf4d6e8a1$var$Sh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $e6216febf4d6e8a1$var$Ph(b), null;
        case 13:
            $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($e6216febf4d6e8a1$var$p(340));
                $e6216febf4d6e8a1$var$Wg();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $e6216febf4d6e8a1$var$dj(b), b) : null;
        case 19:
            return $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$L), null;
        case 4:
            return $e6216febf4d6e8a1$var$Nh(), null;
        case 10:
            return $e6216febf4d6e8a1$var$oh(b.type._context), null;
        case 22:
        case 23:
            return $e6216febf4d6e8a1$var$nk(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $e6216febf4d6e8a1$var$pk = !1, $e6216febf4d6e8a1$var$qk = !1, $e6216febf4d6e8a1$var$rk = "function" === typeof WeakSet ? WeakSet : Set, $e6216febf4d6e8a1$var$U = null, $e6216febf4d6e8a1$var$sk = null, $e6216febf4d6e8a1$var$tk = null;
function $e6216febf4d6e8a1$var$uk(a, b) {
    b.props = a.memoizedProps;
    b.state = a.memoizedState;
    if (a.mode & 2) try {
        $e6216febf4d6e8a1$var$cj(), b.componentWillUnmount();
    } finally{
        $e6216febf4d6e8a1$var$aj(a);
    }
    else b.componentWillUnmount();
}
function $e6216febf4d6e8a1$var$vk(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            if (a.mode & 2) try {
                $e6216febf4d6e8a1$var$cj(), c(null);
            } finally{
                $e6216febf4d6e8a1$var$aj(a);
            }
            else c(null);
        } catch (d) {
            $e6216febf4d6e8a1$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $e6216febf4d6e8a1$var$wk(a, b, c) {
    try {
        c();
    } catch (d) {
        $e6216febf4d6e8a1$var$W(a, b, d);
    }
}
var $e6216febf4d6e8a1$var$xk = !1;
function $e6216febf4d6e8a1$var$yk(a, b) {
    $e6216febf4d6e8a1$var$Qf = $e6216febf4d6e8a1$var$rd;
    a = $e6216febf4d6e8a1$var$$e();
    if ($e6216febf4d6e8a1$var$af(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (D) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, n = 0, q = a, r = null;
                b: for(;;){
                    for(var z;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (z = q.firstChild)) break;
                        r = q;
                        q = z;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++n === d && (k = g);
                        if (null !== (z = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = z;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $e6216febf4d6e8a1$var$Rf = {
        focusedElem: a,
        selectionRange: c
    };
    $e6216febf4d6e8a1$var$rd = !1;
    for($e6216febf4d6e8a1$var$U = b; null !== $e6216febf4d6e8a1$var$U;)if (b = $e6216febf4d6e8a1$var$U, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $e6216febf4d6e8a1$var$U = a;
    else for(; null !== $e6216febf4d6e8a1$var$U;){
        b = $e6216febf4d6e8a1$var$U;
        try {
            var m = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== m) {
                        var w = m.memoizedProps, C = m.memoizedState, x = b.stateNode, y = x.getSnapshotBeforeUpdate(b.elementType === b.type ? w : $e6216febf4d6e8a1$var$ej(b.type, w), C);
                        x.__reactInternalSnapshotBeforeUpdate = y;
                    }
                    break;
                case 3:
                    var v = b.stateNode.containerInfo;
                    1 === v.nodeType ? v.textContent = "" : 9 === v.nodeType && v.documentElement && v.removeChild(v.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($e6216febf4d6e8a1$var$p(163));
            }
        } catch (D) {
            $e6216febf4d6e8a1$var$W(b, b.return, D);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $e6216febf4d6e8a1$var$U = a;
            break;
        }
        $e6216febf4d6e8a1$var$U = b.return;
    }
    m = $e6216febf4d6e8a1$var$xk;
    $e6216febf4d6e8a1$var$xk = !1;
    return m;
}
function $e6216febf4d6e8a1$var$zk(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && (0 !== (a & 8) ? null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markComponentPassiveEffectUnmountStarted && $e6216febf4d6e8a1$var$B.markComponentPassiveEffectUnmountStarted(b) : 0 !== (a & 4) && $e6216febf4d6e8a1$var$uc(b), $e6216febf4d6e8a1$var$wk(b, c, f), 0 !== (a & 8) ? null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markComponentPassiveEffectUnmountStopped && $e6216febf4d6e8a1$var$B.markComponentPassiveEffectUnmountStopped() : 0 !== (a & 4) && $e6216febf4d6e8a1$var$vc());
            }
            e = e.next;
        }while (e !== d);
    }
}
function $e6216febf4d6e8a1$var$Ak(a, b) {
    var c = b.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if ((d.tag & a) === a) {
                0 !== (a & 8) ? null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markComponentPassiveEffectMountStarted && $e6216febf4d6e8a1$var$B.markComponentPassiveEffectMountStarted(b) : 0 !== (a & 4) && null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markComponentLayoutEffectMountStarted && $e6216febf4d6e8a1$var$B.markComponentLayoutEffectMountStarted(b);
                var e = d.create;
                d.destroy = e();
                0 !== (a & 8) ? null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markComponentPassiveEffectMountStopped && $e6216febf4d6e8a1$var$B.markComponentPassiveEffectMountStopped() : 0 !== (a & 4) && null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markComponentLayoutEffectMountStopped && $e6216febf4d6e8a1$var$B.markComponentLayoutEffectMountStopped();
            }
            d = d.next;
        }while (d !== c);
    }
}
function $e6216febf4d6e8a1$var$Bk(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        if ("function" === typeof b) {
            if (a.mode & 2) try {
                $e6216febf4d6e8a1$var$cj(), b(c);
            } finally{
                $e6216febf4d6e8a1$var$aj(a);
            }
            else b(c);
        } else b.current = c;
    }
}
function $e6216febf4d6e8a1$var$Ck(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $e6216febf4d6e8a1$var$Ck(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$e6216febf4d6e8a1$var$bg], delete b[$e6216febf4d6e8a1$var$cg], delete b[$e6216febf4d6e8a1$var$Cf], delete b[$e6216febf4d6e8a1$var$dg], delete b[$e6216febf4d6e8a1$var$eg]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $e6216febf4d6e8a1$var$Dk(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $e6216febf4d6e8a1$var$Ek(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $e6216febf4d6e8a1$var$Dk(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $e6216febf4d6e8a1$var$Fk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $e6216febf4d6e8a1$var$Pf));
    else if (4 !== d && (a = a.child, null !== a)) for($e6216febf4d6e8a1$var$Fk(a, b, c), a = a.sibling; null !== a;)$e6216febf4d6e8a1$var$Fk(a, b, c), a = a.sibling;
}
function $e6216febf4d6e8a1$var$Gk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($e6216febf4d6e8a1$var$Gk(a, b, c), a = a.sibling; null !== a;)$e6216febf4d6e8a1$var$Gk(a, b, c), a = a.sibling;
}
var $e6216febf4d6e8a1$var$X = null, $e6216febf4d6e8a1$var$Hk = !1;
function $e6216febf4d6e8a1$var$Ik(a, b, c) {
    for(c = c.child; null !== c;)$e6216febf4d6e8a1$var$Jk(a, b, c), c = c.sibling;
}
function $e6216febf4d6e8a1$var$Jk(a, b, c) {
    if ($e6216febf4d6e8a1$var$lc && "function" === typeof $e6216febf4d6e8a1$var$lc.onCommitFiberUnmount) try {
        $e6216febf4d6e8a1$var$lc.onCommitFiberUnmount($e6216febf4d6e8a1$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $e6216febf4d6e8a1$var$qk || $e6216febf4d6e8a1$var$vk(c, b);
        case 6:
            var d = $e6216febf4d6e8a1$var$X, e = $e6216febf4d6e8a1$var$Hk;
            $e6216febf4d6e8a1$var$X = null;
            $e6216febf4d6e8a1$var$Ik(a, b, c);
            $e6216febf4d6e8a1$var$X = d;
            $e6216febf4d6e8a1$var$Hk = e;
            null !== $e6216febf4d6e8a1$var$X && ($e6216febf4d6e8a1$var$Hk ? (a = $e6216febf4d6e8a1$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $e6216febf4d6e8a1$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $e6216febf4d6e8a1$var$X && ($e6216febf4d6e8a1$var$Hk ? (a = $e6216febf4d6e8a1$var$X, c = c.stateNode, 8 === a.nodeType ? $e6216febf4d6e8a1$var$Yf(a.parentNode, c) : 1 === a.nodeType && $e6216febf4d6e8a1$var$Yf(a, c), $e6216febf4d6e8a1$var$pd(a)) : $e6216febf4d6e8a1$var$Yf($e6216febf4d6e8a1$var$X, c.stateNode));
            break;
        case 4:
            d = $e6216febf4d6e8a1$var$X;
            e = $e6216febf4d6e8a1$var$Hk;
            $e6216febf4d6e8a1$var$X = c.stateNode.containerInfo;
            $e6216febf4d6e8a1$var$Hk = !0;
            $e6216febf4d6e8a1$var$Ik(a, b, c);
            $e6216febf4d6e8a1$var$X = d;
            $e6216febf4d6e8a1$var$Hk = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$e6216febf4d6e8a1$var$qk && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $e6216febf4d6e8a1$var$wk(c, b, g) : 0 !== (f & 4) && ($e6216febf4d6e8a1$var$uc(c), c.mode & 2 ? ($e6216febf4d6e8a1$var$cj(), $e6216febf4d6e8a1$var$wk(c, b, g), $e6216febf4d6e8a1$var$aj(c)) : $e6216febf4d6e8a1$var$wk(c, b, g), $e6216febf4d6e8a1$var$vc()));
                    e = e.next;
                }while (e !== d);
            }
            $e6216febf4d6e8a1$var$Ik(a, b, c);
            break;
        case 1:
            if (!$e6216febf4d6e8a1$var$qk && ($e6216febf4d6e8a1$var$vk(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                $e6216febf4d6e8a1$var$uk(c, d);
            } catch (h) {
                $e6216febf4d6e8a1$var$W(c, b, h);
            }
            $e6216febf4d6e8a1$var$Ik(a, b, c);
            break;
        case 21:
            $e6216febf4d6e8a1$var$Ik(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($e6216febf4d6e8a1$var$qk = (d = $e6216febf4d6e8a1$var$qk) || null !== c.memoizedState, $e6216febf4d6e8a1$var$Ik(a, b, c), $e6216febf4d6e8a1$var$qk = d) : $e6216febf4d6e8a1$var$Ik(a, b, c);
            break;
        default:
            $e6216febf4d6e8a1$var$Ik(a, b, c);
    }
}
function $e6216febf4d6e8a1$var$Kk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $e6216febf4d6e8a1$var$rk);
        b.forEach(function(b) {
            var d = $e6216febf4d6e8a1$var$Lk.bind(null, a, b);
            if (!c.has(b)) {
                c.add(b);
                if ($e6216febf4d6e8a1$var$mc) {
                    if (null !== $e6216febf4d6e8a1$var$sk && null !== $e6216febf4d6e8a1$var$tk) $e6216febf4d6e8a1$var$wj($e6216febf4d6e8a1$var$tk, $e6216febf4d6e8a1$var$sk);
                    else throw Error($e6216febf4d6e8a1$var$p(413));
                }
                b.then(d, d);
            }
        });
    }
}
function $e6216febf4d6e8a1$var$Mk(a, b, c) {
    $e6216febf4d6e8a1$var$sk = c;
    $e6216febf4d6e8a1$var$tk = a;
    $e6216febf4d6e8a1$var$Nk(b, a);
    $e6216febf4d6e8a1$var$tk = $e6216febf4d6e8a1$var$sk = null;
}
function $e6216febf4d6e8a1$var$Ok(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $e6216febf4d6e8a1$var$X = h.stateNode;
                        $e6216febf4d6e8a1$var$Hk = !1;
                        break a;
                    case 3:
                        $e6216febf4d6e8a1$var$X = h.stateNode.containerInfo;
                        $e6216febf4d6e8a1$var$Hk = !0;
                        break a;
                    case 4:
                        $e6216febf4d6e8a1$var$X = h.stateNode.containerInfo;
                        $e6216febf4d6e8a1$var$Hk = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $e6216febf4d6e8a1$var$X) throw Error($e6216febf4d6e8a1$var$p(160));
            $e6216febf4d6e8a1$var$Jk(f, g, e);
            $e6216febf4d6e8a1$var$X = null;
            $e6216febf4d6e8a1$var$Hk = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $e6216febf4d6e8a1$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$e6216febf4d6e8a1$var$Nk(b, a), b = b.sibling;
}
function $e6216febf4d6e8a1$var$Nk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e6216febf4d6e8a1$var$Ok(b, a);
            $e6216febf4d6e8a1$var$Pk(a);
            if (d & 4) {
                try {
                    $e6216febf4d6e8a1$var$zk(3, a, a.return), $e6216febf4d6e8a1$var$Ak(3, a);
                } catch (m) {
                    $e6216febf4d6e8a1$var$W(a, a.return, m);
                }
                if (a.mode & 2) {
                    try {
                        $e6216febf4d6e8a1$var$cj(), $e6216febf4d6e8a1$var$zk(5, a, a.return);
                    } catch (m) {
                        $e6216febf4d6e8a1$var$W(a, a.return, m);
                    }
                    $e6216febf4d6e8a1$var$aj(a);
                } else try {
                    $e6216febf4d6e8a1$var$zk(5, a, a.return);
                } catch (m) {
                    $e6216febf4d6e8a1$var$W(a, a.return, m);
                }
            }
            break;
        case 1:
            $e6216febf4d6e8a1$var$Ok(b, a);
            $e6216febf4d6e8a1$var$Pk(a);
            d & 512 && null !== c && $e6216febf4d6e8a1$var$vk(c, c.return);
            break;
        case 5:
            $e6216febf4d6e8a1$var$Ok(b, a);
            $e6216febf4d6e8a1$var$Pk(a);
            d & 512 && null !== c && $e6216febf4d6e8a1$var$vk(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $e6216febf4d6e8a1$var$ob(e, "");
                } catch (m) {
                    $e6216febf4d6e8a1$var$W(a, a.return, m);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $e6216febf4d6e8a1$var$$a(e, f);
                    $e6216febf4d6e8a1$var$vb(h, g);
                    var l = $e6216febf4d6e8a1$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var n = k[g], q = k[g + 1];
                        "style" === n ? $e6216febf4d6e8a1$var$sb(e, q) : "dangerouslySetInnerHTML" === n ? $e6216febf4d6e8a1$var$nb(e, q) : "children" === n ? $e6216febf4d6e8a1$var$ob(e, q) : $e6216febf4d6e8a1$var$ua(e, n, q, l);
                    }
                    switch(h){
                        case "input":
                            $e6216febf4d6e8a1$var$ab(e, f);
                            break;
                        case "textarea":
                            $e6216febf4d6e8a1$var$hb(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var z = f.value;
                            null != z ? $e6216febf4d6e8a1$var$eb(e, !!f.multiple, z, !1) : r !== !!f.multiple && (null != f.defaultValue ? $e6216febf4d6e8a1$var$eb(e, !!f.multiple, f.defaultValue, !0) : $e6216febf4d6e8a1$var$eb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$e6216febf4d6e8a1$var$cg] = f;
                } catch (m) {
                    $e6216febf4d6e8a1$var$W(a, a.return, m);
                }
            }
            break;
        case 6:
            $e6216febf4d6e8a1$var$Ok(b, a);
            $e6216febf4d6e8a1$var$Pk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($e6216febf4d6e8a1$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (m) {
                    $e6216febf4d6e8a1$var$W(a, a.return, m);
                }
            }
            break;
        case 3:
            $e6216febf4d6e8a1$var$Ok(b, a);
            $e6216febf4d6e8a1$var$Pk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $e6216febf4d6e8a1$var$pd(b.containerInfo);
            } catch (m) {
                $e6216febf4d6e8a1$var$W(a, a.return, m);
            }
            break;
        case 4:
            $e6216febf4d6e8a1$var$Ok(b, a);
            $e6216febf4d6e8a1$var$Pk(a);
            break;
        case 13:
            $e6216febf4d6e8a1$var$Ok(b, a);
            $e6216febf4d6e8a1$var$Pk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($e6216febf4d6e8a1$var$Qk = $e6216febf4d6e8a1$var$A()));
            d & 4 && $e6216febf4d6e8a1$var$Kk(a);
            break;
        case 22:
            n = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($e6216febf4d6e8a1$var$qk = (l = $e6216febf4d6e8a1$var$qk) || n, $e6216febf4d6e8a1$var$Ok(b, a), $e6216febf4d6e8a1$var$qk = l) : $e6216febf4d6e8a1$var$Ok(b, a);
            $e6216febf4d6e8a1$var$Pk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !n && 0 !== (a.mode & 1)) for($e6216febf4d6e8a1$var$U = a, n = a.child; null !== n;){
                    for(q = $e6216febf4d6e8a1$var$U = n; null !== $e6216febf4d6e8a1$var$U;){
                        r = $e6216febf4d6e8a1$var$U;
                        z = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                if (r.mode & 2) try {
                                    $e6216febf4d6e8a1$var$cj(), $e6216febf4d6e8a1$var$zk(4, r, r.return);
                                } finally{
                                    $e6216febf4d6e8a1$var$aj(r);
                                }
                                else $e6216febf4d6e8a1$var$zk(4, r, r.return);
                                break;
                            case 1:
                                $e6216febf4d6e8a1$var$vk(r, r.return);
                                d = r.stateNode;
                                if ("function" === typeof d.componentWillUnmount) {
                                    c = r;
                                    b = r.return;
                                    try {
                                        $e6216febf4d6e8a1$var$uk(c, d);
                                    } catch (m) {
                                        $e6216febf4d6e8a1$var$W(c, b, m);
                                    }
                                }
                                break;
                            case 5:
                                $e6216febf4d6e8a1$var$vk(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $e6216febf4d6e8a1$var$Rk(q);
                                    continue;
                                }
                        }
                        null !== z ? (z.return = r, $e6216febf4d6e8a1$var$U = z) : $e6216febf4d6e8a1$var$Rk(q);
                    }
                    n = n.sibling;
                }
                a: for(n = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === n) {
                            n = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $e6216febf4d6e8a1$var$rb("display", g));
                            } catch (m) {
                                $e6216febf4d6e8a1$var$W(a, a.return, m);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === n) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (m) {
                            $e6216febf4d6e8a1$var$W(a, a.return, m);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        n === q && (n = null);
                        q = q.return;
                    }
                    n === q && (n = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $e6216febf4d6e8a1$var$Ok(b, a);
            $e6216febf4d6e8a1$var$Pk(a);
            d & 4 && $e6216febf4d6e8a1$var$Kk(a);
            break;
        case 21:
            break;
        default:
            $e6216febf4d6e8a1$var$Ok(b, a), $e6216febf4d6e8a1$var$Pk(a);
    }
}
function $e6216febf4d6e8a1$var$Pk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($e6216febf4d6e8a1$var$Dk(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($e6216febf4d6e8a1$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($e6216febf4d6e8a1$var$ob(e, ""), d.flags &= -33);
                    var f = $e6216febf4d6e8a1$var$Ek(a);
                    $e6216febf4d6e8a1$var$Gk(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $e6216febf4d6e8a1$var$Ek(a);
                    $e6216febf4d6e8a1$var$Fk(a, h, g);
                    break;
                default:
                    throw Error($e6216febf4d6e8a1$var$p(161));
            }
        } catch (k) {
            $e6216febf4d6e8a1$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $e6216febf4d6e8a1$var$Sk(a, b, c) {
    $e6216febf4d6e8a1$var$sk = c;
    $e6216febf4d6e8a1$var$tk = b;
    $e6216febf4d6e8a1$var$U = a;
    $e6216febf4d6e8a1$var$Tk(a, b, c);
    $e6216febf4d6e8a1$var$tk = $e6216febf4d6e8a1$var$sk = null;
}
function $e6216febf4d6e8a1$var$Tk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $e6216febf4d6e8a1$var$U;){
        var e = $e6216febf4d6e8a1$var$U, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $e6216febf4d6e8a1$var$pk;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $e6216febf4d6e8a1$var$qk;
                h = $e6216febf4d6e8a1$var$pk;
                var l = $e6216febf4d6e8a1$var$qk;
                $e6216febf4d6e8a1$var$pk = g;
                if (($e6216febf4d6e8a1$var$qk = k) && !l) for($e6216febf4d6e8a1$var$U = e; null !== $e6216febf4d6e8a1$var$U;)g = $e6216febf4d6e8a1$var$U, k = g.child, 22 === g.tag && null !== g.memoizedState ? $e6216febf4d6e8a1$var$Uk(e) : null !== k ? (k.return = g, $e6216febf4d6e8a1$var$U = k) : $e6216febf4d6e8a1$var$Uk(e);
                for(; null !== f;)$e6216febf4d6e8a1$var$U = f, $e6216febf4d6e8a1$var$Tk(f, b, c), f = f.sibling;
                $e6216febf4d6e8a1$var$U = e;
                $e6216febf4d6e8a1$var$pk = h;
                $e6216febf4d6e8a1$var$qk = l;
            }
            $e6216febf4d6e8a1$var$Vk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $e6216febf4d6e8a1$var$U = f) : $e6216febf4d6e8a1$var$Vk(a, b, c);
    }
}
function $e6216febf4d6e8a1$var$Vk(a) {
    for(; null !== $e6216febf4d6e8a1$var$U;){
        var b = $e6216febf4d6e8a1$var$U;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        if (!$e6216febf4d6e8a1$var$qk) {
                            if (b.mode & 2) try {
                                $e6216febf4d6e8a1$var$cj(), $e6216febf4d6e8a1$var$Ak(5, b);
                            } finally{
                                $e6216febf4d6e8a1$var$aj(b);
                            }
                            else $e6216febf4d6e8a1$var$Ak(5, b);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$e6216febf4d6e8a1$var$qk) {
                            if (null === c) {
                                if (b.mode & 2) try {
                                    $e6216febf4d6e8a1$var$cj(), d.componentDidMount();
                                } finally{
                                    $e6216febf4d6e8a1$var$aj(b);
                                }
                                else d.componentDidMount();
                            } else {
                                var e = b.elementType === b.type ? c.memoizedProps : $e6216febf4d6e8a1$var$ej(b.type, c.memoizedProps), f = c.memoizedState;
                                if (b.mode & 2) try {
                                    $e6216febf4d6e8a1$var$cj(), d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                                } finally{
                                    $e6216febf4d6e8a1$var$aj(b);
                                }
                                else d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var g = b.updateQueue;
                        null !== g && $e6216febf4d6e8a1$var$Gh(b, g, d);
                        break;
                    case 3:
                        var h = b.updateQueue;
                        if (null !== h) {
                            var k = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    k = b.child.stateNode;
                                    break;
                                case 1:
                                    k = b.child.stateNode;
                            }
                            $e6216febf4d6e8a1$var$Gh(b, h, k);
                        }
                        break;
                    case 5:
                        var l = b.stateNode;
                        if (null === c && b.flags & 4) {
                            k = l;
                            var n = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    n.autoFocus && k.focus();
                                    break;
                                case "img":
                                    n.src && (k.src = n.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        var q = b.memoizedProps, r = q.onCommit, z = q.onRender, m = b.stateNode.effectDuration;
                        k = $e6216febf4d6e8a1$var$Ui;
                        c = null === c ? "mount" : "update";
                        $e6216febf4d6e8a1$var$Yi && (c = "nested-update");
                        "function" === typeof z && z(b.memoizedProps.id, c, b.actualDuration, b.treeBaseDuration, b.actualStartTime, k);
                        "function" === typeof r && r(b.memoizedProps.id, c, m, k);
                        $e6216febf4d6e8a1$var$Wk(b);
                        var w = b.return;
                        a: for(; null !== w;){
                            switch(w.tag){
                                case 3:
                                    w.stateNode.effectDuration += m;
                                    break a;
                                case 12:
                                    w.stateNode.effectDuration += m;
                                    break a;
                            }
                            w = w.return;
                        }
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var C = b.alternate;
                            if (null !== C) {
                                var x = C.memoizedState;
                                if (null !== x) {
                                    var y = x.dehydrated;
                                    null !== y && $e6216febf4d6e8a1$var$pd(y);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($e6216febf4d6e8a1$var$p(163));
                }
                $e6216febf4d6e8a1$var$qk || b.flags & 512 && $e6216febf4d6e8a1$var$Bk(b);
            } catch (v) {
                $e6216febf4d6e8a1$var$W(b, b.return, v);
            }
        }
        if (b === a) {
            $e6216febf4d6e8a1$var$U = null;
            break;
        }
        k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $e6216febf4d6e8a1$var$U = k;
            break;
        }
        $e6216febf4d6e8a1$var$U = b.return;
    }
}
function $e6216febf4d6e8a1$var$Rk(a) {
    for(; null !== $e6216febf4d6e8a1$var$U;){
        var b = $e6216febf4d6e8a1$var$U;
        if (b === a) {
            $e6216febf4d6e8a1$var$U = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e6216febf4d6e8a1$var$U = c;
            break;
        }
        $e6216febf4d6e8a1$var$U = b.return;
    }
}
function $e6216febf4d6e8a1$var$Uk(a) {
    for(; null !== $e6216febf4d6e8a1$var$U;){
        var b = $e6216febf4d6e8a1$var$U;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    if (b.mode & 2) try {
                        $e6216febf4d6e8a1$var$cj();
                        var c = b.return;
                        try {
                            $e6216febf4d6e8a1$var$Ak(4, b);
                        } catch (l) {
                            $e6216febf4d6e8a1$var$W(b, c, l);
                        }
                    } finally{
                        $e6216febf4d6e8a1$var$aj(b);
                    }
                    else {
                        var d = b.return;
                        try {
                            $e6216febf4d6e8a1$var$Ak(4, b);
                        } catch (l) {
                            $e6216febf4d6e8a1$var$W(b, d, l);
                        }
                    }
                    break;
                case 1:
                    var e = b.stateNode;
                    if ("function" === typeof e.componentDidMount) {
                        var f = b.return;
                        try {
                            e.componentDidMount();
                        } catch (l) {
                            $e6216febf4d6e8a1$var$W(b, f, l);
                        }
                    }
                    var g = b.return;
                    try {
                        $e6216febf4d6e8a1$var$Bk(b);
                    } catch (l) {
                        $e6216febf4d6e8a1$var$W(b, g, l);
                    }
                    break;
                case 5:
                    var h = b.return;
                    try {
                        $e6216febf4d6e8a1$var$Bk(b);
                    } catch (l) {
                        $e6216febf4d6e8a1$var$W(b, h, l);
                    }
            }
        } catch (l) {
            $e6216febf4d6e8a1$var$W(b, b.return, l);
        }
        if (b === a) {
            $e6216febf4d6e8a1$var$U = null;
            break;
        }
        var k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $e6216febf4d6e8a1$var$U = k;
            break;
        }
        $e6216febf4d6e8a1$var$U = b.return;
    }
}
var $e6216febf4d6e8a1$var$Xk = Math.ceil, $e6216febf4d6e8a1$var$Yk = $e6216febf4d6e8a1$var$va.ReactCurrentDispatcher, $e6216febf4d6e8a1$var$Zk = $e6216febf4d6e8a1$var$va.ReactCurrentOwner, $e6216febf4d6e8a1$var$$k = $e6216febf4d6e8a1$var$va.ReactCurrentBatchConfig, $e6216febf4d6e8a1$var$K = 0, $e6216febf4d6e8a1$var$Q = null, $e6216febf4d6e8a1$var$Y = null, $e6216febf4d6e8a1$var$Z = 0, $e6216febf4d6e8a1$var$Jj = 0, $e6216febf4d6e8a1$var$Ij = $e6216febf4d6e8a1$var$hg(0), $e6216febf4d6e8a1$var$T = 0, $e6216febf4d6e8a1$var$al = null, $e6216febf4d6e8a1$var$Fh = 0, $e6216febf4d6e8a1$var$bl = 0, $e6216febf4d6e8a1$var$cl = 0, $e6216febf4d6e8a1$var$dl = null, $e6216febf4d6e8a1$var$el = null, $e6216febf4d6e8a1$var$Qk = 0, $e6216febf4d6e8a1$var$mk = Infinity, $e6216febf4d6e8a1$var$fl = null, $e6216febf4d6e8a1$var$qj = !1, $e6216febf4d6e8a1$var$rj = null, $e6216febf4d6e8a1$var$tj = null, $e6216febf4d6e8a1$var$gl = !1, $e6216febf4d6e8a1$var$hl = null, $e6216febf4d6e8a1$var$il = 0, $e6216febf4d6e8a1$var$jl = [], $e6216febf4d6e8a1$var$kl = 0, $e6216febf4d6e8a1$var$ll = null, $e6216febf4d6e8a1$var$ml = -1, $e6216febf4d6e8a1$var$nl = 0;
function $e6216febf4d6e8a1$var$Ri() {
    return 0 !== ($e6216febf4d6e8a1$var$K & 6) ? $e6216febf4d6e8a1$var$A() : -1 !== $e6216febf4d6e8a1$var$ml ? $e6216febf4d6e8a1$var$ml : $e6216febf4d6e8a1$var$ml = $e6216febf4d6e8a1$var$A();
}
function $e6216febf4d6e8a1$var$Oi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($e6216febf4d6e8a1$var$K & 2) && 0 !== $e6216febf4d6e8a1$var$Z) return $e6216febf4d6e8a1$var$Z & -$e6216febf4d6e8a1$var$Z;
    if (null !== $e6216febf4d6e8a1$var$Yg.transition) return 0 === $e6216febf4d6e8a1$var$nl && ($e6216febf4d6e8a1$var$nl = $e6216febf4d6e8a1$var$Kc()), $e6216febf4d6e8a1$var$nl;
    a = $e6216febf4d6e8a1$var$E;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $e6216febf4d6e8a1$var$xd(a.type);
    return a;
}
function $e6216febf4d6e8a1$var$ui(a, b, c, d) {
    if (50 < $e6216febf4d6e8a1$var$kl) throw $e6216febf4d6e8a1$var$kl = 0, $e6216febf4d6e8a1$var$ll = null, Error($e6216febf4d6e8a1$var$p(185));
    $e6216febf4d6e8a1$var$Mc(a, c, d);
    if (0 === ($e6216febf4d6e8a1$var$K & 2) || a !== $e6216febf4d6e8a1$var$Q) $e6216febf4d6e8a1$var$mc && $e6216febf4d6e8a1$var$Pc(a, b, c), a === $e6216febf4d6e8a1$var$Q && (0 === ($e6216febf4d6e8a1$var$K & 2) && ($e6216febf4d6e8a1$var$bl |= c), 4 === $e6216febf4d6e8a1$var$T && $e6216febf4d6e8a1$var$ol(a, $e6216febf4d6e8a1$var$Z)), $e6216febf4d6e8a1$var$pl(a, d), 1 === c && 0 === $e6216febf4d6e8a1$var$K && 0 === (b.mode & 1) && ($e6216febf4d6e8a1$var$mk = $e6216febf4d6e8a1$var$A() + 500, $e6216febf4d6e8a1$var$tg && $e6216febf4d6e8a1$var$xg());
}
function $e6216febf4d6e8a1$var$pl(a, b) {
    var c = a.callbackNode;
    $e6216febf4d6e8a1$var$Ic(a, b);
    var d = $e6216febf4d6e8a1$var$Gc(a, a === $e6216febf4d6e8a1$var$Q ? $e6216febf4d6e8a1$var$Z : 0);
    if (0 === d) null !== c && $e6216febf4d6e8a1$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $e6216febf4d6e8a1$var$bc(c);
        if (1 === b) 0 === a.tag ? $e6216febf4d6e8a1$var$wg($e6216febf4d6e8a1$var$ql.bind(null, a)) : $e6216febf4d6e8a1$var$vg($e6216febf4d6e8a1$var$ql.bind(null, a)), $e6216febf4d6e8a1$var$Xf(function() {
            0 === ($e6216febf4d6e8a1$var$K & 6) && $e6216febf4d6e8a1$var$xg();
        }), c = null;
        else {
            switch($e6216febf4d6e8a1$var$Rc(d)){
                case 1:
                    c = $e6216febf4d6e8a1$var$fc;
                    break;
                case 4:
                    c = $e6216febf4d6e8a1$var$gc;
                    break;
                case 16:
                    c = $e6216febf4d6e8a1$var$hc;
                    break;
                case 536870912:
                    c = $e6216febf4d6e8a1$var$jc;
                    break;
                default:
                    c = $e6216febf4d6e8a1$var$hc;
            }
            c = $e6216febf4d6e8a1$var$rl(c, $e6216febf4d6e8a1$var$sl.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $e6216febf4d6e8a1$var$sl(a, b) {
    $e6216febf4d6e8a1$var$Zi = $e6216febf4d6e8a1$var$Yi = !1;
    $e6216febf4d6e8a1$var$ml = -1;
    $e6216febf4d6e8a1$var$nl = 0;
    if (0 !== ($e6216febf4d6e8a1$var$K & 6)) throw Error($e6216febf4d6e8a1$var$p(327));
    var c = a.callbackNode;
    if ($e6216febf4d6e8a1$var$tl() && a.callbackNode !== c) return null;
    var d = $e6216febf4d6e8a1$var$Gc(a, a === $e6216febf4d6e8a1$var$Q ? $e6216febf4d6e8a1$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $e6216febf4d6e8a1$var$ul(a, d);
    else {
        b = d;
        var e = $e6216febf4d6e8a1$var$K;
        $e6216febf4d6e8a1$var$K |= 2;
        var f = $e6216febf4d6e8a1$var$vl();
        if ($e6216febf4d6e8a1$var$Q !== a || $e6216febf4d6e8a1$var$Z !== b) {
            if ($e6216febf4d6e8a1$var$mc) {
                var g = a.memoizedUpdaters;
                0 < g.size && ($e6216febf4d6e8a1$var$wj(a, $e6216febf4d6e8a1$var$Z), g.clear());
                $e6216febf4d6e8a1$var$Qc(a, b);
            }
            $e6216febf4d6e8a1$var$fl = null;
            $e6216febf4d6e8a1$var$mk = $e6216febf4d6e8a1$var$A() + 500;
            $e6216febf4d6e8a1$var$wl(a, b);
        }
        $e6216febf4d6e8a1$var$wc(b);
        for(;;)try {
            $e6216febf4d6e8a1$var$xl();
            break;
        } catch (h) {
            $e6216febf4d6e8a1$var$yl(a, h);
        }
        $e6216febf4d6e8a1$var$nh();
        $e6216febf4d6e8a1$var$Yk.current = f;
        $e6216febf4d6e8a1$var$K = e;
        null !== $e6216febf4d6e8a1$var$Y ? (null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markRenderYielded && $e6216febf4d6e8a1$var$B.markRenderYielded(), b = 0) : ($e6216febf4d6e8a1$var$xc(), $e6216febf4d6e8a1$var$Q = null, $e6216febf4d6e8a1$var$Z = 0, b = $e6216febf4d6e8a1$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $e6216febf4d6e8a1$var$Jc(a), 0 !== e && (d = e, b = $e6216febf4d6e8a1$var$zl(a, e)));
        if (1 === b) throw c = $e6216febf4d6e8a1$var$al, $e6216febf4d6e8a1$var$wl(a, 0), $e6216febf4d6e8a1$var$ol(a, d), $e6216febf4d6e8a1$var$pl(a, $e6216febf4d6e8a1$var$A()), c;
        if (6 === b) $e6216febf4d6e8a1$var$ol(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$e6216febf4d6e8a1$var$Al(e) && (b = $e6216febf4d6e8a1$var$ul(a, d), 2 === b && (f = $e6216febf4d6e8a1$var$Jc(a), 0 !== f && (d = f, b = $e6216febf4d6e8a1$var$zl(a, f))), 1 === b)) throw c = $e6216febf4d6e8a1$var$al, $e6216febf4d6e8a1$var$wl(a, 0), $e6216febf4d6e8a1$var$ol(a, d), $e6216febf4d6e8a1$var$pl(a, $e6216febf4d6e8a1$var$A()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($e6216febf4d6e8a1$var$p(345));
                case 2:
                    $e6216febf4d6e8a1$var$Cl(a, $e6216febf4d6e8a1$var$el, $e6216febf4d6e8a1$var$fl);
                    break;
                case 3:
                    $e6216febf4d6e8a1$var$ol(a, d);
                    if ((d & 130023424) === d && (b = $e6216febf4d6e8a1$var$Qk + 500 - $e6216febf4d6e8a1$var$A(), 10 < b)) {
                        if (0 !== $e6216febf4d6e8a1$var$Gc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $e6216febf4d6e8a1$var$Ri();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $e6216febf4d6e8a1$var$Tf($e6216febf4d6e8a1$var$Cl.bind(null, a, $e6216febf4d6e8a1$var$el, $e6216febf4d6e8a1$var$fl), b);
                        break;
                    }
                    $e6216febf4d6e8a1$var$Cl(a, $e6216febf4d6e8a1$var$el, $e6216febf4d6e8a1$var$fl);
                    break;
                case 4:
                    $e6216febf4d6e8a1$var$ol(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;)g = 31 - $e6216febf4d6e8a1$var$Ac(d), f = 1 << g, g = b[g], g > e && (e = g), d &= ~f;
                    d = e;
                    d = $e6216febf4d6e8a1$var$A() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $e6216febf4d6e8a1$var$Xk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $e6216febf4d6e8a1$var$Tf($e6216febf4d6e8a1$var$Cl.bind(null, a, $e6216febf4d6e8a1$var$el, $e6216febf4d6e8a1$var$fl), d);
                        break;
                    }
                    $e6216febf4d6e8a1$var$Cl(a, $e6216febf4d6e8a1$var$el, $e6216febf4d6e8a1$var$fl);
                    break;
                case 5:
                    $e6216febf4d6e8a1$var$Cl(a, $e6216febf4d6e8a1$var$el, $e6216febf4d6e8a1$var$fl);
                    break;
                default:
                    throw Error($e6216febf4d6e8a1$var$p(329));
            }
        }
    }
    $e6216febf4d6e8a1$var$pl(a, $e6216febf4d6e8a1$var$A());
    return a.callbackNode === c ? $e6216febf4d6e8a1$var$sl.bind(null, a) : null;
}
function $e6216febf4d6e8a1$var$zl(a, b) {
    var c = $e6216febf4d6e8a1$var$dl;
    a.current.memoizedState.isDehydrated && ($e6216febf4d6e8a1$var$wl(a, b).flags |= 256);
    a = $e6216febf4d6e8a1$var$ul(a, b);
    2 !== a && (b = $e6216febf4d6e8a1$var$el, $e6216febf4d6e8a1$var$el = c, null !== b && $e6216febf4d6e8a1$var$lk(b));
    return a;
}
function $e6216febf4d6e8a1$var$lk(a) {
    null === $e6216febf4d6e8a1$var$el ? $e6216febf4d6e8a1$var$el = a : $e6216febf4d6e8a1$var$el.push.apply($e6216febf4d6e8a1$var$el, a);
}
function $e6216febf4d6e8a1$var$Al(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$e6216febf4d6e8a1$var$Ve(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $e6216febf4d6e8a1$var$ol(a, b) {
    b &= ~$e6216febf4d6e8a1$var$cl;
    b &= ~$e6216febf4d6e8a1$var$bl;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $e6216febf4d6e8a1$var$Ac(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $e6216febf4d6e8a1$var$ql(a) {
    $e6216febf4d6e8a1$var$Yi = $e6216febf4d6e8a1$var$Zi;
    $e6216febf4d6e8a1$var$Zi = !1;
    if (0 !== ($e6216febf4d6e8a1$var$K & 6)) throw Error($e6216febf4d6e8a1$var$p(327));
    $e6216febf4d6e8a1$var$tl();
    var b = $e6216febf4d6e8a1$var$Gc(a, 0);
    if (0 === (b & 1)) return $e6216febf4d6e8a1$var$pl(a, $e6216febf4d6e8a1$var$A()), null;
    var c = $e6216febf4d6e8a1$var$ul(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $e6216febf4d6e8a1$var$Jc(a);
        0 !== d && (b = d, c = $e6216febf4d6e8a1$var$zl(a, d));
    }
    if (1 === c) throw c = $e6216febf4d6e8a1$var$al, $e6216febf4d6e8a1$var$wl(a, 0), $e6216febf4d6e8a1$var$ol(a, b), $e6216febf4d6e8a1$var$pl(a, $e6216febf4d6e8a1$var$A()), c;
    if (6 === c) throw Error($e6216febf4d6e8a1$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $e6216febf4d6e8a1$var$Cl(a, $e6216febf4d6e8a1$var$el, $e6216febf4d6e8a1$var$fl);
    $e6216febf4d6e8a1$var$pl(a, $e6216febf4d6e8a1$var$A());
    return null;
}
function $e6216febf4d6e8a1$var$Dl(a, b) {
    var c = $e6216febf4d6e8a1$var$K;
    $e6216febf4d6e8a1$var$K |= 1;
    try {
        return a(b);
    } finally{
        $e6216febf4d6e8a1$var$K = c, 0 === $e6216febf4d6e8a1$var$K && ($e6216febf4d6e8a1$var$mk = $e6216febf4d6e8a1$var$A() + 500, $e6216febf4d6e8a1$var$tg && $e6216febf4d6e8a1$var$xg());
    }
}
function $e6216febf4d6e8a1$var$El(a) {
    null !== $e6216febf4d6e8a1$var$hl && 0 === $e6216febf4d6e8a1$var$hl.tag && 0 === ($e6216febf4d6e8a1$var$K & 6) && $e6216febf4d6e8a1$var$tl();
    var b = $e6216febf4d6e8a1$var$K;
    $e6216febf4d6e8a1$var$K |= 1;
    var c = $e6216febf4d6e8a1$var$$k.transition, d = $e6216febf4d6e8a1$var$E;
    try {
        if ($e6216febf4d6e8a1$var$$k.transition = null, $e6216febf4d6e8a1$var$E = 1, a) return a();
    } finally{
        $e6216febf4d6e8a1$var$E = d, $e6216febf4d6e8a1$var$$k.transition = c, $e6216febf4d6e8a1$var$K = b, 0 === ($e6216febf4d6e8a1$var$K & 6) && $e6216febf4d6e8a1$var$xg();
    }
}
function $e6216febf4d6e8a1$var$nk() {
    $e6216febf4d6e8a1$var$Jj = $e6216febf4d6e8a1$var$Ij.current;
    $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$Ij);
}
function $e6216febf4d6e8a1$var$wl(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $e6216febf4d6e8a1$var$Uf(c));
    if (null !== $e6216febf4d6e8a1$var$Y) for(c = $e6216febf4d6e8a1$var$Y.return; null !== c;){
        var d = c;
        $e6216febf4d6e8a1$var$Kg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $e6216febf4d6e8a1$var$ng();
                break;
            case 3:
                $e6216febf4d6e8a1$var$Nh();
                $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$jg);
                $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$I);
                $e6216febf4d6e8a1$var$Sh();
                break;
            case 5:
                $e6216febf4d6e8a1$var$Ph(d);
                break;
            case 4:
                $e6216febf4d6e8a1$var$Nh();
                break;
            case 13:
                $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$L);
                break;
            case 19:
                $e6216febf4d6e8a1$var$G($e6216febf4d6e8a1$var$L);
                break;
            case 10:
                $e6216febf4d6e8a1$var$oh(d.type._context);
                break;
            case 22:
            case 23:
                $e6216febf4d6e8a1$var$nk();
        }
        c = c.return;
    }
    $e6216febf4d6e8a1$var$Q = a;
    $e6216febf4d6e8a1$var$Y = a = $e6216febf4d6e8a1$var$ch(a.current, null);
    $e6216febf4d6e8a1$var$Z = $e6216febf4d6e8a1$var$Jj = b;
    $e6216febf4d6e8a1$var$T = 0;
    $e6216febf4d6e8a1$var$al = null;
    $e6216febf4d6e8a1$var$cl = $e6216febf4d6e8a1$var$bl = $e6216febf4d6e8a1$var$Fh = 0;
    $e6216febf4d6e8a1$var$el = $e6216febf4d6e8a1$var$dl = null;
    if (null !== $e6216febf4d6e8a1$var$th) {
        for(b = 0; b < $e6216febf4d6e8a1$var$th.length; b++)if (c = $e6216febf4d6e8a1$var$th[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $e6216febf4d6e8a1$var$th = null;
    }
    return a;
}
function $e6216febf4d6e8a1$var$yl(a, b) {
    do {
        var c = $e6216febf4d6e8a1$var$Y;
        try {
            $e6216febf4d6e8a1$var$nh();
            $e6216febf4d6e8a1$var$Th.current = $e6216febf4d6e8a1$var$ei;
            if ($e6216febf4d6e8a1$var$Wh) {
                for(var d = $e6216febf4d6e8a1$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $e6216febf4d6e8a1$var$Wh = !1;
            }
            $e6216febf4d6e8a1$var$Vh = 0;
            $e6216febf4d6e8a1$var$O = $e6216febf4d6e8a1$var$N = $e6216febf4d6e8a1$var$M = null;
            $e6216febf4d6e8a1$var$Xh = !1;
            $e6216febf4d6e8a1$var$Yh = 0;
            $e6216febf4d6e8a1$var$Zk.current = null;
            if (null === c || null === c.return) {
                $e6216febf4d6e8a1$var$T = 1;
                $e6216febf4d6e8a1$var$al = b;
                $e6216febf4d6e8a1$var$Y = null;
                break;
            }
            c.mode & 2 && $e6216febf4d6e8a1$var$$i(c, !0);
            $e6216febf4d6e8a1$var$tc();
            if (null !== b && "object" === typeof b && "function" === typeof b.then) {
                var f = b;
                null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markComponentSuspended && $e6216febf4d6e8a1$var$B.markComponentSuspended(c, f, $e6216febf4d6e8a1$var$Z);
            } else null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markComponentErrored && $e6216febf4d6e8a1$var$B.markComponentErrored(c, b, $e6216febf4d6e8a1$var$Z);
            a: {
                var g = a, h = c.return, k = c;
                f = b;
                b = $e6216febf4d6e8a1$var$Z;
                k.flags |= 32768;
                $e6216febf4d6e8a1$var$mc && $e6216febf4d6e8a1$var$wj(g, b);
                if (null !== f && "object" === typeof f && "function" === typeof f.then) {
                    var l = f, n = k, q = n.tag;
                    if (0 === (n.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = n.alternate;
                        r ? (n.updateQueue = r.updateQueue, n.memoizedState = r.memoizedState, n.lanes = r.lanes) : (n.updateQueue = null, n.memoizedState = null);
                    }
                    var z = $e6216febf4d6e8a1$var$xj(h);
                    if (null !== z) {
                        z.flags &= -257;
                        $e6216febf4d6e8a1$var$yj(z, h, k, g, b);
                        z.mode & 1 && $e6216febf4d6e8a1$var$uj(g, l, b);
                        b = z;
                        f = l;
                        var m = b.updateQueue;
                        if (null === m) {
                            var w = new Set;
                            w.add(f);
                            b.updateQueue = w;
                        } else m.add(f);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $e6216febf4d6e8a1$var$uj(g, l, b);
                            $e6216febf4d6e8a1$var$Zj();
                            break a;
                        }
                        f = Error($e6216febf4d6e8a1$var$p(426));
                    }
                } else if ($e6216febf4d6e8a1$var$J && k.mode & 1) {
                    var C = $e6216febf4d6e8a1$var$xj(h);
                    if (null !== C) {
                        0 === (C.flags & 65536) && (C.flags |= 256);
                        $e6216febf4d6e8a1$var$yj(C, h, k, g, b);
                        $e6216febf4d6e8a1$var$Xg($e6216febf4d6e8a1$var$lj(f, k));
                        break a;
                    }
                }
                g = f = $e6216febf4d6e8a1$var$lj(f, k);
                4 !== $e6216febf4d6e8a1$var$T && ($e6216febf4d6e8a1$var$T = 2);
                null === $e6216febf4d6e8a1$var$dl ? $e6216febf4d6e8a1$var$dl = [
                    g
                ] : $e6216febf4d6e8a1$var$dl.push(g);
                g = h;
                do {
                    switch(g.tag){
                        case 3:
                            g.flags |= 65536;
                            b &= -b;
                            g.lanes |= b;
                            var x = $e6216febf4d6e8a1$var$pj(g, f, b);
                            $e6216febf4d6e8a1$var$Dh(g, x);
                            break a;
                        case 1:
                            k = f;
                            var y = g.type, v = g.stateNode;
                            if (0 === (g.flags & 128) && ("function" === typeof y.getDerivedStateFromError || null !== v && "function" === typeof v.componentDidCatch && (null === $e6216febf4d6e8a1$var$tj || !$e6216febf4d6e8a1$var$tj.has(v)))) {
                                g.flags |= 65536;
                                b &= -b;
                                g.lanes |= b;
                                var D = $e6216febf4d6e8a1$var$sj(g, k, b);
                                $e6216febf4d6e8a1$var$Dh(g, D);
                                break a;
                            }
                    }
                    g = g.return;
                }while (null !== g);
            }
            $e6216febf4d6e8a1$var$Fl(c);
        } catch (ca) {
            b = ca;
            $e6216febf4d6e8a1$var$Y === c && null !== c && ($e6216febf4d6e8a1$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $e6216febf4d6e8a1$var$vl() {
    var a = $e6216febf4d6e8a1$var$Yk.current;
    $e6216febf4d6e8a1$var$Yk.current = $e6216febf4d6e8a1$var$ei;
    return null === a ? $e6216febf4d6e8a1$var$ei : a;
}
function $e6216febf4d6e8a1$var$Zj() {
    if (0 === $e6216febf4d6e8a1$var$T || 3 === $e6216febf4d6e8a1$var$T || 2 === $e6216febf4d6e8a1$var$T) $e6216febf4d6e8a1$var$T = 4;
    null === $e6216febf4d6e8a1$var$Q || 0 === ($e6216febf4d6e8a1$var$Fh & 268435455) && 0 === ($e6216febf4d6e8a1$var$bl & 268435455) || $e6216febf4d6e8a1$var$ol($e6216febf4d6e8a1$var$Q, $e6216febf4d6e8a1$var$Z);
}
function $e6216febf4d6e8a1$var$ul(a, b) {
    var c = $e6216febf4d6e8a1$var$K;
    $e6216febf4d6e8a1$var$K |= 2;
    var d = $e6216febf4d6e8a1$var$vl();
    if ($e6216febf4d6e8a1$var$Q !== a || $e6216febf4d6e8a1$var$Z !== b) {
        if ($e6216febf4d6e8a1$var$mc) {
            var e = a.memoizedUpdaters;
            0 < e.size && ($e6216febf4d6e8a1$var$wj(a, $e6216febf4d6e8a1$var$Z), e.clear());
            $e6216febf4d6e8a1$var$Qc(a, b);
        }
        $e6216febf4d6e8a1$var$fl = null;
        $e6216febf4d6e8a1$var$wl(a, b);
    }
    $e6216febf4d6e8a1$var$wc(b);
    for(;;)try {
        $e6216febf4d6e8a1$var$Gl();
        break;
    } catch (f) {
        $e6216febf4d6e8a1$var$yl(a, f);
    }
    $e6216febf4d6e8a1$var$nh();
    $e6216febf4d6e8a1$var$K = c;
    $e6216febf4d6e8a1$var$Yk.current = d;
    if (null !== $e6216febf4d6e8a1$var$Y) throw Error($e6216febf4d6e8a1$var$p(261));
    $e6216febf4d6e8a1$var$xc();
    $e6216febf4d6e8a1$var$Q = null;
    $e6216febf4d6e8a1$var$Z = 0;
    return $e6216febf4d6e8a1$var$T;
}
function $e6216febf4d6e8a1$var$Gl() {
    for(; null !== $e6216febf4d6e8a1$var$Y;)$e6216febf4d6e8a1$var$Hl($e6216febf4d6e8a1$var$Y);
}
function $e6216febf4d6e8a1$var$xl() {
    for(; null !== $e6216febf4d6e8a1$var$Y && !$e6216febf4d6e8a1$var$cc();)$e6216febf4d6e8a1$var$Hl($e6216febf4d6e8a1$var$Y);
}
function $e6216febf4d6e8a1$var$Hl(a) {
    var b = a.alternate;
    0 !== (a.mode & 2) ? ($e6216febf4d6e8a1$var$Wi = $e6216febf4d6e8a1$var$Ti(), 0 > a.actualStartTime && (a.actualStartTime = $e6216febf4d6e8a1$var$Ti()), b = $e6216febf4d6e8a1$var$Il(b, a, $e6216febf4d6e8a1$var$Jj), $e6216febf4d6e8a1$var$$i(a, !0)) : b = $e6216febf4d6e8a1$var$Il(b, a, $e6216febf4d6e8a1$var$Jj);
    a.memoizedProps = a.pendingProps;
    null === b ? $e6216febf4d6e8a1$var$Fl(a) : $e6216febf4d6e8a1$var$Y = b;
    $e6216febf4d6e8a1$var$Zk.current = null;
}
function $e6216febf4d6e8a1$var$Fl(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (0 === (b.mode & 2)) c = $e6216febf4d6e8a1$var$kk(c, b, $e6216febf4d6e8a1$var$Jj);
            else {
                var d = b;
                $e6216febf4d6e8a1$var$Wi = $e6216febf4d6e8a1$var$Ti();
                0 > d.actualStartTime && (d.actualStartTime = $e6216febf4d6e8a1$var$Ti());
                c = $e6216febf4d6e8a1$var$kk(c, b, $e6216febf4d6e8a1$var$Jj);
                $e6216febf4d6e8a1$var$$i(b, !1);
            }
            if (null !== c) {
                $e6216febf4d6e8a1$var$Y = c;
                return;
            }
        } else {
            c = $e6216febf4d6e8a1$var$ok(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $e6216febf4d6e8a1$var$Y = c;
                return;
            }
            if (0 !== (b.mode & 2)) {
                $e6216febf4d6e8a1$var$$i(b, !1);
                c = b.actualDuration;
                for(d = b.child; null !== d;)c += d.actualDuration, d = d.sibling;
                b.actualDuration = c;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $e6216febf4d6e8a1$var$T = 6;
                $e6216febf4d6e8a1$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $e6216febf4d6e8a1$var$Y = b;
            return;
        }
        $e6216febf4d6e8a1$var$Y = b = a;
    }while (null !== b);
    0 === $e6216febf4d6e8a1$var$T && ($e6216febf4d6e8a1$var$T = 5);
}
function $e6216febf4d6e8a1$var$Cl(a, b, c) {
    var d = $e6216febf4d6e8a1$var$E, e = $e6216febf4d6e8a1$var$$k.transition;
    try {
        $e6216febf4d6e8a1$var$$k.transition = null, $e6216febf4d6e8a1$var$E = 1, $e6216febf4d6e8a1$var$Jl(a, b, c, d);
    } finally{
        $e6216febf4d6e8a1$var$$k.transition = e, $e6216febf4d6e8a1$var$E = d;
    }
    return null;
}
function $e6216febf4d6e8a1$var$Jl(a, b, c, d) {
    do $e6216febf4d6e8a1$var$tl();
    while (null !== $e6216febf4d6e8a1$var$hl);
    if (0 !== ($e6216febf4d6e8a1$var$K & 6)) throw Error($e6216febf4d6e8a1$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markCommitStarted && $e6216febf4d6e8a1$var$B.markCommitStarted(e);
    if (null === c) return $e6216febf4d6e8a1$var$rc(), null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($e6216febf4d6e8a1$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $e6216febf4d6e8a1$var$Nc(a, f);
    a === $e6216febf4d6e8a1$var$Q && ($e6216febf4d6e8a1$var$Y = $e6216febf4d6e8a1$var$Q = null, $e6216febf4d6e8a1$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $e6216febf4d6e8a1$var$gl || ($e6216febf4d6e8a1$var$gl = !0, $e6216febf4d6e8a1$var$rl($e6216febf4d6e8a1$var$hc, function() {
        $e6216febf4d6e8a1$var$tl();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $e6216febf4d6e8a1$var$$k.transition;
        $e6216febf4d6e8a1$var$$k.transition = null;
        var g = $e6216febf4d6e8a1$var$E;
        $e6216febf4d6e8a1$var$E = 1;
        var h = $e6216febf4d6e8a1$var$K;
        $e6216febf4d6e8a1$var$K |= 4;
        $e6216febf4d6e8a1$var$Zk.current = null;
        $e6216febf4d6e8a1$var$yk(a, c);
        $e6216febf4d6e8a1$var$Ui = $e6216febf4d6e8a1$var$Ti();
        $e6216febf4d6e8a1$var$Mk(a, c, e);
        $e6216febf4d6e8a1$var$bf($e6216febf4d6e8a1$var$Rf);
        $e6216febf4d6e8a1$var$rd = !!$e6216febf4d6e8a1$var$Qf;
        $e6216febf4d6e8a1$var$Rf = $e6216febf4d6e8a1$var$Qf = null;
        a.current = c;
        null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markLayoutEffectsStarted && $e6216febf4d6e8a1$var$B.markLayoutEffectsStarted(e);
        $e6216febf4d6e8a1$var$Sk(c, a, e);
        null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markLayoutEffectsStopped && $e6216febf4d6e8a1$var$B.markLayoutEffectsStopped();
        $e6216febf4d6e8a1$var$dc();
        $e6216febf4d6e8a1$var$K = h;
        $e6216febf4d6e8a1$var$E = g;
        $e6216febf4d6e8a1$var$$k.transition = f;
    } else a.current = c, $e6216febf4d6e8a1$var$Ui = $e6216febf4d6e8a1$var$Ti();
    $e6216febf4d6e8a1$var$gl && ($e6216febf4d6e8a1$var$gl = !1, $e6216febf4d6e8a1$var$hl = a, $e6216febf4d6e8a1$var$il = e);
    f = a.pendingLanes;
    0 === f && ($e6216febf4d6e8a1$var$tj = null);
    $e6216febf4d6e8a1$var$nc(c.stateNode, d);
    $e6216febf4d6e8a1$var$mc && a.memoizedUpdaters.clear();
    $e6216febf4d6e8a1$var$pl(a, $e6216febf4d6e8a1$var$A());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($e6216febf4d6e8a1$var$qj) throw $e6216febf4d6e8a1$var$qj = !1, a = $e6216febf4d6e8a1$var$rj, $e6216febf4d6e8a1$var$rj = null, a;
    0 !== ($e6216febf4d6e8a1$var$il & 1) && 0 !== a.tag && $e6216febf4d6e8a1$var$tl();
    f = a.pendingLanes;
    0 !== (f & 1) ? ($e6216febf4d6e8a1$var$Zi = !0, a === $e6216febf4d6e8a1$var$ll ? $e6216febf4d6e8a1$var$kl++ : ($e6216febf4d6e8a1$var$kl = 0, $e6216febf4d6e8a1$var$ll = a)) : $e6216febf4d6e8a1$var$kl = 0;
    $e6216febf4d6e8a1$var$xg();
    $e6216febf4d6e8a1$var$rc();
    return null;
}
function $e6216febf4d6e8a1$var$tl() {
    if (null !== $e6216febf4d6e8a1$var$hl) {
        var a = $e6216febf4d6e8a1$var$Rc($e6216febf4d6e8a1$var$il), b = $e6216febf4d6e8a1$var$$k.transition, c = $e6216febf4d6e8a1$var$E;
        try {
            $e6216febf4d6e8a1$var$$k.transition = null;
            $e6216febf4d6e8a1$var$E = 16 > a ? 16 : a;
            if (null === $e6216febf4d6e8a1$var$hl) var d = !1;
            else {
                a = $e6216febf4d6e8a1$var$hl;
                var e = $e6216febf4d6e8a1$var$il;
                $e6216febf4d6e8a1$var$hl = null;
                $e6216febf4d6e8a1$var$il = 0;
                if (0 !== ($e6216febf4d6e8a1$var$K & 6)) throw Error($e6216febf4d6e8a1$var$p(331));
                null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markPassiveEffectsStarted && $e6216febf4d6e8a1$var$B.markPassiveEffectsStarted(e);
                e = $e6216febf4d6e8a1$var$K;
                $e6216febf4d6e8a1$var$K |= 4;
                for($e6216febf4d6e8a1$var$U = a.current; null !== $e6216febf4d6e8a1$var$U;){
                    var f = $e6216febf4d6e8a1$var$U, g = f.child;
                    if (0 !== ($e6216febf4d6e8a1$var$U.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($e6216febf4d6e8a1$var$U = l; null !== $e6216febf4d6e8a1$var$U;){
                                    var n = $e6216febf4d6e8a1$var$U, q = n;
                                    switch(q.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            q.mode & 2 ? ($e6216febf4d6e8a1$var$Xi = $e6216febf4d6e8a1$var$Ti(), $e6216febf4d6e8a1$var$zk(8, q, f), $e6216febf4d6e8a1$var$bj(q)) : $e6216febf4d6e8a1$var$zk(8, q, f);
                                    }
                                    var r = n.child;
                                    if (null !== r) r.return = n, $e6216febf4d6e8a1$var$U = r;
                                    else for(; null !== $e6216febf4d6e8a1$var$U;){
                                        n = $e6216febf4d6e8a1$var$U;
                                        var z = n.sibling, m = n.return;
                                        $e6216febf4d6e8a1$var$Ck(n);
                                        if (n === l) {
                                            $e6216febf4d6e8a1$var$U = null;
                                            break;
                                        }
                                        if (null !== z) {
                                            z.return = m;
                                            $e6216febf4d6e8a1$var$U = z;
                                            break;
                                        }
                                        $e6216febf4d6e8a1$var$U = m;
                                    }
                                }
                            }
                            var w = f.alternate;
                            if (null !== w) {
                                var C = w.child;
                                if (null !== C) {
                                    w.child = null;
                                    do {
                                        var x = C.sibling;
                                        C.sibling = null;
                                        C = x;
                                    }while (null !== C);
                                }
                            }
                            $e6216febf4d6e8a1$var$U = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $e6216febf4d6e8a1$var$U = g;
                    else b: for(; null !== $e6216febf4d6e8a1$var$U;){
                        f = $e6216febf4d6e8a1$var$U;
                        if (0 !== (f.flags & 2048)) switch(k = f, k.tag){
                            case 0:
                            case 11:
                            case 15:
                                k.mode & 2 ? ($e6216febf4d6e8a1$var$Xi = $e6216febf4d6e8a1$var$Ti(), $e6216febf4d6e8a1$var$zk(9, k, k.return), $e6216febf4d6e8a1$var$bj(k)) : $e6216febf4d6e8a1$var$zk(9, k, k.return);
                        }
                        var y = f.sibling;
                        if (null !== y) {
                            y.return = f.return;
                            $e6216febf4d6e8a1$var$U = y;
                            break b;
                        }
                        $e6216febf4d6e8a1$var$U = f.return;
                    }
                }
                var v = a.current;
                for($e6216febf4d6e8a1$var$U = v; null !== $e6216febf4d6e8a1$var$U;){
                    g = $e6216febf4d6e8a1$var$U;
                    var D = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== D) D.return = g, $e6216febf4d6e8a1$var$U = D;
                    else b: for(g = v; null !== $e6216febf4d6e8a1$var$U;){
                        h = $e6216febf4d6e8a1$var$U;
                        if (0 !== (h.flags & 2048)) try {
                            switch(l = h, l.tag){
                                case 0:
                                case 11:
                                case 15:
                                    if (l.mode & 2) {
                                        $e6216febf4d6e8a1$var$Xi = $e6216febf4d6e8a1$var$Ti();
                                        try {
                                            $e6216febf4d6e8a1$var$Ak(9, l);
                                        } finally{
                                            $e6216febf4d6e8a1$var$bj(l);
                                        }
                                    } else $e6216febf4d6e8a1$var$Ak(9, l);
                            }
                        } catch (Pj) {
                            $e6216febf4d6e8a1$var$W(h, h.return, Pj);
                        }
                        if (h === g) {
                            $e6216febf4d6e8a1$var$U = null;
                            break b;
                        }
                        var ca = h.sibling;
                        if (null !== ca) {
                            ca.return = h.return;
                            $e6216febf4d6e8a1$var$U = ca;
                            break b;
                        }
                        $e6216febf4d6e8a1$var$U = h.return;
                    }
                }
                v = $e6216febf4d6e8a1$var$jl;
                $e6216febf4d6e8a1$var$jl = [];
                for(D = 0; D < v.length; D++){
                    var R = v[D];
                    if (0 !== (R.flags & 4)) switch(R.tag){
                        case 12:
                            var sa = R.stateNode.passiveEffectDuration, V = R.memoizedProps, Bl = V.id, yi = V.onPostCommit;
                            ca = $e6216febf4d6e8a1$var$Ui;
                            var zi = null === R.alternate ? "mount" : "update";
                            $e6216febf4d6e8a1$var$Yi && (zi = "nested-update");
                            "function" === typeof yi && yi(Bl, zi, sa, ca);
                            var lb = R.return;
                            b: for(; null !== lb;){
                                switch(lb.tag){
                                    case 3:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                    case 12:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                }
                                lb = lb.return;
                            }
                    }
                }
                null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markPassiveEffectsStopped && $e6216febf4d6e8a1$var$B.markPassiveEffectsStopped();
                $e6216febf4d6e8a1$var$K = e;
                $e6216febf4d6e8a1$var$xg();
                if ($e6216febf4d6e8a1$var$lc && "function" === typeof $e6216febf4d6e8a1$var$lc.onPostCommitFiberRoot) try {
                    $e6216febf4d6e8a1$var$lc.onPostCommitFiberRoot($e6216febf4d6e8a1$var$kc, a);
                } catch (Pj) {}
                var Qj = a.current.stateNode;
                Qj.effectDuration = 0;
                Qj.passiveEffectDuration = 0;
                d = !0;
            }
            return d;
        } finally{
            $e6216febf4d6e8a1$var$E = c, $e6216febf4d6e8a1$var$$k.transition = b;
        }
    }
    return !1;
}
function $e6216febf4d6e8a1$var$Wk(a) {
    $e6216febf4d6e8a1$var$jl.push(a);
    $e6216febf4d6e8a1$var$gl || ($e6216febf4d6e8a1$var$gl = !0, $e6216febf4d6e8a1$var$rl($e6216febf4d6e8a1$var$hc, function() {
        $e6216febf4d6e8a1$var$tl();
        return null;
    }));
}
function $e6216febf4d6e8a1$var$Kl(a, b, c) {
    b = $e6216febf4d6e8a1$var$lj(c, b);
    b = $e6216febf4d6e8a1$var$pj(a, b, 1);
    a = $e6216febf4d6e8a1$var$Bh(a, b, 1);
    b = $e6216febf4d6e8a1$var$Ri();
    null !== a && ($e6216febf4d6e8a1$var$Mc(a, 1, b), $e6216febf4d6e8a1$var$pl(a, b));
}
function $e6216febf4d6e8a1$var$W(a, b, c) {
    if (3 === a.tag) $e6216febf4d6e8a1$var$Kl(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $e6216febf4d6e8a1$var$Kl(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $e6216febf4d6e8a1$var$tj || !$e6216febf4d6e8a1$var$tj.has(d))) {
                a = $e6216febf4d6e8a1$var$lj(c, a);
                a = $e6216febf4d6e8a1$var$sj(b, a, 1);
                b = $e6216febf4d6e8a1$var$Bh(b, a, 1);
                a = $e6216febf4d6e8a1$var$Ri();
                null !== b && ($e6216febf4d6e8a1$var$Mc(b, 1, a), $e6216febf4d6e8a1$var$pl(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $e6216febf4d6e8a1$var$vj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $e6216febf4d6e8a1$var$Ri();
    a.pingedLanes |= a.suspendedLanes & c;
    $e6216febf4d6e8a1$var$Q === a && ($e6216febf4d6e8a1$var$Z & c) === c && (4 === $e6216febf4d6e8a1$var$T || 3 === $e6216febf4d6e8a1$var$T && ($e6216febf4d6e8a1$var$Z & 130023424) === $e6216febf4d6e8a1$var$Z && 500 > $e6216febf4d6e8a1$var$A() - $e6216febf4d6e8a1$var$Qk ? $e6216febf4d6e8a1$var$wl(a, 0) : $e6216febf4d6e8a1$var$cl |= c);
    $e6216febf4d6e8a1$var$pl(a, b);
}
function $e6216febf4d6e8a1$var$Ll(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $e6216febf4d6e8a1$var$Ec, $e6216febf4d6e8a1$var$Ec <<= 1, 0 === ($e6216febf4d6e8a1$var$Ec & 130023424) && ($e6216febf4d6e8a1$var$Ec = 4194304)));
    var c = $e6216febf4d6e8a1$var$Ri();
    a = $e6216febf4d6e8a1$var$wh(a, b);
    null !== a && ($e6216febf4d6e8a1$var$Mc(a, b, c), $e6216febf4d6e8a1$var$pl(a, c));
}
function $e6216febf4d6e8a1$var$ak(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $e6216febf4d6e8a1$var$Ll(a, c);
}
function $e6216febf4d6e8a1$var$Lk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($e6216febf4d6e8a1$var$p(314));
    }
    null !== d && d.delete(b);
    $e6216febf4d6e8a1$var$Ll(a, c);
}
var $e6216febf4d6e8a1$var$Il;
$e6216febf4d6e8a1$var$Il = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $e6216febf4d6e8a1$var$jg.current) $e6216febf4d6e8a1$var$rh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $e6216febf4d6e8a1$var$rh = !1, $e6216febf4d6e8a1$var$ek(a, b, c);
            $e6216febf4d6e8a1$var$rh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $e6216febf4d6e8a1$var$rh = !1, $e6216febf4d6e8a1$var$J && 0 !== (b.flags & 1048576) && $e6216febf4d6e8a1$var$Ig(b, $e6216febf4d6e8a1$var$Bg, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $e6216febf4d6e8a1$var$Mj(a, b);
            a = b.pendingProps;
            var e = $e6216febf4d6e8a1$var$lg(b, $e6216febf4d6e8a1$var$I.current);
            $e6216febf4d6e8a1$var$qh(b, c);
            $e6216febf4d6e8a1$var$sc(b);
            e = $e6216febf4d6e8a1$var$ai(null, b, d, a, e, c);
            var f = $e6216febf4d6e8a1$var$fi();
            $e6216febf4d6e8a1$var$tc();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $e6216febf4d6e8a1$var$mg(d) ? (f = !0, $e6216febf4d6e8a1$var$qg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $e6216febf4d6e8a1$var$yh(b), e.updater = $e6216febf4d6e8a1$var$gj, b.stateNode = e, e._reactInternals = b, $e6216febf4d6e8a1$var$kj(b, d, a, c), b = $e6216febf4d6e8a1$var$Nj(null, b, d, !0, f, c)) : (b.tag = 0, $e6216febf4d6e8a1$var$J && f && $e6216febf4d6e8a1$var$Jg(b), $e6216febf4d6e8a1$var$Aj(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $e6216febf4d6e8a1$var$Mj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $e6216febf4d6e8a1$var$Ml(d);
                a = $e6216febf4d6e8a1$var$ej(d, a);
                switch(e){
                    case 0:
                        b = $e6216febf4d6e8a1$var$Gj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $e6216febf4d6e8a1$var$Lj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $e6216febf4d6e8a1$var$Bj(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $e6216febf4d6e8a1$var$Dj(null, b, d, $e6216febf4d6e8a1$var$ej(d.type, a), c);
                        break a;
                }
                throw Error($e6216febf4d6e8a1$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e6216febf4d6e8a1$var$ej(d, e), $e6216febf4d6e8a1$var$Gj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e6216febf4d6e8a1$var$ej(d, e), $e6216febf4d6e8a1$var$Lj(a, b, d, e, c);
        case 3:
            a: {
                $e6216febf4d6e8a1$var$Oj(b);
                if (null === a) throw Error($e6216febf4d6e8a1$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $e6216febf4d6e8a1$var$zh(a, b);
                $e6216febf4d6e8a1$var$Eh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $e6216febf4d6e8a1$var$lj(Error($e6216febf4d6e8a1$var$p(423)), b);
                        b = $e6216febf4d6e8a1$var$Rj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $e6216febf4d6e8a1$var$lj(Error($e6216febf4d6e8a1$var$p(424)), b);
                        b = $e6216febf4d6e8a1$var$Rj(a, b, d, c, e);
                        break a;
                    } else for($e6216febf4d6e8a1$var$Mg = $e6216febf4d6e8a1$var$Zf(b.stateNode.containerInfo.firstChild), $e6216febf4d6e8a1$var$Lg = b, $e6216febf4d6e8a1$var$J = !0, $e6216febf4d6e8a1$var$Ng = null, c = $e6216febf4d6e8a1$var$ih(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $e6216febf4d6e8a1$var$Wg();
                    if (d === e) {
                        b = $e6216febf4d6e8a1$var$Cj(a, b, c);
                        break a;
                    }
                    $e6216febf4d6e8a1$var$Aj(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $e6216febf4d6e8a1$var$Oh(b), null === a && $e6216febf4d6e8a1$var$Sg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $e6216febf4d6e8a1$var$Sf(d, e) ? g = null : null !== f && $e6216febf4d6e8a1$var$Sf(d, f) && (b.flags |= 32), $e6216febf4d6e8a1$var$Kj(a, b), $e6216febf4d6e8a1$var$Aj(a, b, g, c), b.child;
        case 6:
            return null === a && $e6216febf4d6e8a1$var$Sg(b), null;
        case 13:
            return $e6216febf4d6e8a1$var$Uj(a, b, c);
        case 4:
            return $e6216febf4d6e8a1$var$Mh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $e6216febf4d6e8a1$var$hh(b, null, d, c) : $e6216febf4d6e8a1$var$Aj(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e6216febf4d6e8a1$var$ej(d, e), $e6216febf4d6e8a1$var$Bj(a, b, d, e, c);
        case 7:
            return $e6216febf4d6e8a1$var$Aj(a, b, b.pendingProps, c), b.child;
        case 8:
            return $e6216febf4d6e8a1$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return b.flags |= 4, d = b.stateNode, d.effectDuration = 0, d.passiveEffectDuration = 0, $e6216febf4d6e8a1$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $e6216febf4d6e8a1$var$H($e6216febf4d6e8a1$var$jh, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($e6216febf4d6e8a1$var$Ve(f.value, g)) {
                        if (f.children === e.children && !$e6216febf4d6e8a1$var$jg.current) {
                            b = $e6216febf4d6e8a1$var$Cj(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $e6216febf4d6e8a1$var$Ah(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var n = l.pending;
                                            null === n ? k.next = k : (k.next = n.next, n.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $e6216febf4d6e8a1$var$ph(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($e6216febf4d6e8a1$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $e6216febf4d6e8a1$var$ph(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $e6216febf4d6e8a1$var$Aj(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $e6216febf4d6e8a1$var$qh(b, c), e = $e6216febf4d6e8a1$var$sh(e), $e6216febf4d6e8a1$var$sc(b), d = d(e), $e6216febf4d6e8a1$var$tc(), b.flags |= 1, $e6216febf4d6e8a1$var$Aj(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $e6216febf4d6e8a1$var$ej(d, b.pendingProps), e = $e6216febf4d6e8a1$var$ej(d.type, e), $e6216febf4d6e8a1$var$Dj(a, b, d, e, c);
        case 15:
            return $e6216febf4d6e8a1$var$Fj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e6216febf4d6e8a1$var$ej(d, e), $e6216febf4d6e8a1$var$Mj(a, b), b.tag = 1, $e6216febf4d6e8a1$var$mg(d) ? (a = !0, $e6216febf4d6e8a1$var$qg(b)) : a = !1, $e6216febf4d6e8a1$var$qh(b, c), $e6216febf4d6e8a1$var$ij(b, d, e), $e6216febf4d6e8a1$var$kj(b, d, e, c), $e6216febf4d6e8a1$var$Nj(null, b, d, !0, a, c);
        case 19:
            return $e6216febf4d6e8a1$var$dk(a, b, c);
        case 22:
            return $e6216febf4d6e8a1$var$Hj(a, b, c);
    }
    throw Error($e6216febf4d6e8a1$var$p(156, b.tag));
};
function $e6216febf4d6e8a1$var$wj(a, b) {
    $e6216febf4d6e8a1$var$mc && a.memoizedUpdaters.forEach(function(c) {
        $e6216febf4d6e8a1$var$Pc(a, c, b);
    });
}
function $e6216febf4d6e8a1$var$rl(a, b) {
    return $e6216febf4d6e8a1$var$ac(a, b);
}
function $e6216febf4d6e8a1$var$Nl(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
    this.actualDuration = 0;
    this.actualStartTime = -1;
    this.treeBaseDuration = this.selfBaseDuration = 0;
}
function $e6216febf4d6e8a1$var$Pg(a, b, c, d) {
    return new $e6216febf4d6e8a1$var$Nl(a, b, c, d);
}
function $e6216febf4d6e8a1$var$Ej(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $e6216febf4d6e8a1$var$Ml(a) {
    if ("function" === typeof a) return $e6216febf4d6e8a1$var$Ej(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $e6216febf4d6e8a1$var$Da) return 11;
        if (a === $e6216febf4d6e8a1$var$Ga) return 14;
    }
    return 2;
}
function $e6216febf4d6e8a1$var$ch(a, b) {
    var c = a.alternate;
    null === c ? (c = $e6216febf4d6e8a1$var$Pg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null, c.actualDuration = 0, c.actualStartTime = -1);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    c.selfBaseDuration = a.selfBaseDuration;
    c.treeBaseDuration = a.treeBaseDuration;
    return c;
}
function $e6216febf4d6e8a1$var$eh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $e6216febf4d6e8a1$var$Ej(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $e6216febf4d6e8a1$var$ya:
            return $e6216febf4d6e8a1$var$gh(c.children, e, f, b);
        case $e6216febf4d6e8a1$var$za:
            g = 8;
            e |= 8;
            break;
        case $e6216febf4d6e8a1$var$Aa:
            return a = $e6216febf4d6e8a1$var$Pg(12, c, b, e | 2), a.elementType = $e6216febf4d6e8a1$var$Aa, a.lanes = f, a.stateNode = {
                effectDuration: 0,
                passiveEffectDuration: 0
            }, a;
        case $e6216febf4d6e8a1$var$Ea:
            return a = $e6216febf4d6e8a1$var$Pg(13, c, b, e), a.elementType = $e6216febf4d6e8a1$var$Ea, a.lanes = f, a;
        case $e6216febf4d6e8a1$var$Fa:
            return a = $e6216febf4d6e8a1$var$Pg(19, c, b, e), a.elementType = $e6216febf4d6e8a1$var$Fa, a.lanes = f, a;
        case $e6216febf4d6e8a1$var$Ia:
            return $e6216febf4d6e8a1$var$Vj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $e6216febf4d6e8a1$var$Ba:
                    g = 10;
                    break a;
                case $e6216febf4d6e8a1$var$Ca:
                    g = 9;
                    break a;
                case $e6216febf4d6e8a1$var$Da:
                    g = 11;
                    break a;
                case $e6216febf4d6e8a1$var$Ga:
                    g = 14;
                    break a;
                case $e6216febf4d6e8a1$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($e6216febf4d6e8a1$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $e6216febf4d6e8a1$var$Pg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $e6216febf4d6e8a1$var$gh(a, b, c, d) {
    a = $e6216febf4d6e8a1$var$Pg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $e6216febf4d6e8a1$var$Vj(a, b, c, d) {
    a = $e6216febf4d6e8a1$var$Pg(22, a, d, b);
    a.elementType = $e6216febf4d6e8a1$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $e6216febf4d6e8a1$var$dh(a, b, c) {
    a = $e6216febf4d6e8a1$var$Pg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $e6216febf4d6e8a1$var$fh(a, b, c) {
    b = $e6216febf4d6e8a1$var$Pg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $e6216febf4d6e8a1$var$Ol(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $e6216febf4d6e8a1$var$Lc(0);
    this.expirationTimes = $e6216febf4d6e8a1$var$Lc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e6216febf4d6e8a1$var$Lc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
    this.passiveEffectDuration = this.effectDuration = 0;
    this.memoizedUpdaters = new Set;
    a = this.pendingUpdatersLaneMap = [];
    for(b = 0; 31 > b; b++)a.push(new Set);
}
function $e6216febf4d6e8a1$var$Pl(a, b, c, d, e, f, g, h, k) {
    a = new $e6216febf4d6e8a1$var$Ol(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    $e6216febf4d6e8a1$var$mc && (b |= 2);
    f = $e6216febf4d6e8a1$var$Pg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $e6216febf4d6e8a1$var$yh(f);
    return a;
}
function $e6216febf4d6e8a1$var$Ql(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e6216febf4d6e8a1$var$xa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $e6216febf4d6e8a1$var$Rl(a) {
    if (!a) return $e6216febf4d6e8a1$var$ig;
    a = a._reactInternals;
    a: {
        if ($e6216febf4d6e8a1$var$Vb(a) !== a || 1 !== a.tag) throw Error($e6216febf4d6e8a1$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($e6216febf4d6e8a1$var$mg(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($e6216febf4d6e8a1$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($e6216febf4d6e8a1$var$mg(c)) return $e6216febf4d6e8a1$var$pg(a, c, b);
    }
    return b;
}
function $e6216febf4d6e8a1$var$Sl(a, b, c, d, e, f, g, h, k) {
    a = $e6216febf4d6e8a1$var$Pl(c, d, !0, a, e, f, g, h, k);
    a.context = $e6216febf4d6e8a1$var$Rl(null);
    c = a.current;
    d = $e6216febf4d6e8a1$var$Ri();
    e = $e6216febf4d6e8a1$var$Oi(c);
    f = $e6216febf4d6e8a1$var$Ah(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $e6216febf4d6e8a1$var$Bh(c, f, e);
    a.current.lanes = e;
    $e6216febf4d6e8a1$var$Mc(a, e, d);
    $e6216febf4d6e8a1$var$pl(a, d);
    return a;
}
function $e6216febf4d6e8a1$var$Tl(a, b, c, d) {
    var e = b.current, f = $e6216febf4d6e8a1$var$Ri(), g = $e6216febf4d6e8a1$var$Oi(e);
    null !== $e6216febf4d6e8a1$var$B && "function" === typeof $e6216febf4d6e8a1$var$B.markRenderScheduled && $e6216febf4d6e8a1$var$B.markRenderScheduled(g);
    c = $e6216febf4d6e8a1$var$Rl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $e6216febf4d6e8a1$var$Ah(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $e6216febf4d6e8a1$var$Bh(e, b, g);
    null !== a && ($e6216febf4d6e8a1$var$ui(a, e, g, f), $e6216febf4d6e8a1$var$Ch(a, e, g));
    return g;
}
function $e6216febf4d6e8a1$var$Ul(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $e6216febf4d6e8a1$var$Vl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $e6216febf4d6e8a1$var$Wl(a, b) {
    $e6216febf4d6e8a1$var$Vl(a, b);
    (a = a.alternate) && $e6216febf4d6e8a1$var$Vl(a, b);
}
function $e6216febf4d6e8a1$var$Xl() {
    return null;
}
var $e6216febf4d6e8a1$var$Yl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $e6216febf4d6e8a1$var$Zl(a) {
    this._internalRoot = a;
}
$e6216febf4d6e8a1$var$$l.prototype.render = $e6216febf4d6e8a1$var$Zl.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($e6216febf4d6e8a1$var$p(409));
    $e6216febf4d6e8a1$var$Tl(a, b, null, null);
};
$e6216febf4d6e8a1$var$$l.prototype.unmount = $e6216febf4d6e8a1$var$Zl.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $e6216febf4d6e8a1$var$El(function() {
            $e6216febf4d6e8a1$var$Tl(null, a, null, null);
        });
        b[$e6216febf4d6e8a1$var$If] = null;
    }
};
function $e6216febf4d6e8a1$var$$l(a) {
    this._internalRoot = a;
}
$e6216febf4d6e8a1$var$$l.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $e6216febf4d6e8a1$var$Vc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $e6216febf4d6e8a1$var$dd.length && 0 !== b && b < $e6216febf4d6e8a1$var$dd[c].priority; c++);
        $e6216febf4d6e8a1$var$dd.splice(c, 0, a);
        0 === c && $e6216febf4d6e8a1$var$id(a);
    }
};
function $e6216febf4d6e8a1$var$am(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $e6216febf4d6e8a1$var$bm(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $e6216febf4d6e8a1$var$cm() {}
function $e6216febf4d6e8a1$var$dm(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $e6216febf4d6e8a1$var$Ul(g);
                f.call(a);
            };
        }
        var g = $e6216febf4d6e8a1$var$Sl(b, d, a, 0, null, !1, !1, "", $e6216febf4d6e8a1$var$cm);
        a._reactRootContainer = g;
        a[$e6216febf4d6e8a1$var$If] = g.current;
        $e6216febf4d6e8a1$var$Gf(8 === a.nodeType ? a.parentNode : a);
        $e6216febf4d6e8a1$var$El();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $e6216febf4d6e8a1$var$Ul(k);
            h.call(a);
        };
    }
    var k = $e6216febf4d6e8a1$var$Pl(a, 0, !1, null, null, !1, !1, "", $e6216febf4d6e8a1$var$cm);
    a._reactRootContainer = k;
    a[$e6216febf4d6e8a1$var$If] = k.current;
    $e6216febf4d6e8a1$var$Gf(8 === a.nodeType ? a.parentNode : a);
    $e6216febf4d6e8a1$var$El(function() {
        $e6216febf4d6e8a1$var$Tl(b, k, c, d);
    });
    return k;
}
function $e6216febf4d6e8a1$var$em(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $e6216febf4d6e8a1$var$Ul(g);
                h.call(a);
            };
        }
        $e6216febf4d6e8a1$var$Tl(b, g, a, e);
    } else g = $e6216febf4d6e8a1$var$dm(c, b, a, e, d);
    return $e6216febf4d6e8a1$var$Ul(g);
}
$e6216febf4d6e8a1$var$Sc = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $e6216febf4d6e8a1$var$Fc(b.pendingLanes);
                0 !== c && ($e6216febf4d6e8a1$var$Oc(b, c | 1), $e6216febf4d6e8a1$var$pl(b, $e6216febf4d6e8a1$var$A()), 0 === ($e6216febf4d6e8a1$var$K & 6) && ($e6216febf4d6e8a1$var$mk = $e6216febf4d6e8a1$var$A() + 500, $e6216febf4d6e8a1$var$xg()));
            }
            break;
        case 13:
            $e6216febf4d6e8a1$var$El(function() {
                var b = $e6216febf4d6e8a1$var$wh(a, 1);
                if (null !== b) {
                    var c = $e6216febf4d6e8a1$var$Ri();
                    $e6216febf4d6e8a1$var$ui(b, a, 1, c);
                }
            }), $e6216febf4d6e8a1$var$Wl(a, 1);
    }
};
$e6216febf4d6e8a1$var$Tc = function(a) {
    if (13 === a.tag) {
        var b = $e6216febf4d6e8a1$var$wh(a, 134217728);
        if (null !== b) {
            var c = $e6216febf4d6e8a1$var$Ri();
            $e6216febf4d6e8a1$var$ui(b, a, 134217728, c);
        }
        $e6216febf4d6e8a1$var$Wl(a, 134217728);
    }
};
$e6216febf4d6e8a1$var$Uc = function(a) {
    if (13 === a.tag) {
        var b = $e6216febf4d6e8a1$var$Oi(a), c = $e6216febf4d6e8a1$var$wh(a, b);
        if (null !== c) {
            var d = $e6216febf4d6e8a1$var$Ri();
            $e6216febf4d6e8a1$var$ui(c, a, b, d);
        }
        $e6216febf4d6e8a1$var$Wl(a, b);
    }
};
$e6216febf4d6e8a1$var$Vc = function() {
    return $e6216febf4d6e8a1$var$E;
};
$e6216febf4d6e8a1$var$Wc = function(a, b) {
    var c = $e6216febf4d6e8a1$var$E;
    try {
        return $e6216febf4d6e8a1$var$E = a, b();
    } finally{
        $e6216febf4d6e8a1$var$E = c;
    }
};
$e6216febf4d6e8a1$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $e6216febf4d6e8a1$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $e6216febf4d6e8a1$var$Db(d);
                        if (!e) throw Error($e6216febf4d6e8a1$var$p(90));
                        $e6216febf4d6e8a1$var$Wa(d);
                        $e6216febf4d6e8a1$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $e6216febf4d6e8a1$var$hb(a, c);
            break;
        case "select":
            b = c.value, null != b && $e6216febf4d6e8a1$var$eb(a, !!c.multiple, b, !1);
    }
};
$e6216febf4d6e8a1$var$Gb = $e6216febf4d6e8a1$var$Dl;
$e6216febf4d6e8a1$var$Hb = $e6216febf4d6e8a1$var$El;
var $e6216febf4d6e8a1$var$fm = {
    usingClientEntryPoint: !1,
    Events: [
        $e6216febf4d6e8a1$var$Cb,
        $e6216febf4d6e8a1$var$Ie,
        $e6216febf4d6e8a1$var$Db,
        $e6216febf4d6e8a1$var$Eb,
        $e6216febf4d6e8a1$var$Fb,
        $e6216febf4d6e8a1$var$Dl
    ]
}, $e6216febf4d6e8a1$var$gm = {
    findFiberByHostInstance: $e6216febf4d6e8a1$var$jd,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
(function(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        a = $e6216febf4d6e8a1$var$u({}, a, {
            getLaneLabelMap: $e6216febf4d6e8a1$var$pc,
            injectProfilingHooks: $e6216febf4d6e8a1$var$oc
        }), $e6216febf4d6e8a1$var$kc = b.inject(a), $e6216febf4d6e8a1$var$lc = b;
    } catch (c) {}
    return b.checkDCE ? !0 : !1;
})({
    bundleType: $e6216febf4d6e8a1$var$gm.bundleType,
    version: $e6216febf4d6e8a1$var$gm.version,
    rendererPackageName: $e6216febf4d6e8a1$var$gm.rendererPackageName,
    rendererConfig: $e6216febf4d6e8a1$var$gm.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $e6216febf4d6e8a1$var$va.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $e6216febf4d6e8a1$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $e6216febf4d6e8a1$var$gm.findFiberByHostInstance || $e6216febf4d6e8a1$var$Xl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
});
$e6216febf4d6e8a1$export$ae55be85d98224ed = $e6216febf4d6e8a1$var$fm;
$e6216febf4d6e8a1$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$e6216febf4d6e8a1$var$am(b)) throw Error($e6216febf4d6e8a1$var$p(200));
    return $e6216febf4d6e8a1$var$Ql(a, b, null, c);
};
$e6216febf4d6e8a1$export$882461b6382ed46c = function(a, b) {
    if (!$e6216febf4d6e8a1$var$am(a)) throw Error($e6216febf4d6e8a1$var$p(299));
    var c = !1, d = "", e = $e6216febf4d6e8a1$var$Yl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $e6216febf4d6e8a1$var$Pl(a, 1, !1, null, null, c, !1, d, e);
    a[$e6216febf4d6e8a1$var$If] = b.current;
    $e6216febf4d6e8a1$var$Gf(8 === a.nodeType ? a.parentNode : a);
    return new $e6216febf4d6e8a1$var$Zl(b);
};
$e6216febf4d6e8a1$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($e6216febf4d6e8a1$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($e6216febf4d6e8a1$var$p(268, a));
    }
    a = $e6216febf4d6e8a1$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$e6216febf4d6e8a1$export$cd75ccfd720a3cd4 = function(a) {
    return $e6216febf4d6e8a1$var$El(a);
};
$e6216febf4d6e8a1$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$e6216febf4d6e8a1$var$bm(b)) throw Error($e6216febf4d6e8a1$var$p(200));
    return $e6216febf4d6e8a1$var$em(null, a, b, !0, c);
};
$e6216febf4d6e8a1$export$757ceba2d55c277e = function(a, b, c) {
    if (!$e6216febf4d6e8a1$var$am(a)) throw Error($e6216febf4d6e8a1$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $e6216febf4d6e8a1$var$Yl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $e6216febf4d6e8a1$var$Sl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$e6216febf4d6e8a1$var$If] = b.current;
    $e6216febf4d6e8a1$var$Gf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $e6216febf4d6e8a1$var$$l(b);
};
$e6216febf4d6e8a1$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$e6216febf4d6e8a1$var$bm(b)) throw Error($e6216febf4d6e8a1$var$p(200));
    return $e6216febf4d6e8a1$var$em(null, a, b, !1, c);
};
$e6216febf4d6e8a1$export$502457920280e6be = function(a) {
    if (!$e6216febf4d6e8a1$var$bm(a)) throw Error($e6216febf4d6e8a1$var$p(40));
    return a._reactRootContainer ? ($e6216febf4d6e8a1$var$El(function() {
        $e6216febf4d6e8a1$var$em(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$e6216febf4d6e8a1$var$If] = null;
        });
    }), !0) : !1;
};
$e6216febf4d6e8a1$export$c78a37762a8d58e1 = $e6216febf4d6e8a1$var$Dl;
$e6216febf4d6e8a1$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$e6216febf4d6e8a1$var$bm(c)) throw Error($e6216febf4d6e8a1$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($e6216febf4d6e8a1$var$p(38));
    return $e6216febf4d6e8a1$var$em(a, b, c, !1, d);
};
$e6216febf4d6e8a1$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());

});
parcelRegister("hziAm", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bOmx3"));

});
parcelRegister("bOmx3", function(module, exports) {
$parcel$export(module.exports, "unstable_now", () => $8995d7a8614d7a36$export$c4744153514ff05d, (v) => $8995d7a8614d7a36$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $8995d7a8614d7a36$export$3e506c1ccc9cc1a7, (v) => $8995d7a8614d7a36$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $8995d7a8614d7a36$export$e26fe2ed2fa76875, (v) => $8995d7a8614d7a36$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $8995d7a8614d7a36$export$502329bbf4b505b1, (v) => $8995d7a8614d7a36$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $8995d7a8614d7a36$export$6e3807111c4874c4, (v) => $8995d7a8614d7a36$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $8995d7a8614d7a36$export$c27134553091fb3a, (v) => $8995d7a8614d7a36$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $8995d7a8614d7a36$export$33ee1acdc04fd2a2, (v) => $8995d7a8614d7a36$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $8995d7a8614d7a36$export$b00a404bbd5edef2, (v) => $8995d7a8614d7a36$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $8995d7a8614d7a36$export$8352ce38b91d0c62, (v) => $8995d7a8614d7a36$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $8995d7a8614d7a36$export$d66a1c1c77bd778b, (v) => $8995d7a8614d7a36$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $8995d7a8614d7a36$export$d3dfb8e4810cb555, (v) => $8995d7a8614d7a36$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $8995d7a8614d7a36$export$839f9183b0465a69, (v) => $8995d7a8614d7a36$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $8995d7a8614d7a36$export$72fdf0e06517287b, (v) => $8995d7a8614d7a36$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $8995d7a8614d7a36$export$4b844e58a3e414b4, (v) => $8995d7a8614d7a36$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $8995d7a8614d7a36$export$816d2913ae6b83b1, (v) => $8995d7a8614d7a36$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $8995d7a8614d7a36$export$61bcfe829111a1d0, (v) => $8995d7a8614d7a36$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $8995d7a8614d7a36$export$7ee8c9beb337bc3f, (v) => $8995d7a8614d7a36$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $8995d7a8614d7a36$export$b5836b71941fa3ed, (v) => $8995d7a8614d7a36$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $8995d7a8614d7a36$export$cf845f2c119da08a, (v) => $8995d7a8614d7a36$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8995d7a8614d7a36$export$c4744153514ff05d;
var $8995d7a8614d7a36$export$3e506c1ccc9cc1a7;
var $8995d7a8614d7a36$export$e26fe2ed2fa76875;
var $8995d7a8614d7a36$export$502329bbf4b505b1;
var $8995d7a8614d7a36$export$6e3807111c4874c4;
var $8995d7a8614d7a36$export$c27134553091fb3a;
var $8995d7a8614d7a36$export$33ee1acdc04fd2a2;
var $8995d7a8614d7a36$export$b00a404bbd5edef2;
var $8995d7a8614d7a36$export$8352ce38b91d0c62;
var $8995d7a8614d7a36$export$d66a1c1c77bd778b;
var $8995d7a8614d7a36$export$d3dfb8e4810cb555;
var $8995d7a8614d7a36$export$839f9183b0465a69;
var $8995d7a8614d7a36$export$72fdf0e06517287b;
var $8995d7a8614d7a36$export$4b844e58a3e414b4;
var $8995d7a8614d7a36$export$816d2913ae6b83b1;
var $8995d7a8614d7a36$export$61bcfe829111a1d0;
var $8995d7a8614d7a36$export$7ee8c9beb337bc3f;
var $8995d7a8614d7a36$export$b5836b71941fa3ed;
var $8995d7a8614d7a36$export$cf845f2c119da08a;
'use strict';
function $8995d7a8614d7a36$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $8995d7a8614d7a36$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $8995d7a8614d7a36$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $8995d7a8614d7a36$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $8995d7a8614d7a36$var$g(C, c)) n < e && 0 > $8995d7a8614d7a36$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $8995d7a8614d7a36$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $8995d7a8614d7a36$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $8995d7a8614d7a36$var$l = performance;
    $8995d7a8614d7a36$export$c4744153514ff05d = function() {
        return $8995d7a8614d7a36$var$l.now();
    };
} else {
    var $8995d7a8614d7a36$var$p = Date, $8995d7a8614d7a36$var$q = $8995d7a8614d7a36$var$p.now();
    $8995d7a8614d7a36$export$c4744153514ff05d = function() {
        return $8995d7a8614d7a36$var$p.now() - $8995d7a8614d7a36$var$q;
    };
}
var $8995d7a8614d7a36$var$r = [], $8995d7a8614d7a36$var$t = [], $8995d7a8614d7a36$var$u = 1, $8995d7a8614d7a36$var$v = null, $8995d7a8614d7a36$var$y = 3, $8995d7a8614d7a36$var$z = !1, $8995d7a8614d7a36$var$A = !1, $8995d7a8614d7a36$var$B = !1, $8995d7a8614d7a36$var$D = "function" === typeof setTimeout ? setTimeout : null, $8995d7a8614d7a36$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $8995d7a8614d7a36$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $8995d7a8614d7a36$var$G(a) {
    for(var b = $8995d7a8614d7a36$var$h($8995d7a8614d7a36$var$t); null !== b;){
        if (null === b.callback) $8995d7a8614d7a36$var$k($8995d7a8614d7a36$var$t);
        else if (b.startTime <= a) $8995d7a8614d7a36$var$k($8995d7a8614d7a36$var$t), b.sortIndex = b.expirationTime, $8995d7a8614d7a36$var$f($8995d7a8614d7a36$var$r, b);
        else break;
        b = $8995d7a8614d7a36$var$h($8995d7a8614d7a36$var$t);
    }
}
function $8995d7a8614d7a36$var$H(a) {
    $8995d7a8614d7a36$var$B = !1;
    $8995d7a8614d7a36$var$G(a);
    if (!$8995d7a8614d7a36$var$A) {
        if (null !== $8995d7a8614d7a36$var$h($8995d7a8614d7a36$var$r)) $8995d7a8614d7a36$var$A = !0, $8995d7a8614d7a36$var$I($8995d7a8614d7a36$var$J);
        else {
            var b = $8995d7a8614d7a36$var$h($8995d7a8614d7a36$var$t);
            null !== b && $8995d7a8614d7a36$var$K($8995d7a8614d7a36$var$H, b.startTime - a);
        }
    }
}
function $8995d7a8614d7a36$var$J(a, b) {
    $8995d7a8614d7a36$var$A = !1;
    $8995d7a8614d7a36$var$B && ($8995d7a8614d7a36$var$B = !1, $8995d7a8614d7a36$var$E($8995d7a8614d7a36$var$L), $8995d7a8614d7a36$var$L = -1);
    $8995d7a8614d7a36$var$z = !0;
    var c = $8995d7a8614d7a36$var$y;
    try {
        $8995d7a8614d7a36$var$G(b);
        for($8995d7a8614d7a36$var$v = $8995d7a8614d7a36$var$h($8995d7a8614d7a36$var$r); null !== $8995d7a8614d7a36$var$v && (!($8995d7a8614d7a36$var$v.expirationTime > b) || a && !$8995d7a8614d7a36$var$M());){
            var d = $8995d7a8614d7a36$var$v.callback;
            if ("function" === typeof d) {
                $8995d7a8614d7a36$var$v.callback = null;
                $8995d7a8614d7a36$var$y = $8995d7a8614d7a36$var$v.priorityLevel;
                var e = d($8995d7a8614d7a36$var$v.expirationTime <= b);
                b = $8995d7a8614d7a36$export$c4744153514ff05d();
                "function" === typeof e ? $8995d7a8614d7a36$var$v.callback = e : $8995d7a8614d7a36$var$v === $8995d7a8614d7a36$var$h($8995d7a8614d7a36$var$r) && $8995d7a8614d7a36$var$k($8995d7a8614d7a36$var$r);
                $8995d7a8614d7a36$var$G(b);
            } else $8995d7a8614d7a36$var$k($8995d7a8614d7a36$var$r);
            $8995d7a8614d7a36$var$v = $8995d7a8614d7a36$var$h($8995d7a8614d7a36$var$r);
        }
        if (null !== $8995d7a8614d7a36$var$v) var w = !0;
        else {
            var m = $8995d7a8614d7a36$var$h($8995d7a8614d7a36$var$t);
            null !== m && $8995d7a8614d7a36$var$K($8995d7a8614d7a36$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $8995d7a8614d7a36$var$v = null, $8995d7a8614d7a36$var$y = c, $8995d7a8614d7a36$var$z = !1;
    }
}
var $8995d7a8614d7a36$var$N = !1, $8995d7a8614d7a36$var$O = null, $8995d7a8614d7a36$var$L = -1, $8995d7a8614d7a36$var$P = 5, $8995d7a8614d7a36$var$Q = -1;
function $8995d7a8614d7a36$var$M() {
    return $8995d7a8614d7a36$export$c4744153514ff05d() - $8995d7a8614d7a36$var$Q < $8995d7a8614d7a36$var$P ? !1 : !0;
}
function $8995d7a8614d7a36$var$R() {
    if (null !== $8995d7a8614d7a36$var$O) {
        var a = $8995d7a8614d7a36$export$c4744153514ff05d();
        $8995d7a8614d7a36$var$Q = a;
        var b = !0;
        try {
            b = $8995d7a8614d7a36$var$O(!0, a);
        } finally{
            b ? $8995d7a8614d7a36$var$S() : ($8995d7a8614d7a36$var$N = !1, $8995d7a8614d7a36$var$O = null);
        }
    } else $8995d7a8614d7a36$var$N = !1;
}
var $8995d7a8614d7a36$var$S;
if ("function" === typeof $8995d7a8614d7a36$var$F) $8995d7a8614d7a36$var$S = function() {
    $8995d7a8614d7a36$var$F($8995d7a8614d7a36$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $8995d7a8614d7a36$var$T = new MessageChannel, $8995d7a8614d7a36$var$U = $8995d7a8614d7a36$var$T.port2;
    $8995d7a8614d7a36$var$T.port1.onmessage = $8995d7a8614d7a36$var$R;
    $8995d7a8614d7a36$var$S = function() {
        $8995d7a8614d7a36$var$U.postMessage(null);
    };
} else $8995d7a8614d7a36$var$S = function() {
    $8995d7a8614d7a36$var$D($8995d7a8614d7a36$var$R, 0);
};
function $8995d7a8614d7a36$var$I(a) {
    $8995d7a8614d7a36$var$O = a;
    $8995d7a8614d7a36$var$N || ($8995d7a8614d7a36$var$N = !0, $8995d7a8614d7a36$var$S());
}
function $8995d7a8614d7a36$var$K(a, b) {
    $8995d7a8614d7a36$var$L = $8995d7a8614d7a36$var$D(function() {
        a($8995d7a8614d7a36$export$c4744153514ff05d());
    }, b);
}
$8995d7a8614d7a36$export$3e506c1ccc9cc1a7 = 5;
$8995d7a8614d7a36$export$e26fe2ed2fa76875 = 1;
$8995d7a8614d7a36$export$502329bbf4b505b1 = 4;
$8995d7a8614d7a36$export$6e3807111c4874c4 = 3;
$8995d7a8614d7a36$export$c27134553091fb3a = null;
$8995d7a8614d7a36$export$33ee1acdc04fd2a2 = 2;
$8995d7a8614d7a36$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$8995d7a8614d7a36$export$8352ce38b91d0c62 = function() {
    $8995d7a8614d7a36$var$A || $8995d7a8614d7a36$var$z || ($8995d7a8614d7a36$var$A = !0, $8995d7a8614d7a36$var$I($8995d7a8614d7a36$var$J));
};
$8995d7a8614d7a36$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $8995d7a8614d7a36$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$8995d7a8614d7a36$export$d3dfb8e4810cb555 = function() {
    return $8995d7a8614d7a36$var$y;
};
$8995d7a8614d7a36$export$839f9183b0465a69 = function() {
    return $8995d7a8614d7a36$var$h($8995d7a8614d7a36$var$r);
};
$8995d7a8614d7a36$export$72fdf0e06517287b = function(a) {
    switch($8995d7a8614d7a36$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $8995d7a8614d7a36$var$y;
    }
    var c = $8995d7a8614d7a36$var$y;
    $8995d7a8614d7a36$var$y = b;
    try {
        return a();
    } finally{
        $8995d7a8614d7a36$var$y = c;
    }
};
$8995d7a8614d7a36$export$4b844e58a3e414b4 = function() {};
$8995d7a8614d7a36$export$816d2913ae6b83b1 = function() {};
$8995d7a8614d7a36$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $8995d7a8614d7a36$var$y;
    $8995d7a8614d7a36$var$y = a;
    try {
        return b();
    } finally{
        $8995d7a8614d7a36$var$y = c;
    }
};
$8995d7a8614d7a36$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $8995d7a8614d7a36$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $8995d7a8614d7a36$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $8995d7a8614d7a36$var$f($8995d7a8614d7a36$var$t, a), null === $8995d7a8614d7a36$var$h($8995d7a8614d7a36$var$r) && a === $8995d7a8614d7a36$var$h($8995d7a8614d7a36$var$t) && ($8995d7a8614d7a36$var$B ? ($8995d7a8614d7a36$var$E($8995d7a8614d7a36$var$L), $8995d7a8614d7a36$var$L = -1) : $8995d7a8614d7a36$var$B = !0, $8995d7a8614d7a36$var$K($8995d7a8614d7a36$var$H, c - d))) : (a.sortIndex = e, $8995d7a8614d7a36$var$f($8995d7a8614d7a36$var$r, a), $8995d7a8614d7a36$var$A || $8995d7a8614d7a36$var$z || ($8995d7a8614d7a36$var$A = !0, $8995d7a8614d7a36$var$I($8995d7a8614d7a36$var$J)));
    return a;
};
$8995d7a8614d7a36$export$b5836b71941fa3ed = $8995d7a8614d7a36$var$M;
$8995d7a8614d7a36$export$cf845f2c119da08a = function(a) {
    var b = $8995d7a8614d7a36$var$y;
    return function() {
        var c = $8995d7a8614d7a36$var$y;
        $8995d7a8614d7a36$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $8995d7a8614d7a36$var$y = c;
        }
    };
};

});





parcelRegister("jYxYB", function(module, exports) {
$parcel$export(module.exports, "createSubscribeFn", () => $0f6c436cadd337a2$export$10f5a0700f263f11);

var $ArurZ = parcelRequire("ArurZ");

var $2aEiL = parcelRequire("2aEiL");

var $irnMl = parcelRequire("irnMl");

var $4gHdz = parcelRequire("4gHdz");

var $7GiIo = parcelRequire("7GiIo");
const $0f6c436cadd337a2$var$channels = new Map();
const $0f6c436cadd337a2$var$channelsByClient = new WeakMap();
/** Select connection state; all observers then run the same subscription implementation. */ function $0f6c436cadd337a2$var$createSubscriptionObservable(cacheConfig, subscribe) {
    return (0, $ArurZ.Observable).create((sink)=>{
        const context = cacheConfig?.metadata?.subscriptionShardingContext;
        if (context === undefined) return subscribe(sink, (0, $4gHdz.getClient)(), $0f6c436cadd337a2$var$channels, (0, $4gHdz.getSocketConnectionState));
        const lease = (0, $4gHdz.acquireSubscriptionClient)(()=>(0, $irnMl.getSubscriptionUrl)(context));
        if (!lease) return subscribe(sink, null, $0f6c436cadd337a2$var$channels, (0, $4gHdz.getSocketConnectionState));
        try {
            let clientChannels = $0f6c436cadd337a2$var$channelsByClient.get(lease.client);
            if (!clientChannels) {
                clientChannels = new Map();
                $0f6c436cadd337a2$var$channelsByClient.set(lease.client, clientChannels);
            }
            const cleanup = subscribe(sink, lease.client, clientChannels, lease.getSocketConnectionState);
            return ()=>{
                try {
                    cleanup?.();
                } finally{
                    lease.release();
                }
            };
        } catch (error) {
            lease.release();
            throw error;
        }
    });
}
function $0f6c436cadd337a2$var$stableStringify(value) {
    if (value === null || typeof value !== 'object') return JSON.stringify(value) ?? 'null';
    if (Array.isArray(value)) return `[${value.map($0f6c436cadd337a2$var$stableStringify).join(',')}]`;
    const obj = value;
    const keys = Object.keys(obj).sort();
    return `{${keys.map((k)=>`${JSON.stringify(k)}:${$0f6c436cadd337a2$var$stableStringify(obj[k])}`).join(',')}}`;
}
function $0f6c436cadd337a2$var$channelKey(payload) {
    return $0f6c436cadd337a2$var$stableStringify({
        pq: payload.extensions?.pq ?? null,
        operationName: payload.operationName ?? null,
        variables: payload.variables ?? null,
        extensions: payload.extensions ?? null
    });
}
let $0f6c436cadd337a2$var$cachedDefaultSubscribe;
function $0f6c436cadd337a2$export$10f5a0700f263f11(subscribeOptions) {
    if (typeof subscribeOptions === 'undefined' && typeof $0f6c436cadd337a2$var$cachedDefaultSubscribe !== 'undefined') return $0f6c436cadd337a2$var$cachedDefaultSubscribe;
    const fn = ({ id: id, name: operationName }, variables, cacheConfig)=>$0f6c436cadd337a2$var$createSubscriptionObservable(cacheConfig, (sink, client, channels, getConnectionState)=>{
            if (!client) return sink.error(new Error('Unable to create subscription client'));
            const replayConfig = cacheConfig?.metadata?.replay || undefined;
            const replayCommand = replayConfig !== null && typeof replayConfig === 'object' && 'command' in replayConfig ? replayConfig.command : undefined;
            const replayExtensions = replayCommand ? {
                command: replayCommand
            } : replayConfig ? {
                replay: replayConfig
            } : {};
            const payload = {
                query: '',
                operationName: operationName,
                variables: variables,
                extensions: {
                    pq: id,
                    ...subscribeOptions?.subscribeExtensions || {},
                    ...replayExtensions
                }
            };
            subscribeOptions?.onSubscribeTrigger?.(payload);
            const key = $0f6c436cadd337a2$var$channelKey(payload);
            // Keep one cleanup policy for the entire observer lifetime.
            const guardChannelOwnership = !(0, $2aEiL.fg)('relay_subscription_cleanup_killswitch');
            const existingChannel = channels.get(key);
            let joinedChannel = existingChannel;
            // Capture before failure; the channel may reopen first.
            const isNewChannel = !existingChannel;
            const observerCount = (existingChannel?.sinks.size ?? 0) + 1;
            // Reuse the product-level subscription reporter instead of a per-call metadata callback.
            const diagnosticsEnabled = (0, $2aEiL.fg)('platform_relay_subscription_reliability-additional');
            const diagnostics = diagnosticsEnabled && typeof subscribeOptions?.onSubscriptionDiagnostic === 'function' ? subscribeOptions.onSubscriptionDiagnostic : undefined;
            const report = (event)=>{
                try {
                    diagnostics?.({
                        operationName: payload.operationName,
                        variables: payload.variables,
                        ...event
                    });
                } catch  {
                // Diagnostics must not interrupt subscriptions.
                }
            };
            if (diagnostics) report({
                type: 'attached',
                isNewChannel: isNewChannel,
                observerCount: observerCount,
                channelHasReceivedResponse: existingChannel?.hasReceivedResponse ?? false,
                socketState: getConnectionState()
            });
            const removeConnected = diagnostics ? client.on('connected', ()=>report({
                    type: 'connected'
                })) : undefined;
            const removeClosed = diagnostics ? client.on('closed', ()=>report({
                    type: 'closed'
                })) : undefined;
            const detachDiagnostics = ()=>{
                removeConnected?.();
                removeClosed?.();
            };
            const localSink = {
                next: (value)=>{
                    if (diagnostics) {
                        const extensions = value?.extensions;
                        const requestId = extensions?.gateway?.request_id;
                        const traceId = extensions?.gateway?.tId ?? extensions?.gateway?.trace_id;
                        const channel = extensions?.agg?.channel;
                        report({
                            type: 'response',
                            requestId: typeof requestId === 'string' ? requestId : null,
                            traceId: typeof traceId === 'string' ? traceId : null,
                            channel: typeof channel === 'string' ? channel : null
                        });
                    }
                    // @ts-expect-error incompatible types between two libraries
                    sink.next(value);
                },
                error: (err, requestId)=>{
                    report({
                        type: 'error',
                        requestId: requestId
                    });
                    detachDiagnostics();
                    sink.error(err);
                    subscribeOptions?.onSubscribeError?.({
                        ...payload,
                        requestId: requestId,
                        isNewChannel: isNewChannel,
                        observerCount: observerCount
                    });
                },
                complete: ()=>{
                    report({
                        type: 'completed'
                    });
                    detachDiagnostics();
                    sink.complete?.();
                }
            };
            if (!existingChannel) {
                const newChannel = {
                    sinks: new Set([
                        localSink
                    ]),
                    dispose: ()=>{},
                    lastRequestId: null,
                    hasReceivedResponse: false
                };
                joinedChannel = newChannel;
                let terminated = false;
                newChannel.dispose = client.subscribe(payload, {
                    next: (value)=>{
                        if (diagnosticsEnabled) newChannel.hasReceivedResponse = true;
                        // @ts-expect-error agg prop is missing on generic "extensions" type
                        const aggRequestId = value?.extensions?.gateway?.request_id;
                        if (aggRequestId) newChannel.lastRequestId = aggRequestId;
                        for (const s of Array.from(newChannel.sinks))try {
                            s.next(value);
                        } catch  {
                        /* isolate sinks */ }
                    },
                    error: (sinkError)=>{
                        terminated = true;
                        const errorInfo = (0, $7GiIo.getSinkError)(sinkError);
                        const sinks = Array.from(newChannel.sinks);
                        const { lastRequestId: lastRequestId } = newChannel;
                        if (!guardChannelOwnership || channels.get(key) === newChannel) channels.delete(key);
                        newChannel.sinks.clear();
                        for (const s of sinks)try {
                            s.error(errorInfo, lastRequestId);
                        } catch  {
                        /* isolate sinks */ }
                    },
                    complete: ()=>{
                        terminated = true;
                        const sinks = Array.from(newChannel.sinks);
                        if (!guardChannelOwnership || channels.get(key) === newChannel) channels.delete(key);
                        newChannel.sinks.clear();
                        for (const s of sinks)try {
                            s.complete?.();
                        } catch  {
                        /* isolate sinks */ }
                    }
                });
                // A synchronous terminal callback may already have opened a replacement.
                // Register only a live channel, once its real disposer is available.
                if (!guardChannelOwnership || !terminated) channels.set(key, newChannel);
            } else existingChannel.sinks.add(localSink);
            return ()=>{
                report({
                    type: 'disposed'
                });
                detachDiagnostics();
                const c = guardChannelOwnership ? joinedChannel : channels.get(key);
                if (!c) return;
                const removed = c.sinks.delete(localSink);
                if (guardChannelOwnership && !removed) return;
                if (c.sinks.size === 0) {
                    if (!guardChannelOwnership || channels.get(key) === c) channels.delete(key);
                    try {
                        c.dispose();
                    } catch  {
                    /* upstream dispose errors must not break Relay teardown */ }
                }
            };
        });
    if (typeof subscribeOptions === 'undefined') $0f6c436cadd337a2$var$cachedDefaultSubscribe = fn;
    return fn;
}
const $0f6c436cadd337a2$export$ec068583843480e7 = $0f6c436cadd337a2$export$10f5a0700f263f11();

});
parcelRegister("irnMl", function(module, exports) {
$parcel$export(module.exports, "getSubscriptionUrl", () => $919a96e3007c5012$export$192ea60656b1a47f);

var $5UfqC = parcelRequire("5UfqC");
function $919a96e3007c5012$export$192ea60656b1a47f(context) {
    if (typeof context !== 'object' || context === null || !('type' in context) || context.type !== 'workspace' || !('product' in context) || typeof context.product !== 'string' || !('workspaceId' in context) || typeof context.workspaceId !== 'string') throw new Error('Invalid subscription sharding context');
    return `${(0, $5UfqC.getAggSubscriptionEndpoint)()}/${$919a96e3007c5012$var$encodeContextSegment(context.product)}/workspace/${$919a96e3007c5012$var$encodeContextSegment(context.workspaceId)}`;
}
function $919a96e3007c5012$var$encodeContextSegment(value) {
    if (!value || value === '.' || value === '..') throw new Error('Invalid subscription sharding context segment');
    return encodeURIComponent(value);
}

});


parcelRegister("gP2Fh", function(module, exports) {
$parcel$export(module.exports, "createRelayHandlerProvider", () => $f8edb4129ab13200$export$a40b5c8b00dd9369);

var $ArurZ = parcelRequire("ArurZ");

var $51KQC = parcelRequire("51KQC");

var $iXWi7 = parcelRequire("iXWi7");
function $f8edb4129ab13200$export$a40b5c8b00dd9369(source) {
    const DeleteRecordHandler = (0, $iXWi7.createDeleteRecordHandler)(source);
    return (handle)=>{
        switch(handle){
            case 'deleteEdge':
                return 0, $51KQC.DeleteEdgeHandler;
            case 'deleteRecord':
                return DeleteRecordHandler;
            default:
                return (0, $ArurZ.DefaultHandlerProvider)(handle);
        }
    };
}

});
parcelRegister("51KQC", function(module, exports) {
$parcel$export(module.exports, "DeleteEdgeHandler", () => $35646952b50c3dad$export$a2264b8f69028704);

var $ArurZ = parcelRequire("ArurZ");

var $cwFVG = parcelRequire("cwFVG");

var $io12q = parcelRequire("io12q");
// Copied from ConnectionHandler.deleteNode implementation with a single change in behaviour:
// nodeID is compared to the `id` field of the node, rather than node.getDataID().
// This is a sane thing to do within the scope of a single connection even in the light of
// id collisions present in AGG for the entities of different types.
// Such change makes @deleteEdge directive usable again.
function $35646952b50c3dad$var$deleteNode(record, nodeID) {
    const { EDGES: EDGES, NODE: NODE } = (0, $ArurZ.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    let nextEdges;
    for(let ii = 0; ii < edges.length; ii++){
        const edge = edges[ii];
        const node = edge && edge.getLinkedRecord(NODE);
        // N.B. node.getValue('id') instead of node.getDataID()
        if (node != null && node.getValue('id') === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
const $35646952b50c3dad$export$a2264b8f69028704 = {
    update: (store, payload)=>{
        const record = store.get(payload.dataID);
        if (record == null) return;
        // @types/relay-runtime is broken, handleArgs is present in the original Flow types.
        const { connections: connections } = payload.handleArgs;
        (0, $cwFVG.default)(connections != null, 'MutationHandlers: Expected connection IDs to be specified.');
        const idOrIds = record.getValue(payload.fieldKey);
        const idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach((id)=>{
            if (typeof id === 'string') for (const connectionID of connections){
                const connection = store.get(connectionID);
                if (connection == null) {
                    (0, $io12q.default)(false, `[Relay] The connection with id ${connectionID} doesn't exist.`);
                    continue;
                }
                $35646952b50c3dad$var$deleteNode(connection, id);
            }
        });
    }
};

});
parcelRegister("cwFVG", function(module, exports) {
$parcel$export(module.exports, "default", () => $91e8ff83ae1b0516$export$2e2bcd8739ae039);
var $91e8ff83ae1b0516$var$isProduction = true;
var $91e8ff83ae1b0516$var$prefix = 'Invariant failed';
function $91e8ff83ae1b0516$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($91e8ff83ae1b0516$var$isProduction) throw new Error($91e8ff83ae1b0516$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($91e8ff83ae1b0516$var$prefix, ": ").concat(provided) : $91e8ff83ae1b0516$var$prefix;
    throw new Error(value);
}

});

parcelRegister("io12q", function(module, exports) {
$parcel$export(module.exports, "default", () => $d62b460e326ce0e1$export$2e2bcd8739ae039);
var $d62b460e326ce0e1$var$isProduction = true;
function $d62b460e326ce0e1$var$warning(condition, message) {
    if (!$d62b460e326ce0e1$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $d62b460e326ce0e1$export$2e2bcd8739ae039 = $d62b460e326ce0e1$var$warning;

});


parcelRegister("iXWi7", function(module, exports) {
$parcel$export(module.exports, "createDeleteRecordHandler", () => $1ded26b280bc4c3f$export$a61ecd985ed07422);
const $1ded26b280bc4c3f$var$RELAY_DATA_ID_SEPARATOR = ':::::';
const $1ded26b280bc4c3f$export$a61ecd985ed07422 = (source)=>({
        update: (store, payload)=>{
            const record = store.get(payload.dataID);
            if (record == null) return;
            const idOrIds = record.getValue(payload.fieldKey);
            const aris = Array.isArray(idOrIds) ? idOrIds : [
                idOrIds
            ];
            const idsInStore = source.getRecordIDs();
            const arisToDelete = aris.flatMap((id)=>{
                if (typeof id !== 'string') return [];
                const typeQualifiedPrefix = `${id}${$1ded26b280bc4c3f$var$RELAY_DATA_ID_SEPARATOR}`;
                const matchingStoreIDs = idsInStore.filter((dataID)=>dataID.startsWith(typeQualifiedPrefix));
                return matchingStoreIDs;
            });
            arisToDelete.forEach((dataID)=>store.delete(dataID));
        }
    });

});


parcelRegister("4Sf93", function(module, exports) {
$parcel$export(module.exports, "ufoDataFetchHoldMiddleware", () => $acbf901ef4d7b6e4$export$3e78a79ab7bcbcc3);

var $ArurZ = parcelRequire("ArurZ");

var $jMaQ3 = parcelRequire("jMaQ3");
const $acbf901ef4d7b6e4$var$HELD_INTERACTION_TYPES = [
    'press',
    'typing'
];
const $acbf901ef4d7b6e4$export$3e78a79ab7bcbcc3 = (next, options)=>(request, variables, cacheConfig, uploadables)=>{
        if (options?.getIsEnabled?.() !== true) return next(request, variables, cacheConfig, uploadables);
        const source = next(request, variables, cacheConfig, uploadables);
        if ('subscribe' in source) return (0, $ArurZ.Observable).create((sink)=>{
            const releaseHold = (0, $jMaQ3.startDataFetchHold)({
                label: `relay-${request.operationKind}`,
                // `as const` to ignore `no-literal-string-in-object`
                name: request.name,
                interactionTypes: $acbf901ef4d7b6e4$var$HELD_INTERACTION_TYPES
            });
            const subscription = source.subscribe(sink);
            return ()=>{
                try {
                    subscription.unsubscribe();
                } finally{
                    releaseHold?.();
                }
            };
        });
        return source;
    };

});
parcelRegister("jMaQ3", function(module, exports) {
$parcel$export(module.exports, "startDataFetchHold", () => $b8ad577e1ad5b8c8$export$fbd04cc8165928ea);

var $8OjRF = parcelRequire("8OjRF");

var $jnGk3 = parcelRequire("jnGk3");
function $b8ad577e1ad5b8c8$export$fbd04cc8165928ea({ label: label, name: name, interactionTypes: interactionTypes }) {
    const interaction = (0, $8OjRF.getActiveInteraction)();
    if (!interaction || interaction.end !== 0) return;
    if (interactionTypes && !interactionTypes.includes(interaction.type)) return;
    const releaseHold = (0, $8OjRF.addHold)(interaction.id, [
        {
            name: label
        }
    ], name, false);
    let released = false;
    return ()=>{
        if (released) return;
        released = true;
        (0, $jnGk3.default)(()=>{
            releaseHold();
            (0, $8OjRF.tryComplete)(interaction.id);
        });
    };
}

});
parcelRegister("8OjRF", function(module, exports) {
$parcel$export(module.exports, "PreviousInteractionLog", () => $56736c0547554e17$export$dbba6cdedab4e68b);
$parcel$export(module.exports, "postInteractionLog", () => $56736c0547554e17$export$d8f52e8f804021e8);
$parcel$export(module.exports, "segmentUnmountCache", () => $56736c0547554e17$export$a2b14406ded37d60);
$parcel$export(module.exports, "getActiveInteraction", () => $56736c0547554e17$export$2b3954d2e8509985);
$parcel$export(module.exports, "updatePageLoadInteractionName", () => $56736c0547554e17$export$f6f1cf5bedf83c71);
$parcel$export(module.exports, "addCustomData", () => $56736c0547554e17$export$e4380431c2bdabee);
$parcel$export(module.exports, "addCohortingCustomData", () => $56736c0547554e17$export$20265b12c6625451);
$parcel$export(module.exports, "addCustomTiming", () => $56736c0547554e17$export$27cacb7d7f3fe20a);
$parcel$export(module.exports, "addMark", () => $56736c0547554e17$export$728e28c22a0fba4);
$parcel$export(module.exports, "addSpan", () => $56736c0547554e17$export$2c1d6e17cfa9bbc7);
$parcel$export(module.exports, "addSpanToAll", () => $56736c0547554e17$export$943a8b2b5d6b1809);
$parcel$export(module.exports, "addHold", () => $56736c0547554e17$export$7606887303596f82);
$parcel$export(module.exports, "addHoldByID", () => $56736c0547554e17$export$10582acd678c213);
$parcel$export(module.exports, "removeHoldByID", () => $56736c0547554e17$export$4983dfbbb996f7ae);
$parcel$export(module.exports, "addError", () => $56736c0547554e17$export$239c33984d9b1367);
$parcel$export(module.exports, "addErrorToAll", () => $56736c0547554e17$export$7379c15afd3840fa);
$parcel$export(module.exports, "addProfilerTimings", () => $56736c0547554e17$export$53d6f611de951a13);
$parcel$export(module.exports, "sinkInteractionHandler", () => $56736c0547554e17$export$9e614a29a1ac213e);
$parcel$export(module.exports, "sinkPostInteractionLogHandler", () => $56736c0547554e17$export$8a1ba7bef607358a);
$parcel$export(module.exports, "tryComplete", () => $56736c0547554e17$export$673be905888f8839);
$parcel$export(module.exports, "abort", () => $56736c0547554e17$export$5def58af4fd46132);
$parcel$export(module.exports, "abortByNewInteraction", () => $56736c0547554e17$export$c4a545284f55edf2);
$parcel$export(module.exports, "abortAll", () => $56736c0547554e17$export$614a7af2affc5dff);
$parcel$export(module.exports, "addNewInteraction", () => $56736c0547554e17$export$1a1ed1e1fdb2006b);
$parcel$export(module.exports, "addBrowserMetricEvent", () => $56736c0547554e17$export$4a759336b50e86e3);
$parcel$export(module.exports, "addApdex", () => $56736c0547554e17$export$35220fd6cdd1b731);
$parcel$export(module.exports, "addRequestInfo", () => $56736c0547554e17$export$57d55b4569823d8f);
$parcel$export(module.exports, "addSegment", () => $56736c0547554e17$export$1c43f9ac826b6462);
$parcel$export(module.exports, "removeSegment", () => $56736c0547554e17$export$d0365e48b58231c3);
$parcel$export(module.exports, "interactionSpans", () => $56736c0547554e17$export$6ce04c7ca6810a7e);
$parcel$export(module.exports, "addCustomSpans", () => $56736c0547554e17$export$5342dcad19138a1c);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Preserves the existing UUID implementation.

var $2BKzr = parcelRequire("2BKzr");

var $2aEiL = parcelRequire("2aEiL");

var $fskN5 = parcelRequire("fskN5");

var $3D6wc = parcelRequire("3D6wc");

var $5tITM = parcelRequire("5tITM");

var $bAEA2 = parcelRequire("bAEA2");

var $i7UKa = parcelRequire("i7UKa");

var $85exp = parcelRequire("85exp");

var $ktZzU = parcelRequire("ktZzU");

var $9S99b = parcelRequire("9S99b");

var $i8z2S = parcelRequire("i8z2S");

var $kPSgw = parcelRequire("kPSgw");

var $58teO = parcelRequire("58teO");

var $bIWIw = parcelRequire("bIWIw");

var $eId1k = parcelRequire("eId1k");

var $i0C6O = parcelRequire("i0C6O");
const $56736c0547554e17$export$dbba6cdedab4e68b = {
    id: undefined,
    name: undefined,
    type: undefined,
    isAborted: undefined,
    timestamp: undefined
};
const $56736c0547554e17$export$d8f52e8f804021e8 = new (0, $i0C6O.default)();
const $56736c0547554e17$var$interactionQueue = [];
const $56736c0547554e17$var$segmentCache = new Map();
const $56736c0547554e17$export$a2b14406ded37d60 = new Map(); // Temporarily store segment unmount counts
const $56736c0547554e17$var$segmentObservers = [];
function $56736c0547554e17$export$2b3954d2e8509985() {
    const interactionId = (0, $i8z2S.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $eId1k.interactions).get(interactionId.current);
}
function $56736c0547554e17$var$isPerformanceTracingEnabled() {
    return (0, $5tITM.getConfig)()?.enableAdditionalPerformanceMarks || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
let $56736c0547554e17$var$performanceEventObserver;
const $56736c0547554e17$export$17afbba0f16b4b19 = ()=>{
    $56736c0547554e17$var$performanceEventObserver = $56736c0547554e17$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $56736c0547554e17$export$e6be05b411ce21a6(entry);
    });
    return $56736c0547554e17$var$performanceEventObserver;
};
const $56736c0547554e17$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = $56736c0547554e17$export$2b3954d2e8509985();
    if (interaction?.type === 'press') {
        const responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $56736c0547554e17$var$labelStackToString(labelStack, name) {
    const stack = [
        ...labelStack ?? []
    ];
    if (name) stack.push({
        name: name
    });
    return stack.map((l)=>l.name)?.join('/');
}
function $56736c0547554e17$var$labelStackToIdString(labelStack) {
    return labelStack?.map((l)=>'segmentId' in l ? `${l.name}:${l.segmentId}` : `${l.name}`)?.join('/');
}
function $56736c0547554e17$var$addSegmentObserver(observer) {
    $56736c0547554e17$var$segmentObservers.push(observer);
    for (const segmentInfo of $56736c0547554e17$var$segmentCache.values())observer.onAdd(segmentInfo);
}
function $56736c0547554e17$var$removeSegmentObserver(observer) {
    const index = $56736c0547554e17$var$segmentObservers.findIndex((obs)=>obs === observer);
    if (index !== -1) $56736c0547554e17$var$segmentObservers.splice(index, 1);
}
function $56736c0547554e17$export$cd7f480d6b8286c3(interactionId) {
    (0, $eId1k.interactions).delete(interactionId);
}
function $56736c0547554e17$export$f6f1cf5bedf83c71(ufoName, routeName = ufoName) {
    const interaction = $56736c0547554e17$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $56736c0547554e17$export$12f2b6cb85d59904(interactionId, data) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((key)=>{
        interaction.metaData[key] = data[key];
    });
}
function $56736c0547554e17$export$e4380431c2bdabee(interactionId, labelStack, data) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((i)=>{
        interaction.customData.push({
            labelStack: labelStack,
            data: {
                [i]: data[i]
            }
        });
    });
}
function $56736c0547554e17$export$9bfdf89f35702b2e(interactionId, segmentId, data) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) (interaction.excluded3pSegmentData ??= {})[segmentId] = {
        segmentId: segmentId,
        ...interaction.excluded3pSegmentData[segmentId],
        ...data
    };
}
function $56736c0547554e17$export$35723c3772fda7dd(interactionId, segmentId, data) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        if (!interaction.segmentExtraData) interaction.segmentExtraData = {};
        interaction.segmentExtraData[segmentId] = {
            ...interaction.segmentExtraData[segmentId],
            ...data
        };
    }
}
/**
 * Builds a stable cross-segment dedup key for a segment3pTimings entry.
 *
 * For `resource-timing`, query-stripped backend labels + timing fields identify a request without
 * depending on query parameters. Shared CSS/JS asset timings dedupe across segments, but backend
 * fetch/XHR entries are scoped by `segmentId` because each iframe can make its own backend request
 * to the same URL.
 *
 * For all other labels the data objects are small (a handful of fields), so we use a full
 * JSON fingerprint which is cheap and collision-free.
 */ function $56736c0547554e17$var$buildCrossSegmentDedupKey(entry, segmentId) {
    if (entry.label === 'resource-timing') {
        const { label: resourceLabel, startTime: startTime, duration: duration, requestStart: requestStart, fetchStart: fetchStart, ttfb: ttfb, type: type } = entry.data;
        if ((0, $kPSgw.BACKEND_RESOURCE_TIMING_INITIATOR_TYPES).has(String(type))) // Backend calls are separate requests per segment; include extra timings and segment scope.
        return `resource-timing|${resourceLabel}|${startTime}|${duration}|${fetchStart}|${requestStart}|${ttfb}|${segmentId}`;
        // Shared CSS/JS assets keep the original B3 key so they can dedupe across segments.
        return `resource-timing|${resourceLabel}|${startTime}|${duration}`;
    }
    return `${entry.label}|${JSON.stringify(entry.data)}`;
}
function $56736c0547554e17$export$c227d812a1e08d80(interactionId, segmentId, entry) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        // B3: dedup by content — drops identical entries within and across iframes.
        // Abort markers are excluded so every segment's abort is recorded.
        if (entry.label !== 'segment-timing-abort') {
            if (!interaction.segment3pCrossSegmentSeen) interaction.segment3pCrossSegmentSeen = new Set();
            const key = $56736c0547554e17$var$buildCrossSegmentDedupKey(entry, segmentId);
            if (interaction.segment3pCrossSegmentSeen.has(key)) return;
            interaction.segment3pCrossSegmentSeen.add(key);
        }
        if (!interaction.segment3pTimings) interaction.segment3pTimings = {};
        if (!interaction.segment3pTimings[segmentId]) interaction.segment3pTimings[segmentId] = [];
        interaction.segment3pTimings[segmentId].push(entry);
    }
}
function $56736c0547554e17$export$20265b12c6625451(interactionId, key, value) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction == null) return;
    // Allow null and undefined values
    if (value === null || value === undefined) {
        interaction.cohortingCustomData.set(key, value);
        return;
    }
    // Validate that the value is a primitive (number, boolean, or string)
    if (typeof value !== 'number' && typeof value !== 'boolean' && typeof value !== 'string') return;
    // Validate string length (max 50 characters)
    if (typeof value === 'string' && value.length > 50) return;
    interaction.cohortingCustomData.set(key, value);
}
function $56736c0547554e17$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        const sanitizedData = Object.fromEntries(Object.entries(data).map(([key, timingData])=>[
                (0, $3D6wc.sanitizeTimingName)(key),
                timingData
            ]));
        interaction.customTimings.push({
            labelStack: labelStack,
            data: sanitizedData
        });
        if ($56736c0547554e17$var$isPerformanceTracingEnabled()) for (const [key, timingData] of Object.entries(sanitizedData)){
            const { startTime: startTime, endTime: endTime } = timingData;
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$56736c0547554e17$var$labelStackToString(labelStack, key)} [custom_timing]`, {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
function $56736c0547554e17$export$728e28c22a0fba4(interactionId, type, name, labelStack, time = performance.now()) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($56736c0547554e17$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$56736c0547554e17$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $56736c0547554e17$export$85d1eb835f669bf(_interactionId, _labelStack, _time) {}
function $56736c0547554e17$export$c4b23cc624bd2fb(type, name, labelStack, time = performance.now()) {
    (0, $eId1k.interactions).forEach((interaction)=>{
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($56736c0547554e17$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$56736c0547554e17$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $56736c0547554e17$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start, end = performance.now(), size) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($56736c0547554e17$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${$56736c0547554e17$var$labelStackToString(labelStack, name)} [${type}]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
}
function $56736c0547554e17$export$943a8b2b5d6b1809(type, name, labelStack, start, end = performance.now(), size = 0) {
    (0, $eId1k.interactions).forEach((interaction)=>{
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($56736c0547554e17$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$56736c0547554e17$var$labelStackToString(labelStack, name)} [${type}]`, {
            start: start,
            end: end,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary'
                }
            }
        });
    } catch  {
    // do nothing
    }
}
function $56736c0547554e17$export$9e04fe1a58571ec(moduleId, timestamp) {
    $56736c0547554e17$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $56736c0547554e17$export$6f228d1fdc911d7(identifier, start, end) {
    $56736c0547554e17$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
const $56736c0547554e17$var$moduleLoadingRequests = {};
function $56736c0547554e17$export$f5a8f10de74904da(input) {
    let result = input ?? '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $56736c0547554e17$var$addHoldCriterion(id, labelStack, name, startTime) {
    if (!window.__CRITERION__?.addUFOHold) return;
    window.__CRITERION__.addUFOHold(id, $56736c0547554e17$var$labelStackToString(labelStack), name, startTime);
}
function $56736c0547554e17$var$removeHoldCriterion(id) {
    if (!window.__CRITERION__?.removeUFOHold) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $56736c0547554e17$export$7606887303596f82(interactionId, labelStack, name, _experimental, holdStartedAt) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $2BKzr.default)();
    if (!interaction) // add hold timestamp to post interaction log if interaction is complete
    $56736c0547554e17$export$d8f52e8f804021e8.addHoldInfo(labelStack, name, holdStartedAt ?? performance.now());
    if (interaction != null) {
        const start = holdStartedAt ?? performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ($56736c0547554e17$var$shouldMoveHoldToExtendedBucket(interaction, holdActive)) $56736c0547554e17$var$ensureExtendedHoldActive(interaction).set(id, {
            ...holdActive,
            start: start
        });
        else {
            interaction.holdActive.set(id, {
                ...holdActive,
                start: start
            });
            $56736c0547554e17$var$addHoldCriterion(id, labelStack, name, start);
        }
        return ()=>{
            const end = performance.now();
            if ($56736c0547554e17$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$56736c0547554e17$var$labelStackToString(labelStack, name)} [hold]`, {
                    start: start,
                    end: end,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'secondary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
            $56736c0547554e17$var$removeHoldCriterion(id);
            const currentInteraction = (0, $eId1k.interactions).get(interactionId);
            const currentHold = interaction.holdActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push({
                        ...currentHold,
                        end: end
                    });
                    interaction.holdActive.delete(id);
                }
                if (interaction.hold3pActive) {
                    const current3pHold = interaction.hold3pActive.get(id);
                    if (current3pHold != null) {
                        $56736c0547554e17$var$recordMetricVariantCategoryEnd(currentInteraction, current3pHold.labelStack, end);
                        if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                        currentInteraction.hold3pInfo.push({
                            ...current3pHold,
                            end: end
                        });
                        interaction.hold3pActive.delete(id);
                    }
                }
            }
        };
    }
    return ()=>{};
}
function $56736c0547554e17$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        };
        if ($56736c0547554e17$var$shouldMoveHoldToExtendedBucket(interaction, holdActive)) $56736c0547554e17$var$ensureExtendedHoldActive(interaction).set(id, holdActive);
        else {
            interaction.holdActive.set(id, holdActive);
            $56736c0547554e17$var$addHoldCriterion(id, labelStack, name, start);
        }
    }
    return ()=>{};
}
function $56736c0547554e17$export$d6cf9650acfb0dab(interactionId, labelStack, name, start, end) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        // `recordMetricVariantCategoryEnd` skips excluded (background-script) holds, so the completed
        // hold is retained in `hold3pInfo` for observability but never contributes a third-party
        // category end.
        $56736c0547554e17$var$recordMetricVariantCategoryEnd(interaction, labelStack, end);
        $56736c0547554e17$var$ensureExtendedHoldInfo(interaction).push({
            labelStack: labelStack,
            name: name,
            start: start,
            end: end
        });
    }
}
function $56736c0547554e17$export$4983dfbbb996f7ae(interactionId, id) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        const end = performance.now();
        const currentInteraction = (0, $eId1k.interactions).get(interactionId);
        const currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            if ($56736c0547554e17$var$shouldMoveHoldToExtendedBucket(currentInteraction, currentHold)) $56736c0547554e17$var$ensureExtendedHoldInfo(currentInteraction).push({
                ...currentHold,
                end: end
            });
            else currentInteraction.holdInfo.push({
                ...currentHold,
                end: end
            });
            interaction.holdActive.delete(id);
            $56736c0547554e17$var$removeHoldCriterion(id);
        }
        if (interaction.hold3pActive) {
            const current3pHold = interaction.hold3pActive.get(id);
            if (currentInteraction != null && current3pHold != null) {
                $56736c0547554e17$var$recordMetricVariantCategoryEnd(currentInteraction, current3pHold.labelStack, end);
                if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                currentInteraction.hold3pInfo.push({
                    ...current3pHold,
                    end: end
                });
                interaction.hold3pActive.delete(id);
            }
        }
    }
}
function $56736c0547554e17$export$2df109852219d16e(interactionId) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
function $56736c0547554e17$export$b1ce94abc72c69d7(interactionId, info) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction == null) return ()=>{};
    const preloadRow = {
        source: info.source,
        preloadStartedAt: info.preloadStartedAt,
        adoptedAt: info.adoptedAt
    };
    interaction.preloadInfo.push(preloadRow);
    const releaseHold = $56736c0547554e17$export$7606887303596f82(interactionId, [], `preload:${info.source}`, false, interaction.start);
    let released = false;
    return ()=>{
        if (released) return;
        released = true;
        preloadRow.settledAt = performance.now();
        releaseHold();
    };
}
function $56736c0547554e17$export$43f87b52eb8fc449(args) {
    const interaction = $56736c0547554e17$export$2b3954d2e8509985();
    if (interaction == null || interaction.ufoName !== args.experienceKey || args.preloadKey !== undefined && interaction.preloadKey !== undefined && interaction.preloadKey !== args.preloadKey) return null;
    return $56736c0547554e17$export$b1ce94abc72c69d7(interaction.id, {
        source: args.source,
        preloadStartedAt: args.preloadStartedAt,
        adoptedAt: args.adoptedAt
    });
}
let $56736c0547554e17$var$onInteractionStartForPreloadHolds = null;
function $56736c0547554e17$export$e96f751b1e82abda(hook) {
    $56736c0547554e17$var$onInteractionStartForPreloadHolds = hook;
}
const $56736c0547554e17$export$9591b52b33ccc510 = {
    onPreload (moduleId, _priority) {
        $56736c0547554e17$export$9e04fe1a58571ec($56736c0547554e17$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart (info) {
        const timeoutId = setTimeout(()=>{
            delete $56736c0547554e17$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        const request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $56736c0547554e17$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete (info) {
        const request = $56736c0547554e17$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $56736c0547554e17$var$moduleLoadingRequests[info.identifier];
            $56736c0547554e17$export$6f228d1fdc911d7($56736c0547554e17$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted (id, moduleId) {
        const interactionId = (0, $i8z2S.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $56736c0547554e17$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted (id) {
        const interactionId = (0, $i8z2S.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $56736c0547554e17$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $56736c0547554e17$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError, errorHash, errorStatusCode) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError,
        errorHash: errorHash,
        errorStatusCode: errorStatusCode
    });
}
function $56736c0547554e17$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack, errorHash, errorStatusCode) {
    (0, $eId1k.interactions).forEach((interaction)=>{
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack,
            errorHash: errorHash,
            errorStatusCode: errorStatusCode
        });
    });
}
function $56736c0547554e17$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    if ($56736c0547554e17$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$56736c0547554e17$var$labelStackToString(labelStack)} [react-profiler] ${type}`, {
            start: startTime,
            duration: actualDuration,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary-dark'
                }
            }
        });
    } catch  {
    // do nothing
    }
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((0, $5tITM.getConfig)()?.postInteractionLog?.enabled) $56736c0547554e17$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $56736c0547554e17$var$pushToQueue(id, data) {
    $56736c0547554e17$var$interactionQueue.push({
        id: id,
        data: data
    });
}
let $56736c0547554e17$var$handleInteraction = $56736c0547554e17$var$pushToQueue;
const $56736c0547554e17$var$isKnownMetricVariantCategory = (type)=>type === 'third-party' || type === 'gen-ai';
const $56736c0547554e17$var$hasMetricVariantCategory = (labelStack, category)=>labelStack?.some((label)=>'type' in label && label.type === category) ?? false;
const $56736c0547554e17$var$hasAnyMetricVariantCategory = (labelStack)=>labelStack?.some((label)=>'type' in label && $56736c0547554e17$var$isKnownMetricVariantCategory(label.type)) ?? false;
/**
 * A hold is fully excluded from every metric window (standard and include-third-party) and from
 * completion gating iff its labelStack contains a single label that is BOTH `type: 'third-party'`
 * AND `excludeFromMetrics: true`. Requiring both on the same label guarantees exclusion can only
 * ever apply to third-party work, never first-party. Such holds are dropped at creation time, so
 * they never enter `holdActive`/`hold3pActive`, never block completion.
 */ const $56736c0547554e17$var$isExcludedThirdPartyHold = (labelStack)=>labelStack?.some((label)=>'type' in label && label.type === 'third-party' && 'excludeFromMetrics' in label && label.excludeFromMetrics === true) ?? false;
const $56736c0547554e17$var$getMetricVariantCategories = (labelStack)=>{
    const categories = new Set();
    labelStack?.forEach((label)=>{
        if ('type' in label && $56736c0547554e17$var$isKnownMetricVariantCategory(label.type)) categories.add(label.type);
    });
    return [
        ...categories
    ];
};
const $56736c0547554e17$var$hasMetricVariantCategoryInHoldData = (interaction, category)=>interaction.holdInfo.some((hold)=>$56736c0547554e17$var$hasMetricVariantCategory(hold.labelStack, category)) || [
        ...interaction.holdActive.values() ?? []
    ].some((hold)=>$56736c0547554e17$var$hasMetricVariantCategory(hold.labelStack, category)) || [
        ...interaction.hold3pInfo ?? []
    ].some((hold)=>$56736c0547554e17$var$hasMetricVariantCategory(hold.labelStack, category)) || [
        ...interaction.hold3pActive?.values() ?? []
    ].some((hold)=>$56736c0547554e17$var$hasMetricVariantCategory(hold.labelStack, category));
const $56736c0547554e17$var$recordMetricVariantCategoryEnd = (interaction, labelStack, end)=>{
    // Excluded third-party holds (e.g. Forge background scripts) still live in `hold3pActive` and
    // gate completion like any third-party hold, but they must never contribute a third-party
    // category end. Skipping here covers every caller at once: the normal-release closure in
    // `addHold`, `removeHoldByID`, `addCompletedHold`, and the abort/timeout iterator
    // `recordActiveMetricVariantCategoryEnds`.
    if ($56736c0547554e17$var$isExcludedThirdPartyHold(labelStack)) return;
    const categories = $56736c0547554e17$var$getMetricVariantCategories(labelStack);
    if (categories.length === 0) return;
    interaction.metricCategoryEnds = interaction.metricCategoryEnds ?? {};
    categories.forEach((category)=>{
        interaction.metricCategoryEnds[category] = Math.max(interaction.metricCategoryEnds[category] ?? 0, end);
    });
};
const $56736c0547554e17$var$recordActiveMetricVariantCategoryEnds = (interaction, end)=>{
    interaction.hold3pActive?.forEach((hold)=>{
        $56736c0547554e17$var$recordMetricVariantCategoryEnd(interaction, hold.labelStack, end);
    });
};
const $56736c0547554e17$var$hasActiveMetricVariantCategory = (interaction, category)=>[
        ...interaction.hold3pActive?.values() ?? []
    ].some((hold)=>$56736c0547554e17$var$hasMetricVariantCategory(hold.labelStack, category));
function $56736c0547554e17$var$shouldMoveHoldToExtendedBucket(interaction, hold) {
    // Excluded third-party holds (e.g. Forge background scripts) are routed to the extended
    // (`hold3pActive`) bucket exactly like any other third-party hold: they carry `type: 'third-party'`
    // so `hasAnyMetricVariantCategory` is true. They therefore keep gating completion (which preserves
    // the standard-bucket VC parity), and are excluded ONLY at the third-party accounting sites
    // (`recordMetricVariantCategoryEnd` and the `end3p` computation via `getNonExcludedThirdPartyEnd`).
    return $56736c0547554e17$var$hasAnyMetricVariantCategory(hold.labelStack) || interaction.end !== 0 && hold.start > interaction.end;
}
/**
 * The third-party end marker (`end3p`), used as the `include-third-party` window end whenever no
 * genuine third-party category end was recorded, must reflect only NON-excluded third-party work.
 *
 * `currentTime` is the timestamp the caller would otherwise have used verbatim (e.g. the abort
 * time, or the interaction end on the success path). If there is any genuine (non-excluded)
 * third-party hold that is still ACTIVE at this point, that work legitimately extends to
 * `currentTime`, so we keep it. Otherwise the only active third-party holds are excluded
 * background scripts, which must NOT drag the marker, so we fall back to the latest end among the
 * already-released non-excluded holds, clamped to at least `interactionEnd`. This preserves the
 * pre-fix behaviour for real third-party work while preventing background scripts from inflating
 * `end3p` / the include-third-party window.
 *
 * Note the released entries in `hold3pInfo` are `HoldActive & { end: number }`, so we read `h.end`.
 */ const $56736c0547554e17$var$getNonExcludedThirdPartyEnd = (interaction, currentTime, interactionEnd)=>{
    const activeHolds = [
        ...interaction.hold3pActive?.values() ?? []
    ];
    const releasedHolds = interaction.hold3pInfo ?? [];
    // If this interaction never involved an excluded (background-script) hold at all
    // (none active AND none released), it is unaffected by an exclusion logic.
    // The derivation below only runs when at least one excluded hold actually exists.
    const hasAnyExcludedThirdParty = activeHolds.some((hold)=>$56736c0547554e17$var$isExcludedThirdPartyHold(hold.labelStack)) || releasedHolds.some((hold)=>$56736c0547554e17$var$isExcludedThirdPartyHold(hold.labelStack));
    if (!hasAnyExcludedThirdParty) return currentTime;
    // If a genuine (non-excluded) third-party hold is still active, the interaction is legitimately
    // being kept open by real third-party work, so the marker is the current time
    const hasActiveNonExcludedThirdParty = activeHolds.some((hold)=>!$56736c0547554e17$var$isExcludedThirdPartyHold(hold.labelStack));
    if (hasActiveNonExcludedThirdParty) return currentTime;
    // Otherwise, only excluded background-script holds (if any) remain active. `currentTime` may have
    // been pushed out purely by a background script, so derive the marker from the latest genuine
    // (non-excluded) third-party work instead, floored to the interaction end so it is never reported
    // earlier than the interaction itself and a background script can never drag it late.
    return Math.max(interactionEnd, ...releasedHolds.filter((hold)=>!$56736c0547554e17$var$isExcludedThirdPartyHold(hold.labelStack)).map((hold)=>hold.end));
};
function $56736c0547554e17$var$ensureExtendedHoldActive(interaction) {
    interaction.hold3pActive = interaction.hold3pActive ?? new Map();
    return interaction.hold3pActive;
}
function $56736c0547554e17$var$ensureExtendedHoldInfo(interaction) {
    interaction.hold3pInfo = interaction.hold3pInfo ?? [];
    return interaction.hold3pInfo;
}
function $56736c0547554e17$var$moveLateActiveHoldsToExtendedBucket(interaction) {
    if (interaction.end === 0) return;
    const holdsToMove = [
        ...interaction.holdActive.entries()
    ].filter(([, hold])=>$56736c0547554e17$var$shouldMoveHoldToExtendedBucket(interaction, hold));
    holdsToMove.forEach(([id, hold])=>{
        $56736c0547554e17$var$ensureExtendedHoldActive(interaction).set(id, hold);
        interaction.holdActive.delete(id);
    });
}
function $56736c0547554e17$var$ensureMetricWindows(interaction) {
    if (interaction.end === 0) return;
    const hasGenAI = $56736c0547554e17$var$hasMetricVariantCategoryInHoldData(interaction, 'gen-ai');
    const hasThirdParty = $56736c0547554e17$var$hasMetricVariantCategoryInHoldData(interaction, 'third-party');
    const includeThirdPartyEnd = interaction.metricCategoryEnds?.['third-party'] !== undefined ? Math.max(interaction.metricCategoryEnds['third-party'], interaction.end) : interaction.end3p;
    const includeGenAIEnd = interaction.metricCategoryEnds?.['gen-ai'] !== undefined ? Math.max(interaction.metricCategoryEnds['gen-ai'], interaction.end) : undefined;
    interaction.metricWindows = {
        ...interaction.metricWindows,
        standard: {
            start: interaction.start,
            end: interaction.end,
            includeCategories: [],
            excludeCategories: [
                'third-party',
                'gen-ai'
            ]
        }
    };
    if (includeThirdPartyEnd !== undefined && (hasThirdParty || !hasGenAI)) interaction.metricWindows['include-third-party'] = {
        start: interaction.start,
        end: includeThirdPartyEnd,
        includeCategories: [
            'third-party'
        ],
        excludeCategories: []
    };
    if (hasGenAI && includeGenAIEnd !== undefined) interaction.metricWindows['include-gen-ai'] = {
        start: interaction.start,
        end: includeGenAIEnd,
        includeCategories: [
            'gen-ai'
        ],
        excludeCategories: []
    };
}
function $56736c0547554e17$var$addLifecycleObservation(interaction, observation) {
    interaction.lifecycleObservations = interaction.lifecycleObservations ?? [];
    interaction.lifecycleObservations.push(observation);
}
function $56736c0547554e17$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach((cleanUpCallback)=>{
        cleanUpCallback();
    });
}
function $56736c0547554e17$var$finishInteraction(id, data, endTime = performance.now()) {
    data.end = endTime;
    $56736c0547554e17$var$ensureMetricWindows(data);
    try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} [${data.type}] ${data.ufoName} [ttai]`, {
            start: data.start,
            end: data.end,
            detail: {
                devtools: {
                    track: 'main metrics',
                    trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                    color: 'tertiary'
                }
            }
        });
        performance.mark(`TTAI`, {
            startTime: data.end,
            detail: {
                devtools: {
                    dataType: 'marker'
                }
            }
        });
    } catch  {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $9S99b.currentFeatureFlagsAccessed));
    (0, $ktZzU.clearActiveTrace)();
    $56736c0547554e17$var$callCleanUpCallbacks(data);
    (0, $58teO.flushSsrRenderProfilerTraces)();
    if (data.type === 'page_load') data.hydration = (0, $5tITM.getReactHydrationStats)();
    // By this time, stop the post interaction log observer if coinflip rate is 0
    if (!(0, $fskN5.default)((0, $5tITM.getPostInteractionRate)((0, $i7UKa.sanitizeUfoName)(data.ufoName), data.type))) $56736c0547554e17$export$d8f52e8f804021e8.stopVCObserver();
    $56736c0547554e17$export$cd7f480d6b8286c3(id);
    $56736c0547554e17$export$dbba6cdedab4e68b.id = data.id;
    $56736c0547554e17$export$dbba6cdedab4e68b.type = data.type;
    $56736c0547554e17$export$dbba6cdedab4e68b.timestamp = data.end;
    $56736c0547554e17$export$dbba6cdedab4e68b.name = data.ufoName || 'unknown';
    $56736c0547554e17$export$dbba6cdedab4e68b.isAborted = data.abortReason != null;
    if (data.ufoName) $56736c0547554e17$var$handleInteraction(id, data);
    if ($56736c0547554e17$var$isPerformanceTracingEnabled()) {
        const profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach((profilerTiming)=>{
            const labelStackId = $56736c0547554e17$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                const timing = profilerTimingMap.get(labelStackId) ?? {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < (timing.start ?? Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > (timing.end ?? Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            for (const [, { labelStack: labelStack, start: start, end: end }] of profilerTimingMap.entries())performance.measure(`\u{1F6F8} ${$56736c0547554e17$var$labelStackToString(labelStack)} [segment_ttai]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary-dark'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch  {
    // do nothing
    }
}
function $56736c0547554e17$export$9e614a29a1ac213e(sinkFn) {
    if ($56736c0547554e17$var$handleInteraction === $56736c0547554e17$var$pushToQueue) {
        $56736c0547554e17$var$handleInteraction = sinkFn;
        $56736c0547554e17$var$interactionQueue.forEach((interaction)=>{
            sinkFn(interaction.id, interaction.data);
        });
        $56736c0547554e17$var$interactionQueue.length = 0;
    }
}
function $56736c0547554e17$export$8a1ba7bef607358a(sinkFn) {
    $56736c0547554e17$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
let $56736c0547554e17$var$activeSubmitted = false;
function $56736c0547554e17$export$673be905888f8839(interactionId, endTime) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const shouldUseRawDataThirdParty = (0, $5tITM.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const postInteraction = async ()=>{
            if ((0, $5tITM.getConfig)()?.postInteractionLog?.enabled) $56736c0547554e17$export$d8f52e8f804021e8.onInteractionComplete(interaction);
            $56736c0547554e17$var$activeSubmitted = false;
        };
        const noMoreActiveMetricVariantHolds = interaction.hold3pActive?.size === 0 || interaction.hold3pActive === undefined;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $56736c0547554e17$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If using separated metric variant behavior, wait for extended category holds to clear.
        // The backing fields still use their legacy 3P names because they are part of the existing
        // third-party payload contract, but this bucket now also drives client metric windows.
        if (shouldUseSeparatedMetricVariantBehavior) {
            // If there are no standard holds active, mark the interaction as successful
            // but don't finish until extended metric variant holds are cleared.
            if (noMoreActiveHolds && !noMoreActiveMetricVariantHolds) {
                // Mark interaction as successful by setting endTime, but don't finish yet
                if (endTime !== undefined && interaction.end === 0) interaction.end = endTime;
                $56736c0547554e17$var$moveLateActiveHoldsToExtendedBucket(interaction);
                $56736c0547554e17$var$ensureMetricWindows(interaction);
                // Wait for extended metric variant holds to clear before finishing.
                return;
            }
            // If all holds, including extended metric variant holds, are cleared, finish the interaction.
            if (noMoreActiveHolds && noMoreActiveMetricVariantHolds) {
                if (!$56736c0547554e17$var$activeSubmitted) {
                    // Set the legacy third-party end marker when extended metric variant holds clear,
                    // preserving existing 3P payload behavior while category-specific end times are
                    // recorded separately in metricCategoryEnds. When a genuine third-party hold is still
                    // active (or was the last to release), `getNonExcludedThirdPartyEnd` returns the same
                    // clamped current time as before. When only excluded background-script holds remain,
                    // the marker is derived from the non-excluded third-party holds and floored to the
                    // interaction end, so a background script cannot drag it late.
                    const currentTime = endTime ?? performance.now();
                    interaction.end3p = $56736c0547554e17$var$getNonExcludedThirdPartyEnd(interaction, interaction.end !== 0 && currentTime < interaction.end ? interaction.end : currentTime, interaction.end !== 0 ? interaction.end : currentTime);
                    $56736c0547554e17$var$ensureMetricWindows(interaction);
                    $56736c0547554e17$var$finishInteraction(interactionId, interaction, interaction.end !== 0 ? interaction.end : endTime);
                    if ((0, $5tITM.getConfig)()?.extraSearchPageInteraction?.enabled && interaction.ufoName === (0, $5tITM.getConfig)()?.extraSearchPageInteraction?.searchPageMetricName) (0, $bAEA2.onSearchPageInteractionComplete)(interactionId, interaction);
                    $56736c0547554e17$var$activeSubmitted = true;
                }
                postInteraction();
            }
        } else if (noMoreActiveHolds) {
            if (!$56736c0547554e17$var$activeSubmitted) {
                $56736c0547554e17$var$finishInteraction(interactionId, interaction, endTime);
                if ((0, $5tITM.getConfig)()?.extraSearchPageInteraction?.enabled && interaction.ufoName === (0, $5tITM.getConfig)()?.extraSearchPageInteraction?.searchPageMetricName) (0, $bAEA2.onSearchPageInteractionComplete)(interactionId, interaction);
                $56736c0547554e17$var$activeSubmitted = true;
            }
            postInteraction();
        }
    }
}
function $56736c0547554e17$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach((cancelCallback)=>{
        cancelCallback();
    });
}
function $56736c0547554e17$export$5def58af4fd46132(interactionId, abortReason) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        const shouldUseRawDataThirdParty = (0, $5tITM.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $56736c0547554e17$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Excluded background-script holds that are still active at abort/timeout must not drag
            // `end3p` (and thus the include-third-party window) past the real interaction end. Derive it
            // from the non-excluded third-party holds only. `recordActiveMetricVariantCategoryEnds`
            // likewise skips excluded holds internally.
            interaction.end3p = $56736c0547554e17$var$getNonExcludedThirdPartyEnd(interaction, performance.now(), endTime);
            $56736c0547554e17$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $56736c0547554e17$var$addLifecycleObservation(interaction, {
                type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
                timestamp: interaction.end3p,
                activeHoldCount: interaction.hold3pActive?.size ?? 0
            });
            $56736c0547554e17$var$ensureMetricWindows(interaction);
            $56736c0547554e17$var$finishInteraction(interactionId, interaction, endTime);
            $56736c0547554e17$export$d8f52e8f804021e8.reset();
            $56736c0547554e17$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        $56736c0547554e17$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $56736c0547554e17$var$addLifecycleObservation(interaction, {
            type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
            timestamp: performance.now(),
            activeHoldCount: interaction.holdActive.size + (interaction.hold3pActive?.size ?? 0)
        });
        $56736c0547554e17$var$finishInteraction(interactionId, interaction);
        $56736c0547554e17$export$d8f52e8f804021e8.reset();
        $56736c0547554e17$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $56736c0547554e17$export$c4a545284f55edf2(interactionId, interactionName) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        const shouldUseRawDataThirdParty = (0, $5tITM.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $56736c0547554e17$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Excluded background-script holds still active at this point must not drag `end3p` (and
            // thus the include-third-party window) past the real interaction end. Derive it from the
            // non-excluded third-party holds only, clamped to at least the interaction end.
            interaction.end3p = $56736c0547554e17$var$getNonExcludedThirdPartyEnd(interaction, performance.now(), endTime);
            $56736c0547554e17$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $56736c0547554e17$var$addLifecycleObservation(interaction, {
                type: 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: interactionName
            });
            $56736c0547554e17$var$ensureMetricWindows(interaction);
            $56736c0547554e17$var$finishInteraction(interactionId, interaction, endTime);
            $56736c0547554e17$export$d8f52e8f804021e8.reset();
            $56736c0547554e17$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        $56736c0547554e17$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $56736c0547554e17$var$addLifecycleObservation(interaction, {
            type: 'new_interaction_started',
            timestamp: performance.now(),
            triggerName: interactionName
        });
        $56736c0547554e17$var$finishInteraction(interactionId, interaction);
        $56736c0547554e17$export$d8f52e8f804021e8.reset();
        $56736c0547554e17$export$d8f52e8f804021e8.stopVCObserver();
    } else {
        // post-interaction log is active after interaction is aborted by new one
        $56736c0547554e17$export$d8f52e8f804021e8.reset();
        $56736c0547554e17$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $56736c0547554e17$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    const activeInteraction = $56736c0547554e17$export$2b3954d2e8509985();
    const finishInteractions = (0, $5tITM.getFinishInteractionOnTransition)();
    (0, $eId1k.interactions).forEach((interaction, interactionId)=>{
        const isActiveInteraction = activeInteraction === interaction;
        let hasFinished = interaction.holdActive.size === 0;
        if (isActiveInteraction && abortReason === 'transition' && interaction.type === 'press' && finishInteractions?.includes(interaction.ufoName)) hasFinished = true;
        const shouldUseRawDataThirdParty = (0, $5tITM.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $56736c0547554e17$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Excluded background-script holds still active at transition/new-interaction abort must not
            // drag `end3p` (and thus the include-third-party window) past the real interaction end.
            // Derive it from the non-excluded third-party holds only, clamped to at least the end.
            interaction.end3p = $56736c0547554e17$var$getNonExcludedThirdPartyEnd(interaction, performance.now(), endTime);
            $56736c0547554e17$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $56736c0547554e17$var$addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: abortedByInteractionName
            });
            $56736c0547554e17$var$ensureMetricWindows(interaction);
            $56736c0547554e17$var$finishInteraction(interactionId, interaction, endTime);
            $56736c0547554e17$export$d8f52e8f804021e8.reset();
            $56736c0547554e17$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        if (!hasFinished) {
            $56736c0547554e17$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
            $56736c0547554e17$var$addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: performance.now(),
                triggerName: abortedByInteractionName
            });
        }
        $56736c0547554e17$var$finishInteraction(interactionId, interaction);
        $56736c0547554e17$export$d8f52e8f804021e8.reset();
        $56736c0547554e17$export$d8f52e8f804021e8.stopVCObserver();
    });
}
function $56736c0547554e17$export$7b9261a96cfe427b(id, cancelCallback) {
    const interaction = (0, $eId1k.interactions).get(id);
    interaction?.cancelCallbacks.push(cancelCallback);
}
function $56736c0547554e17$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName, trace = null, preloadKey) {
    $56736c0547554e17$export$d8f52e8f804021e8.reset();
    let vcObserver;
    let previousTime = startTime;
    let timeoutTime = (0, $5tITM.getInteractionTimeout)(ufoName);
    const timerID = setTimeout(()=>{
        $56736c0547554e17$export$5def58af4fd46132(interactionId, 'timeout');
    }, timeoutTime);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        const currentTime = performance.now();
        const timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        const newTimerID = setTimeout(()=>{
            $56736c0547554e17$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    const addFeatureFlagsToInteraction = (0, $fskN5.default)((0, $5tITM.getCapabilityRate)('feature_flag_access'));
    const config = (0, $5tITM.getConfig)();
    const searchPageConfig = {
        enableSmartAnswersMutations: config?.extraSearchPageInteraction?.enabled,
        searchPageRoute: config?.extraSearchPageInteraction?.searchPageRoute
    };
    if (config && config.vc) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $5tITM.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders,
            searchPageConfig: searchPageConfig
        };
        vcObserver = (0, $bIWIw.newVCObserver)(vcOptions);
    }
    const priorAccessedFg = type === 'press' ? {} : Object.fromEntries((0, $9S99b.allFeatureFlagsAccessed));
    const metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        preloadKey: preloadKey,
        type: type,
        previousInteractionName: $56736c0547554e17$export$dbba6cdedab4e68b.name,
        ...(0, $2aEiL.fg)('platform_ufo_emit_previous_interaction_id') ? {
            previousInteractionId: $56736c0547554e17$export$dbba6cdedab4e68b.id
        } : {},
        isPreviousInteractionAborted: $56736c0547554e17$export$dbba6cdedab4e68b.isAborted === true,
        marks: [],
        customData: [],
        cohortingCustomData: new Map(),
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdActive: new Map(),
        preloadInfo: [],
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        excluded3pSegmentData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName ?? ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: priorAccessedFg,
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace,
        vcObserver: vcObserver,
        hold3pActive: new Map(),
        hold3pInfo: [],
        minorInteractions: []
    };
    if (addFeatureFlagsToInteraction) (0, $9S99b.currentFeatureFlagsAccessed).clear();
    (0, $eId1k.interactions).set(interactionId, metrics);
    const segmentObserver = {
        onAdd (segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove () {}
    };
    $56736c0547554e17$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(()=>{
        $56736c0547554e17$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(()=>{
        clearTimeout(metrics.timerID);
    });
    // Add cleanup for per-interaction VC observer
    if (vcObserver) metrics.cleanupCallbacks.push(()=>{
        vcObserver.stop(ufoName);
    });
    const awaitBM3TTIList = (0, $5tITM.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $56736c0547554e17$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition' || type === 'page_load') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
        // Start post interaction observer for all if config is enabled
        // in case ufoName is updated at later time
        if ((0, $5tITM.getConfig)()?.postInteractionLog?.enabled) $56736c0547554e17$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
    }
    if (type === 'press') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
    }
    if ($56736c0547554e17$var$onInteractionStartForPreloadHolds) try {
        $56736c0547554e17$var$onInteractionStartForPreloadHolds(interactionId, ufoName, preloadKey);
    } catch  {
    // Preload instrumentation must not break interaction creation.
    }
}
function $56736c0547554e17$export$4a759336b50e86e3(event) {
    const interaction = $56736c0547554e17$export$2b3954d2e8509985();
    if (interaction) {
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && event.config?.type === 'PAGE_LOAD') $56736c0547554e17$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
    }
}
function $56736c0547554e17$export$ad216cc25852d44b(apdex) {
    (0, $eId1k.interactions).forEach((interaction, key)=>{
        interaction.apdex.push(apdex);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdex.key} [bm3_tti]`, {
                start: apdex.startTime ?? interaction.start,
                end: apdex.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdex.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $56736c0547554e17$export$4983dfbbb996f7ae(key, interaction.ufoName);
    });
}
function $56736c0547554e17$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdexInfo.key} [bm3_tti]`, {
                start: apdexInfo.startTime ?? interaction.start,
                end: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $56736c0547554e17$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
    }
}
function $56736c0547554e17$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push({
        labelStack: labelStack,
        ...requestInfo
    });
}
function $56736c0547554e17$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $56736c0547554e17$var$getSegmentCacheKey(labelStack) {
    return labelStack.map((l)=>{
        if ($56736c0547554e17$var$isSegmentLabel(l)) return `${l.name}_${l.segmentId}`;
        return l.name;
    }).join('|');
}
function $56736c0547554e17$export$1c43f9ac826b6462(labelStack) {
    const key = $56736c0547554e17$var$getSegmentCacheKey(labelStack);
    const existingSegment = $56736c0547554e17$var$segmentCache.get(key);
    if (!existingSegment) {
        const segmentInfo = {
            labelStack: labelStack
        };
        $56736c0547554e17$var$segmentCache.set(key, segmentInfo);
        $56736c0547554e17$var$segmentObservers.forEach((observer)=>{
            observer.onAdd(segmentInfo);
        });
    }
}
function $56736c0547554e17$export$d0365e48b58231c3(labelStack) {
    const key = $56736c0547554e17$var$getSegmentCacheKey(labelStack);
    const segmentInfo = $56736c0547554e17$var$segmentCache.get(key);
    if (segmentInfo) {
        $56736c0547554e17$var$segmentCache.delete(key);
        const cacheKey = (0, $85exp.stringifyLabelStackFully)(labelStack);
        $56736c0547554e17$export$a2b14406ded37d60.set(cacheKey, ($56736c0547554e17$export$a2b14406ded37d60.get(cacheKey) || 0) + 1);
        $56736c0547554e17$var$segmentObservers.forEach((observer)=>{
            observer.onRemove(segmentInfo);
        });
    }
}
function $56736c0547554e17$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($56736c0547554e17$var$isPerformanceTracingEnabled()) {
            const prevRedirect = interaction.redirects.at(-2);
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${nextUfoName} [redirect]`, {
                    start: prevRedirect?.time ?? interaction.start,
                    end: time,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
const $56736c0547554e17$export$6ce04c7ca6810a7e = [];
const $56736c0547554e17$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $56736c0547554e17$export$5342dcad19138a1c(name, start, end = performance.now(), size = 0, labelStack = $56736c0547554e17$var$defaultLabelStack) {
    const customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $56736c0547554e17$export$6ce04c7ca6810a7e.push(customSpan);
}

});
parcelRegister("2BKzr", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e63296833009520$export$2e2bcd8739ae039);

var $6m40H = parcelRequire("6m40H");

var $3rKW1 = parcelRequire("3rKW1");

var $iYmmM = parcelRequire("iYmmM");
function $1e63296833009520$var$v4(options, buf, offset) {
    if ((0, $6m40H.default).randomUUID && !buf && !options) return (0, $6m40H.default).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $3rKW1.default)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $iYmmM.unsafeStringify)(rnds);
}
var $1e63296833009520$export$2e2bcd8739ae039 = $1e63296833009520$var$v4;

});
parcelRegister("6m40H", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a07e87d688a2a1c$export$2e2bcd8739ae039);
const $4a07e87d688a2a1c$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $4a07e87d688a2a1c$export$2e2bcd8739ae039 = {
    randomUUID: $4a07e87d688a2a1c$var$randomUUID
};

});

parcelRegister("3rKW1", function(module, exports) {
$parcel$export(module.exports, "default", () => $28284cfaeabb85bd$export$2e2bcd8739ae039);
let $28284cfaeabb85bd$var$getRandomValues;
const $28284cfaeabb85bd$var$rnds8 = new Uint8Array(16);
function $28284cfaeabb85bd$export$2e2bcd8739ae039() {
    if (!$28284cfaeabb85bd$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $28284cfaeabb85bd$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $28284cfaeabb85bd$var$getRandomValues($28284cfaeabb85bd$var$rnds8);
}

});

parcelRegister("iYmmM", function(module, exports) {
$parcel$export(module.exports, "unsafeStringify", () => $dcff2e1d796b847e$export$8fb373d660548968);

var $3mgCf = parcelRequire("3mgCf");
const $dcff2e1d796b847e$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$dcff2e1d796b847e$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $dcff2e1d796b847e$export$8fb373d660548968(arr, offset = 0) {
    return ($dcff2e1d796b847e$var$byteToHex[arr[offset + 0]] + $dcff2e1d796b847e$var$byteToHex[arr[offset + 1]] + $dcff2e1d796b847e$var$byteToHex[arr[offset + 2]] + $dcff2e1d796b847e$var$byteToHex[arr[offset + 3]] + '-' + $dcff2e1d796b847e$var$byteToHex[arr[offset + 4]] + $dcff2e1d796b847e$var$byteToHex[arr[offset + 5]] + '-' + $dcff2e1d796b847e$var$byteToHex[arr[offset + 6]] + $dcff2e1d796b847e$var$byteToHex[arr[offset + 7]] + '-' + $dcff2e1d796b847e$var$byteToHex[arr[offset + 8]] + $dcff2e1d796b847e$var$byteToHex[arr[offset + 9]] + '-' + $dcff2e1d796b847e$var$byteToHex[arr[offset + 10]] + $dcff2e1d796b847e$var$byteToHex[arr[offset + 11]] + $dcff2e1d796b847e$var$byteToHex[arr[offset + 12]] + $dcff2e1d796b847e$var$byteToHex[arr[offset + 13]] + $dcff2e1d796b847e$var$byteToHex[arr[offset + 14]] + $dcff2e1d796b847e$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $dcff2e1d796b847e$var$stringify(arr, offset = 0) {
    const uuid = $dcff2e1d796b847e$export$8fb373d660548968(arr, offset);
    if (!(0, $3mgCf.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $dcff2e1d796b847e$export$2e2bcd8739ae039 = $dcff2e1d796b847e$var$stringify;

});
parcelRegister("3mgCf", function(module, exports) {
$parcel$export(module.exports, "default", () => $272050bb57d95829$export$2e2bcd8739ae039);

var $dAwTp = parcelRequire("dAwTp");
function $272050bb57d95829$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $dAwTp.default).test(uuid);
}
var $272050bb57d95829$export$2e2bcd8739ae039 = $272050bb57d95829$var$validate;

});
parcelRegister("dAwTp", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e4826f32f31535a$export$2e2bcd8739ae039);
var $9e4826f32f31535a$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

});




parcelRegister("fskN5", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ecdef8b2cee0fb9$export$2e2bcd8739ae039);
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $1ecdef8b2cee0fb9$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $1ecdef8b2cee0fb9$export$2e2bcd8739ae039 = $1ecdef8b2cee0fb9$var$coinflip;

});

parcelRegister("3D6wc", function(module, exports) {
$parcel$export(module.exports, "sanitizeTimingName", () => $f34a48f6d3f8904d$export$23e69abaca7d0236);
const $f34a48f6d3f8904d$export$4c07c8a3507ce307 = 255;
const $f34a48f6d3f8904d$var$GQL_OPERATION_PARAMS = [
    'operation',
    'operationName',
    'q'
];
function $f34a48f6d3f8904d$var$isGqlUrl(name) {
    try {
        const url = new URL(name);
        const searchParams = url.search ? new URLSearchParams(url.search) : null;
        return $f34a48f6d3f8904d$var$GQL_OPERATION_PARAMS.some((param)=>Boolean(searchParams?.get(param)));
    } catch  {
        return false;
    }
}
function $f34a48f6d3f8904d$export$23e69abaca7d0236(name) {
    if (name.length <= $f34a48f6d3f8904d$export$4c07c8a3507ce307) return name;
    if ($f34a48f6d3f8904d$var$isGqlUrl(name)) return name;
    return name.slice(0, $f34a48f6d3f8904d$export$4c07c8a3507ce307);
}

});

parcelRegister("5tITM", function(module, exports) {
$parcel$export(module.exports, "isFedrampOverrideActive", () => $435c1b8be196ab54$export$1133b5e2873baa7a);
$parcel$export(module.exports, "DEFAULT_TTVC_REVISION", () => $435c1b8be196ab54$export$f9bb3bb330fb9609);
$parcel$export(module.exports, "setUFOConfig", () => $435c1b8be196ab54$export$10d6139a8fb42158);
$parcel$export(module.exports, "getConfig", () => $435c1b8be196ab54$export$44487a86467333c3);
$parcel$export(module.exports, "getSelectorConfig", () => $435c1b8be196ab54$export$59e1f072477dfb48);
$parcel$export(module.exports, "isUFOEnabled", () => $435c1b8be196ab54$export$74bdb753f1cf4860);
$parcel$export(module.exports, "isVCRevisionEnabled", () => $435c1b8be196ab54$export$4babcefc81a3ef0b);
$parcel$export(module.exports, "getMostRecentVCRevision", () => $435c1b8be196ab54$export$70184d6e2c753893);
$parcel$export(module.exports, "getReactHydrationStats", () => $435c1b8be196ab54$export$2d8f8d64dc343d7b);
$parcel$export(module.exports, "getInteractionRate", () => $435c1b8be196ab54$export$9466a8f085fa7d4e);
$parcel$export(module.exports, "shouldUseRawDataThirdPartyBehavior", () => $435c1b8be196ab54$export$9c69f5a724f05f38);
$parcel$export(module.exports, "getPostInteractionRate", () => $435c1b8be196ab54$export$1d459f020c06ae34);
$parcel$export(module.exports, "getCapabilityRate", () => $435c1b8be196ab54$export$29b9ffb14861a1d);
$parcel$export(module.exports, "getAwaitBM3TTIList", () => $435c1b8be196ab54$export$2d311b3fd18dcab1);
$parcel$export(module.exports, "getUfoNameOverrides", () => $435c1b8be196ab54$export$4f4649ef27b6f5d6);
$parcel$export(module.exports, "getMinorInteractions", () => $435c1b8be196ab54$export$b150ddad71c80d77);
$parcel$export(module.exports, "getDoNotAbortActivePressInteraction", () => $435c1b8be196ab54$export$3c170167645a0eff);
$parcel$export(module.exports, "getDoNotAbortActivePressInteractionOnTransition", () => $435c1b8be196ab54$export$d6dc9444bd15f70f);
$parcel$export(module.exports, "getFinishInteractionOnTransition", () => $435c1b8be196ab54$export$20e8108b8ccdd0bd);
$parcel$export(module.exports, "getInteractionTimeout", () => $435c1b8be196ab54$export$c681731847989445);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $40Sn3 = parcelRequire("40Sn3");

var $2aEiL = parcelRequire("2aEiL");
let $435c1b8be196ab54$var$config;
/**
 * Cached result of `isFedrampModerate()` so we don't re-parse cookies on
 * every selector lookup. Reset via `__resetFedrampOverrideCacheForTests` in
 * unit tests only.
 */ let $435c1b8be196ab54$var$cachedIsFedrampModerate;
function $435c1b8be196ab54$var$detectIsFedrampModerate() {
    if ($435c1b8be196ab54$var$cachedIsFedrampModerate !== undefined) return $435c1b8be196ab54$var$cachedIsFedrampModerate;
    try {
        $435c1b8be196ab54$var$cachedIsFedrampModerate = (0, $40Sn3.isFedrampModerate)();
    } catch  {
        // Defensive default: if perimeter detection throws, treat as non-FedRAMP
        // so UFO behaviour is unchanged. Mirrors `analyticsWebClient` pattern.
        $435c1b8be196ab54$var$cachedIsFedrampModerate = false;
    }
    return $435c1b8be196ab54$var$cachedIsFedrampModerate;
}
function $435c1b8be196ab54$export$89dc2b6be8cc261() {
    $435c1b8be196ab54$var$cachedIsFedrampModerate = undefined;
}
function $435c1b8be196ab54$export$1133b5e2873baa7a() {
    try {
        return $435c1b8be196ab54$var$detectIsFedrampModerate();
    } catch  {
        return false;
    }
}
const $435c1b8be196ab54$var$FEDRAMP_DISABLED_SELECTOR_CONFIG = Object.freeze({
    id: false,
    testId: false,
    role: false,
    className: false,
    dataVC: false
});
const $435c1b8be196ab54$export$f9bb3bb330fb9609 = 'fy26.04';
function $435c1b8be196ab54$export$2182e73d31080cbc() {
    return $435c1b8be196ab54$export$f9bb3bb330fb9609;
}
const $435c1b8be196ab54$export$d50dacda7fe6392b = 1000;
function $435c1b8be196ab54$export$10d6139a8fb42158(newConfig) {
    // Handle edge cases with `enabledVCRevisions`
    const { enabledVCRevisions: enabledVCRevisions } = newConfig?.vc ?? {};
    if (enabledVCRevisions) {
        const byExperience = typeof enabledVCRevisions?.byExperience === 'object' ? enabledVCRevisions.byExperience : {};
        const allRevisions = [
            // Products control their own revisions.
            ...enabledVCRevisions?.all ?? [],
            ...Object.values(byExperience).flat()
        ];
        $435c1b8be196ab54$var$config = {
            ...newConfig,
            vc: {
                ...newConfig.vc,
                enabledVCRevisions: {
                    all: Array.from(new Set(allRevisions)),
                    byExperience: byExperience
                }
            }
        };
    } else $435c1b8be196ab54$var$config = newConfig;
}
function $435c1b8be196ab54$export$44487a86467333c3() {
    return $435c1b8be196ab54$var$config;
}
function $435c1b8be196ab54$export$59e1f072477dfb48(callerOverride, defaultConfig) {
    // 1. FedRAMP override always wins.
    if ($435c1b8be196ab54$var$detectIsFedrampModerate()) return $435c1b8be196ab54$var$FEDRAMP_DISABLED_SELECTOR_CONFIG;
    // 2. Then caller-provided.
    // 3. Then centrally configured.
    // 4. Then caller-provided default.
    return callerOverride ?? $435c1b8be196ab54$var$config?.vc?.selectorConfig ?? defaultConfig;
}
function $435c1b8be196ab54$export$74bdb753f1cf4860() {
    // Default to enabled if config is not set or enabled is not explicitly false
    return $435c1b8be196ab54$var$config?.enabled !== false;
}
const $435c1b8be196ab54$var$isValidConfigArray = (array)=>{
    return Array.isArray(array) && array.length > 0;
};
function $435c1b8be196ab54$export$87fbc8e01b137811(experienceKey = '') {
    try {
        if (!$435c1b8be196ab54$var$config) return [];
        if ($435c1b8be196ab54$var$config.vc?.enabled) {
            const { enabledVCRevisions: enabledVCRevisions } = $435c1b8be196ab54$var$config.vc ?? {};
            if ($435c1b8be196ab54$var$isValidConfigArray(enabledVCRevisions?.byExperience?.[experienceKey])) return enabledVCRevisions.byExperience?.[experienceKey];
            // When the disable flag is on, treat an explicitly-set empty array as
            // "no client-side revisions" rather than falling back to the default revision.
            const allRevisions = enabledVCRevisions?.all;
            if (Array.isArray(allRevisions) && allRevisions.length === 0 && (0, $2aEiL.fg)('ufo_disable_ttvc_v4')) return allRevisions;
            if ($435c1b8be196ab54$var$isValidConfigArray(allRevisions)) return allRevisions;
            return [
                $435c1b8be196ab54$export$2182e73d31080cbc()
            ];
        }
        return [];
    } catch  {
        return [];
    }
}
function $435c1b8be196ab54$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $435c1b8be196ab54$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $435c1b8be196ab54$export$70184d6e2c753893(experienceKey = '') {
    const enabledVCRevisions = $435c1b8be196ab54$export$87fbc8e01b137811(experienceKey);
    if (enabledVCRevisions.length === 0) return $435c1b8be196ab54$export$2182e73d31080cbc();
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $435c1b8be196ab54$export$2d8f8d64dc343d7b() {
    if (!$435c1b8be196ab54$var$config) return undefined;
    try {
        const stats = $435c1b8be196ab54$var$config?.getReactHydrationStats?.();
        return stats ?? undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getReactHydrationStats threw an error: ', e);
        return undefined;
    }
}
function $435c1b8be196ab54$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$435c1b8be196ab54$var$config) return 0;
        const { killswitch: killswitch, rates: rates, rules: rules, kind: kind, autoGeneratedRate: autoGeneratedRate } = $435c1b8be196ab54$var$config;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        const isUnknown = name === 'unknown';
        if (isUnknown) {
            if (rates?.[name] != null) return rates[name];
            // Return default rate for unknown events when no explicit rate is configured
            return $435c1b8be196ab54$export$d50dacda7fe6392b;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(let i = 0; i < rules.length; i++){
            const rule = rules[i];
            const { test: test, rate: rate } = rule;
            if (test != null && rate != null) {
                const regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        const isAutogenerated = name?.startsWith('auto-generated');
        if (isAutogenerated) {
            const rate = autoGeneratedRate;
            if (rate != null) return rate;
        }
        if (kind != null) {
            const rate = kind[interactionKind];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        // Fallback
        return 0;
    }
}
function $435c1b8be196ab54$export$48f4e0d964030a96(name, interactionType) {
    return $435c1b8be196ab54$var$getConfigRate(name, interactionType, 'enableVCRawDataRates');
}
function $435c1b8be196ab54$export$9c69f5a724f05f38(name, interactionType) {
    return $435c1b8be196ab54$export$48f4e0d964030a96(name, interactionType) > 0;
}
function $435c1b8be196ab54$export$1d459f020c06ae34(name, interactionType) {
    return $435c1b8be196ab54$var$getConfigRate(name, interactionType, 'postInteractionLog');
}
function $435c1b8be196ab54$export$29b9ffb14861a1d(capability) {
    if ((0, $2aEiL.fg)('platform_ufo_remove_deprecated_config_fields')) return 1;
    try {
        if (!$435c1b8be196ab54$var$config) return 0;
        const { capability: capabilityRate } = $435c1b8be196ab54$var$config;
        if (capabilityRate != null) {
            const rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        return 0;
    }
}
function $435c1b8be196ab54$var$getConfigRate(name, interactionType, configName) {
    try {
        if (!$435c1b8be196ab54$var$config) return 0;
        const gotConfig = $435c1b8be196ab54$var$config[configName];
        if (!gotConfig?.enabled) return 0;
        if (interactionType !== 'page_load' && interactionType !== 'transition') return 0;
        if (gotConfig.rates && typeof gotConfig.rates[name] === 'number') return gotConfig.rates[name];
        if ('kind' in gotConfig && gotConfig.kind && typeof gotConfig.kind[interactionType] === 'number') return gotConfig.kind[interactionType];
        return 0;
    } catch  {
        return 0;
    }
}
const $435c1b8be196ab54$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $435c1b8be196ab54$export$7e32aae12bf9b50f() {
    const defaultMethod = 'timeout';
    try {
        if (!$435c1b8be196ab54$var$config) return defaultMethod;
        const { typingMethod: typingMethod } = $435c1b8be196ab54$var$config;
        if (typingMethod != null && $435c1b8be196ab54$var$validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
        else return defaultMethod;
    } catch  {
        return defaultMethod;
    }
}
function $435c1b8be196ab54$export$2d311b3fd18dcab1() {
    try {
        if (!$435c1b8be196ab54$var$config) return [];
        const { awaitBM3TTI: awaitBM3TTI } = $435c1b8be196ab54$var$config;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch  {
        return [];
    }
}
function $435c1b8be196ab54$export$4f4649ef27b6f5d6() {
    try {
        if (!$435c1b8be196ab54$var$config) return undefined;
        const { ufoNameOverrides: ufoNameOverrides } = $435c1b8be196ab54$var$config;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch  {
        return undefined;
    }
}
function $435c1b8be196ab54$export$b150ddad71c80d77() {
    try {
        if (!$435c1b8be196ab54$var$config) return undefined;
        const { minorInteractions: minorInteractions } = $435c1b8be196ab54$var$config;
        return minorInteractions;
    } catch  {
        return undefined;
    }
}
function $435c1b8be196ab54$export$3c170167645a0eff() {
    try {
        if (!$435c1b8be196ab54$var$config) return undefined;
        const { doNotAbortActivePressInteraction: doNotAbortActivePressInteraction } = $435c1b8be196ab54$var$config;
        return doNotAbortActivePressInteraction;
    } catch  {
        return undefined;
    }
}
function $435c1b8be196ab54$export$d6dc9444bd15f70f() {
    try {
        if (!$435c1b8be196ab54$var$config) return undefined;
        const { doNotAbortActivePressInteractionOnTransition: doNotAbortActivePressInteractionOnTransition } = $435c1b8be196ab54$var$config;
        return doNotAbortActivePressInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
function $435c1b8be196ab54$export$20e8108b8ccdd0bd() {
    try {
        if (!$435c1b8be196ab54$var$config) return undefined;
        const { finishInteractionOnTransition: finishInteractionOnTransition } = $435c1b8be196ab54$var$config;
        return finishInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
const $435c1b8be196ab54$export$2a8604960d7d23d9 = 60000;
function $435c1b8be196ab54$export$c681731847989445(ufoName) {
    try {
        if (!$435c1b8be196ab54$var$config) return $435c1b8be196ab54$export$2a8604960d7d23d9;
        const { interactionTimeout: interactionTimeout } = $435c1b8be196ab54$var$config;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return $435c1b8be196ab54$export$2a8604960d7d23d9;
    } catch  {
        return $435c1b8be196ab54$export$2a8604960d7d23d9;
    }
}

});
parcelRegister("40Sn3", function(module, exports) {
$parcel$export(module.exports, "isFedrampModerate", () => $8cc770332363bca6$export$104cb891a6e90b3a);

var $aPJb3 = parcelRequire("aPJb3");

var $ggGWC = parcelRequire("ggGWC");
function $8cc770332363bca6$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext?.isInFedramp ?? false;
    const atlCtxCookieValues = (0, $ggGWC.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $aPJb3.FEDRAMP_MODERATE);
}

});
parcelRegister("aPJb3", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $43d66246f5dc76db$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $43d66246f5dc76db$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "STAGING", () => $43d66246f5dc76db$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $43d66246f5dc76db$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $43d66246f5dc76db$export$404582bc18fe4d9e);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $43d66246f5dc76db$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $43d66246f5dc76db$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $43d66246f5dc76db$export$a0ffa0598c95dfb7);
$parcel$export(module.exports, "BIFROST_ATL_CTX_CLOUD_SERVICE_PROVIDER", () => $43d66246f5dc76db$export$74814ca8786924c3);
$parcel$export(module.exports, "CLOUD_SERVICE_PROVIDER_GCP", () => $43d66246f5dc76db$export$b61e047ddcc35726);
const $43d66246f5dc76db$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $43d66246f5dc76db$export$f005e2e9f707cb5f = 'commercial';
const $43d66246f5dc76db$export$17b81a3d6c98013c = 'isolated-cloud';
const $43d66246f5dc76db$export$a739cd5aac835909 = 'staging';
const $43d66246f5dc76db$export$42dd0cdd351a4a9 = 'prod';
const $43d66246f5dc76db$export$404582bc18fe4d9e = 'dev';
const $43d66246f5dc76db$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $43d66246f5dc76db$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $43d66246f5dc76db$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
const $43d66246f5dc76db$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
const $43d66246f5dc76db$export$b61e047ddcc35726 = 'GCP';
const $43d66246f5dc76db$export$1baf17f3e645a2b2 = 'AWS';

});

parcelRegister("ggGWC", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", () => $4d4c1f8c6683dfc2$export$3fa7b7af96286cc9);

var $aPJb3 = parcelRequire("aPJb3");

var $4KYU8 = parcelRequire("4KYU8");
function $4d4c1f8c6683dfc2$export$3fa7b7af96286cc9() {
    const global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        const cookies = global.document.cookie;
        const perimeter = (0, $4KYU8.getRawCookieValue)((0, $aPJb3.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        const icDomain = (0, $4KYU8.getRawCookieValue)((0, $aPJb3.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        const icId = (0, $4KYU8.getRawCookieValue)((0, $aPJb3.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        const emptyIcDomain = !icDomain || icDomain.length === 0;
        const emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});
parcelRegister("4KYU8", function(module, exports) {
$parcel$export(module.exports, "getRawCookieValue", () => $ab6dc6ed062ce3a7$export$aa09aab30a92256c);
function $ab6dc6ed062ce3a7$export$aa09aab30a92256c(cookieName, cookieString) {
    if (!cookieString) return undefined;
    const cookies = cookieString.split(';');
    for (const cookie of cookies){
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) return value;
    }
    return undefined;
}

});




parcelRegister("bAEA2", function(module, exports) {
$parcel$export(module.exports, "onSearchPageInteractionComplete", () => $8d5bb452d6ceb334$export$74b9ce7e9d206a8);

var $9Aca2 = parcelRequire("9Aca2");
function $8d5bb452d6ceb334$export$74b9ce7e9d206a8(interactionId, data) {
    if (data.ufoName) {
        (0, $9Aca2.interactionBufferState).bufferInteractionData(interactionId, data);
        (0, $9Aca2.interactionBufferState).interactionBuffer.length = 0;
    }
}

});
parcelRegister("9Aca2", function(module, exports) {
$parcel$export(module.exports, "interactionBufferState", () => $0d0b468b882abf20$export$af15cc1c63c2807a);
const $0d0b468b882abf20$var$interactionBuffer = [];
const $0d0b468b882abf20$export$af15cc1c63c2807a = {
    interactionBuffer: $0d0b468b882abf20$var$interactionBuffer,
    bufferInteractionData: (interactionId, data)=>{
        $0d0b468b882abf20$var$interactionBuffer.push({
            interactionId: interactionId,
            data: data
        });
    }
};

});


parcelRegister("i7UKa", function(module, exports) {
$parcel$export(module.exports, "sanitizeUfoName", () => $54d8f0037afb6f14$export$e08487ea3ae92adb);
function $54d8f0037afb6f14$export$e08487ea3ae92adb(name) {
    return name.replace(/_/g, '-');
}

});

parcelRegister("85exp", function(module, exports) {
$parcel$export(module.exports, "stringifyLabelStackFully", () => $1fe127602942cd1e$export$caeee352b541de1f);

var $4wCCv = parcelRequire("4wCCv");

var $bodHZ = parcelRequire("bodHZ");
function $1fe127602942cd1e$export$caeee352b541de1f(labelStack) {
    return labelStack.map((l)=>{
        const name = (0, $bodHZ.sanitizeLabelStackName)(l.name);
        if ((0, $4wCCv.isSegmentLabel)(l)) return `${name}:${l.segmentId}`;
        return name;
    }).join('/');
}

});
parcelRegister("4wCCv", function(module, exports) {
$parcel$export(module.exports, "isSegmentLabel", () => $ad4e4cb147ccc671$export$1adbaf5c2363e4ae);
function $ad4e4cb147ccc671$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}

});

parcelRegister("bodHZ", function(module, exports) {
$parcel$export(module.exports, "sanitizeLabelStackName", () => $ab6565f8199956cb$export$3535cd9da4961282);
function $ab6565f8199956cb$export$3535cd9da4961282(name) {
    if (name.startsWith('/')) name = name.replace(/^\/+/, '');
    if (name.endsWith('/')) name = name.replace(/\/+$/, '');
    return name;
}

});


parcelRegister("ktZzU", function(module, exports) {
$parcel$export(module.exports, "clearActiveTrace", () => $a9b5c38524ae45bd$export$17ab21d7be720b);

var $dCCNu = parcelRequire("dCCNu");

var $2aEiL = parcelRequire("2aEiL");

var $96k96 = parcelRequire("96k96");

var $Yfgvi = parcelRequire("Yfgvi");
function $a9b5c38524ae45bd$export$17ab21d7be720b() {
    if ((0, $2aEiL.fg)('platform_ufo_enable_otel_context_manager')) // Now we need to get the global Context Manager and set the active context
    // Using type assertion because we've "extended" the ContextManager type
    {
        if ((0, $96k96.getContextManager)() instanceof (0, $96k96.UFOContextManager)) {
            let contextManager = (0, $96k96.getContextManager)();
            // ROOT_CONTEXT is an empty context used to initialise ContextManagers
            contextManager.setActive((0, $dCCNu.ROOT_CONTEXT));
        }
    } else (0, $Yfgvi.state).context = null;
}

});
parcelRegister("dCCNu", function(module, exports) {
$parcel$export(module.exports, "createContextKey", () => $9eaceb50b9d4a7b6$export$b8c322c5a7cfce78);
$parcel$export(module.exports, "ROOT_CONTEXT", () => $9eaceb50b9d4a7b6$export$78df28f9b2f9a7dc);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Get a key to uniquely identify a context value
 *
 * @since 1.0.0
 */ function $9eaceb50b9d4a7b6$export$b8c322c5a7cfce78(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
class $9eaceb50b9d4a7b6$var$BaseContext {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */ constructor(parentContext){
        // for minification
        const self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = (key)=>self._currentContext.get(key);
        self.setValue = (key, value)=>{
            const context = new $9eaceb50b9d4a7b6$var$BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = (key)=>{
            const context = new $9eaceb50b9d4a7b6$var$BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
}
const $9eaceb50b9d4a7b6$export$78df28f9b2f9a7dc = new $9eaceb50b9d4a7b6$var$BaseContext();

});

parcelRegister("96k96", function(module, exports) {
$parcel$export(module.exports, "setContextManager", () => $8f4c23928f3f735e$export$4a00ab8a5dd9b5cf);
$parcel$export(module.exports, "getContextManager", () => $8f4c23928f3f735e$export$831109c9f7727010);
$parcel$export(module.exports, "UFOContextManager", () => $8f4c23928f3f735e$export$dd301b96c16f583d);

var $dCCNu = parcelRequire("dCCNu");
/**
 * We need to store a reference to the Context manager so that we can get it later.
 * This is because the OTel JS API doesn't allow us to get the registered context manager,
 * and we need to get it because we need to call a function that's not available in the OTel API:
 * `setActive`. The OTel JS API design doesn't allow us to manually set the active context
 * despite the spec allowing for the capability. Sigh.
 *
 * I imagine this situation might not be permanent if we can move to a system were we can rely
 * solely on the API, but for the purposes of the first change being React UFO API compatible,
 * we'll need to do this.
 */ let $8f4c23928f3f735e$var$contextManager;
function $8f4c23928f3f735e$export$4a00ab8a5dd9b5cf(ctxMgr) {
    $8f4c23928f3f735e$var$contextManager = ctxMgr;
}
function $8f4c23928f3f735e$export$831109c9f7727010() {
    return $8f4c23928f3f735e$var$contextManager;
}
class $8f4c23928f3f735e$export$dd301b96c16f583d {
    /**
   * whether the context manager is enabled or not
   */ _enabled = false;
    /**
   * Keeps the reference to current context
   */ _currentContext = (0, $dCCNu.ROOT_CONTEXT);
    /**
   *
   * @param context
   * @param target Function to be executed within the context
   */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    _bindFunction(context = (0, $dCCNu.ROOT_CONTEXT), target) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const manager = this;
        const contextWrapper = function(...args) {
            return manager.with(context, ()=>target.apply(this, args));
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    }
    /**
   * Returns the active context
   */ active() {
        return this._currentContext;
    }
    /**
   * Binds a the certain context or the active one to the target function and then returns the target
   * @param context A context (span) to be bind to target
   * @param target a function or event emitter. When target or one of its callbacks is called,
   *  the provided context will be used as the active context for the duration of the call.
   */ bind(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === 'function') return this._bindFunction(context, target);
        return target;
    }
    /**
   * Disable the context manager (clears the current context)
   */ disable() {
        this._currentContext = (0, $dCCNu.ROOT_CONTEXT);
        this._enabled = false;
        return this;
    }
    /**
   * Enables the context manager and creates a default(root) context
   */ enable() {
        if (this._enabled) return this;
        this._enabled = true;
        this._currentContext = (0, $dCCNu.ROOT_CONTEXT);
        return this;
    }
    /**
   * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
   * The context will be set as active
   * @param context
   * @param fn Callback function
   * @param thisArg optional receiver to be used for calling fn
   * @param args optional arguments forwarded to fn
   */ with(context, fn, thisArg, ...args) {
        const previousContext = this._currentContext;
        this._currentContext = context || (0, $dCCNu.ROOT_CONTEXT);
        try {
            return fn.call(thisArg, ...args);
        } finally{
            this._currentContext = previousContext;
        }
    }
    /**
   * Sets the active context.
   * This function is an extension of the OTel spec, in order to facilitate the current API of React UFO trace context handling.
   * It doesn't keep track of any previously set active contexts, because it's assumed (for now) that only one trace context
   * will ever exist at a time.
   * The next step in the work to improve tracing in the FE will likely remove this function as we need to track the
   * hierarchy of contexts (likely using the `with()` function above).
   * @param context The context to be made the globally active one
   */ setActive(context) {
        if (this._enabled) this._currentContext = context;
    }
}

});

parcelRegister("Yfgvi", function(module, exports) {
$parcel$export(module.exports, "state", () => $7c46898f711b6064$export$ca000e230c0caa3e);
const $7c46898f711b6064$export$ca000e230c0caa3e = {
    context: null
};

});


parcelRegister("9S99b", function(module, exports) {
$parcel$export(module.exports, "allFeatureFlagsAccessed", () => $9a0c0ac80b8f0e6c$export$5b78c989c8db2561);
$parcel$export(module.exports, "currentFeatureFlagsAccessed", () => $9a0c0ac80b8f0e6c$export$2a5c8df26bb89760);
$parcel$export(module.exports, "addFeatureFlagAccessed", () => $9a0c0ac80b8f0e6c$export$47fade9662f71000);

var $hwKeE = parcelRequire("hwKeE");
const $9a0c0ac80b8f0e6c$export$5b78c989c8db2561 = new Map();
const $9a0c0ac80b8f0e6c$export$2a5c8df26bb89760 = new Map();
function $9a0c0ac80b8f0e6c$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    const value = (0, $hwKeE.redactValue)(featureFlagValue);
    $9a0c0ac80b8f0e6c$export$5b78c989c8db2561.set(featureFlagName, value);
    $9a0c0ac80b8f0e6c$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("hwKeE", function(module, exports) {
$parcel$export(module.exports, "redactValue", () => $df36f0cf105ad5f3$export$fcc03ee4c944962f);

var $eP67m = parcelRequire("eP67m");

var $loNMU = parcelRequire("loNMU");
function $df36f0cf105ad5f3$export$fcc03ee4c944962f(featureFlagValue) {
    return (0, $loNMU.shouldRedactValue)(featureFlagValue) ? (0, $eP67m.NON_BOOLEAN_VALUE) : featureFlagValue;
}

});
parcelRegister("eP67m", function(module, exports) {
$parcel$export(module.exports, "NON_BOOLEAN_VALUE", () => $7eb96e12a818aa98$export$42f4885608027d0c);
const $7eb96e12a818aa98$export$42f4885608027d0c = 'non_boolean';

});

parcelRegister("loNMU", function(module, exports) {
$parcel$export(module.exports, "shouldRedactValue", () => $43cc8b82b2789e47$export$7b4abba432e57989);
function $43cc8b82b2789e47$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch  {
        return false;
    }
    return false;
}
function $43cc8b82b2789e47$var$isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
}
function $43cc8b82b2789e47$var$isString(input) {
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch  {
        // swallow any errors
        result = false;
    }
    return result;
}
function $43cc8b82b2789e47$export$7b4abba432e57989(value) {
    return $43cc8b82b2789e47$var$isString(value) && $43cc8b82b2789e47$var$startsAsObject(value) || $43cc8b82b2789e47$var$isObject(value);
}

});



parcelRegister("i8z2S", function(module, exports) {
$parcel$export(module.exports, "getInteractionId", () => $936a25d37b0fbae4$export$37bca3107733ac1e);

var $eIO99 = parcelRequire("eIO99");
const $936a25d37b0fbae4$export$37bca3107733ac1e = ()=>(0, $eIO99.default);

});
parcelRegister("eIO99", function(module, exports) {
$parcel$export(module.exports, "default", () => $2306154997a51e18$export$2e2bcd8739ae039);

var $insso = parcelRequire("insso");
class $2306154997a51e18$var$ObservableInteractionID {
    _current = null;
    get current() {
        return this._current;
    }
    set current(newId) {
        const oldId = this._current;
        this._current = newId;
        if (oldId !== newId) (0, $insso.listeners).forEach((listener)=>listener(newId));
    }
}
const $2306154997a51e18$var$initializeGlobalDefaultInteractionID = ()=>{
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    const instance = new $2306154997a51e18$var$ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
const $2306154997a51e18$var$DefaultInteractionID = $2306154997a51e18$var$initializeGlobalDefaultInteractionID();
var $2306154997a51e18$export$2e2bcd8739ae039 = $2306154997a51e18$var$DefaultInteractionID;

});
parcelRegister("insso", function(module, exports) {
$parcel$export(module.exports, "listeners", () => $d3478711c085f9e7$export$58bed631278dbc67);
$parcel$export(module.exports, "subscribeToInteractionIdChanges", () => $d3478711c085f9e7$export$3e0c3023952f6774);
// Subscription system for interaction ID changes
const $d3478711c085f9e7$export$58bed631278dbc67 = new Set();
const $d3478711c085f9e7$export$3e0c3023952f6774 = (listener)=>{
    $d3478711c085f9e7$export$58bed631278dbc67.add(listener);
    return ()=>{
        $d3478711c085f9e7$export$58bed631278dbc67.delete(listener);
    };
};

});



parcelRegister("kPSgw", function(module, exports) {
$parcel$export(module.exports, "BACKEND_RESOURCE_TIMING_INITIATOR_TYPES", () => $2318f69729a1087a$export$c3b002e13fbb9ef2);
const $2318f69729a1087a$export$c3b002e13fbb9ef2 = new Set([
    'fetch',
    'xmlhttprequest'
]);

});

parcelRegister("58teO", function(module, exports) {
$parcel$export(module.exports, "flushSsrRenderProfilerTraces", () => $acfff6ee4653d699$export$c8760e11c713fafc);

var $gJODL = parcelRequire("gJODL");
const $acfff6ee4653d699$export$c8760e11c713fafc = ()=>{
    (0, $gJODL.default).spanStates.forEach((spanState)=>{
        if (spanState.latestEndTime != null) spanState.span.end(spanState.latestEndTime);
    });
    (0, $gJODL.default).spanStates.clear();
};

});
parcelRegister("gJODL", function(module, exports) {
$parcel$export(module.exports, "default", () => $64693bd39d652585$export$2e2bcd8739ae039);
// Shared across profiler renders and the public reset/flush entry points. Keep this
// outside React context so Suspense restarts cannot discard the initial render.
const $64693bd39d652585$var$state = {
    startTimes: new Map(),
    spanStates: new Map(),
    lastActiveInteraction: undefined
};
var $64693bd39d652585$export$2e2bcd8739ae039 = $64693bd39d652585$var$state;

});


parcelRegister("bIWIw", function(module, exports) {
$parcel$export(module.exports, "newVCObserver", () => $9bf5c6237dbfb62c$export$c69731bddfc24d85);

var $ccGnr = parcelRequire("ccGnr");

var $8auTb = parcelRequire("8auTb");

var $kp3Hh = parcelRequire("kp3Hh");
function $9bf5c6237dbfb62c$export$c69731bddfc24d85(opts = {}) {
    const shouldMockVCObserver = !(0, $ccGnr.isEnvironmentSupported)();
    const observer = shouldMockVCObserver ? new (0, $8auTb.VCObserverNOOP)() : new (0, $kp3Hh.VCObserverWrapper)(opts);
    return observer;
}

});
parcelRegister("ccGnr", function(module, exports) {
$parcel$export(module.exports, "isEnvironmentSupported", () => $bb5ee53ac736c11e$export$68d57b133e88584d);
// Some products set this variable to indicate it is running in SSR

var $k1Wvt = parcelRequire("k1Wvt");
let $bb5ee53ac736c11e$var$isServer = Boolean(globalThis?.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
let $bb5ee53ac736c11e$var$isReactSSR = typeof $k1Wvt !== 'undefined' && Boolean($k1Wvt?.env?.REACT_SSR || false);
function $bb5ee53ac736c11e$export$68d57b133e88584d() {
    // SSR environment aren't supported
    if ($bb5ee53ac736c11e$var$isReactSSR || $bb5ee53ac736c11e$var$isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof globalThis?.WeakRef !== 'function') return false;
    if (typeof globalThis?.MutationObserver !== 'function' || typeof globalThis?.IntersectionObserver !== 'function' || typeof globalThis?.PerformanceObserver !== 'function') return false;
    return true;
}

});

parcelRegister("8auTb", function(module, exports) {
$parcel$export(module.exports, "VCObserverNOOP", () => $1fe11c102b379866$export$24d07287b49da906);
class $1fe11c102b379866$export$24d07287b49da906 {
    start(_) {}
    stop() {}
    getVCRawData() {
        return null;
    }
    getVCResult(_) {
        return Promise.resolve({
            'ufo:vc:noop': true
        });
    }
    setSSRElement(_) {}
    setReactRootRenderStart(_) {}
    setReactRootRenderStop(_) {}
}

});

parcelRegister("kp3Hh", function(module, exports) {
$parcel$export(module.exports, "VCObserverWrapper", () => $6a018966190f1f65$export$4a1fe1ab3c13bbf5);

var $5tITM = parcelRequire("5tITM");

var $gY5Ep = parcelRequire("gY5Ep");

var $7BMVq = parcelRequire("7BMVq");

var $2x5fo = parcelRequire("2x5fo");

var $eJ691 = parcelRequire("eJ691");
class $6a018966190f1f65$export$4a1fe1ab3c13bbf5 {
    oldVCObserver;
    newVCObserver;
    ssrPlaceholderHandler;
    constructor(opts = {}){
        this.newVCObserver = null;
        this.oldVCObserver = null;
        // Initialize SSR placeholder handler once
        this.ssrPlaceholderHandler = new (0, $eJ691.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
        });
        this.newVCObserver = new (0, $7BMVq.default)({
            selectorConfig: opts.selectorConfig,
            isPostInteraction: opts.isPostInteraction,
            SSRConfig: {
                enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
            },
            ssrPlaceholderHandler: this.ssrPlaceholderHandler,
            trackLayoutShiftOffenders: opts.trackLayoutShiftOffenders ?? false,
            searchPageConfig: opts.searchPageConfig
        });
        if ((0, $5tITM.isVCRevisionEnabled)('fy25.01') || (0, $5tITM.isVCRevisionEnabled)('fy25.02')) this.oldVCObserver = new (0, $gY5Ep.VCObserver)({
            ...opts,
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        });
    }
    // Helper method to process SSR abort listeners
    processSsrAbortListeners() {
        // Process any SSR abort listeners that remain
        if (window?.__SSR_ABORT_LISTENERS__) {
            // Clean up any event listeners that may have been registered during SSR
            // This is centralized here so only the wrapper handles unbinding, not individual observers
            if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach((unbind)=>{
                if (typeof unbind === 'function') unbind();
            });
            // After all observers had a chance to process abort events,
            // we can safely delete the SSR_ABORT_LISTENERS object
            delete window.__SSR_ABORT_LISTENERS__;
        }
    }
    start({ startTime: startTime, experienceKey: experienceKey }) {
        if ((0, $5tITM.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $5tITM.isVCRevisionEnabled)('fy25.02', experienceKey)) this.oldVCObserver?.start({
            startTime: startTime
        });
        this.newVCObserver?.start({
            startTime: startTime
        });
        // Clean up any remaining SSR abort listeners after all observers have been started
        this.processSsrAbortListeners();
    }
    stop(experienceKey) {
        if ((0, $5tITM.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $5tITM.isVCRevisionEnabled)('fy25.02', experienceKey)) this.oldVCObserver?.stop();
        this.newVCObserver?.stop();
        (0, $2x5fo.RLLPlaceholderHandlers).getInstance().reset();
        // Clear shared SSR placeholder handler
        this.ssrPlaceholderHandler.clear();
    }
    getVCRawData() {
        return this.oldVCObserver?.getVCRawData() ?? null;
    }
    async getVCResult(param) {
        const { experienceKey: experienceKey, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, includeRawData: includeRawData } = param;
        const v1v2Result = (0, $5tITM.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $5tITM.isVCRevisionEnabled)('fy25.02', experienceKey) ? await this.oldVCObserver?.getVCResult(param) : {};
        const v3v4Result = await this.newVCObserver?.getVCResult({
            start: param.start,
            stop: param.stop,
            interactionId: param.interactionId,
            ssr: param.ssr,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            interactionType: param.interactionType,
            isPageVisible: param.isPageVisible,
            interactionAbortReason: param.interactionAbortReason,
            includeRawData: includeRawData,
            includeSSRInV3: param.includeSSRInV3,
            rawDataStopTime: param.rawDataStopTime,
            reportLayoutShiftOffenders: param.reportLayoutShiftOffenders
        });
        if (!v3v4Result || v3v4Result.length === 0) return v1v2Result ?? {};
        const ssrRatio = v3v4Result?.[0]?.ssrRatio;
        return {
            ...includeSSRRatio && ssrRatio !== undefined ? {
                'ufo:vc:ssrRatio': ssrRatio
            } : {},
            ...v1v2Result,
            'ufo:vc:rev': [
                ...v1v2Result?.['ufo:vc:rev'] ?? [],
                ...v3v4Result ?? []
            ]
        };
    }
    setSSRElement(element) {
        this.oldVCObserver?.setSSRElement(element);
        this.newVCObserver?.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime) {
        this.oldVCObserver?.setReactRootRenderStart(startTime || performance.now());
        this.newVCObserver?.setReactRootRenderStart(startTime || performance.now());
    }
    setReactRootRenderStop(stopTime) {
        this.oldVCObserver?.setReactRootRenderStop(stopTime || performance.now());
        this.newVCObserver?.setReactRootRenderStop(stopTime || performance.now());
    }
    collectSSRPlaceholders() {
        this.ssrPlaceholderHandler.collectExistingPlaceholders();
    }
}

});
parcelRegister("gY5Ep", function(module, exports) {
$parcel$export(module.exports, "VCObserver", () => $06d9d1ee13c23a47$export$1f70d263701b1d01);

var $2aEiL = parcelRequire("2aEiL");

var $5tITM = parcelRequire("5tITM");

var $8OjRF = parcelRequire("8OjRF");

var $fOozI = parcelRequire("fOozI");

var $dQn6k = parcelRequire("dQn6k");

var $57H8M = parcelRequire("57H8M");

var $6Pn3f = parcelRequire("6Pn3f");

var $9nILy = parcelRequire("9nILy");

var $eCDPR = parcelRequire("eCDPR");
const $06d9d1ee13c23a47$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
const $06d9d1ee13c23a47$var$UNUSED_SECTOR = 0;
function $06d9d1ee13c23a47$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(([timestamp, entries])=>[
            Number(timestamp),
            entries.map((entry)=>{
                const { __debug__element: __debug__element, ...rest } = entry;
                return rest;
            })
        ]));
}
class $06d9d1ee13c23a47$export$1f70d263701b1d01 {
    /* abort logic */ abortReason = {
        reason: null,
        info: '',
        timestamp: -1,
        blocking: false
    };
    outOfBoundaryInfo = '';
    /** config * */ static VCParts = [
        '25',
        '50',
        '75',
        '80',
        '85',
        '90',
        '95',
        '98',
        '99'
    ];
    viewport = {
        w: 0,
        h: 0
    };
    /* heatmap */ arraySize = 0;
    heatmap;
    heatmapNext;
    componentsLog = {};
    vcRatios = {};
    active = false;
    totalTime = 0;
    startTime = 0;
    observers;
    _startMeasureTimestamp = -1;
    ssr = {
        reactRendered: -1
    };
    devToolsEnabled;
    oldDomUpdatesEnabled;
    unbind = [];
    isPostInteraction;
    constructor(options){
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        const { ssrEnablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder, ssrPlaceholderHandler: ssrPlaceholderHandler } = options;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It enforces FedRAMP-override > caller-override >
        // centrally configured > caller default. When `getSelectorConfig()`
        // returns `undefined` we fall back to the legacy hard-coded default
        // to preserve pre-existing behaviour for callers that don't pass an
        // explicit `selectorConfig`.
        const LEGACY_DEFAULT_SELECTOR_CONFIG = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.observers = new (0, $eCDPR.Observers)({
            selectorConfig: (0, $5tITM.getSelectorConfig)(options.selectorConfig, LEGACY_DEFAULT_SELECTOR_CONFIG) || options.selectorConfig || LEGACY_DEFAULT_SELECTOR_CONFIG,
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false
            },
            ssrPlaceholderHandler: ssrPlaceholderHandler
        });
        this.heatmap = !(0, $5tITM.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
    start({ startTime: startTime }) {
        this.active = true;
        if (this.observers.isBrowserSupported()) {
            this.setViewportSize();
            this.resetState();
            this.startTime = startTime;
            this.attachAbortListeners();
            this.observers.subscribeResults(this.handleUpdate);
            this.observers.observe();
        } else this.setAbortReason('not-supported', startTime);
    }
    stop() {
        this.observers.disconnect();
        this.detachAbortListeners();
    }
    getAbortReasonInfo = ()=>{
        if (this.abortReason.reason === null) return null;
        const info = this.abortReason.info !== '' ? ` ${this.abortReason.info}` : '';
        return `${this.abortReason.reason}${info}`;
    };
    getVCRawData = ()=>{
        this.measureStart();
        if (!this.active) {
            this.measureStop();
            return null;
        }
        this.stop();
        const abortReasonInfo = this.getAbortReasonInfo();
        this.measureStop();
        return {
            abortReasonInfo: abortReasonInfo,
            abortReason: {
                ...this.abortReason
            },
            heatmap: this.heatmap,
            heatmapNext: this.heatmapNext,
            outOfBoundaryInfo: this.outOfBoundaryInfo,
            totalTime: Math.round(this.totalTime + this.observers.getTotalTime()),
            componentsLog: {
                ...this.componentsLog
            },
            viewport: {
                ...this.viewport
            },
            oldDomUpdatesEnabled: this.oldDomUpdatesEnabled,
            devToolsEnabled: this.devToolsEnabled,
            ratios: this.vcRatios
        };
    };
    getIgnoredElements(componentsLog) {
        return Object.values(componentsLog).flat().filter(({ ignoreReason: ignoreReason })=>Boolean(ignoreReason)).map(({ targetName: targetName, ignoreReason: ignoreReason })=>({
                targetName: targetName,
                ignoreReason: ignoreReason
            }));
    }
    static getSSRRatio(entries, ssr) {
        if (ssr === undefined || entries.length === 0) return undefined;
        const maybeSSR = entries[0];
        if (maybeSSR.elements[0] === 'SSR') return maybeSSR.vc;
        return 0;
    }
    getVCResult = async ({ start: start, stop: stop, tti: tti, prefix: prefix, ssr: ssr, vc: vc, isEventAborted: isEventAborted, experienceKey: experienceKey, interactionId: interactionId, includeSSRRatio: includeSSRRatio })=>{
        const startTime = performance.now();
        // add local measurement
        const fullPrefix = prefix !== undefined && prefix !== '' ? `${prefix}:` : '';
        const rawData = vc !== undefined ? vc : this.getVCRawData();
        if (rawData === null) return {};
        const { abortReason: abortReason, abortReasonInfo: abortReasonInfo, heatmap: heatmap, heatmapNext: heatmapNext, outOfBoundaryInfo: outOfBoundaryInfo, totalTime: totalTime, componentsLog: componentsLog, viewport: viewport, devToolsEnabled: devToolsEnabled, ratios: ratios } = rawData;
        const isTTVCv1Disabled = !(0, $5tITM.isVCRevisionEnabled)('fy25.01', experienceKey);
        if (abortReasonInfo !== null) {
            // exposing data to devtools
            try {
                if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
            } catch  {}
            const vcAbortedResultWithRevisions = {
                [`${fullPrefix}vc:rev`]: [
                    {
                        revision: 'fy25.02',
                        clean: false,
                        'metric:vc90': null,
                        abortReason: abortReason.reason,
                        abortTimestamp: Math.round(abortReason.timestamp)
                    }
                ]
            };
            if (!isTTVCv1Disabled) vcAbortedResultWithRevisions[`${fullPrefix}vc:rev`].push({
                revision: 'fy25.01',
                clean: false,
                'metric:vc90': null,
                abortReason: abortReason.reason,
                abortTimestamp: Math.round(abortReason.timestamp)
            });
            return vcAbortedResultWithRevisions;
        }
        const ttvcV1Result = isTTVCv1Disabled ? {
            VC: {},
            VCBox: {},
            VCEntries: {
                abs: [],
                rel: [],
                speedIndex: -1
            },
            totalPainted: -1
        } : $06d9d1ee13c23a47$export$1f70d263701b1d01.calculateVC({
            heatmap: heatmap,
            ssr: ssr,
            componentsLog: {
                ...componentsLog
            },
            viewport: viewport,
            fixSSRAttribution: includeSSRRatio
        });
        const { VC: VC, VCBox: VCBox, VCEntries: VCEntries, totalPainted: totalPainted } = ttvcV1Result;
        const _componentsLog = {};
        Object.entries(this.componentsLog).forEach(([_timestamp, value])=>{
            const timestamp = Number(_timestamp);
            if (stop > timestamp) _componentsLog[timestamp] = value;
        });
        const vcNext = $06d9d1ee13c23a47$export$1f70d263701b1d01.calculateVC({
            heatmap: heatmapNext,
            ssr: ssr,
            componentsLog: _componentsLog,
            viewport: viewport,
            fixSSRAttribution: includeSSRRatio
        });
        const outOfBoundary = outOfBoundaryInfo ? {
            [`${fullPrefix}vc:oob`]: outOfBoundaryInfo
        } : {};
        //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
        const stopTime = performance.now();
        // exposing data to devtools
        try {
            if (!this.isPostInteraction && devToolsEnabled) {
                const ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                    entries: VCEntries.rel,
                    log: componentsLog,
                    metrics: {
                        '75': VC['75'],
                        '80': VC['80'],
                        '85': VC['85'],
                        '90': VC['90'],
                        '95': VC['95'],
                        '98': VC['98'],
                        '99': VC['99'],
                        tti: tti,
                        ttai: stop - start
                    },
                    start: start,
                    stop: stop,
                    heatmap: heatmap,
                    ratios: ratios
                };
                const ttvcV2DevToolInfo = {
                    entries: vcNext.VCEntries.rel,
                    log: componentsLog,
                    metrics: {
                        '75': vcNext.VC['75'],
                        '80': vcNext.VC['80'],
                        '85': vcNext.VC['85'],
                        '90': vcNext.VC['90'],
                        '95': vcNext.VC['95'],
                        '98': vcNext.VC['98'],
                        '99': vcNext.VC['99'],
                        tti: tti,
                        ttai: stop - start
                    },
                    start: start,
                    stop: stop,
                    heatmap: heatmapNext,
                    ratios: ratios
                };
                if (isTTVCv1Disabled) {
                    window.__vc = ttvcV2DevToolInfo;
                    window.__vcNext = ttvcV2DevToolInfo;
                } else {
                    window.__vc = ttvcV1DevToolInfo;
                    window.__vcNext = ttvcV2DevToolInfo;
                }
                // Emitting a custom event to make it available in the Chrome extension
                window.dispatchEvent(new CustomEvent('vcReady', {
                    detail: {
                        log: $06d9d1ee13c23a47$var$filterComponentsLog(componentsLog),
                        entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                    }
                }));
            }
            if (!this.isPostInteraction) {
                // Only create revision debug details if callbacks exist
                const shouldCreateDebugDetails = typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window.__on_ufo_vc_debug_data_ready === 'function';
                if (shouldCreateDebugDetails) {
                    const v1RevisionDebugDetails = (0, $dQn6k.getVCRevisionDebugDetails)({
                        revision: 'fy25.01',
                        isClean: !abortReasonInfo,
                        abortReason: abortReason.reason,
                        VCEntries: VCEntries.rel,
                        componentsLog: componentsLog,
                        interactionId: interactionId
                    });
                    const v2RevisionDebugDetails = (0, $dQn6k.getVCRevisionDebugDetails)({
                        revision: 'fy25.02',
                        isClean: !abortReasonInfo,
                        abortReason: abortReason.reason,
                        VCEntries: vcNext.VCEntries.rel,
                        componentsLog: componentsLog,
                        interactionId: interactionId
                    });
                    // Add devtool callback for both v1 and v2
                    if (typeof window.__ufo_devtool_onVCRevisionReady__ === 'function') {
                        // Handle v1 if not disabled
                        if (!isTTVCv1Disabled) window.__ufo_devtool_onVCRevisionReady__?.(v1RevisionDebugDetails);
                        // Handle v2
                        window.__ufo_devtool_onVCRevisionReady__?.(v2RevisionDebugDetails);
                    }
                    if (typeof window.__on_ufo_vc_debug_data_ready === 'function') {
                        if (!isTTVCv1Disabled) window.__on_ufo_vc_debug_data_ready?.(v1RevisionDebugDetails);
                        window.__on_ufo_vc_debug_data_ready?.(v2RevisionDebugDetails);
                    }
                }
            }
        } catch  {
        /*  do nothing */ }
        const isVCClean = !abortReasonInfo;
        const revisionsData = (0, $57H8M.getVCRevisionsData)({
            fullPrefix: fullPrefix,
            interaction: {
                start: start,
                end: stop
            },
            isVCClean: isVCClean,
            calculatedVC: {
                VC: VC,
                VCBox: VCBox
            },
            calculatedVCNext: {
                VC: vcNext.VC,
                VCBox: vcNext.VCBox
            },
            isEventAborted: isEventAborted,
            experienceKey: experienceKey,
            ratios: ratios
        });
        const speedIndex = {
            [`ufo:speedIndex`]: isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex,
            [`ufo:next:speedIndex`]: vcNext.VCEntries.speedIndex
        };
        const SSRRatio = $06d9d1ee13c23a47$export$1f70d263701b1d01.getSSRRatio(VCEntries.rel, ssr);
        const SSRRatioNext = $06d9d1ee13c23a47$export$1f70d263701b1d01.getSSRRatio(vcNext.VCEntries.rel, ssr);
        const SSRRatioPayload = includeSSRRatio ? {
            [`${fullPrefix}vc:ssrRatio`]: isTTVCv1Disabled ? SSRRatioNext : SSRRatio,
            [`${fullPrefix}vc:next:ssrRatio`]: SSRRatioNext
        } : {};
        if (isTTVCv1Disabled) return {
            [`${fullPrefix}vc:size`]: viewport,
            [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
            [`${fullPrefix}vc:ratios`]: ratios,
            ...outOfBoundary,
            [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
            ...SSRRatioPayload,
            [`${fullPrefix}vc:ssrRatio`]: SSRRatioNext,
            ...revisionsData,
            ...speedIndex
        };
        const isTTVCv3Enabled = (0, $5tITM.isVCRevisionEnabled)('fy25.03', experienceKey);
        return {
            'metrics:vc': VC,
            [`${fullPrefix}vc:state`]: true,
            [`${fullPrefix}vc:clean`]: isVCClean,
            [`${fullPrefix}vc:dom`]: VCBox,
            [`${fullPrefix}vc:updates`]: isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50),
            // max 50
            [`${fullPrefix}vc:size`]: viewport,
            [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
            [`${fullPrefix}vc:total`]: totalPainted,
            [`${fullPrefix}vc:ratios`]: ratios,
            [`${fullPrefix}vc:ssrRatio`]: SSRRatio,
            ...outOfBoundary,
            [`${fullPrefix}vc:next`]: vcNext.VC,
            [`${fullPrefix}vc:next:updates`]: isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50),
            // max 50
            [`${fullPrefix}vc:next:dom`]: vcNext.VCBox,
            ...SSRRatioPayload,
            [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
            ...revisionsData,
            ...speedIndex
        };
    };
    static calculateVC({ heatmap: heatmap, ssr: ssr = $06d9d1ee13c23a47$var$UNUSED_SECTOR, componentsLog: componentsLog, viewport: viewport, fixSSRAttribution: fixSSRAttribution }) {
        const lastUpdate = {};
        let totalPainted = 0;
        const ssrTime = fixSSRAttribution ? Math.floor(ssr) : ssr;
        if (ssrTime !== $06d9d1ee13c23a47$var$UNUSED_SECTOR) {
            const element = {
                __debug__element: new WeakRef(window.document?.body),
                intersectionRect: {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    x: 0,
                    y: 0,
                    width: viewport.w,
                    height: viewport.h,
                    toJSON () {
                        return {};
                    }
                },
                targetName: 'SSR'
            };
            if (!componentsLog[ssrTime]) componentsLog[ssrTime] = [];
            componentsLog[ssrTime].push(element);
        }
        heatmap.forEach((line)=>{
            line.forEach((entry)=>{
                const rounded = Math.floor(entry === $06d9d1ee13c23a47$var$UNUSED_SECTOR && ssrTime !== $06d9d1ee13c23a47$var$UNUSED_SECTOR ? ssrTime : entry);
                totalPainted += rounded !== $06d9d1ee13c23a47$var$UNUSED_SECTOR ? 1 : 0;
                if (rounded !== $06d9d1ee13c23a47$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            });
        });
        const entries = Object.entries(lastUpdate).map((a)=>[
                parseInt(a[0], 10),
                a[1]
            ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
        const VC = $06d9d1ee13c23a47$export$1f70d263701b1d01.makeVCReturnObj();
        const VCBox = $06d9d1ee13c23a47$export$1f70d263701b1d01.makeVCReturnObj();
        entries.reduce((acc = 0, v)=>{
            const currRatio = v[1] / totalPainted;
            let VCRatio = currRatio + acc;
            const preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
            const preciseAccRatio = Math.round(acc * 100);
            VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
            const time = v[0];
            $06d9d1ee13c23a47$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                const value = parseInt(key, 10);
                if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                    VC[key] = time;
                    VCBox[key] = [
                        ...new Set(componentsLog[time]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
                    ];
                }
            });
            return VCRatio;
        }, 0);
        const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
            const currentlyPainted = entryPainted + (acc.abs[i - 1]?.[1] || 0);
            const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
            const logEntry = [
                ...new Set(componentsLog[timestamp]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
            ];
            const ratioDelta = (currentlyPaintedRatio - (acc.rel[i - 1]?.vc ?? 0)) / 100;
            const speedIndex = timestamp * ratioDelta;
            acc.speedIndex += speedIndex;
            acc.abs.push([
                timestamp,
                currentlyPainted
            ]);
            acc.rel.push({
                time: timestamp,
                vc: currentlyPaintedRatio,
                elements: logEntry
            });
            return acc;
        }, {
            abs: [],
            rel: [],
            speedIndex: 0
        });
        VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
        return {
            VC: VC,
            VCBox: VCBox,
            VCEntries: VCEntries,
            totalPainted: totalPainted
        };
    }
    setSSRElement(element) {
        this.observers.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.observers.setReactRootRenderStart(startTime);
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.observers.setReactRootRenderStop(stopTime);
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    handleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue)=>{
        if (this.abortReason.reason === null || this.abortReason.blocking === false) {
            const time = Math.round(rawTime - this.startTime);
            const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
            this.vcRatios[targetName] = this.getElementRatio(mappedValues);
            if (!ignoreReason) this.applyChangesToHeatMap(mappedValues, time, this.heatmapNext);
            const interaction = (0, $8OjRF.getActiveInteraction)();
            const isTTVCv1Disabled = !(0, $5tITM.isVCRevisionEnabled)('fy25.01', interaction?.ufoName);
            if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') this.applyChangesToHeatMap(mappedValues, time, this.heatmap);
            if (!this.componentsLog[time]) this.componentsLog[time] = [];
            this.componentsLog[time].push({
                __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                type: type,
                intersectionRect: intersectionRect,
                targetName: targetName,
                ignoreReason: ignoreReason,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        }
    };
    setAbortReason(abort, timestamp, info = '') {
        if (this.abortReason.reason === null || this.abortReason.blocking === false) {
            this.abortReason.reason = abort;
            this.abortReason.info = info;
            this.abortReason.timestamp = timestamp;
            this.abortReason.blocking = abort !== $06d9d1ee13c23a47$var$abortReason.scroll;
            if (this.abortReason.blocking) this.detachAbortListeners();
        }
    }
    resetState() {
        this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.detachAbortListeners();
        this.heatmap = !(0, $5tITM.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.totalTime = 0;
        this.componentsLog = {};
        this.vcRatios = {};
    }
    getCleanHeatmap() {
        return Array(this.arraySize).fill('').map(()=>Array(this.arraySize).fill($06d9d1ee13c23a47$var$UNUSED_SECTOR));
    }
    setViewportSize() {
        this.viewport.w = (0, $9nILy.getViewportWidth)();
        this.viewport.h = (0, $6Pn3f.getViewportHeight)();
    }
    mapPixelsToHeatmap = (left, top, width, height)=>{
        const { w: w, h: h } = this.viewport;
        const l = Math.floor(left / w * this.arraySize);
        const t = Math.floor(top / h * this.arraySize);
        const r = Math.ceil((left + width) / w * this.arraySize);
        const b = Math.ceil((top + height) / h * this.arraySize);
        // that info is temporary to get info why it goes over boundary
        if (this.outOfBoundaryInfo === '') {
            let outOfBoundaryInfo = '';
            if (r > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${left} ${width}`;
            if (b > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${top} ${height}`;
            this.outOfBoundaryInfo = outOfBoundaryInfo;
        }
        // correct values to min - 0, max - arraySize
        const result = {
            l: Math.max(0, l),
            t: Math.max(0, t),
            r: Math.min(this.arraySize, r),
            b: Math.min(this.arraySize, b)
        };
        return result;
    };
    getElementRatio = (mappedValues)=>{
        const { r: r, l: l, b: b, t: t } = mappedValues;
        return (r - l) * (b - t) / (this.arraySize * this.arraySize);
    };
    applyChangesToHeatMap(a, time, heatmap) {
        const { l: l, t: t, r: r, b: b } = a;
        const localHeatmap = heatmap;
        for(let row = t; row < b; row++){
            for(let col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                try {
                    this.setAbortReason($06d9d1ee13c23a47$var$abortReason.error, time, `index - ${row}`);
                } catch  {
                    this.setAbortReason($06d9d1ee13c23a47$var$abortReason.error, time, 'row error');
                }
                return;
            } else localHeatmap[row][col] = time;
        }
    }
    static makeVCReturnObj() {
        const vc = {};
        $06d9d1ee13c23a47$export$1f70d263701b1d01.VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
    abortReasonCallback = (key, time)=>{
        switch(key){
            case 'wheel':
                this.setAbortReason($06d9d1ee13c23a47$var$abortReason.scroll, time);
                break;
            case 'keydown':
                // Don't abort press interactions on keydown events, as keydown is expected
                // when users press Enter/Space to activate buttons or other interactive elements
                if ((0, $2aEiL.fg)('platform_ufo_keypress_interaction_abort')) {
                    const interaction = (0, $8OjRF.getActiveInteraction)();
                    if (interaction?.type === 'press') break;
                }
                this.setAbortReason($06d9d1ee13c23a47$var$abortReason.keypress, time);
                break;
            case 'resize':
                this.setAbortReason($06d9d1ee13c23a47$var$abortReason.resize, time);
                break;
        }
    };
    attachAbortListeners = ()=>{
        this.detachAbortListeners();
        let unbinds = (0, $fOozI.attachAbortListeners)(window, this.viewport, this.abortReasonCallback);
        if (window?.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(([key, time])=>{
            if (time) this.abortReasonCallback(key, time);
        });
        this.unbind = unbinds;
    };
    detachAbortListeners() {
        if (this.unbind) {
            const { unbind: unbind } = this;
            for(let i = 0; i < unbind.length; i++)unbind[i]();
            this.unbind.length = 0;
        }
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("fOozI", function(module, exports) {
$parcel$export(module.exports, "attachAbortListeners", () => $5d5ed60250dc350f$export$9010aa71841a6887);

var $dmmsG = parcelRequire("dmmsG");

var $78F7G = parcelRequire("78F7G");

var $6Pn3f = parcelRequire("6Pn3f");

var $9nILy = parcelRequire("9nILy");
function $5d5ed60250dc350f$export$9010aa71841a6887(window, initialViewPort, callback) {
    const unbindWheel = (0, $dmmsG.bind)(window, {
        type: (0, $78F7G.AbortEvent).wheel,
        listener: (e)=>{
            callback((0, $78F7G.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    const unbindKeydown = (0, $dmmsG.bind)(window, {
        type: (0, $78F7G.AbortEvent).keydown,
        listener: (e)=>{
            callback((0, $78F7G.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    const unbindResize = (0, $dmmsG.bind)(window, {
        type: (0, $78F7G.AbortEvent).resize,
        listener: (e)=>{
            if ((0, $9nILy.getViewportWidth)() !== initialViewPort.w || (0, $6Pn3f.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $78F7G.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}

});
parcelRegister("dmmsG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $f3XIg = parcelRequire("f3XIg");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $f3XIg.bind;
    }
});

var $6entr = parcelRequire("6entr");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $6entr.bindAll;
    }
});

});
parcelRegister("f3XIg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $af757495d6637b42$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $af757495d6637b42$var$bind;

});

parcelRegister("6entr", function(module, exports) {
"use strict";
var $4896424d5f0c4bf3$var$__assign = module.exports && module.exports.__assign || function() {
    $4896424d5f0c4bf3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4896424d5f0c4bf3$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $f3XIg = parcelRequire("f3XIg");
function $4896424d5f0c4bf3$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $4896424d5f0c4bf3$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $4896424d5f0c4bf3$var$__assign($4896424d5f0c4bf3$var$__assign({}, original), {
        options: $4896424d5f0c4bf3$var$__assign($4896424d5f0c4bf3$var$__assign({}, $4896424d5f0c4bf3$var$toOptions(sharedOptions)), $4896424d5f0c4bf3$var$toOptions(original.options))
    });
    return binding;
}
function $4896424d5f0c4bf3$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $4896424d5f0c4bf3$var$getBinding(original, sharedOptions);
        return (0, $f3XIg.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $4896424d5f0c4bf3$var$bindAll;

});


parcelRegister("78F7G", function(module, exports) {
$parcel$export(module.exports, "AbortEvent", () => $61f1c9f223568925$export$199edc0307b5587f);
const $61f1c9f223568925$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

});

parcelRegister("6Pn3f", function(module, exports) {
$parcel$export(module.exports, "getViewportHeight", () => $3cd94ea3c69e66ab$export$4f01c15d21ef9cc6);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $3cd94ea3c69e66ab$export$4f01c15d21ef9cc6(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});

parcelRegister("9nILy", function(module, exports) {
$parcel$export(module.exports, "getViewportWidth", () => $f83a06a40e1812a0$export$a497a1dcb4408212);
function $f83a06a40e1812a0$export$a497a1dcb4408212(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}

});


parcelRegister("dQn6k", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionDebugDetails", () => $212cf4c76a48b0e3$export$72e6dda9d5859230);
function $212cf4c76a48b0e3$export$72e6dda9d5859230({ revision: revision, isClean: isClean, abortReason: abortReason, VCEntries: VCEntries, componentsLog: componentsLog, interactionId: interactionId }) {
    // Pre-sort VCEntries by time for efficient lookups
    const sortedVCEntries = [
        ...VCEntries
    ].sort((a, b)=>a.time - b.time);
    // Pre-calculate max viewport percentage up to each time for efficient lookups
    const maxViewportPercentageAtTime = new Map();
    let maxSoFar = 0;
    for (const entry of sortedVCEntries){
        maxSoFar = Math.max(maxSoFar, entry.vc);
        maxViewportPercentageAtTime.set(entry.time, maxSoFar);
    }
    // Helper function to find the biggest previous viewport percentage
    const getBiggestPreviousViewportPercentage = (targetTime)=>{
        // Binary search for the largest time <= targetTime
        let left = 0;
        let right = sortedVCEntries.length - 1;
        let result = -1;
        while(left <= right){
            const mid = Math.floor((left + right) / 2);
            if (sortedVCEntries[mid].time <= targetTime) {
                result = mid;
                left = mid + 1;
            } else right = mid - 1;
        }
        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
    };
    const allVcLogs = [];
    // Add regular VC entries
    for (const entry of VCEntries){
        const timeLogEntries = componentsLog[entry.time];
        allVcLogs.push({
            time: entry.time,
            viewportPercentage: entry.vc,
            entries: entry.elements.map((element)=>{
                const logEntry = timeLogEntries?.find((log)=>log.targetName === element);
                return {
                    elementName: element,
                    type: logEntry?.type,
                    rect: logEntry?.intersectionRect,
                    visible: true,
                    attributeName: logEntry?.attributeName,
                    oldValue: logEntry?.oldValue,
                    newValue: logEntry?.newValue,
                    ignoreReason: logEntry?.ignoreReason
                };
            })
        });
    }
    // Add ignored elements - only process timestamps that have ignored elements
    for (const [timestamp, timeLogEntries] of Object.entries(componentsLog)){
        const ignoredElements = timeLogEntries.filter((log)=>log.ignoreReason);
        if (ignoredElements.length === 0) continue;
        const time = Number(timestamp);
        const viewportPercentage = getBiggestPreviousViewportPercentage(time);
        allVcLogs.push({
            time: time,
            viewportPercentage: viewportPercentage,
            entries: ignoredElements.map((logEntry)=>({
                    elementName: logEntry.targetName,
                    type: logEntry.type,
                    rect: logEntry.intersectionRect,
                    visible: false,
                    attributeName: logEntry.attributeName,
                    oldValue: logEntry.oldValue,
                    newValue: logEntry.newValue,
                    ignoreReason: logEntry.ignoreReason
                }))
        });
    }
    // Sort once at the end
    allVcLogs.sort((a, b)=>a.time - b.time);
    return {
        revision: revision,
        isClean: isClean,
        abortReason: abortReason,
        vcLogs: allVcLogs,
        interactionId: interactionId
    };
}

});

parcelRegister("57H8M", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionsData", () => $8666fec6ea05cfd2$export$5c86a34c9becd6d0);

var $5tITM = parcelRequire("5tITM");

var $cGjFC = parcelRequire("cGjFC");
const $8666fec6ea05cfd2$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
const $8666fec6ea05cfd2$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $8666fec6ea05cfd2$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    const details = {};
    const { VC: VC, VCBox: VCBox } = calculatedVC; // Destructure once to avoid repeated property access
    for (const key of $8666fec6ea05cfd2$var$VCParts)details[key] = {
        t: VC[key] || -1,
        e: VCBox[key] || $8666fec6ea05cfd2$var$READONLY_EMPTY_ARRAY
    };
    return details;
}
function $8666fec6ea05cfd2$export$5c86a34c9becd6d0({ fullPrefix: fullPrefix, interaction: interaction, isVCClean: isVCClean, isEventAborted: isEventAborted, calculatedVC: calculatedVC, calculatedVCNext: calculatedVCNext, experienceKey: experienceKey, ratios: ratios }) {
    const pageVisibilityUpToTTAI = (0, $cGjFC.getPageVisibilityState)(interaction.start, interaction.end);
    const isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    const shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    const availableVCRevisionPayloads = [];
    if ((0, $5tITM.isVCRevisionEnabled)('fy25.01', experienceKey)) {
        const revision = {
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: $8666fec6ea05cfd2$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    if ((0, $5tITM.isVCRevisionEnabled)('fy25.02', experienceKey)) {
        const revision = {
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: $8666fec6ea05cfd2$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    return {
        [`${fullPrefix}vc:rev`]: availableVCRevisionPayloads
    };
}

});
parcelRegister("cGjFC", function(module, exports) {
$parcel$export(module.exports, "getEarliestHiddenTiming", () => $41278ded42065dfe$export$754443ce7c615bd7);
$parcel$export(module.exports, "isOpenedInBackground", () => $41278ded42065dfe$export$21a1a62a307062f1);
$parcel$export(module.exports, "getHasHiddenTimingBeforeSetup", () => $41278ded42065dfe$export$95f048bd8bcdda23);
$parcel$export(module.exports, "setupHiddenTimingCapture", () => $41278ded42065dfe$export$554cefe0f0373da4);
$parcel$export(module.exports, "getPageVisibilityState", () => $41278ded42065dfe$export$768b2008623433e1);
$parcel$export(module.exports, "setupThrottleDetection", () => $41278ded42065dfe$export$fa0d29a9c87052da);
$parcel$export(module.exports, "isTabThrottled", () => $41278ded42065dfe$export$62a28c860277b3bf);
$parcel$export(module.exports, "getPageVisibilityTimeline", () => $41278ded42065dfe$export$5a06b84e47ad70d9);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $dmmsG = parcelRequire("dmmsG");

var $2aEiL = parcelRequire("2aEiL");
const $41278ded42065dfe$var$timings = [];
let $41278ded42065dfe$var$wasHiddenFlag;
let $41278ded42065dfe$var$setupFlag = false;
// Threshold for determining if page was opened in background.
// If setup runs within this time and page is hidden, we assume it was opened in a background tab.
const $41278ded42065dfe$var$OPENED_IN_BACKGROUND_THRESHOLD_MS = 100;
let $41278ded42065dfe$var$openedInBackground = null;
function $41278ded42065dfe$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
const $41278ded42065dfe$var$SIZE = 50;
let $41278ded42065dfe$var$insertIndex = 0;
function $41278ded42065dfe$export$754443ce7c615bd7(startTime, endTime) {
    const earliestHiddenTiming = $41278ded42065dfe$var$timings.find(({ hidden: hidden, time: time })=>hidden && time > 0 && time >= startTime && time <= endTime)?.time;
    if (typeof earliestHiddenTiming === 'number') return Math.round(earliestHiddenTiming - startTime);
}
function $41278ded42065dfe$export$21a1a62a307062f1(interactionType) {
    if (interactionType !== 'page_load') return false;
    // Check native visibility-state entries first (most reliable, Chromium only)
    try {
        const entries = performance.getEntriesByType('visibility-state');
        if (entries.length > 0) return entries.some((entry)=>entry.name === 'hidden' && entry.startTime <= $41278ded42065dfe$var$OPENED_IN_BACKGROUND_THRESHOLD_MS);
    } catch  {
    // visibility-state not supported (Firefox/Safari)
    }
    // Fallback to cached value from setup (determined using time threshold)
    return $41278ded42065dfe$var$openedInBackground === true;
}
function $41278ded42065dfe$var$pushHidden(isPageHiddenFlag, time) {
    $41278ded42065dfe$var$timings[$41278ded42065dfe$var$insertIndex] = {
        time: time ?? performance.now(),
        hidden: isPageHiddenFlag
    };
    $41278ded42065dfe$var$insertIndex = ($41278ded42065dfe$var$insertIndex + 1) % $41278ded42065dfe$var$SIZE;
    $41278ded42065dfe$var$wasHiddenFlag = isPageHiddenFlag;
}
function $41278ded42065dfe$var$handleChange() {
    const isPageHiddenFlag = $41278ded42065dfe$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$41278ded42065dfe$var$wasHiddenFlag) $41278ded42065dfe$var$pushHidden(isPageHiddenFlag);
        $41278ded42065dfe$var$wasHiddenFlag = true;
    } else {
        if ($41278ded42065dfe$var$wasHiddenFlag) $41278ded42065dfe$var$pushHidden(isPageHiddenFlag);
        $41278ded42065dfe$var$wasHiddenFlag = false;
    }
}
let $41278ded42065dfe$var$hasHiddenTimingBeforeSetup = false;
function $41278ded42065dfe$export$95f048bd8bcdda23() {
    return $41278ded42065dfe$var$hasHiddenTimingBeforeSetup;
}
function $41278ded42065dfe$var$setup() {
    try {
        const results = performance.getEntriesByType('visibility-state');
        results?.forEach((result)=>{
            if ((0, $2aEiL.fg)('platform_ufo_use_native_page_visibility_api')) $41278ded42065dfe$var$pushHidden(result.name === 'hidden', result.startTime);
            if (result.name === 'hidden') $41278ded42065dfe$var$hasHiddenTimingBeforeSetup = true;
        });
    } catch  {
    /* do nothing */ /* note: visibility-state entry types are not available in Firefox/Safari: https://developer.mozilla.org/en-US/docs/Web/API/VisibilityStateEntry#browser_compatibility */ }
    (0, $dmmsG.bind)(window, {
        type: 'pageshow',
        listener: $41278ded42065dfe$var$handleChange
    });
    (0, $dmmsG.bind)(window, {
        type: 'pagehide',
        listener: $41278ded42065dfe$var$handleChange
    });
    (0, $dmmsG.bind)(document, {
        type: 'visibilitychange',
        listener: $41278ded42065dfe$var$handleChange
    });
}
function $41278ded42065dfe$export$554cefe0f0373da4() {
    if (!$41278ded42065dfe$var$setupFlag) {
        const isPageHiddenFlag = $41278ded42065dfe$var$isPageHidden();
        const setupTime = performance.now();
        // Determine if page was opened in background.
        // If we're early in page lifecycle (< threshold) and page is hidden,
        // it's likely the page was opened in a background tab.
        if ($41278ded42065dfe$var$openedInBackground === null) $41278ded42065dfe$var$openedInBackground = isPageHiddenFlag && setupTime < $41278ded42065dfe$var$OPENED_IN_BACKGROUND_THRESHOLD_MS;
        $41278ded42065dfe$var$pushHidden(isPageHiddenFlag, 0);
        $41278ded42065dfe$var$setup();
        $41278ded42065dfe$var$setupFlag = true;
    }
}
function $41278ded42065dfe$export$768b2008623433e1(start, end) {
    // Input validation - return default for invalid inputs
    if (!Number.isFinite(start) || !Number.isFinite(end)) return 'visible';
    // Desirable default value is visible
    if ($41278ded42065dfe$var$timings.length === 0) return 'visible';
    const currentSize = $41278ded42065dfe$var$timings.length;
    let hiddenState = 'mixed';
    let startIdx = $41278ded42065dfe$var$insertIndex;
    let endIdx = $41278ded42065dfe$var$insertIndex;
    // currentSize is capped at SIZE.
    for(let i = 0; i < currentSize; i++){
        const tmpIdx = ($41278ded42065dfe$var$insertIndex + i) % currentSize;
        // Add bounds checking before accessing array element
        if ($41278ded42065dfe$var$timings[tmpIdx] && $41278ded42065dfe$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($41278ded42065dfe$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    // Add bounds checking before accessing timings array
    if (endIdx - startIdx === 0 && $41278ded42065dfe$var$timings[startIdx]) hiddenState = $41278ded42065dfe$var$timings[startIdx].hidden ? 'hidden' : 'visible';
    return hiddenState;
}
// Throttle detection configuration
// Expected interval for timer checks (in milliseconds)
const $41278ded42065dfe$var$THROTTLE_CHECK_INTERVAL_MS = 1000;
// Threshold for considering a timer as throttled (50% drift tolerance)
const $41278ded42065dfe$var$THROTTLE_DRIFT_THRESHOLD = 1.5;
// Maximum number of throttle measurements to store (circular buffer)
const $41278ded42065dfe$var$THROTTLE_BUFFER_SIZE = 120;
// Circular buffer to store throttle measurements
const $41278ded42065dfe$var$throttleMeasurements = [];
let $41278ded42065dfe$var$throttleInsertIndex = 0;
let $41278ded42065dfe$var$throttleIntervalId = null;
let $41278ded42065dfe$var$lastThrottleCheckTime = null;
let $41278ded42065dfe$var$throttleSetupDone = false;
function $41278ded42065dfe$var$recordThrottleMeasurement(expectedElapsed, actualElapsed) {
    const isThrottled = actualElapsed > expectedElapsed * $41278ded42065dfe$var$THROTTLE_DRIFT_THRESHOLD;
    $41278ded42065dfe$var$throttleMeasurements[$41278ded42065dfe$var$throttleInsertIndex] = {
        time: performance.now(),
        expectedElapsed: expectedElapsed,
        actualElapsed: actualElapsed,
        isThrottled: isThrottled
    };
    $41278ded42065dfe$var$throttleInsertIndex = ($41278ded42065dfe$var$throttleInsertIndex + 1) % $41278ded42065dfe$var$THROTTLE_BUFFER_SIZE;
}
function $41278ded42065dfe$var$throttleCheckCallback() {
    const currentTime = performance.now();
    if ($41278ded42065dfe$var$lastThrottleCheckTime !== null) {
        const actualElapsed = currentTime - $41278ded42065dfe$var$lastThrottleCheckTime;
        $41278ded42065dfe$var$recordThrottleMeasurement($41278ded42065dfe$var$THROTTLE_CHECK_INTERVAL_MS, actualElapsed);
    }
    $41278ded42065dfe$var$lastThrottleCheckTime = currentTime;
}
function $41278ded42065dfe$export$fa0d29a9c87052da() {
    if ($41278ded42065dfe$var$throttleSetupDone) return;
    $41278ded42065dfe$var$throttleSetupDone = true;
    // Record the initial timestamp
    $41278ded42065dfe$var$lastThrottleCheckTime = performance.now();
    // Start the periodic timer for throttle detection
    $41278ded42065dfe$var$throttleIntervalId = setInterval($41278ded42065dfe$var$throttleCheckCallback, $41278ded42065dfe$var$THROTTLE_CHECK_INTERVAL_MS);
}
function $41278ded42065dfe$export$3279694d66e4a1() {
    if ($41278ded42065dfe$var$throttleIntervalId !== null) {
        clearInterval($41278ded42065dfe$var$throttleIntervalId);
        $41278ded42065dfe$var$throttleIntervalId = null;
    }
    $41278ded42065dfe$var$lastThrottleCheckTime = null;
    $41278ded42065dfe$var$throttleSetupDone = false;
    $41278ded42065dfe$var$throttleMeasurements.length = 0;
    $41278ded42065dfe$var$throttleInsertIndex = 0;
}
function $41278ded42065dfe$export$62a28c860277b3bf(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return false;
    // No measurements available
    if ($41278ded42065dfe$var$throttleMeasurements.length === 0) return false;
    // Check if any measurement within the time window indicates throttling
    for(let i = 0; i < $41278ded42065dfe$var$throttleMeasurements.length; i++){
        const measurement = $41278ded42065dfe$var$throttleMeasurements[i];
        if (measurement && measurement.time >= startTime && measurement.time <= endTime && measurement.isThrottled) return true;
    }
    return false;
}
function $41278ded42065dfe$export$77aaa9b1ce57d9bc(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    return $41278ded42065dfe$var$throttleMeasurements.filter((measurement)=>measurement && measurement.time >= startTime && measurement.time <= endTime);
}
function $41278ded42065dfe$export$9332de935653b687(measurement) {
    $41278ded42065dfe$var$throttleMeasurements[$41278ded42065dfe$var$throttleInsertIndex] = measurement;
    $41278ded42065dfe$var$throttleInsertIndex = ($41278ded42065dfe$var$throttleInsertIndex + 1) % $41278ded42065dfe$var$THROTTLE_BUFFER_SIZE;
}
function $41278ded42065dfe$export$5a06b84e47ad70d9(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    if ($41278ded42065dfe$var$timings.length === 0) return [];
    const result = [];
    // Find the most recent entry at or before startTime to establish initial state
    let initialEntry;
    const currentSize = $41278ded42065dfe$var$timings.length;
    for(let i = 0; i < currentSize; i++){
        const idx = ($41278ded42065dfe$var$insertIndex + i) % currentSize;
        const entry = $41278ded42065dfe$var$timings[idx];
        if (entry && entry.time <= startTime) initialEntry = entry;
    }
    // Add the initial visibility state at the start of the window
    if (initialEntry) result.push({
        time: 0,
        hidden: initialEntry.hidden
    });
    // Add all entries within the time window
    for(let i = 0; i < currentSize; i++){
        const idx = ($41278ded42065dfe$var$insertIndex + i) % currentSize;
        const entry = $41278ded42065dfe$var$timings[idx];
        if (entry && entry.time > startTime && entry.time <= endTime) result.push({
            time: Math.round(entry.time - startTime),
            hidden: entry.hidden
        });
    }
    return result;
}
// Expose testing API on window for integration tests
if (typeof window !== 'undefined') window.__reactUfoHiddenTiming = {
    __injectThrottleMeasurementForTesting: $41278ded42065dfe$export$9332de935653b687
};

});


parcelRegister("eCDPR", function(module, exports) {
$parcel$export(module.exports, "Observers", () => $5ac7787b4f4afa79$export$b65d046240060e78);

var $5tITM = parcelRequire("5tITM");

var $69x7c = parcelRequire("69x7c");

var $dCLz7 = parcelRequire("dCLz7");

var $2x5fo = parcelRequire("2x5fo");

var $eJ691 = parcelRequire("eJ691");
const $5ac7787b4f4afa79$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $5ac7787b4f4afa79$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    const isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
class $5ac7787b4f4afa79$export$b65d046240060e78 {
    intersectionObserver;
    mutationObserver;
    observedMutations = new WeakMap();
    elementsInView = new Set();
    callbacks = new Set();
    totalTime = 0;
    _startMeasureTimestamp = -1;
    ssrPlaceholderHandler;
    ssr = {
        state: $5ac7787b4f4afa79$var$state.normal,
        reactRootElement: null,
        renderStart: -1,
        renderStop: -1
    };
    selectorConfig = {
        id: false,
        testId: false,
        role: false,
        className: true,
        dataVC: true
    };
    constructor(opts){
        // Selector-config resolution is centralised in `getSelectorConfig()`.
        // It enforces FedRAMP-override > caller-override > centrally
        // configured > caller default.
        const resolved = (0, $5tITM.getSelectorConfig)(opts.selectorConfig, this.selectorConfig);
        this.selectorConfig = resolved ?? {
            ...this.selectorConfig,
            ...opts.selectorConfig
        };
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        // Use shared SSR placeholder handler if provided, otherwise create new one
        if (opts.ssrPlaceholderHandler) this.ssrPlaceholderHandler = opts.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, $eJ691.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: opts.SSRConfig?.enablePageLayoutPlaceholder
        });
    }
    isBrowserSupported() {
        return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
    }
    observe() {
        this.totalTime = 0;
        this.ssr = {
            state: $5ac7787b4f4afa79$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.mutationObserver?.observe(document.body, {
            attributeFilter: [
                'hidden',
                'style',
                'src',
                'class'
            ],
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
    }
    disconnect() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.observedMutations = new WeakMap();
        this.elementsInView.clear();
        this.callbacks.clear();
        this.ssr.reactRootElement = null;
        this.ssrPlaceholderHandler.clear();
    }
    subscribeResults = (cb)=>{
        this.callbacks.add(cb);
    };
    getTotalTime() {
        return this.totalTime;
    }
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $5ac7787b4f4afa79$var$state.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    observeElement = (node, mutation, type, ignoreReason, attributeName, oldValue = null, newValue = null)=>{
        this.intersectionObserver?.observe(node);
        this.observedMutations.set(node, {
            mutation: mutation,
            ignoreReason: ignoreReason,
            type: type,
            attributeName: attributeName,
            oldValue: oldValue,
            newValue: newValue
        });
    };
    getMutationObserver() {
        if (!this.isBrowserSupported()) return null;
        return new MutationObserver((mutations)=>{
            this.measureStart();
            mutations.forEach((mutation)=>{
                // patching element if timestamp not automatically added
                // eslint-disable-next-line no-param-reassign
                mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                let ignoreReason = '';
                if (this.ssr.state === $5ac7787b4f4afa79$var$state.waitingForFirstRender && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    this.ssr.state = $5ac7787b4f4afa79$var$state.ignoring;
                    if (this.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                    this.ssr.renderStop = mutation.timestamp + 500;
                    ignoreReason = 'ssr-hydration';
                }
                if (this.ssr.state === $5ac7787b4f4afa79$var$state.ignoring && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    if (mutation.timestamp <= this.ssr.renderStop) ignoreReason = 'ssr-hydration';
                    else this.ssr.state = $5ac7787b4f4afa79$var$state.normal;
                }
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node)=>{
                        if ((0, $69x7c.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                        if (node instanceof HTMLElement) {
                            if (this.ssrPlaceholderHandler.isPlaceholder(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            if (this.ssrPlaceholderHandler.isPlaceholderReplacement(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            this.observeElement(node, mutation, 'html', ignoreReason);
                        }
                        if (node instanceof Text && node.parentElement != null) this.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                    });
                    mutation.removedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            this.elementsInView.delete(node);
                            this.intersectionObserver?.unobserve(node);
                        }
                    });
                } else if (mutation.type === 'attributes') {
                    if (mutation.target instanceof HTMLElement) {
                        const attributeName = mutation.attributeName;
                        /*
            	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
            	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
            	Conceptually there is after all a mutation: there is an old value replaced with a new one,
            	and whether or not they are the same doesn't really matter.
            	And Custom elements should work the same way as MutationObserver."
            	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
            */ const oldValue = mutation.oldValue ?? undefined;
                        const newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                        if (oldValue !== newValue) {
                            if ((0, $dCLz7.default)(mutation)) ignoreReason = 'non-visual-style';
                            if ((0, $69x7c.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                            this.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                        }
                    }
                }
            });
        });
    }
    getElementName(element) {
        try {
            const tagName = element.localName;
            const dataVCAttr = element.getAttribute('data-vc');
            const dataVC = this.selectorConfig.dataVC && dataVCAttr ? `[data-vc="${dataVCAttr}"]` : '';
            const id = this.selectorConfig.id && element.id ? `#${element.id}` : '';
            let testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
            testId = testId ? `[testid=${testId}]` : '';
            let role = this.selectorConfig.role ? element.getAttribute('role') : '';
            role = role ? `[role=${role}]` : '';
            let classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
            classList = classList === '' ? '' : `.${classList}`;
            const attrs = dataVC ? dataVC : [
                id,
                testId,
                role
            ].join('');
            let idString = '';
            if (attrs === '' && classList === '') {
                const parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                idString = `${parent} > ${tagName}`;
            } else idString = [
                tagName,
                attrs || classList
            ].join('');
            return idString;
        } catch  {
            return 'error';
        }
    }
    getIntersectionObserver() {
        if (!this.isBrowserSupported()) return null;
        return new IntersectionObserver((entries)=>{
            this.measureStart();
            entries.forEach(({ isIntersecting: isIntersecting, intersectionRect: ir, target: target })=>{
                const data = this.observedMutations.get(target);
                this.observedMutations.delete(target);
                if (isIntersecting && ir.width > 0 && ir.height > 0) {
                    if (!(target instanceof HTMLElement)) return;
                    if (!data?.mutation) // ignore intersection report without recent mutation
                    return;
                    if (!$5ac7787b4f4afa79$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                    if ((0, $2x5fo.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(ir)) data.ignoreReason = 'rll-placeholder';
                    this.callbacks.forEach((callback)=>{
                        let elementName;
                        try {
                            elementName = this.getElementName(target);
                        } catch  {
                            elementName = 'error';
                        }
                        callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                    });
                    this.elementsInView.add(target);
                } else this.elementsInView.delete(target);
            });
            this.measureStop();
        });
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("69x7c", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinMediaWrapper", () => $c907462cd7c245e5$export$f61fbc3b9c4a9019);

var $1R1hC = parcelRequire("1R1hC");
function $c907462cd7c245e5$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $1R1hC.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
}

});
parcelRegister("1R1hC", function(module, exports) {
$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", () => $6cc14ae230f77969$export$7674290405cc25b0);
$parcel$export(module.exports, "VcMediaWrapperProps", () => $6cc14ae230f77969$export$7028e9efe569888c);
parcelRequire("1v5pe");

var $kIqwl = parcelRequire("kIqwl");
const $6cc14ae230f77969$export$7674290405cc25b0 = 'data-media-vc-wrapper';
const $6cc14ae230f77969$export$7028e9efe569888c = {
    [$6cc14ae230f77969$export$7674290405cc25b0]: true
};
function $6cc14ae230f77969$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
        ...$6cc14ae230f77969$export$7028e9efe569888c,
        children: children
    });
}

});
parcelRegister("kIqwl", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cvx3o"));

});
parcelRegister("cvx3o", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $91b2050fd2f37fbc$export$ffb0004e005737fa, (v) => $91b2050fd2f37fbc$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $91b2050fd2f37fbc$export$34b9dba7ce09269b, (v) => $91b2050fd2f37fbc$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $91b2050fd2f37fbc$export$25062201e9e25d76, (v) => $91b2050fd2f37fbc$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $91b2050fd2f37fbc$export$ffb0004e005737fa;
var $91b2050fd2f37fbc$export$34b9dba7ce09269b;
var $91b2050fd2f37fbc$export$25062201e9e25d76;
'use strict';

var $1v5pe = parcelRequire("1v5pe");
var $91b2050fd2f37fbc$var$k = Symbol.for("react.element"), $91b2050fd2f37fbc$var$l = Symbol.for("react.fragment"), $91b2050fd2f37fbc$var$m = Object.prototype.hasOwnProperty, $91b2050fd2f37fbc$var$n = $1v5pe.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $91b2050fd2f37fbc$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $91b2050fd2f37fbc$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$91b2050fd2f37fbc$var$m.call(a, b) && !$91b2050fd2f37fbc$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $91b2050fd2f37fbc$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $91b2050fd2f37fbc$var$n.current
    };
}
$91b2050fd2f37fbc$export$ffb0004e005737fa = $91b2050fd2f37fbc$var$l;
$91b2050fd2f37fbc$export$34b9dba7ce09269b = $91b2050fd2f37fbc$var$q;
$91b2050fd2f37fbc$export$25062201e9e25d76 = $91b2050fd2f37fbc$var$q;

});




parcelRegister("dCLz7", function(module, exports) {
$parcel$export(module.exports, "default", () => $6aba97a6d8cb36ab$export$2e2bcd8739ae039);
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $6aba97a6d8cb36ab$var$isNonVisualStyleMutation({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
var $6aba97a6d8cb36ab$export$2e2bcd8739ae039 = $6aba97a6d8cb36ab$var$isNonVisualStyleMutation;

});

parcelRegister("2x5fo", function(module, exports) {
$parcel$export(module.exports, "RLLPlaceholderHandlers", () => $f64ee0e5879f0e30$export$166779fc0f49d4df);
const $f64ee0e5879f0e30$var$GLOBAL_RLL_HANDLERS_KEY = '__REACT_UFO_RLL_PLACEHOLDER_HANDLERS__';
class $f64ee0e5879f0e30$export$166779fc0f49d4df {
    placeholders = [];
    constructor(){
        if (typeof window !== 'undefined' && typeof document !== 'undefined' && typeof window.document !== 'undefined') this.collectRLLPlaceholders();
    }
    /**
   * Gets the global singleton instance of RLLPlaceholderHandlers.
   * Creates the instance if it doesn't exist and stores it in globalThis.
   * @returns The singleton instance of RLLPlaceholderHandlers
   */ static getInstance() {
        if (typeof globalThis !== 'undefined') {
            if (!globalThis[$f64ee0e5879f0e30$var$GLOBAL_RLL_HANDLERS_KEY]) globalThis[$f64ee0e5879f0e30$var$GLOBAL_RLL_HANDLERS_KEY] = new $f64ee0e5879f0e30$export$166779fc0f49d4df();
            return globalThis[$f64ee0e5879f0e30$var$GLOBAL_RLL_HANDLERS_KEY];
        }
        // Fallback for environments without globalThis (should be rare)
        return new $f64ee0e5879f0e30$export$166779fc0f49d4df();
    }
    reset() {
        this.placeholders = [];
    }
    /**
   * Collects all React Loosely Lazy (RLL) placeholders from the DOM and caches their viewport intersecting rectangles.
   * RLL placeholders are marked with data-lazy-begin and data-lazy-end attributes on hidden input elements.
   * Performance optimized to batch getBoundingClientRect calls and minimize layout thrashing.
   * Only stores the intersecting portions of rectangles that are currently visible in the viewport.
   */ collectRLLPlaceholders() {
        if (typeof window === 'undefined' || typeof document === 'undefined' || typeof window.document === 'undefined') return;
        const beginElements = document.querySelectorAll('input[data-lazy-begin]');
        const beginCount = beginElements.length;
        if (beginCount === 0) return;
        // Performance optimization: pre-allocate array with estimated size
        const allElements = [];
        // Performance optimization: use traditional for loop instead of forEach
        for(let i = 0; i < beginCount; i++){
            const beginEl = beginElements[i];
            const id = beginEl.getAttribute('data-lazy-begin');
            if (!id) continue;
            const elements = this.refElements(beginEl, id);
            if (elements.length > 0) allElements.push(...elements);
        }
        // Second pass: batch all getBoundingClientRect calls to minimize reflow cycles
        const allElementsLength = allElements.length;
        if (allElementsLength > 0) {
            // Performance optimization: pre-allocate array with exact size
            const intersectingRects = [];
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            for(let i = 0; i < allElementsLength; i++){
                const rect = allElements[i].getBoundingClientRect();
                // Performance optimization: inline intersection calculation to avoid function call overhead
                const left = Math.max(rect.left, 0);
                const top = Math.max(rect.top, 0);
                const right = Math.min(rect.right, windowWidth);
                const bottom = Math.min(rect.bottom, windowHeight);
                // Check if there's a valid intersection with non-zero width and height
                if (left < right && top < bottom) intersectingRects.push(new DOMRect(left, top, right - left, bottom - top));
            }
            this.placeholders = intersectingRects;
        }
    }
    /**
   * Traverses DOM siblings to find all elements between RLL begin and end markers.
   * Based on the refElements pattern from react-loosely-lazy's platform/packages/async/react-loosely-lazy/src/collect/hydrate.ts
   * Performance optimized to minimize iterations and early exit conditions.
   *
   * @param fromEl - The input element with data-lazy-begin attribute
   * @param id - The placeholder ID to match against data-lazy-end
   * @returns Array of DOM elements between the begin/end markers
   */ refElements(fromEl, id) {
        const result = [];
        let el = fromEl.nextSibling;
        // Performance optimization: use while loop instead of recursive calls
        while(el){
            if (el.dataset?.lazyEnd === id) break;
            if (el.nodeType === Node.ELEMENT_NODE) result.push(el);
            el = el.nextSibling;
        }
        return result;
    }
    /**
   * Returns the cached intersecting viewport rectangles for all RLL placeholder elements.
   * @returns Array of DOMRect objects representing the intersecting portions of placeholders within the viewport
   */ getPlaceholders() {
        return this.placeholders;
    }
    /**
   * Checks if the given intersecting rectangle matches any of the cached RLL placeholder intersecting rectangles.
   * This is designed to be called from IntersectionObserver with the intersectionRect.
   * Performance optimized with early exits and minimal calculations.
   * @param intersectingRect - The intersecting rectangle from IntersectionObserver
   * @returns true if the intersecting rectangle matches a cached placeholder rectangle and hasn't exceeded match limit, false otherwise
   */ isRLLPlaceholderHydration(intersectingRect) {
        const placeholdersLength = this.placeholders.length;
        if (placeholdersLength === 0) return false;
        // Performance optimization: cache array length and use traditional for loop
        for(let i = 0; i < placeholdersLength; i++){
            const placeholderRect = this.placeholders[i];
            if (this.areRectsEqual(intersectingRect, placeholderRect)) return true;
        }
        return false;
    }
    /**
   * Compares two DOMRect objects for equality with ±1 pixel tolerance.
   * Performance optimized to minimize calculations and early exit on major differences.
   * @param rect1 - First rectangle to compare
   * @param rect2 - Second rectangle to compare
   * @returns true if rectangles are within 1 pixel tolerance for all properties
   */ areRectsEqual(rect1, rect2) {
        // Early exit for exact matches (most common case)
        if (rect1.left === rect2.left && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom) return true;
        // Performance optimization: check largest differences first for early exit
        const leftDiff = rect1.left - rect2.left;
        if (leftDiff > 1 || leftDiff < -1) return false;
        const rightDiff = rect1.right - rect2.right;
        if (rightDiff > 1 || rightDiff < -1) return false;
        const topDiff = rect1.top - rect2.top;
        if (topDiff > 1 || topDiff < -1) return false;
        const bottomDiff = rect1.bottom - rect2.bottom;
        if (bottomDiff > 1 || bottomDiff < -1) return false;
        return true;
    }
}

});

parcelRegister("eJ691", function(module, exports) {
$parcel$export(module.exports, "SSRPlaceholderHandlers", () => $487c921a16ccd5c9$export$c0102f1a1198d10f);
const $487c921a16ccd5c9$var$ANCESTOR_LOOKUP_LIMIT = 10;
const $487c921a16ccd5c9$var$PAGE_LAYOUT_ID = 'page-layout.root';
class $487c921a16ccd5c9$export$c0102f1a1198d10f {
    staticPlaceholders = new Map();
    callbacks = new Map();
    getSizeCallbacks = new Map();
    reactValidateCallbacks = new Map();
    intersectionObserver;
    EQUALITY_THRESHOLD = 1;
    enablePageLayoutPlaceholder;
    constructor({ enablePageLayoutPlaceholder: enablePageLayoutPlaceholder = false }){
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        if (window.document) try {
            // Collect initial placeholders using SSR dimensions. __SSR_PLACEHOLDERS_DIMENSIONS__ is
            // deliberately left in place: several VCObserverWrappers are built per page load and each
            // builds its own handler, so dropping it here would leave every later handler measuring
            // each placeholder with getBoundingClientRect() — a synchronous style recalc and a
            // full-document layout mid-hydration. Keeping it costs one small map per document.
            this.collectPlaceholdersInternal();
        } catch  {}
    }
    getPlaceholderId = (el)=>{
        const ssrPlaceholderId = el?.dataset?.ssrPlaceholder;
        if (!!ssrPlaceholderId) return ssrPlaceholderId;
        if (this.enablePageLayoutPlaceholder && el?.dataset.testid === $487c921a16ccd5c9$var$PAGE_LAYOUT_ID) return $487c921a16ccd5c9$var$PAGE_LAYOUT_ID;
        return '';
    };
    getPlaceholderReplacementId = (el)=>{
        const ssrPlaceholderReplaceId = el?.dataset?.ssrPlaceholderReplace;
        if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
        if (this.enablePageLayoutPlaceholder && el?.dataset.testid === $487c921a16ccd5c9$var$PAGE_LAYOUT_ID) return $487c921a16ccd5c9$var$PAGE_LAYOUT_ID;
        return '';
    };
    clear() {
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
    }
    collectPlaceholdersInternal() {
        const selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : '[data-ssr-placeholder]';
        const existingElements = document.querySelectorAll(selector);
        existingElements.forEach((el)=>{
            const placeholderId = el instanceof HTMLElement && this.getPlaceholderId(el);
            if (placeholderId && !this.staticPlaceholders.has(placeholderId)) {
                let width = -1;
                let height = -1;
                let x = -1;
                let y = -1;
                // Use SSR dimensions from window global if available
                const boundingClientRect = window.__SSR_PLACEHOLDERS_DIMENSIONS__?.[placeholderId];
                if (boundingClientRect) {
                    width = boundingClientRect.width;
                    height = boundingClientRect.height;
                    x = boundingClientRect.x;
                    y = boundingClientRect.y;
                } else {
                    // Fallback to current bounding rect if SSR dimensions not available
                    const rect = el.getBoundingClientRect();
                    width = rect.width;
                    height = rect.height;
                    x = rect.x;
                    y = rect.y;
                }
                this.staticPlaceholders.set(placeholderId, {
                    width: width,
                    height: height,
                    x: x,
                    y: y
                });
                this.intersectionObserver?.observe(el);
            }
        });
    }
    /**
   * Added this method to be utilised for testing purposes.
   * In production it collection placeholder should only happens on constructor
   */ collectExistingPlaceholders() {
        if (!window.document) return;
        try {
            // Collect placeholders using SSR dimensions or fallback to live dimensions
            this.collectPlaceholdersInternal();
        } catch  {
        // Silently fail if there are any issues
        }
    }
    isPlaceholder(element) {
        return Boolean(this.getPlaceholderId(element));
    }
    isPlaceholderReplacement(element) {
        return Boolean(this.getPlaceholderReplacementId(element));
    }
    isPlaceholderIgnored(element) {
        // data-ssr-placeholder-ignored doesn't have a value.
        return 'ssrPlaceholderIgnored' in element.dataset;
    }
    isPlaceholderV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $487c921a16ccd5c9$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    isPlaceholderReplacementV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $487c921a16ccd5c9$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderReplacementId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    findNearestPlaceholderContainerIfIgnored(element) {
        if (!this.isPlaceholderIgnored(element)) return element;
        let ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < $487c921a16ccd5c9$var$ANCESTOR_LOOKUP_LIMIT){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            ancestor = ancestor.parentElement;
            i++;
        }
        return element;
    }
    findNearestPlaceholderOrContainer(element, limit = $487c921a16ccd5c9$var$ANCESTOR_LOOKUP_LIMIT) {
        let ancestor = element;
        if (this.isPlaceholderIgnored(element) && element.parentElement) ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < limit){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            if (ancestor.parentElement) {
                ancestor = ancestor.parentElement;
                i++;
            } else break;
        }
        return element;
    }
    // Validates placeholder match using asynchronous observation and resolves with the result
    checkIfExistedAndSizeMatching(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.callbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    // Validates placeholder match synchronously using stored SSR dimensions and current bounds
    checkIfExistedAndSizeMatchingV3(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        const placeholderRects = this.staticPlaceholders.get(id);
        if (!placeholderRects) return false;
        return this.hasSameSizePosition(placeholderRects, this.getEffectiveBoundingRect(el));
    }
    getSize(el) {
        return new Promise((resolve)=>{
            this.getSizeCallbacks.set(this.getPlaceholderId(el), resolve);
            this.intersectionObserver?.observe(el);
        });
    }
    validateReactComponentMatchToPlaceholder(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderReplacementId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.reactValidateCallbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    validateReactComponentMatchToPlaceholderV4(el) {
        el = this.findNearestPlaceholderOrContainer(el, 2); // We are using 2 due to over-eagerness of the default, only check itself and 1 ancestor
        const id = this.getPlaceholderReplacementId(el);
        return this.staticPlaceholders.has(id);
    }
    hasSameSizePosition(rect, boundingClientRect) {
        if (!rect) return false;
        const horizontalCheck = Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD;
        const verticalCheck = Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD;
        return horizontalCheck && verticalCheck || false;
    }
    /**
   * Gets the effective bounding rectangle for an element, handling display: contents elements
   * by collecting dimensions from their children instead
   */ getEffectiveBoundingRect(el) {
        const computedStyle = window.getComputedStyle(el);
        // If element has display: contents, collect bounding rect from children
        if (computedStyle.display === 'contents') {
            const children = Array.from(el.children);
            if (children.length === 0) // No children, return zero rect
            return new DOMRect(0, 0, 0, 0);
            // Calculate union of all children's bounding rects
            let minX = Infinity;
            let minY = Infinity;
            let maxX = -Infinity;
            let maxY = -Infinity;
            children.forEach((child)=>{
                const childRect = child.getBoundingClientRect();
                // Skip children with zero dimensions (likely also display: contents)
                if (childRect.width > 0 || childRect.height > 0) {
                    minX = Math.min(minX, childRect.left);
                    minY = Math.min(minY, childRect.top);
                    maxX = Math.max(maxX, childRect.right);
                    maxY = Math.max(maxY, childRect.bottom);
                }
            });
            // If no children with dimensions found, return zero rect
            if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
            return new DOMRect(minX, minY, maxX - minX, maxY - minY);
        }
        // Normal element, return its bounding rect
        return el.getBoundingClientRect();
    }
    isDummyRect(rect) {
        return rect && rect.width < 0 && rect.height < 0 || false;
    }
    intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
        this.intersectionObserver?.unobserve(target);
        if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
        return;
        const staticKey = this.getPlaceholderId(target);
        if (staticKey) {
            if (this.staticPlaceholders.has(staticKey) && this.callbacks.has(staticKey)) {
                // validation
                const resolve = this.callbacks.get(staticKey);
                if (!resolve) return;
                const rect = this.staticPlaceholders.get(staticKey);
                const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                else requestAnimationFrame(()=>{
                    const targetRect = this.getEffectiveBoundingRect(target);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                    resolve(hasSameSizePosition);
                });
                this.callbacks.delete(staticKey);
            }
        } else {
            const key = this.getPlaceholderReplacementId(target);
            const resolve = this.reactValidateCallbacks.get(key);
            if (!resolve) return;
            const rect = this.staticPlaceholders.get(key);
            const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
            if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
            else requestAnimationFrame(()=>{
                const targetRect = this.getEffectiveBoundingRect(target);
                const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                resolve(hasSameSizePosition);
            });
            this.staticPlaceholders.delete(staticKey);
            this.reactValidateCallbacks.delete(staticKey);
        }
    };
}

});



parcelRegister("7BMVq", function(module, exports) {
$parcel$export(module.exports, "default", () => $38e539c84ba4d052$export$2e2bcd8739ae039);

var $2aEiL = parcelRequire("2aEiL");

var $5tITM = parcelRequire("5tITM");

var $bodHZ = parcelRequire("bodHZ");

var $8OjRF = parcelRequire("8OjRF");

var $eJ691 = parcelRequire("eJ691");

var $1te8m = parcelRequire("1te8m");

var $5bpMv = parcelRequire("5bpMv");

var $lYAaG = parcelRequire("lYAaG");

var $1b6ay = parcelRequire("1b6ay");

var $5Zpwf = parcelRequire("5Zpwf");

var $eMj7K = parcelRequire("eMj7K");

var $142PG = parcelRequire("142PG");

var $iEFO6 = parcelRequire("iEFO6");

var $kOjDj = parcelRequire("kOjDj");

var $i9M5e = parcelRequire("i9M5e");
const $38e539c84ba4d052$var$SSRState = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
const $38e539c84ba4d052$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
class $38e539c84ba4d052$export$2e2bcd8739ae039 {
    selectorConfig;
    viewportObserver = null;
    windowEventObserver = null;
    entriesTimeline;
    isPostInteraction;
    trackLayoutShiftOffenders;
    // SSR related properties
    ssrPlaceholderHandler = null;
    ssr = {
        state: $38e539c84ba4d052$var$SSRState.normal,
        reactRootElement: null,
        renderStart: -1,
        renderStop: -1
    };
    constructor(config){
        this.entriesTimeline = new (0, $1te8m.default)();
        this.isPostInteraction = config.isPostInteraction ?? false;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It applies the FedRAMP all-`false` override when
        // `isFedrampModerate()` is true; otherwise it returns `caller-override
        // → setUFOConfig value → historical default`.
        this.selectorConfig = (0, $5tITM.getSelectorConfig)(config.selectorConfig, $38e539c84ba4d052$var$DEFAULT_SELECTOR_CONFIG) ?? config.selectorConfig ?? $38e539c84ba4d052$var$DEFAULT_SELECTOR_CONFIG;
        // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
        if (config.ssrPlaceholderHandler) this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, $eJ691.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: config.SSRConfig?.enablePageLayoutPlaceholder ?? false
        });
        this.trackLayoutShiftOffenders = config.trackLayoutShiftOffenders ?? false;
        this.viewportObserver = new (0, $kOjDj.default)({
            onChange: (onChangeArg)=>{
                const { time: time, type: type, elementRef: elementRef, visible: visible, rect: rect, previousRect: previousRect, mutationData: mutationData } = onChangeArg;
                let elementName = 'unknown';
                const element = elementRef.deref();
                if (element) elementName = this.getElementName(element);
                const data = {
                    type: type,
                    elementName: elementName,
                    rect: rect,
                    previousRect: previousRect,
                    visible: visible,
                    attributeName: mutationData?.attributeName,
                    oldValue: mutationData?.oldValue,
                    newValue: mutationData?.newValue,
                    originalMutationTimestamp: mutationData?.timestamp
                };
                if (element) {
                    const labelStacks = $38e539c84ba4d052$var$getLabelStacks(element);
                    if (labelStacks) Object.assign(data, {
                        labelStacks: labelStacks
                    });
                }
                this.entriesTimeline.push({
                    time: time,
                    data: data
                });
            },
            // Pass SSR context to ViewportObserver
            getSSRState: ()=>this.getSSRState(),
            getSSRPlaceholderHandler: ()=>this.getSSRPlaceholderHandler(),
            searchPageConfig: config.searchPageConfig,
            trackLayoutShiftOffenders: this.trackLayoutShiftOffenders
        });
        this.windowEventObserver = new (0, $i9M5e.default)({
            onEvent: ({ time: time, type: type, event: event })=>{
                // Don't abort press interactions on keydown events, as keydown is expected
                // when users press Enter/Space to activate buttons or other interactive elements
                if (type === 'keydown' && (0, $2aEiL.fg)('platform_ufo_keypress_interaction_abort')) {
                    const interaction = (0, $8OjRF.getActiveInteraction)();
                    if (interaction?.type === 'press') return;
                }
                const abortEventTargetElement = $38e539c84ba4d052$var$isAbortEventTargetSupported(type) && event ? $38e539c84ba4d052$var$getAbortEventTargetElement(event.target) : null;
                const elementName = abortEventTargetElement ? this.getElementName(abortEventTargetElement) : undefined;
                this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: type,
                        ...elementName ? {
                            elementName: elementName
                        } : {}
                    }
                });
            }
        });
    }
    start(_) {
        // Reset SSR state on start (matches old VCObserver behavior)
        this.ssr = {
            state: $38e539c84ba4d052$var$SSRState.normal,
            reactRootElement: null,
            // Reset to null (matches old VCObserver)
            renderStart: -1,
            renderStop: -1
        };
        this.viewportObserver?.start();
        this.entriesTimeline.clear();
        if (window?.__SSR_ABORT_LISTENERS__) {
            const abortListeners = window.__SSR_ABORT_LISTENERS__;
            const aborts = abortListeners.aborts;
            if (aborts && typeof aborts === 'object') Object.entries(aborts).forEach(([key, time])=>{
                if (typeof time === 'number') this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: key
                    }
                });
            });
        }
        this.windowEventObserver?.start();
    }
    stop() {
        this.viewportObserver?.stop();
        this.windowEventObserver?.stop();
        // Clear SSR state on stop (matches old VCObserver behavior)
        this.ssr.reactRootElement = null;
    }
    // SSR related methods
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $38e539c84ba4d052$var$SSRState.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    // Internal methods for ViewportObserver to access SSR state
    getSSRState() {
        return this.ssr;
    }
    getSSRPlaceholderHandler() {
        return this.ssrPlaceholderHandler;
    }
    addSSR(ssr) {
        this.entriesTimeline.push({
            time: ssr,
            data: {
                elementName: 'SSR',
                type: 'mutation:element',
                rect: {
                    height: (0, $5Zpwf.default)(),
                    width: (0, $eMj7K.default)(),
                    left: 0,
                    top: 0,
                    x: 0,
                    y: 0,
                    bottom: (0, $5Zpwf.default)(),
                    right: (0, $eMj7K.default)(),
                    toJSON () {
                        return null;
                    }
                },
                visible: true
            }
        });
    }
    async getVCResult(param) {
        const { start: start, stop: stop, interactionId: interactionId, interactionType: interactionType, interactionAbortReason: interactionAbortReason, isPageVisible: isPageVisible, include3p: include3p, includeSSRRatio: includeSSRRatio, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, rawDataStopTime: rawDataStopTime } = param;
        const results = [];
        this.addStartEntry(start);
        const feVCCalculationStartTime = performance.now();
        const calculator_fy25_03 = new (0, $lYAaG.default)();
        if (param.includeSSRInV3 && param.ssr) this.addSSR(param.ssr);
        const orderedEntries = this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: stop
        });
        const fy25_03 = (0, $5tITM.isVCRevisionEnabled)('fy25.03') ? await calculator_fy25_03.calculate({
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        }) : null;
        if (fy25_03) results.push(fy25_03);
        // From TTVC v4 onwards, ensuring that SSR entry is always auto-added, whenever it is configured.
        if (param.ssr) this.addSSR(param.ssr);
        const calculator_fy26_04 = new (0, $1b6ay.default)();
        const calculator_next = new (0, $142PG.default)();
        const calculatorParams = {
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        };
        const isFy2604Enabled = (0, $5tITM.isVCRevisionEnabled)('fy26.04');
        const [fy26_04, vcNext] = await Promise.all([
            isFy2604Enabled ? calculator_fy26_04.calculate(calculatorParams) : null,
            (0, $5tITM.isVCRevisionEnabled)('next') ? calculator_next.calculate(calculatorParams) : null
        ]);
        if (fy26_04) results.push(fy26_04);
        if (vcNext) results.push(vcNext);
        const feVCCalculationEndTime = performance.now();
        // Always include raw data so the server can recalculate metrics
        // (ssrRatio, labelStacks, speedIndex) from raw observations.
        const rawVCCalculationStartTime = performance.now();
        const rawHandler = new (0, $iEFO6.default)();
        // Use rawDataStopTime (end3p) when available to capture observations during 3p holds
        const rawStopTime = rawDataStopTime ?? stop;
        const rawOrderedEntries = rawDataStopTime ? this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: rawStopTime
        }) : orderedEntries;
        const raw = await rawHandler.getRawData({
            entries: rawOrderedEntries,
            startTime: start,
            stopTime: rawStopTime,
            isPageVisible: isPageVisible
        });
        results.forEach((result)=>{
            delete result.vcDetails;
            delete result.ratios;
        });
        if (raw) {
            raw.rawVCTime = Number((performance.now() - rawVCCalculationStartTime).toFixed(2));
            raw.feVCTime = Number((feVCCalculationEndTime - feVCCalculationStartTime).toFixed(2));
            results.push(raw);
        }
        return results;
    }
    addStartEntry(startTime) {
        this.entriesTimeline.push({
            time: startTime,
            data: {
                type: 'mutation:element',
                elementName: 'START',
                visible: true,
                rect: {
                    x: 0,
                    y: 0,
                    width: window.innerWidth,
                    height: window.innerHeight,
                    top: 0,
                    left: 0,
                    bottom: window.innerHeight,
                    right: window.innerWidth,
                    toJSON: function() {
                        return {
                            x: this.x,
                            y: this.y,
                            width: this.width,
                            height: this.height,
                            top: this.top,
                            left: this.left,
                            bottom: this.bottom,
                            right: this.right
                        };
                    }
                }
            }
        });
    }
    getElementName(element) {
        return (0, $5bpMv.default)(this.selectorConfig, element);
    }
}
function $38e539c84ba4d052$var$labelStackFromFiber(fiber) {
    const value = fiber?.child?.memoizedProps?.value;
    return Array.isArray(value?.labelStack) ? value.labelStack : [];
}
function $38e539c84ba4d052$var$labelStackToString(labelStack) {
    return labelStack.map((label)=>(0, $bodHZ.sanitizeLabelStackName)(label.name)).join('/');
}
function $38e539c84ba4d052$var$labelStackToSegment(labelStack) {
    let segmentIndex = -1;
    for(let i = labelStack.length - 1; i >= 0; i--)if (labelStack[i].segmentId) {
        segmentIndex = i;
        break;
    }
    return labelStack.slice(0, segmentIndex + 1).map((label)=>(0, $bodHZ.sanitizeLabelStackName)(label.name)).join('/');
}
function $38e539c84ba4d052$var$traverseFiber(fiber) {
    let segment = 'unknown';
    let labelStackString = 'unknown';
    let currentFiber = fiber;
    while(currentFiber){
        if (currentFiber.type) {
            const componentName = currentFiber.type.displayName || currentFiber.type.name;
            if (componentName === 'UFOSegment' || componentName === 'UFOLabel') {
                const labelStack = $38e539c84ba4d052$var$labelStackFromFiber(currentFiber);
                labelStackString = $38e539c84ba4d052$var$labelStackToString(labelStack) || 'unknown';
                segment = $38e539c84ba4d052$var$labelStackToSegment(labelStack) || 'unknown';
                break;
            }
        }
        currentFiber = currentFiber.return;
    }
    return {
        segment: segment,
        labelStack: labelStackString
    };
}
function $38e539c84ba4d052$var$getLabelStacks(element) {
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (!reactFiberKey) return null;
    const fiber = element[reactFiberKey];
    return fiber ? $38e539c84ba4d052$var$traverseFiber(fiber) : null;
}
const $38e539c84ba4d052$var$SUPPORTED_ABORT_EVENT_TARGET_TYPES = new Set([
    'scroll-container',
    'scroll',
    'wheel'
]);
function $38e539c84ba4d052$var$isAbortEventTargetSupported(type) {
    return $38e539c84ba4d052$var$SUPPORTED_ABORT_EVENT_TARGET_TYPES.has(type);
}
function $38e539c84ba4d052$var$getAbortEventTargetElement(target) {
    if (target instanceof HTMLElement) return target;
    if (target instanceof Document) {
        const scrollingElement = target.scrollingElement;
        if (scrollingElement instanceof HTMLElement) return scrollingElement;
        return target.documentElement ?? null;
    }
    if (target instanceof Window) {
        const scrollingElement = target.document.scrollingElement;
        if (scrollingElement instanceof HTMLElement) return scrollingElement;
        return target.document.documentElement ?? null;
    }
    if (target instanceof Node) return target.parentElement;
    return null;
}

});
parcelRegister("1te8m", function(module, exports) {
$parcel$export(module.exports, "default", () => $de8bf3fd8d1a5bf4$export$2e2bcd8739ae039);
class $de8bf3fd8d1a5bf4$export$2e2bcd8739ae039 {
    unorderedEntries;
    sortedEntriesCache;
    constructor(){
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
    push(entry) {
        this.unorderedEntries.push(entry);
        this.sortedEntriesCache.clear();
    }
    getCacheKey(start, stop) {
        return `${start ?? 'null'}_${stop ?? 'null'}`;
    }
    getOrderedEntries({ start: start, stop: stop }) {
        const cacheKey = this.getCacheKey(start, stop);
        const cachedSortedEntries = this.sortedEntriesCache.get(cacheKey)?.deref();
        if (cachedSortedEntries) return cachedSortedEntries;
        const filteredEntries = this.unorderedEntries.filter((e)=>e.time >= (start ?? 0) && e.time <= (stop ?? performance.now()));
        const sortedEntries = filteredEntries.sort((a, b)=>a.time - b.time);
        this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
        return sortedEntries;
    }
    clear() {
        this.unorderedEntries = [];
        this.sortedEntriesCache.clear();
    }
}

});

parcelRegister("5bpMv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e79b3709d59899f$export$2e2bcd8739ae039);
const $9e79b3709d59899f$var$nameCache = new WeakMap();
function $9e79b3709d59899f$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) {
        let elementInstance = 'Unknown';
        // Types of elements according to LLM
        if (element instanceof Text) elementInstance = 'Text';
        else if (element instanceof DocumentFragment) elementInstance = 'DocumentFragment';
        else if (element instanceof Document) elementInstance = 'Document';
        else if (element instanceof Comment) elementInstance = 'Comment';
        else if (element instanceof ProcessingInstruction) elementInstance = 'ProcessingInstruction';
        else if (element instanceof Attr) elementInstance = 'Attr';
        else if (element instanceof CDATASection) elementInstance = 'CDATASection';
        if (element.parentElement && element.parentElement instanceof HTMLElement) {
            const parentElementSelector = $9e79b3709d59899f$var$getElementName(selectorConfig, element.parentElement);
            return `${parentElementSelector} > ${elementInstance}`;
        } else return elementInstance;
    }
    const cachedName = $9e79b3709d59899f$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    const tagName = element.localName;
    const encodeValue = (s)=>{
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch  {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    const getAttributeSelector = (attributeName, prefix = '')=>{
        if (element && typeof element.getAttribute !== 'function') return '';
        const attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        const encondedAttrValue = encodeValue(attrValue);
        return `${prefix}[${attributeName}="${encondedAttrValue}"]`;
    };
    // Construct the data-vc attribute selector if specified in the config.
    const dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    const id = selectorConfig.id && element.id ? `#${encodeValue(element.id)}` : '';
    // Construct the test ID selector if specified in the config.
    const testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    const role = selectorConfig.role ? getAttributeSelector('role') : '';
    const classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    const classList = selectorConfig.className && classNames ? `.${classNames}` : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    const primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    const attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        const parentName = element.parentElement ? $9e79b3709d59899f$var$getElementName(selectorConfig, element.parentElement) : 'unknown';
        return `${parentName} > ${tagName}`;
    }
    // Return the final constructed name: tagName + attributes or classList.
    const name = `${tagName}${attributes || classList}`;
    $9e79b3709d59899f$var$nameCache.set(element, name);
    return name;
}
var $9e79b3709d59899f$export$2e2bcd8739ae039 = $9e79b3709d59899f$var$getElementName;

});

parcelRegister("lYAaG", function(module, exports) {
$parcel$export(module.exports, "default", () => $6224feb15204bf76$export$2e2bcd8739ae039);

var $2aEiL = parcelRequire("2aEiL");

var $hMXHM = parcelRequire("hMXHM");

var $gvFOW = parcelRequire("gvFOW");

var $3AS1h = parcelRequire("3AS1h");

var $42aJX = parcelRequire("42aJX");

var $jAsDj = parcelRequire("jAsDj");
const $6224feb15204bf76$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $6224feb15204bf76$var$REVISION_NO = 'fy25.03';
const $6224feb15204bf76$var$getConsideredEntryTypes = (include3p, excludeSmartAnswersInSearch)=>{
    const entryTypes = [
        'mutation:child-element',
        'mutation:element',
        'mutation:attribute',
        'layout-shift',
        'layout-shift:same-rect',
        'window:event'
    ];
    // Only include third-party elements in TTVC calculation when explicitly requested.
    // GenAI elements intentionally remain excluded from core TTVC; a server-side metric variant
    // can derive "including GenAI" from the emitted metricWindows payload.
    if (include3p) {
        entryTypes.push('mutation:third-party-element');
        entryTypes.push('mutation:third-party-attribute');
    }
    if (!excludeSmartAnswersInSearch) {
        entryTypes.push('mutation:smart-answers-element');
        entryTypes.push('mutation:smart-answers-attribute');
    }
    entryTypes.push('mutation:media');
    // Still included as part of TTVC v3
    entryTypes.push('mutation:attribute:non-visual-input-name');
    return entryTypes;
};
class $6224feb15204bf76$export$2e2bcd8739ae039 extends (0, $3AS1h.default) {
    constructor(revisionNo){
        super(revisionNo ?? $6224feb15204bf76$var$REVISION_NO);
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        if (!$6224feb15204bf76$var$getConsideredEntryTypes(include3p, excludeSmartAnswersInSearch).includes(entry.data.type)) return false;
        if (entry.data.type === 'mutation:attribute:framework-routing') return false;
        if (entry.data.type === 'mutation:media' && (0, $2aEiL.fg)('media-perf-uplift-mutation-fix')) {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (attributeName && (/data-(test|file|context)-\S+/g.test(attributeName) || attributeName === 'data-cursor' || attributeName === 'alt' || (attributeName === 'localid' || attributeName === 'contenteditable' || attributeName === 'anchor-name') && (0, $hMXHM.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false))) return false;
            // special case for style attribute to ignore only anchor-name changes
            if ((0, $hMXHM.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false)) {
                if ((0, $gvFOW.containsAnchorNameMutationInStyle)({
                    attributeName: entryData.attributeName,
                    oldValue: entryData.oldValue,
                    newValue: entryData.newValue
                })) return false;
            }
        }
        if (entry.data.type === 'mutation:attribute') {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (!attributeName || (0, $42aJX.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName)) return false;
            if (attributeName.startsWith('data-test') || (0, $42aJX.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || (0, $42aJX.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES).includes(attributeName) || (0, $42aJX.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES).includes(attributeName)) return false;
            return true;
        }
        if ((0, $jAsDj.default)(entry.data) && !entry.data.visible) return false;
        return true;
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($6224feb15204bf76$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
}

});
parcelRegister("hMXHM", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $98e60058c9a3b960$export$9db1624a8af791a4);

var $4d1Vr = parcelRequire("4d1Vr");

var $9S99b = parcelRequire("9S99b");
const $98e60058c9a3b960$export$9db1624a8af791a4 = (experimentName, experimentParam, defaultValue)=>{
    // If client is not initialized, we return the default value
    if (!(0, $4d1Vr.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $4d1Vr.default).getExperimentValue(experimentName, experimentParam, defaultValue);
    (0, $9S99b.addFeatureFlagAccessed)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue;
};

});

parcelRegister("gvFOW", function(module, exports) {
$parcel$export(module.exports, "containsAnchorNameMutationInStyle", () => $67c9c5a8365cbb9b$export$f83f33200c1a234e);
$parcel$export(module.exports, "default", () => $67c9c5a8365cbb9b$export$2e2bcd8739ae039);

var $2aEiL = parcelRequire("2aEiL");
/**
 * Matches only the editor drag and drop anchors. This is the pre-gate behaviour.
 */ const $67c9c5a8365cbb9b$var$isDnDAnchorNameDeclaration = (declaration)=>{
    return declaration.startsWith('anchor-name: --node-anchor');
};
/**
 * Matches any `anchor-name` declaration.
 *
 * `anchor-name` (CSS Anchor Positioning) only names an element so that _other_
 * elements can position themselves against it. It never changes how the named
 * element itself renders, so adding or removing it is never a visual change.
 *
 * `@atlaskit/top-layer` writes `anchor-name` onto a popover's trigger as soon as
 * the popover host element exists, which for `Popover`-based consumers is first
 * open (for example, hovering an `@atlaskit/tooltip` trigger). Without this
 * exclusion that write is recorded as a repaint of the trigger at hover time,
 * which shifts TTVC in sessions where a user hovers a trigger before the page
 * has settled. See COPPER-1736.
 */ const $67c9c5a8365cbb9b$var$isAnyAnchorNameDeclaration = (declaration)=>{
    return declaration.startsWith('anchor-name:');
};
const $67c9c5a8365cbb9b$var$parseStyleSet = (style)=>{
    if (!style) return null;
    const set = new Set();
    for (const part of style.split(';')){
        const t = part.trim();
        if (t) set.add(t);
    }
    return set;
};
/**
 * Checks if a mutation record represents a `style` change that consists only
 * of `anchor-name` declarations being added or removed.
 *
 * Without `platform_ufo_exclude_anchor_name_from_ttvc` this is limited to the
 * editor's drag and drop anchors (`--node-anchor…`), which is where the check
 * originated. With the gate on, every `anchor-name` is treated as non-visual,
 * because the property never affects the rendering of the element it is set on.
 *
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is an anchor-name-only style mutation
 */ function $67c9c5a8365cbb9b$export$7a0b59cebcbf44ec({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (!(target instanceof Element)) return false;
    return $67c9c5a8365cbb9b$export$f83f33200c1a234e({
        attributeName: attributeName,
        oldValue: oldValue,
        newValue: newValue
    });
}
function $67c9c5a8365cbb9b$export$f83f33200c1a234e({ attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (attributeName !== 'style') return false;
    // Resolved once per mutation rather than once per declaration: this runs
    // inside the MutationObserver callback.
    const isIgnoredDeclaration = (0, $2aEiL.fg)('platform_ufo_exclude_anchor_name_from_ttvc') ? $67c9c5a8365cbb9b$var$isAnyAnchorNameDeclaration : $67c9c5a8365cbb9b$var$isDnDAnchorNameDeclaration;
    const oldStyles = $67c9c5a8365cbb9b$var$parseStyleSet(oldValue);
    const newStyles = $67c9c5a8365cbb9b$var$parseStyleSet(newValue);
    let isAnchorNameMutation = false;
    for (const s of oldStyles ?? [])if (!newStyles?.has(s)) {
        if (!isIgnoredDeclaration(s)) return false;
        isAnchorNameMutation = true;
    }
    for (const s of newStyles ?? [])if (!oldStyles?.has(s)) {
        if (!isIgnoredDeclaration(s)) return false;
        isAnchorNameMutation = true;
    }
    return isAnchorNameMutation;
}
var $67c9c5a8365cbb9b$export$2e2bcd8739ae039 = $67c9c5a8365cbb9b$export$7a0b59cebcbf44ec;

});

parcelRegister("3AS1h", function(module, exports) {
$parcel$export(module.exports, "default", () => $79980d3adfe56d7b$export$2e2bcd8739ae039);

var $c2PID = parcelRequire("c2PID");

var $kiSKw = parcelRequire("kiSKw");

var $5Zpwf = parcelRequire("5Zpwf");

var $eMj7K = parcelRequire("eMj7K");

var $jAsDj = parcelRequire("jAsDj");
// Helper function for reporting ratios
function $79980d3adfe56d7b$var$roundDecimal(value, decimals = 3) {
    const factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
}
class $79980d3adfe56d7b$export$2e2bcd8739ae039 {
    revisionNo;
    constructor(revisionNo){
        this.revisionNo = revisionNo;
    }
    filterViewportEntries(entries) {
        return entries.filter((entry)=>{
            return 'rect' in entry.data;
        });
    }
    /**
   * Calculate ratios for each element based on their viewport coverage.
   */ calculateRatios(filteredEntries) {
        const ratios = {};
        const viewportWidth = (0, $eMj7K.default)();
        const viewportHeight = (0, $5Zpwf.default)();
        const totalViewportArea = viewportWidth * viewportHeight;
        if (totalViewportArea === 0) return ratios;
        const elementRects = new Map();
        for (const entry of filteredEntries)if ('rect' in entry.data) {
            const viewportEntry = entry.data;
            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
        }
        for (const [elementName, rect] of elementRects){
            const elementArea = rect.width * rect.height;
            ratios[elementName] = $79980d3adfe56d7b$var$roundDecimal(elementArea / totalViewportArea);
        }
        return ratios;
    }
    getLabelStacks(filteredEntries, isPostInteraction) {
        const labelStacks = {};
        for (const entry of filteredEntries)if ((0, $jAsDj.default)(entry.data) && entry.data.labelStacks) {
            if (isPostInteraction) labelStacks[entry.data.elementName] = {
                segment: entry.data.labelStacks.segment,
                labelStack: entry.data.labelStacks.labelStack
            };
            else labelStacks[entry.data.elementName] = entry.data.labelStacks.labelStack;
        }
        return labelStacks;
    }
    async calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, allEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders) {
        const percentiles = [
            25,
            50,
            75,
            80,
            85,
            90,
            95,
            98,
            99,
            100
        ];
        const viewportEntries = this.filterViewportEntries(filteredEntries);
        const { entries: vcLogs, speedIndex: speedIndex } = await (0, $c2PID.calculateTTVCPercentilesWithDebugInfo)({
            viewport: {
                width: (0, $eMj7K.default)(),
                height: (0, $5Zpwf.default)()
            },
            startTime: startTime,
            stopTime: stopTime,
            orderedEntries: viewportEntries
        });
        const vcDetails = {};
        let percentileIndex = 0;
        const entryDataBuffer = new Set();
        let ssrRatio = -1;
        let layoutShiftInsights = null;
        let previousViewportPercentage = 0;
        if (vcLogs) for (const entry of vcLogs){
            const { time: time, viewportPercentage: viewportPercentage, entries: entries } = entry;
            if (includeSSRRatio && ssrRatio === -1 && entries.some((e)=>e.elementName === 'SSR')) ssrRatio = viewportPercentage;
            // Only process entries if we haven't reached all percentiles
            if (percentileIndex >= percentiles.length) break;
            // Check if this entry matches any checkpoint percentiles
            if (viewportPercentage >= percentiles[percentileIndex]) {
                const elementNames = [
                    ...new Set(entries.map((e)=>e.elementName))
                ];
                // Process all matching percentiles in one go
                while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                    vcDetails[`${percentiles[percentileIndex]}`] = {
                        t: Math.round(time),
                        e: elementNames
                    };
                    if (reportLayoutShiftOffenders && percentiles[percentileIndex] === 90 && entries.some((e)=>e.type === 'layout-shift')) {
                        const layoutShiftEntries = entries.filter((e)=>e.type === 'layout-shift');
                        layoutShiftInsights = {
                            layoutShiftOffendersResult: (0, $kiSKw.detectLayoutShiftCause)({
                                viewportEntries: viewportEntries,
                                layoutShiftEntries: layoutShiftEntries,
                                time: time,
                                startTime: startTime
                            }),
                            layoutShiftEntriesCount: layoutShiftEntries.length,
                            layoutShiftImpact: viewportPercentage - previousViewportPercentage
                        };
                    }
                    percentileIndex++;
                }
                // Clear buffer after processing all matching percentiles
                entryDataBuffer.clear();
            } else // Only add to buffer if we haven't reached all percentiles
            entries.forEach((e)=>entryDataBuffer.add(e));
            previousViewportPercentage = viewportPercentage;
        }
        // Fill in any missing percentiles with the last known values
        let previousResult = {
            t: 0,
            e: []
        };
        for(let i = 0; i < percentiles.length; i++){
            const percentile = percentiles[i];
            if (!(percentile in vcDetails)) vcDetails[`${percentile}`] = previousResult;
            else previousResult = vcDetails[`${percentile}`];
        }
        let enhancedVcLogs = vcLogs ? vcLogs.map((log)=>({
                ...log,
                entries: log.entries.map((entry)=>({
                        ...entry,
                        rect: entry.rect?.toJSON(),
                        previousRect: entry.previousRect?.toJSON()
                    })),
                viewportPercentage: log.viewportPercentage
            })) : [];
        // If 3p metric enabled - calculate the debug details
        const shouldCalculate3p = include3p;
        // Only calculate enhanced debug details if devtool callbacks exist
        const shouldCalculateDebugDetails = !isPostInteraction && (typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window?.__on_ufo_vc_debug_data_ready === 'function' || typeof window?.__ufo_devtool_vc_3p_debug_data === 'function');
        if (shouldCalculateDebugDetails && allEntries && vcLogs) {
            // Pre-sort vcLogs by time for efficient lookups
            const sortedVcLogs = [
                ...vcLogs
            ].sort((a, b)=>a.time - b.time);
            // Pre-calculate max viewport percentage up to each time for efficient lookups
            const maxViewportPercentageAtTime = new Map();
            let maxSoFar = 0;
            for (const log of sortedVcLogs)if (log.viewportPercentage !== null) {
                maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                maxViewportPercentageAtTime.set(log.time, maxSoFar);
            }
            // Helper function to find the biggest previous viewport percentage
            const getBiggestPreviousViewportPercentage = (targetTime)=>{
                // Binary search for the largest time <= targetTime
                let left = 0;
                let right = sortedVcLogs.length - 1;
                let result = -1;
                while(left <= right){
                    const mid = Math.floor((left + right) / 2);
                    if (sortedVcLogs[mid].time <= targetTime) {
                        result = mid;
                        left = mid + 1;
                    } else right = mid - 1;
                }
                return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
            };
            // Group ignored entries by timestamp
            const ignoredEntriesByTime = new Map();
            for (const entry of allEntries)if ('rect' in entry.data && !this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch)) {
                const viewportData = entry.data;
                const timestamp = Math.round(entry.time);
                if (!ignoredEntriesByTime.has(timestamp)) ignoredEntriesByTime.set(timestamp, []);
                ignoredEntriesByTime.get(timestamp)?.push({
                    ...viewportData,
                    rect: viewportData.rect?.toJSON(),
                    previousRect: viewportData.previousRect?.toJSON(),
                    ignoreReason: viewportData.visible ? viewportData.type : 'not-visible'
                });
            }
            // Add ignored entries to vcLogs
            const additionalVcLogs = [];
            for (const [timestamp, ignoredEntries] of ignoredEntriesByTime)if (ignoredEntries.length > 0) {
                const viewportPercentage = getBiggestPreviousViewportPercentage(timestamp);
                additionalVcLogs.push({
                    time: timestamp,
                    viewportPercentage: viewportPercentage,
                    entries: ignoredEntries
                });
            }
            // Combine and sort all vcLogs
            enhancedVcLogs = [
                ...enhancedVcLogs,
                ...additionalVcLogs
            ].sort((a, b)=>a.time - b.time);
        }
        // Only create debug details if callbacks exist
        let v3RevisionDebugDetails = null;
        if (shouldCalculateDebugDetails) v3RevisionDebugDetails = {
            revision: this.revisionNo,
            isClean: isVCClean && !interactionAbortReason && isPageVisible,
            abortReason: !isPageVisible ? 'browser_backgrounded' : dirtyReason ?? interactionAbortReason,
            vcLogs: enhancedVcLogs,
            interactionId: interactionId,
            interactionType: interactionType
        };
        // Handle devtool callback
        if (v3RevisionDebugDetails && typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' && !include3p) try {
            window?.__ufo_devtool_onVCRevisionReady__?.(v3RevisionDebugDetails);
        } catch (e) {
            // if any error communicating with devtool, we don't want to break the app
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && typeof window?.__on_ufo_vc_debug_data_ready === 'function' && !include3p) try {
            window?.__on_ufo_vc_debug_data_ready?.(v3RevisionDebugDetails);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && shouldCalculate3p) try {
            // Log vc details with 3p for debugging
            window.__ufo_devtool_vc_3p_debug_data = v3RevisionDebugDetails;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in 3pDebugData', e);
        }
        return {
            vcDetails: vcDetails,
            ssrRatio: ssrRatio,
            speedIndex: speedIndex,
            VC90layoutShiftInsights: layoutShiftInsights
        };
    }
    async calculate({ startTime: startTime, stopTime: stopTime, orderedEntries: orderedEntries, interactionId: interactionId, isPostInteraction: isPostInteraction, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, interactionType: interactionType, isPageVisible: isPageVisible, interactionAbortReason: interactionAbortReason, reportLayoutShiftOffenders: reportLayoutShiftOffenders }) {
        const filteredEntries = orderedEntries.filter((entry)=>{
            return this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        });
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isVCClean) return {
            revision: this.revisionNo,
            'metric:vc90': null,
            clean: false,
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp
        };
        const { vcDetails: vcDetails, ssrRatio: ssrRatio, speedIndex: speedIndex, VC90layoutShiftInsights: VC90layoutShiftInsights } = await this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, orderedEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders);
        let layoutShiftInsightsPayload;
        if (VC90layoutShiftInsights !== null && reportLayoutShiftOffenders) {
            const { layoutShiftOffendersResult: layoutShiftOffendersResult, layoutShiftEntriesCount: layoutShiftEntriesCount, layoutShiftImpact: layoutShiftImpact } = VC90layoutShiftInsights;
            layoutShiftInsightsPayload = {
                impact: layoutShiftImpact,
                sources: layoutShiftEntriesCount ?? 0,
                same: {
                    dir: layoutShiftOffendersResult?.layoutShiftVariables.allMovedSameWay ?? false,
                    dist: layoutShiftOffendersResult?.layoutShiftVariables.allMovedSameAmount ?? false
                },
                total_mut: layoutShiftOffendersResult?.layoutShiftOffenders.length ?? 0,
                mut: layoutShiftOffendersResult?.layoutShiftOffenders.sort((a, b)=>Math.abs(a.distanceToLS) - Math.abs(b.distanceToLS)).slice(0, 5).map((offender)=>({
                        e: offender.offender,
                        size: -1,
                        // @todo: calculate size
                        attr: {
                            t_before: offender.happenedBefore,
                            t_distance: offender.distanceToLS,
                            p_above: offender.isAbove,
                            p_left: offender.isLeft,
                            p_right: offender.isRight,
                            p_h_overlap: offender.hasHorizontalOverlap,
                            p_v_overlap: offender.hasVerticalOverlap,
                            p_same_offset: offender.matchesLayoutShiftDelta ? 'all' : 'none'
                        }
                    }))
            };
        }
        const result = {
            revision: this.revisionNo,
            clean: true,
            'metric:vc90': vcDetails?.['90']?.t ?? null,
            vcDetails: vcDetails ?? undefined,
            'vc90:ls': layoutShiftInsightsPayload ?? undefined
        };
        result.ratios = this.calculateRatios(filteredEntries);
        if (ssrRatio !== -1) result.ssrRatio = ssrRatio;
        // speedIndex is only included in the result when it has a meaningful value (> 0)
        if (speedIndex > 0) result.speedIndex = speedIndex;
        result.labelStacks = this.getLabelStacks(filteredEntries, isPostInteraction);
        return result;
    }
}

});
parcelRegister("c2PID", function(module, exports) {
$parcel$export(module.exports, "calculateTTVCPercentilesWithDebugInfo", () => $e145ff91963f0f10$export$96ea73435089b05a);

var $2aEiL = parcelRequire("2aEiL");

var $gk8I4 = parcelRequire("gk8I4");

var $7qjfe = parcelRequire("7qjfe");

var $bq3eO = parcelRequire("bq3eO");
async function $e145ff91963f0f10$var$calculateTTVCPercentiles({ viewport: viewport, orderedEntries: orderedEntries, percentiles: percentiles, startTime: startTime }) {
    const canvas = new (0, $bq3eO.ViewportCanvas)(viewport, (0, $2aEiL.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        const elementName = entry.data.elementName;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
        elementMap.get(entry.time).add(elementName);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimenstions = canvas.getScaledDimensions();
    const totalPixels = canvasDimenstions.width * canvasDimenstions.height;
    return (0, $gk8I4.calculatePercentiles)(timePixelCounts, elementMap, percentiles, totalPixels, startTime);
}
async function $e145ff91963f0f10$export$96ea73435089b05a({ viewport: viewport, orderedEntries: orderedEntries, startTime: startTime }) {
    const canvas = new (0, $bq3eO.ViewportCanvas)(viewport, (0, $2aEiL.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
        elementMap.get(entry.time).push(entry.data);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimensions = canvas.getScaledDimensions();
    const totalPixels = canvasDimensions.width * canvasDimensions.height;
    return (0, $7qjfe.calculatePercentilesWithDebugInfo)(timePixelCounts, elementMap, totalPixels, startTime);
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$e145ff91963f0f10$export$2e2bcd8739ae039 = $e145ff91963f0f10$var$calculateTTVCPercentiles;

});
parcelRegister("gk8I4", function(module, exports) {
$parcel$export(module.exports, "calculatePercentiles", () => $3cd45cb14b9dc981$export$89c8da9b65eff678);
function $3cd45cb14b9dc981$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    const results = {};
    let cumulativePixels = 0;
    const percentiles = unorderedPercentiles.sort((a, b)=>a - b);
    // Sort entries by timestamp for consistent processing
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    let percentileIndex = 0;
    let domElementsBuffer = new Set();
    for (const [time, pixelCount] of sortedEntries){
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const elementNames = elementMap.get(time) || new Set();
        elementNames.forEach((elName)=>domElementsBuffer.add(elName));
        let matchesAnyCheckpoints = false;
        while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
            results[`${percentiles[percentileIndex]}`] = {
                t: Math.round(Number(time - startTime)),
                e: Array.from(domElementsBuffer)
            };
            percentileIndex++;
            matchesAnyCheckpoints = true;
        }
        if (matchesAnyCheckpoints) domElementsBuffer.clear();
        if (percentileIndex >= percentiles.length) break;
    }
    let previousResult = {
        t: 0,
        e: []
    };
    for(let i = 0; i < percentiles.length; i++){
        const percentile = percentiles[i];
        if (!(percentile in results)) results[`${percentile}`] = previousResult;
        previousResult = results[`${percentile}`];
    }
    return results;
}

});

parcelRegister("7qjfe", function(module, exports) {
$parcel$export(module.exports, "calculatePercentilesWithDebugInfo", () => $96ccfca432aa1b99$export$a532ce01ea38d882);
function $96ccfca432aa1b99$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime) {
    const entries = new Array(elementMap.size);
    let cumulativePixels = 0;
    let speedIndex = 0;
    let previousPercentCovered = 0;
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    for(let i = 0; i < sortedEntries.length; i++){
        const [time, pixelCount] = sortedEntries[i];
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const entryDatas = elementMap.get(time) || [];
        const relativeTime = Math.round(Number(time - startTime));
        entries[i] = {
            time: relativeTime,
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
        // Speed index calculation: sum of (time × incremental viewport percentage)
        const ratioDelta = (percentCovered - previousPercentCovered) / 100;
        speedIndex += relativeTime * ratioDelta;
        previousPercentCovered = percentCovered;
    }
    return {
        entries: entries,
        speedIndex: Math.round(speedIndex)
    };
}

});

parcelRegister("bq3eO", function(module, exports) {
$parcel$export(module.exports, "ViewportCanvas", () => $d33bd737e8584b0d$export$3e59ac9de7402fb1);

var $5k3Vs = parcelRequire("5k3Vs");

var $hh7ZM = parcelRequire("hh7ZM");
class $d33bd737e8584b0d$export$3e59ac9de7402fb1 {
    /** The underlying Canvas instance (either OffscreenCanvas or HTMLCanvasElement) */ canvas;
    /** The 2D rendering context of the canvas */ ctx;
    /** Scale factor applied to the canvas (affects final pixel counts) */ scaleFactor;
    /** Maps unique colors to their corresponding timestamps */ colorTimeMap;
    /** Counter used to generate unique colors */ colorCounter;
    scaledWidth;
    scaledHeight;
    scaleX;
    scaleY;
    /**
   * Creates a new ViewportCanvas instance.
   * @param viewport - The dimensions of the viewport
   * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
   * @throws {Error} If canvas context cannot be obtained
   */ constructor(viewport, scaleFactor = 1){
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        const safeViewportWidth = Math.max(viewport.width, 1);
        const safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        const ctx = this.canvas.getContext('2d', {
            alpha: false,
            // Disable alpha channel for better performance
            willReadFrequently: true,
            // Optimize for frequent pixel reading
            colorSpace: 'srgb' // Use standard RGB color space
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
    /**
   * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
   */ createCanvas(width, height) {
        if (typeof OffscreenCanvas !== 'undefined') return new OffscreenCanvas(width, height);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    getScaledDimensions() {
        return {
            width: this.scaledWidth,
            height: this.scaledHeight
        };
    }
    /**
   * Clears the entire canvas by removing all drawn content.
   * @private
   */ clear() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    /**
   * Generates a unique RGB color from an incrementing counter.
   * Uses a 24-bit color space (16,777,216 possible colors).
   *
   * @private
   * @returns A unique RGB color string
   *
   * @example
   * // Example bit operations for color 0x00FF8040:
   * // Red:   (0x00FF8040 >> 16) & 0xFF = 0xFF = 255
   * // Green: (0x00FF8040 >> 8) & 0xFF  = 0x80 = 128
   * // Blue:   0x00FF8040 & 0xFF        = 0x40 = 64
   */ generateColor() {
        // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
        const rgbColor = this.colorCounter++ % 0x00ffffff;
        return (0, $hh7ZM.getRGBComponents)(rgbColor);
    }
    /**
   * Draws a rectangle on the canvas with a unique color and associates it with a timestamp.
   * Each drawn rectangle gets a unique color which is mapped to the provided timestamp.
   *
   * @param rect - The rectangle dimensions to draw
   * @param timestamp - The timestamp to associate with this drawing operation
   */ drawRect(rect, timestamp) {
        const color = this.generateColor();
        this.colorTimeMap.set(color, timestamp);
        this.ctx.fillStyle = color;
        if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
        const scaledX = rect.x * this.scaleX;
        const scaledY = rect.y * this.scaleY;
        const scaledWidth = rect.width * this.scaleX;
        const scaledHeight = rect.height * this.scaleY;
        this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
    }
    /**
   * Calculates the number of pixels drawn for each timestamp.
   * This method:
   * 1. Reads the pixel data from the canvas
   * 2. Counts pixels of each unique color
   * 3. Maps colors back to their timestamps
   * 4. Adjusts counts based on the scale factor
   *
   * @returns A Map containing timestamp to pixel count mappings
   */ async getPixelCounts() {
        const imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        const timestampsAmount = this.colorTimeMap.size;
        const pixelCounts = await (0, $5k3Vs.calculateDrawnPixelsRaw)(imageData, this.scaleFactor, timestampsAmount);
        // Convert color counts to timestamp counts
        const timePixelCounts = new Map();
        for(let i = 0; i < pixelCounts.length; i++){
            const count = pixelCounts[i];
            if (typeof count !== 'number') continue;
            const color = i + 1;
            const rgbColor = (0, $hh7ZM.getRGBComponents)(color);
            const timestamp = this.colorTimeMap.get(rgbColor);
            if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
        }
        return timePixelCounts;
    }
}

});
parcelRegister("5k3Vs", function(module, exports) {
$parcel$export(module.exports, "calculateDrawnPixelsRaw", () => $d707d049fc8f8ae3$export$fafc9be44839f9c8);

var $fGlUY = parcelRequire("fGlUY");
async function $d707d049fc8f8ae3$export$fafc9be44839f9c8(imageData, _, arraySize) {
    const data = imageData.data;
    const arr = new Uint32Array(arraySize);
    for(let i = 0; i < data.length; i += 4){
        // Check alpha
        if (data[i + 3] !== 0) {
            // Combine RGB components into a single 24-bit color value:
            // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
            // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
            // data[i + 2]       - Blue component stays as is         (bits 0-7)
            // The | operator combines all bits together
            const color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
            const colorIndex = color - 1;
            arr[colorIndex] = (arr[colorIndex] || 0) + 1;
        }
        if (i % 10000 === 0) await (0, $fGlUY.default)();
    }
    return arr;
}

});
parcelRegister("fGlUY", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd169abf8d6db57d$export$2e2bcd8739ae039);
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
async function $dd169abf8d6db57d$var$taskYield() {
    // This is using globalThis to allow the yield task to be used outside of a browser env
    if ('scheduler' in globalThis && // @ts-ignore
    'yield' in globalThis.scheduler) {
        // @ts-ignore
        await scheduler.yield();
        return;
    }
    let resolve = ()=>{};
    const p = new Promise((a)=>{
        resolve = a;
    });
    setTimeout(resolve, 0);
    await p;
}
var $dd169abf8d6db57d$export$2e2bcd8739ae039 = $dd169abf8d6db57d$var$taskYield;

});


parcelRegister("hh7ZM", function(module, exports) {
$parcel$export(module.exports, "getRGBComponents", () => $93fe64b514ae97ac$export$54591583ed0b20ce);
function $93fe64b514ae97ac$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    const blue = n & 0xff;
    // Extract green component (bits 8-15)
    const green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    const red = n >> 16 & 0xff;
    return `rgb(${red}, ${green}, ${blue})`;
}

});



parcelRegister("kiSKw", function(module, exports) {
$parcel$export(module.exports, "detectLayoutShiftCause", () => $84db84fe1421f4bc$export$93ce39b765ea2cd3);
const $84db84fe1421f4bc$var$calculateOffenderState = (current, matchesCurrentEntry)=>{
    // Once we know it's mixed across entries, we can short-circuit.
    if (current === 'some') return 'some';
    const entryState = matchesCurrentEntry ? 'all' : 'none';
    if (current == null) return entryState;
    // If the state flips between entries (all <-> none), it's "some".
    if (current !== entryState) return 'some';
    return current;
};
const $84db84fe1421f4bc$var$calculateLayoutShiftMovement = (layoutShiftEntries)=>{
    const movements = layoutShiftEntries.map((lsEntry)=>{
        const rect = lsEntry.rect;
        const previousRect = lsEntry.previousRect;
        if (!rect || !previousRect) return null;
        const dx = rect.x - previousRect.x;
        const dy = rect.y - previousRect.y;
        return {
            dx: dx,
            dy: dy,
            movedX: dx !== 0,
            movedY: dy !== 0,
            dirX: Math.sign(dx),
            dirY: Math.sign(dy),
            absDx: Math.abs(dx),
            absDy: Math.abs(dy)
        };
    });
    const hasMovement = (m)=>m !== null;
    const validMovements = movements.filter(hasMovement);
    const allHaveRects = layoutShiftEntries.length > 0 && validMovements.length === layoutShiftEntries.length;
    if (!allHaveRects) return {
        allHaveRects: allHaveRects,
        allMovedSameWay: false,
        allMovedSameAmount: false
    };
    const first = validMovements[0];
    const allMovedSameWay = validMovements.every((m)=>m.movedX === first.movedX && m.movedY === first.movedY && m.dirX === first.dirX && m.dirY === first.dirY);
    const allMovedSameAmount = allMovedSameWay && validMovements.every((m)=>m.absDx === first.absDx && m.absDy === first.absDy);
    return {
        allHaveRects: allHaveRects,
        allMovedSameWay: allMovedSameWay,
        allMovedSameAmount: allMovedSameAmount,
        deltaX: first.dx,
        deltaY: first.dy
    };
};
const $84db84fe1421f4bc$export$93ce39b765ea2cd3 = ({ viewportEntries: viewportEntries, layoutShiftEntries: layoutShiftEntries, time: time, startTime: startTime, offenderWindowMs: offenderWindowMs = 250 })=>{
    const checkpointTimestamp = startTime + time;
    const filteredLSPotentialOffenders = viewportEntries.filter((viewportEntry)=>(viewportEntry.time < checkpointTimestamp && viewportEntry.time > checkpointTimestamp - offenderWindowMs || viewportEntry.time > checkpointTimestamp && viewportEntry.time < checkpointTimestamp + offenderWindowMs) && viewportEntry.data.type !== 'layout-shift');
    // Summarize whether all layout-shift entries moved in a consistent direction and by the same amount.
    const layoutShiftVariables = $84db84fe1421f4bc$var$calculateLayoutShiftMovement(layoutShiftEntries);
    // Classify each offender against *all* layout-shift entries when the layout shift is consistently moving in a
    // single axis (pure X or pure Y) so we can reason about whether an offender could have caused the movement.
    const layoutShiftOffenders = filteredLSPotentialOffenders.reduce((acc, offender)=>{
        const offenderData = offender.data;
        const offenderRect = offenderData.rect;
        if (!offenderRect) return acc;
        const offenderTimestamp = offenderData.originalMutationTimestamp ?? offender.time;
        const happenedBefore = offenderTimestamp <= checkpointTimestamp;
        const offenderLeft = offenderRect.x;
        const offenderRight = offenderRect.x + offenderRect.width;
        const offenderTop = offenderRect.y;
        const offenderBottom = offenderRect.y + offenderRect.height;
        const shouldClassifyAgainstAllEntries = layoutShiftVariables.allMovedSameWay && 'deltaX' in layoutShiftVariables && 'deltaY' in layoutShiftVariables && layoutShiftVariables.deltaX === 0 !== (layoutShiftVariables.deltaY === 0);
        let isAbove = null;
        let isLeft = null;
        let isRight = null;
        let hasHorizontalOverlap = null;
        let hasVerticalOverlap = null;
        if (shouldClassifyAgainstAllEntries) for (const lsEntry of layoutShiftEntries){
            const lsRect = lsEntry.rect;
            if (!lsRect) continue;
            const lsLeft = lsRect.x;
            const lsRight = lsRect.x + lsRect.width;
            const lsTop = lsRect.y;
            const lsBottom = lsRect.y + lsRect.height;
            isAbove = $84db84fe1421f4bc$var$calculateOffenderState(isAbove, offenderBottom <= lsTop);
            isLeft = $84db84fe1421f4bc$var$calculateOffenderState(isLeft, offenderRight <= lsLeft);
            isRight = $84db84fe1421f4bc$var$calculateOffenderState(isRight, offenderLeft >= lsRight);
            hasHorizontalOverlap = $84db84fe1421f4bc$var$calculateOffenderState(hasHorizontalOverlap, offenderLeft < lsRight && offenderRight > lsLeft);
            hasVerticalOverlap = $84db84fe1421f4bc$var$calculateOffenderState(hasVerticalOverlap, offenderTop < lsBottom && offenderBottom > lsTop);
        }
        let matchesLayoutShiftDelta = false;
        if (shouldClassifyAgainstAllEntries && layoutShiftVariables.allMovedSameAmount && offenderData.previousRect) {
            const dx = offenderRect.x - offenderData.previousRect.x;
            const dy = offenderRect.y - offenderData.previousRect.y;
            const isPureX = layoutShiftVariables.deltaX !== 0 && layoutShiftVariables.deltaY === 0;
            const isPureY = layoutShiftVariables.deltaY !== 0 && layoutShiftVariables.deltaX === 0;
            if (isPureX) matchesLayoutShiftDelta = dx === layoutShiftVariables.deltaX && dy === 0;
            else if (isPureY) matchesLayoutShiftDelta = dy === layoutShiftVariables.deltaY && dx === 0;
        }
        acc.push({
            offender: offenderData.elementName,
            happenedBefore: happenedBefore,
            distanceToLS: Math.round(offenderTimestamp - checkpointTimestamp),
            isAbove: isAbove ?? 'none',
            isLeft: isLeft ?? 'none',
            isRight: isRight ?? 'none',
            hasHorizontalOverlap: hasHorizontalOverlap ?? 'none',
            hasVerticalOverlap: hasVerticalOverlap ?? 'none',
            matchesLayoutShiftDelta: matchesLayoutShiftDelta
        });
        return acc;
    }, []);
    return {
        layoutShiftVariables: layoutShiftVariables,
        layoutShiftOffenders: layoutShiftOffenders
    };
};

});

parcelRegister("5Zpwf", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0e320622c832a63$export$2e2bcd8739ae039);
function $f0e320622c832a63$var$getViewportHeight(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $f0e320622c832a63$export$2e2bcd8739ae039 = $f0e320622c832a63$var$getViewportHeight;

});

parcelRegister("eMj7K", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f429ad1b84541e9$export$2e2bcd8739ae039);
function $6f429ad1b84541e9$var$getViewportWidth(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $6f429ad1b84541e9$export$2e2bcd8739ae039 = $6f429ad1b84541e9$var$getViewportWidth;

});

parcelRegister("jAsDj", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3d2dd7ea7d29ef8$export$2e2bcd8739ae039);
function $c3d2dd7ea7d29ef8$var$isViewportEntryData(data) {
    if (data) {
        const hasElementName = typeof data.elementName === 'string';
        const hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $c3d2dd7ea7d29ef8$export$2e2bcd8739ae039 = $c3d2dd7ea7d29ef8$var$isViewportEntryData;

});


parcelRegister("42aJX", function(module, exports) {
$parcel$export(module.exports, "KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS", () => $24c5458bf663b76d$export$98812f4e79596e2b);
$parcel$export(module.exports, "NON_VISUAL_ARIA_ATTRIBUTES", () => $24c5458bf663b76d$export$44331555a87fcd9e);
$parcel$export(module.exports, "THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES", () => $24c5458bf663b76d$export$c4351da6279bef53);
$parcel$export(module.exports, "MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES", () => $24c5458bf663b76d$export$2492353b2cc31cc0);
$parcel$export(module.exports, "DARK_READER_BROWSER_EXTENSION_ATTRIBUTES", () => $24c5458bf663b76d$export$5a7b359ee5e32a5b);
// TODO: AFO-3523
// Those are the attributes we have found when testing the 'fy25.03' manually.
// We still need to replace this hardcoded list with a proper automation
const $24c5458bf663b76d$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'data-drop-target-for-external',
    'draggable',
    'data-is-observed',
    'data-aui-version',
    'data-testid',
    'data-vc',
    'data-ssr-placeholder',
    'data-ssr-placeholder-replace',
    'data-vc-nvs',
    'data-media-vc-wrapper',
    'data-renderer-start-pos',
    'data-table-local-id',
    'spellcheck',
    'data-auto-scrollable',
    'id',
    'tabindex',
    'data-is-ttvc-ready',
    'contenteditable',
    'data-has-collab-initialised',
    'translate',
    'data-comment-id',
    'data-access-level'
];
const $24c5458bf663b76d$export$44331555a87fcd9e = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-hidden',
    'aria-expanded',
    'aria-controls',
    'aria-selected',
    'aria-checked',
    'aria-disabled',
    'aria-required',
    'aria-current',
    'aria-haspopup',
    'aria-pressed',
    'aria-atomic',
    'aria-live'
];
const $24c5458bf663b76d$export$c4351da6279bef53 = [
    'bis_skin_checked',
    'cz-shortcut-listen',
    'monica-version',
    'data-gr-ext-installed',
    'data-dashlane-rid',
    'sapling-installed',
    'data-gptw',
    // grammarly extensions
    'data-new-gr-c-s-loaded',
    'data-gr-aaa-notch-connection-id',
    'data-gr-aaa-loaded'
];
const $24c5458bf663b76d$export$2492353b2cc31cc0 = [
    'fdprocessedid',
    'data-dashlane-classification'
];
const $24c5458bf663b76d$export$5a7b359ee5e32a5b = [
    // dark reader extension
    'data-darkreader-inline-bgcolor',
    'data-darkreader-inline-bgimage',
    'data-darkreader-inline-border',
    'data-darkreader-inline-border-bottom',
    'data-darkreader-inline-border-left',
    'data-darkreader-inline-border-right',
    'data-darkreader-inline-border-top',
    'data-darkreader-inline-boxshadow',
    'data-darkreader-inline-color',
    'data-darkreader-inline-fill',
    'data-darkreader-inline-stroke',
    'data-darkreader-inline-outline',
    'data-darkreader-inline-stopcolor',
    'data-darkreader-inline-bg',
    'data-darkreader-inline-border-short',
    'data-darkreader-inline-border-bottom-short',
    'data-darkreader-inline-border-left-short',
    'data-darkreader-inline-border-right-short',
    'data-darkreader-inline-border-top-short'
];

});


parcelRegister("1b6ay", function(module, exports) {
$parcel$export(module.exports, "default", () => $a520f259ecab00d1$export$2e2bcd8739ae039);

var $2aEiL = parcelRequire("2aEiL");

var $lYAaG = parcelRequire("lYAaG");

var $42aJX = parcelRequire("42aJX");
const $a520f259ecab00d1$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [
        'mutation:display-contents-children-element'
    ];
    consideredEntryTypes.push('mutation:display-contents-children-attribute');
    return consideredEntryTypes;
};
const $a520f259ecab00d1$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [
        'layout-shift:same-rect',
        'mutation:attribute:non-visual-input-name'
    ];
    return excludedEntryTypes;
};
const $a520f259ecab00d1$var$fy26_04_excluded_attributes = [
    'data-is-hovered' // non-visual attribute
];
class $a520f259ecab00d1$export$2e2bcd8739ae039 extends (0, $lYAaG.default) {
    constructor(revisionNo = 'fy26.04'){
        super(revisionNo);
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const extra_fy26_04_excluded_attributes = [
            'data-fabric-mode'
        ];
        const entryData = entry.data;
        const { attributeName: attributeName } = entryData;
        if (entry.data.type === 'mutation:attribute' && attributeName && extra_fy26_04_excluded_attributes.includes(attributeName)) return false;
        const isEntryIncludedInV3 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV3 && !$a520f259ecab00d1$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        if (entry.data.type === 'mutation:attribute' && (!attributeName || $a520f259ecab00d1$var$fy26_04_excluded_attributes.includes(attributeName) && (0, $2aEiL.fg)('platform_ufo_data-is-hovered-v4-exclusion'))) return false;
        const thirdPartyAttributes = [
            ...(0, $42aJX.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES),
            ...(0, $42aJX.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES),
            ...(0, $42aJX.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES)
        ];
        if (entryData.type === 'mutation:display-contents-children-attribute') {
            if (!attributeName || attributeName.startsWith('data-test') || (0, $42aJX.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName) || (0, $42aJX.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || thirdPartyAttributes.includes(attributeName)) return false;
            return true;
        }
        return $a520f259ecab00d1$var$getConsideredEntryTypes().includes(entry.data.type);
    }
}

});

parcelRegister("142PG", function(module, exports) {
$parcel$export(module.exports, "default", () => $68a6ac0f4f91fa61$export$2e2bcd8739ae039);

var $1b6ay = parcelRequire("1b6ay");
const $68a6ac0f4f91fa61$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize',
    'scroll-container'
];
const $68a6ac0f4f91fa61$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [];
    return consideredEntryTypes;
};
const $68a6ac0f4f91fa61$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [];
    return excludedEntryTypes;
};
class $68a6ac0f4f91fa61$export$2e2bcd8739ae039 extends (0, $1b6ay.default) {
    constructor(){
        super('next');
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const isEntryIncludedInV4 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV4 && !$68a6ac0f4f91fa61$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        return $68a6ac0f4f91fa61$var$getConsideredEntryTypes().includes(entry.data.type);
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($68a6ac0f4f91fa61$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    if (eventType === 'keydown') dirtyReason = 'keypress';
                    else if (eventType === 'scroll-container') dirtyReason = 'scroll';
                    else dirtyReason = eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
}

});

parcelRegister("iEFO6", function(module, exports) {
$parcel$export(module.exports, "default", () => $e056b37ef80a686a$export$2e2bcd8739ae039);

var $5tITM = parcelRequire("5tITM");

var $cGjFC = parcelRequire("cGjFC");

var $5Zpwf = parcelRequire("5Zpwf");

var $eMj7K = parcelRequire("eMj7K");
const $e056b37ef80a686a$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $e056b37ef80a686a$var$MAX_OBSERVATIONS = 200;
const $e056b37ef80a686a$var$encodeRect = (rect)=>[
        Math.round(rect.left * 10) / 10,
        Math.round(rect.top * 10) / 10,
        Math.round(rect.right * 10) / 10,
        Math.round(rect.bottom * 10) / 10
    ];
const $e056b37ef80a686a$var$areRectsEqual = (left, right)=>left.every((value, index)=>value === right[index]);
function $e056b37ef80a686a$var$isWindowEventEntryData(data) {
    return data.type === 'window:event' && 'eventType' in data;
}
class $e056b37ef80a686a$export$2e2bcd8739ae039 {
    revisionNo = 'raw-handler';
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($e056b37ef80a686a$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    async getRawData({ entries: entries, startTime: startTime, stopTime: stopTime, isPageVisible: isPageVisible }) {
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(entries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isPageVisible) return {
            revision: this.revisionNo,
            clean: false,
            'metric:vc90': null,
            abortReason: 'browser_backgrounded',
            abortTimestamp: (0, $cGjFC.getEarliestHiddenTiming)(startTime, stopTime) ?? -1,
            viewport: {
                w: (0, $eMj7K.default)(),
                h: (0, $5Zpwf.default)()
            }
        };
        const viewportEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && entry.data.visible;
        });
        const windowEventEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && $e056b37ef80a686a$var$isWindowEventEntryData(entry.data);
        });
        const targetNameToIdMap = new Map();
        const elementMapEntriesMap = {};
        let nextElementId = 1;
        const typeMap = new Map();
        const typeMapEntriesMap = {};
        let nextTypeId = 1;
        const attributeMap = new Map();
        const attributeEntriesMap = {};
        let nextAttributeId = 1;
        const eventTypeMap = new Map();
        const eventTypeMapEntriesMap = {};
        let nextEventTypeId = 1;
        const labelStacksMap = {};
        let rawObservations = viewportEntries.map((entry)=>{
            const viewportEntry = entry.data;
            const targetName = viewportEntry.elementName || '';
            const type = viewportEntry.type || '';
            const rect = viewportEntry.rect;
            const attributeName = viewportEntry.attributeName || '';
            let eid = targetNameToIdMap.get(viewportEntry.elementName || '') || 0;
            if (eid === 0) {
                eid = nextElementId;
                nextElementId += 1;
                targetNameToIdMap.set(targetName, eid);
                elementMapEntriesMap[eid] = targetName;
            }
            // Capture labelStacks per element (only stored once per unique element)
            if (viewportEntry.labelStacks && !(eid in labelStacksMap)) {
                const labelInfo = {
                    s: viewportEntry.labelStacks.segment,
                    l: viewportEntry.labelStacks.labelStack
                };
                const shouldCompactImplicitUnknown = labelInfo.s === 'unknown' && labelInfo.l === 'unknown';
                labelStacksMap[eid] = shouldCompactImplicitUnknown ? 'u' : labelInfo;
            }
            let chg = typeMap.get(type || '') || 0;
            if (chg === 0) {
                chg = nextTypeId;
                nextTypeId += 1;
                typeMap.set(type, chg);
                typeMapEntriesMap[chg] = type;
            }
            let att = 0;
            if (attributeName) {
                att = attributeMap.get(attributeName) || 0;
                if (att === 0) {
                    att = nextAttributeId;
                    nextAttributeId += 1;
                    attributeMap.set(attributeName, att);
                    attributeEntriesMap[att] = attributeName;
                }
            }
            const encodedRect = $e056b37ef80a686a$var$encodeRect(rect);
            const encodedPreviousRect = viewportEntry.previousRect ? $e056b37ef80a686a$var$encodeRect(viewportEntry.previousRect) : null;
            const shouldIncludePreviousRect = encodedPreviousRect === null || !$e056b37ef80a686a$var$areRectsEqual(encodedRect, encodedPreviousRect);
            const observation = {
                t: Math.round(entry.time - startTime),
                r: encodedRect,
                ...shouldIncludePreviousRect ? {
                    pr: encodedPreviousRect
                } : {},
                chg: chg,
                eid: eid || 0,
                ...att > 0 ? {
                    att: att
                } : {}
            };
            return observation;
        });
        let rawEventObservations = windowEventEntries.map((entry)=>{
            const windowEventEntry = entry.data;
            const eventType = windowEventEntry.eventType;
            let evtId = eventTypeMap.get(eventType) || 0;
            if (evtId === 0) {
                evtId = nextEventTypeId;
                nextEventTypeId += 1;
                eventTypeMap.set(eventType, evtId);
                eventTypeMapEntriesMap[evtId] = eventType;
            }
            let eventTargetId = 0;
            const eventTargetName = windowEventEntry.elementName || '';
            if (eventTargetName) {
                eventTargetId = targetNameToIdMap.get(eventTargetName) || 0;
                if (eventTargetId === 0) {
                    eventTargetId = nextElementId;
                    nextElementId += 1;
                    targetNameToIdMap.set(eventTargetName, eventTargetId);
                    elementMapEntriesMap[eventTargetId] = eventTargetName;
                }
            }
            const eventObservation = {
                t: Math.round(entry.time - startTime),
                evt: evtId,
                ...eventTargetId > 0 ? {
                    eid: eventTargetId
                } : {}
            };
            return eventObservation;
        });
        const shouldTrimEventObservations = rawEventObservations.length > $e056b37ef80a686a$var$MAX_OBSERVATIONS;
        const shouldTrimViewportObservations = rawObservations.length > $e056b37ef80a686a$var$MAX_OBSERVATIONS;
        // If the number of event observations is greater than the maximum allowed, we need to trim the event observations to the maximum allowed.
        // We do this by keeping the first observation and the last MAX_OBSERVATIONS observations.
        if (shouldTrimEventObservations) {
            const firstEventObservation = rawEventObservations[0];
            const lastEventObservations = rawEventObservations.slice(-$e056b37ef80a686a$var$MAX_OBSERVATIONS);
            rawEventObservations = [
                firstEventObservation,
                ...lastEventObservations
            ];
        }
        // If the number of observations is greater than the maximum allowed, we need to trim the observations to the maximum allowed.
        // We do this by keeping the first observation, the SSR observation (if present), and the last MAX_OBSERVATIONS observations.
        if (shouldTrimViewportObservations) {
            const firstObservation = rawObservations[0];
            const lastObservations = rawObservations.slice(-$e056b37ef80a686a$var$MAX_OBSERVATIONS);
            // Find the SSR observation by looking up the eid that corresponds to 'SSR' element name
            const ssrEid = targetNameToIdMap.get('SSR');
            const ssrObservation = ssrEid ? rawObservations.find((obs)=>obs.eid === ssrEid && obs !== firstObservation) : undefined;
            // Include SSR observation if it exists and is not already in the kept observations
            const ssrAlreadyIncluded = ssrObservation && lastObservations.some((obs)=>obs === ssrObservation);
            rawObservations = [
                firstObservation,
                ...ssrObservation && !ssrAlreadyIncluded ? [
                    ssrObservation
                ] : [],
                ...lastObservations
            ];
        }
        if (shouldTrimViewportObservations || shouldTrimEventObservations) {
            // Collect referenced IDs from final retained observations. Keep this inside the trim
            // guard so the common untrimmed path avoids extra Set allocations and scans.
            const referencedEids = new Set();
            const referencedChgs = new Set();
            const referencedAtts = new Set();
            const referencedEvts = new Set();
            const referencedEventTargetEids = new Set();
            for (const observation of rawObservations){
                if (observation.eid > 0) referencedEids.add(observation.eid);
                if (typeof observation.chg === 'number' && observation.chg > 0) referencedChgs.add(observation.chg);
                if (observation.att !== undefined && observation.att > 0) referencedAtts.add(observation.att);
            }
            for (const observation of rawEventObservations){
                if (observation.evt > 0) referencedEvts.add(observation.evt);
                if (observation.eid !== undefined && observation.eid > 0) referencedEventTargetEids.add(observation.eid);
            }
            for (const eid of Object.keys(elementMapEntriesMap).map(Number))if (!referencedEids.has(eid) && !referencedEventTargetEids.has(eid)) {
                delete elementMapEntriesMap[eid];
                delete labelStacksMap[eid];
            }
            if (shouldTrimViewportObservations) {
                for (const chg of Object.keys(typeMapEntriesMap).map(Number))if (!referencedChgs.has(chg)) delete typeMapEntriesMap[chg];
                for (const att of Object.keys(attributeEntriesMap).map(Number))if (!referencedAtts.has(att)) delete attributeEntriesMap[att];
            }
            if (shouldTrimEventObservations) {
                // Event type map cleanup is only needed when event observations were trimmed.
                // If only viewport observations were trimmed, all event observations remain and
                // therefore every event type ID in the map is still referenced.
                for (const evt of Object.keys(eventTypeMapEntriesMap).map(Number))if (!referencedEvts.has(evt)) delete eventTypeMapEntriesMap[evt];
            }
        }
        // FedRAMP-Moderate scrubbing.
        //
        // In commercial environments the raw-handler payload includes:
        //   - `rawData.att` / `obs[].att`  → DOM attribute names from
        //     `MutationRecord.attributeName`. These are *names* (not values),
        //     but custom product attributes can in principle embed
        //     identifiers (e.g. `data-user-{id}-state`).
        //   - `rawData.lbl`                → UFO labelStacks. Generally
        //     curated product paths but in poorly-instrumented call sites
        //     could embed dynamic identifiers.
        //
        // Server-side TTVC reconstruction does not require these fields
        // (it is driven by timestamps, rectangles, and mutation kind),
        // so dropping them in FedRAMP is safe and removes residual PII risk.
        const isFedrampScrubbed = (0, $5tITM.isFedrampOverrideActive)();
        const scrubbedObservations = isFedrampScrubbed ? rawObservations.map(({ att: _att, ...rest })=>rest) : rawObservations;
        const result = {
            revision: this.revisionNo,
            clean: isVCClean,
            'metric:vc90': null,
            rawData: {
                obs: scrubbedObservations ?? undefined,
                eid: elementMapEntriesMap ?? undefined,
                chg: typeMapEntriesMap ?? undefined,
                att: isFedrampScrubbed ? undefined : attributeEntriesMap ?? undefined,
                evts: rawEventObservations.length > 0 ? rawEventObservations : undefined,
                evt: Object.keys(eventTypeMapEntriesMap).length > 0 ? eventTypeMapEntriesMap : undefined,
                lbl: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? labelStacksMap : undefined,
                lblMode: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? 'sentinel-v1' : undefined
            },
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp,
            viewport: {
                w: (0, $eMj7K.default)(),
                h: (0, $5Zpwf.default)()
            }
        };
        return result;
    }
}

});

parcelRegister("kOjDj", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6f28342b3e39361$export$2e2bcd8739ae039);

var $2aEiL = parcelRequire("2aEiL");

var $69x7c = parcelRequire("69x7c");

var $gvFOW = parcelRequire("gvFOW");

var $dCLz7 = parcelRequire("dCLz7");

var $cSmmC = parcelRequire("cSmmC");

var $2x5fo = parcelRequire("2x5fo");

var $F8nLl = parcelRequire("F8nLl");

var $adYmJ = parcelRequire("adYmJ");

var $iKi2c = parcelRequire("iKi2c");

var $6YZlL = parcelRequire("6YZlL");

var $kQD8D = parcelRequire("kQD8D");

var $g2glP = parcelRequire("g2glP");

var $4JcrE = parcelRequire("4JcrE");

var $apDf4 = parcelRequire("apDf4");

var $j61J2 = parcelRequire("j61J2");

var $8eh0L = parcelRequire("8eh0L");

var $iEqvs = parcelRequire("iEqvs");
const $b6f28342b3e39361$var$createElementMutationsWatcher = (removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return 'ssr-hydration';
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return 'ssr-hydration';
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return 'mutation:ssr-placeholder';
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return 'mutation:ssr-placeholder';
            }
        }
        if (hasSameDeletedNode && (0, $apDf4.default)(target)) return 'mutation:remount';
        if ((0, $69x7c.isContainedWithinMediaWrapper)(target)) return 'mutation:media';
        if (isWithinThirdPartySegment) return 'mutation:third-party-element';
        if (isWithinGenAISegment) return 'mutation:gen-ai-element';
        if (isWithinSmartAnswersSegment) return 'mutation:smart-answers-element';
        const isInIgnoreLsMarker = (0, $apDf4.default)(target);
        if (!isInIgnoreLsMarker) return 'mutation:element';
        const isRLLPlaceholder = (0, $2x5fo.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return 'mutation:rll-placeholder';
        const wasDeleted = removedNodeRects.some((nr)=>(0, $8eh0L.isSameRectDimensions)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return 'mutation:element-replacement';
        return 'mutation:element';
    };
const $b6f28342b3e39361$var$createElementMutationsWatcherNew = (removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
        }
        if (hasSameDeletedNode && (0, $apDf4.default)(target)) return {
            type: 'mutation:remount',
            mutationData: {
                timestamp: timestamp
            }
        };
        if ((0, $69x7c.isContainedWithinMediaWrapper)(target)) return {
            type: 'mutation:media',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinThirdPartySegment) return {
            type: 'mutation:third-party-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinGenAISegment) return {
            type: 'mutation:gen-ai-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinSmartAnswersSegment) return {
            type: 'mutation:smart-answers-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        const isInIgnoreLsMarker = (0, $apDf4.default)(target);
        if (!isInIgnoreLsMarker) return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
        const isRLLPlaceholder = (0, $2x5fo.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return {
            type: 'mutation:rll-placeholder',
            mutationData: {
                timestamp: timestamp
            }
        };
        const wasDeleted = removedNodeRects.some((nr)=>(0, $8eh0L.isSameRectDimensions)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return {
            type: 'mutation:element-replacement',
            mutationData: {
                timestamp: timestamp
            }
        };
        return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
    };
class $b6f28342b3e39361$export$2e2bcd8739ae039 {
    intersectionObserver;
    mutationObserver;
    performanceObserver;
    mapVisibleNodeRects;
    mapIs3pResult;
    mapIsGenAIResult;
    onChange;
    isStarted;
    trackLayoutShiftOffenders;
    searchPageConfig;
    // SSR context functions
    getSSRState;
    getSSRPlaceholderHandler;
    constructor({ onChange: onChange, getSSRState: getSSRState, getSSRPlaceholderHandler: getSSRPlaceholderHandler, trackLayoutShiftOffenders: trackLayoutShiftOffenders = false, searchPageConfig: searchPageConfig }){
        this.mapVisibleNodeRects = new WeakMap();
        this.mapIs3pResult = new WeakMap();
        this.mapIsGenAIResult = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
        this.trackLayoutShiftOffenders = trackLayoutShiftOffenders;
        // Initialize SSR context functions
        this.getSSRState = getSSRState;
        this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
        this.searchPageConfig = searchPageConfig;
    }
    handleIntersectionEntry = ({ target: target, rect: rect, time: time, type: type, mutationData: mutationData })=>{
        if (!target) return;
        const visible = (0, $4JcrE.isElementVisible)(target);
        const lastElementRect = this.mapVisibleNodeRects.get(target);
        this.mapVisibleNodeRects.set(target, rect);
        this.onChange({
            time: time,
            type: type,
            elementRef: new WeakRef(target),
            visible: visible,
            rect: rect,
            previousRect: lastElementRect,
            mutationData: mutationData
        });
    };
    handleChildListMutation = async ({ target: target, addedNodes: addedNodes, removedNodes: removedNodes, timestamp: timestamp })=>{
        const removedNodeRects = removedNodes.map((ref)=>{
            const n = ref.deref();
            if (!n) return;
            return this.mapVisibleNodeRects.get(n);
        });
        const targetNode = target.deref();
        for (const addedNodeRef of addedNodes){
            const addedNode = addedNodeRef.deref();
            if (!addedNode) continue;
            const hasSameDeletedNode = removedNodes.find((ref)=>{
                const n = ref.deref();
                if (!n || !addedNode) return false;
                return n.isEqualNode(addedNode);
            });
            const { isWithin: isWithinThirdPartySegment } = (0, $6YZlL.default)(addedNode, 'UFOThirdPartySegment', this.mapIs3pResult);
            const { isWithin: isWithinGenAISegment } = (0, $6YZlL.default)(addedNode, 'UFOGenAISegment', this.mapIsGenAIResult);
            const isWithinSmartAnswersSegment = Boolean(this.shouldCheckSmartAnswersMutations() && (0, $g2glP.isContainedWithinSmartAnswers)(addedNode));
            const isTargetReactRoot = targetNode === this.getSSRState?.()?.reactRootElement;
            this.intersectionObserver?.watchAndTag(addedNode, (this.trackLayoutShiftOffenders ? $b6f28342b3e39361$var$createElementMutationsWatcherNew : $b6f28342b3e39361$var$createElementMutationsWatcher)(removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, !!hasSameDeletedNode, timestamp, isTargetReactRoot, this.getSSRState, this.getSSRPlaceholderHandler));
        }
    };
    handleAttributeMutation = ({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue, timestamp: timestamp })=>{
        this.intersectionObserver?.watchAndTag(target, ({ target: target, rect: rect })=>{
            if ((0, $69x7c.isContainedWithinMediaWrapper)(target)) return {
                type: 'mutation:media',
                mutationData: {
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue,
                    timestamp: timestamp
                }
            };
            const { isWithin: isWithinThirdPartySegment } = (0, $6YZlL.default)(target, 'UFOThirdPartySegment', this.mapIs3pResult);
            const { isWithin: isWithinGenAISegment } = (0, $6YZlL.default)(target, 'UFOGenAISegment', this.mapIsGenAIResult);
            if (isWithinThirdPartySegment) return {
                type: 'mutation:third-party-attribute',
                mutationData: {
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue,
                    timestamp: timestamp
                }
            };
            if (isWithinGenAISegment) return {
                type: 'mutation:gen-ai-attribute',
                mutationData: {
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue,
                    timestamp: timestamp
                }
            };
            if (this.shouldCheckSmartAnswersMutations() && (0, $g2glP.isContainedWithinSmartAnswers)(target)) return {
                type: 'mutation:smart-answers-attribute',
                mutationData: {
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                }
            };
            if ((0, $gvFOW.default)({
                target: target,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            })) return {
                type: 'mutation:attribute:non-visual-style',
                mutationData: {
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue,
                    timestamp: timestamp
                }
            };
            if ((0, $dCLz7.default)({
                target: target,
                attributeName: attributeName,
                type: 'attributes'
            })) return {
                type: 'mutation:attribute:non-visual-style',
                mutationData: {
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue,
                    timestamp: timestamp
                }
            };
            // Pragmatic Drag and Drop attributes added during post-paint
            // registration; do not affect layout or paint.
            if ((0, $cSmmC.default)({
                target: target,
                attributeName: attributeName
            }) && (0, $2aEiL.fg)('platform_ufo_exclude_pdnd_attributes_from_vc')) return {
                type: 'mutation:attribute:non-visual-style',
                mutationData: {
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue,
                    timestamp: timestamp
                }
            };
            if ((0, $j61J2.isInputNameMutation)({
                target: target,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            })) return {
                type: 'mutation:attribute:non-visual-input-name',
                mutationData: {
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue,
                    timestamp: timestamp
                }
            };
            const isRLLPlaceholder = (0, $2x5fo.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
            if (isRLLPlaceholder) return {
                type: 'mutation:rll-placeholder',
                mutationData: {
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue,
                    timestamp: timestamp
                }
            };
            const lastElementRect = this.mapVisibleNodeRects.get(target);
            if (lastElementRect && (0, $iEqvs.isSameRectSize)(rect, lastElementRect)) return {
                type: 'mutation:attribute:no-layout-shift',
                mutationData: {
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue,
                    timestamp: timestamp
                }
            };
            return {
                type: 'mutation:attribute',
                mutationData: {
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue,
                    timestamp: timestamp
                }
            };
        });
    };
    handleLayoutShift = ({ time: time, changedRects: changedRects })=>{
        for (const changedRect of changedRects){
            const target = changedRect.node;
            if (target) {
                const isSameCurrentAndPreviousRects = (0, $8eh0L.isSameRectDimensions)(changedRect.rect, changedRect.previousRect);
                this.onChange({
                    time: time,
                    elementRef: new WeakRef(target),
                    visible: true,
                    rect: changedRect.rect,
                    previousRect: changedRect.previousRect,
                    type: isSameCurrentAndPreviousRects ? 'layout-shift:same-rect' : 'layout-shift'
                });
            }
        }
    };
    initializeObservers() {
        if (this.isStarted) return;
        this.intersectionObserver = (0, $F8nLl.createIntersectionObserver)({
            onEntry: this.handleIntersectionEntry
        });
        this.mutationObserver = (0, $adYmJ.default)({
            onChildListMutation: this.handleChildListMutation,
            onAttributeMutation: this.handleAttributeMutation
        });
        this.performanceObserver = (0, $iKi2c.default)({
            onLayoutShift: this.handleLayoutShift
        });
    }
    shouldCheckSmartAnswersMutations = ()=>{
        return this.searchPageConfig?.enableSmartAnswersMutations && this.searchPageConfig?.searchPageRoute && window?.location?.pathname && window.location.pathname === this.searchPageConfig.searchPageRoute;
    };
    start() {
        if (this.isStarted) return;
        this.initializeObservers();
        this.mutationObserver?.observe(document.body, {
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
        this.performanceObserver?.observe({
            type: 'layout-shift',
            buffered: true,
            // @ts-ignore -error
            durationThreshold: 30
        });
        this.isStarted = true;
    }
    stop() {
        if (!this.isStarted) return;
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.performanceObserver?.disconnect();
        this.isStarted = false;
        // Clean up caches when stopping
        (0, $kQD8D.cleanupCaches)(this.mapIs3pResult);
    }
}

});
parcelRegister("cSmmC", function(module, exports) {
$parcel$export(module.exports, "default", () => $7138168166501b1b$export$2e2bcd8739ae039);
/**
 * Attributes that Pragmatic Drag and Drop adds via `setAttribute` during its
 * post-paint registration step. They are used purely for hit testing and
 * registration bookkeeping, and do not affect layout, paint, or visible
 * styling, so they are safe to ignore for VC measurement.
 *
 * Drop target attributes follow `data-drop-target-for-<typeKey>` and are
 * handled by the prefix below (covers shipped and custom adapters).
 */ const $7138168166501b1b$export$bcd335ae574a0717 = new Set([
    // @atlaskit/pragmatic-drag-and-drop (core)
    'draggable',
    // Honey pot lives on a transient element; included for completeness.
    'data-pdnd-honey-pot',
    // @atlaskit/pragmatic-drag-and-drop-auto-scroll
    'data-auto-scrollable',
    // @atlaskit/pragmatic-drag-and-drop/react-beautiful-dnd-migration
    'data-rbd-draggable-droppable-id',
    'data-rbd-draggable-index',
    'data-rbd-droppable-type',
    'data-rbd-droppable-direction',
    'data-rbd-droppable-id',
    'data-rbd-droppable-context-id',
    'data-rbd-style-context-id'
]);
const $7138168166501b1b$export$846396c2d8be3710 = 'data-drop-target-for-';
function $7138168166501b1b$export$2e2bcd8739ae039({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (!attributeName) return false;
    if ($7138168166501b1b$export$bcd335ae574a0717.has(attributeName)) return true;
    if (attributeName.startsWith($7138168166501b1b$export$846396c2d8be3710)) return true;
    return false;
}

});

parcelRegister("F8nLl", function(module, exports) {
$parcel$export(module.exports, "createIntersectionObserver", () => $71bc833a27d1da0f$export$c3799d33e0ae80a5);

var $edFac = parcelRequire("edFac");
function $71bc833a27d1da0f$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $71bc833a27d1da0f$export$c3799d33e0ae80a5({ onEntry: onEntry, onObserved: onObserved }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const callbacksPerElement = new WeakMap();
    const intersectionObserverCallback = (entries)=>{
        const validEntries = [];
        const startTime = performance.now();
        entries.forEach((entry)=>{
            if (!(entry.target instanceof HTMLElement)) return;
            const tagOrCallback = callbacksPerElement.get(entry.target);
            if ((0, $edFac.isZeroDimensionRectangle)(entry.intersectionRect)) {
                const zeroDimensionRectangleTagCallback = (props)=>{
                    const tagOrCallbackResult = typeof tagOrCallback === 'function' ? tagOrCallback(props) : tagOrCallback;
                    // override as display-contents mutation
                    if (tagOrCallbackResult === 'mutation:element') return 'mutation:display-contents-children-element';
                    // override as display-contents mutation
                    if (tagOrCallbackResult && typeof tagOrCallbackResult !== 'string' && tagOrCallbackResult.type === 'mutation:attribute' && 'oldValue' in tagOrCallbackResult.mutationData) {
                        const { attributeName: attributeName, oldValue: oldValue, newValue: newValue } = tagOrCallbackResult.mutationData;
                        const isRoutingMutation = attributeName === 'style' && (!oldValue && newValue === 'display: none !important;' || oldValue === 'display: none !important;' && !newValue);
                        if (isRoutingMutation) return {
                            type: 'mutation:attribute:framework-routing',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                        return {
                            type: 'mutation:display-contents-children-attribute',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                    }
                    return tagOrCallbackResult;
                };
                for (const child of Array.from(entry.target.children)){
                    observer.observe(child);
                    callbacksPerElement.set(child, zeroDimensionRectangleTagCallback);
                }
                return;
            }
            if (!$71bc833a27d1da0f$var$isValidEntry(entry)) return;
            let mutationTag = null;
            let mutationData = null;
            if (typeof tagOrCallback === 'function') {
                const tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag ?? 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved?.({
            time: startTime,
            elements: validEntries
        });
    };
    const observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: ()=>{
            observer.disconnect();
        },
        unobserve: (target)=>{
            observer.unobserve(target);
        },
        watchAndTag: (target, tagOrCallback)=>{
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}

});
parcelRegister("edFac", function(module, exports) {
$parcel$export(module.exports, "isZeroDimensionRectangle", () => $36ac99a49f3dd600$export$80d6b07c2266a1c6);
function $36ac99a49f3dd600$export$80d6b07c2266a1c6(rect) {
    return rect.bottom === 0 && rect.top === 0 && rect.left === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0 && rect.width === 0 && rect.height === 0;
}

});


parcelRegister("adYmJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1adba065fc8a517$export$2e2bcd8739ae039);

var $hMXHM = parcelRequire("hMXHM");
/**
 * Whether the node is a top-layer element (`[popover]` or `<dialog>`) that
 * contains `data-vc-oob` content. A top-layer flag group mounts its layer only
 * while a flag shows, so the layer is added and removed with its out-of-band
 * content. Only top-layer elements are searched, so ordinary nodes stay cheap
 * and are still counted.
 */ function $c1adba065fc8a517$var$isLayerContainingOutOfBandContent(node) {
    const isLayer = node.hasAttribute('popover') || node.localName === 'dialog';
    return isLayer && node.querySelector('[data-vc-oob]') !== null;
}
function $c1adba065fc8a517$var$createMutationObserver({ onAttributeMutation: onAttributeMutation, onChildListMutation: onChildListMutation, onMutationFinished: onMutationFinished }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const mutationObserverCallback = (mutations)=>{
        const targets = [];
        // Use nested Maps for O(1) batching performance
        // Short-lived Maps are safe since they're discarded after each callback
        const batchedMutations = new Map();
        for (const mut of mutations){
            if (!(mut.target instanceof HTMLElement)) continue;
            const shouldExcludeOutOfBand = (0, $hMXHM.expVal)('cc_editor_vc_exclude_flags', 'isEnabled', false);
            if (shouldExcludeOutOfBand) {
                // Intended for excluding out of band mutations such as tooltips on hover, and page flags
                // Currently being tested in Confluence
                // Skip elements with data-vc-oob attribute
                if (mut.target.dataset.vcOob) return;
            }
            if (mut.type === 'attributes') {
                /*
        	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
        	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
        	Conceptually there is after all a mutation: there is an old value replaced with a new one,
        	and whether or not they are the same doesn't really matter.
        	And Custom elements should work the same way as MutationObserver."
        	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
        */ const oldValue = mut.oldValue ?? undefined;
                const newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                if (oldValue !== newValue) onAttributeMutation({
                    target: mut.target,
                    attributeName: mut.attributeName ?? 'unknown',
                    oldValue: oldValue,
                    newValue: newValue,
                    timestamp: mut.timestamp || performance.now()
                });
                continue;
            } else if (mut.type === 'childList') {
                // In chromium browser MutationRecord has timestamp field, which we should use.
                const timestamp = Math.round(mut.timestamp || performance.now());
                // Get or create timestamp bucket
                let timestampBucket = batchedMutations.get(timestamp);
                if (!timestampBucket) {
                    timestampBucket = new Map();
                    batchedMutations.set(timestamp, timestampBucket);
                }
                // Get or create target batch within timestamp bucket
                let batch = timestampBucket.get(mut.target);
                if (!batch) {
                    batch = {
                        target: new WeakRef(mut.target),
                        addedNodes: [],
                        removedNodes: [],
                        timestamp: timestamp
                    };
                    timestampBucket.set(mut.target, batch);
                }
                // Accumulate added nodes. With the experiment on, skip a top-layer element
                // that contains out-of-band content, such as a flag layer.
                (mut.addedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement && !(shouldExcludeOutOfBand && $c1adba065fc8a517$var$isLayerContainingOutOfBandContent(node))) batch.addedNodes.push(new WeakRef(node));
                });
                // Accumulate removed nodes
                (mut.removedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement && !(shouldExcludeOutOfBand && $c1adba065fc8a517$var$isLayerContainingOutOfBandContent(node))) batch.removedNodes.push(new WeakRef(node));
                });
            }
            targets.push(mut.target);
        }
        // Process all batched childList mutations
        for (const timestampBucket of batchedMutations.values())for (const batch of timestampBucket.values())onChildListMutation({
            target: batch.target,
            addedNodes: batch.addedNodes,
            removedNodes: batch.removedNodes,
            timestamp: batch.timestamp
        });
        onMutationFinished?.({
            targets: targets
        });
    };
    const observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $c1adba065fc8a517$export$2e2bcd8739ae039 = $c1adba065fc8a517$var$createMutationObserver;

});

parcelRegister("iKi2c", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba27037996347b4d$export$2e2bcd8739ae039);

var $hSAjJ = parcelRequire("hSAjJ");
function $ba27037996347b4d$var$createPerformanceObserver({ onLayoutShift: onLayoutShift }) {
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    const performanceObserverCallback = (entries)=>{
        for (const entry of entries.getEntries())if (entry.entryType === 'layout-shift' && 'sources' in entry) {
            // see https://developer.mozilla.org/en-US/docs/Web/API/LayoutShiftAttribution for more info
            const changedRects = entry.sources.reduceRight((acc, attr)=>{
                acc.push({
                    rect: (0, $hSAjJ.convertPhysicalToLogicalResolution)(attr.currentRect),
                    previousRect: (0, $hSAjJ.convertPhysicalToLogicalResolution)(attr.previousRect),
                    node: attr.node
                });
                return acc;
            }, []);
            onLayoutShift({
                time: entry.startTime,
                changedRects: changedRects
            });
        }
    };
    const observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ba27037996347b4d$export$2e2bcd8739ae039 = $ba27037996347b4d$var$createPerformanceObserver;

});
parcelRegister("hSAjJ", function(module, exports) {
$parcel$export(module.exports, "convertPhysicalToLogicalResolution", () => $269d3a9329514580$export$5e3f54cad8cb65e2);
// The LayoutShiftAttribution API is returning the numbers on physical dimension
function $269d3a9329514580$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}

});


parcelRegister("6YZlL", function(module, exports) {
$parcel$export(module.exports, "default", () => $dcb3e1ebeea3a187$export$2e2bcd8739ae039);

var $2aEiL = parcelRequire("2aEiL");

var $fskN5 = parcelRequire("fskN5");

var $e037O = parcelRequire("e037O");

var $kFPqX = parcelRequire("kFPqX");

var $kQD8D = parcelRequire("kQD8D");

var $cQuS0 = parcelRequire("cQuS0");
const $dcb3e1ebeea3a187$var$OLD_DOM_WALK_MAX_LEVEL = 40;
const $dcb3e1ebeea3a187$var$OLD_FIBER_WALK_MAX_LEVEL = 40;
const $dcb3e1ebeea3a187$var$NEW_DOM_WALK_MAX_LEVEL = 400;
const $dcb3e1ebeea3a187$var$NEW_FIBER_WALK_MAX_LEVEL = 400;
const $dcb3e1ebeea3a187$var$CLEANUP_THRESHOLD = 50;
function $dcb3e1ebeea3a187$var$maybeCleanup(resultCache) {
    (0, $e037O.cacheCleanupState).callCount++;
    if ((0, $e037O.cacheCleanupState).callCount >= $dcb3e1ebeea3a187$var$CLEANUP_THRESHOLD && (0, $fskN5.default)(0.3)) (0, $kQD8D.cleanupCaches)(resultCache);
}
function $dcb3e1ebeea3a187$export$2e2bcd8739ae039(node, targetComponentName, resultCache) {
    $dcb3e1ebeea3a187$var$maybeCleanup(resultCache);
    if (resultCache.has(node)) return {
        isWithin: resultCache.get(node) ?? false
    };
    const checkedNodes = [];
    const shouldUseBumpedWalkLevels = (0, $2aEiL.fg)('ufo-bump-walk-levels');
    const DOM_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? $dcb3e1ebeea3a187$var$NEW_DOM_WALK_MAX_LEVEL : $dcb3e1ebeea3a187$var$OLD_DOM_WALK_MAX_LEVEL;
    const FIBER_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? $dcb3e1ebeea3a187$var$NEW_FIBER_WALK_MAX_LEVEL : $dcb3e1ebeea3a187$var$OLD_FIBER_WALK_MAX_LEVEL;
    // Always use cached fiber strategy to handle non-React elements reliably
    const { fiber: fiber, cachedResult: cachedResult } = (0, $cQuS0.default)(node, DOM_WALK_MAX_LEVEL, checkedNodes, shouldUseBumpedWalkLevels ? resultCache : undefined);
    if (cachedResult !== undefined) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, cachedResult);
        });
        return {
            isWithin: cachedResult
        };
    }
    if (!fiber) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, false);
        });
        return {
            isWithin: false
        };
    }
    const isWithin = (0, $kFPqX.default)(fiber, targetComponentName, FIBER_WALK_MAX_LEVEL);
    checkedNodes.forEach((checkedNode)=>{
        resultCache.set(checkedNode, isWithin);
    });
    return {
        isWithin: isWithin
    };
}

});
parcelRegister("e037O", function(module, exports) {
$parcel$export(module.exports, "cacheCleanupState", () => $a7f235c738bcb854$export$2d67c094e7802413);
const $a7f235c738bcb854$export$2d67c094e7802413 = {
    callCount: 0
};

});

parcelRegister("kFPqX", function(module, exports) {
$parcel$export(module.exports, "default", () => $78f74fb28de135b2$export$2e2bcd8739ae039);

var $kr13D = parcelRequire("kr13D");
function $78f74fb28de135b2$export$2e2bcd8739ae039(fiber, targetComponentName, maxLevel) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return false;
    if (!fiber) return false;
    const componentName = (0, $kr13D.default)(fiber);
    if (componentName === targetComponentName) return true;
    // Recursively traverse up the fiber tree
    return $78f74fb28de135b2$export$2e2bcd8739ae039(fiber.return, targetComponentName, maxLevel - 1);
}

});
parcelRegister("kr13D", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc35b3e7e68f26ef$export$2e2bcd8739ae039);
// Helper function to extract component name from fiber
function $bc35b3e7e68f26ef$export$2e2bcd8739ae039(fiber) {
    const type = fiber?.type;
    if (!type) return undefined;
    if (typeof type === 'function' || typeof type === 'object') return type.displayName || type.name;
    return undefined;
}

});


parcelRegister("kQD8D", function(module, exports) {
$parcel$export(module.exports, "cleanupCaches", () => $452c0cab22aa08aa$export$6a35c3789c327630);

var $e037O = parcelRequire("e037O");
function $452c0cab22aa08aa$export$6a35c3789c327630(resultCache) {
    resultCache = new WeakMap();
    (0, $e037O.cacheCleanupState).callCount = 0;
    return resultCache;
}

});

parcelRegister("cQuS0", function(module, exports) {
$parcel$export(module.exports, "default", () => $99730203ecb883ae$export$2e2bcd8739ae039);

var $d65Dm = parcelRequire("d65Dm");
function $99730203ecb883ae$export$2e2bcd8739ae039(element, maxLevel, checkedNodes, resultCache) {
    let currentElement = element;
    let remainingLevels = maxLevel;
    while(currentElement && remainingLevels > 0){
        const cachedResult = resultCache?.get(currentElement);
        if (cachedResult !== undefined) return {
            fiber: null,
            cachedResult: cachedResult
        };
        checkedNodes.push(currentElement);
        const fiber = (0, $d65Dm.default)(currentElement);
        if (fiber) return {
            fiber: fiber
        };
        currentElement = currentElement.parentElement;
        remainingLevels--;
    }
    return {
        fiber: null
    };
}

});
parcelRegister("d65Dm", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fe88ae73d6119f3$export$2e2bcd8739ae039);
// Helper function to find React fiber on an element
function $5fe88ae73d6119f3$export$2e2bcd8739ae039(element) {
    // Use for...in loop instead of Object.keys().find() to avoid creating an array
    for(const key in element){
        if (key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$')) return element[key];
    }
    return null;
}

});



parcelRegister("g2glP", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinSmartAnswers", () => $ee64bddaa4fee9ab$export$16c2770458939f21);

var $brxde = parcelRequire("brxde");
function $ee64bddaa4fee9ab$export$16c2770458939f21(node) {
    const doc = (0, $brxde.getDocument)();
    if (!doc) return false;
    const smartAnswersElement = doc.getElementById('search-page-smart-answers');
    if (!smartAnswersElement) return false;
    // When the node is the smart answer element, .contains() still returns true
    return smartAnswersElement.contains(node);
}

});

parcelRegister("4JcrE", function(module, exports) {
$parcel$export(module.exports, "isElementVisible", () => $86c651a56861c2b1$export$e989c0fffaa6b27a);
function $86c651a56861c2b1$export$e989c0fffaa6b27a(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        const visible = element.checkVisibility({
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch  {
        // there is no support for checkVisibility
        return true;
    }
}

});

parcelRegister("apDf4", function(module, exports) {
$parcel$export(module.exports, "default", () => $014cec57022e0c56$export$2e2bcd8739ae039);
/**
 * Check if the element is in the VC ignore if no layout shift marker.
 * @param element - The element to check.
 * @returns True if the element has the data-vc-ignore-if-no-layout-shift attribute == 'true or its parent has it, false otherwise.
 */ function $014cec57022e0c56$export$2e2bcd8739ae039(element) {
    if (!element) return false;
    return element.getAttribute('data-vc-ignore-if-no-layout-shift') === 'true' || $014cec57022e0c56$export$2e2bcd8739ae039(element.parentElement);
}

});

parcelRegister("j61J2", function(module, exports) {
$parcel$export(module.exports, "isInputNameMutation", () => $7d8352cb8bd61eaa$export$80a5724ceedcfd3d);
// Detecting this is required due to a React/Chromium bug, where React itself triggers an attribute mutation for input elements
// Reference: https://atlassian.slack.com/archives/C08EK6TCUP6/p1764129900970719
function $7d8352cb8bd61eaa$export$80a5724ceedcfd3d({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    return target instanceof HTMLInputElement && attributeName === 'name' && (oldValue === '' || newValue === '');
}

});

parcelRegister("8eh0L", function(module, exports) {
$parcel$export(module.exports, "isSameRectDimensions", () => $faa7bc555fe6bfc2$export$fde63bc968551821);
const $faa7bc555fe6bfc2$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $faa7bc555fe6bfc2$export$fde63bc968551821(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $faa7bc555fe6bfc2$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $faa7bc555fe6bfc2$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.x - b.x) <= $faa7bc555fe6bfc2$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.y - b.y) <= $faa7bc555fe6bfc2$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});

parcelRegister("iEqvs", function(module, exports) {
$parcel$export(module.exports, "isSameRectSize", () => $a4c55366a5e5d8ca$export$597b41700f7dcd36);
const $a4c55366a5e5d8ca$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $a4c55366a5e5d8ca$export$597b41700f7dcd36(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $a4c55366a5e5d8ca$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $a4c55366a5e5d8ca$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});


parcelRegister("i9M5e", function(module, exports) {
$parcel$export(module.exports, "default", () => $c578a5e448f0e26a$export$2e2bcd8739ae039);

var $dmmsG = parcelRequire("dmmsG");
class $c578a5e448f0e26a$export$2e2bcd8739ae039 {
    unbindFns = [];
    onEvent;
    constructor(opts){
        this.onEvent = opts.onEvent;
    }
    bindEvent(type) {
        const unbindCallback = (0, $dmmsG.bind)(window, {
            type: type,
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: type,
                    event: event
                });
            },
            options: {
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    /**
   * Binds a scroll listener on `document` using the capture phase.
   * The `scroll` event does not bubble, so listening on `window` only catches
   * document-level scrolls. By using `{ capture: true }` on `document`, we can
   * detect scroll events from any element in the DOM tree, including inner
   * scrollable containers (e.g. when the user drags a scrollbar).
   */ bindCaptureScrollEvent() {
        const unbindCallback = (0, $dmmsG.bind)(document, {
            type: 'scroll',
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: 'scroll-container',
                    event: event
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    start() {
        this.bindEvent('wheel');
        this.bindEvent('scroll');
        this.bindEvent('keydown');
        this.bindEvent('resize');
        this.bindCaptureScrollEvent();
    }
    stop() {
        this.unbindFns.forEach((cb)=>{
            cb();
        });
        this.unbindFns = [];
    }
}

});




parcelRegister("eId1k", function(module, exports) {
$parcel$export(module.exports, "interactions", () => $6a2bccdfbb7b3d04$export$cc97b17ef9aeb088);
const $6a2bccdfbb7b3d04$export$cc97b17ef9aeb088 = new Map();

});

parcelRegister("i0C6O", function(module, exports) {
$parcel$export(module.exports, "default", () => $c29a54cb80154253$export$2e2bcd8739ae039);

var $5tITM = parcelRequire("5tITM");

var $cGjFC = parcelRequire("cGjFC");

var $kp3Hh = parcelRequire("kp3Hh");
const $c29a54cb80154253$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
class $c29a54cb80154253$export$2e2bcd8739ae039 {
    /**
   * Basic info about interaction that has just finished
   */ lastInteractionFinish = null;
    /**
   * Array of observed react render timings
   */ reactProfilerTimings = [];
    /**
   * Store the scheduled sink timeout Id so that it can be cancelled when needed
   */ sinkTimeoutId = null;
    holdInfo = [];
    /**
   * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
   */ vcObserver = null;
    vcObserverSSRConfig = null;
    lastInteractionFinishVCResult;
    initializeVCObserver(options) {
        this.vcObserver = new (0, $kp3Hh.VCObserverWrapper)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }) {
        this.vcObserver?.start({
            startTime: startTime
        });
    }
    stopVCObserver() {
        this.vcObserver?.stop();
    }
    setVCObserverSSRConfig(vcObserverSSRConfig) {
        this.vcObserverSSRConfig = vcObserverSSRConfig;
    }
    /**
   * Set the VC result as per the last interaction
   * Used to compare diffs of VC updates vs post interaction VC observer
   * @param result - VC result as calculated by UFO create payload
   */ setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    /**
   * Handler function to process / send the observation data
   */ sinkHandlerFn = ()=>{};
    /**
   * Set the fn that would be invoked to process / send the observation data
   */ sinkHandler(sinkHandlerFn) {
        this.sinkHandlerFn = sinkHandlerFn;
    }
    /**
   * Reset state of the log
   */ reset() {
        this.lastInteractionFinish = null;
        this.reactProfilerTimings = [];
        this.holdInfo = [];
        if (this.sinkTimeoutId != null) {
            clearTimeout(this.sinkTimeoutId);
            this.sinkTimeoutId = null;
        }
        this.setVCObserverSSRConfig(null);
    }
    /**
   * Check if there is data in the log
   */ hasData() {
        return this.reactProfilerTimings?.length > 0;
    }
    /**
   * Send the log if there is data
   */ async sendPostInteractionLog() {
        if (!this.lastInteractionFinish || !this.sinkHandlerFn) {
            this.reset();
            this.vcObserver?.stop();
            return;
        }
        const pageVisibilityState = (0, $cGjFC.getPageVisibilityState)(this.lastInteractionFinish.start, this.lastInteractionFinish.end);
        const isPageVisible = pageVisibilityState === 'visible';
        const config = (0, $5tITM.getConfig)();
        const postInteractionFinishVCResult = await this.vcObserver?.getVCResult({
            start: this.lastInteractionFinish.start,
            stop: performance.now(),
            tti: -1,
            // no need for TTI value here
            isEventAborted: !!this.lastInteractionFinish.abortReason,
            prefix: 'ufo',
            experienceKey: this.lastInteractionFinish.ufoName,
            interactionId: this.lastInteractionFinish.id,
            includeSSRInV3: config?.vc?.includeSSRInV3,
            includeSSRRatio: config?.vc?.includeSSRRatio,
            ...this.vcObserverSSRConfig,
            interactionType: this.lastInteractionFinish.type,
            isPageVisible: isPageVisible,
            interactionAbortReason: this.lastInteractionFinish.abortReason
        });
        this.vcObserver?.stop();
        this.sinkHandlerFn({
            lastInteractionFinish: this.lastInteractionFinish,
            reactProfilerTimings: this.reactProfilerTimings,
            postInteractionFinishVCResult: postInteractionFinishVCResult,
            lastInteractionFinishVCResult: this.lastInteractionFinishVCResult,
            postInteractionHoldInfo: this.holdInfo
        });
        this.reset();
    }
    /**
   * This fn should be invoked when an interaction has finished
   * Basic details about the finished interaction will be recorded
   * A timeout will be setup to send the post interaction observation after some time.
   */ onInteractionComplete({ ufoName: ufoName, start: start, end: end, id: id, abortReason: abortReason, abortedByInteractionName: abortedByInteractionName, routeName: routeName, type: type, errors: errors }) {
        this.lastInteractionFinish = {
            ufoName: ufoName,
            start: start,
            end: end,
            id: id,
            abortReason: abortReason,
            abortedByInteractionName: abortedByInteractionName,
            routeName: routeName,
            type: type,
            errors: errors
        };
        const timeout = (0, $5tITM.getConfig)()?.timeWindowForLateMutationsInMilliseconds || $c29a54cb80154253$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
        this.sinkTimeoutId = window.setTimeout(async ()=>{
            await this.sendPostInteractionLog();
        }, timeout);
    }
    /**
   * This fn should be invoked when a React render happens after interaction has finished
   */ addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
        if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
            type: type,
            actualDuration: actualDuration,
            baseDuration: baseDuration,
            startTime: startTime,
            commitTime: commitTime,
            labelStack: labelStack
        });
    }
    addHoldInfo(labelStack, name, start) {
        this.holdInfo.push({
            name: name,
            labelStack: labelStack,
            start: start
        });
    }
}

});


parcelRegister("jnGk3", function(module, exports) {
$parcel$export(module.exports, "default", () => $7492fa49b0b52229$export$2e2bcd8739ae039);

var $k1Wvt = parcelRequire("k1Wvt");
function $7492fa49b0b52229$var$scheduleOnPaint(callback) {
    const isSSR = typeof window === 'undefined' || Boolean(globalThis?.__SERVER__) || typeof $k1Wvt !== 'undefined' && Boolean($k1Wvt?.env?.REACT_SSR);
    if (isSSR) {
        // In SSR, execute callback immediately (no paint event exists)
        callback();
        return;
    }
    if (globalThis.document?.visibilityState !== 'visible') {
        // last resort fallback
        setTimeout(callback, 100);
        return;
    }
    // Check if the Scheduler API is available
    if (typeof window.scheduler !== 'undefined' && typeof window.scheduler.postTask === 'function') // Use scheduler.postTask if available
    // https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
    // Make sure we are scheduling this task before the browser paint the next frame
    requestAnimationFrame(()=>{
        window.scheduler.postTask(callback, {
            priority: 'user-visible'
        });
    });
    else if (typeof requestAnimationFrame !== 'undefined') // Fallback to using double requestAnimationFrame
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            callback();
        });
    });
}
var $7492fa49b0b52229$export$2e2bcd8739ae039 = $7492fa49b0b52229$var$scheduleOnPaint;

});




parcelRegister("lTVJL", function(module, exports) {
$parcel$export(module.exports, "__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__", () => $5f1bd218d24dbdfe$export$df54517d175e6d6b);

var $2aEiL = parcelRequire("2aEiL");

var $6Fero = parcelRequire("6Fero");

var $layCf = parcelRequire("layCf");

var $grLh0 = parcelRequire("grLh0");
const $5f1bd218d24dbdfe$var$getLoggingAndMetricsHelper = ()=>{
    return {
        logNonBreakingErrors: ()=>{},
        logError: ()=>{},
        logErrorRetry: ()=>{},
        logQueryFallbackToPost: ()=>{}
    };
};
const $5f1bd218d24dbdfe$export$4a639ebead870a0c = new (0, $grLh0.SSRQueryResponseCache)({
    cacheName: 'relay-cache/v2/AGG',
    size: Infinity,
    ttl: Infinity
});
const $5f1bd218d24dbdfe$export$df54517d175e6d6b = (0, $6Fero.createRelayEnvironment)({
    networkOptions: {
        getLoggingAndMetricsHelper: $5f1bd218d24dbdfe$var$getLoggingAndMetricsHelper,
        validateResponse: (request, response)=>{
            const errors = 'errors' in response ? response.errors : undefined;
            if (errors != null) {
                const requestId = response?.extensions?.gateway?.request_id;
                (0, $layCf.captureErrors)(errors, {
                    operationName: request.name,
                    requestId: requestId
                });
                if ((0, $2aEiL.fg)('platform_relay_redirect_on_step_up_auth_studio')) {
                    const { hasStepUpAuthError: hasStepUpAuthError, stepUpUrl: stepUpUrl } = (0, $layCf.isStepUpAuthError)(errors);
                    // Guard against SSR: window is not defined in server-side rendering environments.
                    // RelayEnvironmentProvider is used by platform components (e.g. GlobalSideNavigation)
                    // during SSR — validateResponse may be called during renderToString where window
                    // does not exist. Without this guard, a step-up auth error would throw
                    // ReferenceError and crash the entire SSR render.
                    if (hasStepUpAuthError && stepUpUrl && typeof window !== 'undefined') window.location.href = stepUpUrl;
                }
            }
            return true;
        },
        onInvalidResponse: ()=>{},
        queryResponseCache: $5f1bd218d24dbdfe$export$4a639ebead870a0c,
        // Use typeof window === 'undefined' for SSR detection rather than globalThis.__SERVER__.
        // __SERVER__ is set in tests but not in Bifrost's actual SSR environment (it's set in
        // init() which runs after module evaluation). typeof window === 'undefined' is the
        // standard pattern and correctly identifies both Bifrost SSR and test environments.
        isServer: typeof window === 'undefined'
    }
});

});
parcelRegister("layCf", function(module, exports) {
$parcel$export(module.exports, "startCaptureGraphQlErrors", () => $fbbd61a4f5f518c7$export$c211170518c6d0f6);
$parcel$export(module.exports, "stopCaptureGraphQlErrors", () => $fbbd61a4f5f518c7$export$e0491a0d974dadfa);
$parcel$export(module.exports, "captureErrors", () => $fbbd61a4f5f518c7$export$7a973c0ff390eb47);
$parcel$export(module.exports, "isStepUpAuthError", () => $fbbd61a4f5f518c7$export$60fba4117567a49b);

var $2BKzr = parcelRequire("2BKzr");
const $fbbd61a4f5f518c7$var$errorCollector = new Map();
const $fbbd61a4f5f518c7$export$da396ad2a542b095 = 120000; // 2min
const $fbbd61a4f5f518c7$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $fbbd61a4f5f518c7$var$errorCollector.delete(key);
    }, $fbbd61a4f5f518c7$export$da396ad2a542b095);
};
const $fbbd61a4f5f518c7$export$c211170518c6d0f6 = (key = (0, $2BKzr.default)())=>{
    $fbbd61a4f5f518c7$var$errorCollector.set(key, []);
    $fbbd61a4f5f518c7$var$scheduleCleanup(key);
    return key;
};
const $fbbd61a4f5f518c7$export$e0491a0d974dadfa = (key)=>{
    const errors = $fbbd61a4f5f518c7$var$errorCollector.get(key);
    $fbbd61a4f5f518c7$var$errorCollector.delete(key);
    return errors || [];
};
const $fbbd61a4f5f518c7$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $fbbd61a4f5f518c7$var$errorCollector.forEach((value, key)=>{
        $fbbd61a4f5f518c7$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $fbbd61a4f5f518c7$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};
const $fbbd61a4f5f518c7$export$60fba4117567a49b = (errors)=>{
    const stepUpError = errors.find((error)=>error.message.startsWith('Step-up authentication is required.') && error.extensions?.statusCode === 303 && error.extensions?.stepUpUrl);
    return {
        hasStepUpAuthError: !!stepUpError,
        stepUpUrl: stepUpError?.extensions?.stepUpUrl ?? undefined
    };
};

});

parcelRegister("grLh0", function(module, exports) {
$parcel$export(module.exports, "SSRQueryResponseCache", () => $dffe43ebbc7c566c$export$be21c283b097d175);

var $ArurZ = parcelRequire("ArurZ");
function $dffe43ebbc7c566c$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $ArurZ.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $dffe43ebbc7c566c$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
class $dffe43ebbc7c566c$export$be21c283b097d175 extends (0, $ArurZ.QueryResponseCache) {
    cacheName;
    requestMetadata;
    constructor({ cacheName: cacheName, size: size, ttl: ttl, timeoutCallback: timeoutCallback }){
        super({
            size: size,
            ttl: ttl
        });
        const isServer = typeof window === 'undefined';
        const cachedData = isServer ? {} : window?.SPA_STATE?.[cacheName] || window?.SKELETON_NAVIGATION?.[cacheName] || window?.__PLATFORM_SSR_AGG_CACHE__?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!isServer) setTimeout(()=>{
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            timeoutCallback?.(this._responses, this.requestMetadata);
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    /**
   * @deprecated only sets a single response; does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */ setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
   * Stores a GraphQLRepsonse along with metadata about the call.
   * If called multiple times (such as when incremental payloads are received),
   * will update the stored response to be an array of GraphQLSingularResponse objects,
   * which Relay is happy to handle.
   * @deprecated works, but does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */ appendWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        const currentResponse = this.get(queryID, variables);
        if (!currentResponse) this.set(queryID, variables, payload);
        else if (currentResponse instanceof Array) {
            const newResponse = [
                ...currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        } else {
            const newResponse = [
                currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        }
    }
    /**
   * Deletes a request from the store, if found.
   *
   * IMPORTANT: Make sure DELETE method always has tests that include get/set
   * to ensure our `getCacheKey` matches Relay's.
   *
   * @returns {boolean} indicating if an entry in the cache was deleted
   */ delete(queryID, variables) {
        const cacheKey = $dffe43ebbc7c566c$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
}

});



parcelRegister("fjjed", function(module, exports) {
$parcel$export(module.exports, "AnalyticsDataProvider", () => (parcelRequire("hn9bU")).AnalyticsDataProvider);
$parcel$export(module.exports, "devAnalyticsClient", () => (parcelRequire("6AigK")).devAnalyticsClient);
$parcel$export(module.exports, "FireScreenEvent", () => (parcelRequire("7hFVb")).FireScreenEvent);
$parcel$export(module.exports, "AnalyticsWebClientProvider", () => (parcelRequire("eajEV")).AnalyticsWebClientProvider);
$parcel$export(module.exports, "useAnalyticsWebClient", () => (parcelRequire("eajEV")).useAnalyticsWebClient);
$parcel$export(module.exports, "useRovoDevWebAnalyticsClient", () => (parcelRequire("aXHSI")).useRovoDevWebAnalyticsClient);
$parcel$export(module.exports, "AIEventsInstrumentationProvider", () => (parcelRequire("8fh7G")).AIEventsInstrumentationProvider);
$parcel$export(module.exports, "useDevAgentsAIAnalytics", () => (parcelRequire("3OyKJ")).useDevAgentsAIAnalytics);
$parcel$export(module.exports, "useDevAgentsAIAnalyticsConfig", () => (parcelRequire("3OyKJ")).useDevAgentsAIAnalyticsConfig);
// Analytics data context exports

var $hn9bU = parcelRequire("hn9bU");

var $6AigK = parcelRequire("6AigK");

var $7hFVb = parcelRequire("7hFVb");

var $eajEV = parcelRequire("eajEV");

var $aXHSI = parcelRequire("aXHSI");

var $8fh7G = parcelRequire("8fh7G");

var $3OyKJ = parcelRequire("3OyKJ");

});
parcelRegister("hn9bU", function(module, exports) {
$parcel$export(module.exports, "AnalyticsDataProvider", () => $345a115bd553d852$export$786a3c4de7070223);
$parcel$export(module.exports, "useAnalyticsData", () => $345a115bd553d852$export$45885672916a1436);

var $1v5pe = parcelRequire("1v5pe");

var $kIqwl = parcelRequire("kIqwl");
const $345a115bd553d852$var$AnalyticsDataContext = /*#__PURE__*/ (0, $1v5pe.createContext)({
    data: {}
});
const $345a115bd553d852$export$786a3c4de7070223 = ({ children: children, data: data = {} })=>{
    const parentContext = (0, $1v5pe.useContext)($345a115bd553d852$var$AnalyticsDataContext);
    const mergedData = (0, $1v5pe.useMemo)(()=>({
            ...parentContext.data,
            ...data
        }), [
        parentContext.data,
        data
    ]);
    const contextValue = (0, $1v5pe.useMemo)(()=>({
            data: mergedData
        }), [
        mergedData
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)($345a115bd553d852$var$AnalyticsDataContext.Provider, {
        value: contextValue,
        children: children
    });
};
const $345a115bd553d852$export$45885672916a1436 = ()=>{
    const context = (0, $1v5pe.useContext)($345a115bd553d852$var$AnalyticsDataContext);
    return context.data;
};

});

parcelRegister("6AigK", function(module, exports) {
$parcel$export(module.exports, "devAnalyticsClient", () => $db2e3c688a52bf29$export$b2e5abba3e61d1a4);
$parcel$export(module.exports, "devAIAnalyticsClient", () => $db2e3c688a52bf29$export$da0c9afabe276bd);

var $6yEEN = parcelRequire("6yEEN");

var $jcoDC = parcelRequire("jcoDC");
parcelRequire("JEkkv");
var $fYUfs = parcelRequire("fYUfs");
const $db2e3c688a52bf29$var$getApiHost = ()=>{
    const host = '';
    return `${host}/gateway/api/gasv3/api/v1/`;
};
const $db2e3c688a52bf29$export$b2e5abba3e61d1a4 = new (0, $jcoDC.default)({
    env: (0, $fYUfs.getEnvType)(),
    locale: 'en',
    product: 'devAgents',
    version: '1.0.0',
    origin: (0, $6yEEN.originType).WEB
}, (0, $fYUfs.isLocal)() ? {
    apiHost: $db2e3c688a52bf29$var$getApiHost(),
    disableCookiePersistence: true
} : {
    disableCookiePersistence: true
});
const $db2e3c688a52bf29$export$da0c9afabe276bd = new (0, $jcoDC.default)({
    env: (0, $fYUfs.getEnvType)(),
    locale: 'en',
    product: 'devAi',
    version: '1.0.0',
    origin: (0, $6yEEN.originType).WEB
}, (0, $fYUfs.isLocal)() ? {
    apiHost: $db2e3c688a52bf29$var$getApiHost(),
    disableCookiePersistence: true
} : {
    disableCookiePersistence: true
});

});
parcelRegister("6yEEN", function(module, exports) {
$parcel$export(module.exports, "envType", () => $a692e4b02a0c1cd3$export$56ac8ebc9870b1b9);
$parcel$export(module.exports, "eventType", () => $a692e4b02a0c1cd3$export$4c045e605d532c98);
$parcel$export(module.exports, "platformType", () => $a692e4b02a0c1cd3$export$6b4f396210e539f3);
$parcel$export(module.exports, "originType", () => $a692e4b02a0c1cd3$export$f73e9fcd368bb695);
$parcel$export(module.exports, "tenantType", () => $a692e4b02a0c1cd3$export$496f06ac2a964da2);
$parcel$export(module.exports, "productEmbedType", () => $a692e4b02a0c1cd3$export$f49776dca27a2e7c);
$parcel$export(module.exports, "userType", () => $a692e4b02a0c1cd3$export$1827adfd178b4870);
$parcel$export(module.exports, "apdexType", () => $a692e4b02a0c1cd3$export$99b37380a464d794);
$parcel$export(module.exports, "desktopPlatforms", () => $a692e4b02a0c1cd3$export$809831be6c4c6227);
$parcel$export(module.exports, "webPlatforms", () => $a692e4b02a0c1cd3$export$19c579398ad213e7);
$parcel$export(module.exports, "originTracingType", () => $a692e4b02a0c1cd3$export$62a500c02dc63ee);
$parcel$export(module.exports, "perimeterType", () => $a692e4b02a0c1cd3$export$bdd41749d2096e4b);
$parcel$export(module.exports, "aliasType", () => $a692e4b02a0c1cd3$export$a8c99e46b781d936);
$parcel$export(module.exports, "groupType", () => $a692e4b02a0c1cd3$export$e73680b18d9b7c6e);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.


var $a692e4b02a0c1cd3$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
var $a692e4b02a0c1cd3$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
var $a692e4b02a0c1cd3$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
   *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
   */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
var $a692e4b02a0c1cd3$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
var $a692e4b02a0c1cd3$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["STUDIO_WORKSPACE_ID"] = "studioWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
var $a692e4b02a0c1cd3$export$f49776dca27a2e7c = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
var $a692e4b02a0c1cd3$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $a692e4b02a0c1cd3$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $a692e4b02a0c1cd3$export$809831be6c4c6227 = Object.freeze([
    "desktop",
    "mac",
    "linux",
    "windows"
]);
const $a692e4b02a0c1cd3$export$19c579398ad213e7 = Object.freeze([
    "web",
    "mobileWeb"
]);
var $a692e4b02a0c1cd3$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
var $a692e4b02a0c1cd3$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
var $a692e4b02a0c1cd3$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
var $a692e4b02a0c1cd3$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
var $a692e4b02a0c1cd3$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("jcoDC", function(module, exports) {
$parcel$export(module.exports, "default", () => $54163c7a82e686f3$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $40Sn3 = parcelRequire("40Sn3");

var $kHb6M = parcelRequire("kHb6M");

var $6yEEN = parcelRequire("6yEEN");

var $1ZJYO = parcelRequire("1ZJYO");

var $3iYgg = parcelRequire("3iYgg");

var $lN1hr = parcelRequire("lN1hr");

var $8pyDj = parcelRequire("8pyDj");

var $lbIUD = parcelRequire("lbIUD");

var $3CH4k = parcelRequire("3CH4k");

var $dK0yy = parcelRequire("dK0yy");

var $atzxl = parcelRequire("atzxl");

var $gAgTu = parcelRequire("gAgTu");

var $h6Sce = parcelRequire("h6Sce");

var $b4wuS = parcelRequire("b4wuS");

var $4YfNf = parcelRequire("4YfNf");

var $fsyj7 = parcelRequire("fsyj7");

var $7ruzK = parcelRequire("7ruzK");

var $7YjGB = parcelRequire("7YjGB");

var $gxsPs = parcelRequire("gxsPs");

var $ezsdd = parcelRequire("ezsdd");

var $3ykaG = parcelRequire("3ykaG");

var $4Pm5b = parcelRequire("4Pm5b");

var $9D95u = parcelRequire("9D95u");

var $8kCZu = parcelRequire("8kCZu");

var $79qz9 = parcelRequire("79qz9");

var $fMH0v = parcelRequire("fMH0v");

var $lches = parcelRequire("lches");

var $lqefr = parcelRequire("lqefr");

var $g34ub = parcelRequire("g34ub");

var $akdUN = parcelRequire("akdUN");

var $cof0D = parcelRequire("cof0D");

var $grc8S = parcelRequire("grc8S");

var $l0B9l = parcelRequire("l0B9l");

var $j8q2U = parcelRequire("j8q2U");

var $foSph = parcelRequire("foSph");

var $fSLua = parcelRequire("fSLua");

var $6RBzd = parcelRequire("6RBzd");

var $hNvco = parcelRequire("hNvco");

var $jIMQu = parcelRequire("jIMQu");
const $54163c7a82e686f3$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $54163c7a82e686f3$export$2e2bcd8739ae039 {
    _apdexEvent;
    _context;
    _eventDelayQueue;
    _historyReplaceFn;
    _orgInfo;
    _pageVisibility;
    _internalProductInfo;
    _safeSessionStorage;
    _sessionTracking;
    _tabTracking;
    _tenantInfo;
    _testingCache;
    _uiViewedAttributes;
    _uiViewedEvent;
    _userInfo;
    _originTracing;
    _task;
    _pageLoadId;
    _workspaceInfo;
    _collaborationContextInfo;
    _aliases;
    _groups;
    _eventProcessor;
    _logger;
    _embeddedContext;
    _crossProductInteractionTracking;
    constructor(productInfo, settings = {}){
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $7ruzK.isType)((0, $6yEEN.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $gxsPs.objectValues)((0, $6yEEN.envType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $6yEEN.originType).WEB;
        else if (!(0, $7ruzK.isType)((0, $6yEEN.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $gxsPs.objectValues)((0, $6yEEN.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $6yEEN.originType).WEB ? (0, $6yEEN.platformType).WEB : (0, $6yEEN.platformType).DESKTOP;
        else (0, $j8q2U.validatePlatform)(productInfo);
        this._logger = settings.logger || console;
        // Auto-detect Oasis perimeter (e.g. FedRAMP Moderate) when the consumer hasn't explicitly provided a perimeter.
        if (!productInfo.perimeter) try {
            if ((0, $40Sn3.isFedrampModerate)()) productInfo.perimeter = (0, $6yEEN.perimeterType).FEDRAMP_MODERATE;
        } catch (e) {
            this._logger.warn('Failed to auto-detect perimeter: %s', e instanceof Error ? e.message : String(e));
        }
        // Default to commercial perimeter if not explicitly provided and not auto-detected.
        if (!productInfo.perimeter) productInfo.perimeter = (0, $6yEEN.perimeterType).COMMERCIAL;
        if (!(0, $7ruzK.isType)((0, $6yEEN.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be a perimeterType: [${(0, $gxsPs.objectValues)((0, $6yEEN.perimeterType))}]`);
        // Auto-detect Oasis Isolated Cloud (IC) environment when the consumer hasn't explicitly provided an `ic` value.
        if (!productInfo.ic) try {
            const icId = (0, $kHb6M.isolationContextId)();
            if (icId && icId.length > 0) productInfo.ic = icId;
        } catch (e) {
            this._logger.warn('Failed to auto-detect isolation context: %s', e instanceof Error ? e.message : String(e));
        }
        this._internalProductInfo = {
            ...productInfo,
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        };
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo?.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, $4YfNf.isFirstParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromProduct: this._embeddedContext['embeddedFromProduct'],
                embeddedFromSubproduct: this._embeddedContext['embeddedFromSubproduct'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
            if ((0, $fsyj7.isThirdParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
        }
        this._context = (0, $8pyDj.buildContext)(this._internalProductInfo);
        this._safeSessionStorage = new (0, $8kCZu.default)();
        const useStargate = this._useStargate(settings.useStargate);
        const apiHost = (0, $4Pm5b.selectHost)({
            useStargate: useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            ic: productInfo.ic,
            envOverride: productInfo.envOverride,
            apiHost: settings.apiHost
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const maxAttempts = settings.maxRetryAttempts !== undefined && Number.isInteger(settings.maxRetryAttempts) && settings.maxRetryAttempts >= 0 ? settings.maxRetryAttempts + 1 : undefined;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload,
            maxAttempts: maxAttempts,
            maxQueueSize: settings.maxQueueSize
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $jIMQu.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        const metadataClientFactory = settings.metadataClientFactory || (0, $b4wuS.MetadataClient).Factory;
        const metadataClient = metadataClientFactory(apiHostProtocol, apiHost, productInfo.product);
        this._eventProcessor = new (0, $h6Sce.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this._logger,
            metadataClient: metadataClient,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: (0, $7YjGB.LoggingResponseCallback).getCallback(this._logger),
            env: productInfo.env,
            perimeter: productInfo.perimeter,
            enableMetadataCalls: this.metadataCallsEnabled(settings),
            enableEventCalls: this.eventCallsEnabled(settings)
        });
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId(settings?.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $3ykaG.default)();
        this._tabTracking = new (0, $79qz9.default)();
        this._sessionTracking = new (0, $9D95u.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this._task = new (0, $fMH0v.default)();
        this._originTracing = new (0, $ezsdd.default)();
        this._eventProcessor.setOriginTracingClient(this._originTracing);
        // Init Apdex
        this._apdexEvent = new (0, $1ZJYO.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $atzxl.defaultHistoryReplaceFn);
        this._eventDelayQueue = new (0, $gAgTu.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $lches.default)(settings.isSynthetic, settings.enableTestingCache);
        this._pageLoadId = (0, $akdUN.default)();
        this._workspaceInfo = {};
        this._collaborationContextInfo = {};
        this._aliases = {};
        this._groups = {};
        this._crossProductInteractionTracking = new (0, $dK0yy.default)({
            perimeter: productInfo.perimeter,
            product: productInfo.product,
            sendEventCallback: this.sendOperationalEvent,
            historyReplaceFn: this._historyReplaceFn
        });
        this._crossProductInteractionTracking.validateInteractionSession();
    }
    metadataCallsEnabled(settings) {
        if (typeof settings.disableMetadataCalls === 'boolean') return !settings.disableMetadataCalls;
        return !(0, $g34ub.TestSupport).isGeminiVREnvironment() && !(0, $g34ub.TestSupport).areFetchCallsDisabled();
    }
    eventCallsEnabled(settings) {
        if (typeof settings.disableEventCalls === 'boolean') return !settings.disableEventCalls;
        return !(0, $g34ub.TestSupport).isGeminiVREnvironment() && !(0, $g34ub.TestSupport).areFetchCallsDisabled();
    }
    _useStargate = (useStargate)=>{
        if (useStargate == null) return true;
        return useStargate;
    };
    _changeInternalUserId = (userId, anonymousId)=>{
        this._eventProcessor.getUser().setUserId(userId);
        if (anonymousId && anonymousId !== this._eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
        // Only update if it has changed.
        this._eventProcessor.getUser().setAnonymousId(anonymousId);
    };
    _createSubproductGetter = (subproduct)=>(0, $3CH4k.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.');
    _createEmbeddedProductGetter = (embeddedProduct)=>(0, $3CH4k.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.');
    _getLastScreenEvent = ()=>{
        try {
            return JSON.parse(this._safeSessionStorage.getItem($54163c7a82e686f3$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
        } catch  {
            this._safeSessionStorage.removeItem($54163c7a82e686f3$var$LAST_SCREEN_EVENT_STORAGE_KEY);
            return null;
        }
    };
    _setLastScreenEvent = (event)=>{
        this._safeSessionStorage.setItem($54163c7a82e686f3$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
            name: event.name,
            attributes: event.attributes
        }));
    };
    _shouldEventBeDelayed = (event)=>{
        // TODO: this is a temporary restriction for the purposes of the Track All Changes project
        // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
        // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
        // then we will be able to open it up for other products to use by removing this check.
        if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
        const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
        return this._eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
    };
    _fireEvent = (identifier, builtEvent, context, callback)=>{
        switch(builtEvent.eventType){
            case (0, $6yEEN.eventType).UI:
            case (0, $6yEEN.eventType).OPERATIONAL:
            case (0, $6yEEN.eventType).TRACK:
                return this._eventProcessor.track(identifier, builtEvent, context, callback);
            case (0, $6yEEN.eventType).SCREEN:
                return this._eventProcessor.page(identifier, builtEvent, context, callback);
            case (0, $6yEEN.eventType).IDENTIFY:
                return this._eventProcessor.identify(identifier, builtEvent, context, callback);
            default:
                throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
        }
    };
    _fireDelayedEvent = (identifier, builtEvent, context, userInfo)=>{
        try {
            // User information can change while the delay period is active, so we need to restore the values that
            // were active when the event was originally fired.
            this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
            builtEvent.tags = [
                ...builtEvent.tags || [],
                'sentWithDelay'
            ];
            // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
            this._fireEvent(identifier, builtEvent, context, undefined);
        } finally{
            this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
        }
    };
    _delayEvent = (identifier, builtEvent, context, userInfo, callback)=>{
        this._eventDelayQueue.push(identifier, builtEvent, context, userInfo);
        // Fire the callback immediately, as we can consider the event successfully processed at this point
        if (callback) callback();
    };
    _processEvent = (identifier, builtEvent, context, callback)=>{
        this._testingCache.saveEvent(builtEvent);
        if (this._shouldEventBeDelayed(builtEvent)) {
            this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
            return Promise.resolve();
        } else return this._fireEvent(identifier, builtEvent, context, callback);
    };
    setEmbeddedProduct = (embeddedProduct)=>{
        this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
        this.resetUIViewedTimers();
    };
    clearEmbeddedProduct = ()=>{
        this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
    };
    setSubproduct = (subproduct)=>{
        this._internalProductInfo.subproduct = this._createSubproductGetter(subproduct);
        this.resetUIViewedTimers();
    };
    /**
    * Calling this function in the intialisation of the client in product
    * captures specified 'origin tracing' URL params and fires a single origin landed event
    * <p>
    * This function expects a mapping between the keys for any URL parameters
    *  that should be captured and removed for origin tracing
    * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
    * Each handler function should return an object with two items
    * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
    * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
    *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
    * </p>
    * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
    * e.g. from a share or email
    *
    * An example calling this function using an external decoding library, with taskSessionId specified to persist
    * analyticsWebClient.setOriginTracingHandlers({
         atlOrigin: encodedOrigin => {
             const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
             return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
         },
     });
    *
    * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
    * @this {AnalyticsWebClient}
    */ setOriginTracingHandlers = (originParamHandlerMapping)=>{
        const capturedOriginTraces = this._originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
        const keys = Object.keys(capturedOriginTraces);
        keys.forEach((x)=>{
            if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this._task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
        });
        const originAttributes = {};
        keys.forEach((x)=>{
            if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
            else // eslint-disable-next-line no-console
            console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
        });
        if (keys.length > 0) return this.sendOperationalEvent({
            action: 'landed',
            actionSubject: 'origin',
            source: 'webClient',
            attributes: {
                originTracesLanded: originAttributes
            }
        }, // eslint-disable-next-line @typescript-eslint/no-empty-function
        ()=>{});
        return Promise.resolve();
    };
    setTenantInfo = (tenantIdType, tenantId)=>{
        if (!tenantIdType) throw new Error('Missing tenantIdType');
        if (tenantIdType !== (0, $6yEEN.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
        if (!(0, $7ruzK.isType)((0, $6yEEN.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $gxsPs.objectValues)((0, $6yEEN.tenantType))}]`);
        this._tenantInfo = {
            tenantIdType: tenantIdType,
            tenantId: tenantId
        };
        this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
    };
    clearTenantInfo = ()=>{
        this._tenantInfo = {};
        this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
    };
    setOrgInfo = (orgId)=>{
        if (!orgId) throw new Error('Missing orgId');
        this._orgInfo = {
            orgId: orgId
        };
    };
    clearOrgInfo = ()=>{
        this._orgInfo = {};
    };
    setWorkspaceInfo = (workspaceId)=>{
        if (!workspaceId) throw new Error('Missing workspaceId');
        this._workspaceInfo = {
            workspaceId: workspaceId
        };
    };
    clearWorkspaceInfo = ()=>{
        this._workspaceInfo = {};
    };
    setCollaborationContextInfo = (collaborationContextAri)=>{
        if (!collaborationContextAri) throw new Error('Missing collaborationContextAri');
        this._collaborationContextInfo = {
            collaborationContextAri: collaborationContextAri
        };
    };
    clearCollaborationContextInfo = ()=>{
        this._collaborationContextInfo = {};
    };
    setUserInfo = (userIdType, userId)=>{
        (0, $grc8S.validateIdentifyEvent)(userIdType, userId);
        this._changeInternalUserId(userId);
        this._userInfo = {
            userIdType: userIdType,
            userId: userId,
            anonymousId: this._eventProcessor.getUser().getAnonymousId()
        };
        this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
    };
    clearUserInfo = ()=>{
        this._changeInternalUserId(undefined);
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId()
        };
        this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
    };
    setAlias = (aliasKeyType, alias)=>{
        if (!aliasKeyType) throw new Error('Missing aliasType');
        if (!(0, $7ruzK.isType)((0, $6yEEN.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $gxsPs.objectValues)((0, $6yEEN.aliasType))}]`);
        this._aliases[aliasKeyType] = alias;
    };
    clearAlias = ()=>{
        this._aliases = {};
    };
    setGroup = (groupsKeyType, group)=>{
        if (!groupsKeyType) throw new Error('Missing groupType');
        if (!(0, $7ruzK.isType)((0, $6yEEN.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $gxsPs.objectValues)((0, $6yEEN.groupType))}]`);
        this._groups[groupsKeyType] = group;
    };
    clearGroup = ()=>{
        this._groups = {};
    };
    getAnonymousId = ()=>this._userInfo.anonymousId;
    getCurrentSessionId = ()=>this._sessionTracking.getCurrentSessionId();
    setUIViewedAttributes = (uiViewedAttributes)=>{
        if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
        if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
        this._uiViewedAttributes = {
            ...uiViewedAttributes
        };
    };
    getUIViewedAttributes = ()=>{
        return this._uiViewedAttributes;
    };
    clearUIViewedAttributes = ()=>{
        this._uiViewedAttributes = {};
    };
    appendUIViewedAttributes = (attributes)=>{
        if (!this._uiViewedAttributes) this._uiViewedAttributes = attributes;
        else this._uiViewedAttributes = {
            ...this._uiViewedAttributes,
            ...attributes
        };
    };
    sendIdentifyEvent = (userIdType, userId, callback)=>{
        this.setUserInfo(userIdType, userId);
        const builtEvent = {
            userIdType: userIdType,
            eventType: (0, $6yEEN.eventType).IDENTIFY
        };
        return this._processEvent(userId, builtEvent, this._context, callback);
    };
    /**
   * @deprecated
   * please use {@link sendScreenEvent instead)
   */ sendPageEvent = (name, callback)=>{
        return this.sendScreenEvent(name, callback);
    };
    /**
   * send screen event
   * @param event The event / For retrocompatibility event name is still supported here.
   * @param callback
   * @param attributes. Deprecated, will get ignored if using an event object as first param.
   */ sendScreenEvent = (event, callback, attributes)=>{
        let screenName;
        let screenAttributes;
        let screenContainers;
        let screenTags;
        if (typeof event === 'object') {
            /* This is for retrocompatibility */ screenName = event.name;
            screenAttributes = event.attributes;
            screenContainers = event.containers;
            screenTags = event.tags;
        } else {
            screenName = event;
            screenAttributes = attributes;
        }
        (0, $foSph.validateScreenEvent)(screenName);
        (0, $cof0D.validateContainers)(screenContainers);
        const builtEvent = (0, $lbIUD.buildScreenEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
        event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, event, screenContainers, this._aliases, this._groups);
        const builtEventWithName = {
            name: screenName,
            ...builtEvent
        };
        this._setLastScreenEvent(builtEventWithName);
        return this._processEvent(screenName, builtEventWithName, this._context, (0, $hNvco.default)(callback, builtEventWithName));
    };
    sendTrackEvent = (event, callback)=>{
        (0, $fSLua.validateTrackEvent)(event);
        const builtEvent = (0, $3iYgg.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $6yEEN.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
        return this._processEvent((0, $lN1hr.buildActionName)(event), builtEvent, this._context, (0, $hNvco.default)(callback, builtEvent));
    };
    sendUIEvent = (event, callback)=>{
        (0, $6RBzd.validateUIEvent)(event);
        const builtEvent = (0, $3iYgg.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $6yEEN.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
        return this._processEvent((0, $lN1hr.buildActionName)(event), builtEvent, this._context, (0, $hNvco.default)(callback, builtEvent));
    };
    sendOperationalEvent = (event, callback)=>{
        (0, $l0B9l.validateOperationalEvent)(event);
        const builtEvent = (0, $3iYgg.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $6yEEN.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
        return this._processEvent((0, $lN1hr.buildActionName)(event), builtEvent, this._context, (0, $hNvco.default)(callback, builtEvent));
    };
    startUIViewedEvent = (callback)=>{
        this.stopUIViewedEvent();
        this._uiViewedEvent = this.createUIViewedEvent(callback);
        this._uiViewedEvent.start();
    };
    stopUIViewedEvent = ()=>{
        if (this._uiViewedEvent) {
            this._uiViewedEvent.stop();
            this._uiViewedEvent = null;
        }
    };
    resetUIViewedTimers = ()=>{
        if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
    };
    signalUserActive = ()=>{
        let uiViewedEvent = this._uiViewedEvent || this.createUIViewedEvent(null);
        uiViewedEvent.signalUserActive();
    };
    createUIViewedEvent = (callback)=>{
        return new (0, $lqefr.default)(this._internalProductInfo, ()=>({
                embeddedProduct: this._internalProductInfo.embeddedProduct(),
                subproduct: this._internalProductInfo.subproduct(),
                tenantIdType: this._tenantInfo.tenantIdType,
                tenantId: this._tenantInfo.tenantId,
                userId: this._userInfo.userId,
                lastScreenEvent: this._getLastScreenEvent(),
                attributes: this._uiViewedAttributes
            }), (event)=>this.sendUIEvent(event, callback));
    };
    startApdexEvent = (apdexEvent)=>{
        this._apdexEvent.start(apdexEvent);
    };
    getApdexStart = (apdexEvent)=>this._apdexEvent.getStart(apdexEvent);
    stopApdexEvent = (apdexEvent, callback)=>{
        this._apdexEvent.stop(apdexEvent, callback);
    };
    // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
    startLowPriorityEventDelay = (timeout, callback)=>{
        this._eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
    };
    stopLowPriorityEventDelay = ()=>{
        this._eventDelayQueue.stopLowPriorityEventDelay();
    };
    onEvent = (_analyticsId, analyticsData)=>{
        if (!analyticsData) throw new Error('Missing analyticsData');
        if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
        if (analyticsData.eventType === (0, $6yEEN.eventType).TRACK) return this.sendTrackEvent(analyticsData);
        else if (analyticsData.eventType === (0, $6yEEN.eventType).UI) return this.sendUIEvent(analyticsData);
        else if (analyticsData.eventType === (0, $6yEEN.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
        else if (analyticsData.eventType === (0, $6yEEN.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
        else if (analyticsData.eventType === (0, $6yEEN.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
        throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $gxsPs.objectValues)((0, $6yEEN.eventType))}]`);
    };
    setResponseCallback = (responseCallback)=>{
        this._eventProcessor.setResponseCallback(responseCallback);
    };
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties. They are not part of the public
   * API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get task() {
        return this._task;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties.
   * They are not part of the public API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get _productInfo() {
        return this._internalProductInfo;
    }
}

});
parcelRegister("kHb6M", function(module, exports) {
$parcel$export(module.exports, "isolationContextId", () => $9e342fc2b1cfe745$export$839b022803d38d4d);

var $ggGWC = parcelRequire("ggGWC");

var $dEnZ3 = parcelRequire("dEnZ3");
function $9e342fc2b1cfe745$export$839b022803d38d4d() {
    if (typeof document === 'undefined') // @ts-ignore
    return (0, $dEnZ3.isIsolatedCloud)() ? globalThis.ssrContext?.icName : undefined;
    const atlCtxCookieValues = (0, $ggGWC.parseAtlCtxCookies)();
    return atlCtxCookieValues?.icId;
}

});
parcelRegister("dEnZ3", function(module, exports) {
$parcel$export(module.exports, "isIsolatedCloud", () => $812d05a916a874d0$export$9186ccba8effc5de);

var $bIhqQ = parcelRequire("bIhqQ");

var $ggGWC = parcelRequire("ggGWC");
function $812d05a916a874d0$export$9186ccba8effc5de() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext?.isInIC ?? false;
    const atlCtxCookieValues = (0, $ggGWC.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $bIhqQ.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}

});
parcelRegister("bIhqQ", function(module, exports) {
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $70c90d79d9f5ec2b$export$d8347b4aae768c2d);

var $aPJb3 = parcelRequire("aPJb3");
const $70c90d79d9f5ec2b$export$d8347b4aae768c2d = [
    (0, $aPJb3.COMMERCIAL)
];

});



parcelRegister("1ZJYO", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb770e91d1096bd5$export$2e2bcd8739ae039);

var $6yEEN = parcelRequire("6yEEN");

var $7ruzK = parcelRequire("7ruzK");

var $3ykaG = parcelRequire("3ykaG");

var $9xHYC = parcelRequire("9xHYC");
class $bb770e91d1096bd5$export$2e2bcd8739ae039 {
    _isActiveEvents;
    _onEvent;
    _pageVisibility;
    _performance;
    _startedEvents;
    _threshold;
    _wasPreviouslyHidden;
    constructor(onEvent, pageVisibility){
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $3ykaG.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $9xHYC.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent({
            ...event,
            ...apdexFields,
            ...visibilityFields
        }, callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
    _getEventKey = ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task;
    _getEventTimingByName = (name)=>{
        const eventTimings = this._performance.getEntriesByName(name);
        const eventTiming = eventTimings[eventTimings.length - 1];
        return eventTiming;
    };
    _getApdexFields = (event)=>{
        const apdexTimings = this._getApdexTimings(event);
        const apdexScore = this._calculateApdex({
            duration: apdexTimings.duration,
            threshold: event.threshold
        });
        return {
            ...apdexTimings,
            apdex: apdexScore
        };
    };
    _getApdexTimings = (event)=>{
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        const startTime = event.startTime || this._getStartTime(event, eventStartName);
        const stopTime = event.stopTime || this._getStopTime();
        // We do some clean up of the marks and started events
        this._cleanApdexState(eventKey);
        return {
            startTime: startTime,
            stopTime: stopTime,
            duration: stopTime - startTime
        };
    };
    _getStartTime = (event, eventName)=>{
        let startTime;
        const timeOrigin = this._performance.getTimeOrigin();
        if (event.type === (0, $6yEEN.apdexType).INITIAL_LOAD) startTime = timeOrigin;
        else {
            const eventTiming = this._getEventTimingByName(eventName);
            startTime = timeOrigin + eventTiming.startTime;
        }
        return startTime;
    };
    _getStopTime = ()=>this._performance.getTimeOrigin() + this._performance.now();
    _cleanApdexState = (eventKey)=>{
        this._performance.clearMarks(`${eventKey}-start`);
        this._performance.clearMarks(`${eventKey}-stop`);
        this._startedEvents.delete(eventKey);
    };
    _getVisibilityFields = (event)=>{
        let isActiveTab;
        /**
     * For initialLoad type:
     * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
     *
     * For transition type:
     * 1. active status is tracked in active events map (_isActiveEvents)
     *
     * For any type, if startTime or stopTime is specified:
     * 1. If currently active (!_isHidden)
     */ if (event.type === (0, $6yEEN.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
        else if (event.type === (0, $6yEEN.apdexType).TRANSITION) {
            const eventKey = this._getEventKey(event);
            isActiveTab = this._isActiveEvents.get(eventKey);
        }
        if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
        return {
            isActiveTab: isActiveTab
        };
    };
    _calculateApdex = ({ duration: duration, threshold: threshold = this._threshold })=>{
        let apdex;
        const satisfiedThreshold = threshold;
        const tolerableThreshold = threshold * 4;
        if (duration <= satisfiedThreshold) apdex = 1;
        else if (duration <= tolerableThreshold) apdex = 0.5;
        else apdex = 0;
        return apdex;
    };
    _validateStartEvent = (event)=>{
        if (!event) throw new Error('Missing "event" in Apdex start event');
        if (!event.task) throw new Error('Missing "task" in Apdex start event');
        if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
        if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
    };
    _validateStopEvent = (event)=>{
        if (!event) throw new Error('Missing "event" in Apdex stop event');
        if (!event.task) throw new Error('Missing "task" in Apdex stop event');
        if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
        if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
        if (!event.type) throw new Error('Missing "type" in Apdex stop event');
        if (event.type && !(0, $7ruzK.isType)((0, $6yEEN.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
        if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
        /*
     * For a transition, if the startTime was not specified,
     * the start event should have been present.
     */ if (!event.startTime && event.type === (0, $6yEEN.apdexType).TRANSITION) {
            const eventKey = this._getEventKey(event);
            if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
        }
        if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
        if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
        if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
    };
    _shouldSendEvent = (event)=>{
        if (!event) return false;
        if (typeof event.apdex !== 'number') return false;
        return true;
    };
    _sendEvent = (event, callback)=>{
        if (this._shouldSendEvent(event)) this._onEvent({
            source: 'ui',
            action: 'readyForUser',
            actionSubject: 'ui',
            attributes: {
                ...event.additionalAttributes,
                task: event.task,
                taskId: event.taskId,
                type: event.type,
                threshold: event.threshold || this._threshold,
                apdex: event.apdex,
                startTime: event.startTime,
                stopTime: event.stopTime,
                duration: event.duration,
                isActiveTab: event.isActiveTab
            }
        }, callback);
    };
}

});
parcelRegister("7ruzK", function(module, exports) {
$parcel$export(module.exports, "isType", () => $942ae326c64d4b3c$export$26b9f946b448f23e);
function $942ae326c64d4b3c$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}

});

parcelRegister("3ykaG", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e68099b8055df71$export$2e2bcd8739ae039);
class $1e68099b8055df71$export$2e2bcd8739ae039 {
    _callbacks;
    _hidden;
    _isHidden;
    _visibilityChange;
    constructor(){
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
    _bindEventListeners = ()=>{
        document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
    };
    _handleVisibilityChange = ()=>{
        const isHidden = document[this._hidden];
        this._isHidden = isHidden;
        this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
    };
}

});

parcelRegister("9xHYC", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8e99bdabf07b9b0$export$2e2bcd8739ae039);
class $e8e99bdabf07b9b0$export$2e2bcd8739ae039 {
    _performance;
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}

});


parcelRegister("3iYgg", function(module, exports) {
$parcel$export(module.exports, "buildActionEvent", () => $1b7f8c1def5a81fb$export$7bf451af4a8e3dd9);

var $ccwBB = parcelRequire("ccwBB");

var $9Fdu2 = parcelRequire("9Fdu2");

var $esDM1 = parcelRequire("esDM1");

var $5z1qe = parcelRequire("5z1qe");

var $1s0TO = parcelRequire("1s0TO");

var $2CsWn = parcelRequire("2CsWn");

var $9GsyC = parcelRequire("9GsyC");

var $4PRIc = parcelRequire("4PRIc");

var $9yHtD = parcelRequire("9yHtD");

var $6G0jx = parcelRequire("6G0jx");

var $7aK3r = parcelRequire("7aK3r");
function $1b7f8c1def5a81fb$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, aliases, groups) {
    const productFields = (0, $9GsyC.buildProductFields)(productInfo, (0, $7aK3r.extractProductOverrides)(event));
    const tenantFields = (0, $4PRIc.buildTenantFields)(tenantInfo);
    const orgFields = (0, $2CsWn.buildOrgFields)(orgInfo);
    const workspaceFields = (0, $6G0jx.buildWorkspaceFields)(workspaceInfo);
    const collaborationContextFields = (0, $esDM1.buildCollaborationContextFields)(collaborationContextInfo);
    const userFields = (0, $9yHtD.buildUserFields)(userInfo);
    const actionFields = (0, $ccwBB.buildActionFields)(event, actionEventType);
    return {
        ...productFields,
        ...tenantFields,
        ...orgFields,
        ...userFields,
        ...actionFields,
        ...(0, $5z1qe.buildEventOverrides)(event),
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...collaborationContextFields,
        ...(0, $9Fdu2.buildAliases)(aliases),
        ...(0, $1s0TO.buildGroups)(groups)
    };
}

});
parcelRegister("ccwBB", function(module, exports) {
$parcel$export(module.exports, "buildActionFields", () => $aef1fe9e0da53e0a$export$655ecf7241feac42);

var $4sYlB = parcelRequire("4sYlB");
function $aef1fe9e0da53e0a$export$655ecf7241feac42(event, actionEventType) {
    return {
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType,
        ...(0, $4sYlB.buildContainersWithName)(event.containers)
    };
}

});
parcelRegister("4sYlB", function(module, exports) {
$parcel$export(module.exports, "buildContainersWithName", () => $7b54f3ab6b33c0aa$export$f045f238d77c002a);

var $4PVz9 = parcelRequire("4PVz9");

var $7G38G = parcelRequire("7G38G");

var $4DHf6 = parcelRequire("4DHf6");
function $7b54f3ab6b33c0aa$export$f045f238d77c002a(containers) {
    if ((0, $4DHf6.isNotEmptyObject)(containers)) {
        const validContainers = (0, $7G38G.filterAndBuildContainers)(containers);
        return (0, $4PVz9.buildAttributesWithName)('containers', validContainers);
    }
    return undefined;
}

});
parcelRegister("4PVz9", function(module, exports) {
$parcel$export(module.exports, "buildAttributesWithName", () => $0b0f0453a35bd567$export$55b70947967d0b50);

var $4DHf6 = parcelRequire("4DHf6");
function $0b0f0453a35bd567$export$55b70947967d0b50(name, attrObject) {
    return (0, $4DHf6.isNotEmptyObject)(attrObject) ? {
        [name]: attrObject
    } : undefined;
}

});
parcelRegister("4DHf6", function(module, exports) {
$parcel$export(module.exports, "isNotEmptyObject", () => $3e002eff01f90b9a$export$e0287cc73292b477);

var $gmwxH = parcelRequire("gmwxH");
function $3e002eff01f90b9a$export$e0287cc73292b477(obj) {
    return (0, $gmwxH.isPlainObject)(obj) && Object.keys(obj).length > 0;
}

});
parcelRegister("gmwxH", function(module, exports) {
$parcel$export(module.exports, "isPlainObject", () => $abbe47506c4ffbc8$export$53b83ca8eaab0383);
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $abbe47506c4ffbc8$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $abbe47506c4ffbc8$var$isObjectObject(o) {
    return $abbe47506c4ffbc8$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $abbe47506c4ffbc8$export$53b83ca8eaab0383(o) {
    if ($abbe47506c4ffbc8$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($abbe47506c4ffbc8$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});



parcelRegister("7G38G", function(module, exports) {
$parcel$export(module.exports, "filterAndBuildContainers", () => $0105553f665bac77$export$3f5115a568819c1a);
function $0105553f665bac77$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}

});



parcelRegister("9Fdu2", function(module, exports) {
$parcel$export(module.exports, "buildAliases", () => $ba60058d2167ecc4$export$2c4ef8ee173bbcaa);

var $4DHf6 = parcelRequire("4DHf6");
function $ba60058d2167ecc4$export$2c4ef8ee173bbcaa(aliases) {
    if ((0, $4DHf6.isNotEmptyObject)(aliases)) return {
        aliases: aliases
    };
    return undefined;
}

});

parcelRegister("esDM1", function(module, exports) {
$parcel$export(module.exports, "buildCollaborationContextFields", () => $6e559bb992c62c9e$export$d138783ff9effae1);
function $6e559bb992c62c9e$export$d138783ff9effae1(collaborationContextInfo) {
    return {
        collaborationContextAri: collaborationContextInfo.collaborationContextAri
    };
}

});

parcelRegister("5z1qe", function(module, exports) {
$parcel$export(module.exports, "buildEventOverrides", () => $34d8998188d499af$export$469803cc371327c2);
function $34d8998188d499af$export$469803cc371327c2(event) {
    let result = {};
    if (event.anonymousId) result.anonymousId = event.anonymousId;
    if (event.excludedProperties) result.excludedProperties = event.excludedProperties;
    if (event.userConsents) result.userConsents = event.userConsents;
    return result;
}

});

parcelRegister("1s0TO", function(module, exports) {
$parcel$export(module.exports, "buildGroups", () => $f0d143005b7667d1$export$680f59e10d3eb269);

var $4DHf6 = parcelRequire("4DHf6");
function $f0d143005b7667d1$export$680f59e10d3eb269(groups) {
    if ((0, $4DHf6.isNotEmptyObject)(groups)) return {
        groups: groups
    };
    return undefined;
}

});

parcelRegister("2CsWn", function(module, exports) {
$parcel$export(module.exports, "buildOrgFields", () => $63758ee62a4f1e1b$export$19ccbe55c9aa75d5);
function $63758ee62a4f1e1b$export$19ccbe55c9aa75d5(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}

});

parcelRegister("9GsyC", function(module, exports) {
$parcel$export(module.exports, "buildProductFields", () => $7cd56c5bc3b0bf62$export$bd1896e45d2ef8e8);

var $kQaMY = parcelRequire("kQaMY");
function $7cd56c5bc3b0bf62$export$bd1896e45d2ef8e8(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = (0, $kQaMY.getProductField)(productInfo.env, overrides.env);
    const product = (0, $kQaMY.getProductField)(productInfo.product, overrides.product);
    const subproduct = (0, $kQaMY.getProductField)(productInfo.subproduct(), overrides.subproduct);
    const version = (0, $kQaMY.getProductField)(productInfo.version, overrides.version);
    const origin = (0, $kQaMY.getProductField)(productInfo.origin, overrides.origin);
    const platform = (0, $kQaMY.getProductField)(productInfo.platform, overrides.platform);
    const ic = productInfo.ic; // ic should not be overriden once set
    const cdp = productInfo.cdp;
    const csp = productInfo.csp;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform,
        ic: ic,
        cdp: cdp,
        csp: csp
    };
}

});
parcelRegister("kQaMY", function(module, exports) {
$parcel$export(module.exports, "getProductField", () => $e2af6aa32a904c3a$export$690c718dc8037b2e);
function $e2af6aa32a904c3a$export$690c718dc8037b2e(field, override) {
    return override === undefined ? field : override;
}

});


parcelRegister("4PRIc", function(module, exports) {
$parcel$export(module.exports, "buildTenantFields", () => $1908dd568b6686f6$export$ab02ab56ae59d840);
function $1908dd568b6686f6$export$ab02ab56ae59d840(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}

});

parcelRegister("9yHtD", function(module, exports) {
$parcel$export(module.exports, "buildUserFields", () => $b19436ed040f8c1b$export$4557a3fdd8921d68);
function $b19436ed040f8c1b$export$4557a3fdd8921d68(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}

});

parcelRegister("6G0jx", function(module, exports) {
$parcel$export(module.exports, "buildWorkspaceFields", () => $f0d3e0fc12391323$export$73c41604cd4b31da);
function $f0d3e0fc12391323$export$73c41604cd4b31da(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}

});

parcelRegister("7aK3r", function(module, exports) {
$parcel$export(module.exports, "extractProductOverrides", () => $7a92e3d12dbbb862$export$e3d99b4bfec06f6e);
function $7a92e3d12dbbb862$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}

});


parcelRegister("lN1hr", function(module, exports) {
$parcel$export(module.exports, "buildActionName", () => $9fcf9612755f891a$export$9c5623a792efc9b0);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $9fcf9612755f891a$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}

});

parcelRegister("8pyDj", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $25cb2866e2d44cd5$export$3a7fe28f9bf4f3d9);

var $d7DAo = parcelRequire("d7DAo");
const $25cb2866e2d44cd5$var$libraryVersion = undefined;
function $25cb2866e2d44cd5$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return (0, $d7DAo.validationMode).QUIET;
    if (environment.includes('prod')) return (0, $d7DAo.validationMode).QUIET;
    return (0, $d7DAo.validationMode).COMPLETE;
}
function $25cb2866e2d44cd5$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $25cb2866e2d44cd5$var$libraryVersion
            },
            validationMode: $25cb2866e2d44cd5$var$getDefaultValidationMode(productInfo)
        }
    };
}

});
parcelRegister("d7DAo", function(module, exports) {
$parcel$export(module.exports, "validationMode", () => $2dd4ee677fb28b79$export$fbd92247fb4d6159);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $2dd4ee677fb28b79$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});

});


parcelRegister("lbIUD", function(module, exports) {
$parcel$export(module.exports, "buildScreenEvent", () => $50850c72f9250f53$export$c7d9a5f56acc4b19);

var $6yEEN = parcelRequire("6yEEN");

var $9Fdu2 = parcelRequire("9Fdu2");

var $4PVz9 = parcelRequire("4PVz9");

var $esDM1 = parcelRequire("esDM1");

var $4sYlB = parcelRequire("4sYlB");

var $5z1qe = parcelRequire("5z1qe");

var $1s0TO = parcelRequire("1s0TO");

var $3EHhC = parcelRequire("3EHhC");

var $2CsWn = parcelRequire("2CsWn");

var $9GsyC = parcelRequire("9GsyC");

var $4PRIc = parcelRequire("4PRIc");

var $9yHtD = parcelRequire("9yHtD");

var $6G0jx = parcelRequire("6G0jx");
function $50850c72f9250f53$var$buildAttributes(attributes) {
    return (0, $4PVz9.buildAttributesWithName)('attributes', attributes);
}
function $50850c72f9250f53$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return (0, $4PVz9.buildAttributesWithName)('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $50850c72f9250f53$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, event, containers, aliases, groups) {
    const productFields = (0, $9GsyC.buildProductFields)(productInfo);
    const tenantFields = (0, $4PRIc.buildTenantFields)(tenantInfo);
    const userFields = (0, $9yHtD.buildUserFields)(userInfo);
    const orgFields = (0, $2CsWn.buildOrgFields)(orgInfo);
    const workspaceFields = (0, $6G0jx.buildWorkspaceFields)(workspaceInfo);
    const collaborationContextFields = (0, $esDM1.buildCollaborationContextFields)(collaborationContextInfo);
    return {
        eventType: (0, $6yEEN.eventType).SCREEN,
        ...productFields,
        ...tenantFields,
        ...userFields,
        ...orgFields,
        ...(0, $3EHhC.buildLocationFields)(event),
        ...$50850c72f9250f53$var$buildAttributes(attributes),
        ...$50850c72f9250f53$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes),
        ...(0, $4sYlB.buildContainersWithName)(containers),
        ...(0, $5z1qe.buildEventOverrides)(event),
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...collaborationContextFields,
        ...(0, $9Fdu2.buildAliases)(aliases),
        ...(0, $1s0TO.buildGroups)(groups)
    };
}

});
parcelRegister("3EHhC", function(module, exports) {
$parcel$export(module.exports, "buildLocationFields", () => $363477e36367657e$export$6dfd201add24e54d);
function $363477e36367657e$export$6dfd201add24e54d(event) {
    const payload = typeof event === 'object' ? event : undefined;
    return {
        title: '',
        path: typeof payload?.path === 'string' ? payload.path : '',
        url: typeof payload?.url === 'string' ? payload.url : '',
        referrer: '',
        search: ''
    };
}

});


parcelRegister("3CH4k", function(module, exports) {
$parcel$export(module.exports, "default", () => $a91154a2bb04128b$export$2e2bcd8739ae039);
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $a91154a2bb04128b$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $a91154a2bb04128b$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($a91154a2bb04128b$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("dK0yy", function(module, exports) {
$parcel$export(module.exports, "default", () => $53f26d303ce3621e$export$2e2bcd8739ae039);

var $6V50t = parcelRequire("6V50t");

var $5mPNA = parcelRequire("5mPNA");

var $9t0G7 = parcelRequire("9t0G7");

var $6yEEN = parcelRequire("6yEEN");

var $aNsr9 = parcelRequire("aNsr9");
const $53f26d303ce3621e$var$isCrossProductInteractionAttribute = (_, paramName)=>{
    return paramName === (0, $5mPNA.URL_QUERY_PARAM_INTERACTION_SESSION);
};
class $53f26d303ce3621e$export$2e2bcd8739ae039 {
    analyticsCrossProductInteractionClient;
    isEnabled;
    urlValidation;
    sendEventCallback;
    validProduct = false;
    constructor(options){
        this.isEnabled = options.perimeter !== (0, $6yEEN.perimeterType).FEDRAMP_MODERATE;
        this.urlValidation = {
            result: true,
            url: ''
        };
        this.sendEventCallback = options.sendEventCallback;
        if (this.isEnabled) {
            let bridge;
            let interactionSessionId;
            let interactionSource;
            let interactionSessionOptions;
            this.urlValidation.url = window.location.href;
            // Validate product
            //
            // Various UI components in the page might initialize their own AWC instances but some of those
            // instances might be associated with subordinate products that are of no interest to XPC tracking. We
            // want to avoid XPC meta analytics being fired against uninteresting products.
            //
            // Some products (e.g. Confluence) also have custom URL replace functions passed into AWC settings,
            // and we need to use those to ensure our query parameter is correctly processed.
            //
            // TODO - this is currently the best way we can try and guarantee that the most relevant product's AWC
            // is passing in the options. Down the line we ideally want the relevant products themselves to opt-in
            // to initialising cross product tracking via a flag in their AWC init options.
            this.validProduct = (0, $9t0G7.validProducts).includes(options.product);
            if (this.validProduct) {
                // Only parse URL parameters if we are in a valid product
                const crossProductUrlPramater = (0, $aNsr9.default)($53f26d303ce3621e$var$isCrossProductInteractionAttribute, options.historyReplaceFn);
                const interactionSessionBlob = (0, $5mPNA.URL_QUERY_PARAM_INTERACTION_SESSION) in crossProductUrlPramater ? crossProductUrlPramater[0, $5mPNA.URL_QUERY_PARAM_INTERACTION_SESSION] : null;
                if (interactionSessionBlob) try {
                    const interactionSession = JSON.parse(atob(interactionSessionBlob));
                    if (interactionSession.bridge && interactionSession.id && interactionSession.source) {
                        // All 3 fields must be present from a valid query param
                        bridge = interactionSession.bridge;
                        interactionSessionId = interactionSession.id;
                        interactionSource = interactionSession.source;
                    } else this.urlValidation.result = false;
                } catch  {
                    // Gracefully fail through if parameter has been corrupted
                    this.urlValidation.result = false;
                }
                interactionSessionOptions = {
                    analyticsEventCallback: this.sendEventCallback,
                    persistedSessionId: interactionSessionId
                };
            }
            // Initialise interaction session client with parsed values if they exist
            this.analyticsCrossProductInteractionClient = new (0, $6V50t.default)(interactionSessionOptions, bridge, interactionSource);
        }
    }
    getInteractionSession() {
        if (this.isEnabled && this.analyticsCrossProductInteractionClient) return {
            bridge: this.analyticsCrossProductInteractionClient.getBridge(),
            id: this.analyticsCrossProductInteractionClient.getCurrentInteractionSessionId(),
            prevId: this.analyticsCrossProductInteractionClient.getPreviousInteractionSessionId(),
            source: this.analyticsCrossProductInteractionClient.getInteractionSource()
        };
        else return {
            bridge: null,
            id: null,
            prevId: null,
            source: null
        };
    }
    /**
   * Validates the cross product interaction session parameters parsed from the URL (if present)
   * If the Base64-encoded URL does not decode into a valid JSON object
   *
   * This method must be called out of the constructor, as the sendEventCallback we expect here
   * depends on crossProductInteractionTracking.getInteractionSession() so the class must be initialised
   */ validateInteractionSession() {
        if (!this.urlValidation.result) this.sendEventCallback({
            action: 'corrupted',
            actionSubject: 'interactionSession',
            attributes: {
                url: this.urlValidation.url
            },
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
}

});
parcelRegister("6V50t", function(module, exports) {
$parcel$export(module.exports, "default", () => $830da856f38c5e68$export$2e2bcd8739ae039);

var $cc5qg = parcelRequire("cc5qg");

var $40Sn3 = parcelRequire("40Sn3");

var $2aEiL = parcelRequire("2aEiL");

var $f2gT6 = parcelRequire("f2gT6");

var $cqoOu = parcelRequire("cqoOu");
const $830da856f38c5e68$export$b9dd752fb13352ce = 'interactionSession.source';
const $830da856f38c5e68$export$e04e3c50573f9af7 = 'interactionSession.bridge';
class $830da856f38c5e68$export$2e2bcd8739ae039 {
    safeSessionStorage;
    interactionSessionTracking;
    isEnabled;
    constructor(interactionSessionOptions, bridge, interactionSource){
        const shouldDisable = (0, $2aEiL.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, $cc5qg.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, $40Sn3.isFedrampModerate)();
        this.isEnabled = !shouldDisable;
        if (this.isEnabled) {
            // Get singleton interaction session tracking instance
            this.interactionSessionTracking = (0, $f2gT6.default).getInstance();
            let isValidPersistedId = false;
            if (this.interactionSessionTracking) {
                if (interactionSessionOptions) {
                    this.interactionSessionTracking.setAnalyticsCallback(interactionSessionOptions.analyticsEventCallback);
                    isValidPersistedId = this.interactionSessionTracking.setInteractionSessionId(interactionSessionOptions.persistedSessionId);
                }
            }
            this.safeSessionStorage = new (0, $cqoOu.default)();
            // Store other interaction session parameters directly in session storage if ID has been validated
            if (isValidPersistedId) {
                bridge && this.safeSessionStorage.setItem($830da856f38c5e68$export$e04e3c50573f9af7, bridge);
                interactionSource && this.safeSessionStorage.setItem($830da856f38c5e68$export$b9dd752fb13352ce, interactionSource);
            }
        }
    }
    getCurrentInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getCurrentInteractionSessionId() : null;
    getPreviousInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getPreviousInteractionSessionId() : null;
    getBridge = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($830da856f38c5e68$export$e04e3c50573f9af7) : null;
    getInteractionSource = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($830da856f38c5e68$export$b9dd752fb13352ce) : null;
}

});
parcelRegister("cc5qg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $5JCtR = parcelRequire("5JCtR");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabled", {
    enumerable: true,
    get: function() {
        return $5JCtR.isEnvironmentBlockEnabled;
    }
});
Object.defineProperty(module.exports, "isFeatureEnabled", {
    enumerable: true,
    get: function() {
        return $5JCtR.isFeatureEnabled;
    }
});

});
parcelRegister("5JCtR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAuditState = module.exports.configureAuditState = module.exports.shouldEnableForAudit = module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $40Sn3 = parcelRequire("40Sn3");
var $dEnZ3 = parcelRequire("dEnZ3");
var $kHb6M = parcelRequire("kHb6M");

var $hFywt = parcelRequire("hFywt");

var $4qXSO = parcelRequire("4qXSO");

var $1wz5q = parcelRequire("1wz5q");

var $kLfgy = parcelRequire("kLfgy");
const $42cf0131eca6fd98$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX = "aem-audit";
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @returns if the environment block is available in the current cloud environment
 */ function $42cf0131eca6fd98$var$isEnvironmentBlockEnabled(environmentBlockName) {
    const boundaryKey = $42cf0131eca6fd98$var$getBoundaryKey();
    return (0, $4qXSO.isEnvironmentBlockEnabledForBoundary)(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabled = $42cf0131eca6fd98$var$isEnvironmentBlockEnabled;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param offeringPredicates Optional map of boundary keys to predicate functions. When a predicate
 *   is provided for the current boundary, the feature is only considered enabled if both
 *   the AEM state and the predicate return true.
 * @returns if the feature is available in the current cloud environment
 */ function $42cf0131eca6fd98$var$isFeatureEnabled(environmentBlockName, featureName, offeringPredicates) {
    const override = (0, $1wz5q.getFeatureOverride)(environmentBlockName, featureName);
    if (override !== null) return override;
    const boundaryKey = $42cf0131eca6fd98$var$getBoundaryKey();
    const aemResult = (0, $4qXSO.isFeatureEnabledForBoundary)(environmentBlockName, featureName, boundaryKey);
    // Keep predicate evaluation deferred until AEM or an explicit fallback resolves the feature as enabled.
    const isAllowedForCurrentOffering = ()=>{
        const predicate = offeringPredicates ? offeringPredicates[boundaryKey] : undefined;
        return predicate ? predicate() : true;
    };
    if (!aemResult) {
        const metadata = (0, $4qXSO.getFeatureAvailabilityMetadataForBoundary)(environmentBlockName, featureName, boundaryKey);
        if ($42cf0131eca6fd98$var$shouldEnableForIcPreRelease(metadata, boundaryKey)) return isAllowedForCurrentOffering();
        if ((0, $kLfgy.isSSR)()) return false; // SSR: fallback to standard AEM resolution
        if (metadata && metadata.auditPhase) return $42cf0131eca6fd98$var$shouldEnableForAudit(metadata.auditPhase, environmentBlockName, featureName);
        return false; // fallback to default behavior when not in audit state
    }
    return isAllowedForCurrentOffering();
}
module.exports.isFeatureEnabled = $42cf0131eca6fd98$var$isFeatureEnabled;
/** Enables IC pre-release features only for the pre-release isolation context. */ function $42cf0131eca6fd98$var$shouldEnableForIcPreRelease(metadata, boundaryKey) {
    return boundaryKey === $4qXSO.ISOLATED_CLOUD_COMMERCIAL_KEY && (0, $kHb6M.isolationContextId)() === "ic-dr6" && metadata !== undefined && metadata.preRelease === true;
}
/**
 * Determines whether a feature that is not enabled via standard AEM resolution
 * should be enabled due to an active audit phase.
 *
 * This function should only be called for excluded features in browser contexts that have an active
 * audit phase. It applies the following rules:
 *
 * | Phase            | Environment | localStorage key set? | Result  |
 * | ---------------- | ----------- | --------------------- | ------- |
 * | internal-audit   | non-prod    | any                   | true    |
 * | internal-audit   | prod        | any                   | false   |
 * | external-audit   | non-prod    | any                   | true    |
 * | external-audit   | prod        | yes ("true")          | true    |
 * | external-audit   | prod        | no                    | false   |
 *
 * In SSR contexts (no window/localStorage), this falls back to false
 * for any case that would require a localStorage check.
 */ function $42cf0131eca6fd98$var$shouldEnableForAudit(auditPhase, environmentBlockName, featureName) {
    const envType = (0, $kLfgy.getEnvironmentType)();
    if (envType === "non-prod") return true;
    if (auditPhase === $4qXSO.UnderAuditPhase.EXTERNAL_AUDIT && !(0, $kLfgy.isSSR)() && localStorage.getItem(`${$42cf0131eca6fd98$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`) === "true") return true;
    return false;
}
module.exports.shouldEnableForAudit = $42cf0131eca6fd98$var$shouldEnableForAudit;
function $42cf0131eca6fd98$var$getBoundaryKey() {
    if ((0, $40Sn3.isFedrampModerate)()) return $4qXSO.FED_MOD_KEY;
    if ((0, $dEnZ3.isIsolatedCloud)()) return $4qXSO.ISOLATED_CLOUD_COMMERCIAL_KEY;
    if ((0, $hFywt.isGoogleCloudPlatform)()) return $4qXSO.GOOGLE_CLOUD_PLATFORM_KEY;
    return $4qXSO.COMMERCIAL_KEY;
}
function $42cf0131eca6fd98$var$configureAuditState(environmentBlockName, featureName, value) {
    localStorage.setItem(`${$42cf0131eca6fd98$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`, value);
}
module.exports.configureAuditState = $42cf0131eca6fd98$var$configureAuditState;
function $42cf0131eca6fd98$var$clearAuditState(environmentBlockName, featureName) {
    localStorage.removeItem(`${$42cf0131eca6fd98$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`);
}
module.exports.clearAuditState = $42cf0131eca6fd98$var$clearAuditState;
// Register global API on window for browser dev tools usage
if (typeof window !== "undefined") window.__AEM_FEATURE_JS__ = {
    checkFeature: $42cf0131eca6fd98$var$isFeatureEnabled,
    overrideFeature: $1wz5q.overrideFeature,
    clearFeatureOverride: $1wz5q.clearFeatureOverride,
    clearAllOverrides: $1wz5q.clearAllOverrides,
    configureAuditState: $42cf0131eca6fd98$var$configureAuditState,
    clearAuditState: $42cf0131eca6fd98$var$clearAuditState
};

});
parcelRegister("hFywt", function(module, exports) {
$parcel$export(module.exports, "isGoogleCloudPlatform", () => $79c3b122dcb073e4$export$d62bd105df52518a);

var $aPJb3 = parcelRequire("aPJb3");

var $4KYU8 = parcelRequire("4KYU8");
function $79c3b122dcb073e4$export$d62bd105df52518a() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext?.isInGCP ?? false;
    try {
        const cookies = globalThis.document.cookie;
        const cloudServiceProvider = (0, $4KYU8.getRawCookieValue)((0, $aPJb3.BIFROST_ATL_CTX_CLOUD_SERVICE_PROVIDER), cookies);
        return cloudServiceProvider === (0, $aPJb3.CLOUD_SERVICE_PROVIDER_GCP);
    } catch (e) {
        return false;
    }
}

});

parcelRegister("4qXSO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GOOGLE_CLOUD_PLATFORM_KEY = module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

var $hcZ24 = parcelRequire("hcZ24");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $hcZ24.isEnvironmentBlockEnabledForBoundary;
    }
});

var $hcZ24 = parcelRequire("hcZ24");
Object.defineProperty(module.exports, "isFeatureEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $hcZ24.isFeatureEnabledForBoundary;
    }
});

var $hcZ24 = parcelRequire("hcZ24");
Object.defineProperty(module.exports, "getFeatureAvailabilityMetadataForBoundary", {
    enumerable: true,
    get: function() {
        return $hcZ24.getFeatureAvailabilityMetadataForBoundary;
    }
});

var $1pIeV = parcelRequire("1pIeV");
Object.defineProperty(module.exports, "BOUNDARY_KEYS_LIST", {
    enumerable: true,
    get: function() {
        return $1pIeV.BOUNDARY_KEYS_LIST;
    }
});
Object.defineProperty(module.exports, "UnderAuditPhase", {
    enumerable: true,
    get: function() {
        return $1pIeV.UnderAuditPhase;
    }
});
Object.defineProperty(module.exports, "COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $1pIeV.COMMERCIAL_KEY;
    }
});
Object.defineProperty(module.exports, "FED_MOD_KEY", {
    enumerable: true,
    get: function() {
        return $1pIeV.FED_MOD_KEY;
    }
});
Object.defineProperty(module.exports, "ISOLATED_CLOUD_COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $1pIeV.ISOLATED_CLOUD_COMMERCIAL_KEY;
    }
});
Object.defineProperty(module.exports, "GOOGLE_CLOUD_PLATFORM_KEY", {
    enumerable: true,
    get: function() {
        return $1pIeV.GOOGLE_CLOUD_PLATFORM_KEY;
    }
});

});
parcelRegister("hcZ24", function(module, exports) {
"use strict";
var $c872e66d13fefca4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

const $c872e66d13fefca4$var$sdk_data_json_1 = $c872e66d13fefca4$var$__importDefault((parcelRequire("5FmmH")));
const $c872e66d13fefca4$var$aemEnvironmentBlockData = $c872e66d13fefca4$var$sdk_data_json_1.default;
// Build reverse map: offeringId -> offeringShortKeyId, derived from compositionKeyMap (offeringShortKeyId -> offeringId)
const $c872e66d13fefca4$var$offeringToOfferingShortKeyId = Object.fromEntries(Object.entries($c872e66d13fefca4$var$aemEnvironmentBlockData.compositionKeyMap).map(([offeringShortKeyId, offeringId])=>[
        offeringId,
        offeringShortKeyId
    ]));
/**
 * Translates a full offering ID (BoundaryKey) to its short SDK key name.
 * Falls back to the original key if no mapping exists.
 */ function $c872e66d13fefca4$var$toofferingShortKeyId(boundaryKey) {
    const mapped = $c872e66d13fefca4$var$offeringToOfferingShortKeyId[boundaryKey];
    return mapped !== undefined && mapped !== null ? mapped : boundaryKey;
}
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @param boundaryKey The boundary to evaluate for.
 *
 * @returns if the environment block is available in the current cloud environment
 */ function $c872e66d13fefca4$var$isEnvironmentBlockEnabledForBoundary(environmentBlockName, boundaryKey) {
    return $c872e66d13fefca4$var$environmentBlockInBoundary(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabledForBoundary = $c872e66d13fefca4$var$isEnvironmentBlockEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns if the feature is available in the current cloud environment
 */ function $c872e66d13fefca4$var$isFeatureEnabledForBoundary(environmentBlockName, featureName, boundaryKey) {
    if ($c872e66d13fefca4$var$environmentBlockInBoundary(environmentBlockName, boundaryKey)) {
        const environmentBlockData = $c872e66d13fefca4$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
        const feature = environmentBlockData.features[featureName];
        if (!feature) return false;
        return feature.compositions[$c872e66d13fefca4$var$toofferingShortKeyId(boundaryKey)] === true;
    }
    return false;
}
module.exports.isFeatureEnabledForBoundary = $c872e66d13fefca4$var$isFeatureEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns the availability metadata for the feature in the given boundary, or undefined if none
 */ function $c872e66d13fefca4$var$getFeatureAvailabilityMetadataForBoundary(environmentBlockName, featureName, boundaryKey) {
    const block = $c872e66d13fefca4$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return undefined;
    const feature = block.features[featureName];
    if (!feature) return undefined;
    return feature.availabilityMetadata && feature.availabilityMetadata[$c872e66d13fefca4$var$toofferingShortKeyId(boundaryKey)];
}
module.exports.getFeatureAvailabilityMetadataForBoundary = $c872e66d13fefca4$var$getFeatureAvailabilityMetadataForBoundary;
function $c872e66d13fefca4$var$environmentBlockInBoundary(environmentBlockName, boundaryKey) {
    const block = $c872e66d13fefca4$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return false;
    return block.compositions[$c872e66d13fefca4$var$toofferingShortKeyId(boundaryKey)] === true;
}

});
parcelRegister("5FmmH", function(module, exports) {
module.exports = JSON.parse("{\"compositionKeyMap\":{\"cc\":\"commercial-cloud\",\"gcp\":\"google-cloud-platform\",\"ic\":\"isolated-cloud-commercial\",\"fm\":\"fedramp-moderate\"},\"environmentBlocks\":{\"adminhub\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"adminhub-access-requests\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-beta-grid\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-collections-grid\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-discover-grid\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-enterprise-grid\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-add-app-standalone-apps-grid\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-product\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-admin-insights\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-ai-enabled-apps\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-api-token-and-key-management\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"adminhub-api-token-controls\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-app-requests\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-app-updates\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-application-tunnels\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-apps-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-atlassian-guard-standard\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-atlassian-intelligence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-audit-log\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-authentication-management\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"adminhub-authentication-policies\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-automations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-backup-and-restore\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-billing-console\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"adminhub-billing-preview\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"adminhub-byok\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-cart\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"adminhub-cmk-encryption\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-code-intelligence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-connected-emoji\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-connected-sources\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-connector-protection\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-contacts\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-custom-domain-email-notification\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-custom-domains\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-data-classifications\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-data-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-data-residency\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-data-security-policies\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-data-transfer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-delta-migrations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-disaster-recovery\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"adminhub-discover-apps-shadow-it\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-discover-new-products\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-enable-user-merge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-encryption\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-environments\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-experiment-controls\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-external-user-security\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-findings\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"adminhub-footprint\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-freeze-windows\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-guard-detect-alerts\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-guard-detect-detections\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-help\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-hippa-compliance\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"adminhub-jsm-scim\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-link-bitbucket\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-llm\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-local-transcript-upload\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-login-customisation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-managed-accounts-export\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-marketplace-apps\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-mcp-settings\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-mobile-app-policy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-nested-side-navigation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-org-audit-logs\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-org-create\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-org-deletion\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-org-transfer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-performance-monitoring\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-platform-usage\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-policies\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-portfolio-insights\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"adminhub-product-insights-workflow-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-insights\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-links\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-product-recommendation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-product-urls\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-release-tracks\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-revamped-organization-overview\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-rovo-access\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-rovo-chat-protection\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-rovo-insights\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-rovo-mcp-server\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-rovo-settings\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-saml-sso\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-sandbox\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-sdp-policy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"adminhub-searchbar\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-security-checklist\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-sensitive-data-policies\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-signup\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-site-rename\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-site-transfer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-system-health\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-team-site-assignment\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-teams\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-teamwork-graph-cli\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-units\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-use-available-apps\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-user-access-invites\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"adminhub-user-access-settings\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"adminhub-user-connected-apps\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-user-counts\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"adminhub-user-last-active-timestamp\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"adminhub-workspaces-table-plans\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"core-adminhub\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"assets\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"assets-data-manager-client-tools-distribution\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"assets-data-manager-ui\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"assets-data-manager\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"assets-recent-items\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"assets-reports\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"assets-rovo-search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"assets-service-registry\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"assets-software-catalog\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"core-assets\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-analytics\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"features\":{\"atlassian-analytics-3p-data-source-connections\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"atlassian-analytics-chart-dashboard-pdf-png-exports\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"atlassian-analytics-chart-templates\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-charts\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-comments\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-commerce-sentry\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"atlassian-analytics-cross-product-interaction-client\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"atlassian-analytics-dashboard-subscriptions\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-dashboard-templates\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-dashboards\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-data-lake-connections\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"atlassian-analytics-data-shares\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"atlassian-analytics-jira-align-enterprise-insights-connections\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"core-atlassian-analytics\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}}}},\"bitbucket\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{\"bitbucket-development-events-and-status\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"bitbucket-merge-queue\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"bitbucket-slack-app\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"bitbucket-ssh-key-validation\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"pipelines\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"chat\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false},\"features\":{}},\"compass\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"confluence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"ccma\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-ai\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"confluence-anonymous-access\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-canvas-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"confluence-canvas-relay\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-comment-and-header-links\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-company-hub\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-content-archiving\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-content-manager\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-create-experience\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-databases\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"availabilityMetadata\":{\"fm\":{\"auditPhase\":\"external-audit\"}}},\"confluence-editing-experience\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-edition-awareness\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-editor-offline-storage\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-embedded-pages\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-employee-directory\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-forge-apps-sidebar\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-inline-comments-in-edit-mode\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-inspect-permissions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-invitations\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"confluence-legacy-collaborative-editor\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"confluence-loom-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-mission-control\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-mobile-app\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-monolith-isolated-cloud\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-monolith\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"confluence-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-page-analytics\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-page-tree\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-pages-blogs-folders\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-premium-onboarding\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-presenter-mode\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-public-links\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-questions-native-experience\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-recap\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-remix\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-server\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-share-to-slack-button\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"confluence-single-space-guests\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"confluence-slack-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"confluence-slides\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"confluence-smart-links\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-space-analytics\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-team-calendars\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"confluence-update-page-owners\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-view-page\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"confluence-whiteboards-browser-network-compatibility-check\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"confluence-whiteboards\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"availabilityMetadata\":{\"fm\":{\"auditPhase\":\"external-audit\"}}},\"core-confluence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"moved-to-monolith-awaiting-deprecation\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"customer-service-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{\"customer-service-management-ai-agent\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"dx\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"feedback\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"focus\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{\"asks-and-planning\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"goals\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"guard-premium\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"guard-premium-atlassian-guard-premium-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"guard-premium-full-site-security-scanning\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}}}},\"home\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"basic-home-experience\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":true}},\"home-cross-app-create\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"home-dashboard-experience\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"home-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"home-ms-teams-and-slack-integration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"home-org-chart-analytics-pipeline\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"home-rerouting-services\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"home-status-backend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"home-where-you-work\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"jira\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-jira\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"issue-transition-customisation-for-srb\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jcma-x2c\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jcma\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-admin-oauth-credentials\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-ai-issue-classification\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-ai-planner\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-ai-snippet\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jira-ai-upsell-in-editor-free\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-apps-menu\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-atlassian-intelligence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-atlassian-vs-code-extension\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-audit-log\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-backlogs\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-boards-and-views\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-calendar-view\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-company-managed-projects\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-components\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-dashboard-public-sharing\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-development-hub\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"jira-development-tab-druid-metric-cards\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-development-tab-issue-centric-deployments\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-development-tab-lead-time-for-changes-dxe\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-development-tab\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jira-devinfo-async-pull-request-icon\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-devops-toolchain\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-edition-awareness\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-figma-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-forms\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-github-for-jira\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jira-github-workflows\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-global-issue-create-smart-fields\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-goals-nav\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jira-import-work-sidebar\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-in-product-help\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-individual-capacity-planning\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-insights\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-invite-people\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jira-issue\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-jinx-blue-green-jql-search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-jpd-nav-recommendations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-jpd-roadmap-on-timeline-cross-sell\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-loom-banner\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-marketplace-sidebar-recommendations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-mobile-app\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-monolith-isolated-cloud\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jira-monolith\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jira-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-next-best-task\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-oasis-reports\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jira-opsgenie\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-planned-deprecated-jira-services\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jira-plans\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-project-archiving\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-project-issue-navigator\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-project-templates\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-project-theme-unsplash\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-project\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-quickstart-pages\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jira-releases\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-roadmap-in-nav\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-search-investigation\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"jira-share\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-site-optimiser\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-slack\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jira-smart-links\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-smart-related-issues\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-software-devops\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-software-reports-cycle-time\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-software-reports-deployment-frequency\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-space-dashboard\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-spreadsheets-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-synced-blocks\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jira-team-managed-projects\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-unsplash\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-whiteboards-backlog-experiment\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jira-work-item-archiving\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-work-suggestions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jira-workflow-configuration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jira-your-work-dashboard\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"modern-issue-transition-connect-app-fields\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}}}},\"jira-align\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"jira-product-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"jira-service-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"iris\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jira-service-management-help-center\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-ai-core-services\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-ai-ops\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-ai-services\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-alert-notifications\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-analytics-dashboards\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-approvals\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-assets-vertical\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"jsm-automation-playbook\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-canned-responses\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-case-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-change-ai-risk-assessment\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-change-calendar\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-change-management-deployment-vendors\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-change-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jsm-change-risk-assessment\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-change-risk-reporter-configuration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-chat-jira-event-integration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-chat-ops-ic-custom-apps\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jsm-chat-ops\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-chat-slack-and-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jsm-chat\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-cloud-megatron\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-csat\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-csm-functionality\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-customer-access-internal-account\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-customer-account-directory\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-customer-notifications\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-customer-service-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-deployment-gating\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-deployment-tracking\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jsm-deprecated-incident-timeline\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jsm-developer-escalations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-email-requests\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-embeddable-widget\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jsm-entity-migration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-err-governance-api\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-accounts\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-single-sign-on\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-user-provisioning\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-forms\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-halp-admin-panel\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-help-center-change-password\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"jsm-help-center-password-login\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-help-center-rovo-agent\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-sign-up\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-virtual-agent\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-hr-employee-experience\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-incident-conference-calls\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-incident-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-issue\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-journey-builder\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-knowledge-base\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-lightweight-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-live-chat\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-multi-language-support\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-notification-logs\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-on-call-schedule\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-ops-gatekeeper\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-ops-genie-reporting\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-opsgenie-conference-management\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-opsgenie-devops\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-portal-only-account-scim\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-post-incident-reviews\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-project-creation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-queues\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-related-issues\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"jsm-reports-operations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"jsm-request-intake\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-request-type-template\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-services\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-shield\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-sidebar-navigation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-sla-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-solution-composer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-status-page-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-support-ai\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-surveys\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"jsm-templates-and-views\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"jsm-virtual-service-agent\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"jsm-workforce-management-and-smart-routing\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"jsm-workforce\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-automation-actions\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-bitbucket-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-internal-ops\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"opsgenie-onboarding\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-postmortem\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-url-shortener\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie-web-apps\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"opsgenie\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"loom\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"features\":{\"loom-ai-evaluation\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"projects\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"rovo\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"features\":{\"rovo-agent-playground\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"rovo-ai-app-availability\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-generative-ai-editor\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-projects\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-browser-extension-experience\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"rovo-chat-experience\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"rovo-editor-ai-panels\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-slack-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"rovo-dev\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{\"rovo-dev-agents\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"statuspage\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"studio\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"talent\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"teams\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-teams\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"teams-directory-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"teams-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"teams-profile-media-token-fetch\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"teams-third-party-invites\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"unified-profile\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"user-provided-banners-on-profile-pictures\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"trello\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{\"trello-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"anti-abuse-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"ai-safety\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"anti-abuse-classification\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"core-anti-abuse-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"file-scanner-content-moderation-api\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"application-tunnels\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false},\"features\":{\"core-application-tunnels\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}}}},\"atlassian-cli\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"features\":{}},\"atlassian-new-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"atlassian-visualization-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlassian-analytics-chart-export\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"atlassian-visualization-platform-kamino\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-manifold\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-monolith\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-rovo-skills\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"core-atlassian-visualization-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"dxe-metrics-service\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}}}},\"automation-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"admin-experience-connector\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-barrel-next-gen\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-barrel\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-network-and-key-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"automation-platform-actions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-platform-automation-templates\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-platform-branches\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-platform-conditions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-platform-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"automation-platform-legacy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"automation-platform-natural-language-rule-builder\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-platform-rule-builder\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-platform-sieve-cross-cloud\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}},\"automation-platform-sieve\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-platform-templates\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"automation-platform-triggers\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"automation-provisioner\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"core-automation-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"central-ai\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"features\":{\"agent-control-plane\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"agentic-runtime-session-execution\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"ai-3p-connections\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"ai-3p-lifecycle\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"ai-3p-permissions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"ai-managed-objects\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"alta\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"convo-ai-legacy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"convo-ai\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"gen-ai\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"knowledge-ai-tecton\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"knowledge-ai\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"knowledge-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"machine-learning-platform-supporting-infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"machine-learning-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-chat-send-message\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"rovo-chat-ui\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"cloud-to-data-center-connection-bridge\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"code-assist\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"collaboration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-collaboration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"userbase-merge\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"commerce-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"commerce-platform-pls-changes-for-hams-cofs-in-boundary-deployment\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"commerce-platform-self-serve\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"core-commerce-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"customer-configuration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-customer-configuration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"orcs\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"org-policy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"customer-data-lake\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-customer-data-lake\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"druid\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"link-paste-anonymization\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"plato-data-lake-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"plato-data-lake\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"socrates-demux\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"starrocks\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"customer-facing-observability\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"customer-support-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"aggregated-support-help\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"ecosystem-forge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-ecosystem-forge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"dac-get-help-widget\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"developer-atlassian-community\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"docs-atlassian-com\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"ecosystem-oauth\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"ecosystem-outbound-auth-flow\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"expression-playground\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"forge-ac-checker-fedramp\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-ac-checker\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"forge-app-client-events\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"forge-apps-bff\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"forge-cli\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"forge-developer-console\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"forge-entity-storage\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-mcp-server\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"forge-object-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-remote-capabilities\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-runtime-logs-api\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"forge-sql-storage\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"forge-storage-control-plane\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-storage-service-rockmelon\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"forge-system-apps\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"forge-ui-ic-cdn-auth\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":true,\"fm\":false}},\"ui-extensibility\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"editor-collaboration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"block-service\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"core-editor-collaboration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"real-time-presence\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"experience-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-experience-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}}}},\"export-control-compliance\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"growth-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"auto-provisioning\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"bxp-signup\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"core-growth-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"cross-flow\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"feedback-collection\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"growth-content-generation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"growth-unified-profile\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"guard-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cross-domain-attribute-service\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"identity\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"authz-consistency-checker\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"core-identity\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"identity-cache\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"identity-core-post-m4\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"identity-deprecated-for-gcp-m5\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"identity-gsuite-bridge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"identity-microsoft-azure-ad-bridge\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"identity-mobile-integrity\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"identity-userbase-merge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"identity-virality\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"suspicious-login-blocking\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"learning-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"marketplace\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"marketplace-amkt-fe-server\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"marketplace-app-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"marketplace-app-migrations\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"marketplace-atlassian-labs\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"marketplace-audit-logs\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"marketplace-self-service-purchase-provision-install\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"migrations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"agc-migrations\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"commercial-cloud-to-agc\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"data-center-to-agc\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"migration-link-fixing\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"migrations-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"ai-powered-migration-intelligence\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"app-migrations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"brie\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"c2c-middleware-assistant\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":true,\"fm\":false}},\"continuous-import-export-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"core-migrations-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"dare-app-migration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"data-center-to-cloud-migration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"external-data-sync\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"file-migration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"lio-synthetic-consumer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"media-migration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"migration-admin-ui\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"sandbox-promotion\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"monolith-key-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"navigation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-navigation\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"navigation-home-entry-mode\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"navigation-identity-ic-routing\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":true,\"fm\":false}},\"navigation-switcher-discovery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"navigation-switcher-rovo-scas-visibility\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"units-icons\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"notification-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true},\"features\":{\"core-notification-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"notifications-fpn-link\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}}}},\"post-office\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-post-office\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"identity-mail-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"post-office-rml-frontend\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"product-integrations-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-product-integrations-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"external-user-directory-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"gitlab-integration\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"google-workspace-apps-integrations\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"sign-in-with-slack-usage-analytics\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"product-license-enforcement-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-product-license-enforcement-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"reporting-lines\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-reporting-lines\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-search\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"search-identity-dare-isolated\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"search-identity-user-validator\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"search-townsquare-tab\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"user-search-indexing\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"xpsearch-forward-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"xpsearch-memory\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"xpsearch-workflows\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"smartlinks\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlassian-cloud-offering-smartlinks\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"atlassian-third-party-smartlinks\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"core-smartlinks\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"linking-platform-cdn\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"linking-platform-user-preferences\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"smartlinks-datasource-ari-collection\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"smartlinks-support-portal-fedramp\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":true}}}},\"stakeholder-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"teamwork-graph-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"collaboration-graph\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"core-teamwork-graph-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"flock\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"mcp-collaboration-graph\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"usage-based-pricing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"usage-tracking-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true},\"features\":{\"core-usage-tracking-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"user-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-user-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"user-recommendations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-user-recommendations\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-graphql-gateway\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-atlassian-graphql-gateway\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-platform-deployer\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"atlassian-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-atlassian-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-secure-sandbox-platform\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"atlassian-workflow-platform-temporal\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"batched-data-replication-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-batched-data-replication-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"kamino-ingestion\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"kamino-portal\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"batched-data-replication-platform-infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false},\"features\":{\"core-batched-data-replication-platform-infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}}}},\"browser-remote-update-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"build-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"artifact-distribution\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"deployment-gating\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"deployments\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"kitt-source-control\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"racs-refapp-archetype\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"racs\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"secrets\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"change-gateway\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"change-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"experimentation\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"feature-flag\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"flag-distribution\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"cloud-governance-and-inventory\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cdp-cell-provisioning\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"cloud-telemetry\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"compliance-posture-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"configuration-distribution\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"config-registry\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"shipyard\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"consent-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"consenthub\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"core-network-automation-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cdp-network\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"fedramp-network\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"isolated-cloud-network\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}}}},\"core-network-automation-telemetry\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cna-theia\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"cna-theid\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"cross-boundary-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-cross-boundary-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"cpg-federal\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"data-policy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"icg-commercial\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"icg-ic\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":true,\"fm\":false}},\"isolated-cloud-network\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"customer-data-lake-infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false},\"features\":{}},\"data-access-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-access-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"data-center-diagnostics\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"data-depot-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-depot-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"data-exchange-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"eureka-cdp\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}},\"phoenix-tester\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"queuing-platform\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}},\"streamhub\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"streaming-processing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"streaming-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"topic-osb\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"data-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"emperor-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"data-platform-services\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-platform-services\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"hydra\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"pii-mapper\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"data-telemetry-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-telemetry-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"postgres-telemetry-agent\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"telemetry-management\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"detection-and-response-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"disaster-recovery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"region-failover-orchestration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"edge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-edge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"edge-cloudfront\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":true,\"fm\":false}},\"edge-diagnostics\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"edge-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":false}},\"edge-sliver-refapp-archetype\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"envoy-controlplane\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":false}},\"envoy-partitions\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"encryption-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cryptor-ref-client\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"cryptor\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"kms-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"environment-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"em-l3-astra-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"error-tracking-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"sentry-opsgenie-integration\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"event-demux-and-routing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-event-demux-and-routing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"event-demux\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"flight-deck-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"gasv3\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"analytics-service\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"gasv3-tester\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"golden-ami\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"incident-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"rapid-investigation-framework\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-infrastructure\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"internal-data-lake\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"airlock-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"job-execution-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-job-execution-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"job-orchestration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-job-orchestration-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"kitt-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlaskube\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"customer-data-plane-pc-archetypes\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":false}},\"k8s-ref-service\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":false}},\"kitt-fleet-platform-infra\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"kitt-fleet\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"logging-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"management-plane\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"media-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-media-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"media-cdn-delivery\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"media-control-plane\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"messaging-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"metrics-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"micros-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"network-fabric\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-network-fabric\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"network-extension-routing\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"observability-visualization-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"opensearch\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true},\"features\":{}},\"per-tenant-loop\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"performance-testing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"public-backend-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-public-backend-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"rate-limiting-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-rate-limiting-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"heimdall-tester\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":true}},\"hofund-platform-tester\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"relational-database-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"homa\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"postgresql\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"sql\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}},\"test-product\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":false}}}},\"release-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"release-tracks\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"features\":{}},\"resiliency-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"wiremock\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"security-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"service-authentication\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"identity-provider\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"key-management\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"poco\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"rollcall\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"slauth\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"service-mesh\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"sp-ref-kitt-consumer-archetype\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}},\"sp-ref-kitt-provider\":{\"compositions\":{\"cc\":false,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"shard-and-cell-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cell-routing\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"raptor-archetype\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":false}},\"shard-lifecycle-service\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"slauth-auth-slack-notification-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"staff-directory\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"staff-governance\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"static-app-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"cookie-reference-app\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"ssr-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}},\"static-app-gateway\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"statsig\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlassian-statsig-proxy\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"targeting-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-targeting-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}}}},\"tdp-control-plane\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"tdp-entity-relationship-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tdp-entity-relationship-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"tdp-object-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tdp-object-store\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"tdp-sky-bridge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-tdp-sky-bridge\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":false}}}},\"telemetry-processing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"alkemia-engine\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}}}},\"tenant-context\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-context\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true}},\"tcs-ref-client\":{\"compositions\":{\"cc\":false,\"gcp\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"tenant-lifecycle\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-platform\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}},\"tenant-data-destroyer\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true}},\"tenant-passivation-removal\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true}}}},\"testing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"polliwhirl\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false}}}},\"testing-platform-legacy\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":true,\"fm\":true},\"features\":{}},\"tracing-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"vector-database\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"violation-management-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"volt-platform\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{\"volt-platform-app\":{\"compositions\":{\"cc\":true,\"gcp\":false,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"workplace-infra\":{\"compositions\":{\"cc\":true,\"gcp\":true,\"ic\":true,\"fm\":true},\"features\":{}}}}");

});


parcelRegister("1pIeV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.GOOGLE_CLOUD_PLATFORM_KEY = module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = void 0;
// Each BoundaryKey is a key in the sdk data
module.exports.COMMERCIAL_KEY = "commercial-cloud";
module.exports.FED_MOD_KEY = "fedramp-moderate";
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = "isolated-cloud-commercial";
module.exports.GOOGLE_CLOUD_PLATFORM_KEY = "google-cloud-platform";
module.exports.BOUNDARY_KEYS_LIST = [
    module.exports.COMMERCIAL_KEY,
    module.exports.FED_MOD_KEY,
    module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY,
    module.exports.GOOGLE_CLOUD_PLATFORM_KEY
];
var $107a714ef3ae0230$var$UnderAuditPhase;
(function(UnderAuditPhase) {
    UnderAuditPhase["INTERNAL_AUDIT"] = "internal-audit";
    UnderAuditPhase["EXTERNAL_AUDIT"] = "external-audit";
})($107a714ef3ae0230$var$UnderAuditPhase || (module.exports.UnderAuditPhase = $107a714ef3ae0230$var$UnderAuditPhase = {}));

});


parcelRegister("1wz5q", function(module, exports) {
"use strict";
/**
 * Manages feature overrides stored in browser localStorage.
 * No-ops when not in a browser context.
 *
 * localStorage key: "AEM_FEATURE_OVERRIDES"
 * localStorage value: JSON-encoded string mapping "{environmentBlockName}::{featureName}" to boolean
 *
 * Example:
 *   "AEM_FEATURE_OVERRIDES": "{\"confluence::my_feature\":true,\"jira::other_feature\":false}"
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAllOverrides = module.exports.clearFeatureOverride = module.exports.overrideFeature = module.exports.getFeatureOverride = module.exports.STORAGE_KEY = void 0;
module.exports.STORAGE_KEY = "AEM_FEATURE_OVERRIDES";
function $11c3ff0b47072a2c$var$buildKey(environmentBlockName, featureName) {
    return `${environmentBlockName}::${featureName}`;
}
function $11c3ff0b47072a2c$var$isBrowserEnvironment() {
    return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}
function $11c3ff0b47072a2c$var$getOverridesMap() {
    const featureOverrideValue = window.localStorage.getItem(module.exports.STORAGE_KEY);
    if (featureOverrideValue) try {
        return JSON.parse(featureOverrideValue);
    } catch (e) {
        console.warn("Failed to parse AEM_FEATURE_OVERRIDES from localStorage", e);
    }
    return {};
}
function $11c3ff0b47072a2c$var$setOverridesMap(map) {
    window.localStorage.setItem(module.exports.STORAGE_KEY, JSON.stringify(map));
}
/**
 * Returns the override value for a feature if one exists, or null if no override is set.
 * Returns null in non-browser environments.
 */ function $11c3ff0b47072a2c$var$getFeatureOverride(environmentBlockName, featureName) {
    if (!$11c3ff0b47072a2c$var$isBrowserEnvironment()) return null;
    const map = $11c3ff0b47072a2c$var$getOverridesMap();
    const key = $11c3ff0b47072a2c$var$buildKey(environmentBlockName, featureName);
    if (key in map) return map[key];
    return null;
}
module.exports.getFeatureOverride = $11c3ff0b47072a2c$var$getFeatureOverride;
/**
 * Sets a feature override in localStorage.
 */ function $11c3ff0b47072a2c$var$overrideFeature(environmentBlockName, featureName, value) {
    if (!$11c3ff0b47072a2c$var$isBrowserEnvironment()) return;
    const map = $11c3ff0b47072a2c$var$getOverridesMap();
    map[$11c3ff0b47072a2c$var$buildKey(environmentBlockName, featureName)] = value;
    $11c3ff0b47072a2c$var$setOverridesMap(map);
}
module.exports.overrideFeature = $11c3ff0b47072a2c$var$overrideFeature;
/**
 * Removes a single feature override from localStorage. Removes the key entirely if no overrides are left.
 */ function $11c3ff0b47072a2c$var$clearFeatureOverride(environmentBlockName, featureName) {
    if (!$11c3ff0b47072a2c$var$isBrowserEnvironment()) return;
    const map = $11c3ff0b47072a2c$var$getOverridesMap();
    delete map[$11c3ff0b47072a2c$var$buildKey(environmentBlockName, featureName)];
    if (Object.keys(map).length === 0) window.localStorage.removeItem(module.exports.STORAGE_KEY);
    else $11c3ff0b47072a2c$var$setOverridesMap(map);
}
module.exports.clearFeatureOverride = $11c3ff0b47072a2c$var$clearFeatureOverride;
/**
 * Clears all feature overrides from localStorage.
 */ function $11c3ff0b47072a2c$var$clearAllOverrides() {
    if (!$11c3ff0b47072a2c$var$isBrowserEnvironment()) return;
    window.localStorage.removeItem(module.exports.STORAGE_KEY);
}
module.exports.clearAllOverrides = $11c3ff0b47072a2c$var$clearAllOverrides;

});

parcelRegister("kLfgy", function(module, exports) {

var $k1Wvt = parcelRequire("k1Wvt");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEnvironmentType = module.exports.isSSR = void 0;
/** Returns true when running in a server-side rendering context (no browser window). */ function $f1d409ef19b076f1$var$isSSR() {
    return typeof window === "undefined" || typeof document === "undefined" || Boolean(typeof $k1Wvt !== "undefined" && $k1Wvt && $k1Wvt.env && undefined); // see https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/7377575ff0ec8a6f78257788b224e37c2bae8f66/platform/packages/editor/editor-common/src/core-utils/is-ssr.ts#lines-6
}
module.exports.isSSR = $f1d409ef19b076f1$var$isSSR;
/**
 * Returns the current environment type.
 * Defaults to "prod" in unknown cases.
 *
 * In SSR contexts, reads from globalThis.ssrContext.environmentType.
 * In browser contexts, infers from window.location.hostname.
 */ function $f1d409ef19b076f1$var$getEnvironmentType() {
    // 1. SSR: Use ssrContext if available
    if (typeof window === "undefined") {
        // @ts-expect-error — ssrContext in globalThis type
        const ssrContext = globalThis.ssrContext;
        if (ssrContext && ssrContext.environmentType) {
            const type = ssrContext.environmentType;
            if (type === "dev") return "non-prod";
            if (type === "staging") return "non-prod";
            if (type === "prod") return "prod";
        }
        return "prod";
    }
    // 2. Browser: Use hostname-based detection with all patterns
    const host = window.location.hostname.toLowerCase();
    if (!host) // default to prod if no location available
    return "prod";
    // Exact matches
    if (host === "localhost" || host === "127.0.0.1") return "non-prod";
    // Staging patterns
    if (host.endsWith(".jira-dev.com") || host.includes(".stg.") || host.includes(".staging.") || host.endsWith(".atlassian-stg-fedm.net") || host.endsWith(".atlassian-stg-fedm.com")) return "non-prod";
    // Development patterns
    if (host.includes(".dev.") || host.includes(".ddev.")) return "non-prod";
    if (host.endsWith(".atlassian.net") || host.endsWith(".atlassian-us-gov-mod.com") || host.endsWith(".atlassian.com")) return "prod";
    return "prod";
}
module.exports.getEnvironmentType = $f1d409ef19b076f1$var$getEnvironmentType;

});



parcelRegister("f2gT6", function(module, exports) {
$parcel$export(module.exports, "default", () => $202c63cd0e47e67e$export$2e2bcd8739ae039);

var $koGM0 = parcelRequire("koGM0");
const $202c63cd0e47e67e$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $202c63cd0e47e67e$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($202c63cd0e47e67e$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$202c63cd0e47e67e$export$7bc189309d2ad463];
            else {
                // Initialise InteractionSessionTracking on global window object
                window[$202c63cd0e47e67e$export$7bc189309d2ad463] = new (0, $koGM0.default)();
                interactionSessionTracking = window[$202c63cd0e47e67e$export$7bc189309d2ad463];
            }
        } catch (error) {
        // Silently swallow exception
        }
        return interactionSessionTracking;
    }
}

});
parcelRegister("koGM0", function(module, exports) {
$parcel$export(module.exports, "INTERACTION_SESSION_ID_UPDATED_EVENT", () => $89c82a4959e50539$export$5d4c4eab0863aae3);
$parcel$export(module.exports, "default", () => $89c82a4959e50539$export$2e2bcd8739ae039);

var $cqoOu = parcelRequire("cqoOu");
const $89c82a4959e50539$var$INTERACTION_SESSION_ID_STORAGE_KEY = 'interactionSession.id';
const $89c82a4959e50539$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY = 'interactionSession.id.prev';
const $89c82a4959e50539$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY = 'interactionSession.expiry';
const $89c82a4959e50539$export$285f6bddd927a06d = 1800000; // 30 minutes
const $89c82a4959e50539$export$d050a4cab1b9f734 = 86400000; // 24 hours
const $89c82a4959e50539$export$a92e915d70316eb2 = 5000; // 5 seconds
const $89c82a4959e50539$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $89c82a4959e50539$var$INTEGER_REGEX = /^\d+$/;
const $89c82a4959e50539$export$5d4c4eab0863aae3 = 'interactionSessionIdUpdated';
class $89c82a4959e50539$export$2e2bcd8739ae039 {
    safeSessionStorage;
    sessionExpiryTime;
    sessionExpiryDebounce;
    sessionExpiryDebounceThresholdPercentage;
    sessionExpiryDebounceTimer;
    analyticsReady = false;
    // This callback function will be called whenever a new session ID is generated
    // It expects a function that sends an operational analytics event, with
    // the first parameter being set to the action ('started' or 'renewed'), and the second parameter being
    // an InteractionSession object containing the new session ID and previous session ID.
    sendEventCallback;
    constructor(){
        this.sessionExpiryTime = $89c82a4959e50539$export$285f6bddd927a06d;
        this.sessionExpiryDebounce = $89c82a4959e50539$export$a92e915d70316eb2;
        this.sessionExpiryDebounceThresholdPercentage = $89c82a4959e50539$export$de43760b2dc10c19;
        this.safeSessionStorage = new (0, $cqoOu.default)();
    }
    getCurrentInteractionSessionId() {
        try {
            const { isValidSession: isValidSession, sessionExpiry: sessionExpiry, sessionId: sessionId } = this.getCurrentSessionParams();
            // If we have an existing valid session we can return the sessionId straight away
            if (isValidSession) {
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return sessionId;
            }
            // To generate a new session ID we must ensure analytics is ready
            if (this.analyticsReady) {
                // Session expiry update must occur before generateNewSessionId. Otherwise we were running
                // into issues of calls attempting to read the session ID before a valid expiry had been set
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return this.generateNewSessionId();
            }
        } catch (err) {
        // Silently swallow exception
        }
        return null;
    }
    getPreviousInteractionSessionId() {
        return this.safeSessionStorage.getItem($89c82a4959e50539$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
    }
    setInteractionSessionId(persistedSessionId) {
        if (this.validateSessionId(persistedSessionId)) {
            const currentSessionId = this.safeSessionStorage.getItem($89c82a4959e50539$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            // If we are already on the required session ID, just return true and make no changes
            // This can happen if the persisted session ID in options is the same as the current session ID
            // We noticed this happening in some cases where Confluence's own URL redirect logic was causing
            // race conditions with our URL stripping, resulting in the same query parameter being processed multiple times
            if (currentSessionId === persistedSessionId) return false;
            // Session expiry update must occur before we fire off the dispatchEvent. Otherwise we were running
            // into issues of the event consumer attempting to read the session ID before a valid expiry had been set
            this.debouncedUpdateSessionExpiry(0);
            this.safeSessionStorage.setItem($89c82a4959e50539$var$INTERACTION_SESSION_ID_STORAGE_KEY, persistedSessionId);
            this.safeSessionStorage.removeItem($89c82a4959e50539$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
            document.dispatchEvent(new Event($89c82a4959e50539$export$5d4c4eab0863aae3));
            return true;
        }
        return false;
    }
    // Must be called with a valid sendEvent function for other methods to work
    setAnalyticsCallback(sendEventCallback) {
        if (this.analyticsReady) // If we already have a valid callback, don't over-write it
        return;
        if (sendEventCallback && typeof sendEventCallback === 'function') {
            this.sendEventCallback = sendEventCallback;
            this.analyticsReady = true;
        } else this.analyticsReady = false;
    }
    validateSessionId(sessionId) {
        // Check if persisted session ID can parse as valid Unix timestamp
        if (sessionId && $89c82a4959e50539$var$INTEGER_REGEX.test(sessionId)) {
            const sessionAge = Date.now() - parseInt(sessionId, 10);
            // Validate that timestamp is not a future time, and is also within the TTL
            if (sessionAge >= 0 && sessionAge <= $89c82a4959e50539$export$d050a4cab1b9f734) return true;
        }
        return false;
    }
    /*
   * This function retrieves the current session ID and expiry from SessionStorage
   * It runs the necessary checks to ensure the session ID is valid and within expiry
   *
   * It returns the values along with a `validSession` boolean
   */ getCurrentSessionParams() {
        const sessionId = this.safeSessionStorage.getItem($89c82a4959e50539$var$INTERACTION_SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this.safeSessionStorage.getItem($89c82a4959e50539$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        if (sessionId && !Number.isNaN(sessionExpiry) && sessionExpiry > Date.now()) return {
            isValidSession: true,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
        return {
            isValidSession: false,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
    }
    /*
   * This function sends a GASv3 analytics event indicating the interaction session has started or renewed
   * It requires this.sendEventCallback to be set via Analytics Web Client to a valid operational event sender function
   *
   * Note that Analytics Web Client's callback function will make its own call to getCurrentInteractionSessionId to retrieve the session ID
   * to attach to the event, so a valid session ID/expiry must be retrievable from SessionStorage before this function is called to avoid infinite loops.
   *
   * This is not an ideal solution but it works with the current architecture of Analytics Web Client.
   */ sendInteractionSessionEvent(action) {
        this.sendEventCallback && this.sendEventCallback({
            action: action,
            actionSubject: 'interactionSession',
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
    generateNewSessionId = ()=>{
        if (!this.analyticsReady) return null;
        const currentSessionId = this.safeSessionStorage.getItem($89c82a4959e50539$var$INTERACTION_SESSION_ID_STORAGE_KEY);
        const newSessionId = Date.now().toString();
        this.safeSessionStorage.setItem($89c82a4959e50539$var$INTERACTION_SESSION_ID_STORAGE_KEY, newSessionId);
        const { isValidSession: isValidSession } = this.getCurrentSessionParams();
        if (!isValidSession) // If session is not valid at this point, something has gone wrong with Session Storage access
        // Calling sendInteractionSessionEvent now would result in an infinite loop, so we terminate
        return null;
        if (currentSessionId) {
            // Store a copy of the current session ID so we can link sessions if needed
            this.safeSessionStorage.setItem($89c82a4959e50539$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY, currentSessionId);
            this.sendInteractionSessionEvent('renewed');
        } else this.sendInteractionSessionEvent('started');
        // Event listener is in useCrossProductUrl.tsx to update URL query params
        document.dispatchEvent(new Event($89c82a4959e50539$export$5d4c4eab0863aae3));
        return newSessionId;
    };
    updateSessionExpiry = ()=>{
        const expiry = Date.now() + this.sessionExpiryTime;
        this.safeSessionStorage.setItem($89c82a4959e50539$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
        return expiry;
    };
    debouncedUpdateSessionExpiry = (currentExpiry)=>{
        const { updateSessionExpiry: updateSessionExpiry } = this;
        // If the current expiry is out of date by more than 10% of the expiry, update immediately
        if (currentExpiry < Date.now() + this.sessionExpiryDebounceThresholdPercentage * this.sessionExpiryTime) updateSessionExpiry();
        else {
            if (this.sessionExpiryDebounceTimer) clearTimeout(this.sessionExpiryDebounceTimer);
            // @ts-ignore Something wrong with our types... this is legit
            this.sessionExpiryDebounceTimer = setTimeout(()=>{
                updateSessionExpiry();
            }, this.sessionExpiryDebounce);
        }
    };
}

});
parcelRegister("cqoOu", function(module, exports) {
$parcel$export(module.exports, "default", () => $51b6f04e65ca85d4$export$2e2bcd8739ae039);

var $kVBH4 = parcelRequire("kVBH4");

var $cbgsz = parcelRequire("cbgsz");
class $51b6f04e65ca85d4$export$2e2bcd8739ae039 extends (0, $cbgsz.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = window.sessionStorage || (0, $kVBH4.default);
        } catch (err) {
            storageToUse = (0, $kVBH4.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("kVBH4", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7067c2d36788641$export$2e2bcd8739ae039);

var $aoEbD = parcelRequire("aoEbD");
// eslint-disable-next-line import/no-anonymous-default-export
const $e7067c2d36788641$var$inmemorystorage = new (0, $aoEbD.InMemoryStore)();
var $e7067c2d36788641$export$2e2bcd8739ae039 = $e7067c2d36788641$var$inmemorystorage;

});
parcelRegister("aoEbD", function(module, exports) {
$parcel$export(module.exports, "InMemoryStore", () => $a300058f3382c015$export$90e3e001bcac59c7);
class $a300058f3382c015$export$90e3e001bcac59c7 {
    data = {};
    length = 0;
    setItem = (key, value)=>{
        this.data[key] = value;
        this.length = Object.keys(this.data).length;
        return value;
    };
    getItem = (key)=>{
        if (key in this.data) return this.data[key];
        return null;
    };
    removeItem = (key)=>{
        if (key in this.data) delete this.data[key];
        this.length = Object.keys(this.data).length;
        return null;
    };
    clear = ()=>{
        this.data = {};
        this.length = 0;
    };
    key = (index)=>Object.keys(this.data)[index];
}

});


parcelRegister("cbgsz", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb58d6e7da8b8d56$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $jMPT2 = parcelRequire("jMPT2");

var $kVBH4 = parcelRequire("kVBH4");

var $b3VY1 = parcelRequire("b3VY1");
const $fb58d6e7da8b8d56$export$41c06fdd37b7e9a5 = 'awc';
const $fb58d6e7da8b8d56$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
class $fb58d6e7da8b8d56$export$2e2bcd8739ae039 {
    prefix;
    store;
    options;
    constructor(storageToUse, options = {}){
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($fb58d6e7da8b8d56$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $jMPT2.envType).PROD) prefixes.push(options.envPrefix);
        this.prefix = prefixes.join('-');
        if ((0, $b3VY1.isSupported)(storageToUse)) this.store = storageToUse;
        else this.swapToInMemory();
    }
    getStore = ()=>this.store;
    getItem = (key)=>this.store.getItem(this.createKey(key));
    removeItem = (key)=>this.store.removeItem(this.createKey(key));
    setItem = (key, value)=>{
        try {
            this.store.setItem(this.createKey(key), value);
        } catch (err) {
            // Theoretically should only be QuotaExceededError, but keeping 'err' generic
            // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
            this.swapToInMemory();
            this.store.setItem(this.createKey(key), value);
        }
    };
    swapToInMemory = ()=>{
        if (this.store === (0, $kVBH4.default) || typeof window === 'undefined') return;
        const keys = Object.keys(this.store || {});
        let inMemoryStorage;
        if ((0, $b3VY1.isSupported)(window[$fb58d6e7da8b8d56$export$770aa8bc07b3de03])) inMemoryStorage = window[$fb58d6e7da8b8d56$export$770aa8bc07b3de03];
        else {
            inMemoryStorage = (0, $kVBH4.default);
            if (!window[$fb58d6e7da8b8d56$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
            // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
            // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
            window[$fb58d6e7da8b8d56$export$770aa8bc07b3de03] = (0, $kVBH4.default);
        }
        keys.forEach((key)=>{
            if (key.indexOf(this.getPrefix()) === 0) {
                const value = this.store.getItem(key);
                if (value) inMemoryStorage.setItem(key, value);
            }
        });
        this.store = inMemoryStorage;
    };
    clear = ()=>this.store.clear();
    key = (index)=>this.store.key(index);
    getPrefix = ()=>this.prefix;
    createKey = (key)=>{
        if (this.prefix) return `${this.getPrefix()}.${key}`;
        return key;
    };
}

});
parcelRegister("jMPT2", function(module, exports) {
$parcel$export(module.exports, "envType", () => $bd26d07d8edd972b$export$56ac8ebc9870b1b9);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ // This type has been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var $bd26d07d8edd972b$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["DEV"] = "dev";
    envType["LOCAL"] = "local";
    envType["PROD"] = "prod";
    envType["STAGING"] = "staging";
    return envType;
}({});

});

parcelRegister("b3VY1", function(module, exports) {
$parcel$export(module.exports, "isSupported", () => $7ebad7868a170bbc$export$48c17662a6902497);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ function $7ebad7868a170bbc$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}

});






parcelRegister("5mPNA", function(module, exports) {
$parcel$export(module.exports, "URL_QUERY_PARAM_INTERACTION_SESSION", () => $a95fb8024cb18746$export$81d16f1428ce0486);
$parcel$export(module.exports, "generateUrlWithParams", () => $a95fb8024cb18746$export$2e3999ec51334ffe);
const $a95fb8024cb18746$export$81d16f1428ce0486 = 'xpis';
const $a95fb8024cb18746$export$2e3999ec51334ffe = (url, bridge, interactionSessionId, product, subProduct)=>{
    const interactionSource = subProduct ? `${product}-${subProduct}` : product;
    const interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    const paramValueEncoded = btoa(JSON.stringify(interactionSession));
    let partialUrl = false;
    let urlObj;
    // If relative URL provided, add localhost as placeholder base, to be stripped later
    try {
        urlObj = new URL(url);
    } catch  {
        urlObj = new URL(url, 'http://localhost/');
        partialUrl = true;
    }
    urlObj.searchParams.set($a95fb8024cb18746$export$81d16f1428ce0486, paramValueEncoded);
    if (partialUrl) return urlObj.pathname + urlObj.search;
    else return urlObj.toString();
};

});

parcelRegister("9t0G7", function(module, exports) {
$parcel$export(module.exports, "validProducts", () => $f3ea743b2ba0eac5$export$b1e8b4360a046e61);
// Add products that will participate in cross-product interaction tracking here
// TODO: Down the line this should ideally be synced with ECS product list but that
// will take significant engineering effort
const $f3ea743b2ba0eac5$export$b1e8b4360a046e61 = [
    'jira',
    'confluence',
    'townsquare',
    'loom',
    'atlassianStudio',
    'bitbucket',
    'admin',
    'mercury',
    'talent',
    'trello',
    'analyticsVisualizationPlatform'
];

});

parcelRegister("aNsr9", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e244c6cc78c8c6e$export$2e2bcd8739ae039);

var $9FFsN = parcelRequire("9FFsN");

var $atzxl = parcelRequire("atzxl");

var $hlFNB = parcelRequire("hlFNB");
const $3e244c6cc78c8c6e$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = (0, $atzxl.defaultHistoryReplaceFn))=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $9FFsN.parseUrl)(removedFragmentURL);
    const captureParams = (0, $hlFNB.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $hlFNB.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $9FFsN.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$3e244c6cc78c8c6e$export$2e2bcd8739ae039 = $3e244c6cc78c8c6e$var$urlParamExtractor;

});
parcelRegister("9FFsN", function(module, exports) {
$parcel$export(module.exports, "extract", () => $70a81b2540816ea4$export$f9380c9a627682d3, (v) => $70a81b2540816ea4$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $70a81b2540816ea4$export$98e6a39c04603d36, (v) => $70a81b2540816ea4$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $70a81b2540816ea4$export$fac44ee5b035f737, (v) => $70a81b2540816ea4$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $70a81b2540816ea4$export$7a5253c0f62e0150, (v) => $70a81b2540816ea4$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $70a81b2540816ea4$export$a8c1621ea79325d3, (v) => $70a81b2540816ea4$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $70a81b2540816ea4$export$357523c63a2253b9, (v) => $70a81b2540816ea4$export$357523c63a2253b9 = v);
var $70a81b2540816ea4$export$f9380c9a627682d3;
var $70a81b2540816ea4$export$98e6a39c04603d36;
var $70a81b2540816ea4$export$fac44ee5b035f737;
var $70a81b2540816ea4$export$7a5253c0f62e0150;
var $70a81b2540816ea4$export$a8c1621ea79325d3;
var $70a81b2540816ea4$export$357523c63a2253b9;
var $70a81b2540816ea4$export$44c361b8ec72ef7f;
'use strict';

var $9c1gy = parcelRequire("9c1gy");

var $dkHF4 = parcelRequire("dkHF4");

var $2DDeI = parcelRequire("2DDeI");

var $4eK5n = parcelRequire("4eK5n");
const $70a81b2540816ea4$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $70a81b2540816ea4$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $70a81b2540816ea4$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $70a81b2540816ea4$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $70a81b2540816ea4$var$encode(key, options),
                            '[',
                            $70a81b2540816ea4$var$encode(index, options),
                            ']=',
                            $70a81b2540816ea4$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $70a81b2540816ea4$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $70a81b2540816ea4$var$encode(key, options),
                            '[]=',
                            $70a81b2540816ea4$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $70a81b2540816ea4$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $70a81b2540816ea4$var$encode(key, options),
                            ':list=',
                            $70a81b2540816ea4$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $70a81b2540816ea4$var$encode(key, options),
                                keyValueSep,
                                $70a81b2540816ea4$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $70a81b2540816ea4$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $70a81b2540816ea4$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $70a81b2540816ea4$var$encode(key, options),
                            '=',
                            $70a81b2540816ea4$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $70a81b2540816ea4$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $70a81b2540816ea4$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $70a81b2540816ea4$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$70a81b2540816ea4$var$decode(item, options)) : value === null ? value : $70a81b2540816ea4$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $70a81b2540816ea4$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$70a81b2540816ea4$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $70a81b2540816ea4$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $70a81b2540816ea4$var$encode(value, options) {
    if (options.encode) return options.strict ? $9c1gy(value) : encodeURIComponent(value);
    return value;
}
function $70a81b2540816ea4$var$decode(value, options) {
    if (options.decode) return $dkHF4(value);
    return value;
}
function $70a81b2540816ea4$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $70a81b2540816ea4$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $70a81b2540816ea4$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $70a81b2540816ea4$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $70a81b2540816ea4$var$extract(input) {
    input = $70a81b2540816ea4$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $70a81b2540816ea4$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $70a81b2540816ea4$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $70a81b2540816ea4$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $70a81b2540816ea4$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $2DDeI(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $70a81b2540816ea4$var$decode(value, options);
        formatter($70a81b2540816ea4$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $70a81b2540816ea4$var$parseValue(value[k], options);
        else ret[key] = $70a81b2540816ea4$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $70a81b2540816ea4$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$70a81b2540816ea4$export$f9380c9a627682d3 = $70a81b2540816ea4$var$extract;
$70a81b2540816ea4$export$98e6a39c04603d36 = $70a81b2540816ea4$var$parse;
$70a81b2540816ea4$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $70a81b2540816ea4$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $70a81b2540816ea4$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $70a81b2540816ea4$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $70a81b2540816ea4$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $70a81b2540816ea4$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $70a81b2540816ea4$var$encode(key, options) + '=' + $70a81b2540816ea4$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$70a81b2540816ea4$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $2DDeI(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $70a81b2540816ea4$var$parse($70a81b2540816ea4$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $70a81b2540816ea4$var$decode(hash, options)
    } : {});
};
$70a81b2540816ea4$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$70a81b2540816ea4$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $70a81b2540816ea4$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $70a81b2540816ea4$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $70a81b2540816ea4$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $70a81b2540816ea4$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $70a81b2540816ea4$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$70a81b2540816ea4$var$encodeFragmentIdentifier] ? $70a81b2540816ea4$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$70a81b2540816ea4$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$70a81b2540816ea4$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $70a81b2540816ea4$export$7a5253c0f62e0150(input, options);
    return $70a81b2540816ea4$export$a8c1621ea79325d3({
        url: url,
        query: $4eK5n(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$70a81b2540816ea4$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $70a81b2540816ea4$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("9c1gy", function(module, exports) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("dkHF4", function(module, exports) {
'use strict';
var $9b4f02e1ed474cb7$var$token = '%[a-f0-9]{2}';
var $9b4f02e1ed474cb7$var$singleMatcher = new RegExp('(' + $9b4f02e1ed474cb7$var$token + ')|([^%]+?)', 'gi');
var $9b4f02e1ed474cb7$var$multiMatcher = new RegExp('(' + $9b4f02e1ed474cb7$var$token + ')+', 'gi');
function $9b4f02e1ed474cb7$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $9b4f02e1ed474cb7$var$decodeComponents(left), $9b4f02e1ed474cb7$var$decodeComponents(right));
}
function $9b4f02e1ed474cb7$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($9b4f02e1ed474cb7$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $9b4f02e1ed474cb7$var$decodeComponents(tokens, i).join('');
            tokens = input.match($9b4f02e1ed474cb7$var$singleMatcher) || [];
        }
        return input;
    }
}
function $9b4f02e1ed474cb7$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $9b4f02e1ed474cb7$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $9b4f02e1ed474cb7$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $9b4f02e1ed474cb7$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $9b4f02e1ed474cb7$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("2DDeI", function(module, exports) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("4eK5n", function(module, exports) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});


parcelRegister("atzxl", function(module, exports) {
$parcel$export(module.exports, "defaultHistoryReplaceFn", () => $2e553f90a053a364$export$600dd5bf1b049f11);
const $2e553f90a053a364$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);

});

parcelRegister("hlFNB", function(module, exports) {
$parcel$export(module.exports, "mapKeys", () => $4bcb8c6de098326f$export$781522908e4e76a1);
$parcel$export(module.exports, "pick", () => $4bcb8c6de098326f$export$357523c63a2253b9);
$parcel$export(module.exports, "omitBy", () => $4bcb8c6de098326f$export$d7a617dda645b4e3);
$parcel$export(module.exports, "pickBy", () => $4bcb8c6de098326f$export$b460b275d6c6aa0);
$parcel$export(module.exports, "omit", () => $4bcb8c6de098326f$export$30a06c8d3562193f);
$parcel$export(module.exports, "equals", () => $4bcb8c6de098326f$export$e9bab7fafb253603);
$parcel$export(module.exports, "partition", () => $4bcb8c6de098326f$export$b29f828819edca8d);
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $4bcb8c6de098326f$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $4bcb8c6de098326f$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $4bcb8c6de098326f$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $4bcb8c6de098326f$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $4bcb8c6de098326f$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $4bcb8c6de098326f$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$4bcb8c6de098326f$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $4bcb8c6de098326f$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});



parcelRegister("gAgTu", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d26ee32da0268d0$export$2e2bcd8739ae039);

var $1y7U8 = parcelRequire("1y7U8");

var $jgKMu = parcelRequire("jgKMu");

var $5hVPW = parcelRequire("5hVPW");
class $1d26ee32da0268d0$export$2e2bcd8739ae039 {
    delayQueue;
    delayTimeout;
    delayCallback;
    isDelaying;
    constructor(fireDelayedEvent, compressors){
        this.isDelaying = false;
        this.delayQueue = new (0, $jgKMu.default)(fireDelayedEvent, compressors);
    }
    push = (identifier, builtEvent, context, userInfo)=>{
        this.delayQueue.push(identifier, builtEvent, context, userInfo);
    };
    startLowPriorityEventDelay = (timeout = (0, $1y7U8.DEFAULT_DELAY_TIMEOUT), callback)=>{
        if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
        if (this.delayTimeout) clearTimeout(this.delayTimeout);
        const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $1y7U8.MAX_DELAY_TIMEOUT)) : (0, $1y7U8.MAX_DELAY_TIMEOUT);
        this.delayCallback = callback;
        this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $5hVPW.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
        // If the queue is still flushing from a previous delay period, then we should cancel that flush
        // to stop it from negatively impacting the performance of the new critical section
        this.delayQueue.cancelFlush();
        this.isDelaying = true;
    };
    stopLowPriorityEventDelay = (reason = (0, $5hVPW.StopLowPriorityEventDelayReason).MANUAL)=>{
        if (this.delayTimeout) {
            clearTimeout(this.delayTimeout);
            this.delayTimeout = undefined;
        }
        this.delayQueue.startFlush();
        this.isDelaying = false;
        this.delayCallback?.(reason);
        this.delayCallback = undefined;
    };
    isDelayingLowPriorityEvents = ()=>this.isDelaying;
}

});
parcelRegister("1y7U8", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", () => $fc758d9589088227$export$cf090d5281b5ae06);
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", () => $fc758d9589088227$export$8575e30be0feb909);
const $fc758d9589088227$export$cf090d5281b5ae06 = 10000;
const $fc758d9589088227$export$8575e30be0feb909 = 30000;

});

parcelRegister("jgKMu", function(module, exports) {
$parcel$export(module.exports, "default", () => $ddaf52dbe4e16b0a$export$2e2bcd8739ae039);

var $lN1hr = parcelRequire("lN1hr");

var $hlFNB = parcelRequire("hlFNB");

var $3wFsO = parcelRequire("3wFsO");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $ddaf52dbe4e16b0a$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $ddaf52dbe4e16b0a$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $ddaf52dbe4e16b0a$export$2e2bcd8739ae039 {
    compressor;
    eventArgs;
    flushBatchTimeout;
    processFn;
    constructor(processFn, compressionRules){
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $3wFsO.default)(compressionRules);
    }
    push = (identifier, builtEvent, context, userInfo)=>{
        this.eventArgs.push({
            identifier: identifier,
            builtEvent: builtEvent,
            context: context,
            userInfo: userInfo
        });
    };
    size = ()=>this.eventArgs.length;
    startFlush = ()=>{
        try {
            this.eventArgs = this.compressEventArgs(this.eventArgs);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
        }
        this.flushNextBatch();
    };
    cancelFlush = ()=>{
        if (this.flushBatchTimeout) {
            clearTimeout(this.flushBatchTimeout);
            this.flushBatchTimeout = null;
        }
    };
    flushNextBatch = ()=>{
        const batch = this.eventArgs.splice(0, $ddaf52dbe4e16b0a$var$FLUSH_BATCH_SIZE);
        batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
        if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $ddaf52dbe4e16b0a$var$FLUSH_BATCH_BACKOFF_PERIOD);
        else this.flushBatchTimeout = null;
    };
    compressEventArgs = (eventArgs)=>{
        const [compressibleEventArgs, incompressibleEventArgs] = (0, $hlFNB.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
        // Events can only be compressed together if they share the same context and user info, since these are top-level
        // fields that need to exist on the fired event and can only be set to a single value.
        // We can achieve this by grouping our events by context prior to passing them to the compressor.
        const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
            const matchingGroup = groups.find((group)=>(0, $hlFNB.equals)(group.userInfo, args.userInfo) && (0, $hlFNB.equals)(group.context, args.context));
            if (matchingGroup) matchingGroup.eventArgs.push(args);
            else groups.push({
                userInfo: args.userInfo,
                context: args.context,
                eventArgs: [
                    args
                ]
            });
            return groups;
        }, []);
        // Run the compressor on each group
        const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
            try {
                const events = group.eventArgs.map((args)=>args.builtEvent);
                const compressedEvents = this.compressor.compress(events);
                const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                        identifier: (0, $lN1hr.buildActionName)(compressedEvent),
                        builtEvent: compressedEvent,
                        userInfo: group.userInfo,
                        context: group.context
                    }));
                return acc.concat(compressedEventArgs);
            } catch (e) {
                // If anything goes wrong while compressing this group, then just fall back on the
                // uncompressed events instead. The event compressor already handles errors with invalid
                // generator functions or results, but this is an extra layer of defense to prevent data
                // loss in the event of an unexpected error.
                // eslint-disable-next-line no-console
                console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                return group.eventArgs;
            }
        }, []);
        incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
        return allCompressedEventArgs;
    };
}

});
parcelRegister("3wFsO", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed642d3803226b27$export$2e2bcd8739ae039);
/* eslint-disable implicit-arrow-linebreak */ /* eslint-disable max-classes-per-file */ 
var $ccwBB = parcelRequire("ccwBB");

var $hlFNB = parcelRequire("hlFNB");

var $h5eAc = parcelRequire("h5eAc");
class $ed642d3803226b27$export$2e2bcd8739ae039 {
    compressionRules;
    constructor(compressionRules = []){
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $h5eAc.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
    canCompress = (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event));
    compress = (events)=>{
        const groups = this.createGroups(events);
        return groups.reduce((allCompressedEvents, group)=>{
            const groupCompressedEvents = this.compressGroup(group);
            return allCompressedEvents.concat(groupCompressedEvents);
        }, []);
    };
    createGroups = (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
        // rather than passed in by the caller (eg. product, org. and tenant info)
        events.reduce((groups, event)=>{
            const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
            let contextFields;
            if (matchingCompressor) {
                const actionFields = (0, $ccwBB.buildActionFields)(event, event.eventType);
                contextFields = (0, $hlFNB.omit)(event, Object.keys(actionFields));
            }
            const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $hlFNB.equals)(contextFields, group.contextFields));
            if (matchingGroup) matchingGroup.events.push(event);
            else groups.push({
                contextFields: contextFields,
                compressor: matchingCompressor,
                events: [
                    event
                ]
            });
            return groups;
        }, []);
    compressGroup = (group)=>{
        // If this group doesn't have any compressor, then the event args are already in their final format
        if (!group.compressor) return group.events;
        try {
            // Run the compressor on the group to generate some new events.
            // The compression function is only expected to return the action fields for each
            // event that it generates, since all other fields are generated by the client.
            const compressedEventActionFields = group.compressor.compress(group.events);
            // Add the context fields to each of the resulting events to inflate them into a full action event
            return compressedEventActionFields.map((actionFields)=>({
                    ...actionFields,
                    ...group.contextFields
                }));
        } catch (e) {
            // If we fail to compress the events, then just fall back the uncompressed events
            // so that no data is lost. This can happen if the compression function throws an error
            // or returns some invalid event payloads.
            // eslint-disable-next-line no-console
            // console.warn(
            // 	'Failed to compress some analytics events. ' +
            // 		`Error: ${(e as Error).message}. Sending ${
            // 			group.events.length
            // 		} uncompressed events instead`,
            // );
            return group.events;
        }
    };
}

});
parcelRegister("h5eAc", function(module, exports) {
$parcel$export(module.exports, "CompressionRule", () => $8e4398b3fe08e42d$export$89b3253ddfd2e6e8);

var $3mq7P = parcelRequire("3mq7P");

var $hlFNB = parcelRequire("hlFNB");

var $9l1HQ = parcelRequire("9l1HQ");

var $iFSFK = parcelRequire("iFSFK");
class $8e4398b3fe08e42d$export$89b3253ddfd2e6e8 {
    compressFn;
    predicate;
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
    /**
   * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
   * @param event
   * @returns {boolean}
   */ canCompress = (event)=>{
        try {
            return event && (0, $3mq7P.isActionEventType)(event.eventType) && this.predicate(event);
        } catch (e) {
            return false;
        }
    };
    /**
   * This function compresses as many events in the given collection as possible.<p>
   * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
   * appended to the end of the resulting array.
   *
   * @param events A collection of analytic events to compress
   * @returns {Array.<Object>} The action fields for the resulting compressed events
   */ compress = (events)=>{
        const [compatibleEvents, incompatibleEvents] = (0, $hlFNB.partition)(events, (event)=>this.canCompress(event));
        const compressedEvents = this.compressFn(compatibleEvents);
        if (!compressedEvents) throw new Error('No events were returned from the compression function');
        compressedEvents.forEach((event)=>{
            (0, $iFSFK.validateActionEventType)(event.eventType);
            (0, $9l1HQ.validateActionEvent)(event);
        });
        return compressedEvents.concat(incompatibleEvents);
    };
}

});
parcelRegister("3mq7P", function(module, exports) {
$parcel$export(module.exports, "isActionEventType", () => $6caa211cccd5604c$export$d19cebda16f7579a);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $6yEEN = parcelRequire("6yEEN");
function $6caa211cccd5604c$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $6yEEN.eventType).OPERATIONAL:
        case (0, $6yEEN.eventType).TRACK:
        case (0, $6yEEN.eventType).UI:
            return true;
        default:
            return false;
    }
}

});

parcelRegister("9l1HQ", function(module, exports) {
$parcel$export(module.exports, "validateActionEvent", () => $e8d8d013c4d3c887$export$e0c121325c66ed4c);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $cof0D = parcelRequire("cof0D");
function $e8d8d013c4d3c887$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    (0, $cof0D.validateContainers)(event.containers);
}

});
parcelRegister("cof0D", function(module, exports) {
$parcel$export(module.exports, "validateContainers", () => $e3c151643c3ba0ec$export$e63ea5d8477971d3);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $7fdF2 = parcelRequire("7fdF2");
function $e3c151643c3ba0ec$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>(0, $7fdF2.validateContainersObject)(container));
}

});
parcelRegister("7fdF2", function(module, exports) {
$parcel$export(module.exports, "validateContainersObject", () => $ba592b3841a86885$export$df8ff30e3c960006);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $gmwxH = parcelRequire("gmwxH");
function $ba592b3841a86885$export$df8ff30e3c960006(container) {
    if (!(0, $gmwxH.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}

});



parcelRegister("iFSFK", function(module, exports) {
$parcel$export(module.exports, "validateActionEventType", () => $bf745d79a7e3b06f$export$4a8d7476662aebcc);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $6yEEN = parcelRequire("6yEEN");

var $3mq7P = parcelRequire("3mq7P");
const $bf745d79a7e3b06f$var$actionEventTypes = Object.freeze([
    (0, $6yEEN.eventType).OPERATIONAL,
    (0, $6yEEN.eventType).TRACK,
    (0, $6yEEN.eventType).UI
]);
function $bf745d79a7e3b06f$export$4a8d7476662aebcc(type) {
    if (!(0, $3mq7P.isActionEventType)(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$bf745d79a7e3b06f$var$actionEventTypes}]`);
    return true;
}

});




parcelRegister("5hVPW", function(module, exports) {
$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => $236fb7d2bb39a6c6$export$fa6e3729c21cb8f);
var $236fb7d2bb39a6c6$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("h6Sce", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba200e6434f568f1$export$2e2bcd8739ae039);

var $hLqf1 = parcelRequire("hLqf1");

var $01o2L = parcelRequire("01o2L");

var $akdUN = parcelRequire("akdUN");

var $6FwgN = parcelRequire("6FwgN");

var $2Sn0X = parcelRequire("2Sn0X");

var $80hV4 = parcelRequire("80hV4");

var $jQSOC = parcelRequire("jQSOC");

var $fTVBT = parcelRequire("fTVBT");

var $4t7l6 = parcelRequire("4t7l6");

var $dqphw = parcelRequire("dqphw");

var $6KUTo = parcelRequire("6KUTo");

var $h5bp1 = parcelRequire("h5bp1");

var $8hcKA = parcelRequire("8hcKA");

var $2Wbf8 = parcelRequire("2Wbf8");

var $hCUC3 = parcelRequire("hCUC3");

var $387qv = parcelRequire("387qv");
class $ba200e6434f568f1$var$AnalyticsAPIResponse {
    success;
    validationErrors;
    message;
    code;
    validationReports;
    constructor(success, validationErrors, message, code, validationReports){
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports === undefined ? null : this.validationReports;
    }
}
class $ba200e6434f568f1$var$Message {
    error;
    constructor(error){
        this.error = error;
    }
}
class $ba200e6434f568f1$var$EventValidationReport {
    messageId;
    results;
    constructor(messageId, results){
        this.messageId = messageId;
        this.results = results;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
}
class $ba200e6434f568f1$export$2e2bcd8739ae039 {
    user;
    options;
    resilienceQueue;
    gasv3BatchUrl;
    metrics;
    xidPromiseCallback;
    responseCallback;
    metadataClient;
    useUrlFromMetadata;
    lastSendEventsError;
    lastUrlFallbackError;
    originTracingClient = null;
    constructor(options){
        this.options = {
            ...options,
            requestTimeout: options.requestTimeout || (0, $jQSOC.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false,
            env: options.env,
            perimeter: options.perimeter || '',
            enableMetadataCalls: typeof options.enableMetadataCalls === 'boolean' ? options.enableMetadataCalls : true,
            enableEventCalls: typeof options.enableEventCalls === 'boolean' ? options.enableEventCalls : true
        };
        this.user = new (0, $387qv.default)(this.options?.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $01o2L.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $hLqf1.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.metadataClient = options.metadataClient;
        this.useUrlFromMetadata = true;
        this.lastSendEventsError = null;
        this.lastUrlFallbackError = null;
        setInterval(()=>{
            this.useUrlFromMetadata = true;
        }, 600000);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $hCUC3.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $hCUC3.SegmentEventTypes).TRACK,
            properties: (0, $8hcKA.prepareEventProperties)(builtEvent),
            event: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $hCUC3.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $hCUC3.SegmentEventTypes).PAGE,
            properties: (0, $8hcKA.prepareEventProperties)(builtEvent),
            name: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $hCUC3.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $hCUC3.SegmentEventTypes).IDENTIFY,
            traits: (0, $8hcKA.prepareEventProperties)(builtEvent)
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async enqueueEvent(packagedEvent) {
        if (this.options.enableMetadataCalls) this.metadataClient.start(false); // Start the metadata client if needed
        await this.resilienceQueue.addItem(packagedEvent);
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $h5bp1.prepareEventContext)(context);
        const segmentContext = (0, $80hV4.buildContext)(clonedContext, overrides);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, $akdUN.default)()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    // Using anonymous function so it can have the BatchFlushCallback type associated with it
    // And to allow it to not need bind when passing through to ResilieceQueue.
    sendEvents = async (items, callback)=>{
        if (this.options.enableEventCalls === false) return;
        const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
        const metricsPayload = this.metrics.getMetricsPayload();
        const eventsWithXID = await this.attachXIDs(items);
        // Calculating sentAt after the XID generation as this may take some time.
        const sentAt = new Date().toISOString();
        const metadataInfo = await this.metadataClient.getMetadataAsync();
        const [eventUrl, isFallbackUrl] = this.getEventUrl(metadataInfo);
        const metadata = {
            ...metricsPayload,
            httpRetryCount: httpRetryCount,
            lastSendEventsErrorReason: this.lastSendEventsError?.message || null,
            // Temporary back-compat
            lastSendEventsError: this.lastSendEventsError,
            lastUrlFallbackError: this.lastUrlFallbackError,
            isUsingFallbackUrl: isFallbackUrl,
            props: metadataInfo?.props || null,
            metadataClientMetrics: this.metadataClient?.metrics || null
        };
        // Remove default values from metadata to save space
        this.cleanLibraryMetadata(metadata);
        const unpackagedEvents = eventsWithXID.map((item)=>{
            this.applyExclusions(item);
            item.msg.sentAt = sentAt;
            return item.msg;
        });
        const batchBody = {
            batch: unpackagedEvents,
            sentAt: sentAt,
            metadata: metadata
        };
        try {
            const response = await (0, $2Wbf8.sendEvents)({
                url: eventUrl,
                batch: batchBody,
                timeout: this.options.requestTimeout
            });
            this.lastSendEventsError = null;
            this.lastUrlFallbackError = null;
            this.metrics.subtractFromMetrics(metricsPayload);
            callback(null, response);
            this.originTracingClient?.cleanupOriginParameters(items);
            await this.invokeLocalResponseCallbackAsync(items, response, null);
        } catch (error) {
            // If there's an error, other than one which indicates a temporary problem with the service,
            // we'll stop using the URL from the metadata and fall back to the default URL. After a time
            // we'll fall forward again in case the problem has been resolved.
            if (error instanceof (0, $4t7l6.FetchError) && [
                429,
                503
            ].includes(error.statusCode)) // Ignore 429 and 503 errors since they're considered to indicate a temporary
            // issue with the service, rather than a network failure due to blocked requests.
            this.lastSendEventsError = new (0, $6KUTo.LastError)('ServerBusyError', error);
            else {
                const errorName = error instanceof Error && (0, $hCUC3.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
                this.lastSendEventsError = new (0, $6KUTo.LastError)(errorName, error);
                // Handle falling back to the default URL if we're using the metadata URL.
                this.useUrlFromMetadata = false;
                // If we're now using the fallback URL, and the last attempt wasn't,
                // we'll record this as the error that triggered the fallback.
                const [_, willUseFallbackUrl] = this.getEventUrl(metadataInfo);
                if (willUseFallbackUrl && willUseFallbackUrl !== isFallbackUrl) this.lastUrlFallbackError = this.lastSendEventsError;
            }
            callback(error, null);
            await this.invokeLocalResponseCallbackAsync(items, null, error);
        }
    };
    applyExclusions(item) {
        const msg = item.msg;
        const properties = msg.properties;
        const traits = msg.traits;
        const excluded = msg.context?.excludedProperties;
        if (!excluded) return;
        if (excluded.anonymousId === true) msg.anonymousId = undefined;
        if (excluded.interactionSession === true) {
            if (properties) properties.interactionSession = undefined;
        }
        if (excluded.sessionId === true) {
            if (properties) properties.sessionId = undefined;
        }
        if (excluded.pageLoadId === true) {
            if (properties) properties.pageLoadId = undefined;
        }
        if (excluded.tabId === true) {
            if (properties) properties.tabId = undefined;
        }
        if (excluded.taskSessions === true) {
            if (properties) properties.taskSessions = undefined;
        }
        if (excluded.userId === true) {
            msg.userId = undefined;
            if (properties) properties.userIdType = undefined;
        }
        if (excluded.xid === true) {
            if (properties) properties.xid = undefined;
            if (traits) traits.xid = undefined;
        }
    }
    getEventUrl(metadataInfo) {
        const preferredBatchUrl = metadataInfo?.url ? metadataInfo.url : this.gasv3BatchUrl;
        const finalBatchUrl = this.useUrlFromMetadata ? preferredBatchUrl : this.gasv3BatchUrl;
        const isFallbackUrl = preferredBatchUrl === this.gasv3BatchUrl ? null : finalBatchUrl !== preferredBatchUrl;
        return [
            finalBatchUrl,
            isFallbackUrl
        ];
    }
    cleanLibraryMetadata(obj) {
        // skip if the parameter is not an object
        if (obj === null || typeof obj !== 'object') return;
        for(const key in obj){
            // Skip cleaning up props object and its keys
            // to avoid having to check the existence of the fields in props object
            // and manipulate them to calculate metadata signature in analytics service
            if (key === 'props') continue;
            let value = obj[key];
            // Remove null or undefined values
            if (value === null || value === undefined) delete obj[key];
            else if (typeof value === 'number' && value === 0) delete obj[key];
            else if (Array.isArray(value)) {
                if (value.length === 0) delete obj[key];
                else value.forEach((item)=>{
                    this.cleanLibraryMetadata(item);
                });
            } else if (typeof value === 'object') this.cleanLibraryMetadata(obj[key]);
        }
    }
    async invokeLocalResponseCallbackAsync(items, response, error) {
        const localResponseCallback = this.responseCallback;
        if (localResponseCallback) {
            // If we have a response, we'll parse it and create an AnalyticsAPIResponse from it.
            let analyticsAPIResponse = null;
            if (response) {
                let responseObject;
                try {
                    responseObject = await response.clone().json();
                } catch  {
                // Ignore errors parsing the response, we can't do anything about them
                }
                // Ensure we've got a valid object to work with, filling in any missing
                // properties as best we can.
                responseObject = responseObject || {};
                responseObject.code = Number.parseInt(responseObject.code) > 0 ? Number.parseInt(responseObject.code) : response.status;
                responseObject.success = responseObject.success || responseObject.code >= 200 && responseObject.code <= 299;
                analyticsAPIResponse = new $ba200e6434f568f1$var$AnalyticsAPIResponse(responseObject.success, responseObject.validationErrors || new Map(), new $ba200e6434f568f1$var$Message(responseObject.message?.error || ''), responseObject.code, responseObject.validationReports || null);
            }
            // If we have an error, but it's not an instance of Error (e.g. it's a string), we'll convert it to an Error object.
            if (error && !(error instanceof Error)) error = new Error(String(error));
            const analyticsResponse = $ba200e6434f568f1$var$BatchInterceptor.toAnalyticsResponse(items || [], error || null, // In case 'error' were to be undefined we'll convert it to null.
            analyticsAPIResponse);
            localResponseCallback(analyticsResponse);
        }
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $6FwgN.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    /** @internal Used by AnalyticsWebClient to wire up origin tracing cleanup. */ setOriginTracingClient(client) {
        this.originTracingClient = client;
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
    refreshMetadata(userInfo, tenantInfo) {
        this.metadataClient.userInfo = userInfo;
        this.metadataClient.tenantInfo = tenantInfo;
    }
}
class $ba200e6434f568f1$var$BatchInterceptor {
    static http_error_regex = /HTTP Error\s([0-9]{3})\s\((.+)\)/;
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                analyticsAPIResponse.validationReports?.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new (0, $fTVBT.EventResponse)(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new (0, $2Sn0X.AnalyticsResponse)(success, statusCode, (0, $dqphw.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = analyticsAPIResponse.message?.error !== null ? analyticsAPIResponse.message.error : (0, $dqphw.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $dqphw.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $dqphw.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new (0, $fTVBT.EventResponse)(item.msg.messageId, [], item.msg));
                });
                return new (0, $2Sn0X.AnalyticsResponse)(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error?.message) {
            const match = error.message.match($ba200e6434f568f1$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new (0, $fTVBT.EventResponse)(item.msg.messageId, [], item.msg));
                });
                return new (0, $2Sn0X.AnalyticsResponse)(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new (0, $fTVBT.EventResponse)(item.msg.messageId, [], item.msg));
        });
        return new (0, $2Sn0X.AnalyticsResponse)(false, -1, (0, $dqphw.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}

});
parcelRegister("hLqf1", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba06f754ab45912a$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $c4drF = parcelRequire("c4drF");

var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ba06f754ab45912a$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $c4drF.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("c4drF", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_POLLING_OPTIONS", () => $f042c86e7f39cc1c$export$d219df4fe04c04a7);
$parcel$export(module.exports, "default", () => $f042c86e7f39cc1c$export$2e2bcd8739ae039);

var $ldEFV = parcelRequire("ldEFV");

var $8xvEx = parcelRequire("8xvEx");

var $1Olia = parcelRequire("1Olia");

var $4C2iD = parcelRequire("4C2iD");

var $2eIO7 = parcelRequire("2eIO7");

var $01o2L = parcelRequire("01o2L");

var $5JD19 = parcelRequire("5JD19");

var $begmT = parcelRequire("begmT");

var $7YeV5 = parcelRequire("7YeV5");

var $iIQlI = parcelRequire("iIQlI");
const $f042c86e7f39cc1c$var$ONE_MINUTE = 60000;
const $f042c86e7f39cc1c$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $f042c86e7f39cc1c$var$ONE_MINUTE,
    minRetryDelay: $f042c86e7f39cc1c$var$ONE_MINUTE,
    maxRetryDelay: $f042c86e7f39cc1c$var$ONE_MINUTE
};
const $f042c86e7f39cc1c$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // The maximum number of events that can be stored in the resilience queue (IndexedDB/memory).
    // This limit is per product and is enforced by the EventCountGuard in the resilience layer.
    maxQueueSize: 8000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $f042c86e7f39cc1c$export$2e2bcd8739ae039 {
    queuePrefix;
    resilience;
    batchFlushCallback;
    options;
    scheduler;
    longPollingScheduler;
    metricsCollector;
    networkStatus;
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $1Olia.default)(product, {
            logger: logger,
            maxAttempts: options?.maxAttempts,
            maxEventLimit: options?.maxQueueSize || $f042c86e7f39cc1c$export$d219df4fe04c04a7.maxQueueSize
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $begmT.default)({
            ...this.options,
            waitInterval: options?.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }, this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $begmT.default)({
            ...$f042c86e7f39cc1c$var$LONG_POLLING_OPTIONS,
            waitInterval: $f042c86e7f39cc1c$var$LONG_POLLING_OPTIONS.flushWaitMs
        }, this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $01o2L.default)();
        this.networkStatus = new (0, $5JD19.default)((status)=>{
            if (status === (0, $iIQlI.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $4C2iD.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $iIQlI.NetworkStatusEnum).OFFLINE) {
            done((0, $7YeV5.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $2eIO7.CallbackProcessingErrorName)) {
                done((0, $7YeV5.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $ldEFV.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $8xvEx.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $4C2iD.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $7YeV5.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $7YeV5.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $7YeV5.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || $f042c86e7f39cc1c$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : $f042c86e7f39cc1c$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: options?.batchFlushSize || $f042c86e7f39cc1c$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: options?.flushBeforeUnload || $f042c86e7f39cc1c$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: options?.flushWaitMs || $f042c86e7f39cc1c$export$d219df4fe04c04a7.flushWaitMs,
            maxQueueSize: options?.maxQueueSize || $f042c86e7f39cc1c$export$d219df4fe04c04a7.maxQueueSize,
            maxAttempts: options?.maxAttempts || $f042c86e7f39cc1c$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: options?.maxRetryDelay || $f042c86e7f39cc1c$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || $f042c86e7f39cc1c$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}

});
parcelRegister("ldEFV", function(module, exports) {
$parcel$export(module.exports, "default", () => $882dc867356bc33a$export$2e2bcd8739ae039);

var $hQXbP = parcelRequire("hQXbP");

var $gqRNZ = parcelRequire("gqRNZ");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $882dc867356bc33a$var$validSuffixs = Object.values((0, $hQXbP.LocalStorageKeySuffix));
var $882dc867356bc33a$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $882dc867356bc33a$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $hQXbP.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $gqRNZ.createLocalStorageKeys)(prefix, id);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(inProgress);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(queue);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(reclaimStart);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("hQXbP", function(module, exports) {
$parcel$export(module.exports, "LocalStorageKeySuffix", () => $d8453ab6d7de843e$export$ecfa71cbc9b28241);
$parcel$export(module.exports, "Timers", () => $d8453ab6d7de843e$export$8bb2c1fb2b1765a9);
var $d8453ab6d7de843e$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
var $d8453ab6d7de843e$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("gqRNZ", function(module, exports) {
$parcel$export(module.exports, "createLocalStorageKeys", () => $7c597dd6673c24a5$export$8433d54f767cbec5);

var $hQXbP = parcelRequire("hQXbP");
const $7c597dd6673c24a5$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $hQXbP.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $hQXbP.LocalStorageKeySuffix).ACK}`,
        [(0, $hQXbP.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $hQXbP.LocalStorageKeySuffix).QUEUE}`,
        [(0, $hQXbP.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $hQXbP.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $hQXbP.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $hQXbP.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $hQXbP.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $hQXbP.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("8xvEx", function(module, exports) {
$parcel$export(module.exports, "default", () => $be1d83f9b54d1711$export$2e2bcd8739ae039);

var $akdUN = parcelRequire("akdUN");

var $hQXbP = parcelRequire("hQXbP");

var $gqRNZ = parcelRequire("gqRNZ");
const $be1d83f9b54d1711$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $be1d83f9b54d1711$var$findOtherQueues = (queuePrefix)=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $hQXbP.LocalStorageKeySuffix).ACK) try {
                // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $hQXbP.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch  {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch  {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $be1d83f9b54d1711$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(ack, start.toString());
    await $be1d83f9b54d1711$var$promisedSetTimeout((0, $hQXbP.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $hQXbP.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $be1d83f9b54d1711$var$promisedSetTimeout((0, $hQXbP.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $hQXbP.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $be1d83f9b54d1711$var$reclaim(options, callback);
};
const $be1d83f9b54d1711$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = {
            ...item,
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        };
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $be1d83f9b54d1711$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(inProgress);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $be1d83f9b54d1711$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $be1d83f9b54d1711$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.queue);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.inProgress);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.reclaimEnd);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.ack);
};
var $be1d83f9b54d1711$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, $akdUN.default)();
    const queuesToReclaim = $be1d83f9b54d1711$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$be1d83f9b54d1711$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $gqRNZ.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});
parcelRegister("akdUN", function(module, exports) {
$parcel$export(module.exports, "default", () => $550e2bec6cfe75c2$export$2e2bcd8739ae039);
// UUID v4 generator with fallback for non-secure contexts
function $550e2bec6cfe75c2$export$2e2bcd8739ae039() {
    const g = globalThis;
    try {
        if (g.crypto && typeof g.crypto.randomUUID === 'function') return g.crypto.randomUUID();
    } catch  {
    // ignore and fallback
    }
    // Fallback to Math.random-based v4 UUID
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.floor(Math.random() * 16);
        const v = c === 'x' ? r : r & 0x3 | 0x8; // x => random hex digit; y => set RFC 4122 variant bits (10xx), yielding 8, 9, a, or b
        return v.toString(16);
    });
}

});


parcelRegister("1Olia", function(module, exports) {
$parcel$export(module.exports, "default", () => $dff95ef306d8cb1e$export$2e2bcd8739ae039);

var $rfmTU = parcelRequire("rfmTU");
var $dff95ef306d8cb1e$export$2e2bcd8739ae039 = (0, $rfmTU.default);

});
parcelRegister("rfmTU", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe84693c3db8260d$export$2e2bcd8739ae039);

var $4C2iD = parcelRequire("4C2iD");

var $8860M = parcelRequire("8860M");

var $94QKN = parcelRequire("94QKN");

var $cbnIY = parcelRequire("cbnIY");

var $5arE4 = parcelRequire("5arE4");

var $20x1F = parcelRequire("20x1F");
class $fe84693c3db8260d$export$2e2bcd8739ae039 {
    resilience;
    options;
    namespace;
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $8860M.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $5arE4.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $94QKN.default))) options.logger?.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
        }
        return new (0, $20x1F.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $4C2iD.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $4C2iD.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $cbnIY.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $4C2iD.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $20x1F.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $4C2iD.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
}

});
parcelRegister("4C2iD", function(module, exports) {
$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", () => $1a3ed7c526d9ac95$export$d21fbb25eb37b5bf);
$parcel$export(module.exports, "RESILIENCE_DB_NAME", () => $1a3ed7c526d9ac95$export$8cad224051643259);
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", () => $1a3ed7c526d9ac95$export$3d8420be07b276ab);
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", () => $1a3ed7c526d9ac95$export$a512a65455fce2a6);
$parcel$export(module.exports, "TIME_ADDED_INDEX", () => $1a3ed7c526d9ac95$export$89d9c1ff8ac91862);
$parcel$export(module.exports, "RETRY_INDEX", () => $1a3ed7c526d9ac95$export$a37d385bcd713809);
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", () => $1a3ed7c526d9ac95$export$6d8635fed0e4b14d);
$parcel$export(module.exports, "StoreType", () => $1a3ed7c526d9ac95$export$39337ab5872e9457);
$parcel$export(module.exports, "GuardPolicy", () => $1a3ed7c526d9ac95$export$7710d69e6f450f20);
const $1a3ed7c526d9ac95$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $1a3ed7c526d9ac95$export$8cad224051643259 = 'analytics-web-client';
const $1a3ed7c526d9ac95$export$3d8420be07b276ab = 'analytics-resilience';
const $1a3ed7c526d9ac95$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $1a3ed7c526d9ac95$export$89d9c1ff8ac91862 = 'timeAdded';
const $1a3ed7c526d9ac95$export$a37d385bcd713809 = 'retryAttempts';
const $1a3ed7c526d9ac95$export$6d8635fed0e4b14d = 15000;
var $1a3ed7c526d9ac95$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
var $1a3ed7c526d9ac95$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("8860M", function(module, exports) {
$parcel$export(module.exports, "createOptionsWithDefaults", () => $92e957c04fb15daf$export$ddc6718318090f71);

var $1n9ft = parcelRequire("1n9ft");
const $92e957c04fb15daf$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $1n9ft.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $1n9ft.EVENT_COUNT_LIMIT)
    });

});
parcelRegister("1n9ft", function(module, exports) {
$parcel$export(module.exports, "GET_ITEM_COUNT", () => $67507f0d6afa2492$export$b6df3d334cec060f);
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", () => $67507f0d6afa2492$export$14ef152a03a4b6ee);
$parcel$export(module.exports, "MAX_ATTEMPTS", () => $67507f0d6afa2492$export$da9ab7b2fd5998e8);
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", () => $67507f0d6afa2492$export$1188664dfff364c8);
const $67507f0d6afa2492$export$b6df3d334cec060f = 7;
const $67507f0d6afa2492$export$14ef152a03a4b6ee = 60000;
const $67507f0d6afa2492$export$da9ab7b2fd5998e8 = 10;
const $67507f0d6afa2492$export$1188664dfff364c8 = 8000;

});


parcelRegister("94QKN", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f3145fe2ff9cf8d$export$2e2bcd8739ae039);
const $2f3145fe2ff9cf8d$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $2f3145fe2ff9cf8d$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $2f3145fe2ff9cf8d$export$2e2bcd8739ae039.prototype);
        this.name = $2f3145fe2ff9cf8d$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("cbnIY", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreResilienceDbError", () => $3de84c348995c363$export$74101021e0969375);

var $caN3I = parcelRequire("caN3I");

var $2eIO7 = parcelRequire("2eIO7");

var $eG7ts = parcelRequire("eG7ts");
const $3de84c348995c363$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $caN3I.AbandonWriteErrorName) || errorWithName.name === (0, $2eIO7.CallbackProcessingErrorName) || errorWithName.name === (0, $eG7ts.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("caN3I", function(module, exports) {
$parcel$export(module.exports, "AbandonWriteErrorName", () => $cc73796265993b01$export$ba95206613c96b28);
$parcel$export(module.exports, "default", () => $cc73796265993b01$export$2e2bcd8739ae039);
const $cc73796265993b01$export$ba95206613c96b28 = 'AbandonWriteError';
class $cc73796265993b01$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $cc73796265993b01$export$2e2bcd8739ae039.prototype);
        this.name = $cc73796265993b01$export$ba95206613c96b28;
    }
}

});

parcelRegister("2eIO7", function(module, exports) {
$parcel$export(module.exports, "CallbackProcessingErrorName", () => $61e8a86132e5e7df$export$a409c8de90e11e14);
$parcel$export(module.exports, "default", () => $61e8a86132e5e7df$export$2e2bcd8739ae039);
const $61e8a86132e5e7df$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $61e8a86132e5e7df$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $61e8a86132e5e7df$export$2e2bcd8739ae039.prototype);
        this.name = $61e8a86132e5e7df$export$a409c8de90e11e14;
    }
}

});

parcelRegister("eG7ts", function(module, exports) {
$parcel$export(module.exports, "InvalidPolicyErrorName", () => $fec22f9fa6df835a$export$7e7aee9a953465ec);
$parcel$export(module.exports, "default", () => $fec22f9fa6df835a$export$2e2bcd8739ae039);
const $fec22f9fa6df835a$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $fec22f9fa6df835a$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $fec22f9fa6df835a$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("5arE4", function(module, exports) {
$parcel$export(module.exports, "default", () => $230a3e9f45263a56$export$2e2bcd8739ae039);

var $lDglx = parcelRequire("lDglx");

var $4C2iD = parcelRequire("4C2iD");

var $7f6E8 = parcelRequire("7f6E8");

var $8860M = parcelRequire("8860M");

var $1n9ft = parcelRequire("1n9ft");

var $2eIO7 = parcelRequire("2eIO7");

var $eG7ts = parcelRequire("eG7ts");

var $94QKN = parcelRequire("94QKN");

var $cbnIY = parcelRequire("cbnIY");

var $eX2VP = parcelRequire("eX2VP");

var $1Ww9U = parcelRequire("1Ww9U");

var $2PhLz = parcelRequire("2PhLz");
class $230a3e9f45263a56$export$2e2bcd8739ae039 {
    db;
    logger;
    globalEventLimitGuard;
    options;
    namespace;
    constructor(namespace, options = {}){
        this.options = (0, $8860M.createOptionsWithDefaults)(options);
        this.namespace = namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $94QKN.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $eX2VP.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    startDB = async ()=>{
        return new Promise(async (resolve, reject)=>{
            if (typeof window !== 'undefined') {
                const dbTimeout = window.setTimeout(()=>{
                    this.logger.warn('IndexedDB timed out.');
                    reject(new (0, $94QKN.default)());
                }, (0, $4C2iD.INDEXEDDB_TIMEOUT));
                /*
         * The database version number can never change.
         * An upgrade transaction is limited to only one connection to the database.
         * Once this is done, we cannot open any connections with older versions of the schema.
         * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
         *
         * Due to the nature of how AWC is used (multiple tabs that are very long lived),
         * we will not be able to run version upgrades via indexeddb.
         *
         * This does not mean we cant change what is stored in the tables,
         * this limitation just prevents us from:
         *   - Creating new ObjectStores in this database connection, and
         *   - Creating new indexes on our ObjectStores
         *
         * Any upgrades we wish to run in the future will have to create a new database,
         * and migrate all the data from older databases.
         *
         * This also means any migrations we make will have to be supported until we have evidence
         * that no events are coming from old versions of the database.
         * This may take a long time.
         */ const request = window.indexedDB.open((0, $4C2iD.RESILIENCE_DB_NAME), 1);
                request.onupgradeneeded = (event)=>{
                    if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                    const db = request.result;
                    const store = db.createObjectStore((0, $4C2iD.RESILIENCE_STORE_NAME), {
                        keyPath: 'id'
                    });
                    store.createIndex((0, $4C2iD.TIME_TO_PROCESS_AFTER_INDEX), (0, $4C2iD.TIME_TO_PROCESS_AFTER_INDEX), {
                        unique: false
                    });
                    store.createIndex((0, $4C2iD.RETRY_INDEX), (0, $4C2iD.RETRY_INDEX), {
                        unique: false
                    });
                    store.createIndex((0, $4C2iD.TIME_ADDED_INDEX), (0, $4C2iD.TIME_ADDED_INDEX), {
                        unique: false
                    });
                    // Compound key index of product - timeAdded.
                    store.createIndex((0, $4C2iD.NAMESPACE_AND_TIME_ADDED_INDEX), [
                        'namespace',
                        'timeAdded'
                    ], {
                        unique: false
                    });
                };
                request.onerror = function() {
                    reject(new (0, $94QKN.default)());
                };
                try {
                    await (0, $2PhLz.requestToPromise)(request);
                    return resolve(request.result);
                } catch (error) {
                    this.logger.warn('IndexedDB failed to initialise.', error);
                    reject(new (0, $94QKN.default)());
                } finally{
                    window.clearTimeout(dbTimeout);
                }
            } else {
                this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                reject(new (0, $94QKN.default)());
            }
        });
    };
    addItem = async (item, options = {}, policy = (0, $4C2iD.GuardPolicy).ABANDON)=>{
        const { logger: logger, namespace: namespace } = this;
        const value = (0, $7f6E8.convertToItemWrapper)(item, namespace, options);
        const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
        if (policy === (0, $4C2iD.GuardPolicy).IGNORE) throw new (0, $eG7ts.default)(policy, 'IndexedDbConnector#addItem');
        try {
            if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
            // Making space for 1 event, if required.
            const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                value
            ], policy);
            if (bulkAddResult.items.length === 1) return {
                item: bulkAddResult.items[0],
                numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
            };
            // Should never happen as the Policy and EventCountGuard should cause another pathway
            throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
        } catch (error) {
            if ((0, $cbnIY.shouldIgnoreResilienceDbError)(error)) throw error;
            logger.log('Failed to add item to table', error);
            throw new Error('Request to add item to table failed');
        }
    };
    bulkAddItem = async (itemOptions, policy = (0, $4C2iD.GuardPolicy).ABANDON)=>{
        const { logger: logger, namespace: namespace } = this;
        const items = itemOptions.map(({ item: item, ...options })=>(0, $7f6E8.convertToItemWrapper)(item, namespace, options));
        const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
        try {
            return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
        } catch (error) {
            if ((0, $cbnIY.shouldIgnoreResilienceDbError)(error)) throw error;
            logger.log('Failed to add item to table', error);
            throw new Error('Request to add item to table failed');
        }
    };
    getItems = async (count = (0, $1n9ft.GET_ITEM_COUNT))=>{
        const fixedCount = count > 0 ? count : (0, $1n9ft.GET_ITEM_COUNT);
        const { logger: logger } = this;
        const maxAttempts = this.options.maxAttempts;
        const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
        const timeIndex = objectStore.index((0, $4C2iD.TIME_TO_PROCESS_AFTER_INDEX));
        const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
        const request = timeIndex.openCursor(upperBoundOpenKeyRange);
        const getResult = await new Promise(async (resolve, reject)=>{
            const items = [];
            let numberOfDeletedItems = 0;
            request.onerror = (error)=>{
                logger.error('Failed to open cursor:', error);
                reject('Failed to open cursor');
            };
            // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
            request.onsuccess = (event)=>{
                const cursor = event.target.result;
                if (cursor) {
                    // Prevent mutation of the value we are returning
                    const value = {
                        ...cursor.value
                    };
                    items.push(value);
                    // Mutations seem to be required for testing indexeddb library
                    const updatedValue = cursor.value;
                    updatedValue.retryAttempts += 1;
                    updatedValue.timeToBeProcessedAfter = Date.now() + (0, $1n9ft.VISIBILITY_TIMEOUT);
                    if (updatedValue.retryAttempts >= maxAttempts) {
                        ++numberOfDeletedItems;
                        const request = cursor.delete();
                        (0, $1Ww9U.monitorErrorsOnRequest)(request, logger);
                    } else {
                        const request = cursor.update(updatedValue);
                        (0, $1Ww9U.monitorErrorsOnRequest)(request, logger);
                    }
                    if (items.length < fixedCount) cursor.continue();
                    else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                } else resolve({
                    items: items,
                    numberOfDeletedItems: numberOfDeletedItems
                });
            };
        });
        await (0, $lDglx.commitTransaction)(transaction, this.logger);
        return getResult;
    };
    deleteItems = async (itemIds)=>{
        const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
        try {
            const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
            await (0, $lDglx.commitTransaction)(transaction, this.logger);
            await Promise.all(deletePromises);
        } catch (error) {
            this.logger.warn('Failed to delete items from indexeddb.', error);
            throw error;
        }
    };
    getItemCount = async ()=>{
        const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
        const timeIndex = objectStore.index((0, $4C2iD.TIME_TO_PROCESS_AFTER_INDEX));
        const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
        const request = timeIndex.count(upperBoundOpenKeyRange);
        const event = await (0, $2PhLz.requestToPromise)(request);
        await (0, $lDglx.commitTransaction)(transaction, this.logger);
        return event.target.result;
    };
    processItems = async (processFn, count = (0, $1n9ft.GET_ITEM_COUNT))=>{
        const { items: items, ...partialResult } = await this.getItems(count);
        try {
            const result = await processFn(items, partialResult);
            const itemIds = items.map((item)=>item.id);
            // We should not await this delete as a rejected promise would get caught by the catch statement
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            // Eventually we will need a intermediate class to catch all errors but we should ignore this error
            // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
            // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
            throw new (0, $2eIO7.default)(error);
        }
    };
    deleteItem = async (objectStore, id)=>{
        const { logger: logger } = this;
        try {
            await (0, $2PhLz.requestToPromise)(objectStore.delete(id));
        } catch (error) {
            logger.error('Failed to delete item:', id, error);
            throw error;
        }
    };
    getObjectStoreAndTransaction = async (mode)=>{
        const transaction = (await this.db).transaction((0, $4C2iD.RESILIENCE_STORE_NAME), mode);
        const objectStore = transaction.objectStore((0, $4C2iD.RESILIENCE_STORE_NAME));
        return {
            transaction: transaction,
            objectStore: objectStore
        };
    };
    storeType() {
        return (0, $4C2iD.StoreType).INDEXEDDB;
    }
}

});
parcelRegister("lDglx", function(module, exports) {
$parcel$export(module.exports, "commitTransaction", () => $ce6f8012e62aaa76$export$feab8418f018df89);

var $8Xkw9 = parcelRequire("8Xkw9");
const $ce6f8012e62aaa76$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return (0, $8Xkw9.transactionToPromise)(transaction);
};

});
parcelRegister("8Xkw9", function(module, exports) {
$parcel$export(module.exports, "transactionToPromise", () => $a98b25187ecff225$export$2a5213bce1720b42);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $a98b25187ecff225$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};

});


parcelRegister("7f6E8", function(module, exports) {
$parcel$export(module.exports, "convertToItemWrapper", () => $9c3b46972b767e0a$export$aec476f33d77be11);

var $akdUN = parcelRequire("akdUN");
const $9c3b46972b767e0a$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, $akdUN.default)(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });

});

parcelRegister("eX2VP", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa5726a13f8da1a5$export$2e2bcd8739ae039);

var $lDglx = parcelRequire("lDglx");

var $4C2iD = parcelRequire("4C2iD");

var $caN3I = parcelRequire("caN3I");

var $2PhLz = parcelRequire("2PhLz");
class $aa5726a13f8da1a5$export$2e2bcd8739ae039 {
    eventLimit;
    namespace;
    logger;
    deleteItemHandler;
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $4C2iD.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $4C2iD.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $4C2iD.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $4C2iD.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $2PhLz.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $lDglx.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $caN3I.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $4C2iD.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $2PhLz.requestToPromise)(request);
        return event.target.result;
    }
    /**
   * This query fetches the oldest events currently stored in AWC IndexedDb object store
   * and deletes them sequentially
   */ deleteOldestNEvents = async (objectStore, count)=>{
        const productTimeAddedIndex = objectStore.index((0, $4C2iD.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
        const event = await (0, $2PhLz.requestToPromise)(getAllRequest);
        const result = event?.target?.result;
        // Adding extra safety
        if (result && Array.isArray(result) && result.length > 0) try {
            const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
            await Promise.all(deletePromises);
        } catch (error) {
            this.logger.warn('Failed to delete items from indexeddb.', error);
            throw error;
        }
    };
}

});
parcelRegister("2PhLz", function(module, exports) {
$parcel$export(module.exports, "requestToPromise", () => $87e8c430941c7718$export$85ceed0783e42041);
// Not to be used on cursors or other requests that may call onsuccess multiple times.
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $87e8c430941c7718$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};

});


parcelRegister("1Ww9U", function(module, exports) {
$parcel$export(module.exports, "monitorErrorsOnRequest", () => $931811cd3a6ef6e5$export$342d941b6f724995);
const $931811cd3a6ef6e5$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

});


parcelRegister("20x1F", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8dab793bb6dc78e$export$2e2bcd8739ae039);

var $4C2iD = parcelRequire("4C2iD");

var $7f6E8 = parcelRequire("7f6E8");

var $8860M = parcelRequire("8860M");

var $1n9ft = parcelRequire("1n9ft");

var $2eIO7 = parcelRequire("2eIO7");

var $eG7ts = parcelRequire("eG7ts");

var $84aRh = parcelRequire("84aRh");
class $e8dab793bb6dc78e$export$2e2bcd8739ae039 {
    memoryStore;
    options;
    globalEventLimitGuard;
    namespace;
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $8860M.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $84aRh.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $4C2iD.GuardPolicy).ABANDON) {
        if (policy === (0, $4C2iD.GuardPolicy).IGNORE) throw new (0, $eG7ts.default)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $7f6E8.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $4C2iD.GuardPolicy).ABANDON) {
        const items = itemOptions.map(({ item: item, ...addOptions })=>(0, $7f6E8.convertToItemWrapper)(item, this.namespace, addOptions));
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $4C2iD.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $1n9ft.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $1n9ft.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $1n9ft.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push({
                    ...wrappedItem
                });
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $1n9ft.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const { items: items, ...partialGetResult } = this.synchronousGetItems(count);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $2eIO7.default)(error);
        }
    }
    storeType() {
        return (0, $4C2iD.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}

});
parcelRegister("84aRh", function(module, exports) {
$parcel$export(module.exports, "default", () => $18ca09e71d3625b0$export$2e2bcd8739ae039);

var $4C2iD = parcelRequire("4C2iD");

var $caN3I = parcelRequire("caN3I");
class $18ca09e71d3625b0$export$2e2bcd8739ae039 {
    eventLimit;
    memoryItemHandlers;
    constructor(eventLimit, memoryItemHandlers){
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
    /**
   * Unlike IndexedDb, we cannot take advantage of any index. So we are,
   * treating the memory store as a sorted set when adding items.
   */ insertItemsToMemoryStore = (itemsToAdd, policy)=>{
        switch(policy){
            case (0, $4C2iD.GuardPolicy).ABANDON:
                return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
            case (0, $4C2iD.GuardPolicy).EVICT:
                return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
            case (0, $4C2iD.GuardPolicy).IGNORE:
                return this.handleAddAsManyAsPossible(itemsToAdd);
        }
    };
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $caN3I.default)((0, $4C2iD.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}

});




parcelRegister("01o2L", function(module, exports) {
$parcel$export(module.exports, "default", () => $00d15616a7580b75$export$2e2bcd8739ae039);

var $8FTGg = parcelRequire("8FTGg");
let $00d15616a7580b75$var$cachedMetricsClient = null;
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$00d15616a7580b75$export$2e2bcd8739ae039 = ()=>{
    if (!$00d15616a7580b75$var$cachedMetricsClient) $00d15616a7580b75$var$cachedMetricsClient = new (0, $8FTGg.MetricsCollector)();
    return $00d15616a7580b75$var$cachedMetricsClient;
};

});
parcelRegister("8FTGg", function(module, exports) {
$parcel$export(module.exports, "MetricsCollector", () => $57efc7e81e4aed70$export$4b62ee5120ab50a8);

var $iIQlI = parcelRequire("iIQlI");
class $57efc7e81e4aed70$export$4b62ee5120ab50a8 {
    // Number of events discarded due to exceeding retry limits.
    itemsDiscardedByRetry = 0;
    // Number of events created by the product in current tab.
    eventCount = 0;
    // Number of events discarded due to reaching queue max size.
    itemsDiscardedByOverflow = 0;
    // Will be used in the future when we get more resilience mechanisms
    resilienceMechanism = (0, $iIQlI.ResilienceMechanism).INDEXEDDB;
    /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
    // https://github.com/segmentio/localstorage-retry/pull/17
    localstorageNumberOfQueuesPurged = 0;
    // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
    // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
    // Queue was found, all events removed and put into resilienceDb.
    localstorageNumberOfFullReclaims = 0;
    // Queue was found but not all events were able to be put into resilienceDb.
    localstorageNumberOfPartialReclaims = 0;
    // Reclaim failed for a queue and reclaim was abandonded.
    localstorageNumberOfFailedReclaims = 0;
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
}

});
parcelRegister("iIQlI", function(module, exports) {
$parcel$export(module.exports, "ResilienceMechanism", () => $548d8509bef1f923$export$c75161629e3ec34e);
$parcel$export(module.exports, "NetworkStatusEnum", () => $548d8509bef1f923$export$ee138fa712d11b84);
var $548d8509bef1f923$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
var $548d8509bef1f923$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});



parcelRegister("5JD19", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0e073258382a972$export$2e2bcd8739ae039);

var $iIQlI = parcelRequire("iIQlI");
class $e0e073258382a972$export$2e2bcd8739ae039 {
    _networkChangeCallback;
    constructor(networkChangeCallback){
        this._networkChangeCallback = networkChangeCallback;
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $iIQlI.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $iIQlI.NetworkStatusEnum).ONLINE));
        }
    }
    removeListeners() {
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $iIQlI.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $iIQlI.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $iIQlI.NetworkStatusEnum).ONLINE;
        return (0, $iIQlI.NetworkStatusEnum).OFFLINE;
    }
}

});

parcelRegister("begmT", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d9c1d737878794e$export$2e2bcd8739ae039);

var $sYtmI = parcelRequire("sYtmI");

var $7YeV5 = parcelRequire("7YeV5");
const $0d9c1d737878794e$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
var $0d9c1d737878794e$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $0d9c1d737878794e$export$2e2bcd8739ae039 {
    callback;
    failureCount;
    operationInFlight;
    options;
    queuedSchedule;
    scheduledTimeout;
    callbackTimer;
    constructor(retryOptions, callback){
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $0d9c1d737878794e$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $0d9c1d737878794e$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $0d9c1d737878794e$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $0d9c1d737878794e$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $0d9c1d737878794e$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $0d9c1d737878794e$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = 0;
        this.callbackTimer = new (0, $sYtmI.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
    schedule = ({ immediate: immediate } = {})=>{
        if (typeof window === 'undefined') return;
        if (this.operationInFlight) {
            if (immediate) this.queuedSchedule = 1;
            else if (this.queuedSchedule !== 1) this.queuedSchedule = 2;
        // Only run immediately if we have no failures
        } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
            this.clearTimeout();
            this.run();
        // Calculate backoff for normal or failure scenario
        } else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
    };
    stop = ()=>{
        this.clearTimeout();
        this.queuedSchedule = 0;
    };
    getFailureCount = ()=>this.failureCount;
    getCallbackStatus = ()=>{
        return this.callbackTimer.getCallbackStatus();
    };
    clearTimeout = ()=>{
        if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
            window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    };
    run = ()=>{
        this.operationInFlight = true;
        this.clearTimeout();
        try {
            this.callbackTimer.executeCallbackWithTimeout(// callback to execute
            this.callback, // when callback completes, call this function
            this.done, // on timeout, do this instead
            ()=>this.done((0, $7YeV5.DoneState).ERROR));
        } catch (err) {
            this.done(err);
        }
    };
    done = (state)=>{
        this.operationInFlight = false;
        if (state === (0, $7YeV5.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $sYtmI.CallbackStatus).TIMED_OUT) {
            this.failureCount++;
            this.clearTimeout();
        } else if (state === (0, $7YeV5.DoneState).SUCCESS) this.failureCount = 0;
        this.processQueuedSchedule();
    };
    processQueuedSchedule = ()=>{
        if (this.queuedSchedule !== 0) {
            const immediate = this.queuedSchedule === 1;
            this.queuedSchedule = 0;
            this.schedule({
                immediate: immediate
            });
        } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
        // For example, when this.callback(this._done) was not called within
        // this.callbackTimeoutPeriod
        this.schedule();
    };
    calculateBackoff = ()=>{
        const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage, waitInterval: waitInterval } = this.options;
        // Helper for deviation based on a single random sample
        const jitter = (base, symmetric)=>{
            if (!backoffJitterPercentage || base <= 0) return 0;
            const r = (Math.random() - 0.5) * 2;
            const frac = symmetric ? r : Math.abs(r);
            return Math.floor(frac * backoffJitterPercentage * base);
        };
        // No failures: wait interval with positive-only jitter
        if (this.failureCount === 0) return waitInterval + jitter(waitInterval, false);
        // Failures: exponential backoff with symmetric jitter
        const base = Math.min(minRetryDelay * backoffFactor ** this.failureCount, maxRetryDelay);
        const withJitter = base + jitter(base, true);
        return Math.max(minRetryDelay, Math.min(withJitter, maxRetryDelay));
    };
}

});
parcelRegister("sYtmI", function(module, exports) {
$parcel$export(module.exports, "CallbackStatus", () => $8a68e7ee8683649b$export$ef3353088fca369c);
$parcel$export(module.exports, "CallbackWithTimeout", () => $8a68e7ee8683649b$export$590a718599f8f8b3);
var $8a68e7ee8683649b$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
var $8a68e7ee8683649b$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $8a68e7ee8683649b$export$590a718599f8f8b3 {
    // Milliseconds to wait
    timeoutPeriod;
    // Tracks the settimeout; so that we can clear the timeout
    timeoutHandle = undefined;
    callbackStatus = "idle";
    constructor(timeoutPeriod){
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case "idle":
            case "timedOut":
            case "completed":
                if (event === "execute") this.callbackStatus = "running";
                break;
            case "running":
                switch(event){
                    case "complete":
                        this.callbackStatus = "completed";
                        break;
                    case "timeout":
                        this.callbackStatus = "timedOut";
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, "execute");
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, "timeout");
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== "timedOut") {
                this.transitionCallbackStatus(this.callbackStatus, "complete");
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}

});

parcelRegister("7YeV5", function(module, exports) {
$parcel$export(module.exports, "DoneState", () => $7513cdff52141dbd$export$f93c40fda808dd0c);
// Clients can optionally provide the callbackTimeoutPeriod parameter
var $7513cdff52141dbd$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("6FwgN", function(module, exports) {
$parcel$export(module.exports, "attachXidToMultipleEvents", () => $2a9ecaf8403f5e37$export$c21270cab66ab290);

var $dADIb = parcelRequire("dADIb");
async function $2a9ecaf8403f5e37$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>(0, $dADIb.attachXidToSingleEvent)(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("dADIb", function(module, exports) {
$parcel$export(module.exports, "attachXidToSingleEvent", () => $373446a34900a6b1$export$c9c3aaf655d6f275);

var $hCUC3 = parcelRequire("hCUC3");
function $373446a34900a6b1$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $hCUC3.SegmentEventTypes).PAGE || item.msg.type === (0, $hCUC3.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = {
            ...item.msg.properties,
            xid: xid
        };
    } else if (item.msg.traits && item.msg.type === (0, $hCUC3.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = {
            ...item.msg.traits,
            xid: xid
        };
    }
    return item;
}

});
parcelRegister("hCUC3", function(module, exports) {
$parcel$export(module.exports, "SegmentEventTypes", () => $af39c8ca899dd473$export$ddf929981dc6feb3);
$parcel$export(module.exports, "ALLOW_LISTED_FETCH_ERROR_NAMES", () => $af39c8ca899dd473$export$96f086dcf574a9e2);
var $af39c8ca899dd473$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
var $af39c8ca899dd473$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
var $af39c8ca899dd473$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});
const $af39c8ca899dd473$export$96f086dcf574a9e2 = [
    'FetchError',
    'AbortError',
    'TypeError'
];

});



parcelRegister("2Sn0X", function(module, exports) {
$parcel$export(module.exports, "AnalyticsResponse", () => $6b6fb619c362ba48$export$133650fcdde1b226);
class $6b6fb619c362ba48$export$133650fcdde1b226 {
    success;
    statusCode;
    message;
    eventResponseList;
    constructor(success, statusCode, message, eventResponseList){
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
}

});

parcelRegister("80hV4", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $7047c6f69b8b5b0b$export$3a7fe28f9bf4f3d9);

var $9FgWr = parcelRequire("9FgWr");
// Shallow removal of all falsey properties from an object, returning a new object.
const $7047c6f69b8b5b0b$var$removeFalseyProperties = (obj)=>{
    const result = {};
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) // If the value is not strictly true, map it to undefined
        {
            if (obj[key]) result[key] = obj[key];
        }
    }
    return result;
};
const $7047c6f69b8b5b0b$export$3a7fe28f9bf4f3d9 = (context, overrides)=>{
    const result = {
        ...context.context,
        userAgent: navigator.userAgent
    };
    // use nestedRemoveUndefinedValues to strip undefined properties before
    // spreading the override object since we want properties that explicitly
    // set to 'undefined' to not overwrite any values, just like properties
    // that are 'undefined' because they're not set at all will.
    if (overrides?.excludedProperties) result.excludedProperties = {
        ...result.excludedProperties,
        ...(0, $9FgWr.nestedRemoveUndefinedValues)(overrides.excludedProperties, '$.excludedProperties')
    };
    if (overrides?.userConsents) result.userConsents = {
        ...result.userConsents,
        ...(0, $9FgWr.nestedRemoveUndefinedValues)(overrides.userConsents, '$.userConsents')
    };
    // Remove any falsey properties since we only want to have exclusions
    // that were explicitly declared as excluded.
    if (result.excludedProperties) result.excludedProperties = $7047c6f69b8b5b0b$var$removeFalseyProperties(result.excludedProperties);
    return result;
};

});
parcelRegister("9FgWr", function(module, exports) {
$parcel$export(module.exports, "nestedRemoveUndefinedValues", () => $15b853f473192d66$export$2250ccecd1e040fd);
// This function will essentially deepClone as well
const $15b853f473192d66$export$2250ccecd1e040fd = (obj, path)=>{
    const recursionDepthLimit = 512;
    const nestedRemoveUndefinedValuesImpl = (source, processedReferences, path, depth)=>{
        if (source === null || typeof source !== 'object') return source;
        // If the level of nesting is egregiously excessive we'll stop processing any further to
        // avoid crashing due to stack exhaustion, instead we return a note object.
        if (depth > recursionDepthLimit) return {
            _depthLimitExceeded: true,
            message: `Object nesting depth limit exceeded at path '${path}' with depth '${depth}'`
        };
        // If this object has already been seen then processing it would create a circular reference,
        // instead we return a note object.
        if (processedReferences.has(source)) {
            const originalPath = processedReferences.get(source);
            return {
                _circularReference: true,
                message: `Circular reference to object at original path '${originalPath}' detected at path '${path}'`,
                originalPath: originalPath
            };
        }
        processedReferences.set(source, path);
        const clone = {};
        Object.keys(source).forEach((key)=>{
            const value = source[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    const newArray = [];
                    value.forEach((v, i)=>{
                        const newValue = nestedRemoveUndefinedValuesImpl(v, processedReferences, `${path}.${key}[${i}]`, depth + 1);
                        if (newValue !== undefined) newArray.push(newValue);
                    });
                    clone[key] = newArray;
                } else {
                    const newValue = nestedRemoveUndefinedValuesImpl(value, processedReferences, `${path}.${key}`, depth + 1);
                    if (newValue !== undefined) clone[key] = newValue;
                }
            }
        });
        processedReferences.delete(source);
        return clone;
    };
    return nestedRemoveUndefinedValuesImpl(obj, new Map(), path, 0);
};

});


parcelRegister("jQSOC", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", () => $9437ee47ce2b0774$export$9175ce0e1c95daf2);
$parcel$export(module.exports, "DEFAULT_METADATA_REQUEST_TIMEOUT", () => $9437ee47ce2b0774$export$8fddcd1eff390364);
$parcel$export(module.exports, "DEFAULT_METADATA_REFRESH_INTERVAL", () => $9437ee47ce2b0774$export$92ed669a3d41dad3);
$parcel$export(module.exports, "DEFAULT_METADATA_MIN_RETRY_DELAY", () => $9437ee47ce2b0774$export$6649d5c857717efe);
$parcel$export(module.exports, "DEFAULT_METADATA_MAX_RETRY_DELAY", () => $9437ee47ce2b0774$export$33e7628d3b2c0e2);
$parcel$export(module.exports, "DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL", () => $9437ee47ce2b0774$export$6f1c008dd0c3b67e);
const $9437ee47ce2b0774$export$9175ce0e1c95daf2 = 10000; // 10 seconds
const $9437ee47ce2b0774$export$8fddcd1eff390364 = 60000; // 60 seconds
const $9437ee47ce2b0774$export$92ed669a3d41dad3 = 600000; // 10 minutes
const $9437ee47ce2b0774$export$6649d5c857717efe = 5000; // 5 seconds
const $9437ee47ce2b0774$export$33e7628d3b2c0e2 = 3600000; // 60 minutes
const $9437ee47ce2b0774$export$6f1c008dd0c3b67e = 10; // 10 milliseconds

});

parcelRegister("fTVBT", function(module, exports) {
$parcel$export(module.exports, "EventResponse", () => $04ba0d63647d631b$export$51e0b986fdbf3840);
class $04ba0d63647d631b$export$51e0b986fdbf3840 {
    messageId;
    results;
    segmentEvent;
    constructor(messageId, results, segmentEvent){
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
}

});

parcelRegister("4t7l6", function(module, exports) {
$parcel$export(module.exports, "FetchError", () => $253b1eb1274c3321$export$26e841bcf1aeb894);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
class $253b1eb1274c3321$export$26e841bcf1aeb894 extends Error {
    statusCode;
    statusText;
    constructor(message, statusCode, statusText){
        super(message);
        this.statusCode = statusCode;
        this.statusText = statusText;
    }
}

});

parcelRegister("dqphw", function(module, exports) {
$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", () => $65bd245a90529cca$export$ba118f9de1e5ac63);
const $65bd245a90529cca$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

});

parcelRegister("6KUTo", function(module, exports) {
$parcel$export(module.exports, "LastError", () => $0e37a3456569258b$export$a63e16b3351b8c36);

var $4t7l6 = parcelRequire("4t7l6");
class $0e37a3456569258b$export$a63e16b3351b8c36 {
    reason;
    message;
    statusCode;
    constructor(reason, error){
        this.reason = reason;
        this.message = error instanceof Error ? error.message : null;
        this.statusCode = error instanceof (0, $4t7l6.FetchError) ? error.statusCode : null;
    }
}

});

parcelRegister("h5bp1", function(module, exports) {
$parcel$export(module.exports, "prepareEventContext", () => $d5ad63104ffb2a38$export$6b26e26d40264200);
// @ts-ignore

var $3WNR1 = parcelRequire("3WNR1");

var $9FgWr = parcelRequire("9FgWr");
const $d5ad63104ffb2a38$export$6b26e26d40264200 = (context)=>{
    const propertiesWithoutUndefined = (0, $9FgWr.nestedRemoveUndefinedValues)(context, '$.context');
    return (0, (/*@__PURE__*/$parcel$interopDefault($3WNR1)))(propertiesWithoutUndefined);
};

});
parcelRegister("3WNR1", function(module, exports) {
'use strict';

var $2Kd38 = parcelRequire("2Kd38");
/**
 * Expose `traverse`.
 */ module.exports = $2dfd75dfb2dce420$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $2dfd75dfb2dce420$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return $2dfd75dfb2dce420$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $2dfd75dfb2dce420$var$traverseArray(input, strict);
    else if ($2Kd38.is(input, strict)) return $2Kd38.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $2dfd75dfb2dce420$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $2dfd75dfb2dce420$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $2dfd75dfb2dce420$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $2dfd75dfb2dce420$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("2Kd38", function(module, exports) {
$parcel$export(module.exports, "parse", () => $1ffa0000a57ce84b$export$98e6a39c04603d36, (v) => $1ffa0000a57ce84b$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "is", () => $1ffa0000a57ce84b$export$226b3eccf92c9ed9, (v) => $1ffa0000a57ce84b$export$226b3eccf92c9ed9 = v);
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $1ffa0000a57ce84b$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $1ffa0000a57ce84b$export$226b3eccf92c9ed9;
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $1ffa0000a57ce84b$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$1ffa0000a57ce84b$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $1ffa0000a57ce84b$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$1ffa0000a57ce84b$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $1ffa0000a57ce84b$var$matcher.test(string);
};

});



parcelRegister("8hcKA", function(module, exports) {
$parcel$export(module.exports, "prepareEventProperties", () => $ebf176d11616a164$export$44d22e5fb02cc68e);
// @ts-ignore

var $3WNR1 = parcelRequire("3WNR1");

var $9FgWr = parcelRequire("9FgWr");
const $ebf176d11616a164$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = (0, $9FgWr.nestedRemoveUndefinedValues)(properties, '$.properties');
    // Remove any override properties that shouldn't be included in the event body
    delete propertiesWithoutUndefined.excludedProperties;
    delete propertiesWithoutUndefined.userConsents;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3WNR1)))(propertiesWithoutUndefined);
};

});

parcelRegister("2Wbf8", function(module, exports) {
$parcel$export(module.exports, "sendEvents", () => $71ce80c242b9af2e$export$8e8f0180c1b41fad);

var $2IvOD = parcelRequire("2IvOD");

var $1uvI9 = parcelRequire("1uvI9");

var $4t7l6 = parcelRequire("4t7l6");
const $71ce80c242b9af2e$export$8e8f0180c1b41fad = async (options)=>{
    const signal = $71ce80c242b9af2e$var$createOrGetAbortController(options)?.signal;
    const corsOptions = $71ce80c242b9af2e$var$getCorsForUrl(options.url);
    const payload = await (0, $1uvI9.createRequestPayload)(options.batch);
    const response = await fetch(options.url, {
        method: 'POST',
        ...payload,
        signal: signal,
        ...corsOptions
    });
    if (response.status !== 200) throw new (0, $4t7l6.FetchError)(`HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    try {
        let responseBody = await response.clone().json();
        if (responseBody.success === true) return response;
    } catch  {}
    throw new (0, $4t7l6.FetchError)('Invalid HTTP Response (Invalid response body)', 200, 'Invalid response body');
};
const $71ce80c242b9af2e$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
    return undefined;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $71ce80c242b9af2e$var$getCorsForUrl = (0, $2IvOD.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});
parcelRegister("2IvOD", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fa85ec6884a5e67$export$2e2bcd8739ae039);
var $1fa85ec6884a5e67$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $1fa85ec6884a5e67$var$isEqual(first, second) {
    if (first === second) return true;
    if ($1fa85ec6884a5e67$var$safeIsNaN(first) && $1fa85ec6884a5e67$var$safeIsNaN(second)) return true;
    return false;
}
function $1fa85ec6884a5e67$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$1fa85ec6884a5e67$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $1fa85ec6884a5e67$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $1fa85ec6884a5e67$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});

parcelRegister("1uvI9", function(module, exports) {
$parcel$export(module.exports, "createRequestPayload", () => $af2fb88ffc0e2f4a$export$714cf425c39c51a5);

var $2aEiL = parcelRequire("2aEiL");
const $af2fb88ffc0e2f4a$var$REQUEST_COMPRESSION_GATE = 'analytics-web-client-request-compression';
const $af2fb88ffc0e2f4a$var$gzip = async (body)=>{
    try {
        // Feature-detected below; the compat data lags browsers that support CompressionStream.
        // eslint-disable-next-line compat/compat
        const reader = new Blob([
            body
        ]).stream().pipeThrough(new CompressionStream('gzip')).getReader();
        const chunks = [];
        for(let next = await reader.read(); !next.done; next = await reader.read())chunks.push(next.value);
        return new Blob(chunks);
    } catch  {
        return undefined;
    }
};
const $af2fb88ffc0e2f4a$export$714cf425c39c51a5 = async (batch)=>{
    const body = JSON.stringify(batch);
    const compressedBody = (0, $2aEiL.fg)($af2fb88ffc0e2f4a$var$REQUEST_COMPRESSION_GATE) && typeof CompressionStream !== 'undefined' ? await $af2fb88ffc0e2f4a$var$gzip(body) : undefined;
    return {
        // Plain requests avoid preflights. Compressed requests also require CORS to allow Content-Encoding.
        headers: {
            'Content-Type': 'text/plain',
            ...compressedBody ? {
                'Content-Encoding': 'gzip'
            } : {}
        },
        body: compressedBody ?? body
    };
};

});


parcelRegister("387qv", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ec3877863d57ff1$export$2e2bcd8739ae039);

var $75pqB = parcelRequire("75pqB");

var $3VIC4 = parcelRequire("3VIC4");

var $fFAhf = parcelRequire("fFAhf");

var $i9AMt = parcelRequire("i9AMt");

var $akdUN = parcelRequire("akdUN");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $6ec3877863d57ff1$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $6ec3877863d57ff1$var$SAFE = 'SAFE';
const $6ec3877863d57ff1$var$UNSAFE = 'UNSAFE';
const $6ec3877863d57ff1$var$NOT_FOUND = 'NOT_FOUND';
const $6ec3877863d57ff1$var$COOKIE = 'COOKIE';
const $6ec3877863d57ff1$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $6ec3877863d57ff1$export$2e2bcd8739ae039 {
    store;
    cookie;
    userId;
    lastAnonymousIdCookieUpdate;
    constructor(disableCookiePersistence){
        this.store = new (0, $i9AMt.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $fFAhf.default)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $3VIC4.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $3VIC4.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $6ec3877863d57ff1$var$LOCAL_STORAGE ? this.store.getItem((0, $3VIC4.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $3VIC4.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $6ec3877863d57ff1$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $6ec3877863d57ff1$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch  {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $6ec3877863d57ff1$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($6ec3877863d57ff1$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $75pqB.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $6ec3877863d57ff1$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $6ec3877863d57ff1$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $6ec3877863d57ff1$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $6ec3877863d57ff1$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($6ec3877863d57ff1$var$COOKIE);
        switch(cookieValue.type){
            case $6ec3877863d57ff1$var$SAFE:
            case $6ec3877863d57ff1$var$UNSAFE:
                this.store.setItem((0, $3VIC4.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $6ec3877863d57ff1$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator) {
        const generator = typeof customAnonymousIdGenerator === 'function' ? customAnonymousIdGenerator : ()=>{
            return (0, $akdUN.default)();
        };
        const newAnonId = generator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}

});
parcelRegister("75pqB", function(module, exports) {
$parcel$export(module.exports, "default", () => $528cb9888068240e$export$2e2bcd8739ae039);

var $fwHtn = parcelRequire("fwHtn");

var $90QDS = parcelRequire("90QDS");

var $aGVpx = parcelRequire("aGVpx");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $528cb9888068240e$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $528cb9888068240e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $aGVpx.default)(2, arguments);
    var dateLeft = (0, $fwHtn.default)(dirtyDateLeft);
    var dateRight = (0, $fwHtn.default)(dirtyDateRight);
    var sign = $528cb9888068240e$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $90QDS.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($528cb9888068240e$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("fwHtn", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4db90f1fc297c62$export$2e2bcd8739ae039);

var $ebQXH = parcelRequire("ebQXH");

var $aGVpx = parcelRequire("aGVpx");
function $b4db90f1fc297c62$export$2e2bcd8739ae039(argument) {
    (0, $aGVpx.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $ebQXH.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("ebQXH", function(module, exports) {
$parcel$export(module.exports, "default", () => $a54b2ce35641e526$export$2e2bcd8739ae039);
function $a54b2ce35641e526$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $a54b2ce35641e526$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a54b2ce35641e526$export$2e2bcd8739ae039(o);
}

});

parcelRegister("aGVpx", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c8a5c373eceec49$export$2e2bcd8739ae039);
function $7c8a5c373eceec49$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("90QDS", function(module, exports) {
$parcel$export(module.exports, "default", () => $68fcf2ca31f71173$export$2e2bcd8739ae039);

var $7VYPy = parcelRequire("7VYPy");

var $3brbU = parcelRequire("3brbU");

var $aGVpx = parcelRequire("aGVpx");
var $68fcf2ca31f71173$var$MILLISECONDS_IN_DAY = 86400000;
function $68fcf2ca31f71173$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $aGVpx.default)(2, arguments);
    var startOfDayLeft = (0, $3brbU.default)(dirtyDateLeft);
    var startOfDayRight = (0, $3brbU.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $7VYPy.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $7VYPy.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $68fcf2ca31f71173$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("7VYPy", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c6d0af2b07a2d73$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $5c6d0af2b07a2d73$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("3brbU", function(module, exports) {
$parcel$export(module.exports, "default", () => $25177dc20b8655a0$export$2e2bcd8739ae039);

var $fwHtn = parcelRequire("fwHtn");

var $aGVpx = parcelRequire("aGVpx");
function $25177dc20b8655a0$export$2e2bcd8739ae039(dirtyDate) {
    (0, $aGVpx.default)(1, arguments);
    var date = (0, $fwHtn.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("3VIC4", function(module, exports) {
$parcel$export(module.exports, "AWCCookiesKeys", () => $a7be9a79b9b3fbaf$export$202d555a5dbfd90c);
$parcel$export(module.exports, "AllAnalyticsCookies", () => $a7be9a79b9b3fbaf$export$d4cb17942ea57c95);
var $a7be9a79b9b3fbaf$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $a7be9a79b9b3fbaf$var$CookieSchema {
    key;
    options;
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $a7be9a79b9b3fbaf$var$isSecure = ()=>{
    try {
        return globalThis && globalThis.location && globalThis.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $a7be9a79b9b3fbaf$export$d4cb17942ea57c95 = {
    ["AWC_TLD_TEST"]: new $a7be9a79b9b3fbaf$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $a7be9a79b9b3fbaf$var$isSecure(),
        path: '/'
    }),
    ["AWC_ANALYTICS_DEBUG"]: new $a7be9a79b9b3fbaf$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $a7be9a79b9b3fbaf$var$isSecure(),
        path: '/'
    }),
    ["AJS_ANONYMOUS_ID"]: new $a7be9a79b9b3fbaf$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $a7be9a79b9b3fbaf$var$isSecure(),
        path: '/'
    })
};

});

parcelRegister("fFAhf", function(module, exports) {
$parcel$export(module.exports, "default", () => $572e7ed0755f0cb9$export$2e2bcd8739ae039);

var $6yOvq = parcelRequire("6yOvq");

var $3VIC4 = parcelRequire("3VIC4");

var $d5TBb = parcelRequire("d5TBb");

var $44mCf = parcelRequire("44mCf");
class $572e7ed0755f0cb9$export$2e2bcd8739ae039 {
    cookieLike;
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $44mCf.canUseCookie)(disableCookiePersistence) ? (0, $6yOvq.default) : new (0, $d5TBb.default)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $3VIC4.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $3VIC4.AllAnalyticsCookies)[name].getKey(), value, {
            ...(0, $3VIC4.AllAnalyticsCookies)[name].getAttributes(),
            // Function is memoized so we only calculate this once per page load
            domain: (0, $44mCf.getTld)(),
            ...options
        });
    }
    get(name) {
        if (!(0, $3VIC4.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $3VIC4.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $3VIC4.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $3VIC4.AllAnalyticsCookies)[name].getKey(), {
            ...options
        });
    }
}

});
parcelRegister("6yOvq", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c6d187aa5a59fb0$export$2e2bcd8739ae039);
/*! js-cookie v3.0.8 | MIT */ function $4c6d187aa5a59fb0$var$assign(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source){
            if (key === '__proto__') continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $4c6d187aa5a59fb0$var$defaultConverter = {
    read: function(value) {
        if (value[0] === '"') value = value.slice(1, -1);
        return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function(value) {
        return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    }
};
function $4c6d187aa5a59fb0$var$init(converter, defaultAttributes) {
    function set(name, value, attributes) {
        if (typeof document === 'undefined') return;
        attributes = $4c6d187aa5a59fb0$var$assign({}, defaultAttributes, attributes);
        if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
        if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
        name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
        var stringifiedAttributes = '';
        for(var attributeName in attributes){
            if (!attributes[attributeName]) continue;
            stringifiedAttributes += '; ' + attributeName;
            if (attributes[attributeName] === true) continue;
            // Considers RFC 6265 section 5.2:
            // ...
            // 3.  If the remaining unparsed-attributes contains a %x3B (";")
            //     character:
            // Consume the characters of the unparsed-attributes up to,
            // not including, the first %x3B (";") character.
            // ...
            stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
        }
        return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
    }
    function get(name) {
        if (typeof document === 'undefined' || arguments.length && !name) return;
        // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all.
        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var jar = {};
        for(var i = 0; i < cookies.length; i++){
            var parts = cookies[i].split('=');
            var value = parts.slice(1).join('=');
            try {
                var found = decodeURIComponent(parts[0]);
                if (!(found in jar)) jar[found] = converter.read(value, found);
                if (name === found) break;
            } catch (_e) {
            // Do nothing...
            }
        }
        return name ? jar[name] : jar;
    }
    return Object.create({
        set: set,
        get: get,
        remove: function(name, attributes) {
            set(name, '', $4c6d187aa5a59fb0$var$assign({}, attributes, {
                expires: -1
            }));
        },
        withAttributes: function(attributes) {
            return $4c6d187aa5a59fb0$var$init(this.converter, $4c6d187aa5a59fb0$var$assign({}, this.attributes, attributes));
        },
        withConverter: function(converter) {
            return $4c6d187aa5a59fb0$var$init($4c6d187aa5a59fb0$var$assign({}, this.converter, converter), this.attributes);
        }
    }, {
        attributes: {
            value: Object.freeze(defaultAttributes)
        },
        converter: {
            value: Object.freeze(converter)
        }
    });
}
var $4c6d187aa5a59fb0$export$2e2bcd8739ae039 = $4c6d187aa5a59fb0$var$init($4c6d187aa5a59fb0$var$defaultConverter, {
    path: '/'
});

});

parcelRegister("d5TBb", function(module, exports) {
$parcel$export(module.exports, "default", () => $d241ec98c26dae1e$export$2e2bcd8739ae039);

var $i9AMt = parcelRequire("i9AMt");
class $d241ec98c26dae1e$export$2e2bcd8739ae039 {
    safeStorage;
    constructor(){
        this.safeStorage = new (0, $i9AMt.default)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}

});
parcelRegister("i9AMt", function(module, exports) {
$parcel$export(module.exports, "default", () => $6351ed4248e9951a$export$2e2bcd8739ae039);

var $bN4rZ = parcelRequire("bN4rZ");

var $adCuR = parcelRequire("adCuR");
class $6351ed4248e9951a$export$2e2bcd8739ae039 extends (0, $adCuR.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = globalThis.localStorage || (0, $bN4rZ.default);
        } catch (err) {
            storageToUse = (0, $bN4rZ.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("bN4rZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b55ecc9b2bea828e$export$2e2bcd8739ae039);

var $fjlbX = parcelRequire("fjlbX");
// eslint-disable-next-line import/no-anonymous-default-export
const $b55ecc9b2bea828e$var$inmemorystorage = new (0, $fjlbX.InMemoryStore)();
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b55ecc9b2bea828e$export$2e2bcd8739ae039 = $b55ecc9b2bea828e$var$inmemorystorage;

});
parcelRegister("fjlbX", function(module, exports) {
$parcel$export(module.exports, "InMemoryStore", () => $f474ef4d98c809dd$export$90e3e001bcac59c7);
class $f474ef4d98c809dd$export$90e3e001bcac59c7 {
    _data = {};
    length = 0;
    setItem = (key, value)=>{
        this._data[key] = value;
        this.length = Object.keys(this._data).length;
        return value;
    };
    getItem = (key)=>{
        if (key in this._data) return this._data[key];
        return null;
    };
    removeItem = (key)=>{
        if (key in this._data) delete this._data[key];
        this.length = Object.keys(this._data).length;
        return null;
    };
    clear = ()=>{
        this._data = {};
        this.length = 0;
    };
    key = (index)=>Object.keys(this._data)[index];
}

});


parcelRegister("adCuR", function(module, exports) {
$parcel$export(module.exports, "default", () => $344d15765865c9c9$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $6yEEN = parcelRequire("6yEEN");

var $bN4rZ = parcelRequire("bN4rZ");

var $6WlvL = parcelRequire("6WlvL");
const $344d15765865c9c9$export$41c06fdd37b7e9a5 = 'awc';
const $344d15765865c9c9$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
class $344d15765865c9c9$export$2e2bcd8739ae039 {
    _prefix;
    _store;
    options;
    constructor(storageToUse, options = {}){
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($344d15765865c9c9$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $6yEEN.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ((0, $6WlvL.isSupported)(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
    getStore = ()=>this._store;
    getItem = (key)=>this._store.getItem(this.createKey(key));
    removeItem = (key)=>this._store.removeItem(this.createKey(key));
    setItem = (key, value)=>{
        try {
            this._store.setItem(this.createKey(key), value);
        } catch (err) {
            // Theoretically should only be QuotaExceededError, but keeping 'err' generic
            // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
            this.swapToInMemory();
            this._store.setItem(this.createKey(key), value);
        }
    };
    swapToInMemory = ()=>{
        if (this._store === (0, $bN4rZ.default) || typeof globalThis === 'undefined') return;
        const keys = Object.keys(this._store || {});
        let inMemoryStorage;
        if ((0, $6WlvL.isSupported)(globalThis[$344d15765865c9c9$export$770aa8bc07b3de03])) inMemoryStorage = globalThis[$344d15765865c9c9$export$770aa8bc07b3de03];
        else {
            inMemoryStorage = (0, $bN4rZ.default);
            if (!globalThis[$344d15765865c9c9$export$770aa8bc07b3de03]) // If not already attached to globalThis then attach our instance of InMemoryStorage
            // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
            // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
            globalThis[$344d15765865c9c9$export$770aa8bc07b3de03] = (0, $bN4rZ.default);
        }
        keys.forEach((key)=>{
            if (key.indexOf(this.getPrefix()) === 0) {
                const value = this._store.getItem(key);
                if (value) inMemoryStorage.setItem(key, value);
            }
        });
        this._store = inMemoryStorage;
    };
    clear = ()=>this._store.clear();
    key = (index)=>this._store.key(index);
    getPrefix = ()=>this._prefix;
    createKey = (key)=>{
        if (this._prefix) return `${this.getPrefix()}.${key}`;
        return key;
    };
}

});
parcelRegister("6WlvL", function(module, exports) {
$parcel$export(module.exports, "isSupported", () => $1c27c81a57123648$export$48c17662a6902497);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $1c27c81a57123648$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}

});




parcelRegister("44mCf", function(module, exports) {
$parcel$export(module.exports, "canUseCookie", () => $4c096f9acd8c1d81$export$a9330601ee8f4d95);
$parcel$export(module.exports, "getTld", () => $4c096f9acd8c1d81$export$de6821eed3d5f32d);

var $6yOvq = parcelRequire("6yOvq");

var $2IvOD = parcelRequire("2IvOD");

var $3VIC4 = parcelRequire("3VIC4");
const $4c096f9acd8c1d81$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $4c096f9acd8c1d81$export$eb80e1beaa8dacf8 = (0, $3VIC4.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $4c096f9acd8c1d81$export$19164982d36535d8 = 'tld_test';
const $4c096f9acd8c1d81$export$de6821eed3d5f32d = (0, $2IvOD.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, $6yOvq.default).set($4c096f9acd8c1d81$export$eb80e1beaa8dacf8, $4c096f9acd8c1d81$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, $6yOvq.default).get($4c096f9acd8c1d81$export$eb80e1beaa8dacf8) === $4c096f9acd8c1d81$export$19164982d36535d8) {
            (0, $6yOvq.default).remove($4c096f9acd8c1d81$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});




parcelRegister("b4wuS", function(module, exports) {
$parcel$export(module.exports, "MetadataClient", () => $2dfe2130b57d2548$export$1ac223ae496131c9);

var $jKjZR = parcelRequire("jKjZR");

var $5JD19 = parcelRequire("5JD19");

var $c4drF = parcelRequire("c4drF");

var $begmT = parcelRequire("begmT");

var $7YeV5 = parcelRequire("7YeV5");

var $iIQlI = parcelRequire("iIQlI");

var $g34ub = parcelRequire("g34ub");

var $jQSOC = parcelRequire("jQSOC");

var $4t7l6 = parcelRequire("4t7l6");

var $6A6xV = parcelRequire("6A6xV");

var $wIHxY = parcelRequire("wIHxY");

var $hCUC3 = parcelRequire("hCUC3");
class $2dfe2130b57d2548$export$1ac223ae496131c9 {
    _userInfo;
    _tenantInfo;
    _url;
    _metadataHost;
    _product;
    _metadataInfo;
    _requestStatus;
    _lastFetchRequestCount;
    _options;
    _scheduler;
    _networkStatus;
    _lastErrorReason;
    _fetchAbortController;
    _hasBeenStopped;
    _isEnabled;
    _propertyChangeRefreshTimeout;
    static INITIAL_REFRESH_DELAY = 1;
    static Factory = (apiHostProtocol, apiHost, product)=>{
        return new $2dfe2130b57d2548$export$1ac223ae496131c9(apiHostProtocol, apiHost, product);
    };
    constructor(apiHostProtocol, apiHost, product){
        this._userInfo = {
            anonymousId: ''
        };
        this._tenantInfo = {};
        this._url = `${apiHostProtocol}://${apiHost}/metadata`;
        this._product = product;
        this._metadataInfo = null;
        this._requestStatus = 'PENDING';
        this._lastFetchRequestCount = 0;
        this._lastErrorReason = null;
        this._fetchAbortController = null;
        this._hasBeenStopped = false;
        this._isEnabled = false;
        this._propertyChangeRefreshTimeout = null;
        const isStargateProxy = (0, $jKjZR.isStargateProxyPath)({
            apiHost: apiHost
        });
        this._metadataHost = isStargateProxy ? 'PRODUCT_HOST' : apiHost;
        this._options = this.buildOptions({
            backoffFactor: 2,
            backoffJitterPercentage: 0.8,
            flushBeforeUnload: false,
            flushWaitMs: 500,
            maxAttempts: 10,
            minRetryDelay: (0, $jQSOC.DEFAULT_METADATA_MIN_RETRY_DELAY),
            maxRetryDelay: (0, $jQSOC.DEFAULT_METADATA_MAX_RETRY_DELAY)
        });
        this._scheduler = new (0, $begmT.default)({
            ...this._options,
            waitInterval: (0, $jQSOC.DEFAULT_METADATA_REFRESH_INTERVAL)
        }, this.scheduleCallback.bind(this));
        this._networkStatus = null;
    }
    /**
   * Starts the metadata client. This will start the scheduler and begin
   * fetching metadata.
   *
   * @param allowRestart - If false, the client will not be restarted if it has already been stopped
   *						 by a call to stop().
   */ start(allowRestart) {
        if (this._isEnabled || this._hasBeenStopped && !allowRestart) return;
        this._isEnabled = true;
        this.startNetworkStatusMonitor();
        setTimeout(()=>{
            this._scheduler.schedule({
                immediate: true
            });
        }, $2dfe2130b57d2548$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY);
    }
    stop() {
        if (!this._isEnabled) return;
        this._hasBeenStopped = true;
        this._isEnabled = false;
        this.stopNetworkStatusMonitor();
        this._scheduler.stop();
        this._fetchAbortController?.abort();
        this.resetPropertyChangeRefresh();
    }
    startNetworkStatusMonitor() {
        if (this._networkStatus) return;
        this._networkStatus = new (0, $5JD19.default)((status)=>{
            if (status === (0, $iIQlI.NetworkStatusEnum).OFFLINE) this._scheduler.stop();
            else if (this._isEnabled) this._scheduler.schedule({
                immediate: this._metadataInfo === null
            });
        });
    }
    stopNetworkStatusMonitor() {
        if (this._networkStatus) {
            this._networkStatus.removeListeners();
            this._networkStatus = null;
        }
    }
    async refreshMetadataAsync() {
        if ((0, $g34ub.TestSupport).areFetchCallsDisabled() || !this._isEnabled) return Promise.resolve();
        this._fetchAbortController?.abort();
        this._fetchAbortController = new AbortController();
        const fetchAbortSignal = this._fetchAbortController.signal;
        this._lastFetchRequestCount = this._scheduler.getFailureCount();
        await (0, $6A6xV.fetchMetadata)(this._url, {
            product: this._product,
            userInfo: this._userInfo,
            tenantInfo: this._tenantInfo
        }, (0, $jQSOC.DEFAULT_METADATA_REQUEST_TIMEOUT), fetchAbortSignal).then(async (response)=>{
            const metadata = await response.json();
            this._metadataInfo = (0, $wIHxY.MetadataResponse).fromJson(metadata);
            this._lastFetchRequestCount++;
            this._requestStatus = 'FETCHED';
            this._lastErrorReason = null;
        }).catch((error)=>{
            if (fetchAbortSignal.aborted) // This request was aborted, so we don't need to handle it.
            return;
            this._requestStatus = 'FAILED';
            if (error instanceof (0, $4t7l6.FetchError) && [
                429,
                503
            ].includes(error.statusCode)) this._lastErrorReason = 'ServerBusyError';
            else this._lastErrorReason = error instanceof Error && (0, $hCUC3.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
            throw error;
        });
    }
    getMetadataAsync() {
        return Promise.resolve(this._metadataInfo);
    }
    get status() {
        return this._requestStatus;
    }
    get lastErrorReason() {
        return this._lastErrorReason;
    }
    get lastFetchRequestCount() {
        return this._lastFetchRequestCount;
    }
    get userInfo() {
        return this._userInfo;
    }
    set userInfo(userInfo) {
        if (this._userInfo?.userId === userInfo?.userId && this._userInfo?.userIdType === userInfo?.userIdType) return;
        this._userInfo = userInfo;
        this.schedulePropertyChangeRefresh();
    }
    get tenantInfo() {
        return this._tenantInfo;
    }
    set tenantInfo(tenantInfo) {
        if (this._tenantInfo?.tenantId === tenantInfo?.tenantId && this._tenantInfo?.tenantIdType === tenantInfo?.tenantIdType) return;
        this._tenantInfo = tenantInfo;
        this.schedulePropertyChangeRefresh();
    }
    get metrics() {
        return {
            host: this._metadataHost,
            status: this.status,
            lastErrorReason: this.lastErrorReason,
            lastRefreshRequestCount: this.lastFetchRequestCount
        };
    }
    async scheduleCallback(done) {
        if (this._networkStatus?.getNetworkStatus() === (0, $iIQlI.NetworkStatusEnum).OFFLINE) {
            done((0, $7YeV5.DoneState).NOOP);
            return;
        }
        try {
            await this.refreshMetadataAsync();
            done((0, $7YeV5.DoneState).SUCCESS);
            this._scheduler.schedule();
        } catch  {
            done((0, $7YeV5.DoneState).ERROR);
        }
    }
    /**
   * Schedules a refresh of the metadata when the user or tenant info changes. There is
   * a short delay to allow for multiple changes to be batched together, such as when the
   * callers sets the user info and tenant info in quick succession.
   */ schedulePropertyChangeRefresh() {
        if (!this._isEnabled) return;
        this.resetPropertyChangeRefresh();
        this._propertyChangeRefreshTimeout = setTimeout(()=>{
            this.resetPropertyChangeRefresh();
            this._scheduler.schedule({
                immediate: true
            });
        }, (0, $jQSOC.DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL));
    }
    resetPropertyChangeRefresh() {
        if (this._propertyChangeRefreshTimeout) {
            clearTimeout(this._propertyChangeRefreshTimeout);
            this._propertyChangeRefreshTimeout = null;
        }
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || (0, $c4drF.DEFAULT_POLLING_OPTIONS).backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : (0, $c4drF.DEFAULT_POLLING_OPTIONS).backoffJitterPercentage,
            maxRetryDelay: options?.maxRetryDelay || (0, $c4drF.DEFAULT_POLLING_OPTIONS).maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || (0, $c4drF.DEFAULT_POLLING_OPTIONS).minRetryDelay
        };
    }
}

});
parcelRegister("jKjZR", function(module, exports) {
$parcel$export(module.exports, "isStargateProxyPath", () => $973ffd7dc1662a19$export$83a9dd8d74be72c);

var $4Pm5b = parcelRequire("4Pm5b");
function $973ffd7dc1662a19$export$83a9dd8d74be72c({ apiHost: apiHost }) {
    return apiHost === (0, $4Pm5b.stargateProxyUrl)();
}

});
parcelRegister("4Pm5b", function(module, exports) {
$parcel$export(module.exports, "stargateProxyUrl", () => $8c95fc60ff472bec$export$78e02cfb66671ad0);
$parcel$export(module.exports, "selectHost", () => $8c95fc60ff472bec$export$18c0b81944902eae);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $6yEEN = parcelRequire("6yEEN");

const $8c95fc60ff472bec$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $8c95fc60ff472bec$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $8c95fc60ff472bec$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $8c95fc60ff472bec$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $8c95fc60ff472bec$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $8c95fc60ff472bec$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $8c95fc60ff472bec$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $8c95fc60ff472bec$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $8c95fc60ff472bec$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
/**
* Returns the full Stargate proxy URL (host + proxy path) for the current host.
*
* This is the default endpoint for Commercial, FedRAMP Moderate (with Stargate),
* and Oasis IC environments. Using the first-party proxy works around browser
* restrictions with third-party cookies.
*
* In non-browser environments (e.g. SSR) where `window` is not defined, the host
* portion is omitted and the function returns only `STARGATE_PROXY_PATH`
* (i.e. `/gateway/api/gasv3/api/v1`).
*/ function $8c95fc60ff472bec$export$78e02cfb66671ad0() {
    return (typeof window !== 'undefined' ? window.location.host : '') + $8c95fc60ff472bec$export$5df9262e102d0c32;
}
const $8c95fc60ff472bec$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $6yEEN.envType).LOCAL || env === (0, $6yEEN.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $6yEEN.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $6yEEN.envType).PROD ? $8c95fc60ff472bec$var$FEDRAMP_PROD_HOST : $8c95fc60ff472bec$var$FEDRAMP_STAGING_HOST;
    if (useLegacyUrl) return env === (0, $6yEEN.envType).PROD ? $8c95fc60ff472bec$var$STARGATE_FEDRAMP_PROD_HOST : $8c95fc60ff472bec$var$STARGATE_FEDRAMP_STAGING_HOST;
    return $8c95fc60ff472bec$export$78e02cfb66671ad0();
};
const $8c95fc60ff472bec$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $6yEEN.envType).PROD ? $8c95fc60ff472bec$var$PROD_HOST : $8c95fc60ff472bec$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $6yEEN.envType).PROD ? $8c95fc60ff472bec$var$STARGATE_PROD_HOST : $8c95fc60ff472bec$var$STARGATE_STAGING_HOST;
    return $8c95fc60ff472bec$export$78e02cfb66671ad0();
};
function $8c95fc60ff472bec$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, ic: ic, envOverride: envOverride, apiHost: apiHost }) {
    // If the caller has explicitly set an apiHost, use it as the endpoint.
    if (apiHost) return apiHost;
    // When running inside an IC, events are routed through the Stargate proxy.
    if (ic) {
        if (useLegacyUrl) throw Error('IC is set but useLegacyUrl is true. Legacy URLs are not supported in IC environments.');
        return $8c95fc60ff472bec$export$78e02cfb66671ad0();
    }
    if (perimeter === (0, $6yEEN.perimeterType).FEDRAMP_MODERATE) return $8c95fc60ff472bec$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $8c95fc60ff472bec$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}

});


parcelRegister("g34ub", function(module, exports) {
$parcel$export(module.exports, "TestSupport", () => $b19be266a2c13a8a$export$44b578549c42d779);
class $b19be266a2c13a8a$export$44b578549c42d779 {
    static DISABLE_METADATA_CALLS_PROPERTY = '__awc_disable_metadata_calls__';
    static DISABLE_EVENT_CALLS_PROPERTY = '__awc_disable_event_calls__';
    static DISABLE_FETCH_CALLS_PROPERTY = '__awc_disable_fetch_calls__';
    static SYNTHETIC_FLAG_OVERRIDE_PROPERTY = '__awc_synthetic_flag_override__';
    static isGeminiVREnvironment() {
        try {
            for(const k in globalThis){
                if (k.startsWith('__gemini_') && k.endsWith('__')) return true;
            }
        } catch (e) {
        // ignore
        }
        return false;
    }
    static areMetadataCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($b19be266a2c13a8a$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY);
    }
    static areEventCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($b19be266a2c13a8a$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY);
    }
    static areFetchCallsDisabled() {
        return this.getGlobalBooleanProperty($b19be266a2c13a8a$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY);
    }
    static getSyntheticFlagOverride() {
        return this.getGlobalTriStateProperty($b19be266a2c13a8a$export$44b578549c42d779.SYNTHETIC_FLAG_OVERRIDE_PROPERTY);
    }
    static getGlobalBooleanProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) return globalThis[propertyName] === true;
        return false;
    }
    static getGlobalTriStateProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) {
            const value = globalThis[propertyName];
            if (typeof value === 'boolean') return value;
        }
        return undefined;
    }
}

});

parcelRegister("6A6xV", function(module, exports) {
$parcel$export(module.exports, "fetchMetadata", () => $9bb63a70da714223$export$55b0d0261469055);

var $2IvOD = parcelRequire("2IvOD");

var $4t7l6 = parcelRequire("4t7l6");
const $9bb63a70da714223$export$55b0d0261469055 = async (url, params, timeout, signal)=>{
    const requestAbortController = $9bb63a70da714223$var$createRequestAbortController(timeout, signal);
    const corsOptions = $9bb63a70da714223$var$getCorsForUrl(url);
    const metadataUrl = url + '?' + new URLSearchParams({
        product: `${params.product}`,
        userId: `${params.userInfo?.userId || ''}`,
        userIdType: `${params.userInfo?.userIdType || ''}`,
        tenantId: `${params.tenantInfo?.tenantId || ''}`,
        tenantIdType: `${params.tenantInfo?.tenantIdType || ''}`
    }).toString();
    const response = await fetch(metadataUrl, {
        method: 'GET',
        signal: requestAbortController.signal,
        ...corsOptions
    });
    // Response must be a 200 (we expect a JSON response, so 204 is not valid for instance)
    if (response.status !== 200) throw new (0, $4t7l6.FetchError)(`Metadata: HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $9bb63a70da714223$var$createRequestAbortController = (timeout, signal)=>{
    const abortController = new AbortController();
    setTimeout(()=>{
        abortController.abort();
    }, timeout || 30000);
    signal?.addEventListener('abort', ()=>{
        abortController.abort();
    });
    return abortController;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $9bb63a70da714223$var$getCorsForUrl = (0, $2IvOD.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});

parcelRegister("wIHxY", function(module, exports) {
$parcel$export(module.exports, "MetadataResponse", () => $ba6031df816672e9$export$4b1a5e5486cc0d80);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
class $ba6031df816672e9$export$4b1a5e5486cc0d80 {
    constructor(props, url){
        this.props = props;
        this.url = url;
    }
    props;
    url;
    static fromJson(json) {
        let isString = (value)=>typeof value === 'string' || value instanceof String;
        const url = isString(json?.url) ? json.url.trim() : '';
        return new $ba6031df816672e9$export$4b1a5e5486cc0d80(json?.props || null, url.startsWith('http') ? url : null);
    }
}

});


parcelRegister("4YfNf", function(module, exports) {
$parcel$export(module.exports, "isFirstParty", () => $9bf1c33c93ebfa36$export$f56713ced121eb91);

var $6yEEN = parcelRequire("6yEEN");
const $9bf1c33c93ebfa36$export$f56713ced121eb91 = (input)=>{
    return input.embeddedType === (0, $6yEEN.productEmbedType).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};

});

parcelRegister("fsyj7", function(module, exports) {
$parcel$export(module.exports, "isThirdParty", () => $96fefcf3a49fa805$export$ab34f90cc32c8960);

var $6yEEN = parcelRequire("6yEEN");
const $96fefcf3a49fa805$export$ab34f90cc32c8960 = (input)=>{
    return input.embeddedType === (0, $6yEEN.productEmbedType).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};

});

parcelRegister("7YjGB", function(module, exports) {
$parcel$export(module.exports, "LoggingResponseCallback", () => $4fbb9b73847da03f$export$48361b6ed38f1b0);
class $4fbb9b73847da03f$export$48361b6ed38f1b0 {
    static getCallback(logger) {
        logger = logger || console;
        return (response)=>{
            $4fbb9b73847da03f$export$48361b6ed38f1b0.callback(response, logger);
        };
    }
    static callback(response, logger) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) response.getEventResponseList().forEach((eventResponse)=>{
            logger.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
        });
        else if (statusCode === 400 || statusCode === 404) {
            logger.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                logger.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            logger.log('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                logger.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}

});

parcelRegister("gxsPs", function(module, exports) {
$parcel$export(module.exports, "objectValues", () => $434bc43c89d2a86a$export$ad1854f4a08c15f8);
function $434bc43c89d2a86a$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}

});

parcelRegister("ezsdd", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8741e5cf8146677$export$2e2bcd8739ae039);

var $6yEEN = parcelRequire("6yEEN");

var $aNsr9 = parcelRequire("aNsr9");
class $b8741e5cf8146677$export$2e2bcd8739ae039 {
    _originStore;
    pendingCleanup = null;
    static messageEvent = 'origin landed';
    constructor(){
        this._originStore = {};
    }
    handleOriginParameters = (originParamHandlerMapping, historyReplaceFn)=>{
        // Collect all the parameter labels to be handled
        const originParamLabelList = Object.keys(originParamHandlerMapping);
        if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
        // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
        const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $6yEEN.originTracingType)).indexOf(x) < 0);
        if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
        const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
        // Capture params WITHOUT removing from URL (explicit no-op required because
        // urlParamExtractor defaults to calling history.replaceState if omitted)
        const paramExtractorReplace = ()=>{};
        const capturedURLParams = (0, $aNsr9.default)(isCaptureParam, paramExtractorReplace);
        // Apply provided handler function to extract origin trace ID from each URL parameter
        const applyHandlerFunction = (key)=>{
            const x = originParamHandlerMapping[key](capturedURLParams[key]);
            return {
                [key]: x
            };
        };
        const capturedOriginTraces = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
        if (Object.keys(capturedOriginTraces).length > 0) this.pendingCleanup = ()=>{
            (0, $aNsr9.default)(isCaptureParam, historyReplaceFn);
        };
        return capturedOriginTraces;
    };
    /** Executes and clears any pending origin param cleanup. No-op if nothing is pending. */ _cleanupOriginParams() {
        if (this.pendingCleanup) {
            const cleanup = this.pendingCleanup;
            this.pendingCleanup = null;
            cleanup();
        }
    }
    /**
   * Designed to be invoked after a successful flush with the batch of flushed events.
   */ cleanupOriginParameters(events) {
        try {
            if (this.pendingCleanup) {
                const hasOriginLanded = events.some((item)=>'event' in item.msg && item.msg.event === $b8741e5cf8146677$export$2e2bcd8739ae039.messageEvent);
                if (hasOriginLanded) this._cleanupOriginParams();
            }
        } catch  {
        // Silently ignore cleanup errors to avoid disrupting the flush cycle
        }
    }
}

});

parcelRegister("9D95u", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8b369d7f47b502c$export$2e2bcd8739ae039);

var $f4X2T = parcelRequire("f4X2T");

var $i9AMt = parcelRequire("i9AMt");
// WARNING: The value of SESSION_ID_STORAGE_KEY is relied upon by other Platform packages
// (eg. search-page, product-search-dialog). If you need to change this key, you MUST
// notify the dependant Platform teams and update all dependent packages accordingly.
const $b8b369d7f47b502c$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $b8b369d7f47b502c$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $b8b369d7f47b502c$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $b8b369d7f47b502c$export$285f6bddd927a06d = 1800000;
const $b8b369d7f47b502c$export$a92e915d70316eb2 = 5000;
const $b8b369d7f47b502c$export$de43760b2dc10c19 = 0.9;
class $b8b369d7f47b502c$export$2e2bcd8739ae039 {
    _safeLocalStorage;
    _sessionExpiryTime;
    _sessionExpiryDebounce;
    _sessionExpiryDebounceThresholdPercentage;
    _sessionExpiryDebounceTimer;
    _onNewSessionStarted;
    constructor(options = {}){
        this._sessionExpiryTime = options.sessionExpiryTime || $b8b369d7f47b502c$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $b8b369d7f47b502c$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $b8b369d7f47b502c$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : (0, $f4X2T.NOOP);
        this._safeLocalStorage = new (0, $i9AMt.default)();
    }
    /*
   * This function retrieves the current session ID and expiry from SessionStorage
   * It runs the necessary checks to ensure the session ID is valid and within expiry
   *
   * It returns the values along with a `validSession` boolean
   */ _getCurrentSessionParams() {
        const sessionId = this._safeLocalStorage.getItem($b8b369d7f47b502c$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($b8b369d7f47b502c$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        // REGEX test: Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (sessionId && !Number.isNaN(sessionExpiry) && $b8b369d7f47b502c$var$ONLY_NUMBERS_REGEX.test(sessionId) && sessionExpiry > Date.now()) return {
            isValidSession: true,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
        return {
            isValidSession: false,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
    }
    /*
   * Session ID SHOULD always be a timestamp, however due to new Browser Storage Controls key classifications, it is
   * technically possible that writing Session ID to local storage is intercepted by BSC, in which case we can potentially
   * read a null value from storage, in which case we will return empty String
   */ getCurrentSessionId() {
        const { isValidSession: isValidSession, sessionExpiry: sessionExpiry, sessionId: sessionId } = this._getCurrentSessionParams();
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        // If we have an existing valid session we can return the sessionId straight away
        if (isValidSession) return sessionId;
        else return this._generateNewSessionId();
    }
    _generateNewSessionId = ()=>{
        const newSessionId = Date.now().toString();
        this._safeLocalStorage.setItem($b8b369d7f47b502c$var$SESSION_ID_STORAGE_KEY, newSessionId);
        // If session is not valid at this point, something has gone wrong with Local Storage access
        // Calling the callback may result in possible recursion errors (see HOT-304742). Feature
        // gating roll-out of this early exit condition
        const { isValidSession: isValidSession } = this._getCurrentSessionParams();
        if (!isValidSession) return '';
        // COMMENTS-123 - When a new session starts, call the callback if it is given
        this._onNewSessionStarted && this._onNewSessionStarted();
        return newSessionId;
    };
    _updateSessionExpiry = ()=>{
        const expiry = Date.now() + this._sessionExpiryTime;
        this._safeLocalStorage.setItem($b8b369d7f47b502c$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
        return expiry;
    };
    _debouncedUpdateSessionExpiry = (currentExpiry)=>{
        const { _updateSessionExpiry: _updateSessionExpiry } = this;
        // If the current expiry is out of date by more than 10% of the expiry, update immediately
        if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) _updateSessionExpiry();
        else {
            if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
            // @ts-ignore Something wrong with our types... this is legit
            this._sessionExpiryDebounceTimer = setTimeout(()=>{
                _updateSessionExpiry();
            }, this._sessionExpiryDebounce);
        }
    };
}

});
parcelRegister("f4X2T", function(module, exports) {
$parcel$export(module.exports, "NOOP", () => $ba4ec6e887e122e4$export$5702a91a6f42969f);
// 90% of expiry
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $ba4ec6e887e122e4$export$5702a91a6f42969f = ()=>{};

});


parcelRegister("8kCZu", function(module, exports) {
$parcel$export(module.exports, "default", () => $cffffb4be491cbfd$export$2e2bcd8739ae039);

var $bN4rZ = parcelRequire("bN4rZ");

var $adCuR = parcelRequire("adCuR");
class $cffffb4be491cbfd$export$2e2bcd8739ae039 extends (0, $adCuR.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = globalThis.sessionStorage || (0, $bN4rZ.default);
        } catch (err) {
            storageToUse = (0, $bN4rZ.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("79qz9", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d61f9207a561211$export$2e2bcd8739ae039);

var $8kCZu = parcelRequire("8kCZu");

var $akdUN = parcelRequire("akdUN");
const $5d61f9207a561211$var$STORAGE_KEY = 'tab.id';
class $5d61f9207a561211$export$2e2bcd8739ae039 {
    _safeSessionStorage;
    constructor(){
        this._safeSessionStorage = new (0, $8kCZu.default)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($5d61f9207a561211$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
    _generateNewTabId = ()=>{
        const newTabId = (0, $akdUN.default)();
        this._safeSessionStorage.setItem($5d61f9207a561211$var$STORAGE_KEY, newTabId);
        return newTabId;
    };
}

});

parcelRegister("fMH0v", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0d8dd21a2f776bc$export$2e2bcd8739ae039);

var $9FFsN = parcelRequire("9FFsN");

var $6yEEN = parcelRequire("6yEEN");

var $hlFNB = parcelRequire("hlFNB");

var $8kCZu = parcelRequire("8kCZu");

var $aNsr9 = parcelRequire("aNsr9");

var $akdUN = parcelRequire("akdUN");
const $e0d8dd21a2f776bc$var$STORAGE_KEY = 'taskSessions';
const $e0d8dd21a2f776bc$var$INIT_KEY = 'taskSessionsInit';
const $e0d8dd21a2f776bc$var$AWC_PARAM_PREFIX = 'awc.';
const $e0d8dd21a2f776bc$var$TASK_SESSION_RELOAD_TIME = 3000;
class $e0d8dd21a2f776bc$export$2e2bcd8739ae039 {
    _safeSessionStorage;
    constructor(){
        const currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $8kCZu.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($e0d8dd21a2f776bc$var$INIT_KEY, currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch  {}
    }
    _taskSessionsNotRecentlyInitialised = (currentTimestamp)=>this._safeSessionStorage.getItem($e0d8dd21a2f776bc$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($e0d8dd21a2f776bc$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($e0d8dd21a2f776bc$var$INIT_KEY) || '0', 10) < currentTimestamp - $e0d8dd21a2f776bc$var$TASK_SESSION_RELOAD_TIME;
    _removeTaskSessionPrefix = (_, taskSessionName)=>taskSessionName.split($e0d8dd21a2f776bc$var$AWC_PARAM_PREFIX)[1];
    _isTaskSessionQueryParam = (_, taskSessionName)=>taskSessionName.startsWith($e0d8dd21a2f776bc$var$AWC_PARAM_PREFIX);
    getAllTaskSessions = ()=>{
        try {
            return JSON.parse(this._safeSessionStorage.getItem($e0d8dd21a2f776bc$var$STORAGE_KEY) || '');
        } catch  {
            return {};
        }
    };
    _writeToSessionStorage = (taskSessions)=>{
        try {
            this._safeSessionStorage.setItem($e0d8dd21a2f776bc$var$STORAGE_KEY, JSON.stringify(taskSessions));
        // eslint-disable-next-line no-empty
        } catch  {}
    };
    _appendTaskSessions = (newTaskSessions)=>{
        const currentState = this.getAllTaskSessions();
        const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
        this._writeToSessionStorage(newState);
    };
    _safelyRemoveKey = (currentState, taskSessionName)=>{
        if (currentState === null) return {};
        delete currentState[taskSessionName];
        return currentState;
    };
    createTaskSession = (taskSessionName)=>{
        const taskSessionId = (0, $akdUN.default)();
        const newTaskSessions = {};
        newTaskSessions[taskSessionName] = taskSessionId;
        this._appendTaskSessions(newTaskSessions);
        return taskSessionId;
    };
    createTaskSessionWithProvidedId = (taskSessionName, taskSessionId)=>{
        if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
        const newTaskSessions = {};
        newTaskSessions[taskSessionName] = taskSessionId;
        this._appendTaskSessions(newTaskSessions);
    };
    completeTaskSession = (taskSessionName)=>{
        const currentState = this.getAllTaskSessions();
        const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
        this._writeToSessionStorage(updatedState);
    };
    formatTaskSessionQueryString = ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
        const { url: url, query: query } = (0, $9FFsN.parseUrl)(uri);
        const currentState = this.getAllTaskSessions();
        // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
        const filteredTaskSessions = includedTaskSessions ? (0, $hlFNB.pick)(currentState, includedTaskSessions) : (0, $hlFNB.omit)(currentState, Object.values((0, $6yEEN.originTracingType)));
        if (Object.keys(filteredTaskSessions).length === 0) return uri;
        const queryWithTaskSessions = {
            ...(0, $hlFNB.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$e0d8dd21a2f776bc$var$AWC_PARAM_PREFIX + taskSessionName),
            ...query
        };
        return `${url}?${(0, $9FFsN.stringify)(queryWithTaskSessions)}`;
    };
    stripQueryParameters = ()=>{
        const extractedTaskSessions = (0, $hlFNB.mapKeys)((0, $aNsr9.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
        this._appendTaskSessions(extractedTaskSessions);
    };
}

});

parcelRegister("lches", function(module, exports) {
$parcel$export(module.exports, "default", () => $2eccb035b0c97033$export$2e2bcd8739ae039);

var $6yOvq = parcelRequire("6yOvq");

var $3VIC4 = parcelRequire("3VIC4");

var $g34ub = parcelRequire("g34ub");
const $2eccb035b0c97033$var$MAX_CACHE_SIZE = 100;
const $2eccb035b0c97033$var$COOKIE_NAME = (0, $3VIC4.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $2eccb035b0c97033$var$DEBUG_TAG = 'synthetic';
class $2eccb035b0c97033$var$TestingCache {
    _isDebugCookieEnabled;
    _syntheticFlagOverride;
    _enableTestingCache;
    constructor(syntheticFlagOverride, enableTestingCache){
        this._syntheticFlagOverride = typeof syntheticFlagOverride === 'boolean' ? syntheticFlagOverride : undefined;
        this._enableTestingCache = typeof enableTestingCache === 'boolean' ? enableTestingCache : undefined;
        this._isDebugCookieEnabled = $2eccb035b0c97033$var$TestingCache.getDebugCookie();
        this.bind();
    }
    saveEvent(event) {
        try {
            if (!event) return;
            this.bind();
            this.addSyntheticTag(event);
            this.cache(event);
        } catch  {
        // Ignore errors from testing cache.
        }
    }
    bind() {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || window.testAnalytics) return;
        window.testAnalytics = {
            eventCache: [],
            events: ()=>window.testAnalytics.eventCache,
            clear: ()=>{
                window.testAnalytics.eventCache = [];
                try {
                    localStorage.removeItem('awc.ui.viewed.last.sent');
                    localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                    localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                    localStorage.removeItem('awc-local.ui.viewed.last.sent');
                } catch  {
                // Ignore errors from localStorage.
                }
            }
        };
    }
    cache(event) {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || !window.testAnalytics) return;
        if (window.testAnalytics.eventCache.length >= $2eccb035b0c97033$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
        window.testAnalytics.eventCache.push(event);
    }
    addSyntheticTag(event) {
        if (!this.shouldSetSyntheticFlag()) return;
        if (event.tags instanceof Array) {
            if (!event.tags.includes($2eccb035b0c97033$var$DEBUG_TAG)) event.tags.push($2eccb035b0c97033$var$DEBUG_TAG);
        } else event.tags = [
            $2eccb035b0c97033$var$DEBUG_TAG
        ];
    }
    shouldCacheEvent() {
        return this._enableTestingCache ? this._enableTestingCache : this._isDebugCookieEnabled;
    }
    shouldSetSyntheticFlag() {
        if (this._syntheticFlagOverride !== undefined) return this._syntheticFlagOverride;
        const globalSyntheticOverride = (0, $g34ub.TestSupport).getSyntheticFlagOverride();
        if (globalSyntheticOverride !== undefined) return globalSyntheticOverride;
        return this.shouldCacheEvent();
    }
    static getDebugCookie() {
        try {
            return JSON.parse((0, $6yOvq.default).get($2eccb035b0c97033$var$COOKIE_NAME) || 'false') === true;
        } catch  {
            (0, $6yOvq.default).remove($2eccb035b0c97033$var$COOKIE_NAME);
        }
        return false;
    }
}
var $2eccb035b0c97033$export$2e2bcd8739ae039 = $2eccb035b0c97033$var$TestingCache;

});

parcelRegister("lqefr", function(module, exports) {
$parcel$export(module.exports, "default", () => $097420b529b8174e$export$2e2bcd8739ae039);

var $6yEEN = parcelRequire("6yEEN");

var $1Zypc = parcelRequire("1Zypc");

var $i9AMt = parcelRequire("i9AMt");
const $097420b529b8174e$var$DEFAULT_DELAY = 2000; // 2 seconds
const $097420b529b8174e$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $097420b529b8174e$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
const $097420b529b8174e$var$DEFAULT_MALFORMED_UIVIEWED_EVENT = 'malformed.uiviewed.last.sent';
var $097420b529b8174e$var$SendEventDecision = /*#__PURE__*/ function(SendEventDecision) {
    SendEventDecision[SendEventDecision["FocusLost"] = 0] = "FocusLost";
    SendEventDecision[SendEventDecision["UserOrTenantIncomplete"] = 1] = "UserOrTenantIncomplete";
    SendEventDecision[SendEventDecision["MalformedUiViewedRateLimited"] = 2] = "MalformedUiViewedRateLimited";
    SendEventDecision[SendEventDecision["EligibleToSend"] = 3] = "EligibleToSend";
    SendEventDecision[SendEventDecision["UiViewedRateLimited"] = 4] = "UiViewedRateLimited";
    return SendEventDecision;
}($097420b529b8174e$var$SendEventDecision || {});
class $097420b529b8174e$export$2e2bcd8739ae039 {
    _blurListener;
    _delay;
    _focusListener;
    _getContext;
    _intervalId;
    _onEvent;
    _product;
    _productInfo;
    _safeLocalStorage;
    _storageKey;
    _malformedEventStorageKey;
    _throttle;
    constructor(productInfo, getContext, onEvent, settings = {}){
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $097420b529b8174e$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $097420b529b8174e$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $097420b529b8174e$var$DEFAULT_STORAGE_KEY;
        this._malformedEventStorageKey = settings.malformedStorageKey || $097420b529b8174e$var$DEFAULT_MALFORMED_UIVIEWED_EVENT;
        this._safeLocalStorage = new (0, $i9AMt.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
    start = ()=>{
        this._startInterval();
        this._bindEventListeners();
    };
    stop = ()=>{
        this._stopInterval();
        this._unbindEventListeners();
    };
    resetTimers = ()=>{
        if (this._intervalId) {
            this.stop();
            this.start();
        }
    };
    signalUserActive = ()=>{
        this._sendUserActiveEvents();
    };
    _bindEventListeners = ()=>{
        if (typeof window !== 'undefined') {
            window.addEventListener('focus', this._focusListener);
            window.addEventListener('blur', this._blurListener);
        }
    };
    _unbindEventListeners = ()=>{
        if (typeof window !== 'undefined') {
            window.removeEventListener('focus', this._focusListener);
            window.removeEventListener('blur', this._blurListener);
        }
    };
    _startInterval = ()=>{
        clearInterval(this._intervalId);
        this._intervalId = setInterval(this._handleDwellTimerTriggered, this._delay);
    };
    _stopInterval = ()=>{
        if (this._intervalId) {
            clearInterval(this._intervalId);
            this._intervalId = null;
        }
    };
    _getProductKey = (product, subproduct)=>{
        let productKey = product;
        if (subproduct) productKey += `-${subproduct}`;
        return productKey;
    };
    _getLastSentTimestamp = (productKey, tenantId, userId)=>{
        const json = this._parseLocalStorageData(this._storageKey) || {};
        const u = json[userId] || {};
        const t = u[tenantId] || {};
        const p = t[productKey] || null;
        return p;
    };
    _parseLocalStorageData = (key)=>{
        const data = this._safeLocalStorage.getItem(key);
        try {
            return JSON.parse(data || '');
        } catch  {
            this._safeLocalStorage.removeItem(key);
            return null;
        }
    };
    _getMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
        const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
        const finalUserId = userId || 'NOT_SET';
        const finalTenantId = tenantId || 'NOT_SET';
        const u = json[finalUserId] || {};
        const t = u[finalTenantId] || {};
        const p = t[productKey] || null;
        return p;
    };
    _setLastSentTimestamp = (productKey, tenantId, userId)=>{
        const json = this._parseLocalStorageData(this._storageKey) || {};
        const u = json[userId] || {};
        const t = u[tenantId] || {};
        t[productKey] = Date.now();
        u[tenantId] = t;
        json[userId] = u;
        this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
    };
    _setMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
        const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
        const finalUserId = userId || 'NOT_SET';
        const finalTenantId = tenantId || 'NOT_SET';
        const u = json[finalUserId] || {};
        const t = u[finalTenantId] || {};
        t[productKey] = Date.now();
        u[finalTenantId] = t;
        json[finalUserId] = u;
        this._safeLocalStorage.setItem(this._malformedEventStorageKey, JSON.stringify(json));
    };
    _handleDwellTimerTriggered = ()=>{
        const document = (0, $1Zypc.getDocument)();
        if (document && !document.hasFocus()) return;
        this._sendUserActiveEvents();
    };
    _sendUserActiveEvents = ()=>{
        const { embeddedProduct: embeddedProduct, ...context } = this._getContext();
        this._sendEvent(this._product, context, false);
        if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
    };
    _sendEvent = (product, context, isEmbeddedProduct)=>{
        const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
        const productKey = this._getProductKey(product, subproduct);
        const sendEventDecision = this._shouldSendEvent(productKey, tenantIdType, tenantId, userId);
        switch(sendEventDecision){
            case 3:
                this._setLastSentTimestamp(productKey, tenantId, userId);
                this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'ui', 'viewed'));
                break;
            case 1:
                this._setMalformedLastSentTimestamp(productKey, tenantId, userId);
                this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'malformed', 'uiviewed'));
                break;
            default:
                break;
        }
    };
    _shouldSendEvent = (productKey, tenantIdType, tenantId, userId)=>{
        // TENANT OR USER ID NOT SET
        if (tenantIdType !== (0, $6yEEN.tenantType).NONE && !tenantId || !userId) {
            const sinceLastSent = Date.now() - this._getMalformedLastSentTimestamp(productKey, tenantId, userId);
            if (sinceLastSent === null || sinceLastSent > this._throttle) return 1;
            return 2;
        }
        const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
        if (sinceLastSent === null || sinceLastSent > this._throttle) return 3;
        return 4;
    };
    _createEvent = (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes, actionSubject, action)=>{
        const event = {
            product: product,
            source: 'ui',
            action: action,
            actionSubject: actionSubject,
            attributes: extraAttributes
        };
        if (isEmbeddedProduct) {
            // Clear the subproduct and version as they don't relate to the embedded product
            event.subproduct = null;
            event.version = null;
            event.attributes = {
                ...event.attributes,
                embeddedInEnv: this._productInfo.env,
                embeddedInProduct: this._productInfo.product,
                embeddedInSubproduct: subproduct,
                embeddedInVersion: this._productInfo.version,
                embeddedInOrigin: this._productInfo.origin,
                embeddedInPlatform: this._productInfo.platform
            };
        }
        if (lastScreenEvent) event.attributes = {
            ...event.attributes,
            lastScreenEvent: {
                name: lastScreenEvent.name,
                attributes: lastScreenEvent.attributes
            }
        };
        return event;
    };
}

});
parcelRegister("1Zypc", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $5a446e1345c26f8c$export$f65ca476c09acec0);
const $5a446e1345c26f8c$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("grc8S", function(module, exports) {
$parcel$export(module.exports, "validateIdentifyEvent", () => $7887eeb2a106f514$export$c16a4e16aa4026c0);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $6yEEN = parcelRequire("6yEEN");

var $7ruzK = parcelRequire("7ruzK");

var $gxsPs = parcelRequire("gxsPs");
function $7887eeb2a106f514$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $7ruzK.isType)((0, $6yEEN.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $gxsPs.objectValues)((0, $6yEEN.userType))}]`);
}

});

parcelRegister("l0B9l", function(module, exports) {
$parcel$export(module.exports, "validateOperationalEvent", () => $b06f39794e9500a4$export$1e561554275607ef);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $9l1HQ = parcelRequire("9l1HQ");
function $b06f39794e9500a4$export$1e561554275607ef(event) {
    (0, $9l1HQ.validateActionEvent)(event);
}

});

parcelRegister("j8q2U", function(module, exports) {
$parcel$export(module.exports, "validatePlatform", () => $9094e15a5a2ac071$export$801b46c35394d316);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $6yEEN = parcelRequire("6yEEN");

var $7ruzK = parcelRequire("7ruzK");

var $gxsPs = parcelRequire("gxsPs");
function $9094e15a5a2ac071$export$801b46c35394d316(productInfo) {
    if (!(0, $7ruzK.isType)((0, $6yEEN.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $gxsPs.objectValues)((0, $6yEEN.platformType))}]`);
    if (productInfo.origin === (0, $6yEEN.originType).DESKTOP && !(0, $7ruzK.isType)((0, $6yEEN.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $6yEEN.originType).WEB && !(0, $7ruzK.isType)((0, $6yEEN.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});

parcelRegister("foSph", function(module, exports) {
$parcel$export(module.exports, "validateScreenEvent", () => $58a625a553fa959b$export$dc993432a592dc27);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ function $58a625a553fa959b$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}

});

parcelRegister("fSLua", function(module, exports) {
$parcel$export(module.exports, "validateTrackEvent", () => $2714bfa4dbf6ccc7$export$8c014fd74b0c8b99);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $9l1HQ = parcelRequire("9l1HQ");
function $2714bfa4dbf6ccc7$export$8c014fd74b0c8b99(event) {
    (0, $9l1HQ.validateActionEvent)(event);
}

});

parcelRegister("6RBzd", function(module, exports) {
$parcel$export(module.exports, "validateUIEvent", () => $a743960e4a92713f$export$e5bac0930c812e90);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $9l1HQ = parcelRequire("9l1HQ");
function $a743960e4a92713f$export$e5bac0930c812e90(event) {
    (0, $9l1HQ.validateActionEvent)(event);
}

});

parcelRegister("hNvco", function(module, exports) {
$parcel$export(module.exports, "default", () => $b12ad62ff59d1201$export$2e2bcd8739ae039);
function $b12ad62ff59d1201$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("jIMQu", function(module, exports) {
$parcel$export(module.exports, "XIDPromise", () => $19bfc829ab585028$export$fbe53bbbe682bcdd);

var $blkpN = parcelRequire("blkpN");
const $19bfc829ab585028$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $blkpN.createTimeoutXid)()), (0, $blkpN.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $blkpN.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("blkpN", function(module, exports) {
$parcel$export(module.exports, "XID_TIMEOUT", () => $5b05870376aed452$export$545bcbd53afabfa3);
$parcel$export(module.exports, "createTimeoutXid", () => $5b05870376aed452$export$af4087e36d63846);
$parcel$export(module.exports, "createUnknownXid", () => $5b05870376aed452$export$fa341d0c750d705b);

var $fNacg = parcelRequire("fNacg");
const $5b05870376aed452$export$545bcbd53afabfa3 = 5000;
const $5b05870376aed452$export$af4087e36d63846 = ()=>[
        {
            type: (0, $fNacg.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $fNacg.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const $5b05870376aed452$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $fNacg.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $fNacg.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

});
parcelRegister("fNacg", function(module, exports) {
$parcel$export(module.exports, "XIDItemType", () => $8436d7eb5bd6f3eb$export$92ca0438bcb0d396);
var $8436d7eb5bd6f3eb$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
var $8436d7eb5bd6f3eb$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("JEkkv", function(module, exports) {
$parcel$export(module.exports, "ADMIN_HUB_BASE_URL_PROD", () => (parcelRequire("lm2lt")).ADMIN_HUB_BASE_URL_PROD);
$parcel$export(module.exports, "ADMIN_HUB_BASE_URL_STG", () => (parcelRequire("lm2lt")).ADMIN_HUB_BASE_URL_STG);
$parcel$export(module.exports, "BITBUCKET_DATA_CENTER_TOKENS_URL", () => (parcelRequire("lm2lt")).BITBUCKET_DATA_CENTER_TOKENS_URL);
$parcel$export(module.exports, "BITBUCKET_SETUP_GUIDE_LINK", () => (parcelRequire("lm2lt")).BITBUCKET_SETUP_GUIDE_LINK);
$parcel$export(module.exports, "CLI_INSTRUCTIONS_VIDEO_URL", () => (parcelRequire("lm2lt")).CLI_INSTRUCTIONS_VIDEO_URL);
$parcel$export(module.exports, "CODE_REVIEW_ENABLED_GUIDE_URL", () => (parcelRequire("lm2lt")).CODE_REVIEW_ENABLED_GUIDE_URL);
$parcel$export(module.exports, "CODE_REVIEW_INSTRUCTIONS_VIDEO_URL", () => (parcelRequire("lm2lt")).CODE_REVIEW_INSTRUCTIONS_VIDEO_URL);
$parcel$export(module.exports, "CODE_REVIEWER_LEARN_MORE_SAC_LINK", () => (parcelRequire("lm2lt")).CODE_REVIEWER_LEARN_MORE_SAC_LINK);
$parcel$export(module.exports, "GET_SUPPORT_LINK", () => (parcelRequire("lm2lt")).GET_SUPPORT_LINK);
$parcel$export(module.exports, "GITHUB_SETUP_GUIDE_LINK", () => (parcelRequire("lm2lt")).GITHUB_SETUP_GUIDE_LINK);
$parcel$export(module.exports, "GITLAB_SERVICE_ACCOUNT_TOKENS_URL", () => (parcelRequire("lm2lt")).GITLAB_SERVICE_ACCOUNT_TOKENS_URL);
$parcel$export(module.exports, "JIRA_CODING_AGENT_GUIDE_URL", () => (parcelRequire("lm2lt")).JIRA_CODING_AGENT_GUIDE_URL);
$parcel$export(module.exports, "JIRA_TRIAL_LINK", () => (parcelRequire("lm2lt")).JIRA_TRIAL_LINK);
$parcel$export(module.exports, "PROD_BITBUCKET_DOMAIN", () => (parcelRequire("lm2lt")).PROD_BITBUCKET_DOMAIN);
$parcel$export(module.exports, "ROVO_DEV_AUTOMATION_GUIDE_URL", () => (parcelRequire("lm2lt")).ROVO_DEV_AUTOMATION_GUIDE_URL);
$parcel$export(module.exports, "ROVO_DEV_CLI_LINUX_INSTRUCTIONS_URL", () => (parcelRequire("lm2lt")).ROVO_DEV_CLI_LINUX_INSTRUCTIONS_URL);
$parcel$export(module.exports, "ROVO_DEV_CLI_MAC_INSTRUCTIONS_URL", () => (parcelRequire("lm2lt")).ROVO_DEV_CLI_MAC_INSTRUCTIONS_URL);
$parcel$export(module.exports, "ROVO_DEV_CLI_TOKENS_URL", () => (parcelRequire("lm2lt")).ROVO_DEV_CLI_TOKENS_URL);
$parcel$export(module.exports, "ROVO_DEV_CLI_USE_GUIDE_URL", () => (parcelRequire("lm2lt")).ROVO_DEV_CLI_USE_GUIDE_URL);
$parcel$export(module.exports, "ROVO_DEV_CLI_WINDOWS_INSTRUCTIONS_URL", () => (parcelRequire("lm2lt")).ROVO_DEV_CLI_WINDOWS_INSTRUCTIONS_URL);
$parcel$export(module.exports, "ROVO_DEV_IN_JIRA_GUIDE_URL", () => (parcelRequire("lm2lt")).ROVO_DEV_IN_JIRA_GUIDE_URL);
$parcel$export(module.exports, "ROVO_DEV_STANDARD_PRICING_LINK", () => (parcelRequire("lm2lt")).ROVO_DEV_STANDARD_PRICING_LINK);
$parcel$export(module.exports, "ROVO_DEV_STANDARD_TRIAL_DOCS_URL", () => (parcelRequire("lm2lt")).ROVO_DEV_STANDARD_TRIAL_DOCS_URL);
$parcel$export(module.exports, "STG_BITBUCKET_DOMAIN", () => (parcelRequire("lm2lt")).STG_BITBUCKET_DOMAIN);
$parcel$export(module.exports, "WORK_WITH_ROVO_DEV_DOCS_URL", () => (parcelRequire("lm2lt")).WORK_WITH_ROVO_DEV_DOCS_URL);
$parcel$export(module.exports, "envType", () => (parcelRequire("1qaWF")).envType);
$parcel$export(module.exports, "getEnvType", () => (parcelRequire("fYUfs")).getEnvType);
$parcel$export(module.exports, "getHostname", () => (parcelRequire("fYUfs")).getHostname);
$parcel$export(module.exports, "isProduction", () => (parcelRequire("fYUfs")).isProduction);
$parcel$export(module.exports, "isLocal", () => (parcelRequire("fYUfs")).isLocal);
$parcel$export(module.exports, "isDevelopment", () => (parcelRequire("fYUfs")).isDevelopment);
// Environment package exports
// Types

var $1qaWF = parcelRequire("1qaWF");
parcelRequire("lm2lt");

var $fYUfs = parcelRequire("fYUfs");

});
parcelRegister("1qaWF", function(module, exports) {
$parcel$export(module.exports, "envType", () => $52092cbc9b5e7df6$export$56ac8ebc9870b1b9);
/**
 * Environment types for the application
 */ var $52092cbc9b5e7df6$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});

});

parcelRegister("lm2lt", function(module, exports) {
$parcel$export(module.exports, "STAGING_PUBLIC_PATH", () => $3769d7d0026ce6a5$export$cf681dc9f7811050);
$parcel$export(module.exports, "PROD_PUBLIC_PATH", () => $3769d7d0026ce6a5$export$792ab0c5da0fd7c5);
$parcel$export(module.exports, "STG_BITBUCKET_DOMAIN", () => $3769d7d0026ce6a5$export$37e363941a7d06d9);
$parcel$export(module.exports, "PROD_BITBUCKET_DOMAIN", () => $3769d7d0026ce6a5$export$25eb080fef99f257);
$parcel$export(module.exports, "ADMIN_HUB_BASE_URL_PROD", () => $3769d7d0026ce6a5$export$627321b82c429923);
$parcel$export(module.exports, "ADMIN_HUB_BASE_URL_STG", () => $3769d7d0026ce6a5$export$944e1ecf8da9f253);
$parcel$export(module.exports, "BITBUCKET_SETUP_GUIDE_LINK", () => $3769d7d0026ce6a5$export$cc0ce9deeea0cdfa);
$parcel$export(module.exports, "GITHUB_SETUP_GUIDE_LINK", () => $3769d7d0026ce6a5$export$6a5f3b89af31068a);
$parcel$export(module.exports, "WORK_WITH_ROVO_DEV_DOCS_URL", () => $3769d7d0026ce6a5$export$5deb2265d22bb3da);
$parcel$export(module.exports, "ROVO_DEV_STANDARD_TRIAL_DOCS_URL", () => $3769d7d0026ce6a5$export$1978886932177ca4);
$parcel$export(module.exports, "ROVO_DEV_CLI_USE_GUIDE_URL", () => $3769d7d0026ce6a5$export$1d55554399fdb210);
$parcel$export(module.exports, "ROVO_DEV_CLI_MAC_INSTRUCTIONS_URL", () => $3769d7d0026ce6a5$export$1c9f60393772813c);
$parcel$export(module.exports, "ROVO_DEV_CLI_LINUX_INSTRUCTIONS_URL", () => $3769d7d0026ce6a5$export$2a1789535495a20f);
$parcel$export(module.exports, "ROVO_DEV_CLI_WINDOWS_INSTRUCTIONS_URL", () => $3769d7d0026ce6a5$export$ce06234640630149);
$parcel$export(module.exports, "ROVO_DEV_CLI_TOKENS_URL", () => $3769d7d0026ce6a5$export$b09aacae36ab3e40);
$parcel$export(module.exports, "GITLAB_SERVICE_ACCOUNT_TOKENS_URL", () => $3769d7d0026ce6a5$export$a1a25ea7e8cadc2d);
$parcel$export(module.exports, "BITBUCKET_DATA_CENTER_TOKENS_URL", () => $3769d7d0026ce6a5$export$9618fd45245eb4f8);
$parcel$export(module.exports, "ROVO_DEV_STANDARD_PRICING_LINK", () => $3769d7d0026ce6a5$export$7e3404dc47c0a245);
$parcel$export(module.exports, "ROVO_DEV_IN_JIRA_GUIDE_URL", () => $3769d7d0026ce6a5$export$94710a236381c546);
$parcel$export(module.exports, "JIRA_CODING_AGENT_GUIDE_URL", () => $3769d7d0026ce6a5$export$5c56eb7a20ae6504);
$parcel$export(module.exports, "ROVO_DEV_AUTOMATION_GUIDE_URL", () => $3769d7d0026ce6a5$export$f015d5d2c3b82015);
$parcel$export(module.exports, "CODE_REVIEWER_LEARN_MORE_SAC_LINK", () => $3769d7d0026ce6a5$export$2c70b2d8923008f2);
$parcel$export(module.exports, "CLI_INSTRUCTIONS_VIDEO_URL", () => $3769d7d0026ce6a5$export$44d2d819ebe793ff);
$parcel$export(module.exports, "CODE_REVIEW_INSTRUCTIONS_VIDEO_URL", () => $3769d7d0026ce6a5$export$d4b1b53f9dbb10df);
$parcel$export(module.exports, "CODE_REVIEW_ENABLED_GUIDE_URL", () => $3769d7d0026ce6a5$export$a1e2c61d1f0a7fe1);
$parcel$export(module.exports, "JIRA_TRIAL_LINK", () => $3769d7d0026ce6a5$export$16f5b3b7fe9c23bc);
$parcel$export(module.exports, "GET_SUPPORT_LINK", () => $3769d7d0026ce6a5$export$cd0d3f31c5caaa8a);
/**
 * Environment-specific constants and URLs
 */ // Public paths for different environments
const $3769d7d0026ce6a5$export$cf681dc9f7811050 = 'https://dev-agents.stg-east.frontend.public.atl-paas.net/assets/';
const $3769d7d0026ce6a5$export$792ab0c5da0fd7c5 = 'https://dev-agents.prod-east.frontend.public.atl-paas.net/assets/';
const $3769d7d0026ce6a5$export$37e363941a7d06d9 = 'integration.bb-inf.net';
const $3769d7d0026ce6a5$export$25eb080fef99f257 = 'bitbucket.org';
const $3769d7d0026ce6a5$export$627321b82c429923 = 'https://admin.atlassian.com';
const $3769d7d0026ce6a5$export$944e1ecf8da9f253 = 'https://admin.stg.atlassian.com';
const $3769d7d0026ce6a5$export$595fbe9beb48a7a7 = '/secure/admin/ConfigureDvcsOrganizations!default.jspa';
const $3769d7d0026ce6a5$export$d76ba9bdae389e5f = '/plugins/servlet/ac/com.github.integration.production/gh-addon-admin?s=com.github.integration.production__gh-addon-admin';
const $3769d7d0026ce6a5$export$deed3f587f71617d = '/plugins/servlet/ac/com.github.integration.staging/gh-addon-admin?s=com.github.integration.staging__gh-addon-admin';
const $3769d7d0026ce6a5$export$cc0ce9deeea0cdfa = 'https://support.atlassian.com/jira-cloud-administration/docs/integrate-bitbucket-with-jira/';
const $3769d7d0026ce6a5$export$ad9d2623b45ad758 = 'https://marketplace.atlassian.com/apps/1219592/github-for-jira?tab=overview&hosting=cloud';
const $3769d7d0026ce6a5$export$6a5f3b89af31068a = 'https://support.atlassian.com/jira-cloud-administration/docs/integrate-with-github/';
const $3769d7d0026ce6a5$export$4c0bd3485d463fe = 'https://bitbucket.org/account/workspaces/';
const $3769d7d0026ce6a5$export$4a98fc7b279f08ef = 'https://integration.bb-inf.net/account/workspaces/';
const $3769d7d0026ce6a5$export$5deb2265d22bb3da = 'https://support.atlassian.com/rovo/docs/work-with-rovo-dev-agents/';
const $3769d7d0026ce6a5$export$1978886932177ca4 = 'https://support.atlassian.com/rovo/docs/start-a-rovo-dev-standard-trial/';
const $3769d7d0026ce6a5$export$c39cfd122465c04e = 'https://rovodevagents-beta.atlassian.net/wiki/external/ZmEwZmU2MTYwMGM3NDE3NjhlOTA2MDZhNGY5ZmU0OTU';
const $3769d7d0026ce6a5$export$3255dadb03b35a28 = 'https://rovodevagents-beta.atlassian.net/wiki/external/YWJmZmRiNTFhYTUxNDBhOTg5ZjY5ZmQ0Yzg5MTlkNzA';
const $3769d7d0026ce6a5$export$f7cf5dee5734594c = 'https://rovodevagents-beta.atlassian.net/wiki/external/OWYyYTFhNGEyNGUwNGY3YjgwMzkxMDhhMTAzM2EwYzc';
const $3769d7d0026ce6a5$export$7b0f8fec4b919ab3 = 'https://rovodevagents-beta.atlassian.net/wiki/external/ZjBjMmQ3YmQzOThhNDY1MGEzZjRiMjM1NzA5YmNkZTU';
const $3769d7d0026ce6a5$export$da4fecf2d95db63b = 'https://rovodevagents-beta.atlassian.net/wiki/external/NzJlM2JlYjRmZTc1NGQ1NTk5NjUwNDFkYmE3NTZiODY';
const $3769d7d0026ce6a5$export$8ad022a16b75d1b8 = 'https://rovodevagents-beta.atlassian.net/wiki/external/OWY5NjhmMDIyNjgzNDkxY2IyNjk4OTViOGIzZjM4ZDc';
const $3769d7d0026ce6a5$export$67efc9ea144c1797 = 'https://rovodevagents-beta.atlassian.net/wiki/external/ZTk0Y2QzMmFmMDVlNDNjNzlkYjg5YjUyOWJhOTIyZTQ';
const $3769d7d0026ce6a5$export$b48ea3f417d3c529 = 'https://rovodevagents-beta.atlassian.net/wiki/external/NTgwMGQ3Yzg1ZThjNDQ5ZDhmZWYyNWVjN2ZjODExNmM';
const $3769d7d0026ce6a5$export$f646aec6c096a2df = 'https://rovodevagents.atlassian.net/servicedesk/customer/portal/1';
const $3769d7d0026ce6a5$export$1d55554399fdb210 = 'https://support.atlassian.com/rovo/docs/use-rovo-dev-cli/';
const $3769d7d0026ce6a5$export$ac00119995b0b385 = 'https://rovodevagents-beta.atlassian.net/wiki/external/Yzc2NzI4MTk3YTBhNDdiYjkzZDhhZTc3MjE0ZmE4Y2Q';
const $3769d7d0026ce6a5$export$e649e098739c9373 = 'https://developer.atlassian.com/cloud/acli/guides/introduction/';
const $3769d7d0026ce6a5$export$1c9f60393772813c = 'https://developer.atlassian.com/cloud/acli/guides/install-macos/';
const $3769d7d0026ce6a5$export$2a1789535495a20f = 'https://developer.atlassian.com/cloud/acli/guides/install-linux/';
const $3769d7d0026ce6a5$export$ce06234640630149 = 'https://developer.atlassian.com/cloud/acli/guides/install-windows/';
const $3769d7d0026ce6a5$export$b09aacae36ab3e40 = 'https://id.atlassian.com/manage-profile/security/api-tokens?autofillToken&expiryDays=max&appId=rovodev&selectedScopes=all';
const $3769d7d0026ce6a5$export$a1a25ea7e8cadc2d = 'https://docs.gitlab.com/user/profile/service_accounts/#view-and-manage-personal-access-tokens-for-a-service-account';
const $3769d7d0026ce6a5$export$9618fd45245eb4f8 = 'https://confluence.atlassian.com/bitbucketserver0717/personal-access-tokens-1087535496.html';
const $3769d7d0026ce6a5$export$f9acf0c992fe35dd = 'https://rovodevagents-beta.atlassian.net/wiki/external/ZDQxM2VhODI2MjJkNDI3M2IwMjgyNzNjZWIwYjJhYTM';
const $3769d7d0026ce6a5$export$7e3404dc47c0a245 = 'https://www.atlassian.com/software/rovo-dev/pricing';
const $3769d7d0026ce6a5$export$94710a236381c546 = 'https://support.atlassian.com/rovo/docs/work-with-rovo-dev-in-jira/';
const $3769d7d0026ce6a5$export$5c56eb7a20ae6504 = 'https://support.atlassian.com/jira-software-cloud/docs/set-up-jira-coding-agent-in-your-organization/';
const $3769d7d0026ce6a5$export$f015d5d2c3b82015 = 'https://support.atlassian.com/rovo/docs/work-with-rovo-dev-in-automations/';
const $3769d7d0026ce6a5$export$696cc1fcfc4c83c6 = 'Not an Atlassian user';
const $3769d7d0026ce6a5$export$2c70b2d8923008f2 = 'https://support.atlassian.com/rovo/docs/activate-code-reviews-in-your-repository/';
const $3769d7d0026ce6a5$export$44d2d819ebe793ff = 'https://www.youtube.com/embed/OTgOulR4IZ0?si=Wgmg_AEKZWOcS-9V';
const $3769d7d0026ce6a5$export$d4b1b53f9dbb10df = 'https://dam-cdn.atl.orangelogic.com/AssetLink/qe61ptsy7bb01i22on613t388a502hvy.mp4';
const $3769d7d0026ce6a5$export$a1e2c61d1f0a7fe1 = 'https://support.atlassian.com/rovo/docs/enable-code-reviews/';
const $3769d7d0026ce6a5$export$16f5b3b7fe9c23bc = 'https://www.atlassian.com/software/jira/try';
const $3769d7d0026ce6a5$export$657bcdc54216df1f = 'https://dam-cdn.atl.orangelogic.com/AssetLink/oifi18gd3n6kht71g3s81g1t7181w128.svg';
const $3769d7d0026ce6a5$export$ad3dedabfe632c39 = 'https://dam-cdn.atl.orangelogic.com/AssetLink/gj3058bs3202y2t8m45a1x3u854kr650.svg';
const $3769d7d0026ce6a5$export$cd0d3f31c5caaa8a = 'https://support.atlassian.com/contact';

});

parcelRegister("fYUfs", function(module, exports) {
$parcel$export(module.exports, "getEnvType", () => $dfbf7aade60fcc91$export$1038046b28a1d92e);
$parcel$export(module.exports, "getHostname", () => $dfbf7aade60fcc91$export$e61aef4ae55da883);
$parcel$export(module.exports, "isProduction", () => $dfbf7aade60fcc91$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isLocal", () => $dfbf7aade60fcc91$export$6dd1bbd39f571125);
$parcel$export(module.exports, "isDevelopment", () => $dfbf7aade60fcc91$export$df77466336fe5355);

var $lm2lt = parcelRequire("lm2lt");

var $1qaWF = parcelRequire("1qaWF");
const $dfbf7aade60fcc91$export$1038046b28a1d92e = ()=>{
    const isStaging = "https://dev-agents.prod-east.frontend.public.atl-paas.net/assets/" === (0, $lm2lt.STAGING_PUBLIC_PATH);
    const isProd = "https://dev-agents.prod-east.frontend.public.atl-paas.net/assets/" === (0, $lm2lt.PROD_PUBLIC_PATH);
    if (isStaging) return (0, $1qaWF.envType).STAGING;
    if (isProd) return (0, $1qaWF.envType).PROD;
    return (0, $1qaWF.envType).LOCAL;
};
const $dfbf7aade60fcc91$export$e61aef4ae55da883 = ()=>{
    return $dfbf7aade60fcc91$export$1038046b28a1d92e() === (0, $1qaWF.envType).LOCAL ? '' : window.location.hostname;
};
const $dfbf7aade60fcc91$export$5911d6599ccd5587 = ()=>{
    const envTypeValue = $dfbf7aade60fcc91$export$1038046b28a1d92e();
    return {
        type: envTypeValue,
        isLocal: envTypeValue === (0, $1qaWF.envType).LOCAL,
        isStaging: envTypeValue === (0, $1qaWF.envType).STAGING,
        isProd: envTypeValue === (0, $1qaWF.envType).PROD,
        isDev: envTypeValue === (0, $1qaWF.envType).DEV,
        hostname: $dfbf7aade60fcc91$export$e61aef4ae55da883(),
        remoteDomain: undefined
    };
};
const $dfbf7aade60fcc91$export$f15d00aa73aafac4 = ()=>{
    return $dfbf7aade60fcc91$export$1038046b28a1d92e() === (0, $1qaWF.envType).PROD;
};
const $dfbf7aade60fcc91$export$23da1d24a38b0bde = ()=>{
    return $dfbf7aade60fcc91$export$1038046b28a1d92e() === (0, $1qaWF.envType).STAGING;
};
const $dfbf7aade60fcc91$export$6dd1bbd39f571125 = ()=>{
    return $dfbf7aade60fcc91$export$1038046b28a1d92e() === (0, $1qaWF.envType).LOCAL;
};
const $dfbf7aade60fcc91$export$df77466336fe5355 = ()=>{
    const env = $dfbf7aade60fcc91$export$1038046b28a1d92e();
    return env === (0, $1qaWF.envType).LOCAL || env === (0, $1qaWF.envType).DEV;
};

});



parcelRegister("7hFVb", function(module, exports) {
$parcel$export(module.exports, "FireScreenEvent", () => $a39fc65b5ce87e3d$export$ea24dc24f42376aa);

var $1v5pe = parcelRequire("1v5pe");

var $aXHSI = parcelRequire("aXHSI");
const $a39fc65b5ce87e3d$export$ea24dc24f42376aa = ({ name: name, attributes: attributes })=>{
    const { fireScreenEvent: fireScreenEvent } = (0, $aXHSI.useRovoDevWebAnalyticsClient)();
    const hasFired = (0, $1v5pe.useRef)(false);
    (0, $1v5pe.useEffect)(()=>{
        if (!hasFired.current) {
            fireScreenEvent({
                name: name,
                attributes: attributes
            });
            hasFired.current = true;
        }
    }, [
        fireScreenEvent,
        name,
        attributes
    ]);
    return null;
};

});
parcelRegister("aXHSI", function(module, exports) {
$parcel$export(module.exports, "useRovoDevWebAnalyticsClient", () => $7143da9f6cba30f9$export$de7e30c3aa459c6c);
$parcel$export(module.exports, "useDevAIWebAnalyticsClient", () => $7143da9f6cba30f9$export$53f2cc070651a68f);
parcelRequire("j5h4D");
var $h7lQ2 = parcelRequire("h7lQ2");

var $1v5pe = parcelRequire("1v5pe");

var $hn9bU = parcelRequire("hn9bU");

var $eajEV = parcelRequire("eajEV");
const $7143da9f6cba30f9$export$de7e30c3aa459c6c = ()=>{
    const { tenantContexts: tenantContexts } = (0, $h7lQ2.useTenantData)();
    const currentTenantContext = tenantContexts[0];
    const { sendUIEvent: sendUIEvent, sendScreenEvent: sendScreenEvent, sendTrackEvent: sendTrackEvent } = (0, $eajEV.useAnalyticsWebClient)();
    const analyticsData = (0, $hn9bU.useAnalyticsData)();
    const fireUiEvent = (0, $1v5pe.useCallback)((eventPayload)=>{
        const commonAttrs = {
            orgId: currentTenantContext.orgId,
            ...analyticsData
        };
        const extendedPayload = {
            ...eventPayload,
            attributes: {
                ...eventPayload.attributes,
                ...commonAttrs
            }
        };
        sendUIEvent(extendedPayload);
    }, [
        currentTenantContext.orgId,
        analyticsData,
        sendUIEvent
    ]);
    const fireScreenEvent = (0, $1v5pe.useCallback)((eventPayload)=>{
        const commonAttrs = {
            orgId: currentTenantContext.orgId,
            ...analyticsData
        };
        const extendedPayload = {
            ...eventPayload,
            attributes: {
                ...eventPayload.attributes,
                ...commonAttrs
            }
        };
        sendScreenEvent(extendedPayload);
    }, [
        currentTenantContext.orgId,
        analyticsData,
        sendScreenEvent
    ]);
    const fireTrackEvent = (0, $1v5pe.useCallback)((eventPayload)=>{
        const commonAttrs = {
            orgId: currentTenantContext.orgId,
            ...analyticsData
        };
        const extendedPayload = {
            ...eventPayload,
            attributes: {
                ...eventPayload.attributes,
                ...commonAttrs
            }
        };
        sendTrackEvent(extendedPayload);
    }, [
        currentTenantContext.orgId,
        analyticsData,
        sendTrackEvent
    ]);
    return {
        fireUiEvent: fireUiEvent,
        fireScreenEvent: fireScreenEvent,
        fireTrackEvent: fireTrackEvent
    };
};
const $7143da9f6cba30f9$export$53f2cc070651a68f = ()=>{
    const { tenantContexts: tenantContexts } = (0, $h7lQ2.useTenantData)();
    const currentTenantContext = tenantContexts[0];
    const { sendTrackEvent: sendTrackEvent } = (0, $eajEV.useAIAnalyticsWebClient)();
    const analyticsData = (0, $hn9bU.useAnalyticsData)();
    const fireTrackEvent = (0, $1v5pe.useCallback)((eventPayload)=>{
        const commonAttrs = {
            orgId: currentTenantContext.orgId,
            ...analyticsData
        };
        const extendedPayload = {
            ...eventPayload,
            attributes: {
                ...eventPayload.attributes,
                ...commonAttrs
            }
        };
        sendTrackEvent(extendedPayload);
    }, [
        currentTenantContext.orgId,
        analyticsData,
        sendTrackEvent
    ]);
    return {
        fireTrackEvent: fireTrackEvent
    };
};

});
parcelRegister("j5h4D", function(module, exports) {
$parcel$export(module.exports, "TenantContextProvider", () => (parcelRequire("2xoF5")).TenantContextProvider);
$parcel$export(module.exports, "TenantDataContext", () => (parcelRequire("h7lQ2")).TenantDataContext);
$parcel$export(module.exports, "useTenantData", () => (parcelRequire("h7lQ2")).useTenantData);
$parcel$export(module.exports, "useWorkspaceAri", () => (parcelRequire("h7lQ2")).useWorkspaceAri);
$parcel$export(module.exports, "tenantContextProviderQuery", () => (parcelRequire("kNelK")).default);

var $2xoF5 = parcelRequire("2xoF5");

var $h7lQ2 = parcelRequire("h7lQ2");

var $iemon = parcelRequire("iemon");

var $kNelK = parcelRequire("kNelK");

});
parcelRegister("2xoF5", function(module, exports) {
$parcel$export(module.exports, "TenantContextProvider", () => $9f5621b710e984df$export$e32355e80a92030c);

var $kNelK = parcelRequire("kNelK");

var $jEbac = parcelRequire("jEbac");

var $h7lQ2 = parcelRequire("h7lQ2");

var $kIqwl = parcelRequire("kIqwl");
const $9f5621b710e984df$export$e32355e80a92030c = ({ children: children, queryRef: queryRef })=>{
    const data = (0, $jEbac.usePreloadedQuery)((0, $kNelK.default), queryRef);
    const tenantData = {
        tenantContexts: data.tenantContexts.filter((context)=>context !== null).map((context)=>({
                cloudId: context.cloudId,
                orgId: context.orgId,
                devaiEntitlementId: context.entitlementInfo?.entitlementId ?? null,
                devAiActivationId: context.activationIdByProduct?.active ?? null,
                jiraActivationId: context.activationIdByProductJira?.active ?? null
            }))
    };
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $h7lQ2.TenantDataContext).Provider, {
        value: tenantData,
        children: children
    });
};

});
parcelRegister("kNelK", function(module, exports) {
$parcel$export(module.exports, "default", () => $92410c1af6389327$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6b1d86b7b4e213492f91ea797c7c3ee8>>
 * @relayHash f636d5e85b5e9a800a3fed04bd92a96f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2dc9b6455650f84b59ef904fc9d125506fea290e4471ce311588d93306f2aec0
const $92410c1af6389327$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hostNames"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "hostNames",
            "variableName": "hostNames"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "orgId"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "active"
        }
    ], v5 = {
        "args": [
            {
                "kind": "Literal",
                "name": "product",
                "value": "devai"
            }
        ],
        "concreteType": "TenantContextActivationId",
        "kind": "LinkedField",
        "name": "activationIdByProduct",
        "plural": false,
        "selections": v4 /*: any*/ ,
        "storageKey": "activationIdByProduct(product:\"devai\")"
    }, v6 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "devai.ondemand"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v8 = {
        "alias": "activationIdByProductJira",
        "args": [
            {
                "kind": "Literal",
                "name": "product",
                "value": "jira"
            }
        ],
        "concreteType": "TenantContextActivationId",
        "kind": "LinkedField",
        "name": "activationIdByProduct",
        "plural": false,
        "selections": v4 /*: any*/ ,
        "storageKey": "activationIdByProduct(product:\"jira\")"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "tenantContextProviderQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "TenantContext",
                        "kind": "LinkedField",
                        "name": "tenantContexts",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v2 /*: any*/ ,
                                "action": "THROW"
                            },
                            {
                                "kind": "RequiredField",
                                "field": v3 /*: any*/ ,
                                "action": "THROW"
                            },
                            v5 /*: any*/ ,
                            {
                                "args": v6 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "entitlementInfo",
                                "plural": false,
                                "selections": [
                                    v7 /*: any*/ 
                                ],
                                "storageKey": "entitlementInfo(hamsProductKey:\"devai.ondemand\")"
                            },
                            v8 /*: any*/ 
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "tenantContextProviderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "args": v6 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v7 /*: any*/ 
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"devai.ondemand\")"
                        },
                        v8 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "2dc9b6455650f84b59ef904fc9d125506fea290e4471ce311588d93306f2aec0",
            "metadata": {},
            "name": "tenantContextProviderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$92410c1af6389327$var$node.hash = "f157dfd1d60f16833e71aea7f1b5c916";
var $92410c1af6389327$export$2e2bcd8739ae039 = $92410c1af6389327$var$node;

});

parcelRegister("h7lQ2", function(module, exports) {
$parcel$export(module.exports, "TenantDataContext", () => $4d213054cd5ac619$export$7adae10110d5e04c);
$parcel$export(module.exports, "useTenantData", () => $4d213054cd5ac619$export$c00a80cbbdafd66b);
$parcel$export(module.exports, "useWorkspaceAri", () => $4d213054cd5ac619$export$c035c34076ea255e);

var $1v5pe = parcelRequire("1v5pe");

var $iemon = parcelRequire("iemon");
const $4d213054cd5ac619$export$7adae10110d5e04c = /*#__PURE__*/ (0, $1v5pe.createContext)(null);
const $4d213054cd5ac619$export$c00a80cbbdafd66b = ()=>{
    const context = (0, $1v5pe.useContext)($4d213054cd5ac619$export$7adae10110d5e04c);
    if (!context) throw new Error('useTenantData must be used within a TenantDataProvider');
    return context;
};
const $4d213054cd5ac619$export$c035c34076ea255e = ()=>{
    const { tenantContexts: tenantContexts } = $4d213054cd5ac619$export$c00a80cbbdafd66b();
    const firstActivationId = tenantContexts[0]?.devAiActivationId;
    return firstActivationId ? (0, $iemon.buildDevAiWorkspaceAri)(firstActivationId) : null;
};

});
parcelRegister("iemon", function(module, exports) {
$parcel$export(module.exports, "buildDevAiWorkspaceAri", () => $0998ff642ca90259$export$dac5ef412733d01a);
// https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#ati%3Acloud%3Adevai%3Aworkspace
const $0998ff642ca90259$export$dac5ef412733d01a = (activationId)=>{
    return `ari:cloud:devai::workspace/${activationId}`;
};

});




parcelRegister("eajEV", function(module, exports) {
$parcel$export(module.exports, "AnalyticsWebClientProvider", () => $16fff2b7526867a6$export$457db49ce252eed8);
$parcel$export(module.exports, "useAnalyticsWebClient", () => $16fff2b7526867a6$export$ab46754111902b52);
$parcel$export(module.exports, "useAIAnalyticsWebClient", () => $16fff2b7526867a6$export$6ee17a65a3e8bb09);

var $6yEEN = parcelRequire("6yEEN");
parcelRequire("j5h4D");
var $h7lQ2 = parcelRequire("h7lQ2");

var $1v5pe = parcelRequire("1v5pe");

var $6AigK = parcelRequire("6AigK");

var $kIqwl = parcelRequire("kIqwl");
const $16fff2b7526867a6$var$AnalyticsWebClientContext = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);
const $16fff2b7526867a6$var$AIAnalyticsWebClientContext = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);
const $16fff2b7526867a6$export$457db49ce252eed8 = ({ children: children, authData: authData })=>{
    const { tenantContexts: tenantContexts } = (0, $h7lQ2.useTenantData)();
    const accountId = authData.user?.accountId;
    const cloudId = tenantContexts[0]?.cloudId;
    const hasStartedUIViewedEvent = (0, $1v5pe.useRef)(false);
    const analyticsWebClient = (0, $1v5pe.useMemo)(()=>{
        if (accountId && cloudId) {
            (0, $6AigK.devAnalyticsClient).setTenantInfo((0, $6yEEN.tenantType).CLOUD_ID, cloudId);
            (0, $6AigK.devAnalyticsClient).setUserInfo((0, $6yEEN.userType).ATLASSIAN_ACCOUNT, accountId);
        }
        return 0, $6AigK.devAnalyticsClient;
    }, [
        accountId,
        cloudId
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (!accountId || !cloudId || hasStartedUIViewedEvent.current) return;
        (0, $6AigK.devAnalyticsClient).startUIViewedEvent();
        hasStartedUIViewedEvent.current = true;
    }, [
        accountId,
        cloudId
    ]);
    // Mirror tenant + user identity onto the AI client so AI events carry
    // the same envelope as standard track events. `startUIViewedEvent()` is
    // intentionally not called here — it's a product-level concern on the
    // base client only.
    const aiAnalyticsWebClient = (0, $1v5pe.useMemo)(()=>{
        if (accountId && cloudId) {
            (0, $6AigK.devAIAnalyticsClient).setTenantInfo((0, $6yEEN.tenantType).CLOUD_ID, cloudId);
            (0, $6AigK.devAIAnalyticsClient).setUserInfo((0, $6yEEN.userType).ATLASSIAN_ACCOUNT, accountId);
        }
        return 0, $6AigK.devAIAnalyticsClient;
    }, [
        accountId,
        cloudId
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)($16fff2b7526867a6$var$AnalyticsWebClientContext.Provider, {
        value: analyticsWebClient,
        children: /*#__PURE__*/ (0, $kIqwl.jsx)($16fff2b7526867a6$var$AIAnalyticsWebClientContext.Provider, {
            value: aiAnalyticsWebClient,
            children: children
        })
    });
};
const $16fff2b7526867a6$export$ab46754111902b52 = ()=>{
    const analyticsWebClient = (0, $1v5pe.useContext)($16fff2b7526867a6$var$AnalyticsWebClientContext);
    if (!analyticsWebClient) throw new Error('Must be used inside AnalyticsWebClientProvider');
    return analyticsWebClient;
};
const $16fff2b7526867a6$export$6ee17a65a3e8bb09 = ()=>{
    const aiAnalyticsWebClient = (0, $1v5pe.useContext)($16fff2b7526867a6$var$AIAnalyticsWebClientContext);
    if (!aiAnalyticsWebClient) throw new Error('Must be used inside AnalyticsWebClientProvider');
    return aiAnalyticsWebClient;
};

});



parcelRegister("8fh7G", function(module, exports) {
$parcel$export(module.exports, "AIEventsInstrumentationProvider", () => $e2580ea37def3c8b$export$b5d4bc85dfbaa4f8);

var $1v5pe = parcelRequire("1v5pe");

var $aqz5d = parcelRequire("aqz5d");

var $2PYYP = parcelRequire("2PYYP");

var $1anQY = parcelRequire("1anQY");

var $kIqwl = parcelRequire("kIqwl");
const $e2580ea37def3c8b$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $e2580ea37def3c8b$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $1anQY.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $1v5pe.useMemo)(()=>{
        $e2580ea37def3c8b$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $2PYYP.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $aqz5d.AIEventsInstrumentationContext).Provider, {
        value: contextValue,
        children: children
    });
};

});
parcelRegister("aqz5d", function(module, exports) {
$parcel$export(module.exports, "AIEventsInstrumentationContext", () => $e3bcacda73eceecf$export$4f059feb37b5835e);

var $1v5pe = parcelRequire("1v5pe");
const $e3bcacda73eceecf$export$4f059feb37b5835e = (0, $1v5pe.createContext)(null);

});

parcelRegister("2PYYP", function(module, exports) {
$parcel$export(module.exports, "defaultAIEventsInstrumentationConfigValues", () => $ee3aaa331f705581$export$5013b36eeed4ec19);

var $fy9FQ = parcelRequire("fy9FQ");
const $ee3aaa331f705581$export$5013b36eeed4ec19 = {
    isAIFeature: 1,
    actionSubjectId: 'client',
    eventDispatcherSource: (0, $fy9FQ.EventDispatcherSources).JSLib,
    skipAISessionValidation: false,
    useDefaultGASv3EventSchema: false,
    enablePlatformEvents: false
};

});
parcelRegister("fy9FQ", function(module, exports) {
$parcel$export(module.exports, "AISessionState", () => $7f2b6313c54ee183$export$af92e0e920a45719);
$parcel$export(module.exports, "EventDispatcherSources", () => $7f2b6313c54ee183$export$7052d5b66e36f60f);
var $7f2b6313c54ee183$export$af92e0e920a45719 = /*#__PURE__*/ function(AISessionState) {
    AISessionState["unset"] = "[AIInteraction]:UNSET";
    AISessionState["initiated"] = "[AIInteraction]:INITIATED";
    AISessionState["viewed"] = "[AIInteraction]:VIEWED";
    AISessionState["error"] = "[AIInteraction]:ERROR";
    AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
    AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
    AISessionState["adopted"] = "[AIInteraction]:ADOPTED";
    AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
    AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
    return AISessionState;
}({});
var $7f2b6313c54ee183$export$7052d5b66e36f60f = /*#__PURE__*/ function(EventDispatcherSources) {
    EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
    return EventDispatcherSources;
}({});

});


parcelRegister("1anQY", function(module, exports) {
$parcel$export(module.exports, "useAIInstrumentationSetup", () => $7ceab73a9c810457$export$259576f4e7ac6488);

var $1v5pe = parcelRequire("1v5pe");

var $8UbrS = parcelRequire("8UbrS");

var $7Om0G = parcelRequire("7Om0G");

var $fy9FQ = parcelRequire("fy9FQ");
const $7ceab73a9c810457$export$259576f4e7ac6488 = (customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig)=>{
    const singleInstrumentationIDRef = (0, $1v5pe.useRef)(undefined);
    const aiSessionStateRef = (0, $1v5pe.useRef)((0, $fy9FQ.AISessionState).unset);
    const setAISessionState = (0, $1v5pe.useCallback)((nextState)=>{
        aiSessionStateRef.current = nextState;
    }, []);
    const getAISessionState = (0, $1v5pe.useCallback)(()=>{
        return aiSessionStateRef.current;
    }, []);
    const refreshSingleInstrumentationID = (0, $1v5pe.useCallback)((customSingleInstrumentationIDFromEvent)=>{
        const nextSingleInstrumentationID = (0, $8UbrS.getNewSingleInstrumentationID)(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
        singleInstrumentationIDRef.current = nextSingleInstrumentationID;
        if (cookieSingleInstrumentationConfig) (0, $7Om0G.setSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig
    ]);
    const getSingleInstrumentationID = (0, $1v5pe.useCallback)(()=>{
        // this handles a race condition when we have a new singleInstrumentationID from the user config
        // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
        // singleInstrumentationID at first step and then return a new one.
        if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
            refreshSingleInstrumentationID();
            return singleInstrumentationIDRef.current;
        }
        if (cookieSingleInstrumentationConfig) return (0, $7Om0G.readSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
        return singleInstrumentationIDRef.current;
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig,
        refreshSingleInstrumentationID
    ]);
    return {
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        getSingleInstrumentationID: getSingleInstrumentationID,
        setAISessionState: setAISessionState,
        getAISessionState: getAISessionState
    };
};

});
parcelRegister("8UbrS", function(module, exports) {
$parcel$export(module.exports, "getNewSingleInstrumentationID", () => $8272089feea37b14$export$cee2a1482be61648);

var $2nfvt = parcelRequire("2nfvt");

var $2BKzr = parcelRequire("2BKzr");
function $8272089feea37b14$export$cee2a1482be61648(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. from cookie lib
    // 4. default behaviour generates through the crypto API
    return (0, $2nfvt.match)({
        customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
        customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
    }).with({
        customSingleInstrumentationIDFromEvent: (0, $2nfvt.P).string
    }, (result)=>result.customSingleInstrumentationIDFromEvent).with({
        customSingleInstrumentationIDFromUserConfig: (0, $2nfvt.P).string
    }, (result)=>result.customSingleInstrumentationIDFromUserConfig)// we can't use the crypto API in the browser due to SSR issues?
    // https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    .otherwise(()=>(0, $2BKzr.default)());
}

});
parcelRegister("2nfvt", function(module, exports) {
$parcel$export(module.exports, "P", () => $1ba9c20f3c8189a5$export$56c0d5a1e737357d);
$parcel$export(module.exports, "match", () => $1ba9c20f3c8189a5$export$4659b591c19bdf3d);
const $1ba9c20f3c8189a5$var$t = Symbol.for("@ts-pattern/matcher"), $1ba9c20f3c8189a5$var$e = Symbol.for("@ts-pattern/isVariadic"), $1ba9c20f3c8189a5$var$n = "@ts-pattern/anonymous-select-key", $1ba9c20f3c8189a5$var$r = (t)=>Boolean(t && "object" == typeof t), $1ba9c20f3c8189a5$var$i = (e)=>e && !!e[$1ba9c20f3c8189a5$var$t], $1ba9c20f3c8189a5$var$o = (n, s, c)=>{
    if ($1ba9c20f3c8189a5$var$i(n)) {
        const e = n[$1ba9c20f3c8189a5$var$t](), { matched: r, selections: i } = e.match(s);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($1ba9c20f3c8189a5$var$r(n)) {
        if (!$1ba9c20f3c8189a5$var$r(s)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(s)) return !1;
            let t = [], r = [], a = [];
            for (const o of n.keys()){
                const s = n[o];
                $1ba9c20f3c8189a5$var$i(s) && s[$1ba9c20f3c8189a5$var$e] ? a.push(s) : a.length ? r.push(s) : t.push(s);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (s.length < t.length + r.length) return !1;
                const e = s.slice(0, t.length), n = 0 === r.length ? [] : s.slice(-r.length), i = s.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$1ba9c20f3c8189a5$var$o(t, e[n], c)) && r.every((t, e)=>$1ba9c20f3c8189a5$var$o(t, n[e], c)) && (0 === a.length || $1ba9c20f3c8189a5$var$o(a[0], i, c));
            }
            return n.length === s.length && n.every((t, e)=>$1ba9c20f3c8189a5$var$o(t, s[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in s || $1ba9c20f3c8189a5$var$i(a = r) && "optional" === a[$1ba9c20f3c8189a5$var$t]().matcherType) && $1ba9c20f3c8189a5$var$o(r, s[e], c);
        });
    }
    return Object.is(s, n);
}, $1ba9c20f3c8189a5$var$s = (e)=>{
    var n, o, a;
    return $1ba9c20f3c8189a5$var$r(e) ? $1ba9c20f3c8189a5$var$i(e) ? null != (n = null == (o = (a = e[$1ba9c20f3c8189a5$var$t]()).getSelectionKeys) ? void 0 : o.call(a)) ? n : [] : Array.isArray(e) ? $1ba9c20f3c8189a5$var$c(e, $1ba9c20f3c8189a5$var$s) : $1ba9c20f3c8189a5$var$c(Object.values(e), $1ba9c20f3c8189a5$var$s) : [];
}, $1ba9c20f3c8189a5$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $1ba9c20f3c8189a5$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$1ba9c20f3c8189a5$var$o(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $1ba9c20f3c8189a5$var$o(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $1ba9c20f3c8189a5$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$1ba9c20f3c8189a5$var$l(t),
        and: (e)=>$1ba9c20f3c8189a5$var$m(t, e),
        or: (e)=>$1ba9c20f3c8189a5$var$d(t, e),
        select: (e)=>void 0 === e ? $1ba9c20f3c8189a5$var$y(t) : $1ba9c20f3c8189a5$var$y(e, t)
    });
}
function $1ba9c20f3c8189a5$var$h(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$1ba9c20f3c8189a5$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$1ba9c20f3c8189a5$var$h($1ba9c20f3c8189a5$var$l(t)),
        select: (e)=>$1ba9c20f3c8189a5$var$h(void 0 === e ? $1ba9c20f3c8189a5$var$y(t) : $1ba9c20f3c8189a5$var$y(e, t))
    });
}
function $1ba9c20f3c8189a5$var$l(e) {
    return $1ba9c20f3c8189a5$var$u({
        [$1ba9c20f3c8189a5$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($1ba9c20f3c8189a5$var$s(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $1ba9c20f3c8189a5$var$o(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$1ba9c20f3c8189a5$var$s(e),
                matcherType: "optional"
            })
    });
}
const $1ba9c20f3c8189a5$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $1ba9c20f3c8189a5$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $1ba9c20f3c8189a5$var$m(...e) {
    return $1ba9c20f3c8189a5$var$u({
        [$1ba9c20f3c8189a5$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$1ba9c20f3c8189a5$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$1ba9c20f3c8189a5$var$c(e, $1ba9c20f3c8189a5$var$s),
                matcherType: "and"
            })
    });
}
function $1ba9c20f3c8189a5$var$d(...e) {
    return $1ba9c20f3c8189a5$var$u({
        [$1ba9c20f3c8189a5$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $1ba9c20f3c8189a5$var$c(e, $1ba9c20f3c8189a5$var$s).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$1ba9c20f3c8189a5$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$1ba9c20f3c8189a5$var$c(e, $1ba9c20f3c8189a5$var$s),
                matcherType: "or"
            })
    });
}
function $1ba9c20f3c8189a5$var$p(e) {
    return {
        [$1ba9c20f3c8189a5$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $1ba9c20f3c8189a5$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $1ba9c20f3c8189a5$var$u({
        [$1ba9c20f3c8189a5$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $1ba9c20f3c8189a5$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $1ba9c20f3c8189a5$var$o(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $1ba9c20f3c8189a5$var$n
                    ].concat(void 0 === i ? [] : $1ba9c20f3c8189a5$var$s(i))
            })
    });
}
function $1ba9c20f3c8189a5$var$v(t) {
    return "number" == typeof t;
}
function $1ba9c20f3c8189a5$var$b(t) {
    return "string" == typeof t;
}
function $1ba9c20f3c8189a5$var$w(t) {
    return "bigint" == typeof t;
}
const $1ba9c20f3c8189a5$var$S = $1ba9c20f3c8189a5$var$u($1ba9c20f3c8189a5$var$p(function(t) {
    return !0;
})), $1ba9c20f3c8189a5$var$O = $1ba9c20f3c8189a5$var$S, $1ba9c20f3c8189a5$var$j = (t)=>Object.assign($1ba9c20f3c8189a5$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $1ba9c20f3c8189a5$var$j($1ba9c20f3c8189a5$var$m(t, (n = e, $1ba9c20f3c8189a5$var$p((t)=>$1ba9c20f3c8189a5$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $1ba9c20f3c8189a5$var$j($1ba9c20f3c8189a5$var$m(t, (n = e, $1ba9c20f3c8189a5$var$p((t)=>$1ba9c20f3c8189a5$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$1ba9c20f3c8189a5$var$j($1ba9c20f3c8189a5$var$m(t, ((t)=>$1ba9c20f3c8189a5$var$p((e)=>$1ba9c20f3c8189a5$var$b(e) && e.length >= t))(e))),
        length: (e)=>$1ba9c20f3c8189a5$var$j($1ba9c20f3c8189a5$var$m(t, ((t)=>$1ba9c20f3c8189a5$var$p((e)=>$1ba9c20f3c8189a5$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$1ba9c20f3c8189a5$var$j($1ba9c20f3c8189a5$var$m(t, ((t)=>$1ba9c20f3c8189a5$var$p((e)=>$1ba9c20f3c8189a5$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $1ba9c20f3c8189a5$var$j($1ba9c20f3c8189a5$var$m(t, (n = e, $1ba9c20f3c8189a5$var$p((t)=>$1ba9c20f3c8189a5$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $1ba9c20f3c8189a5$var$j($1ba9c20f3c8189a5$var$m(t, (n = e, $1ba9c20f3c8189a5$var$p((t)=>$1ba9c20f3c8189a5$var$b(t) && Boolean(t.match(n))))));
        }
    }), $1ba9c20f3c8189a5$var$K = $1ba9c20f3c8189a5$var$j($1ba9c20f3c8189a5$var$p($1ba9c20f3c8189a5$var$b)), $1ba9c20f3c8189a5$var$x = (t)=>Object.assign($1ba9c20f3c8189a5$var$u(t), {
        between: (e, n)=>$1ba9c20f3c8189a5$var$x($1ba9c20f3c8189a5$var$m(t, ((t, e)=>$1ba9c20f3c8189a5$var$p((n)=>$1ba9c20f3c8189a5$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$1ba9c20f3c8189a5$var$x($1ba9c20f3c8189a5$var$m(t, ((t)=>$1ba9c20f3c8189a5$var$p((e)=>$1ba9c20f3c8189a5$var$v(e) && e < t))(e))),
        gt: (e)=>$1ba9c20f3c8189a5$var$x($1ba9c20f3c8189a5$var$m(t, ((t)=>$1ba9c20f3c8189a5$var$p((e)=>$1ba9c20f3c8189a5$var$v(e) && e > t))(e))),
        lte: (e)=>$1ba9c20f3c8189a5$var$x($1ba9c20f3c8189a5$var$m(t, ((t)=>$1ba9c20f3c8189a5$var$p((e)=>$1ba9c20f3c8189a5$var$v(e) && e <= t))(e))),
        gte: (e)=>$1ba9c20f3c8189a5$var$x($1ba9c20f3c8189a5$var$m(t, ((t)=>$1ba9c20f3c8189a5$var$p((e)=>$1ba9c20f3c8189a5$var$v(e) && e >= t))(e))),
        int: ()=>$1ba9c20f3c8189a5$var$x($1ba9c20f3c8189a5$var$m(t, $1ba9c20f3c8189a5$var$p((t)=>$1ba9c20f3c8189a5$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$1ba9c20f3c8189a5$var$x($1ba9c20f3c8189a5$var$m(t, $1ba9c20f3c8189a5$var$p((t)=>$1ba9c20f3c8189a5$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$1ba9c20f3c8189a5$var$x($1ba9c20f3c8189a5$var$m(t, $1ba9c20f3c8189a5$var$p((t)=>$1ba9c20f3c8189a5$var$v(t) && t > 0))),
        negative: ()=>$1ba9c20f3c8189a5$var$x($1ba9c20f3c8189a5$var$m(t, $1ba9c20f3c8189a5$var$p((t)=>$1ba9c20f3c8189a5$var$v(t) && t < 0)))
    }), $1ba9c20f3c8189a5$var$E = $1ba9c20f3c8189a5$var$x($1ba9c20f3c8189a5$var$p($1ba9c20f3c8189a5$var$v)), $1ba9c20f3c8189a5$var$A = (t)=>Object.assign($1ba9c20f3c8189a5$var$u(t), {
        between: (e, n)=>$1ba9c20f3c8189a5$var$A($1ba9c20f3c8189a5$var$m(t, ((t, e)=>$1ba9c20f3c8189a5$var$p((n)=>$1ba9c20f3c8189a5$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$1ba9c20f3c8189a5$var$A($1ba9c20f3c8189a5$var$m(t, ((t)=>$1ba9c20f3c8189a5$var$p((e)=>$1ba9c20f3c8189a5$var$w(e) && e < t))(e))),
        gt: (e)=>$1ba9c20f3c8189a5$var$A($1ba9c20f3c8189a5$var$m(t, ((t)=>$1ba9c20f3c8189a5$var$p((e)=>$1ba9c20f3c8189a5$var$w(e) && e > t))(e))),
        lte: (e)=>$1ba9c20f3c8189a5$var$A($1ba9c20f3c8189a5$var$m(t, ((t)=>$1ba9c20f3c8189a5$var$p((e)=>$1ba9c20f3c8189a5$var$w(e) && e <= t))(e))),
        gte: (e)=>$1ba9c20f3c8189a5$var$A($1ba9c20f3c8189a5$var$m(t, ((t)=>$1ba9c20f3c8189a5$var$p((e)=>$1ba9c20f3c8189a5$var$w(e) && e >= t))(e))),
        positive: ()=>$1ba9c20f3c8189a5$var$A($1ba9c20f3c8189a5$var$m(t, $1ba9c20f3c8189a5$var$p((t)=>$1ba9c20f3c8189a5$var$w(t) && t > 0))),
        negative: ()=>$1ba9c20f3c8189a5$var$A($1ba9c20f3c8189a5$var$m(t, $1ba9c20f3c8189a5$var$p((t)=>$1ba9c20f3c8189a5$var$w(t) && t < 0)))
    }), $1ba9c20f3c8189a5$var$P = $1ba9c20f3c8189a5$var$A($1ba9c20f3c8189a5$var$p($1ba9c20f3c8189a5$var$w)), $1ba9c20f3c8189a5$var$T = $1ba9c20f3c8189a5$var$u($1ba9c20f3c8189a5$var$p(function(t) {
    return "boolean" == typeof t;
})), $1ba9c20f3c8189a5$var$B = $1ba9c20f3c8189a5$var$u($1ba9c20f3c8189a5$var$p(function(t) {
    return "symbol" == typeof t;
})), $1ba9c20f3c8189a5$var$_ = $1ba9c20f3c8189a5$var$u($1ba9c20f3c8189a5$var$p(function(t) {
    return null == t;
})), $1ba9c20f3c8189a5$var$k = $1ba9c20f3c8189a5$var$u($1ba9c20f3c8189a5$var$p(function(t) {
    return null != t;
}));
var $1ba9c20f3c8189a5$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $1ba9c20f3c8189a5$var$t,
    optional: $1ba9c20f3c8189a5$var$l,
    array: function(...e) {
        return $1ba9c20f3c8189a5$var$h({
            [$1ba9c20f3c8189a5$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $1ba9c20f3c8189a5$var$s(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$1ba9c20f3c8189a5$var$o(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $1ba9c20f3c8189a5$var$s(e[0])
                })
        });
    },
    set: function(...e) {
        return $1ba9c20f3c8189a5$var$u({
            [$1ba9c20f3c8189a5$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $1ba9c20f3c8189a5$var$f(t, (t)=>$1ba9c20f3c8189a5$var$o(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $1ba9c20f3c8189a5$var$s(e[0])
                })
        });
    },
    map: function(...e) {
        return $1ba9c20f3c8189a5$var$u({
            [$1ba9c20f3c8189a5$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [s, c] = e;
                        return {
                            matched: $1ba9c20f3c8189a5$var$g(t, (t, e)=>{
                                const n = $1ba9c20f3c8189a5$var$o(s, e, r), i = $1ba9c20f3c8189a5$var$o(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$1ba9c20f3c8189a5$var$s(e[0]),
                            ...$1ba9c20f3c8189a5$var$s(e[1])
                        ]
                })
        });
    },
    intersection: $1ba9c20f3c8189a5$var$m,
    union: $1ba9c20f3c8189a5$var$d,
    not: function(e) {
        return $1ba9c20f3c8189a5$var$u({
            [$1ba9c20f3c8189a5$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$1ba9c20f3c8189a5$var$o(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $1ba9c20f3c8189a5$var$p,
    select: $1ba9c20f3c8189a5$var$y,
    any: $1ba9c20f3c8189a5$var$S,
    _: $1ba9c20f3c8189a5$var$O,
    string: $1ba9c20f3c8189a5$var$K,
    number: $1ba9c20f3c8189a5$var$E,
    bigint: $1ba9c20f3c8189a5$var$P,
    boolean: $1ba9c20f3c8189a5$var$T,
    symbol: $1ba9c20f3c8189a5$var$B,
    nullish: $1ba9c20f3c8189a5$var$_,
    nonNullable: $1ba9c20f3c8189a5$var$k,
    instanceOf: function(t) {
        return $1ba9c20f3c8189a5$var$u($1ba9c20f3c8189a5$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $1ba9c20f3c8189a5$var$u($1ba9c20f3c8189a5$var$p($1ba9c20f3c8189a5$export$ce1e7a33533a73d9(t)));
    }
};
class $1ba9c20f3c8189a5$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $1ba9c20f3c8189a5$var$$ = {
    matched: !1,
    value: void 0
};
function $1ba9c20f3c8189a5$export$4659b591c19bdf3d(t) {
    return new $1ba9c20f3c8189a5$var$I(t, $1ba9c20f3c8189a5$var$$);
}
class $1ba9c20f3c8189a5$var$I {
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let s = !1, c = {};
        const a = (t, e)=>{
            s = !0, c[t] = e;
        }, u = !r.some((t)=>$1ba9c20f3c8189a5$var$o(t, this.input, a)) || i && !Boolean(i(this.input)) ? $1ba9c20f3c8189a5$var$$ : {
            matched: !0,
            value: e(s ? $1ba9c20f3c8189a5$var$n in c ? c[$1ba9c20f3c8189a5$var$n] : c : this.input, this.input)
        };
        return new $1ba9c20f3c8189a5$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $1ba9c20f3c8189a5$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $1ba9c20f3c8189a5$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive(t = $1ba9c20f3c8189a5$var$L) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    narrow() {
        return this;
    }
}
function $1ba9c20f3c8189a5$var$L(t) {
    throw new $1ba9c20f3c8189a5$export$6c1467edb54d3773(t);
}

});


parcelRegister("7Om0G", function(module, exports) {
$parcel$export(module.exports, "setSingleInstrumentationIDCookie", () => $8b69356c9556ea72$export$9a4eaf99327c19fe);
$parcel$export(module.exports, "readSingleInstrumentationIDCookie", () => $8b69356c9556ea72$export$d6fb1caea334c7c7);

var $dbJ6U = parcelRequire("dbJ6U");
var $1Y0UN = parcelRequire("1Y0UN");
const $8b69356c9556ea72$export$72d8c154d3f75075 = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
const $8b69356c9556ea72$export$35ae1861d13fb6c8 = (uniqueCookieFeatureName)=>`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;
const $8b69356c9556ea72$export$9a4eaf99327c19fe = (uniqueCookieFeatureName, nextSingleInstrumentationID)=>(0, $1Y0UN.setCookie)($8b69356c9556ea72$export$35ae1861d13fb6c8(uniqueCookieFeatureName), nextSingleInstrumentationID, {
        expires: 7,
        domain: location.hostname,
        sameSite: 'strict'
    });
const $8b69356c9556ea72$export$d6fb1caea334c7c7 = (uniqueCookieFeatureName)=>(0, $dbJ6U.getCookie)($8b69356c9556ea72$export$35ae1861d13fb6c8(uniqueCookieFeatureName)) || $8b69356c9556ea72$export$72d8c154d3f75075;

});
parcelRegister("dbJ6U", function(module, exports) {
$parcel$export(module.exports, "getCookie", () => $185be24be28f778f$export$4be65e66cfa2648a);

var $6yOvq = parcelRequire("6yOvq");

var $2aEiL = parcelRequire("2aEiL");

var $7WT4C = parcelRequire("7WT4C");

var $bEUFb = parcelRequire("bEUFb");
function $185be24be28f778f$export$4be65e66cfa2648a(key) {
    if ((0, $2aEiL.fg)('platform_moonjelly_bsc_master_killswitch')) // Get the cookie without package operational events
    // when master killswitch is enabled
    return key ? (0, $6yOvq.default).get(key) : (0, $6yOvq.default).get();
    try {
        (0, $7WT4C.sendPackageOperationalEvent)({
            action: 'usedGetCookie',
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, $6yOvq.default).get(key) : (0, $6yOvq.default).get();
    } catch (e) {
        (0, $bEUFb.Logger).errorWithOperationalEvent({
            action: 'usedGetCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use get cookie. ${e.message || ''}`
        });
    }
}

});
parcelRegister("7WT4C", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsClient", () => $2710243828018c15$export$fde53e78fd93a54d);
$parcel$export(module.exports, "sendPackageOperationalEvent", () => $2710243828018c15$export$5bfe55348e7aebc1);
$parcel$export(module.exports, "sendUnsampledPackageOperationalEvent", () => $2710243828018c15$export$c986f0e7f985d67f);
$parcel$export(module.exports, "sendUIEvent", () => $2710243828018c15$export$1aecf263098db667);
$parcel$export(module.exports, "sendScreenEvent", () => $2710243828018c15$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendTrackEvent", () => $2710243828018c15$export$1ba525b8a711eaac);

var $6yEEN = parcelRequire("6yEEN");

var $jcoDC = parcelRequire("jcoDC");

var $2aEiL = parcelRequire("2aEiL");

var $jeHvL = parcelRequire("jeHvL");

var $hDU2p = parcelRequire("hDU2p");

var $3Tj3s = parcelRequire("3Tj3s");

var $36AKy = parcelRequire("36AKy");

var $h4Fd6 = parcelRequire("h4Fd6");
const $2710243828018c15$var$getEnvironment = ()=>{
    const { hostname: hostname } = window.location;
    if (hostname.includes('.dev.') || hostname.includes('.stg.') || hostname.includes('.jira-dev.') || hostname.includes('.jira-stg.')) return (0, $6yEEN.envType).STAGING;
    if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, $6yEEN.envType).DEV;
    return (0, $6yEEN.envType).PROD;
};
const $2710243828018c15$export$78d7c0236b4fece9 = (path)=>{
    let subPath = '';
    if (!path) return subPath;
    const checkPath = (match)=>{
        return new RegExp(`^${match}(/|$)`).test(String(path));
    };
    if (checkPath('/wiki')) subPath = '/wiki';
    if (checkPath('/jira')) subPath = '/jira';
    if (checkPath('/compass')) subPath = '/compass';
    if (checkPath('/canvas')) subPath = '/canvas';
    if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
    return subPath;
};
const $2710243828018c15$var$getProductFromDomain = (domain)=>{
    if (domain === 'https://trello.com') return 'trello';
    return null;
};
const $2710243828018c15$export$fce3dd735e04d566 = ()=>{
    const { origin: origin, pathname: pathname } = window.location;
    const productPath = $2710243828018c15$export$78d7c0236b4fece9(pathname);
    const domain = `${origin}${productPath}`;
    const product = $2710243828018c15$var$getProductFromDomain(domain) || productPath.slice(1);
    return {
        domain: domain,
        product: product
    };
};
const $2710243828018c15$var$decorateEventAttributes = (attributes)=>{
    const { domain: domain, product: product } = $2710243828018c15$export$fce3dd735e04d566();
    const cdnFileVersion = (0, $jeHvL.getBscGlobalState)().cdnFileVersion;
    return {
        packageName: (0, $2aEiL.fg)('platform_bsc_use_generated_package_info') ? (0, $36AKy.packageName) : (0, $3Tj3s.packageName),
        packageVersion: (0, $2aEiL.fg)('platform_bsc_use_generated_package_info') ? (0, $36AKy.packageVersion) : (0, $3Tj3s.packageVersion),
        domain: domain,
        product: (0, $jeHvL.getBscGlobalState)().product?.toLowerCase() ?? product,
        ...(0, $2aEiL.fg)('platform_bsc_add_cdn_file_version_in_events') && cdnFileVersion && typeof cdnFileVersion === 'object' ? {
            cdnBuildNumber: cdnFileVersion.buildNumber,
            cdnBuildTimestamp: cdnFileVersion.fileCreationTimestamp
        } : {},
        ...attributes && attributes
    };
};
const $2710243828018c15$export$fde53e78fd93a54d = (()=>{
    let instance;
    return ()=>{
        try {
            if (!instance && (0, $jeHvL.getBscGlobalState)().analyticsEnabled) {
                instance = new (0, $jcoDC.default)({
                    env: $2710243828018c15$var$getEnvironment(),
                    product: 'atlassianCookies'
                }, {
                    // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                    // When set to false, the client will use a stargate proxy for the current URL to send events
                    // to GAS. Said another way:
                    // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                    // false => events are sent to <the current domain>/gasv3/api/v1/batch
                    //
                    // By default, this should be set to false.  If you need to validate that analytics events
                    // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                    // won't be able to proxy to GAS via stargate.
                    useLegacyUrl: false,
                    disableCookiePersistence: true
                });
                if ((0, $jeHvL.getBscGlobalState)().cloudId) instance.setTenantInfo((0, $6yEEN.tenantType).CLOUD_ID, (0, $jeHvL.getBscGlobalState)().cloudId);
                if ((0, $jeHvL.getBscGlobalState)().userId) instance.setUserInfo((0, $6yEEN.userType).ATLASSIAN_ACCOUNT, (0, $jeHvL.getBscGlobalState)().userId ?? '');
            }
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            // eslint-disable-next-line no-console
            console.error(`${(0, $hDU2p.LOG_PREFIX)}: Failed to initialize AnalyticsWebClient. ${e}`);
        }
        if (!(0, $jeHvL.getBscGlobalState)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
})();
function $2710243828018c15$export$5bfe55348e7aebc1(properties) {
    (0, $h4Fd6.withAnalyticsEventSampling)(properties.action, ()=>$2710243828018c15$export$fde53e78fd93a54d()?.sendOperationalEvent({
            source: 'package',
            actionSubject: 'package',
            action: properties.action,
            attributes: $2710243828018c15$var$decorateEventAttributes(properties.attributes)
        }));
}
function $2710243828018c15$export$c986f0e7f985d67f(properties) {
    $2710243828018c15$export$fde53e78fd93a54d()?.sendOperationalEvent({
        source: 'package',
        actionSubject: 'package',
        action: properties.action,
        attributes: $2710243828018c15$var$decorateEventAttributes(properties.attributes)
    });
}
function $2710243828018c15$export$1aecf263098db667(properties) {
    (0, $h4Fd6.withAnalyticsEventSampling)(properties.actionSubjectId, ()=>$2710243828018c15$export$fde53e78fd93a54d()?.sendUIEvent({
            ...properties,
            attributes: $2710243828018c15$var$decorateEventAttributes(properties.attributes)
        }));
}
function $2710243828018c15$export$22a3b1671f38a193(properties) {
    (0, $h4Fd6.withAnalyticsEventSampling)(properties.name, ()=>$2710243828018c15$export$fde53e78fd93a54d()?.sendScreenEvent({
            ...properties,
            attributes: $2710243828018c15$var$decorateEventAttributes(properties.attributes)
        }));
}
function $2710243828018c15$export$1ba525b8a711eaac(properties) {
    const { onSent: onSent, ...eventProperties } = properties;
    (0, $h4Fd6.withAnalyticsEventSampling)(properties.actionSubject, ()=>{
        const client = $2710243828018c15$export$fde53e78fd93a54d();
        if (!client) // No client means nothing was emitted, so we must not run onSent
        return;
        client.sendTrackEvent({
            ...eventProperties,
            attributes: $2710243828018c15$var$decorateEventAttributes(properties.attributes)
        });
        onSent?.();
    });
}

});
parcelRegister("jeHvL", function(module, exports) {
$parcel$export(module.exports, "getBscGlobalState", () => $12abd53530fa2f1e$export$3b78a1ea01f5ec28);
$parcel$export(module.exports, "__internalApplyInitialState", () => $12abd53530fa2f1e$export$725ef39b428c0dc2);
$parcel$export(module.exports, "__internalGetPatternFormat", () => $12abd53530fa2f1e$export$f9550288b9b1f6e3);
$parcel$export(module.exports, "__internalSetPatternFormat", () => $12abd53530fa2f1e$export$f10a7691f1fb3cb);
$parcel$export(module.exports, "__internalGetResolvedFlatPatternFileFormat", () => $12abd53530fa2f1e$export$8bf1367cc4bb66da);
$parcel$export(module.exports, "__internalSetResolvedFlatPatternFileFormat", () => $12abd53530fa2f1e$export$2bd306fd2b97e710);
$parcel$export(module.exports, "__internalGetHasInitialized", () => $12abd53530fa2f1e$export$8835d45f445e6ba4);
$parcel$export(module.exports, "__internalGetProductGlobalState", () => $12abd53530fa2f1e$export$9dfdd17bbd03b460);
$parcel$export(module.exports, "__internalGetWebStorageControlsEnabledGlobalState", () => $12abd53530fa2f1e$export$d96c3b0fb6d35c5d);
$parcel$export(module.exports, "__internalGetIndexedDbControlsEnabledGlobalState", () => $12abd53530fa2f1e$export$c8554d68c78456d3);
$parcel$export(module.exports, "__internalGetDisableWebStorageConsentChecksGlobalState", () => $12abd53530fa2f1e$export$ea650e4f51ec84d8);
$parcel$export(module.exports, "__internalGetAllowUncategorizedCookiesInOverridesGlobalState", () => $12abd53530fa2f1e$export$fa1f6ebb49ec4b30);
$parcel$export(module.exports, "__internalGetAllowUncategorizedItemsInWebStorageOverridesGlobalState", () => $12abd53530fa2f1e$export$b60c6437117dfaf9);
$parcel$export(module.exports, "__internalGetAllowUncategorizedItemsInIndexedDBOverridesGlobalState", () => $12abd53530fa2f1e$export$cff869f7e58c9036);
$parcel$export(module.exports, "__internalSetCacheLoadedDate", () => $12abd53530fa2f1e$export$491d0e6c401a0697);
$parcel$export(module.exports, "__internalSetCdnFileVersion", () => $12abd53530fa2f1e$export$4c4bd5703eacf293);
$parcel$export(module.exports, "__internalGetDisableIndexedDbConsentChecksGlobalState", () => $12abd53530fa2f1e$export$ea32fe1e8610fd3b);

var $2W5OM = parcelRequire("2W5OM");

var $bwJVB = parcelRequire("bwJVB");
let $12abd53530fa2f1e$var$analyticsEnabledGlobalState;
let $12abd53530fa2f1e$var$productGlobalState;
let $12abd53530fa2f1e$var$perimeterGlobalState;
let $12abd53530fa2f1e$var$webStorageControlsEnabledGlobalState;
let $12abd53530fa2f1e$var$indexedDbControlsEnabledGlobalState;
let $12abd53530fa2f1e$var$disableWebStorageConsentChecksGlobalState;
let $12abd53530fa2f1e$var$localConsentModeGlobalState;
let $12abd53530fa2f1e$var$packageLogLevelGlobalState;
let $12abd53530fa2f1e$var$allowUncategorizedCookiesInOverridesGlobalState;
let $12abd53530fa2f1e$var$allowUncategorizedItemsInWebStorageOverridesGlobalState;
let $12abd53530fa2f1e$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState;
let $12abd53530fa2f1e$var$disableIndexedDbConsentChecksGlobalState;
let $12abd53530fa2f1e$var$userIdGlobalState;
let $12abd53530fa2f1e$var$cloudIdGlobalState;
let $12abd53530fa2f1e$var$hasInitialized = false;
let $12abd53530fa2f1e$var$cacheLoadedDateGlobalState;
let $12abd53530fa2f1e$var$cdnFileVersionGlobalState;
let $12abd53530fa2f1e$var$patternFormatGlobalState;
let $12abd53530fa2f1e$var$resolvedFlatPatternFileFormatGlobalState;
let $12abd53530fa2f1e$var$cookiesCacheLoader;
let $12abd53530fa2f1e$var$localStorageCacheLoader;
let $12abd53530fa2f1e$var$sessionStorageCacheLoader;
let $12abd53530fa2f1e$var$indexedDBCacheLoader;
let $12abd53530fa2f1e$var$loadCache = async (storageType)=>{
    switch(storageType){
        case (0, $2W5OM.CategoryStorageType).Cookies:
            return await $12abd53530fa2f1e$var$cookiesCacheLoader?.loadStorageControlsData();
        case (0, $2W5OM.CategoryStorageType).LocalStorage:
            return await $12abd53530fa2f1e$var$localStorageCacheLoader?.loadStorageControlsData();
        case (0, $2W5OM.CategoryStorageType).SessionStorage:
            return await $12abd53530fa2f1e$var$sessionStorageCacheLoader?.loadStorageControlsData();
        case (0, $2W5OM.CategoryStorageType).IndexedDB:
            return await $12abd53530fa2f1e$var$indexedDBCacheLoader?.loadStorageControlsData();
        default:
            return undefined;
    }
};
let $12abd53530fa2f1e$var$loadCacheMaybeSync = (storageType)=>{
    switch(storageType){
        case (0, $2W5OM.CategoryStorageType).Cookies:
            return $12abd53530fa2f1e$var$cookiesCacheLoader?.getStorageControlsDataFromCache() ?? $12abd53530fa2f1e$var$cookiesCacheLoader?.loadStorageControlsData();
        case (0, $2W5OM.CategoryStorageType).LocalStorage:
            return $12abd53530fa2f1e$var$localStorageCacheLoader?.getStorageControlsDataFromCache() ?? $12abd53530fa2f1e$var$localStorageCacheLoader?.loadStorageControlsData();
        case (0, $2W5OM.CategoryStorageType).SessionStorage:
            return $12abd53530fa2f1e$var$sessionStorageCacheLoader?.getStorageControlsDataFromCache() ?? $12abd53530fa2f1e$var$sessionStorageCacheLoader?.loadStorageControlsData();
        case (0, $2W5OM.CategoryStorageType).IndexedDB:
            return $12abd53530fa2f1e$var$indexedDBCacheLoader?.getStorageControlsDataFromCache() ?? $12abd53530fa2f1e$var$indexedDBCacheLoader?.loadStorageControlsData();
        default:
            return undefined;
    }
};
const $12abd53530fa2f1e$export$3b78a1ea01f5ec28 = ()=>{
    return {
        analyticsEnabled: $12abd53530fa2f1e$var$analyticsEnabledGlobalState ?? true,
        product: $12abd53530fa2f1e$var$productGlobalState,
        perimeter: $12abd53530fa2f1e$var$perimeterGlobalState,
        webStorageEnabled: $12abd53530fa2f1e$var$webStorageControlsEnabledGlobalState ?? false,
        indexedDbEnabled: $12abd53530fa2f1e$var$indexedDbControlsEnabledGlobalState ?? false,
        disableWebStorageConsentChecks: $12abd53530fa2f1e$var$disableWebStorageConsentChecksGlobalState ?? false,
        localConsentMode: $12abd53530fa2f1e$var$localConsentModeGlobalState ?? false,
        allowUncategorizedCookiesInOverrides: $12abd53530fa2f1e$var$allowUncategorizedCookiesInOverridesGlobalState ?? false,
        allowUncategorizedItemsInWebStorageOverrides: $12abd53530fa2f1e$var$allowUncategorizedItemsInWebStorageOverridesGlobalState ?? false,
        allowUncategorizedItemsInIndexedDBOverrides: $12abd53530fa2f1e$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState ?? false,
        disableIndexedDbConsentChecks: $12abd53530fa2f1e$var$disableIndexedDbConsentChecksGlobalState ?? false,
        packageLogLevel: $12abd53530fa2f1e$var$packageLogLevelGlobalState,
        cookiesCacheLoader: $12abd53530fa2f1e$var$cookiesCacheLoader,
        localStorageCacheLoader: $12abd53530fa2f1e$var$localStorageCacheLoader,
        sessionStorageCacheLoader: $12abd53530fa2f1e$var$sessionStorageCacheLoader,
        indexedDBCacheLoader: $12abd53530fa2f1e$var$indexedDBCacheLoader,
        loadCache: $12abd53530fa2f1e$var$loadCache,
        loadCacheMaybeSync: $12abd53530fa2f1e$var$loadCacheMaybeSync,
        hasInitialized: $12abd53530fa2f1e$var$hasInitialized,
        userId: $12abd53530fa2f1e$var$userIdGlobalState,
        cloudId: $12abd53530fa2f1e$var$cloudIdGlobalState,
        cacheLoadedDate: $12abd53530fa2f1e$var$cacheLoadedDateGlobalState,
        cdnFileVersion: $12abd53530fa2f1e$var$cdnFileVersionGlobalState,
        patternFormat: $12abd53530fa2f1e$var$patternFormatGlobalState
    };
};
const $12abd53530fa2f1e$export$f86e17381f699baf = ({ loadCache: overrideLoadCache, loadCacheMaybeSync: overrideLoadCacheMaybeSync, product: overrideProduct })=>{
    if (overrideLoadCache) $12abd53530fa2f1e$var$loadCache = overrideLoadCache;
    if (overrideLoadCacheMaybeSync) $12abd53530fa2f1e$var$loadCacheMaybeSync = overrideLoadCacheMaybeSync;
    if (overrideProduct) $12abd53530fa2f1e$var$productGlobalState = overrideProduct;
};
const $12abd53530fa2f1e$export$ac7c2edd09656c05 = ()=>{
    $12abd53530fa2f1e$var$analyticsEnabledGlobalState = undefined;
    $12abd53530fa2f1e$var$productGlobalState = undefined;
    $12abd53530fa2f1e$var$webStorageControlsEnabledGlobalState = undefined;
    $12abd53530fa2f1e$var$indexedDbControlsEnabledGlobalState = undefined;
    $12abd53530fa2f1e$var$disableWebStorageConsentChecksGlobalState = undefined;
    $12abd53530fa2f1e$var$localConsentModeGlobalState = undefined;
    $12abd53530fa2f1e$var$allowUncategorizedCookiesInOverridesGlobalState = undefined;
    $12abd53530fa2f1e$var$allowUncategorizedItemsInWebStorageOverridesGlobalState = undefined;
    $12abd53530fa2f1e$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState = undefined;
    $12abd53530fa2f1e$var$disableIndexedDbConsentChecksGlobalState = undefined;
    $12abd53530fa2f1e$var$userIdGlobalState = undefined;
    $12abd53530fa2f1e$var$cloudIdGlobalState = undefined;
    $12abd53530fa2f1e$var$packageLogLevelGlobalState = undefined;
    // Reset the resolved-log-level cache too, so a teardown that clears global state without a
    // following initializeGlobalState() can't bleed the previous request's level into the next.
    (0, $bwJVB.resetLogLevelCache)();
    $12abd53530fa2f1e$var$cookiesCacheLoader = undefined;
    $12abd53530fa2f1e$var$localStorageCacheLoader = undefined;
    $12abd53530fa2f1e$var$sessionStorageCacheLoader = undefined;
    $12abd53530fa2f1e$var$indexedDBCacheLoader = undefined;
    $12abd53530fa2f1e$var$hasInitialized = false;
    $12abd53530fa2f1e$var$cacheLoadedDateGlobalState = undefined;
    $12abd53530fa2f1e$var$cdnFileVersionGlobalState = undefined;
    $12abd53530fa2f1e$var$patternFormatGlobalState = undefined;
    $12abd53530fa2f1e$var$resolvedFlatPatternFileFormatGlobalState = undefined;
};
function $12abd53530fa2f1e$export$725ef39b428c0dc2(updates) {
    if (updates.productGlobalState !== undefined) $12abd53530fa2f1e$var$productGlobalState = updates.productGlobalState;
    if (updates.webStorageControlsEnabledGlobalState !== undefined) $12abd53530fa2f1e$var$webStorageControlsEnabledGlobalState = updates.webStorageControlsEnabledGlobalState;
    if (updates.indexedDbControlsEnabledGlobalState !== undefined) $12abd53530fa2f1e$var$indexedDbControlsEnabledGlobalState = updates.indexedDbControlsEnabledGlobalState;
    if (updates.disableWebStorageConsentChecksGlobalState !== undefined) $12abd53530fa2f1e$var$disableWebStorageConsentChecksGlobalState = updates.disableWebStorageConsentChecksGlobalState;
    if (updates.allowUncategorizedCookiesInOverridesGlobalState !== undefined) $12abd53530fa2f1e$var$allowUncategorizedCookiesInOverridesGlobalState = updates.allowUncategorizedCookiesInOverridesGlobalState;
    if (updates.allowUncategorizedItemsInWebStorageOverridesGlobalState !== undefined) $12abd53530fa2f1e$var$allowUncategorizedItemsInWebStorageOverridesGlobalState = updates.allowUncategorizedItemsInWebStorageOverridesGlobalState;
    if (updates.allowUncategorizedItemsInIndexedDBOverridesGlobalState !== undefined) $12abd53530fa2f1e$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState = updates.allowUncategorizedItemsInIndexedDBOverridesGlobalState;
    if (updates.disableIndexedDbConsentChecksGlobalState !== undefined) $12abd53530fa2f1e$var$disableIndexedDbConsentChecksGlobalState = updates.disableIndexedDbConsentChecksGlobalState;
    if (updates.localConsentModeGlobalState !== undefined) $12abd53530fa2f1e$var$localConsentModeGlobalState = updates.localConsentModeGlobalState;
    if (updates.analyticsEnabledGlobalState !== undefined) $12abd53530fa2f1e$var$analyticsEnabledGlobalState = updates.analyticsEnabledGlobalState;
    if (updates.perimeterGlobalState !== undefined) $12abd53530fa2f1e$var$perimeterGlobalState = updates.perimeterGlobalState;
    if (updates.cookiesCacheLoader !== undefined) $12abd53530fa2f1e$var$cookiesCacheLoader = updates.cookiesCacheLoader;
    if (updates.localStorageCacheLoader !== undefined) $12abd53530fa2f1e$var$localStorageCacheLoader = updates.localStorageCacheLoader;
    if (updates.sessionStorageCacheLoader !== undefined) $12abd53530fa2f1e$var$sessionStorageCacheLoader = updates.sessionStorageCacheLoader;
    if (updates.indexedDBCacheLoader !== undefined) $12abd53530fa2f1e$var$indexedDBCacheLoader = updates.indexedDBCacheLoader;
    if (updates.packageLogLevelGlobalState !== undefined) $12abd53530fa2f1e$var$packageLogLevelGlobalState = updates.packageLogLevelGlobalState;
    if (updates.hasInitialized !== undefined) $12abd53530fa2f1e$var$hasInitialized = updates.hasInitialized;
    if (updates.cloudIdGlobalState !== undefined) $12abd53530fa2f1e$var$cloudIdGlobalState = updates.cloudIdGlobalState;
    if (updates.userIdGlobalState !== undefined) $12abd53530fa2f1e$var$userIdGlobalState = updates.userIdGlobalState;
    if (updates.cdnFileVersionGlobalState !== undefined) $12abd53530fa2f1e$var$cdnFileVersionGlobalState = updates.cdnFileVersionGlobalState;
}
function $12abd53530fa2f1e$export$f9550288b9b1f6e3() {
    return $12abd53530fa2f1e$var$patternFormatGlobalState;
}
function $12abd53530fa2f1e$export$f10a7691f1fb3cb(patternFormat) {
    if ($12abd53530fa2f1e$var$patternFormatGlobalState === undefined) $12abd53530fa2f1e$var$patternFormatGlobalState = patternFormat;
}
function $12abd53530fa2f1e$export$8bf1367cc4bb66da() {
    return $12abd53530fa2f1e$var$resolvedFlatPatternFileFormatGlobalState;
}
function $12abd53530fa2f1e$export$2bd306fd2b97e710(value) {
    if ($12abd53530fa2f1e$var$resolvedFlatPatternFileFormatGlobalState === undefined) $12abd53530fa2f1e$var$resolvedFlatPatternFileFormatGlobalState = value;
}
function $12abd53530fa2f1e$export$8835d45f445e6ba4() {
    return $12abd53530fa2f1e$var$hasInitialized;
}
function $12abd53530fa2f1e$export$9dfdd17bbd03b460() {
    return $12abd53530fa2f1e$var$productGlobalState;
}
function $12abd53530fa2f1e$export$d96c3b0fb6d35c5d() {
    return $12abd53530fa2f1e$var$webStorageControlsEnabledGlobalState;
}
function $12abd53530fa2f1e$export$c8554d68c78456d3() {
    return $12abd53530fa2f1e$var$indexedDbControlsEnabledGlobalState;
}
function $12abd53530fa2f1e$export$ea650e4f51ec84d8() {
    return $12abd53530fa2f1e$var$disableWebStorageConsentChecksGlobalState;
}
function $12abd53530fa2f1e$export$fa1f6ebb49ec4b30() {
    return $12abd53530fa2f1e$var$allowUncategorizedCookiesInOverridesGlobalState;
}
function $12abd53530fa2f1e$export$b60c6437117dfaf9() {
    return $12abd53530fa2f1e$var$allowUncategorizedItemsInWebStorageOverridesGlobalState;
}
function $12abd53530fa2f1e$export$cff869f7e58c9036() {
    return $12abd53530fa2f1e$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState;
}
function $12abd53530fa2f1e$export$491d0e6c401a0697(date) {
    if ($12abd53530fa2f1e$var$cacheLoadedDateGlobalState === undefined) $12abd53530fa2f1e$var$cacheLoadedDateGlobalState = date;
}
function $12abd53530fa2f1e$export$4c4bd5703eacf293(version) {
    if ($12abd53530fa2f1e$var$cdnFileVersionGlobalState === undefined) $12abd53530fa2f1e$var$cdnFileVersionGlobalState = version;
}
function $12abd53530fa2f1e$export$ea32fe1e8610fd3b() {
    return $12abd53530fa2f1e$var$disableIndexedDbConsentChecksGlobalState;
}

});
parcelRegister("2W5OM", function(module, exports) {
$parcel$export(module.exports, "PreferenceCategory", () => $55482963df864ddc$export$ba064dbfe4bb66d7);
$parcel$export(module.exports, "ConsentPreferenceV2", () => $55482963df864ddc$export$cdef20bac194f235);
$parcel$export(module.exports, "ContextualConsentProperty", () => $55482963df864ddc$export$fac80ad19b60e313);
$parcel$export(module.exports, "PrefetchedPreferenceState", () => $55482963df864ddc$export$5d6594a0bba4ab8a);
$parcel$export(module.exports, "CategoryStorageType", () => $55482963df864ddc$export$2506b012eb637f61);
$parcel$export(module.exports, "Status", () => $55482963df864ddc$export$96e9906d6d93a972);
var $55482963df864ddc$export$ba064dbfe4bb66d7 = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
var $55482963df864ddc$export$cdef20bac194f235 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
var $55482963df864ddc$export$fac80ad19b60e313 = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
var $55482963df864ddc$export$4fda8eb914d6791c = /*#__PURE__*/ function(CachedKeysDataPropertyLegacy) {
    CachedKeysDataPropertyLegacy["LocalStorage"] = "localStorageKeys";
    CachedKeysDataPropertyLegacy["SessionStorage"] = "sessionStorageKeys";
    CachedKeysDataPropertyLegacy["Cookies"] = "keys";
    CachedKeysDataPropertyLegacy["ThirdParty"] = "thirdPartyKeys";
    return CachedKeysDataPropertyLegacy;
}({});
var $55482963df864ddc$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});
var $55482963df864ddc$export$2506b012eb637f61 = /*#__PURE__*/ function(CategoryStorageType) {
    CategoryStorageType["Cookies"] = "Cookies";
    CategoryStorageType["LocalStorage"] = "LocalStorage";
    CategoryStorageType["SessionStorage"] = "SessionStorage";
    CategoryStorageType["IndexedDB"] = "IndexedDB";
    return CategoryStorageType;
}({});
var $55482963df864ddc$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    Status["ERROR"] = "ERROR";
    return Status;
}({});
var $55482963df864ddc$export$eefdbcf75990494a = /*#__PURE__*/ function(BSC_PACKAGE_KILLSWITCHES) {
    BSC_PACKAGE_KILLSWITCHES["MASTER_KILLSWITCH"] = "platform_moonjelly_bsc_master_killswitch";
    BSC_PACKAGE_KILLSWITCHES["UI_KILLSWITCH"] = "platform_moonjelly_bsc_ui_killswitch";
    BSC_PACKAGE_KILLSWITCHES["SSR_KILLSWITCH"] = "platform_moonjelly_bsc_ssr_killswitch";
    BSC_PACKAGE_KILLSWITCHES["WEB_STORAGE_KILLSWITCH"] = "platform_moonjelly_bsc_web_storage_killswitch";
    return BSC_PACKAGE_KILLSWITCHES;
}({});

});

parcelRegister("bwJVB", function(module, exports) {
$parcel$export(module.exports, "determineLogLevel", () => $a07afcb50518ebcb$export$5461380538f47d52);
$parcel$export(module.exports, "resetLogLevelCache", () => $a07afcb50518ebcb$export$977223726df102da);

var $6yOvq = parcelRequire("6yOvq");

var $2aEiL = parcelRequire("2aEiL");

var $jeHvL = parcelRequire("jeHvL");

var $kDq5E = parcelRequire("kDq5E");
/**
 * Returns the active log level for the BSC Logger, resolved from (in order):
 * developer cookie override, consumer init param, or `DEFAULT_LOG_LEVEL`.
 *
 * The first call resolves and caches; subsequent calls return the cached
 * value. `initializeGlobalState` invalidates the cache via
 * `resetLogLevelCache()` so an init that runs after the first Logger call
 * still picks up the consumer's `packageLogLevel`.
 *
 * SSR caveat: `cachedLogLevel` is a module-level singleton, so in a shared
 * Node module cache it persists across requests. Both `initializeGlobalState`
 * and `clearGlobalState` call `resetLogLevelCache()`, so per-request init and
 * teardown keep it correct — one request's resolved level cannot leak into the
 * next.
 */ let $a07afcb50518ebcb$var$cachedLogLevel;
const $a07afcb50518ebcb$export$5461380538f47d52 = ()=>{
    if ($a07afcb50518ebcb$var$cachedLogLevel !== undefined) return $a07afcb50518ebcb$var$cachedLogLevel;
    $a07afcb50518ebcb$var$cachedLogLevel = $a07afcb50518ebcb$var$readDebugCookieOverride() ?? $a07afcb50518ebcb$var$readInitParamLogLevel() ?? (0, $kDq5E.DEFAULT_LOG_LEVEL);
    return $a07afcb50518ebcb$var$cachedLogLevel;
};
const $a07afcb50518ebcb$export$977223726df102da = ()=>{
    $a07afcb50518ebcb$var$cachedLogLevel = undefined;
};
/**
 * Returns `LogLevel.DEBUG` when the dev override is active (cookie set AND
 * the safety-net FF is enabled), else `null`. The FF gate lets us remotely
 * disable the cookie path if it ever misbehaves.
 *
 * The cookie is checked BEFORE the feature gate on purpose: `fg` is only ever
 * evaluated when the (rare, dev-only) `atl-bsc-debug-mode` cookie is present.
 * This keeps `Logger.*` calls — including ones that run at module-load time
 * (e.g. the AtlIndexedDb singleton) — from calling `fg` during a plain import.
 * Otherwise importing BSC crashes any consumer whose test mocks `fg` with a
 * not-yet-initialized factory variable ("Cannot access 'mockFg' before
 * initialization").
 */ const $a07afcb50518ebcb$var$readDebugCookieOverride = ()=>{
    let debugCookieSet = false;
    try {
        debugCookieSet = (0, $6yOvq.default).get('atl-bsc-debug-mode') === 'true';
    } catch  {
        // Cookie access can throw in sandboxed iframes / strict cookie policies.
        return null;
    }
    if (!debugCookieSet) return null;
    return (0, $2aEiL.fg)('platform_moonjelly_bsc_debug_mode') ? (0, $kDq5E.LogLevel).DEBUG : null;
};
/**
 * Returns the LogLevel corresponding to the consumer's `packageLogLevel` init
 * param, or `null` if unset or unrecognized.
 */ const $a07afcb50518ebcb$var$readInitParamLogLevel = ()=>{
    return (0, $kDq5E.packageLogLevelStringToEnum)((0, $jeHvL.getBscGlobalState)().packageLogLevel);
};

});
parcelRegister("kDq5E", function(module, exports) {
$parcel$export(module.exports, "LogLevel", () => $3574737933c084ff$export$243e62d78d3b544d);
$parcel$export(module.exports, "DEFAULT_LOG_LEVEL", () => $3574737933c084ff$export$97d4c6871900dcac);
$parcel$export(module.exports, "packageLogLevelStringToEnum", () => $3574737933c084ff$export$6b31b02af0747fdf);
/**
 * Internal numeric log level. Higher = more verbose; a Logger method fires
 * when the resolved level is `>=` its own. Not exported from the package's
 * public entry — consumers use `PackageLogLevel` instead.
 */ var $3574737933c084ff$export$243e62d78d3b544d = /*#__PURE__*/ function(LogLevel) {
    LogLevel[LogLevel["SILENT"] = 0] = "SILENT";
    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
    LogLevel[LogLevel["WARN"] = 2] = "WARN";
    LogLevel[LogLevel["INFO"] = 3] = "INFO";
    LogLevel[LogLevel["DEBUG"] = 4] = "DEBUG";
    return LogLevel;
}({});
const $3574737933c084ff$export$97d4c6871900dcac = 1;
const $3574737933c084ff$var$PACKAGE_LOG_LEVEL_BY_STRING = {
    silent: 0,
    error: 1,
    warn: 2,
    info: 3,
    debug: 4
};
const $3574737933c084ff$export$6b31b02af0747fdf = (value)=>{
    if (value === undefined) return null;
    return $3574737933c084ff$var$PACKAGE_LOG_LEVEL_BY_STRING[value] ?? null;
};

});



parcelRegister("hDU2p", function(module, exports) {
$parcel$export(module.exports, "LOG_PREFIX", () => $6f37f4e2602467c2$export$5e28bf885ebebfa6);
$parcel$export(module.exports, "ERROR_EVENT_THROTTLE_INTERVAL_MS", () => $6f37f4e2602467c2$export$aeb1f5aa1188ce28);
$parcel$export(module.exports, "ERROR_EVENT_MAX_PER_SESSION", () => $6f37f4e2602467c2$export$ee3d07c2528881e2);
const $6f37f4e2602467c2$export$5e28bf885ebebfa6 = '[browser-storage-controls]';
const $6f37f4e2602467c2$export$aeb1f5aa1188ce28 = 5000; // min gap between sends of the same action
const $6f37f4e2602467c2$export$ee3d07c2528881e2 = 10; // hard cap per action per page load

});

parcelRegister("3Tj3s", function(module, exports) {
$parcel$export(module.exports, "packageName", () => $87aed303a1b1e5fe$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $87aed303a1b1e5fe$export$91546b032799aa40);
const $87aed303a1b1e5fe$export$9345d7360ffe0722 = undefined ?? '';
const $87aed303a1b1e5fe$export$91546b032799aa40 = undefined ?? '';

});

parcelRegister("36AKy", function(module, exports) {
$parcel$export(module.exports, "packageName", () => $edb726dec92d8e0c$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $edb726dec92d8e0c$export$91546b032799aa40);
// eslint-disable-next-line import/no-extraneous-dependencies

var $hiruf = parcelRequire("hiruf");
const $edb726dec92d8e0c$export$9345d7360ffe0722 = (0, (/*@__PURE__*/$parcel$interopDefault($hiruf))).name;
const $edb726dec92d8e0c$export$91546b032799aa40 = (0, (/*@__PURE__*/$parcel$interopDefault($hiruf))).version;

});
parcelRegister("hiruf", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"@atlassian/browser-storage-controls\",\"version\":\"11.5.4\",\"description\":\"Package containing utilities and components for collecting and enforcing user preferences on atlassian browser storage (cookies,localstorage, indexedDB etc.)\",\"publishConfig\":{\"registry\":\"https://packages.atlassian.com/api/npm/npm-remote\"},\"repository\":\"https://bitbucket.org/atlassian/atlassian-frontend-monorepo\",\"author\":\"Atlassian Pty Ltd\",\"main\":\"dist/cjs/index.js\",\"module\":\"dist/esm/index.js\",\"module:es2019\":\"dist/es2019/index.js\",\"types\":\"dist/types/index.d.ts\",\"sideEffects\":[\"*.compiled.css\"],\"atlaskit:src\":\"src/index.ts\",\"atlassian\":{\"team\":\"trust-privacy-controls-eng-team\",\"i18n\":true},\"scripts\":{\"webpack-build\":\"NODE_OPTIONS=--max-old-space-size=4096 webpack --env NODE_ENV=production --env prod --progress --config config/webpack.prod.js\",\"ak-postbuild\":\"NODE_OPTIONS=--max-old-space-size=4096 webpack --env NODE_ENV=production --env prod --progress --config config/webpack.prod.js && cp package.json dist/package.json\",\"test\":\"node -r esbuild-register build/ci/test-pipeline/scripts/run-test.ts -c packages/policy-platform/browser-storage-controls/jest.config.js\"},\"dependencies\":{\"@atlaskit/atlassian-context\":\"workspace:^\",\"@atlaskit/button\":\"workspace:^\",\"@atlaskit/checkbox\":\"workspace:^\",\"@atlaskit/feature-gate-js-client\":\"workspace:^\",\"@atlaskit/flag\":\"workspace:^\",\"@atlaskit/form\":\"workspace:^\",\"@atlaskit/heading\":\"workspace:^\",\"@atlaskit/icon\":\"workspace:^\",\"@atlaskit/intl-messages-provider\":\"workspace:^\",\"@atlaskit/modal-dialog\":\"workspace:^\",\"@atlaskit/platform-feature-flags\":\"workspace:^\",\"@atlaskit/primitives\":\"workspace:^\",\"@atlaskit/react-ufo\":\"workspace:^\",\"@atlaskit/tokens\":\"workspace:^\",\"@atlaskit/tooltip\":\"workspace:^\",\"@atlassian/afm-i18n-platform-policy-platform-browser-storage-controls\":\"root:*\",\"@atlassian/atl-context\":\"workspace:^\",\"@atlassian/ufo\":\"workspace:^\",\"@atlassian/ufo-experimental\":\"workspace:^\",\"@atlassiansox/analytics-web-client\":\"workspace:^\",\"@atlassiansox/frontend-feature-encoding\":\"root:*\",\"@babel/runtime\":\"root:*\",\"bind-event-listener\":\"root:*\",\"js-cookie\":\"root:*\",\"react-error-boundary\":\"root:*\",\"react-magnetic-di\":\"root:*\"},\"peerDependencies\":{\"react\":\"^18.2.0\",\"react-dom\":\"^18.2.0\",\"react-intl\":\"^5.25.1 || ^6.0.0 || ^7.0.0\"},\"devDependencies\":{\"@af/integration-testing\":\"workspace:^\",\"@af/visual-regression\":\"workspace:^\",\"@atlaskit/code\":\"workspace:^\",\"@atlaskit/css\":\"workspace:^\",\"@atlaskit/docs\":\"workspace:^\",\"@atlaskit/ssr\":\"workspace:^\",\"@atlaskit/toggle\":\"workspace:^\",\"@atlassian/feature-flags-storybook-utils\":\"workspace:^\",\"@atlassian/feature-flags-test-utils\":\"workspace:^\",\"@atlassian/multi-entry-tools\":\"workspace:^\",\"@atlassian/platform-storybook-helpers\":\"workspace:^\",\"@atlassian/testing-library\":\"workspace:^\",\"@babel/preset-typescript\":\"root:*\",\"@storybook/addon-actions\":\"root:*\",\"@storybook/test\":\"root:*\",\"@testing-library/react\":\"root:*\",\"@testing-library/user-event\":\"root:*\",\"@types/node\":\"root:*\",\"fake-indexeddb\":\"root:*\",\"fetch-mock\":\"root:*\",\"react\":\"root:*\",\"react-dom\":\"root:*\",\"react-intl\":\"root:*\",\"webpack-cli\":\"root:*\"},\"exports\":{\".\":\"./src/index.ts\",\"./banner-controls\":\"./src/controllers/banner-controls/index.ts\",\"./consent-banner\":\"./src/ui/consent-banner/index.tsx\",\"./consent-banner/preference-modal\":\"./src/ui/consent-banner/preference-modal/index.tsx\",\"./constants\":\"./src/constants.ts\",\"./controllers/banner-controls/get-banner-visibility\":\"./src/controllers/banner-controls/get-banner-visibility/index.ts\",\"./controllers/banner-controls/should-banner-render-prefetched\":\"./src/controllers/banner-controls/should-banner-render-prefetched/index.ts\",\"./controllers/banner-controls/should-banner-render\":\"./src/controllers/banner-controls/should-banner-render/index.ts\",\"./controllers/banner-controls/types\":\"./src/controllers/banner-controls/types.ts\",\"./controllers/cookie-controls/delete-cookie\":\"./src/controllers/cookie-controls/delete-cookie/index.ts\",\"./controllers/cookie-controls/get-cookie\":\"./src/controllers/cookie-controls/get-cookie/index.ts\",\"./controllers/cookie-controls/initialize-controls\":\"./src/controllers/cookie-controls/initialize-controls/index.ts\",\"./controllers/cookie-controls/set-cookie\":\"./src/controllers/cookie-controls/set-cookie/index.ts\",\"./controllers/cookie-controls/set-cookie/types\":\"./src/controllers/cookie-controls/set-cookie/types.ts\",\"./controllers/cookie-controls/set-strictly-necessary-cookie\":\"./src/controllers/cookie-controls/set-strictly-necessary-cookie/index.ts\",\"./controllers/cookie-controls/transformer\":\"./src/controllers/cookie-controls/transformer/index.ts\",\"./controllers/preferences-controls/get-preferences\":\"./src/controllers/preferences-controls/get-preferences/index.ts\",\"./controllers/third-party-controls/check-third-party\":\"./src/controllers/third-party-controls/check-third-party/index.ts\",\"./cookie-controls\":\"./src/controllers/cookie-controls/index.ts\",\"./core\":\"./src/common/utils/bsc-global-state/core.ts\",\"./consent-hub-service/types\":\"./src/services/consent-hub-service/types.ts\",\"./consent-hub-service/utils\":\"./src/services/consent-hub-service/utils.ts\",\"./i18n/*\":{\"publish\":null,\"default\":\"./src/i18n/*.ts\"},\"./indexed-db-wrapper-service\":\"./src/services/indexed-db-wrapper-service/index.ts\",\"./indexed-db-wrapper-service/types\":\"./src/services/indexed-db-wrapper-service/types.ts\",\"./types\":\"./src/types.ts\",\"./utils/item-processing\":\"./src/common/utils/item-processing/index.ts\",\"./utils/load-storage-controls-data/constants\":\"./src/common/utils/load-storage-controls-data/constants.ts\",\"./web-storage-service\":\"./src/services/web-storage-service/index.ts\",\"./web-storage-service/types\":\"./src/services/web-storage-service/types.ts\"},\"platform-feature-flags\":{\"platform_bsc_auto_detect_perimeter\":{\"type\":\"boolean\"},\"platform.moonjelly.block-unknown-cookies\":{\"type\":\"boolean\"},\"platform_moonjelly_bsc_ssr_killswitch\":{\"type\":\"boolean\"},\"platform_moonjelly_bsc_ui_killswitch\":{\"type\":\"boolean\"},\"platform_moonjelly_bsc_master_killswitch\":{\"type\":\"boolean\"},\"platform_moonjelly_bsc_debug_mode\":{\"type\":\"boolean\"},\"platform_moonjelly_bsc_web_storage_killswitch\":{\"type\":\"boolean\"},\"product-terminology-refresh\":{\"type\":\"boolean\"},\"platform_remove_bsc_overrides\":{\"type\":\"boolean\"},\"platform_bsc_ssr_flat_pattern_file_format\":{\"type\":\"boolean\"},\"platform_bsc_longest_pattern_match_wins\":{\"type\":\"boolean\"},\"platform_bsc_flat_lookup_skip_merge\":{\"type\":\"boolean\"},\"platform_bsc_cleanup_revoked_storage_live_delete\":{\"type\":\"boolean\"},\"platform_bsc_consent_hub_x_origin_app_normalized\":{\"type\":\"boolean\"},\"platform_bsc_consent_bypass_analytics\":{\"type\":\"boolean\"},\"platform_bsc_sync_initialize_controls\":{\"type\":\"boolean\"},\"platform_bsc_use_generated_package_info\":{\"type\":\"boolean\"},\"platform_bsc_add_cdn_file_version_in_events\":{\"type\":\"boolean\"}}}");

});


parcelRegister("h4Fd6", function(module, exports) {
$parcel$export(module.exports, "withAnalyticsEventSampling", () => $54092f12bef1ca09$export$67b6e87f323cb6ad);

var $2W5OM = parcelRequire("2W5OM");

var $jeHvL = parcelRequire("jeHvL");

var $bHi4N = parcelRequire("bHi4N");

var $dS1lP = parcelRequire("dS1lP");
const $54092f12bef1ca09$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1,
    usedAtlBrowserStorageGetItem: 1000,
    usedAtlBrowserStorageGetItemError: 1,
    usedAtlBrowserStorageSetItem: 100,
    usedAtlBrowserStorageSetItemError: 1,
    usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
    usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
    indexDbSetRecordError: 1,
    renderConsentBannerError: 1,
    bannerAppearanceAfterDismissal: 1,
    usedAtlIndexedDBOpen: 100,
    usedAtlIndexedDBOpenError: 1,
    usedAtlIndexedDBOpenStrictlyNecessary: 100,
    usedAtlIndexedDBOpenStrictlyNecessaryError: 1,
    bscInitControlsParameters: 1000,
    setItemWithoutInit: 1000,
    uncategorizedWebStorageItemSet: 100,
    browserExtensionKeysAllowed: 100,
    storageCleanupCategorized: 100,
    storageCleanupDeleted: 100,
    storageCleanupError: 1,
    detectPerimeterError: 1,
    usedAtlBrowserStorageSetItemBscDisabled: 100,
    usedSetCookieMasterKillswitch: 100,
    cookieConsentPreferences: 1,
    cookieConsentModal: 1,
    cookieConsentBanner: 1,
    preferences: 1,
    onlyNecessary: 1,
    acceptAll: 1,
    cookiesTrackingNotice: 1,
    confirm: 1,
    performanceConsent: 1,
    functionalConsent: 1,
    targetingConsent: 1,
    cancel: 1,
    close: 1,
    background: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
const $54092f12bef1ca09$var$localOnlySamplingKeys = [
    'loadStorageControlsError'
];
async function $54092f12bef1ca09$var$loadSamplingConfig() {
    if ((0, $bHi4N.cache).cachedSamplingConfig) return (0, $bHi4N.cache).cachedSamplingConfig;
    if ((0, $dS1lP.isSSR)()) return undefined;
    const { loadCache: loadCache } = (0, $jeHvL.getBscGlobalState)();
    const controlsData = await loadCache((0, $2W5OM.CategoryStorageType).Cookies);
    const analyticsSamplingRatioConfigs = controlsData?.analyticsSamplingRatio;
    (0, $bHi4N.cache).cachedSamplingConfig = analyticsSamplingRatioConfigs;
    return analyticsSamplingRatioConfigs;
}
async function $54092f12bef1ca09$export$b286f5e8716d11ad(analyticsEventKey) {
    if ($54092f12bef1ca09$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $54092f12bef1ca09$export$1138592b3c099377[analyticsEventKey];
    const remoteSamplingConfig = await $54092f12bef1ca09$var$loadSamplingConfig();
    const samplingConfig = remoteSamplingConfig ?? $54092f12bef1ca09$export$1138592b3c099377;
    const samplingRatio = samplingConfig?.[analyticsEventKey] !== undefined ? samplingConfig[analyticsEventKey] : $54092f12bef1ca09$export$1138592b3c099377[analyticsEventKey];
    return samplingRatio;
}
function $54092f12bef1ca09$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
        ________
       /\       \
      /()\   ()  \
     /    \_______\
     \    /()     /
      \()/   ()  /
       \/_____()/
   */ const shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
async function $54092f12bef1ca09$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
    const ratio = await $54092f12bef1ca09$export$b286f5e8716d11ad(analyticsEventKey);
    $54092f12bef1ca09$export$dc2f0946255b3f89(ratio, cb);
}

});
parcelRegister("bHi4N", function(module, exports) {
$parcel$export(module.exports, "cache", () => $82b98c816b467d71$export$69a3209f1a06c04d);

var $TDqoV = parcelRequire("TDqoV");
const $82b98c816b467d71$export$69a3209f1a06c04d = new (0, $TDqoV.CachedSamplingConfig)();

});
parcelRegister("TDqoV", function(module, exports) {
$parcel$export(module.exports, "CachedSamplingConfig", () => $96d7295b8fe60ffd$export$b886edaf6623554a);
class $96d7295b8fe60ffd$export$b886edaf6623554a {
    cache;
    get cachedSamplingConfig() {
        return this.cache;
    }
    set cachedSamplingConfig(value) {
        this.cache = value;
    }
}

});


parcelRegister("dS1lP", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $281cf2428eba4b45$export$48d7c418edadb60c);

var $jcoDC = parcelRequire("jcoDC");

var $2aEiL = parcelRequire("2aEiL");
const $281cf2428eba4b45$export$48d7c418edadb60c = ()=>{
    const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
    const isMissingBooleanFF = !(0, $2aEiL.fg);
    const isMissingAnalyticsWebClient = !Boolean((0, $jcoDC.default));
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};

});



parcelRegister("bEUFb", function(module, exports) {
$parcel$export(module.exports, "Logger", () => $af55bfd2cef1b264$export$efa9a398d6368992);
/* eslint-disable no-console */ 
var $7WT4C = parcelRequire("7WT4C");

var $hDU2p = parcelRequire("hDU2p");

var $bwJVB = parcelRequire("bwJVB");

var $8VkkR = parcelRequire("8VkkR");

var $kDq5E = parcelRequire("kDq5E");
const $af55bfd2cef1b264$var$formatMetadata = (metadata)=>{
    if (!metadata) return '';
    // `LoggingMetadata` allows a bare string; emit it as-is rather than running it
    // through JSON.stringify, which would wrap it in extra quotes ("error-code" -> '"error-code"').
    return typeof metadata === 'string' ? metadata : JSON.stringify(metadata);
};
class $af55bfd2cef1b264$export$efa9a398d6368992 {
    // Console output is controlled solely by the resolved log level. `DEFAULT_LOG_LEVEL` is ERROR,
    // so info/warn/debug stay silent unless a consumer raises `packageLogLevel` or a developer sets
    // the `atl-bsc-debug-mode` cookie. ERROR output is intentionally always on.
    //
    // Keep these guards free of `fg` calls: `Logger.*` runs at module-load time in some consumers
    // (e.g. the AtlIndexedDb singleton), and evaluating a feature gate during a plain import breaks
    // consumers whose tests mock `fg` with a not-yet-initialized factory variable. The one gate this
    // path can still reach is handled in determine-log-level.ts, which checks its cookie first.
    static info(message, metadata) {
        if ((0, $bwJVB.determineLogLevel)() >= (0, $kDq5E.LogLevel).INFO) console.info(`${(0, $hDU2p.LOG_PREFIX)}: ${message}`, $af55bfd2cef1b264$var$formatMetadata(metadata));
    }
    static warn(message, metadata) {
        if ((0, $bwJVB.determineLogLevel)() >= (0, $kDq5E.LogLevel).WARN) console.warn(`${(0, $hDU2p.LOG_PREFIX)}: ${message}`, $af55bfd2cef1b264$var$formatMetadata(metadata));
    }
    static error(message, metadata) {
        if ((0, $bwJVB.determineLogLevel)() >= (0, $kDq5E.LogLevel).ERROR) console.error(`${(0, $hDU2p.LOG_PREFIX)}: ${message}`, $af55bfd2cef1b264$var$formatMetadata(metadata));
    }
    static debug(message, metadata) {
        if ((0, $bwJVB.determineLogLevel)() >= (0, $kDq5E.LogLevel).DEBUG) console.debug(`${(0, $hDU2p.LOG_PREFIX)}: DEBUG ${message}`, $af55bfd2cef1b264$var$formatMetadata(metadata));
    }
    /**
   * Sends an unsampled operational event to backend telemetry and also emits the message via
   * `Logger.error`. The telemetry send is throttled per-action (see error-event-throttle). The
   * console output is always at ERROR level (subject to the resolved log level).
   */ static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
        try {
            // shouldSendErrorEvent records the send and limits per-action volume, so a repeatedly
            // failing call site cannot flood telemetry with duplicate events.
            if ((0, $8VkkR.shouldSendErrorEvent)(action)) (0, $7WT4C.sendUnsampledPackageOperationalEvent)({
                action: action,
                attributes: {
                    error: message,
                    ...attributes
                }
            });
        } catch (e) {
            this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
        }
        this.error(message, metadata);
    }
}

});
parcelRegister("8VkkR", function(module, exports) {
$parcel$export(module.exports, "shouldSendErrorEvent", () => $28311beab73b7c0c$export$e54335114720f029);

var $hDU2p = parcelRequire("hDU2p");
// Per-process (per page load) throttle state, keyed by operational event action.
// Resets naturally on page reload because module state is re-initialised, which gives
// us the "per session" semantic for free (same pattern as bsc-global-state).
const $28311beab73b7c0c$var$throttleState = new Map();
function $28311beab73b7c0c$export$e54335114720f029(action) {
    const now = Date.now();
    const entry = $28311beab73b7c0c$var$throttleState.get(action);
    if (!entry) {
        // First occurrence of this action this session always sends.
        $28311beab73b7c0c$var$throttleState.set(action, {
            lastSentAt: now,
            sentCount: 1
        });
        return true;
    }
    if (entry.sentCount >= (0, $hDU2p.ERROR_EVENT_MAX_PER_SESSION)) // Hard per-session cap reached — drop regardless of elapsed time.
    return false;
    if (now - entry.lastSentAt < (0, $hDU2p.ERROR_EVENT_THROTTLE_INTERVAL_MS)) // Within the cooldown window since the last send for this action.
    return false;
    entry.lastSentAt = now;
    entry.sentCount += 1;
    return true;
}
function $28311beab73b7c0c$export$a5ff37ede5ff9625() {
    $28311beab73b7c0c$var$throttleState.clear();
}

});



parcelRegister("1Y0UN", function(module, exports) {
$parcel$export(module.exports, "setCookie", () => $02ae1ab24543d2e0$export$110700823644f4a6);

var $6yOvq = parcelRequire("6yOvq");

var $2aEiL = parcelRequire("2aEiL");

var $jeHvL = parcelRequire("jeHvL");
var $7WT4C = parcelRequire("7WT4C");

var $7vtyD = parcelRequire("7vtyD");

var $bEUFb = parcelRequire("bEUFb");

var $2W5OM = parcelRequire("2W5OM");
const $02ae1ab24543d2e0$export$110700823644f4a6 = async (key, value, attributes)=>{
    if ((0, $2aEiL.fg)('platform_moonjelly_bsc_master_killswitch')) {
        // Set the cookie without checking user preferences when master killswitch is enabled.
        // Emit analytics so we can quantify how often the killswitch path is taken per product
        if ((0, $2aEiL.fg)('platform_bsc_consent_bypass_analytics')) (0, $7WT4C.sendPackageOperationalEvent)({
            action: 'usedSetCookieMasterKillswitch',
            attributes: {
                cookieKey: key,
                product: (0, $jeHvL.getBscGlobalState)().product
            }
        });
        (0, $6yOvq.default).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
        return (0, $2W5OM.Status).SUCCESS;
    }
    // user belongs to an org that opted into cookies management and we should respect their preferences
    const productName = (0, $jeHvL.getBscGlobalState)().product;
    const wasInitialized = (0, $jeHvL.getBscGlobalState)().hasInitialized;
    // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
    let blockedCookieItemCategory;
    const shouldSetCookie = await (0, $7vtyD.isProcessingAllowedByPreferences)({
        itemKey: key,
        storageType: (0, $2W5OM.CategoryStorageType).Cookies,
        productName: productName,
        blockedCallback: ({ itemCategory: itemCategory })=>{
            blockedCookieItemCategory = itemCategory;
        }
    });
    const eventAttributes = {
        wasRejected: !shouldSetCookie,
        cookieKey: key
    };
    try {
        (0, $7WT4C.sendPackageOperationalEvent)({
            action: 'usedSetCookie',
            attributes: eventAttributes
        });
        if (!wasInitialized) (0, $7WT4C.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: 'Cookie'
            }
        });
        if (shouldSetCookie) {
            (0, $6yOvq.default).set(key, value, {
                ...attributes,
                'atl-set-cookie': true
            });
            return (0, $2W5OM.Status).SUCCESS;
        } else {
            if (blockedCookieItemCategory === null) (0, $bEUFb.Logger).warn(`setCookie('${key}', ...) was blocked` + `${productName ? ` for product "${productName}"` : ''}` + `: '${key}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
            return (0, $2W5OM.Status).BLOCKED;
        }
    } catch (e) {
        (0, $bEUFb.Logger).errorWithOperationalEvent({
            action: 'usedSetCookieError',
            attributes: eventAttributes,
            message: `Failed to use set cookie. ${e.message || ''}`
        });
        throw e;
    }
};

});
parcelRegister("7vtyD", function(module, exports) {
$parcel$export(module.exports, "getItemCategoryFromPassedCache", () => $0c7f9607cdd2e297$export$69d5b68d01f4a366);
$parcel$export(module.exports, "getItemCategory", () => $0c7f9607cdd2e297$export$ec8ce5237293e4a4);
$parcel$export(module.exports, "isPromise", () => $0c7f9607cdd2e297$export$4369c812aac99591);
$parcel$export(module.exports, "isProcessingAllowedByPreferencesMaybeSync", () => $0c7f9607cdd2e297$export$ffbb879d3fefb45c);
$parcel$export(module.exports, "isProcessingAllowedByPreferences", () => $0c7f9607cdd2e297$export$e7a3dca206fec6e2);
$parcel$export(module.exports, "isProcessingAllowedByPreferencesWithCategory", () => $0c7f9607cdd2e297$export$17e4a7e00d5b99d9);

var $2aEiL = parcelRequire("2aEiL");

var $hEEEo = parcelRequire("hEEEo");

var $2W5OM = parcelRequire("2W5OM");

var $7WT4C = parcelRequire("7WT4C");

var $jeHvL = parcelRequire("jeHvL");

var $hORic = parcelRequire("hORic");

var $bEUFb = parcelRequire("bEUFb");
/**
 * Narrows a payload to the layout it declares, so the matchers below can be type-checked against a
 * concrete pattern shape rather than casting.
 *
 * An absent `patternFormat` means the legacy trie layout — the format the CDN serves while the
 * flat-format gate is off, and what a payload fetched by a consumer that predates COOK-632 will be.
 * TypeScript cannot infer that rule, so this is the one place it is asserted.
 */ const $0c7f9607cdd2e297$var$asConcreteCache = (storageControlsData)=>storageControlsData.patternFormat === 'flat' ? storageControlsData : storageControlsData;
/**
 * WeakMap cache for precompiled RegExp objects, keyed by the raw regExp product map.
 * This ensures RegExp strings are compiled at most once per unique cache object.
 */ const $0c7f9607cdd2e297$var$compiledRegExpCache = new WeakMap();
const $0c7f9607cdd2e297$var$compileRegExpPatterns = (rawPatterns)=>{
    if ($0c7f9607cdd2e297$var$compiledRegExpCache.has(rawPatterns)) return $0c7f9607cdd2e297$var$compiledRegExpCache.get(rawPatterns);
    const compiled = [];
    for (const [regexString, category] of Object.entries(rawPatterns))try {
        compiled.push({
            regexp: new RegExp(regexString),
            category: category
        });
    } catch (e) {
        (0, $bEUFb.Logger).warn(`BSC: Invalid RegExp pattern "${regexString}" in storage controls cache \u{2014} skipping.`);
    }
    $0c7f9607cdd2e297$var$compiledRegExpCache.set(rawPatterns, compiled);
    return compiled;
};
const $0c7f9607cdd2e297$export$2c141b1c00f3e482 = (itemKey, startsWith)=>{
    // Setup initial pattern step and position
    let currentStep = startsWith;
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        // The value of item character at the position
        const currentStepValue = currentStep[itemKey[position]];
        // If there is no match for item symbol in cache, this means there is no
        // pattern match for the item key
        if (currentStepValue === undefined) return null;
        // If current step value is a number, this means we reached the end of the pattern
        // and should return category number
        if (typeof currentStepValue === 'number') return currentStepValue;
        // Continue to going through pattern
        currentStep = currentStepValue;
        position++;
    }
    // No pattern match - all patterns longer or shorter than item key
    return null;
};
const $0c7f9607cdd2e297$export$81a82818a800a999 = (itemKey, compiledPatterns)=>{
    for (const { regexp: regexp, category: category } of compiledPatterns){
        if (regexp.test(itemKey)) return category;
    }
    return null;
};
const $0c7f9607cdd2e297$export$c4a1dd71bbd8954c = (itemKey, endsWith)=>{
    // Return category number if str is found in the trie, otherwise return undefined
    const trieSearch = (str)=>{
        let currentStep = endsWith;
        let foundString = '';
        let terminalNumber;
        for(let i = 0; i < str.length; i++){
            const char = str[i];
            currentStep = currentStep[char];
            if (currentStep === undefined) break;
            foundString += char;
            if (typeof currentStep === 'number') {
                terminalNumber = currentStep;
                break;
            }
        }
        if (foundString === str) // Trie contained the complete string
        return terminalNumber;
        else // Trie did not contain the complete string
        return undefined;
    };
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        const remainderMatch = trieSearch(itemKey.slice(position));
        if (remainderMatch !== undefined) return remainderMatch;
        position++;
    }
    return null;
};
const $0c7f9607cdd2e297$export$915dea35caff63c = (itemKey, startsWith)=>{
    for (const prefix of Object.keys(startsWith)){
        if (itemKey.startsWith(prefix)) return startsWith[prefix];
    }
    return null;
};
const $0c7f9607cdd2e297$export$4381be1b9fd38456 = (itemKey, startsWith)=>{
    let best = null;
    for (const prefix of Object.keys(startsWith)){
        if (itemKey.startsWith(prefix)) {
            if (best === null || prefix.length > best.length) best = {
                category: startsWith[prefix],
                length: prefix.length
            };
        }
    }
    return best;
};
const $0c7f9607cdd2e297$export$495f1917e0bfb98c = (itemKey, endsWith)=>{
    let best = null;
    for (const suffix of Object.keys(endsWith)){
        if (itemKey.endsWith(suffix)) {
            if (best === null || suffix.length > best.length) best = {
                category: endsWith[suffix],
                length: suffix.length
            };
        }
    }
    return best;
};
const $0c7f9607cdd2e297$export$f6f7882079c4a2cb = (itemKey, endsWith)=>{
    for (const suffix of Object.keys(endsWith)){
        if (itemKey.endsWith(suffix)) return endsWith[suffix];
    }
    return null;
};
const $0c7f9607cdd2e297$var$hasOwn = (map, key)=>map !== undefined && Object.prototype.hasOwnProperty.call(map, key);
/**
 * Picks the longer of a product and an 'all' pattern match. A tie can only be the same pattern in
 * both maps (two distinct prefixes or suffixes of equal length cannot both match one key), and the
 * product entry wins it — the value a merge of the two maps would have produced.
 */ const $0c7f9607cdd2e297$var$pickLongerMatch = (productMatch, allMatch)=>{
    if (productMatch === null) return allMatch;
    if (allMatch === null || productMatch.length >= allMatch.length) return productMatch;
    return allMatch;
};
/**
 * Resolves an item key's category number from a flat payload without merging the 'all' and
 * product maps. Merging allocated four objects per lookup, and the merged regexp object was new
 * every call so `compiledRegExpCache` never hit. Each stage checks the product map before 'all',
 * matching the precedence of the legacy trie path.
 */ const $0c7f9607cdd2e297$var$findFlatItemCategoryNumber = (itemKey, cache, product)=>{
    const { keys: keys, patterns: patterns } = cache;
    const productKeys = product ? keys[product] : undefined;
    if ($0c7f9607cdd2e297$var$hasOwn(productKeys, itemKey)) return productKeys[itemKey];
    const allKeys = keys['all'];
    if ($0c7f9607cdd2e297$var$hasOwn(allKeys, itemKey)) return allKeys[itemKey];
    const productStartsWith = product ? patterns.startsWith[product] : undefined;
    const allStartsWith = patterns.startsWith['all'];
    const productEndsWith = product ? patterns.endsWith[product] : undefined;
    const allEndsWith = patterns.endsWith['all'];
    if ((0, $2aEiL.fg)('platform_bsc_longest_pattern_match_wins')) {
        const swMatch = $0c7f9607cdd2e297$var$pickLongerMatch(productStartsWith ? $0c7f9607cdd2e297$export$4381be1b9fd38456(itemKey, productStartsWith) : null, allStartsWith ? $0c7f9607cdd2e297$export$4381be1b9fd38456(itemKey, allStartsWith) : null);
        if (swMatch !== null) return swMatch.category;
        const ewMatch = $0c7f9607cdd2e297$var$pickLongerMatch(productEndsWith ? $0c7f9607cdd2e297$export$495f1917e0bfb98c(itemKey, productEndsWith) : null, allEndsWith ? $0c7f9607cdd2e297$export$495f1917e0bfb98c(itemKey, allEndsWith) : null);
        if (ewMatch !== null) return ewMatch.category;
    } else {
        // Compare against null, not truthiness: category 0 (strictly necessary) is a valid match.
        if (productStartsWith) {
            const match = $0c7f9607cdd2e297$export$915dea35caff63c(itemKey, productStartsWith);
            if (match !== null) return match;
        }
        if (allStartsWith) {
            const match = $0c7f9607cdd2e297$export$915dea35caff63c(itemKey, allStartsWith);
            if (match !== null) return match;
        }
        if (productEndsWith) {
            const match = $0c7f9607cdd2e297$export$f6f7882079c4a2cb(itemKey, productEndsWith);
            if (match !== null) return match;
        }
        if (allEndsWith) {
            const match = $0c7f9607cdd2e297$export$f6f7882079c4a2cb(itemKey, allEndsWith);
            if (match !== null) return match;
        }
    }
    // The payload's own regexp maps are stable objects, so the WeakMap compile cache hits.
    const productRegExp = product ? patterns.regexp?.[product] : undefined;
    if (productRegExp) {
        const match = $0c7f9607cdd2e297$export$81a82818a800a999(itemKey, $0c7f9607cdd2e297$var$compileRegExpPatterns(productRegExp));
        if (match !== null) return match;
    }
    const allRegExp = patterns.regexp?.['all'];
    if (allRegExp) return $0c7f9607cdd2e297$export$81a82818a800a999(itemKey, $0c7f9607cdd2e297$var$compileRegExpPatterns(allRegExp));
    return null;
};
/**
 * A matcher can hand back a value that is not a category number when the payload's shape does
 * not match the matcher in use, so the lookup misses. Coalesce that miss to `null` to honour
 * the declared `PreferenceCategory | null` return type; callers treat `null` as uncategorized.
 */ const $0c7f9607cdd2e297$var$toPreferenceCategory = (itemCategoryNumber, categories)=>{
    const numToCategoryMap = {
        [categories.STRICTLY_NECESSARY]: (0, $2W5OM.PreferenceCategory).StrictlyNecessary,
        [categories.FUNCTIONAL]: (0, $2W5OM.PreferenceCategory).Functional,
        [categories.ANALYTICS]: (0, $2W5OM.PreferenceCategory).Analytics,
        [categories.MARKETING]: (0, $2W5OM.PreferenceCategory).Marketing,
        [categories.UNKNOWN]: (0, $2W5OM.PreferenceCategory).Unknown
    };
    return itemCategoryNumber !== null ? numToCategoryMap[itemCategoryNumber] ?? null : null;
};
const $0c7f9607cdd2e297$export$69d5b68d01f4a366 = (itemKey, storageControlsData, productName)=>{
    const downcasedProduct = productName?.toLowerCase();
    let itemCategoryNumber = null;
    const { categories: categories, patterns: patterns } = storageControlsData;
    // The payload states its own format, recorded when it was fetched. Re-evaluating the flat-format
    // rollout gate here could disagree with the gate value that chose the file we actually fetched — an
    // unresolved Statsig client, a stale cross-request SSR cache entry, or a gate flip mid-session — and
    // the losing matcher silently returns null for every pattern rather than erroring. The gate stays
    // the sole input to the *fetch* decision.
    const cache = $0c7f9607cdd2e297$var$asConcreteCache(storageControlsData);
    if (cache.patternFormat === 'flat' && (0, $2aEiL.fg)('platform_bsc_flat_lookup_skip_merge')) return $0c7f9607cdd2e297$var$toPreferenceCategory($0c7f9607cdd2e297$var$findFlatItemCategoryNumber(itemKey, cache, downcasedProduct), categories);
    let productKeys = {
        ...storageControlsData['keys']['all'],
        ...downcasedProduct ? storageControlsData['keys'][downcasedProduct] : {}
    };
    // Find direct match in keys
    if (Object.keys(productKeys).includes(itemKey)) itemCategoryNumber = productKeys[itemKey];
    else if (cache.patternFormat === 'flat') {
        // Flat prefix/suffix maps merge cleanly, because each key is a whole pattern rather than one
        // character of one.
        const productStartsWithPatterns = {
            ...cache.patterns.startsWith['all'],
            ...downcasedProduct ? cache.patterns.startsWith[downcasedProduct] : {}
        };
        const productEndsWithPatterns = {
            ...cache.patterns.endsWith['all'],
            ...downcasedProduct ? cache.patterns.endsWith[downcasedProduct] : {}
        };
        if ((0, $2aEiL.fg)('platform_bsc_longest_pattern_match_wins')) {
            // Longest-match-wins flat path
            const swMatch = $0c7f9607cdd2e297$export$4381be1b9fd38456(itemKey, productStartsWithPatterns);
            if (swMatch !== null) itemCategoryNumber = swMatch.category;
            else {
                const ewMatch = $0c7f9607cdd2e297$export$495f1917e0bfb98c(itemKey, productEndsWithPatterns);
                if (ewMatch !== null) itemCategoryNumber = ewMatch.category;
            }
        } else {
            // First-match flat path (COOK-435)
            itemCategoryNumber = $0c7f9607cdd2e297$export$915dea35caff63c(itemKey, productStartsWithPatterns);
            if (itemCategoryNumber === null) itemCategoryNumber = $0c7f9607cdd2e297$export$f6f7882079c4a2cb(itemKey, productEndsWithPatterns);
        }
    } else {
        // Legacy trie matching path. We search the product trie first and fall back
        // to the 'all' trie; a merged trie is unsafe because a shared first character
        // silently drops the entire 'all' subtree under it (HOT-303432).
        const productStartsWith = downcasedProduct ? cache.patterns.startsWith[downcasedProduct] : undefined;
        const productEndsWith = downcasedProduct ? cache.patterns.endsWith[downcasedProduct] : undefined;
        const allStartsWith = cache.patterns.startsWith['all'];
        const allEndsWith = cache.patterns.endsWith['all'];
        if (productStartsWith) itemCategoryNumber = $0c7f9607cdd2e297$export$2c141b1c00f3e482(itemKey, productStartsWith);
        if (itemCategoryNumber === null && allStartsWith) itemCategoryNumber = $0c7f9607cdd2e297$export$2c141b1c00f3e482(itemKey, allStartsWith);
        if (itemCategoryNumber === null && productEndsWith) itemCategoryNumber = $0c7f9607cdd2e297$export$c4a1dd71bbd8954c(itemKey, productEndsWith);
        if (itemCategoryNumber === null && allEndsWith) itemCategoryNumber = $0c7f9607cdd2e297$export$c4a1dd71bbd8954c(itemKey, allEndsWith);
    }
    // RegExp fallback, applied to both the flat and legacy trie pattern paths
    if (itemCategoryNumber === null) {
        const rawRegExpPatterns = {
            ...patterns.regexp?.['all'],
            ...downcasedProduct ? patterns.regexp?.[downcasedProduct] : {}
        };
        const compiledPatterns = $0c7f9607cdd2e297$var$compileRegExpPatterns(rawRegExpPatterns);
        itemCategoryNumber = $0c7f9607cdd2e297$export$81a82818a800a999(itemKey, compiledPatterns);
    }
    return $0c7f9607cdd2e297$var$toPreferenceCategory(itemCategoryNumber, categories);
};
const $0c7f9607cdd2e297$export$ec8ce5237293e4a4 = async (itemKey, storageType, productName)=>{
    const storageControlsData = await (0, $jeHvL.getBscGlobalState)().loadCache(storageType);
    if (!storageControlsData) return null;
    else return $0c7f9607cdd2e297$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
};
const $0c7f9607cdd2e297$export$4369c812aac99591 = (value)=>value != null && typeof value.then === 'function';
const $0c7f9607cdd2e297$export$68b935e7ddb93762 = (itemKey, storageType, productName)=>{
    const storageControlsDataOrPromise = (0, $jeHvL.getBscGlobalState)().loadCacheMaybeSync(storageType);
    if ($0c7f9607cdd2e297$export$4369c812aac99591(storageControlsDataOrPromise)) return storageControlsDataOrPromise.then((storageControlsData)=>{
        if (!storageControlsData) return null;
        else return $0c7f9607cdd2e297$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
    });
    if (!storageControlsDataOrPromise) return null;
    else return $0c7f9607cdd2e297$export$69d5b68d01f4a366(itemKey, storageControlsDataOrPromise, productName);
};
function $0c7f9607cdd2e297$var$getEffectiveCategory(category) {
    if (category === null) return (0, $2W5OM.PreferenceCategory).Marketing;
    return category;
}
function $0c7f9607cdd2e297$var$isProcessingAllowedForCategoryAndPreferenceSync(category, preferences) {
    const effectiveCategory = $0c7f9607cdd2e297$var$getEffectiveCategory(category);
    if (!!preferences) {
        if (!!effectiveCategory) return preferences[effectiveCategory];
    }
    return false;
}
/**
 * Given an item category and a promise or object of user preferences, determines whether the item can be set.
 * It avoids only returns a promise if we need the preference data to determine the result, otherwise it returns synchronously.
 *
 * DO NOT CONVERT THIS FUNCTION TO ASYNC - as async functions always return a promise, breaking read-after-write consistency for clients that have already loaded the cache.
 */ function $0c7f9607cdd2e297$var$isProcessingAllowedForCategoryMaybeSync(itemCategory, preferencesOrPromise) {
    if (itemCategory === (0, $2W5OM.PreferenceCategory).StrictlyNecessary) return {
        itemCategory: itemCategory,
        shouldProcessItem: true
    };
    if ($0c7f9607cdd2e297$export$4369c812aac99591(preferencesOrPromise)) return preferencesOrPromise.then((prefs)=>{
        return {
            itemCategory: itemCategory,
            shouldProcessItem: $0c7f9607cdd2e297$var$isProcessingAllowedForCategoryAndPreferenceSync(itemCategory, prefs)
        };
    });
    else return {
        itemCategory: itemCategory,
        shouldProcessItem: $0c7f9607cdd2e297$var$isProcessingAllowedForCategoryAndPreferenceSync(itemCategory, preferencesOrPromise)
    };
}
const $0c7f9607cdd2e297$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync = ({ itemKey: itemKey, storageType: storageType, productName: productName })=>{
    // start fetching both promises upfront, so they can resolve in parallel if needed
    const itemCategoryOrPromise = $0c7f9607cdd2e297$export$68b935e7ddb93762(itemKey, storageType, productName);
    const preferencesOrPromise = (0, $hEEEo.getPreferencesMaybeSync)();
    if ($0c7f9607cdd2e297$export$4369c812aac99591(itemCategoryOrPromise)) return itemCategoryOrPromise.then((category)=>$0c7f9607cdd2e297$var$isProcessingAllowedForCategoryMaybeSync(category, preferencesOrPromise));
    else return $0c7f9607cdd2e297$var$isProcessingAllowedForCategoryMaybeSync(itemCategoryOrPromise, preferencesOrPromise);
};
const $0c7f9607cdd2e297$export$ffbb879d3fefb45c = ({ itemKey: itemKey, storageType: storageType, productName: productName, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, extensionSignals: extensionSignals })=>{
    const categoryAndPreferenceOrPromise = $0c7f9607cdd2e297$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey: itemKey,
        storageType: storageType,
        productName: productName
    });
    const handleDecision = ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory }, wasAsync)=>{
        if (shouldProcessItem) {
            allowedCallback?.({
                wasAsync: wasAsync
            });
            return shouldProcessItem;
        }
        // Check if blocked item is from extension
        const extensionCaller = itemCategory === null ? (0, $hORic.attributeExtensionCaller)(extensionSignals) : null;
        if (extensionCaller) {
            (0, $7WT4C.sendTrackEvent)({
                source: 'package',
                action: 'package',
                actionSubject: 'browserExtensionKeysAllowed',
                attributes: {
                    itemKey: itemKey,
                    storageType: storageType,
                    productName: productName,
                    extensionScheme: extensionCaller.scheme
                }
            });
            allowedCallback?.({
                wasAsync: wasAsync
            });
            return true;
        }
        blockedCallback?.({
            itemHasCategory: itemCategory != null,
            itemCategory: itemCategory,
            wasAsync: wasAsync
        });
        return shouldProcessItem;
    };
    if ($0c7f9607cdd2e297$export$4369c812aac99591(categoryAndPreferenceOrPromise)) return categoryAndPreferenceOrPromise.then((categoryAndPreference)=>handleDecision(categoryAndPreference, true));
    else return handleDecision(categoryAndPreferenceOrPromise, false);
};
const $0c7f9607cdd2e297$export$e7a3dca206fec6e2 = async ({ itemKey: itemKey, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, storageType: storageType, productName: productName, extensionSignals: extensionSignals })=>{
    let shouldProcessItem;
    let itemCategory = null;
    let wasAsync = true;
    let categoryAndPreferenceOrPromise = $0c7f9607cdd2e297$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey: itemKey,
        storageType: storageType,
        productName: productName
    });
    if ($0c7f9607cdd2e297$export$4369c812aac99591(categoryAndPreferenceOrPromise)) // this should be the only await in the function.
    ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = await categoryAndPreferenceOrPromise);
    else {
        wasAsync = false;
        ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = categoryAndPreferenceOrPromise);
    }
    if (shouldProcessItem) allowedCallback?.({
        wasAsync: wasAsync
    });
    else {
        // Check if blocked item is from extension
        const extensionCaller = itemCategory === null ? (0, $hORic.attributeExtensionCaller)(extensionSignals) : null;
        if (extensionCaller) {
            (0, $7WT4C.sendTrackEvent)({
                source: 'package',
                action: 'package',
                actionSubject: 'browserExtensionKeysAllowed',
                attributes: {
                    itemKey: itemKey,
                    storageType: storageType,
                    productName: productName,
                    extensionScheme: extensionCaller.scheme
                }
            });
            allowedCallback?.({
                wasAsync: wasAsync
            });
            return true;
        }
        blockedCallback?.({
            itemHasCategory: itemCategory != null,
            itemCategory: itemCategory,
            wasAsync: wasAsync
        });
    }
    return shouldProcessItem;
};
const $0c7f9607cdd2e297$export$17e4a7e00d5b99d9 = async ({ itemKey: itemKey, storageType: storageType, productName: productName, extensionSignals: extensionSignals })=>{
    const categoryAndPreferenceOrPromise = $0c7f9607cdd2e297$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey: itemKey,
        storageType: storageType,
        productName: productName
    });
    let shouldProcessItem;
    let itemCategory;
    if ($0c7f9607cdd2e297$export$4369c812aac99591(categoryAndPreferenceOrPromise)) ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = await categoryAndPreferenceOrPromise);
    else ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = categoryAndPreferenceOrPromise);
    // Check if blocked item is from extension
    if (!shouldProcessItem) {
        const extensionCaller = itemCategory === null ? (0, $hORic.attributeExtensionCaller)(extensionSignals) : null;
        if (extensionCaller) {
            (0, $7WT4C.sendTrackEvent)({
                source: 'package',
                action: 'package',
                actionSubject: 'browserExtensionKeysAllowed',
                attributes: {
                    itemKey: itemKey,
                    storageType: storageType,
                    productName: productName,
                    extensionScheme: extensionCaller.scheme
                }
            });
            return {
                isAllowed: true,
                itemCategory: itemCategory
            };
        }
    }
    return {
        isAllowed: shouldProcessItem,
        itemCategory: itemCategory
    };
};

});
parcelRegister("hEEEo", function(module, exports) {
$parcel$export(module.exports, "getPreferences", () => $7ca169793fac694e$export$1de6a888ae076ff8);
$parcel$export(module.exports, "getPreferencesMaybeSync", () => $7ca169793fac694e$export$39c2cb6e65c1c16b);

var $jeHvL = parcelRequire("jeHvL");
var $dS1lP = parcelRequire("dS1lP");

var $3yjSR = parcelRequire("3yjSR");

var $cSGfl = parcelRequire("cSGfl");

var $dbJ6U = parcelRequire("dbJ6U");

var $hJye1 = parcelRequire("hJye1");
async function $7ca169793fac694e$export$1de6a888ae076ff8() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $jeHvL.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $dbJ6U.getCookie)((0, $3yjSR.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $hJye1.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $dbJ6U.getCookie)((0, $3yjSR.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) {
            const consentToken = await (0, $cSGfl.getConsentToken)();
            if ((0, $dS1lP.isSSR)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $hJye1.unpackUserPreferencesCookie)(consentToken) : undefined;
        }
        return (0, $hJye1.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}
function $7ca169793fac694e$export$39c2cb6e65c1c16b() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $jeHvL.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $dbJ6U.getCookie)((0, $3yjSR.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $hJye1.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $dbJ6U.getCookie)((0, $3yjSR.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) return (0, $cSGfl.getConsentToken)().then((consentToken)=>{
            if ((0, $dS1lP.isSSR)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $hJye1.unpackUserPreferencesCookie)(consentToken) : undefined;
        });
        else return (0, $hJye1.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}

});
parcelRegister("3yjSR", function(module, exports) {
$parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", () => $7dce39c1a1830d4b$export$10d7db8e1a856fd8);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", () => $7dce39c1a1830d4b$export$435de28e5b000487);
$parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", () => $7dce39c1a1830d4b$export$4b17acc0e875ba2a);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", () => $7dce39c1a1830d4b$export$23a1e02c3c0b0d08);
$parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", () => $7dce39c1a1830d4b$export$37073d560ecebada);
$parcel$export(module.exports, "ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY", () => $7dce39c1a1830d4b$export$5dc0026db06844f3);
$parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", () => $7dce39c1a1830d4b$export$b28b5d760fe14a21);
$parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", () => $7dce39c1a1830d4b$export$4a12f9e99971760a);
$parcel$export(module.exports, "DEFAULT_PREFERENCES", () => $7dce39c1a1830d4b$export$f0fd1d13ec1d48f2);
$parcel$export(module.exports, "V001_SCHEMA_KEY", () => $7dce39c1a1830d4b$export$f95182b7aa141c57);
$parcel$export(module.exports, "V002_SCHEMA_KEY", () => $7dce39c1a1830d4b$export$1f25427b34f9c405);
$parcel$export(module.exports, "V003_SCHEMA_KEY", () => $7dce39c1a1830d4b$export$31deaeaebce525bb);

var $2W5OM = parcelRequire("2W5OM");
const $7dce39c1a1830d4b$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
const $7dce39c1a1830d4b$export$435de28e5b000487 = 'atl-bsc-consent-token';
const $7dce39c1a1830d4b$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
const $7dce39c1a1830d4b$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
const $7dce39c1a1830d4b$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
const $7dce39c1a1830d4b$export$37073d560ecebada = 'atl-testing-consents';
const $7dce39c1a1830d4b$export$5dc0026db06844f3 = 'atl-bsc-banner-dismissed-time';
const $7dce39c1a1830d4b$export$b28b5d760fe14a21 = {
    [(0, $2W5OM.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $2W5OM.PreferenceCategory).Functional]: true,
    [(0, $2W5OM.PreferenceCategory).Marketing]: true,
    [(0, $2W5OM.PreferenceCategory).Analytics]: true,
    [(0, $2W5OM.PreferenceCategory).Unknown]: true // Includes uncategorized cookies
};
const $7dce39c1a1830d4b$export$4a12f9e99971760a = {
    [(0, $2W5OM.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $2W5OM.PreferenceCategory).Functional]: false,
    [(0, $2W5OM.PreferenceCategory).Marketing]: false,
    [(0, $2W5OM.PreferenceCategory).Analytics]: false,
    [(0, $2W5OM.PreferenceCategory).Unknown]: false
};
const $7dce39c1a1830d4b$export$f0fd1d13ec1d48f2 = {
    ...$7dce39c1a1830d4b$export$4a12f9e99971760a,
    [(0, $2W5OM.ContextualConsentProperty).ConsentsAreDefault]: true,
    [(0, $2W5OM.ContextualConsentProperty).UserIsAuthenticated]: false,
    [(0, $2W5OM.ContextualConsentProperty).ConsentDataUnavailable]: true
};
const $7dce39c1a1830d4b$export$f95182b7aa141c57 = '001';
const $7dce39c1a1830d4b$export$1f25427b34f9c405 = '002';
const $7dce39c1a1830d4b$export$31deaeaebce525bb = '003';

});

parcelRegister("cSGfl", function(module, exports) {
$parcel$export(module.exports, "getConsentToken", () => $5ff2410fc5eb96ca$export$f1b8f2ca713fca08);

var $3yjSR = parcelRequire("3yjSR");

var $dbJ6U = parcelRequire("dbJ6U");

var $iqJSJ = parcelRequire("iqJSJ");

var $3za5i = parcelRequire("3za5i");

var $fF3Mh = parcelRequire("fF3Mh");
/**
 * Module-level cache of the in-flight ConsentHub fetch promise.
 * Cleared as soon as the promise settles (resolved or rejected).
 *
 * Without this, N concurrent callers that all find the consent cookie absent
 * would each independently fire a fetch to ConsentHub, causing a request
 * fan-out on every page load where multiple components call getPreferences()
 * simultaneously.
 */ let $5ff2410fc5eb96ca$var$inFlightConsentToken = null;
const $5ff2410fc5eb96ca$var$_getConsentToken = async ()=>{
    const fallbackConsentToken = (0, $dbJ6U.getCookie)((0, $3yjSR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const consentData = await (0, $fF3Mh.getValidConsentData)(fallbackConsentToken);
    if (consentData) {
        const { consentToken: consentToken, consentTimestamp: consentTimestamp } = consentData;
        /*** TESTING OVERRIDES ***/ const potentiallyOverriddenConsentToken = (0, $iqJSJ.overrideConsentTokenForLiveTesting)(consentToken);
        const testingConsentOverride = (0, $dbJ6U.getCookie)((0, $3yjSR.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
        const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
        if (hasTestingConsents) {
            // If testing, set the cookies accordingly so we can test with any overridden token data.
            (0, $3za5i.setShouldShowBannerCookie)(potentiallyOverriddenConsentToken);
            (0, $3za5i.setConsentTokenCookie)(potentiallyOverriddenConsentToken);
            // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
            // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
            // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
            return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
        }
        // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
        (0, $3za5i.setRequiredConsentCookies)(potentiallyOverriddenConsentToken, consentTimestamp);
        return consentToken;
    }
    return undefined;
};
const $5ff2410fc5eb96ca$export$f1b8f2ca713fca08 = ()=>{
    // N concurrent callers share a single in-flight promise so only one ConsentHub fetch
    // fires per page load regardless of how many components call getPreferences() simultaneously.
    if ($5ff2410fc5eb96ca$var$inFlightConsentToken) return $5ff2410fc5eb96ca$var$inFlightConsentToken;
    $5ff2410fc5eb96ca$var$inFlightConsentToken = $5ff2410fc5eb96ca$var$_getConsentToken().finally(()=>{
        $5ff2410fc5eb96ca$var$inFlightConsentToken = null;
    });
    return $5ff2410fc5eb96ca$var$inFlightConsentToken;
};

});
parcelRegister("iqJSJ", function(module, exports) {
$parcel$export(module.exports, "overrideConsentTokenForLiveTesting", () => $0114ae2692bc3d79$export$b5282052fc15e1ae);

var $3yjSR = parcelRequire("3yjSR");

var $dbJ6U = parcelRequire("dbJ6U");
const $0114ae2692bc3d79$export$b5282052fc15e1ae = (genuineConsentToken)=>{
    // The existence of this cookie will make it look like fetched ConsentHub data is missing
    // You can set it to undefined yourself/empty string, or an actual default value.
    const tokenOverride = (0, $dbJ6U.getCookie)((0, $3yjSR.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
    // Note: Clear this cookie out of your browser when you're done testing empty data sets
    // Or you'll be stuck seeing the banner and never actually consenting on the UI
    return tokenOverride || genuineConsentToken;
};

});

parcelRegister("3za5i", function(module, exports) {
$parcel$export(module.exports, "setConsentTokenCookie", () => $7d000fce1a5acd38$export$8e560d0760f733a2);
$parcel$export(module.exports, "setConsentTokenFallbackCookie", () => $7d000fce1a5acd38$export$133cd762b0f705a2);
$parcel$export(module.exports, "setShouldShowBannerCookie", () => $7d000fce1a5acd38$export$99ecece88c58d938);
$parcel$export(module.exports, "setRequiredConsentCookies", () => $7d000fce1a5acd38$export$b3365240280cb3c3);

var $ihZsR = parcelRequire("ihZsR");
var $bEUFb = parcelRequire("bEUFb");

var $3yjSR = parcelRequire("3yjSR");

var $il7mV = parcelRequire("il7mV");

var $jlHNc = parcelRequire("jlHNc");
const $7d000fce1a5acd38$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = 50;
const $7d000fce1a5acd38$var$MAX_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = 70;
const $7d000fce1a5acd38$export$6e0b780517c88191 = ()=>{
    // Random offset is 0-20 minutes inclusive, so the final lifetime spreads across 50-70 minutes.
    const randomizedOffsetMinutes = Math.floor(Math.random() * ($7d000fce1a5acd38$var$MAX_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES - $7d000fce1a5acd38$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES + 1));
    // Spread cookie expiration times to smooth traffic spikes to ConsentHub.
    return $7d000fce1a5acd38$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES + randomizedOffsetMinutes;
};
// Pick once per module load so both required consent cookies share the same spread-out expiry.
const $7d000fce1a5acd38$var$RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = $7d000fce1a5acd38$export$6e0b780517c88191();
const $7d000fce1a5acd38$var$getRequiredConsentCookieExpiryDate = ()=>{
    const expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + $7d000fce1a5acd38$var$RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES * 60000);
    return expiryDate;
};
const $7d000fce1a5acd38$export$8e560d0760f733a2 = (consentToken)=>{
    (0, $jlHNc.setStrictlyNecessaryCookie)((0, $3yjSR.ATLASSIAN_CONSENT_COOKIE_KEY), consentToken, {
        expires: $7d000fce1a5acd38$var$getRequiredConsentCookieExpiryDate(),
        path: '/'
    });
    (0, $bEUFb.Logger).debug(`Set Consent Token ${(0, $3yjSR.ATLASSIAN_CONSENT_COOKIE_KEY)} ${consentToken}`);
};
const $7d000fce1a5acd38$export$133cd762b0f705a2 = (consentToken)=>{
    const inOneYear = new Date();
    inOneYear.setFullYear(inOneYear.getFullYear() + 1);
    (0, $jlHNc.setStrictlyNecessaryCookie)((0, $3yjSR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), consentToken, {
        expires: inOneYear,
        path: '/'
    });
    (0, $bEUFb.Logger).debug(`set fallback consent token: ${(0, $3yjSR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)} ${consentToken}`);
};
const $7d000fce1a5acd38$export$99ecece88c58d938 = (consentToken, consentTimestamp)=>{
    // Since we have no good way to reference this as a global state object, we want to precompute and store the
    // banner visibility in a temporary, session-scope cookie (same expiry as the other cookies), which we can
    // lookup in the UI as needed
    const bannerVisibility = (0, $il7mV.getBannerVisibility)({
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    });
    const shouldShowBanner = (0, $ihZsR.getBitValueFromBool)(!!bannerVisibility);
    (0, $jlHNc.setStrictlyNecessaryCookie)((0, $3yjSR.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), shouldShowBanner, {
        expires: $7d000fce1a5acd38$var$getRequiredConsentCookieExpiryDate(),
        path: '/'
    });
    (0, $bEUFb.Logger).debug(`set shouldShowBannerCookie: ${(0, $3yjSR.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)} ${shouldShowBanner}`);
};
const $7d000fce1a5acd38$export$b3365240280cb3c3 = (consentToken, consentTimestamps)=>{
    $7d000fce1a5acd38$export$8e560d0760f733a2(consentToken);
    $7d000fce1a5acd38$export$99ecece88c58d938(consentToken, consentTimestamps);
};

});
parcelRegister("ihZsR", function(module, exports) {
$parcel$export(module.exports, "getBitValueFromBool", () => $eeb94047a7db081a$export$929f1500428a1fc8);
$parcel$export(module.exports, "getBoolFromBitValue", () => $eeb94047a7db081a$export$27647458f3cf29d2);
const $eeb94047a7db081a$export$929f1500428a1fc8 = (value)=>{
    return Number(value).toString();
};
const $eeb94047a7db081a$export$27647458f3cf29d2 = (bitValue)=>{
    if (bitValue) return !!Number(bitValue);
};

});

parcelRegister("il7mV", function(module, exports) {
$parcel$export(module.exports, "getBannerVisibility", () => $530e0d9245369756$export$bfdb9f82a9194c1e);

var $6yOvq = parcelRequire("6yOvq");

var $dS1lP = parcelRequire("dS1lP");

var $ihZsR = parcelRequire("ihZsR");

var $3yjSR = parcelRequire("3yjSR");

var $9e4p2 = parcelRequire("9e4p2");

var $dbJ6U = parcelRequire("dbJ6U");

var $hJye1 = parcelRequire("hJye1");
const $530e0d9245369756$var$getUserIsAuthenticatedBit = (consentToken)=>{
    const { isV002: isV002 } = (0, $hJye1.checkTokenVersionValidity)(consentToken);
    let userIsAuthenticatedBit = consentToken[8]; // V3 position
    if (isV002) {
        // Schema has changed in V3, V2 had this bit in a different position. Logged out users will have this bit set to 1
        const legacyV2ConsentDataUnavailableBit = consentToken[7];
        // We can backfill the UserIsAuthenticated bit by flipping the bit value. If ConsentHub was unavailable, that means they were logged out.
        userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
    }
    return userIsAuthenticatedBit;
};
const $530e0d9245369756$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
    // Logged out + default consents + fallback: we have a discrepancy where ConsentHub is down/unavailable, or they're just logged out,
    // but the user has actually consented previously (which essentially the only way to save to the fallback to begin with)
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $530e0d9245369756$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $ihZsR.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $9e4p2.checkIfTokenIsDefault)(fallbackConsentToken);
        const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        // If the fallback is from a logged out consent (localOnlyConsent), they're currently
        // logged out and also saved while logged out, so don't show the banner
        if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
        const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        if (loggedOutUserPreviouslyConsentedWhileLoggedIn) // Or if it is from a logged in consent, and they've consented somewhere (they must have)
        // then we should not show the banner, as their consents aren't "stale", we're just in a situation
        // where the original token has expired so they get a default set, but we should hide the banner
        return false;
    }
    // Defaults consents + unauthed + missing a fallback, show the banner, as they haven't consented in the past year
    return true;
};
const $530e0d9245369756$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
    const tokenIsADefaultConsent = !!(0, $9e4p2.checkIfTokenIsDefault)(consentToken);
    // Handle default token flow
    if (tokenIsADefaultConsent) return $530e0d9245369756$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    // If they're a legacy/V2 user who hasn't consented, this will have checked the V3 "is default" bit to note they've consented or not
    const localOnlyUserHasConsented = (0, $9e4p2.hasLegacyV2TokenConsentedPreviously)(consentToken) || !tokenIsADefaultConsent;
    if (localOnlyUserHasConsented) // LocalOnly users will never have a timestamp to validate against since they can't talk to ConsentHub
    // Existence of fallback consents means they've consented in the past year and do not have stale consents, do not show banner
    return fallbackConsentToken ? false : true;
    // This case should never be hit: if it's not a default, but they haven't consented... what is it? Add a catch-all "show banner"
    return true;
};
const $530e0d9245369756$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
    // Defaults + fallback + logged in, but they consented while they were previously logged out:
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $530e0d9245369756$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $ihZsR.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $9e4p2.checkIfTokenIsDefault)(fallbackConsentToken);
        if (fallbackTokenHasGenuineConsents) {
            // Defaults + logged in user + consented <1yr ago, but while logged out
            if (isLoggedOutFallbackConsents) /*
            They've consented, and thus stored a fallback while logged out (fallback's CH bit is 1),
            then fetched from CH but get empty data (since they couldn't save to CH on their initial "save"), which sets authed consent defaults (bit 0)
             UX Problem:
            Since they have genuinely consented within the past year, the ideal UX would be to not show the banner...
            But if we do not re-prompt here in an effort to recapture their consents, the opportunity for them/us to actually get consents in the DB
            is infrequent (either via Account Privacy Page or once this fallback expires in a year).
             Example:
            While logged out, they consent in Trello, so we store the unauthed fallback token, then log in on Trello. If we hide the banner when the
            fallback exists, if that user later goes to Confluence's cookie domain (where they have no fallback), it would show the banner
            because they have no stored consents on CH, and no fallback in that domain, but are logged in. Repeat for every new domain...
             We could be fancy and save under the hood for them if they have a fallback, but to ensure we don't copy stale/different consents saved in a fallback
            to ConsentHub on their behalf, we should just re-prompt them for consents now that they're logged in. This way, they will actually
            persist their choices, and when loading other domains/products, there will be a Source of Truth to reference and not show the banner.
             Ultimately, this feels like the more "correct" way to handle this situation, as the cost of showing the banner again to officially capture
            consents feels lower than the potential cost of relying on fallbacks in all situations/across all domains for this user for the next whole year
             Result: Show the banner again and hope we officially recapture consents this time around
          */ return true;
            // Defaults + logged in user + consented <1yr ago, but while logged in
            // This scenario shouldn't happen, or if it does, it's in a phase where we haven't fetched preferences
            // yet, so hide the banner for now
            return false;
        }
        // Default token + default fallback (authed or unauthed) mean we've likely stored this
        // fallback from SSR's initialPreferences flow in. Fallbacks should not be saved with defaults intentionally
        // But sometimes we copy an existing token to the fallback via SSR flow, so let's treat this
        // as an bunk fallback, and show the banner as they haven't consented
        return true;
    }
    // Default consent token + logged in user + no fallback = they haven't consented in the past year, show banner
    return true;
};
const $530e0d9245369756$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
    // Handle default token flow
    const tokenIsADefaultConsent = !!(0, $9e4p2.checkIfTokenIsDefault)(consentToken);
    if (tokenIsADefaultConsent) return $530e0d9245369756$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    if (consentTimestamp) {
        // If the user has genuine consents, and a timestamp, check if they're stale (> 1yr old), show the banner if they're stale
        const showBannerIfStale = (0, $9e4p2.checkIfConsentsAreStale)(consentTimestamp);
        return showBannerIfStale;
    }
    // Genuine consents + no timestamp— we're in a situation where we've been passed cached cookie data instead of CH response data,
    // so the only way to determine staleness is through the absence of the fallback.
    // Technically, we could assume since they've consented recently, we don't have to show the banner here but... to be safe we should
    return fallbackConsentToken ? false : true;
};
const $530e0d9245369756$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents }, ssrOptions)=>{
    // Consent tokens are either a set of defaults, or genuine (persisted to the remote, or saved in an entire local-only flow via fallbacks).
    // the deciding factor is whether or not your consents are stale/fresh, either via the existence/absence of a fallback (a.k.a consented within a year or not)
    // or if the ConsentHub response data of a user's consent has a timestamp that is older than a year
    // Detect if js-cookie has been replaced with SSR-safe version (Confluence only)
    const isJsCookieSSRSafe = typeof (0, $6yOvq.default).__SSR_INITIALIZE_COOKIES__ === 'function';
    // Jira passes getCookie explicitly via ssrOptions - it works on both SSR and CSR.
    const ssrFriendlyGetCookie = ssrOptions?.getCookie;
    let fallbackConsentToken;
    if (ssrFriendlyGetCookie) fallbackConsentToken = fallbackConsents || ssrFriendlyGetCookie((0, $3yjSR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    else fallbackConsentToken = (0, $dS1lP.isSSR)() ? fallbackConsents || (isJsCookieSSRSafe ? (0, $dbJ6U.getCookie)((0, $3yjSR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)) : undefined) : fallbackConsents || (0, $dbJ6U.getCookie)((0, $3yjSR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    let userIsAuthenticatedBit = $530e0d9245369756$var$getUserIsAuthenticatedBit(consentToken);
    const isLoggedOutConsentToken = !(0, $ihZsR.getBoolFromBitValue)(userIsAuthenticatedBit);
    let isBannerVisible = true; // By default, show the banner to every user
    // Unauthed/logged out user flow, should never receive a timestamp because logged out users can't communicate to ConsentHub
    if (isLoggedOutConsentToken) isBannerVisible = $530e0d9245369756$var$shouldShowBannerForLoggedOutUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    });
    else // Authed/logged in user flow
    isBannerVisible = $530e0d9245369756$var$shouldShowBannerForLoggedInUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken,
        consentTimestamp: consentTimestamp
    });
    return isBannerVisible;
};

});
parcelRegister("9e4p2", function(module, exports) {
$parcel$export(module.exports, "hasLegacyV2TokenConsentedPreviously", () => $7e84a4a6a15a5d61$export$42b0ca8aba2631e4);
$parcel$export(module.exports, "checkIfTokenIsDefault", () => $7e84a4a6a15a5d61$export$497a647f0eb30ef4);
$parcel$export(module.exports, "serializeConsents", () => $7e84a4a6a15a5d61$export$92ba0b2fe50f90df);
$parcel$export(module.exports, "deserializeConsents", () => $7e84a4a6a15a5d61$export$bfa0c91662787fb0);
$parcel$export(module.exports, "getConsentTimestamp", () => $7e84a4a6a15a5d61$export$13e4cff933f26b03);
$parcel$export(module.exports, "checkIfConsentsAreStale", () => $7e84a4a6a15a5d61$export$3387347b75450ae1);
$parcel$export(module.exports, "hasPrefetchedDataConsents", () => $7e84a4a6a15a5d61$export$7133f415a79804e8);
$parcel$export(module.exports, "StatusCodeError", () => $7e84a4a6a15a5d61$export$a79c0ea3d7c2444a);

var $ihZsR = parcelRequire("ihZsR");

var $3yjSR = parcelRequire("3yjSR");

var $dbJ6U = parcelRequire("dbJ6U");

var $2W5OM = parcelRequire("2W5OM");

var $iyNrT = parcelRequire("iyNrT");
const $7e84a4a6a15a5d61$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV2Schema = version === (0, $3yjSR.V002_SCHEMA_KEY);
    return isV2Schema;
};
const $7e84a4a6a15a5d61$var$isLegacyV1Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV1Schema = version === (0, $3yjSR.V001_SCHEMA_KEY);
    return isV1Schema;
};
const $7e84a4a6a15a5d61$export$42b0ca8aba2631e4 = (consentToken)=>{
    if ($7e84a4a6a15a5d61$var$isLegacyGeoTargetingV2Token(consentToken)) {
        // If we're looking at a V2 token and they have ANY saved 'consentedUnderXX' bits,
        // we know it must be a set of valid consents instead of defaults
        const consentedUnderGDPR = consentToken[8] === '1';
        const consentedUnderCPRA = consentToken[9] === '1';
        const consentedUnderLGPD = consentToken[10] === '1';
        const consentedUnderFADP = consentToken[11] === '1';
        const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
        return hasConsentedPreviously;
    }
    return false;
};
const $7e84a4a6a15a5d61$export$497a647f0eb30ef4 = (consentToken)=>{
    const isLegacyV1ConsentToken = $7e84a4a6a15a5d61$var$isLegacyV1Token(consentToken);
    const isLegacyV2ConsentToken = $7e84a4a6a15a5d61$var$isLegacyGeoTargetingV2Token(consentToken);
    if (isLegacyV1ConsentToken) // We only add a legacy `atl-gdpr-consents` cookie if a user has consented,
    // so if we see a V1 token, we know it must be a set of valid consents
    // instead of default consents
    return false;
    if (isLegacyV2ConsentToken) {
        const legacyTokenHasConsents = $7e84a4a6a15a5d61$export$42b0ca8aba2631e4(consentToken);
        return !legacyTokenHasConsents;
    }
    // Check 'isDefaultConsentBit' bit for V003 Schema tokens
    const isDefaultTokenV3 = (0, $ihZsR.getBoolFromBitValue)(consentToken[7]);
    return isDefaultTokenV3;
};
const $7e84a4a6a15a5d61$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
    const version = (0, $3yjSR.V003_SCHEMA_KEY);
    // DEFAULT_PREFERENCES now has the default boolean baked into it, so we don't need to set it here
    const serializedBits = Object.entries((0, $3yjSR.DEFAULT_PREFERENCES)).reduce((acc, [key, val])=>{
        // Skip the STRICTLY_NECESSARY as it's always allowed
        if (key === (0, $2W5OM.PreferenceCategory).StrictlyNecessary) return acc;
        if (key === (0, $2W5OM.ContextualConsentProperty).UserIsAuthenticated) {
            // If consents are missing when setting these defaults, the user will be logged out,
            // so pack this info into the consent token bits
            const userIsAuthed = !consentsUnavailable;
            return acc + (0, $ihZsR.getBitValueFromBool)(userIsAuthed);
        }
        if (key === (0, $2W5OM.ContextualConsentProperty).ConsentDataUnavailable) // If consents are missing when setting these defaults, the user will be logged out,
        // so pack this info into the consent token bits
        return acc + (0, $ihZsR.getBitValueFromBool)(!!consentsUnavailable);
        return acc + (0, $ihZsR.getBitValueFromBool)(val);
    }, '');
    return `${version}${serializedBits}`;
};
const $7e84a4a6a15a5d61$export$42a0b3fb1e53e7b9 = (consents)=>{
    const version = (0, $3yjSR.V003_SCHEMA_KEY);
    // As 'strictlyNecessaryConsent' would always be allowed, we don't store it in the cookie or use ConsentHub
    const functionalConsent = (0, $ihZsR.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $iyNrT.ConsentHubKey).Functional)?.granted);
    const analyticsConsent = (0, $ihZsR.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $iyNrT.ConsentHubKey).Analytics)?.granted);
    const marketingConsent = (0, $ihZsR.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $iyNrT.ConsentHubKey).Marketing)?.granted);
    const unknownConsent = (0, $ihZsR.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $iyNrT.ConsentHubKey).Unknown)?.granted);
    // As these consents were returned from the server, ConsentHub is obviously available, they're logged in, and aren't defaults
    const isDefaultToken = 0;
    const userIsAuthenticated = 1;
    const consentHubDataUnavailable = 0;
    return [
        version,
        functionalConsent,
        analyticsConsent,
        marketingConsent,
        unknownConsent,
        isDefaultToken,
        userIsAuthenticated,
        consentHubDataUnavailable
    ].join('');
};
const $7e84a4a6a15a5d61$export$92ba0b2fe50f90df = ({ consents: consents })=>{
    if (!consents) {
        // When generating consents for an unauthenticated user, use the fallback token if it exists
        // This circumvents us setting defaults for them if their token has expired, but they have consented previously
        const existingFallbackToken = (0, $dbJ6U.getCookie)((0, $3yjSR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        if (existingFallbackToken) return existingFallbackToken;
        // User is unauthed, will only use local consenting, consent data will also be unavailable
        return $7e84a4a6a15a5d61$export$c42e1a74e60f4d73(true); // e.g. 0030000101
    } else if (consents.length === 0) // User is authed but has no consents in the system, so use defaults in the interim, consentData must be available
    return $7e84a4a6a15a5d61$export$c42e1a74e60f4d73(); // e.g. 0030000110
    else // User is authed and has consents in the system
    return $7e84a4a6a15a5d61$export$42a0b3fb1e53e7b9(consents); // e.g. 0030110110
};
const $7e84a4a6a15a5d61$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
    const validConsentHubCookieConsents = [
        (0, $2W5OM.PreferenceCategory).StrictlyNecessary,
        (0, $2W5OM.PreferenceCategory).Functional,
        (0, $2W5OM.PreferenceCategory).Analytics,
        (0, $2W5OM.PreferenceCategory).Marketing,
        (0, $2W5OM.PreferenceCategory).Unknown
    ];
    const consentKeyMap = {
        [(0, $2W5OM.PreferenceCategory).StrictlyNecessary]: (0, $iyNrT.ConsentHubKey).StrictlyNecessary,
        [(0, $2W5OM.PreferenceCategory).Functional]: (0, $iyNrT.ConsentHubKey).Functional,
        [(0, $2W5OM.PreferenceCategory).Analytics]: (0, $iyNrT.ConsentHubKey).Analytics,
        [(0, $2W5OM.PreferenceCategory).Marketing]: (0, $iyNrT.ConsentHubKey).Marketing,
        [(0, $2W5OM.PreferenceCategory).Unknown]: (0, $iyNrT.ConsentHubKey).Unknown
    };
    const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
        const key = consentKeyMap[consentKey];
        return {
            key: key,
            granted: !!unpackedUserPreferences[consentKey],
            gatheredTs: new Date().toISOString(),
            displayedText: displayedTextMap[consentKey]
        };
    });
    return consentRecords;
};
const $7e84a4a6a15a5d61$export$13e4cff933f26b03 = ({ consents: consents })=>{
    if (consents && consents.length) {
        // As consents can be updated individually, we need to find the most recent timestamp to use as "most recent consent"
        const timestamps = consents.map((consent)=>{
            return new Date(consent.updatedTs).getTime();
        });
        const maxTimestamp = Math.max(...timestamps);
        const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
        return mostRecentConsentTimestamp;
    }
};
const $7e84a4a6a15a5d61$export$3387347b75450ae1 = (consentTimestamp)=>{
    // Privacy has determined that we should re-prompt users for consent if they haven't
    // consented in over a year regardless, because they're legally stale/expired
    let consentedOverAYearAgo = false;
    if (consentTimestamp) {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
    }
    return consentedOverAYearAgo;
};
const $7e84a4a6a15a5d61$export$7133f415a79804e8 = (preferences)=>{
    if (!preferences) return false;
    const prefetchedToken = 'consentToken' in preferences && preferences.consentToken;
    const prefetchedTokenIsDefault = $7e84a4a6a15a5d61$export$497a647f0eb30ef4(prefetchedToken || '');
    const hasLegitConsentToken = prefetchedToken && !prefetchedTokenIsDefault;
    const prefetchedConsents = 'consents' in preferences && preferences.consents;
    const hasLegitConsents = prefetchedConsents && Array.isArray(prefetchedConsents) && prefetchedConsents.length > 0;
    return Boolean(hasLegitConsentToken || hasLegitConsents);
};
class $7e84a4a6a15a5d61$export$a79c0ea3d7c2444a extends Error {
    status;
    constructor(message, status){
        super(message);
        this.status = status;
        Object.setPrototypeOf(this, $7e84a4a6a15a5d61$export$a79c0ea3d7c2444a.prototype);
        // Captures the stack trace (for environments that support it)
        if (Error.captureStackTrace) Error.captureStackTrace(this, $7e84a4a6a15a5d61$export$a79c0ea3d7c2444a);
        this.name = 'StatusCodeError';
    }
}

});
parcelRegister("iyNrT", function(module, exports) {
$parcel$export(module.exports, "ConsentHubKey", () => $790c381024427f82$export$31140359b1e505cf);
var $790c381024427f82$export$31140359b1e505cf = /*#__PURE__*/ function(ConsentHubKey) {
    ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
    ConsentHubKey["Functional"] = "functionalCookies";
    ConsentHubKey["Analytics"] = "performanceCookies";
    ConsentHubKey["Marketing"] = "targetingCookies";
    ConsentHubKey["Unknown"] = "unknownCookies";
    return ConsentHubKey;
}({});

});


parcelRegister("hJye1", function(module, exports) {
$parcel$export(module.exports, "checkTokenVersionValidity", () => $e32595370751d489$export$64b31470e8522819);
$parcel$export(module.exports, "packUserPreferences", () => $e32595370751d489$export$3199823fec979bd1);
$parcel$export(module.exports, "unpackUserPreferencesCookie", () => $e32595370751d489$export$8d213cb390bab4fa);
$parcel$export(module.exports, "initializePreferencesData", () => $e32595370751d489$export$7962405c3ca274b1);

var $jeHvL = parcelRequire("jeHvL");

var $ihZsR = parcelRequire("ihZsR");

var $3yjSR = parcelRequire("3yjSR");

var $9e4p2 = parcelRequire("9e4p2");

var $2W5OM = parcelRequire("2W5OM");
const $e32595370751d489$export$64b31470e8522819 = (consentToken)=>{
    // A token can technically be bad data (alphanumeric instead of binary) but we should fail gracefully if so
    if (consentToken.length < 3) // Wrong format, no version
    return {
        isValid: false,
        isV001: false,
        isV002: false,
        isV003: false
    };
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV001 = version === (0, $3yjSR.V001_SCHEMA_KEY) && consentToken.length === 7;
    const isV002 = version === (0, $3yjSR.V002_SCHEMA_KEY) && consentToken.length === 12;
    const isV003 = version === (0, $3yjSR.V003_SCHEMA_KEY) && consentToken.length === 10;
    // We support version 001, 002, 003 only
    const isSupportedVersion = [
        (0, $3yjSR.V001_SCHEMA_KEY),
        (0, $3yjSR.V002_SCHEMA_KEY),
        (0, $3yjSR.V003_SCHEMA_KEY)
    ].includes(version);
    const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
    return {
        isValid: isValid,
        isV001: isV001,
        isV002: isV002,
        isV003: isV003
    };
};
/* Schema Version 001:
---------------------------------------------------
  - Format 0000000
  - 001 (schema version 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
*/ const $e32595370751d489$var$packPrefsVersion001 = (userPreferences)=>{
    const version = (0, $3yjSR.V001_SCHEMA_KEY);
    return [
        version,
        (0, $ihZsR.getBitValueFromBool)(userPreferences.FUNCTIONAL),
        (0, $ihZsR.getBitValueFromBool)(userPreferences.ANALYTICS),
        (0, $ihZsR.getBitValueFromBool)(userPreferences.MARKETING),
        (0, $ihZsR.getBitValueFromBool)(userPreferences.UNKNOWN)
    ].join('');
};
const $e32595370751d489$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        [(0, $2W5OM.PreferenceCategory).StrictlyNecessary]: true,
        // always allowed
        [(0, $2W5OM.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $2W5OM.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $2W5OM.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $2W5OM.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1'
    };
};
/* Schema Version 002 ***** DEPRECATED *****
---------------------------------------------------
  - Format 000000000000
  - 002 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, consent records are unavailable from ConsentHub (logged out) - yes/no)
  - 0/1 (1 digit, consents saved while in GDPR locale (Europe) - yes/no)
  - 0/1 (1 digit, consents saved while in CPRA locale (CPRA will act as 'all USA' bucket) - yes/no)
  - 0/1 (1 digit, consents saved while in LGPD locale (Brazil) - yes/no)
  - 0/1 (1 digit, consents saved while in FADP locale (Switzerland) - yes/no)
*/ const $e32595370751d489$var$packPrefsVersion002 = (userPreferences)=>{
    // As we want to slowly kill off any V002 preferences, if we're provided one for some reason
    // internally convert it to a V003 preference to drop contextual GeoIP details
    const version = (0, $3yjSR.V003_SCHEMA_KEY);
    const hasConsentedPreviously = userPreferences[(0, $2W5OM.ConsentPreferenceV2).ConsentedUnderGDPR] || userPreferences[(0, $2W5OM.ConsentPreferenceV2).ConsentedUnderCPRA] || userPreferences[(0, $2W5OM.ConsentPreferenceV2).ConsentedUnderLGPD] || userPreferences[(0, $2W5OM.ConsentPreferenceV2).ConsentedUnderFADP];
    const isDefaultConsentBit = !hasConsentedPreviously;
    // As we've broken out authentication insights/context from "ConsentDataUnavailable" bit in V3,
    // and it does not exist, we will backfill the value based on the previous bit state
    const existingConsentDataUnavailableBit = userPreferences[(0, $2W5OM.ContextualConsentProperty).ConsentDataUnavailable];
    const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
    return [
        version,
        (0, $ihZsR.getBitValueFromBool)(userPreferences[(0, $2W5OM.PreferenceCategory).Functional]),
        (0, $ihZsR.getBitValueFromBool)(userPreferences[(0, $2W5OM.PreferenceCategory).Analytics]),
        (0, $ihZsR.getBitValueFromBool)(userPreferences[(0, $2W5OM.PreferenceCategory).Marketing]),
        (0, $ihZsR.getBitValueFromBool)(userPreferences[(0, $2W5OM.PreferenceCategory).Unknown]),
        (0, $ihZsR.getBitValueFromBool)(isDefaultConsentBit),
        (0, $ihZsR.getBitValueFromBool)(userIsAuthenticatedBit),
        (0, $ihZsR.getBitValueFromBool)(existingConsentDataUnavailableBit)
    ].join('');
};
const $e32595370751d489$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
    // If the provided V002 token has consented anywhere, we'll drop the contextual GeoIP bits and
    // convert it to a V003 schema
    const isADefaultConsentToken = (0, $9e4p2.checkIfTokenIsDefault)(userPreferencesCookie);
    // Backfill the value based on the previous "ConsentDataUnavailable" bit state as we've broken this contextual info out
    const consentDataUnavailable = userPreferencesCookie[7] === '1';
    const userIsDeemedAuthenticated = !consentDataUnavailable;
    return {
        ...$e32595370751d489$var$unpackPrefsVersion003(userPreferencesCookie),
        [(0, $2W5OM.ContextualConsentProperty).ConsentsAreDefault]: !!isADefaultConsentToken,
        [(0, $2W5OM.ContextualConsentProperty).UserIsAuthenticated]: userIsDeemedAuthenticated,
        [(0, $2W5OM.ContextualConsentProperty).ConsentDataUnavailable]: consentDataUnavailable
    };
};
/* Schema Version 003
---------------------------------------------------
  - Format 0000000000
  - 003 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, Consent token in a default state, user has yet to consent) - no/yes)
  - 0/1 (1 digit, User is authenticated, did not 401 during save) - no/yes)
  - 0/1 (1 digit, ConsentHub records are unavailable (CH is down, errored while saving, etc) - no/yes)
*/ const $e32595370751d489$var$packPrefsVersion003 = (userPreferences)=>{
    const version = (0, $3yjSR.V003_SCHEMA_KEY);
    return [
        version,
        (0, $ihZsR.getBitValueFromBool)(userPreferences[(0, $2W5OM.PreferenceCategory).Functional]),
        (0, $ihZsR.getBitValueFromBool)(userPreferences[(0, $2W5OM.PreferenceCategory).Analytics]),
        (0, $ihZsR.getBitValueFromBool)(userPreferences[(0, $2W5OM.PreferenceCategory).Marketing]),
        (0, $ihZsR.getBitValueFromBool)(userPreferences[(0, $2W5OM.PreferenceCategory).Unknown]),
        (0, $ihZsR.getBitValueFromBool)(userPreferences[(0, $2W5OM.ContextualConsentProperty).ConsentsAreDefault]),
        (0, $ihZsR.getBitValueFromBool)(userPreferences[(0, $2W5OM.ContextualConsentProperty).UserIsAuthenticated]),
        (0, $ihZsR.getBitValueFromBool)(userPreferences[(0, $2W5OM.ContextualConsentProperty).ConsentDataUnavailable])
    ].join('');
};
const $e32595370751d489$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
    return {
        [(0, $2W5OM.PreferenceCategory).StrictlyNecessary]: true,
        // always allowed
        [(0, $2W5OM.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $2W5OM.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $2W5OM.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $2W5OM.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1',
        [(0, $2W5OM.ContextualConsentProperty).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
        [(0, $2W5OM.ContextualConsentProperty).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
        [(0, $2W5OM.ContextualConsentProperty).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
    };
};
const $e32595370751d489$var$V002SpecificBitKeys = [
    (0, $2W5OM.ContextualConsentProperty).ConsentDataUnavailable,
    (0, $2W5OM.ConsentPreferenceV2).ConsentedUnderGDPR,
    (0, $2W5OM.ConsentPreferenceV2).ConsentedUnderCPRA,
    (0, $2W5OM.ConsentPreferenceV2).ConsentedUnderLGPD,
    (0, $2W5OM.ConsentPreferenceV2).ConsentedUnderFADP
];
const $e32595370751d489$var$V003SpecificBitKeys = [
    (0, $2W5OM.ContextualConsentProperty).ConsentsAreDefault,
    (0, $2W5OM.ContextualConsentProperty).UserIsAuthenticated,
    (0, $2W5OM.ContextualConsentProperty).ConsentDataUnavailable
];
function $e32595370751d489$export$3199823fec979bd1(userPreferences) {
    if ((0, $jeHvL.getBscGlobalState)().localConsentMode) return $e32595370751d489$var$packPrefsVersion001(userPreferences);
    const isV002 = $e32595370751d489$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV002) // As V002 is deprecated, if we've been provided V002 set of "legacy" prefs, internally
    // convert them to V003 to drop the unnecessary contextual details
    return $e32595370751d489$var$packPrefsVersion002(userPreferences);
    const isV003 = $e32595370751d489$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV003) return $e32595370751d489$var$packPrefsVersion003(userPreferences);
    // Fallback to V001
    return $e32595370751d489$var$packPrefsVersion001(userPreferences);
}
function $e32595370751d489$export$8d213cb390bab4fa(userPreferencesCookie) {
    if ((0, $jeHvL.getBscGlobalState)().localConsentMode) {
        if (userPreferencesCookie.length < 3) // Wrong format, no version
        return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version === (0, $3yjSR.V001_SCHEMA_KEY)) return $e32595370751d489$var$unpackPrefsVersion001(userPreferencesCookie);
        return;
    }
    const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $e32595370751d489$export$64b31470e8522819(userPreferencesCookie);
    if (!isValid) // We support version 001, 002, 003 only
    return;
    if (isV001) return $e32595370751d489$var$unpackPrefsVersion001(userPreferencesCookie);
    if (isV002) // Deprecated, so this will unpack to 003 to drop the contextual GeoIP bits
    return $e32595370751d489$var$unpackPrefsVersion002(userPreferencesCookie);
    if (isV003) return $e32595370751d489$var$unpackPrefsVersion003(userPreferencesCookie);
}
const $e32595370751d489$export$67f70eb55341bd29 = (initialPreferences)=>{
    if (!initialPreferences) return true;
    const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
    return prefExistButAreEmpty;
};
const $e32595370751d489$export$7962405c3ca274b1 = (initialPreferences)=>{
    if (initialPreferences !== (0, $2W5OM.PrefetchedPreferenceState).INTERNAL) {
        if ($e32595370751d489$export$67f70eb55341bd29(initialPreferences)) // Failsafe handling: Consumer failed to provide data even though they have prefetched, so we need to fetch again
        // This may occur if a consumer's prefetch requests fails, or if they fail to implement the system correctly
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        // If initialPreferences is not INTERNAL on first render, we have been provided a pre-fetched
        // value, which means we don't need to make a fetch to storage or ConsentHub to get it.
        // If that preference is defined, we persist it to our local cookie set
        // If the data is a ConsentHubResponse/PrefetchedConsentCookieData, we'll need to transform it properly before consumption
        const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
        if (consentToken) {
            // We already have a consent cookie that was passed in, let's not override it by setting it again
            const unpackedExistingPrefs = $e32595370751d489$export$8d213cb390bab4fa(consentToken);
            return {
                prefs: unpackedExistingPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
            };
        }
        // This type guard protects the below casting of ConsentHubResponse ensuring we have the correct shape
        if (initialPreferences && 'consents' in initialPreferences) {
            const serializedPrefetchedConsentToken = (0, $9e4p2.serializeConsents)(initialPreferences);
            const unpackedPrefetchedPrefs = $e32595370751d489$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
            return {
                prefs: unpackedPrefetchedPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
            };
        }
    }
    // If we've fallen into this, EMPTY implies we have no data at all
    // INTERNAL implies we still need to fetch new data, so trigger a refetch
    if (initialPreferences === (0, $2W5OM.PrefetchedPreferenceState).INTERNAL) return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: true
    };
    return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: false
    };
};

});


parcelRegister("jlHNc", function(module, exports) {
$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $30eaf03d4efae8df$export$93509ff9a62ee022);

var $6yOvq = parcelRequire("6yOvq");

var $2aEiL = parcelRequire("2aEiL");

var $jeHvL = parcelRequire("jeHvL");
var $7WT4C = parcelRequire("7WT4C");

var $bEUFb = parcelRequire("bEUFb");
const $30eaf03d4efae8df$export$93509ff9a62ee022 = (key, value, attributes)=>{
    if ((0, $2aEiL.fg)('platform_moonjelly_bsc_master_killswitch')) // Set the cookie without package operational events
    // when master killswitch is enabled
    (0, $6yOvq.default).set(key, value, {
        ...attributes,
        'atl-set-cookie': true
    });
    else try {
        if (!(0, $jeHvL.getBscGlobalState)().hasInitialized) (0, $7WT4C.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: 'Cookie'
            }
        });
        (0, $7WT4C.sendPackageOperationalEvent)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, $6yOvq.default).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
    } catch (e) {
        (0, $bEUFb.Logger).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
        throw e;
    }
};

});


parcelRegister("fF3Mh", function(module, exports) {
$parcel$export(module.exports, "getValidConsentData", () => $58b04c3d4a0fa5f4$export$c515de1cc9cebc71);

var $3yjSR = parcelRequire("3yjSR");

var $37e9E = parcelRequire("37e9E");

var $hJye1 = parcelRequire("hJye1");
const $58b04c3d4a0fa5f4$export$c515de1cc9cebc71 = async (fallbackConsentToken)=>{
    // Fetches preferences from ConsentHub and returns serialized token data if possible
    const consentData = await (0, $37e9E.fetchConsentPreferences)();
    let { consentToken: consentToken, consentTimestamp: consentTimestamp, consentHubInaccessible: consentHubInaccessible } = consentData;
    let { isValid: isValid } = (0, $hJye1.checkTokenVersionValidity)(consentToken);
    if (isValid && consentHubInaccessible) {
        if (fallbackConsentToken) // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
        // any previously set consents in the interim if we have them.
        consentToken = fallbackConsentToken;
        else {
            const version = (0, $3yjSR.V003_SCHEMA_KEY);
            const consents = consentToken.slice(3, 7);
            // V003 BSC bits set to reflect default consent token status, authenticated user status,
            // and unavailable consentHub records status)
            const serviceBits = '111';
            // Temporary: Sets a default token with V003 properties
            // when ConsentHub is inaccessible and there is not fallback token. This
            // will ensure the banner isn't shown when ConsentHub is down.
            consentToken = `${version}${consents}${serviceBits}`;
        }
    }
    return isValid ? {
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    } : undefined;
};

});
parcelRegister("37e9E", function(module, exports) {
$parcel$export(module.exports, "buildConsentPreferences", () => $62248c49724835b7$export$bd9f5bcbf9cd947c);
$parcel$export(module.exports, "fetchConsentPreferences", () => $62248c49724835b7$export$86467566615ab85e);
$parcel$export(module.exports, "saveConsentPreferences", () => $62248c49724835b7$export$f8422650c3dec8b2);

var $2aEiL = parcelRequire("2aEiL");

var $bEUFb = parcelRequire("bEUFb");

var $jeHvL = parcelRequire("jeHvL");

var $9e4p2 = parcelRequire("9e4p2");
const $62248c49724835b7$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
const $62248c49724835b7$var$POST_CONSENTS_URL = `${$62248c49724835b7$var$BASE_CONSENTS_URL}/user`;
const $62248c49724835b7$var$GET_CONSENTS_URL = `${$62248c49724835b7$var$POST_CONSENTS_URL}/consents/cookies`;
const $62248c49724835b7$var$getConsentHubHeaders = ()=>({
        'Content-Type': 'application/json',
        'X-Request-Origin': 'bsc',
        'X-Request-Origin-App': $62248c49724835b7$var$getProductForConsentHubHeader()
    });
const $62248c49724835b7$var$getProductForConsentHubHeader = ()=>{
    const product = (0, $jeHvL.getBscGlobalState)().product;
    if (!product || product === 'all') return 'unknown';
    if ((0, $2aEiL.fg)('platform_bsc_consent_hub_x_origin_app_normalized')) // ConsentHub buckets anything that is not lowercase and hyphen-separated as `unknown`.
    return product.toLowerCase().replace(/\s+/g, '-');
    return product;
};
const $62248c49724835b7$export$bd9f5bcbf9cd947c = (consentData)=>{
    if (consentData) {
        const serializedConsents = (0, $9e4p2.serializeConsents)(consentData);
        const consentTimestamp = (0, $9e4p2.getConsentTimestamp)(consentData);
        return {
            consentToken: serializedConsents,
            consentTimestamp: consentTimestamp
        };
    }
    // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
    return {
        consentToken: (0, $9e4p2.serializeConsents)({}),
        consentHubInaccessible: true
    };
};
const $62248c49724835b7$export$86467566615ab85e = async ()=>{
    const { origin: origin } = window.location;
    const getFromConsentHubURL = `${origin}${$62248c49724835b7$var$GET_CONSENTS_URL}`;
    try {
        const response = await fetch(getFromConsentHubURL, {
            method: 'GET',
            headers: $62248c49724835b7$var$getConsentHubHeaders()
        });
        if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
        const consentData = await response.json();
        return $62248c49724835b7$export$bd9f5bcbf9cd947c(consentData);
    } catch (err) {
        (0, $bEUFb.Logger).errorWithOperationalEvent({
            action: 'fetchConsentPreferencesError',
            message: err.message || ''
        });
        return $62248c49724835b7$export$bd9f5bcbf9cd947c();
    }
};
const $62248c49724835b7$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
    const { origin: origin, pathname: pathname } = window.location;
    const deserializedConsents = (0, $9e4p2.deserializeConsents)(unpackedUserPreferences, displayedTextMap);
    // Type guard here so TS knows we're working with ConsentPreferenceV003
    const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
    const consentRequestBody = {
        action: action,
        // If there are no consents, it's a first time fill, otherwise it's an update action
        consents: deserializedConsents,
        formUrl: `${origin}${pathname}`,
        locale: 'UNKNOWN',
        site: 'atlassian',
        source: 'COOKIE_PREFERENCES'
    };
    return JSON.stringify(consentRequestBody);
};
const $62248c49724835b7$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
    const saveToConsentHubURL = `${window.location.origin}${$62248c49724835b7$var$POST_CONSENTS_URL}`;
    try {
        const response = await fetch(saveToConsentHubURL, {
            method: 'POST',
            headers: $62248c49724835b7$var$getConsentHubHeaders(),
            body: $62248c49724835b7$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
        });
        // Saving is an async API (we don't know if the save succeeds) so returns 202 Accepted.
        // 401 = User is unauthenticated
        // 5xx = ConsentHub is unavailable
        if (!response.ok || response.status !== 202 && response.status !== 200) {
            const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
            const errWithStatusCode = new (0, $9e4p2.StatusCodeError)(errMsg, response.status);
            throw errWithStatusCode;
        }
    } catch (err) {
        (0, $bEUFb.Logger).errorWithOperationalEvent({
            action: 'saveConsentPreferencesError',
            message: err.message || ''
        });
        // Re-throw to any encapsulating logic, a la `setConsentToken()`
        throw err;
    }
};

});




parcelRegister("hORic", function(module, exports) {
$parcel$export(module.exports, "captureCallerSignals", () => $8558fa0d4e2e4d75$export$9a9299a14dc0c1cb);
$parcel$export(module.exports, "attributeExtensionCaller", () => $8558fa0d4e2e4d75$export$9674893ac982a3cc);
// Detects storage writes made by browser extensions so consent enforcement doesn't block them.
// Chromium family (Chrome, Chromium Edge, Brave, Opera) all use `chrome-extension://`.
// Firefox uses `moz-extension://`; Safari uses `safari-web-extension://`.
// `ms-browser-extension://` is the legacy EdgeHTML
const $8558fa0d4e2e4d75$export$99d1f70e3d2681ed = /(chrome-extension|moz-extension|safari-web-extension|ms-browser-extension):\/\/([^/)\s]+)/;
// A frame's script location, minus the `:line:column`. Matches V8's `at fn (url:1:2)` and
// SpiderMonkey/JavaScriptCore's `fn@url:1:2`.
const $8558fa0d4e2e4d75$var$FRAME_LOCATION = /([a-z][a-z0-9+.-]*:\/\/[^\s)]+?)(?::\d+){0,2}\)?$/i;
// A frame line, not the `Error: ` header V8 prefixes the trace with. V8 starts frames with `at `; the
// other engines use `name@url` and emit no header, so filtering keeps indices comparable.
const $8558fa0d4e2e4d75$var$FRAME_LINE = /^at\s|@/;
// How many leading frames can hold the code that made the write. BSC sits 2 frames above the caller —
// `captureCallerSignals` and the override closure — and neither can be inlined away: the closure is the
// value installed on `setItem`/the cookie accessor, and a minifier won't inline a function containing
// try/catch. The capture is deliberately one function for that reason.
//
// Bounding the scan is the point of this module. Matching an extension URL anywhere in the stack also
// matches every write made by Atlassian code that an extension merely called into, which turns the
// extension allowance into a blanket consent bypass for our own writes.
const $8558fa0d4e2e4d75$var$ORIGINATOR_FRAME_WINDOW = 3;
// Nothing past the window is read. V8 defaults to 10 and a product can lower it, so pin it.
const $8558fa0d4e2e4d75$var$CAPTURED_FRAME_LIMIT = 6;
const $8558fa0d4e2e4d75$var$parseFrames = (stack)=>stack.split('\n').map((line)=>line.trim()).filter((line)=>$8558fa0d4e2e4d75$var$FRAME_LINE.test(line));
const $8558fa0d4e2e4d75$var$asExtensionCaller = (frame)=>{
    const extension = frame?.match($8558fa0d4e2e4d75$var$FRAME_LOCATION)?.[1]?.match($8558fa0d4e2e4d75$export$99d1f70e3d2681ed);
    return extension ? {
        scheme: extension[1],
        id: extension[2]
    } : null;
};
const $8558fa0d4e2e4d75$export$d5f56ab842d0792b = (captured)=>{
    const stack = captured?.stack;
    if (!stack) return null;
    for (const frame of $8558fa0d4e2e4d75$var$parseFrames(stack).slice(0, $8558fa0d4e2e4d75$var$ORIGINATOR_FRAME_WINDOW)){
        const caller = $8558fa0d4e2e4d75$var$asExtensionCaller(frame);
        if (caller) return caller;
    }
    return null;
};
const $8558fa0d4e2e4d75$export$9a9299a14dc0c1cb = ()=>{
    try {
        const previousLimit = Error.stackTraceLimit;
        Error.stackTraceLimit = $8558fa0d4e2e4d75$var$CAPTURED_FRAME_LIMIT;
        const stack = new Error();
        Error.stackTraceLimit = previousLimit;
        return {
            stack: stack
        };
    } catch  {
        return {
            stack: new Error()
        };
    }
};
const $8558fa0d4e2e4d75$export$9674893ac982a3cc = (signals)=>signals ? $8558fa0d4e2e4d75$export$d5f56ab842d0792b(signals.stack) : null;

});






parcelRegister("3OyKJ", function(module, exports) {
$parcel$export(module.exports, "useDevAgentsAIAnalyticsConfig", () => $331c7329165e876b$export$a9f022e9191faebe);
$parcel$export(module.exports, "useDevAgentsAIAnalytics", () => $331c7329165e876b$export$a86bb9493bea602c);

var $1DFor = parcelRequire("1DFor");

var $1v5pe = parcelRequire("1v5pe");

var $aXHSI = parcelRequire("aXHSI");
const $331c7329165e876b$export$a9f022e9191faebe = (config)=>{
    const { fireTrackEvent: fireTrackEvent } = (0, $aXHSI.useDevAIWebAnalyticsClient)();
    const { conversationId: conversationId, ...rest } = config;
    return (0, $1v5pe.useMemo)(()=>({
            product: 'devAi',
            isAIFeature: 1,
            singleInstrumentationID: conversationId,
            ...rest,
            // Forwards each AI event through the AI client's `fireTrackEvent`
            // (which inherits orgId + common analytics data). The first arg is
            // an `InternalAIEvent` union — Confluence-style events nest the
            // same fields under `data`.
            customAnalyticsFire: (aiEvent)=>{
                const eventPayload = 'data' in aiEvent ? aiEvent.data : aiEvent;
                const action = eventPayload.action;
                const actionSubject = eventPayload.actionSubject;
                const source = eventPayload.source ?? '';
                const attributes = eventPayload.attributes ?? {};
                fireTrackEvent({
                    action: action,
                    actionSubject: actionSubject,
                    source: source,
                    attributes: attributes
                });
            }
        }), [
        fireTrackEvent,
        conversationId,
        rest
    ]);
};
const $331c7329165e876b$export$a86bb9493bea602c = (0, $1DFor.useAIEventsInstrumentation);

});
parcelRegister("1DFor", function(module, exports) {
$parcel$export(module.exports, "useAIEventsInstrumentation", () => $fa08892f2b2fec9f$export$ddf49ad062368ad2);

var $1v5pe = parcelRequire("1v5pe");

var $2nfvt = parcelRequire("2nfvt");

var $50qlS = parcelRequire("50qlS");

var $8g8jL = parcelRequire("8g8jL");

var $aqz5d = parcelRequire("aqz5d");

var $2PYYP = parcelRequire("2PYYP");

var $9UJqk = parcelRequire("9UJqk");

var $fy9FQ = parcelRequire("fy9FQ");

var $1anQY = parcelRequire("1anQY");
const $fa08892f2b2fec9f$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $1v5pe.useContext)((0, $aqz5d.AIEventsInstrumentationContext));
    const aiEventAttributesOverride = (0, $1v5pe.useRef)({});
    if (customConfig) context = {
        config: {
            ...(0, $2PYYP.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $1anQY.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $8g8jL.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, aiFeatureId: aiFeatureId, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $1v5pe.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $2nfvt.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $fy9FQ.AISessionState).unset,
            nextState: (0, $2nfvt.P).union((0, $fy9FQ.AISessionState).viewed, (0, $fy9FQ.AISessionState).error, (0, $fy9FQ.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $fy9FQ.AISessionState).initiated,
            nextState: (0, $2nfvt.P).union((0, $fy9FQ.AISessionState).submitted, (0, $fy9FQ.AISessionState).actioned, (0, $fy9FQ.AISessionState).adopted, (0, $fy9FQ.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $1v5pe.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $50qlS.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $1v5pe.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                aiFeatureId: aiFeatureId,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes,
                ...aiEventAttributesOverride.current
            }
        };
        return (0, $2nfvt.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $9UJqk.getTagsWithPlatformTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $2nfvt.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $2nfvt.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        product,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents,
        aiExperienceName,
        aiFeatureName,
        aiFeatureId,
        proactiveGeneratedAI,
        userGeneratedAI,
        isAIFeature
    ]);
    const trackAIInteractionInit = (0, $1v5pe.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $fy9FQ.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $1v5pe.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $fy9FQ.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $1v5pe.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $fy9FQ.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $1v5pe.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $fy9FQ.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $1v5pe.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $fy9FQ.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $1v5pe.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $fy9FQ.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAdopted = (0, $1v5pe.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $fy9FQ.AISessionState).adopted)) return;
        const event = createAndMergeEventPayload({
            action: 'adopted',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $1v5pe.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $fy9FQ.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const updateAIAttributes = (0, $1v5pe.useCallback)((newAttributes)=>{
        aiEventAttributesOverride.current = {
            ...aiEventAttributesOverride.current,
            ...newAttributes
        };
    }, []);
    const baseReturn = {
        updateAIAttributes: updateAIAttributes,
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIResultAdopted: trackAIResultAdopted,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
    return $fa08892f2b2fec9f$var$useStableMethods(baseReturn);
};
/**
 * Returns an object with the same shape as `methods`, but with every method
 * replaced by a stable wrapper that delegates to the latest version. The
 * wrappers are created once on mount; they always read the freshest closure
 * via a ref, so calls observe the same behaviour as calling the unstable
 * methods directly.
 */ function $fa08892f2b2fec9f$var$useStableMethods(methods) {
    const ref = (0, $1v5pe.useRef)(methods);
    ref.current = methods;
    return (0, $1v5pe.useMemo)(()=>{
        const out = {};
        for (const key of Object.keys(ref.current))out[key] = (...args)=>ref.current[key](...args);
        return out;
    // Wrappers always read from `ref.current`; no deps needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});
parcelRegister("50qlS", function(module, exports) {
$parcel$export(module.exports, "FabricChannel", () => $8643eccaf758ede6$export$8faa0b115ef0268b);
var $8643eccaf758ede6$export$8faa0b115ef0268b = /*#__PURE__*/ function(FabricChannel) {
    FabricChannel["a2ui"] = "a2ui";
    FabricChannel["atlaskit"] = "atlaskit";
    FabricChannel["elements"] = "fabric-elements";
    FabricChannel["navigation"] = "navigation";
    FabricChannel["editor"] = "editor";
    FabricChannel["media"] = "media";
    FabricChannel["peopleTeams"] = "peopleTeams";
    FabricChannel["notifications"] = "notifications";
    FabricChannel["recentWork"] = "recentWork";
    FabricChannel["atlas"] = "atlas";
    FabricChannel["crossFlow"] = "crossFlow";
    FabricChannel["linkingPlatform"] = "linkingPlatform";
    FabricChannel["postOffice"] = "postOffice";
    FabricChannel["aiMate"] = "aiMate";
    FabricChannel["avp"] = "avp";
    FabricChannel["growth"] = "growth";
    FabricChannel["omniChannel"] = "omniChannel";
    FabricChannel["townsquareHome"] = "townsquareHome";
    FabricChannel["rovoExtension"] = "rovoExtension";
    FabricChannel["teamworkGraph"] = "teamworkGraph";
    return FabricChannel;
}({});

});

parcelRegister("8g8jL", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $623fc1d773e1d7c1$export$5bf35293e545f20c);

var $dfVKT = parcelRequire("dfVKT");

var $2wC77 = parcelRequire("2wC77");

var $4jgWK = parcelRequire("4jgWK");
function $623fc1d773e1d7c1$export$5bf35293e545f20c() {
    const analyticsContext = (0, $4jgWK.useAnalyticsContext)();
    const createAnalyticsEvent = (0, $dfVKT.useCallbackOne)((payload)=>{
        return new (0, $2wC77.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("dfVKT", function(module, exports) {
$parcel$export(module.exports, "useCallbackOne", () => $9a697a1a20f1eb39$export$33752cf3ee811995);

var $1v5pe = parcelRequire("1v5pe");
function $9a697a1a20f1eb39$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $9a697a1a20f1eb39$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $1v5pe.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $1v5pe.useRef)(true);
    var committed = (0, $1v5pe.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $9a697a1a20f1eb39$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $1v5pe.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $9a697a1a20f1eb39$export$33752cf3ee811995(callback, inputs) {
    return $9a697a1a20f1eb39$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $9a697a1a20f1eb39$export$1538c33de8887b59 = $9a697a1a20f1eb39$export$b6feb8998cd9b342;
var $9a697a1a20f1eb39$export$35808ee640e87ca7 = $9a697a1a20f1eb39$export$33752cf3ee811995;

});

parcelRegister("2wC77", function(module, exports) {
$parcel$export(module.exports, "default", () => $828c4c3689eba8e0$export$2e2bcd8739ae039);
/// <reference types="node" />

var $fHJyA = parcelRequire("fHJyA");
class $828c4c3689eba8e0$export$2e2bcd8739ae039 extends (0, $fHJyA.default) {
    context;
    handlers;
    hasFired;
    _isUIAnalyticsEvent = true;
    constructor(props){
        super(props);
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
    clone = ()=>{
        if (this.hasFired) return null;
        const context = [
            ...this.context
        ];
        const handlers = [
            ...this.handlers
        ];
        const payload = $828c4c3689eba8e0$var$clonePayload(this.payload);
        return new $828c4c3689eba8e0$export$2e2bcd8739ae039({
            context: context,
            handlers: handlers,
            payload: payload
        });
    };
    fire = (channel)=>{
        if (this.hasFired) return;
        this.handlers.forEach((handler)=>{
            try {
                handler(this, channel);
            } catch (e) {}
        });
        this.hasFired = true;
    };
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
}
const $828c4c3689eba8e0$var$clonePayload = (payload)=>{
    try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return {
            ...payload
        };
    }
};

});
parcelRegister("fHJyA", function(module, exports) {
$parcel$export(module.exports, "default", () => $45979b05f235576b$export$2e2bcd8739ae039);
class $45979b05f235576b$export$2e2bcd8739ae039 {
    payload;
    _isAnalyticsEvent = true;
    constructor(props){
        this.payload = props.payload;
    }
    clone = ()=>{
        // just a shallow clone, don't change sub refs unless you want to
        // affect the original's too
        const payload = {
            ...this.payload
        };
        return new $45979b05f235576b$export$2e2bcd8739ae039({
            payload: payload
        });
    };
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = {
            ...this.payload,
            ...updater
        };
        return this;
    }
}

});


parcelRegister("4jgWK", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $bd63b222505563e4$export$d1f587f82ad51c4);

var $1v5pe = parcelRequire("1v5pe");

var $eRjpU = parcelRequire("eRjpU");
const $bd63b222505563e4$export$d1f587f82ad51c4 = ()=>{
    return (0, $1v5pe.useContext)((0, $eRjpU.default));
};

});
parcelRegister("eRjpU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $ad1513b8943145a5$export$2e2bcd8739ae039);

var $aABFI = parcelRequire("aABFI");
var $ad1513b8943145a5$export$2e2bcd8739ae039 = (0, $aABFI.default);

});
parcelRegister("aABFI", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b5a7d05a8905834$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");
var $7b5a7d05a8905834$var$AnalyticsNextContext = (0, $1v5pe.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $7b5a7d05a8905834$export$2e2bcd8739ae039 = $7b5a7d05a8905834$var$AnalyticsNextContext;

});




parcelRegister("9UJqk", function(module, exports) {
$parcel$export(module.exports, "getTagsWithPlatformTag", () => $02ca4317b69201d1$export$e053e424fcbfebe9);
const $02ca4317b69201d1$export$e053e424fcbfebe9 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};

});




parcelRegister("4okYx", function(module, exports) {
$parcel$export(module.exports, "createRoot", () => $3329ac9d1c78579e$export$882461b6382ed46c, (v) => $3329ac9d1c78579e$export$882461b6382ed46c = v);
var $3329ac9d1c78579e$export$882461b6382ed46c;
var $3329ac9d1c78579e$export$757ceba2d55c277e;
'use strict';

var $fBuCt = parcelRequire("fBuCt");
var $3329ac9d1c78579e$var$i;
$3329ac9d1c78579e$export$882461b6382ed46c = $fBuCt.createRoot;
$3329ac9d1c78579e$export$757ceba2d55c277e = $fBuCt.hydrateRoot;

});

parcelRegister("fjzd2", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9a278a35979f368$export$2e2bcd8739ae039);

var $fVlp5 = parcelRequire("fVlp5");
var $a9a278a35979f368$export$2e2bcd8739ae039 = (0, $fVlp5.default);

});
parcelRegister("fVlp5", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b1c2f89981130d3$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $5tITM = parcelRequire("5tITM");

var $hRUfe = parcelRequire("hRUfe");

var $31aDV = parcelRequire("31aDV");

var $insso = parcelRequire("insso");

var $kIqwl = parcelRequire("kIqwl");
const $6b1c2f89981130d3$var$useLayoutEffectSAFE = typeof window === 'undefined' ? (0, $1v5pe.useEffect) : (0, $1v5pe.useLayoutEffect);
/**
 * Custom hook to track changes to the interaction ID.
 * Uses a subscription system to automatically update when the interaction ID changes.
 */ function $6b1c2f89981130d3$var$useInteractionIdValue() {
    const interactionId = (0, $1v5pe.useContext)((0, $31aDV.default));
    const [currentId, setCurrentId] = (0, $1v5pe.useState)(interactionId?.current || null);
    $6b1c2f89981130d3$var$useLayoutEffectSAFE(()=>{
        setCurrentId(interactionId?.current || null);
        const unsubscribe = (0, $insso.subscribeToInteractionIdChanges)((newId)=>{
            setCurrentId(newId);
        });
        return unsubscribe;
    }, [
        interactionId
    ]);
    return currentId;
}
function $6b1c2f89981130d3$export$2e2bcd8739ae039({ children: children, name: name, hold: hold = true }) {
    // Check if UFO is enabled
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, $5tITM.isUFOEnabled)();
    const currentInteractionId = $6b1c2f89981130d3$var$useInteractionIdValue();
    // react-18: useId instead
    const context = (0, $1v5pe.useContext)((0, $hRUfe.default));
    $6b1c2f89981130d3$var$useLayoutEffectSAFE(()=>{
        // Skip hold registration if UFO is disabled
        if (!ufoEnabled) return;
        if (hold && context != null) return context.hold(name);
    }, [
        hold,
        context,
        name,
        currentInteractionId,
        ufoEnabled
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kIqwl.Fragment), {
        children: children
    }) : null;
}

});
parcelRegister("hRUfe", function(module, exports) {
$parcel$export(module.exports, "default", () => $de75a2afdc2c5381$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $7qISg = parcelRequire("7qISg");

var $de75a2afdc2c5381$export$2e2bcd8739ae039 = (0, $7qISg.default);

});
parcelRegister("7qISg", function(module, exports) {
$parcel$export(module.exports, "default", () => $e118919a32101f2b$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");
const $e118919a32101f2b$var$interactionContext = (0, $1v5pe.createContext)(null);
var $e118919a32101f2b$export$2e2bcd8739ae039 = $e118919a32101f2b$var$interactionContext;

});


parcelRegister("31aDV", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ef862ab02d90d26$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $1v5pe = parcelRequire("1v5pe");

var $eIO99 = parcelRequire("eIO99");



// We use a context to allow modals to have their own lifecycle
const $5ef862ab02d90d26$var$interactionContext = (0, $1v5pe.createContext)((0, $eIO99.default));
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$5ef862ab02d90d26$export$2e2bcd8739ae039 = $5ef862ab02d90d26$var$interactionContext;

});



parcelRegister("jgDDj", function(module, exports) {
$parcel$export(module.exports, "useInteractionContext", () => $a38bc7b0db29bfe9$export$11bcb6e9af2aca35);

var $1v5pe = parcelRequire("1v5pe");

var $7qISg = parcelRequire("7qISg");
function $a38bc7b0db29bfe9$export$11bcb6e9af2aca35() {
    return (0, $1v5pe.useContext)((0, $7qISg.default));
}

});

parcelRegister("gtUgB", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ad3d8f0f062d55c$export$2e2bcd8739ae039);

var $2QFT5 = parcelRequire("2QFT5");
var $7ad3d8f0f062d55c$export$2e2bcd8739ae039 = (0, $2QFT5.default);

});
parcelRegister("2QFT5", function(module, exports) {
$parcel$export(module.exports, "default", () => $dfd8660abff8180c$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $fjzd2 = parcelRequire("fjzd2");

var $8AmHC = parcelRequire("8AmHC");

var $aCshG = parcelRequire("aCshG");

var $kIqwl = parcelRequire("kIqwl");
function $dfd8660abff8180c$export$2e2bcd8739ae039({ name: name, children: children, fallback: fallback = null }) {
    const waitContext = (0, $1v5pe.useContext)((0, $aCshG.WaitContext));
    const shouldHold = !waitContext || !!waitContext.currentValue();
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8AmHC.LazySuspense), {
        fallback: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $kIqwl.Fragment), {
            children: [
                fallback,
                /*#__PURE__*/ (0, $kIqwl.jsx)((0, $fjzd2.default), {
                    name: name,
                    hold: shouldHold
                })
            ]
        }),
        name: name,
        children: children
    });
}

});
parcelRegister("8AmHC", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => $57a00f0c5ad82f6b$export$256c542058532d6f);

var $1v5pe = parcelRequire("1v5pe");

var $kIqwl = parcelRequire("kIqwl");
const $57a00f0c5ad82f6b$var$isNodeEnvironment = ()=>{
    return typeof window === 'undefined' || window.name === 'nodejs';
};
const $57a00f0c5ad82f6b$var$LazySuspenseContext = /*#__PURE__*/ (0, $1v5pe.createContext)({
    fallback: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1v5pe.Fragment), {}),
    setFallback: ()=>{
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    },
    name: ''
});
const $57a00f0c5ad82f6b$var$DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
    const { fallback: fallback, setFallback: setFallback } = (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).useContext($57a00f0c5ad82f6b$var$LazySuspenseContext);
    (0, $1v5pe.useLayoutEffect)(()=>{
        return ()=>{
            if (!outsideSuspense) setFallback(null);
        };
    }, [
        outsideSuspense,
        setFallback
    ]);
    return children(outsideSuspense ? null : fallback);
};
$57a00f0c5ad82f6b$var$DynamicFallback.displayName = 'DynamicFallback';
const $57a00f0c5ad82f6b$export$256c542058532d6f = ({ fallback: fallback, children: children, name: name })=>{
    const [hydrationFallback, setHydrationFallback] = (0, $1v5pe.useState)(null);
    const mountedRef = (0, $1v5pe.useRef)(false);
    (0, $1v5pe.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    const contextValue = (0, $1v5pe.useMemo)(()=>({
            fallback: fallback,
            setFallback: (newFallback)=>{
                if (hydrationFallback === newFallback) return;
                setHydrationFallback(newFallback);
            },
            name: name
        }), [
        fallback,
        hydrationFallback,
        name
    ]);
    const renderFallback = (outsideSuspense)=>/*#__PURE__*/ (0, $kIqwl.jsx)($57a00f0c5ad82f6b$var$DynamicFallback, {
            outsideSuspense: outsideSuspense,
            children: (resolvedFallback)=>outsideSuspense && hydrationFallback ? hydrationFallback : resolvedFallback
        });
    return /*#__PURE__*/ (0, $kIqwl.jsx)($57a00f0c5ad82f6b$var$LazySuspenseContext.Provider, {
        value: contextValue,
        children: $57a00f0c5ad82f6b$var$isNodeEnvironment() ? children : /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $kIqwl.Fragment), {
            children: [
                /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1v5pe.Suspense), {
                    fallback: renderFallback(false),
                    children: children
                }),
                (!mountedRef.current || hydrationFallback) && renderFallback(true)
            ]
        })
    });
};
$57a00f0c5ad82f6b$export$256c542058532d6f.displayName = 'LazySuspense';

});

parcelRegister("aCshG", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => $3db65f95887a4d8a$export$9ba3fe09d15de47b);

var $1v5pe = parcelRequire("1v5pe");
const $3db65f95887a4d8a$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $1v5pe.createContext)({
    subscribe: ()=>()=>{},
    currentValue: ()=>1
});

});



parcelRegister("8oX5A", function(module, exports) {
$parcel$export(module.exports, "AuthContextProvider", () => (parcelRequire("5CgYT")).AuthContextProvider);
$parcel$export(module.exports, "useAuthData", () => (parcelRequire("e60FT")).useAuthData);
$parcel$export(module.exports, "authContextProviderQuery", () => (parcelRequire("gfvRq")).default);

var $5CgYT = parcelRequire("5CgYT");

var $e60FT = parcelRequire("e60FT");

var $gfvRq = parcelRequire("gfvRq");

});
parcelRegister("5CgYT", function(module, exports) {
$parcel$export(module.exports, "AuthContextProvider", () => $5556434801cdc770$export$b2316657917319d2);

var $gfvRq = parcelRequire("gfvRq");

var $jEbac = parcelRequire("jEbac");

var $e60FT = parcelRequire("e60FT");

var $kIqwl = parcelRequire("kIqwl");
const $5556434801cdc770$export$b2316657917319d2 = ({ children: children, queryRef: queryRef })=>{
    const data = (0, $jEbac.usePreloadedQuery)((0, $gfvRq.default), queryRef);
    const userData = {
        user: {
            accountId: data.me.user.accountId,
            picture: data.me.user.picture ?? undefined,
            email: data.me.user.email ?? undefined,
            name: data.me.user.name ?? undefined,
            locale: data.me.user.locale ?? 'en-US'
        }
    };
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $e60FT.AuthDataContext).Provider, {
        value: userData,
        children: children
    });
};

});
parcelRegister("gfvRq", function(module, exports) {
$parcel$export(module.exports, "default", () => $402149f04efbf7de$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<24eb897bcb92d9cee263ceb3b922f1e2>>
 * @relayHash 0feb27b7c87c797f1dcb2aa3de16ed96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1e996341592b8748e7470656b64cde194c43241fc967a0068a34cd7da59175bd
const $402149f04efbf7de$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v1 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "picture"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "email"
            },
            {
                "kind": "ScalarField",
                "name": "locale"
            }
        ],
        "type": "AtlassianAccountUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "authContextProviderQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "AuthenticationContext",
                        "kind": "LinkedField",
                        "name": "me",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v0 /*: any*/ ,
                                            "action": "THROW"
                                        },
                                        v1 /*: any*/ 
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "authContextProviderQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v0 /*: any*/ ,
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1e996341592b8748e7470656b64cde194c43241fc967a0068a34cd7da59175bd",
            "metadata": {},
            "name": "authContextProviderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$402149f04efbf7de$var$node.hash = "c2b8e75c9ecbb2325a843ea26f6d5ab8";
var $402149f04efbf7de$export$2e2bcd8739ae039 = $402149f04efbf7de$var$node;

});

parcelRegister("e60FT", function(module, exports) {
$parcel$export(module.exports, "AuthDataContext", () => $8f90e47ceef02b19$export$8d72aed7d7257c6a);
$parcel$export(module.exports, "useAuthData", () => $8f90e47ceef02b19$export$69bbac602c81ca6e);

var $1v5pe = parcelRequire("1v5pe");
const $8f90e47ceef02b19$export$8d72aed7d7257c6a = /*#__PURE__*/ (0, $1v5pe.createContext)(null);
const $8f90e47ceef02b19$export$69bbac602c81ca6e = ()=>{
    const context = (0, $1v5pe.useContext)($8f90e47ceef02b19$export$8d72aed7d7257c6a);
    if (!context) throw new Error('useAuthData must be used within a AuthDataProvider');
    return context;
};

});



parcelRegister("8YStQ", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $375b55442d95c50d$export$e926676385687eaf);

var $hRUfe = parcelRequire("hRUfe");

var $8OjRF = parcelRequire("8OjRF");

var $iO2Nf = parcelRequire("iO2Nf");

var $1v5pe = parcelRequire("1v5pe");

var $jNIYg = parcelRequire("jNIYg");

var $kIqwl = parcelRequire("kIqwl");
const $375b55442d95c50d$export$e926676385687eaf = ({ children: children, fallback: fallback, onError: onError, componentName: componentName })=>{
    const labelStack = (0, $1v5pe.useContext)((0, $hRUfe.default))?.labelStack;
    const handleError = (0, $1v5pe.useCallback)((error, componentStack, eventId)=>{
        const interactionId = (0, $8OjRF.getActiveInteraction)()?.id;
        onError?.(error, componentStack, eventId);
        if (interactionId) (0, $8OjRF.addError)(interactionId, `${componentName}.ErrorBoundary`, labelStack || null, 'errorBoundaryHit', error.message, error.stack);
    }, [
        onError,
        labelStack,
        componentName
    ]);
    const getFallback = ()=>{
        switch(fallback){
            case 'flag':
                return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jNIYg.FlagFallback), {});
            case 'unmount':
                return undefined;
            default:
                return fallback ?? /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jNIYg.DefaultFallback), {});
        }
    };
    return /*#__PURE__*/ (0, $kIqwl.jsx)($iO2Nf.ErrorBoundary, {
        fallback: getFallback(),
        onError: handleError,
        children: children
    });
};

});
parcelRegister("iO2Nf", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $db0f10378c73d9e0$export$e926676385687eaf);

var $fopve = parcelRequire("fopve");
var $1mdNz = parcelRequire("1mdNz");

var $dotLe = parcelRequire("dotLe");
var $4drcP = parcelRequire("4drcP");

var $35aua = parcelRequire("35aua");

var $1v5pe = parcelRequire("1v5pe");

var $gSx5i = parcelRequire("gSx5i");
const $db0f10378c73d9e0$var$_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/errorboundary.tsx";
function $db0f10378c73d9e0$export$a87138b73900f5b(version) {
    const major = version.match(/^([^.]+)/);
    return major !== null && parseInt(major[0]) >= 17;
}
const $db0f10378c73d9e0$export$6ef4c0367e27f2d5 = 'unknown';
const $db0f10378c73d9e0$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
function $db0f10378c73d9e0$var$setCause(error, cause) {
    const seenErrors = new WeakMap();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.set(error, true);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * A ErrorBoundary component that logs errors to Sentry. Requires React >= 16.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ class $db0f10378c73d9e0$export$e926676385687eaf extends $1v5pe.Component {
    constructor(props){
        super(props);
        $db0f10378c73d9e0$export$e926676385687eaf.prototype.__init.call(this);
        this.state = $db0f10378c73d9e0$var$INITIAL_STATE;
        this._openFallbackReportDialog = true;
        const client = (0, $fopve.getClient)();
        if (client && client.on && props.showDialog) {
            this._openFallbackReportDialog = false;
            client.on('afterSendEvent', (event)=>{
                if (!event.type && event.event_id === this._lastEventId) // eslint-disable-next-line deprecation/deprecation
                (0, $1mdNz.showReportDialog)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
    componentDidCatch(error, { componentStack: componentStack }) {
        const { beforeCapture: beforeCapture, onError: onError, showDialog: showDialog, dialogOptions: dialogOptions } = this.props;
        (0, $fopve.withScope)((scope)=>{
            // If on React version >= 17, create stack trace from componentStack param and links
            // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
            // Linking errors requires the `LinkedErrors` integration be enabled.
            // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
            //
            // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
            // with non-error objects. This is why we need to check if the error is an error-like object.
            // See: https://github.com/getsentry/sentry-javascript/issues/6167
            if ($db0f10378c73d9e0$export$a87138b73900f5b($1v5pe.version) && (0, $dotLe.isError)(error)) {
                const errorBoundaryError = new Error(error.message);
                errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
                errorBoundaryError.stack = componentStack;
                // Using the `LinkedErrors` integration to link the errors together.
                $db0f10378c73d9e0$var$setCause(error, errorBoundaryError);
            }
            if (beforeCapture) beforeCapture(scope, error, componentStack);
            const eventId = (0, $fopve.captureException)(error, {
                captureContext: {
                    contexts: {
                        react: {
                            componentStack: componentStack
                        }
                    }
                },
                // If users provide a fallback component we can assume they are handling the error.
                // Therefore, we set the mechanism depending on the presence of the fallback prop.
                mechanism: {
                    handled: !!this.props.fallback
                }
            });
            if (onError) onError(error, componentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, $1mdNz.showReportDialog)({
                    ...dialogOptions,
                    eventId: eventId
                });
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            this.setState({
                error: error,
                componentStack: componentStack,
                eventId: eventId
            });
        });
    }
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) onUnmount(error, componentStack, eventId);
    }
    __init() {
        this.resetErrorBoundary = ()=>{
            const { onReset: onReset } = this.props;
            const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
            if (onReset) onReset(error, componentStack, eventId);
            this.setState($db0f10378c73d9e0$var$INITIAL_STATE);
        };
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const state = this.state;
        if (state.error) {
            let element = undefined;
            if (typeof fallback === 'function') element = fallback({
                error: state.error,
                componentStack: state.componentStack,
                resetError: this.resetErrorBoundary,
                eventId: state.eventId
            });
            else element = fallback;
            if ($1v5pe.isValidElement(element)) return element;
            if (fallback) (0, $gSx5i.DEBUG_BUILD) && (0, $4drcP.logger).warn('fallback did not produce a valid ReactElement');
            // Fail gracefully if no fallback provided or is not valid
            return null;
        }
        if (typeof children === 'function') return children();
        return children;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $db0f10378c73d9e0$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $db0f10378c73d9e0$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>$1v5pe.createElement($db0f10378c73d9e0$export$e926676385687eaf, {
            ...errorBoundaryOptions,
            __self: this,
            __source: {
                fileName: $db0f10378c73d9e0$var$_jsxFileName,
                lineNumber: 240
            }
        }, $1v5pe.createElement(WrappedComponent, {
            ...props,
            __self: this,
            __source: {
                fileName: $db0f10378c73d9e0$var$_jsxFileName,
                lineNumber: 241
            }
        }));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, (/*@__PURE__*/$parcel$interopDefault($35aua)))(Wrapped, WrappedComponent);
    return Wrapped;
}

});
parcelRegister("fopve", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $b34ce13e073b2d86$export$f5282963edea4a68);
$parcel$export(module.exports, "captureEvent", () => $b34ce13e073b2d86$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "addBreadcrumb", () => $b34ce13e073b2d86$export$efda9a273d7a036d);
$parcel$export(module.exports, "withScope", () => $b34ce13e073b2d86$export$ec58d9285c204497);
$parcel$export(module.exports, "getCurrentScope", () => $b34ce13e073b2d86$export$c7be4b0125a10cba);
$parcel$export(module.exports, "getClient", () => $b34ce13e073b2d86$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "startSession", () => $b34ce13e073b2d86$export$c0d84948cecf78d8);
$parcel$export(module.exports, "captureSession", () => $b34ce13e073b2d86$export$667e7b4d445d566b);

var $34PpH = parcelRequire("34PpH");
var $dotLe = parcelRequire("dotLe");
var $4drcP = parcelRequire("4drcP");
var $4bBSq = parcelRequire("4bBSq");
var $jHxHe = parcelRequire("jHxHe");

var $2jZ2R = parcelRequire("2jZ2R");

var $ckw0B = parcelRequire("ckw0B");

var $a2Uuq = parcelRequire("a2Uuq");

var $i1aOi = parcelRequire("i1aOi");

var $3D6Pz = parcelRequire("3D6Pz");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $b34ce13e073b2d86$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $a2Uuq.getCurrentHub)().captureException(exception, (0, $3D6Pz.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $b34ce13e073b2d86$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $a2Uuq.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $b34ce13e073b2d86$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $a2Uuq.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $b34ce13e073b2d86$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $a2Uuq.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $b34ce13e073b2d86$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $a2Uuq.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $b34ce13e073b2d86$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $a2Uuq.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $b34ce13e073b2d86$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $a2Uuq.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $b34ce13e073b2d86$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $a2Uuq.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $b34ce13e073b2d86$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $a2Uuq.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $b34ce13e073b2d86$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $a2Uuq.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $b34ce13e073b2d86$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $a2Uuq.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $b34ce13e073b2d86$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $a2Uuq.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $b34ce13e073b2d86$export$9a4fed82c350c2bd(callback) {
    return (0, $a2Uuq.runWithAsyncContext)(()=>{
        return callback((0, $a2Uuq.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $b34ce13e073b2d86$export$e57ac09b143d92a2(span, callback) {
    return $b34ce13e073b2d86$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $b34ce13e073b2d86$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $a2Uuq.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $b34ce13e073b2d86$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $b34ce13e073b2d86$export$c7be4b0125a10cba();
    const client = $b34ce13e073b2d86$export$6bb76d6eba7e258c();
    if (!client) (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $jHxHe.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $b34ce13e073b2d86$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $b34ce13e073b2d86$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $4bBSq.timestampInSeconds)();
    function finishCheckIn(status) {
        $b34ce13e073b2d86$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $4bBSq.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn('error');
        throw e;
    }
    if ((0, $dotLe.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn('ok');
    }, ()=>{
        finishCheckIn('error');
    });
    else finishCheckIn('ok');
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $b34ce13e073b2d86$export$4909b86c8034bf73(timeout) {
    const client = $b34ce13e073b2d86$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $b34ce13e073b2d86$export$8360e631d277ea4d(timeout) {
    const client = $b34ce13e073b2d86$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $b34ce13e073b2d86$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $a2Uuq.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $b34ce13e073b2d86$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $a2Uuq.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $b34ce13e073b2d86$export$3f95c6f800b78024() {
    return !!$b34ce13e073b2d86$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $b34ce13e073b2d86$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $a2Uuq.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $b34ce13e073b2d86$export$c0d84948cecf78d8(context) {
    const client = $b34ce13e073b2d86$export$6bb76d6eba7e258c();
    const isolationScope = (0, $a2Uuq.getIsolationScope)();
    const currentScope = $b34ce13e073b2d86$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $2jZ2R.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $34PpH.GLOBAL_OBJ).navigator || {};
    const session = (0, $i1aOi.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $i1aOi.updateSession)(currentSession, {
        status: 'exited'
    });
    $b34ce13e073b2d86$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $b34ce13e073b2d86$export$17a5be43989a0bc1() {
    const isolationScope = (0, $a2Uuq.getIsolationScope)();
    const currentScope = $b34ce13e073b2d86$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $i1aOi.closeSession)(session);
    $b34ce13e073b2d86$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $b34ce13e073b2d86$var$_sendSessionUpdate() {
    const isolationScope = (0, $a2Uuq.getIsolationScope)();
    const currentScope = $b34ce13e073b2d86$export$c7be4b0125a10cba();
    const client = $b34ce13e073b2d86$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $b34ce13e073b2d86$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $b34ce13e073b2d86$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $b34ce13e073b2d86$var$_sendSessionUpdate();
}

});
parcelRegister("34PpH", function(module, exports) {
$parcel$export(module.exports, "GLOBAL_OBJ", () => $23d9a07ea7515e70$export$f1a6cdb1459e81d1);
$parcel$export(module.exports, "getGlobalObject", () => $23d9a07ea7515e70$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $23d9a07ea7515e70$export$7e223ec222791509);
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $23d9a07ea7515e70$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $23d9a07ea7515e70$export$f1a6cdb1459e81d1 = typeof globalThis == 'object' && $23d9a07ea7515e70$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == 'object' && $23d9a07ea7515e70$var$isGlobalObj(window) || typeof self == 'object' && $23d9a07ea7515e70$var$isGlobalObj(self) || typeof $parcel$global == 'object' && $23d9a07ea7515e70$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $23d9a07ea7515e70$export$256479dc0cea61c4() {
    return $23d9a07ea7515e70$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $23d9a07ea7515e70$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $23d9a07ea7515e70$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});

parcelRegister("dotLe", function(module, exports) {
$parcel$export(module.exports, "isError", () => $9c049a22c3c9ac7a$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $9c049a22c3c9ac7a$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $9c049a22c3c9ac7a$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $9c049a22c3c9ac7a$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $9c049a22c3c9ac7a$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $9c049a22c3c9ac7a$export$844ec244b1367d54);
$parcel$export(module.exports, "isParameterizedString", () => $9c049a22c3c9ac7a$export$dbcbffa59149b824);
$parcel$export(module.exports, "isPrimitive", () => $9c049a22c3c9ac7a$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $9c049a22c3c9ac7a$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $9c049a22c3c9ac7a$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $9c049a22c3c9ac7a$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $9c049a22c3c9ac7a$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $9c049a22c3c9ac7a$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $9c049a22c3c9ac7a$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $9c049a22c3c9ac7a$export$c9f5652083b8129d);
$parcel$export(module.exports, "isVueViewModel", () => $9c049a22c3c9ac7a$export$7916fad0ebc23f48);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $9c049a22c3c9ac7a$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c049a22c3c9ac7a$export$e6127cc7fe7395c3(wat) {
    switch($9c049a22c3c9ac7a$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $9c049a22c3c9ac7a$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $9c049a22c3c9ac7a$var$isBuiltin(wat, className) {
    return $9c049a22c3c9ac7a$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c049a22c3c9ac7a$export$9f9636d330b71954(wat) {
    return $9c049a22c3c9ac7a$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c049a22c3c9ac7a$export$ef9e2056653f0c8e(wat) {
    return $9c049a22c3c9ac7a$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c049a22c3c9ac7a$export$12e869b2a583f783(wat) {
    return $9c049a22c3c9ac7a$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c049a22c3c9ac7a$export$844ec244b1367d54(wat) {
    return $9c049a22c3c9ac7a$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c049a22c3c9ac7a$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c049a22c3c9ac7a$export$c3825b437cbdea5c(wat) {
    return wat === null || $9c049a22c3c9ac7a$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c049a22c3c9ac7a$export$53b83ca8eaab0383(wat) {
    return $9c049a22c3c9ac7a$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c049a22c3c9ac7a$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $9c049a22c3c9ac7a$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c049a22c3c9ac7a$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $9c049a22c3c9ac7a$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c049a22c3c9ac7a$export$49841c62b9eff15(wat) {
    return $9c049a22c3c9ac7a$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $9c049a22c3c9ac7a$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c049a22c3c9ac7a$export$bc2894c7158efbac(wat) {
    return $9c049a22c3c9ac7a$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c049a22c3c9ac7a$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $9c049a22c3c9ac7a$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c049a22c3c9ac7a$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}

});

parcelRegister("4drcP", function(module, exports) {
$parcel$export(module.exports, "CONSOLE_LEVELS", () => $311d7ada94f616b7$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "originalConsoleMethods", () => $311d7ada94f616b7$export$77c4ce905194557b);
$parcel$export(module.exports, "consoleSandbox", () => $311d7ada94f616b7$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $311d7ada94f616b7$export$af88d00dbe7f521);

var $6gomZ = parcelRequire("6gomZ");

var $34PpH = parcelRequire("34PpH");
/** Prefix for logging strings */ const $311d7ada94f616b7$var$PREFIX = 'Sentry Logger ';
const $311d7ada94f616b7$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $311d7ada94f616b7$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $311d7ada94f616b7$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $34PpH.GLOBAL_OBJ))) return callback();
    const console = (0, $34PpH.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($311d7ada94f616b7$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $311d7ada94f616b7$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $311d7ada94f616b7$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $6gomZ.DEBUG_BUILD) $311d7ada94f616b7$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $311d7ada94f616b7$export$cda52e2a8927a2ca(()=>{
                (0, $34PpH.GLOBAL_OBJ).console[name](`${$311d7ada94f616b7$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $311d7ada94f616b7$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $311d7ada94f616b7$export$af88d00dbe7f521 = $311d7ada94f616b7$var$makeLogger();

});
parcelRegister("6gomZ", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $48f72407a8c0c6f0$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $48f72407a8c0c6f0$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});


parcelRegister("4bBSq", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => $30c592135f5a1184$export$7740643b9eeaf0c4);
$parcel$export(module.exports, "timestampInSeconds", () => $30c592135f5a1184$export$ee52dced521e3e18);

var $34PpH = parcelRequire("34PpH");
const $30c592135f5a1184$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $30c592135f5a1184$export$7740643b9eeaf0c4() {
    return Date.now() / $30c592135f5a1184$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $30c592135f5a1184$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $34PpH.GLOBAL_OBJ);
    if (!performance || !performance.now) return $30c592135f5a1184$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $30c592135f5a1184$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $30c592135f5a1184$export$ee52dced521e3e18 = $30c592135f5a1184$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $30c592135f5a1184$export$c5907b5a8838db13 = $30c592135f5a1184$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $30c592135f5a1184$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $30c592135f5a1184$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $34PpH.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        $30c592135f5a1184$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $30c592135f5a1184$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            $30c592135f5a1184$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $30c592135f5a1184$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();

});

parcelRegister("jHxHe", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $e57c2bdb632b73f8$export$19f53698e68b2496);
$parcel$export(module.exports, "getEventDescription", () => $e57c2bdb632b73f8$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $e57c2bdb632b73f8$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $e57c2bdb632b73f8$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $e57c2bdb632b73f8$export$6de4ffac6a2f1098);
$parcel$export(module.exports, "arrayify", () => $e57c2bdb632b73f8$export$3131421a7d01b4fb);

var $18iHd = parcelRequire("18iHd");

var $hONnT = parcelRequire("hONnT");

var $34PpH = parcelRequire("34PpH");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $e57c2bdb632b73f8$export$19f53698e68b2496() {
    const gbl = (0, $34PpH.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $e57c2bdb632b73f8$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $e57c2bdb632b73f8$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $e57c2bdb632b73f8$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $e57c2bdb632b73f8$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $e57c2bdb632b73f8$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $e57c2bdb632b73f8$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $e57c2bdb632b73f8$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $e57c2bdb632b73f8$export$d364f2020ab30578(input) {
    const match = input.match($e57c2bdb632b73f8$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $e57c2bdb632b73f8$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $hONnT.snipLine)(line, 0));
    frame.context_line = (0, $hONnT.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $hONnT.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $e57c2bdb632b73f8$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $18iHd.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $e57c2bdb632b73f8$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("18iHd", function(module, exports) {
$parcel$export(module.exports, "fill", () => $0d350a706569f49b$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $0d350a706569f49b$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $0d350a706569f49b$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $0d350a706569f49b$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $0d350a706569f49b$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $0d350a706569f49b$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $0d350a706569f49b$export$b0244d5063c0b61b);
$parcel$export(module.exports, "dropUndefinedKeys", () => $0d350a706569f49b$export$d25f2688db1bb433);

var $8Cmwx = parcelRequire("8Cmwx");

var $6gomZ = parcelRequire("6gomZ");

var $dotLe = parcelRequire("dotLe");

var $4drcP = parcelRequire("4drcP");

var $hONnT = parcelRequire("hONnT");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $0d350a706569f49b$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $0d350a706569f49b$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $0d350a706569f49b$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $6gomZ.DEBUG_BUILD) && (0, $4drcP.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $0d350a706569f49b$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $0d350a706569f49b$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $0d350a706569f49b$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $0d350a706569f49b$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $0d350a706569f49b$export$62ff257738bf57f5(value) {
    if ((0, $dotLe.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$0d350a706569f49b$var$getOwnProperties(value)
    };
    else if ((0, $dotLe.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $0d350a706569f49b$var$serializeEventTarget(value.target),
            currentTarget: $0d350a706569f49b$var$serializeEventTarget(value.currentTarget),
            ...$0d350a706569f49b$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $dotLe.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $0d350a706569f49b$var$serializeEventTarget(target) {
    try {
        return (0, $dotLe.isElement)(target) ? (0, $8Cmwx.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $0d350a706569f49b$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $0d350a706569f49b$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($0d350a706569f49b$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $hONnT.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $hONnT.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $0d350a706569f49b$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $0d350a706569f49b$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $0d350a706569f49b$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($0d350a706569f49b$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $0d350a706569f49b$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($0d350a706569f49b$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $0d350a706569f49b$var$isPojo(input) {
    if (!(0, $dotLe.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $0d350a706569f49b$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $dotLe.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("8Cmwx", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $646358157fe55962$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $646358157fe55962$export$1cfafeee2987818b);
$parcel$export(module.exports, "getComponentName", () => $646358157fe55962$export$26727cfcc4d7e0fc);

var $dotLe = parcelRequire("dotLe");

var $34PpH = parcelRequire("34PpH");
// eslint-disable-next-line deprecation/deprecation
const $646358157fe55962$var$WINDOW = (0, $34PpH.getGlobalObject)();
const $646358157fe55962$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $646358157fe55962$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $646358157fe55962$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $646358157fe55962$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $646358157fe55962$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($646358157fe55962$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $dotLe.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $646358157fe55962$export$1cfafeee2987818b() {
    try {
        return $646358157fe55962$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $646358157fe55962$export$c660c1f3ab49225c(selector) {
    if ($646358157fe55962$var$WINDOW.document && $646358157fe55962$var$WINDOW.document.querySelector) return $646358157fe55962$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $646358157fe55962$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$646358157fe55962$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
        currentElem = currentElem.parentNode;
    }
    return null;
}

});

parcelRegister("hONnT", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $cf8d69e8ce2e68ab$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $cf8d69e8ce2e68ab$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $cf8d69e8ce2e68ab$export$465e9d514283d4fd);
$parcel$export(module.exports, "stringMatchesSomePattern", () => $cf8d69e8ce2e68ab$export$a7a5ec66062ea5d);

var $dotLe = parcelRequire("dotLe");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $cf8d69e8ce2e68ab$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $cf8d69e8ce2e68ab$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $cf8d69e8ce2e68ab$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $dotLe.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $cf8d69e8ce2e68ab$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $dotLe.isString)(value)) return false;
    if ((0, $dotLe.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $dotLe.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $cf8d69e8ce2e68ab$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$cf8d69e8ce2e68ab$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("2jZ2R", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", () => $1b0cb56928b07b18$export$849dbeeeda01ae98);
const $1b0cb56928b07b18$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("ckw0B", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $8fa02e8dd4a6de9a$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $8fa02e8dd4a6de9a$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("a2Uuq", function(module, exports) {
$parcel$export(module.exports, "getCurrentHub", () => $7505e8f8892505b9$export$a07cdf6544bbd7c);
$parcel$export(module.exports, "getIsolationScope", () => $7505e8f8892505b9$export$68f3af03034c9e90);
$parcel$export(module.exports, "runWithAsyncContext", () => $7505e8f8892505b9$export$70d775fb1f267027);

var $4drcP = parcelRequire("4drcP");
var $4bBSq = parcelRequire("4bBSq");
var $34PpH = parcelRequire("34PpH");
var $dotLe = parcelRequire("dotLe");
var $jHxHe = parcelRequire("jHxHe");

var $2jZ2R = parcelRequire("2jZ2R");

var $ckw0B = parcelRequire("ckw0B");

var $6fI1x = parcelRequire("6fI1x");

var $i1aOi = parcelRequire("i1aOi");

var $8xtKn = parcelRequire("8xtKn");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $7505e8f8892505b9$export$24a86ef7798177e4 = parseFloat((0, $8xtKn.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $7505e8f8892505b9$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $7505e8f8892505b9$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $7505e8f8892505b9$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $6fI1x.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $6fI1x.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $dotLe.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $jHxHe.uuid4)();
        const syntheticException = new Error('Sentry syntheticException');
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $jHxHe.uuid4)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $jHxHe.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $7505e8f8892505b9$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $4bBSq.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $4drcP.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $7505e8f8892505b9$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $7505e8f8892505b9$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);
        if ((0, $ckw0B.DEBUG_BUILD) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $4drcP.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $4drcP.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod('traceHeaders');
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $i1aOi.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $2jZ2R.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $34PpH.GLOBAL_OBJ).navigator || {};
        const session = (0, $i1aOi.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === 'ok') (0, $i1aOi.updateSession)(currentSession, {
            status: 'exited'
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $7505e8f8892505b9$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $7505e8f8892505b9$export$19eade501500c6c1() {
    (0, $34PpH.GLOBAL_OBJ).__SENTRY__ = (0, $34PpH.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $34PpH.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $7505e8f8892505b9$export$4188a14ad302d1bc(hub) {
    const registry = $7505e8f8892505b9$export$19eade501500c6c1();
    const oldHub = $7505e8f8892505b9$export$bfa8a924a84a76b7(registry);
    $7505e8f8892505b9$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $7505e8f8892505b9$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $7505e8f8892505b9$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $7505e8f8892505b9$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $7505e8f8892505b9$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $7505e8f8892505b9$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $7505e8f8892505b9$var$getGlobalHub(registry = $7505e8f8892505b9$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$7505e8f8892505b9$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $7505e8f8892505b9$export$bfa8a924a84a76b7(registry).isOlderThan($7505e8f8892505b9$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $7505e8f8892505b9$export$849f05434e95d2f2(registry, new $7505e8f8892505b9$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $7505e8f8892505b9$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $7505e8f8892505b9$export$236689a79f5aa020(carrier, parent = $7505e8f8892505b9$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$7505e8f8892505b9$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $7505e8f8892505b9$export$bfa8a924a84a76b7(carrier).isOlderThan($7505e8f8892505b9$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $7505e8f8892505b9$export$849f05434e95d2f2(carrier, new $7505e8f8892505b9$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $7505e8f8892505b9$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $7505e8f8892505b9$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $7505e8f8892505b9$export$70d775fb1f267027(callback, options = {}) {
    const registry = $7505e8f8892505b9$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $7505e8f8892505b9$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $7505e8f8892505b9$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $34PpH.getGlobalSingleton)('hub', ()=>new $7505e8f8892505b9$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $7505e8f8892505b9$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("6fI1x", function(module, exports) {
$parcel$export(module.exports, "Scope", () => $48d64b012143748b$export$775b6bb06e53a214);
$parcel$export(module.exports, "getGlobalScope", () => $48d64b012143748b$export$aa55d5ab8e05984f);

var $4bBSq = parcelRequire("4bBSq");
var $dotLe = parcelRequire("dotLe");
var $4drcP = parcelRequire("4drcP");
var $jHxHe = parcelRequire("jHxHe");

var $2MxQb = parcelRequire("2MxQb");

var $i1aOi = parcelRequire("i1aOi");

var $9OoPG = parcelRequire("9OoPG");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $48d64b012143748b$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $48d64b012143748b$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $48d64b012143748b$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $48d64b012143748b$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $48d64b012143748b$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $48d64b012143748b$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $i1aOi.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $48d64b012143748b$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $dotLe.isPlainObject)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $48d64b012143748b$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $48d64b012143748b$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $4bBSq.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $9OoPG.applyScopeDataToEvent)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $2MxQb.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ];
        return (0, $2MxQb.notifyEventProcessors)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $jHxHe.uuid4)();
        if (!this._client) {
            (0, $4drcP.logger).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $jHxHe.uuid4)();
        if (!this._client) {
            (0, $4drcP.logger).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $jHxHe.uuid4)();
        if (!this._client) {
            (0, $4drcP.logger).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $48d64b012143748b$export$aa55d5ab8e05984f() {
    if (!$48d64b012143748b$var$globalScope) $48d64b012143748b$var$globalScope = new $48d64b012143748b$export$775b6bb06e53a214();
    return $48d64b012143748b$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $48d64b012143748b$export$c83048efd17527d6(scope) {
    $48d64b012143748b$var$globalScope = scope;
}
function $48d64b012143748b$var$generatePropagationContext() {
    return {
        traceId: (0, $jHxHe.uuid4)(),
        spanId: (0, $jHxHe.uuid4)().substring(16)
    };
}

});
parcelRegister("2MxQb", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventProcessors", () => $206a508601bb6100$export$3c4238858b85e8ac);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $206a508601bb6100$export$8e4e25f54d456511);
$parcel$export(module.exports, "notifyEventProcessors", () => $206a508601bb6100$export$bf2a096c3e883e79);

var $34PpH = parcelRequire("34PpH");
var $dotLe = parcelRequire("dotLe");
var $4drcP = parcelRequire("4drcP");
var $g4ejk = parcelRequire("g4ejk");

var $ckw0B = parcelRequire("ckw0B");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $206a508601bb6100$export$3c4238858b85e8ac() {
    return (0, $34PpH.getGlobalSingleton)('globalEventProcessors', ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $206a508601bb6100$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $206a508601bb6100$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $206a508601bb6100$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $g4ejk.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $ckw0B.DEBUG_BUILD) && processor.id && result === null && (0, $4drcP.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $dotLe.isThenable)(result)) result.then((final)=>$206a508601bb6100$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $206a508601bb6100$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("g4ejk", function(module, exports) {
$parcel$export(module.exports, "resolvedSyncPromise", () => $bb281edac528fd13$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $bb281edac528fd13$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $bb281edac528fd13$export$78e43115b553f358);

var $dotLe = parcelRequire("dotLe");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $bb281edac528fd13$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($bb281edac528fd13$var$States || ($bb281edac528fd13$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $bb281edac528fd13$export$1fda8aa4d135f8aa(value) {
    return new $bb281edac528fd13$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $bb281edac528fd13$export$78e43115b553f358(reason) {
    return new $bb281edac528fd13$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $bb281edac528fd13$export$6f292d4960313241 {
    constructor(executor){
        $bb281edac528fd13$export$6f292d4960313241.prototype.__init.call(this);
        $bb281edac528fd13$export$6f292d4960313241.prototype.__init2.call(this);
        $bb281edac528fd13$export$6f292d4960313241.prototype.__init3.call(this);
        $bb281edac528fd13$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $bb281edac528fd13$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $bb281edac528fd13$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $bb281edac528fd13$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($bb281edac528fd13$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($bb281edac528fd13$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $bb281edac528fd13$var$States.PENDING) return;
            if ((0, $dotLe.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $bb281edac528fd13$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $bb281edac528fd13$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $bb281edac528fd13$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});


parcelRegister("i1aOi", function(module, exports) {
$parcel$export(module.exports, "makeSession", () => $d1e0b4b283bf7618$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $d1e0b4b283bf7618$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $d1e0b4b283bf7618$export$56521d9ba90f62ee);

var $18iHd = parcelRequire("18iHd");
var $4bBSq = parcelRequire("4bBSq");
var $jHxHe = parcelRequire("jHxHe");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $d1e0b4b283bf7618$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $4bBSq.timestampInSeconds)();
    const session = {
        sid: (0, $jHxHe.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$d1e0b4b283bf7618$var$sessionToJSON(session)
    };
    if (context) $d1e0b4b283bf7618$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $d1e0b4b283bf7618$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $4bBSq.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $jHxHe.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $d1e0b4b283bf7618$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $d1e0b4b283bf7618$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $d1e0b4b283bf7618$var$sessionToJSON(session) {
    return (0, $18iHd.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});

parcelRegister("9OoPG", function(module, exports) {
$parcel$export(module.exports, "applyScopeDataToEvent", () => $724c0bd1687696aa$export$43988bc651a80216);
$parcel$export(module.exports, "mergeScopeData", () => $724c0bd1687696aa$export$25ac7e259a513db4);

var $jHxHe = parcelRequire("jHxHe");
var $18iHd = parcelRequire("18iHd");

var $1OyBH = parcelRequire("1OyBH");

var $6ZiLO = parcelRequire("6ZiLO");

var $gpj6O = parcelRequire("gpj6O");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $724c0bd1687696aa$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $724c0bd1687696aa$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $724c0bd1687696aa$var$applySpanToEvent(event, span);
    $724c0bd1687696aa$var$applyFingerprintToEvent(event, fingerprint);
    $724c0bd1687696aa$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $724c0bd1687696aa$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $724c0bd1687696aa$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $724c0bd1687696aa$export$b1a120a2871faa46(data, 'extra', extra);
    $724c0bd1687696aa$export$b1a120a2871faa46(data, 'tags', tags);
    $724c0bd1687696aa$export$b1a120a2871faa46(data, 'user', user);
    $724c0bd1687696aa$export$b1a120a2871faa46(data, 'contexts', contexts);
    $724c0bd1687696aa$export$b1a120a2871faa46(data, 'sdkProcessingMetadata', sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $724c0bd1687696aa$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $724c0bd1687696aa$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $18iHd.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $18iHd.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $18iHd.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $18iHd.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $724c0bd1687696aa$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $724c0bd1687696aa$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $724c0bd1687696aa$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $gpj6O.spanToTraceContext)(span),
        ...event.contexts
    };
    const rootSpan = (0, $6ZiLO.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $1OyBH.getDynamicSamplingContextFromSpan)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $gpj6O.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $724c0bd1687696aa$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $jHxHe.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("1OyBH", function(module, exports) {
$parcel$export(module.exports, "getDynamicSamplingContextFromClient", () => $15254e3903f1d75c$export$366bad00d6815eed);
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", () => $15254e3903f1d75c$export$a117f995597e25df);

var $18iHd = parcelRequire("18iHd");

var $2jZ2R = parcelRequire("2jZ2R");

var $fopve = parcelRequire("fopve");

var $6ZiLO = parcelRequire("6ZiLO");

var $gpj6O = parcelRequire("gpj6O");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $15254e3903f1d75c$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $18iHd.dropUndefinedKeys)({
        environment: options.environment || (0, $2jZ2R.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $15254e3903f1d75c$export$a117f995597e25df(span) {
    const client = (0, $fopve.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $15254e3903f1d75c$export$366bad00d6815eed((0, $gpj6O.spanToJSON)(span).trace_id || '', client, (0, $fopve.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $6ZiLO.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $gpj6O.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== 'url') dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $gpj6O.spanIsSampled)(txn));
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}

});
parcelRegister("6ZiLO", function(module, exports) {
$parcel$export(module.exports, "getRootSpan", () => $5166fff2907ab9fc$export$c4c6a79b1260ca1b);
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $5166fff2907ab9fc$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

});

parcelRegister("gpj6O", function(module, exports) {
$parcel$export(module.exports, "spanToTraceContext", () => $bf1dcdc0e75be194$export$46c6fbd1d265ebf0);
$parcel$export(module.exports, "spanToJSON", () => $bf1dcdc0e75be194$export$92d8c23565496537);
$parcel$export(module.exports, "spanIsSampled", () => $bf1dcdc0e75be194$export$5caecac1caaf3a71);

var $18iHd = parcelRequire("18iHd");
var $fGCys = parcelRequire("fGCys");
var $4bBSq = parcelRequire("4bBSq");
// These are aligned with OpenTelemetry trace flags
const $bf1dcdc0e75be194$export$208d5b368507fb8b = 0x0;
const $bf1dcdc0e75be194$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $bf1dcdc0e75be194$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $bf1dcdc0e75be194$export$92d8c23565496537(span);
    return (0, $18iHd.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $bf1dcdc0e75be194$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $bf1dcdc0e75be194$export$5caecac1caaf3a71(span);
    return (0, $fGCys.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $bf1dcdc0e75be194$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $bf1dcdc0e75be194$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $bf1dcdc0e75be194$var$ensureTimestampInSeconds(input.getTime());
    return (0, $4bBSq.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $bf1dcdc0e75be194$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $bf1dcdc0e75be194$export$92d8c23565496537(span) {
    if ($bf1dcdc0e75be194$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === 'function') // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $bf1dcdc0e75be194$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $bf1dcdc0e75be194$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $bf1dcdc0e75be194$export$eb571cd9b5d98de8);
}

});
parcelRegister("fGCys", function(module, exports) {
$parcel$export(module.exports, "generateSentryTraceHeader", () => $b6b8af73e5002142$export$f35d907436da45cf);

var $wJj5L = parcelRequire("wJj5L");

var $jHxHe = parcelRequire("jHxHe");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $b6b8af73e5002142$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $b6b8af73e5002142$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($b6b8af73e5002142$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $b6b8af73e5002142$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $b6b8af73e5002142$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $wJj5L.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $jHxHe.uuid4)(),
            spanId: (0, $jHxHe.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $jHxHe.uuid4)(),
            parentSpanId: parentSpanId || (0, $jHxHe.uuid4)().substring(16),
            spanId: (0, $jHxHe.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $b6b8af73e5002142$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $b6b8af73e5002142$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $wJj5L.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $jHxHe.uuid4)(),
        spanId: (0, $jHxHe.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $jHxHe.uuid4)(),
        parentSpanId: parentSpanId || (0, $jHxHe.uuid4)().substring(16),
        spanId: (0, $jHxHe.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $b6b8af73e5002142$export$f35d907436da45cf(traceId = (0, $jHxHe.uuid4)(), spanId = (0, $jHxHe.uuid4)().substring(16), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}

});
parcelRegister("wJj5L", function(module, exports) {
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", () => $06262249881269a8$export$5b96ee2c8421f107);

var $6gomZ = parcelRequire("6gomZ");

var $dotLe = parcelRequire("dotLe");

var $4drcP = parcelRequire("4drcP");
const $06262249881269a8$export$9ca9946bd449ac06 = 'baggage';
const $06262249881269a8$export$6e69537d67fa20f = 'sentry-';
const $06262249881269a8$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $06262249881269a8$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $06262249881269a8$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $dotLe.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $06262249881269a8$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $06262249881269a8$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($06262249881269a8$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($06262249881269a8$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $06262249881269a8$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$06262249881269a8$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $06262249881269a8$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $06262249881269a8$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $06262249881269a8$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $06262249881269a8$export$bdd844ddb2def819) {
            (0, $6gomZ.DEBUG_BUILD) && (0, $4drcP.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});






parcelRegister("8xtKn", function(module, exports) {
$parcel$export(module.exports, "SDK_VERSION", () => $63787aecc1034a81$export$31499a9cd224b78c);
const $63787aecc1034a81$export$31499a9cd224b78c = '7.120.4';

});


parcelRegister("3D6Pz", function(module, exports) {
$parcel$export(module.exports, "prepareEvent", () => $2a4a5010b80c8bc1$export$2d67fb380bd11267);
$parcel$export(module.exports, "parseEventHintOrCaptureContext", () => $2a4a5010b80c8bc1$export$76b5f966996d1653);

var $jHxHe = parcelRequire("jHxHe");
var $4bBSq = parcelRequire("4bBSq");
var $34PpH = parcelRequire("34PpH");
var $73XIK = parcelRequire("73XIK");
var $hONnT = parcelRequire("hONnT");

var $2jZ2R = parcelRequire("2jZ2R");

var $2MxQb = parcelRequire("2MxQb");

var $6fI1x = parcelRequire("6fI1x");

var $9OoPG = parcelRequire("9OoPG");

var $gpj6O = parcelRequire("gpj6O");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $2a4a5010b80c8bc1$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $jHxHe.uuid4)(),
        timestamp: event.timestamp || (0, $4bBSq.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $2a4a5010b80c8bc1$var$applyClientOptions(prepared, options);
    $2a4a5010b80c8bc1$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $2a4a5010b80c8bc1$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $2a4a5010b80c8bc1$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $jHxHe.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $6fI1x.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $9OoPG.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $9OoPG.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $9OoPG.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $2MxQb.getGlobalEventProcessors)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $2MxQb.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $2a4a5010b80c8bc1$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $2a4a5010b80c8bc1$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $2a4a5010b80c8bc1$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, $2jZ2R.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $hONnT.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $hONnT.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $hONnT.truncate)(request.url, maxValueLength);
}
const $2a4a5010b80c8bc1$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $2a4a5010b80c8bc1$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $34PpH.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $2a4a5010b80c8bc1$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $2a4a5010b80c8bc1$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $2a4a5010b80c8bc1$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $2a4a5010b80c8bc1$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $2a4a5010b80c8bc1$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $73XIK.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $73XIK.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $73XIK.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $73XIK.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $73XIK.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $gpj6O.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $73XIK.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $2a4a5010b80c8bc1$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $6fI1x.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $2a4a5010b80c8bc1$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($2a4a5010b80c8bc1$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($2a4a5010b80c8bc1$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $2a4a5010b80c8bc1$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $6fI1x.Scope) || typeof hint === 'function';
}
const $2a4a5010b80c8bc1$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $2a4a5010b80c8bc1$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$2a4a5010b80c8bc1$var$captureContextKeys.includes(key));
}

});
parcelRegister("73XIK", function(module, exports) {
$parcel$export(module.exports, "normalize", () => $524723823ea2db64$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $524723823ea2db64$export$23fbbb20bed71033);

var $dotLe = parcelRequire("dotLe");

var $bM4Xl = parcelRequire("bM4Xl");

var $18iHd = parcelRequire("18iHd");

var $iiLLw = parcelRequire("iiLLw");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $524723823ea2db64$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $524723823ea2db64$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $524723823ea2db64$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $524723823ea2db64$export$a3295358bff77e(object, depth);
    if ($524723823ea2db64$var$jsonSize(normalized) > maxSize) return $524723823ea2db64$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $524723823ea2db64$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $bM4Xl.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $dotLe.isNaN)(value)) return value;
    const stringified = $524723823ea2db64$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $524723823ea2db64$export$588732934346abbf('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $18iHd.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $524723823ea2db64$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $524723823ea2db64$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $dotLe.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $dotLe.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        if (typeof value === 'function') return `[Function: ${(0, $iiLLw.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $524723823ea2db64$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $524723823ea2db64$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $524723823ea2db64$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $524723823ea2db64$var$jsonSize(value) {
    return $524723823ea2db64$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $524723823ea2db64$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}

});
parcelRegister("bM4Xl", function(module, exports) {
$parcel$export(module.exports, "memoBuilder", () => $8928059b55fe617f$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $8928059b55fe617f$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("iiLLw", function(module, exports) {
$parcel$export(module.exports, "createStackParser", () => $d52ef5a674347cb8$export$a5739666fb2d03d4);
$parcel$export(module.exports, "stackParserFromStackParserOptions", () => $d52ef5a674347cb8$export$1d5cf88b347146d4);
$parcel$export(module.exports, "getFunctionName", () => $d52ef5a674347cb8$export$aad197c7121a6651);

var $87rdZ = parcelRequire("87rdZ");
const $d52ef5a674347cb8$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $d52ef5a674347cb8$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $d52ef5a674347cb8$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $d52ef5a674347cb8$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $d52ef5a674347cb8$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($d52ef5a674347cb8$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $d52ef5a674347cb8$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $d52ef5a674347cb8$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $d52ef5a674347cb8$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $d52ef5a674347cb8$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $d52ef5a674347cb8$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($d52ef5a674347cb8$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($d52ef5a674347cb8$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    }
    return localStack.slice(0, $d52ef5a674347cb8$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || '?'
        }));
}
const $d52ef5a674347cb8$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $d52ef5a674347cb8$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $d52ef5a674347cb8$var$defaultFunctionName;
        return fn.name || $d52ef5a674347cb8$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $d52ef5a674347cb8$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $d52ef5a674347cb8$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $87rdZ.node)(getModule)
    ];
}

});
parcelRegister("87rdZ", function(module, exports) {
$parcel$export(module.exports, "node", () => $5e94186f66dfab3d$export$35059013cd4a06db);
/**
 * Does this filename look like it's part of the app code?
 */ function $5e94186f66dfab3d$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith('/') && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith('.') && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes('node_modules/');
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $5e94186f66dfab3d$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || '<anonymous>';
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === 'native';
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $5e94186f66dfab3d$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});





parcelRegister("1mdNz", function(module, exports) {
$parcel$export(module.exports, "init", () => $0fd28c9ae4a77016$export$2cd8252107eb640b);
$parcel$export(module.exports, "showReportDialog", () => $0fd28c9ae4a77016$export$3a8fd680da42627b);

var $fopve = parcelRequire("fopve");
var $h1hB5 = parcelRequire("h1hB5");
var $a2Uuq = parcelRequire("a2Uuq");
var $hvFMZ = parcelRequire("hvFMZ");
var $aN3Gs = parcelRequire("aN3Gs");
var $3oNmT = parcelRequire("3oNmT");
var $9PSpe = parcelRequire("9PSpe");

var $j8w51 = parcelRequire("j8w51");
var $4drcP = parcelRequire("4drcP");
var $iiLLw = parcelRequire("iiLLw");
var $8DLVl = parcelRequire("8DLVl");

var $kHE0Y = parcelRequire("kHE0Y");

var $cNd6k = parcelRequire("cNd6k");

var $5mFGM = parcelRequire("5mFGM");

var $3jQIp = parcelRequire("3jQIp");

var $943cD = parcelRequire("943cD");

var $2frTJ = parcelRequire("2frTJ");

var $bTy7P = parcelRequire("bTy7P");

var $jru71 = parcelRequire("jru71");

var $ifPHN = parcelRequire("ifPHN");

var $aEtMI = parcelRequire("aEtMI");

var $22AST = parcelRequire("22AST");

var $bTVcz = parcelRequire("bTVcz");
/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $0fd28c9ae4a77016$export$5ef831fccfce35e5 = [
    (0, $3oNmT.inboundFiltersIntegration)(),
    (0, $h1hB5.functionToStringIntegration)(),
    (0, $ifPHN.browserApiErrorsIntegration)(),
    (0, $3jQIp.breadcrumbsIntegration)(),
    (0, $2frTJ.globalHandlersIntegration)(),
    (0, $jru71.linkedErrorsIntegration)(),
    (0, $943cD.dedupeIntegration)(),
    (0, $bTy7P.httpContextIntegration)()
];
/** Get the default integrations for the browser SDK. */ function $0fd28c9ae4a77016$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$0fd28c9ae4a77016$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $0fd28c9ae4a77016$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $0fd28c9ae4a77016$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === 'string') options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $5mFGM.WINDOW).SENTRY_RELEASE && (0, $5mFGM.WINDOW).SENTRY_RELEASE.id) options.release = (0, $5mFGM.WINDOW).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $iiLLw.stackParserFromStackParserOptions)(options.stackParser || (0, $aEtMI.defaultStackParser)),
        integrations: (0, $hvFMZ.getIntegrationsToSetup)(options),
        transport: options.transport || ((0, $8DLVl.supportsFetch)() ? (0, $22AST.makeFetchTransport) : (0, $bTVcz.makeXHRTransport))
    };
    (0, $9PSpe.initAndBind)((0, $kHE0Y.BrowserClient), clientOptions);
    if (options.autoSessionTracking) $0fd28c9ae4a77016$var$startSessionTracking();
}
const $0fd28c9ae4a77016$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $a2Uuq.getCurrentHub)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $5mFGM.WINDOW).document) {
        (0, $cNd6k.DEBUG_BUILD) && (0, $4drcP.logger).error('Global document not defined in showReportDialog call');
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $cNd6k.DEBUG_BUILD) && (0, $4drcP.logger).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $5mFGM.WINDOW).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $aN3Gs.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $5mFGM.WINDOW).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $5mFGM.WINDOW).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $5mFGM.WINDOW).document.head || (0, $5mFGM.WINDOW).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $cNd6k.DEBUG_BUILD) && (0, $4drcP.logger).error('Not injecting report dialog. No injection point found in HTML');
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $0fd28c9ae4a77016$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $0fd28c9ae4a77016$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0fd28c9ae4a77016$export$4997ffc0176396a6(fn) {
    return (0, $5mFGM.wrap)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $0fd28c9ae4a77016$var$startSessionTracking() {
    if (typeof (0, $5mFGM.WINDOW).document === 'undefined') {
        (0, $cNd6k.DEBUG_BUILD) && (0, $4drcP.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $fopve.startSession)({
        ignoreDuration: true
    });
    (0, $fopve.captureSession)();
    // We want to create a session for every navigation as well
    (0, $j8w51.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $fopve.startSession)({
                ignoreDuration: true
            });
            (0, $fopve.captureSession)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $0fd28c9ae4a77016$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $fopve.getClient)();
    if (client) client.captureUserFeedback(feedback);
}

});
parcelRegister("h1hB5", function(module, exports) {
$parcel$export(module.exports, "functionToStringIntegration", () => $c6402e1aca0043c8$export$7918117e9202e4fb);
$parcel$export(module.exports, "FunctionToString", () => $c6402e1aca0043c8$export$da4704525c20ae79);

var $18iHd = parcelRequire("18iHd");

var $fopve = parcelRequire("fopve");

var $hvFMZ = parcelRequire("hvFMZ");
let $c6402e1aca0043c8$var$originalFunctionToString;
const $c6402e1aca0043c8$var$INTEGRATION_NAME = 'FunctionToString';
const $c6402e1aca0043c8$var$SETUP_CLIENTS = new WeakMap();
const $c6402e1aca0043c8$var$_functionToStringIntegration = ()=>{
    return {
        name: $c6402e1aca0043c8$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $c6402e1aca0043c8$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $18iHd.getOriginalFunction)(this);
                    const context = $c6402e1aca0043c8$var$SETUP_CLIENTS.has((0, $fopve.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $c6402e1aca0043c8$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $c6402e1aca0043c8$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $c6402e1aca0043c8$export$7918117e9202e4fb = (0, $hvFMZ.defineIntegration)($c6402e1aca0043c8$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $c6402e1aca0043c8$export$da4704525c20ae79 = (0, $hvFMZ.convertIntegrationFnToClass)($c6402e1aca0043c8$var$INTEGRATION_NAME, $c6402e1aca0043c8$export$7918117e9202e4fb);

});
parcelRegister("hvFMZ", function(module, exports) {
$parcel$export(module.exports, "getIntegrationsToSetup", () => $cbf5bf66034c620e$export$68bc4c01ab8ae766);
$parcel$export(module.exports, "setupIntegrations", () => $cbf5bf66034c620e$export$51abed9797baa598);
$parcel$export(module.exports, "setupIntegration", () => $cbf5bf66034c620e$export$e7390a03b70a6f2f);
$parcel$export(module.exports, "afterSetupIntegrations", () => $cbf5bf66034c620e$export$35abcfd71227c6ca);
$parcel$export(module.exports, "convertIntegrationFnToClass", () => $cbf5bf66034c620e$export$afa219bf23651160);
$parcel$export(module.exports, "defineIntegration", () => $cbf5bf66034c620e$export$2323046b9414659f);

var $jHxHe = parcelRequire("jHxHe");
var $4drcP = parcelRequire("4drcP");

var $ckw0B = parcelRequire("ckw0B");

var $2MxQb = parcelRequire("2MxQb");

var $fopve = parcelRequire("fopve");

var $a2Uuq = parcelRequire("a2Uuq");
const $cbf5bf66034c620e$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $cbf5bf66034c620e$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $cbf5bf66034c620e$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') integrations = (0, $jHxHe.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $cbf5bf66034c620e$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $cbf5bf66034c620e$var$findIndex(finalIntegrations, (integration)=>integration.name === 'Debug');
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $cbf5bf66034c620e$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $cbf5bf66034c620e$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $cbf5bf66034c620e$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $cbf5bf66034c620e$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($cbf5bf66034c620e$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $2MxQb.addGlobalEventProcessor), (0, $a2Uuq.getCurrentHub));
        $cbf5bf66034c620e$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = (event, hint)=>callback(event, hint, client);
        processor.id = integration.name;
        client.addEventProcessor(processor);
    }
    (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $cbf5bf66034c620e$export$2d8f5188773bcddd(integration) {
    const client = (0, $fopve.getClient)();
    if (!client || !client.addIntegration) {
        (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $cbf5bf66034c620e$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $cbf5bf66034c620e$export$afa219bf23651160(name, fn) {
    const ConvertedIntegration = function ConvertedIntegration(...args) {
        return fn(...args);
    };
    ConvertedIntegration.id = name;
    return ConvertedIntegration;
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $cbf5bf66034c620e$export$2323046b9414659f(fn) {
    return fn;
}

});


parcelRegister("aN3Gs", function(module, exports) {
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $7db1567d969f93d3$export$9964600bfe84e6a3);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $7db1567d969f93d3$export$671c7ed8e40a7a57);

var $c3khB = parcelRequire("c3khB");
var $18iHd = parcelRequire("18iHd");
const $7db1567d969f93d3$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $7db1567d969f93d3$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $7db1567d969f93d3$var$_getIngestEndpoint(dsn) {
    return `${$7db1567d969f93d3$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $7db1567d969f93d3$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $18iHd.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $7db1567d969f93d3$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $7db1567d969f93d3$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$7db1567d969f93d3$var$_getIngestEndpoint(dsn)}?${$7db1567d969f93d3$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $7db1567d969f93d3$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $c3khB.makeDsn)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$7db1567d969f93d3$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $c3khB.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

});
parcelRegister("c3khB", function(module, exports) {
$parcel$export(module.exports, "dsnToString", () => $8c657fa204e1a0a3$export$44d472fbb931a776);
$parcel$export(module.exports, "makeDsn", () => $8c657fa204e1a0a3$export$128827c3562ec0cb);

var $6gomZ = parcelRequire("6gomZ");

var $4drcP = parcelRequire("4drcP");
/** Regular expression used to parse a Dsn. */ const $8c657fa204e1a0a3$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $8c657fa204e1a0a3$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $8c657fa204e1a0a3$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $8c657fa204e1a0a3$export$b892860177f70a30(str) {
    const match = $8c657fa204e1a0a3$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $4drcP.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $8c657fa204e1a0a3$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $8c657fa204e1a0a3$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $8c657fa204e1a0a3$var$validateDsn(dsn) {
    if (!(0, $6gomZ.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $4drcP.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $4drcP.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$8c657fa204e1a0a3$var$isValidProtocol(protocol)) {
        (0, $4drcP.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $4drcP.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $8c657fa204e1a0a3$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $8c657fa204e1a0a3$export$b892860177f70a30(from) : $8c657fa204e1a0a3$var$dsnFromComponents(from);
    if (!components || !$8c657fa204e1a0a3$var$validateDsn(components)) return undefined;
    return components;
}

});


parcelRegister("3oNmT", function(module, exports) {
$parcel$export(module.exports, "inboundFiltersIntegration", () => $2799e877a953e5bb$export$cb3c5c2ceb9818ba);
$parcel$export(module.exports, "InboundFilters", () => $2799e877a953e5bb$export$2ffbb5359dcc6be4);

var $jHxHe = parcelRequire("jHxHe");
var $4drcP = parcelRequire("4drcP");
var $hONnT = parcelRequire("hONnT");

var $ckw0B = parcelRequire("ckw0B");

var $hvFMZ = parcelRequire("hvFMZ");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $2799e877a953e5bb$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $2799e877a953e5bb$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $2799e877a953e5bb$var$INTEGRATION_NAME = 'InboundFilters';
const $2799e877a953e5bb$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $2799e877a953e5bb$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $2799e877a953e5bb$var$_mergeOptions(options, clientOptions);
            return $2799e877a953e5bb$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $2799e877a953e5bb$export$cb3c5c2ceb9818ba = (0, $hvFMZ.defineIntegration)($2799e877a953e5bb$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $2799e877a953e5bb$export$2ffbb5359dcc6be4 = (0, $hvFMZ.convertIntegrationFnToClass)($2799e877a953e5bb$var$INTEGRATION_NAME, $2799e877a953e5bb$export$cb3c5c2ceb9818ba);
function $2799e877a953e5bb$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $2799e877a953e5bb$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $2799e877a953e5bb$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $2799e877a953e5bb$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $2799e877a953e5bb$var$_isSentryError(event)) {
        (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $jHxHe.getEventDescription)(event)}`);
        return true;
    }
    if ($2799e877a953e5bb$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $jHxHe.getEventDescription)(event)}`);
        return true;
    }
    if ($2799e877a953e5bb$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $jHxHe.getEventDescription)(event)}`);
        return true;
    }
    if ($2799e877a953e5bb$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $jHxHe.getEventDescription)(event)}.\nUrl: ${$2799e877a953e5bb$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$2799e877a953e5bb$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $jHxHe.getEventDescription)(event)}.\nUrl: ${$2799e877a953e5bb$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $2799e877a953e5bb$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $2799e877a953e5bb$var$_getPossibleEventMessages(event).some((message)=>(0, $hONnT.stringMatchesSomePattern)(message, ignoreErrors));
}
function $2799e877a953e5bb$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $hONnT.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $2799e877a953e5bb$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $2799e877a953e5bb$var$_getEventFilterUrl(event);
    return !url ? false : (0, $hONnT.stringMatchesSomePattern)(url, denyUrls);
}
function $2799e877a953e5bb$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $2799e877a953e5bb$var$_getEventFilterUrl(event);
    return !url ? true : (0, $hONnT.stringMatchesSomePattern)(url, allowUrls);
}
function $2799e877a953e5bb$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $ckw0B.DEBUG_BUILD) && possibleMessages.length === 0) (0, $4drcP.logger).error(`Could not extract message for event ${(0, $jHxHe.getEventDescription)(event)}`);
    return possibleMessages;
}
function $2799e877a953e5bb$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $2799e877a953e5bb$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $2799e877a953e5bb$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $2799e877a953e5bb$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).error(`Cannot extract url for event ${(0, $jHxHe.getEventDescription)(event)}`);
        return null;
    }
}

});

parcelRegister("9PSpe", function(module, exports) {
$parcel$export(module.exports, "initAndBind", () => $7293145ad055ae5b$export$5333c3f1c58d9bc1);

var $4drcP = parcelRequire("4drcP");

var $ckw0B = parcelRequire("ckw0B");

var $fopve = parcelRequire("fopve");

var $a2Uuq = parcelRequire("a2Uuq");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $7293145ad055ae5b$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $ckw0B.DEBUG_BUILD) (0, $4drcP.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $4drcP.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $fopve.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $7293145ad055ae5b$export$ecb76f41d43c0e43(client);
    $7293145ad055ae5b$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $7293145ad055ae5b$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $a2Uuq.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $7293145ad055ae5b$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}

});

parcelRegister("j8w51", function(module, exports) {
$parcel$export(module.exports, "addHistoryInstrumentationHandler", () => $dee7a61d52bc0861$export$3f18c56c58114e75);

var $18iHd = parcelRequire("18iHd");



var $34PpH = parcelRequire("34PpH");

var $lzh2C = parcelRequire("lzh2C");

var $35xZg = parcelRequire("35xZg");
const $dee7a61d52bc0861$var$WINDOW = (0, $34PpH.GLOBAL_OBJ);
let $dee7a61d52bc0861$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $dee7a61d52bc0861$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $35xZg.addHandler)(type, handler);
    (0, $35xZg.maybeInstrument)(type, $dee7a61d52bc0861$var$instrumentHistory);
}
function $dee7a61d52bc0861$var$instrumentHistory() {
    if (!(0, $lzh2C.supportsHistory)()) return;
    const oldOnPopState = $dee7a61d52bc0861$var$WINDOW.onpopstate;
    $dee7a61d52bc0861$var$WINDOW.onpopstate = function(...args) {
        const to = $dee7a61d52bc0861$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $dee7a61d52bc0861$var$lastHref;
        $dee7a61d52bc0861$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $35xZg.triggerHandlers)('history', handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $dee7a61d52bc0861$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $dee7a61d52bc0861$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $35xZg.triggerHandlers)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $18iHd.fill)($dee7a61d52bc0861$var$WINDOW.history, 'pushState', historyReplacementFunction);
    (0, $18iHd.fill)($dee7a61d52bc0861$var$WINDOW.history, 'replaceState', historyReplacementFunction);
}

});
parcelRegister("lzh2C", function(module, exports) {
$parcel$export(module.exports, "supportsHistory", () => $fb3a15eadbc7b974$export$67fc34576016d6ec);

var $34PpH = parcelRequire("34PpH");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $fb3a15eadbc7b974$var$WINDOW = (0, $34PpH.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $fb3a15eadbc7b974$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $fb3a15eadbc7b974$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = 'history' in $fb3a15eadbc7b974$var$WINDOW && !!$fb3a15eadbc7b974$var$WINDOW.history.pushState && !!$fb3a15eadbc7b974$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});

parcelRegister("35xZg", function(module, exports) {
$parcel$export(module.exports, "addHandler", () => $23fc33d7b4fa5045$export$a4e09611e30da72e);
$parcel$export(module.exports, "maybeInstrument", () => $23fc33d7b4fa5045$export$e18d6c5462c01368);
$parcel$export(module.exports, "triggerHandlers", () => $23fc33d7b4fa5045$export$b18c893e424d3127);

var $6gomZ = parcelRequire("6gomZ");

var $4drcP = parcelRequire("4drcP");

var $iiLLw = parcelRequire("iiLLw");
// We keep the handlers globally
const $23fc33d7b4fa5045$var$handlers = {};
const $23fc33d7b4fa5045$var$instrumented = {};
/** Add a handler function. */ function $23fc33d7b4fa5045$export$a4e09611e30da72e(type, handler) {
    $23fc33d7b4fa5045$var$handlers[type] = $23fc33d7b4fa5045$var$handlers[type] || [];
    $23fc33d7b4fa5045$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $23fc33d7b4fa5045$export$b17eab759a1cb5fe() {
    Object.keys($23fc33d7b4fa5045$var$handlers).forEach((key)=>{
        $23fc33d7b4fa5045$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $23fc33d7b4fa5045$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$23fc33d7b4fa5045$var$instrumented[type]) {
        instrumentFn();
        $23fc33d7b4fa5045$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $23fc33d7b4fa5045$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $23fc33d7b4fa5045$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $6gomZ.DEBUG_BUILD) && (0, $4drcP.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $iiLLw.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("8DLVl", function(module, exports) {
$parcel$export(module.exports, "supportsFetch", () => $64a723eb19feec34$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFetch", () => $64a723eb19feec34$export$18cf36ed71d733e7);
$parcel$export(module.exports, "supportsNativeFetch", () => $64a723eb19feec34$export$c82d238e23c40b21);

var $6gomZ = parcelRequire("6gomZ");

var $4drcP = parcelRequire("4drcP");

var $34PpH = parcelRequire("34PpH");
// eslint-disable-next-line deprecation/deprecation
const $64a723eb19feec34$var$WINDOW = (0, $34PpH.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $64a723eb19feec34$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $64a723eb19feec34$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $64a723eb19feec34$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $64a723eb19feec34$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $64a723eb19feec34$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $64a723eb19feec34$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $64a723eb19feec34$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$64a723eb19feec34$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($64a723eb19feec34$export$18cf36ed71d733e7($64a723eb19feec34$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $64a723eb19feec34$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $64a723eb19feec34$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $6gomZ.DEBUG_BUILD) && (0, $4drcP.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $64a723eb19feec34$export$531055a6c684a70a() {
    return 'ReportingObserver' in $64a723eb19feec34$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $64a723eb19feec34$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$64a723eb19feec34$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("kHE0Y", function(module, exports) {
$parcel$export(module.exports, "BrowserClient", () => $f126dce613d8f400$export$1df9218a526d318d);

var $hYbv2 = parcelRequire("hYbv2");
var $fwF75 = parcelRequire("fwF75");

var $2gO2a = parcelRequire("2gO2a");
var $c3khB = parcelRequire("c3khB");
var $grc1H = parcelRequire("grc1H");
var $4drcP = parcelRequire("4drcP");

var $cNd6k = parcelRequire("cNd6k");

var $5LiDS = parcelRequire("5LiDS");

var $5mFGM = parcelRequire("5mFGM");

var $7FW19 = parcelRequire("7FW19");
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $f126dce613d8f400$export$1df9218a526d318d extends (0, $fwF75.BaseClient) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $5mFGM.WINDOW).SENTRY_SDK_SOURCE || (0, $grc1H.getSDKSource)();
        (0, $hYbv2.applySdkMetadata)(options, 'browser', [
            'browser'
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $5mFGM.WINDOW).document) (0, $5mFGM.WINDOW).document.addEventListener('visibilitychange', ()=>{
            if ((0, $5mFGM.WINDOW).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $5LiDS.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = 'info', hint) {
        return (0, $5LiDS.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $cNd6k.DEBUG_BUILD) && (0, $4drcP.logger).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $7FW19.createUserFeedbackEnvelope)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $cNd6k.DEBUG_BUILD) && (0, $4drcP.logger).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $cNd6k.DEBUG_BUILD) && (0, $4drcP.logger).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $cNd6k.DEBUG_BUILD) && (0, $4drcP.logger).log('Sending outcomes:', outcomes);
        const envelope = (0, $2gO2a.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $c3khB.dsnToString)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}

});
parcelRegister("hYbv2", function(module, exports) {
$parcel$export(module.exports, "applySdkMetadata", () => $d150f5dce61769b7$export$b9f95b027256052c);

var $8xtKn = parcelRequire("8xtKn");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $d150f5dce61769b7$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $8xtKn.SDK_VERSION)
            })),
        version: (0, $8xtKn.SDK_VERSION)
    };
    options._metadata = metadata;
}

});

parcelRegister("fwF75", function(module, exports) {
$parcel$export(module.exports, "BaseClient", () => $b4d9bc70dd74b9ea$export$4f22f74eddb7716a);

var $67YmR = parcelRequire("67YmR");
var $jHxHe = parcelRequire("jHxHe");
var $dotLe = parcelRequire("dotLe");
var $4drcP = parcelRequire("4drcP");
var $c3khB = parcelRequire("c3khB");
var $g4ejk = parcelRequire("g4ejk");
var $k1NUX = parcelRequire("k1NUX");

var $aN3Gs = parcelRequire("aN3Gs");

var $ckw0B = parcelRequire("ckw0B");

var $3vvK4 = parcelRequire("3vvK4");

var $fopve = parcelRequire("fopve");

var $a2Uuq = parcelRequire("a2Uuq");

var $hvFMZ = parcelRequire("hvFMZ");

var $iNA9s = parcelRequire("iNA9s");

var $i1aOi = parcelRequire("i1aOi");

var $1OyBH = parcelRequire("1OyBH");

var $3D6Pz = parcelRequire("3D6Pz");
const $b4d9bc70dd74b9ea$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $b4d9bc70dd74b9ea$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $c3khB.makeDsn)(options.dsn);
        else (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $aN3Gs.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $jHxHe.checkOrSetAlreadyCaught)(exception)) {
            (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).log($b4d9bc70dd74b9ea$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $dotLe.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $dotLe.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $jHxHe.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).log($b4d9bc70dd74b9ea$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === 'string')) (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $i1aOi.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $g4ejk.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $hvFMZ.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $hvFMZ.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $3vvK4.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $67YmR.addItemToEnvelope)(env, (0, $67YmR.createAttachmentEnvelopeItem)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $3vvK4.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === 'number' ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $iNA9s.createMetricEnvelope)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $hvFMZ.setupIntegrations)(this, integrations);
        (0, $hvFMZ.afterSetupIntegrations)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $i1aOi.updateSession)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $g4ejk.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $a2Uuq.getIsolationScope)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        return (0, $3D6Pz.prepareEvent)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $1OyBH.getDynamicSamplingContextFromClient)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $ckw0B.DEBUG_BUILD) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === 'log') (0, $4drcP.logger).log(sentryError.message);
                else (0, $4drcP.logger).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $b4d9bc70dd74b9ea$var$isTransactionEvent(event);
        const isError = $b4d9bc70dd74b9ea$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $g4ejk.rejectedSyncPromise)(new (0, $k1NUX.SentryError)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $k1NUX.SentryError)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $b4d9bc70dd74b9ea$var$processBeforeSend(options, prepared, hint);
            return $b4d9bc70dd74b9ea$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw new (0, $k1NUX.SentryError)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $k1NUX.SentryError)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $k1NUX.SentryError)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).error('Error while sending event:', reason);
        });
        else (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).error('Transport disabled');
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $b4d9bc70dd74b9ea$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $dotLe.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $dotLe.isPlainObject)(event) && event !== null) throw new (0, $k1NUX.SentryError)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $k1NUX.SentryError)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $dotLe.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $k1NUX.SentryError)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $b4d9bc70dd74b9ea$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($b4d9bc70dd74b9ea$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($b4d9bc70dd74b9ea$var$isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            const spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                spanCountBeforeProcessing: spanCountBefore
            };
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function $b4d9bc70dd74b9ea$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $b4d9bc70dd74b9ea$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $b4d9bc70dd74b9ea$export$9aac0b9f77928fbf(callback) {
    const client = (0, $fopve.getClient)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}

});
parcelRegister("67YmR", function(module, exports) {
$parcel$export(module.exports, "createEnvelope", () => $4762394f3dcb5379$export$f93f7f385160c44e);
$parcel$export(module.exports, "addItemToEnvelope", () => $4762394f3dcb5379$export$d650323442802f6f);
$parcel$export(module.exports, "forEachEnvelopeItem", () => $4762394f3dcb5379$export$c56c55acf0136fd3);
$parcel$export(module.exports, "serializeEnvelope", () => $4762394f3dcb5379$export$32f9b428425aac85);
$parcel$export(module.exports, "createAttachmentEnvelopeItem", () => $4762394f3dcb5379$export$d8fc80952cc31fa4);
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", () => $4762394f3dcb5379$export$b11169581eeaf237);
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", () => $4762394f3dcb5379$export$d369f3b2758f6743);
$parcel$export(module.exports, "createEventEnvelopeHeaders", () => $4762394f3dcb5379$export$92b6093782fe661b);

var $c3khB = parcelRequire("c3khB");

var $73XIK = parcelRequire("73XIK");

var $18iHd = parcelRequire("18iHd");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $4762394f3dcb5379$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $4762394f3dcb5379$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $4762394f3dcb5379$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $4762394f3dcb5379$export$604a45d95a155e2b(envelope, types) {
    return $4762394f3dcb5379$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $4762394f3dcb5379$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $4762394f3dcb5379$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $4762394f3dcb5379$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === 'string' ? $4762394f3dcb5379$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $73XIK.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $4762394f3dcb5379$var$concatBuffers(parts);
}
function $4762394f3dcb5379$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $4762394f3dcb5379$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $4762394f3dcb5379$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === 'string' ? $4762394f3dcb5379$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $18iHd.dropUndefinedKeys)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $4762394f3dcb5379$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    statsd: 'metric_bucket'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $4762394f3dcb5379$export$b11169581eeaf237(type) {
    return $4762394f3dcb5379$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $4762394f3dcb5379$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $4762394f3dcb5379$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $c3khB.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $18iHd.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}

});

parcelRegister("k1NUX", function(module, exports) {
$parcel$export(module.exports, "SentryError", () => $e94a9f3ba1327a78$export$5949942ba2a7c0e2);
/** An error emitted by Sentry SDKs and related utilities. */ class $e94a9f3ba1327a78$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}

});

parcelRegister("3vvK4", function(module, exports) {
$parcel$export(module.exports, "createSessionEnvelope", () => $28dce3a76530e7de$export$124b03c077baa2f3);
$parcel$export(module.exports, "createEventEnvelope", () => $28dce3a76530e7de$export$c31057337a18010f);

var $67YmR = parcelRequire("67YmR");
var $c3khB = parcelRequire("c3khB");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $28dce3a76530e7de$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $28dce3a76530e7de$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $67YmR.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $c3khB.dsnToString)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $67YmR.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $28dce3a76530e7de$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $67YmR.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $28dce3a76530e7de$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $67YmR.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $67YmR.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}

});

parcelRegister("iNA9s", function(module, exports) {
$parcel$export(module.exports, "createMetricEnvelope", () => $daf8d890135d7447$export$f23eb96e33154901);

var $67YmR = parcelRequire("67YmR");
var $c3khB = parcelRequire("c3khB");

var $gF8dQ = parcelRequire("gF8dQ");
/**
 * Create envelope from a metric aggregate.
 */ function $daf8d890135d7447$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $c3khB.dsnToString)(dsn);
    const item = $daf8d890135d7447$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $67YmR.createEnvelope)(headers, [
        item
    ]);
}
function $daf8d890135d7447$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $gF8dQ.serializeMetricBuckets)(metricBucketItems);
    const metricHeaders = {
        type: 'statsd',
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}

});
parcelRegister("gF8dQ", function(module, exports) {
$parcel$export(module.exports, "serializeMetricBuckets", () => $c216da793ca98eb6$export$66decd709db01dc8);

var $18iHd = parcelRequire("18iHd");
/**
 * Generate bucket key from metric properties.
 */ function $c216da793ca98eb6$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $18iHd.dropUndefinedKeys)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $c216da793ca98eb6$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $c216da793ca98eb6$export$66decd709db01dc8(metricBucketItems) {
    let out = '';
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(',')}` : '';
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $c216da793ca98eb6$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, '_');
}
/** Sanitizes metric keys */ function $c216da793ca98eb6$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, '_');
}
function $c216da793ca98eb6$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, '');
}
const $c216da793ca98eb6$var$tagValueReplacements = [
    [
        '\n',
        '\\n'
    ],
    [
        '\r',
        '\\r'
    ],
    [
        '\t',
        '\\t'
    ],
    [
        '\\',
        '\\\\'
    ],
    [
        '|',
        "\\u{7c}"
    ],
    [
        ',',
        "\\u{2c}"
    ]
];
function $c216da793ca98eb6$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $c216da793ca98eb6$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $c216da793ca98eb6$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $c216da793ca98eb6$var$getCharOrReplacement(char), '');
}
/**
 * Sanitizes tags.
 */ function $c216da793ca98eb6$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $c216da793ca98eb6$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $c216da793ca98eb6$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}

});



parcelRegister("2gO2a", function(module, exports) {
$parcel$export(module.exports, "createClientReportEnvelope", () => $1a73e31d019a728c$export$f3b9ed77c03eeb00);

var $67YmR = parcelRequire("67YmR");

var $4bBSq = parcelRequire("4bBSq");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $1a73e31d019a728c$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $4bBSq.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $67YmR.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("grc1H", function(module, exports) {
$parcel$export(module.exports, "getSDKSource", () => $bf787f267e915111$export$8ad33f488b1ab046);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $bf787f267e915111$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $bf787f267e915111$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRegister("cNd6k", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $9504393aa8816db8$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $9504393aa8816db8$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("5LiDS", function(module, exports) {
$parcel$export(module.exports, "exceptionFromError", () => $431fcd7ef12a7a1e$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $431fcd7ef12a7a1e$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $431fcd7ef12a7a1e$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $431fcd7ef12a7a1e$export$5425b53185d13d6c);

var $fopve = parcelRequire("fopve");

var $jHxHe = parcelRequire("jHxHe");
var $18iHd = parcelRequire("18iHd");
var $dotLe = parcelRequire("dotLe");
var $73XIK = parcelRequire("73XIK");
var $g4ejk = parcelRequire("g4ejk");
/**
 * This function creates an exception from a JavaScript Error
 */ function $431fcd7ef12a7a1e$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $431fcd7ef12a7a1e$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $431fcd7ef12a7a1e$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
/**
 * @hidden
 */ function $431fcd7ef12a7a1e$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $fopve.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $dotLe.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $431fcd7ef12a7a1e$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $73XIK.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $431fcd7ef12a7a1e$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $431fcd7ef12a7a1e$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $431fcd7ef12a7a1e$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $431fcd7ef12a7a1e$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const popSize = $431fcd7ef12a7a1e$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $431fcd7ef12a7a1e$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $431fcd7ef12a7a1e$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($431fcd7ef12a7a1e$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $431fcd7ef12a7a1e$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $431fcd7ef12a7a1e$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $431fcd7ef12a7a1e$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $jHxHe.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $g4ejk.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $431fcd7ef12a7a1e$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $431fcd7ef12a7a1e$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $g4ejk.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $431fcd7ef12a7a1e$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $dotLe.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $431fcd7ef12a7a1e$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $dotLe.isDOMError)(exception) || (0, $dotLe.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $431fcd7ef12a7a1e$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $dotLe.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $431fcd7ef12a7a1e$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $jHxHe.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $dotLe.isError)(exception)) // we have a real Error object, do nothing
    return $431fcd7ef12a7a1e$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $dotLe.isPlainObject)(exception) || (0, $dotLe.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $431fcd7ef12a7a1e$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $jHxHe.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $431fcd7ef12a7a1e$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $jHxHe.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $jHxHe.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $431fcd7ef12a7a1e$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $431fcd7ef12a7a1e$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $dotLe.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $431fcd7ef12a7a1e$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $18iHd.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $dotLe.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $dotLe.isEvent)(exception)) {
        const className = $431fcd7ef12a7a1e$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $431fcd7ef12a7a1e$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}

});

parcelRegister("5mFGM", function(module, exports) {
$parcel$export(module.exports, "WINDOW", () => $3e7f5865eb6b5175$export$56d8a8a25bd48b81);
$parcel$export(module.exports, "shouldIgnoreOnError", () => $3e7f5865eb6b5175$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $3e7f5865eb6b5175$export$4997ffc0176396a6);


var $fopve = parcelRequire("fopve");

var $jHxHe = parcelRequire("jHxHe");
var $18iHd = parcelRequire("18iHd");
var $34PpH = parcelRequire("34PpH");
const $3e7f5865eb6b5175$export$56d8a8a25bd48b81 = (0, $34PpH.GLOBAL_OBJ);
let $3e7f5865eb6b5175$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $3e7f5865eb6b5175$export$b79738ab10c590b2() {
    return $3e7f5865eb6b5175$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $3e7f5865eb6b5175$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $3e7f5865eb6b5175$var$ignoreOnError++;
    setTimeout(()=>{
        $3e7f5865eb6b5175$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $3e7f5865eb6b5175$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $18iHd.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$3e7f5865eb6b5175$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $3e7f5865eb6b5175$export$1265a142ff5ba165();
            (0, $fopve.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $jHxHe.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $jHxHe.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $fopve.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $18iHd.markFunctionWrapped)(sentryWrapped, fn);
    (0, $18iHd.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}

});

parcelRegister("7FW19", function(module, exports) {
$parcel$export(module.exports, "createUserFeedbackEnvelope", () => $59695dcf876f565e$export$24a4dfcb686ee5bf);

var $67YmR = parcelRequire("67YmR");
var $c3khB = parcelRequire("c3khB");
/**
 * Creates an envelope from a user feedback.
 */ function $59695dcf876f565e$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $c3khB.dsnToString)(dsn)
        }
    };
    const item = $59695dcf876f565e$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $67YmR.createEnvelope)(headers, [
        item
    ]);
}
function $59695dcf876f565e$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}

});


parcelRegister("3jQIp", function(module, exports) {
$parcel$export(module.exports, "breadcrumbsIntegration", () => $26ac099cc9601ee2$export$c079d904b326663a);

var $fopve = parcelRequire("fopve");
var $hvFMZ = parcelRequire("hvFMZ");

var $kDZ4p = parcelRequire("kDZ4p");
var $43yF6 = parcelRequire("43yF6");
var $6NcAr = parcelRequire("6NcAr");
var $j8w51 = parcelRequire("j8w51");
var $gnUpW = parcelRequire("gnUpW");
var $8Cmwx = parcelRequire("8Cmwx");
var $jHxHe = parcelRequire("jHxHe");
var $4drcP = parcelRequire("4drcP");
var $kdoka = parcelRequire("kdoka");
var $hONnT = parcelRequire("hONnT");
var $crmLI = parcelRequire("crmLI");

var $cNd6k = parcelRequire("cNd6k");

var $5mFGM = parcelRequire("5mFGM");
/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $26ac099cc9601ee2$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $26ac099cc9601ee2$var$INTEGRATION_NAME = 'Breadcrumbs';
const $26ac099cc9601ee2$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $26ac099cc9601ee2$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $43yF6.addConsoleInstrumentationHandler)($26ac099cc9601ee2$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $kDZ4p.addClickKeypressInstrumentationHandler)($26ac099cc9601ee2$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $gnUpW.addXhrInstrumentationHandler)($26ac099cc9601ee2$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $6NcAr.addFetchInstrumentationHandler)($26ac099cc9601ee2$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $j8w51.addHistoryInstrumentationHandler)($26ac099cc9601ee2$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on('beforeSendEvent', $26ac099cc9601ee2$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $26ac099cc9601ee2$export$c079d904b326663a = (0, $hvFMZ.defineIntegration)($26ac099cc9601ee2$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $26ac099cc9601ee2$export$2dc68d50d56fbbd = (0, $hvFMZ.convertIntegrationFnToClass)($26ac099cc9601ee2$var$INTEGRATION_NAME, $26ac099cc9601ee2$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $26ac099cc9601ee2$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $fopve.getClient)() !== client) return;
        (0, $fopve.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $jHxHe.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $26ac099cc9601ee2$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $fopve.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $26ac099cc9601ee2$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $cNd6k.DEBUG_BUILD) && (0, $4drcP.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$26ac099cc9601ee2$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$26ac099cc9601ee2$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $26ac099cc9601ee2$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $26ac099cc9601ee2$var$_isEvent(event) ? event.target : event;
            target = (0, $8Cmwx.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $8Cmwx.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $fopve.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $26ac099cc9601ee2$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $fopve.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $crmLI.severityLevelFromString)(handlerData.level),
            message: (0, $hONnT.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $hONnT.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $fopve.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $26ac099cc9601ee2$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $fopve.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $gnUpW.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $fopve.addBreadcrumb)({
            category: 'xhr',
            data: data,
            type: 'http'
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $26ac099cc9601ee2$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $fopve.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $fopve.addBreadcrumb)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $fopve.addBreadcrumb)({
                category: 'fetch',
                data: data,
                type: 'http'
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $26ac099cc9601ee2$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $fopve.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $kdoka.parseUrl)((0, $5mFGM.WINDOW).location.href);
        let parsedFrom = from ? (0, $kdoka.parseUrl)(from) : undefined;
        const parsedTo = (0, $kdoka.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $fopve.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $26ac099cc9601ee2$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("kDZ4p", function(module, exports) {
$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", () => $f076d26fabc8452e$export$5aeffd3db2cf9df7);

var $jHxHe = parcelRequire("jHxHe");

var $18iHd = parcelRequire("18iHd");

var $34PpH = parcelRequire("34PpH");

var $35xZg = parcelRequire("35xZg");
const $f076d26fabc8452e$var$WINDOW = (0, $34PpH.GLOBAL_OBJ);
const $f076d26fabc8452e$var$DEBOUNCE_DURATION = 1000;
let $f076d26fabc8452e$var$debounceTimerID;
let $f076d26fabc8452e$var$lastCapturedEventType;
let $f076d26fabc8452e$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $f076d26fabc8452e$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $35xZg.addHandler)(type, handler);
    (0, $35xZg.maybeInstrument)(type, $f076d26fabc8452e$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $f076d26fabc8452e$export$3014bbf0af0e1d4a() {
    if (!$f076d26fabc8452e$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $35xZg.triggerHandlers).bind(null, 'dom');
    const globalDOMEventHandler = $f076d26fabc8452e$var$makeDOMEventHandler(triggerDOMHandler, true);
    $f076d26fabc8452e$var$WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
    $f076d26fabc8452e$var$WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $f076d26fabc8452e$var$WINDOW[target] && $f076d26fabc8452e$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $18iHd.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $f076d26fabc8452e$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $18iHd.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $f076d26fabc8452e$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $f076d26fabc8452e$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $f076d26fabc8452e$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $f076d26fabc8452e$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $f076d26fabc8452e$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $f076d26fabc8452e$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($f076d26fabc8452e$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $18iHd.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $18iHd.addNonEnumerableProperty)(target, '_sentryId', (0, $jHxHe.uuid4)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$f076d26fabc8452e$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $f076d26fabc8452e$var$lastCapturedEventType = event.type;
            $f076d26fabc8452e$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($f076d26fabc8452e$var$debounceTimerID);
        $f076d26fabc8452e$var$debounceTimerID = $f076d26fabc8452e$var$WINDOW.setTimeout(()=>{
            $f076d26fabc8452e$var$lastCapturedEventTargetId = undefined;
            $f076d26fabc8452e$var$lastCapturedEventType = undefined;
        }, $f076d26fabc8452e$var$DEBOUNCE_DURATION);
    };
}
function $f076d26fabc8452e$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

});

parcelRegister("43yF6", function(module, exports) {
$parcel$export(module.exports, "addConsoleInstrumentationHandler", () => $2f42546622cd7c6f$export$1d6e0d073f9e6723);

var $4drcP = parcelRequire("4drcP");

var $18iHd = parcelRequire("18iHd");

var $34PpH = parcelRequire("34PpH");

var $35xZg = parcelRequire("35xZg");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $2f42546622cd7c6f$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $35xZg.addHandler)(type, handler);
    (0, $35xZg.maybeInstrument)(type, $2f42546622cd7c6f$var$instrumentConsole);
}
function $2f42546622cd7c6f$var$instrumentConsole() {
    if (!('console' in (0, $34PpH.GLOBAL_OBJ))) return;
    (0, $4drcP.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $34PpH.GLOBAL_OBJ).console)) return;
        (0, $18iHd.fill)((0, $34PpH.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $4drcP.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $35xZg.triggerHandlers)('console', handlerData);
                const log = (0, $4drcP.originalConsoleMethods)[level];
                log && log.apply((0, $34PpH.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});

parcelRegister("6NcAr", function(module, exports) {
$parcel$export(module.exports, "addFetchInstrumentationHandler", () => $4f211527544074c2$export$f75d3c772c923df0);

var $18iHd = parcelRequire("18iHd");

var $8DLVl = parcelRequire("8DLVl");

var $34PpH = parcelRequire("34PpH");

var $35xZg = parcelRequire("35xZg");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $4f211527544074c2$export$f75d3c772c923df0(handler) {
    const type = 'fetch';
    (0, $35xZg.addHandler)(type, handler);
    (0, $35xZg.maybeInstrument)(type, $4f211527544074c2$var$instrumentFetch);
}
function $4f211527544074c2$var$instrumentFetch() {
    if (!(0, $8DLVl.supportsNativeFetch)()) return;
    (0, $18iHd.fill)((0, $34PpH.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $4f211527544074c2$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $35xZg.triggerHandlers)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $34PpH.GLOBAL_OBJ), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $35xZg.triggerHandlers)('fetch', finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $35xZg.triggerHandlers)('fetch', erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $4f211527544074c2$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $4f211527544074c2$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($4f211527544074c2$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $4f211527544074c2$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $4f211527544074c2$var$getUrlFromResource(url),
            method: $4f211527544074c2$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $4f211527544074c2$var$getUrlFromResource(arg),
        method: $4f211527544074c2$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}

});

parcelRegister("gnUpW", function(module, exports) {
$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", () => $beda8ea7abbd9a30$export$55b6bb1e45c6cf59);
$parcel$export(module.exports, "addXhrInstrumentationHandler", () => $beda8ea7abbd9a30$export$26ace48dd54c9aea);

var $dotLe = parcelRequire("dotLe");

var $18iHd = parcelRequire("18iHd");

var $34PpH = parcelRequire("34PpH");

var $35xZg = parcelRequire("35xZg");
const $beda8ea7abbd9a30$var$WINDOW = (0, $34PpH.GLOBAL_OBJ);
const $beda8ea7abbd9a30$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $beda8ea7abbd9a30$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $35xZg.addHandler)(type, handler);
    (0, $35xZg.maybeInstrument)(type, $beda8ea7abbd9a30$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $beda8ea7abbd9a30$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$beda8ea7abbd9a30$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $18iHd.fill)(xhrproto, 'open', function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $dotLe.isString)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $beda8ea7abbd9a30$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$beda8ea7abbd9a30$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$beda8ea7abbd9a30$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $35xZg.triggerHandlers)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') (0, $18iHd.fill)(this, 'onreadystatechange', function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $18iHd.fill)(this, 'setRequestHeader', function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$beda8ea7abbd9a30$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $dotLe.isString)(header) && (0, $dotLe.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $18iHd.fill)(xhrproto, 'send', function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$beda8ea7abbd9a30$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $35xZg.triggerHandlers)('xhr', handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $beda8ea7abbd9a30$var$parseUrl(url) {
    if ((0, $dotLe.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}

});

parcelRegister("kdoka", function(module, exports) {
$parcel$export(module.exports, "parseUrl", () => $eb77e3d4c554e366$export$7a5253c0f62e0150);
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $eb77e3d4c554e366$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $eb77e3d4c554e366$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $eb77e3d4c554e366$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $eb77e3d4c554e366$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

});

parcelRegister("crmLI", function(module, exports) {
$parcel$export(module.exports, "severityLevelFromString", () => $90e9ab066a0893c7$export$d771ef054122c30a);
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $90e9ab066a0893c7$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $90e9ab066a0893c7$export$e01cef29b4327697(level) {
    return $90e9ab066a0893c7$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $90e9ab066a0893c7$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : $90e9ab066a0893c7$export$411d0ffdba845b6c.includes(level) ? level : 'log';
}

});


parcelRegister("943cD", function(module, exports) {
$parcel$export(module.exports, "dedupeIntegration", () => $6996f8c6ee43dbd4$export$6d39aa44cd0c7567);

var $hvFMZ = parcelRequire("hvFMZ");

var $4drcP = parcelRequire("4drcP");

var $cNd6k = parcelRequire("cNd6k");
const $6996f8c6ee43dbd4$var$INTEGRATION_NAME = 'Dedupe';
const $6996f8c6ee43dbd4$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $6996f8c6ee43dbd4$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($6996f8c6ee43dbd4$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $cNd6k.DEBUG_BUILD) && (0, $4drcP.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $6996f8c6ee43dbd4$export$6d39aa44cd0c7567 = (0, $hvFMZ.defineIntegration)($6996f8c6ee43dbd4$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $6996f8c6ee43dbd4$export$688d98c249d31ad3 = (0, $hvFMZ.convertIntegrationFnToClass)($6996f8c6ee43dbd4$var$INTEGRATION_NAME, $6996f8c6ee43dbd4$export$6d39aa44cd0c7567);
function $6996f8c6ee43dbd4$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($6996f8c6ee43dbd4$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($6996f8c6ee43dbd4$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $6996f8c6ee43dbd4$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$6996f8c6ee43dbd4$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$6996f8c6ee43dbd4$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $6996f8c6ee43dbd4$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $6996f8c6ee43dbd4$var$_getExceptionFromEvent(previousEvent);
    const currentException = $6996f8c6ee43dbd4$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$6996f8c6ee43dbd4$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$6996f8c6ee43dbd4$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $6996f8c6ee43dbd4$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $6996f8c6ee43dbd4$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $6996f8c6ee43dbd4$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $6996f8c6ee43dbd4$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $6996f8c6ee43dbd4$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $6996f8c6ee43dbd4$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

});

parcelRegister("2frTJ", function(module, exports) {
$parcel$export(module.exports, "globalHandlersIntegration", () => $1a329f6cfae37d4e$export$66acc70e8cf2b71a);

var $fopve = parcelRequire("fopve");
var $hvFMZ = parcelRequire("hvFMZ");

var $aFPET = parcelRequire("aFPET");
var $hFB4b = parcelRequire("hFB4b");
var $8Cmwx = parcelRequire("8Cmwx");
var $dotLe = parcelRequire("dotLe");
var $4drcP = parcelRequire("4drcP");

var $cNd6k = parcelRequire("cNd6k");

var $5LiDS = parcelRequire("5LiDS");

var $5mFGM = parcelRequire("5mFGM");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $1a329f6cfae37d4e$var$INTEGRATION_NAME = 'GlobalHandlers';
const $1a329f6cfae37d4e$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $1a329f6cfae37d4e$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $1a329f6cfae37d4e$var$_installGlobalOnErrorHandler(client);
                $1a329f6cfae37d4e$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $1a329f6cfae37d4e$var$_installGlobalOnUnhandledRejectionHandler(client);
                $1a329f6cfae37d4e$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $1a329f6cfae37d4e$export$66acc70e8cf2b71a = (0, $hvFMZ.defineIntegration)($1a329f6cfae37d4e$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $1a329f6cfae37d4e$export$204155decbc90e5a = (0, $hvFMZ.convertIntegrationFnToClass)($1a329f6cfae37d4e$var$INTEGRATION_NAME, $1a329f6cfae37d4e$export$66acc70e8cf2b71a);
function $1a329f6cfae37d4e$var$_installGlobalOnErrorHandler(client) {
    (0, $aFPET.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $1a329f6cfae37d4e$var$getOptions();
        if ((0, $fopve.getClient)() !== client || (0, $5mFGM.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $dotLe.isString)(msg) ? $1a329f6cfae37d4e$var$_eventFromIncompleteOnError(msg, url, line, column) : $1a329f6cfae37d4e$var$_enhanceEventWithInitialFrame((0, $5LiDS.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $fopve.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $1a329f6cfae37d4e$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $hFB4b.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $1a329f6cfae37d4e$var$getOptions();
        if ((0, $fopve.getClient)() !== client || (0, $5mFGM.shouldIgnoreOnError)()) return;
        const error = $1a329f6cfae37d4e$var$_getUnhandledRejectionError(e);
        const event = (0, $dotLe.isPrimitive)(error) ? $1a329f6cfae37d4e$var$_eventFromRejectionWithPrimitive(error) : (0, $5LiDS.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $fopve.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $1a329f6cfae37d4e$var$_getUnhandledRejectionError(error) {
    if ((0, $dotLe.isPrimitive)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) return e.reason;
        else if ('detail' in e && 'reason' in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $1a329f6cfae37d4e$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1a329f6cfae37d4e$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $dotLe.isErrorEvent)(msg) ? msg.message : msg;
    let name = 'Error';
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $1a329f6cfae37d4e$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1a329f6cfae37d4e$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $dotLe.isString)(url) && url.length > 0 ? url : (0, $8Cmwx.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $1a329f6cfae37d4e$var$globalHandlerLog(type) {
    (0, $cNd6k.DEBUG_BUILD) && (0, $4drcP.logger).log(`Global Handler attached: ${type}`);
}
function $1a329f6cfae37d4e$var$getOptions() {
    const client = (0, $fopve.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

});
parcelRegister("aFPET", function(module, exports) {
$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", () => $7c55ce053032a217$export$55b5c3ba2194f0c6);

var $34PpH = parcelRequire("34PpH");

var $35xZg = parcelRequire("35xZg");
let $7c55ce053032a217$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $7c55ce053032a217$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $35xZg.addHandler)(type, handler);
    (0, $35xZg.maybeInstrument)(type, $7c55ce053032a217$var$instrumentError);
}
function $7c55ce053032a217$var$instrumentError() {
    $7c55ce053032a217$var$_oldOnErrorHandler = (0, $34PpH.GLOBAL_OBJ).onerror;
    (0, $34PpH.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $35xZg.triggerHandlers)('error', handlerData);
        if ($7c55ce053032a217$var$_oldOnErrorHandler && !$7c55ce053032a217$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $7c55ce053032a217$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $34PpH.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("hFB4b", function(module, exports) {
$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", () => $cdd304a3cb81d808$export$8bf4fc6858821a4e);

var $34PpH = parcelRequire("34PpH");

var $35xZg = parcelRequire("35xZg");
let $cdd304a3cb81d808$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $cdd304a3cb81d808$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $35xZg.addHandler)(type, handler);
    (0, $35xZg.maybeInstrument)(type, $cdd304a3cb81d808$var$instrumentUnhandledRejection);
}
function $cdd304a3cb81d808$var$instrumentUnhandledRejection() {
    $cdd304a3cb81d808$var$_oldOnUnhandledRejectionHandler = (0, $34PpH.GLOBAL_OBJ).onunhandledrejection;
    (0, $34PpH.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $35xZg.triggerHandlers)('unhandledrejection', handlerData);
        if ($cdd304a3cb81d808$var$_oldOnUnhandledRejectionHandler && !$cdd304a3cb81d808$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $cdd304a3cb81d808$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $34PpH.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});


parcelRegister("bTy7P", function(module, exports) {
$parcel$export(module.exports, "httpContextIntegration", () => $8a8f4d5607b1937f$export$1378794447170364);

var $hvFMZ = parcelRequire("hvFMZ");

var $5mFGM = parcelRequire("5mFGM");
const $8a8f4d5607b1937f$var$INTEGRATION_NAME = 'HttpContext';
const $8a8f4d5607b1937f$var$_httpContextIntegration = ()=>{
    return {
        name: $8a8f4d5607b1937f$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $5mFGM.WINDOW).navigator && !(0, $5mFGM.WINDOW).location && !(0, $5mFGM.WINDOW).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $5mFGM.WINDOW).location && (0, $5mFGM.WINDOW).location.href;
            const { referrer: referrer } = (0, $5mFGM.WINDOW).document || {};
            const { userAgent: userAgent } = (0, $5mFGM.WINDOW).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $8a8f4d5607b1937f$export$1378794447170364 = (0, $hvFMZ.defineIntegration)($8a8f4d5607b1937f$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $8a8f4d5607b1937f$export$5d2ee9a544b09a94 = (0, $hvFMZ.convertIntegrationFnToClass)($8a8f4d5607b1937f$var$INTEGRATION_NAME, $8a8f4d5607b1937f$export$1378794447170364);

});

parcelRegister("jru71", function(module, exports) {
$parcel$export(module.exports, "linkedErrorsIntegration", () => $e277e59a14baaabf$export$ebabb00eb7f3a395);

var $hvFMZ = parcelRequire("hvFMZ");

var $adduN = parcelRequire("adduN");

var $5LiDS = parcelRequire("5LiDS");
const $e277e59a14baaabf$var$DEFAULT_KEY = 'cause';
const $e277e59a14baaabf$var$DEFAULT_LIMIT = 5;
const $e277e59a14baaabf$var$INTEGRATION_NAME = 'LinkedErrors';
const $e277e59a14baaabf$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $e277e59a14baaabf$var$DEFAULT_LIMIT;
    const key = options.key || $e277e59a14baaabf$var$DEFAULT_KEY;
    return {
        name: $e277e59a14baaabf$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $adduN.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $5LiDS.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $e277e59a14baaabf$export$ebabb00eb7f3a395 = (0, $hvFMZ.defineIntegration)($e277e59a14baaabf$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $e277e59a14baaabf$export$8d1e60aaf616fb4f = (0, $hvFMZ.convertIntegrationFnToClass)($e277e59a14baaabf$var$INTEGRATION_NAME, $e277e59a14baaabf$export$ebabb00eb7f3a395);

});
parcelRegister("adduN", function(module, exports) {
$parcel$export(module.exports, "applyAggregateErrorsToEvent", () => $76f5963a4a037317$export$b91c38ed7d8ae9b2);

var $dotLe = parcelRequire("dotLe");

var $hONnT = parcelRequire("hONnT");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $76f5963a4a037317$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $dotLe.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $76f5963a4a037317$var$truncateAggregateExceptions($76f5963a4a037317$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $76f5963a4a037317$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $dotLe.isInstanceOf)(error[key], Error)) {
        $76f5963a4a037317$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $76f5963a4a037317$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $76f5963a4a037317$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $dotLe.isInstanceOf)(childError, Error)) {
            $76f5963a4a037317$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $76f5963a4a037317$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $76f5963a4a037317$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $76f5963a4a037317$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $76f5963a4a037317$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $76f5963a4a037317$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $hONnT.truncate)(exception.value, maxValueLength);
        return exception;
    });
}

});


parcelRegister("ifPHN", function(module, exports) {
$parcel$export(module.exports, "browserApiErrorsIntegration", () => $d4a1bc5307bcab5d$export$59bfe9f1c76150e);

var $hvFMZ = parcelRequire("hvFMZ");

var $18iHd = parcelRequire("18iHd");
var $iiLLw = parcelRequire("iiLLw");

var $5mFGM = parcelRequire("5mFGM");
const $d4a1bc5307bcab5d$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $d4a1bc5307bcab5d$var$INTEGRATION_NAME = 'TryCatch';
const $d4a1bc5307bcab5d$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $d4a1bc5307bcab5d$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $18iHd.fill)((0, $5mFGM.WINDOW), 'setTimeout', $d4a1bc5307bcab5d$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $18iHd.fill)((0, $5mFGM.WINDOW), 'setInterval', $d4a1bc5307bcab5d$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $18iHd.fill)((0, $5mFGM.WINDOW), 'requestAnimationFrame', $d4a1bc5307bcab5d$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $5mFGM.WINDOW)) (0, $18iHd.fill)(XMLHttpRequest.prototype, 'send', $d4a1bc5307bcab5d$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $d4a1bc5307bcab5d$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($d4a1bc5307bcab5d$var$_wrapEventTarget);
            }
        }
    };
};
const $d4a1bc5307bcab5d$export$59bfe9f1c76150e = (0, $hvFMZ.defineIntegration)($d4a1bc5307bcab5d$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $d4a1bc5307bcab5d$export$f1a018517668e6d3 = (0, $hvFMZ.convertIntegrationFnToClass)($d4a1bc5307bcab5d$var$INTEGRATION_NAME, $d4a1bc5307bcab5d$export$59bfe9f1c76150e);
function $d4a1bc5307bcab5d$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $5mFGM.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $iiLLw.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d4a1bc5307bcab5d$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $5mFGM.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $iiLLw.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $d4a1bc5307bcab5d$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $18iHd.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $iiLLw.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $18iHd.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $iiLLw.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $5mFGM.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $d4a1bc5307bcab5d$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $5mFGM.WINDOW);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $18iHd.fill)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $5mFGM.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $iiLLw.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $5mFGM.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $iiLLw.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $18iHd.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRegister("aEtMI", function(module, exports) {
$parcel$export(module.exports, "defaultStackParser", () => $7c14be6a78315106$export$2b2b997d81bf3907);

var $iiLLw = parcelRequire("iiLLw");
// global reference to slice
const $7c14be6a78315106$var$UNKNOWN_FUNCTION = '?';
const $7c14be6a78315106$var$OPERA10_PRIORITY = 10;
const $7c14be6a78315106$var$OPERA11_PRIORITY = 20;
const $7c14be6a78315106$var$CHROME_PRIORITY = 30;
const $7c14be6a78315106$var$WINJS_PRIORITY = 40;
const $7c14be6a78315106$var$GECKO_PRIORITY = 50;
function $7c14be6a78315106$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $7c14be6a78315106$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $7c14be6a78315106$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $7c14be6a78315106$var$chromeStackParserFn = (line)=>{
    const parts = $7c14be6a78315106$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $7c14be6a78315106$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $7c14be6a78315106$var$extractSafariExtensionDetails(parts[1] || $7c14be6a78315106$var$UNKNOWN_FUNCTION, parts[2]);
        return $7c14be6a78315106$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $7c14be6a78315106$export$263a749fff749872 = [
    $7c14be6a78315106$var$CHROME_PRIORITY,
    $7c14be6a78315106$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $7c14be6a78315106$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $7c14be6a78315106$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $7c14be6a78315106$var$gecko = (line)=>{
    const parts = $7c14be6a78315106$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $7c14be6a78315106$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $7c14be6a78315106$var$UNKNOWN_FUNCTION;
        [func, filename] = $7c14be6a78315106$var$extractSafariExtensionDetails(func, filename);
        return $7c14be6a78315106$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $7c14be6a78315106$export$cdba47a5dd2804d = [
    $7c14be6a78315106$var$GECKO_PRIORITY,
    $7c14be6a78315106$var$gecko
];
const $7c14be6a78315106$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $7c14be6a78315106$var$winjs = (line)=>{
    const parts = $7c14be6a78315106$var$winjsRegex.exec(line);
    return parts ? $7c14be6a78315106$var$createFrame(parts[2], parts[1] || $7c14be6a78315106$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $7c14be6a78315106$export$179460296da408e8 = [
    $7c14be6a78315106$var$WINJS_PRIORITY,
    $7c14be6a78315106$var$winjs
];
const $7c14be6a78315106$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $7c14be6a78315106$var$opera10 = (line)=>{
    const parts = $7c14be6a78315106$var$opera10Regex.exec(line);
    return parts ? $7c14be6a78315106$var$createFrame(parts[2], parts[3] || $7c14be6a78315106$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $7c14be6a78315106$export$f892b52c880ffc7a = [
    $7c14be6a78315106$var$OPERA10_PRIORITY,
    $7c14be6a78315106$var$opera10
];
const $7c14be6a78315106$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $7c14be6a78315106$var$opera11 = (line)=>{
    const parts = $7c14be6a78315106$var$opera11Regex.exec(line);
    return parts ? $7c14be6a78315106$var$createFrame(parts[5], parts[3] || parts[4] || $7c14be6a78315106$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $7c14be6a78315106$export$af11af13f09fb0dc = [
    $7c14be6a78315106$var$OPERA11_PRIORITY,
    $7c14be6a78315106$var$opera11
];
const $7c14be6a78315106$export$7197c0fe6554c079 = [
    $7c14be6a78315106$export$263a749fff749872,
    $7c14be6a78315106$export$cdba47a5dd2804d,
    $7c14be6a78315106$export$179460296da408e8
];
const $7c14be6a78315106$export$2b2b997d81bf3907 = (0, $iiLLw.createStackParser)(...$7c14be6a78315106$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $7c14be6a78315106$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $7c14be6a78315106$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("22AST", function(module, exports) {
$parcel$export(module.exports, "makeFetchTransport", () => $17c8611f8e63dc4a$export$b2311068c46d7cc8);

var $eyj98 = parcelRequire("eyj98");

var $g4ejk = parcelRequire("g4ejk");

var $cCcDz = parcelRequire("cCcDz");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $17c8611f8e63dc4a$export$b2311068c46d7cc8(options, nativeFetch = (0, $cCcDz.getNativeFetchImplementation)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $cCcDz.clearCachedFetchImplementation)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $g4ejk.rejectedSyncPromise)(e);
        }
    }
    return (0, $eyj98.createTransport)(options, makeRequest);
}

});
parcelRegister("eyj98", function(module, exports) {
$parcel$export(module.exports, "createTransport", () => $a98317b47492661a$export$d09f50d9ab7f7b69);

var $67YmR = parcelRequire("67YmR");
var $cyLgV = parcelRequire("cyLgV");
var $4drcP = parcelRequire("4drcP");
var $cfLF1 = parcelRequire("cfLF1");
var $g4ejk = parcelRequire("g4ejk");
var $k1NUX = parcelRequire("k1NUX");

var $ckw0B = parcelRequire("ckw0B");
const $a98317b47492661a$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $a98317b47492661a$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $cfLF1.makePromiseBuffer)(options.bufferSize || $a98317b47492661a$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $67YmR.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $67YmR.envelopeItemTypeToDataCategory)(type);
            if ((0, $cyLgV.isRateLimited)(rateLimits, dataCategory)) {
                const event = $a98317b47492661a$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $g4ejk.resolvedSyncPromise)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $67YmR.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $67YmR.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                const event = $a98317b47492661a$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $67YmR.envelopeItemTypeToDataCategory)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $67YmR.serializeEnvelope)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $cyLgV.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $k1NUX.SentryError)) {
                (0, $ckw0B.DEBUG_BUILD) && (0, $4drcP.logger).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $g4ejk.resolvedSyncPromise)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $a98317b47492661a$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}

});
parcelRegister("cyLgV", function(module, exports) {
$parcel$export(module.exports, "isRateLimited", () => $924d543fa37cd282$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $924d543fa37cd282$export$699aff705e0d49d4);
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $924d543fa37cd282$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $924d543fa37cd282$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $924d543fa37cd282$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $924d543fa37cd282$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $924d543fa37cd282$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $924d543fa37cd282$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $924d543fa37cd282$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $924d543fa37cd282$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});

parcelRegister("cfLF1", function(module, exports) {
$parcel$export(module.exports, "makePromiseBuffer", () => $8ebbdb2fbdf3dcd0$export$85a4f67f852183e6);

var $k1NUX = parcelRequire("k1NUX");

var $g4ejk = parcelRequire("g4ejk");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $8ebbdb2fbdf3dcd0$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $g4ejk.rejectedSyncPromise)(new (0, $k1NUX.SentryError)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $g4ejk.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $g4ejk.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});


parcelRegister("cCcDz", function(module, exports) {
$parcel$export(module.exports, "getNativeFetchImplementation", () => $92f2d6261e278381$export$8be2119ce08e3379);
$parcel$export(module.exports, "clearCachedFetchImplementation", () => $92f2d6261e278381$export$d499686d2dd738c6);

var $8DLVl = parcelRequire("8DLVl");
var $4drcP = parcelRequire("4drcP");

var $cNd6k = parcelRequire("cNd6k");

var $5mFGM = parcelRequire("5mFGM");
let $92f2d6261e278381$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $92f2d6261e278381$export$8be2119ce08e3379() {
    if ($92f2d6261e278381$var$cachedFetchImpl) return $92f2d6261e278381$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $8DLVl.isNativeFetch)((0, $5mFGM.WINDOW).fetch)) return $92f2d6261e278381$var$cachedFetchImpl = (0, $5mFGM.WINDOW).fetch.bind((0, $5mFGM.WINDOW));
    const document = (0, $5mFGM.WINDOW).document;
    let fetchImpl = (0, $5mFGM.WINDOW).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $cNd6k.DEBUG_BUILD) && (0, $4drcP.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $92f2d6261e278381$var$cachedFetchImpl = fetchImpl.bind((0, $5mFGM.WINDOW));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $92f2d6261e278381$export$d499686d2dd738c6() {
    $92f2d6261e278381$var$cachedFetchImpl = undefined;
}

});


parcelRegister("bTVcz", function(module, exports) {
$parcel$export(module.exports, "makeXHRTransport", () => $8aa133dafc06e3b6$export$5e1441cee30d5a39);

var $eyj98 = parcelRequire("eyj98");

var $g4ejk = parcelRequire("g4ejk");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $8aa133dafc06e3b6$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $8aa133dafc06e3b6$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $g4ejk.SyncPromise)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $8aa133dafc06e3b6$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': xhr.getResponseHeader('Retry-After')
                    }
                });
            };
            xhr.open('POST', options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $eyj98.createTransport)(options, makeRequest);
}

});


parcelRegister("35aua", function(module, exports) {
'use strict';

var $eHK3y = parcelRequire("eHK3y");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $23e9f8f01248e898$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $23e9f8f01248e898$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $23e9f8f01248e898$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $23e9f8f01248e898$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $23e9f8f01248e898$var$TYPE_STATICS = {};
$23e9f8f01248e898$var$TYPE_STATICS[$eHK3y.ForwardRef] = $23e9f8f01248e898$var$FORWARD_REF_STATICS;
$23e9f8f01248e898$var$TYPE_STATICS[$eHK3y.Memo] = $23e9f8f01248e898$var$MEMO_STATICS;
function $23e9f8f01248e898$var$getStatics(component) {
    // React v16.11 and below
    if ($eHK3y.isMemo(component)) return $23e9f8f01248e898$var$MEMO_STATICS;
     // React v16.12 and above
    return $23e9f8f01248e898$var$TYPE_STATICS[component['$$typeof']] || $23e9f8f01248e898$var$REACT_STATICS;
}
var $23e9f8f01248e898$var$defineProperty = Object.defineProperty;
var $23e9f8f01248e898$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $23e9f8f01248e898$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $23e9f8f01248e898$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $23e9f8f01248e898$var$getPrototypeOf = Object.getPrototypeOf;
var $23e9f8f01248e898$var$objectPrototype = Object.prototype;
function $23e9f8f01248e898$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($23e9f8f01248e898$var$objectPrototype) {
            var inheritedComponent = $23e9f8f01248e898$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $23e9f8f01248e898$var$objectPrototype) $23e9f8f01248e898$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $23e9f8f01248e898$var$getOwnPropertyNames(sourceComponent);
        if ($23e9f8f01248e898$var$getOwnPropertySymbols) keys = keys.concat($23e9f8f01248e898$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $23e9f8f01248e898$var$getStatics(targetComponent);
        var sourceStatics = $23e9f8f01248e898$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$23e9f8f01248e898$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $23e9f8f01248e898$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $23e9f8f01248e898$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $23e9f8f01248e898$var$hoistNonReactStatics;

});
parcelRegister("eHK3y", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3TsFs"));

});
parcelRegister("3TsFs", function(module, exports) {
$parcel$export(module.exports, "AsyncMode", () => $2d5cbef009b3054e$export$2b8d127b894957b9, (v) => $2d5cbef009b3054e$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $2d5cbef009b3054e$export$cea3a54a6425200c, (v) => $2d5cbef009b3054e$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $2d5cbef009b3054e$export$a7c73072b1a182ae, (v) => $2d5cbef009b3054e$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $2d5cbef009b3054e$export$9f27bc3417b4524d, (v) => $2d5cbef009b3054e$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $2d5cbef009b3054e$export$db77ccec0bb4ccac, (v) => $2d5cbef009b3054e$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $2d5cbef009b3054e$export$8392c0c9d3dcbd35, (v) => $2d5cbef009b3054e$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $2d5cbef009b3054e$export$ffb0004e005737fa, (v) => $2d5cbef009b3054e$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $2d5cbef009b3054e$export$b624eff549462981, (v) => $2d5cbef009b3054e$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $2d5cbef009b3054e$export$7897aa7841a5380c, (v) => $2d5cbef009b3054e$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $2d5cbef009b3054e$export$602eac185826482c, (v) => $2d5cbef009b3054e$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $2d5cbef009b3054e$export$e2c29f18771995cb, (v) => $2d5cbef009b3054e$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $2d5cbef009b3054e$export$5f8d39834fd61797, (v) => $2d5cbef009b3054e$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $2d5cbef009b3054e$export$74bf444e3cd11ea5, (v) => $2d5cbef009b3054e$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $2d5cbef009b3054e$export$92387174baf9b227, (v) => $2d5cbef009b3054e$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $2d5cbef009b3054e$export$ec112efeb987d9c6, (v) => $2d5cbef009b3054e$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $2d5cbef009b3054e$export$b706b080d889d2c9, (v) => $2d5cbef009b3054e$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $2d5cbef009b3054e$export$5be5a87408f70ddc, (v) => $2d5cbef009b3054e$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $2d5cbef009b3054e$export$45a5e7f76e0caa8d, (v) => $2d5cbef009b3054e$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $2d5cbef009b3054e$export$455c2e768291efa6, (v) => $2d5cbef009b3054e$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $2d5cbef009b3054e$export$9522e17588c12572, (v) => $2d5cbef009b3054e$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $2d5cbef009b3054e$export$2110ac352bb060b9, (v) => $2d5cbef009b3054e$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $2d5cbef009b3054e$export$56885ab8b9c456ab, (v) => $2d5cbef009b3054e$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $2d5cbef009b3054e$export$d927fcb6adf8f9de, (v) => $2d5cbef009b3054e$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $2d5cbef009b3054e$export$b82d16f27459e05a, (v) => $2d5cbef009b3054e$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $2d5cbef009b3054e$export$522c17b4f5e123e8, (v) => $2d5cbef009b3054e$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $2d5cbef009b3054e$export$1aabd8a0274ecfd6, (v) => $2d5cbef009b3054e$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $2d5cbef009b3054e$export$9b621391a187a31a, (v) => $2d5cbef009b3054e$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $2d5cbef009b3054e$export$f5bbd400c2f4426f, (v) => $2d5cbef009b3054e$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2d5cbef009b3054e$export$2b8d127b894957b9;
var $2d5cbef009b3054e$export$cea3a54a6425200c;
var $2d5cbef009b3054e$export$a7c73072b1a182ae;
var $2d5cbef009b3054e$export$9f27bc3417b4524d;
var $2d5cbef009b3054e$export$db77ccec0bb4ccac;
var $2d5cbef009b3054e$export$8392c0c9d3dcbd35;
var $2d5cbef009b3054e$export$ffb0004e005737fa;
var $2d5cbef009b3054e$export$b624eff549462981;
var $2d5cbef009b3054e$export$7897aa7841a5380c;
var $2d5cbef009b3054e$export$602eac185826482c;
var $2d5cbef009b3054e$export$e2c29f18771995cb;
var $2d5cbef009b3054e$export$5f8d39834fd61797;
var $2d5cbef009b3054e$export$74bf444e3cd11ea5;
var $2d5cbef009b3054e$export$92387174baf9b227;
var $2d5cbef009b3054e$export$ec112efeb987d9c6;
var $2d5cbef009b3054e$export$b706b080d889d2c9;
var $2d5cbef009b3054e$export$5be5a87408f70ddc;
var $2d5cbef009b3054e$export$45a5e7f76e0caa8d;
var $2d5cbef009b3054e$export$455c2e768291efa6;
var $2d5cbef009b3054e$export$9522e17588c12572;
var $2d5cbef009b3054e$export$2110ac352bb060b9;
var $2d5cbef009b3054e$export$56885ab8b9c456ab;
var $2d5cbef009b3054e$export$d927fcb6adf8f9de;
var $2d5cbef009b3054e$export$b82d16f27459e05a;
var $2d5cbef009b3054e$export$522c17b4f5e123e8;
var $2d5cbef009b3054e$export$1aabd8a0274ecfd6;
var $2d5cbef009b3054e$export$9b621391a187a31a;
var $2d5cbef009b3054e$export$f5bbd400c2f4426f;
'use strict';
var $2d5cbef009b3054e$var$b = "function" === typeof Symbol && Symbol.for, $2d5cbef009b3054e$var$c = $2d5cbef009b3054e$var$b ? Symbol.for("react.element") : 60103, $2d5cbef009b3054e$var$d = $2d5cbef009b3054e$var$b ? Symbol.for("react.portal") : 60106, $2d5cbef009b3054e$var$e = $2d5cbef009b3054e$var$b ? Symbol.for("react.fragment") : 60107, $2d5cbef009b3054e$var$f = $2d5cbef009b3054e$var$b ? Symbol.for("react.strict_mode") : 60108, $2d5cbef009b3054e$var$g = $2d5cbef009b3054e$var$b ? Symbol.for("react.profiler") : 60114, $2d5cbef009b3054e$var$h = $2d5cbef009b3054e$var$b ? Symbol.for("react.provider") : 60109, $2d5cbef009b3054e$var$k = $2d5cbef009b3054e$var$b ? Symbol.for("react.context") : 60110, $2d5cbef009b3054e$var$l = $2d5cbef009b3054e$var$b ? Symbol.for("react.async_mode") : 60111, $2d5cbef009b3054e$var$m = $2d5cbef009b3054e$var$b ? Symbol.for("react.concurrent_mode") : 60111, $2d5cbef009b3054e$var$n = $2d5cbef009b3054e$var$b ? Symbol.for("react.forward_ref") : 60112, $2d5cbef009b3054e$var$p = $2d5cbef009b3054e$var$b ? Symbol.for("react.suspense") : 60113, $2d5cbef009b3054e$var$q = $2d5cbef009b3054e$var$b ? Symbol.for("react.suspense_list") : 60120, $2d5cbef009b3054e$var$r = $2d5cbef009b3054e$var$b ? Symbol.for("react.memo") : 60115, $2d5cbef009b3054e$var$t = $2d5cbef009b3054e$var$b ? Symbol.for("react.lazy") : 60116, $2d5cbef009b3054e$var$v = $2d5cbef009b3054e$var$b ? Symbol.for("react.block") : 60121, $2d5cbef009b3054e$var$w = $2d5cbef009b3054e$var$b ? Symbol.for("react.fundamental") : 60117, $2d5cbef009b3054e$var$x = $2d5cbef009b3054e$var$b ? Symbol.for("react.responder") : 60118, $2d5cbef009b3054e$var$y = $2d5cbef009b3054e$var$b ? Symbol.for("react.scope") : 60119;
function $2d5cbef009b3054e$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $2d5cbef009b3054e$var$c:
                switch(a = a.type, a){
                    case $2d5cbef009b3054e$var$l:
                    case $2d5cbef009b3054e$var$m:
                    case $2d5cbef009b3054e$var$e:
                    case $2d5cbef009b3054e$var$g:
                    case $2d5cbef009b3054e$var$f:
                    case $2d5cbef009b3054e$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2d5cbef009b3054e$var$k:
                            case $2d5cbef009b3054e$var$n:
                            case $2d5cbef009b3054e$var$t:
                            case $2d5cbef009b3054e$var$r:
                            case $2d5cbef009b3054e$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $2d5cbef009b3054e$var$d:
                return u;
        }
    }
}
function $2d5cbef009b3054e$var$A(a) {
    return $2d5cbef009b3054e$var$z(a) === $2d5cbef009b3054e$var$m;
}
$2d5cbef009b3054e$export$2b8d127b894957b9 = $2d5cbef009b3054e$var$l;
$2d5cbef009b3054e$export$cea3a54a6425200c = $2d5cbef009b3054e$var$m;
$2d5cbef009b3054e$export$a7c73072b1a182ae = $2d5cbef009b3054e$var$k;
$2d5cbef009b3054e$export$9f27bc3417b4524d = $2d5cbef009b3054e$var$h;
$2d5cbef009b3054e$export$db77ccec0bb4ccac = $2d5cbef009b3054e$var$c;
$2d5cbef009b3054e$export$8392c0c9d3dcbd35 = $2d5cbef009b3054e$var$n;
$2d5cbef009b3054e$export$ffb0004e005737fa = $2d5cbef009b3054e$var$e;
$2d5cbef009b3054e$export$b624eff549462981 = $2d5cbef009b3054e$var$t;
$2d5cbef009b3054e$export$7897aa7841a5380c = $2d5cbef009b3054e$var$r;
$2d5cbef009b3054e$export$602eac185826482c = $2d5cbef009b3054e$var$d;
$2d5cbef009b3054e$export$e2c29f18771995cb = $2d5cbef009b3054e$var$g;
$2d5cbef009b3054e$export$5f8d39834fd61797 = $2d5cbef009b3054e$var$f;
$2d5cbef009b3054e$export$74bf444e3cd11ea5 = $2d5cbef009b3054e$var$p;
$2d5cbef009b3054e$export$92387174baf9b227 = function(a) {
    return $2d5cbef009b3054e$var$A(a) || $2d5cbef009b3054e$var$z(a) === $2d5cbef009b3054e$var$l;
};
$2d5cbef009b3054e$export$ec112efeb987d9c6 = $2d5cbef009b3054e$var$A;
$2d5cbef009b3054e$export$b706b080d889d2c9 = function(a) {
    return $2d5cbef009b3054e$var$z(a) === $2d5cbef009b3054e$var$k;
};
$2d5cbef009b3054e$export$5be5a87408f70ddc = function(a) {
    return $2d5cbef009b3054e$var$z(a) === $2d5cbef009b3054e$var$h;
};
$2d5cbef009b3054e$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2d5cbef009b3054e$var$c;
};
$2d5cbef009b3054e$export$455c2e768291efa6 = function(a) {
    return $2d5cbef009b3054e$var$z(a) === $2d5cbef009b3054e$var$n;
};
$2d5cbef009b3054e$export$9522e17588c12572 = function(a) {
    return $2d5cbef009b3054e$var$z(a) === $2d5cbef009b3054e$var$e;
};
$2d5cbef009b3054e$export$2110ac352bb060b9 = function(a) {
    return $2d5cbef009b3054e$var$z(a) === $2d5cbef009b3054e$var$t;
};
$2d5cbef009b3054e$export$56885ab8b9c456ab = function(a) {
    return $2d5cbef009b3054e$var$z(a) === $2d5cbef009b3054e$var$r;
};
$2d5cbef009b3054e$export$d927fcb6adf8f9de = function(a) {
    return $2d5cbef009b3054e$var$z(a) === $2d5cbef009b3054e$var$d;
};
$2d5cbef009b3054e$export$b82d16f27459e05a = function(a) {
    return $2d5cbef009b3054e$var$z(a) === $2d5cbef009b3054e$var$g;
};
$2d5cbef009b3054e$export$522c17b4f5e123e8 = function(a) {
    return $2d5cbef009b3054e$var$z(a) === $2d5cbef009b3054e$var$f;
};
$2d5cbef009b3054e$export$1aabd8a0274ecfd6 = function(a) {
    return $2d5cbef009b3054e$var$z(a) === $2d5cbef009b3054e$var$p;
};
$2d5cbef009b3054e$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2d5cbef009b3054e$var$e || a === $2d5cbef009b3054e$var$m || a === $2d5cbef009b3054e$var$g || a === $2d5cbef009b3054e$var$f || a === $2d5cbef009b3054e$var$p || a === $2d5cbef009b3054e$var$q || "object" === typeof a && null !== a && (a.$$typeof === $2d5cbef009b3054e$var$t || a.$$typeof === $2d5cbef009b3054e$var$r || a.$$typeof === $2d5cbef009b3054e$var$h || a.$$typeof === $2d5cbef009b3054e$var$k || a.$$typeof === $2d5cbef009b3054e$var$n || a.$$typeof === $2d5cbef009b3054e$var$w || a.$$typeof === $2d5cbef009b3054e$var$x || a.$$typeof === $2d5cbef009b3054e$var$y || a.$$typeof === $2d5cbef009b3054e$var$v);
};
$2d5cbef009b3054e$export$f5bbd400c2f4426f = $2d5cbef009b3054e$var$z;

});



parcelRegister("gSx5i", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $c49b5a5ef3f0da7f$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $c49b5a5ef3f0da7f$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});


parcelRegister("jNIYg", function(module, exports) {
$parcel$export(module.exports, "DefaultFallback", () => $40ccbb173162fcdd$export$93c734e924cdbdaa);
$parcel$export(module.exports, "FlagFallback", () => $40ccbb173162fcdd$export$53424aa680b9fa40);

var $dNZ1k = parcelRequire("dNZ1k");

var $4saCT = parcelRequire("4saCT");

var $eMSEP = parcelRequire("eMSEP");

var $1v5pe = parcelRequire("1v5pe");

var $kK7WO = parcelRequire("kK7WO");

var $6XPVu = parcelRequire("6XPVu");

var $kIqwl = parcelRequire("kIqwl");
const $40ccbb173162fcdd$export$93c734e924cdbdaa = ()=>{
    const { formatMessage: formatMessage } = (0, $kK7WO.default)();
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eMSEP.Box), {
        testId: "error-boundary-default-fallback",
        children: formatMessage((0, $6XPVu.default).defaultFallback)
    });
};
const $40ccbb173162fcdd$export$53424aa680b9fa40 = ()=>{
    const { showFlag: showFlag } = (0, $dNZ1k.useFlags)();
    const { formatMessage: formatMessage } = (0, $kK7WO.default)();
    const flagId = (0, $1v5pe.useId)();
    (0, $1v5pe.useEffect)(()=>{
        showFlag({
            id: flagId,
            testId: 'error-boundary-flag-fallback',
            icon: /*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4saCT))), {
                label: formatMessage((0, $6XPVu.default).flagIconLabel)
            }),
            title: formatMessage((0, $6XPVu.default).flagTitle),
            description: formatMessage((0, $6XPVu.default).flagDescription),
            appearance: 'error',
            actions: [
                {
                    content: formatMessage((0, $6XPVu.default).flagReloadButton),
                    onClick: ()=>window.location.reload()
                }
            ]
        });
    }, [
        showFlag,
        flagId,
        formatMessage
    ]);
    return null;
};

});
parcelRegister("dNZ1k", function(module, exports) {
$parcel$export(module.exports, "useFlags", () => $aab297df26d78b45$export$2879604e6aec4ab);

var $1v5pe = parcelRequire("1v5pe");

var $f4yCW = parcelRequire("f4yCW");
function $aab297df26d78b45$export$2879604e6aec4ab() {
    const api = (0, $1v5pe.useContext)((0, $f4yCW.FlagContext));
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}

});
parcelRegister("f4yCW", function(module, exports) {
$parcel$export(module.exports, "FlagContext", () => $f103065f30107dcf$export$2eb95677cf2465e1);

var $1v5pe = parcelRequire("1v5pe");
const $f103065f30107dcf$export$2eb95677cf2465e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createContext(null);

});


parcelRegister("4saCT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b3cfa183fa168ea8c7cf286e27765b6f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33e205216bc950b6$var$_react = $33e205216bc950b6$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $33e205216bc950b6$var$_iconNew = $33e205216bc950b6$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $33e205216bc950b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-error
 * Usage guidance:
 * Reserved for error statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33e205216bc950b6$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $33e205216bc950b6$var$_react.default.createElement($33e205216bc950b6$var$_iconNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$33e205216bc950b6$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $33e205216bc950b6$var$_default = module.exports.default = $33e205216bc950b6$var$StatusErrorIcon;

});
parcelRegister("5CpUv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Icon", () => $2ca28ffd177dec65$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $2ca28ffd177dec65$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $kIqwl = parcelRequire("kIqwl");
const $2ca28ffd177dec65$var$_20 = "._4t3i1ejb{height:var(--ds-space-300,24px)}";
const $2ca28ffd177dec65$var$_19 = "._1bsb1ejb{width:var(--ds-space-300,24px)}";
const $2ca28ffd177dec65$var$_18 = "._4t3ipxbi{height:var(--ds-space-200,1pc)}";
const $2ca28ffd177dec65$var$_17 = "._1bsbpxbi{width:var(--ds-space-200,1pc)}";
const $2ca28ffd177dec65$var$_16 = "._4t3iutpp{height:var(--ds-space-150,9pt)}";
const $2ca28ffd177dec65$var$_15 = "._1bsbutpp{width:var(--ds-space-150,9pt)}";
const $2ca28ffd177dec65$var$_14 = "._vc881r31 stop{stop-color:currentColor}";
const $2ca28ffd177dec65$var$_13 = "._s7n4yfq0{vertical-align:bottom}";
const $2ca28ffd177dec65$var$_12 = "._lcxvglyw{pointer-events:none}";
const $2ca28ffd177dec65$var$_11 = "._syaz1r31{color:currentColor}";
const $2ca28ffd177dec65$var$_10 = "._18m915vq{overflow-y:hidden}";
const $2ca28ffd177dec65$var$_1 = "._1reo15vq{overflow-x:hidden}";
const $2ca28ffd177dec65$var$_0 = "._vwz4utpp{line-height:var(--ds-space-150,9pt)}";
const $2ca28ffd177dec65$var$_9 = "._4t3i1kw7{height:inherit}";
const $2ca28ffd177dec65$var$_8 = "._1bsb1kw7{width:inherit}";
const $2ca28ffd177dec65$var$_7 = "@media screen and (forced-colors:active){._12va1onz{color:CanvasText}._jcxd1r8n{filter:grayscale(1)}}";
const $2ca28ffd177dec65$var$_6 = "._bozg1mb9{padding-inline-start:var(--ds--button--new-icon-padding-start,0)}";
const $2ca28ffd177dec65$var$_5 = "._y4ti1igz{padding-inline-end:var(--ds--button--new-icon-padding-end,0)}";
const $2ca28ffd177dec65$var$_4 = "._vwz4kb7n{line-height:1}";
const $2ca28ffd177dec65$var$_3 = "._1o9zidpf{flex-shrink:0}";
const $2ca28ffd177dec65$var$_2 = "._vchhusvi{box-sizing:border-box}";
const $2ca28ffd177dec65$var$_ = "._1e0c1o8l{display:inline-block}";
const $2ca28ffd177dec65$var$svgStyles = null;
const $2ca28ffd177dec65$var$iconStyles = null;
const $2ca28ffd177dec65$var$smallIconStyles = null;
const $2ca28ffd177dec65$var$scaleStyles = null; /**
                           * For windows high contrast mode
                           */ 
const $2ca28ffd177dec65$var$baseHcmStyles = null;
const $2ca28ffd177dec65$var$scaleSize = null;
const $2ca28ffd177dec65$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $2ca28ffd177dec65$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $2ca28ffd177dec65$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
}; /**
              * __Icon__
              *
              * An icon is used as a visual representation of common actions and commands to provide context.
              *
              * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
              */ 
const $2ca28ffd177dec65$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1v5pe.memo)(function Icon(props) {
    const { color: color = 'currentColor', testId: testId, label: label, dangerouslySetGlyph: // Used to set icon dimensions/behaviour in codegen
    // Used to set icon glyphs in codegen
    dangerouslySetGlyph, shouldScale: // Used with iconTile to scale icon up and down
    shouldScale, spacing: spacing = 'none', name: name } = props;
    const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    let size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            const newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    const baseSize = 16;
    const viewBoxPadding = $2ca28ffd177dec65$var$paddingMap[size][spacing];
    const viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $2ca28ffd177dec65$var$_,
                    $2ca28ffd177dec65$var$_2,
                    $2ca28ffd177dec65$var$_3,
                    $2ca28ffd177dec65$var$_4,
                    $2ca28ffd177dec65$var$_5,
                    $2ca28ffd177dec65$var$_6,
                    $2ca28ffd177dec65$var$_7,
                    $2ca28ffd177dec65$var$_8,
                    $2ca28ffd177dec65$var$_9,
                    $2ca28ffd177dec65$var$_0
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
                "data-testid": testId,
                role: label ? 'img' : undefined,
                "aria-label": label ? label : undefined,
                "aria-hidden": label ? undefined : true,
                style: {
                    color: color
                },
                className: (0, $hMvDh.default)([
                    "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
                    "_12va1onz _jcxd1r8n",
                    shouldScale && "_1bsb1kw7 _4t3i1kw7",
                    size === 'small' && "_vwz4utpp"
                ]),
                children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                    children: [
                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                            children: [
                                $2ca28ffd177dec65$var$_1,
                                $2ca28ffd177dec65$var$_10,
                                $2ca28ffd177dec65$var$_11,
                                $2ca28ffd177dec65$var$_12,
                                $2ca28ffd177dec65$var$_13,
                                $2ca28ffd177dec65$var$_14,
                                $2ca28ffd177dec65$var$_8,
                                $2ca28ffd177dec65$var$_9,
                                $2ca28ffd177dec65$var$_15,
                                $2ca28ffd177dec65$var$_16,
                                $2ca28ffd177dec65$var$_17,
                                $2ca28ffd177dec65$var$_18,
                                $2ca28ffd177dec65$var$_19,
                                $2ca28ffd177dec65$var$_20
                            ]
                        }),
                        /*#__PURE__*/ (0, $kIqwl.jsx)("svg", {
                            fill: "none" // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
                            ,
                            viewBox: `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`,
                            role: "presentation",
                            dangerouslySetInnerHTML: dangerouslySetInnerHTML,
                            className: (0, $hMvDh.default)([
                                "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
                                shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $2ca28ffd177dec65$var$coreSizeSmall[spacing] : $2ca28ffd177dec65$var$coreSizeMedium[spacing]
                            ])
                        })
                    ]
                })
            })
        ]
    });
}); // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $2ca28ffd177dec65$export$2e2bcd8739ae039 = $2ca28ffd177dec65$export$f04a61298a47a40f;

});
parcelRegister("hMvDh", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf1f74e83e39b972$export$2e2bcd8739ae039);
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $cf1f74e83e39b972$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $cf1f74e83e39b972$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $cf1f74e83e39b972$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("2T805", function(module, exports) {
$parcel$export(module.exports, "useCache", () => $21a6ec84cbb72606$export$c6e89b6bb9436bc0);
$parcel$export(module.exports, "default", () => $21a6ec84cbb72606$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");


var $cBMZ5 = parcelRequire("cBMZ5");
/**
 * Cache to hold already used styles.
 * React Context on the server - singleton object on the client.
 */ const $21a6ec84cbb72606$var$Cache = (0, $cBMZ5.isServerEnvironment)() ? (0, $1v5pe.createContext)(null) : {};
if (!(0, $cBMZ5.isServerEnvironment)() && typeof document !== 'undefined') {
    /**
     * Iterates through all found style elements generated when server side rendering.
     *
     * @param cb
     */ const ssrStyles = document.querySelectorAll('style[data-cmpld]');
    for(let i = 0; i < ssrStyles.length; i++)// Move all found server-side rendered style elements to the head before React hydration happens.
    document.head.appendChild(ssrStyles[i]);
}
const $21a6ec84cbb72606$export$c6e89b6bb9436bc0 = ()=>{
    if ((0, $cBMZ5.isServerEnvironment)()) // On the server we use React Context to we don't leak the cache between SSR calls.
    // During runtime this hook isn't conditionally called - it is at build time that the flow gets decided.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $1v5pe.useContext)($21a6ec84cbb72606$var$Cache) || {};
    // On the client we use the object singleton.
    return $21a6ec84cbb72606$var$Cache;
};
/**
 * On the server this ensures the minimal amount of styles will be rendered
 * safely using React Context.
 *
 * On the browser this turns into a fragment with no React Context.
 */ const $21a6ec84cbb72606$var$StyleCacheProvider = (props)=>{
    if ((0, $cBMZ5.isServerEnvironment)()) {
        // This code path isn't conditionally called at build time - safe to ignore.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const inserted = $21a6ec84cbb72606$export$c6e89b6bb9436bc0();
        return $1v5pe.createElement($21a6ec84cbb72606$var$Cache.Provider, {
            value: inserted
        }, props.children);
    }
    return props.children;
};
var $21a6ec84cbb72606$export$2e2bcd8739ae039 = $21a6ec84cbb72606$var$StyleCacheProvider;

});
parcelRegister("cBMZ5", function(module, exports) {
$parcel$export(module.exports, "isServerEnvironment", () => $92deefff48fc835c$export$455cc18296abe008);
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $k1Wvt = parcelRequire("k1Wvt");
const $92deefff48fc835c$var$isJsDomEnvironment = ()=>window.name === 'nodejs' || (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent.includes('Node.js')) || (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent.includes('jsdom'));
const $92deefff48fc835c$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $k1Wvt !== 'undefined' && $k1Wvt.versions != null && $k1Wvt.versions.node != null) return true;
    if ($92deefff48fc835c$var$isJsDomEnvironment()) return true;
    return false;
};

});


parcelRegister("cdHM2", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e58a7831394807a$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");


var $cBMZ5 = parcelRequire("cBMZ5");

var $7Kra0 = parcelRequire("7Kra0");

var $2T805 = parcelRequire("2T805");

var $ahVR3 = parcelRequire("ahVR3");
/**
 * Returns true if the CSS sheet string is a non-atomic rule generated by
 * `cssMapScoped`. Non-atomic rules use the `cc-` class prefix.
 * Uses `includes` rather than `startsWith` to also match at-rule-wrapped
 * non-atomic rules like `@media{.cc-xxx{...}}` or `@container{.cc-xxx{...}}`.
 */ const $8e58a7831394807a$var$isNonAtomicSheet = (sheet)=>sheet.includes('.cc-');
function $8e58a7831394807a$export$2e2bcd8739ae039(props) {
    const inserted = (0, $2T805.useCache)();
    const styleContainer = (0, $ahVR3.useStyleContainer)();
    if (props.children.length) {
        if ((0, $cBMZ5.isServerEnvironment)()) {
            const bucketedSheets = {};
            let hasSheets = false;
            for(let i = 0; i < props.children.length; i++){
                const sheet = props.children[i];
                if (inserted[sheet]) continue;
                else {
                    inserted[sheet] = true;
                    hasSheets = true;
                }
                // Non-atomic rules (cc- prefix from cssMapScoped) go into a
                // dedicated 'cc' bucket. Keeping them in their own bucket:
                //   1. Preserves source-order cascade for the multi-rule payload
                //      (the bucket is text-appended in insertion order).
                //   2. On the client, guarantees the runtime never mixes CSSOM
                //      `insertRule` (atomic buckets, production) with `Text.appendData`
                //      (non-atomic bucket) on the same `<style>` element — the mixing
                //      that causes a full style wipe when a large `.cc-` sheet is
                //      injected after atomic rules. See sheet.ts `insertNonAtomicRule`.
                // On the server, the isolation matters less (we render into a single
                // `<style>`), but we keep the same bucket key so SSR and CSR agree.
                const bucketName = $8e58a7831394807a$var$isNonAtomicSheet(sheet) ? 'cc' : (0, $7Kra0.getStyleBucketName)(sheet);
                bucketedSheets[bucketName] = (bucketedSheets[bucketName] || '') + sheet;
            }
            if (!hasSheets) return null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("style", {
                "data-cmpld": true,
                nonce: props.nonce,
                dangerouslySetInnerHTML: {
                    __html: (0, $7Kra0.styleBucketOrdering).map((bucket)=>bucketedSheets[bucket]).join('')
                }
            });
        } else {
            const opts = styleContainer ? Object.assign(Object.assign({}, props), {
                container: styleContainer.container,
                cacheKey: styleContainer.cacheKey
            }) : props;
            for(let i = 0; i < props.children.length; i++){
                const sheet = props.children[i];
                // When a container is active, namespace the cache key so this container's
                // inserted records are tracked independently from the main document cache.
                const cacheKey = styleContainer ? `${styleContainer.cacheKey}:${sheet}` : sheet;
                if (inserted[cacheKey]) continue;
                inserted[cacheKey] = true;
                // Non-atomic rules (cc- prefix from cssMapScoped) must bypass the
                // shorthand bucket sorting logic — they contain multiple declarations per rule
                // and must preserve source-order cascade within the catch-all bucket.
                if ($8e58a7831394807a$var$isNonAtomicSheet(sheet)) (0, $7Kra0.insertNonAtomicRule)(sheet, opts);
                else (0, $7Kra0.default)(sheet, opts);
            }
        }
    }
    return null;
}

});
parcelRegister("7Kra0", function(module, exports) {
$parcel$export(module.exports, "styleBucketOrdering", () => $5a41e5bff9ffd724$export$8394bdfbee416ca4);
$parcel$export(module.exports, "getStyleBucketName", () => $5a41e5bff9ffd724$export$d90f6836ea1aee93);
$parcel$export(module.exports, "default", () => $5a41e5bff9ffd724$export$2e2bcd8739ae039);
$parcel$export(module.exports, "insertNonAtomicRule", () => $5a41e5bff9ffd724$export$2f01f8749482f7ab);


var $jeFff = parcelRequire("jeFff");
const $5a41e5bff9ffd724$export$8394bdfbee416ca4 = [
    // shorthand properties
    's-0',
    's-1',
    's-2',
    's-3',
    's-4',
    's-5',
    // catch-all
    '',
    // link
    'l',
    // visited
    'v',
    // focus-within
    'w',
    // focus
    'f',
    // focus-visible
    'i',
    // hover
    'h',
    // active
    'a',
    // at-rules
    'm',
    // non-atomic `cssMapScoped` (`.cc-…`) rules — MUST live in a dedicated
    // `<style>` element (never shared with the atomic catch-all `''` bucket
    // or any other atomic bucket). In production, atomic rules are injected
    // via `sheet.insertRule()` (CSSOM-only, `textContent` stays empty).
    // Non-atomic rules are injected via `Text.appendData()` on the same node,
    // which — if it were the same element — would force the browser to reparse
    // the sheet from text and DISCARD every previously `insertRule`-inserted
    // rule (a full style wipe). Keeping `cc` in its own bucket guarantees the
    // two insertion strategies never target the same DOM node. Placed last so
    // `.cc-` rules cascade after all atomic rules (matches previous behaviour
    // where they were appended to the shared catch-all bucket).
    'cc'
];
/**
 * Holds all style buckets in memory that have been added to the head.
 */ const $5a41e5bff9ffd724$var$styleBucketsInHead = {};
/**
 * Maps the long pseudo name to the short pseudo name.
 * Pseudos that match here will be ordered,
 * everything else will make their way to the catch all style bucket.
 * We reduce the pseudo name to save bundlesize.
 * Thankfully there aren't any overlaps, see: https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-classes.
 */ const $5a41e5bff9ffd724$var$pseudosMap = {
    // link
    k: 'l',
    // visited
    ited: 'v',
    // focus-within
    'us-within': 'w',
    // focus
    us: 'f',
    // focus-visible
    'us-visible': 'i',
    // hover
    er: 'h',
    // active
    ive: 'a'
};
/**
 * Holds style buckets per custom container (e.g. a ShadowRoot), keyed by the
 * container DOM node. Uses WeakMap so entries are garbage collected when the
 * container is removed from the page.
 */ const $5a41e5bff9ffd724$var$styleBucketsByContainer = new WeakMap();
/**
 * Lazily adds a `<style>` bucket to a container, defaulting to `the `<head>`
 * when no container is provided in opts. Ensures style buckets are inserted in
 * the correct order regardless of the target container.
 *
 * Each custom container (e.g. a ShadowRoot) gets its own independent set of
 * buckets via the WeakMap — the main document singleton is unaffected.
 *
 * @param bucketName Bucket to insert into the container.
 * @param opts StyleSheetOpts optionally including a custom container.
 */ function $5a41e5bff9ffd724$var$lazyAddStyleBucketToContainer(bucketName, opts) {
    var _a;
    const target = (_a = opts.container) !== null && _a !== void 0 ? _a : document.head;
    let buckets;
    if (opts.container) {
        if (!$5a41e5bff9ffd724$var$styleBucketsByContainer.has(opts.container)) $5a41e5bff9ffd724$var$styleBucketsByContainer.set(opts.container, {});
        buckets = $5a41e5bff9ffd724$var$styleBucketsByContainer.get(opts.container);
    } else buckets = $5a41e5bff9ffd724$var$styleBucketsInHead;
    if (!buckets[bucketName]) {
        let currentBucketIndex = $5a41e5bff9ffd724$export$8394bdfbee416ca4.indexOf(bucketName) + 1;
        let nextBucketFromCache = null;
        // Find the next bucket which we will add our new style bucket before.
        for(; currentBucketIndex < $5a41e5bff9ffd724$export$8394bdfbee416ca4.length; currentBucketIndex++){
            const nextBucket = buckets[$5a41e5bff9ffd724$export$8394bdfbee416ca4[currentBucketIndex]];
            if (nextBucket) {
                nextBucketFromCache = nextBucket;
                break;
            }
        }
        const tag = document.createElement('style');
        opts.nonce && tag.setAttribute('nonce', opts.nonce);
        tag.appendChild(document.createTextNode(''));
        target.insertBefore(tag, nextBucketFromCache);
        buckets[bucketName] = tag;
    }
    return buckets[bucketName];
}
/**
 * Returns true when `characterCode` is a CSS selector delimiter that can appear
 * immediately after an atomic class name — i.e. a character that marks the end of
 * the class token. Covers the declaration block (`{`), pseudo (`:`), attribute
 * (`[`), class/id qualifiers (`.`/`#`), combinators (space/`>`/`+`/`~`), and the
 * selector-list separator (`,`). Operates on character codes (not substrings) to
 * stay allocation-free on the runtime hot path.
 */ const $5a41e5bff9ffd724$var$isClassBoundary = (characterCode)=>characterCode === 58 /* ":" */  || characterCode === 123 /* "{" */  || characterCode === 91 /* "[" */  || characterCode === 46 /* "." */  || characterCode === 35 /* "#" */  || characterCode === 32 /* " " */  || characterCode === 62 /* ">" */  || characterCode === 43 /* "+" */  || characterCode === 126 /* "~" */  || characterCode === 44; /* "," */ 
const $5a41e5bff9ffd724$export$d90f6836ea1aee93 = (sheet)=>{
    // We are grouping all the at-rules like @media, @supports etc under `m` bucket.
    if (sheet.charCodeAt(0) === 64 /* "@" */ ) return 'm';
    const firstBracket = sheet.indexOf('{');
    /**
     * Atomic class names are either 9 chars (legacy hash: `_` + 8) or 11 chars
     * (collisionResistantHash: `_` + 10). We only need to know where the class token
     * ends so the pseudo (if any) can be read relative to that boundary.
     *
     * Since exactly two widths exist, inspecting index 10 is sufficient: if it holds
     * a CSS selector delimiter, the class ended at 9 chars; otherwise index 10 is
     * still a hash character and the class is the 11-char form (boundary at index 12).
     *
     * We test for a delimiter (`isClassBoundary`) rather than the hash alphabet: the
     * question is "did the class token end?", not "which characters did the hasher
     * emit?". This keeps the legacy 9-char path correct for every continuation
     * (`:`, `{`, `[`, `.`, `#`, space, `>`, `+`, `~`, `,`), where a delimiter-poor
     * check would misread e.g. `._legacyhsh a:visited` as an 11-char class.
     */ const classEnd = $5a41e5bff9ffd724$var$isClassBoundary(sheet.charCodeAt(10)) ? 10 : 12;
    if (sheet.charCodeAt(classEnd) === 58 /* ":" */ ) {
        // We send through a subset of the string instead of the full pseudo name:
        // drop the colon plus the first three characters, e.g. `"focus-visible"`
        // becomes `"us-visible"`. Compound selectors slice an unmapped fragment
        // (e.g. `"ited:hover"`) and so fall through to the catch-all bucket, matching
        // the legacy behavior. Return a mapped pseudo else the default catch all bucket.
        const mapped = $5a41e5bff9ffd724$var$pseudosMap[sheet.slice(classEnd + 4, firstBracket)];
        if (mapped) return mapped;
    }
    const property = sheet.slice(firstBracket + 1, sheet.indexOf(':', firstBracket)).trim();
    const shorthandDepth = (0, $jeFff.getShorthandDepth)(property);
    if (typeof shorthandDepth === 'number') return `s-${shorthandDepth}`;
    // Return default catch all bucket
    return '';
};
function $5a41e5bff9ffd724$export$2e2bcd8739ae039(css, opts) {
    const bucketName = $5a41e5bff9ffd724$export$d90f6836ea1aee93(css);
    const style = $5a41e5bff9ffd724$var$lazyAddStyleBucketToContainer(bucketName, opts);
    const sheet = style.sheet;
    // Used to avoid unhandled exceptions across browsers with prefixed selectors such as -moz-placeholder.
    try {
        sheet.insertRule(css, sheet.cssRules.length);
    } catch (_a) {}
}
function $5a41e5bff9ffd724$export$2f01f8749482f7ab(css, opts) {
    // Use the dedicated 'cc' bucket to (a) preserve source-order cascade for the
    // multi-rule `cssMapScoped` payload, and (b) guarantee we never mutate the text
    // node of any atomic bucket's `<style>` element. `insertRule` only accepts a
    // single rule per call, so we use `Text.appendData` — it appends to an existing
    // text node in a single DOM mutation (no new text node creation, no parsing
    // limits, accepts multi-rule strings).
    const style = $5a41e5bff9ffd724$var$lazyAddStyleBucketToContainer('cc', opts);
    const text = style.firstChild;
    if (text) text.appendData(css);
    else style.appendChild(document.createTextNode(css));
}

});
parcelRegister("jeFff", function(module, exports) {
$parcel$export(module.exports, "getShorthandDepth", () => $e00f5182fbb8aeba$export$b08836c779543dbf);
// Copied from packages/utils/src/shorthand.ts so that we avoid
// inflating the bundle size of @compiled/react/runtime with the contents
// of @compiled/utils
//
// Keep this `shorthandBuckets` in sync with the `shorthandBuckets` defined in
// packages/utils/src/shorthand.ts
const $e00f5182fbb8aeba$var$shorthandBuckets = {
    all: 0,
    animation: 1,
    'animation-range': 1,
    background: 1,
    border: 1,
    'border-color': 2,
    'border-style': 2,
    'border-width': 2,
    'border-block': 3,
    'border-inline': 3,
    'border-top': 4,
    'border-right': 4,
    'border-bottom': 4,
    'border-left': 4,
    'border-block-start': 5,
    'border-block-end': 5,
    'border-inline-start': 5,
    'border-inline-end': 5,
    'border-image': 1,
    'border-radius': 1,
    'column-rule': 1,
    columns: 1,
    'contain-intrinsic-size': 1,
    container: 1,
    flex: 1,
    'flex-flow': 1,
    font: 1,
    'font-synthesis': 1,
    'font-variant': 2,
    gap: 1,
    grid: 1,
    'grid-area': 1,
    'grid-column': 2,
    'grid-row': 2,
    'grid-template': 2,
    inset: 1,
    'inset-block': 2,
    'inset-inline': 2,
    'list-style': 1,
    margin: 1,
    'margin-block': 2,
    'margin-inline': 2,
    mask: 1,
    'mask-border': 1,
    offset: 1,
    outline: 1,
    overflow: 1,
    'overscroll-behavior': 1,
    padding: 1,
    'padding-block': 2,
    'padding-inline': 2,
    'place-content': 1,
    'place-items': 1,
    'place-self': 1,
    'position-try': 1,
    'scroll-margin': 1,
    'scroll-margin-block': 2,
    'scroll-margin-inline': 2,
    'scroll-padding': 1,
    'scroll-padding-block': 2,
    'scroll-padding-inline': 2,
    'scroll-timeline': 1,
    'text-decoration': 1,
    'text-emphasis': 1,
    'text-wrap': 1,
    transition: 1,
    'view-timeline': 1
};
const $e00f5182fbb8aeba$export$b08836c779543dbf = (shorthand)=>{
    var _a;
    return (_a = $e00f5182fbb8aeba$var$shorthandBuckets[shorthand]) !== null && _a !== void 0 ? _a : null;
};

});


parcelRegister("ahVR3", function(module, exports) {
$parcel$export(module.exports, "useStyleContainer", () => $77d85ea9c2cba085$export$27c28af7c58fc6b4);

var $1v5pe = parcelRequire("1v5pe");

var $cBMZ5 = parcelRequire("cBMZ5");
let $77d85ea9c2cba085$export$1c617ef0fac4c274 = null;
const $77d85ea9c2cba085$export$27c28af7c58fc6b4 = ()=>{
    return $77d85ea9c2cba085$export$1c617ef0fac4c274;
};
function $77d85ea9c2cba085$export$c2e7cf7518b34f16({ container: container, cacheKey: cacheKey, children: children }) {
    if ((0, $cBMZ5.isServerEnvironment)()) return children;
    // On the client, set the singleton synchronously during the render phase via
    // useMemo so CS children pick it up immediately.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).useMemo(()=>{
        $77d85ea9c2cba085$export$1c617ef0fac4c274 = {
            container: container,
            cacheKey: cacheKey
        };
    }, [
        container,
        cacheKey
    ]);
    // Clear the singleton when this provider unmounts.
    // Note: nested StyleContainerProviders are not supported. If an inner provider
    // unmounts, this will clear clientStyleContainer to null rather than restoring
    // the outer provider's value. This is an acceptable limitation for the intended
    // use case of a single provider wrapping a shadow DOM subtree.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).useEffect(()=>{
        return ()=>{
            $77d85ea9c2cba085$export$1c617ef0fac4c274 = null;
        };
    }, []);
    return children;
}

});




parcelRegister("eMSEP", function(module, exports) {
$parcel$export(module.exports, "Box", () => $dc9981cc052e4090$export$e71c4d32a2263218);
$parcel$export(module.exports, "default", () => $dc9981cc052e4090$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $hRuTh = parcelRequire("hRuTh");

var $kH2JL = parcelRequire("kH2JL");

var $77s18 = parcelRequire("77s18");

var $7tKyU = parcelRequire("7tKyU");

var $cpDmm = parcelRequire("cpDmm");

var $4Iv3g = parcelRequire("4Iv3g");

var $ihIkA = parcelRequire("ihIkA");
function $dc9981cc052e4090$var$_extends() {
    return $dc9981cc052e4090$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $dc9981cc052e4090$var$_extends.apply(null, arguments);
}
const $dc9981cc052e4090$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $4Iv3g.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $hRuTh.jsx)(Component, $dc9981cc052e4090$var$_extends({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $dc9981cc052e4090$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $77s18.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $7tKyU.isSurfaceColorToken)(backgroundColor) && (0, $ihIkA.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $cpDmm.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $cpDmm.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $cpDmm.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $cpDmm.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $cpDmm.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $cpDmm.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $cpDmm.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $hRuTh.jsx)((0, $kH2JL.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$dc9981cc052e4090$export$2e2bcd8739ae039 = $dc9981cc052e4090$export$e71c4d32a2263218;
const $dc9981cc052e4090$var$baseStyles = (0, $hRuTh.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("hRuTh", function(module, exports) {
$parcel$export(module.exports, "createElement", () => $d00f591d08112ff5$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "Global", () => $d00f591d08112ff5$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $d00f591d08112ff5$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $d00f591d08112ff5$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ClassNames", () => $d00f591d08112ff5$export$9b9c0f9d9f3552b8);
$parcel$export(module.exports, "jsx", () => $d00f591d08112ff5$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "CacheProvider", () => (parcelRequire("7aoHd")).C);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("7aoHd")).T);
$parcel$export(module.exports, "ThemeProvider", () => (parcelRequire("7aoHd")).a);
$parcel$export(module.exports, "__unsafe_useEmotionCache", () => (parcelRequire("7aoHd"))._);
$parcel$export(module.exports, "useTheme", () => (parcelRequire("7aoHd")).u);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("7aoHd")).w);
$parcel$export(module.exports, "withTheme", () => (parcelRequire("7aoHd")).b);

var $7aoHd = parcelRequire("7aoHd");

var $1v5pe = parcelRequire("1v5pe");

var $eSd6x = parcelRequire("eSd6x");

var $9oExk = parcelRequire("9oExk");

var $90BXC = parcelRequire("90BXC");
parcelRequire("lnvMm");
parcelRequire("87uOn");
parcelRequire("7LkUp");

parcelRequire("35aua");
var $d00f591d08112ff5$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $7aoHd.h).call(props, 'css')) return $1v5pe.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $7aoHd.E);
    createElementArgArray[1] = (0, $7aoHd.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $1v5pe.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($d00f591d08112ff5$export$c8a8987d4410bf2d || ($d00f591d08112ff5$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $d00f591d08112ff5$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $7aoHd.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $90BXC.serializeStyles)([
        styles
    ], undefined, $1v5pe.useContext((0, $7aoHd.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $1v5pe.useRef();
    (0, $9oExk.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $9oExk.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $eSd6x.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $d00f591d08112ff5$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $90BXC.serializeStyles)(args);
}
function $d00f591d08112ff5$export$d25ddfdf17c3ad3e() {
    var insertable = $d00f591d08112ff5$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $d00f591d08112ff5$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $d00f591d08112ff5$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $eSd6x.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $d00f591d08112ff5$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $9oExk.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $eSd6x.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $d00f591d08112ff5$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $7aoHd.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $7aoHd.i)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $90BXC.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $eSd6x.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $7aoHd.i)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $d00f591d08112ff5$var$merge(cache.registered, css, $d00f591d08112ff5$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $1v5pe.useContext((0, $7aoHd.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $1v5pe.createElement($1v5pe.Fragment, null, /*#__PURE__*/ $1v5pe.createElement($d00f591d08112ff5$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("7aoHd", function(module, exports) {
$parcel$export(module.exports, "i", () => $537c9fb56ac2640a$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $537c9fb56ac2640a$export$e7094788287c5e9b);
$parcel$export(module.exports, "_", () => $537c9fb56ac2640a$export$71511d61b312f219);
$parcel$export(module.exports, "w", () => $537c9fb56ac2640a$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $537c9fb56ac2640a$export$971d5caa766a69d7);
$parcel$export(module.exports, "u", () => $537c9fb56ac2640a$export$3b14a55fb2447963);
$parcel$export(module.exports, "a", () => $537c9fb56ac2640a$export$407448d2b89b1813);
$parcel$export(module.exports, "b", () => $537c9fb56ac2640a$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "h", () => $537c9fb56ac2640a$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $537c9fb56ac2640a$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $537c9fb56ac2640a$export$a9c23c6ac3fc3eca);

var $1v5pe = parcelRequire("1v5pe");

var $lnvMm = parcelRequire("lnvMm");

var $87uOn = parcelRequire("87uOn");

var $7LkUp = parcelRequire("7LkUp");

var $3hx71 = parcelRequire("3hx71");

var $eSd6x = parcelRequire("eSd6x");

var $90BXC = parcelRequire("90BXC");

var $9oExk = parcelRequire("9oExk");
var $537c9fb56ac2640a$export$23f2a1d2818174ef = false;
var $537c9fb56ac2640a$var$EmotionCacheContext = /* #__PURE__ */ $1v5pe.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $lnvMm.default)({
    key: 'css'
}) : null);
var $537c9fb56ac2640a$export$e7094788287c5e9b = $537c9fb56ac2640a$var$EmotionCacheContext.Provider;
var $537c9fb56ac2640a$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $1v5pe.useContext)($537c9fb56ac2640a$var$EmotionCacheContext);
};
var $537c9fb56ac2640a$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $1v5pe.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $1v5pe.useContext)($537c9fb56ac2640a$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $537c9fb56ac2640a$export$971d5caa766a69d7 = /* #__PURE__ */ $1v5pe.createContext({});
var $537c9fb56ac2640a$export$3b14a55fb2447963 = function useTheme() {
    return $1v5pe.useContext($537c9fb56ac2640a$export$971d5caa766a69d7);
};
var $537c9fb56ac2640a$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $87uOn.default)({}, outerTheme, theme);
};
var $537c9fb56ac2640a$var$createCacheWithTheme = /* #__PURE__ */ (0, $7LkUp.default)(function(outerTheme) {
    return (0, $7LkUp.default)(function(theme) {
        return $537c9fb56ac2640a$var$getTheme(outerTheme, theme);
    });
});
var $537c9fb56ac2640a$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $1v5pe.useContext($537c9fb56ac2640a$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $537c9fb56ac2640a$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $1v5pe.createElement($537c9fb56ac2640a$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $537c9fb56ac2640a$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $1v5pe.forwardRef(function render(props, ref) {
        var theme = $1v5pe.useContext($537c9fb56ac2640a$export$971d5caa766a69d7);
        return /*#__PURE__*/ $1v5pe.createElement(Component, (0, $87uOn.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $3hx71.default)(WithTheme, Component);
}
var $537c9fb56ac2640a$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $537c9fb56ac2640a$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $537c9fb56ac2640a$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($537c9fb56ac2640a$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$537c9fb56ac2640a$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $537c9fb56ac2640a$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $eSd6x.registerStyles)(cache, serialized, isStringTag);
    (0, $9oExk.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $eSd6x.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $537c9fb56ac2640a$var$Emotion = /* #__PURE__ */ $537c9fb56ac2640a$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$537c9fb56ac2640a$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $eSd6x.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $90BXC.serializeStyles)(registeredStyles, undefined, $1v5pe.useContext($537c9fb56ac2640a$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($537c9fb56ac2640a$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $537c9fb56ac2640a$var$typePropName && !$537c9fb56ac2640a$export$23f2a1d2818174ef) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $1v5pe.createElement($1v5pe.Fragment, null, /*#__PURE__*/ $1v5pe.createElement($537c9fb56ac2640a$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $1v5pe.createElement(WrappedComponent, newProps));
});
var $537c9fb56ac2640a$export$a9c23c6ac3fc3eca = $537c9fb56ac2640a$var$Emotion;

});
parcelRegister("lnvMm", function(module, exports) {
$parcel$export(module.exports, "default", () => $f904659a3fd14c7d$export$2e2bcd8739ae039);

var $7ZlJE = parcelRequire("7ZlJE");

var $dhEBD = parcelRequire("dhEBD");
var $jjhpc = parcelRequire("jjhpc");
var $7MQd3 = parcelRequire("7MQd3");
var $buE9b = parcelRequire("buE9b");
var $5Z4pX = parcelRequire("5Z4pX");
var $6RQdH = parcelRequire("6RQdH");
parcelRequire("7LkUp");
parcelRequire("62Oof");
var $f904659a3fd14c7d$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $dhEBD.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $dhEBD.token)(character)) break;
        (0, $dhEBD.next)();
    }
    return (0, $dhEBD.slice)(begin, (0, $dhEBD.position));
};
var $f904659a3fd14c7d$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $dhEBD.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $dhEBD.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $f904659a3fd14c7d$var$identifierWithPointTracking((0, $dhEBD.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $dhEBD.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $dhEBD.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $jjhpc.from)(character);
    }
    while (character = (0, $dhEBD.next)());
    return parsed;
};
var $f904659a3fd14c7d$var$getRules = function getRules(value, points) {
    return (0, $dhEBD.dealloc)($f904659a3fd14c7d$var$toRules((0, $dhEBD.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $f904659a3fd14c7d$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $f904659a3fd14c7d$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$f904659a3fd14c7d$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $f904659a3fd14c7d$var$fixedElements.set(element, true);
    var points = [];
    var rules = $f904659a3fd14c7d$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $f904659a3fd14c7d$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $f904659a3fd14c7d$var$prefix(value, length) {
    switch((0, $jjhpc.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $buE9b.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $buE9b.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MOZ) + value + (0, $buE9b.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + value + value;
        // order
        case 6165:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $buE9b.WEBKIT) + value + (0, $jjhpc.replace)(value, /(\w+).+(:[^]+)/, (0, $buE9b.WEBKIT) + 'box-$1$2' + (0, $buE9b.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + 'flex-item-' + (0, $jjhpc.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + 'flex-line-pack' + (0, $jjhpc.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $buE9b.WEBKIT) + 'box-' + (0, $jjhpc.replace)(value, '-grow', '') + (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $buE9b.WEBKIT) + (0, $jjhpc.replace)(value, /([^-])(transform)/g, '$1' + (0, $buE9b.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $jjhpc.replace)((0, $jjhpc.replace)((0, $jjhpc.replace)(value, /(zoom-|grab)/, (0, $buE9b.WEBKIT) + '$1'), /(image-set)/, (0, $buE9b.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $jjhpc.replace)(value, /(image-set\([^]*)/, (0, $buE9b.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $jjhpc.replace)((0, $jjhpc.replace)(value, /(.+:)(flex-)?(.*)/, (0, $buE9b.WEBKIT) + 'box-pack:$3' + (0, $buE9b.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $buE9b.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $jjhpc.replace)(value, /(.+)-inline(.+)/, (0, $buE9b.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $jjhpc.strlen)(value) - 1 - length > 6) switch((0, $jjhpc.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $jjhpc.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $jjhpc.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $buE9b.WEBKIT) + '$2-$3' + '$1' + (0, $buE9b.MOZ) + ((0, $jjhpc.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $jjhpc.indexof)(value, 'stretch') ? $f904659a3fd14c7d$var$prefix((0, $jjhpc.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $jjhpc.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $jjhpc.charat)(value, (0, $jjhpc.strlen)(value) - 3 - (~(0, $jjhpc.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $jjhpc.replace)(value, ':', ':' + (0, $buE9b.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $jjhpc.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $buE9b.WEBKIT) + ((0, $jjhpc.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $buE9b.WEBKIT) + '$2$3' + '$1' + (0, $buE9b.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $jjhpc.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + value + value;
    }
    return value;
}
var $f904659a3fd14c7d$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $buE9b.DECLARATION:
                element["return"] = $f904659a3fd14c7d$var$prefix(element.value, element.length);
                break;
            case 0, $buE9b.KEYFRAMES:
                return (0, $6RQdH.serialize)([
                    (0, $dhEBD.copy)(element, {
                        value: (0, $jjhpc.replace)(element.value, '@', '@' + (0, $buE9b.WEBKIT))
                    })
                ], callback);
            case 0, $buE9b.RULESET:
                if (element.length) return (0, $jjhpc.combine)(element.props, function(value) {
                    switch((0, $jjhpc.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $6RQdH.serialize)([
                                (0, $dhEBD.copy)(element, {
                                    props: [
                                        (0, $jjhpc.replace)(value, /:(read-\w+)/, ':' + (0, $buE9b.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $6RQdH.serialize)([
                                (0, $dhEBD.copy)(element, {
                                    props: [
                                        (0, $jjhpc.replace)(value, /:(plac\w+)/, ':' + (0, $buE9b.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $dhEBD.copy)(element, {
                                    props: [
                                        (0, $jjhpc.replace)(value, /:(plac\w+)/, ':' + (0, $buE9b.MOZ) + '$1')
                                    ]
                                }),
                                (0, $dhEBD.copy)(element, {
                                    props: [
                                        (0, $jjhpc.replace)(value, /:(plac\w+)/, (0, $buE9b.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $f904659a3fd14c7d$var$defaultStylisPlugins = [
    $f904659a3fd14c7d$var$prefixer
];
var $f904659a3fd14c7d$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $f904659a3fd14c7d$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' ');
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $f904659a3fd14c7d$var$compat,
        $f904659a3fd14c7d$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $6RQdH.stringify),
        (0, $5Z4pX.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $5Z4pX.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $6RQdH.serialize)((0, $7MQd3.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $7ZlJE.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("7ZlJE", function(module, exports) {
$parcel$export(module.exports, "StyleSheet", () => $5d0f1714c4136662$export$9d753cd7ae895cce);
var $5d0f1714c4136662$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $5d0f1714c4136662$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $5d0f1714c4136662$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $5d0f1714c4136662$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$5d0f1714c4136662$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($5d0f1714c4136662$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $5d0f1714c4136662$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("dhEBD", function(module, exports) {
$parcel$export(module.exports, "position", () => $9abc5c6483fbd68f$export$5880b8b5730aff45);
$parcel$export(module.exports, "node", () => $9abc5c6483fbd68f$export$35059013cd4a06db);
$parcel$export(module.exports, "copy", () => $9abc5c6483fbd68f$export$784d13d8ee351f07);
$parcel$export(module.exports, "char", () => $9abc5c6483fbd68f$export$eba6f6f03b0a92e7);
$parcel$export(module.exports, "prev", () => $9abc5c6483fbd68f$export$232faf9add678146);
$parcel$export(module.exports, "next", () => $9abc5c6483fbd68f$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $9abc5c6483fbd68f$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "caret", () => $9abc5c6483fbd68f$export$e88cb2efb12ae807);
$parcel$export(module.exports, "slice", () => $9abc5c6483fbd68f$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $9abc5c6483fbd68f$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $9abc5c6483fbd68f$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $9abc5c6483fbd68f$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $9abc5c6483fbd68f$export$410ac95b9ec204b8);
$parcel$export(module.exports, "tokenize", () => $9abc5c6483fbd68f$export$660b2ee2d4fb4eff);
$parcel$export(module.exports, "whitespace", () => $9abc5c6483fbd68f$export$7af1228ff777d175);
$parcel$export(module.exports, "identifier", () => $9abc5c6483fbd68f$export$c2ab62c7bf24634);
$parcel$export(module.exports, "escaping", () => $9abc5c6483fbd68f$export$955ba06d119e085e);
$parcel$export(module.exports, "commenter", () => $9abc5c6483fbd68f$export$4254d4e2b3745c4c);

var $jjhpc = parcelRequire("jjhpc");
var $9abc5c6483fbd68f$export$53f1d5ea8de3d7c = 1;
var $9abc5c6483fbd68f$export$4e0c71f277ca26b3 = 1;
var $9abc5c6483fbd68f$export$f24224f1c91d8156 = 0;
var $9abc5c6483fbd68f$export$5880b8b5730aff45 = 0;
var $9abc5c6483fbd68f$export$c0306caf338ac095 = 0;
var $9abc5c6483fbd68f$export$30a86d91af8ff6e6 = '';
function $9abc5c6483fbd68f$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $9abc5c6483fbd68f$export$53f1d5ea8de3d7c,
        column: $9abc5c6483fbd68f$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $9abc5c6483fbd68f$export$784d13d8ee351f07(root, props) {
    return (0, $jjhpc.assign)($9abc5c6483fbd68f$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $9abc5c6483fbd68f$export$eba6f6f03b0a92e7() {
    return $9abc5c6483fbd68f$export$c0306caf338ac095;
}
function $9abc5c6483fbd68f$export$232faf9add678146() {
    $9abc5c6483fbd68f$export$c0306caf338ac095 = $9abc5c6483fbd68f$export$5880b8b5730aff45 > 0 ? (0, $jjhpc.charat)($9abc5c6483fbd68f$export$30a86d91af8ff6e6, --$9abc5c6483fbd68f$export$5880b8b5730aff45) : 0;
    if ($9abc5c6483fbd68f$export$4e0c71f277ca26b3--, $9abc5c6483fbd68f$export$c0306caf338ac095 === 10) $9abc5c6483fbd68f$export$4e0c71f277ca26b3 = 1, $9abc5c6483fbd68f$export$53f1d5ea8de3d7c--;
    return $9abc5c6483fbd68f$export$c0306caf338ac095;
}
function $9abc5c6483fbd68f$export$48cfd1e771a65c4f() {
    $9abc5c6483fbd68f$export$c0306caf338ac095 = $9abc5c6483fbd68f$export$5880b8b5730aff45 < $9abc5c6483fbd68f$export$f24224f1c91d8156 ? (0, $jjhpc.charat)($9abc5c6483fbd68f$export$30a86d91af8ff6e6, $9abc5c6483fbd68f$export$5880b8b5730aff45++) : 0;
    if ($9abc5c6483fbd68f$export$4e0c71f277ca26b3++, $9abc5c6483fbd68f$export$c0306caf338ac095 === 10) $9abc5c6483fbd68f$export$4e0c71f277ca26b3 = 1, $9abc5c6483fbd68f$export$53f1d5ea8de3d7c++;
    return $9abc5c6483fbd68f$export$c0306caf338ac095;
}
function $9abc5c6483fbd68f$export$4d3fb11e950abb9e() {
    return (0, $jjhpc.charat)($9abc5c6483fbd68f$export$30a86d91af8ff6e6, $9abc5c6483fbd68f$export$5880b8b5730aff45);
}
function $9abc5c6483fbd68f$export$e88cb2efb12ae807() {
    return $9abc5c6483fbd68f$export$5880b8b5730aff45;
}
function $9abc5c6483fbd68f$export$58adb3bec8346d0f(begin, end) {
    return (0, $jjhpc.substr)($9abc5c6483fbd68f$export$30a86d91af8ff6e6, begin, end);
}
function $9abc5c6483fbd68f$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $9abc5c6483fbd68f$export$2de70f21292aac9e(value) {
    return $9abc5c6483fbd68f$export$53f1d5ea8de3d7c = $9abc5c6483fbd68f$export$4e0c71f277ca26b3 = 1, $9abc5c6483fbd68f$export$f24224f1c91d8156 = (0, $jjhpc.strlen)($9abc5c6483fbd68f$export$30a86d91af8ff6e6 = value), $9abc5c6483fbd68f$export$5880b8b5730aff45 = 0, [];
}
function $9abc5c6483fbd68f$export$45918ac1574455b1(value) {
    return $9abc5c6483fbd68f$export$30a86d91af8ff6e6 = '', value;
}
function $9abc5c6483fbd68f$export$410ac95b9ec204b8(type) {
    return (0, $jjhpc.trim)($9abc5c6483fbd68f$export$58adb3bec8346d0f($9abc5c6483fbd68f$export$5880b8b5730aff45 - 1, $9abc5c6483fbd68f$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $9abc5c6483fbd68f$export$660b2ee2d4fb4eff(value) {
    return $9abc5c6483fbd68f$export$45918ac1574455b1($9abc5c6483fbd68f$export$5f8c09e3ae6f64e1($9abc5c6483fbd68f$export$2de70f21292aac9e(value)));
}
function $9abc5c6483fbd68f$export$7af1228ff777d175(type) {
    while($9abc5c6483fbd68f$export$c0306caf338ac095 = $9abc5c6483fbd68f$export$4d3fb11e950abb9e())if ($9abc5c6483fbd68f$export$c0306caf338ac095 < 33) $9abc5c6483fbd68f$export$48cfd1e771a65c4f();
    else break;
    return $9abc5c6483fbd68f$export$9e1725a4cfeada27(type) > 2 || $9abc5c6483fbd68f$export$9e1725a4cfeada27($9abc5c6483fbd68f$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $9abc5c6483fbd68f$export$5f8c09e3ae6f64e1(children) {
    while($9abc5c6483fbd68f$export$48cfd1e771a65c4f())switch($9abc5c6483fbd68f$export$9e1725a4cfeada27($9abc5c6483fbd68f$export$c0306caf338ac095)){
        case 0:
            (0, $jjhpc.append)($9abc5c6483fbd68f$export$c2ab62c7bf24634($9abc5c6483fbd68f$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $jjhpc.append)($9abc5c6483fbd68f$export$410ac95b9ec204b8($9abc5c6483fbd68f$export$c0306caf338ac095), children);
            break;
        default:
            (0, $jjhpc.append)((0, $jjhpc.from)($9abc5c6483fbd68f$export$c0306caf338ac095), children);
    }
    return children;
}
function $9abc5c6483fbd68f$export$955ba06d119e085e(index, count) {
    while(--count && $9abc5c6483fbd68f$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($9abc5c6483fbd68f$export$c0306caf338ac095 < 48 || $9abc5c6483fbd68f$export$c0306caf338ac095 > 102 || $9abc5c6483fbd68f$export$c0306caf338ac095 > 57 && $9abc5c6483fbd68f$export$c0306caf338ac095 < 65 || $9abc5c6483fbd68f$export$c0306caf338ac095 > 70 && $9abc5c6483fbd68f$export$c0306caf338ac095 < 97) break;
    return $9abc5c6483fbd68f$export$58adb3bec8346d0f(index, $9abc5c6483fbd68f$export$e88cb2efb12ae807() + (count < 6 && $9abc5c6483fbd68f$export$4d3fb11e950abb9e() == 32 && $9abc5c6483fbd68f$export$48cfd1e771a65c4f() == 32));
}
function $9abc5c6483fbd68f$export$c889f2fcc19dbf12(type) {
    while($9abc5c6483fbd68f$export$48cfd1e771a65c4f())switch($9abc5c6483fbd68f$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $9abc5c6483fbd68f$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $9abc5c6483fbd68f$export$c889f2fcc19dbf12($9abc5c6483fbd68f$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $9abc5c6483fbd68f$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $9abc5c6483fbd68f$export$48cfd1e771a65c4f();
            break;
    }
    return $9abc5c6483fbd68f$export$5880b8b5730aff45;
}
function $9abc5c6483fbd68f$export$4254d4e2b3745c4c(type, index) {
    while($9abc5c6483fbd68f$export$48cfd1e771a65c4f())// //
    if (type + $9abc5c6483fbd68f$export$c0306caf338ac095 === 57) break;
    else if (type + $9abc5c6483fbd68f$export$c0306caf338ac095 === 84 && $9abc5c6483fbd68f$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $9abc5c6483fbd68f$export$58adb3bec8346d0f(index, $9abc5c6483fbd68f$export$5880b8b5730aff45 - 1) + '*' + (0, $jjhpc.from)(type === 47 ? type : $9abc5c6483fbd68f$export$48cfd1e771a65c4f());
}
function $9abc5c6483fbd68f$export$c2ab62c7bf24634(index) {
    while(!$9abc5c6483fbd68f$export$9e1725a4cfeada27($9abc5c6483fbd68f$export$4d3fb11e950abb9e()))$9abc5c6483fbd68f$export$48cfd1e771a65c4f();
    return $9abc5c6483fbd68f$export$58adb3bec8346d0f(index, $9abc5c6483fbd68f$export$5880b8b5730aff45);
}

});
parcelRegister("jjhpc", function(module, exports) {
$parcel$export(module.exports, "abs", () => $e0ed4b03afd8ea51$export$2335f513bbd82c6d);
$parcel$export(module.exports, "from", () => $e0ed4b03afd8ea51$export$6788812c4e6611e6);
$parcel$export(module.exports, "assign", () => $e0ed4b03afd8ea51$export$e6e34fd1f2686227);
$parcel$export(module.exports, "hash", () => $e0ed4b03afd8ea51$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $e0ed4b03afd8ea51$export$a9db5e087081082d);
$parcel$export(module.exports, "trim", () => $e0ed4b03afd8ea51$export$87c2784dc9fc4ab);
$parcel$export(module.exports, "match", () => $e0ed4b03afd8ea51$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $e0ed4b03afd8ea51$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $e0ed4b03afd8ea51$export$f8e21b1e77979a08);
$parcel$export(module.exports, "substr", () => $e0ed4b03afd8ea51$export$2f35ab04d2335697);
$parcel$export(module.exports, "strlen", () => $e0ed4b03afd8ea51$export$36776f635604f274);
$parcel$export(module.exports, "sizeof", () => $e0ed4b03afd8ea51$export$f9084667e487ed46);
$parcel$export(module.exports, "append", () => $e0ed4b03afd8ea51$export$10d8903dec122b9d);
$parcel$export(module.exports, "combine", () => $e0ed4b03afd8ea51$export$1be1fc439b849fdf);
/**
 * @param {number}
 * @return {number}
 */ var $e0ed4b03afd8ea51$export$2335f513bbd82c6d = Math.abs;
var $e0ed4b03afd8ea51$export$6788812c4e6611e6 = String.fromCharCode;
var $e0ed4b03afd8ea51$export$e6e34fd1f2686227 = Object.assign;
function $e0ed4b03afd8ea51$export$d6af199866bfb566(value, length) {
    return $e0ed4b03afd8ea51$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $e0ed4b03afd8ea51$export$a9db5e087081082d(value, 0)) << 2 ^ $e0ed4b03afd8ea51$export$a9db5e087081082d(value, 1)) << 2 ^ $e0ed4b03afd8ea51$export$a9db5e087081082d(value, 2)) << 2 ^ $e0ed4b03afd8ea51$export$a9db5e087081082d(value, 3) : 0;
}
function $e0ed4b03afd8ea51$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $e0ed4b03afd8ea51$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $e0ed4b03afd8ea51$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $e0ed4b03afd8ea51$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $e0ed4b03afd8ea51$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $e0ed4b03afd8ea51$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $e0ed4b03afd8ea51$export$36776f635604f274(value) {
    return value.length;
}
function $e0ed4b03afd8ea51$export$f9084667e487ed46(value) {
    return value.length;
}
function $e0ed4b03afd8ea51$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $e0ed4b03afd8ea51$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}

});


parcelRegister("7MQd3", function(module, exports) {
$parcel$export(module.exports, "compile", () => $5ab583d041aa3f57$export$ef7acd7185315e22);

var $buE9b = parcelRequire("buE9b");

var $jjhpc = parcelRequire("jjhpc");

var $dhEBD = parcelRequire("dhEBD");
function $5ab583d041aa3f57$export$ef7acd7185315e22(value) {
    return (0, $dhEBD.dealloc)($5ab583d041aa3f57$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $dhEBD.alloc)(value), 0, [
        0
    ], value));
}
function $5ab583d041aa3f57$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $dhEBD.next)()){
        // (
        case 40:
            if (previous != 108 && (0, $jjhpc.charat)(characters, length - 1) == 58) {
                if ((0, $jjhpc.indexof)(characters += (0, $jjhpc.replace)((0, $dhEBD.delimit)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $dhEBD.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $dhEBD.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, $dhEBD.escaping)((0, $dhEBD.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $dhEBD.peek)()){
                case 42:
                case 47:
                    (0, $jjhpc.append)($5ab583d041aa3f57$export$4a34f930e789283c((0, $dhEBD.commenter)((0, $dhEBD.next)(), (0, $dhEBD.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $jjhpc.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $jjhpc.replace)(characters, /\f/g, '');
                    if (property > 0 && (0, $jjhpc.strlen)(characters) - length) (0, $jjhpc.append)(property > 32 ? $5ab583d041aa3f57$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $5ab583d041aa3f57$export$f8483753829ec8f3((0, $jjhpc.replace)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $jjhpc.append)(reference = $5ab583d041aa3f57$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $5ab583d041aa3f57$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $jjhpc.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $5ab583d041aa3f57$export$98e6a39c04603d36(value, reference, reference, rule && (0, $jjhpc.append)($5ab583d041aa3f57$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $5ab583d041aa3f57$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $jjhpc.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $dhEBD.prev)() == 125) continue;
            }
            switch(characters += (0, $jjhpc.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $jjhpc.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $dhEBD.peek)() === 45) characters += (0, $dhEBD.delimit)((0, $dhEBD.next)());
                    atrule = (0, $dhEBD.peek)(), offset = length = (0, $jjhpc.strlen)(type = characters += (0, $dhEBD.identifier)((0, $dhEBD.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $jjhpc.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $5ab583d041aa3f57$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $jjhpc.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $jjhpc.substr)(value, post + 1, post = (0, $jjhpc.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, $jjhpc.trim)(j > 0 ? rule[x] + ' ' + y : (0, $jjhpc.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $dhEBD.node)(value, root, parent, offset === 0 ? (0, $buE9b.RULESET) : type, props, children, length);
}
function $5ab583d041aa3f57$export$4a34f930e789283c(value, root, parent) {
    return (0, $dhEBD.node)(value, root, parent, (0, $buE9b.COMMENT), (0, $jjhpc.from)((0, $dhEBD.char)()), (0, $jjhpc.substr)(value, 2, -2), 0);
}
function $5ab583d041aa3f57$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $dhEBD.node)(value, root, parent, (0, $buE9b.DECLARATION), (0, $jjhpc.substr)(value, 0, length), (0, $jjhpc.substr)(value, length + 1, -1), length);
}

});
parcelRegister("buE9b", function(module, exports) {
$parcel$export(module.exports, "MS", () => $85e1a372462440e6$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $85e1a372462440e6$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $85e1a372462440e6$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "COMMENT", () => $85e1a372462440e6$export$a29989082612d0d9);
$parcel$export(module.exports, "RULESET", () => $85e1a372462440e6$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $85e1a372462440e6$export$527d108ccf083c2b);
$parcel$export(module.exports, "IMPORT", () => $85e1a372462440e6$export$a763edbf796b780a);
$parcel$export(module.exports, "KEYFRAMES", () => $85e1a372462440e6$export$b44a8529a35fcb60);
$parcel$export(module.exports, "LAYER", () => $85e1a372462440e6$export$d773506282b3cfe6);
var $85e1a372462440e6$export$71ad59f2e432cfe8 = '-ms-';
var $85e1a372462440e6$export$2c0f367103c8d01c = '-moz-';
var $85e1a372462440e6$export$39dfd62a25e0fe93 = '-webkit-';
var $85e1a372462440e6$export$a29989082612d0d9 = 'comm';
var $85e1a372462440e6$export$aa3a2e812ca8570d = 'rule';
var $85e1a372462440e6$export$527d108ccf083c2b = 'decl';
var $85e1a372462440e6$export$d3d35020fa5b54f0 = '@page';
var $85e1a372462440e6$export$500415a86c544f73 = '@media';
var $85e1a372462440e6$export$a763edbf796b780a = '@import';
var $85e1a372462440e6$export$2790aeb8b4e5c826 = '@charset';
var $85e1a372462440e6$export$1cc683e23b84b133 = '@viewport';
var $85e1a372462440e6$export$9447a5efea57e862 = '@supports';
var $85e1a372462440e6$export$ef011b4e114b1fba = '@document';
var $85e1a372462440e6$export$6aad947bda0f3f46 = '@namespace';
var $85e1a372462440e6$export$b44a8529a35fcb60 = '@keyframes';
var $85e1a372462440e6$export$2c16de31893252e6 = '@font-face';
var $85e1a372462440e6$export$3d846dd52e150c6f = '@counter-style';
var $85e1a372462440e6$export$22314bfbb57653fe = '@font-feature-values';
var $85e1a372462440e6$export$d773506282b3cfe6 = '@layer';

});


parcelRegister("5Z4pX", function(module, exports) {
$parcel$export(module.exports, "middleware", () => $45b613815fd25d99$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $45b613815fd25d99$export$38bcb760f1d4871c);

var $buE9b = parcelRequire("buE9b");

var $jjhpc = parcelRequire("jjhpc");

var $dhEBD = parcelRequire("dhEBD");

var $6RQdH = parcelRequire("6RQdH");

var $2kwCb = parcelRequire("2kwCb");
function $45b613815fd25d99$export$5a7767152ae0305f(collection) {
    var length = (0, $jjhpc.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $45b613815fd25d99$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $45b613815fd25d99$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $buE9b.DECLARATION:
                element.return = (0, $2kwCb.prefix)(element.value, element.length, children);
                return;
            case 0, $buE9b.KEYFRAMES:
                return (0, $6RQdH.serialize)([
                    (0, $dhEBD.copy)(element, {
                        value: (0, $jjhpc.replace)(element.value, '@', '@' + (0, $buE9b.WEBKIT))
                    })
                ], callback);
            case 0, $buE9b.RULESET:
                if (element.length) return (0, $jjhpc.combine)(element.props, function(value) {
                    switch((0, $jjhpc.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $6RQdH.serialize)([
                                (0, $dhEBD.copy)(element, {
                                    props: [
                                        (0, $jjhpc.replace)(value, /:(read-\w+)/, ':' + (0, $buE9b.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $6RQdH.serialize)([
                                (0, $dhEBD.copy)(element, {
                                    props: [
                                        (0, $jjhpc.replace)(value, /:(plac\w+)/, ':' + (0, $buE9b.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $dhEBD.copy)(element, {
                                    props: [
                                        (0, $jjhpc.replace)(value, /:(plac\w+)/, ':' + (0, $buE9b.MOZ) + '$1')
                                    ]
                                }),
                                (0, $dhEBD.copy)(element, {
                                    props: [
                                        (0, $jjhpc.replace)(value, /:(plac\w+)/, (0, $buE9b.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $45b613815fd25d99$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $buE9b.RULESET:
            element.props = element.props.map(function(value) {
                return (0, $jjhpc.combine)((0, $dhEBD.tokenize)(value), function(value, index, children) {
                    switch((0, $jjhpc.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, $jjhpc.substr)(value, 1, (0, $jjhpc.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $jjhpc.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $jjhpc.sizeof)(children) > 1 ? '' : value;
                                case index = (0, $jjhpc.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

});
parcelRegister("6RQdH", function(module, exports) {
$parcel$export(module.exports, "serialize", () => $5000331b77d59caa$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $5000331b77d59caa$export$fac44ee5b035f737);

var $buE9b = parcelRequire("buE9b");

var $jjhpc = parcelRequire("jjhpc");
function $5000331b77d59caa$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $jjhpc.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $5000331b77d59caa$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $buE9b.LAYER:
            if (element.children.length) break;
        case 0, $buE9b.IMPORT:
        case 0, $buE9b.DECLARATION:
            return element.return = element.return || element.value;
        case 0, $buE9b.COMMENT:
            return '';
        case 0, $buE9b.KEYFRAMES:
            return element.return = element.value + '{' + $5000331b77d59caa$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $buE9b.RULESET:
            element.value = element.props.join(',');
    }
    return (0, $jjhpc.strlen)(children = $5000331b77d59caa$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

});

parcelRegister("2kwCb", function(module, exports) {
$parcel$export(module.exports, "prefix", () => $1b26bfac7c9cdada$export$82e9f45cca5ba907);

var $buE9b = parcelRequire("buE9b");

var $jjhpc = parcelRequire("jjhpc");
function $1b26bfac7c9cdada$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $jjhpc.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $buE9b.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $buE9b.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, $buE9b.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MOZ) + value + (0, $buE9b.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, $jjhpc.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + value + value;
        // order
        case 6165:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $buE9b.WEBKIT) + value + (0, $jjhpc.replace)(value, /(\w+).+(:[^]+)/, (0, $buE9b.WEBKIT) + 'box-$1$2' + (0, $buE9b.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + 'flex-item-' + (0, $jjhpc.replace)(value, /flex-|-self/g, '') + (!(0, $jjhpc.match)(value, /flex-|baseline/) ? (0, $buE9b.MS) + 'grid-row-' + (0, $jjhpc.replace)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + 'flex-line-pack' + (0, $jjhpc.replace)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $buE9b.WEBKIT) + 'box-' + (0, $jjhpc.replace)(value, '-grow', '') + (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $buE9b.WEBKIT) + (0, $jjhpc.replace)(value, /([^-])(transform)/g, '$1' + (0, $buE9b.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $jjhpc.replace)((0, $jjhpc.replace)((0, $jjhpc.replace)(value, /(zoom-|grab)/, (0, $buE9b.WEBKIT) + '$1'), /(image-set)/, (0, $buE9b.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $jjhpc.replace)(value, /(image-set\([^]*)/, (0, $buE9b.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $jjhpc.replace)((0, $jjhpc.replace)(value, /(.+:)(flex-)?(.*)/, (0, $buE9b.WEBKIT) + 'box-pack:$3' + (0, $buE9b.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $buE9b.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, $jjhpc.match)(value, /flex-|baseline/)) return (0, $buE9b.MS) + 'grid-column-align' + (0, $jjhpc.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $buE9b.MS) + (0, $jjhpc.replace)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $jjhpc.match)(element.props, /grid-\w+-end/);
            })) return ~(0, $jjhpc.indexof)(value + (children = children[length].value), 'span') ? value : (0, $buE9b.MS) + (0, $jjhpc.replace)(value, '-start', '') + value + (0, $buE9b.MS) + 'grid-row-span:' + (~(0, $jjhpc.indexof)(children, 'span') ? (0, $jjhpc.match)(children, /\d+/) : +(0, $jjhpc.match)(children, /\d+/) - +(0, $jjhpc.match)(value, /\d+/)) + ';';
            return (0, $buE9b.MS) + (0, $jjhpc.replace)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $jjhpc.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, $buE9b.MS) + (0, $jjhpc.replace)((0, $jjhpc.replace)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $jjhpc.replace)(value, /(.+)-inline(.+)/, (0, $buE9b.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $jjhpc.strlen)(value) - 1 - length > 6) switch((0, $jjhpc.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $jjhpc.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $jjhpc.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $buE9b.WEBKIT) + '$2-$3' + '$1' + (0, $buE9b.MOZ) + ((0, $jjhpc.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $jjhpc.indexof)(value, 'stretch') ? $1b26bfac7c9cdada$export$82e9f45cca5ba907((0, $jjhpc.replace)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $jjhpc.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $buE9b.MS) + a + ':' + b + f + (c ? (0, $buE9b.MS) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $jjhpc.charat)(value, length + 6) === 121) return (0, $jjhpc.replace)(value, ':', ':' + (0, $buE9b.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $jjhpc.charat)(value, (0, $jjhpc.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $jjhpc.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $buE9b.WEBKIT) + ((0, $jjhpc.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $buE9b.WEBKIT) + '$2$3' + '$1' + (0, $buE9b.MS) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $jjhpc.replace)(value, ':', ':' + (0, $buE9b.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $jjhpc.replace)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}

});


parcelRegister("7LkUp", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a6d24410be87591$export$2e2bcd8739ae039);
var $5a6d24410be87591$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("62Oof", function(module, exports) {
$parcel$export(module.exports, "default", () => $466a0462a396a56a$export$2e2bcd8739ae039);
function $466a0462a396a56a$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("87uOn", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e96e0ae3c8e2999$export$2e2bcd8739ae039);
function $5e96e0ae3c8e2999$export$2e2bcd8739ae039() {
    return $5e96e0ae3c8e2999$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5e96e0ae3c8e2999$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("3hx71", function(module, exports) {
$parcel$export(module.exports, "default", () => $263ca508648a6bcb$export$2e2bcd8739ae039);

var $35aua = parcelRequire("35aua");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $263ca508648a6bcb$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($35aua)))(targetComponent, sourceComponent);
};

});

parcelRegister("eSd6x", function(module, exports) {
$parcel$export(module.exports, "getRegisteredStyles", () => $ad404616b71240e2$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $ad404616b71240e2$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $ad404616b71240e2$export$6f077d94b33a01aa);
var $ad404616b71240e2$var$isBrowser = true;
function $ad404616b71240e2$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $ad404616b71240e2$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $ad404616b71240e2$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $ad404616b71240e2$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $ad404616b71240e2$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("90BXC", function(module, exports) {
$parcel$export(module.exports, "serializeStyles", () => $68f18f4ea61e9c41$export$6321afa313b251b5);

var $aCY0v = parcelRequire("aCY0v");

var $55h8i = parcelRequire("55h8i");

var $62Oof = parcelRequire("62Oof");
var $68f18f4ea61e9c41$var$isDevelopment = false;
var $68f18f4ea61e9c41$var$hyphenateRegex = /[A-Z]|^ms/g;
var $68f18f4ea61e9c41$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $68f18f4ea61e9c41$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $68f18f4ea61e9c41$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $68f18f4ea61e9c41$var$processStyleName = /* #__PURE__ */ (0, $62Oof.default)(function(styleName) {
    return $68f18f4ea61e9c41$var$isCustomProperty(styleName) ? styleName : styleName.replace($68f18f4ea61e9c41$var$hyphenateRegex, '-$&').toLowerCase();
});
var $68f18f4ea61e9c41$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($68f18f4ea61e9c41$var$animationRegex, function(match, p1, p2) {
                $68f18f4ea61e9c41$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $68f18f4ea61e9c41$var$cursor
                };
                return p1;
            });
    }
    if ((0, $55h8i.default)[key] !== 1 && !$68f18f4ea61e9c41$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $68f18f4ea61e9c41$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $68f18f4ea61e9c41$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $68f18f4ea61e9c41$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $68f18f4ea61e9c41$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $68f18f4ea61e9c41$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $68f18f4ea61e9c41$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $68f18f4ea61e9c41$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $68f18f4ea61e9c41$var$cursor;
                var result = interpolation(mergedProps);
                $68f18f4ea61e9c41$var$cursor = previousCursor;
                return $68f18f4ea61e9c41$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $68f18f4ea61e9c41$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $68f18f4ea61e9c41$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($68f18f4ea61e9c41$var$isProcessableValue(asString)) string += $68f18f4ea61e9c41$var$processStyleName(key) + ":" + $68f18f4ea61e9c41$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $68f18f4ea61e9c41$var$isDevelopment) throw new Error($68f18f4ea61e9c41$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($68f18f4ea61e9c41$var$isProcessableValue(value[_i])) string += $68f18f4ea61e9c41$var$processStyleName(key) + ":" + $68f18f4ea61e9c41$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $68f18f4ea61e9c41$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $68f18f4ea61e9c41$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $68f18f4ea61e9c41$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $68f18f4ea61e9c41$var$cursor;
function $68f18f4ea61e9c41$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $68f18f4ea61e9c41$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $68f18f4ea61e9c41$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $68f18f4ea61e9c41$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $68f18f4ea61e9c41$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $68f18f4ea61e9c41$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $aCY0v.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $68f18f4ea61e9c41$var$cursor
    };
}

});
parcelRegister("aCY0v", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bcc002b5700def0$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $7bcc002b5700def0$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("55h8i", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b3ab59f97f8b260$export$2e2bcd8739ae039);
var $3b3ab59f97f8b260$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("9oExk", function(module, exports) {
$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $6d75cca965600918$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $6d75cca965600918$export$811a713a7276cb9d);

var $1v5pe = parcelRequire("1v5pe");
var $6d75cca965600918$var$syncFallback = function syncFallback(create) {
    return create();
};
var $6d75cca965600918$var$useInsertionEffect = false;
var $6d75cca965600918$export$db21c7ffa21794e7 = $6d75cca965600918$var$useInsertionEffect || $6d75cca965600918$var$syncFallback;
var $6d75cca965600918$export$811a713a7276cb9d = $6d75cca965600918$var$useInsertionEffect || $1v5pe.useLayoutEffect;

});



parcelRegister("kH2JL", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", () => $77e03087b3c033de$export$1ca2a26fecb070ae);

var $1v5pe = parcelRequire("1v5pe");
const $77e03087b3c033de$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1v5pe.createContext)('elevation.surface');

});

parcelRegister("77s18", function(module, exports) {
$parcel$export(module.exports, "backgroundColorStylesMap", () => $0a51ba62339ad919$export$e7af83bafe7f9e63);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $iItnK = parcelRequire("iItnK");

var $6OZZq = parcelRequire("6OZZq");
const $0a51ba62339ad919$export$e7af83bafe7f9e63 = (0, $6OZZq.getSerializedStylesMap)('backgroundColor', (0, $iItnK.backgroundColorMap));

});
parcelRegister("iItnK", function(module, exports) {
$parcel$export(module.exports, "backgroundColorMap", () => $5b77da98f1b2c5af$export$d1d79bf68ac056bd);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b9ffd6dcccead720baadbffd4a1648a>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $5b77da98f1b2c5af$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.code.added.highlight': "var(--ds-background-code-added-highlight, #DCFFF1)",
    'color.background.code.added.line': "var(--ds-background-code-added-line, #BAF3DB66)",
    'color.background.code.default': "var(--ds-background-code-default, #FFFFFF)",
    'color.background.code.gutter': "var(--ds-background-code-gutter, #F0F1F2)",
    'color.background.code.highlight': "var(--ds-background-code-highlight, #F0F1F2)",
    'color.background.code.removed.highlight': "var(--ds-background-code-removed-highlight, #FFECEB)",
    'color.background.code.removed.line': "var(--ds-background-code-removed-line, #FFD5D266)",
    'color.background.disabled': "var(--ds-background-disabled, #0515240F)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.subtle': "var(--ds-background-danger-subtle, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.subtle': "var(--ds-background-warning-subtle, #FBD779)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.subtle': "var(--ds-background-success-subtle, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.subtle': "var(--ds-background-discovery-subtle, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.subtle': "var(--ds-background-information-subtle, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.rovo.background.brand.bold': "var(--ds-rovo-background-brand-bold, #000000)",
    'color.rovo.background.brand.bold.hovered': "var(--ds-rovo-background-brand-bold-hovered, #1E1F21)",
    'color.rovo.background.brand.bold.pressed': "var(--ds-rovo-background-brand-bold-pressed, #292A2E)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};

});

parcelRegister("6OZZq", function(module, exports) {
$parcel$export(module.exports, "getSerializedStylesMap", () => $4d679e63416097c5$export$ca0f9c2de39ffed7);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $hRuTh = parcelRequire("hRuTh");
const $4d679e63416097c5$export$ca0f9c2de39ffed7 = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, tokenName)=>{
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[tokenName] = (0, $hRuTh.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [cssProperty]: tokenMap[tokenName]
        });
        return emotionSpacingMap;
    }, {});
};

});


parcelRegister("7tKyU", function(module, exports) {
$parcel$export(module.exports, "isSurfaceColorToken", () => $c126803e62251ff9$export$5e65a44e5b6ecadb);

var $jsoiD = parcelRequire("jsoiD");
const $c126803e62251ff9$export$5e65a44e5b6ecadb = (color)=>(0, $jsoiD.surfaceColorMap)[color] !== undefined;

});
parcelRegister("jsoiD", function(module, exports) {
$parcel$export(module.exports, "surfaceColorMap", () => $3900a8d26ce16fd7$export$41a358c9c2356760);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6c124f7044e82421c90bec6e00efe281>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $3900a8d26ce16fd7$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};

});


parcelRegister("cpDmm", function(module, exports) {
$parcel$export(module.exports, "paddingStylesMap", () => $381ed20a58049278$export$e615f061ca585a6c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $5OwLN = parcelRequire("5OwLN");

var $9QsMz = parcelRequire("9QsMz");
const $381ed20a58049278$export$e615f061ca585a6c = (0, $5OwLN.createSpacingStylesMap)((0, $9QsMz.positiveSpaceMap), [
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd'
]);

});
parcelRegister("5OwLN", function(module, exports) {
$parcel$export(module.exports, "createSpacingStylesMap", () => $9a26af2c42fa079b$export$f2bee1f59203ac70);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6OZZq = parcelRequire("6OZZq");
const $9a26af2c42fa079b$var$spacingProperties = [
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'gap',
    'rowGap',
    'columnGap'
];
const $9a26af2c42fa079b$export$f2bee1f59203ac70 = (tokenMap, properties)=>{
    return properties.reduce((styleMap, spacingProperty)=>{
        styleMap[spacingProperty] = (0, $6OZZq.getSerializedStylesMap)(spacingProperty, tokenMap);
        return styleMap;
    }, {});
};

});

parcelRegister("9QsMz", function(module, exports) {
$parcel$export(module.exports, "positiveSpaceMap", () => $570d12423add9232$export$958d0ae7f2977ae4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd46ff4a983762dcab797228d1ab2ee6>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::27b3f9240cb9c6f16e54a6ebd2c859b9>>
 */ const $570d12423add9232$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};

});


parcelRegister("4Iv3g", function(module, exports) {
$parcel$export(module.exports, "parseXcss", () => $04c9006d58e3d81b$export$a9c84988c8f81f2d);
/* parse-xcss.tsx generated by @compiled/babel-plugin v3.0.2 */ /* parse-xcss.tsx generated by @compiled/babel-plugin v3.0.2 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
parcelRequire("1v5pe");

var $5Rxcw = parcelRequire("5Rxcw");
const $04c9006d58e3d81b$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $04c9006d58e3d81b$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [(0, $5Rxcw.uniqueSymbol)]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};

});
parcelRegister("5Rxcw", function(module, exports) {
$parcel$export(module.exports, "uniqueSymbol", () => $e0c499d4fac9425d$export$43e479c916cb4ada);
const $e0c499d4fac9425d$export$43e479c916cb4ada = Symbol('UNSAFE_INTERNAL_styles');

});


parcelRegister("ihIkA", function(module, exports) {
$parcel$export(module.exports, "surfaceColorStylesMap", () => $5235e6cc45771278$export$ff257d957d48c421);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $21yAH = parcelRequire("21yAH");

var $6OZZq = parcelRequire("6OZZq");

var $jsoiD = parcelRequire("jsoiD");
const $5235e6cc45771278$export$ff257d957d48c421 = (0, $6OZZq.getSerializedStylesMap)((0, $21yAH.CURRENT_SURFACE_CSS_VAR), (0, $jsoiD.surfaceColorMap));

});
parcelRegister("21yAH", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $a4c09e4de3749474$export$4ef52930e33717cd);
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", () => $a4c09e4de3749474$export$cb374d25ded7f6ab);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $a4c09e4de3749474$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $a4c09e4de3749474$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $a4c09e4de3749474$export$352e418ed5b6193a);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $a4c09e4de3749474$export$9d7b58831ae93caa);
const $a4c09e4de3749474$export$4ef52930e33717cd = 'data-theme';
const $a4c09e4de3749474$export$cb374d25ded7f6ab = 'data-subtree-theme';
const $a4c09e4de3749474$export$a00eac3f8684bcd0 = 'data-color-mode';
const $a4c09e4de3749474$export$2112803007239c61 = 'data-contrast-mode';
const $a4c09e4de3749474$export$352e418ed5b6193a = 'data-custom-theme';
const $a4c09e4de3749474$export$6f0c6fb8c80fcc92 = 'ds';
const $a4c09e4de3749474$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
const $a4c09e4de3749474$export$dddac1532e822863 = `--${$a4c09e4de3749474$export$6f0c6fb8c80fcc92}-token-not-found`;
const $a4c09e4de3749474$export$9d7b58831ae93caa = `--${$a4c09e4de3749474$export$6f0c6fb8c80fcc92}-elevation-surface-current`;

});



parcelRegister("kK7WO", function(module, exports) {
$parcel$export(module.exports, "default", () => $f19e44bce5ed1452$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $kfP5u = parcelRequire("kfP5u");

var $lJYzG = parcelRequire("lJYzG");
function $f19e44bce5ed1452$export$2e2bcd8739ae039() {
    var intl = $1v5pe.useContext((0, $lJYzG.Context));
    (0, $kfP5u.invariantIntlContext)(intl);
    return intl;
}

});
parcelRegister("kfP5u", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $ebecd645f84dc6af$export$f5708dca728d7177);
$parcel$export(module.exports, "invariantIntlContext", () => $ebecd645f84dc6af$export$45c4bbf6e55bba1f);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $ebecd645f84dc6af$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "toKeyedReactNodeArray", () => $ebecd645f84dc6af$export$d2fd241e0b53c057);
$parcel$export(module.exports, "assignUniqueKeysToParts", () => $ebecd645f84dc6af$export$cfec03d26465fa63);
$parcel$export(module.exports, "shallowEqual", () => $ebecd645f84dc6af$export$d36bdfa510afb180);

var $lmviS = parcelRequire("lmviS");

var $1v5pe = parcelRequire("1v5pe");

var $3zCfq = parcelRequire("3zCfq");
function $ebecd645f84dc6af$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $ebecd645f84dc6af$export$45c4bbf6e55bba1f(intl) {
    $ebecd645f84dc6af$export$f5708dca728d7177(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $ebecd645f84dc6af$export$b52f8d6fc0d47415 = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, (0, $3zCfq.DEFAULT_INTL_CONFIG)), {
    textComponent: $1v5pe.Fragment
});
var $ebecd645f84dc6af$var$toKeyedReactNode = function(reactNode, key) {
    return $1v5pe.isValidElement(reactNode) ? $1v5pe.cloneElement(reactNode, {
        key: key
    }) : reactNode;
};
var $ebecd645f84dc6af$export$d2fd241e0b53c057 = function(children) {
    var _a;
    /**
 * Note: {@link React.Children.map} will add its own index-based prefix to
 * every key anyway, so the auto-injected one doesn't even have to be unique.
 * This basically just tells React that it's explicit/intentional.
 */ return (_a = $1v5pe.Children.map(children, $ebecd645f84dc6af$var$toKeyedReactNode)) !== null && _a !== void 0 ? _a : [];
};
function $ebecd645f84dc6af$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($ebecd645f84dc6af$export$d2fd241e0b53c057(parts));
    };
}
function $ebecd645f84dc6af$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("lmviS", function(module, exports) {
$parcel$export(module.exports, "__extends", () => $f8d3ef3f5f1ac4bf$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $f8d3ef3f5f1ac4bf$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $f8d3ef3f5f1ac4bf$export$3c9a16f847548506);
$parcel$export(module.exports, "__exportStar", () => $f8d3ef3f5f1ac4bf$export$f33643c0debef087);
$parcel$export(module.exports, "__values", () => $f8d3ef3f5f1ac4bf$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $f8d3ef3f5f1ac4bf$export$8d051b38c9118094);
$parcel$export(module.exports, "__spread", () => $f8d3ef3f5f1ac4bf$export$afc72e2116322959);
$parcel$export(module.exports, "__spreadArray", () => $f8d3ef3f5f1ac4bf$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $f8d3ef3f5f1ac4bf$var$extendStatics = function(d, b) {
    $f8d3ef3f5f1ac4bf$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f8d3ef3f5f1ac4bf$var$extendStatics(d, b);
};
function $f8d3ef3f5f1ac4bf$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f8d3ef3f5f1ac4bf$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f8d3ef3f5f1ac4bf$export$18ce0697a983be9b = function() {
    $f8d3ef3f5f1ac4bf$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f8d3ef3f5f1ac4bf$export$18ce0697a983be9b.apply(this, arguments);
};
function $f8d3ef3f5f1ac4bf$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f8d3ef3f5f1ac4bf$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f8d3ef3f5f1ac4bf$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f8d3ef3f5f1ac4bf$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f8d3ef3f5f1ac4bf$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f8d3ef3f5f1ac4bf$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $f8d3ef3f5f1ac4bf$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f8d3ef3f5f1ac4bf$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f8d3ef3f5f1ac4bf$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f8d3ef3f5f1ac4bf$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f8d3ef3f5f1ac4bf$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f8d3ef3f5f1ac4bf$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f8d3ef3f5f1ac4bf$export$45d3717a4c69092e(o, m, p);
}
function $f8d3ef3f5f1ac4bf$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f8d3ef3f5f1ac4bf$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f8d3ef3f5f1ac4bf$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f8d3ef3f5f1ac4bf$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f8d3ef3f5f1ac4bf$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f8d3ef3f5f1ac4bf$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f8d3ef3f5f1ac4bf$export$10c90e4f7922046c(v) {
    return this instanceof $f8d3ef3f5f1ac4bf$export$10c90e4f7922046c ? (this.v = v, this) : new $f8d3ef3f5f1ac4bf$export$10c90e4f7922046c(v);
}
function $f8d3ef3f5f1ac4bf$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f8d3ef3f5f1ac4bf$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f8d3ef3f5f1ac4bf$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f8d3ef3f5f1ac4bf$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f8d3ef3f5f1ac4bf$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f8d3ef3f5f1ac4bf$export$19a8beecd37a4c45 === "function" ? $f8d3ef3f5f1ac4bf$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f8d3ef3f5f1ac4bf$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f8d3ef3f5f1ac4bf$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $f8d3ef3f5f1ac4bf$var$ownKeys = function(o) {
    $f8d3ef3f5f1ac4bf$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $f8d3ef3f5f1ac4bf$var$ownKeys(o);
};
function $f8d3ef3f5f1ac4bf$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $f8d3ef3f5f1ac4bf$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $f8d3ef3f5f1ac4bf$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $f8d3ef3f5f1ac4bf$var$__setModuleDefault(result, mod);
    return result;
}
function $f8d3ef3f5f1ac4bf$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f8d3ef3f5f1ac4bf$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f8d3ef3f5f1ac4bf$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f8d3ef3f5f1ac4bf$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f8d3ef3f5f1ac4bf$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f8d3ef3f5f1ac4bf$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f8d3ef3f5f1ac4bf$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f8d3ef3f5f1ac4bf$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $f8d3ef3f5f1ac4bf$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $f8d3ef3f5f1ac4bf$export$2e2bcd8739ae039 = {
    __extends: $f8d3ef3f5f1ac4bf$export$a8ba968b8961cb8a,
    __assign: $f8d3ef3f5f1ac4bf$export$18ce0697a983be9b,
    __rest: $f8d3ef3f5f1ac4bf$export$3c9a16f847548506,
    __decorate: $f8d3ef3f5f1ac4bf$export$29e00dfd3077644b,
    __param: $f8d3ef3f5f1ac4bf$export$d5ad3fd78186038f,
    __esDecorate: $f8d3ef3f5f1ac4bf$export$3a84e1ae4e97e9b0,
    __runInitializers: $f8d3ef3f5f1ac4bf$export$d831c04e792af3d,
    __propKey: $f8d3ef3f5f1ac4bf$export$6a2a36740a146cb8,
    __setFunctionName: $f8d3ef3f5f1ac4bf$export$d1a06452d3489bc7,
    __metadata: $f8d3ef3f5f1ac4bf$export$f1db080c865becb9,
    __awaiter: $f8d3ef3f5f1ac4bf$export$1050f835b63b671e,
    __generator: $f8d3ef3f5f1ac4bf$export$67ebef60e6f28a6,
    __createBinding: $f8d3ef3f5f1ac4bf$export$45d3717a4c69092e,
    __exportStar: $f8d3ef3f5f1ac4bf$export$f33643c0debef087,
    __values: $f8d3ef3f5f1ac4bf$export$19a8beecd37a4c45,
    __read: $f8d3ef3f5f1ac4bf$export$8d051b38c9118094,
    __spread: $f8d3ef3f5f1ac4bf$export$afc72e2116322959,
    __spreadArrays: $f8d3ef3f5f1ac4bf$export$6388937ca91ccae8,
    __spreadArray: $f8d3ef3f5f1ac4bf$export$1216008129fb82ed,
    __await: $f8d3ef3f5f1ac4bf$export$10c90e4f7922046c,
    __asyncGenerator: $f8d3ef3f5f1ac4bf$export$e427f37a30a4de9b,
    __asyncDelegator: $f8d3ef3f5f1ac4bf$export$bbd80228419bb833,
    __asyncValues: $f8d3ef3f5f1ac4bf$export$e3b29a3d6162315f,
    __makeTemplateObject: $f8d3ef3f5f1ac4bf$export$4fb47efe1390b86f,
    __importStar: $f8d3ef3f5f1ac4bf$export$c21735bcef00d192,
    __importDefault: $f8d3ef3f5f1ac4bf$export$da59b14a69baef04,
    __classPrivateFieldGet: $f8d3ef3f5f1ac4bf$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f8d3ef3f5f1ac4bf$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f8d3ef3f5f1ac4bf$export$81fdc39f203e4e04,
    __addDisposableResource: $f8d3ef3f5f1ac4bf$export$88ac25d8e944e405,
    __disposeResources: $f8d3ef3f5f1ac4bf$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $f8d3ef3f5f1ac4bf$export$889dfb5d17574b0b
};

});

parcelRegister("3zCfq", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $29a24f33d5456f79$export$f5708dca728d7177);
$parcel$export(module.exports, "filterProps", () => $29a24f33d5456f79$export$d697c39a2985a4c);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $29a24f33d5456f79$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "createIntlCache", () => $29a24f33d5456f79$export$51c4f4e973f2dc00);
$parcel$export(module.exports, "createFormatters", () => $29a24f33d5456f79$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "getNamedFormat", () => $29a24f33d5456f79$export$4ee1db8ce44a209b);

var $lmviS = parcelRequire("lmviS");

var $iZCbV = parcelRequire("iZCbV");
parcelRequire("5wzdk");
var $diqj4 = parcelRequire("diqj4");

var $elgnH = parcelRequire("elgnH");
function $29a24f33d5456f79$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $29a24f33d5456f79$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $29a24f33d5456f79$var$defaultErrorHandler = function(error) {};
var $29a24f33d5456f79$var$defaultWarnHandler = function(warning) {};
var $29a24f33d5456f79$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $29a24f33d5456f79$var$defaultErrorHandler,
    onWarn: $29a24f33d5456f79$var$defaultWarnHandler
};
function $29a24f33d5456f79$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $29a24f33d5456f79$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $29a24f33d5456f79$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $29a24f33d5456f79$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $iZCbV.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $lmviS.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $29a24f33d5456f79$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $iZCbV.strategies).variadic
    });
    var getNumberFormat = (0, $iZCbV.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $lmviS.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $29a24f33d5456f79$var$createFastMemoizeCache(cache.number),
        strategy: (0, $iZCbV.strategies).variadic
    });
    var getPluralRules = (0, $iZCbV.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $lmviS.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $29a24f33d5456f79$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $iZCbV.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $iZCbV.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $diqj4.IntlMessageFormat)(message, locales, overrideFormats, (0, $lmviS.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $29a24f33d5456f79$var$createFastMemoizeCache(cache.message),
            strategy: (0, $iZCbV.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $iZCbV.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $lmviS.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $29a24f33d5456f79$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $iZCbV.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $iZCbV.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $lmviS.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $29a24f33d5456f79$var$createFastMemoizeCache(cache.list),
            strategy: (0, $iZCbV.strategies).variadic
        }),
        getDisplayNames: (0, $iZCbV.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $lmviS.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $29a24f33d5456f79$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $iZCbV.strategies).variadic
        })
    };
}
function $29a24f33d5456f79$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $elgnH.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("iZCbV", function(module, exports) {
$parcel$export(module.exports, "memoize", () => $03917a0203ce2598$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $03917a0203ce2598$export$c5491a8691a23b9e);
//
// Main
//
function $03917a0203ce2598$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $03917a0203ce2598$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $03917a0203ce2598$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $03917a0203ce2598$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $03917a0203ce2598$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $03917a0203ce2598$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $03917a0203ce2598$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $03917a0203ce2598$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $03917a0203ce2598$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $03917a0203ce2598$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $03917a0203ce2598$var$monadic : $03917a0203ce2598$var$variadic;
    return $03917a0203ce2598$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $03917a0203ce2598$var$strategyVariadic(fn, options) {
    return $03917a0203ce2598$var$assemble(fn, this, $03917a0203ce2598$var$variadic, options.cache.create(), options.serializer);
}
function $03917a0203ce2598$var$strategyMonadic(fn, options) {
    return $03917a0203ce2598$var$assemble(fn, this, $03917a0203ce2598$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $03917a0203ce2598$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
var $03917a0203ce2598$var$ObjectWithoutPrototypeCache = /** @class */ function() {
    function ObjectWithoutPrototypeCache() {
        this.cache = Object.create(null);
    }
    ObjectWithoutPrototypeCache.prototype.get = function(key) {
        return this.cache[key];
    };
    ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
        this.cache[key] = value;
    };
    return ObjectWithoutPrototypeCache;
}();
var $03917a0203ce2598$var$cacheDefault = {
    create: function create() {
        return new $03917a0203ce2598$var$ObjectWithoutPrototypeCache();
    }
};
var $03917a0203ce2598$export$c5491a8691a23b9e = {
    variadic: $03917a0203ce2598$var$strategyVariadic,
    monadic: $03917a0203ce2598$var$strategyMonadic
};

});

parcelRegister("5wzdk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", () => (parcelRequire("783MZ")).ErrorCode);
$parcel$export(module.exports, "FormatError", () => (parcelRequire("783MZ")).FormatError);
$parcel$export(module.exports, "isFormatXMLElementFn", () => (parcelRequire("hA2YD")).isFormatXMLElementFn);
$parcel$export(module.exports, "IntlMessageFormat", () => (parcelRequire("diqj4")).IntlMessageFormat);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $diqj4 = parcelRequire("diqj4");
parcelRequire("783MZ");
parcelRequire("hA2YD");
var $405b41a717912e93$export$2e2bcd8739ae039 = (0, $diqj4.IntlMessageFormat);

});
parcelRegister("diqj4", function(module, exports) {
$parcel$export(module.exports, "IntlMessageFormat", () => $9ae15cc116d6cb99$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $lmviS = parcelRequire("lmviS");

var $iZCbV = parcelRequire("iZCbV");

var $3JjFu = parcelRequire("3JjFu");

var $hA2YD = parcelRequire("hA2YD");
// -- MessageFormat --------------------------------------------------------
function $9ae15cc116d6cb99$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $lmviS.__assign)((0, $lmviS.__assign)((0, $lmviS.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $9ae15cc116d6cb99$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $9ae15cc116d6cb99$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $lmviS.__assign)({}, defaultConfig));
}
function $9ae15cc116d6cb99$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $9ae15cc116d6cb99$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $iZCbV.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $lmviS.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $9ae15cc116d6cb99$var$createFastMemoizeCache(cache.number),
            strategy: (0, $iZCbV.strategies).variadic
        }),
        getDateTimeFormat: (0, $iZCbV.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $lmviS.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $9ae15cc116d6cb99$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $iZCbV.strategies).variadic
        }),
        getPluralRules: (0, $iZCbV.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $lmviS.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $9ae15cc116d6cb99$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $iZCbV.strategies).variadic
        })
    };
}
var $9ae15cc116d6cb99$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $hA2YD.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $hA2YD.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $lmviS.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $lmviS.__assign)((0, $lmviS.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $9ae15cc116d6cb99$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $9ae15cc116d6cb99$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $3JjFu.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("3JjFu", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("4cQwB")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("4cQwB")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("4cQwB")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("4cQwB")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("4cQwB")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("4cQwB")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("4cQwB")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("4cQwB")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("4cQwB")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("4cQwB")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("4cQwB")).isTimeElement);
$parcel$export(module.exports, "TYPE", () => (parcelRequire("4cQwB")).TYPE);
$parcel$export(module.exports, "parse", () => $2b74d4c6d875e768$export$98e6a39c04603d36);

var $lmviS = parcelRequire("lmviS");

var $hhvRB = parcelRequire("hhvRB");

var $lMzVS = parcelRequire("lMzVS");

var $4cQwB = parcelRequire("4cQwB");

var $hlkCH = parcelRequire("hlkCH");
function $2b74d4c6d875e768$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $4cQwB.isSelectElement)(el) || (0, $4cQwB.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $2b74d4c6d875e768$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $4cQwB.isNumberElement)(el) && (0, $4cQwB.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $4cQwB.isDateElement)(el) || (0, $4cQwB.isTimeElement)(el)) && (0, $4cQwB.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $4cQwB.isTagElement)(el)) $2b74d4c6d875e768$var$pruneLocation(el.children);
    });
}
function $2b74d4c6d875e768$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $lmviS.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $lMzVS.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $hhvRB.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $2b74d4c6d875e768$var$pruneLocation(result.val);
    return result.val;
}
var $2b74d4c6d875e768$export$d3c1bfa0f7d806e9 = (0, $lMzVS.Parser);

});
parcelRegister("hhvRB", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $c94cbda4fb48af24$export$896afd8541959ee5);
var $c94cbda4fb48af24$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($c94cbda4fb48af24$export$896afd8541959ee5 || ($c94cbda4fb48af24$export$896afd8541959ee5 = {}));

});

parcelRegister("lMzVS", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $fdb9f41ebf6a1729$export$7acfa6ed01010e37);

var $lmviS = parcelRequire("lmviS");

var $hhvRB = parcelRequire("hhvRB");

var $4cQwB = parcelRequire("4cQwB");

var $Ef8yO = parcelRequire("Ef8yO");
parcelRequire("4zrWy");
var $dJC6N = parcelRequire("dJC6N");
var $22Fn8 = parcelRequire("22Fn8");

var $8R32B = parcelRequire("8R32B");
var $fdb9f41ebf6a1729$var$_a;
var $fdb9f41ebf6a1729$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $Ef8yO.SPACE_SEPARATOR_REGEX).source, "*"));
var $fdb9f41ebf6a1729$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $Ef8yO.SPACE_SEPARATOR_REGEX).source, "*$"));
function $fdb9f41ebf6a1729$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $fdb9f41ebf6a1729$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $fdb9f41ebf6a1729$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $fdb9f41ebf6a1729$var$hasNativeFromEntries = !!Object.fromEntries;
var $fdb9f41ebf6a1729$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $fdb9f41ebf6a1729$var$hasTrimStart = !!String.prototype.trimStart;
var $fdb9f41ebf6a1729$var$hasTrimEnd = !!String.prototype.trimEnd;
var $fdb9f41ebf6a1729$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $fdb9f41ebf6a1729$var$isSafeInteger = $fdb9f41ebf6a1729$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $fdb9f41ebf6a1729$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $fdb9f41ebf6a1729$var$re = $fdb9f41ebf6a1729$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $fdb9f41ebf6a1729$var$REGEX_SUPPORTS_U_AND_Y = (($fdb9f41ebf6a1729$var$_a = $fdb9f41ebf6a1729$var$re.exec('a')) === null || $fdb9f41ebf6a1729$var$_a === void 0 ? void 0 : $fdb9f41ebf6a1729$var$_a[0]) === 'a';
} catch (_) {
    $fdb9f41ebf6a1729$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $fdb9f41ebf6a1729$var$startsWith = $fdb9f41ebf6a1729$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $fdb9f41ebf6a1729$var$fromCodePoint = $fdb9f41ebf6a1729$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $fdb9f41ebf6a1729$var$fromEntries = // native
$fdb9f41ebf6a1729$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $fdb9f41ebf6a1729$var$codePointAt = $fdb9f41ebf6a1729$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $fdb9f41ebf6a1729$var$trimStart = $fdb9f41ebf6a1729$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($fdb9f41ebf6a1729$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $fdb9f41ebf6a1729$var$trimEnd = $fdb9f41ebf6a1729$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($fdb9f41ebf6a1729$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $fdb9f41ebf6a1729$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $fdb9f41ebf6a1729$var$matchIdentifierAtIndex;
if ($fdb9f41ebf6a1729$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $fdb9f41ebf6a1729$var$IDENTIFIER_PREFIX_RE_1 = $fdb9f41ebf6a1729$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $fdb9f41ebf6a1729$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $fdb9f41ebf6a1729$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $fdb9f41ebf6a1729$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$fdb9f41ebf6a1729$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $fdb9f41ebf6a1729$var$codePointAt(s, index);
        if (c === undefined || $fdb9f41ebf6a1729$var$_isWhiteSpace(c) || $fdb9f41ebf6a1729$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $fdb9f41ebf6a1729$var$fromCodePoint.apply(void 0, match);
};
var $fdb9f41ebf6a1729$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $4cQwB.TYPE).pound,
                    location: $fdb9f41ebf6a1729$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $hhvRB.ErrorKind).UNMATCHED_CLOSING_TAG, $fdb9f41ebf6a1729$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $fdb9f41ebf6a1729$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $4cQwB.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $fdb9f41ebf6a1729$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$fdb9f41ebf6a1729$var$_isAlpha(this.char())) return this.error((0, $hhvRB.ErrorKind).INVALID_TAG, $fdb9f41ebf6a1729$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $hhvRB.ErrorKind).UNMATCHED_CLOSING_TAG, $fdb9f41ebf6a1729$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $hhvRB.ErrorKind).INVALID_TAG, $fdb9f41ebf6a1729$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $4cQwB.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $fdb9f41ebf6a1729$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $hhvRB.ErrorKind).UNCLOSED_TAG, $fdb9f41ebf6a1729$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $hhvRB.ErrorKind).INVALID_TAG, $fdb9f41ebf6a1729$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $fdb9f41ebf6a1729$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $fdb9f41ebf6a1729$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $4cQwB.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$fdb9f41ebf6a1729$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $fdb9f41ebf6a1729$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $fdb9f41ebf6a1729$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $hhvRB.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $fdb9f41ebf6a1729$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $hhvRB.ErrorKind).EMPTY_ARGUMENT, $fdb9f41ebf6a1729$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $hhvRB.ErrorKind).MALFORMED_ARGUMENT, $fdb9f41ebf6a1729$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $hhvRB.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $fdb9f41ebf6a1729$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $4cQwB.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $fdb9f41ebf6a1729$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $hhvRB.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $fdb9f41ebf6a1729$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $hhvRB.ErrorKind).MALFORMED_ARGUMENT, $fdb9f41ebf6a1729$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $fdb9f41ebf6a1729$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $fdb9f41ebf6a1729$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $hhvRB.ErrorKind).EXPECT_ARGUMENT_TYPE, $fdb9f41ebf6a1729$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $fdb9f41ebf6a1729$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $hhvRB.ErrorKind).EXPECT_ARGUMENT_STYLE, $fdb9f41ebf6a1729$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $fdb9f41ebf6a1729$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $fdb9f41ebf6a1729$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $fdb9f41ebf6a1729$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $fdb9f41ebf6a1729$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $4cQwB.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $hhvRB.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $8R32B.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $4cQwB.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $dJC6N.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $4cQwB.TYPE).date : (0, $4cQwB.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $4cQwB.TYPE).number : argType === 'date' ? (0, $4cQwB.TYPE).date : (0, $4cQwB.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $hhvRB.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $fdb9f41ebf6a1729$var$createLocation(typeEndPosition_1, (0, $lmviS.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $hhvRB.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $fdb9f41ebf6a1729$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $hhvRB.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $hhvRB.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $fdb9f41ebf6a1729$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $4cQwB.TYPE).select,
                        value: value,
                        options: $fdb9f41ebf6a1729$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $4cQwB.TYPE).plural,
                        value: value,
                        options: $fdb9f41ebf6a1729$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $hhvRB.ErrorKind).INVALID_ARGUMENT_TYPE, $fdb9f41ebf6a1729$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $hhvRB.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $fdb9f41ebf6a1729$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $hhvRB.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $fdb9f41ebf6a1729$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $22Fn8.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $hhvRB.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $4cQwB.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $22Fn8.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $hhvRB.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $hhvRB.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $fdb9f41ebf6a1729$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $hhvRB.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $hhvRB.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $hhvRB.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $hhvRB.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $fdb9f41ebf6a1729$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $fdb9f41ebf6a1729$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $hhvRB.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $hhvRB.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $fdb9f41ebf6a1729$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $hhvRB.ErrorKind).MISSING_OTHER_CLAUSE, $fdb9f41ebf6a1729$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $fdb9f41ebf6a1729$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$fdb9f41ebf6a1729$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $fdb9f41ebf6a1729$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($fdb9f41ebf6a1729$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $fdb9f41ebf6a1729$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $fdb9f41ebf6a1729$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $fdb9f41ebf6a1729$var$_isAlphaOrSlash(codepoint) {
    return $fdb9f41ebf6a1729$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $fdb9f41ebf6a1729$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $fdb9f41ebf6a1729$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $fdb9f41ebf6a1729$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("4cQwB", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $310106c7780da567$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $310106c7780da567$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $310106c7780da567$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $310106c7780da567$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $310106c7780da567$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $310106c7780da567$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $310106c7780da567$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $310106c7780da567$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $310106c7780da567$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $310106c7780da567$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $310106c7780da567$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $310106c7780da567$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $310106c7780da567$export$7680c41f1a55f4cf);
var $310106c7780da567$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($310106c7780da567$export$b87f371cbc396fcf || ($310106c7780da567$export$b87f371cbc396fcf = {}));
var $310106c7780da567$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($310106c7780da567$export$906452485466fa53 || ($310106c7780da567$export$906452485466fa53 = {}));
function $310106c7780da567$export$cfa10c5697238752(el) {
    return el.type === $310106c7780da567$export$b87f371cbc396fcf.literal;
}
function $310106c7780da567$export$4f55724281bdfaf9(el) {
    return el.type === $310106c7780da567$export$b87f371cbc396fcf.argument;
}
function $310106c7780da567$export$e11187b219e191e1(el) {
    return el.type === $310106c7780da567$export$b87f371cbc396fcf.number;
}
function $310106c7780da567$export$32d811605da75f40(el) {
    return el.type === $310106c7780da567$export$b87f371cbc396fcf.date;
}
function $310106c7780da567$export$34ec46f596b1702f(el) {
    return el.type === $310106c7780da567$export$b87f371cbc396fcf.time;
}
function $310106c7780da567$export$dcfe1c11d168b5a1(el) {
    return el.type === $310106c7780da567$export$b87f371cbc396fcf.select;
}
function $310106c7780da567$export$6c796d116f0a4fbc(el) {
    return el.type === $310106c7780da567$export$b87f371cbc396fcf.plural;
}
function $310106c7780da567$export$c0ece297bdd0c082(el) {
    return el.type === $310106c7780da567$export$b87f371cbc396fcf.pound;
}
function $310106c7780da567$export$5c83de34745812b(el) {
    return el.type === $310106c7780da567$export$b87f371cbc396fcf.tag;
}
function $310106c7780da567$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $310106c7780da567$export$906452485466fa53.number);
}
function $310106c7780da567$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $310106c7780da567$export$906452485466fa53.dateTime);
}
function $310106c7780da567$export$f0ac572c1121c662(value) {
    return {
        type: $310106c7780da567$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $310106c7780da567$export$425e864b0ba114f1(value, style) {
    return {
        type: $310106c7780da567$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("Ef8yO", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $078f7a73000cfe1f$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $078f7a73000cfe1f$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $078f7a73000cfe1f$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("4zrWy", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("dJC6N")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("22Fn8")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("22Fn8")).parseNumberSkeletonFromString);
parcelRequire("dJC6N");
parcelRequire("22Fn8");

});
parcelRegister("dJC6N", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => $9ffd09e3947b5c5e$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $9ffd09e3947b5c5e$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $9ffd09e3947b5c5e$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($9ffd09e3947b5c5e$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("22Fn8", function(module, exports) {
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $17cbdc51753bb5eb$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $17cbdc51753bb5eb$export$47c6f8480bda3e11);

var $lmviS = parcelRequire("lmviS");

var $g4rqc = parcelRequire("g4rqc");
function $17cbdc51753bb5eb$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $g4rqc.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $17cbdc51753bb5eb$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $17cbdc51753bb5eb$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $17cbdc51753bb5eb$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $17cbdc51753bb5eb$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $17cbdc51753bb5eb$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $17cbdc51753bb5eb$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($17cbdc51753bb5eb$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $17cbdc51753bb5eb$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $17cbdc51753bb5eb$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$17cbdc51753bb5eb$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $17cbdc51753bb5eb$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $17cbdc51753bb5eb$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $17cbdc51753bb5eb$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $17cbdc51753bb5eb$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $lmviS.__assign)((0, $lmviS.__assign)((0, $lmviS.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $lmviS.__assign)((0, $lmviS.__assign)({}, all), $17cbdc51753bb5eb$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $lmviS.__assign)((0, $lmviS.__assign)((0, $lmviS.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $lmviS.__assign)((0, $lmviS.__assign)({}, all), $17cbdc51753bb5eb$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($17cbdc51753bb5eb$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($17cbdc51753bb5eb$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($17cbdc51753bb5eb$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($17cbdc51753bb5eb$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, result), $17cbdc51753bb5eb$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($17cbdc51753bb5eb$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, result), $17cbdc51753bb5eb$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $17cbdc51753bb5eb$var$parseSign(token.stem);
        if (signOpts) result = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $17cbdc51753bb5eb$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("g4rqc", function(module, exports) {
$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $bb324a64f7f21993$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $bb324a64f7f21993$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("8R32B", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", () => $6725a1d136b0883c$export$29c5368be8904d27);

var $9b7g2 = parcelRequire("9b7g2");
function $6725a1d136b0883c$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $6725a1d136b0883c$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $6725a1d136b0883c$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $9b7g2.timeData)[regionTag || ''] || (0, $9b7g2.timeData)[languageTag || ''] || (0, $9b7g2.timeData)["".concat(languageTag, "-001")] || (0, $9b7g2.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("9b7g2", function(module, exports) {
$parcel$export(module.exports, "timeData", () => $6aeac559d4e4f8ce$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $6aeac559d4e4f8ce$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});



parcelRegister("hlkCH", function(module, exports) {

var $lmviS = parcelRequire("lmviS");

var $4cQwB = parcelRequire("4cQwB");
function $ca04652d057de8bf$var$cloneDeep(obj) {
    if (Array.isArray(obj)) // @ts-expect-error meh
    return (0, $lmviS.__spreadArray)([], obj.map($ca04652d057de8bf$var$cloneDeep), true);
    if (obj !== null && typeof obj === 'object') // @ts-expect-error meh
    return Object.keys(obj).reduce(function(cloned, k) {
        // @ts-expect-error meh
        cloned[k] = $ca04652d057de8bf$var$cloneDeep(obj[k]);
        return cloned;
    }, {});
    return obj;
}
function $ca04652d057de8bf$var$hoistPluralOrSelectElement(ast, el, positionToInject) {
    // pull this out of the ast and move it to the top
    var cloned = $ca04652d057de8bf$var$cloneDeep(el);
    var options = cloned.options;
    cloned.options = Object.keys(options).reduce(function(all, k) {
        var newValue = $ca04652d057de8bf$export$be5687ba8bbdf416((0, $lmviS.__spreadArray)((0, $lmviS.__spreadArray)((0, $lmviS.__spreadArray)([], ast.slice(0, positionToInject), true), options[k].value, true), ast.slice(positionToInject + 1), true));
        all[k] = {
            value: newValue
        };
        return all;
    }, {});
    return cloned;
}
function $ca04652d057de8bf$var$isPluralOrSelectElement(el) {
    return (0, $4cQwB.isPluralElement)(el) || (0, $4cQwB.isSelectElement)(el);
}
function $ca04652d057de8bf$var$findPluralOrSelectElement(ast) {
    return !!ast.find(function(el) {
        if ($ca04652d057de8bf$var$isPluralOrSelectElement(el)) return true;
        if ((0, $4cQwB.isTagElement)(el)) return $ca04652d057de8bf$var$findPluralOrSelectElement(el.children);
        return false;
    });
}
function $ca04652d057de8bf$export$be5687ba8bbdf416(ast) {
    for(var i = 0; i < ast.length; i++){
        var el = ast[i];
        if ($ca04652d057de8bf$var$isPluralOrSelectElement(el)) return [
            $ca04652d057de8bf$var$hoistPluralOrSelectElement(ast, el, i)
        ];
        if ((0, $4cQwB.isTagElement)(el) && $ca04652d057de8bf$var$findPluralOrSelectElement([
            el
        ])) throw new Error('Cannot hoist plural/select within a tag element. Please put the tag element inside each plural/select option');
    }
    return ast;
}
/**
 * Collect all variables in an AST to Record<string, TYPE>
 * @param ast AST to collect variables from
 * @param vars Record of variable name to variable type
 */ function $ca04652d057de8bf$var$collectVariables(ast, vars) {
    if (vars === void 0) vars = new Map();
    ast.forEach(function(el) {
        if ((0, $4cQwB.isArgumentElement)(el) || (0, $4cQwB.isDateElement)(el) || (0, $4cQwB.isTimeElement)(el) || (0, $4cQwB.isNumberElement)(el)) {
            if (el.value in vars && vars.get(el.value) !== el.type) throw new Error("Variable ".concat(el.value, " has conflicting types"));
            vars.set(el.value, el.type);
        }
        if ((0, $4cQwB.isPluralElement)(el) || (0, $4cQwB.isSelectElement)(el)) {
            vars.set(el.value, el.type);
            Object.keys(el.options).forEach(function(k) {
                $ca04652d057de8bf$var$collectVariables(el.options[k].value, vars);
            });
        }
        if ((0, $4cQwB.isTagElement)(el)) {
            vars.set(el.value, el.type);
            $ca04652d057de8bf$var$collectVariables(el.children, vars);
        }
    });
}
function $ca04652d057de8bf$export$1edd9c892fdd9d27(a, b) {
    var aVars = new Map();
    var bVars = new Map();
    $ca04652d057de8bf$var$collectVariables(a, aVars);
    $ca04652d057de8bf$var$collectVariables(b, bVars);
    if (aVars.size !== bVars.size) return {
        success: false,
        error: new Error("Different number of variables: [".concat(Array.from(aVars.keys()).join(', '), "] vs [").concat(Array.from(bVars.keys()).join(', '), "]"))
    };
    return Array.from(aVars.entries()).reduce(function(result, _a) {
        var key = _a[0], type = _a[1];
        if (!result.success) return result;
        var bType = bVars.get(key);
        if (bType == null) return {
            success: false,
            error: new Error("Missing variable ".concat(key, " in message"))
        };
        if (bType !== type) return {
            success: false,
            error: new Error("Variable ".concat(key, " has conflicting types: ").concat((0, $4cQwB.TYPE)[type], " vs ").concat((0, $4cQwB.TYPE)[bType]))
        };
        return result;
    }, {
        success: true
    });
}

});


parcelRegister("hA2YD", function(module, exports) {
$parcel$export(module.exports, "PART_TYPE", () => $ccc81b9daa1354c2$export$49694c2877b44c57);
$parcel$export(module.exports, "isFormatXMLElementFn", () => $ccc81b9daa1354c2$export$df0c12a2d414a163);
$parcel$export(module.exports, "formatToParts", () => $ccc81b9daa1354c2$export$275d4a3bb5f66fda);
parcelRequire("3JjFu");
var $4cQwB = parcelRequire("4cQwB");

var $783MZ = parcelRequire("783MZ");
var $ccc81b9daa1354c2$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($ccc81b9daa1354c2$export$49694c2877b44c57 || ($ccc81b9daa1354c2$export$49694c2877b44c57 = {}));
function $ccc81b9daa1354c2$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $ccc81b9daa1354c2$export$49694c2877b44c57.literal || part.type !== $ccc81b9daa1354c2$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $ccc81b9daa1354c2$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $ccc81b9daa1354c2$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $4cQwB.isLiteralElement)(els[0])) return [
        {
            type: $ccc81b9daa1354c2$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $4cQwB.isLiteralElement)(el)) {
            result.push({
                type: $ccc81b9daa1354c2$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $4cQwB.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $ccc81b9daa1354c2$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $783MZ.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $4cQwB.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $ccc81b9daa1354c2$export$49694c2877b44c57.literal : $ccc81b9daa1354c2$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $4cQwB.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $4cQwB.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $ccc81b9daa1354c2$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4cQwB.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $4cQwB.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $ccc81b9daa1354c2$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4cQwB.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $4cQwB.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $ccc81b9daa1354c2$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4cQwB.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$ccc81b9daa1354c2$export$df0c12a2d414a163(formatFn)) throw new (0, $783MZ.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $ccc81b9daa1354c2$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $ccc81b9daa1354c2$export$49694c2877b44c57.literal : $ccc81b9daa1354c2$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $4cQwB.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $783MZ.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $ccc81b9daa1354c2$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $4cQwB.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $783MZ.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $783MZ.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $783MZ.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $ccc81b9daa1354c2$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $ccc81b9daa1354c2$var$mergeLiteral(result);
}

});
parcelRegister("783MZ", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", () => $530c3836dc36a5b9$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $530c3836dc36a5b9$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $530c3836dc36a5b9$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $530c3836dc36a5b9$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $530c3836dc36a5b9$export$8bfc137e4d23fdf0);

var $lmviS = parcelRequire("lmviS");
var $530c3836dc36a5b9$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($530c3836dc36a5b9$export$d4e71bc0b80dc0fb || ($530c3836dc36a5b9$export$d4e71bc0b80dc0fb = {}));
var $530c3836dc36a5b9$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $lmviS.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $530c3836dc36a5b9$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $lmviS.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $530c3836dc36a5b9$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($530c3836dc36a5b9$export$7369836851cc1329);
var $530c3836dc36a5b9$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $lmviS.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $530c3836dc36a5b9$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($530c3836dc36a5b9$export$7369836851cc1329);
var $530c3836dc36a5b9$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $lmviS.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $530c3836dc36a5b9$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($530c3836dc36a5b9$export$7369836851cc1329);

});




parcelRegister("elgnH", function(module, exports) {
$parcel$export(module.exports, "IntlErrorCode", () => $a70fbbcf8430f01a$export$557d6acb76e8a244);
$parcel$export(module.exports, "IntlError", () => $a70fbbcf8430f01a$export$c016d36112f6ddf8);
$parcel$export(module.exports, "UnsupportedFormatterError", () => $a70fbbcf8430f01a$export$549f97e137a05c90);
$parcel$export(module.exports, "InvalidConfigError", () => $a70fbbcf8430f01a$export$3ca04dd7fb305893);
$parcel$export(module.exports, "MissingDataError", () => $a70fbbcf8430f01a$export$c1eaf877d81384b6);
$parcel$export(module.exports, "IntlFormatError", () => $a70fbbcf8430f01a$export$e3b7eee1dbc44895);
$parcel$export(module.exports, "MessageFormatError", () => $a70fbbcf8430f01a$export$74a601a3d3f31621);
$parcel$export(module.exports, "MissingTranslationError", () => $a70fbbcf8430f01a$export$2ddcb436d0aa3688);

var $lmviS = parcelRequire("lmviS");
var $a70fbbcf8430f01a$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($a70fbbcf8430f01a$export$557d6acb76e8a244 || ($a70fbbcf8430f01a$export$557d6acb76e8a244 = {}));
var $a70fbbcf8430f01a$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $lmviS.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $a70fbbcf8430f01a$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $lmviS.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $a70fbbcf8430f01a$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($a70fbbcf8430f01a$export$c016d36112f6ddf8);
var $a70fbbcf8430f01a$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $lmviS.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $a70fbbcf8430f01a$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($a70fbbcf8430f01a$export$c016d36112f6ddf8);
var $a70fbbcf8430f01a$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $lmviS.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $a70fbbcf8430f01a$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($a70fbbcf8430f01a$export$c016d36112f6ddf8);
var $a70fbbcf8430f01a$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $lmviS.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $a70fbbcf8430f01a$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($a70fbbcf8430f01a$export$c016d36112f6ddf8);
var $a70fbbcf8430f01a$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $lmviS.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($a70fbbcf8430f01a$export$e3b7eee1dbc44895);
var $a70fbbcf8430f01a$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $lmviS.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $a70fbbcf8430f01a$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($a70fbbcf8430f01a$export$c016d36112f6ddf8);

});



parcelRegister("lJYzG", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $fd3cc9ccf667a0a4$export$2881499e37b75b9a);
$parcel$export(module.exports, "Context", () => $fd3cc9ccf667a0a4$export$841858b892ce1f4c);
$parcel$export(module.exports, "default", () => $fd3cc9ccf667a0a4$export$2e2bcd8739ae039);

var $lmviS = parcelRequire("lmviS");

var $35aua = parcelRequire("35aua");

var $1v5pe = parcelRequire("1v5pe");

var $kfP5u = parcelRequire("kfP5u");
function $fd3cc9ccf667a0a4$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $fd3cc9ccf667a0a4$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $1v5pe.createContext(null)) : $1v5pe.createContext(null);
var $fd3cc9ccf667a0a4$var$IntlConsumer = $fd3cc9ccf667a0a4$var$IntlContext.Consumer, $fd3cc9ccf667a0a4$var$IntlProvider = $fd3cc9ccf667a0a4$var$IntlContext.Provider;
var $fd3cc9ccf667a0a4$export$2881499e37b75b9a = $fd3cc9ccf667a0a4$var$IntlProvider;
var $fd3cc9ccf667a0a4$export$841858b892ce1f4c = $fd3cc9ccf667a0a4$var$IntlContext;
function $fd3cc9ccf667a0a4$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $1v5pe.createElement($fd3cc9ccf667a0a4$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $kfP5u.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $1v5pe.createElement(WrappedComponent, (0, $lmviS.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($fd3cc9ccf667a0a4$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($35aua)))(// @ts-expect-error
    $1v5pe.forwardRef(function(props, ref) {
        return $1v5pe.createElement(WithIntl, (0, $lmviS.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($35aua)))(WithIntl, WrappedComponent);
}

});


parcelRegister("6XPVu", function(module, exports) {
$parcel$export(module.exports, "default", () => $984e80906b00ff9d$export$2e2bcd8739ae039);

var $75IaS = parcelRequire("75IaS");
var $984e80906b00ff9d$export$2e2bcd8739ae039 = (0, $75IaS.defineMessages)({
    defaultFallback: {
        id: 'dev-agents.error-boundary.default-fallback',
        defaultMessage: 'Something went wrong',
        description: 'Default fallback message shown when an error occurs'
    },
    flagTitle: {
        id: 'dev-agents.error-boundary.flag.title',
        defaultMessage: 'Something went wrong on our end',
        description: 'Title of the error flag shown when an error is caught by the error boundary'
    },
    flagDescription: {
        id: 'dev-agents.error-boundary.flag.description',
        defaultMessage: 'Try refreshing the page. If the problem persists, contact support.',
        description: 'Description of the error flag shown when an error is caught by the error boundary'
    },
    flagReloadButton: {
        id: 'dev-agents.error-boundary.flag.reload-button',
        defaultMessage: 'Reload page',
        description: 'Button text to reload the page in the error flag'
    },
    flagIconLabel: {
        id: 'dev-agents.error-boundary.flag.icon-label',
        defaultMessage: 'Error',
        description: 'Accessibility label for the error icon in the error flag'
    }
});

});
parcelRegister("75IaS", function(module, exports) {
$parcel$export(module.exports, "defineMessages", () => $529b4426a6d8b1d2$export$1adfeb024f5185b);
$parcel$export(module.exports, "defineMessage", () => $529b4426a6d8b1d2$export$747d244ee58120dd);
$parcel$export(module.exports, "FormattedDate", () => $529b4426a6d8b1d2$export$40ae3194919d16b);
$parcel$export(module.exports, "FormattedTime", () => $529b4426a6d8b1d2$export$5b390a54f8a846f7);
$parcel$export(module.exports, "FormattedNumber", () => $529b4426a6d8b1d2$export$db80edc1e6b2f63d);
$parcel$export(module.exports, "FormattedList", () => $529b4426a6d8b1d2$export$f52b44e459e6e71d);
$parcel$export(module.exports, "FormattedDisplayName", () => $529b4426a6d8b1d2$export$c2336ea5aaab92fa);
$parcel$export(module.exports, "FormattedDateParts", () => $529b4426a6d8b1d2$export$7fdc7d2c91ce149b);
$parcel$export(module.exports, "FormattedTimeParts", () => $529b4426a6d8b1d2$export$ec35873761676c2a);
$parcel$export(module.exports, "createIntlCache", () => (parcelRequire("3zCfq")).createIntlCache);
$parcel$export(module.exports, "InvalidConfigError", () => (parcelRequire("elgnH")).InvalidConfigError);
$parcel$export(module.exports, "MessageFormatError", () => (parcelRequire("elgnH")).MessageFormatError);
$parcel$export(module.exports, "MissingDataError", () => (parcelRequire("elgnH")).MissingDataError);
$parcel$export(module.exports, "MissingTranslationError", () => (parcelRequire("elgnH")).MissingTranslationError);
$parcel$export(module.exports, "ReactIntlError", () => (parcelRequire("elgnH")).IntlError);
$parcel$export(module.exports, "ReactIntlErrorCode", () => (parcelRequire("elgnH")).IntlErrorCode);
$parcel$export(module.exports, "UnsupportedFormatterError", () => (parcelRequire("elgnH")).UnsupportedFormatterError);
$parcel$export(module.exports, "createIntl", () => (parcelRequire("1YTwG")).createIntl);
$parcel$export(module.exports, "FormattedDateTimeRange", () => (parcelRequire("4DGRH")).default);
$parcel$export(module.exports, "FormattedMessage", () => (parcelRequire("b2Az1")).default);
$parcel$export(module.exports, "FormattedPlural", () => (parcelRequire("1wmds")).default);
$parcel$export(module.exports, "FormattedRelativeTime", () => (parcelRequire("1CCqZ")).default);
$parcel$export(module.exports, "injectIntl", () => (parcelRequire("lJYzG")).default);
$parcel$export(module.exports, "IntlContext", () => (parcelRequire("lJYzG")).Context);
$parcel$export(module.exports, "IntlProvider", () => (parcelRequire("cZ6aD")).default);
$parcel$export(module.exports, "RawIntlProvider", () => (parcelRequire("lJYzG")).Provider);
$parcel$export(module.exports, "useIntl", () => (parcelRequire("kK7WO")).default);
$parcel$export(module.exports, "FormattedListParts", () => (parcelRequire("56iES")).FormattedListParts);
$parcel$export(module.exports, "FormattedNumberParts", () => (parcelRequire("56iES")).FormattedNumberParts);

var $56iES = parcelRequire("56iES");

var $1YTwG = parcelRequire("1YTwG");

var $4DGRH = parcelRequire("4DGRH");

var $lJYzG = parcelRequire("lJYzG");

var $b2Az1 = parcelRequire("b2Az1");

var $1wmds = parcelRequire("1wmds");

var $cZ6aD = parcelRequire("cZ6aD");

var $1CCqZ = parcelRequire("1CCqZ");

var $kK7WO = parcelRequire("kK7WO");

var $3zCfq = parcelRequire("3zCfq");
var $elgnH = parcelRequire("elgnH");
function $529b4426a6d8b1d2$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $529b4426a6d8b1d2$export$747d244ee58120dd(msg) {
    return msg;
}
var $529b4426a6d8b1d2$export$40ae3194919d16b = (0, $56iES.createFormattedComponent)('formatDate');
var $529b4426a6d8b1d2$export$5b390a54f8a846f7 = (0, $56iES.createFormattedComponent)('formatTime');
var $529b4426a6d8b1d2$export$db80edc1e6b2f63d = (0, $56iES.createFormattedComponent)('formatNumber');
var $529b4426a6d8b1d2$export$f52b44e459e6e71d = (0, $56iES.createFormattedComponent)('formatList');
var $529b4426a6d8b1d2$export$c2336ea5aaab92fa = (0, $56iES.createFormattedComponent)('formatDisplayName');
var $529b4426a6d8b1d2$export$7fdc7d2c91ce149b = (0, $56iES.createFormattedDateTimePartsComponent)('formatDate');
var $529b4426a6d8b1d2$export$ec35873761676c2a = (0, $56iES.createFormattedDateTimePartsComponent)('formatTime');

});
parcelRegister("56iES", function(module, exports) {
$parcel$export(module.exports, "FormattedNumberParts", () => $3b6bfc6bcf5a3490$export$54d4989ed3eea1ea);
$parcel$export(module.exports, "FormattedListParts", () => $3b6bfc6bcf5a3490$export$5ac259c7da6d2188);
$parcel$export(module.exports, "createFormattedDateTimePartsComponent", () => $3b6bfc6bcf5a3490$export$7448277f6036d2ab);
$parcel$export(module.exports, "createFormattedComponent", () => $3b6bfc6bcf5a3490$export$b37e14176d001dec);

var $lmviS = parcelRequire("lmviS");

var $1v5pe = parcelRequire("1v5pe");

var $kK7WO = parcelRequire("kK7WO");
var $3b6bfc6bcf5a3490$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($3b6bfc6bcf5a3490$var$DisplayName || ($3b6bfc6bcf5a3490$var$DisplayName = {}));
var $3b6bfc6bcf5a3490$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($3b6bfc6bcf5a3490$var$DisplayNameParts || ($3b6bfc6bcf5a3490$var$DisplayNameParts = {}));
var $3b6bfc6bcf5a3490$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $kK7WO.default)();
    var value = props.value, children = props.children, formatProps = (0, $lmviS.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$3b6bfc6bcf5a3490$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $3b6bfc6bcf5a3490$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $kK7WO.default)();
    var value = props.value, children = props.children, formatProps = (0, $lmviS.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$3b6bfc6bcf5a3490$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $3b6bfc6bcf5a3490$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $kK7WO.default)();
        var value = props.value, children = props.children, formatProps = (0, $lmviS.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $3b6bfc6bcf5a3490$var$DisplayNameParts[name];
    return ComponentParts;
}
function $3b6bfc6bcf5a3490$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $kK7WO.default)();
        var value = props.value, children = props.children, formatProps = (0, $lmviS.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $1v5pe.Fragment;
        return $1v5pe.createElement(Text, null, formattedValue);
    };
    Component.displayName = $3b6bfc6bcf5a3490$var$DisplayName[name];
    return Component;
}

});

parcelRegister("1YTwG", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $1716776161aaadb1$export$7e4cbedfdd7b4c0d);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $lmviS = parcelRequire("lmviS");

var $4qdJT = parcelRequire("4qdJT");
var $9Hg69 = parcelRequire("9Hg69");

var $hA2YD = parcelRequire("hA2YD");

var $kfP5u = parcelRequire("kfP5u");
function $1716776161aaadb1$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $hA2YD.isFormatXMLElementFn)(v) ? (0, $kfP5u.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $1716776161aaadb1$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $1716776161aaadb1$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $9Hg69.formatMessage).apply(void 0, (0, $lmviS.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return (0, $kfP5u.toKeyedReactNodeArray)(chunks);
    return chunks;
};
var $1716776161aaadb1$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $lmviS.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $1716776161aaadb1$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $4qdJT.createIntl)((0, $lmviS.__assign)((0, $lmviS.__assign)((0, $lmviS.__assign)({}, (0, $kfP5u.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $lmviS.__assign)((0, $lmviS.__assign)({}, coreIntl), {
        formatMessage: $1716776161aaadb1$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        $t: $1716776161aaadb1$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};

});
parcelRegister("4qdJT", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $33843f6e18504ce7$export$7e4cbedfdd7b4c0d);

var $lmviS = parcelRequire("lmviS");

var $fXOyZ = parcelRequire("fXOyZ");

var $3sWhm = parcelRequire("3sWhm");

var $elgnH = parcelRequire("elgnH");

var $bKDJF = parcelRequire("bKDJF");

var $9Hg69 = parcelRequire("9Hg69");

var $gZNX1 = parcelRequire("gZNX1");

var $eNCzn = parcelRequire("eNCzn");

var $frjbX = parcelRequire("frjbX");

var $3zCfq = parcelRequire("3zCfq");
function $33843f6e18504ce7$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $33843f6e18504ce7$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $33843f6e18504ce7$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.github.io/docs/getting-started/message-distribution");
}
function $33843f6e18504ce7$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $3zCfq.createFormatters)(cache);
    var resolvedConfig = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, (0, $3zCfq.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $elgnH.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $elgnH.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $elgnH.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    $33843f6e18504ce7$var$verifyConfigMessages(resolvedConfig);
    return (0, $lmviS.__assign)((0, $lmviS.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $gZNX1.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $gZNX1.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $frjbX.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $fXOyZ.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $fXOyZ.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $fXOyZ.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $fXOyZ.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $fXOyZ.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $eNCzn.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $9Hg69.formatMessage).bind(null, resolvedConfig, formatters),
        $t: (0, $9Hg69.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $bKDJF.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $bKDJF.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $3sWhm.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("fXOyZ", function(module, exports) {
$parcel$export(module.exports, "formatDate", () => $b9f39685a0a84745$export$3ae94a2503e890a1);
$parcel$export(module.exports, "formatTime", () => $b9f39685a0a84745$export$3203edd9e5edd663);
$parcel$export(module.exports, "formatDateTimeRange", () => $b9f39685a0a84745$export$a7fc3a91cb2ec376);
$parcel$export(module.exports, "formatDateToParts", () => $b9f39685a0a84745$export$dc1f059bce486b1);
$parcel$export(module.exports, "formatTimeToParts", () => $b9f39685a0a84745$export$af6e5d7a5c73edeb);

var $lmviS = parcelRequire("lmviS");

var $elgnH = parcelRequire("elgnH");

var $3zCfq = parcelRequire("3zCfq");
var $b9f39685a0a84745$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $b9f39685a0a84745$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $3zCfq.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $3zCfq.filterProps)(options, $b9f39685a0a84745$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $b9f39685a0a84745$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $b9f39685a0a84745$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $elgnH.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $b9f39685a0a84745$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $b9f39685a0a84745$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $elgnH.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $b9f39685a0a84745$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var fromDate = typeof from === 'string' ? new Date(from || 0) : from;
    var toDate = typeof to === 'string' ? new Date(to || 0) : to;
    try {
        return $b9f39685a0a84745$export$a7f9565e3c81cd54(config, 'dateTimeRange', getDateTimeFormat, options).formatRange(fromDate, toDate);
    } catch (e) {
        config.onError(new (0, $elgnH.IntlFormatError)('Error formatting date time range.', config.locale, e));
    }
    return String(fromDate);
}
function $b9f39685a0a84745$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $b9f39685a0a84745$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $elgnH.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $b9f39685a0a84745$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $b9f39685a0a84745$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $elgnH.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return [];
}

});

parcelRegister("3sWhm", function(module, exports) {
$parcel$export(module.exports, "formatDisplayName", () => $286131a4958e257e$export$62fe1a4d9e891fa2);

var $3zCfq = parcelRequire("3zCfq");

var $783MZ = parcelRequire("783MZ");

var $elgnH = parcelRequire("elgnH");
var $286131a4958e257e$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $286131a4958e257e$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $783MZ.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $783MZ.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $3zCfq.filterProps)(options, $286131a4958e257e$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $elgnH.IntlFormatError)('Error formatting display name.', locale, e));
    }
}

});

parcelRegister("bKDJF", function(module, exports) {
$parcel$export(module.exports, "formatList", () => $88e2d03c1dc3e99c$export$e8b8be48b45905bb);
$parcel$export(module.exports, "formatListToParts", () => $88e2d03c1dc3e99c$export$6f284aad1934db69);

var $lmviS = parcelRequire("lmviS");

var $783MZ = parcelRequire("783MZ");

var $elgnH = parcelRequire("elgnH");

var $3zCfq = parcelRequire("3zCfq");
var $88e2d03c1dc3e99c$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $88e2d03c1dc3e99c$var$now = Date.now();
function $88e2d03c1dc3e99c$var$generateToken(i) {
    return "".concat($88e2d03c1dc3e99c$var$now, "_").concat(i, "_").concat($88e2d03c1dc3e99c$var$now);
}
function $88e2d03c1dc3e99c$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $88e2d03c1dc3e99c$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $88e2d03c1dc3e99c$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $783MZ.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $783MZ.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $3zCfq.filterProps)(options, $88e2d03c1dc3e99c$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = Array.from(values).map(function(v, i) {
            if (typeof v === 'object' && v !== null) {
                var id = $88e2d03c1dc3e99c$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $lmviS.__assign)((0, $lmviS.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $elgnH.IntlFormatError)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("9Hg69", function(module, exports) {
$parcel$export(module.exports, "formatMessage", () => $70f49df9403a3dd2$export$25868d1e8e76735f);

var $lmviS = parcelRequire("lmviS");
parcelRequire("3JjFu");
var $4cQwB = parcelRequire("4cQwB");
parcelRequire("5wzdk");
var $diqj4 = parcelRequire("diqj4");

var $elgnH = parcelRequire("elgnH");

var $3zCfq = parcelRequire("3zCfq");
function $70f49df9403a3dd2$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $lmviS.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $70f49df9403a3dd2$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $lmviS.__assign)((0, $lmviS.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $70f49df9403a3dd2$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $diqj4.IntlMessageFormat).formats;
    return (0, $lmviS.__assign)((0, $lmviS.__assign)((0, $lmviS.__assign)({}, mfFormats), f1), {
        date: $70f49df9403a3dd2$var$deepMergeOptions($70f49df9403a3dd2$var$setTimeZoneInOptions(mfFormats.date, timeZone), $70f49df9403a3dd2$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $70f49df9403a3dd2$var$deepMergeOptions($70f49df9403a3dd2$var$setTimeZoneInOptions(mfFormats.time, timeZone), $70f49df9403a3dd2$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $70f49df9403a3dd2$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $3zCfq.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.github.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.github.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.github.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $4cQwB.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, defaultRichTextElements), values || {});
    formats = $70f49df9403a3dd2$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $70f49df9403a3dd2$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $elgnH.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $elgnH.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $lmviS.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $elgnH.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $elgnH.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};

});

parcelRegister("gZNX1", function(module, exports) {
$parcel$export(module.exports, "formatNumber", () => $c5f917161729c38f$export$f5dd818bff069720);
$parcel$export(module.exports, "formatNumberToParts", () => $c5f917161729c38f$export$6871080848f10b2f);

var $elgnH = parcelRequire("elgnH");

var $3zCfq = parcelRequire("3zCfq");
var $c5f917161729c38f$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $c5f917161729c38f$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $3zCfq.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $3zCfq.filterProps)(options, $c5f917161729c38f$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $c5f917161729c38f$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $c5f917161729c38f$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $elgnH.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $c5f917161729c38f$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $c5f917161729c38f$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $elgnH.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return [];
}

});

parcelRegister("eNCzn", function(module, exports) {
$parcel$export(module.exports, "formatPlural", () => $ac638f6e0c22b179$export$bbbd05c900f3568d);

var $783MZ = parcelRequire("783MZ");

var $elgnH = parcelRequire("elgnH");

var $3zCfq = parcelRequire("3zCfq");
var $ac638f6e0c22b179$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $ac638f6e0c22b179$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $783MZ.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $783MZ.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $3zCfq.filterProps)(options, $ac638f6e0c22b179$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $elgnH.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("frjbX", function(module, exports) {
$parcel$export(module.exports, "formatRelativeTime", () => $b3d843bb4dd5ca30$export$b4ea3b48dcf921f6);

var $3zCfq = parcelRequire("3zCfq");

var $783MZ = parcelRequire("783MZ");

var $elgnH = parcelRequire("elgnH");
var $b3d843bb4dd5ca30$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $b3d843bb4dd5ca30$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $3zCfq.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $3zCfq.filterProps)(options, $b3d843bb4dd5ca30$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $b3d843bb4dd5ca30$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $783MZ.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $783MZ.ErrorCode).MISSING_INTL_API));
    try {
        return $b3d843bb4dd5ca30$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $elgnH.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});



parcelRegister("4DGRH", function(module, exports) {
$parcel$export(module.exports, "default", () => $360c0e15d24294be$export$2e2bcd8739ae039);

var $lmviS = parcelRequire("lmviS");

var $1v5pe = parcelRequire("1v5pe");

var $kK7WO = parcelRequire("kK7WO");
var $360c0e15d24294be$var$FormattedDateTimeRange = function(props) {
    var intl = (0, $kK7WO.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = (0, $lmviS.__rest)(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === 'function') return children(formattedValue);
    var Text = intl.textComponent || $1v5pe.Fragment;
    return $1v5pe.createElement(Text, null, formattedValue);
};
$360c0e15d24294be$var$FormattedDateTimeRange.displayName = 'FormattedDateTimeRange';
var $360c0e15d24294be$export$2e2bcd8739ae039 = $360c0e15d24294be$var$FormattedDateTimeRange;

});

parcelRegister("b2Az1", function(module, exports) {
$parcel$export(module.exports, "default", () => $809c3e70ee8a3d04$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $lmviS = parcelRequire("lmviS");

var $1v5pe = parcelRequire("1v5pe");

var $kfP5u = parcelRequire("kfP5u");

var $kK7WO = parcelRequire("kK7WO");
function $809c3e70ee8a3d04$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $lmviS.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $lmviS.__rest)(nextProps, [
        "values"
    ]);
    return (0, $kfP5u.shallowEqual)(nextValues, values) && (0, $kfP5u.shallowEqual)(otherProps, nextOtherProps);
}
function $809c3e70ee8a3d04$var$FormattedMessage(props) {
    var intl = (0, $kK7WO.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $1v5pe.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $1v5pe.createElement(Component, null, nodes);
    return $1v5pe.createElement($1v5pe.Fragment, null, nodes);
}
$809c3e70ee8a3d04$var$FormattedMessage.displayName = 'FormattedMessage';
var $809c3e70ee8a3d04$var$MemoizedFormattedMessage = $1v5pe.memo($809c3e70ee8a3d04$var$FormattedMessage, $809c3e70ee8a3d04$var$areEqual);
$809c3e70ee8a3d04$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $809c3e70ee8a3d04$export$2e2bcd8739ae039 = $809c3e70ee8a3d04$var$MemoizedFormattedMessage;

});

parcelRegister("1wmds", function(module, exports) {
$parcel$export(module.exports, "default", () => $11ba033b5cc531c8$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $kK7WO = parcelRequire("kK7WO");
var $11ba033b5cc531c8$var$FormattedPlural = function(props) {
    var _a = (0, $kK7WO.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === 'function') return children(formattedPlural);
    if (Text) return $1v5pe.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$11ba033b5cc531c8$var$FormattedPlural.displayName = 'FormattedPlural';
var $11ba033b5cc531c8$export$2e2bcd8739ae039 = $11ba033b5cc531c8$var$FormattedPlural;

});

parcelRegister("cZ6aD", function(module, exports) {
$parcel$export(module.exports, "default", () => $973ff7e5aa25ef51$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $lmviS = parcelRequire("lmviS");

var $3zCfq = parcelRequire("3zCfq");

var $1v5pe = parcelRequire("1v5pe");

var $kfP5u = parcelRequire("kfP5u");

var $1YTwG = parcelRequire("1YTwG");

var $lJYzG = parcelRequire("lJYzG");
function $973ff7e5aa25ef51$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $973ff7e5aa25ef51$var$IntlProvider = /** @class */ function(_super) {
    (0, $lmviS.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $3zCfq.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $1YTwG.createIntl)($973ff7e5aa25ef51$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $973ff7e5aa25ef51$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $973ff7e5aa25ef51$var$processIntlConfig(props);
        if (!(0, $kfP5u.shallowEqual)(prevConfig, config)) return {
            intl: (0, $1YTwG.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $kfP5u.invariantIntlContext)(this.state.intl);
        return $1v5pe.createElement((0, $lJYzG.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $kfP5u.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($1v5pe.PureComponent);
var $973ff7e5aa25ef51$export$2e2bcd8739ae039 = $973ff7e5aa25ef51$var$IntlProvider;

});

parcelRegister("1CCqZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $12e7274a9cd20e8d$export$2e2bcd8739ae039);

var $lmviS = parcelRequire("lmviS");

var $1v5pe = parcelRequire("1v5pe");

var $kfP5u = parcelRequire("kfP5u");

var $kK7WO = parcelRequire("kK7WO");
var $12e7274a9cd20e8d$var$MINUTE = 60;
var $12e7274a9cd20e8d$var$HOUR = 3600;
var $12e7274a9cd20e8d$var$DAY = 86400;
function $12e7274a9cd20e8d$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $12e7274a9cd20e8d$var$MINUTE) return 'second';
    if (absValue < $12e7274a9cd20e8d$var$HOUR) return 'minute';
    if (absValue < $12e7274a9cd20e8d$var$DAY) return 'hour';
    return 'day';
}
function $12e7274a9cd20e8d$var$getDurationInSeconds(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return $12e7274a9cd20e8d$var$MINUTE;
        case 'hour':
            return $12e7274a9cd20e8d$var$HOUR;
        default:
            return $12e7274a9cd20e8d$var$DAY;
    }
}
function $12e7274a9cd20e8d$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case 'second':
            return value;
        case 'minute':
            return value * $12e7274a9cd20e8d$var$MINUTE;
        default:
            return value * $12e7274a9cd20e8d$var$HOUR;
    }
}
var $12e7274a9cd20e8d$var$INCREMENTABLE_UNITS = [
    'second',
    'minute',
    'hour'
];
function $12e7274a9cd20e8d$var$canIncrement(unit) {
    if (unit === void 0) unit = 'second';
    return $12e7274a9cd20e8d$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $12e7274a9cd20e8d$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $kK7WO.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $lmviS.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === 'function') return children(formattedRelativeTime);
    if (Text) return $1v5pe.createElement(Text, null, formattedRelativeTime);
    return $1v5pe.createElement($1v5pe.Fragment, null, formattedRelativeTime);
};
var $12e7274a9cd20e8d$var$FormattedRelativeTime = function(_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.unit, unit = _c === void 0 ? 'second' : _c, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $lmviS.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $kfP5u.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $12e7274a9cd20e8d$var$canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
    var _d = $1v5pe.useState(), prevUnit = _d[0], setPrevUnit = _d[1];
    var _e = $1v5pe.useState(0), prevValue = _e[0], setPrevValue = _e[1];
    var _f = $1v5pe.useState(0), currentValueInSeconds = _f[0], setCurrentValueInSeconds = _f[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($12e7274a9cd20e8d$var$canIncrement(unit) ? $12e7274a9cd20e8d$var$valueToSeconds(value, unit) : 0);
    }
    $1v5pe.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$12e7274a9cd20e8d$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $12e7274a9cd20e8d$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') return clearUpdateTimer;
        var unitDuration = $12e7274a9cd20e8d$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($12e7274a9cd20e8d$var$canIncrement(unit) && typeof currentValueInSeconds === 'number' && updateIntervalInSeconds) {
        currentUnit = $12e7274a9cd20e8d$var$selectUnit(currentValueInSeconds);
        var unitDuration = $12e7274a9cd20e8d$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $1v5pe.createElement($12e7274a9cd20e8d$var$SimpleFormattedRelativeTime, (0, $lmviS.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$12e7274a9cd20e8d$var$FormattedRelativeTime.displayName = 'FormattedRelativeTime';
var $12e7274a9cd20e8d$export$2e2bcd8739ae039 = $12e7274a9cd20e8d$var$FormattedRelativeTime;

});





parcelRegister("cWkcy", function(module, exports) {
$parcel$export(module.exports, "LoadingSkeleton", () => $a622773e27d4430d$export$44c18d210d5de37b);

var $eMSEP = parcelRequire("eMSEP");

var $aCcGw = parcelRequire("aCcGw");

var $4nsh9 = parcelRequire("4nsh9");

var $iOm08 = parcelRequire("iOm08");

var $iOq8l = parcelRequire("iOq8l");

var $bQOrV = parcelRequire("bQOrV");

var $89lSy = parcelRequire("89lSy");

var $kIqwl = parcelRequire("kIqwl");
const $a622773e27d4430d$export$44c18d210d5de37b = ()=>{
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $4nsh9.Grid), {
        alignItems: "center",
        xcss: $a622773e27d4430d$var$responsiveStyles,
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eMSEP.Box), {}),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $aCcGw.Flex), {
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eMSEP.Box), {
                    xcss: $a622773e27d4430d$var$skeletonItemsContainer,
                    children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $iOq8l.Stack), {
                        space: "space.500",
                        children: [
                            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $89lSy.default), {
                                width: "100%",
                                height: "300px",
                                isShimmering: true,
                                borderRadius: "var(--ds-radius-medium, 6px)"
                            }),
                            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $89lSy.default), {
                                width: "100%",
                                height: "150px",
                                isShimmering: true,
                                borderRadius: "var(--ds-radius-medium, 6px)"
                            }),
                            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $89lSy.default), {
                                width: "100%",
                                height: "150px",
                                isShimmering: true,
                                borderRadius: "var(--ds-radius-medium, 6px)"
                            }),
                            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $89lSy.default), {
                                width: "100%",
                                height: "200px",
                                isShimmering: true,
                                borderRadius: "var(--ds-radius-medium, 6px)"
                            }),
                            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $89lSy.default), {
                                width: "100%",
                                height: "200px",
                                isShimmering: true,
                                borderRadius: "var(--ds-radius-medium, 6px)"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eMSEP.Box), {})
        ]
    });
};
const $a622773e27d4430d$var$skeletonItemsContainer = (0, $bQOrV.xcss)({
    paddingTop: 'space.500',
    paddingBottom: 'space.300',
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    width: '100%'
});
const $a622773e27d4430d$var$responsiveStyles = (0, $bQOrV.xcss)({
    [(0, $iOm08.media).above.lg]: {
        width: '1200px'
    },
    marginLeft: 'auto',
    marginRight: 'auto'
});

});
parcelRegister("aCcGw", function(module, exports) {
$parcel$export(module.exports, "Flex", () => $574a7c1c0702d122$export$f51f4c4ede09e011);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hRuTh = parcelRequire("hRuTh");

var $4Iv3g = parcelRequire("4Iv3g");

var $b0k2W = parcelRequire("b0k2W");
const $574a7c1c0702d122$var$justifyContentMap = {
    start: (0, $hRuTh.css)({
        justifyContent: 'start'
    }),
    center: (0, $hRuTh.css)({
        justifyContent: 'center'
    }),
    end: (0, $hRuTh.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $hRuTh.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $hRuTh.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $hRuTh.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $hRuTh.css)({
        justifyContent: 'stretch'
    })
};
const $574a7c1c0702d122$var$flexDirectionMap = {
    column: (0, $hRuTh.css)({
        flexDirection: 'column'
    }),
    row: (0, $hRuTh.css)({
        flexDirection: 'row'
    })
};
const $574a7c1c0702d122$var$flexWrapMap = {
    wrap: (0, $hRuTh.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $hRuTh.css)({
        flexWrap: 'nowrap'
    })
};
const $574a7c1c0702d122$var$alignItemsMap = {
    start: (0, $hRuTh.css)({
        alignItems: 'start'
    }),
    center: (0, $hRuTh.css)({
        alignItems: 'center'
    }),
    baseline: (0, $hRuTh.css)({
        alignItems: 'baseline'
    }),
    end: (0, $hRuTh.css)({
        alignItems: 'end'
    }),
    stretch: (0, $hRuTh.css)({
        alignItems: 'stretch'
    })
};
const $574a7c1c0702d122$var$baseStyles = (0, $hRuTh.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
const $574a7c1c0702d122$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, id: id }, ref)=>{
    const resolvedStyles = (0, $4Iv3g.parseXcss)(xcss);
    return (0, $hRuTh.jsx)(Component, {
        id: id,
        role: role,
        className: resolvedStyles.static,
        css: [
            $574a7c1c0702d122$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $b0k2W.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $b0k2W.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $b0k2W.spaceStylesMap).rowGap[rowGap],
            alignItems && $574a7c1c0702d122$var$alignItemsMap[alignItems],
            direction && $574a7c1c0702d122$var$flexDirectionMap[direction],
            justifyContent && $574a7c1c0702d122$var$justifyContentMap[justifyContent],
            wrap && $574a7c1c0702d122$var$flexWrapMap[wrap],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$574a7c1c0702d122$export$f51f4c4ede09e011.displayName = 'Flex';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$574a7c1c0702d122$export$2e2bcd8739ae039 = $574a7c1c0702d122$export$f51f4c4ede09e011;

});
parcelRegister("b0k2W", function(module, exports) {
$parcel$export(module.exports, "spaceStylesMap", () => $2c444520b8a205fd$export$bf46c3f9eeafc71f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $5OwLN = parcelRequire("5OwLN");

var $cbeq4 = parcelRequire("cbeq4");
const $2c444520b8a205fd$export$bf46c3f9eeafc71f = (0, $5OwLN.createSpacingStylesMap)((0, $cbeq4.gapSpaceMap), [
    'gap',
    'rowGap',
    'columnGap'
]);

});
parcelRegister("cbeq4", function(module, exports) {
$parcel$export(module.exports, "gapSpaceMap", () => $286e589f0d62e539$export$ae2d66f16ab57ecd);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::71d191c679a99ef0b72b3412372b1db9>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::27b3f9240cb9c6f16e54a6ebd2c859b9>>
 */ const $286e589f0d62e539$export$ae2d66f16ab57ecd = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)",
    'space.gap.large': "var(--ds-space-gap-large, 12px)",
    'space.gap.medium': "var(--ds-space-gap-medium, 8px)",
    'space.gap.small': "var(--ds-space-gap-small, 6px)",
    'space.gap.xlarge': "var(--ds-space-gap-xlarge, 16px)",
    'space.gap.xsmall': "var(--ds-space-gap-xsmall, 4px)",
    'space.gap.xxlarge': "var(--ds-space-gap-xxlarge, 24px)",
    'space.gap.xxsmall': "var(--ds-space-gap-xxsmall, 2px)"
};

});



parcelRegister("4nsh9", function(module, exports) {
$parcel$export(module.exports, "Grid", () => $e401223827f4ebe6$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hRuTh = parcelRequire("hRuTh");

var $4Iv3g = parcelRequire("4Iv3g");

var $b0k2W = parcelRequire("b0k2W");
const $e401223827f4ebe6$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $e401223827f4ebe6$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $e401223827f4ebe6$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $e401223827f4ebe6$var$justifyContentMap = {
    start: (0, $hRuTh.css)({
        justifyContent: 'start'
    }),
    center: (0, $hRuTh.css)({
        justifyContent: 'center'
    }),
    end: (0, $hRuTh.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $hRuTh.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $hRuTh.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $hRuTh.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $hRuTh.css)({
        justifyContent: 'stretch'
    })
};
const $e401223827f4ebe6$var$justifyItemsMap = {
    start: (0, $hRuTh.css)({
        justifyItems: 'start'
    }),
    center: (0, $hRuTh.css)({
        justifyItems: 'center'
    }),
    end: (0, $hRuTh.css)({
        justifyItems: 'end'
    }),
    stretch: (0, $hRuTh.css)({
        justifyItems: 'stretch'
    })
};
const $e401223827f4ebe6$var$alignContentMap = {
    start: (0, $hRuTh.css)({
        alignContent: 'start'
    }),
    center: (0, $hRuTh.css)({
        alignContent: 'center'
    }),
    end: (0, $hRuTh.css)({
        alignContent: 'end'
    }),
    'space-between': (0, $hRuTh.css)({
        alignContent: 'space-between'
    }),
    'space-around': (0, $hRuTh.css)({
        alignContent: 'space-around'
    }),
    'space-evenly': (0, $hRuTh.css)({
        alignContent: 'space-evenly'
    }),
    stretch: (0, $hRuTh.css)({
        alignContent: 'stretch'
    })
};
const $e401223827f4ebe6$var$alignItemsMap = {
    start: (0, $hRuTh.css)({
        alignItems: 'start'
    }),
    center: (0, $hRuTh.css)({
        alignItems: 'center'
    }),
    baseline: (0, $hRuTh.css)({
        alignItems: 'baseline'
    }),
    end: (0, $hRuTh.css)({
        alignItems: 'end'
    })
};
const $e401223827f4ebe6$var$baseStyles = (0, $hRuTh.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$e401223827f4ebe6$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$e401223827f4ebe6$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$e401223827f4ebe6$var$gridTemplateRowsVar})`
});
const $e401223827f4ebe6$var$gridAutoFlowMap = {
    row: (0, $hRuTh.css)({
        gridAutoFlow: 'row'
    }),
    column: (0, $hRuTh.css)({
        gridAutoFlow: 'column'
    }),
    dense: (0, $hRuTh.css)({
        gridAutoFlow: 'dense'
    }),
    'row dense': (0, $hRuTh.css)({
        gridAutoFlow: 'row dense'
    }),
    'column dense': (0, $hRuTh.css)({
        gridAutoFlow: 'column dense'
    })
};
const $e401223827f4ebe6$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $4Iv3g.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $1v5pe.useMemo)(()=>({
            [$e401223827f4ebe6$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$e401223827f4ebe6$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$e401223827f4ebe6$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return (0, $hRuTh.jsx)(Component, {
        id: id,
        role: role,
        style: style,
        className: resolvedStyles.static,
        css: [
            $e401223827f4ebe6$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $b0k2W.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $b0k2W.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $b0k2W.spaceStylesMap).rowGap[rowGap],
            alignItems && $e401223827f4ebe6$var$alignItemsMap[alignItems],
            alignContent && $e401223827f4ebe6$var$alignContentMap[alignContent],
            justifyContent && $e401223827f4ebe6$var$justifyContentMap[justifyContent],
            autoFlow && $e401223827f4ebe6$var$gridAutoFlowMap[autoFlow],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$e401223827f4ebe6$export$ef2184bd89960b14.displayName = 'Grid';

});

parcelRegister("iOm08", function(module, exports) {
$parcel$export(module.exports, "media", () => $6b91237b9d14579a$export$987d49ffe1b0900f);
const $6b91237b9d14579a$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});

parcelRegister("iOq8l", function(module, exports) {
$parcel$export(module.exports, "Stack", () => $449622c59b12728b$export$694e0d28c7ffc90c);
$parcel$export(module.exports, "default", () => $449622c59b12728b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hRuTh = parcelRequire("hRuTh");

var $bQOrV = parcelRequire("bQOrV");

var $aCcGw = parcelRequire("aCcGw");
const $449622c59b12728b$var$flexGrowMap = {
    hug: (0, $bQOrV.xcss)({
        flexGrow: 0
    }),
    fill: (0, $bQOrV.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $449622c59b12728b$export$694e0d28c7ffc90c = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, id: id }, ref)=>{
    const justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $449622c59b12728b$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return (0, $hRuTh.jsx)((0, $aCcGw.Flex), {
        id: id,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$449622c59b12728b$export$694e0d28c7ffc90c.displayName = 'Stack';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$449622c59b12728b$export$2e2bcd8739ae039 = $449622c59b12728b$export$694e0d28c7ffc90c;

});
parcelRegister("bQOrV", function(module, exports) {
$parcel$export(module.exports, "xcss", () => $5adc29778b59a492$export$f6c783d06584602c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $hRuTh = parcelRequire("hRuTh");

var $aTRDF = parcelRequire("aTRDF");

var $5Rxcw = parcelRequire("5Rxcw");

var $k1Wvt = parcelRequire("k1Wvt");
const $5adc29778b59a492$var$isSafeEnvToThrow = ()=>typeof $k1Wvt === 'object' && typeof $k1Wvt.env === 'object' && false;
const $5adc29778b59a492$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $5adc29778b59a492$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $5adc29778b59a492$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
     // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($5adc29778b59a492$var$transformStyles);
     // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $5adc29778b59a492$var$safeSelectors.test(key)) {
            styleObj[key] = $5adc29778b59a492$var$transformStyles(value);
            return;
        }
        if ($5adc29778b59a492$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($5adc29778b59a492$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        } // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in (0, $aTRDF.tokensMap))) return;
        const tokenValue = (0, $aTRDF.tokensMap)[key][value];
        styleObj[key] = tokenValue ?? value;
    });
    return styleObj;
};
const $5adc29778b59a492$var$baseXcss = (style)=>{
    const transformedStyles = $5adc29778b59a492$var$transformStyles(style);
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [(0, $5Rxcw.uniqueSymbol)]: (0, $hRuTh.css)(transformedStyles)
    };
};
function $5adc29778b59a492$export$f6c783d06584602c(style) {
    return $5adc29778b59a492$var$baseXcss(style);
}

});
parcelRegister("aTRDF", function(module, exports) {
$parcel$export(module.exports, "tokensMap", () => $2fe8bb23ddaa3e9f$export$9a199fbafee0014e);

var $ifkFq = parcelRequire("ifkFq");

var $iItnK = parcelRequire("iItnK");

var $kVvu0 = parcelRequire("kVvu0");

var $f0BjI = parcelRequire("f0BjI");

var $ipf3f = parcelRequire("ipf3f");

var $6fPUV = parcelRequire("6fPUV");

var $lCelt = parcelRequire("lCelt");

var $lvZmJ = parcelRequire("lvZmJ");

var $a0kQ6 = parcelRequire("a0kQ6");

var $cbeq4 = parcelRequire("cbeq4");

var $3P8Km = parcelRequire("3P8Km");

var $ebBz8 = parcelRequire("ebBz8");

var $9QsMz = parcelRequire("9QsMz");

var $8UQ0c = parcelRequire("8UQ0c");

var $bOekP = parcelRequire("bOekP");
const $2fe8bb23ddaa3e9f$export$9a199fbafee0014e = {
    backgroundColor: (0, $iItnK.backgroundColorMap),
    blockSize: (0, $6fPUV.dimensionMap),
    borderBlockColor: (0, $kVvu0.borderColorMap),
    borderBlockEndColor: (0, $kVvu0.borderColorMap),
    borderBlockEndWidth: (0, $ipf3f.borderWidthMap),
    borderBlockStartColor: (0, $kVvu0.borderColorMap),
    borderBlockStartWidth: (0, $ipf3f.borderWidthMap),
    borderBlockWidth: (0, $ipf3f.borderWidthMap),
    borderBottomColor: (0, $kVvu0.borderColorMap),
    borderBottomLeftRadius: (0, $f0BjI.borderRadiusMap),
    borderBottomRightRadius: (0, $f0BjI.borderRadiusMap),
    borderBottomWidth: (0, $ipf3f.borderWidthMap),
    borderColor: (0, $kVvu0.borderColorMap),
    borderEndEndRadius: (0, $f0BjI.borderRadiusMap),
    borderEndStartRadius: (0, $f0BjI.borderRadiusMap),
    borderInlineColor: (0, $kVvu0.borderColorMap),
    borderInlineEndColor: (0, $kVvu0.borderColorMap),
    borderInlineEndWidth: (0, $ipf3f.borderWidthMap),
    borderInlineStartColor: (0, $kVvu0.borderColorMap),
    borderInlineStartWidth: (0, $ipf3f.borderWidthMap),
    borderInlineWidth: (0, $ipf3f.borderWidthMap),
    borderLeftColor: (0, $kVvu0.borderColorMap),
    borderLeftWidth: (0, $ipf3f.borderWidthMap),
    borderRadius: (0, $f0BjI.borderRadiusMap),
    borderRightColor: (0, $kVvu0.borderColorMap),
    borderRightWidth: (0, $ipf3f.borderWidthMap),
    borderStartEndRadius: (0, $f0BjI.borderRadiusMap),
    borderStartStartRadius: (0, $f0BjI.borderRadiusMap),
    borderTopColor: (0, $kVvu0.borderColorMap),
    borderTopLeftRadius: (0, $f0BjI.borderRadiusMap),
    borderTopRightRadius: (0, $f0BjI.borderRadiusMap),
    borderTopWidth: (0, $ipf3f.borderWidthMap),
    borderWidth: (0, $ipf3f.borderWidthMap),
    bottom: (0, $ifkFq.allSpaceMap),
    boxShadow: (0, $8UQ0c.shadowMap),
    color: (0, $bOekP.textColorMap),
    columnGap: (0, $cbeq4.gapSpaceMap),
    font: (0, $lCelt.fontMap),
    fontFamily: (0, $lvZmJ.fontFamilyMap),
    fontWeight: (0, $a0kQ6.fontWeightMap),
    gap: (0, $cbeq4.gapSpaceMap),
    height: (0, $6fPUV.dimensionMap),
    inlineSize: (0, $6fPUV.dimensionMap),
    inset: (0, $ifkFq.allSpaceMap),
    insetBlock: (0, $ifkFq.allSpaceMap),
    insetBlockEnd: (0, $ifkFq.allSpaceMap),
    insetBlockStart: (0, $ifkFq.allSpaceMap),
    insetInline: (0, $ifkFq.allSpaceMap),
    insetInlineEnd: (0, $ifkFq.allSpaceMap),
    insetInlineStart: (0, $ifkFq.allSpaceMap),
    left: (0, $ifkFq.allSpaceMap),
    margin: (0, $ifkFq.allSpaceMap),
    marginBlock: (0, $ifkFq.allSpaceMap),
    marginBlockEnd: (0, $ifkFq.allSpaceMap),
    marginBlockStart: (0, $ifkFq.allSpaceMap),
    marginBottom: (0, $ifkFq.allSpaceMap),
    marginInline: (0, $ifkFq.allSpaceMap),
    marginInlineEnd: (0, $ifkFq.allSpaceMap),
    marginInlineStart: (0, $ifkFq.allSpaceMap),
    marginLeft: (0, $ifkFq.allSpaceMap),
    marginRight: (0, $ifkFq.allSpaceMap),
    marginTop: (0, $ifkFq.allSpaceMap),
    maxBlockSize: (0, $6fPUV.dimensionMap),
    maxHeight: (0, $6fPUV.dimensionMap),
    maxInlineSize: (0, $6fPUV.dimensionMap),
    maxWidth: (0, $6fPUV.dimensionMap),
    minBlockSize: (0, $6fPUV.dimensionMap),
    minHeight: (0, $6fPUV.dimensionMap),
    minInlineSize: (0, $6fPUV.dimensionMap),
    minWidth: (0, $6fPUV.dimensionMap),
    opacity: (0, $ebBz8.opacityMap),
    outlineColor: (0, $kVvu0.borderColorMap),
    outlineOffset: (0, $ifkFq.allSpaceMap),
    outlineWidth: (0, $ipf3f.borderWidthMap),
    padding: (0, $9QsMz.positiveSpaceMap),
    paddingBlock: (0, $9QsMz.positiveSpaceMap),
    paddingBlockEnd: (0, $9QsMz.positiveSpaceMap),
    paddingBlockStart: (0, $9QsMz.positiveSpaceMap),
    paddingBottom: (0, $9QsMz.positiveSpaceMap),
    paddingInline: (0, $9QsMz.positiveSpaceMap),
    paddingInlineEnd: (0, $9QsMz.positiveSpaceMap),
    paddingInlineStart: (0, $9QsMz.positiveSpaceMap),
    paddingLeft: (0, $9QsMz.positiveSpaceMap),
    paddingRight: (0, $9QsMz.positiveSpaceMap),
    paddingTop: (0, $9QsMz.positiveSpaceMap),
    right: (0, $ifkFq.allSpaceMap),
    rowGap: (0, $cbeq4.gapSpaceMap),
    top: (0, $ifkFq.allSpaceMap),
    width: (0, $6fPUV.dimensionMap),
    zIndex: (0, $3P8Km.layerMap)
};

});
parcelRegister("ifkFq", function(module, exports) {
$parcel$export(module.exports, "allSpaceMap", () => $52dde579028cc48e$export$632685d741f3dbbf);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3cc1af374b7280144c0465457ed9f756>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::27b3f9240cb9c6f16e54a6ebd2c859b9>>
 */ const $52dde579028cc48e$export$632685d741f3dbbf = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)",
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};

});

parcelRegister("kVvu0", function(module, exports) {
$parcel$export(module.exports, "borderColorMap", () => $b0209af09316e243$export$1531ad5bb3fbedac);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2852cd6e8656adbef1c6b8cb926235c9>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $b0209af09316e243$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.lime.subtle': "var(--ds-border-accent-lime-subtle, #B3DF72)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.red.subtle': "var(--ds-border-accent-red-subtle, #FD9891)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.orange.subtle': "var(--ds-border-accent-orange-subtle, #FBC828)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.yellow.subtle': "var(--ds-border-accent-yellow-subtle, #EED12B)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.green.subtle': "var(--ds-border-accent-green-subtle, #7EE2B8)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.teal.subtle': "var(--ds-border-accent-teal-subtle, #9DD9EE)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.blue.subtle': "var(--ds-border-accent-blue-subtle, #8FB8F6)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.purple.subtle': "var(--ds-border-accent-purple-subtle, #D8A0F7)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.magenta.subtle': "var(--ds-border-accent-magenta-subtle, #F797D2)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.accent.gray.subtle': "var(--ds-border-accent-gray-subtle, #B7B9BE)",
    'color.border.code': "var(--ds-border-code, #0B120E24)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.input.search': "var(--ds-border-input-search, #0B120E24)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.danger.subtle': "var(--ds-border-danger-subtle, #FD9891)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.warning.subtle': "var(--ds-border-warning-subtle, #FBC828)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.success.subtle': "var(--ds-border-success-subtle, #B3DF72)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.discovery.subtle': "var(--ds-border-discovery-subtle, #D8A0F7)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.information.subtle': "var(--ds-border-information-subtle, #8FB8F6)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};

});

parcelRegister("f0BjI", function(module, exports) {
$parcel$export(module.exports, "borderRadiusMap", () => $ef7ef7484397c7fb$export$3c0a6c3e64bb180d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aac51b10fd4c84e2b653aff461a93b73>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::419cf7fccef8a341df2ce9890e3cdad2>>
 */ const $ef7ef7484397c7fb$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};

});

parcelRegister("ipf3f", function(module, exports) {
$parcel$export(module.exports, "borderWidthMap", () => $d5cff34db0f5c902$export$e1b83c5210c471b8);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7cdb9fba904c3ac54bf1c429a821ffc2>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::419cf7fccef8a341df2ce9890e3cdad2>>
 */ const $d5cff34db0f5c902$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};

});

parcelRegister("6fPUV", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $b64f830179e31ff1$export$6ccdbebca2ee545f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e4616710c813452a5dda10e6c422716>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 */ const $b64f830179e31ff1$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};

});

parcelRegister("lCelt", function(module, exports) {
$parcel$export(module.exports, "fontMap", () => $73c1b555087e4895$export$6ffa317d5e70375);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9dc903b89132658c3e8db351b3cf92f>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $73c1b555087e4895$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});

parcelRegister("lvZmJ", function(module, exports) {
$parcel$export(module.exports, "fontFamilyMap", () => $09bf2aa4ba014ba8$export$3c7e9587132614b4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1bd05ea1282426e07fb0ae630b07823d>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $09bf2aa4ba014ba8$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});

parcelRegister("a0kQ6", function(module, exports) {
$parcel$export(module.exports, "fontWeightMap", () => $b207c7138aae90d5$export$303e322c6b1ed114);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::709c4cdac6e8ef806ec1e227c3e362d1>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $b207c7138aae90d5$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};

});

parcelRegister("3P8Km", function(module, exports) {
$parcel$export(module.exports, "layerMap", () => $eda11606e869bca3$export$b5f31a7e431d2eab);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::10940883f780b624bff6c0029b7ac6fd>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $eda11606e869bca3$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};

});

parcelRegister("ebBz8", function(module, exports) {
$parcel$export(module.exports, "opacityMap", () => $cbd32aa6234089d1$export$daf94a976c798b4f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f768e44d85ca8256730a17510c4d3901>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $cbd32aa6234089d1$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};

});

parcelRegister("8UQ0c", function(module, exports) {
$parcel$export(module.exports, "shadowMap", () => $5b12550f4f37ccad$export$7aff6e7ba39bb774);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::31f7af0716c25896201100f27266bca7>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $5b12550f4f37ccad$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F2128, 0px 0px 1px #1E1F211e)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
};

});

parcelRegister("bOekP", function(module, exports) {
$parcel$export(module.exports, "textColorMap", () => $534fe9286b4d17e9$export$8473307aa00d6ea1);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c49ded1370dd9125e2572ecce0dec81>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $534fe9286b4d17e9$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.code.accent.1': "var(--ds-text-code-accent-1, #943D73)",
    'color.text.code.accent.2': "var(--ds-text-code-accent-2, #1558BC)",
    'color.text.code.comments': "var(--ds-text-code-comments, #505258)",
    'color.text.code.default': "var(--ds-text-code-default, #505258)",
    'color.text.code.functions': "var(--ds-text-code-functions, #216E4E)",
    'color.text.code.gutter': "var(--ds-text-code-gutter, #6B6E76)",
    'color.text.code.keywords': "var(--ds-text-code-keywords, #AE2E24)",
    'color.text.code.numbers': "var(--ds-text-code-numbers, #7F5F01)",
    'color.text.code.operators': "var(--ds-text-code-operators, #292A2E)",
    'color.text.code.strings': "var(--ds-text-code-strings, #4C6B1F)",
    'color.text.code.tags': "var(--ds-text-code-tags, #9E4C00)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};

});




parcelRegister("89lSy", function(module, exports) {
$parcel$export(module.exports, "default", () => $69ea2c259fc59a2d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $1v5pe = parcelRequire("1v5pe");

var $7qISg = parcelRequire("7qISg");

var $2aEiL = parcelRequire("2aEiL");

var $kIqwl = parcelRequire("kIqwl");
const $69ea2c259fc59a2d$var$_7 = "._j7hq19vq{animation-name:k4nwfqi}";
const $69ea2c259fc59a2d$var$_6 = "@keyframes k4nwfqi{0%{background-color:var(--ds-skeleton-from-color,var(--ds-skeleton,#0515240f))}to{background-color:var(--ds-skeleton-to-color,var(--ds-skeleton-subtle,#17171708))}}";
const $69ea2c259fc59a2d$var$_5 = "._bfhkizff{background-color:var(--ds-skeleton,#0515240f)}";
const $69ea2c259fc59a2d$var$_4 = "._1pglp3kn{animation-timing-function:linear}";
const $69ea2c259fc59a2d$var$_3 = "._tip812c5{animation-iteration-count:infinite}";
const $69ea2c259fc59a2d$var$_2 = "._5sag12o8{animation-duration:1.5s}";
const $69ea2c259fc59a2d$var$_ = "._7hjf1yy8{animation-direction:alternate}";
const $69ea2c259fc59a2d$var$shimmerKeyframes = null;
const $69ea2c259fc59a2d$var$skeletonStyles = null;
const $69ea2c259fc59a2d$var$activeShimmerStyles = null; /**
                                   * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
                                   * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
                                   * which makes things simpler than doing an `isServer` check or a `null` check.
                                   *
                                   * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
                                   */ 
const $69ea2c259fc59a2d$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1v5pe.useEffect) : (0, $1v5pe.useLayoutEffect); /**
                                                                                          * __Skeleton__
                                                                                          *
                                                                                          * A skeleton acts as a placeholder for content, usually while the content loads.
                                                                                          *
                                                                                          * - [Examples](https://atlassian.design/components/skeleton/examples)
                                                                                          * - [Code](https://atlassian.design/components/skeleton/code)
                                                                                          */ 
const $69ea2c259fc59a2d$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = "var(--ds-radius-small, 4px)", color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, interactionName: interactionName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $1v5pe.useContext)((0, $7qISg.default));
    $69ea2c259fc59a2d$var$useLayoutEffect(()=>{
        if (context != null && (0, $2aEiL.fg)('platform-dst-skeleton-ufo-hold')) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $69ea2c259fc59a2d$var$_,
                    $69ea2c259fc59a2d$var$_2,
                    $69ea2c259fc59a2d$var$_3,
                    $69ea2c259fc59a2d$var$_4,
                    $69ea2c259fc59a2d$var$_5,
                    $69ea2c259fc59a2d$var$_6,
                    $69ea2c259fc59a2d$var$_7
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                "data-testid": testId,
                style: {
                    width: width,
                    height: height,
                    borderRadius: borderRadius,
                    backgroundColor: color,
                    // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
                    '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
                    '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
                },
                ...groupDataAttribute && {
                    [groupDataAttribute]: 'true'
                },
                className: (0, $hMvDh.default)([
                    "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkizff",
                    isShimmering && "",
                    isShimmering && "_j7hq19vq"
                ])
            })
        ]
    });
};
var $69ea2c259fc59a2d$export$2e2bcd8739ae039 = $69ea2c259fc59a2d$var$Skeleton;

});


parcelRegister("4hS6l", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("fPro0").then(()=>parcelRequire('lcMh8'));

});

parcelRegister("gUWrs", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("9xn5m").then(()=>parcelRequire('b4e1b'));

});

parcelRegister("fQd9o", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("6PjUU").then(()=>parcelRequire('9rGDe'));

});

parcelRegister("5hF01", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("9q6v8").then(()=>parcelRequire('9JtNW'));

});

parcelRegister("4iFay", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("1LZm5").then(()=>parcelRequire('a4vxp'));

});

parcelRegister("3yWwv", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("5fQgU").then(()=>parcelRequire('9lOxh'));

});

parcelRegister("adQD0", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("583mJ").then(()=>parcelRequire('d1YRS'));

});

parcelRegister("bkUZb", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("enQ88").then(()=>parcelRequire('dsSlg'));

});

parcelRegister("ihdge", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("65VeL").then(()=>parcelRequire('jdoyd'));

});

parcelRegister("9uDA5", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("eA0Yx").then(()=>parcelRequire('72rNb'));

});

parcelRegister("cFRr7", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("9yjEk").then(()=>parcelRequire('10HCb'));

});

parcelRegister("2B22r", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("hfVXA").then(()=>parcelRequire('4oi9i'));

});

parcelRegister("kQSDn", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("gjrgN").then(()=>parcelRequire('2KcWS'));

});

parcelRegister("6zSYs", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("8E0l8").then(()=>parcelRequire('2ax6o'));

});

parcelRegister("dnt5F", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("4Mb4g").then(()=>parcelRequire('2tZwR'));

});

parcelRegister("kqDq2", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("efabn").then(()=>parcelRequire('4MGOm'));

});

parcelRegister("aFX2k", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("7djIA").then(()=>parcelRequire('7g7j2'));

});

parcelRegister("jh5HN", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("gcxIN").then(()=>parcelRequire('i9OUP'));

});

parcelRegister("4iAsx", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("iAbBc").then(()=>parcelRequire('fuRJ3'));

});

parcelRegister("kFMzS", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("g5hGY").then(()=>parcelRequire('9T4ep'));

});

parcelRegister("3313C", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("jSdEO").then(()=>parcelRequire('gNXYq'));

});

parcelRegister("Vkq0T", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("ivIgg").then(()=>parcelRequire('b54ag'));

});

parcelRegister("et9F7", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("lmy5O").then(()=>parcelRequire('5tjDU'));

});

parcelRegister("2ep82", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("ft7u1").then(()=>parcelRequire('01GUk'));

});

parcelRegister("iDF7y", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("ckwkc").then(()=>parcelRequire('8GJw2'));

});

parcelRegister("ja864", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $df353b629fcf3192$export$e926676385687eaf);
$parcel$export(module.exports, "withErrorBoundary", () => $df353b629fcf3192$export$f0c7a449e0cfaec7);

var $1v5pe = parcelRequire("1v5pe");
'use client';
const $df353b629fcf3192$export$b16d9fb1a22de840 = (0, $1v5pe.createContext)(null);
const $df353b629fcf3192$var$initialState = {
    didCatch: false,
    error: null
};
class $df353b629fcf3192$export$e926676385687eaf extends (0, $1v5pe.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $df353b629fcf3192$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($df353b629fcf3192$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $df353b629fcf3192$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($df353b629fcf3192$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $1v5pe.createElement)(FallbackComponent, props);
            else if (fallback !== undefined) childToRender = fallback;
            else throw error;
        }
        return (0, $1v5pe.createElement)($df353b629fcf3192$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $df353b629fcf3192$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $df353b629fcf3192$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $df353b629fcf3192$export$c052f6604b7d51fe() {
    const context = (0, $1v5pe.useContext)($df353b629fcf3192$export$b16d9fb1a22de840);
    $df353b629fcf3192$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $1v5pe.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $1v5pe.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $df353b629fcf3192$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $1v5pe.forwardRef)((props, ref)=>(0, $1v5pe.createElement)($df353b629fcf3192$export$e926676385687eaf, errorBoundaryProps, (0, $1v5pe.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});

parcelRegister("bHcZt", function(module, exports) {
$parcel$export(module.exports, "FlagsProvider", () => $89141af8f1a4fec7$export$a4270ab432ac8a58);

var $1v5pe = parcelRequire("1v5pe");

var $4tQUn = parcelRequire("4tQUn");

var $gLkHF = parcelRequire("gLkHF");

var $f4yCW = parcelRequire("f4yCW");

var $5fHZY = parcelRequire("5fHZY");

var $kIqwl = parcelRequire("kIqwl");
const $89141af8f1a4fec7$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $89141af8f1a4fec7$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $1v5pe.useState)([]);
    const removeFlag = (0, $1v5pe.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $1v5pe.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $89141af8f1a4fec7$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $kIqwl.Fragment), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $f4yCW.FlagContext).Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $5fHZY.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $4tQUn.default) : (0, $gLkHF.default);
                    return /*#__PURE__*/ (0, $1v5pe.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}

});
parcelRegister("4tQUn", function(module, exports) {
$parcel$export(module.exports, "default", () => $90d2f51c7e148e8a$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $j9QYE = parcelRequire("j9QYE");

var $aD9yk = parcelRequire("aD9yk");

var $gLkHF = parcelRequire("gLkHF");

var $lJzVc = parcelRequire("lJzVc");

var $kIqwl = parcelRequire("kIqwl");
const $90d2f51c7e148e8a$var$packageName = undefined;
const $90d2f51c7e148e8a$var$packageVersion = undefined;
const $90d2f51c7e148e8a$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ const $90d2f51c7e148e8a$var$AutoDismissFlag = (props)=>{
    const { id: id, analyticsContext: analyticsContext, onDismissed: onDismissedProp = (0, $aD9yk.default), autoDismissSeconds: autoDismissSeconds = $90d2f51c7e148e8a$export$66c3d409977b5615 } = props;
    const autoDismissTimer = (0, $1v5pe.useRef)(null);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $lJzVc.useFlagGroup)();
    const onDismissed = (0, $1v5pe.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const onDismissedAnalytics = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        componentName: 'flag',
        packageName: $90d2f51c7e148e8a$var$packageName,
        packageVersion: $90d2f51c7e148e8a$var$packageVersion
    });
    const isAutoDismissAllowed = isDismissAllowed && onDismissed;
    const dismissFlag = (0, $1v5pe.useCallback)(()=>{
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    const stopAutoDismissTimer = (0, $1v5pe.useCallback)(()=>{
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    const startAutoDismissTimer = (0, $1v5pe.useCallback)(()=>{
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, autoDismissSeconds * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed,
        autoDismissSeconds
    ]);
    (0, $1v5pe.useEffect)(()=>{
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $gLkHF.default), {
        ...props,
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    });
};
var $90d2f51c7e148e8a$export$2e2bcd8739ae039 = $90d2f51c7e148e8a$var$AutoDismissFlag;

});
parcelRegister("j9QYE", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $89e7f8d5047bc7d4$export$a4687b0234b40e28);

var $1v5pe = parcelRequire("1v5pe");

var $8g8jL = parcelRequire("8g8jL");

var $gEAl7 = parcelRequire("gEAl7");
function $89e7f8d5047bc7d4$export$a4687b0234b40e28({ fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $8g8jL.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $gEAl7.useTrackedRef)(analyticsData);
    const fnRef = (0, $gEAl7.useTrackedRef)(fn);
    const handler = (0, $1v5pe.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("gEAl7", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $76ed38080b3f8b17$export$1d27a74659855e44);

var $1v5pe = parcelRequire("1v5pe");
const $76ed38080b3f8b17$export$1d27a74659855e44 = (value)=>{
    const ref = (0, $1v5pe.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("aD9yk", function(module, exports) {
$parcel$export(module.exports, "default", () => $2692dae318bded41$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $2692dae318bded41$export$2e2bcd8739ae039() {}

});

parcelRegister("gLkHF", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7e13ae4f2e5a64f$export$2e2bcd8739ae039);
/* flag.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $j9QYE = parcelRequire("j9QYE");

var $aD9yk = parcelRequire("aD9yk");

var $ayBRL = parcelRequire("ayBRL");

var $7M9W5 = parcelRequire("7M9W5");

var $2aEiL = parcelRequire("2aEiL");

var $8GxWE = parcelRequire("8GxWE");

var $bkr3m = parcelRequire("bkr3m");

var $2txLH = parcelRequire("2txLH");

var $kFr83 = parcelRequire("kFr83");

var $7Plna = parcelRequire("7Plna");

var $lNrGg = parcelRequire("lNrGg");

var $k4HTD = parcelRequire("k4HTD");

var $6yOdY = parcelRequire("6yOdY");

var $14AP4 = parcelRequire("14AP4");

var $htM0G = parcelRequire("htM0G");

var $3P3M8 = parcelRequire("3P3M8");

var $87cVw = parcelRequire("87cVw");

var $71SzD = parcelRequire("71SzD");

var $lJzVc = parcelRequire("lJzVc");

var $kIqwl = parcelRequire("kIqwl");
const $d7e13ae4f2e5a64f$var$_23 = "._c71l53f4{max-height:75pt}";
const $d7e13ae4f2e5a64f$var$_22 = "._18m91wug{overflow-y:auto}";
const $d7e13ae4f2e5a64f$var$_21 = "._1reo1wug{overflow-x:auto}";
const $d7e13ae4f2e5a64f$var$_20 = "._11c8fhey{font:var(--ds-font-body,normal 400 14px/20px \"Atlassian Sans\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const $d7e13ae4f2e5a64f$var$_19 = "._16jlkb7n{flex-grow:1}";
const $d7e13ae4f2e5a64f$var$_18 = "._1ul9idpf{min-width:0}";
const $d7e13ae4f2e5a64f$var$_17 = "._v5641hdc{transition:gap .3s}";
const $d7e13ae4f2e5a64f$var$_16 = "._syaz1jn0{color:var(--flag-icon-color)}";
const $d7e13ae4f2e5a64f$var$_15 = "._1o9zidpf{flex-shrink:0}";
const $d7e13ae4f2e5a64f$var$_14 = "._1bah1h6o{justify-content:center}";
const $d7e13ae4f2e5a64f$var$_13 = "._4cvr1h6o{align-items:center}";
const $d7e13ae4f2e5a64f$var$_12 = "._1tke1tcg{min-height:24px}";
const $d7e13ae4f2e5a64f$var$_11 = "._1ul91tcg{min-width:24px}";
const $d7e13ae4f2e5a64f$var$_10 = "._1e0c1txw{display:flex}";
const $d7e13ae4f2e5a64f$var$_1 = "@media (prefers-reduced-motion:reduce){._156yru3m{transition-duration:0s}}";
const $d7e13ae4f2e5a64f$var$_0 = "._1oec1mzy{transition-duration:var(--ds-duration-long,.25s)}";
const $d7e13ae4f2e5a64f$var$_9 = "._k8m01vax{transition-property:gap}";
const $d7e13ae4f2e5a64f$var$_8 = "._1pbyni7l{z-index:600}";
const $d7e13ae4f2e5a64f$var$_7 = "._16qs130s{box-shadow:var(--ds-shadow-overlay,0 8px 9pt #1e1f2126,0 0 1px #1e1f214f)}";
const $d7e13ae4f2e5a64f$var$_6 = "._v564z97a{transition:background-color .2s}";
const $d7e13ae4f2e5a64f$var$_5 = "._18m915vq{overflow-y:hidden}";
const $d7e13ae4f2e5a64f$var$_4 = "._1reo15vq{overflow-x:hidden}";
const $d7e13ae4f2e5a64f$var$_3 = "._2rko1mok{border-radius:var(--ds-radius-large,8px)}";
const $d7e13ae4f2e5a64f$var$_2 = "._1i4qfg65{overflow-wrap:anywhere}";
const $d7e13ae4f2e5a64f$var$_ = "._1bsb1osq{width:100%}";
const $d7e13ae4f2e5a64f$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rko1mok _1reo15vq _18m915vq _v564z97a _16qs130s _1pbyni7l _1bsb1osq",
    contentStack: "_k8m01vax _1oec1mzy _156yru3m"
};
const $d7e13ae4f2e5a64f$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
const $d7e13ae4f2e5a64f$var$descriptionStyles = null;
const $d7e13ae4f2e5a64f$var$flagWrapperStyles = null;
const $d7e13ae4f2e5a64f$var$iconWrapperStyles = null;
const $d7e13ae4f2e5a64f$var$transitionStyles = null;
const $d7e13ae4f2e5a64f$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: undefined,
    packageVersion: undefined
}; /**
    * __Flag__
    *
    * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
    * often displayed using a flag group.
    *
    * - [Examples](https://atlassian.design/components/flag/examples)
    * - [Code](https://atlassian.design/components/flag/code)
    * - [Usage](https://atlassian.design/components/flag/usage)
    */ 
const $d7e13ae4f2e5a64f$var$Flag = (props)=>{
    const { actions: actions = [], appearance: appearance = (0, $7Plna.DEFAULT_APPEARANCE), icon: icon, title: title, description: description, linkComponent: linkComponent, onMouseOver: onMouseOver, onFocus: onFocus = (0, $aD9yk.default), onMouseOut: onMouseOut, onBlur: onBlur = (0, $aD9yk.default), onDismissed: onDismissedProp = (0, $aD9yk.default), testId: testId, id: id, analyticsContext: analyticsContext, delayAnnouncement: delayAnnouncement, headingLevel: headingLevel = 2 } = props;
    const [isDelayToAnnounce, setIsDelayToAnnounce] = (0, $1v5pe.useState)(false);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $lJzVc.useFlagGroup)();
    const onDismissed = (0, $1v5pe.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const [isExpanded, setIsExpanded] = (0, $1v5pe.useState)(false);
    const onDismissedAnalytics = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        ...$d7e13ae4f2e5a64f$var$analyticsAttributes
    });
    const isBold = appearance !== (0, $7Plna.DEFAULT_APPEARANCE);
    const toggleExpand = (0, $1v5pe.useCallback)(()=>{
        setIsExpanded((previous)=>!previous);
    }, []);
    const buttonActionCallback = (0, $1v5pe.useCallback)(()=>{
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $1v5pe.useEffect)(()=>{
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (!delayAnnouncement) return;
        setTimeout(()=>{
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    const onFocusAnalytics = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext,
        ...$d7e13ae4f2e5a64f$var$analyticsAttributes
    });
    const onBlurAnalytics = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext,
        ...$d7e13ae4f2e5a64f$var$analyticsAttributes
    });
    const autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    const textColor = (0, $htM0G.flagTextColor)[appearance];
    const iconColor = (0, $6yOdY.flagIconColor)[appearance];
    const iconGlyph = (0, $14AP4.flagIconGlyph)[appearance];
    const isDismissable = isBold || isDismissAllowed;
    const shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    const isCollapseAnimationEnabled = (0, $2aEiL.fg)('platform-dst-flag-collapse-animation-fix'); // when delayAnnouncement is available we will use a hidden content for announcement
    const delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kFr83.default), {
        children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $7M9W5.default), {
            children: [
                title,
                description
            ]
        })
    }) : undefined; // A11y improvement opportunity: all flags currently use role="alert" (assertive),
    // but non-critical flags (e.g. info, success) should use role="status" (polite)
    // to avoid interrupting screen reader users. See WCAG 4.1.3.
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $d7e13ae4f2e5a64f$var$_
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                role: "alert",
                "data-testid": testId,
                ...autoDismissProps,
                className: (0, $hMvDh.default)([
                    "_1bsb1osq"
                ]),
                children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                    children: [
                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                            children: [
                                $d7e13ae4f2e5a64f$var$_2,
                                $d7e13ae4f2e5a64f$var$_3,
                                $d7e13ae4f2e5a64f$var$_4,
                                $d7e13ae4f2e5a64f$var$_5,
                                $d7e13ae4f2e5a64f$var$_6,
                                $d7e13ae4f2e5a64f$var$_7,
                                $d7e13ae4f2e5a64f$var$_8,
                                $d7e13ae4f2e5a64f$var$_,
                                $d7e13ae4f2e5a64f$var$_9,
                                $d7e13ae4f2e5a64f$var$_0,
                                $d7e13ae4f2e5a64f$var$_1
                            ]
                        }),
                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8GxWE.Box), {
                            padding: "space.200",
                            backgroundColor: (0, $k4HTD.flagBackgroundColor)[appearance],
                            xcss: $d7e13ae4f2e5a64f$var$styles.flag,
                            children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $bkr3m.Inline), {
                                alignBlock: "start",
                                space: "space.200",
                                children: [
                                    /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                                                children: [
                                                    $d7e13ae4f2e5a64f$var$_10,
                                                    $d7e13ae4f2e5a64f$var$_11,
                                                    $d7e13ae4f2e5a64f$var$_12,
                                                    $d7e13ae4f2e5a64f$var$_13,
                                                    $d7e13ae4f2e5a64f$var$_14,
                                                    $d7e13ae4f2e5a64f$var$_15,
                                                    $d7e13ae4f2e5a64f$var$_16
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                                style: {
                                                    [$d7e13ae4f2e5a64f$var$CSS_VAR_ICON_COLOR]: iconColor
                                                },
                                                "data-testid": testId && `${testId}-icon-container`,
                                                className: (0, $hMvDh.default)([
                                                    "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz1jn0"
                                                ]),
                                                children: icon || iconGlyph
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                                                children: [
                                                    $d7e13ae4f2e5a64f$var$_17,
                                                    $d7e13ae4f2e5a64f$var$_18,
                                                    $d7e13ae4f2e5a64f$var$_19
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
                                                className: (0, $hMvDh.default)([
                                                    "_v5641hdc _1ul9idpf _16jlkb7n"
                                                ]),
                                                children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                                                            children: [
                                                                $d7e13ae4f2e5a64f$var$_2,
                                                                $d7e13ae4f2e5a64f$var$_3,
                                                                $d7e13ae4f2e5a64f$var$_4,
                                                                $d7e13ae4f2e5a64f$var$_5,
                                                                $d7e13ae4f2e5a64f$var$_6,
                                                                $d7e13ae4f2e5a64f$var$_7,
                                                                $d7e13ae4f2e5a64f$var$_8,
                                                                $d7e13ae4f2e5a64f$var$_,
                                                                $d7e13ae4f2e5a64f$var$_9,
                                                                $d7e13ae4f2e5a64f$var$_0,
                                                                $d7e13ae4f2e5a64f$var$_1
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2txLH.Stack), {
                                                            space: shouldRenderGap ? 'space.100' : 'space.0' // Gap exists even when not expanded due to Expander internals always being in the DOM
                                                            ,
                                                            xcss: isCollapseAnimationEnabled ? $d7e13ae4f2e5a64f$var$styles.contentStack : undefined,
                                                            testId: testId && `${testId}-content-stack`,
                                                            children: [
                                                                isDelayToAnnounce && delayedAnnouncement,
                                                                /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $bkr3m.Inline), {
                                                                    alignBlock: "stretch",
                                                                    space: "space.100",
                                                                    spread: "space-between",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                                                                                    children: [
                                                                                        $d7e13ae4f2e5a64f$var$_2,
                                                                                        $d7e13ae4f2e5a64f$var$_3,
                                                                                        $d7e13ae4f2e5a64f$var$_4,
                                                                                        $d7e13ae4f2e5a64f$var$_5,
                                                                                        $d7e13ae4f2e5a64f$var$_6,
                                                                                        $d7e13ae4f2e5a64f$var$_7,
                                                                                        $d7e13ae4f2e5a64f$var$_8,
                                                                                        $d7e13ae4f2e5a64f$var$_,
                                                                                        $d7e13ae4f2e5a64f$var$_9,
                                                                                        $d7e13ae4f2e5a64f$var$_0,
                                                                                        $d7e13ae4f2e5a64f$var$_1
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8GxWE.Box), {
                                                                                    paddingBlockStart: "space.050",
                                                                                    paddingBlockEnd: "space.025",
                                                                                    xcss: $d7e13ae4f2e5a64f$var$styles.overflowWrap,
                                                                                    children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $ayBRL.default), {
                                                                                        as: `h${headingLevel}`,
                                                                                        size: "xsmall",
                                                                                        color: textColor,
                                                                                        children: /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
                                                                                            /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce,
                                                                                            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7M9W5.default), {
                                                                                                children: title
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $87cVw.default), {
                                                                            testId: testId,
                                                                            appearance: appearance,
                                                                            isBold: isBold,
                                                                            isExpanded: isExpanded,
                                                                            onClick: isBold ? toggleExpand : buttonActionCallback
                                                                        }) : null
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $71SzD.default), {
                                                                    isExpanded: !isBold || isExpanded,
                                                                    testId: testId,
                                                                    children: [
                                                                        description && /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                                                                                    children: [
                                                                                        $d7e13ae4f2e5a64f$var$_20,
                                                                                        $d7e13ae4f2e5a64f$var$_21,
                                                                                        $d7e13ae4f2e5a64f$var$_22,
                                                                                        $d7e13ae4f2e5a64f$var$_23,
                                                                                        $d7e13ae4f2e5a64f$var$_2
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                                                                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                                                                    style: {
                                                                                        color: (0, $3P3M8.flagTextColorToken)[appearance]
                                                                                    },
                                                                                    "data-testid": testId && `${testId}-description`,
                                                                                    "aria-hidden": isDelayToAnnounce,
                                                                                    className: (0, $hMvDh.default)([
                                                                                        "_11c8fhey _1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
                                                                                    ]),
                                                                                    children: description
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $lNrGg.default), {
                                                                            actions: actions,
                                                                            appearance: appearance,
                                                                            linkComponent: linkComponent,
                                                                            testId: testId
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $d7e13ae4f2e5a64f$export$2e2bcd8739ae039 = $d7e13ae4f2e5a64f$var$Flag;

});
parcelRegister("ayBRL", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce61df91ef6970e2$export$2e2bcd8739ae039);
/* heading.tsx generated by @compiled/babel-plugin v3.0.2 */ /* heading.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $3WrNu = parcelRequire("3WrNu");

var $8N3pK = parcelRequire("8N3pK");

var $dlkqG = parcelRequire("dlkqG");

var $kIqwl = parcelRequire("kIqwl");

var $k1Wvt = parcelRequire("k1Wvt");
const $ce61df91ef6970e2$var$_11 = "._1w901yd3._1w901yd3{color:var(--ds-text-warning-inverse,#292a2e)}";
const $ce61df91ef6970e2$var$_10 = "._1w9015cr._1w9015cr{color:var(--ds-text-inverse,#fff)}";
const $ce61df91ef6970e2$var$_1 = "._1w90i7uo._1w90i7uo{color:var(--ds-text,#292a2e)}";
const $ce61df91ef6970e2$var$_0 = "._fqoxi4vh._fqoxi4vh{font:var(--ds-font-heading-xxsmall,normal 653 9pt/1pc \"Atlassian Sans\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const $ce61df91ef6970e2$var$_9 = "._fqox1qyo._fqox1qyo{font:var(--ds-font-heading-xsmall,normal 653 14px/20px \"Atlassian Sans\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const $ce61df91ef6970e2$var$_8 = "._fqox1e3o._fqox1e3o{font:var(--ds-font-heading-small,normal 653 1pc/20px \"Atlassian Sans\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const $ce61df91ef6970e2$var$_7 = "._fqox1af2._fqox1af2{font:var(--ds-font-heading-medium,normal 653 20px/24px \"Atlassian Sans\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const $ce61df91ef6970e2$var$_6 = "._fqox10sd._fqox10sd{font:var(--ds-font-heading-large,normal 653 24px/28px \"Atlassian Sans\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const $ce61df91ef6970e2$var$_5 = "._fqox12ln._fqox12ln{font:var(--ds-font-heading-xlarge,normal 653 28px/2pc \"Atlassian Sans\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const $ce61df91ef6970e2$var$_4 = "._fqox1iff._fqox1iff{font:var(--ds-font-heading-xxlarge,normal 653 2pc/36px \"Atlassian Sans\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const $ce61df91ef6970e2$var$_3 = "._nmk4glyw._nmk4glyw{text-transform:none}";
const $ce61df91ef6970e2$var$_2 = "._1i144jg8._1i144jg8{letter-spacing:normal}";
const $ce61df91ef6970e2$var$_ = "._dxsyidpf._dxsyidpf{margin-block:0}";
const $ce61df91ef6970e2$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $ce61df91ef6970e2$var$styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $ce61df91ef6970e2$var$headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $ce61df91ef6970e2$var$headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
/**
 * @codegenEnd
 */ const $ce61df91ef6970e2$var$useColor = (colorProp)=>{
    const surface = (0, $3WrNu.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $8N3pK.inverseColorMap).hasOwnProperty(surface)) return (0, $8N3pK.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ const $ce61df91ef6970e2$var$Heading = /*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>{
    const { children: children, size: size, id: id, testId: testId, as: as, color: colorProp } = props;
    typeof $k1Wvt;
    const [hLevel, inferredElement] = (0, $dlkqG.useHeading)($ce61df91ef6970e2$var$sizeTagMap[size]);
    const Component = as || inferredElement;
    const needsAriaRole = Component === 'div' && hLevel;
    const color = $ce61df91ef6970e2$var$useColor(colorProp);
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $ce61df91ef6970e2$var$_,
                    $ce61df91ef6970e2$var$_2,
                    $ce61df91ef6970e2$var$_3,
                    $ce61df91ef6970e2$var$_4,
                    $ce61df91ef6970e2$var$_5,
                    $ce61df91ef6970e2$var$_6,
                    $ce61df91ef6970e2$var$_7,
                    $ce61df91ef6970e2$var$_8,
                    $ce61df91ef6970e2$var$_9,
                    $ce61df91ef6970e2$var$_0,
                    $ce61df91ef6970e2$var$_1,
                    $ce61df91ef6970e2$var$_10,
                    $ce61df91ef6970e2$var$_11
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)(Component, {
                id: id,
                ref: ref,
                "data-testid": testId,
                role: needsAriaRole ? 'heading' : undefined,
                "aria-level": needsAriaRole ? hLevel : undefined,
                className: (0, $hMvDh.default)([
                    $ce61df91ef6970e2$var$styles.reset,
                    $ce61df91ef6970e2$var$headingSizeStyles[size],
                    $ce61df91ef6970e2$var$headingColorStyles[color]
                ]),
                children: children
            })
        ]
    });
});
var $ce61df91ef6970e2$export$2e2bcd8739ae039 = $ce61df91ef6970e2$var$Heading;

});
parcelRegister("3WrNu", function(module, exports) {
$parcel$export(module.exports, "useSurface", () => $5b23ea2ee89a156c$export$1aeb4f6b93c4540d);

var $1v5pe = parcelRequire("1v5pe");

var $kH2JL = parcelRequire("kH2JL");
const $5b23ea2ee89a156c$export$1aeb4f6b93c4540d = ()=>{
    return (0, $1v5pe.useContext)((0, $kH2JL.SurfaceContext));
};
(0, $kH2JL.SurfaceContext).displayName = 'SurfaceProvider';

});

parcelRegister("8N3pK", function(module, exports) {
$parcel$export(module.exports, "inverseColorMap", () => $a86b3e62ffc24c0c$export$2185ce37f9bdd963);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69f941eca1bf309f7088207fc024b707>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $a86b3e62ffc24c0c$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse',
    'color.rovo.background.brand.bold': 'color.text.inverse',
    'color.rovo.background.brand.bold.hovered': 'color.text.inverse',
    'color.rovo.background.brand.bold.pressed': 'color.text.inverse'
};

});

parcelRegister("dlkqG", function(module, exports) {
$parcel$export(module.exports, "useHeading", () => $17c2872008eee7c3$export$97a37b1befbbf9b1);

var $k3PRr = parcelRequire("k3PRr");
const $17c2872008eee7c3$export$97a37b1befbbf9b1 = (fallback)=>{
    const hLevel = (0, $k3PRr.useHeadingLevel)();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : `h${hLevel}`) || fallback
    ];
};

});
parcelRegister("k3PRr", function(module, exports) {
$parcel$export(module.exports, "useHeadingLevel", () => $86030959f9220a79$export$6a64a1e2d0bbbf75);

var $1v5pe = parcelRequire("1v5pe");

var $EVsfH = parcelRequire("EVsfH");
const $86030959f9220a79$export$6a64a1e2d0bbbf75 = ()=>{
    return (0, $1v5pe.useContext)((0, $EVsfH.HeadingLevelContext));
};

});
parcelRegister("EVsfH", function(module, exports) {
$parcel$export(module.exports, "HeadingLevelContext", () => $04fa45639cd61d14$export$d1fa8a19e192bc63);

var $1v5pe = parcelRequire("1v5pe");
const $04fa45639cd61d14$export$d1fa8a19e192bc63 = /*#__PURE__*/ (0, $1v5pe.createContext)(0);

});




parcelRegister("7M9W5", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6bef3f91c3f7963$export$2e2bcd8739ae039);
parcelRequire("1v5pe");

var $2aEiL = parcelRequire("2aEiL");

var $7dKqR = parcelRequire("7dKqR");

var $kIqwl = parcelRequire("kIqwl");
function $f6bef3f91c3f7963$export$2e2bcd8739ae039({ children: children }) {
    return (0, $2aEiL.fg)('platform-dst-motion-isolate-presence') ? /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7dKqR.ExitingContext).Provider, {
        value: (0, $7dKqR.defaultExitingContext),
        children: children
    }) : /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kIqwl.Fragment), {
        children: children
    });
}

});
parcelRegister("7dKqR", function(module, exports) {
$parcel$export(module.exports, "defaultExitingContext", () => $22b9c5033f875444$export$52502485782d6180);
$parcel$export(module.exports, "ExitingContext", () => $22b9c5033f875444$export$b9c4904d7a6929e6);
$parcel$export(module.exports, "default", () => $22b9c5033f875444$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $2aEiL = parcelRequire("2aEiL");

var $kIqwl = parcelRequire("kIqwl");
const $22b9c5033f875444$export$52502485782d6180 = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isInsideExitingPersistence: false,
    isExiting: false
};
const $22b9c5033f875444$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $1v5pe.createContext)($22b9c5033f875444$export$52502485782d6180);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ const $22b9c5033f875444$var$wrapChildWithContextProvider = (child, value = $22b9c5033f875444$export$52502485782d6180)=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)($22b9c5033f875444$export$b9c4904d7a6929e6.Provider, {
        value: value,
        children: child
    }, `${child.key}-provider`);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ const $22b9c5033f875444$var$childrenToArray = (children)=>{
    const childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $1v5pe.Children).toArray(children).forEach((child)=>{
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
const $22b9c5033f875444$var$spliceNewElementsIntoPrevious = (current, previous)=>{
    const splicedChildren = previous.concat([]);
    const previousMap = $22b9c5033f875444$var$childrenToObj(previous);
    for(let i = 0; i < current.length; i++){
        const child = current[i];
        const childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
const $22b9c5033f875444$var$childrenToObj = (children)=>{
    return children.reduce((acc, child)=>{
        acc[child.key] = child;
        return acc;
    }, {});
};
const $22b9c5033f875444$var$getMissingKeys = (current, previous)=>{
    const currentMapKeys = new Set(current.map((child)=>child.key));
    const missing = new Set();
    for(let i = 0; i < previous.length; i++){
        const element = previous[i];
        const key = element.key;
        if (!currentMapKeys.has(key)) missing.add(key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $22b9c5033f875444$var$ExitingPersistence = /*#__PURE__*/ (0, $1v5pe.memo)(({ appear: appear = false, children: children, exitThenEnter: exitThenEnter })=>{
    const [stateChildren, setChildren] = (0, $1v5pe.useState)([
        null,
        children
    ]);
    const [exitingChildren, setExitingChildren] = (0, $1v5pe.useState)([]);
    const [defaultContext, setDefaultContext] = (0, $1v5pe.useState)(()=>({
            appear: appear,
            isExiting: false,
            isInsideExitingPersistence: true
        }));
    (0, $1v5pe.useEffect)(()=>{
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false,
            isInsideExitingPersistence: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    const [previousChildren, currentChildren] = stateChildren;
    const previous = $22b9c5033f875444$var$childrenToArray(previousChildren);
    const current = $22b9c5033f875444$var$childrenToArray(currentChildren);
    if (currentChildren !== children) {
        // Parent updates can rerender this boundary before its children finish exiting. Keep
        // the previous children until their onFinish callbacks release them.
        const hasPendingExit = ((0, $2aEiL.fg)('platform-dst-motion-uplift-labels') || (0, $2aEiL.fg)('platform-dst-motion-uplift-input')) && $22b9c5033f875444$var$getMissingKeys(current, previous).size > 0;
        setChildren([
            hasPendingExit ? previousChildren : currentChildren,
            children
        ]);
    }
    const nextChildren = currentChildren !== children ? $22b9c5033f875444$var$childrenToArray(children) : current;
    const missingKeys = $22b9c5033f875444$var$getMissingKeys(nextChildren, previous);
    const isSomeChildRemoved = !!missingKeys.size;
    let visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $22b9c5033f875444$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $2aEiL.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            const nextExitingChildren = visibleChildren.filter((child)=>missingKeys.has(child.key));
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map((child)=>{
        const isExiting = missingKeys.has(child.key);
        // Retained exits can span several parent renders. Unchanged siblings should
        // keep their context identity instead of receiving redundant updates.
        if (((0, $2aEiL.fg)('platform-dst-motion-uplift-labels') || (0, $2aEiL.fg)('platform-dst-motion-uplift-input')) && !isExiting) return $22b9c5033f875444$var$wrapChildWithContextProvider(child, defaultContext);
        return $22b9c5033f875444$var$wrapChildWithContextProvider(child, {
            appear: true,
            isInsideExitingPersistence: true,
            isExiting: isExiting,
            onFinish: isExiting ? ()=>{
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map((child)=>$22b9c5033f875444$var$wrapChildWithContextProvider(child, defaultContext));
    return visibleChildren;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$22b9c5033f875444$export$2e2bcd8739ae039 = $22b9c5033f875444$var$ExitingPersistence;
$22b9c5033f875444$var$ExitingPersistence.displayName = 'ExitingPersistence';

});


parcelRegister("8GxWE", function(module, exports) {
$parcel$export(module.exports, "Box", () => $dd7c8d30b57c2656$export$e71c4d32a2263218);
/* box.tsx generated by @compiled/babel-plugin v3.0.2 */ /* box.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $kH2JL = parcelRequire("kH2JL");

var $kIqwl = parcelRequire("kIqwl");
const $dd7c8d30b57c2656$var$_264 = "._y4ti1epz{padding-inline-end:var(--ds-space-1000,5pc)}";
const $dd7c8d30b57c2656$var$_263 = "._y4tixncg{padding-inline-end:var(--ds-space-800,4pc)}";
const $dd7c8d30b57c2656$var$_262 = "._y4tioahv{padding-inline-end:var(--ds-space-600,3pc)}";
const $dd7c8d30b57c2656$var$_261 = "._y4ti1jfw{padding-inline-end:var(--ds-space-500,40px)}";
const $dd7c8d30b57c2656$var$_260 = "._y4tixy5q{padding-inline-end:var(--ds-space-400,2pc)}";
const $dd7c8d30b57c2656$var$_259 = "._y4ti1ejb{padding-inline-end:var(--ds-space-300,24px)}";
const $dd7c8d30b57c2656$var$_258 = "._y4tiv47k{padding-inline-end:var(--ds-space-250,20px)}";
const $dd7c8d30b57c2656$var$_257 = "._y4tipxbi{padding-inline-end:var(--ds-space-200,1pc)}";
const $dd7c8d30b57c2656$var$_256 = "._y4tiutpp{padding-inline-end:var(--ds-space-150,9pt)}";
const $dd7c8d30b57c2656$var$_255 = "._y4tiu2gc{padding-inline-end:var(--ds-space-100,8px)}";
const $dd7c8d30b57c2656$var$_254 = "._y4ti12x7{padding-inline-end:var(--ds-space-075,6px)}";
const $dd7c8d30b57c2656$var$_253 = "._y4ti1b66{padding-inline-end:var(--ds-space-050,4px)}";
const $dd7c8d30b57c2656$var$_252 = "._y4tiv77o{padding-inline-end:var(--ds-space-025,2px)}";
const $dd7c8d30b57c2656$var$_251 = "._y4tize3t{padding-inline-end:var(--ds-space-0,0)}";
const $dd7c8d30b57c2656$var$_250 = "._bozg1epz{padding-inline-start:var(--ds-space-1000,5pc)}";
const $dd7c8d30b57c2656$var$_249 = "._bozgxncg{padding-inline-start:var(--ds-space-800,4pc)}";
const $dd7c8d30b57c2656$var$_248 = "._bozgoahv{padding-inline-start:var(--ds-space-600,3pc)}";
const $dd7c8d30b57c2656$var$_247 = "._bozg1jfw{padding-inline-start:var(--ds-space-500,40px)}";
const $dd7c8d30b57c2656$var$_246 = "._bozgxy5q{padding-inline-start:var(--ds-space-400,2pc)}";
const $dd7c8d30b57c2656$var$_245 = "._bozg1ejb{padding-inline-start:var(--ds-space-300,24px)}";
const $dd7c8d30b57c2656$var$_244 = "._bozgv47k{padding-inline-start:var(--ds-space-250,20px)}";
const $dd7c8d30b57c2656$var$_243 = "._bozgpxbi{padding-inline-start:var(--ds-space-200,1pc)}";
const $dd7c8d30b57c2656$var$_242 = "._bozgutpp{padding-inline-start:var(--ds-space-150,9pt)}";
const $dd7c8d30b57c2656$var$_241 = "._bozgu2gc{padding-inline-start:var(--ds-space-100,8px)}";
const $dd7c8d30b57c2656$var$_240 = "._bozg12x7{padding-inline-start:var(--ds-space-075,6px)}";
const $dd7c8d30b57c2656$var$_239 = "._bozg1b66{padding-inline-start:var(--ds-space-050,4px)}";
const $dd7c8d30b57c2656$var$_238 = "._bozgv77o{padding-inline-start:var(--ds-space-025,2px)}";
const $dd7c8d30b57c2656$var$_237 = "._bozgze3t{padding-inline-start:var(--ds-space-0,0)}";
const $dd7c8d30b57c2656$var$_236 = "._85i51epz{padding-block-end:var(--ds-space-1000,5pc)}";
const $dd7c8d30b57c2656$var$_235 = "._85i5xncg{padding-block-end:var(--ds-space-800,4pc)}";
const $dd7c8d30b57c2656$var$_234 = "._85i5oahv{padding-block-end:var(--ds-space-600,3pc)}";
const $dd7c8d30b57c2656$var$_233 = "._85i51jfw{padding-block-end:var(--ds-space-500,40px)}";
const $dd7c8d30b57c2656$var$_232 = "._85i5xy5q{padding-block-end:var(--ds-space-400,2pc)}";
const $dd7c8d30b57c2656$var$_231 = "._85i51ejb{padding-block-end:var(--ds-space-300,24px)}";
const $dd7c8d30b57c2656$var$_230 = "._85i5v47k{padding-block-end:var(--ds-space-250,20px)}";
const $dd7c8d30b57c2656$var$_229 = "._85i5pxbi{padding-block-end:var(--ds-space-200,1pc)}";
const $dd7c8d30b57c2656$var$_228 = "._85i5utpp{padding-block-end:var(--ds-space-150,9pt)}";
const $dd7c8d30b57c2656$var$_227 = "._85i5u2gc{padding-block-end:var(--ds-space-100,8px)}";
const $dd7c8d30b57c2656$var$_226 = "._85i512x7{padding-block-end:var(--ds-space-075,6px)}";
const $dd7c8d30b57c2656$var$_225 = "._85i51b66{padding-block-end:var(--ds-space-050,4px)}";
const $dd7c8d30b57c2656$var$_224 = "._85i5v77o{padding-block-end:var(--ds-space-025,2px)}";
const $dd7c8d30b57c2656$var$_223 = "._85i5ze3t{padding-block-end:var(--ds-space-0,0)}";
const $dd7c8d30b57c2656$var$_222 = "._1q511epz{padding-block-start:var(--ds-space-1000,5pc)}";
const $dd7c8d30b57c2656$var$_221 = "._1q51xncg{padding-block-start:var(--ds-space-800,4pc)}";
const $dd7c8d30b57c2656$var$_220 = "._1q51oahv{padding-block-start:var(--ds-space-600,3pc)}";
const $dd7c8d30b57c2656$var$_219 = "._1q511jfw{padding-block-start:var(--ds-space-500,40px)}";
const $dd7c8d30b57c2656$var$_218 = "._1q51xy5q{padding-block-start:var(--ds-space-400,2pc)}";
const $dd7c8d30b57c2656$var$_217 = "._1q511ejb{padding-block-start:var(--ds-space-300,24px)}";
const $dd7c8d30b57c2656$var$_216 = "._1q51v47k{padding-block-start:var(--ds-space-250,20px)}";
const $dd7c8d30b57c2656$var$_215 = "._1q51pxbi{padding-block-start:var(--ds-space-200,1pc)}";
const $dd7c8d30b57c2656$var$_214 = "._1q51utpp{padding-block-start:var(--ds-space-150,9pt)}";
const $dd7c8d30b57c2656$var$_213 = "._1q51u2gc{padding-block-start:var(--ds-space-100,8px)}";
const $dd7c8d30b57c2656$var$_212 = "._1q5112x7{padding-block-start:var(--ds-space-075,6px)}";
const $dd7c8d30b57c2656$var$_211 = "._1q511b66{padding-block-start:var(--ds-space-050,4px)}";
const $dd7c8d30b57c2656$var$_210 = "._1q51v77o{padding-block-start:var(--ds-space-025,2px)}";
const $dd7c8d30b57c2656$var$_209 = "._1q51ze3t{padding-block-start:var(--ds-space-0,0)}";
const $dd7c8d30b57c2656$var$_208 = "._1q1lhfxm{--ds-elevation-surface-current:var(--ds-surface-sunken,#f8f8f8)}";
const $dd7c8d30b57c2656$var$_207 = "._1q1l14aj{--ds-elevation-surface-current:var(--ds-surface-raised-pressed,#dddee1)}";
const $dd7c8d30b57c2656$var$_206 = "._1q1l116u{--ds-elevation-surface-current:var(--ds-surface-raised-hovered,#f0f1f2)}";
const $dd7c8d30b57c2656$var$_205 = "._1q1lhp5a{--ds-elevation-surface-current:var(--ds-surface-raised,#fff)}";
const $dd7c8d30b57c2656$var$_204 = "._1q1lm8nx{--ds-elevation-surface-current:var(--ds-surface-overlay-pressed,#dddee1)}";
const $dd7c8d30b57c2656$var$_203 = "._1q1l6o2t{--ds-elevation-surface-current:var(--ds-surface-overlay-hovered,#f0f1f2)}";
const $dd7c8d30b57c2656$var$_202 = "._1q1l1bhr{--ds-elevation-surface-current:var(--ds-surface-overlay,#fff)}";
const $dd7c8d30b57c2656$var$_201 = "._1q1l13ro{--ds-elevation-surface-current:var(--ds-surface-pressed,#dddee1)}";
const $dd7c8d30b57c2656$var$_200 = "._1q1l19i6{--ds-elevation-surface-current:var(--ds-surface-hovered,#f0f1f2)}";
const $dd7c8d30b57c2656$var$_199 = "._1q1lvuon{--ds-elevation-surface-current:var(--ds-surface,#fff)}";
const $dd7c8d30b57c2656$var$_198 = "._bfhkchd4{background-color:var(--ds-elevation-surface-current,#fff)}";
const $dd7c8d30b57c2656$var$_197 = "._bfhkhfxm{background-color:var(--ds-surface-sunken,#f8f8f8)}";
const $dd7c8d30b57c2656$var$_196 = "._bfhk14aj{background-color:var(--ds-surface-raised-pressed,#dddee1)}";
const $dd7c8d30b57c2656$var$_195 = "._bfhk116u{background-color:var(--ds-surface-raised-hovered,#f0f1f2)}";
const $dd7c8d30b57c2656$var$_194 = "._bfhkhp5a{background-color:var(--ds-surface-raised,#fff)}";
const $dd7c8d30b57c2656$var$_193 = "._bfhkm8nx{background-color:var(--ds-surface-overlay-pressed,#dddee1)}";
const $dd7c8d30b57c2656$var$_192 = "._bfhk6o2t{background-color:var(--ds-surface-overlay-hovered,#f0f1f2)}";
const $dd7c8d30b57c2656$var$_191 = "._bfhk1bhr{background-color:var(--ds-surface-overlay,#fff)}";
const $dd7c8d30b57c2656$var$_190 = "._bfhk13ro{background-color:var(--ds-surface-pressed,#dddee1)}";
const $dd7c8d30b57c2656$var$_189 = "._bfhk19i6{background-color:var(--ds-surface-hovered,#f0f1f2)}";
const $dd7c8d30b57c2656$var$_188 = "._bfhkvuon{background-color:var(--ds-surface,#fff)}";
const $dd7c8d30b57c2656$var$_187 = "._bfhkvkf5{background-color:var(--ds-skeleton-subtle,#17171708)}";
const $dd7c8d30b57c2656$var$_186 = "._bfhkizff{background-color:var(--ds-skeleton,#0515240f)}";
const $dd7c8d30b57c2656$var$_185 = "._bfhkrprw{background-color:var(--ds-blanket-danger,#ef5c4814)}";
const $dd7c8d30b57c2656$var$_184 = "._bfhk7wq0{background-color:var(--ds-blanket-selected,#388bff14)}";
const $dd7c8d30b57c2656$var$_183 = "._bfhk1i5c{background-color:var(--ds-blanket,#050c1f75)}";
const $dd7c8d30b57c2656$var$_182 = "._bfhkf89v{background-color:var(--ds-background-information-bold-pressed,#144794)}";
const $dd7c8d30b57c2656$var$_181 = "._bfhkq2ii{background-color:var(--ds-background-information-bold-hovered,#1558bc)}";
const $dd7c8d30b57c2656$var$_180 = "._bfhkx4w0{background-color:var(--ds-background-information-bold,#1868db)}";
const $dd7c8d30b57c2656$var$_179 = "._bfhk1c1j{background-color:var(--ds-background-information-pressed,#adcbfb)}";
const $dd7c8d30b57c2656$var$_178 = "._bfhk86z5{background-color:var(--ds-background-information-hovered,#cfe1fd)}";
const $dd7c8d30b57c2656$var$_177 = "._bfhk19ip{background-color:var(--ds-background-information,#e9f2fe)}";
const $dd7c8d30b57c2656$var$_176 = "._bfhk1f1m{background-color:var(--ds-background-discovery-bold-pressed,#673286)}";
const $dd7c8d30b57c2656$var$_175 = "._bfhkfqeg{background-color:var(--ds-background-discovery-bold-hovered,#803fa5)}";
const $dd7c8d30b57c2656$var$_174 = "._bfhku5tj{background-color:var(--ds-background-discovery-bold,#964ac0)}";
const $dd7c8d30b57c2656$var$_173 = "._bfhk18vq{background-color:var(--ds-background-discovery-pressed,#e3bdfa)}";
const $dd7c8d30b57c2656$var$_172 = "._bfhk12eq{background-color:var(--ds-background-discovery-hovered,#eed7fc)}";
const $dd7c8d30b57c2656$var$_171 = "._bfhk6vm6{background-color:var(--ds-background-discovery,#f8eefe)}";
const $dd7c8d30b57c2656$var$_170 = "._bfhkwcbh{background-color:var(--ds-background-success-bold-pressed,#3f5224)}";
const $dd7c8d30b57c2656$var$_169 = "._bfhky7x8{background-color:var(--ds-background-success-bold-hovered,#4c6b1f)}";
const $dd7c8d30b57c2656$var$_168 = "._bfhkkcmj{background-color:var(--ds-background-success-bold,#5b7f24)}";
const $dd7c8d30b57c2656$var$_167 = "._bfhk1wl5{background-color:var(--ds-background-success-pressed,#bde97c)}";
const $dd7c8d30b57c2656$var$_166 = "._bfhk1vfx{background-color:var(--ds-background-success-hovered,#d3f1a7)}";
const $dd7c8d30b57c2656$var$_165 = "._bfhk1y9u{background-color:var(--ds-background-success,#efffd6)}";
const $dd7c8d30b57c2656$var$_164 = "._bfhk4m4m{background-color:var(--ds-background-warning-bold-pressed,#f68909)}";
const $dd7c8d30b57c2656$var$_163 = "._bfhk1spp{background-color:var(--ds-background-warning-bold-hovered,#fca700)}";
const $dd7c8d30b57c2656$var$_162 = "._bfhk1kmu{background-color:var(--ds-background-warning-bold,#fbc828)}";
const $dd7c8d30b57c2656$var$_161 = "._bfhkzr32{background-color:var(--ds-background-warning-pressed,#fbd779)}";
const $dd7c8d30b57c2656$var$_160 = "._bfhk19zu{background-color:var(--ds-background-warning-hovered,#fce4a6)}";
const $dd7c8d30b57c2656$var$_159 = "._bfhk1917{background-color:var(--ds-background-warning,#fff5db)}";
const $dd7c8d30b57c2656$var$_158 = "._bfhk13a9{background-color:var(--ds-background-danger-bold-pressed,#872821)}";
const $dd7c8d30b57c2656$var$_157 = "._bfhks9hg{background-color:var(--ds-background-danger-bold-hovered,#ae2e24)}";
const $dd7c8d30b57c2656$var$_156 = "._bfhkybec{background-color:var(--ds-background-danger-bold,#c9372c)}";
const $dd7c8d30b57c2656$var$_155 = "._bfhk1r4b{background-color:var(--ds-background-danger-pressed,#ffb8b2)}";
const $dd7c8d30b57c2656$var$_154 = "._bfhk1yvi{background-color:var(--ds-background-danger-hovered,#ffd5d2)}";
const $dd7c8d30b57c2656$var$_153 = "._bfhk1gly{background-color:var(--ds-background-danger,#ffeceb)}";
const $dd7c8d30b57c2656$var$_152 = "._bfhk16k6{background-color:var(--ds-background-brand-boldest-pressed,#144794)}";
const $dd7c8d30b57c2656$var$_151 = "._bfhklefx{background-color:var(--ds-background-brand-boldest-hovered,#123263)}";
const $dd7c8d30b57c2656$var$_150 = "._bfhk1o4i{background-color:var(--ds-background-brand-boldest,#1c2b42)}";
const $dd7c8d30b57c2656$var$_149 = "._bfhkg6ey{background-color:var(--ds-background-brand-bold-pressed,#144794)}";
const $dd7c8d30b57c2656$var$_148 = "._bfhkhf2y{background-color:var(--ds-background-brand-bold-hovered,#1558bc)}";
const $dd7c8d30b57c2656$var$_147 = "._bfhk1856{background-color:var(--ds-background-brand-bold,#1868db)}";
const $dd7c8d30b57c2656$var$_146 = "._bfhku02c{background-color:var(--ds-background-brand-subtlest-pressed,#adcbfb)}";
const $dd7c8d30b57c2656$var$_145 = "._bfhk3v15{background-color:var(--ds-background-brand-subtlest-hovered,#cfe1fd)}";
const $dd7c8d30b57c2656$var$_144 = "._bfhk1gmr{background-color:var(--ds-background-brand-subtlest,#e9f2fe)}";
const $dd7c8d30b57c2656$var$_143 = "._bfhk12kk{background-color:var(--ds-background-selected-bold-pressed,#123263)}";
const $dd7c8d30b57c2656$var$_142 = "._bfhk1q28{background-color:var(--ds-background-selected-bold-hovered,#1558bc)}";
const $dd7c8d30b57c2656$var$_141 = "._bfhkjmqp{background-color:var(--ds-background-selected-bold,#1868db)}";
const $dd7c8d30b57c2656$var$_140 = "._bfhknozp{background-color:var(--ds-background-selected-pressed,#8fb8f6)}";
const $dd7c8d30b57c2656$var$_139 = "._bfhkufnl{background-color:var(--ds-background-selected-hovered,#cfe1fd)}";
const $dd7c8d30b57c2656$var$_138 = "._bfhk15s3{background-color:var(--ds-background-selected,#e9f2fe)}";
const $dd7c8d30b57c2656$var$_137 = "._bfhkof27{background-color:var(--ds-background-neutral-bold-pressed,#505258)}";
const $dd7c8d30b57c2656$var$_136 = "._bfhk1ibz{background-color:var(--ds-background-neutral-bold-hovered,#3b3d42)}";
const $dd7c8d30b57c2656$var$_135 = "._bfhk1aqn{background-color:var(--ds-background-neutral-bold,#292a2e)}";
const $dd7c8d30b57c2656$var$_134 = "._bfhkfcek{background-color:var(--ds-background-neutral-subtle-pressed,#0b120e24)}";
const $dd7c8d30b57c2656$var$_133 = "._bfhk1dpa{background-color:var(--ds-background-neutral-subtle-hovered,#0515240f)}";
const $dd7c8d30b57c2656$var$_132 = "._bfhksm61{background-color:var(--ds-background-neutral-subtle,#00000000)}";
const $dd7c8d30b57c2656$var$_131 = "._bfhk1gdz{background-color:var(--ds-background-neutral-pressed,#080f214a)}";
const $dd7c8d30b57c2656$var$_130 = "._bfhkplhp{background-color:var(--ds-background-neutral-hovered,#0b120e24)}";
const $dd7c8d30b57c2656$var$_129 = "._bfhki8nm{background-color:var(--ds-background-neutral,#0515240f)}";
const $dd7c8d30b57c2656$var$_128 = "._bfhk1gii{background-color:var(--ds-background-inverse-subtle-pressed,#00000052)}";
const $dd7c8d30b57c2656$var$_127 = "._bfhkmpja{background-color:var(--ds-background-inverse-subtle-hovered,#0000003d)}";
const $dd7c8d30b57c2656$var$_126 = "._bfhk1vck{background-color:var(--ds-background-inverse-subtle,#00000029)}";
const $dd7c8d30b57c2656$var$_125 = "._bfhkr01l{background-color:var(--ds-background-input-pressed,#fff)}";
const $dd7c8d30b57c2656$var$_124 = "._bfhkl4ek{background-color:var(--ds-background-input-hovered,#f8f8f8)}";
const $dd7c8d30b57c2656$var$_123 = "._bfhk1j9a{background-color:var(--ds-background-input,#fff)}";
const $dd7c8d30b57c2656$var$_122 = "._bfhk187o{background-color:var(--ds-background-disabled,#0515240f)}";
const $dd7c8d30b57c2656$var$_121 = "._bfhk1van{background-color:var(--ds-background-accent-gray-bolder-pressed,#3b3d42)}";
const $dd7c8d30b57c2656$var$_120 = "._bfhkbyip{background-color:var(--ds-background-accent-gray-bolder-hovered,#505258)}";
const $dd7c8d30b57c2656$var$_119 = "._bfhk1i45{background-color:var(--ds-background-accent-gray-bolder,#6b6e76)}";
const $dd7c8d30b57c2656$var$_118 = "._bfhkq9tj{background-color:var(--ds-background-accent-gray-subtle-pressed,#dddee1)}";
const $dd7c8d30b57c2656$var$_117 = "._bfhk1nv3{background-color:var(--ds-background-accent-gray-subtle-hovered,#b7b9be)}";
const $dd7c8d30b57c2656$var$_116 = "._bfhk18j9{background-color:var(--ds-background-accent-gray-subtle,#8c8f97)}";
const $dd7c8d30b57c2656$var$_115 = "._bfhk1rk9{background-color:var(--ds-background-accent-gray-subtler-pressed,#8c8f97)}";
const $dd7c8d30b57c2656$var$_114 = "._bfhk10ef{background-color:var(--ds-background-accent-gray-subtler-hovered,#b7b9be)}";
const $dd7c8d30b57c2656$var$_113 = "._bfhk7qp0{background-color:var(--ds-background-accent-gray-subtler,#dddee1)}";
const $dd7c8d30b57c2656$var$_112 = "._bfhk18ut{background-color:var(--ds-background-accent-gray-subtlest-pressed,#b7b9be)}";
const $dd7c8d30b57c2656$var$_111 = "._bfhkwejn{background-color:var(--ds-background-accent-gray-subtlest-hovered,#dddee1)}";
const $dd7c8d30b57c2656$var$_110 = "._bfhkysee{background-color:var(--ds-background-accent-gray-subtlest,#f0f1f2)}";
const $dd7c8d30b57c2656$var$_109 = "._bfhkeawv{background-color:var(--ds-background-accent-magenta-bolder-pressed,#77325b)}";
const $dd7c8d30b57c2656$var$_108 = "._bfhk1ok8{background-color:var(--ds-background-accent-magenta-bolder-hovered,#943d73)}";
const $dd7c8d30b57c2656$var$_107 = "._bfhkc3uk{background-color:var(--ds-background-accent-magenta-bolder,#ae4787)}";
const $dd7c8d30b57c2656$var$_106 = "._bfhk6c15{background-color:var(--ds-background-accent-magenta-subtle-pressed,#fcb6e1)}";
const $dd7c8d30b57c2656$var$_105 = "._bfhkrwyz{background-color:var(--ds-background-accent-magenta-subtle-hovered,#f797d2)}";
const $dd7c8d30b57c2656$var$_104 = "._bfhk1mi6{background-color:var(--ds-background-accent-magenta-subtle,#e774bb)}";
const $dd7c8d30b57c2656$var$_103 = "._bfhk42ri{background-color:var(--ds-background-accent-magenta-subtler-pressed,#f797d2)}";
const $dd7c8d30b57c2656$var$_102 = "._bfhk1axx{background-color:var(--ds-background-accent-magenta-subtler-hovered,#fcb6e1)}";
const $dd7c8d30b57c2656$var$_101 = "._bfhkv9ra{background-color:var(--ds-background-accent-magenta-subtler,#fdd0ec)}";
const $dd7c8d30b57c2656$var$_100 = "._bfhk1ckf{background-color:var(--ds-background-accent-magenta-subtlest-pressed,#fcb6e1)}";
const $dd7c8d30b57c2656$var$_99 = "._bfhkr3zd{background-color:var(--ds-background-accent-magenta-subtlest-hovered,#fdd0ec)}";
const $dd7c8d30b57c2656$var$_98 = "._bfhk8tvm{background-color:var(--ds-background-accent-magenta-subtlest,#ffecf8)}";
const $dd7c8d30b57c2656$var$_97 = "._bfhk6cze{background-color:var(--ds-background-accent-purple-bolder-pressed,#673286)}";
const $dd7c8d30b57c2656$var$_96 = "._bfhk1af5{background-color:var(--ds-background-accent-purple-bolder-hovered,#803fa5)}";
const $dd7c8d30b57c2656$var$_95 = "._bfhkya33{background-color:var(--ds-background-accent-purple-bolder,#964ac0)}";
const $dd7c8d30b57c2656$var$_94 = "._bfhk1cd2{background-color:var(--ds-background-accent-purple-subtle-pressed,#e3bdfa)}";
const $dd7c8d30b57c2656$var$_93 = "._bfhk8bp1{background-color:var(--ds-background-accent-purple-subtle-hovered,#d8a0f7)}";
const $dd7c8d30b57c2656$var$_92 = "._bfhk18ah{background-color:var(--ds-background-accent-purple-subtle,#c97cf4)}";
const $dd7c8d30b57c2656$var$_91 = "._bfhk3nfk{background-color:var(--ds-background-accent-purple-subtler-pressed,#d8a0f7)}";
const $dd7c8d30b57c2656$var$_90 = "._bfhkattl{background-color:var(--ds-background-accent-purple-subtler-hovered,#e3bdfa)}";
const $dd7c8d30b57c2656$var$_89 = "._bfhk1nm4{background-color:var(--ds-background-accent-purple-subtler,#eed7fc)}";
const $dd7c8d30b57c2656$var$_88 = "._bfhk1jbm{background-color:var(--ds-background-accent-purple-subtlest-pressed,#e3bdfa)}";
const $dd7c8d30b57c2656$var$_87 = "._bfhkkca2{background-color:var(--ds-background-accent-purple-subtlest-hovered,#eed7fc)}";
const $dd7c8d30b57c2656$var$_86 = "._bfhkp2ly{background-color:var(--ds-background-accent-purple-subtlest,#f8eefe)}";
const $dd7c8d30b57c2656$var$_85 = "._bfhk1xwi{background-color:var(--ds-background-accent-blue-bolder-pressed,#144794)}";
const $dd7c8d30b57c2656$var$_84 = "._bfhk1vbm{background-color:var(--ds-background-accent-blue-bolder-hovered,#1558bc)}";
const $dd7c8d30b57c2656$var$_83 = "._bfhk16e3{background-color:var(--ds-background-accent-blue-bolder,#1868db)}";
const $dd7c8d30b57c2656$var$_82 = "._bfhknpx7{background-color:var(--ds-background-accent-blue-subtle-pressed,#adcbfb)}";
const $dd7c8d30b57c2656$var$_81 = "._bfhk9pr4{background-color:var(--ds-background-accent-blue-subtle-hovered,#8fb8f6)}";
const $dd7c8d30b57c2656$var$_80 = "._bfhk115i{background-color:var(--ds-background-accent-blue-subtle,#669df1)}";
const $dd7c8d30b57c2656$var$_79 = "._bfhkrwxf{background-color:var(--ds-background-accent-blue-subtler-pressed,#8fb8f6)}";
const $dd7c8d30b57c2656$var$_78 = "._bfhk815t{background-color:var(--ds-background-accent-blue-subtler-hovered,#adcbfb)}";
const $dd7c8d30b57c2656$var$_77 = "._bfhk1dy8{background-color:var(--ds-background-accent-blue-subtler,#cfe1fd)}";
const $dd7c8d30b57c2656$var$_76 = "._bfhkxm0g{background-color:var(--ds-background-accent-blue-subtlest-pressed,#adcbfb)}";
const $dd7c8d30b57c2656$var$_75 = "._bfhkdaj9{background-color:var(--ds-background-accent-blue-subtlest-hovered,#cfe1fd)}";
const $dd7c8d30b57c2656$var$_74 = "._bfhk1s93{background-color:var(--ds-background-accent-blue-subtlest,#e9f2fe)}";
const $dd7c8d30b57c2656$var$_73 = "._bfhktor0{background-color:var(--ds-background-accent-teal-bolder-pressed,#1a5265)}";
const $dd7c8d30b57c2656$var$_72 = "._bfhkl3ve{background-color:var(--ds-background-accent-teal-bolder-hovered,#206a83)}";
const $dd7c8d30b57c2656$var$_71 = "._bfhk2c8p{background-color:var(--ds-background-accent-teal-bolder,#227d9b)}";
const $dd7c8d30b57c2656$var$_70 = "._bfhk16zl{background-color:var(--ds-background-accent-teal-subtle-pressed,#b1e4f7)}";
const $dd7c8d30b57c2656$var$_69 = "._bfhkzh8h{background-color:var(--ds-background-accent-teal-subtle-hovered,#9dd9ee)}";
const $dd7c8d30b57c2656$var$_68 = "._bfhktdv8{background-color:var(--ds-background-accent-teal-subtle,#6cc3e0)}";
const $dd7c8d30b57c2656$var$_67 = "._bfhk1jb0{background-color:var(--ds-background-accent-teal-subtler-pressed,#9dd9ee)}";
const $dd7c8d30b57c2656$var$_66 = "._bfhkkwwr{background-color:var(--ds-background-accent-teal-subtler-hovered,#b1e4f7)}";
const $dd7c8d30b57c2656$var$_65 = "._bfhk1a17{background-color:var(--ds-background-accent-teal-subtler,#c6edfb)}";
const $dd7c8d30b57c2656$var$_64 = "._bfhk1cxp{background-color:var(--ds-background-accent-teal-subtlest-pressed,#b1e4f7)}";
const $dd7c8d30b57c2656$var$_63 = "._bfhk108c{background-color:var(--ds-background-accent-teal-subtlest-hovered,#c6edfb)}";
const $dd7c8d30b57c2656$var$_62 = "._bfhk7xuz{background-color:var(--ds-background-accent-teal-subtlest,#e7f9ff)}";
const $dd7c8d30b57c2656$var$_61 = "._bfhk1j68{background-color:var(--ds-background-accent-green-bolder-pressed,#19573d)}";
const $dd7c8d30b57c2656$var$_60 = "._bfhka5yi{background-color:var(--ds-background-accent-green-bolder-hovered,#216e4e)}";
const $dd7c8d30b57c2656$var$_59 = "._bfhk1e5c{background-color:var(--ds-background-accent-green-bolder,#1f845a)}";
const $dd7c8d30b57c2656$var$_58 = "._bfhk1g86{background-color:var(--ds-background-accent-green-subtle-pressed,#97edc9)}";
const $dd7c8d30b57c2656$var$_57 = "._bfhk12e3{background-color:var(--ds-background-accent-green-subtle-hovered,#7ee2b8)}";
const $dd7c8d30b57c2656$var$_56 = "._bfhk1rsu{background-color:var(--ds-background-accent-green-subtle,#4bce97)}";
const $dd7c8d30b57c2656$var$_55 = "._bfhkybhx{background-color:var(--ds-background-accent-green-subtler-pressed,#7ee2b8)}";
const $dd7c8d30b57c2656$var$_54 = "._bfhk1e2h{background-color:var(--ds-background-accent-green-subtler-hovered,#97edc9)}";
const $dd7c8d30b57c2656$var$_53 = "._bfhk1wnw{background-color:var(--ds-background-accent-green-subtler,#baf3db)}";
const $dd7c8d30b57c2656$var$_52 = "._bfhkyfny{background-color:var(--ds-background-accent-green-subtlest-pressed,#97edc9)}";
const $dd7c8d30b57c2656$var$_51 = "._bfhk3utz{background-color:var(--ds-background-accent-green-subtlest-hovered,#baf3db)}";
const $dd7c8d30b57c2656$var$_50 = "._bfhkn729{background-color:var(--ds-background-accent-green-subtlest,#dcfff1)}";
const $dd7c8d30b57c2656$var$_49 = "._bfhk1okt{background-color:var(--ds-background-accent-yellow-bolder-pressed,#614a05)}";
const $dd7c8d30b57c2656$var$_48 = "._bfhkkjqf{background-color:var(--ds-background-accent-yellow-bolder-hovered,#7f5f01)}";
const $dd7c8d30b57c2656$var$_47 = "._bfhk1vop{background-color:var(--ds-background-accent-yellow-bolder,#946f00)}";
const $dd7c8d30b57c2656$var$_46 = "._bfhk1jx0{background-color:var(--ds-background-accent-yellow-subtle-pressed,#efdd4e)}";
const $dd7c8d30b57c2656$var$_45 = "._bfhk819w{background-color:var(--ds-background-accent-yellow-subtle-hovered,#ddb30e)}";
const $dd7c8d30b57c2656$var$_44 = "._bfhk8y3s{background-color:var(--ds-background-accent-yellow-subtle,#eed12b)}";
const $dd7c8d30b57c2656$var$_43 = "._bfhk1r9w{background-color:var(--ds-background-accent-yellow-subtler-pressed,#eed12b)}";
const $dd7c8d30b57c2656$var$_42 = "._bfhk1uw7{background-color:var(--ds-background-accent-yellow-subtler-hovered,#efdd4e)}";
const $dd7c8d30b57c2656$var$_41 = "._bfhk1773{background-color:var(--ds-background-accent-yellow-subtler,#f5e989)}";
const $dd7c8d30b57c2656$var$_40 = "._bfhk1o1l{background-color:var(--ds-background-accent-yellow-subtlest-pressed,#efdd4e)}";
const $dd7c8d30b57c2656$var$_39 = "._bfhkaetg{background-color:var(--ds-background-accent-yellow-subtlest-hovered,#f5e989)}";
const $dd7c8d30b57c2656$var$_38 = "._bfhkibhp{background-color:var(--ds-background-accent-yellow-subtlest,#fef7c8)}";
const $dd7c8d30b57c2656$var$_37 = "._bfhk1fyq{background-color:var(--ds-background-accent-orange-bolder-pressed,#7a3b00)}";
const $dd7c8d30b57c2656$var$_36 = "._bfhk12qo{background-color:var(--ds-background-accent-orange-bolder-hovered,#9e4c00)}";
const $dd7c8d30b57c2656$var$_35 = "._bfhk1qg1{background-color:var(--ds-background-accent-orange-bolder,#bd5b00)}";
const $dd7c8d30b57c2656$var$_34 = "._bfhkaxpp{background-color:var(--ds-background-accent-orange-subtle-pressed,#fbd779)}";
const $dd7c8d30b57c2656$var$_33 = "._bfhk9mfs{background-color:var(--ds-background-accent-orange-subtle-hovered,#fbc828)}";
const $dd7c8d30b57c2656$var$_32 = "._bfhk1kkj{background-color:var(--ds-background-accent-orange-subtle,#fca700)}";
const $dd7c8d30b57c2656$var$_31 = "._bfhkdpo3{background-color:var(--ds-background-accent-orange-subtler-pressed,#fbc828)}";
const $dd7c8d30b57c2656$var$_30 = "._bfhk1ei0{background-color:var(--ds-background-accent-orange-subtler-hovered,#fbd779)}";
const $dd7c8d30b57c2656$var$_29 = "._bfhk165s{background-color:var(--ds-background-accent-orange-subtler,#fce4a6)}";
const $dd7c8d30b57c2656$var$_28 = "._bfhkf90x{background-color:var(--ds-background-accent-orange-subtlest-pressed,#fbd779)}";
const $dd7c8d30b57c2656$var$_27 = "._bfhk19yr{background-color:var(--ds-background-accent-orange-subtlest-hovered,#fce4a6)}";
const $dd7c8d30b57c2656$var$_26 = "._bfhkf5uh{background-color:var(--ds-background-accent-orange-subtlest,#fff5db)}";
const $dd7c8d30b57c2656$var$_25 = "._bfhk1cl6{background-color:var(--ds-background-accent-red-bolder-pressed,#872821)}";
const $dd7c8d30b57c2656$var$_24 = "._bfhk100f{background-color:var(--ds-background-accent-red-bolder-hovered,#ae2e24)}";
const $dd7c8d30b57c2656$var$_23 = "._bfhkuibq{background-color:var(--ds-background-accent-red-bolder,#c9372c)}";
const $dd7c8d30b57c2656$var$_22 = "._bfhk1fnn{background-color:var(--ds-background-accent-red-subtle-pressed,#ffb8b2)}";
const $dd7c8d30b57c2656$var$_21 = "._bfhk1sou{background-color:var(--ds-background-accent-red-subtle-hovered,#fd9891)}";
const $dd7c8d30b57c2656$var$_20 = "._bfhkkrt9{background-color:var(--ds-background-accent-red-subtle,#f87168)}";
const $dd7c8d30b57c2656$var$_19 = "._bfhk1j5a{background-color:var(--ds-background-accent-red-subtler-pressed,#fd9891)}";
const $dd7c8d30b57c2656$var$_18 = "._bfhkaffd{background-color:var(--ds-background-accent-red-subtler-hovered,#ffb8b2)}";
const $dd7c8d30b57c2656$var$_17 = "._bfhk1rtt{background-color:var(--ds-background-accent-red-subtler,#ffd5d2)}";
const $dd7c8d30b57c2656$var$_16 = "._bfhknbir{background-color:var(--ds-background-accent-red-subtlest-pressed,#ffb8b2)}";
const $dd7c8d30b57c2656$var$_15 = "._bfhk1i6i{background-color:var(--ds-background-accent-red-subtlest-hovered,#ffd5d2)}";
const $dd7c8d30b57c2656$var$_14 = "._bfhk1vk5{background-color:var(--ds-background-accent-red-subtlest,#ffeceb)}";
const $dd7c8d30b57c2656$var$_13 = "._bfhkh0j0{background-color:var(--ds-background-accent-lime-bolder-pressed,#3f5224)}";
const $dd7c8d30b57c2656$var$_12 = "._bfhknzpa{background-color:var(--ds-background-accent-lime-bolder-hovered,#4c6b1f)}";
const $dd7c8d30b57c2656$var$_11 = "._bfhktde4{background-color:var(--ds-background-accent-lime-bolder,#5b7f24)}";
const $dd7c8d30b57c2656$var$_10 = "._bfhk1jbd{background-color:var(--ds-background-accent-lime-subtle-pressed,#bde97c)}";
const $dd7c8d30b57c2656$var$_1 = "._bfhkfoww{background-color:var(--ds-background-accent-lime-subtle-hovered,#b3df72)}";
const $dd7c8d30b57c2656$var$_0 = "._bfhkbq5w{background-color:var(--ds-background-accent-lime-subtle,#94c748)}";
const $dd7c8d30b57c2656$var$_9 = "._bfhk2kxc{background-color:var(--ds-background-accent-lime-subtler-pressed,#b3df72)}";
const $dd7c8d30b57c2656$var$_8 = "._bfhk1gf0{background-color:var(--ds-background-accent-lime-subtler-hovered,#bde97c)}";
const $dd7c8d30b57c2656$var$_7 = "._bfhkz2ec{background-color:var(--ds-background-accent-lime-subtler,#d3f1a7)}";
const $dd7c8d30b57c2656$var$_6 = "._bfhkkuup{background-color:var(--ds-background-accent-lime-subtlest-pressed,#bde97c)}";
const $dd7c8d30b57c2656$var$_5 = "._bfhkd4y8{background-color:var(--ds-background-accent-lime-subtlest-hovered,#d3f1a7)}";
const $dd7c8d30b57c2656$var$_4 = "._bfhkm890{background-color:var(--ds-background-accent-lime-subtlest,#efffd6)}";
const $dd7c8d30b57c2656$var$_3 = "._r06hglyw{-webkit-appearance:none;-moz-appearance:none;appearance:none}";
const $dd7c8d30b57c2656$var$_2 = "._vchhusvi{box-sizing:border-box}";
const $dd7c8d30b57c2656$var$_ = "._19itglyw{border:none}";
const $dd7c8d30b57c2656$var$baseStyles = null;
const $dd7c8d30b57c2656$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhk187o",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
const $dd7c8d30b57c2656$var$CURRENT_SURFACE_CSS_VAR = `--ds-elevation-surface-current`;
const $dd7c8d30b57c2656$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
const $dd7c8d30b57c2656$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
const $dd7c8d30b57c2656$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
const $dd7c8d30b57c2656$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
const $dd7c8d30b57c2656$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
}; /**
    * __Box__
    *
    * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
    * Renders a `div` by default.
    *
    * - [Examples](https://atlassian.design/components/primitives/box/examples)
    * - [Code](https://atlassian.design/components/primitives/box/code)
    * - [Usage](https://atlassian.design/components/primitives/box/usage)
    */ 
const $dd7c8d30b57c2656$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock = padding, paddingBlockStart: paddingBlockStart = paddingBlock, paddingBlockEnd: paddingBlockEnd = paddingBlock, paddingInline: paddingInline = padding, paddingInlineStart: paddingInlineStart = paddingInline, paddingInlineEnd: paddingInlineEnd = paddingInline, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const node = /*#__PURE__*/ // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $dd7c8d30b57c2656$var$_,
                    $dd7c8d30b57c2656$var$_2,
                    $dd7c8d30b57c2656$var$_3,
                    $dd7c8d30b57c2656$var$_4,
                    $dd7c8d30b57c2656$var$_5,
                    $dd7c8d30b57c2656$var$_6,
                    $dd7c8d30b57c2656$var$_7,
                    $dd7c8d30b57c2656$var$_8,
                    $dd7c8d30b57c2656$var$_9,
                    $dd7c8d30b57c2656$var$_0,
                    $dd7c8d30b57c2656$var$_1,
                    $dd7c8d30b57c2656$var$_10,
                    $dd7c8d30b57c2656$var$_11,
                    $dd7c8d30b57c2656$var$_12,
                    $dd7c8d30b57c2656$var$_13,
                    $dd7c8d30b57c2656$var$_14,
                    $dd7c8d30b57c2656$var$_15,
                    $dd7c8d30b57c2656$var$_16,
                    $dd7c8d30b57c2656$var$_17,
                    $dd7c8d30b57c2656$var$_18,
                    $dd7c8d30b57c2656$var$_19,
                    $dd7c8d30b57c2656$var$_20,
                    $dd7c8d30b57c2656$var$_21,
                    $dd7c8d30b57c2656$var$_22,
                    $dd7c8d30b57c2656$var$_23,
                    $dd7c8d30b57c2656$var$_24,
                    $dd7c8d30b57c2656$var$_25,
                    $dd7c8d30b57c2656$var$_26,
                    $dd7c8d30b57c2656$var$_27,
                    $dd7c8d30b57c2656$var$_28,
                    $dd7c8d30b57c2656$var$_29,
                    $dd7c8d30b57c2656$var$_30,
                    $dd7c8d30b57c2656$var$_31,
                    $dd7c8d30b57c2656$var$_32,
                    $dd7c8d30b57c2656$var$_33,
                    $dd7c8d30b57c2656$var$_34,
                    $dd7c8d30b57c2656$var$_35,
                    $dd7c8d30b57c2656$var$_36,
                    $dd7c8d30b57c2656$var$_37,
                    $dd7c8d30b57c2656$var$_38,
                    $dd7c8d30b57c2656$var$_39,
                    $dd7c8d30b57c2656$var$_40,
                    $dd7c8d30b57c2656$var$_41,
                    $dd7c8d30b57c2656$var$_42,
                    $dd7c8d30b57c2656$var$_43,
                    $dd7c8d30b57c2656$var$_44,
                    $dd7c8d30b57c2656$var$_45,
                    $dd7c8d30b57c2656$var$_46,
                    $dd7c8d30b57c2656$var$_47,
                    $dd7c8d30b57c2656$var$_48,
                    $dd7c8d30b57c2656$var$_49,
                    $dd7c8d30b57c2656$var$_50,
                    $dd7c8d30b57c2656$var$_51,
                    $dd7c8d30b57c2656$var$_52,
                    $dd7c8d30b57c2656$var$_53,
                    $dd7c8d30b57c2656$var$_54,
                    $dd7c8d30b57c2656$var$_55,
                    $dd7c8d30b57c2656$var$_56,
                    $dd7c8d30b57c2656$var$_57,
                    $dd7c8d30b57c2656$var$_58,
                    $dd7c8d30b57c2656$var$_59,
                    $dd7c8d30b57c2656$var$_60,
                    $dd7c8d30b57c2656$var$_61,
                    $dd7c8d30b57c2656$var$_62,
                    $dd7c8d30b57c2656$var$_63,
                    $dd7c8d30b57c2656$var$_64,
                    $dd7c8d30b57c2656$var$_65,
                    $dd7c8d30b57c2656$var$_66,
                    $dd7c8d30b57c2656$var$_67,
                    $dd7c8d30b57c2656$var$_68,
                    $dd7c8d30b57c2656$var$_69,
                    $dd7c8d30b57c2656$var$_70,
                    $dd7c8d30b57c2656$var$_71,
                    $dd7c8d30b57c2656$var$_72,
                    $dd7c8d30b57c2656$var$_73,
                    $dd7c8d30b57c2656$var$_74,
                    $dd7c8d30b57c2656$var$_75,
                    $dd7c8d30b57c2656$var$_76,
                    $dd7c8d30b57c2656$var$_77,
                    $dd7c8d30b57c2656$var$_78,
                    $dd7c8d30b57c2656$var$_79,
                    $dd7c8d30b57c2656$var$_80,
                    $dd7c8d30b57c2656$var$_81,
                    $dd7c8d30b57c2656$var$_82,
                    $dd7c8d30b57c2656$var$_83,
                    $dd7c8d30b57c2656$var$_84,
                    $dd7c8d30b57c2656$var$_85,
                    $dd7c8d30b57c2656$var$_86,
                    $dd7c8d30b57c2656$var$_87,
                    $dd7c8d30b57c2656$var$_88,
                    $dd7c8d30b57c2656$var$_89,
                    $dd7c8d30b57c2656$var$_90,
                    $dd7c8d30b57c2656$var$_91,
                    $dd7c8d30b57c2656$var$_92,
                    $dd7c8d30b57c2656$var$_93,
                    $dd7c8d30b57c2656$var$_94,
                    $dd7c8d30b57c2656$var$_95,
                    $dd7c8d30b57c2656$var$_96,
                    $dd7c8d30b57c2656$var$_97,
                    $dd7c8d30b57c2656$var$_98,
                    $dd7c8d30b57c2656$var$_99,
                    $dd7c8d30b57c2656$var$_100,
                    $dd7c8d30b57c2656$var$_101,
                    $dd7c8d30b57c2656$var$_102,
                    $dd7c8d30b57c2656$var$_103,
                    $dd7c8d30b57c2656$var$_104,
                    $dd7c8d30b57c2656$var$_105,
                    $dd7c8d30b57c2656$var$_106,
                    $dd7c8d30b57c2656$var$_107,
                    $dd7c8d30b57c2656$var$_108,
                    $dd7c8d30b57c2656$var$_109,
                    $dd7c8d30b57c2656$var$_110,
                    $dd7c8d30b57c2656$var$_111,
                    $dd7c8d30b57c2656$var$_112,
                    $dd7c8d30b57c2656$var$_113,
                    $dd7c8d30b57c2656$var$_114,
                    $dd7c8d30b57c2656$var$_115,
                    $dd7c8d30b57c2656$var$_116,
                    $dd7c8d30b57c2656$var$_117,
                    $dd7c8d30b57c2656$var$_118,
                    $dd7c8d30b57c2656$var$_119,
                    $dd7c8d30b57c2656$var$_120,
                    $dd7c8d30b57c2656$var$_121,
                    $dd7c8d30b57c2656$var$_122,
                    $dd7c8d30b57c2656$var$_123,
                    $dd7c8d30b57c2656$var$_124,
                    $dd7c8d30b57c2656$var$_125,
                    $dd7c8d30b57c2656$var$_126,
                    $dd7c8d30b57c2656$var$_127,
                    $dd7c8d30b57c2656$var$_128,
                    $dd7c8d30b57c2656$var$_129,
                    $dd7c8d30b57c2656$var$_130,
                    $dd7c8d30b57c2656$var$_131,
                    $dd7c8d30b57c2656$var$_132,
                    $dd7c8d30b57c2656$var$_133,
                    $dd7c8d30b57c2656$var$_134,
                    $dd7c8d30b57c2656$var$_135,
                    $dd7c8d30b57c2656$var$_136,
                    $dd7c8d30b57c2656$var$_137,
                    $dd7c8d30b57c2656$var$_138,
                    $dd7c8d30b57c2656$var$_139,
                    $dd7c8d30b57c2656$var$_140,
                    $dd7c8d30b57c2656$var$_141,
                    $dd7c8d30b57c2656$var$_142,
                    $dd7c8d30b57c2656$var$_143,
                    $dd7c8d30b57c2656$var$_144,
                    $dd7c8d30b57c2656$var$_145,
                    $dd7c8d30b57c2656$var$_146,
                    $dd7c8d30b57c2656$var$_147,
                    $dd7c8d30b57c2656$var$_148,
                    $dd7c8d30b57c2656$var$_149,
                    $dd7c8d30b57c2656$var$_150,
                    $dd7c8d30b57c2656$var$_151,
                    $dd7c8d30b57c2656$var$_152,
                    $dd7c8d30b57c2656$var$_153,
                    $dd7c8d30b57c2656$var$_154,
                    $dd7c8d30b57c2656$var$_155,
                    $dd7c8d30b57c2656$var$_156,
                    $dd7c8d30b57c2656$var$_157,
                    $dd7c8d30b57c2656$var$_158,
                    $dd7c8d30b57c2656$var$_159,
                    $dd7c8d30b57c2656$var$_160,
                    $dd7c8d30b57c2656$var$_161,
                    $dd7c8d30b57c2656$var$_162,
                    $dd7c8d30b57c2656$var$_163,
                    $dd7c8d30b57c2656$var$_164,
                    $dd7c8d30b57c2656$var$_165,
                    $dd7c8d30b57c2656$var$_166,
                    $dd7c8d30b57c2656$var$_167,
                    $dd7c8d30b57c2656$var$_168,
                    $dd7c8d30b57c2656$var$_169,
                    $dd7c8d30b57c2656$var$_170,
                    $dd7c8d30b57c2656$var$_171,
                    $dd7c8d30b57c2656$var$_172,
                    $dd7c8d30b57c2656$var$_173,
                    $dd7c8d30b57c2656$var$_174,
                    $dd7c8d30b57c2656$var$_175,
                    $dd7c8d30b57c2656$var$_176,
                    $dd7c8d30b57c2656$var$_177,
                    $dd7c8d30b57c2656$var$_178,
                    $dd7c8d30b57c2656$var$_179,
                    $dd7c8d30b57c2656$var$_180,
                    $dd7c8d30b57c2656$var$_181,
                    $dd7c8d30b57c2656$var$_182,
                    $dd7c8d30b57c2656$var$_183,
                    $dd7c8d30b57c2656$var$_184,
                    $dd7c8d30b57c2656$var$_185,
                    $dd7c8d30b57c2656$var$_186,
                    $dd7c8d30b57c2656$var$_187,
                    $dd7c8d30b57c2656$var$_188,
                    $dd7c8d30b57c2656$var$_189,
                    $dd7c8d30b57c2656$var$_190,
                    $dd7c8d30b57c2656$var$_191,
                    $dd7c8d30b57c2656$var$_192,
                    $dd7c8d30b57c2656$var$_193,
                    $dd7c8d30b57c2656$var$_194,
                    $dd7c8d30b57c2656$var$_195,
                    $dd7c8d30b57c2656$var$_196,
                    $dd7c8d30b57c2656$var$_197,
                    $dd7c8d30b57c2656$var$_198,
                    $dd7c8d30b57c2656$var$_199,
                    $dd7c8d30b57c2656$var$_200,
                    $dd7c8d30b57c2656$var$_201,
                    $dd7c8d30b57c2656$var$_202,
                    $dd7c8d30b57c2656$var$_203,
                    $dd7c8d30b57c2656$var$_204,
                    $dd7c8d30b57c2656$var$_205,
                    $dd7c8d30b57c2656$var$_206,
                    $dd7c8d30b57c2656$var$_207,
                    $dd7c8d30b57c2656$var$_208,
                    $dd7c8d30b57c2656$var$_209,
                    $dd7c8d30b57c2656$var$_210,
                    $dd7c8d30b57c2656$var$_211,
                    $dd7c8d30b57c2656$var$_212,
                    $dd7c8d30b57c2656$var$_213,
                    $dd7c8d30b57c2656$var$_214,
                    $dd7c8d30b57c2656$var$_215,
                    $dd7c8d30b57c2656$var$_216,
                    $dd7c8d30b57c2656$var$_217,
                    $dd7c8d30b57c2656$var$_218,
                    $dd7c8d30b57c2656$var$_219,
                    $dd7c8d30b57c2656$var$_220,
                    $dd7c8d30b57c2656$var$_221,
                    $dd7c8d30b57c2656$var$_222,
                    $dd7c8d30b57c2656$var$_223,
                    $dd7c8d30b57c2656$var$_224,
                    $dd7c8d30b57c2656$var$_225,
                    $dd7c8d30b57c2656$var$_226,
                    $dd7c8d30b57c2656$var$_227,
                    $dd7c8d30b57c2656$var$_228,
                    $dd7c8d30b57c2656$var$_229,
                    $dd7c8d30b57c2656$var$_230,
                    $dd7c8d30b57c2656$var$_231,
                    $dd7c8d30b57c2656$var$_232,
                    $dd7c8d30b57c2656$var$_233,
                    $dd7c8d30b57c2656$var$_234,
                    $dd7c8d30b57c2656$var$_235,
                    $dd7c8d30b57c2656$var$_236,
                    $dd7c8d30b57c2656$var$_237,
                    $dd7c8d30b57c2656$var$_238,
                    $dd7c8d30b57c2656$var$_239,
                    $dd7c8d30b57c2656$var$_240,
                    $dd7c8d30b57c2656$var$_241,
                    $dd7c8d30b57c2656$var$_242,
                    $dd7c8d30b57c2656$var$_243,
                    $dd7c8d30b57c2656$var$_244,
                    $dd7c8d30b57c2656$var$_245,
                    $dd7c8d30b57c2656$var$_246,
                    $dd7c8d30b57c2656$var$_247,
                    $dd7c8d30b57c2656$var$_248,
                    $dd7c8d30b57c2656$var$_249,
                    $dd7c8d30b57c2656$var$_250,
                    $dd7c8d30b57c2656$var$_251,
                    $dd7c8d30b57c2656$var$_252,
                    $dd7c8d30b57c2656$var$_253,
                    $dd7c8d30b57c2656$var$_254,
                    $dd7c8d30b57c2656$var$_255,
                    $dd7c8d30b57c2656$var$_256,
                    $dd7c8d30b57c2656$var$_257,
                    $dd7c8d30b57c2656$var$_258,
                    $dd7c8d30b57c2656$var$_259,
                    $dd7c8d30b57c2656$var$_260,
                    $dd7c8d30b57c2656$var$_261,
                    $dd7c8d30b57c2656$var$_262,
                    $dd7c8d30b57c2656$var$_263,
                    $dd7c8d30b57c2656$var$_264
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)(Component, {
                style: style // @ts-ignore -- Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
                ,
                ref: ref,
                className: (0, $hMvDh.default)([
                    "_19itglyw _vchhusvi _r06hglyw",
                    backgroundColor && $dd7c8d30b57c2656$var$backgroundColorMap[backgroundColor],
                    backgroundColor && $dd7c8d30b57c2656$var$isSurfaceToken(backgroundColor) && $dd7c8d30b57c2656$var$setSurfaceTokenMap[backgroundColor],
                    paddingBlockStart && $dd7c8d30b57c2656$var$paddingBlockStartMap[paddingBlockStart],
                    paddingBlockEnd && $dd7c8d30b57c2656$var$paddingBlockEndMap[paddingBlockEnd],
                    paddingInlineStart && $dd7c8d30b57c2656$var$paddingInlineStartMap[paddingInlineStart],
                    paddingInlineEnd && $dd7c8d30b57c2656$var$paddingInlineEndMap[paddingInlineEnd],
                    xcss
                ]),
                ...safeHtmlAttributes,
                "data-testid": testId,
                children: children
            })
        ]
    });
    if (backgroundColor) return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kH2JL.SurfaceContext).Provider, {
        value: backgroundColor,
        children: node
    });
    return node;
} // The return type of `BoxComponent` does not match the return type of `forwardRef` in React 18
);
function $dd7c8d30b57c2656$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $dd7c8d30b57c2656$var$setSurfaceTokenMap;
}

});

parcelRegister("bkr3m", function(module, exports) {
$parcel$export(module.exports, "Inline", () => $f3bfc9214b5b00ff$export$fbae5b5ffd8af05e);
/* inline.tsx generated by @compiled/babel-plugin v3.0.2 */ /* inline.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $ky45w = parcelRequire("ky45w");

var $iZBEG = parcelRequire("iZBEG");

var $kIqwl = parcelRequire("kIqwl");
const $f3bfc9214b5b00ff$var$_8 = "._16jlkb7n{flex-grow:1}";
const $f3bfc9214b5b00ff$var$_7 = "._1bsb1osq{width:100%}";
const $f3bfc9214b5b00ff$var$_6 = "._16jlidpf{flex-grow:0}";
const $f3bfc9214b5b00ff$var$_5 = "._uiztglyw{-webkit-user-select:none;-moz-user-select:none;user-select:none}";
const $f3bfc9214b5b00ff$var$_4 = "._lcxvglyw{pointer-events:none}";
const $f3bfc9214b5b00ff$var$_3 = "._syazjjyb{color:var(--ds-text-subtle,#42526e)}";
const $f3bfc9214b5b00ff$var$_2 = "._195g1i6y{margin-inline:var(--ds-space-negative-025,-2px)}";
const $f3bfc9214b5b00ff$var$_ = "._1mouze3t{margin-block:var(--ds-space-0,0)}";
const $f3bfc9214b5b00ff$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $f3bfc9214b5b00ff$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $f3bfc9214b5b00ff$var$_,
                    $f3bfc9214b5b00ff$var$_2,
                    $f3bfc9214b5b00ff$var$_3,
                    $f3bfc9214b5b00ff$var$_4,
                    $f3bfc9214b5b00ff$var$_5,
                    $f3bfc9214b5b00ff$var$_6,
                    $f3bfc9214b5b00ff$var$_7,
                    $f3bfc9214b5b00ff$var$_8
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
                className: (0, $hMvDh.default)([
                    $f3bfc9214b5b00ff$var$styles.separator
                ]),
                children: children
            })
        ]
    }); /**
     * __Inline__
     *
     * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
     *
     * @example
     * ```tsx
     *  <Inline>
     *    <Box padding="space.100" backgroundColor="neutral"></Box>
     *    <Box padding="space.100" backgroundColor="neutral"></Box>
     *  </Inline>
     * ```
     *
     */ 
const $f3bfc9214b5b00ff$export$fbae5b5ffd8af05e = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren, ...ariaAttributes }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $kIqwl.jsx)($f3bfc9214b5b00ff$var$Separator, {
        children: separator
    }) : separator;
    const children = separatorComponent ? (0, $1v5pe.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $1v5pe.Fragment), {
            children: [
                separator && index > 0 ? separatorComponent : null,
                child
            ]
        }, index);
    }) : rawChildren;
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $f3bfc9214b5b00ff$var$_,
                    $f3bfc9214b5b00ff$var$_2,
                    $f3bfc9214b5b00ff$var$_3,
                    $f3bfc9214b5b00ff$var$_4,
                    $f3bfc9214b5b00ff$var$_5,
                    $f3bfc9214b5b00ff$var$_6,
                    $f3bfc9214b5b00ff$var$_7,
                    $f3bfc9214b5b00ff$var$_8
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $iZBEG.Flex), {
                ...ariaAttributes,
                as: as,
                role: role,
                alignItems: alignItems,
                justifyContent: spread || alignInline,
                direction: "row",
                gap: space,
                rowGap: rowSpace,
                wrap: shouldWrap ? 'wrap' : undefined,
                xcss: (0, $ky45w.cx)(grow === 'hug' && $f3bfc9214b5b00ff$var$styles.hug, grow === 'fill' && $f3bfc9214b5b00ff$var$styles.fill, xcss),
                testId: testId,
                ref: ref,
                children: children
            })
        ]
    });
}));
$f3bfc9214b5b00ff$export$fbae5b5ffd8af05e.displayName = 'Inline';

});
parcelRegister("ky45w", function(module, exports) {
$parcel$export(module.exports, "cx", () => $1d8a80fb263f7599$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ parcelRequire("1v5pe");

var $eTtS7 = parcelRequire("eTtS7");
const $1d8a80fb263f7599$var$strictApi = (0, $eTtS7.createStrictAPI)();
const $1d8a80fb263f7599$export$dbf350e5966cf602 = $1d8a80fb263f7599$var$strictApi.css;
const $1d8a80fb263f7599$export$eb1ecd84a24ee424 = $1d8a80fb263f7599$var$strictApi.cssMap;
$1d8a80fb263f7599$var$strictApi.cssMap;
const $1d8a80fb263f7599$export$a274e22fb40f762e = $1d8a80fb263f7599$var$strictApi.cx;
const $1d8a80fb263f7599$var$XCSSProp = $1d8a80fb263f7599$var$strictApi.XCSSProp;

});
parcelRegister("eTtS7", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", () => $ad7d5fb26eb33771$export$39716b4af53f4ad);

var $gDf1S = parcelRequire("gDf1S");

var $hGIzV = parcelRequire("hGIzV");
function $ad7d5fb26eb33771$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $gDf1S.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $gDf1S.createStrictSetupError)();
        },
        cx: $hGIzV.cx,
        XCSSProp () {
            throw (0, $gDf1S.createStrictSetupError)();
        }
    };
}

});
parcelRegister("gDf1S", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", () => $c1bbf258741050ab$export$c4df1cb0c2b4d77c);
const $c1bbf258741050ab$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $c1bbf258741050ab$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("hGIzV", function(module, exports) {
$parcel$export(module.exports, "cx", () => $ce08f04945169e71$export$a274e22fb40f762e);

var $hMvDh = parcelRequire("hMvDh");
const $ce08f04945169e71$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $hMvDh.default)(actualStyles);
};

});



parcelRegister("iZBEG", function(module, exports) {
$parcel$export(module.exports, "Flex", () => $bb3fac02b5bcd5f0$export$f51f4c4ede09e011);
/* flex.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $kIqwl = parcelRequire("kIqwl");
const $bb3fac02b5bcd5f0$var$_58 = "._1n261q9c{flex-wrap:nowrap}";
const $bb3fac02b5bcd5f0$var$_57 = "._1n261g80{flex-wrap:wrap}";
const $bb3fac02b5bcd5f0$var$_56 = "._1bah1fhb{justify-content:stretch}";
const $bb3fac02b5bcd5f0$var$_55 = "._1bahitcz{justify-content:space-evenly}";
const $bb3fac02b5bcd5f0$var$_54 = "._1bah1b1v{justify-content:space-around}";
const $bb3fac02b5bcd5f0$var$_53 = "._1bah1yb4{justify-content:space-between}";
const $bb3fac02b5bcd5f0$var$_52 = "._1bahh9n0{justify-content:end}";
const $bb3fac02b5bcd5f0$var$_51 = "._1bah1h6o{justify-content:center}";
const $bb3fac02b5bcd5f0$var$_50 = "._1bahv2br{justify-content:start}";
const $bb3fac02b5bcd5f0$var$_49 = "._2lx2vrvc{flex-direction:row}";
const $bb3fac02b5bcd5f0$var$_48 = "._2lx21bp4{flex-direction:column}";
const $bb3fac02b5bcd5f0$var$_47 = "._4cvr1fhb{align-items:stretch}";
const $bb3fac02b5bcd5f0$var$_46 = "._4cvrh9n0{align-items:end}";
const $bb3fac02b5bcd5f0$var$_45 = "._4cvr1q9y{align-items:baseline}";
const $bb3fac02b5bcd5f0$var$_44 = "._4cvr1h6o{align-items:center}";
const $bb3fac02b5bcd5f0$var$_43 = "._4cvrv2br{align-items:start}";
const $bb3fac02b5bcd5f0$var$_42 = "._1p57rdp2{row-gap:var(--ds-space-gap-xxlarge,24px)}";
const $bb3fac02b5bcd5f0$var$_41 = "._1p571a4g{row-gap:var(--ds-space-gap-xlarge,1pc)}";
const $bb3fac02b5bcd5f0$var$_40 = "._1p571l0c{row-gap:var(--ds-space-gap-large,9pt)}";
const $bb3fac02b5bcd5f0$var$_39 = "._1p57slki{row-gap:var(--ds-space-gap-medium,8px)}";
const $bb3fac02b5bcd5f0$var$_38 = "._1p57e2kt{row-gap:var(--ds-space-gap-small,6px)}";
const $bb3fac02b5bcd5f0$var$_37 = "._1p57t24t{row-gap:var(--ds-space-gap-xsmall,4px)}";
const $bb3fac02b5bcd5f0$var$_36 = "._1p571j29{row-gap:var(--ds-space-gap-xxsmall,2px)}";
const $bb3fac02b5bcd5f0$var$_35 = "._1p571epz{row-gap:var(--ds-space-1000,5pc)}";
const $bb3fac02b5bcd5f0$var$_34 = "._1p57xncg{row-gap:var(--ds-space-800,4pc)}";
const $bb3fac02b5bcd5f0$var$_33 = "._1p57oahv{row-gap:var(--ds-space-600,3pc)}";
const $bb3fac02b5bcd5f0$var$_32 = "._1p571jfw{row-gap:var(--ds-space-500,40px)}";
const $bb3fac02b5bcd5f0$var$_31 = "._1p57xy5q{row-gap:var(--ds-space-400,2pc)}";
const $bb3fac02b5bcd5f0$var$_30 = "._1p571ejb{row-gap:var(--ds-space-300,24px)}";
const $bb3fac02b5bcd5f0$var$_29 = "._1p57v47k{row-gap:var(--ds-space-250,20px)}";
const $bb3fac02b5bcd5f0$var$_28 = "._1p57pxbi{row-gap:var(--ds-space-200,1pc)}";
const $bb3fac02b5bcd5f0$var$_27 = "._1p57utpp{row-gap:var(--ds-space-150,9pt)}";
const $bb3fac02b5bcd5f0$var$_26 = "._1p57u2gc{row-gap:var(--ds-space-100,8px)}";
const $bb3fac02b5bcd5f0$var$_25 = "._1p5712x7{row-gap:var(--ds-space-075,6px)}";
const $bb3fac02b5bcd5f0$var$_24 = "._1p571b66{row-gap:var(--ds-space-050,4px)}";
const $bb3fac02b5bcd5f0$var$_23 = "._1p57v77o{row-gap:var(--ds-space-025,2px)}";
const $bb3fac02b5bcd5f0$var$_22 = "._1p57ze3t{row-gap:var(--ds-space-0,0)}";
const $bb3fac02b5bcd5f0$var$_21 = "._gy1prdp2{-moz-column-gap:var(--ds-space-gap-xxlarge,24px);column-gap:var(--ds-space-gap-xxlarge,24px)}";
const $bb3fac02b5bcd5f0$var$_20 = "._gy1p1a4g{-moz-column-gap:var(--ds-space-gap-xlarge,1pc);column-gap:var(--ds-space-gap-xlarge,1pc)}";
const $bb3fac02b5bcd5f0$var$_19 = "._gy1p1l0c{-moz-column-gap:var(--ds-space-gap-large,9pt);column-gap:var(--ds-space-gap-large,9pt)}";
const $bb3fac02b5bcd5f0$var$_18 = "._gy1pslki{-moz-column-gap:var(--ds-space-gap-medium,8px);column-gap:var(--ds-space-gap-medium,8px)}";
const $bb3fac02b5bcd5f0$var$_17 = "._gy1pe2kt{-moz-column-gap:var(--ds-space-gap-small,6px);column-gap:var(--ds-space-gap-small,6px)}";
const $bb3fac02b5bcd5f0$var$_16 = "._gy1pt24t{-moz-column-gap:var(--ds-space-gap-xsmall,4px);column-gap:var(--ds-space-gap-xsmall,4px)}";
const $bb3fac02b5bcd5f0$var$_15 = "._gy1p1j29{-moz-column-gap:var(--ds-space-gap-xxsmall,2px);column-gap:var(--ds-space-gap-xxsmall,2px)}";
const $bb3fac02b5bcd5f0$var$_14 = "._gy1p1epz{-moz-column-gap:var(--ds-space-1000,5pc);column-gap:var(--ds-space-1000,5pc)}";
const $bb3fac02b5bcd5f0$var$_13 = "._gy1pxncg{-moz-column-gap:var(--ds-space-800,4pc);column-gap:var(--ds-space-800,4pc)}";
const $bb3fac02b5bcd5f0$var$_12 = "._gy1poahv{-moz-column-gap:var(--ds-space-600,3pc);column-gap:var(--ds-space-600,3pc)}";
const $bb3fac02b5bcd5f0$var$_11 = "._gy1p1jfw{-moz-column-gap:var(--ds-space-500,40px);column-gap:var(--ds-space-500,40px)}";
const $bb3fac02b5bcd5f0$var$_10 = "._gy1pxy5q{-moz-column-gap:var(--ds-space-400,2pc);column-gap:var(--ds-space-400,2pc)}";
const $bb3fac02b5bcd5f0$var$_1 = "._gy1p1ejb{-moz-column-gap:var(--ds-space-300,24px);column-gap:var(--ds-space-300,24px)}";
const $bb3fac02b5bcd5f0$var$_0 = "._gy1pv47k{-moz-column-gap:var(--ds-space-250,20px);column-gap:var(--ds-space-250,20px)}";
const $bb3fac02b5bcd5f0$var$_9 = "._gy1ppxbi{-moz-column-gap:var(--ds-space-200,1pc);column-gap:var(--ds-space-200,1pc)}";
const $bb3fac02b5bcd5f0$var$_8 = "._gy1putpp{-moz-column-gap:var(--ds-space-150,9pt);column-gap:var(--ds-space-150,9pt)}";
const $bb3fac02b5bcd5f0$var$_7 = "._gy1pu2gc{-moz-column-gap:var(--ds-space-100,8px);column-gap:var(--ds-space-100,8px)}";
const $bb3fac02b5bcd5f0$var$_6 = "._gy1p12x7{-moz-column-gap:var(--ds-space-075,6px);column-gap:var(--ds-space-075,6px)}";
const $bb3fac02b5bcd5f0$var$_5 = "._gy1p1b66{-moz-column-gap:var(--ds-space-050,4px);column-gap:var(--ds-space-050,4px)}";
const $bb3fac02b5bcd5f0$var$_4 = "._gy1pv77o{-moz-column-gap:var(--ds-space-025,2px);column-gap:var(--ds-space-025,2px)}";
const $bb3fac02b5bcd5f0$var$_3 = "._gy1pze3t{-moz-column-gap:var(--ds-space-0,0);column-gap:var(--ds-space-0,0)}";
const $bb3fac02b5bcd5f0$var$_2 = "._vchhusvi{box-sizing:border-box}";
const $bb3fac02b5bcd5f0$var$_ = "._1e0c1txw{display:flex}";
const $bb3fac02b5bcd5f0$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz",
    'space.gap.xxsmall': "_1p571j29",
    'space.gap.xsmall': "_1p57t24t",
    'space.gap.small': "_1p57e2kt",
    'space.gap.medium': "_1p57slki",
    'space.gap.large': "_1p571l0c",
    'space.gap.xlarge': "_1p571a4g",
    'space.gap.xxlarge': "_1p57rdp2"
};
const $bb3fac02b5bcd5f0$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz",
    'space.gap.xxsmall': "_gy1p1j29",
    'space.gap.xsmall': "_gy1pt24t",
    'space.gap.small': "_gy1pe2kt",
    'space.gap.medium': "_gy1pslki",
    'space.gap.large': "_gy1p1l0c",
    'space.gap.xlarge': "_gy1p1a4g",
    'space.gap.xxlarge': "_gy1prdp2"
};
const $bb3fac02b5bcd5f0$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $bb3fac02b5bcd5f0$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const $bb3fac02b5bcd5f0$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const $bb3fac02b5bcd5f0$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $bb3fac02b5bcd5f0$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
const $bb3fac02b5bcd5f0$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $bb3fac02b5bcd5f0$var$_,
                    $bb3fac02b5bcd5f0$var$_2,
                    $bb3fac02b5bcd5f0$var$_3,
                    $bb3fac02b5bcd5f0$var$_4,
                    $bb3fac02b5bcd5f0$var$_5,
                    $bb3fac02b5bcd5f0$var$_6,
                    $bb3fac02b5bcd5f0$var$_7,
                    $bb3fac02b5bcd5f0$var$_8,
                    $bb3fac02b5bcd5f0$var$_9,
                    $bb3fac02b5bcd5f0$var$_0,
                    $bb3fac02b5bcd5f0$var$_1,
                    $bb3fac02b5bcd5f0$var$_10,
                    $bb3fac02b5bcd5f0$var$_11,
                    $bb3fac02b5bcd5f0$var$_12,
                    $bb3fac02b5bcd5f0$var$_13,
                    $bb3fac02b5bcd5f0$var$_14,
                    $bb3fac02b5bcd5f0$var$_15,
                    $bb3fac02b5bcd5f0$var$_16,
                    $bb3fac02b5bcd5f0$var$_17,
                    $bb3fac02b5bcd5f0$var$_18,
                    $bb3fac02b5bcd5f0$var$_19,
                    $bb3fac02b5bcd5f0$var$_20,
                    $bb3fac02b5bcd5f0$var$_21,
                    $bb3fac02b5bcd5f0$var$_22,
                    $bb3fac02b5bcd5f0$var$_23,
                    $bb3fac02b5bcd5f0$var$_24,
                    $bb3fac02b5bcd5f0$var$_25,
                    $bb3fac02b5bcd5f0$var$_26,
                    $bb3fac02b5bcd5f0$var$_27,
                    $bb3fac02b5bcd5f0$var$_28,
                    $bb3fac02b5bcd5f0$var$_29,
                    $bb3fac02b5bcd5f0$var$_30,
                    $bb3fac02b5bcd5f0$var$_31,
                    $bb3fac02b5bcd5f0$var$_32,
                    $bb3fac02b5bcd5f0$var$_33,
                    $bb3fac02b5bcd5f0$var$_34,
                    $bb3fac02b5bcd5f0$var$_35,
                    $bb3fac02b5bcd5f0$var$_36,
                    $bb3fac02b5bcd5f0$var$_37,
                    $bb3fac02b5bcd5f0$var$_38,
                    $bb3fac02b5bcd5f0$var$_39,
                    $bb3fac02b5bcd5f0$var$_40,
                    $bb3fac02b5bcd5f0$var$_41,
                    $bb3fac02b5bcd5f0$var$_42,
                    $bb3fac02b5bcd5f0$var$_43,
                    $bb3fac02b5bcd5f0$var$_44,
                    $bb3fac02b5bcd5f0$var$_45,
                    $bb3fac02b5bcd5f0$var$_46,
                    $bb3fac02b5bcd5f0$var$_47,
                    $bb3fac02b5bcd5f0$var$_48,
                    $bb3fac02b5bcd5f0$var$_49,
                    $bb3fac02b5bcd5f0$var$_50,
                    $bb3fac02b5bcd5f0$var$_51,
                    $bb3fac02b5bcd5f0$var$_52,
                    $bb3fac02b5bcd5f0$var$_53,
                    $bb3fac02b5bcd5f0$var$_54,
                    $bb3fac02b5bcd5f0$var$_55,
                    $bb3fac02b5bcd5f0$var$_56,
                    $bb3fac02b5bcd5f0$var$_57,
                    $bb3fac02b5bcd5f0$var$_58
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)(Component, {
                ...ariaAttributes,
                role: role,
                className: (0, $hMvDh.default)([
                    $bb3fac02b5bcd5f0$var$styles.root,
                    gap && $bb3fac02b5bcd5f0$var$columnGapMap[gap],
                    columnGap && $bb3fac02b5bcd5f0$var$columnGapMap[columnGap],
                    gap && $bb3fac02b5bcd5f0$var$rowGapMap[gap],
                    rowGap && $bb3fac02b5bcd5f0$var$rowGapMap[rowGap],
                    alignItems && $bb3fac02b5bcd5f0$var$alignItemsMap[alignItems],
                    direction && $bb3fac02b5bcd5f0$var$flexDirectionMap[direction],
                    justifyContent && $bb3fac02b5bcd5f0$var$justifyContentMap[justifyContent],
                    wrap && $bb3fac02b5bcd5f0$var$flexWrapMap[wrap],
                    xcss
                ]),
                "data-testid": testId,
                ref: ref,
                children: children
            })
        ]
    });
}));
$bb3fac02b5bcd5f0$export$f51f4c4ede09e011.displayName = 'Flex';

});


parcelRegister("2txLH", function(module, exports) {
$parcel$export(module.exports, "Stack", () => $17ce564eeeb07bda$export$694e0d28c7ffc90c);
/* stack.tsx generated by @compiled/babel-plugin v3.0.2 */ /* stack.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $ky45w = parcelRequire("ky45w");

var $iZBEG = parcelRequire("iZBEG");

var $kIqwl = parcelRequire("kIqwl");
const $17ce564eeeb07bda$var$_3 = "._16jlkb7n{flex-grow:1}";
const $17ce564eeeb07bda$var$_2 = "._1bsb1osq{width:100%}";
const $17ce564eeeb07bda$var$_ = "._16jlidpf{flex-grow:0}";
const $17ce564eeeb07bda$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
}; /**
    * __Stack__
    *
    * Stack is a primitive component based on flexbox that manages the block layout of direct children.
    *
    * @example
    * ```tsx
    *  <Stack>
    *    <Box padding="space.100" backgroundColor="neutral"></Box>
    *    <Box padding="space.100" backgroundColor="neutral"></Box>
    *  </Stack>
    * ```
    *
    */ 
const $17ce564eeeb07bda$export$694e0d28c7ffc90c = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $17ce564eeeb07bda$var$_,
                    $17ce564eeeb07bda$var$_2,
                    $17ce564eeeb07bda$var$_3
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $iZBEG.Flex), {
                ...ariaAttributes,
                as: as,
                role: role,
                gap: space,
                direction: "column",
                alignItems: alignItems,
                justifyContent: spread || alignBlock,
                xcss: (0, $ky45w.cx)(grow === 'hug' && $17ce564eeeb07bda$var$styles.hug, grow === 'fill' && $17ce564eeeb07bda$var$styles.fill, xcss),
                testId: testId,
                ref: ref,
                children: children
            })
        ]
    });
}));
$17ce564eeeb07bda$export$694e0d28c7ffc90c.displayName = 'Stack';

});

parcelRegister("kFr83", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a031fe54235ad2c$export$2e2bcd8739ae039);
/* visually-hidden.tsx generated by @compiled/babel-plugin v3.0.2 */ parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $kIqwl = parcelRequire("kIqwl");
const $6a031fe54235ad2c$var$_11 = "._o5721q9c{white-space:nowrap}";
const $6a031fe54235ad2c$var$_10 = "._uiztglyw{-webkit-user-select:none;-moz-user-select:none;user-select:none}";
const $6a031fe54235ad2c$var$_1 = "._ogto7mnp{clip:rect(1px,1px,1px,1px)}";
const $6a031fe54235ad2c$var$_0 = "._kqswstnw{position:absolute}";
const $6a031fe54235ad2c$var$_9 = "._4t3it94y{height:1px}";
const $6a031fe54235ad2c$var$_8 = "._1bsbt94y{width:1px}";
const $6a031fe54235ad2c$var$_7 = "._18m915vq{overflow-y:hidden}";
const $6a031fe54235ad2c$var$_6 = "._1reo15vq{overflow-x:hidden}";
const $6a031fe54235ad2c$var$_5 = "._19itidpf{border:0}";
const $6a031fe54235ad2c$var$_4 = "._19bvidpf{padding-left:0}";
const $6a031fe54235ad2c$var$_3 = "._n3tdidpf{padding-bottom:0}";
const $6a031fe54235ad2c$var$_2 = "._u5f3idpf{padding-right:0}";
const $6a031fe54235ad2c$var$_ = "._ca0qidpf{padding-top:0}";
const $6a031fe54235ad2c$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ const $6a031fe54235ad2c$var$VisuallyHidden = ({ children: children, testId: testId, role: role, id: id })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $6a031fe54235ad2c$var$_,
                    $6a031fe54235ad2c$var$_2,
                    $6a031fe54235ad2c$var$_3,
                    $6a031fe54235ad2c$var$_4,
                    $6a031fe54235ad2c$var$_5,
                    $6a031fe54235ad2c$var$_6,
                    $6a031fe54235ad2c$var$_7,
                    $6a031fe54235ad2c$var$_8,
                    $6a031fe54235ad2c$var$_9,
                    $6a031fe54235ad2c$var$_0,
                    $6a031fe54235ad2c$var$_1,
                    $6a031fe54235ad2c$var$_10,
                    $6a031fe54235ad2c$var$_11
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
                id: id,
                "data-testid": testId,
                role: role,
                className: (0, $hMvDh.default)([
                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
$6a031fe54235ad2c$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $6a031fe54235ad2c$export$2e2bcd8739ae039 = $6a031fe54235ad2c$var$VisuallyHidden;

});

parcelRegister("7Plna", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_APPEARANCE", () => $5dfad7a5b3c4c768$export$d6830277b06edd6);
const $5dfad7a5b3c4c768$export$d6830277b06edd6 = 'normal';
const $5dfad7a5b3c4c768$export$1eee5ddc4f6d41c5 = 400;

});

parcelRegister("lNrGg", function(module, exports) {
$parcel$export(module.exports, "default", () => $d62db64ffdf221d1$export$2e2bcd8739ae039);
/* flag-actions.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $eduFF = parcelRequire("eduFF");

var $2aEiL = parcelRequire("2aEiL");

var $bkr3m = parcelRequire("bkr3m");

var $injd3 = parcelRequire("injd3");

var $7Plna = parcelRequire("7Plna");

var $3mn2v = parcelRequire("3mn2v");

var $kIqwl = parcelRequire("kIqwl");
const $d62db64ffdf221d1$var$_41 = "a._eqps1a66._eqps1a66{padding-inline-start:var(--ds-space-100,8px)!important}";
const $d62db64ffdf221d1$var$_40 = "._b3g31a66._b3g31a66{padding-inline-start:var(--ds-space-100,8px)!important}";
const $d62db64ffdf221d1$var$_39 = "a._1wy61a66._1wy61a66{padding-inline-end:var(--ds-space-100,8px)!important}";
const $d62db64ffdf221d1$var$_38 = "._1bk61a66._1bk61a66{padding-inline-end:var(--ds-space-100,8px)!important}";
const $d62db64ffdf221d1$var$_37 = "a._1dwvgrf3._1dwvgrf3{padding-block-start:0!important}";
const $d62db64ffdf221d1$var$_36 = "._gbuigrf3._gbuigrf3{padding-block-start:0!important}";
const $d62db64ffdf221d1$var$_35 = "a._1v8mgrf3._1v8mgrf3{padding-block-end:0!important}";
const $d62db64ffdf221d1$var$_34 = "._1ku2grf3._1ku2grf3{padding-block-end:0!important}";
const $d62db64ffdf221d1$var$_33 = "a._z7cdgrf3._z7cdgrf3{padding-left:0!important}";
const $d62db64ffdf221d1$var$_32 = "._1yxxgrf3._1yxxgrf3{padding-left:0!important}";
const $d62db64ffdf221d1$var$_31 = "a._1iysgrf3._1iysgrf3{padding-right:0!important}";
const $d62db64ffdf221d1$var$_30 = "._w8sqgrf3._w8sqgrf3{padding-right:0!important}";
const $d62db64ffdf221d1$var$_29 = "a._z7cd1a66._z7cd1a66{padding-left:var(--ds-space-100,8px)!important}";
const $d62db64ffdf221d1$var$_28 = "._1yxx1a66._1yxx1a66{padding-left:var(--ds-space-100,8px)!important}";
const $d62db64ffdf221d1$var$_27 = "a._cwkngrf3._cwkngrf3{padding-bottom:0!important}";
const $d62db64ffdf221d1$var$_26 = "._fjwrgrf3._fjwrgrf3{padding-bottom:0!important}";
const $d62db64ffdf221d1$var$_25 = "a._1iys1a66._1iys1a66{padding-right:var(--ds-space-100,8px)!important}";
const $d62db64ffdf221d1$var$_24 = "._w8sq1a66._w8sq1a66{padding-right:var(--ds-space-100,8px)!important}";
const $d62db64ffdf221d1$var$_23 = "a._h03xgrf3._h03xgrf3{padding-top:0!important}";
const $d62db64ffdf221d1$var$_22 = "._1dltgrf3._1dltgrf3{padding-top:0!important}";
const $d62db64ffdf221d1$var$_21 = "._10fu17w4._10fu17w4:active{background-color:var(--bg-color-active)}";
const $d62db64ffdf221d1$var$_20 = "._u1mb14jz._u1mb14jz:hover{background-color:var(--bg-color-hover)}";
const $d62db64ffdf221d1$var$_19 = "a._1rsgnqa1._1rsgnqa1:hover{text-decoration-style:solid}";
const $d62db64ffdf221d1$var$_18 = "a._b6ztnqa1._b6ztnqa1:active{text-decoration-style:solid}";
const $d62db64ffdf221d1$var$_17 = "._1ejunqa1._1ejunqa1:hover{text-decoration-style:solid}";
const $d62db64ffdf221d1$var$_16 = "._1iqunqa1._1iqunqa1:active{text-decoration-style:solid}";
const $d62db64ffdf221d1$var$_15 = "a._1pd88stv._1pd88stv:hover{text-decoration-line:underline}";
const $d62db64ffdf221d1$var$_14 = "a._5kwq8stv._5kwq8stv:active{text-decoration-line:underline}";
const $d62db64ffdf221d1$var$_13 = "._1p6m8stv._1p6m8stv:hover{text-decoration-line:underline}";
const $d62db64ffdf221d1$var$_12 = "._17rj8stv._17rj8stv:active{text-decoration-line:underline}";
const $d62db64ffdf221d1$var$_11 = "a._77mc1r31._77mc1r31:hover{text-decoration-color:currentColor}";
const $d62db64ffdf221d1$var$_10 = "a._8dbm1r31._8dbm1r31:active{text-decoration-color:currentColor}";
const $d62db64ffdf221d1$var$_1 = "._1p6b1r31._1p6b1r31:hover{text-decoration-color:currentColor}";
const $d62db64ffdf221d1$var$_0 = "._ow071r31._ow071r31:active{text-decoration-color:currentColor}";
const $d62db64ffdf221d1$var$_9 = "a._il101wq8._il101wq8{font-weight:var(--ds-font-weight-medium,500)}";
const $d62db64ffdf221d1$var$_8 = "._12r21wq8._12r21wq8{font-weight:var(--ds-font-weight-medium,500)}";
const $d62db64ffdf221d1$var$_7 = "a._qkwg1pkf._qkwg1pkf{color:var(--color)!important}";
const $d62db64ffdf221d1$var$_6 = "._1w901pkf._1w901pkf{color:var(--color)!important}";
const $d62db64ffdf221d1$var$_5 = "a._u4iq1zz4._u4iq1zz4{background:var(--bg-color)}";
const $d62db64ffdf221d1$var$_4 = "._nup91zz4._nup91zz4{background:var(--bg-color)}";
const $d62db64ffdf221d1$var$_3 = "._11c8fhey{font:var(--ds-font-body,normal 400 14px/20px \"Atlassian Sans\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const $d62db64ffdf221d1$var$_2 = "a._y8dn107e._y8dn107e{transform:translateX(-2px)}";
const $d62db64ffdf221d1$var$_ = "._1g4l107e._1g4l107e{transform:translateX(-2px)}";
const $d62db64ffdf221d1$var$buttonStylesOld = null;
const $d62db64ffdf221d1$var$buttonStyles = null;
const $d62db64ffdf221d1$var$fontStyles = null;
const $d62db64ffdf221d1$var$appearanceNormalButtonStyles = null;
const $d62db64ffdf221d1$var$appearanceBoldButtonStyles = null;
const $d62db64ffdf221d1$var$appearanceNormalActionsContainerStyles = null;
const $d62db64ffdf221d1$var$FlagActions = (props)=>{
    const { appearance: appearance = (0, $7Plna.DEFAULT_APPEARANCE), actions: actions = [], linkComponent: linkComponent, testId: testId } = props;
    if (!actions.length) return null;
    const isBold = appearance !== (0, $7Plna.DEFAULT_APPEARANCE);
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $d62db64ffdf221d1$var$_,
                    $d62db64ffdf221d1$var$_2,
                    $d62db64ffdf221d1$var$_3
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
                className: (0, $hMvDh.default)([
                    !isBold && "_1g4l107e _y8dn107e",
                    "_11c8fhey"
                ]),
                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $bkr3m.Inline), {
                    space: "space.100",
                    shouldWrap: true,
                    alignBlock: "center",
                    separator: isBold ? undefined : "\xb7",
                    testId: testId && `${testId}-actions`,
                    children: actions.map((action, index)=>(0, $2aEiL.fg)('platform_dst_flag_action_padding_fix') ? /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                            children: [
                                /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                                    children: [
                                        $d62db64ffdf221d1$var$_4,
                                        $d62db64ffdf221d1$var$_5,
                                        $d62db64ffdf221d1$var$_6,
                                        $d62db64ffdf221d1$var$_7,
                                        $d62db64ffdf221d1$var$_8,
                                        $d62db64ffdf221d1$var$_9,
                                        $d62db64ffdf221d1$var$_0,
                                        $d62db64ffdf221d1$var$_1,
                                        $d62db64ffdf221d1$var$_10,
                                        $d62db64ffdf221d1$var$_11,
                                        $d62db64ffdf221d1$var$_12,
                                        $d62db64ffdf221d1$var$_13,
                                        $d62db64ffdf221d1$var$_14,
                                        $d62db64ffdf221d1$var$_15,
                                        $d62db64ffdf221d1$var$_16,
                                        $d62db64ffdf221d1$var$_17,
                                        $d62db64ffdf221d1$var$_18,
                                        $d62db64ffdf221d1$var$_19,
                                        $d62db64ffdf221d1$var$_20,
                                        $d62db64ffdf221d1$var$_21,
                                        $d62db64ffdf221d1$var$_22,
                                        $d62db64ffdf221d1$var$_23,
                                        $d62db64ffdf221d1$var$_24,
                                        $d62db64ffdf221d1$var$_25,
                                        $d62db64ffdf221d1$var$_26,
                                        $d62db64ffdf221d1$var$_27,
                                        $d62db64ffdf221d1$var$_28,
                                        $d62db64ffdf221d1$var$_29,
                                        $d62db64ffdf221d1$var$_30,
                                        $d62db64ffdf221d1$var$_31,
                                        $d62db64ffdf221d1$var$_32,
                                        $d62db64ffdf221d1$var$_33
                                    ]
                                }),
                                /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eduFF.default), {
                                    onClick: action.onClick,
                                    href: action.href,
                                    target: action.target,
                                    appearance: isBold ? 'default' : 'link',
                                    component: linkComponent,
                                    spacing: "compact",
                                    testId: action.testId,
                                    style: {
                                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                        '--color': (0, $injd3.actionTextColor)[appearance],
                                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                        '--bg-color': (0, $3mn2v.actionBackgroundColor)[appearance].default,
                                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                        '--bg-color-hover': (0, $3mn2v.actionBackgroundColor)[appearance].pressed,
                                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                        '--bg-color-active': (0, $3mn2v.actionBackgroundColor)[appearance].active
                                    },
                                    className: (0, $hMvDh.default)([
                                        "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                                        isBold ? "_1dltgrf3 _h03xgrf3 _w8sq1a66 _1iys1a66 _fjwrgrf3 _cwkngrf3 _1yxx1a66 _z7cd1a66" : "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
                                    ]),
                                    children: action.content
                                }, index)
                            ]
                        }, index) : /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                            children: [
                                /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                                    children: [
                                        $d62db64ffdf221d1$var$_4,
                                        $d62db64ffdf221d1$var$_5,
                                        $d62db64ffdf221d1$var$_6,
                                        $d62db64ffdf221d1$var$_7,
                                        $d62db64ffdf221d1$var$_8,
                                        $d62db64ffdf221d1$var$_9,
                                        $d62db64ffdf221d1$var$_34,
                                        $d62db64ffdf221d1$var$_35,
                                        $d62db64ffdf221d1$var$_36,
                                        $d62db64ffdf221d1$var$_37,
                                        $d62db64ffdf221d1$var$_38,
                                        $d62db64ffdf221d1$var$_39,
                                        $d62db64ffdf221d1$var$_40,
                                        $d62db64ffdf221d1$var$_41,
                                        $d62db64ffdf221d1$var$_0,
                                        $d62db64ffdf221d1$var$_1,
                                        $d62db64ffdf221d1$var$_10,
                                        $d62db64ffdf221d1$var$_11,
                                        $d62db64ffdf221d1$var$_12,
                                        $d62db64ffdf221d1$var$_13,
                                        $d62db64ffdf221d1$var$_14,
                                        $d62db64ffdf221d1$var$_15,
                                        $d62db64ffdf221d1$var$_16,
                                        $d62db64ffdf221d1$var$_17,
                                        $d62db64ffdf221d1$var$_18,
                                        $d62db64ffdf221d1$var$_19,
                                        $d62db64ffdf221d1$var$_20,
                                        $d62db64ffdf221d1$var$_21,
                                        $d62db64ffdf221d1$var$_22,
                                        $d62db64ffdf221d1$var$_23,
                                        $d62db64ffdf221d1$var$_30,
                                        $d62db64ffdf221d1$var$_31,
                                        $d62db64ffdf221d1$var$_26,
                                        $d62db64ffdf221d1$var$_27,
                                        $d62db64ffdf221d1$var$_32,
                                        $d62db64ffdf221d1$var$_33
                                    ]
                                }),
                                /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eduFF.default), {
                                    onClick: action.onClick,
                                    href: action.href,
                                    target: action.target,
                                    appearance: isBold ? 'default' : 'link',
                                    component: linkComponent,
                                    spacing: "compact",
                                    testId: action.testId,
                                    style: {
                                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                        '--color': (0, $injd3.actionTextColor)[appearance],
                                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                        '--bg-color': (0, $3mn2v.actionBackgroundColor)[appearance].default,
                                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                        '--bg-color-hover': (0, $3mn2v.actionBackgroundColor)[appearance].pressed,
                                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                        '--bg-color-active': (0, $3mn2v.actionBackgroundColor)[appearance].active
                                    },
                                    className: (0, $hMvDh.default)([
                                        "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk61a66 _1wy61a66 _b3g31a66 _eqps1a66 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                                        !isBold && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
                                    ]),
                                    children: action.content
                                }, index)
                            ]
                        }, index))
                })
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d62db64ffdf221d1$export$2e2bcd8739ae039 = $d62db64ffdf221d1$var$FlagActions;

});
parcelRegister("eduFF", function(module, exports) {
$parcel$export(module.exports, "default", () => $d32ce3f51357233e$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $frybl = parcelRequire("frybl");

var $5Qmrb = parcelRequire("5Qmrb");

var $H8FDJ = parcelRequire("H8FDJ");

var $iBcO5 = parcelRequire("iBcO5");

var $jG29I = parcelRequire("jG29I");

var $nPPwU = parcelRequire("nPPwU");

var $iQ4mB = parcelRequire("iQ4mB");

var $kIqwl = parcelRequire("kIqwl");
function $d32ce3f51357233e$var$getInteractionState({ isDisabled: isDisabled = false, isActive: isActive = false, isFocus: isFocus = false, isHover: isHover = false, isSelected: isSelected = false, isLoading: isLoading = false }) {
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
const $d32ce3f51357233e$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use `Button` from `@atlaskit/button/default/button`.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ const $d32ce3f51357233e$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).forwardRef(function CustomThemeButton({ appearance: // Calculate default props for use in custom themes
appearance = 'default', autoFocus: autoFocus = false, isDisabled: isDisabled = false, isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', isLoading: isLoading = false, onMouseEnter: providedOnMouseEnter, onMouseLeave: providedOnMouseLeave, onMouseDown: providedOnMouseDown, onMouseUp: providedOnMouseUp, onFocus: providedOnFocus, onBlur: providedOnBlur, theme: theme = (0, $jG29I.defaultThemeFn), ...rest }, ref) {
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    const restProps = {
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ...rest
    };
    const [state, setState] = (0, $1v5pe.useState)($d32ce3f51357233e$var$initial);
    const onMouseEnter = (0, $1v5pe.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: true
            }));
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    const onMouseLeave = (0, $1v5pe.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: false,
                isActive: false
            }));
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    const onMouseDown = (0, $1v5pe.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: true
            }));
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    const onMouseUp = (0, $1v5pe.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: false
            }));
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    const onFocus = (0, $1v5pe.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: true
            }));
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    const onBlur = (0, $1v5pe.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: false
            }));
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $iQ4mB.default).Provider, {
        value: theme,
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $frybl.default).Consumer, {
            children: ({ mode: mode })=>/*#__PURE__*/ (0, $kIqwl.jsx)((0, $iQ4mB.default).Consumer, {
                    mode: mode,
                    state: $d32ce3f51357233e$var$getInteractionState({
                        ...state,
                        isLoading: isLoading,
                        isSelected: restProps.isSelected,
                        isDisabled: restProps.isDisabled
                    }),
                    iconIsOnlyChild: (0, $H8FDJ.default)(restProps),
                    isLoading: isLoading,
                    ...restProps,
                    children: ({ buttonStyles: buttonStyles })=>/*#__PURE__*/ (0, $kIqwl.jsx)((0, $5Qmrb.default), {
                            ...restProps,
                            ref: ref,
                            overlay: isLoading ? /*#__PURE__*/ (0, $kIqwl.jsx)((0, $iBcO5.default), {
                                ...restProps
                            }) : null,
                            "aria-disabled": isLoading || restProps['aria-disabled'],
                            onMouseEnter: onMouseEnter,
                            onMouseLeave: onMouseLeave,
                            onMouseDown: onMouseDown,
                            onMouseUp: onMouseUp,
                            onFocus: onFocus,
                            onBlur: onBlur,
                            buttonCss: (0, $nPPwU.getSpecifiers)(buttonStyles)
                        })
                })
        })
    });
}));
// Tools including enzyme rely on components having a display name
$d32ce3f51357233e$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $d32ce3f51357233e$export$2e2bcd8739ae039 = $d32ce3f51357233e$var$CustomThemeButton;

});
parcelRegister("frybl", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd0812fb6054e63e$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $5MWmb = parcelRequire("5MWmb");
// Create default global light theme
const $fd0812fb6054e63e$var$dest = (0, $5MWmb.createTheme)(()=>({
        mode: 'light'
    }));
const $fd0812fb6054e63e$var$Provider = $fd0812fb6054e63e$var$dest.Provider;
const $fd0812fb6054e63e$var$Consumer = $fd0812fb6054e63e$var$dest.Consumer;
const $fd0812fb6054e63e$export$7692396083754928 = $fd0812fb6054e63e$var$dest.useTheme;
const $fd0812fb6054e63e$var$Theme = {
    Provider: $fd0812fb6054e63e$var$Provider,
    Consumer: $fd0812fb6054e63e$var$Consumer
};
var /**
 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-2652 Internal documentation for deprecation (no external access)}
 * Use design tokens and the supported customization APIs of Atlassian Design System components.
 */ $fd0812fb6054e63e$export$2e2bcd8739ae039 = $fd0812fb6054e63e$var$Theme;

});
parcelRegister("5MWmb", function(module, exports) {
$parcel$export(module.exports, "createTheme", () => $58c642e9152c40e3$export$25d302a5b900a763);

var $1v5pe = parcelRequire("1v5pe");

var $kIqwl = parcelRequire("kIqwl");
function $58c642e9152c40e3$export$25d302a5b900a763(defaultGetTokens) {
    const emptyThemeFn = (getTokens, props)=>getTokens(props);
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ const ThemeContext = /*#__PURE__*/ (0, $1v5pe.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        const theme = (0, $1v5pe.useContext)(ThemeContext);
        const themeFn = theme || emptyThemeFn;
        const tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        const { children: children, ...themeProps } = props;
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        const tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kIqwl.Fragment), {
            children: children(tokens)
        });
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        const themeFn = (0, $1v5pe.useContext)(ThemeContext);
        const valueFn = props.value || emptyThemeFn;
        const mixedFn = (0, $1v5pe.useCallback)((themeProps)=>valueFn(themeFn, themeProps), [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, $kIqwl.jsx)(ThemeContext.Provider, {
            value: mixedFn,
            children: props.children
        });
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("5Qmrb", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce18d0e8c92f494e$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $hRuTh = parcelRequire("hRuTh");

var $j9QYE = parcelRequire("j9QYE");

var $aD9yk = parcelRequire("aD9yk");

var $Ms2ib = parcelRequire("Ms2ib");

var $8uWRL = parcelRequire("8uWRL");

var $7qISg = parcelRequire("7qISg");

var $i8DvG = parcelRequire("i8DvG");

var $b32Ws = parcelRequire("b32Ws");

var $6SyBh = parcelRequire("6SyBh");

var $k4gsk = parcelRequire("k4gsk");

var $hckPA = parcelRequire("hckPA");

var $6eehW = parcelRequire("6eehW");
function $ce18d0e8c92f494e$var$_extends() {
    return $ce18d0e8c92f494e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ce18d0e8c92f494e$var$_extends.apply(null, arguments);
}
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
const $ce18d0e8c92f494e$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out
 * and we bump Button to set padding based on the new icons.
 */ const $ce18d0e8c92f494e$var$iconBeforeSpacingFixStyle = (0, $hRuTh.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
const $ce18d0e8c92f494e$var$iconAfterSpacingFixStyle = (0, $hRuTh.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
const $ce18d0e8c92f494e$var$getSpacingFix = (children, spacingStyles)=>{
    if (!children || (0, $hckPA.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
const $ce18d0e8c92f494e$var$getChildren = (children, childrenStyles)=>{
    if ((0, $hckPA.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $hRuTh.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
const $ce18d0e8c92f494e$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).forwardRef(function ButtonBase(props, ref) {
    const { analyticsContext: // I don't think analytics should be in button, but for now it is
    analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, buttonCss: buttonCss, children: children, className: className, href: href, // use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component: Component = href ? 'a' : 'button', iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled = false, isSelected: isSelected = false, onBlur: onBlur, onClick: providedOnClick = (0, $aD9yk.default), onFocus: onFocus, onMouseDown: providedOnMouseDown = (0, $aD9yk.default), overlay: overlay, shouldFitContainer: // Pulling out so it doesn't spread on rendered component
    shouldFitContainer, spacing: spacing = 'default', tabIndex: tabIndex = 0, type: type = !href ? 'button' : undefined, testId: testId, ...rest } = props;
    const ourRef = (0, $1v5pe.useRef)();
    const setRef = (0, $1v5pe.useCallback)((node)=>{
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $Ms2ib.default)(ourRef, autoFocus);
    const interactionContext = (0, $1v5pe.useContext)((0, $7qISg.default));
    const handleClick = (0, $1v5pe.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    const onMouseDown = (0, $1v5pe.useCallback)((event)=>{
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $1v5pe.useEffect)(()=>{
        const el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    const hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const fadeStyles = (0, $hRuTh.css)((0, $6SyBh.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    const isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: `${isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)"} !important`
        }
    };
    return (0, $hRuTh.jsx)((0, $8uWRL.default), null, (0, $hRuTh.jsx)(Component, $ce18d0e8c92f494e$var$_extends({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $ce18d0e8c92f494e$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $i8DvG.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $hRuTh.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $k4gsk.getIconStyle)({
                spacing: spacing
            }),
            $ce18d0e8c92f494e$var$getSpacingFix(children, $ce18d0e8c92f494e$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $ce18d0e8c92f494e$var$getChildren(children, [
        fadeStyles,
        (0, $b32Ws.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $hRuTh.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $k4gsk.getIconStyle)({
                spacing: spacing
            }),
            $ce18d0e8c92f494e$var$getSpacingFix(children, $ce18d0e8c92f494e$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $hRuTh.jsx)("span", {
        css: [
            (0, $6eehW.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ce18d0e8c92f494e$export$2e2bcd8739ae039 = $ce18d0e8c92f494e$var$ButtonBase;

});
parcelRegister("Ms2ib", function(module, exports) {
$parcel$export(module.exports, "default", () => $304418d7574b6889$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");
function $304418d7574b6889$export$2e2bcd8739ae039(ref, autoFocus) {
    const initialMount = (0, $1v5pe.useRef)(true);
    (0, $1v5pe.useEffect)(()=>{
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("8uWRL", function(module, exports) {
$parcel$export(module.exports, "default", () => $914497e9c37f61bc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- LENS1-245 tracks @atlaskit/focus-ring deprecation. */ 
var $1v5pe = parcelRequire("1v5pe");

var $hRuTh = parcelRequire("hRuTh");
const $914497e9c37f61bc$var$BORDER_WIDTH = 2;
const $914497e9c37f61bc$var$baseFocusOutsideStyles = (0, $hRuTh.css)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`,
    outlineOffset: $914497e9c37f61bc$var$BORDER_WIDTH
});
const $914497e9c37f61bc$var$baseInsetStyles = (0, $hRuTh.css)({
    outlineColor: "var(--ds-border-focused, #4688EC)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$914497e9c37f61bc$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
const $914497e9c37f61bc$var$focusRingStyles = (0, $hRuTh.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $914497e9c37f61bc$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $914497e9c37f61bc$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`
        }
    }
});
const $914497e9c37f61bc$var$insetFocusRingStyles = (0, $hRuTh.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $914497e9c37f61bc$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $914497e9c37f61bc$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 *
 * @deprecated FocusRing is deprecated. Use Focusable from @atlaskit/primitives/compiled/focusable instead.
 */ const $914497e9c37f61bc$var$FocusRing = /*#__PURE__*/ (0, $1v5pe.memo)(({ children: children, isInset: isInset, focus: focus })=>{
    const controlledStyles = isInset ? $914497e9c37f61bc$var$baseInsetStyles : $914497e9c37f61bc$var$baseFocusOutsideStyles;
    const uncontrolledStyles = isInset ? $914497e9c37f61bc$var$insetFocusRingStyles : $914497e9c37f61bc$var$focusRingStyles;
    const focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $hRuTh.jsx)((0, $hRuTh.ClassNames), null, ({ css: css, cx: cx })=>(0, $1v5pe.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, $1v5pe.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children));
});
$914497e9c37f61bc$var$FocusRing.displayName = 'FocusRing';
var $914497e9c37f61bc$export$2e2bcd8739ae039 = $914497e9c37f61bc$var$FocusRing;

});

parcelRegister("i8DvG", function(module, exports) {
$parcel$export(module.exports, "default", () => $b22fa924f865e60d$export$2e2bcd8739ae039);
function $b22fa924f865e60d$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $b22fa924f865e60d$var$tabKeyCode = 9;
function $b22fa924f865e60d$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $b22fa924f865e60d$var$tabKeyCode) return;
    $b22fa924f865e60d$var$abort(event);
}
const $b22fa924f865e60d$var$block = {
    onMouseDownCapture: $b22fa924f865e60d$var$abort,
    onMouseUpCapture: $b22fa924f865e60d$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $b22fa924f865e60d$var$onKey,
    onKeyUpCapture: $b22fa924f865e60d$var$onKey,
    onTouchStartCapture: $b22fa924f865e60d$var$abort,
    onTouchEndCapture: $b22fa924f865e60d$var$abort,
    onPointerDownCapture: $b22fa924f865e60d$var$abort,
    onPointerUpCapture: $b22fa924f865e60d$var$abort,
    onClickCapture: $b22fa924f865e60d$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $b22fa924f865e60d$var$abort
};
const $b22fa924f865e60d$var$doNotBlock = {};
function $b22fa924f865e60d$export$2e2bcd8739ae039({ isInteractive: isInteractive }) {
    return isInteractive ? $b22fa924f865e60d$var$doNotBlock : $b22fa924f865e60d$var$block;
}

});

parcelRegister("b32Ws", function(module, exports) {
$parcel$export(module.exports, "getContentStyle", () => $8592433700eea827$export$7ad0316cc0dd65a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $hRuTh = parcelRequire("hRuTh");
function $8592433700eea827$export$7ad0316cc0dd65a({ spacing: spacing }) {
    return (0, $hRuTh.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : '0 2px',
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}

});

parcelRegister("6SyBh", function(module, exports) {
$parcel$export(module.exports, "getFadingCss", () => $e65f184a21624a8b$export$1b5827d324e945b1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $hRuTh = parcelRequire("hRuTh");
function $e65f184a21624a8b$export$1b5827d324e945b1({ hasOverlay: hasOverlay }) {
    return (0, $hRuTh.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}

});

parcelRegister("k4gsk", function(module, exports) {
$parcel$export(module.exports, "getIconStyle", () => $5b3b350e1901f6a0$export$864eea3f4ec3368f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $hRuTh = parcelRequire("hRuTh");
function $5b3b350e1901f6a0$export$864eea3f4ec3368f({ spacing: spacing }) {
    return (0, $hRuTh.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : `0 2px`,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}

});

parcelRegister("hckPA", function(module, exports) {
$parcel$export(module.exports, "getIfVisuallyHiddenChildren", () => $72e303532ffb2193$export$20bbd2efb0d734c4);

var $1v5pe = parcelRequire("1v5pe");

var $kFr83 = parcelRequire("kFr83");
const $72e303532ffb2193$export$20bbd2efb0d734c4 = (children)=>{
    return children && /*#__PURE__*/ (0, $1v5pe.isValidElement)(children) && children.type === (0, $kFr83.default);
};

});

parcelRegister("6eehW", function(module, exports) {
$parcel$export(module.exports, "overlayCss", () => $d0977fa093015bff$export$1a9fe1b84c876bb5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $d0977fa093015bff$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});


parcelRegister("H8FDJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ad8a40ce63139e0$export$2e2bcd8739ae039);

var $hckPA = parcelRequire("hckPA");
function $1ad8a40ce63139e0$export$2e2bcd8739ae039({ children: children, iconBefore: iconBefore, iconAfter: iconAfter }) {
    if ((0, $hckPA.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});

parcelRegister("iBcO5", function(module, exports) {
$parcel$export(module.exports, "default", () => $bac09e2367545890$export$2e2bcd8739ae039);
parcelRequire("1v5pe");

var $5I7AE = parcelRequire("5I7AE");

var $kIqwl = parcelRequire("kIqwl");
function $bac09e2367545890$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $bac09e2367545890$export$2e2bcd8739ae039({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, spacing: spacing = 'default' }) {
    const size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $5I7AE.default), {
        size: size,
        label: ", Loading",
        appearance: $bac09e2367545890$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("5I7AE", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e8d512b105ac091$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $1v5pe = parcelRequire("1v5pe");

var $7qISg = parcelRequire("7qISg");

var $gHqmN = parcelRequire("gHqmN");

var $kIqwl = parcelRequire("kIqwl");
const $6e8d512b105ac091$var$_15 = "@media screen and (forced-colors:active){._jcxd7g3v{filter:grayscale(100%)}._1tjm1onz{stroke:CanvasText}}";
const $6e8d512b105ac091$var$_14 = "._1snbbs82{stroke-width:1.5}";
const $6e8d512b105ac091$var$_13 = "._7ljx1dhp{stroke-dasharray:60}";
const $6e8d512b105ac091$var$_12 = "._lswuglyw{fill:none}";
const $6e8d512b105ac091$var$_11 = "._s7n4nkob{vertical-align:middle}";
const $6e8d512b105ac091$var$_10 = "._1e0c116y{display:inline-flex}";
const $6e8d512b105ac091$var$_1 = "._1o511hrf{animation-fill-mode:both}";
const $6e8d512b105ac091$var$_0 = "._1pgl1ytf{animation-timing-function:ease-in-out}";
const $6e8d512b105ac091$var$_9 = "._5sag9cwz{animation-duration:1s}";
const $6e8d512b105ac091$var$_8 = "._j7hq1ky6{animation-name:k1v8un7d}";
const $6e8d512b105ac091$var$_7 = "@keyframes k1v8un7d{0%{transform:rotate(50deg);stroke-dashoffset:60}to{transform:rotate(230deg);stroke-dashoffset:50}}";
const $6e8d512b105ac091$var$_6 = "._8hrz1h6o{transform-origin:center}";
const $6e8d512b105ac091$var$_5 = "._1pgl2qsq{animation-timing-function:cubic-bezier(.4,.15,.6,.85)}";
const $6e8d512b105ac091$var$_4 = "._tip812c5{animation-iteration-count:infinite}";
const $6e8d512b105ac091$var$_3 = "._5sag12kz{animation-duration:.86s}";
const $6e8d512b105ac091$var$_2 = "._j7hqsf8s{animation-name:kztt5h0}";
const $6e8d512b105ac091$var$_ = "@keyframes kztt5h0{to{transform:rotate(1turn)}}";
function $6e8d512b105ac091$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
const $6e8d512b105ac091$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ const $6e8d512b105ac091$var$loadIn = null;
const $6e8d512b105ac091$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o511hrf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ const $6e8d512b105ac091$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1v5pe.useEffect) : (0, $1v5pe.useLayoutEffect); /**
                                                                                          * __Spinner__
                                                                                          *
                                                                                          * A spinner is an animated spinning icon that lets users know content is being loaded.
                                                                                          *
                                                                                          * - [Examples](https://atlassian.design/components/spinner/examples)
                                                                                          * - [Code](https://atlassian.design/components/spinner/code)
                                                                                          * - [Usage](https://atlassian.design/components/spinner/usage)
                                                                                          */ 
const $6e8d512b105ac091$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).forwardRef(function Spinner({ appearance: appearance = 'inherit', delay: delay = 0, interactionName: interactionName, label: label, size: providedSize = 'medium', testId: testId }, ref) {
    const size = typeof providedSize === 'number' ? providedSize : (0, $gHqmN.presetSizes)[providedSize];
    const animationDelay = `${delay}ms`;
    const stroke = $6e8d512b105ac091$var$getStrokeColor(appearance);
    const context = (0, $1v5pe.useContext)((0, $7qISg.default));
    $6e8d512b105ac091$var$useLayoutEffect(()=>{
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]); /**
                                   * The Spinner animation uses a combination of two
                                   * css animations on two separate elements.
                                   */ 
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $6e8d512b105ac091$var$_,
                    $6e8d512b105ac091$var$_2,
                    $6e8d512b105ac091$var$_3,
                    $6e8d512b105ac091$var$_4,
                    $6e8d512b105ac091$var$_5,
                    $6e8d512b105ac091$var$_6,
                    $6e8d512b105ac091$var$_7,
                    $6e8d512b105ac091$var$_8,
                    $6e8d512b105ac091$var$_9,
                    $6e8d512b105ac091$var$_0,
                    $6e8d512b105ac091$var$_1,
                    $6e8d512b105ac091$var$_10,
                    $6e8d512b105ac091$var$_11,
                    $6e8d512b105ac091$var$_12,
                    $6e8d512b105ac091$var$_13,
                    $6e8d512b105ac091$var$_14,
                    $6e8d512b105ac091$var$_15
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
                /**
       * This span exists to off-load animations from the circle element,
       * which were causing performance issues (style recalculations)
       * on Safari and older versions of Chrome.
       *
       * This can be removed and styles placed back on the circle element once
       * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
       */ "data-testid": testId ? `${testId}-wrapper` : 'spinner-wrapper' // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ,
                style: {
                    animationDelay: animationDelay,
                    width: size,
                    height: size
                },
                className: (0, $hMvDh.default)([
                    $6e8d512b105ac091$var$styles.wrapperStyles,
                    $6e8d512b105ac091$var$styles.rotateStyles
                ]),
                children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                    children: [
                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                            children: [
                                $6e8d512b105ac091$var$_,
                                $6e8d512b105ac091$var$_2,
                                $6e8d512b105ac091$var$_3,
                                $6e8d512b105ac091$var$_4,
                                $6e8d512b105ac091$var$_5,
                                $6e8d512b105ac091$var$_6,
                                $6e8d512b105ac091$var$_7,
                                $6e8d512b105ac091$var$_8,
                                $6e8d512b105ac091$var$_9,
                                $6e8d512b105ac091$var$_0,
                                $6e8d512b105ac091$var$_1,
                                $6e8d512b105ac091$var$_10,
                                $6e8d512b105ac091$var$_11,
                                $6e8d512b105ac091$var$_12,
                                $6e8d512b105ac091$var$_13,
                                $6e8d512b105ac091$var$_14,
                                $6e8d512b105ac091$var$_15
                            ]
                        }),
                        /*#__PURE__*/ (0, $kIqwl.jsx)("svg", {
                            height: size,
                            width: size,
                            viewBox: "0 0 16 16",
                            xmlns: "http://www.w3.org/2000/svg",
                            "data-testid": testId,
                            ref: ref,
                            "aria-label": label || undefined // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            ,
                            style: {
                                animationDelay: animationDelay
                            },
                            role: label ? 'img' : 'none',
                            className: (0, $hMvDh.default)([
                                $6e8d512b105ac091$var$styles.loadInStyles
                            ]),
                            children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                                children: [
                                    /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                                        children: [
                                            $6e8d512b105ac091$var$_,
                                            $6e8d512b105ac091$var$_2,
                                            $6e8d512b105ac091$var$_3,
                                            $6e8d512b105ac091$var$_4,
                                            $6e8d512b105ac091$var$_5,
                                            $6e8d512b105ac091$var$_6,
                                            $6e8d512b105ac091$var$_7,
                                            $6e8d512b105ac091$var$_8,
                                            $6e8d512b105ac091$var$_9,
                                            $6e8d512b105ac091$var$_0,
                                            $6e8d512b105ac091$var$_1,
                                            $6e8d512b105ac091$var$_10,
                                            $6e8d512b105ac091$var$_11,
                                            $6e8d512b105ac091$var$_12,
                                            $6e8d512b105ac091$var$_13,
                                            $6e8d512b105ac091$var$_14,
                                            $6e8d512b105ac091$var$_15
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $kIqwl.jsx)("circle", {
                                        cx: "8",
                                        cy: "8",
                                        r: "7",
                                        style: {
                                            stroke: stroke
                                        },
                                        className: (0, $hMvDh.default)([
                                            $6e8d512b105ac091$var$styles.circleStyles
                                        ])
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}));
var $6e8d512b105ac091$export$2e2bcd8739ae039 = $6e8d512b105ac091$var$Spinner;

});
parcelRegister("gHqmN", function(module, exports) {
$parcel$export(module.exports, "presetSizes", () => $a805e17be9aff939$export$4e9f1640bbe7a1a8);
const $a805e17be9aff939$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});



parcelRegister("jG29I", function(module, exports) {
$parcel$export(module.exports, "defaultThemeFn", () => $af9996ddd1d07b48$export$437a7f77d13d7916);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $af9996ddd1d07b48$export$437a7f77d13d7916(current, values) {
    return current(values);
}

});

parcelRegister("nPPwU", function(module, exports) {
$parcel$export(module.exports, "getSpecifiers", () => $eef0a32b5e180a41$export$643db0b8d8778e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $eef0a32b5e180a41$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}

});

parcelRegister("iQ4mB", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc5bbd794beb60ab$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @atlaskit/ui-styling-standard/no-atlaskit-theme -- Ignored via go/DSP-18766

var $5MWmb = parcelRequire("5MWmb");

var $hfjHG = parcelRequire("hfjHG");
const $bc5bbd794beb60ab$var$Theme = (0, $5MWmb.createTheme)((themeProps)=>({
        buttonStyles: (0, $hfjHG.getCustomCss)(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bc5bbd794beb60ab$export$2e2bcd8739ae039 = $bc5bbd794beb60ab$var$Theme;

});
parcelRegister("hfjHG", function(module, exports) {
$parcel$export(module.exports, "getCustomCss", () => $faef32d12c334334$export$31512de7fa606fa4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eJD8u = parcelRequire("eJD8u");
const $faef32d12c334334$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $faef32d12c334334$export$31512de7fa606fa4({ appearance: appearance = 'default', spacing: spacing = 'default', isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, iconIsOnlyChild: iconIsOnlyChild = false, isLoading: isLoading = false, state: state }) {
    let result = (0, $eJD8u.getCss)({
        appearance: appearance,
        spacing: spacing,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    const selector = $faef32d12c334334$var$stateToSelectorMap[state];
    if (selector) result = {
        ...result,
        ...result[selector]
    };
    if (isLoading) result = {
        ...result,
        // Pull overlay styles up to the top
        ...result['&[data-has-overlay="true"]']
    };
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach((key)=>{
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}

});
parcelRegister("eJD8u", function(module, exports) {
$parcel$export(module.exports, "getCss", () => $f3fc4416b1b0dcc2$export$955358618f994a11);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2aEiL = parcelRequire("2aEiL");
const $f3fc4416b1b0dcc2$var$gridSize = 8;
const $f3fc4416b1b0dcc2$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
const $f3fc4416b1b0dcc2$var$heights = {
    default: `${32 / 14}em`,
    // 32px
    compact: `${24 / 14}em`,
    none: 'auto'
};
const $f3fc4416b1b0dcc2$var$lineHeights = {
    default: $f3fc4416b1b0dcc2$var$heights.default,
    compact: $f3fc4416b1b0dcc2$var$heights.compact,
    none: 'inherit'
};
const $f3fc4416b1b0dcc2$var$padding = {
    // 10px gutter
    default: `0 ${$f3fc4416b1b0dcc2$var$gridSize + $f3fc4416b1b0dcc2$var$gridSize / 4}px`,
    compact: `0 ${$f3fc4416b1b0dcc2$var$gridSize + $f3fc4416b1b0dcc2$var$gridSize / 4}px`,
    none: '0'
};
const $f3fc4416b1b0dcc2$var$singleIconPadding = {
    // 2px gutter
    compact: `0 ${$f3fc4416b1b0dcc2$var$gridSize / 4}px`,
    default: `0 ${$f3fc4416b1b0dcc2$var$gridSize / 4}px`,
    none: '0'
};
const $f3fc4416b1b0dcc2$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
const $f3fc4416b1b0dcc2$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
const $f3fc4416b1b0dcc2$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': {
        ...$f3fc4416b1b0dcc2$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    },
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)",
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)",
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    textDecoration: 'none'
};
const $f3fc4416b1b0dcc2$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    },
    textDecoration: 'none'
};
const $f3fc4416b1b0dcc2$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    },
    textDecoration: 'none'
};
const $f3fc4416b1b0dcc2$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    },
    textDecoration: 'none'
};
const $f3fc4416b1b0dcc2$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    },
    textDecoration: 'none'
};
const $f3fc4416b1b0dcc2$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)",
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)",
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    },
    textDecoration: 'none'
};
const $f3fc4416b1b0dcc2$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    },
    textDecoration: 'none'
};
const $f3fc4416b1b0dcc2$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': {
        ...$f3fc4416b1b0dcc2$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    }
};
const $f3fc4416b1b0dcc2$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $f3fc4416b1b0dcc2$export$955358618f994a11({ appearance: appearance, spacing: spacing, isSelected: isSelected, shouldFitContainer: shouldFitContainer, isOnlySingleIcon: isOnlySingleIcon }) {
    const baseAppearanceStyles = {
        ...appearance === 'default' && $f3fc4416b1b0dcc2$var$defaultStyles,
        ...appearance === 'primary' && $f3fc4416b1b0dcc2$var$primaryStyles,
        ...appearance === 'link' && $f3fc4416b1b0dcc2$var$linkStyles,
        ...appearance === 'subtle' && $f3fc4416b1b0dcc2$var$subtleStyles,
        ...appearance === 'subtle-link' && $f3fc4416b1b0dcc2$var$subtleLinkStyles,
        ...appearance === 'warning' && $f3fc4416b1b0dcc2$var$warningStyles,
        ...appearance === 'danger' && $f3fc4416b1b0dcc2$var$dangerStyles
    };
    const appearanceStyles = appearance === 'default' && (0, $2aEiL.fg)('platform-dst-tokens-finesse') ? {
        ...baseAppearanceStyles,
        '&:hover': {
            ...baseAppearanceStyles['&:hover'],
            background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        },
        '&:active': {
            ...baseAppearanceStyles['&:active'],
            background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
        }
    } : baseAppearanceStyles;
    const activeStyles = appearanceStyles['&:active'];
    return {
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-radius-medium, 6px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: `${"var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"}, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)`,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $f3fc4416b1b0dcc2$var$heights[spacing],
        lineHeight: $f3fc4416b1b0dcc2$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $f3fc4416b1b0dcc2$var$singleIconPadding[spacing] : $f3fc4416b1b0dcc2$var$padding[spacing],
        verticalAlign: $f3fc4416b1b0dcc2$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        ...isSelected ? $f3fc4416b1b0dcc2$var$selectedStyles : {
            ...appearanceStyles,
            ...activeStyles && {
                '&:active': {
                    ...activeStyles,
                    transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
                }
            },
            '&[disabled]': {
                color: "var(--ds-text-disabled, #080F214A)",
                backgroundColor: $f3fc4416b1b0dcc2$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent',
                cursor: 'not-allowed',
                textDecoration: 'none',
                '&:hovered': {
                    backgroundColor: $f3fc4416b1b0dcc2$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
                },
                '&:active': {
                    backgroundColor: $f3fc4416b1b0dcc2$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
                }
            },
            ...$f3fc4416b1b0dcc2$var$hasOverlayStyles
        },
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    };
}

});




parcelRegister("injd3", function(module, exports) {
$parcel$export(module.exports, "actionTextColor", () => $50668d198d4251f6$export$7bcfe3cca4dd78b6);
const $50668d198d4251f6$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)",
    normal: "var(--ds-link, #1868DB)"
};

});

parcelRegister("3mn2v", function(module, exports) {
$parcel$export(module.exports, "actionBackgroundColor", () => $8234ac0ce256fbfc$export$81ba6b63eedb299f);
const $8234ac0ce256fbfc$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    info: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    error: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};

});


parcelRegister("k4HTD", function(module, exports) {
$parcel$export(module.exports, "flagBackgroundColor", () => $d5d4fb90f8752990$export$59e42969c95d314);
const $d5d4fb90f8752990$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};

});

parcelRegister("6yOdY", function(module, exports) {
$parcel$export(module.exports, "flagIconColor", () => $3b3c4c0e550a76eb$export$7f70afe2167f8235);
const $3b3c4c0e550a76eb$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #505258)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #292A2E)"
};

});

parcelRegister("14AP4", function(module, exports) {
$parcel$export(module.exports, "flagIconGlyph", () => $50e65d7db70ebbcc$export$73f08aee70487cd4);
parcelRequire("1v5pe");

var $4saCT = parcelRequire("4saCT");

var $kHOHC = parcelRequire("kHOHC");

var $8sBGu = parcelRequire("8sBGu");

var $1LQZ9 = parcelRequire("1LQZ9");

var $kIqwl = parcelRequire("kIqwl");
const $50e65d7db70ebbcc$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4saCT))), {
        label: ""
    }),
    info: /*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kHOHC))), {
        label: ""
    }),
    normal: /*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kHOHC))), {
        label: ""
    }),
    success: /*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8sBGu))), {
        label: ""
    }),
    warning: /*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1LQZ9))), {
        label: ""
    })
};

});
parcelRegister("kHOHC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::341f1a6f1df1c6bee81376e850857e59>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f12f2748c3811675$var$_react = $f12f2748c3811675$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $f12f2748c3811675$var$_iconNew = $f12f2748c3811675$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $f12f2748c3811675$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-information
 * Usage guidance:
 * Reserved for information statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f12f2748c3811675$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $f12f2748c3811675$var$_react.default.createElement($f12f2748c3811675$var$_iconNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$f12f2748c3811675$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $f12f2748c3811675$var$_default = module.exports.default = $f12f2748c3811675$var$StatusInformationIcon;

});

parcelRegister("8sBGu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fec260a5beb0e93db2111df1ab9a2e97>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $628e2b93b0e85985$var$_react = $628e2b93b0e85985$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $628e2b93b0e85985$var$_iconNew = $628e2b93b0e85985$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $628e2b93b0e85985$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-success
 * Usage guidance:
 * Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $628e2b93b0e85985$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $628e2b93b0e85985$var$_react.default.createElement($628e2b93b0e85985$var$_iconNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$628e2b93b0e85985$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $628e2b93b0e85985$var$_default = module.exports.default = $628e2b93b0e85985$var$StatusSuccessIcon;

});

parcelRegister("1LQZ9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd90c08a28534c92e68f27855e77fa64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $14a347fd5452dd17$var$_react = $14a347fd5452dd17$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $14a347fd5452dd17$var$_iconNew = $14a347fd5452dd17$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $14a347fd5452dd17$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-warning
 * Usage guidance:
 * Reserved for warning statuses.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $14a347fd5452dd17$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $14a347fd5452dd17$var$_react.default.createElement($14a347fd5452dd17$var$_iconNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$14a347fd5452dd17$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $14a347fd5452dd17$var$_default = module.exports.default = $14a347fd5452dd17$var$StatusWarningIcon;

});


parcelRegister("htM0G", function(module, exports) {
$parcel$export(module.exports, "flagTextColor", () => $306760556fb3f179$export$f50075b2584087f);
const $306760556fb3f179$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};

});

parcelRegister("3P3M8", function(module, exports) {
$parcel$export(module.exports, "flagTextColorToken", () => $0e27f87bdc84a579$export$13b42cd9d596bfe0);
const $0e27f87bdc84a579$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    normal: "var(--ds-text, #292A2E)",
    success: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)"
};

});

parcelRegister("87cVw", function(module, exports) {
$parcel$export(module.exports, "default", () => $92c3810d9d45853e$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $hHzJx = parcelRequire("hHzJx");

var $6p0OQ = parcelRequire("6p0OQ");

var $See7r = parcelRequire("See7r");

var $ebDRY = parcelRequire("ebDRY");

var $3P3M8 = parcelRequire("3P3M8");

var $kIqwl = parcelRequire("kIqwl");
const $92c3810d9d45853e$var$DismissButtonComponent = ({ appearance: appearance, onClick: onClick, isBold: isBold, isExpanded: isExpanded, testId: testId })=>{
    let ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($ebDRY)));
    let buttonLabel = 'Dismiss';
    let buttonTestId = testId && `${testId}-dismiss`;
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($See7r))) : (0, (/*@__PURE__*/$parcel$interopDefault($6p0OQ)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        buttonTestId = testId && `${testId}-toggle`;
    }
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $hHzJx.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $kIqwl.jsx)(ButtonIcon, {
                ...iconProps,
                size: "small",
                label: "",
                color: (0, $3P3M8.flagTextColorToken)[appearance]
            }),
        appearance: "subtle",
        spacing: "compact",
        label: buttonLabel,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    });
};
const $92c3810d9d45853e$var$DismissButton = /*#__PURE__*/ (0, $1v5pe.memo)($92c3810d9d45853e$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$92c3810d9d45853e$export$2e2bcd8739ae039 = $92c3810d9d45853e$var$DismissButton;

});
parcelRegister("hHzJx", function(module, exports) {
$parcel$export(module.exports, "default", () => $a449b98196b2c781$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $fl4ll = parcelRequire("fl4ll");

var $1Tz0w = parcelRequire("1Tz0w");

var $kFr83 = parcelRequire("kFr83");

var $1895S = parcelRequire("1895S");

var $1TZ74 = parcelRequire("1TZ74");

var $lreqQ = parcelRequire("lreqQ");

var $kIqwl = parcelRequire("kIqwl");
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ const $a449b98196b2c781$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).forwardRef(function Button({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    if (isTooltipDisabled) return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1895S.default), {
        ...saferRest,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $1TZ74.default), {
            type: "icon",
            isLoading: isLoading,
            children: [
                /*#__PURE__*/ (0, $kIqwl.jsx)((0, $lreqQ.default), {
                    icon: icon,
                    spacing: spacing
                }),
                /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kFr83.default), {
                    children: label
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1Tz0w.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        hasNewContentOnTriggerClick: tooltip?.hasNewContentOnTriggerClick,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents,
        shortcut: tooltip?.shortcut,
        children: (triggerProps)=>/*#__PURE__*/ (0, $kIqwl.jsx)((0, $1895S.default), {
                ...saferRest,
                appearance: appearance,
                autoFocus: autoFocus,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isSelected: isSelected,
                isIconButton: true,
                isCircle: shape === 'circle',
                hasIconBefore: false,
                spacing: spacing,
                ariaLabelledBy: ariaLabelledBy,
                onClick: (e, analyticsEvent)=>{
                    onClick?.(e, analyticsEvent);
                    triggerProps.onClick?.(e);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                ref: (0, $fl4ll.default)([
                    ref,
                    triggerProps?.ref
                ].filter(Boolean)),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                type: type,
                testId: testId,
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                componentName: "IconButton",
                children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $1TZ74.default), {
                    type: "icon",
                    isLoading: isLoading,
                    children: [
                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $lreqQ.default), {
                            icon: icon,
                            spacing: spacing
                        }),
                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kFr83.default), {
                            children: label
                        })
                    ]
                })
            })
    });
}));
$a449b98196b2c781$var$IconButton.displayName = 'IconButton';
var $a449b98196b2c781$export$2e2bcd8739ae039 = $a449b98196b2c781$var$IconButton;

});
parcelRegister("fl4ll", function(module, exports) {
$parcel$export(module.exports, "default", () => $13062f7697472575$export$2e2bcd8739ae039);
function $13062f7697472575$export$2e2bcd8739ae039(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && typeof ref === 'object') ref.current = value;
        });
    };
}

});

parcelRegister("1Tz0w", function(module, exports) {
$parcel$export(module.exports, "default", () => $7508eca7c3ede388$export$2e2bcd8739ae039);
/* tooltip.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $7IGXm = parcelRequire("7IGXm");

var $fl4ll = parcelRequire("fl4ll");

var $aD9yk = parcelRequire("aD9yk");

var $jwdiX = parcelRequire("jwdiX");

var $dEAlx = parcelRequire("dEAlx");

var $fsl6p = parcelRequire("fsl6p");

var $7dKqR = parcelRequire("7dKqR");

var $etMwD = parcelRequire("etMwD");

var $2aEiL = parcelRequire("2aEiL");

var $5PkvR = parcelRequire("5PkvR");

var $kARP4 = parcelRequire("kARP4");

var $iMM0r = parcelRequire("iMM0r");

var $fBJWG = parcelRequire("fBJWG");

var $jL9lp = parcelRequire("jL9lp");

var $4RAor = parcelRequire("4RAor");

var $hWoE3 = parcelRequire("hWoE3");

var $4XO6k = parcelRequire("4XO6k");

var $lsSZw = parcelRequire("lsSZw");

var $6wPh7 = parcelRequire("6wPh7");

var $dgDxP = parcelRequire("dgDxP");

var $2GGcL = parcelRequire("2GGcL");

var $4w8qa = parcelRequire("4w8qa");

var $g8xuk = parcelRequire("g8xuk");

var $kIqwl = parcelRequire("kIqwl");
const $7508eca7c3ede388$var$_2 = "._j7hq1a5s{animation-name:var(--ds-keyframe-fade-out,FadeOut100to0)}";
const $7508eca7c3ede388$var$_ = "._j7hq1bym{animation-name:var(--ds-keyframe-fade-in,FadeIn0to100)}";
const $7508eca7c3ede388$var$tooltipZIndex = (0, $iMM0r.layers).tooltip();
const $7508eca7c3ede388$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: undefined,
    packageVersion: undefined
}; // Inverts motion direction
const $7508eca7c3ede388$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
}; /**
              * Converts a Popper placement to it's general direction.
              *
              * @param placement - Popper Placement value, e.g. 'top-start'
              * @returns Popper Direction, e.g. 'top'
              */ 
const $7508eca7c3ede388$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0]; /**
                                                                                                                * For the `platform-dst-top-layer-tooltip` path only. Always `false` when that
                                                                                                                * gate is off, so this cannot affect the legacy path even if it gains a caller
                                                                                                                * there.
                                                                                                                *
                                                                                                                * `mouseover` also fires when the pointer crosses boundaries between elements
                                                                                                                * _inside_ the trigger. A `relatedTarget` the trigger does not contain is what
                                                                                                                * distinguishes a real re-entry (or, for `mouseout`, a real exit) from one of those.
                                                                                                                */ 
function $7508eca7c3ede388$var$isTopLayerPointerReEntry({ trigger: trigger, relatedTarget: relatedTarget }) {
    if (!(0, $2aEiL.fg)('platform-dst-top-layer-tooltip')) return false;
     // Missing trigger, or pointer from outside the document. Treat both as an
    // entry so we cannot get stuck suppressed.
    if (!trigger || !(relatedTarget instanceof Node)) return true;
    return !trigger.contains(relatedTarget);
}
function $7508eca7c3ede388$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, component: Container = (0, $g8xuk.default), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, $aD9yk.default), onHide: onHide = (0, $aD9yk.default), canAppear: canAppear, hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, hasNewContentOnTriggerClick: hasNewContentOnTriggerClick = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = false, shortcut: shortcut, shouldAlwaysFadeIn: shouldAlwaysFadeIn = false, shouldRenderToParent: shouldRenderToParent = false }) {
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    const isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    const tooltipPosition = isMousePosition ? mousePosition : position; // The deprecated hide props win over `hasNewContentOnTriggerClick`, as the prop
    // docs say. Setting both is a mistake, so keep the older behaviour. Read only
    // together with `platform-dst-top-layer-tooltip`; without the gate a press
    // never closes.
    const isStayOpenOnTriggerClick = hasNewContentOnTriggerClick && !hideTooltipOnClick && !hideTooltipOnMouseDown;
    const onShowHandler = (0, $7IGXm.usePlatformLeafSyntheticEventHandler)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext,
        ...$7508eca7c3ede388$var$analyticsAttributes
    });
    const onHideHandler = (0, $7IGXm.usePlatformLeafSyntheticEventHandler)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext,
        ...$7508eca7c3ede388$var$analyticsAttributes
    });
    const apiRef = (0, $1v5pe.useRef)(null);
    const [state, setState] = (0, $1v5pe.useState)('hide');
    const targetRef = (0, $1v5pe.useRef)(null);
    const containerRef = (0, $1v5pe.useRef)(null); // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    const setImplicitRefFromChildren = (node)=>{
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    }; // This is memoized and passed into the render props callback.
    const setDirectRef = (0, $1v5pe.useCallback)((node)=>{
        targetRef.current = node;
    }, []); // Putting a few things into refs so that we don't have to break memoization
    const stableState = (0, $dEAlx.default)(state); // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    const onShowHandlerStable = (0, $dEAlx.default)(onShowHandler);
    const onHideHandlerStable = (0, $dEAlx.default)(onHideHandler);
    const delayStable = (0, $dEAlx.default)(delay);
    const canAppearStable = (0, $dEAlx.default)(canAppear);
    const hasCalledShowHandler = (0, $1v5pe.useRef)(false);
    const shouldAlwaysFadeInStable = (0, $dEAlx.default)(shouldAlwaysFadeIn);
    const start = (0, $1v5pe.useCallback)((api)=>{
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    const done = (0, $1v5pe.useCallback)(()=>{
        if (!apiRef.current) return;
         // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
        hasCalledShowHandler.current = false; // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    const abort = (0, $1v5pe.useCallback)(()=>{
        if (!apiRef.current) return;
        apiRef.current.abort(); // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $1v5pe.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    const isDraggingRef = (0, $1v5pe.useRef)(false);
    (0, $1v5pe.useEffect)(()=>{
        return (0, $lsSZw.register)({
            onRegister ({ isDragging: isDragging }) {
                isDraggingRef.current = isDragging;
            },
            onDragStart () {
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ apiRef.current?.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd () {
                isDraggingRef.current = false;
            }
        });
    }, []); // Set by Escape, light dismiss or a press on the trigger. Every read and write is
    // behind `platform-dst-top-layer-tooltip`.
    const isDismissedUntilTriggerLeaveRef = (0, $1v5pe.useRef)(false);
    const tryShowTooltip = (0, $1v5pe.useCallback)((source)=>{
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
         // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
         // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        } // After the "already active" check, so a held press stays visible.
        if (isDismissedUntilTriggerLeaveRef.current && (0, $2aEiL.fg)('platform-dst-top-layer-tooltip')) return;
         /**
       * Check if tooltip is allowed to show.
       *
       * Once a tooltip has started, or has scheduled to start
       * we won't be checking `canAppear` again.
       *
       * - We don't want tooltips to disappear once they are shown
       * - For consistency, we start after a single positive `canAppear`.
       *   Otherwise the amount of times we ask consumers would depend on
       *   how many times we get a "mousemove", which _could_ lead to situations
       *   where moving the mouse could result in a different outcome to if
       *   the mouse was not moved.
       */ 
        if (canAppearStable.current && !canAppearStable.current?.()) return;
        const entry = {
            source: source,
            delay: delayStable.current,
            show: ({ isImmediate: isImmediate })=>{
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: ({ isImmediate: isImmediate })=>{
                if (isImmediate) setState('hide');
                else if ((0, $2aEiL.fg)('platform-dst-top-layer-tooltip')) // Top-layer path: set state to 'top-layer-exit'. The component
                // stays mounted and Popover's isOpen prop transitions to
                // false, triggering the CSS exit animation internally.
                // finishHideAnimation is called after a brief delay matching
                // the CSS exit animation duration.
                setState('top-layer-exit');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: shouldAlwaysFadeInStable.current
        };
        const api = (0, $2GGcL.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    const hideTooltipOnEsc = (0, $1v5pe.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]); // When using top-layer, popover="hint" handles Escape natively
    (0, $jwdiX.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out' || state === 'top-layer-exit' || (0, $2aEiL.fg)('platform-dst-top-layer-tooltip')
    }); // ── Top-layer exit animation lifecycle ──
    // When state is 'top-layer-exit', Popover's isOpen transitions to false and
    // the CSS exit animation plays. The Popover's built-in `transitionend`
    // detection (with timeout fallback) calls `onExitFinish` when the exit
    // animation completes, which triggers the tooltip-manager lifecycle
    // (finishHideAnimation → done → onHide, setState('hide'), cleanup).
    const handleExitFinish = (0, $1v5pe.useCallback)(()=>{
        apiRef.current?.finishHideAnimation();
    }, []); // Browser dismiss: Escape, or light dismiss on pointerup.
    const handlePopoverClose = (0, $1v5pe.useCallback)(()=>{
        if ((0, $2aEiL.fg)('platform-dst-top-layer-tooltip')) isDismissedUntilTriggerLeaveRef.current = true;
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $1v5pe.useEffect)(()=>{
        if (state === 'hide') return 0, $aD9yk.default;
        if (state === 'before-fade-out') setState('fade-out');
        const unbind = (0, $dmmsG.bind)(window, {
            type: 'scroll',
            listener: ()=>{
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    const onMouseDown = (0, $1v5pe.useCallback)(()=>{
        // `hasNewContentOnTriggerClick`: `TopLayerTooltipPopup` re-shows the popover
        // after the light dismiss, so there is nothing to record, and a pending
        // show goes ahead with the new content, as it does without the gate.
        if (isStayOpenOnTriggerClick && (0, $2aEiL.fg)('platform-dst-top-layer-tooltip')) return;
         // Set now: light dismiss only hides on pointerup.
        if ((0, $2aEiL.fg)('platform-dst-top-layer-tooltip')) isDismissedUntilTriggerLeaveRef.current = true;
         // A press inside the show delay never reaches light dismiss, because no
        // popover is open on pointerup. Cancel the pending show so a quick click
        // does not surface a tooltip over content the press just changed.
        const shouldCancelPendingShow = stableState.current === 'hide' && (0, $2aEiL.fg)('platform-dst-top-layer-tooltip');
        if ((hideTooltipOnMouseDown || shouldCancelPendingShow) && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown,
        isStayOpenOnTriggerClick,
        stableState
    ]);
    const onClick = (0, $1v5pe.useCallback)(()=>{
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]); // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOver = (0, $1v5pe.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
         // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault(); // Not on a boundary crossing inside the trigger.
        if ($7508eca7c3ede388$var$isTopLayerPointerReEntry({
            trigger: targetRef.current,
            relatedTarget: event.relatedTarget
        }) && (0, $2aEiL.fg)('platform-dst-top-layer-tooltip')) isDismissedUntilTriggerLeaveRef.current = false;
        const source = isMousePosition ? {
            type: 'mouse',
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]); // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOut = (0, $1v5pe.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
         // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault(); // Not on a boundary crossing inside the trigger.
        if ($7508eca7c3ede388$var$isTopLayerPointerReEntry({
            trigger: targetRef.current,
            relatedTarget: event.relatedTarget
        }) && (0, $2aEiL.fg)('platform-dst-top-layer-tooltip')) isDismissedUntilTriggerLeaveRef.current = false;
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onMouseMove = isMousePosition ? (event)=>{
        if (apiRef.current?.isActive()) apiRef.current.mousePos = {
            clientX: event.clientX,
            clientY: event.clientY
        };
    } : undefined;
    const onMouseOverTooltip = (0, $1v5pe.useCallback)(()=>{
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    const onFocus = (0, $1v5pe.useCallback)((e)=>{
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch  {} // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    const onBlur = (0, $1v5pe.useCallback)(()=>{
        if ((0, $2aEiL.fg)('platform-dst-top-layer-tooltip')) isDismissedUntilTriggerLeaveRef.current = false;
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onAnimationFinished = (0, $1v5pe.useCallback)((transition)=>{
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]); // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    const shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    const shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out' && state !== 'top-layer-exit';
    const handleOpenLayerObserverCloseSignal = (0, $1v5pe.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, []); // Called unconditionally so the hook order never depends on the feature
    // flag value. On the top-layer path a tooltip is not a layer (open layer
    // checks skip tooltips), so it does not register with the observer.
    (0, $fsl6p.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        isEnabled: !(0, $2aEiL.fg)('platform-dst-top-layer-tooltip'),
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    const getReferenceElement = ()=>{
        if (isMousePosition && apiRef.current?.mousePos && targetRef.current) return (0, $dgDxP.getVirtualElementFromMousePos)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        return targetRef.current || undefined;
    };
    const tooltipIdForHiddenContent = (0, $4w8qa.default)('tooltip', shouldRenderHiddenContent);
    const tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    }; // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    const isChildrenAFunction = typeof children === 'function';
    (0, $1v5pe.useEffect)(()=>{
        if (isChildrenAFunction) return;
         // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        const target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return ()=>target.removeAttribute('aria-describedby');
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    const hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
        "data-testid": testId ? `${testId}-hidden` : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent,
        children: typeof content === 'function' ? content({}) : content
    }) : null;
    const PopperWrapper = shouldRenderToParent ? (0, $1v5pe.Fragment) : $7508eca7c3ede388$var$TooltipPortal;
    const trigger = typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, $kIqwl.jsxs)((0, $1v5pe.Fragment), {
        children: [
            children({
                ...tooltipTriggerProps,
                // `testId` propagates to the trigger element so `data-testid` lands in the
                // rendered DOM. Required because `@atlaskit/button/new` (and other Pressable-
                // backed primitives) overwrite `data-testid` from spread; passing a typed
                // `testId` lets their own destructure pick it up directly.
                ...testId ? {
                    testId: `${testId}--container`
                } : {},
                'aria-describedby': tooltipIdForHiddenContent,
                ref: setDirectRef
            }),
            hiddenContent
        ]
    }) : /*#__PURE__*/ (0, $kIqwl.jsxs)(CastTargetContainer, {
        ...tooltipTriggerProps,
        ...testId ? {
            'data-testid': `${testId}--container`
        } : undefined,
        ref: setImplicitRefFromChildren /**
                                     * TODO: Why is role="presentation" added?
                                     * - Is it only to "remove" the `Container` from screen readers?
                                     * - Why is it added only to the `Container` but not to `tooltipTriggerProps`?
                                     * - Should `role="presentation"` only be used if `shouldRenderHiddenContent == false`?
                                     */ ,
        role: "presentation",
        children: [
            children,
            hiddenContent
        ]
    });
    if ((0, $2aEiL.fg)('platform-dst-top-layer-tooltip')) return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $1v5pe.Fragment), {
        children: [
            trigger,
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $kIqwl.jsx)($7508eca7c3ede388$var$TopLayerTooltipPopup, {
                targetRef: targetRef,
                tooltipPosition: tooltipPosition,
                mousePos: apiRef.current?.mousePos ?? undefined,
                position: position,
                onMouseOut: onMouseOut,
                onMouseOverTooltip: onMouseOverTooltip,
                ignoreTooltipPointerEvents: ignoreTooltipPointerEvents,
                truncate: truncate,
                testId: testId,
                shortcut: shortcut,
                content: content,
                Container: Container,
                onClose: handlePopoverClose,
                shouldStayOpenOnTriggerClick: isStayOpenOnTriggerClick,
                onExitFinish: handleExitFinish,
                isOpen: state !== 'hide' && state !== 'top-layer-exit'
            }) : null
        ]
    });
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $1v5pe.Fragment), {
        children: [
            trigger,
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $kIqwl.jsx)(PopperWrapper, {
                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $5PkvR.Popper), {
                    placement: tooltipPosition,
                    referenceElement: getReferenceElement(),
                    strategy: strategy,
                    children: ({ ref: ref, style: style, update: update, placement: placement })=>{
                        const direction = isMousePosition ? undefined : $7508eca7c3ede388$var$invertedDirection[$7508eca7c3ede388$var$getDirectionFromPlacement(placement)];
                        return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7dKqR.default), {
                            appear: true,
                            children: shouldRenderTooltipChildren && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $etMwD.default), {
                                distance: "constant",
                                entranceDirection: direction,
                                exitDirection: direction,
                                onFinish: onAnimationFinished,
                                duration: state !== 'show-immediate' ? 'medium' : 'none',
                                children: ({ className: className })=>/*#__PURE__*/ (0, $kIqwl.jsx)(Container, {
                                        ref: ref /**
                          * "Tooltip" classname is a hook used by tests to manipulate
                          * and hide tooltips, including in VR snapshots
                          */ ,
                                        className: `Tooltip ${className}`,
                                        style: {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...style,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...ignoreTooltipPointerEvents && {
                                                pointerEvents: 'none'
                                            }
                                        },
                                        truncate: truncate,
                                        placement: tooltipPosition,
                                        testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                                        onMouseOut: onMouseOut,
                                        onMouseOver: onMouseOverTooltip,
                                        shortcut: shortcut,
                                        children: typeof content === 'function' ? content({
                                            update: update
                                        }) : content
                                    })
                            })
                        });
                    }
                })
            }) : null
        ]
    });
}
var $7508eca7c3ede388$export$2e2bcd8739ae039 = $7508eca7c3ede388$var$Tooltip;
const $7508eca7c3ede388$var$TooltipPortal = ({ children: children })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kARP4.default), {
        zIndex: $7508eca7c3ede388$var$tooltipZIndex,
        children: children
    });
};
const $7508eca7c3ede388$var$tooltipMouseAnimationStyles = {
    enter: "_j7hq1bym",
    exit: "_j7hq1a5s"
}; /**
    * Top-layer tooltip popup component.
    *
    * Composes `Popover` (top-layer visibility + animation) with two positioning
    * hooks, of which EXACTLY ONE is enabled - two writing to the same popover would
    * fight for ownership, so `isEnabled` is derived from one boolean and negated:
    *
    *   - `useAnchoredPopoverAtPoint` for cursor-tracking positions (`mouse`,
    *     `mouse-x`, `mouse-y`) activated by a pointer.
    *   - `useAnchoredPopover` for everything else, including a cursor position
    *     activated via keyboard focus, where there is no cursor to track and
    *     anchoring to the trigger is what keeps the tooltip beside the target.
    *
    * Exit animation is handled by `Popover`'s `isOpen` prop. When `isOpen`
    * transitions to `false`, the primitive calls `hidePopover()` internally and
    * the CSS exit animation plays via `allow-discrete`. No glue code needed.
    */ 
function $7508eca7c3ede388$var$TopLayerTooltipPopup({ targetRef: targetRef, tooltipPosition: tooltipPosition, mousePos: mousePos, position: position, onMouseOut: onMouseOut, onMouseOverTooltip: onMouseOverTooltip, ignoreTooltipPointerEvents: ignoreTooltipPointerEvents, truncate: truncate, testId: testId, shortcut: shortcut, content: content, Container: Container, onClose: onClose, onExitFinish: onExitFinish, isOpen: isOpen, shouldStayOpenOnTriggerClick: shouldStayOpenOnTriggerClick }) {
    const popoverRef = (0, $1v5pe.useRef)(null); // Never read. Some custom `component` wrappers render nothing without a ref.
    const containerRef = (0, $1v5pe.useRef)(null); // The host unmounts on close and remounts on open, so set `data-placement`
    // whenever a node attaches, as well as when the placement changes.
    const setPopoverNode = (0, $1v5pe.useCallback)((node)=>{
        node?.setAttribute('data-placement', tooltipPosition);
    }, [
        tooltipPosition
    ]);
    const hostRef = (0, $fl4ll.default)([
        popoverRef,
        setPopoverNode
    ]); // `shouldStayOpenOnTriggerClick`: a press on the trigger light-dismisses the hint
    // popover, and the browser gives no way to cancel that. The dismiss runs
    // before the `pointerup` is dispatched, so show the popover again from the
    // trigger's `pointerup`. It is the same task, so no closed frame is painted,
    // the entry transition does not restart, and the `toggle` events coalesce
    // to open -> open, so `onClose` is not called. `mouseup` covers
    // environments that dismiss on `mouseup` too, such as the test polyfill.
    // `showPopover()` does nothing when the popover is already open. A layout
    // effect, so the listener is gone in the same commit that closes the
    // popover: a passive cleanup runs later, and a `pointerup` in that gap would
    // re-open a closing tooltip.
    (0, $1v5pe.useLayoutEffect)(()=>{
        const trigger = targetRef.current;
        if (!shouldStayOpenOnTriggerClick || !isOpen || !trigger) return;
        const reshow = ()=>{
            try {
                popoverRef.current?.showPopover();
            } catch  {}
        };
        return (0, $dmmsG.bindAll)(trigger, [
            {
                type: 'pointerup',
                listener: reshow
            },
            {
                type: 'mouseup',
                listener: reshow
            }
        ]);
    }, [
        shouldStayOpenOnTriggerClick,
        isOpen,
        targetRef
    ]); // Translate the legacy Popper-style placement string ("right",
    // "bottom-start", etc.) once and pass the same object to the hook and
    // to `Popover`.
    const placement = (0, $fBJWG.fromLegacyPlacement)({
        legacy: tooltipPosition
    });
    const isMousePosition = position === 'mouse' || position === 'mouse-x' || position === 'mouse-y';
    const isMouseStrategyActive = isMousePosition && Boolean(mousePos); // One object so the two calls cannot drift on `placement` or `isOpen`.
    const sharedPositioning = {
        popoverRef: popoverRef,
        placement: placement,
        isOpen: isOpen
    };
    (0, $4RAor.useAnchoredPopover)({
        ...sharedPositioning,
        anchorRef: targetRef,
        isEnabled: !isMouseStrategyActive
    }); // `getPoint()` is latched once per activation, which is per-show here because
    // `TopLayerTooltipPopup` mounts fresh on every show. `null` before the trigger
    // has mounted applies no positioning at all.
    (0, $hWoE3.useAnchoredPopoverAtPoint)({
        ...sharedPositioning,
        isEnabled: isMouseStrategyActive,
        getPoint: ()=>{
            if (!mousePos || !targetRef.current || !isMousePosition) return null;
            return (0, $6wPh7.getAnchorPoint)({
                cursor: mousePos,
                triggerRect: targetRef.current.getBoundingClientRect(),
                tooltipPosition: position,
                placement: placement
            });
        }
    });
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $7508eca7c3ede388$var$_,
                    $7508eca7c3ede388$var$_2
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jL9lp.Popover), {
                ref: hostRef,
                role: "tooltip",
                mode: "hint",
                isOpen: isOpen,
                onClose: onClose,
                onExitFinish: onExitFinish,
                testId: testId ? `${testId}--popover` : undefined,
                shouldAnimate: true,
                enteringAnimationXcss: isMouseStrategyActive && $7508eca7c3ede388$var$tooltipMouseAnimationStyles.enter,
                exitingAnimationXcss: isMouseStrategyActive && $7508eca7c3ede388$var$tooltipMouseAnimationStyles.exit,
                placement: placement,
                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $4XO6k.DefaultRoleContext).Provider, {
                    value: "presentation",
                    children: /*#__PURE__*/ (0, $kIqwl.jsx)(Container, {
                        ref: containerRef // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- top-layer spike
                        ,
                        className: "Tooltip" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- top-layer spike
                        ,
                        style: ignoreTooltipPointerEvents ? {
                            pointerEvents: 'none'
                        } : undefined,
                        truncate: truncate,
                        placement: tooltipPosition,
                        testId: testId,
                        onMouseOut: onMouseOut,
                        onMouseOver: onMouseOverTooltip,
                        shortcut: shortcut,
                        children: typeof content === 'function' ? content({
                            update: (0, $aD9yk.default)
                        }) : content
                    })
                })
            })
        ]
    });
}

});
parcelRegister("7IGXm", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $7edeb4032320163a$export$1a04351537078b55);

var $1v5pe = parcelRequire("1v5pe");

var $8g8jL = parcelRequire("8g8jL");

var $gEAl7 = parcelRequire("gEAl7");
function $7edeb4032320163a$export$1a04351537078b55({ fn: fn, action: action, componentName: componentName, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $8g8jL.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $gEAl7.useTrackedRef)(analyticsData);
    const fnRef = (0, $gEAl7.useTrackedRef)(fn);
    const handler = (0, $1v5pe.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("jwdiX", function(module, exports) {
$parcel$export(module.exports, "default", () => $46f3cfe723189ed0$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $2cXad = parcelRequire("2cXad");
function $46f3cfe723189ed0$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $1v5pe.useRef)(false);
    const onKeyDown = (0, $1v5pe.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== (0, $2cXad.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, $1v5pe.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $1v5pe.useEffect)(()=>{
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $dmmsG.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("2cXad", function(module, exports) {
$parcel$export(module.exports, "KEY_UP", () => $aba1f1569d49f646$export$390330c10ff2b9a1);
$parcel$export(module.exports, "KEY_DOWN", () => $aba1f1569d49f646$export$a80636c6f41931fe);
$parcel$export(module.exports, "KEY_LEFT", () => $aba1f1569d49f646$export$fc4577f2a2af0ae3);
$parcel$export(module.exports, "KEY_RIGHT", () => $aba1f1569d49f646$export$c40f9845adc73fb5);
$parcel$export(module.exports, "KEY_HOME", () => $aba1f1569d49f646$export$4af703091671bc);
$parcel$export(module.exports, "KEY_END", () => $aba1f1569d49f646$export$e2bc30913faa5db7);
$parcel$export(module.exports, "KEY_TAB", () => $aba1f1569d49f646$export$10f6869ed0a7d75b);
$parcel$export(module.exports, "KEY_ENTER", () => $aba1f1569d49f646$export$8152f929a25a0ff4);
$parcel$export(module.exports, "KEY_SPACE", () => $aba1f1569d49f646$export$e51a3576c045c8d5);
$parcel$export(module.exports, "ESCAPE", () => $aba1f1569d49f646$export$2bb790b9008907b4);
/**
 * Character key codes which can be used in keyboard events.
 */ const $aba1f1569d49f646$export$390330c10ff2b9a1 = 'ArrowUp';
const $aba1f1569d49f646$export$a80636c6f41931fe = 'ArrowDown';
const $aba1f1569d49f646$export$fc4577f2a2af0ae3 = 'ArrowLeft';
const $aba1f1569d49f646$export$c40f9845adc73fb5 = 'ArrowRight';
const $aba1f1569d49f646$export$4af703091671bc = 'Home';
const $aba1f1569d49f646$export$e2bc30913faa5db7 = 'End';
const $aba1f1569d49f646$export$10f6869ed0a7d75b = 'Tab';
const $aba1f1569d49f646$export$8152f929a25a0ff4 = 'Enter';
const $aba1f1569d49f646$export$e51a3576c045c8d5 = 'Space';
const $aba1f1569d49f646$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("dEAlx", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4ab0237e0a03052$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");
function $d4ab0237e0a03052$export$2e2bcd8739ae039(value) {
    const ref = (0, $1v5pe.useRef)(value);
    (0, $1v5pe.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("fsl6p", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $1f73df27f354f7e8$export$469bb693f11edc7f);

var $1v5pe = parcelRequire("1v5pe");

var $cukzB = parcelRequire("cukzB");

var $1V1we = parcelRequire("1V1we");
function $1f73df27f354f7e8$export$469bb693f11edc7f({ isOpen: isOpen, type: type, onClose: onClose, isEnabled: isEnabled = true }) {
    const context = (0, $1v5pe.useContext)((0, $cukzB.OpenLayerObserverContext));
    const namespace = (0, $1V1we.useOpenLayerObserverNamespace)();
    (0, $1v5pe.useEffect)(()=>{
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null || !isEnabled) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isEnabled,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("cukzB", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $f6b360a3e53a3771$export$5fbf4d7fae6cdc00);

var $1v5pe = parcelRequire("1v5pe");
const $f6b360a3e53a3771$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $1v5pe.createContext)(null);

});

parcelRegister("1V1we", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $4c28ca6745dc2c5a$export$1d57e79091cc3046);

var $1v5pe = parcelRequire("1v5pe");

var $dFLT5 = parcelRequire("dFLT5");
function $4c28ca6745dc2c5a$export$1d57e79091cc3046() {
    const namespace = (0, $1v5pe.useContext)((0, $dFLT5.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("dFLT5", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $bd835c38de8ca8c2$export$644a49f3b8c50fcd);

var $1v5pe = parcelRequire("1v5pe");
const $bd835c38de8ca8c2$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $1v5pe.createContext)(null);

});



parcelRegister("etMwD", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff3250e67f6712eb$export$2e2bcd8739ae039);
parcelRequire("1v5pe");

var $4G6iD = parcelRequire("4G6iD");

var $kIqwl = parcelRequire("kIqwl");
const $ff3250e67f6712eb$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $ff3250e67f6712eb$var$FadeIn = ({ children: children, duration: duration = 'large', entranceDirection: entranceDirection, exitDirection: exitDirection, distance: distance = 'proportional', onFinish: onFinish, isPaused: isPaused })=>{
    const invertedEntranceDirection = entranceDirection !== undefined ? $ff3250e67f6712eb$var$invertedDirection[entranceDirection] : undefined;
    const isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? `fade-out-from-${exitDirection || invertedEntranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-out';
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $4G6iD.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? `fade-in-from-${entranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused,
        children: children
    });
};
var $ff3250e67f6712eb$export$2e2bcd8739ae039 = $ff3250e67f6712eb$var$FadeIn;

});
parcelRegister("4G6iD", function(module, exports) {
$parcel$export(module.exports, "default", () => $d31bc9ba961aead9$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $bKulK = parcelRequire("bKulK");

var $aWXtu = parcelRequire("aWXtu");

var $9RhH4 = parcelRequire("9RhH4");

var $hU6dr = parcelRequire("hU6dr");

var $cUr2h = parcelRequire("cUr2h");

var $d1xmU = parcelRequire("d1xmU");

var $kIqwl = parcelRequire("kIqwl");
const $d31bc9ba961aead9$var$_72 = "._j7hq1pgp{animation-name:k1ylodgn}";
const $d31bc9ba961aead9$var$_71 = "@keyframes k1ylodgn{0%{opacity:1;transform:translate3d(0,0,0)}to{opacity:0;transform:translate3d(4px,0,0)}}";
const $d31bc9ba961aead9$var$_70 = "._j7hqt8u5{animation-name:k1vint76}";
const $d31bc9ba961aead9$var$_69 = "@keyframes k1vint76{0%{opacity:0;transform:translate3d(4px,0,0)}50%{opacity:1}to{opacity:1;transform:none}}";
const $d31bc9ba961aead9$var$_68 = "._j7hqwo7r{animation-name:k73gfcn}";
const $d31bc9ba961aead9$var$_67 = "@keyframes k73gfcn{0%{opacity:1;transform:translate3d(0,0,0)}to{opacity:0;transform:translate3d(0,4px,0)}}";
const $d31bc9ba961aead9$var$_66 = "._j7hq797a{animation-name:k1h8oue3}";
const $d31bc9ba961aead9$var$_65 = "@keyframes k1h8oue3{0%{opacity:0;transform:translate3d(0,4px,0)}50%{opacity:1}to{opacity:1;transform:none}}";
const $d31bc9ba961aead9$var$_64 = "._j7hq15do{animation-name:k7ccisj}";
const $d31bc9ba961aead9$var$_63 = "@keyframes k7ccisj{0%{opacity:1;transform:translate3d}to{opacity:0;transform:translate3d(-4px,0,0)}}";
const $d31bc9ba961aead9$var$_62 = "._j7hqovgq{animation-name:km3530i}";
const $d31bc9ba961aead9$var$_61 = "@keyframes km3530i{0%{opacity:0;transform:translate3d(-4px,0,0)}50%{opacity:1}to{opacity:1;transform:none}}";
const $d31bc9ba961aead9$var$_60 = "._j7hq97jn{animation-name:k11647nu}";
const $d31bc9ba961aead9$var$_59 = "@keyframes k11647nu{0%{opacity:1;transform:translate3d(0,0,0)}to{opacity:0;transform:translate3d(0,-4px,0)}}";
const $d31bc9ba961aead9$var$_58 = "._j7hqm2e2{animation-name:k1fo8igf}";
const $d31bc9ba961aead9$var$_57 = "@keyframes k1fo8igf{0%{opacity:0;transform:translate3d(0,-4px,0)}50%{opacity:1}to{opacity:1;transform:none}}";
const $d31bc9ba961aead9$var$_56 = "._j7hq1ebg{animation-name:k1dj5hf1}";
const $d31bc9ba961aead9$var$_55 = "@keyframes k1dj5hf1{0%{opacity:1;transform:translate3d(0,0,0)}to{opacity:0;transform:translate3d(calc(5% + 4px),0,0)}}";
const $d31bc9ba961aead9$var$_54 = "._j7hqpqak{animation-name:k1gp9ioh}";
const $d31bc9ba961aead9$var$_53 = "@keyframes k1gp9ioh{0%{opacity:0;transform:translate3d(calc(5% + 4px),0,0)}50%{opacity:1}to{opacity:1;transform:none}}";
const $d31bc9ba961aead9$var$_52 = "._j7hqzy3z{animation-name:kwlxyjp}";
const $d31bc9ba961aead9$var$_51 = "@keyframes kwlxyjp{0%{opacity:1;transform:translate3d(0,0,0)}to{opacity:0;transform:translate3d(0,calc(5% + 4px),0)}}";
const $d31bc9ba961aead9$var$_50 = "._j7hq1w00{animation-name:k9i97cc}";
const $d31bc9ba961aead9$var$_49 = "@keyframes k9i97cc{0%{opacity:0;transform:translate3d(0,calc(5% + 4px),0)}50%{opacity:1}to{opacity:1;transform:none}}";
const $d31bc9ba961aead9$var$_48 = "._j7hq1yiv{animation-name:k12cqms0}";
const $d31bc9ba961aead9$var$_47 = "@keyframes k12cqms0{0%{opacity:1;transform:translate3d(0,0,0)}to{opacity:0;transform:translate3d(calc(-5% - 4px),0,0)}}";
const $d31bc9ba961aead9$var$_46 = "._j7hq15m2{animation-name:k1y4xa46}";
const $d31bc9ba961aead9$var$_45 = "@keyframes k1y4xa46{0%{opacity:0;transform:translate3d(calc(-5% - 4px),0,0)}50%{opacity:1}to{opacity:1;transform:none}}";
const $d31bc9ba961aead9$var$_44 = "._j7hq39va{animation-name:k1sspn6e}";
const $d31bc9ba961aead9$var$_43 = "@keyframes k1sspn6e{0%{opacity:1;transform:translate3d(0,0,0)}to{opacity:0;transform:translate3d(0,calc(-5% - 4px),0)}}";
const $d31bc9ba961aead9$var$_42 = "._j7hq2iua{animation-name:kecjqy3}";
const $d31bc9ba961aead9$var$_41 = "@keyframes kecjqy3{0%{opacity:0;transform:translate3d(0,calc(-5% - 4px),0)}50%{opacity:1}to{opacity:1;transform:none}}";
const $d31bc9ba961aead9$var$_40 = "._j7hqj08w{animation-name:k1wh49cw}";
const $d31bc9ba961aead9$var$_39 = "@keyframes k1wh49cw{0%{transform:none;opacity:1}to{transform:translate3d(-100%,0,0);opacity:0}}";
const $d31bc9ba961aead9$var$_38 = "._j7hq1bh1{animation-name:k1na2ju7}";
const $d31bc9ba961aead9$var$_37 = "@keyframes k1na2ju7{0%{transform:translate3d(-100%,0,0);opacity:0}to{transform:none;opacity:1}}";
const $d31bc9ba961aead9$var$_36 = "._j7hqhnf1{animation-name:k1vmhg30}";
const $d31bc9ba961aead9$var$_35 = "@keyframes k1vmhg30{0%{transform:none;opacity:1}to{transform:translate3d(0,100%,0);opacity:0}}";
const $d31bc9ba961aead9$var$_34 = "._j7hq1liq{animation-name:kqit24e}";
const $d31bc9ba961aead9$var$_33 = "@keyframes kqit24e{0%{transform:translate3d(0,100%,0);opacity:0}to{transform:none;opacity:1}}";
const $d31bc9ba961aead9$var$_32 = "._j7hqonfj{animation-name:k1bbsfcj}";
const $d31bc9ba961aead9$var$_31 = "@keyframes k1bbsfcj{0%{transform:none;opacity:1}to{transform:translate3d(100%,0,0);opacity:0}}";
const $d31bc9ba961aead9$var$_30 = "._j7hqdfjr{animation-name:k8nf8el}";
const $d31bc9ba961aead9$var$_29 = "@keyframes k8nf8el{0%{transform:translate3d(100%,0,0);opacity:0}to{transform:none;opacity:1}}";
const $d31bc9ba961aead9$var$_28 = "._j7hq7ri4{animation-name:k1ydy56c}";
const $d31bc9ba961aead9$var$_27 = "@keyframes k1ydy56c{0%{transform:none;opacity:1}to{transform:translate3d(0,-100%,0);opacity:0}}";
const $d31bc9ba961aead9$var$_26 = "._j7hqqshu{animation-name:k1j8u6o8}";
const $d31bc9ba961aead9$var$_25 = "@keyframes k1j8u6o8{0%{transform:translate3d(0,-100%,0);opacity:0}to{transform:none;opacity:1}}";
const $d31bc9ba961aead9$var$_24 = "._j7hqy6ql{animation-name:k1tay9q1}";
const $d31bc9ba961aead9$var$_23 = "@keyframes k1tay9q1{to{opacity:0;transform:scale(.75)}}";
const $d31bc9ba961aead9$var$_22 = "._j7hqe8p0{animation-name:k1rq2oqw}";
const $d31bc9ba961aead9$var$_21 = "@keyframes k1rq2oqw{0%{opacity:0;transform:scale(.5)}50%{opacity:1}75%{transform:scale(1.25)}to{transform:scale(1)}}";
const $d31bc9ba961aead9$var$_20 = "._j7hq1lln{animation-name:kbjizr2}";
const $d31bc9ba961aead9$var$_19 = "@keyframes kbjizr2{0%{opacity:1}to{opacity:0}}";
const $d31bc9ba961aead9$var$_18 = "._j7hq1cgr{animation-name:kij747q}";
const $d31bc9ba961aead9$var$_17 = "@keyframes kij747q{0%{opacity:0}50%{opacity:1}to{opacity:1}}";
const $d31bc9ba961aead9$var$_16 = "._1pgl1fu8{animation-timing-function:cubic-bezier(.15,1,.3,1)}";
const $d31bc9ba961aead9$var$_15 = "._1pglannl{animation-timing-function:cubic-bezier(.8,0,0,1)}";
const $d31bc9ba961aead9$var$_14 = "._1pgl1ddy{animation-timing-function:cubic-bezier(.6,0,0,1)}";
const $d31bc9ba961aead9$var$_13 = "._1pgl5y64{animation-timing-function:cubic-bezier(.4,0,0,1)}";
const $d31bc9ba961aead9$var$_12 = "._1pgl1nzg{animation-timing-function:cubic-bezier(.8,0,0,.8)}";
const $d31bc9ba961aead9$var$_11 = "._1pgldkwg{animation-timing-function:cubic-bezier(.2,0,0,1)}";
const $d31bc9ba961aead9$var$_10 = "._1pglp3kn{animation-timing-function:linear}";
const $d31bc9ba961aead9$var$_1 = "._1o51q7pw{animation-fill-mode:forwards}";
const $d31bc9ba961aead9$var$_0 = "._ju255cps{animation-delay:0ms}";
const $d31bc9ba961aead9$var$_9 = "._5sagluct{animation-duration:175ms}";
const $d31bc9ba961aead9$var$_8 = "._5sag14ed{animation-duration:50ms}";
const $d31bc9ba961aead9$var$_7 = "._5sagpwmj{animation-duration:.7s}";
const $d31bc9ba961aead9$var$_6 = "._5sag1ttt{animation-duration:.35s}";
const $d31bc9ba961aead9$var$_5 = "._5sag1yx9{animation-duration:.1s}";
const $d31bc9ba961aead9$var$_4 = "._1y0ctrqk{animation-play-state:paused}";
const $d31bc9ba961aead9$var$_3 = "@media (prefers-reduced-motion:reduce){._1bumglyw{animation:none}._sedtglyw{transition:none}}";
const $d31bc9ba961aead9$var$_2 = "._1y0co91m{animation-play-state:running}";
const $d31bc9ba961aead9$var$_ = "._1o51eoah{animation-fill-mode:backwards}";
const $d31bc9ba961aead9$var$zoomIn = null;
const $d31bc9ba961aead9$var$zoomOut = null;
const $d31bc9ba961aead9$var$fadeIn = null;
const $d31bc9ba961aead9$var$fadeOut = null;
const $d31bc9ba961aead9$var$fadeInFromTop = null;
const $d31bc9ba961aead9$var$fadeOutFromTop = null;
const $d31bc9ba961aead9$var$fadeInFromLeft = null;
const $d31bc9ba961aead9$var$fadeOutFromLeft = null;
const $d31bc9ba961aead9$var$fadeInFromBottom = null;
const $d31bc9ba961aead9$var$fadeOutFromBottom = null;
const $d31bc9ba961aead9$var$fadeInFromRight = null;
const $d31bc9ba961aead9$var$fadeOutFromRight = null;
const $d31bc9ba961aead9$var$fadeInFromTopConstant = null;
const $d31bc9ba961aead9$var$fadeOutFromTopConstant = null;
const $d31bc9ba961aead9$var$fadeInFromLeftConstant = null;
const $d31bc9ba961aead9$var$fadeOutFromLeftConstant = null;
const $d31bc9ba961aead9$var$fadeInFromBottomConstant = null;
const $d31bc9ba961aead9$var$fadeOutFromBottomConstant = null;
const $d31bc9ba961aead9$var$fadeInFromRightConstant = null;
const $d31bc9ba961aead9$var$fadeOutFromRightConstant = null;
const $d31bc9ba961aead9$var$slideInFromTop = null;
const $d31bc9ba961aead9$var$slideOutFromTop = null;
const $d31bc9ba961aead9$var$slideInFromRight = null;
const $d31bc9ba961aead9$var$slideOutFromRight = null;
const $d31bc9ba961aead9$var$slideInFromBottom = null;
const $d31bc9ba961aead9$var$slideOutFromBottom = null;
const $d31bc9ba961aead9$var$slideInFromLeft = null;
const $d31bc9ba961aead9$var$slideOutFromLeft = null;
const $d31bc9ba961aead9$var$EnteringMotion = ({ children: children, animationTimingFunction: animationTimingFunction, animationTimingFunctionExiting: animationTimingFunctionExiting = animationTimingFunction, enteringAnimation: enteringAnimation, exitingAnimation: exitingAnimation = enteringAnimation, isPaused: isPaused, onFinish: onFinishMotion, duration: duration = 'large' })=>{
    const staggered = (0, $d1xmU.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $cUr2h.useExitingPersistence)();
    const setTimeout = (0, $hU6dr.useSetTimeout)();
    const paused = isPaused || !staggered.isReady;
    const delay = isExiting ? 0 : staggered.delay;
    const state = isExiting ? 'exiting' : 'entering';
    const [hasAnimationStyles, setHasAnimationStyles] = (0, $1v5pe.useState)(appear);
    (0, $1v5pe.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (paused) return;
         // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        } /**
       * Updates relevant state.
       * Called when the animation is finished, or immediately with reduced motion.
       */ 
        const onAnimationEnd = ()=>{
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished?.();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion?.(state);
        };
        if ((0, $9RhH4.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        } // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true); // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $aWXtu.exitingDurations)[duration] : (0, $bKulK.durations)[duration] + delay);
        return ()=>{
            isCancelled = true;
        }; // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $d31bc9ba961aead9$var$_,
                    $d31bc9ba961aead9$var$_2,
                    $d31bc9ba961aead9$var$_3,
                    $d31bc9ba961aead9$var$_4,
                    $d31bc9ba961aead9$var$_5,
                    $d31bc9ba961aead9$var$_6,
                    $d31bc9ba961aead9$var$_7,
                    $d31bc9ba961aead9$var$_8,
                    $d31bc9ba961aead9$var$_9,
                    $d31bc9ba961aead9$var$_0,
                    $d31bc9ba961aead9$var$_1,
                    $d31bc9ba961aead9$var$_10,
                    $d31bc9ba961aead9$var$_11,
                    $d31bc9ba961aead9$var$_12,
                    $d31bc9ba961aead9$var$_13,
                    $d31bc9ba961aead9$var$_14,
                    $d31bc9ba961aead9$var$_15,
                    $d31bc9ba961aead9$var$_16,
                    $d31bc9ba961aead9$var$_17,
                    $d31bc9ba961aead9$var$_18,
                    $d31bc9ba961aead9$var$_19,
                    $d31bc9ba961aead9$var$_20,
                    $d31bc9ba961aead9$var$_21,
                    $d31bc9ba961aead9$var$_22,
                    $d31bc9ba961aead9$var$_23,
                    $d31bc9ba961aead9$var$_24,
                    $d31bc9ba961aead9$var$_25,
                    $d31bc9ba961aead9$var$_26,
                    $d31bc9ba961aead9$var$_27,
                    $d31bc9ba961aead9$var$_28,
                    $d31bc9ba961aead9$var$_29,
                    $d31bc9ba961aead9$var$_30,
                    $d31bc9ba961aead9$var$_31,
                    $d31bc9ba961aead9$var$_32,
                    $d31bc9ba961aead9$var$_33,
                    $d31bc9ba961aead9$var$_34,
                    $d31bc9ba961aead9$var$_35,
                    $d31bc9ba961aead9$var$_36,
                    $d31bc9ba961aead9$var$_37,
                    $d31bc9ba961aead9$var$_38,
                    $d31bc9ba961aead9$var$_39,
                    $d31bc9ba961aead9$var$_40,
                    $d31bc9ba961aead9$var$_41,
                    $d31bc9ba961aead9$var$_42,
                    $d31bc9ba961aead9$var$_43,
                    $d31bc9ba961aead9$var$_44,
                    $d31bc9ba961aead9$var$_45,
                    $d31bc9ba961aead9$var$_46,
                    $d31bc9ba961aead9$var$_47,
                    $d31bc9ba961aead9$var$_48,
                    $d31bc9ba961aead9$var$_49,
                    $d31bc9ba961aead9$var$_50,
                    $d31bc9ba961aead9$var$_51,
                    $d31bc9ba961aead9$var$_52,
                    $d31bc9ba961aead9$var$_53,
                    $d31bc9ba961aead9$var$_54,
                    $d31bc9ba961aead9$var$_55,
                    $d31bc9ba961aead9$var$_56,
                    $d31bc9ba961aead9$var$_57,
                    $d31bc9ba961aead9$var$_58,
                    $d31bc9ba961aead9$var$_59,
                    $d31bc9ba961aead9$var$_60,
                    $d31bc9ba961aead9$var$_61,
                    $d31bc9ba961aead9$var$_62,
                    $d31bc9ba961aead9$var$_63,
                    $d31bc9ba961aead9$var$_64,
                    $d31bc9ba961aead9$var$_65,
                    $d31bc9ba961aead9$var$_66,
                    $d31bc9ba961aead9$var$_67,
                    $d31bc9ba961aead9$var$_68,
                    $d31bc9ba961aead9$var$_69,
                    $d31bc9ba961aead9$var$_70,
                    $d31bc9ba961aead9$var$_71,
                    $d31bc9ba961aead9$var$_72
                ]
            }),
            children({
                ref: staggered.ref,
                // @ts-expect-error: `ax` is not typed correctly
                className: hasAnimationStyles ? (0, $hMvDh.default)([
                    (0, $hMvDh.default)([
                        "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
                    ]),
                    paused && (0, $hMvDh.default)([
                        "_1y0ctrqk"
                    ]),
                    duration === 'small' && (0, $hMvDh.default)([
                        "_5sag1yx9"
                    ]),
                    duration === 'medium' && (0, $hMvDh.default)([
                        "_5sag1ttt"
                    ]),
                    duration === 'large' && (0, $hMvDh.default)([
                        "_5sagpwmj"
                    ]),
                    isExiting && duration === 'small' && (0, $hMvDh.default)([
                        "_5sag14ed"
                    ]),
                    isExiting && duration === 'medium' && (0, $hMvDh.default)([
                        "_5sagluct"
                    ]),
                    isExiting && duration === 'large' && (0, $hMvDh.default)([
                        "_5sag1ttt"
                    ]),
                    isExiting && (0, $hMvDh.default)([
                        "_ju255cps _1o51q7pw"
                    ]),
                    !isExiting && animationTimingFunction === 'linear' && (0, $hMvDh.default)([
                        "_1pglp3kn"
                    ]),
                    !isExiting && animationTimingFunction === 'ease-out' && (0, $hMvDh.default)([
                        "_1pgldkwg"
                    ]),
                    !isExiting && animationTimingFunction === 'ease-in' && (0, $hMvDh.default)([
                        "_1pgl1nzg"
                    ]),
                    !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $hMvDh.default)([
                        "_1pgl5y64"
                    ]),
                    !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $hMvDh.default)([
                        "_1pgl1ddy"
                    ]),
                    !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $hMvDh.default)([
                        "_1pglannl"
                    ]),
                    !isExiting && animationTimingFunction === 'ease-in-out' && (0, $hMvDh.default)([
                        "_1pgl1fu8"
                    ]),
                    isExiting && animationTimingFunction === 'linear' && (0, $hMvDh.default)([
                        "_1pglp3kn"
                    ]),
                    isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $hMvDh.default)([
                        "_1pgldkwg"
                    ]),
                    isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $hMvDh.default)([
                        "_1pgl1nzg"
                    ]),
                    isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $hMvDh.default)([
                        "_1pgl5y64"
                    ]),
                    isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $hMvDh.default)([
                        "_1pgl1ddy"
                    ]),
                    isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $hMvDh.default)([
                        "_1pglannl"
                    ]),
                    isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $hMvDh.default)([
                        "_1pgl1fu8"
                    ]),
                    (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $hMvDh.default)([
                        "_j7hq1cgr"
                    ]),
                    (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $hMvDh.default)([
                        "_j7hq1lln"
                    ]),
                    (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $hMvDh.default)([
                        "_j7hqe8p0"
                    ]),
                    (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $hMvDh.default)([
                        "_j7hqy6ql"
                    ]),
                    (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $hMvDh.default)([
                        "_j7hqqshu"
                    ]),
                    (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $hMvDh.default)([
                        "_j7hq7ri4"
                    ]),
                    (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $hMvDh.default)([
                        "_j7hqdfjr"
                    ]),
                    (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $hMvDh.default)([
                        "_j7hqonfj"
                    ]),
                    (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $hMvDh.default)([
                        "_j7hq1liq"
                    ]),
                    (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $hMvDh.default)([
                        "_j7hqhnf1"
                    ]),
                    (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $hMvDh.default)([
                        "_j7hq1bh1"
                    ]),
                    (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $hMvDh.default)([
                        "_j7hqj08w"
                    ]),
                    (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $hMvDh.default)([
                        "_j7hq2iua"
                    ]),
                    (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $hMvDh.default)([
                        "_j7hq39va"
                    ]),
                    (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $hMvDh.default)([
                        "_j7hq15m2"
                    ]),
                    (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $hMvDh.default)([
                        "_j7hq1yiv"
                    ]),
                    (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $hMvDh.default)([
                        "_j7hq1w00"
                    ]),
                    (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $hMvDh.default)([
                        "_j7hqzy3z"
                    ]),
                    (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $hMvDh.default)([
                        "_j7hqpqak"
                    ]),
                    (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $hMvDh.default)([
                        "_j7hq1ebg"
                    ]),
                    (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $hMvDh.default)([
                        "_j7hqm2e2"
                    ]),
                    (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $hMvDh.default)([
                        "_j7hq97jn"
                    ]),
                    (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $hMvDh.default)([
                        "_j7hqovgq"
                    ]),
                    (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $hMvDh.default)([
                        "_j7hq15do"
                    ]),
                    (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $hMvDh.default)([
                        "_j7hq797a"
                    ]),
                    (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $hMvDh.default)([
                        "_j7hqwo7r"
                    ]),
                    (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $hMvDh.default)([
                        "_j7hqt8u5"
                    ]),
                    (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $hMvDh.default)([
                        "_j7hq1pgp"
                    ])
                ]) : '',
                style: {
                    animationDelay: `${delay}ms`
                }
            }, state)
        ]
    });
};
var $d31bc9ba961aead9$export$2e2bcd8739ae039 = $d31bc9ba961aead9$var$EnteringMotion;

});
parcelRegister("bKulK", function(module, exports) {
$parcel$export(module.exports, "durations", () => $aac17f98e353344e$export$38b928a7167ce124);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ const $aac17f98e353344e$export$368bacef0dacbe05 = 25;
const $aac17f98e353344e$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};

});

parcelRegister("aWXtu", function(module, exports) {
$parcel$export(module.exports, "exitingDurations", () => $8161ccf9e2176002$export$30fa1a2e62ae150c);

var $bKulK = parcelRequire("bKulK");
/**
 * Used to multiply the initial duration for exiting motions.
 */ const $8161ccf9e2176002$var$EXITING_MOTION_MULTIPLIER = 0.5;
const $8161ccf9e2176002$export$30fa1a2e62ae150c = {
    none: (0, $bKulK.durations).none,
    small: (0, $bKulK.durations).small * $8161ccf9e2176002$var$EXITING_MOTION_MULTIPLIER,
    medium: (0, $bKulK.durations).medium * $8161ccf9e2176002$var$EXITING_MOTION_MULTIPLIER,
    large: (0, $bKulK.durations).large * $8161ccf9e2176002$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("9RhH4", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $e1a1f3903e1286e6$export$b7baf7667a68d87c);

var $7J9fS = parcelRequire("7J9fS");
const $e1a1f3903e1286e6$export$b7baf7667a68d87c = ()=>{
    if (!(0, $7J9fS.isMatchMediaAvailable)()) return false;
    const { matches: matches } = window.matchMedia('(prefers-reduced-motion: reduce)');
    return matches;
};

});
parcelRegister("7J9fS", function(module, exports) {
$parcel$export(module.exports, "isMatchMediaAvailable", () => $25d5c374f487b07b$export$c5406bd59b374abd);
const $25d5c374f487b07b$export$c5406bd59b374abd = ()=>typeof window !== 'undefined' && 'matchMedia' in window;

});


parcelRegister("hU6dr", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", () => $87ddffbc9b7c2bbb$export$4f34107a2b00f39c);

var $1v5pe = parcelRequire("1v5pe");
const $87ddffbc9b7c2bbb$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $87ddffbc9b7c2bbb$export$4f34107a2b00f39c = (opts = {
    cleanup: 'unmount'
})=>{
    const timeouts = (0, $1v5pe.useRef)([]);
    (0, $1v5pe.useEffect)(()=>{
        return ()=>{
            if (timeouts.current.length) {
                timeouts.current.forEach((id)=>clearTimeout(id));
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $87ddffbc9b7c2bbb$var$getHookDeps(opts));
    return (0, $1v5pe.useCallback)((handler, timeout, ...args)=>{
        const id = setTimeout(()=>{
            timeouts.current = timeouts.current.filter((timeoutId)=>timeoutId !== id);
            handler();
        }, timeout, ...args);
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("cUr2h", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $77050e375edea113$export$3b6f38abbdcbd000);

var $1v5pe = parcelRequire("1v5pe");

var $7dKqR = parcelRequire("7dKqR");
const $77050e375edea113$export$3b6f38abbdcbd000 = ()=>{
    return (0, $1v5pe.useContext)((0, $7dKqR.ExitingContext));
};

});

parcelRegister("d1xmU", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $8c1a588e05efcb1a$export$25c7213fc07ec080);

var $1v5pe = parcelRequire("1v5pe");

var $j3XTt = parcelRequire("j3XTt");

var $aBk6O = parcelRequire("aBk6O");
const $8c1a588e05efcb1a$export$25c7213fc07ec080 = ()=>{
    const identifier = (0, $j3XTt.useUniqueId)();
    const context = (0, $1v5pe.useContext)((0, $aBk6O.StaggeredEntranceContext));
    return context(identifier);
};

});
parcelRegister("j3XTt", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $0cbb334fcc900720$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $1v5pe = parcelRequire("1v5pe");
function $0cbb334fcc900720$export$c485849f2e393253() {
    const identifier = (0, $1v5pe.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});

parcelRegister("aBk6O", function(module, exports) {
$parcel$export(module.exports, "StaggeredEntranceContext", () => $829ea8096c8b88b2$export$5e65d7d58ae96ad8);

var $1v5pe = parcelRequire("1v5pe");

var $aD9yk = parcelRequire("aD9yk");

var $fRsBS = parcelRequire("fRsBS");

var $kIqwl = parcelRequire("kIqwl");
const $829ea8096c8b88b2$export$5e65d7d58ae96ad8 = /*#__PURE__*/ (0, $1v5pe.createContext)(()=>({
        isReady: true,
        delay: 0,
        ref: (0, $aD9yk.default)
    }));
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ const $829ea8096c8b88b2$var$StaggeredEntrance = ({ children: children, column: column, columns: columns = 'responsive', delayStep: delayStep = 50 })=>{
    const elementRefs = (0, $1v5pe.useRef)([]);
    const indexes = [];
    const [actualColumns, setActualColumns] = (0, $1v5pe.useState)(()=>{
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    });
    (0, $fRsBS.useLayoutEffect)(()=>{
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            let currentTop = 0;
            let numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(let i = 0; i < elementRefs.current.length; i++){
                const child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $kIqwl.jsx)($829ea8096c8b88b2$export$5e65d7d58ae96ad8.Provider, {
        value: (id)=>{
            if (!indexes.includes(id)) indexes.push(id);
            const isReady = actualColumns > 0;
            const index = indexes.indexOf(id);
            const currentColumn = column || index % actualColumns;
            const currentRow = Math.floor(index / actualColumns);
            const distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            const delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: (element)=>elementRefs.current[index] = element
            };
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$829ea8096c8b88b2$export$2e2bcd8739ae039 = $829ea8096c8b88b2$var$StaggeredEntrance;

});
parcelRegister("fRsBS", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $c0dc1c8a29cd243f$export$e5c5a5f917a5871c);

var $1v5pe = parcelRequire("1v5pe");
const $c0dc1c8a29cd243f$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $1v5pe.useEffect) : (0, $1v5pe.useLayoutEffect);

});





parcelRegister("5PkvR", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $32a5f058e406caf2$export$badac9ada3a0bdf9);

var $1v5pe = parcelRequire("1v5pe");

var $71YaH = parcelRequire("71YaH");

var $2aEiL = parcelRequire("2aEiL");

var $eI54n = parcelRequire("eI54n");

var $lAfnf = parcelRequire("lAfnf");

var $kIqwl = parcelRequire("kIqwl");

const $32a5f058e406caf2$var$viewportPadding = 5;
const $32a5f058e406caf2$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $32a5f058e406caf2$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $32a5f058e406caf2$var$defaultChildrenFn() {
    return null;
}
const $32a5f058e406caf2$var$defaultOffset = [
    0,
    8
];
function $32a5f058e406caf2$export$badac9ada3a0bdf9({ children: children, offset: offset, placement: placement, referenceElement: referenceElement, modifiers: modifiers, strategy: strategy, shouldFitViewport: shouldFitViewport }) {
    // The FF check sits at the very top of the public Popper so the
    // rest of the function (which has its own hooks) does not violate
    // the rules of hooks. Each branch is its own component with its
    // own complete hook order. Props are forwarded explicitly to
    // satisfy `no-unsafe-spread-props`.
    if ((0, $2aEiL.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $lAfnf.PopperTopLayer), {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
    return /*#__PURE__*/ (0, $kIqwl.jsx)($32a5f058e406caf2$var$LegacyPopper, {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
}
function $32a5f058e406caf2$var$LegacyPopper({ children: children = $32a5f058e406caf2$var$defaultChildrenFn, offset: offset = $32a5f058e406caf2$var$defaultOffset, placement: placement = 'bottom-start', referenceElement: referenceElement, modifiers: modifiers, strategy: strategy = 'fixed', shouldFitViewport: shouldFitViewport = false }) {
    const [offsetX, offsetY] = offset;
    const internalModifiers = (0, $1v5pe.useMemo)(()=>{
        const preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $32a5f058e406caf2$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        const offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        const maxSizeModifiers = shouldFitViewport ? (0, $eI54n.getMaxSizeModifiers)({
            viewportPadding: $32a5f058e406caf2$var$viewportPadding
        }) : [];
        return [
            ...$32a5f058e406caf2$var$constantModifiers,
            preventOverflowModifier,
            offsetModifier,
            ...maxSizeModifiers
        ];
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    const mergedModifiers = (0, $1v5pe.useMemo)(()=>{
        if (modifiers == null) return internalModifiers;
        return [
            ...internalModifiers,
            ...modifiers
        ];
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $71YaH.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement,
        children: children
    });
}

});
parcelRegister("71YaH", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $51e74d3e21b5b571$export$badac9ada3a0bdf9);

var $1v5pe = parcelRequire("1v5pe");

var $dQjgQ = parcelRequire("dQjgQ");

var $jJFKU = parcelRequire("jJFKU");

var $7fLza = parcelRequire("7fLza");
var $51e74d3e21b5b571$var$NOOP = function NOOP() {
    return void 0;
};
var $51e74d3e21b5b571$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $51e74d3e21b5b571$var$EMPTY_MODIFIERS = [];
function $51e74d3e21b5b571$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $51e74d3e21b5b571$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $1v5pe.useContext((0, $dQjgQ.ManagerReferenceNodeContext));
    var _React$useState = $1v5pe.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $1v5pe.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $1v5pe.useEffect(function() {
        (0, $jJFKU.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $1v5pe.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $7fLza.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $1v5pe.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $51e74d3e21b5b571$var$NOOP,
            update: update || $51e74d3e21b5b571$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $jJFKU.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("dQjgQ", function(module, exports) {
$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $a13f147938486ff0$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $a13f147938486ff0$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $a13f147938486ff0$export$d0d38e7dec7a1a61);

var $1v5pe = parcelRequire("1v5pe");
var $a13f147938486ff0$export$3dbd3405086fec7b = $1v5pe.createContext();
var $a13f147938486ff0$export$cbabb21c2529b130 = $1v5pe.createContext();
function $a13f147938486ff0$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $1v5pe.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $1v5pe.useRef(false);
    $1v5pe.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $1v5pe.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $1v5pe.createElement($a13f147938486ff0$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $1v5pe.createElement($a13f147938486ff0$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("jJFKU", function(module, exports) {
$parcel$export(module.exports, "unwrapArray", () => $e5e29c14bb2a39b0$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $e5e29c14bb2a39b0$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $e5e29c14bb2a39b0$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $e5e29c14bb2a39b0$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $e5e29c14bb2a39b0$export$700979bc83e7db82);

var $1v5pe = parcelRequire("1v5pe");
var $e5e29c14bb2a39b0$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $e5e29c14bb2a39b0$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $e5e29c14bb2a39b0$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $e5e29c14bb2a39b0$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $e5e29c14bb2a39b0$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $e5e29c14bb2a39b0$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $1v5pe.useLayoutEffect : $1v5pe.useEffect;

});

parcelRegister("7fLza", function(module, exports) {
$parcel$export(module.exports, "usePopper", () => $547ed4cd4a0a26f4$export$f4d5bf230a36dd6e);

var $1v5pe = parcelRequire("1v5pe");

var $fBuCt = parcelRequire("fBuCt");

var $4UxZm = parcelRequire("4UxZm");

var $dgx9M = parcelRequire("dgx9M");

var $jJFKU = parcelRequire("jJFKU");
var $547ed4cd4a0a26f4$var$EMPTY_MODIFIERS = [];
var $547ed4cd4a0a26f4$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $1v5pe.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $547ed4cd4a0a26f4$var$EMPTY_MODIFIERS
    };
    var _React$useState = $1v5pe.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $1v5pe.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $fBuCt.flushSync(function() {
                    setState({
                        styles: (0, $jJFKU.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $jJFKU.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $1v5pe.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($dgx9M)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $1v5pe.useRef();
    (0, $jJFKU.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $jJFKU.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $4UxZm.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("4UxZm", function(module, exports) {
$parcel$export(module.exports, "createPopper", () => $3936c1d23ac97044$export$8f7491d57c8f97a9);

var $4TqrI = parcelRequire("4TqrI");

var $fVEaO = parcelRequire("fVEaO");

var $h04mL = parcelRequire("h04mL");

var $hEUhF = parcelRequire("hEUhF");

var $iVVaj = parcelRequire("iVVaj");

var $9j9fp = parcelRequire("9j9fp");

var $gZULw = parcelRequire("gZULw");

var $80FTA = parcelRequire("80FTA");

var $5qZps = parcelRequire("5qZps");

var $ltwXj = parcelRequire("ltwXj");


var $3936c1d23ac97044$export$d34966752335dd47 = [
    (0, $fVEaO.default),
    (0, $h04mL.default),
    (0, $hEUhF.default),
    (0, $iVVaj.default),
    (0, $9j9fp.default),
    (0, $gZULw.default),
    (0, $80FTA.default),
    (0, $5qZps.default),
    (0, $ltwXj.default)
];
var $3936c1d23ac97044$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $4TqrI.popperGenerator)({
    defaultModifiers: $3936c1d23ac97044$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("4TqrI", function(module, exports) {
$parcel$export(module.exports, "popperGenerator", () => $3900d01c6e7a4d1b$export$ed5e13716264f202);

var $7PVDk = parcelRequire("7PVDk");

var $4acnM = parcelRequire("4acnM");

var $bh0bC = parcelRequire("bh0bC");

var $6TiV3 = parcelRequire("6TiV3");

var $gaq9z = parcelRequire("gaq9z");

var $3yR8e = parcelRequire("3yR8e");

var $ky67f = parcelRequire("ky67f");


var $eyZgR = parcelRequire("eyZgR");
var $3900d01c6e7a4d1b$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $3900d01c6e7a4d1b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $3900d01c6e7a4d1b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $3900d01c6e7a4d1b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $3900d01c6e7a4d1b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $eyZgR.isElement)(reference) ? (0, $bh0bC.default)(reference) : reference.contextElement ? (0, $bh0bC.default)(reference.contextElement) : [],
                    popper: (0, $bh0bC.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $gaq9z.default)((0, $ky67f.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$3900d01c6e7a4d1b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $7PVDk.default)(reference, (0, $6TiV3.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $4acnM.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $3yR8e.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$3900d01c6e7a4d1b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $3900d01c6e7a4d1b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $3900d01c6e7a4d1b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("7PVDk", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b4a0097824f53b0$export$2e2bcd8739ae039);

var $2ZGde = parcelRequire("2ZGde");

var $5sHpL = parcelRequire("5sHpL");

var $hm1wJ = parcelRequire("hm1wJ");

var $eyZgR = parcelRequire("eyZgR");

var $2N7WB = parcelRequire("2N7WB");

var $lJqsK = parcelRequire("lJqsK");

var $aXOsW = parcelRequire("aXOsW");

var $jjJ3Q = parcelRequire("jjJ3Q");
function $5b4a0097824f53b0$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $jjJ3Q.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $jjJ3Q.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $5b4a0097824f53b0$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $eyZgR.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $eyZgR.isHTMLElement)(offsetParent) && $5b4a0097824f53b0$var$isElementScaled(offsetParent);
    var documentElement = (0, $lJqsK.default)(offsetParent);
    var rect = (0, $2ZGde.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $hm1wJ.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $aXOsW.default)(documentElement)) scroll = (0, $5sHpL.default)(offsetParent);
        if ((0, $eyZgR.isHTMLElement)(offsetParent)) {
            offsets = (0, $2ZGde.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $2N7WB.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("2ZGde", function(module, exports) {
$parcel$export(module.exports, "default", () => $22e205cdb35dc38b$export$2e2bcd8739ae039);

var $eyZgR = parcelRequire("eyZgR");

var $jjJ3Q = parcelRequire("jjJ3Q");

var $1mV9B = parcelRequire("1mV9B");

var $6IY9T = parcelRequire("6IY9T");
function $22e205cdb35dc38b$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $eyZgR.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $jjJ3Q.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $jjJ3Q.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $eyZgR.isElement)(element) ? (0, $1mV9B.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $6IY9T.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("eyZgR", function(module, exports) {
$parcel$export(module.exports, "isElement", () => $a9a3c4d01f60306c$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $a9a3c4d01f60306c$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $a9a3c4d01f60306c$export$af51f0f06c0f328a);

var $1mV9B = parcelRequire("1mV9B");
function $a9a3c4d01f60306c$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $1mV9B.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $a9a3c4d01f60306c$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $1mV9B.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $a9a3c4d01f60306c$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $1mV9B.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("1mV9B", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ff42e1b4f5fd96a$export$2e2bcd8739ae039);
function $0ff42e1b4f5fd96a$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("jjJ3Q", function(module, exports) {
$parcel$export(module.exports, "max", () => $e102bedd40b77d9d$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $e102bedd40b77d9d$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $e102bedd40b77d9d$export$2077e0241d6afd3c);
var $e102bedd40b77d9d$export$8960430cfd85939f = Math.max;
var $e102bedd40b77d9d$export$96ec731ed4dcb222 = Math.min;
var $e102bedd40b77d9d$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("6IY9T", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e558464660aa82d$export$2e2bcd8739ae039);

var $8r4GS = parcelRequire("8r4GS");
function $4e558464660aa82d$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $8r4GS.default)());
}

});
parcelRegister("8r4GS", function(module, exports) {
$parcel$export(module.exports, "default", () => $62447bcb455e108a$export$2e2bcd8739ae039);
function $62447bcb455e108a$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("5sHpL", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fa13e81e21ebe00$export$2e2bcd8739ae039);

var $hNvaW = parcelRequire("hNvaW");

var $1mV9B = parcelRequire("1mV9B");

var $eyZgR = parcelRequire("eyZgR");

var $krJxH = parcelRequire("krJxH");
function $3fa13e81e21ebe00$export$2e2bcd8739ae039(node) {
    if (node === (0, $1mV9B.default)(node) || !(0, $eyZgR.isHTMLElement)(node)) return (0, $hNvaW.default)(node);
    else return (0, $krJxH.default)(node);
}

});
parcelRegister("hNvaW", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf4f3211b048dc5e$export$2e2bcd8739ae039);

var $1mV9B = parcelRequire("1mV9B");
function $cf4f3211b048dc5e$export$2e2bcd8739ae039(node) {
    var win = (0, $1mV9B.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("krJxH", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee29a8114c28a721$export$2e2bcd8739ae039);
function $ee29a8114c28a721$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("hm1wJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca25acf69e993014$export$2e2bcd8739ae039);
function $ca25acf69e993014$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("2N7WB", function(module, exports) {
$parcel$export(module.exports, "default", () => $208651edc2247516$export$2e2bcd8739ae039);

var $2ZGde = parcelRequire("2ZGde");

var $lJqsK = parcelRequire("lJqsK");

var $hNvaW = parcelRequire("hNvaW");
function $208651edc2247516$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ZGde.default)((0, $lJqsK.default)(element)).left + (0, $hNvaW.default)(element).scrollLeft;
}

});
parcelRegister("lJqsK", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd2253de03323389$export$2e2bcd8739ae039);

var $eyZgR = parcelRequire("eyZgR");
function $fd2253de03323389$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $eyZgR.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("aXOsW", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fb68f809910a294$export$2e2bcd8739ae039);

var $DKWEv = parcelRequire("DKWEv");
function $7fb68f809910a294$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $DKWEv.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("DKWEv", function(module, exports) {
$parcel$export(module.exports, "default", () => $07780eeeccfd9d0f$export$2e2bcd8739ae039);

var $1mV9B = parcelRequire("1mV9B");
function $07780eeeccfd9d0f$export$2e2bcd8739ae039(element) {
    return (0, $1mV9B.default)(element).getComputedStyle(element);
}

});



parcelRegister("4acnM", function(module, exports) {
$parcel$export(module.exports, "default", () => $3081b381f10ea9e4$export$2e2bcd8739ae039);

var $2ZGde = parcelRequire("2ZGde");
function $3081b381f10ea9e4$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ZGde.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("bh0bC", function(module, exports) {
$parcel$export(module.exports, "default", () => $83516d445d0aa175$export$2e2bcd8739ae039);

var $bwOwL = parcelRequire("bwOwL");

var $5rloo = parcelRequire("5rloo");

var $1mV9B = parcelRequire("1mV9B");

var $aXOsW = parcelRequire("aXOsW");
function $83516d445d0aa175$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $bwOwL.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $1mV9B.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $aXOsW.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($83516d445d0aa175$export$2e2bcd8739ae039((0, $5rloo.default)(target)));
}

});
parcelRegister("bwOwL", function(module, exports) {
$parcel$export(module.exports, "default", () => $8649e0906e5152cc$export$2e2bcd8739ae039);

var $5rloo = parcelRequire("5rloo");

var $aXOsW = parcelRequire("aXOsW");

var $hm1wJ = parcelRequire("hm1wJ");

var $eyZgR = parcelRequire("eyZgR");
function $8649e0906e5152cc$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $hm1wJ.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $eyZgR.isHTMLElement)(node) && (0, $aXOsW.default)(node)) return node;
    return $8649e0906e5152cc$export$2e2bcd8739ae039((0, $5rloo.default)(node));
}

});
parcelRegister("5rloo", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f6011709b3afde5$export$2e2bcd8739ae039);

var $hm1wJ = parcelRequire("hm1wJ");

var $lJqsK = parcelRequire("lJqsK");

var $eyZgR = parcelRequire("eyZgR");
function $3f6011709b3afde5$export$2e2bcd8739ae039(element) {
    if ((0, $hm1wJ.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $eyZgR.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $lJqsK.default)(element) // fallback
    );
}

});



parcelRegister("6TiV3", function(module, exports) {
$parcel$export(module.exports, "default", () => $50468e1922964b13$export$2e2bcd8739ae039);

var $1mV9B = parcelRequire("1mV9B");

var $hm1wJ = parcelRequire("hm1wJ");

var $DKWEv = parcelRequire("DKWEv");

var $eyZgR = parcelRequire("eyZgR");

var $1uEgW = parcelRequire("1uEgW");

var $5rloo = parcelRequire("5rloo");

var $8r4GS = parcelRequire("8r4GS");
function $50468e1922964b13$var$getTrueOffsetParent(element) {
    if (!(0, $eyZgR.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $DKWEv.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $50468e1922964b13$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $8r4GS.default)());
    var isIE = /Trident/i.test((0, $8r4GS.default)());
    if (isIE && (0, $eyZgR.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $DKWEv.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $5rloo.default)(element);
    if ((0, $eyZgR.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $eyZgR.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $hm1wJ.default)(currentNode)) < 0){
        var css = (0, $DKWEv.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $50468e1922964b13$export$2e2bcd8739ae039(element) {
    var window = (0, $1mV9B.default)(element);
    var offsetParent = $50468e1922964b13$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $1uEgW.default)(offsetParent) && (0, $DKWEv.default)(offsetParent).position === 'static')offsetParent = $50468e1922964b13$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $hm1wJ.default)(offsetParent) === 'html' || (0, $hm1wJ.default)(offsetParent) === 'body' && (0, $DKWEv.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $50468e1922964b13$var$getContainingBlock(element) || window;
}

});
parcelRegister("1uEgW", function(module, exports) {
$parcel$export(module.exports, "default", () => $1167d50a5f6adb18$export$2e2bcd8739ae039);

var $hm1wJ = parcelRequire("hm1wJ");
function $1167d50a5f6adb18$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $hm1wJ.default)(element)) >= 0;
}

});


parcelRegister("gaq9z", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc51de0b0edd8ccb$export$2e2bcd8739ae039);

var $4JZl1 = parcelRequire("4JZl1");
function $bc51de0b0edd8ccb$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $bc51de0b0edd8ccb$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $bc51de0b0edd8ccb$var$order(modifiers); // order based on phase
    return (0, $4JZl1.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("4JZl1", function(module, exports) {
$parcel$export(module.exports, "top", () => $373af1dd35c30daa$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $373af1dd35c30daa$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $373af1dd35c30daa$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $373af1dd35c30daa$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $373af1dd35c30daa$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $373af1dd35c30daa$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $373af1dd35c30daa$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $373af1dd35c30daa$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $373af1dd35c30daa$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $373af1dd35c30daa$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $373af1dd35c30daa$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $373af1dd35c30daa$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $373af1dd35c30daa$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $373af1dd35c30daa$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $373af1dd35c30daa$export$d087d3878fdf71d5);
var $373af1dd35c30daa$export$1e95b668f3b82d = 'top';
var $373af1dd35c30daa$export$40e543e69a8b3fbb = 'bottom';
var $373af1dd35c30daa$export$79ffe56a765070d2 = 'right';
var $373af1dd35c30daa$export$eabcd2c8791e7bf4 = 'left';
var $373af1dd35c30daa$export$dfb5619354ba860 = 'auto';
var $373af1dd35c30daa$export$aec2ce47c367b8c3 = [
    $373af1dd35c30daa$export$1e95b668f3b82d,
    $373af1dd35c30daa$export$40e543e69a8b3fbb,
    $373af1dd35c30daa$export$79ffe56a765070d2,
    $373af1dd35c30daa$export$eabcd2c8791e7bf4
];
var $373af1dd35c30daa$export$b3571188c770cc5a = 'start';
var $373af1dd35c30daa$export$bd5df0f255a350f8 = 'end';
var $373af1dd35c30daa$export$390fd549c5303b4d = 'clippingParents';
var $373af1dd35c30daa$export$d7b7311ec04a3e8f = 'viewport';
var $373af1dd35c30daa$export$ae5ab1c730825774 = 'popper';
var $373af1dd35c30daa$export$ca50aac9f3ba507f = 'reference';
var $373af1dd35c30daa$export$368f9a87e87fa4e1 = /*#__PURE__*/ $373af1dd35c30daa$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $373af1dd35c30daa$export$b3571188c770cc5a,
        placement + "-" + $373af1dd35c30daa$export$bd5df0f255a350f8
    ]);
}, []);
var $373af1dd35c30daa$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($373af1dd35c30daa$export$aec2ce47c367b8c3, [
    $373af1dd35c30daa$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $373af1dd35c30daa$export$b3571188c770cc5a,
        placement + "-" + $373af1dd35c30daa$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $373af1dd35c30daa$export$421679a7c3d56e = 'beforeRead';
var $373af1dd35c30daa$export$aafa59e2e03f2942 = 'read';
var $373af1dd35c30daa$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $373af1dd35c30daa$export$c65e99957a05207c = 'beforeMain';
var $373af1dd35c30daa$export$f22da7240b7add18 = 'main';
var $373af1dd35c30daa$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $373af1dd35c30daa$export$8d4d2d70e7d46032 = 'beforeWrite';
var $373af1dd35c30daa$export$68d8715fc104d294 = 'write';
var $373af1dd35c30daa$export$70a6e5159acce2e6 = 'afterWrite';
var $373af1dd35c30daa$export$d087d3878fdf71d5 = [
    $373af1dd35c30daa$export$421679a7c3d56e,
    $373af1dd35c30daa$export$aafa59e2e03f2942,
    $373af1dd35c30daa$export$6964f6c886723980,
    $373af1dd35c30daa$export$c65e99957a05207c,
    $373af1dd35c30daa$export$f22da7240b7add18,
    $373af1dd35c30daa$export$bab79516f2d662fe,
    $373af1dd35c30daa$export$8d4d2d70e7d46032,
    $373af1dd35c30daa$export$68d8715fc104d294,
    $373af1dd35c30daa$export$70a6e5159acce2e6
];

});


parcelRegister("3yR8e", function(module, exports) {
$parcel$export(module.exports, "default", () => $297dc2f2e450b1ab$export$2e2bcd8739ae039);
function $297dc2f2e450b1ab$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("ky67f", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef5bba21b27d5b74$export$2e2bcd8739ae039);
function $ef5bba21b27d5b74$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("fVEaO", function(module, exports) {
$parcel$export(module.exports, "default", () => $b98b577f9670b42c$export$2e2bcd8739ae039);

var $1mV9B = parcelRequire("1mV9B");
var $b98b577f9670b42c$var$passive = {
    passive: true
};
function $b98b577f9670b42c$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $1mV9B.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $b98b577f9670b42c$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $b98b577f9670b42c$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $b98b577f9670b42c$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $b98b577f9670b42c$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $b98b577f9670b42c$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $b98b577f9670b42c$var$effect,
    data: {}
};

});

parcelRegister("h04mL", function(module, exports) {
$parcel$export(module.exports, "default", () => $c605d2c2774b3196$export$2e2bcd8739ae039);

var $dPXF9 = parcelRequire("dPXF9");
function $c605d2c2774b3196$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $dPXF9.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c605d2c2774b3196$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $c605d2c2774b3196$var$popperOffsets,
    data: {}
};

});
parcelRegister("dPXF9", function(module, exports) {
$parcel$export(module.exports, "default", () => $a12e51937c623ca5$export$2e2bcd8739ae039);

var $axX8x = parcelRequire("axX8x");

var $hWYug = parcelRequire("hWYug");

var $8u4Bg = parcelRequire("8u4Bg");

var $4JZl1 = parcelRequire("4JZl1");
function $a12e51937c623ca5$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $axX8x.default)(placement) : null;
    var variation = placement ? (0, $hWYug.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $4JZl1.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $4JZl1.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $4JZl1.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $4JZl1.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $8u4Bg.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $4JZl1.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $4JZl1.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("axX8x", function(module, exports) {
$parcel$export(module.exports, "default", () => $7adadbcac88dd8b5$export$2e2bcd8739ae039);

function $7adadbcac88dd8b5$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("hWYug", function(module, exports) {
$parcel$export(module.exports, "default", () => $d116c5ed9dc2b932$export$2e2bcd8739ae039);
function $d116c5ed9dc2b932$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("8u4Bg", function(module, exports) {
$parcel$export(module.exports, "default", () => $62d4b189bf24033f$export$2e2bcd8739ae039);
function $62d4b189bf24033f$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("hEUhF", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdb1d4f031e66bb3$export$2e2bcd8739ae039);

var $4JZl1 = parcelRequire("4JZl1");

var $6TiV3 = parcelRequire("6TiV3");

var $1mV9B = parcelRequire("1mV9B");

var $lJqsK = parcelRequire("lJqsK");

var $DKWEv = parcelRequire("DKWEv");

var $axX8x = parcelRequire("axX8x");

var $hWYug = parcelRequire("hWYug");

var $jjJ3Q = parcelRequire("jjJ3Q");
var $cdb1d4f031e66bb3$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $cdb1d4f031e66bb3$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $jjJ3Q.round)(x * dpr) / dpr || 0,
        y: (0, $jjJ3Q.round)(y * dpr) / dpr || 0
    };
}
function $cdb1d4f031e66bb3$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $4JZl1.left);
    var sideY = (0, $4JZl1.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $6TiV3.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $1mV9B.default)(popper)) {
            offsetParent = (0, $lJqsK.default)(popper);
            if ((0, $DKWEv.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $4JZl1.top) || (placement === (0, $4JZl1.left) || placement === (0, $4JZl1.right)) && variation === (0, $4JZl1.end)) {
            sideY = (0, $4JZl1.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $4JZl1.left) || (placement === (0, $4JZl1.top) || placement === (0, $4JZl1.bottom)) && variation === (0, $4JZl1.end)) {
            sideX = (0, $4JZl1.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $cdb1d4f031e66bb3$var$unsetSides);
    var _ref4 = roundOffsets === true ? $cdb1d4f031e66bb3$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $1mV9B.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $cdb1d4f031e66bb3$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $axX8x.default)(state.placement),
        variation: (0, $hWYug.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $cdb1d4f031e66bb3$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $cdb1d4f031e66bb3$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $cdb1d4f031e66bb3$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $cdb1d4f031e66bb3$var$computeStyles,
    data: {}
};

});

parcelRegister("iVVaj", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc89e4b8b29deea9$export$2e2bcd8739ae039);

var $hm1wJ = parcelRequire("hm1wJ");

var $eyZgR = parcelRequire("eyZgR");
// and applies them to the HTMLElements such as popper and arrow
function $dc89e4b8b29deea9$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $eyZgR.isHTMLElement)(element) || !(0, $hm1wJ.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $dc89e4b8b29deea9$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $eyZgR.isHTMLElement)(element) || !(0, $hm1wJ.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $dc89e4b8b29deea9$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $dc89e4b8b29deea9$var$applyStyles,
    effect: $dc89e4b8b29deea9$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("9j9fp", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c6d0fcac9d2cf2d$export$2e2bcd8739ae039);

var $axX8x = parcelRequire("axX8x");

var $4JZl1 = parcelRequire("4JZl1");
function $6c6d0fcac9d2cf2d$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $axX8x.default)(placement);
    var invertDistance = [
        (0, $4JZl1.left),
        (0, $4JZl1.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $4JZl1.left),
        (0, $4JZl1.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $6c6d0fcac9d2cf2d$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $4JZl1.placements).reduce(function(acc, placement) {
        acc[placement] = $6c6d0fcac9d2cf2d$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $6c6d0fcac9d2cf2d$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $6c6d0fcac9d2cf2d$var$offset
};

});

parcelRegister("gZULw", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5fe60443366c005$export$2e2bcd8739ae039);

var $jTcDg = parcelRequire("jTcDg");

var $axX8x = parcelRequire("axX8x");

var $cua8E = parcelRequire("cua8E");

var $d4gW5 = parcelRequire("d4gW5");

var $bzk8P = parcelRequire("bzk8P");

var $4JZl1 = parcelRequire("4JZl1");

var $hWYug = parcelRequire("hWYug");
function $c5fe60443366c005$var$getExpandedFallbackPlacements(placement) {
    if ((0, $axX8x.default)(placement) === (0, $4JZl1.auto)) return [];
    var oppositePlacement = (0, $jTcDg.default)(placement);
    return [
        (0, $cua8E.default)(placement),
        oppositePlacement,
        (0, $cua8E.default)(oppositePlacement)
    ];
}
function $c5fe60443366c005$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $axX8x.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $jTcDg.default)(preferredPlacement)
    ] : $c5fe60443366c005$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $axX8x.default)(placement) === (0, $4JZl1.auto) ? (0, $bzk8P.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $axX8x.default)(placement);
        var isStartVariation = (0, $hWYug.default)(placement) === (0, $4JZl1.start);
        var isVertical = [
            (0, $4JZl1.top),
            (0, $4JZl1.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $d4gW5.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $4JZl1.right) : (0, $4JZl1.left) : isStartVariation ? (0, $4JZl1.bottom) : (0, $4JZl1.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $jTcDg.default)(mainVariationSide);
        var altVariationSide = (0, $jTcDg.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $c5fe60443366c005$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $c5fe60443366c005$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("jTcDg", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7acf3de443d5cb2$export$2e2bcd8739ae039);
var $e7acf3de443d5cb2$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $e7acf3de443d5cb2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $e7acf3de443d5cb2$var$hash[matched];
    });
}

});

parcelRegister("cua8E", function(module, exports) {
$parcel$export(module.exports, "default", () => $917026aa12a7fde9$export$2e2bcd8739ae039);
var $917026aa12a7fde9$var$hash = {
    start: 'end',
    end: 'start'
};
function $917026aa12a7fde9$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $917026aa12a7fde9$var$hash[matched];
    });
}

});

parcelRegister("d4gW5", function(module, exports) {
$parcel$export(module.exports, "default", () => $9838c9308b9959b4$export$2e2bcd8739ae039);

var $4MW2F = parcelRequire("4MW2F");

var $lJqsK = parcelRequire("lJqsK");

var $2ZGde = parcelRequire("2ZGde");

var $dPXF9 = parcelRequire("dPXF9");

var $bqyjg = parcelRequire("bqyjg");

var $4JZl1 = parcelRequire("4JZl1");

var $eyZgR = parcelRequire("eyZgR");

var $5YeBx = parcelRequire("5YeBx");

var $feEbn = parcelRequire("feEbn");
function $9838c9308b9959b4$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $4JZl1.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $4JZl1.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $4JZl1.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $5YeBx.default)(typeof padding !== 'number' ? padding : (0, $feEbn.default)(padding, (0, $4JZl1.basePlacements)));
    var altContext = elementContext === (0, $4JZl1.popper) ? (0, $4JZl1.reference) : (0, $4JZl1.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $4MW2F.default)((0, $eyZgR.isElement)(element) ? element : element.contextElement || (0, $lJqsK.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ZGde.default)(state.elements.reference);
    var popperOffsets = (0, $dPXF9.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $bqyjg.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $4JZl1.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $4JZl1.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $4JZl1.right),
                (0, $4JZl1.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $4JZl1.top),
                (0, $4JZl1.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("4MW2F", function(module, exports) {
$parcel$export(module.exports, "default", () => $37c8ab0886a3f2aa$export$2e2bcd8739ae039);

var $4JZl1 = parcelRequire("4JZl1");

var $1JW7p = parcelRequire("1JW7p");

var $bzmCU = parcelRequire("bzmCU");

var $bh0bC = parcelRequire("bh0bC");

var $6TiV3 = parcelRequire("6TiV3");

var $lJqsK = parcelRequire("lJqsK");

var $DKWEv = parcelRequire("DKWEv");

var $eyZgR = parcelRequire("eyZgR");

var $2ZGde = parcelRequire("2ZGde");

var $5rloo = parcelRequire("5rloo");

var $bnZkU = parcelRequire("bnZkU");

var $hm1wJ = parcelRequire("hm1wJ");

var $bqyjg = parcelRequire("bqyjg");

var $jjJ3Q = parcelRequire("jjJ3Q");
function $37c8ab0886a3f2aa$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ZGde.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $37c8ab0886a3f2aa$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $4JZl1.viewport) ? (0, $bqyjg.default)((0, $1JW7p.default)(element, strategy)) : (0, $eyZgR.isElement)(clippingParent) ? $37c8ab0886a3f2aa$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $bqyjg.default)((0, $bzmCU.default)((0, $lJqsK.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $37c8ab0886a3f2aa$var$getClippingParents(element) {
    var clippingParents = (0, $bh0bC.default)((0, $5rloo.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $DKWEv.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $eyZgR.isHTMLElement)(element) ? (0, $6TiV3.default)(element) : element;
    if (!(0, $eyZgR.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $eyZgR.isElement)(clippingParent) && (0, $bnZkU.default)(clippingParent, clipperElement) && (0, $hm1wJ.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $37c8ab0886a3f2aa$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $37c8ab0886a3f2aa$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $37c8ab0886a3f2aa$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $jjJ3Q.max)(rect.top, accRect.top);
        accRect.right = (0, $jjJ3Q.min)(rect.right, accRect.right);
        accRect.bottom = (0, $jjJ3Q.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $jjJ3Q.max)(rect.left, accRect.left);
        return accRect;
    }, $37c8ab0886a3f2aa$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("1JW7p", function(module, exports) {
$parcel$export(module.exports, "default", () => $144713904465e9aa$export$2e2bcd8739ae039);

var $1mV9B = parcelRequire("1mV9B");

var $lJqsK = parcelRequire("lJqsK");

var $2N7WB = parcelRequire("2N7WB");

var $6IY9T = parcelRequire("6IY9T");
function $144713904465e9aa$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $1mV9B.default)(element);
    var html = (0, $lJqsK.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $6IY9T.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $2N7WB.default)(element),
        y: y
    };
}

});

parcelRegister("bzmCU", function(module, exports) {
$parcel$export(module.exports, "default", () => $86c483c7598de391$export$2e2bcd8739ae039);

var $lJqsK = parcelRequire("lJqsK");

var $DKWEv = parcelRequire("DKWEv");

var $2N7WB = parcelRequire("2N7WB");

var $hNvaW = parcelRequire("hNvaW");

var $jjJ3Q = parcelRequire("jjJ3Q");
function $86c483c7598de391$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $lJqsK.default)(element);
    var winScroll = (0, $hNvaW.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $jjJ3Q.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $jjJ3Q.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $2N7WB.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $DKWEv.default)(body || html).direction === 'rtl') x += (0, $jjJ3Q.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("bnZkU", function(module, exports) {
$parcel$export(module.exports, "default", () => $84a16bc63c9721fc$export$2e2bcd8739ae039);

var $eyZgR = parcelRequire("eyZgR");
function $84a16bc63c9721fc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $eyZgR.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("bqyjg", function(module, exports) {
$parcel$export(module.exports, "default", () => $851cbc9a881ee36a$export$2e2bcd8739ae039);
function $851cbc9a881ee36a$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("5YeBx", function(module, exports) {
$parcel$export(module.exports, "default", () => $458de277c58ec793$export$2e2bcd8739ae039);

var $6GLc1 = parcelRequire("6GLc1");
function $458de277c58ec793$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $6GLc1.default)(), paddingObject);
}

});
parcelRegister("6GLc1", function(module, exports) {
$parcel$export(module.exports, "default", () => $4deb45dd1c4d2f74$export$2e2bcd8739ae039);
function $4deb45dd1c4d2f74$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("feEbn", function(module, exports) {
$parcel$export(module.exports, "default", () => $b17755393fee5db0$export$2e2bcd8739ae039);
function $b17755393fee5db0$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("bzk8P", function(module, exports) {
$parcel$export(module.exports, "default", () => $86c2963e32664915$export$2e2bcd8739ae039);

var $hWYug = parcelRequire("hWYug");

var $4JZl1 = parcelRequire("4JZl1");

var $d4gW5 = parcelRequire("d4gW5");

var $axX8x = parcelRequire("axX8x");
function $86c2963e32664915$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $4JZl1.placements) : _options$allowedAutoP;
    var variation = (0, $hWYug.default)(placement);
    var placements = variation ? flipVariations ? (0, $4JZl1.variationPlacements) : (0, $4JZl1.variationPlacements).filter(function(placement) {
        return (0, $hWYug.default)(placement) === variation;
    }) : (0, $4JZl1.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $d4gW5.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $axX8x.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("80FTA", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d4ed26bad1175bc$export$2e2bcd8739ae039);

var $4JZl1 = parcelRequire("4JZl1");

var $axX8x = parcelRequire("axX8x");

var $8u4Bg = parcelRequire("8u4Bg");

var $lzUVy = parcelRequire("lzUVy");

var $dtniG = parcelRequire("dtniG");

var $4acnM = parcelRequire("4acnM");

var $6TiV3 = parcelRequire("6TiV3");

var $d4gW5 = parcelRequire("d4gW5");

var $hWYug = parcelRequire("hWYug");

var $6GLc1 = parcelRequire("6GLc1");

var $jjJ3Q = parcelRequire("jjJ3Q");
function $5d4ed26bad1175bc$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $d4gW5.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $axX8x.default)(state.placement);
    var variation = (0, $hWYug.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $8u4Bg.default)(basePlacement);
    var altAxis = (0, $lzUVy.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $4JZl1.top) : (0, $4JZl1.left);
        var altSide = mainAxis === 'y' ? (0, $4JZl1.bottom) : (0, $4JZl1.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $4JZl1.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $4JZl1.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $4acnM.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $6GLc1.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $dtniG.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $6TiV3.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $dtniG.within)(tether ? (0, $jjJ3Q.min)(min, tetherMin) : min, offset, tether ? (0, $jjJ3Q.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $4JZl1.top) : (0, $4JZl1.left);
        var _altSide = mainAxis === 'x' ? (0, $4JZl1.bottom) : (0, $4JZl1.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $4JZl1.top),
            (0, $4JZl1.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $dtniG.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $dtniG.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $5d4ed26bad1175bc$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $5d4ed26bad1175bc$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("lzUVy", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb590673c9f5c002$export$2e2bcd8739ae039);
function $fb590673c9f5c002$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("dtniG", function(module, exports) {
$parcel$export(module.exports, "within", () => $9cf00ec7f99c2afc$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $9cf00ec7f99c2afc$export$86c8af6d3ef0b4a);

var $jjJ3Q = parcelRequire("jjJ3Q");
function $9cf00ec7f99c2afc$export$f28d906d67a997f3(min, value, max) {
    return (0, $jjJ3Q.max)(min, (0, $jjJ3Q.min)(value, max));
}
function $9cf00ec7f99c2afc$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $9cf00ec7f99c2afc$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("5qZps", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f4f041d2525b29e$export$2e2bcd8739ae039);

var $axX8x = parcelRequire("axX8x");

var $4acnM = parcelRequire("4acnM");

var $bnZkU = parcelRequire("bnZkU");

var $6TiV3 = parcelRequire("6TiV3");

var $8u4Bg = parcelRequire("8u4Bg");

var $dtniG = parcelRequire("dtniG");

var $5YeBx = parcelRequire("5YeBx");

var $feEbn = parcelRequire("feEbn");

var $4JZl1 = parcelRequire("4JZl1");
var $3f4f041d2525b29e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $5YeBx.default)(typeof padding !== 'number' ? padding : (0, $feEbn.default)(padding, (0, $4JZl1.basePlacements)));
};
function $3f4f041d2525b29e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $axX8x.default)(state.placement);
    var axis = (0, $8u4Bg.default)(basePlacement);
    var isVertical = [
        (0, $4JZl1.left),
        (0, $4JZl1.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $3f4f041d2525b29e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $4acnM.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $4JZl1.top) : (0, $4JZl1.left);
    var maxProp = axis === 'y' ? (0, $4JZl1.bottom) : (0, $4JZl1.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $6TiV3.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $dtniG.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $3f4f041d2525b29e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $bnZkU.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $3f4f041d2525b29e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $3f4f041d2525b29e$var$arrow,
    effect: $3f4f041d2525b29e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("ltwXj", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa25deb84cdc6cd4$export$2e2bcd8739ae039);

var $4JZl1 = parcelRequire("4JZl1");

var $d4gW5 = parcelRequire("d4gW5");
function $fa25deb84cdc6cd4$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $fa25deb84cdc6cd4$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $4JZl1.top),
        (0, $4JZl1.right),
        (0, $4JZl1.bottom),
        (0, $4JZl1.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $fa25deb84cdc6cd4$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $d4gW5.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $d4gW5.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $fa25deb84cdc6cd4$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $fa25deb84cdc6cd4$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $fa25deb84cdc6cd4$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $fa25deb84cdc6cd4$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $fa25deb84cdc6cd4$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $fa25deb84cdc6cd4$var$hide
};

});


parcelRegister("dgx9M", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $9a867d38592235eb$var$hasElementType = typeof Element !== 'undefined';
var $9a867d38592235eb$var$hasMap = typeof Map === 'function';
var $9a867d38592235eb$var$hasSet = typeof Set === 'function';
var $9a867d38592235eb$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $9a867d38592235eb$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$9a867d38592235eb$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($9a867d38592235eb$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$9a867d38592235eb$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($9a867d38592235eb$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($9a867d38592235eb$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($9a867d38592235eb$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$9a867d38592235eb$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $9a867d38592235eb$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});



parcelRegister("eI54n", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", () => $e04042c220ee25d9$export$6d8c2b45c99d6e3f);
function $e04042c220ee25d9$export$6d8c2b45c99d6e3f({ viewportPadding: viewportPadding }) {
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn ({ state: state, name: name }) {
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn ({ state: state }) {
                const data = state.modifiersData.maxSizeData;
                if (typeof data?.viewport?.width !== 'number' || typeof data?.viewport?.height !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                const { viewport: viewport } = data;
                const { popperOffsets: popperOffsets = {
                    x: 0,
                    y: 0
                } } = state.modifiersData;
                const [basePlacement] = state.placement.split('-');
                const placementOffset = state.modifiersData?.offset?.[state.placement] ?? {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                let maxWidth = viewport.width - 2 * viewportPadding;
                let maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = `${maxWidth}px`;
                state.styles.popper.maxHeight = `${maxHeight}px`;
            }
        }
    ];
}

});

parcelRegister("lAfnf", function(module, exports) {
$parcel$export(module.exports, "PopperTopLayer", () => $d58b0db9de82403b$export$9802f50720ab826e);

var $1v5pe = parcelRequire("1v5pe");

var $aD9yk = parcelRequire("aD9yk");

var $fBJWG = parcelRequire("fBJWG");

var $jL9lp = parcelRequire("jL9lp");

var $4RAor = parcelRequire("4RAor");

var $hWoE3 = parcelRequire("hWoE3");

var $fZI65 = parcelRequire("fZI65");

var $akiB7 = parcelRequire("akiB7");

var $lyX3t = parcelRequire("lyX3t");

var $9TZYC = parcelRequire("9TZYC");

var $fxK4C = parcelRequire("fxK4C");

var $6gUQ3 = parcelRequire("6gUQ3");

var $kIqwl = parcelRequire("kIqwl");
/**
 * Inert render-prop values. The browser owns positioning under CSS Anchor
 * Positioning, so `style` / `ref` / `arrowProps` / `update` / `forceUpdate`
 * are no-ops that consumers can safely spread. Module scope keeps identities
 * stable for effect dep arrays.
 */ const $d58b0db9de82403b$var$noopStyle = {};
const $d58b0db9de82403b$var$noopSetRef = (0, $aD9yk.default);
const $d58b0db9de82403b$var$noopUpdate = ()=>Promise.resolve(null);
const $d58b0db9de82403b$var$noopForceUpdate = ()=>({});
const $d58b0db9de82403b$var$noopArrowProps = {
    ref: $d58b0db9de82403b$var$noopSetRef,
    style: $d58b0db9de82403b$var$noopStyle,
    'data-popper-arrow': true
};
/**
 * Normalises popper's `[along, away]` offset (which may include `null` or
 * `undefined` entries) into the `[along, away]` number tuple
 * `fromLegacyPlacement` expects.
 */ function $d58b0db9de82403b$var$popperToTopLayerOffset(offset) {
    if (!offset) return undefined;
    const [along, away] = offset;
    if (along == null && away == null) return undefined;
    return [
        along ?? 0,
        away ?? 0
    ];
}
/**
 * SSR-safe `instanceof HTMLElement`. This runs during render, and the server
 * has no `HTMLElement` global. No hydration mismatch: refs are unset on the
 * server and on the first client render, so both sides get the same result.
 */ function $d58b0db9de82403b$var$isHTMLElement(value) {
    return typeof HTMLElement !== 'undefined' && value instanceof HTMLElement;
}
function $d58b0db9de82403b$export$9802f50720ab826e({ children: children, offset: offset, placement: placement = 'bottom-start', referenceElement: referenceElement, shouldFitViewport: shouldFitViewport = false }) {
    // `modifiers` and `strategy` are accepted for source compatibility but have
    // no runtime effect; CSS Anchor Positioning + top-layer rendering replaces
    // them. See `top-layer/notes/migrations/popper-migration.md`.
    // Anchor resolution: `referenceElement` prop, then `<Manager>` context.
    const managerAnchor = (0, $fxK4C.useManagerAnchor)();
    const effectiveReference = referenceElement ?? managerAnchor ?? undefined;
    // Real DOM nodes are anchored by `useAnchoredPopover`; popper
    // `VirtualElement`s go to `useAnchoredPopoverAtPoint`, which owns a synthetic
    // anchor element in `document.body`.
    const htmlAnchor = $d58b0db9de82403b$var$isHTMLElement(effectiveReference) ? effectiveReference : null;
    const virtualReference = effectiveReference != null && !$d58b0db9de82403b$var$isHTMLElement(effectiveReference) ? effectiveReference : null;
    const htmlAnchorRef = (0, $1v5pe.useRef)(htmlAnchor);
    htmlAnchorRef.current = htmlAnchor;
    const popoverRef = (0, $1v5pe.useRef)(null);
    const popoverId = (0, $fZI65.usePopoverId)();
    // Track the resolved DOM anchor in state so the visibility hook re-runs when
    // its identity changes. Virtual anchors do not feed that hook, because their
    // probe is outside the consumer's DOM.
    //
    // Adjust state during render by comparing against the state itself: the
    // conditional guard means `setResolvedAnchor` is skipped once they match,
    // so it converges in one extra render. This is the React-documented pattern
    // and is side-effect-free — no ref mutation during render.
    const [resolvedAnchor, setResolvedAnchor] = (0, $1v5pe.useState)(htmlAnchor);
    if (resolvedAnchor !== htmlAnchor) setResolvedAnchor(htmlAnchor);
    const topLayerPlacement = (0, $1v5pe.useMemo)(()=>{
        return (0, $fBJWG.fromLegacyPlacement)({
            legacy: (0, $9TZYC.toLegacyPlacement)(placement),
            offset: $d58b0db9de82403b$var$popperToTopLayerOffset(offset)
        });
    }, [
        placement,
        offset
    ]);
    const isOpen = effectiveReference != null;
    // Refs, because `getPoint` is LATCHED: called once per activation, so a
    // closed-over value would go stale if either prop changed while it stayed open.
    const virtualReferenceRef = (0, $1v5pe.useRef)(virtualReference);
    virtualReferenceRef.current = virtualReference;
    const topLayerPlacementRef = (0, $1v5pe.useRef)(topLayerPlacement);
    topLayerPlacementRef.current = topLayerPlacement;
    // Two positioning hooks, at most one enabled: `htmlAnchor` and
    // `virtualReference` both derive from `effectiveReference`, so they are never
    // both set, and when neither is the popover is closed.
    const isElementAnchored = htmlAnchor !== null;
    const isPointAnchored = virtualReference !== null;
    // Passed as one object so the element and point calls cannot drift.
    const sharedPositioning = {
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen,
        inlineSize: shouldFitViewport ? 'max-available' : 'content',
        blockSize: shouldFitViewport ? 'max-available' : 'content'
    };
    (0, $4RAor.useAnchoredPopover)({
        ...sharedPositioning,
        anchorRef: htmlAnchorRef,
        isEnabled: isElementAnchored
    });
    (0, $hWoE3.useAnchoredPopoverAtPoint)({
        ...sharedPositioning,
        isEnabled: isPointAnchored,
        getPoint: ()=>{
            const current = virtualReferenceRef.current;
            if (!current) return null;
            return (0, $lyX3t.rectPointForPlacement)({
                rect: current.getBoundingClientRect(),
                placement: topLayerPlacementRef.current,
                isRtl: (0, $akiB7.isPageRtl)()
            });
        }
    });
    const { isReferenceHidden: isReferenceHidden, hasPopperEscaped: hasPopperEscaped } = (0, $6gUQ3.useReferenceVisibility)({
        anchor: resolvedAnchor,
        popoverRef: popoverRef
    });
    const renderChildren = children;
    if (typeof renderChildren !== 'function') return null;
    const renderPropArg = {
        ref: $d58b0db9de82403b$var$noopSetRef,
        style: $d58b0db9de82403b$var$noopStyle,
        placement: placement,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped,
        update: $d58b0db9de82403b$var$noopUpdate,
        forceUpdate: $d58b0db9de82403b$var$noopForceUpdate,
        arrowProps: $d58b0db9de82403b$var$noopArrowProps
    };
    const content = renderChildren(renderPropArg);
    // Rendered directly into the `<Popover>` host, which supplies the flex
    // formatting context the size caps need — so the render prop must return ONE
    // element. See `children` in `@atlaskit/top-layer`'s `popover/types.tsx`.
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jL9lp.Popover), {
        ref: popoverRef,
        id: popoverId,
        isOpen: isOpen,
        mode: "manual",
        shouldAnimate: false,
        children: content
    });
}

});
parcelRegister("fBJWG", function(module, exports) {
$parcel$export(module.exports, "fromLegacyPlacement", () => $6b2dab1848fd34b2$export$69e99ed50b2534c9);

var $4MXgM = parcelRequire("4MXgM");
function $6b2dab1848fd34b2$export$69e99ed50b2534c9({ legacy: legacy, offset: offset }) {
    const basePlacement = (0, $4MXgM.placementMapping)[legacy];
    if (!offset) return basePlacement;
    const [along, away] = offset;
    return {
        ...basePlacement,
        offset: {
            gap: away,
            crossAxisShift: {
                // `direction` holds the sign and `value` holds the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    };
}

});
parcelRegister("4MXgM", function(module, exports) {
$parcel$export(module.exports, "placementMapping", () => $ad3035c5b9315788$export$27df359c528b7120);
const $ad3035c5b9315788$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};

});


parcelRegister("jL9lp", function(module, exports) {
$parcel$export(module.exports, "Popover", () => $2c5ea079d1bfd0d5$export$5b6b19405a83ff9d);
/* popover.tsx generated by @compiled/babel-plugin v3.0.2 */ /* popover.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $1v5pe = parcelRequire("1v5pe");

var $hGIzV = parcelRequire("hGIzV");

var $dmmsG = parcelRequire("dmmsG");

var $fl4ll = parcelRequire("fl4ll");

var $c16KL = parcelRequire("c16KL");

var $3q5kf = parcelRequire("3q5kf");

var $59fvM = parcelRequire("59fvM");

var $gHI9p = parcelRequire("gHI9p");

var $w8uxN = parcelRequire("w8uxN");

var $eaSsy = parcelRequire("eaSsy");

var $bLaOP = parcelRequire("bLaOP");

var $ilEG4 = parcelRequire("ilEG4");

var $kIqwl = parcelRequire("kIqwl");
const $2c5ea079d1bfd0d5$var$_48 = "._9kefi7uo:defined:defined:defined{color:var(--ds-text,#292a2e)}";
const $2c5ea079d1bfd0d5$var$_47 = "._1b80glyw:defined:defined:defined{text-transform:none}";
const $2c5ea079d1bfd0d5$var$_46 = "._m466idpf:defined:defined:defined{text-indent:0}";
const $2c5ea079d1bfd0d5$var$_45 = "._tcxkv2br:defined:defined:defined{text-align:start}";
const $2c5ea079d1bfd0d5$var$_44 = "._1f6b4jg8:defined:defined:defined{overflow-wrap:normal}";
const $2c5ea079d1bfd0d5$var$_43 = "._19w84jg8:defined:defined:defined{word-break:normal}";
const $2c5ea079d1bfd0d5$var$_42 = "._ux9u4jg8:defined:defined:defined{white-space:normal}";
const $2c5ea079d1bfd0d5$var$_41 = "._goh41wug:defined:defined:defined{pointer-events:auto}";
const $2c5ea079d1bfd0d5$var$_40 = "._y44vof1f{animation:var(--ds-popover-motion-exit)}";
const $2c5ea079d1bfd0d5$var$_39 = "._y44v179n{animation:var(--ds-popover-motion-enter)}";
const $2c5ea079d1bfd0d5$var$_38 = "@media (prefers-reduced-motion:reduce){._bl8aglyw{animation-name:none}._156y147i{transition-duration:var(--ds-duration-instant,0ms)}}";
const $2c5ea079d1bfd0d5$var$_37 = "._1o511hrf{animation-fill-mode:both}";
const $2c5ea079d1bfd0d5$var$_36 = "._1s9z1a5r{transition-behavior:allow-discrete}";
const $2c5ea079d1bfd0d5$var$_35 = "._1oecdn4k{transition-duration:var(--ds-duration-xshort,.1s)}";
const $2c5ea079d1bfd0d5$var$_34 = "._k8m011k7{transition-property:overlay,display}";
const $2c5ea079d1bfd0d5$var$_33 = ":where(._f5r5idpf)>*{min-block-size:0}";
const $2c5ea079d1bfd0d5$var$_32 = ":where(._1yp3idpf)>*{min-inline-size:0}";
const $2c5ea079d1bfd0d5$var$_31 = ":where(._51hckb7n)>*{flex-grow:1}";
const $2c5ea079d1bfd0d5$var$_30 = "._1p7w1txw:popover-open:popover-open:popover-open{display:flex}";
const $2c5ea079d1bfd0d5$var$_29 = "._1715kb7n:defined:defined:defined{opacity:1}";
const $2c5ea079d1bfd0d5$var$_28 = "._1s8uglyw:defined:defined:defined{rotate:none}";
const $2c5ea079d1bfd0d5$var$_27 = "._tdqwglyw:defined:defined:defined{scale:none}";
const $2c5ea079d1bfd0d5$var$_26 = "._x2wjglyw:defined:defined:defined{translate:none}";
const $2c5ea079d1bfd0d5$var$_25 = "._1f2zglyw:defined:defined:defined{transform:none}";
const $2c5ea079d1bfd0d5$var$_24 = "._jg1o4jg8:defined:defined:defined{justify-self:normal}";
const $2c5ea079d1bfd0d5$var$_23 = "._1ljj4jg8:defined:defined:defined{align-self:normal}";
const $2c5ea079d1bfd0d5$var$_22 = "._ao8dglyw:defined:defined:defined{max-height:none}";
const $2c5ea079d1bfd0d5$var$_21 = "._1gd81wug:defined:defined:defined{min-height:auto}";
const $2c5ea079d1bfd0d5$var$_20 = "._li0iglyw:defined:defined:defined{max-width:none}";
const $2c5ea079d1bfd0d5$var$_19 = "._1yd01wug:defined:defined:defined{min-width:auto}";
const $2c5ea079d1bfd0d5$var$_18 = "._1rmr1wug:defined:defined:defined{height:auto}";
const $2c5ea079d1bfd0d5$var$_17 = "._qctn1ns9:defined:defined:defined{width:-moz-fit-content;width:fit-content}";
const $2c5ea079d1bfd0d5$var$_16 = "._1dqv1n9t:defined:defined:defined{position:fixed}";
const $2c5ea079d1bfd0d5$var$_15 = "._1ogd4jg8:defined:defined:defined{justify-content:normal}";
const $2c5ea079d1bfd0d5$var$_14 = "._17ke4jg8:defined:defined:defined{align-items:normal}";
const $2c5ea079d1bfd0d5$var$_13 = "._1maw1q9c:defined:defined:defined{flex-wrap:nowrap}";
const $2c5ea079d1bfd0d5$var$_12 = "._kqwmvrvc:defined:defined:defined{flex-direction:row}";
const $2c5ea079d1bfd0d5$var$_11 = "._1rec1j28:defined:defined:defined{background-color:transparent}";
const $2c5ea079d1bfd0d5$var$_10 = "._1blzewfl:defined:defined:defined{overflow-y:visible}";
const $2c5ea079d1bfd0d5$var$_1 = "._wmifewfl:defined:defined:defined{overflow-x:visible}";
const $2c5ea079d1bfd0d5$var$_0 = "._1vdi1wug:defined:defined:defined{inset:auto}";
const $2c5ea079d1bfd0d5$var$_9 = "._1ap0idpf:defined:defined:defined{margin-left:0}";
const $2c5ea079d1bfd0d5$var$_8 = "._1aqridpf:defined:defined:defined{margin-bottom:0}";
const $2c5ea079d1bfd0d5$var$_7 = "._z3e7idpf:defined:defined:defined{margin-right:0}";
const $2c5ea079d1bfd0d5$var$_6 = "._b2a9idpf:defined:defined:defined{margin-top:0}";
const $2c5ea079d1bfd0d5$var$_5 = "._byz4idpf:defined:defined:defined{padding-left:0}";
const $2c5ea079d1bfd0d5$var$_4 = "._1mjeidpf:defined:defined:defined{padding-bottom:0}";
const $2c5ea079d1bfd0d5$var$_3 = "._13shidpf:defined:defined:defined{padding-right:0}";
const $2c5ea079d1bfd0d5$var$_2 = "._az2pidpf:defined:defined:defined{padding-top:0}";
const $2c5ea079d1bfd0d5$var$_ = "._lzhqglyw:defined:defined:defined{border:none}";
function $2c5ea079d1bfd0d5$var$restoreFocus({ popover: popover, focusRestorationTarget: focusRestorationTarget }) {
    if (!focusRestorationTarget) return;
    const { ownerDocument: ownerDocument } = popover;
    // Native restoration has finished. Preserve focus moved outside the popover.
    const activeElementAfterClose = ownerDocument.activeElement;
    // Before close, we checked that focus was inside. Body can now mean focus was lost during close.
    if (activeElementAfterClose === ownerDocument.body || popover.contains(activeElementAfterClose)) // Match native popover restoration, which does not scroll the viewport.
    focusRestorationTarget.focus({
        preventScroll: true
    });
}
/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ const $2c5ea079d1bfd0d5$var$supportsPopoverHint = (0, $c16KL.default)(()=>{
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    const element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
/**
 * **Surface reset**
 *
 * The host is still a DOM child of its trigger for inheritance, so it inherits
 * values like `pointer-events: none` or `white-space: nowrap`. Resets them to
 * what `<body>` gave the portal path. `font` and direction still inherit.
 * Not `all: initial`: that would also override the UA `[popover]` rules.
 *
 * `color` is a reset too: the UA `[popover]` rule sets `color: CanvasText`, so
 * the host never inherits a colour. `color.text` is what `<body>` gave the portal
 * path. Not `inherit`, which would take the trigger's colour (for example a link).
 * See `notes/decisions/surface-reset-color.md`.
 *
 * KEEP IN SYNC with `dialog/dialog-content.tsx` (ADS forbids shared styles).
 * The `satisfies` check below catches drift.
 */ const $2c5ea079d1bfd0d5$var$surfaceResetStyles = {
    root: "_goh41wug _ux9u4jg8 _19w84jg8 _1f6b4jg8 _tcxkv2br _m466idpf _1b80glyw _9kefi7uo"
};
const $2c5ea079d1bfd0d5$var$styles = {
    root: "_lzhqglyw _az2pidpf _13shidpf _1mjeidpf _byz4idpf _b2a9idpf _z3e7idpf _1aqridpf _1ap0idpf _1vdi1wug _wmifewfl _1blzewfl _1rec1j28 _kqwmvrvc _1maw1q9c _17ke4jg8 _1ogd4jg8 _1dqv1n9t _qctn1ns9 _1rmr1wug _1yd01wug _li0iglyw _1gd81wug _ao8dglyw _1ljj4jg8 _jg1o4jg8 _1f2zglyw _x2wjglyw _tdqwglyw _1s8uglyw _1715kb7n _1p7w1txw _51hckb7n _1yp3idpf _f5r5idpf",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
const $2c5ea079d1bfd0d5$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
const $2c5ea079d1bfd0d5$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $1v5pe.forwardRef)(function Popover({ children: children, mode: modeProp = 'auto', onClose: onClose, onEnterFinish: onEnterFinish, onExitFinish: onExitFinish, shouldAnimate: shouldAnimate = false, placement: placement, testId: testId, isOpen: isOpen, enteringAnimationXcss: enteringAnimationXcss, exitingAnimationXcss: exitingAnimationXcss, initialFocusRef: initialFocusRef, UNSAFE__disableInitialAutoFocus: UNSAFE__disableInitialAutoFocus = false, role: // ARIA
role, label: label, labelledBy: labelledBy, id: idProp }, ref) {
    const autoId = (0, $1v5pe.useId)();
    const ownRef = (0, $1v5pe.useRef)(null);
    const combinedRef = (0, $fl4ll.default)([
        ownRef,
        ref
    ].filter(Boolean)); // `useId()` colons are invalid in CSS selectors and popover target attributes.
    const popoverId = idProp ?? `popover-${autoId.replace(/:/g, '')}`; // Keep the semantic callback current without rebinding native lifecycle
    // listeners during the same commit that calls showPopover()/hidePopover().
    const onCloseRef = (0, $1v5pe.useRef)(onClose);
    (0, $3q5kf.useLayoutEffect)(()=>{
        onCloseRef.current = onClose;
    }, [
        onClose
    ]); // A popover with `onClose` is closable (see `closable-popover-contract`).
    // `requestClosePopovers()` asks it to close; the consumer decides.
    const isClosable = Boolean(onClose); // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    const mode = modeProp === 'hint' && !$2c5ea079d1bfd0d5$var$supportsPopoverHint() ? 'auto' : modeProp;
    const popupMotionStyle = (0, $1v5pe.useMemo)(()=>{
        if (!placement || !shouldAnimate) return undefined;
        const { axis: axis, edge: edge } = (0, $w8uxN.resolvePlacement)({
            placement: placement
        });
        return $2c5ea079d1bfd0d5$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]); // Tracks the close reason, including our own hidePopover() calls.
    const closeReasonRef = (0, $1v5pe.useRef)('light-dismiss'); // Pre-open focus target, cleared before close when restoration is not eligible.
    const focusRestorationTargetRef = (0, $1v5pe.useRef)(null);
    const handleBeforeToggle = (0, $1v5pe.useCallback)((event)=>{
        const popover = event.currentTarget;
        if (!(popover instanceof HTMLElement)) return;
        const { ownerDocument: ownerDocument } = popover;
        const { activeElement: activeElement } = ownerDocument;
        if (event.newState === 'open') {
            focusRestorationTargetRef.current = activeElement instanceof HTMLElement ? activeElement : null;
            return;
        } /**
       * Like native restoration, leave external focus alone and skip light dismiss.
       * Check before closing so focus already on body is not mistaken for focus lost during close.
       * See https://html.spec.whatwg.org/multipage/popover.html#hide-popover-algorithm (step 20.2).
       */ 
        if (closeReasonRef.current === 'light-dismiss' || !popover.contains(activeElement)) focusRestorationTargetRef.current = null;
    }, []);
    const handleToggleClosed = (0, $1v5pe.useCallback)((event)=>{
        const popover = event.currentTarget;
        if (!(popover instanceof HTMLElement)) return;
        const focusRestorationTarget = focusRestorationTargetRef.current;
        focusRestorationTargetRef.current = null;
        const reason = closeReasonRef.current; // Reset reason so a stale 'escape' from a race with Escape keydown
        // does not corrupt the next browser-dismiss cycle.
        closeReasonRef.current = 'light-dismiss'; // Run after native restoration, before notifying the consumer, which may move focus itself.
        $2c5ea079d1bfd0d5$var$restoreFocus({
            popover: popover,
            focusRestorationTarget: focusRestorationTarget
        }); // Programmatic closes are already known to the consumer.
        if (reason !== 'programmatic') onCloseRef.current?.({
            reason: reason
        });
    }, []);
    const { phase: phase, isMounted: isMounted, onBeforeToggle: onBeforeToggle, onToggle: onToggle } = (0, $eaSsy.useAnimatedVisibility)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }); // Focus management: Tab cycling for dialog roles. Initial focus is below
    // the show/hide layout effect. Restoration is native for outermost
    // popovers; nested popovers are handled above via the `beforetoggle`
    // snapshot. Passing `phase` keeps `useFocusWrap` attached through the
    // animated-exit window (WCAG 2.4.3 guard). See notes/architecture/focus.md.
    (0, $bLaOP.useFocusWrap)({
        elementRef: ownRef,
        role: role,
        phase: phase
    }); // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `focusRestorationTargetRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $3q5kf.useLayoutEffect)(()=>{
        const element = ownRef.current;
        if (!element) return;
         // Tag Escape before the browser processes light dismiss.
        const unbindEscape = (0, $dmmsG.bind)(element, {
            type: 'keydown',
            listener: (event)=>{
                // Ignore Escape events dispatched after native close.
                if (event.key === 'Escape' && (0, $gHI9p.isNativeElementOpen)({
                    element: element
                })) closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        const unbindToggle = (0, $dmmsG.bind)(element, {
            type: 'toggle',
            listener: (event)=>{
                if (event.newState === 'closed') handleToggleClosed(event);
                onToggle(event);
            }
        }); // Snapshot the active element before `useInitialFocus` moves it,
        // then advance the shared visibility lifecycle.
        const unbindBeforeToggle = (0, $dmmsG.bind)(element, {
            type: 'beforetoggle',
            listener: (event)=>{
                handleBeforeToggle(event);
                onBeforeToggle(event);
            }
        }); // `requestClosePopovers()` asks the consumer to close. Nothing is
        // hidden here, so a consumer that keeps `isOpen` stays in sync.
        const unbindRequestClose = (0, $dmmsG.bind)(element, {
            type: (0, $59fvM.requestCloseEventName),
            listener: ()=>{
                onCloseRef.current?.({
                    reason: 'programmatic'
                });
            }
        });
        return ()=>{
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
            unbindRequestClose();
        };
    }, [
        handleBeforeToggle,
        handleToggleClosed,
        isMounted,
        onBeforeToggle,
        onToggle
    ]); // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $3q5kf.useLayoutEffect)(()=>{
        const element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and interrupted close lifecycles may not reach
            // `handleToggleClosed` to reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch  {}
            return ()=>{
                closeReasonRef.current = 'programmatic';
                try {
                    element.hidePopover();
                } catch  {}
            };
        }
        closeReasonRef.current = 'programmatic';
        try {
            element.hidePopover();
        } catch  {}
    }, [
        isOpen
    ]); // Initial focus (role-dependent) is a layout effect, so it must come AFTER
    // the show/hide layout effect above: React runs layout effects in source
    // order, and focus only works once `showPopover()` has run. Focus then
    // lands in the same task as the open, before the browser paints.
    (0, $ilEG4.useInitialFocus)({
        elementRef: ownRef,
        isEnabled: !UNSAFE__disableInitialAutoFocus,
        initialFocusRef: initialFocusRef,
        phase: phase,
        role: role
    }); // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isMounted) return null;
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $2c5ea079d1bfd0d5$var$_,
                    $2c5ea079d1bfd0d5$var$_2,
                    $2c5ea079d1bfd0d5$var$_3,
                    $2c5ea079d1bfd0d5$var$_4,
                    $2c5ea079d1bfd0d5$var$_5,
                    $2c5ea079d1bfd0d5$var$_6,
                    $2c5ea079d1bfd0d5$var$_7,
                    $2c5ea079d1bfd0d5$var$_8,
                    $2c5ea079d1bfd0d5$var$_9,
                    $2c5ea079d1bfd0d5$var$_0,
                    $2c5ea079d1bfd0d5$var$_1,
                    $2c5ea079d1bfd0d5$var$_10,
                    $2c5ea079d1bfd0d5$var$_11,
                    $2c5ea079d1bfd0d5$var$_12,
                    $2c5ea079d1bfd0d5$var$_13,
                    $2c5ea079d1bfd0d5$var$_14,
                    $2c5ea079d1bfd0d5$var$_15,
                    $2c5ea079d1bfd0d5$var$_16,
                    $2c5ea079d1bfd0d5$var$_17,
                    $2c5ea079d1bfd0d5$var$_18,
                    $2c5ea079d1bfd0d5$var$_19,
                    $2c5ea079d1bfd0d5$var$_20,
                    $2c5ea079d1bfd0d5$var$_21,
                    $2c5ea079d1bfd0d5$var$_22,
                    $2c5ea079d1bfd0d5$var$_23,
                    $2c5ea079d1bfd0d5$var$_24,
                    $2c5ea079d1bfd0d5$var$_25,
                    $2c5ea079d1bfd0d5$var$_26,
                    $2c5ea079d1bfd0d5$var$_27,
                    $2c5ea079d1bfd0d5$var$_28,
                    $2c5ea079d1bfd0d5$var$_29,
                    $2c5ea079d1bfd0d5$var$_30,
                    $2c5ea079d1bfd0d5$var$_31,
                    $2c5ea079d1bfd0d5$var$_32,
                    $2c5ea079d1bfd0d5$var$_33,
                    $2c5ea079d1bfd0d5$var$_34,
                    $2c5ea079d1bfd0d5$var$_35,
                    $2c5ea079d1bfd0d5$var$_36,
                    $2c5ea079d1bfd0d5$var$_37,
                    $2c5ea079d1bfd0d5$var$_38,
                    $2c5ea079d1bfd0d5$var$_39,
                    $2c5ea079d1bfd0d5$var$_40,
                    $2c5ea079d1bfd0d5$var$_41,
                    $2c5ea079d1bfd0d5$var$_42,
                    $2c5ea079d1bfd0d5$var$_43,
                    $2c5ea079d1bfd0d5$var$_44,
                    $2c5ea079d1bfd0d5$var$_45,
                    $2c5ea079d1bfd0d5$var$_46,
                    $2c5ea079d1bfd0d5$var$_47,
                    $2c5ea079d1bfd0d5$var$_48
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                ref: combinedRef,
                id: popoverId // @ts-expect-error -- popover attribute not yet in React types
                ,
                popover: mode,
                role: role // Keep in sync with `closablePopoverAttribute` (internal/closable-popover-contract).
                ,
                "data-top-layer-closable": isClosable ? '' : undefined,
                "aria-label": label,
                "aria-labelledby": labelledBy,
                "data-testid": testId // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Motion styles are selected at runtime from the placement.
                ,
                style: popupMotionStyle // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
                ,
                className: (0, $hMvDh.default)([
                    $2c5ea079d1bfd0d5$var$styles.root,
                    $2c5ea079d1bfd0d5$var$surfaceResetStyles.root,
                    shouldAnimate && phase === 'entering' && $2c5ea079d1bfd0d5$var$styles.enter,
                    shouldAnimate && phase === 'exiting' && $2c5ea079d1bfd0d5$var$styles.exit,
                    shouldAnimate && $2c5ea079d1bfd0d5$var$styles.motion,
                    (0, $hGIzV.cx)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
                ]),
                children: children
            })
        ]
    });
});

});
parcelRegister("c16KL", function(module, exports) {
$parcel$export(module.exports, "default", () => $660d4a0f2c6fc880$export$2e2bcd8739ae039);
function $660d4a0f2c6fc880$export$2e2bcd8739ae039(fn) {
    let cache = null;
    return function result(...args) {
        if (!cache) cache = {
            value: fn.call(this, ...args)
        };
        /**
     * Intentionally not adding `.clear()` function property
     *
     * - We currently have no need for it
     * - We don't want to add a `.clear()` to functions that should never be called twice,
     *   for example: `cleanup` functions.
     * - We can add a `onceWithCleanup` variant as a separate export from ds-lib if the
     *   need arises 🧘
     */ return cache.value;
    };
}

});

parcelRegister("3q5kf", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $9a00bb7fa11d0ec6$export$e5c5a5f917a5871c);

var $1v5pe = parcelRequire("1v5pe");
const $9a00bb7fa11d0ec6$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $1v5pe.useEffect) : (0, $1v5pe.useLayoutEffect);

});

parcelRegister("59fvM", function(module, exports) {
$parcel$export(module.exports, "closablePopoverAttribute", () => $aaf3693d7273c0fb$export$c6890d80f1a52941);
$parcel$export(module.exports, "requestCloseEventName", () => $aaf3693d7273c0fb$export$17ed9502ee8e92da);
/**
 * `Popover` sets this attribute on its host element when it has an `onClose`. Only those popovers
 * can be asked to close, so `hasOpenDialogOrPopover` counts only those and `requestClosePopovers`
 * asks only those. Outside code cannot dismiss a popover without `onClose` (for example the flag
 * group or a spotlight), so both skip it.
 *
 * `Popover` writes the attribute name as a literal JSX prop. Keep the two in sync.
 */ const $aaf3693d7273c0fb$export$c6890d80f1a52941 = 'data-top-layer-closable';
const $aaf3693d7273c0fb$export$17ed9502ee8e92da = 'top-layer-request-close';

});

parcelRegister("gHI9p", function(module, exports) {
$parcel$export(module.exports, "isNativeElementOpen", () => $5c664306de66fa7c$export$89b923e18c14644d);
/**
 * `true` when `element` is open in the DOM: an open `<dialog>`, or a popover that matches
 * `:popover-open`. This is the browser state, not the `isOpen` prop.
 */ function $5c664306de66fa7c$export$89b923e18c14644d({ element: element }) {
    if (element instanceof HTMLDialogElement) return element.open;
    // Some DOM implementations throw on `:popover-open`.
    try {
        return element.matches(':popover-open');
    } catch  {
        return false;
    }
}

});

parcelRegister("w8uxN", function(module, exports) {
$parcel$export(module.exports, "resolvePlacement", () => $66b0604844607e9f$export$63044d21bc3d3fa2);

var $8r31n = parcelRequire("8r31n");
/**
 * The gap between the anchor and the popover when `placement.offset.gap` is not
 * set. A design token (`space.100`), so it follows the spacing scale.
 */ const $66b0604844607e9f$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $66b0604844607e9f$export$63044d21bc3d3fa2({ placement: placement }) {
    return {
        axis: placement.axis ?? 'block',
        edge: placement.edge ?? 'end',
        align: placement.align ?? 'center',
        // No `??` default: `undefined` must survive, so "not set" stays different
        // from an explicit `0`.
        minSize: placement.minSize === undefined ? undefined : (0, $8r31n.toCssLengthString)({
            value: placement.minSize
        }),
        offset: {
            gap: (0, $8r31n.toCssLengthString)({
                value: placement.offset?.gap ?? $66b0604844607e9f$var$DEFAULT_GAP
            }),
            crossAxisShift: {
                value: (0, $8r31n.toCssLengthString)({
                    value: placement.offset?.crossAxisShift?.value ?? 0
                }),
                direction: placement.offset?.crossAxisShift?.direction ?? 'forwards'
            }
        }
    };
}

});
parcelRegister("8r31n", function(module, exports) {
$parcel$export(module.exports, "toCssLengthString", () => $34b3b64660bbd320$export$63b6b0ff65d84d47);
/**
 * Converts a length to a CSS length string. A number becomes `${value}px`, and a
 * string passes through unchanged. Apply at the API boundary, so internal code
 * only deals with strings.
 */ function $34b3b64660bbd320$export$63b6b0ff65d84d47({ value: value }) {
    if (typeof value === 'number') return `${value}px`;
    return value;
}

});


parcelRegister("eaSsy", function(module, exports) {
$parcel$export(module.exports, "useAnimatedVisibility", () => $a89544fdb2bf047e$export$1bccb45daf07907f);

var $1v5pe = parcelRequire("1v5pe");

var $3q5kf = parcelRequire("3q5kf");

var $gHI9p = parcelRequire("gHI9p");

var $jGgQY = parcelRequire("jGgQY");
/**
 * Calls `schedule` with a `settle` callback, and `settle` calls `onSettled`.
 * The returned cleanup makes `settle` do nothing, so an interrupted or
 * unmounted lifecycle cannot call a stale `onSettled`.
 */ function $a89544fdb2bf047e$var$runCancellableSettlement({ schedule: schedule, onSettled: onSettled }) {
    let isCancelled = false;
    schedule(()=>{
        if (isCancelled) return;
        onSettled();
    });
    return ()=>{
        isCancelled = true;
    };
}
/**
 * Calls `onSettled` when all animations on `element` at the time of the call
 * finish or are cancelled. With no animations, it settles in a promise
 * microtask. Returns a cleanup that stops a stale `onSettled` call.
 */ function $a89544fdb2bf047e$var$runOnAnimationsSettled({ element: element, onSettled: onSettled }) {
    return $a89544fdb2bf047e$var$runCancellableSettlement({
        onSettled: onSettled,
        schedule: (settle)=>{
            // Some environments, such as jsdom, do not implement `getAnimations`.
            const animations = element.getAnimations?.() ?? [];
            Promise.allSettled(animations.map((animation)=>animation.finished)).then(settle);
        }
    });
}
function $a89544fdb2bf047e$var$getInitialVisibilityState({ isOpen: isOpen, willAnimate: willAnimate }) {
    if (!isOpen) return {
        phase: 'closed',
        controlledIntent: 'closed'
    };
    if (willAnimate) return {
        phase: 'entering',
        controlledIntent: 'open'
    };
    return {
        phase: 'open',
        controlledIntent: 'open'
    };
}
/**
 * Applies one lifecycle event to the current visibility state.
 *
 * Events that are stale for the current phase are ignored. This allows
 * animation callbacks and native close events to settle safely after an
 * interrupted lifecycle.
 */ function $a89544fdb2bf047e$var$getNextVisibilityState(state, action) {
    if (action.type === 'open-requested') {
        const shouldEnter = state.phase === 'closed' || state.phase === 'exiting' && state.controlledIntent === 'closed';
        if (shouldEnter && action.willAnimate) return {
            phase: 'entering',
            controlledIntent: 'open'
        };
        if (shouldEnter) return {
            phase: 'open',
            controlledIntent: 'open'
        };
        return {
            ...state,
            controlledIntent: 'open'
        };
    }
    if (action.type === 'close-requested') return {
        ...state,
        controlledIntent: 'closed'
    };
    if (action.type === 'native-close-started') {
        if (state.phase !== 'open' && state.phase !== 'entering') return state;
        return {
            ...state,
            phase: 'exiting'
        };
    }
    // A browser dismiss started the exit while controlled intent stayed open, and
    // the element was shown natively again before the exit settled. For example,
    // `@atlaskit/tooltip` calls `showPopover()` on `pointerup`, in the same task as
    // the light dismiss of a press. The element never painted closed, so go back
    // to `open`. See `notes/decisions/tooltip-stay-open-on-trigger-click.md`.
    if (action.type === 'native-open-started') {
        if (state.phase !== 'exiting' || state.controlledIntent !== 'open') return state;
        return {
            ...state,
            phase: 'open'
        };
    }
    if (action.type === 'entry-settled') {
        if (state.phase !== 'entering') return state;
        return {
            ...state,
            phase: 'open'
        };
    }
    if (action.type === 'exit-settled') {
        if (state.phase !== 'exiting') return state;
        return {
            ...state,
            phase: 'closed'
        };
    }
    return state;
}
function $a89544fdb2bf047e$export$1bccb45daf07907f({ isOpen: isOpen, shouldAnimate: shouldAnimate, elementRef: elementRef, onEnterFinish: onEnterFinish, onExitFinish: onExitFinish }) {
    const willAnimate = shouldAnimate && !(0, $jGgQY.prefersReducedMotion)();
    const [visibilityState, dispatch] = (0, $1v5pe.useReducer)($a89544fdb2bf047e$var$getNextVisibilityState, {
        isOpen: isOpen,
        willAnimate: willAnimate
    }, $a89544fdb2bf047e$var$getInitialVisibilityState);
    const { phase: phase, controlledIntent: controlledIntent } = visibilityState;
    // Refs hold the latest callbacks and `willAnimate`, so the stable callbacks, effects
    // and settlement closures read current values without them in dependency arrays.
    const onEnterFinishRef = (0, $1v5pe.useRef)(onEnterFinish);
    const onExitFinishRef = (0, $1v5pe.useRef)(onExitFinish);
    const willAnimateRef = (0, $1v5pe.useRef)(willAnimate);
    (0, $3q5kf.useLayoutEffect)(()=>{
        onEnterFinishRef.current = onEnterFinish;
        onExitFinishRef.current = onExitFinish;
        willAnimateRef.current = willAnimate;
    }, [
        onEnterFinish,
        onExitFinish,
        willAnimate
    ]);
    // Synchronize controlled intent during render so opening mounts the host in
    // the same commit. Keeping the processed intent in reducer state prevents a
    // browser-driven exit from being mistaken for a new controlled open request.
    if (isOpen && controlledIntent === 'closed') dispatch({
        type: 'open-requested',
        willAnimate: willAnimate
    });
    if (!isOpen && controlledIntent === 'open') dispatch({
        type: 'close-requested'
    });
    // Call `onEnterFinish` after the `open` commit, so consumers observe the
    // settled host and not its entering styles. Entry can wait for the commit
    // because the host stays mounted. The previous phase starts as `closed`, so
    // a host that is open on mount also calls `onEnterFinish`.
    const previousPhaseRef = (0, $1v5pe.useRef)('closed');
    (0, $1v5pe.useEffect)(()=>{
        const previousPhase = previousPhaseRef.current;
        previousPhaseRef.current = phase;
        if (previousPhase === phase) return;
        if (phase === 'open') onEnterFinishRef.current?.();
    }, [
        phase
    ]);
    const isMounted = phase !== 'closed';
    const cancelExitSettlementRef = (0, $1v5pe.useRef)(()=>{});
    // Exit must notify consumers before `closed` unmounts the host.
    const settleExit = (0, $1v5pe.useCallback)(()=>{
        onExitFinishRef.current?.();
        dispatch({
            type: 'exit-settled'
        });
    }, []);
    const onBeforeToggle = (0, $1v5pe.useCallback)((event)=>{
        // Any native toggle cancels a pending exit settlement, so a stale
        // settlement cannot close a host that is reopening or closing again.
        cancelExitSettlementRef.current();
        // Snapshot `currentTarget`, because the DOM clears it after event dispatch.
        const element = event.currentTarget;
        if (event.newState === 'open') {
            // Undo the `inert` and `aria-hidden` that a previous close added.
            if (element instanceof HTMLElement) {
                element.removeAttribute('inert');
                element.removeAttribute('aria-hidden');
            }
            // Dispatched on every native open. The reducer only acts when a browser
            // dismiss left the host `exiting` while `isOpen` stayed `true`.
            dispatch({
                type: 'native-open-started'
            });
        }
        if (event.newState === 'closed') {
            if (element instanceof HTMLElement) // Wait a microtask so native focus restoration runs before the host
            // becomes inert. The browser restores focus after `beforetoggle`
            // returns, during its close steps.
            queueMicrotask(()=>{
                // A controlled close can be interrupted by `isOpen` changing back to
                // `true`, which reopens the element before this microtask runs.
                if ((0, $gHI9p.isNativeElementOpen)({
                    element: element
                })) return;
                // Exit animations keep the closed host rendered, so make it
                // non-interactive and hide it from assistive technology.
                element.setAttribute('inert', '');
                // Tooling does not consistently treat inert content as hidden, even
                // though the browser does.
                element.setAttribute('aria-hidden', 'true');
            });
            dispatch({
                type: 'native-close-started'
            });
        }
    }, []);
    const onToggle = (0, $1v5pe.useCallback)((event)=>{
        if (event.newState !== 'closed') return;
        if (!willAnimateRef.current) {
            cancelExitSettlementRef.current = $a89544fdb2bf047e$var$runCancellableSettlement({
                schedule: queueMicrotask,
                onSettled: settleExit
            });
            return;
        }
        const element = elementRef.current;
        if (!element) return;
        // The closed `toggle` is task-queued after the synchronous `beforetoggle`.
        // By now the `exiting` styles have committed, so the snapshot holds the
        // animations that decide when the exit settles.
        cancelExitSettlementRef.current = $a89544fdb2bf047e$var$runOnAnimationsSettled({
            element: element,
            onSettled: settleExit
        });
    }, [
        elementRef,
        settleExit
    ]);
    (0, $3q5kf.useLayoutEffect)(()=>()=>{
            // Prevent a pending animation or microtask from notifying after unmount.
            cancelExitSettlementRef.current();
        }, []);
    // Entry settlement moves the phase to `open`, which removes the entering
    // styles. The effect above then calls `onEnterFinish`.
    (0, $1v5pe.useEffect)(function settleEntry() {
        if (phase !== 'entering') return;
        // Animation was disabled during entry, so settle now.
        if (!willAnimate) {
            dispatch({
                type: 'entry-settled'
            });
            return;
        }
        const element = elementRef.current;
        if (!element) return;
        return $a89544fdb2bf047e$var$runOnAnimationsSettled({
            element: element,
            onSettled () {
                dispatch({
                    type: 'entry-settled'
                });
            }
        });
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    return {
        phase: phase,
        isMounted: isMounted,
        onBeforeToggle: onBeforeToggle,
        onToggle: onToggle
    };
}

});
parcelRegister("jGgQY", function(module, exports) {
$parcel$export(module.exports, "prefersReducedMotion", () => $2c24a920ce9623ab$export$ff7706047246b98b);

var $c16KL = parcelRequire("c16KL");
const $2c24a920ce9623ab$export$ff7706047246b98b = (0, $c16KL.default)(function getPrefersReducedMotion() {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});

});


parcelRegister("bLaOP", function(module, exports) {
$parcel$export(module.exports, "useFocusWrap", () => $d65561d5406f117d$export$4f6462e86a70abe5);

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $1CaUw = parcelRequire("1CaUw");

var $5Hn4C = parcelRequire("5Hn4C");

var $6rqEn = parcelRequire("6rqEn");

var $4UmzM = parcelRequire("4UmzM");
/**
 * Returns `true` for the roles that wrap Tab focus, per the WAI-ARIA APG:
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as `dialog`
 *
 * `menu` is not included. A menu is a composite widget
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within):
 * arrow keys move focus inside it, and Tab moves focus out of it.
 *
 * Menu keyboard behavior (arrow keys, Home and End, type-ahead, Enter and
 * Space) changes with orientation, nesting, item type and control pattern
 * (menu button or menubar), so this hook cannot do it for all menus. The
 * consumer (for example `dropdown-menu`) owns it.
 *
 * See `notes/decisions/menu-keyboard.md`.
 */ function $d65561d5406f117d$var$roleRequiresFocusWrap({ role: role }) {
    return role === 'dialog' || role === 'alertdialog';
}
function $d65561d5406f117d$export$4f6462e86a70abe5({ elementRef: elementRef, role: role, phase: phase }) {
    const isVisible = phase !== 'closed';
    (0, $1v5pe.useEffect)(()=>{
        const element = elementRef.current;
        if (!element || !$d65561d5406f117d$var$roleRequiresFocusWrap({
            role: role
        }) || !isVisible) return;
        const unbind = (0, $dmmsG.bind)(element, {
            type: 'keydown',
            listener: (event)=>{
                if (event.key !== 'Tab') return;
                // While focus is in a nested layer, that layer handles Tab.
                if ((0, $4UmzM.isNestedLayerFocused)({
                    container: element
                })) return;
                // Stop the browser focus move. This hook moves focus itself.
                event.preventDefault();
                const direction = event.shiftKey ? 'backwards' : 'forwards';
                const nextFocusable = (0, $6rqEn.getNextFocusable)({
                    container: element,
                    direction: direction
                });
                if (nextFocusable) {
                    nextFocusable.focus();
                    return;
                }
                // Focus is not inside the element, or the element has no focusable
                // elements. Move focus to the first or last focusable element, based
                // on the direction.
                const fallback = direction === 'forwards' ? (0, $1CaUw.getFirstFocusable)({
                    container: element
                }) : (0, $5Hn4C.getLastFocusable)({
                    container: element
                });
                fallback?.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}

});
parcelRegister("1CaUw", function(module, exports) {
$parcel$export(module.exports, "getFirstFocusable", () => $37c529501327eaf4$export$748138f04a69bf21);

var $lAwsu = parcelRequire("lAwsu");
function $37c529501327eaf4$export$748138f04a69bf21({ container: container, filter: filter }) {
    const items = (0, $lAwsu.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}

});
parcelRegister("lAwsu", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $aec201ae6ec447e6$export$f6768025e418420e);

var $dzjNA = parcelRequire("dzjNA");
const $aec201ae6ec447e6$var$focusableExclusions = [
    '[tabindex="-1"]',
    ':disabled',
    '[aria-disabled="true"]',
    '[aria-hidden="true"]'
];
const $aec201ae6ec447e6$var$exclusionSelector = $aec201ae6ec447e6$var$focusableExclusions.map((selector)=>`:not(${selector})`).join('');
const $aec201ae6ec447e6$var$focusableSelector = [
    'a[href]',
    'area[href]',
    'input:not([type="hidden"])',
    'select',
    'textarea',
    'button',
    'iframe',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])',
    '[tabindex]'
].map((selector)=>`${selector}${$aec201ae6ec447e6$var$exclusionSelector}`).join(',');
function $aec201ae6ec447e6$var$isVisible({ element: element }) {
    // Visibility filtering must not break focus navigation when the API is unsupported.
    if (typeof element.checkVisibility !== 'function') return true;
    try {
        // Exclude elements hidden by display, content-visibility or visibility because
        // they cannot receive focus. Offscreen, occluded and opacity-zero elements can
        // receive focus, so they intentionally remain included.
        return element.checkVisibility({
            checkVisibilityCSS: true
        });
    } catch  {
        return true;
    }
}
function $aec201ae6ec447e6$export$f6768025e418420e({ container: container, filter: filter }) {
    const containerLayer = (0, $dzjNA.getClosestLayer)({
        element: container
    });
    return Array.from(container.querySelectorAll($aec201ae6ec447e6$var$focusableSelector)).filter((element)=>{
        if (!(element instanceof HTMLElement)) return false;
        if ((0, $dzjNA.getClosestLayer)({
            element: element
        }) !== containerLayer) return false;
        if (element.closest('[inert]')) return false;
        if (!$aec201ae6ec447e6$var$isVisible({
            element: element
        })) return false;
        return !filter || filter(element, container);
    });
}

});
parcelRegister("dzjNA", function(module, exports) {
$parcel$export(module.exports, "getClosestLayer", () => $77b0b64cb109ebb6$export$3c9385904be131db);
/**
 * Returns the closest `[popover]` or `<dialog>` element, starting at `element`
 * itself. Returns `null` when the element is not in a layer.
 */ function $77b0b64cb109ebb6$export$3c9385904be131db({ element: element }) {
    return element.closest('[popover], dialog');
}

});



parcelRegister("5Hn4C", function(module, exports) {
$parcel$export(module.exports, "getLastFocusable", () => $541c55b0749826ce$export$73e81fa65335a75b);

var $lAwsu = parcelRequire("lAwsu");
function $541c55b0749826ce$export$73e81fa65335a75b({ container: container, filter: filter }) {
    const items = (0, $lAwsu.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}

});

parcelRegister("6rqEn", function(module, exports) {
$parcel$export(module.exports, "getNextFocusable", () => $eb45c20aea976e50$export$a7db88e6d491b450);

var $lAwsu = parcelRequire("lAwsu");
function $eb45c20aea976e50$export$a7db88e6d491b450({ container: container, direction: direction, filter: filter }) {
    const focusables = (0, $lAwsu.getFocusables)({
        container: container,
        filter: filter
    });
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    // `container` has no focusable elements.
    if (!first || !last) return null;
    const focusedElement = container.ownerDocument.activeElement;
    if (!(focusedElement instanceof HTMLElement) || !container.contains(focusedElement)) return null;
    const focusedIndex = focusables.indexOf(focusedElement);
    // The focused element is not in `focusables` when it is not tabbable, or
    // when `filter` excludes it. Find the first focusable element after it in
    // the DOM. That element, and the one before it in `focusables`, are the
    // closest focusable elements in each direction.
    if (focusedIndex === -1) {
        const followingIndex = focusables.findIndex((element)=>Boolean(focusedElement.compareDocumentPosition(element) & focusedElement.DOCUMENT_POSITION_FOLLOWING));
        if (direction === 'forwards') // If nothing follows the focused element, wrap to the start.
        return focusables[followingIndex] ?? first;
        // Use `last` when there is no entry before the following element. Either
        // nothing precedes the focused element (wrap to the end), or nothing
        // follows it (`last` is the closest preceding element).
        return focusables[followingIndex - 1] ?? last;
    }
    // The focused element is in `focusables`, so use the adjacent entry. Wrap
    // when the focused element is at either end.
    if (direction === 'forwards') return focusables[focusedIndex + 1] ?? first;
    return focusables[focusedIndex - 1] ?? last;
}

});

parcelRegister("4UmzM", function(module, exports) {
$parcel$export(module.exports, "isNestedLayerFocused", () => $5deb16e9987a17cb$export$b9590fdfeb5f722f);

var $dzjNA = parcelRequire("dzjNA");
function $5deb16e9987a17cb$export$b9590fdfeb5f722f({ container: container }) {
    const focusedElement = container.ownerDocument.activeElement;
    if (!(focusedElement instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focusedElement)) return false;
    // If not in the same layer, must be in a nested layer
    return (0, $dzjNA.getClosestLayer)({
        element: focusedElement
    }) !== (0, $dzjNA.getClosestLayer)({
        element: container
    });
}

});


parcelRegister("ilEG4", function(module, exports) {
$parcel$export(module.exports, "useInitialFocus", () => $ecf1828dad6b4d94$export$e992c40175757a22);

var $1v5pe = parcelRequire("1v5pe");

var $3q5kf = parcelRequire("3q5kf");

var $hNzf1 = parcelRequire("hNzf1");
function $ecf1828dad6b4d94$export$e992c40175757a22({ elementRef: elementRef, isEnabled: isEnabled, initialFocusRef: initialFocusRef, phase: phase, role: role }) {
    const prevPhaseRef = (0, $1v5pe.useRef)('closed');
    (0, $3q5kf.useLayoutEffect)(()=>{
        const prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        if (!isEnabled || phase === 'closed' || prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        const element = elementRef.current;
        if (element) (0, $hNzf1.applyInitialFocus)({
            container: element,
            initialFocusRef: initialFocusRef,
            role: role
        });
    }, [
        elementRef,
        initialFocusRef,
        isEnabled,
        phase,
        role
    ]);
}

});
parcelRegister("hNzf1", function(module, exports) {
$parcel$export(module.exports, "applyInitialFocus", () => $23b158310a6900e4$export$d1972957354b5ad6);

var $7GgPE = parcelRequire("7GgPE");
function $23b158310a6900e4$export$d1972957354b5ad6({ container: container, initialFocusRef: initialFocusRef, role: role }) {
    const target = (0, $7GgPE.getInitialFocusTarget)({
        container: container,
        initialFocusRef: initialFocusRef,
        role: role
    });
    if (!target) return {
        applied: false,
        target: null
    };
    target.focus();
    return {
        applied: true,
        target: target
    };
}

});
parcelRegister("7GgPE", function(module, exports) {
$parcel$export(module.exports, "getInitialFocusTarget", () => $84c201ca3aab976a$export$2e85eb60457252d6);

var $1CaUw = parcelRequire("1CaUw");
/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox. This applies to `menu`, `listbox`, and to
 * `dialog` / `alertdialog` when the combobox is outside the dialog. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, menu, or dialog), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
const $84c201ca3aab976a$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $84c201ca3aab976a$var$isTextboxLikeElement(element) {
    const role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    const tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        const type = (element.getAttribute('type') ?? 'text').toLowerCase();
        return $84c201ca3aab976a$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $84c201ca3aab976a$var$isComboboxControllingPopup({ container: container }) {
    const ownerDocument = container.ownerDocument;
    const active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$84c201ca3aab976a$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    const idRefs = active.getAttribute('aria-controls') ?? active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    const referencedIds = idRefs.split(/\s+/).filter((id)=>id !== '');
    return referencedIds.some((id)=>{
        const referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
/**
 * The `initialFocusRef` override target, when it is inside the popover. A
 * target outside the popover (or not in the DOM) is ignored, so the role
 * default applies.
 */ function $84c201ca3aab976a$var$getOverrideTarget({ container: container, initialFocusRef: initialFocusRef }) {
    const target = initialFocusRef?.current;
    if (target && container.contains(target)) return target;
    return null;
}
function $84c201ca3aab976a$export$2e85eb60457252d6({ container: container, initialFocusRef: initialFocusRef, role: role }) {
    // In each role branch, the combobox carve-out decides whether focus moves.
    // The override target, then the role default, decides where.
    if (role === 'dialog' || role === 'alertdialog') {
        // APG allows a combobox to control a dialog popup. Focus stays on the
        // combobox only when it is OUTSIDE the dialog. A dialog that contains
        // its own combobox still takes focus (see the comment below on why the
        // carve-out is per-role).
        if (!container.contains(container.ownerDocument.activeElement) && $84c201ca3aab976a$var$isComboboxControllingPopup({
            container: container
        })) return null;
        const overrideTarget = $84c201ca3aab976a$var$getOverrideTarget({
            container: container,
            initialFocusRef: initialFocusRef
        });
        if (overrideTarget) return overrideTarget;
        // Prefer element with the native HTML autofocus attribute.
        const autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $1CaUw.getFirstFocusable)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific rather than hoisted.
    // Hoisting it over-matched on dialog popups that contain a nested
    // combobox (e.g. datetime-picker's dialog hosts a react-select), where
    // the active combobox's `aria-controls` falsely matched the container
    // and suppressed the dialog's own focus contract. The dialog branch
    // above therefore skips only for a combobox outside the dialog.
    if (role === 'menu') {
        if ($84c201ca3aab976a$var$isComboboxControllingPopup({
            container: container
        })) return null;
        const overrideTarget = $84c201ca3aab976a$var$getOverrideTarget({
            container: container,
            initialFocusRef: initialFocusRef
        });
        if (overrideTarget) return overrideTarget;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/decisions/menu-keyboard.md
        return (0, $1CaUw.getFirstFocusable)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($84c201ca3aab976a$var$isComboboxControllingPopup({
            container: container
        })) return null;
        const overrideTarget = $84c201ca3aab976a$var$getOverrideTarget({
            container: container,
            initialFocusRef: initialFocusRef
        });
        if (overrideTarget) return overrideTarget;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        const selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        const firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $1CaUw.getFirstFocusable)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
} /**
 * Moves focus into a popover element when it opens, based on its ARIA role.
 *
 * Follows the WAI-ARIA APG initial-focus patterns for each role. For the
 * roles that move focus, an `initialFocusRef` target inside the popover
 * comes first:
 * - `dialog` / `alertdialog` → focus first focusable (or `[autofocus]`)
 * - `menu` → focus first menu item
 * - `listbox` → focus selected or first option
 * - `tooltip` / no role → no focus movement (focus must remain on trigger;
 *   moving focus into the tooltip would dismiss it)
 *
 * Role is taken from the typed `role` prop - this is the consumer's contract
 * and is not subject to drift from a directly-mutated DOM attribute.
 *
 * Always call this hook unconditionally. Focus is moved on each transition
 * into a visible phase, the moment the host element first becomes visible
 * for that open intent:
 *
 * - Animated path: on `closed → entering`. The host has just been mounted
 *   and the layout effect that calls `showPopover()` / `showModal()` has
 *   already run, so the element is in the top layer. We focus before the
 *   entry transition settles to match the WAI-ARIA APG expectation that
 *   focus lands on the new menu / dialog the instant it opens, not after
 *   the CSS finishes animating.
 * - Non-animated path: on `closed → open` (the entering phase is skipped).
 * - Reopen mid-exit: on `exiting → entering`. When a user dismisses the
 *   popup (Escape, close button, light dismiss) the browser natively
 *   restores focus to the trigger as part of `hidePopover()` /
 *   `<dialog>.close()`. If the consumer reopens before the exit transition
 *   has settled, the phase machine jumps `exiting → entering` without
 *   passing through `closed`, so without this branch the popup would be
 *   visible again with focus stranded on the trigger - a keyboard usability
 *   gap for menu/dialog/listbox roles.
 *
 * Note: there is a rare programmatic path where a consumer flips `isOpen`
 * false → true without any user-initiated close gesture and had moved focus
 * to a non-default target inside the popup. In that scenario this hook
 * re-focuses the role-appropriate default (e.g. first menu item) rather
 * than preserving the consumer-chosen target. This matches the documented
 * `closed → entering` behavior and is considered acceptable given how
 * abstract the scenario is. See `notes/architecture/focus.md`.
 *
 * Pure `entering → exiting → entering` stutters where the popup never
 * reaches `closed` and the consumer toggles in the same frame are still
 * collapsed: the `prevPhase` ref guard rejects any transition whose
 * previous phase was not `closed` or `exiting`.
 *
 * Runs in a layout effect, so focus lands in the same task as the open,
 * before the browser paints. Call it AFTER the layout effect that calls
 * `showPopover()`: React runs a component's layout effects in source order,
 * and a hidden popover cannot take focus.
 *
 * An `initialFocusRef` target must be set by then: in a ref callback, a
 * child's layout effect, or during render. A child's `useEffect` runs later
 * and its target is missed.
 *
 * If a regression appears that needs a paint before focusing (e.g. browsers
 * that require a layout pass before `focus()` works on a freshly promoted
 * top-layer element), wrap the `focus()` call in a single
 * `requestAnimationFrame` here and re-add a same-element ref check inside
 * the RAF callback.
 */ 

});




parcelRegister("4RAor", function(module, exports) {
$parcel$export(module.exports, "useAnchoredPopover", () => $cdb2865ddcae7224$export$147d8888d96bf7a3);
/**
 * Positioning AND anchor-relative sizing for top-layer popovers. Anchors an
 * ELEMENT; to anchor a viewport coordinate, use `useAnchoredPopoverAtPoint`.
 *
 * There are two runtime paths. Each is a function that applies its styles and
 * returns the cleanup: CSS Anchor Positioning in `./anchor-positioning`, and the
 * JavaScript fallback in `./javascript-fallback`. The hook picks the path ONCE,
 * at the top of the effect, and passes it to positioning, sizing and margins.
 *
 * See `notes/architecture/positioning.md` and
 * `notes/decisions/fit-available-space.md`.
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $lHxwq = parcelRequire("lHxwq");

var $3q5kf = parcelRequire("3q5kf");

var $kuKVz = parcelRequire("kuKVz");

var $9JXzA = parcelRequire("9JXzA");

var $aJaUn = parcelRequire("aJaUn");

var $w8uxN = parcelRequire("w8uxN");

var $3snav = parcelRequire("3snav");

var $hnsvW = parcelRequire("hnsvW");
/**
 * Which way the popover's inline axis runs. Maps every physical measurement below
 * onto a logical axis: the viewport unit of each cap and the anchor's measured
 * size. A style read, not a layout read, so it is cheap enough to do for every
 * popover.
 */ function $cdb2865ddcae7224$var$getPopoverWritingMode({ popover: popover }) {
    // `String()` because not every test environment implements `writing-mode`.
    const writingMode = String(getComputedStyle(popover).writingMode);
    const isVertical = writingMode.startsWith('vertical') || writingMode.startsWith('sideways');
    return isVertical ? 'vertical' : 'horizontal';
}
/**
 * Measured stand-in for `anchor-size(self-*)`, used wherever `anchor-size()` is
 * not: the JavaScript fallback, and browsers with anchor positioning but no
 * `anchor-size()`.
 *
 * `offsetWidth` / `offsetHeight` are physical, so the axis is picked from the
 * POPOVER's `writing-mode`. Deliberately not memoized: a cached anchor size is a
 * stale one. Runs once per effect, not per frame.
 */ function $cdb2865ddcae7224$var$measureAnchorSize({ anchor: anchor, writingMode: writingMode }) {
    if (writingMode === 'vertical') return {
        inline: `${anchor.offsetHeight}px`,
        block: `${anchor.offsetWidth}px`
    };
    return {
        inline: `${anchor.offsetWidth}px`,
        block: `${anchor.offsetHeight}px`
    };
}
const $cdb2865ddcae7224$var$NO_ANCHOR_SIZE = {
    inline: null,
    block: null
};
const $cdb2865ddcae7224$var$CSS_ANCHOR_SIZE = {
    inline: 'anchor-size(self-inline)',
    block: 'anchor-size(self-block)'
};
/**
 * The anchor size that the size declarations use:
 *
 * - `NO_ANCHOR_SIZE` when no size rule reads the anchor size.
 * - `CSS_ANCHOR_SIZE` (`anchor-size()` references) when the browser supports them.
 * - Otherwise, the anchor size measured in pixels.
 */ function $cdb2865ddcae7224$var$getAnchorSize({ anchor: anchor, writingMode: writingMode, needsAnchorSize: needsAnchorSize, canUseAnchorSize: canUseAnchorSize }) {
    if (!needsAnchorSize) return $cdb2865ddcae7224$var$NO_ANCHOR_SIZE;
    if (canUseAnchorSize) return $cdb2865ddcae7224$var$CSS_ANCHOR_SIZE;
    return $cdb2865ddcae7224$var$measureAnchorSize({
        anchor: anchor,
        writingMode: writingMode
    });
}
function $cdb2865ddcae7224$var$isAnchorRelative({ size: size }) {
    return size === 'match-anchor' || size === 'min-anchor';
}
/**
 * The `anchor-name` written to an anchor that does not already carry one, as a
 * CSS `<dashed-ident>`. `useId()` is the same source as every other id in the
 * design system, including the popover's own `id` that `aria-controls` and
 * `popovertarget` point at. So it is unique exactly where those are, and collides
 * exactly where they do. See `useAnchoredPopover` for the one case that needs the
 * host's help.
 *
 * `@atlaskit/ds-lib`'s `useId` already swaps React's `:` and `«»` for `_`. The
 * replace covers a host `identifierPrefix`, which may carry characters a
 * `<dashed-ident>` cannot.
 */ function $cdb2865ddcae7224$var$useNewAnchorName() {
    const id = (0, $lHxwq.useId)();
    return (0, $1v5pe.useMemo)(()=>`--anchor-${id.replace(/[^A-Za-z0-9_-]/g, '_')}`, [
        id
    ]);
}
/**
 * A referentially stable, fully resolved `TPlacement`, so a new inline
 * `placement` object on each render does not re-run the effect.
 */ function $cdb2865ddcae7224$var$useStablePlacement({ placement: placement }) {
    const resolved = (0, $w8uxN.resolvePlacement)({
        placement: placement
    });
    const axis = resolved.axis;
    const edge = resolved.edge;
    const align = resolved.align;
    const minSize = resolved.minSize;
    const gap = resolved.offset.gap;
    const shiftValue = resolved.offset.crossAxisShift.value;
    const shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuilt from primitive deps, so the factory does not close over `resolved`
    // and exhaustive-deps can verify it.
    return (0, $1v5pe.useMemo)(()=>({
            axis: axis,
            edge: edge,
            align: align,
            minSize: minSize,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        }), [
        axis,
        edge,
        align,
        minSize,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $cdb2865ddcae7224$export$147d8888d96bf7a3({ anchorRef: anchorRef, popoverRef: popoverRef, placement: placement, isOpen: isOpen, isEnabled: isEnabled = true, inlineSize: inlineSize = 'content', blockSize: blockSize = 'content', shouldPreserveInlineSize: shouldPreserveInlineSize = false, forceFallbackPositioning: forceFallbackPositioning = false }) {
    // Stable for the life of the hook instance, so it follows a replacement anchor
    // element (the point hook remounts its `<div>`).
    const fallbackAnchorName = $cdb2865ddcae7224$var$useNewAnchorName();
    const stablePlacement = $cdb2865ddcae7224$var$useStablePlacement({
        placement: placement
    });
    (0, $3q5kf.useLayoutEffect)(()=>{
        if (!isEnabled) return;
        // Resolved once, so positioning, sizing and margins cannot disagree about it.
        const isUsingCssAnchorPositioning = (0, $3snav.supportsAnchorPositioning)() && !forceFallbackPositioning;
        // BOTH probes: a browser can have positioning without sizing, and
        // `anchor-size()` needs the `position-anchor` only the CSS path writes.
        const canUseAnchorSize = isUsingCssAnchorPositioning && (0, $hnsvW.supportsAnchorSize)();
        const anchor = anchorRef.current;
        const popover = popoverRef.current;
        if (!anchor || !popover) return;
        // Fitting also reserves padding from the viewport edge as a margin.
        const isFitting = inlineSize === 'max-available' || blockSize === 'max-available';
        // Always read: the viewport caps are always written, and their unit follows
        // the popover's writing mode.
        const writingMode = $cdb2865ddcae7224$var$getPopoverWritingMode({
            popover: popover
        });
        // Skipped where possible, so a position-only consumer pays no layout read.
        // Fitting on the CSS path needs it to clamp the default flip floor; see
        // `getDefaultPlacementAxisFloor`.
        const needsAnchorSize = $cdb2865ddcae7224$var$isAnchorRelative({
            size: inlineSize
        }) || $cdb2865ddcae7224$var$isAnchorRelative({
            size: blockSize
        }) || isFitting && isUsingCssAnchorPositioning;
        const anchorSize = $cdb2865ddcae7224$var$getAnchorSize({
            anchor: anchor,
            writingMode: writingMode,
            needsAnchorSize: needsAnchorSize,
            canUseAnchorSize: canUseAnchorSize
        });
        const sizeStyles = (0, $9JXzA.getAnchoredPopoverSizeDeclarations)({
            placement: stablePlacement,
            inlineSize: inlineSize,
            blockSize: blockSize,
            isUsingCssAnchorPositioning: isUsingCssAnchorPositioning,
            anchorSize: anchorSize,
            writingMode: writingMode,
            shouldPreserveInlineSize: shouldPreserveInlineSize
        });
        if (isUsingCssAnchorPositioning) return (0, $kuKVz.applyAnchorPositioning)({
            anchor: anchor,
            popover: popover,
            placement: stablePlacement,
            sizeStyles: sizeStyles,
            isFitting: isFitting,
            fallbackAnchorName: fallbackAnchorName
        });
        return (0, $aJaUn.applyJavaScriptFallbackPositioning)({
            anchor: anchor,
            popover: popover,
            placement: stablePlacement,
            sizeStyles: sizeStyles
        });
    }, [
        isEnabled,
        anchorRef,
        popoverRef,
        stablePlacement,
        inlineSize,
        blockSize,
        shouldPreserveInlineSize,
        fallbackAnchorName,
        forceFallbackPositioning,
        isOpen
    ]);
}

});
parcelRegister("lHxwq", function(module, exports) {
$parcel$export(module.exports, "useId", () => $6d21fbfc50cc74e8$export$f680877a34711e37);

var $1v5pe = parcelRequire("1v5pe");
function $6d21fbfc50cc74e8$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).useId().replace(/[:«»]/g, '_');
}

});

parcelRegister("kuKVz", function(module, exports) {
$parcel$export(module.exports, "applyAnchorPositioning", () => $2194242f11c258a3$export$50da8074e1408934);
/**
 * The CSS Anchor Positioning path: `position-anchor`, `position-area`,
 * `position-try-fallbacks` and the gap and shift margins, all declared on the
 * popover so the browser owns placement and flipping. The twin of
 * `../javascript-fallback/apply-javascript-fallback-positioning`.
 */ 
var $dKqTB = parcelRequire("dKqTB");

var $jFIDv = parcelRequire("jFIDv");

var $6Uvey = parcelRequire("6Uvey");

var $cCaNb = parcelRequire("cCaNb");

var $cQzhI = parcelRequire("cQzhI");

var $GsDz5 = parcelRequire("GsDz5");

var $9E1Zw = parcelRequire("9E1Zw");
function $2194242f11c258a3$export$50da8074e1408934({ anchor: anchor, popover: popover, placement: placement, sizeStyles: sizeStyles, isFitting: isFitting, fallbackAnchorName: fallbackAnchorName }) {
    // Reuse the existing name rather than write a new one: another popover may already be anchored to it, or a
    // CONSUMER may have set it on their own element, as `post-office` does.
    const existingAnchorName = (0, $cQzhI.getExistingAnchorName)({
        element: anchor
    });
    const anchorName = existingAnchorName ?? fallbackAnchorName;
    const gapMargin = (0, $6Uvey.edgeMargin)({
        placement: placement,
        offset: placement.offset.gap
    });
    const shiftMargins = (0, $jFIDv.crossAxisShiftMargins)({
        placement: placement,
        crossAxisShiftCssValue: placement.offset.crossAxisShift.value,
        direction: placement.offset.crossAxisShift.direction
    });
    const popoverStyles = [
        {
            property: 'position-anchor',
            value: anchorName
        },
        {
            property: 'position-area',
            value: (0, $GsDz5.placementToPositionArea)({
                placement: placement
            })
        },
        {
            property: 'position-try-fallbacks',
            value: (0, $9E1Zw.placementToTryFallbacks)({
                placement: placement
            })
        },
        /**
   * **`position-visibility: always`**
   *
   * The initial value, `anchors-visible`, lets the browser hide the popover
   * when its anchor is fully clipped by an ancestor (for example a scroll
   * container) or is `visibility: hidden`. This hiding does not close the
   * popover: `:popover-open` still matches, but the popover is not painted and
   * gets no pointer input. Chrome also keeps it focusable and in the
   * accessibility tree, so keyboard and screen reader users can land inside a
   * surface they cannot see.
   *
   * The default is usually fine. It fails when:
   *  - The anchor is hidden on purpose (for example `position: absolute` moves
   *    it outside its parent's clip, or it is `visibility: hidden`).
   *  - The anchor scrolls out of its scroll container while the popover is
   *    open.
   *
   * `always` turns the automatic hiding off. There is no strong reason to keep
   * the default. If one comes up, this could become configurable. Per-engine
   * behaviour: `notes/decisions/position-visibility-always.md`.
   */ {
            property: 'position-visibility',
            value: 'always'
        },
        // Reset the UA popover styles (`inset: 0; margin: auto`), which conflict
        // with anchor positioning.
        {
            property: 'margin',
            value: '0'
        },
        {
            property: 'inset',
            value: 'auto'
        },
        gapMargin,
        // When fitting, the shift margins come back COMPOSED with the reserved
        // viewport padding, rather than being written twice.
        ...isFitting ? (0, $cCaNb.getFitMarginDeclarations)({
            placement: placement,
            crossAxisShiftMargins: shiftMargins
        }) : shiftMargins,
        ...sizeStyles
    ];
    // Anchor names are never removed: several popovers can share an anchor, and
    // even with reference counting an async React update could remove the name
    // while something else still uses it. See
    // `notes/decisions/anchor-name-lifetime.md`. Only a new name is written: a
    // name from a stylesheet may be a list, which an inline copy of its first entry
    // would collapse.
    if (existingAnchorName === null) anchor.style.setProperty('anchor-name', anchorName);
    return (0, $dKqTB.setStyle)({
        element: popover,
        styles: popoverStyles
    });
}

});
parcelRegister("dKqTB", function(module, exports) {
$parcel$export(module.exports, "setStyle", () => $a23d91c132b59eec$export$37a5fde709c1db82);
/**
 * A single inline style declaration.
 *
 * `TProperty` narrows the property name for callers that write a known, closed
 * set of properties. Narrowing it lets a record keyed on those same names be
 * checked for exhaustiveness at compile time, rather than silently resolving to
 * `undefined` for a name that was never mapped.
 */ function $a23d91c132b59eec$export$37a5fde709c1db82({ element: element, styles: styles }) {
    // Snapshot the prior INLINE value, not the computed style: cleanup restores
    // only what the consumer or an earlier run wrote inline. An empty string means
    // there was no inline value, so cleanup removes the property.
    const priorValues = styles.map(({ property: property })=>({
            property: property,
            value: element.style.getPropertyValue(property)
        }));
    styles.forEach(({ property: property, value: value })=>{
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(({ property: property, value: value })=>{
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});

parcelRegister("jFIDv", function(module, exports) {
$parcel$export(module.exports, "crossAxisShiftMargins", () => $6512809a7951581e$export$f7505ccec0897ae3);
function $6512809a7951581e$export$f7505ccec0897ae3({ placement: placement, crossAxisShiftCssValue: crossAxisShiftCssValue, direction: direction }) {
    const crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    // `calc()` rather than JavaScript math, so opaque values such as design tokens
    // negate correctly.
    const negatedValue = `calc(-1 * ${crossAxisShiftCssValue})`;
    const isForwards = direction === 'forwards';
    return [
        {
            property: `margin-${crossAxis}-start`,
            value: isForwards ? crossAxisShiftCssValue : negatedValue
        },
        {
            property: `margin-${crossAxis}-end`,
            value: isForwards ? negatedValue : crossAxisShiftCssValue
        }
    ];
}

});

parcelRegister("6Uvey", function(module, exports) {
$parcel$export(module.exports, "edgeMargin", () => $595fee265c1dc290$export$b94d052c6b40496);
function $595fee265c1dc290$export$b94d052c6b40496({ placement: placement, offset: offset }) {
    const { axis: axis, edge: edge } = placement;
    // The side FACING the anchor is always opposite the placement edge.
    const anchorFacingEdge = edge === 'end' ? 'start' : 'end';
    return {
        property: `margin-${axis}-${anchorFacingEdge}`,
        value: offset
    };
}

});

parcelRegister("cCaNb", function(module, exports) {
$parcel$export(module.exports, "getFitMarginDeclarations", () => $3e64bacfc9a4a19a$export$a7ffde4a856e8d8e);

var $9JXzA = parcelRequire("9JXzA");
/**
 * The cross-axis sides that face the viewport rather than the anchor, and so take
 * the reserved padding.
 *
 * A `span-*` cell aligns the popover's MARGIN box to the anchor's edge, so padding
 * on the anchor-facing side does not reserve space at the viewport: it insets the
 * border box from the edge the consumer asked it to line up with. A centred
 * popover has no anchor-facing side, and padding both keeps the shift pair
 * antisymmetric so `anchor-center` still centres.
 *
 * Known cost: the slide fallbacks do not swap the inline margins the way
 * `flip-inline` does, so a slid popover keeps its padding on the anchor side (or,
 * re-centred, sits 2.5px off centre). Alignment in the requested position wins.
 */ function $3e64bacfc9a4a19a$var$viewportFacingCrossAxisSides({ align: align }) {
    if (align === 'center') return [
        'start',
        'end'
    ];
    // `align: 'start'` sits on the anchor's start edge and expands toward end.
    return [
        align === 'start' ? 'end' : 'start'
    ];
}
function $3e64bacfc9a4a19a$export$a7ffde4a856e8d8e({ placement: placement, crossAxisShiftMargins: crossAxisShiftMargins }) {
    const crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    const paddedProperties = new Set($3e64bacfc9a4a19a$var$viewportFacingCrossAxisSides({
        align: placement.align
    }).map((side)=>`margin-${crossAxis}-${side}`));
    return [
        {
            property: `margin-${placement.axis}-${placement.edge}`,
            value: (0, $9JXzA.VIEWPORT_PADDING)
        },
        ...crossAxisShiftMargins.map(({ property: property, value: value })=>paddedProperties.has(property) ? {
                property: property,
                value: `calc(${value} + ${0, $9JXzA.VIEWPORT_PADDING})`
            } : {
                property: property,
                value: value
            })
    ];
}

});
parcelRegister("9JXzA", function(module, exports) {
$parcel$export(module.exports, "VIEWPORT_PADDING", () => $f35d25d3ed42fdf6$export$9f2fdbacbc62226e);
$parcel$export(module.exports, "getAnchoredPopoverSizeDeclarations", () => $f35d25d3ed42fdf6$export$860b30329fa0b990);
const $f35d25d3ed42fdf6$export$9f2fdbacbc62226e = '5px';
const $f35d25d3ed42fdf6$export$32ab78b2bb853a01 = '150px';
/**
 * The dynamic viewport unit for one of the popover's axes. Not `dvi` / `dvb`:
 * css-values-4 defines those against the ROOT element's writing mode, while the
 * `max-{axis}-size` they are written to follows the popover's, so a popover in a
 * `vertical-rl` subtree of a horizontal document would be capped by the wrong
 * dimension.
 */ function $f35d25d3ed42fdf6$var$viewportUnit({ axis: axis, writingMode: writingMode }) {
    // The inline axis is horizontal in a horizontal writing mode. The block axis is
    // horizontal in a vertical one.
    const isHorizontalAxis = axis === 'inline' === (writingMode === 'horizontal');
    return isHorizontalAxis ? 'dvw' : 'dvh';
}
function $f35d25d3ed42fdf6$var$getCrossAxis({ axis: axis }) {
    return axis === 'block' ? 'inline' : 'block';
}
/**
 * The whole viewport, less the reserved padding on both sides. Rule 3's backstop.
 */ function $f35d25d3ed42fdf6$var$viewportCap({ axis: axis, writingMode: writingMode }) {
    return `calc(100${$f35d25d3ed42fdf6$var$viewportUnit({
        axis: axis,
        writingMode: writingMode
    })} - 2 * ${$f35d25d3ed42fdf6$export$9f2fdbacbc62226e})`;
}
/**
 * The position-area cell cap, for the placement axis only. The host carries
 * `position-area`, so per css-anchor-position-1 the cell is its containing block:
 * `100%` is the anchor edge to the viewport edge, and it follows whichever side
 * `position-try-fallbacks` settles on. Percentages do not subtract margins, so
 * the gap is subtracted here.
 *
 * Meaningless on the JavaScript fallback, whose containing block is the viewport,
 * so that path gets `viewportCap` on both axes.
 */ function $f35d25d3ed42fdf6$var$cellCap({ gap: gap }) {
    return `calc(100% - ${$f35d25d3ed42fdf6$export$9f2fdbacbc62226e} - ${gap})`;
}
/**
 * The anchor term of the placement-axis floor, or `null` for none. It is the only
 * part of the floor that is ever clamped to a cap.
 *
 * `'min-anchor'` always gets an anchor floor. `'match-anchor'` gets one only where
 * it can flip: its definite size alone gives way to the cap, so the popover would
 * shrink below the anchor instead of flipping.
 *
 * It is clamped only where it cannot flip, on purpose:
 *
 * - With no flip, an unclamped floor beats `max-{axis}-size` (CSS applies the
 *   `min` last), so the viewport backstop would do nothing.
 * - With a flip, a clamp would stop the floor exceeding the cell cap, and that
 *   overflow is what drives the flip.
 */ function $f35d25d3ed42fdf6$var$getPlacementAxisAnchorFloor({ placementAxis: placementAxis, placementAxisSize: placementAxisSize, anchorValue: anchorValue, canFlip: canFlip, writingMode: writingMode }) {
    const hasAnchorFloor = placementAxisSize === 'min-anchor' || placementAxisSize === 'match-anchor' && canFlip;
    if (!hasAnchorFloor || anchorValue === null) return null;
    if (canFlip) return anchorValue;
    return `min(${anchorValue}, ${$f35d25d3ed42fdf6$var$viewportCap({
        axis: placementAxis,
        writingMode: writingMode
    })})`;
}
/**
 * The default flip floor, clamped so that SOME cell can always hold it.
 *
 * The two cells on either side of the anchor add up to the viewport less the
 * anchor, so the roomier one is at least half of that. A floor whose margin box
 * fits inside that half is guaranteed a cell somewhere in the fallback chain.
 * Unclamped, a short viewport with a centred anchor has NO cell that holds
 * 150px: every try-fallback overflows, the browser reverts to the base position,
 * and the floor pushes the popover past the viewport edge.
 *
 * This is NOT the `min(floor, cellCap)` that suppresses flipping: it is relative
 * to the VIEWPORT, so a small base cell still overflows it. `max(0px, …)` stops
 * the floor going negative, for example for an anchor larger than the viewport.
 */ function $f35d25d3ed42fdf6$var$getDefaultPlacementAxisFloor({ placementAxis: placementAxis, anchorValue: anchorValue, gap: gap, writingMode: writingMode }) {
    if (anchorValue === null) return $f35d25d3ed42fdf6$export$32ab78b2bb853a01;
    // The viewport term and the anchor term must measure the SAME axis; see
    // `viewportUnit`.
    const viewport = `100${$f35d25d3ed42fdf6$var$viewportUnit({
        axis: placementAxis,
        writingMode: writingMode
    })}`;
    const halfOfRemainingViewport = `calc((${viewport} - ${anchorValue}) / 2 - ${gap} - ${$f35d25d3ed42fdf6$export$9f2fdbacbc62226e})`;
    return `min(${$f35d25d3ed42fdf6$export$32ab78b2bb853a01}, max(0px, ${halfOfRemainingViewport}))`;
}
/**
 * The placement-axis floor, or `null` for none. Explicit minimums COMPOSE, the
 * default does not:
 *
 * - `placement.minSize` and the anchor term are both explicit requests, so they
 *   compose as `max()`. As intended, `minSize: 0` does not remove an anchor
 *   floor, because `max(0px, anchor)` IS the anchor.
 * - The default floor applies only when neither is set and the popover can flip.
 *   It never composes: in a `max()` it would only win by overriding a size the
 *   consumer asked for, and the anchor term drives the flip on its own.
 */ function $f35d25d3ed42fdf6$var$getPlacementAxisFloor({ minSize: minSize, placementAxis: placementAxis, placementAxisSize: placementAxisSize, anchorValue: anchorValue, gap: gap, canFlip: canFlip, writingMode: writingMode }) {
    const anchorFloor = $f35d25d3ed42fdf6$var$getPlacementAxisAnchorFloor({
        placementAxis: placementAxis,
        placementAxisSize: placementAxisSize,
        anchorValue: anchorValue,
        canFlip: canFlip,
        writingMode: writingMode
    });
    if (minSize !== undefined) return anchorFloor === null ? minSize : `max(${minSize}, ${anchorFloor})`;
    if (anchorFloor !== null) return anchorFloor;
    if (!canFlip) return null;
    return $f35d25d3ed42fdf6$var$getDefaultPlacementAxisFloor({
        placementAxis: placementAxis,
        anchorValue: anchorValue,
        gap: gap,
        writingMode: writingMode
    });
}
function $f35d25d3ed42fdf6$export$860b30329fa0b990({ placement: placement, inlineSize: inlineSize, blockSize: blockSize, isUsingCssAnchorPositioning: isUsingCssAnchorPositioning, anchorSize: anchorSize, writingMode: writingMode, shouldPreserveInlineSize: shouldPreserveInlineSize = false }) {
    const placementAxis = placement.axis;
    const crossAxis = $f35d25d3ed42fdf6$var$getCrossAxis({
        axis: placementAxis
    });
    // Rule 1. In effect this feeds only the placement-axis cap: every other check
    // below treats `'content'` and `'max-available'` the same.
    const size = {
        inline: inlineSize === 'content' && blockSize === 'max-available' ? 'max-available' : inlineSize,
        block: blockSize === 'content' && inlineSize === 'max-available' ? 'max-available' : blockSize
    };
    // Rule 2 reads the requested values, not `size`: flipping is a whole-popover
    // outcome, so a fit request on either axis turns the floor on.
    const isFitting = inlineSize === 'max-available' || blockSize === 'max-available';
    // The floor drives the flip only on the CSS path. On the JavaScript fallback a
    // floor only inflates the measured size that the side is picked from, so it
    // would flip a popover that fits.
    const canFlip = isFitting && isUsingCssAnchorPositioning;
    const declarations = [
        // Rule 3: both caps are always written. Only the placement axis can take the
        // cell cap.
        {
            property: `max-${placementAxis}-size`,
            value: size[placementAxis] === 'max-available' && isUsingCssAnchorPositioning ? $f35d25d3ed42fdf6$var$cellCap({
                gap: placement.offset.gap
            }) : $f35d25d3ed42fdf6$var$viewportCap({
                axis: placementAxis,
                writingMode: writingMode
            })
        },
        {
            property: `max-${crossAxis}-size`,
            value: $f35d25d3ed42fdf6$var$viewportCap({
                axis: crossAxis,
                writingMode: writingMode
            })
        }
    ];
    // Rule 4. Only for a non-anchor-relative inline axis, so `'match-anchor'` below
    // stays the one writer of `inline-size` when it applies. CSS path only: the
    // fallback's containing block is the viewport, where shrink-to-fit already IS
    // the natural width for anything that fits on screen.
    if (isUsingCssAnchorPositioning && !shouldPreserveInlineSize && (size.inline === 'content' || size.inline === 'max-available')) declarations.push({
        property: 'inline-size',
        value: 'max-content'
    });
    // `'match-anchor'` is a definite size. A max beats a definite size, so the caps
    // above still win.
    [
        placementAxis,
        crossAxis
    ].forEach((axis)=>{
        const anchorValue = anchorSize[axis];
        if (size[axis] === 'match-anchor' && anchorValue !== null) declarations.push({
            property: `${axis}-size`,
            value: anchorValue
        });
    });
    const placementAxisFloor = $f35d25d3ed42fdf6$var$getPlacementAxisFloor({
        minSize: placement.minSize,
        placementAxis: placementAxis,
        placementAxisSize: size[placementAxis],
        anchorValue: anchorSize[placementAxis],
        gap: placement.offset.gap,
        canFlip: canFlip,
        writingMode: writingMode
    });
    if (placementAxisFloor !== null) declarations.push({
        property: `min-${placementAxis}-size`,
        value: placementAxisFloor
    });
    // `'min-anchor'` on the cross axis is a size contract, not a flip driver, so it
    // is clamped to the viewport cap.
    const crossAxisAnchorValue = anchorSize[crossAxis];
    if (size[crossAxis] === 'min-anchor' && crossAxisAnchorValue !== null) declarations.push({
        property: `min-${crossAxis}-size`,
        value: `min(${crossAxisAnchorValue}, ${$f35d25d3ed42fdf6$var$viewportCap({
            axis: crossAxis,
            writingMode: writingMode
        })})`
    });
    return declarations;
}

});


parcelRegister("cQzhI", function(module, exports) {
$parcel$export(module.exports, "getExistingAnchorName", () => $5ba55bc1f0675404$export$948d15b01d509455);
/**
 * The `anchor-name` an element already carries, or `null`. Reads the computed
 * value as well as the inline one, so a name set from a STYLESHEET is found: a
 * new inline name would otherwise override it for every other rule anchored
 * to that element. `anchor-name` is a list and `position-anchor` takes one ident,
 * so the first name is the one to anchor to.
 */ function $5ba55bc1f0675404$export$948d15b01d509455({ element: element }) {
    const anchorNames = element.style.getPropertyValue('anchor-name') || getComputedStyle(element).getPropertyValue('anchor-name');
    const firstAnchorName = anchorNames.split(',')[0].trim();
    return firstAnchorName !== '' && firstAnchorName !== 'none' ? firstAnchorName : null;
}

});

parcelRegister("GsDz5", function(module, exports) {
$parcel$export(module.exports, "placementToPositionArea", () => $5b904d50cf0d1ddc$export$de49b61f233ddeb9);
function $5b904d50cf0d1ddc$export$de49b61f233ddeb9({ placement: placement }) {
    const { axis: axis, edge: edge, align: align } = placement;
    const edgeArea = `${axis}-${edge}`;
    if (align === 'center') return edgeArea;
    const crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    const spanDirection = align === 'start' ? 'end' : 'start';
    return `${edgeArea} span-${crossAxis}-${spanDirection}`;
}

});

parcelRegister("9E1Zw", function(module, exports) {
$parcel$export(module.exports, "placementToTryFallbacks", () => $f5313f1dc717a44b$export$c4e16947a95d61f1);
/**
 * The try options that slide the popover along one edge, on the cross axis.
 *
 * A try option is only worth listing if its margin box can fit where an earlier
 * one did not. Two options over the SAME cell have the same margin box and the
 * same fit result. That rules out three cells for an aligned placement: the near
 * span on the requested edge IS the base `position-area`, and on the opposite
 * edge the near and far spans are where the placement-axis flip and the diagonal
 * flip land.
 *
 * A centred placement has no near or far span, so it slides to both spans on
 * both edges.
 */ function $f5313f1dc717a44b$var$getSlideTryOptions({ align: align, edgeArea: edgeArea, crossAxis: crossAxis, isOppositeEdge: isOppositeEdge }) {
    if (align === 'center') return [
        `${edgeArea} span-${crossAxis}-end`,
        `${edgeArea} span-${crossAxis}-start`
    ];
    if (isOppositeEdge) return [
        edgeArea
    ];
    // For `align: 'start'` the popover expands toward `end`, so the far span is
    // `start`. `align: 'end'` is the mirror image.
    const farSpanSide = align === 'start' ? 'start' : 'end';
    return [
        edgeArea,
        `${edgeArea} span-${crossAxis}-${farSpanSide}`
    ];
}
/**
 * The try option that flips on both axes, into the opposite corner.
 */ function $f5313f1dc717a44b$var$getDiagonalFlipTryOption({ axis: axis }) {
    const placementAxisFlip = axis === 'block' ? 'flip-block' : 'flip-inline';
    const crossAxisFlip = axis === 'block' ? 'flip-inline' : 'flip-block';
    return `${placementAxisFlip} ${crossAxisFlip}`;
}
function $f5313f1dc717a44b$export$c4e16947a95d61f1({ placement: placement }) {
    const { axis: axis, edge: edge, align: align } = placement;
    const crossAxis = axis === 'block' ? 'inline' : 'block';
    const oppositeEdge = edge === 'start' ? 'end' : 'start';
    const sameEdgeArea = `${axis}-${edge}`;
    const oppositeEdgeArea = `${axis}-${oppositeEdge}`;
    const placementAxisFlip = axis === 'block' ? 'flip-block' : 'flip-inline';
    return [
        $f5313f1dc717a44b$var$getSlideTryOptions({
            align: align,
            edgeArea: sameEdgeArea,
            crossAxis: crossAxis,
            isOppositeEdge: false
        }),
        placementAxisFlip,
        align !== 'center' ? $f5313f1dc717a44b$var$getDiagonalFlipTryOption({
            axis: axis
        }) : null,
        $f5313f1dc717a44b$var$getSlideTryOptions({
            align: align,
            edgeArea: oppositeEdgeArea,
            crossAxis: crossAxis,
            isOppositeEdge: true
        })
    ].filter(Boolean).flat().join(', ');
}

});


parcelRegister("aJaUn", function(module, exports) {
$parcel$export(module.exports, "applyJavaScriptFallbackPositioning", () => $bb5b920cc9f1b689$export$89babc4c2047d2ba);
/**
 * **JavaScript positioning fallback**
 *
 * Writes measured `position: fixed` coordinates for browsers without CSS Anchor
 * Positioning.
 *
 * Best effort. The popover is always visible, and the position degrades in this
 * order:
 *
 * 1. Anchored, at the measured position.
 * 2. Anchored, with unresolvable offsets treated as `0`.
 * 3. Centred in the viewport.
 *
 * The two hazards differ in kind:
 *
 * - `new ResizeObserver` runs synchronously in the layout effect, where a throw
 *   unmounts the React tree.
 * - `updatePosition` runs asynchronously, where the danger is an `opacity: 0`
 *   that is never cleared.
 */ 
var $dmmsG = parcelRequire("dmmsG");

var $9q8C6 = parcelRequire("9q8C6");

var $2uH9r = parcelRequire("2uH9r");

var $dKqTB = parcelRequire("dKqTB");

var $36pKc = parcelRequire("36pKc");

var $2N0qL = parcelRequire("2N0qL");

var $dmOgh = parcelRequire("dmOgh");
// Wrapped because jsdom throws on the unknown `:popover-open` selector.
function $bb5b920cc9f1b689$var$isPopoverOpen({ popover: popover }) {
    try {
        return popover.matches(':popover-open');
    } catch  {
        return false;
    }
}
/**
 * Creates an observer that calls `onFirstLayout` at the first non-zero layout
 * of the popover, then disconnects. The scroll and resize listeners handle
 * movement after that. The popover is `display: none` until `showPopover()`,
 * and some browsers fire `toggle` before layout, so a RAF after `toggle` is
 * unreliable.
 *
 * Returns `null` when `ResizeObserver` is missing (non-DOM jest environments)
 * or its constructor throws. There is then no measurement to wait for, so the
 * caller positions immediately and must not hide the popover, because no
 * reveal would follow.
 */ function $bb5b920cc9f1b689$var$createFirstLayoutObserver({ popover: popover, onFirstLayout: onFirstLayout }) {
    if (typeof ResizeObserver === 'undefined') return null;
    try {
        const observer = new ResizeObserver(()=>{
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                onFirstLayout();
                observer.disconnect();
            }
        });
        return observer;
    } catch (error) {
        (0, $dmOgh.warnFallbackFailure)({
            error: error
        });
        return null;
    }
}
function $bb5b920cc9f1b689$export$89babc4c2047d2ba({ anchor: anchor, popover: popover, placement: placement, sizeStyles: sizeStyles }) {
    // The `popover` attribute already puts the popover in the top layer. Reset the
    // UA `margin` and `inset` so that the measured `top` / `left` apply, and write
    // the size styles.
    const cleanupBaseStyles = (0, $dKqTB.setStyle)({
        element: popover,
        styles: [
            {
                property: 'margin',
                value: '0'
            },
            {
                property: 'inset',
                value: 'auto'
            },
            ...sizeStyles
        ]
    });
    // The popover can be consumer-owned (`@atlaskit/popper`'s `createPopper`),
    // so restore prior inline values rather than removing ours.
    let cleanupPositionStyles;
    let cleanupHideStyles;
    // Resolved once per open and per resize, and reused across scrolls. Resolving
    // is a full style and layout flush, and a scroll cannot change what a CSS
    // length resolves to. A resize can (viewport units), and so can a re-open (a
    // token retargeted while closed).
    let resolvedOffsets = null;
    function invalidateResolvedOffsets() {
        resolvedOffsets = null;
    }
    function getResolvedOffsets() {
        if (resolvedOffsets) return resolvedOffsets;
        // Probe INSIDE the popover, so a length resolves against the popover's font
        // size and custom-property scope, not the anchor's.
        resolvedOffsets = {
            gap: (0, $2N0qL.resolveCssLengthToPixels)({
                value: placement.offset.gap,
                container: popover
            }),
            crossAxisShift: (0, $2N0qL.resolveCssLengthToPixels)({
                value: placement.offset.crossAxisShift.value,
                container: popover
            })
        };
        return resolvedOffsets;
    }
    function reveal() {
        cleanupHideStyles?.();
        cleanupHideStyles = undefined;
    }
    function restorePosition() {
        cleanupPositionStyles?.();
        cleanupPositionStyles = undefined;
    }
    // `opacity: 0` not `visibility: hidden`: Firefox skips visibility-hidden
    // elements during `<dialog>` initial-focus traversal.
    function hideUntilPositioned() {
        // Keep the first snapshot, else we capture our own `opacity: 0`.
        if (cleanupHideStyles) return;
        cleanupHideStyles = (0, $dKqTB.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'opacity',
                    value: '0'
                }
            ]
        });
    }
    /**
   * Last resort. The base styles above reset the UA
   * `[popover] { inset: 0; margin: auto }`, so a popover with no `top` / `left`
   * sits in the viewport corner rather than centred.
   */ function centerInViewport() {
        restorePosition();
        cleanupPositionStyles = (0, $dKqTB.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'inset',
                    value: '0'
                },
                {
                    property: 'margin',
                    value: 'auto'
                }
            ]
        });
    }
    function updatePosition() {
        try {
            const anchorRect = anchor.getBoundingClientRect();
            const viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            const { gap: gap, crossAxisShift: crossAxisShift } = getResolvedOffsets();
            const { top: top, left: left } = (0, $36pKc.computeFallbackPosition)({
                anchorRect: anchorRect,
                popover: popover,
                placement: placement,
                viewport: viewport,
                gap: gap,
                crossAxisShift: {
                    value: crossAxisShift,
                    direction: placement.offset.crossAxisShift.direction
                }
            });
            // A non-finite coordinate serialises to a declaration the browser drops.
            // That leaves the popover in the corner, as silently as a throw would.
            if (!Number.isFinite(top) || !Number.isFinite(left)) {
                centerInViewport();
                return;
            }
            // Restore first so the snapshot stays the consumer's value.
            restorePosition();
            cleanupPositionStyles = (0, $dKqTB.setStyle)({
                element: popover,
                styles: [
                    {
                        property: 'top',
                        value: `${top}px`
                    },
                    {
                        property: 'left',
                        value: `${left}px`
                    }
                ]
            });
        } catch (error) {
            (0, $dmOgh.warnFallbackFailure)({
                error: error
            });
            // Anchored positioning failed, so the centred position is the only one left
            // to degrade to.
            try {
                centerInViewport();
            } catch  {}
        } finally{
            // Always reveal. A popover in the wrong place recovers on the next scroll or
            // resize. A popover left at `opacity: 0` stays invisible.
            reveal();
        }
    }
    function invalidateOffsetsAndUpdatePosition() {
        invalidateResolvedOffsets();
        updatePosition();
    }
    // One update per animation frame. Scroll reuses the resolved offsets. Resize
    // resolves them again.
    const scheduledScrollUpdate = (0, $9q8C6.default)(updatePosition);
    const scheduledResizeUpdate = (0, $9q8C6.default)(invalidateOffsetsAndUpdatePosition);
    const firstLayoutObserver = $bb5b920cc9f1b689$var$createFirstLayoutObserver({
        popover: popover,
        onFirstLayout: updatePosition
    });
    function positionOnNextLayout() {
        // A token can have been retargeted while the popover was closed, so each
        // open resolves the offsets again.
        invalidateResolvedOffsets();
        // No observer means no measurement is coming: position now, and do not
        // hide, because the reveal would never arrive.
        if (!firstLayoutObserver) {
            updatePosition();
            return;
        }
        hideUntilPositioned();
        firstLayoutObserver.observe(popover);
    }
    // The popover can already be open when this runs. Then the initial `toggle`
    // has fired, and the listener below would miss it.
    if ($bb5b920cc9f1b689$var$isPopoverOpen({
        popover: popover
    })) positionOnNextLayout();
    return (0, $2uH9r.combine)(cleanupBaseStyles, // Each open needs a fresh measurement, so hide and observe again.
    (0, $dmmsG.bind)(popover, {
        type: 'toggle',
        listener: (event)=>{
            const toggleEvent = event;
            if (toggleEvent.newState === 'open') positionOnNextLayout();
        }
    }), ()=>firstLayoutObserver?.disconnect(), (0, $dmmsG.bind)(window, {
        type: 'scroll',
        listener: scheduledScrollUpdate,
        options: {
            capture: true,
            passive: true
        }
    }), (0, $dmmsG.bind)(window, {
        type: 'resize',
        listener: scheduledResizeUpdate,
        options: {
            passive: true
        }
    }), ()=>{
        scheduledScrollUpdate.cancel();
        scheduledResizeUpdate.cancel();
        restorePosition();
        reveal();
    });
}

});
parcelRegister("9q8C6", function(module, exports) {
$parcel$export(module.exports, "default", () => $6dbd39392d980e15$export$2e2bcd8739ae039);
var $6dbd39392d980e15$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $6dbd39392d980e15$export$2e2bcd8739ae039 = $6dbd39392d980e15$var$rafSchd;

});

parcelRegister("2uH9r", function(module, exports) {
$parcel$export(module.exports, "combine", () => $177bb383354a9b97$export$1be1fc439b849fdf);
/**
 * Combines cleanup functions into one cleanup function. It calls them in order and skips
 * `undefined` entries.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $177bb383354a9b97$export$1be1fc439b849fdf(...cleanupFns) {
    return function cleanup() {
        cleanupFns.forEach((cleanupFn)=>cleanupFn?.());
    };
}

});

parcelRegister("36pKc", function(module, exports) {
$parcel$export(module.exports, "computeFallbackPosition", () => $d735a5acc6a8c820$export$d5ef1dac02135664);
/**
 * Returns the position on the placement `edge`, centred on the cross axis.
 *
 * Flips to the opposite edge when the popover does not fit and the opposite
 * edge has more space. `gap` separates the anchor and the popover along the
 * placement axis.
 */ function $d735a5acc6a8c820$var$computeEdgePosition({ axis: axis, edge: edge, anchorRect: anchorRect, popoverWidth: popoverWidth, popoverHeight: popoverHeight, viewport: viewport, gap: gap }) {
    if (axis === 'block' && edge === 'end') {
        // Below the anchor
        const spaceBelow = viewport.height - anchorRect.bottom;
        const spaceAbove = anchorRect.top;
        const fitsBelow = spaceBelow >= popoverHeight + gap;
        const shouldPlaceBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: shouldPlaceBelow ? anchorRect.bottom + gap : anchorRect.top - popoverHeight - gap,
            left: anchorRect.left + anchorRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above the anchor
        const spaceAbove = anchorRect.top;
        const spaceBelow = viewport.height - anchorRect.bottom;
        const fitsAbove = spaceAbove >= popoverHeight + gap;
        const shouldPlaceAbove = fitsAbove || spaceAbove >= spaceBelow;
        return {
            top: shouldPlaceAbove ? anchorRect.top - popoverHeight - gap : anchorRect.bottom + gap,
            left: anchorRect.left + anchorRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of the anchor
        const spaceRight = viewport.width - anchorRect.right;
        const spaceLeft = anchorRect.left;
        const fitsRight = spaceRight >= popoverWidth + gap;
        const shouldPlaceRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: anchorRect.top + anchorRect.height / 2 - popoverHeight / 2,
            left: shouldPlaceRight ? anchorRect.right + gap : anchorRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of the anchor
        const spaceLeft = anchorRect.left;
        const spaceRight = viewport.width - anchorRect.right;
        const fitsLeft = spaceLeft >= popoverWidth + gap;
        const shouldPlaceLeft = fitsLeft || spaceLeft >= spaceRight;
        return {
            top: anchorRect.top + anchorRect.height / 2 - popoverHeight / 2,
            left: shouldPlaceLeft ? anchorRect.left - popoverWidth - gap : anchorRect.right + gap
        };
    }
    // Unreachable for a valid placement. Defaults to below the anchor.
    return {
        top: anchorRect.bottom + gap,
        left: anchorRect.left + anchorRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Moves the centred position from `computeEdgePosition` along the cross axis
 * for a non-centre `align`:
 *
 * - `'start'`: the popover start edge lines up with the anchor start edge.
 * - `'end'`: the popover end edge lines up with the anchor end edge.
 */ function $d735a5acc6a8c820$var$applyAlignment({ position: position, axis: axis, align: align, anchorRect: anchorRect, popoverWidth: popoverWidth, popoverHeight: popoverHeight }) {
    if (align === 'center') return position;
    // A block-axis placement has an inline (left and right) cross axis.
    if (axis === 'block') {
        if (align === 'start') return {
            ...position,
            left: anchorRect.left
        };
        return {
            ...position,
            left: anchorRect.right - popoverWidth
        };
    }
    // An inline-axis placement has a block (top and bottom) cross axis.
    if (align === 'start') return {
        ...position,
        top: anchorRect.top
    };
    return {
        ...position,
        top: anchorRect.bottom - popoverHeight
    };
}
/**
 * Applies the cross-axis shift offset. `forwards` always moves the popover
 * toward the cross-axis END, for every `align` value.
 *
 * Do not add a per-`align` sign inversion here. This is a coordinate, so the
 * direction is the sign and nothing else. The CSS path inverts only because an
 * END-side margin pushes a box the opposite way to a START-side one, which is a
 * property of margins.
 */ function $d735a5acc6a8c820$var$applyCrossAxisShift({ position: position, axis: axis, crossAxisShift: crossAxisShift }) {
    if (crossAxisShift.value === 0) return position;
    const directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    const delta = crossAxisShift.value * directionSign;
    // The cross axis is perpendicular to the placement axis.
    if (axis === 'block') return {
        ...position,
        left: position.left + delta
    };
    return {
        ...position,
        top: position.top + delta
    };
}
function $d735a5acc6a8c820$export$d5ef1dac02135664({ anchorRect: anchorRect, popover: popover, placement: placement, viewport: viewport, gap: gap, crossAxisShift: crossAxisShift }) {
    const { axis: axis, edge: edge, align: align } = placement;
    // The popover must have layout here (not `display: none`), or both sizes are `0`.
    const popoverWidth = popover.offsetWidth;
    const popoverHeight = popover.offsetHeight;
    const edgePosition = $d735a5acc6a8c820$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        anchorRect: anchorRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    const alignedPosition = $d735a5acc6a8c820$var$applyAlignment({
        position: edgePosition,
        axis: axis,
        align: align,
        anchorRect: anchorRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    const shiftedPosition = $d735a5acc6a8c820$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        crossAxisShift: crossAxisShift
    });
    // Clamp to the viewport. A popover larger than the viewport keeps its top-left
    // corner on screen.
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}

});

parcelRegister("2N0qL", function(module, exports) {
$parcel$export(module.exports, "resolveCssLengthToPixels", () => $ccce4517009c1d10$export$98721546d2816d9e);

var $dmOgh = parcelRequire("dmOgh");
/**
 * Measures `value` as the computed `margin-left` of a hidden probe inside
 * `container`. Returns `null` when the environment cannot measure, and `0` when
 * the computed value is not a number.
 */ function $ccce4517009c1d10$var$measureWithProbe({ value: value, container: container }) {
    // Reached through the container rather than the global, so a popover in
    // another document still measures and one with no view degrades gracefully.
    const view = container.ownerDocument.defaultView;
    if (!view) return null;
    const probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `margin-left`, not `width`, because `width` clamps a negative value to `0`.
    // `getComputedStyle` returns the resolved pixel value of a margin, even when
    // the source is a token, `calc()` or `var()`.
    probe.style.marginLeft = value;
    // Hidden from assistive technology and from events. This also protects
    // consumer code that walks the DOM (for example `getElementsByTagName('div')`).
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    try {
        container.appendChild(probe);
        const pixels = parseFloat(view.getComputedStyle(probe).marginLeft);
        return Number.isFinite(pixels) ? pixels : 0;
    } catch (error) {
        (0, $dmOgh.warnFallbackFailure)({
            error: error
        });
        return null;
    } finally{
        // `remove()` rather than `removeChild()`: consumer code may already have
        // detached the probe, which must not throw out of a layout effect.
        probe.remove();
    }
}
function $ccce4517009c1d10$export$98721546d2816d9e({ value: value, container: container }) {
    if (typeof value === 'number') return value;
    // Fast path: consumers occasionally pass `'0'` instead of the number `0`.
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from `resolvePlacement`, so this avoids
    // a reflow for the common case.
    const pixelMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pixelMatch) return Number(pixelMatch[1]);
    return $ccce4517009c1d10$var$measureWithProbe({
        value: value,
        container: container
    }) ?? 0;
}

});
parcelRegister("dmOgh", function(module, exports) {
$parcel$export(module.exports, "warnFallbackFailure", () => $e78a26b572e5b8a4$export$e142245b95267f17);

function $e78a26b572e5b8a4$export$e142245b95267f17({ error: error }) {
    return;
}

});



parcelRegister("3snav", function(module, exports) {
$parcel$export(module.exports, "supportsAnchorPositioning", () => $ee9c90036cf68bb4$export$7192e63dfa9e8124);

var $icte8 = parcelRequire("icte8");
const $ee9c90036cf68bb4$export$7192e63dfa9e8124 = (0, $icte8.createCssDeclarationProbe)({
    property: 'anchor-name',
    value: '--a'
});

});
parcelRegister("icte8", function(module, exports) {
$parcel$export(module.exports, "createCssDeclarationProbe", () => $e2ce150ec0f7cc9b$export$69de71b4b7c76bad);

var $c16KL = parcelRequire("c16KL");
function $e2ce150ec0f7cc9b$export$69de71b4b7c76bad({ property: property, value: value }) {
    return (0, $c16KL.default)(function supportsCssDeclaration() {
        if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
        return CSS.supports(property, value);
    });
}

});


parcelRegister("hnsvW", function(module, exports) {
$parcel$export(module.exports, "supportsAnchorSize", () => $ba634b97a6469638$export$1c8dd0d1c9df9c6e);

var $icte8 = parcelRequire("icte8");
const $ba634b97a6469638$export$1c8dd0d1c9df9c6e = (0, $icte8.createCssDeclarationProbe)({
    property: 'min-inline-size',
    value: 'anchor-size(self-inline)'
});

});


parcelRegister("hWoE3", function(module, exports) {
$parcel$export(module.exports, "useAnchoredPopoverAtPoint", () => $c53898ccc78b7e97$export$3c5c8baff3ccd957);
/**
 * Positioning and sizing for a popover anchored to a viewport COORDINATE. No
 * positioning logic here: CSS Anchor Positioning needs a real element to carry
 * `anchor-name`, so this hook creates a hidden, zero-size one at the requested
 * point and delegates everything else to `useAnchoredPopover`.
 *
 * See `notes/decisions/anchored-popover-at-point.md` for why this is a sibling
 * hook instead of an anchor union inside `useAnchoredPopover`.
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $3q5kf = parcelRequire("3q5kf");

var $4RAor = parcelRequire("4RAor");
/**
 * Creates a hidden, zero-size anchor element at `point`. It is appended to
 * `document.body` to escape any transformed ancestor, which would stop
 * `position: fixed` from resolving against the viewport. `Object.assign` rather
 * than `setStyle`: we own the element, so there is nothing to restore.
 */ function $c53898ccc78b7e97$var$mountAnchorElementAtPoint({ point: point }) {
    const element = document.createElement('div');
    element.setAttribute('aria-hidden', 'true');
    Object.assign(element.style, {
        position: 'fixed',
        // Physical insets: `inset-inline-start` would need `viewportWidth - point.x`
        // in RTL.
        top: `${point.y}px`,
        left: `${point.x}px`,
        // Zero size, so placement alone decides which side the popover sits on.
        width: '0',
        height: '0',
        pointerEvents: 'none'
    });
    document.body.appendChild(element);
    return {
        element: element,
        cleanup: function cleanup() {
            element.remove();
        }
    };
}
function $c53898ccc78b7e97$export$3c5c8baff3ccd957({ getPoint: getPoint, isEnabled: isEnabled = true, ...anchoredPopoverOptions }) {
    const anchorRef = (0, $1v5pe.useRef)(null);
    // Latched, keyed on `isEnabled`: consumers read mutable refs inside `getPoint`,
    // so re-reading it would move an already-open popover, and keying on
    // `getPoint`'s identity would re-latch on every parent render.
    const getPointRef = (0, $1v5pe.useRef)(getPoint);
    getPointRef.current = getPoint;
    // Declared BEFORE `useAnchoredPopover` below, so the element exists when that
    // hook's effect reads the ref (React runs layout effects in source order). This
    // effect must not depend on anything the delegated effect does not: a dependency
    // here alone re-creates the element without that hook writing an `anchor-name`
    // onto it, and positioning silently dies.
    (0, $3q5kf.useLayoutEffect)(()=>{
        if (!isEnabled) return;
        const point = getPointRef.current();
        if (!point) return;
        const { element: element, cleanup: unmountAnchorElement } = $c53898ccc78b7e97$var$mountAnchorElementAtPoint({
            point: point
        });
        anchorRef.current = element;
        return function cleanup() {
            unmountAnchorElement();
            anchorRef.current = null;
        };
    // The latch. See `getPointRef` above: `getPoint` is deliberately absent.
    }, [
        isEnabled
    ]);
    (0, $4RAor.useAnchoredPopover)({
        ...anchoredPopoverOptions,
        anchorRef: anchorRef,
        isEnabled: isEnabled
    });
}

});

parcelRegister("fZI65", function(module, exports) {
$parcel$export(module.exports, "usePopoverId", () => $6b8f44bf9ae3bdad$export$9198c6c168be2eeb);

var $lHxwq = parcelRequire("lHxwq");
function $6b8f44bf9ae3bdad$export$9198c6c168be2eeb() {
    // `@atlaskit/ds-lib/use-id`, not React's `useId`: React's output can contain `:`, `«` and `»`,
    // which break CSS selectors such as `document.querySelector('#id')`.
    return `popover-${(0, $lHxwq.useId)()}`;
}

});

parcelRegister("akiB7", function(module, exports) {
$parcel$export(module.exports, "isPageRtl", () => $5e777c0caf3a22b4$export$175375e9a2b5515d);

var $brxde = parcelRequire("brxde");
function $5e777c0caf3a22b4$export$175375e9a2b5515d() {
    const document = (0, $brxde.getDocument)();
    if (!document) return false;
    return document.dir === 'rtl' || document.body.dir === 'rtl' || document.documentElement.dir === 'rtl';
}

});

parcelRegister("lyX3t", function(module, exports) {
$parcel$export(module.exports, "rectPointForPlacement", () => $0bee1aad4c6b9a5d$export$b065aeb850c3e87f);
function $0bee1aad4c6b9a5d$export$b065aeb850c3e87f({ rect: rect, placement: placement, isRtl: isRtl }) {
    const axis = placement.axis ?? 'block';
    const edge = placement.edge ?? 'end';
    const align = placement.align ?? 'center';
    if (axis === 'block') {
        // Popover sits above (`edge: 'start'`) or below (`edge: 'end'`)
        // the anchor. Hug the matching horizontal edge; align along x.
        const y = edge === 'start' ? rect.top : rect.bottom;
        const x = $0bee1aad4c6b9a5d$var$horizontalForAlign({
            rect: rect,
            align: align,
            isRtl: isRtl
        });
        return {
            x: x,
            y: y
        };
    }
    // `axis: 'inline'`: popover sits inline-start or inline-end of the
    // anchor. Hug the matching vertical edge; align along y.
    const x = $0bee1aad4c6b9a5d$var$inlineEdgeX({
        rect: rect,
        edge: edge,
        isRtl: isRtl
    });
    const y = $0bee1aad4c6b9a5d$var$verticalForAlign({
        rect: rect,
        align: align
    });
    return {
        x: x,
        y: y
    };
}
function $0bee1aad4c6b9a5d$var$horizontalForAlign({ rect: rect, align: align, isRtl: isRtl }) {
    if (align === 'center') return rect.left + rect.width / 2;
    // `start` / `end` are logical. In LTR, `start` is the left edge.
    // In RTL, `start` is the right edge.
    const isStartLeft = !isRtl;
    if (align === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}
function $0bee1aad4c6b9a5d$var$verticalForAlign({ rect: rect, align: align }) {
    if (align === 'center') return rect.top + rect.height / 2;
    if (align === 'start') return rect.top;
    return rect.bottom;
}
function $0bee1aad4c6b9a5d$var$inlineEdgeX({ rect: rect, edge: edge, isRtl: isRtl }) {
    const isStartLeft = !isRtl;
    if (edge === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}

});

parcelRegister("9TZYC", function(module, exports) {
$parcel$export(module.exports, "toLegacyPlacement", () => $6bf9582e656717ad$export$e9a6fdb80170ffd);
function $6bf9582e656717ad$export$e9a6fdb80170ffd(placement) {
    return placement;
}

});

parcelRegister("fxK4C", function(module, exports) {
$parcel$export(module.exports, "useManagerAnchor", () => $7b53f58aa0d14929$export$941a7e8bf0b9eafd);

var $1v5pe = parcelRequire("1v5pe");

var $7ALLt = parcelRequire("7ALLt");
function $7b53f58aa0d14929$export$941a7e8bf0b9eafd() {
    return (0, $1v5pe.useContext)((0, $7ALLt.AnchorContext));
}

});
parcelRegister("7ALLt", function(module, exports) {
$parcel$export(module.exports, "AnchorContext", () => $2d59a2c466857be2$export$8f73317645bb7b8e);

var $1v5pe = parcelRequire("1v5pe");
const $2d59a2c466857be2$export$8f73317645bb7b8e = /*#__PURE__*/ (0, $1v5pe.createContext)(null);

});


parcelRegister("6gUQ3", function(module, exports) {
$parcel$export(module.exports, "useReferenceVisibility", () => $b19a7e0e74ea3b21$export$61d36e2b682e92f7);

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $3q5kf = parcelRequire("3q5kf");

var $gDkpF = parcelRequire("gDkpF");
const $b19a7e0e74ea3b21$var$INITIAL = {
    isReferenceHidden: false,
    hasPopperEscaped: false
};
function $b19a7e0e74ea3b21$var$isFullyOutsideViewport(rect, viewport) {
    if (rect.width === 0 && rect.height === 0) return true;
    if (rect.bottom <= 0) return true;
    if (rect.right <= 0) return true;
    if (rect.top >= viewport.height) return true;
    if (rect.left >= viewport.width) return true;
    return false;
}
function $b19a7e0e74ea3b21$var$isClippingOverflow(value) {
    return value === 'auto' || value === 'scroll' || value === 'hidden' || value === 'clip';
}
function $b19a7e0e74ea3b21$var$isClippedByAncestors(element) {
    const rect = element.getBoundingClientRect();
    let parent = element.parentElement;
    while(parent){
        // Read the longhand axis properties directly. The `overflow` shorthand
        // is only populated when both axes share the same value, so reading it
        // alone misses ancestors that set only `overflow-x` or `overflow-y`.
        const style = window.getComputedStyle(parent);
        const clipsHorizontally = $b19a7e0e74ea3b21$var$isClippingOverflow(style.overflowX);
        const clipsVertically = $b19a7e0e74ea3b21$var$isClippingOverflow(style.overflowY);
        if (clipsHorizontally || clipsVertically) {
            const parentRect = parent.getBoundingClientRect();
            const horizontallyOutside = rect.right <= parentRect.left || rect.left >= parentRect.right;
            const verticallyOutside = rect.bottom <= parentRect.top || rect.top >= parentRect.bottom;
            if (clipsHorizontally && horizontallyOutside) return true;
            if (clipsVertically && verticallyOutside) return true;
        }
        parent = parent.parentElement;
    }
    return false;
}
function $b19a7e0e74ea3b21$export$61d36e2b682e92f7({ anchor: anchor, popoverRef: popoverRef }) {
    const [visibility, setVisibility] = (0, $1v5pe.useState)($b19a7e0e74ea3b21$var$INITIAL);
    const measure = (0, $1v5pe.useCallback)(()=>{
        if (!anchor) {
            setVisibility((previous)=>previous.isReferenceHidden === false && previous.hasPopperEscaped === false ? previous : $b19a7e0e74ea3b21$var$INITIAL);
            return;
        }
        const viewport = (0, $gDkpF.readViewport)();
        const anchorRect = anchor.getBoundingClientRect();
        const isReferenceHidden = $b19a7e0e74ea3b21$var$isFullyOutsideViewport(anchorRect, viewport) || $b19a7e0e74ea3b21$var$isClippedByAncestors(anchor);
        const popoverElement = popoverRef.current;
        const hasPopperEscaped = popoverElement ? $b19a7e0e74ea3b21$var$isFullyOutsideViewport(popoverElement.getBoundingClientRect(), viewport) : false;
        setVisibility((previous)=>{
            if (previous.isReferenceHidden === isReferenceHidden && previous.hasPopperEscaped === hasPopperEscaped) return previous;
            return {
                isReferenceHidden: isReferenceHidden,
                hasPopperEscaped: hasPopperEscaped
            };
        });
    }, [
        anchor,
        popoverRef
    ]);
    (0, $3q5kf.useLayoutEffect)(()=>{
        measure();
        if (typeof window === 'undefined') return undefined;
        const cleanups = [];
        // Resize observer on the anchor so layout changes update visibility.
        if (anchor && typeof ResizeObserver !== 'undefined') {
            const observer = new ResizeObserver(()=>measure());
            observer.observe(anchor);
            cleanups.push(()=>observer.disconnect());
        }
        // Scroll + resize: any scroll event in the document can move the
        // anchor in/out of any scrollable ancestor's viewport.
        cleanups.push((0, $dmmsG.bindAll)(window, [
            {
                type: 'scroll',
                listener: measure,
                options: {
                    capture: true,
                    passive: true
                }
            },
            {
                type: 'resize',
                listener: measure,
                options: {
                    passive: true
                }
            }
        ]));
        const visual = window.visualViewport;
        if (visual) cleanups.push((0, $dmmsG.bind)(visual, {
            type: 'resize',
            listener: measure,
            options: {
                passive: true
            }
        }));
        return ()=>{
            cleanups.forEach((cleanup)=>cleanup());
        };
    }, [
        anchor,
        measure
    ]);
    return visibility;
}

});
parcelRegister("gDkpF", function(module, exports) {
$parcel$export(module.exports, "readViewport", () => $b4c551119441163e$export$64beed533e21f72d);
function $b4c551119441163e$export$64beed533e21f72d() {
    if (typeof window === 'undefined') return {
        width: 0,
        height: 0
    };
    const visual = window.visualViewport;
    if (visual) return {
        width: visual.width,
        height: visual.height
    };
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}

});




parcelRegister("kARP4", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e3caca48a398b2c$export$2e2bcd8739ae039);
parcelRequire("1v5pe");

var $2aEiL = parcelRequire("2aEiL");

var $hwRfn = parcelRequire("hwRfn");

var $bN0sf = parcelRequire("bN0sf");

var $3QZA6 = parcelRequire("3QZA6");

var $lAu9T = parcelRequire("lAu9T");

var $kIqwl = parcelRequire("kIqwl");
function $6e3caca48a398b2c$export$2e2bcd8739ae039({ zIndex: zIndex = 0, children: children, mountStrategy: mountStrategy = 'effect' }) {
    const isSubsequentRender = (0, $3QZA6.default)(mountStrategy);
    (0, $lAu9T.default)(zIndex);
    return !(0, $2aEiL.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, $kIqwl.jsx)((0, $hwRfn.default), {
        zIndex: zIndex,
        children: children
    }) : null : /*#__PURE__*/ (0, $kIqwl.jsx)((0, $bN0sf.default), {
        zIndex: zIndex,
        children: children
    });
}

});
parcelRegister("hwRfn", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f16ce52793d0689$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $fBuCt = parcelRequire("fBuCt");

var $5jHNN = parcelRequire("5jHNN");

var $8RTDE = parcelRequire("8RTDE");

var $j4OG8 = parcelRequire("j4OG8");

var $hDdFl = parcelRequire("hDdFl");

var $4tTzL = parcelRequire("4tTzL");

var $2bmkj = parcelRequire("2bmkj");

var $kIqwl = parcelRequire("kIqwl");
function $4f16ce52793d0689$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const container = (0, $1v5pe.useMemo)(()=>(0, $4tTzL.createContainer)(zIndex), [
        zIndex
    ]);
    const colorMode = (0, $8RTDE.useColorMode)();
    const isInsideThemeProvider = (0, $j4OG8.useIsInsideThemeProvider)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $hDdFl.appendPortalContainerIfNotAppended)(container);
    (0, $1v5pe.useEffect)(()=>{
        return ()=>{
            (0, $2bmkj.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $fBuCt.createPortal)(isInsideThemeProvider ? /*#__PURE__*/ (0, $kIqwl.jsx)((0, $5jHNN.ThemeProvider), {
        defaultColorMode: colorMode,
        children: children
    }) : children, container);
}

});
parcelRegister("5jHNN", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", () => $6379a368701735c1$export$d8964aec282183a3);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $2aEiL = parcelRequire("2aEiL");

var $21yAH = parcelRequire("21yAH");

var $khHZs = parcelRequire("khHZs");

var $4r3Q4 = parcelRequire("4r3Q4");

var $dxx1U = parcelRequire("dxx1U");

var $afqYt = parcelRequire("afqYt");

var $h8JSM = parcelRequire("h8JSM");

var $lmUZy = parcelRequire("lmUZy");

var $5mHvF = parcelRequire("5mHvF");

var $8BkRv = parcelRequire("8BkRv");

var $7HPJy = parcelRequire("7HPJy");

var $j4OG8 = parcelRequire("j4OG8");

var $bbF2a = parcelRequire("bbF2a");

var $juHZq = parcelRequire("juHZq");

var $kIqwl = parcelRequire("kIqwl");
const $6379a368701735c1$var$_ = "._1e0c1bgi{display:contents}";
const $6379a368701735c1$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    shape: 'shape',
    spacing: 'spacing',
    typography: 'typography'
};
const $6379a368701735c1$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $6379a368701735c1$var$prefersDarkModeMql = $6379a368701735c1$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined; // TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $6379a368701735c1$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $6379a368701735c1$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
const $6379a368701735c1$var$contentStyles = {
    body: "_1e0c1bgi"
};
function $6379a368701735c1$export$d8964aec282183a3({ children: children, defaultColorMode: defaultColorMode = 'auto', defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $1v5pe.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $1v5pe.useState)($6379a368701735c1$var$getReconciledColorMode(defaultColorMode));
    const isInsideAppProvider = (0, $h8JSM.useIsInsideAppProvider)();
    const isAppProviderThemingEnabled = (0, $afqYt.useIsAppProviderThemingEnabled)();
    const isInsideThemeProvider = (0, $j4OG8.useIsInsideThemeProvider)(); /**
                                                             * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
                                                             *
                                                             * This will not use sub-tree theming but instead set the global theme state using the
                                                             * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
                                                             * for compatibility with `@atlaskit/css-reset`.
                                                             *
                                                             * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
                                                             * `html` in order to apply global theme state, which would allow a more consistent approach to
                                                             * theme loading.
                                                             */ 
    const isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled; /**
                                                                                                             * Each provider owns its own override stylesheet, so nested providers don't overwrite or remove
                                                                                                             * each other's overrides. `useId` is stable between the server render and hydration.
                                                                                                             *
                                                                                                             * Subtree providers also scope their override selector to their own element. Otherwise every
                                                                                                             * subtree using the same custom theme would match every provider's overrides, and the last
                                                                                                             * stylesheet in the document would win. The root provider targets `html`, which subtrees
                                                                                                             * inherit from.
                                                                                                             */ 
    const customThemeOverridesStyleId = (0, $1v5pe.useId)();
    const { theme: normalizedDefaultTheme, inlineStyles: inlineStyles } = (0, $khHZs.getThemeAndOverrides)(defaultTheme, isRootThemeProvider ? undefined : customThemeOverridesStyleId);
    const [theme, setTheme] = (0, $1v5pe.useState)(()=>({
            ...$6379a368701735c1$var$defaultThemeSettings,
            ...normalizedDefaultTheme
        }));
    const [hasHoistedInlineThemeStyles, setHasHoistedInlineThemeStyles] = (0, $1v5pe.useState)(false);
    const setColorMode = (0, $1v5pe.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($6379a368701735c1$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $1v5pe.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $1v5pe.useRef)(null); /**
                                                                                                * Custom theme overrides apply regardless of `platform-static-theme-loading`: that gate only
                                                                                                * controls how the theme stylesheets themselves are loaded.
                                                                                                */ 
    const inlineThemeStylesOverrides = inlineStyles;
    (0, $1v5pe.useLayoutEffect)(()=>{
        return ()=>{
            document.head.querySelector(`style[data-theme-overrides="${customThemeOverridesStyleId}"]`)?.remove();
        };
    }, [
        customThemeOverridesStyleId
    ]);
    (0, $1v5pe.useLayoutEffect)(()=>{
        const isStaticThemeLoadingEnabled = (0, $2aEiL.fg)('platform-static-theme-loading');
        if (isStaticThemeLoadingEnabled && !hasHoistedInlineThemeStyles) (0, $bbF2a.getInlineThemeStyles)(theme, chosenColorMode).forEach(({ id: id, css: css })=>{
            if (document.head.querySelector(`style[data-theme="${id}"]`)) return;
            const style = document.createElement('style');
            style.dataset.theme = id;
            style.textContent = css;
            document.head.appendChild(style);
        });
        const existingOverrideStyle = document.head.querySelector(`style[data-theme-overrides="${customThemeOverridesStyleId}"]`);
        if (inlineThemeStylesOverrides) {
            if (existingOverrideStyle) existingOverrideStyle.textContent = inlineThemeStylesOverrides;
            else {
                const style = document.createElement('style');
                style.dataset.themeOverrides = customThemeOverridesStyleId;
                style.textContent = inlineThemeStylesOverrides;
                document.head.appendChild(style);
            }
        } else existingOverrideStyle?.remove();
         // Only re-render to drop the inline styles when there are any to drop.
        if (!hasHoistedInlineThemeStyles && (isStaticThemeLoadingEnabled || inlineThemeStylesOverrides)) setHasHoistedInlineThemeStyles(true);
    }, [
        chosenColorMode,
        customThemeOverridesStyleId,
        hasHoistedInlineThemeStyles,
        inlineThemeStylesOverrides,
        theme
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ const cleanupLastFnCall = async ()=>{
                if (lastSetGlobalThemePromiseRef.current) {
                    const unbindFn = await lastSetGlobalThemePromiseRef.current;
                    unbindFn();
                    lastSetGlobalThemePromiseRef.current = null;
                }
            };
            const safelySetGlobalTheme = async ()=>{
                await cleanupLastFnCall();
                const promise = (0, $dxx1U.setGlobalTheme)({
                    ...theme,
                    colorMode: reconciledColorMode
                });
                lastSetGlobalThemePromiseRef.current = promise;
            };
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $juHZq.loadAndMountThemes)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (!$6379a368701735c1$var$prefersDarkModeMql) return;
        const unbindListener = (0, $dmmsG.bind)($6379a368701735c1$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    const attrs = {
        ...(0, $4r3Q4.getThemeHtmlAttrs)({
            ...theme,
            colorMode: reconciledColorMode
        }),
        [(0, $21yAH.SUBTREE_THEME_ATTRIBUTE)]: true,
        // Matches this provider's scoped override selector. Only set when there are overrides.
        ...inlineThemeStylesOverrides ? {
            [(0, $khHZs.CUSTOM_THEME_SCOPE_ATTRIBUTE)]: customThemeOverridesStyleId
        } : {}
    };
    const inlineThemeStyles = (0, $2aEiL.fg)('platform-static-theme-loading') && !hasHoistedInlineThemeStyles ? (0, $bbF2a.getInlineThemeStyles)(theme, chosenColorMode) : [];
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $5mHvF.InsideThemeProviderContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $lmUZy.ColorModeContext).Provider, {
            value: reconciledColorMode,
            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8BkRv.SetColorModeContext).Provider, {
                value: setColorMode,
                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7HPJy.ThemeContext).Provider, {
                    value: theme,
                    children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7HPJy.SetThemeContext).Provider, {
                        value: setPartialTheme,
                        children: !isRootThemeProvider ? /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                            children: [
                                /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                                    children: [
                                        $6379a368701735c1$var$_
                                    ]
                                }),
                                /*#__PURE__*/ (0, $kIqwl.jsxs)("div", {
                                    ...attrs,
                                    className: (0, $hMvDh.default)([
                                        $6379a368701735c1$var$contentStyles.body
                                    ]),
                                    children: [
                                        !hasHoistedInlineThemeStyles && inlineThemeStylesOverrides && /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
                                        (0, $kIqwl.jsx)("style", {
                                            "data-theme-overrides": customThemeOverridesStyleId,
                                            children: inlineThemeStylesOverrides
                                        }),
                                        inlineThemeStyles.map(({ id: id, css: css })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
                                            (0, $kIqwl.jsx)("style", {
                                                "data-theme": id,
                                                children: css
                                            }, id)),
                                        children
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $kIqwl.Fragment), {
                            children: [
                                !hasHoistedInlineThemeStyles && inlineThemeStylesOverrides && /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
                                (0, $kIqwl.jsx)("style", {
                                    "data-theme-overrides": customThemeOverridesStyleId,
                                    children: inlineThemeStylesOverrides
                                }),
                                inlineThemeStyles.map(({ id: id, css: css })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
                                    (0, $kIqwl.jsx)("style", {
                                        "data-theme": id,
                                        children: css
                                    }, id)),
                                children
                            ]
                        })
                    })
                })
            })
        })
    });
}

});
parcelRegister("khHZs", function(module, exports) {
$parcel$export(module.exports, "CUSTOM_THEME_SCOPE_ATTRIBUTE", () => $b010e1f6e1e237bb$export$e5f6e0f338f81b9a);
$parcel$export(module.exports, "getThemeAndOverrides", () => $b010e1f6e1e237bb$export$12087c26a9b2e83e);
function $b010e1f6e1e237bb$var$isThemeWithOverrides(value) {
    return typeof value === 'object' && value !== null && 'id' in value && 'overrides' in value && typeof value.id === 'string' && typeof value.overrides === 'object' && value.overrides !== null;
}
const $b010e1f6e1e237bb$export$e5f6e0f338f81b9a = 'data-theme-overrides-scope';
function $b010e1f6e1e237bb$export$12087c26a9b2e83e(themeWithOverrides, scope) {
    const theme = {};
    const overrides = {};
    for (const [themeKind, value] of Object.entries(themeWithOverrides || {})){
        if ($b010e1f6e1e237bb$var$isThemeWithOverrides(value)) {
            theme[themeKind] = value.id;
            overrides[themeKind] = {
                [value.id]: value.overrides
            };
            continue;
        }
        theme[themeKind] = value;
    }
    return {
        theme: theme,
        inlineStyles: $b010e1f6e1e237bb$var$getCustomThemeOverrideStyles(overrides, scope)
    };
}
/**
 * Escapes a value for use inside a double-quoted CSS attribute selector.
 */ function $b010e1f6e1e237bb$var$escapeAttributeValue(value) {
    return value.replace(/["\\]/g, '\\$&');
}
function $b010e1f6e1e237bb$var$getThemeOverrideSelector(themeKind, themeName, scope) {
    // Colour themes only apply in their own colour mode.
    const colorMode = themeKind === 'light' || themeKind === 'dark' ? `[data-color-mode="${themeKind}"]` : '';
    const theme = `${colorMode}[data-theme~="${themeKind}:${themeName}"]`;
    if (scope) return `[data-subtree-theme][${$b010e1f6e1e237bb$export$e5f6e0f338f81b9a}="${$b010e1f6e1e237bb$var$escapeAttributeValue(scope)}"]${theme}`;
    return `html${theme}, [data-subtree-theme]${theme}`;
}
function $b010e1f6e1e237bb$var$getCssVariableName(propertyName) {
    return `--ds-${propertyName.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
}
/**
 * Generates CSS for custom theme overrides.
 *
 * Override property names are converted from camel case to `--ds-` CSS custom properties.
 */ function $b010e1f6e1e237bb$var$getCustomThemeOverrideStyles(overrides, scope) {
    if (!overrides) return '';
    return Object.entries(overrides).flatMap(([themeKind, themes])=>Object.entries(themes || {}).flatMap(([themeName, values])=>{
            const styles = Object.entries(values || {})// Unset optional inputs are skipped so the theme's `var()` fallback applies. Writing
            // `undefined` would be a valid custom property value that breaks the formula.
            .filter(([, value])=>value !== undefined && value !== null).map(([propertyName, value])=>`${$b010e1f6e1e237bb$var$getCssVariableName(propertyName)}: ${typeof value === 'boolean' ? Number(value) : value};`).join('');
            return styles ? `
		${$b010e1f6e1e237bb$var$getThemeOverrideSelector(themeKind, themeName, scope)} {
			${styles}
		}
	` : [];
        })).join('');
}

});

parcelRegister("4r3Q4", function(module, exports) {
$parcel$export(module.exports, "getThemeHtmlAttrs", () => $4f9eaf152b5dd551$export$e1f80cb7a749802f);
$parcel$export(module.exports, "default", () => $4f9eaf152b5dd551$export$2e2bcd8739ae039);

var $2aEiL = parcelRequire("2aEiL");

var $21yAH = parcelRequire("21yAH");

var $5C02M = parcelRequire("5C02M");

var $j3ot2 = parcelRequire("j3ot2");

var $4Meqh = parcelRequire("4Meqh");

var $G4moy = parcelRequire("G4moy");
const $4f9eaf152b5dd551$var$defaultColorMode = 'light';
const $4f9eaf152b5dd551$var$defaultContrastMode = 'no-preference';
const $4f9eaf152b5dd551$export$e1f80cb7a749802f = ({ colorMode: colorMode = (0, $j3ot2.themeStateDefaults)['colorMode'], dark: dark = (0, $j3ot2.themeStateDefaults)['dark'], light: light = (0, $j3ot2.themeStateDefaults)['light'], contrastMode: contrastMode = (0, $j3ot2.themeStateDefaults)['contrastMode'], motion: motion = (0, $j3ot2.themeStateDefaults)['motion'](), shape: shape = (0, $j3ot2.themeStateDefaults)['shape'], spacing: spacing = (0, $j3ot2.themeStateDefaults)['spacing'], typography: typography = (0, $j3ot2.themeStateDefaults)['typography'], UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $j3ot2.themeStateDefaults)['UNSAFE_themeOptions'] } = {})=>{
    const themeAttribute = (0, $5C02M.themeObjectToString)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    let result = {
        [(0, $21yAH.THEME_DATA_ATTRIBUTE)]: themeAttribute,
        [(0, $21yAH.COLOR_MODE_ATTRIBUTE)]: colorMode === 'auto' ? $4f9eaf152b5dd551$var$defaultColorMode : colorMode
    };
    if ((0, $2aEiL.fg)('platform_increased-contrast-themes')) result = {
        ...result,
        // CLEANUP: Move this to the initial `result` assignment above
        [(0, $21yAH.CONTRAST_MODE_ATTRIBUTE)]: contrastMode === 'auto' ? $4f9eaf152b5dd551$var$defaultContrastMode : contrastMode
    };
    if (UNSAFE_themeOptions && (0, $G4moy.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        const optionString = JSON.stringify(UNSAFE_themeOptions);
        const uniqueId = (0, $4Meqh.hash)(optionString);
        result[0, $21yAH.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $4f9eaf152b5dd551$export$2e2bcd8739ae039 = $4f9eaf152b5dd551$export$e1f80cb7a749802f;

});
parcelRegister("5C02M", function(module, exports) {
$parcel$export(module.exports, "themeObjectToString", () => $274a5185c74bb2b4$export$62c37ab81302621a);

var $fcMBA = parcelRequire("fcMBA");

var $VJ5Z0 = parcelRequire("VJ5Z0");

var $lMeSE = parcelRequire("lMeSE");
const $274a5185c74bb2b4$var$customThemeOptions = 'UNSAFE_themeOptions';
const $274a5185c74bb2b4$export$62c37ab81302621a = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && (0, $fcMBA.isColorMode)(id) || // custom theme state
        kind === $274a5185c74bb2b4$var$customThemeOptions && typeof id === 'object' || // other theme states
        (0, $lMeSE.isThemeKind)(kind) && typeof id === 'string' && (0, $VJ5Z0.isThemeIds)(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
        return themeString;
    }, '');

});
parcelRegister("fcMBA", function(module, exports) {
$parcel$export(module.exports, "isColorMode", () => $e8b8be26062c0434$export$4a14e169b1de4ee7);
const $e8b8be26062c0434$export$4a14e169b1de4ee7 = (modeId)=>{
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};

});

parcelRegister("VJ5Z0", function(module, exports) {
$parcel$export(module.exports, "isThemeIds", () => $bac7a593658e72f7$export$ea35b8958c39dd07);

var $fdGCC = parcelRequire("fdGCC");
const $bac7a593658e72f7$export$ea35b8958c39dd07 = (themeId)=>{
    return (0, $fdGCC.themeIds).find((id)=>id === themeId) !== undefined;
};

});
parcelRegister("fdGCC", function(module, exports) {
$parcel$export(module.exports, "themeIds", () => $2afeb8891762b84b$export$7d43e72a58e3283f);
const $2afeb8891762b84b$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'UNSAFE-dynamic',
    'UNSAFE-dynamic-dark',
    'UNSAFE-test-light',
    'dark',
    'UNSAFE-test-dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'UNSAFE-spacing',
    'shape',
    'typography',
    'UNSAFE-typography',
    'motion'
];

});


parcelRegister("lMeSE", function(module, exports) {
$parcel$export(module.exports, "isThemeKind", () => $d7ba6b4d02867005$export$958fa026be3a263e);
const $d7ba6b4d02867005$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
const $d7ba6b4d02867005$export$958fa026be3a263e = (themeKind)=>{
    return $d7ba6b4d02867005$var$themeKinds.find((kind)=>kind === themeKind) !== undefined;
};

});


parcelRegister("j3ot2", function(module, exports) {
$parcel$export(module.exports, "themeStateDefaults", () => $0303901240983f7d$export$9aedcfa7336a207);
function $0303901240983f7d$var$getMotionDefault() {
    return 'motion';
}
const $0303901240983f7d$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: 'shape',
    spacing: 'spacing',
    typography: 'typography',
    motion: $0303901240983f7d$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};

});

parcelRegister("4Meqh", function(module, exports) {
$parcel$export(module.exports, "hash", () => $eb913f77b484dd70$export$d6af199866bfb566);
const $eb913f77b484dd70$export$d6af199866bfb566 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("G4moy", function(module, exports) {
$parcel$export(module.exports, "isValidBrandHex", () => $9400dc89a993b258$export$53031ac1ecb71f44);
const $9400dc89a993b258$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);

});


parcelRegister("dxx1U", function(module, exports) {
$parcel$export(module.exports, "setGlobalTheme", () => $b57c42ddde60d130$export$fd7e0dd2b74807f7);

var $2aEiL = parcelRequire("2aEiL");

var $cgaUN = parcelRequire("cgaUN");

var $j3ot2 = parcelRequire("j3ot2");

var $bblC7 = parcelRequire("bblC7");

var $2Cuue = parcelRequire("2Cuue");

var $19yAB = parcelRequire("19yAB");

var $2TWNJ = parcelRequire("2TWNJ");

var $G4moy = parcelRequire("G4moy");

var $3R70r = parcelRequire("3R70r");

var $faVsI = parcelRequire("faVsI");

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ const $b57c42ddde60d130$export$fd7e0dd2b74807f7 = async (nextThemeState = {}, themeLoader)=>{
    let { colorMode: colorMode = (0, $j3ot2.themeStateDefaults)['colorMode'], contrastMode: contrastMode = (0, $j3ot2.themeStateDefaults)['contrastMode'], dark: dark = (0, $j3ot2.themeStateDefaults)['dark'], light: light = (0, $j3ot2.themeStateDefaults)['light'], shape: shape = (0, $j3ot2.themeStateDefaults)['shape'], spacing: spacing = (0, $j3ot2.themeStateDefaults)['spacing'], typography: typography = (0, $j3ot2.themeStateDefaults)['typography'], motion: motion = (0, $j3ot2.themeStateDefaults)['motion'](), UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $j3ot2.themeStateDefaults)['UNSAFE_themeOptions'] } = typeof nextThemeState === 'function' ? nextThemeState({
        ...(0, $j3ot2.themeStateDefaults),
        typography: (0, $j3ot2.themeStateDefaults)['typography'],
        shape: (0, $j3ot2.themeStateDefaults)['shape'],
        motion: (0, $j3ot2.themeStateDefaults)['motion'](),
        ...(0, $cgaUN.getGlobalTheme)()
    }) : nextThemeState;
    // CLEANUP: Remove. This blocks application of increased contrast themes
    // without the feature flag enabled.
    if (!(0, $2aEiL.fg)('platform_increased-contrast-themes')) {
        if (light === 'light-increased-contrast') light = 'light';
        if (dark === 'dark-increased-contrast') dark = 'dark';
    }
    const themeState = {
        colorMode: colorMode,
        contrastMode: contrastMode,
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography,
        motion: motion,
        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
    };
    // Determine what to load and loading strategy
    const themePreferences = (0, $2TWNJ.getThemePreferences)(themeState);
    const loadingStrategy = themeLoader ? themeLoader : (0, $faVsI.loadAndAppendThemeCss);
    // Load standard themes
    const loadingTasks = themePreferences.map(async (themeId)=>await loadingStrategy(themeId));
    const themeOverridePreferences = (0, $19yAB.getThemeOverridePreferences)(themeState);
    // Start loading override CSS before the first await. It is appended only after the standard
    // themes have loaded so that the override cascade order remains deterministic.
    const overrideThemeCssLoadingTasks = themeLoader ? [] : themeOverridePreferences.map((themeId)=>(0, $3R70r.loadThemeCss)(themeId));
    // Load custom themes if needed
    if (!themeLoader && UNSAFE_themeOptions && (0, $G4moy.isValidBrandHex)(UNSAFE_themeOptions?.brandColor)) {
        const mode = colorMode || (0, $j3ot2.themeStateDefaults)['colorMode'];
        const attrOfMissingCustomStyles = (0, $2Cuue.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
        loadingTasks.push((async ()=>{
            const { loadAndAppendCustomThemeCss: loadAndAppendCustomThemeCss } = await (parcelRequire("kfCL4"));
            loadAndAppendCustomThemeCss({
                colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                attrOfMissingCustomStyles[0],
                UNSAFE_themeOptions: UNSAFE_themeOptions
            });
        })());
    }
    await Promise.all(loadingTasks);
    // Load override themes after standard themes
    if (themeLoader) for (const themeId of themeOverridePreferences)await loadingStrategy(themeId);
    else {
        const overrideThemeCss = await Promise.all(overrideThemeCssLoadingTasks);
        await Promise.all(themeOverridePreferences.map((themeId, index)=>(0, $faVsI.loadAndAppendThemeCss)(themeId, overrideThemeCss[index])));
    }
    const autoUnbind = (0, $bblC7.default)(themeState);
    return autoUnbind;
};

});
parcelRegister("cgaUN", function(module, exports) {
$parcel$export(module.exports, "getGlobalTheme", () => $27604db4b33a1813$export$813ecdf77207a053);

var $21yAH = parcelRequire("21yAH");

var $kunMy = parcelRequire("kunMy");

var $anwEU = parcelRequire("anwEU");
const $27604db4b33a1813$export$813ecdf77207a053 = ()=>{
    if (typeof document === 'undefined') return {};
    const element = document.documentElement;
    const colorMode = element.getAttribute((0, $21yAH.COLOR_MODE_ATTRIBUTE)) || '';
    const theme = element.getAttribute((0, $21yAH.THEME_DATA_ATTRIBUTE)) || '';
    return {
        ...(0, $anwEU.themeStringToObject)(theme),
        ...(0, $kunMy.isThemeColorMode)(colorMode) && {
            colorMode: colorMode
        }
    };
};

});
parcelRegister("kunMy", function(module, exports) {
$parcel$export(module.exports, "isThemeColorMode", () => $152e6f9eed38715e$export$fcfb1976c88f9f75);

var $jbymH = parcelRequire("jbymH");
const $152e6f9eed38715e$export$fcfb1976c88f9f75 = (colorMode)=>{
    return (0, $jbymH.themeColorModes).find((mode)=>mode === colorMode) !== undefined;
};

});
parcelRegister("jbymH", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", () => $aad8be85ed571266$export$83993de8eb66733);
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ const $aad8be85ed571266$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];

});


parcelRegister("anwEU", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", () => $48cef401e2b6925b$export$f19b488f7c0547ee);

var $fcMBA = parcelRequire("fcMBA");

var $VJ5Z0 = parcelRequire("VJ5Z0");

var $lMeSE = parcelRequire("lMeSE");
const $48cef401e2b6925b$var$customThemeOptions = 'UNSAFE_themeOptions';
const $48cef401e2b6925b$export$f19b488f7c0547ee = (themeState)=>{
    return themeState.split(' ').map((theme)=>theme.split(/:(.*)/s)).reduce((themeObject, [kind, id])=>{
        if (kind === 'colorMode' && (0, $fcMBA.isColorMode)(id)) themeObject[kind] = id;
        if ((0, $lMeSE.isThemeKind)(kind) && (0, $VJ5Z0.isThemeIds)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $48cef401e2b6925b$var$customThemeOptions) try {
            themeObject[$48cef401e2b6925b$var$customThemeOptions] = JSON.parse(id);
        } catch  {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};

});


parcelRegister("bblC7", function(module, exports) {
$parcel$export(module.exports, "default", () => $73be6079969c2763$export$2e2bcd8739ae039);

var $2aEiL = parcelRequire("2aEiL");

var $4r3Q4 = parcelRequire("4r3Q4");

var $kGZGA = parcelRequire("kGZGA");

var $hqjx2 = parcelRequire("hqjx2");
function $73be6079969c2763$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $kGZGA.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $kGZGA.default).bind();
    } else (0, $kGZGA.default).unbind();
    if ((0, $2aEiL.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $hqjx2.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $hqjx2.default).bind();
        } else (0, $hqjx2.default).unbind();
    }
    const themeAttributes = (0, $4r3Q4.default)(themeState);
    Object.entries(themeAttributes).forEach(([key, value])=>{
        document.documentElement.setAttribute(key, value);
    });
    return ()=>{
        (0, $kGZGA.default).unbind();
        if ((0, $2aEiL.fg)('platform_increased-contrast-themes')) (0, $hqjx2.default).unbind();
    };
}

});
parcelRegister("kGZGA", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a1c5147d7a15cbd$export$2e2bcd8739ae039);

var $dmmsG = parcelRequire("dmmsG");

var $21yAH = parcelRequire("21yAH");

var $faVsI = parcelRequire("faVsI");
const $2a1c5147d7a15cbd$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $2a1c5147d7a15cbd$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $21yAH.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
const $2a1c5147d7a15cbd$var$darkModeMql = $2a1c5147d7a15cbd$var$isMatchMediaAvailable && window.matchMedia((0, $faVsI.darkModeMediaQuery));
class $2a1c5147d7a15cbd$var$ColorModeObserver {
    unbindThemeChangeListener = null;
    getColorMode() {
        if (!$2a1c5147d7a15cbd$var$darkModeMql) return 'light';
        return $2a1c5147d7a15cbd$var$darkModeMql?.matches ? 'dark' : 'light';
    }
    bind() {
        if ($2a1c5147d7a15cbd$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $dmmsG.bind)($2a1c5147d7a15cbd$var$darkModeMql, {
            type: 'change',
            listener: $2a1c5147d7a15cbd$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindThemeChangeListener) {
            this.unbindThemeChangeListener();
            this.unbindThemeChangeListener = null;
        }
    }
}
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $2a1c5147d7a15cbd$var$SingletonColorModeObserver = new $2a1c5147d7a15cbd$var$ColorModeObserver();
var $2a1c5147d7a15cbd$export$2e2bcd8739ae039 = $2a1c5147d7a15cbd$var$SingletonColorModeObserver;

});
parcelRegister("faVsI", function(module, exports) {
$parcel$export(module.exports, "loadAndAppendThemeCss", () => $01f7bf57d53cc3a4$export$26cd7ae85c7144e5);
$parcel$export(module.exports, "darkModeMediaQuery", () => $01f7bf57d53cc3a4$export$bb1e815119d30f8b);
$parcel$export(module.exports, "moreContrastMediaQuery", () => $01f7bf57d53cc3a4$export$8662df6937d86fcb);

var $21yAH = parcelRequire("21yAH");

var $3R70r = parcelRequire("3R70r");
const $01f7bf57d53cc3a4$export$26cd7ae85c7144e5 = async (themeId, preloadedThemeCss)=>{
    if (document.head.querySelector(`style[${(0, $21yAH.THEME_DATA_ATTRIBUTE)}="${themeId}"]:not([${(0, $21yAH.CUSTOM_THEME_ATTRIBUTE)}])`)) return;
    // Gracefully handles falsy values like `null` and `undefined` when maker ignore TS
    // to avoid loading default themes.
    if (!themeId) return;
    const themeCss = preloadedThemeCss ?? await (0, $3R70r.loadThemeCss)(themeId);
    const style = document.createElement('style');
    style.textContent = themeCss;
    style.dataset.theme = themeId;
    document.head.appendChild(style);
};
const $01f7bf57d53cc3a4$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
const $01f7bf57d53cc3a4$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("3R70r", function(module, exports) {
$parcel$export(module.exports, "loadThemeCss", () => $d1f3a79e33812296$export$8a48286ed7df6720);

var $eR5vK = parcelRequire("eR5vK");
const $d1f3a79e33812296$export$8a48286ed7df6720 = async (themeId)=>{
    const { default: themeCss } = await (0, $eR5vK.default)[themeId]();
    return themeCss;
};

});
parcelRegister("eR5vK", function(module, exports) {
$parcel$export(module.exports, "themeImportMap", () => $56d63eaf46707399$export$3a171c49f8c16356);
$parcel$export(module.exports, "default", () => $56d63eaf46707399$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::53ff14285f7c9bd19729a6820212b645>>
 * @codegenCommand yarn build tokens
 */ 




















const $56d63eaf46707399$export$3a171c49f8c16356 = {
    'light': ()=>(parcelRequire("lML70")),
    'light-future': ()=>(parcelRequire("cTYTH")),
    'light-finesse': ()=>(parcelRequire("ec3mZ")),
    'light-increased-contrast-finesse': ()=>(parcelRequire("1nbt0")),
    'light-increased-contrast': ()=>(parcelRequire("7zhDg")),
    'UNSAFE-dynamic': ()=>(parcelRequire("brEF6")),
    'UNSAFE-dynamic-dark': ()=>(parcelRequire("6WPAo")),
    'UNSAFE-test-light': ()=>(parcelRequire("6maXH")),
    'UNSAFE-test-dark': ()=>(parcelRequire("l7XWf")),
    'dark': ()=>(parcelRequire("bNppg")),
    'dark-future': ()=>(parcelRequire("7SHey")),
    'dark-finesse': ()=>(parcelRequire("7Lt01")),
    'dark-increased-contrast-finesse': ()=>(parcelRequire("js1Vi")),
    'dark-increased-contrast': ()=>(parcelRequire("iEa76")),
    'spacing': ()=>(parcelRequire("a3bb0")),
    'UNSAFE-spacing': ()=>(parcelRequire("fxSWh")),
    'typography': ()=>(parcelRequire("i0DmX")),
    'UNSAFE-typography': ()=>(parcelRequire("7ZtbC")),
    'typography-finesse': ()=>(parcelRequire("7WOSR")),
    'shape': ()=>(parcelRequire("1ugFm")),
    'motion': ()=>(parcelRequire("99hb7"))
};
var $56d63eaf46707399$export$2e2bcd8739ae039 = $56d63eaf46707399$export$3a171c49f8c16356;

});
parcelRegister("lML70", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("7zVae").then(()=>parcelRequire('3Gr7K'));

});

parcelRegister("cTYTH", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("iJlYY").then(()=>parcelRequire('8K59U'));

});

parcelRegister("ec3mZ", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("dQybu").then(()=>parcelRequire('fWFRB'));

});

parcelRegister("1nbt0", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("a2QCb").then(()=>parcelRequire('fAEmL'));

});

parcelRegister("7zhDg", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("62F3k").then(()=>parcelRequire('6aA9I'));

});

parcelRegister("brEF6", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("cwL6c").then(()=>parcelRequire('dxYAt'));

});

parcelRegister("6WPAo", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("hjWNG").then(()=>parcelRequire('jnBOh'));

});

parcelRegister("6maXH", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("fFq3b").then(()=>parcelRequire('fdYsG'));

});

parcelRegister("l7XWf", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("6ulfq").then(()=>parcelRequire('aOJpu'));

});

parcelRegister("bNppg", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("bBfMW").then(()=>parcelRequire('865gV'));

});

parcelRegister("7SHey", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("9Doej").then(()=>parcelRequire('fx9Vc'));

});

parcelRegister("7Lt01", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("9pxvm").then(()=>parcelRequire('2xCxS'));

});

parcelRegister("js1Vi", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("hCoJa").then(()=>parcelRequire('bpTU4'));

});

parcelRegister("iEa76", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("1GbqL").then(()=>parcelRequire('gjVTm'));

});

parcelRegister("a3bb0", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("eh1a0").then(()=>parcelRequire('a2gva'));

});

parcelRegister("fxSWh", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("9amaM").then(()=>parcelRequire('8cwcL'));

});

parcelRegister("i0DmX", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("4btGb").then(()=>parcelRequire('7yomw'));

});

parcelRegister("7ZtbC", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("2Qx2x").then(()=>parcelRequire('gfpq2'));

});

parcelRegister("7WOSR", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("eqSM6").then(()=>parcelRequire('lAXDI'));

});

parcelRegister("1ugFm", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("2depd").then(()=>parcelRequire('kHC6H'));

});

parcelRegister("99hb7", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("g7Wzp").then(()=>parcelRequire('6q7AY'));

});





parcelRegister("hqjx2", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cad10cccd5b8177$export$2e2bcd8739ae039);

var $dmmsG = parcelRequire("dmmsG");

var $21yAH = parcelRequire("21yAH");

var $faVsI = parcelRequire("faVsI");
const $2cad10cccd5b8177$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $2cad10cccd5b8177$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $21yAH.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
const $2cad10cccd5b8177$var$contrastModeMql = $2cad10cccd5b8177$var$isMatchMediaAvailable && window.matchMedia((0, $faVsI.moreContrastMediaQuery));
class $2cad10cccd5b8177$var$ContrastModeObserver {
    unbindContrastChangeListener = null;
    getContrastMode() {
        if (!$2cad10cccd5b8177$var$contrastModeMql) return 'no-preference';
        return $2cad10cccd5b8177$var$contrastModeMql?.matches ? 'more' : 'no-preference';
    }
    bind() {
        if ($2cad10cccd5b8177$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $dmmsG.bind)($2cad10cccd5b8177$var$contrastModeMql, {
            type: 'change',
            listener: $2cad10cccd5b8177$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindContrastChangeListener) {
            this.unbindContrastChangeListener();
            this.unbindContrastChangeListener = null;
        }
    }
}
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $2cad10cccd5b8177$var$SingletonContrastModeObserver = new $2cad10cccd5b8177$var$ContrastModeObserver();
var $2cad10cccd5b8177$export$2e2bcd8739ae039 = $2cad10cccd5b8177$var$SingletonContrastModeObserver;

});


parcelRegister("2Cuue", function(module, exports) {
$parcel$export(module.exports, "findMissingCustomStyleElements", () => $635af4f85bb802f7$export$bd1ac9300b0e885a);

var $21yAH = parcelRequire("21yAH");

var $4Meqh = parcelRequire("4Meqh");
function $635af4f85bb802f7$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    const optionString = JSON.stringify(UNSAFE_themeOptions);
    const uniqueId = (0, $4Meqh.hash)(optionString);
    const attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach((themeId)=>{
        const element = document.head.querySelector(`style[${(0, $21yAH.CUSTOM_THEME_ATTRIBUTE)}="${uniqueId}"][${(0, $21yAH.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}

});

parcelRegister("19yAB", function(module, exports) {
$parcel$export(module.exports, "getThemeOverridePreferences", () => $3921ba61a8ebecb8$export$5d76d7014f4a5d08);

var $2aEiL = parcelRequire("2aEiL");

var $jM9Uu = parcelRequire("jM9Uu");
const $3921ba61a8ebecb8$var$finesseOverrides = {
    light: 'light-finesse',
    'light-increased-contrast': 'light-increased-contrast-finesse',
    dark: 'dark-finesse',
    'dark-increased-contrast': 'dark-increased-contrast-finesse',
    typography: 'typography-finesse'
};
const $3921ba61a8ebecb8$export$5d76d7014f4a5d08 = (themeState)=>{
    if (!(0, $2aEiL.fg)('platform-dst-tokens-finesse')) return [];
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, typography: typography } = themeState;
    const selectedThemes = [
        ...colorMode === 'auto' ? [
            light,
            dark
        ] : [
            themeState[colorMode]
        ],
        typography
    ];
    if (contrastMode !== 'no-preference' && (0, $2aEiL.fg)('platform_increased-contrast-themes')) selectedThemes.forEach((themeId)=>{
        const increasedContrastTheme = (0, $jM9Uu.default)(themeId);
        if (increasedContrastTheme) selectedThemes.push(increasedContrastTheme);
    });
    const themeOverridePreferences = selectedThemes.map((themeId)=>$3921ba61a8ebecb8$var$finesseOverrides[themeId]).filter((themeId)=>themeId !== undefined);
    return [
        ...new Set(themeOverridePreferences)
    ];
};

});
parcelRegister("jM9Uu", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd9e33e8358a7933$export$2e2bcd8739ae039);

var $j750x = parcelRequire("j750x");
function $cd9e33e8358a7933$export$2e2bcd8739ae039(themeId) {
    return Object.entries((0, $j750x.default)).find(([, { increasesContrastFor: increasesContrastFor }])=>{
        return increasesContrastFor === themeId;
    })?.[1].id;
}

});
parcelRegister("j750x", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9791af1a358b5e9$export$2e2bcd8739ae039);
/**
 * This file contains the source of truth for themes and all associated meta data.
 */ 
var $fdGCC = parcelRequire("fdGCC");


/**
 * Contrast preferences: The system contrast preference
 */ const $b9791af1a358b5e9$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
const $b9791af1a358b5e9$export$ba8a43b83ecc69f8 = [
    'light-finesse',
    'light-increased-contrast-finesse',
    'dark-finesse',
    'dark-increased-contrast-finesse',
    'typography-finesse'
];
const $b9791af1a358b5e9$export$92ba366331403db2 = [
    ...(0, $fdGCC.themeIds),
    ...$b9791af1a358b5e9$export$ba8a43b83ecc69f8
];
const $b9791af1a358b5e9$export$9d64ff89b6869900 = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-finesse': {
        id: 'light-finesse',
        displayName: 'FY27 Finesse Light Theme Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast-finesse': {
        id: 'light-increased-contrast-finesse',
        displayName: 'FY27 Finesse Light Theme (increased contrast) Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light-increased-contrast'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'UNSAFE-dynamic': {
        id: 'UNSAFE-dynamic',
        displayName: 'UNSAFE Dynamic Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light'
    },
    'UNSAFE-dynamic-dark': {
        id: 'UNSAFE-dynamic-dark',
        displayName: 'UNSAFE Dynamic Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark'
    },
    'UNSAFE-test-light': {
        id: 'UNSAFE-test-light',
        displayName: 'UNSAFE Test Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light'
    },
    'UNSAFE-test-dark': {
        id: 'UNSAFE-test-dark',
        displayName: 'UNSAFE Test Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-finesse': {
        id: 'dark-finesse',
        displayName: 'FY27 Finesse Dark Theme Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'dark'
    },
    'atlassian-dark-increased-contrast-finesse': {
        id: 'dark-increased-contrast-finesse',
        displayName: 'FY27 Finesse Dark Theme (increased contrast) Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'dark-increased-contrast'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'UNSAFE-spacing': {
        id: 'UNSAFE-spacing',
        displayName: 'UNSAFE Dynamic Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        },
        extends: 'spacing'
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'UNSAFE-typography': {
        id: 'UNSAFE-typography',
        displayName: 'UNSAFE Dynamic Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        },
        extends: 'typography'
    },
    'atlassian-typography-finesse': {
        id: 'typography-finesse',
        displayName: 'FY27 Finesse Typography Override',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        },
        override: 'typography'
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b9791af1a358b5e9$export$2e2bcd8739ae039 = $b9791af1a358b5e9$export$9d64ff89b6869900;

});



parcelRegister("2TWNJ", function(module, exports) {
$parcel$export(module.exports, "getThemePreferences", () => $3b010900218c5883$export$dd6aeb7c823fc03d);

var $2aEiL = parcelRequire("2aEiL");

var $jM9Uu = parcelRequire("jM9Uu");
const $3b010900218c5883$export$dd6aeb7c823fc03d = (themeState)=>{
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, shape: shape, spacing: spacing, typography: typography, motion: motion } = themeState;
    const autoColorModeThemes = [
        light,
        dark
    ];
    const themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $2aEiL.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach((normalTheme)=>{
            const increasedContrastTheme = (0, $jM9Uu.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push(...autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $2aEiL.fg)('platform_increased-contrast-themes')) {
            const increasedContrastTheme = (0, $jM9Uu.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach((themeId)=>{
        if (themeId) themePreferences.push(themeId);
    });
    return [
        ...new Set(themePreferences)
    ];
};

});

parcelRegister("kfCL4", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("jPGtX"),
    $7mhPs("1TJHk")
]).then(()=>parcelRequire('YyYQE'));

});


parcelRegister("afqYt", function(module, exports) {
$parcel$export(module.exports, "useIsAppProviderThemingEnabled", () => $a43b430d1b1c8b6f$export$a782702263f77544);

var $1v5pe = parcelRequire("1v5pe");

var $8vj5e = parcelRequire("8vj5e");
const $a43b430d1b1c8b6f$export$a782702263f77544 = ()=>{
    return (0, $1v5pe.useContext)((0, $8vj5e.AppProviderThemingEnabledContext));
};

});
parcelRegister("8vj5e", function(module, exports) {
$parcel$export(module.exports, "AppProviderThemingEnabledContext", () => $80c508a0dfc50308$export$d2def9838ca456c0);

var $1v5pe = parcelRequire("1v5pe");
const $80c508a0dfc50308$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $1v5pe.createContext)(false);

});


parcelRegister("h8JSM", function(module, exports) {
$parcel$export(module.exports, "useIsInsideAppProvider", () => $52b30feed3a8dd6b$export$26aa23367bfbab0e);

var $1v5pe = parcelRequire("1v5pe");

var $GByrF = parcelRequire("GByrF");
const $52b30feed3a8dd6b$export$26aa23367bfbab0e = ()=>{
    return (0, $1v5pe.useContext)((0, $GByrF.InsideAppProviderContext));
};

});
parcelRegister("GByrF", function(module, exports) {
$parcel$export(module.exports, "InsideAppProviderContext", () => $a279345e9f0b24b9$export$7981b2444296e410);

var $1v5pe = parcelRequire("1v5pe");
const $a279345e9f0b24b9$export$7981b2444296e410 = /*#__PURE__*/ (0, $1v5pe.createContext)(false);

});


parcelRegister("lmUZy", function(module, exports) {
$parcel$export(module.exports, "ColorModeContext", () => $d079da823ccd1c48$export$49ddd74a6729fdb0);

var $1v5pe = parcelRequire("1v5pe");
const $d079da823ccd1c48$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);

});

parcelRegister("5mHvF", function(module, exports) {
$parcel$export(module.exports, "InsideThemeProviderContext", () => $e93f4f6c2884ddca$export$332347eeb335453c);

var $1v5pe = parcelRequire("1v5pe");
const $e93f4f6c2884ddca$export$332347eeb335453c = /*#__PURE__*/ (0, $1v5pe.createContext)(false);

});

parcelRegister("8BkRv", function(module, exports) {
$parcel$export(module.exports, "SetColorModeContext", () => $d42f7228d2fc514d$export$b06130bad0bbc70f);

var $1v5pe = parcelRequire("1v5pe");
const $d42f7228d2fc514d$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);

});

parcelRegister("7HPJy", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => $1b3a376b23d4ee5c$export$2c657da244d00bd6);
$parcel$export(module.exports, "SetThemeContext", () => $1b3a376b23d4ee5c$export$f7a97b47760e2a13);

var $1v5pe = parcelRequire("1v5pe");
const $1b3a376b23d4ee5c$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);
const $1b3a376b23d4ee5c$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);

});

parcelRegister("j4OG8", function(module, exports) {
$parcel$export(module.exports, "useIsInsideThemeProvider", () => $11561564bfcb268a$export$7ca11437599d653d);

var $1v5pe = parcelRequire("1v5pe");

var $5mHvF = parcelRequire("5mHvF");
const $11561564bfcb268a$export$7ca11437599d653d = ()=>{
    return (0, $1v5pe.useContext)((0, $5mHvF.InsideThemeProviderContext)) ?? false;
};

});

parcelRegister("bbF2a", function(module, exports) {
$parcel$export(module.exports, "getInlineThemeStyles", () => $f696be6d41b71766$export$ae40e6ba718781b9);

var $1v5pe = parcelRequire("1v5pe");

var $eR5vK = parcelRequire("eR5vK");

var $19yAB = parcelRequire("19yAB");

var $2TWNJ = parcelRequire("2TWNJ");
const $f696be6d41b71766$var$themeCssPromises = new Map();
function $f696be6d41b71766$var$getThemeCssPromise(themeId) {
    let themeCssPromise = $f696be6d41b71766$var$themeCssPromises.get(themeId);
    if (!themeCssPromise) {
        themeCssPromise = (0, $eR5vK.themeImportMap)[themeId]().then(({ default: css })=>css);
        $f696be6d41b71766$var$themeCssPromises.set(themeId, themeCssPromise);
    }
    return themeCssPromise;
}
function $f696be6d41b71766$var$getInlineThemeCss(themeId) {
    const reactUse = (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).use;
    const isServer = globalThis.__SERVER__ === true || typeof document === 'undefined';
    if (isServer) return reactUse?.($f696be6d41b71766$var$getThemeCssPromise(themeId));
    return document.body.querySelector(`style[data-theme="${themeId}"]`)?.textContent ?? undefined;
}
function $f696be6d41b71766$export$ae40e6ba718781b9(theme, colorMode) {
    const themeState = {
        ...theme,
        colorMode: colorMode,
        contrastMode: 'no-preference'
    };
    const themeIds = [
        ...(0, $2TWNJ.getThemePreferences)(themeState),
        ...(0, $19yAB.getThemeOverridePreferences)(themeState)
    ];
    return [
        ...new Set(themeIds)
    ].map((themeId)=>{
        const css = $f696be6d41b71766$var$getInlineThemeCss(themeId);
        return css ? {
            id: themeId,
            css: css
        } : undefined;
    }).filter((style)=>style !== undefined);
}

});

parcelRegister("juHZq", function(module, exports) {
$parcel$export(module.exports, "loadAndMountThemes", () => $d1b87b2909162c9e$export$7d4a7e812d176b24);

var $brxde = parcelRequire("brxde");

var $2aEiL = parcelRequire("2aEiL");

var $eR5vK = parcelRequire("eR5vK");

var $19yAB = parcelRequire("19yAB");

var $2TWNJ = parcelRequire("2TWNJ");

var $bBDno = parcelRequire("bBDno");
const $d1b87b2909162c9e$var$loadThemeCss = async (themeId)=>{
    // Prevent duplicate loading of themes
    if ((0, $bBDno.isThemeMounted)(themeId)) return;
    // Gracefully handles falsy values like `null` and `undefined` when makers ignore
    // TS to avoid loading default themes.
    if (!themeId) return;
    const { default: themeCss } = await (0, $eR5vK.themeImportMap)[themeId]();
    return themeCss;
};
const $d1b87b2909162c9e$var$mountThemeCss = (css, themeId)=>{
    // SSR-safe: Only mount on client side
    const doc = (0, $brxde.getDocument)();
    if (!doc) return;
    const style = doc.createElement('style');
    style.textContent = css;
    style.dataset.theme = themeId;
    // Prevent duplicate mounting of themes.
    // It's possible the theme was already being loaded elsewhere.
    if ((0, $bBDno.isThemeMounted)(themeId)) return;
    doc.head.appendChild(style);
};
const $d1b87b2909162c9e$var$loadAndMountThemeCss = async (themeId)=>{
    const themeCss = await $d1b87b2909162c9e$var$loadThemeCss(themeId);
    if (!themeCss) return;
    $d1b87b2909162c9e$var$mountThemeCss(themeCss, themeId);
};
const $d1b87b2909162c9e$export$7d4a7e812d176b24 = async (theme)=>{
    if ((0, $2aEiL.fg)('platform-dst-tokens-finesse')) {
        const themeState = {
            ...theme,
            // Keep both configured color themes available for subtree color-mode changes.
            colorMode: 'auto',
            contrastMode: 'no-preference'
        };
        const themeIds = [
            ...new Set([
                ...(0, $2TWNJ.getThemePreferences)(themeState),
                ...(0, $19yAB.getThemeOverridePreferences)(themeState)
            ])
        ];
        const themes = await Promise.allSettled(themeIds.map(async (id)=>({
                id: id,
                css: await $d1b87b2909162c9e$var$loadThemeCss(id)
            })));
        // Imports may resolve in any order. Mount bases before overrides, even when
        // multiple providers are loading the same styles at the same time. A failed
        // import must not prevent successfully loaded styles from mounting.
        themes.forEach((result)=>{
            if (result.status === 'fulfilled' && result.value.css) $d1b87b2909162c9e$var$mountThemeCss(result.value.css, result.value.id);
        });
        return;
    }
    const themesToLoad = Object.values(theme).filter((themeId)=>!!themeId);
    themesToLoad.forEach($d1b87b2909162c9e$var$loadAndMountThemeCss);
};

});
parcelRegister("bBDno", function(module, exports) {
$parcel$export(module.exports, "isThemeMounted", () => $8bc934693eb31466$export$835a0dc855d02822);

var $brxde = parcelRequire("brxde");

var $21yAH = parcelRequire("21yAH");
function $8bc934693eb31466$export$835a0dc855d02822(themeId) {
    const doc = (0, $brxde.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector(`style[${(0, $21yAH.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
}

});



parcelRegister("8RTDE", function(module, exports) {
$parcel$export(module.exports, "useColorMode", () => $546d87d06153ebf6$export$20f3076712c8dfa);

var $1v5pe = parcelRequire("1v5pe");

var $cgaUN = parcelRequire("cgaUN");

var $j5RGe = parcelRequire("j5RGe");

var $lmUZy = parcelRequire("lmUZy");
function $546d87d06153ebf6$export$20f3076712c8dfa() {
    const value = (0, $1v5pe.useContext)((0, $lmUZy.ColorModeContext));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    const theme = (0, $cgaUN.getGlobalTheme)();
    const [resolvedColorMode, setResolvedColorMode] = (0, $1v5pe.useState)(theme?.colorMode || 'light');
    (0, $1v5pe.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        const observer = new (0, $j5RGe.ThemeMutationObserver)((theme)=>{
            setResolvedColorMode(theme?.colorMode || 'light');
        });
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}

});
parcelRegister("j5RGe", function(module, exports) {
$parcel$export(module.exports, "ThemeMutationObserver", () => $b03a10dc09d07869$export$b741a7c3bcb1c635);
$parcel$export(module.exports, "default", () => $b03a10dc09d07869$export$2e2bcd8739ae039);

var $21yAH = parcelRequire("21yAH");

var $cgaUN = parcelRequire("cgaUN");
class $b03a10dc09d07869$export$b741a7c3bcb1c635 {
    legacyObserver = null;
    static observer = null;
    static callbacks = new Set();
    callback;
    constructor(callback){
        this.callback = callback;
        $b03a10dc09d07869$export$b741a7c3bcb1c635.callbacks.add(callback);
    }
    observe() {
        if (!$b03a10dc09d07869$export$b741a7c3bcb1c635.observer) {
            $b03a10dc09d07869$export$b741a7c3bcb1c635.observer = new MutationObserver(()=>{
                const theme = (0, $cgaUN.getGlobalTheme)();
                $b03a10dc09d07869$export$b741a7c3bcb1c635.callbacks.forEach((callback)=>callback(theme));
            });
            // Observer only needs to be configured once
            $b03a10dc09d07869$export$b741a7c3bcb1c635.observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, $21yAH.THEME_DATA_ATTRIBUTE),
                    (0, $21yAH.COLOR_MODE_ATTRIBUTE)
                ]
            });
        }
    }
    disconnect() {
        if (this.callback) $b03a10dc09d07869$export$b741a7c3bcb1c635.callbacks.delete(this.callback);
        if ($b03a10dc09d07869$export$b741a7c3bcb1c635.callbacks.size === 0 && $b03a10dc09d07869$export$b741a7c3bcb1c635.observer) {
            $b03a10dc09d07869$export$b741a7c3bcb1c635.observer.disconnect();
            $b03a10dc09d07869$export$b741a7c3bcb1c635.observer = null;
        }
    }
}
var $b03a10dc09d07869$export$2e2bcd8739ae039 = $b03a10dc09d07869$export$b741a7c3bcb1c635;

});


parcelRegister("hDdFl", function(module, exports) {
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $1079aa3b54008ce0$export$c582005add11e141);

var $j0uoe = parcelRequire("j0uoe");

var $h6gqD = parcelRequire("h6gqD");
const $1079aa3b54008ce0$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $j0uoe.portalParentSelector));
    if (!parentElement) {
        const parent = document.createElement('div');
        parent.className = (0, $j0uoe.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (0, $h6gqD.getBody)()?.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $1079aa3b54008ce0$export$c582005add11e141 = (container)=>{
    if (!container.parentElement) $1079aa3b54008ce0$var$getPortalParent().appendChild(container);
};

});
parcelRegister("j0uoe", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", () => $dfd6d552de789486$export$e4c79eb95c23a0da);
$parcel$export(module.exports, "portalParentSelector", () => $dfd6d552de789486$export$72f415121273627e);
$parcel$export(module.exports, "portalClassName", () => $dfd6d552de789486$export$13f57c02915787b3);
const $dfd6d552de789486$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $dfd6d552de789486$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $dfd6d552de789486$export$13f57c02915787b3 = 'atlaskit-portal';

});

parcelRegister("h6gqD", function(module, exports) {
$parcel$export(module.exports, "getBody", () => $e2d5d558cf1ecea2$export$135b49d4bc2964c6);
/**
 * Returns document body element
 * @return {number} - The document body element
 */ const $e2d5d558cf1ecea2$export$135b49d4bc2964c6 = ()=>{
    return document.body;
};

});


parcelRegister("4tTzL", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $31cb62d45358de99$export$26ae5ca175b4ec5a);

var $j0uoe = parcelRequire("j0uoe");
const $31cb62d45358de99$export$26ae5ca175b4ec5a = (zIndex)=>{
    const container = document.createElement('div');
    container.className = (0, $j0uoe.portalClassName);
    container.style.zIndex = `${zIndex}`;
    return container;
};

});

parcelRegister("2bmkj", function(module, exports) {
$parcel$export(module.exports, "removePortalContainer", () => $fc839aa4c0821059$export$da99f98bf3fe55b3);

var $j0uoe = parcelRequire("j0uoe");

var $h6gqD = parcelRequire("h6gqD");
const $fc839aa4c0821059$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $j0uoe.portalParentSelector));
    if (!parentElement) {
        const parent = document.createElement('div');
        parent.className = (0, $j0uoe.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (0, $h6gqD.getBody)()?.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $fc839aa4c0821059$export$da99f98bf3fe55b3 = (container)=>{
    const parent = $fc839aa4c0821059$var$getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};

});


parcelRegister("bN0sf", function(module, exports) {
$parcel$export(module.exports, "default", () => $2277d8559cae28b7$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $fBuCt = parcelRequire("fBuCt");

var $5jHNN = parcelRequire("5jHNN");

var $8RTDE = parcelRequire("8RTDE");

var $j4OG8 = parcelRequire("j4OG8");

var $dnkZZ = parcelRequire("dnkZZ");

var $apeeS = parcelRequire("apeeS");

var $arHWP = parcelRequire("arHWP");

var $kIqwl = parcelRequire("kIqwl");
function $2277d8559cae28b7$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const [atlaskitPortal, setAtlaskitPortal] = (0, $1v5pe.useState)(null);
    const colorMode = (0, $8RTDE.useColorMode)();
    const isInsideThemeProvider = (0, $j4OG8.useIsInsideThemeProvider)();
    (0, $dnkZZ.useIsomorphicLayoutEffect)(()=>{
        const tempPortalContainer = (0, $apeeS.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        const portalParent = (0, $arHWP.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return ()=>{
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ const suspendedChildren = /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1v5pe.Suspense), {
        fallback: null,
        children: isInsideThemeProvider ? /*#__PURE__*/ (0, $kIqwl.jsx)((0, $5jHNN.ThemeProvider), {
            defaultColorMode: colorMode,
            children: children
        }) : children
    });
    return atlaskitPortal ? /*#__PURE__*/ (0, $fBuCt.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("dnkZZ", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $52e37eeb365df91e$export$700979bc83e7db82);

var $1v5pe = parcelRequire("1v5pe");
const $52e37eeb365df91e$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $1v5pe.useLayoutEffect) : (0, $1v5pe.useEffect);

});

parcelRegister("apeeS", function(module, exports) {
$parcel$export(module.exports, "createAtlaskitPortal", () => $8f615b93dc62b7c6$export$fef014d7cef9e543);

var $j0uoe = parcelRequire("j0uoe");
const $8f615b93dc62b7c6$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $8f615b93dc62b7c6$export$fef014d7cef9e543 = (zIndex)=>{
    //atlaskit-portal div
    if ($8f615b93dc62b7c6$var$isDocumentDefined()) {
        const atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $j0uoe.portalClassName);
        atlaskitportal.style.zIndex = `${zIndex}`;
        return atlaskitportal;
    }
    return;
};

});

parcelRegister("arHWP", function(module, exports) {
$parcel$export(module.exports, "createPortalParent", () => $96bbeadc1bd84458$export$95029ca7aca2989e);

var $j0uoe = parcelRequire("j0uoe");

var $h6gqD = parcelRequire("h6gqD");
const $96bbeadc1bd84458$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $96bbeadc1bd84458$export$95029ca7aca2989e = ()=>{
    //atlaskit-portal-container div
    if ($96bbeadc1bd84458$var$isDocumentDefined()) {
        const parentElement = document.querySelector((0, $j0uoe.portalParentSelector));
        if (!parentElement) {
            const parent = document.createElement('div');
            parent.className = (0, $j0uoe.portalParentClassName);
            parent.style.display = 'flex';
            (0, $h6gqD.getBody)()?.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});


parcelRegister("3QZA6", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bb280d34ee64de2$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $dnkZZ = parcelRequire("dnkZZ");
const $2bb280d34ee64de2$var$useIsSubsequentRender = (mountStrategy)=>{
    const [isSubsequentRender, setIsSubsequentRender] = (0, $1v5pe.useState)(false);
    const [useMountEffect] = (0, $1v5pe.useState)(()=>mountStrategy === 'layoutEffect' ? (0, $dnkZZ.useIsomorphicLayoutEffect) : (0, $1v5pe.useEffect));
    useMountEffect(()=>{
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $2bb280d34ee64de2$export$2e2bcd8739ae039 = $2bb280d34ee64de2$var$useIsSubsequentRender;

});

parcelRegister("lAu9T", function(module, exports) {
$parcel$export(module.exports, "default", () => $de33ba5f83273580$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $2UqFH = parcelRequire("2UqFH");

var $4WJY0 = parcelRequire("4WJY0");
const $de33ba5f83273580$var$useFirePortalEvent = (zIndex)=>{
    const zIndexNumber = Number(zIndex);
    (0, $1v5pe.useEffect)(()=>{
        (0, $4WJY0.default)((0, $2UqFH.PORTAL_MOUNT_EVENT), zIndexNumber);
        return ()=>{
            (0, $4WJY0.default)((0, $2UqFH.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $de33ba5f83273580$export$2e2bcd8739ae039 = $de33ba5f83273580$var$useFirePortalEvent;

});
parcelRegister("2UqFH", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", () => $ce9b76b027e7b6ab$export$ed5835cc67e87f72);
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", () => $ce9b76b027e7b6ab$export$80816bd900e5bd00);
/**
 * @deprecated Top-layer surfaces do not fire portal events. To know when a top-layer surface opens
 * or closes, listen for the native `toggle` and `close` events.
 */ const $ce9b76b027e7b6ab$export$ed5835cc67e87f72 = 'akPortalMount';
const $ce9b76b027e7b6ab$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("4WJY0", function(module, exports) {
$parcel$export(module.exports, "default", () => $87a8f62755f6e8a0$export$2e2bcd8739ae039);
const $87a8f62755f6e8a0$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ const $87a8f62755f6e8a0$var$getLayerName = (zIndex)=>{
    return $87a8f62755f6e8a0$var$zIndexToName.hasOwnProperty(zIndex) ? $87a8f62755f6e8a0$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ const $87a8f62755f6e8a0$var$getEvent = (eventName, zIndex)=>{
    const detail = {
        layer: $87a8f62755f6e8a0$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $87a8f62755f6e8a0$export$2e2bcd8739ae039(eventName, zIndex) {
    const event = $87a8f62755f6e8a0$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("iMM0r", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $3p2SC = parcelRequire("3p2SC");
module.exports = Object.assign({}, $3p2SC, {
    gridSize: ()=>8,
    borderRadius: ()=>3,
    fontSize: ()=>14,
    fontSizeSmall: ()=>11
});
if ($3p2SC.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});
parcelRegister("3p2SC", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", () => $8129bc8db99db09d$export$44ffba16bd48dac6);
$parcel$export(module.exports, "DEFAULT_THEME_MODE", () => $8129bc8db99db09d$export$c93026a968943f95);
$parcel$export(module.exports, "THEME_MODES", () => $8129bc8db99db09d$export$6ba72c8346b4c57e);
$parcel$export(module.exports, "layers", () => $8129bc8db99db09d$export$7be255094ccdc533);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $8129bc8db99db09d$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
const $8129bc8db99db09d$export$c93026a968943f95 = 'light';
const $8129bc8db99db09d$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
const $8129bc8db99db09d$export$7be255094ccdc533 = {
    card: ()=>100,
    navigation: ()=>200,
    dialog: ()=>300,
    layer: ()=>400,
    blanket: ()=>500,
    modal: ()=>510,
    flag: ()=>600,
    spotlight: ()=>700,
    tooltip: ()=>9999
};

});


parcelRegister("4XO6k", function(module, exports) {
$parcel$export(module.exports, "DefaultRoleContext", () => $a7725ae85fc67576$export$acf85578b9060d4d);
$parcel$export(module.exports, "useDefaultRole", () => $a7725ae85fc67576$export$940503e6d676c973);

var $1v5pe = parcelRequire("1v5pe");
const $a7725ae85fc67576$export$acf85578b9060d4d = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);
function $a7725ae85fc67576$export$940503e6d676c973() {
    return (0, $1v5pe.useContext)($a7725ae85fc67576$export$acf85578b9060d4d);
}

});

parcelRegister("lsSZw", function(module, exports) {
$parcel$export(module.exports, "register", () => $f837e5363f08245a$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $dmmsG = parcelRequire("dmmsG");
const $f837e5363f08245a$var$registrations = new Set();
let $f837e5363f08245a$var$cleanupEndEventListeners = null;
function $f837e5363f08245a$var$onDragStart() {
    if ($f837e5363f08245a$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $f837e5363f08245a$var$cleanupEndEventListeners = (0, $dmmsG.bindAll)(window, [
        {
            type: 'dragend',
            listener: $f837e5363f08245a$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $f837e5363f08245a$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $f837e5363f08245a$var$onDragEnd();
                };
            })()
        }
    ]);
    const clone = Array.from($f837e5363f08245a$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragStart();
    });
}
function $f837e5363f08245a$var$onDragEnd() {
    $f837e5363f08245a$var$cleanupEndEventListeners?.();
    $f837e5363f08245a$var$cleanupEndEventListeners = null;
    const clone = Array.from($f837e5363f08245a$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragEnd();
    });
}
function $f837e5363f08245a$var$bindStartEvents() {
    return (0, $dmmsG.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $f837e5363f08245a$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $f837e5363f08245a$var$onDragStart
        }
    ]);
}
let $f837e5363f08245a$var$cleanupStartEventListeners = null;
function $f837e5363f08245a$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$f837e5363f08245a$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $f837e5363f08245a$var$cleanupStartEventListeners = $f837e5363f08245a$var$bindStartEvents();
    $f837e5363f08245a$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $f837e5363f08245a$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $f837e5363f08245a$var$registrations.delete(registration);
        if ($f837e5363f08245a$var$registrations.size === 0) {
            $f837e5363f08245a$var$cleanupStartEventListeners?.();
            $f837e5363f08245a$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("6wPh7", function(module, exports) {
$parcel$export(module.exports, "getAnchorPoint", () => $d52dbe3ee000f9bb$export$d26fd3d066ede49);
/**
 * Returns the trigger's X edge for inline-axis placements, or the
 * trigger's horizontal center for block-axis placements.
 *
 * Note: does not account for RTL writing modes.
 */ function $d52dbe3ee000f9bb$var$getTriggerEdgeX({ triggerRect: triggerRect, placement: placement }) {
    if (placement.axis === 'inline') return placement.edge === 'start' ? triggerRect.left : triggerRect.right;
    return triggerRect.left + triggerRect.width / 2;
}
/**
 * Returns the trigger's Y edge for block-axis placements, or the
 * trigger's vertical center for inline-axis placements.
 */ function $d52dbe3ee000f9bb$var$getTriggerEdgeY({ triggerRect: triggerRect, placement: placement }) {
    if (placement.axis === 'block') return placement.edge === 'start' ? triggerRect.top : triggerRect.bottom;
    return triggerRect.top + triggerRect.height / 2;
}
function $d52dbe3ee000f9bb$export$d26fd3d066ede49({ cursor: cursor, triggerRect: triggerRect, tooltipPosition: tooltipPosition, placement: placement }) {
    if (tooltipPosition === 'mouse-y') return {
        x: $d52dbe3ee000f9bb$var$getTriggerEdgeX({
            triggerRect: triggerRect,
            placement: placement
        }),
        y: cursor.clientY
    };
    if (tooltipPosition === 'mouse-x') return {
        x: cursor.clientX,
        y: $d52dbe3ee000f9bb$var$getTriggerEdgeY({
            triggerRect: triggerRect,
            placement: placement
        })
    };
    // tooltipPosition === 'mouse'
    return {
        x: cursor.clientX,
        y: cursor.clientY
    };
}

});

parcelRegister("dgDxP", function(module, exports) {
$parcel$export(module.exports, "getVirtualElementFromMousePos", () => $fd6c703b693725e3$export$2e68479e0a5d8746);
function $fd6c703b693725e3$export$2e68479e0a5d8746(mousePos, { targetElement: targetElement, tooltipPosition: tooltipPosition }) {
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            })
    };
    const targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            })
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            })
    };
    throw new Error(`Invalid tooltip position for virtual element: ${tooltipPosition}`);
}

});

parcelRegister("2GGcL", function(module, exports) {
$parcel$export(module.exports, "show", () => $3e58b9e1dce6a669$export$57bf213be019eeb0);

var $2aEiL = parcelRequire("2aEiL");
let $3e58b9e1dce6a669$var$delayId = null;
function $3e58b9e1dce6a669$var$clearScheduled() {
    if ($3e58b9e1dce6a669$var$delayId != null) {
        window.clearTimeout($3e58b9e1dce6a669$var$delayId);
        $3e58b9e1dce6a669$var$delayId = null;
    }
}
function $3e58b9e1dce6a669$var$scheduleTimeout(fn, delay) {
    $3e58b9e1dce6a669$var$clearScheduled();
    $3e58b9e1dce6a669$var$delayId = window.setTimeout(()=>{
        $3e58b9e1dce6a669$var$delayId = null;
        fn();
    }, delay);
}
let $3e58b9e1dce6a669$var$active = null;
function $3e58b9e1dce6a669$export$57bf213be019eeb0(entry) {
    let phase = 'waiting-to-show';
    function isActive() {
        return Boolean($3e58b9e1dce6a669$var$active && $3e58b9e1dce6a669$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            $3e58b9e1dce6a669$var$clearScheduled();
            $3e58b9e1dce6a669$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            $3e58b9e1dce6a669$var$clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            $3e58b9e1dce6a669$var$clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide({ isImmediate: isImmediate }) {
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        // Bug in legacy path: isImmediate hide requests are ignored during waiting-to-hide,
        // meaning Escape/scroll won't instantly dismiss a tooltip that's already fading out.
        // Gated fix: only apply the immediate-hide behavior under the top-layer flag for now.
        if (phase === 'waiting-to-hide') {
            if (isImmediate && (0, $2aEiL.fg)('platform-dst-top-layer-tooltip')) immediatelyHideAndDone();
            return;
        }
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        $3e58b9e1dce6a669$var$scheduleTimeout(()=>{
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function start() {
        const shouldAlwaysFadeIn = entry.shouldAlwaysFadeIn;
        const showImmediately = Boolean($3e58b9e1dce6a669$var$active && $3e58b9e1dce6a669$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($3e58b9e1dce6a669$var$active) {
            $3e58b9e1dce6a669$var$clearScheduled();
            $3e58b9e1dce6a669$var$active.entry.hide({
                isImmediate: true
            });
            $3e58b9e1dce6a669$var$active.entry.done();
            $3e58b9e1dce6a669$var$active = null;
        }
        // this tooltip is now the active tooltip
        $3e58b9e1dce6a669$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        $3e58b9e1dce6a669$var$scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    const result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePos: entry.source.type === 'mouse' ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}

});

parcelRegister("4w8qa", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae52781a1c11f76d$export$2e2bcd8739ae039);

var $llugW = parcelRequire("llugW");
function $ae52781a1c11f76d$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    const seed = (0, $llugW.useIdSeed)();
    return shouldRenderId ? `${seed(prefix)}` : undefined;
}

});
parcelRegister("llugW", function(module, exports) {
$parcel$export(module.exports, "useIdSeed", () => $d2fc979cfbd447b1$export$6ee17796e3d70de2);

var $lHxwq = parcelRequire("lHxwq");
function $d2fc979cfbd447b1$export$6ee17796e3d70de2() {
    const uid = (0, $lHxwq.useId)();
    return (id)=>`${uid}-${id.toString()}`;
}

});


parcelRegister("g8xuk", function(module, exports) {
$parcel$export(module.exports, "default", () => $93326fc20b0320eb$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $75j28 = parcelRequire("75j28");

var $kIqwl = parcelRequire("kIqwl");
const $93326fc20b0320eb$var$_17 = "._o5721q9c{white-space:nowrap}";
const $93326fc20b0320eb$var$_16 = "._1bto1l2s{text-overflow:ellipsis}";
const $93326fc20b0320eb$var$_15 = "._p12f1pna{max-width:420px}";
const $93326fc20b0320eb$var$_14 = "._18m915vq{overflow-y:hidden}";
const $93326fc20b0320eb$var$_13 = "._1reo15vq{overflow-x:hidden}";
const $93326fc20b0320eb$var$_12 = "._slp31hna{word-wrap:break-word}";
const $93326fc20b0320eb$var$_11 = "._bozg12x7{padding-inline-start:var(--ds-space-075,6px)}";
const $93326fc20b0320eb$var$_10 = "._y4ti12x7{padding-inline-end:var(--ds-space-075,6px)}";
const $93326fc20b0320eb$var$_1 = "._85i51b66{padding-block-end:var(--ds-space-050,4px)}";
const $93326fc20b0320eb$var$_0 = "._1q511b66{padding-block-start:var(--ds-space-050,4px)}";
const $93326fc20b0320eb$var$_9 = "._1i4q1hna{overflow-wrap:break-word}";
const $93326fc20b0320eb$var$_8 = "._1e02ze3t{inset-inline-start:var(--ds-space-0,0)}";
const $93326fc20b0320eb$var$_7 = "._152tze3t{inset-block-start:var(--ds-space-0,0)}";
const $93326fc20b0320eb$var$_6 = "._syaz15cr{color:var(--ds-text-inverse,#fff)}";
const $93326fc20b0320eb$var$_5 = "._bfhk1aqn{background-color:var(--ds-background-neutral-bold,#292a2e)}";
const $93326fc20b0320eb$var$_4 = "._p12fp3fh{max-width:15pc}";
const $93326fc20b0320eb$var$_3 = "._vchhusvi{box-sizing:border-box}";
const $93326fc20b0320eb$var$_2 = "._11c8wadc{font:var(--ds-font-body-small,normal 400 9pt/1pc \"Atlassian Sans\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const $93326fc20b0320eb$var$_ = "._2rkofajl{border-radius:var(--ds-radius-small,3px)}";
const $93326fc20b0320eb$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ const $93326fc20b0320eb$var$TooltipContainer = /*#__PURE__*/ (0, $1v5pe.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut, role: role }, ref) {
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $93326fc20b0320eb$var$_,
                    $93326fc20b0320eb$var$_2,
                    $93326fc20b0320eb$var$_3,
                    $93326fc20b0320eb$var$_4,
                    $93326fc20b0320eb$var$_5,
                    $93326fc20b0320eb$var$_6,
                    $93326fc20b0320eb$var$_7,
                    $93326fc20b0320eb$var$_8,
                    $93326fc20b0320eb$var$_9,
                    $93326fc20b0320eb$var$_0,
                    $93326fc20b0320eb$var$_1,
                    $93326fc20b0320eb$var$_10,
                    $93326fc20b0320eb$var$_11,
                    $93326fc20b0320eb$var$_12,
                    $93326fc20b0320eb$var$_13,
                    $93326fc20b0320eb$var$_14,
                    $93326fc20b0320eb$var$_15,
                    $93326fc20b0320eb$var$_16,
                    $93326fc20b0320eb$var$_17
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $75j28.default), {
                ref: ref,
                style: style // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                ,
                className: (0, $hMvDh.default)([
                    $93326fc20b0320eb$var$styles.base,
                    truncate && $93326fc20b0320eb$var$styles.truncate,
                    className
                ]),
                placement: placement,
                testId: testId,
                id: id,
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOver,
                shortcut: shortcut,
                role: role,
                children: children
            })
        ]
    });
});
$93326fc20b0320eb$var$TooltipContainer.displayName = 'TooltipContainer';
var $93326fc20b0320eb$export$2e2bcd8739ae039 = $93326fc20b0320eb$var$TooltipContainer;

});
parcelRegister("75j28", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4901eef432e1b31$export$2e2bcd8739ae039);
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $4XO6k = parcelRequire("4XO6k");

var $7Q58i = parcelRequire("7Q58i");

var $kIqwl = parcelRequire("kIqwl");
const $d4901eef432e1b31$var$_ = "._80om73ad{cursor:default}";
const $d4901eef432e1b31$var$primitiveStyles = null; /**
                               * The lower level component for rendering a tooltip.
                               */ 
const $d4901eef432e1b31$var$TooltipPrimitive = /*#__PURE__*/ (0, $1v5pe.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut, role: role }, ref) {
    const defaultRole = (0, $4XO6k.useDefaultRole)();
    return /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? `${testId}--wrapper` : undefined,
        children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
            children: [
                /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                    children: [
                        $d4901eef432e1b31$var$_
                    ]
                }),
                /*#__PURE__*/ (0, $kIqwl.jsxs)("div", {
                    role: role ?? defaultRole ?? 'tooltip' // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    ,
                    className: (0, $hMvDh.default)([
                        "_80om73ad",
                        className
                    ]) // Because the tooltip should not be focusable, there is no reason to have key events.
                    ,
                    onMouseOut: onMouseOut /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ ,
                    onMouseOver: onMouseOver,
                    "data-placement": placement,
                    "data-testid": testId,
                    id: id,
                    children: [
                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $4XO6k.DefaultRoleContext).Provider, {
                            value: undefined,
                            children: children
                        }),
                        shortcut && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7Q58i.TooltipShortcut), {
                            shortcut: shortcut
                        })
                    ]
                })
            ]
        })
    });
});
$d4901eef432e1b31$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $d4901eef432e1b31$export$2e2bcd8739ae039 = $d4901eef432e1b31$var$TooltipPrimitive;

});
parcelRegister("7Q58i", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", () => $373d2d0977968a0e$export$5bcbc43c84236222);
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v3.0.2 */ parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $kIqwl = parcelRequire("kIqwl");
const $373d2d0977968a0e$var$_24 = "._bfhk261p{background-color:unset!important}";
const $373d2d0977968a0e$var$_23 = "._w19jn7od{text-shadow:unset}";
const $373d2d0977968a0e$var$_22 = "._1ul9n7od{min-width:unset}";
const $373d2d0977968a0e$var$_21 = "._6rthn7od{margin-block-end:unset}";
const $373d2d0977968a0e$var$_20 = "._1pfhn7od{margin-block-start:unset}";
const $373d2d0977968a0e$var$_19 = "._12l2n7od{margin-inline-end:unset}";
const $373d2d0977968a0e$var$_18 = "._ahbqn7od{margin-inline-start:unset}";
const $373d2d0977968a0e$var$_17 = "._syazn7od{color:unset}";
const $373d2d0977968a0e$var$_16 = "._cgnln7od{-moz-box-shadow:unset}";
const $373d2d0977968a0e$var$_15 = "._1254n7od{-webkit-box-shadow:unset}";
const $373d2d0977968a0e$var$_14 = "._16qsn7od{box-shadow:unset}";
const $373d2d0977968a0e$var$_13 = "._y4ti12x7{padding-inline-end:var(--ds-space-075,6px)}";
const $373d2d0977968a0e$var$_12 = "._bozg12x7{padding-inline-start:var(--ds-space-075,6px)}";
const $373d2d0977968a0e$var$_11 = "._1q51v77o{padding-block-start:var(--ds-space-025,2px)}";
const $373d2d0977968a0e$var$_10 = "._vchhusvi{box-sizing:border-box}";
const $373d2d0977968a0e$var$_1 = "._4t3i1k92{height:1.25rem}";
const $373d2d0977968a0e$var$_0 = "._4cvr1h6o{align-items:center}";
const $373d2d0977968a0e$var$_9 = "._1h6d1ihb{border-color:var(--ds-border-bold,#7d818a)}";
const $373d2d0977968a0e$var$_8 = "._189ee4h9{border-width:var(--ds-border-width,1px)}";
const $373d2d0977968a0e$var$_7 = "._1dqonqa1{border-style:solid}";
const $373d2d0977968a0e$var$_6 = "._2rkolb4i{border-radius:var(--ds-radius-xsmall,2px)}";
const $373d2d0977968a0e$var$_5 = "._11c8wadc{font:var(--ds-font-body-small,normal 400 9pt/1pc \"Atlassian Sans\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const $373d2d0977968a0e$var$_4 = "._85i5v77o{padding-block-end:var(--ds-space-025,2px)}";
const $373d2d0977968a0e$var$_3 = "._1q511b66{padding-block-start:var(--ds-space-050,4px)}";
const $373d2d0977968a0e$var$_2 = "._1e0c1txw{display:flex}";
const $373d2d0977968a0e$var$_ = "._zulpv77o{gap:var(--ds-space-025,2px)}";
const $373d2d0977968a0e$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
const $373d2d0977968a0e$export$5bcbc43c84236222 = ({ shortcut: shortcut })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $373d2d0977968a0e$var$_,
                    $373d2d0977968a0e$var$_2,
                    $373d2d0977968a0e$var$_3,
                    $373d2d0977968a0e$var$_4,
                    $373d2d0977968a0e$var$_5,
                    $373d2d0977968a0e$var$_6,
                    $373d2d0977968a0e$var$_7,
                    $373d2d0977968a0e$var$_8,
                    $373d2d0977968a0e$var$_9,
                    $373d2d0977968a0e$var$_0,
                    $373d2d0977968a0e$var$_1,
                    $373d2d0977968a0e$var$_10,
                    $373d2d0977968a0e$var$_11,
                    $373d2d0977968a0e$var$_12,
                    $373d2d0977968a0e$var$_13,
                    $373d2d0977968a0e$var$_14,
                    $373d2d0977968a0e$var$_15,
                    $373d2d0977968a0e$var$_16,
                    $373d2d0977968a0e$var$_17,
                    $373d2d0977968a0e$var$_18,
                    $373d2d0977968a0e$var$_19,
                    $373d2d0977968a0e$var$_20,
                    $373d2d0977968a0e$var$_21,
                    $373d2d0977968a0e$var$_22,
                    $373d2d0977968a0e$var$_23,
                    $373d2d0977968a0e$var$_24
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                className: (0, $hMvDh.default)([
                    $373d2d0977968a0e$var$styles.shortcutSegmentsContainer
                ]),
                children: shortcut.map((segment, index)=>/*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                        children: [
                            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                                children: [
                                    $373d2d0977968a0e$var$_,
                                    $373d2d0977968a0e$var$_2,
                                    $373d2d0977968a0e$var$_3,
                                    $373d2d0977968a0e$var$_4,
                                    $373d2d0977968a0e$var$_5,
                                    $373d2d0977968a0e$var$_6,
                                    $373d2d0977968a0e$var$_7,
                                    $373d2d0977968a0e$var$_8,
                                    $373d2d0977968a0e$var$_9,
                                    $373d2d0977968a0e$var$_0,
                                    $373d2d0977968a0e$var$_1,
                                    $373d2d0977968a0e$var$_10,
                                    $373d2d0977968a0e$var$_11,
                                    $373d2d0977968a0e$var$_12,
                                    $373d2d0977968a0e$var$_13,
                                    $373d2d0977968a0e$var$_14,
                                    $373d2d0977968a0e$var$_15,
                                    $373d2d0977968a0e$var$_16,
                                    $373d2d0977968a0e$var$_17,
                                    $373d2d0977968a0e$var$_18,
                                    $373d2d0977968a0e$var$_19,
                                    $373d2d0977968a0e$var$_20,
                                    $373d2d0977968a0e$var$_21,
                                    $373d2d0977968a0e$var$_22,
                                    $373d2d0977968a0e$var$_23,
                                    $373d2d0977968a0e$var$_24
                                ]
                            }),
                            /*#__PURE__*/ (0, $kIqwl.jsx)("kbd", {
                                className: (0, $hMvDh.default)([
                                    $373d2d0977968a0e$var$styles.shortcutSegment
                                ]),
                                children: segment
                            }, `${segment}-${index}`)
                        ]
                    }, `${segment}-${index}`))
            })
        ]
    });
};

});




parcelRegister("1895S", function(module, exports) {
$parcel$export(module.exports, "default", () => $49f0534daadba05f$export$2e2bcd8739ae039);
/* button-base.tsx generated by @compiled/babel-plugin v3.0.2 */ /* button-base.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $1v5pe = parcelRequire("1v5pe");

var $ky45w = parcelRequire("ky45w");

var $fl4ll = parcelRequire("fl4ll");

var $Ms2ib = parcelRequire("Ms2ib");

var $lHxwq = parcelRequire("lHxwq");

var $2aEiL = parcelRequire("2aEiL");

var $g4uNb = parcelRequire("g4uNb");

var $kFr83 = parcelRequire("kFr83");

var $3xwP1 = parcelRequire("3xwP1");

var $510jU = parcelRequire("510jU");

var $3iTXu = parcelRequire("3iTXu");

var $1ObgC = parcelRequire("1ObgC");

var $kIqwl = parcelRequire("kIqwl");
const $49f0534daadba05f$var$_129 = "._1di6u02c:active{background-color:var(--ds-background-brand-subtlest-pressed,#adcbfb)}";
const $49f0534daadba05f$var$_128 = "._irr33v15:hover{background-color:var(--ds-background-brand-subtlest-hovered,#cfe1fd)}";
const $49f0534daadba05f$var$_127 = "._9h8h1oa5:active{color:var(--ds-text-brand,#1868db)}";
const $49f0534daadba05f$var$_126 = "._30l31oa5:hover{color:var(--ds-text-brand,#1868db)}";
const $49f0534daadba05f$var$_125 = "._f8pj1oa5:focus{color:var(--ds-text-brand,#1868db)}";
const $49f0534daadba05f$var$_124 = "._10531oa5:visited{color:var(--ds-text-brand,#1868db)}";
const $49f0534daadba05f$var$_123 = "._8l3ma755:after{border-color:var(--ds-border-brand,#1868db)}";
const $49f0534daadba05f$var$_122 = "._syaz1oa5{color:var(--ds-text-brand,#1868db)}";
const $49f0534daadba05f$var$_121 = "._bfhk1gmr{background-color:var(--ds-background-brand-subtlest,#e9f2fe)}";
const $49f0534daadba05f$var$_120 = "._1di615s3:active{background-color:var(--ds-background-selected,#e9f2fe)}";
const $49f0534daadba05f$var$_119 = "._irr315s3:hover{background-color:var(--ds-background-selected,#e9f2fe)}";
const $49f0534daadba05f$var$_118 = "._1di6nozp:active{background-color:var(--ds-background-selected-pressed,#8fb8f6)}";
const $49f0534daadba05f$var$_117 = "._irr3ufnl:hover{background-color:var(--ds-background-selected-hovered,#cfe1fd)}";
const $49f0534daadba05f$var$_116 = "._1pbycs5v{z-index:2}";
const $49f0534daadba05f$var$_115 = "._9h8h6x5g:active{color:var(--ds-text-selected,#1868db)}";
const $49f0534daadba05f$var$_114 = "._30l36x5g:hover{color:var(--ds-text-selected,#1868db)}";
const $49f0534daadba05f$var$_113 = "._f8pj6x5g:focus{color:var(--ds-text-selected,#1868db)}";
const $49f0534daadba05f$var$_112 = "._10536x5g:visited{color:var(--ds-text-selected,#1868db)}";
const $49f0534daadba05f$var$_111 = "._8l3mq98m:after{border-color:var(--ds-border-selected,#1868db)}";
const $49f0534daadba05f$var$_110 = "._syaz6x5g{color:var(--ds-text-selected,#1868db)}";
const $49f0534daadba05f$var$_109 = "._bfhk15s3{background-color:var(--ds-background-selected,#e9f2fe)}";
const $49f0534daadba05f$var$_108 = "._1di61f1m:active{background-color:var(--ds-background-discovery-bold-pressed,#673286)}";
const $49f0534daadba05f$var$_107 = "._irr3fqeg:hover{background-color:var(--ds-background-discovery-bold-hovered,#803fa5)}";
const $49f0534daadba05f$var$_106 = "._bfhku5tj{background-color:var(--ds-background-discovery-bold,#964ac0)}";
const $49f0534daadba05f$var$_105 = "._1di613a9:active{background-color:var(--ds-background-danger-bold-pressed,#872821)}";
const $49f0534daadba05f$var$_104 = "._irr3s9hg:hover{background-color:var(--ds-background-danger-bold-hovered,#ae2e24)}";
const $49f0534daadba05f$var$_103 = "._bfhkybec{background-color:var(--ds-background-danger-bold,#c9372c)}";
const $49f0534daadba05f$var$_102 = "._1di64m4m:active{background-color:var(--ds-background-warning-bold-pressed,#f68909)}";
const $49f0534daadba05f$var$_101 = "._irr31spp:hover{background-color:var(--ds-background-warning-bold-hovered,#fca700)}";
const $49f0534daadba05f$var$_100 = "._9h8h1yd3:active{color:var(--ds-text-warning-inverse,#292a2e)}";
const $49f0534daadba05f$var$_99 = "._30l31yd3:hover{color:var(--ds-text-warning-inverse,#292a2e)}";
const $49f0534daadba05f$var$_98 = "._f8pj1yd3:focus{color:var(--ds-text-warning-inverse,#292a2e)}";
const $49f0534daadba05f$var$_97 = "._10531yd3:visited{color:var(--ds-text-warning-inverse,#292a2e)}";
const $49f0534daadba05f$var$_96 = "._syaz1yd3{color:var(--ds-text-warning-inverse,#292a2e)}";
const $49f0534daadba05f$var$_95 = "._bfhk1kmu{background-color:var(--ds-background-warning-bold,#fbc828)}";
const $49f0534daadba05f$var$_94 = "._1di61kru:active{background-color:var(--ds-rovo-background-brand-bold-pressed,#292a2e)}";
const $49f0534daadba05f$var$_93 = "._irr31afz:hover{background-color:var(--ds-rovo-background-brand-bold-hovered,#1e1f21)}";
const $49f0534daadba05f$var$_92 = "._bfhklqh9{background-color:var(--ds-rovo-background-brand-bold,#000)}";
const $49f0534daadba05f$var$_91 = "._1di6g6ey:active{background-color:var(--ds-background-brand-bold-pressed,#144794)}";
const $49f0534daadba05f$var$_90 = "._irr3hf2y:hover{background-color:var(--ds-background-brand-bold-hovered,#1558bc)}";
const $49f0534daadba05f$var$_89 = "._9h8h15cr:active{color:var(--ds-text-inverse,#fff)}";
const $49f0534daadba05f$var$_88 = "._30l315cr:hover{color:var(--ds-text-inverse,#fff)}";
const $49f0534daadba05f$var$_87 = "._f8pj15cr:focus{color:var(--ds-text-inverse,#fff)}";
const $49f0534daadba05f$var$_86 = "._105315cr:visited{color:var(--ds-text-inverse,#fff)}";
const $49f0534daadba05f$var$_85 = "._syaz15cr{color:var(--ds-text-inverse,#fff)}";
const $49f0534daadba05f$var$_84 = "._bfhk1856{background-color:var(--ds-background-brand-bold,#1868db)}";
const $49f0534daadba05f$var$_83 = "._1di61j28:active{background-color:transparent}";
const $49f0534daadba05f$var$_82 = "._irr31j28:hover{background-color:transparent}";
const $49f0534daadba05f$var$_81 = "._8l3mbk0g:after{border-color:var(--ds-border-disabled,#0515240f)}";
const $49f0534daadba05f$var$_80 = "._bfhk1j28{background-color:transparent}";
const $49f0534daadba05f$var$_79 = "._1di6fcek:active{background-color:var(--ds-background-neutral-subtle-pressed,#0b120e24)}";
const $49f0534daadba05f$var$_78 = "._irr31dpa:hover{background-color:var(--ds-background-neutral-subtle-hovered,#0515240f)}";
const $49f0534daadba05f$var$_77 = "._9h8hazsu:active{color:var(--ds-text-subtle,#505258)}";
const $49f0534daadba05f$var$_76 = "._30l3azsu:hover{color:var(--ds-text-subtle,#505258)}";
const $49f0534daadba05f$var$_75 = "._f8pjazsu:focus{color:var(--ds-text-subtle,#505258)}";
const $49f0534daadba05f$var$_74 = "._1053azsu:visited{color:var(--ds-text-subtle,#505258)}";
const $49f0534daadba05f$var$_73 = "._aetrb3bt:after{content:\"\"}";
const $49f0534daadba05f$var$_72 = "._8l3m1l7x:after{border-color:var(--ds-border,#0b120e24)}";
const $49f0534daadba05f$var$_71 = "._syazazsu{color:var(--ds-text-subtle,#505258)}";
const $49f0534daadba05f$var$_70 = "._bozg12x7{padding-inline-start:var(--ds-space-075,6px)}";
const $49f0534daadba05f$var$_69 = "._y4ti12x7{padding-inline-end:var(--ds-space-075,6px)}";
const $49f0534daadba05f$var$_68 = "._bfhksm61{background-color:var(--ds-background-neutral-subtle,#00000000)}";
const $49f0534daadba05f$var$_67 = "._1bsb1tcg{width:24px}";
const $49f0534daadba05f$var$_66 = "._1e02ze3t{inset-inline-start:var(--ds-space-0,0)}";
const $49f0534daadba05f$var$_65 = "._rjxpze3t{inset-inline-end:var(--ds-space-0,0)}";
const $49f0534daadba05f$var$_64 = "._152tze3t{inset-block-start:var(--ds-space-0,0)}";
const $49f0534daadba05f$var$_63 = "._u7coze3t{inset-block-end:var(--ds-space-0,0)}";
const $49f0534daadba05f$var$_62 = "._4cvr1h6o{align-items:center}";
const $49f0534daadba05f$var$_61 = "._kqswstnw{position:absolute}";
const $49f0534daadba05f$var$_60 = "._1e0c1txw{display:flex}";
const $49f0534daadba05f$var$_59 = "._18m915vq{overflow-y:hidden}";
const $49f0534daadba05f$var$_58 = "._1reo15vq{overflow-x:hidden}";
const $49f0534daadba05f$var$_57 = "._g0pbb4wl:focus-visible{z-index:100}";
const $49f0534daadba05f$var$_56 = "._gy1p12x7{-moz-column-gap:var(--ds-space-075,6px);column-gap:var(--ds-space-075,6px)}";
const $49f0534daadba05f$var$_55 = "._1bsb1k8s{width:1.5rem}";
const $49f0534daadba05f$var$_54 = "._bozgze3t{padding-inline-start:var(--ds-space-0,0)}";
const $49f0534daadba05f$var$_53 = "._y4tize3t{padding-inline-end:var(--ds-space-0,0)}";
const $49f0534daadba05f$var$_52 = "._1bsbviql{width:2rem}";
const $49f0534daadba05f$var$_51 = "._80om15jw{cursor:progress}";
const $49f0534daadba05f$var$_50 = "._1bsb1osq{width:100%}";
const $49f0534daadba05f$var$_49 = "._2rko1rr0{border-radius:var(--ds-radius-full,9999px)}";
const $49f0534daadba05f$var$_48 = "._4t3i1k8s{height:1.5rem}";
const $49f0534daadba05f$var$_47 = "._1rjcv77o{padding-block:var(--ds-space-025,2px)}";
const $49f0534daadba05f$var$_46 = "._2rko12b0{border-radius:var(--ds-radius-small,4px)}";
const $49f0534daadba05f$var$_45 = "._1di6187o:active{background-color:var(--ds-background-disabled,#0515240f)}";
const $49f0534daadba05f$var$_44 = "._irr3187o:hover{background-color:var(--ds-background-disabled,#0515240f)}";
const $49f0534daadba05f$var$_43 = "._bfhk187o{background-color:var(--ds-background-disabled,#0515240f)}";
const $49f0534daadba05f$var$_42 = "._9h8h1gmx:active{color:var(--ds-text-disabled,#080f214a)}";
const $49f0534daadba05f$var$_41 = "._30l31gmx:hover{color:var(--ds-text-disabled,#080f214a)}";
const $49f0534daadba05f$var$_40 = "._syaz1gmx{color:var(--ds-text-disabled,#080f214a)}";
const $49f0534daadba05f$var$_39 = "._80om13gf{cursor:not-allowed}";
const $49f0534daadba05f$var$_38 = "._1iohnqa1:active{text-decoration-style:solid}";
const $49f0534daadba05f$var$_37 = "._c2waglyw:active{text-decoration-line:none}";
const $49f0534daadba05f$var$_36 = "._1nrm1r31:active{text-decoration-color:currentColor}";
const $49f0534daadba05f$var$_35 = "._jf4cnqa1:hover{text-decoration-style:solid}";
const $49f0534daadba05f$var$_34 = "._1bnxglyw:hover{text-decoration-line:none}";
const $49f0534daadba05f$var$_33 = "._9oik1r31:hover{text-decoration-color:currentColor}";
const $49f0534daadba05f$var$_32 = "._5goinqa1:focus{text-decoration-style:solid}";
const $49f0534daadba05f$var$_31 = "._4fprglyw:focus{text-decoration-line:none}";
const $49f0534daadba05f$var$_30 = "._1a3b1r31:focus{text-decoration-color:currentColor}";
const $49f0534daadba05f$var$_29 = "._ajmmnqa1{text-decoration-style:solid}";
const $49f0534daadba05f$var$_28 = "._1hmsglyw{text-decoration-line:none}";
const $49f0534daadba05f$var$_27 = "._4bfu1r31{text-decoration-color:currentColor}";
const $49f0534daadba05f$var$_26 = "._1ggl5xtf:active{transition:var(--ds-button-pressed,background-color border-color .15s cubic-bezier(.4,1,.6,1))}";
const $49f0534daadba05f$var$_25 = "._v564k6bl{transition:var(--ds-button-hovered,background-color border-color .15s cubic-bezier(.4,1,.6,1))}";
const $49f0534daadba05f$var$_24 = "._18postnw:after{position:absolute}";
const $49f0534daadba05f$var$_23 = "._11fnglyw:after{pointer-events:none}";
const $49f0534daadba05f$var$_22 = "._39yqe4h9:after{border-width:var(--ds-border-width,1px)}";
const $49f0534daadba05f$var$_21 = "._1tv3nqa1:after{border-style:solid}";
const $49f0534daadba05f$var$_20 = "._9v7aze3t:after{inset:var(--ds-space-0,0)}";
const $49f0534daadba05f$var$_19 = "._14mj1kw7:after{border-radius:inherit}";
const $49f0534daadba05f$var$_18 = "._s7n4nkob{vertical-align:middle}";
const $49f0534daadba05f$var$_17 = "._y3gn1h6o{text-align:center}";
const $49f0534daadba05f$var$_16 = "._bozgutpp{padding-inline-start:var(--ds-space-150,9pt)}";
const $49f0534daadba05f$var$_15 = "._y4tiutpp{padding-inline-end:var(--ds-space-150,9pt)}";
const $49f0534daadba05f$var$_14 = "._k48p1wq8{font-weight:var(--ds-font-weight-medium,500)}";
const $49f0534daadba05f$var$_13 = "._4t3iviql{height:2rem}";
const $49f0534daadba05f$var$_12 = "._1o9zidpf{flex-shrink:0}";
const $49f0534daadba05f$var$_11 = "._gy1p1b66{-moz-column-gap:var(--ds-space-050,4px);column-gap:var(--ds-space-050,4px)}";
const $49f0534daadba05f$var$_10 = "._1bah1h6o{justify-content:center}";
const $49f0534daadba05f$var$_1 = "._4cvr1q9y{align-items:baseline}";
const $49f0534daadba05f$var$_0 = "._kqswh2mm{position:relative}";
const $49f0534daadba05f$var$_9 = "._p12f1osq{max-width:100%}";
const $49f0534daadba05f$var$_8 = "._1bsb1wug{width:auto}";
const $49f0534daadba05f$var$_7 = "._vchhusvi{box-sizing:border-box}";
const $49f0534daadba05f$var$_6 = "._1e0c116y{display:inline-flex}";
const $49f0534daadba05f$var$_5 = "._1rjc12x7{padding-block:var(--ds-space-075,6px)}";
const $49f0534daadba05f$var$_4 = "._189eidpf{border-width:0}";
const $49f0534daadba05f$var$_3 = "._v5649dqc{transition:background .1s ease-out}";
const $49f0534daadba05f$var$_2 = "._11c8fhey{font:var(--ds-font-body,normal 400 14px/20px \"Atlassian Sans\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const $49f0534daadba05f$var$_ = "._2rko1qi0{border-radius:var(--ds-radius-medium,6px)}";
const $49f0534daadba05f$var$LOADING_LABEL = ', Loading';
const $49f0534daadba05f$var$styles = {
    base: "_2rko1qi0 _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    interactiveMotion: "_v564k6bl _1ggl5xtf",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk187o _irr3187o _1di6187o",
    spacingCompact: "_2rko12b0 _1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
const $49f0534daadba05f$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
const $49f0534daadba05f$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $49f0534daadba05f$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31afz _9h8h15cr _1di61kru"
};
const $49f0534daadba05f$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _9h8h1yd3",
    interactive: "_30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
const $49f0534daadba05f$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
const $49f0534daadba05f$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $49f0534daadba05f$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
const $49f0534daadba05f$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
const $49f0534daadba05f$var$brandSelectedSplitButtonStyles = {
    root: "_bfhk1gmr _syaz1oa5 _8l3ma755 _aetrb3bt _10531oa5 _f8pj1oa5 _30l31oa5 _9h8h1oa5",
    interactive: "_irr33v15 _30l31oa5 _1di6u02c _9h8h1oa5"
}; /**
    * __button base__
    *
    * - Implements auto focus when enabled.
    * - Appends the `onClick` event with UFO analytics tracking.
    *
    * @private
    */ 
const $49f0534daadba05f$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
({ appearance: propAppearance, autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: isIconButton = false, isCircle: isCircle = false, hasIconBefore: hasIconBefore = false, hasIconAfter: hasIconAfter = false, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, children: children, interactionName: interactionName, onClick: onClick, onMouseDown: onMouseDown, onMouseDownCapture: onMouseDownCapture, onMouseUp: onMouseUp, onMouseUpCapture: onMouseUpCapture, onKeyDown: onKeyDown, onKeyDownCapture: onKeyDownCapture, onKeyUp: onKeyUp, onKeyUpCapture: onKeyUpCapture, onTouchStart: onTouchStart, onTouchStartCapture: onTouchStartCapture, onTouchEnd: onTouchEnd, onTouchEndCapture: onTouchEndCapture, onPointerDown: onPointerDown, onPointerDownCapture: onPointerDownCapture, onPointerUp: onPointerUp, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, testId: testId, analyticsContext: analyticsContext, componentName: componentName, rootXcss: rootXcss, role: role, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onFocus: onFocus, onBlur: onBlur, onMouseMove: onMouseMove, type: type, ...unsafeRest }, ref)=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const localRef = (0, $1v5pe.useRef)(null);
    const splitButtonContext = (0, $510jU.useSplitButtonContext)();
    const loadingLabelId = (0, $lHxwq.useId)();
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = splitButtonContext?.isNavigationSplitButton || false;
    const isDefaultAppearanceSplitButton = splitButtonContext?.appearance === 'default';
    const appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || splitButtonContext?.appearance || 'default';
    const spacing = splitButtonContext?.spacing || propSpacing;
    const isDisabled = splitButtonContext?.isDisabled || propIsDisabled;
    const isInteractive = !isDisabled && !isLoading; // Also treat loading buttons as disabled
    const isEffectivelyDisabled = isDisabled || isLoading;
    const isSelected = propIsSelected && !isDisabled; // The open dropdown is part of a primary action, not a standalone selection.
    const isBrandSelectedSplitButton = isSelected && appearance === 'primary' && splitButtonContext?.appearance === 'primary' && (0, $2aEiL.fg)('platform-dst-tokens-finesse');
    (0, $Ms2ib.default)(localRef, autoFocus); // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $49f0534daadba05f$var$_,
                    $49f0534daadba05f$var$_2,
                    $49f0534daadba05f$var$_3,
                    $49f0534daadba05f$var$_4,
                    $49f0534daadba05f$var$_5,
                    $49f0534daadba05f$var$_6,
                    $49f0534daadba05f$var$_7,
                    $49f0534daadba05f$var$_8,
                    $49f0534daadba05f$var$_9,
                    $49f0534daadba05f$var$_0,
                    $49f0534daadba05f$var$_1,
                    $49f0534daadba05f$var$_10,
                    $49f0534daadba05f$var$_11,
                    $49f0534daadba05f$var$_12,
                    $49f0534daadba05f$var$_13,
                    $49f0534daadba05f$var$_14,
                    $49f0534daadba05f$var$_15,
                    $49f0534daadba05f$var$_16,
                    $49f0534daadba05f$var$_17,
                    $49f0534daadba05f$var$_18,
                    $49f0534daadba05f$var$_19,
                    $49f0534daadba05f$var$_20,
                    $49f0534daadba05f$var$_21,
                    $49f0534daadba05f$var$_22,
                    $49f0534daadba05f$var$_23,
                    $49f0534daadba05f$var$_24,
                    $49f0534daadba05f$var$_25,
                    $49f0534daadba05f$var$_26,
                    $49f0534daadba05f$var$_27,
                    $49f0534daadba05f$var$_28,
                    $49f0534daadba05f$var$_29,
                    $49f0534daadba05f$var$_30,
                    $49f0534daadba05f$var$_31,
                    $49f0534daadba05f$var$_32,
                    $49f0534daadba05f$var$_33,
                    $49f0534daadba05f$var$_34,
                    $49f0534daadba05f$var$_35,
                    $49f0534daadba05f$var$_36,
                    $49f0534daadba05f$var$_37,
                    $49f0534daadba05f$var$_38,
                    $49f0534daadba05f$var$_39,
                    $49f0534daadba05f$var$_40,
                    $49f0534daadba05f$var$_41,
                    $49f0534daadba05f$var$_42,
                    $49f0534daadba05f$var$_43,
                    $49f0534daadba05f$var$_44,
                    $49f0534daadba05f$var$_45,
                    $49f0534daadba05f$var$_46,
                    $49f0534daadba05f$var$_47,
                    $49f0534daadba05f$var$_48,
                    $49f0534daadba05f$var$_49,
                    $49f0534daadba05f$var$_50,
                    $49f0534daadba05f$var$_51,
                    $49f0534daadba05f$var$_52,
                    $49f0534daadba05f$var$_53,
                    $49f0534daadba05f$var$_54,
                    $49f0534daadba05f$var$_55,
                    $49f0534daadba05f$var$_56,
                    $49f0534daadba05f$var$_57,
                    $49f0534daadba05f$var$_58,
                    $49f0534daadba05f$var$_59,
                    $49f0534daadba05f$var$_60,
                    $49f0534daadba05f$var$_61,
                    $49f0534daadba05f$var$_62,
                    $49f0534daadba05f$var$_63,
                    $49f0534daadba05f$var$_64,
                    $49f0534daadba05f$var$_65,
                    $49f0534daadba05f$var$_66,
                    $49f0534daadba05f$var$_67,
                    $49f0534daadba05f$var$_68,
                    $49f0534daadba05f$var$_69,
                    $49f0534daadba05f$var$_70,
                    $49f0534daadba05f$var$_71,
                    $49f0534daadba05f$var$_72,
                    $49f0534daadba05f$var$_73,
                    $49f0534daadba05f$var$_74,
                    $49f0534daadba05f$var$_75,
                    $49f0534daadba05f$var$_76,
                    $49f0534daadba05f$var$_77,
                    $49f0534daadba05f$var$_78,
                    $49f0534daadba05f$var$_79,
                    $49f0534daadba05f$var$_80,
                    $49f0534daadba05f$var$_81,
                    $49f0534daadba05f$var$_82,
                    $49f0534daadba05f$var$_83,
                    $49f0534daadba05f$var$_84,
                    $49f0534daadba05f$var$_85,
                    $49f0534daadba05f$var$_86,
                    $49f0534daadba05f$var$_87,
                    $49f0534daadba05f$var$_88,
                    $49f0534daadba05f$var$_89,
                    $49f0534daadba05f$var$_90,
                    $49f0534daadba05f$var$_91,
                    $49f0534daadba05f$var$_92,
                    $49f0534daadba05f$var$_93,
                    $49f0534daadba05f$var$_94,
                    $49f0534daadba05f$var$_95,
                    $49f0534daadba05f$var$_96,
                    $49f0534daadba05f$var$_97,
                    $49f0534daadba05f$var$_98,
                    $49f0534daadba05f$var$_99,
                    $49f0534daadba05f$var$_100,
                    $49f0534daadba05f$var$_101,
                    $49f0534daadba05f$var$_102,
                    $49f0534daadba05f$var$_103,
                    $49f0534daadba05f$var$_104,
                    $49f0534daadba05f$var$_105,
                    $49f0534daadba05f$var$_106,
                    $49f0534daadba05f$var$_107,
                    $49f0534daadba05f$var$_108,
                    $49f0534daadba05f$var$_109,
                    $49f0534daadba05f$var$_110,
                    $49f0534daadba05f$var$_111,
                    $49f0534daadba05f$var$_112,
                    $49f0534daadba05f$var$_113,
                    $49f0534daadba05f$var$_114,
                    $49f0534daadba05f$var$_115,
                    $49f0534daadba05f$var$_116,
                    $49f0534daadba05f$var$_117,
                    $49f0534daadba05f$var$_118,
                    $49f0534daadba05f$var$_119,
                    $49f0534daadba05f$var$_120,
                    $49f0534daadba05f$var$_121,
                    $49f0534daadba05f$var$_122,
                    $49f0534daadba05f$var$_123,
                    $49f0534daadba05f$var$_124,
                    $49f0534daadba05f$var$_125,
                    $49f0534daadba05f$var$_126,
                    $49f0534daadba05f$var$_127,
                    $49f0534daadba05f$var$_128,
                    $49f0534daadba05f$var$_129
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $g4uNb.Pressable), {
                ...saferRest,
                componentName: componentName || 'button',
                analyticsContext: analyticsContext,
                role: role,
                ref: (0, $fl4ll.default)([
                    localRef,
                    ref
                ]),
                xcss: (0, $ky45w.cx)($49f0534daadba05f$var$styles.base, isInteractive && $49f0534daadba05f$var$styles.interactiveMotion, appearance === 'default' && $49f0534daadba05f$var$defaultStyles.root, appearance === 'default' && isInteractive && $49f0534daadba05f$var$defaultStyles.interactive, appearance === 'primary' && $49f0534daadba05f$var$primaryStyles.root, appearance === 'primary' && isInteractive && $49f0534daadba05f$var$primaryStyles.interactive, appearance === 'rovo' && $49f0534daadba05f$var$rovoStyles.root, appearance === 'rovo' && isInteractive && $49f0534daadba05f$var$rovoStyles.interactive, appearance === 'warning' && $49f0534daadba05f$var$warningStyles.root, appearance === 'warning' && isInteractive && $49f0534daadba05f$var$warningStyles.interactive, appearance === 'danger' && $49f0534daadba05f$var$dangerStyles.root, appearance === 'danger' && isInteractive && $49f0534daadba05f$var$dangerStyles.interactive, appearance === 'discovery' && $49f0534daadba05f$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $49f0534daadba05f$var$discoveryStyles.interactive, appearance === 'subtle' && $49f0534daadba05f$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $49f0534daadba05f$var$subtleStyles.interactive, $49f0534daadba05f$var$styles.linkDecorationUnset, isSelected && $49f0534daadba05f$var$selectedStyles.root, isSelected && isSplitButton && $49f0534daadba05f$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $49f0534daadba05f$var$selectedStyles.interactive, isBrandSelectedSplitButton && $49f0534daadba05f$var$brandSelectedSplitButtonStyles.root, isBrandSelectedSplitButton && isInteractive && $49f0534daadba05f$var$brandSelectedSplitButtonStyles.interactive, // TODO: remove me once we kill color fallbacks
                isSelected && appearance === 'danger' && $49f0534daadba05f$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
                isSelected && appearance === 'warning' && $49f0534daadba05f$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
                isSelected && appearance === 'discovery' && $49f0534daadba05f$var$selectedStyles.discovery, isDisabled && $49f0534daadba05f$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $49f0534daadba05f$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $49f0534daadba05f$var$defaultStyles.disabled, spacing === 'compact' && $49f0534daadba05f$var$styles.spacingCompact, // This must come after spacing compact styling as it overrides the border radius
                isCircle && !isSplitButton && $49f0534daadba05f$var$styles.circle, shouldFitContainer && $49f0534daadba05f$var$styles.fullWidth, hasIconBefore && $49f0534daadba05f$var$styles.buttonIconBefore, hasIconAfter && $49f0534daadba05f$var$styles.buttonIconAfter, isIconButton && $49f0534daadba05f$var$styles.iconButton, isIconButton && spacing === 'compact' && $49f0534daadba05f$var$styles.iconButtonCompact, isLoading && $49f0534daadba05f$var$styles.loading, isSplitButton && $49f0534daadba05f$var$styles.splitButton, isNavigationSplitButton && $49f0534daadba05f$var$styles.navigationSplitButton, rootXcss),
                isDisabled: isDisabled,
                "aria-live": "polite",
                ...isLoading && {
                    'aria-disabled': true
                },
                "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${$49f0534daadba05f$var$LOADING_LABEL}` : ariaLabel,
                "aria-labelledby": isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
                onClick: onClick,
                ...(0, $3iTXu.default)(isEffectivelyDisabled, {
                    onMouseDownCapture: onMouseDownCapture,
                    onMouseUpCapture: onMouseUpCapture,
                    onKeyDownCapture: onKeyDownCapture,
                    onKeyUpCapture: onKeyUpCapture,
                    onTouchStartCapture: onTouchStartCapture,
                    onTouchEndCapture: onTouchEndCapture,
                    onPointerDownCapture: onPointerDownCapture,
                    onPointerUpCapture: onPointerUpCapture,
                    onClickCapture: onClickCapture
                }),
                testId: testId,
                onMouseOver: onMouseOver,
                onFocus: onFocus,
                onMouseMove: onMouseMove,
                onBlur: onBlur,
                type: type,
                interactionName: interactionName,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onKeyDown: onKeyDown,
                onMouseOut: onMouseOut,
                onKeyUp: onKeyUp,
                onTouchStart: onTouchStart,
                onTouchEnd: onTouchEnd,
                onPointerDown: onPointerDown,
                onPointerUp: onPointerUp,
                children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $3xwP1.SplitButtonContext).Provider, {
                    value: undefined,
                    children: [
                        children,
                        isLoading && /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                            children: [
                                /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                                    children: [
                                        $49f0534daadba05f$var$_,
                                        $49f0534daadba05f$var$_2,
                                        $49f0534daadba05f$var$_3,
                                        $49f0534daadba05f$var$_4,
                                        $49f0534daadba05f$var$_5,
                                        $49f0534daadba05f$var$_6,
                                        $49f0534daadba05f$var$_7,
                                        $49f0534daadba05f$var$_8,
                                        $49f0534daadba05f$var$_9,
                                        $49f0534daadba05f$var$_0,
                                        $49f0534daadba05f$var$_1,
                                        $49f0534daadba05f$var$_10,
                                        $49f0534daadba05f$var$_11,
                                        $49f0534daadba05f$var$_12,
                                        $49f0534daadba05f$var$_13,
                                        $49f0534daadba05f$var$_14,
                                        $49f0534daadba05f$var$_15,
                                        $49f0534daadba05f$var$_16,
                                        $49f0534daadba05f$var$_17,
                                        $49f0534daadba05f$var$_18,
                                        $49f0534daadba05f$var$_19,
                                        $49f0534daadba05f$var$_20,
                                        $49f0534daadba05f$var$_21,
                                        $49f0534daadba05f$var$_22,
                                        $49f0534daadba05f$var$_23,
                                        $49f0534daadba05f$var$_24,
                                        $49f0534daadba05f$var$_25,
                                        $49f0534daadba05f$var$_26,
                                        $49f0534daadba05f$var$_27,
                                        $49f0534daadba05f$var$_28,
                                        $49f0534daadba05f$var$_29,
                                        $49f0534daadba05f$var$_30,
                                        $49f0534daadba05f$var$_31,
                                        $49f0534daadba05f$var$_32,
                                        $49f0534daadba05f$var$_33,
                                        $49f0534daadba05f$var$_34,
                                        $49f0534daadba05f$var$_35,
                                        $49f0534daadba05f$var$_36,
                                        $49f0534daadba05f$var$_37,
                                        $49f0534daadba05f$var$_38,
                                        $49f0534daadba05f$var$_39,
                                        $49f0534daadba05f$var$_40,
                                        $49f0534daadba05f$var$_41,
                                        $49f0534daadba05f$var$_42,
                                        $49f0534daadba05f$var$_43,
                                        $49f0534daadba05f$var$_44,
                                        $49f0534daadba05f$var$_45,
                                        $49f0534daadba05f$var$_46,
                                        $49f0534daadba05f$var$_47,
                                        $49f0534daadba05f$var$_48,
                                        $49f0534daadba05f$var$_49,
                                        $49f0534daadba05f$var$_50,
                                        $49f0534daadba05f$var$_51,
                                        $49f0534daadba05f$var$_52,
                                        $49f0534daadba05f$var$_53,
                                        $49f0534daadba05f$var$_54,
                                        $49f0534daadba05f$var$_55,
                                        $49f0534daadba05f$var$_56,
                                        $49f0534daadba05f$var$_57,
                                        $49f0534daadba05f$var$_58,
                                        $49f0534daadba05f$var$_59,
                                        $49f0534daadba05f$var$_60,
                                        $49f0534daadba05f$var$_61,
                                        $49f0534daadba05f$var$_62,
                                        $49f0534daadba05f$var$_63,
                                        $49f0534daadba05f$var$_64,
                                        $49f0534daadba05f$var$_65,
                                        $49f0534daadba05f$var$_66,
                                        $49f0534daadba05f$var$_67,
                                        $49f0534daadba05f$var$_68,
                                        $49f0534daadba05f$var$_69,
                                        $49f0534daadba05f$var$_70
                                    ]
                                }),
                                /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
                                    className: (0, $hMvDh.default)([
                                        $49f0534daadba05f$var$styles.loadingOverlay
                                    ]),
                                    children: (0, $1ObgC.default)({
                                        spacing: spacing,
                                        appearance: appearance,
                                        isDisabled: isDisabled,
                                        isSelected: isSelected,
                                        testId: testId
                                    })
                                })
                            ]
                        }),
                        isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kFr83.default), {
                            id: loadingLabelId,
                            children: $49f0534daadba05f$var$LOADING_LABEL
                        })
                    ]
                })
            })
        ]
    });
});
var $49f0534daadba05f$export$2e2bcd8739ae039 = $49f0534daadba05f$var$ButtonBase;

});
parcelRegister("g4uNb", function(module, exports) {
$parcel$export(module.exports, "Pressable", () => $718ff0d4b098d338$export$27c701ed9e449e99);
/* pressable.tsx generated by @compiled/babel-plugin v3.0.2 */ /* pressable.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $hGIzV = parcelRequire("hGIzV");

var $j9QYE = parcelRequire("j9QYE");

var $EPIBl = parcelRequire("EPIBl");

var $aD9yk = parcelRequire("aD9yk");

var $7qISg = parcelRequire("7qISg");

var $22rKq = parcelRequire("22rKq");

var $kIqwl = parcelRequire("kIqwl");
const $718ff0d4b098d338$var$_5 = "._80om13gf{cursor:not-allowed}";
const $718ff0d4b098d338$var$_4 = "._80omtlke{cursor:pointer}";
const $718ff0d4b098d338$var$_3 = "._r06hglyw{-webkit-appearance:none;-moz-appearance:none;appearance:none}";
const $718ff0d4b098d338$var$_2 = "._vchhusvi{box-sizing:border-box}";
const $718ff0d4b098d338$var$_ = "._19itglyw{border:none}";
const $718ff0d4b098d338$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
}; /**
    * __Pressable__
    *
    * A primitive for building custom buttons.
    *
    * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
    * - [Code](https://atlassian.design/components/primitives/pressable/code)
    * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
    */ 
const $718ff0d4b098d338$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ children: children, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $aD9yk.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, tabIndex: tabIndex, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $1v5pe.useContext)((0, $7qISg.default));
    const handleClick = (0, $1v5pe.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'button'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $718ff0d4b098d338$var$_,
                    $718ff0d4b098d338$var$_2,
                    $718ff0d4b098d338$var$_3,
                    $718ff0d4b098d338$var$_4,
                    $718ff0d4b098d338$var$_5
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $22rKq.Focusable // @ts-ignore -- not using expect since it causes issues with help-center local consumption - we don't allow `button` on Focusable for makers as they should use Pressable instead
            ), {
                as: "button" // Safari does not apply focus to buttons on click like other browsers, which means click events will not be fired.
                ,
                tabIndex: tabIndex ?? ((0, $EPIBl.isSafari)() && !isDisabled ? 0 : undefined),
                style: style,
                ...safeHtmlAttributes,
                type: type,
                onClick: onClick,
                disabled: isDisabled,
                xcss: (0, $hGIzV.cx)($718ff0d4b098d338$var$styles.root, isDisabled && $718ff0d4b098d338$var$styles.disabled, xcss),
                testId: testId,
                ref: ref,
                children: children
            })
        ]
    });
});

});
parcelRegister("EPIBl", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $ddff4270039d11a0$export$95df08bae54cb4df);
function $ddff4270039d11a0$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        const ua = window.navigator.userAgent?.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}

});

parcelRegister("22rKq", function(module, exports) {
$parcel$export(module.exports, "Focusable", () => $b2d5d2462fdbda07$export$35a3bebf7ef2d934);
/* focusable.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $kIqwl = parcelRequire("kIqwl");
const $b2d5d2462fdbda07$var$_0 = "@media screen and (-ms-high-contrast:active),screen and (forced-colors:active){._2mwq1gjf:focus-visible{outline-offset:calc(0px - var(--ds-border-width-focused, 2px))}}";
const $b2d5d2462fdbda07$var$_9 = "._1ah31gjf:focus-visible{outline-offset:calc(0px - var(--ds-border-width-focused, 2px))}";
const $b2d5d2462fdbda07$var$_8 = "@media screen and (-ms-high-contrast:active),screen and (forced-colors:active){._1cvmnqa1:focus-visible{outline-style:solid}._4davt94y:focus-visible{outline-width:1px}}";
const $b2d5d2462fdbda07$var$_7 = "._128mdkaa:focus-visible{outline-width:var(--ds-border-width-focused,2px)}";
const $b2d5d2462fdbda07$var$_6 = "._ra3xnqa1:focus-visible{outline-style:solid}";
const $b2d5d2462fdbda07$var$_5 = "._1ah3dkaa:focus-visible{outline-offset:var(--ds-border-width-focused,2px)}";
const $b2d5d2462fdbda07$var$_4 = "._mizu194a:focus-visible{outline-color:var(--ds-border-focused,#2684ff)}";
const $b2d5d2462fdbda07$var$_3 = "._zcxs1o36:focus:not(:focus-visible){outline-width:medium}";
const $b2d5d2462fdbda07$var$_2 = "._ypr0glyw:focus:not(:focus-visible){outline-style:none}";
const $b2d5d2462fdbda07$var$_ = "._ymio1r31:focus:not(:focus-visible){outline-color:currentColor}";
const $b2d5d2462fdbda07$var$focusRingStyles = null;
const $b2d5d2462fdbda07$var$insetFocusRingStyles = null;
const $b2d5d2462fdbda07$export$35a3bebf7ef2d934 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: Component = 'button', children: children, isInset: isInset, testId: testId, style: style, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return(/*#__PURE__*/ // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $b2d5d2462fdbda07$var$_,
                    $b2d5d2462fdbda07$var$_2,
                    $b2d5d2462fdbda07$var$_3,
                    $b2d5d2462fdbda07$var$_4,
                    $b2d5d2462fdbda07$var$_5,
                    $b2d5d2462fdbda07$var$_6,
                    $b2d5d2462fdbda07$var$_7,
                    $b2d5d2462fdbda07$var$_8,
                    $b2d5d2462fdbda07$var$_9,
                    $b2d5d2462fdbda07$var$_0
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)(Component, {
                ...safeHtmlAttributes,
                // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
                ref: ref,
                className: (0, $hMvDh.default)([
                    "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
                    isInset && "_1ah31gjf _2mwq1gjf",
                    xcss
                ]),
                style: style,
                "data-testid": testId,
                children: children
            })
        ]
    }));
});

});


parcelRegister("3xwP1", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", () => $31dafb6d95c4b4c9$export$4b86304b2c0d7e71);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1v5pe = parcelRequire("1v5pe");
const $31dafb6d95c4b4c9$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);

});

parcelRegister("510jU", function(module, exports) {
$parcel$export(module.exports, "useSplitButtonContext", () => $cd41f3327218c180$export$47e2c6fdb142d947);

var $1v5pe = parcelRequire("1v5pe");

var $3xwP1 = parcelRequire("3xwP1");
const $cd41f3327218c180$export$47e2c6fdb142d947 = ()=>{
    const context = (0, $1v5pe.useContext)((0, $3xwP1.SplitButtonContext));
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("3iTXu", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2160cc5bed4a8cb$export$2e2bcd8739ae039);
function $b2160cc5bed4a8cb$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $b2160cc5bed4a8cb$var$tabKeyCode = 9;
function $b2160cc5bed4a8cb$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $b2160cc5bed4a8cb$var$tabKeyCode) return;
    $b2160cc5bed4a8cb$var$abort(event);
}
function $b2160cc5bed4a8cb$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $b2160cc5bed4a8cb$var$abort,
        onMouseUpCapture: $b2160cc5bed4a8cb$var$abort,
        onKeyDownCapture: $b2160cc5bed4a8cb$var$onKey,
        onKeyUpCapture: $b2160cc5bed4a8cb$var$onKey,
        onTouchStartCapture: $b2160cc5bed4a8cb$var$abort,
        onTouchEndCapture: $b2160cc5bed4a8cb$var$abort,
        onPointerDownCapture: $b2160cc5bed4a8cb$var$abort,
        onPointerUpCapture: $b2160cc5bed4a8cb$var$abort,
        onClickCapture: $b2160cc5bed4a8cb$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $b2160cc5bed4a8cb$var$abort
    } : events;
}

});

parcelRegister("1ObgC", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b9c30dd6d7316a7$export$2e2bcd8739ae039);
parcelRequire("1v5pe");

var $5I7AE = parcelRequire("5I7AE");

var $kIqwl = parcelRequire("kIqwl");
function $4b9c30dd6d7316a7$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $4b9c30dd6d7316a7$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'rovo' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $4b9c30dd6d7316a7$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $5I7AE.default), {
        size: $4b9c30dd6d7316a7$var$getIconSpacing(spacing),
        appearance: $4b9c30dd6d7316a7$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? `${testId}--loading-spinner` : undefined
    });
}

});


parcelRegister("1TZ74", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c33814dfe247865$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");
parcelRequire("1v5pe");

var $kIqwl = parcelRequire("kIqwl");
const $2c33814dfe247865$var$_13 = "._tzy4idpf{opacity:0}";
const $2c33814dfe247865$var$_12 = "._v564g17y{transition:opacity .3s}";
const $2c33814dfe247865$var$_11 = "._uiztglyw{-webkit-user-select:none;-moz-user-select:none;user-select:none}";
const $2c33814dfe247865$var$_10 = "._vwz4idpf{line-height:0}";
const $2c33814dfe247865$var$_1 = "._1wybidpf{font-size:0}";
const $2c33814dfe247865$var$_0 = "._1wpz1h6o{align-self:center}";
const $2c33814dfe247865$var$_9 = "._1o9zidpf{flex-shrink:0}";
const $2c33814dfe247865$var$_8 = "._16jlidpf{flex-grow:0}";
const $2c33814dfe247865$var$_7 = "._1e0c1txw{display:flex}";
const $2c33814dfe247865$var$_6 = "._o5721q9c{white-space:nowrap}";
const $2c33814dfe247865$var$_5 = "._1bto1l2s{text-overflow:ellipsis}";
const $2c33814dfe247865$var$_4 = "._1o9zkb7n{flex-shrink:1}";
const $2c33814dfe247865$var$_3 = "._16jlkb7n{flex-grow:1}";
const $2c33814dfe247865$var$_2 = "._18m915vq{overflow-y:hidden}";
const $2c33814dfe247865$var$_ = "._1reo15vq{overflow-x:hidden}";
const $2c33814dfe247865$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
const $2c33814dfe247865$var$Content = ({ children: children, type: type = 'text', isLoading: isLoading })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $2c33814dfe247865$var$_,
                    $2c33814dfe247865$var$_2,
                    $2c33814dfe247865$var$_3,
                    $2c33814dfe247865$var$_4,
                    $2c33814dfe247865$var$_5,
                    $2c33814dfe247865$var$_6,
                    $2c33814dfe247865$var$_7,
                    $2c33814dfe247865$var$_8,
                    $2c33814dfe247865$var$_9,
                    $2c33814dfe247865$var$_0,
                    $2c33814dfe247865$var$_1,
                    $2c33814dfe247865$var$_10,
                    $2c33814dfe247865$var$_11,
                    $2c33814dfe247865$var$_12,
                    $2c33814dfe247865$var$_13
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
                className: (0, $hMvDh.default)([
                    $2c33814dfe247865$var$styles.common,
                    type === 'text' && $2c33814dfe247865$var$styles.text,
                    type === 'icon' && $2c33814dfe247865$var$styles.icon,
                    isLoading && $2c33814dfe247865$var$styles.fade
                ]),
                children: children
            })
        ]
    });
};
var $2c33814dfe247865$export$2e2bcd8739ae039 = $2c33814dfe247865$var$Content;

});

parcelRegister("lreqQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ba8d66f4aae8c37$export$2e2bcd8739ae039);
parcelRequire("1v5pe");

var $2aEiL = parcelRequire("2aEiL");

var $kIqwl = parcelRequire("kIqwl");
function $4ba8d66f4aae8c37$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * How far an icon can move past its box before it reaches the border of the button, which is the
 * space around the icon in the button minus the width of the border, so that the icon doesn't go
 * over the border. Passed to icon render props so that, for example, `IconMotion` can use it as its
 * `overshoot`. These are worked out once here, as every icon in every button goes through this file.
 */ const $4ba8d66f4aae8c37$var$OVERSHOOT_DEFAULT = `calc(${"var(--ds-space-100, 8px)"} - ${"var(--ds-border-width, 1px)"})`;
const $4ba8d66f4aae8c37$var$OVERSHOOT_COMPACT = `calc(${"var(--ds-space-050, 4px)"} - ${"var(--ds-border-width, 1px)"})`;
const $4ba8d66f4aae8c37$var$getOvershoot = (spacing)=>spacing === 'compact' ? $4ba8d66f4aae8c37$var$OVERSHOOT_COMPACT : $4ba8d66f4aae8c37$var$OVERSHOOT_DEFAULT;
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ const $4ba8d66f4aae8c37$var$IconRenderer = ({ icon: Icon, spacing: spacing })=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const isRenderProp = $4ba8d66f4aae8c37$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $2aEiL.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // Only a render prop can use `motionOvershoot`, so an icon component doesn't get it
    const icon = isRenderProp ? Icon({
        ...iconProps,
        motionOvershoot: $4ba8d66f4aae8c37$var$getOvershoot(spacing)
    }) : /*#__PURE__*/ (0, $kIqwl.jsx)(Icon, {
        ...iconProps
    });
    // @ts-expect-error -- The render-prop guard returns IconProp (a component type), which is not a ReactNode.
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kIqwl.Fragment), {
        children: icon
    });
};
var $4ba8d66f4aae8c37$export$2e2bcd8739ae039 = $4ba8d66f4aae8c37$var$IconRenderer;

});


parcelRegister("6p0OQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ceff5ba2cd41cd6899d33441cb75c99>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a95b6879649f707$var$_react = $4a95b6879649f707$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $4a95b6879649f707$var$_iconNew = $4a95b6879649f707$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $4a95b6879649f707$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-down
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4a95b6879649f707$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $4a95b6879649f707$var$_react.default.createElement($4a95b6879649f707$var$_iconNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$4a95b6879649f707$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $4a95b6879649f707$var$_default = module.exports.default = $4a95b6879649f707$var$ChevronDownIcon;

});

parcelRegister("See7r", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd264112f4a6872d04b33e03dd95c892>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0a3014644fe1d04b$var$_react = $0a3014644fe1d04b$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $0a3014644fe1d04b$var$_iconNew = $0a3014644fe1d04b$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $0a3014644fe1d04b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-up
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0a3014644fe1d04b$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $0a3014644fe1d04b$var$_react.default.createElement($0a3014644fe1d04b$var$_iconNew.default, Object.assign({
        name: "ChevronUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$0a3014644fe1d04b$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $0a3014644fe1d04b$var$_default = module.exports.default = $0a3014644fe1d04b$var$ChevronUpIcon;

});

parcelRegister("ebDRY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe87206c037b1ad46cb54a88ca95fa3b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a541050e0dc5b1ad$var$_react = $a541050e0dc5b1ad$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $a541050e0dc5b1ad$var$_iconNew = $a541050e0dc5b1ad$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $a541050e0dc5b1ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cross
 * Usage guidance:
 * Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a541050e0dc5b1ad$var$CrossIcon = (props)=>/*#__PURE__*/ $a541050e0dc5b1ad$var$_react.default.createElement($a541050e0dc5b1ad$var$_iconNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.53 3.53 9.06 8l4.47 4.47-1.06 1.06L8 9.06l-4.47 4.47-1.06-1.06L6.94 8 2.47 3.53l1.06-1.06L8 6.94l4.47-4.47z"/>`
    }, props));
$a541050e0dc5b1ad$var$CrossIcon.displayName = 'CrossIcon';
var $a541050e0dc5b1ad$var$_default = module.exports.default = $a541050e0dc5b1ad$var$CrossIcon;

});


parcelRegister("71SzD", function(module, exports) {
$parcel$export(module.exports, "default", () => $81d5f2ee349900f5$export$2e2bcd8739ae039);
/* expander.tsx generated by @compiled/babel-plugin v3.0.2 */ /* expander.tsx generated by @compiled/babel-plugin v3.0.2 */ parcelRequire("1v5pe");

var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $ky45w = parcelRequire("ky45w");

var $7dKqR = parcelRequire("7dKqR");

var $etMwD = parcelRequire("etMwD");

var $7M9W5 = parcelRequire("7M9W5");

var $2aEiL = parcelRequire("2aEiL");

var $8GxWE = parcelRequire("8GxWE");

var $2txLH = parcelRequire("2txLH");

var $kIqwl = parcelRequire("kIqwl");
const $81d5f2ee349900f5$var$_7 = "._v5641xzp{transition:max-height .3s}";
const $81d5f2ee349900f5$var$_6 = "._18m915vq{overflow-y:hidden}";
const $81d5f2ee349900f5$var$_5 = "._1reo15vq{overflow-x:hidden}";
const $81d5f2ee349900f5$var$_4 = "@media (prefers-reduced-motion:reduce){._156yru3m{transition-duration:0s}}";
const $81d5f2ee349900f5$var$_3 = "._1oec1mzy{transition-duration:var(--ds-duration-long,.25s)}";
const $81d5f2ee349900f5$var$_2 = "._k8m0wor5{transition-property:max-height}";
const $81d5f2ee349900f5$var$_ = "._1bsb1osq{width:100%}";
const $81d5f2ee349900f5$var$styles = {
    expander: "_1bsb1osq",
    expanderTransition: "_k8m0wor5 _1oec1mzy _156yru3m",
    expanderCollapsed: "_1reo15vq _18m915vq",
    container: "_v5641xzp"
};
const $81d5f2ee349900f5$var$Expander = ({ children: children, isExpanded: isExpanded, testId: testId })=>{
    const isCollapseAnimationEnabled = (0, $2aEiL.fg)('platform-dst-flag-collapse-animation-fix'); // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $81d5f2ee349900f5$var$_,
                    $81d5f2ee349900f5$var$_2,
                    $81d5f2ee349900f5$var$_3,
                    $81d5f2ee349900f5$var$_4,
                    $81d5f2ee349900f5$var$_5,
                    $81d5f2ee349900f5$var$_6,
                    $81d5f2ee349900f5$var$_7
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8GxWE.Box), {
                xcss: (0, $ky45w.cx)($81d5f2ee349900f5$var$styles.expander, isCollapseAnimationEnabled && $81d5f2ee349900f5$var$styles.expanderTransition, isCollapseAnimationEnabled && !isExpanded && $81d5f2ee349900f5$var$styles.expanderCollapsed),
                style: {
                    maxHeight: isExpanded ? 150 : 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    flex: '1 1 100%',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    minWidth: 0
                },
                "aria-hidden": !isExpanded,
                testId: testId && `${testId}-expander`,
                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7dKqR.default), {
                    appear: true,
                    children: isExpanded && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $etMwD.default), {
                        children: (props)=>/*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                                children: [
                                    /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                                        children: [
                                            $81d5f2ee349900f5$var$_,
                                            $81d5f2ee349900f5$var$_2,
                                            $81d5f2ee349900f5$var$_3,
                                            $81d5f2ee349900f5$var$_4,
                                            $81d5f2ee349900f5$var$_5,
                                            $81d5f2ee349900f5$var$_6,
                                            $81d5f2ee349900f5$var$_7
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8GxWE.Box), {
                                        xcss: (0, $ky45w.cx)(!isCollapseAnimationEnabled && $81d5f2ee349900f5$var$styles.container),
                                        ...props,
                                        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $2txLH.Stack), {
                                            space: "space.100",
                                            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7M9W5.default), {
                                                children: children
                                            })
                                        })
                                    })
                                ]
                            })
                    })
                })
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$81d5f2ee349900f5$export$2e2bcd8739ae039 = $81d5f2ee349900f5$var$Expander;

});

parcelRegister("lJzVc", function(module, exports) {
$parcel$export(module.exports, "useFlagGroup", () => $4faa4dfa36d18dc9$export$e91ea202abb66350);

var $1v5pe = parcelRequire("1v5pe");

var $3FPgO = parcelRequire("3FPgO");
function $4faa4dfa36d18dc9$export$e91ea202abb66350() {
    return (0, $1v5pe.useContext)((0, $3FPgO.FlagGroupContext));
}

});
parcelRegister("3FPgO", function(module, exports) {
$parcel$export(module.exports, "FlagGroupContext", () => $526eafbf86f5e804$export$c57ba665aaa722be);

var $1v5pe = parcelRequire("1v5pe");

var $a5tDy = parcelRequire("a5tDy");
const $526eafbf86f5e804$export$c57ba665aaa722be = /*#__PURE__*/ (0, $1v5pe.createContext)((0, $a5tDy.defaultFlagGroupContext));

});
parcelRegister("a5tDy", function(module, exports) {
$parcel$export(module.exports, "defaultFlagGroupContext", () => $ed99b1743641ad7e$export$643760c4938da30d);

var $aD9yk = parcelRequire("aD9yk");
const $ed99b1743641ad7e$export$643760c4938da30d = {
    onDismissed: (0, $aD9yk.default),
    isDismissAllowed: false
};

});





parcelRegister("5fHZY", function(module, exports) {
$parcel$export(module.exports, "FlagGroup", () => $a4a70ae210ad0f34$export$a2c3479950310d7d);
$parcel$export(module.exports, "default", () => $a4a70ae210ad0f34$export$2e2bcd8739ae039);
/* flag-group.tsx generated by @compiled/babel-plugin v3.0.2 */ /* flag-group.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $dmmsG = parcelRequire("dmmsG");

var $8g8jL = parcelRequire("8g8jL");

var $brxde = parcelRequire("brxde");

var $ky45w = parcelRequire("ky45w");

var $aD9yk = parcelRequire("aD9yk");

var $3q5kf = parcelRequire("3q5kf");

var $eTbg2 = parcelRequire("eTbg2");

var $7dKqR = parcelRequire("7dKqR");

var $Udtso = parcelRequire("Udtso");

var $2aEiL = parcelRequire("2aEiL");

var $kARP4 = parcelRequire("kARP4");

var $8GxWE = parcelRequire("8GxWE");

var $iMM0r = parcelRequire("iMM0r");

var $jL9lp = parcelRequire("jL9lp");

var $kFr83 = parcelRequire("kFr83");

var $a5tDy = parcelRequire("a5tDy");

var $3FPgO = parcelRequire("3FPgO");

var $kIqwl = parcelRequire("kIqwl");
const $a4a70ae210ad0f34$var$_22 = "@media (max-width:560px){._il0widpf{inset-inline-start:0}}";
const $a4a70ae210ad0f34$var$_21 = "._1e02oahv{inset-inline-start:var(--ds-space-600,3pc)}";
const $a4a70ae210ad0f34$var$_20 = "._1pby1wug{z-index:auto}";
const $a4a70ae210ad0f34$var$_19 = "@media (max-width:560px){._1iafidpf{inset-block-end:0}._il0widpf{inset-inline-start:0}}";
const $a4a70ae210ad0f34$var$_18 = "._1e021epz{inset-inline-start:var(--ds-space-1000,5pc)}";
const $a4a70ae210ad0f34$var$_17 = "._u7cooahv{inset-block-end:var(--ds-space-600,3pc)}";
const $a4a70ae210ad0f34$var$_16 = "._1pbyxejw{z-index:flag}";
const $a4a70ae210ad0f34$var$_15 = "._kqsw1n9t{position:fixed}";
const $a4a70ae210ad0f34$var$_14 = "._12a7luct._12a7luct+*{transition-duration:175ms}";
const $a4a70ae210ad0f34$var$_13 = "._t9ec1hw2{transform:translateX(0) translateY(100%) translateY(1pc)}";
const $a4a70ae210ad0f34$var$_12 = "._5sag5cps{animation-duration:0ms}";
const $a4a70ae210ad0f34$var$_11 = "._v564glyw{transition:none}";
const $a4a70ae210ad0f34$var$_10 = "._v5641b8g{transition:transform .35s ease-in-out}";
const $a4a70ae210ad0f34$var$_1 = "._3um015vq{visibility:hidden}";
const $a4a70ae210ad0f34$var$_0 = "._t9ec15wd{transform:translateY(200%) translateY(2pc)}";
const $a4a70ae210ad0f34$var$_9 = "._1pbyegat{z-index:4}";
const $a4a70ae210ad0f34$var$_8 = "._t9ec1pi4{transform:translateY(100%) translateY(1pc)}";
const $a4a70ae210ad0f34$var$_7 = "._1pbyqfx8{z-index:5}";
const $a4a70ae210ad0f34$var$_6 = "._t9ec1ygq{transform:translate(0,0)}";
const $a4a70ae210ad0f34$var$_5 = "@media (max-width:560px){._1eqkauwl{width:100vw}}";
const $a4a70ae210ad0f34$var$_4 = "._1bsb1kdj{width:25pc}";
const $a4a70ae210ad0f34$var$_3 = "._u7coidpf{inset-block-end:0}";
const $a4a70ae210ad0f34$var$_2 = "._kqswstnw{position:absolute}";
const $a4a70ae210ad0f34$var$_ = "._v564t8bh{transition:var(--ds-flag-reposition,transform .25s cubic-bezier(.4,0,0,1))}";
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $a4a70ae210ad0f34$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $a4a70ae210ad0f34$var$groupStylesNew = {
    root: "_v564t8bh _kqswstnw _u7coidpf _1bsb1kdj _1eqkauwl",
    first: "_t9ec1ygq _1pbyqfx8",
    second: "_t9ec1pi4 _1pbyegat",
    nth: "_t9ec15wd",
    hidden: "_3um015vq"
}; // Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
const $a4a70ae210ad0f34$var$dismissAllowedStyles = null;
const $a4a70ae210ad0f34$var$flagGroupContainerStyles = null; // When rendering in top layer, z-index is redundant (top layer stacks above everything).
// Override to avoid leaving an explicit z-index on the container.
const $a4a70ae210ad0f34$var$flagGroupContainerStylesTopLayer = null; // cc_mohiti_flag_anchoring: update left inset from space.1000 (80px) to space.600 (48px)
// to match the bottom inset and produce a symmetric 48px × 48px anchor.
// The 80px left offset was a legacy artefact from the old left-rail nav sidebar.
// The mobile reset is mirrored from the base style so the override is self-contained
// and doesn't depend on @compiled's atomic CSS emit order at the ≤560px breakpoint.
const $a4a70ae210ad0f34$var$flagGroupContainerStylesSymmetric = null; /**
                                                 * Tells the flag group when a flag mounts and unmounts. A flag stays mounted
                                                 * while its exit animation plays, so the count includes exiting flags.
                                                 */ 
function $a4a70ae210ad0f34$var$FlagPresence({ onChange: onChange }) {
    (0, $3q5kf.useLayoutEffect)(()=>{
        onChange(1);
        return ()=>onChange(-1);
    }, [
        onChange
    ]);
    return null;
} /**
   * __Flag group__
   *
   * A flag group is used to group a set of related flags, with entry and exit animations.
   *
   * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
   * - [Code](https://atlassian.design/components/flag/flag-group/code)
   */ 
const $a4a70ae210ad0f34$export$a2c3479950310d7d = (props)=>{
    const { id: id, label: label = 'Flag notifications', labelTag: LabelTag = 'h2', shouldRenderToParent: shouldRenderToParent = false, children: children, onDismissed: onDismissed = (0, $aD9yk.default) } = props;
    const hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    const useTopLayer = (0, $2aEiL.fg)('platform-dst-top-layer'); // Top layer only. The host renders in place, so an open host with no flags
    // adds an empty element to the consumer's DOM. Open the host only while a
    // flag is mounted, including a flag that plays its exit animation.
    const [mountedFlagCount, setMountedFlagCount] = (0, $1v5pe.useState)(0);
    const onFlagPresenceChange = (0, $1v5pe.useCallback)((delta)=>{
        setMountedFlagCount((count)=>count + delta);
    }, []); // `hasFlags` opens the host for the first flag: flags count themselves from
    // inside the host, so the count is 0 until the host renders. The count keeps
    // the host open after the last flag leaves `children` but is still exiting.
    const isHostOpen = hasFlags || mountedFlagCount > 0; // Top layer only. The host mounts with its first flag, so that flag must
    // animate in. Flags that are present when the group mounts do not animate,
    // as on the portal path.
    const hasMountedRef = (0, $1v5pe.useRef)(false);
    (0, $1v5pe.useEffect)(()=>{
        hasMountedRef.current = true;
    }, []);
    const dismissFlagContext = (0, $1v5pe.useMemo)(()=>({
            onDismissed: onDismissed,
            isDismissAllowed: true
        }), [
        onDismissed
    ]); // Keep a stable reference to the latest children, dismiss handler, and
    // analytics creator so the keydown listener never reads stale closures.
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $8g8jL.useAnalyticsEvents)();
    const latestRef = (0, $1v5pe.useRef)({
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    });
    latestRef.current = {
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    }; // Accessibility (JRACLOUD-97876): allow keyboard-only and assistive
    // technology users to dismiss the topmost (and only dismissable) flag with
    // the Escape key, without having to tab through the entire page to reach
    // the dismiss button. Behaviour is gated behind a feature flag so it can
    // be rolled out and validated incrementally.
    (0, $1v5pe.useEffect)(()=>{
        if (!(0, $2aEiL.fg)('platform_dst_flag_keyboard_dismiss')) return;
        if (!hasFlags) return;
        const doc = (0, $brxde.getDocument)();
        if (!doc) return;
        const timeoutIds = new Set();
        const unbind = (0, $dmmsG.bind)(doc, {
            type: 'keydown',
            listener: (event)=>{
                if (event.key !== 'Escape' || event.defaultPrevented) return;
                const currentChildren = latestRef.current.children;
                const firstFlag = Array.isArray(currentChildren) ? currentChildren.find(Boolean) : currentChildren;
                if (!firstFlag || typeof firstFlag !== 'object') return;
                const id = firstFlag.props?.id;
                if (id === undefined || id === null || id === '') return;
                const analyticsEvent = latestRef.current.createAnalyticsEvent({
                    action: 'dismissed',
                    actionSubject: 'flag',
                    attributes: {
                        dismissedVia: 'keyboardShortcut',
                        key: 'Escape'
                    }
                });
                const timeoutId = setTimeout(()=>{
                    timeoutIds.delete(timeoutId);
                    if (event.defaultPrevented) return;
                    event.preventDefault();
                    latestRef.current.onDismissed?.(id, analyticsEvent);
                });
                timeoutIds.add(timeoutId);
            },
            options: {
                capture: true
            }
        });
        return ()=>{
            unbind();
            timeoutIds.forEach(clearTimeout);
            timeoutIds.clear();
        };
    }, [
        hasFlags
    ]);
    const renderChildren = ()=>{
        return children && typeof children === 'object' ? (0, $1v5pe.Children).map(children, (flag, index)=>{
            const isDismissAllowed = index === 0;
            return (0, $2aEiL.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                children: [
                    /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                        children: [
                            $a4a70ae210ad0f34$var$_,
                            $a4a70ae210ad0f34$var$_2,
                            $a4a70ae210ad0f34$var$_3,
                            $a4a70ae210ad0f34$var$_4,
                            $a4a70ae210ad0f34$var$_5,
                            $a4a70ae210ad0f34$var$_6,
                            $a4a70ae210ad0f34$var$_7,
                            $a4a70ae210ad0f34$var$_8,
                            $a4a70ae210ad0f34$var$_9,
                            $a4a70ae210ad0f34$var$_0,
                            $a4a70ae210ad0f34$var$_1
                        ]
                    }),
                    /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8GxWE.Box), {
                        xcss: (0, $ky45w.cx)($a4a70ae210ad0f34$var$groupStylesNew.root, index === 0 && $a4a70ae210ad0f34$var$groupStylesNew.first, index === 1 && $a4a70ae210ad0f34$var$groupStylesNew.second, index >= 2 && $a4a70ae210ad0f34$var$groupStylesNew.nth, index >= 3 && $a4a70ae210ad0f34$var$groupStylesNew.hidden),
                        "data-vc-oob": true,
                        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eTbg2.default), {
                            enteringAnimation: "var(--ds-flag-enter, 250ms cubic-bezier(0, 0.4, 0, 1) SlideIn50PercentLeft, 250ms cubic-bezier(0, 0.4, 0, 1) FadeIn0to100)",
                            exitingAnimation: "var(--ds-flag-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOut15PercentLeft, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                            children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $3FPgO.FlagGroupContext).Provider, {
                                value: // Only the first flag should be able to be dismissed.
                                isDismissAllowed ? dismissFlagContext : (0, $a5tDy.defaultFlagGroupContext),
                                children: [
                                    flag,
                                    useTopLayer ? /*#__PURE__*/ (0, $kIqwl.jsx)($a4a70ae210ad0f34$var$FlagPresence, {
                                        onChange: onFlagPresenceChange
                                    }) : null
                                ]
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $kIqwl.jsx)((0, $Udtso.default), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in",
                children: ({ className: className, ref: ref })=>/*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                        children: [
                            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                                children: [
                                    $a4a70ae210ad0f34$var$_10,
                                    $a4a70ae210ad0f34$var$_4,
                                    $a4a70ae210ad0f34$var$_2,
                                    $a4a70ae210ad0f34$var$_3,
                                    $a4a70ae210ad0f34$var$_5,
                                    $a4a70ae210ad0f34$var$_11,
                                    $a4a70ae210ad0f34$var$_6,
                                    $a4a70ae210ad0f34$var$_7,
                                    $a4a70ae210ad0f34$var$_9,
                                    $a4a70ae210ad0f34$var$_12,
                                    $a4a70ae210ad0f34$var$_13,
                                    $a4a70ae210ad0f34$var$_1,
                                    $a4a70ae210ad0f34$var$_14
                                ]
                            }),
                            /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: (0, $hMvDh.default)([
                                    $a4a70ae210ad0f34$var$groupStyles.root,
                                    index === 0 && $a4a70ae210ad0f34$var$groupStyles.first,
                                    index === 1 && $a4a70ae210ad0f34$var$groupStyles.second,
                                    index >= 1 && $a4a70ae210ad0f34$var$groupStyles.nth,
                                    index >= 2 && $a4a70ae210ad0f34$var$groupStyles.hidden,
                                    isDismissAllowed && "_12a7luct",
                                    className
                                ]),
                                ref: ref,
                                "data-vc-oob": true,
                                children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $3FPgO.FlagGroupContext).Provider, {
                                    value: // Only the first flag should be able to be dismissed.
                                    isDismissAllowed ? dismissFlagContext : (0, $a5tDy.defaultFlagGroupContext),
                                    children: [
                                        flag,
                                        useTopLayer ? /*#__PURE__*/ (0, $kIqwl.jsx)($a4a70ae210ad0f34$var$FlagPresence, {
                                            onChange: onFlagPresenceChange
                                        }) : null
                                    ]
                                })
                            })
                        ]
                    })
            });
        }) : false;
    };
    const useSymmetricAnchor = (0, $2aEiL.fg)('cc_mohiti_flag_anchoring');
    const isKeyboardDismissEnabled = (0, $2aEiL.fg)('platform_dst_flag_keyboard_dismiss'); // When the keyboard dismiss shortcut is available, surface it to assistive
    // technology users via the existing visually-hidden landmark heading so they
    // know they can press Escape to dismiss the topmost flag.
    const screenReaderLabel = isKeyboardDismissEnabled ? `${label}. Press Escape to dismiss.` : label;
    const flags = /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $a4a70ae210ad0f34$var$_15,
                    $a4a70ae210ad0f34$var$_16,
                    $a4a70ae210ad0f34$var$_17,
                    $a4a70ae210ad0f34$var$_18,
                    $a4a70ae210ad0f34$var$_19,
                    $a4a70ae210ad0f34$var$_20,
                    $a4a70ae210ad0f34$var$_21,
                    $a4a70ae210ad0f34$var$_22
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsxs)("div", {
                id: id,
                "data-vc-oob": true,
                className: (0, $hMvDh.default)([
                    "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf",
                    useTopLayer && "_1pby1wug",
                    useSymmetricAnchor && "_1e02oahv _il0widpf"
                ]),
                children: [
                    hasFlags ? /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kFr83.default), {
                        children: /*#__PURE__*/ (0, $kIqwl.jsx)(LabelTag, {
                            children: screenReaderLabel
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7dKqR.default), {
                        appear: useTopLayer && hasMountedRef.current,
                        children: renderChildren()
                    })
                ]
            })
        ]
    });
    if (useTopLayer) // Render no host (and run no Popover hooks) until a flag mounts.
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1v5pe.Fragment), {
        children: isHostOpen ? /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jL9lp.Popover), {
            mode: "manual",
            isOpen: true,
            children: flags
        }) : null
    });
    return shouldRenderToParent ? flags : /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kARP4.default), {
        zIndex: (0, $iMM0r.layers).flag(),
        children: flags
    });
};
var /* eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of this deprecated default export shim. */ /**
 * @deprecated Use `import { FlagGroup } from '@atlaskit/flag/flag-group'` instead.
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports -- VOLTC-139 tracks removal of this deprecated default export shim.
$a4a70ae210ad0f34$export$2e2bcd8739ae039 = $a4a70ae210ad0f34$export$a2c3479950310d7d;

});
parcelRegister("eTbg2", function(module, exports) {
$parcel$export(module.exports, "default", () => $92019df934d4049f$export$2e2bcd8739ae039);
/* motion.tsx generated by @compiled/babel-plugin v3.0.2 */ /* motion.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $1v5pe = parcelRequire("1v5pe");

var $ky45w = parcelRequire("ky45w");

var $fl4ll = parcelRequire("fl4ll");

var $2aEiL = parcelRequire("2aEiL");

var $UulbM = parcelRequire("UulbM");

var $lRoch = parcelRequire("lRoch");

var $9RhH4 = parcelRequire("9RhH4");

var $f7sGY = parcelRequire("f7sGY");

var $4hd7B = parcelRequire("4hd7B");

var $cUr2h = parcelRequire("cUr2h");

var $ipFVY = parcelRequire("ipFVY");

var $d1xmU = parcelRequire("d1xmU");

var $kIqwl = parcelRequire("kIqwl");
const $92019df934d4049f$var$_3 = "._3um015vq{visibility:hidden}";
const $92019df934d4049f$var$_2 = "@media (prefers-reduced-motion:reduce){._1bumglyw{animation:none}._sedtglyw{transition:none}}";
const $92019df934d4049f$var$_ = "._1y0co91m{animation-play-state:running}";
const $92019df934d4049f$var$initialStateByAction = {
    enter: 'visible',
    exit: 'hidden'
};
const $92019df934d4049f$var$styles = {
    base: "_1y0co91m _1bumglyw _sedtglyw",
    hidden: "_3um015vq"
};
/**
 * Legacy implementation of `Motion` that inlines the animation lifecycle.
 * Used when the `platform-dst-use-motion` feature gate is off.
 */ const $92019df934d4049f$var$MotionLegacy = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ children: children, enteringAnimation: enteringAnimation, enteringAnimationXcss: enteringAnimationXcss, exitingAnimation: exitingAnimation, exitingAnimationXcss: exitingAnimationXcss, onFinish: onFinishMotion, xcss: xcss, style: styleProp, testId: testId }, ref)=>{
    const staggered = (0, $d1xmU.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $cUr2h.useExitingPersistence)();
    const staggeredDelay = isExiting ? 0 : staggered.delay;
    const staggedIsReady = staggered.isReady;
    const [state, setState] = (0, $1v5pe.useState)(appear ? staggedIsReady && !staggeredDelay ? 'entering' : 'init' : 'idle');
    const elementRef = (0, $1v5pe.useRef)(null);
    const reanimateRef = (0, $1v5pe.useRef)();
    const animationRef = (0, $1v5pe.useRef)();
    const staggeredEntryRef = (0, $1v5pe.useRef)();
    (0, $1v5pe.useEffect)(()=>{
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]); // Handles staggered entry
    (0, $1v5pe.useEffect)(()=>{
        if (state !== 'init') return; // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(()=>{
            setState('entering');
        }, staggeredDelay);
        return ()=>{
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        state,
        staggedIsReady,
        staggeredDelay
    ]); /**
                                                * Updates relevant state.
                                                * Called when the animation is finished, or immediately with reduced motion.
                                                */ 
    const onAnimationEnd = (0, $1v5pe.useCallback)((state, cancelled)=>{
        // We are done animating, so we set the state to idle
        let newState = 'idle';
        if (state === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished?.();
            onFinishMotion?.('exiting');
        }
        if (state === 'entering') onFinishMotion?.('entering');
        if (reanimateRef.current === (0, $4hd7B.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $4hd7B.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        if (!cancelled) setState(newState);
         // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    (0, $1v5pe.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (!staggedIsReady) return;
         // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        } // If the state is idle or init, we don't need to do anything
        if (state === 'idle' || state === 'init') return;
         // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if ((0, $9RhH4.isReducedMotion)() || !exitingAnimation && !exitingAnimationXcss) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        let animationDuration = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    const animationTimings = (0, $lRoch.getDurationMs)((0, $f7sGY.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    const styles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $UulbM.getComputedAnimationDurationMs)(styles.animationName, styles.animationDuration, styles.animationDelay);
                }
            }
        } // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting' && (exitingAnimation || exitingAnimationXcss)) animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), animationDuration);
        else if (state === 'entering' && (enteringAnimation || enteringAnimationXcss)) animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), animationDuration);
        return ()=>{
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        }; // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        exitingAnimation,
        enteringAnimation,
        exitingAnimationXcss,
        enteringAnimationXcss,
        staggeredDelay,
        staggedIsReady
    ]);
    (0, $1v5pe.useImperativeHandle)(ref, ()=>({
            reanimate: (value)=>{
                animationRef.current && clearTimeout(animationRef.current);
                reanimateRef.current = value;
                if (value === (0, $4hd7B.Reanimate).exit_then_enter) setState('exiting');
                else if (value === (0, $4hd7B.Reanimate).enter) setState('entering');
            }
        }));
    let style = {};
    let customAnimation;
    if (state === 'entering') {
        if (enteringAnimation) style.animation = enteringAnimation;
        else if (enteringAnimationXcss) customAnimation = enteringAnimationXcss;
    } else if (state === 'exiting') {
        if (exitingAnimation) style.animation = exitingAnimation;
        else if (exitingAnimationXcss) customAnimation = exitingAnimationXcss;
    }
    const hasAnimationStyles = state !== 'idle' && state !== 'init';
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $92019df934d4049f$var$_,
                    $92019df934d4049f$var$_2,
                    $92019df934d4049f$var$_3
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
                className: (0, $hMvDh.default)([
                    hasAnimationStyles && $92019df934d4049f$var$styles.base,
                    state === 'init' && $92019df934d4049f$var$styles.hidden,
                    (0, $ky45w.cx)(xcss, customAnimation)
                ]),
                ref: (0, $fl4ll.default)([
                    staggered.ref,
                    elementRef
                ]) // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                ,
                style: styleProp || hasAnimationStyles ? {
                    ...styleProp,
                    ...style
                } : undefined,
                "data-testid": testId,
                children: children
            })
        ]
    });
});
/**
 * Implementation of `Motion` built on top of the `useMotion` hook.
 * Used when the `platform-dst-use-motion` feature gate is on.
 */ const $92019df934d4049f$var$MotionNext = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ children: children, enteringAnimation: enteringAnimation, enteringAnimationXcss: enteringAnimationXcss, exitingAnimation: exitingAnimation, exitingAnimationXcss: exitingAnimationXcss, onFinish: onFinishMotion, action: action, xcss: xcss, style: styleProp, testId: testId }, ref)=>{
    const { state: state, ref: motionRef, reanimate: reanimate } = (0, $ipFVY.useMotion)({
        onFinish: onFinishMotion,
        initialState: action ? $92019df934d4049f$var$initialStateByAction[action] : undefined
    });
    (0, $1v5pe.useImperativeHandle)(ref, ()=>({
            reanimate: reanimate
        }), [
        reanimate
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (action === 'exit' && state !== 'exiting' && state !== 'hidden') reanimate((0, $4hd7B.Reanimate).exit);
        else if (action === 'enter' && (state === 'exiting' || state === 'hidden')) reanimate((0, $4hd7B.Reanimate).enter);
    }, [
        action,
        reanimate,
        state
    ]);
    if (state === 'hidden') return null;
     // `xcss` and `style` apply to the wrapper `<div>` the `Motion` component renders,
    // so they are merged here (not in the hook) alongside the hook's animation output.
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $92019df934d4049f$var$_,
                    $92019df934d4049f$var$_2,
                    $92019df934d4049f$var$_3
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
                className: (0, $hMvDh.default)([
                    state === 'init' && $92019df934d4049f$var$styles.hidden,
                    (0, $ky45w.cx)(xcss, state === 'entering' && enteringAnimationXcss, state === 'exiting' && exitingAnimationXcss)
                ]),
                ref: motionRef,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    ...styleProp,
                    animation: state === 'entering' ? enteringAnimation : state === 'exiting' ? exitingAnimation : undefined
                },
                "data-testid": testId,
                children: children
            })
        ]
    });
}); /**
     * __Motion__
     *
     * A motion primitive that can be used to animate the entry and exit of components.
     */ 
const $92019df934d4049f$var$Motion = /*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>{
    if ((0, $2aEiL.fg)('platform-dst-use-motion')) return /*#__PURE__*/ (0, $kIqwl.jsx)($92019df934d4049f$var$MotionNext, {
        ...props,
        ref: ref
    });
    return /*#__PURE__*/ (0, $kIqwl.jsx)($92019df934d4049f$var$MotionLegacy, {
        ...props,
        ref: ref
    });
}); // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $92019df934d4049f$export$2e2bcd8739ae039 = $92019df934d4049f$var$Motion;

});
parcelRegister("UulbM", function(module, exports) {
$parcel$export(module.exports, "getComputedAnimationDurationMs", () => $96622127ffe45781$export$dd9b73a7482d05b6);

var $786Ge = parcelRequire("786Ge");
const $96622127ffe45781$var$cssTimePattern = /^-?(?:\d+\.?\d*|\.\d+)(?:ms|s)$/;
const $96622127ffe45781$var$toCssList = (value)=>value.split(',').map((item)=>item.trim()).filter(Boolean);
const $96622127ffe45781$var$toTimeList = (value)=>$96622127ffe45781$var$toCssList(value).filter((time)=>$96622127ffe45781$var$cssTimePattern.test(time)).map((0, $786Ge.convertToMs));
const $96622127ffe45781$export$dd9b73a7482d05b6 = (animationName, animationDuration, animationDelay)=>{
    const names = $96622127ffe45781$var$toCssList(animationName);
    const durations = $96622127ffe45781$var$toTimeList(animationDuration);
    const delays = $96622127ffe45781$var$toTimeList(animationDelay);
    if (names.length === 0 || durations.length === 0) return 0;
    let longestDuration = 0;
    for(let index = 0; index < names.length; index++){
        if (names[index] === 'none') continue;
        const duration = durations[index % durations.length];
        const delay = delays.length > 0 ? delays[index % delays.length] : 0;
        longestDuration = Math.max(longestDuration, duration + delay);
    }
    return longestDuration;
};

});
parcelRegister("786Ge", function(module, exports) {
$parcel$export(module.exports, "convertToMs", () => $ef817f2551057089$export$75eee42ff540d8ae);
const $ef817f2551057089$export$75eee42ff540d8ae = (duration)=>{
    // Use regex to separate the number and the unit
    const matches = duration.match(/^(-?(?:\d+\.?\d*|\.\d+))(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    const value = parseFloat(matches[1]);
    const unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};

});


parcelRegister("lRoch", function(module, exports) {
$parcel$export(module.exports, "getDurationMs", () => $fb3e2d7216a3a769$export$d0038b6e47881463);
/**
 * Gets the duration in milliseconds for an animation property.
 * @param animation - The animation property to get the duration for.
 * @returns The duration in milliseconds.
 */ const $fb3e2d7216a3a769$export$d0038b6e47881463 = (animation)=>{
    const animations = animation.split(/,(?![^()]*\))/).map((value)=>[
            ...value.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g)
        ]).filter((matches)=>matches.length > 0);
    if (animations.length === 0) return {
        duration: 0,
        delay: 0
    };
    return animations.reduce((longest, matches)=>{
        const toMilliseconds = (match)=>{
            const value = parseFloat(match[1]);
            return match[2] === 's' ? value * 1000 : value;
        };
        const timing = {
            duration: toMilliseconds(matches[0]),
            delay: matches[1] ? toMilliseconds(matches[1]) : 0
        };
        return timing.duration + timing.delay > longest.duration + longest.delay ? timing : longest;
    }, {
        duration: 0,
        delay: 0
    });
};

});

parcelRegister("f7sGY", function(module, exports) {
$parcel$export(module.exports, "resolveMotionToken", () => $fd94014fe9d0dcc4$export$82b92541889a035d);

var $brxde = parcelRequire("brxde");
const $fd94014fe9d0dcc4$export$82b92541889a035d = (token)=>{
    const cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    const cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        const documentElement = (0, $brxde.getDocument)()?.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};

});

parcelRegister("4hd7B", function(module, exports) {
$parcel$export(module.exports, "Reanimate", () => $bc9efd492531bba5$export$569340a66b14e0dc);
/**
 * Supported reanimate values.
 * 'enter' will re-enter the animation.
 * 'exit-then-enter' will exit the animation and then enter it again.
 */ var $bc9efd492531bba5$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    Reanimate["exit"] = "exit";
    return Reanimate;
}({});

});

parcelRegister("ipFVY", function(module, exports) {
$parcel$export(module.exports, "useMotion", () => $345db73f9506cb2e$export$2a51cfe9390d36ef);
/* use-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ /* use-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ // Exposes start and finish callbacks while useMotion coordinates the animation lifecycle.

var $1v5pe = parcelRequire("1v5pe");

var $fl4ll = parcelRequire("fl4ll");

var $UulbM = parcelRequire("UulbM");

var $lRoch = parcelRequire("lRoch");

var $9RhH4 = parcelRequire("9RhH4");

var $f7sGY = parcelRequire("f7sGY");

var $fRsBS = parcelRequire("fRsBS");

var $4hd7B = parcelRequire("4hd7B");

var $cUr2h = parcelRequire("cUr2h");

var $d1xmU = parcelRequire("d1xmU");
function $345db73f9506cb2e$export$2a51cfe9390d36ef({ onFinish: onFinishMotion, onStart: onStartMotion, initialState: initialState } = {}) {
    const reducedMotion = (0, $9RhH4.isReducedMotion)();
    const staggered = (0, $d1xmU.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $cUr2h.useExitingPersistence)();
    const staggeredDelay = isExiting ? 0 : staggered.delay;
    const staggeredIsReady = staggered.isReady;
    const [state, setState] = (0, $1v5pe.useState)(initialState ?? (appear ? staggeredIsReady && !staggeredDelay ? 'entering' : 'init' : 'visible')); // ExitingPersistence must win during render so consumers apply exit styles before layout effects.
    // The lifecycle effect below uses the same value to measure and finish that exit.
    const motionState = isExiting ? 'exiting' : state;
    const elementRef = (0, $1v5pe.useRef)(null);
    const onFinishMotionRef = (0, $1v5pe.useRef)(onFinishMotion);
    onFinishMotionRef.current = onFinishMotion;
    const onStartMotionRef = (0, $1v5pe.useRef)(onStartMotion);
    onStartMotionRef.current = onStartMotion;
    const onExitFinishedRef = (0, $1v5pe.useRef)(onExitFinished);
    onExitFinishedRef.current = onExitFinished;
    const reanimateRef = (0, $1v5pe.useRef)();
    const animationRef = (0, $1v5pe.useRef)();
    const staggeredEntryRef = (0, $1v5pe.useRef)();
    (0, $fRsBS.useLayoutEffect)(()=>{
        if (motionState === 'exiting') onStartMotionRef.current?.('exiting');
        if (motionState === 'entering') onStartMotionRef.current?.('entering');
    }, [
        motionState
    ]); /**
                      * Updates relevant state.
                      * Called when the animation is finished, or immediately with reduced motion.
                      */ 
    const onAnimationEnd = (0, $1v5pe.useCallback)((currentState, cancelled)=>{
        // We are done animating, so we set the state to visible
        let newState = 'visible';
        if (currentState === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinishedRef.current?.();
            onFinishMotionRef.current?.('exiting');
        }
        if (currentState === 'entering') onFinishMotionRef.current?.('entering');
        if (reanimateRef.current === (0, $4hd7B.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $4hd7B.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current === (0, $4hd7B.Reanimate).enter) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        else if (reanimateRef.current === (0, $4hd7B.Reanimate).exit) {
            // We are done reanimating, so we clear the reanimate state
            reanimateRef.current = undefined;
            newState = 'hidden';
        }
        if (!cancelled) setState(newState);
         // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Handles staggered entry
    (0, $1v5pe.useEffect)(()=>{
        if (state !== 'init') return;
        if (reducedMotion) {
            onAnimationEnd('entering', false);
            return;
        } // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(()=>{
            setState('entering');
        }, staggeredDelay);
        return ()=>{
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        onAnimationEnd,
        state,
        staggeredIsReady,
        staggeredDelay,
        reducedMotion
    ]);
    (0, $1v5pe.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (!staggeredIsReady) return;
         // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        } // If the state is visible, hidden or init, we don't need to do anything
        if (motionState === 'visible' || motionState === 'init' || motionState === 'hidden') return;
         // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if (reducedMotion) {
            onAnimationEnd(motionState, isCancelled);
            return;
        }
        let animationDuration = 0;
        if (motionState === 'entering' || motionState === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    const animationTimings = (0, $lRoch.getDurationMs)((0, $f7sGY.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    const computedStyles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $UulbM.getComputedAnimationDurationMs)(computedStyles.animationName, computedStyles.animationDuration, computedStyles.animationDelay);
                }
            }
        } // Queue `onAnimationEnd` for after the animation has finished
        if (motionState === 'exiting') animationRef.current = setTimeout(()=>onAnimationEnd(motionState, isCancelled), animationDuration);
        else if (motionState === 'entering') animationRef.current = setTimeout(()=>onAnimationEnd(motionState, isCancelled), animationDuration);
        return ()=>{
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        }; // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        motionState,
        appear,
        staggeredDelay,
        staggeredIsReady,
        reducedMotion
    ]);
    const reanimate = (0, $1v5pe.useCallback)((value)=>{
        animationRef.current && clearTimeout(animationRef.current);
        reanimateRef.current = value;
        if (value === (0, $4hd7B.Reanimate).exit_then_enter) setState('exiting');
        else if (value === (0, $4hd7B.Reanimate).enter) setState('entering');
        else if (value === (0, $4hd7B.Reanimate).exit) setState('exiting');
    }, []);
    const ref = (0, $1v5pe.useMemo)(()=>(0, $fl4ll.default)([
            staggered.ref,
            elementRef
        ]), [
        staggered.ref
    ]);
    return {
        ref: ref,
        reanimate: reanimate,
        state: motionState
    };
}

});


parcelRegister("Udtso", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec853c9f5ab91cc8$export$2e2bcd8739ae039);
parcelRequire("1v5pe");

var $4G6iD = parcelRequire("4G6iD");

var $kIqwl = parcelRequire("kIqwl");
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion).
 */ const $ec853c9f5ab91cc8$var$SlideIn = ({ children: children, enterFrom: enterFrom, exitTo: exitTo, duration: duration = 'medium', isPaused: isPaused, onFinish: onFinish, animationTimingFunction: animationTimingFunction = 'ease-out', animationTimingFunctionExiting: animationTimingFunctionExiting = 'ease-in' })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $4G6iD.default), {
        duration: duration,
        enteringAnimation: `slide-in-from-${enterFrom}`,
        exitingAnimation: `slide-out-from-${exitTo || enterFrom}`,
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish,
        children: children
    });
};
var $ec853c9f5ab91cc8$export$2e2bcd8739ae039 = $ec853c9f5ab91cc8$var$SlideIn;

});



parcelRegister("7uhky", function(module, exports) {
$parcel$export(module.exports, "addUFOCustomData", () => $33bc30e06a8e1dbb$export$d12f56a472cdbe6c);

var $i8z2S = parcelRequire("i8z2S");

var $8OjRF = parcelRequire("8OjRF");
function $33bc30e06a8e1dbb$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $i8z2S.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    if (typeof globalThis?.structuredClone === 'function') (0, $8OjRF.addCustomData)(currentInteractionId, [], globalThis.structuredClone(data));
    else (0, $8OjRF.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("5ndys", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", () => $f2a6449edcdd04f6$export$c00d22927c60484a);

var $8Dwhw = parcelRequire("8Dwhw");
class $f2a6449edcdd04f6$export$c00d22927c60484a extends (0, $8Dwhw.UFOAbstractExperience) {
}

});
parcelRegister("8Dwhw", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", () => $3589366c0905387e$export$d31c89db257648c);

var $2BKzr = parcelRequire("2BKzr");

var $2aEiL = parcelRequire("2aEiL");

var $b1aN1 = parcelRequire("b1aN1");

var $5078C = parcelRequire("5078C");

var $aJPNr = parcelRequire("aJPNr");

var $4hthk = parcelRequire("4hthk");

var $eWLNl = parcelRequire("eWLNl");

var $5wsAo = parcelRequire("5wsAo");

var $5IKwo = parcelRequire("5IKwo");

var $d0hLm = parcelRequire("d0hLm");

var $kU1xr = parcelRequire("kU1xr");

var $6tHB0 = parcelRequire("6tHB0");

var $i5zAu = parcelRequire("i5zAu");

var $dFi9A = parcelRequire("dFi9A");

var $luDSq = parcelRequire("luDSq");

var $8B5VS = parcelRequire("8B5VS");

var $hFdXd = parcelRequire("hFdXd");

var $ltNHt = parcelRequire("ltNHt");

var $lMJNN = parcelRequire("lMJNN");

var $fqfOD = parcelRequire("fqfOD");

var $1iLZ5 = parcelRequire("1iLZ5");
const $3589366c0905387e$var$getPageVisibleState = ()=>{
    return !(0, $5IKwo.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $hFdXd.PageVisibleState).VISIBLE : (0, $hFdXd.PageVisibleState).HIDDEN;
};
class $3589366c0905387e$export$d31c89db257648c {
    state = (0, $ltNHt.UFOExperienceState).NOT_STARTED;
    id;
    instanceId = null;
    parent = null;
    category = null;
    type;
    performanceType;
    metadata = {};
    onDoneCallbacks = [];
    childExperiences = [];
    featureFlags;
    timings;
    explicitTimings = {};
    // @todo move to page load experience when proper classes/inheritance prepared
    isSSROutputAsFMP = false;
    handleDoneBind;
    uuid = null;
    until;
    _until = null;
    pageVisibleState;
    traceContext = null;
    metrics = {
        startTime: null,
        endTime: null,
        marks: []
    };
    performanceConfig = {};
    config;
    constructor(id, config, instanceId = null){
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $3589366c0905387e$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $fqfOD.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $fqfOD.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $dFi9A.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $lMJNN.canTransition)(this.state, newState)) {
            (0, $dFi9A.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $ltNHt.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = (0, $1iLZ5.perfNowOrTimestamp)(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $2BKzr.default)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = (0, $1iLZ5.perfNowOrTimestamp)(timestamp);
                if (!this._isManualStateEnabled()) (0, $kU1xr.getGlobalEventStream)().push((0, $i5zAu.unsubscribeEvent)((0, $hFdXd.SUBSCRIBE_ALL), this.handleDoneBind));
                this.stopTrace();
                const data = await this.exportData();
                (0, $dFi9A.ufolog)('this.parent', this.parent);
                (0, $kU1xr.getGlobalEventStream)().push((0, $d0hLm.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $dFi9A.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $luDSq.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $ltNHt.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $3589366c0905387e$var$getPageVisibleState();
            (0, $8B5VS.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $dFi9A.ufolog)('subscribed', this.id);
                (0, $kU1xr.getGlobalEventStream)().push((0, $6tHB0.subscribeEvent)((0, $hFdXd.SUBSCRIBE_ALL), this.handleDoneBind));
            }
            this.startTrace(this.id);
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $hFdXd.FMP_MARK) && name !== (0, $hFdXd.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $luDSq.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: (0, $1iLZ5.perfNowOrTimestamp)(timestamp)
        });
        this.transition((0, $ltNHt.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $hFdXd.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $hFdXd.INLINE_RESPONSE_MARK), timestamp);
    }
    startTrace(experienceId) {
        if ((0, $2aEiL.fg)('ufo_v1_tracing')) {
            let traceContext = (0, $4hthk.getActiveTrace)();
            if (!traceContext) {
                traceContext = {
                    traceId: (0, $aJPNr.generateTraceId)(),
                    spanId: (0, $5078C.generateSpanId)()
                };
                (0, $eWLNl.setActiveTrace)(traceContext.traceId, traceContext.spanId, 'ufo_v1.' + experienceId);
            }
            this.traceContext = traceContext;
        }
    }
    stopTrace() {
        if ((0, $2aEiL.fg)('ufo_v1_tracing')) (0, $b1aN1.clearActiveTrace)();
    }
    setPageVisibleStateToMixed = ()=>{
        this.pageVisibleState = (0, $hFdXd.PageVisibleState).MIXED;
        (0, $8B5VS.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
    };
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $luDSq.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $8B5VS.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $ltNHt.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $ltNHt.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $ltNHt.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $dFi9A.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $5wsAo.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig,
            ...(0, $2aEiL.fg)('ufo_v1_tracing') ? {
                traceContext: this.traceContext
            } : {}
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.traceContext = null;
        this._until = this.until ? this.until() : null;
    }
}

});
parcelRegister("b1aN1", function(module, exports) {
$parcel$export(module.exports, "clearActiveTrace", () => $5c9fc3f123bf9849$export$17ab21d7be720b);

var $8WfCw = parcelRequire("8WfCw");
function $5c9fc3f123bf9849$export$17ab21d7be720b() {
    (0, $8WfCw.state).context = null;
}

});
parcelRegister("8WfCw", function(module, exports) {
$parcel$export(module.exports, "state", () => $dd442011e39d6c6f$export$ca000e230c0caa3e);
const $dd442011e39d6c6f$export$ca000e230c0caa3e = {
    context: null
};

});


parcelRegister("5078C", function(module, exports) {
$parcel$export(module.exports, "generateSpanId", () => $385cf53b09c338fc$export$295213bc4d0c54ad);
/**
 * Generates a random 16-character hexadecimal span ID.
 * This is used for creating new span IDs in distributed tracing.
 *
 * @returns A 16-character hexadecimal string
 *
 * @example
 * ```typescript
 * const spanId = generateSpanId(); // e.g., "84a67a1b3ceccf27"
 * ```
 */ function $385cf53b09c338fc$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});

parcelRegister("aJPNr", function(module, exports) {
$parcel$export(module.exports, "generateTraceId", () => $b315c7e8da913596$export$dc6d7ea554bcce10);
/**
 * Generates a random 32-character hexadecimal trace ID.
 * This is used for creating new trace IDs in distributed tracing.
 *
 * @returns A 32-character hexadecimal string
 *
 * @example
 * ```typescript
 * const traceId = generateTraceId(); // e.g., "9ad3407c1a7d484b86847e7226e566d3"
 * ```
 */ function $b315c7e8da913596$export$dc6d7ea554bcce10() {
    return Array.from(new Array(32), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});

parcelRegister("4hthk", function(module, exports) {
$parcel$export(module.exports, "getActiveTrace", () => $4c70377c21c9ac88$export$b6ac780db3a3cc77);

var $8WfCw = parcelRequire("8WfCw");
function $4c70377c21c9ac88$export$b6ac780db3a3cc77() {
    return (0, $8WfCw.state).context;
}

});

parcelRegister("eWLNl", function(module, exports) {
$parcel$export(module.exports, "setActiveTrace", () => $bd1491c47b3a7afc$export$a1002be327997103);

var $jcoDC = parcelRequire("jcoDC");

var $bxQue = parcelRequire("bxQue");

var $8WfCw = parcelRequire("8WfCw");
const $bd1491c47b3a7afc$var$getAnalyticsClient = (()=>{
    let instance;
    return ()=>{
        if (!instance) {
            const env = (0, $bxQue.getEnvironment)();
            instance = new (0, $jcoDC.default)({
                env: env,
                product: 'observability'
            });
        }
        return instance;
    };
})();
function $bd1491c47b3a7afc$export$a1002be327997103(traceId, spanId, source) {
    // If trace context has already been set, there has been an experience collision
    // Don't update the trace context.
    if ((0, $8WfCw.state).context !== null) $bd1491c47b3a7afc$var$getAnalyticsClient().sendOperationalEvent({
        source: source,
        action: 'setActiveTrace',
        actionSubject: 'traceContext',
        attributes: {
            currentContext: (0, $8WfCw.state).context,
            incomingContext: {
                traceId: traceId,
                spanId: spanId
            },
            status: 'collision'
        },
        tags: [
            'observability'
        ]
    });
    else (0, $8WfCw.state).context = {
        traceId: traceId,
        spanId: spanId
    };
}

});
parcelRegister("bxQue", function(module, exports) {
$parcel$export(module.exports, "getEnvironment", () => $6d986f8ac8a310bd$export$57570b1603cf6adb);

var $6yEEN = parcelRequire("6yEEN");
function $6d986f8ac8a310bd$export$57570b1603cf6adb() {
    // Gaurd for running in the browser - if SSR (somehow) just return prod
    if (typeof window === 'undefined') return (0, $6yEEN.envType).PROD;
    const { hostname: hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') return (0, $6yEEN.envType).LOCAL;
    if (hostname.includes('.dev.')) return (0, $6yEEN.envType).STAGING;
    if (hostname.includes('.stg.')) return (0, $6yEEN.envType).STAGING;
    return (0, $6yEEN.envType).PROD;
}

});


parcelRegister("5wsAo", function(module, exports) {
$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", () => $69a92176ffd57aeb$export$2295b861f318254a);
// temp solution until we can get it automated
const $69a92176ffd57aeb$export$2295b861f318254a = '0.1.5';

});

parcelRegister("5IKwo", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", () => $434a51e785fd4547$export$15e172712955e18f);
const $434a51e785fd4547$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});

parcelRegister("d0hLm", function(module, exports) {
$parcel$export(module.exports, "experiencePayloadEvent", () => $3132e33710343c3a$export$7c957416596ca127);

var $hFdXd = parcelRequire("hFdXd");
const $3132e33710343c3a$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $hFdXd.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("hFdXd", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $4893cc8941877715$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $4893cc8941877715$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $4893cc8941877715$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $4893cc8941877715$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $4893cc8941877715$export$837e0f79a8056912);
var $4893cc8941877715$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $4893cc8941877715$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $4893cc8941877715$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $4893cc8941877715$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $4893cc8941877715$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $4893cc8941877715$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $4893cc8941877715$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $4893cc8941877715$export$9f2bf58999404c75 = 'fmp';
const $4893cc8941877715$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("kU1xr", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", () => $87724fa034710353$export$6123a44dc2384540);

var $jjfdf = parcelRequire("jjfdf");
const $87724fa034710353$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < (0, $jjfdf.MAX_EARLY_QUEUE_LENGTH)) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};

});
parcelRegister("jjfdf", function(module, exports) {
$parcel$export(module.exports, "MAX_EARLY_QUEUE_LENGTH", () => $e8c811b02e31a2a4$export$d8b468db8a225bc9);
const $e8c811b02e31a2a4$export$d8b468db8a225bc9 = 250;

});


parcelRegister("6tHB0", function(module, exports) {
$parcel$export(module.exports, "subscribeEvent", () => $0752655d49648199$export$37863216db4b714d);

var $hFdXd = parcelRequire("hFdXd");
const $0752655d49648199$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $hFdXd.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};

});

parcelRegister("i5zAu", function(module, exports) {
$parcel$export(module.exports, "unsubscribeEvent", () => $6dc9a089cb05c42b$export$ee1a7bd1fc9ea85e);

var $hFdXd = parcelRequire("hFdXd");
const $6dc9a089cb05c42b$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $hFdXd.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};

});

parcelRegister("dFi9A", function(module, exports) {
$parcel$export(module.exports, "ufolog", () => $8965a6bb5015c48d$export$b4958caff08a0960);

var $9KfqA = parcelRequire("9KfqA");
const $8965a6bb5015c48d$export$b4958caff08a0960 = (...args)=>{
    (0, $9KfqA.ufologger).log(...args);
};

});
parcelRegister("9KfqA", function(module, exports) {
$parcel$export(module.exports, "ufologger", () => $156b00335414a5f7$export$4ab84f6f04f6566d);
class $156b00335414a5f7$var$UFOLogger {
    enabled = false;
    static UFOprefix = "[ufo\uD83D\uDEF8]";
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($156b00335414a5f7$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($156b00335414a5f7$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
}
const $156b00335414a5f7$export$4ab84f6f04f6566d = new $156b00335414a5f7$var$UFOLogger();

});


parcelRegister("luDSq", function(module, exports) {
$parcel$export(module.exports, "ufowarn", () => $1cf74ec27d438c9f$export$d53d07b6034c4560);

var $9KfqA = parcelRequire("9KfqA");
const $1cf74ec27d438c9f$export$d53d07b6034c4560 = (...args)=>{
    (0, $9KfqA.ufologger).warn(...args);
};

});

parcelRegister("8B5VS", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $696fc3c05736911a$export$13e680397ec8f3eb);

var $5IKwo = parcelRequire("5IKwo");
class $696fc3c05736911a$var$VisibilityChangeObserver {
    started = false;
    observers = [];
    broadcast = ()=>{
        this.observers.forEach((fn)=>fn());
        this.observers = [];
    };
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ if ((0, $5IKwo.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
}
const $696fc3c05736911a$export$13e680397ec8f3eb = new $696fc3c05736911a$var$VisibilityChangeObserver();

});

parcelRegister("ltNHt", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", () => $6a6a93583b1abdd9$export$81b70111112841a0);
const $6a6a93583b1abdd9$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("lMJNN", function(module, exports) {
$parcel$export(module.exports, "canTransition", () => $921cec6479bfa15e$export$178881f329fdb81f);

var $ltNHt = parcelRequire("ltNHt");
const $921cec6479bfa15e$var$UFOStateAvailableTransitions = {
    [(0, $ltNHt.UFOExperienceState).NOT_STARTED.id]: [
        (0, $ltNHt.UFOExperienceState).STARTED.id
    ],
    [(0, $ltNHt.UFOExperienceState).STARTED.id]: [
        (0, $ltNHt.UFOExperienceState).IN_PROGRESS.id,
        (0, $ltNHt.UFOExperienceState).BLOCKED.id,
        (0, $ltNHt.UFOExperienceState).SUCCEEDED.id,
        (0, $ltNHt.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $ltNHt.UFOExperienceState).FAILED.id,
        (0, $ltNHt.UFOExperienceState).ABORTED.id
    ],
    [(0, $ltNHt.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $ltNHt.UFOExperienceState).BLOCKED.id,
        (0, $ltNHt.UFOExperienceState).SUCCEEDED.id,
        (0, $ltNHt.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $ltNHt.UFOExperienceState).FAILED.id,
        (0, $ltNHt.UFOExperienceState).ABORTED.id
    ],
    [(0, $ltNHt.UFOExperienceState).BLOCKED.id]: [
        (0, $ltNHt.UFOExperienceState).RECOVERED.id,
        (0, $ltNHt.UFOExperienceState).ABORTED.id
    ],
    [(0, $ltNHt.UFOExperienceState).RECOVERED.id]: [
        (0, $ltNHt.UFOExperienceState).STARTED.id,
        (0, $ltNHt.UFOExperienceState).SUCCEEDED.id,
        (0, $ltNHt.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $ltNHt.UFOExperienceState).FAILED.id,
        (0, $ltNHt.UFOExperienceState).ABORTED.id
    ],
    [(0, $ltNHt.UFOExperienceState).SUCCEEDED.id]: [
        (0, $ltNHt.UFOExperienceState).STARTED.id
    ],
    [(0, $ltNHt.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $ltNHt.UFOExperienceState).SUCCEEDED.id,
        (0, $ltNHt.UFOExperienceState).FAILED.id,
        (0, $ltNHt.UFOExperienceState).ABORTED.id
    ],
    [(0, $ltNHt.UFOExperienceState).FAILED.id]: [
        (0, $ltNHt.UFOExperienceState).STARTED.id
    ],
    [(0, $ltNHt.UFOExperienceState).ABORTED.id]: [
        (0, $ltNHt.UFOExperienceState).STARTED.id
    ]
};
const $921cec6479bfa15e$export$178881f329fdb81f = (state1, state2)=>{
    return $921cec6479bfa15e$var$UFOStateAvailableTransitions[state1.id] && $921cec6479bfa15e$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("fqfOD", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", () => $143efb82297c8737$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $143efb82297c8737$export$cc26007c03242fff);
var $143efb82297c8737$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $143efb82297c8737$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("1iLZ5", function(module, exports) {
$parcel$export(module.exports, "perfNowOrTimestamp", () => $608a749477e3f893$export$c753e8669d30c8ad);

var $c8cYi = parcelRequire("c8cYi");
const $608a749477e3f893$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $c8cYi.roundPerfNow)();
};

});
parcelRegister("c8cYi", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", () => $8af30e183b517e3b$export$5f490af6b2b115cf);
const $8af30e183b517e3b$export$5f490af6b2b115cf = ()=>~~performance.now();

});




parcelRegister("7EVvM", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c423de30497c8ed$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $cZ6aD = parcelRequire("cZ6aD");

var $6c3s0 = parcelRequire("6c3s0");

var $hb3uL = parcelRequire("hb3uL");

var $kIqwl = parcelRequire("kIqwl");
function $4c423de30497c8ed$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $hb3uL.useSafeIntl)();
    const messages = (0, $6c3s0.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $1v5pe.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cZ6aD.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}

});
parcelRegister("6c3s0", function(module, exports) {
$parcel$export(module.exports, "useMessages", () => $baef41f646f5e783$export$4d17e2d9c5348842);

var $1v5pe = parcelRequire("1v5pe");

var $75gx9 = parcelRequire("75gx9");
function $baef41f646f5e783$export$4d17e2d9c5348842(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $1v5pe.useState)((0, $75gx9.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $1v5pe.useRef)(localeState.locale);
    (0, $1v5pe.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
}

});
parcelRegister("75gx9", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LOCALE_STATE", () => $60abd50562ea94da$export$79618bef82c02d4c);
const $60abd50562ea94da$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};

});


parcelRegister("hb3uL", function(module, exports) {
$parcel$export(module.exports, "useSafeIntl", () => $248d35f15899d432$export$f752ac21ea3960a5);

var $1v5pe = parcelRequire("1v5pe");

var $1YTwG = parcelRequire("1YTwG");
var $3zCfq = parcelRequire("3zCfq");
var $lJYzG = parcelRequire("lJYzG");

var $75gx9 = parcelRequire("75gx9");
// Prevents memory leaks
const $248d35f15899d432$var$cache = (0, $3zCfq.createIntlCache)();
const $248d35f15899d432$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $1v5pe.useContext)((0, $lJYzG.Context));
    if (!context) return (0, $1YTwG.createIntl)((0, $75gx9.DEFAULT_LOCALE_STATE), $248d35f15899d432$var$cache);
    return context;
};

});


parcelRegister("gVdmf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c25cdb5eabfe9ffe$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $caExe = parcelRequire("caExe");
var $c25cdb5eabfe9ffe$export$2e2bcd8739ae039 = (0, $caExe.default);

});
parcelRegister("caExe", function(module, exports) {
$parcel$export(module.exports, "default", () => $9da0062b2c8868e7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //
var $9da0062b2c8868e7$export$2e2bcd8739ae039 = {
    "browser-storage-controls.consent-banner-modal.analytical.description.101024": "Measures usage to improve product performance.",
    "browser-storage-controls.consent-banner-modal.analytical.description.101024-appify": "Measures usage to improve app performance.",
    "browser-storage-controls.consent-banner-modal.analytical.option.082624": "Allow analytical cookies",
    "browser-storage-controls.consent-banner-modal.cancel.button": "Cancel",
    "browser-storage-controls.consent-banner-modal.confirm.button": "Confirm",
    "browser-storage-controls.consent-banner-modal.functional.description.082624": "Provides enhanced functionality and personalization.",
    "browser-storage-controls.consent-banner-modal.functional.option.082624": "Allow functional cookies",
    "browser-storage-controls.consent-banner-modal.marketing.description.082624": "Used for targeted advertising.",
    "browser-storage-controls.consent-banner-modal.marketing.option.082624": "Allow marketing cookies",
    "browser-storage-controls.consent-banner-modal.strict.description.082624": "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
    "browser-storage-controls.consent-banner-modal.strict.description.082624-appify": "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our apps to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
    "browser-storage-controls.consent-banner-modal.summary.description.082624": "Because we value your privacy, you can select which cookies you allow. {link}",
    "browser-storage-controls.consent-banner-modal.title": "Cookie preferences",
    "browser-storage-controls.consent-banner-modal.tracking.link.082624": "Review our cookies and tracking notice",
    "browser-storage-controls.consent-banner.accept-all.button": "Accept all",
    "browser-storage-controls.consent-banner.cookies-description.text": "Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}",
    "browser-storage-controls.consent-banner.cookies-description.text.no.link": "Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device.",
    "browser-storage-controls.consent-banner.cookies-tracking-notice.text.101024": "Atlassian cookies and tracking notice",
    "browser-storage-controls.consent-banner.error-flag.description": "Try again in a few minutes.",
    "browser-storage-controls.consent-banner.error-flag.title": "We're unable to update the policy",
    "browser-storage-controls.consent-banner.only-necessary.button": "Only necessary",
    "browser-storage-controls.consent-banner.preferences.button": "Preferences",
    "browser-storage-controls.consent-banner.success-flag.description": "You can change this at any time in your Atlassian account.",
    "browser-storage-controls.consent-banner.success-flag.description-local-only": "Your preferences will only affect this site.",
    "browser-storage-controls.consent-banner.success-flag.title": "Cookie preferences saved",
    "browser-storage-controls.consent-banner.toast.error": "Error",
    "browser-storage-controls.consent-banner.toast.success": "Success"
};

});


parcelRegister("fWVN4", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("7BMAC").then(()=>parcelRequire('6slG9'));

});

parcelRegister("ietv1", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("9cAV9").then(()=>parcelRequire('gjhTq'));

});

parcelRegister("cemEO", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("40gUm").then(()=>parcelRequire('l0wdU'));

});

parcelRegister("4JSOu", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("4a2Qk").then(()=>parcelRequire('dRvqw'));

});

parcelRegister("dh7Ku", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("feIRj").then(()=>parcelRequire('9d5OX'));

});

parcelRegister("kXKTS", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("edEZl").then(()=>parcelRequire('l8cRV'));

});

parcelRegister("diwhy", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("9igwW").then(()=>parcelRequire('5X1w8'));

});

parcelRegister("gV7na", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("9rYqr").then(()=>parcelRequire('kLJGB'));

});

parcelRegister("5tP7S", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("lQM7a").then(()=>parcelRequire('gQDnO'));

});

parcelRegister("2AY7t", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("hnBA6").then(()=>parcelRequire('8T59R'));

});

parcelRegister("87iqv", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("9yGwo").then(()=>parcelRequire('3PPyG'));

});

parcelRegister("32oA8", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("56Bik").then(()=>parcelRequire('29irv'));

});

parcelRegister("5kASx", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("cDuUR").then(()=>parcelRequire('6uJ2c'));

});

parcelRegister("5n6wX", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("2g0IN").then(()=>parcelRequire('11erB'));

});

parcelRegister("dc2ke", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("6XPW0").then(()=>parcelRequire('lQBP5'));

});

parcelRegister("jIhs6", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("el8Dz").then(()=>parcelRequire('h8jEY'));

});

parcelRegister("8UhbH", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("6YcAm").then(()=>parcelRequire('2d0pq'));

});

parcelRegister("2DZYs", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("4i8Qo").then(()=>parcelRequire('AbHno'));

});

parcelRegister("boS4K", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("3kwhk").then(()=>parcelRequire('fIxue'));

});

parcelRegister("e6bmU", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("kqugc").then(()=>parcelRequire('92dzO'));

});

parcelRegister("jTrm6", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("2OIe8").then(()=>parcelRequire('cF1HM'));

});

parcelRegister("eBcB7", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("6IABf").then(()=>parcelRequire('3ywlL'));

});

parcelRegister("7tOgO", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("b8vB4").then(()=>parcelRequire('dMRBw'));

});

parcelRegister("4dAcI", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("6DUuo").then(()=>parcelRequire('9CSHE'));

});

parcelRegister("k3I0K", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("gU4se").then(()=>parcelRequire('7SAGf'));

});

parcelRegister("1yaAJ", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("59sBW").then(()=>parcelRequire('gDdcv'));

});

parcelRegister("dUEzh", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("aB4LX").then(()=>parcelRequire('5EtxQ'));

});

parcelRegister("bcdfp", function(module, exports) {
$parcel$export(module.exports, "default", () => $d556e1cc0878738a$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $aD9yk = parcelRequire("aD9yk");

var $5Qmrb = parcelRequire("5Qmrb");

var $eJD8u = parcelRequire("eJD8u");

var $H8FDJ = parcelRequire("H8FDJ");

var $kIqwl = parcelRequire("kIqwl");
const $d556e1cc0878738a$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use `Button` from `@atlaskit/button/default/button`.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ const $d556e1cc0878738a$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).forwardRef(function Button({ appearance: appearance = 'default', children: children, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: isSelected = false, onMouseDown: providedOnMouseDown = (0, $aD9yk.default), onMouseUp: providedOnMouseUp = (0, $aD9yk.default), shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', ...rest }, ref) {
    const isOnlySingleIcon = (0, $H8FDJ.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    const [isActive, setIsActive] = (0, $1v5pe.useState)(false);
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    const onMouseDown = (0, $1v5pe.useCallback)((event)=>{
        providedOnMouseDown(event);
        if ($d556e1cc0878738a$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    const onMouseUp = (0, $1v5pe.useCallback)((event)=>{
        providedOnMouseUp(event);
        if ($d556e1cc0878738a$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    const buttonCss = (0, $1v5pe.useMemo)(()=>(0, $eJD8u.getCss)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        }), [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $5Qmrb.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    });
}));
// Tools including enzyme rely on components having a display name
$d556e1cc0878738a$var$Button.displayName = 'Button';
var $d556e1cc0878738a$export$2e2bcd8739ae039 = $d556e1cc0878738a$var$Button;

});

parcelRegister("c25AW", function(module, exports) {
$parcel$export(module.exports, "default", () => $911c8bb0e155d0d0$export$2e2bcd8739ae039);
/* form.tsx generated by @compiled/babel-plugin v3.0.2 */ /* form.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $dtLWD = parcelRequire("dtLWD");

var $bOSZO = parcelRequire("bOSZO");

var $bhyFt = parcelRequire("bhyFt");

var $eb2bk = parcelRequire("eb2bk");

var $fl4ll = parcelRequire("fl4ll");

var $2aEiL = parcelRequire("2aEiL");

var $loknS = parcelRequire("loknS");

var $9Jgay = parcelRequire("9Jgay");

var $lzsyI = parcelRequire("lzsyI");

var $bFu7t = parcelRequire("bFu7t");

var $kIqwl = parcelRequire("kIqwl");
const $911c8bb0e155d0d0$var$FormBase = (props, ref)=>{
    const { autocomplete: autocomplete, formProps: userProvidedFormProps, id: id, label: label, labelId: labelId, name: name, noValidate: noValidate, onSubmit: onSubmit, testId: testId, xcss: xcss } = props;
    const formRef = (0, $1v5pe.useRef)(null);
    const onSubmitRef = (0, $1v5pe.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    const [form] = (0, $1v5pe.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $dtLWD.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($bhyFt)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($bhyFt)))(values, name, value);
                    }
                }
            }
        });
        (0, $bOSZO.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [], (0, $bFu7t.getFirstErrorField))(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $1v5pe.useState)({
        dirty: false,
        submitting: false
    });
    const [submitCount, setSubmitCount] = (0, $1v5pe.useState)(0);
    (0, $1v5pe.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $1v5pe.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        if ((0, $2aEiL.fg)('platform-dst-motion-uplift-input')) setSubmitCount((count)=>count + 1);
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children, errorMessageLabel: errorMessageLabel, validMessageLabel: validMessageLabel } = props;
    const { dirty: dirty, submitting: submitting } = state; /**
              * This method is needed in FormContext to use it on the field level
              * to check the current value of the field in case of the component re-mounting.
              */ 
    const getCurrentValue = (0, $1v5pe.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $1v5pe.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe,
            errorMessageLabel: errorMessageLabel,
            validMessageLabel: validMessageLabel
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe,
        errorMessageLabel,
        validMessageLabel
    ]);
    const conditionalFormProps = {
        autocomplete: autocomplete,
        className: xcss,
        id: id,
        'aria-label': label,
        'aria-labelledby': labelId,
        name: name,
        noValidate: noValidate,
        'data-testid': testId
    }; // Abstracting so we can use the same for both rendering patterns
    const formProps = {
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: ref ? (0, $fl4ll.default)([
            ref,
            formRef
        ]) : formRef
    }; // We don't want to add undefined values to the component
    Object.keys(conditionalFormProps).forEach((attr)=>{
        if (conditionalFormProps[attr] !== undefined) formProps[attr] = conditionalFormProps[attr];
    });
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change,
                resetFieldState: form.resetFieldState
            }) : children();
            return result === undefined ? null : result;
        } else return /*#__PURE__*/ (0, $kIqwl.jsx)("form", {
            ...formProps,
            ...userProvidedFormProps,
            children: children
        });
    })();
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $loknS.FormContext).Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $9Jgay.FormSubmitContext).Provider, {
            value: submitCount,
            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $lzsyI.IsDisabledContext).Provider, {
                value: isDisabled,
                children: childrenContent
            })
        })
    });
};
/**
 * __Form__
 *
 * A form allows users to input information.
 *
 * - [Examples](https://atlassian.design/components/form/examples)
 * - [Code](https://atlassian.design/components/form/code)
 * - [Usage](https://atlassian.design/components/form/usage)
 */ const $911c8bb0e155d0d0$var$Form = (0, $eb2bk.default)($911c8bb0e155d0d0$var$FormBase); // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $911c8bb0e155d0d0$export$2e2bcd8739ae039 = $911c8bb0e155d0d0$var$Form;

});
parcelRegister("dtLWD", function(module, exports) {
$parcel$export(module.exports, "getIn", () => $9d032ca0a0a2aabe$export$c52e5867d5879e24);
$parcel$export(module.exports, "createForm", () => $9d032ca0a0a2aabe$export$f681a8129d2e9d28);

var $87uOn = parcelRequire("87uOn");

var $3mdE8 = parcelRequire("3mdE8");
//      
var $9d032ca0a0a2aabe$var$charCodeOfDot = ".".charCodeAt(0);
var $9d032ca0a0a2aabe$var$reEscapeChar = /\\(\\)?/g;
var $9d032ca0a0a2aabe$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $9d032ca0a0a2aabe$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $9d032ca0a0a2aabe$var$charCodeOfDot) result.push("");
    string.replace($9d032ca0a0a2aabe$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($9d032ca0a0a2aabe$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $9d032ca0a0a2aabe$var$keysCache = {};
var $9d032ca0a0a2aabe$var$keysRegex = /[.[\]]+/;
var $9d032ca0a0a2aabe$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($9d032ca0a0a2aabe$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $9d032ca0a0a2aabe$var$keysCache[key] = key.split($9d032ca0a0a2aabe$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $9d032ca0a0a2aabe$var$keysCache[key] = $9d032ca0a0a2aabe$var$stringToPath(key);
    }
    return $9d032ca0a0a2aabe$var$keysCache[key];
};
//      
var $9d032ca0a0a2aabe$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $9d032ca0a0a2aabe$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $9d032ca0a0a2aabe$var$_toPropertyKey(arg) {
    var key = $9d032ca0a0a2aabe$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $9d032ca0a0a2aabe$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $9d032ca0a0a2aabe$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $3mdE8.default)(current, [
                key
            ].map($9d032ca0a0a2aabe$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $87uOn.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $9d032ca0a0a2aabe$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $9d032ca0a0a2aabe$var$setInRecursor(state, 0, $9d032ca0a0a2aabe$var$toPath(key), value1, destroyArrays);
};
var $9d032ca0a0a2aabe$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $9d032ca0a0a2aabe$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $9d032ca0a0a2aabe$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $9d032ca0a0a2aabe$export$c52e5867d5879e24(values, name);
    var error = $9d032ca0a0a2aabe$export$c52e5867d5879e24(errors, name);
    if (error && error[$9d032ca0a0a2aabe$export$735bebc8ffabf28a]) error = error[$9d032ca0a0a2aabe$export$735bebc8ffabf28a];
    var submitError = submitErrors && $9d032ca0a0a2aabe$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $9d032ca0a0a2aabe$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($9d032ca0a0a2aabe$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $9d032ca0a0a2aabe$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $9d032ca0a0a2aabe$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $9d032ca0a0a2aabe$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$9d032ca0a0a2aabe$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $9d032ca0a0a2aabe$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $9d032ca0a0a2aabe$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $9d032ca0a0a2aabe$var$subscriptionFilter(result, state, previousState, subscription, $9d032ca0a0a2aabe$export$41e855cb628c1b55, $9d032ca0a0a2aabe$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $9d032ca0a0a2aabe$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $9d032ca0a0a2aabe$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $9d032ca0a0a2aabe$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $9d032ca0a0a2aabe$var$subscriptionFilter(result, state, previousState, subscription, $9d032ca0a0a2aabe$export$f1ff97b9d1c7a3c3, $9d032ca0a0a2aabe$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $9d032ca0a0a2aabe$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$9d032ca0a0a2aabe$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $9d032ca0a0a2aabe$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $9d032ca0a0a2aabe$export$83d89fbfd8236492 = "4.20.10";
var $9d032ca0a0a2aabe$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $9d032ca0a0a2aabe$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $9d032ca0a0a2aabe$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $9d032ca0a0a2aabe$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $9d032ca0a0a2aabe$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $9d032ca0a0a2aabe$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $9d032ca0a0a2aabe$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $9d032ca0a0a2aabe$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($9d032ca0a0a2aabe$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $9d032ca0a0a2aabe$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $87uOn.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $87uOn.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $9d032ca0a0a2aabe$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $9d032ca0a0a2aabe$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $87uOn.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $87uOn.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $87uOn.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $9d032ca0a0a2aabe$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $9d032ca0a0a2aabe$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $9d032ca0a0a2aabe$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $9d032ca0a0a2aabe$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $9d032ca0a0a2aabe$export$e6bdf135a54e021b,
                    shallowEqual: $9d032ca0a0a2aabe$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $87uOn.default)({}, state.formState.values)); // clone to avoid writing
            if ($9d032ca0a0a2aabe$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($9d032ca0a0a2aabe$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $9d032ca0a0a2aabe$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $9d032ca0a0a2aabe$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $87uOn.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $87uOn.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $9d032ca0a0a2aabe$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $9d032ca0a0a2aabe$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $9d032ca0a0a2aabe$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$9d032ca0a0a2aabe$export$735bebc8ffabf28a]) {
                    var existing = $9d032ca0a0a2aabe$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$9d032ca0a0a2aabe$export$735bebc8ffabf28a] = error[$9d032ca0a0a2aabe$export$735bebc8ffabf28a];
                    merged = $9d032ca0a0a2aabe$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$9d032ca0a0a2aabe$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$9d032ca0a0a2aabe$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $87uOn.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $9d032ca0a0a2aabe$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $9d032ca0a0a2aabe$var$notify(fieldSubscriber, fieldState, lastFieldState, $9d032ca0a0a2aabe$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $9d032ca0a0a2aabe$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $87uOn.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($9d032ca0a0a2aabe$export$c52e5867d5879e24(formState.values, key), $9d032ca0a0a2aabe$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($9d032ca0a0a2aabe$export$c52e5867d5879e24(formState.values, key), $9d032ca0a0a2aabe$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$9d032ca0a0a2aabe$var$hasAnyError(formState.errors) && !(formState.submitErrors && $9d032ca0a0a2aabe$var$hasAnyError(formState.submitErrors));
        var nextFormState = $9d032ca0a0a2aabe$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $9d032ca0a0a2aabe$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $9d032ca0a0a2aabe$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $9d032ca0a0a2aabe$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $9d032ca0a0a2aabe$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $9d032ca0a0a2aabe$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $9d032ca0a0a2aabe$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $9d032ca0a0a2aabe$var$notify(state.subscribers, nextFormState, lastFormState, $9d032ca0a0a2aabe$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $87uOn.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($9d032ca0a0a2aabe$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $87uOn.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $87uOn.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($9d032ca0a0a2aabe$export$c52e5867d5879e24(formState.values, key), $9d032ca0a0a2aabe$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $9d032ca0a0a2aabe$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $9d032ca0a0a2aabe$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $9d032ca0a0a2aabe$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $9d032ca0a0a2aabe$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $9d032ca0a0a2aabe$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $9d032ca0a0a2aabe$export$c52e5867d5879e24(state.formState.values, name) === $9d032ca0a0a2aabe$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $9d032ca0a0a2aabe$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $9d032ca0a0a2aabe$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $9d032ca0a0a2aabe$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $9d032ca0a0a2aabe$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $9d032ca0a0a2aabe$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $9d032ca0a0a2aabe$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $87uOn.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $87uOn.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $87uOn.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $9d032ca0a0a2aabe$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$9d032ca0a0a2aabe$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $87uOn.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $9d032ca0a0a2aabe$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $9d032ca0a0a2aabe$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $9d032ca0a0a2aabe$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $9d032ca0a0a2aabe$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});
parcelRegister("3mdE8", function(module, exports) {
$parcel$export(module.exports, "default", () => $271e0311c2a8a765$export$2e2bcd8739ae039);
function $271e0311c2a8a765$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("bOSZO", function(module, exports) {
$parcel$export(module.exports, "default", () => $89af0645ec0d6178$export$2e2bcd8739ae039);

var $dtLWD = parcelRequire("dtLWD");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $89af0645ec0d6178$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $89af0645ec0d6178$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($89af0645ec0d6178$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $89af0645ec0d6178$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $dtLWD.getIn)(errors, input.name);
    });
};
//      
var $89af0645ec0d6178$var$noop = function noop() {};
var $89af0645ec0d6178$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $89af0645ec0d6178$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $89af0645ec0d6178$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $89af0645ec0d6178$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $89af0645ec0d6178$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($89af0645ec0d6178$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$89af0645ec0d6178$export$2e2bcd8739ae039 = $89af0645ec0d6178$var$createDecorator;

});

parcelRegister("bhyFt", function(module, exports) {

var $d0bln = parcelRequire("d0bln");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $836c2c8b4ace22e3$var$set(object, path, value) {
    return object == null ? object : $d0bln(object, path, value);
}
module.exports = $836c2c8b4ace22e3$var$set;

});
parcelRegister("d0bln", function(module, exports) {

var $1GvDV = parcelRequire("1GvDV");

var $h8usd = parcelRequire("h8usd");

var $gCPVC = parcelRequire("gCPVC");

var $ghi1o = parcelRequire("ghi1o");

var $gwgzf = parcelRequire("gwgzf");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $977413183639e1db$var$baseSet(object, path, value, customizer) {
    if (!$ghi1o(object)) return object;
    path = $h8usd(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $gwgzf(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $ghi1o(objValue) ? objValue : $gCPVC(path[index + 1]) ? [] : {};
        }
        $1GvDV(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $977413183639e1db$var$baseSet;

});
parcelRegister("h8usd", function(module, exports) {

var $ipbSm = parcelRequire("ipbSm");

var $9drQl = parcelRequire("9drQl");

var $eOUCX = parcelRequire("eOUCX");

var $5QJ6w = parcelRequire("5QJ6w");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $c79ace8e8923b573$var$castPath(value, object) {
    if ($ipbSm(value)) return value;
    return $9drQl(value, object) ? [
        value
    ] : $eOUCX($5QJ6w(value));
}
module.exports = $c79ace8e8923b573$var$castPath;

});
parcelRegister("9drQl", function(module, exports) {

var $ipbSm = parcelRequire("ipbSm");

var $3qRJb = parcelRequire("3qRJb");
/** Used to match property names within property paths. */ var $6b5aed0b8bd97525$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $6b5aed0b8bd97525$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $6b5aed0b8bd97525$var$isKey(value, object) {
    if ($ipbSm(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $3qRJb(value)) return true;
    return $6b5aed0b8bd97525$var$reIsPlainProp.test(value) || !$6b5aed0b8bd97525$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $6b5aed0b8bd97525$var$isKey;

});
parcelRegister("3qRJb", function(module, exports) {

var $avvbo = parcelRequire("avvbo");

var $jbhhu = parcelRequire("jbhhu");
/** `Object#toString` result references. */ var $27fd7a001b9ede2a$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $27fd7a001b9ede2a$var$isSymbol(value) {
    return typeof value == 'symbol' || $jbhhu(value) && $avvbo(value) == $27fd7a001b9ede2a$var$symbolTag;
}
module.exports = $27fd7a001b9ede2a$var$isSymbol;

});


parcelRegister("eOUCX", function(module, exports) {

var $icnUd = parcelRequire("icnUd");
/** Used to match property names within property paths. */ var $aca1a93159f58f02$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $aca1a93159f58f02$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $aca1a93159f58f02$var$stringToPath = $icnUd(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($aca1a93159f58f02$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($aca1a93159f58f02$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $aca1a93159f58f02$var$stringToPath;

});
parcelRegister("icnUd", function(module, exports) {

var $2NdRj = parcelRequire("2NdRj");
/** Used as the maximum memoize cache size. */ var $d3fbe429b5f3b19b$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $d3fbe429b5f3b19b$var$memoizeCapped(func) {
    var result = $2NdRj(func, function(key) {
        if (cache.size === $d3fbe429b5f3b19b$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $d3fbe429b5f3b19b$var$memoizeCapped;

});
parcelRegister("2NdRj", function(module, exports) {

var $32K13 = parcelRequire("32K13");
/** Error message constants. */ var $208ae870bcf3547f$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $208ae870bcf3547f$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($208ae870bcf3547f$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($208ae870bcf3547f$var$memoize.Cache || $32K13);
    return memoized;
}
// Expose `MapCache`.
$208ae870bcf3547f$var$memoize.Cache = $32K13;
module.exports = $208ae870bcf3547f$var$memoize;

});



parcelRegister("5QJ6w", function(module, exports) {

var $i9Zi5 = parcelRequire("i9Zi5");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $4424cbdb269ee075$var$toString(value) {
    return value == null ? '' : $i9Zi5(value);
}
module.exports = $4424cbdb269ee075$var$toString;

});
parcelRegister("i9Zi5", function(module, exports) {

var $ePDSv = parcelRequire("ePDSv");

var $33rLk = parcelRequire("33rLk");

var $ipbSm = parcelRequire("ipbSm");

var $3qRJb = parcelRequire("3qRJb");
/** Used as references for various `Number` constants. */ var $d3889c5089f753f0$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $d3889c5089f753f0$var$symbolProto = $ePDSv ? $ePDSv.prototype : undefined, $d3889c5089f753f0$var$symbolToString = $d3889c5089f753f0$var$symbolProto ? $d3889c5089f753f0$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $d3889c5089f753f0$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($ipbSm(value)) // Recursively convert values (susceptible to call stack limits).
    return $33rLk(value, $d3889c5089f753f0$var$baseToString) + '';
    if ($3qRJb(value)) return $d3889c5089f753f0$var$symbolToString ? $d3889c5089f753f0$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$d3889c5089f753f0$var$INFINITY ? '-0' : result;
}
module.exports = $d3889c5089f753f0$var$baseToString;

});
parcelRegister("33rLk", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $23972ff20fae130f$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $23972ff20fae130f$var$arrayMap;

});




parcelRegister("gwgzf", function(module, exports) {

var $3qRJb = parcelRequire("3qRJb");
/** Used as references for various `Number` constants. */ var $c06c7c7b121484de$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $c06c7c7b121484de$var$toKey(value) {
    if (typeof value == 'string' || $3qRJb(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$c06c7c7b121484de$var$INFINITY ? '-0' : result;
}
module.exports = $c06c7c7b121484de$var$toKey;

});



parcelRegister("eb2bk", function(module, exports) {
$parcel$export(module.exports, "default", () => $fafffca17cb97047$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");
var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $fafffca17cb97047$export$2e2bcd8739ae039 = (0, $1v5pe.forwardRef);

});

parcelRegister("loknS", function(module, exports) {
$parcel$export(module.exports, "FormContext", () => $9a9fa1266a221d5e$export$c24727297075ec6a);

var $1v5pe = parcelRequire("1v5pe");
const $9a9fa1266a221d5e$export$c24727297075ec6a = /*#__PURE__*/ (0, $1v5pe.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});

});

parcelRegister("9Jgay", function(module, exports) {
$parcel$export(module.exports, "FormSubmitContext", () => $601246ee69c1453c$export$8f3f615a5fb5d1d6);

var $1v5pe = parcelRequire("1v5pe");
const $601246ee69c1453c$export$8f3f615a5fb5d1d6 = /*#__PURE__*/ (0, $1v5pe.createContext)(0);

});

parcelRegister("lzsyI", function(module, exports) {
$parcel$export(module.exports, "IsDisabledContext", () => $aacb004fc62c205c$export$c17cf6b332a82dbc);

var $1v5pe = parcelRequire("1v5pe");
const $aacb004fc62c205c$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $1v5pe.createContext)(false);

});

parcelRegister("bFu7t", function(module, exports) {
$parcel$export(module.exports, "getFirstErrorField", () => $aaeffef0e8199aa5$export$fc06342dc8588d3b);

var $dtLWD = parcelRequire("dtLWD");
const $aaeffef0e8199aa5$export$fc06342dc8588d3b = (inputs, errors)=>{
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    let htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, $dtLWD.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $dtLWD.getIn)(errors, input.name);
    });
};

});


parcelRegister("cOGx6", function(module, exports) {
$parcel$export(module.exports, "CloseButton", () => $b20a8251098e354e$export$de65de8213222d10);
parcelRequire("1v5pe");

var $hHzJx = parcelRequire("hHzJx");

var $ebDRY = parcelRequire("ebDRY");

var $kIqwl = parcelRequire("kIqwl");
const $b20a8251098e354e$export$de65de8213222d10 = ({ label: label, onBlur: onBlur, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $kIqwl.jsx)((0, $hHzJx.default), {
        testId: testId && `${testId}--close-button`,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ebDRY))),
        label: label || 'Close Modal',
        onBlur: onBlur,
        onClick: onClick
    });

});

parcelRegister("kYkRP", function(module, exports) {
$parcel$export(module.exports, "default", () => $51feafb09f6da7fc$export$2e2bcd8739ae039);
/* modal-body.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");
parcelRequire("1v5pe");

var $ccDPm = parcelRequire("ccDPm");

var $bCJu2 = parcelRequire("bCJu2");

var $l8fBF = parcelRequire("l8fBF");

var $4twQO = parcelRequire("4twQO");

var $kIqwl = parcelRequire("kIqwl");
const $51feafb09f6da7fc$var$_6 = "._18zr1ejb{padding-inline:var(--ds-space-300,24px)}";
const $51feafb09f6da7fc$var$_5 = "._1rjcv77o{padding-block:var(--ds-space-025,2px)}";
const $51feafb09f6da7fc$var$_4 = "._11c8fhey{font:var(--ds-font-body,normal 400 14px/20px \"Atlassian Sans\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const $51feafb09f6da7fc$var$_3 = "._i0dl1wug{flex-basis:auto}";
const $51feafb09f6da7fc$var$_2 = "._1o9zkb7n{flex-shrink:1}";
const $51feafb09f6da7fc$var$_ = "._16jlkb7n{flex-grow:1}";
const $51feafb09f6da7fc$var$styles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _11c8fhey",
    paddingBlock: "_1rjcv77o",
    paddingInline: "_18zr1ejb"
};
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $51feafb09f6da7fc$var$ModalBody = (props)=>{
    const { children: children, testId: userDefinedTestId, hasInlinePadding: hasInlinePadding = true } = props;
    const { testId: modalTestId } = (0, $bCJu2.useModal)();
    const shouldScrollInViewport = (0, $4twQO.default)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return shouldScrollInViewport ? /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $51feafb09f6da7fc$var$_,
                    $51feafb09f6da7fc$var$_2,
                    $51feafb09f6da7fc$var$_3,
                    $51feafb09f6da7fc$var$_4,
                    $51feafb09f6da7fc$var$_5,
                    $51feafb09f6da7fc$var$_6
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                "data-testid": testId,
                className: (0, $hMvDh.default)([
                    $51feafb09f6da7fc$var$styles.root,
                    hasInlinePadding && $51feafb09f6da7fc$var$styles.paddingInline
                ]),
                children: children
            })
        ]
    }) : /*#__PURE__*/ (0, $kIqwl.jsx)((0, $ccDPm.TouchScrollable), {
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $l8fBF.default), {
            testId: userDefinedTestId || modalTestId,
            children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                children: [
                    /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                        children: [
                            $51feafb09f6da7fc$var$_,
                            $51feafb09f6da7fc$var$_2,
                            $51feafb09f6da7fc$var$_3,
                            $51feafb09f6da7fc$var$_4,
                            $51feafb09f6da7fc$var$_5,
                            $51feafb09f6da7fc$var$_6
                        ]
                    }),
                    /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                        "data-testid": testId,
                        className: (0, $hMvDh.default)([
                            $51feafb09f6da7fc$var$styles.root,
                            /**
           * Adding block padding for scroll keylines, which are only shown when the scrolling
           * is on the container.
           */ $51feafb09f6da7fc$var$styles.paddingBlock,
                            hasInlinePadding && $51feafb09f6da7fc$var$styles.paddingInline
                        ]),
                        children: children
                    })
                ]
            })
        })
    });
};
var $51feafb09f6da7fc$export$2e2bcd8739ae039 = $51feafb09f6da7fc$var$ModalBody;

});
parcelRegister("ccDPm", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2VrMI = parcelRequire("2VrMI");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $8e257ff035359448$var$_interopRequireDefault($2VrMI).default;
    }
});

var $7bfIM = parcelRequire("7bfIM");
Object.defineProperty(module.exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $7bfIM.TouchScrollable;
    }
});
function $8e257ff035359448$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("2VrMI", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $221675163850c778$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $1v5pe = parcelRequire("1v5pe");
var $221675163850c778$var$_react2 = $221675163850c778$var$_interopRequireDefault($1v5pe);

var $hMzBt = parcelRequire("hMzBt");

var $7bfIM = parcelRequire("7bfIM");

var $bUDfS = parcelRequire("bUDfS");
var $221675163850c778$var$_withLockSheet2 = $221675163850c778$var$_interopRequireDefault($bUDfS);

var $jLDSu = parcelRequire("jLDSu");
var $221675163850c778$var$_withTouchListeners2 = $221675163850c778$var$_interopRequireDefault($jLDSu);

var $kWeoJ = parcelRequire("kWeoJ");
function $221675163850c778$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $221675163850c778$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $221675163850c778$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $221675163850c778$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $221675163850c778$var$ScrollLock = function(_PureComponent) {
    $221675163850c778$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $221675163850c778$var$_classCallCheck(this, ScrollLock);
        return $221675163850c778$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $221675163850c778$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$hMzBt.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $221675163850c778$var$_react2.default.createElement($7bfIM.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($1v5pe.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $221675163850c778$var$compose = (0, $kWeoJ.pipe)($221675163850c778$var$_withTouchListeners2.default, $221675163850c778$var$_withLockSheet2.default);
var $221675163850c778$var$SheetLock = $221675163850c778$var$compose($221675163850c778$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $221675163850c778$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $221675163850c778$var$_react2.default.createElement($221675163850c778$var$SheetLock, props) : props.children;
};
$221675163850c778$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $221675163850c778$var$LockToggle;

});
parcelRegister("hMzBt", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("7bfIM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $53a5c161f69d626a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $53a5c161f69d626a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $1v5pe = parcelRequire("1v5pe");

var $hMzBt = parcelRequire("hMzBt");

var $kWeoJ = parcelRequire("kWeoJ");
function $53a5c161f69d626a$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $53a5c161f69d626a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $53a5c161f69d626a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $53a5c161f69d626a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $53a5c161f69d626a$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $53a5c161f69d626a$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $53a5c161f69d626a$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $53a5c161f69d626a$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $53a5c161f69d626a$var$_possibleConstructorReturn(_this, _ret);
    }
    $53a5c161f69d626a$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$hMzBt.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $kWeoJ.preventInertiaScroll, $kWeoJ.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $kWeoJ.allowTouchMove, $kWeoJ.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$hMzBt.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $kWeoJ.preventInertiaScroll, $kWeoJ.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $kWeoJ.allowTouchMove, $kWeoJ.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $53a5c161f69d626a$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $1v5pe.cloneElement)(children, $53a5c161f69d626a$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($1v5pe.PureComponent);

});
parcelRegister("kWeoJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $f3e4648a60c21aa6$var$preventTouchMove;
module.exports.allowTouchMove = $f3e4648a60c21aa6$var$allowTouchMove;
module.exports.preventInertiaScroll = $f3e4648a60c21aa6$var$preventInertiaScroll;
module.exports.isTouchDevice = $f3e4648a60c21aa6$var$isTouchDevice;
module.exports.camelToKebab = $f3e4648a60c21aa6$var$camelToKebab;
module.exports.parse = $f3e4648a60c21aa6$var$parse;
module.exports.getPadding = $f3e4648a60c21aa6$var$getPadding;
module.exports.getWindowHeight = $f3e4648a60c21aa6$var$getWindowHeight;
module.exports.getDocumentHeight = $f3e4648a60c21aa6$var$getDocumentHeight;
module.exports.makeStyleTag = $f3e4648a60c21aa6$var$makeStyleTag;
module.exports.injectStyles = $f3e4648a60c21aa6$var$injectStyles;
module.exports.insertStyleTag = $f3e4648a60c21aa6$var$insertStyleTag;

var $hMzBt = parcelRequire("hMzBt");
var $f3e4648a60c21aa6$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $f3e4648a60c21aa6$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $f3e4648a60c21aa6$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $f3e4648a60c21aa6$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $f3e4648a60c21aa6$var$isTouchDevice() {
    if (!$hMzBt.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $f3e4648a60c21aa6$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $f3e4648a60c21aa6$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $f3e4648a60c21aa6$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $f3e4648a60c21aa6$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($f3e4648a60c21aa6$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $f3e4648a60c21aa6$var$getPadding() {
    if (!$hMzBt.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $f3e4648a60c21aa6$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($hMzBt.canUseDOM) return window.innerHeight * multiplier;
}
function $f3e4648a60c21aa6$var$getDocumentHeight() {
    if ($hMzBt.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $f3e4648a60c21aa6$var$makeStyleTag() {
    if (!$hMzBt.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $f3e4648a60c21aa6$var$injectStyles(tag, css) {
    if (!$hMzBt.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $f3e4648a60c21aa6$var$insertStyleTag(tag) {
    if (!$hMzBt.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

});


parcelRegister("bUDfS", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8ac35fe8abb45e58$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $8ac35fe8abb45e58$var$withLockSheet;

var $1v5pe = parcelRequire("1v5pe");
var $8ac35fe8abb45e58$var$_react2 = $8ac35fe8abb45e58$var$_interopRequireDefault($1v5pe);

var $kWeoJ = parcelRequire("kWeoJ");
function $8ac35fe8abb45e58$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8ac35fe8abb45e58$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8ac35fe8abb45e58$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8ac35fe8abb45e58$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $8ac35fe8abb45e58$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $8ac35fe8abb45e58$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $8ac35fe8abb45e58$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $8ac35fe8abb45e58$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $kWeoJ.makeStyleTag)();
                if (!sheet) return;
                (0, $kWeoJ.injectStyles)(sheet, styles);
                (0, $kWeoJ.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $kWeoJ.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $kWeoJ.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $8ac35fe8abb45e58$var$_possibleConstructorReturn(_this, _ret);
        }
        $8ac35fe8abb45e58$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet || !this.sheet.parentNode || typeof this.sheet.parentNode.removeChild !== 'function') return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $8ac35fe8abb45e58$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($1v5pe.PureComponent);
}

});

parcelRegister("jLDSu", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e64156ffba0139f6$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $e64156ffba0139f6$var$withTouchListeners;

var $1v5pe = parcelRequire("1v5pe");
var $e64156ffba0139f6$var$_react2 = $e64156ffba0139f6$var$_interopRequireDefault($1v5pe);

var $hMzBt = parcelRequire("hMzBt");

var $kWeoJ = parcelRequire("kWeoJ");
function $e64156ffba0139f6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e64156ffba0139f6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e64156ffba0139f6$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e64156ffba0139f6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $e64156ffba0139f6$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $e64156ffba0139f6$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $e64156ffba0139f6$var$_classCallCheck(this, TouchProvider);
            return $e64156ffba0139f6$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $e64156ffba0139f6$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$hMzBt.canUseDOM || !(0, $kWeoJ.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $kWeoJ.preventTouchMove, $kWeoJ.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$hMzBt.canUseDOM || !(0, $kWeoJ.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $kWeoJ.preventTouchMove, $kWeoJ.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $e64156ffba0139f6$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($1v5pe.PureComponent);
}

});



parcelRegister("bCJu2", function(module, exports) {
$parcel$export(module.exports, "useModal", () => $99b27f95562a9c00$export$33ffd74ebf07f060);

var $1v5pe = parcelRequire("1v5pe");

var $eSj0I = parcelRequire("eSj0I");
const $99b27f95562a9c00$export$33ffd74ebf07f060 = ()=>{
    const modalContext = (0, $1v5pe.useContext)((0, $eSj0I.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});
parcelRegister("eSj0I", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $c4e40c4c2ab840ea$export$ab57792b9b6974a6);

var $1v5pe = parcelRequire("1v5pe");
const $c4e40c4c2ab840ea$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $1v5pe.createContext)(null);

});


parcelRegister("l8fBF", function(module, exports) {
$parcel$export(module.exports, "default", () => $05db46a3a69573a0$export$2e2bcd8739ae039);
/* scroll-container.tsx generated by @compiled/babel-plugin v3.0.2 */ /* scroll-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $9q8C6 = parcelRequire("9q8C6");

var $ky45w = parcelRequire("ky45w");

var $fl4ll = parcelRequire("fl4ll");

var $aD9yk = parcelRequire("aD9yk");

var $bbv94 = parcelRequire("bbv94");

var $22rKq = parcelRequire("22rKq");

var $kIqwl = parcelRequire("kIqwl");
const $05db46a3a69573a0$var$_11 = "._179ria51{border-block-end:var(--ds-border-width,1px) solid var(--ds-border,#0b120e24)}";
const $05db46a3a69573a0$var$_10 = "._mqm2ia51{border-block-start:var(--ds-border-width,1px) solid var(--ds-border,#0b120e24)}";
const $05db46a3a69573a0$var$_1 = "@media (min-width:30rem){._1jykn7od{height:unset}._wzg61wug{overflow-y:auto}}";
const $05db46a3a69573a0$var$_0 = "._18m91wug{overflow-y:auto}";
const $05db46a3a69573a0$var$_9 = "._1reo15vq{overflow-x:hidden}";
const $05db46a3a69573a0$var$_8 = "._ahbqze3t{margin-inline-start:var(--ds-space-0,0)}";
const $05db46a3a69573a0$var$_7 = "._12l2ze3t{margin-inline-end:var(--ds-space-0,0)}";
const $05db46a3a69573a0$var$_6 = "._1pfhze3t{margin-block-start:var(--ds-space-0,0)}";
const $05db46a3a69573a0$var$_5 = "._6rthze3t{margin-block-end:var(--ds-space-0,0)}";
const $05db46a3a69573a0$var$_4 = "._16jlkb7n{flex-grow:1}";
const $05db46a3a69573a0$var$_3 = "._2lx21kw7{flex-direction:inherit}";
const $05db46a3a69573a0$var$_2 = "._1e0c1kw7{display:inherit}";
const $05db46a3a69573a0$var$_ = "._kkes1kw7{flex:inherit}";
const $05db46a3a69573a0$var$keylineColor = "var(--ds-border, #0B120E24)";
const $05db46a3a69573a0$var$styles = {
    base: "_kkes1kw7 _1e0c1kw7 _2lx21kw7 _16jlkb7n _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1reo15vq _18m91wug _1jykn7od _wzg61wug",
    topKeyline: "_mqm2ia51",
    bottomKeyline: "_179ria51"
};
const $05db46a3a69573a0$var$keylineHeight = 1;
const $05db46a3a69573a0$var$ScrollContainer = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ testId: testId, children: children }, ref)=>{
    const scrollableRef = (0, $1v5pe.useRef)(null);
    const [showTopKeyline, setTopKeyline] = (0, $1v5pe.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $1v5pe.useState)(false);
    const [showContentFocus, setContentFocus] = (0, $1v5pe.useState)(false); // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $1v5pe.useEffect)(()=>{
        const schedule = (0, $9q8C6.default)(()=>{
            const target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    const setLazyKeylines = (0, $bbv94.default)((0, $9q8C6.default)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $05db46a3a69573a0$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $05db46a3a69573a0$var$keylineHeight);
        }
    })); // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $1v5pe.useEffect)(()=>{
        const target = scrollableRef.current;
        setLazyKeylines();
        const unbindWindowEvent = (0, $dmmsG.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        const unbindTargetEvent = target ? (0, $dmmsG.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $aD9yk.default);
        return ()=>{
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $05db46a3a69573a0$var$_,
                    $05db46a3a69573a0$var$_2,
                    $05db46a3a69573a0$var$_3,
                    $05db46a3a69573a0$var$_4,
                    $05db46a3a69573a0$var$_5,
                    $05db46a3a69573a0$var$_6,
                    $05db46a3a69573a0$var$_7,
                    $05db46a3a69573a0$var$_8,
                    $05db46a3a69573a0$var$_9,
                    $05db46a3a69573a0$var$_0,
                    $05db46a3a69573a0$var$_1,
                    $05db46a3a69573a0$var$_10,
                    $05db46a3a69573a0$var$_11
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $22rKq.Focusable), {
                as: "div",
                isInset: true // tabindex is allowed here so that keyboard users can scroll content
                ,
                tabIndex: showContentFocus ? 0 : undefined,
                role: showContentFocus ? 'region' : undefined,
                "aria-label": showContentFocus ? 'Scrollable content' : undefined,
                testId: testId && `${testId}--scrollable`,
                ref: (0, $fl4ll.default)([
                    ref,
                    scrollableRef
                ]),
                xcss: (0, $ky45w.cx)($05db46a3a69573a0$var$styles.base, showTopKeyline && $05db46a3a69573a0$var$styles.topKeyline, showBottomKeyline && $05db46a3a69573a0$var$styles.bottomKeyline),
                children: children
            })
        ]
    });
});
$05db46a3a69573a0$var$ScrollContainer.displayName = 'ScrollContainer';
var $05db46a3a69573a0$export$2e2bcd8739ae039 = $05db46a3a69573a0$var$ScrollContainer;

});
parcelRegister("bbv94", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f4cc428438d68f9$export$2e2bcd8739ae039);

var $kmNm3 = parcelRequire("kmNm3");
function $1f4cc428438d68f9$export$2e2bcd8739ae039(callback) {
    const ref = (0, $kmNm3.default)(()=>callback);
    return ref.current;
}

});
parcelRegister("kmNm3", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4cfb5ef88df5eaf$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");
const $b4cfb5ef88df5eaf$var$uniqueReferencedValue = {};
function $b4cfb5ef88df5eaf$export$2e2bcd8739ae039(initializer) {
    const ref = (0, $1v5pe.useRef)($b4cfb5ef88df5eaf$var$uniqueReferencedValue);
    if (ref.current === $b4cfb5ef88df5eaf$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});



parcelRegister("4twQO", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cb5b4cfa9297de2$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $1LjAb = parcelRequire("1LjAb");
function $2cb5b4cfa9297de2$export$2e2bcd8739ae039() {
    const shouldScrollInViewport = (0, $1v5pe.useContext)((0, $1LjAb.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});
parcelRegister("1LjAb", function(module, exports) {
$parcel$export(module.exports, "ScrollContext", () => $fe5f9084ae0bce2b$export$dece24112a937f92);

var $1v5pe = parcelRequire("1v5pe");
const $fe5f9084ae0bce2b$export$dece24112a937f92 = /*#__PURE__*/ (0, $1v5pe.createContext)(null);

});



parcelRegister("2rArt", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca3762ffc2207830$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $hRF0p = parcelRequire("hRF0p");

var $kIqwl = parcelRequire("kIqwl");
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $ca3762ffc2207830$var$ModalWrapper = /*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $hRF0p.default), {
        ...props,
        isFullScreen: false,
        ref: ref
    });
});
$ca3762ffc2207830$var$ModalWrapper.displayName = 'ModalWrapper';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ca3762ffc2207830$export$2e2bcd8739ae039 = $ca3762ffc2207830$var$ModalWrapper;

});
parcelRegister("hRF0p", function(module, exports) {
$parcel$export(module.exports, "default", () => $70ef7ffe6f4f9558$export$2e2bcd8739ae039);
/* modal-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $4r5TA = parcelRequire("4r5TA");

var $ccDPm = parcelRequire("ccDPm");

var $j9QYE = parcelRequire("j9QYE");

var $6pgJk = parcelRequire("6pgJk");

var $aD9yk = parcelRequire("aD9yk");

var $Ms2ib = parcelRequire("Ms2ib");

var $lHxwq = parcelRequire("lHxwq");

var $azfBr = parcelRequire("azfBr");

var $fsl6p = parcelRequire("fsl6p");

var $eTbg2 = parcelRequire("eTbg2");

var $cUr2h = parcelRequire("cUr2h");

var $etMwD = parcelRequire("etMwD");

var $7M9W5 = parcelRequire("7M9W5");

var $2aEiL = parcelRequire("2aEiL");

var $kARP4 = parcelRequire("kARP4");

var $jySDc = parcelRequire("jySDc");

var $iMM0r = parcelRequire("iMM0r");

var $h4l9f = parcelRequire("h4l9f");

var $gUI7t = parcelRequire("gUI7t");

var $3Lr6X = parcelRequire("3Lr6X");

var $eSj0I = parcelRequire("eSj0I");

var $3nXae = parcelRequire("3nXae");

var $5ogzQ = parcelRequire("5ogzQ");

var $9o1SS = parcelRequire("9o1SS");

var $94IQO = parcelRequire("94IQO");

var $11R2l = parcelRequire("11R2l");

var $1LjAb = parcelRequire("1LjAb");

var $8KJ3R = parcelRequire("8KJ3R");

var $5BrkL = parcelRequire("5BrkL");

var $kIqwl = parcelRequire("kIqwl");
const $70ef7ffe6f4f9558$var$_32 = "@media (min-width:30rem){._e8uo1ris{max-height:-moz-max-content;max-height:max-content}}";
const $70ef7ffe6f4f9558$var$_31 = "@media (min-width:30rem){._1jyk17ks{height:var(--modal-dialog-height)}._g7116m9r{width:var(--modal-dialog-width)}._we1i18uh{max-width:calc(100vw - 90pt)}._e8uo221b{max-height:calc(100vh - 90pt)}}";
const $70ef7ffe6f4f9558$var$_30 = "@media (min-width:30rem){._1sg41wqb{margin-top:60px}._maxs1wug{margin-right:auto}._1jvh1wqb{margin-bottom:60px}._1uca1wug{margin-left:auto}._1mpv184x{min-height:-moz-min-content;min-height:min-content}._1jyk17ks{height:var(--modal-dialog-height)}._g7116m9r{width:var(--modal-dialog-width)}._we1i18uh{max-width:calc(100vw - 90pt)}}";
const $70ef7ffe6f4f9558$var$_29 = "._8am5i4x0{-webkit-overflow-scrolling:touch}";
const $70ef7ffe6f4f9558$var$_28 = "._18m91wug{overflow-y:auto}";
const $70ef7ffe6f4f9558$var$_27 = "._1e02ze3t{inset-inline-start:var(--ds-space-0,0)}";
const $70ef7ffe6f4f9558$var$_26 = "._152tze3t{inset-block-start:var(--ds-space-0,0)}";
const $70ef7ffe6f4f9558$var$_25 = "._kqsw1n9t{position:fixed}";
const $70ef7ffe6f4f9558$var$_24 = "@media (min-width:30rem){._epkxpb1k{border-radius:var(--ds-radius-xlarge,9pt)}}";
const $70ef7ffe6f4f9558$var$_23 = "._2rkoidpf{border-radius:0}";
const $70ef7ffe6f4f9558$var$_22 = "@media (min-width:30rem){._zg7p130s{box-shadow:var(--ds-shadow-overlay,0 8px 9pt #1e1f2126,0 0 1px #1e1f214f)}}";
const $70ef7ffe6f4f9558$var$_21 = "._128mdkaa:focus-visible{outline-width:var(--ds-border-width-focused,2px)}";
const $70ef7ffe6f4f9558$var$_20 = "._ra3xnqa1:focus-visible{outline-style:solid}";
const $70ef7ffe6f4f9558$var$_19 = "._1ah3dkaa:focus-visible{outline-offset:var(--ds-border-width-focused,2px)}";
const $70ef7ffe6f4f9558$var$_18 = "._mizu1v1w:focus-visible{outline-color:var(--ds-border-focused,#4688ec)}";
const $70ef7ffe6f4f9558$var$_17 = "._1dg11kw7>form:only-child{flex-direction:inherit}";
const $70ef7ffe6f4f9558$var$_16 = "._ds62idpf>form:only-child{min-height:0}";
const $70ef7ffe6f4f9558$var$_15 = "._m01u1kw7>form:only-child{max-height:inherit}";
const $70ef7ffe6f4f9558$var$_14 = "._1mq81kw7>form:only-child{display:inherit}";
const $70ef7ffe6f4f9558$var$_13 = "._lcxv1wug{pointer-events:auto}";
const $70ef7ffe6f4f9558$var$_12 = "._1q1l1bhr{--ds-elevation-surface-current:var(--ds-surface-overlay,#fff)}";
const $70ef7ffe6f4f9558$var$_11 = "._bfhk1bhr{background-color:var(--ds-surface-overlay,#fff)}";
const $70ef7ffe6f4f9558$var$_10 = "._2lx21bp4{flex-direction:column}";
const $70ef7ffe6f4f9558$var$_1 = "._1e0c1txw{display:flex}";
const $70ef7ffe6f4f9558$var$_0 = "._4t3i1kxc{height:100vh}";
const $70ef7ffe6f4f9558$var$_9 = "._1bsbauwl{width:100vw}";
const $70ef7ffe6f4f9558$var$_8 = "._ln19p27b{scrollbar-gutter:stable}";
const $70ef7ffe6f4f9558$var$_7 = "@media (min-width:30rem){._1sg41wqb{margin-top:60px}._maxs1wug{margin-right:auto}._1jvh1wqb{margin-bottom:60px}._1uca1wug{margin-left:auto}}";
const $70ef7ffe6f4f9558$var$_6 = "._18u0idpf{margin-left:0}";
const $70ef7ffe6f4f9558$var$_5 = "._otyridpf{margin-bottom:0}";
const $70ef7ffe6f4f9558$var$_4 = "._2hwxidpf{margin-right:0}";
const $70ef7ffe6f4f9558$var$_3 = "._19pkidpf{margin-top:0}";
const $70ef7ffe6f4f9558$var$_2 = "._18m9ewfl{overflow-y:visible}";
const $70ef7ffe6f4f9558$var$_ = "._1reoewfl{overflow-x:visible}";
const $70ef7ffe6f4f9558$var$fillScreenStyles = null;
/**
 * Styles applied to the <dialog> wrapper, NOT the visual modal surface.
 */ const $70ef7ffe6f4f9558$var$dialogStyles = {
    'body-scroll': "_1reoewfl _18m9ewfl _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1sg41wqb _maxs1wug _1jvh1wqb _1uca1wug",
    'viewport-scroll': "_ln19p27b _1bsbauwl _4t3i1kxc",
    'full-screen': "_1bsbauwl _4t3i1kxc"
};
// Visual styles for modal content inside native <dialog>.
// Uses cssMap (not css) to avoid triggering no-nested-styles lint rule.
const $70ef7ffe6f4f9558$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current'; /**
                                                                                                         * Styles applied to the visual modal surface.
                                                                                                         */ 
const $70ef7ffe6f4f9558$var$surfaceStyles = {
    root: "_1e0c1txw _2lx21bp4 _bfhk1bhr _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _ds62idpf _1dg11kw7 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _zg7p130s",
    borderRadius: "_2rkoidpf _epkxpb1k"
};
const $70ef7ffe6f4f9558$var$topLayerScrollModeStyles = {
    'full-screen': "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
    'viewport-scroll': "_4t3i1kxc _1sg41wqb _maxs1wug _1jvh1wqb _1uca1wug _1mpv184x _1jyk17ks _g7116m9r _we1i18uh",
    'body-scroll': "_1bsbauwl _4t3i1kxc _1jyk17ks _g7116m9r _we1i18uh _e8uo221b"
};
const $70ef7ffe6f4f9558$var$topLayerAutoHeightStyles = null;
const $70ef7ffe6f4f9558$var$allowlistElements = (element, callback)=>{
    // Allow focus outside modal when AUI dialog is visible
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- legacy FocusLock allowlist
    if (document.querySelector('.aui-blanket:not([hidden])')) return false;
     // Optional callback to let consumers exclude elements from focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
}; // Analytics-wrapped close handler. Extracted so both rendering paths build it
// identically.
function $70ef7ffe6f4f9558$var$useModalCloseHandler(providedOnClose) {
    return (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $aD9yk.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: undefined,
        packageVersion: undefined
    });
}
function $70ef7ffe6f4f9558$var$getScrollMode({ shouldScrollInViewport: shouldScrollInViewport, isFullScreen: isFullScreen }) {
    if (isFullScreen) return 'full-screen';
    if (shouldScrollInViewport) return 'viewport-scroll';
    return 'body-scroll';
}
function $70ef7ffe6f4f9558$var$isWidthName(value) {
    return (0, $8KJ3R.width).values.includes(value);
}
function $70ef7ffe6f4f9558$var$getTopLayerSurfaceWidth(input) {
    if (!input) return 'auto';
    if (typeof input === 'number') return `${input}px`;
    if ($70ef7ffe6f4f9558$var$isWidthName(input)) return `${(0, $8KJ3R.width).widths[input]}px`;
    if (input.endsWith('%')) // Percentage widths need special handling in the top layer.
    // In legacy, the percentage resolved against the Positioner's max-width
    // (100vw - 120px). In the top layer, the <dialog>'s containing block is the
    // viewport (100vw), so a raw percentage would produce a wider modal.
    // Transform e.g. '42%' → 'calc(42 * (100vw - 120px) / 100)' to match legacy.
    return `calc(${parseFloat(input)} * (100vw - 120px) / 100)`;
    return input;
}
function $70ef7ffe6f4f9558$var$getTopLayerSurfaceHeight(input) {
    if (!input) // Although this value would ordinarily fill the viewport height,
    // there is also a `max-height: max-content` applied to keep it constrained.
    // But we need to provide the modal with a fixed height (non-keyword, non-percentage)
    // in order for child elements with 100% height to work correctly.
    return 'calc(100vh - 120px)';
    if (typeof input === 'number') return `${input}px`;
    if (input.endsWith('%')) // Percentage heights need special handling in the top layer.
    // In legacy, the percentage resolved against the Positioner's max-height
    // (100vh - 120px). In the top layer, the <dialog>'s containing block is the
    // viewport (100vh), so a raw percentage would produce a taller modal.
    // Transform e.g. '42%' → 'calc(42 * (100vh - 120px) / 100)' to match legacy.
    return `calc(${parseFloat(input)} * (100vh - 120px) / 100)`;
    return input;
}
function $70ef7ffe6f4f9558$var$getDismissedBy({ shouldCloseOnEscapePress: shouldCloseOnEscapePress, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick }) {
    if (shouldCloseOnEscapePress && shouldCloseOnOverlayClick) return 'escape-and-outside-click';
    if (shouldCloseOnEscapePress) return 'escape';
     // Backdrop clicks only: `Dialog` asks on both, and `onDialogAsk` ignores Escape.
    if (shouldCloseOnOverlayClick) return 'escape-and-outside-click';
    return 'none';
} /**
   * Top-layer rendering path (platform-dst-top-layer).
   *
   * Replaces Portal, FocusLock, ScrollLock, Blanket, Positioner, and z-index
   * management with native <dialog> via @atlaskit/top-layer/dialog.
   *
   * Key decisions:
   * - Animation: CSS transitions via @starting-style / allow-discrete.
   * - Close gating: matches legacy while open. Dialog asks on Escape and backdrop
   *   clicks (the consumer may refuse any number of times). During the exit they
   *   do not call `onClose` again.
   * - A close that Dialog did not ask about (e.g. `<form method="dialog">`): not
   *   supported. Dialog shows the modal again, and `onClose` does not run.
   * - onClose event param: undefined - consumers should use close reason.
   * - Focus restoration: native <dialog> behavior replaces react-focus-lock's
   *   returnFocus (see accessibility-criteria.md).
   *
   * Every hook here runs unconditionally: this component only mounts on the
   * top-layer path, so it never shares a hook sequence with the legacy path.
   */ 
function $70ef7ffe6f4f9558$var$ModalWrapperTopLayer(props) {
    const { autoFocus: autoFocus, UNSAFE__disableInitialAutoFocus: UNSAFE__disableInitialAutoFocus, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, onClose: providedOnClose, onStackChange: onStackChange = (0, $aD9yk.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width = 'medium', onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId, isFullScreen: isFullScreen = false } = props;
    (0, $3nXae.default)({
        onStackChange: onStackChange
    });
    const onCloseHandler = $70ef7ffe6f4f9558$var$useModalCloseHandler(providedOnClose);
    const { isExiting: isExiting, onFinish: onExitFinish } = (0, $cUr2h.useExitingPersistence)(); // Native <dialog> always restores focus on close - no opt-out via shouldReturnFocus.
    const defaultTestId = testId || 'modal-dialog';
    const id = (0, $lHxwq.useId)();
    const titleId = `modal-dialog-title-${id}`; // Content container ref - used for onOpenComplete/onCloseComplete callbacks.
    const contentRef = (0, $1v5pe.useRef)(null); // Cache last content element for onCloseComplete after children unmount
    // (with reduced motion, contentRef clears before onExitFinish fires).
    const lastContentElRef = (0, $1v5pe.useRef)(null);
    if (contentRef.current) lastContentElRef.current = contentRef.current;
     // Native <dialog> ref - needed for ExitingPersistence to call dialog.close().
    const dialogRef = (0, $1v5pe.useRef)(null);
    const hasProvidedOnClose = Boolean(providedOnClose);
    const modalDialogContext = (0, $1v5pe.useMemo)(()=>({
            testId: defaultTestId,
            titleId: titleId,
            onClose: onCloseHandler,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen ?? false
        }), [
        defaultTestId,
        titleId,
        onCloseHandler,
        hasProvidedOnClose,
        isFullScreen
    ]); // Pass a synthetic event to satisfy the KeyboardOrMouseEvent contract. Dialog calls this
    // for an allowed Escape or backdrop click.
    const onDialogClose = (0, $1v5pe.useCallback)(({ reason: reason })=>{
        onCloseHandler((0, $h4l9f.createCloseEvent)({
            reason: reason
        }));
    }, [
        onCloseHandler
    ]); /**
                         * Dialog asks on an allowed Escape or backdrop click. Ignoring an Escape ask refuses it:
                         * Dialog still cancels the Escape `keydown`, so nothing else closes.
                         */ 
    const onDialogAsk = (0, $1v5pe.useCallback)(({ reason: reason })=>{
        if (reason === 'escape' && !shouldCloseOnEscapePress) return;
        onDialogClose({
            reason: reason
        });
    }, [
        onDialogClose,
        shouldCloseOnEscapePress
    ]); // Unlike legacy, Escape and backdrop clicks during the exit do not call `onClose` again.
    // See `@atlaskit/top-layer` notes: `decisions/dialog-close-flow.md`.
    // Dialog could not reopen after a close it did not ask about (its parent layer is closed), so
    // the `<dialog>` is already gone. End the exit.
    (0, $1v5pe.useEffect)(()=>{
        if (isExiting && !dialogRef.current) onExitFinish?.();
    }, [
        isExiting,
        onExitFinish
    ]); // ExitingPersistence: isExiting → isOpen={false} → Dialog exit animation →
    // onExitFinish → onCloseComplete + unmount.
    const handleDialogExitFinish = (0, $1v5pe.useCallback)(()=>{
        const el = contentRef.current ?? lastContentElRef.current;
        if (onCloseComplete && el) onCloseComplete(el);
        lastContentElRef.current = null;
        onExitFinish?.();
    }, [
        onExitFinish,
        onCloseComplete
    ]);
    const handleDialogEnterFinish = (0, $1v5pe.useCallback)(()=>{
        if (onOpenComplete && contentRef.current) onOpenComplete(contentRef.current, true);
    }, [
        onOpenComplete
    ]); // Honor `shouldReturnFocus={ref}` on unmount.
    // Native <dialog>.close() restores focus to the trigger that opened it,
    // but the consumer asked for focus to go to a specific element instead.
    // Run this in an unmount cleanup so it fires after dialog.close()
    // (which fires in the Dialog's effect cleanup).
    const shouldReturnFocusRef = (0, $1v5pe.useRef)(shouldReturnFocus);
    shouldReturnFocusRef.current = shouldReturnFocus;
    (0, $1v5pe.useEffect)(()=>{
        return ()=>{
            const target = shouldReturnFocusRef.current;
            if (typeof target === 'object' && target.current) target.current.focus();
        };
    }, []); // Focus a ref-targeted element after mount (when autoFocus is a ref).
    // When true, native <dialog>.showModal() handles focus automatically.
    (0, $Ms2ib.default)(typeof autoFocus === 'object' ? autoFocus : undefined, typeof autoFocus === 'object' && !UNSAFE__disableInitialAutoFocus); // Chrome cross-origin iframe DnD workaround (crbug.com/362301053)
    (0, $1v5pe.useEffect)(()=>{
        return (0, $jySDc.combine)((0, $9o1SS.disableDraggingToCrossOriginIFramesForElement)(), (0, $11R2l.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $94IQO.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    const scrollMode = $70ef7ffe6f4f9558$var$getScrollMode({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $70ef7ffe6f4f9558$var$_,
                    $70ef7ffe6f4f9558$var$_2,
                    $70ef7ffe6f4f9558$var$_3,
                    $70ef7ffe6f4f9558$var$_4,
                    $70ef7ffe6f4f9558$var$_5,
                    $70ef7ffe6f4f9558$var$_6,
                    $70ef7ffe6f4f9558$var$_7,
                    $70ef7ffe6f4f9558$var$_8,
                    $70ef7ffe6f4f9558$var$_9,
                    $70ef7ffe6f4f9558$var$_0
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $gUI7t.Dialog), {
                ref: dialogRef,
                onClose: onDialogAsk,
                dismissedBy: $70ef7ffe6f4f9558$var$getDismissedBy({
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
                }),
                onExitFinish: handleDialogExitFinish,
                shouldAnimate: !isFullScreen,
                isOpen: !isExiting,
                onEnterFinish: handleDialogEnterFinish,
                shouldHideBackdrop: isBlanketHidden // Dialog requires at least one of `label` or `labelledBy` (string, not undefined).
                ,
                ...label ? {
                    label: label
                } : {
                    labelledBy: titleId
                },
                testId: defaultTestId,
                xcss: $70ef7ffe6f4f9558$var$dialogStyles[scrollMode],
                children: [
                    /*#__PURE__*/ (0, $kIqwl.jsx)((0, $3Lr6X.DialogScrollLock), {
                        isOpen: true
                    }),
                    /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                        children: [
                            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                                children: [
                                    $70ef7ffe6f4f9558$var$_1,
                                    $70ef7ffe6f4f9558$var$_10,
                                    $70ef7ffe6f4f9558$var$_11,
                                    $70ef7ffe6f4f9558$var$_12,
                                    $70ef7ffe6f4f9558$var$_13,
                                    $70ef7ffe6f4f9558$var$_14,
                                    $70ef7ffe6f4f9558$var$_15,
                                    $70ef7ffe6f4f9558$var$_16,
                                    $70ef7ffe6f4f9558$var$_17,
                                    $70ef7ffe6f4f9558$var$_18,
                                    $70ef7ffe6f4f9558$var$_19,
                                    $70ef7ffe6f4f9558$var$_20,
                                    $70ef7ffe6f4f9558$var$_21,
                                    $70ef7ffe6f4f9558$var$_22,
                                    $70ef7ffe6f4f9558$var$_23,
                                    $70ef7ffe6f4f9558$var$_24,
                                    $70ef7ffe6f4f9558$var$_9,
                                    $70ef7ffe6f4f9558$var$_0,
                                    $70ef7ffe6f4f9558$var$_25,
                                    $70ef7ffe6f4f9558$var$_26,
                                    $70ef7ffe6f4f9558$var$_27,
                                    $70ef7ffe6f4f9558$var$_28,
                                    $70ef7ffe6f4f9558$var$_29,
                                    $70ef7ffe6f4f9558$var$_30,
                                    $70ef7ffe6f4f9558$var$_31,
                                    $70ef7ffe6f4f9558$var$_32
                                ]
                            }),
                            /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                                ref: contentRef,
                                style: {
                                    '--modal-dialog-height': $70ef7ffe6f4f9558$var$getTopLayerSurfaceHeight(height),
                                    '--modal-dialog-width': $70ef7ffe6f4f9558$var$getTopLayerSurfaceWidth(width)
                                },
                                className: (0, $hMvDh.default)([
                                    $70ef7ffe6f4f9558$var$surfaceStyles.root,
                                    !isFullScreen && $70ef7ffe6f4f9558$var$surfaceStyles.borderRadius,
                                    $70ef7ffe6f4f9558$var$topLayerScrollModeStyles[scrollMode],
                                    !height && !isFullScreen && "_e8uo1ris"
                                ]),
                                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eSj0I.ModalContext).Provider, {
                                    value: modalDialogContext,
                                    children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1LjAb.ScrollContext).Provider, {
                                        value: shouldScrollInViewport,
                                        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7M9W5.default), {
                                            children: children
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/**
 * Legacy rendering path (Portal + FocusLock + ScrollLock + Blanket).
 *
 * Every hook here runs unconditionally: this component only mounts on the
 * legacy path, so it never shares a hook sequence with the top-layer path.
 */ const $70ef7ffe6f4f9558$var$ModalWrapperLegacy = /*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>{
    const { autoFocus: autoFocus, UNSAFE__disableInitialAutoFocus: UNSAFE__disableInitialAutoFocus = false, focusLockAllowlist: focusLockAllowlist, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, stackIndex: stackIndexOverride, onClose: providedOnClose, onStackChange: onStackChange = (0, $aD9yk.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId, isFullScreen: isFullScreen, UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift = false } = props;
    const calculatedStackIndex = (0, $3nXae.default)({
        onStackChange: onStackChange
    });
    const stackIndex = stackIndexOverride || calculatedStackIndex;
    const isForeground = stackIndex === 0; // If no ref is provided, autofocus on first element
    const autoFocusLock = !UNSAFE__disableInitialAutoFocus && !(typeof autoFocus === 'object');
    const onCloseHandler = $70ef7ffe6f4f9558$var$useModalCloseHandler(providedOnClose);
    const onBlanketClicked = (0, $1v5pe.useCallback)((e)=>{
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]); // Stable callback to avoid re-renders when focusLockAllowlist is not provided.
    const allowListCallback = (0, $1v5pe.useCallback)((element)=>$70ef7ffe6f4f9558$var$allowlistElements(element, focusLockAllowlist), [
        focusLockAllowlist
    ]); // Prevent background scroll (top-layer path uses DialogScrollLock instead).
    (0, $5ogzQ.default)(); // Register with the open layer observer. On the top-layer path the Dialog
    // primitive does this itself, which is why it lives in this legacy-only
    // component rather than the shared dispatcher.
    (0, $fsl6p.useNotifyOpenLayerObserver)({
        type: 'modal',
        // Always open — modal is conditionally rendered when visible.
        isOpen: true,
        // No-op: no current use case for programmatic close via OpenLayerObserver.
        onClose: (0, $aD9yk.default)
    });
    const modalDialogWithBlanket = /*#__PURE__*/ (0, $kIqwl.jsx)((0, $6pgJk.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && `${testId}--blanket`,
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $5BrkL.default), {
            testId: testId,
            label: label,
            autoFocus: autoFocus,
            stackIndex: stackIndex,
            onClose: onCloseHandler,
            shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
            shouldScrollInViewport: shouldScrollInViewport,
            height: height,
            width: width,
            onCloseComplete: onCloseComplete,
            onOpenComplete: onOpenComplete,
            hasProvidedOnClose: Boolean(providedOnClose),
            isFullScreen: isFullScreen,
            UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift,
            ref: ref,
            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7M9W5.default), {
                children: children
            })
        })
    });
    let returnFocus = true;
    let onDeactivation = (0, $aD9yk.default);
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = ()=>{
        window.setTimeout(()=>{
            shouldReturnFocus.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $azfBr.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kARP4.default), {
            zIndex: (0, $iMM0r.layers).modal(),
            children: !UNSAFE_shouldDisableMotionUplift && (0, $2aEiL.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eTbg2.default), {
                enteringAnimation: "var(--ds-blanket-enter, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
                exitingAnimation: "var(--ds-blanket-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                    children: [
                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                            children: [
                                $70ef7ffe6f4f9558$var$_9,
                                $70ef7ffe6f4f9558$var$_0,
                                $70ef7ffe6f4f9558$var$_25,
                                $70ef7ffe6f4f9558$var$_26,
                                $70ef7ffe6f4f9558$var$_27,
                                $70ef7ffe6f4f9558$var$_28,
                                $70ef7ffe6f4f9558$var$_29
                            ]
                        }),
                        /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                            "aria-hidden": !isForeground,
                            className: (0, $hMvDh.default)([
                                "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0"
                            ]),
                            children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $4r5TA.default), {
                                autoFocus: autoFocusLock,
                                returnFocus: returnFocus,
                                onDeactivation: onDeactivation,
                                whiteList: allowListCallback,
                                children: [
                                    /*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ccDPm))), {}),
                                    shouldScrollInViewport ? /*#__PURE__*/ (0, $kIqwl.jsx)((0, $ccDPm.TouchScrollable), {
                                        children: modalDialogWithBlanket
                                    }) : modalDialogWithBlanket
                                ]
                            })
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $kIqwl.jsx)((0, $etMwD.default), {
                children: (fadeInProps)=>/*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                        children: [
                            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                                children: [
                                    $70ef7ffe6f4f9558$var$_9,
                                    $70ef7ffe6f4f9558$var$_0,
                                    $70ef7ffe6f4f9558$var$_25,
                                    $70ef7ffe6f4f9558$var$_26,
                                    $70ef7ffe6f4f9558$var$_27,
                                    $70ef7ffe6f4f9558$var$_28,
                                    $70ef7ffe6f4f9558$var$_29
                                ]
                            }),
                            /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                                ...fadeInProps,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                                className: (0, $hMvDh.default)([
                                    "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
                                    fadeInProps.className
                                ]),
                                "aria-hidden": !isForeground,
                                children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $4r5TA.default), {
                                    autoFocus: autoFocusLock,
                                    returnFocus: returnFocus,
                                    onDeactivation: onDeactivation,
                                    whiteList: allowListCallback,
                                    children: [
                                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ccDPm))), {}),
                                        shouldScrollInViewport ? /*#__PURE__*/ (0, $kIqwl.jsx)((0, $ccDPm.TouchScrollable), {
                                            children: modalDialogWithBlanket
                                        }) : modalDialogWithBlanket
                                    ]
                                })
                            })
                        ]
                    })
            })
        })
    });
}); // Choose the rendering implementation at the component boundary rather than
// gating hooks inside a single component. Each implementation owns its own
// hooks unconditionally, so a runtime feature-flag change swaps component types
// (a clean remount) instead of changing the hook order of a mounted component.
const $70ef7ffe6f4f9558$var$InternalModalWrapper = /*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>{
    if ((0, $2aEiL.fg)('platform-dst-top-layer')) // TODO: the top-layer path does not forward the external `ref` (parity
    // with the pre-refactor behavior, where the top-layer branch never
    // consumed it). The public type still advertises `RefAttributes`, so a
    // consumer ref silently no-ops here. Follow up by forwarding `ref` to a
    // sensible element (for example the content `div`) once ref parity is
    // intentionally desired.
    return /*#__PURE__*/ (0, $kIqwl.jsx)($70ef7ffe6f4f9558$var$ModalWrapperTopLayer, {
        ...props
    });
    return /*#__PURE__*/ (0, $kIqwl.jsx)($70ef7ffe6f4f9558$var$ModalWrapperLegacy, {
        ref: ref,
        ...props
    });
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $70ef7ffe6f4f9558$export$2e2bcd8739ae039 = $70ef7ffe6f4f9558$var$InternalModalWrapper;

});
parcelRegister("4r5TA", function(module, exports) {
$parcel$export(module.exports, "default", () => $33ae41c83818243c$export$2e2bcd8739ae039);

var $86t7j = parcelRequire("86t7j");

var $33ae41c83818243c$export$2e2bcd8739ae039 = (0, $86t7j.default);

});
parcelRegister("86t7j", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e65784494cf7684$export$2e2bcd8739ae039);

var $3mdE8 = parcelRequire("3mdE8");

var $87uOn = parcelRequire("87uOn");

var $1v5pe = parcelRequire("1v5pe");

var $4OfHG = parcelRequire("4OfHG");

var $cey1i = parcelRequire("cey1i");
var $5e65784494cf7684$var$FocusLockCombination = /*#__PURE__*/ $1v5pe.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $1v5pe.createElement((0, $4OfHG.default), (0, $87uOn.default)({
        sideCar: (0, $cey1i.default),
        ref: ref
    }, props));
});
var $5e65784494cf7684$var$_ref = (0, $4OfHG.default).propTypes || {}, $5e65784494cf7684$var$sideCar = $5e65784494cf7684$var$_ref.sideCar, $5e65784494cf7684$var$propTypes = (0, $3mdE8.default)($5e65784494cf7684$var$_ref, [
    "sideCar"
]);
$5e65784494cf7684$var$FocusLockCombination.propTypes = {};
var $5e65784494cf7684$export$2e2bcd8739ae039 = $5e65784494cf7684$var$FocusLockCombination;

});
parcelRegister("4OfHG", function(module, exports) {
$parcel$export(module.exports, "default", () => $380803570801efac$export$2e2bcd8739ae039);

var $87uOn = parcelRequire("87uOn");

var $1v5pe = parcelRequire("1v5pe");


var $kmUY7 = parcelRequire("kmUY7");

var $jxPGo = parcelRequire("jxPGo");

var $l3Z1u = parcelRequire("l3Z1u");

var $ahIvS = parcelRequire("ahIvS");

var $cIY8V = parcelRequire("cIY8V");
var $380803570801efac$var$emptyArray = [];
var $380803570801efac$var$FocusLock = /*#__PURE__*/ $1v5pe.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $1v5pe.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $1v5pe.useRef();
    var isActive = $1v5pe.useRef(false);
    var originalFocusedElement = $1v5pe.useRef(null);
    var _React$useState2 = $1v5pe.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $380803570801efac$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $1v5pe.useState({}), id = _React$useState3[0];
    var onActivation = $1v5pe.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $1v5pe.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $1v5pe.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $1v5pe.useCallback(function(event) {
        if (isActive.current) (0, $ahIvS.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $ahIvS.mediumBlur).useMedium;
    var setObserveNode = $1v5pe.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $87uOn.default)((_extends2 = {}, _extends2[$kmUY7.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$kmUY7.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $jxPGo.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $1v5pe.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $1v5pe.createElement($1v5pe.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $1v5pe.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $l3Z1u.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $1v5pe.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $l3Z1u.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $1v5pe.createElement(SideCar, {
        id: id,
        sideCar: (0, $ahIvS.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $1v5pe.createElement(Container, (0, $87uOn.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $1v5pe.createElement((0, $cIY8V.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $1v5pe.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $l3Z1u.hiddenGuard)
    }));
});
$380803570801efac$var$FocusLock.propTypes = {};
var $380803570801efac$export$2e2bcd8739ae039 = $380803570801efac$var$FocusLock;

});
parcelRegister("kmUY7", function(module, exports) {
$parcel$export(module.exports, "FOCUS_GROUP", () => $ed420d86be8f85e2$export$4f9a06cb7441a087);
$parcel$export(module.exports, "FOCUS_DISABLED", () => $ed420d86be8f85e2$export$aeda8252e54b50f7);
$parcel$export(module.exports, "FOCUS_ALLOW", () => $ed420d86be8f85e2$export$54ecf528c58f9ef6);
$parcel$export(module.exports, "FOCUS_AUTO", () => $ed420d86be8f85e2$export$70e9b4a1820af101);
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", () => $ed420d86be8f85e2$export$134ebef29fd94853);
/**
 * defines a focus group
 */ var $ed420d86be8f85e2$export$4f9a06cb7441a087 = 'data-focus-lock';
var $ed420d86be8f85e2$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $ed420d86be8f85e2$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $ed420d86be8f85e2$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $ed420d86be8f85e2$export$134ebef29fd94853 = 'data-no-autofocus';

});

parcelRegister("jxPGo", function(module, exports) {
$parcel$export(module.exports, "useMergeRefs", () => $e3a93085e0ad49b5$export$74665b213cb5c4cf);

var $1v5pe = parcelRequire("1v5pe");

var $5sYpU = parcelRequire("5sYpU");

var $xSLU7 = parcelRequire("xSLU7");
var $e3a93085e0ad49b5$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $1v5pe.useLayoutEffect : $1v5pe.useEffect;
var $e3a93085e0ad49b5$var$currentValues = new WeakMap();
function $e3a93085e0ad49b5$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $xSLU7.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $5sYpU.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $e3a93085e0ad49b5$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $e3a93085e0ad49b5$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $5sYpU.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $5sYpU.assignRef)(ref, current_1);
            });
        }
        $e3a93085e0ad49b5$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("5sYpU", function(module, exports) {
$parcel$export(module.exports, "assignRef", () => $3fae6eca4f3f66bc$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $3fae6eca4f3f66bc$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("xSLU7", function(module, exports) {
$parcel$export(module.exports, "useCallbackRef", () => $065d91b0b3cc0abd$export$25bec8c6f54ee79a);

var $1v5pe = parcelRequire("1v5pe");
function $065d91b0b3cc0abd$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $1v5pe.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("l3Z1u", function(module, exports) {
$parcel$export(module.exports, "hiddenGuard", () => $f55936aed11027f3$export$b8c7b07253306600);

var $1v5pe = parcelRequire("1v5pe");

var $f55936aed11027f3$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $f55936aed11027f3$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $1v5pe.createElement($1v5pe.Fragment, null, /*#__PURE__*/ $1v5pe.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $f55936aed11027f3$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $1v5pe.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $f55936aed11027f3$export$b8c7b07253306600
    }));
};
$f55936aed11027f3$var$InFocusGuard.propTypes = {};
var $f55936aed11027f3$export$2e2bcd8739ae039 = $f55936aed11027f3$var$InFocusGuard;

});

parcelRegister("ahIvS", function(module, exports) {
$parcel$export(module.exports, "mediumFocus", () => $77ce054dbe1bfcfa$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $77ce054dbe1bfcfa$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $77ce054dbe1bfcfa$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $77ce054dbe1bfcfa$export$892cbf28e5518020);

var $laqft = parcelRequire("laqft");
var $77ce054dbe1bfcfa$export$5733e022b1d538cb = (0, $laqft.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $77ce054dbe1bfcfa$export$b3e9a9312f73723c = (0, $laqft.createMedium)();
var $77ce054dbe1bfcfa$export$3a1d52767cbc07b8 = (0, $laqft.createMedium)();
var $77ce054dbe1bfcfa$export$892cbf28e5518020 = (0, $laqft.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});
parcelRegister("laqft", function(module, exports) {
$parcel$export(module.exports, "createMedium", () => $f68ee48f68e39cb2$export$9ffbfcaf067b02c6);
$parcel$export(module.exports, "createSidecarMedium", () => $f68ee48f68e39cb2$export$e13ec7dd7a14088d);

var $lmviS = parcelRequire("lmviS");
function $f68ee48f68e39cb2$var$ItoI(a) {
    return a;
}
function $f68ee48f68e39cb2$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $f68ee48f68e39cb2$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $f68ee48f68e39cb2$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $f68ee48f68e39cb2$var$ItoI;
    return $f68ee48f68e39cb2$var$innerCreateMedium(defaults, middleware);
}
function $f68ee48f68e39cb2$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $f68ee48f68e39cb2$var$innerCreateMedium(null);
    medium.options = (0, $lmviS.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});


parcelRegister("cIY8V", function(module, exports) {
$parcel$export(module.exports, "focusScope", () => $94383f3e311e8147$export$f5272e9b1168239c);

var $1v5pe = parcelRequire("1v5pe");
var $94383f3e311e8147$export$f5272e9b1168239c = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);

});


parcelRegister("cey1i", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e812e808791c7e6$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");


var $lXRNa = parcelRequire("lXRNa");

var $dGPH2 = parcelRequire("dGPH2");
var $bZxBR = parcelRequire("bZxBR");
var $6lLiI = parcelRequire("6lLiI");
var $3vXZ0 = parcelRequire("3vXZ0");
var $iEzwC = parcelRequire("iEzwC");parcelRequire("94mkS");
var $l454t = parcelRequire("l454t");

var $aqTpV = parcelRequire("aqTpV");

var $ahIvS = parcelRequire("ahIvS");
var $8e812e808791c7e6$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $8e812e808791c7e6$var$isFreeFocus = function isFreeFocus() {
    return $8e812e808791c7e6$var$focusOnBody() || (0, $iEzwC.focusIsHidden)();
};
var $8e812e808791c7e6$var$lastActiveTrap = null;
var $8e812e808791c7e6$var$lastActiveFocus = null;
var $8e812e808791c7e6$var$lastPortaledElement = null;
var $8e812e808791c7e6$var$focusWasOutsideWindow = false;
var $8e812e808791c7e6$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $8e812e808791c7e6$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($8e812e808791c7e6$var$lastActiveTrap.whiteList || $8e812e808791c7e6$var$defaultWhitelist)(activeElement);
};
var $8e812e808791c7e6$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $8e812e808791c7e6$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $8e812e808791c7e6$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $8e812e808791c7e6$var$lastPortaledElement && $8e812e808791c7e6$var$lastPortaledElement.portaledElement === element;
};
function $8e812e808791c7e6$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $8e812e808791c7e6$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($8e812e808791c7e6$var$focusWasOutsideWindow);
    return $8e812e808791c7e6$var$focusWasOutsideWindow === 'meanwhile';
};
var $8e812e808791c7e6$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $8e812e808791c7e6$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $8e812e808791c7e6$var$checkInHost(activeElement, area, area);
    });
};
var $8e812e808791c7e6$var$activateTrap = function activateTrap() {
    var result = false;
    if ($8e812e808791c7e6$var$lastActiveTrap) {
        var _lastActiveTrap = $8e812e808791c7e6$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $8e812e808791c7e6$var$lastPortaledElement && $8e812e808791c7e6$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $aqTpV.extractRef)).filter(Boolean));
            if (!activeElement || $8e812e808791c7e6$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $8e812e808791c7e6$var$focusWasOutside(crossFrame) || !$8e812e808791c7e6$var$isFreeFocus() || !$8e812e808791c7e6$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $3vXZ0.focusInside)(workingArea) || activeElement && $8e812e808791c7e6$var$withinHost(activeElement, workingArea) || $8e812e808791c7e6$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$8e812e808791c7e6$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $l454t.moveFocusInside)(workingArea, $8e812e808791c7e6$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $8e812e808791c7e6$var$lastPortaledElement = {};
                        }
                    }
                    $8e812e808791c7e6$var$focusWasOutsideWindow = false;
                    $8e812e808791c7e6$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $bZxBR.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $8e812e808791c7e6$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $8e812e808791c7e6$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $8e812e808791c7e6$var$onTrap = function onTrap(event) {
    if ($8e812e808791c7e6$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $8e812e808791c7e6$var$onBlur = function onBlur() {
    return (0, $aqTpV.deferAction)($8e812e808791c7e6$var$activateTrap);
};
var $8e812e808791c7e6$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $8e812e808791c7e6$var$recordPortal(currentNode, source);
};
var $8e812e808791c7e6$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $8e812e808791c7e6$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $1v5pe.createElement("div", {
        onBlur: $8e812e808791c7e6$var$onBlur,
        onFocus: $8e812e808791c7e6$var$onFocus
    }, children);
};
$8e812e808791c7e6$var$FocusTrap.propTypes = {};
var $8e812e808791c7e6$var$onWindowBlur = function onWindowBlur() {
    $8e812e808791c7e6$var$focusWasOutsideWindow = 'just';
    (0, $aqTpV.deferAction)(function() {
        $8e812e808791c7e6$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $8e812e808791c7e6$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $8e812e808791c7e6$var$onTrap);
    document.addEventListener('focusout', $8e812e808791c7e6$var$onBlur);
    window.addEventListener('blur', $8e812e808791c7e6$var$onWindowBlur);
};
var $8e812e808791c7e6$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $8e812e808791c7e6$var$onTrap);
    document.removeEventListener('focusout', $8e812e808791c7e6$var$onBlur);
    window.removeEventListener('blur', $8e812e808791c7e6$var$onWindowBlur);
};
function $8e812e808791c7e6$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
var $8e812e808791c7e6$var$focusLockAPI = {
    moveFocusInside: (0, $l454t.moveFocusInside),
    focusInside: (0, $3vXZ0.focusInside),
    focusNextElement: (0, $6lLiI.focusNextElement),
    focusPrevElement: (0, $6lLiI.focusPrevElement),
    focusFirstElement: (0, $6lLiI.focusFirstElement),
    focusLastElement: (0, $6lLiI.focusLastElement),
    captureFocusRestore: (0, $dGPH2.captureFocusRestore)
};
function $8e812e808791c7e6$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$8e812e808791c7e6$var$lastActiveTrap) $8e812e808791c7e6$var$attachHandler();
    var lastTrap = $8e812e808791c7e6$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $8e812e808791c7e6$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $8e812e808791c7e6$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($8e812e808791c7e6$var$focusLockAPI);
        $8e812e808791c7e6$var$activateTrap(true);
        (0, $aqTpV.deferAction)($8e812e808791c7e6$var$activateTrap);
    } else {
        $8e812e808791c7e6$var$detachHandler();
        $8e812e808791c7e6$var$lastActiveFocus = null;
    }
}
(0, $ahIvS.mediumFocus).assignSyncMedium($8e812e808791c7e6$var$onFocus);
(0, $ahIvS.mediumBlur).assignMedium($8e812e808791c7e6$var$onBlur);
(0, $ahIvS.mediumEffect).assignMedium(function(cb) {
    return cb($8e812e808791c7e6$var$focusLockAPI);
});
var $8e812e808791c7e6$export$2e2bcd8739ae039 = (0, $lXRNa.default)($8e812e808791c7e6$var$reducePropsToState, $8e812e808791c7e6$var$handleStateChangeOnClient)($8e812e808791c7e6$var$FocusWatcher);

});
parcelRegister("lXRNa", function(module, exports) {
$parcel$export(module.exports, "default", () => $ffd8d5a72c526313$export$2e2bcd8739ae039);

var $k9pxZ = parcelRequire("k9pxZ");

var $7sAh5 = parcelRequire("7sAh5");

var $1v5pe = parcelRequire("1v5pe");
function $ffd8d5a72c526313$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $k9pxZ.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $1v5pe.PureComponent));
        (0, $7sAh5.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $ffd8d5a72c526313$export$2e2bcd8739ae039 = $ffd8d5a72c526313$var$withSideEffect;

});
parcelRegister("k9pxZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $eab877127cc595c9$export$2e2bcd8739ae039);

var $e9I1c = parcelRequire("e9I1c");
function $eab877127cc595c9$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $e9I1c.default)(t, o);
}

});
parcelRegister("e9I1c", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4e40d0ec96ef49b$export$2e2bcd8739ae039);
function $a4e40d0ec96ef49b$export$2e2bcd8739ae039(t, e) {
    return $a4e40d0ec96ef49b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $a4e40d0ec96ef49b$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("7sAh5", function(module, exports) {
$parcel$export(module.exports, "default", () => $56e74951c021382b$export$2e2bcd8739ae039);

var $kq672 = parcelRequire("kq672");
function $56e74951c021382b$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $kq672.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("kq672", function(module, exports) {
$parcel$export(module.exports, "default", () => $eddafa2a5db3f8df$export$2e2bcd8739ae039);

var $ebQXH = parcelRequire("ebQXH");

var $d2s6k = parcelRequire("d2s6k");
function $eddafa2a5db3f8df$export$2e2bcd8739ae039(t) {
    var i = (0, $d2s6k.default)(t, "string");
    return "symbol" == (0, $ebQXH.default)(i) ? i : i + "";
}

});
parcelRegister("d2s6k", function(module, exports) {
$parcel$export(module.exports, "default", () => $97e14288de754642$export$2e2bcd8739ae039);

var $ebQXH = parcelRequire("ebQXH");
function $97e14288de754642$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $ebQXH.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $ebQXH.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("dGPH2", function(module, exports) {
$parcel$export(module.exports, "captureFocusRestore", () => $9f774bc8fa0c8494$export$d357db6e554ff59a);

var $24xvB = parcelRequire("24xvB");
function $9f774bc8fa0c8494$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $9f774bc8fa0c8494$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $9f774bc8fa0c8494$var$weakRef(currentElement),
            parent: $9f774bc8fa0c8494$var$weakRef(currentElement.parentElement),
            left: $9f774bc8fa0c8494$var$weakRef(currentElement.previousElementSibling),
            right: $9f774bc8fa0c8494$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $9f774bc8fa0c8494$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $9f774bc8fa0c8494$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $24xvB.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $9f774bc8fa0c8494$export$d357db6e554ff59a = function(targetElement) {
    var location = $9f774bc8fa0c8494$export$5061a7725be48ff9(targetElement);
    return function() {
        return $9f774bc8fa0c8494$var$restoreFocusTo(location);
    };
};

});
parcelRegister("24xvB", function(module, exports) {
$parcel$export(module.exports, "filterAutoFocusable", () => $1825f2a22ebc0286$export$2f70373d403a5d2b);
$parcel$export(module.exports, "getTabbableNodes", () => $1825f2a22ebc0286$export$3738e313571e2ad2);
$parcel$export(module.exports, "getFocusableNodes", () => $1825f2a22ebc0286$export$493d05a3a8e6532d);
$parcel$export(module.exports, "parentAutofocusables", () => $1825f2a22ebc0286$export$dc26309a71d1ce47);
$parcel$export(module.exports, "contains", () => $1825f2a22ebc0286$export$2344b14b097df817);

var $d3kWD = parcelRequire("d3kWD");

var $3KPZd = parcelRequire("3KPZd");

var $e3qls = parcelRequire("e3qls");

var $5mocc = parcelRequire("5mocc");
var $1825f2a22ebc0286$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $d3kWD.toArray)(nodes).filter(function(node) {
        return (0, $3KPZd.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $3KPZd.notHiddenInput)(node);
    });
};
var $1825f2a22ebc0286$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $d3kWD.toArray)(nodes).filter(function(node) {
        return (0, $3KPZd.isAutoFocusAllowedCached)(cache, node);
    });
};
var $1825f2a22ebc0286$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $e3qls.orderByTabIndex)($1825f2a22ebc0286$export$6266a5cd5915dc33((0, $5mocc.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $1825f2a22ebc0286$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $e3qls.orderByTabIndex)($1825f2a22ebc0286$export$6266a5cd5915dc33((0, $5mocc.getFocusables)(topNodes), visibilityCache), false);
};
var $1825f2a22ebc0286$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $1825f2a22ebc0286$export$6266a5cd5915dc33((0, $5mocc.getParentAutofocusables)(topNode), visibilityCache);
};
var $1825f2a22ebc0286$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $1825f2a22ebc0286$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $d3kWD.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $1825f2a22ebc0286$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $1825f2a22ebc0286$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("d3kWD", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $980bcd5b32a1328e$export$45b10814cc054894);
$parcel$export(module.exports, "asArray", () => $980bcd5b32a1328e$export$75093a47a9fa838d);
$parcel$export(module.exports, "getFirst", () => $980bcd5b32a1328e$export$bcd7afcd904dce14);
/*
IE11 support
 */ var $980bcd5b32a1328e$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $980bcd5b32a1328e$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $980bcd5b32a1328e$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("3KPZd", function(module, exports) {
$parcel$export(module.exports, "isVisibleCached", () => $2bbdfe660974b846$export$3c9dc299685ad160);
$parcel$export(module.exports, "isAutoFocusAllowedCached", () => $2bbdfe660974b846$export$bcaa50628f6a736e);
$parcel$export(module.exports, "getDataset", () => $2bbdfe660974b846$export$698b339b0c8edae3);
$parcel$export(module.exports, "isRadioElement", () => $2bbdfe660974b846$export$9d74f6fbc6f469d0);
$parcel$export(module.exports, "notHiddenInput", () => $2bbdfe660974b846$export$8197b0ea56b3b055);
$parcel$export(module.exports, "isGuard", () => $2bbdfe660974b846$export$d94b8b58ec2f30eb);
$parcel$export(module.exports, "isNotAGuard", () => $2bbdfe660974b846$export$602e5a0d338d7750);
$parcel$export(module.exports, "isDefined", () => $2bbdfe660974b846$export$4e62c701997796c1);

var $kmUY7 = parcelRequire("kmUY7");
var $2bbdfe660974b846$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $2bbdfe660974b846$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $2bbdfe660974b846$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $2bbdfe660974b846$var$isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $2bbdfe660974b846$var$isVisibleUncached = function(node, checkParent) {
    return !node || $2bbdfe660974b846$var$isTopNode(node) || !$2bbdfe660974b846$var$isElementHidden(node) && !$2bbdfe660974b846$var$isInert(node) && checkParent($2bbdfe660974b846$var$getParentNode(node));
};
var $2bbdfe660974b846$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $2bbdfe660974b846$var$isVisibleUncached(node, $2bbdfe660974b846$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $2bbdfe660974b846$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$2bbdfe660974b846$var$isTopNode(node) ? $2bbdfe660974b846$export$b8550e27de209d85(node) ? checkParent($2bbdfe660974b846$var$getParentNode(node)) : false : true;
};
var $2bbdfe660974b846$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $2bbdfe660974b846$var$isAutoFocusAllowedUncached(node, $2bbdfe660974b846$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $2bbdfe660974b846$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $2bbdfe660974b846$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $2bbdfe660974b846$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $2bbdfe660974b846$export$9d74f6fbc6f469d0 = function(node) {
    return $2bbdfe660974b846$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $2bbdfe660974b846$export$8197b0ea56b3b055 = function(node) {
    return !(($2bbdfe660974b846$export$88a6ceeed5737ba3(node) || $2bbdfe660974b846$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $2bbdfe660974b846$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $kmUY7.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $2bbdfe660974b846$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $2bbdfe660974b846$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $2bbdfe660974b846$export$602e5a0d338d7750 = function(node) {
    return !$2bbdfe660974b846$export$d94b8b58ec2f30eb(node);
};
var $2bbdfe660974b846$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("e3qls", function(module, exports) {
$parcel$export(module.exports, "orderByTabIndex", () => $a3b5c812bb69d297$export$cb40ee071f0d5226);

var $d3kWD = parcelRequire("d3kWD");
var $a3b5c812bb69d297$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $a3b5c812bb69d297$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var $a3b5c812bb69d297$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $d3kWD.toArray)(nodes).map(function(node, index) {
        var tabIndex = $a3b5c812bb69d297$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($a3b5c812bb69d297$export$350ee6c095d98996);
};

});

parcelRegister("5mocc", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $3e71c696a64224eb$export$f6768025e418420e);
$parcel$export(module.exports, "getParentAutofocusables", () => $3e71c696a64224eb$export$853fa94d922e78b9);

var $kmUY7 = parcelRequire("kmUY7");

var $d3kWD = parcelRequire("d3kWD");

var $ayBHx = parcelRequire("ayBHx");
var $3e71c696a64224eb$var$queryTabbables = (0, $ayBHx.tabbables).join(',');
var $3e71c696a64224eb$var$queryGuardTabbables = "".concat($3e71c696a64224eb$var$queryTabbables, ", [data-focus-guard]");
var $3e71c696a64224eb$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $d3kWD.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $3e71c696a64224eb$var$queryGuardTabbables : $3e71c696a64224eb$var$queryTabbables) ? [
            child
        ] : [], $3e71c696a64224eb$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $3e71c696a64224eb$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $3e71c696a64224eb$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $3e71c696a64224eb$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $3e71c696a64224eb$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $3e71c696a64224eb$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $d3kWD.toArray)(parent.parentNode.querySelectorAll($3e71c696a64224eb$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $3e71c696a64224eb$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $kmUY7.FOCUS_AUTO), "]"));
    return (0, $d3kWD.toArray)(parentFocus).map(function(node) {
        return $3e71c696a64224eb$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("ayBHx", function(module, exports) {
$parcel$export(module.exports, "tabbables", () => $7afa530e5d8a2965$export$8555f4622e95784);
/**
 * list of the object to be considered as focusable
 */ var $7afa530e5d8a2965$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

});




parcelRegister("bZxBR", function(module, exports) {
$parcel$export(module.exports, "expandFocusableNodes", () => $8baf7667b0e0242d$export$f89ac71e91767111);

var $4QHHA = parcelRequire("4QHHA");

var $3KPZd = parcelRequire("3KPZd");

var $D37dE = parcelRequire("D37dE");

var $e3qls = parcelRequire("e3qls");

var $5mocc = parcelRequire("5mocc");
var $8baf7667b0e0242d$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $4QHHA.getAllAffectedNodes)(topNode).filter((0, $3KPZd.isNotAGuard));
    var commonParent = (0, $D37dE.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, $e3qls.orderByTabIndex)((0, $5mocc.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $5mocc.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $3KPZd.isGuard)(node)
        };
    });
};

});
parcelRegister("4QHHA", function(module, exports) {
$parcel$export(module.exports, "getAllAffectedNodes", () => $387deb0bc2bf6fd1$export$7e87c4720b9b279b);

var $kmUY7 = parcelRequire("kmUY7");

var $d3kWD = parcelRequire("d3kWD");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $387deb0bc2bf6fd1$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $387deb0bc2bf6fd1$var$getTopParent = function(node) {
    return node.parentNode ? $387deb0bc2bf6fd1$var$getTopParent(node.parentNode) : node;
};
var $387deb0bc2bf6fd1$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $d3kWD.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $kmUY7.FOCUS_GROUP));
        acc.push.apply(acc, group ? $387deb0bc2bf6fd1$var$filterNested((0, $d3kWD.toArray)($387deb0bc2bf6fd1$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $kmUY7.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, $kmUY7.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("D37dE", function(module, exports) {
$parcel$export(module.exports, "getTopCommonParent", () => $07560f4b681c6d01$export$a9a7252b5f2e280e);
$parcel$export(module.exports, "allParentAutofocusables", () => $07560f4b681c6d01$export$8f99714c70a37db1);

var $24xvB = parcelRequire("24xvB");

var $d3kWD = parcelRequire("d3kWD");
var $07560f4b681c6d01$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $07560f4b681c6d01$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $07560f4b681c6d01$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $07560f4b681c6d01$var$getParents(nodeA);
    var parentsB = $07560f4b681c6d01$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $07560f4b681c6d01$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $d3kWD.asArray)(baseActiveElement);
    var leftEntries = (0, $d3kWD.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $07560f4b681c6d01$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $07560f4b681c6d01$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $24xvB.contains)(common, topCommon)) topCommon = common;
                else topCommon = $07560f4b681c6d01$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $07560f4b681c6d01$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $24xvB.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("6lLiI", function(module, exports) {
$parcel$export(module.exports, "focusNextElement", () => $49f96535dd423b3a$export$3b0237e8566c8d65);
$parcel$export(module.exports, "focusPrevElement", () => $49f96535dd423b3a$export$33b47db07a82b2fb);
$parcel$export(module.exports, "focusFirstElement", () => $49f96535dd423b3a$export$2a791d8097a66406);
$parcel$export(module.exports, "focusLastElement", () => $49f96535dd423b3a$export$6a79073ddabfd6c3);

var $4FC5g = parcelRequire("4FC5g");

var $24xvB = parcelRequire("24xvB");

var $d3kWD = parcelRequire("d3kWD");
var $49f96535dd423b3a$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, $d3kWD.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, $24xvB.contains)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, $24xvB.getTabbableNodes)(shards, new Map()) : (0, $24xvB.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $49f96535dd423b3a$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $24xvB.getTabbableNodes)((0, $d3kWD.asArray)(shards), new Map()) : (0, $24xvB.getFocusableNodes)((0, $d3kWD.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $49f96535dd423b3a$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $49f96535dd423b3a$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $49f96535dd423b3a$var$defaultOptions(options);
    var solution = $49f96535dd423b3a$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $4FC5g.focusOn)(target.node, newOptions.focusOptions);
};
var $49f96535dd423b3a$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $49f96535dd423b3a$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $49f96535dd423b3a$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $49f96535dd423b3a$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $49f96535dd423b3a$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $49f96535dd423b3a$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $4FC5g.focusOn)(node.node, options.focusOptions);
};
var $49f96535dd423b3a$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $49f96535dd423b3a$var$pickBoundary(scope, options, 'first');
};
var $49f96535dd423b3a$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $49f96535dd423b3a$var$pickBoundary(scope, options, 'last');
};

});
parcelRegister("4FC5g", function(module, exports) {
$parcel$export(module.exports, "focusOn", () => $36688872895cdb77$export$c12b3da842c43a8);
var $36688872895cdb77$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};

});


parcelRegister("3vXZ0", function(module, exports) {
$parcel$export(module.exports, "focusInside", () => $28f2cbb71962bdef$export$20115f8da7baa6fa);

var $24xvB = parcelRequire("24xvB");

var $4QHHA = parcelRequire("4QHHA");

var $d3kWD = parcelRequire("d3kWD");

var $fI7MT = parcelRequire("fI7MT");
var $28f2cbb71962bdef$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $28f2cbb71962bdef$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $d3kWD.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $28f2cbb71962bdef$var$focusInFrame(node, activeElement);
    }));
};
var $28f2cbb71962bdef$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $fI7MT.getActiveElement)((0, $d3kWD.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $4QHHA.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $24xvB.contains)(node, activeElement) || $28f2cbb71962bdef$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("fI7MT", function(module, exports) {
$parcel$export(module.exports, "getActiveElement", () => $b7010183c30f5477$export$cd4e5573fbe2b576);
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $7bM1B = parcelRequire("7bM1B");
var $b7010183c30f5477$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $b7010183c30f5477$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $7bM1B.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $b7010183c30f5477$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("7bM1B", function(module, exports) {
$parcel$export(module.exports, "safeProbe", () => $53bed03270768e0b$export$78d20aae35adef88);
var $53bed03270768e0b$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("iEzwC", function(module, exports) {
$parcel$export(module.exports, "focusIsHidden", () => $d94784f886733808$export$be6b21806d3fd485);

var $kmUY7 = parcelRequire("kmUY7");

var $24xvB = parcelRequire("24xvB");

var $d3kWD = parcelRequire("d3kWD");

var $fI7MT = parcelRequire("fI7MT");
var $d94784f886733808$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $fI7MT.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $d3kWD.toArray)(inDocument.querySelectorAll("[".concat((0, $kmUY7.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $24xvB.contains)(node, activeElement);
    });
};

});

parcelRegister("94mkS", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => (parcelRequire("l454t")).moveFocusInside);

var $kmUY7 = parcelRequire("kmUY7");

var $3vXZ0 = parcelRequire("3vXZ0");

var $iEzwC = parcelRequire("iEzwC");


var $bZxBR = parcelRequire("bZxBR");

var $l454t = parcelRequire("l454t");

var $dGPH2 = parcelRequire("dGPH2");

var $6lLiI = parcelRequire("6lLiI");

/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $69a5d02abfa89445$export$1a988e7317c65621 = $kmUY7;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $69a5d02abfa89445$var$deprecated_default_moveFocusInside = (0, $l454t.moveFocusInside);
var $69a5d02abfa89445$export$2e2bcd8739ae039 //
 = $69a5d02abfa89445$var$deprecated_default_moveFocusInside;

});
parcelRegister("l454t", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => $f55de7b55d6b05f3$export$cd599851e879a025);

var $4FC5g = parcelRequire("4FC5g");

var $6E0kV = parcelRequire("6E0kV");
var $f55de7b55d6b05f3$var$guardCount = 0;
var $f55de7b55d6b05f3$var$lockDisabled = false;
var $f55de7b55d6b05f3$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $6E0kV.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($f55de7b55d6b05f3$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($f55de7b55d6b05f3$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $f55de7b55d6b05f3$var$lockDisabled = true;
            setTimeout(function() {
                $f55de7b55d6b05f3$var$lockDisabled = false;
            }, 1);
            return;
        }
        $f55de7b55d6b05f3$var$guardCount++;
        (0, $4FC5g.focusOn)(focusable.node, options.focusOptions);
        $f55de7b55d6b05f3$var$guardCount--;
    }
};

});
parcelRegister("6E0kV", function(module, exports) {
$parcel$export(module.exports, "focusSolver", () => $4d66bd5977dbfc37$export$305758c744b57f6f);

var $dSsLM = parcelRequire("dSsLM");

var $24xvB = parcelRequire("24xvB");

var $4QHHA = parcelRequire("4QHHA");

var $d3kWD = parcelRequire("d3kWD");

var $kFmfz = parcelRequire("kFmfz");

var $fI7MT = parcelRequire("fI7MT");

var $3KPZd = parcelRequire("3KPZd");

var $D37dE = parcelRequire("D37dE");
var $4d66bd5977dbfc37$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $3KPZd.isDefined));
};
var $4d66bd5977dbfc37$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $fI7MT.getActiveElement)((0, $d3kWD.asArray)(topNode).length > 0 ? document : (0, $d3kWD.getFirst)(topNode).ownerDocument);
    var entries = (0, $4QHHA.getAllAffectedNodes)(topNode).filter((0, $3KPZd.isNotAGuard));
    var commonParent = (0, $D37dE.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $24xvB.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $3KPZd.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $24xvB.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $4d66bd5977dbfc37$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $dSsLM.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $dSsLM.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $kFmfz.pickAutofocus)(anyFocusable, innerTabbable, (0, $D37dE.allParentAutofocusables)(entries, visibilityCache)) || (0, $kFmfz.pickAutofocus)(anyFocusable, innerFocusables, (0, $D37dE.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("dSsLM", function(module, exports) {
$parcel$export(module.exports, "NEW_FOCUS", () => $a1a6a293b1f32398$export$85710b12cf912438);
$parcel$export(module.exports, "newFocus", () => $a1a6a293b1f32398$export$65842178e9bb4205);

var $jNkKQ = parcelRequire("jNkKQ");

var $RFASZ = parcelRequire("RFASZ");

var $3KPZd = parcelRequire("3KPZd");
var $a1a6a293b1f32398$export$85710b12cf912438 = 'NEW_FOCUS';
var $a1a6a293b1f32398$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $3KPZd.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $a1a6a293b1f32398$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $a1a6a293b1f32398$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $jNkKQ.correctNodes)(outerNodes);
    var currentFocusableIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var previousFocusableIndex = lastNode ? correctedNodes.indexOf(lastNode) : currentFocusableIndex;
    var tabbableNodes = correctedNodes.filter(function(node) {
        return node.tabIndex >= 0;
    });
    var currentTabbableIndex = activeElement !== undefined ? tabbableNodes.indexOf(activeElement) : -1;
    var previousTabbableIndex = lastNode ? tabbableNodes.indexOf(lastNode) : currentTabbableIndex;
    var focusIndexDiff = currentTabbableIndex >= 0 && previousTabbableIndex >= 0 ? previousTabbableIndex - currentTabbableIndex : previousFocusableIndex - currentFocusableIndex;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $RFASZ.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $RFASZ.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(focusIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("jNkKQ", function(module, exports) {
$parcel$export(module.exports, "correctNode", () => $e692b15adeeece81$export$5261662167ad7ced);
$parcel$export(module.exports, "correctNodes", () => $e692b15adeeece81$export$4a5a72a7124e45f9);

var $3KPZd = parcelRequire("3KPZd");
var $e692b15adeeece81$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $3KPZd.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $e692b15adeeece81$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $3KPZd.isRadioElement)(node) && node.name) return $e692b15adeeece81$var$findSelectedRadio(node, nodes);
    return node;
};
var $e692b15adeeece81$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($e692b15adeeece81$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("RFASZ", function(module, exports) {
$parcel$export(module.exports, "pickFirstFocus", () => $0a15370a6a924074$export$f4e86cfa0679b9cc);
$parcel$export(module.exports, "pickFocusable", () => $0a15370a6a924074$export$e06728ee87c96122);

var $jNkKQ = parcelRequire("jNkKQ");
var $0a15370a6a924074$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $jNkKQ.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $0a15370a6a924074$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $jNkKQ.correctNode)(node, nodes));
};

});


parcelRegister("kFmfz", function(module, exports) {
$parcel$export(module.exports, "pickAutofocus", () => $f0b8e56b7f3735f2$export$cfb742983e257555);

var $24xvB = parcelRequire("24xvB");

var $RFASZ = parcelRequire("RFASZ");

var $3KPZd = parcelRequire("3KPZd");
var $f0b8e56b7f3735f2$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $3KPZd.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $f0b8e56b7f3735f2$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $24xvB.filterAutoFocusable)(nodes.filter($f0b8e56b7f3735f2$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $RFASZ.pickFirstFocus)(autoFocusable);
    return (0, $RFASZ.pickFirstFocus)((0, $24xvB.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("aqTpV", function(module, exports) {
$parcel$export(module.exports, "deferAction", () => $798751c431302401$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $798751c431302401$export$c613fed06e332533);
function $798751c431302401$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $798751c431302401$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $798751c431302401$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("6pgJk", function(module, exports) {
$parcel$export(module.exports, "default", () => $bcb2eb3ac15674da$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $j9QYE = parcelRequire("j9QYE");

var $aD9yk = parcelRequire("aD9yk");

var $kIqwl = parcelRequire("kIqwl");
const $bcb2eb3ac15674da$var$_8 = "._bfhk1j28{background-color:transparent}";
const $bcb2eb3ac15674da$var$_7 = "._lcxvglyw{pointer-events:none}";
const $bcb2eb3ac15674da$var$_6 = "._lcxv1wug{pointer-events:auto}";
const $bcb2eb3ac15674da$var$_5 = "._18m91wug{overflow-y:auto}";
const $bcb2eb3ac15674da$var$_4 = "._bfhk1i5c{background-color:var(--ds-blanket,#050c1f75)}";
const $bcb2eb3ac15674da$var$_3 = "._1pbybfng{z-index:500}";
const $bcb2eb3ac15674da$var$_2 = "._kqsw1n9t{position:fixed}";
const $bcb2eb3ac15674da$var$_ = "._1r04idpf{inset:0}";
const $bcb2eb3ac15674da$var$packageName = undefined;
const $bcb2eb3ac15674da$var$packageVersion = undefined;
const $bcb2eb3ac15674da$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $bcb2eb3ac15674da$var$packageName,
    packageVersion: $bcb2eb3ac15674da$var$packageVersion
};
const $bcb2eb3ac15674da$var$baseStyles = null;
const $bcb2eb3ac15674da$var$shouldAllowClickThroughStyles = null;
const $bcb2eb3ac15674da$var$invisibleStyles = null; /**
                               * __Blanket__
                               *
                               * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
                               *
                               * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
                               */ 
const $bcb2eb3ac15674da$var$Blanket = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)(function Blanket({ shouldAllowClickThrough: shouldAllowClickThrough = false, isTinted: isTinted = false, onBlanketClicked: onBlanketClicked = (0, $aD9yk.default), testId: testId, children: children, analyticsContext: analyticsContext }, ref) {
    const mouseDownTarget = (0, $1v5pe.useRef)(null);
    const onBlanketClickedWithAnalytics = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$bcb2eb3ac15674da$var$analyticsAttributes
    });
    const blanketClickOutsideChildren = (0, $1v5pe.useCallback)((e)=>e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined, [
        onBlanketClickedWithAnalytics
    ]);
    const onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    const onMouseDown = (0, $1v5pe.useCallback)((e)=>{
        mouseDownTarget.current = e.target;
    }, []);
    return(/*#__PURE__*/ /**
     * It is not normally acceptable to add click and key handlers to non-interactive
     * elements as this is an accessibility anti-pattern. However, because this
     * instance is to enable light dismiss functionality instead of creating an
     * inaccessible custom element, we can add role="presentation" so that there
     * are no negative impacts to assistive technologies.
     */ // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $bcb2eb3ac15674da$var$_,
                    $bcb2eb3ac15674da$var$_2,
                    $bcb2eb3ac15674da$var$_3,
                    $bcb2eb3ac15674da$var$_4,
                    $bcb2eb3ac15674da$var$_5,
                    $bcb2eb3ac15674da$var$_6,
                    $bcb2eb3ac15674da$var$_7,
                    $bcb2eb3ac15674da$var$_8
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                role: "presentation",
                onClick: onClick,
                onMouseDown: onMouseDown,
                "data-testid": testId,
                ref: ref,
                className: (0, $hMvDh.default)([
                    "_1r04idpf _kqsw1n9t _1pbybfng _bfhk1i5c _18m91wug _lcxv1wug",
                    shouldAllowClickThrough && "_lcxvglyw",
                    !isTinted && "_bfhk1j28"
                ]),
                children: children
            })
        ]
    }));
}));
$bcb2eb3ac15674da$var$Blanket.displayName = 'Blanket';
var $bcb2eb3ac15674da$export$2e2bcd8739ae039 = $bcb2eb3ac15674da$var$Blanket;

});

parcelRegister("azfBr", function(module, exports) {
$parcel$export(module.exports, "Layering", () => $c0b5b1a4986107d0$export$7c885f891c940977);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1v5pe = parcelRequire("1v5pe");

var $9maLu = parcelRequire("9maLu");

var $k2kmX = parcelRequire("k2kmX");

var $99aSv = parcelRequire("99aSv");

var $8P9x3 = parcelRequire("8P9x3");

var $kIqwl = parcelRequire("kIqwl");
const $c0b5b1a4986107d0$var$LevelProvider = ({ children: children, currentLevel: currentLevel, node: levelNode })=>{
    (0, $1v5pe.useEffect)(()=>{
        const levelNodeSafe = levelNode.current;
        const parentNode = levelNodeSafe.parent;
        parentNode?.addChild(levelNodeSafe);
        return ()=>{
            parentNode?.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $k2kmX.LevelContext).Provider, {
        value: currentLevel,
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $99aSv.LevelNodeContext).Provider, {
            value: levelNode,
            children: children
        })
    });
};
const $c0b5b1a4986107d0$export$7c885f891c940977 = ({ children: children, isDisabled: isDisabled = true })=>{
    const currentLevel = (0, $1v5pe.useContext)((0, $k2kmX.LevelContext));
    const parentNode = (0, $1v5pe.useContext)((0, $99aSv.LevelNodeContext));
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    const newNode = (0, $1v5pe.useRef)(new (0, $9maLu.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kIqwl.Fragment), {
        children: children
    });
    const isNested = currentLevel > 0;
    const content = /*#__PURE__*/ (0, $kIqwl.jsx)($c0b5b1a4986107d0$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode,
        children: children
    });
    return isNested ? content : /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8P9x3.RootNodeContext).Provider, {
        value: newNode,
        children: content
    });
};

});
parcelRegister("9maLu", function(module, exports) {
$parcel$export(module.exports, "LayerNode", () => $e4d0bf89f1bde193$export$da4f61fd78d35243);
class $e4d0bf89f1bde193$export$da4f61fd78d35243 {
    id;
    childNodes;
    parent;
    constructor(id, parent){
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    addChild(node) {
        this.childNodes.push(node);
    }
    removeChild(node) {
        this.childNodes = this.childNodes.filter((child)=>child.id !== node.id);
    }
    getLevel() {
        if (!this.parent) return 1;
        return this.parent.getLevel() + 1;
    }
    getHeight() {
        if (this.childNodes.length === 0) return 1;
        return Math.max(...this.childNodes.map((child)=>child.getHeight())) + 1;
    }
}

});

parcelRegister("k2kmX", function(module, exports) {
$parcel$export(module.exports, "LevelContext", () => $662c57911a610eec$export$650d12d3c2ddb8fc);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1v5pe = parcelRequire("1v5pe");
const $662c57911a610eec$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $1v5pe.createContext)(0);

});

parcelRegister("99aSv", function(module, exports) {
$parcel$export(module.exports, "LevelNodeContext", () => $cc90f0ff860f176e$export$18f4d8b5b3a77f59);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1v5pe = parcelRequire("1v5pe");
const $cc90f0ff860f176e$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $1v5pe.createContext)({
    current: null
});

});

parcelRegister("8P9x3", function(module, exports) {
$parcel$export(module.exports, "RootNodeContext", () => $0f91cf76ff64c0b5$export$fa973f110e8f6ca8);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1v5pe = parcelRequire("1v5pe");
const $0f91cf76ff64c0b5$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $1v5pe.createContext)({
    current: null
});

});


parcelRegister("jySDc", function(module, exports) {
$parcel$export(module.exports, "combine", () => $ebaa074bf4f3e2a3$export$1be1fc439b849fdf);
function $ebaa074bf4f3e2a3$export$1be1fc439b849fdf(...fns) {
    return function cleanup() {
        fns.forEach((fn)=>fn());
    };
}

});

parcelRegister("h4l9f", function(module, exports) {
$parcel$export(module.exports, "createCloseEvent", () => $fa408d8f8cf4721c$export$330cd73b9da5838b);
function $fa408d8f8cf4721c$export$330cd73b9da5838b({ reason: reason }) {
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        code: 'Escape',
        bubbles: true
    });
    return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
}

});

parcelRegister("gUI7t", function(module, exports) {
$parcel$export(module.exports, "Dialog", () => $8fe22e09ea762de2$export$3ddf2d174ce01153);
/* dialog-content.tsx generated by @compiled/babel-plugin v3.0.2 */ /* dialog-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $1v5pe = parcelRequire("1v5pe");

var $fBuCt = parcelRequire("fBuCt");

var $hGIzV = parcelRequire("hGIzV");

var $dmmsG = parcelRequire("dmmsG");

var $fl4ll = parcelRequire("fl4ll");

var $3q5kf = parcelRequire("3q5kf");

var $gHI9p = parcelRequire("gHI9p");

var $eaSsy = parcelRequire("eaSsy");

var $bLaOP = parcelRequire("bLaOP");

var $gYTpG = parcelRequire("gYTpG");

var $bmVqm = parcelRequire("bmVqm");

var $e902l = parcelRequire("e902l");

var $kIqwl = parcelRequire("kIqwl");
const $8fe22e09ea762de2$var$_41 = "._1m5e1op4::backdrop{animation:var(--ds-blanket-exit,.2s cubic-bezier(.6,0,.8,.6) FadeOut100to0)}";
const $8fe22e09ea762de2$var$_40 = "._1m5exbuz::backdrop{animation:var(--ds-blanket-enter,.25s cubic-bezier(.4,0,0,1) FadeIn0to100)}";
const $8fe22e09ea762de2$var$_39 = "._1ltk1j28::backdrop{background-color:transparent}";
const $8fe22e09ea762de2$var$_38 = "._1ltk1i5c::backdrop{background-color:var(--ds-blanket,#050c1f75)}";
const $8fe22e09ea762de2$var$_37 = "._9kefi7uo:defined:defined:defined{color:var(--ds-text,#292a2e)}";
const $8fe22e09ea762de2$var$_36 = "._1b80glyw:defined:defined:defined{text-transform:none}";
const $8fe22e09ea762de2$var$_35 = "._m466idpf:defined:defined:defined{text-indent:0}";
const $8fe22e09ea762de2$var$_34 = "._tcxkv2br:defined:defined:defined{text-align:start}";
const $8fe22e09ea762de2$var$_33 = "._1f6b4jg8:defined:defined:defined{overflow-wrap:normal}";
const $8fe22e09ea762de2$var$_32 = "._19w84jg8:defined:defined:defined{word-break:normal}";
const $8fe22e09ea762de2$var$_31 = "._ux9u4jg8:defined:defined:defined{white-space:normal}";
const $8fe22e09ea762de2$var$_30 = "._goh41wug:defined:defined:defined{pointer-events:auto}";
const $8fe22e09ea762de2$var$_29 = "._y44vgeqi{animation:var(--ds-modal-exit,.2s cubic-bezier(.6,0,.8,.6) ScaleOut100to95)}";
const $8fe22e09ea762de2$var$_28 = "._y44v7kvq{animation:var(--ds-modal-enter,.25s cubic-bezier(.4,0,0,1) ScaleIn95to100)}";
const $8fe22e09ea762de2$var$_27 = "@media (prefers-reduced-motion:reduce){._bl8aglyw{animation-name:none}._156y147i{transition-duration:var(--ds-duration-instant,0ms)}}";
const $8fe22e09ea762de2$var$_26 = "._1o511hrf{animation-fill-mode:both}";
const $8fe22e09ea762de2$var$_25 = "._1s9z1a5r{transition-behavior:allow-discrete}";
const $8fe22e09ea762de2$var$_24 = "._1oeci9qs{transition-duration:var(--ds-duration-medium,.2s)}";
const $8fe22e09ea762de2$var$_23 = "._k8m011k7{transition-property:overlay,display}";
const $8fe22e09ea762de2$var$_22 = "._722r1ule[open][open][open]{display:block}";
const $8fe22e09ea762de2$var$_21 = "._1rec1j28:defined:defined:defined{background-color:transparent}";
const $8fe22e09ea762de2$var$_20 = "._6hkqidpf:defined:defined:defined{inset-block-end:0}";
const $8fe22e09ea762de2$var$_19 = "._1dqv1n9t:defined:defined:defined{position:fixed}";
const $8fe22e09ea762de2$var$_18 = "._1715kb7n:defined:defined:defined{opacity:1}";
const $8fe22e09ea762de2$var$_17 = "._1s8uglyw:defined:defined:defined{rotate:none}";
const $8fe22e09ea762de2$var$_16 = "._tdqwglyw:defined:defined:defined{scale:none}";
const $8fe22e09ea762de2$var$_15 = "._x2wjglyw:defined:defined:defined{translate:none}";
const $8fe22e09ea762de2$var$_14 = "._1f2zglyw:defined:defined:defined{transform:none}";
const $8fe22e09ea762de2$var$_13 = "._jg1o4jg8:defined:defined:defined{justify-self:normal}";
const $8fe22e09ea762de2$var$_12 = "._1ljj4jg8:defined:defined:defined{align-self:normal}";
const $8fe22e09ea762de2$var$_11 = "._ao8dglyw:defined:defined:defined{max-height:none}";
const $8fe22e09ea762de2$var$_10 = "._1gd81wug:defined:defined:defined{min-height:auto}";
const $8fe22e09ea762de2$var$_1 = "._1yd01wug:defined:defined:defined{min-width:auto}";
const $8fe22e09ea762de2$var$_0 = "._v12pze3t:defined:defined:defined{padding-inline-start:var(--ds-space-0,0)}";
const $8fe22e09ea762de2$var$_9 = "._dbnbze3t:defined:defined:defined{padding-block-end:var(--ds-space-0,0)}";
const $8fe22e09ea762de2$var$_8 = "._lizuze3t:defined:defined:defined{padding-inline-end:var(--ds-space-0,0)}";
const $8fe22e09ea762de2$var$_7 = "._mkdmze3t:defined:defined:defined{padding-block-start:var(--ds-space-0,0)}";
const $8fe22e09ea762de2$var$_6 = "._lzhqglyw:defined:defined:defined{border:none}";
const $8fe22e09ea762de2$var$_5 = "._p12fglyw{max-width:none}";
const $8fe22e09ea762de2$var$_4 = "._18u01wug{margin-left:auto}";
const $8fe22e09ea762de2$var$_3 = "._otyr1wug{margin-bottom:auto}";
const $8fe22e09ea762de2$var$_2 = "._2hwx1wug{margin-right:auto}";
const $8fe22e09ea762de2$var$_ = "._19pk1wug{margin-top:auto}";
const $8fe22e09ea762de2$var$surfaceResetStyles = {
    root: "_goh41wug _ux9u4jg8 _19w84jg8 _1f6b4jg8 _tcxkv2br _m466idpf _1b80glyw _9kefi7uo"
};
const $8fe22e09ea762de2$var$dialogStyles = {
    root: "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12fglyw _lzhqglyw _mkdmze3t _lizuze3t _dbnbze3t _v12pze3t _1yd01wug _1gd81wug _ao8dglyw _1ljj4jg8 _jg1o4jg8 _1f2zglyw _x2wjglyw _tdqwglyw _1s8uglyw _1715kb7n _1dqv1n9t _6hkqidpf _1rec1j28 _722r1ule",
    motion: "_k8m011k7 _1oeci9qs _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v7kvq",
    exit: "_y44vgeqi"
};
const $8fe22e09ea762de2$var$backdropStyles = {
    root: "_1ltk1i5c",
    hidden: "_1ltk1j28",
    enter: "_1m5exbuz",
    exit: "_1m5e1op4"
};
function $8fe22e09ea762de2$var$isEscapeAllowed({ dismissedBy: dismissedBy }) {
    return dismissedBy === 'escape' || dismissedBy === 'escape-and-outside-click';
}
function $8fe22e09ea762de2$var$isBackdropClickAllowed({ dismissedBy: dismissedBy }) {
    return dismissedBy === 'escape-and-outside-click';
} // Whether every `<dialog>` and `[popover]` that contains the node is open. Crosses shadow roots.
function $8fe22e09ea762de2$var$isEveryAncestorLayerOpen({ node: node }) {
    const parent = node.parentNode instanceof ShadowRoot ? node.parentNode.host : node.parentElement;
    if (!parent) return true;
    if (parent instanceof HTMLElement && (parent instanceof HTMLDialogElement || parent.hasAttribute('popover')) && !(0, $gHI9p.isNativeElementOpen)({
        element: parent
    })) return false;
    return $8fe22e09ea762de2$var$isEveryAncestorLayerOpen({
        node: parent
    });
} /**
   * Safety net for a close that `Dialog` did not ask about (for example `dialog.close()` or a
   * `<form method="dialog">` submit). Consumers should not close the native dialog. `isOpen` is the
   * source of truth, so show the dialog again.
   *
   * Skipped inside a closed layer: an open modal there is invisible but still makes the page inert.
   *
   * Returns `true` when this call showed the dialog again.
   */ 
function $8fe22e09ea762de2$var$reopenAfterUnaskedClose({ dialog: dialog }) {
    if (dialog.open || !$8fe22e09ea762de2$var$isEveryAncestorLayerOpen({
        node: dialog
    })) return false;
    try {
        dialog.showModal();
    } catch  {
        return false;
    }
    return dialog.open;
} /**
   * Low-level `<dialog>` primitive. It has no visual opinions: no width, height, background,
   * border-radius or layout. Consumers provide their own styling.
   *
   * `isOpen` controls visibility. When the user asks to dismiss the dialog (an allowed Escape or
   * backdrop click), `onClose` runs. Set `isOpen={false}` to close it, or keep `isOpen` `true` to
   * keep it open, in every browser.
   *
   * **How closing works**
   *
   * - Standard path: the `<dialog>` has `closedby="none"`, so the browser never closes it for a
   *   user action. `Dialog` listens for Escape (`useEscapeKeydown`) and backdrop clicks
   *   (`useBackdropClick`) itself, and asks through `onClose`. Other close requests (for example
   *   Android back) go past the dialog.
   * - Fallback: browsers without `closedby` (Safari 27 and earlier) still send `cancel` for close
   *   requests. `useCancelFallback` refuses them. It binds only in those browsers.
   * - Do not close the native dialog directly (`dialog.close()`, `<form method="dialog">`). If it
   *   closes while `isOpen` is `true`, `Dialog` shows it again and does not call `onClose`.
   *
   * See `notes/decisions/dialog-close-flow.md`.
   *
   * **Accessibility**
   *
   * Render at least one focusable element (typically a close button) when `isOpen` becomes `true`.
   * `Dialog` always traps Tab inside the dialog, so keyboard users need somewhere to land.
   */ 
const $8fe22e09ea762de2$export$3ddf2d174ce01153 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(function Dialog({ children: children, isOpen: isOpen, onClose: onClose, dismissedBy: dismissedBy = 'escape-and-outside-click', onEnterFinish: onEnterFinish, onExitFinish: onExitFinish, shouldAnimate: shouldAnimate = false, xcss: consumerXcss, enteringAnimationXcss: enteringAnimationXcss, exitingAnimationXcss: exitingAnimationXcss, style: style, testId: testId, id: providedId, label: label, labelledBy: labelledBy, shouldHideBackdrop: shouldHideBackdrop }, ref) {
    const generatedId = (0, $1v5pe.useId)();
    const dialogId = providedId ?? generatedId;
    const ownRef = (0, $1v5pe.useRef)(null);
    const combinedRef = (0, $fl4ll.default)([
        ownRef,
        ref
    ]);
    const dismissedByRef = (0, $1v5pe.useRef)(dismissedBy);
    const onCloseRef = (0, $1v5pe.useRef)(onClose);
    const isOpenRef = (0, $1v5pe.useRef)(isOpen); // Keep native event handlers stable while ensuring they read the latest committed props.
    (0, $3q5kf.useLayoutEffect)(()=>{
        dismissedByRef.current = dismissedBy;
        onCloseRef.current = onClose;
        isOpenRef.current = isOpen;
    }, [
        dismissedBy,
        onClose,
        isOpen
    ]);
    const { phase: phase, isMounted: isMounted, onBeforeToggle: onBeforeToggle, onToggle: onToggle } = (0, $eaSsy.useAnimatedVisibility)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }); // Bind the lifecycle listeners before the `isOpen` effect below calls `showModal()` or
    // `close()`: `beforetoggle` fires synchronously during those calls.
    (0, $3q5kf.useLayoutEffect)(()=>{
        if (!isMounted) return;
        const dialog = ownRef.current;
        if (!dialog) return;
        return (0, $dmmsG.bindAll)(dialog, [
            {
                type: 'beforetoggle',
                listener: onBeforeToggle
            },
            {
                type: 'toggle',
                listener (event) {
                    // The consumer unmounted the dialog in `onClose`. Do not schedule
                    // `onExitFinish` after unmount.
                    if (!dialog.isConnected) return;
                     // Safety net: something closed the native dialog while `isOpen` is `true`, so
                    // show it again. Runs before `onToggle`, so the exit never settles.
                    if (event.newState === 'closed' && isOpenRef.current && $8fe22e09ea762de2$var$reopenAfterUnaskedClose({
                        dialog: dialog
                    })) return;
                    onToggle(event);
                }
            }
        ]);
    }, [
        isMounted,
        onBeforeToggle,
        onToggle
    ]); // Native `<dialog>.showModal()` traps focus but wraps through `<body>` at the boundary
    // (A → B → C → body → A). `useFocusWrap` handles Tab and wraps directly (A → B → C → A), as in
    // the WAI-ARIA APG pattern. `phase` keeps the listener during the exit animation (WCAG 2.4.3 Focus
    // Order regression guard).
    (0, $bLaOP.useFocusWrap)({
        elementRef: ownRef,
        role: 'dialog',
        phase: phase
    }); // Show or close the native dialog to match `isOpen`.
    (0, $3q5kf.useLayoutEffect)(()=>{
        const dialog = ownRef.current;
        if (!dialog) return;
        if (isOpen) {
            if (!dialog.open) dialog.showModal();
            return ()=>{
                if (dialog.open) dialog.close();
            };
        }
        if (dialog.open) dialog.close();
    }, [
        isOpen
    ]); // Standard path: Escape.
    const handleEscape = (0, $1v5pe.useCallback)(()=>{
        if (!$8fe22e09ea762de2$var$isEscapeAllowed({
            dismissedBy: dismissedByRef.current
        })) return;
         // Commit the consumer's `isOpen` answer before the keydown ends.
        (0, $fBuCt.flushSync)(()=>{
            onCloseRef.current({
                reason: 'escape'
            });
        });
    }, []);
    (0, $e902l.useEscapeKeydown)({
        dialogRef: ownRef,
        isMounted: isMounted,
        onEscape: handleEscape
    }); // Standard path: backdrop click.
    const handleBackdropClick = (0, $1v5pe.useCallback)(()=>{
        if (!$8fe22e09ea762de2$var$isBackdropClickAllowed({
            dismissedBy: dismissedByRef.current
        })) return;
         // Commit the consumer's `isOpen` answer before the click ends.
        (0, $fBuCt.flushSync)(()=>{
            onCloseRef.current({
                reason: 'overlay-click'
            });
        });
    }, []);
    (0, $gYTpG.useBackdropClick)({
        dialogRef: ownRef,
        isMounted: isMounted,
        onBackdropClick: handleBackdropClick
    }); // Fallback: only in browsers without `closedby`.
    (0, $bmVqm.useCancelFallback)({
        dialogRef: ownRef,
        isMounted: isMounted
    }); // After the exit, render nothing, so no empty `role="dialog"` element stays in the accessibility
    // tree. The next open mounts a new `<dialog>`, and the effects above run again for it.
    if (!isMounted) return null;
    const shouldAnimateBackdrop = !shouldHideBackdrop && shouldAnimate;
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $8fe22e09ea762de2$var$_,
                    $8fe22e09ea762de2$var$_2,
                    $8fe22e09ea762de2$var$_3,
                    $8fe22e09ea762de2$var$_4,
                    $8fe22e09ea762de2$var$_5,
                    $8fe22e09ea762de2$var$_6,
                    $8fe22e09ea762de2$var$_7,
                    $8fe22e09ea762de2$var$_8,
                    $8fe22e09ea762de2$var$_9,
                    $8fe22e09ea762de2$var$_0,
                    $8fe22e09ea762de2$var$_1,
                    $8fe22e09ea762de2$var$_10,
                    $8fe22e09ea762de2$var$_11,
                    $8fe22e09ea762de2$var$_12,
                    $8fe22e09ea762de2$var$_13,
                    $8fe22e09ea762de2$var$_14,
                    $8fe22e09ea762de2$var$_15,
                    $8fe22e09ea762de2$var$_16,
                    $8fe22e09ea762de2$var$_17,
                    $8fe22e09ea762de2$var$_18,
                    $8fe22e09ea762de2$var$_19,
                    $8fe22e09ea762de2$var$_20,
                    $8fe22e09ea762de2$var$_21,
                    $8fe22e09ea762de2$var$_22,
                    $8fe22e09ea762de2$var$_23,
                    $8fe22e09ea762de2$var$_24,
                    $8fe22e09ea762de2$var$_25,
                    $8fe22e09ea762de2$var$_26,
                    $8fe22e09ea762de2$var$_27,
                    $8fe22e09ea762de2$var$_28,
                    $8fe22e09ea762de2$var$_29,
                    $8fe22e09ea762de2$var$_30,
                    $8fe22e09ea762de2$var$_31,
                    $8fe22e09ea762de2$var$_32,
                    $8fe22e09ea762de2$var$_33,
                    $8fe22e09ea762de2$var$_34,
                    $8fe22e09ea762de2$var$_35,
                    $8fe22e09ea762de2$var$_36,
                    $8fe22e09ea762de2$var$_37,
                    $8fe22e09ea762de2$var$_38,
                    $8fe22e09ea762de2$var$_39,
                    $8fe22e09ea762de2$var$_40,
                    $8fe22e09ea762de2$var$_41
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("dialog", {
                ref: combinedRef,
                id: dialogId // No `aria-modal`: `showModal()` already tells assistive technology that the dialog is
                ,
                "aria-label": label,
                "aria-labelledby": label ? undefined : labelledBy,
                style: style // The browser never closes the dialog for a user action. `Dialog` handles Escape and
                ,
                closedby: "none",
                "data-testid": testId // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
                ,
                className: (0, $hMvDh.default)([
                    // Dialog styles
                    $8fe22e09ea762de2$var$dialogStyles.root,
                    $8fe22e09ea762de2$var$surfaceResetStyles.root,
                    shouldAnimate && phase === 'entering' && $8fe22e09ea762de2$var$dialogStyles.enter,
                    shouldAnimate && phase === 'exiting' && $8fe22e09ea762de2$var$dialogStyles.exit,
                    shouldAnimate && $8fe22e09ea762de2$var$dialogStyles.motion,
                    shouldHideBackdrop ? $8fe22e09ea762de2$var$backdropStyles.hidden : $8fe22e09ea762de2$var$backdropStyles.root,
                    shouldAnimateBackdrop && phase === 'entering' && $8fe22e09ea762de2$var$backdropStyles.enter,
                    shouldAnimateBackdrop && phase === 'exiting' && $8fe22e09ea762de2$var$backdropStyles.exit,
                    (0, $hGIzV.cx)(consumerXcss, shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
                ]),
                children: children
            })
        ]
    });
});

});
parcelRegister("gYTpG", function(module, exports) {
$parcel$export(module.exports, "useBackdropClick", () => $1c2411710b354992$export$a18054e824c0afa5);

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");
function $1c2411710b354992$export$a18054e824c0afa5({ dialogRef: dialogRef, isMounted: isMounted, onBackdropClick: onBackdropClick }) {
    (0, $1v5pe.useEffect)(()=>{
        const dialog = dialogRef.current;
        if (!isMounted || !dialog) return;
        /**
     * Matches native dialog light dismiss: the `pointerdown` and `pointerup` targets must match.
     * A `click` alone is not enough, as it fires on the common ancestor of both targets.
     * https://html.spec.whatwg.org/multipage/interactive-elements.html#dialog-light-dismiss
     */ let isBackdropPress = false;
        return (0, $dmmsG.bindAll)(dialog, [
            {
                type: 'pointerdown',
                listener (event) {
                    // Primary button only. `!button`: jsdom has no `PointerEvent`, so `button` is undefined.
                    isBackdropPress = event.target === dialog && !event.button;
                }
            },
            {
                type: 'pointerup',
                listener (event) {
                    isBackdropPress = isBackdropPress && event.target === dialog;
                }
            },
            {
                type: 'pointercancel',
                listener () {
                    isBackdropPress = false;
                }
            },
            {
                type: 'click',
                listener (event) {
                    // Each press is used once.
                    const wasBackdropPress = isBackdropPress;
                    isBackdropPress = false;
                    if (!wasBackdropPress || event.target !== dialog || !dialog.open) return;
                    onBackdropClick();
                }
            }
        ]);
    }, [
        dialogRef,
        isMounted,
        onBackdropClick
    ]);
}

});

parcelRegister("bmVqm", function(module, exports) {
$parcel$export(module.exports, "useCancelFallback", () => $a033cc9cf56686ab$export$91a60beba8b292ad);

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");
/**
 * Whether the browser supports the `closedby` attribute on `<dialog>`.
 *
 * Read on the client only (in an effect), so it never changes the server markup.
 */ function $a033cc9cf56686ab$var$isClosedBySupported() {
    // eslint-disable-next-line compat/compat -- every browser in the browser policy has `<dialog>`
    return 'closedBy' in HTMLDialogElement.prototype;
}
function $a033cc9cf56686ab$export$91a60beba8b292ad({ dialogRef: dialogRef, isMounted: isMounted }) {
    (0, $1v5pe.useEffect)(()=>{
        const dialog = dialogRef.current;
        if (!isMounted || !dialog || $a033cc9cf56686ab$var$isClosedBySupported()) return;
        // Native `cancel` does not bubble, so a nested dialog's `cancel` does not reach this listener.
        return (0, $dmmsG.bind)(dialog, {
            type: 'cancel',
            listener (event) {
                event.preventDefault();
            }
        });
    }, [
        dialogRef,
        isMounted
    ]);
}

});

parcelRegister("e902l", function(module, exports) {
$parcel$export(module.exports, "useEscapeKeydown", () => $121844ee3344d93a$export$3a72a57244d6e765);

var $dmmsG = parcelRequire("dmmsG");

var $3q5kf = parcelRequire("3q5kf");

var $2uH9r = parcelRequire("2uH9r");

var $5CxPC = parcelRequire("5CxPC");

var $7LgTX = parcelRequire("7LgTX");

var $8khPQ = parcelRequire("8khPQ");

var $3UIKp = parcelRequire("3UIKp");

var $2l0Ma = parcelRequire("2l0Ma");

var $8TRgn = parcelRequire("8TRgn");
function $121844ee3344d93a$export$3a72a57244d6e765({ dialogRef: dialogRef, isMounted: isMounted, onEscape: onEscape }) {
    (0, $2l0Ma.useStartOpenOrderTracking)();
    // A layout effect, so the dialog is marked and listening as soon as it opens, even from a timer
    // outside a React event.
    (0, $3q5kf.useLayoutEffect)(()=>{
        const dialog = dialogRef.current;
        if (!isMounted || !dialog) return;
        let shouldOwnEscapeRequest = false;
        return (0, $2uH9r.combine)(// `closedby="none"` hides the dialog from other layers' checks. Mark it.
        (0, $8TRgn.setAttribute)({
            element: dialog,
            name: (0, $3UIKp.manualEscapeLayerAttribute),
            value: ''
        }), // Target and phase matter. See the listener order in `claim-escape`.
        (0, $dmmsG.bindAll)(window, [
            {
                // Capture: decide while every layer is still open. An inner layer may close on this
                // keydown before the bubble listener runs.
                type: 'keydown',
                listener (event) {
                    if (event.key === 'Escape') shouldOwnEscapeRequest = dialog.open && !(0, $7LgTX.hasEscapeOwnerAbove)({
                        element: dialog,
                        isLayer: true
                    });
                },
                options: {
                    capture: true
                }
            },
            {
                // Bubble: inner handlers run first.
                type: 'keydown',
                listener (event) {
                    // `defaultPrevented`: an inner handler took this Escape, so one press undoes one thing (as
                    // with a native `<dialog>`). Legacy ModalDialog closes anyway; the flag changes that.
                    if (!(0, $8khPQ.isEscapeToHandle)({
                        event: event
                    }) || !shouldOwnEscapeRequest || !dialog.open) return;
                    // `claimEscape()` stops the browser's close request. It would skip this `closedby="none"`
                    // dialog and close the next close watcher (for example a parent `auto` popover), or fire
                    // `cancel` without `closedby` support. A held key asks once.
                    if (!(0, $5CxPC.claimEscape)({
                        event: event
                    })) return;
                    onEscape();
                }
            }
        ]));
    }, [
        dialogRef,
        isMounted,
        onEscape
    ]);
}

});
parcelRegister("5CxPC", function(module, exports) {
$parcel$export(module.exports, "claimEscape", () => $f31bb11df277f702$export$7bfc69962e56136);
/**
 * **Listener order**
 *
 * One Escape `keydown` reaches the listeners in this order:
 *
 * 1. `Dialog`, `window` capture: decides if the Escape is its own while every layer is still open.
 * 2. `useCloseOnUnclaimedEscape` with a `targetRef`: on that element, so only while focus is in it.
 * 3. React handlers, on the React root (bubble).
 * 4. `useManualLightDismiss` and `useCloseOnUnclaimedEscape` without a `targetRef`: on `document`
 *    (bubble), in bind order. React binds child effects first.
 * 5. `Dialog`, `window` bubble: closes the dialog.
 * 6. The browser, unless a listener called `preventDefault()`: closes the topmost close watcher (an
 *    open `auto` or `hint` popover, or a `<dialog>` that closes on Escape). A `Dialog` has
 *    `closedby="none"`, so it is skipped.
 *
 * The open layers decide which layer takes Escape, not focus. But the `keydown` starts at the
 * focused element, so a handler on its path can take the Escape first, and step 2 hears it only
 * while focus is inside its element.
 *
 * Rules:
 *
 * - A listener that takes an Escape calls `claimEscape()`, and every listener checks
 *   `isEscapeToHandle()` first. So later listeners and the browser leave their layers open.
 * - An owner claims the Escape even when it declines to close.
 * - `defaultPrevented` only shows earlier listeners. A listener that runs before a layer above it
 *   must find that layer itself, with `hasEscapeOwnerAbove`:
 *   - `Dialog` asks in step 1, because the browser (step 6) closes `auto` and `hint` popovers.
 *   - A page surface on an element (step 2) runs before `manual` popovers (step 4), so it counts
 *     them too.
 *   - `document` listeners (step 4) run in bind order, not open order, so `manual` popovers and
 *     page surfaces there also ask.
 * - `hasEscapeOwnerAbove` orders owners: the later open is above, but a descendant is always above
 *   its ancestors. A marked page surface ranks just above its nearest containing layer.
 * - `stopPropagation()` before `document` (for example in a React handler) skips steps 4 and 5, not
 *   step 6: the browser closes the topmost `auto` or `hint` popover, and a `Dialog` stays open.
 *
 * Check these rules before moving a listener to another target or phase. For example, a `Dialog`
 * listener on `document` could run before a `manual` popover inside it, and close the dialog
 * instead of the popover.
 */ /**
 * Takes this Escape for a layer. `preventDefault()` stops ancestor layers and the browser from also
 * closing, so one press acts on one layer, as with a native close watcher. This is true even when
 * the layer stays open.
 *
 * Returns `true` when the layer should ask to close. Returns `false` for a held-key repeat: the
 * layer still takes the Escape, but asks to close once per key press.
 */ function $f31bb11df277f702$export$7bfc69962e56136({ event: event }) {
    event.preventDefault();
    return !event.repeat;
}

});

parcelRegister("7LgTX", function(module, exports) {
$parcel$export(module.exports, "hasEscapeOwnerAbove", () => $9c03526f0da88a9b$export$34d7e67eba469e06);

var $8hpNz = parcelRequire("8hpNz");

var $6SmSh = parcelRequire("6SmSh");

var $7VH8u = parcelRequire("7VH8u");

var $86jEU = parcelRequire("86jEU");
/**
 * The stack position of an Escape owner. Higher is above.
 *
 * - A layer ranks by its open order. No open order means it opened before tracking started, so it
 *   ranks `0`, below every later layer.
 * - A page surface is not in the top layer, so it has no open order. It ranks just above its
 *   nearest containing layer, and below every layer that opened after that one. Outside every
 *   layer, it ranks below every layer.
 */ function $9c03526f0da88a9b$var$getRank({ element: element, layers: layers, isLayer: isLayer }) {
    if (isLayer) return (0, $7VH8u.openOrderTracker).getOpenOrder({
        element: element
    }) ?? 0;
    const containingLayer = (0, $8hpNz.getNearestContainingLayer)({
        element: element,
        layers: layers
    });
    if (!containingLayer) return Number.NEGATIVE_INFINITY;
    return ((0, $7VH8u.openOrderTracker).getOpenOrder({
        element: containingLayer
    }) ?? 0) + 0.5;
}
/**
 * `true` when `candidate` is above `element`, as with native close watchers: the later open is
 * above.
 *
 * A descendant is always above its ancestors. This fixes the open order when React opens the child
 * first (child effects run first), or when the ancestor opens again.
 *
 * A page surface ranks just above its nearest containing layer (see `getRank`). This prevents a
 * cycle where an older manual popover waits for a newer one, the newer one waits for a page surface
 * inside it, and that surface waits for the older popover.
 */ function $9c03526f0da88a9b$var$isCandidateAbove({ element: element, isElementLayer: isElementLayer, candidate: candidate, layers: layers }) {
    if (element === candidate || candidate.contains(element)) return false;
    if (element.contains(candidate)) return true;
    return $9c03526f0da88a9b$var$getRank({
        element: candidate,
        layers: layers,
        isLayer: layers.includes(candidate)
    }) > $9c03526f0da88a9b$var$getRank({
        element: element,
        layers: layers,
        isLayer: isElementLayer
    });
}
function $9c03526f0da88a9b$export$34d7e67eba469e06({ element: element, isLayer: isLayer = false }) {
    const { ownerDocument: ownerDocument } = element;
    const layers = (0, $6SmSh.getOpenLayersTakingEscape)({
        within: ownerDocument
    });
    // The hook can attach before its popover opens. Compare it anyway.
    if (isLayer && !layers.includes(element)) layers.push(element);
    const surfaces = Array.from(ownerDocument.querySelectorAll(`[${(0, $86jEU.pageSurfaceEscapeAttribute)}]`));
    return [
        ...layers,
        ...surfaces
    ].some((candidate)=>$9c03526f0da88a9b$var$isCandidateAbove({
            element: element,
            isElementLayer: isLayer,
            candidate: candidate,
            layers: layers
        }));
}

});
parcelRegister("8hpNz", function(module, exports) {
$parcel$export(module.exports, "getNearestContainingLayer", () => $e8734a147b99e073$export$a866a64ce12fcfe5);
/**
 * The deepest layer in `layers` that contains `element` (not `element` itself), or `null`.
 */ function $e8734a147b99e073$export$a866a64ce12fcfe5({ element: element, layers: layers }) {
    const containingLayers = layers.filter((layer)=>layer !== element && layer.contains(element));
    // The deepest containing layer contains no other containing layer.
    return containingLayers.find((layer)=>!containingLayers.some((otherLayer)=>otherLayer !== layer && layer.contains(otherLayer))) ?? null;
}

});

parcelRegister("6SmSh", function(module, exports) {
$parcel$export(module.exports, "getOpenLayersTakingEscape", () => $6bd23f190b74b37a$export$f07656e15ea7b8be);

var $leZEk = parcelRequire("leZEk");
function $6bd23f190b74b37a$export$f07656e15ea7b8be({ within: within }) {
    return Array.from(within.querySelectorAll('dialog, [popover]')).filter((element)=>(0, $leZEk.isOpenLayerTakingEscape)({
            element: element
        }));
}

});
parcelRegister("leZEk", function(module, exports) {
$parcel$export(module.exports, "isOpenLayerTakingEscape", () => $75b8b8893536d9bd$export$53614d3ce6b06e6);

var $gHI9p = parcelRequire("gHI9p");

var $7zmqy = parcelRequire("7zmqy");

var $3UIKp = parcelRequire("3UIKp");
/**
 * `true` when an open `<dialog>` takes Escape, as the browser decides:
 *
 * - A `Dialog` has `closedby="none"` but takes Escape itself, so it marks itself with
 *   `manualEscapeLayerAttribute` while open.
 * - With `closedby` support, `closedBy` is the computed state: `"closerequest"` for a modal dialog
 *   without the attribute, `"none"` for a non-modal one. `closedby="none"` does not take Escape
 *   even when modal: the browser sends the close request past it.
 * - Without `closedby` support (Safari 27), only a modal dialog closes on Escape.
 *
 * A dialog that does not take Escape is part of the layer around it. Counting it would stop that
 * layer from closing.
 */ function $75b8b8893536d9bd$var$isDialogTakingEscape({ element: element }) {
    if (!element.open) return false;
    if (element.hasAttribute((0, $3UIKp.manualEscapeLayerAttribute))) return true;
    if (!('closedBy' in element)) return (0, $7zmqy.isModalDialog)({
        element: element
    });
    return element.closedBy !== 'none';
}
function $75b8b8893536d9bd$export$53614d3ce6b06e6({ element: element }) {
    if (element instanceof HTMLDialogElement) return $75b8b8893536d9bd$var$isDialogTakingEscape({
        element: element
    });
    if (!(0, $gHI9p.isNativeElementOpen)({
        element: element
    })) return false;
    if (element.popover === 'auto' || element.popover === 'hint') return true;
    return element.hasAttribute((0, $3UIKp.manualEscapeLayerAttribute));
}

});
parcelRegister("7zmqy", function(module, exports) {
$parcel$export(module.exports, "isModalDialog", () => $4764d7c0d9eb7884$export$cebb092bf393cc5);
/**
 * `true` for an open modal `<dialog>`.
 */ function $4764d7c0d9eb7884$export$cebb092bf393cc5({ element: element }) {
    if (!element.open) return false;
    // Some DOM implementations throw on `:modal`.
    try {
        return element.matches(':modal');
    } catch  {
        return false;
    }
}

});

parcelRegister("3UIKp", function(module, exports) {
$parcel$export(module.exports, "manualEscapeLayerAttribute", () => $83132e05f2242e5b$export$e9d791a989444609);
/**
 * Marks an open layer that takes Escape itself where the browser would not: a `manual` popover
 * with `useManualLightDismiss`, or a `Dialog` (`closedby="none"`), while it listens for Escape.
 *
 * A string, so it works across copies of `@atlaskit/top-layer`.
 *
 * An attribute, not a registry: the DOM is the record of open layers. The browser opens and closes
 * layers without our code (light dismiss, Escape), and layers from other code or older copies do
 * not register, so a registry would miss them. The mark only adds what the DOM cannot show, and it
 * goes away with its element.
 */ const $83132e05f2242e5b$export$e9d791a989444609 = 'data-top-layer-takes-escape';

});



parcelRegister("7VH8u", function(module, exports) {
$parcel$export(module.exports, "openOrderTracker", () => $8c735b963ea1db93$export$859fb18bafe6a3cf);

var $dmmsG = parcelRequire("dmmsG");
function $8c735b963ea1db93$var$createOpenOrderTracker() {
    // A `WeakMap`, so a removed element is not kept alive.
    const openOrders = new WeakMap();
    let lastOpenOrder = 0;
    let isTracking = false;
    function record({ element: element }) {
        lastOpenOrder += 1;
        openOrders.set(element, lastOpenOrder);
    }
    return {
        start () {
            if (isTracking) return;
            isTracking = true;
            /**
       * - Never unbound: it must see every open for the life of the page.
       * - `beforetoggle`, not `toggle`: `beforetoggle` fires synchronously on open. `toggle` is
       *   task-queued, and in Chrome it can arrive after an Escape that follows the open.
       * - Capture: `beforetoggle` does not bubble, and an inner `stopPropagation()` cannot hide
       *   an open from a capture listener on `document`.
       */ // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- open order is tracked for the whole document
            (0, $dmmsG.bind)(document, {
                type: 'beforetoggle',
                listener (event) {
                    if (event.newState !== 'open' || !(event.target instanceof Element)) return;
                    // An element that opens again gets a new, higher order.
                    record({
                        element: event.target
                    });
                },
                options: {
                    capture: true
                }
            });
        },
        getOpenOrder ({ element: element }) {
            return openOrders.get(element) ?? null;
        },
        ensureOpenOrder ({ element: element }) {
            if (openOrders.has(element)) return;
            record({
                element: element
            });
        }
    };
}
const $8c735b963ea1db93$export$859fb18bafe6a3cf = $8c735b963ea1db93$var$createOpenOrderTracker();

});

parcelRegister("86jEU", function(module, exports) {
$parcel$export(module.exports, "pageSurfaceEscapeAttribute", () => $f858484515044a54$export$890961b3d10b17dc);
/**
 * Marks the surface element of an open page surface while `useCloseOnUnclaimedEscape` listens for
 * Escape on `document`. A `manual` popover around the surface also listens on `document`, in bind
 * order. The mark lets the popover leave the Escape to the surface, whatever the bind order.
 *
 * A string, so it works across copies of `@atlaskit/top-layer`.
 */ const $f858484515044a54$export$890961b3d10b17dc = 'data-top-layer-surface-takes-escape';

});


parcelRegister("8khPQ", function(module, exports) {
$parcel$export(module.exports, "isEscapeToHandle", () => $80502cff94b5181f$export$da0a8943df86d627);
/**
 * `true` for an Escape keydown that a layer should act on.
 */ function $80502cff94b5181f$export$da0a8943df86d627({ event: event }) {
    if (event.key !== 'Escape') return false;
    // Something else already handled this Escape.
    if (event.defaultPrevented) return false;
    /**
   * The user is typing with an IME (input method editor), such as for Japanese or Chinese text.
   * While a composition is open, Escape cancels the composition, so it must not also close a layer.
   *
   * https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/isComposing
   */ if (event.isComposing) return false;
    return true;
}

});

parcelRegister("2l0Ma", function(module, exports) {
$parcel$export(module.exports, "useStartOpenOrderTracking", () => $56fab7b3b773c7f3$export$67e00e6e0682a61c);

var $1v5pe = parcelRequire("1v5pe");

var $7VH8u = parcelRequire("7VH8u");
function $56fab7b3b773c7f3$export$67e00e6e0682a61c() {
    /**
   * **Why `useInsertionEffect`**
   *
   * - It must run before any popover or dialog in this commit opens. `Popover` and `Dialog` open
   *   in layout effects, and React runs child effects first, so our own `useLayoutEffect` can run
   *   after a child layer has opened. React runs every insertion effect of a commit before any
   *   layout effect.
   * - Not during render: render also runs on the server, and binding a `document` listener there
   *   breaks SSR in a DOM test environment. Effects never run on the server.
   */ (0, $1v5pe.useInsertionEffect)(()=>{
        (0, $7VH8u.openOrderTracker).start();
    }, []);
}

});

parcelRegister("8TRgn", function(module, exports) {
$parcel$export(module.exports, "setAttribute", () => $0ef6a37c32be74c0$export$9fec4d97f1922e0b);
/**
 * Sets an attribute on an element and returns a cleanup function that removes it.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     setAttribute({ element, name: 'data-example', value: '' }),
 *     bind(window, { type: 'keydown', listener: onKeyDown }),
 *   );
 * }, []);
 * ```
 */ function $0ef6a37c32be74c0$export$9fec4d97f1922e0b({ element: element, name: name, value: value }) {
    element.setAttribute(name, value);
    return function cleanup() {
        element.removeAttribute(name);
    };
}

});



parcelRegister("3Lr6X", function(module, exports) {
$parcel$export(module.exports, "DialogScrollLock", () => $867840813305fda4$export$e458030908e2d723);

var $brxde = parcelRequire("brxde");

var $3q5kf = parcelRequire("3q5kf");
function $867840813305fda4$export$e458030908e2d723({ isOpen: isOpen }) {
    (0, $3q5kf.useLayoutEffect)(()=>{
        if (!isOpen) return;
        const body = (0, $brxde.getDocument)()?.body;
        if (!body) return;
        const previousOverflow = body.style.overflow;
        body.style.overflow = 'hidden';
        return ()=>{
            body.style.overflow = previousOverflow;
        };
    }, [
        isOpen
    ]);
    return null;
}

});

parcelRegister("3nXae", function(module, exports) {
$parcel$export(module.exports, "default", () => $c792f126ececc6e3$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $bbv94 = parcelRequire("bbv94");

var $9UVx7 = parcelRequire("9UVx7");

var $6vllQ = parcelRequire("6vllQ");

var $cUr2h = parcelRequire("cUr2h");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ const $c792f126ececc6e3$var$modalStackRegister = [];
function $c792f126ececc6e3$export$2e2bcd8739ae039({ onStackChange: onStackChange }) {
    const { isExiting: isExiting } = (0, $cUr2h.useExitingPersistence)();
    const [stackIndexRef, setStackIndex] = (0, $6vllQ.default)(0);
    const currentStackIndex = stackIndexRef.current;
    const previousStackIndex = (0, $9UVx7.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    const updateStack = (0, $bbv94.default)(()=>{
        const newStackIndex = $c792f126ececc6e3$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $1v5pe.useEffect)(()=>{
        const currentStackIndex = $c792f126ececc6e3$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $c792f126ececc6e3$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $c792f126ececc6e3$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $c792f126ececc6e3$var$modalStackRegister.forEach((cb)=>cb());
    }, [
        updateStack,
        isExiting
    ]);
    (0, $1v5pe.useEffect)(()=>()=>{
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            const currentStackIndex = $c792f126ececc6e3$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $c792f126ececc6e3$var$modalStackRegister.splice(currentStackIndex, 1);
                $c792f126ececc6e3$var$modalStackRegister.forEach((cb)=>cb());
            }
        }, [
        updateStack
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("9UVx7", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d30ab26726c265a$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");
function $8d30ab26726c265a$export$2e2bcd8739ae039(value) {
    const ref = (0, $1v5pe.useRef)();
    (0, $1v5pe.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("6vllQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8824e84ae8f110f$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");
function $f8824e84ae8f110f$export$2e2bcd8739ae039(initialState) {
    const [value, setValue] = (0, $1v5pe.useState)(initialState);
    const valueRef = (0, $1v5pe.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("5ogzQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5dce0559847068c$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $f5dce0559847068c$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
function $f5dce0559847068c$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $1v5pe.useState)(0);
    (0, $1v5pe.useLayoutEffect)(()=>{
        setScrollTopOffset($f5dce0559847068c$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $1v5pe.useCallback)(()=>{
        if ($f5dce0559847068c$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $1v5pe.useEffect)(()=>{
        return (0, $dmmsG.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});

parcelRegister("9o1SS", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", () => $c15c65e15e82fcc1$export$ec28e97c7d8b1b35);

var $dmmsG = parcelRequire("dmmsG");

var $dkTAq = parcelRequire("dkTAq");

var $jySDc = parcelRequire("jySDc");

var $j8xpA = parcelRequire("j8xpA");
function $c15c65e15e82fcc1$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    const unbindEvents = (0, $dmmsG.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $dkTAq.monitorForElements)({
        onGenerateDragPreview () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $jySDc.combine)(unbindEvents, unbindMonitor);
}
function $c15c65e15e82fcc1$var$watchForInteractionStart({ start: start }) {
    return (0, $dmmsG.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener (event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
const $c15c65e15e82fcc1$var$api = (0, $j8xpA.makeFixForAdapter)({
    watchForInteractionStart: $c15c65e15e82fcc1$var$watchForInteractionStart,
    watchForInteractionEnd: $c15c65e15e82fcc1$var$watchForInteractionEnd
});
function $c15c65e15e82fcc1$export$ec28e97c7d8b1b35() {
    return $c15c65e15e82fcc1$var$api.registerUsage();
}

});
parcelRegister("dkTAq", function(module, exports) {
$parcel$export(module.exports, "dropTargetForElements", () => $9759698508989323$export$e7140b68045b5036);
$parcel$export(module.exports, "monitorForElements", () => $9759698508989323$export$59a074bac4c54f54);
$parcel$export(module.exports, "draggable", () => $9759698508989323$export$c746a5152d4ba26c);

var $dmmsG = parcelRequire("dmmsG");

var $9FwzV = parcelRequire("9FwzV");

var $i4CJu = parcelRequire("i4CJu");

var $2nsfo = parcelRequire("2nsfo");

var $jySDc = parcelRequire("jySDc");

var $3piJr = parcelRequire("3piJr");

var $6hQzd = parcelRequire("6hQzd");

var $eUE4T = parcelRequire("eUE4T");

var $at0C2 = parcelRequire("at0C2");

var $doCBz = parcelRequire("doCBz");

var $7G5b7 = parcelRequire("7G5b7");

var $1RlTs = parcelRequire("1RlTs");
const $9759698508989323$var$draggableRegistry = new WeakMap();
function $9759698508989323$var$addToRegistry(args) {
    $9759698508989323$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $9759698508989323$var$draggableRegistry.delete(args.element);
    };
}
const $9759698508989323$var$honeyPotFix = (0, $i4CJu.makeHoneyPotFix)();
const $9759698508989323$var$adapter = (0, $2nsfo.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount (api) {
        /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */ return (0, $jySDc.combine)($9759698508989323$var$honeyPotFix.bindEvents(), (0, $dmmsG.bind)(document, {
            type: 'dragstart',
            listener (event) {
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                const target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return;
                // see if the thing being dragged is owned by us
                const entry = $9759698508989323$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return;
                /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */ const input = (0, $at0C2.getInput)(event);
                const feedback = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    const over = (0, $9FwzV.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return;
                    }
                }
                /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */ const nativeData = entry.getInitialDataForExternal?.(feedback) ?? null;
                if (nativeData) for (const [key, data] of Object.entries(nativeData))event.dataTransfer.setData(key, data ?? '');
                /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */ if ((0, $eUE4T.isAndroid)() && !event.dataTransfer.types.includes((0, $doCBz.textMediaType)) && !event.dataTransfer.types.includes((0, $7G5b7.URLMediaType))) event.dataTransfer.setData((0, $doCBz.textMediaType), (0, $eUE4T.androidFallbackText));
                /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */ event.dataTransfer.setData((0, $1RlTs.elementAdapterNativeDataKey), '');
                const payload = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    data: entry.getInitialData?.(feedback) ?? {}
                };
                const dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: ({ eventName: eventName, payload: payload })=>{
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        $9759698508989323$var$draggableRegistry.get(payload.source.element)?.[eventName]?.(// I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $9759698508989323$var$honeyPotFix.getOnPostDispatch()
});
const $9759698508989323$export$e7140b68045b5036 = $9759698508989323$var$adapter.dropTarget;
const $9759698508989323$export$59a074bac4c54f54 = $9759698508989323$var$adapter.monitor;
function $9759698508989323$export$c746a5152d4ba26c(args) {
    const cleanup = (0, $jySDc.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $9759698508989323$var$adapter.registerUsage(), $9759698508989323$var$addToRegistry(args), (0, $6hQzd.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $3piJr.once)(cleanup);
}

});
parcelRegister("9FwzV", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => $13938c9cffb86263$export$81d0353f25f5dd);

var $581yD = parcelRequire("581yD");
function $13938c9cffb86263$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    const [top, second] = document.elementsFromPoint(client.x, client.y);
    if (!top) return null;
    if ((0, $581yD.isHoneyPotElement)(top)) return second ?? null;
    return top;
}

});
parcelRegister("581yD", function(module, exports) {
$parcel$export(module.exports, "isHoneyPotElement", () => $946c0be3506a2cb5$export$821bdcd739a2706b);

var $b6Cc1 = parcelRequire("b6Cc1");
function $946c0be3506a2cb5$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $b6Cc1.honeyPotDataAttribute));
}

});
parcelRegister("b6Cc1", function(module, exports) {
$parcel$export(module.exports, "honeyPotDataAttribute", () => $a162174df15a583a$export$6eafea55f7947469);
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
const $a162174df15a583a$export$6eafea55f7947469 = 'data-pdnd-honey-pot';

});



parcelRegister("i4CJu", function(module, exports) {
$parcel$export(module.exports, "makeHoneyPotFix", () => $92e541429d0ce4cb$export$8ecad27c959e89e0);

var $dmmsG = parcelRequire("dmmsG");

var $1oOCb = parcelRequire("1oOCb");

var $8PQQy = parcelRequire("8PQQy");

var $gDWyl = parcelRequire("gDWyl");

var $b6Cc1 = parcelRequire("b6Cc1");
const $92e541429d0ce4cb$var$honeyPotSize = 2;
const $92e541429d0ce4cb$var$halfHoneyPotSize = $92e541429d0ce4cb$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $92e541429d0ce4cb$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $92e541429d0ce4cb$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $92e541429d0ce4cb$var$halfHoneyPotSize,
        y: point.y - $92e541429d0ce4cb$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $92e541429d0ce4cb$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $92e541429d0ce4cb$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $92e541429d0ce4cb$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $92e541429d0ce4cb$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $92e541429d0ce4cb$var$getHoneyPotRectFor({ client: client }) {
    const point = $92e541429d0ce4cb$var$preventGoingForwardsOffScreen($92e541429d0ce4cb$var$preventGoingBackwardsOffScreen($92e541429d0ce4cb$var$pullBackByHalfHoneyPotSize($92e541429d0ce4cb$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $92e541429d0ce4cb$var$honeyPotSize,
        height: $92e541429d0ce4cb$var$honeyPotSize
    });
}
function $92e541429d0ce4cb$var$getRectStyles({ clientRect: clientRect }) {
    return {
        left: `${clientRect.left}px`,
        top: `${clientRect.top}px`,
        width: `${clientRect.width}px`,
        height: `${clientRect.height}px`
    };
}
function $92e541429d0ce4cb$var$isWithin({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $92e541429d0ce4cb$var$mountHoneyPot({ initial: initial }) {
    const element = document.createElement('div');
    element.setAttribute((0, $b6Cc1.honeyPotDataAttribute), 'true');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the honey pot is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    if ((0, $gDWyl.supportsPopover)()) // eslint-disable-next-line @atlaskit/design-system/no-native-popover-or-dialog -- paints above the page during a drag; it never takes Escape or closes on an outside press
    element.setAttribute('popover', 'manual');
    // can shift during the drag thanks to Firefox
    let clientRect = $92e541429d0ce4cb$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, {
        position: 'fixed',
        ...(0, $gDWyl.supportsPopover)() ? // needs to come first as it has 'inset: unset' which
        // needs to be overridden by our top / left values
        (0, $8PQQy.popoverResetUserAgentStyles) : {
            // Fallback: using maximum possible z-index so that this element
            // will always be on top of other positioned content.
            zIndex: (0, $1oOCb.maxZIndex)
        },
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box',
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        ...$92e541429d0ce4cb$var$getRectStyles({
            clientRect: clientRect
        })
    });
    document.body.appendChild(element);
    if ((0, $gDWyl.supportsPopover)()) element.showPopover();
    /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */ const unbindPointerMove = (0, $dmmsG.bind)(window, {
        type: 'pointermove',
        listener (event) {
            const client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $92e541429d0ce4cb$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $92e541429d0ce4cb$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish({ current: current }) {
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($92e541429d0ce4cb$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        const unbindPostDragEvents = (0, $dmmsG.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $92e541429d0ce4cb$export$8ecad27c959e89e0() {
    let latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $dmmsG.bind)(window, {
            type: 'pointermove',
            listener (event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        let finish = null;
        return function onPostEvent({ eventName: eventName, payload: payload }) {
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                const { input: input } = payload.location.initial;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                const initial = latestPointerMove ?? {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $92e541429d0ce4cb$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                const { input: input } = payload.location.current;
                finish?.({
                    current: {
                        x: input.clientX,
                        y: input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
parcelRegister("1oOCb", function(module, exports) {
$parcel$export(module.exports, "maxZIndex", () => $975227891fdd5fcd$export$7d0a15ee70427305);
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $975227891fdd5fcd$export$7d0a15ee70427305 = 2147483647;

});

parcelRegister("8PQQy", function(module, exports) {
$parcel$export(module.exports, "popoverResetUserAgentStyles", () => $ea5812bbc8641137$export$74004cb910cdc478);
const $ea5812bbc8641137$export$74004cb910cdc478 = {
    inset: 'unset',
    border: 'none',
    padding: 0,
    margin: 0,
    overflow: 'visible',
    color: 'inherit',
    background: 'transparent',
    width: 'auto',
    height: 'auto'
};

});

parcelRegister("gDWyl", function(module, exports) {
$parcel$export(module.exports, "supportsPopover", () => $bc197170fdbde358$export$1150b66d0ff92823);

var $3piJr = parcelRequire("3piJr");
const $bc197170fdbde358$export$1150b66d0ff92823 = (0, $3piJr.once)(function supportsPopover() {
    return typeof HTMLElement !== 'undefined' && typeof HTMLElement.prototype.showPopover === 'function';
});

});
parcelRegister("3piJr", function(module, exports) {
$parcel$export(module.exports, "once", () => $4bbac7494ef928cd$export$d2de3aaeafa91619);
/** Provide a function that you only ever want to be called a single time */ function $4bbac7494ef928cd$export$d2de3aaeafa91619(fn) {
    let cache = null;
    return function wrapped(...args) {
        if (!cache) {
            const result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});



parcelRegister("2nsfo", function(module, exports) {
$parcel$export(module.exports, "makeAdapter", () => $bc3e86dff269c11f$export$2aa3a33160990d96);

var $1syxn = parcelRequire("1syxn");

var $9YLgA = parcelRequire("9YLgA");

var $jELIs = parcelRequire("jELIs");

var $2p571 = parcelRequire("2p571");
function $bc3e86dff269c11f$export$2aa3a33160990d96({ typeKey: typeKey, mount: mount, dispatchEventToSource: dispatchEventToSource, onPostDispatch: onPostDispatch, defaultDropEffect: defaultDropEffect }) {
    const monitorAPI = (0, $2p571.makeMonitor)();
    const dropTargetAPI = (0, $jELIs.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource?.(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch?.(args);
    }
    function start({ event: event, dragType: dragType }) {
        (0, $1syxn.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            const api = {
                canStart: (0, $1syxn.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $9YLgA.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("1syxn", function(module, exports) {
$parcel$export(module.exports, "lifecycle", () => $c33dafed8f75189b$export$3efdceeb8ca25c51);

var $dmmsG = parcelRequire("dmmsG");

var $9FwzV = parcelRequire("9FwzV");

var $581yD = parcelRequire("581yD");

var $04gGg = parcelRequire("04gGg");

var $i6Jl4 = parcelRequire("i6Jl4");

var $at0C2 = parcelRequire("at0C2");

var $loUD1 = parcelRequire("loUD1");
const $c33dafed8f75189b$var$globalState = {
    isActive: false
};
function $c33dafed8f75189b$var$canStart() {
    return !$c33dafed8f75189b$var$globalState.isActive;
}
function $c33dafed8f75189b$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $c33dafed8f75189b$var$hasHierarchyChanged({ current: current, next: next }) {
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(let i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $c33dafed8f75189b$var$start({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver, dispatchEvent: dispatchEvent }) {
    if (!$c33dafed8f75189b$var$canStart()) return;
    const initial = $c33dafed8f75189b$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $c33dafed8f75189b$var$globalState.isActive = true;
    const state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $c33dafed8f75189b$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    const dispatch = (0, $loUD1.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        const hasChanged = $c33dafed8f75189b$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        const input = (0, $at0C2.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        const target = (0, $581yD.isHoneyPotElement)(event.target) ? (0, $9FwzV.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        const nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $c33dafed8f75189b$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $c33dafed8f75189b$var$globalState.isActive = false;
        unbindEvents();
    }
    const unbindEvents = (0, $dmmsG.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener (event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener (event) {
                if (!(0, $04gGg.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener (event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $at0C2.getInput)(event)
                };
                /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $c33dafed8f75189b$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener (event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $at0C2.getInput)(event)
                };
                cancel();
            }
        },
        ...(0, $i6Jl4.getBindingsForBrokenDrags)({
            onDragEnd: cancel
        })
    ], // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $c33dafed8f75189b$var$getNativeSetDragImage(event)
    });
}
function $c33dafed8f75189b$var$setDropEffectOnEvent({ event: event, current: current }) {
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    const innerMost = current[0]?.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $c33dafed8f75189b$var$getStartLocation({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver }) {
    const input = (0, $at0C2.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    const dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
const $c33dafed8f75189b$export$3efdceeb8ca25c51 = {
    canStart: $c33dafed8f75189b$var$canStart,
    start: $c33dafed8f75189b$var$start
};

});
parcelRegister("04gGg", function(module, exports) {
$parcel$export(module.exports, "isLeavingWindow", () => $f0df7c10958e85a4$export$57d220c74e84a273);

var $4NBtu = parcelRequire("4NBtu");

var $3jeAD = parcelRequire("3jeAD");

var $3OQMh = parcelRequire("3OQMh");

var $6hqfI = parcelRequire("6hqfI");
function $f0df7c10958e85a4$export$57d220c74e84a273({ dragLeave: dragLeave }) {
    const { type: type, relatedTarget: relatedTarget } = dragLeave;
    if (type !== 'dragleave') return false;
    if ((0, $3jeAD.isSafari)()) return (0, $6hqfI.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */ if ((0, $4NBtu.isFirefox)()) return (0, $3OQMh.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("4NBtu", function(module, exports) {
$parcel$export(module.exports, "isFirefox", () => $c4c411b71483ad5f$export$b7d78993b74f766d);

var $3piJr = parcelRequire("3piJr");
const $c4c411b71483ad5f$export$b7d78993b74f766d = (0, $3piJr.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});

parcelRegister("3jeAD", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $161ca076c8ad6f76$export$95df08bae54cb4df);

var $3piJr = parcelRequire("3piJr");
const $161ca076c8ad6f76$export$95df08bae54cb4df = (0, $3piJr.once)(function isSafari() {
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("3OQMh", function(module, exports) {
$parcel$export(module.exports, "isFromAnotherWindow", () => $6449e0a0dba5a44c$export$e46810fef53b5b0e);
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $6449e0a0dba5a44c$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $6449e0a0dba5a44c$export$e46810fef53b5b0e(eventTarget) {
    return $6449e0a0dba5a44c$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});

parcelRegister("6hqfI", function(module, exports) {
$parcel$export(module.exports, "isLeavingWindowInSafari", () => $4c1bd95e4487b079$export$f21837c338005454);

var $3jeAD = parcelRequire("3jeAD");

var $2cSyW = parcelRequire("2cSyW");
function $4c1bd95e4487b079$export$f21837c338005454({ dragLeave: dragLeave }) {
    if (!(0, $3jeAD.isSafari)()) return false;
    return dragLeave.hasOwnProperty((0, $2cSyW.symbols).isLeavingWindow);
}

});
parcelRegister("2cSyW", function(module, exports) {
$parcel$export(module.exports, "symbols", () => $685df2234f141bbd$export$47616e9f7f5fe113);

var $dmmsG = parcelRequire("dmmsG");

var $3jeAD = parcelRequire("3jeAD");
const $685df2234f141bbd$export$47616e9f7f5fe113 = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $3jeAD.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    let state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $dmmsG.bindAll)(window, [
        {
            type: 'dragstart',
            listener: ()=>{
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: (event)=>{
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                event[$685df2234f141bbd$export$47616e9f7f5fe113.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: (event)=>{
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    event[$685df2234f141bbd$export$47616e9f7f5fe113.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});



parcelRegister("i6Jl4", function(module, exports) {
$parcel$export(module.exports, "getBindingsForBrokenDrags", () => $3da0ca8bbe7787e3$export$ac5e5b0daf997b2);
function $3da0ca8bbe7787e3$export$ac5e5b0daf997b2({ onDragEnd: onDragEnd }) {
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            })()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("at0C2", function(module, exports) {
$parcel$export(module.exports, "getInput", () => $4ca3c032d90d1186$export$7c112ceec8941e67);
function $4ca3c032d90d1186$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("loUD1", function(module, exports) {
$parcel$export(module.exports, "makeDispatch", () => $19c7f750f01d0057$export$9f13ecc44e83d682);

var $9q8C6 = parcelRequire("9q8C6");
const $19c7f750f01d0057$var$scheduleOnDrag = (0, $9q8C6.default)((fn)=>fn());
const $19c7f750f01d0057$var$dragStart = (()=>{
    let scheduled = null;
    function schedule(fn) {
        const frameId = requestAnimationFrame(()=>{
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
})();
function $19c7f750f01d0057$export$9f13ecc44e83d682({ source: source, initial: initial, dispatchEvent: dispatchEvent }) {
    let previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    const dispatch = {
        start ({ nativeSetDragImage: nativeSetDragImage }) {
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            const location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $19c7f750f01d0057$var$dragStart.schedule(()=>{
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate ({ current: current }) {
            $19c7f750f01d0057$var$dragStart.flush();
            $19c7f750f01d0057$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag ({ current: current }) {
            $19c7f750f01d0057$var$scheduleOnDrag(()=>{
                $19c7f750f01d0057$var$dragStart.flush();
                const location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop ({ current: current, updatedSourcePayload: updatedSourcePayload }) {
            $19c7f750f01d0057$var$dragStart.flush();
            $19c7f750f01d0057$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload ?? source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});


parcelRegister("9YLgA", function(module, exports) {
$parcel$export(module.exports, "register", () => $aa60299fbd6ceb4d$export$6503ec6e8aabbaf);
const $aa60299fbd6ceb4d$var$ledger = new Map();
function $aa60299fbd6ceb4d$var$registerUsage({ typeKey: typeKey, mount: mount }) {
    const entry = $aa60299fbd6ceb4d$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    const initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $aa60299fbd6ceb4d$var$ledger.set(typeKey, initial);
    return initial;
}
function $aa60299fbd6ceb4d$export$6503ec6e8aabbaf(args) {
    const entry = $aa60299fbd6ceb4d$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $aa60299fbd6ceb4d$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("jELIs", function(module, exports) {
$parcel$export(module.exports, "makeDropTarget", () => $42479763e29ff9fb$export$47d10e7bd9c81890);

var $jySDc = parcelRequire("jySDc");

var $3piJr = parcelRequire("3piJr");

var $6hQzd = parcelRequire("6hQzd");
function $42479763e29ff9fb$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $42479763e29ff9fb$export$47d10e7bd9c81890({ typeKey: typeKey, defaultDropEffect: defaultDropEffect }) {
    const registry = new WeakMap();
    const dropTargetDataAtt = `data-drop-target-for-${typeKey}`;
    const dropTargetSelector = `[${dropTargetDataAtt}]`;
    function addToRegistry(args) {
        registry.set(args.element, args);
        return ()=>registry.delete(args.element);
    }
    function dropTargetForConsumers(args) {
        const cleanup = (0, $jySDc.combine)((0, $6hQzd.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $3piJr.once)(cleanup);
    }
    function getActualDropTargets({ source: source, target: target, input: input, result: result = [] }) {
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        const closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        const args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        const feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        const data = args.getData?.(feedback) ?? {};
        const dropEffect = args.getDropEffect?.(feedback) ?? defaultDropEffect;
        const record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [
                ...result,
                record
            ]
        });
    }
    function notifyCurrent({ eventName: eventName, payload: payload }) {
        for (const record of payload.location.current.dropTargets){
            const entry = registry.get(record.element);
            const args = {
                ...payload,
                self: record
            };
            entry?.[eventName]?.(// I cannot seem to get the types right here.
            // TS doesn't seem to like that one event can need `nativeSetDragImage`
            // @ts-expect-error
            args);
        }
    }
    const actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: ({ payload: payload })=>{
            const isCurrent = new Set(payload.location.current.dropTargets.map((record)=>record.element));
            const visited = new Set();
            for (const record of payload.location.previous.dropTargets){
                visited.add(record.element);
                const entry = registry.get(record.element);
                const isOver = isCurrent.has(record.element);
                const args = {
                    ...payload,
                    self: record
                };
                entry?.onDropTargetChange?.(args);
                // if we cannot find the drop target in the current array, then it has been left
                if (!isOver) entry?.onDragLeave?.(args);
            }
            for (const record of payload.location.current.dropTargets){
                // already published an update to this drop target
                if (visited.has(record.element)) continue;
                // at this point we have a new drop target that is being entered into
                const args = {
                    ...payload,
                    self: record
                };
                const entry = registry.get(record.element);
                entry?.onDropTargetChange?.(args);
                entry?.onDragEnter?.(args);
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver({ source: source, target: target, input: input, current: current }) {
        const actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        const lastCaptureOrdered = $42479763e29ff9fb$var$copyReverse(current);
        const actualCaptureOrdered = $42479763e29ff9fb$var$copyReverse(actual);
        const resultCaptureOrdered = [];
        for(let index = 0; index < lastCaptureOrdered.length; index++){
            const last = lastCaptureOrdered[index];
            const fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            const parent = resultCaptureOrdered[index - 1];
            const lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if (parent?.element !== lastParent?.element) break;
            // We need to check whether the old drop target can still be dropped on
            const argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            const feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!argsForLast.getIsSticky?.(feedback)) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push({
                ...last,
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            });
        }
        // return bubble ordered result
        return $42479763e29ff9fb$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("6hQzd", function(module, exports) {
$parcel$export(module.exports, "addAttribute", () => $e26a00fac74dbc30$export$5dcb5c23b6ba980a);
function $e26a00fac74dbc30$export$5dcb5c23b6ba980a(element, { attribute: attribute, value: value }) {
    element.setAttribute(attribute, value);
    return ()=>element.removeAttribute(attribute);
}

});


parcelRegister("2p571", function(module, exports) {
$parcel$export(module.exports, "makeMonitor", () => $bffb96498b2d9e4d$export$5dd4ed888d5b12ca);

var $3piJr = parcelRequire("3piJr");
function $bffb96498b2d9e4d$export$5dd4ed888d5b12ca() {
    const registry = new Set();
    let dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        const entry = {
            ...args
        };
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $3piJr.once)(cleanup);
    }
    function dispatchEvent({ eventName: eventName, payload: payload }) {
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            for (const monitor of registry)tryAddToActive(monitor);
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        const active = Array.from(dragging.active);
        for (const monitor of active)// A monitor can be removed by another monitor during an event.
        // We need to check that the monitor is still registered before calling it
        if (dragging.active.has(monitor)) // @ts-expect-error: I cannot get this type working!
        monitor[eventName]?.(payload);
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("eUE4T", function(module, exports) {
$parcel$export(module.exports, "isAndroid", () => $b3a6dc958f1f2889$export$a11b0059900ceec8);
$parcel$export(module.exports, "androidFallbackText", () => $b3a6dc958f1f2889$export$aceb3ed8b7f7bd2c);

var $3piJr = parcelRequire("3piJr");
const $b3a6dc958f1f2889$export$a11b0059900ceec8 = (0, $3piJr.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
const $b3a6dc958f1f2889$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

parcelRegister("doCBz", function(module, exports) {
$parcel$export(module.exports, "textMediaType", () => $ddfc3d7fb082b4bc$export$fd3d00026297c0ad);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $ddfc3d7fb082b4bc$export$fd3d00026297c0ad = 'text/plain';

});

parcelRegister("7G5b7", function(module, exports) {
$parcel$export(module.exports, "URLMediaType", () => $1a20191a4a04eed1$export$4c44a460f123106);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $1a20191a4a04eed1$export$4c44a460f123106 = 'text/uri-list';

});

parcelRegister("1RlTs", function(module, exports) {
$parcel$export(module.exports, "elementAdapterNativeDataKey", () => $697e6b46936239c7$export$c9c4cc54e73b125d);
/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ const $697e6b46936239c7$export$c9c4cc54e73b125d = 'application/vnd.pdnd';

});


parcelRegister("j8xpA", function(module, exports) {
$parcel$export(module.exports, "makeFixForAdapter", () => $924eed6d40e44b23$export$a74bff2507e6126b);

var $jySDc = parcelRequire("jySDc");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $924eed6d40e44b23$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $924eed6d40e44b23$var$hasSameOrigin(href1, href2) {
    let url1;
    let url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch  {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $924eed6d40e44b23$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith('data:')) return false;
    return !$924eed6d40e44b23$var$hasSameOrigin(window.location.href, iframe.src);
}
const $924eed6d40e44b23$var$registry = new Map();
function $924eed6d40e44b23$var$applyFix(watchForEndOfInteraction) {
    const iframes = Array.from(document.querySelectorAll('iframe')).filter($924eed6d40e44b23$var$isIframeOnAnotherDomain);
    const cleanups = iframes.map((iframe)=>{
        let entry = $924eed6d40e44b23$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $924eed6d40e44b23$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $924eed6d40e44b23$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $924eed6d40e44b23$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $jySDc.combine)(...cleanups)();
    }
    const cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $924eed6d40e44b23$export$a74bff2507e6126b({ watchForInteractionStart: watchForInteractionStart, watchForInteractionEnd: watchForInteractionEnd }) {
    let registrationCount = 0;
    let stopWatchingInteractionStart = null;
    function start() {
        $924eed6d40e44b23$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            registrationCount--;
            if (registrationCount !== 0) return;
            stopWatchingInteractionStart?.();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("94IQO", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", () => $60d1b9698263783f$export$27d79116d3a4e7d5);

var $l0fBr = parcelRequire("l0fBr");

var $j8xpA = parcelRequire("j8xpA");
function $60d1b9698263783f$var$watchForInteractionStart({ start: start }) {
    return (0, $l0fBr.monitorForExternal)({
        onDragStart () {
            start();
        }
    });
}
function $60d1b9698263783f$var$watchForInteractionEnd({ stop: stop }) {
    return (0, $l0fBr.monitorForExternal)({
        onDrop () {
            stop();
        }
    });
}
const $60d1b9698263783f$var$api = (0, $j8xpA.makeFixForAdapter)({
    watchForInteractionStart: $60d1b9698263783f$var$watchForInteractionStart,
    watchForInteractionEnd: $60d1b9698263783f$var$watchForInteractionEnd
});
function $60d1b9698263783f$export$27d79116d3a4e7d5() {
    return $60d1b9698263783f$var$api.registerUsage();
}

});
parcelRegister("l0fBr", function(module, exports) {
$parcel$export(module.exports, "monitorForExternal", () => $b7433deb626ed34f$export$bb1740f3194979c1);

var $8W3qZ = parcelRequire("8W3qZ");
function $b7433deb626ed34f$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return (0, $8W3qZ.adapter).monitor(args);
}

});
parcelRegister("8W3qZ", function(module, exports) {
$parcel$export(module.exports, "adapter", () => $21bd1627266cc91b$export$e00c9c6684b0ace);

var $dmmsG = parcelRequire("dmmsG");

var $2nsfo = parcelRequire("2nsfo");

var $9fpdU = parcelRequire("9fpdU");

var $i6Jl4 = parcelRequire("i6Jl4");

var $1nAr1 = parcelRequire("1nAr1");

var $6GqD2 = parcelRequire("6GqD2");

var $lWNx8 = parcelRequire("lWNx8");
let $21bd1627266cc91b$var$didDragStartLocally = false;
const $21bd1627266cc91b$export$e00c9c6684b0ace = (0, $2nsfo.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $dmmsG.bind)(window, {
            type: 'dragenter',
            listener (event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($21bd1627266cc91b$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $9fpdU.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                const types = (0, $6GqD2.getAvailableTypes)(event.dataTransfer);
                if (!types.length) return;
                const locked = {
                    types: types,
                    items: [],
                    getStringData: ()=>null
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload (event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            const items = (0, $1nAr1.getAvailableItems)(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            const nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData (mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    const value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!(0, $lWNx8.isAnAvailableType)({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $21bd1627266cc91b$export$e00c9c6684b0ace.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    const idle = {
        type: 'idle'
    };
    let state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $21bd1627266cc91b$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $dmmsG.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            },
            ...(0, $i6Jl4.getBindingsForBrokenDrags)({
                onDragEnd: clear
            })
        ], // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $dmmsG.bind)(window, {
        type: 'dragstart',
        listener () {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $21bd1627266cc91b$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})();

});
parcelRegister("9fpdU", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindow", () => $fe839351c846fb59$export$d1c6f249e893cdf4);

var $4NBtu = parcelRequire("4NBtu");

var $3jeAD = parcelRequire("3jeAD");

var $fxJD0 = parcelRequire("fxJD0");

var $3OQMh = parcelRequire("3OQMh");
function $fe839351c846fb59$export$d1c6f249e893cdf4({ dragEnter: dragEnter }) {
    const { type: type, relatedTarget: relatedTarget } = dragEnter;
    if (type !== 'dragenter') return false;
    if ((0, $3jeAD.isSafari)()) return (0, $fxJD0.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is the `iframe` element in the parent `window`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is an element inside the child `iframe`
   * (foreign element)
   */ if ((0, $4NBtu.isFirefox)()) return (0, $3OQMh.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is `null` *(standard check)*
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is the `iframe` element in the parent `window`
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("fxJD0", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindowInSafari", () => $65938e64d75e4206$export$de68634bd94ed596);

var $3jeAD = parcelRequire("3jeAD");

var $2cSyW = parcelRequire("2cSyW");
function $65938e64d75e4206$export$de68634bd94ed596({ dragEnter: dragEnter }) {
    if (!(0, $3jeAD.isSafari)()) return false;
    return dragEnter.hasOwnProperty((0, $2cSyW.symbols).isEnteringWindow);
}

});


parcelRegister("1nAr1", function(module, exports) {
$parcel$export(module.exports, "getAvailableItems", () => $d7c05c2b99e57bde$export$8d28cfecded8dcab);

var $lWNx8 = parcelRequire("lWNx8");
function $d7c05c2b99e57bde$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter((item)=>item.kind === 'file' || (0, $lWNx8.isAnAvailableType)({
            type: item.type,
            value: dataTransfer.getData(item.type)
        }));
}

});
parcelRegister("lWNx8", function(module, exports) {
$parcel$export(module.exports, "isAnAvailableType", () => $40876ba264d53550$export$a8e56a860d7957c7);

var $eUE4T = parcelRequire("eUE4T");

var $doCBz = parcelRequire("doCBz");

var $1RlTs = parcelRequire("1RlTs");
function $40876ba264d53550$export$a8e56a860d7957c7({ type: type, value: value }) {
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $1RlTs.elementAdapterNativeDataKey)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $doCBz.textMediaType) && value === (0, $eUE4T.androidFallbackText)) return false;
    return true;
}

});


parcelRegister("6GqD2", function(module, exports) {
$parcel$export(module.exports, "getAvailableTypes", () => $792053a3c7cee0cc$export$8c257a3856120a77);

var $lWNx8 = parcelRequire("lWNx8");
function $792053a3c7cee0cc$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter((type)=>(0, $lWNx8.isAnAvailableType)({
            type: type,
            value: transfer.getData(type)
        }));
}

});




parcelRegister("11R2l", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", () => $0d688745ac2ae62e$export$9c0606fcefb5d1e2);

var $dmmsG = parcelRequire("dmmsG");

var $eFkoH = parcelRequire("eFkoH");

var $jySDc = parcelRequire("jySDc");

var $j8xpA = parcelRequire("j8xpA");
function $0d688745ac2ae62e$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    let frameId = null;
    const unbindEvents = (0, $dmmsG.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener () {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(()=>{
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $eFkoH.monitorForTextSelection)({
        onDragStart () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $jySDc.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $0d688745ac2ae62e$var$watchForInteractionStart({ start: start }) {
    return (0, $dmmsG.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener () {
            // A text selection drag will only start when there is
            // an active text selection.
            const selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
const $0d688745ac2ae62e$var$api = (0, $j8xpA.makeFixForAdapter)({
    watchForInteractionStart: $0d688745ac2ae62e$var$watchForInteractionStart,
    watchForInteractionEnd: $0d688745ac2ae62e$var$watchForInteractionEnd
});
function $0d688745ac2ae62e$export$9c0606fcefb5d1e2() {
    return $0d688745ac2ae62e$var$api.registerUsage();
}

});
parcelRegister("eFkoH", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", () => $6e91153be6f6d65d$export$2e178e3647f5e6e9);

var $8GvKN = parcelRequire("8GvKN");
function $6e91153be6f6d65d$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return (0, $8GvKN.adapter).monitor(args);
}

});
parcelRegister("8GvKN", function(module, exports) {
$parcel$export(module.exports, "adapter", () => $302810749f46f67c$export$e00c9c6684b0ace);

var $dmmsG = parcelRequire("dmmsG");

var $2nsfo = parcelRequire("2nsfo");

var $jySDc = parcelRequire("jySDc");

var $3zF5U = parcelRequire("3zF5U");

var $doCBz = parcelRequire("doCBz");

var $1RlTs = parcelRequire("1RlTs");

var $iV5Ok = parcelRequire("iV5Ok");

var $dYzzU = parcelRequire("dYzzU");
const $302810749f46f67c$export$e00c9c6684b0ace = (0, $2nsfo.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $jySDc.combine)((0, $dYzzU.honeyPotFix).bindEvents(), (0, $dmmsG.bind)(window, {
            type: 'dragstart',
            listener (event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $1RlTs.elementAdapterNativeDataKey))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $doCBz.textMediaType))) return;
                const target = (0, $iV5Ok.findTextNode)(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                const payload = {
                    target: // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target,
                    plain: event.dataTransfer.getData((0, $doCBz.textMediaType)),
                    HTML: event.dataTransfer.getData((0, $3zF5U.HTMLMediaType))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: (0, $dYzzU.honeyPotFix).getOnPostDispatch()
});
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $302810749f46f67c$export$e00c9c6684b0ace.registerUsage();
})();

});
parcelRegister("3zF5U", function(module, exports) {
$parcel$export(module.exports, "HTMLMediaType", () => $8b2ac2600ad4fda7$export$338a9f6c7a1f02b0);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $8b2ac2600ad4fda7$export$338a9f6c7a1f02b0 = 'text/html';

});

parcelRegister("iV5Ok", function(module, exports) {
$parcel$export(module.exports, "findTextNode", () => $6f5d682e11cfe2b1$export$c15c0fde2d293bb4);

var $3jeAD = parcelRequire("3jeAD");

var $doCBz = parcelRequire("doCBz");
function $6f5d682e11cfe2b1$export$c15c0fde2d293bb4(event) {
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $3jeAD.isSafari)()) return null;
    /**
   * According to the spec, `event.target` should be the `Text` node that
   * the drag started from when dragging a text selection.
   *
   * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
   *
   * However, in Safari the closest `HTMLElement` is returned.
   * So we need to figure out if text is dragging ourselves.
   *
   * → https://bugs.webkit.org/show_bug.cgi?id=268959
   */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!event.dataTransfer?.getData((0, $doCBz.textMediaType))) return null;
    /**
   * Grab the first Text node and use that.
   * Only doing a single level search as that is all we need for this bug.
   */ const text = Array.from(event.target.childNodes).find((node)=>node.nodeType === Node.TEXT_NODE);
    return text ?? null;
}

});

parcelRegister("dYzzU", function(module, exports) {
$parcel$export(module.exports, "honeyPotFix", () => $4977d11ae641bb15$export$f17744ed5439c0ab);

var $i4CJu = parcelRequire("i4CJu");
const $4977d11ae641bb15$export$f17744ed5439c0ab = (0, $i4CJu.makeHoneyPotFix)();

});




parcelRegister("8KJ3R", function(module, exports) {
$parcel$export(module.exports, "width", () => $dd588a9ad0085abc$export$7e3df82ee760448c);
const $dd588a9ad0085abc$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};

});

parcelRegister("5BrkL", function(module, exports) {
$parcel$export(module.exports, "default", () => $02b1de7676d62ddf$export$2e2bcd8739ae039);
/* modal-dialog.tsx generated by @compiled/babel-plugin v3.0.2 */ /* modal-dialog.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $ky45w = parcelRequire("ky45w");

var $fl4ll = parcelRequire("fl4ll");

var $Ms2ib = parcelRequire("Ms2ib");

var $lHxwq = parcelRequire("lHxwq");

var $gvhLu = parcelRequire("gvhLu");

var $ulOZK = parcelRequire("ulOZK");

var $eTbg2 = parcelRequire("eTbg2");

var $etMwD = parcelRequire("etMwD");

var $2aEiL = parcelRequire("2aEiL");

var $jySDc = parcelRequire("jySDc");

var $eSj0I = parcelRequire("eSj0I");

var $iezB5 = parcelRequire("iezB5");

var $9o1SS = parcelRequire("9o1SS");

var $94IQO = parcelRequire("94IQO");

var $11R2l = parcelRequire("11R2l");

var $1LjAb = parcelRequire("1LjAb");

var $7Skuo = parcelRequire("7Skuo");

var $401cB = parcelRequire("401cB");

var $gdewX = parcelRequire("gdewX");

var $kIqwl = parcelRequire("kIqwl");
const $02b1de7676d62ddf$var$_32 = "@media (min-width:30rem){._cbiz17ks._cbiz17ks{height:var(--modal-dialog-height)}._bolh1kw7._bolh1kw7{max-height:inherit}}";
const $02b1de7676d62ddf$var$_31 = "@media (min-width:30rem){._8kn617ks._8kn617ks{min-height:var(--modal-dialog-height)}}";
const $02b1de7676d62ddf$var$_30 = "._c71lglyw{max-height:none}";
const $02b1de7676d62ddf$var$_29 = "._1tke1kxc{min-height:100vh}";
const $02b1de7676d62ddf$var$_28 = "@media (min-width:30rem){._1jyk1osq{height:100%}}";
const $02b1de7676d62ddf$var$_27 = "@media (min-width:30rem){._yakv1wug{margin-inline-end:auto}._4lht1wug{margin-inline-start:auto}}";
const $02b1de7676d62ddf$var$_26 = "@media (max-width:29.9375rem){._1if81osq{height:100%}}";
const $02b1de7676d62ddf$var$_25 = "@media (min-width:30rem){._1jyk1jm9{height:var(--modal-dialog-height,auto)}}";
const $02b1de7676d62ddf$var$_24 = "._p12f1kw7{max-width:inherit}";
const $02b1de7676d62ddf$var$_23 = "._c71l1kw7{max-height:inherit}";
const $02b1de7676d62ddf$var$_22 = "@media (min-width:30rem){._epkxpb1k{border-radius:var(--ds-radius-xlarge,9pt)}}";
const $02b1de7676d62ddf$var$_21 = "@media (min-width:30rem){._we1i1kw7{max-width:inherit}._zg7p130s{box-shadow:var(--ds-shadow-overlay,0 8px 9pt #1e1f2126,0 0 1px #1e1f214f)}._yakv1kw7{margin-inline-end:inherit}._4lht1kw7{margin-inline-start:inherit}._1xlt6m9r._1xlt6m9r{width:var(--modal-dialog-width)}}";
const $02b1de7676d62ddf$var$_20 = "@media screen and (-ms-high-contrast:active),screen and (forced-colors:active){._1cvmnqa1:focus-visible{outline-style:solid}._4davt94y:focus-visible{outline-width:1px}}";
const $02b1de7676d62ddf$var$_19 = "._128mdkaa:focus-visible{outline-width:var(--ds-border-width-focused,2px)}";
const $02b1de7676d62ddf$var$_18 = "._ra3xnqa1:focus-visible{outline-style:solid}";
const $02b1de7676d62ddf$var$_17 = "._1ah3dkaa:focus-visible{outline-offset:var(--ds-border-width-focused,2px)}";
const $02b1de7676d62ddf$var$_16 = "._mizu1v1w:focus-visible{outline-color:var(--ds-border-focused,#4688ec)}";
const $02b1de7676d62ddf$var$_15 = "._1dg11kw7>form:only-child{flex-direction:inherit}";
const $02b1de7676d62ddf$var$_14 = "._m01u1kw7>form:only-child{max-height:inherit}";
const $02b1de7676d62ddf$var$_13 = "._1mq81kw7>form:only-child{display:inherit}";
const $02b1de7676d62ddf$var$_12 = "._lcxv1wug{pointer-events:auto}";
const $02b1de7676d62ddf$var$_11 = "._1q1l1bhr{--ds-elevation-surface-current:var(--ds-surface-overlay,#fff)}";
const $02b1de7676d62ddf$var$_10 = "._syazi7uo{color:var(--ds-text,#292a2e)}";
const $02b1de7676d62ddf$var$_1 = "._bfhk1bhr{background-color:var(--ds-surface-overlay,#fff)}";
const $02b1de7676d62ddf$var$_0 = "._2lx21bp4{flex-direction:column}";
const $02b1de7676d62ddf$var$_9 = "._c71l1kxc{max-height:100vh}";
const $02b1de7676d62ddf$var$_8 = "._1tkeidpf{min-height:0}";
const $02b1de7676d62ddf$var$_7 = "._4t3i1osq{height:100%}";
const $02b1de7676d62ddf$var$_6 = "._p12fauwl{max-width:100vw}";
const $02b1de7676d62ddf$var$_5 = "._1bsb1osq{width:100%}";
const $02b1de7676d62ddf$var$_4 = "._1e0c1txw{display:flex}";
const $02b1de7676d62ddf$var$_3 = "._i0dl1wug{flex-basis:auto}";
const $02b1de7676d62ddf$var$_2 = "._1o9zkb7n{flex-shrink:1}";
const $02b1de7676d62ddf$var$_ = "._16jlidpf{flex-grow:0}";
const $02b1de7676d62ddf$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $02b1de7676d62ddf$var$dialogStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _1bsb1osq _p12fauwl _4t3i1osq _1tkeidpf _c71l1kxc _2lx21bp4 _bfhk1bhr _syazi7uo _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y _we1i1kw7 _zg7p130s _yakv1kw7 _4lht1kw7 _1xlt6m9r",
    borderRadius: "_epkxpb1k",
    motion: "_c71l1kw7 _p12f1kw7 _1e0c1txw _1jyk1jm9 _1if81osq",
    rootMotion: "_yakv1wug _4lht1wug",
    fullscreen: "_1jyk1osq"
};
const $02b1de7676d62ddf$var$viewportScrollStyles = null;
const $02b1de7676d62ddf$var$bodyScrollStyles = null;
const $02b1de7676d62ddf$var$ModalDialog = /*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>{
    const { width: width = 'medium', shouldScrollInViewport: shouldScrollInViewport = false, shouldCloseOnEscapePress: shouldCloseOnEscapePress, autoFocus: autoFocus, UNSAFE__disableInitialAutoFocus: UNSAFE__disableInitialAutoFocus = false, stackIndex: stackIndex, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, height: height, hasProvidedOnClose: hasProvidedOnClose, children: children, label: label, testId: testId, isFullScreen: isFullScreen = false, UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift = false } = props;
    const id = (0, $lHxwq.useId)();
    const titleId = `modal-dialog-title-${id}`;
    const defaultTestId = testId || 'modal-dialog';
    (0, $1v5pe.useEffect)(()=>// Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        (0, $jySDc.combine)((0, $9o1SS.disableDraggingToCrossOriginIFramesForElement)(), (0, $11R2l.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $94IQO.disableDraggingToCrossOriginIFramesForExternal)()), []);
    (0, $Ms2ib.default)(autoFocus, // When a user supplies  a ref to focus we enable this hook
    typeof autoFocus === 'object' && !UNSAFE__disableInitialAutoFocus);
    const [motionRef, onMotionFinish] = (0, $iezB5.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    });
    const modalDialogContext = (0, $1v5pe.useMemo)(()=>({
            testId: defaultTestId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen
        }), [
        defaultTestId,
        titleId,
        onClose,
        hasProvidedOnClose,
        isFullScreen
    ]);
    (0, $gvhLu.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    const { currentLevel: currentLevel } = (0, $ulOZK.useLayering)();
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $gdewX.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: defaultTestId,
        isFullScreen: isFullScreen,
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eSj0I.ModalContext).Provider, {
            value: modalDialogContext,
            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1LjAb.ScrollContext).Provider, {
                value: shouldScrollInViewport,
                children: !UNSAFE_shouldDisableMotionUplift && (0, $2aEiL.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                    children: [
                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                            children: [
                                $02b1de7676d62ddf$var$_,
                                $02b1de7676d62ddf$var$_2,
                                $02b1de7676d62ddf$var$_3,
                                $02b1de7676d62ddf$var$_4,
                                $02b1de7676d62ddf$var$_5,
                                $02b1de7676d62ddf$var$_6,
                                $02b1de7676d62ddf$var$_7,
                                $02b1de7676d62ddf$var$_8,
                                $02b1de7676d62ddf$var$_9,
                                $02b1de7676d62ddf$var$_0,
                                $02b1de7676d62ddf$var$_1,
                                $02b1de7676d62ddf$var$_10,
                                $02b1de7676d62ddf$var$_11,
                                $02b1de7676d62ddf$var$_12,
                                $02b1de7676d62ddf$var$_13,
                                $02b1de7676d62ddf$var$_14,
                                $02b1de7676d62ddf$var$_15,
                                $02b1de7676d62ddf$var$_16,
                                $02b1de7676d62ddf$var$_17,
                                $02b1de7676d62ddf$var$_18,
                                $02b1de7676d62ddf$var$_19,
                                $02b1de7676d62ddf$var$_20,
                                $02b1de7676d62ddf$var$_21,
                                $02b1de7676d62ddf$var$_22,
                                $02b1de7676d62ddf$var$_23,
                                $02b1de7676d62ddf$var$_24,
                                $02b1de7676d62ddf$var$_25,
                                $02b1de7676d62ddf$var$_26,
                                $02b1de7676d62ddf$var$_27,
                                $02b1de7676d62ddf$var$_28
                            ]
                        }),
                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eTbg2.default), {
                            enteringAnimation: "var(--ds-modal-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100)",
                            exitingAnimation: "var(--ds-modal-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95)",
                            onFinish: onMotionFinish,
                            xcss: (0, $ky45w.cx)($02b1de7676d62ddf$var$dialogStyles.motion, isFullScreen && $02b1de7676d62ddf$var$dialogStyles.fullscreen),
                            style: {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-width': (0, $401cB.dialogWidth)(width),
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-height': (0, $7Skuo.dialogHeight)(height)
                            },
                            children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                                children: [
                                    /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                                        children: [
                                            $02b1de7676d62ddf$var$_,
                                            $02b1de7676d62ddf$var$_2,
                                            $02b1de7676d62ddf$var$_3,
                                            $02b1de7676d62ddf$var$_4,
                                            $02b1de7676d62ddf$var$_5,
                                            $02b1de7676d62ddf$var$_6,
                                            $02b1de7676d62ddf$var$_7,
                                            $02b1de7676d62ddf$var$_8,
                                            $02b1de7676d62ddf$var$_9,
                                            $02b1de7676d62ddf$var$_0,
                                            $02b1de7676d62ddf$var$_1,
                                            $02b1de7676d62ddf$var$_10,
                                            $02b1de7676d62ddf$var$_11,
                                            $02b1de7676d62ddf$var$_12,
                                            $02b1de7676d62ddf$var$_13,
                                            $02b1de7676d62ddf$var$_14,
                                            $02b1de7676d62ddf$var$_15,
                                            $02b1de7676d62ddf$var$_16,
                                            $02b1de7676d62ddf$var$_17,
                                            $02b1de7676d62ddf$var$_18,
                                            $02b1de7676d62ddf$var$_19,
                                            $02b1de7676d62ddf$var$_20,
                                            $02b1de7676d62ddf$var$_21,
                                            $02b1de7676d62ddf$var$_22,
                                            $02b1de7676d62ddf$var$_23,
                                            $02b1de7676d62ddf$var$_24,
                                            $02b1de7676d62ddf$var$_25,
                                            $02b1de7676d62ddf$var$_26,
                                            $02b1de7676d62ddf$var$_27,
                                            $02b1de7676d62ddf$var$_28,
                                            $02b1de7676d62ddf$var$_29,
                                            $02b1de7676d62ddf$var$_30,
                                            $02b1de7676d62ddf$var$_31,
                                            $02b1de7676d62ddf$var$_32
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $kIqwl.jsx)("section", {
                                        "aria-label": label,
                                        ref: (0, $fl4ll.default)([
                                            motionRef,
                                            ref
                                        ]),
                                        style: {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                            '--modal-dialog-width': (0, $401cB.dialogWidth)(width),
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                            '--modal-dialog-height': (0, $7Skuo.dialogHeight)(height)
                                        },
                                        role: "dialog",
                                        "aria-labelledby": label ? undefined : titleId,
                                        "data-testid": defaultTestId,
                                        "data-modal-stack": stackIndex,
                                        tabIndex: -1,
                                        "aria-modal": true,
                                        "data-ds--level": currentLevel,
                                        className: (0, $hMvDh.default)([
                                            $02b1de7676d62ddf$var$dialogStyles.root,
                                            $02b1de7676d62ddf$var$dialogStyles.rootMotion,
                                            !isFullScreen && $02b1de7676d62ddf$var$dialogStyles.borderRadius,
                                            shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7"
                                        ]),
                                        children: children
                                    })
                                ]
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $kIqwl.jsx)((0, $etMwD.default /**
                                       * We don't want a 'slide in' for the full screen modals.
                                       */ ), {
                    entranceDirection: isFullScreen ? undefined : 'bottom',
                    onFinish: onMotionFinish,
                    children: (bottomFadeInProps)=>/*#__PURE__*/ // TODO: Use `dialog` element instead of overriding section semantics (DSP-11588)
                        (0, $kIqwl.jsxs)((0, $2T805.default), {
                            children: [
                                /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                                    children: [
                                        $02b1de7676d62ddf$var$_,
                                        $02b1de7676d62ddf$var$_2,
                                        $02b1de7676d62ddf$var$_3,
                                        $02b1de7676d62ddf$var$_4,
                                        $02b1de7676d62ddf$var$_5,
                                        $02b1de7676d62ddf$var$_6,
                                        $02b1de7676d62ddf$var$_7,
                                        $02b1de7676d62ddf$var$_8,
                                        $02b1de7676d62ddf$var$_9,
                                        $02b1de7676d62ddf$var$_0,
                                        $02b1de7676d62ddf$var$_1,
                                        $02b1de7676d62ddf$var$_10,
                                        $02b1de7676d62ddf$var$_11,
                                        $02b1de7676d62ddf$var$_12,
                                        $02b1de7676d62ddf$var$_13,
                                        $02b1de7676d62ddf$var$_14,
                                        $02b1de7676d62ddf$var$_15,
                                        $02b1de7676d62ddf$var$_16,
                                        $02b1de7676d62ddf$var$_17,
                                        $02b1de7676d62ddf$var$_18,
                                        $02b1de7676d62ddf$var$_19,
                                        $02b1de7676d62ddf$var$_20,
                                        $02b1de7676d62ddf$var$_21,
                                        $02b1de7676d62ddf$var$_22,
                                        $02b1de7676d62ddf$var$_23,
                                        $02b1de7676d62ddf$var$_24,
                                        $02b1de7676d62ddf$var$_25,
                                        $02b1de7676d62ddf$var$_26,
                                        $02b1de7676d62ddf$var$_27,
                                        $02b1de7676d62ddf$var$_28,
                                        $02b1de7676d62ddf$var$_29,
                                        $02b1de7676d62ddf$var$_30,
                                        $02b1de7676d62ddf$var$_31,
                                        $02b1de7676d62ddf$var$_32
                                    ]
                                }),
                                /*#__PURE__*/ (0, $kIqwl.jsx)("section", {
                                    ...bottomFadeInProps,
                                    "aria-label": label,
                                    ref: (0, $fl4ll.default)([
                                        bottomFadeInProps.ref,
                                        motionRef,
                                        ref
                                    ]),
                                    style: {
                                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                        '--modal-dialog-width': (0, $401cB.dialogWidth)(width),
                                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                        '--modal-dialog-height': (0, $7Skuo.dialogHeight)(height)
                                    } // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                                    ,
                                    className: (0, $hMvDh.default)([
                                        $02b1de7676d62ddf$var$dialogStyles.root,
                                        !isFullScreen && $02b1de7676d62ddf$var$dialogStyles.borderRadius,
                                        shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7",
                                        bottomFadeInProps.className
                                    ]),
                                    role: "dialog",
                                    "aria-labelledby": label ? undefined : titleId,
                                    "data-testid": defaultTestId,
                                    "data-modal-stack": stackIndex,
                                    tabIndex: -1,
                                    "aria-modal": true,
                                    "data-ds--level": currentLevel,
                                    children: children
                                })
                            ]
                        })
                })
            })
        })
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc, @atlaskit/volt-strict-mode/no-multiple-exports
$02b1de7676d62ddf$export$2e2bcd8739ae039 = $02b1de7676d62ddf$var$ModalDialog;

});
parcelRegister("gvhLu", function(module, exports) {
$parcel$export(module.exports, "useCloseOnEscapePress", () => $341446a597c0fbe0$export$4a4bf067ea9e7886);

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $ulOZK = parcelRequire("ulOZK");
const $341446a597c0fbe0$var$ESCAPE = 'Escape';
function $341446a597c0fbe0$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled, isEnabled: isEnabled = true }) {
    const escapePressed = (0, $1v5pe.useRef)(false);
    const { isLayerDisabled: isLayerDisabled } = (0, $ulOZK.useLayering)({
        isEnabled: isEnabled
    });
    const onKeyDown = (0, $1v5pe.useCallback)((e)=>{
        const isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $341446a597c0fbe0$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    const onKeyUp = (0, $1v5pe.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $1v5pe.useEffect)(()=>{
        if (!isEnabled) return;
        return (0, $dmmsG.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        isEnabled,
        onKeyDown,
        onKeyUp
    ]);
}

});
parcelRegister("ulOZK", function(module, exports) {
$parcel$export(module.exports, "useLayering", () => $9e3894507ec5fed7$export$c8b4d54e03dee6ed);

var $1v5pe = parcelRequire("1v5pe");

var $k2kmX = parcelRequire("k2kmX");

var $99aSv = parcelRequire("99aSv");

var $8P9x3 = parcelRequire("8P9x3");
function $9e3894507ec5fed7$export$c8b4d54e03dee6ed({ isEnabled: isEnabled = true } = {}) {
    const levelFromContext = (0, $1v5pe.useContext)((0, $k2kmX.LevelContext));
    const currentLevel = isEnabled ? levelFromContext : 0;
    const layerNode = (0, $1v5pe.useContext)((0, $99aSv.LevelNodeContext));
    const rootNode = (0, $1v5pe.useContext)((0, $8P9x3.RootNodeContext));
    const isLayerDisabled = (0, $1v5pe.useCallback)(()=>{
        if (!isEnabled) return false;
        // This is an impossible case, added for type safety
        if (!layerNode?.current || !rootNode?.current) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        isEnabled,
        layerNode,
        rootNode
    ]);
    const getTopLevel = (0, $1v5pe.useCallback)(()=>{
        if (!isEnabled) return null;
        return rootNode?.current ? rootNode.current.getHeight() : null;
    }, [
        isEnabled,
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});


parcelRegister("iezB5", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff249416ebf3536e$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");
function $ff249416ebf3536e$export$2e2bcd8739ae039({ onOpenComplete: onOpenComplete, onCloseComplete: onCloseComplete }) {
    const motionRef = (0, $1v5pe.useRef)(null);
    const onMotionFinish = (0, $1v5pe.useCallback)((state)=>{
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("7Skuo", function(module, exports) {
$parcel$export(module.exports, "dialogHeight", () => $5f06d14dd588ddce$export$ceba93bf0bdd16f2);
const $5f06d14dd588ddce$export$ceba93bf0bdd16f2 = (input)=>{
    if (!input) return 'auto';
    return typeof input === 'number' ? `${input}px` : input;
};

});

parcelRegister("401cB", function(module, exports) {
$parcel$export(module.exports, "dialogWidth", () => $32d58c5d43ea6efd$export$a3da89b899389ed8);

var $8KJ3R = parcelRequire("8KJ3R");
const $32d58c5d43ea6efd$export$a3da89b899389ed8 = (input)=>{
    if (!input) return 'auto';
    const isWidthName = (0, $8KJ3R.width).values.indexOf(input.toString()) !== -1;
    const widthName = isWidthName && input;
    if (widthName) return `${(0, $8KJ3R.width).widths[widthName]}px`;
    return typeof input === 'number' ? `${input}px` : input;
};

});

parcelRegister("gdewX", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c9703ffa567416f$export$2e2bcd8739ae039);
/* positioner.tsx generated by @compiled/babel-plugin v3.0.2 */ parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $aWQrI = parcelRequire("aWQrI");

var $bKulK = parcelRequire("bKulK");

var $kIqwl = parcelRequire("kIqwl");
const $2c9703ffa567416f$var$_15 = "@media (min-width:30rem){._we1i18uh{max-width:calc(100vw - 90pt)}._e8uozwhf{max-height:calc(100vh - 119px)}._y1k5stnw{position:absolute}._5ee41nf8{inset-block-start:60px!important}._1urridpf{inset-inline-end:0}._1juqidpf{inset-inline-start:0}._yakv1wug{margin-inline-end:auto}._4lht1wug{margin-inline-start:auto}._eoawglyw{pointer-events:none}}";
const $2c9703ffa567416f$var$_14 = "@media (min-width:30rem){._1f6n1wqb{margin-block:60px}._1eot1wug{margin-inline:auto}._eoawglyw{pointer-events:none}}";
const $2c9703ffa567416f$var$_13 = "._kqswh2mm{position:relative}";
const $2c9703ffa567416f$var$_12 = "._4t3i1wug{height:auto}";
const $2c9703ffa567416f$var$_11 = "._t9ecglyw{transform:none}";
const $2c9703ffa567416f$var$_10 = "._t9ec1b95{transform:translateY(var(--modal-dialog-translate-y))}";
const $2c9703ffa567416f$var$_1 = "@media (prefers-reduced-motion:reduce){._1bumglyw{animation:none}._sedtglyw{transition:none}}";
const $2c9703ffa567416f$var$_0 = "._k8m01e03{transition-property:transform}";
const $2c9703ffa567416f$var$_9 = "._1e02idpf{inset-inline-start:0}";
const $2c9703ffa567416f$var$_8 = "._152tidpf{inset-block-start:0}";
const $2c9703ffa567416f$var$_7 = "._2lx21bp4{flex-direction:column}";
const $2c9703ffa567416f$var$_6 = "._1pby16oo{z-index:510}";
const $2c9703ffa567416f$var$_5 = "._kqsw1n9t{position:fixed}";
const $2c9703ffa567416f$var$_4 = "._4t3i1osq{height:100%}";
const $2c9703ffa567416f$var$_3 = "._p12f1osq{max-width:100%}";
const $2c9703ffa567416f$var$_2 = "._1bsb1osq{width:100%}";
const $2c9703ffa567416f$var$_ = "._1e0c1txw{display:flex}";
const $2c9703ffa567416f$var$positionerStyles = null;
const $2c9703ffa567416f$var$stackStyles = {
    stackTransition: "_k8m01e03 _1bumglyw _sedtglyw",
    stackTransform: "_t9ec1b95",
    stackIdle: "_t9ecglyw"
};
// Hardcoded pixels are based off a 60px base gutter
const $2c9703ffa567416f$var$scrollStyles = {
    viewport: "_4t3i1wug _kqswh2mm _1f6n1wqb _1eot1wug _eoawglyw",
    body: "_we1i18uh _e8uozwhf _y1k5stnw _5ee41nf8 _1urridpf _1juqidpf _yakv1wug _4lht1wug _eoawglyw",
    fullScreen: ""
};
function $2c9703ffa567416f$var$getScrollBehavior({ isFullScreen: isFullScreen, shouldScrollInViewport: shouldScrollInViewport }) {
    if (isFullScreen) return 'fullScreen';
    if (shouldScrollInViewport) return 'viewport';
    return 'body';
}
const $2c9703ffa567416f$var$Positioner = (props)=>{
    const { children: children, stackIndex: stackIndex, shouldScrollInViewport: shouldScrollInViewport, testId: testId, isFullScreen: isFullScreen } = props;
    const scrollBehavior = $2c9703ffa567416f$var$getScrollBehavior({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $2c9703ffa567416f$var$_,
                    $2c9703ffa567416f$var$_2,
                    $2c9703ffa567416f$var$_3,
                    $2c9703ffa567416f$var$_4,
                    $2c9703ffa567416f$var$_5,
                    $2c9703ffa567416f$var$_6,
                    $2c9703ffa567416f$var$_7,
                    $2c9703ffa567416f$var$_8,
                    $2c9703ffa567416f$var$_9,
                    $2c9703ffa567416f$var$_0,
                    $2c9703ffa567416f$var$_1,
                    $2c9703ffa567416f$var$_10,
                    $2c9703ffa567416f$var$_11,
                    $2c9703ffa567416f$var$_12,
                    $2c9703ffa567416f$var$_13,
                    $2c9703ffa567416f$var$_14,
                    $2c9703ffa567416f$var$_15
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                style: {
                    '--modal-dialog-translate-y': `calc(${stackIndex}px * ${"var(--ds-space-100, 8px)"})`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    transitionDuration: `${(0, $bKulK.durations).medium}ms`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    transitionTimingFunction: (0, $aWQrI.easeInOut)
                },
                "data-testid": testId && `${testId}--positioner`,
                className: (0, $hMvDh.default)([
                    "_1e0c1txw _1bsb1osq _p12f1osq _4t3i1osq _kqsw1n9t _1pby16oo _2lx21bp4 _152tidpf _1e02idpf",
                    $2c9703ffa567416f$var$stackStyles.stackTransition,
                    stackIndex > 0 ? $2c9703ffa567416f$var$stackStyles.stackTransform : $2c9703ffa567416f$var$stackStyles.stackIdle,
                    $2c9703ffa567416f$var$scrollStyles[scrollBehavior]
                ]),
                children: children
            })
        ]
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $2c9703ffa567416f$export$2e2bcd8739ae039 = $2c9703ffa567416f$var$Positioner;

});
parcelRegister("aWQrI", function(module, exports) {
$parcel$export(module.exports, "easeInOut", () => $14e15c2ec5f243f6$export$c07234257a03d5e9);
const $14e15c2ec5f243f6$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $14e15c2ec5f243f6$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $14e15c2ec5f243f6$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $14e15c2ec5f243f6$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
const $14e15c2ec5f243f6$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
const $14e15c2ec5f243f6$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
const $14e15c2ec5f243f6$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

});





parcelRegister("VkTYT", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0ac589ac0a8d0d7e$var$ReactIs, $0ac589ac0a8d0d7e$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("atFq8"))();

});
parcelRegister("atFq8", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $7IFBr = parcelRequire("7IFBr");
function $7a0cbe10261dc603$var$emptyFunction() {}
function $7a0cbe10261dc603$var$emptyFunctionWithReset() {}
$7a0cbe10261dc603$var$emptyFunctionWithReset.resetWarningCache = $7a0cbe10261dc603$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7IFBr) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $7a0cbe10261dc603$var$emptyFunctionWithReset,
        resetWarningCache: $7a0cbe10261dc603$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7IFBr", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $59ece9f03da6ea40$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $59ece9f03da6ea40$var$ReactPropTypesSecret;

});



parcelRegister("epvFM", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf691c5b993c3527$export$2e2bcd8739ae039);
/* modal-footer.tsx generated by @compiled/babel-plugin v3.0.2 */ parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $bCJu2 = parcelRequire("bCJu2");

var $kIqwl = parcelRequire("kIqwl");
const $bf691c5b993c3527$var$_9 = "._1q51pxbi{padding-block-start:var(--ds-space-200,1pc)}";
const $bf691c5b993c3527$var$_8 = "._85i51ejb{padding-block-end:var(--ds-space-300,24px)}";
const $bf691c5b993c3527$var$_7 = "._1pfh1i6y{margin-block-start:var(--ds-space-negative-025,-2px)}";
const $bf691c5b993c3527$var$_6 = "._1bahesu3{justify-content:flex-end}";
const $bf691c5b993c3527$var$_5 = "._4cvr1h6o{align-items:center}";
const $bf691c5b993c3527$var$_4 = "._kqswh2mm{position:relative}";
const $bf691c5b993c3527$var$_3 = "._1e0c1txw{display:flex}";
const $bf691c5b993c3527$var$_2 = "._18zr1ejb{padding-inline:var(--ds-space-300,24px)}";
const $bf691c5b993c3527$var$_ = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const $bf691c5b993c3527$var$footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $bf691c5b993c3527$var$ModalFooter = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $bCJu2.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $bf691c5b993c3527$var$_,
                    $bf691c5b993c3527$var$_2,
                    $bf691c5b993c3527$var$_3,
                    $bf691c5b993c3527$var$_4,
                    $bf691c5b993c3527$var$_5,
                    $bf691c5b993c3527$var$_6,
                    $bf691c5b993c3527$var$_7,
                    $bf691c5b993c3527$var$_8,
                    $bf691c5b993c3527$var$_9
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                "data-testid": testId,
                className: (0, $hMvDh.default)([
                    "_zulpu2gc _18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bahesu3 _1pfh1i6y _85i51ejb _1q51pxbi"
                ]),
                children: children
            })
        ]
    });
};
var $bf691c5b993c3527$export$2e2bcd8739ae039 = $bf691c5b993c3527$var$ModalFooter;

});

parcelRegister("ileP7", function(module, exports) {
$parcel$export(module.exports, "default", () => $9dff571ff7d4c2f3$export$2e2bcd8739ae039);
/* modal-header.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");
parcelRequire("1v5pe");

var $iZBEG = parcelRequire("iZBEG");

var $cOGx6 = parcelRequire("cOGx6");

var $bCJu2 = parcelRequire("bCJu2");

var $kIqwl = parcelRequire("kIqwl");
const $9dff571ff7d4c2f3$var$_1 = "._1ul9idpf{min-width:0}";
const $9dff571ff7d4c2f3$var$_0 = "._1bsb1osq{width:100%}";
const $9dff571ff7d4c2f3$var$_9 = "._2lx21sbv{flex-direction:row-reverse}";
const $9dff571ff7d4c2f3$var$_8 = "._1q511ejb{padding-block-start:var(--ds-space-300,24px)}";
const $9dff571ff7d4c2f3$var$_7 = "._85i5pxbi{padding-block-end:var(--ds-space-200,1pc)}";
const $9dff571ff7d4c2f3$var$_6 = "._6rth1i6y{margin-block-end:var(--ds-space-negative-025,-2px)}";
const $9dff571ff7d4c2f3$var$_5 = "._1bah1yb4{justify-content:space-between}";
const $9dff571ff7d4c2f3$var$_4 = "._4cvr1h6o{align-items:center}";
const $9dff571ff7d4c2f3$var$_3 = "._kqswh2mm{position:relative}";
const $9dff571ff7d4c2f3$var$_2 = "._1e0c1txw{display:flex}";
const $9dff571ff7d4c2f3$var$_ = "._18zr1ejb{padding-inline:var(--ds-space-300,24px)}";
const $9dff571ff7d4c2f3$var$styles = {
    header: "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rth1i6y _85i5pxbi _1q511ejb",
    flex: "_2lx21sbv _1bsb1osq",
    titleContainer: "_1ul9idpf"
};
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $9dff571ff7d4c2f3$var$ModalHeader = (props)=>{
    const { children: children, testId: userDefinedTestId, hasCloseButton: hasCloseButton = false, closeButtonLabel: closeButtonLabel } = props;
    const { hasProvidedOnClose: hasProvidedOnClose, onClose: onClose, testId: modalTestId } = (0, $bCJu2.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--header`; // Only show if an onClose was provided for the modal dialog
    const shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $9dff571ff7d4c2f3$var$_,
                    $9dff571ff7d4c2f3$var$_2,
                    $9dff571ff7d4c2f3$var$_3,
                    $9dff571ff7d4c2f3$var$_4,
                    $9dff571ff7d4c2f3$var$_5,
                    $9dff571ff7d4c2f3$var$_6,
                    $9dff571ff7d4c2f3$var$_7,
                    $9dff571ff7d4c2f3$var$_8,
                    $9dff571ff7d4c2f3$var$_9,
                    $9dff571ff7d4c2f3$var$_0,
                    $9dff571ff7d4c2f3$var$_1
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                "data-testid": testId,
                className: (0, $hMvDh.default)([
                    $9dff571ff7d4c2f3$var$styles.header
                ]),
                children: shouldShowCloseButton ? /*#__PURE__*/ // The reason we are putting the close button first in the DOM and then
                // reordering them is to ensure that users of assistive technology get
                // all the context of a modal when initial focus is placed on the close
                // button, since it's the first interactive element.
                (0, $kIqwl.jsxs)((0, $2T805.default), {
                    children: [
                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                            children: [
                                $9dff571ff7d4c2f3$var$_,
                                $9dff571ff7d4c2f3$var$_2,
                                $9dff571ff7d4c2f3$var$_3,
                                $9dff571ff7d4c2f3$var$_4,
                                $9dff571ff7d4c2f3$var$_5,
                                $9dff571ff7d4c2f3$var$_6,
                                $9dff571ff7d4c2f3$var$_7,
                                $9dff571ff7d4c2f3$var$_8,
                                $9dff571ff7d4c2f3$var$_9,
                                $9dff571ff7d4c2f3$var$_0,
                                $9dff571ff7d4c2f3$var$_1
                            ]
                        }),
                        /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $iZBEG.Flex), {
                            gap: "space.200",
                            justifyContent: "space-between",
                            xcss: $9dff571ff7d4c2f3$var$styles.flex,
                            children: [
                                /*#__PURE__*/ (0, $kIqwl.jsx)((0, $iZBEG.Flex), {
                                    justifyContent: "end",
                                    children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cOGx6.CloseButton), {
                                        label: closeButtonLabel,
                                        onClick: onClose,
                                        testId: modalTestId
                                    })
                                }),
                                /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                                            children: [
                                                $9dff571ff7d4c2f3$var$_,
                                                $9dff571ff7d4c2f3$var$_2,
                                                $9dff571ff7d4c2f3$var$_3,
                                                $9dff571ff7d4c2f3$var$_4,
                                                $9dff571ff7d4c2f3$var$_5,
                                                $9dff571ff7d4c2f3$var$_6,
                                                $9dff571ff7d4c2f3$var$_7,
                                                $9dff571ff7d4c2f3$var$_8,
                                                $9dff571ff7d4c2f3$var$_9,
                                                $9dff571ff7d4c2f3$var$_0,
                                                $9dff571ff7d4c2f3$var$_1
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $iZBEG.Flex), {
                                            justifyContent: "start",
                                            alignItems: "center",
                                            xcss: $9dff571ff7d4c2f3$var$styles.titleContainer,
                                            children: children
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : children
            })
        ]
    });
};
var $9dff571ff7d4c2f3$export$2e2bcd8739ae039 = $9dff571ff7d4c2f3$var$ModalHeader;

});

parcelRegister("5YVPC", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ff497ee297d997d$export$2e2bcd8739ae039);
/* modal-title.tsx generated by @compiled/babel-plugin v3.0.2 */ parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $4saCT = parcelRequire("4saCT");

var $1LQZ9 = parcelRequire("1LQZ9");

var $bCJu2 = parcelRequire("bCJu2");

var $kIqwl = parcelRequire("kIqwl");
const $9ff497ee297d997d$var$_22 = "._o5721q9c{white-space:nowrap}";
const $9ff497ee297d997d$var$_21 = "._1bto1l2s{text-overflow:ellipsis}";
const $9ff497ee297d997d$var$_20 = "._18m915vq{overflow-y:hidden}";
const $9ff497ee297d997d$var$_19 = "._1reo15vq{overflow-x:hidden}";
const $9ff497ee297d997d$var$_18 = "._slp31hna{word-wrap:break-word}";
const $9ff497ee297d997d$var$_17 = "._1o9zkb7n{flex-shrink:1}";
const $9ff497ee297d997d$var$_16 = "._16jlkb7n{flex-grow:1}";
const $9ff497ee297d997d$var$_15 = "._ahbqze3t{margin-inline-start:var(--ds-space-0,0)}";
const $9ff497ee297d997d$var$_14 = "._12l2ze3t{margin-inline-end:var(--ds-space-0,0)}";
const $9ff497ee297d997d$var$_13 = "._1pfhze3t{margin-block-start:var(--ds-space-0,0)}";
const $9ff497ee297d997d$var$_12 = "._6rthze3t{margin-block-end:var(--ds-space-0,0)}";
const $9ff497ee297d997d$var$_11 = "._1ul9idpf{min-width:0}";
const $9ff497ee297d997d$var$_10 = "._1e0c1txw{display:flex}";
const $9ff497ee297d997d$var$_1 = "._11c81af2{font:var(--ds-font-heading-medium,normal 653 20px/24px \"Atlassian Sans\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const $9ff497ee297d997d$var$_0 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const $9ff497ee297d997d$var$_9 = "._vwz41kw7{line-height:inherit}";
const $9ff497ee297d997d$var$_8 = "._1dyz1kw7{letter-spacing:inherit}";
const $9ff497ee297d997d$var$_7 = "._k48p1kw7{font-weight:inherit}";
const $9ff497ee297d997d$var$_6 = "._zg8l1kw7{font-style:inherit}";
const $9ff497ee297d997d$var$_5 = "._1wyb1kw7{font-size:inherit}";
const $9ff497ee297d997d$var$_4 = "._syaz1kw7{color:inherit}";
const $9ff497ee297d997d$var$_3 = "._i0dl1wug{flex-basis:auto}";
const $9ff497ee297d997d$var$_2 = "._1o9zidpf{flex-shrink:0}";
const $9ff497ee297d997d$var$_ = "._16jlidpf{flex-grow:0}";
const $9ff497ee297d997d$var$iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E06C00)"
};
const $9ff497ee297d997d$var$iconStyles = null;
const $9ff497ee297d997d$var$titleStyles = null;
const $9ff497ee297d997d$var$textStyles = null;
const $9ff497ee297d997d$var$truncatedTextStyles = null;
const $9ff497ee297d997d$var$TitleIcon = ({ appearance: appearance })=>{
    const Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($4saCT))) : (0, (/*@__PURE__*/$parcel$interopDefault($1LQZ9)));
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $9ff497ee297d997d$var$_,
                    $9ff497ee297d997d$var$_2,
                    $9ff497ee297d997d$var$_3,
                    $9ff497ee297d997d$var$_4,
                    $9ff497ee297d997d$var$_5,
                    $9ff497ee297d997d$var$_6,
                    $9ff497ee297d997d$var$_7,
                    $9ff497ee297d997d$var$_8,
                    $9ff497ee297d997d$var$_9
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
                className: (0, $hMvDh.default)([
                    "_16jlidpf _1o9zidpf _i0dl1wug _syaz1kw7 _1wyb1kw7 _zg8l1kw7 _k48p1kw7 _1dyz1kw7 _vwz41kw7"
                ]),
                children: /*#__PURE__*/ (0, $kIqwl.jsx)(Icon, {
                    label: appearance,
                    color: $9ff497ee297d997d$var$iconColor[appearance],
                    spacing: "spacious"
                })
            })
        ]
    });
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $9ff497ee297d997d$var$ModalTitle = (props)=>{
    const { appearance: appearance, children: children, isMultiline: isMultiline = true, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $bCJu2.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/use-heading
    (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $9ff497ee297d997d$var$_0,
                    $9ff497ee297d997d$var$_1,
                    $9ff497ee297d997d$var$_10,
                    $9ff497ee297d997d$var$_11,
                    $9ff497ee297d997d$var$_12,
                    $9ff497ee297d997d$var$_13,
                    $9ff497ee297d997d$var$_14,
                    $9ff497ee297d997d$var$_15
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsxs)("h1", {
                "data-testid": testId,
                className: (0, $hMvDh.default)([
                    "_zulpu2gc _11c81af2 _1e0c1txw _1ul9idpf _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t"
                ]),
                children: [
                    appearance && /*#__PURE__*/ (0, $kIqwl.jsx)($9ff497ee297d997d$var$TitleIcon, {
                        appearance: appearance
                    }),
                    /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                        children: [
                            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                                children: [
                                    $9ff497ee297d997d$var$_16,
                                    $9ff497ee297d997d$var$_17,
                                    $9ff497ee297d997d$var$_3,
                                    $9ff497ee297d997d$var$_1,
                                    $9ff497ee297d997d$var$_11,
                                    $9ff497ee297d997d$var$_18,
                                    $9ff497ee297d997d$var$_19,
                                    $9ff497ee297d997d$var$_20,
                                    $9ff497ee297d997d$var$_21,
                                    $9ff497ee297d997d$var$_22
                                ]
                            }),
                            /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
                                id: titleId,
                                "data-testid": testId && `${testId}-text`,
                                className: (0, $hMvDh.default)([
                                    "_16jlkb7n _1o9zkb7n _i0dl1wug _11c81af2 _1ul9idpf _slp31hna",
                                    !isMultiline && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                                ]),
                                children: children
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
var $9ff497ee297d997d$export$2e2bcd8739ae039 = $9ff497ee297d997d$var$ModalTitle;

});

parcelRegister("8O99O", function(module, exports) {
$parcel$export(module.exports, "default", () => $b04ddaa5ae898796$export$2e2bcd8739ae039);
parcelRequire("1v5pe");

var $7dKqR = parcelRequire("7dKqR");

var $kIqwl = parcelRequire("kIqwl");
const $b04ddaa5ae898796$var$ModalTransition = (props)=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7dKqR.default), {
        appear: true,
        children: //Checking if children are undefined to prevent potential runtime errors in React 17
        props.children ?? null
    });
};
var $b04ddaa5ae898796$export$2e2bcd8739ae039 = $b04ddaa5ae898796$var$ModalTransition;

});

parcelRegister("hpF1c", function(module, exports) {
$parcel$export(module.exports, "Anchor", () => $557ae7da41ae2f27$export$b688253958b8dfe7);
$parcel$export(module.exports, "default", () => $557ae7da41ae2f27$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $hRuTh = parcelRequire("hRuTh");

var $cwFVG = parcelRequire("cwFVG");

var $j9QYE = parcelRequire("j9QYE");

var $9SOWu = parcelRequire("9SOWu");

var $aD9yk = parcelRequire("aD9yk");

var $lHxwq = parcelRequire("lHxwq");

var $7qISg = parcelRequire("7qISg");

var $kFr83 = parcelRequire("kFr83");

var $77s18 = parcelRequire("77s18");

var $kVvu0 = parcelRequire("kVvu0");

var $ipf3f = parcelRequire("ipf3f");

var $cpDmm = parcelRequire("cpDmm");

var $4Iv3g = parcelRequire("4Iv3g");

var $9QsMz = parcelRequire("9QsMz");
function $557ae7da41ae2f27$var$_extends() {
    return $557ae7da41ae2f27$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $557ae7da41ae2f27$var$_extends.apply(null, arguments);
}
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $557ae7da41ae2f27$var$focusRingStyles = (0, $hRuTh.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $kVvu0.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $9QsMz.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $ipf3f.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $ipf3f.borderWidthMap)['border.width']} solid`
        }
    }
});
const $557ae7da41ae2f27$var$baseStyles = (0, $hRuTh.css)({
    boxSizing: 'border-box',
    textDecoration: 'underline'
});
const $557ae7da41ae2f27$var$positionStyles = (0, $hRuTh.css)({
    position: 'relative'
});
const $557ae7da41ae2f27$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $557ae7da41ae2f27$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
const $557ae7da41ae2f27$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $557ae7da41ae2f27$var$AnchorNoRef = ({ href: href, children: children, backgroundColor: backgroundColor, newWindowLabel: newWindowLabel, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, onClick: providedOnClick = (0, $aD9yk.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $1v5pe.useContext)((0, $7qISg.default));
    const handleClick = (0, $1v5pe.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $lHxwq.useId)();
    const onClick = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $4Iv3g.parseXcss)(xcss);
    const RouterLink = (0, $9SOWu.useRouterLink)();
    const isExternal = typeof href === 'string' && $557ae7da41ae2f27$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $557ae7da41ae2f27$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $cwFVG.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return (0, $hRuTh.jsx)(Component, $557ae7da41ae2f27$var$_extends({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? //`${ariaLabel} ${OPENS_NEW_WINDOW_LABEL}`
        `${ariaLabel} , ${newWindowLabel ? newWindowLabel : $557ae7da41ae2f27$var$OPENS_NEW_WINDOW_LABEL}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        css: [
            $557ae7da41ae2f27$var$baseStyles,
            $557ae7da41ae2f27$var$positionStyles,
            $557ae7da41ae2f27$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $77s18.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $cpDmm.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $cpDmm.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $cpDmm.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $cpDmm.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $cpDmm.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $cpDmm.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $cpDmm.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && (0, $hRuTh.jsx)((0, $kFr83.default), {
        id: opensNewWindowLabelId
    }, `, ${newWindowLabel ? newWindowLabel : $557ae7da41ae2f27$var$OPENS_NEW_WINDOW_LABEL}`));
};
const $557ae7da41ae2f27$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $1v5pe.forwardRef)($557ae7da41ae2f27$var$AnchorNoRef);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$557ae7da41ae2f27$export$2e2bcd8739ae039 = $557ae7da41ae2f27$export$b688253958b8dfe7;

});
parcelRegister("9SOWu", function(module, exports) {
$parcel$export(module.exports, "useRouterLink", () => $c46ce239cbf7150b$export$6d558eab13290f59);

var $1v5pe = parcelRequire("1v5pe");

var $93598 = parcelRequire("93598");
const $c46ce239cbf7150b$export$6d558eab13290f59 = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $1v5pe.useContext)((0, $93598.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};

});
parcelRegister("93598", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", () => $badba70c46ee795d$export$2931e0ee690eee88);
$parcel$export(module.exports, "default", () => $badba70c46ee795d$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $kIqwl = parcelRequire("kIqwl");
const $badba70c46ee795d$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $1v5pe.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $badba70c46ee795d$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)($badba70c46ee795d$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$badba70c46ee795d$export$2e2bcd8739ae039 = $badba70c46ee795d$var$RouterLinkProvider;

});



parcelRegister("fRfXo", function(module, exports) {
$parcel$export(module.exports, "Text", () => $3a57f23ecb15575a$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "default", () => $3a57f23ecb15575a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hRuTh = parcelRequire("hRuTh");

var $cwFVG = parcelRequire("cwFVG");

var $5bXLq = parcelRequire("5bXLq");

var $3WrNu = parcelRequire("3WrNu");

var $4tWUL = parcelRequire("4tWUL");

var $8N3pK = parcelRequire("8N3pK");

var $19JGr = parcelRequire("19JGr");

var $iptls = parcelRequire("iptls");

var $9dWx4 = parcelRequire("9dWx4");
const $3a57f23ecb15575a$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
const $3a57f23ecb15575a$var$resetStyles = (0, $hRuTh.css)({
    margin: 0,
    overflowWrap: 'anywhere'
});
const $3a57f23ecb15575a$var$strongStyles = (0, $hRuTh.css)({
    fontWeight: "var(--ds-font-weight-bold, 653)"
});
const $3a57f23ecb15575a$var$emStyles = (0, $hRuTh.css)({
    fontStyle: 'italic'
});
const $3a57f23ecb15575a$var$textAlignMap = {
    center: (0, $hRuTh.css)({
        textAlign: 'center'
    }),
    end: (0, $hRuTh.css)({
        textAlign: 'end'
    }),
    start: (0, $hRuTh.css)({
        textAlign: 'start'
    })
};
const $3a57f23ecb15575a$var$truncationStyles = (0, $hRuTh.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
const $3a57f23ecb15575a$var$wordBreakMap = {
    breakAll: (0, $hRuTh.css)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $3a57f23ecb15575a$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $3WrNu.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $8N3pK.inverseColorMap).hasOwnProperty(surface)) return (0, $8N3pK.inverseColorMap)[surface];
    return 'color.text';
};
const $3a57f23ecb15575a$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, children: children }, ref)=>{
    (0, $cwFVG.default)($3a57f23ecb15575a$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $4tWUL.useHasTextAncestor)();
    const color = $3a57f23ecb15575a$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = (0, $hRuTh.jsx)(Component, {
        ref: ref,
        css: [
            $3a57f23ecb15575a$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $iptls.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $19JGr.textColorStylesMap)[color],
            maxLines && $3a57f23ecb15575a$var$truncationStyles,
            maxLines === 1 && $3a57f23ecb15575a$var$wordBreakMap.breakAll,
            align && $3a57f23ecb15575a$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $9dWx4.textWeightStylesMap)[weight],
            Component === 'em' && $3a57f23ecb15575a$var$emStyles,
            Component === 'strong' && $3a57f23ecb15575a$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $hRuTh.jsx)((0, $5bXLq.HasTextAncestorProvider), {
        value: true
    }, component);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$3a57f23ecb15575a$export$2e2bcd8739ae039 = $3a57f23ecb15575a$export$5f1af8db9871e1d6;

});
parcelRegister("5bXLq", function(module, exports) {
$parcel$export(module.exports, "HasTextAncestorProvider", () => $3494ba966a51c987$export$ae933c6cbe5643ad);

var $9y0mv = parcelRequire("9y0mv");
const $3494ba966a51c987$export$ae933c6cbe5643ad = (0, $9y0mv.HasTextAncestorContext).Provider;

});
parcelRegister("9y0mv", function(module, exports) {
$parcel$export(module.exports, "HasTextAncestorContext", () => $54d43cc3defd5ad5$export$19538d0bfc69c6e0);

var $1v5pe = parcelRequire("1v5pe");
const $54d43cc3defd5ad5$export$19538d0bfc69c6e0 = /*#__PURE__*/ (0, $1v5pe.createContext)(false);

});


parcelRegister("4tWUL", function(module, exports) {
$parcel$export(module.exports, "useHasTextAncestor", () => $74dade3862e6f3fb$export$9322276ec105d055);

var $1v5pe = parcelRequire("1v5pe");

var $9y0mv = parcelRequire("9y0mv");
const $74dade3862e6f3fb$export$9322276ec105d055 = ()=>(0, $1v5pe.useContext)((0, $9y0mv.HasTextAncestorContext));

});

parcelRegister("19JGr", function(module, exports) {
$parcel$export(module.exports, "textColorStylesMap", () => $4fb50fff32a66a9c$export$3a1bcba60b23d7f0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $6OZZq = parcelRequire("6OZZq");

var $bOekP = parcelRequire("bOekP");
const $4fb50fff32a66a9c$export$3a1bcba60b23d7f0 = (0, $6OZZq.getSerializedStylesMap)('color', (0, $bOekP.textColorMap));

});

parcelRegister("iptls", function(module, exports) {
$parcel$export(module.exports, "textSizeStylesMap", () => $aefb7c8213dfbcbd$export$219d364c0da35ae4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $6OZZq = parcelRequire("6OZZq");

var $6AnG9 = parcelRequire("6AnG9");
const $aefb7c8213dfbcbd$export$219d364c0da35ae4 = (0, $6OZZq.getSerializedStylesMap)('font', (0, $6AnG9.textSizeMap));

});
parcelRegister("6AnG9", function(module, exports) {
$parcel$export(module.exports, "textSizeMap", () => $0112edd240b90533$export$236bfe3a33ef1292);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6fd3eebcc815c6c62e80e08d3ca4f843>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $0112edd240b90533$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});


parcelRegister("9dWx4", function(module, exports) {
$parcel$export(module.exports, "textWeightStylesMap", () => $a115d5ed8322aa93$export$38845ca010b93505);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $6OZZq = parcelRequire("6OZZq");

var $1KMLq = parcelRequire("1KMLq");
const $a115d5ed8322aa93$export$38845ca010b93505 = (0, $6OZZq.getSerializedStylesMap)('fontWeight', (0, $1KMLq.textWeightMap));

});
parcelRegister("1KMLq", function(module, exports) {
$parcel$export(module.exports, "textWeightMap", () => $e17b33c485603bce$export$855cfd311192d666);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8120a44c21b94ee961979aa2a9470314>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $e17b33c485603bce$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};

});



parcelRegister("2FQOu", function(module, exports) {
$parcel$export(module.exports, "Checkbox", () => $ebc43d0bdbfb771e$export$48513f6b9f8ce62d);
$parcel$export(module.exports, "default", () => $ebc43d0bdbfb771e$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $j9QYE = parcelRequire("j9QYE");

var $fl4ll = parcelRequire("fl4ll");

var $bgQC7 = parcelRequire("bgQC7");

var $gfBoy = parcelRequire("gfBoy");

var $53Dxu = parcelRequire("53Dxu");

var $WgGC3 = parcelRequire("WgGC3");

var $kIqwl = parcelRequire("kIqwl");
const $ebc43d0bdbfb771e$var$_11 = "._tzy4idpf{opacity:0}";
const $ebc43d0bdbfb771e$var$_10 = "._ahbqze3t{margin-inline-start:var(--ds-space-0,0)}";
const $ebc43d0bdbfb771e$var$_1 = "._12l2ze3t{margin-inline-end:var(--ds-space-0,0)}";
const $ebc43d0bdbfb771e$var$_0 = "._1pfhze3t{margin-block-start:var(--ds-space-0,0)}";
const $ebc43d0bdbfb771e$var$_9 = "._6rthze3t{margin-block-end:var(--ds-space-0,0)}";
const $ebc43d0bdbfb771e$var$_8 = "._r06hglyw{-webkit-appearance:none;-moz-appearance:none;appearance:none}";
const $ebc43d0bdbfb771e$var$_7 = "._4t3i1osq{height:100%}";
const $ebc43d0bdbfb771e$var$_6 = "._1bsb1osq{width:100%}";
const $ebc43d0bdbfb771e$var$_5 = "._12y31o36{outline-width:medium}";
const $ebc43d0bdbfb771e$var$_4 = "._1qu2glyw{outline-style:none}";
const $ebc43d0bdbfb771e$var$_3 = "._12ji1r31{outline-color:currentColor}";
const $ebc43d0bdbfb771e$var$_2 = "._nd5lfibj{grid-area:1/1/2/2}";
const $ebc43d0bdbfb771e$var$_ = "._19itglyw{border:none}";
const $ebc43d0bdbfb771e$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $ebc43d0bdbfb771e$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $1v5pe.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $1v5pe.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: undefined,
        packageVersion: undefined
    });
    const internalRef = (0, $1v5pe.useRef)(null);
    const mergedRefs = (0, $fl4ll.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $1v5pe.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $gfBoy.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label` // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        ,
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                children: [
                    /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                        children: [
                            $ebc43d0bdbfb771e$var$_,
                            $ebc43d0bdbfb771e$var$_2,
                            $ebc43d0bdbfb771e$var$_3,
                            $ebc43d0bdbfb771e$var$_4,
                            $ebc43d0bdbfb771e$var$_5,
                            $ebc43d0bdbfb771e$var$_6,
                            $ebc43d0bdbfb771e$var$_7,
                            $ebc43d0bdbfb771e$var$_8,
                            $ebc43d0bdbfb771e$var$_9,
                            $ebc43d0bdbfb771e$var$_0,
                            $ebc43d0bdbfb771e$var$_1,
                            $ebc43d0bdbfb771e$var$_10,
                            $ebc43d0bdbfb771e$var$_11
                        ]
                    }),
                    /*#__PURE__*/ (0, $kIqwl.jsx)("input", {
                        // It is necessary only for Safari. It allows to render focus styles.
                        tabIndex: 0,
                        ...rest,
                        type: "checkbox",
                        ref: mergedRefs,
                        disabled: isDisabled,
                        checked: isChecked,
                        value: value,
                        name: name,
                        required: isRequired // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                        ,
                        className: (0, $hMvDh.default)([
                            $ebc43d0bdbfb771e$var$checkboxStyles.root,
                            className
                        ]),
                        onChange: onChangeAnalytics,
                        "aria-invalid": isInvalid ? 'true' : undefined,
                        "data-testid": testId && `${testId}--hidden-checkbox`,
                        "data-invalid": isInvalid ? 'true' : undefined
                    })
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $bgQC7.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $53Dxu.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $WgGC3.default), {})
                ]
            })
        ]
    });
}));
$ebc43d0bdbfb771e$export$48513f6b9f8ce62d.displayName = 'Checkbox'; // keep the default export for backwards compatibility
var $ebc43d0bdbfb771e$export$2e2bcd8739ae039 = $ebc43d0bdbfb771e$export$48513f6b9f8ce62d;

});
parcelRegister("bgQC7", function(module, exports) {
$parcel$export(module.exports, "default", () => $48722ba0ae9b45c7$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $2aEiL = parcelRequire("2aEiL");

var $kIqwl = parcelRequire("kIqwl");
const $48722ba0ae9b45c7$var$_15 = "._1s17hteq{stroke:var(--checkbox-border-color)}";
const $48722ba0ae9b45c7$var$_14 = "._1snbe4h9{stroke-width:var(--ds-border-width,1px)}";
const $48722ba0ae9b45c7$var$_13 = "._v56411so{transition:stroke .2s ease-in-out}";
const $48722ba0ae9b45c7$var$_12 = "._1cwg1i6y{outline-offset:var(--ds-space-negative-025,-2px)}";
const $48722ba0ae9b45c7$var$_11 = "._lswu1kgh{fill:var(--checkbox-tick-color,var(--ds-surface,#fff))}";
const $48722ba0ae9b45c7$var$_10 = "._syazmov0{color:var(--checkbox-background-color)}";
const $48722ba0ae9b45c7$var$_1 = "._lcxvglyw{pointer-events:none}";
const $48722ba0ae9b45c7$var$_0 = "._1a3742bt{outline:var(--checkbox-outline)}";
const $48722ba0ae9b45c7$var$_9 = "._2rko12b0{border-radius:var(--ds-radius-small,4px)}";
const $48722ba0ae9b45c7$var$_8 = "._v5641mn3{transition:color .2s ease-in-out,fill .2s ease-in-out}";
const $48722ba0ae9b45c7$var$_7 = "._18m915vq{overflow-y:hidden}";
const $48722ba0ae9b45c7$var$_6 = "._1reo15vq{overflow-x:hidden}";
const $48722ba0ae9b45c7$var$_5 = "._nd5lfibj{grid-area:1/1/2/2}";
const $48722ba0ae9b45c7$var$_4 = "@media (forced-colors:active){._1hdqglyw{transition:none}}";
const $48722ba0ae9b45c7$var$_3 = "._tzy4idpf{opacity:0}";
const $48722ba0ae9b45c7$var$_2 = "._tzy4kb7n{opacity:1}";
const $48722ba0ae9b45c7$var$_ = "._v564109b{transition:var(--ds-input-selection,background-color border-color color fill stroke opacity .15s cubic-bezier(.4,1,.6,1))}";
const $48722ba0ae9b45c7$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
// Cross-fade colors and glyphs without moving the input or focus outline.
// Semantic tokens keep SVG colors, borders and indicators aligned with input motion.
// Preserve non-spatial transitions for reduced motion, per the LDR:
// https://hello.atlassian.net/wiki/spaces/DST/pages/7402790985
const $48722ba0ae9b45c7$var$motionStyles = {
    root: "_v564109b",
    selected: "_tzy4kb7n",
    glyph: "_v564109b _tzy4idpf _1hdqglyw",
    border: "_v564109b"
};
function $48722ba0ae9b45c7$var$getIcon(isIndeterminate, isChecked, motionState) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $48722ba0ae9b45c7$var$_,
                    $48722ba0ae9b45c7$var$_2,
                    $48722ba0ae9b45c7$var$_3,
                    $48722ba0ae9b45c7$var$_4
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
                fill: "inherit",
                className: (0, $hMvDh.default)([
                    motionState && $48722ba0ae9b45c7$var$motionStyles.glyph,
                    motionState === 'visible' && $48722ba0ae9b45c7$var$motionStyles.selected
                ])
            })
        ]
    });
    if (isChecked) return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $48722ba0ae9b45c7$var$_,
                    $48722ba0ae9b45c7$var$_2,
                    $48722ba0ae9b45c7$var$_3,
                    $48722ba0ae9b45c7$var$_4
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                fill: "inherit",
                className: (0, $hMvDh.default)([
                    motionState && $48722ba0ae9b45c7$var$motionStyles.glyph,
                    motionState === 'visible' && $48722ba0ae9b45c7$var$motionStyles.selected
                ])
            })
        ]
    });
     // No icon
    return null;
}
const $48722ba0ae9b45c7$var$CheckboxIcon = /*#__PURE__*/ (0, $1v5pe.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const hasMotion = (0, $2aEiL.fg)('platform_design_system_selection_radial_fade');
    const icon = (0, $1v5pe.useMemo)(()=>$48722ba0ae9b45c7$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $48722ba0ae9b45c7$var$_5,
                    $48722ba0ae9b45c7$var$_6,
                    $48722ba0ae9b45c7$var$_7,
                    $48722ba0ae9b45c7$var$_8,
                    $48722ba0ae9b45c7$var$_9,
                    $48722ba0ae9b45c7$var$_0,
                    $48722ba0ae9b45c7$var$_1,
                    $48722ba0ae9b45c7$var$_10,
                    $48722ba0ae9b45c7$var$_11,
                    $48722ba0ae9b45c7$var$_12,
                    $48722ba0ae9b45c7$var$_13,
                    $48722ba0ae9b45c7$var$_14,
                    $48722ba0ae9b45c7$var$_15,
                    $48722ba0ae9b45c7$var$_,
                    $48722ba0ae9b45c7$var$_2,
                    $48722ba0ae9b45c7$var$_3,
                    $48722ba0ae9b45c7$var$_4
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("svg", {
                width: 24,
                height: 24,
                viewBox: "0 0 24 24",
                role: "presentation",
                className: (0, $hMvDh.default)([
                    $48722ba0ae9b45c7$var$svgStyles.root,
                    hasMotion && $48722ba0ae9b45c7$var$motionStyles.root
                ]),
                children: /*#__PURE__*/ (0, $kIqwl.jsxs)("g", {
                    fillRule: "evenodd",
                    children: [
                        /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
                            children: [
                                /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                                    children: [
                                        $48722ba0ae9b45c7$var$_5,
                                        $48722ba0ae9b45c7$var$_6,
                                        $48722ba0ae9b45c7$var$_7,
                                        $48722ba0ae9b45c7$var$_8,
                                        $48722ba0ae9b45c7$var$_9,
                                        $48722ba0ae9b45c7$var$_0,
                                        $48722ba0ae9b45c7$var$_1,
                                        $48722ba0ae9b45c7$var$_10,
                                        $48722ba0ae9b45c7$var$_11,
                                        $48722ba0ae9b45c7$var$_12,
                                        $48722ba0ae9b45c7$var$_13,
                                        $48722ba0ae9b45c7$var$_14,
                                        $48722ba0ae9b45c7$var$_15,
                                        $48722ba0ae9b45c7$var$_,
                                        $48722ba0ae9b45c7$var$_2,
                                        $48722ba0ae9b45c7$var$_3,
                                        $48722ba0ae9b45c7$var$_4
                                    ]
                                }),
                                /*#__PURE__*/ (0, $kIqwl.jsx)("rect", {
                                    fill: "currentColor",
                                    x: "5.5",
                                    y: "5.5",
                                    width: "13",
                                    height: "13",
                                    rx: "1.5",
                                    className: (0, $hMvDh.default)([
                                        $48722ba0ae9b45c7$var$svgStyles.rect,
                                        hasMotion && $48722ba0ae9b45c7$var$motionStyles.border
                                    ])
                                })
                            ]
                        }),
                        hasMotion ? /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $1v5pe.Fragment), {
                            children: [
                                $48722ba0ae9b45c7$var$getIcon(false, true, isChecked && !isIndeterminate ? 'visible' : 'hidden'),
                                $48722ba0ae9b45c7$var$getIcon(true, false, isIndeterminate ? 'visible' : 'hidden')
                            ]
                        }) : icon
                    ]
                })
            })
        ]
    });
});
var $48722ba0ae9b45c7$export$2e2bcd8739ae039 = $48722ba0ae9b45c7$var$CheckboxIcon;

});

parcelRegister("gfBoy", function(module, exports) {
$parcel$export(module.exports, "default", () => $0541050623ec6192$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v3.0.2 */ parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $kIqwl = parcelRequire("kIqwl");
const $0541050623ec6192$var$_37 = "._zoo92sac:active{--checkbox-tick-color:var(--ds-icon-disabled,#080f214a)}";
const $0541050623ec6192$var$_36 = "._9js12sac:hover{--checkbox-tick-color:var(--ds-icon-disabled,#080f214a)}";
const $0541050623ec6192$var$_35 = "._1e9d2sac{--checkbox-tick-color:var(--ds-icon-disabled,#080f214a)}";
const $0541050623ec6192$var$_34 = "@media screen and (forced-colors:active){._jom5wc43{--checkbox-background-color:Canvas}._1s0718qt{--checkbox-border-color:GrayText}._106f18qt{--checkbox-tick-color:GrayText}}";
const $0541050623ec6192$var$_33 = "._cz1u187o:active{--checkbox-border-color:var(--ds-background-disabled,#0515240f)}";
const $0541050623ec6192$var$_32 = "._dh4g187o:active{--checkbox-background-color:var(--ds-background-disabled,#0515240f)}";
const $0541050623ec6192$var$_31 = "._q29q187o:hover{--checkbox-border-color:var(--ds-background-disabled,#0515240f)}";
const $0541050623ec6192$var$_30 = "._1vj5187o:hover{--checkbox-background-color:var(--ds-background-disabled,#0515240f)}";
const $0541050623ec6192$var$_29 = "._80om13gf{cursor:not-allowed}";
const $0541050623ec6192$var$_28 = "._syaz1gmx{color:var(--ds-text-disabled,#080f214a)}";
const $0541050623ec6192$var$_27 = "._f0gr187o{--checkbox-border-color:var(--ds-background-disabled,#0515240f)}";
const $0541050623ec6192$var$_26 = "._1qwn187o{--checkbox-background-color:var(--ds-background-disabled,#0515240f)}";
const $0541050623ec6192$var$_25 = "@media screen and (forced-colors:active){._1s07gir2{--checkbox-border-color:Highlight}}";
const $0541050623ec6192$var$_24 = "._cz1u1bqt:active{--checkbox-border-color:var(--ds-border-danger,#e2483d)}";
const $0541050623ec6192$var$_23 = "._q29q1bqt:hover{--checkbox-border-color:var(--ds-border-danger,#e2483d)}";
const $0541050623ec6192$var$_22 = "._f0gr1bqt{--checkbox-border-color:var(--ds-border-danger,#e2483d)}";
const $0541050623ec6192$var$_21 = "._zoo95w2r:active{--checkbox-tick-color:var(--ds-icon-inverse,#fff)}";
const $0541050623ec6192$var$_20 = "._q29q1q28:hover{--checkbox-border-color:var(--ds-background-selected-bold-hovered,#1558bc)}";
const $0541050623ec6192$var$_19 = "._1vj51q28:hover{--checkbox-background-color:var(--ds-background-selected-bold-hovered,#1558bc)}";
const $0541050623ec6192$var$_18 = "._1e9d5w2r{--checkbox-tick-color:var(--ds-icon-inverse,#fff)}";
const $0541050623ec6192$var$_17 = "._f0grjmqp{--checkbox-border-color:var(--ds-background-selected-bold,#1868db)}";
const $0541050623ec6192$var$_16 = "._1qwnjmqp{--checkbox-background-color:var(--ds-background-selected-bold,#1868db)}";
const $0541050623ec6192$var$_15 = "._yv0ey09t{grid-template-columns:min-content auto}";
const $0541050623ec6192$var$_14 = "._zulp1nu5{gap:var(--ds-space-0,0) var(--ds-space-050,4px)}";
const $0541050623ec6192$var$_13 = "@media screen and (forced-colors:active){._jom5wc43{--checkbox-background-color:Canvas}._1s071onz{--checkbox-border-color:CanvasText}._106f1onz{--checkbox-tick-color:CanvasText}}";
const $0541050623ec6192$var$_12 = "._cz1u1l7x:active{--checkbox-border-color:var(--ds-border,#0b120e24)}";
const $0541050623ec6192$var$_11 = "._dh4gr01l:active{--checkbox-background-color:var(--ds-background-input-pressed,#fff)}";
const $0541050623ec6192$var$_10 = "._1vj5l4ek:hover{--checkbox-background-color:var(--ds-background-input-hovered,#f8f8f8)}";
const $0541050623ec6192$var$_1 = "._ljcgdfik:focus-within{--checkbox-outline:var(--ds-border-width-focused,2px) solid var(--ds-border-focused,#4688ec)}";
const $0541050623ec6192$var$_0 = "._80om73ad{cursor:default}";
const $0541050623ec6192$var$_9 = "._syazi7uo{color:var(--ds-text,#292a2e)}";
const $0541050623ec6192$var$_8 = "._1e9d1j28{--checkbox-tick-color:transparent}";
const $0541050623ec6192$var$_7 = "._1c53glyw{--checkbox-outline:none}";
const $0541050623ec6192$var$_6 = "._f0grrsbi{--checkbox-border-color:var(--ds-border-input,#8c8f97)}";
const $0541050623ec6192$var$_5 = "._1qwn1j9a{--checkbox-background-color:var(--ds-background-input,#fff)}";
const $0541050623ec6192$var$_4 = "._umai184x{grid-auto-rows:min-content}";
const $0541050623ec6192$var$_3 = "._1ejihkll{grid-auto-columns:1fr}";
const $0541050623ec6192$var$_2 = "._1e0c11p5{display:grid}";
const $0541050623ec6192$var$_ = "._11c8fhey{font:var(--ds-font-body,normal 400 14px/20px \"Atlassian Sans\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const $0541050623ec6192$var$baseStyles = null;
const $0541050623ec6192$var$textLabelLayoutStyles = null;
// Checked/Indeterminate state
const $0541050623ec6192$var$checkedStyles = null;
// Invalid state - must override hover/active to maintain red border
const $0541050623ec6192$var$invalidStyles = null; // Disabled state - must override hover/active to maintain disabled appearance
const $0541050623ec6192$var$disabledStyles = null; // Disabled + Checked/Indeterminate
const $0541050623ec6192$var$disabledCheckedStyles = null;
function $0541050623ec6192$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $0541050623ec6192$var$_,
                    $0541050623ec6192$var$_2,
                    $0541050623ec6192$var$_3,
                    $0541050623ec6192$var$_4,
                    $0541050623ec6192$var$_5,
                    $0541050623ec6192$var$_6,
                    $0541050623ec6192$var$_7,
                    $0541050623ec6192$var$_8,
                    $0541050623ec6192$var$_9,
                    $0541050623ec6192$var$_0,
                    $0541050623ec6192$var$_1,
                    $0541050623ec6192$var$_10,
                    $0541050623ec6192$var$_11,
                    $0541050623ec6192$var$_12,
                    $0541050623ec6192$var$_13,
                    $0541050623ec6192$var$_14,
                    $0541050623ec6192$var$_15,
                    $0541050623ec6192$var$_16,
                    $0541050623ec6192$var$_17,
                    $0541050623ec6192$var$_18,
                    $0541050623ec6192$var$_19,
                    $0541050623ec6192$var$_20,
                    $0541050623ec6192$var$_21,
                    $0541050623ec6192$var$_22,
                    $0541050623ec6192$var$_23,
                    $0541050623ec6192$var$_24,
                    $0541050623ec6192$var$_25,
                    $0541050623ec6192$var$_26,
                    $0541050623ec6192$var$_27,
                    $0541050623ec6192$var$_28,
                    $0541050623ec6192$var$_29,
                    $0541050623ec6192$var$_30,
                    $0541050623ec6192$var$_31,
                    $0541050623ec6192$var$_32,
                    $0541050623ec6192$var$_33,
                    $0541050623ec6192$var$_34,
                    $0541050623ec6192$var$_35,
                    $0541050623ec6192$var$_36,
                    $0541050623ec6192$var$_37
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("label", {
                className: (0, $hMvDh.default)([
                    "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
                    label && "_zulp1nu5 _yv0ey09t",
                    (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
                    isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
                    isDisabled && "_1qwn187o _f0gr187o _syaz1gmx _80om13gf _1vj5187o _q29q187o _dh4g187o _cz1u187o _jom5wc43 _1s0718qt _106f18qt",
                    isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
                    xcss
                ]),
                "data-testid": testId,
                "data-disabled": isDisabled || undefined,
                id: id,
                children: children
            })
        ]
    });
}

});

parcelRegister("53Dxu", function(module, exports) {
$parcel$export(module.exports, "default", () => $136267f4b4143d59$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v3.0.2 */ parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $kIqwl = parcelRequire("kIqwl");
const $136267f4b4143d59$var$_2 = "._1wpz1h6o{align-self:center}";
const $136267f4b4143d59$var$_ = "._nd5l11ig{grid-area:1/2/2/3}";
const $136267f4b4143d59$var$labelTextStyles = null;
function $136267f4b4143d59$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $136267f4b4143d59$var$_,
                    $136267f4b4143d59$var$_2
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
                className: (0, $hMvDh.default)([
                    "_nd5l11ig _1wpz1h6o"
                ]),
                children: children
            })
        ]
    });
}

});

parcelRegister("WgGC3", function(module, exports) {
$parcel$export(module.exports, "default", () => $64516635a6c1fea0$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v3.0.2 */ parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $kIqwl = parcelRequire("kIqwl");
const $64516635a6c1fea0$var$_2 = "._bozgv77o{padding-inline-start:var(--ds-space-025,2px)}";
const $64516635a6c1fea0$var$_ = "._syaz1tmw{color:var(--ds-text-danger,#ae2e24)}";
const $64516635a6c1fea0$var$requiredIndicatorStyles = null;
function $64516635a6c1fea0$export$2e2bcd8739ae039() {
    return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $64516635a6c1fea0$var$_,
                    $64516635a6c1fea0$var$_2
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
                "aria-hidden": true,
                className: (0, $hMvDh.default)([
                    "_syaz1tmw _bozgv77o"
                ]),
                children: "*"
            })
        ]
    }));
}

});


parcelRegister("49361", function(module, exports) {
$parcel$export(module.exports, "default", () => $65e2863bd86ba227$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $1895S = parcelRequire("1895S");

var $1TZ74 = parcelRequire("1TZ74");

var $lreqQ = parcelRequire("lreqQ");

var $kIqwl = parcelRequire("kIqwl");
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $65e2863bd86ba227$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $1895S.default), {
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName,
        ...saferRest,
        children: [
            iconBefore && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1TZ74.default), {
                type: "icon",
                position: "before",
                isLoading: isLoading,
                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $lreqQ.default), {
                    icon: iconBefore,
                    spacing: spacing
                })
            }),
            children && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1TZ74.default), {
                isLoading: isLoading,
                children: children
            }),
            iconAfter && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1TZ74.default), {
                type: "icon",
                position: "after",
                isLoading: isLoading,
                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $lreqQ.default), {
                    icon: iconAfter,
                    spacing: spacing
                })
            })
        ]
    });
}));
$65e2863bd86ba227$var$Button.displayName = 'Button';
var $65e2863bd86ba227$export$2e2bcd8739ae039 = $65e2863bd86ba227$var$Button;

});

parcelRegister("caOTO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97fadb77040fc214fca377f612fb6ef3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8dcde6b856eadaa2$var$_react = $8dcde6b856eadaa2$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $8dcde6b856eadaa2$var$_iconNew = $8dcde6b856eadaa2$var$_interopRequireDefault((parcelRequire("5CpUv")));
function $8dcde6b856eadaa2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/check-mark
 * Usage guidance:
 * Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8dcde6b856eadaa2$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $8dcde6b856eadaa2$var$_react.default.createElement($8dcde6b856eadaa2$var$_iconNew.default, Object.assign({
        name: "CheckMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$8dcde6b856eadaa2$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $8dcde6b856eadaa2$var$_default = module.exports.default = $8dcde6b856eadaa2$var$CheckMarkIcon;

});

parcelRegister("f4K70", function(module, exports) {
$parcel$export(module.exports, "Inline", () => $cd3b83ba54ce062c$export$fbae5b5ffd8af05e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hRuTh = parcelRequire("hRuTh");

var $bQOrV = parcelRequire("bQOrV");

var $aCcGw = parcelRequire("aCcGw");
const $cd3b83ba54ce062c$var$flexGrowMap = {
    hug: (0, $bQOrV.xcss)({
        flexGrow: 0
    }),
    fill: (0, $bQOrV.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $cd3b83ba54ce062c$var$separatorStyles = (0, $hRuTh.css)({
    color: "var(--ds-text-subtle, #505258)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none',
    userSelect: 'none'
});
const $cd3b83ba54ce062c$var$Separator = ({ children: children })=>(0, $hRuTh.jsx)("span", {
        css: $cd3b83ba54ce062c$var$separatorStyles
    }, children);
const $cd3b83ba54ce062c$export$fbae5b5ffd8af05e = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, id: id, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? (0, $hRuTh.jsx)($cd3b83ba54ce062c$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $1v5pe.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return (0, $hRuTh.jsx)((0, $1v5pe.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    const justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $cd3b83ba54ce062c$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return (0, $hRuTh.jsx)((0, $aCcGw.Flex), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$cd3b83ba54ce062c$export$fbae5b5ffd8af05e.displayName = 'Inline';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$cd3b83ba54ce062c$export$2e2bcd8739ae039 = $cd3b83ba54ce062c$export$fbae5b5ffd8af05e;

});

parcelRegister("8zRL5", function(module, exports) {
$parcel$export(module.exports, "AtlBrowserStorageLocal", () => $025700daaf38b42f$export$c8cc3ffd3f2c1d2f);
$parcel$export(module.exports, "AtlBrowserStorageSession", () => $025700daaf38b42f$export$edbae459bdf957a5);
$parcel$export(module.exports, "findStorageTarget", () => $025700daaf38b42f$export$14921bfc334334c0);
$parcel$export(module.exports, "WebStorageType", () => (parcelRequire("5noOS")).WebStorageType);

var $2aEiL = parcelRequire("2aEiL");

var $jeHvL = parcelRequire("jeHvL");
var $dS1lP = parcelRequire("dS1lP");
var $7WT4C = parcelRequire("7WT4C");

var $bEUFb = parcelRequire("bEUFb");

var $2W5OM = parcelRequire("2W5OM");

var $5noOS = parcelRequire("5noOS");

var $9q18u = parcelRequire("9q18u");
var $8TF7r = parcelRequire("8TF7r");
var $8SoP3 = parcelRequire("8SoP3");
class $025700daaf38b42f$export$8e4a3cf07a10930b {
    storage;
    storageType;
    isAvailable = false;
    constructor(storage, storageType){
        this.storage = storage;
        this.storageType = storageType;
        this.isAvailable = this.isStorageAvailable();
    }
    get isWebStorageEnabled() {
        // Note: outside of user configuration, webStorageEnabled is also feature gated by
        // 1. platform_moonjelly_bsc_master_killswitch
        // 2. platform_moonjelly_bsc_web_storage_killswitch
        if ((0, $jeHvL.getBscGlobalState)().webStorageEnabled) return true;
        (0, $bEUFb.Logger).debug('WebStorage config is disabled, cannot proceed.');
        return false;
    }
    // Core API
    getItem(key) {
        if (!this.isWebStorageEnabled) return this.storage.getItem(key);
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $bEUFb.Logger).warn(`${this.storageType} is unavailable. Failed to get item ${key}`);
            return null;
        }
        const retrievedItem = (0, $9q18u.getStorageItem)(key, this.storageType, this.storage);
        return retrievedItem;
    }
    async setItem(key, value) {
        if (!this.isWebStorageEnabled) {
            // BSC controls are disabled (pre-init, caller opted out, or killswitch active).
            // Write proceeds unconditionally — emit analytics so we can quantify bypass volume
            // (gated by platform_bsc_consent_bypass_analytics for safe rollout).
            if ((0, $2aEiL.fg)('platform_bsc_consent_bypass_analytics')) {
                const globalState = (0, $jeHvL.getBscGlobalState)();
                (0, $7WT4C.sendPackageOperationalEvent)({
                    action: 'usedAtlBrowserStorageSetItemBscDisabled',
                    attributes: {
                        storageType: this.storageType,
                        product: globalState.product,
                        hasInitialized: globalState.hasInitialized ?? false
                    }
                });
            }
            this.storage.setItem(key, value);
            return {
                status: (0, $2W5OM.Status).SUCCESS
            };
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $bEUFb.Logger).warn(`${this.storageType} is unavailable. Failed to set item ${key}`);
            return {
                status: (0, $2W5OM.Status).ERROR,
                error: new Error(`${this.storageType} is unavailable. Failed to set item ${key}`)
            };
        }
        const globalStateProduct = (0, $jeHvL.getBscGlobalState)().product;
        const wasInitialized = (0, $jeHvL.getBscGlobalState)().hasInitialized;
        // IMPORTANT: do not await above this line - if you do it will cause reading after writing to not return the new value until the microtask queue is drained, instead of just those that need to wait for remote fetch.
        const itemSetResult = await (0, $8TF7r.setStorageItem)(key, value, this.storageType, globalStateProduct, this.storage);
        if (!wasInitialized) (0, $7WT4C.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: this.storageType
            }
        });
        if (itemSetResult.status === (0, $2W5OM.Status).SUCCESS) (0, $bEUFb.Logger).debug(`Successfully set item ${key} with value ${value}`);
        else if (itemSetResult.status === (0, $2W5OM.Status).BLOCKED) {
            // Only an actual block is described as "blocked" — errors are surfaced (and logged)
            // upstream in setStorageItem's catch blocks via Logger.errorWithOperationalEvent.
            (0, $bEUFb.Logger).debug(`Blocked setting item ${key}`);
            const productSuffix = globalStateProduct ? ` for product "${globalStateProduct}"` : '';
            if (itemSetResult.blockedItemCategory === null) // Async path with confirmed cause: key is not registered.
            (0, $bEUFb.Logger).warn(`${this.storageType}.setItem('${key}', ...) was blocked${productSuffix}` + `: '${key}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
            else if (itemSetResult.blockedItemCategory === undefined) // MaybeSync path: cause not available. State only what we know.
            (0, $bEUFb.Logger).warn(`${this.storageType}.setItem('${key}', ...) was blocked${productSuffix}.`);
        }
        return itemSetResult;
    }
    setStrictlyNecessaryItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $bEUFb.Logger).warn(`${this.storageType} is unavailable. Failed to set strictly necessary item ${key}`);
            return;
        }
        const itemSetStatus = (0, $8SoP3.setStrictlyNecessaryStorageItem)(key, value, this.storageType, this.storage);
        if (!(0, $jeHvL.getBscGlobalState)().hasInitialized) (0, $7WT4C.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: this.storageType
            }
        });
        (0, $bEUFb.Logger).debug(`${itemSetStatus === (0, $2W5OM.Status).SUCCESS ? 'Successfully' : 'Failed to'} set strictly necessary item ${key} with value ${value}`);
    }
    // Native Utilities
    removeItem(key) {
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $bEUFb.Logger).warn(`${this.storageType} is unavailable. Failed to remove item ${key}`);
            return;
        }
        this.storage.removeItem(key);
    }
    key(index) {
        if (!this.isAvailable) return null;
        return this.storage.key(index);
    }
    length() {
        if (!this.isAvailable) return 0;
        return this.storage.length;
    }
    clear() {
        if (!this.isAvailable) return;
        this.storage.clear();
    }
    // Utilities
    isStorageAvailable() {
        if ((0, $dS1lP.isSSR)()) return false;
        try {
            const x = '__storage_test__';
            this.storage.setItem(x, x);
            this.storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && // everything except Firefox
            (e.code === 22 || // Firefox
            e.code === 1014 || // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' || // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
            this.storage && this.storage.length !== 0;
        }
    }
}
const $025700daaf38b42f$export$c8cc3ffd3f2c1d2f = new $025700daaf38b42f$export$8e4a3cf07a10930b(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
globalThis.localStorage, (0, $5noOS.WebStorageType).LocalStorage);
const $025700daaf38b42f$export$edbae459bdf957a5 = new $025700daaf38b42f$export$8e4a3cf07a10930b(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
globalThis.sessionStorage, (0, $5noOS.WebStorageType).SessionStorage);
const $025700daaf38b42f$export$14921bfc334334c0 = (type)=>{
    return ({
        [(0, $5noOS.WebStorageType).LocalStorage]: $025700daaf38b42f$export$c8cc3ffd3f2c1d2f,
        [(0, $5noOS.WebStorageType).SessionStorage]: $025700daaf38b42f$export$edbae459bdf957a5
    })[type];
};

});
parcelRegister("5noOS", function(module, exports) {
$parcel$export(module.exports, "WebStorageType", () => $f3dcf08643e73a90$export$259e3a861f28589b);
var $f3dcf08643e73a90$export$259e3a861f28589b = /*#__PURE__*/ function(WebStorageType) {
    WebStorageType["LocalStorage"] = "LocalStorage";
    WebStorageType["SessionStorage"] = "SessionStorage";
    return WebStorageType;
}({});

});

parcelRegister("9q18u", function(module, exports) {
$parcel$export(module.exports, "getStorageItem", () => $6b76d601ddf7e8cf$export$e612bb1301d659de);

var $7WT4C = parcelRequire("7WT4C");

var $bEUFb = parcelRequire("bEUFb");
const $6b76d601ddf7e8cf$export$e612bb1301d659de = (itemKey, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $7WT4C.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageGetItem',
            attributes: eventAttributes
        });
        return browserStorage.getItem(itemKey);
    } catch (e) {
        (0, $bEUFb.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageGetItemError',
            attributes: eventAttributes,
            message: `Failed to get ${storageType} item. ${e.message || ''}`
        });
        return null;
    }
};

});

parcelRegister("8TF7r", function(module, exports) {
$parcel$export(module.exports, "setStorageItem", () => $025bf9bcf84138ab$export$5ee8760f703d9d62);

var $jeHvL = parcelRequire("jeHvL");
var $7WT4C = parcelRequire("7WT4C");

var $7vtyD = parcelRequire("7vtyD");

var $2W5OM = parcelRequire("2W5OM");

var $kqaLu = parcelRequire("kqaLu");

var $5noOS = parcelRequire("5noOS");

var $36ucG = parcelRequire("36ucG");
const $025bf9bcf84138ab$var$isPromise = (value)=>value != null && typeof value.then === 'function';
const $025bf9bcf84138ab$export$5ee8760f703d9d62 = async (itemKey, value, storageType, productName, browserStorage)=>{
    const categoryStorageType = storageType === (0, $5noOS.WebStorageType).LocalStorage ? (0, $2W5OM.CategoryStorageType).LocalStorage : (0, $2W5OM.CategoryStorageType).SessionStorage;
    const disableWebStorageConsentChecks = (0, $jeHvL.getBscGlobalState)().disableWebStorageConsentChecks ?? false;
    if (disableWebStorageConsentChecks) {
        const eventAttributes = {
            itemKey: itemKey,
            storageType: storageType,
            consentChecksDisabled: true
        };
        try {
            // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
            // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
            (0, $kqaLu.ItemKeyCache).markSetByPackage(categoryStorageType, itemKey);
            browserStorage.setItem(itemKey, value);
        } catch (e) {
            (0, $36ucG.reportSetItemError)({
                message: `${storageType} failed to setItem with consent checks disabled. ${e.message || ''}`,
                attributes: eventAttributes,
                error: e
            });
            return {
                status: (0, $2W5OM.Status).ERROR,
                error: e
            };
        }
        let wasAsync = true;
        try {
            let shouldSetItem;
            const shouldSetItemOrPromise = (0, $7vtyD.isProcessingAllowedByPreferencesMaybeSync)({
                itemKey: itemKey,
                storageType: categoryStorageType,
                productName: productName
            });
            if ($025bf9bcf84138ab$var$isPromise(shouldSetItemOrPromise)) shouldSetItem = await shouldSetItemOrPromise;
            else {
                wasAsync = false;
                shouldSetItem = shouldSetItemOrPromise;
            }
            (0, $7WT4C.sendPackageOperationalEvent)({
                action: 'usedAtlBrowserStorageSetItem',
                attributes: {
                    ...eventAttributes,
                    wasRejected: !shouldSetItem,
                    wasAsync: wasAsync
                }
            });
        } catch (e) {
            (0, $36ucG.reportSetItemError)({
                attributes: {
                    ...eventAttributes,
                    wasAsync: wasAsync
                },
                message: `Failed to emit analytics for setStorageItem with consent checks disabled. ${e.message || ''}`,
                error: e
            });
        }
        return {
            status: (0, $2W5OM.Status).SUCCESS
        };
    }
    // user belongs to an org that opted into cookies management and we should respect their preferences
    let shouldSetItem;
    let wasAsync = true;
    const shouldSetItemOrPromise = (0, $7vtyD.isProcessingAllowedByPreferencesMaybeSync)({
        itemKey: itemKey,
        storageType: categoryStorageType,
        productName: productName
    });
    if ($025bf9bcf84138ab$var$isPromise(shouldSetItemOrPromise)) shouldSetItem = await shouldSetItemOrPromise;
    else {
        wasAsync = false;
        shouldSetItem = shouldSetItemOrPromise;
    }
    // The synchronous preference check surfaces no block reason:
    // `isProcessingAllowedByPreferencesMaybeSync` takes no blockedCallback, so we cannot tell
    // "key not registered in the allow-list" from "blocked by user consent" here. The BLOCKED
    // result therefore carries `blockedItemCategory: undefined` ("reason unknown"), which the
    // caller reads as such and answers with a terse "was blocked" warning.
    const eventAttributes = {
        wasRejected: !shouldSetItem,
        itemKey: itemKey,
        storageType: storageType,
        consentChecksDisabled: false,
        wasAsync: wasAsync
    };
    try {
        (0, $7WT4C.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetItem',
            attributes: eventAttributes
        });
        if (shouldSetItem) {
            // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
            // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
            (0, $kqaLu.ItemKeyCache).markSetByPackage(categoryStorageType, itemKey);
            browserStorage.setItem(itemKey, value);
            return {
                status: (0, $2W5OM.Status).SUCCESS
            };
        } else return {
            status: (0, $2W5OM.Status).BLOCKED,
            blockedItemCategory: undefined
        };
    } catch (e) {
        (0, $36ucG.reportSetItemError)({
            attributes: eventAttributes,
            message: `Failed to set ${storageType} item. ${e.message || ''}`,
            error: e
        });
        return {
            status: (0, $2W5OM.Status).ERROR,
            error: e
        };
    }
};

});
parcelRegister("kqaLu", function(module, exports) {
$parcel$export(module.exports, "ItemKeyCache", () => $092d0a7701de4285$export$ff3c91e80f54f26c);

var $2W5OM = parcelRequire("2W5OM");
class $092d0a7701de4285$var$ItemKeyCacheService {
    cache;
    constructor(){
        this.cache = Object.fromEntries(Object.keys((0, $2W5OM.CategoryStorageType)).map((storageType)=>{
            return [
                storageType,
                new Set()
            ];
        }));
    }
    markSetByPackage(storageType, itemKey) {
        this.cache[storageType].add(itemKey);
    }
    wasSetByPackage(storageType, itemKey) {
        return this.cache[storageType].has(itemKey);
    }
}
const $092d0a7701de4285$export$ff3c91e80f54f26c = new $092d0a7701de4285$var$ItemKeyCacheService();

});

parcelRegister("36ucG", function(module, exports) {
$parcel$export(module.exports, "reportSetItemError", () => $16e3fc8efae64d02$export$ba6a684424c69e54);

var $bEUFb = parcelRequire("bEUFb");
/**
 * Identifies browser "quota exceeded" storage failures across the cross-browser variants (per MDN's
 * `Storage.setItem` exceptions): modern browsers throw a `DOMException` named `QuotaExceededError`;
 * legacy WebKit/Blink expose the numeric `code === 22` (`QUOTA_EXCEEDED_ERR`); Firefox historically
 * throws `NS_ERROR_DOM_QUOTA_REACHED` with `code === 1014`.
 */ const $16e3fc8efae64d02$var$isQuotaExceededError = (error)=>{
    if (!error || typeof error !== 'object') return false;
    const { name: name, code: code } = error;
    return name === 'QuotaExceededError' || name === 'NS_ERROR_DOM_QUOTA_REACHED' || code === 22 || code === 1014;
};
const $16e3fc8efae64d02$export$ba6a684424c69e54 = ({ message: message, attributes: attributes, error: error })=>{
    if ($16e3fc8efae64d02$var$isQuotaExceededError(error)) {
        (0, $bEUFb.Logger).error(message);
        return;
    }
    (0, $bEUFb.Logger).errorWithOperationalEvent({
        action: 'usedAtlBrowserStorageSetItemError',
        message: message,
        attributes: attributes
    });
};

});


parcelRegister("8SoP3", function(module, exports) {
$parcel$export(module.exports, "setStrictlyNecessaryStorageItem", () => $7ecf8bb31f7cb973$export$f1b0c189562aa9fd);

var $7WT4C = parcelRequire("7WT4C");

var $bEUFb = parcelRequire("bEUFb");

var $2W5OM = parcelRequire("2W5OM");

var $kqaLu = parcelRequire("kqaLu");

var $5noOS = parcelRequire("5noOS");
const $7ecf8bb31f7cb973$export$f1b0c189562aa9fd = (itemKey, value, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $7WT4C.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItem',
            attributes: eventAttributes
        });
        // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
        // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
        (0, $kqaLu.ItemKeyCache).markSetByPackage(storageType === (0, $5noOS.WebStorageType).LocalStorage ? (0, $2W5OM.CategoryStorageType).LocalStorage : (0, $2W5OM.CategoryStorageType).SessionStorage, itemKey);
        browserStorage.setItem(itemKey, value);
        return (0, $2W5OM.Status).SUCCESS;
    } catch (e) {
        (0, $bEUFb.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItemError',
            attributes: eventAttributes,
            message: `Failed to set strictly necessary ${storageType} item. ${e.message || ''}`
        });
        return (0, $2W5OM.Status).FAILED;
    }
};

});


parcelRegister("7yQXV", function(module, exports) {
$parcel$export(module.exports, "createBrowserHistory", () => (parcelRequire("gHVeV")).createBrowserHistory);
$parcel$export(module.exports, "Redirect", () => (parcelRequire("inmj3")).Redirect);
$parcel$export(module.exports, "Router", () => (parcelRequire("j2pl3")).Router);
$parcel$export(module.exports, "usePathParam", () => (parcelRequire("7OyXD")).usePathParam);
$parcel$export(module.exports, "useQueryParam", () => (parcelRequire("dQa3A")).useQueryParam);
$parcel$export(module.exports, "useRouter", () => (parcelRequire("fsPVv")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("aZhFm")).useRouterActions);
$parcel$export(module.exports, "RouteComponent", () => (parcelRequire("7rOcK")).RouteComponent);
$parcel$export(module.exports, "Link", () => (parcelRequire("iR5yZ")).default);
$parcel$export(module.exports, "generatePath", () => (parcelRequire("j5iRK")).generatePath);

var $gHVeV = parcelRequire("gHVeV");
parcelRequire("b75yl");
var $inmj3 = parcelRequire("inmj3");
var $j2pl3 = parcelRequire("j2pl3");
var $7OyXD = parcelRequire("7OyXD");
var $dQa3A = parcelRequire("dQa3A");
var $fsPVv = parcelRequire("fsPVv");
var $aZhFm = parcelRequire("aZhFm");
parcelRequire("gEGDD");
var $iR5yZ = parcelRequire("iR5yZ");
var $7rOcK = parcelRequire("7rOcK");
parcelRequire("i4lyD");
var $j5iRK = parcelRequire("j5iRK");

var $7OL8N = parcelRequire("7OL8N");

var $2yUAk = parcelRequire("2yUAk");

var $5lbjJ = parcelRequire("5lbjJ");
parcelRequire("9G6YZ");
var $4k3vk = parcelRequire("4k3vk");
var $fvHkP = parcelRequire("fvHkP");
var $7Vv8o = parcelRequire("7Vv8o");

});
parcelRegister("gHVeV", function(module, exports) {
$parcel$export(module.exports, "createBrowserHistory", () => $c29d101a2cf08ade$export$719fc203c4e16dee);
$parcel$export(module.exports, "createPath", () => $c29d101a2cf08ade$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $c29d101a2cf08ade$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createMemoryHistory", () => $c29d101a2cf08ade$export$2b76ad033c6e6d08);

var $87uOn = parcelRequire("87uOn");
/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */ var $c29d101a2cf08ade$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($c29d101a2cf08ade$export$e19cd5f9376f8cee || ($c29d101a2cf08ade$export$e19cd5f9376f8cee = {}));
var $c29d101a2cf08ade$var$readOnly = function(obj) {
    return obj;
};
function $c29d101a2cf08ade$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== 'undefined') console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
var $c29d101a2cf08ade$var$BeforeUnloadEventType = 'beforeunload';
var $c29d101a2cf08ade$var$HashChangeEventType = 'hashchange';
var $c29d101a2cf08ade$var$PopStateEventType = 'popstate';
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $c29d101a2cf08ade$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    var _options = options, _options$window = _options.window, window = _options$window === void 0 ? document.defaultView : _options$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $c29d101a2cf08ade$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($c29d101a2cf08ade$var$PopStateEventType, handlePop);
    var action = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
    var listeners = $c29d101a2cf08ade$var$createEvents();
    var blockers = $c29d101a2cf08ade$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $87uOn.default)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function createHref(to) {
        return typeof to === 'string' ? to : $c29d101a2cf08ade$export$fe53371bee54353d(to);
    } // state defaults to `null` because `window.history.state` does
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $c29d101a2cf08ade$var$readOnly((0, $87uOn.default)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $c29d101a2cf08ade$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $c29d101a2cf08ade$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0];
        location = _getIndexAndLocation3[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($c29d101a2cf08ade$var$BeforeUnloadEventType, $c29d101a2cf08ade$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($c29d101a2cf08ade$var$BeforeUnloadEventType, $c29d101a2cf08ade$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $c29d101a2cf08ade$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    var _options2 = options, _options2$window = _options2.window, window = _options2$window === void 0 ? document.defaultView : _options2$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _parsePath = $c29d101a2cf08ade$export$8ccf933b0513f8d0(window.location.hash.substr(1)), _parsePath$pathname = _parsePath.pathname, pathname = _parsePath$pathname === void 0 ? '/' : _parsePath$pathname, _parsePath$search = _parsePath.search, search = _parsePath$search === void 0 ? '' : _parsePath$search, _parsePath$hash = _parsePath.hash, hash = _parsePath$hash === void 0 ? '' : _parsePath$hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $c29d101a2cf08ade$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation4 = getIndexAndLocation(), nextIndex = _getIndexAndLocation4[0], nextLocation = _getIndexAndLocation4[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($c29d101a2cf08ade$var$PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
    // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event
    window.addEventListener($c29d101a2cf08ade$var$HashChangeEventType, function() {
        var _getIndexAndLocation5 = getIndexAndLocation(), nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.
        if ($c29d101a2cf08ade$export$fe53371bee54353d(nextLocation) !== $c29d101a2cf08ade$export$fe53371bee54353d(location)) handlePop();
    });
    var action = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation6 = getIndexAndLocation(), index = _getIndexAndLocation6[0], location = _getIndexAndLocation6[1];
    var listeners = $c29d101a2cf08ade$var$createEvents();
    var blockers = $c29d101a2cf08ade$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $87uOn.default)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function getBaseHref() {
        var base = document.querySelector('base');
        var href = '';
        if (base && base.getAttribute('href')) {
            var url = window.location.href;
            var hashIndex = url.indexOf('#');
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + '#' + (typeof to === 'string' ? to : $c29d101a2cf08ade$export$fe53371bee54353d(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $c29d101a2cf08ade$var$readOnly((0, $87uOn.default)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $c29d101a2cf08ade$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $c29d101a2cf08ade$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation7 = getIndexAndLocation();
        index = _getIndexAndLocation7[0];
        location = _getIndexAndLocation7[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr3[0], url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr4[0], url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($c29d101a2cf08ade$var$BeforeUnloadEventType, $c29d101a2cf08ade$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($c29d101a2cf08ade$var$BeforeUnloadEventType, $c29d101a2cf08ade$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */ function $c29d101a2cf08ade$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options3 = options, _options3$initialEntr = _options3.initialEntries, initialEntries = _options3$initialEntr === void 0 ? [
        '/'
    ] : _options3$initialEntr, initialIndex = _options3.initialIndex;
    var entries = initialEntries.map(function(entry) {
        var location = $c29d101a2cf08ade$var$readOnly((0, $87uOn.default)({
            pathname: '/',
            search: '',
            hash: '',
            state: null,
            key: $c29d101a2cf08ade$var$createKey()
        }, typeof entry === 'string' ? $c29d101a2cf08ade$export$8ccf933b0513f8d0(entry) : entry));
        return location;
    });
    var index = $c29d101a2cf08ade$var$clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
    var location = entries[index];
    var listeners = $c29d101a2cf08ade$var$createEvents();
    var blockers = $c29d101a2cf08ade$var$createEvents();
    function createHref(to) {
        return typeof to === 'string' ? to : $c29d101a2cf08ade$export$fe53371bee54353d(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $c29d101a2cf08ade$var$readOnly((0, $87uOn.default)({
            pathname: location.pathname,
            search: '',
            hash: ''
        }, typeof to === 'string' ? $c29d101a2cf08ade$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $c29d101a2cf08ade$var$createKey()
        }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = $c29d101a2cf08ade$var$clamp(index + delta, 0, entries.length - 1);
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////
function $c29d101a2cf08ade$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function $c29d101a2cf08ade$var$promptBeforeUnload(event) {
    // Cancel the event.
    event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.
    event.returnValue = '';
}
function $c29d101a2cf08ade$var$createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function push(fn) {
            handlers.push(fn);
            return function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function call(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function $c29d101a2cf08ade$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */ function $c29d101a2cf08ade$export$fe53371bee54353d(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? '/' : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? '' : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? '' : _ref$hash;
    if (search && search !== '?') pathname += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') pathname += hash.charAt(0) === '#' ? hash : '#' + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */ function $c29d101a2cf08ade$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf('#');
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf('?');
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}

});

parcelRegister("b75yl", function(module, exports) {
$parcel$export(module.exports, "Redirect", () => (parcelRequire("inmj3")).Redirect);
$parcel$export(module.exports, "Router", () => (parcelRequire("j2pl3")).Router);
$parcel$export(module.exports, "usePathParam", () => (parcelRequire("7OyXD")).usePathParam);
$parcel$export(module.exports, "useQueryParam", () => (parcelRequire("dQa3A")).useQueryParam);
$parcel$export(module.exports, "useRouter", () => (parcelRequire("fsPVv")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("aZhFm")).useRouterActions);

var $inmj3 = parcelRequire("inmj3");

var $j2pl3 = parcelRequire("j2pl3");

var $kUmh0 = parcelRequire("kUmh0");

var $dVcvD = parcelRequire("dVcvD");

var $2yUAk = parcelRequire("2yUAk");

var $7OyXD = parcelRequire("7OyXD");

var $dQa3A = parcelRequire("dQa3A");

var $fsPVv = parcelRequire("fsPVv");

var $aZhFm = parcelRequire("aZhFm");

var $l3uV8 = parcelRequire("l3uV8");

});
parcelRegister("inmj3", function(module, exports) {
$parcel$export(module.exports, "Redirect", () => $d60bad8df7964b6c$export$2d8d895a0a0f636e);

var $87uOn = parcelRequire("87uOn");

var $7sAh5 = parcelRequire("7sAh5");

var $gHVeV = parcelRequire("gHVeV");

var $1v5pe = parcelRequire("1v5pe");
parcelRequire("i4lyD");
var $ab2Wt = parcelRequire("ab2Wt");

var $fsPVv = parcelRequire("fsPVv");
class $d60bad8df7964b6c$var$Redirector extends (0, $1v5pe.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === 'object' ? 'path' in to ? (0, $gHVeV.createPath)((0, $ab2Wt.generateLocationFromPath)(to.path, routeAttributes)) : (0, $gHVeV.createPath)(to) : to;
        const currentPath = (0, $gHVeV.createPath)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, $7sAh5.default)($d60bad8df7964b6c$var$Redirector, "defaultProps", {
    push: false
});
const $d60bad8df7964b6c$export$2d8d895a0a0f636e = (props)=>{
    const [{ location: location }, actions] = (0, $fsPVv.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($d60bad8df7964b6c$var$Redirector, (0, $87uOn.default)({
        actions: actions,
        location: location
    }, props));
};

});
parcelRegister("i4lyD", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => (parcelRequire("ab2Wt")).generateLocationFromPath);
$parcel$export(module.exports, "generatePath", () => (parcelRequire("j5iRK")).generatePath);
$parcel$export(module.exports, "isServerEnvironment", () => (parcelRequire("lsuSy")).isServerEnvironment);
$parcel$export(module.exports, "warmupMatchRouteCache", () => (parcelRequire("jULRR")).warmupMatchRouteCache);
$parcel$export(module.exports, "findRouterContext", () => (parcelRequire("1qFV0")).findRouterContext);
$parcel$export(module.exports, "createRouterContext", () => (parcelRequire("1qFV0")).createRouterContext);
$parcel$export(module.exports, "isSameRouteMatch", () => (parcelRequire("4fQCQ")).isSameRouteMatch);

var $dvc2F = parcelRequire("dvc2F");

var $ab2Wt = parcelRequire("ab2Wt");

var $j5iRK = parcelRequire("j5iRK");

var $lsuSy = parcelRequire("lsuSy");

var $jULRR = parcelRequire("jULRR");

var $1qFV0 = parcelRequire("1qFV0");

var $4fQCQ = parcelRequire("4fQCQ");

});
parcelRegister("dvc2F", function(module, exports) {
$parcel$export(module.exports, "createLegacyHistory", () => $9d4782ee5a008819$export$883c3f3b6c000133);

var $87uOn = parcelRequire("87uOn");

var $gHVeV = parcelRequire("gHVeV");

var $hGanY = parcelRequire("hGanY");

var $g6G0J = parcelRequire("g6G0J");
const $9d4782ee5a008819$var$hasWindow = ()=>typeof window !== 'undefined';
const $9d4782ee5a008819$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($g6G0J))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($g6G0J))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($g6G0J))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($g6G0J))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($g6G0J))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($g6G0J)))
};
const $9d4782ee5a008819$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $9d4782ee5a008819$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $9d4782ee5a008819$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector('#content');
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($hGanY)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $9d4782ee5a008819$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $9d4782ee5a008819$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $9d4782ee5a008819$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, $87uOn.default)({
        get location () {
            return currentLocation;
        },
        get length () {
            return $9d4782ee5a008819$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $9d4782ee5a008819$var$hasWindow() ? {
        push: (path)=>window.location.assign(typeof path === 'string' ? path : (0, $gHVeV.createPath)(path || {})),
        replace: (path)=>window.history.replaceState({}, document.title, typeof path === 'string' ? path : (0, $gHVeV.createPath)(path || {})),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $9d4782ee5a008819$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($g6G0J))),
        createHref: (location)=>(0, $gHVeV.createPath)(location)
    } : $9d4782ee5a008819$var$methodsPlaceholders);
};

});
parcelRegister("hGanY", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $cdee6a4bd96f30d1$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $cdee6a4bd96f30d1$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $cdee6a4bd96f30d1$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $cdee6a4bd96f30d1$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $cdee6a4bd96f30d1$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $cdee6a4bd96f30d1$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $cdee6a4bd96f30d1$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $cdee6a4bd96f30d1$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $cdee6a4bd96f30d1$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $cdee6a4bd96f30d1$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $cdee6a4bd96f30d1$var$root = $cdee6a4bd96f30d1$var$freeGlobal || $cdee6a4bd96f30d1$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $cdee6a4bd96f30d1$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $cdee6a4bd96f30d1$var$objectToString = $cdee6a4bd96f30d1$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $cdee6a4bd96f30d1$var$nativeMax = Math.max, $cdee6a4bd96f30d1$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $cdee6a4bd96f30d1$var$now = function() {
    return $cdee6a4bd96f30d1$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $cdee6a4bd96f30d1$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($cdee6a4bd96f30d1$var$FUNC_ERROR_TEXT);
    wait = $cdee6a4bd96f30d1$var$toNumber(wait) || 0;
    if ($cdee6a4bd96f30d1$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $cdee6a4bd96f30d1$var$nativeMax($cdee6a4bd96f30d1$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $cdee6a4bd96f30d1$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $cdee6a4bd96f30d1$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($cdee6a4bd96f30d1$var$now());
    }
    function debounced() {
        var time = $cdee6a4bd96f30d1$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $cdee6a4bd96f30d1$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $cdee6a4bd96f30d1$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $cdee6a4bd96f30d1$var$isSymbol(value) {
    return typeof value == 'symbol' || $cdee6a4bd96f30d1$var$isObjectLike(value) && $cdee6a4bd96f30d1$var$objectToString.call(value) == $cdee6a4bd96f30d1$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $cdee6a4bd96f30d1$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($cdee6a4bd96f30d1$var$isSymbol(value)) return $cdee6a4bd96f30d1$var$NAN;
    if ($cdee6a4bd96f30d1$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $cdee6a4bd96f30d1$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($cdee6a4bd96f30d1$var$reTrim, '');
    var isBinary = $cdee6a4bd96f30d1$var$reIsBinary.test(value);
    return isBinary || $cdee6a4bd96f30d1$var$reIsOctal.test(value) ? $cdee6a4bd96f30d1$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $cdee6a4bd96f30d1$var$reIsBadHex.test(value) ? $cdee6a4bd96f30d1$var$NAN : +value;
}
module.exports = $cdee6a4bd96f30d1$var$debounce;

});

parcelRegister("g6G0J", function(module, exports) {
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize include="noop" exports="npm" -o ./foo`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @category Util
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */ function $bb9dcb5956b29dc6$var$noop() {
// No operation performed.
}
module.exports = $bb9dcb5956b29dc6$var$noop;

});


parcelRegister("ab2Wt", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => $768d36b334678dfa$export$37e0729cc751960b);

var $MkcwS = parcelRequire("MkcwS");

var $ajSxF = parcelRequire("ajSxF");
function $768d36b334678dfa$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $ajSxF.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, $MkcwS.compile)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}

});
parcelRegister("MkcwS", function(module, exports) {
$parcel$export(module.exports, "compile", () => $09142752f95cb46b$export$ef7acd7185315e22);
$parcel$export(module.exports, "pathToRegexp", () => $09142752f95cb46b$export$71304158c7e35877);
/**
 * Tokenize input string.
 */ function $09142752f95cb46b$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $09142752f95cb46b$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $09142752f95cb46b$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a, _b = options.delimiter, delimiter = _b === void 0 ? "/#?" : _b;
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    var isSafe = function(value) {
        for(var _i = 0, delimiter_1 = delimiter; _i < delimiter_1.length; _i++){
            var char = delimiter_1[_i];
            if (value.indexOf(char) > -1) return true;
        }
        return false;
    };
    var safePattern = function(prefix) {
        var prev = result[result.length - 1];
        var prevText = prefix || (prev && typeof prev === "string" ? prev : "");
        if (prev && !prevText) throw new TypeError("Must have text between two parameters, missing text after \"".concat(prev.name, "\""));
        if (!prevText || isSafe(prevText)) return "[^".concat($09142752f95cb46b$var$escapeString(delimiter), "]+?");
        return "(?:(?!".concat($09142752f95cb46b$var$escapeString(prevText), ")[^").concat($09142752f95cb46b$var$escapeString(delimiter), "])+?");
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || safePattern(prefix),
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? safePattern(prefix) : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $09142752f95cb46b$export$ef7acd7185315e22(str, options) {
    return $09142752f95cb46b$export$5b9bad9e403cf3d9($09142752f95cb46b$export$98e6a39c04603d36(str, options), options);
}
function $09142752f95cb46b$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $09142752f95cb46b$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError("Expected \"".concat(token.name, "\" to not repeat, but got an array"));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError("Expected \"".concat(token.name, "\" to not be empty"));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError("Expected all \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError("Expected \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"".concat(token.name, "\" to be ").concat(typeOfMessage));
        }
        return path;
    };
}
function $09142752f95cb46b$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $09142752f95cb46b$export$71304158c7e35877(str, keys, options);
    return $09142752f95cb46b$export$968e97c88708237a(re, keys, options);
}
function $09142752f95cb46b$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $09142752f95cb46b$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $09142752f95cb46b$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $09142752f95cb46b$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $09142752f95cb46b$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $09142752f95cb46b$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $09142752f95cb46b$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $09142752f95cb46b$var$stringToRegexp(path, keys, options) {
    return $09142752f95cb46b$export$9a9303716def6456($09142752f95cb46b$export$98e6a39c04603d36(path, options), keys, options);
}
function $09142752f95cb46b$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($09142752f95cb46b$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($09142752f95cb46b$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $09142752f95cb46b$var$escapeString(encode(token));
        else {
            var prefix = $09142752f95cb46b$var$escapeString(encode(token.prefix));
            var suffix = $09142752f95cb46b$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else {
                    if (token.modifier === "+" || token.modifier === "*") throw new TypeError("Can not repeat \"".concat(token.name, "\" without a prefix and suffix"));
                    route += "(".concat(token.pattern, ")").concat(token.modifier);
                }
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $09142752f95cb46b$var$flags(options));
}
function $09142752f95cb46b$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $09142752f95cb46b$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $09142752f95cb46b$var$arrayToRegexp(path, keys, options);
    return $09142752f95cb46b$var$stringToRegexp(path, keys, options);
}

});

parcelRegister("ajSxF", function(module, exports) {
'use strict';

var $1b6Tk = parcelRequire("1b6Tk");

var $5BUaG = parcelRequire("5BUaG");
var $7835fc9d5dd24c3a$var$controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, $7835fc9d5dd24c3a$var$CRHTLF = /[\n\r\t]/g, $7835fc9d5dd24c3a$var$slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, $7835fc9d5dd24c3a$var$port = /:\d+$/, $7835fc9d5dd24c3a$var$protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, $7835fc9d5dd24c3a$var$windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function $7835fc9d5dd24c3a$var$trimLeft(str) {
    return (str ? str : '').toString().replace($7835fc9d5dd24c3a$var$controlOrWhitespace, '');
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var $7835fc9d5dd24c3a$var$rules = [
    [
        '#',
        'hash'
    ],
    [
        '?',
        'query'
    ],
    function sanitize(address, url) {
        return $7835fc9d5dd24c3a$var$isSpecial(url.protocol) ? address.replace(/\\/g, '/') : address;
    },
    [
        '/',
        'pathname'
    ],
    [
        '@',
        'auth',
        1
    ],
    [
        NaN,
        'host',
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        'port',
        undefined,
        1
    ],
    [
        NaN,
        'hostname',
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var $7835fc9d5dd24c3a$var$ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function $7835fc9d5dd24c3a$var$lolcation(loc) {
    var globalVar;
    if (typeof window !== 'undefined') globalVar = window;
    else if (typeof $parcel$global !== 'undefined') globalVar = $parcel$global;
    else if (typeof self !== 'undefined') globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc, key;
    if ('blob:' === loc.protocol) finaldestination = new $7835fc9d5dd24c3a$var$Url(unescape(loc.pathname), {});
    else if ('string' === type) {
        finaldestination = new $7835fc9d5dd24c3a$var$Url(loc, {});
        for(key in $7835fc9d5dd24c3a$var$ignore)delete finaldestination[key];
    } else if ('object' === type) {
        for(key in loc){
            if (key in $7835fc9d5dd24c3a$var$ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = $7835fc9d5dd24c3a$var$slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function $7835fc9d5dd24c3a$var$isSpecial(scheme) {
    return scheme === 'file:' || scheme === 'ftp:' || scheme === 'http:' || scheme === 'https:' || scheme === 'ws:' || scheme === 'wss:';
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function $7835fc9d5dd24c3a$var$extractProtocol(address, location) {
    address = $7835fc9d5dd24c3a$var$trimLeft(address);
    address = address.replace($7835fc9d5dd24c3a$var$CRHTLF, '');
    location = location || {};
    var match = $7835fc9d5dd24c3a$var$protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : '';
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === 'file:') {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if ($7835fc9d5dd24c3a$var$isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && $7835fc9d5dd24c3a$var$isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || $7835fc9d5dd24c3a$var$isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function $7835fc9d5dd24c3a$var$resolve(relative, base) {
    if (relative === '') return base;
    var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/')), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === '.') path.splice(i, 1);
        else if (path[i] === '..') {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift('');
    if (last === '.' || last === '..') path.push('');
    return path.join('/');
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function $7835fc9d5dd24c3a$var$Url(address, location, parser) {
    address = $7835fc9d5dd24c3a$var$trimLeft(address);
    address = address.replace($7835fc9d5dd24c3a$var$CRHTLF, '');
    if (!(this instanceof $7835fc9d5dd24c3a$var$Url)) return new $7835fc9d5dd24c3a$var$Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = $7835fc9d5dd24c3a$var$rules.slice(), type = typeof location, url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ('object' !== type && 'string' !== type) {
        parser = location;
        location = null;
    }
    if (parser && 'function' !== typeof parser) parser = $5BUaG.parse;
    location = $7835fc9d5dd24c3a$var$lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = $7835fc9d5dd24c3a$var$extractProtocol(address || '', location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || '';
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === 'file:' && (extracted.slashesCount !== 2 || $7835fc9d5dd24c3a$var$windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !$7835fc9d5dd24c3a$var$isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        'pathname'
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === 'function') {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ('string' === typeof parse) {
            index = parse === '@' ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ('number' === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || '' : '');
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== '/' && (url.pathname !== '' || location.pathname !== '')) url.pathname = $7835fc9d5dd24c3a$var$resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== '/' && $7835fc9d5dd24c3a$var$isSpecial(url.protocol)) url.pathname = '/' + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!$1b6Tk(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = '';
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = '';
    if (url.auth) {
        index = url.auth.indexOf(':');
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ':' + url.password : url.username;
    }
    url.origin = url.protocol !== 'file:' && $7835fc9d5dd24c3a$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function $7835fc9d5dd24c3a$var$set(part, value, fn) {
    var url = this;
    switch(part){
        case 'query':
            if ('string' === typeof value && value.length) value = (fn || $5BUaG.parse)(value);
            url[part] = value;
            break;
        case 'port':
            url[part] = value;
            if (!$1b6Tk(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = '';
            } else if (value) url.host = url.hostname + ':' + value;
            break;
        case 'hostname':
            url[part] = value;
            if (url.port) value += ':' + url.port;
            url.host = value;
            break;
        case 'host':
            url[part] = value;
            if ($7835fc9d5dd24c3a$var$port.test(value)) {
                value = value.split(':');
                url.port = value.pop();
                url.hostname = value.join(':');
            } else {
                url.hostname = value;
                url.port = '';
            }
            break;
        case 'protocol':
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case 'pathname':
        case 'hash':
            if (value) {
                var char = part === 'pathname' ? '/' : '#';
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case 'username':
        case 'password':
            url[part] = encodeURIComponent(value);
            break;
        case 'auth':
            var index = value.indexOf(':');
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < $7835fc9d5dd24c3a$var$rules.length; i++){
        var ins = $7835fc9d5dd24c3a$var$rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ':' + url.password : url.username;
    url.origin = url.protocol !== 'file:' && $7835fc9d5dd24c3a$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function $7835fc9d5dd24c3a$var$toString(stringify) {
    if (!stringify || 'function' !== typeof stringify) stringify = $5BUaG.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
    var result = protocol + (url.protocol && url.slashes || $7835fc9d5dd24c3a$var$isSpecial(url.protocol) ? '//' : '');
    if (url.username) {
        result += url.username;
        if (url.password) result += ':' + url.password;
        result += '@';
    } else if (url.password) {
        result += ':' + url.password;
        result += '@';
    } else if (url.protocol !== 'file:' && $7835fc9d5dd24c3a$var$isSpecial(url.protocol) && !host && url.pathname !== '/') //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += '@';
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ':' || $7835fc9d5dd24c3a$var$port.test(url.hostname) && !url.port) host += ':';
    result += host + url.pathname;
    query = 'object' === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += '?' !== query.charAt(0) ? '?' + query : query;
    if (url.hash) result += url.hash;
    return result;
}
$7835fc9d5dd24c3a$var$Url.prototype = {
    set: $7835fc9d5dd24c3a$var$set,
    toString: $7835fc9d5dd24c3a$var$toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
$7835fc9d5dd24c3a$var$Url.extractProtocol = $7835fc9d5dd24c3a$var$extractProtocol;
$7835fc9d5dd24c3a$var$Url.location = $7835fc9d5dd24c3a$var$lolcation;
$7835fc9d5dd24c3a$var$Url.trimLeft = $7835fc9d5dd24c3a$var$trimLeft;
$7835fc9d5dd24c3a$var$Url.qs = $5BUaG;
module.exports = $7835fc9d5dd24c3a$var$Url;

});
parcelRegister("1b6Tk", function(module, exports) {
'use strict';
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ module.exports = function required(port, protocol) {
    protocol = protocol.split(':')[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case 'http':
        case 'ws':
            return port !== 80;
        case 'https':
        case 'wss':
            return port !== 443;
        case 'ftp':
            return port !== 21;
        case 'gopher':
            return port !== 70;
        case 'file':
            return false;
    }
    return port !== 0;
};

});

parcelRegister("5BUaG", function(module, exports) {
$parcel$export(module.exports, "stringify", () => $415bfaed3ad1f82b$export$fac44ee5b035f737, (v) => $415bfaed3ad1f82b$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parse", () => $415bfaed3ad1f82b$export$98e6a39c04603d36, (v) => $415bfaed3ad1f82b$export$98e6a39c04603d36 = v);
//
// Expose the module.
//
var $415bfaed3ad1f82b$export$fac44ee5b035f737;
var $415bfaed3ad1f82b$export$98e6a39c04603d36;
'use strict';
var $415bfaed3ad1f82b$var$has = Object.prototype.hasOwnProperty, $415bfaed3ad1f82b$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $415bfaed3ad1f82b$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $415bfaed3ad1f82b$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $415bfaed3ad1f82b$var$querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $415bfaed3ad1f82b$var$decode(part[1]), value = $415bfaed3ad1f82b$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $415bfaed3ad1f82b$var$querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(key in obj)if ($415bfaed3ad1f82b$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $415bfaed3ad1f82b$var$undef || isNaN(value))) value = '';
        key = $415bfaed3ad1f82b$var$encode(key);
        value = $415bfaed3ad1f82b$var$encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + '=' + value);
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
$415bfaed3ad1f82b$export$fac44ee5b035f737 = $415bfaed3ad1f82b$var$querystringify;
$415bfaed3ad1f82b$export$98e6a39c04603d36 = $415bfaed3ad1f82b$var$querystring;

});



parcelRegister("j5iRK", function(module, exports) {
$parcel$export(module.exports, "generatePath", () => $de4d1e4f61a87867$export$82476f982757e71e);

var $MkcwS = parcelRequire("MkcwS");
const $de4d1e4f61a87867$export$82476f982757e71e = (pattern = '/', params)=>pattern === '/' ? pattern : (0, $MkcwS.compile)(pattern)(params);

});

parcelRegister("lsuSy", function(module, exports) {
$parcel$export(module.exports, "isServerEnvironment", () => $f9f42a63082f8b8d$export$455cc18296abe008);
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $k1Wvt = parcelRequire("k1Wvt");
const $f9f42a63082f8b8d$var$isJsDomEnvironment = ()=>{
    var _navigator, _navigator2;
    return window.name === 'nodejs' || ((_navigator = navigator) == null ? void 0 : _navigator.userAgent.includes('Node.js')) || ((_navigator2 = navigator) == null ? void 0 : _navigator2.userAgent.includes('jsdom'));
};
const $f9f42a63082f8b8d$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $k1Wvt !== 'undefined' && $k1Wvt.versions != null && $k1Wvt.versions.node != null) return true;
    if ($f9f42a63082f8b8d$var$isJsDomEnvironment()) return true;
    return false;
};

});

parcelRegister("jULRR", function(module, exports) {
$parcel$export(module.exports, "warmupMatchRouteCache", () => $e7f860d2e0e9373c$export$4e76f1d455ef7c95);
$parcel$export(module.exports, "default", () => $e7f860d2e0e9373c$export$2e2bcd8739ae039);

var $ajSxF = parcelRequire("ajSxF");

var $lrd3Q = parcelRequire("lrd3Q");

var $7Fcdh = parcelRequire("7Fcdh");
/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $e7f860d2e0e9373c$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    // if navigating to to `/` or just basePath, then do not append basePath
    const updatedBasePath = [
        '/',
        basePath
    ].includes(pathname) ? '' : basePath;
    const queryParamObject = typeof queryParams === 'string' ? (0, $ajSxF.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $7Fcdh.matchRouteCache).get(pathname, queryParamObject, updatedBasePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $lrd3Q.default)(routes[i], pathname, queryParamObject, updatedBasePath);
        if (matchedRoute) {
            (0, $7Fcdh.matchRouteCache).set(pathname, queryParamObject, updatedBasePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $e7f860d2e0e9373c$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>$e7f860d2e0e9373c$var$matchRoute(routes, pathname, queryParams, basePath);
const $e7f860d2e0e9373c$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    $e7f860d2e0e9373c$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $e7f860d2e0e9373c$export$2e2bcd8739ae039 = (routes, pathname, queryParams, basePath = '')=>$e7f860d2e0e9373c$var$matchRoute(routes, pathname, queryParams, basePath);

});
parcelRegister("lrd3Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9b6403fcc99d44d$export$2e2bcd8739ae039);

var $87uOn = parcelRequire("87uOn");

var $jT8pW = parcelRequire("jT8pW");

var $5j5Fj = parcelRequire("5j5Fj");
/* This should match what react-router does to compute a root match. */ const $f9b6403fcc99d44d$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $f9b6403fcc99d44d$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $jT8pW.default)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $f9b6403fcc99d44d$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $5j5Fj.default)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, $87uOn.default)({}, pathMatch, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $f9b6403fcc99d44d$export$2e2bcd8739ae039 = $f9b6403fcc99d44d$var$execRouteMatching;

});
parcelRegister("jT8pW", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7a9aee364b5805f$export$2e2bcd8739ae039);
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $MkcwS = parcelRequire("MkcwS");
const $e7a9aee364b5805f$var$cache = {};
const $e7a9aee364b5805f$var$cacheLimit = 10000;
let $e7a9aee364b5805f$var$cacheCount = 0;
function $e7a9aee364b5805f$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $e7a9aee364b5805f$var$cache[cacheKey] || ($e7a9aee364b5805f$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $MkcwS.pathToRegexp)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($e7a9aee364b5805f$var$cacheCount < $e7a9aee364b5805f$var$cacheLimit) {
        pathCache[path] = result;
        $e7a9aee364b5805f$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $e7a9aee364b5805f$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $e7a9aee364b5805f$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === '/' && url === '' ? '/' : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $e7a9aee364b5805f$export$2e2bcd8739ae039 = $e7a9aee364b5805f$var$matchPath;

});

parcelRegister("5j5Fj", function(module, exports) {
$parcel$export(module.exports, "default", () => $3dd31f20fffa4bf7$export$2e2bcd8739ae039);

var $87uOn = parcelRequire("87uOn");
/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $3dd31f20fffa4bf7$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, $87uOn.default)({}, pathMatch, {
        query: queryMatch
    }) : null;
}
var $3dd31f20fffa4bf7$export$2e2bcd8739ae039 = $3dd31f20fffa4bf7$var$matchQuery;

});


parcelRegister("7Fcdh", function(module, exports) {
$parcel$export(module.exports, "matchRouteCache", () => $5945d60cd4066b5d$export$f594abf16a5ad948);
const $5945d60cd4066b5d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $5945d60cd4066b5d$var$MAX_CACHE_SIZE = 1000;
function $5945d60cd4066b5d$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$5945d60cd4066b5d$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $5945d60cd4066b5d$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($5945d60cd4066b5d$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $5945d60cd4066b5d$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $5945d60cd4066b5d$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};

});


parcelRegister("1qFV0", function(module, exports) {
$parcel$export(module.exports, "createRouterContext", () => $10a8bc47d57825ec$export$faed15f35ddc6f99);
$parcel$export(module.exports, "findRouterContext", () => $10a8bc47d57825ec$export$a0bd0313cbeabd49);

var $ajSxF = parcelRequire("ajSxF");

var $5lbjJ = parcelRequire("5lbjJ");

var $j5iRK = parcelRequire("j5iRK");

var $jULRR = parcelRequire("jULRR");
const $10a8bc47d57825ec$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $j5iRK.generatePath)(route.path, params);
    const matchedRoute = (0, $jULRR.default)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $5lbjJ.DEFAULT_MATCH),
        query: query
    };
};
const $10a8bc47d57825ec$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $ajSxF.qs).parse(search);
    const matchedRoute = (0, $jULRR.default)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $5lbjJ.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, $5lbjJ.DEFAULT_MATCH)
    };
};

});
parcelRegister("5lbjJ", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_MATCH", () => $0100e5f4b4767f2b$export$2de13e891a662beb);
$parcel$export(module.exports, "DEFAULT_ROUTE", () => $0100e5f4b4767f2b$export$4eadc79233226325);
$parcel$export(module.exports, "DEFAULT_HISTORY", () => $0100e5f4b4767f2b$export$39607c9878cf5148);
$parcel$export(module.exports, "DEFAULT_ACTION", () => $0100e5f4b4767f2b$export$fa440ddf675c8a93);

var $g6G0J = parcelRequire("g6G0J");

var $dvc2F = parcelRequire("dvc2F");
const $0100e5f4b4767f2b$export$7c22f8f9552f689e = {
    pathname: '',
    search: '',
    hash: ''
};
const $0100e5f4b4767f2b$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $0100e5f4b4767f2b$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $0100e5f4b4767f2b$export$39607c9878cf5148 = (0, $dvc2F.createLegacyHistory)();
const $0100e5f4b4767f2b$export$1515254c8c90bebb = {
    location: $0100e5f4b4767f2b$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($g6G0J))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($g6G0J))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($g6G0J))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($g6G0J))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($g6G0J))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($g6G0J))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($g6G0J)))
};
const $0100e5f4b4767f2b$export$fa440ddf675c8a93 = 'POP';

});


parcelRegister("4fQCQ", function(module, exports) {
$parcel$export(module.exports, "isSameRouteMatch", () => $31916272644d9021$export$5997e70fc4543270);
const $31916272644d9021$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $31916272644d9021$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $31916272644d9021$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $31916272644d9021$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});


parcelRegister("fsPVv", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => $b421c015f5018cd0$export$9a302a45f65d0572);

var $2yUAk = parcelRequire("2yUAk");
const $b421c015f5018cd0$export$9a302a45f65d0572 = (0, $2yUAk.useRouterStore);

});
parcelRegister("2yUAk", function(module, exports) {
$parcel$export(module.exports, "RouterStore", () => $1ddaa6502d719738$export$1cf0ecab63b1963c);
$parcel$export(module.exports, "RouterContainer", () => $1ddaa6502d719738$export$d6b817abe7a77ea5);
$parcel$export(module.exports, "useRouterStore", () => $1ddaa6502d719738$export$9569010eab09ae9e);
$parcel$export(module.exports, "useRouterStoreActions", () => $1ddaa6502d719738$export$ada49399abf7a3a1);

var $87uOn = parcelRequire("87uOn");

var $gHVeV = parcelRequire("gHVeV");

var $9SHd3 = parcelRequire("9SHd3");
var $lO7p1 = parcelRequire("lO7p1");
var $5U9wF = parcelRequire("5U9wF");
var $eB2PL = parcelRequire("eB2PL");
var $5gTHJ = parcelRequire("5gTHJ");

var $5lbjJ = parcelRequire("5lbjJ");
parcelRequire("i4lyD");
var $1qFV0 = parcelRequire("1qFV0");
var $ab2Wt = parcelRequire("ab2Wt");
var $j5iRK = parcelRequire("j5iRK");
var $lsuSy = parcelRequire("lsuSy");
var $jULRR = parcelRequire("jULRR");

var $gFibE = parcelRequire("gFibE");
const $1ddaa6502d719738$export$36d128238e6b60f5 = {
    action: (0, $5lbjJ.DEFAULT_ACTION),
    basePath: '',
    location: (0, $5lbjJ.DEFAULT_HISTORY).location,
    history: (0, $5lbjJ.DEFAULT_HISTORY),
    match: (0, $5lbjJ.DEFAULT_MATCH),
    onPrefetch: undefined,
    query: {},
    route: (0, $5lbjJ.DEFAULT_ROUTE),
    routes: [],
    unlisten: null,
    plugins: []
};
const $1ddaa6502d719738$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { basePath: basePath = '', history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins } = props;
            const routerContext = (0, $1qFV0.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, $87uOn.default)({}, routerContext, {
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins
            }));
            if (!(0, $lsuSy.isServerEnvironment)()) dispatch($1ddaa6502d719738$var$actions.listen());
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const nextContext = (0, $1qFV0.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $gFibE.shouldReload)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $9SHd3.batch)(()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad == null || p.beforeRouteLoad({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    setState((0, $87uOn.default)({}, nextContext, {
                        location: location,
                        action: action
                    }));
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad == null || p.routeLoad({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $gFibE.isExternalAbsolutePath)(path)) window.location.assign(path);
            else history.push((0, $gFibE.getRelativePath)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $ab2Wt.generateLocationFromPath)(route.path, (0, $87uOn.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $jULRR.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes == null ? void 0 : attributes.state);
        },
    replace: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $gFibE.isExternalAbsolutePath)(path)) window.location.replace(path);
            else history.replace((0, $gFibE.getRelativePath)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $ab2Wt.generateLocationFromPath)(route.path, (0, $87uOn.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $jULRR.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes == null ? void 0 : attributes.state);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ('goBack' in history) history.goBack();
            else if ('back' in history) history.back();
            else throw new Error('History does not support goBack');
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ('goForward' in history) history.goForward();
            else if ('forward' in history) history.forward();
            else throw new Error('History does not support goForward');
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, $87uOn.default)({}, existingQueryParams, params);
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $gFibE.updateQueryParams)(location, existingQueryParams);
            const updatedPath = (0, $gFibE.updateQueryParams)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, $87uOn.default)({}, existingPathParams, params);
            const updatedPath = (0, $j5iRK.generatePath)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, $87uOn.default)({}, location, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $gFibE.getRelativeURLFromLocation)(location);
            const updatedRelativePath = (0, $gFibE.getRelativeURLFromLocation)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState: getState })=>{
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad == null ? void 0 : p.routeLoad({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState: getState })=>{
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $1ddaa6502d719738$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $gFibE.isExternalAbsolutePath)(path)) {
                const location = (0, $gHVeV.parsePath)((0, $gFibE.getRelativePath)(path, basePath));
                nextContext = (0, $1qFV0.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $9SHd3.batch)(()=>{
                plugins.forEach((p)=>p.routePrefetch == null ? void 0 : p.routePrefetch({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        }
};
const $1ddaa6502d719738$export$1cf0ecab63b1963c = (0, $eB2PL.createStore)({
    initialState: $1ddaa6502d719738$export$36d128238e6b60f5,
    actions: $1ddaa6502d719738$var$actions,
    name: 'router'
});
const $1ddaa6502d719738$export$d6b817abe7a77ea5 = (0, $5U9wF.createContainer)($1ddaa6502d719738$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($1ddaa6502d719738$var$actions.bootstrapStore(props));
            !(0, $lsuSy.isServerEnvironment)() && dispatch($1ddaa6502d719738$var$actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, $lsuSy.isServerEnvironment)()) {
                const { unlisten: unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const $1ddaa6502d719738$export$9569010eab09ae9e = (0, $lO7p1.createHook)($1ddaa6502d719738$export$1cf0ecab63b1963c);
const $1ddaa6502d719738$export$ada49399abf7a3a1 = (0, $lO7p1.createActionsHook)($1ddaa6502d719738$export$1cf0ecab63b1963c);
function $1ddaa6502d719738$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $lO7p1.createHook)($1ddaa6502d719738$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const $1ddaa6502d719738$export$5ccad187366c8494 = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, $5gTHJ.defaultRegistry).getStore($1ddaa6502d719738$export$1cf0ecab63b1963c);
const $1ddaa6502d719738$export$ebf37f7e180b13a9 = ()=>$1ddaa6502d719738$export$5ccad187366c8494().storeState.getState();

});
parcelRegister("9SHd3", function(module, exports) {
$parcel$export(module.exports, "batch", () => $731aacb7e11196a4$export$712ea50be43a7858);
/* eslint-disable import/no-unresolved */ 
var $fBuCt = parcelRequire("fBuCt");

var $hziAm = parcelRequire("hziAm");

var $5mVPL = parcelRequire("5mVPL");

var $f9e24 = parcelRequire("f9e24");
let $731aacb7e11196a4$var$isInsideBatchedSchedule = false;
function $731aacb7e11196a4$export$712ea50be43a7858(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, $5mVPL.default).batchUpdates || !(0, $f9e24.default).scheduling() || $731aacb7e11196a4$var$isInsideBatchedSchedule) return (0, $fBuCt.unstable_batchedUpdates)(fn);
    $731aacb7e11196a4$var$isInsideBatchedSchedule = true; // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, $hziAm.unstable_scheduleCallback)((0, $hziAm.unstable_ImmediatePriority), function scheduleBatchedUpdates() {
        (0, $fBuCt.unstable_batchedUpdates)(fn);
        $731aacb7e11196a4$var$isInsideBatchedSchedule = false;
    });
}

});
parcelRegister("5mVPL", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e8bde725c61a622$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");
const $3e8bde725c61a622$var$defaultMutator = (prevState, partialState)=>{
    // Merge the partial state and the previous state.
    return Object.assign({}, prevState, partialState);
};
const $3e8bde725c61a622$var$defaults = {
    batchUpdates: 'useSyncExternalStore' in (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))),
    devtools: false,
    middlewares: new Set(),
    mutator: $3e8bde725c61a622$var$defaultMutator
};
var $3e8bde725c61a622$export$2e2bcd8739ae039 = $3e8bde725c61a622$var$defaults;

});

parcelRegister("f9e24", function(module, exports) {
$parcel$export(module.exports, "default", () => $b07294d1c2f2e794$export$2e2bcd8739ae039);
const $b07294d1c2f2e794$var$supports = {
    scheduling () {
        return typeof window !== 'undefined' && typeof MessageChannel === 'function';
    }
};
var $b07294d1c2f2e794$export$2e2bcd8739ae039 = $b07294d1c2f2e794$var$supports;

});


parcelRegister("lO7p1", function(module, exports) {
$parcel$export(module.exports, "createHook", () => $fe0402804117f292$export$e7f733c8fc2b8a24);
$parcel$export(module.exports, "createActionsHook", () => $fe0402804117f292$export$7c643e1d6648e418);
$parcel$export(module.exports, "createStateHook", () => $fe0402804117f292$export$6e4e5611de132e85);

var $1v5pe = parcelRequire("1v5pe");

var $9g1Mt = parcelRequire("9g1Mt");

var $4jreY = parcelRequire("4jreY");

var $5AjMj = parcelRequire("5AjMj");
const $fe0402804117f292$var$EMPTY_SELECTOR = ()=>undefined;
const $fe0402804117f292$var$DEFAULT_SELECTOR = (state)=>state;
function $fe0402804117f292$export$e7f733c8fc2b8a24(Store, _temp) {
    let { selector: selector } = _temp === void 0 ? {} : _temp;
    return function useSweetState(propsArg) {
        const { retrieveStore: retrieveStore } = (0, $1v5pe.useContext)((0, $4jreY.Context));
        const { storeState: storeState, actions: actions } = retrieveStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, $1v5pe.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, $1v5pe.useMemo)(()=>selector ? (0, $5AjMj.getSelectorInstance)(selector, storeState, hasPropsArg) : selector === null ? $fe0402804117f292$var$EMPTY_SELECTOR : $fe0402804117f292$var$DEFAULT_SELECTOR, [
            hasPropsArg,
            storeState
        ]);
        const forceUpdate = (0, $1v5pe.useState)({})[1];
        const getSnapshot = (0, $1v5pe.useCallback)(()=>{
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            const state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        const currentState = (0, $9g1Mt.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function $fe0402804117f292$export$7c643e1d6648e418(Store) {
    const useHook = $fe0402804117f292$export$e7f733c8fc2b8a24(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function $fe0402804117f292$export$6e4e5611de132e85(Store, _temp2) {
    let { selector: selector } = _temp2 === void 0 ? {} : _temp2;
    const useHook = $fe0402804117f292$export$e7f733c8fc2b8a24(Store, {
        selector: selector
    });
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}

});
parcelRegister("9g1Mt", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6497j"));

});
parcelRegister("6497j", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStore", () => $46aa3040eccd1d7c$export$306c0aa65ff9ec16, (v) => $46aa3040eccd1d7c$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $46aa3040eccd1d7c$export$306c0aa65ff9ec16;
"use strict";

var $1v5pe = parcelRequire("1v5pe");
function $46aa3040eccd1d7c$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $46aa3040eccd1d7c$var$objectIs = "function" === typeof Object.is ? Object.is : $46aa3040eccd1d7c$var$is, $46aa3040eccd1d7c$var$useState = $1v5pe.useState, $46aa3040eccd1d7c$var$useEffect = $1v5pe.useEffect, $46aa3040eccd1d7c$var$useLayoutEffect = $1v5pe.useLayoutEffect, $46aa3040eccd1d7c$var$useDebugValue = $1v5pe.useDebugValue;
function $46aa3040eccd1d7c$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $46aa3040eccd1d7c$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $46aa3040eccd1d7c$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $46aa3040eccd1d7c$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $46aa3040eccd1d7c$var$useEffect(function() {
        $46aa3040eccd1d7c$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $46aa3040eccd1d7c$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $46aa3040eccd1d7c$var$useDebugValue(value);
    return value;
}
function $46aa3040eccd1d7c$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$46aa3040eccd1d7c$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $46aa3040eccd1d7c$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $46aa3040eccd1d7c$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $46aa3040eccd1d7c$var$useSyncExternalStore$1 : $46aa3040eccd1d7c$var$useSyncExternalStore$2;
$46aa3040eccd1d7c$export$306c0aa65ff9ec16 = void 0 !== $1v5pe.useSyncExternalStore ? $1v5pe.useSyncExternalStore : $46aa3040eccd1d7c$var$shim;

});


parcelRegister("4jreY", function(module, exports) {
$parcel$export(module.exports, "Context", () => $323e112caabc4035$export$841858b892ce1f4c);

var $1v5pe = parcelRequire("1v5pe");

var $5gTHJ = parcelRequire("5gTHJ");
const $323e112caabc4035$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createContext({
    globalRegistry: (0, $5gTHJ.defaultRegistry),
    retrieveStore: (Store)=>(0, $5gTHJ.defaultRegistry).getStore(Store)
}, ()=>0);

});
parcelRegister("5gTHJ", function(module, exports) {
$parcel$export(module.exports, "StoreRegistry", () => $3d69a813d4d6a168$export$acb47f32da33501e);
$parcel$export(module.exports, "defaultRegistry", () => $3d69a813d4d6a168$export$9d726ae4880b1060);

var $f9e24 = parcelRequire("f9e24");

var $6P0gD = parcelRequire("6P0gD");

var $hqIWy = parcelRequire("hqIWy");
const $3d69a813d4d6a168$export$e4d628ba0054221b = '__global__';
class $3d69a813d4d6a168$export$acb47f32da33501e {
    constructor(defaultScope){
        var _this = this;
        if (defaultScope === void 0) defaultScope = $3d69a813d4d6a168$export$e4d628ba0054221b;
        this.stores = new Map();
        this.initStore = (key, Store, config)=>{
            const { initialState: initialState, actions: actions } = Store;
            if (Store.containedBy && !config.contained(Store)) {
                const err = new Error(`Store ${Store.key} should be contained by a container but it is used globally. ` + `While it might still work, it will likely cause unexpected behaviours.`);
                if ((0, $f9e24.default).scheduling()) Promise.reject(err);
                else throw err;
            }
            const storeState = (0, $hqIWy.default)(key, initialState);
            let boundActions;
            const store = {
                storeState: storeState,
                // these are used only when container-less, so we generate them on-demand
                get actions () {
                    if (!boundActions) boundActions = (0, $6P0gD.bindActions)(actions, storeState, config);
                    return boundActions;
                }
            };
            this.stores.set(key, store);
            return store;
        };
        this.hasStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.has(key);
        };
        this.getStore = function(Store, scopeId, config) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            if (config === void 0) config = {
                props: ()=>({}),
                contained: ()=>false
            };
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.get(key) || config && _this.initStore(key, Store, config);
        };
        this.deleteStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            _this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
const $3d69a813d4d6a168$export$9d726ae4880b1060 = new $3d69a813d4d6a168$export$acb47f32da33501e();

});
parcelRegister("6P0gD", function(module, exports) {
$parcel$export(module.exports, "bindActions", () => $4f77b68f274309ac$export$5ee1d46cd0883a22);

var $5mVPL = parcelRequire("5mVPL");
const $4f77b68f274309ac$var$namedMutator = (storeState, actionName)=>function() {
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arguments);
    };
const $4f77b68f274309ac$var$warnings = new WeakMap();
const $4f77b68f274309ac$export$5f944353e69b9bf3 = (storeState, actionFn, actionKey, config, actions)=>{
    const callThunk = (instance, thunkFn, actionName)=>thunkFn({
            setState: (0, $5mVPL.default).devtools ? $4f77b68f274309ac$var$namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            get actions () {
                if (!$4f77b68f274309ac$var$warnings.has(actionFn)) $4f77b68f274309ac$var$warnings.set(actionFn, console.warn(`react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. ` + `Please check action '${actionName}' of Store '${instance.storeState.key}' and use 'dispatch' instead`));
                return actions;
            },
            dispatch: (tFn)=>callThunk(instance, tFn, `${actionName}.dispatch`)
        }, config.props());
    return function() {
        return callThunk({
            storeState: storeState,
            actions: actions
        }, actionFn(...arguments), actionKey);
    };
};
const $4f77b68f274309ac$export$5ee1d46cd0883a22 = function bindActions(actions, storeState, config, boundActions) {
    if (boundActions === void 0) boundActions = null;
    return Object.keys(actions).reduce((acc, k)=>{
        acc[k] = $4f77b68f274309ac$export$5f944353e69b9bf3(storeState, actions[k], k, config, boundActions || acc);
        return acc;
    }, {});
};

});

parcelRegister("hqIWy", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb07ba34ce2c72ad$export$2e2bcd8739ae039);

var $fgnS2 = parcelRequire("fgnS2");

var $ju84g = parcelRequire("ju84g");

var $5mVPL = parcelRequire("5mVPL");

var $jpkJ7 = parcelRequire("jpkJ7");
function $cb07ba34ce2c72ad$var$createStoreState(key, initialState) {
    let listeners = new Set();
    let currentState = initialState;
    const storeState = {
        key: key,
        getState () {
            return currentState;
        },
        setState (nextState) {
            currentState = nextState; // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, $jpkJ7.default)(storeState.notify);
        },
        resetState () {
            storeState.setState(initialState);
        },
        notify () {
            for (const listener of listeners)listener(storeState.getState());
        },
        subscribe (listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners () {
            return listeners;
        }
    };
    storeState.mutator = (0, $fgnS2.default)(storeState, (0, $5mVPL.default).middlewares);
    return storeState;
}
var $cb07ba34ce2c72ad$export$2e2bcd8739ae039 = (0, $ju84g.default)($cb07ba34ce2c72ad$var$createStoreState);

});
parcelRegister("fgnS2", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1caddd0cdf7760e$export$2e2bcd8739ae039);

var $5mVPL = parcelRequire("5mVPL");

var $axBs9 = parcelRequire("axBs9");
const $b1caddd0cdf7760e$var$applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, $axBs9.default)).reduceRight((next, mw)=>mw(storeState)(next), (0, $5mVPL.default).mutator);
var $b1caddd0cdf7760e$export$2e2bcd8739ae039 = $b1caddd0cdf7760e$var$applyMiddleware;

});
parcelRegister("axBs9", function(module, exports) {
$parcel$export(module.exports, "default", () => $7aca09d6e4597c5d$export$2e2bcd8739ae039);

var $exYRi = parcelRequire("exYRi");
const $7aca09d6e4597c5d$var$updateMiddleware = (storeState)=>(next)=>(arg)=>{
            let output;
            const state = storeState.getState();
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, $exYRi.default)(nextState, state)) storeState.setState(nextState);
            return output;
        };
var $7aca09d6e4597c5d$export$2e2bcd8739ae039 = $7aca09d6e4597c5d$var$updateMiddleware;

});
parcelRegister("exYRi", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9735b05315e2614$export$2e2bcd8739ae039);
// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
const $a9735b05315e2614$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $a9735b05315e2614$var$CACHE = new WeakMap();
function $a9735b05315e2614$export$2e2bcd8739ae039(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    } else {
        // Handle Date, RegExp, String, Number, ... and complex objects
        const strA = '' + objA;
        const strB = '' + objB;
        if (strA !== strB || strA[0] === '[' && strA !== '[object Object]') return false;
         // do object comparison
        let keysA;
        if ($a9735b05315e2614$var$CACHE.has(objA)) keysA = $a9735b05315e2614$var$CACHE.get(objA);
        else {
            keysA = Object.keys(objA);
            $a9735b05315e2614$var$CACHE.set(objA, keysA);
        }
        let keysB;
        if ($a9735b05315e2614$var$CACHE.has(objB)) keysB = $a9735b05315e2614$var$CACHE.get(objB);
        else {
            keysB = Object.keys(objB);
            $a9735b05315e2614$var$CACHE.set(objB, keysB);
        }
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(let i = 0; i < keysA.length; i++){
            if (!$a9735b05315e2614$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        }
        return true;
    }
}

});



parcelRegister("ju84g", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2f713bc7bb30ec9$export$2e2bcd8739ae039);

var $5mVPL = parcelRequire("5mVPL");
const $e2f713bc7bb30ec9$var$connectDevTools = (storeState, config)=>{
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(Object.assign({
        name: `Store ${storeState.key}`,
        serialize: true,
        trace: true
    }, config));
    devTools.init(storeState.getState());
    devTools.subscribe((message)=>{
        if (message.type === 'DISPATCH') switch(message.payload.type){
            case 'RESET':
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case 'COMMIT':
                devTools.init(storeState.getState());
                return;
            case 'ROLLBACK':
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case 'JUMP_TO_STATE':
            case 'JUMP_TO_ACTION':
                storeState.setState(JSON.parse(message.state));
                return;
        }
        else if (message.type === 'ACTION') {
            let action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const $e2f713bc7bb30ec9$var$withDevtools = (createStoreState)=>function() {
        const storeState = createStoreState(...arguments);
        if ((0, $5mVPL.default).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            let devTools;
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, $5mVPL.default).devtools === 'function' ? (0, $5mVPL.default).devtools(storeState) : {};
                        devTools = $e2f713bc7bb30ec9$var$connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
var $e2f713bc7bb30ec9$export$2e2bcd8739ae039 = $e2f713bc7bb30ec9$var$withDevtools;

});

parcelRegister("jpkJ7", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2106e01f0383ad5$export$2e2bcd8739ae039);

var $5mVPL = parcelRequire("5mVPL");

var $9SHd3 = parcelRequire("9SHd3");

var $f9e24 = parcelRequire("f9e24");
const $e2106e01f0383ad5$var$QUEUE = [];
let $e2106e01f0383ad5$var$scheduled;
function $e2106e01f0383ad5$export$2e2bcd8739ae039(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, $5mVPL.default).batchUpdates || !(0, $f9e24.default).scheduling()) return (0, $9SHd3.batch)(()=>fn()); // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!$e2106e01f0383ad5$var$QUEUE.includes(fn)) $e2106e01f0383ad5$var$QUEUE.push(fn); // if something already started schedule, skip
    if ($e2106e01f0383ad5$var$scheduled) return;
    $e2106e01f0383ad5$var$scheduled = (0, $9SHd3.batch)(()=>{
        let queueFn;
        while(queueFn = $e2106e01f0383ad5$var$QUEUE.shift())queueFn();
        $e2106e01f0383ad5$var$scheduled = null;
    });
}

});




parcelRegister("5AjMj", function(module, exports) {
$parcel$export(module.exports, "createSelector", () => $410fa815d33ff0a5$export$595d22ed68ca2841);
$parcel$export(module.exports, "getSelectorInstance", () => $410fa815d33ff0a5$export$38d24f3c60944dd5);

var $g19EN = parcelRequire("g19EN");
function $410fa815d33ff0a5$export$595d22ed68ca2841() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, $g19EN.default)(function() {
        return resultFunc.apply(null, arguments);
    }); // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, $g19EN.default)(function() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)params.push(dependencies[i].apply(null, arguments));
         // then call the final func with all them as arguments
        return memoizedResultFunc.apply(null, params);
    }, true); // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}
function $410fa815d33ff0a5$export$d2c200d79fc82f8c(selector) {
    const isReselector = typeof selector.resultFunc === 'function' && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return $410fa815d33ff0a5$export$595d22ed68ca2841(dependencies, resultFunc);
}
const $410fa815d33ff0a5$var$cache = new WeakMap();
function $410fa815d33ff0a5$export$38d24f3c60944dd5(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!$410fa815d33ff0a5$var$cache.has(storeState)) $410fa815d33ff0a5$var$cache.set(storeState, new WeakMap());
        const scopeSelectors = $410fa815d33ff0a5$var$cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, $410fa815d33ff0a5$export$d2c200d79fc82f8c(selector));
        return scopeSelectors.get(selector);
    }
    return $410fa815d33ff0a5$export$d2c200d79fc82f8c(selector);
}

});
parcelRegister("g19EN", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba943b02f1419bc5$export$2e2bcd8739ae039);

var $exYRi = parcelRequire("exYRi");
function $ba943b02f1419bc5$var$exactEqual(objA, objB) {
    return objA === objB;
}
function $ba943b02f1419bc5$var$areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false; // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, $exYRi.default)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!$ba943b02f1419bc5$var$exactEqual(prev[i], next[i])) return false;
    }
    return true;
}
function $ba943b02f1419bc5$export$2e2bcd8739ae039(resultFn, propsMode) {
    if (propsMode === void 0) propsMode = false;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    const result = function result() {
        if (calledOnce && $ba943b02f1419bc5$var$areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
        const nextResult = resultFn.apply(this, arguments);
        if (!propsMode && (0, $exYRi.default)(nextResult, lastResult)) return lastResult;
        lastResult = nextResult;
        calledOnce = true;
        lastArgs = arguments;
        return lastResult;
    };
    return result;
}

});



parcelRegister("5U9wF", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $44c9925a99ad458c$export$26ae5ca175b4ec5a);

var $1v5pe = parcelRequire("1v5pe");

var $VkTYT = parcelRequire("VkTYT");

var $4jreY = parcelRequire("4jreY");

var $6P0gD = parcelRequire("6P0gD");
var $5gTHJ = parcelRequire("5gTHJ");

var $exYRi = parcelRequire("exYRi");
const $44c9925a99ad458c$var$_excluded = [
    "children"
], $44c9925a99ad458c$var$_excluded2 = [
    "scope",
    "isGlobal"
];
function $44c9925a99ad458c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $44c9925a99ad458c$var$noop = ()=>()=>{};
function $44c9925a99ad458c$export$26ae5ca175b4ec5a(StoreOrOptions, _temp) {
    if (StoreOrOptions === void 0) StoreOrOptions = {};
    let { onInit: _onInit = $44c9925a99ad458c$var$noop, onUpdate: onUpdate = $44c9925a99ad458c$var$noop, onCleanup: onCleanup = $44c9925a99ad458c$var$noop, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    if ('key' in StoreOrOptions) {
        const Store = StoreOrOptions;
        const dn = displayName || `Container(${Store.key.split('__')[0]})`;
        return $44c9925a99ad458c$var$createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store: Store,
                handlers: Object.assign({}, _onInit !== $44c9925a99ad458c$var$noop && {
                    onInit: ()=>_onInit()
                }, onCleanup !== $44c9925a99ad458c$var$noop && {
                    onDestroy: ()=>onCleanup()
                }, onUpdate !== $44c9925a99ad458c$var$noop && {
                    onContainerUpdate: ()=>onUpdate()
                })
            }
        });
    }
    return $44c9925a99ad458c$var$createFunctionContainer(StoreOrOptions);
}
function $44c9925a99ad458c$var$useRegistry(scope, isGlobal, _ref) {
    let { globalRegistry: globalRegistry } = _ref;
    return (0, $1v5pe.useMemo)(()=>{
        const isLocal = !scope && !isGlobal;
        return isLocal ? new (0, $5gTHJ.StoreRegistry)('__local__') : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function $44c9925a99ad458c$var$useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const containedStores = (0, $1v5pe.useMemo)(()=>new Map(), [
        scope
    ]);
    const getContainedStore = (0, $1v5pe.useCallback)((Store)=>{
        let containedStore = containedStores.get(Store); // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            const isExisting = registry.hasStore(Store, scope);
            const config = {
                props: ()=>propsRef.current.sub,
                contained: check
            };
            const { storeState: storeState } = registry.getStore(Store, scope, config);
            const actions = (0, $6P0gD.bindActions)(Store.actions, storeState, config);
            const handlers = (0, $6P0gD.bindActions)(Object.assign({}, Store.handlers, override == null ? void 0 : override.handlers), storeState, config, actions);
            containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                unsubscribe: undefined
            };
            containedStores.set(Store, containedStore); // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            if (!isExisting || override) handlers.onInit == null || handlers.onInit();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function $44c9925a99ad458c$var$useApi(check, getContainedStore, _ref2) {
    let { globalRegistry: globalRegistry, retrieveStore: retrieveStore } = _ref2;
    const retrieveRef = (0, $1v5pe.useRef)();
    retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store); // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    return (0, $1v5pe.useMemo)(()=>({
            globalRegistry: globalRegistry,
            retrieveStore: (s)=>retrieveRef.current(s)
        }), [
        globalRegistry
    ]);
}
function $44c9925a99ad458c$var$createFunctionContainer(_temp2) {
    let { displayName: displayName, override: override } = _temp2 === void 0 ? {} : _temp2;
    const check = (store)=>override ? store === override.Store : store.containedBy === FunctionContainer;
    function FunctionContainer(props) {
        const { children: children } = props, restProps = $44c9925a99ad458c$var$_objectWithoutPropertiesLoose(props, $44c9925a99ad458c$var$_excluded);
        const { scope: scope, isGlobal: isGlobal } = restProps, subProps = $44c9925a99ad458c$var$_objectWithoutPropertiesLoose(restProps, $44c9925a99ad458c$var$_excluded2);
        const ctx = (0, $1v5pe.useContext)((0, $4jreY.Context));
        const registry = $44c9925a99ad458c$var$useRegistry(scope, isGlobal, ctx); // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        const propsRef = (0, $1v5pe.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps // TODO remove on next major
        };
        const [containedStores, getContainedStore] = $44c9925a99ad458c$var$useContainedStore(scope, registry, propsRef, check, override); // Use a stable object as is passed as value to context Provider
        const api = $44c9925a99ad458c$var$useApi(check, getContainedStore, ctx); // This listens for custom props change, and so we trigger container update actions
        // before the re-render gets to consumers (hence why side effect on render).
        // We do not use React hooks because num of restProps might change and react will throws
        if (!(0, $exYRi.default)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach((_ref3)=>{
            let { handlers: handlers } = _ref3;
            handlers.onContainerUpdate == null || handlers.onContainerUpdate(propsRef.current.next, propsRef.current.prev);
        });
         // Every time we add/remove a contained store, we ensure we are subscribed to the updates
        // as an effect to properly handle strict mode
        (0, $1v5pe.useEffect)(()=>{
            containedStores.forEach((containedStore)=>{
                if (!containedStore.unsubscribe) {
                    const unsub = containedStore.storeState.subscribe(()=>containedStore.handlers.onUpdate == null ? void 0 : containedStore.handlers.onUpdate());
                    containedStore.unsubscribe = ()=>{
                        unsub();
                        containedStore.unsubscribe = undefined;
                    };
                }
            });
        }, [
            containedStores,
            containedStores.size
        ]); // We support renderding "bootstrap" containers without children with override API
        // so in this case we call getCS to initialize the store globally asap
        if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
         // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, $1v5pe.useEffect)(()=>{
            return ()=>{
                containedStores.forEach((_ref4, Store)=>{
                    let { storeState: storeState, handlers: handlers, unsubscribe: unsubscribe } = _ref4;
                    // Detatch container from subscription
                    unsubscribe == null || unsubscribe(); // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify(); // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(()=>{
                        var _registry$getStore;
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === ((_registry$getStore = registry.getStore(Store, scope, null)) == null ? void 0 : _registry$getStore.storeState)) {
                            handlers.onDestroy == null || handlers.onDestroy(); // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (!isGlobal) registry.deleteStore(Store, scope);
                        }
                    });
                }); // no need to reset containedStores as the map is already bound to scope
            };
        }, [
            registry,
            scope,
            isGlobal,
            containedStores
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $4jreY.Context).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || `Container`;
    FunctionContainer.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($VkTYT))).node,
        scope: (0, (/*@__PURE__*/$parcel$interopDefault($VkTYT))).string,
        isGlobal: (0, (/*@__PURE__*/$parcel$interopDefault($VkTYT))).bool
    };
    return FunctionContainer;
}

});

parcelRegister("eB2PL", function(module, exports) {
$parcel$export(module.exports, "createStore", () => $aa06b821ad7b9b5c$export$f51a9068ac82ea43);

var $2lGrt = parcelRequire("2lGrt");
function $aa06b821ad7b9b5c$var$createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), '') : '';
    return [
        name,
        (0, $2lGrt.default)(src + JSON.stringify(initialState))
    ].filter(Boolean).join('__');
}
function $aa06b821ad7b9b5c$export$f51a9068ac82ea43(_ref) {
    let { name: name = '', initialState: initialState, actions: actions, containedBy: containedBy, handlers: handlers = {} } = _ref;
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            return key || (key = $aa06b821ad7b9b5c$var$createKey(initialState, actions, name));
        },
        initialState: initialState,
        actions: actions,
        containedBy: containedBy,
        handlers: handlers
    };
}

});
parcelRegister("2lGrt", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b5e770a6c148ec0$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $1b5e770a6c148ec0$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});


parcelRegister("gFibE", function(module, exports) {
$parcel$export(module.exports, "isExternalAbsolutePath", () => $c21e9538f0e35012$export$2fa6dede99f181e5);
$parcel$export(module.exports, "getRelativePath", () => $c21e9538f0e35012$export$ae9fda833d91ed65);
$parcel$export(module.exports, "updateQueryParams", () => $c21e9538f0e35012$export$92377f461a797888);
$parcel$export(module.exports, "getRelativeURLFromLocation", () => $c21e9538f0e35012$export$9ae1c7c875ef309d);
$parcel$export(module.exports, "shouldReload", () => $c21e9538f0e35012$export$c9237620ff7fdf7c);

var $ajSxF = parcelRequire("ajSxF");
parcelRequire("i4lyD");
var $4fQCQ = parcelRequire("4fQCQ");
const $c21e9538f0e35012$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $c21e9538f0e35012$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : '/' + path;
const $c21e9538f0e35012$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        prefix = $c21e9538f0e35012$var$stripTrailingSlash(prefix);
        prefix = $c21e9538f0e35012$var$addLeadingSlash(prefix);
        path = $c21e9538f0e35012$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $c21e9538f0e35012$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $c21e9538f0e35012$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$c21e9538f0e35012$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($ajSxF)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($ajSxF)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $c21e9538f0e35012$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$c21e9538f0e35012$export$e83e3719fc818ee5(path)) {
        path = $c21e9538f0e35012$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($ajSxF)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $c21e9538f0e35012$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $ajSxF.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $c21e9538f0e35012$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
const $c21e9538f0e35012$export$c9237620ff7fdf7c = ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
    const sameRoute = (0, $4fQCQ.isSameRouteMatch)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === 'resources-plugin' || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === 'boolean') return routeChoice;
    }
    return defaultShouldReload;
};

});




parcelRegister("j2pl3", function(module, exports) {
$parcel$export(module.exports, "Router", () => $ddc1dbf2b1f7581e$export$55185c17a0fcbe46);

var $87uOn = parcelRequire("87uOn");

var $gHVeV = parcelRequire("gHVeV");

var $1v5pe = parcelRequire("1v5pe");

var $2yUAk = parcelRequire("2yUAk");
const $ddc1dbf2b1f7581e$export$55185c17a0fcbe46 = ({ basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, routes: routes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $2yUAk.RouterContainer), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins != null ? plugins : [],
        routes: routes
    }, children);
};
function $ddc1dbf2b1f7581e$export$ae46f04cfaffe093(props) {
    var _props$plugins;
    const history = (0, $1v5pe.useMemo)(()=>(0, $gHVeV.createMemoryHistory)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($ddc1dbf2b1f7581e$export$55185c17a0fcbe46, (0, $87uOn.default)({}, props, {
        history: history,
        isGlobal: false,
        plugins: (_props$plugins = props == null ? void 0 : props.plugins) != null ? _props$plugins : []
    }));
}

});

parcelRegister("kUmh0", function(module, exports) {

var $1v5pe = parcelRequire("1v5pe");

var $aZhFm = parcelRequire("aZhFm");
const $f38a5098ae6c30bf$export$b371fa9cf762ad06 = ({ children: children })=>{
    const actions = (0, $aZhFm.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null, children(actions));
};
$f38a5098ae6c30bf$export$b371fa9cf762ad06.displayName = 'RouterActions';

});
parcelRegister("aZhFm", function(module, exports) {
$parcel$export(module.exports, "useRouterActions", () => $7ffd4dfc86b29f7d$export$402e82ff1b20594b);

var $2yUAk = parcelRequire("2yUAk");
const $7ffd4dfc86b29f7d$export$402e82ff1b20594b = (0, $2yUAk.useRouterStoreActions);

});


parcelRegister("dVcvD", function(module, exports) {

var $3mdE8 = parcelRequire("3mdE8");

var $1v5pe = parcelRequire("1v5pe");
parcelRequire("i4lyD");
var $lsuSy = parcelRequire("lsuSy");

var $2yUAk = parcelRequire("2yUAk");
const $a22a4d51e8ac3bb8$var$_excluded = [
    "listen"
];
const $a22a4d51e8ac3bb8$export$672d721d310ff5f0 = ({ children: children })=>{
    const [state, _ref] = (0, $2yUAk.useRouterStore)();
    const { listen: listen } = _ref, actions = (0, $3mdE8.default)(_ref, $a22a4d51e8ac3bb8$var$_excluded);
    if (!state.unlisten && !(0, $lsuSy.isServerEnvironment)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null, children(state, actions));
};

});

parcelRegister("7OyXD", function(module, exports) {
$parcel$export(module.exports, "usePathParam", () => $5b08526dd1b3cd91$export$8c8591dcd57728e6);

var $1v5pe = parcelRequire("1v5pe");

var $lO7p1 = parcelRequire("lO7p1");

var $2yUAk = parcelRequire("2yUAk");
const $5b08526dd1b3cd91$var$createPathParamHook = (0, $lO7p1.createHook)((0, $2yUAk.RouterStore), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $5b08526dd1b3cd91$export$8c8591dcd57728e6 = (paramKey)=>{
    const [paramVal, routerActions] = $5b08526dd1b3cd91$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $1v5pe.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};

});

parcelRegister("dQa3A", function(module, exports) {
$parcel$export(module.exports, "useQueryParam", () => $a137eec8ff4dd5ae$export$ae316f0eeb712a36);

var $1v5pe = parcelRequire("1v5pe");

var $lO7p1 = parcelRequire("lO7p1");

var $2yUAk = parcelRequire("2yUAk");
const $a137eec8ff4dd5ae$var$createQueryParamHook = (0, $lO7p1.createHook)((0, $2yUAk.RouterStore), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $a137eec8ff4dd5ae$export$ae316f0eeb712a36 = (paramKey)=>{
    const [paramVal, routerActions] = $a137eec8ff4dd5ae$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, $1v5pe.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};

});

parcelRegister("l3uV8", function(module, exports) {

var $87uOn = parcelRequire("87uOn");

var $1v5pe = parcelRequire("1v5pe");

var $2yUAk = parcelRequire("2yUAk");
const $f541dcf8f1a6c6da$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $f541dcf8f1a6c6da$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $f541dcf8f1a6c6da$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $2yUAk.useRouterStore)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(Component, (0, $87uOn.default)({}, props, {
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        }));
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

});


parcelRegister("gEGDD", function(module, exports) {
$parcel$export(module.exports, "Link", () => (parcelRequire("iR5yZ")).default);
$parcel$export(module.exports, "RouteComponent", () => (parcelRequire("7rOcK")).RouteComponent);

var $iR5yZ = parcelRequire("iR5yZ");

var $7rOcK = parcelRequire("7rOcK");

});
parcelRegister("iR5yZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $dba17dfd00ae7d8f$export$2e2bcd8739ae039);

var $87uOn = parcelRequire("87uOn");

var $3mdE8 = parcelRequire("3mdE8");

var $gHVeV = parcelRequire("gHVeV");

var $1v5pe = parcelRequire("1v5pe");
parcelRequire("i4lyD");
var $1qFV0 = parcelRequire("1qFV0");
var $ab2Wt = parcelRequire("ab2Wt");

var $2yUAk = parcelRequire("2yUAk");

var $b6Se7 = parcelRequire("b6Se7");
parcelRequire("9eXCu");
var $4Uf7P = parcelRequire("4Uf7P");
var $uJeF5 = parcelRequire("uJeF5");
const $dba17dfd00ae7d8f$var$_excluded = [
    "children",
    "target",
    "replace",
    "href",
    "to",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onPointerDown",
    "onFocus",
    "onBlur",
    "type",
    "params",
    "query",
    "prefetch",
    "state"
];
const $dba17dfd00ae7d8f$var$PREFETCH_DELAY = 225;
const $dba17dfd00ae7d8f$var$Link = /*#__PURE__*/ (0, $1v5pe.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false, state: state } = _ref, rest = (0, $3mdE8.default)(_ref, $dba17dfd00ae7d8f$var$_excluded);
    const routerActions = (0, $2yUAk.useRouterStoreActions)();
    const { schedule: schedule, cancel: cancel } = (0, $b6Se7.useTimeout)($dba17dfd00ae7d8f$var$PREFETCH_DELAY);
    const validLinkType = (0, $4Uf7P.getValidLinkType)(linkType);
    const [route, setRoute] = (0, $1v5pe.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== 'string' ? route && (0, $gHVeV.createPath)((0, $ab2Wt.generateLocationFromPath)(route.path, routeAttributes)) || '' : to;
    const IS_ABSOLUTE_LINK_REGEX = /^((?:(http|https):\/\/)|\/\/)/;
    const staticBasePath = href != null && !IS_ABSOLUTE_LINK_REGEX.test(href) || typeof to === 'string' ? routeAttributes.basePath : '';
    const triggerPrefetch = (0, $1v5pe.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== 'string' && !route) return;
        const context = typeof to !== 'string' && route ? (0, $1qFV0.createRouterContext)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (prefetch === 'mount') schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $uJeF5.handleNavigation)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ],
            state: state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover') cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === 'hover') cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === 'hover') {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $1v5pe.createElement)(validLinkType, (0, $87uOn.default)({}, rest, {
        href: `${staticBasePath}${linkDestination}`,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }), children);
});
$dba17dfd00ae7d8f$var$Link.displayName = 'Link';
var $dba17dfd00ae7d8f$export$2e2bcd8739ae039 = $dba17dfd00ae7d8f$var$Link;

});
parcelRegister("b6Se7", function(module, exports) {
$parcel$export(module.exports, "useTimeout", () => $816a5189e752f4e6$export$d8e6abf214c9ec0f);

var $1v5pe = parcelRequire("1v5pe");
const $816a5189e752f4e6$export$d8e6abf214c9ec0f = (delay)=>{
    const timeoutId = (0, $1v5pe.useRef)();
    const schedule = (0, $1v5pe.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $1v5pe.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};

});

parcelRegister("9eXCu", function(module, exports) {
$parcel$export(module.exports, "getValidLinkType", () => (parcelRequire("4Uf7P")).getValidLinkType);
$parcel$export(module.exports, "handleNavigation", () => (parcelRequire("uJeF5")).handleNavigation);

var $4Uf7P = parcelRequire("4Uf7P");

var $uJeF5 = parcelRequire("uJeF5");

});
parcelRegister("4Uf7P", function(module, exports) {
$parcel$export(module.exports, "getValidLinkType", () => $39281ff350272ced$export$855ece989b15eb57);
const $39281ff350272ced$var$VALID_LINK_TYPES = [
    'a',
    'button'
];
const $39281ff350272ced$export$855ece989b15eb57 = (type)=>$39281ff350272ced$var$VALID_LINK_TYPES.includes(type) ? type : 'a';

});

parcelRegister("uJeF5", function(module, exports) {
$parcel$export(module.exports, "handleNavigation", () => $05c5e447ce24817b$export$706ad1af8096e280);

var $kJ2rU = parcelRequire("kJ2rU");
const $05c5e447ce24817b$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to, state: state })=>{
    if ((0, $kJ2rU.isKeyboardEvent)(event) && event.key !== 'Enter') return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, $kJ2rU.isKeyboardEvent)(event) && event.key === 'Enter' || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $kJ2rU.isModifiedEvent)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};

});
parcelRegister("kJ2rU", function(module, exports) {
$parcel$export(module.exports, "isModifiedEvent", () => $f169e8fd2c308647$export$642c6f14f6d4bbd5);
$parcel$export(module.exports, "isKeyboardEvent", () => $f169e8fd2c308647$export$130b789831072f4c);
const $f169e8fd2c308647$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $f169e8fd2c308647$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);

});




parcelRegister("7rOcK", function(module, exports) {
$parcel$export(module.exports, "RouteComponent", () => $56c1ff970910c658$export$7903e4b73fc7d6c3);

var $1v5pe = parcelRequire("1v5pe");
parcelRequire("b75yl");
var $fsPVv = parcelRequire("fsPVv");
const $56c1ff970910c658$export$7903e4b73fc7d6c3 = ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $fsPVv.useRouter)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};

});


parcelRegister("7OL8N", function(module, exports) {
parcelRequire("i4lyD");
var $1qFV0 = parcelRequire("1qFV0");
const $5b11c5222dd8637d$export$c36ce69a82764756 = (plugins, { routes: routes, history: history, basePath: basePath })=>{
    const context = (0, $1qFV0.findRouterContext)(routes, {
        location: history.location,
        basePath: basePath
    });
    plugins.forEach((p)=>{
        p.routeLoad == null || p.routeLoad({
            context: context
        });
    });
};

});

parcelRegister("9G6YZ", function(module, exports) {
$parcel$export(module.exports, "createResourcesPlugin", () => (parcelRequire("lpZJn")).createResourcesPlugin);

var $lpZJn = parcelRequire("lpZJn");

var $fvHkP = parcelRequire("fvHkP");

var $7Vv8o = parcelRequire("7Vv8o");

var $7v7E4 = parcelRequire("7v7E4");

var $4k3vk = parcelRequire("4k3vk");

var $lpZJn = parcelRequire("lpZJn");

var $7xqso = parcelRequire("7xqso");

});
parcelRegister("lpZJn", function(module, exports) {
$parcel$export(module.exports, "createResourcesPlugin", () => $f97bd143060a0c12$export$23ed892c481a96fe);

var $4k3vk = parcelRequire("4k3vk");
parcelRequire("6ZZek");
var $2Xsp0 = parcelRequire("2Xsp0");
const $f97bd143060a0c12$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $f97bd143060a0c12$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $4k3vk.getResourceStore)().actions;
    const nextResources = (0, $2Xsp0.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $f97bd143060a0c12$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $4k3vk.getResourceStore)().actions;
    const nextResources = (0, $2Xsp0.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $f97bd143060a0c12$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $4k3vk.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $f97bd143060a0c12$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $f97bd143060a0c12$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $f97bd143060a0c12$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $4k3vk.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $4k3vk.getResourceStore)().actions;
            const nextResources = (0, $2Xsp0.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $4k3vk.getResourceStore)().actions.getSafeData();
        }
    };
};

});
parcelRegister("4k3vk", function(module, exports) {
$parcel$export(module.exports, "getResourceStore", () => $325bbf8ea5f9a12e$export$6f6057d42352becb);
$parcel$export(module.exports, "useResourceStore", () => $325bbf8ea5f9a12e$export$ac3608e0bb357c7);
$parcel$export(module.exports, "useResourceStoreActions", () => $325bbf8ea5f9a12e$export$98e41a62c9bef75e);

var $87uOn = parcelRequire("87uOn");

var $3mdE8 = parcelRequire("3mdE8");

var $lO7p1 = parcelRequire("lO7p1");
var $5U9wF = parcelRequire("5U9wF");
var $eB2PL = parcelRequire("eB2PL");
var $gobwV = parcelRequire("gobwV");
var $5gTHJ = parcelRequire("5gTHJ");
parcelRequire("i4lyD");
var $lsuSy = parcelRequire("lsuSy");

var $haLPO = parcelRequire("haLPO");
parcelRequire("6ZZek");
var $1sV6W = parcelRequire("1sV6W");
var $dH4uy = parcelRequire("dH4uy");
var $gFv7A = parcelRequire("gFv7A");
var $eaktq = parcelRequire("eaktq");
var $80RDa = parcelRequire("80RDa");
var $1x6lu = parcelRequire("1x6lu");
var $aiDW3 = parcelRequire("aiDW3");
var $456XX = parcelRequire("456XX");
var $695MK = parcelRequire("695MK");
var $aUkFx = parcelRequire("aUkFx");
var $dyrRZ = parcelRequire("dyrRZ");
var $jGoH8 = parcelRequire("jGoH8");
const $325bbf8ea5f9a12e$var$_excluded = [
    "context"
], $325bbf8ea5f9a12e$var$_excluded2 = [
    "error",
    "expiresAt",
    "loading"
];
const $325bbf8ea5f9a12e$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $gFv7A.deleteResourceState)(type, key));
                dispatch((0, $1sV6W.executeForDependents)(resource, (dependentResource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $gFv7A.deleteResourceState)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, $3mdE8.default)(_getState, $325bbf8ea5f9a12e$var$_excluded);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $haLPO.getSliceForResource)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, $87uOn.default)({}, prevSlice, changes, {
                expiresAt: (0, $aiDW3.getExpiresAt)(maxAge),
                accessedAt: (0, $80RDa.getAccessedAt)()
            });
            dispatch((0, $gFv7A.setResourceState)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $1sV6W.executeForDependents)(resource, (dependentResource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $gFv7A.getResourceState)(type, key));
            if (cached && (0, $456XX.shouldUseCache)(cached)) {
                if ((0, $456XX.isFromSsr)(cached)) {
                    const withResolvedPromise = (0, $695MK.setSsrDataPromise)(cached);
                    cached = (0, $aiDW3.setExpiresAt)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $80RDa.getAccessedAt)();
                dispatch((0, $gFv7A.setResourceState)(type, key, cached));
                return cached;
            }
            return dispatch($325bbf8ea5f9a12e$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $gFv7A.getResourceState)(type, key)) || (0, $1x6lu.getDefaultStateSlice)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $jGoH8.validateLRUCache)(resource, key));
            const loadingSlice = dispatch((0, $gFv7A.getPrefetchSlice)(type, key)) || (0, $dH4uy.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $1sV6W.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $gFv7A.setResourceState)(type, key, (0, $87uOn.default)({}, prevSlice, loadingSlice, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $80RDa.getAccessedAt)()
                })));
                // trigger dependent resources to also load
                dispatch((0, $1sV6W.executeForDependents)(resource, (dependentResource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    var _loadingSlice$data;
                    const data = (_loadingSlice$data = loadingSlice.data) != null ? _loadingSlice$data : await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $aUkFx.TimeoutError)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $gFv7A.getResourceState)(type, key));
            const finalSlice = (0, $87uOn.default)({}, recentSlice || prevSlice, resolvedSlice, {
                accessedAt: (0, $80RDa.getAccessedAt)(),
                expiresAt: (0, $aiDW3.getExpiresAt)(maxAge)
            });
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $gFv7A.setResourceState)(type, key, finalSlice));
            return finalSlice;
        },
    /**
   * Prefetch a single resource and store in the prefetch cache.
   */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const loadingSlice = dispatch((0, $gFv7A.getPrefetchSlice)(type, key)) || (0, $dH4uy.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $1sV6W.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            // save deferred value to be used also by dependants
            dispatch((0, $gFv7A.setPrefetchSlice)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, $1sV6W.executeForDependents)(resource, (dependentResource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $325bbf8ea5f9a12e$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>{
        var _routerStoreContext$r;
        return (0, $1sV6W.actionWithDependencies)(routerStoreContext == null || (_routerStoreContext$r = routerStoreContext.route) == null ? void 0 : _routerStoreContext$r.resources, resource, $325bbf8ea5f9a12e$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null));
    },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $1sV6W.actionWithDependencies)(routerStoreContext.route.resources, resource, $325bbf8ea5f9a12e$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, options)=>(0, $1sV6W.actionWithDependencies)(routerStoreContext.route.resources, resource, $325bbf8ea5f9a12e$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $1sV6W.actionWithDependencies)(routerStoreContext.route.resources, resource, $325bbf8ea5f9a12e$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch: dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($325bbf8ea5f9a12e$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $gFv7A.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $gFv7A.deleteResourceState)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _resources;
        const predicate = (0, $lsuSy.isServerEnvironment)() ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $1sV6W.mapActionWithDependencies)((_resources = routerStoreContext.route.resources) == null ? void 0 : _resources.filter(predicate), resources.filter(predicate), (resource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Prefetch a specific set of resources.
   */ prefetchResources: (resources, routerStoreContext, options)=>(0, $1sV6W.mapActionWithDependencies)(routerStoreContext.route.resources, resources, (resource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, (0, $87uOn.default)({}, options, {
                prefetch: true
            }))),
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $dyrRZ.transformData)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref, rest = (0, $3mdE8.default)(_ref, $325bbf8ea5f9a12e$var$_excluded2);
                const deserializedError = !error ? null : (0, $eaktq.deserializeError)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === 'TimeoutError';
                return (0, $87uOn.default)({}, rest, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState: getState })=>(0, $dyrRZ.transformData)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $eaktq.serializeError)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $aUkFx.TimeoutError) ? loading : false
                }))
};
const $325bbf8ea5f9a12e$export$94f50dade551bd01 = (0, $eB2PL.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $325bbf8ea5f9a12e$export$e324594224ef24da,
    name: 'router-resources'
});
const $325bbf8ea5f9a12e$export$cc90fb9c37c5589d = (0, $5U9wF.createContainer)($325bbf8ea5f9a12e$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $325bbf8ea5f9a12e$export$fee1a6213543bd78 = (0, $gobwV.createSubscriber)($325bbf8ea5f9a12e$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $haLPO.getSliceForResource)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $325bbf8ea5f9a12e$export$6f6057d42352becb = ()=>// @ts-ignore not providing a scopeId param
    (0, $5gTHJ.defaultRegistry).getStore($325bbf8ea5f9a12e$export$94f50dade551bd01);
const $325bbf8ea5f9a12e$export$ac3608e0bb357c7 = (0, $lO7p1.createHook)($325bbf8ea5f9a12e$export$94f50dade551bd01, {
    selector: (0, $haLPO.getSliceForResource)
});
const $325bbf8ea5f9a12e$export$98e41a62c9bef75e = (0, $lO7p1.createActionsHook)($325bbf8ea5f9a12e$export$94f50dade551bd01);
const $325bbf8ea5f9a12e$export$e59f52df235ac7b3 = (0, $lO7p1.createHook)($325bbf8ea5f9a12e$export$94f50dade551bd01, {
    selector: (0, $haLPO.getResourceStoreContext)
});

});
parcelRegister("gobwV", function(module, exports) {
$parcel$export(module.exports, "createSubscriber", () => $bee7d4db99dded24$export$48f338a7e080595c);

var $lO7p1 = parcelRequire("lO7p1");
const $bee7d4db99dded24$var$_excluded = [
    "children"
];
function $bee7d4db99dded24$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bee7d4db99dded24$var$hasAdditionalProps(props) {
    for(let i in props)return true;
    return false;
}
function $bee7d4db99dded24$export$48f338a7e080595c(Store, _temp) {
    let { selector: selector, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    const useStore = (0, $lO7p1.createHook)(Store, {
        selector: selector
    });
    const Subscriber = function Subscriber(_ref) {
        let { children: children } = _ref, rest = $bee7d4db99dded24$var$_objectWithoutPropertiesLoose(_ref, $bee7d4db99dded24$var$_excluded);
        const api = useStore($bee7d4db99dded24$var$hasAdditionalProps(rest) ? rest : undefined);
        return children(...api);
    };
    Subscriber.displayName = displayName || `Subscriber(${Store.key.split('__')[0]})`;
    return Subscriber;
}

});

parcelRegister("haLPO", function(module, exports) {
$parcel$export(module.exports, "getSliceForResource", () => $c80879d114529b7c$export$c9ed509724feb827);
$parcel$export(module.exports, "getResourceStoreContext", () => $c80879d114529b7c$export$6a0b1779210de0ee);

var $87uOn = parcelRequire("87uOn");
parcelRequire("6ZZek");
var $1x6lu = parcelRequire("1x6lu");
const $c80879d114529b7c$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, $87uOn.default)({}, slice) : (0, $1x6lu.getDefaultStateSlice)();
};
const $c80879d114529b7c$export$6a0b1779210de0ee = (state)=>state.context;

});
parcelRegister("6ZZek", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => (parcelRequire("80RDa")).getAccessedAt);
$parcel$export(module.exports, "createLoadingSlice", () => (parcelRequire("dH4uy")).createLoadingSlice);
$parcel$export(module.exports, "actionWithDependencies", () => (parcelRequire("1sV6W")).actionWithDependencies);
$parcel$export(module.exports, "mapActionWithDependencies", () => (parcelRequire("1sV6W")).mapActionWithDependencies);
$parcel$export(module.exports, "executeForDependents", () => (parcelRequire("1sV6W")).executeForDependents);
$parcel$export(module.exports, "getDependencies", () => (parcelRequire("1sV6W")).getDependencies);
$parcel$export(module.exports, "getExpiresAt", () => (parcelRequire("aiDW3")).getExpiresAt);
$parcel$export(module.exports, "setExpiresAt", () => (parcelRequire("aiDW3")).setExpiresAt);
$parcel$export(module.exports, "getDefaultStateSlice", () => (parcelRequire("1x6lu")).getDefaultStateSlice);
$parcel$export(module.exports, "getResourcesForNextLocation", () => (parcelRequire("2Xsp0")).getResourcesForNextLocation);
$parcel$export(module.exports, "validateLRUCache", () => (parcelRequire("jGoH8")).validateLRUCache);
$parcel$export(module.exports, "deleteResourceState", () => (parcelRequire("gFv7A")).deleteResourceState);
$parcel$export(module.exports, "getResourceState", () => (parcelRequire("gFv7A")).getResourceState);
$parcel$export(module.exports, "setResourceState", () => (parcelRequire("gFv7A")).setResourceState);
$parcel$export(module.exports, "getPrefetchSlice", () => (parcelRequire("gFv7A")).getPrefetchSlice);
$parcel$export(module.exports, "setPrefetchSlice", () => (parcelRequire("gFv7A")).setPrefetchSlice);
$parcel$export(module.exports, "serializeError", () => (parcelRequire("eaktq")).serializeError);
$parcel$export(module.exports, "deserializeError", () => (parcelRequire("eaktq")).deserializeError);
$parcel$export(module.exports, "shouldUseCache", () => (parcelRequire("456XX")).shouldUseCache);
$parcel$export(module.exports, "isFromSsr", () => (parcelRequire("456XX")).isFromSsr);
$parcel$export(module.exports, "setSsrDataPromise", () => (parcelRequire("695MK")).setSsrDataPromise);
$parcel$export(module.exports, "TimeoutError", () => (parcelRequire("aUkFx")).TimeoutError);
$parcel$export(module.exports, "transformData", () => (parcelRequire("dyrRZ")).transformData);

var $80RDa = parcelRequire("80RDa");

var $dH4uy = parcelRequire("dH4uy");

var $aBRJH = parcelRequire("aBRJH");

var $1sV6W = parcelRequire("1sV6W");

var $aiDW3 = parcelRequire("aiDW3");

var $1q3iT = parcelRequire("1q3iT");

var $1x6lu = parcelRequire("1x6lu");

var $cjXqv = parcelRequire("cjXqv");

var $2Xsp0 = parcelRequire("2Xsp0");

var $jGoH8 = parcelRequire("jGoH8");

var $gFv7A = parcelRequire("gFv7A");

var $aydsJ = parcelRequire("aydsJ");

var $eaktq = parcelRequire("eaktq");

var $456XX = parcelRequire("456XX");

var $695MK = parcelRequire("695MK");

var $aUkFx = parcelRequire("aUkFx");

var $dyrRZ = parcelRequire("dyrRZ");

});
parcelRegister("80RDa", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => $5d57ecbfe3b77e12$export$9ccb639b7a119f61);
const $5d57ecbfe3b77e12$export$9ccb639b7a119f61 = ()=>Date.now();

});

parcelRegister("dH4uy", function(module, exports) {
$parcel$export(module.exports, "createLoadingSlice", () => $9f82c6853cb9305f$export$dc62515c8f0b52dd);

var $87uOn = parcelRequire("87uOn");

var $gdDp6 = parcelRequire("gdDp6");

var $aiDW3 = parcelRequire("aiDW3");

var $1q3iT = parcelRequire("1q3iT");

var $aUkFx = parcelRequire("aUkFx");

var $eOzsh = parcelRequire("eOzsh");
function $9f82c6853cb9305f$export$dc62515c8f0b52dd({ context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext }) {
    var _promiseOrData, _resource$maxAge;
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData((0, $87uOn.default)({}, routerStoreContext, {
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }), context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $1q3iT.generateTimeGuard)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof ((_promiseOrData = promiseOrData) == null ? void 0 : _promiseOrData.then) === 'function' ? undefined : promiseOrData;
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard == null ? void 0 : timeoutGuard.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $aUkFx.TimeoutError)(type);
        (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : // if we already have a result, wrap it so consumers can access it via same API
    data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $aiDW3.getExpiresAt)((_resource$maxAge = resource.maxAge) != null ? _resource$maxAge : (0, $gdDp6.DEFAULT_RESOURCE_MAX_AGE));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $aiDW3.getExpiresAt)((0, $eOzsh.DEFAULT_PREFETCH_MAX_AGE))) : resourceMaxAge
    };
}

});
parcelRegister("gdDp6", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_CACHE_MAX_LIMIT", () => $bcec6d01a9b8b822$export$881d135f98d8d7d0);
$parcel$export(module.exports, "DEFAULT_RESOURCE_BROWSER_ONLY", () => $bcec6d01a9b8b822$export$9ab5bdcb8a1d6c34);
$parcel$export(module.exports, "DEFAULT_RESOURCE_MAX_AGE", () => $bcec6d01a9b8b822$export$12c1dc38ea1692da);
const $bcec6d01a9b8b822$export$881d135f98d8d7d0 = 100;
const $bcec6d01a9b8b822$export$9ab5bdcb8a1d6c34 = false;
const $bcec6d01a9b8b822$export$12c1dc38ea1692da = 0;

});

parcelRegister("aiDW3", function(module, exports) {
$parcel$export(module.exports, "getExpiresAt", () => $77fa9025423fc23c$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "setExpiresAt", () => $77fa9025423fc23c$export$18d1d420fd588368);

var $87uOn = parcelRequire("87uOn");
const $77fa9025423fc23c$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $77fa9025423fc23c$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, $87uOn.default)({}, slice, {
        expiresAt: $77fa9025423fc23c$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;

});

parcelRegister("1q3iT", function(module, exports) {
$parcel$export(module.exports, "generateTimeGuard", () => $108ac836d0c63e52$export$58634b3a58ae66b7);
const $108ac836d0c63e52$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};

});

parcelRegister("aUkFx", function(module, exports) {
$parcel$export(module.exports, "TimeoutError", () => $7f0f2ac24b55a8af$export$66d311bf29d5c89c);
class $7f0f2ac24b55a8af$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super('Resource timed out: ' + message);
        this.name = 'TimeoutError';
    }
}

});

parcelRegister("eOzsh", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_PREFETCH_MAX_AGE", () => $ac913cdf516a6c19$export$37d3126be6549b13);
const $ac913cdf516a6c19$export$37d3126be6549b13 = 10000;

});


parcelRegister("aBRJH", function(module, exports) {

var $gdDp6 = parcelRequire("gdDp6");
/**
 * Utility method to created async versions of getData functions
 */ const $7b970af4b8ce2c1d$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $7b970af4b8ce2c1d$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $7b970af4b8ce2c1d$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $gdDp6.DEFAULT_RESOURCE_MAX_AGE),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $gdDp6.DEFAULT_CACHE_MAX_LIMIT),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $gdDp6.DEFAULT_RESOURCE_BROWSER_ONLY),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};

});

parcelRegister("1sV6W", function(module, exports) {
$parcel$export(module.exports, "actionWithDependencies", () => $1114b4ff1105d34f$export$5f7e1fd85734e71e);
$parcel$export(module.exports, "mapActionWithDependencies", () => $1114b4ff1105d34f$export$f71a65c89c987a02);
$parcel$export(module.exports, "executeForDependents", () => $1114b4ff1105d34f$export$7d1ffac63c68405d);
$parcel$export(module.exports, "getDependencies", () => $1114b4ff1105d34f$export$75915f81f2a6540a);

var $87uOn = parcelRequire("87uOn");

var $1x6lu = parcelRequire("1x6lu");

var $gFv7A = parcelRequire("gFv7A");
var $1114b4ff1105d34f$var$_Object$fromEntries;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const $1114b4ff1105d34f$var$fromEntries = ($1114b4ff1105d34f$var$_Object$fromEntries = Object.fromEntries) != null ? $1114b4ff1105d34f$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const $1114b4ff1105d34f$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $1114b4ff1105d34f$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const $1114b4ff1105d34f$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error('execution is already in progress');
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends: depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some($1114b4ff1105d34f$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends != null && depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($1114b4ff1105d34f$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($1114b4ff1105d34f$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $1114b4ff1105d34f$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($1114b4ff1105d34f$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $1114b4ff1105d34f$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$1114b4ff1105d34f$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $1114b4ff1105d34f$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($1114b4ff1105d34f$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && (_tupleResource$depend = tupleResource.depends) != null && _tupleResource$depend.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $1114b4ff1105d34f$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>({ getState: getState, dispatch: dispatch })=>{
        var _tuples$findIndex2;
        const { type: type, depends: depends } = resource;
        // optimise the case of no dependencies
        if (!(depends != null && depends.length)) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($1114b4ff1105d34f$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $1114b4ff1105d34f$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($1114b4ff1105d34f$var$matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $1114b4ff1105d34f$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $1114b4ff1105d34f$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $1114b4ff1105d34f$var$fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $gFv7A.getResourceState)(dependencyType, key)) || (0, $1x6lu.getDefaultStateSlice)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $gFv7A.getPrefetchSlice)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = (0, $87uOn.default)({}, slice, {
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            });
            return [
                dependencyType,
                slice
            ];
        }));
    };

});
parcelRegister("1x6lu", function(module, exports) {
$parcel$export(module.exports, "getDefaultStateSlice", () => $11ddcb99c77f2a5f$export$fa8e33c3301e2e94);

var $87uOn = parcelRequire("87uOn");

var $80RDa = parcelRequire("80RDa");

var $gdDp6 = parcelRequire("gdDp6");

var $aiDW3 = parcelRequire("aiDW3");

var $46vMW = parcelRequire("46vMW");
const $11ddcb99c77f2a5f$export$fa8e33c3301e2e94 = ()=>(0, $87uOn.default)({}, (0, $46vMW.BASE_DEFAULT_STATE_SLICE), {
        expiresAt: (0, $aiDW3.getExpiresAt)((0, $gdDp6.DEFAULT_RESOURCE_MAX_AGE)),
        accessedAt: (0, $80RDa.getAccessedAt)()
    });

});
parcelRegister("46vMW", function(module, exports) {
$parcel$export(module.exports, "BASE_DEFAULT_STATE_SLICE", () => $2fd0617e74ae762e$export$2df85a734ff5ed27);
/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $2fd0617e74ae762e$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};

});


parcelRegister("gFv7A", function(module, exports) {
$parcel$export(module.exports, "getPrefetchSlice", () => $c2289db837328500$export$11374758be89e40);
$parcel$export(module.exports, "setPrefetchSlice", () => $c2289db837328500$export$1e32615dc8354436);
$parcel$export(module.exports, "setResourceState", () => $c2289db837328500$export$704f800f263b050e);
$parcel$export(module.exports, "getResourceState", () => $c2289db837328500$export$5fc90c33b03fffb);
$parcel$export(module.exports, "deleteResourceState", () => $c2289db837328500$export$d40f35dc5952864b);

var $3mdE8 = parcelRequire("3mdE8");

var $87uOn = parcelRequire("87uOn");
function $c2289db837328500$var$_toPropertyKey(t) {
    var i = $c2289db837328500$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function $c2289db837328500$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $c2289db837328500$export$11374758be89e40 = (type, key)=>({ getState: getState })=>{
        var _prefetching$type;
        const { prefetching: prefetching } = getState();
        const slice = prefetching == null || (_prefetching$type = prefetching[type]) == null ? void 0 : _prefetching$type[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $c2289db837328500$export$1e32615dc8354436 = (type, key, slice)=>({ setState: setState, getState: getState })=>{
        var _prefetching$type2, _slice$promise;
        const { prefetching: prefetching } = getState();
        // avoid doing extra set if same value
        if ((prefetching == null || (_prefetching$type2 = prefetching[type]) == null ? void 0 : _prefetching$type2[key]) === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice == null || (_slice$promise = slice.promise) == null || _slice$promise.then((maybeData)=>slice.data = maybeData);
        setState({
            prefetching: (0, $87uOn.default)({}, prefetching, {
                [type]: (0, $87uOn.default)({}, prefetching == null ? void 0 : prefetching[type], {
                    [key]: slice
                })
            })
        });
    };
const $c2289db837328500$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { data: data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch($c2289db837328500$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: (0, $87uOn.default)({}, data, {
                [type]: (0, $87uOn.default)({}, data[type] || {}, {
                    [key]: state
                })
            })
        });
    };
const $c2289db837328500$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $c2289db837328500$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, $3mdE8.default)(data, [
            type
        ].map($c2289db837328500$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, $3mdE8.default)(resourceForType, [
                key
            ].map($c2289db837328500$var$_toPropertyKey));
            setState({
                data: (0, $87uOn.default)({}, remainingData, {
                    [type]: remainingForType
                })
            });
        }
    };

});


parcelRegister("cjXqv", function(module, exports) {
$parcel$export(module.exports, "getResourceIdentifier", () => $8f855b3c85bfcd50$export$c616b176adf9ad4a);
$parcel$export(module.exports, "getResourceIdentifiers", () => $8f855b3c85bfcd50$export$cd7fbe7e979df558);
const $8f855b3c85bfcd50$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $8f855b3c85bfcd50$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$8f855b3c85bfcd50$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));

});

parcelRegister("2Xsp0", function(module, exports) {
$parcel$export(module.exports, "getResourcesForNextLocation", () => $22771f91a0427f12$export$7cbbc763e2f3d65d);

var $cjXqv = parcelRequire("cjXqv");

var $aydsJ = parcelRequire("aydsJ");
const $22771f91a0427f12$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $aydsJ.routeHasResources)(nextRoute)) return [];
    if ((0, $aydsJ.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $cjXqv.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $cjXqv.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};

});
parcelRegister("aydsJ", function(module, exports) {
$parcel$export(module.exports, "routeHasResources", () => $7ae785bb12efd361$export$740886389191c640);
$parcel$export(module.exports, "routeHasChanged", () => $7ae785bb12efd361$export$221027ff1aa38f82);
const $7ae785bb12efd361$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $7ae785bb12efd361$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;

});


parcelRegister("jGoH8", function(module, exports) {
$parcel$export(module.exports, "validateLRUCache", () => $e5451870b07c58fa$export$89440b7623c2c75c);

var $gFv7A = parcelRequire("gFv7A");
const $e5451870b07c58fa$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $e5451870b07c58fa$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $e5451870b07c58fa$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $e5451870b07c58fa$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $e5451870b07c58fa$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $gFv7A.deleteResourceState)(type, keyTobeDeleted));
    };

});

parcelRegister("eaktq", function(module, exports) {
$parcel$export(module.exports, "serializeError", () => $a501e17e10f67e01$export$46ff38bc6bdea8fb);
$parcel$export(module.exports, "deserializeError", () => $a501e17e10f67e01$export$64cddc1e268e9046);
// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $a501e17e10f67e01$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $a501e17e10f67e01$var$NonError);
    }
}
const $a501e17e10f67e01$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $a501e17e10f67e01$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $a501e17e10f67e01$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $a501e17e10f67e01$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const $a501e17e10f67e01$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $a501e17e10f67e01$var$destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $a501e17e10f67e01$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $a501e17e10f67e01$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $a501e17e10f67e01$var$NonError(value);
};

});

parcelRegister("456XX", function(module, exports) {
$parcel$export(module.exports, "isFromSsr", () => $2f8d085a7807db31$export$b25d2963b8a3488a);
$parcel$export(module.exports, "shouldUseCache", () => $2f8d085a7807db31$export$399de8c43d0ece3c);
const $2f8d085a7807db31$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $2f8d085a7807db31$var$isFresh = (resource)=>{
    if ($2f8d085a7807db31$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $2f8d085a7807db31$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null || (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($2f8d085a7807db31$var$isFresh(resource)) return true;
    return false;
};

});

parcelRegister("695MK", function(module, exports) {
$parcel$export(module.exports, "setSsrDataPromise", () => $4798122614ec3b45$export$2e4da1b414980956);

var $87uOn = parcelRequire("87uOn");
const $4798122614ec3b45$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, $87uOn.default)({}, slice, {
        promise: Promise.resolve(slice.data)
    }) : slice;

});

parcelRegister("dyrRZ", function(module, exports) {
$parcel$export(module.exports, "transformData", () => $9de411b0b18cf8f2$export$3ceb62baab058c6b);
const $9de411b0b18cf8f2$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});

});





parcelRegister("fvHkP", function(module, exports) {

var $1v5pe = parcelRequire("1v5pe");

var $7Vv8o = parcelRequire("7Vv8o");
const $b4ab5dace00b8583$export$fee1a6213543bd78 = ({ children: children, resource: resource, options: options })=>{
    const result = (0, $7Vv8o.useResource)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null, children(result));
};

});
parcelRegister("7Vv8o", function(module, exports) {
$parcel$export(module.exports, "useResource", () => $5c5601e773daa875$export$9f6abfd74295843b);

var $87uOn = parcelRequire("87uOn");

var $1v5pe = parcelRequire("1v5pe");

var $lO7p1 = parcelRequire("lO7p1");

var $2yUAk = parcelRequire("2yUAk");

var $4k3vk = parcelRequire("4k3vk");
const $5c5601e773daa875$export$9f6abfd74295843b = (resource, options)=>{
    const actions = (0, $4k3vk.useResourceStoreActions)();
    const { getContext: getRouterContext } = (0, $2yUAk.useRouterStoreActions)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $1v5pe.useMemo)(()=>(0, $lO7p1.createHook)((0, $2yUAk.RouterStore), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $4k3vk.useResourceStore)({
        type: resource.type,
        key: key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $1v5pe.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    ()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, $1v5pe.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $1v5pe.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $1v5pe.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $1v5pe.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, $87uOn.default)({}, slice, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};

});


parcelRegister("7v7E4", function(module, exports) {

var $4k3vk = parcelRequire("4k3vk");
const $57615bd5aef4bc45$export$dee7bf9fc0ff48c3 = (fn)=>(0, $4k3vk.getResourceStore)().storeState.subscribe(fn);

});

parcelRegister("7xqso", function(module, exports) {
const $57d0234526918c1c$export$d4864d13105dc5ed = {
    loading: false,
    error: null,
    data: {
        foo: 'bar'
    },
    promise: null,
    expiresAt: Date.now(),
    accessedAt: Date.now(),
    key: ''
};

});



parcelRegister("c6q87", function(module, exports) {
$parcel$export(module.exports, "FeatureGateClient", () => $2a2550c5d9d0444f$export$6084ad8a2ad35ad4);
$parcel$export(module.exports, "fg", () => (parcelRequire("jY3c0")).fg);

var $joS99 = parcelRequire("joS99");

var $SOJpc = parcelRequire("SOJpc");
parcelRequire("8oX5A");
var $e60FT = parcelRequire("e60FT");
parcelRequire("JEkkv");
var $fYUfs = parcelRequire("fYUfs");

var $jY3c0 = parcelRequire("jY3c0");
parcelRequire("j5h4D");
var $h7lQ2 = parcelRequire("h7lQ2");
parcelRequire("1v5pe");

var $eyztC = parcelRequire("eyztC");

var $kIqwl = parcelRequire("kIqwl");
const $2a2550c5d9d0444f$var$STATSIG_CLIENT_KEY = {
    staging: '00f6830e-2abf-458f-b2ad-10c1a238d343',
    production: 'bf14aab7-117d-45e0-98ea-1e2e5efc2c39'
};
const $2a2550c5d9d0444f$export$6084ad8a2ad35ad4 = ({ children: children })=>{
    const { tenantContexts: tenantContexts } = (0, $h7lQ2.useTenantData)();
    const { user: user } = (0, $e60FT.useAuthData)();
    const onError = (err)=>{
        if (err) {
            console.error('STATSIG_CLIENT_ERROR', err);
            throw err;
        }
    };
    // If tenantContexts is empty, the user does not have access to the site.
    if (!tenantContexts?.length) return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eyztC.NotFound), {});
    if (!user?.accountId || !tenantContexts[0].cloudId) throw new Error('User/Tenant Context is not set');
    // Allow overriding the Statsig environment via STATSIG_ENV env var.
    // Useful when proxying to production locally (STATSIG_ENV=production in .env).
    const statsigEnvOverride = undefined;
    const isProd = statsigEnvOverride === 'production' || statsigEnvOverride !== 'staging' && (0, $fYUfs.isProduction)();
    const apiKey = $2a2550c5d9d0444f$var$STATSIG_CLIENT_KEY[isProd ? 'production' : 'staging'];
    if (!apiKey) throw new Error('STATSIG_CLIENT_API_KEY is not set');
    const atlassianAccountId = user.accountId;
    const { cloudId: cloudId, orgId: orgId } = tenantContexts[0];
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $SOJpc.FeatureGatesInitialization), {
        options: {
            apiKey: apiKey,
            environment: isProd ? (0, $joS99.FeatureGateEnvironment).Production : (0, $joS99.FeatureGateEnvironment).Staging,
            targetApp: 'dev-agents_web',
            fetchTimeoutMs: 1000,
            useGatewayURL: true
        },
        identifiers: {
            atlassianAccountId: atlassianAccountId,
            tenantId: cloudId,
            atlassianOrgId: orgId
        },
        onReady: onError,
        children: children
    });
};

});
parcelRegister("SOJpc", function(module, exports) {
"use strict";
var $0a4c6572dbf104c4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0a4c6572dbf104c4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0a4c6572dbf104c4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0a4c6572dbf104c4$var$__exportStar((parcelRequire("ir32P")), module.exports);

$0a4c6572dbf104c4$var$__exportStar((parcelRequire("bj8Zo")), module.exports);

$0a4c6572dbf104c4$var$__exportStar((parcelRequire("dQ3yU")), module.exports);

$0a4c6572dbf104c4$var$__exportStar((parcelRequire("kyyQ5")), module.exports);

$0a4c6572dbf104c4$var$__exportStar((parcelRequire("i6koh")), module.exports);

});
parcelRegister("ir32P", function(module, exports) {
"use strict";
var $d6bd1c351628a6f2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useExperimentValue = module.exports.useFeatureGate = void 0;

var $1v5pe = parcelRequire("1v5pe");

const $d6bd1c351628a6f2$var$feature_gate_js_client_1 = $d6bd1c351628a6f2$var$__importDefault((parcelRequire("gGyUC")));
const $d6bd1c351628a6f2$var$useFeatureGate = (gateName, options = {})=>{
    const [gate, setGate] = (0, $1v5pe.useState)(()=>$d6bd1c351628a6f2$var$feature_gate_js_client_1.default.checkGate(gateName, options));
    (0, $1v5pe.useEffect)(()=>{
        const onGateChange = (newValue)=>setGate(newValue);
        return $d6bd1c351628a6f2$var$feature_gate_js_client_1.default.onGateUpdated(gateName, onGateChange, options);
    }, [
        gateName,
        options
    ]);
    return gate;
};
module.exports.useFeatureGate = $d6bd1c351628a6f2$var$useFeatureGate;
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const $d6bd1c351628a6f2$var$useExperimentValue = (experimentName, parameterName, defaultValue, options = {})=>{
    const [experimentValue, setExperimentValue] = (0, $1v5pe.useState)(()=>$d6bd1c351628a6f2$var$feature_gate_js_client_1.default.getExperimentValue(experimentName, parameterName, defaultValue, options));
    (0, $1v5pe.useEffect)(()=>{
        const onExperimentValueChange = (newValue)=>setExperimentValue(newValue);
        return $d6bd1c351628a6f2$var$feature_gate_js_client_1.default.onExperimentValueUpdated(experimentName, parameterName, defaultValue, onExperimentValueChange, options);
    }, [
        experimentName,
        parameterName,
        defaultValue,
        options
    ]);
    return experimentValue;
};
module.exports.useExperimentValue = $d6bd1c351628a6f2$var$useExperimentValue;

});
parcelRegister("gGyUC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("4d1Vr")).default);
$parcel$export(module.exports, "FeatureGateEnvironment", () => (parcelRequire("joS99")).FeatureGateEnvironment);
$parcel$export(module.exports, "PerimeterType", () => (parcelRequire("joS99")).PerimeterType);
$parcel$export(module.exports, "CLIENT_VERSION", () => (parcelRequire("4d6dI")).CLIENT_VERSION);
$parcel$export(module.exports, "DynamicConfig", () => (parcelRequire("4p9Sd")).DynamicConfig);
$parcel$export(module.exports, "Layer", () => (parcelRequire("kIeaF")).Layer);
$parcel$export(module.exports, "EvaluationReason", () => (parcelRequire("lOIRH")).EvaluationReason);

var $4d1Vr = parcelRequire("4d1Vr");

var $joS99 = parcelRequire("joS99");

var $4d6dI = parcelRequire("4d6dI");

var $4p9Sd = parcelRequire("4p9Sd");

var $kIeaF = parcelRequire("kIeaF");

var $lOIRH = parcelRequire("lOIRH");

});


parcelRegister("bj8Zo", function(module, exports) {
"use strict";
var $83b87120a3a3f350$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitialization = void 0;

var $1v5pe = parcelRequire("1v5pe");

const $83b87120a3a3f350$var$feature_gate_js_client_1 = $83b87120a3a3f350$var$__importDefault((parcelRequire("gGyUC")));

var $5cBwV = parcelRequire("5cBwV");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $83b87120a3a3f350$var$FeatureGatesInitialization = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $1v5pe.useState)(!overrides && (0, $5cBwV.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $1v5pe.useRef)(options);
    (0, $1v5pe.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (enabled) {
            if ((0, $5cBwV.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $5cBwV.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $83b87120a3a3f350$var$feature_gate_js_client_1.default.initializeCalled() ? $83b87120a3a3f350$var$feature_gate_js_client_1.default.updateUser(optionsRef.current, identifiers, customAttributes) : $83b87120a3a3f350$var$feature_gate_js_client_1.default.initialize(optionsRef.current, identifiers, customAttributes);
                initPromise.catch((err)=>(0, $5cBwV.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $5cBwV.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $5cBwV.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $5cBwV.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitialization = $83b87120a3a3f350$var$FeatureGatesInitialization;
module.exports.default = module.exports.FeatureGatesInitialization;

});
parcelRegister("5cBwV", function(module, exports) {
"use strict";
var $3c9b2f71dbe5292d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isClientAlreadyInCorrectState = $3c9b2f71dbe5292d$var$isClientAlreadyInCorrectState;
module.exports.pickChildToRender = $3c9b2f71dbe5292d$var$pickChildToRender;
module.exports.toError = $3c9b2f71dbe5292d$var$toError;
module.exports.applyOverrides = $3c9b2f71dbe5292d$var$applyOverrides;
module.exports.clearOverrides = $3c9b2f71dbe5292d$var$clearOverrides;

const $3c9b2f71dbe5292d$var$react_1 = $3c9b2f71dbe5292d$var$__importDefault((parcelRequire("1v5pe")));

const $3c9b2f71dbe5292d$var$feature_gate_js_client_1 = $3c9b2f71dbe5292d$var$__importDefault((parcelRequire("gGyUC")));
let $3c9b2f71dbe5292d$var$hasWarnedAboutMissingOverrideSupport = false;
function $3c9b2f71dbe5292d$var$isClientAlreadyInCorrectState(identifiers, customAttributes) {
    var _a, _b;
    // If either of these methods don't exist (ie. if the product is using <v4.2.0), then this method will always return false
    return ((_a = $3c9b2f71dbe5292d$var$feature_gate_js_client_1.default.initializeCompleted) === null || _a === void 0 ? void 0 : _a.call($3c9b2f71dbe5292d$var$feature_gate_js_client_1.default)) && ((_b = $3c9b2f71dbe5292d$var$feature_gate_js_client_1.default.isCurrentUser) === null || _b === void 0 ? void 0 : _b.call($3c9b2f71dbe5292d$var$feature_gate_js_client_1.default, identifiers, customAttributes));
}
function $3c9b2f71dbe5292d$var$pickChildToRender(enabled, isInitialized, children, initializingComponent) {
    if (!enabled || isInitialized) return $3c9b2f71dbe5292d$var$react_1.default.createElement($3c9b2f71dbe5292d$var$react_1.default.Fragment, null, children);
    if (initializingComponent != null) return $3c9b2f71dbe5292d$var$react_1.default.createElement($3c9b2f71dbe5292d$var$react_1.default.Fragment, null, initializingComponent);
    return null;
}
function $3c9b2f71dbe5292d$var$toError(err) {
    if (err instanceof Error) return err;
    return new Error(err === null || err === void 0 ? void 0 : err.toString());
}
function $3c9b2f71dbe5292d$var$applyOverrides(overrides) {
    // Allow newer versions of the React SDK to be used with older v3.x JS client versions,
    // provided the caller does not try to leverage the overrides which were introduced in v4.
    if (overrides && (!$3c9b2f71dbe5292d$var$feature_gate_js_client_1.default.overrideGate || !$3c9b2f71dbe5292d$var$feature_gate_js_client_1.default.overrideConfig)) {
        if (!$3c9b2f71dbe5292d$var$hasWarnedAboutMissingOverrideSupport) {
            console.warn('Overrides are only supported in @atlaskit/feature-gate-js-client v4.0.0+');
            $3c9b2f71dbe5292d$var$hasWarnedAboutMissingOverrideSupport = true;
        }
        return;
    }
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach(([gateName, value])=>{
        var _a;
        (_a = $3c9b2f71dbe5292d$var$feature_gate_js_client_1.default.overrideGate) === null || _a === void 0 || _a.call($3c9b2f71dbe5292d$var$feature_gate_js_client_1.default, gateName, value);
    });
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach(([configName, values])=>{
        var _a;
        (_a = $3c9b2f71dbe5292d$var$feature_gate_js_client_1.default.overrideConfig) === null || _a === void 0 || _a.call($3c9b2f71dbe5292d$var$feature_gate_js_client_1.default, configName, values);
    });
}
function $3c9b2f71dbe5292d$var$clearOverrides(overrides) {
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach((gateName)=>{
        var _a;
        (_a = $3c9b2f71dbe5292d$var$feature_gate_js_client_1.default.clearGateOverride) === null || _a === void 0 || _a.call($3c9b2f71dbe5292d$var$feature_gate_js_client_1.default, gateName);
    });
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach((configName)=>{
        var _a;
        (_a = $3c9b2f71dbe5292d$var$feature_gate_js_client_1.default.clearConfigOverride) === null || _a === void 0 || _a.call($3c9b2f71dbe5292d$var$feature_gate_js_client_1.default, configName);
    });
}

});


parcelRegister("dQ3yU", function(module, exports) {
"use strict";
var $a132e508e4c80896$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithProvider = void 0;

var $1v5pe = parcelRequire("1v5pe");

const $a132e508e4c80896$var$feature_gate_js_client_1 = $a132e508e4c80896$var$__importDefault((parcelRequire("gGyUC")));

var $5cBwV = parcelRequire("5cBwV");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $a132e508e4c80896$var$FeatureGatesInitializationWithProvider = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady, provider: provider })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $1v5pe.useState)(!overrides && (0, $5cBwV.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options and provider, so that we can use them within the following useEffect
    // without adding options and provider as dependencies.
    // This avoids the user updating every time an option or provider is attempted to be changed.
    const optionsRef = (0, $1v5pe.useRef)(options);
    const providerRef = (0, $1v5pe.useRef)(provider);
    (0, $1v5pe.useEffect)(()=>{
        optionsRef.current = options;
        providerRef.current = provider;
    }, [
        options,
        provider
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (enabled) {
            if ((0, $5cBwV.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $5cBwV.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $a132e508e4c80896$var$feature_gate_js_client_1.default.initializeCalled() ? $a132e508e4c80896$var$feature_gate_js_client_1.default.updateUserWithProvider(identifiers, customAttributes) : $a132e508e4c80896$var$feature_gate_js_client_1.default.initializeWithProvider(options, provider, identifiers, customAttributes);
                initPromise.catch((err)=>(0, $5cBwV.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $5cBwV.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $5cBwV.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $5cBwV.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitializationWithProvider = $a132e508e4c80896$var$FeatureGatesInitializationWithProvider;
module.exports.default = module.exports.FeatureGatesInitializationWithProvider;

});

parcelRegister("kyyQ5", function(module, exports) {
"use strict";
var $ef7201ee4557bb25$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithDefaults = void 0;

var $1v5pe = parcelRequire("1v5pe");

const $ef7201ee4557bb25$var$feature_gate_js_client_1 = $ef7201ee4557bb25$var$__importDefault((parcelRequire("gGyUC")));

var $5cBwV = parcelRequire("5cBwV");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $ef7201ee4557bb25$var$FeatureGatesInitializationWithDefaults = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $1v5pe.useState)(!overrides && (0, $5cBwV.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $1v5pe.useRef)(options);
    (0, $1v5pe.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (enabled) {
            if ((0, $5cBwV.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $5cBwV.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $ef7201ee4557bb25$var$feature_gate_js_client_1.default.initializeCalled() ? $ef7201ee4557bb25$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes) : $ef7201ee4557bb25$var$feature_gate_js_client_1.default.initializeFromValues(Object.assign({
                    sdkKey: 'client-default-key'
                }, optionsRef.current || {}), identifiers, customAttributes);
                initPromise.catch((err)=>(0, $5cBwV.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $5cBwV.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $5cBwV.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $5cBwV.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithDefaults = $ef7201ee4557bb25$var$FeatureGatesInitializationWithDefaults;
module.exports.default = module.exports.FeatureGatesInitializationWithDefaults;

});

parcelRegister("i6koh", function(module, exports) {
"use strict";
var $d2d89ab43b3c322f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithValues = void 0;

var $1v5pe = parcelRequire("1v5pe");

const $d2d89ab43b3c322f$var$feature_gate_js_client_1 = $d2d89ab43b3c322f$var$__importDefault((parcelRequire("gGyUC")));

var $5cBwV = parcelRequire("5cBwV");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $d2d89ab43b3c322f$var$FeatureGatesInitializationWithValues = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializeValues: initializeValues, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $1v5pe.useState)(!overrides && (0, $5cBwV.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $1v5pe.useRef)(options);
    (0, $1v5pe.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (enabled) {
            if ((0, $5cBwV.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $5cBwV.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $d2d89ab43b3c322f$var$feature_gate_js_client_1.default.initializeCalled() ? $d2d89ab43b3c322f$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes, initializeValues) : $d2d89ab43b3c322f$var$feature_gate_js_client_1.default.initializeFromValues(optionsRef.current, identifiers, customAttributes, initializeValues);
                initPromise.catch((err)=>(0, $5cBwV.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $5cBwV.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $5cBwV.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        initializeValues,
        overrides
    ]);
    return (0, $5cBwV.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithValues = $d2d89ab43b3c322f$var$FeatureGatesInitializationWithValues;
module.exports.default = module.exports.FeatureGatesInitializationWithValues;

});


parcelRegister("jY3c0", function(module, exports) {
$parcel$export(module.exports, "fg", () => $88e734f7a603529b$export$b40ec24ac8275656);
$parcel$export(module.exports, "ComponentWithCondition", () => (parcelRequire("lUKJP")).ComponentWithCondition);

var $4d1Vr = parcelRequire("4d1Vr");
parcelRequire("je6Hx");
var $lUKJP = parcelRequire("lUKJP");
const $88e734f7a603529b$export$b40ec24ac8275656 = (gateName)=>{
    (0, $4d1Vr.default).initializeCompleted();
    return (0, $4d1Vr.default).checkGate(gateName);
};
const $88e734f7a603529b$export$9db1624a8af791a4 = (experimentName, param, defaultValue)=>{
    (0, $4d1Vr.default).initializeCompleted();
    return (0, $4d1Vr.default).getExperimentValue(experimentName, param, defaultValue);
};

});
parcelRegister("je6Hx", function(module, exports) {
$parcel$export(module.exports, "ComponentWithCondition", () => (parcelRequire("lUKJP")).ComponentWithCondition);

var $lUKJP = parcelRequire("lUKJP");

});
parcelRegister("lUKJP", function(module, exports) {
$parcel$export(module.exports, "ComponentWithCondition", () => $e82393328e4dc107$export$e4e273a7819d58cb);

var $1v5pe = parcelRequire("1v5pe");

var $kIqwl = parcelRequire("kIqwl");
function $e82393328e4dc107$export$e4e273a7819d58cb(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, $kIqwl.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $kIqwl.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    return ComponentWithCondition;
}

});



parcelRegister("eyztC", function(module, exports) {
$parcel$export(module.exports, "NotFound", () => $b4d0ef03862e8933$export$271f9f08425019c7);
parcelRequire("fjjed");
var $7hFVb = parcelRequire("7hFVb");

var $kK7WO = parcelRequire("kK7WO");
parcelRequire("7yQXV");
var $inmj3 = parcelRequire("inmj3");
var $fsPVv = parcelRequire("fsPVv");

var $6tsgF = parcelRequire("6tsgF");

var $kIqwl = parcelRequire("kIqwl");
const $b4d0ef03862e8933$export$271f9f08425019c7 = ()=>{
    const { formatMessage: formatMessage } = (0, $kK7WO.default)();
    const [routeState] = (0, $fsPVv.useRouter)();
    if (routeState.match.path === '/') return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $inmj3.Redirect), {
        to: "/"
    });
    return /*#__PURE__*/ (0, $kIqwl.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7hFVb.FireScreenEvent), {
                name: "devAgentsNotFound",
                attributes: {
                    attemptedPath: routeState.location.pathname
                }
            }),
            formatMessage((0, $6tsgF.default).pageTitle)
        ]
    });
};

});
parcelRegister("6tsgF", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f9cd5c6b485e50b$export$2e2bcd8739ae039);

var $75IaS = parcelRequire("75IaS");
var $9f9cd5c6b485e50b$export$2e2bcd8739ae039 = (0, $75IaS.defineMessages)({
    pageTitle: {
        id: 'dev-agents.not-found.page-title',
        defaultMessage: 'Not found',
        description: 'Message displayed when a requested page cannot be found'
    }
});

});



parcelRegister("2gfcT", function(module, exports) {
$parcel$export(module.exports, "appAdminUnavailablePath", () => (parcelRequire("5cmoV")).appAdminUnavailablePath);
$parcel$export(module.exports, "autoDevAssemblyLinePath", () => (parcelRequire("5cmoV")).autoDevAssemblyLinePath);
$parcel$export(module.exports, "autoDevAssemblyLineSettingsPath", () => (parcelRequire("5cmoV")).autoDevAssemblyLineSettingsPath);
$parcel$export(module.exports, "autoDevAssemblyLineSettingsSectionPath", () => (parcelRequire("5cmoV")).autoDevAssemblyLineSettingsSectionPath);
$parcel$export(module.exports, "autoDevAssemblyLineTabPath", () => (parcelRequire("5cmoV")).autoDevAssemblyLineTabPath);
$parcel$export(module.exports, "autoDevBacklogScansPath", () => (parcelRequire("5cmoV")).autoDevBacklogScansPath);
$parcel$export(module.exports, "autoDevDashboardPath", () => (parcelRequire("5cmoV")).autoDevDashboardPath);
$parcel$export(module.exports, "autoDevRefineIssuePath", () => (parcelRequire("5cmoV")).autoDevRefineIssuePath);
$parcel$export(module.exports, "autoDevRefinePath", () => (parcelRequire("5cmoV")).autoDevRefinePath);
$parcel$export(module.exports, "autoDevSettingsPath", () => (parcelRequire("5cmoV")).autoDevSettingsPath);
$parcel$export(module.exports, "autoDevSettingsSharedSpacesPath", () => (parcelRequire("5cmoV")).autoDevSettingsSharedSpacesPath);
$parcel$export(module.exports, "autoDevSettingsSkillsRepositoryPath", () => (parcelRequire("5cmoV")).autoDevSettingsSkillsRepositoryPath);
$parcel$export(module.exports, "autoDevWorkstreamsPath", () => (parcelRequire("5cmoV")).autoDevWorkstreamsPath);
$parcel$export(module.exports, "betaOfferingDeprecationPath", () => (parcelRequire("5cmoV")).betaOfferingDeprecationPath);
$parcel$export(module.exports, "boysenberryCodePagePath", () => (parcelRequire("5cmoV")).boysenberryCodePagePath);
$parcel$export(module.exports, "boysenberryDashboardLegacyPath", () => (parcelRequire("5cmoV")).boysenberryDashboardLegacyPath);
$parcel$export(module.exports, "boysenberryDashboardPath", () => (parcelRequire("5cmoV")).boysenberryDashboardPath);
$parcel$export(module.exports, "boysenberryFlowPath", () => (parcelRequire("5cmoV")).boysenberryFlowPath);
$parcel$export(module.exports, "dashboardPath", () => (parcelRequire("5cmoV")).dashboardPath);
$parcel$export(module.exports, "devaiSetupWizardPath", () => (parcelRequire("5cmoV")).devaiSetupWizardPath);
$parcel$export(module.exports, "environmentSettingsPath", () => (parcelRequire("5cmoV")).environmentSettingsPath);
$parcel$export(module.exports, "getAutoDevAssemblyLineSettingsUrl", () => (parcelRequire("5cmoV")).getAutoDevAssemblyLineSettingsUrl);
$parcel$export(module.exports, "getAutoDevAssemblyLineTabUrl", () => (parcelRequire("5cmoV")).getAutoDevAssemblyLineTabUrl);
$parcel$export(module.exports, "getAutoDevAssemblyLineUrl", () => (parcelRequire("5cmoV")).getAutoDevAssemblyLineUrl);
$parcel$export(module.exports, "githubOauthRedirectPath", () => (parcelRequire("5cmoV")).githubOauthRedirectPath);
$parcel$export(module.exports, "homePath", () => (parcelRequire("5cmoV")).homePath);
$parcel$export(module.exports, "invitePath", () => (parcelRequire("5cmoV")).invitePath);
$parcel$export(module.exports, "migrateFromBetaPath", () => (parcelRequire("5cmoV")).migrateFromBetaPath);
$parcel$export(module.exports, "noAccessPath", () => (parcelRequire("5cmoV")).noAccessPath);
$parcel$export(module.exports, "noInstallationPath", () => (parcelRequire("5cmoV")).noInstallationPath);
$parcel$export(module.exports, "orgUsagePath", () => (parcelRequire("5cmoV")).orgUsagePath);
$parcel$export(module.exports, "overviewPath", () => (parcelRequire("5cmoV")).overviewPath);
$parcel$export(module.exports, "reviewerPath", () => (parcelRequire("5cmoV")).reviewerPath);
$parcel$export(module.exports, "reviewerRepositoriesPath", () => (parcelRequire("5cmoV")).reviewerRepositoriesPath);
$parcel$export(module.exports, "rootPath", () => (parcelRequire("5cmoV")).rootPath);
$parcel$export(module.exports, "scmSetupWizardPath", () => (parcelRequire("5cmoV")).scmSetupWizardPath);
$parcel$export(module.exports, "settingsCodeReviewerGithubPath", () => (parcelRequire("5cmoV")).settingsCodeReviewerGithubPath);
$parcel$export(module.exports, "settingsCodeReviewerGithubRepoSettingsPath", () => (parcelRequire("5cmoV")).settingsCodeReviewerGithubRepoSettingsPath);
$parcel$export(module.exports, "settingsCodeReviewerGithubReposSettingsPath", () => (parcelRequire("5cmoV")).settingsCodeReviewerGithubReposSettingsPath);
$parcel$export(module.exports, "settingsCodeReviewerPath", () => (parcelRequire("5cmoV")).settingsCodeReviewerPath);
$parcel$export(module.exports, "settingsPath", () => (parcelRequire("5cmoV")).settingsPath);
$parcel$export(module.exports, "settingsRovoDevCLIPath", () => (parcelRequire("5cmoV")).settingsRovoDevCLIPath);
$parcel$export(module.exports, "siteSettingsPath", () => (parcelRequire("5cmoV")).siteSettingsPath);
$parcel$export(module.exports, "sreDetailedUsagePath", () => (parcelRequire("5cmoV")).sreDetailedUsagePath);
$parcel$export(module.exports, "srePath", () => (parcelRequire("5cmoV")).srePath);
$parcel$export(module.exports, "sreSetupPath", () => (parcelRequire("5cmoV")).sreSetupPath);
$parcel$export(module.exports, "standardsDetailPath", () => (parcelRequire("5cmoV")).standardsDetailPath);
$parcel$export(module.exports, "standardsNewPath", () => (parcelRequire("5cmoV")).standardsNewPath);
$parcel$export(module.exports, "standardsPath", () => (parcelRequire("5cmoV")).standardsPath);
$parcel$export(module.exports, "upgradeRequestPath", () => (parcelRequire("5cmoV")).upgradeRequestPath);
$parcel$export(module.exports, "userSettingsPath", () => (parcelRequire("5cmoV")).userSettingsPath);
$parcel$export(module.exports, "yourUsagePath", () => (parcelRequire("5cmoV")).yourUsagePath);
$parcel$export(module.exports, "createAutoDevRefineRoute", () => (parcelRequire("k92qP")).createAutoDevRefineRoute);
$parcel$export(module.exports, "createEnvironmentSettingsRoute", () => (parcelRequire("k92qP")).createEnvironmentSettingsRoute);
$parcel$export(module.exports, "createFlowRoute", () => (parcelRequire("k92qP")).createFlowRoute);
$parcel$export(module.exports, "decodeRepositoryUrl", () => (parcelRequire("k92qP")).decodeRepositoryUrl);
$parcel$export(module.exports, "getReviewerRepositoryUrl", () => (parcelRequire("k92qP")).getReviewerRepositoryUrl);
$parcel$export(module.exports, "getStandardsDetailPath", () => (parcelRequire("k92qP")).getStandardsDetailPath);
parcelRequire("5cmoV");
parcelRequire("k92qP");

});
parcelRegister("5cmoV", function(module, exports) {
$parcel$export(module.exports, "rootPath", () => $fa481780bd1e257e$export$2c2b629ee110b0c4);
$parcel$export(module.exports, "homePath", () => $fa481780bd1e257e$export$5d5930b97498321d);
$parcel$export(module.exports, "noAccessPath", () => $fa481780bd1e257e$export$29d3201d8af27b92);
$parcel$export(module.exports, "noInstallationPath", () => $fa481780bd1e257e$export$b583bc9f88f5fba);
$parcel$export(module.exports, "betaOfferingDeprecationPath", () => $fa481780bd1e257e$export$34233e018672f0fe);
$parcel$export(module.exports, "migrateFromBetaPath", () => $fa481780bd1e257e$export$7beb611fa12121de);
$parcel$export(module.exports, "overviewPath", () => $fa481780bd1e257e$export$ea6f5aba5c487964);
$parcel$export(module.exports, "yourUsagePath", () => $fa481780bd1e257e$export$c6b47d347d8ffabf);
$parcel$export(module.exports, "orgUsagePath", () => $fa481780bd1e257e$export$5dee4e158f96aaee);
$parcel$export(module.exports, "dashboardPath", () => $fa481780bd1e257e$export$fbb774459e7ab9d9);
$parcel$export(module.exports, "invitePath", () => $fa481780bd1e257e$export$1e91d82895f751c0);
$parcel$export(module.exports, "scmSetupWizardPath", () => $fa481780bd1e257e$export$f9003c8d341ef886);
$parcel$export(module.exports, "siteSettingsPath", () => $fa481780bd1e257e$export$d4f4f7c403efb423);
$parcel$export(module.exports, "settingsPath", () => $fa481780bd1e257e$export$f415a4675edd2314);
$parcel$export(module.exports, "userSettingsPath", () => $fa481780bd1e257e$export$599fd4300a5230e4);
$parcel$export(module.exports, "settingsCodeReviewerPath", () => $fa481780bd1e257e$export$d278c9a4e4cdafa2);
$parcel$export(module.exports, "settingsCodeReviewerGithubPath", () => $fa481780bd1e257e$export$4e79c595b768bc2d);
$parcel$export(module.exports, "settingsCodeReviewerGithubReposSettingsPath", () => $fa481780bd1e257e$export$ec3ca2d88343e549);
$parcel$export(module.exports, "settingsCodeReviewerGithubRepoSettingsPath", () => $fa481780bd1e257e$export$aea07dd61f0939c1);
$parcel$export(module.exports, "settingsRovoDevCLIPath", () => $fa481780bd1e257e$export$1b149c62acfc2371);
$parcel$export(module.exports, "upgradeRequestPath", () => $fa481780bd1e257e$export$18d311d30bf428b2);
$parcel$export(module.exports, "boysenberryDashboardPath", () => $fa481780bd1e257e$export$78101976e2867735);
$parcel$export(module.exports, "boysenberryDashboardLegacyPath", () => $fa481780bd1e257e$export$4d6438971c2097f0);
$parcel$export(module.exports, "boysenberryFlowPath", () => $fa481780bd1e257e$export$aba8de7a7c35cfeb);
$parcel$export(module.exports, "boysenberryCodePagePath", () => $fa481780bd1e257e$export$8c7edd817b46b0f5);
$parcel$export(module.exports, "environmentSettingsPath", () => $fa481780bd1e257e$export$6c02b5e8f8822fc0);
$parcel$export(module.exports, "githubOauthRedirectPath", () => $fa481780bd1e257e$export$ce1f0d37aab66ffa);
$parcel$export(module.exports, "reviewerPath", () => $fa481780bd1e257e$export$7b5bf4dcf816ec88);
$parcel$export(module.exports, "reviewerRepositoriesPath", () => $fa481780bd1e257e$export$304c06e44c6a6aa);
$parcel$export(module.exports, "standardsPath", () => $fa481780bd1e257e$export$dae40912b467a99);
$parcel$export(module.exports, "standardsNewPath", () => $fa481780bd1e257e$export$dfa2fd9ab12767ab);
$parcel$export(module.exports, "standardsDetailPath", () => $fa481780bd1e257e$export$e1e41a1ed126c0c7);
$parcel$export(module.exports, "autoDevDashboardPath", () => $fa481780bd1e257e$export$7f0e7bdf43da2290);
$parcel$export(module.exports, "autoDevRefinePath", () => $fa481780bd1e257e$export$dc52deb7c116957);
$parcel$export(module.exports, "autoDevRefineIssuePath", () => $fa481780bd1e257e$export$a4c30107fee932e3);
$parcel$export(module.exports, "autoDevBacklogScansPath", () => $fa481780bd1e257e$export$d75c5d2a88fdb57b);
$parcel$export(module.exports, "autoDevWorkstreamsPath", () => $fa481780bd1e257e$export$b095cbb637dde8ce);
$parcel$export(module.exports, "autoDevSettingsPath", () => $fa481780bd1e257e$export$af799a218fa42026);
$parcel$export(module.exports, "autoDevSettingsSkillsRepositoryPath", () => $fa481780bd1e257e$export$79524c694d729091);
$parcel$export(module.exports, "autoDevSettingsSharedSpacesPath", () => $fa481780bd1e257e$export$31c9cee3a0cc1963);
$parcel$export(module.exports, "autoDevAssemblyLinePath", () => $fa481780bd1e257e$export$3ac0c2b485103d67);
$parcel$export(module.exports, "autoDevAssemblyLineTabPath", () => $fa481780bd1e257e$export$ec29302a2f1563d8);
$parcel$export(module.exports, "autoDevAssemblyLineSettingsPath", () => $fa481780bd1e257e$export$6b8346311d3fa1fb);
$parcel$export(module.exports, "autoDevAssemblyLineSettingsSectionPath", () => $fa481780bd1e257e$export$fa2471b9d7b31264);
$parcel$export(module.exports, "devaiSetupWizardPath", () => $fa481780bd1e257e$export$eddffae962a52f6f);
$parcel$export(module.exports, "appAdminUnavailablePath", () => $fa481780bd1e257e$export$b2853a4ff9568f8);
$parcel$export(module.exports, "srePath", () => $fa481780bd1e257e$export$33e47f170e3e4ec9);
$parcel$export(module.exports, "sreSetupPath", () => $fa481780bd1e257e$export$bae2831f25837a46);
$parcel$export(module.exports, "sreDetailedUsagePath", () => $fa481780bd1e257e$export$b5f145a06eeef352);
$parcel$export(module.exports, "getAutoDevAssemblyLineUrl", () => $fa481780bd1e257e$export$186f1df9eefcb55);
$parcel$export(module.exports, "getAutoDevAssemblyLineTabUrl", () => $fa481780bd1e257e$export$e74530e4ba524572);
$parcel$export(module.exports, "getAutoDevAssemblyLineSettingsUrl", () => $fa481780bd1e257e$export$30cc40dbb2a28e26);
const $fa481780bd1e257e$export$2c2b629ee110b0c4 = '/';
const $fa481780bd1e257e$export$5d5930b97498321d = '/home';
const $fa481780bd1e257e$export$29d3201d8af27b92 = '/no-access';
const $fa481780bd1e257e$export$b583bc9f88f5fba = '/no-installation';
const $fa481780bd1e257e$export$34233e018672f0fe = '/beta-offering-ended';
const $fa481780bd1e257e$export$7beb611fa12121de = '/migrate-from-beta';
const $fa481780bd1e257e$export$ea6f5aba5c487964 = '/overview';
const $fa481780bd1e257e$export$c6b47d347d8ffabf = '/your-usage';
const $fa481780bd1e257e$export$5dee4e158f96aaee = '/usage';
const $fa481780bd1e257e$export$fbb774459e7ab9d9 = '/dashboard';
const $fa481780bd1e257e$export$1e91d82895f751c0 = '/invite';
const $fa481780bd1e257e$export$f9003c8d341ef886 = '/setup';
const $fa481780bd1e257e$export$d4f4f7c403efb423 = '/site-settings';
const $fa481780bd1e257e$export$f415a4675edd2314 = '/settings';
const $fa481780bd1e257e$export$599fd4300a5230e4 = '/my-settings';
const $fa481780bd1e257e$export$d278c9a4e4cdafa2 = '/code-reviewer';
const $fa481780bd1e257e$export$4e79c595b768bc2d = '/code-reviewer/github';
const $fa481780bd1e257e$export$ec3ca2d88343e549 = '/code-reviewer/github/organisations/:orgId';
const $fa481780bd1e257e$export$aea07dd61f0939c1 = '/code-reviewer/github/organisations/:orgId/repositories/:repoName';
const $fa481780bd1e257e$export$1b149c62acfc2371 = '/rovo-dev-cli';
const $fa481780bd1e257e$export$18d311d30bf428b2 = '/upgrade-request';
const $fa481780bd1e257e$export$78101976e2867735 = '/sessions';
const $fa481780bd1e257e$export$4d6438971c2097f0 = '/flow/dashboard';
const $fa481780bd1e257e$export$aba8de7a7c35cfeb = '/flow/s/:flowId';
const $fa481780bd1e257e$export$8c7edd817b46b0f5 = '/flow/s/:flowId/code';
const $fa481780bd1e257e$export$6c02b5e8f8822fc0 = '/environment-settings/:encodedRepoUrl';
const $fa481780bd1e257e$export$ce1f0d37aab66ffa = '/github-oauth-redirect';
const $fa481780bd1e257e$export$7b5bf4dcf816ec88 = '/reviewer';
const $fa481780bd1e257e$export$304c06e44c6a6aa = '/reviewer/repositories';
const $fa481780bd1e257e$export$dae40912b467a99 = '/standards';
const $fa481780bd1e257e$export$dfa2fd9ab12767ab = '/standards/new';
const $fa481780bd1e257e$export$e1e41a1ed126c0c7 = '/standards/:standardId';
const $fa481780bd1e257e$export$7f0e7bdf43da2290 = '/autodev';
const $fa481780bd1e257e$export$dc52deb7c116957 = '/autodev/refine';
const $fa481780bd1e257e$export$a4c30107fee932e3 = '/autodev/refine/:issueKey';
const $fa481780bd1e257e$export$d75c5d2a88fdb57b = '/autodev/backlog-scans';
const $fa481780bd1e257e$export$b095cbb637dde8ce = $fa481780bd1e257e$export$d75c5d2a88fdb57b;
const $fa481780bd1e257e$export$af799a218fa42026 = '/autodev/settings';
const $fa481780bd1e257e$export$79524c694d729091 = '/autodev/settings/skill-repositories';
const $fa481780bd1e257e$export$31c9cee3a0cc1963 = '/autodev/settings/shared-spaces';
const $fa481780bd1e257e$export$3ac0c2b485103d67 = '/autodev/dashboard/:workstreamId';
const $fa481780bd1e257e$export$ec29302a2f1563d8 = '/autodev/dashboard/:workstreamId/:tab(insights|all-work-items)';
const $fa481780bd1e257e$export$6b8346311d3fa1fb = '/autodev/dashboard/:workstreamId/settings';
const $fa481780bd1e257e$export$fa2471b9d7b31264 = '/autodev/dashboard/:workstreamId/settings/:settingsSection';
const $fa481780bd1e257e$export$eddffae962a52f6f = '/setup-devai';
const $fa481780bd1e257e$export$b2853a4ff9568f8 = '/app-admin-unavailable';
const $fa481780bd1e257e$export$33e47f170e3e4ec9 = '/sre';
const $fa481780bd1e257e$export$bae2831f25837a46 = '/sre/setup';
const $fa481780bd1e257e$export$b5f145a06eeef352 = '/sre/detailed-usage';
const $fa481780bd1e257e$export$b46856ed1001aeb1 = [
    'insights',
    'all-work-items'
];
const $fa481780bd1e257e$export$186f1df9eefcb55 = (workstreamId)=>`/autodev/dashboard/${workstreamId}`;
const $fa481780bd1e257e$export$e74530e4ba524572 = (workstreamId, tab)=>tab ? `/autodev/dashboard/${workstreamId}/${tab}` : $fa481780bd1e257e$export$186f1df9eefcb55(workstreamId);
const $fa481780bd1e257e$export$30cc40dbb2a28e26 = (workstreamId)=>`/autodev/dashboard/${workstreamId}/settings`;

});

parcelRegister("k92qP", function(module, exports) {
$parcel$export(module.exports, "getStandardsDetailPath", () => $d7d528e55429a52a$export$108aa20d4851be32);
$parcel$export(module.exports, "createFlowRoute", () => $d7d528e55429a52a$export$ba128a57e6df3736);
$parcel$export(module.exports, "createAutoDevRefineRoute", () => $d7d528e55429a52a$export$84ee17df5350c331);
$parcel$export(module.exports, "createEnvironmentSettingsRoute", () => $d7d528e55429a52a$export$46671d2a7a402a22);
$parcel$export(module.exports, "decodeRepositoryUrl", () => $d7d528e55429a52a$export$d2f92420c9e43245);
$parcel$export(module.exports, "getReviewerRepositoryUrl", () => $d7d528e55429a52a$export$69ee1004e8e57ba6);
parcelRequire("7yQXV");
var $j5iRK = parcelRequire("j5iRK");

var $5cmoV = parcelRequire("5cmoV");
const $d7d528e55429a52a$export$2494cae61487b7f5 = (name)=>name.trim().replace(/\s+/g, '-').toLowerCase();
const $d7d528e55429a52a$export$108aa20d4851be32 = (standardId)=>(0, $j5iRK.generatePath)((0, $5cmoV.standardsDetailPath), {
        standardId: standardId
    });
const $d7d528e55429a52a$export$ba128a57e6df3736 = (flowId)=>{
    return (0, $j5iRK.generatePath)((0, $5cmoV.boysenberryFlowPath), {
        flowId: flowId
    });
};
const $d7d528e55429a52a$export$f9c9ceb569f226b1 = (flowId)=>{
    return (0, $j5iRK.generatePath)((0, $5cmoV.boysenberryCodePagePath), {
        flowId: flowId
    });
};
const $d7d528e55429a52a$export$84ee17df5350c331 = (issueKey)=>{
    return (0, $j5iRK.generatePath)((0, $5cmoV.autoDevRefineIssuePath), {
        issueKey: issueKey
    });
};
const $d7d528e55429a52a$export$7a74bc24a35ed858 = (workstreamId)=>{
    return (0, $j5iRK.generatePath)((0, $5cmoV.autoDevAssemblyLinePath), {
        workstreamId: workstreamId
    });
};
const $d7d528e55429a52a$export$779afd42838daa25 = (repositoryUrl)=>{
    return btoa(repositoryUrl);
};
const $d7d528e55429a52a$export$46671d2a7a402a22 = (repositoryUrl)=>{
    const encodedRepoUrl = $d7d528e55429a52a$export$779afd42838daa25(repositoryUrl);
    return (0, $j5iRK.generatePath)((0, $5cmoV.environmentSettingsPath), {
        encodedRepoUrl: encodedRepoUrl
    });
};
const $d7d528e55429a52a$export$d2f92420c9e43245 = (encodedRepoUrl)=>{
    return atob(encodedRepoUrl);
};
const $d7d528e55429a52a$export$69ee1004e8e57ba6 = (repoAri)=>`${0, $5cmoV.reviewerRepositoriesPath}?repoAri=${encodeURIComponent(repoAri)}`;

});


parcelRegister("dKVDt", function(module, exports) {
$parcel$export(module.exports, "appHistory", () => $f57224add7f1899c$export$76704fbcbb4f06ff);
parcelRequire("7yQXV");
var $gHVeV = parcelRequire("gHVeV");
const $f57224add7f1899c$export$76704fbcbb4f06ff = (0, $gHVeV.createBrowserHistory)();

});

parcelRegister("ccEZf", function(module, exports) {
$parcel$export(module.exports, "ROVO_DEV_BASE_PATH", () => $d04ca0512f38b65f$export$84e8e3c5a3f682ee);
$parcel$export(module.exports, "DEVAI_BASE_PATH", () => $d04ca0512f38b65f$export$1a518c13e2f05816);
$parcel$export(module.exports, "STG_BITBUCKET_DOMAIN", () => $d04ca0512f38b65f$export$37e363941a7d06d9);
$parcel$export(module.exports, "PROD_BITBUCKET_DOMAIN", () => $d04ca0512f38b65f$export$25eb080fef99f257);
$parcel$export(module.exports, "BITBUCKET_SETUP_GUIDE_LINK", () => $d04ca0512f38b65f$export$cc0ce9deeea0cdfa);
$parcel$export(module.exports, "GITHUB_INSTALL_LINK", () => $d04ca0512f38b65f$export$ad9d2623b45ad758);
$parcel$export(module.exports, "GITHUB_SETUP_GUIDE_LINK", () => $d04ca0512f38b65f$export$6a5f3b89af31068a);
$parcel$export(module.exports, "BITBUCKET_MANAGE_LINK", () => $d04ca0512f38b65f$export$595fbe9beb48a7a7);
$parcel$export(module.exports, "ROVO_DEV_DOCS_HOME_LINK", () => $d04ca0512f38b65f$export$9d7199a1d37b2b16);
$parcel$export(module.exports, "CODING_AGENTS_LEARN_MORE_LINK", () => $d04ca0512f38b65f$export$c39cfd122465c04e);
$parcel$export(module.exports, "CODE_REVIEWER_LEARN_MORE_LINK", () => $d04ca0512f38b65f$export$3255dadb03b35a28);
$parcel$export(module.exports, "DEPLOYMENT_SUMMARIZER_LEARN_MORE_LINK", () => $d04ca0512f38b65f$export$f7cf5dee5734594c);
$parcel$export(module.exports, "PIPELINE_TROUBLESHOOTER_LEARN_MORE_LINK", () => $d04ca0512f38b65f$export$7b0f8fec4b919ab3);
$parcel$export(module.exports, "CODE_SEARCH_LEARN_MORE_LINK", () => $d04ca0512f38b65f$export$da4fecf2d95db63b);
$parcel$export(module.exports, "ROVO_DEV_CLI_LEARN_MORE_LINK", () => $d04ca0512f38b65f$export$8ad022a16b75d1b8);
$parcel$export(module.exports, "ADMIN_HUB_BASE_URL_PROD", () => $d04ca0512f38b65f$export$627321b82c429923);
$parcel$export(module.exports, "ADMIN_HUB_BASE_URL_STG", () => $d04ca0512f38b65f$export$944e1ecf8da9f253);
$parcel$export(module.exports, "GITHUB_MANAGE_LINK_PROD", () => $d04ca0512f38b65f$export$d76ba9bdae389e5f);
$parcel$export(module.exports, "GITHUB_MANAGE_LINK_STG", () => $d04ca0512f38b65f$export$deed3f587f71617d);
$parcel$export(module.exports, "DEPLOYMENT_SUMMARIZER_SETTINGS_LINK", () => $d04ca0512f38b65f$export$67efc9ea144c1797);
$parcel$export(module.exports, "PIPELINE_TROUBLESHOOTER_SETTINGS_LINK", () => $d04ca0512f38b65f$export$b48ea3f417d3c529);
$parcel$export(module.exports, "JOIN_WAITLIST_LINK", () => $d04ca0512f38b65f$export$f646aec6c096a2df);
$parcel$export(module.exports, "ROVO_DEV_CLI_READ_MORE_URL", () => $d04ca0512f38b65f$export$ac00119995b0b385);
$parcel$export(module.exports, "ROVO_DEV_CLI_INTRO_URL", () => $d04ca0512f38b65f$export$e649e098739c9373);
$parcel$export(module.exports, "ROVO_DEV_CLI_MAC_INSTRUCTIONS_URL", () => $d04ca0512f38b65f$export$1c9f60393772813c);
$parcel$export(module.exports, "ROVO_DEV_CLI_LINUX_INSTRUCTIONS_URL", () => $d04ca0512f38b65f$export$2a1789535495a20f);
$parcel$export(module.exports, "ROVO_DEV_CLI_WINDOWS_INSTRUCTIONS_URL", () => $d04ca0512f38b65f$export$ce06234640630149);
$parcel$export(module.exports, "ROVO_DEV_CLI_TOKENS_URL", () => $d04ca0512f38b65f$export$b09aacae36ab3e40);
$parcel$export(module.exports, "ROVO_DEV_CLI_BETA_LEARN_MORE_URL", () => $d04ca0512f38b65f$export$f9acf0c992fe35dd);
$parcel$export(module.exports, "ROVO_DEV_ACTIVATE_CODE_REVIEWS_IN_YOUR_REPOS_URL", () => $d04ca0512f38b65f$export$9ecb6abe4ea16180);
$parcel$export(module.exports, "ROVO_DEV_LEARN_ABOUT_GRANTING_ACCESS_URL", () => $d04ca0512f38b65f$export$1e337b71a8d31bdb);
$parcel$export(module.exports, "ROVO_DEV_REQUEST_ACCESS_URL", () => $d04ca0512f38b65f$export$e675e30c4fe7d7ee);
$parcel$export(module.exports, "ROVO_DEV_SIGNUP_URL", () => $d04ca0512f38b65f$export$bf922ad4ddf27877);
$parcel$export(module.exports, "ROVO_DEV_USAGE_URL", () => $d04ca0512f38b65f$export$aebb1d8c96ca4155);
$parcel$export(module.exports, "ROVO_DEV_CLI_TUTORIALS_PLAYLIST_URL", () => $d04ca0512f38b65f$export$74fcb76fee6ef501);
$parcel$export(module.exports, "ROVO_DEV_IDE_VCODE_LEARN_MORE_LINK", () => $d04ca0512f38b65f$export$dc73cf828f0535f0);
$parcel$export(module.exports, "ROVO_DEV_AUTOMATION_REQUEST_ACCESS_LINK", () => $d04ca0512f38b65f$export$2778c55dc303378d);
$parcel$export(module.exports, "GITHUB_FOR_ATLASSIAN_INSTALLATION_PROD_URL", () => $d04ca0512f38b65f$export$2bdc5fc9e68cdcfc);
$parcel$export(module.exports, "GITHUB_FOR_ATLASSIAN_INSTALLATION_STAGING_URL", () => $d04ca0512f38b65f$export$2ceee16a2362752e);
$parcel$export(module.exports, "ROVO_DEV_SOFTWARE_URL", () => $d04ca0512f38b65f$export$d6e3a57abf901396);
$parcel$export(module.exports, "ROVO_DEV_WORK_IN_IDE_URL", () => $d04ca0512f38b65f$export$d451e269e1a96fbe);
$parcel$export(module.exports, "DEVAI_OUTBOUND_AUTH_CONTAINER_ID_PROD", () => $d04ca0512f38b65f$export$337a20bdfe649c93);
$parcel$export(module.exports, "DEVAI_OUTBOUND_AUTH_CONTAINER_ID_STG", () => $d04ca0512f38b65f$export$2a4fc02f01572bb6);
$parcel$export(module.exports, "MANAGE_CONNECTED_APPS_URL_PROD", () => $d04ca0512f38b65f$export$24419c25abfdbd09);
$parcel$export(module.exports, "MANAGE_CONNECTED_APPS_URL_STG", () => $d04ca0512f38b65f$export$123dfdbe28086b37);
const $d04ca0512f38b65f$export$84e8e3c5a3f682ee = '/rovodev';
const $d04ca0512f38b65f$export$1a518c13e2f05816 = '/devai';
const $d04ca0512f38b65f$export$cf681dc9f7811050 = 'https://dev-agents.stg-east.frontend.public.atl-paas.net/assets/';
const $d04ca0512f38b65f$export$792ab0c5da0fd7c5 = 'https://dev-agents.prod-east.frontend.public.atl-paas.net/assets/';
const $d04ca0512f38b65f$export$37e363941a7d06d9 = 'integration.bb-inf.net';
const $d04ca0512f38b65f$export$25eb080fef99f257 = 'bitbucket.org';
const $d04ca0512f38b65f$export$cc0ce9deeea0cdfa = 'https://support.atlassian.com/jira-cloud-administration/docs/integrate-bitbucket-with-jira/';
const $d04ca0512f38b65f$export$ad9d2623b45ad758 = 'https://marketplace.atlassian.com/apps/1219592/github-for-jira?tab=overview&hosting=cloud';
const $d04ca0512f38b65f$export$6a5f3b89af31068a = 'https://support.atlassian.com/jira-cloud-administration/docs/integrate-with-github/';
const $d04ca0512f38b65f$export$595fbe9beb48a7a7 = '/secure/admin/ConfigureDvcsOrganizations!default.jspa';
const $d04ca0512f38b65f$export$9d7199a1d37b2b16 = 'https://support.atlassian.com/rovo/docs/work-with-rovo-dev-agents/';
const $d04ca0512f38b65f$export$c39cfd122465c04e = 'https://rovodevagents-beta.atlassian.net/wiki/external/ZmEwZmU2MTYwMGM3NDE3NjhlOTA2MDZhNGY5ZmU0OTU';
const $d04ca0512f38b65f$export$3255dadb03b35a28 = 'https://rovodevagents-beta.atlassian.net/wiki/external/YWJmZmRiNTFhYTUxNDBhOTg5ZjY5ZmQ0Yzg5MTlkNzA';
const $d04ca0512f38b65f$export$f7cf5dee5734594c = 'https://rovodevagents-beta.atlassian.net/wiki/external/OWYyYTFhNGEyNGUwNGY3YjgwMzkxMDhhMTAzM2EwYzc';
const $d04ca0512f38b65f$export$4c0bd3485d463fe = 'https://bitbucket.org/account/workspaces/';
const $d04ca0512f38b65f$export$4a98fc7b279f08ef = 'https://integration.bb-inf.net/account/workspaces/';
const $d04ca0512f38b65f$export$7b0f8fec4b919ab3 = 'https://rovodevagents-beta.atlassian.net/wiki/external/ZjBjMmQ3YmQzOThhNDY1MGEzZjRiMjM1NzA5YmNkZTU';
const $d04ca0512f38b65f$export$da4fecf2d95db63b = 'https://rovodevagents-beta.atlassian.net/wiki/external/NzJlM2JlYjRmZTc1NGQ1NTk5NjUwNDFkYmE3NTZiODY';
const $d04ca0512f38b65f$export$8ad022a16b75d1b8 = 'https://rovodevagents-beta.atlassian.net/wiki/external/OWY5NjhmMDIyNjgzNDkxY2IyNjk4OTViOGIzZjM4ZDc';
const $d04ca0512f38b65f$export$627321b82c429923 = 'https://admin.atlassian.com';
const $d04ca0512f38b65f$export$944e1ecf8da9f253 = 'https://admin.stg.atlassian.com';
const $d04ca0512f38b65f$export$d76ba9bdae389e5f = '/plugins/servlet/ac/com.github.integration.production/gh-addon-admin?s=com.github.integration.production__gh-addon-admin';
const $d04ca0512f38b65f$export$deed3f587f71617d = '/plugins/servlet/ac/com.github.integration.staging/gh-addon-admin?s=com.github.integration.staging__gh-addon-admin';
const $d04ca0512f38b65f$export$67efc9ea144c1797 = 'https://rovodevagents-beta.atlassian.net/wiki/external/ZTk0Y2QzMmFmMDVlNDNjNzlkYjg5YjUyOWJhOTIyZTQ';
const $d04ca0512f38b65f$export$b48ea3f417d3c529 = 'https://rovodevagents-beta.atlassian.net/wiki/external/NTgwMGQ3Yzg1ZThjNDQ5ZDhmZWYyNWVjN2ZjODExNmM';
const $d04ca0512f38b65f$export$f646aec6c096a2df = 'https://rovodevagents.atlassian.net/servicedesk/customer/portal/1';
const $d04ca0512f38b65f$export$ac00119995b0b385 = 'https://rovodevagents-beta.atlassian.net/wiki/external/Yzc2NzI4MTk3YTBhNDdiYjkzZDhhZTc3MjE0ZmE4Y2Q';
const $d04ca0512f38b65f$export$e649e098739c9373 = 'https://developer.atlassian.com/cloud/acli/guides/introduction/';
const $d04ca0512f38b65f$export$1c9f60393772813c = 'https://developer.atlassian.com/cloud/acli/guides/install-macos/';
const $d04ca0512f38b65f$export$2a1789535495a20f = 'https://developer.atlassian.com/cloud/acli/guides/install-linux/';
const $d04ca0512f38b65f$export$ce06234640630149 = 'https://developer.atlassian.com/cloud/acli/guides/install-windows/';
const $d04ca0512f38b65f$export$b09aacae36ab3e40 = 'https://id.atlassian.com/manage-profile/security/api-tokens?autofillToken&expiryDays=max&appId=rovodev&selectedScopes=all';
const $d04ca0512f38b65f$export$a1a25ea7e8cadc2d = 'https://docs.gitlab.com/user/profile/service_accounts/#view-and-manage-personal-access-tokens-for-a-service-account';
const $d04ca0512f38b65f$export$9618fd45245eb4f8 = 'https://confluence.atlassian.com/bitbucketserver0717/personal-access-tokens-1087535496.html';
const $d04ca0512f38b65f$export$f9acf0c992fe35dd = 'https://rovodevagents-beta.atlassian.net/wiki/external/ZDQxM2VhODI2MjJkNDI3M2IwMjgyNzNjZWIwYjJhYTM';
const $d04ca0512f38b65f$export$9ecb6abe4ea16180 = 'https://support.atlassian.com/rovo/docs/activate-code-reviews-in-your-repository/';
const $d04ca0512f38b65f$export$1e337b71a8d31bdb = 'https://support.atlassian.com/rovo/docs/add-rovo-dev-standard-to-your-site/#Add-users-to-Rovo-Dev-Standard-user-group';
const $d04ca0512f38b65f$export$e675e30c4fe7d7ee = 'https://id.atlassian.com/join/user-access';
const $d04ca0512f38b65f$export$bf922ad4ddf27877 = 'https://www.atlassian.com/try/cloud/signup?bundle=devai';
const $d04ca0512f38b65f$export$aebb1d8c96ca4155 = 'https://support.atlassian.com/rovo/docs/view-your-rovo-dev-credit-usage';
const $d04ca0512f38b65f$export$74fcb76fee6ef501 = 'https://www.youtube.com/watch?v=OTgOulR4IZ0&list=PLaD4FvsFdarQj5c0ou9qrKMD5S302V9D0';
const $d04ca0512f38b65f$export$dc73cf828f0535f0 = 'https://marketplace.visualstudio.com/items?itemName=Atlassian.atlascode&ssr=false#overview';
const $d04ca0512f38b65f$export$2778c55dc303378d = 'https://rovodevagents.atlassian.net/servicedesk/customer/portal/1/group/1/create/144';
const $d04ca0512f38b65f$export$2bdc5fc9e68cdcfc = 'https://marketplace.atlassian.com/apps/1219592/github-for-atlassian?hosting=cloud&tab=overview';
const $d04ca0512f38b65f$export$2ceee16a2362752e = 'https://marketplace-admin.stg.internal.atlassian.com/apps/1243270/github-for-jira-staging?hosting=cloud&tab=overview';
const $d04ca0512f38b65f$export$ac429f3c31036757 = 'https://github.atlassian.com';
const $d04ca0512f38b65f$export$5ec8e5066ac5206 = 'https://github.stg.atlassian.com';
const $d04ca0512f38b65f$export$d6e3a57abf901396 = 'https://www.atlassian.com/software/rovo-dev';
const $d04ca0512f38b65f$export$d451e269e1a96fbe = 'https://support.atlassian.com/rovo/docs/work-with-rovo-dev-in-the-ide/';
const $d04ca0512f38b65f$export$337a20bdfe649c93 = 'c364f950-69f5-4812-9716-ed71a8d3d408_a57ca83d-597f-4de9-8dca-f9d3cd18d3a7';
const $d04ca0512f38b65f$export$2a4fc02f01572bb6 = '9bb160f8-1abb-4dc8-9780-ca5327e7ccc8_91300e36-3710-4f7b-aba2-95f43be1ac6f';
const $d04ca0512f38b65f$export$24419c25abfdbd09 = 'https://id.atlassian.com/manage-profile/apps';
const $d04ca0512f38b65f$export$123dfdbe28086b37 = 'https://id.stg.internal.atlassian.com/manage-profile/apps';

});

parcelRegister("bOKPN", function(module, exports) {
$parcel$export(module.exports, "AggRelayEnvironmentProvider", () => $b1aeb59908e24f51$export$97ade3d027654b2);

var $6Fero = parcelRequire("6Fero");

var $layCf = parcelRequire("layCf");
parcelRequire("j5h4D");
var $h7lQ2 = parcelRequire("h7lQ2");

var $1v5pe = parcelRequire("1v5pe");

var $jEbac = parcelRequire("jEbac");

var $kIqwl = parcelRequire("kIqwl");
const $b1aeb59908e24f51$var$PRODUCT_NAME = 'Rovo Dev';
const $b1aeb59908e24f51$var$SERVICE_NAME = 'dev-agents';
const $b1aeb59908e24f51$var$TEAM_NAME = 'Jolt';
function $b1aeb59908e24f51$var$validateResponse(request, response) {
    const errors = 'errors' in response ? response.errors : undefined;
    if (errors != null) // @ts-expect-error errors path is string or number, platform captureErrors expects string only
    (0, $layCf.captureErrors)(errors, {
        operationName: request.name
    });
    return true;
}
const $b1aeb59908e24f51$var$preInitAggRelayEnvironment = (0, $6Fero.createRelayEnvironment)({
    networkOptions: {
        isServer: false,
        getHeaders: ()=>({
                'atl-client-name': $b1aeb59908e24f51$var$SERVICE_NAME
            }),
        validateResponse: $b1aeb59908e24f51$var$validateResponse
    }
});
const $b1aeb59908e24f51$var$initializedAggRelayEnvironments = new Map();
/**
 * atl-attribution header standard defined by AGG platform
 * https://hello.atlassian.net/wiki/spaces/AGG/blog/2025/10/30/6024467212/Blocking+requests+in+AGG+Staging+for+missing+metrics+attribution+headers
 */ const $b1aeb59908e24f51$var$getAtlAttributionHeader = (workspaceAri, tenantAriOrCloudId)=>{
    return {
        'atl-attribution': JSON.stringify({
            atlWorkspaceId: workspaceAri,
            tenantId: tenantAriOrCloudId,
            product: $b1aeb59908e24f51$var$PRODUCT_NAME,
            service: $b1aeb59908e24f51$var$SERVICE_NAME,
            team: $b1aeb59908e24f51$var$TEAM_NAME
        })
    };
};
function $b1aeb59908e24f51$var$initializeAggRelayEnvironment(workspaceAri, tenantAriOrCloudId) {
    return (0, $6Fero.createRelayEnvironment)({
        networkOptions: {
            isServer: false,
            getHeaders: ()=>({
                    'atl-client-name': $b1aeb59908e24f51$var$SERVICE_NAME,
                    ...$b1aeb59908e24f51$var$getAtlAttributionHeader(workspaceAri, tenantAriOrCloudId)
                }),
            validateResponse: $b1aeb59908e24f51$var$validateResponse
        }
    });
}
function $b1aeb59908e24f51$export$7b46ba5306c5ad22(workspaceAri, tenantAriOrCloudId) {
    // Reuse the environment so route content and sidebar content update the same Relay store.
    const cacheKey = JSON.stringify({
        workspaceAri: workspaceAri,
        tenantAriOrCloudId: tenantAriOrCloudId
    });
    const cachedEnvironment = $b1aeb59908e24f51$var$initializedAggRelayEnvironments.get(cacheKey);
    if (cachedEnvironment) return cachedEnvironment;
    const environment = $b1aeb59908e24f51$var$initializeAggRelayEnvironment(workspaceAri, tenantAriOrCloudId);
    $b1aeb59908e24f51$var$initializedAggRelayEnvironments.set(cacheKey, environment);
    return environment;
}
const $b1aeb59908e24f51$export$97ade3d027654b2 = ({ children: children })=>{
    const workspaceAri = (0, $h7lQ2.useWorkspaceAri)();
    const { tenantContexts: tenantContexts } = (0, $h7lQ2.useTenantData)();
    const { cloudId: cloudId } = tenantContexts?.[0] || {};
    const aggRelayEnvironment = (0, $1v5pe.useMemo)(()=>{
        if (workspaceAri && cloudId) return $b1aeb59908e24f51$export$7b46ba5306c5ad22(workspaceAri, cloudId);
        return $b1aeb59908e24f51$var$preInitAggRelayEnvironment;
    }, [
        workspaceAri,
        cloudId
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $jEbac.RelayEnvironmentProvider), {
        environment: aggRelayEnvironment,
        children: children
    });
};

});

parcelRegister("jZIPe", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("jPGtX"),
    $7mhPs("kFEjP")
]).then(()=>parcelRequire('hm8El'));

});

parcelRegister("aQPoi", function(module, exports) {
$parcel$export(module.exports, "useJiraAdminPermissions", () => $e2fdf4112cacf04f$export$22d3466ff9c1c804);

var $1v5pe = parcelRequire("1v5pe");
parcelRequire("6tkuB");
var $6T1YA = parcelRequire("6T1YA");
const $e2fdf4112cacf04f$var$URL = '/gateway/api/adminhub/um/user/my/permissions';
const $e2fdf4112cacf04f$export$22d3466ff9c1c804 = ()=>{
    const [error, setError] = (0, $1v5pe.useState)(null);
    const [loading, setLoading] = (0, $1v5pe.useState)(false);
    const [permissions, setPermissions] = (0, $1v5pe.useState)([]);
    const getJiraAdminPermissions = (0, $1v5pe.useCallback)(async (cloudId)=>{
        setLoading(true);
        setError(null);
        const resourceAri = `ari:cloud:jira::site/${cloudId}`;
        try {
            const response = await fetch((0, $6T1YA.default)(`${$e2fdf4112cacf04f$var$URL}?resourceAri=${resourceAri}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            }));
            if (!response.ok) throw new Error(`Error: ${response.statusText}`);
            const data = await response.json();
            if (data[resourceAri]) setPermissions(data[resourceAri]);
            else setError('An error has occurred');
        } catch (e) {
            setError('An error has occurred');
        }
        setLoading(false);
    }, []);
    return {
        getJiraAdminPermissions: getJiraAdminPermissions,
        permissions: permissions,
        loading: loading,
        error: error
    };
};

});
parcelRegister("6tkuB", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("6T1YA")).default);
/**
 * Re-export the shared authenticated fetch helper from @dev-agents/fetch.
 *
 * This file exists to maintain backward-compatible import paths for existing
 * app consumers (e.g. `import authRequest from '../utils/fetch'`).
 */ parcelRequire("e7lmd");
var $6T1YA = parcelRequire("6T1YA");

});
parcelRegister("e7lmd", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("6T1YA")).default);
$parcel$export(module.exports, "authRequest", () => (parcelRequire("6T1YA")).default);
$parcel$export(module.exports, "getRequestHeaders", () => (parcelRequire("6T1YA")).getRequestHeaders);
/**
 * @dev-agents/fetch — Shared authenticated same-origin REST fetch helpers.
 *
 * Provides CSRF-protected request construction for Dev Agents REST calls.
 * All same-domain requests automatically include the `X-CSRFToken` header
 * (read from the `csrftoken` cookie) and use `credentials: 'same-origin'`.
 *
 * @example
 * ```ts
 * import authRequest from '@dev-agents/fetch';
 *
 * const response = await fetch(authRequest('/api/endpoint'));
 * ```
 *
 * @example
 * ```ts
 * import { getRequestHeaders } from '@dev-agents/fetch';
 *
 * // For streaming or custom fetch calls where you need headers only:
 * const response = await fetch(url, {
 *   method: 'POST',
 *   credentials: 'same-origin',
 *   headers: { ...getRequestHeaders(url), 'Content-Type': 'application/json' },
 *   body: JSON.stringify(payload),
 * });
 * ```
 */ 
var $cOLHI = parcelRequire("cOLHI");

var $6T1YA = parcelRequire("6T1YA");

});
parcelRegister("cOLHI", function(module, exports) {
$parcel$export(module.exports, "CSRF_COOKIE_NAME", () => $60a53b248f47c550$export$f39f459ffe3b5b2);
$parcel$export(module.exports, "CSRF_HEADER_NAME", () => $60a53b248f47c550$export$7f697e417cb7a5a8);
/**
 * Name of the cookie that stores the CSRF token.
 *
 * The token is set by the server as a same-origin cookie and must be echoed
 * back in a request header so the server can verify that the request
 * originated from a page it served (preventing cross-site request forgery).
 */ const $60a53b248f47c550$export$f39f459ffe3b5b2 = 'csrftoken';
const $60a53b248f47c550$export$7f697e417cb7a5a8 = 'X-CSRFToken';

});

parcelRegister("6T1YA", function(module, exports) {
$parcel$export(module.exports, "getRequestHeaders", () => $7c9caefca086bce4$export$1e4d4724de7b199e);
$parcel$export(module.exports, "default", () => $7c9caefca086bce4$export$2e2bcd8739ae039);

var $dbJ6U = parcelRequire("dbJ6U");

var $cOLHI = parcelRequire("cOLHI");
const $7c9caefca086bce4$export$81350727a0ff4e2e = (url)=>/^(?!https?:)/.test(url) || url.indexOf(window.location.origin) === 0;
const $7c9caefca086bce4$export$1e4d4724de7b199e = (url, csrftoken = (0, $dbJ6U.getCookie)((0, $cOLHI.CSRF_COOKIE_NAME)) || '')=>{
    const headers = {};
    // Never send tokens cross-(sub)domain
    if ($7c9caefca086bce4$export$81350727a0ff4e2e(url)) headers[0, $cOLHI.CSRF_HEADER_NAME] = csrftoken;
    return headers;
};
function $7c9caefca086bce4$export$2e2bcd8739ae039(url, options = {}, csrftoken = (0, $dbJ6U.getCookie)((0, $cOLHI.CSRF_COOKIE_NAME)) || '') {
    const headers = $7c9caefca086bce4$export$1e4d4724de7b199e(url, csrftoken);
    return new Request(url, {
        credentials: 'same-origin',
        ...options,
        headers: {
            ...headers,
            ...options.headers || {}
        }
    });
}

});




parcelRegister("3IGBn", function(module, exports) {
$parcel$export(module.exports, "GithubOauthRedirectPage", () => $626ee942307727a8$export$8451ca8a54a00a5e);

var $gQyTH = parcelRequire("gQyTH");

var $ayBRL = parcelRequire("ayBRL");

var $cYe7u = parcelRequire("cYe7u");

var $aCcGw = parcelRequire("aCcGw");

var $fRfXo = parcelRequire("fRfXo");

var $bQOrV = parcelRequire("bQOrV");
parcelRequire("fjjed");
var $aXHSI = parcelRequire("aXHSI");

var $1v5pe = parcelRequire("1v5pe");

var $kK7WO = parcelRequire("kK7WO");

var $735hs = parcelRequire("735hs");

var $6WxQp = parcelRequire("6WxQp");

var $1sNTn = parcelRequire("1sNTn");

var $kIqwl = parcelRequire("kIqwl");
const $626ee942307727a8$var$SuccessMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $kK7WO.default)();
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $kIqwl.Fragment), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cYe7u.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($735hs))),
                alt: ""
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $ayBRL.default), {
                size: "xxlarge",
                children: formatMessage((0, $1sNTn.default).authenticationSuccessful)
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $fRfXo.Text), {
                as: "p",
                children: formatMessage((0, $1sNTn.default).allDoneDescription)
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $fRfXo.Text), {
                as: "p",
                children: formatMessage((0, $1sNTn.default).resubmitPullRequestInstructions)
            })
        ]
    });
};
const $626ee942307727a8$var$ErrorMessage = ({ errorDescription: errorDescription })=>{
    const { formatMessage: formatMessage } = (0, $kK7WO.default)();
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $kIqwl.Fragment), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $6WxQp.WarningIcon), {
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $ayBRL.default), {
                size: "xxlarge",
                children: formatMessage((0, $1sNTn.default).authenticationFailed)
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $fRfXo.Text), {
                as: "p",
                children: formatMessage((0, $1sNTn.default).authenticationErrorDescription)
            }),
            errorDescription && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $fRfXo.Text), {
                as: "p",
                children: errorDescription
            })
        ]
    });
};
const $626ee942307727a8$export$8451ca8a54a00a5e = ()=>{
    const { formatMessage: formatMessage } = (0, $kK7WO.default)();
    const { fireScreenEvent: fireScreenEvent } = (0, $aXHSI.useRovoDevWebAnalyticsClient)();
    const hasFiredScreenEvent = (0, $1v5pe.useRef)(false);
    const urlParams = new URLSearchParams(window.location.search);
    const hasErrorParam = urlParams.has('errorDescription');
    const errorDescription = urlParams.get('errorDescription');
    (0, $1v5pe.useEffect)(()=>{
        if (!hasFiredScreenEvent.current) {
            fireScreenEvent({
                name: 'githubOauthRedirectPage',
                attributes: {
                    isSuccess: !hasErrorParam,
                    errorDescription: errorDescription || ''
                }
            });
            hasFiredScreenEvent.current = true;
        }
    }, [
        hasErrorParam,
        errorDescription,
        fireScreenEvent
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $aCcGw.Flex), {
        direction: "column",
        gap: "space.200",
        justifyContent: "center",
        alignItems: "center",
        xcss: $626ee942307727a8$var$wrapperStyles,
        children: [
            hasErrorParam ? /*#__PURE__*/ (0, $kIqwl.jsx)($626ee942307727a8$var$ErrorMessage, {
                errorDescription: errorDescription
            }) : /*#__PURE__*/ (0, $kIqwl.jsx)($626ee942307727a8$var$SuccessMessage, {}),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $gQyTH.default), {
                href: "https://github.com",
                appearance: "primary",
                children: formatMessage((0, $1sNTn.default).backToGitHubButton)
            })
        ]
    });
};
const $626ee942307727a8$var$wrapperStyles = (0, $bQOrV.xcss)({
    height: 'calc(100vh - 48px)'
});

});
parcelRegister("gQyTH", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b19770410a1bc1c$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v3.0.2 */ /* link.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $ky45w = parcelRequire("ky45w");

var $fl4ll = parcelRequire("fl4ll");

var $Ms2ib = parcelRequire("Ms2ib");

var $hK1py = parcelRequire("hK1py");

var $1TZ74 = parcelRequire("1TZ74");

var $lreqQ = parcelRequire("lreqQ");

var $kIqwl = parcelRequire("kIqwl");
const $8b19770410a1bc1c$var$_98 = "._1di615s3:active{background-color:var(--ds-background-selected,#e9f2fe)}";
const $8b19770410a1bc1c$var$_97 = "._irr315s3:hover{background-color:var(--ds-background-selected,#e9f2fe)}";
const $8b19770410a1bc1c$var$_96 = "._9h8h6x5g:active{color:var(--ds-text-selected,#1868db)}";
const $8b19770410a1bc1c$var$_95 = "._30l36x5g:hover{color:var(--ds-text-selected,#1868db)}";
const $8b19770410a1bc1c$var$_94 = "._f8pj6x5g:focus{color:var(--ds-text-selected,#1868db)}";
const $8b19770410a1bc1c$var$_93 = "._10536x5g:visited{color:var(--ds-text-selected,#1868db)}";
const $8b19770410a1bc1c$var$_92 = "._8l3mq98m:after{border-color:var(--ds-border-selected,#1868db)}";
const $8b19770410a1bc1c$var$_91 = "._syaz6x5g{color:var(--ds-text-selected,#1868db)}";
const $8b19770410a1bc1c$var$_90 = "._bfhk15s3{background-color:var(--ds-background-selected,#e9f2fe)}";
const $8b19770410a1bc1c$var$_89 = "._f8pj1mjl:focus{color:color.text.subtle}";
const $8b19770410a1bc1c$var$_88 = "._1di61f1m:active{background-color:var(--ds-background-discovery-bold-pressed,#673286)}";
const $8b19770410a1bc1c$var$_87 = "._irr3fqeg:hover{background-color:var(--ds-background-discovery-bold-hovered,#803fa5)}";
const $8b19770410a1bc1c$var$_86 = "._bfhku5tj{background-color:var(--ds-background-discovery-bold,#964ac0)}";
const $8b19770410a1bc1c$var$_85 = "._1di613a9:active{background-color:var(--ds-background-danger-bold-pressed,#872821)}";
const $8b19770410a1bc1c$var$_84 = "._irr3s9hg:hover{background-color:var(--ds-background-danger-bold-hovered,#ae2e24)}";
const $8b19770410a1bc1c$var$_83 = "._bfhkybec{background-color:var(--ds-background-danger-bold,#c9372c)}";
const $8b19770410a1bc1c$var$_82 = "._1di64m4m:active{background-color:var(--ds-background-warning-bold-pressed,#f68909)}";
const $8b19770410a1bc1c$var$_81 = "._9h8h1yd3:active{color:var(--ds-text-warning-inverse,#292a2e)}";
const $8b19770410a1bc1c$var$_80 = "._irr31spp:hover{background-color:var(--ds-background-warning-bold-hovered,#fca700)}";
const $8b19770410a1bc1c$var$_79 = "._30l31yd3:hover{color:var(--ds-text-warning-inverse,#292a2e)}";
const $8b19770410a1bc1c$var$_78 = "._f8pj1yd3:focus{color:var(--ds-text-warning-inverse,#292a2e)}";
const $8b19770410a1bc1c$var$_77 = "._10531yd3:visited{color:var(--ds-text-warning-inverse,#292a2e)}";
const $8b19770410a1bc1c$var$_76 = "._syaz1yd3{color:var(--ds-text-warning-inverse,#292a2e)}";
const $8b19770410a1bc1c$var$_75 = "._bfhk1kmu{background-color:var(--ds-background-warning-bold,#fbc828)}";
const $8b19770410a1bc1c$var$_74 = "._1di61kru:active{background-color:var(--ds-rovo-background-brand-bold-pressed,#292a2e)}";
const $8b19770410a1bc1c$var$_73 = "._irr31afz:hover{background-color:var(--ds-rovo-background-brand-bold-hovered,#1e1f21)}";
const $8b19770410a1bc1c$var$_72 = "._bfhklqh9{background-color:var(--ds-rovo-background-brand-bold,#000)}";
const $8b19770410a1bc1c$var$_71 = "._1di6g6ey:active{background-color:var(--ds-background-brand-bold-pressed,#144794)}";
const $8b19770410a1bc1c$var$_70 = "._9h8h15cr:active{color:var(--ds-text-inverse,#fff)}";
const $8b19770410a1bc1c$var$_69 = "._irr3hf2y:hover{background-color:var(--ds-background-brand-bold-hovered,#1558bc)}";
const $8b19770410a1bc1c$var$_68 = "._30l315cr:hover{color:var(--ds-text-inverse,#fff)}";
const $8b19770410a1bc1c$var$_67 = "._f8pj15cr:focus{color:var(--ds-text-inverse,#fff)}";
const $8b19770410a1bc1c$var$_66 = "._105315cr:visited{color:var(--ds-text-inverse,#fff)}";
const $8b19770410a1bc1c$var$_65 = "._syaz15cr{color:var(--ds-text-inverse,#fff)}";
const $8b19770410a1bc1c$var$_64 = "._bfhk1856{background-color:var(--ds-background-brand-bold,#1868db)}";
const $8b19770410a1bc1c$var$_63 = "._9h8hazsu:active{color:var(--ds-text-subtle,#505258)}";
const $8b19770410a1bc1c$var$_62 = "._1di6fcek:active{background-color:var(--ds-background-neutral-subtle-pressed,#0b120e24)}";
const $8b19770410a1bc1c$var$_61 = "._30l3azsu:hover{color:var(--ds-text-subtle,#505258)}";
const $8b19770410a1bc1c$var$_60 = "._irr31dpa:hover{background-color:var(--ds-background-neutral-subtle-hovered,#0515240f)}";
const $8b19770410a1bc1c$var$_59 = "._f8pjazsu:focus{color:var(--ds-text-subtle,#505258)}";
const $8b19770410a1bc1c$var$_58 = "._1053azsu:visited{color:var(--ds-text-subtle,#505258)}";
const $8b19770410a1bc1c$var$_57 = "._aetrb3bt:after{content:\"\"}";
const $8b19770410a1bc1c$var$_56 = "._8l3m1l7x:after{border-color:var(--ds-border,#0b120e24)}";
const $8b19770410a1bc1c$var$_55 = "._syazazsu{color:var(--ds-text-subtle,#505258)}";
const $8b19770410a1bc1c$var$_54 = "._bfhksm61{background-color:var(--ds-background-neutral-subtle,#00000000)}";
const $8b19770410a1bc1c$var$_53 = "._1bsb1osq{width:100%}";
const $8b19770410a1bc1c$var$_52 = "._gy1p12x7{-moz-column-gap:var(--ds-space-075,6px);column-gap:var(--ds-space-075,6px)}";
const $8b19770410a1bc1c$var$_51 = "._4t3i1k8s{height:1.5rem}";
const $8b19770410a1bc1c$var$_50 = "._1rjcv77o{padding-block:var(--ds-space-025,2px)}";
const $8b19770410a1bc1c$var$_49 = "._9h8h1gmx:active{color:var(--ds-text-disabled,#080f214a)}";
const $8b19770410a1bc1c$var$_48 = "._1di6187o:active{background-color:var(--ds-background-disabled,#0515240f)}";
const $8b19770410a1bc1c$var$_47 = "._30l31gmx:hover{color:var(--ds-text-disabled,#080f214a)}";
const $8b19770410a1bc1c$var$_46 = "._irr3187o:hover{background-color:var(--ds-background-disabled,#0515240f)}";
const $8b19770410a1bc1c$var$_45 = "._f8pj1gmx:focus{color:var(--ds-text-disabled,#080f214a)}";
const $8b19770410a1bc1c$var$_44 = "._jomr187o:focus{background-color:var(--ds-background-disabled,#0515240f)}";
const $8b19770410a1bc1c$var$_43 = "._10531gmx:visited{color:var(--ds-text-disabled,#080f214a)}";
const $8b19770410a1bc1c$var$_42 = "._aetrglyw:after{content:none}";
const $8b19770410a1bc1c$var$_41 = "._syaz1gmx{color:var(--ds-text-disabled,#080f214a)}";
const $8b19770410a1bc1c$var$_40 = "._bfhk187o{background-color:var(--ds-background-disabled,#0515240f)}";
const $8b19770410a1bc1c$var$_39 = "._80om13gf{cursor:not-allowed}";
const $8b19770410a1bc1c$var$_38 = "._1iohnqa1:active{text-decoration-style:solid}";
const $8b19770410a1bc1c$var$_37 = "._c2waglyw:active{text-decoration-line:none}";
const $8b19770410a1bc1c$var$_36 = "._1nrm1r31:active{text-decoration-color:currentColor}";
const $8b19770410a1bc1c$var$_35 = "._jf4cnqa1:hover{text-decoration-style:solid}";
const $8b19770410a1bc1c$var$_34 = "._1bnxglyw:hover{text-decoration-line:none}";
const $8b19770410a1bc1c$var$_33 = "._9oik1r31:hover{text-decoration-color:currentColor}";
const $8b19770410a1bc1c$var$_32 = "._5goinqa1:focus{text-decoration-style:solid}";
const $8b19770410a1bc1c$var$_31 = "._4fprglyw:focus{text-decoration-line:none}";
const $8b19770410a1bc1c$var$_30 = "._1a3b1r31:focus{text-decoration-color:currentColor}";
const $8b19770410a1bc1c$var$_29 = "._ajmmvv82{text-decoration-style:solid!important}";
const $8b19770410a1bc1c$var$_28 = "._1hmsagmp{text-decoration-line:none!important}";
const $8b19770410a1bc1c$var$_27 = "._4bfu1snc{text-decoration-color:currentColor!important}";
const $8b19770410a1bc1c$var$_26 = "._1ggl5xtf:active{transition:var(--ds-button-pressed,background-color border-color .15s cubic-bezier(.4,1,.6,1))}";
const $8b19770410a1bc1c$var$_25 = "._v564k6bl{transition:var(--ds-button-hovered,background-color border-color .15s cubic-bezier(.4,1,.6,1))}";
const $8b19770410a1bc1c$var$_24 = "._18postnw:after{position:absolute}";
const $8b19770410a1bc1c$var$_23 = "._11fnglyw:after{pointer-events:none}";
const $8b19770410a1bc1c$var$_22 = "._39yqe4h9:after{border-width:var(--ds-border-width,1px)}";
const $8b19770410a1bc1c$var$_21 = "._1tv3nqa1:after{border-style:solid}";
const $8b19770410a1bc1c$var$_20 = "._9v7aze3t:after{inset:var(--ds-space-0,0)}";
const $8b19770410a1bc1c$var$_19 = "._14mj1kw7:after{border-radius:inherit}";
const $8b19770410a1bc1c$var$_18 = "._s7n4nkob{vertical-align:middle}";
const $8b19770410a1bc1c$var$_17 = "._y3gn1h6o{text-align:center}";
const $8b19770410a1bc1c$var$_16 = "._bozgutpp{padding-inline-start:var(--ds-space-150,9pt)}";
const $8b19770410a1bc1c$var$_15 = "._y4tiutpp{padding-inline-end:var(--ds-space-150,9pt)}";
const $8b19770410a1bc1c$var$_14 = "._k48p1wq8{font-weight:var(--ds-font-weight-medium,500)}";
const $8b19770410a1bc1c$var$_13 = "._4t3iviql{height:2rem}";
const $8b19770410a1bc1c$var$_12 = "._1o9zidpf{flex-shrink:0}";
const $8b19770410a1bc1c$var$_11 = "._gy1p1b66{-moz-column-gap:var(--ds-space-050,4px);column-gap:var(--ds-space-050,4px)}";
const $8b19770410a1bc1c$var$_10 = "._1bah1h6o{justify-content:center}";
const $8b19770410a1bc1c$var$_1 = "._4cvr1q9y{align-items:baseline}";
const $8b19770410a1bc1c$var$_0 = "._kqswh2mm{position:relative}";
const $8b19770410a1bc1c$var$_9 = "._p12f1osq{max-width:100%}";
const $8b19770410a1bc1c$var$_8 = "._1bsb1wug{width:auto}";
const $8b19770410a1bc1c$var$_7 = "._vchhusvi{box-sizing:border-box}";
const $8b19770410a1bc1c$var$_6 = "._1e0c116y{display:inline-flex}";
const $8b19770410a1bc1c$var$_5 = "._1rjc12x7{padding-block:var(--ds-space-075,6px)}";
const $8b19770410a1bc1c$var$_4 = "._189eidpf{border-width:0}";
const $8b19770410a1bc1c$var$_3 = "._v5649dqc{transition:background .1s ease-out}";
const $8b19770410a1bc1c$var$_2 = "._11c8fhey{font:var(--ds-font-body,normal 400 14px/20px \"Atlassian Sans\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const $8b19770410a1bc1c$var$_ = "._2rko1qi0{border-radius:var(--ds-radius-medium,6px)}";
const $8b19770410a1bc1c$var$styles = {
    base: "_2rko1qi0 _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    interactiveMotion: "_v564k6bl _1ggl5xtf",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhk187o _syaz1gmx _aetrglyw _10531gmx _jomr187o _f8pj1gmx _irr3187o _30l31gmx _1di6187o _9h8h1gmx",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    fullWidth: "_1bsb1osq"
};
const $8b19770410a1bc1c$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $8b19770410a1bc1c$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $8b19770410a1bc1c$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _f8pj15cr _irr31afz _1di61kru"
};
const $8b19770410a1bc1c$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
const $8b19770410a1bc1c$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
const $8b19770410a1bc1c$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $8b19770410a1bc1c$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pj1mjl _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $8b19770410a1bc1c$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
}; /**
    * __Link Button__
    *
    * Renders a link in the style of a button.
    *
    * - [Examples](https://atlassian.design/components/link-button/examples)
    * - [Code](https://atlassian.design/components/link-button/code)
    * - [Usage](https://atlassian.design/components/link-button/usage)
    */ 
const $8b19770410a1bc1c$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance = 'default', 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus = false, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const hasIconAfter = Boolean(iconAfter);
    const hasIconBefore = Boolean(iconBefore);
    const localRef = (0, $1v5pe.useRef)(null);
    (0, $Ms2ib.default)(localRef, autoFocus);
    const combinedRef = (0, $fl4ll.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $8b19770410a1bc1c$var$_,
                    $8b19770410a1bc1c$var$_2,
                    $8b19770410a1bc1c$var$_3,
                    $8b19770410a1bc1c$var$_4,
                    $8b19770410a1bc1c$var$_5,
                    $8b19770410a1bc1c$var$_6,
                    $8b19770410a1bc1c$var$_7,
                    $8b19770410a1bc1c$var$_8,
                    $8b19770410a1bc1c$var$_9,
                    $8b19770410a1bc1c$var$_0,
                    $8b19770410a1bc1c$var$_1,
                    $8b19770410a1bc1c$var$_10,
                    $8b19770410a1bc1c$var$_11,
                    $8b19770410a1bc1c$var$_12,
                    $8b19770410a1bc1c$var$_13,
                    $8b19770410a1bc1c$var$_14,
                    $8b19770410a1bc1c$var$_15,
                    $8b19770410a1bc1c$var$_16,
                    $8b19770410a1bc1c$var$_17,
                    $8b19770410a1bc1c$var$_18,
                    $8b19770410a1bc1c$var$_19,
                    $8b19770410a1bc1c$var$_20,
                    $8b19770410a1bc1c$var$_21,
                    $8b19770410a1bc1c$var$_22,
                    $8b19770410a1bc1c$var$_23,
                    $8b19770410a1bc1c$var$_24,
                    $8b19770410a1bc1c$var$_25,
                    $8b19770410a1bc1c$var$_26,
                    $8b19770410a1bc1c$var$_27,
                    $8b19770410a1bc1c$var$_28,
                    $8b19770410a1bc1c$var$_29,
                    $8b19770410a1bc1c$var$_30,
                    $8b19770410a1bc1c$var$_31,
                    $8b19770410a1bc1c$var$_32,
                    $8b19770410a1bc1c$var$_33,
                    $8b19770410a1bc1c$var$_34,
                    $8b19770410a1bc1c$var$_35,
                    $8b19770410a1bc1c$var$_36,
                    $8b19770410a1bc1c$var$_37,
                    $8b19770410a1bc1c$var$_38,
                    $8b19770410a1bc1c$var$_39,
                    $8b19770410a1bc1c$var$_40,
                    $8b19770410a1bc1c$var$_41,
                    $8b19770410a1bc1c$var$_42,
                    $8b19770410a1bc1c$var$_43,
                    $8b19770410a1bc1c$var$_44,
                    $8b19770410a1bc1c$var$_45,
                    $8b19770410a1bc1c$var$_46,
                    $8b19770410a1bc1c$var$_47,
                    $8b19770410a1bc1c$var$_48,
                    $8b19770410a1bc1c$var$_49,
                    $8b19770410a1bc1c$var$_50,
                    $8b19770410a1bc1c$var$_51,
                    $8b19770410a1bc1c$var$_52,
                    $8b19770410a1bc1c$var$_53,
                    $8b19770410a1bc1c$var$_54,
                    $8b19770410a1bc1c$var$_55,
                    $8b19770410a1bc1c$var$_56,
                    $8b19770410a1bc1c$var$_57,
                    $8b19770410a1bc1c$var$_58,
                    $8b19770410a1bc1c$var$_59,
                    $8b19770410a1bc1c$var$_60,
                    $8b19770410a1bc1c$var$_61,
                    $8b19770410a1bc1c$var$_62,
                    $8b19770410a1bc1c$var$_63,
                    $8b19770410a1bc1c$var$_64,
                    $8b19770410a1bc1c$var$_65,
                    $8b19770410a1bc1c$var$_66,
                    $8b19770410a1bc1c$var$_67,
                    $8b19770410a1bc1c$var$_68,
                    $8b19770410a1bc1c$var$_69,
                    $8b19770410a1bc1c$var$_70,
                    $8b19770410a1bc1c$var$_71,
                    $8b19770410a1bc1c$var$_72,
                    $8b19770410a1bc1c$var$_73,
                    $8b19770410a1bc1c$var$_74,
                    $8b19770410a1bc1c$var$_75,
                    $8b19770410a1bc1c$var$_76,
                    $8b19770410a1bc1c$var$_77,
                    $8b19770410a1bc1c$var$_78,
                    $8b19770410a1bc1c$var$_79,
                    $8b19770410a1bc1c$var$_80,
                    $8b19770410a1bc1c$var$_81,
                    $8b19770410a1bc1c$var$_82,
                    $8b19770410a1bc1c$var$_83,
                    $8b19770410a1bc1c$var$_84,
                    $8b19770410a1bc1c$var$_85,
                    $8b19770410a1bc1c$var$_86,
                    $8b19770410a1bc1c$var$_87,
                    $8b19770410a1bc1c$var$_88,
                    $8b19770410a1bc1c$var$_89,
                    $8b19770410a1bc1c$var$_90,
                    $8b19770410a1bc1c$var$_91,
                    $8b19770410a1bc1c$var$_92,
                    $8b19770410a1bc1c$var$_93,
                    $8b19770410a1bc1c$var$_94,
                    $8b19770410a1bc1c$var$_95,
                    $8b19770410a1bc1c$var$_96,
                    $8b19770410a1bc1c$var$_97,
                    $8b19770410a1bc1c$var$_98
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $hK1py.Anchor), {
                analyticsContext: analyticsContext,
                ref: combinedRef /**
                        * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
                        * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
                        */ ,
                href: isDisabled ? undefined : href,
                role: isDisabled ? 'link' : undefined,
                "aria-disabled": isDisabled === true ? true : undefined,
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledBy,
                onClick: onClick,
                onClickCapture: onClickCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onTouchEndCapture: onTouchEndCapture,
                onTouchStartCapture: onTouchStartCapture,
                testId: testId,
                componentName: "LinkButton",
                interactionName: interactionName // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
                ,
                ...saferRest,
                xcss: (0, $ky45w.cx)($8b19770410a1bc1c$var$styles.base, !isDisabled && $8b19770410a1bc1c$var$styles.interactiveMotion, appearance === 'default' && $8b19770410a1bc1c$var$defaultStyles.root, appearance === 'primary' && $8b19770410a1bc1c$var$primaryStyles.root, appearance === 'rovo' && $8b19770410a1bc1c$var$rovoStyles.root, appearance === 'warning' && $8b19770410a1bc1c$var$warningStyles.root, appearance === 'danger' && $8b19770410a1bc1c$var$dangerStyles.root, appearance === 'discovery' && $8b19770410a1bc1c$var$discoveryStyles.root, appearance === 'subtle' && $8b19770410a1bc1c$var$subtleStyles.root, $8b19770410a1bc1c$var$styles.linkDecorationUnset, isSelected && $8b19770410a1bc1c$var$selectedStyles.root, isSelected && appearance === 'danger' && $8b19770410a1bc1c$var$selectedStyles.danger, isSelected && appearance === 'warning' && $8b19770410a1bc1c$var$selectedStyles.warning, isSelected && appearance === 'discovery' && $8b19770410a1bc1c$var$selectedStyles.discovery, isDisabled && $8b19770410a1bc1c$var$styles.disabled, spacing === 'compact' && $8b19770410a1bc1c$var$styles.spacingCompact, hasIconBefore && $8b19770410a1bc1c$var$styles.buttonIconBefore, hasIconAfter && $8b19770410a1bc1c$var$styles.buttonIconAfter, shouldFitContainer && $8b19770410a1bc1c$var$styles.fullWidth),
                children: [
                    iconBefore && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1TZ74.default), {
                        type: "icon",
                        position: "before",
                        isLoading: false,
                        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $lreqQ.default), {
                            icon: iconBefore,
                            spacing: spacing
                        })
                    }),
                    children && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1TZ74.default), {
                        isLoading: false,
                        children: children
                    }),
                    iconAfter && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1TZ74.default), {
                        type: "icon",
                        position: "after",
                        isLoading: false,
                        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $lreqQ.default), {
                            icon: iconAfter,
                            spacing: spacing
                        })
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $8b19770410a1bc1c$var$LinkButton = /*#__PURE__*/ (0, $1v5pe.forwardRef)($8b19770410a1bc1c$var$LinkButtonBase);
$8b19770410a1bc1c$var$LinkButton.displayName = 'LinkButton';
var $8b19770410a1bc1c$export$2e2bcd8739ae039 = $8b19770410a1bc1c$var$LinkButton;

});
parcelRegister("hK1py", function(module, exports) {
$parcel$export(module.exports, "Anchor", () => $007ca811c6548823$export$b688253958b8dfe7);
/* anchor.tsx generated by @compiled/babel-plugin v3.0.2 */ /* anchor.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $hGIzV = parcelRequire("hGIzV");

var $cwFVG = parcelRequire("cwFVG");

var $j9QYE = parcelRequire("j9QYE");

var $9SOWu = parcelRequire("9SOWu");

var $aD9yk = parcelRequire("aD9yk");

var $lHxwq = parcelRequire("lHxwq");

var $7qISg = parcelRequire("7qISg");

var $kFr83 = parcelRequire("kFr83");

var $22rKq = parcelRequire("22rKq");

var $kIqwl = parcelRequire("kIqwl");
const $007ca811c6548823$var$_5 = "._kqswh2mm{position:relative}";
const $007ca811c6548823$var$_4 = "._vchhusvi{box-sizing:border-box}";
const $007ca811c6548823$var$_3 = "._ajmmnqa1{text-decoration-style:solid}";
const $007ca811c6548823$var$_2 = "._1hms8stv{text-decoration-line:underline}";
const $007ca811c6548823$var$_ = "._4bfu1r31{text-decoration-color:currentColor}";
const $007ca811c6548823$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
const $007ca811c6548823$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $007ca811c6548823$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/; /**
                                                              * __Anchor__
                                                              *
                                                              * A primitive for building custom anchor links.
                                                              *
                                                              * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
                                                              * - [Code](https://atlassian.design/components/primitives/anchor/code)
                                                              * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
                                                              */ 
const $007ca811c6548823$var$AnchorNoRef = ({ href: href, children: children, onClick: providedOnClick = (0, $aD9yk.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, newWindowLabel: newWindowLabel = '(opens new window)', ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $1v5pe.useContext)((0, $7qISg.default));
    const handleClick = (0, $1v5pe.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $lHxwq.useId)();
    const onClick = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'link'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const RouterLink = (0, $9SOWu.useRouterLink)();
    const isExternal = typeof href === 'string' && $007ca811c6548823$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $007ca811c6548823$var$IS_NON_HTTP_BASED.test(href); /**
                                                                                    * Renders a router link if:
                                                                                    *
                                                                                    * - a link component is set in the app provider
                                                                                    * - it's not an external link (starting with `http://` or `https://`)
                                                                                    * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
                                                                                    */ 
    const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $cwFVG.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $007ca811c6548823$var$_,
                    $007ca811c6548823$var$_2,
                    $007ca811c6548823$var$_3,
                    $007ca811c6548823$var$_4,
                    $007ca811c6548823$var$_5
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $22rKq.Focusable // @ts-expect-error we don't allow `a` on Focusable for makers as they should use Anchor instead
            ), {
                as: Component,
                className: xcss,
                style: style,
                ref: ref // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
                ,
                ...safeHtmlAttributes,
                href: !isRouterLink && typeof href !== 'string' ? undefined : href,
                target: target,
                onClick: onClick,
                "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel}` : ariaLabel,
                "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
                xcss: (0, $hGIzV.cx)($007ca811c6548823$var$styles.root, $007ca811c6548823$var$styles.position, xcss),
                testId: testId,
                "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
                children: [
                    children,
                    target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kFr83.default), {
                        id: opensNewWindowLabelId,
                        children: `, ${newWindowLabel}`
                    })
                ]
            })
        ]
    });
};
const $007ca811c6548823$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $1v5pe.forwardRef)($007ca811c6548823$var$AnchorNoRef);

});


parcelRegister("cYe7u", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ceac90841319523$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $2T805 = parcelRequire("2T805");
var $cdHM2 = parcelRequire("cdHM2");

var $5e3kx = parcelRequire("5e3kx");

var $j2K7l = parcelRequire("j2K7l");

var $kIqwl = parcelRequire("kIqwl");
const $4ceac90841319523$var$_2 = "._4t3i1wug{height:auto}";
const $4ceac90841319523$var$_ = "._p12f1osq{max-width:100%}";
const $4ceac90841319523$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $4ceac90841319523$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $1v5pe.useRef)(null);
    const providedColorMode = (0, $5e3kx.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $j2K7l.useThemeObserver)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $1v5pe.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $2T805.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cdHM2.default), {
                children: [
                    $4ceac90841319523$var$_,
                    $4ceac90841319523$var$_2
                ]
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)("img", {
                alt: alt,
                "data-testid": testId,
                src: src // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                ,
                className: (0, $hMvDh.default)([
                    "_p12f1osq _4t3i1wug",
                    className
                ]),
                ref: imgRef // The spread operator is necessary since the component can accept all the props of an `img` element.
                ,
                ...props
            })
        ]
    });
}

});
parcelRegister("5e3kx", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", () => $b2574bda6347a875$export$ce91654eb9fea460);

var $1v5pe = parcelRequire("1v5pe");

var $lmUZy = parcelRequire("lmUZy");
function $b2574bda6347a875$export$ce91654eb9fea460() {
    const value = (0, $1v5pe.useContext)((0, $lmUZy.ColorModeContext));
    return value;
}

});

parcelRegister("j2K7l", function(module, exports) {
$parcel$export(module.exports, "useThemeObserver", () => $daee67072644a367$export$3dd7971102e44fa8);

var $1v5pe = parcelRequire("1v5pe");

var $cgaUN = parcelRequire("cgaUN");

var $j5RGe = parcelRequire("j5RGe");
const $daee67072644a367$export$3dd7971102e44fa8 = ()=>{
    const [theme, setTheme] = (0, $1v5pe.useState)((0, $cgaUN.getGlobalTheme)());
    (0, $1v5pe.useEffect)(()=>{
        const observer = new (0, $j5RGe.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $daee67072644a367$export$2e2bcd8739ae039 = $daee67072644a367$export$3dd7971102e44fa8;

});


parcelRegister("735hs", function(module, exports) {
module.exports = new URL("code-review-tick.f900e294.svg", import.meta.url).toString();

});

parcelRegister("6WxQp", function(module, exports) {
$parcel$export(module.exports, "WarningIcon", () => $986ca7a4a64dd2c1$export$f7dc499a72baa103);

var $kIqwl = parcelRequire("kIqwl");
const $986ca7a4a64dd2c1$var$Svg = ({ color: color })=>/*#__PURE__*/ (0, $kIqwl.jsx)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $kIqwl.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M11.7032 2.18968C13.1222 -0.426508 16.8779 -0.426506 18.2969 2.18968L29.3583 22.5858C30.7135 25.0845 28.9049 28.1229 26.0624 28.1229H3.93772C1.09519 28.1229 -0.713393 25.0845 0.641825 22.5858L11.7032 2.18968ZM14.9991 20.1542C13.9642 20.1546 13.1244 20.9941 13.1241 22.0292C13.1241 23.0644 13.964 23.9037 14.9991 23.9042C16.0347 23.9042 16.8741 23.0647 16.8741 22.0292C16.8739 20.9938 16.0345 20.1542 14.9991 20.1542ZM13.5929 8.4354V17.8104H16.4054V8.4354H13.5929Z",
            fill: color
        })
    });
const $986ca7a4a64dd2c1$export$f7dc499a72baa103 = ({ color: color })=>/*#__PURE__*/ (0, $kIqwl.jsx)($986ca7a4a64dd2c1$var$Svg, {
        color: color
    });

});

parcelRegister("1sNTn", function(module, exports) {
$parcel$export(module.exports, "default", () => $24dd04e70af2dc11$export$2e2bcd8739ae039);

var $75IaS = parcelRequire("75IaS");
var $24dd04e70af2dc11$export$2e2bcd8739ae039 = (0, $75IaS.defineMessages)({
    authenticationSuccessful: {
        id: 'dev-agents.github-oauth-redirect.authentication-successful',
        defaultMessage: 'Authentication successful',
        description: 'Title message shown when GitHub OAuth authentication is successful'
    },
    allDoneDescription: {
        id: 'dev-agents.github-oauth-redirect.all-done-description.code-reviewer',
        defaultMessage: "You're all done. Code Reviewer is ready to review your pull requests in GitHub.",
        description: 'Description message indicating setup is complete and Code Reviewer is ready'
    },
    resubmitPullRequestInstructions: {
        id: 'dev-agents.github-oauth-redirect.resubmit-pull-request-instructions',
        defaultMessage: 'Resubmit your pull request, or create a new one, to trigger a code review.',
        description: 'Instructions for users to resubmit or create a pull request to trigger code review'
    },
    backToGitHubButton: {
        id: 'dev-agents.github-oauth-redirect.back-to-github-button',
        defaultMessage: 'Back to GitHub',
        description: 'Label for the button that navigates the user back to GitHub'
    },
    authenticationFailed: {
        id: 'dev-agents.github-oauth-redirect.authentication-failed',
        defaultMessage: 'Authentication failed',
        description: 'Title message shown when GitHub OAuth authentication fails'
    },
    authenticationErrorDescription: {
        id: 'dev-agents.github-oauth-redirect.authentication-error-description',
        defaultMessage: 'There was an error during authentication. Please try again.',
        description: 'Description message shown when authentication fails'
    }
});

});


parcelRegister("9Lgqr", function(module, exports) {
$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $0379aa7fb0ed38ea$export$a4def92db6fc8e17);
// oxlint-disable-next-line eslint/no-redeclare
const $0379aa7fb0ed38ea$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("haLaD", function(module, exports) {
$parcel$export(module.exports, "BufferWithMaxLength", () => $ba8a7283ef86860e$export$2c6e86519c9e8188);
$parcel$export(module.exports, "EntriesBuffer", () => $ba8a7283ef86860e$export$f7dc16cbd16f7bbe);

var $9Lgqr = parcelRequire("9Lgqr");
class $ba8a7283ef86860e$export$2c6e86519c9e8188 {
    buffer = [];
    maxLength;
    full = false;
    constructor(maxLength = 1000){
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $ba8a7283ef86860e$export$f7dc16cbd16f7bbe = {
    [(0, $9Lgqr.PerformanceObserverEntryTypes).LongTask]: new $ba8a7283ef86860e$export$2c6e86519c9e8188(),
    [(0, $9Lgqr.PerformanceObserverEntryTypes).LayoutShift]: new $ba8a7283ef86860e$export$2c6e86519c9e8188()
};

});

parcelRegister("hF6SW", function(module, exports) {
$parcel$export(module.exports, "createPressureStateReport", () => $a80d49b8c669a248$export$1f0ff35da084986e);
$parcel$export(module.exports, "createMemoryStateReport", () => $a80d49b8c669a248$export$3b47ebb9832b4e24);
$parcel$export(module.exports, "initialisePressureObserver", () => $a80d49b8c669a248$export$117ebc554c6e9f2f);
$parcel$export(module.exports, "initialiseMemoryObserver", () => $a80d49b8c669a248$export$a3271f53e91faab7);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $a80d49b8c669a248$var$BUFFER_MAX_LENGTH = 1000; // ensure we don't blow up this buffer
let $a80d49b8c669a248$var$pressureRecordBuffer = [];
let $a80d49b8c669a248$var$pressureObserver = null;
let $a80d49b8c669a248$var$memoryRecordBuffer = [];
let $a80d49b8c669a248$var$memoryInterval;
function $a80d49b8c669a248$export$6c1060bed5fea050() {
    $a80d49b8c669a248$var$pressureRecordBuffer.length = 0;
}
function $a80d49b8c669a248$export$aa672c7221b183b0() {
    $a80d49b8c669a248$var$memoryRecordBuffer.length = 0;
}
function $a80d49b8c669a248$export$ec86686c1d2e65bc(filter) {
    $a80d49b8c669a248$var$pressureRecordBuffer = $a80d49b8c669a248$var$pressureRecordBuffer.filter(({ time: time })=>time > filter);
}
function $a80d49b8c669a248$export$c0142ac82f5d0c28(filter) {
    $a80d49b8c669a248$var$memoryRecordBuffer = $a80d49b8c669a248$var$memoryRecordBuffer.filter(({ time: time })=>time > filter);
}
function $a80d49b8c669a248$export$1f0ff35da084986e(start, end) {
    try {
        // To differentiate between the API not available, vs no PressureRecords added
        if (!('PressureObserver' in globalThis)) return null;
        const pressureStateCount = $a80d49b8c669a248$var$pressureRecordBuffer.reduce((pressureReport, { time: time, state: state })=>{
            if (time >= start && time <= end) pressureReport[state] += 1;
            return pressureReport;
        }, {
            nominal: 0,
            fair: 0,
            serious: 0,
            critical: 0
        });
        const pressureStateTotal = Object.values(pressureStateCount).reduce((total, count)=>total + count) || 1;
        $a80d49b8c669a248$export$ec86686c1d2e65bc(end);
        return {
            count: pressureStateCount,
            percentage: {
                nominal: Math.round(pressureStateCount.nominal / pressureStateTotal * 100),
                fair: Math.round(pressureStateCount.fair / pressureStateTotal * 100),
                serious: Math.round(pressureStateCount.serious / pressureStateTotal * 100),
                critical: Math.round(pressureStateCount.critical / pressureStateTotal * 100)
            }
        };
    } catch  {
        return null;
    }
}
function $a80d49b8c669a248$var$convertBytesToMegabytes(bytes) {
    return Math.round(Math.round(bytes / 1048576 * 100) / 100);
}
function $a80d49b8c669a248$export$3b47ebb9832b4e24(start, end) {
    try {
        if (!('memory' in performance)) return null;
        const accumulatedMemoryUsage = $a80d49b8c669a248$var$memoryRecordBuffer.reduce((acc, snapshot)=>{
            if (snapshot.time >= start && snapshot.time <= end) {
                acc.totalJSHeapSize += snapshot.totalJSHeapSize;
                acc.usedJSHeapSize += snapshot.usedJSHeapSize;
                acc.snapshotCount += 1;
            }
            return acc;
        }, {
            totalJSHeapSize: 0,
            usedJSHeapSize: 0,
            snapshotCount: 0
        });
        const memoryStateReport = {
            jsHeapSizeLimitInMB: $a80d49b8c669a248$var$convertBytesToMegabytes($a80d49b8c669a248$var$memoryRecordBuffer[0].jsHeapSizeLimit),
            // just use the first record, since this value always remains the same over time
            avgTotalJSHeapSizeInMB: $a80d49b8c669a248$var$convertBytesToMegabytes(accumulatedMemoryUsage.totalJSHeapSize / accumulatedMemoryUsage.snapshotCount),
            avgUsedJSHeapSizeInMB: $a80d49b8c669a248$var$convertBytesToMegabytes(accumulatedMemoryUsage.usedJSHeapSize / accumulatedMemoryUsage.snapshotCount)
        };
        $a80d49b8c669a248$export$c0142ac82f5d0c28(end);
        return memoryStateReport;
    } catch  {
        return null;
    }
}
function $a80d49b8c669a248$export$117ebc554c6e9f2f() {
    try {
        if ('PressureObserver' in globalThis) {
            $a80d49b8c669a248$var$pressureObserver = new PressureObserver((records)=>{
                if ($a80d49b8c669a248$var$pressureRecordBuffer.length + records.length <= $a80d49b8c669a248$var$BUFFER_MAX_LENGTH) $a80d49b8c669a248$var$pressureRecordBuffer.push(...records);
            });
            $a80d49b8c669a248$var$pressureObserver.observe('cpu', {
                sampleInterval: 100
            }).catch(()=>{
            // Silently handle permission policy restrictions or other observe failures
            // This prevents unhandled promise rejections from being reported to Sentry
            });
        }
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $a80d49b8c669a248$export$a3271f53e91faab7() {
    try {
        // only set up the interval if `performance.memory` is available in the browser
        if ('memory' in performance) $a80d49b8c669a248$var$memoryInterval = setInterval(()=>{
            // another check of `performance.memory` availability to satisfy typescript
            if ('memory' in performance) {
                const memory = performance.memory;
                if ($a80d49b8c669a248$var$memoryRecordBuffer.length <= $a80d49b8c669a248$var$BUFFER_MAX_LENGTH) $a80d49b8c669a248$var$memoryRecordBuffer.push({
                    time: performance.now(),
                    jsHeapSizeLimit: memory.jsHeapSizeLimit,
                    totalJSHeapSize: memory.totalJSHeapSize,
                    usedJSHeapSize: memory.usedJSHeapSize
                });
            }
        }, 100);
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $a80d49b8c669a248$export$10899ada382f2ae3() {
    clearInterval($a80d49b8c669a248$var$memoryInterval);
}
function $a80d49b8c669a248$export$b9fdd785f0fc1d40() {
    $a80d49b8c669a248$var$pressureObserver?.disconnect();
}

});

parcelRegister("5TRbo", function(module, exports) {
$parcel$export(module.exports, "getActiveTrace", () => $67c8b4420cd9fd5d$export$b6ac780db3a3cc77);
parcelRequire("keFM9");
var $i6wLE = parcelRequire("i6wLE");

var $2aEiL = parcelRequire("2aEiL");

var $iQo1C = parcelRequire("iQo1C");

var $ky6Wv = parcelRequire("ky6Wv");

var $Yfgvi = parcelRequire("Yfgvi");

var $5GvaV = parcelRequire("5GvaV");
function $67c8b4420cd9fd5d$export$b6ac780db3a3cc77() {
    if ((0, $2aEiL.fg)('platform_ufo_enable_otel_context_manager')) {
        // Get trace context from active context
        const activeTraceContext = {
            traceId: String((0, $i6wLE.context).active().getValue((0, $5GvaV.traceIdKey))),
            spanId: String((0, $i6wLE.context).active().getValue((0, $ky6Wv.spanIdKey))),
            type: String((0, $i6wLE.context).active().getValue((0, $iQo1C.experienceTypeKey)))
        };
        // Return activeTraceContext if traceId and spanId are not "undefined"
        return activeTraceContext.traceId !== 'undefined' && activeTraceContext.spanId !== 'undefined' ? activeTraceContext : undefined;
    } else return (0, $Yfgvi.state).context || undefined;
}

});
parcelRegister("keFM9", function(module, exports) {
$parcel$export(module.exports, "context", () => (parcelRequire("i6wLE")).context);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 

var $dCCNu = parcelRequire("dCCNu");















var $i6wLE = parcelRequire("i6wLE");

var $aaHZo = parcelRequire("aaHZo");

var $kZ8AQ = parcelRequire("kZ8AQ");

var $gwbQ0 = parcelRequire("gwbQ0");

var $2cvl5 = parcelRequire("2cvl5");
var // Default export.
$ebb5853f1afcb1db$export$2e2bcd8739ae039 = {
    context: $i6wLE.context,
    diag: $aaHZo.diag,
    metrics: $kZ8AQ.metrics,
    propagation: $gwbQ0.propagation,
    trace: $2cvl5.trace
};

});
parcelRegister("i6wLE", function(module, exports) {
$parcel$export(module.exports, "context", () => $d2e2347fabe4ed66$export$a078c61943f9dbbe);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $e5aXd = parcelRequire("e5aXd");
const $d2e2347fabe4ed66$export$a078c61943f9dbbe = (0, $e5aXd.ContextAPI).getInstance();

});
parcelRegister("e5aXd", function(module, exports) {
$parcel$export(module.exports, "ContextAPI", () => $a40a078d0b176e64$export$4148866f0a453927);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $1f7Oj = parcelRequire("1f7Oj");

var $jTV6N = parcelRequire("jTV6N");

var $TiYt8 = parcelRequire("TiYt8");
const $a40a078d0b176e64$var$API_NAME = 'context';
const $a40a078d0b176e64$var$NOOP_CONTEXT_MANAGER = new (0, $1f7Oj.NoopContextManager)();
class $a40a078d0b176e64$export$4148866f0a453927 {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){}
    /** Get the singleton instance of the Context API */ static getInstance() {
        if (!this._instance) this._instance = new $a40a078d0b176e64$export$4148866f0a453927();
        return this._instance;
    }
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */ setGlobalContextManager(contextManager) {
        return (0, $jTV6N.registerGlobal)($a40a078d0b176e64$var$API_NAME, contextManager, (0, $TiYt8.DiagAPI).instance());
    }
    /**
     * Get the currently active context
     */ active() {
        return this._getContextManager().active();
    }
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ with(context, fn, thisArg, ...args) {
        return this._getContextManager().with(context, fn, thisArg, ...args);
    }
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */ bind(context, target) {
        return this._getContextManager().bind(context, target);
    }
    _getContextManager() {
        return (0, $jTV6N.getGlobal)($a40a078d0b176e64$var$API_NAME) || $a40a078d0b176e64$var$NOOP_CONTEXT_MANAGER;
    }
    /** Disable and remove the global context manager */ disable() {
        this._getContextManager().disable();
        (0, $jTV6N.unregisterGlobal)($a40a078d0b176e64$var$API_NAME, (0, $TiYt8.DiagAPI).instance());
    }
}

});
parcelRegister("1f7Oj", function(module, exports) {
$parcel$export(module.exports, "NoopContextManager", () => $0e7d4023cc4c29c1$export$a27e5df35d1539a6);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $dCCNu = parcelRequire("dCCNu");
class $0e7d4023cc4c29c1$export$a27e5df35d1539a6 {
    active() {
        return 0, $dCCNu.ROOT_CONTEXT;
    }
    with(_context, fn, thisArg, ...args) {
        return fn.call(thisArg, ...args);
    }
    bind(_context, target) {
        return target;
    }
    enable() {
        return this;
    }
    disable() {
        return this;
    }
}

});

parcelRegister("jTV6N", function(module, exports) {
$parcel$export(module.exports, "registerGlobal", () => $e7cf73f90e6f5b08$export$d586ae880b433238);
$parcel$export(module.exports, "getGlobal", () => $e7cf73f90e6f5b08$export$a4e55266d2135a7f);
$parcel$export(module.exports, "unregisterGlobal", () => $e7cf73f90e6f5b08$export$d42ac835f38d1fb2);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $4lGN2 = parcelRequire("4lGN2");

var $cVruD = parcelRequire("cVruD");
const $e7cf73f90e6f5b08$var$major = (0, $4lGN2.VERSION).split('.')[0];
const $e7cf73f90e6f5b08$var$GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for(`opentelemetry.js.api.${$e7cf73f90e6f5b08$var$major}`);
const $e7cf73f90e6f5b08$var$_global = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};
function $e7cf73f90e6f5b08$export$d586ae880b433238(type, instance, diag, allowOverride = false) {
    var _a;
    const api = $e7cf73f90e6f5b08$var$_global[$e7cf73f90e6f5b08$var$GLOBAL_OPENTELEMETRY_API_KEY] = (_a = $e7cf73f90e6f5b08$var$_global[$e7cf73f90e6f5b08$var$GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: (0, $4lGN2.VERSION)
    };
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        const err = new Error(`@opentelemetry/api: Attempted duplicate registration of API: ${type}`);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== (0, $4lGN2.VERSION)) {
        // All registered APIs must be of the same version exactly
        const err = new Error(`@opentelemetry/api: Registration of version v${api.version} for ${type} does not match previously registered API v${(0, $4lGN2.VERSION)}`);
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug(`@opentelemetry/api: Registered a global for ${type} v${(0, $4lGN2.VERSION)}.`);
    return true;
}
function $e7cf73f90e6f5b08$export$a4e55266d2135a7f(type) {
    var _a, _b;
    const globalVersion = (_a = $e7cf73f90e6f5b08$var$_global[$e7cf73f90e6f5b08$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !(0, $cVruD.isCompatible)(globalVersion)) return;
    return (_b = $e7cf73f90e6f5b08$var$_global[$e7cf73f90e6f5b08$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function $e7cf73f90e6f5b08$export$d42ac835f38d1fb2(type, diag) {
    diag.debug(`@opentelemetry/api: Unregistering a global for ${type} v${(0, $4lGN2.VERSION)}.`);
    const api = $e7cf73f90e6f5b08$var$_global[$e7cf73f90e6f5b08$var$GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}

});
parcelRegister("4lGN2", function(module, exports) {
$parcel$export(module.exports, "VERSION", () => $32aa50c22b669e86$export$a4ad2735b021c132);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // this is autogenerated file, see scripts/version-update.js
const $32aa50c22b669e86$export$a4ad2735b021c132 = '1.9.1';

});

parcelRegister("cVruD", function(module, exports) {
$parcel$export(module.exports, "isCompatible", () => $969022765c4a38e7$export$7fc0d8c3ab188c4c);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $4lGN2 = parcelRequire("4lGN2");
const $969022765c4a38e7$var$re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function $969022765c4a38e7$export$a5733a4d26a1ec61(ownVersion) {
    const acceptedVersions = new Set([
        ownVersion
    ]);
    const rejectedVersions = new Set();
    const myVersionMatch = ownVersion.match($969022765c4a38e7$var$re);
    if (!myVersionMatch) // we cannot guarantee compatibility so we always return noop
    return ()=>false;
    const ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        const globalVersionMatch = globalVersion.match($969022765c4a38e7$var$re);
        if (!globalVersionMatch) // cannot parse other version
        // we cannot guarantee compatibility so we always noop
        return _reject(globalVersion);
        const globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
const $969022765c4a38e7$export$7fc0d8c3ab188c4c = $969022765c4a38e7$export$a5733a4d26a1ec61((0, $4lGN2.VERSION));

});


parcelRegister("TiYt8", function(module, exports) {
$parcel$export(module.exports, "DiagAPI", () => $0a63db1223de8fcd$export$5c8937ffc688cfd3);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $i0wyM = parcelRequire("i0wyM");

var $7Fo2w = parcelRequire("7Fo2w");

var $2vjrO = parcelRequire("2vjrO");

var $jTV6N = parcelRequire("jTV6N");
const $0a63db1223de8fcd$var$API_NAME = 'diag';
class $0a63db1223de8fcd$export$5c8937ffc688cfd3 {
    /** Get the singleton instance of the DiagAPI API */ static instance() {
        if (!this._instance) this._instance = new $0a63db1223de8fcd$export$5c8937ffc688cfd3();
        return this._instance;
    }
    /**
     * Private internal constructor
     * @private
     */ constructor(){
        function _logProxy(funcName) {
            return function(...args) {
                const logger = (0, $jTV6N.getGlobal)('diag');
                // shortcut if logger not set
                if (!logger) return;
                return logger[funcName](...args);
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        const self = this;
        // DiagAPI specific functions
        const setLogger = (logger, optionsOrLogLevel = {
            logLevel: (0, $2vjrO.DiagLogLevel).INFO
        })=>{
            var _a, _b, _c;
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                const err = new Error('Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation');
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === 'number') optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            const oldLogger = (0, $jTV6N.getGlobal)('diag');
            const newLogger = (0, $7Fo2w.createLogLevelDiagLogger)((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : (0, $2vjrO.DiagLogLevel).INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                const stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : '<failed to generate stacktrace>';
                oldLogger.warn(`Current logger will be overwritten from ${stack}`);
                newLogger.warn(`Current logger will overwrite one already registered from ${stack}`);
            }
            return (0, $jTV6N.registerGlobal)('diag', newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = ()=>{
            (0, $jTV6N.unregisterGlobal)($0a63db1223de8fcd$var$API_NAME, self);
        };
        self.createComponentLogger = (options)=>{
            return new (0, $i0wyM.DiagComponentLogger)(options);
        };
        self.verbose = _logProxy('verbose');
        self.debug = _logProxy('debug');
        self.info = _logProxy('info');
        self.warn = _logProxy('warn');
        self.error = _logProxy('error');
    }
}

});
parcelRegister("i0wyM", function(module, exports) {
$parcel$export(module.exports, "DiagComponentLogger", () => $d1c17bcff23d940a$export$b4bccc12f5b13129);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $jTV6N = parcelRequire("jTV6N");
class $d1c17bcff23d940a$export$b4bccc12f5b13129 {
    constructor(props){
        this._namespace = props.namespace || 'DiagComponentLogger';
    }
    debug(...args) {
        return $d1c17bcff23d940a$var$logProxy('debug', this._namespace, args);
    }
    error(...args) {
        return $d1c17bcff23d940a$var$logProxy('error', this._namespace, args);
    }
    info(...args) {
        return $d1c17bcff23d940a$var$logProxy('info', this._namespace, args);
    }
    warn(...args) {
        return $d1c17bcff23d940a$var$logProxy('warn', this._namespace, args);
    }
    verbose(...args) {
        return $d1c17bcff23d940a$var$logProxy('verbose', this._namespace, args);
    }
}
function $d1c17bcff23d940a$var$logProxy(funcName, namespace, args) {
    const logger = (0, $jTV6N.getGlobal)('diag');
    // shortcut if logger not set
    if (!logger) return;
    return logger[funcName](namespace, ...args);
}

});

parcelRegister("7Fo2w", function(module, exports) {
$parcel$export(module.exports, "createLogLevelDiagLogger", () => $594f0286f9a51a3d$export$9a9cc475abb19689);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $2vjrO = parcelRequire("2vjrO");
function $594f0286f9a51a3d$export$9a9cc475abb19689(maxLevel, logger) {
    if (maxLevel < (0, $2vjrO.DiagLogLevel).NONE) maxLevel = (0, $2vjrO.DiagLogLevel).NONE;
    else if (maxLevel > (0, $2vjrO.DiagLogLevel).ALL) maxLevel = (0, $2vjrO.DiagLogLevel).ALL;
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        const theFunc = logger[funcName];
        if (typeof theFunc === 'function' && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc('error', (0, $2vjrO.DiagLogLevel).ERROR),
        warn: _filterFunc('warn', (0, $2vjrO.DiagLogLevel).WARN),
        info: _filterFunc('info', (0, $2vjrO.DiagLogLevel).INFO),
        debug: _filterFunc('debug', (0, $2vjrO.DiagLogLevel).DEBUG),
        verbose: _filterFunc('verbose', (0, $2vjrO.DiagLogLevel).VERBOSE)
    };
}

});
parcelRegister("2vjrO", function(module, exports) {
$parcel$export(module.exports, "DiagLogLevel", () => $1d2d8fe4e44dc42b$export$b7d7b4c0f3c95263);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */ var $1d2d8fe4e44dc42b$export$b7d7b4c0f3c95263;
(function(DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */ DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */ DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */ DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */ DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */ DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */ DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */ DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})($1d2d8fe4e44dc42b$export$b7d7b4c0f3c95263 || ($1d2d8fe4e44dc42b$export$b7d7b4c0f3c95263 = {}));

});





parcelRegister("aaHZo", function(module, exports) {
$parcel$export(module.exports, "diag", () => $767cf5e2b843cc4f$export$c042e7c2f59bc046);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $TiYt8 = parcelRequire("TiYt8");
const $767cf5e2b843cc4f$export$c042e7c2f59bc046 = (0, $TiYt8.DiagAPI).instance();

});

parcelRegister("kZ8AQ", function(module, exports) {
$parcel$export(module.exports, "metrics", () => $f4702b93e495ea46$export$b0c5c2fac8144e54);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $8pIjC = parcelRequire("8pIjC");
const $f4702b93e495ea46$export$b0c5c2fac8144e54 = (0, $8pIjC.MetricsAPI).getInstance();

});
parcelRegister("8pIjC", function(module, exports) {
$parcel$export(module.exports, "MetricsAPI", () => $620308a7a02e7c9e$export$1339f6eb6111c638);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $hjCih = parcelRequire("hjCih");

var $jTV6N = parcelRequire("jTV6N");

var $TiYt8 = parcelRequire("TiYt8");
const $620308a7a02e7c9e$var$API_NAME = 'metrics';
class $620308a7a02e7c9e$export$1339f6eb6111c638 {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){}
    /** Get the singleton instance of the Metrics API */ static getInstance() {
        if (!this._instance) this._instance = new $620308a7a02e7c9e$export$1339f6eb6111c638();
        return this._instance;
    }
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */ setGlobalMeterProvider(provider) {
        return (0, $jTV6N.registerGlobal)($620308a7a02e7c9e$var$API_NAME, provider, (0, $TiYt8.DiagAPI).instance());
    }
    /**
     * Returns the global meter provider.
     */ getMeterProvider() {
        return (0, $jTV6N.getGlobal)($620308a7a02e7c9e$var$API_NAME) || (0, $hjCih.NOOP_METER_PROVIDER);
    }
    /**
     * Returns a meter from the global meter provider.
     */ getMeter(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    }
    /** Remove the global meter provider */ disable() {
        (0, $jTV6N.unregisterGlobal)($620308a7a02e7c9e$var$API_NAME, (0, $TiYt8.DiagAPI).instance());
    }
}

});
parcelRegister("hjCih", function(module, exports) {
$parcel$export(module.exports, "NOOP_METER_PROVIDER", () => $c9b1ea5f475cdcb4$export$d21fe83355c56e18);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $e2uEZ = parcelRequire("e2uEZ");
class $c9b1ea5f475cdcb4$export$51c513ea08316108 {
    getMeter(_name, _version, _options) {
        return 0, $e2uEZ.NOOP_METER;
    }
}
const $c9b1ea5f475cdcb4$export$d21fe83355c56e18 = new $c9b1ea5f475cdcb4$export$51c513ea08316108();

});
parcelRegister("e2uEZ", function(module, exports) {
$parcel$export(module.exports, "NOOP_METER", () => $a389090a076a5add$export$65e277d35235a01f);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */ class $a389090a076a5add$export$c23c6f85dd4fc1e9 {
    constructor(){}
    /**
     * @see {@link Meter.createGauge}
     */ createGauge(_name, _options) {
        return $a389090a076a5add$export$dd01300aacbcec1c;
    }
    /**
     * @see {@link Meter.createHistogram}
     */ createHistogram(_name, _options) {
        return $a389090a076a5add$export$689c32a6a552e1a6;
    }
    /**
     * @see {@link Meter.createCounter}
     */ createCounter(_name, _options) {
        return $a389090a076a5add$export$e6d19fe5233efc54;
    }
    /**
     * @see {@link Meter.createUpDownCounter}
     */ createUpDownCounter(_name, _options) {
        return $a389090a076a5add$export$2f189cd99d2b7429;
    }
    /**
     * @see {@link Meter.createObservableGauge}
     */ createObservableGauge(_name, _options) {
        return $a389090a076a5add$export$ea67e3c6ff624776;
    }
    /**
     * @see {@link Meter.createObservableCounter}
     */ createObservableCounter(_name, _options) {
        return $a389090a076a5add$export$163422b94c3edbcb;
    }
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */ createObservableUpDownCounter(_name, _options) {
        return $a389090a076a5add$export$5b8be9ab17b673b3;
    }
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */ addBatchObservableCallback(_callback, _observables) {}
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */ removeBatchObservableCallback(_callback) {}
}
class $a389090a076a5add$export$834a616d1cf278b {
}
class $a389090a076a5add$export$b556ba0f560c45b extends $a389090a076a5add$export$834a616d1cf278b {
    add(_value, _attributes) {}
}
class $a389090a076a5add$export$df09a35db160df98 extends $a389090a076a5add$export$834a616d1cf278b {
    add(_value, _attributes) {}
}
class $a389090a076a5add$export$b7f4a3c7ea16c24 extends $a389090a076a5add$export$834a616d1cf278b {
    record(_value, _attributes) {}
}
class $a389090a076a5add$export$ef064c3e0426c607 extends $a389090a076a5add$export$834a616d1cf278b {
    record(_value, _attributes) {}
}
class $a389090a076a5add$export$a5a3e7829c289482 {
    addCallback(_callback) {}
    removeCallback(_callback) {}
}
class $a389090a076a5add$export$7a7e4b169d5c93a8 extends $a389090a076a5add$export$a5a3e7829c289482 {
}
class $a389090a076a5add$export$6990a2f90809ffc1 extends $a389090a076a5add$export$a5a3e7829c289482 {
}
class $a389090a076a5add$export$3ec3555bc6f693a4 extends $a389090a076a5add$export$a5a3e7829c289482 {
}
const $a389090a076a5add$export$65e277d35235a01f = new $a389090a076a5add$export$c23c6f85dd4fc1e9();
const $a389090a076a5add$export$e6d19fe5233efc54 = new $a389090a076a5add$export$b556ba0f560c45b();
const $a389090a076a5add$export$dd01300aacbcec1c = new $a389090a076a5add$export$b7f4a3c7ea16c24();
const $a389090a076a5add$export$689c32a6a552e1a6 = new $a389090a076a5add$export$ef064c3e0426c607();
const $a389090a076a5add$export$2f189cd99d2b7429 = new $a389090a076a5add$export$df09a35db160df98();
const $a389090a076a5add$export$163422b94c3edbcb = new $a389090a076a5add$export$7a7e4b169d5c93a8();
const $a389090a076a5add$export$ea67e3c6ff624776 = new $a389090a076a5add$export$6990a2f90809ffc1();
const $a389090a076a5add$export$5b8be9ab17b673b3 = new $a389090a076a5add$export$3ec3555bc6f693a4();
function $a389090a076a5add$export$bc3a498ccbb5c2b5() {
    return $a389090a076a5add$export$65e277d35235a01f;
}

});




parcelRegister("gwbQ0", function(module, exports) {
$parcel$export(module.exports, "propagation", () => $c068d140f08cb467$export$3e49040daa9dba20);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $bCjzO = parcelRequire("bCjzO");
const $c068d140f08cb467$export$3e49040daa9dba20 = (0, $bCjzO.PropagationAPI).getInstance();

});
parcelRegister("bCjzO", function(module, exports) {
$parcel$export(module.exports, "PropagationAPI", () => $87526dd3fca0eac7$export$471eda0a6213cac9);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $jTV6N = parcelRequire("jTV6N");

var $a6A3m = parcelRequire("a6A3m");

var $60mVP = parcelRequire("60mVP");

var $dNPuZ = parcelRequire("dNPuZ");

var $bwzCI = parcelRequire("bwzCI");

var $TiYt8 = parcelRequire("TiYt8");
const $87526dd3fca0eac7$var$API_NAME = 'propagation';
const $87526dd3fca0eac7$var$NOOP_TEXT_MAP_PROPAGATOR = new (0, $a6A3m.NoopTextMapPropagator)();
class $87526dd3fca0eac7$export$471eda0a6213cac9 {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){
        this.createBaggage = (0, $bwzCI.createBaggage);
        this.getBaggage = (0, $dNPuZ.getBaggage);
        this.getActiveBaggage = (0, $dNPuZ.getActiveBaggage);
        this.setBaggage = (0, $dNPuZ.setBaggage);
        this.deleteBaggage = (0, $dNPuZ.deleteBaggage);
    }
    /** Get the singleton instance of the Propagator API */ static getInstance() {
        if (!this._instance) this._instance = new $87526dd3fca0eac7$export$471eda0a6213cac9();
        return this._instance;
    }
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */ setGlobalPropagator(propagator) {
        return (0, $jTV6N.registerGlobal)($87526dd3fca0eac7$var$API_NAME, propagator, (0, $TiYt8.DiagAPI).instance());
    }
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */ inject(context, carrier, setter = (0, $60mVP.defaultTextMapSetter)) {
        return this._getGlobalPropagator().inject(context, carrier, setter);
    }
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */ extract(context, carrier, getter = (0, $60mVP.defaultTextMapGetter)) {
        return this._getGlobalPropagator().extract(context, carrier, getter);
    }
    /**
     * Return a list of all fields which may be used by the propagator.
     */ fields() {
        return this._getGlobalPropagator().fields();
    }
    /** Remove the global propagator */ disable() {
        (0, $jTV6N.unregisterGlobal)($87526dd3fca0eac7$var$API_NAME, (0, $TiYt8.DiagAPI).instance());
    }
    _getGlobalPropagator() {
        return (0, $jTV6N.getGlobal)($87526dd3fca0eac7$var$API_NAME) || $87526dd3fca0eac7$var$NOOP_TEXT_MAP_PROPAGATOR;
    }
}

});
parcelRegister("a6A3m", function(module, exports) {
$parcel$export(module.exports, "NoopTextMapPropagator", () => $75b66e5b01f4c83c$export$8356c7eb3af7963b);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * No-op implementations of {@link TextMapPropagator}.
 */ class $75b66e5b01f4c83c$export$8356c7eb3af7963b {
    /** Noop inject function does nothing */ inject(_context, _carrier) {}
    /** Noop extract function does nothing and returns the input context */ extract(context, _carrier) {
        return context;
    }
    fields() {
        return [];
    }
}

});

parcelRegister("60mVP", function(module, exports) {
$parcel$export(module.exports, "defaultTextMapGetter", () => $45f487e9285d4927$export$a0f575f55f38720a);
$parcel$export(module.exports, "defaultTextMapSetter", () => $45f487e9285d4927$export$f70f1d111fccf1c1);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @since 1.0.0
 */ const $45f487e9285d4927$export$a0f575f55f38720a = {
    get (carrier, key) {
        if (carrier == null) return undefined;
        return carrier[key];
    },
    keys (carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
const $45f487e9285d4927$export$f70f1d111fccf1c1 = {
    set (carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};

});

parcelRegister("dNPuZ", function(module, exports) {
$parcel$export(module.exports, "getBaggage", () => $a0c7cc91a89fce25$export$f3bffa0b5dd10d1e);
$parcel$export(module.exports, "getActiveBaggage", () => $a0c7cc91a89fce25$export$120a1756099436ee);
$parcel$export(module.exports, "setBaggage", () => $a0c7cc91a89fce25$export$adc9ca19eab3f500);
$parcel$export(module.exports, "deleteBaggage", () => $a0c7cc91a89fce25$export$4ca3a8a743c9f633);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $e5aXd = parcelRequire("e5aXd");

var $dCCNu = parcelRequire("dCCNu");
/**
 * Baggage key
 */ const $a0c7cc91a89fce25$var$BAGGAGE_KEY = (0, $dCCNu.createContextKey)('OpenTelemetry Baggage Key');
function $a0c7cc91a89fce25$export$f3bffa0b5dd10d1e(context) {
    return context.getValue($a0c7cc91a89fce25$var$BAGGAGE_KEY) || undefined;
}
function $a0c7cc91a89fce25$export$120a1756099436ee() {
    return $a0c7cc91a89fce25$export$f3bffa0b5dd10d1e((0, $e5aXd.ContextAPI).getInstance().active());
}
function $a0c7cc91a89fce25$export$adc9ca19eab3f500(context, baggage) {
    return context.setValue($a0c7cc91a89fce25$var$BAGGAGE_KEY, baggage);
}
function $a0c7cc91a89fce25$export$4ca3a8a743c9f633(context) {
    return context.deleteValue($a0c7cc91a89fce25$var$BAGGAGE_KEY);
}

});

parcelRegister("bwzCI", function(module, exports) {
$parcel$export(module.exports, "createBaggage", () => $863e50f0b81e71c4$export$1034a425c7384452);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $TiYt8 = parcelRequire("TiYt8");

var $fBmzt = parcelRequire("fBmzt");

var $55eBc = parcelRequire("55eBc");
const $863e50f0b81e71c4$var$diag = (0, $TiYt8.DiagAPI).instance();
function $863e50f0b81e71c4$export$1034a425c7384452(entries = {}) {
    return new (0, $fBmzt.BaggageImpl)(new Map(Object.entries(entries)));
}
function $863e50f0b81e71c4$export$c491cedc1b2b6e9e(str) {
    if (typeof str !== 'string') {
        $863e50f0b81e71c4$var$diag.error(`Cannot create baggage metadata from unknown type: ${typeof str}`);
        str = '';
    }
    return {
        __TYPE__: (0, $55eBc.baggageEntryMetadataSymbol),
        toString () {
            return str;
        }
    };
}

});
parcelRegister("fBmzt", function(module, exports) {
$parcel$export(module.exports, "BaggageImpl", () => $b5bbd1e251e6b158$export$b8c511fa1a5f4987);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ class $b5bbd1e251e6b158$export$b8c511fa1a5f4987 {
    constructor(entries){
        this._entries = entries ? new Map(entries) : new Map();
    }
    getEntry(key) {
        const entry = this._entries.get(key);
        if (!entry) return undefined;
        return Object.assign({}, entry);
    }
    getAllEntries() {
        return Array.from(this._entries.entries());
    }
    setEntry(key, entry) {
        const newBaggage = new $b5bbd1e251e6b158$export$b8c511fa1a5f4987(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    }
    removeEntry(key) {
        const newBaggage = new $b5bbd1e251e6b158$export$b8c511fa1a5f4987(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    }
    removeEntries(...keys) {
        const newBaggage = new $b5bbd1e251e6b158$export$b8c511fa1a5f4987(this._entries);
        for (const key of keys)newBaggage._entries.delete(key);
        return newBaggage;
    }
    clear() {
        return new $b5bbd1e251e6b158$export$b8c511fa1a5f4987();
    }
}

});

parcelRegister("55eBc", function(module, exports) {
$parcel$export(module.exports, "baggageEntryMetadataSymbol", () => $3b38be7506de47a0$export$92dd2fe8ddb5cb7);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */ const $3b38be7506de47a0$export$92dd2fe8ddb5cb7 = Symbol('BaggageEntryMetadata');

});




parcelRegister("2cvl5", function(module, exports) {
$parcel$export(module.exports, "trace", () => $19a5031239cd3f24$export$357889f174732d38);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $3q1UK = parcelRequire("3q1UK");
const $19a5031239cd3f24$export$357889f174732d38 = (0, $3q1UK.TraceAPI).getInstance();

});
parcelRegister("3q1UK", function(module, exports) {
$parcel$export(module.exports, "TraceAPI", () => $27d548ec858449c5$export$2cccde6fcc7b568a);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $jTV6N = parcelRequire("jTV6N");

var $1ocWv = parcelRequire("1ocWv");

var $idFOa = parcelRequire("idFOa");

var $7SVLL = parcelRequire("7SVLL");

var $TiYt8 = parcelRequire("TiYt8");
const $27d548ec858449c5$var$API_NAME = 'trace';
class $27d548ec858449c5$export$2cccde6fcc7b568a {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){
        this._proxyTracerProvider = new (0, $1ocWv.ProxyTracerProvider)();
        this.wrapSpanContext = (0, $idFOa.wrapSpanContext);
        this.isSpanContextValid = (0, $idFOa.isSpanContextValid);
        this.deleteSpan = (0, $7SVLL.deleteSpan);
        this.getSpan = (0, $7SVLL.getSpan);
        this.getActiveSpan = (0, $7SVLL.getActiveSpan);
        this.getSpanContext = (0, $7SVLL.getSpanContext);
        this.setSpan = (0, $7SVLL.setSpan);
        this.setSpanContext = (0, $7SVLL.setSpanContext);
    }
    /** Get the singleton instance of the Trace API */ static getInstance() {
        if (!this._instance) this._instance = new $27d548ec858449c5$export$2cccde6fcc7b568a();
        return this._instance;
    }
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */ setGlobalTracerProvider(provider) {
        const success = (0, $jTV6N.registerGlobal)($27d548ec858449c5$var$API_NAME, this._proxyTracerProvider, (0, $TiYt8.DiagAPI).instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    }
    /**
     * Returns the global tracer provider.
     */ getTracerProvider() {
        return (0, $jTV6N.getGlobal)($27d548ec858449c5$var$API_NAME) || this._proxyTracerProvider;
    }
    /**
     * Returns a tracer from the global tracer provider.
     */ getTracer(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    }
    /** Remove the global tracer provider */ disable() {
        (0, $jTV6N.unregisterGlobal)($27d548ec858449c5$var$API_NAME, (0, $TiYt8.DiagAPI).instance());
        this._proxyTracerProvider = new (0, $1ocWv.ProxyTracerProvider)();
    }
}

});
parcelRegister("1ocWv", function(module, exports) {
$parcel$export(module.exports, "ProxyTracerProvider", () => $103212778747070d$export$4137aabcb4254962);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $23nnY = parcelRequire("23nnY");

var $46FqL = parcelRequire("46FqL");
const $103212778747070d$var$NOOP_TRACER_PROVIDER = new (0, $46FqL.NoopTracerProvider)();
class $103212778747070d$export$4137aabcb4254962 {
    /**
     * Get a {@link ProxyTracer}
     */ getTracer(name, version, options) {
        var _a;
        return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $23nnY.ProxyTracer)(this, name, version, options);
    }
    getDelegate() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : $103212778747070d$var$NOOP_TRACER_PROVIDER;
    }
    /**
     * Set the delegate tracer provider
     */ setDelegate(delegate) {
        this._delegate = delegate;
    }
    getDelegateTracer(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    }
}

});
parcelRegister("23nnY", function(module, exports) {
$parcel$export(module.exports, "ProxyTracer", () => $17ee0083e1967f32$export$df2c38268c6bb6b3);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $12tBY = parcelRequire("12tBY");
const $17ee0083e1967f32$var$NOOP_TRACER = new (0, $12tBY.NoopTracer)();
class $17ee0083e1967f32$export$df2c38268c6bb6b3 {
    constructor(provider, name, version, options){
        this._provider = provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    startSpan(name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    }
    startActiveSpan(_name, _options, _context, _fn) {
        const tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    }
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */ _getTracer() {
        if (this._delegate) return this._delegate;
        const tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return $17ee0083e1967f32$var$NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    }
}

});
parcelRegister("12tBY", function(module, exports) {
$parcel$export(module.exports, "NoopTracer", () => $0c1cf28c1847f958$export$714c1036cabcd223);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $e5aXd = parcelRequire("e5aXd");

var $7SVLL = parcelRequire("7SVLL");

var $i8tx3 = parcelRequire("i8tx3");

var $idFOa = parcelRequire("idFOa");
const $0c1cf28c1847f958$var$contextApi = (0, $e5aXd.ContextAPI).getInstance();
class $0c1cf28c1847f958$export$714c1036cabcd223 {
    // startSpan starts a noop span.
    startSpan(name, options, context = $0c1cf28c1847f958$var$contextApi.active()) {
        const root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new (0, $i8tx3.NonRecordingSpan)();
        const parentFromContext = context && (0, $7SVLL.getSpanContext)(context);
        if ($0c1cf28c1847f958$var$isSpanContext(parentFromContext) && (0, $idFOa.isSpanContextValid)(parentFromContext)) return new (0, $i8tx3.NonRecordingSpan)(parentFromContext);
        else return new (0, $i8tx3.NonRecordingSpan)();
    }
    startActiveSpan(name, arg2, arg3, arg4) {
        let opts;
        let ctx;
        let fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        const parentContext = ctx !== null && ctx !== void 0 ? ctx : $0c1cf28c1847f958$var$contextApi.active();
        const span = this.startSpan(name, opts, parentContext);
        const contextWithSpanSet = (0, $7SVLL.setSpan)(parentContext, span);
        return $0c1cf28c1847f958$var$contextApi.with(contextWithSpanSet, fn, undefined, span);
    }
}
function $0c1cf28c1847f958$var$isSpanContext(spanContext) {
    return spanContext !== null && typeof spanContext === 'object' && 'spanId' in spanContext && typeof spanContext['spanId'] === 'string' && 'traceId' in spanContext && typeof spanContext['traceId'] === 'string' && 'traceFlags' in spanContext && typeof spanContext['traceFlags'] === 'number';
}

});
parcelRegister("7SVLL", function(module, exports) {
$parcel$export(module.exports, "getSpan", () => $5bda635535e8bad2$export$246e04ba06066af1);
$parcel$export(module.exports, "getActiveSpan", () => $5bda635535e8bad2$export$1be426a8e585c83e);
$parcel$export(module.exports, "setSpan", () => $5bda635535e8bad2$export$8ab2f2e6ee8ed0a8);
$parcel$export(module.exports, "deleteSpan", () => $5bda635535e8bad2$export$a6bbfe9a17f7941c);
$parcel$export(module.exports, "setSpanContext", () => $5bda635535e8bad2$export$c90bf5428c14cdb1);
$parcel$export(module.exports, "getSpanContext", () => $5bda635535e8bad2$export$1a635f8f0b912781);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $dCCNu = parcelRequire("dCCNu");

var $i8tx3 = parcelRequire("i8tx3");

var $e5aXd = parcelRequire("e5aXd");
/**
 * span key
 */ const $5bda635535e8bad2$var$SPAN_KEY = (0, $dCCNu.createContextKey)('OpenTelemetry Context Key SPAN');
function $5bda635535e8bad2$export$246e04ba06066af1(context) {
    return context.getValue($5bda635535e8bad2$var$SPAN_KEY) || undefined;
}
function $5bda635535e8bad2$export$1be426a8e585c83e() {
    return $5bda635535e8bad2$export$246e04ba06066af1((0, $e5aXd.ContextAPI).getInstance().active());
}
function $5bda635535e8bad2$export$8ab2f2e6ee8ed0a8(context, span) {
    return context.setValue($5bda635535e8bad2$var$SPAN_KEY, span);
}
function $5bda635535e8bad2$export$a6bbfe9a17f7941c(context) {
    return context.deleteValue($5bda635535e8bad2$var$SPAN_KEY);
}
function $5bda635535e8bad2$export$c90bf5428c14cdb1(context, spanContext) {
    return $5bda635535e8bad2$export$8ab2f2e6ee8ed0a8(context, new (0, $i8tx3.NonRecordingSpan)(spanContext));
}
function $5bda635535e8bad2$export$1a635f8f0b912781(context) {
    var _a;
    return (_a = $5bda635535e8bad2$export$246e04ba06066af1(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}

});
parcelRegister("i8tx3", function(module, exports) {
$parcel$export(module.exports, "NonRecordingSpan", () => $d33fe1cbc1a96b7a$export$972d28f7c6a8c6c7);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $1L9tl = parcelRequire("1L9tl");
class $d33fe1cbc1a96b7a$export$972d28f7c6a8c6c7 {
    constructor(spanContext = (0, $1L9tl.INVALID_SPAN_CONTEXT)){
        this._spanContext = spanContext;
    }
    // Returns a SpanContext.
    spanContext() {
        return this._spanContext;
    }
    // By default does nothing
    setAttribute(_key, _value) {
        return this;
    }
    // By default does nothing
    setAttributes(_attributes) {
        return this;
    }
    // By default does nothing
    addEvent(_name, _attributes) {
        return this;
    }
    addLink(_link) {
        return this;
    }
    addLinks(_links) {
        return this;
    }
    // By default does nothing
    setStatus(_status) {
        return this;
    }
    // By default does nothing
    updateName(_name) {
        return this;
    }
    // By default does nothing
    end(_endTime) {}
    // isRecording always returns false for NonRecordingSpan.
    isRecording() {
        return false;
    }
    // By default does nothing
    recordException(_exception, _time) {}
}

});
parcelRegister("1L9tl", function(module, exports) {
$parcel$export(module.exports, "INVALID_SPANID", () => $1481873ac95b4715$export$55cc39fb0d4bb4c0);
$parcel$export(module.exports, "INVALID_TRACEID", () => $1481873ac95b4715$export$22be96e88d95e128);
$parcel$export(module.exports, "INVALID_SPAN_CONTEXT", () => $1481873ac95b4715$export$8591e4c852b66703);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $3IBE2 = parcelRequire("3IBE2");
const $1481873ac95b4715$export$55cc39fb0d4bb4c0 = '0000000000000000';
const $1481873ac95b4715$export$22be96e88d95e128 = '00000000000000000000000000000000';
const $1481873ac95b4715$export$8591e4c852b66703 = {
    traceId: $1481873ac95b4715$export$22be96e88d95e128,
    spanId: $1481873ac95b4715$export$55cc39fb0d4bb4c0,
    traceFlags: (0, $3IBE2.TraceFlags).NONE
};

});
parcelRegister("3IBE2", function(module, exports) {
$parcel$export(module.exports, "TraceFlags", () => $2b52aea6ff5880a3$export$bf9049ad2b0883ff);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @since 1.0.0
 */ var $2b52aea6ff5880a3$export$bf9049ad2b0883ff;
(function(TraceFlags) {
    /** Represents no flag set. */ TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */ TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})($2b52aea6ff5880a3$export$bf9049ad2b0883ff || ($2b52aea6ff5880a3$export$bf9049ad2b0883ff = {}));

});




parcelRegister("idFOa", function(module, exports) {
$parcel$export(module.exports, "isSpanContextValid", () => $d439df1ba5a666a9$export$e4373b9a2c09216c);
$parcel$export(module.exports, "wrapSpanContext", () => $d439df1ba5a666a9$export$c19cc0f1911bdb85);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $1L9tl = parcelRequire("1L9tl");

var $i8tx3 = parcelRequire("i8tx3");
// Valid characters (0-9, a-f, A-F) are marked as 1.
const $d439df1ba5a666a9$var$isHex = new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1
]);
function $d439df1ba5a666a9$var$isValidHex(id, length) {
    // As of 1.9.0 the id was allowed to be a non-string value,
    // even though it was not possible in the types.
    if (typeof id !== 'string' || id.length !== length) return false;
    let r = 0;
    for(let i = 0; i < id.length; i += 4)r += ($d439df1ba5a666a9$var$isHex[id.charCodeAt(i)] | 0) + ($d439df1ba5a666a9$var$isHex[id.charCodeAt(i + 1)] | 0) + ($d439df1ba5a666a9$var$isHex[id.charCodeAt(i + 2)] | 0) + ($d439df1ba5a666a9$var$isHex[id.charCodeAt(i + 3)] | 0);
    return r === length;
}
function $d439df1ba5a666a9$export$29dd34cf1269f6da(traceId) {
    return $d439df1ba5a666a9$var$isValidHex(traceId, 32) && traceId !== (0, $1L9tl.INVALID_TRACEID);
}
function $d439df1ba5a666a9$export$8e51c6d8f0586aff(spanId) {
    return $d439df1ba5a666a9$var$isValidHex(spanId, 16) && spanId !== (0, $1L9tl.INVALID_SPANID);
}
function $d439df1ba5a666a9$export$e4373b9a2c09216c(spanContext) {
    return $d439df1ba5a666a9$export$29dd34cf1269f6da(spanContext.traceId) && $d439df1ba5a666a9$export$8e51c6d8f0586aff(spanContext.spanId);
}
function $d439df1ba5a666a9$export$c19cc0f1911bdb85(spanContext) {
    return new (0, $i8tx3.NonRecordingSpan)(spanContext);
}

});



parcelRegister("46FqL", function(module, exports) {
$parcel$export(module.exports, "NoopTracerProvider", () => $2fd7dc412726b7ed$export$87d8e93756f9e86e);
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $12tBY = parcelRequire("12tBY");
class $2fd7dc412726b7ed$export$87d8e93756f9e86e {
    getTracer(_name, _version, _options) {
        return new (0, $12tBY.NoopTracer)();
    }
}

});





parcelRegister("iQo1C", function(module, exports) {
$parcel$export(module.exports, "experienceTypeKey", () => $d2233ea5690d11e2$export$1069c2293742749e);

var $dCCNu = parcelRequire("dCCNu");
const $d2233ea5690d11e2$export$1069c2293742749e = (0, $dCCNu.createContextKey)('type');

});

parcelRegister("ky6Wv", function(module, exports) {
$parcel$export(module.exports, "spanIdKey", () => $5f174d69eeaaec83$export$ccdc89d1d45284c2);

var $dCCNu = parcelRequire("dCCNu");
const $5f174d69eeaaec83$export$ccdc89d1d45284c2 = (0, $dCCNu.createContextKey)('spanId');

});

parcelRegister("5GvaV", function(module, exports) {
$parcel$export(module.exports, "traceIdKey", () => $e09119ccbe1634d6$export$65f3d43d675bb81b);

var $dCCNu = parcelRequire("dCCNu");
const $e09119ccbe1634d6$export$65f3d43d675bb81b = (0, $dCCNu.createContextKey)('traceId');

});


parcelRegister("5CbDz", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b2509b0112247ac$export$2e2bcd8739ae039);
// The UFORouteName object is a global singleton
const $0b2509b0112247ac$var$UFORouteName = {
    current: null
};
var $0b2509b0112247ac$export$2e2bcd8739ae039 = $0b2509b0112247ac$var$UFORouteName;

});

parcelRegister("6NNNz", function(module, exports) {
$parcel$export(module.exports, "ensureSoftNavigationObserved", () => $cb97d65790b67ad7$export$e064a2fa755ff6f2);
$parcel$export(module.exports, "getSoftNavigationPaintMetrics", () => $cb97d65790b67ad7$export$e0d5520cde609f66);

var $haLaD = parcelRequire("haLaD");
const $cb97d65790b67ad7$var$MAX_TRACKED_SOFT_NAVIGATIONS = 20;
// A soft navigation's startTime is the interaction that triggered it, so it comes slightly before
// the UFO transition starts. Ignore soft navigations that started too long before the transition,
// as they most likely belong to an earlier navigation.
const $cb97d65790b67ad7$var$MAX_SOFT_NAVIGATION_LEAD_TIME = 1000;
// Only plain timestamps are kept, so long-lived sessions don't retain the painted DOM elements.
const $cb97d65790b67ad7$var$softNavigations = new (0, $haLaD.BufferWithMaxLength)($cb97d65790b67ad7$var$MAX_TRACKED_SOFT_NAVIGATIONS);
let $cb97d65790b67ad7$var$observer = null;
// Same check as web-vitals' checkSoftNavsEnabled (src/lib/softNavs.ts).
function $cb97d65790b67ad7$var$isSoftNavigationSupported() {
    return (globalThis.PerformanceObserver?.supportedEntryTypes?.includes('soft-navigation') ?? false) && // Older implementations expose the value as an attribute rather than the method. Only the
    // method shipped to stable.
    typeof globalThis.PerformanceSoftNavigation?.prototype?.getLargestInteractionContentfulPaint === 'function';
}
// Each contentful paint is larger than the one before, so the latest one is the LCP.
function $cb97d65790b67ad7$var$setLargestContentfulPaint(softNavigation, entry) {
    const paint = entry?.largestContentfulPaint;
    // `||` rather than `??` on purpose: renderTime is 0 when the browser withholds it (e.g. cross-origin
    // images without Timing-Allow-Origin), and no real paint here can happen at time 0.
    const paintTime = paint?.renderTime || paint?.loadTime;
    if (softNavigation !== undefined && paintTime) softNavigation.largestContentfulPaint = paintTime;
}
function $cb97d65790b67ad7$var$handleEntries(entries) {
    entries.forEach((entry)=>{
        if (entry.entryType === 'soft-navigation') {
            const softNavigationEntry = entry;
            const softNavigation = {
                interactionId: softNavigationEntry.interactionId,
                startTime: softNavigationEntry.startTime,
                // presentationTime is null where unsupported, and a paint after an interaction can't be at 0.
                firstContentfulPaint: softNavigationEntry.presentationTime || softNavigationEntry.paintTime || undefined
            };
            $cb97d65790b67ad7$var$softNavigations.push(softNavigation);
            // Paints for this interaction that happened before the soft navigation was detected.
            $cb97d65790b67ad7$var$setLargestContentfulPaint(softNavigation, softNavigationEntry.getLargestInteractionContentfulPaint?.());
        } else if (entry.entryType === 'interaction-contentful-paint') {
            // These are emitted for any interaction that paints, not only soft navigations, so only keep
            // the ones for a tracked soft navigation.
            const contentfulPaint = entry;
            $cb97d65790b67ad7$var$setLargestContentfulPaint($cb97d65790b67ad7$var$softNavigations.getAll().find((softNavigation)=>softNavigation.interactionId === contentfulPaint.interactionId), contentfulPaint);
        }
    });
}
function $cb97d65790b67ad7$var$findSoftNavigation(start) {
    return $cb97d65790b67ad7$var$softNavigations.getAll().reduce((match, softNavigation)=>{
        if (softNavigation.startTime <= start && softNavigation.startTime >= start - $cb97d65790b67ad7$var$MAX_SOFT_NAVIGATION_LEAD_TIME && (match === undefined || match.startTime < softNavigation.startTime)) return softNavigation;
        return match;
    }, undefined);
}
function $cb97d65790b67ad7$export$e064a2fa755ff6f2() {
    if ($cb97d65790b67ad7$var$observer !== null || !$cb97d65790b67ad7$var$isSoftNavigationSupported()) return;
    try {
        $cb97d65790b67ad7$var$observer = new PerformanceObserver((list)=>$cb97d65790b67ad7$var$handleEntries(list.getEntries()));
        $cb97d65790b67ad7$var$observer.observe({
            type: 'soft-navigation',
            buffered: true
        });
        if (PerformanceObserver.supportedEntryTypes.includes('interaction-contentful-paint')) $cb97d65790b67ad7$var$observer.observe({
            type: 'interaction-contentful-paint',
            buffered: true
        });
    } catch  {
        // A later observe() can throw after an earlier one succeeded, so stop the half-started observer
        // rather than leaving it filling the buffers while the next call starts another one.
        $cb97d65790b67ad7$var$observer?.disconnect();
        $cb97d65790b67ad7$var$observer = null;
    }
}
function $cb97d65790b67ad7$export$e0d5520cde609f66(start) {
    // UFO init runs before jira-spa installs its platform flag resolver, so fg() there skips Jira's
    // overrides (e.g. ?fg=) and can read the un-overridden value. Soft navigations only happen once
    // the page has loaded, and buffered entries replay the ones from before the observer started.
    $cb97d65790b67ad7$export$e064a2fa755ff6f2();
    if ($cb97d65790b67ad7$var$observer === null) return {};
    $cb97d65790b67ad7$var$handleEntries($cb97d65790b67ad7$var$observer.takeRecords());
    const softNavigation = $cb97d65790b67ad7$var$findSoftNavigation(start);
    if (softNavigation === undefined) return {};
    const metrics = {};
    if (softNavigation.firstContentfulPaint) metrics.fcp = Math.round(Math.max(softNavigation.firstContentfulPaint - start, 0));
    if (softNavigation.largestContentfulPaint) metrics.lcp = Math.round(Math.max(softNavigation.largestContentfulPaint - start, 0));
    return metrics;
}

});

parcelRegister("i8szI", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("0Jq5E"),
    $7mhPs("ftVoH")
]).then(()=>parcelRequire('8SCov'));

});

parcelRegister("fxxkW", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("0Jq5E"),
    $7mhPs("6l6jm")
]).then(()=>parcelRequire('biBOw'));

});

parcelRegister("1tuyH", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("jviTA").then(()=>parcelRequire('46i49'));

});

parcelRegister("4LTDv", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("2s0OZ").then(()=>parcelRequire('lGV9l'));

});

parcelRegister("54iU5", function(module, exports) {
$parcel$export(module.exports, "default", () => $033bc544096a6949$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Preserves the existing UUID implementation.

var $2BKzr = parcelRequire("2BKzr");

var $fskN5 = parcelRequire("fskN5");

var $5tITM = parcelRequire("5tITM");

var $5TRbo = parcelRequire("5TRbo");

var $eIO99 = parcelRequire("eIO99");

var $8OjRF = parcelRequire("8OjRF");

var $5CbDz = parcelRequire("5CbDz");

const $033bc544096a6949$export$8851ca06c4e629aa = 'awaiting_pageload_name';
function $033bc544096a6949$var$traceUFOPageLoad(ufoName, routeName = ufoName) {
    if (!(0, $5tITM.isUFOEnabled)()) return;
    const activeInteraction = (0, $8OjRF.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $5CbDz.default).current = routeName || null;
    const rate = ufoName ? (0, $5tITM.getInteractionRate)(ufoName, 'page_load') : 1;
    const enabledBySamplingRate = (0, $fskN5.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const newId = (0, $2BKzr.default)();
        (0, $eIO99.default).current = newId;
        (0, $8OjRF.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $5TRbo.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $8OjRF.addHoldByID)(newId, [], $033bc544096a6949$export$8851ca06c4e629aa, $033bc544096a6949$export$8851ca06c4e629aa, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $8OjRF.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $8OjRF.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $8OjRF.removeHoldByID)(activeInteraction.id, $033bc544096a6949$export$8851ca06c4e629aa);
    }
}
var $033bc544096a6949$export$2e2bcd8739ae039 = $033bc544096a6949$var$traceUFOPageLoad;

});


var $1apN2 = parcelRequire("1apN2");
parcelRequire("fjjed");
var $6AigK = parcelRequire("6AigK");
parcelRequire("JEkkv");
var $1qaWF = parcelRequire("1qaWF");
var $fYUfs = parcelRequire("fYUfs");

var $1mdNz = parcelRequire("1mdNz");

var $hYbv2 = parcelRequire("hYbv2");
/**
 * Inits the React SDK
 */ function $d45605c22e84ef75$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $hYbv2.applySdkMetadata)(opts, 'react');
    (0, $1mdNz.init)(opts);
}



var $4okYx = parcelRequire("4okYx");



var $fjzd2 = parcelRequire("fjzd2");

var $gtUgB = parcelRequire("gtUgB");
parcelRequire("8oX5A");
var $5CgYT = parcelRequire("5CgYT");
var $gfvRq = parcelRequire("gfvRq");
parcelRequire("JEkkv");
var $1qaWF = parcelRequire("1qaWF");
var $fYUfs = parcelRequire("fYUfs");

var $8YStQ = parcelRequire("8YStQ");
parcelRequire("j5h4D");
var $kNelK = parcelRequire("kNelK");

var $1v5pe = parcelRequire("1v5pe");

var $jEbac = parcelRequire("jEbac");

var $cWkcy = parcelRequire("cWkcy");

var $fjzd2 = parcelRequire("fjzd2");

var $gtUgB = parcelRequire("gtUgB");
parcelRequire("fjjed");
var $eajEV = parcelRequire("eajEV");
parcelRequire("8oX5A");
var $e60FT = parcelRequire("e60FT");

var $8YStQ = parcelRequire("8YStQ");
parcelRequire("j5h4D");
var $2xoF5 = parcelRequire("2xoF5");

var $gtUgB = parcelRequire("gtUgB");
parcelRequire("fjjed");
var $eajEV = parcelRequire("eajEV");

var $8YStQ = parcelRequire("8YStQ");

var $cWkcy = parcelRequire("cWkcy");
parcelRequire("8oX5A");
var $e60FT = parcelRequire("e60FT");

var $1v5pe = parcelRequire("1v5pe");

var $cZ6aD = parcelRequire("cZ6aD");
/*
Except the below locales, Traduki will return short locale.json files
   rewriteLocales:
      en-GB: en-GB
      en-US: en-US
      en-ZZ: en-ZZ
      pt-PT: pt-PT
      pt-BR: pt-BR
      zh-CN: zh-CN
      zh-TW: zh-TW
*/ // Enable this once Traduki starts returning short locale files


























const $ffcff2bc90456ab3$var$getLocaleFileFromShortLocale = (locale)=>{
    switch(locale){
        case 'cs':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("4hS6l"));
        case 'da':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("gUWrs"));
        case 'de':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("fQd9o"));
        case 'en':
        case 'en-us':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("5hF01"));
        case 'en-gb':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("4iFay"));
        case 'es':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("3yWwv"));
        case 'fi':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("adQD0"));
        case 'fr':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("bkUZb"));
        case 'hr':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("ihdge"));
        case 'hu':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("9uDA5"));
        case 'it':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("cFRr7"));
        case 'ja':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("2B22r"));
        case 'ko':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("kQSDn"));
        case 'nb':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("6zSYs"));
        case 'nl':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("dnt5F"));
        case 'pl':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("kqDq2"));
        case 'pt-br':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("aFX2k"));
        case 'ru':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("jh5HN"));
        case 'sk':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("5hF01"));
        case 'sv':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("4iAsx"));
        case 'th':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("kFMzS"));
        case 'tr':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("3313C"));
        case 'uk':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("Vkq0T"));
        case 'vi':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("et9F7"));
        case 'zh-cn':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("2ep82"));
        case 'zh-tw':
            // @ts-expect-error dynamic import somehow doesn't infer its type correctly
            return (parcelRequire("iDF7y"));
        default:
            console.warn(`No translation file found for locale: ${locale}. Falling back to the default locale (en-US).`);
            return undefined;
    }
};
const $ffcff2bc90456ab3$export$d0a3169680473b6c = async (lowerCasedLocale)=>{
    // This dynamic import approach doesn't work with Parcel, so we use a switch statement instead.
    // Please fix this if you find a way to make it work with Parcel, since this solution could be fragile when translation language scales.
    // try {
    // 	return await import(`./${lowerCasedLocale}.json`);
    // } catch (e1) {
    // 	console.warn(
    // 		`No translation file found for locale file: ${lowerCasedLocale}.json. Falling back to rule-based imports.`,
    // 	);
    // }
    return $ffcff2bc90456ab3$var$getLocaleFileFromShortLocale(lowerCasedLocale);
};



var $kIqwl = parcelRequire("kIqwl");

var $k1Wvt = parcelRequire("k1Wvt");
const $137f55099ce95f20$export$c2518934dd564e83 = ({ children: children })=>{
    const [messages, setMessages] = (0, $1v5pe.useState)(undefined);
    const { user: { locale: locale } } = (0, $e60FT.useAuthData)();
    (0, $1v5pe.useEffect)(()=>{
        const loadMessages = async ()=>{
            try {
                const translatedMessages = await (0, $ffcff2bc90456ab3$export$d0a3169680473b6c)((locale ?? 'en-us').toLowerCase());
                setMessages(translatedMessages);
            } catch (e) {
                console.error(`Failed to load messages for locale ${locale}. Falling back to default:`, e);
                setMessages(undefined);
            }
        };
        loadMessages();
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cZ6aD.default), {
        locale: locale ?? 'en-US',
        messages: messages || undefined,
        onError: (err)=>{
            // Do not spam local devloop with missing translation errors
            //
            // See: https://github.com/formatjs/formatjs/issues/465#issuecomment-643887472
            // Note the default error handler: https://github.com/formatjs/formatjs/blob/d0b80fd9a814d1427b73577aebb7ccdb80b9ae94/packages/intl/src/utils.ts#L43
            if ($k1Wvt?.env?.NODE_ENV !== 'production' && err?.code !== 'MISSING_TRANSLATION') // eslint-disable-next-line no-console
            console.error(err);
        },
        children: children
    });
};



var $1v5pe = parcelRequire("1v5pe");

var $ja864 = parcelRequire("ja864");

var $bHcZt = parcelRequire("bHcZt");

var $2aEiL = parcelRequire("2aEiL");

var $bEUFb = parcelRequire("bEUFb");

var $1v5pe = parcelRequire("1v5pe");

var $lJYzG = parcelRequire("lJYzG");
var $kK7WO = parcelRequire("kK7WO");

var $bHcZt = parcelRequire("bHcZt");

var $dNZ1k = parcelRequire("dNZ1k");

var $4saCT = parcelRequire("4saCT");

var $8sBGu = parcelRequire("8sBGu");

var $7uhky = parcelRequire("7uhky");

var $cc5qg = parcelRequire("cc5qg");

var $2aEiL = parcelRequire("2aEiL");

var $2W5OM = parcelRequire("2W5OM");

var $40Sn3 = parcelRequire("40Sn3");

var $2aEiL = parcelRequire("2aEiL");

var $5ndys = parcelRequire("5ndys");

var $fqfOD = parcelRequire("fqfOD");

var $jeHvL = parcelRequire("jeHvL");

var $2aEiL = parcelRequire("2aEiL");

var $jeHvL = parcelRequire("jeHvL");

var $dS1lP = parcelRequire("dS1lP");
const $ae95425a4d75d2eb$export$43a35c1452d55dd7 = ()=>{
    if (!(0, $dS1lP.isSSR)()) return true;
    return (0, $jeHvL.__internalGetResolvedFlatPatternFileFormat)() ?? (0, $2aEiL.fg)('platform_bsc_ssr_flat_pattern_file_format');
};
const $ae95425a4d75d2eb$export$711aafe8a89fd09c = (value)=>{
    (0, $jeHvL.__internalSetResolvedFlatPatternFileFormat)(value);
};
const $ae95425a4d75d2eb$export$38a9c01091046388 = ()=>{
    const decided = (0, $jeHvL.__internalGetPatternFormat)();
    if (decided) return decided;
    const patternFormat = $ae95425a4d75d2eb$export$43a35c1452d55dd7() ? 'flat' : 'trie';
    (0, $jeHvL.__internalSetPatternFormat)(patternFormat);
    return patternFormat;
};



var $bEUFb = parcelRequire("bEUFb");

var $2W5OM = parcelRequire("2W5OM");

var $560c29f7f06e7acf$export$40467b362aa82ae = /*#__PURE__*/ function(Sources) {
    Sources["BIFROST"] = "bifrost";
    Sources["CLOUDFRONT_S3"] = "cloudfrontS3";
    return Sources;
}({});
var $560c29f7f06e7acf$export$c5ae10d7c88c4d3e = /*#__PURE__*/ function(FileType) {
    FileType["COOKIE"] = "COOKIE";
    FileType["LOCAL_STORAGE"] = "LOCAL_STORAGE";
    FileType["SESSION_STORAGE"] = "SESSION_STORAGE";
    FileType["INDEXED_DB"] = "INDEXED_DB";
    return FileType;
}({});
const $560c29f7f06e7acf$var$baseBifrostCommercialPath = 'https://atlassian-cookies.prod-east.frontend.public.atl-paas.net/';
const $560c29f7f06e7acf$var$baseBifrostFedrampPath = 'https://atlassian-cookies.frontend.cdn.atlassian-us-gov-mod.com/';
const $560c29f7f06e7acf$var$generateResourcePath = (perimeter, storageType, useFlatFormat = false)=>{
    const fileName = useFlatFormat ? `categories_v2_${storageType}.json` : `categories_${storageType}.json`;
    switch(perimeter){
        case 'fedramp-moderate':
            return `${$560c29f7f06e7acf$var$baseBifrostFedrampPath}${fileName}`;
        case 'commercial':
            return `${$560c29f7f06e7acf$var$baseBifrostCommercialPath}${fileName}`;
        default:
            return `${$560c29f7f06e7acf$var$baseBifrostCommercialPath}${fileName}`;
    }
};
const $560c29f7f06e7acf$export$5989415260e0cf82 = (useFlatFormat = false)=>{
    return {
        [(0, $2W5OM.CategoryStorageType).Cookies]: $560c29f7f06e7acf$var$generateResourcePath('commercial', "COOKIE", useFlatFormat),
        [(0, $2W5OM.CategoryStorageType).LocalStorage]: $560c29f7f06e7acf$var$generateResourcePath('commercial', "LOCAL_STORAGE", useFlatFormat),
        [(0, $2W5OM.CategoryStorageType).SessionStorage]: $560c29f7f06e7acf$var$generateResourcePath('commercial', "SESSION_STORAGE", useFlatFormat),
        [(0, $2W5OM.CategoryStorageType).IndexedDB]: $560c29f7f06e7acf$var$generateResourcePath('commercial', "INDEXED_DB", useFlatFormat)
    };
};
const $560c29f7f06e7acf$export$9797a362f9385b1a = (useFlatFormat = false)=>{
    return {
        commercial: $560c29f7f06e7acf$export$5989415260e0cf82(useFlatFormat),
        'fedramp-moderate': {
            [(0, $2W5OM.CategoryStorageType).Cookies]: $560c29f7f06e7acf$var$generateResourcePath('fedramp-moderate', "COOKIE", useFlatFormat),
            [(0, $2W5OM.CategoryStorageType).LocalStorage]: $560c29f7f06e7acf$var$generateResourcePath('fedramp-moderate', "LOCAL_STORAGE", useFlatFormat),
            [(0, $2W5OM.CategoryStorageType).SessionStorage]: $560c29f7f06e7acf$var$generateResourcePath('fedramp-moderate', "SESSION_STORAGE", useFlatFormat),
            [(0, $2W5OM.CategoryStorageType).IndexedDB]: $560c29f7f06e7acf$var$generateResourcePath('fedramp-moderate', "INDEXED_DB", useFlatFormat)
        }
    };
};
const $560c29f7f06e7acf$export$1f60178895e28eb8 = (source, perimeter, storageType, UNSAFE__resolvedFlatPatternFileFormat)=>{
    if (UNSAFE__resolvedFlatPatternFileFormat !== undefined) (0, $ae95425a4d75d2eb$export$711aafe8a89fd09c)(UNSAFE__resolvedFlatPatternFileFormat);
    return $560c29f7f06e7acf$var$generateResourcePath(perimeter, storageType, (0, $ae95425a4d75d2eb$export$38a9c01091046388)() === 'flat');
};


class $2c756d3d602be1a8$export$e479342c697b82a9 {
    cacheUrl;
    /**
   * The format of the file `cacheUrl` points at — the layout this process decided to fetch. Read from
   * that single decision rather than passed in, so the URL and the format recorded on the fetched
   * payload cannot come from different gate evaluations.
   *
   * TEMPORARY: Will be removed when `platform_bsc_ssr_flat_pattern_file_format` is cleaned up.
   */ fetchedPatternFormat;
    /**
   * Cache variable for storing categorized cookies cache
   */ localResponseCache;
    /**
   * Cache variable for storing a promise that's been fired by a different invocation of loadStorageControls
   *
   * Allows for many invocations to happen simultaneously, and for only one fetch to go out
   */ localResponsePromiseCache;
    /**
   * Cache variable for storing the promise returned from the response object's json method
   *
   * Ensures we don't invoke response.json multiple times
   */ localResponseJsonPromiseCache;
    constructor(storageType, perimeter){
        // Asked for, not passed in: whoever constructs a loader gets the layout this process already
        // decided to fetch, so no caller can hand it a format that disagrees with everyone else's.
        this.fetchedPatternFormat = (0, $ae95425a4d75d2eb$export$38a9c01091046388)();
        // Auto-detect perimeter from the Atl-Ctx-Perimeter cookie when not explicitly provided.
        // isFedrampModerate() reads the cookie set by the platform; if absent, the perimeter is commercial.
        // Gated by platform_bsc_auto_detect_perimeter for safe rollout.
        // Wrapped in try/catch to ensure a cookie-read failure never breaks BSC initialisation.
        const detectPerimeter = ()=>{
            try {
                return (0, $40Sn3.isFedrampModerate)() ? 'fedramp-moderate' : 'commercial';
            } catch (e) {
                (0, $bEUFb.Logger).errorWithOperationalEvent({
                    action: 'detectPerimeterError',
                    message: e?.message || 'Failed to detect perimeter via isFedrampModerate'
                });
                return 'commercial';
            }
        };
        const resolvedPerimeter = perimeter ?? ((0, $2aEiL.fg)('platform_bsc_auto_detect_perimeter') ? detectPerimeter() : 'commercial');
        const useFlatFormat = this.fetchedPatternFormat === 'flat';
        const cacheUrlLookup = (0, $560c29f7f06e7acf$export$9797a362f9385b1a)(useFlatFormat)[resolvedPerimeter] || (0, $560c29f7f06e7acf$export$5989415260e0cf82)(useFlatFormat);
        this.cacheUrl = cacheUrlLookup[storageType];
    }
    clearStorageControlsDataCache() {
        this.localResponseCache = undefined;
        this.localResponsePromiseCache = undefined;
        this.localResponseJsonPromiseCache = undefined;
    }
    /**
   * Unpacks the response promise from the categories CDN
   *
   * errors if that request was unsuccessful, returns the categories data otherwise
   *
   */ async handleCategoriesResponse(responsePromise) {
        if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
        const response = await responsePromise;
        if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
        // Checks if we've already fired the response.json() promise
        this.localResponseJsonPromiseCache = this.localResponseJsonPromiseCache || response?.json();
        return this.localResponseJsonPromiseCache;
    }
    getStorageControlsDataFromCache() {
        return this.localResponseCache;
    }
    /**
   * The format of the file this loader fetches.
  	* TEMPORARY: Will be removed when `platform_bsc_ssr_flat_pattern_file_format` is cleaned up.
   */ getFetchedPatternFormat() {
        return this.fetchedPatternFormat;
    }
    async loadStorageControlsData() {
        const isFetchTrackingSampled = !Math.floor(Math.random() * 100);
        let fetchExperience = null;
        if (isFetchTrackingSampled) {
            fetchExperience = new (0, $5ndys.UFOExperience)('browser-storage-controls-fetch-time', {
                type: (0, $fqfOD.ExperienceTypes).Load,
                performanceType: (0, $fqfOD.ExperiencePerformanceTypes).Custom,
                platform: {
                    component: 'browser-storage-controls'
                }
            });
            fetchExperience.start();
        }
        if (this.localResponseCache) {
            if (fetchExperience) fetchExperience.success();
            return this.localResponseCache;
        } else // Always use Prod CDN for prod/local/dev/staging environments, but stub the route for automation tests
        try {
            if (!this.localResponsePromiseCache) {
                (0, $bEUFb.Logger).debug(`Loading cache ${this.cacheUrl}`);
                // invoke CDN and cache the promise
                this.localResponsePromiseCache = fetch(this.cacheUrl);
            }
            // unpack response
            this.localResponseCache = await this.handleCategoriesResponse(this.localResponsePromiseCache);
            // Record what we actually fetched, so pattern matching never has to re-evaluate the
            // rollout gate to work out how to read it. clearStorageControlsDataCache() drops the
            // payload, so a re-fetch re-records from that loader's own format. A malformed response
            // can parse to a primitive, which cannot carry the field — those fall back to the legacy
            // trie reading, and match nothing either way.
            if (typeof this.localResponseCache === 'object' && this.localResponseCache !== null) this.localResponseCache.patternFormat = this.fetchedPatternFormat;
            (0, $jeHvL.__internalSetCacheLoadedDate)(new Date().toISOString().slice(0, 10));
            // Extract and store CDN file version (write-once: first loader to resolve wins)
            if (typeof this.localResponseCache === 'object' && this.localResponseCache !== null && this.localResponseCache.version) (0, $jeHvL.__internalSetCdnFileVersion)(this.localResponseCache.version);
            if (fetchExperience) fetchExperience.success();
            return this.localResponseCache;
        } catch (e) {
            if (fetchExperience) fetchExperience.failure({
                metadata: {
                    error: String(e)
                }
            });
            (0, $bEUFb.Logger).errorWithOperationalEvent({
                action: 'loadStorageControlsError',
                message: e.message || ''
            });
            this.clearStorageControlsDataCache();
        }
    }
}



var $bEUFb = parcelRequire("bEUFb");

var $bwJVB = parcelRequire("bwJVB");

var $jeHvL = parcelRequire("jeHvL");
const $751de4a961087994$export$882c4530c58781d8 = ({ webStorageEnabled: webStorageEnabled, indexedDbEnabled: indexedDbEnabled, disableWebStorageConsentChecks: disableWebStorageConsentChecks, packageLogLevel: packageLogLevel, allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides, allowUncategorizedItemsInIndexedDBOverrides: allowUncategorizedItemsInIndexedDBOverrides, disableIndexedDbConsentChecks: disableIndexedDbConsentChecks, localConsentMode: localConsentMode = false, product: product = 'all', perimeter: perimeter, analyticsEnabled: analyticsEnabled = true, userId: userId, cloudId: cloudId, overrideOnceParams: overrideOnceParams = false } = {})=>{
    (0, $bEUFb.Logger).debug('Initialize global state invoked');
    const productGlobalState = (0, $jeHvL.__internalGetProductGlobalState)();
    // If the app provides a value for product only in one place,
    // we want that value to be sticky and to override the default if necessary
    if ((!productGlobalState || productGlobalState == null || productGlobalState === 'all') && product) (0, $jeHvL.__internalApplyInitialState)({
        productGlobalState: product
    });
    // Treating webStorageEnabled, indexedDbEnabled, and allowUncategorizedCookiesInOverrides differently
    // because they are only passed through initializeControls and
    // we don't want it to be defaulted to false via a call from the ConsentBanner
    const webStorageControlsEnabledGlobalState = (0, $jeHvL.__internalGetWebStorageControlsEnabledGlobalState)();
    if (webStorageEnabled !== undefined && webStorageControlsEnabledGlobalState === undefined) (0, $jeHvL.__internalApplyInitialState)({
        webStorageControlsEnabledGlobalState: webStorageEnabled && !(0, $2aEiL.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $2aEiL.fg)('platform_moonjelly_bsc_web_storage_killswitch')
    });
    const indexedDbControlsEnabledGlobalState = (0, $jeHvL.__internalGetIndexedDbControlsEnabledGlobalState)();
    if (indexedDbEnabled !== undefined && indexedDbControlsEnabledGlobalState === undefined) (0, $jeHvL.__internalApplyInitialState)({
        indexedDbControlsEnabledGlobalState: indexedDbEnabled && !(0, $2aEiL.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $2aEiL.fg)('platform_moonjelly_bsc_web_storage_killswitch')
    });
    // `disableWebStorageConsentChecks` is sticky like the other controls flags above and
    // mirrors the behaviour of `disableIndexedDbConsentChecks`. When the caller does not
    // explicitly pass a value, the global state is left undefined and the public getter
    // (`getBscGlobalState`) reports `false` by default. It only takes effect when the
    // matching `webStorageEnabled` is `true` — see the consumer in `initializeControls`.
    const disableWebStorageConsentChecksGlobalState = (0, $jeHvL.__internalGetDisableWebStorageConsentChecksGlobalState)();
    if (disableWebStorageConsentChecks !== undefined && disableWebStorageConsentChecksGlobalState === undefined) (0, $jeHvL.__internalApplyInitialState)({
        disableWebStorageConsentChecksGlobalState: disableWebStorageConsentChecks
    });
    const allowUncategorizedCookiesInOverridesGlobalState = (0, $jeHvL.__internalGetAllowUncategorizedCookiesInOverridesGlobalState)();
    if (allowUncategorizedCookiesInOverrides !== undefined && allowUncategorizedCookiesInOverridesGlobalState === undefined) (0, $jeHvL.__internalApplyInitialState)({
        allowUncategorizedCookiesInOverridesGlobalState: allowUncategorizedCookiesInOverrides
    });
    // `allowUncategorizedItemsInWebStorageOverrides` is the web-storage-only counterpart to
    // `allowUncategorizedCookiesInOverrides`. It is sticky in the same way, and only takes
    // effect when web-storage controls are enabled. It does not affect cookies.
    const allowUncategorizedItemsInWebStorageOverridesGlobalState = (0, $jeHvL.__internalGetAllowUncategorizedItemsInWebStorageOverridesGlobalState)();
    if (allowUncategorizedItemsInWebStorageOverrides !== undefined && allowUncategorizedItemsInWebStorageOverridesGlobalState === undefined) (0, $jeHvL.__internalApplyInitialState)({
        allowUncategorizedItemsInWebStorageOverridesGlobalState: allowUncategorizedItemsInWebStorageOverrides
    });
    // `allowUncategorizedItemsInIndexedDBOverrides` is the IDB-only counterpart to
    // `allowUncategorizedItemsInWebStorageOverrides`. It is sticky in the same way, and only
    // takes effect when IndexedDB controls are enabled. It does not affect cookies or web storage.
    const allowUncategorizedItemsInIndexedDBOverridesGlobalState = (0, $jeHvL.__internalGetAllowUncategorizedItemsInIndexedDBOverridesGlobalState)();
    if (allowUncategorizedItemsInIndexedDBOverrides !== undefined && allowUncategorizedItemsInIndexedDBOverridesGlobalState === undefined) (0, $jeHvL.__internalApplyInitialState)({
        allowUncategorizedItemsInIndexedDBOverridesGlobalState: allowUncategorizedItemsInIndexedDBOverrides
    });
    const disableIndexedDbConsentChecksGlobalState = (0, $jeHvL.__internalGetDisableIndexedDbConsentChecksGlobalState)();
    if (disableIndexedDbConsentChecks !== undefined && disableIndexedDbConsentChecksGlobalState === undefined) (0, $jeHvL.__internalApplyInitialState)({
        disableIndexedDbConsentChecksGlobalState: disableIndexedDbConsentChecks
    });
    // All other state can only be initialized once and is defaulted if not passed on the first initialization.
    // overrideOnceParams allows a subsequent call (e.g. from initializeControls) to bypass this guard
    // and re-apply these parameters, correcting values that were defaulted by an earlier accidental call
    // (e.g. from ConsentBannerImpl before initializeControls has run).
    if ((0, $jeHvL.__internalGetHasInitialized)() && !overrideOnceParams) return;
    // Force local consent mode when ConsentHub is not enabled because ConsentHub is
    // not hydrated in the perimeter as of this comment
    const localConsentModeGlobalState = localConsentMode || !(0, $cc5qg.isFeatureEnabled)('consent-platform', 'consenthub');
    const cookiesCacheLoader = new (0, $2c756d3d602be1a8$export$e479342c697b82a9)((0, $2W5OM.CategoryStorageType).Cookies, perimeter);
    const localStorageCacheLoader = new (0, $2c756d3d602be1a8$export$e479342c697b82a9)((0, $2W5OM.CategoryStorageType).LocalStorage, perimeter);
    const sessionStorageCacheLoader = new (0, $2c756d3d602be1a8$export$e479342c697b82a9)((0, $2W5OM.CategoryStorageType).SessionStorage, perimeter);
    const indexedDBCacheLoader = new (0, $2c756d3d602be1a8$export$e479342c697b82a9)((0, $2W5OM.CategoryStorageType).IndexedDB, perimeter);
    const updates = {
        localConsentModeGlobalState: localConsentModeGlobalState,
        analyticsEnabledGlobalState: analyticsEnabled,
        perimeterGlobalState: perimeter,
        cookiesCacheLoader: cookiesCacheLoader,
        localStorageCacheLoader: localStorageCacheLoader,
        sessionStorageCacheLoader: sessionStorageCacheLoader,
        indexedDBCacheLoader: indexedDBCacheLoader,
        packageLogLevelGlobalState: packageLogLevel,
        hasInitialized: true
    };
    if (cloudId) updates.cloudIdGlobalState = cloudId;
    if (userId) updates.userIdGlobalState = userId;
    (0, $jeHvL.__internalApplyInitialState)(updates);
    // Invalidate the resolved Logger level so any callers that triggered an
    // early `Logger.*` call before init pick up the new `packageLogLevel`.
    (0, $bwJVB.resetLogLevelCache)();
};


var $7WT4C = parcelRequire("7WT4C");
parcelRequire("1v5pe");

var $7EVvM = parcelRequire("7EVvM");

var $gVdmf = parcelRequire("gVdmf");
var $gVdmf = parcelRequire("gVdmf");




























const $06c5662aff3a78a3$var$locales = {
    cs: ()=>(parcelRequire("fWVN4")),
    da: ()=>(parcelRequire("ietv1")),
    de: ()=>(parcelRequire("cemEO")),
    'en-GB': ()=>(parcelRequire("4JSOu")),
    'en-ZZ': ()=>(parcelRequire("dh7Ku")),
    en: ()=>Promise.resolve((parcelRequire("gVdmf"))),
    es: ()=>(parcelRequire("kXKTS")),
    fi: ()=>(parcelRequire("diwhy")),
    fr: ()=>(parcelRequire("gV7na")),
    hu: ()=>(parcelRequire("5tP7S")),
    it: ()=>(parcelRequire("2AY7t")),
    ja: ()=>(parcelRequire("87iqv")),
    ko: ()=>(parcelRequire("32oA8")),
    nb: ()=>(parcelRequire("5kASx")),
    nl: ()=>(parcelRequire("5n6wX")),
    pl: ()=>(parcelRequire("dc2ke")),
    'pt-BR': ()=>(parcelRequire("jIhs6")),
    ru: ()=>(parcelRequire("8UhbH")),
    sl: ()=>(parcelRequire("2DZYs")),
    sr_RS: ()=>(parcelRequire("boS4K")),
    sr_YR: ()=>(parcelRequire("e6bmU")),
    sv: ()=>(parcelRequire("jTrm6")),
    th: ()=>(parcelRequire("eBcB7")),
    tr: ()=>(parcelRequire("7tOgO")),
    uk: ()=>(parcelRequire("4dAcI")),
    vi: ()=>(parcelRequire("k3I0K")),
    zh_TW: ()=>(parcelRequire("1yaAJ")),
    zh: ()=>(parcelRequire("dUEzh"))
};
const $06c5662aff3a78a3$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const messages = await $06c5662aff3a78a3$var$locales[locale]();
        return messages.default;
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await $06c5662aff3a78a3$var$locales[parentLocale]();
        return messages.default;
    } catch (e) {
    // ignore
    }
};



var $kIqwl = parcelRequire("kIqwl");
const $c92052f02b4f1e2c$export$9aa38aed134c207f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $7EVvM.default), {
        defaultMessages: (0, $gVdmf.default),
        loaderFn: (0, $06c5662aff3a78a3$export$2b153a2030b0feb2),
        children: children
    });
};



var $bEUFb = parcelRequire("bEUFb");

var $3yjSR = parcelRequire("3yjSR");

var $6yOvq = parcelRequire("6yOvq");

var $2aEiL = parcelRequire("2aEiL");

var $7WT4C = parcelRequire("7WT4C");

var $bEUFb = parcelRequire("bEUFb");
const $2dfafd1edeed1471$export$b43e45590305ffaa = (key, attributes)=>{
    if ((0, $2aEiL.fg)('platform_moonjelly_bsc_master_killswitch')) // Delete the cookie without package operational events
    // when master killswitch is enabled
    (0, $6yOvq.default).remove(key, attributes);
    else try {
        (0, $7WT4C.sendPackageOperationalEvent)({
            action: 'usedDeleteCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, $6yOvq.default).remove(key, attributes);
    } catch (e) {
        (0, $bEUFb.Logger).errorWithOperationalEvent({
            action: 'usedDeleteCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use delete cookie. ${e.message || ''}`
        });
        throw e;
    }
};


var $dbJ6U = parcelRequire("dbJ6U");

var $jeHvL = parcelRequire("jeHvL");

var $3yjSR = parcelRequire("3yjSR");

var $2W5OM = parcelRequire("2W5OM");

var $bEUFb = parcelRequire("bEUFb");

var $37e9E = parcelRequire("37e9E");

var $9e4p2 = parcelRequire("9e4p2");

var $2W5OM = parcelRequire("2W5OM");

var $3za5i = parcelRequire("3za5i");

var $hJye1 = parcelRequire("hJye1");

var $3yjSR = parcelRequire("3yjSR");

var $2W5OM = parcelRequire("2W5OM");

var $dbJ6U = parcelRequire("dbJ6U");

var $3za5i = parcelRequire("3za5i");

var $hJye1 = parcelRequire("hJye1");
const $9969f6229a98cbaa$var$pruneLegacyProperties = (updatedPreferences)=>{
    // Strips any possible V002/legacy properties from the preferences by excluding everything but the core prefs
    return {
        [(0, $2W5OM.PreferenceCategory).StrictlyNecessary]: updatedPreferences[(0, $2W5OM.PreferenceCategory).StrictlyNecessary],
        [(0, $2W5OM.PreferenceCategory).Functional]: updatedPreferences[(0, $2W5OM.PreferenceCategory).Functional],
        [(0, $2W5OM.PreferenceCategory).Analytics]: updatedPreferences[(0, $2W5OM.PreferenceCategory).Analytics],
        [(0, $2W5OM.PreferenceCategory).Marketing]: updatedPreferences[(0, $2W5OM.PreferenceCategory).Marketing],
        [(0, $2W5OM.PreferenceCategory).Unknown]: updatedPreferences[(0, $2W5OM.PreferenceCategory).Unknown]
    };
};
const $9969f6229a98cbaa$var$setContextualConsentProperties = (consentPreferences, usingPrefetchedData)=>{
    // When merging during this phase, retain the "unauthed/authed" context of the preferences
    const existingUserAuthenticatedState = consentPreferences?.[(0, $2W5OM.ContextualConsentProperty).UserIsAuthenticated];
    const existingConsentHubUnavailableState = !!consentPreferences?.[(0, $2W5OM.ContextualConsentProperty).ConsentDataUnavailable];
    // When processing a legacy token, UserIsAuthenticated will be missing, so we need to backfill it with context from ConsentHubUnavailable
    const existingOrBackfilledAuthState = existingUserAuthenticatedState === undefined ? !existingConsentHubUnavailableState : existingUserAuthenticatedState;
    // Overwriting this flag while merging here gets us into a situation where a prefetched/cached, default cookie is just being set in the system,
    // but we mark the consents as "genuine", when they haven't actually been saved.
    // Doing this would have negative downstream effects, as we invoke logic dependent on if a token is a default or not
    const existingDefaultState = !!consentPreferences?.[(0, $2W5OM.ContextualConsentProperty).ConsentsAreDefault];
    const consentsAreDefault = usingPrefetchedData ? existingDefaultState : false;
    return {
        [(0, $2W5OM.ContextualConsentProperty).ConsentsAreDefault]: consentsAreDefault,
        [(0, $2W5OM.ContextualConsentProperty).UserIsAuthenticated]: existingOrBackfilledAuthState,
        [(0, $2W5OM.ContextualConsentProperty).ConsentDataUnavailable]: existingConsentHubUnavailableState
    };
};
const $9969f6229a98cbaa$export$c0214a364df3006f = (updatedPreferences, usingPrefetchedData)=>{
    // DEFAULT_PREFERENCES now gives us "CH unavailable" and "is default" bits
    const existingPrefs = (0, $dbJ6U.getCookie)((0, $3yjSR.ATLASSIAN_CONSENT_COOKIE_KEY));
    if (existingPrefs) {
        // Unpacking a V2 should now result in a V3 token anyway, but ensure we have proper bits
        const unpackedExistingPrefs = (0, $hJye1.unpackUserPreferencesCookie)(existingPrefs);
        // Capture any missed options (shouldn't have any if we have existing consent token), and
        // ensure we write the bit dictating that these consents are no longer defaults since they're being saved
        if (unpackedExistingPrefs) return {
            ...(0, $3yjSR.DEFAULT_PREFERENCES),
            ...unpackedExistingPrefs,
            ...$9969f6229a98cbaa$var$pruneLegacyProperties(updatedPreferences),
            ...$9969f6229a98cbaa$var$setContextualConsentProperties(unpackedExistingPrefs, usingPrefetchedData)
        };
        return {
            ...(0, $3yjSR.DEFAULT_PREFERENCES),
            ...$9969f6229a98cbaa$var$pruneLegacyProperties(updatedPreferences)
        };
    }
    // If we don't have existing prefs, this is likely a first time save for this domain
    // Ensure we note this is a successful, genuine set of prefs by updating the contextual properties as needed
    return {
        ...(0, $3yjSR.DEFAULT_PREFERENCES),
        ...$9969f6229a98cbaa$var$pruneLegacyProperties(updatedPreferences),
        ...$9969f6229a98cbaa$var$setContextualConsentProperties(updatedPreferences, usingPrefetchedData)
    };
};
const $9969f6229a98cbaa$export$a023a0b818522757 = (consentToken)=>{
    // Diff the token we're trying to set vs. any existing fallback, and only set a new fallback if the value has changed.
    // A difference would mean the user made a change since their original fallback was stored and we should update.
    // Otherwise, we would be unintentionally overriding the "1 year" expiration date the fallback token tracks.
    const existingFallbackToken = (0, $dbJ6U.getCookie)((0, $3yjSR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const tokenDiffersFromOldFallback = existingFallbackToken !== consentToken;
    if (!existingFallbackToken || tokenDiffersFromOldFallback) (0, $3za5i.setConsentTokenFallbackCookie)(consentToken);
};


const $dc55a943bed32c59$export$c8a8f3474b56fa5f = (mergedPrefs, usingPrefetchedData)=>{
    // If platform_moonjelly_bsc_fallback_token_audit feature gate is on,
    // use new fallback consent token logic
    // On a successful save, transform the prefs object into a formatted consentToken bit string
    // Then store the new token in a 10min-expiry consent cookie and a 1yr-expiry fallback cookie
    const consentToken = (0, $hJye1.packUserPreferences)(mergedPrefs);
    // Check if the token is prefetched and set to default.
    if (usingPrefetchedData && (0, $9e4p2.checkIfTokenIsDefault)(consentToken)) return;
    if (usingPrefetchedData) (0, $9969f6229a98cbaa$export$a023a0b818522757)(consentToken);
    else (0, $3za5i.setConsentTokenFallbackCookie)(consentToken);
    (0, $3za5i.setConsentTokenCookie)(consentToken);
    (0, $3za5i.setShouldShowBannerCookie)(consentToken);
};
const $dc55a943bed32c59$export$2c4e14a9e4d984da = (err, mergedPrefs)=>{
    const errorDueToUnauthenticatedRequest = err instanceof (0, $9e4p2.StatusCodeError) && err.status === 401;
    const errorDueToConsentHubBeingInaccessible = err instanceof (0, $9e4p2.StatusCodeError) && err.status >= 500 && err.status < 600; // Any 5xx error
    // Indicates the user is genuinely logged out instead of ConsentHub being inaccessible
    // If we dont explicitly 401, defer to the previous auth state
    const updatedAuthState = errorDueToUnauthenticatedRequest ? !errorDueToUnauthenticatedRequest : !!mergedPrefs[(0, $2W5OM.ContextualConsentProperty).UserIsAuthenticated];
    const consentToken = (0, $hJye1.packUserPreferences)({
        ...mergedPrefs,
        [(0, $2W5OM.ContextualConsentProperty).UserIsAuthenticated]: updatedAuthState,
        [(0, $2W5OM.ContextualConsentProperty).ConsentDataUnavailable]: errorDueToConsentHubBeingInaccessible // Indicates we were unable to hit ConsentHub when the consents were created
    });
    if (errorDueToUnauthenticatedRequest) {
        // When the failure is derived from a local-only/unauthenticated user, we need to also set the consent token
        // Otherwise, we will never actually adhere to their consents, as they'll continue to receive default every time we attempt to unsuccessfully fetch their prefs
        (0, $bEUFb.Logger).error(`User is unauthenticated. ${err.message}`);
        (0, $9969f6229a98cbaa$export$a023a0b818522757)(consentToken);
        (0, $3za5i.setConsentTokenCookie)(consentToken);
        (0, $3za5i.setShouldShowBannerCookie)(consentToken);
        return;
    }
    // When there's an actual failure, we only store data in the fallbackConsentToken cookie
    // This allows us to still track consents when ConsentHub is down beyond the short-lived
    // consent token cookie's expiry
    // But do _not_ set a consentToken cookie so we attempt to re-request from ConsentHub on sequential loads
    // This circumvents an issue of a user thinking they saved consents to CH, but when we request them later,
    // CH has no record of them, and they get shown the banner again
    (0, $bEUFb.Logger).error('Token failed to save');
    (0, $9969f6229a98cbaa$export$a023a0b818522757)(consentToken);
    (0, $3za5i.setShouldShowBannerCookie)(consentToken);
};
const $dc55a943bed32c59$export$fbf549fe6f0e91dc = async (updatedPreferences, displayedTextMap, usingPrefetchedData)=>{
    const mergedPrefs = (0, $9969f6229a98cbaa$export$c0214a364df3006f)(updatedPreferences, usingPrefetchedData);
    try {
        if (!usingPrefetchedData) // Attempts to save the newly updated preferences object
        // Can only be saved when a user is logged in, so this error will be caught if unauthed
        await (0, $37e9E.saveConsentPreferences)(mergedPrefs, displayedTextMap);
        $dc55a943bed32c59$export$c8a8f3474b56fa5f(mergedPrefs, usingPrefetchedData);
    } catch (err) {
        // If we fail to save to ConsentHub, it could be due to ConsentHub being down, the user being unauthenticated/local-only,
        // or an exception somewhere in the stack. Ensure we pack that information into the token where applicable.
        $dc55a943bed32c59$export$2c4e14a9e4d984da(err, mergedPrefs);
    }
};



var $jlHNc = parcelRequire("jlHNc");

var $hJye1 = parcelRequire("hJye1");
const $6c9ad8f22389201e$var$emptyDisplayedTextMap = {
    [(0, $2W5OM.PreferenceCategory).Analytics]: '',
    [(0, $2W5OM.PreferenceCategory).Functional]: '',
    [(0, $2W5OM.PreferenceCategory).Marketing]: '',
    [(0, $2W5OM.PreferenceCategory).StrictlyNecessary]: '',
    [(0, $2W5OM.PreferenceCategory).Unknown]: ''
};
async function $6c9ad8f22389201e$export$7bb3e177c1a1e841(preferences, displayedTextMap = $6c9ad8f22389201e$var$emptyDisplayedTextMap, usingPrefetchedData) {
    if ((0, $jeHvL.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $hJye1.packUserPreferences)(preferences);
        (0, $jlHNc.setStrictlyNecessaryCookie)((0, $3yjSR.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY), packedPrefs, {
            expires: 365,
            path: '/'
        });
    } else await (0, $dc55a943bed32c59$export$fbf549fe6f0e91dc)(preferences, displayedTextMap, usingPrefetchedData);
}



var $75IaS = parcelRequire("75IaS");
const $3b34077852b8f32d$export$a7357cdd1f0b0168 = (0, $75IaS.defineMessages)({
    preferencesBtn: {
        id: 'browser-storage-controls.consent-banner.preferences.button',
        defaultMessage: 'Preferences',
        description: 'Preferences button that opens consent modal dialog.'
    },
    onlyNecessaryBtn: {
        id: 'browser-storage-controls.consent-banner.only-necessary.button',
        defaultMessage: 'Only necessary',
        description: 'Only necessary button that saves user preferences - only necessary cookies.'
    },
    acceptAllBtn: {
        id: 'browser-storage-controls.consent-banner.accept-all.button',
        defaultMessage: 'Accept all',
        description: 'Accept all button that saves user preferences - accepts all cookies.'
    },
    cookiesTrackingNotice: {
        id: 'browser-storage-controls.consent-banner.cookies-tracking-notice.text.101024',
        defaultMessage: 'Atlassian cookies and tracking notice',
        description: 'Link that leads to Atlassian cookies/tracking legal notice text on Atlassian website.'
    },
    useCookiesDescription: {
        id: 'browser-storage-controls.consent-banner.cookies-description.text',
        defaultMessage: 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}',
        description: 'Description that explains Atlassian cookie controls and how it is used.'
    },
    useCookiesDescriptionNoLink: {
        id: 'browser-storage-controls.consent-banner.cookies-description.text.no.link',
        defaultMessage: 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device.',
        description: 'Description that explains Atlassian cookie controls and how it is used.'
    },
    successFlagTitle: {
        id: 'browser-storage-controls.consent-banner.success-flag.title',
        defaultMessage: 'Cookie preferences saved',
        description: 'Title for the success flag shown when cookie preferences are saved initially.'
    },
    successFlagDescription: {
        id: 'browser-storage-controls.consent-banner.success-flag.description',
        defaultMessage: 'You can change this at any time in your Atlassian account.',
        description: 'Description for the success flag shown when cookie preferences are saved initially.'
    },
    successFlagDescriptionLocalOnly: {
        id: 'browser-storage-controls.consent-banner.success-flag.description-local-only',
        defaultMessage: 'Your preferences will only affect this site.',
        description: 'Description for the success flag shown when cookie preferences are saved locally, meaning that those preferences will only affect the current domain.'
    },
    errorFlagTitle: {
        id: 'browser-storage-controls.consent-banner.error-flag.title',
        defaultMessage: "We're unable to update the policy",
        description: 'Title for the error flag shown when cookie preferences are not saved.'
    },
    errorFlagDescription: {
        id: 'browser-storage-controls.consent-banner.error-flag.description',
        defaultMessage: 'Try again in a few minutes.',
        description: 'Description for the error flag shown when cookie preferences are not saved.'
    }
});



var $1v5pe = parcelRequire("1v5pe");

var $bHcZt = parcelRequire("bHcZt");

var $2aEiL = parcelRequire("2aEiL");

var $7WT4C = parcelRequire("7WT4C");


var $bEUFb = parcelRequire("bEUFb");

var $3yjSR = parcelRequire("3yjSR");


var $1v5pe = parcelRequire("1v5pe");

var $b2Az1 = parcelRequire("b2Az1");
var $kK7WO = parcelRequire("kK7WO");

var $bcdfp = parcelRequire("bcdfp");

var $c25AW = parcelRequire("c25AW");

var $cOGx6 = parcelRequire("cOGx6");

var $kYkRP = parcelRequire("kYkRP");

var $2rArt = parcelRequire("2rArt");

var $epvFM = parcelRequire("epvFM");

var $ileP7 = parcelRequire("ileP7");

var $5YVPC = parcelRequire("5YVPC");

var $8O99O = parcelRequire("8O99O");

var $2aEiL = parcelRequire("2aEiL");

var $hpF1c = parcelRequire("hpF1c");

var $eMSEP = parcelRequire("eMSEP");

var $iOq8l = parcelRequire("iOq8l");

var $fRfXo = parcelRequire("fRfXo");

var $bQOrV = parcelRequire("bQOrV");

var $7WT4C = parcelRequire("7WT4C");

var $2W5OM = parcelRequire("2W5OM");
const $f08b7823d6424088$export$99df83ca0f45bd54 = [
    (0, $2W5OM.PreferenceCategory).Analytics,
    (0, $2W5OM.PreferenceCategory).Functional,
    (0, $2W5OM.PreferenceCategory).Marketing,
    (0, $2W5OM.PreferenceCategory).StrictlyNecessary,
    (0, $2W5OM.PreferenceCategory).Unknown
];



var $2W5OM = parcelRequire("2W5OM");

var $1v5pe = parcelRequire("1v5pe");

var $2FQOu = parcelRequire("2FQOu");

var $eMSEP = parcelRequire("eMSEP");

var $fRfXo = parcelRequire("fRfXo");

var $bQOrV = parcelRequire("bQOrV");

var $7WT4C = parcelRequire("7WT4C");

var $2W5OM = parcelRequire("2W5OM");

var $kIqwl = parcelRequire("kIqwl");
const $c45ed46f0596e5e2$var$tmpTrelloClassNameOverride = 'atl-bsc-preference-modal-checkbox';
// Styles
const $c45ed46f0596e5e2$var$categoryBoxStyles = (0, $bQOrV.xcss)({
    paddingBlockStart: 'space.200'
});
const $c45ed46f0596e5e2$var$categoryDescriptionStyles = (0, $bQOrV.xcss)({
    paddingInlineStart: 'space.300',
    marginInlineStart: 'space.050'
});
// We don't bother tracking unknown checkbox toggles
const $c45ed46f0596e5e2$var$categoryToEventSubjectMap = {
    [(0, $2W5OM.PreferenceCategory).Analytics]: 'performanceConsent',
    [(0, $2W5OM.PreferenceCategory).Functional]: 'functionalConsent',
    [(0, $2W5OM.PreferenceCategory).Marketing]: 'targetingConsent',
    [(0, $2W5OM.PreferenceCategory).Unknown]: null,
    [(0, $2W5OM.PreferenceCategory).StrictlyNecessary]: null
};
const $c45ed46f0596e5e2$var$categoryToTestIdMap = {
    [(0, $2W5OM.PreferenceCategory).StrictlyNecessary]: null,
    [(0, $2W5OM.PreferenceCategory).Analytics]: 'analytics',
    [(0, $2W5OM.PreferenceCategory).Functional]: 'functional',
    [(0, $2W5OM.PreferenceCategory).Marketing]: 'marketing',
    [(0, $2W5OM.PreferenceCategory).Unknown]: null
};
const $c45ed46f0596e5e2$export$3c97a3b492e10ae9 = ({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: descriptionElement, isChecked: isChecked, setPreferencesData: setPreferencesData })=>{
    const onCheckboxChange = (0, $1v5pe.useCallback)(()=>{
        // Don't alter cookies that are strictly necessary
        if (category === (0, $2W5OM.PreferenceCategory).StrictlyNecessary) return;
        setPreferencesData((prevPrefsData)=>{
            const isSelected = prevPrefsData.prefs && !prevPrefsData.prefs[category];
            const actionSubjectId = $c45ed46f0596e5e2$var$categoryToEventSubjectMap[category];
            if (actionSubjectId) (0, $7WT4C.sendUIEvent)({
                actionSubjectId: actionSubjectId,
                action: 'clicked',
                actionSubject: 'checkbox',
                source: 'cookieConsentModal',
                attributes: {
                    isSelected: isSelected
                }
            });
            return {
                ...prevPrefsData,
                prefs: {
                    ...prevPrefsData.prefs,
                    [category]: isSelected
                }
            };
        });
    }, [
        category,
        setPreferencesData
    ]);
    const descriptionId = `consent-preference-${$c45ed46f0596e5e2$var$categoryToTestIdMap[category]}-description`;
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $eMSEP.Box), {
        xcss: $c45ed46f0596e5e2$var$categoryBoxStyles,
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $2FQOu.Checkbox), {
                className: `${$c45ed46f0596e5e2$var$tmpTrelloClassNameOverride}`,
                isChecked: isChecked,
                value: isChecked.toString(),
                onChange: onCheckboxChange,
                label: titleElement,
                name: `${titleString}`,
                testId: `consent-preference-${$c45ed46f0596e5e2$var$categoryToTestIdMap[category]}`,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eMSEP.Box), {
                xcss: $c45ed46f0596e5e2$var$categoryDescriptionStyles,
                id: descriptionId,
                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $fRfXo.Text), {
                    size: "small",
                    color: "color.text.subtle",
                    children: descriptionElement
                })
            })
        ]
    });
};



var $75IaS = parcelRequire("75IaS");
const $75b476d4f13492f7$export$a7357cdd1f0b0168 = (0, $75IaS.defineMessages)({
    title: {
        id: 'browser-storage-controls.consent-banner-modal.title',
        defaultMessage: 'Cookie preferences',
        description: 'The text is shown as the heading at the top of the cookie preferences modal dialog, which allows users to manage and configure their browser cookie and storage settings.'
    },
    summaryDescription: {
        id: 'browser-storage-controls.consent-banner-modal.summary.description.082624',
        defaultMessage: 'Because we value your privacy, you can select which cookies you allow. {link}',
        description: 'Cookie preferences modal dialog summary description.'
    },
    strictDescription: {
        id: 'browser-storage-controls.consent-banner-modal.strict.description.082624',
        defaultMessage: "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
        description: 'Cookie preferences modal strict description.'
    },
    confirmBtn: {
        id: 'browser-storage-controls.consent-banner-modal.confirm.button',
        defaultMessage: 'Confirm',
        description: 'Cookie preferences modal dialog confirm button.'
    },
    cancelBtn: {
        id: 'browser-storage-controls.consent-banner-modal.cancel.button',
        defaultMessage: 'Cancel',
        description: 'Cookie preferences modal dialog cancel button.'
    },
    trackingLink: {
        id: 'browser-storage-controls.consent-banner-modal.tracking.link.082624',
        defaultMessage: 'Review our cookies and tracking notice',
        description: 'Cookie preferences modal link to tracking notice page.'
    },
    functionalOption: {
        id: 'browser-storage-controls.consent-banner-modal.functional.option.082624',
        defaultMessage: 'Allow functional cookies',
        description: 'Cookie preferences modal functional option.'
    },
    functionalOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.functional.description.082624',
        defaultMessage: 'Provides enhanced functionality and personalization.',
        description: 'Cookie preferences modal functional option description.'
    },
    analyticalOption: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.option.082624',
        defaultMessage: 'Allow analytical cookies',
        description: 'Cookie preferences modal analytical option.'
    },
    analyticalOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.description.101024',
        defaultMessage: 'Measures usage to improve product performance.',
        description: 'Cookie preferences modal analytical option description.'
    },
    marketingOption: {
        id: 'browser-storage-controls.consent-banner-modal.marketing.option.082624',
        defaultMessage: 'Allow marketing cookies',
        description: 'Cookie preferences modal marketing option.'
    },
    marketingOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.marketing.description.082624',
        defaultMessage: 'Used for targeted advertising.',
        description: 'Cookie preferences modal marketing option description.'
    },
    strictDescriptionAppify: {
        id: 'browser-storage-controls.consent-banner-modal.strict.description.082624-appify',
        defaultMessage: "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our apps to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
        description: 'Cookie preferences modal strict description.'
    },
    analyticalOptionDescriptionAppify: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.description.101024-appify',
        defaultMessage: 'Measures usage to improve app performance.',
        description: 'Cookie preferences modal analytical option description.'
    }
});



var $kIqwl = parcelRequire("kIqwl");
const $1fdd8efae9e052a3$var$categoryNameStyles = (0, $bQOrV.xcss)({
    fontWeight: 'font.weight.bold'
});
const $1fdd8efae9e052a3$var$extractTextFromReactNode = (node)=>{
    if (typeof node === 'string') return node;
    if (typeof node === 'number') return String(node);
    if (Array.isArray(node)) return node.map($1fdd8efae9e052a3$var$extractTextFromReactNode).join('');
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).isValidElement(node)) {
        if (node.props.children) return $1fdd8efae9e052a3$var$extractTextFromReactNode(node.props.children);
    }
    return '';
};
const $1fdd8efae9e052a3$var$getDefaultText = (intl)=>{
    const link = intl.formatMessage((0, $75b476d4f13492f7$export$a7357cdd1f0b0168).trackingLink);
    const defaultSummaryDescriptionDisplayedText = intl.formatMessage((0, $75b476d4f13492f7$export$a7357cdd1f0b0168).summaryDescription, {
        link: link
    });
    const defaultStrictDescriptionDisplayedTextNode = intl.formatMessage((0, $2aEiL.fg)('product-terminology-refresh') ? (0, $75b476d4f13492f7$export$a7357cdd1f0b0168).strictDescriptionAppify : (0, $75b476d4f13492f7$export$a7357cdd1f0b0168).strictDescription, {
        bold: (msg)=>msg
    });
    // ReactIntl requires interpolated values to be passed in, and this particular string requires a <bold> modifier.
    // Unfortunately, this converts the above formatted message to a ReactNode but ConsentHub needs strings for `displayedText`,
    // thus, we have to render to a static HTML string first and sanitize the result
    const defaultStrictDescriptionDisplayedText = $1fdd8efae9e052a3$var$extractTextFromReactNode(defaultStrictDescriptionDisplayedTextNode);
    let defaultDisplayedText = `${defaultSummaryDescriptionDisplayedText}. ${defaultStrictDescriptionDisplayedText}`;
    const sanitizedText = defaultDisplayedText.replace(/&#x27;/g, "'");
    return sanitizedText;
};
const $1fdd8efae9e052a3$var$getCookieCategories = (intl)=>{
    const cookieCategoriesToTranslate = [
        {
            // Tracks Functional related cookies like preferences
            category: (0, $2W5OM.PreferenceCategory).Functional,
            title: (0, $75b476d4f13492f7$export$a7357cdd1f0b0168).functionalOption,
            description: (0, $75b476d4f13492f7$export$a7357cdd1f0b0168).functionalOptionDescription
        },
        {
            // Tracks Performance related cookies like analytics
            category: (0, $2W5OM.PreferenceCategory).Analytics,
            title: (0, $75b476d4f13492f7$export$a7357cdd1f0b0168).analyticalOption,
            description: (0, $2aEiL.fg)('product-terminology-refresh') ? (0, $75b476d4f13492f7$export$a7357cdd1f0b0168).analyticalOptionDescriptionAppify : (0, $75b476d4f13492f7$export$a7357cdd1f0b0168).analyticalOptionDescription
        },
        {
            // Tracks Targeting related cookies like marketing and advertising
            category: (0, $2W5OM.PreferenceCategory).Marketing,
            title: (0, $75b476d4f13492f7$export$a7357cdd1f0b0168).marketingOption,
            description: (0, $75b476d4f13492f7$export$a7357cdd1f0b0168).marketingOptionDescription
        }
    ];
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, $f08b7823d6424088$export$99df83ca0f45bd54).reduce((translatedTextMap, category)=>{
        // Set the description as the default for all items (including items with checkboxes in the UI)
        // and we'll override as needed. Prefs that are not visually displayed in the UI anymore will use this default.
        translatedTextMap[category] = $1fdd8efae9e052a3$var$getDefaultText(intl);
        return translatedTextMap;
    }, {});
    const checkboxes = cookieCategoriesToTranslate.map(({ category: category, title: title, description: description })=>{
        const translatedTitle = intl.formatMessage(title);
        const translatedDescription = intl.formatMessage(description);
        // If we are showing individual checkboxes, use that description for auditing purposes
        displayedTextMap[category] = translatedDescription;
        return {
            category: category,
            titleElement: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eMSEP.Box), {
                xcss: $1fdd8efae9e052a3$var$categoryNameStyles,
                children: translatedTitle
            }),
            descriptionElement: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eMSEP.Box), {
                children: translatedDescription
            }),
            titleString: title.defaultMessage
        };
    });
    return {
        checkboxes: checkboxes,
        displayedTextMap: displayedTextMap
    };
};
const $1fdd8efae9e052a3$var$noop = ()=>{};
const $1fdd8efae9e052a3$var$CustomHeader = ({ onClose: onClose })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $ileP7.default), {
        children: [
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cOGx6.CloseButton), {
                onClick: onClose,
                testId: "close-modal-button"
            }),
            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $5YVPC.default), {
                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
                    ...(0, $75b476d4f13492f7$export$a7357cdd1f0b0168).title
                })
            })
        ]
    });
};
const $1fdd8efae9e052a3$export$9921ee7829a3ba4 = ({ preferences: preferences, setPreferencesData: setPreferencesData = $1fdd8efae9e052a3$var$noop, onSubmit: onSubmit = $1fdd8efae9e052a3$var$noop, onClose: onClose = $1fdd8efae9e052a3$var$noop, setIsOpen: setIsOpen = $1fdd8efae9e052a3$var$noop })=>{
    const intl = (0, $kK7WO.default)();
    const onCloseModal = (0, $1v5pe.useCallback)(()=>{
        setIsOpen(false);
        onClose();
    }, [
        setIsOpen,
        onClose
    ]);
    const onClickCancel = (0, $1v5pe.useCallback)(()=>{
        onCloseModal();
        (0, $7WT4C.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'cancel',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickClose = (0, $1v5pe.useCallback)(()=>{
        onCloseModal();
        (0, $7WT4C.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'close',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickBackground = (0, $1v5pe.useCallback)(()=>{
        onCloseModal();
        (0, $7WT4C.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'area',
            actionSubjectId: 'background',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickTrackingNoticeLink = (0, $1v5pe.useCallback)(()=>{
        (0, $7WT4C.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentModal'
        });
    }, []);
    const cookieCategories = (0, $1v5pe.useMemo)(()=>{
        return $1fdd8efae9e052a3$var$getCookieCategories(intl);
    }, [
        intl
    ]);
    const handleSubmission = (0, $1v5pe.useCallback)(()=>{
        const { displayedTextMap: displayedTextMap } = cookieCategories;
        onSubmit(displayedTextMap);
    }, [
        onSubmit,
        cookieCategories
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8O99O.default), {
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $2rArt.default), {
            onClose: onClickBackground,
            children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $c25AW.default), {
                onSubmit: handleSubmission,
                children: [
                    /*#__PURE__*/ (0, $kIqwl.jsx)($1fdd8efae9e052a3$var$CustomHeader, {
                        onClose: onClickClose
                    }),
                    /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $kYkRP.default), {
                        children: [
                            /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $eMSEP.Box), {
                                children: [
                                    /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
                                        ...(0, $75b476d4f13492f7$export$a7357cdd1f0b0168).summaryDescription,
                                        values: {
                                            link: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $hpF1c.Anchor), {
                                                href: "https://www.atlassian.com/legal/cookies#cookies-and-other-tracking-technologies",
                                                target: "_blank",
                                                onClick: onClickTrackingNoticeLink,
                                                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
                                                    ...(0, $75b476d4f13492f7$export$a7357cdd1f0b0168).trackingLink
                                                })
                                            })
                                        },
                                        tagName: 'p'
                                    }),
                                    /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
                                        ...(0, $2aEiL.fg)('product-terminology-refresh') ? (0, $75b476d4f13492f7$export$a7357cdd1f0b0168).strictDescriptionAppify : (0, $75b476d4f13492f7$export$a7357cdd1f0b0168).strictDescription,
                                        values: {
                                            bold: (msg)=>/*#__PURE__*/ (0, $kIqwl.jsx)((0, $fRfXo.Text), {
                                                    weight: "bold",
                                                    children: msg
                                                })
                                        },
                                        tagName: 'p'
                                    })
                                ]
                            }),
                            cookieCategories.checkboxes.map(({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: description }, index)=>/*#__PURE__*/ (0, $kIqwl.jsx)((0, $iOq8l.Stack), {
                                    children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $c45ed46f0596e5e2$export$3c97a3b492e10ae9), {
                                        category: category,
                                        titleElement: titleElement,
                                        titleString: titleString,
                                        descriptionElement: description,
                                        isChecked: (preferences && preferences[category]) ?? false,
                                        setPreferencesData: setPreferencesData
                                    })
                                }, index))
                        ]
                    }),
                    /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $epvFM.default), {
                        children: [
                            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $bcdfp.default), {
                                appearance: "subtle",
                                onClick: onClickCancel,
                                testId: "consent-preference-cancel",
                                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
                                    ...(0, $75b476d4f13492f7$export$a7357cdd1f0b0168).cancelBtn
                                })
                            }),
                            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $bcdfp.default), {
                                type: "submit",
                                appearance: "primary",
                                onClick: handleSubmission,
                                testId: "consent-preference-confirm",
                                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
                                    ...(0, $75b476d4f13492f7$export$a7357cdd1f0b0168).confirmBtn
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};



var $1v5pe = parcelRequire("1v5pe");

var $hJye1 = parcelRequire("hJye1");

var $hEEEo = parcelRequire("hEEEo");

/**
 * This function is responsible for loading the user's preferences from storage, and setting the state accordingly.
 * If the user's preferences are not found in storage, the default preferences will be used.
 */ const $a5b8a4c1ef8129f1$var$loadStoredPreferences = async ({ setPreferencesData: setPreferencesData, isInitialRender: isInitialRender })=>{
    const prefs = await (0, $hEEEo.getPreferences)();
    // If something has gone wrong during this `get` process (invalid token, failed request, etc.)
    // these preferences will be undefined and we'll need to show the banner as we're in an unknown state
    setPreferencesData({
        prefs: prefs,
        isPrefetchedPrefsInternalState: Boolean(prefs)
    });
    // Set the initialRender flag to false so we can skip logic in banner rendering
    if (isInitialRender) isInitialRender.current = false;
};
/**
 * This hook is responsible for handling any initially provided preference data, and/or fetching missing preference
 * data from ConsentHub. It will then set the appropriate cookies and state for the user's preferences to be used
 * throughout the application.

 * @param (optional) initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @returns (object) {
 * 	preferences - The current state of the user's preferences after fetching/transforming/setting cookies
 *	isPrefetchedPreferencesState - A boolean that indicates if we are in a prefetched internal state
 *	setPreferencesData - Setter function to update the preferences state
 *	isInitialRender - A boolean that indicates if this is the first render of the component
 * }
 */ const $a5b8a4c1ef8129f1$var$usePreferences = ({ initialPreferences: initialPreferences })=>{
    /**
   * isInitialRender is used to ensure consistent banner visibility by addressing potential mismatches that occur
   *  during the initial render. Without this flag, the application might incorrectly display a banner based on
   * incomplete or missing preference data. During the rehydration process, this initial render triggers
   * the useMemo and useEffect hooks which means that initialPreferences may be undefined due to the asynchronous
   * nature of setting props. This can lead to discrepancies in banner visibility between the SSR state
   * and the client-rendered state.
   */ const isInitialRender = (0, $1v5pe.useRef)(true);
    const prefetchedPreferencesData = (0, $1v5pe.useRef)(initialPreferences);
    const [preferencesData, setPreferencesData] = (0, $1v5pe.useState)((0, $hJye1.initializePreferencesData)(initialPreferences));
    (0, $1v5pe.useEffect)(()=>{
        const { prefs: unpackedPrefetchedPrefs, isPrefetchedPrefsInternalState: isPrefetchedPrefsInternalState } = (0, $hJye1.initializePreferencesData)(prefetchedPreferencesData.current);
        if (!isPrefetchedPrefsInternalState && unpackedPrefetchedPrefs) // With a valid set of prefs, set them on the cookies, but don't save to ConsentHub
        (0, $6c9ad8f22389201e$export$7bb3e177c1a1e841)(unpackedPrefetchedPrefs, undefined, true);
        // On initial render, this will either set the proper preferences in state + required cookies based on the
        // prefetched data, or fetch all of that data from ConsentHub and then set appropriate cookies + state.
        $a5b8a4c1ef8129f1$var$loadStoredPreferences({
            setPreferencesData: setPreferencesData,
            isInitialRender: isInitialRender
        });
    }, [
        isInitialRender
    ]);
    return {
        preferences: preferencesData?.prefs,
        isPrefetchedPreferencesState: preferencesData?.isPrefetchedPrefsInternalState,
        setPreferencesData: setPreferencesData,
        isInitialRender: isInitialRender.current
    };
};
var $a5b8a4c1ef8129f1$export$2e2bcd8739ae039 = $a5b8a4c1ef8129f1$var$usePreferences;



var $kIqwl = parcelRequire("kIqwl");
const $bbe9d9ffb1100a9a$export$94c5684831c222e7 = (props)=>{
    if ((0, $2aEiL.fg)('platform_moonjelly_bsc_master_killswitch') || (0, $2aEiL.fg)('platform_moonjelly_bsc_ui_killswitch')) // Don't render the preference modal if the killswitch is enabled
    return null;
    return /*#__PURE__*/ (0, $kIqwl.jsx)($bbe9d9ffb1100a9a$export$30df3cfccbe10e6e, {
        ...props
    });
};
const $bbe9d9ffb1100a9a$export$30df3cfccbe10e6e = ({ onClose: onClose, onSubmit: onSubmit, showSuccessFlag: showSuccessFlag, showErrorFlag: showErrorFlag, shouldAddWrappers: shouldAddWrappers = true })=>{
    const [isModalOpen, setIsModalOpen] = (0, $1v5pe.useState)(true);
    const isEventSent = (0, $1v5pe.useRef)(false);
    (0, $1v5pe.useEffect)(()=>{
        if (!isEventSent.current) {
            (0, $7WT4C.sendScreenEvent)({
                name: 'cookieConsentModal'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent
    ]);
    const { preferences: preferences, setPreferencesData: setPreferencesData } = (0, $a5b8a4c1ef8129f1$export$2e2bcd8739ae039)({});
    // If we don't have preferences, set default preferences
    // for modal interactions
    if (!preferences) setPreferencesData({
        prefs: (0, $3yjSR.ONLY_NECESSARY_PREFERENCES),
        isPrefetchedPrefsInternalState: false
    });
    const handleOnSubmit = (0, $1v5pe.useCallback)(async (displayedTextMap)=>{
        if (preferences) {
            const selectedPreferences = preferences;
            (0, $7WT4C.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'confirm',
                source: 'cookieConsentModal'
            });
            try {
                await (0, $6c9ad8f22389201e$export$7bb3e177c1a1e841)(selectedPreferences, displayedTextMap);
                (0, $7WT4C.sendTrackEvent)({
                    source: 'cookieConsentModal',
                    action: 'submitted',
                    actionSubject: 'cookieConsentPreferences'
                });
                showSuccessFlag?.();
            } catch (e) {
                (0, $bEUFb.Logger).errorWithOperationalEvent({
                    action: 'updatePreferencesError',
                    attributes: {
                        preferences: selectedPreferences
                    },
                    message: `Failed to update preferences from modal. ${e.message || ''}`
                });
                showErrorFlag?.();
            }
            setIsModalOpen(false);
            onSubmit?.();
        } else // Preferences have reached an invalid state, show error flag
        showErrorFlag?.();
    }, [
        preferences,
        onSubmit,
        showSuccessFlag,
        showErrorFlag
    ]);
    const modalContent = /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1fdd8efae9e052a3$export$9921ee7829a3ba4), {
        onSubmit: handleOnSubmit,
        onClose: onClose,
        setIsOpen: setIsModalOpen,
        preferences: preferences ?? (0, $3yjSR.ONLY_NECESSARY_PREFERENCES),
        setPreferencesData: setPreferencesData
    });
    if (!isModalOpen) return null;
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kIqwl.Fragment), {
        children: shouldAddWrappers ? /*#__PURE__*/ (0, $kIqwl.jsx)((0, $bHcZt.FlagsProvider), {
            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $c92052f02b4f1e2c$export$9aa38aed134c207f), {
                children: modalContent
            })
        }) : modalContent
    });
};




var $1v5pe = parcelRequire("1v5pe");

var $b2Az1 = parcelRequire("b2Az1");
var $kK7WO = parcelRequire("kK7WO");

var $49361 = parcelRequire("49361");

var $caOTO = parcelRequire("caOTO");

var $hpF1c = parcelRequire("hpF1c");

var $eMSEP = parcelRequire("eMSEP");

var $f4K70 = parcelRequire("f4K70");

var $iOm08 = parcelRequire("iOm08");

var $bQOrV = parcelRequire("bQOrV");

var $1Tz0w = parcelRequire("1Tz0w");



var $kIqwl = parcelRequire("kIqwl");
const $4f78cee0f4ae6f10$var$boxStylesPurpleWithMinHeight = (0, $bQOrV.xcss)({
    padding: 'space.200',
    backgroundColor: 'color.background.discovery',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    overflowY: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
});
const $4f78cee0f4ae6f10$var$noticeContainerStyles = (0, $bQOrV.xcss)({
    flexDirection: 'row',
    alignItems: 'center',
    gap: 'space.200'
});
const $4f78cee0f4ae6f10$var$inlineWrapperStylesStaticHeight = (0, $bQOrV.xcss)({
    // Small & Medium viewport defaults
    gap: 'space.100',
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    [(0, $iOm08.media).above.md]: {
        gap: 'space.300',
        flexDirection: 'row',
        alignItems: 'center'
    }
});
const $4f78cee0f4ae6f10$var$buttonContainerStylesStaticHeight = (0, $bQOrV.xcss)({
    minWidth: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row-reverse',
    flexWrap: 'wrap-reverse',
    justifyContent: 'start',
    [(0, $iOm08.media).above.md]: {
        marginLeft: 'auto',
        flexWrap: 'nowrap',
        flexDirection: 'row'
    }
});
const $4f78cee0f4ae6f10$var$truncatedTextStyles = (0, $bQOrV.xcss)({
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    flex: '0 1 auto'
});
const $4f78cee0f4ae6f10$var$linkNoTruncateStyles = (0, $bQOrV.xcss)({
    flex: '0 0 auto',
    whiteSpace: 'nowrap'
});
const $4f78cee0f4ae6f10$var$smallMediumScreenContainerStyles = (0, $bQOrV.xcss)({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 'space.050',
    alignItems: 'baseline',
    [(0, $iOm08.media).above.md]: {
        display: 'none'
    }
});
const $4f78cee0f4ae6f10$var$largeScreenContainerStyles = (0, $bQOrV.xcss)({
    display: 'none',
    [(0, $iOm08.media).above.md]: {
        display: 'block'
    }
});
const $4f78cee0f4ae6f10$var$noop = ()=>{};
const $4f78cee0f4ae6f10$var$getDisplayedTextMap = (intl)=>{
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, $f08b7823d6424088$export$99df83ca0f45bd54).reduce((translatedTextMap, category)=>{
        const linkToCookiesTrackingNotice = intl.formatMessage((0, $3b34077852b8f32d$export$a7357cdd1f0b0168).cookiesTrackingNotice);
        const bannerDescription = intl.formatMessage((0, $3b34077852b8f32d$export$a7357cdd1f0b0168).useCookiesDescription, {
            linkToCookiesTrackingNotice: linkToCookiesTrackingNotice
        });
        // Set this for all items (including items with checkboxes in the UI), we'll override as needed below
        // for things like strictlyNecessary/acceptAll
        translatedTextMap[category] = bannerDescription;
        return translatedTextMap;
    }, {});
    return displayedTextMap;
};
const $4f78cee0f4ae6f10$var$updateDisplayedTextMap = (intl, displayTextMap, isOnlyNecessary)=>{
    const updatedDisplayedTextMap = {
        ...displayTextMap
    };
    // Use description as message to translate
    const onlyNecessaryContent = intl.formatMessage((0, $3b34077852b8f32d$export$a7357cdd1f0b0168).onlyNecessaryBtn);
    const acceptAllContent = intl.formatMessage((0, $3b34077852b8f32d$export$a7357cdd1f0b0168).acceptAllBtn);
    // For additional auditing content, append the description related to the button when pressed
    Object.keys(updatedDisplayedTextMap).forEach((key)=>{
        const preferenceCategory = key;
        const additionalContent = isOnlyNecessary ? onlyNecessaryContent : acceptAllContent;
        const textContent = updatedDisplayedTextMap[preferenceCategory];
        updatedDisplayedTextMap[preferenceCategory] = `${additionalContent} \u{2014} ${textContent}`;
    });
    return updatedDisplayedTextMap;
};
const $4f78cee0f4ae6f10$export$dd3e60478510f81d = ({ onClickOnlyNecessary: onClickOnlyNecessary = $4f78cee0f4ae6f10$var$noop, onClickAcceptAll: onClickAcceptAll = $4f78cee0f4ae6f10$var$noop, onClickPreferences: onClickPreferences = $4f78cee0f4ae6f10$var$noop, onClickTrackingNoticeLink: onClickTrackingNoticeLink = $4f78cee0f4ae6f10$var$noop, minWidth: minWidth = 400, newMinHeight: newMinHeight = 105 })=>{
    const intl = (0, $kK7WO.default)();
    const displayedTextMap = (0, $1v5pe.useMemo)(()=>{
        return $4f78cee0f4ae6f10$var$getDisplayedTextMap(intl);
    }, [
        intl
    ]);
    const handleOnlyNecessaryClick = (0, $1v5pe.useCallback)(()=>{
        const displayedTextOnlyNecessaryMap = $4f78cee0f4ae6f10$var$updateDisplayedTextMap(intl, displayedTextMap, true);
        onClickOnlyNecessary(displayedTextOnlyNecessaryMap);
    }, [
        onClickOnlyNecessary,
        intl,
        displayedTextMap
    ]);
    const handleAcceptAllClick = (0, $1v5pe.useCallback)(()=>{
        const displayedTextAcceptAllMap = $4f78cee0f4ae6f10$var$updateDisplayedTextMap(intl, displayedTextMap);
        onClickAcceptAll(displayedTextAcceptAllMap);
    }, [
        onClickAcceptAll,
        intl,
        displayedTextMap
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eMSEP.Box), {
        role: "dialog",
        "aria-labelledby": "cookiesTrackingNoticeLink",
        xcss: $4f78cee0f4ae6f10$var$boxStylesPurpleWithMinHeight,
        style: {
            minWidth: `${minWidth}px`,
            // If you are updating the minHeight, please also update the MIN_BANNER_HEIGHT in confluence/next/packages/cookies-consent-banner/src/useCookiesConsentBanner.ts
            minHeight: `${newMinHeight}px`,
            height: `${newMinHeight}px`
        },
        children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $f4K70.Inline), {
            xcss: $4f78cee0f4ae6f10$var$inlineWrapperStylesStaticHeight,
            children: [
                /*#__PURE__*/ (0, $kIqwl.jsx)((0, $f4K70.Inline), {
                    xcss: $4f78cee0f4ae6f10$var$noticeContainerStyles,
                    children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $kIqwl.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $f4K70.Inline), {
                                xcss: $4f78cee0f4ae6f10$var$smallMediumScreenContainerStyles,
                                children: [
                                    /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1Tz0w.default), {
                                        content: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
                                            ...(0, $3b34077852b8f32d$export$a7357cdd1f0b0168).useCookiesDescriptionNoLink
                                        }),
                                        position: "top",
                                        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $f4K70.Inline), {
                                            xcss: $4f78cee0f4ae6f10$var$truncatedTextStyles,
                                            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
                                                ...(0, $3b34077852b8f32d$export$a7357cdd1f0b0168).useCookiesDescriptionNoLink,
                                                tagName: "span"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $kIqwl.jsx)((0, $hpF1c.Anchor), {
                                        id: "cookiesTrackingNoticeLink",
                                        href: "https://www.atlassian.com/legal/cookies",
                                        target: "_blank",
                                        onClick: onClickTrackingNoticeLink,
                                        xcss: $4f78cee0f4ae6f10$var$linkNoTruncateStyles,
                                        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
                                            ...(0, $3b34077852b8f32d$export$a7357cdd1f0b0168).cookiesTrackingNotice
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eMSEP.Box), {
                                xcss: $4f78cee0f4ae6f10$var$largeScreenContainerStyles,
                                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
                                    ...(0, $3b34077852b8f32d$export$a7357cdd1f0b0168).useCookiesDescription,
                                    tagName: "span",
                                    values: {
                                        linkToCookiesTrackingNotice: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $hpF1c.Anchor), {
                                            id: "cookiesTrackingNoticeLink",
                                            href: "https://www.atlassian.com/legal/cookies",
                                            target: "_blank",
                                            onClick: onClickTrackingNoticeLink,
                                            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
                                                ...(0, $3b34077852b8f32d$export$a7357cdd1f0b0168).cookiesTrackingNotice
                                            })
                                        })
                                    }
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $f4K70.Inline), {
                    space: "space.100",
                    xcss: $4f78cee0f4ae6f10$var$buttonContainerStylesStaticHeight,
                    children: [
                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $49361.default), {
                            testId: "preferences-button",
                            appearance: "subtle",
                            onClick: onClickPreferences,
                            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
                                ...(0, $3b34077852b8f32d$export$a7357cdd1f0b0168).preferencesBtn
                            })
                        }),
                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $49361.default), {
                            testId: "only-necessary-button",
                            onClick: handleOnlyNecessaryClick,
                            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
                                ...(0, $3b34077852b8f32d$export$a7357cdd1f0b0168).onlyNecessaryBtn
                            })
                        }),
                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $49361.default), {
                            testId: "accept-all-button",
                            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($caOTO))),
                            onClick: handleAcceptAllClick,
                            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b2Az1.default), {
                                ...(0, $3b34077852b8f32d$export$a7357cdd1f0b0168).acceptAllBtn
                            })
                        })
                    ]
                })
            ]
        })
    });
};



var $1v5pe = parcelRequire("1v5pe");

var $jeHvL = parcelRequire("jeHvL");
var $7WT4C = parcelRequire("7WT4C");

var $dS1lP = parcelRequire("dS1lP");

var $3yjSR = parcelRequire("3yjSR");

var $2aEiL = parcelRequire("2aEiL");

var $37e9E = parcelRequire("37e9E");

var $9e4p2 = parcelRequire("9e4p2");

var $hJye1 = parcelRequire("hJye1");

var $il7mV = parcelRequire("il7mV");
const $dee132b12fb8d196$export$6406464aa126433e = (prefetchedPreferencesData, ssrOptions)=>{
    if ((0, $2aEiL.fg)('platform_moonjelly_bsc_ssr_killswitch')) // If the bsc ssr killswitch is enabled, we should not show the banner
    // in SSR context
    return false;
    if (!prefetchedPreferencesData) // If prefetched prefs are missing (presumably SSR prefetching failed), but are still trying to compute
    // banner state, we have no info to calculate from so, we need to show the banner to be compliant
    return true;
    if ('consentToken' in prefetchedPreferencesData) {
        // We've been given cached cookie data, validate it before use.
        // If invalid, we can't determine anything, show the banner for compliance sake
        const { isValid: isValid } = (0, $hJye1.checkTokenVersionValidity)(prefetchedPreferencesData.consentToken);
        return isValid ? (0, $il7mV.getBannerVisibility)(prefetchedPreferencesData, ssrOptions) : true;
    }
    // We've been given ConsentHub response data
    // Check if we have consents via prefetched data
    // to prevent mismatches where space is reserved but UI doesn't render
    const prefetchedDataHasConsents = (0, $9e4p2.hasPrefetchedDataConsents)(prefetchedPreferencesData);
    if (prefetchedDataHasConsents) return false;
    // Format it appropriately and use getBannerVisibility for proper staleness/fallback checks
    const consentPrefsData = (0, $37e9E.buildConsentPreferences)(prefetchedPreferencesData);
    return (0, $il7mV.getBannerVisibility)(consentPrefsData, ssrOptions);
};



var $jlHNc = parcelRequire("jlHNc");

var $dbJ6U = parcelRequire("dbJ6U");

var $2W5OM = parcelRequire("2W5OM");
const $dccef779b4037a33$export$f6e8c8e54d2f31fe = (isInitialRender, initialPreferences, ssrOptions)=>{
    // We don't have a great way to handle dealing with consent timestamps right here, as we have no global state/store, so we have to precompute
    // banner visibility state when we fetch consents, and store it in a cookie to be read later, here.
    const shouldShowBannerBit = ssrOptions?.getCookie ? ssrOptions.getCookie((0, $3yjSR.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)) : (0, $dbJ6U.getCookie)((0, $3yjSR.ATLASSIAN_SHOW_BANNER_COOKIE_KEY));
    const inFlowWhereBannerStateIsUnknown = initialPreferences && isInitialRender && shouldShowBannerBit === undefined;
    if ((ssrOptions?.isSSR ?? (0, $dS1lP.isSSR)()) || inFlowWhereBannerStateIsUnknown) {
        // When coming from SSR, this hook will only execute once and won't update later
        // Instead, if we're on the server, have initial preference data with valid consents, don't render
        // On later checks (rehydration), this will always fail and skip to the normal rendering logic
        // Once we're rehydrating, if have been provided initial prefs (from SSR), on the "first render", the banner cookie may still be missing.
        // Due to React lifecycle where this useMemo is executing prior to the useEffect in the usePreferences hook, which sets the core cookies.
        // We should give this flow the same treatment as rendering in an SSR context to match the behavior of the SSR flow to reduce any potential UX flicker.
        if (initialPreferences === (0, $2W5OM.PrefetchedPreferenceState).INTERNAL) // If we're in the "fetch internally" state, we have no prefetched data and we can't determine
        // if the user has consented or not yet since we need to fetch, so show the banner
        return true;
        // shouldRenderBannerPrefetched is the single source of truth for SSR/hydration banner visibility.
        // It is used here and by all external consumers (e.g. useCookiesConsentBanner) to guarantee
        // consistent decisions, including correct handling of fallbackConsentToken.
        //
        // Cast: PrefetchedConsentPreferenceData is a narrower type than PrefetchedConsentPreferences —
        // it excludes PrefetchedPreferenceState (handled above) but is otherwise compatible at this call site.
        return (0, $dee132b12fb8d196$export$6406464aa126433e)(initialPreferences, ssrOptions);
    }
    const shouldShowBanner = shouldShowBannerBit ? !!Number(shouldShowBannerBit) : false;
    return shouldShowBanner;
};
/**
 * This hook is responsible for determining whether or not the consent banner should be shown based on the user's
 * preferences and the current state of the banner cookie, as well as if the we're rendering from an SSR context.
 *
 * @param preferences - The current state of the user's preferences
 * @param initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @param isInitialRender - A boolean to track if this is the "first" render of the component
 * @param isPrefetchedPreferencesState - A boolean that indicates if are fetching consents internally to our component
 * @returns showBanner - Whether or not the banner should be shown
 * @returns setIsDismissed - Setter function to update the dismissed state of the banner
 */ const $dccef779b4037a33$var$useBannerVisibility = ({ preferences: preferences, initialPreferences: initialPreferences, isInitialRender: isInitialRender, isPrefetchedPreferencesState: isPrefetchedPreferencesState, ssrOptions: ssrOptions })=>{
    const isEventSent = (0, $1v5pe.useRef)(false);
    const [isDismissed, setIsDismissedProp] = (0, $1v5pe.useState)(false);
    const setIsDismissed = (isDismissed)=>{
        if (isDismissed) (0, $jlHNc.setStrictlyNecessaryCookie)((0, $3yjSR.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY), Date.now().toString(), {
            path: '/'
        });
        setIsDismissedProp(isDismissed);
    };
    const showBanner = (0, $1v5pe.useMemo)(()=>{
        return $dccef779b4037a33$export$4ea0ccb8ff519056({
            preferences: preferences,
            initialPreferences: initialPreferences,
            isInitialRender: isInitialRender,
            isPrefetchedPreferencesState: isPrefetchedPreferencesState,
            isDismissed: isDismissed,
            ssrOptions: ssrOptions
        });
    }, [
        isInitialRender,
        initialPreferences,
        isPrefetchedPreferencesState,
        preferences,
        isDismissed,
        ssrOptions
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (!isEventSent.current && showBanner) {
            (0, $7WT4C.sendScreenEvent)({
                name: 'cookieConsentBanner'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent,
        showBanner
    ]);
    return {
        showBanner: showBanner,
        setIsDismissed: setIsDismissed
    };
};
const $dccef779b4037a33$export$4ea0ccb8ff519056 = ({ preferences: preferences, initialPreferences: initialPreferences, isInitialRender: isInitialRender, isPrefetchedPreferencesState: isPrefetchedPreferencesState, isDismissed: isDismissed, ssrOptions: ssrOptions })=>{
    if ((0, $jeHvL.getBscGlobalState)().localConsentMode) {
        // In V1, we only checked based on the existence of the preferences
        const prefsMissing = !preferences;
        if (ssrOptions?.isSSR ?? (0, $dS1lP.isSSR)()) // This logic will execute normally in V2, but for now, as SSR prefetching has not been implemented completely
        // just hide the banner if we're missing the data (always will be in SSR-context) and let the UI handle it on rehydration
        return !prefsMissing && !isDismissed;
        return prefsMissing && !isDismissed;
    }
    const shouldShowBanner = $dccef779b4037a33$export$f6e8c8e54d2f31fe(isInitialRender, initialPreferences, ssrOptions);
    const unknownPreferences = !isPrefetchedPreferencesState && !preferences;
    return (unknownPreferences || shouldShowBanner) && !isDismissed;
};
var $dccef779b4037a33$export$2e2bcd8739ae039 = $dccef779b4037a33$var$useBannerVisibility;



var $kIqwl = parcelRequire("kIqwl");
const $33a6600c5da46c88$var$SuccessWithIntl = (0, $lJYzG.default)(({ intl: intl })=>/*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8sBGu))), {
        color: "var(--ds-icon-success, #6A9A23)",
        label: intl.formatMessage({
            id: 'browser-storage-controls.consent-banner.toast.success',
            defaultMessage: 'Success',
            description: 'The text is shown as the title of a success toast notification that appears in the consent banner after the user successfully saves their cookie preferences.'
        }),
        spacing: "spacious"
    }));
const $33a6600c5da46c88$var$ErrorWithIntl = (0, $lJYzG.default)(({ intl: intl })=>/*#__PURE__*/ (0, $kIqwl.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4saCT))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: intl.formatMessage({
            id: 'browser-storage-controls.consent-banner.toast.error',
            defaultMessage: 'Error',
            description: 'The title for an error as a single word.'
        }),
        spacing: "spacious"
    }));
const $33a6600c5da46c88$var$errorToastProps = ()=>({
        icon: /*#__PURE__*/ (0, $kIqwl.jsx)($33a6600c5da46c88$var$ErrorWithIntl, {}),
        appearance: 'normal'
    });
const $33a6600c5da46c88$var$successToastProps = ()=>({
        icon: /*#__PURE__*/ (0, $kIqwl.jsx)($33a6600c5da46c88$var$SuccessWithIntl, {}),
        appearance: 'normal',
        isAutoDismiss: true
    });
const $33a6600c5da46c88$export$24af610f9b900e82 = ({ onShow: onShow, onHide: onHide, initialPreferences: initialPreferences, minWidth: minWidth = 400, product: product, onConsentBannerBailOut: onConsentBannerBailOut, analyticsEnabled: analyticsEnabled = true, localConsentMode: localConsentMode = false, newMinHeight: newMinHeight, ssrOptions: ssrOptions, perimeter: perimeter })=>{
    const firstRender = (0, $1v5pe.useRef)(true);
    (0, $1v5pe.useEffect)(()=>{
        if (!firstRender.current) return;
        // Send an operational event if the banner is shown after previously having
        // been dismissed. This will help prevent issues with the banner
        // inappropriately reappearing.
        const lastBannerDismissal = (0, $dbJ6U.getCookie)((0, $3yjSR.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY));
        if (lastBannerDismissal) {
            const timeSinceDismissal = Date.now() - new Date(Number.parseInt(lastBannerDismissal)).getTime();
            const lessThanOneHour = timeSinceDismissal < 3600000;
            const lessThanOneDay = timeSinceDismissal < 86400000;
            const lessThanOneWeek = timeSinceDismissal < 604800000;
            (0, $7WT4C.sendPackageOperationalEvent)({
                action: 'bannerAppearanceAfterDismissal',
                attributes: {
                    timeSinceDismissal: timeSinceDismissal,
                    lessThanOneHour: lessThanOneHour,
                    lessThanOneDay: lessThanOneDay,
                    lessThanOneWeek: lessThanOneWeek
                }
            });
            (0, $2dfafd1edeed1471$export$b43e45590305ffaa)((0, $3yjSR.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY));
        }
        firstRender.current = false;
    }, []);
    (0, $1v5pe.useEffect)(()=>{
        (0, $751de4a961087994$export$882c4530c58781d8)({
            analyticsEnabled: analyticsEnabled,
            product: product,
            localConsentMode: localConsentMode,
            perimeter: perimeter
        });
    }, [
        analyticsEnabled,
        product,
        localConsentMode,
        perimeter
    ]);
    const [isPreferencesModalOpen, setIsPreferencesModalOpen] = (0, $1v5pe.useState)(false);
    const intl = (0, $kK7WO.default)();
    const { showFlag: showFlag } = (0, $dNZ1k.useFlags)();
    const { preferences: preferences, isPrefetchedPreferencesState: isPrefetchedPreferencesState, isInitialRender: isInitialRender } = (0, $a5b8a4c1ef8129f1$export$2e2bcd8739ae039)({
        initialPreferences: initialPreferences
    });
    const { showBanner: showBanner, setIsDismissed: setIsDismissed } = (0, $dccef779b4037a33$export$2e2bcd8739ae039)({
        preferences: preferences,
        isPrefetchedPreferencesState: isPrefetchedPreferencesState,
        initialPreferences: initialPreferences,
        isInitialRender: isInitialRender,
        ssrOptions: ssrOptions
    });
    const closePreferenceModal = (0, $1v5pe.useCallback)(()=>{
        setIsPreferencesModalOpen(false);
    }, [
        setIsPreferencesModalOpen
    ]);
    const onPreferenceModalSubmit = (0, $1v5pe.useCallback)(()=>{
        closePreferenceModal();
        setIsDismissed(true);
    }, [
        closePreferenceModal,
        setIsDismissed
    ]);
    const onClickPreferences = (0, $1v5pe.useCallback)(()=>{
        setIsPreferencesModalOpen(true);
        (0, $7WT4C.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preferences',
            source: 'cookieConsentBanner'
        });
    }, []);
    const showSuccessFlag = (0, $1v5pe.useCallback)(()=>{
        if (localConsentMode) showFlag({
            ...$33a6600c5da46c88$var$successToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $3b34077852b8f32d$export$a7357cdd1f0b0168).successFlagDescriptionLocalOnly),
            title: intl.formatMessage((0, $3b34077852b8f32d$export$a7357cdd1f0b0168).successFlagTitle)
        });
        else showFlag({
            ...$33a6600c5da46c88$var$successToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $3b34077852b8f32d$export$a7357cdd1f0b0168).successFlagDescription),
            title: intl.formatMessage((0, $3b34077852b8f32d$export$a7357cdd1f0b0168).successFlagTitle)
        });
    }, [
        intl,
        localConsentMode,
        showFlag
    ]);
    const showErrorFlag = (0, $1v5pe.useCallback)(()=>{
        showFlag({
            ...$33a6600c5da46c88$var$errorToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $3b34077852b8f32d$export$a7357cdd1f0b0168).errorFlagDescription),
            title: intl.formatMessage((0, $3b34077852b8f32d$export$a7357cdd1f0b0168).errorFlagTitle)
        });
    }, [
        intl,
        showFlag
    ]);
    // Sets preferences to allow only Strictly Necessary cookies
    const onClickOnlyNecessary = (0, $1v5pe.useCallback)(async (displayedTextMap)=>{
        try {
            (0, $7WT4C.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'onlyNecessary',
                source: 'cookieConsentBanner'
            });
            await (0, $6c9ad8f22389201e$export$7bb3e177c1a1e841)((0, $3yjSR.ONLY_NECESSARY_PREFERENCES), displayedTextMap);
            (0, $7WT4C.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, $bEUFb.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, $3yjSR.ONLY_NECESSARY_PREFERENCES),
                    product: product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    // Sets preferences to allow all categories of cookies
    const onClickAcceptAll = (0, $1v5pe.useCallback)(async (displayedTextMap)=>{
        try {
            (0, $7WT4C.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'acceptAll',
                source: 'cookieConsentBanner'
            });
            await (0, $6c9ad8f22389201e$export$7bb3e177c1a1e841)((0, $3yjSR.ACCEPT_ALL_PREFERENCES), displayedTextMap);
            (0, $7WT4C.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, $bEUFb.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, $3yjSR.ACCEPT_ALL_PREFERENCES),
                    product: product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    const onClickTrackingNoticeLink = (0, $1v5pe.useCallback)(()=>{
        (0, $7WT4C.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentBanner'
        });
    }, []);
    // Call onShow/onHide as a side effect of showBanner changing, rather than
    // possibly having to call them in multiple places.
    (0, $1v5pe.useEffect)(()=>{
        if (showBanner) (0, $7uhky.addUFOCustomData)({
            isCookieConsentBannerDisplayed: true
        });
        if (showBanner) onShow?.();
        else if (!showBanner) onHide?.();
    }, [
        showBanner,
        onShow,
        onHide
    ]);
    (0, $1v5pe.useEffect)(()=>{
        // when banner is not visible and isPrefetchedPreferencesState is in "resolved" state
        if (!showBanner && isPrefetchedPreferencesState !== undefined) // report "banner decided not to show" to sync decision with other components
        onConsentBannerBailOut?.();
    }, [
        showBanner,
        isPrefetchedPreferencesState,
        onConsentBannerBailOut
    ]);
    if (!showBanner) return null;
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $bHcZt.FlagsProvider), {
        children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $c92052f02b4f1e2c$export$9aa38aed134c207f), {
            children: [
                /*#__PURE__*/ (0, $kIqwl.jsx)((0, $4f78cee0f4ae6f10$export$dd3e60478510f81d), {
                    onClickOnlyNecessary: onClickOnlyNecessary,
                    onClickAcceptAll: onClickAcceptAll,
                    onClickPreferences: onClickPreferences,
                    onClickTrackingNoticeLink: onClickTrackingNoticeLink,
                    minWidth: minWidth,
                    newMinHeight: newMinHeight
                }),
                isPreferencesModalOpen && /*#__PURE__*/ (0, $kIqwl.jsx)((0, $bbe9d9ffb1100a9a$export$94c5684831c222e7), {
                    onClose: closePreferenceModal,
                    onSubmit: onPreferenceModalSubmit,
                    showSuccessFlag: showSuccessFlag,
                    showErrorFlag: showErrorFlag,
                    shouldAddWrappers: false
                })
            ]
        })
    });
};



var $kIqwl = parcelRequire("kIqwl");
const $2c754042296d1aa7$export$903b95b8397e77e9 = (props)=>{
    if ((0, $2aEiL.fg)('platform_moonjelly_bsc_master_killswitch') || (0, $2aEiL.fg)('platform_moonjelly_bsc_ui_killswitch')) {
        const { onConsentBannerBailOut: onConsentBannerBailOut } = props;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $1v5pe.useEffect)(()=>{
            onConsentBannerBailOut?.();
        }, [
            onConsentBannerBailOut
        ]);
        // Don't render the consent banner if the killswitch is enabled
        return null;
    }
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $ja864.ErrorBoundary), {
        FallbackComponent: ()=>/*#__PURE__*/ (0, $kIqwl.jsx)("div", {
                "data-testid": "consent-banner-render-error"
            }),
        onError: (e)=>{
            (0, $bEUFb.Logger).errorWithOperationalEvent({
                action: 'renderConsentBannerError',
                message: e.message || ''
            });
        },
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $bHcZt.FlagsProvider), {
            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $33a6600c5da46c88$export$24af610f9b900e82), {
                ...props
            })
        })
    });
};



var $2aEiL = parcelRequire("2aEiL");

var $7WT4C = parcelRequire("7WT4C");
var $dS1lP = parcelRequire("dS1lP");
var $bEUFb = parcelRequire("bEUFb");

var $jeHvL = parcelRequire("jeHvL");
parcelRequire("8zRL5");
var $5noOS = parcelRequire("5noOS");

var $6yOvq = parcelRequire("6yOvq");

var $2aEiL = parcelRequire("2aEiL");

var $jeHvL = parcelRequire("jeHvL");
var $bEUFb = parcelRequire("bEUFb");
var $7WT4C = parcelRequire("7WT4C");

var $7vtyD = parcelRequire("7vtyD");

var $8zRL5 = parcelRequire("8zRL5");
var $5noOS = parcelRequire("5noOS");

var $2W5OM = parcelRequire("2W5OM");

var $hEEEo = parcelRequire("hEEEo");
function $81753edb4e325c61$var$isCategoryRevoked({ category: category, preferences: preferences }) {
    if (category === (0, $2W5OM.PreferenceCategory).StrictlyNecessary) return false;
    if (!preferences) return false;
    return !preferences[category];
}
function $81753edb4e325c61$var$yieldToMain() {
    return new Promise((resolve)=>setTimeout(resolve, 0));
}
const $81753edb4e325c61$var$ITEMS_PER_YIELD = 50;
// Per-run enumeration cap. Yielding to the main thread every ITEMS_PER_YIELD items is independent
// of the limit, so the loop stays cooperative however high this is set.
const $81753edb4e325c61$var$ENUMERATION_LIMIT = 10000;
const $81753edb4e325c61$export$54394d3cfbbf53d0 = 1000;
// `deleteDatabase` completes only once every other connection to that database closes, which the
// browser asks for by firing `versionchange` on each of them. Nothing obliges a holder to listen, so
// the wait needs a bound. Confirmations run concurrently, making this the cost to a run rather than
// the cost per database.
const $81753edb4e325c61$var$IDB_DELETE_CONFIRM_TIMEOUT_MS = 500;
function $81753edb4e325c61$var$isRunningInFrame() {
    try {
        return window.top !== window.self;
    } catch  {
        // A cross-origin read of `window.top` throws, which itself proves we are framed.
        return true;
    }
}
/**
 * Resolves for every outcome rather than rejecting, so one database cannot fail a whole run.
 *
 * `blocked` is deliberately not handled: it is not an outcome. Another open connection leaves the
 * request pending, and `success` still arrives if those connections close, so treating `blocked` as
 * a failure would report a delete that then went through as undeleted. The deadline decides instead
 * — unblocked in time counts as deleted, still blocked when it expires does not.
 */ function $81753edb4e325c61$var$deleteDatabaseAndConfirm(idb, name) {
    return new Promise((resolve)=>{
        let settled = false;
        let timeoutId;
        const settle = (deleted)=>{
            if (settled) return;
            settled = true;
            if (timeoutId !== undefined) clearTimeout(timeoutId);
            resolve(deleted);
        };
        const request = idb.deleteDatabase(name);
        request.onsuccess = ()=>settle(true);
        request.onerror = ()=>{
            (0, $bEUFb.Logger).warn(`cleanupStorage: failed to delete IndexedDB "${name}": ${request.error?.message ?? ''}`);
            settle(false);
        };
        timeoutId = setTimeout(()=>settle(false), $81753edb4e325c61$var$IDB_DELETE_CONFIRM_TIMEOUT_MS);
    });
}
/**
 * A cookie is identified by name + domain + path, and `document.cookie` exposes only the name. An
 * expiry therefore has to guess the other two, and a guess that misses is silently accepted by the
 * browser, so reading the cookie back is the only way to know it went away.
 *
 * Two scopes are tried: host-only, then the served host as an explicit `domain`, because scoping to
 * `Domain=<current host>` is a common library default that a host-only expiry cannot match.
 *
 * Known limitations, all reported as `false` rather than papered over:
 *
 * - **No domain above the served host is tried.** A cookie on a parent or registrable domain — where
 *   the vendor tags we embed (`_ga`, `_fbp`, `_gcl_au`) and our own cross-property cookies live — is
 *   out of reach.
 * - **Non-root paths are never tried.** js-cookie defaults to `path=/`.
 * - **`HttpOnly` cookies are invisible here**, so they are never even enumerated.
 */ function $81753edb4e325c61$var$deleteCookieAndConfirm(key) {
    // `__Secure-`/`__Host-` names are rejected unless the expiring `Set-Cookie` also carries
    // `Secure`. It is not part of a cookie's identity so it is harmless on ordinary cookies, but a
    // non-secure origin ignores the whole header, so only send it where it can take effect.
    const secure = window.location.protocol === 'https:' ? {
        secure: true
    } : {};
    // `atl-set-cookie` marks both expiries below as the package's own writes, which is what the
    // `document.cookie` setter override checks before passing one through. Without it the override
    // consent-checks the expiry against the very category the cookie is being deleted for, takes its
    // blocked branch, and never calls the original setter.
    (0, $6yOvq.default).remove(key, {
        ...secure,
        'atl-set-cookie': true
    });
    if ((0, $6yOvq.default).get(key) === undefined) return true;
    // Still there, so the cookie carries an explicit `Domain`. Two names make even the served-host
    // attempt pointless: a `__Host-` cookie must be host-only, and on a single-label host
    // (`localhost`, an intranet name) `.localhost` matches nothing.
    const { hostname: hostname } = window.location;
    if (key.startsWith('__Host-') || hostname.split('.').length < 2) return false;
    (0, $6yOvq.default).remove(key, {
        ...secure,
        domain: `.${hostname}`,
        'atl-set-cookie': true
    });
    return (0, $6yOvq.default).get(key) === undefined;
}
async function $81753edb4e325c61$export$e6332b39565fb2b3() {
    // One read per run, outside the try so the catch path agrees. `fg()` reads gate config that can
    // change mid-run and this function's p99 is seconds, so re-reading risks a run that deletes
    // while reporting `dry-run`.
    const deletionMode = (0, $2aEiL.fg)('platform_bsc_cleanup_revoked_storage_live_delete') ? 'live' : 'dry-run';
    const isLiveDelete = deletionMode === 'live';
    try {
        const cleanupStartTime = performance.now();
        const globalState = (0, $jeHvL.getBscGlobalState)();
        const preferences = await (0, $hEEEo.getPreferences)();
        const localStorage = (0, $8zRL5.findStorageTarget)((0, $5noOS.WebStorageType).LocalStorage);
        const sessionStorage = (0, $8zRL5.findStorageTarget)((0, $5noOS.WebStorageType).SessionStorage);
        const idb = window.indexedDB;
        const productName = globalState.product;
        const [localStorageCache, sessionStorageCache, cookieCache, indexedDBCache] = await Promise.all([
            globalState.loadCache((0, $2W5OM.CategoryStorageType).LocalStorage),
            globalState.loadCache((0, $2W5OM.CategoryStorageType).SessionStorage),
            globalState.loadCache((0, $2W5OM.CategoryStorageType).Cookies),
            globalState.loadCache((0, $2W5OM.CategoryStorageType).IndexedDB)
        ]);
        const revokedItems = [];
        const uncategorizedItems = [];
        let hitEnumerationLimit = false;
        let itemsProcessed = 0;
        let deletionCount = 0;
        const skippedTypes = [];
        const undeletedItems = [];
        const inFrame = $81753edb4e325c61$var$isRunningInFrame();
        const pendingIdbConfirmations = [];
        // localStorage
        const shouldDeleteWebStorage = !globalState.disableWebStorageConsentChecks && globalState.webStorageEnabled;
        if (!localStorageCache) skippedTypes.push({
            storageType: 'localStorage',
            reason: 'cacheUnavailable'
        });
        else {
            // Cleanup is an internal operation, so it works on the store the wrapper wraps rather than
            // through the wrapper: the read-back below is untrapped, where the wrapper's `getItem`
            // emits `usedAtlBrowserStorageGetItem` on every call. Keys are taken up front so a removal
            // cannot shift the items still to be visited. `Object.keys` would be shorter but omits any
            // item whose name collides with a `Storage` own property — WebKit hides a stored `length`
            // from it, where `key(i)` still reports it.
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const localStore = localStorage.storage;
            const localKeys = Array.from({
                length: localStore.length
            }, (_, i)=>localStore.key(i)).filter((key)=>key !== null);
            for (const key of localKeys){
                if (itemsProcessed >= $81753edb4e325c61$var$ENUMERATION_LIMIT) {
                    hitEnumerationLimit = true;
                    break;
                }
                if ((itemsProcessed + 1) % $81753edb4e325c61$var$ITEMS_PER_YIELD === 0) await $81753edb4e325c61$var$yieldToMain();
                const category = (0, $7vtyD.getItemCategoryFromPassedCache)(key, localStorageCache, productName);
                if (category === null || category === (0, $2W5OM.PreferenceCategory).Unknown) uncategorizedItems.push({
                    key: key,
                    storageType: 'localStorage'
                });
                else if ($81753edb4e325c61$var$isCategoryRevoked({
                    category: category,
                    preferences: preferences
                })) {
                    const item = {
                        key: key,
                        storageType: 'localStorage',
                        category: category
                    };
                    revokedItems.push(item);
                    if (shouldDeleteWebStorage && isLiveDelete) {
                        localStore.removeItem(key);
                        const removed = localStore.getItem(key) === null;
                        item.deleted = removed;
                        if (!removed) undeletedItems.push(item);
                        deletionCount++;
                    }
                }
                itemsProcessed++;
            }
        }
        // sessionStorage
        if (hitEnumerationLimit) skippedTypes.push({
            storageType: 'sessionStorage',
            reason: 'enumerationLimit'
        });
        else if (!sessionStorageCache) skippedTypes.push({
            storageType: 'sessionStorage',
            reason: 'cacheUnavailable'
        });
        else {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const sessionStore = sessionStorage.storage;
            const sessionKeys = Array.from({
                length: sessionStore.length
            }, (_, i)=>sessionStore.key(i)).filter((key)=>key !== null);
            for (const key of sessionKeys){
                if (itemsProcessed >= $81753edb4e325c61$var$ENUMERATION_LIMIT) {
                    hitEnumerationLimit = true;
                    break;
                }
                if ((itemsProcessed + 1) % $81753edb4e325c61$var$ITEMS_PER_YIELD === 0) await $81753edb4e325c61$var$yieldToMain();
                const category = (0, $7vtyD.getItemCategoryFromPassedCache)(key, sessionStorageCache, productName);
                if (category === null || category === (0, $2W5OM.PreferenceCategory).Unknown) uncategorizedItems.push({
                    key: key,
                    storageType: 'sessionStorage'
                });
                else if ($81753edb4e325c61$var$isCategoryRevoked({
                    category: category,
                    preferences: preferences
                })) {
                    const item = {
                        key: key,
                        storageType: 'sessionStorage',
                        category: category
                    };
                    revokedItems.push(item);
                    if (shouldDeleteWebStorage && isLiveDelete) {
                        sessionStore.removeItem(key);
                        const removed = sessionStore.getItem(key) === null;
                        item.deleted = removed;
                        if (!removed) undeletedItems.push(item);
                        deletionCount++;
                    }
                }
                itemsProcessed++;
            }
        }
        // cookies
        if (hitEnumerationLimit) skippedTypes.push({
            storageType: 'cookie',
            reason: 'enumerationLimit'
        });
        else if (!cookieCache) skippedTypes.push({
            storageType: 'cookie',
            reason: 'cacheUnavailable'
        });
        else for (const key of Object.keys((0, $6yOvq.default).get())){
            if (itemsProcessed >= $81753edb4e325c61$var$ENUMERATION_LIMIT) {
                hitEnumerationLimit = true;
                break;
            }
            if ((itemsProcessed + 1) % $81753edb4e325c61$var$ITEMS_PER_YIELD === 0) await $81753edb4e325c61$var$yieldToMain();
            const category = (0, $7vtyD.getItemCategoryFromPassedCache)(key, cookieCache, productName);
            if (category === null || category === (0, $2W5OM.PreferenceCategory).Unknown) uncategorizedItems.push({
                key: key,
                storageType: 'cookie'
            });
            else if ($81753edb4e325c61$var$isCategoryRevoked({
                category: category,
                preferences: preferences
            })) {
                const item = {
                    key: key,
                    storageType: 'cookie',
                    category: category
                };
                revokedItems.push(item);
                // There's no corresponding `shouldDeleteWebStorage` for cookies as they have no reporting-only mode.
                if (isLiveDelete) {
                    item.deleted = $81753edb4e325c61$var$deleteCookieAndConfirm(key);
                    if (!item.deleted) undeletedItems.push(item);
                    deletionCount++;
                }
            }
            itemsProcessed++;
        }
        // IndexedDB
        const shouldDeleteIdb = !globalState.disableIndexedDbConsentChecks && globalState.indexedDbEnabled;
        if (hitEnumerationLimit) skippedTypes.push({
            storageType: 'indexedDB',
            reason: 'enumerationLimit'
        });
        else if (!indexedDBCache) skippedTypes.push({
            storageType: 'indexedDB',
            reason: 'cacheUnavailable'
        });
        else if (typeof idb?.databases !== 'function') // Safari and Firefox do not implement `indexedDB.databases()`.
        skippedTypes.push({
            storageType: 'indexedDB',
            reason: 'unsupported'
        });
        else try {
            const dbs = await idb.databases();
            for (const db of dbs){
                if (itemsProcessed >= $81753edb4e325c61$var$ENUMERATION_LIMIT) {
                    hitEnumerationLimit = true;
                    break;
                }
                if ((itemsProcessed + 1) % $81753edb4e325c61$var$ITEMS_PER_YIELD === 0) await $81753edb4e325c61$var$yieldToMain();
                const name = db.name;
                if (name === undefined) continue;
                const category = (0, $7vtyD.getItemCategoryFromPassedCache)(name, indexedDBCache, productName);
                if (category === null || category === (0, $2W5OM.PreferenceCategory).Unknown) uncategorizedItems.push({
                    key: name,
                    storageType: 'indexedDB'
                });
                else if ($81753edb4e325c61$var$isCategoryRevoked({
                    category: category,
                    preferences: preferences
                })) {
                    const item = {
                        key: name,
                        storageType: 'indexedDB',
                        category: category
                    };
                    revokedItems.push(item);
                    if (shouldDeleteIdb && isLiveDelete) {
                        // Collected, not awaited inline: serial waits would make the worst case the sum of
                        // the per-database timeouts instead of the longest one.
                        pendingIdbConfirmations.push($81753edb4e325c61$var$deleteDatabaseAndConfirm(idb, name).then((deleted)=>{
                            item.deleted = deleted;
                            if (!deleted) undeletedItems.push(item);
                        }));
                        deletionCount++;
                    }
                }
                itemsProcessed++;
            }
        } catch  {
            // idb.databases() unavailable or threw — skip IDB entirely
            skippedTypes.push({
                storageType: 'indexedDB',
                reason: 'error'
            });
        }
        if (pendingIdbConfirmations.length > 0) await Promise.all(pendingIdbConfirmations);
        if (deletionCount > 0) (0, $7WT4C.sendPackageOperationalEvent)({
            action: 'storageCleanupDeleted',
            attributes: {
                deletedCount: deletionCount - undeletedItems.length,
                undeletedCount: undeletedItems.length
            }
        });
        (0, $7WT4C.sendPackageOperationalEvent)({
            action: 'storageCleanupCategorized',
            attributes: {
                durationMs: Math.round(performance.now() - cleanupStartTime),
                deletionMode: deletionMode,
                revokedCount: revokedItems.length,
                revokedItems: revokedItems.map(({ storageType: storageType, key: key, category: category })=>`${storageType} ${key} ${category}`),
                uncategorizedCount: uncategorizedItems.length,
                uncategorizedItems: uncategorizedItems.map(({ storageType: storageType, key: key })=>`${storageType} ${key}`),
                hitEnumerationLimit: hitEnumerationLimit,
                hitRevokedCountCeiling: revokedItems.length > $81753edb4e325c61$export$54394d3cfbbf53d0,
                ...isLiveDelete ? {
                    undeletedCount: undeletedItems.length,
                    undeletedItems: undeletedItems.map(({ storageType: storageType, key: key })=>`${storageType} ${key}`)
                } : {},
                // Sent even when empty, so full coverage reads as an explicit empty value rather than a
                // missing attribute.
                skippedTypes: skippedTypes.map(({ storageType: storageType, reason: reason })=>`${storageType}:${reason}`).join(','),
                inFrame: inFrame
            }
        });
        return {
            deletionMode: deletionMode,
            revokedItems: revokedItems,
            uncategorizedItems: uncategorizedItems,
            hitEnumerationLimit: hitEnumerationLimit,
            skippedTypes: skippedTypes,
            inFrame: inFrame
        };
    } catch (error) {
        (0, $bEUFb.Logger).errorWithOperationalEvent({
            action: 'storageCleanupError',
            message: `cleanupStorage failed: ${error?.message ?? 'no message'}`
        });
        return {
            deletionMode: deletionMode,
            revokedItems: [],
            uncategorizedItems: [],
            hitEnumerationLimit: false
        };
    }
}



var $bEUFb = parcelRequire("bEUFb");

var $jeHvL = parcelRequire("jeHvL");
var $7WT4C = parcelRequire("7WT4C");

var $7WT4C = parcelRequire("7WT4C");

var $hORic = parcelRequire("hORic");

var $7vtyD = parcelRequire("7vtyD");

var $bEUFb = parcelRequire("bEUFb");
/**
 * Tracks which uncategorized storage-item keys have already emitted an
 * `uncategorizedWebStorageItemSet` track event this session, so repeated writes
 * of the same unknown key don't emit duplicate events.
 *
 * State is module-level (per page load), which gives us the "per session"
 * semantic for free — it resets naturally on reload. Same pattern as
 * `ItemKeyCache` (item-key-cache-service) and the logger error-event throttle.
 *
 * Keys are scoped by storage type so the same key name in different storage
 * types (e.g. a cookie and a localStorage item both named `foo`) remain
 * distinct reportable signals.
 */ class $335e109f486de69d$var$UncategorizedItemReportCacheService {
    reportedKeys = new Set();
    compositeKey(storageType, itemKey) {
        return `${storageType}::${itemKey}`;
    }
    markReported(storageType, itemKey) {
        this.reportedKeys.add(this.compositeKey(storageType, itemKey));
    }
    wasReported(storageType, itemKey) {
        return this.reportedKeys.has(this.compositeKey(storageType, itemKey));
    }
    // Test-only helper to reset the per-process cache between tests.
    __reset() {
        this.reportedKeys.clear();
    }
}
let $335e109f486de69d$var$cacheInstance;
/**
 * Lazily creates the cache on first use.
 */ function $335e109f486de69d$var$getCache() {
    if (!$335e109f486de69d$var$cacheInstance) $335e109f486de69d$var$cacheInstance = new $335e109f486de69d$var$UncategorizedItemReportCacheService();
    return $335e109f486de69d$var$cacheInstance;
}
function $335e109f486de69d$export$270367a42ceba9fe() {
    $335e109f486de69d$var$cacheInstance = undefined;
}
function $335e109f486de69d$export$eda682c722f364aa(storageType, itemKey) {
    return !$335e109f486de69d$var$getCache().wasReported(storageType, itemKey);
}
function $335e109f486de69d$export$c81f34d18a3c37c3(storageType, itemKey) {
    return ()=>$335e109f486de69d$var$getCache().markReported(storageType, itemKey);
}



var $2W5OM = parcelRequire("2W5OM");
const $0b3badc7bcc48266$export$b7364c41ddbfdb0a = (originalSetter)=>(originalCookieValue)=>{
        const cookieSetByPackage = originalCookieValue.includes('atl-set-cookie');
        if (cookieSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetter.apply(document, [
                originalCookieValue
            ]);
        } catch (e) {
            (0, $bEUFb.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `document.cookie setter failed to set cookie set by package. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false
                }
            });
        }
        const extensionSignals = (0, $hORic.captureCallerSignals)();
        // Set cookie function reports failure by throwing and callers such as the availability probes
        // depend on that, so a synchronous write failure has to leave this override. Collected here
        // rather than thrown inline, because the handler that catches it sits inside
        // another handler that would report the same error again.
        let setCookieFailure;
        try {
            // Raw cookies and query params can contain sensitive PII/UGC we can't store, so we want to
            // strip that out before we log it out to our analytics client.
            const sanitizedCookieKey = originalCookieValue.slice(0, originalCookieValue.indexOf('=')) || '';
            (0, $7WT4C.sendPackageOperationalEvent)({
                action: 'usedDocumentCookie',
                attributes: {
                    cookieKey: sanitizedCookieKey,
                    outsidePackage: !cookieSetByPackage
                }
            });
            try {
                const productName = (0, $jeHvL.getBscGlobalState)().product;
                // MaybeSync skips the promise entirely once categories and preferences are loaded, which
                // is what keeps the write and any throw from it synchronous.
                // Attempt to set a known cookie that was set from outside the package
                const processingCheck = (0, $7vtyD.isProcessingAllowedByPreferencesMaybeSync)({
                    itemKey: sanitizedCookieKey,
                    allowedCallback: ()=>{
                        return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory, itemCategory: itemCategory })=>{
                        if (!itemHasCategory && (0, $335e109f486de69d$export$eda682c722f364aa)((0, $2W5OM.CategoryStorageType).Cookies, sanitizedCookieKey)) (0, $7WT4C.sendTrackEvent)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: {
                                storageType: (0, $2W5OM.CategoryStorageType).Cookies,
                                productName: productName,
                                originalItemKey: sanitizedCookieKey,
                                itemCategory: itemCategory ?? null,
                                cacheLoadedDate: (0, $jeHvL.getBscGlobalState)().cacheLoadedDate ?? null
                            },
                            onSent: (0, $335e109f486de69d$export$c81f34d18a3c37c3)((0, $2W5OM.CategoryStorageType).Cookies, sanitizedCookieKey)
                        });
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides } = (0, $jeHvL.getBscGlobalState)();
                        if (allowUncategorizedCookiesInOverrides && !itemHasCategory) return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                        else {
                            if (!itemHasCategory) (0, $bEUFb.Logger).warn(`document.cookie setter for '${sanitizedCookieKey}' was blocked` + `${productName ? ` for product "${productName}"` : ''}` + `: '${sanitizedCookieKey}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
                            return;
                        }
                    },
                    storageType: (0, $2W5OM.CategoryStorageType).Cookies,
                    productName: productName,
                    extensionSignals: extensionSignals
                });
                if ((0, $7vtyD.isPromise)(processingCheck)) processingCheck.catch((e)=>{
                    (0, $bEUFb.Logger).errorWithOperationalEvent({
                        action: 'usedDocumentCookieError',
                        message: `Failed to set cookie. ${e?.message || ''}`,
                        attributes: {
                            cookieKey: sanitizedCookieKey
                        }
                    });
                });
            } catch (e) {
                (0, $bEUFb.Logger).errorWithOperationalEvent({
                    action: 'usedDocumentCookieError',
                    message: `Failed to set cookie. ${e.message || ''}`,
                    attributes: {
                        cookieKey: sanitizedCookieKey
                    }
                });
                setCookieFailure = e;
            }
        } catch (e) {
            (0, $bEUFb.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `Failed to send document.cookie setter event. ${e.message || ''}`
            });
        }
        if (setCookieFailure) throw setCookieFailure;
    };


const $3f750fb9611ccfa5$export$50a17589ab8bbee4 = ()=>{
    const documentCookieProperty = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
    const originalSetter = documentCookieProperty?.set;
    const originalGetter = documentCookieProperty?.get;
    if (!originalSetter || !originalGetter) {
        (0, $bEUFb.Logger).warn('No document.cookie capabilities found');
        return;
    }
    // Override document.cookie setter
    Object.defineProperty(document, 'cookie', {
        get: originalGetter,
        set: (0, $0b3badc7bcc48266$export$b7364c41ddbfdb0a)(originalSetter),
        configurable: true
    });
};
const $3f750fb9611ccfa5$export$45a5573b04db016c = async ()=>$3f750fb9611ccfa5$export$50a17589ab8bbee4();



var $bEUFb = parcelRequire("bEUFb");

var $jeHvL = parcelRequire("jeHvL");
var $7WT4C = parcelRequire("7WT4C");

var $hORic = parcelRequire("hORic");

var $7vtyD = parcelRequire("7vtyD");

var $bEUFb = parcelRequire("bEUFb");

var $dmmsG = parcelRequire("dmmsG");

var $dS1lP = parcelRequire("dS1lP");
/**
 * Minimal no-op implementation for SSR environments.
 * Provides the IDBOpenDBRequest interface without relying on EventTarget.
 * This class does not extend EventTarget, making it safe to instantiate in Node.js.
 */ class $ec334ab4b552d28a$export$55ffeaf417e03b66 {
    _error = null;
    _result = null;
    _readyState = 'pending';
    _source = null;
    _transaction = null;
    get error() {
        return this._error;
    }
    get result() {
        return this._result;
    }
    get readyState() {
        return this._readyState;
    }
    get source() {
        return this._source;
    }
    get transaction() {
        return this._transaction;
    }
    onerror = null;
    onsuccess = null;
    onblocked = null;
    onupgradeneeded = null;
    // No-op event methods for SSR
    addEventListener() {}
    removeEventListener() {}
    dispatchEvent() {
        return false;
    }
    // Wrapper-specific methods that shouldn't be called in SSR but are part of the interface
    wrapRequest() {
        throw new Error('IDBOpenDBRequestWrapper cannot wrap requests in SSR environment');
    }
    isWrapping() {
        return false;
    }
    getWrappedRequest() {
        return null;
    }
    unbind() {}
    setError(error) {
        this._error = error;
    }
    setResult(result) {
        this._result = result;
    }
    setReadyState(state) {
        this._readyState = state;
    }
    setSource(source) {
        this._source = source;
    }
    setTransaction(transaction) {
        this._transaction = transaction;
    }
}


// Store the browser implementation class here - defined conditionally below
let $15993080048de7c9$var$BrowserImpl;
/**
 * Browser-only implementation that extends EventTarget.
 * Only defined in browser environments where EventTarget is available.
 * This conditional definition prevents "EventTarget is not defined" errors in SSR.
 */ if (typeof EventTarget !== 'undefined') // Define the class inside this block so it's never parsed in SSR
$15993080048de7c9$var$BrowserImpl = class IDBOpenDBRequestWrapperImpl extends EventTarget {
    _error = null;
    _result = null;
    _readyState = 'pending';
    _source = null;
    _transaction = null;
    _wrappedRequest = null;
    _unbindEventListeners = null;
    // Implementing IDBRequest readonly properties with getters
    get error() {
        return this._wrappedRequest?.error ?? this._error;
    }
    get result() {
        return this._wrappedRequest?.result ?? this._result;
    }
    get readyState() {
        return this._wrappedRequest?.readyState ?? this._readyState;
    }
    get source() {
        return this._wrappedRequest?.source ?? this._source;
    }
    get transaction() {
        return this._wrappedRequest?.transaction ?? this._transaction;
    }
    // Event handler properties (can be set directly by consumers)
    onerror = null;
    onsuccess = null;
    onblocked = null;
    onupgradeneeded = null;
    /**
     * Wrap an existing IDBOpenDBRequest to proxy its events to this wrapper.
     * Once wrapped, all property getters will delegate to the wrapped request,
     * and all events from the wrapped request will be re-dispatched on this wrapper.
     *
     * @param request - The real IDBOpenDBRequest to wrap
     */ wrapRequest(request) {
        if (this._wrappedRequest) throw new Error('This IDBOpenDBRequestWrapper is already wrapping another request');
        this._wrappedRequest = request;
        // Proxy all events from the wrapped request to this wrapper using bindAll
        this._unbindEventListeners = (0, $dmmsG.bindAll)(request, [
            {
                type: 'success',
                listener: (e)=>{
                    this.dispatchEvent(new Event('success', e));
                }
            },
            {
                type: 'error',
                listener: (e)=>{
                    this.dispatchEvent(new Event('error', e));
                }
            },
            {
                type: 'blocked',
                listener: (e)=>{
                    const versionChangeEvent = new IDBVersionChangeEvent('blocked', e);
                    this.dispatchEvent(versionChangeEvent);
                }
            },
            {
                type: 'upgradeneeded',
                listener: (e)=>{
                    const versionChangeEvent = new IDBVersionChangeEvent('upgradeneeded', e);
                    this.dispatchEvent(versionChangeEvent);
                }
            }
        ]);
    }
    /**
     * Check if this mock is wrapping a real request
     */ isWrapping() {
        return this._wrappedRequest !== null;
    }
    /**
     * Get the wrapped request (if any)
     */ getWrappedRequest() {
        return this._wrappedRequest;
    }
    /**
     * Unbind all event listeners attached to the wrapped request.
     * Should be called when the wrapper is no longer needed.
     */ unbind() {
        if (this._unbindEventListeners) {
            this._unbindEventListeners();
            this._unbindEventListeners = null;
        }
        this._wrappedRequest = null;
    }
    /**
     * Set the error property (normally readonly)
     * Only works when not wrapping another request
     */ setError(error) {
        if (this._wrappedRequest) throw new Error('Cannot set error on a wrapping IDBOpenDBRequestWrapper');
        this._error = error;
    }
    /**
     * Set the result property (normally readonly)
     * Only works when not wrapping another request
     */ setResult(result) {
        if (this._wrappedRequest) throw new Error('Cannot set result on a wrapping IDBOpenDBRequestWrapper');
        this._result = result;
    }
    /**
     * Set the readyState property (normally readonly)
     * Only works when not wrapping another request
     */ setReadyState(state) {
        if (this._wrappedRequest) throw new Error('Cannot set readyState on a wrapping IDBOpenDBRequestWrapper');
        this._readyState = state;
    }
    /**
     * Set the source property (normally readonly)
     * Only works when not wrapping another request
     */ setSource(source) {
        if (this._wrappedRequest) throw new Error('Cannot set source on a wrapping IDBOpenDBRequestWrapper');
        this._source = source;
    }
    /**
     * Set the transaction property (normally readonly)
     * Only works when not wrapping another request
     */ setTransaction(transaction) {
        if (this._wrappedRequest) throw new Error('Cannot set transaction on a wrapping IDBOpenDBRequestWrapper');
        this._transaction = transaction;
    }
    /**
     * Override dispatchEvent to also call the corresponding event handler if set
     */ dispatchEvent(event) {
        const result = super.dispatchEvent(event);
        // Call the appropriate event handler if it exists
        switch(event.type){
            case 'error':
                if (this.onerror) this.onerror.call(this, event);
                break;
            case 'success':
                if (this.onsuccess) this.onsuccess.call(this, event);
                break;
            case 'blocked':
                if (this.onblocked) this.onblocked.call(this, event);
                break;
            case 'upgradeneeded':
                if (this.onupgradeneeded) this.onupgradeneeded.call(this, event);
                break;
        }
        return result;
    }
};
function $15993080048de7c9$export$4037ef1f5b40c4b6() {
    if ((0, $dS1lP.isSSR)() || typeof EventTarget === 'undefined' || !$15993080048de7c9$var$BrowserImpl) return new (0, $ec334ab4b552d28a$export$55ffeaf417e03b66)();
    return new $15993080048de7c9$var$BrowserImpl();
}
const $15993080048de7c9$export$c69b1cb39abae960 = $15993080048de7c9$var$BrowserImpl;



var $jeHvL = parcelRequire("jeHvL");
var $dS1lP = parcelRequire("dS1lP");
function $25fbb495118a1dc5$export$ae0d255aec75942(enableSSRCheck = true, enableFeatureFlagCheck = true) {
    // Check if running in SSR environment
    if (enableSSRCheck && (0, $dS1lP.isSSR)()) return {
        available: false,
        reason: 'IndexedDB is not available in SSR environment'
    };
    if (!globalThis.indexedDB) return {
        available: false,
        reason: 'IndexedDB is not supported in this browser'
    };
    if (enableFeatureFlagCheck) {
        const globalState = (0, $jeHvL.getBscGlobalState)();
        if (globalState.indexedDbEnabled === false) return {
            available: true,
            reason: 'Using native IndexedDB: IndexedDB controls are disabled',
            bypassImplementation: true
        };
    }
    return {
        available: true
    };
}
function $25fbb495118a1dc5$export$a5be9a74f3347ccf(dbName) {
    // Database name should not be empty and should be a string
    return typeof dbName === 'string' && dbName.trim().length > 0;
}
function $25fbb495118a1dc5$export$396291456af4fc3(version) {
    // Version should be undefined or a positive integer
    if (version === undefined) return true;
    return Number.isInteger(version) && version > 0;
}



var $kqaLu = parcelRequire("kqaLu");

var $2W5OM = parcelRequire("2W5OM");
// DatabaseBlockedError extends DOMException in browser environments, but DOMException is not
// available in SSR/Node.js, which causes import errors. We conditionally extend DOMException
// only when it is available, falling back to a plain Error in SSR — the same pattern used
// for IDBOpenDBRequestWrapper.
let $82eba2e4cc82043d$var$DatabaseBlockedError;
if (typeof DOMException !== 'undefined') $82eba2e4cc82043d$var$DatabaseBlockedError = class DatabaseBlockedError extends DOMException {
};
else $82eba2e4cc82043d$var$DatabaseBlockedError = class DatabaseBlockedError extends Error {
    name;
    constructor(message, name = 'DatabaseBlockedError'){
        super(message), this.name = name;
    }
};
const $82eba2e4cc82043d$var$checkAndSendAnalyticsEvent = async (eventDetails)=>{
    const wasSetByPackage = (0, $kqaLu.ItemKeyCache).wasSetByPackage((0, $2W5OM.CategoryStorageType).IndexedDB, eventDetails.databaseName);
    const productName = (0, $jeHvL.getBscGlobalState)().product;
    const itemCategory = await (0, $7vtyD.getItemCategory)(eventDetails.databaseName, (0, $2W5OM.CategoryStorageType).IndexedDB, productName);
    const isStrictlyNecessary = itemCategory === (0, $2W5OM.PreferenceCategory).StrictlyNecessary;
    // Strictly-necessary and package-set databases never block, so omit their telemetry.
    if (!isStrictlyNecessary && !wasSetByPackage) {
        const attributes = {
            ...eventDetails,
            productName: productName,
            outsidePackage: true,
            itemCategory: itemCategory ?? (0, $2W5OM.PreferenceCategory).Unknown
        };
        // Send analytics event for uncategorized IndexedDB usage
        (0, $7WT4C.sendPackageOperationalEvent)({
            action: 'usedAtlIndexedDBOpen',
            attributes: attributes
        });
    }
};
// Keep forwarding `extensionSignals` to `isProcessingAllowedByPreferencesWithCategory` — extension
// writes rely on it to bypass the consent check.
const $82eba2e4cc82043d$var$checkIfAllowedWithCategory = async (dbName, extensionSignals)=>{
    if (!(0, $25fbb495118a1dc5$export$a5be9a74f3347ccf)(dbName)) {
        const error = new Error('Invalid database name: must be a non-empty string');
        (0, $bEUFb.Logger).errorWithOperationalEvent({
            action: 'usedAtlIndexedDBOpenError',
            attributes: {
                dbName: dbName
            },
            message: `IndexedDB open failed: ${error.message}`
        });
        throw error;
    }
    const productName = (0, $jeHvL.getBscGlobalState)().product;
    const { isAllowed: isAllowed, itemCategory: itemCategory } = await (0, $7vtyD.isProcessingAllowedByPreferencesWithCategory)({
        itemKey: dbName,
        storageType: (0, $2W5OM.CategoryStorageType).IndexedDB,
        productName: productName,
        extensionSignals: extensionSignals
    });
    return {
        isAllowed: isAllowed,
        itemCategory: itemCategory
    };
};
const $82eba2e4cc82043d$export$5a412306febb78c = (originalOpen)=>(databaseName, version)=>{
        $82eba2e4cc82043d$var$checkAndSendAnalyticsEvent({
            databaseName: databaseName
        }).catch((e)=>{
            (0, $bEUFb.Logger).error(`Failed to send IndexedDB open event. ${e.message || ''}`);
        });
        // Always allow the operation to proceed (we're only tracking usage)
        return originalOpen(databaseName, version);
    };
const $82eba2e4cc82043d$export$5721aa15a04b1881 = (originalOpen)=>(databaseName, version)=>{
        const wasSetByPackage = (0, $kqaLu.ItemKeyCache).wasSetByPackage((0, $2W5OM.CategoryStorageType).IndexedDB, databaseName);
        if (wasSetByPackage) return originalOpen(databaseName, version);
        const extensionSignals = (0, $hORic.captureCallerSignals)();
        (0, $bEUFb.Logger).debug(`IndexedDB operation: overridden open on database \"${databaseName}\"`, {
            version: String(version ?? 'unspecified')
        });
        const requestWrapper = (0, $15993080048de7c9$export$4037ef1f5b40c4b6)();
        // Always resolve category information for telemetry and so the uncategorized passthrough
        // can distinguish an unknown database from one the user denied.
        const allowUncategorizedOverride = !!(0, $jeHvL.getBscGlobalState)().allowUncategorizedItemsInIndexedDBOverrides;
        const allowedPromise = $82eba2e4cc82043d$var$checkIfAllowedWithCategory(databaseName, extensionSignals).then(({ isAllowed: isAllowed, itemCategory: itemCategory })=>({
                isAllowed: isAllowed,
                itemCategory: itemCategory ?? (0, $2W5OM.PreferenceCategory).Unknown,
                categoryAttribute: {
                    itemCategory: itemCategory ?? (0, $2W5OM.PreferenceCategory).Unknown
                }
            }));
        allowedPromise.then(({ isAllowed: isAllowed, itemCategory: itemCategory, categoryAttribute: categoryAttribute })=>{
            // When `allowUncategorizedItemsInIndexedDBOverrides` is enabled, databases that have
            // no known category (null/Unknown) are allowed through instead of being blocked. This
            // is a rollout-safety valve — only uncategorized DBs are affected; DBs that are
            // categorized but user-denied are still blocked regardless of this flag.
            const isUncategorized = itemCategory == null || itemCategory === (0, $2W5OM.PreferenceCategory).Unknown;
            const resolvedIsAllowed = isAllowed || allowUncategorizedOverride && isUncategorized;
            (0, $7WT4C.sendPackageOperationalEvent)({
                action: 'usedAtlIndexedDBOpen',
                attributes: {
                    databaseName: databaseName,
                    wasRejected: !resolvedIsAllowed,
                    outsidePackage: true,
                    ...categoryAttribute
                }
            });
            if (resolvedIsAllowed) {
                (0, $bEUFb.Logger).debug(`IndexedDB operation: override on database \"${databaseName}\" was ALLOWED`, {
                    version: String(version ?? 'unspecified')
                });
                const actualRequest = originalOpen(databaseName, version);
                requestWrapper.wrapRequest(actualRequest);
            } else {
                (0, $bEUFb.Logger).debug(`IndexedDB operation: override on database \"${databaseName}\" was REJECTED`, {
                    version: String(version ?? 'unspecified')
                });
                const error = new $82eba2e4cc82043d$var$DatabaseBlockedError('The database was blocked by consent preferences', 'storageItemBlocked');
                const errorEvent = new ErrorEvent('error', {
                    message: error.message,
                    error: error
                });
                requestWrapper.setError(error);
                requestWrapper.dispatchEvent(errorEvent);
            }
        }).catch((e)=>{
            const errorMessage = e instanceof Error ? e.message : String(e);
            (0, $bEUFb.Logger).debug(`IndexedDB operation: override on database \"${databaseName}\" ERROR: ${errorMessage}`, {
                version: String(version ?? 'unspecified')
            });
            (0, $bEUFb.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenError',
                attributes: {
                    databaseName: databaseName,
                    outsidePackage: true
                },
                message: `IndexedDB open failed during preference check: ${errorMessage}`
            });
            const errorEvent = new ErrorEvent('error', {
                message: errorMessage,
                error: e
            });
            requestWrapper.dispatchEvent(errorEvent);
        });
        return requestWrapper;
    };


const $9770e07337bd9d1e$export$bbe9492afe46739 = (config)=>{
    const indexedDB = window.indexedDB;
    if (!indexedDB) {
        (0, $bEUFb.Logger).warn('No IndexedDB capabilities found');
        return;
    }
    if (typeof indexedDB.open !== 'function') {
        (0, $bEUFb.Logger).warn('IndexedDB.open is not a function');
        return;
    }
    try {
        const originalOpen = indexedDB.open.bind(indexedDB);
        (0, $bEUFb.Logger).debug(`Installing IndexedDB override ${config.performConsentChecks ? 'with' : 'without'} consent checks`);
        // Use Object.defineProperty for better browser compatibility and consistency
        // with other passthrough implementations (document.cookie, localStorage/sessionStorage)
        Object.defineProperty(indexedDB, 'open', {
            value: config.performConsentChecks ? (0, $82eba2e4cc82043d$export$5721aa15a04b1881)(originalOpen) : (0, $82eba2e4cc82043d$export$5a412306febb78c)(originalOpen),
            writable: true,
            configurable: true
        });
        (0, $bEUFb.Logger).debug('IndexedDB open override installed');
    } catch (e) {
        (0, $bEUFb.Logger).error(`Failed to install IndexedDB open override. ${e.message || ''}`);
    }
};
const $9770e07337bd9d1e$export$a03098708eb0de1 = async (config)=>$9770e07337bd9d1e$export$bbe9492afe46739(config);



var $bEUFb = parcelRequire("bEUFb");

var $dS1lP = parcelRequire("dS1lP");
var $7WT4C = parcelRequire("7WT4C");

var $bEUFb = parcelRequire("bEUFb");
class $003133068b78d6a1$export$fde2a4e0e57f47e {
    static OPEN_DB_TIMEOUT_MS = 3000;
    dbName;
    storeName;
    bootUpPromiseCache;
    db = null;
    isBooted = false;
    isAvailable = false;
    constructor(dbName, storeName){
        this.dbName = dbName;
        this.storeName = storeName;
        this.isAvailable = this.getIsDBAvailable();
        this.isBooted = false;
        this.bootUpPromiseCache = null;
    }
    async boot() {
        if (!this.isAvailable) {
            (0, $bEUFb.Logger).warn('IndexedDB is not available');
            return;
        }
        if (this.isBooted) // Short circuit if we've already booted once
        return;
        // Only boot once, even if we've been called numerous times sequentially
        if (!this.bootUpPromiseCache) {
            this.bootUpPromiseCache = this.openDB();
            try {
                await this.bootUpPromiseCache;
                this.isBooted = true;
            } catch (e) {
                this.isBooted = false;
                (0, $bEUFb.Logger).warn('Error booting up IndexedDB.');
                throw e;
            }
        }
    }
    getIsDBAvailable() {
        return !(0, $dS1lP.isSSR)() && !!window.indexedDB;
    }
    async openDB() {
        const openPromise = new Promise((resolve, reject)=>{
            let request = indexedDB.open(this.dbName, 2);
            request.onerror = this.onConnectionErrorHandler(reject);
            request.onsuccess = this.onConnectionSuccessHandler(request, resolve);
            request.onupgradeneeded = this.onConnectionUpgradeNeededHandler(request);
        });
        const timeoutPromise = new Promise((_, reject)=>{
            setTimeout(()=>{
                reject(new Error(`IndexedDB open timed out after ${$003133068b78d6a1$export$fde2a4e0e57f47e.OPEN_DB_TIMEOUT_MS}ms`));
            }, $003133068b78d6a1$export$fde2a4e0e57f47e.OPEN_DB_TIMEOUT_MS);
        });
        return Promise.race([
            openPromise,
            timeoutPromise
        ]);
    }
    onConnectionErrorHandler = (reject)=>(event)=>{
            (0, $bEUFb.Logger).warn('Error opening database.');
            reject(event);
        };
    onConnectionSuccessHandler = (connection, resolve)=>()=>{
            this.db = connection.result;
            resolve();
        };
    onConnectionUpgradeNeededHandler = (request)=>()=>{
            this.db = request.result;
            this.db.createObjectStore(this.storeName, {
                keyPath: 'id'
            });
        };
    async getRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) {
                (0, $7WT4C.sendPackageOperationalEvent)({
                    action: 'indexDbSetRecordError',
                    attributes: {
                        recordKey: recordKey
                    }
                });
                return Promise.resolve({
                    atlSetItem: '',
                    id: recordKey
                }); // return empty AtlIndexedDBItem object to exit code
            }
            let fetchTransaction = this.db.transaction([
                this.storeName
            ]);
            let recordStore = fetchTransaction.objectStore(this.storeName);
            const fetchedRecord = new Promise((resolve, reject)=>{
                let request = recordStore.get(recordKey);
                request.onerror = this.onGetRecordErrorHandler(reject);
                request.onsuccess = this.onGetRecordSuccessHandler(request, resolve);
            });
            return fetchedRecord;
        } catch (e) {
            (0, $bEUFb.Logger).error(`Error fetching record from database. ${e.message || ''}`);
            throw e;
        }
    }
    onGetRecordErrorHandler = (reject)=>()=>{
            const getErrorMessage = `Failed to perform a get transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
            (0, $bEUFb.Logger).warn(getErrorMessage);
            reject(getErrorMessage);
        };
    onGetRecordSuccessHandler = (getRequest, resolve)=>()=>{
            resolve(getRequest.result);
        };
    async setRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) {
                (0, $7WT4C.sendPackageOperationalEvent)({
                    action: 'indexDbSetRecordError',
                    attributes: {
                        recordKey: recordKey
                    }
                });
                Promise.resolve(); // return void promise to exit code and not pass a null record
            }
            const setRecord = new Promise((resolve, reject)=>{
                let setTransaction = this.db.transaction([
                    this.storeName
                ], 'readwrite');
                let objectStore = setTransaction.objectStore(this.storeName);
                const newAtlRecord = {
                    atlSetItem: 'SET-BY-PACKAGE',
                    id: recordKey
                };
                let request = objectStore.put(newAtlRecord);
                request.onerror = this.onSetRecordErrorHandler(reject);
                request.onsuccess = this.onSetRecordSuccessHandler(resolve);
            });
            return setRecord;
        } catch (e) {
            (0, $bEUFb.Logger).warn(`Error setting record in database. ${e.message || ''}`);
            throw e;
        }
    }
    onSetRecordErrorHandler = (reject)=>()=>{
            const errorMessage = `Failed to perform a set transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
            (0, $bEUFb.Logger).warn(errorMessage);
            reject(errorMessage);
        };
    onSetRecordSuccessHandler = (resolve)=>()=>{
            resolve();
        };
}
const $003133068b78d6a1$export$36328b3bcbe4623a = new $003133068b78d6a1$export$fde2a4e0e57f47e('BSCIndexedDB', 'InternalStorageKeys');



var $8zRL5 = parcelRequire("8zRL5");
var $5noOS = parcelRequire("5noOS");

var $jeHvL = parcelRequire("jeHvL");
var $7WT4C = parcelRequire("7WT4C");

var $7WT4C = parcelRequire("7WT4C");

var $hORic = parcelRequire("hORic");

var $7vtyD = parcelRequire("7vtyD");

var $bEUFb = parcelRequire("bEUFb");

var $kqaLu = parcelRequire("kqaLu");

parcelRequire("8zRL5");
var $5noOS = parcelRequire("5noOS");

var $36ucG = parcelRequire("36ucG");

var $2W5OM = parcelRequire("2W5OM");
const $fc3d0a73a5e6218d$export$b4469df6294ea6aa = (bscStorage, originalSetItem, storageType)=>(originalItemKey, originalItemValue)=>{
        const categoryStorageType = storageType === (0, $5noOS.WebStorageType).LocalStorage ? (0, $2W5OM.CategoryStorageType).LocalStorage : (0, $2W5OM.CategoryStorageType).SessionStorage;
        const storageContext = bscStorage.storage;
        let itemSetByPackage = false;
        itemSetByPackage = (0, $kqaLu.ItemKeyCache).wasSetByPackage(categoryStorageType, originalItemKey);
        // `disableWebStorageConsentChecks` is read from the package global state so the
        // behaviour stays consistent with other consent-check flags (rather than being
        // threaded through props/options on every call site). When set, the override
        // always passes through to the underlying storage and only emits analytics
        // events — `AtlBrowserStorage` behaviour is preserved.
        const disableWebStorageConsentChecks = (0, $jeHvL.getBscGlobalState)().disableWebStorageConsentChecks ?? false;
        if (disableWebStorageConsentChecks) {
            try {
                (0, $kqaLu.ItemKeyCache).markSetByPackage(categoryStorageType, originalItemKey);
                originalSetItem.apply(storageContext, [
                    originalItemKey,
                    originalItemValue
                ]);
            } catch (e) {
                (0, $36ucG.reportSetItemError)({
                    message: `${storageType} failed to setItem with consent checks disabled. ${e.message || ''}`,
                    attributes: {
                        outsidePackage: !itemSetByPackage,
                        storageType: storageType,
                        consentChecksDisabled: true
                    },
                    error: e
                });
            }
            let wasCheckAsync = true;
            try {
                const productName = (0, $jeHvL.getBscGlobalState)().product;
                const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides } = (0, $jeHvL.getBscGlobalState)();
                // trigger the callbacks to emit analytics events but do nothing with the result.
                (0, $7vtyD.isProcessingAllowedByPreferences)({
                    itemKey: originalItemKey,
                    allowedCallback: ({ wasAsync: wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, $7WT4C.sendPackageOperationalEvent)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType: storageType,
                                wasAsync: wasAsync,
                                consentChecksDisabled: true
                            }
                        });
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory, itemCategory: itemCategory, wasAsync: wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, $7WT4C.sendPackageOperationalEvent)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType: storageType,
                                wasAsync: wasAsync,
                                consentChecksDisabled: true
                            }
                        });
                        if (!itemHasCategory && (0, $335e109f486de69d$export$eda682c722f364aa)(categoryStorageType, originalItemKey)) (0, $7WT4C.sendTrackEvent)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: {
                                storageType: storageType,
                                productName: productName,
                                originalItemKey: originalItemKey,
                                itemCategory: itemCategory ?? null,
                                allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides,
                                allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides,
                                consentChecksDisabled: true,
                                wasAsync: wasAsync,
                                cacheLoadedDate: (0, $jeHvL.getBscGlobalState)().cacheLoadedDate ?? null
                            },
                            onSent: (0, $335e109f486de69d$export$c81f34d18a3c37c3)(categoryStorageType, originalItemKey)
                        });
                    },
                    storageType: categoryStorageType,
                    productName: productName
                });
            } catch (e) {
                (0, $36ucG.reportSetItemError)({
                    message: `Failed to emit analytics with consent checks disabled. ${e.message || ''}`,
                    attributes: {
                        itemKey: originalItemKey,
                        storageType: storageType,
                        consentChecksDisabled: true,
                        wasAsync: wasCheckAsync
                    },
                    error: e
                });
            }
            return;
        }
        if (itemSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetItem.apply(storageContext, [
                originalItemKey,
                originalItemValue
            ]);
        } catch (e) {
            (0, $36ucG.reportSetItemError)({
                message: `${storageType} failed to setItem. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false,
                    storageType: storageType
                },
                error: e
            });
        }
        const extensionSignals = (0, $hORic.captureCallerSignals)();
        // `Storage.setItem` reports failure by throwing and callers such as the availability probes
        // depend on that, so a synchronous write failure has to leave this override. Collected here
        // rather than thrown inline, because the handler that catches it sits inside
        // another handler that would report the same error again.
        let setItemFailure;
        try {
            let wasCheckAsync = true;
            try {
                const productName = (0, $jeHvL.getBscGlobalState)().product;
                // MaybeSync skips the promise entirely once categories and preferences are loaded, which
                // is what keeps the write and any throw from it synchronous.
                // Attempt to set a known item key that was set from outside the package
                const processingCheck = (0, $7vtyD.isProcessingAllowedByPreferencesMaybeSync)({
                    itemKey: originalItemKey,
                    allowedCallback: ({ wasAsync: wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, $7WT4C.sendPackageOperationalEvent)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType: storageType,
                                wasAsync: wasAsync
                            }
                        });
                        originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory, itemCategory: itemCategory, wasAsync: wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, $7WT4C.sendPackageOperationalEvent)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType: storageType,
                                wasAsync: wasAsync
                            }
                        });
                        if (!itemHasCategory && (0, $335e109f486de69d$export$eda682c722f364aa)(categoryStorageType, originalItemKey)) (0, $7WT4C.sendTrackEvent)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: {
                                storageType: storageType,
                                productName: productName,
                                originalItemKey: originalItemKey,
                                itemCategory: itemCategory ?? null,
                                wasAsync: wasAsync,
                                cacheLoadedDate: (0, $jeHvL.getBscGlobalState)().cacheLoadedDate ?? null
                            },
                            onSent: (0, $335e109f486de69d$export$c81f34d18a3c37c3)(categoryStorageType, originalItemKey)
                        });
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides } = (0, $jeHvL.getBscGlobalState)();
                        // allowUncategorizedCookiesInOverrides impacts both web storage and cookies due to historical reasons
                        const allowUncategorized = allowUncategorizedCookiesInOverrides || allowUncategorizedItemsInWebStorageOverrides;
                        if (allowUncategorized && !itemHasCategory) originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                        else {
                            if (!itemHasCategory) (0, $bEUFb.Logger).warn(`${storageType}.setItem('${originalItemKey}', ...) was blocked` + `${productName ? ` for product "${productName}"` : ''}` + `: '${originalItemKey}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
                            return;
                        }
                    },
                    storageType: categoryStorageType,
                    productName: productName,
                    extensionSignals: extensionSignals
                });
                if ((0, $7vtyD.isPromise)(processingCheck)) processingCheck.catch((e)=>{
                    (0, $36ucG.reportSetItemError)({
                        message: `Failed to set item. ${e?.message || ''}`,
                        attributes: {
                            itemKey: originalItemKey,
                            storageType: storageType,
                            wasAsync: true
                        },
                        error: e
                    });
                });
            } catch (e) {
                (0, $36ucG.reportSetItemError)({
                    message: `Failed to set item. ${e.message || ''}`,
                    attributes: {
                        itemKey: originalItemKey,
                        storageType: storageType,
                        wasAsync: wasCheckAsync
                    },
                    error: e
                });
                setItemFailure = e;
            }
        } catch (e) {
            (0, $36ucG.reportSetItemError)({
                message: `Failed to send ${storageType} setter event. ${e.message || ''}`,
                error: e
            });
        }
        if (setItemFailure) throw setItemFailure;
    };


// Members the Proxy replaces rather than forwarding.
const $f476416956c9c6ee$var$INTERCEPTED_MEMBERS = [
    'setItem',
    'getItem',
    'removeItem',
    'clear',
    'key',
    'length'
];
/**
 * Marks a storage object as already overridden by this package. Duplicate copies of the package in
 * one page (chunk skew) each capture `globalThis.localStorage` at module evaluation, so without this
 * the second copy would proxy the first copy's Proxy and run the consent pipeline — and its
 * analytics — twice per write.
 */ const $f476416956c9c6ee$var$BSC_STORAGE_OVERRIDE_INSTALLED = Symbol.for('atlassian.bsc.webStorageOverrideInstalled');
const $f476416956c9c6ee$var$isAlreadyOverridden = (value)=>value !== null && typeof value === 'object' && value[$f476416956c9c6ee$var$BSC_STORAGE_OVERRIDE_INSTALLED] === true;
/**
 * A Proxy may not report a different value for a property the target exposes as a non-writable,
 * non-configurable own data property — the runtime throws `TypeError` on every such access. A real
 * `Storage` keeps its members on `Storage.prototype` and its items as writable, configurable own
 * properties, so this only happens when something has already replaced `window.localStorage` with a
 * locked-down stand-in (some third-party storage shims and test doubles do exactly that). Detect it
 * up front and keep the legacy override for those environments instead of installing a Proxy that
 * throws on ordinary reads.
 */ const $f476416956c9c6ee$var$canInterceptWithProxy = (storage)=>$f476416956c9c6ee$var$INTERCEPTED_MEMBERS.every((member)=>{
        const descriptor = Object.getOwnPropertyDescriptor(storage, member);
        return !descriptor || descriptor.configurable === true || descriptor.writable === true;
    });
const $f476416956c9c6ee$var$isLockedDownOnTarget = (target, property)=>{
    const descriptor = Reflect.getOwnPropertyDescriptor(target, property);
    return descriptor !== undefined && !descriptor.configurable && descriptor.writable === false;
};
/**
 * Wraps the real `Storage` object so consent checks still apply to writes while the rest of the
 * `Storage` interface keeps working.
 *
 * The legacy override (below) replaces `window.localStorage` with a plain object carrying the six
 * `Storage` operations. That silently drops every other guarantee of the interface: `length` becomes
 * a function instead of a number, stored keys stop being enumerable own properties, and
 * property-style access no longer reaches the store. Consumers that measure or enumerate storage —
 * `localStorage.length`, `Object.keys(localStorage)` — then see an empty or nonsensical view, which
 * disabled the age-based storage cleanups our products depend on and let storage fill to the browser
 * quota (COOK-628).
 *
 * Keeping the native `Storage` as the Proxy target inherits reads, removals, enumeration and brand
 * checks for free. Only writes are intercepted, and they are intercepted without relying on the
 * host's named-property-setter semantics: browsers ignore or shadow a write to `length` or to a
 * `Storage` method, whereas jsdom persists it as an item. Deciding those cases here rather than
 * forwarding them keeps behaviour identical across hosts and guarantees nothing reaches storage
 * without passing through the consent check.
 */ const $f476416956c9c6ee$var$createProxiedStorage = (bscStorage, storageType)=>{
    const nativeStorage = bscStorage.storage;
    const storagePrototype = Object.getPrototypeOf(nativeStorage);
    const interceptedSetItem = (0, $fc3d0a73a5e6218d$export$b4469df6294ea6aa)(bscStorage, nativeStorage.setItem, storageType);
    // The `Storage` operations keep pointing at `AtlBrowserStorage` so their existing availability
    // guards and analytics are unaffected by this Proxy. `length` is handled in the `get` trap
    // because it is an accessor on `Storage` but a method on `AtlBrowserStorage`.
    const operations = new Map([
        [
            'setItem',
            interceptedSetItem
        ],
        [
            'getItem',
            bscStorage.getItem.bind(bscStorage)
        ],
        [
            'removeItem',
            bscStorage.removeItem.bind(bscStorage)
        ],
        [
            'clear',
            bscStorage.clear.bind(bscStorage)
        ],
        [
            'key',
            bscStorage.key.bind(bscStorage)
        ]
    ]);
    // Properties assigned to the storage object that are NOT storage items — symbol keys, and the
    // interface's own member names. Browsers keep these as ordinary own properties on the object and
    // never write them to the store, so we hold them here instead of touching storage. Enumeration
    // deliberately does not report them: `Object.keys(localStorage)` stays exactly the stored keys.
    // They also take precedence over `operations` on read, because products legitimately wrap the
    // storage methods (Confluence's `patchLocalStorage` replaces `setItem` and delegates to whatever
    // it captured) and that has always worked against the legacy override.
    const shadowedProperties = new Map();
    // A property names a storage item unless it resolves on the prototype chain (`length`, the
    // `Storage` methods, `Object.prototype` members) or is a symbol. Used by every trap that can
    // reach the store: `set`, `defineProperty` and `deleteProperty`.
    const isStorageItemKey = (property)=>typeof property === 'string' && !(property in storagePrototype);
    // The consent pipeline emits analytics, and anything on that path that persists a value with
    // property syntax would re-enter this trap and recurse forever. Bound to one level instead.
    let isHandlingStorageWrite = false;
    const gateStorageWrite = (property, value)=>{
        if (isHandlingStorageWrite) {
            (0, $bEUFb.Logger).warn(`Dropped re-entrant ${storageType} write for '${property}' triggered from inside the consent path`);
            return;
        }
        isHandlingStorageWrite = true;
        try {
            interceptedSetItem(property, String(value));
        } finally{
            isHandlingStorageWrite = false;
        }
    };
    const proxiedStorage = new Proxy(nativeStorage, {
        get: (target, property)=>{
            if (property === $f476416956c9c6ee$var$BSC_STORAGE_OVERRIDE_INSTALLED) return true;
            if (property === 'length') return bscStorage.length();
            if (shadowedProperties.has(property)) return shadowedProperties.get(property);
            if (operations.has(property)) return operations.get(property);
            // Deliberately NOT bound to the target: binding would hand out the raw `Storage` through
            // `localStorage.valueOf()`, which is an unchecked write path. Everything that needs a real
            // `Storage` receiver is routed above, and the remainder (`Object.prototype` members, named
            // keys, `Symbol.toStringTag`) works with the Proxy as the receiver. Returning the prototype's
            // own function object also keeps `localStorage.toString === localStorage.toString`.
            return Reflect.get(target, property, target);
        },
        // `localStorage.foo = 'bar'`, `Object.assign(localStorage, …)` and `Reflect.set` all reach the
        // store natively, so they are consent-checked exactly like `setItem`.
        set: (target, property, value, receiver)=>{
            // A receiver that is neither this Proxy nor the storage itself means the assignment targets
            // something further down a prototype chain (`Object.create(localStorage).foo = 'x'`), which
            // the browser also refuses to route into the store.
            if (receiver !== proxiedStorage && receiver !== target) return Reflect.set(target, property, value, receiver);
            if (property === 'length') // Read-only accessor: browsers ignore the write in sloppy mode. Reporting success keeps
            // strict-mode assignment from throwing where the legacy override did not.
            return true;
            // Reporting success for a locked-down own property on the target violates a Proxy
            // invariant. Fail the assignment exactly as the target itself would.
            if ($f476416956c9c6ee$var$isLockedDownOnTarget(target, property)) return false;
            if (!isStorageItemKey(property)) {
                shadowedProperties.set(property, value);
                return true;
            }
            gateStorageWrite(property, value);
            // Report success even when consent blocked the write, so assignment does not throw in
            // strict mode. This matches how the `setItem` override treats a blocked write.
            return true;
        },
        defineProperty: (target, property, descriptor)=>{
            // Accessor descriptors on a storage key are rejected by the browser itself — forward and let
            // it throw rather than inventing a behaviour.
            if (!('value' in descriptor) || property === 'length') return Reflect.defineProperty(target, property, descriptor);
            // A non-configurable property must actually exist on the target for a `true` result to be
            // legal, and consent may block the write, so refuse instead of risking a `TypeError`.
            if (descriptor.configurable === false || $f476416956c9c6ee$var$isLockedDownOnTarget(target, property)) return false;
            if (!isStorageItemKey(property)) {
                shadowedProperties.set(property, descriptor.value);
                return true;
            }
            gateStorageWrite(property, descriptor.value);
            return true;
        },
        // `delete localStorage.foo` removes the item natively, so it has to reach the store — but it goes
        // through `AtlBrowserStorage.removeItem` rather than the target directly, so removals behave
        // identically however they are spelled. Removals are not consent-checked, matching `removeItem`.
        deleteProperty: (target, property)=>{
            if (shadowedProperties.has(property)) {
                shadowedProperties.delete(property);
                return true;
            }
            if (isStorageItemKey(property)) {
                bscStorage.removeItem(property);
                return true;
            }
            return Reflect.deleteProperty(target, property);
        }
    });
    return proxiedStorage;
};
const $f476416956c9c6ee$var$applyWebStorageOverride = (bscStorage, storageType)=>{
    const caseSensitiveStorageType = storageType === (0, $5noOS.WebStorageType).LocalStorage ? 'localStorage' : 'sessionStorage';
    if ($f476416956c9c6ee$var$isAlreadyOverridden(window[caseSensitiveStorageType]) || $f476416956c9c6ee$var$isAlreadyOverridden(bscStorage.storage)) {
        (0, $bEUFb.Logger).debug(`${storageType} override is already installed, skipping`);
        return;
    }
    if ($f476416956c9c6ee$var$canInterceptWithProxy(bscStorage.storage)) {
        Object.defineProperty(window, caseSensitiveStorageType, {
            value: $f476416956c9c6ee$var$createProxiedStorage(bscStorage, storageType),
            writable: true,
            configurable: true
        });
        return;
    }
    (0, $bEUFb.Logger).warn(`${storageType} cannot be proxied because its members are not configurable \u{2014} falling back to the legacy override`);
    const originalSetItem = bscStorage.storage.setItem;
    // As we cannot use Object.defineProperty(window[storageType], 'setItem', ...implementation)
    // we have to override the entire utility with our own edition of the webStorage class
    const overriddenStorageClass = {
        clear: bscStorage.clear.bind(bscStorage),
        key: bscStorage.key.bind(bscStorage),
        length: bscStorage.length.bind(bscStorage),
        removeItem: bscStorage.removeItem.bind(bscStorage),
        getItem: bscStorage.getItem.bind(bscStorage),
        setItem: (0, $fc3d0a73a5e6218d$export$b4469df6294ea6aa)(bscStorage, originalSetItem, storageType)
    };
    Object.defineProperty(window, caseSensitiveStorageType, {
        value: overriddenStorageClass,
        writable: true,
        configurable: true
    });
};
const $f476416956c9c6ee$export$68ddaf53a4783803 = (storageType)=>{
    const bscStorage = (0, $8zRL5.findStorageTarget)(storageType);
    if (!bscStorage.isAvailable) {
        (0, $bEUFb.Logger).warn(`No ${storageType} capabilities found`);
        return;
    }
    $f476416956c9c6ee$var$applyWebStorageOverride(bscStorage, storageType);
};
const $f476416956c9c6ee$export$619fe705922e5d61 = async (storageType)=>{
    const bscStorage = (0, $8zRL5.findStorageTarget)(storageType);
    if (!bscStorage.isAvailable) {
        (0, $bEUFb.Logger).warn(`No ${storageType} capabilities found`);
        return;
    }
    if (!(0, $003133068b78d6a1$export$36328b3bcbe4623a).isAvailable) {
        (0, $bEUFb.Logger).warn('IndexedDB is not available');
        return;
    }
    if (!(0, $003133068b78d6a1$export$36328b3bcbe4623a).isBooted) try {
        await (0, $003133068b78d6a1$export$36328b3bcbe4623a).boot();
    } catch  {
        (0, $bEUFb.Logger).warn('IndexedDB boot failed, proceeding without IDB tracking');
    }
    $f476416956c9c6ee$var$applyWebStorageOverride(bscStorage, storageType);
};


/**
 * Shared by both `platform_bsc_sync_initialize_controls` branches so the consent-check decision can
 * never diverge between the sync and the legacy path.
 */ const $863ae8ae30800032$var$getIndexedDbPassthroughConfig = ()=>{
    const disableIndexedDbConsentChecks = (0, $jeHvL.getBscGlobalState)().disableIndexedDbConsentChecks ?? false;
    return {
        performConsentChecks: !disableIndexedDbConsentChecks
    };
};
const $863ae8ae30800032$export$919040c32a62c7db = async (args = {
    analyticsEnabled: true
})=>{
    if ((0, $2aEiL.fg)('platform_moonjelly_bsc_master_killswitch')) return undefined;
    let initResult;
    try {
        (0, $bEUFb.Logger).debug('initializeControls invoked');
        (0, $751de4a961087994$export$882c4530c58781d8)({
            ...args,
            overrideOnceParams: true
        });
        if ((0, $dS1lP.isSSR)()) return undefined;
        (0, $7WT4C.sendPackageOperationalEvent)({
            action: 'bscInitControlsParameters',
            attributes: {
                product: args.product,
                analyticsEnabled: args.analyticsEnabled,
                flagEnabled: args.flagEnabled,
                webStorageEnabled: args.webStorageEnabled,
                indexedDbEnabled: args.indexedDbEnabled,
                disableWebStorageConsentChecks: args.disableWebStorageConsentChecks,
                disableIndexedDbConsentChecks: args.disableIndexedDbConsentChecks,
                allowUncategorizedCookiesInOverrides: args.allowUncategorizedCookiesInOverrides,
                allowUncategorizedItemsInWebStorageOverrides: args.allowUncategorizedItemsInWebStorageOverrides,
                allowUncategorizedItemsInIndexedDBOverrides: args.allowUncategorizedItemsInIndexedDBOverrides,
                perimeter: args.perimeter
            }
        });
        // Ensures that the AWC is constructed before overwriting any native methods.
        const analyticsWebClientInstance = (0, $7WT4C.getAnalyticsClient)();
        // If AWC is not initialized, it will be undefined
        const isAnalyticsInitialized = !!analyticsWebClientInstance;
        if (args.analyticsEnabled && !isAnalyticsInitialized) throw new Error(`Failed to initialize AnalyticsWebClient. Analytics logging will not be set for native method overrides.`);
        if ((0, $2aEiL.fg)('platform_bsc_sync_initialize_controls')) {
            // Install every override on the calling tick. Because nothing below awaits, this whole
            // `async` function body runs to completion synchronously — so a product that calls
            // `initializeControls` without awaiting it still has all overrides in place the moment the
            // call returns. There is no longer a window in which `document.cookie` / `setItem` /
            // `indexedDB.open` bypass consent enforcement.
            //
            // Synchronous throws still reach the `catch` below, so the `initializeControlsError`
            // operational event and the abort-on-first-failure behaviour are unchanged. That would NOT
            // hold if we merely dropped the `await`s from the legacy `create*Passthrough` functions: a
            // sync throw inside an `async` function surfaces as a rejected promise, not a thrown error.
            (0, $3f750fb9611ccfa5$export$50a17589ab8bbee4)();
            if ((0, $jeHvL.getBscGlobalState)().webStorageEnabled) {
                (0, $f476416956c9c6ee$export$68ddaf53a4783803)((0, $5noOS.WebStorageType).LocalStorage);
                (0, $f476416956c9c6ee$export$68ddaf53a4783803)((0, $5noOS.WebStorageType).SessionStorage);
            }
            if ((0, $jeHvL.getBscGlobalState)().indexedDbEnabled) (0, $9770e07337bd9d1e$export$bbe9492afe46739)($863ae8ae30800032$var$getIndexedDbPassthroughConfig());
        } else {
            await (0, $3f750fb9611ccfa5$export$45a5573b04db016c)();
            const isWebStorageControlsEnabled = (0, $jeHvL.getBscGlobalState)().webStorageEnabled;
            if (isWebStorageControlsEnabled) {
                // Serial, not `Promise.all`: `BSCIndexedDB.boot()` short-circuits on its promise cache for
                // concurrent callers, so parallelising would install the SessionStorage override before
                // the DB is open.
                await (0, $f476416956c9c6ee$export$619fe705922e5d61)((0, $5noOS.WebStorageType).LocalStorage);
                await (0, $f476416956c9c6ee$export$619fe705922e5d61)((0, $5noOS.WebStorageType).SessionStorage);
            }
            const isIndexedDbEnabled = (0, $jeHvL.getBscGlobalState)().indexedDbEnabled;
            if (isIndexedDbEnabled) await (0, $9770e07337bd9d1e$export$a03098708eb0de1)($863ae8ae30800032$var$getIndexedDbPassthroughConfig());
        }
        (0, $bEUFb.Logger).debug('initializeControls finished');
        const storageCleanupPromise = (0, $81753edb4e325c61$export$e6332b39565fb2b3)();
        initResult = Object.assign(initResult ?? {}, {
            storageCleanupPromise: storageCleanupPromise
        });
    } catch (e) {
        (0, $bEUFb.Logger).errorWithOperationalEvent({
            action: 'initializeControlsError',
            message: `Failed to initialize browser storage controls. ${e.message || ''}`
        });
    }
    return initResult;
};


parcelRequire("JEkkv");
var $fYUfs = parcelRequire("fYUfs");

var $1v5pe = parcelRequire("1v5pe");

var $kIqwl = parcelRequire("kIqwl");
const $943b930ce59ea17c$export$583d472d43ace2e9 = ()=>{
    const isConsentBannerAnalyticsEnabled = !(0, $fYUfs.isLocal)();
    const product = 'dev-agents';
    (0, $1v5pe.useEffect)(()=>{
        (0, $863ae8ae30800032$export$919040c32a62c7db)({
            product: product,
            webStorageEnabled: true,
            analyticsEnabled: isConsentBannerAnalyticsEnabled
        });
    }, [
        isConsentBannerAnalyticsEnabled
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $2c754042296d1aa7$export$903b95b8397e77e9), {
        product: product,
        analyticsEnabled: isConsentBannerAnalyticsEnabled
    });
};


parcelRequire("1v5pe");

var $8vj5e = parcelRequire("8vj5e");

var $GByrF = parcelRequire("GByrF");

var $93598 = parcelRequire("93598");

var $1v5pe = parcelRequire("1v5pe");

var $brxde = parcelRequire("brxde");

var $2aEiL = parcelRequire("2aEiL");
const $96430d0128c7805d$export$cc97c2566f53fd12 = 'data-scrollbar-harmonisation';


function $fb649c32e465ff32$export$4d0b2e184ba12ee7(targetDocument, attribute, controllers) {
    const existingController = controllers.get(targetDocument);
    if (existingController) {
        existingController.references += 1;
        let isReleased = false;
        return ()=>{
            if (isReleased) return;
            isReleased = true;
            existingController.references -= 1;
            if (existingController.references === 0) {
                existingController.release();
                controllers.delete(targetDocument);
            }
        };
    }
    const rootElement = targetDocument.documentElement;
    const controller = {
        references: 1,
        release: ()=>rootElement.removeAttribute(attribute)
    };
    rootElement.setAttribute(attribute, '');
    controllers.set(targetDocument, controller);
    let isReleased = false;
    return ()=>{
        if (isReleased) return;
        isReleased = true;
        controller.references -= 1;
        if (controller.references === 0) {
            controller.release();
            controllers.delete(targetDocument);
        }
    };
}


const $2936312cd33a124f$var$controllers = new WeakMap();
function $2936312cd33a124f$export$f289ecff4a99e09d(targetDocument) {
    return (0, $fb649c32e465ff32$export$4d0b2e184ba12ee7)(targetDocument, (0, $96430d0128c7805d$export$cc97c2566f53fd12), $2936312cd33a124f$var$controllers);
}


function $a2ff21b08e5f5148$export$6a82770d3a3903f7(isEnabled) {
    const isGateEnabled = (0, $2aEiL.fg)('platform_dst_scrollbar_harmonisation');
    const shouldEnable = isEnabled ?? isGateEnabled;
    (0, $1v5pe.useEffect)(()=>{
        if (!shouldEnable) return;
        const targetDocument = (0, $brxde.getDocument)();
        if (!targetDocument) return;
        return (0, $2936312cd33a124f$export$f289ecff4a99e09d)(targetDocument);
    }, [
        shouldEnable
    ]);
}



var $5jHNN = parcelRequire("5jHNN");

var $h8JSM = parcelRequire("h8JSM");

var $kIqwl = parcelRequire("kIqwl");
function $80deaf656307b829$export$c7dacf3845253dcf({ children: children, defaultColorMode: defaultColorMode = 'light', defaultTheme: defaultTheme, routerLinkComponent: routerLinkComponent, UNSAFE_isThemingDisabled: UNSAFE_isThemingDisabled }) {
    const isInsideAppProvider = (0, $h8JSM.useIsInsideAppProvider)();
    (0, $a2ff21b08e5f5148$export$6a82770d3a3903f7)();
    if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
    const routerLinkProvider = /*#__PURE__*/ (0, $kIqwl.jsx)((0, $93598.default), {
        routerLinkComponent: routerLinkComponent,
        children: children
    });
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $GByrF.InsideAppProviderContext).Provider, {
        value: true,
        children: UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8vj5e.AppProviderThemingEnabledContext).Provider, {
            value: true,
            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $5jHNN.ThemeProvider), {
                defaultColorMode: defaultColorMode,
                defaultTheme: defaultTheme,
                children: routerLinkProvider
            })
        })
    });
}
var /* eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of this deprecated default export shim. */ /**
 * @deprecated Use `import { AppProvider } from '@atlaskit/app-provider/app-provider'` instead.
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports -- VOLTC-139 tracks removal of this deprecated default export shim.
$80deaf656307b829$export$2e2bcd8739ae039 = $80deaf656307b829$export$c7dacf3845253dcf;



var $bHcZt = parcelRequire("bHcZt");
/**
 * Provided to the APP provider to use as the default router link component.
 *
 * This is necessary so Anchor components can perform SPA transitions.
 *
 * @see https://staging.atlassian.design/components/primitives/anchor/examples#router-links
 */ 
var $1v5pe = parcelRequire("1v5pe");
parcelRequire("7yQXV");
var $iR5yZ = parcelRequire("iR5yZ");

var $kIqwl = parcelRequire("kIqwl");
const $2b55701a327db066$export$c62c1bf7572a3c0c = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ href: href, children: children, ...rest }, ref)=>{
    // A basic link by passing a string as the component's `href` prop.
    if (typeof href === 'string') return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $iR5yZ.default), {
        ref: ref,
        href: href,
        ...rest,
        children: children
    });
    // Gracefully handle undefined href — render as plain text with no navigation.
    if (!href) return /*#__PURE__*/ (0, $kIqwl.jsx)("span", {
        ...rest,
        children: children
    });
    // Advanced link configuration by passing an object as the
    // component's `href` prop
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $iR5yZ.default), {
        ref: ref,
        href: href.href,
        to: href.to,
        replace: href.replace,
        ...rest,
        children: children
    });
});
$2b55701a327db066$export$c62c1bf7572a3c0c.displayName = 'CustomRouterLink';



var $c6q87 = parcelRequire("c6q87");

var $anwEU = parcelRequire("anwEU");

var $8zRL5 = parcelRequire("8zRL5");
const $5a6ffbff018a1f06$export$2f7a12048d96237 = ()=>{
    const savedThemePreference = (0, $8zRL5.AtlBrowserStorageLocal).getItem('themeColorMode');
    // legacy saved theme
    if (savedThemePreference === 'light' || savedThemePreference === 'dark' || savedThemePreference === 'auto') return {
        colorMode: savedThemePreference
    };
    if (savedThemePreference != null) {
        const themeObject = (0, $anwEU.themeStringToObject)(savedThemePreference);
        return Object.keys(themeObject).length > 0 ? themeObject : $5a6ffbff018a1f06$var$getOsThemePreference();
    }
    return $5a6ffbff018a1f06$var$getOsThemePreference();
};
const $5a6ffbff018a1f06$var$getOsThemePreference = ()=>{
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    if (darkModeMediaQuery.matches) return {
        colorMode: 'dark'
    };
    return {
        colorMode: 'light'
    };
};



var $kIqwl = parcelRequire("kIqwl");
const $b55e4270153aa7cb$export$4e51cd0e4cabbfea = ({ children: children })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $80deaf656307b829$export$2e2bcd8739ae039), {
        routerLinkComponent: (0, $2b55701a327db066$export$c62c1bf7572a3c0c),
        defaultColorMode: (0, $5a6ffbff018a1f06$export$2f7a12048d96237)().colorMode,
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $c6q87.FeatureGateClient), {
            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $bHcZt.FlagsProvider), {
                children: children
            })
        })
    });
};



var $jY3c0 = parcelRequire("jY3c0");
parcelRequire("2gfcT");
var $5cmoV = parcelRequire("5cmoV");

var $1v5pe = parcelRequire("1v5pe");

var $dKVDt = parcelRequire("dKVDt");

var $ccEZf = parcelRequire("ccEZf");

var $gtUgB = parcelRequire("gtUgB");

var $8YStQ = parcelRequire("8YStQ");

var $1v5pe = parcelRequire("1v5pe");

var $cWkcy = parcelRequire("cWkcy");

var $bOKPN = parcelRequire("bOKPN");

var $kIqwl = parcelRequire("kIqwl");

const $1dcb734a1d3997ec$var$AppRouteComponent = /*#__PURE__*/ (0, $1v5pe.lazy)(()=>(parcelRequire("jZIPe")).then(({ AppRouteComponent: AppRouteComponent })=>({
            default: AppRouteComponent
        })));
const $1dcb734a1d3997ec$export$134cfa7823220fbd = ()=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8YStQ.ErrorBoundary), {
        componentName: "AppRouteComponentWithAggHeaders",
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $gtUgB.default), {
            name: "dev-agents-app-with-agg-headers",
            fallback: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cWkcy.LoadingSkeleton), {}),
            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $bOKPN.AggRelayEnvironmentProvider), {
                children: /*#__PURE__*/ (0, $kIqwl.jsx)($1dcb734a1d3997ec$var$AppRouteComponent, {})
            })
        })
    });
};


parcelRequire("j5h4D");
var $h7lQ2 = parcelRequire("h7lQ2");

var $1v5pe = parcelRequire("1v5pe");

var $cWkcy = parcelRequire("cWkcy");

var $aQPoi = parcelRequire("aQPoi");

var $kIqwl = parcelRequire("kIqwl");
const $78b39380628dcbac$var$JiraAccessRedirect = ()=>{
    (0, $1v5pe.useEffect)(()=>{
        // Let Jira handle its own access-denied or request-access experience.
        window.location.replace('/jira');
    }, []);
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cWkcy.LoadingSkeleton), {});
};
const $78b39380628dcbac$export$a53c24cd07b2947f = ({ cloudId: cloudId, children: children })=>{
    const { getJiraAdminPermissions: getJiraAdminPermissions, permissions: permissions, loading: loading, error: error } = (0, $aQPoi.useJiraAdminPermissions)();
    const [hasCheckedAccess, setHasCheckedAccess] = (0, $1v5pe.useState)(false);
    (0, $1v5pe.useEffect)(()=>{
        let active = true;
        getJiraAdminPermissions(cloudId).then(()=>{
            if (active) setHasCheckedAccess(true);
        });
        return ()=>{
            active = false;
        };
    }, [
        cloudId,
        getJiraAdminPermissions
    ]);
    if (!hasCheckedAccess || loading) return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cWkcy.LoadingSkeleton), {});
    if (error) throw new Error('Unable to verify Jira product access');
    // Site-scoped write access or product administration grants Jira product access.
    if (!permissions.includes('write') && !permissions.includes('manage')) return /*#__PURE__*/ (0, $kIqwl.jsx)($78b39380628dcbac$var$JiraAccessRedirect, {});
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $kIqwl.Fragment), {
        children: children
    });
};



var $3IGBn = parcelRequire("3IGBn");

var $kIqwl = parcelRequire("kIqwl");
const $8f235d18dd09b3eb$export$a6c90e7f368df109 = ()=>{
    const { tenantContexts: tenantContexts } = (0, $h7lQ2.useTenantData)();
    const cloudId = tenantContexts[0]?.cloudId;
    if (!cloudId) throw new Error('A Jira site is required for the GitHub OAuth redirect');
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $78b39380628dcbac$export$a53c24cd07b2947f), {
        cloudId: cloudId,
        children: /*#__PURE__*/ (0, $kIqwl.jsx)("main", {
            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $3IGBn.GithubOauthRedirectPage), {})
        })
    }, cloudId);
};



var $kIqwl = parcelRequire("kIqwl");
const $b7094fbddc605920$var$standalonePaths = new Set([
    (0, $ccEZf.ROVO_DEV_BASE_PATH),
    (0, $ccEZf.DEVAI_BASE_PATH)
].map((basePath)=>`${basePath}${0, $5cmoV.githubOauthRedirectPath}`));
const $b7094fbddc605920$var$getPathname = ()=>(0, $dKVDt.appHistory).location.pathname;
const $b7094fbddc605920$export$8707b35fd1c03f46 = ()=>{
    const pathname = (0, $1v5pe.useSyncExternalStore)((0, $dKVDt.appHistory).listen, $b7094fbddc605920$var$getPathname);
    if ($b7094fbddc605920$var$standalonePaths.has(pathname.replace(/\/$/, '')) && (0, $jY3c0.fg)('dev_agents_standalone_github_oauth_redirect')) return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8f235d18dd09b3eb$export$a6c90e7f368df109), {});
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $1dcb734a1d3997ec$export$134cfa7823220fbd), {});
};



var $kIqwl = parcelRequire("kIqwl");
const $a35bff0aa91d9525$export$86fbec116b87613f = ()=>{
    const analyticsWebClient = (0, $eajEV.useAnalyticsWebClient)();
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8YStQ.ErrorBoundary), {
        componentName: "App",
        onError: (err)=>{
            analyticsWebClient.sendOperationalEvent({
                action: 'error',
                actionSubject: 'appComponent',
                source: 'app',
                attributes: {
                    message: err.message
                }
            });
        },
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $gtUgB.default), {
            name: "dev-agents-app",
            fallback: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cWkcy.LoadingSkeleton), {}),
            children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $137f55099ce95f20$export$c2518934dd564e83), {
                children: /*#__PURE__*/ (0, $kIqwl.jsxs)((0, $b55e4270153aa7cb$export$4e51cd0e4cabbfea), {
                    children: [
                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $943b930ce59ea17c$export$583d472d43ace2e9), {}),
                        /*#__PURE__*/ (0, $kIqwl.jsx)((0, $b7094fbddc605920$export$8707b35fd1c03f46), {})
                    ]
                })
            })
        })
    });
};



var $kIqwl = parcelRequire("kIqwl");
const $f3bf31c1f9723e6d$export$fd90f7e8fb65886c = ({ tenantQueryRef: tenantQueryRef })=>{
    const authData = (0, $e60FT.useAuthData)();
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8YStQ.ErrorBoundary), {
        componentName: "AppWithTenantContext",
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $gtUgB.default), {
            name: "dev-agents-tenant-context",
            children: tenantQueryRef ? /*#__PURE__*/ (0, $kIqwl.jsx)((0, $2xoF5.TenantContextProvider), {
                queryRef: tenantQueryRef,
                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $eajEV.AnalyticsWebClientProvider), {
                    authData: authData,
                    children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $a35bff0aa91d9525$export$86fbec116b87613f), {})
                })
            }) : /*#__PURE__*/ (0, $kIqwl.jsx)((0, $fjzd2.default), {
                name: "dev-agents-auth-context"
            })
        })
    });
};



var $kIqwl = parcelRequire("kIqwl");
const $ff28a396b5bb8fbc$var$redirectUrl = (0, $fYUfs.getEnvType)() === (0, $1qaWF.envType).PROD ? `https://id.atlassian.com/login?continue=${encodeURIComponent(window.location.href)}` : `https://id.stg.internal.atlassian.com/login?continue=${encodeURIComponent(window.location.href)}`;
const $ff28a396b5bb8fbc$var$AuthErrorBoundary = ({ children: children })=>{
    return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $8YStQ.ErrorBoundary), {
        componentName: "AppWithAuthContext",
        fallback: ()=>{
            // Redirect on auth errors except for localhost
            if (window && window.location.hostname !== 'localhost') window.location.replace($ff28a396b5bb8fbc$var$redirectUrl);
            return /*#__PURE__*/ (0, $kIqwl.jsx)((0, $cWkcy.LoadingSkeleton), {});
        },
        children: children
    });
};
const $ff28a396b5bb8fbc$export$e9f367b065e5ce13 = ()=>{
    const [queryRef, loadQuery] = (0, $jEbac.useQueryLoader)((0, $gfvRq.default));
    const [tenantQueryRef, loadTenantQuery] = (0, $jEbac.useQueryLoader)((0, $kNelK.default));
    const hostName = (0, $fYUfs.getHostname)();
    (0, $1v5pe.useEffect)(()=>{
        loadTenantQuery({
            hostNames: [
                hostName
            ]
        });
    }, [
        loadTenantQuery,
        hostName
    ]);
    (0, $1v5pe.useEffect)(()=>{
        loadQuery({});
    }, [
        loadQuery
    ]);
    return /*#__PURE__*/ (0, $kIqwl.jsx)($ff28a396b5bb8fbc$var$AuthErrorBoundary, {
        children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $gtUgB.default), {
            name: "dev-agents-auth-context",
            children: queryRef ? /*#__PURE__*/ (0, $kIqwl.jsx)((0, $5CgYT.AuthContextProvider), {
                queryRef: queryRef,
                children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $f3bf31c1f9723e6d$export$fd90f7e8fb65886c), {
                    tenantQueryRef: tenantQueryRef
                })
            }) : /*#__PURE__*/ (0, $kIqwl.jsx)((0, $fjzd2.default), {
                name: "dev-agents-auth-context"
            })
        })
    });
};


parcelRequire("keFM9");
var $i6wLE = parcelRequire("i6wLE");

var $2aEiL = parcelRequire("2aEiL");

var $9Lgqr = parcelRequire("9Lgqr");

var $9Lgqr = parcelRequire("9Lgqr");

var $haLaD = parcelRequire("haLaD");
let $b3bbf5b84c71a1d2$var$pe = null;
function $b3bbf5b84c71a1d2$export$619cdeadfd90f3e4() {
    if (typeof PerformanceObserver !== 'function') // Only instantiate the IntersectionObserver if it's supported
    return null;
    if ($b3bbf5b84c71a1d2$var$pe !== null) return $b3bbf5b84c71a1d2$var$pe;
    const performanceObserverCallback = (list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $9Lgqr.PerformanceObserverEntryTypes).LayoutShift) (0, $haLaD.EntriesBuffer)[(0, $9Lgqr.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $9Lgqr.PerformanceObserverEntryTypes).LongTask) (0, $haLaD.EntriesBuffer)[(0, $9Lgqr.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    };
    $b3bbf5b84c71a1d2$var$pe = new PerformanceObserver(performanceObserverCallback);
    return $b3bbf5b84c71a1d2$var$pe;
}


function $f260427eddd39b3f$export$768ccc3ab7bac3ea() {
    (0, $b3bbf5b84c71a1d2$export$619cdeadfd90f3e4)()?.observe({
        type: (0, $9Lgqr.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
}



var $9Lgqr = parcelRequire("9Lgqr");

function $43f51ac7f6ab6fb7$export$54fb8b6aaf70ec9c() {
    (0, $b3bbf5b84c71a1d2$export$619cdeadfd90f3e4)()?.observe({
        type: (0, $9Lgqr.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
}


function $6d0b98aa9776a384$export$5ecf2aafafee3e0() {
    (0, $f260427eddd39b3f$export$768ccc3ab7bac3ea)();
    (0, $43f51ac7f6ab6fb7$export$54fb8b6aaf70ec9c)();
}



var $5tITM = parcelRequire("5tITM");

var $9Aca2 = parcelRequire("9Aca2");
function $a53c040c1a33e466$export$e6a07a94f3e112d4(sinkFn) {
    for (const { interactionId: interactionId, data: data } of (0, $9Aca2.interactionBufferState).interactionBuffer)sinkFn(interactionId, data);
    (0, $9Aca2.interactionBufferState).interactionBuffer.length = 0;
    (0, $9Aca2.interactionBufferState).bufferInteractionData = sinkFn;
}



var $96k96 = parcelRequire("96k96");

var $cGjFC = parcelRequire("cGjFC");

var $8OjRF = parcelRequire("8OjRF");

var $5tITM = parcelRequire("5tITM");

var $8OjRF = parcelRequire("8OjRF");
const $425e93dc579d8f5f$var$nameCache = new WeakMap();
function $425e93dc579d8f5f$var$getAttributeSelector(element, attributeName) {
    const attrValue = element.getAttribute(attributeName);
    if (!attrValue) return '';
    return `[${attributeName}="${attrValue}"]`;
}
function $425e93dc579d8f5f$var$isValidSelector(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch  {
        return false;
    }
}
function $425e93dc579d8f5f$var$isSelectorUnique(selector) {
    return document.querySelectorAll(selector).length === 1;
}
function $425e93dc579d8f5f$var$getUniqueSelector(selectorConfig, element) {
    let currentElement = element;
    const parts = [];
    const MAX_DEPTH = 3;
    let currentDepth = 0;
    while(currentElement && currentElement.localName !== 'body' && currentDepth <= MAX_DEPTH){
        const tagName = currentElement.localName;
        let selectorPart = tagName;
        if (selectorConfig.id && currentElement.id && $425e93dc579d8f5f$var$isValidSelector(`#${currentElement.id}`)) selectorPart += `#${currentElement.id}`;
        else if (selectorConfig.dataVC) selectorPart += $425e93dc579d8f5f$var$getAttributeSelector(currentElement, 'data-vc');
        else if (selectorConfig.testId) selectorPart += $425e93dc579d8f5f$var$getAttributeSelector(currentElement, 'data-testid') || $425e93dc579d8f5f$var$getAttributeSelector(currentElement, 'data-test-id');
        else if (selectorConfig.role) selectorPart += $425e93dc579d8f5f$var$getAttributeSelector(currentElement, 'role');
        else if (selectorConfig.className && currentElement.className) {
            const classNames = Array.from(currentElement.classList).join('.');
            if (classNames) {
                if ($425e93dc579d8f5f$var$isValidSelector(`.${classNames}`)) selectorPart += `.${classNames}`;
            }
        }
        parts.unshift(selectorPart);
        const potentialSelector = parts.join(' > ').trim();
        if (potentialSelector && $425e93dc579d8f5f$var$isSelectorUnique(potentialSelector)) return potentialSelector;
        currentElement = currentElement.parentElement;
        currentDepth++;
    }
    const potentialSelector = parts.join(' > ').trim();
    if (!potentialSelector) return 'unknown';
    else if (!$425e93dc579d8f5f$var$isSelectorUnique(potentialSelector)) {
        const parentElement = element.parentElement;
        if (parentElement) return `${potentialSelector}:nth-child`; // NOTE: invalid DOM selector, but enough information for VC
    }
    return potentialSelector;
}
function $425e93dc579d8f5f$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    const cachedName = $425e93dc579d8f5f$var$nameCache.get(element);
    if (cachedName) return cachedName;
    const uniqueSelector = $425e93dc579d8f5f$var$getUniqueSelector(selectorConfig, element);
    $425e93dc579d8f5f$var$nameCache.set(element, uniqueSelector);
    return uniqueSelector;
}
var $425e93dc579d8f5f$export$2e2bcd8739ae039 = $425e93dc579d8f5f$var$getElementName;


const $16225a80cadc9bc8$var$DEFAULT_SELECTOR_CONFIG = {
    id: true,
    testId: true,
    role: true,
    className: true
};
function $16225a80cadc9bc8$var$resolveSelectorConfig() {
    return (0, $5tITM.getSelectorConfig)() ?? $16225a80cadc9bc8$var$DEFAULT_SELECTOR_CONFIG;
}
function $16225a80cadc9bc8$var$getTestIdName(memoizedProps) {
    if (memoizedProps['data-testid']) return `[data-testid=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-test-id']) return `[data-test-id=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-vc']) return `[data-vc=${memoizedProps['data-vc']}]`;
    return null;
}
function $16225a80cadc9bc8$var$getUFOSegmentName(componentName, memoizedProps) {
    if (memoizedProps && memoizedProps['name']) return `UFOSegment[name=${memoizedProps['name']}]`;
    return componentName;
}
function $16225a80cadc9bc8$var$getReactComponentHierarchy(element) {
    const componentHierarchy = [];
    function traverseFiber(fiber) {
        let currentFiber = fiber;
        while(currentFiber){
            if (currentFiber.type) {
                const componentName = currentFiber.type.displayName || currentFiber.type.name;
                if (componentName && componentName.length > 2 && !componentName.includes('Listener') && !componentName.includes('Provider')) {
                    if (componentName === 'UFOSegment') {
                        componentHierarchy.push($16225a80cadc9bc8$var$getUFOSegmentName(componentName, currentFiber.memoizedProps));
                        break;
                    }
                    componentHierarchy.push(componentName);
                }
            }
            if (currentFiber.memoizedProps) {
                const dataIdInfo = $16225a80cadc9bc8$var$getTestIdName(currentFiber.memoizedProps);
                if (dataIdInfo) {
                    componentHierarchy.push(dataIdInfo);
                    currentFiber = null;
                    continue;
                }
            }
            currentFiber = currentFiber.return;
        }
    }
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (reactFiberKey) {
        const fiber = element[reactFiberKey];
        traverseFiber(fiber);
    }
    return componentHierarchy.reverse().join(' > ');
}
const $16225a80cadc9bc8$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = (0, $8OjRF.getActiveInteraction)();
    if (interaction?.type === 'press') {
        if (!interaction.responsiveness?.experimentalInputToNextPaint) {
            interaction.responsiveness = {
                ...interaction.responsiveness,
                experimentalInputToNextPaint: interaction.responsiveness?.experimentalInputToNextPaint || entry.duration,
                inputDelay: interaction.responsiveness?.inputDelay || entry.processingStart - entry.startTime
            };
            if (interaction.ufoName === 'unknown') {
                if (entry.target) interaction.unknownElementHierarchy = $16225a80cadc9bc8$var$getReactComponentHierarchy(entry.target);
                interaction.unknownElementName = (0, $425e93dc579d8f5f$export$2e2bcd8739ae039)($16225a80cadc9bc8$var$resolveSelectorConfig(), entry.target);
            }
        }
    }
};


let $ab8026bbc1494bfe$var$performanceEventObserver;
const $ab8026bbc1494bfe$export$17afbba0f16b4b19 = ()=>{
    $ab8026bbc1494bfe$var$performanceEventObserver = $ab8026bbc1494bfe$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (const entry of list)if (entry.name === 'click') (0, $16225a80cadc9bc8$export$e6be05b411ce21a6)(entry);
    });
    return $ab8026bbc1494bfe$var$performanceEventObserver;
};



var $hF6SW = parcelRequire("hF6SW");

var $1v5pe = parcelRequire("1v5pe");

var $5TRbo = parcelRequire("5TRbo");

var $jgDDj = parcelRequire("jgDDj");

var $8OjRF = parcelRequire("8OjRF");

var $5CbDz = parcelRequire("5CbDz");
const $d1ea7440bc8c0eee$var$ABORT_ERROR_NAMES = new Set([
    'AbortError'
]);
const $d1ea7440bc8c0eee$var$ABORT_ERROR_MESSAGES = [
    'The operation was aborted',
    'auth_window_closed'
];
// Only treated as abort when combined with AuthError name — the same string
// can appear in other error messages (e.g. 403 response bodies) where it
// should not be classified as abort.
const $d1ea7440bc8c0eee$var$AUTH_ERROR_ABORT_MESSAGES = [
    'access_denied'
];
// AuthError is thrown by @atlaskit/outbound-auth-flow-client during OAuth flows
// (e.g. connecting third-party apps like GitHub or Bitbucket to Jira).
// User-initiated outcomes (closing the popup, denying consent) are classified
// as abort; server/config failures are classified as auth.
const $d1ea7440bc8c0eee$var$AUTH_ERROR_NAMES = new Set([
    'AuthError'
]);
const $d1ea7440bc8c0eee$var$CHUNK_LOAD_ERROR_NAMES = new Set([
    'ChunkLoadError'
]);
const $d1ea7440bc8c0eee$var$CHUNK_LOAD_ERROR_MESSAGES = [
    'Unable to fetch manifest',
    'dynamically imported module',
    'Importing a module script failed'
];
const $d1ea7440bc8c0eee$var$NETWORK_CLIENT_ERROR_NAMES = new Set([
    'NetworkError',
    'Network error'
]);
const $d1ea7440bc8c0eee$var$NETWORK_CLIENT_ERROR_MESSAGES = [
    'Failed to fetch',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'server with the specified hostname could not be found',
    'The network connection was lost',
    'The request timed out',
    'connection failure',
    'CloseEvent: Ping timeout',
    'Curl Error: Failure when receiving data from the peer'
];
const $d1ea7440bc8c0eee$var$NETWORK_SERVER_ERROR_MESSAGES = [
    '... is not valid JSON',
    'in JSON at position 0',
    'JSON.parse: unexpected character',
    'JSON.parse: unexpected end of data',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'cannot parse response',
    'Syntax or http error'
];
function $d1ea7440bc8c0eee$var$matchesCategory(error) {
    const name = error.name ?? '';
    const message = error.message ?? '';
    if ($d1ea7440bc8c0eee$var$ABORT_ERROR_NAMES.has(name) || $d1ea7440bc8c0eee$var$ABORT_ERROR_MESSAGES.some((pattern)=>message.includes(pattern)) || // OAuth Abort errors
    $d1ea7440bc8c0eee$var$AUTH_ERROR_NAMES.has(name) && $d1ea7440bc8c0eee$var$AUTH_ERROR_ABORT_MESSAGES.some((pattern)=>message.includes(pattern))) return 'abort';
    if ($d1ea7440bc8c0eee$var$AUTH_ERROR_NAMES.has(name)) return 'auth';
    if ($d1ea7440bc8c0eee$var$CHUNK_LOAD_ERROR_NAMES.has(name) || $d1ea7440bc8c0eee$var$CHUNK_LOAD_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'chunk-load';
    if ($d1ea7440bc8c0eee$var$NETWORK_CLIENT_ERROR_NAMES.has(name) || $d1ea7440bc8c0eee$var$NETWORK_CLIENT_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'network-client';
    if ($d1ea7440bc8c0eee$var$NETWORK_SERVER_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'network-server';
    return null;
}
function $d1ea7440bc8c0eee$export$17e837b2daecf805(error) {
    const directMatch = $d1ea7440bc8c0eee$var$matchesCategory(error);
    if (directMatch) return directMatch;
    if (typeof error === 'object' && error !== null && 'cause' in error && error.cause instanceof Error) {
        const cause = error.cause;
        const causeMatch = $d1ea7440bc8c0eee$var$matchesCategory(cause);
        if (causeMatch) return causeMatch;
    }
    return 'product';
}


let $992f58aa8ca6b70d$var$sinkHandlerFn = ()=>{};
function $992f58aa8ca6b70d$export$e5fa3ac6dc44efff(fn) {
    $992f58aa8ca6b70d$var$sinkHandlerFn = fn;
}
const $992f58aa8ca6b70d$var$RELAY_NETWORK_ERRORS_NAME = 'RelayNetwork';
const $992f58aa8ca6b70d$export$1a949ef92fd30eca = (error)=>error.name === $992f58aa8ca6b70d$var$RELAY_NETWORK_ERRORS_NAME;
const $992f58aa8ca6b70d$var$isErrorObject = (error)=>typeof error === 'object' && error !== null;
const $992f58aa8ca6b70d$var$getErrorStatusCode = (error)=>{
    if (!$992f58aa8ca6b70d$var$isErrorObject(error)) return undefined;
    if ($992f58aa8ca6b70d$export$1a949ef92fd30eca(error)) return error.source?.errors?.[0]?.extensions?.statusCode;
    if ('statusCode' in error && typeof error.statusCode === 'number') return error.statusCode;
    return undefined;
};
const $992f58aa8ca6b70d$var$getErrorTraceId = (error)=>$992f58aa8ca6b70d$var$isErrorObject(error) && 'traceId' in error && typeof error.traceId === 'string' ? error.traceId : undefined;
function $992f58aa8ca6b70d$export$3e4fb24086cfb97a(error, additionalAttributes, labelStack) {
    const activeInteraction = (0, $8OjRF.getActiveInteraction)();
    const currentTime = performance.now();
    const baseErrorData = {
        errorType: error.name || 'Error',
        errorMessage: error.message?.slice(0, 100) || 'Unknown error',
        timestamp: currentTime,
        errorCategory: (0, $d1ea7440bc8c0eee$export$17e837b2daecf805)(error)
    };
    const errorData = {
        ...baseErrorData,
        statusCode: additionalAttributes?.statusCode ?? $992f58aa8ca6b70d$var$getErrorStatusCode(error),
        // Fallback to traceId from error object if it exists (e.g. FetchError)
        traceId: (0, $5TRbo.getActiveTrace)()?.traceId ?? $992f58aa8ca6b70d$var$getErrorTraceId(error),
        teamName: additionalAttributes?.teamName,
        packageName: additionalAttributes?.packageName,
        errorBoundaryId: additionalAttributes?.errorBoundaryId,
        errorHash: additionalAttributes?.errorHash,
        fallbackType: additionalAttributes?.fallbackType
    };
    // Calculate time since previous interaction
    const timeSincePreviousInteraction = (0, $8OjRF.PreviousInteractionLog).timestamp != null ? currentTime - (0, $8OjRF.PreviousInteractionLog).timestamp : null;
    const context = {
        labelStack: labelStack ?? null,
        activeInteractionName: activeInteraction?.ufoName ?? null,
        activeInteractionId: activeInteraction?.id ?? null,
        activeInteractionType: activeInteraction?.type ?? null,
        previousInteractionId: (0, $8OjRF.PreviousInteractionLog).id ?? null,
        previousInteractionName: (0, $8OjRF.PreviousInteractionLog).name ?? null,
        previousInteractionType: (0, $8OjRF.PreviousInteractionLog).type ?? null,
        timeSincePreviousInteraction: timeSincePreviousInteraction,
        routeName: (0, $5CbDz.default).current ?? null
    };
    $992f58aa8ca6b70d$var$sinkHandlerFn(errorData, context);
}
function $992f58aa8ca6b70d$export$79ee0f0d40355053(error, additionalAttributes) {
    const interactionContext = (0, $jgDDj.useInteractionContext)();
    const hasReportedRef = (0, $1v5pe.useRef)(false);
    (0, $1v5pe.useEffect)(()=>{
        if (error && !hasReportedRef.current) {
            hasReportedRef.current = true;
            $992f58aa8ca6b70d$export$3e4fb24086cfb97a(error, additionalAttributes, interactionContext?.labelStack);
        }
    }, [
        error,
        additionalAttributes,
        interactionContext?.labelStack
    ]);
}



var $6NNNz = parcelRequire("6NNNz");

var $hziAm = parcelRequire("hziAm");

var $2aEiL = parcelRequire("2aEiL");
const $4511fb07bac9d5e1$var$getNativeScheduler = ()=>{
    const nativeScheduler = globalThis.scheduler;
    return typeof nativeScheduler?.postTask === 'function' ? nativeScheduler : undefined;
};
/**
 * Schedules `work` at idle priority using native browser APIs, in order of preference:
 * `requestIdleCallback`, then `scheduler.postTask` with `background` priority, then
 * `setTimeout(work, 0)` (e.g. Safari or SSR, where neither API is available).
 */ function $4511fb07bac9d5e1$var$scheduleNativeIdleTask(work) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(work);
        return;
    }
    const nativeScheduler = $4511fb07bac9d5e1$var$getNativeScheduler();
    if (nativeScheduler) {
        nativeScheduler.postTask(work, {
            priority: 'background'
        });
        return;
    }
    setTimeout(work, 0);
}
/**
 * Schedules `work` to run at idle priority.
 *
 * When `platform_ufo_native_task_scheduling` is enabled, uses native browser scheduling instead of
 * the `scheduler` npm package, which is being removed for React 19 compatibility.
 */ function $4511fb07bac9d5e1$var$scheduleIdleCallback(work) {
    if ((0, $2aEiL.fg)('platform_ufo_native_task_scheduling')) {
        $4511fb07bac9d5e1$var$scheduleNativeIdleTask(work);
        return;
    }
    (0, $hziAm.unstable_scheduleCallback)((0, $hziAm.unstable_IdlePriority), work);
}
var $4511fb07bac9d5e1$export$2e2bcd8739ae039 = $4511fb07bac9d5e1$var$scheduleIdleCallback;


let $4529eb8a23e361e6$var$initialized = false;
function $4529eb8a23e361e6$var$sinkInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createPayloads(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads?.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $4511fb07bac9d5e1$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $8OjRF.sinkInteractionHandler)(sinkFn);
}
function $4529eb8a23e361e6$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $8OjRF.sinkPostInteractionLogHandler)((logOutput)=>{
        (0, $4511fb07bac9d5e1$export$2e2bcd8739ae039)(()=>{
            const payload = createPostInteractionLogPayload(logOutput);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $4529eb8a23e361e6$var$sinkTerminalErrors(instance, createTerminalErrorPayload) {
    (0, $992f58aa8ca6b70d$export$e5fa3ac6dc44efff)((errorData, context)=>{
        (0, $4511fb07bac9d5e1$export$2e2bcd8739ae039)(()=>{
            const payload = createTerminalErrorPayload(errorData, context);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $4529eb8a23e361e6$var$sinkExtraSearchPageInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createExtraSearchPageInteractionPayload(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads?.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $4511fb07bac9d5e1$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $a53c040c1a33e466$export$e6a07a94f3e112d4)(sinkFn);
}




function $4529eb8a23e361e6$export$2cd8252107eb640b(analyticsWebClientAsync, config) {
    if ($4529eb8a23e361e6$var$initialized) return;
    // Always set config first so isUFOEnabled() can check config.enabled
    (0, $5tITM.setUFOConfig)(config);
    // If UFO is disabled via config, skip all initialization
    if (!(0, $5tITM.isUFOEnabled)()) {
        $4529eb8a23e361e6$var$initialized = true;
        return;
    }
    // Initialize pressure observer for CPU usage monitoring
    (0, $hF6SW.initialisePressureObserver)();
    (0, $hF6SW.initialiseMemoryObserver)();
    if ((0, $2aEiL.fg)('platform_ufo_enable_otel_context_manager')) {
        // Configure global OTel context manager
        const contextManager = new (0, $96k96.UFOContextManager)();
        // set the contextmanager somewhere we can reference it later
        (0, $96k96.setContextManager)(contextManager);
        // Register the context manager with the global OTel API
        contextManager.enable();
        (0, $i6wLE.context).setGlobalContextManager(contextManager);
    }
    if (config.vc?.enabled) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $5tITM.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders
        };
        (0, $8OjRF.postInteractionLog).initializeVCObserver(vcOptions);
    }
    (0, $cGjFC.setupHiddenTimingCapture)();
    (0, $6d0b98aa9776a384$export$5ecf2aafafee3e0)();
    if ((0, $2aEiL.fg)('platform_ufo_soft_nav_paint_metrics')) (0, $6NNNz.ensureSoftNavigationObserved)();
    (0, $cGjFC.setupThrottleDetection)();
    $4529eb8a23e361e6$var$initialized = true;
    if (typeof PerformanceObserver !== 'undefined') {
        const observer = (0, $ab8026bbc1494bfe$export$17afbba0f16b4b19)();
        observer.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 16
        });
    }
    Promise.all([
        analyticsWebClientAsync,
        (parcelRequire("i8szI")),
        (parcelRequire("fxxkW")),
        (parcelRequire("1tuyH")),
        (parcelRequire("4LTDv"))
    ]).then(([awc, payloadPackage, extraPayloadPackage, createPostInteractionLogPayloadPackage, createTerminalErrorPayloadPackage])=>{
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
            const instance = client.getInstance();
            $4529eb8a23e361e6$var$sinkInteraction(instance, payloadPackage);
            if (config?.terminalErrors?.enabled) $4529eb8a23e361e6$var$sinkTerminalErrors(instance, createTerminalErrorPayloadPackage.default);
            if (config.postInteractionLog?.enabled) $4529eb8a23e361e6$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            if (config?.extraSearchPageInteraction?.enabled) $4529eb8a23e361e6$var$sinkExtraSearchPageInteraction(instance, extraPayloadPackage);
        });
        else if (awc.sendOperationalEvent) {
            $4529eb8a23e361e6$var$sinkInteraction(awc, payloadPackage);
            if (config?.terminalErrors?.enabled) $4529eb8a23e361e6$var$sinkTerminalErrors(awc, createTerminalErrorPayloadPackage.default);
            if (config.postInteractionLog?.enabled) $4529eb8a23e361e6$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            if (config?.extraSearchPageInteraction?.enabled) $4529eb8a23e361e6$var$sinkExtraSearchPageInteraction(awc, extraPayloadPackage);
        }
    });
}



var $54iU5 = parcelRequire("54iU5");
parcelRequire("JEkkv");
var $1qaWF = parcelRequire("1qaWF");
var $fYUfs = parcelRequire("fYUfs");
const $bc801c052e550a08$var$isProd = (0, $fYUfs.getEnvType)() === (0, $1qaWF.envType).PROD;
const $bc801c052e550a08$var$region = $bc801c052e550a08$var$isProd ? 'prod-east' : 'stg-east';
const $bc801c052e550a08$var$config = {
    product: 'devAgents',
    namePrefix: 'dev-agents-ufo-',
    region: $bc801c052e550a08$var$region,
    interactionTimeout: {
        'dev-agents-ufo-dev-agents-boysenberry-flow-page': 180000
    },
    // 3 minutes
    capability: {
        /*
     * Enabling feature flag data to be captured in UFO.
     */ feature_flag_access: 1,
        /*
     * https://atlassian.slack.com/archives/C01AY8132S3/p1723030532244489?thread_ts=1722580624.223629&cid=C01AY8132S3
     * react_profiler is added since it is required by the type,
     * will be cleaned up in the future
     */ react_profiler: 0
    },
    vc: {
        /*
     * https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/129126/diff#platform%2F.changeset%2Fred-lemons-mate.md
     */ stopVCAtInteractionFinish: true,
        enabled: true,
        ssr: false,
        devToolsEnabled: (0, $fYUfs.getEnvType)() !== (0, $1qaWF.envType).PROD,
        selectorConfig: {
            id: false,
            // in the example above, since ids may contain UGC, we want to set capturing `id` information for TTVC to `false`.
            role: true,
            className: true,
            testId: true
        }
    },
    kind: {
        /*
     * Sampling works in 1 in the rate specified.
     * If rate is 1, it captures all events - 1/1
     */ page_load: 1,
        transition: 1,
        press: 1,
        typing: 1,
        legacy: 0,
        // For some Jira events that will be cleaned up in UFO
        hover: 1
    },
    postInteractionLog: {
        enabled: true
    }
};
const $bc801c052e550a08$export$c486014928b2a4c7 = (analyticsWebClient)=>{
    (0, $4529eb8a23e361e6$export$2cd8252107eb640b)(Promise.resolve(analyticsWebClient), $bc801c052e550a08$var$config);
    (0, $54iU5.default)();
};



var $kIqwl = parcelRequire("kIqwl");
$d45605c22e84ef75$export$2cd8252107eb640b({
    environment: (0, $fYUfs.getEnvType)(),
    enabled: (0, $fYUfs.getEnvType)() !== (0, $1qaWF.envType).LOCAL,
    dsn: 'https://aa7f49d6af9f98e93324071287d92bb8@o55978.ingest.us.sentry.io/4508946351521793',
    tracesSampleRate: 1.0 // Capture 100% of the transactions
});
(0, $bc801c052e550a08$export$c486014928b2a4c7)((0, $6AigK.devAnalyticsClient));
const $a88cc9e8530e2f02$var$root = (0, $4okYx.createRoot)(document.getElementById('root'));
$a88cc9e8530e2f02$var$root.render(/*#__PURE__*/ (0, $kIqwl.jsx)((0, $1apN2.AtlassianRelayEnvironmentProvider), {
    children: /*#__PURE__*/ (0, $kIqwl.jsx)((0, $ff28a396b5bb8fbc$export$e9f367b065e5ce13), {})
}));


//# sourceMappingURL=index.cb9f02c4.js.map
